/* Portal de compras · aplicación · v306 */

// ── Almacenes en memoria, declarados ANTES de que nadie los use ──
// Estos tres se creaban dentro de repGenerar() y enviarCorreoProveedor(),
// que hasta ahora siempre corrían primero. Al cargar los datos en paralelo
// y al añadir la pantalla de Top selling, dejó de ser cierto: quien llegaba
// antes se encontraba con "undefined" y reventaba.
window._atts     = window._atts     || {};   // adjuntos por orden y etapa
window._repSugIA = window._repSugIA || {};   // sugerencias de la IA por SKU
window._nsapFotos= window._nsapFotos|| {};   // fotos sacadas del Excel

// ═══════════════════════════════════════════════════════════════
//  CONEXIÓN A SUPABASE (datos reales de OPOR + seguimiento)
// ═══════════════════════════════════════════════════════════════
// Versión del portal: si no coincide con la última, el navegador tiene una copia vieja
const APP_VERSION = 'v771';
/* Cuándo se subió esta versión, en HORA DE PANAMÁ (UTC-5), que es la que
   ve la gente en su reloj. Se escribe a mano al publicar, junto con el
   número de arriba.
   Además, el portal anota la primera vez que CADA navegador ve una versión
   nueva: si por lo que sea esta fecha se queda vieja, abajo manda lo que de
   verdad pasó en ese equipo. */
const APP_FECHA = '2026-11-02 12:00';
const SB = 'https://sutnfihpmfsejdlkghjp.supabase.co';
const KEY = 'sb_publishable_5ZJdu4hX49XRH1q0dCFsAQ_0S0Eps95';
const SBH = { 'apikey': KEY, 'Authorization': 'Bearer ' + KEY, 'Content-Type': 'application/json' };

// Base pública del bucket de fotos de items en Supabase Storage
const FOTO_BASE = SB + '/storage/v1/object/public/fotos-items/';

// Construye la URL de la foto de una línea de OPOR.
// Usa picturname (nombre del archivo en SAP) en MINÚSCULA para que coincida con
// el bucket (el sync sube las fotos en minúscula). Respaldo: foto_url de Shopify.
function fotoDeLinea(l){
  if(!l) return '';
  var pn = (l.picturname || l.PicturName || '').toString().trim();
  if(pn) return FOTO_BASE + encodeURIComponent(pn);   // nombre TAL CUAL está en el bucket
  if(l.foto_url) return l.foto_url;
  if(l.imagen_url) return l.imagen_url;   // compatibilidad con el campo viejo
  return '';
}
// Variantes de URL de la foto para intentar en orden (cubre mayúsc/minúsc del bucket)
function fotoVariantes(l){
  if(!l) return [];
  var pn = (l.picturname || l.PicturName || '').toString().trim();
  var urls = [];
  // Del nombre de la foto y del propio código del artículo se prueban las
  // variantes que usa el catálogo: con y sin extensión, en mayúscula y en
  // minúscula. Así salen también las que el bucket guardó con otro nombre.
  var cod=(l.itemcode || l.ItemCode || l.item_code || '').toString().trim();
  [pn, cod].forEach(function(base){
    if(!base) return;
    try{
      _catFotoVariantes(base).forEach(function(u){ if(urls.indexOf(u)<0) urls.push(u); });
    }catch(e){
      var u=FOTO_BASE+encodeURIComponent(base);
      if(urls.indexOf(u)<0) urls.push(u);
    }
  });
  if(l._fotoUrl) urls.push(l._fotoUrl);
  if(l.foto) urls.push(l.foto);
  if(l.foto_url) urls.push(l.foto_url);
  if(l.imagen_url) urls.push(l.imagen_url);
  // Último recurso: la imagen que guardó el catálogo NO SAP. Es la única que
  // existe mientras SAP no cargue la suya, y como va al final solo se usa si
  // ninguna de las de SAP responde. El código llega con distintos nombres de
  // campo según la pantalla, así que se prueban todos.
  try{
    var nf=_fotoNoSapDeSku(l.itemcode || l.ItemCode || l.item_code || l.sku || l.SKU);
    if(nf && urls.indexOf(nf)<0) urls.push(nf);
  }catch(e){}
  return urls;
}

// ── La foto que tenemos de un SKU fuera de SAP ──
// Las fichas temporales guardan la imagen que vino del Excel del proveedor.
// Mientras SAP no tenga una foto usable, esa es la única que existe, así que
// cualquier pantalla que no encuentre imagen en SAP tiene que mirar aquí.
function _fotoNoSapDeSku(itemcode){
  var sku=String(itemcode||'').trim().toUpperCase();
  if(!sku) return '';
  // 1) Lo guardado en la ficha temporal (sobrevive a recargar la página).
  //    La imagen puede estar en 'foto' o en 'foto_url' según cómo se creó la
  //    ficha: el resto del portal mira los dos, y aquí solo se miraba uno.
  //    Por eso la fila en ámbar enseñaba la foto y la de SAP no.
  var f=(window._catNoSap||[]).find(function(x){
    return x && x.tipo!=='proveedor' && String(x.itemcode||'').trim().toUpperCase()===sku;
  });
  var u=f && (f.foto || f.foto_url || f.imagen_url || '');
  if(u) return _fotoNoSapUrl(u);
  // 2) Lo que se sacó del Excel en esta misma sesión
  var m=(window._nsapFotos||{})[sku];
  if(m && m.url) return m.url;
  return '';
}

// Si lo guardado es una ruta del almacenamiento y no una dirección completa,
// se le pone delante la base del bucket.
function _fotoNoSapUrl(v){
  var s=String(v||'').trim();
  if(!s) return '';
  if(/^(https?:|data:|blob:)/i.test(s)) return s;
  try{ return DOCS_BASE + s.split('/').map(encodeURIComponent).join('/'); }
  catch(e){ return s; }
}

// Normaliza el grupo de artículos de SAP a un departamento de la app
// Ej: "..Hogar" -> "hogar", "..Alfombra" -> "alfombras"
function normDept(g){
  if(!g) return 'otros';
  // Quitar los puntos al inicio (ej: "..Hogar" -> "hogar")
  var s = g.replace(/^\.+/,'').trim().toLowerCase();
  // Mapeo exacto basado en los valores reales de SAP B1
  var map = {
    // Con puntos al inicio (valores SAP confirmados)
    'hogar'       : 'hogar',
    'ropa'        : 'ropa',
    'muebles'     : 'muebles',
    'alfombra'    : 'alfombras',
    'alfombras'   : 'alfombras',
    'campamento'  : 'campamento',
    'electronica' : 'electronica',
    'electrónica' : 'electronica',
    'ferreteria'  : 'ferreteria',
    'ferretería'  : 'ferreteria',
    // Sin puntos - "Artículos" es un grupo genérico en SAP → otros
    // Home Deco caía en "otros" y por eso no se podía asignar a nadie
    'home deco'   : 'homedeco',
    'homedeco'    : 'homedeco',
    'home-deco'   : 'homedeco',
    'articulos'   : 'otros',
    'artículos'   : 'otros',
    'articulo'    : 'otros',
    'artículo'    : 'otros',
  };
  return map[s] || 'otros';
}

// Emoji por departamento
function deptEmoji(d){
  return {hogar:'🏠',ropa:'👗',muebles:'🪑',alfombras:'🟫',campamento:'⛺',
          electronica:'📱',homedeco:'🖼️',ferreteria:'🔧',otros:'📦'}[d] || '📦';
}

// Formatea fecha ISO (2026-01-22) al formato de la app ("22 ene 2026")
function isoADisplay(iso){
  if(!iso) return '';
  var m=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  var p=String(iso).slice(0,10).split('-');
  if(p.length<3) return iso;
  return p[2]+' '+(m[parseInt(p[1])-1]||'')+' '+p[0];
}

// Carga TODAS las órdenes OPOR + sus líneas + el seguimiento guardado,
// y arma el array `orders` y `stageProgress` que la app ya sabe usar.
// Los cargadores de apoyo. Cada uno se mide por separado para saber cuál
// tarda; el que se pase de 3 segundos queda anotado en la consola.
function _cargarAuxiliares(){
  var tareas=[
    ['bookings',              cargarBookings],
    ['artes',                 cargarArtes],
    ['aprobaciones',          cargarAprob],
    ['correos de depósito',   cargarDepMail],
    ['comentarios pendientes',cargarComPend],
    ['llegadas',              cargarLlegadas],
    ['pendientes SAP',        cargarPendSAP]
  ];
  var t0=Date.now();
  var todas=tareas.map(function(t){
    var ti=Date.now();
    var pr;
    try{ pr=Promise.resolve(t[1]()); }catch(e){ pr=Promise.reject(e); }
    return pr.then(function(){
      var ms=Date.now()-ti;
      if(ms>3000) console.warn('[carga] '+t[0]+' tardó '+(ms/1000).toFixed(1)+'s');
      return {n:t[0], ms:ms, ok:true};
    }).catch(function(e){
      console.warn('[carga] '+t[0]+' falló:', e && e.message || e);
      return {n:t[0], ms:Date.now()-ti, ok:false};
    });
  });
  return Promise.all(todas).then(function(rs){
    rs.sort(function(a,b){ return b.ms-a.ms; });
    console.log('[carga] apoyo terminado en '+((Date.now()-t0)/1000).toFixed(1)+'s · '
      +rs.map(function(r){ return r.n+' '+(r.ms/1000).toFixed(1)+'s'+(r.ok?'':' (falló)'); }).join(' · '));
    return true;
  });
}

async function cargarDatosReales(){
  try{
    try{ window._ultimoSync=localStorage.getItem('kcc_ultimoSync')||window._ultimoSync; }catch(e){}
    // Las consultas de abajo no dependen unas de otras, así que se lanzan
    // TODAS A LA VEZ. Antes iban en fila india —cada una esperaba a que
    // terminara la anterior—, y con once viajes al servidor eso es lo que
    // hacía que "Cargando órdenes…" se quedara tanto rato en pantalla.
    console.time('[carga] datos iniciales');

    // Una consulta minúscula para saber si la cabecera ya trae los datos
    // agregados. Cuesta milisegundos y ahorra megabytes.
    try{
      var _sonda=await fetch(SB+'/rest/v1/opor_ordenes?select=unidades,grupo_items&limit=1',
        {headers:SBH});
      if(_sonda.ok){
        var _f=(await _sonda.json()||[])[0];
        window._lineasNoHacenFalta = !!(_f && (_f.grupo_items!=null || _f.unidades!=null));
      }
    }catch(e){ window._lineasNoHacenFalta=false; }
    if(window._lineasNoHacenFalta)
      console.log('[carga] la cabecera trae los datos de línea: arranque ligero');

    // Las líneas se traen en tandas de 1000. La primera dice cuántas hay;
    // si hay más, el resto de tandas también se piden a la vez.
    async function _traerLineas(){
      var _t0=Date.now();
      var base=SB+'/rest/v1/opor_lineas?select=docnum,itemname,cantidad,grupo_items&limit=1000&offset=';
      var hdr=Object.assign({},SBH,{'Prefer':'count=none'});
      var out=[], offset=0;
      // Las cabeceras ya traen unidades, grupo y descripción calculados en
      // SAP. Si están, no se bajan las líneas: son unos 4 MB que retrasaban
      // el arranque, sobre todo en tableta.
      if(window._lineasNoHacenFalta){
        console.log('[carga] líneas omitidas: la cabecera ya trae los datos');
        return [];
      }
      while(true){
        // Cuatro tandas en paralelo por vuelta: suficiente para ir rápido
        // sin abrir demasiadas conexiones a la vez.
        var lote=await Promise.all([0,1,2,3].map(function(k){
          return fetch(base+(offset+k*1000), {headers:hdr})
            .then(function(r){ return r.ok?r.json():[]; })
            .catch(function(){ return []; });
        }));
        var vacias=0;
        for(var i=0;i<lote.length;i++){
          var pg=Array.isArray(lote[i])?lote[i]:[];
          out=out.concat(pg);
          if(pg.length<1000) vacias++;
        }
        if(vacias>0) break;             // alguna tanda vino corta: ya no hay más
        offset+=4000;
        if(offset>50000) break;
      }
      var _ms=Date.now()-_t0;
      if(_ms>3000) console.warn('[carga] líneas tardó '+(_ms/1000).toFixed(1)+'s para '+out.length+' fila(s)');
      return out;
    }

    async function _json(url, hdr, nombre){
      var t=Date.now();
      try{
        var r=await fetch(url, {headers:hdr||SBH});
        if(!r.ok){
          var txt=''; try{ txt=await r.text(); }catch(e){}
          console.warn('[carga] '+(nombre||'consulta')+' '+r.status+': '+txt.slice(0,160));
          return [];
        }
        var j=await r.json();
        var ms=Date.now()-t;
        if(ms>3000) console.warn('[carga] '+(nombre||'consulta')+' tardó '+(ms/1000).toFixed(1)+'s');
        return Array.isArray(j)?j:[];
      }catch(e){ console.warn('[carga] '+(nombre||'consulta')+':', e&&e.message||e); return []; }
    }

    var _res = await Promise.all([
      _json(SB+'/rest/v1/opor_ordenes?select=*&order=docnum.desc',null,'órdenes'),
      _traerLineas(),                                                         // 2) líneas
      _json(SB+'/rest/v1/compras_seguimiento?select=*',null,'seguimiento'),
      _json(SB+'/rest/v1/compras_comentarios?select=*&order=creado_en.asc',null,'comentarios'),
      // 5) Y los siete cargadores propios. SÍ se espera a que terminen: uno de
      //    ellos trae las órdenes NO SAP, y sin ellas el tablero se dibujaba
      //    vacío. Se miden por separado para saber cuál es el lento.
      _cargarAuxiliares()
    ]);

    var ordEnes=_res[0], lineas=_res[1], segui=_res[2], coments=_res[3];
    console.timeEnd('[carga] datos iniciales');
    console.log('[carga] '+ordEnes.length+' órdenes · '+lineas.length+' líneas · '
      +segui.length+' seguimientos · '+coments.length+' comentarios');

    // --- Agrupa líneas por orden ---
    // Si la cabecera ya trae los tres datos calculados en SAP (unidades,
    // grupo y descripción), NO hace falta bajarse las líneas: eran unos 4 MB
    // antes de pintar nada, y en un iPad eso son treinta segundos de espera.
    var porOrden = {};
    var _cabeceraTraeTodo = ordEnes.length>0 &&
      ordEnes.some(function(o){ return o.grupo_items!=null || o.unidades!=null; });

    if(_cabeceraTraeTodo){
      ordEnes.forEach(function(o){
        var dn=String(o.docnum);
        porOrden[dn]={
          grupos:(o.grupo_items?({}, (function(){ var g={}; g[o.grupo_items]=1; return g; })()):{}),
          unidades:Number(o.unidades)||0,
          primeraDesc:o.primera_desc||''
        };
      });
      console.log('[carga] los datos de línea vienen en la cabecera: '
        +'no hace falta descargarlas');
    } else {
      lineas.forEach(function(l){
        var dn = String(l.docnum);
        if(!porOrden[dn]) porOrden[dn] = {grupos:{}, unidades:0, primeraDesc:''};
        var g = l.grupo_items || '';
        porOrden[dn].grupos[g] = (porOrden[dn].grupos[g]||0) + 1;
        porOrden[dn].unidades += parseFloat(l.cantidad)||0;
        if(!porOrden[dn].primeraDesc && l.itemname) porOrden[dn].primeraDesc = l.itemname;
      });
    }
function deptDominante(dn){
      var g = porOrden[dn] ? porOrden[dn].grupos : {};
      var best='', max=-1;
      Object.keys(g).forEach(function(k){ if(g[k]>max){max=g[k];best=k;} });
      return normDept(best);
    }

    // --- Construye el array orders con el formato de la app ---
    orders = ordEnes.map(function(o){
      var dn = String(o.docnum);
      var info = porOrden[dn] || {unidades:0, primeraDesc:''};
      var dept = deptDominante(dn) || 'otros';
      var total = parseFloat(o.total)||0;
      var abono = parseFloat(o.abono)||0;
      return {
        id: dn,
        dept: dept,
        prov: o.vendor_name || '-',
        valor: total,
        abono: abono,
        desc: info.primeraDesc || o.comentarios || 'Orden '+dn,
        alerta: false,
        resp: o.vendor_code || '',
        fechaCreacion: isoADisplay(o.docdate),
        fechaEst: isoADisplay(o.eta || o.duedate),
        uni: Math.round(info.unidades),
        emoji: deptEmoji(dept),
        pend: false,          // las OPOR ya vienen aprobadas en SAP
        completada: false,
        _estadoSap: o.estado_compra || '',
        // Lo del embarque que las compradoras escriben en SAP: el contenedor
        // y la «Marca de Cliente», donde suele ir el número de BL
        marca_cliente: o.marca_cliente || '',
        contenedor: o.contenedor || '',
        num_contenedor_campo: o.num_contenedor_campo || '',
        barco: o.barco || '',
        puerto_embarque: o.puerto_embarque || '',
        estado_compra: o.estado_compra || '',
        booking: o.booking || '',
        eta_sap: o.eta || '',
        _docstatus: o.doc_status || '',
        vendorEmail: o.vendor_email || '',        // correo del proveedor (OCRD.E_Mail)
        fechaAbono: isoADisplay(o.fecha_abono),   // fecha del abono en SAP
        num_proveedor: o.num_proveedor || ''
      };
    });

    // --- Cargar actividad reciente (últimas 48h) ---
    try{
      var hace48h=new Date(Date.now()-48*60*60*1000).toISOString();
      // La columna actualizado_en puede no existir en la tabla: el portal la
      // manda al guardar, pero si nunca se creó, PostgREST la descarta en
      // silencio y luego rechaza la consulta que la pide. Si eso pasa, se
      // sigue sin la actividad de seguimiento en vez de llenar el log.
      var rAct1=await fetch(SB+'/rest/v1/compras_seguimiento?select=docnum,etapa,actualizado_en&actualizado_en=gte.'+hace48h+'&order=actualizado_en.desc&limit=100',{headers:SBH});
      var act1=[];
      if(rAct1.ok){ act1=await rAct1.json(); }
      else if(!window._avisoActEn){
        window._avisoActEn=1;
        var _ta=''; try{ _ta=await rAct1.text(); }catch(e){}
        console.warn('[actividad] compras_seguimiento '+rAct1.status+': '+_ta.slice(0,160)
          +' — la actividad reciente se muestra solo con los comentarios.');
      }
      var rAct2=await fetch(SB+'/rest/v1/compras_comentarios?select=docnum,etapa,autor,creado_en&creado_en=gte.'+hace48h+'&order=creado_en.desc&limit=100',{headers:SBH});
      var act2=rAct2.ok?(await rAct2.json()):[];
      // Combinar y deduplicar por docnum, quedarse con el más reciente
      var actMap={};
      (Array.isArray(act1)?act1:[]).forEach(function(r){
        var ts=r.actualizado_en||'';
        if(!actMap[r.docnum]||ts>actMap[r.docnum].ts)
          actMap[r.docnum]={docnum:String(r.docnum),etapa:r.etapa||'',autor:r.usuario||'',ts:ts,tipo:'etapa'};
      });
      (Array.isArray(act2)?act2:[]).forEach(function(r){
        var ts=r.creado_en||'';
        if(!actMap[r.docnum]||ts>actMap[r.docnum].ts)
          actMap[r.docnum]={docnum:String(r.docnum),etapa:r.etapa||'',autor:r.autor||'',ts:ts,tipo:'comentario'};
      });
      _recentActivity=Object.values(actMap).sort(function(a,b){return b.ts.localeCompare(a.ts);});
    }catch(e){_recentActivity=[];}
    // --- Reconstruye stageProgress desde compras_seguimiento ---
    stageProgress = {};
    orders.forEach(function(o){ initP(o.id); });
    segui.forEach(function(s){
      var dn = String(s.docnum);
      initP(dn);
      if(stageProgress[dn] && stageProgress[dn][s.etapa]){
        var fechas = [];
        try { fechas = Array.isArray(s.fechas_pasos) ? s.fechas_pasos : JSON.parse(s.fechas_pasos||'[]'); } catch(e){ fechas=[]; }
        stageProgress[dn][s.etapa].stepIdx = s.paso_actual || 0;
        stageProgress[dn][s.etapa].startDate = isoADisplay(s.fecha_inicio);
        stageProgress[dn][s.etapa].stepDates = fechas.map(isoADisplay);
        // guardar también las ISO para poder re-guardar sin perder formato
        stageProgress[dn][s.etapa]._isoInicio = s.fecha_inicio || '';
        stageProgress[dn][s.etapa]._isoPasos = fechas.slice();
      }
    });
    // Si una orden NO SAP ya entró a SAP, el avance se mueve a la clave nueva
    try{ await _migrarEtapasNoSap(true); }catch(e){ console.warn('migrar etapas:',e); }
    // Marca como completadas las órdenes cuya última etapa (bodega) esté terminada
    orders.forEach(function(o){
      var sp = stageProgress[o.id];
      if(sp && sp.bodega && STAGES.length){
        var ult = STAGES[STAGES.length-1];
        if(sp[ult.key] && sp[ult.key].stepIdx >= ult.steps.length) o.completada = true;
      }
      // Y lo que SAP ya cerró también está completado, aunque el seguimiento
      // del portal se haya quedado a medias. Al crear la factura reserva SAP
      // pone DocStatus='C': esa orden no vuelve a moverse, y hasta ahora
      // simplemente desaparecía.
      if(String(o._docstatus||'').toUpperCase()==='C'){
        o.completada = true;
        o.cerradaSap = true;
      }
    });

    // --- Inyecta comentarios ---
    // Se vacía primero: antes se hacía push sobre lo que ya había y cada
    // recarga duplicaba todos los comentarios.
    window._subComs={};
    (orders||[]).forEach(function(o){
      if(stageProgress[o.id]) STAGES.forEach(function(st){
        if(stageProgress[o.id][st.key]) stageProgress[o.id][st.key].comments=[];
      });
    });
    var _vistosCom={};
    coments.forEach(function(c){
      // Ni el mismo comentario dos veces
      var _k=String(c.id||'')||(String(c.docnum)+'|'+String(c.etapa)+'|'+String(c.autor)+'|'+String(c.texto)+'|'+String(c.creado_en));
      if(_vistosCom[_k]) return;
      _vistosCom[_k]=1;
      var dn = String(c.docnum);
      var et = c.etapa||'';
      // Comentarios de sub-etapa (live chat de pasos) y de pendientes SAP van a _subComs
      if(et.indexOf('sub_')===0 || et.indexOf('pendsap_')===0 || et.indexOf('_step')>=0){
        var ck = et.indexOf('sub_')===0 ? et : (et.indexOf('pendsap_')===0 ? et : ('sub_'+dn+'_'+et));
        if(!window._subComs[ck]) window._subComs[ck]=[];
        window._subComs[ck].push({
          id: c.id,
          autor: c.autor + (c.autor_rol?' ('+c.autor_rol+')':''),
          ini: (c.autor||'--').slice(0,2).toUpperCase(),
          texto: c.texto, time: isoADisplay(c.creado_en),
          role: c.autor_rol||'', by: c.autor||''
        });
        return;
      }
      if(stageProgress[dn] && stageProgress[dn][c.etapa]){
        if(!stageProgress[dn][c.etapa].comments) stageProgress[dn][c.etapa].comments=[];
        stageProgress[dn][c.etapa].comments.push({
          autor: c.autor + (c.autor_rol?' ('+c.autor_rol+')':''),
          ini: (c.autor||'--').slice(0,2).toUpperCase(),
          texto: c.texto,
          time: isoADisplay(c.creado_en)
        });
      }
    });

    return true;
  }catch(e){
    console.error('Error cargando datos reales:', e);
    return false;
  }
}

// ── Guardado en Supabase (se llama al avanzar/revertir/comentar) ──
async function guardarEtapa(docnum, etapa){
  try{
    var sp = stageProgress[docnum] && stageProgress[docnum][etapa];
    if(!sp) return;
    // Convierte fechas display de nuevo a ISO no es trivial; guardamos las ISO
    // que ya generamos al avanzar (usamos hoy en ISO). Para robustez, guardamos
    // fecha_inicio y fechas_pasos tal cual estén (la app las relee bien).
    var body = {
      docnum: String(docnum),
      etapa: etapa,
      paso_actual: sp.stepIdx || 0,
      fecha_inicio: sp._isoInicio || null,
      fechas_pasos: JSON.stringify(sp._isoPasos || []),
      completada: (sp.stepIdx||0) >= (STAGES.find(function(s){return s.key===etapa;})?.steps.length||99),
      actualizado_por: CU ? CU.name : '',
      actualizado_en: new Date().toISOString()
    };
    await fetch(SB+'/rest/v1/compras_seguimiento?on_conflict=docnum,etapa', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify(body)
    });
  }catch(e){ console.error('guardarEtapa:', e); }
}

async function guardarComentario(docnum, etapa, texto){
  try{
    await fetch(SB+'/rest/v1/compras_comentarios', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'return=minimal'}),
      body: JSON.stringify({
        docnum:String(docnum), etapa:etapa,
        autor: CU?CU.name:'', autor_rol: CU?CU.role:'',
        texto: texto, creado_en: new Date().toISOString()
      })
    });
  }catch(e){ console.error('guardarComentario:', e); }
}

// Guarda el booking + contenedores de una orden (upsert por docnum)
async function guardarBooking(oid){
  try{
    var bk = getBK(oid);
    await fetch(SB+'/rest/v1/compras_booking?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({
        docnum: String(oid),
        naviera: bk.naviera || '',
        booking: bk.booking || '',
        containers: bk.containers || [],
        actualizado_por: CU ? CU.name : '',
        actualizado_en: new Date().toISOString()
      })
    });
  }catch(e){ console.error('guardarBooking:', e); }
}

// Carga TODOS los bookings guardados a memoria (se llama al iniciar la app)
async function cargarBookings(){
  try{
    var r = await fetch(SB+'/rest/v1/compras_booking?select=*', {headers:SBH});
    var rows = await r.json();
    if(!window._bookingData) window._bookingData={};
    if(Array.isArray(rows)){
      rows.forEach(function(row){
        var conts = row.containers;
        if(typeof conts==='string'){ try{conts=JSON.parse(conts);}catch(e){conts=[];} }
        window._bookingData[String(row.docnum)] = {
          naviera: row.naviera||'',
          booking: row.booking||'',
          containers: Array.isArray(conts)?conts:[]
        };
      });
    }
  }catch(e){ console.error('cargarBookings:', e); }
}

const DEPTS_ALL=['hogar','alfombras','muebles','ropa','campamento','electronica','homedeco','ferreteria','otros'];
// Los departamentos que puede ver quien está dentro. Gerencia sin área los ve
// todos; con área asignada (Gady en alfombras, Henry en ropa) solo la suya.
// Las pantallas que pintan un panel por departamento pasan por aquí.
function _deptsVisibles(){
  try{
    // Un usuario puede tener VARIOS departamentos (los diseñadores llevan
    // varias líneas cada uno). "dept" sigue valiendo para quien tiene uno
    // solo, como las compradoras.
    if(CU && CU.depts && CU.depts.length) return CU.depts.slice();
    if(CU && CU.dept) return [CU.dept];
  }catch(e){}
  return DEPTS_ALL;
}

// El texto del área del usuario: "Hogar" con uno, "Hogar · Muebles · Home
// Deco" con varios. Se usa en la barra y en los avisos.
function _deptEtiqueta(){
  var ds=_deptsVisibles();
  if(!_deptAcotado()) return '';
  return ds.map(function(d){ return dL(d); }).join(' · ');
}
function _deptEmojis(){
  if(!_deptAcotado()) return '';
  return _deptsVisibles().map(function(d){ return EMOJIS2[d]||''; }).join('');
}
// El trozo de URL para acotar una consulta por departamento. Con uno solo
// va "eq."; con varios, "in.(a,b,c)". Sin límite, cadena vacía.
function _deptFiltroURL(campo){
  var c=campo||'dept';
  if(!_deptAcotado()) return '';
  var ds=_deptsVisibles();
  if(ds.length===1) return '&'+c+'=eq.'+encodeURIComponent(ds[0]);
  return '&'+c+'=in.('+ds.map(encodeURIComponent).join(',')+')';
}

// El primero, para los sitios que necesitan UNO solo (el filtro inicial de
// una pantalla, la orden nueva que se va a crear).
function _deptPrimero(){
  var ds=_deptsVisibles();
  return _deptAcotado() ? (ds[0]||'') : '';
}

// ¿Este usuario puede ver este departamento?
function _deptPermitido(d){
  if(!CU) return false;
  if(CU.depts && CU.depts.length) return CU.depts.indexOf(d)>=0;
  if(CU.dept) return String(d)===String(CU.dept);
  return true;      // sin límite: lo ve todo
}

// ¿Tiene el usuario algún límite de departamento?
function _deptAcotado(){
  return !!(CU && ((CU.depts && CU.depts.length) || CU.dept));
}
const DEPT_LABELS={hogar:'Hogar',alfombras:'Alfombras',muebles:'Muebles',ropa:'Ropa',campamento:'Campamento',electronica:'Electrónica',homedeco:'Home Deco',ferreteria:'Ferretería',otros:'Otros'};
const EMOJIS2={hogar:'🛋️',alfombras:'🟫',muebles:'🪑',ropa:'👗',campamento:'⛺',electronica:'📱',homedeco:'🖼️',ferreteria:'🔧',otros:'📦'};

// ═══════ ILUSTRACIONES SVG POR DEPARTAMENTO (tarjetas de inicio) ═══════
const DEPT_SVG = {
  hogar: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="44" rx="17" ry="4" fill="#00000012"/><path d="M17 30h30v8a6 6 0 0 1-6 6H23a6 6 0 0 1-6-6v-8Z" fill="#F5F0E8" stroke="#B99A6B" stroke-width="1.5"/><rect x="14" y="27" width="36" height="4" rx="2" fill="#D9C4A3" stroke="#B99A6B" stroke-width="1.2"/><path d="M30 27c0-3 4-3 4-6" stroke="#B99A6B" stroke-width="1.5" stroke-linecap="round"/><rect x="40" y="14" width="4" height="14" rx="2" fill="#C69A6B"/><rect x="45" y="16" width="4" height="12" rx="2" fill="#B5895A"/><circle cx="25" cy="20" r="5" fill="#7FA9A0"/></svg>`,
  alfombras: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="14" y="18" width="36" height="28" rx="3" fill="#EDE0CC" stroke="#C4A878" stroke-width="1.5"/><rect x="18" y="22" width="28" height="20" rx="2" fill="none" stroke="#C4A878" stroke-width="1"/><path d="M22 38c4-6 8-6 10-10s6-4 10 0" stroke="#B08D57" stroke-width="1.5" fill="none" stroke-linecap="round"/><path d="M22 42c4-6 8-6 10-10" stroke="#CDB68C" stroke-width="1.2" fill="none" stroke-linecap="round"/><rect x="14" y="16" width="36" height="3" fill="#B08D57"/><rect x="14" y="45" width="36" height="3" fill="#B08D57"/></svg>`,
  muebles: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="46" rx="18" ry="3" fill="#00000010"/><path d="M16 32c0-3 2-5 5-5h22c3 0 5 2 5 5v8H16v-8Z" fill="#D8DCCB" stroke="#8B9576" stroke-width="1.5"/><rect x="14" y="30" width="8" height="14" rx="3" fill="#C3C9B0" stroke="#8B9576" stroke-width="1.3"/><rect x="42" y="30" width="8" height="14" rx="3" fill="#C3C9B0" stroke="#8B9576" stroke-width="1.3"/><rect x="20" y="33" width="24" height="7" rx="2" fill="#E8EBDD"/><rect x="19" y="44" width="3" height="6" fill="#8B7355"/><rect x="42" y="44" width="3" height="6" fill="#8B7355"/></svg>`,
  ropa: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 16h12l8 6-4 6-3-2v20a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2V26l-3 2-4-6 8-6Z" fill="#3D4E63" stroke="#2A3646" stroke-width="1.5" stroke-linejoin="round"/><path d="M26 16c0 3 2 5 6 5s6-2 6-5" fill="#4A5D75" stroke="#2A3646" stroke-width="1.3"/></svg>`,
  campamento: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="46" rx="18" ry="3" fill="#00000010"/><path d="M32 18 16 44h32L32 18Z" fill="#6B8E4E" stroke="#4A6533" stroke-width="1.5" stroke-linejoin="round"/><path d="M32 18v26" stroke="#4A6533" stroke-width="1.3"/><path d="M28 44l4-10 4 10" fill="#4A6533"/><path d="M14 44h36" stroke="#8B7355" stroke-width="2" stroke-linecap="round"/><circle cx="44" cy="24" r="3" fill="#E8B84B"/></svg>`,
  electronica: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="16" width="24" height="34" rx="4" fill="#3A3A3E" stroke="#222" stroke-width="1.5"/><rect x="24" y="20" width="16" height="10" rx="2" fill="#5A9FD4"/><circle cx="28" cy="38" r="2.5" fill="#888"/><circle cx="36" cy="38" r="2.5" fill="#888"/><rect x="26" y="44" width="12" height="3" rx="1.5" fill="#666"/></svg>`,
  ferreteria: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 20a7 7 0 0 0-9 8l-13 13 4 4 13-13a7 7 0 0 0 8-9l-4 4-3-1-1-3 5-3Z" fill="#B0B4BA" stroke="#7A7E85" stroke-width="1.5" stroke-linejoin="round"/><rect x="18" y="40" width="8" height="10" rx="2" transform="rotate(-45 22 45)" fill="#C89A5B"/></svg>`,
  otros: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 26l14-7 14 7-14 7-14-7Z" fill="#D9C4A3" stroke="#B08D57" stroke-width="1.5" stroke-linejoin="round"/><path d="M18 26v14l14 7V33L18 26Z" fill="#C9B08A" stroke="#B08D57" stroke-width="1.5" stroke-linejoin="round"/><path d="M46 26v14l-14 7V33l14-7Z" fill="#E0CFAF" stroke="#B08D57" stroke-width="1.5" stroke-linejoin="round"/></svg>`
};
const DEPT_BG = { hogar:'#FCEBD8', alfombras:'#F3EAD8', muebles:'#E8EDDD', ropa:'#E4E8EF', campamento:'#E7EFD9', electronica:'#E5E5EA', ferreteria:'#EDEDF0', otros:'#F3EAD8' };
const DEPT_IMG = {
  hogar: 'data:image/jpeg;base64,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',
  alfombras: 'data:image/jpeg;base64,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',
  muebles: 'data:image/jpeg;base64,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',
  ropa: 'data:image/jpeg;base64,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',
  campamento: 'data:image/jpeg;base64,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',
  electronica: 'data:image/jpeg;base64,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',
};
function _deptIconHTML(d, size){
  size = size||54;
  var img = DEPT_IMG[d];
  if(img){
    // Imagen real del departamento, recortada en círculo
    return '<div style="width:'+size+'px;height:'+size+'px;border-radius:50%;overflow:hidden;flex-shrink:0;background:#F3EAD8">'
      +'<img src="'+img+'" style="width:100%;height:100%;object-fit:cover;display:block" alt=""></div>';
  }
  // Fallback: dibujo SVG para los que no tienen imagen
  var svg = DEPT_SVG[d] || DEPT_SVG.otros;
  var bg = DEPT_BG[d] || '#F0F0F0';
  return '<div style="width:'+size+'px;height:'+size+'px;border-radius:50%;background:'+bg+';display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden">'
    +'<div style="width:'+Math.round(size*0.72)+'px;height:'+Math.round(size*0.72)+'px">'+svg+'</div></div>';
}

function dL(d){return d==='todos'?'Todos':(DEPT_LABELS[d]||d);}
const PASS_DEFAULT='kennedy2024';
function ini(n){const p=n.trim().split(' ');return p.length>=2?(p[0][0]+p[1][0]).toUpperCase():n.trim().slice(0,2).toUpperCase();}
const USERS=[
  {id:'edy',name:'Edy Guindi',email:'edy@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'jimmy',name:'Jimmy Guindi',email:'jimmys@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'samuel',name:'Samuel Guindi',email:'samy@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'eli',name:'Eli Guindi',email:'eli@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'itay',name:'Itay Guindi',email:'itay@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'ariel',name:'Ariel Guindi',email:'ariel@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'saul',name:'Saul Noblesilla',email:'sano@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'dan',name:'Dan Benzaquen',email:'dan@kennedyzl.com',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'lorena',name:'Lorena Cabrera',email:'lorena@kennedyzl.com',role:'compras',dept:'hogar',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'sherene',name:'Sherene Muor',email:'sherene@kennedyzl.com',role:'compras',dept:'hogar',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'libny',name:'Libny',email:'compras3@kennedyzl.com',role:'compras',dept:'hogar',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'edgardo',name:'Edgardo Chiru',email:'furniture@kennedyzl.com',role:'compras',dept:'muebles',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'zeida',name:'Zeida',email:'zeida@kennedyzl.com',role:'compras',dept:'electronica',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'yagizel',name:'Yagizel Ortega',email:'yagizel@kennedyzl.com',role:'compras',dept:'ropa',depts:['ropa','campamento'],color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'henry',name:'Henry Pérez',email:'henry@kennedyzl.com',role:'gerencia',dept:'ropa',color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'eimy',name:'Eimy English',email:'carpets2@kennedyzl.com',role:'compras',dept:'alfombras',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'gady',name:'Gady Naor',email:'gady@kennedyzl.com',role:'gerencia',dept:'alfombras',color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'franco',name:'Franco',email:'nfranco@kennedyzl.com',role:'diseno',dept:null,depts:['hogar','muebles','homedeco'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'osmar',name:'Osmar',email:'osmar@kennedyzl.com',role:'diseno',dept:null,depts:['campamento','electronica','ropa'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'xinara',name:'Sinara',email:'diseno1@kennedyzl.com',role:'diseno',dept:null,depts:['hogar'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'erwin',name:'Erwin',email:'diseno3@kennedyzl.com',role:'diseno',dept:null,depts:['hogar'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'jamileth',name:'Jamileth',email:'jami@kennedyzl.com',role:'importacion',dept:null,etapas:['logistica','costeo'],color:'#E1F5EE',tc:'#085041',nav:['dashboard','ordenes','mistarea','deptos','alertas','reposiciones'],verCostos:false},
  {id:'nasly',name:'Nasly',email:'importacion2@kennedyzl.com',role:'importacion',rolesExtra:['compras'],dept:null,color:'#E1F5EE',tc:'#085041',nav:['dashboard','ordenes','completadas','pendientes','mistarea','deptos','alertas','reposiciones','nueva'],verCostos:false},
  {id:'yeini',name:'Yeini',email:'yeini@kennedyzl.com',role:'contabilidad',dept:null,color:'#FBEAF0',tc:'#72243E',nav:['dashboard','ordenes','completadas','deptos','alertas','reposiciones'],verCostos:true},
  {id:'deici',name:'Deici',email:'contabilidad3@kennedyzl.com',role:'contabilidad',dept:null,color:'#FBEAF0',tc:'#72243E',nav:['dashboard','ordenes','completadas','deptos','alertas','reposiciones'],verCostos:true},
  {id:'deicisoto',name:'Deici Soto',email:'deici@kennedyzl.com',role:'contabilidad',dept:null,color:'#FBEAF0',tc:'#72243E',nav:['dashboard','ordenes','completadas','deptos','alertas','reposiciones'],verCostos:true},
  {id:'edwin',name:'Edwin Quintero',email:'edwin@kennedyzl.com',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'david',name:'David',email:'david@kennedyzl.com',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'jhon',name:'Jhon',email:'john@kennedyzl.com',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'neder',name:'Neder',email:'neder@kennedyzl.com',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
];
USERS.forEach(u=>{if(!u.ini)u.ini=ini(u.name);});
// Diseño, importación, bodega y contabilidad NO tienen acceso a Reposiciones
USERS.forEach(function(u){
  if(['diseno','importacion','bodega','contabilidad'].indexOf(u.role)>=0){
    u.nav=(u.nav||[]).filter(function(n){ return n!=='reposiciones' && n!=='reppedidos'; });
  }
});
// Gerencia también accede a "Compras para firmar" (aprobar/firmar órdenes)
USERS.forEach(function(u){ if(u.role==='gerencia' && (u.nav||[]).indexOf('nueva')<0){ u.nav.push('nueva'); } });
USERS.forEach(function(u){ if((u.nav||[]).indexOf('livechat')<0) u.nav.push('livechat'); });
// Reportes: lo ven todos menos diseño, que no trabaja con embarques
USERS.forEach(function(u){
  if(u.role==='diseno') return;
  if((u.nav||[]).indexOf('reportes')<0) u.nav.push('reportes');
});
const SAP_STOCK={'Juego de sábanas premium':{stock:280,min:50,status:'high'},'Sofás esquineros':{stock:12,min:10,status:'low'},'Cuadros decorativos':{stock:0,min:20,status:'out'},'Colección verano':{stock:450,min:100,status:'high'},'Alfombras persas 3x4':{stock:8,min:15,status:'low'},'Televisores 55" Smart':{stock:35,min:20,status:'ok'}};

// ════════════════════════════════════════════════════════════════════
//  CORREO DESDE LAS ETAPAS
//  Se escribe y se envia sin salir de la ventana. El navegador no manda
//  el correo: lo deja en `correos_queue` y kennedy_live.py lo envia por
//  Brevo, que es el mecanismo que ya existia.
// ════════════════════════════════════════════════════════════════════
window._mailAdj = [];   // adjuntos elegidos: {nombre, mime, contenido(base64), kb}

function _mailEsc(t){
  return String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function mailAbrir(oid, etapaKey, pasoIdx){
  var stage = STAGES.find(function(x){return x.key===etapaKey;}) || {};
  var paso  = (pasoIdx!=null && stage.steps) ? stage.steps[pasoIdx] : null;
  var o     = (typeof orders!=='undefined') ? orders.find(function(x){return x.id===oid;}) : null;
  window._mailAdj = [];

  var titulo = stage.label || etapaKey;
  if(paso) titulo += ' \u2192 ' + paso.name;

  // Asunto y cuerpo ya escritos, para no partir de cero
  var asunto = '[' + oid + '] ' + titulo;
  var cuerpo = 'Orden: ' + oid + '\n'
             + (o && o.desc ? ('Descripcion: ' + o.desc + '\n') : '')
             + (o && o.prov ? ('Proveedor: ' + o.prov + '\n') : '')
             + 'Etapa: ' + (stage.label||etapaKey) + '\n'
             + (paso ? ('Paso: ' + paso.name + '\n') : '')
             + '\n';

  // Destinatarios: NADIE marcado de entrada (v741). Antes se marcaban solos
  // los del rol responsable de la etapa (todo compras, por ejemplo) y el
  // correo salía a gente que no tenía que recibirlo. Ahora quien envía elige
  // a mano. A los responsables de la etapa solo se les resalta, para
  // encontrarlos rápido.
  var rolObjetivo = (paso && paso.role) || stage.alertRole || '';
  var chips = USERS.filter(function(u){ return u.email; }).map(function(u){
    var sug = false;
    var resaltar = rolObjetivo && u.role===rolObjetivo && u.id!==CU.id;
    return '<label class="mail-dest" title="'+(resaltar?'Responsable de esta etapa':'')+'" style="'+(resaltar?'box-shadow:inset 0 0 0 1px #85B7EB;':'')+'display:flex;align-items:center;gap:6px;padding:5px 8px;border:0.5px solid var(--border);border-radius:8px;cursor:pointer;font-size:12px;background:var(--surface-2)">'
      +'<input type="checkbox" value="'+_mailEsc(u.email)+'" data-n="'+_mailEsc(u.name)+'"'+(sug?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')+';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:600;flex-shrink:0">'
      +_mailEsc((u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_mailEsc(u.name)+'</span>'
      +'</label>';
  }).join('');

  var ov=document.createElement('div');
  ov.id='modalMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10000;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:660px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
      +'<div style="font-size:15px;font-weight:600"><i class="ti ti-mail" style="color:var(--text-accent)"></i> Enviar correo</div>'
      +'<button onclick="mailCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="font-size:11.5px;color:var(--text-muted);background:var(--surface-1);border-radius:8px;padding:8px 10px;margin-bottom:12px">'
      +'<b>'+_mailEsc(titulo)+'</b> \u00b7 orden '+_mailEsc(oid)+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_mailEsc(CU.name)+' &lt;'+_mailEsc(CU.email||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">El correo sale con tu direcci\u00f3n, y las respuestas te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA \u2014 marca uno o varios</div>'
    +'<div id="mail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px;max-height:170px;overflow-y:auto">'+chips+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="mail-asunto" value="'+_mailEsc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);box-sizing:border-box">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="mail-cuerpo" rows="7" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);box-sizing:border-box;font-family:inherit;resize:vertical">'+_mailEsc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:6px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="mailCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="mail-btn" onclick="mailEnviar(\'' + oid + '\',\'' + etapaKey + '\',' + (pasoIdx==null?'null':pasoIdx) + ')"><i class="ti ti-send"></i> Enviar</button>'
    +'</div>'
  +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) mailCerrar(); });
  document.body.appendChild(ov);
  _mailAdjuntosDelPaso(oid, etapaKey, pasoIdx);
}

/* v758: el correo de un paso sale con los documentos que ya están subidos en
   ese paso (y, en Depósito & Pago, también los del paso anterior: el
   comprobante del depósito se sube en «Depósito enviado al proveedor» y se
   manda en «Comprobante enviado al proveedor»). Antes había que volver a
   adjuntarlos a mano. Van copias ligeras (_hubAdjLigero): lo que no cabe en
   el correo va como enlace en el mensaje. */
async function _mailAdjuntosDelPaso(oid, etapaKey, pasoIdx){
  if(pasoIdx==null || !window._atts) return;
  var claves=[oid+etapaKey+'_step'+pasoIdx];
  if(etapaKey==='deposito' && pasoIdx>0) claves.push(oid+etapaKey+'_step'+(pasoIdx-1));
  var files=[], vistos={};
  claves.forEach(function(k){
    (window._atts[k]?_dedupDocs(window._atts[k]):[]).forEach(function(f){
      if(f && f.url && !vistos[f.url]){ vistos[f.url]=1; files.push(f); }
    });
  });
  if(!files.length) return;
  var box=document.getElementById('mail-adjs'); if(!box) return;
  var aviso=document.createElement('div');
  aviso.style.cssText='font-size:11.5px;color:var(--text-muted)';
  aviso.innerHTML='<span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando los documentos del paso ('+files.length+')…';
  box.parentNode.insertBefore(aviso, box);
  var puestos=0, enlaces=[], total=0;
  for(var i=0;i<files.length;i++){
    var f=files[i];
    try{
      var adj=await _hubAdjLigero(f.url, f.name||'documento');
      if(!document.getElementById('modalMail')) return;           // se cerró la ventana
      if(adj && total+adj.kb<=HUB_ADJ_TOTAL_MB*1024){ window._mailAdj.push(adj); total+=adj.kb; puestos++; }
      else enlaces.push(f);
    }catch(e){ enlaces.push(f); }
  }
  try{ mailPintarAdjuntos(); }catch(e){}
  if(enlaces.length){
    var tx=document.getElementById('mail-cuerpo');
    if(tx) tx.value+='\n\nDocumentos (enlace):\n'+enlaces.map(function(f){
      return '  • '+(f.name||'documento')+': '+DOCS_BASE+String(f.url).split('/').map(encodeURIComponent).join('/'); }).join('\n');
  }
  aviso.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '+puestos+' documento(s) del paso adjuntos'
    +(enlaces.length?(' · '+enlaces.length+' grande(s) van como enlace en el mensaje'):'')+'. Puedes quitar o añadir.';
}

function mailCerrar(){
  var m=document.getElementById('modalMail'); if(m) m.remove();
  window._mailAdj=[];
}

function _mailMsg(txt, tipo){
  var m=document.getElementById('mail-msg'); if(!m) return;
  if(!txt){ m.style.display='none'; m.innerHTML=''; return; }
  m.style.display='block';
  m.style.color = tipo==='ok' ? '#27500A' : (tipo==='err' ? '#A32D2D' : 'var(--text-muted)');
  m.innerHTML=txt;
}

// Limite de Brevo por correo. Se avisa antes de enviar, no despues.
// Graph manda los adjuntos dentro de la propia petición: por encima de unos
// 3 MB puede rechazarlos. Antes eso BLOQUEABA el envío; ahora solo se avisa y
// se deja intentar, porque el resultado real lo devuelve la cola de correos.
var MAIL_AVISO_MB = 3;    // a partir de aquí se avisa
var MAIL_MAX_MB = 25;     // tope duro: por encima no se intenta

function mailAddFiles(files){
  var pend=Array.prototype.slice.call(files||[]);
  if(!pend.length) return;
  pend.forEach(function(f){
    var fr=new FileReader();
    fr.onload=function(){
      window._mailAdj.push({ nombre:f.name, mime:f.type||'application/octet-stream',
                             contenido:String(fr.result).split(',')[1]||'',
                             kb:Math.round(f.size/1024) });
      mailPintarAdjuntos();
    };
    fr.readAsDataURL(f);
  });
  var inp=document.getElementById('mail-files'); if(inp) inp.value='';
}

function mailQuitarAdj(i){ window._mailAdj.splice(i,1); mailPintarAdjuntos(); }

function mailPintarAdjuntos(){
  // Limpieza antes de pintar: nunca dos veces el mismo documento
  try{ window._mailAdj=_dedupDocs((window._mailAdj||[]).map(function(a){ return Object.assign({},a,{name:a.nombre}); }))
        .map(function(a){ var b=Object.assign({},a); delete b.name; return b; }); }catch(e){}
  var box=document.getElementById('mail-adjs'); if(!box) return;
  var totalKb=window._mailAdj.reduce(function(a,x){return a+(x.kb||0);},0);
  box.innerHTML=window._mailAdj.map(function(a,i){
    return '<div style="display:flex;align-items:center;gap:8px;font-size:12px;background:var(--surface-1);border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-paperclip" style="font-size:12px;color:var(--text-muted)"></i>'
      +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_mailEsc(a.nombre)+'</span>'
      +'<span style="color:var(--text-muted);font-size:10.5px">'+(a.kb>=1024?((a.kb/1024).toFixed(1)+' MB'):(a.kb+' KB'))+'</span>'
      // Ver y descargar ANTES de mandarlo: lo que se envía se mira primero
      +'<button onclick="mailVerAdj('+i+')" title="Ver este archivo" '
      +'style="background:none;border:none;cursor:pointer;color:var(--text-accent);'
      +'font-size:11px;padding:0 4px"><i class="ti ti-eye"></i></button>'
      +'<button onclick="mailBajarAdj('+i+')" title="Descargarlo" '
      +'style="background:none;border:none;cursor:pointer;color:var(--text-accent);'
      +'font-size:11px;padding:0 4px"><i class="ti ti-download"></i></button>'
      +'<button onclick="mailQuitarAdj('+i+')" style="background:none;border:none;cursor:pointer;color:var(--text-danger);font-size:15px;line-height:1">&times;</button>'
      +'</div>';
  }).join('');
  if(window._mailAdj.length){
    var mb=(totalKb/1024).toFixed(1);
    var pasado=totalKb/1024 > MAIL_MAX_MB;
    box.innerHTML += '<div style="font-size:10.5px;margin-top:2px;color:'+(pasado?'var(--text-danger)':'var(--text-muted)')+'">'
      +'Total: '+mb+' MB'+(pasado?(' \u2014 pasa del l\u00edmite de '+MAIL_MAX_MB+' MB, quita alguno'):'')+'</div>';
  }
}

async function mailEnviar(oid, etapaKey, pasoIdx){
  var box=document.getElementById('mail-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ _mailMsg('Marca al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('mail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('mail-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }

  var totalKb=window._mailAdj.reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el l\u00edmite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('mail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando\u2026'; }
  _mailMsg('','info');

  var stage=STAGES.find(function(x){return x.key===etapaKey;})||{};
  var fila={
    docnum: String(oid),
    para_lista: marcados.map(function(c){return c.value;}),
    para_email: marcados[0].value,          // compatibilidad con lo anterior
    asunto: asunto,
    cuerpo: cuerpo,
    adjuntos: window._mailAdj.map(function(a){
      return {nombre:a.nombre, contenido:a.contenido, mime:a.mime};
    }),
    de_nombre: CU.name || '',
    de_email:  CU.email || '',
    origen: (stage.label||etapaKey) + (pasoIdx!=null && stage.steps ? (' \u2192 '+stage.steps[pasoIdx].name) : ''),
    estado: 'pendiente'
  };

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':SBH.Authorization,'Content-Type':'application/json','Prefer':'return=representation'},
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      _mailMsg('No se pudo enviar: '+t.slice(0,180),'err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
    var creado=await r.json();
    _mailSeguir((creado&&creado[0]&&creado[0].id)||null, marcados.length);
  }catch(e){
    _mailMsg('Error de conexi\u00f3n: '+e.message,'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
  }
}

// Espera a que el sync lo mande de verdad, para poder decir "enviado"
// en vez de "encolado".
async function _mailSeguir(id, nDest){
  var btn=document.getElementById('mail-btn');
  if(!id){
    _mailMsg('\u2713 En cola. Saldr\u00e1 en unos segundos.','ok');
    setTimeout(mailCerrar, 1800); return;
  }
  _mailMsg('En cola: esperando a que el sistema lo env\u00ede\u2026','info');
  var intentos=0;
  // v747: se entienden TODOS los estados del correo. Antes «duplicado» no se
  // reconocía y la ventana se quedaba en «Enviando…» sin decir nada.
  var cerrarSinReenviar=function(){
    // Ya está en la cola: el botón pasa a «Cerrar» para no mandarlo dos veces
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-x"></i> Cerrar'; btn.onclick=function(){ mailCerrar(); }; }
  };
  var timer=setInterval(async function(){
    intentos++;
    try{
      var r=await fetch(SB+'/rest/v1/correos_queue?select=estado,error_msg&id=eq.'+id+'&limit=1',{headers:SBH});
      var f=r.ok?(await r.json()):[];
      var row=(f&&f[0])||null;
      if(row){
        if(row.estado==='enviado'){
          clearInterval(timer);
          _mailMsg('\u2713 Enviado a '+nDest+' destinatario(s).','ok');
          setTimeout(mailCerrar, 1500); return;
        }
        if(row.estado==='error'){
          clearInterval(timer);
          _mailMsg('No se pudo enviar: '+(row.error_msg||'sin detalle'),'err');
          if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
          return;
        }
        if(row.estado==='duplicado'){
          clearInterval(timer);
          _mailMsg('No se envi\u00f3: ese MISMO correo (mismo asunto, orden, destinatario y mensaje) ya sali\u00f3 hace poco. '
            +'Si es otro distinto, cambia el asunto o el mensaje y vuelve a enviar.','err');
          if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
          return;
        }
        if(row.estado==='enviando') _mailMsg('Enviando\u2026','info');
      }
    }catch(e){}
    if(intentos===8){
      _mailMsg('Sigue en cola: el sistema lo enviar\u00e1 en cuanto lo tome. Ya puedes cerrar esta ventana; '
        +'lo ver\u00e1s en \u00abMis correos enviados\u00bb.','info');
      cerrarSinReenviar();
    }
    if(intentos>=48){ clearInterval(timer); }
  },2500);
}

const STAGES=[
  {key:'pedido',label:'Pedido',icon:'ti-shopping-cart',color:'#2a78d6',resp:'Compras / Gerencia',alertRole:'compras',steps:[{name:'Pedido creado por compras',role:'compras',docs:[{icon:'📄',name:'Cotización.pdf',meta:'Proveedor'},{icon:'🖼️',name:'Foto.jpg',meta:'Ref'}]},{name:'Aprobado y firmado por gerencia',role:'gerencia',docs:[{icon:'📋',name:'PO-firmada.pdf',meta:'Oficial'}]}]},
  {key:'deposito',label:'Depósito & Pago',icon:'ti-coin',color:'#D4537E',resp:'Contabilidad',alertRole:'contabilidad',noBloquea:true,steps:[{name:'Solicitud de depósito enviada',role:'contabilidad',docs:[{icon:'💰',name:'Solicitud-pago.pdf',meta:'50%'}]},{name:'Depósito enviado al proveedor',role:'contabilidad',docs:[{icon:'🏦',name:'Comprobante.pdf',meta:'Transferencia'}]},{name:'Comprobante enviado al proveedor',role:'compras',docs:[{icon:'📤',name:'Comprobante-proveedor.pdf',meta:'Al proveedor'}]},{name:'Solicitud de final del balance',role:'contabilidad',docs:[{icon:'🏦',name:'Pago-final.pdf',meta:'BL/Embarque'}]},{name:'Comprobante de pago final',role:'compras',docs:[{icon:'📤',name:'Pago-final-proveedor.pdf',meta:'Al proveedor'}]}]},
  {key:'artes',label:'Artes',icon:'ti-palette',color:'#7F77DD',resp:'Diseño / Gerencia',alertRole:'diseno',hasArte:true,steps:[{name:'HUB de diseño',role:'diseno',docs:[{icon:'🎨',name:'Brief.pdf',meta:'Specs'}]},{name:'Artes terminados',role:'diseno',docs:[{icon:'🎨',name:'Arte-final.pdf',meta:'PDF'}]},{name:'Artes aprobados por gerencia',role:'gerencia',docs:[{icon:'🎨',name:'Arte-APROBADO.pdf',meta:'Sello'}]},{name:'Artes enviados al proveedor',role:'compras',docs:[{icon:'📧',name:'Email-confirmado.pdf',meta:'Recepción'}]}]},
  {key:'produccion',label:'Producción',icon:'ti-tool',color:'#BA7517',resp:'Compras / Gerencia',alertRole:'compras',steps:[{name:'Producción terminada — Inspección de producción finalizada',role:'compras',docs:[{icon:'📸',name:'Inspeccion.jpg',meta:'Fotos'}]}]},
  {key:'logistica',label:'Logística',icon:'ti-ship',color:'#1D9E75',resp:'Importación',alertRole:'importacion',steps:[{name:'Booking',role:'importacion',docs:[{icon:'🚢',name:'Booking.pdf',meta:'Naviera'}]},{name:'Bill of Lading (B/L)',role:'importacion',docs:[{icon:'📄',name:'BL.pdf',meta:'B/L'}]},{name:'Aviso de llegada',role:'importacion',docs:[{icon:'🏴',name:'Arrival-notice.pdf',meta:'Puerto'}]}]},
  {key:'costeo',label:'Aduanización & Costeo',icon:'ti-table',color:'#7C3D12',resp:'Importación / Gerencia',alertRole:'importacion',steps:[{name:'DMCE y SIGA',role:'importacion',docs:[{icon:'📋',name:'DMCE.pdf',meta:'Aduana'}]},{name:'DMCE de salida',role:'importacion',docs:[{icon:'📤',name:'DMCE-salida.pdf',meta:'Salida'}]},{name:'Costeo de importación',role:'importacion',docs:[{icon:'📊',name:'Costeo.xlsx',meta:'Excel'}]},{name:'Precios de venta por gerencia',role:'gerencia',docs:[{icon:'📊',name:'Costeo-precios.xlsx',meta:'PVP'}]}]},
  {key:'bodega',label:'Bodega & Venta',icon:'ti-building-warehouse',color:'#3B6D11',resp:'Bodega / Ventas',alertRole:'bodega',steps:[{name:'Recibido en bodega',role:'bodega',docs:[{icon:'📋',name:'Recibo-bodega.pdf',meta:'Firmado'}]},{name:'Disponible en SAP',role:'contabilidad',docs:[{icon:'📊',name:'SAP-disponible.pdf',meta:'Inventario'}]},{name:'En sala de venta',role:'bodega',docs:[{icon:'📸',name:'Foto-sala.jpg',meta:'Sala'}]}]},
];
function fmt(v){return'$'+Number(v).toLocaleString();}
function fmtS(v){
  var n=Math.abs(v);
  if(n>=1000000)return'$'+(v/1000000).toFixed(1)+'M';
  if(n>=100000)return'$'+(v/1000).toFixed(0)+'k';
  if(n>=10000)return'$'+(v/1000).toFixed(1)+'k';
  return'$'+Number(v).toLocaleString();
}
function fmtK(v){return v>=1000?'$'+(v/1000).toFixed(0)+'k':'$'+v.toLocaleString();}
function now2(){const d=new Date();return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'})+' · '+d.toLocaleTimeString('es-PA',{hour:'2-digit',minute:'2-digit'});}
function dateOnly(){return new Date().toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});}
function pct(a,b){return b>0?Math.round((a/b)*100):0;}
function parseDateStr(s){if(!s)return null;const mo={ene:0,feb:1,mar:2,abr:3,may:4,jun:5,jul:6,ago:7,sep:8,oct:9,nov:10,dic:11};const p=(s+'').replace(/·.*/,'').trim().split(' ');if(p.length<3)return null;return new Date(parseInt(p[2]),mo[p[1]?.toLowerCase()],parseInt(p[0]));}
function daysBetween(from,to){const f=parseDateStr(from),t=to?parseDateStr(to):new Date();if(!f)return 0;return Math.max(0,Math.round((t-f)/86400000));}
function diasBadge(days){if(days>14)return`<span class="dias-badge dias-late"><i class="ti ti-alert-triangle" style="font-size:10px"></i>${days}d</span>`;if(days>5)return`<span class="dias-badge dias-warn"><i class="ti ti-clock" style="font-size:10px"></i>${days}d</span>`;return`<span class="dias-badge dias-ok"><i class="ti ti-clock" style="font-size:10px"></i>${days}d</span>`;}
function sapChip(desc){const s=SAP_STOCK[desc];if(!s)return'';if(s.status==='high')return`<span class="sap-chip sap-ok"><i class="ti ti-package" style="font-size:10px"></i>SAP: ${s.stock}</span>`;if(s.status==='low')return`<span class="sap-chip sap-warn"><i class="ti ti-alert-triangle" style="font-size:10px"></i>SAP: ${s.stock} bajo</span>`;return`<span class="sap-chip sap-low"><i class="ti ti-circle-x" style="font-size:10px"></i>SAP: agotado</span>`;}
function pills2(active,fn,id,depts,showCount){var lista=depts||['todos',..._deptsVisibles()];
  // Si el usuario tiene un solo departamento, no tiene sentido ofrecerle
  // los demás: se le quitan de cualquier lista que le llegue.
  try{ if(_deptAcotado()) lista=lista.filter(function(x){ return x==='todos' || _deptPermitido(x); }); }catch(e){}return`<div class="filters" id="${id}">${lista.map(d=>{var cnt='';if(showCount){var n=vO().filter(o=>!o.completada&&!o.pend&&(d==='todos'||o.dept===d)).length;cnt=` <span style="background:rgba(0,0,0,.08);border-radius:8px;padding:0 5px;font-size:9px;font-weight:600">${n}</span>`;}return`<span class="pill ${d===active?'active':''}" onclick="${fn}(this,'${d}')">${dL(d)}${cnt}</span>`;}).join('')}</div>`;}
function canSeeStage(k){if(!CU)return false;
// Un usuario puede tener fijadas SUS etapas: Jamileth solo trabaja
// Logística y Aduanización & Costeo, y el resto le sobra en pantalla.
if(CU.etapas && CU.etapas.length) return CU.etapas.indexOf(k)>=0;
// Diseño no interviene en el pedido: su recorrido empieza en Artes
if(CU.role==='diseno')return k==='artes';if(CU.role==='bodega')return k==='bodega';// Contabilidad no trabaja artes ni producción: se le ocultan
if(CU.role==='contabilidad')return k!=='artes'&&k!=='produccion';return true;}
function stagesForUser(){return STAGES.filter(s=>canSeeStage(s.key));}
let CU=null,PG='dashboard',NID=130,activeDashStage=null,dashStageDept='todos',_deptoAutoAbrir=null;
let dO='todos',dC='todos',dA='todos',dAdept='todos',dAuser='todos',dP='todos',dMT='todos',dComp='todos',searchQuery='';
let contabFilter='all',dashKpiFilter=null,_dSQ='',_dSort='nuevo',_dEst='todos',_dMF=null,_dMD=null;
let firmas={},notifications=[],costeoData={},stageProgress={},recordatorios={};
// Los avisos internos ahora también se guardan en base: antes vivían solo en
// memoria y se perdían al recargar la página. Los dos sistemas quedan unidos.
function addNotif(to,msg,oid,icon='ti-bell',yaPersistido){
  notifications.push({to,msg,oid,icon,time:now2(),read:false,id:Date.now()});
  // El respaldo persistente. Se omite donde ya se manda un aviso propio,
  // para no avisar dos veces de lo mismo.
  if(!yaPersistido){ try{ _notifPersistir(to,msg,oid); }catch(e){} }
}

// Guarda el aviso en la tabla de menciones, para que sobreviva a la recarga
function _notifPersistir(to,msg,oid){
  if(!to || !msg) return;
  // Los destinatarios pueden ser un rol o un usuario concreto
  var destinos=(USERS||[]).filter(function(u){
    if(!u.id) return false;
    if(u.id===to) return true;
    if((u.role||'')===to) return true;
    return false;
  }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
  if(!destinos.length) return;

  // Sin await: es un respaldo, no debe frenar la acción del usuario
  _menNotificar(destinos, {
    docnum:oid||'', contexto:'aviso',
    texto:String(msg).replace(/^[^\w\d]+\s*/,'').slice(0,300),
    etiqueta:'Aviso del portal'
  }).catch(function(e){ console.warn('[aviso] no se pudo guardar:', e); });
}
function unreadN(){return notifications.filter(n=>!n.read&&(n.to===CU?.role||n.to===CU?.id)).length;}
function initP(oid){if(!stageProgress[oid]){stageProgress[oid]={};STAGES.forEach(s=>{stageProgress[oid][s.key]={stepIdx:0,comments:[],startDate:'',stepDates:Array(s.steps.length).fill('')};});}}
function getStageIdx(o){initP(o.id);const sp=stageProgress[o.id];for(let i=0;i<STAGES.length;i++){
  // Si la etapa tiene noBloquea (ej: depósito) y ya se hizo al menos 1 paso, sigue avanzando
  var noBloquea=STAGES[i].noBloquea&&sp[STAGES[i].key].stepIdx>=1;
  if(!noBloquea&&sp[STAGES[i].key].stepIdx<STAGES[i].steps.length)return i;
}return STAGES.length-1;}
function getStageName(o){if(o.pend)return'Sin firmar';if(o.completada)return'Completada';return STAGES[getStageIdx(o)]?.label||'';}
function getPct(o){if(o.completada)return 100;initP(o.id);const sp=stageProgress[o.id];let total=0,done=0;STAGES.forEach(s=>{total+=s.steps.length;done+=Math.min(sp[s.key].stepIdx,s.steps.length);});return Math.round((done/total)*100);}
function getSem(o){
  if(o.pend)return'sem-y';if(o.completada)return'sem-g';
  // Si depósito tiene pasos pero falta pago final → amarillo
  initP(o.id);var sp=stageProgress[o.id];
  var dep=sp&&sp.deposito;
  if(dep&&dep.stepIdx>=1&&dep.stepIdx<STAGES.find(function(s){return s.key==='deposito';}).steps.length)return'sem-y';
  return'sem-y';
}
function getStageColor(o){if(o.completada)return'#534AB7';if(o.pend)return'#eda100';return STAGES[getStageIdx(o)]?.color||'#2a78d6';}
function getStageStartEnd(o,k){initP(o.id);const sp=stageProgress[o.id][k];if(!sp)return{start:'',end:'',days:0,active:false,done:false};const start=sp.startDate||'';const steps=STAGES.find(s=>s.key===k)?.steps||[];const done=sp.stepIdx>=steps.length;const end=done?(sp.stepDates?.[sp.stepIdx-1]||''):'';return{start,end,days:start?daysBetween(start,end||null):0,active:!done&&!!start,done};}
let orders=[
  // Órdenes demo de prueba eliminadas — los datos reales vienen de Supabase (SAP)
];
function setupDemo(){
  initP('OC-2024-0115');const p1=stageProgress['OC-2024-0115'];p1.pedido={stepIdx:2,comments:[{autor:'Lorena (Compras)',ini:'LO',texto:'Pedido creado.',time:'02 jun 2024'}],startDate:'02 jun 2024',stepDates:['02 jun 2024','03 jun 2024']};p1.deposito={stepIdx:2,comments:[],startDate:'05 jun 2024',stepDates:['05 jun 2024','06 jun 2024']};p1.artes={stepIdx:0,comments:[],startDate:'07 jun 2024',stepDates:['','','','']};
  initP('OC-2024-0112');const p2=stageProgress['OC-2024-0112'];p2.pedido={stepIdx:2,comments:[],startDate:'08 jun 2024',stepDates:['08 jun 2024','09 jun 2024']};p2.deposito={stepIdx:2,comments:[],startDate:'10 jun 2024',stepDates:['10 jun 2024','11 jun 2024']};p2.artes={stepIdx:2,comments:[{autor:'Franco (Diseño)',ini:'FR',texto:'V2 lista.',time:'14 jun 2024'}],startDate:'12 jun 2024',stepDates:['12 jun 2024','14 jun 2024','','']};
  initP('OC-2024-0089');const p89=stageProgress['OC-2024-0089'];p89.pedido={stepIdx:2,comments:[],startDate:'18 may 2024',stepDates:['18 may 2024','19 may 2024']};p89.deposito={stepIdx:2,comments:[],startDate:'20 may 2024',stepDates:['20 may 2024','21 may 2024']};p89.artes={stepIdx:4,comments:[],startDate:'23 may 2024',stepDates:['23 may','24 may','25 may','26 may']};p89.produccion={stepIdx:2,comments:[],startDate:'01 jun 2024',stepDates:['01 jun 2024','10 jun 2024']};p89.logistica={stepIdx:6,comments:[],startDate:'12 jun 2024',stepDates:['12 jun','14 jun','16 jun','18 jun','19 jun','20 jun']};p89.costeo={stepIdx:1,comments:[{autor:'Jamileth',ini:'JA',texto:'Costeo subido.',time:'23 jun 2024'}],startDate:'22 jun 2024',stepDates:['22 jun 2024','23 jun 2024','','']};
  costeoData['OC-2024-0089']={status:'uploaded',uploadedBy:'Jamileth',uploadDate:'23 jun 2024',pricedBy:'',items:[{sku:'ALF-001',desc:'Alfombra persa 3x4 — Floral',costo:180,precioVenta:0,unidades:60},{sku:'ALF-002',desc:'Alfombra persa 3x4 — Geométrico',costo:195,precioVenta:0,unidades:50},{sku:'ALF-003',desc:'Alfombra persa 3x4 — Tradicional',costo:210,precioVenta:0,unidades:40}]};
  notifications.push({to:'gerencia',msg:'OC-2024-0089 — Costeo de Alfombras listo. Asignar precios.',oid:'OC-2024-0089',icon:'ti-table',time:'23 jun 2024 · 9:05am',read:false,id:1001});
  initP('OC-2024-0071');STAGES.forEach((s,i)=>{if(i<6)stageProgress['OC-2024-0071'][s.key]={stepIdx:s.steps.length,comments:[],startDate:`0${i+1} may 2024`,stepDates:s.steps.map((_,j)=>`${j+1} jun 2024`)};});stageProgress['OC-2024-0071'].bodega={stepIdx:0,comments:[],startDate:'22 jun 2024',stepDates:['','','']};
  initP('OC-2024-0107');stageProgress['OC-2024-0107'].pedido={stepIdx:2,comments:[],startDate:'10 jun 2024',stepDates:['10 jun','11 jun']};stageProgress['OC-2024-0107'].deposito={stepIdx:0,comments:[],startDate:'12 jun 2024',stepDates:['','']};
  initP('OC-2024-0040');stageProgress['OC-2024-0040'].pedido={stepIdx:2,comments:[],startDate:'01 abr 2024',stepDates:['01 abr','02 abr']};stageProgress['OC-2024-0040'].deposito={stepIdx:0,comments:[],startDate:'03 abr 2024',stepDates:['','']};
  initP('OC-2024-0109');const p09=stageProgress['OC-2024-0109'];p09.pedido={stepIdx:2,comments:[],startDate:'01 jun 2024',stepDates:['01 jun','02 jun']};p09.deposito={stepIdx:2,comments:[],startDate:'03 jun 2024',stepDates:['03 jun','04 jun']};p09.artes={stepIdx:4,comments:[],startDate:'06 jun 2024',stepDates:['06 jun','07 jun','08 jun','09 jun']};p09.produccion={stepIdx:1,comments:[],startDate:'10 jun 2024',stepDates:['10 jun 2024','']};
  initP('OC-2024-0055');STAGES.forEach(s=>{stageProgress['OC-2024-0055'][s.key]={stepIdx:s.steps.length,comments:[],startDate:'01 abr 2024',stepDates:s.steps.map((_,j)=>`0${j+1} may 2024`)};});
  initP('OC-2024-0048');STAGES.forEach(s=>{stageProgress['OC-2024-0048'][s.key]={stepIdx:s.steps.length,comments:[],startDate:'01 mar 2024',stepDates:s.steps.map((_,j)=>`0${j+1} abr 2024`)};});
}
// setupDemo();  // DESACTIVADO: los datos ahora vienen de Supabase
function vO(){if(!CU)return[];
  // Las NO SAP viven en su propio listado: se excluyen de las vistas de SAP
  var base=(orders||[]).filter(function(o){return !o._noSap;});
  return _deptAcotado()?base.filter(function(o){return _deptPermitido(o.dept);}):base;}
function pCnt(){return vO().filter(o=>o.pend).length;}
// ── Logo corporativo incrustado (PNG optimizado, sin dependencias externas) ──
var KCC_LOGO='data:image/png;base64,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';
var KCC_GLOBO='data:image/png;base64,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';

// Logo de la pantalla de entrada (K-Flow). El de Kennedy Center sigue
// usándose en la barra de arriba y en los catálogos en PDF.
var KFLOW_LOGO='data:image/jpeg;base64,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';

// ── Plantillas de shipping mark que se le mandan al proveedor ──────────

function renderLogin(){const grupos=[{l:'Gerencia / Sin restricciones',u:USERS.filter(u=>u.role==='gerencia'&&!u.dept)},{l:'Encargados por departamento',u:USERS.filter(u=>u.role==='gerencia'&&u.dept)},{l:'Compras — Hogar',u:USERS.filter(u=>_esComprasU(u)&&u.dept==='hogar')},{l:'Compras — Muebles',u:USERS.filter(u=>_esComprasU(u)&&u.dept==='muebles')},{l:'Compras — Electrónica',u:USERS.filter(u=>_esComprasU(u)&&u.dept==='electronica')},{l:'Compras — Ropa',u:USERS.filter(u=>_esComprasU(u)&&u.dept==='ropa')},{l:'Compras — Alfombras',u:USERS.filter(u=>_esComprasU(u)&&u.dept==='alfombras')},{l:'Diseño',u:USERS.filter(u=>u.role==='diseno')},{l:'Importación',u:USERS.filter(u=>u.role==='importacion')},{l:'Contabilidad',u:USERS.filter(u=>u.role==='contabilidad')},{l:'Bodega',u:USERS.filter(u=>u.role==='bodega')},].filter(g=>g.u.length);const colores={gerencia:'#EAF3DE',compras:'#e6f1fb',diseno:'#EEEDFE',importacion:'#E1F5EE',contabilidad:'#FBEAF0',bodega:'#FEF3E8'};const tcs={gerencia:'#27500A',compras:'#0c447c',diseno:'#3C3489',importacion:'#085041',contabilidad:'#72243E',bodega:'#7C3D12'};document.getElementById('root').innerHTML=`<div class="lw"><div class="lc"><div class="ll"><img src="${KFLOW_LOGO}" alt="K-Flow" class="kflow-logo-login" style="max-width:280px;margin-bottom:8px"><p style="font-weight:600;color:var(--text-accent);font-size:14px;margin-top:2px">Kennedy · SAP B1</p></div><div id="lerr" class="le">Usuario o contraseña incorrectos</div><div class="lf"><label class="llb">Email o usuario</label><input id="lu" class="li" placeholder="Ej: lorena@kennedyzl.com" onkeydown="if(event.key==='Enter')doLogin()"></div><div class="lf"><label class="llb">Contraseña</label><div style="position:relative"><input id="lp" class="li" type="password" value="" placeholder="Tu contraseña" style="padding-right:40px" onkeydown="if(event.key==='Enter')doLogin()"><button type="button" onclick="_togglePass()" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:var(--text-muted);padding:4px;display:flex;align-items:center" title="Mostrar/ocultar contraseña"><i class="ti ti-eye" id="lp-eye" style="font-size:18px"></i></button></div></div><label style="display:flex;align-items:center;gap:7px;margin:2px 0 12px;cursor:pointer;font-size:12px;color:var(--text-secondary);user-select:none"><input type="checkbox" id="lremember" style="width:15px;height:15px;cursor:pointer;accent-color:var(--text-accent)"><span>Recordar mi contraseña en esta computadora</span></label><div style="display:flex;gap:8px;align-items:stretch"><button class="lb" onclick="doLogin()" style="flex:1"><i class="ti ti-login" style="font-size:13px"></i> Iniciar sesión</button><button type="button" id="bio-login-btn" onclick="_bioLoginDesdeInput()" title="Entrar o activar Face / Touch ID" style="width:52px;flex-shrink:0;padding:10px;background:var(--surface-1);border:1px solid var(--border-accent);border-radius:10px;cursor:pointer;color:var(--text-accent);display:flex;align-items:center;justify-content:center"><i class="ti ti-fingerprint" style="font-size:22px"></i></button></div><div class="ul"><p>Pulsa tu nombre y escribe tu contraseña:</p>${grupos.map(g=>`<div class="ug"><div class="ug-title">${g.l}</div>${g.u.map(u=>`<span class="uc" onclick="qL('${u.email}')"><span style="background:${colores[u.role]||'#eee'};color:${tcs[u.role]||'#333'};padding:1px 6px;border-radius:8px;font-size:10px;font-weight:600">${u.ini}</span><span style="font-size:11px">${u.name}</span></span>`).join('')}</div>`).join('')}</div></div></div>`;
  // Rellenar credenciales recordadas
  try{
    var saved=JSON.parse(localStorage.getItem('kcc_login_recordado')||'null');
    if(saved&&saved.u){
      var lu=document.getElementById('lu'), lp=document.getElementById('lp'), lr=document.getElementById('lremember');
      if(lu)lu.value=saved.u;
      if(lp&&saved.p)lp.value=saved.p;
      if(lr)lr.checked=true;
    }
  }catch(e){}
  try{ _bioChequearBotonLogin(); }catch(e){}
}
// Al pulsar un nombre solo se rellena el usuario. La contrasena la tiene
// que escribir cada uno: antes se metia sola y se entraba sin teclear nada,
// con lo cual cualquiera podia entrar como cualquiera.
function qL(email){
  var lu=document.getElementById('lu'), lp=document.getElementById('lp');
  if(lu) lu.value=email;
  if(lp){ lp.value=''; lp.focus(); }
  var err=document.getElementById('lerr'); if(err) err.style.display='none';
}
let DATOS_CARGADOS=false;

// ═══════════ CAMBIO 7: LOGIN BIOMÉTRICO (Face ID / Touch ID) ═══════════
// Usa WebAuthn del dispositivo. Guarda una credencial ligada al usuario y su
// clave cifrada en localStorage; al validar la huella/cara, entra directo.
function _bioDisponible(){
  return !!(window.PublicKeyCredential && navigator.credentials && navigator.credentials.create);
}
// Face/Touch ID (WebAuthn) SOLO funciona en HTTPS o localhost. En file:// o http falla.
function _bioContextoSeguro(){
  try{ return window.isSecureContext===true || location.protocol==='https:' || location.hostname==='localhost' || location.hostname==='127.0.0.1'; }catch(e){ return false; }
}
function _bioKey(email){ return 'kcc_bio_'+email; }

// Registrar la biometría para el usuario que ya está logueado con clave
async function _bioRegistrar(email, pass){
  if(!_bioDisponible()){ showT('Este navegador no soporta Face/Touch ID'); return false; }
  if(!_bioContextoSeguro()){
    showT('Face/Touch ID necesita HTTPS. Abre la app desde su enlace web (https://), no como archivo local.', 6000);
    return false;
  }
  try{
    var uidBuf=new TextEncoder().encode(email);
    var challenge=new Uint8Array(32); crypto.getRandomValues(challenge);
    var cred=await navigator.credentials.create({ publicKey:{
      challenge:challenge,
      rp:{ name:'Kennedy Compras', id: location.hostname||undefined },
      user:{ id:uidBuf, name:email, displayName:email },
      pubKeyCredParams:[{type:'public-key',alg:-7},{type:'public-key',alg:-257}],
      authenticatorSelection:{ userVerification:'required', authenticatorAttachment:'platform', residentKey:'preferred' },
      timeout:60000, attestation:'none'
    }});
    if(!cred){ showT('No se completó el registro de Face/Touch ID'); return false; }
    var idB64=btoa(String.fromCharCode.apply(null,new Uint8Array(cred.rawId)));
    localStorage.setItem(_bioKey(email), JSON.stringify({ id:idB64, p:pass }));
    return true;
  }catch(e){
    console.warn('bio registrar:',e);
    var msg='No se pudo activar Face/Touch ID';
    if(e && e.name==='NotAllowedError') msg='Cancelaste o no se reconoció la huella/cara. Intenta de nuevo.';
    else if(e && e.name==='InvalidStateError') msg='Este dispositivo ya está registrado para este usuario.';
    else if(e && e.name==='NotSupportedError') msg='Este dispositivo no tiene Face/Touch ID configurado.';
    else if(e && e.name==='SecurityError') msg='Face/Touch ID necesita HTTPS. Abre la app desde su enlace web.';
    showT(msg, 5000);
    return false;
  }
}

// Botón de huella en el login: entra con biometría si ya está registrada,
// o la activa si el usuario ya escribió email + clave correctos.
async function _bioLoginDesdeInput(){
  if(!_bioDisponible()){ showT('Este dispositivo o navegador no soporta Face/Touch ID'); return; }
  var lu=document.getElementById('lu'), lp=document.getElementById('lp');
  var email=(lu&&lu.value.trim())||'';
  if(!email){
    try{ var s=JSON.parse(localStorage.getItem('kcc_login_recordado')||'null'); if(s&&s.u) email=s.u; }catch(e){}
  }
  var emailN=email.toLowerCase();
  // ¿Ya hay biometría registrada para este usuario? -> entrar directo
  if(email && localStorage.getItem(_bioKey(emailN))){
    _bioLogin(emailN);
    return;
  }
  // No registrada: para activarla necesita email + clave correctos
  var pass=(lp&&lp.value.trim())||'';
  if(!email || !pass){
    showT('Para activar Face/Touch ID: escribe tu email y clave, luego toca la huella');
    return;
  }
  // Validar credenciales antes de registrar
  var u=USERS.find(function(x){ return (x.email.toLowerCase()===emailN||x.id===emailN||x.name.toLowerCase()===emailN); });
  var ver=u?await _loginVerificar(u, pass):{ok:false};
  if(!ver.ok){ showT(ver.mensaje||'Email o clave incorrectos. Verifícalos para activar Face/Touch ID'); return; }
  // Registrar la biometría
  var ok=await _bioRegistrar(u.email.toLowerCase(), pass);
  if(ok){ showT('✓ Face/Touch ID activado. La próxima vez entra con tu huella'); }
}
// Al renderizar el login, mostrar el botón bio si hay credencial guardada
function _bioChequearBotonLogin(){
  try{
    var btn=document.getElementById('bio-login-btn');
    if(!btn)return;
    // Si el dispositivo no soporta biometría, ocultar el botón
    if(!_bioDisponible()){ btn.style.display='none'; return; }
    btn.style.display='flex';
  }catch(e){}
}

async function _bioLogin(email){
  if(!_bioDisponible()){ showT('Este navegador no soporta Face/Touch ID'); return; }
  if(!_bioContextoSeguro()){ showT('Face/Touch ID necesita HTTPS. Abre la app desde su enlace web.', 5000); return; }
  var raw=localStorage.getItem(_bioKey(email));
  if(!raw){ showT('Primero inicia sesión con tu clave y activa Face/Touch ID'); return; }
  try{
    var saved=JSON.parse(raw);
    var idBuf=Uint8Array.from(atob(saved.id), function(c){ return c.charCodeAt(0); });
    var challenge=new Uint8Array(32); crypto.getRandomValues(challenge);
    var assertion=await navigator.credentials.get({ publicKey:{
      challenge:challenge,
      allowCredentials:[{ type:'public-key', id:idBuf }],
      userVerification:'required',
      timeout:60000
    }});
    if(!assertion){ showT('No se validó la biometría'); return; }
    // Validó: entrar con el usuario y su clave guardada
    var lu=document.getElementById('lu'), lp=document.getElementById('lp');
    if(lu) lu.value=email;
    if(lp) lp.value=saved.p;
    doLogin();
  }catch(e){ console.warn('bio login:',e); showT('No se pudo validar Face/Touch ID'); }
}

// Botón para activar biometría desde la barra del usuario
function _bioActivarDesdeApp(){
  if(!CU){ return; }
  var raw=localStorage.getItem('kcc_login_recordado');
  var pass='';
  try{ var s=JSON.parse(raw||'null'); if(s&&s.u&&s.u.toLowerCase()===(CU.email||'').toLowerCase()) pass=s.p; }catch(e){}
  if(!pass){ pass=window._claveSesion||''; }
  if(!pass){ showT('Marca "Recordar contraseña" al iniciar sesión para activar la biometría'); return; }
  _bioRegistrar(CU.email, pass);
}


function _togglePass(){
  var inp=document.getElementById('lp'), eye=document.getElementById('lp-eye');
  if(!inp)return;
  if(inp.type==='password'){ inp.type='text'; if(eye)eye.className='ti ti-eye-off'; }
  else { inp.type='password'; if(eye)eye.className='ti ti-eye'; }
}

/* INICIO DE SESIÓN (v738)
   La clave se comprueba en Supabase con la función app_login (claves
   cifradas en app_claves, que el navegador no puede leer), en el proyecto
   del portal de compras: sutnfihpmfsejdlkghjp. Las claves no están en este
   archivo. (La v736/v737 usaba Supabase Auth; se dejó porque los SQL se
   habían corrido por error en otro proyecto, HAKOL.) Lo de _sbSesion queda
   sin uso: sirve si algún día se pasa a Supabase Auth. */
var _sbSesion={access:null, refresh:null, timer:null};
// El correo de siempre de cada usuario (v737): el mismo con el que entra
function _authEmailDe(u){ return String(u.email||'').trim().toLowerCase(); }

function _sbPonerSesion(d){
  _sbSesion.access=d.access_token; _sbSesion.refresh=d.refresh_token;
  SBH.Authorization='Bearer '+d.access_token;
  clearTimeout(_sbSesion.timer);
  var seg=Math.max(60, (Number(d.expires_in)||3600)-180);
  _sbSesion.timer=setTimeout(_sbRenovar, seg*1000);
}
function _sbCerrarSesion(){
  clearTimeout(_sbSesion.timer);
  _sbSesion={access:null, refresh:null, timer:null};
  SBH.Authorization='Bearer '+KEY;
}
async function _sbRenovar(intento){
  if(!_sbSesion.refresh) return;
  try{
    var r=await fetch(SB+'/auth/v1/token?grant_type=refresh_token',{method:'POST',
      headers:{'apikey':KEY,'Content-Type':'application/json'}, body:JSON.stringify({refresh_token:_sbSesion.refresh})});
    if(!r.ok) throw new Error(r.status);
    _sbPonerSesion(await r.json());
  }catch(e){
    // Sin red un momento: se reintenta; si no hay manera, se avisa
    if((intento||0)<5){ _sbSesion.timer=setTimeout(function(){ _sbRenovar((intento||0)+1); }, 30000); return; }
    try{ showT('Tu sesión caducó: sal y vuelve a entrar', 12000); }catch(x){}
  }
}

async function _loginVerificar(u, clave){
  if(!u || !clave) return {ok:false};
  try{
    var r=await fetch(SB+'/rest/v1/rpc/app_login',{method:'POST', headers:SBH,
      body:JSON.stringify({p_id:u.id, p_clave:clave})});
    if(!r.ok){
      var t=await r.text(), det='';
      try{ var j=JSON.parse(t); det=[j.code, j.message, j.hint].filter(Boolean).join(' · '); }catch(e){ det=t; }
      det=String(det||'').slice(0,220);
      console.error('[login] app_login '+r.status+': '+t);
      // Solo si la función de verdad no existe se dice que falta el SQL;
      // cualquier otro error se enseña tal cual, para saber qué pasa (v735)
      if(/Could not find the function|PGRST202/i.test(t))
        return {ok:false, mensaje:'Falta activar el nuevo inicio de sesión: la función app_login no está en Supabase '
          +'(corre v734_login.sql en el proyecto sutnfihpmfsejdlkghjp). Detalle: '+det};
      return {ok:false, mensaje:'No se pudo comprobar la clave ('+r.status+'): '+det};
    }
    var d=await r.json();
    if(d && d.bloqueado) return {ok:false, mensaje:'Demasiados intentos fallidos: espera 15 minutos y vuelve a probar.'};
    return {ok:!!(d && d.ok)};
  }catch(e){
    return {ok:false, mensaje:'Sin conexión: no se pudo comprobar la clave.'};
  }
}

async function doLogin(){const uid=document.getElementById('lu').value.trim().toLowerCase(),p=document.getElementById('lp').value.trim();const u=USERS.find(x=>(x.email.toLowerCase()===uid||x.id===uid||x.name.toLowerCase()===uid));const ver=u?await _loginVerificar(u,p):{ok:false};if(!ver.ok){const le=document.getElementById('lerr');if(le){le.style.display='block';if(ver.mensaje)le.textContent=ver.mensaje;}return;}window._claveSesion=p;
  // Recordar o borrar credenciales según el checkbox
  try{
    var lr=document.getElementById('lremember');
    if(lr&&lr.checked){
      localStorage.setItem('kcc_login_recordado', JSON.stringify({u:document.getElementById('lu').value.trim(), p:p}));
    } else {
      localStorage.removeItem('kcc_login_recordado');
    }
  }catch(e){}CU=u;try{ _accRegistrar('entrada','Inició sesión'); }catch(e){}dO=_deptPrimero()||'todos';dP=_deptPrimero()||'todos';dComp=_deptPrimero()||'todos';activeDashStage=null;dashStageDept='todos';dashKpiFilter=null;searchQuery='';
  if(!DATOS_CARGADOS){
    document.getElementById('root').innerHTML='<div class="lw"><div style="text-align:center"><div style="font-size:34px">📦</div><div style="margin-top:12px;font-size:14px;color:var(--text-secondary)">Cargando órdenes de SAP...</div></div></div>';
    const ok=await cargarDatosReales();
    DATOS_CARGADOS=ok;
    if(!ok){document.getElementById('root').innerHTML='<div class="lw"><div style="text-align:center;max-width:340px"><div style="font-size:34px">⚠️</div><div style="margin-top:12px;font-size:14px;color:var(--text-danger)">No se pudieron cargar los datos.</div><div style="margin-top:6px;font-size:12px;color:var(--text-muted)">Revisa que las tablas compras_* existan en Supabase.</div><button class="lb" style="margin-top:16px;max-width:200px" onclick="renderLogin()">Volver</button></div></div>';return;}
  }
  renderApp();
  // Antes se lanzaba un Sync 300 ms despues de entrar, y como cargarDatosReales
  // acababa de terminar, se descargaba TODO dos veces: 17 segundos y otros 15.
  // La fecha y hora se ponen sin volver a pedir nada.
  try{
    window._ultimoSync=new Date().toLocaleString('es',
      {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'});
    localStorage.setItem('kcc_ultimoSync', window._ultimoSync);
    var _st=document.getElementById('syncTime');
    if(_st) _st.textContent=window._ultimoSync;
  }catch(e){}
}
// ══════════════════════════════════════════════════════════════════════
//  REGISTRO DE ACCESOS Y ACTIVIDAD
//  Quién entra, cuándo y qué hace. Lo consulta la gerencia general en
//  Reportes → Registro de accesos.
//  No se guardan contraseñas ni el contenido de lo que la gente escribe.
// ══════════════════════════════════════════════════════════════════════
function _accRegistrar(tipo, detalle, referencia){
  try{
    if(!CU) return;
    var fila={
      usuario_id:CU.id||'', usuario:CU.name||'', rol:CU.role||'',
      dept:(CU.dept||(CU.depts||[]).join(',')||''),
      tipo:tipo||'accion', detalle:String(detalle||'').slice(0,200),
      referencia:String(referencia||'').slice(0,80),
      navegador:String((navigator&&navigator.userAgent)||'').slice(0,160),
      creado_en:new Date().toISOString()
    };
    // Sin await: si falla, no debe estorbar lo que la persona esté haciendo
    fetch(SB+'/rest/v1/accesos',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)
    }).then(function(r){
      if(!r.ok && !window._accAvisado){
        window._accAvisado=1;
        console.warn('[accesos] no se pudo registrar ('+r.status
          +'). ¿Falta la tabla "accesos"? Está en crear_tabla_accesos.sql');
      }
    }).catch(function(){});
  }catch(e){}
}

// Las pantallas se registran con retardo: si alguien pasa rápido por
// cuatro, no tiene sentido guardar las cuatro.
function _accPantalla(id){
  try{
    clearTimeout(window._accT);
    window._accT=setTimeout(function(){
      if(window._accUltPantalla===id) return;   // ya se anotó
      window._accUltPantalla=id;
      _accRegistrar('pantalla', id);
    }, 1200);
  }catch(e){}
}

function logout(){try{ _sbCerrarSesion(); }catch(e){}
  try{ _accRegistrar('salida','Cerró sesión'); }catch(e){}
  CU=null;PG='dashboard';renderLogin();
}

document.addEventListener('click',function(e){
  var rr=e.target.closest('.ra-row');
  if(rr){openDetail(rr.getAttribute('data-oid'));return;}
  var ab=e.target.closest('.nsap-abrir-btn');
  if(ab){e.stopPropagation();abrirPendSAP(ab.getAttribute('data-abrir'));return;}
  var ib=e.target.closest('.nsap-ia-btn');
  if(ib){e.stopPropagation();revisarPendSAPIA(ib.getAttribute('data-ia'));return;}
});
document.addEventListener('click',function(e){
  var r=e.target.closest('.kp-row');
  if(r){openDetail(r.getAttribute('data-oid'));return;}
  var okb=e.target.closest('.ord-kpi-btn');
  if(okb){_oKpiFilter=okb.getAttribute('data-okf');_oKpiDept=dO;rOrdenes();return;}
});
document.addEventListener('click',function(e){
  var btn=e.target.closest('.ctn-track-mini');
  if(btn){openTrackingCtn(btn.getAttribute('data-oid'),parseInt(btn.getAttribute('data-ci')));return;}
  var tb=e.target.closest('.ctn-track-btn');
  if(tb){openTrackingCtn(tb.getAttribute('data-oid'),parseInt(tb.getAttribute('data-ci')));return;}
  var db=e.target.closest('.ctn-del-btn');
  if(db){removeContainer(db.getAttribute('data-oid'),parseInt(db.getAttribute('data-ci')));return;}
  var ab=e.target.closest('.ctn-add-btn');
  if(ab){addContainer(ab.getAttribute('data-oid'));return;}
});
document.addEventListener('change',function(e){
  var bs=e.target.closest('.bk-sel');
  if(bs){setBKField(bs.getAttribute('data-bk-oid'),bs.getAttribute('data-bk-field'),bs.value);return;}
});
document.addEventListener('input',function(e){
  var bi=e.target.closest('.bk-inp');
  if(bi){setBKField(bi.getAttribute('data-bk-oid'),bi.getAttribute('data-bk-field'),bi.value);return;}
  var ci2=e.target.closest('.ctn-inp');
  if(ci2){setContainerField(ci2.getAttribute('data-ctn-oid'),parseInt(ci2.getAttribute('data-ctn-i')),ci2.getAttribute('data-ctn-field'),ci2.value);return;}
});
renderLogin();

// Event delegation para adjuntos (registrado a nivel global, se activa siempre)
document.addEventListener('click', function(e){
  var tgt=e.target;
  // Eliminar adjunto (closest capta el clic aunque caiga en un hijo del botón)
  var delBtn=tgt.closest?tgt.closest('.att-del'):null;
  if(delBtn){
    e.preventDefault(); e.stopPropagation();
    var ai=parseInt(delBtn.getAttribute('data-ai'));
    var oid=delBtn.getAttribute('data-oid');
    var sk=delBtn.getAttribute('data-sk');
    // En los pasos de ARTES se borra directo: diseño rehace y sube una y otra
    // vez, y confirmar cada archivo es un estorbo. En el resto se pregunta.
    var _esArtes=/^artes_/.test(String(sk||''));
    delAtt(oid, sk, ai, _esArtes);
    return;
  }
  // Si el clic cayó en la X de borrar (o muy cerca), NO se abre la foto
  if(tgt && tgt.closest && tgt.closest('.att-del')) return;
  // Zoom en imagen adjunta. Se abre con TODAS las del mismo paso, para poder
  // pasar de una a otra con las flechas sin cerrar y volver a abrir.
  var imgEl=tgt.closest?tgt.closest('.att-img'):null;
  if(imgEl){
    _visorAbrir(imgEl);
    return;
  }
});
document.addEventListener('change', function(e){
  var tgt=e.target;
  if(tgt.classList&&tgt.classList.contains('att-input')){
    var oid=tgt.getAttribute('data-oid');
    var sk=tgt.getAttribute('data-sk');
    handleAttach(oid,sk,tgt);
  }
});
// ═══════════════════════════════════════════════════════════════════════════
//  AYUDA POR PANTALLA
//  Cada opción del menú lleva un "?" que explica para qué sirve, quién la usa
//  y qué se hace ahí. El texto se adapta al rol de quien está mirando.
// ═══════════════════════════════════════════════════════════════════════════
var AYUDA={
  bancos:{
    t:'Saldos y prestamos bancarios',
    para:'Contabilidad y gerencia',
    q:'El correo diario de saldos a gerencia, con los dos Excel adjuntos y una copia guardada.',
    pasos:[
      'Carga el Excel de saldos y el de prestamos. Tienen que estar en .xlsx, no en .xls.',
      'Se abren en pantalla con su formato: colores, totales y todo.',
      'Corrige lo que haga falta escribiendo en las celdas blancas. Las grises llevan formula y se recalculan solas.',
      'Con el + de la izquierda de cada fila insertas una linea nueva; los totales se ajustan igual que en Excel.',
      'Pulsa "Guardar y enviar a gerencia", marca a quien va y envia: salen los dos adjuntos en un solo correo desde tu buzon.'
    ],
    tip:'En "Envios anteriores" esta la copia de cada dia, con los dos archivos tal como se mandaron.'
  },
  pcs:{
    t:'Product Creation Sheet',
    para:'Compras de Ropa y gerencia',
    q:'Convierte la proforma del proveedor en la hoja de creacion de productos, sin transcribir a mano.',
    pasos:[
      'Pulsa "Subir documento del proveedor" y elige la proforma en PDF, Excel o foto.',
      'Espera: un contrato de 60 estilos tarda cerca de un minuto.',
      'Mira el recuadro de arriba. En verde, la suma cuadra con el total impreso del documento y no falta ninguna linea. En rojo, algo se leyo mal.',
      'Corrige lo que haga falta escribiendo en la misma tabla y pulsa "Guardar cambios".',
      'Pulsa "Descargar Excel" para bajar la hoja con el formato de la plantilla.'
    ],
    tip:'De "Piezas despachadas" en adelante el Excel sale vacio a proposito: esas columnas se llenan al despachar.'
  },
  dashboard:{
    t:'Inicio',
    para:'Todos',
    q:'El resumen del día: cuántas órdenes hay activas, cuánto se ha abonado y qué está por llegar.',
    pasos:[
      'Pulsa cualquier recuadro de arriba (Activas, Abonado, Saldo, Por llegar) para ver el listado de esas órdenes.',
      'Desde ese listado puedes entrar a cualquier orden para trabajarla.',
      'Los avisos en rojo son cosas que necesitan tu atención.'
    ],
    tip:'Los recuadros son filtros: pulsa uno y abajo aparece solo lo que corresponde.'
  },
  ordenes:{
    t:'Buscar órdenes',
    para:'Todos',
    q:'El buscador de todas las órdenes de compra, las de SAP y las BORRADOR.',
    pasos:[
      'Escribe el proveedor, el código, la referencia o parte de la descripción.',
      'Con el desplegable de la derecha eliges si ves las de SAP, las BORRADOR o todas.',
      'Pulsa cualquier orden para abrirla y trabajar sus etapas.'
    ],
    tip:'Las órdenes BORRADOR se reconocen por su etiqueta naranja y se abren igual que las demás.'
  },
  completadas:{
    t:'Completadas',
    para:'Todos',
    q:'El historial de las órdenes que ya terminaron todo su recorrido, desde el pedido hasta la venta.',
    pasos:[
      'Sirve para consultar cómo se trabajó una compra anterior.',
      'Puedes abrirlas para ver sus etapas, documentos y comentarios.'
    ]
  },
  pendientes:{
    t:'Por aprobar',
    para:'Gerencia',
    q:'Las órdenes que esperan tu aprobación para poder seguir avanzando.',
    pasos:[
      'Revisa la orden y sus documentos.',
      'Apruébala para que compras pueda continuar con el proceso.'
    ],
    tip:'El punto rojo indica que hay órdenes esperando.'
  },
  deptos:{
    t:'Departamentos',
    para:'Gerencia y contabilidad',
    q:'El resumen de todas las compras agrupadas por departamento y proveedor.',
    pasos:[
      'Cada fila es un proveedor, con sus órdenes al lado.',
      'De cada orden ves el número, el DKC, el total, lo abonado y el saldo.',
      'Pulsa una orden para abrirla.'
    ]
  },
  mistarea:{
    t:'Mis artes / Embarques / Bodega',
    para:'Diseño, importación y bodega',
    q:'Tu bandeja de trabajo: solo las órdenes que están esperando algo de tu parte.',
    pasos:[
      'Entra a cada orden y completa lo que te toca en tu etapa.',
      'Marca los pasos como hechos para que la orden avance.'
    ]
  },
  alertas:{
    t:'Alertas',
    para:'Todos',
    q:'Lo que está atrasado o necesita atención: órdenes detenidas, artes pendientes, mercancía sin llegar.',
    pasos:[
      'Revisa cada aviso y entra a la orden para resolverlo.',
      'Puedes filtrar por responsable con los botones de arriba.'
    ]
  },
  alertas_contab:{
    t:'Solicitudes de abonos o cancelaciones',
    para:'Contabilidad',
    q:'Las solicitudes de pago que manda compras: abonos para arrancar una orden y cancelaciones del saldo final.',
    pasos:[
      'Revisa cada solicitud con su monto, proveedor y orden.',
      'Están agrupadas por departamento solicitante.',
      'Pulsa el icono de comentarios para hablar con quien la pidió.',
      'Cuando la trabajes, márcala como hecha para que salga del listado.'
    ],
    tip:'Con el botón Reporte sacas la lista para imprimir, con los totales al final.'
  },
  reposiciones:{
    t:'Reposiciones',
    para:'Compras',
    q:'Para volver a pedirle mercancía a un proveedor que ya trabajas.',
    pasos:[
      'Busca el proveedor por código o por nombre.',
      'Se abre su listado de artículos con stock, disponible y última compra.',
      'Escribe las cantidades que quieres pedir, en piezas o en bultos.',
      'Genera el PDF y el Excel, y envíalos al proveedor por correo.'
    ],
    tip:'Con los filtros de stock ves solo lo que se está acabando: sin disponible, o por debajo del 50% de la última llegada.'
  },
  reppedidos:{
    t:'Pedidos guardados',
    para:'Compras',
    q:'Las reposiciones que dejaste a medias para seguirlas después.',
    pasos:['Ábrelas para continuar donde las dejaste.']
  },
  nueva:{
    t:'Nueva compra para firma',
    para:'Compras',
    q:'Para mandarle a gerencia una compra nueva y que la firme.',
    pasos:[
      'Adjunta los dos documentos: la PI del proveedor y nuestra orden de compra.',
      'Pulsa AI para que lea los datos y compare los dos documentos.',
      'Revisa las incidencias que reporte y corrige lo que haga falta.',
      'Completa los campos y envíala a gerencia.'
    ],
    tip:'Mientras gerencia no la firme, la puedes editar o borrar.'
  },
  nueva_ger:{
    t:'Compras para firmar',
    para:'Gerencia',
    q:'Las compras que compras te mandó para que las firmes.',
    pasos:[
      'Revisa el archivo y la revisión de la AI, que te avisa si los dos documentos no coinciden.',
      'Dibuja tu firma y fírmala.',
      'Se firman los dos documentos por separado y le llegan al comprador.'
    ]
  },
  livechat:{
    t:'Live Chat',
    para:'Todos',
    q:'Chat interno del equipo para consultas rápidas sobre las órdenes.',
    pasos:['Escribe tu mensaje y el equipo lo ve al instante.']
  },
  reportes:{
    t:'Reportes',
    para:'Todos menos diseño',
    q:'Vistas de conjunto para seguir el trabajo sin entrar orden por orden.',
    pasos:[
      'Estado de las entradas: dónde está cada embarque, de puerto a inventario.',
      'Los botones de arriba filtran por etapa y por departamento.',
      'Se ordenan por tiempo detenido: arriba lo que lleva más días sin moverse.',
      'Pulsa una fila para abrir esa orden en su etapa de logística.'
    ],
    tip:'Si una entrada lleva más de 15 días en la misma etapa, el número sale en rojo.'
  },
  inventario:{
    t:'Consulta inventario',
    para:'Todos menos contabilidad',
    q:'Para consultar cualquier artículo: existencia, reservado, disponible, por llegar y precio.',
    pasos:[
      'Busca por SKU, descripción, código de barras o proveedor.',
      'Filtra por departamento con los botones de arriba.',
      'Pasa el mouse por la foto para verla grande.',
      'Pulsa cualquier fila para abrir la ficha técnica completa.'
    ],
    tip:'En la ficha, el número de reservado es clickeable: te dice qué cliente tiene esa mercancía separada.'
  },
  catnosap:{
    t:'Proveedores y SKU BORRADOR',
    para:'Compras y gerencia',
    q:'Los proveedores y artículos nuevos que todavía no existen en SAP, creados desde una orden BORRADOR.',
    pasos:[
      'Están agrupados por proveedor; pulsa uno para ver sus artículos.',
      'Cuando el proveedor o el SKU se crean en SAP, su ficha desaparece sola de aquí.',
      'Con Revisar contra SAP fuerzas esa comprobación en el momento.'
    ],
    tip:'El número rojo del menú te dice cuántas fichas faltan por crearse en SAP.'
  },
  ordennosap:{
    t:'Agregar nueva orden BORRADOR',
    para:'Compras y gerencia',
    q:'Para registrar una compra que todavía no está cargada en SAP y poder trabajarla igual.',
    pasos:[
      'Adjunta la PI del proveedor y nuestra orden de compra.',
      'Pulsa Revisar y comparar con IA: llena los datos y te avisa de diferencias entre los dos documentos.',
      'Verifica el proveedor y los artículos, y crea la orden.',
      'La orden nace con la etapa Pedido ya aprobada y queda pendiente de abono.'
    ],
    tip:'Puedes guardarla como borrador y seguir más tarde.'
  },
  reporteabonos:{
    t:'Reporte abonos y cancelaciones',
    para:'Contabilidad y gerencia',
    q:'Saca la lista imprimible de todas las solicitudes de pago pendientes.',
    pasos:[
      'Trae proveedor, orden con su DKC, monto, departamento, concepto y fecha de llegada.',
      'Al final los totales de abonos, de cancelaciones y el gran total.'
    ]
  }
};

// Botón "?" que abre la ayuda
function _ayudaBtn(clave, color){
  return '<span class="ayuda-i" onclick="event.stopPropagation();_ayudaVer(\'' + clave + '\')" '
    +'title="¿Cómo funciona esta pantalla?"'+(color?(' style="color:'+color+'"'):'')+'>?</span>';
}

// La clave cambia según el rol en un par de pantallas
function _ayudaClave(id){
  if(id==='alertas' && CU && CU.role==='contabilidad') return 'alertas_contab';
  if(id==='nueva'   && CU && CU.role==='gerencia')     return 'nueva_ger';
  return id;
}

function _ayudaVer(clave){
  var a=AYUDA[clave];
  if(!a){ showT('Sin ayuda para esta pantalla'); return; }
  var prev=document.getElementById('ayudaOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='ayudaOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2200;display:flex;align-items:center;justify-content:center;padding:18px';
  var h='<div style="background:var(--surface-0);border-radius:13px;max-width:480px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
    +'<div><div style="font-size:15px;font-weight:700"><i class="ti ti-help-circle" style="color:var(--fill-accent)"></i> '+_esc(a.t)+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px"><i class="ti ti-users" style="font-size:11px"></i> Para: '+_esc(a.para)+'</div></div>'
    +'<button onclick="document.getElementById(\'ayudaOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';
  h+='<div style="padding:15px 18px">';
  h+='<div style="font-size:13px;line-height:1.55;margin-bottom:13px">'+_esc(a.q)+'</div>';
  if(a.pasos&&a.pasos.length){
    h+='<div style="font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-muted);font-weight:700;margin-bottom:6px">Cómo se usa</div>';
    h+='<ol style="margin:0 0 13px 0;padding-left:20px;font-size:12.5px;line-height:1.7">'
      +a.pasos.map(function(p){ return '<li>'+_esc(p)+'</li>'; }).join('')+'</ol>';
  }
  if(a.tip){
    h+='<div style="background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px;padding:10px 12px">'
      +'<div style="font-size:10px;text-transform:uppercase;color:var(--t-oro);font-weight:700;margin-bottom:3px">Consejo</div>'
      +'<div style="font-size:12.5px;color:#5A4A1F;line-height:1.5">'+_esc(a.tip)+'</div></div>';
  }
  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// Índice con todas las pantallas, para quien quiera verlo de corrido
function _ayudaIndice(){
  var prev=document.getElementById('ayudaOv'); if(prev) prev.remove();
  var vistos={}, lista=[];
  (CU&&CU.nav?CU.nav:[]).forEach(function(id){
    var k=_ayudaClave(id);
    if(AYUDA[k] && !vistos[k]){ vistos[k]=1; lista.push(k); }
  });
  ['inventario','ordennosap','catnosap','reporteabonos'].forEach(function(k){
    if(AYUDA[k] && !vistos[k]){ vistos[k]=1; lista.push(k); }
  });
  var ov=document.createElement('div');
  ov.id='ayudaOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2200;display:flex;align-items:center;justify-content:center;padding:18px';
  var h='<div style="background:var(--surface-0);border-radius:13px;max-width:520px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
    +'<div style="font-size:15px;font-weight:700"><i class="ti ti-help-circle" style="color:var(--fill-accent)"></i> Guía del portal</div>'
    +'<button onclick="document.getElementById(\'ayudaOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
  h+='<div style="padding:10px 0">';
  lista.forEach(function(k){
    var a=AYUDA[k];
    h+='<div onclick="_ayudaVer(\''+k+'\')" style="padding:10px 18px;border-bottom:0.5px solid var(--border);cursor:pointer;display:flex;gap:10px;align-items:flex-start">'
      +'<i class="ti ti-chevron-right" style="color:var(--text-muted);margin-top:2px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:12.5px;font-weight:600">'+_esc(a.t)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:1px">'+_esc(a.q)+'</div></div></div>';
  });
  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// ═══════════════════════════════════════════════════════════════════════════
//  BORRADO PARA GERENCIA
//  Gerencia puede eliminar del sistema órdenes NO SAP, proveedores y SKU no
//  registrados, reposiciones y los archivos que cuelgan de ellos. Todo pasa
//  por una confirmación que dice exactamente qué se va a borrar y qué se
//  lleva por delante. Nada se borra de SAP: solo de este portal.
// ═══════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════
//  NOMBRE PARA FIRMAR LOS CORREOS
//  Todos los correos van firmados con nombre y apellido. Si el usuario está
//  cargado solo con el nombre, puede completarlo desde su perfil y queda
//  guardado para los envíos siguientes.
// ═══════════════════════════════════════════════════════════════════════════
function _firmaNombreKey(){ return 'firma_nombre_'+((CU&&CU.id)||'x'); }

function _firmaNombre(){
  if(!CU) return '';
  // 1) Lo que el propio usuario haya completado
  try{
    var v=localStorage.getItem(_firmaNombreKey());
    if(v && v.trim()) return v.trim();
  }catch(e){}
  if(CU.firma && String(CU.firma).trim()) return String(CU.firma).trim();
  return String(CU.name||'').trim();
}

// ¿Tiene apellido? (al menos dos palabras)
function _firmaTieneApellido(){
  return String(_firmaNombre()).trim().split(/\s+/).filter(Boolean).length>=2;
}

// Pide el nombre completo y lo guarda
function _firmaPedirNombre(cb){
  var actual=_firmaNombre();
  var txt=prompt('¿Con qué nombre quieres firmar los correos?\n\n'
    +'Poné nombre y apellido, por ejemplo: Sherene Muor\n'
    +'Queda guardado para los próximos envíos.', actual);
  if(txt===null) return false;
  txt=String(txt).trim();
  if(!txt){ showT('El nombre no puede quedar vacío'); return false; }
  try{ localStorage.setItem(_firmaNombreKey(), txt); }catch(e){}
  if(CU) CU.firma=txt;
  showT('Los correos se firmarán como "'+txt+'"');
  if(typeof cb==='function') cb();
  return true;
}

// Aviso para completar el apellido, si falta
function _firmaAvisoNombre(){
  if(_firmaTieneApellido()) return '';
  return '<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 10px;margin-bottom:10px;font-size:11px;color:var(--t-marron)">'
    +'<i class="ti ti-alert-circle"></i> Vas a firmar como <b>'+_esc(_firmaNombre())+'</b>, sin apellido. '
    +'<span onclick="_firmaPedirNombre(function(){ showT(\'Volvé a abrir el correo para verlo actualizado\'); })" '
    +'style="text-decoration:underline;cursor:pointer;font-weight:600">Completar mi nombre</span></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  MENCIONES CON @ EN LOS COMENTARIOS
//  Al escribir @ aparece la lista de usuarios para elegir. El mencionado
//  recibe un aviso en Alertas que lo lleva directo al comentario.
// ═══════════════════════════════════════════════════════════════════════════

// Usuarios que se pueden mencionar, filtrados por lo que se lleva escrito
function _menCandidatos(q){
  q=String(q||'').toLowerCase().trim();
  var yo=(CU&&CU.id)||'';
  return (USERS||[]).filter(function(u){
    if(u.id===yo) return false;
    if(!q) return true;
    return String(u.name||'').toLowerCase().indexOf(q)>=0
        || String(u.role||'').toLowerCase().indexOf(q)>=0
        || String(u.dept||'').toLowerCase().indexOf(q)>=0;
  }).slice(0,8);
}

// El texto que se inserta: @Nombre (sin espacios, para poder detectarlo luego)
function _menToken(u){ return '@'+String(u.name||'').replace(/\s+/g,'_'); }

// Detecta la mención que se está escribiendo justo antes del cursor
function _menEnCurso(input){
  if(!input) return null;
  var pos=input.selectionStart||0;
  var antes=String(input.value||'').slice(0,pos);
  var m=antes.match(/(^|\s)@([\wÁÉÍÓÚÑáéíóúñ_]*)$/);
  if(!m) return null;
  return {q:m[2]||'', inicio:pos-(m[2]||'').length-1, fin:pos};
}

// Muestra u oculta el desplegable de menciones
function _menRefrescar(inputId, listaId){
  var inp=document.getElementById(inputId);
  var box=document.getElementById(listaId);
  if(!inp||!box) return;
  var men=_menEnCurso(inp);
  if(!men){ box.style.display='none'; box.innerHTML=''; return; }
  var cands=_menCandidatos(men.q);
  if(!cands.length){ box.style.display='none'; box.innerHTML=''; return; }
  window._menCtx={inputId:inputId, listaId:listaId, inicio:men.inicio, fin:men.fin};
  box.innerHTML=cands.map(function(u,i){
    return '<div onmousedown="event.preventDefault();_menElegir(\''+u.id+'\')" '
      +'style="display:flex;align-items:center;gap:7px;padding:6px 9px;cursor:pointer;border-bottom:0.5px solid var(--border);font-size:11.5px"'
      +' onmouseover="this.style.background=\'var(--surface-1)\'" onmouseout="this.style.background=\'transparent\'">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')
      +';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;flex-shrink:0">'
      +_esc(String(u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span style="font-weight:600">'+_esc(u.name)+'</span>'
      +'<span style="color:var(--text-muted);font-size:10px">'+_esc(u.role||'')+(u.dept?(' · '+dL(u.dept)):'')+'</span>'
      +'</div>';
  }).join('');
  box.style.display='block';
}

// Inserta la mención elegida
function _menElegir(uid){
  var ctx=window._menCtx; if(!ctx) return;
  var u=(USERS||[]).find(function(x){ return x.id===uid; });
  var inp=document.getElementById(ctx.inputId);
  if(!u||!inp) return;
  var v=String(inp.value||'');
  inp.value=v.slice(0,ctx.inicio)+_menToken(u)+' '+v.slice(ctx.fin);
  var box=document.getElementById(ctx.listaId);
  if(box){ box.style.display='none'; box.innerHTML=''; }
  window._menCtx=null;
  inp.focus();
  var p=ctx.inicio+_menToken(u).length+1;
  try{ inp.setSelectionRange(p,p); }catch(e){}
}

function _menCerrar(listaId){
  var box=document.getElementById(listaId);
  if(box){ box.style.display='none'; box.innerHTML=''; }
}

// Usuarios mencionados en un texto
function _menExtraer(texto){
  var out=[], vistos={};
  String(texto||'').replace(/@([\wÁÉÍÓÚÑáéíóúñ_]+)/g, function(_, nom){
    var busca=nom.replace(/_/g,' ').toLowerCase();
    var u=(USERS||[]).find(function(x){ return String(x.name||'').toLowerCase()===busca; });
    if(u && !vistos[u.id]){ vistos[u.id]=1; out.push(u); }
    return _;
  });
  return out;
}

// Resalta las menciones al mostrar el comentario
function _menResaltar(textoEsc){
  return String(textoEsc||'').replace(/@([\wÁÉÍÓÚÑáéíóúñ_]+)/g, function(tok, nom){
    var busca=nom.replace(/_/g,' ').toLowerCase();
    var u=(USERS||[]).find(function(x){ return String(x.name||'').toLowerCase()===busca; });
    if(!u) return tok;
    var mio=(CU && u.id===CU.id);
    return '<span style="background:'+(mio?'#FEF08A':'var(--bg-accent)')+';color:'+(mio?'#713F12':'var(--text-accent)')
      +';border-radius:5px;padding:0 5px;font-weight:700">@'+_esc(u.name)+'</span>';
  });
}

// ── Avisos de mención ──
// Se guardan en la propia solicitud/etapa para que sobrevivan a la recarga
// ═══════════════════════════════════════════════════════════════════════════
//  AVISOS DEL CIRCUITO DE PAGOS
//  Estos avisos usaban addNotif, que vive solo en memoria: al recargar la
//  página se perdían. Ahora van al sistema persistente, el mismo del globo
//  rojo, así que quedan guardados hasta que la persona los lee.
// ═══════════════════════════════════════════════════════════════════════════
function _avUsuariosPorRol(rol, dept){
  return (USERS||[]).filter(function(u){
    if(u.role!==rol || !u.id) return false;
    if(dept && rol==='compras' && String(u.dept||'')!==String(dept)) return false;
    return u.id!==((CU&&CU.id)||'');
  });
}

function _avSolicitante(x){
  var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
  return u ? [u] : [];
}

// Aviso persistente sobre una solicitud de pago
async function _avSolicitud(destinos, x, texto, etiqueta){
  if(!destinos || !destinos.length) return;
  try{
    await _menNotificar(destinos, {
      docnum:x.docnum, contexto:'solicitud', solId:x.id,
      texto:texto, etiqueta:etiqueta||'Solicitud de pago'
    });
  }catch(e){ console.warn('[aviso pagos]', e); }
}

async function _menNotificar(usuarios, datos){
  if(!usuarios||!usuarios.length) return;
  var ok=0, err='';
  for(var i=0;i<usuarios.length;i++){
    var u=usuarios[i];
    try{
      var _r=await fetch(SB+'/rest/v1/menciones',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({
          para_id:u.id, para_nombre:u.name,
          de_nombre:(CU&&CU.name)||'',
          docnum:String(datos.docnum||''),
          contexto:datos.contexto||'',      // 'solicitud' | 'etapa'
          etapa:datos.etapa||'',
          paso:datos.paso||'',
          sol_id:datos.solId||null,
          texto:String(datos.texto||'').slice(0,400),
          leido:false,
          creado_en:new Date().toISOString()
        })});
      if(_r.ok) ok++;
      else {
        var _t=await _r.text();
        console.error('[mencion] no se guardó:', _r.status, _t);
        // Un fallo aquí es silencioso para el usuario y la mención se pierde:
        // hay que decirlo claro.
        err=/does not exist|Could not find the table|relation .* does not exist/i.test(_t)
          ? 'Falta la tabla menciones en Supabase (script menciones.sql).'
          : ('Error '+_r.status+' al guardar la mención.');
      }
    }catch(e){ console.warn('mencion:',e); err='No hay conexión para avisar la mención.'; }
    // OJO: no se agrega addNotif aquí. El panel "Notificación de lectura de
    // comentario" ya muestra la mención, y hacer las dos cosas la mostraba
    // dos veces al usuario mencionado.
  }
  if(err) showT('⚠ El comentario se guardó, pero no llegó el aviso. '+err);
  else if(ok) showT('✓ Se avisó a '+ok+' persona(s) mencionada(s)');
  // El mencionado ve el aviso en cuanto recargue sus menciones
  try{ if(usuarios.some(function(u){ return CU && u.id===CU.id; })) _menCargar(true).then(_menBadge); }catch(e){}
}

// Diagnóstico: dice si la tabla de menciones está lista
async function _menDiag(){
  showT('Probando la tabla menciones…');
  try{
    var r=await fetch(SB+'/rest/v1/menciones?select=id&limit=1',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      alert('La tabla "menciones" no está disponible.\n\n'
        +(/does not exist|Could not find/i.test(t)
          ? 'Todavía no se creó. Hay que correr el script menciones.sql en Supabase.'
          : ('Error '+r.status+': '+t.slice(0,200)))
        +'\n\nSin esa tabla, los @ se escriben pero el aviso no le llega a nadie.');
      return;
    }
    var p=await fetch(SB+'/rest/v1/menciones',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({para_id:'__test__', para_nombre:'prueba', de_nombre:'diagnostico',
                           docnum:'TEST', contexto:'etapa', texto:'prueba de conexion',
                           leido:false, creado_en:new Date().toISOString()})});
    if(!p.ok){
      var t2=await p.text();
      alert('La tabla existe pero no acepta escritura.\n\n'+t2.slice(0,240)
        +'\n\nRevisa los permisos (RLS) en el script menciones.sql.');
      return;
    }
    var cr=null; try{ cr=await p.json(); }catch(e){}
    if(cr&&cr[0]&&cr[0].id){ try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+cr[0].id,{method:'DELETE',headers:SBH}); }catch(e){} }
    alert('Todo bien: la tabla "menciones" acepta lectura y escritura.\n\nLos @ deberían avisar sin problema.');
  }catch(e){ alert('Error de conexión: '+(e.message||e)); }
}

// Carga las menciones sin leer del usuario
async function _menCargar(silencioso){
  if(!CU) return [];
  try{
    var r=await fetch(SB+'/rest/v1/menciones?select=*&para_id=eq.'+encodeURIComponent(CU.id)
      +'&leido=is.false&order=creado_en.desc&limit=100',{headers:SBH});
    if(!r.ok){ if(!silencioso) console.warn('menciones:', r.status); window._menciones=[]; return []; }
    var rows=await r.json();
    window._menciones=Array.isArray(rows)?rows:[];
  }catch(e){ console.warn('cargar menciones:',e); window._menciones=[]; }
  return window._menciones;
}

// Panel de "Notificación de lectura de comentario" en Alertas
/* Un aviso del SISTEMA (solicitudes atrasadas, por ejemplo) no es que
   alguien te haya mencionado: va con las alertas de órdenes, en Depósitos y
   pagos, no en «Comentarios donde te mencionan». */
function _menEsDelSistema(m){
  if(!m) return false;
  var t=String(m.texto||'');
  if(/^(MUY )?ATRASADA?S?:/i.test(t)) return true;
  if(!String(m.de_nombre||'').trim()) return true;
  return /solicitud\(es\) de pago|sin procesar|sin recibir/i.test(t);
}

function _menPanel(){
  // Solo menciones de PERSONAS. Los avisos del sistema (solicitudes
  // atrasadas) van con las alertas de órdenes, en Depósitos y pagos.
  var ms=(window._menciones||[]).filter(function(m){ return !_menEsDelSistema(m); });
  if(!ms.length) return '';
  var h='<div style="border:1px solid #E0A82E;background:#FEF9E7;border-radius:10px;margin-bottom:12px;overflow:hidden">'
    +'<div style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<i class="ti ti-at" style="color:var(--t-oro)"></i>'
      +'<span style="font-size:12.5px;font-weight:700;color:var(--t-oro)">Notificación de lectura de comentario</span>'
      +'<span style="font-size:11px;color:var(--t-oro);opacity:.85">'+ms.length+' sin leer</span>'
      +'<button class="btn bg2" style="margin-left:auto;padding:3px 10px;font-size:10.5px" onclick="_menMarcarTodas()">Marcar todas como leídas</button>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10.5px" onclick="_menDiag()" title="Probar que los @ funcionan"><i class="ti ti-stethoscope"></i></button>'
    +'</div>';
  ms.forEach(function(m){
    var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(m.de_nombre||''); });
    var ini=String(m.de_nombre||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join('');
    var donde=(m.paso||m.etapa||'');
    h+='<div class="men-fila" onclick="_menAbrir('+m.id+')" style="border-top:0.5px solid #E0A82E;padding:10px 13px;background:var(--surface-0);cursor:pointer;display:flex;gap:10px;align-items:flex-start">'
      +'<span style="width:28px;height:28px;border-radius:50%;flex-shrink:0;background:'+((quien&&quien.color)||'#E0A82E')
      +';color:'+((quien&&quien.tc)||'#fff')+';display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700">'
      +_esc(ini)+'</span>'
      +'<div style="flex:1;min-width:0">'
        // Los avisos del sistema (escalamiento por demora) no son menciones de
        // nadie: decir "Fulano te mencionó" confundía, porque esa persona no
        // había escrito nada, solo tenía el portal abierto.
        +'<div style="font-size:12px;font-weight:700;color:var(--t-oro)">'
        // "etiqueta" se pasa a _menNotificar pero NO se guarda en la tabla, así
        // que no sirve para distinguir. Se mira el texto, que sí está.
        +(/^(MUY )?ATRASADA?S?:/i.test(String(m.texto||''))
            ? 'Aviso del sistema'
            : (_esc(m.de_nombre||'')+' te mencionó'))+'</div>'
        +'<div style="font-size:11px;color:var(--t-oro);opacity:.9;margin-top:1px">'
          +(m.docnum?('<i class="ti ti-file-invoice" style="font-size:11px"></i> Orden '+_esc(m.docnum)
            +(_dkcDeOrden(m.docnum)?(' · <b>'+_esc(_dkcDeOrden(m.docnum))+'</b>'):'')):'')
          +(donde?(' <i class="ti ti-arrow-right" style="font-size:10px"></i> '+_esc(donde)):'')
        +'</div>'
        +'<div style="font-size:12px;color:var(--text-secondary);margin-top:4px;background:var(--surface-1);border-radius:7px;padding:6px 9px">'
          +_menResaltar(_esc(m.texto||''))+'</div>'
        +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
          +(/dep[oó]sito|pago final/i.test(String(m.texto||''))?'Avisado el ':'')+_esc(_fechaHora(m.creado_en))
          +(function(){
              if(!m.docnum || !/dep[oó]sito/i.test(String(m.texto||''))) return '';
              var o=(typeof orders!=='undefined' && orders ? orders : []).find(function(x){ return String(x.id)===String(m.docnum); });
              var f=_fechaAbonoISO(o, (window._solPago||[]).filter(function(x){ return String(x.docnum)===String(m.docnum) && x.tipo==='abono'; }));
              return f?(' · <b style="color:var(--text-secondary)">abono en SAP: '+_esc(f.split('-').reverse().join('/'))+'</b>'):'';
            })()
        +'</div>'
      +'</div>'
      +'<div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0;align-items:flex-end">'
        // El punto verde: sin abrir. Al darle a «Ir» se apaga, pero la
        // mención sigue en la lista hasta que se marque «Leída».
        +(_menEstaAbierta(m.id)
           ? '<span style="font-size:9.5px;color:var(--text-muted)">vista</span>'
           : '<span title="Sin abrir" style="width:10px;height:10px;border-radius:50%;'
             +'background:#25D366;box-shadow:0 0 0 2px rgba(37,211,102,.25)"></span>')
        +'<button class="btn bp" style="padding:5px 11px;font-size:10.5px;white-space:nowrap" onclick="event.stopPropagation();_menAbrir('+m.id+')">'
          +'<i class="ti ti-arrow-right"></i> Ir</button>'
        +'<button class="btn bg2" style="padding:4px 11px;font-size:10px;white-space:nowrap" onclick="event.stopPropagation();_menMarcarUna('+m.id+')" title="Quitarla sin abrirla">'
          +'Leída</button>'
      +'</div>'
    +'</div>';
  });
  return h+'</div>';
}

// Quita una mención sin abrir la orden
async function _menMarcarUna(id){
  try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+id,{method:'PATCH',
    headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
    body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})}); }catch(e){}
  window._menciones=(window._menciones||[]).filter(function(x){ return String(x.id)!==String(id); });
  _menBadge();
  showT('Marcada como leída');
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

/* Abre la orden donde ocurrió la mención. OJO: «Ir» NO la borra. Solo se
   apaga su punto verde, como en WhatsApp al abrir un chat. La mención
   desaparece únicamente con el botón «Leída». */
var MEN_ABIERTAS_KEY='menciones_abiertas_v1';
function _menAbiertas(){
  try{ return JSON.parse(localStorage.getItem(MEN_ABIERTAS_KEY)||'{}')||{}; }
  catch(e){ return {}; }
}
function _menMarcarAbierta(id){
  try{
    var m=_menAbiertas();
    m[String(id)]=Date.now();
    localStorage.setItem(MEN_ABIERTAS_KEY, JSON.stringify(m));
  }catch(e){}
}
function _menEstaAbierta(id){ return !!_menAbiertas()[String(id)]; }

// Cuántas quedan SIN ABRIR: es el número que se enseña
function _menSinAbrir(){
  return (window._menciones||[]).filter(function(m){
    return !_menEstaAbierta(m.id) && !_menEsDelSistema(m); }).length;
}

async function _menAbrir(id){
  var m=(window._menciones||[]).find(function(x){ return String(x.id)===String(id); });
  if(!m) return;
  _menMarcarAbierta(id);
  _menBadge();
  try{ if(PG==='alertas') rAlertas(); }catch(e){}

  // Si la mención vino de una ETAPA, se abre la orden en esa etapa y se deja
  // ahí, con el chat del paso listo para seguir la conversación. La ventana
  // aparte solo se usa cuando no hay etapa a la que ir.
  if(m.contexto==='etapa' && m.docnum){
    _menIrAEtapa(m);
    return;
  }
  // Las alertas de solicitud de pago llevan a la solicitud concreta, no a una
  // etapa: contabilidad quiere ver esa solicitud, no buscarla en la lista.
  if(m.contexto==='solicitud' && m.docnum){
    _menIrASolicitud(m);
    return;
  }
  _menVerHilo(m);
}

// Lleva a la solicitud de pago concreta y la resalta
function _menIrASolicitud(m){
  go('alertas');
  window._solResaltar={docnum:String(m.docnum), id:m.solId||null, hasta:Date.now()+9000};
  showT('Abriendo la solicitud de la orden '+m.docnum);
  _solResaltarIr(0);
}

function _solResaltarIr(intento){
  var r=window._solResaltar;
  if(!r || Date.now()>r.hasta){ window._solResaltar=null; return; }
  // La tarjeta de esa solicitud
  var el=(r.id!=null) ? document.getElementById('solcard-'+r.id) : null;
  if(!el){
    var cands=document.querySelectorAll('[data-soldoc="'+r.docnum+'"]');
    if(cands && cands.length) el=cands[0];
  }
  if(!el){
    if(intento>40){ window._solResaltar=null; return; }
    return setTimeout(function(){ _solResaltarIr(intento+1); }, 160);
  }
  window._solResaltar=null;
  try{ el.scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){}
  el.style.transition='box-shadow .3s';
  el.style.boxShadow='0 0 0 3px var(--fill-accent)';
  setTimeout(function(){ el.style.boxShadow='none'; }, 2400);
}

// Abre la orden en la etapa exacta del comentario y prepara la respuesta
function _menIrAEtapa(m){
  var idx=STAGES.findIndex(function(s){ return s.label===m.etapa || s.key===m.etapa; });
  if(idx<0){ _menVerHilo(m); return; }
  // El paso concreto: el que tenga ese comentario en su chat
  var paso=_menPasoDelComentario(m, idx);
  window._menDestino={oid:String(m.docnum), idx:idx, paso:paso, de:m.de_nombre||'', texto:m.texto||''};
  window._abrirEtapa={oid:String(m.docnum), key:STAGES[idx].key, paso:paso};
  showT('Abriendo '+STAGES[idx].label+' — orden '+m.docnum);
  try{ _solPagoAbrir(m.docnum); }catch(e){ try{ openDetail(m.docnum); }catch(e2){} }
  _abrirEtapaPedida(0);
  _menPrepararRespuesta(0);
}

// Busca en qué subpaso está el comentario que me mencionó
function _menPasoDelComentario(m, idx){
  var st=STAGES[idx];
  if(!st) return 0;
  // Si la alerta ya dice a qué paso lleva, se usa ese
  if(m.paso){
    var ip=st.steps.findIndex(function(p){ return p.name===m.paso; });
    if(ip>=0) return ip;
  }
  for(var i=0;i<st.steps.length;i++){
    var ck='sub_'+m.docnum+'_'+st.key+'_step'+i;
    var coms=(window._subComs&&window._subComs[ck])?window._subComs[ck]:[];
    if(coms.some(function(c){ return String(c.texto||'')===String(m.texto||''); })) return i;
  }
  // Si los comentarios aún no están en memoria, se pregunta a la base y se
  // corrige el destino cuando llegue la respuesta.
  _menPasoDesdeBase(m, idx);
  return 0;
}

// Consulta en qué etapa quedó guardado el comentario
async function _menPasoDesdeBase(m, idx){
  try{
    var r=await fetch(SB+'/rest/v1/compras_comentarios?select=etapa,texto&docnum=eq.'
      +encodeURIComponent(m.docnum)+'&limit=200',{headers:SBH});
    if(!r.ok) return;
    var rows=await r.json()||[];
    var st=STAGES[idx];
    var hit=rows.find(function(c){ return String(c.texto||'')===String(m.texto||''); });
    if(!hit || !hit.etapa) return;
    var mm=String(hit.etapa).match(/_step(\d+)$/);
    if(!mm) return;
    var paso=parseInt(mm[1],10);
    if(isNaN(paso) || paso<0 || paso>=st.steps.length) return;
    if(window._menDestino && String(window._menDestino.oid)===String(m.docnum)){
      window._menDestino.paso=paso;   // se corrige antes de enfocar
    }
  }catch(e){ console.warn('paso del comentario:',e); }
}

// Deja el cursor en el chat del paso, con la persona ya etiquetada
function _menPrepararRespuesta(intento){
  var d=window._menDestino; if(!d) return;
  intento=intento||0;
  var inp=document.getElementById('subcin-'+d.oid+'-'+d.idx+'-'+d.paso);
  if(!inp){
    if(intento>50){ window._menDestino=null; return; }   // ~8 s y se rinde
    return setTimeout(function(){ _menPrepararRespuesta(intento+1); }, 160);
  }
  window._menDestino=null;
  // Responder a quien me mencionó, ya etiquetado
  var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(d.de||''); });
  if(quien && !inp.value) inp.value=_menToken(quien)+' ';
  var caja=document.getElementById('subcms-'+d.oid+'-'+d.idx+'-'+d.paso);
  if(caja && caja.scrollIntoView) caja.scrollIntoView({behavior:'smooth', block:'center'});
  setTimeout(function(){
    try{ inp.focus(); inp.setSelectionRange(inp.value.length, inp.value.length); }catch(e){}
    // Realce breve del chat, para ubicarlo
    var cont=inp.closest?inp.closest('.cir'):null;
    if(cont){
      cont.style.transition='box-shadow .3s';
      cont.style.boxShadow='0 0 0 3px #E0A82E';
      setTimeout(function(){ cont.style.boxShadow='none'; }, 1800);
    }
  }, 220);
}

// Ventana con el hilo de comentarios donde ocurrió la mención
async function _menVerHilo(m){
  var prev=document.getElementById('menHiloOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='menHiloOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2300;display:flex;align-items:center;justify-content:center;padding:18px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:13px;padding:22px;max-width:440px;width:100%">'
    +'<div style="font-size:12.5px;color:var(--text-muted)"><span class="ai-ring g" style="vertical-align:-2px"></span> Abriendo el comentario…</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);

  // Comentarios del hilo, según de dónde venga la mención
  var coms=[], titulo='', sub='', x=null;
  if(m.contexto==='solicitud'){
    x=_solPagoPorId(m.sol_id);
    if(!x){
      // La solicitud puede no estar cargada: se pide a la base
      try{
        var r=await fetch(SB+'/rest/v1/solicitudes_pago?select=*&id=eq.'+m.sol_id+'&limit=1',{headers:SBH});
        if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length){ x=f[0];
          window._solPago=(window._solPago||[]); 
          if(!window._solPago.some(function(z){return String(z.id)===String(x.id);})) window._solPago.push(x); } }
      }catch(e){}
    }
    if(x){
      coms=_solComents(x);
      titulo=(x.tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación');
      sub=(x.proveedor||'')+' · orden '+(x.docnum||'')+' · '+fmt(x.monto);
    }
  } else {
    // Comentario de una etapa: se leen los del subpaso
    titulo=m.etapa||'Comentario de etapa';
    sub='Orden '+(m.docnum||'');
    try{
      var rc=await fetch(SB+'/rest/v1/compras_comentarios?select=*&docnum=eq.'+encodeURIComponent(m.docnum||'')
        +'&order=creado_en.asc&limit=200',{headers:SBH});
      if(rc.ok){
        var todos=await rc.json()||[];
        coms=todos.filter(function(c){ return String(c.texto||'').indexOf('@')>=0 || true; })
                  .map(function(c){ return {autor:c.usuario||c.autor||'', texto:c.texto||'', en:c.creado_en}; });
      }
    }catch(e){}
  }

  if(!coms.length && m.texto) coms=[{autor:m.de_nombre||'', texto:m.texto, en:m.creado_en}];

  var h='<div style="background:var(--surface-0);border-radius:13px;max-width:520px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
    +'<div style="min-width:0"><div style="font-size:14.5px;font-weight:700"><i class="ti ti-at" style="color:var(--t-oro)"></i> '+_esc(titulo)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:2px">'+_esc(sub)+'</div>'
    +'<div style="font-size:11px;color:var(--t-oro);margin-top:3px"><b>'+_esc(m.de_nombre||'')+'</b> te mencionó · '+_esc(_fechaHora(m.creado_en))+'</div></div>'
    +'<button onclick="document.getElementById(\'menHiloOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';

  h+='<div style="padding:13px 18px">';
  coms.forEach(function(c){
    var mio=(String(c.autor||'')===String((CU&&CU.name)||''));
    var esElMio=(String(c.texto||'')===String(m.texto||''));
    h+='<div style="font-size:12px;padding:7px 10px;background:'+(esElMio?'#FEF9E7':(mio?'#eef5fd':'var(--surface-1)'))+';'
      +'border-radius:8px;margin-bottom:6px'+(esElMio?';border:1px solid #E0A82E':'')+'">'
      +'<div style="font-weight:600;font-size:11px;color:var(--text-secondary)">'+_esc(c.autor||'')
      +(c.en?(' <span style="font-weight:400;color:var(--text-muted);font-size:10px">'+_esc(_fechaHora(c.en))+'</span>'):'')+'</div>'
      +'<div style="margin-top:2px">'+_menResaltar(_esc(c.texto||''))+'</div></div>';
  });

  // Responder, con la persona ya mencionada
  var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(m.de_nombre||''); });
  var pre=quien?(_menToken(quien)+' '):'';
  h+='<div style="margin-top:10px;position:relative">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:4px">Responder'
      +(quien?(' a <b>'+_esc(quien.name)+'</b>'):'')+'</div>'
    +'<div id="menhilo-drop" style="display:none;position:absolute;bottom:100%;left:0;right:0;margin-bottom:4px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:200px;overflow-y:auto;z-index:60"></div>'
    +'<div style="display:flex;gap:6px">'
      +'<input id="menhilo-in" value="'+_esc(pre)+'" placeholder="Escribe tu respuesta… usa @ para mencionar" autocomplete="off" '
      +'style="flex:1;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12px;background:var(--surface-0);color:var(--text-primary)" '
      +'oninput="_menRefrescar(\'menhilo-in\',\'menhilo-drop\')" onblur="setTimeout(function(){_menCerrar(\'menhilo-drop\');},150)" '
      +'onkeydown="if(event.key===\'Enter\'){event.preventDefault();_menResponder();}">'
      +'<button class="btn bp" style="padding:7px 12px" onclick="_menResponder()"><i class="ti ti-send"></i></button>'
    +'</div></div>';

  if(m.docnum){
    h+='<div style="margin-top:12px;display:flex;justify-content:flex-end">'
      +'<button class="btn bg2" style="padding:6px 12px;font-size:11.5px" onclick="document.getElementById(\'menHiloOv\').remove();_menIrAlContexto('+m.id+')">'
      +'<i class="ti ti-external-link"></i> Abrir la orden</button></div>';
  }
  h+='</div></div>';
  ov.innerHTML=h;
  window._menHilo=m;
  setTimeout(function(){
    var i=document.getElementById('menhilo-in');
    if(i){ i.focus(); try{ i.setSelectionRange(i.value.length,i.value.length); }catch(e){} }
  },80);
}

// Envía la respuesta desde la ventana del hilo
async function _menResponder(){
  var m=window._menHilo; if(!m) return;
  var inp=document.getElementById('menhilo-in');
  var txt=(inp&&inp.value||'').trim();
  if(!txt){ showT('Escribe una respuesta'); return; }
  if(inp){ inp.disabled=true; }

  if(m.contexto==='solicitud'){
    var x=_solPagoPorId(m.sol_id);
    if(!x){ showT('No se encontró la solicitud'); if(inp) inp.disabled=false; return; }
    var cs=_solComents(x);
    cs.push({autor:(CU&&CU.name)||'', rol:(CU&&CU.role)||'', texto:txt, en:new Date().toISOString()});
    x.comentarios=cs;
    var ok=await _solPagoPatch(m.sol_id,{comentarios:cs});
    if(!ok) showT('⚠ No se pudo guardar la respuesta');
    try{
      var men=_menExtraer(txt);
      if(men.length) await _menNotificar(men, {docnum:x.docnum, contexto:'solicitud', solId:x.id, texto:txt,
        etiqueta:'una solicitud de '+(x.tipo==='abono'?'abono':'cancelación')});
    }catch(e){}
  } else {
    try{ await guardarComentario(m.docnum, m.etapa||'', txt); }catch(e){}
    try{
      var men2=_menExtraer(txt);
      if(men2.length) await _menNotificar(men2, {docnum:m.docnum, contexto:'etapa', etapa:m.etapa, texto:txt,
        etiqueta:m.etapa||('la orden '+m.docnum)});
    }catch(e){}
  }
  var ov=document.getElementById('menHiloOv'); if(ov) ov.remove();
  showT('✓ Respuesta enviada');
  try{ _solPagoRefrescar(); }catch(e){}
}

// Abre la orden donde ocurrió la mención
function _menIrAlContexto(id){
  var m=window._menHilo;
  if(!m || String(m.id)!==String(id)) return;
  if(m.contexto==='solicitud'){
    window._solComentOpen=m.sol_id;
    go('alertas');
    setTimeout(function(){
      var el=document.getElementById('solcom-box-'+m.sol_id);
      if(el && el.scrollIntoView) el.scrollIntoView({behavior:'smooth', block:'center'});
    }, 500);
    return;
  }
  if(m.docnum){
    var idx=STAGES.findIndex(function(s){ return s.label===m.etapa || s.key===m.etapa; });
    if(idx>=0) window._abrirEtapa={oid:m.docnum, key:STAGES[idx].key};
    try{ _solPagoAbrir(m.docnum); }catch(e){}
    if(idx>=0) _abrirEtapaPedida(0);
  }
}

async function _menMarcarTodas(){
  var ms=(window._menciones||[]).slice();
  for(var i=0;i<ms.length;i++){
    try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+ms[i].id,{method:'PATCH',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})}); }catch(e){}
  }
  window._menciones=[];
  _menBadge();
  showT('Menciones marcadas como leídas');
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

function _menBadge(){
  // Solo cuenta lo que no se ha abierto: una vez que le das a «Ir» deja de
  // sumar, aunque la mención siga en la lista hasta marcarla leída.
  var n=_menSinAbrir();
  var el=document.getElementById('nbNumMen');
  if(el){
    if(n>0){
      el.textContent=(n>99?'99+':String(n));
      el.style.display='block';
      el.title=n+' comentario(s) donde te mencionaron. Pulsa Alertas para verlos.';
      el.style.cursor='pointer';
      // El globo también entra a Alertas
      el.onclick=function(ev){ ev.stopPropagation(); go('alertas'); };
    } else {
      el.textContent=''; el.style.display='none'; el.title=''; el.onclick=null;
    }
  }
}

function _menIniciar(){
  // El escalamiento por demora arranca junto con las alertas
  try{ _escIniciar(); }catch(e){ console.warn('escalamiento:',e); }
  // Y los reclamos, para que se vean sin tener que abrir cada orden
  try{ setTimeout(function(){ _reclPrecargar(); }, 2500); }catch(e){}
  _menCargar(true).then(function(){
    _menBadge();
    try{ if(PG==='alertas') rAlertas(); }catch(e){}
  }).catch(function(){});
  if(!window._menPoller){
    window._menPoller=true;
    setInterval(function(){
      _menCargar(true).then(function(){
        _menBadge();
        var escribiendo=false;
        try{
          var act=document.activeElement;
          if(act && /^(solcom-in-|subcin-|cin-)/.test(act.id||'')) escribiendo=true;
        }catch(e){}
        if(!escribiendo && PG==='alertas'){ try{ rAlertas(); }catch(e){} }
      });
    }, 45000);
  }
}

function _esGerencia(){ return !!(CU && CU.role==='gerencia'); }

// Un usuario puede tener un rol principal y, además, apoyar a otro equipo:
// Nasly es de importación y hace también el trabajo de las compradoras. Eso
// va en rolesExtra, y todas las comprobaciones de «es de compras» pasan por
// aquí en vez de mirar el rol a secas.
function _rolesDe(u){
  if(!u) return [];
  var l=u.role?[u.role]:[];
  (u.rolesExtra||[]).forEach(function(r){ if(l.indexOf(r)<0) l.push(r); });
  return l;
}
function _esComprasU(u){ return _rolesDe(u).indexOf('compras')>=0; }
function _esCompras(){ return _esComprasU(typeof CU!=='undefined'?CU:null); }

// Confirmación con el detalle de lo que se elimina
function _confirmarBorrado(titulo, detalle, arrastra){
  var msg='¿Está seguro de que desea borrar '+titulo+'?';
  if(detalle) msg+='\n\n'+detalle;
  if(arrastra && arrastra.length){
    msg+='\n\nSe eliminará también:';
    arrastra.forEach(function(x){ msg+='\n  · '+x; });
  }
  msg+='\n\nEsta acción NO se puede deshacer.';
  return confirm(msg);
}

// Borra un archivo del Storage y su registro
async function _borrarArchivoStorage(path, docId){
  var ok=true;
  if(docId){
    try{ await fetch(SB+'/rest/v1/compras_documentos?id=eq.'+docId,{method:'DELETE',headers:SBH}); }
    catch(e){ ok=false; console.warn('borrar registro doc:',e); }
  }
  if(path){
    try{
      await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+String(path).split('/').map(encodeURIComponent).join('/'),
        {method:'DELETE', headers:{'apikey':KEY,'Authorization':SBH.Authorization}});
    }catch(e){ ok=false; console.warn('borrar archivo:',e); }
  }
  return ok;
}

// Todos los documentos colgados de una referencia
async function _docsDeOrden(ref){
  try{
    var r=await fetch(SB+'/rest/v1/compras_documentos?select=id,archivo_path,nombre&docnum=eq.'+encodeURIComponent(ref)+'&limit=500',{headers:SBH});
    if(r.ok){ var f=await r.json(); return Array.isArray(f)?f:[]; }
  }catch(e){ console.warn('docs de orden:',e); }
  return [];
}

// ── Limpiar archivos duplicados de una orden ──
// Las versiones anteriores del portal subean el mismo archivo varias veces.
// Esto deja UNA copia de cada documento y borra las demás, del registro y
// del almacenamiento.
async function _limpiarDocsDuplicados(ref, silencioso){
  var docs=[];
  try{
    var r=await fetch(SB+'/rest/v1/compras_documentos?select=id,nombre_archivo,url,etapa,subido_en&docnum=eq.'
      +encodeURIComponent(ref)+'&order=subido_en.asc&limit=500',{headers:SBH});
    if(r.ok) docs=await r.json()||[];
  }catch(e){ console.warn('leer docs:',e); return 0; }
  if(!docs.length) return 0;

  // Se agrupa por nombre + etapa: la primera copia se queda, el resto se va
  var vistos={}, sobran=[];
  docs.forEach(function(d){
    var k=String(d.etapa||'')+'|'+_docClave({name:d.nombre_archivo});
    if(vistos[k]) sobran.push(d); else vistos[k]=d;
  });
  if(!sobran.length){ if(!silencioso) showT('No hay archivos duplicados en esta orden'); return 0; }

  if(!silencioso){
    if(!confirm('Esta orden tiene '+sobran.length+' archivo(s) duplicado(s).\n\n'
      +'Se conservará una copia de cada documento y se borrarán las repetidas.\n\n¿Continuar?')) return 0;
  }
  // Las rutas que siguen en uso no se borran del almacenamiento
  var enUso={};
  Object.keys(vistos).forEach(function(k){ if(vistos[k].url) enUso[vistos[k].url]=1; });

  for(var i=0;i<sobran.length;i++){
    try{ await fetch(SB+'/rest/v1/compras_documentos?id=eq.'+sobran[i].id,{method:'DELETE',headers:SBH}); }catch(e){}
    if(sobran[i].url && !enUso[sobran[i].url]){
      try{
        await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+String(sobran[i].url).split('/').map(encodeURIComponent).join('/'),
          {method:'DELETE', headers:{'apikey':KEY,'Authorization':SBH.Authorization}});
      }catch(e){}
    }
  }
  // Y se limpia lo que hay en memoria
  Object.keys(window._atts||{}).forEach(function(k){
    if(k.indexOf(String(ref))===0) window._atts[k]=_dedupDocs(window._atts[k]);
  });
  if(!silencioso) showT('✓ '+sobran.length+' archivo(s) duplicado(s) eliminados');
  return sobran.length;
}

// ── Orden NO SAP: se lleva documentos, etapas, comentarios y solicitudes ──
async function _gerBorrarOrdenNoSap(ref){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar la orden completa'); return; }
  var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref); });
  var nombre=(p?(p.proveedor+' — '):'')+ref;

  showT('Revisando qué cuelga de esta orden…');
  var docs=await _docsDeOrden(ref);
  var sols=[], etapas=0, coments=0;
  try{
    var rs=await fetch(SB+'/rest/v1/solicitudes_pago?select=id,tipo,monto&docnum=eq.'+encodeURIComponent(ref)+'&limit=100',{headers:SBH});
    if(rs.ok) sols=await rs.json()||[];
  }catch(e){}
  try{
    var re=await fetch(SB+'/rest/v1/compras_seguimiento?select=etapa&docnum=eq.'+encodeURIComponent(ref)+'&limit=50',{headers:SBH});
    if(re.ok) etapas=(await re.json()||[]).length;
  }catch(e){}
  try{
    var rc=await fetch(SB+'/rest/v1/compras_comentarios?select=id&docnum=eq.'+encodeURIComponent(ref)+'&limit=200',{headers:SBH});
    if(rc.ok) coments=(await rc.json()||[]).length;
  }catch(e){}

  var arrastra=[];
  if(docs.length)   arrastra.push(docs.length+' archivo(s) adjunto(s)');
  if(etapas)        arrastra.push('el avance de '+etapas+' etapa(s)');
  if(coments)       arrastra.push(coments+' comentario(s)');
  if(sols.length)   arrastra.push(sols.length+' solicitud(es) de pago');

  if(!_confirmarBorrado('la orden BORRADOR "'+nombre+'"',
      'Se borra solo de este portal. SAP no se toca.', arrastra)) return;

  showT('Borrando…');
  // Archivos primero: si algo falla, se ve antes de perder el registro
  for(var i=0;i<docs.length;i++){ await _borrarArchivoStorage(docs[i].archivo_path, docs[i].id); }
  var tablas=[
    ['compras_seguimiento','docnum'],
    ['compras_comentarios','docnum'],
    ['compras_com_pend','docnum'],
    ['solicitudes_pago','docnum'],
    ['compras_pend_sap','dkc']
  ];
  for(var t=0;t<tablas.length;t++){
    try{ await fetch(SB+'/rest/v1/'+tablas[t][0]+'?'+tablas[t][1]+'=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }
    catch(e){ console.warn('borrar '+tablas[t][0]+':',e); }
  }
  try{ await fetch(SB+'/rest/v1/compras_pend_sap?num_orden=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }catch(e){}

  // Limpieza en memoria
  window._pendSAP=(window._pendSAP||[]).filter(function(x){ return String(x.dkc)!==String(ref)&&String(x.num_orden)!==String(ref); });
  if(typeof orders!=='undefined') orders=orders.filter(function(o){ return !(o._noSap && String(o.id)===String(ref)); });
  if(stageProgress) delete stageProgress[ref];
  if(window._atts) delete window._atts[ref+'__pendsap'];
  window._solPago=(window._solPago||[]).filter(function(x){ return String(x.docnum)!==String(ref); });

  showT('✓ Orden '+ref+' eliminada por completo');
  _refrescarPantalla();
  try{ _solPagoBadgeIniciar&&_solPagoBadgeIniciar(); }catch(e){}
}

// ── Proveedor NO SAP: con todos sus SKU ──
async function _gerBorrarProveedorNoSap(cardcode){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar el proveedor completo'); return; }
  var k=_catKeyProv(cardcode);
  var prov=(window._catNoSap||[]).find(function(f){ return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===k; });
  var items=_catItemsDeProveedor(cardcode);
  var nombre=(prov?prov.cardname:'')||cardcode;

  var arrastra=[];
  if(items.length) arrastra.push(items.length+' SKU nuevo(s) de este proveedor');
  if(!_confirmarBorrado('el proveedor BORRADOR "'+cardcode+' — '+nombre+'"',
      'Se quita solo de este portal. Las órdenes que lo usan no se tocan.', arrastra)) return;

  showT('Borrando…');
  var ids=[]; if(prov) ids.push(prov.id);
  items.forEach(function(it){ if(it.id) ids.push(it.id); });
  for(var i=0;i<ids.length;i++){
    try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+ids[i],{method:'DELETE',headers:SBH}); }catch(e){}
  }
  window._catNoSap=(window._catNoSap||[]).filter(function(f){ return ids.indexOf(f.id)<0; });
  _catNoSapBadge();
  showT('✓ Proveedor y '+items.length+' SKU eliminados');
  rCatNoSap();
}

// ── Solo los SKU de un proveedor, dejando la ficha del proveedor ──
// Hace falta cuando el proveedor YA existe en SAP y lo único pendiente son
// sus artículos: antes había que borrarlos de uno en uno.
async function _gerBorrarSkuDeProveedor(cardcode){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar los SKU'); return; }
  var items=_catItemsDeProveedor(cardcode);
  if(!items.length){ showT('Ese proveedor no tiene SKU'); return; }
  var k=_catKeyProv(cardcode);
  var prov=(window._catNoSap||[]).find(function(f){ return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===k; });
  var nombre=(prov?prov.cardname:'')||(items[0]&&items[0].cardname)||cardcode;

  if(!_confirmarBorrado('los '+items.length+' SKU de "'+cardcode+' — '+nombre+'"',
      'Se quitan solo de este portal. Las órdenes que los usan no se tocan.',
      [items.length+' SKU nuevo(s)'])) return;

  showT('Borrando '+items.length+' SKU…');
  var n=0;
  for(var i=0;i<items.length;i++){
    if(!items[i].id) continue;
    try{
      await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+items[i].id,{method:'DELETE',headers:SBH});
      n++;
    }catch(e){}
  }
  var ids={};
  items.forEach(function(it){ ids[it.id]=1; });
  window._catNoSap=(window._catNoSap||[]).filter(function(f){ return !ids[f.id]; });
  _catNoSapBadge();
  showT('✓ '+n+' SKU eliminados');
  rCatNoSap();
}

// ── Todas las fichas de una vez ──

// ═══════ LIMPIEZA DE DATOS DE PRUEBA (solo gerencia) ═══════
async function _gerLimpiarPruebas(){
  if(!_esGerencia()){ showT('Solo gerencia puede limpiar los datos de prueba'); return; }
  if(!confirm('Esto borra TODOS los reclamos, reposiciones y los montos/logs de prueba guardados.\n\nNO toca proveedores, órdenes, SKU, fotos ni cuentas.\n\n¿Continuar?')) return;
  showT('Limpiando datos de prueba…');
  var borrados={reclamos:0, repos:0, envios:0, logs:0};

  // 1. Reclamos (tabla reclamos)
  try{
    await fetch(SB+'/rest/v1/reclamos?id=gt.0',{method:'DELETE',headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    borrados.reclamos=1;
  }catch(e){ console.warn('reclamos:',e); }

  // 2. Reposiciones (pedidos + envíos)
  try{
    await fetch(SB+'/rest/v1/reposiciones_envios?id=gt.0',{method:'DELETE',headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    borrados.envios=1;
  }catch(e){ console.warn('rep envios:',e); }
  try{
    await fetch(SB+'/rest/v1/reposiciones_pedidos?id=gt.0',{method:'DELETE',headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    borrados.repos=1;
  }catch(e){ console.warn('rep pedidos:',e); }

  // 3. Logs de localStorage (montos de reclamo, logística de prueba)
  try{
    var quitar=[];
    for(var i=0;i<localStorage.length;i++){
      var k=localStorage.key(i);
      if(k && (k.indexOf('log_')===0 || k.indexOf('iarev_')===0 || k.indexOf('recepcion_')===0 || k.indexOf('muestras_')===0)) quitar.push(k);
    }
    quitar.forEach(function(k){ localStorage.removeItem(k); });
    borrados.logs=quitar.length;
  }catch(e){}

  // 4. Limpiar memoria
  try{ window._reclEstados={}; window._reclCargado=false; }catch(e){}
  try{ window._repPedidos=[]; window._repEnvios=[]; }catch(e){}
  try{ (window._pendSAP||[]).forEach(function(p){ if(p.logistica&&p.logistica.reclamo) delete p.logistica.reclamo; }); }catch(e){}

  showT('✓ Datos de prueba eliminados. Recarga la página.');
  setTimeout(function(){ location.reload(); }, 1500);
}

async function _gerVaciarCatalogoNoSap(){
  if(!_esGerencia()){ showT('Solo gerencia puede vaciar el catálogo'); return; }
  var filas=window._catNoSap||[];
  if(!filas.length){ showT('No hay nada que borrar'); return; }
  var provs=filas.filter(function(f){return f.tipo==='proveedor';}).length;
  var items=filas.filter(function(f){return f.tipo==='item';}).length;
  if(!_confirmarBorrado('TODO el catálogo BORRADOR',
      'Se eliminan todas las fichas temporales de este portal. SAP no se toca.',
      [provs+' proveedor(es) nuevo(s)', items+' SKU nuevo(s)'])) return;
  if(!confirm('Última confirmación.\n\nSe van a borrar '+filas.length+' fichas. ¿Continuar?')) return;
  showT('Borrando '+filas.length+' fichas…');
  for(var i=0;i<filas.length;i++){
    try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+filas[i].id,{method:'DELETE',headers:SBH}); }catch(e){}
  }
  window._catNoSap=[];
  _catNoSapBadge();
  showT('✓ Catálogo BORRADOR vaciado');
  rCatNoSap();
}

// ── Reposición enviada: con su archivo ──
async function _gerBorrarReposicion(id, archivoPath){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar la reposición'); return; }
  var env=(window._repEnvios||[]).find(function(x){ return String(x.id)===String(id); });
  var nombre=env?((env.cardcode||'')+' — '+(env.cardname||'')):('#'+id);
  var arrastra=[];
  if(archivoPath||(env&&env.archivo_path)) arrastra.push('el archivo adjunto de la reposición');
  if(!_confirmarBorrado('la reposición de "'+nombre+'"',
      'Se elimina del seguimiento de reposiciones.', arrastra)) return;
  showT('Borrando…');
  var path=archivoPath||(env&&env.archivo_path);
  if(path) await _borrarArchivoStorage(path, null);
  try{ await fetch(SB+'/rest/v1/reposiciones_envios?id=eq.'+id,{method:'DELETE',headers:SBH}); }catch(e){}
  window._repEnvios=(window._repEnvios||[]).filter(function(x){ return String(x.id)!==String(id); });
  showT('✓ Reposición eliminada');
  try{ _repEnviosCargar(); }catch(e){}
  try{ _repBadgeActualizar(); }catch(e){}
}

// ── Solicitud de pago ──
async function _gerBorrarSolicitud(id){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar solicitudes'); return; }
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  var nombre=(x.tipo==='abono'?'solicitud de abono':'solicitud de cancelación')
    +' de '+(x.proveedor||'')+' por '+fmt(x.monto);
  var cs=_solComents(x);
  var arrastra=[];
  if(cs.length) arrastra.push(cs.length+' comentario(s)');
  if(!_confirmarBorrado('la '+nombre, 'Dejará de aparecer en alertas y en el reporte.', arrastra)) return;
  try{ await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+id,{method:'DELETE',headers:SBH}); }catch(e){}
  window._solPago=(window._solPago||[]).filter(function(s){ return String(s.id)!==String(id); });
  showT('✓ Solicitud eliminada');
  _solPagoRefrescar();
}

// ── Archivo suelto de cualquier etapa ──
async function _gerBorrarArchivo(oid, stageKey, i){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar archivos de las etapas'); return; }
  var k=oid+stageKey;
  var a=(window._atts&&window._atts[k])?window._atts[k][i]:null;
  if(!a){ showT('Archivo no encontrado'); return; }
  if(!_confirmarBorrado('el archivo "'+(a.name||'sin nombre')+'"',
      'Se elimina del portal y del almacenamiento.')) return;
  await _borrarArchivoStorage(a.url, a.id);
  window._atts[k].splice(i,1);
  showT('✓ Archivo eliminado');
  try{ openDetail(oid); }catch(e){}
}

// ══════════════════════════════════════════════════════════════════════
//  MODO CLARO Y MODO OSCURO
//  Por defecto se sigue lo que tenga puesto el sistema operativo, que es lo
//  que la mayoría espera. Quien quiera otra cosa lo elige aquí y se le
//  recuerda en su equipo.
//    'auto'  → lo que diga el sistema
//    'claro' → siempre claro
//    'oscuro'→ siempre oscuro
// ══════════════════════════════════════════════════════════════════════
function _temaGuardado(){
  // Por defecto CLARO: los colores de siempre. El modo oscuro solo si la
  // persona lo elige, no por lo que tenga puesto el sistema. Así nadie se
  // encuentra el portal cambiado sin haberlo pedido.
  try{ return localStorage.getItem('kcc_tema') || 'claro'; }catch(e){ return 'claro'; }
}

function _temaEfectivo(){ return _temaGuardado()==='oscuro' ? 'oscuro' : 'claro'; }

function _temaAplicar(){
  try{
    var el=document.documentElement;
    el.setAttribute('data-tema', _temaEfectivo());
    // Para que el navegador pinte del color correcto los campos nativos:
    // desplegables, calendarios y barras de desplazamiento
    el.style.colorScheme = (_temaEfectivo()==='oscuro') ? 'dark' : 'light';
  }catch(e){}
}

function _temaCambiar(){
  var nuevo = (_temaGuardado()==='oscuro') ? 'claro' : 'oscuro';
  try{ localStorage.setItem('kcc_tema', nuevo); }catch(e){}
  _temaAplicar();
  try{ if(CU) renderApp(); else renderLogin(); }catch(e){}
  showT(nuevo==='oscuro' ? 'Modo nocturno' : 'Modo diurno');
}

function _temaBoton(){
  var osc = _temaEfectivo()==='oscuro';
  return '<button onclick="_temaCambiar()" '
    +'title="'+(osc?'Modo nocturno. Pulsa para el diurno.':'Modo diurno. Pulsa para el nocturno.')+'" '
    +'style="background:transparent;border:0.5px solid var(--border);border-radius:8px;'
    +'width:32px;height:32px;cursor:pointer;font-size:15px;line-height:1;'
    +'color:'+(osc?'#F0B366':'#B45309')+';display:flex;align-items:center;'
    +'justify-content:center;padding:0">'
    +'<i class="ti '+(osc?'ti-moon':'ti-sun')+'"></i></button>';
}

// Al arrancar
_temaAplicar();

function renderApp(){const rl={gerencia:(_deptAcotado()?('Encargado · '+_deptEtiqueta()):'Gerencia'),compras:'Compras · '+(_deptEtiqueta()||''),diseno:'Diseño',importacion:'Importación',contabilidad:'Contabilidad',bodega:'Bodega'};const ndefs={dashboard:{i:'ti-layout-dashboard',l:'Inicio'},ordenes:{i:'ti-search',l:'Buscar órdenes'},completadas:{i:'ti-circle-check',l:'Completadas'},pendientes:{i:'ti-writing',l:'Por aprobar',dot:true},contab:{i:'ti-coin',l:'Contabilidad'},deptos:{i:'ti-chart-bar',l:'Departamentos'},mistarea:{i:CU.role==='importacion'?'ti-ship':CU.role==='bodega'?'ti-building-warehouse':'ti-palette',l:CU.role==='importacion'?'Embarques':CU.role==='bodega'?'Bodega':'Mis artes'},alertas:{i:'ti-bell',l:(CU.role==='contabilidad'?'Solicitudes de abonos o cancelaciones':'Alertas')},reposiciones:{i:'ti-package',l:'Reposiciones'},reppedidos:{i:'ti-clipboard-list',l:'Pedidos guardados'},nueva:{i:'ti-writing',l:(CU.role==='gerencia'?'Compras para firmar':'Nueva compra para firma')},livechat:{i:'ti-messages',l:'Live Chat'},reportes:{i:'ti-report',l:'Reportes'}};const colores={gerencia:'#EAF3DE',compras:'#e6f1fb',diseno:'#EEEDFE',importacion:'#E1F5EE',contabilidad:'#FBEAF0',bodega:'#FEF3E8'};const tcs={gerencia:'#27500A',compras:'#0c447c',diseno:'#3C3489',importacion:'#085041',contabilidad:'#72243E',bodega:'#7C3D12'};const p=pCnt(),unr=unreadN();document.getElementById('root').innerHTML=`<div class="topbar"><h1><img src="${KCC_GLOBO}" alt="Kennedy Center" class="kcc-logo-top">Control de compras<span title="Versión del portal. Si no coincide con la última que te pasaron, tu navegador tiene una copia vieja: recarga con Ctrl+F5." style="font-size:10px;font-weight:600;color:var(--text-muted);background:var(--surface-1);border-radius:20px;padding:2px 9px;margin-left:9px;vertical-align:middle" title="Última actualización: ${_appFechaLarga()}">${APP_VERSION} · ${_appFechaCorta()}</span></h1><div style="display:flex;gap:5px;align-items:center">${_temaBoton()}<div style="display:flex;flex-direction:column;align-items:center;gap:1px"><button id="btnSync" onclick="hacerSyncGlobal()" style="background:var(--fill-accent);color:white;border:none;border-radius:9px;padding:9px 18px;cursor:pointer;font-size:14px;font-weight:700;display:flex;align-items:center;gap:7px"><i class="ti ti-refresh" id="syncIcon" style="font-size:16px"></i> Sync</button><div id="syncTime" style="font-size:11px;color:var(--text-secondary);white-space:nowrap;font-weight:500;margin-top:2px">${window._ultimoSync||'—'}</div></div>${unr>0?`<span class="badge" style="background:var(--pastel-naranja);color:var(--t-marron);cursor:pointer" onclick="renderNP()"><i class="ti ti-bell" style="font-size:10px"></i> ${unr}</span>`:''}<span class="badge b-al"><i class="ti ti-alert-triangle" style="font-size:10px"></i> <span id="ac">${vO().filter(o=>o.alerta).length}</span></span><span class="badge b-sap">SAP B1</span></div></div><div class="ub"><div style="position:relative;flex-shrink:0"><div id="topAvatar" class="uav" style="background:${colores[CU.role]||'#eee'};color:${tcs[CU.role]||'#333'};background-size:cover;background-position:center">${CU.ini}</div><button onclick="_perfilCambiar()" title="Cambiar foto de perfil" style="position:absolute;bottom:-2px;right:-2px;width:17px;height:17px;border-radius:50%;border:1.5px solid var(--surface-0);background:#075E54;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0"><i class="ti ti-camera" style="font-size:9px"></i></button></div><div style="flex:1"><div style="font-size:12px;font-weight:600">${CU.name}</div><div style="font-size:10px;color:var(--text-muted);margin-top:1px">${CU.email}</div>${window._ultimoLoginPrevio?`<div style="font-size:9.5px;color:var(--text-accent);margin-top:2px;display:flex;align-items:center;gap:3px"><i class="ti ti-clock" style="font-size:10px"></i>Último acceso: ${window._ultimoLoginPrevio}</div>`:''}<div style="display:flex;align-items:center;gap:5px;margin-top:2px"><span class="urb" style="background:${colores[CU.role]};color:${tcs[CU.role]}">${rl[CU.role]||CU.role}</span>${_deptAcotado()?`<span style="font-size:10px;color:var(--text-muted)">${_deptEmojis()} Solo ${_deptEtiqueta()}</span>`:''}${CU.role==='diseno'?'<span style="font-size:10px;color:#7F77DD;background:#EEEDFE;padding:1px 6px;border-radius:8px">Solo pedido y artes</span>':''}${CU.role==='bodega'?'<span style="font-size:10px;color:var(--t-marron);background:var(--pastel-naranja);padding:1px 6px;border-radius:8px">Solo bodega</span>':''}</div></div><button class="xb" onclick="_ayudaIndice()" title="Guía del portal: qué hace cada pantalla" style="margin-right:6px"><i class="ti ti-help-circle" style="font-size:11px"></i> Ayuda</button><button class="xb" onclick="logout()"><i class="ti ti-logout" style="font-size:11px"></i> Salir</button></div><div id="notif-area"></div><div class="nav">${CU.nav.map(nid=>{const n=ndefs[nid];if(!n)return'';return`<button class="nb" onclick="go('${nid}',this)"><i class="ti ${n.i}"></i>${n.l}${nid==='pendientes'&&p>0?'<span class="nb-dot"></span>':''}${nid==='reposiciones'?'<span class="nb-num" id="nbNumRep" style="display:none"></span>':''}${nid==='alertas'?'<span class="nb-num" id="nbNumMen" style="display:none"></span>':''}${nid==='alertas'?'<span class="nb-num" id="nbNumSol" style="display:none"></span>':''}${AYUDA[_ayudaClave(nid)]?_ayudaBtn(_ayudaClave(nid)):''}</button>${(nid==='ordenes'&&_pautPuede())?`<button class="nb" style="color:var(--t-verde)" onclick="go('pautdia',this)"><i class="ti ti-file-invoice"></i>Pedidos</button>`:''}`;}).join('')}${CU.role!=='contabilidad'?`<button class="nb" onclick="go('inventario',this)"><i class="ti ti-package"></i>Consulta inventario${_ayudaBtn('inventario')}</button>`:''}${_bkPuede()?`<button class="nb" style="color:var(--t-verde)" onclick="go('bancos',this)"><i class="ti ti-building-bank"></i>Saldos y préstamos bancarios${_ayudaBtn('bancos')}</button>`:''}${(CU.role==='gerencia'||_esCompras()||CU.role==='importacion')?`<button class="nb" style="color:var(--t-ambar)" onclick="go('ocpend',this)"><i class="ti ti-package-off"></i>Órdenes recibidas a medias</button>`:''}<button class="nb" onclick="_ceAbrir()"><i class="ti ti-send"></i>Mis correos enviados</button>${_sfPuede()?`<button class="nb" style="color:var(--t-lila)" onclick="_sfAbrir()"><i class="ti ti-photo-up"></i>Subir fotos a SAP</button><button class="nb" style="color:var(--t-lila)" onclick="_fexAbrir()"><i class="ti ti-photo-search"></i>Fotos de Kennedy desde Excel</button>`:''}${(CU.role==='gerencia'||_esCompras()||CU.role==='importacion')?`<button class="nb" style="color:var(--t-verde)" onclick="go('ventadirecta',this)"><i class="ti ti-truck-delivery"></i>Venta directa</button>`:''}${(CU.role==='gerencia'&&!_deptAcotado())?`<button class="nb" onclick="go('accesos',this)"><i class="ti ti-history"></i>Registro de accesos</button>`:''}${(CU.role==='contabilidad'||(CU.role==='gerencia'&& !_deptAcotado()))?`<button class="nb" style="color:var(--t-vino)" onclick="_solPagoReporteMenu()"><i class="ti ti-printer"></i>Reporte abonos y cancelaciones${_ayudaBtn('reporteabonos')}</button>${_mantPuede()?`<button class="nb" style="color:var(--text-danger)" onclick="_mantBorrarAvisos()"><i class="ti ti-bell-off"></i>Borrar avisos</button>`:''}<button class="nb" style="color:var(--t-vino)" onclick="go('concil',this)"><i class="ti ti-scale"></i>Conciliación bancaria</button><button class="nb" style="color:var(--t-azul)" onclick="_bncAbrir()" title="Los movimientos que Banistmo deja cada día"><i class="ti ti-building-bank"></i>Banco</button>`:''}${_plaPuede()?`<button class="nb" style="color:var(--t-lila)" onclick="_plaAbrir()" title="Marcaciones y planilla · información reservada"><i class="ti ti-clock-dollar"></i>Planilla</button>`:''}${_frPuede()?`<button class="nb" style="color:var(--t-verde)" onclick="go('facturasres');rFacturasRes()"><i class="ti ti-file-invoice"></i>Facturas Reserva</button><button class="nb" style="color:var(--t-verde)" onclick="go('entradas',this)"><i class="ti ti-truck-loading"></i>Entradas</button>`:''}${(CU.role==='gerencia'||_esCompras())?`<button class="nb" style="color:var(--t-ambar)" onclick="abrirNuevaOrdenSinSAP('${_deptPrimero()}')"><i class="ti ti-plus"></i>Crear nueva orden BORRADOR${_ayudaBtn('ordennosap')}</button>${_txtPuede()?`<button class="nb" style="color:var(--t-lila)" onclick="go('hojassap',this)"><i class="ti ti-file-type-txt"></i>Hojas de creación SAP</button>`:''}${_pcsPuede()?`<button class="nb" style="color:var(--t-lila2)" onclick="go('pcs',this)"><i class="ti ti-table-plus"></i>Product Creation Sheet${_ayudaBtn('pcs')}</button>`:''}<button class="nb" style="color:var(--t-lila)" onclick="go('catnosap',this)"><i class="ti ti-tags"></i>Proveedores y SKU BORRADOR<span class="nb-num" id="nbNumCat" style="display:none"></span>${_ayudaBtn('catnosap')}</button>`:''}</div>${['pautdia','dashboard','ordenes','completadas','pendientes','deptos','mistarea','alertas','reposiciones','nueva','livechat','catnosap','inventario','ocpend','accesos','reportes','concil','pcs','bancos','hojassap','ordensap','factreserva','facturasres','ventadirecta','entradas'].map(id=>`<div id="page-${id}" class="page"></div>`).join('')}`;renderNP();go('dashboard');setTimeout(_firmaBadgeIniciar,600);setTimeout(_dmInit,900);setTimeout(_repBadgeIniciar,800);setTimeout(_catNoSapIniciar,1100);setTimeout(_solPagoBadgeIniciar,1000);setTimeout(function(){ try{ _repCargarProveedores(); }catch(e){} },1500);setTimeout(_menIniciar,1200);}
function renderNP(){const area=document.getElementById('notif-area');if(!area)return;
// Lo más reciente primero, y las firmas pendientes por delante de todo: un
// costeo recién enviado salía al final de la lista y no se veía.
const mine=notifications.filter(n=>!n.read&&(n.to===CU?.role||n.to===CU?.id))
  .slice().sort(function(a,b){
    var pa=_npEsPendiente(a)?1:0, pb=_npEsPendiente(b)?1:0;
    if(pa!==pb) return pb-pa;
    return (Number(b.id)||0)-(Number(a.id)||0);
  });if(!mine.length){area.innerHTML='';return;}area.innerHTML=`<div class="notif-panel"><div class="notif-hdr"><span style="font-size:12px;font-weight:500;color:var(--t-marron);display:flex;align-items:center;gap:5px"><i class="ti ti-bell"></i>${mine.length} notificación${mine.length>1?'es':''}</span><span style="font-size:11px;color:var(--t-marron);cursor:pointer;font-weight:500" onclick="markAllR()">Marcar leídas</span></div>${mine.map(n=>`<div class="ni" onclick="rdN(${n.id},'${n.oid||''}')"><div class="ndot" style="background:${n.icon==='ti-writing-sign'?'#16a34a':n.icon==='ti-x'?'#dc2626':n.icon==='ti-table'?'#eda100':'#2a78d6'}"></div><div style="flex:1"><div style="font-size:12px;font-weight:500">${n.msg}</div><div style="font-size:10px;color:var(--text-muted);margin-top:2px">${n.time}</div></div><i class="ti ti-eye" style="font-size:12px;color:var(--text-accent)"></i></div>`).join('')}</div>`;}
/* Abrir un aviso lo da por leído, salvo los que exigen una acción: una
   compra por firmar sigue pendiente hasta que se firma de verdad. Antes se
   borraba con solo abrirla y se perdía de vista. */
function _npEsPendiente(n){
  if(!n) return false;
  if(n.pendiente) return true;
  var t=String(n.msg||'').toLowerCase();
  return /firmar|por firmar|pendiente de firma/.test(t);
}
function rdN(id,oid){
  const n=notifications.find(x=>x.id===id);
  if(n && !_npEsPendiente(n)) n.read=true;
  renderNP();
  if(n && _npEsPendiente(n)) showT('Este aviso se queda hasta que la firmes');
  if(oid)setTimeout(()=>openDetail(oid),100);
}
// Y al firmar, se quitan los avisos de esa compra
function _npCerrarFirma(ref){
  var t=String(ref||'').toLowerCase();
  notifications.forEach(function(n){
    if(!_npEsPendiente(n)) return;
    if(!t || String(n.msg||'').toLowerCase().indexOf(t)>=0) n.read=true;
  });
  try{ renderNP(); }catch(e){}
}
function markAllR(){
  var quedan=0;
  notifications.forEach(n=>{
    if(!(n.to===CU?.role||n.to===CU?.id)) return;
    if(_npEsPendiente(n)){ quedan++; return; }   // las firmas, no
    n.read=true;
  });
  renderNP(); renderApp();
  if(quedan) showT(quedan+' aviso(s) de firma se quedan hasta que las firmes');
}
function oCard(o){initP(o.id);const sc=CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';const comp=o.completada,pPct=getPct(o),stageName=getStageName(o),stageColor=getStageColor(o);const borderCls=o.alerta?'al':comp?'comp':o.pend?'pend':'ok';const si=getStageIdx(o),stg=STAGES[si],sd=stg?getStageStartEnd(o,stg.key):{start:'',end:'',days:0,active:false,done:false};const depAbn=stageProgress[o.id]?.deposito?.stepDates?.[1]||'';const diasDesdeAbn=depAbn?daysBetween(depAbn,null):0;return`<div class="ocard ${borderCls}" onclick="openDetail('${o.id}')"><div class="oh"><div class="oi">${o.emoji}</div><div class="om"><div class="oc">${o.prov} — ${o.id}${o.num_proveedor?` - <span style="font-weight:700;color:var(--t-ambar)">${o.num_proveedor}</span>`:''}</div><div class="od">${dL(o.dept)} · ${o.desc} · ${o.uni?.toLocaleString()||0} und</div><div style="font-size:11px;color:var(--text-muted);margin-top:1px">Cod proveedor: ${o.resp?`<span onclick="event.stopPropagation();abrirInvProveedor('${String(o.resp).replace(/'/g,'')}')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">${o.resp}</span>`:'—'}${sc&&!o.completada?` &nbsp;·&nbsp; <span style="color:var(--text-danger);font-weight:500">Saldo prov: ${fmt(saldoProv(o.prov))}</span>`:''}</div><div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:3px"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>${o.fechaCreacion}</span>${o.fechaEst?`<span class="fecha-badge"><i class="ti ti-calendar-due" style="font-size:10px"></i>ETA: ${o.fechaEst}</span>`:''}${_arteBadge(o)}${o.num_proveedor?`<span class="fecha-badge" style="background:#EEF2FF;color:var(--t-indigo2)"><i class="ti ti-file-invoice" style="font-size:10px"></i>Ref: ${o.num_proveedor}</span>`:''}</div>${!o.pend&&!comp&&sd.start?`<div class="estado-dates"><span class="ed ed-start"><i class="ti ti-player-play" style="font-size:9px"></i>${stg?.label}: ${sd.start}</span>${sd.done&&sd.end?`<span class="ed ed-end"><i class="ti ti-circle-check" style="font-size:9px"></i>Fin: ${sd.end}</span><span class="ed ed-dur"><i class="ti ti-clock" style="font-size:9px"></i>${sd.days}d</span>`:sd.active?`<span class="ed ed-act"><i class="ti ti-clock" style="font-size:9px"></i>${sd.days}d en progreso</span>`:''}</div>`:''}${sc&&depAbn&&!comp?`<div style="font-size:10px;color:var(--text-muted);margin-top:3px"><i class="ti ti-coin" style="font-size:9px"></i> Abono: ${depAbn} · hace ${diasDesdeAbn}d</div>`:''}${o.pend?`<div class="pchip"><i class="ti ti-clock" style="font-size:10px"></i>Pendiente firma</div>`:''}${comp?`<div style="font-size:10px;background:#F0EEFF;color:var(--t-indigo);padding:2px 7px;border-radius:8px;display:inline-flex;align-items:center;gap:3px;margin-top:3px"><i class="ti ti-circle-check" style="font-size:10px"></i>Proceso completo</div>`:''}${o.alerta?`<div class="achip"><i class="ti ti-alert-triangle" style="font-size:10px"></i>${o.alertaMsg}</div>`:''}${badge6m(o)}</div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:5px"><span class="sem ${getSem(o)}"></span><span style="font-size:10px;padding:2px 7px;border-radius:10px;background:${stageColor}22;color:${stageColor};border:0.5px solid ${stageColor}44;white-space:nowrap;max-width:85px;text-align:right">${stageName}</span><span style="font-size:10px;color:var(--text-muted)">${pPct}%</span></div></div><div class="pb"><div class="pf" style="width:${pPct}%;background:${stageColor}"></div></div><div class="om2">${(sc||_esCompras())?`<span><i class="ti ti-currency-dollar" style="font-size:11px"></i>Total ${fmt(o.valor)}</span><span style="color:var(--text-success)">Abonado ${fmt(o.abono)} · ${pct(o.abono,o.valor)}%</span><span style="color:var(--text-danger)">Saldo ${fmt(o.valor-o.abono)}</span>`:''}<span style="color:var(--text-accent)"><i class="ti ti-eye" style="font-size:11px"></i>Ver detalle</span></div></div>`;}

// ── Helper: ¿orden tiene +6 meses y aún no embarcada? ──
function alerta6meses(o){
  if(o.completada||o.pend)return false;
  var dias=daysBetween(o.fechaCreacion,null);
  if(dias<182)return false;
  initP(o.id);
  var logIdx=stageProgress[o.id]&&stageProgress[o.id].logistica?stageProgress[o.id].logistica.stepIdx:0;
  var stageI=getStageIdx(o);
  return stageI<=4&&logIdx<3;
}
function badge6m(o){
  if(!alerta6meses(o))return'';
  var dias=daysBetween(o.fechaCreacion,null);
  return'<div style="display:inline-flex;align-items:center;gap:4px;margin-top:3px;padding:3px 8px;border-radius:8px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;color:var(--t-marron);font-size:10px;font-weight:500"><i class="ti ti-alarm" style="font-size:10px"></i>'+dias+'d sin embarcar — +6 meses</div>';
}
function saldoProv(prov){
  return orders.filter(function(o){return o.prov===prov&&!o.completada;}).reduce(function(s,o){return s+(o.valor-o.abono);},0);
}
let _oSort='nuevo', _oKpiFilter=null, _oKpiDept=null, _oSapFilter='todas';
function _setSapFilter(v){ _oSapFilter=v; rOrdenes(); }
function rDash(){
  // Si el contenedor no está dibujado, no hay nada que pintar. Esto pasa
  // cuando una carga termina ANTES de que la pantalla exista: reventaba con
  // "Cannot set properties of null" y cortaba el repintado a la mitad.
  // Al volver la pantalla, se pinta con normalidad.
  if(!document.getElementById('page-dashboard')) return;
  /* Las tarjetas y las pastillas de abajo leían "orders" y DEPTS_ALL, o sea
     TODOS los departamentos. Con gerencia acotada por área (Gady en
     alfombras, Henry en ropa) eso les enseñaba lo que no les toca.
     vO() y _deptsVisibles() aplican ese límite y no cambian nada para quien
     no tiene departamento asignado. */
  const vo=vO(),al=vo.filter(o=>o.alerta).length;const activas=vo.filter(o=>!o.completada),comp=vo.filter(o=>o.completada),pend=vo.filter(o=>o.pend);const _plPor={local:0, sap:0, ambos:0};
  const porLlegar=activas.filter(o=>!o.pend&&_plTieneBooking(o,_plPor));
  window._plDiag={total:porLlegar.length, activas:activas.length,
                  local:_plPor.local, sap:_plPor.sap, ambos:_plPor.ambos,
                  mapa:Object.keys(window._bkConBooking||{}).length};const costeoEst=activas.filter(o=>!o.pend&&getStageIdx(o)===5);const tv=activas.reduce((s,o)=>s+o.valor,0),ta=activas.reduce((s,o)=>s+o.abono,0);(function(){var _ac=document.getElementById('ac'); if(_ac) _ac.textContent=al;})();/* Se comprueba que exista: rDash puede llamarse cuando una carga
     termina ANTES de que la barra esté dibujada, y entonces reventaba
     con "Cannot set properties of null" y cortaba el repintado. */const visStages=stagesForUser();const gByStage=STAGES.map((_,i)=>activas.filter(o=>!o.pend&&getStageIdx(o)===i).length);const porLlegarByDept={};_deptsVisibles().forEach(d=>{porLlegarByDept[d]=porLlegar.filter(o=>o.dept===d).length;});let html='';try{html+=_solPagoDashBanner();}catch(e){}if(pend.length&&(CU.role==='gerencia'||_esCompras())){const byDept={};pend.forEach(o=>{byDept[o.dept]=(byDept[o.dept]||[]);byDept[o.dept].push(o);});html+=`<div class="ab"><i class="ti ti-writing" style="font-size:18px;color:var(--text-warning)"></i><div style="flex:1"><div style="font-size:12px;color:var(--text-warning);font-weight:500">${pend.length} orden${pend.length>1?'es':''} pendiente${pend.length>1?'s':''} de firma</div><div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:5px">${Object.entries(byDept).map(([d,list])=>`<span style="font-size:10px;background:var(--bg-warning);border:0.5px solid var(--border-warning);border-radius:8px;padding:2px 8px;color:var(--text-warning)">${EMOJIS2[d]||''} ${dL(d)}: ${list.length}</span>`).join('')}</div></div><button class="btn bw" onclick="go('pendientes')"><i class="ti ti-eye"></i>Ver</button></div>`;}if(costeoEst.length&&CU.role==='gerencia'){const byDept={};costeoEst.forEach(o=>{byDept[o.dept]=(byDept[o.dept]||[]);byDept[o.dept].push(o);});html+=`<div style="background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:var(--radius);padding:10px 12px;margin-bottom:10px"><div style="display:flex;align-items:center;gap:10px"><i class="ti ti-table" style="font-size:18px;color:var(--t-marron)"></i><div style="flex:1"><div style="font-size:12px;color:var(--t-marron);font-weight:500">${costeoEst.length} costeo${costeoEst.length>1?'s':''} pendiente${costeoEst.length>1?'s':''} de precios</div><div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:5px">${Object.entries(byDept).map(([d,list])=>`<span style="font-size:10px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:8px;padding:2px 8px;color:var(--t-marron);cursor:pointer" onclick="openDetail('${list[0].id}')">${EMOJIS2[d]||''} ${dL(d)}: ${list.length}</span>`).join('')}</div></div></div></div>`;}html+=`<div class="kpi-grid"><div class="kpi ${dashKpiFilter==='activas'?'kpi-active':''}" onclick="toggleKpiFilter('activas')"><div class="kpi-l"><i class="ti ti-shopping-cart"></i>Activas</div><div class="kpi-v kva">${activas.length}</div></div><div class="kpi ${dashKpiFilter==='completadas'?'kpi-active':''}" onclick="toggleKpiFilter('completadas')"><div class="kpi-l"><i class="ti ti-circle-check"></i>Completadas</div><div class="kpi-v kvs">${comp.length}</div></div>${(CU.role==='gerencia'||_esCompras())?`<div class="kpi ${dashKpiFilter==='pend'?'kpi-active':''}" onclick="toggleKpiFilter('pend')"><div class="kpi-l"><i class="ti ti-writing"></i>Sin firmar</div><div class="kpi-v kvw">${pend.length}</div></div>`:''}${CU.verCostos?`<div class="kpi ${dashKpiFilter==='tot'?'kpi-active':''}" onclick="toggleKpiFilter('tot')"><div class="kpi-l"><i class="ti ti-currency-dollar"></i>Total SAP</div><div class="kpi-v">${fmt(tv)}</div></div><div class="kpi ${dashKpiFilter==='abn'?'kpi-active':''}" onclick="toggleKpiFilter('abn')"><div class="kpi-l"><i class="ti ti-coin"></i>Abonado SAP ${pct(ta,tv)}%</div><div class="kpi-v kvs">${fmt(ta)}</div></div><div class="kpi ${dashKpiFilter==='sal'?'kpi-active':''}" onclick="toggleKpiFilter('sal')"><div class="kpi-l"><i class="ti ti-receipt"></i>Saldo SAP ${pct(tv-ta,tv)}%</div><div class="kpi-v kvd">${fmt(tv-ta)}</div></div>
<div class="kpi ${dashKpiFilter==='ns_tot'?'kpi-active':''}" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer" onclick="toggleKpiFilter('ns_tot')"><div class="kpi-l" style="color:var(--t-lila2)"><i class="ti ti-file-invoice"></i>Total Borrador</div><div class="kpi-v" style="color:var(--t-lila2)">${_nsapKpi(totalPendSAP())}</div></div>
<div class="kpi ${dashKpiFilter==='ns_abn'?'kpi-active':''}" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer" onclick="toggleKpiFilter('ns_abn')"><div class="kpi-l" style="color:var(--t-lila2)"><i class="ti ti-coin"></i>Abonado Borrador</div><div class="kpi-v kvs" style="color:#059669">${_nsapKpi(totalAbonPendSAP())}</div></div>
<div class="kpi ${dashKpiFilter==='ns_sal'?'kpi-active':''}" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer" onclick="toggleKpiFilter('ns_sal')"><div class="kpi-l" style="color:var(--t-lila2)"><i class="ti ti-receipt"></i>Saldo Borrador</div><div class="kpi-v kvd">${_nsapKpi(totalPendSAP()-totalAbonPendSAP())}</div></div>${(CU.role==='gerencia'||_esCompras())?`<div class="kpi" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px" onclick="abrirNuevaOrdenSinSAP('${_deptPrimero()}')" title="Registrar una compra que todavía no está en SAP"><i class="ti ti-plus" style="font-size:19px;color:var(--t-lila2)"></i><div style="font-size:11.5px;font-weight:700;color:var(--t-lila2);text-align:center;line-height:1.25">Crear nueva<br>orden BORRADOR</div></div>`:''}
<div class="kpi" style="border-color:#185FA5;background:linear-gradient(135deg,#EFF6FF,#DBEAFE);grid-column:span 2"><div class="kpi-l" style="color:#185FA5;font-weight:700"><i class="ti ti-sigma"></i>GRAN TOTAL (SAP + Borrador)</div><div class="kpi-v" style="color:#185FA5;font-size:18px;font-weight:800">${fmt(tv+totalPendSAP())}</div></div>
<div class="kpi" style="border-color:#059669;background:linear-gradient(135deg,#ECFDF5,#D1FAE5)"><div class="kpi-l" style="color:#059669;font-weight:600"><i class="ti ti-coin"></i>Gran Total Abonado</div><div class="kpi-v kvs" style="font-size:15px">${fmt(ta+totalAbonPendSAP())}</div></div>
<div class="kpi" style="border-color:var(--t-rojo2);background:linear-gradient(135deg,#FEF2F2,#FEE2E2)"><div class="kpi-l" style="color:var(--t-rojo2);font-weight:600"><i class="ti ti-receipt"></i>Gran Total Saldo</div><div class="kpi-v kvd" style="font-size:15px">${fmt((tv-ta)+(totalPendSAP()-totalAbonPendSAP()))}</div></div>
`:''}
<div class="kpi ${dashKpiFilter==='llegar'?'kpi-active':''}" onclick="toggleKpiFilter('llegar')" title="Órdenes con booking: lo que viene en camino"><div class="kpi-l"><i class="ti ti-ship"></i>Por llegar <span onclick="event.stopPropagation();_plPorQue()" style="color:var(--text-accent);cursor:pointer;font-size:10px;text-decoration:underline" title="De dónde sale este número">${porLlegar.length?'¿de dónde sale?':'¿por qué 0?'}</span></div><div class="kpi-v" style="color:#1D9E75">${CU.verCostos?fmt(porLlegar.reduce((a,o)=>a+(Number(o.valor)||0),0)):porLlegar.length}</div>${porLlegar.length?`<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">${porLlegar.length} orden(es)${CU.verCostos?'':''}</div>`:''}</div><div class="kpi ${dashKpiFilter==='sap'?'kpi-active':''}" onclick="toggleKpiFilter('sap')"><div class="kpi-l"><i class="ti ti-clock-pause"></i>Orden Borrador</div><div class="kpi-v" style="color:var(--t-ambar)">${pendientesSAPVisibles().length}${CU.verCostos?` <span style="font-size:12px;font-weight:500">· ${fmt(totalPendSAP())}</span>`:''}</div></div><div class="kpi ${dashKpiFilter==='alertas'?'kpi-active':''}" onclick="toggleKpiFilter('alertas')"><div class="kpi-l"><i class="ti ti-alert-triangle"></i>Alertas</div><div class="kpi-v kvd">${al}</div></div></div>`;if(dashKpiFilter){let panelOrdenes=[],panelTitle='',panelColor='#2a78d6';let esNoSAP=false;if(dashKpiFilter==='activas'){panelOrdenes=activas.filter(o=>!o.pend);panelTitle=`Órdenes activas (${panelOrdenes.length})`;panelColor='var(--text-accent)';}else if(dashKpiFilter==='completadas'){panelOrdenes=comp;panelTitle=`Completadas (${comp.length})`;panelColor='var(--text-success)';}else if(dashKpiFilter==='pend'){panelOrdenes=pend;panelTitle=`Sin firmar (${pend.length})`;panelColor='#BA7517';}else if(dashKpiFilter==='llegar'){panelOrdenes=porLlegar;panelTitle=`Por llegar (${porLlegar.length})`;panelColor='#1D9E75';}else if(dashKpiFilter==='alertas'){panelOrdenes=vo.filter(o=>o.alerta);panelTitle=`Con alertas (${panelOrdenes.length})`;panelColor='var(--text-danger)';}else if(dashKpiFilter==='tot'){panelOrdenes=activas.filter(o=>!o.pend);panelTitle=`Total SAP (${panelOrdenes.length})`;panelColor='var(--text-accent)';}else if(dashKpiFilter==='abn'){panelOrdenes=activas.filter(o=>o.abono>0);panelTitle=`Abonado SAP (${panelOrdenes.length})`;panelColor='var(--text-success)';}else if(dashKpiFilter==='sal'){panelOrdenes=activas.filter(o=>(o.valor-o.abono)>0);panelTitle=`Saldo SAP (${panelOrdenes.length})`;panelColor='var(--text-danger)';}else if(dashKpiFilter==='sap'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles();panelTitle=`Orden Borrador (${panelOrdenes.length})`;panelColor='#B45309';}else if(dashKpiFilter==='ns_tot'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles();panelTitle=`Total Borrador (${panelOrdenes.length})`;panelColor='#6D28D9';}else if(dashKpiFilter==='ns_abn'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles().filter(p=>(Number(p.abonado)||0)>0);panelTitle=`Abonado Borrador (${panelOrdenes.length})`;panelColor='#6D28D9';}else if(dashKpiFilter==='ns_sal'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles().filter(p=>((p.saldo!=null?p.saldo:(Number(p.total)||0)-(Number(p.abonado)||0)))>0);panelTitle=`Saldo Borrador (${panelOrdenes.length})`;panelColor='#6D28D9';}
html+=`<div class="kpi-panel"><div class="kpi-panel-hdr"><span style="font-size:12px;font-weight:600;color:${panelColor};display:flex;align-items:center;gap:5px"><i class="ti ti-list"></i>${panelTitle}</span><button class="btn bg2" style="padding:2px 8px;font-size:11px" onclick="toggleKpiFilter(null)"><i class="ti ti-x" style="font-size:11px"></i></button></div>`
  +`<div style="padding:8px 10px;border-bottom:0.5px solid var(--border)"><div style="position:relative"><i class="ti ti-search" style="position:absolute;left:9px;top:50%;transform:translateY(-50%);color:var(--text-muted);font-size:13px"></i><input id="dashKpiSearch" placeholder="Buscar por proveedor o número de orden..." value="${_dashKpiQ||''}" oninput="_dashKpiFiltrar(this.value)" style="width:100%;padding:7px 10px 7px 30px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-2);color:var(--text-primary)"></div></div>`
  +`<div id="dashKpiList">${_dashKpiRenderList(panelOrdenes, esNoSAP)}</div></div>`;}
  else { html += _dashExtraPanel(activas); }if((CU.role==='gerencia'||CU.role==='contabilidad')&&porLlegar.length){const deptConL=_deptsVisibles().filter(d=>porLlegarByDept[d]>0);html+=`<div style="background:var(--pastel-verde2);border:0.5px solid #0F6E56;border-radius:var(--radius);padding:10px 12px;margin-bottom:12px"><div style="font-size:12px;font-weight:500;color:var(--t-verde2);margin-bottom:7px;display:flex;align-items:center;gap:5px"><i class="ti ti-ship"></i>Por llegar por departamento</div><div style="display:flex;gap:7px;flex-wrap:wrap">${deptConL.map(d=>`<span style="background:var(--surface-2);border:0.5px solid #0F6E56;border-radius:10px;padding:3px 10px;font-size:11px;cursor:pointer;color:var(--t-verde2)" onclick="go('deptos')"><strong>${porLlegarByDept[d]}</strong> ${EMOJIS2[d]} ${dL(d)}</span>`).join('')}</div></div>`;}html+=`<div class="slbl"><i class="ti ti-map"></i>Estado por etapa — clic para ver</div>`;if(CU.role==='gerencia')html+=`<div class="dept-filter-row">${(_deptAcotado()?['todos'].concat(_deptsVisibles()):['todos',...DEPTS_ALL]).map(d=>`<span class="dept-chip ${dashStageDept===d?'active':''}" onclick="setDashDept('${d}')">${dL(d)}</span>`).join('')}</div>`;html+=`<div class="etapa-grid">${visStages.map(s=>{const ri=STAGES.indexOf(s);let cnt=dashStageDept==='todos'||CU.role!=='gerencia'?gByStage[ri]:activas.filter(o=>!o.pend&&getStageIdx(o)===ri&&o.dept===dashStageDept).length;const isA=activeDashStage===s.key;return`<div class="etapa-card ${isA?'active-stage':''}" onclick="toggleDashStage('${s.key}')"><div class="etapa-n" style="color:${s.color}">${cnt}</div><div class="etapa-l">${s.label}</div></div>`;}).join('')}</div>`;if(activeDashStage){const st=STAGES.find(s=>s.key===activeDashStage);const stIdx=STAGES.indexOf(st);let list=activas.filter(o=>!o.pend&&getStageIdx(o)===stIdx);if(dashStageDept!=='todos'&&CU.role==='gerencia')list=list.filter(o=>o.dept===dashStageDept);html+=`<div class="etapa-list"><div class="etapa-list-hdr"><div style="display:flex;align-items:center;gap:7px"><i class="ti ${st.icon}" style="font-size:14px;color:${st.color}"></i><span style="font-size:12px;font-weight:500">${st.label} — ${list.length} orden${list.length!==1?'es':''}${dashStageDept!=='todos'?' · '+dL(dashStageDept):''}</span></div><button class="btn bg2" style="padding:3px 8px;font-size:11px" onclick="activeDashStage=null;rDash()"><i class="ti ti-x" style="font-size:11px"></i></button></div>${list.length?list.map(o=>{const sp=stageProgress[o.id]||{};const sS=sp[activeDashStage]||{};const dias=sS.startDate?daysBetween(sS.startDate,null):0;return`<div class="etapa-list-item" onclick="openDetail('${o.id}')"><div style="font-size:20px;flex-shrink:0">${o.emoji}</div><div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">${o.prov} — ${o.id}${o.num_proveedor?` - <span style="font-weight:700;color:var(--t-ambar)">${o.num_proveedor}</span>`:''}</div><div style="font-size:11px;color:var(--text-secondary)">${dL(o.dept)} · ${o.desc}</div><div style="display:flex;gap:5px;margin-top:3px;flex-wrap:wrap"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:9px"></i>${sS.startDate||o.fechaCreacion}</span>${diasBadge(dias)}</div></div><span class="sem sem-y"></span></div>`;}).join(''):'<div class="empty">No hay órdenes en esta etapa</div>'}</div>`;}if(CU.role==='gerencia'||CU.role==='contabilidad'){html+=`<div class="slbl"><i class="ti ti-chart-bar"></i>Por departamento</div><div class="dept-sem-grid">${_deptsVisibles().map(d=>{const list=vO().filter(o=>o.dept===d);if(!list.length)return'';const tot=list.reduce((s,o)=>s+o.valor,0),abn=list.reduce((s,o)=>s+o.abono,0);const pctAbn=pct(abn,tot),pctSal=100-pctAbn;const actCnt=list.filter(o=>!o.completada).length,compCnt=list.filter(o=>o.completada).length;const diasProm=Math.round(list.filter(o=>!o.completada&&!o.pend).reduce((s,o)=>s+daysBetween(o.fechaCreacion,null),0)/Math.max(1,actCnt));const semColor=pctSal>70?'#e24b4a':pctSal>40?'#eda100':'#639922';const porLleg=porLlegarByDept[d]||0;return`<div class="dept-sem-card"><div class="dept-sem-hdr" onclick="go('deptos')" style="cursor:pointer;display:flex;align-items:center;gap:11px">${_deptIconHTML(d,52)}<div style="flex:1;min-width:0"><div class="dept-sem-name" style="font-size:15px;font-weight:700">${dL(d)}</div><div class="dept-sem-count">${list.length} total · ${compCnt} comp · ${actCnt} activas${porLleg>0?` · <span style="color:var(--t-verde2);font-weight:500">${porLleg} por llegar</span>`:''}${_ocPendResumenDept(d)}</div></div></div><div class="dept-sem-body"><div class="sem-row"><span class="sem-label">Total</span><span onclick="_dMF='total';_dMD='${d}';go('deptos')" class="sem-val" style="cursor:pointer;text-decoration:underline;font-weight:600">${fmt(tot)}</span></div><div class="sem-row"><span class="sem-label" style="color:#639922">Abonado</span><div class="sem-bar-bg"><div class="sem-bar-fill" style="width:${pctAbn}%;background:#639922"></div></div><span onclick="_dMF='abonado';_dMD='${d}';go('deptos')" class="sem-val" style="color:#639922;cursor:pointer;text-decoration:underline">${fmt(abn)} · ${pctAbn}%</span></div><div class="sem-row"><span class="sem-label" style="color:${semColor}">Saldo</span><div class="sem-bar-bg"><div class="sem-bar-fill" style="width:${pctSal}%;background:${semColor}"></div></div><span onclick="_dMF='saldo';_dMD='${d}';go('deptos')" class="sem-val" style="color:${semColor};cursor:pointer;text-decoration:underline">${fmt(abn>0?tot-abn:0)} · ${pctSal}%</span></div><div class="sem-dias"><span class="sem" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${semColor};margin-right:4px"></span>Promedio: ${diasProm} días</div>${_ocPendFilaDept(d)}${_dashDeptSinSAP(d,tot,abn)}</div></div>`;}).join('')}</div>`;html+=_invValPanel();html+=_vtaDepPanel();}if(pend.length&&(CU.role==='gerencia'||_esCompras()))html+=`<div class="slbl" style="color:var(--text-warning)"><i class="ti ti-writing"></i>Pendientes de firma</div>${pend.slice(0,2).map(o=>oCard(o)).join('')}`;if(CU.role==='diseno'){
    var _enArtes=activas.filter(function(o){return !o.pend;});
    var _artActivos=_enArtes.filter(function(o){return tieneAdjuntoArte(o.id);});
    // Pendiente = ni terminado ni empezado. Antes bastaba con no tener un
    // arte adjunto, así que una orden con la etapa cerrada y el semáforo en
    // verde seguía contando como pendiente.
    var _artPend=_enArtes.filter(function(o){
      return !_arteCompleta(o) && !_arteEnProceso(o); });
    var _artHechos=_enArtes.filter(_arteCompleta);
    html+='<div class="slbl"><i class="ti ti-palette"></i>Artes activos ('+_artActivos.length+')</div>';
    html+=(_artActivos.length?_artActivos.slice(0,4).map(function(o){return oCard(o);}).join(''):'<div class="empty">Sin artes en trabajo</div>');
    html+='<div class="slbl" style="color:#BA7517"><i class="ti ti-clock"></i>Artes pendientes ('
      +_artPend.length+') de '+_enArtes.length+' totales'
      +(_artHechos.length?(' <span style="font-weight:400;color:var(--t-verde)">· '
        +_artHechos.length+' ya terminados</span>'):'')+'</div>';
    html+=(_artPend.length?_artPend.slice(0,4).map(function(o){return oCard(o);}).join(''):'<div class="empty">No hay artes pendientes</div>');
    document.getElementById('page-dashboard').innerHTML=html;return;
  }
  // Actividad reciente agrupada por departamento
// Si el usuario tiene un departamento asignado (no gerencia), solo ve la actividad de SU depto.
var _raExcl=(CU&&CU.deptExcl)||[];
var _raOrdenes=_recentActivity.map(function(a){return orders.find(function(o){return String(o.id)===String(a.docnum)&&!o.completada;});}).filter(Boolean).filter(function(o){
  if(CU&& _deptAcotado()) return _deptPermitido(o.dept);         // usuario de un solo depto
  if(_raExcl.length) return _raExcl.indexOf(o.dept)<0;  // usuario con deptos excluidos
  return true;                                       // gerencia: ve todo
});
// Los pedidos autorizados de hoy, justo antes de la actividad reciente.
// Solo para gerencia general: llevan ganancia, margen y saldo del cliente,
// que no es información para todo el mundo.
if(_pautPuede()){
  html+='<div id="pautBloque"></div>';
  setTimeout(_pautCargar, 250);
}

// Deduplicar por id de orden, mantener orden
var _raVistas={}, _raList=[];
_raOrdenes.forEach(function(o){if(!_raVistas[o.id]){_raVistas[o.id]=true;_raList.push(o);}});
if(_raList.length){
  // Agrupar por departamento
  var _raDepts={};
  _raList.forEach(function(o){
    if(!_raDepts[o.dept])_raDepts[o.dept]=[];
    _raDepts[o.dept].push(o);
  });
  html+='<div class="slbl"><i class="ti ti-activity"></i>Actividad reciente por departamento <span style="font-size:10px;font-weight:400;color:var(--text-muted)">(últimas 48h)</span></div>';
  html+='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(320px,1fr));gap:10px;margin-bottom:14px">';
  Object.keys(_raDepts).forEach(function(d){
    var list=_raDepts[d];
    html+='<div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;overflow:hidden">';
    html+='<div style="display:flex;align-items:center;gap:7px;padding:8px 12px;background:var(--surface-2);border-bottom:0.5px solid var(--border)">';
    html+='<span style="font-size:16px">'+(EMOJIS2[d]||'📦')+'</span>';
    html+='<span style="font-size:12px;font-weight:600">'+dL(d)+'</span>';
    html+='<span style="margin-left:auto;font-size:10px;background:var(--bg-accent);color:var(--text-accent);padding:1px 7px;border-radius:8px;font-weight:600">'+list.length+' activa'+(list.length>1?'s':'')+'</span>';
    html+='</div>';
    list.forEach(function(o){
      var act=_recentActivity.find(function(a){return String(a.docnum)===String(o.id);});
      var tsLabel='';
      if(act&&act.ts){
        var mins=Math.round((Date.now()-new Date(act.ts).getTime())/60000);
        if(mins<60)tsLabel='hace '+mins+'m';
        else if(mins<1440)tsLabel='hace '+Math.round(mins/60)+'h';
        else tsLabel='hace '+Math.round(mins/1440)+'d';
      }
      var etapaLabel=act?({pedido:'Pedido',deposito:'Depósito',artes:'Artes',produccion:'Producción',logistica:'Logística',costeo:'Costeo',bodega:'Bodega'}[act.etapa]||act.etapa):'';
      var tipoIcon=act&&act.tipo==='comentario'?'<i class="ti ti-message" style="font-size:9px;color:var(--text-muted)"></i>':'<i class="ti ti-edit" style="font-size:9px;color:var(--text-muted)"></i>';
      html+='<div data-oid="'+o.id+'" class="ra-row" style="display:flex;align-items:center;gap:9px;padding:8px 12px;border-bottom:0.5px solid var(--border);cursor:pointer;transition:background .15s">';
      html+='<span class="sem '+(o.completada?'sem-g':o.pend?'sem-y':'sem-y')+'" style="width:8px;height:8px;flex-shrink:0"></span>';
      html+='<div style="flex:1;min-width:0">';
      html+='<div style="font-size:12px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+o.prov+' <span style="color:var(--text-muted);font-weight:400">#'+o.id+'</span></div>';
      html+='<div style="display:flex;gap:6px;align-items:center;margin-top:2px;flex-wrap:wrap">';
      if(etapaLabel)html+='<span style="font-size:10px;background:var(--surface-2);border:0.5px solid var(--border);border-radius:5px;padding:0 5px">'+etapaLabel+'</span>';
      if(act&&act.autor)html+=tipoIcon+'<span style="font-size:10px;color:var(--text-muted)">'+act.autor+'</span>';
      html+='</div></div>';
      if(tsLabel)html+='<span style="font-size:10px;color:var(--text-accent);white-space:nowrap;flex-shrink:0">'+tsLabel+'</span>';
      if(CU.verCostos&&o.abono)html+='<span style="font-size:10px;color:var(--text-success);white-space:nowrap;flex-shrink:0">'+fmt(o.abono)+'</span>';
      html+='</div>';
    });
    html+='</div>';
  });
  html+='</div>';
} else {
  html+='<div class="slbl"><i class="ti ti-activity"></i>Actividad reciente</div>';
  html+='<div class="empty" style="margin-bottom:14px"><i class="ti ti-moon" style="font-size:20px;color:var(--text-muted)"></i><br>Sin actividad en las últimas 48 horas</div>';
}document.getElementById('page-dashboard').innerHTML=html;}
function toggleKpiFilter(f){dashKpiFilter=dashKpiFilter===f?null:f;_dashKpiQ='';rDash();}
var _dashKpiQ='';
// Filtra la lista del panel KPI en vivo (por proveedor o número de orden), sin redibujar todo
function _dashKpiFiltrar(q){
  _dashKpiQ=q||'';
  var cont=document.getElementById('dashKpiList');
  if(!cont)return;
  // Recalcular la lista según el filtro activo
  var info=_dashKpiObtenerLista();
  cont.innerHTML=_dashKpiRenderList(info.lista, info.esNoSAP);
  // Mantener foco en el input
  var inp=document.getElementById('dashKpiSearch');
  if(inp){ inp.focus(); try{inp.setSelectionRange(inp.value.length,inp.value.length);}catch(e){} }
}
// Devuelve la lista base según el filtro KPI activo (para el filtrado en vivo)
function _dashKpiObtenerLista(){
  var vo=vO();
  var activas=vo.filter(function(o){return !o.completada;});
  var comp=vo.filter(function(o){return o.completada;});
  var pend=vo.filter(function(o){return o.pend;});
  /* POR LLEGAR: las órdenes que ya tienen BOOKING. Antes se miraba la etapa
     del seguimiento (Logística o Aduanización), que depende de que alguien
     marque los pasos a mano, y por eso salía 0 con millones en camino. El
     booking es un hecho: si hay reserva con la naviera, la mercancía viene. */
  // La logística de las órdenes de SAP vive en su propia tabla y el tablero
  // no la tiene cargada: se pide una vez y queda en memoria. Sin esto el
  // contador salía 0 aunque la orden tuviera su booking puesto.
  // Se deja además el detalle en la consola para poder comprobarlo:
  //   _verLog(true) y recargar el inicio.
  // Si no hay mapa, o salió vacío, se vuelve a pedir: antes un fallo de red
  // dejaba el mapa vacío cacheado para siempre y el contador en 0.
  try{
    var _m=window._bkConBooking;
    if(!_m || !Object.keys(_m).length) _bkCargarBookings();
  }catch(e){}

  var _plPor={local:0, sap:0, estado:0, etapa:0};
  var porLlegar=activas.filter(function(o){
    if(o.pend) return false;
    try{
      var mapa=window._bkConBooking||{};
      // La logística se guarda unas veces por número de orden y otras por
      // DKC, así que se prueban todas las referencias de la orden.
      if(mapa[String(o.id)] || mapa[String(o.dkc||'')]
         || mapa[String(o.num_proveedor||'')] || mapa[String(o.docnum||'')]){
        _plPor.local++; return true;
      }
      var d=_logLeer(o.id), b=d.booking||{};
      if(String(b.numero||'').trim() || String(b.naviera||'').trim()
         || (b.containers||[]).length || (d.contenedores||[]).length){
        _plPor.local++; return true;
      }
    }catch(e){}
    // Y lo que tenga booking en SAP: vale cualquiera de los dos lados
    if(String(o.booking||o.u_booking||'').trim()
       || String(o.contenedor||o.num_contenedor_campo||'').trim()){
      _plPor.sap++; return true;
    }
    // Embarcada o despachada en SAP también es mercancía en camino
    var est=String(o.estado_compra||o._estadoSap||'').trim().toUpperCase();
    if(est==='S' || est==='D'){ _plPor.estado++; return true; }
    if(getStageIdx(o)===4||getStageIdx(o)===5){ _plPor.etapa++; return true; }
    return false;
  });
  window._plDiag={total:porLlegar.length, activas:activas.length,
                  local:_plPor.local, sap:_plPor.sap, estado:_plPor.estado,
                  etapa:_plPor.etapa,
                  mapa:Object.keys(window._bkConBooking||{}).length};
  var f=dashKpiFilter, esNoSAP=false, lista=[];
  if(f==='activas'||f==='tot')lista=activas.filter(function(o){return !o.pend;});
  else if(f==='completadas')lista=comp;
  else if(f==='pend')lista=pend;
  else if(f==='llegar')lista=porLlegar;
  else if(f==='alertas')lista=vo.filter(function(o){return o.alerta;});
  else if(f==='abn')lista=activas.filter(function(o){return o.abono>0;});
  else if(f==='sal')lista=activas.filter(function(o){return (o.valor-o.abono)>0;});
  else if(f==='sap'||f==='ns_tot'){esNoSAP=true;lista=pendientesSAPVisibles();}
  else if(f==='ns_abn'){esNoSAP=true;lista=pendientesSAPVisibles().filter(function(p){return (Number(p.abonado)||0)>0;});}
  else if(f==='ns_sal'){esNoSAP=true;lista=pendientesSAPVisibles().filter(function(p){return ((p.saldo!=null?p.saldo:(Number(p.total)||0)-(Number(p.abonado)||0)))>0;});}
  return {lista:lista, esNoSAP:esNoSAP};
}
// Renderiza la lista del panel (SAP o No SAP), aplicando el filtro de búsqueda
function _dashKpiRenderList(lista, esNoSAP){
  var q=(_dashKpiQ||'').toLowerCase().trim();
  if(esNoSAP){
    var arr=lista.filter(function(p){
      if(!q)return true;
      return String(p.proveedor||'').toLowerCase().includes(q)||String(p.num_orden||p.dkc||'').toLowerCase().includes(q)||String(p.po||'').toLowerCase().includes(q);
    });
    if(!arr.length)return '<div class="empty">Sin órdenes'+(q?' para "'+_esc(q)+'"':'')+'</div>';
    return arr.map(function(p){
      var saldo=(p.saldo!=null?p.saldo:(Number(p.total)||0)-(Number(p.abonado)||0));
      var _refPend=String(p.dkc||p.num_orden||'').replace(/\x27/g,'');
      return '<div class="kpi-panel-item" style="cursor:pointer" onclick="abrirDetalleNoSap(\''+_refPend+'\')">'
        +'<div style="font-size:18px;flex-shrink:0">📄</div>'
        +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+_esc(p.proveedor||'?')+' — '
          // El número de orden es un enlace explícito para abrir la orden
          +'<span onclick="event.stopPropagation();abrirPendSAP(\''+_refPend+'\')" title="Abrir la orden '+_esc(p.num_orden||p.dkc||'')+'" style="color:var(--text-accent);text-decoration:underline;cursor:pointer;font-weight:700">'+_esc(p.num_orden||p.dkc||'')+'</span>'
          +' <span style="font-size:9px;background:var(--pastel-naranja);color:var(--t-ambar);border-radius:4px;padding:0 5px;font-weight:700">BORRADOR</span>'+_pendSAPBadgeEditada(p)+'</div>'
        +'<div style="font-size:11px;color:var(--text-secondary)">'+dL(p.dept||'')+(p.po?(' · PO: '+_esc(p.po)):'')
          +((Number(p.abonado)>0)?(' · <span style="color:var(--t-verde);font-weight:600"><i class="ti ti-coin" style="font-size:9px"></i> Abono: '+_esc(p.fecha_abono||'sin fecha')+'</span>'):'')+'</div></div>'
        +(CU.verCostos?'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(Number(p.total)||0)+'</div><div style="font-size:10px;color:var(--text-success)">'+fmt(Number(p.abonado)||0)+'</div><div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(saldo)+'</div></div>':'')
      +'</div>';
    }).join('');
  } else {
    var arr2=lista.filter(function(o){
      if(!q)return true;
      return String(o.prov||'').toLowerCase().includes(q)||String(o.id||'').toLowerCase().includes(q)||String(o.num_proveedor||'').toLowerCase().includes(q)||String(o.desc||'').toLowerCase().includes(q);
    });
    if(!arr2.length)return '<div class="empty">Sin órdenes'+(q?' para "'+_esc(q)+'"':'')+'</div>';
    return arr2.map(function(o){
      return '<div class="kpi-panel-item" onclick="openDetail(\''+o.id+'\')"><div style="font-size:18px;flex-shrink:0">'+o.emoji+'</div>'
        +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+_esc(o.prov)+' — '+_esc(o.id)+(o.num_proveedor?' - <span style="font-weight:700;color:var(--t-ambar)">'+_esc(o.num_proveedor)+'</span>':'')+'</div>'
        +'<div style="font-size:11px;color:var(--text-secondary)">'+dL(o.dept)+' · '+_esc(o.desc)+'</div>'
        +'<div style="display:flex;gap:5px;margin-top:2px;flex-wrap:wrap"><span class="fecha-badge" style="margin-top:0"><i class="ti ti-calendar" style="font-size:9px"></i>'+o.fechaCreacion+'</span>'
        +((Number(o.abono)>0)?('<span class="fecha-badge" style="margin-top:0;background:var(--pastel-ok);color:var(--t-verde);border-color:var(--t-verde3)"><i class="ti ti-coin" style="font-size:9px"></i>Abono: '+_esc(o.fechaAbono||'sin fecha')+'</span>'):'')
        +(o.alerta?'<span style="font-size:10px;background:var(--bg-danger);color:var(--text-danger);padding:1px 7px;border-radius:8px">'+o.alertaMsg+'</span>':'')+'</div></div>'
        +(CU.verCostos?'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(o.valor)+'</div><div style="font-size:10px;color:var(--text-success)">'+fmt(o.abono)+'</div><div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>':'')
      +'</div>';
    }).join('');
  }
}
function _dashExtraPanel(activas){
  if(!dashKpiFilter||!['tot','abn','sal'].includes(dashKpiFilter))return'';
  var lst=dashKpiFilter==='tot'?activas:dashKpiFilter==='abn'?activas.filter(function(o){return o.abono>0;}):activas.filter(function(o){return(o.valor-o.abono)>0;});
  var lbl={tot:'Total en órdenes',abn:'Abonadas',sal:'Con saldo'}[dashKpiFilter];
  var col=dashKpiFilter==='abn'?'var(--text-success)':dashKpiFilter==='sal'?'var(--text-danger)':'var(--text-accent)';
  return'<div class="kpi-panel"><div class="kpi-panel-hdr"><span style="font-size:12px;font-weight:600;color:'+col+';display:flex;align-items:center;gap:5px"><i class="ti ti-list"></i>'+lbl+' ('+lst.length+')</span><button class="btn bg2" style="padding:2px 8px;font-size:11px" onclick="toggleKpiFilter(null)"><i class="ti ti-x" style="font-size:11px"></i></button></div>'
    +lst.map(function(o){return'<div class="kp-row" data-oid="'+o.id+'" style="cursor:pointer;display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border)">'
      +'<span style="font-size:18px">'+o.emoji+'</span>'
      +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+o.prov+' — '+o.id+'</div>'
      +'<div style="font-size:11px;color:var(--text-secondary)">'+dL(o.dept)+' · '+o.fechaCreacion+'</div></div>'
      +'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(o.valor)+'</div>'
      +'<div style="font-size:10px;color:var(--text-success)">'+fmt(o.abono)+'</div>'
      +'<div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>'
      +'</div>';}).join('')
    +'</div>';
}
function toggleDashStage(key){
  // Si hay un departamento seleccionado en el dashboard, al hacer clic en una
  // etapa se muestra el listado COMPLETO del departamento (igual que la sección
  // Departamentos), en vez del listado simple por etapa.
  if(dashStageDept && dashStageDept!=='todos' && CU.role==='gerencia'){
    _deptoAutoAbrir=dashStageDept;
    go('deptos');
    return;
  }
  activeDashStage=activeDashStage===key?null:key;rDash();
}
function setDashDept(d){dashStageDept=d;rDash();}
function rOrdenes(d){
  if(!document.getElementById('page-ordenes')) return;dO=d||dO;const avD=_deptAcotado()?['todos'].concat(_deptsVisibles()):['todos',...DEPTS_ALL];let base=vO();if(dO!=='todos'&& !_deptAcotado())base=base.filter(o=>o.dept===dO);const q=searchQuery.toLowerCase().trim();if(q)base=base.filter(o=>o.prov.toLowerCase().includes(q)||o.id.toLowerCase().includes(q)||o.desc.toLowerCase().includes(q)||dL(o.dept).toLowerCase().includes(q)||o.resp.toLowerCase().includes(q)||String(o.num_proveedor||'').toLowerCase().includes(q));
  // FIX 1: sort
  // Filtros por lo que falta llegar. Se cruzan con las órdenes por su
  // referencia (el DKC/SKC) o por el número de pedido de SAP.
  if(_oSapFilter==='abiertas' || _oSapFilter==='sinrecibir'){
    var _pend=_ocPendIndice();
    base=base.filter(function(o){
      var p=_pend[_ocPendClave(o)];
      if(!p) return false;
      return _oSapFilter==='sinrecibir' ? p.completa : !p.completa;
    });
  }
  base=base.slice().sort(function(a,b){var da=_fechaOrden(a),db=_fechaOrden(b);return _oSort==='nuevo'?db-da:da-db;});
  const activas=base.filter(o=>!o.completada),completadas=base.filter(o=>o.completada);
  const list=[...activas,...completadas];
  const t=activas.reduce((s,o)=>s+o.valor,0),a=activas.reduce((s,o)=>s+o.abono,0),sal=t-a;
  // FIX 2: panel KPI clickeado
  var oKpiPanel='';
  if(_oKpiFilter){
    var _okl=_oKpiFilter==='total'?activas:_oKpiFilter==='abonado'?activas.filter(o=>o.abono>0):activas.filter(o=>(o.valor-o.abono)>0);
    if(_oKpiDept&&_oKpiDept!=='todos')_okl=_okl.filter(o=>o.dept===_oKpiDept);
    var _okc=_oKpiFilter==='abonado'?'var(--text-success)':_oKpiFilter==='saldo'?'var(--text-danger)':'var(--text-accent)';
    var _oklbl={total:'Total en órdenes',abonado:'Abonadas',saldo:'Con saldo pendiente'}[_oKpiFilter];
    oKpiPanel='<div style="background:var(--surface-2);border:0.5px solid var(--border-accent);border-radius:var(--radius);margin-bottom:12px;overflow:hidden">'
      +'<div style="display:flex;align-items:center;padding:10px 14px;background:var(--bg-accent)">'
      +'<span style="font-size:13px;font-weight:600;color:'+_okc+'">'+_oklbl+(_oKpiDept&&_oKpiDept!=='todos'?' — '+dL(_oKpiDept):'')+' ('+_okl.length+')</span>'
      +'<button onclick="_oKpiFilter=null;_oKpiDept=null;rOrdenes()" style="margin-left:auto;background:none;border:none;font-size:20px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
      +_okl.map(function(o){return'<div data-oid="'+o.id+'" class="kp-row" style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border);cursor:pointer">'
        +'<span style="font-size:18px">'+o.emoji+'</span>'
        +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+o.prov+' — #'+o.id+'</div>'
        +'<div style="font-size:10px;color:var(--text-muted)">'+dL(o.dept)+' · '+o.fechaCreacion+'</div></div>'
        +(CU.verCostos?'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(o.valor)+'</div><div style="font-size:10px;color:var(--text-success)">'+fmt(o.abono)+' · '+pct(o.abono,o.valor)+'%</div><div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>':'')
        +'</div>';}).join('')
      +'</div>';
  }
  // FIX 1: sort selector; FIX 2: stats con Total+Abonado+Saldo clickeables
  // El origen de la orden va en pastillas a la vista, no escondido en un
  // desplegable: se ve de un vistazo cuál está activo y es un clic menos.
  // Se añaden las dos situaciones de mercancía pendiente. No son un origen
  // como las otras, pero se filtran igual y así están todas a la vista.
  var _sapOpts=[['todas','Todas (SAP + Borrador)'],['sap','Órdenes en SAP'],['nosap','Órdenes Borrador'],
                ['abiertas','Abiertas · falta mercancía'],['sinrecibir','Sin recibir nada']];
  var sapPills='<div class="filters" id="pf-sap" style="margin:0">'
    +_sapOpts.map(function(op){
      return '<span class="pill '+(_oSapFilter===op[0]?'active':'')+'" onclick="_setSapFilter(\''+op[0]+'\')">'+op[1]+'</span>';
    }).join('')+'</div>';
  var sortBar='<div style="display:flex;gap:8px;margin-bottom:10px;align-items:center;flex-wrap:wrap"><select onchange="_oSort=this.value;rOrdenes()" style="padding:6px 10px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)"><option value="nuevo"'+(_oSort==='nuevo'?' selected':'')+'>Más reciente primero</option><option value="antiguo"'+(_oSort==='antiguo'?' selected':'')+'>Más antiguo primero</option></select>'+sapPills+'</div>';
  var statsHtml=CU.verCostos?'<div style="display:flex;gap:7px;margin-bottom:10px;flex-wrap:wrap;align-items:center">'
    +'<span style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)">'+activas.length+' activas</span>'
    +'<span style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)">'+completadas.length+' completadas</span>'
    +'<span data-okf="total" class="ord-kpi-btn" style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border);cursor:pointer;text-decoration:underline"><i class="ti ti-currency-dollar" style="font-size:11px"></i> Total: '+fmt(t)+'</span>'
    +'<span data-okf="abonado" class="ord-kpi-btn" style="font-size:12px;background:var(--bg-success);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border-success);color:var(--text-success);cursor:pointer;text-decoration:underline">Abonado: '+fmt(a)+' ('+pct(a,t)+'%)</span>'
    +'<span data-okf="saldo" class="ord-kpi-btn" style="font-size:12px;background:var(--bg-danger);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border-danger);color:var(--text-danger);cursor:pointer;text-decoration:underline">Saldo: '+fmt(sal)+' ('+pct(sal,t)+'%)</span>'
    +'</div>':'';
  var resultsHtml=(_oSapFilter==='nosap')?'':(list.length?list.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-search" style="font-size:22px;color:var(--text-muted)"></i><br>'+(q?'Sin resultados':'')+'</div>');
  document.getElementById('page-ordenes').innerHTML='<div style="font-size:13px;font-weight:500;margin-bottom:6px">Buscar órdenes</div><div class="search-wrap"><i class="ti ti-search search-icon"></i><input class="search-input" id="search-q" placeholder="Proveedor, código, referencia (SKC), descripción, responsable..." value="'+searchQuery+'" oninput="doSearch(this.value)"><button id="sc-btn" class="search-clear" onclick="clearSearch()" style="display:'+(searchQuery?'flex':'none')+';align-items:center"><i class="ti ti-x"></i></button></div>'+(avD?pills2(dO,'setDO','pf-ord',avD,true):'')+sortBar+statsHtml+oKpiPanel+'<div id="ord-results">'+resultsHtml+'</div>'
    +'<div id="nosap-results"></div>'; setTimeout(function(){refreshSearchResults();try{_renderNoSap();}catch(e){}},0);}
function doSearch(val){
  searchQuery=val;
  var btn=document.getElementById('sc-btn');if(btn)btn.style.display=val?'flex':'none';
  refreshSearchResults();
}
function refreshSearchResults(){
  var base=vO();
  if(dO!=='todos'&& !_deptAcotado())base=base.filter(o=>o.dept===dO);
  var q=searchQuery.toLowerCase().trim();
  if(q)base=base.filter(o=>o.prov.toLowerCase().includes(q)||o.id.toLowerCase().includes(q)||o.desc.toLowerCase().includes(q)||dL(o.dept).toLowerCase().includes(q)||o.resp.toLowerCase().includes(q)||String(o.num_proveedor||'').toLowerCase().includes(q));
  base=base.slice().sort(function(a,b){var da=_fechaOrden(a),db=_fechaOrden(b);return _oSort==='nuevo'?db-da:da-db;});
  var activas=base.filter(o=>!o.completada),completadas=base.filter(o=>o.completada);
  var list=[...activas,...completadas];
  var res=document.getElementById('ord-results');
  if(res)res.innerHTML=(_oSapFilter==='nosap')?'':(list.length?list.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-search" style="font-size:22px;color:var(--text-muted)"></i><br>'+(q?'Sin resultados':'Busca por proveedor, orden, descripción...')+'</div>');
  try{ _renderNoSap(); }catch(e){}
}
function _renderNoSap(){
  var cont=document.getElementById('nosap-results'); if(!cont) return;
  if(_oSapFilter==='sap'){ cont.innerHTML=''; return; }
  var q=searchQuery.toLowerCase().trim();
  var _nsb=pendientesSAPVisibles();
  if(dO!=='todos' && !_deptAcotado())_nsb=_nsb.filter(function(p){return p.dept===dO;});
  if(q)_nsb=_nsb.filter(function(p){return(p.proveedor||'').toLowerCase().includes(q)||(p.num_orden||'').toLowerCase().includes(q)||(p.po||'').toLowerCase().includes(q)||dL(p.dept||'').toLowerCase().includes(q);});
  var show=(_oSapFilter==='nosap')||(q||dO!=='todos');
  if(!show){ cont.innerHTML=''; return; }
  if(!_nsb.length){
    // "No hay ninguna" y "no se pudieron cargar" son cosas distintas. Antes
    // las dos decían lo mismo, y desde una red lenta parecía que la empresa
    // no tenía órdenes NO SAP.
    if(_oSapFilter!=='nosap'){ cont.innerHTML=''; return; }
    var _hay=(window._pendSAP||[]).length;
    cont.innerHTML='<div class="empty" style="padding:14px;color:var(--text-muted)">'
      +(window._pendSAPError
        ? ('<b style="color:var(--t-ambar)"><i class="ti ti-wifi-off"></i> '
           +'No se pudo cargar la lista</b><br>'
           +'<span style="font-size:11px">'+_esc(window._pendSAPError)+'. '
           +'Se reintenta solo; si sigue, pulsa Sync.</span><br>'
           +'<button class="btn bg2" style="font-size:11px;padding:4px 11px;margin-top:7px" '
           +'onclick="cargarPendSAP().then(function(){_refrescarPantalla();})">'
           +'<i class="ti ti-refresh"></i> Reintentar</button>')
        : (_hay
            ? 'Ninguna orden Borrador coincide con este filtro.'
            : 'Sin órdenes Borrador'))
      +'</div>';
    return;
  }
  cont.innerHTML='<div style="font-size:11px;font-weight:600;color:var(--t-ambar);margin:12px 0 6px;display:flex;align-items:center;gap:5px"><i class="ti ti-file-invoice"></i>Órdenes Borrador ('+_nsb.length+')</div>'+_nsb.map(function(p){return _pendSAPFila(p,true);}).join('');
}
function clearSearch(){
  searchQuery='';
  var inp=document.getElementById('search-q');
  if(inp){inp.value='';inp.focus();}
  var btn=document.getElementById('sc-btn');if(btn)btn.style.display='none';
  refreshSearchResults();
}
function setDO(el,d){dO=d;document.querySelectorAll('#pf-ord .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');refreshSearchResults();}
// ── Abonos y cancelaciones realizados (para contabilidad) ──
// Van en Completadas: son las solicitudes cuyo comprobante ya se le envió a
// compras. Se listan de la más nueva a la más vieja y se pueden acotar por
// fecha y por departamento, con el usuario que hizo cada una.
window._solHechasDesde=''; window._solHechasHasta=''; window._solHechasDept='todos';
function _solEnvioComprobante(x){
  var e=x&&x.envio_comprobante;
  if(typeof e==='string'){ try{ e=JSON.parse(e); }catch(err){ e=null; } }
  return (e&&typeof e==='object')?e:null;
}
function _solHechaQuien(x){
  var e=_solEnvioComprobante(x);
  return (e&&e.por) || x.procesado_por || x.recibido_por || '';
}
function _solHechaFecha(x){
  var e=_solEnvioComprobante(x);
  return (e&&e.fecha) || x.finalizado_en || x.procesado_en || x.recibido_en || '';
}
function _solHechas(){
  var cerradas=['abono_enviado','cancelacion_realizada'];
  var lista=(window._solPago||[]).filter(function(x){ return cerradas.indexOf(x.estado)>=0; });
  // Filtros
  var d1=window._solHechasDesde, d2=window._solHechasHasta, dp=window._solHechasDept;
  lista=lista.filter(function(x){
    if(dp && dp!=='todos' && String(x.dept||'otros')!==dp) return false;
    var f=String(_solHechaFecha(x)||'').slice(0,10);
    if(d1 && (!f || f<d1)) return false;
    if(d2 && (!f || f>d2)) return false;
    return true;
  });
  // De la más nueva a la más vieja
  lista.sort(function(a,b){ return String(_solHechaFecha(b)||'').localeCompare(String(_solHechaFecha(a)||'')); });
  return lista;
}
function _solHechasSetDept(v){ window._solHechasDept=v; rCompletadas(); }
function _solHechasSetFecha(cual, v){
  if(cual==='desde') window._solHechasDesde=v; else window._solHechasHasta=v;
  rCompletadas();
}
function _solHechasLimpiar(){
  window._solHechasDesde=''; window._solHechasHasta=''; window._solHechasDept='todos';
  rCompletadas();
}
function _solHechasSeccion(){
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia')) return '';
  var todas=(window._solPago||[]).filter(function(x){
    return ['abono_enviado','cancelacion_realizada'].indexOf(x.estado)>=0; });
  var lista=_solHechas();
  var totAb=lista.filter(function(x){return x.tipo==='abono';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  var totCa=lista.filter(function(x){return x.tipo==='cancelacion';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);

  // Departamentos que realmente aparecen
  var deps={}; todas.forEach(function(x){ deps[x.dept||'otros']=1; });
  var pills='<span class="pill '+(window._solHechasDept==='todos'?'active':'')+'" onclick="_solHechasSetDept(\'todos\')">Todos</span>'
    +Object.keys(deps).sort().map(function(d){
      return '<span class="pill '+(window._solHechasDept===d?'active':'')+'" onclick="_solHechasSetDept(\''+d+'\')">'
        +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</span>';
    }).join('');

  var inp='padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11.5px;'
    +'background:var(--surface-0);color:var(--text-primary)';
  var h='<div style="border:1px solid #A9DFD0;background:var(--pastel-verde2);border-radius:10px;margin-bottom:14px;overflow:hidden">'
    +'<div style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<i class="ti ti-receipt" style="color:var(--t-verde2)"></i>'
      +'<span style="font-size:12.5px;font-weight:700;color:var(--t-verde2)">Abonos y cancelaciones realizados</span>'
      +'<span style="font-size:11px;color:var(--t-verde2);opacity:.85">'+lista.length+' de '+todas.length
        +' · abonos '+fmt(totAb)+' · cancelaciones '+fmt(totCa)+'</span>'
    +'</div>'
    +'<div style="padding:0 13px 9px;display:flex;gap:7px;align-items:center;flex-wrap:wrap">'
      +'<span style="font-size:10.5px;color:var(--t-verde2);font-weight:600">Desde</span>'
      +'<input type="date" value="'+_esc(window._solHechasDesde||'')+'" style="'+inp+'" '
        +'onchange="_solHechasSetFecha(\'desde\',this.value)">'
      +'<span style="font-size:10.5px;color:var(--t-verde2);font-weight:600">Hasta</span>'
      +'<input type="date" value="'+_esc(window._solHechasHasta||'')+'" style="'+inp+'" '
        +'onchange="_solHechasSetFecha(\'hasta\',this.value)">'
      +((window._solHechasDesde||window._solHechasHasta||window._solHechasDept!=='todos')
        ? '<button class="btn bg2" style="padding:4px 10px;font-size:10.5px" onclick="_solHechasLimpiar()">'
          +'<i class="ti ti-x"></i> Quitar filtros</button>' : '')
    +'</div>'
    +'<div class="filters" style="padding:0 13px 9px;margin:0">'+pills+'</div>';

  if(!lista.length){
    h+='<div style="padding:11px 13px;font-size:11.5px;color:var(--text-muted);border-top:0.5px solid #A9DFD0;background:var(--surface-0)">'
      +(todas.length?'Ningún abono o cancelación con esos filtros.':'Todavía no se envió ningún comprobante a compras.')+'</div>';
    return h+'</div>';
  }

  lista.forEach(function(x){
    var esAb=(x.tipo==='abono');
    var col=esAb?'#166534':'#B45309';
    var quien=_solHechaQuien(x), f=_solHechaFecha(x);
    h+='<div style="border-top:0.5px solid #A9DFD0;padding:9px 13px;background:var(--surface-0);cursor:pointer" '
      +'onclick="_solPagoAbrir(\''+_esc(String(x.docnum||''))+'\')">'
      +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:150px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')
            +' <span style="font-weight:400;color:'+col+';font-size:10.5px">'+(esAb?'Abono':'Cancelación')+'</span></div>'
          +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'+_solRefLinks(x)
            +' · '+_esc(dL(x.dept||''))+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'
            +(quien?('Realizó '+_esc(quien)):'')+(f?(' · '+_esc(_fechaHora(f))):'')
            +(x.solicitado_por?(' · solicitó '+_esc(x.solicitado_por)):'')+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0"><div style="font-size:13px;font-weight:700;color:'+col+'">'
          +fmt(x.monto)+'</div>'
          +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(_solEstadoLabel(x).t)+'</div></div>'
      +'</div></div>';
  });
  return h+'</div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  ÓRDENES COMPLETADAS
//  Aquí caen dos cosas: las que terminaron el recorrido de etapas en el
//  portal, y las que SAP cerró al emitirse la factura reserva. Estas últimas
//  antes desaparecían de todas las pantallas.
//  Mismos filtros que la pantalla de órdenes (buscador, departamento y
//  orden), y corte en diciembre de 2025 para que la lista no se llene de
//  historia vieja.
// ═══════════════════════════════════════════════════════════════════════════
var COMP_DESDE = '2025-12-01';
window._compSort = window._compSort || 'nuevo';
window._compQ = window._compQ || '';

// Buscador propio: el de la pantalla de órdenes vive en su página y compartir
// el mismo estado hacía que buscar en un sitio filtrara el otro sin avisar.
function setCompQ(val){
  window._compQ = val;
  var b=document.getElementById('comp-clear'); if(b) b.style.display = val?'flex':'none';
  rCompletadas();
  var inp=document.getElementById('comp-q');
  if(inp){ inp.focus(); try{ inp.setSelectionRange(inp.value.length, inp.value.length); }catch(e){} }
}
function limpiarCompQ(){ setCompQ(''); }

function _compEnRango(o){
  var d = parseDateStr(o.fechaCreacion);
  if(!d) return true;                       // sin fecha legible, mejor mostrarla
  return d >= new Date(COMP_DESDE+'T00:00:00');
}

function setCompSort(v){ window._compSort=v; rCompletadas(); }

function rCompletadas(d){
  if(!document.getElementById('page-completadas')) return;
  dComp = d || dComp;

  var base = vO().filter(function(o){ return o.completada; }).filter(_compEnRango);
  if(dComp!=='todos' && !_deptAcotado()) base = base.filter(function(o){ return o.dept===dComp; });

  // Los mismos campos que busca la pantalla de órdenes
  var q = (window._compQ||'').toLowerCase().trim();
  if(q) base = base.filter(function(o){
    return o.prov.toLowerCase().includes(q)
        || o.id.toLowerCase().includes(q)
        || (o.desc||'').toLowerCase().includes(q)
        || dL(o.dept).toLowerCase().includes(q)
        || String(o.resp||'').toLowerCase().includes(q)
        || String(o.num_proveedor||'').toLowerCase().includes(q);
  });

  base = base.slice().sort(function(a,b){
    var da=parseDateStr(a.fechaCreacion)||new Date(0),
        db=parseDateStr(b.fechaCreacion)||new Date(0);
    return window._compSort==='nuevo' ? db-da : da-db;
  });

  var t = base.reduce(function(s,o){ return s+o.valor; }, 0);
  var nSap = base.filter(function(o){ return o.cerradaSap; }).length;
  var avD = _deptAcotado() ? ['todos'].concat(_deptsVisibles()) : ['todos'].concat(DEPTS_ALL);

  var _hechas='';
  try{ _hechas=_solHechasSeccion(); }catch(e){ console.warn('abonos realizados:',e); }

  var buscador='<div class="search-wrap" style="margin-bottom:10px">'
    +'<i class="ti ti-search"></i>'
    +'<input id="comp-q" value="'+_esc(window._compQ||'')+'" '
    +'placeholder="Buscar por proveedor, orden, referencia, descripción…" '
    +'oninput="setCompQ(this.value)">'
    +'<button id="comp-clear" onclick="limpiarCompQ()" '
    +'style="display:'+(window._compQ?'flex':'none')+'">'
    +'<i class="ti ti-x"></i></button></div>';

  var orden='<div style="display:flex;gap:6px;align-items:center;margin-bottom:10px;flex-wrap:wrap">'
    +'<span style="font-size:11px;color:var(--text-muted)">Ordenar:</span>'
    +['nuevo','viejo'].map(function(v){
        return '<span onclick="setCompSort(\''+v+'\')" style="padding:3px 10px;border-radius:12px;'
          +'font-size:11px;cursor:pointer;border:0.5px solid '
          +(window._compSort===v?'var(--border-accent);background:var(--bg-accent)':'var(--border)')
          +'">'+(v==='nuevo'?'Más nuevas primero':'Más viejas primero')+'</span>';
      }).join('')
    +'<span style="flex:1"></span>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">'
    +'Desde diciembre de 2025</span></div>';

  var resumen = CU.verCostos
    ? '<div style="display:flex;gap:7px;margin-bottom:10px;flex-wrap:wrap">'
      +'<span style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);'
      +'border:0.5px solid var(--border)">'+base.length+' completadas</span>'
      +'<span style="font-size:12px;background:#F0EEFF;color:var(--t-indigo);padding:4px 10px;'
      +'border-radius:var(--radius);border:0.5px solid var(--border)">'+fmt(t)+' facturado</span>'
      +(nSap?'<span style="font-size:12px;background:var(--pastel-lila);color:var(--t-lila);'
        +'padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)" '
        +'title="SAP las cerró al emitirse la factura reserva">'+nSap+' cerradas en SAP</span>':'')
      +'</div>'
    : '';

  document.getElementById('page-completadas').innerHTML =
    _hechas
    + (avD ? pills2(dComp,'setDComp','pf-comp',avD) : '')
    + buscador
    + orden
    + resumen
    + (base.length
        ? base.map(function(o){ return oCard(o); }).join('')
        : '<div class="empty"><i class="ti ti-circle-check" style="font-size:22px;color:#534AB7"></i>'
          +'<br>No hay completadas'+(q?' que coincidan con la búsqueda':'')+'</div>');
}
function setDComp(el,d){document.querySelectorAll('#pf-comp .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');rCompletadas(d);}
function rPendientes(d){
  if(!document.getElementById('page-pendientes')) return;dP=d||dP;const allP=vO().filter(o=>o.pend);const fil=dP==='todos'?allP:allP.filter(o=>o.dept===dP);const avD=_deptAcotado()?_deptsVisibles():DEPTS_ALL;document.getElementById('page-pendientes').innerHTML=`<div style="font-size:13px;font-weight:500;margin-bottom:4px">${CU.role==='gerencia'?'Para revisar, firmar y aprobar':'Enviadas a gerencia'}</div><div style="font-size:12px;color:var(--text-muted);margin-bottom:10px">${allP.length} pendiente${allP.length!==1?'s':''}</div>${avD?`<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px"><span style="padding:4px 10px;background:${dP==='todos'?'var(--bg-accent)':'var(--surface-1)'};border:0.5px solid ${dP==='todos'?'var(--border-accent)':'var(--border)'};border-radius:14px;font-size:11px;cursor:pointer" onclick="setDP(this,'todos')">Todos <span style="background:var(--bg-danger);color:var(--text-danger);border-radius:10px;padding:1px 6px;font-size:10px;font-weight:500">${allP.length}</span></span>${avD.map(d=>{const c=allP.filter(o=>o.dept===d).length;if(!c)return'';return`<span style="display:inline-flex;align-items:center;gap:4px;padding:4px 10px;background:${dP===d?'var(--bg-accent)':'var(--surface-1)'};border:0.5px solid ${dP===d?'var(--border-accent)':'var(--border)'};border-radius:14px;font-size:11px;cursor:pointer" onclick="setDP(this,'${d}')">${EMOJIS2[d]||''} ${dL(d)} <span style="background:var(--bg-danger);color:var(--text-danger);border-radius:10px;padding:1px 6px;font-size:10px;font-weight:500">${c}</span></span>`;}).join('')}</div>`:''}${fil.length?fil.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-circle-check" style="font-size:24px;color:var(--text-success)"></i><br>Sin pendientes</div>'}`;}
function setDP(el,d){dP=d;rPendientes(d);}
function rContab(d){dC=d||dC;const base=dC==='todos'?orders:orders.filter(o=>o.dept===dC);const depPend=base.filter(o=>{initP(o.id);const sp=stageProgress[o.id];return !o.pend&&!o.completada&&sp.pedido?.stepIdx>=2&&sp.deposito?.stepIdx===0&&!_depositoHecho(o);});const saldoPend=base.filter(o=>{initP(o.id);const sp=stageProgress[o.id];return !o.pend&&!o.completada&&sp.deposito?.stepIdx>=2&&(o.valor-o.abono)>0;});const totDep=depPend.reduce((s,o)=>s+o.valor,0),totSaldo=saldoPend.reduce((s,o)=>s+(o.valor-o.abono),0);const totAbn=base.reduce((s,o)=>s+o.abono,0),totComp=base.reduce((s,o)=>s+o.valor,0);function depRow(o){const p=stageProgress[o.id];const sd=p?.pedido?.stepDates?.[1]||o.fechaCreacion;const dias=daysBetween(sd,null);return`<div class="ocard al" onclick="openDetail('${o.id}')"><div class="oh"><div class="oi">${o.emoji}</div><div class="om"><div class="oc">${o.prov} — ${o.id}</div><div class="od">${dL(o.dept)} · ${o.desc}</div><div style="font-size:11px;color:var(--text-muted);margin-top:1px">Cod proveedor: ${o.resp?`<span onclick="event.stopPropagation();abrirInvProveedor('${String(o.resp).replace(/'/g,'')}')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">${o.resp}</span>`:'—'}${sc&&!o.completada?` &nbsp;·&nbsp; <span style="color:var(--text-danger);font-weight:500">Saldo prov: ${fmt(saldoProv(o.prov))}</span>`:''}</div><div style="display:flex;gap:5px;margin-top:3px;flex-wrap:wrap"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>Aprobada: ${sd}</span>${diasBadge(dias)}</div><div class="achip"><i class="ti ti-alert-triangle" style="font-size:10px"></i>${dias} días sin enviar depósito</div></div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px"><span style="font-size:10px;padding:2px 8px;border-radius:10px;background:#FBEAF0;color:var(--t-vino)">Dep. pendiente</span><span style="font-size:10px;color:var(--text-muted)">${dL(o.dept)}</span></div></div><div class="cr-row"><div><div class="crl">Total orden</div><div class="crv">${fmt(o.valor)}</div></div><div><div class="crl">A depositar (50%)</div><div class="crv kvd">${fmt(Math.round(o.valor*0.5))}</div></div><div><div class="crl">Responsable</div><div class="crv" style="font-size:11px">${o.resp}</div></div></div><div style="padding:0 12px 9px"><div class="pct-bar"><div class="pct-fill" style="width:0%;background:#e24b4a"></div></div></div></div>`;}function saldoRow(o){const saldo=o.valor-o.abono,p=stageProgress[o.id];const dd=p?.deposito?.stepDates?.[1]||'';const dias=dd?daysBetween(dd,null):0;const pp=pct(o.abono,o.valor);return`<div class="ocard ok" onclick="openDetail('${o.id}')"><div class="oh"><div class="oi">${o.emoji}</div><div class="om"><div class="oc">${o.prov} — ${o.id}</div><div class="od">${dL(o.dept)} · ${o.desc}</div><div style="font-size:11px;color:var(--text-muted);margin-top:1px">Cod proveedor: ${o.resp?`<span onclick="event.stopPropagation();abrirInvProveedor('${String(o.resp).replace(/'/g,'')}')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">${o.resp}</span>`:'—'}${sc&&!o.completada?` &nbsp;·&nbsp; <span style="color:var(--text-danger);font-weight:500">Saldo prov: ${fmt(saldoProv(o.prov))}</span>`:''}</div><div style="display:flex;gap:5px;margin-top:3px;flex-wrap:wrap">${dd?`<span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>Dep.: ${dd}</span>`:''}<span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>${o.fechaCreacion}</span></div>${dd?`<div style="font-size:10px;color:var(--text-muted);margin-top:2px">Hace ${dias} días del abono</div>`:''}</div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px"><span style="font-size:10px;padding:2px 8px;border-radius:10px;background:var(--pastel-azul);color:var(--t-azul)">Saldo pend.</span><span style="font-size:10px;color:var(--text-muted)">${dL(o.dept)}</span></div></div><div style="padding:0 12px 4px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;font-size:12px"><div><div class="crl">Total</div><div class="crv">${fmt(o.valor)}</div></div><div><div class="crl">Abonado · ${pp}%</div><div class="crv kvs">${fmt(o.abono)}</div></div><div><div class="crl">Saldo · ${100-pp}%</div><div class="crv kvd">${fmt(saldo)}</div></div></div><div style="padding:0 12px 9px"><div class="pct-bar"><div class="pct-fill" style="width:${pp}%;background:#639922"></div></div></div></div>`;}let mainContent='';if(contabFilter==='all'||contabFilter==='dep'){if(depPend.length)mainContent+=`<div class="slbl" style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i>Depósitos pendientes (${depPend.length}) · ${fmt(totDep)}</div>${depPend.map(depRow).join('')}`;else mainContent+=`<div style="font-size:12px;color:var(--text-muted);padding:8px 0;margin-bottom:8px"><i class="ti ti-circle-check" style="color:var(--text-success)"></i> Sin depósitos pendientes</div>`;}if(contabFilter==='all'||contabFilter==='sal'){if(saldoPend.length)mainContent+=`<div class="slbl" style="color:#BA7517"><i class="ti ti-receipt"></i>Saldos pendientes (${saldoPend.length}) · ${fmt(totSaldo)}</div>${saldoPend.map(saldoRow).join('')}`;else mainContent+=`<div style="font-size:12px;color:var(--text-muted);padding:8px 0"><i class="ti ti-circle-check" style="color:var(--text-success)"></i> Sin saldos pendientes</div>`;}// FIX 6: alerta abonados +6m sin embarcar
  const abnSinEmbarcar=saldoPend.filter(o=>alerta6meses(o));
  let ctKpiPanel='';
  const ctKpiKey=window._ctKpi;
  if(ctKpiKey){
    let ctList=ctKpiKey==='dep'?depPend:ctKpiKey==='sal'?saldoPend:ctKpiKey==='tot'?base:base.filter(o=>o.abono>0);
    const ctColor=ctKpiKey==='dep'?'var(--text-danger)':ctKpiKey==='sal'?'#BA7517':ctKpiKey==='tot'?'var(--text-accent)':'var(--text-success)';
    const ctLabel={dep:'Depósitos pendientes',sal:'Saldos pendientes',tot:'Total en órdenes',abn:'Abonadas'}[ctKpiKey]||'';
    ctKpiPanel=`<div style="background:var(--surface-2);border:0.5px solid var(--border-accent);border-radius:var(--radius);margin-bottom:12px;overflow:hidden"><div style="display:flex;align-items:center;padding:10px 14px;background:var(--bg-accent)"><span style="font-size:13px;font-weight:600;color:${ctColor}">${ctLabel} (${ctList.length})</span><button onclick="window._ctKpi=null;rContab()" style="margin-left:auto;background:none;border:none;font-size:20px;cursor:pointer;color:var(--text-muted)">&times;</button></div>${ctList.map(o=>`<div onclick="openDetail('${o.id}')" style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border);cursor:pointer"><span style="font-size:18px">${o.emoji}</span><div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">${o.prov} — #${o.id}${o.num_proveedor?` - <span style="font-weight:700;color:var(--t-ambar)">${o.num_proveedor}</span>`:''}</div><div style="font-size:10px;color:var(--text-muted)">${dL(o.dept)} · ${o.fechaCreacion}</div>${alerta6meses(o)?'<div style="font-size:10px;color:var(--t-marron);background:var(--pastel-naranja);border-radius:6px;padding:1px 6px;display:inline-block;margin-top:2px"><i class="ti ti-alarm" style="font-size:9px"></i> +6 meses sin embarcar</div>':''}</div><div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">${fmt(o.valor)}</div><div style="font-size:10px;color:var(--text-success)">${fmt(o.abono)} (${pct(o.abono,o.valor)}%)</div><div style="font-size:10px;color:var(--text-danger)">Saldo: ${fmt(o.valor-o.abono)}</div></div></div>`).join('')}</div>`;
  }
  document.getElementById('page-contab').innerHTML=`${pills2(dC,'setDC','pf-ct',['todos',...DEPTS_ALL])}<div class="ctab"><button class="ctab-btn ${contabFilter==='all'?'active-all':''}" onclick="setContabFilter('all')"><i class="ti ti-list"></i>Todo (${depPend.length+saldoPend.length})</button><button class="ctab-btn ${contabFilter==='dep'?'active':''}" onclick="setContabFilter('dep')"><i class="ti ti-alert-triangle"></i>Depósitos pendientes <span style="background:#e24b4a;color:white;border-radius:10px;padding:1px 7px;font-size:10px;margin-left:4px">${depPend.length}</span></button><button class="ctab-btn ${contabFilter==='sal'?'active-warn':''}" onclick="setContabFilter('sal')"><i class="ti ti-receipt"></i>Saldos pendientes <span style="background:#eda100;color:white;border-radius:10px;padding:1px 7px;font-size:10px;margin-left:4px">${saldoPend.length}</span></button></div>
  ${abnSinEmbarcar.length?`<div style="background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:var(--radius);padding:10px 14px;margin-bottom:12px;display:flex;align-items:center;gap:10px"><i class="ti ti-alarm" style="font-size:18px;color:var(--t-marron)"></i><div style="flex:1"><div style="font-size:12px;font-weight:600;color:var(--t-marron)">${abnSinEmbarcar.length} orden${abnSinEmbarcar.length>1?'es':''} abonada${abnSinEmbarcar.length>1?'s':''} con +6 meses sin embarcar</div><div style="font-size:11px;color:var(--t-marron);margin-top:2px">${abnSinEmbarcar.map(o=>`<span onclick="openDetail('${o.id}')" style="cursor:pointer;text-decoration:underline;margin-right:8px">${o.prov} #${o.id}</span>`).join('')}</div></div></div>`:''}
  <div class="kpi-grid">
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='dep'?null:'dep';rContab()" style="cursor:pointer"><div class="kpi-l" style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i>Dep. pendientes</div><div class="kpi-v kvd">${depPend.length}</div><div style="font-size:10px;color:var(--text-danger);margin-top:1px">${fmt(totDep)}</div></div>
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='sal'?null:'sal';rContab()" style="cursor:pointer"><div class="kpi-l" style="color:#BA7517"><i class="ti ti-receipt"></i>Saldos pendientes</div><div class="kpi-v kvw">${saldoPend.length}</div><div style="font-size:10px;color:#BA7517;margin-top:1px">${fmt(totSaldo)}</div></div>
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='tot'?null:'tot';rContab()" style="cursor:pointer"><div class="kpi-l"><i class="ti ti-currency-dollar"></i>Total en órdenes</div><div class="kpi-v">${fmt(totComp)}</div></div>
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='abn'?null:'abn';rContab()" style="cursor:pointer"><div class="kpi-l"><i class="ti ti-coin"></i>Abonado ${pct(totAbn,totComp)}%</div><div class="kpi-v kvs">${fmt(totAbn)}</div></div>
  </div>
  <div style="margin-bottom:12px"><div style="display:flex;justify-content:space-between;font-size:11px;color:var(--text-muted);margin-bottom:3px"><span>Porcentaje pagado total</span><span>${pct(totAbn,totComp)}%</span></div><div class="pct-bar" style="height:7px"><div class="pct-fill" style="width:${pct(totAbn,totComp)}%;background:#639922"></div></div></div>
  ${ctKpiPanel}${mainContent}`;}
function setDC(el,d){document.querySelectorAll('#pf-ct .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');rContab(d);}
function setContabFilter(f){contabFilter=f;rContab(dC);}
function rDeptos(){
  if(!document.getElementById('page-deptos')) return;
  // Esta pantalla leía "orders" directamente, o sea TODOS los departamentos.
  // Con gerencia acotada por departamento (Gady en alfombras, Henry en ropa)
  // eso les mostraba áreas que no les tocan. vO() ya aplica ese filtro y no
  // cambia nada para quien no tiene departamento asignado.
  var orders=vO();
  var gT=orders.reduce(function(s,o){return s+o.valor;},0),gA=orders.reduce(function(s,o){return s+o.abono;},0);

  /* ── PANEL MONTO CLICKEADO ── */
  var montoPanel='';
  if(_dMF&&_dMD){
    var _ml=orders.filter(function(o){return o.dept===_dMD&&(_dMF==='abonado'?o.abono>0:(o.valor-o.abono)>0);});
    var _mc=_dMF==='abonado'?'var(--text-success)':'var(--text-danger)';
    var _mlbl=_dMF==='abonado'?'Abonadas':'Con saldo pendiente';
    montoPanel='<div style="background:var(--surface-2);border:0.5px solid var(--border-accent);border-radius:var(--radius);margin-bottom:14px;overflow:hidden">'
      +'<div style="display:flex;align-items:center;padding:10px 14px;background:var(--bg-accent)">'
      +'<span style="font-size:13px;font-weight:600;color:'+_mc+'">'+dL(_dMD)+' \u2014 '+_mlbl+' ('+_ml.length+')</span>'
      +'<button onclick="_dMF=null;_dMD=null;rDeptos()" style="margin-left:auto;background:none;border:none;font-size:20px;cursor:pointer;color:var(--text-muted)">&times;</button>'
      +'</div>'
      +_ml.map(function(o){
        return '<div onclick="openDetail(\''+o.id+'\')" style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border);cursor:pointer">'
          +'<span style="font-size:18px">'+o.emoji+'</span>'
          +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+o.prov+' \u2014 #'+o.id+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+o.fechaCreacion+(o._estadoSap?' \u00b7 '+o._estadoSap:'')+'</div></div>'
          +(CU.verCostos?'<div style="text-align:right;flex-shrink:0">'
            +'<div style="font-size:11px;color:var(--text-success)">'+fmt(o.abono)+'</div>'
            +'<div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>':'')
          +'</div>';
      }).join('')
      +'</div>';
  }

  /* ── KPIs ── */
  var kpiHtml=CU.verCostos
    ?'<div class="kpi-grid"><div class="kpi"><div class="kpi-l">Total en \u00f3rdenes</div><div class="kpi-v">'+fmt(gT)+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Abonado</div><div class="kpi-v kvs">'+fmt(gA)+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Saldo</div><div class="kpi-v kvd">'+fmt(gT-gA)+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Completadas</div><div class="kpi-v kvs">'+orders.filter(function(o){return o.completada;}).length+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Activas</div><div class="kpi-v kva">'+orders.filter(function(o){return!o.completada;}).length+'</div></div></div>'
    :'<div class="kpi-grid"><div class="kpi"><div class="kpi-l">Total</div><div class="kpi-v kva">'+orders.length+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Activas</div><div class="kpi-v kva">'+orders.filter(function(o){return!o.completada;}).length+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Completadas</div><div class="kpi-v kvs">'+orders.filter(function(o){return o.completada;}).length+'</div></div></div>';

  /* ── TOOLBAR ── */
  var toolbar='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px;align-items:center">'
    +'<div class="search-wrap" style="flex:1;min-width:200px;margin-bottom:0"><i class="ti ti-search search-icon"></i>'
    +'<input class="search-input" id="dSQ-inp" placeholder="Buscar proveedor o n\u00famero de orden..." value="'+_dSQ+'">'
    +(_dSQ?'<button class="search-clear" id="dSQ-clr"><i class="ti ti-x"></i></button>':'')
    +'</div>'
    +'<select id="dSort-sel" style="padding:7px 10px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'
    +'<option value="nuevo"'+(_dSort==='nuevo'?' selected':'')+'>M\u00e1s reciente</option>'
    +'<option value="antiguo"'+(_dSort==='antiguo'?' selected':'')+'>M\u00e1s antiguo</option>'
    +'</select>'
    +'<select id="dEst-sel" style="padding:7px 10px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'
    +'<option value="todos"'+(_dEst==='todos'?' selected':'')+'>Todos los estados</option>'
    +'<option value="confirm"'+(_dEst==='confirm'?' selected':'')+'>Confirmado</option>'
    +'<option value="despach"'+(_dEst==='despach'?' selected':'')+'>Despachado</option>'
    +'<option value="embarcad"'+(_dEst==='embarcad'?' selected':'')+'>Embarcado</option>'
    +'<option value="pendiente"'+(_dEst==='pendiente'?' selected':'')+'>Pendiente</option>'
    +'</select></div>';

  /* ── FILAS POR DEPTO ── */
  var rows=_deptsVisibles().map(function(d){
    var allList=orders.filter(function(o){return o.dept===d;});
    if(!allList.length)return'<div class="dc"><div class="dh" onclick="this.nextElementSibling.classList.toggle(\'open\')" style="display:flex;align-items:center;gap:11px">'
      +_deptIconHTML(d,46)+'<div style="flex:1"><div style="font-size:14px;font-weight:700">'+dL(d)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">Sin \u00f3rdenes</div></div></div>'
      +'<div class="dbody"></div></div>';

    // Filtrar y ordenar
    var fl=allList;
    if(_dSQ.trim()){var q=_dSQ.trim().toLowerCase();fl=fl.filter(function(o){return o.prov.toLowerCase().includes(q)||String(o.id).toLowerCase().includes(q)||(o.desc||'').toLowerCase().includes(q);});}
    if(_dEst!=='todos'){fl=fl.filter(function(o){return(o._estadoSap||'').toLowerCase().includes(_dEst);});}
    fl=fl.slice().sort(function(a,b){var da=parseDateStr(a.fechaCreacion)||new Date(0),db=parseDateStr(b.fechaCreacion)||new Date(0);return _dSort==='nuevo'?db-da:da-db;});

    var tot=allList.reduce(function(s,o){return s+o.valor;},0),abn=allList.reduce(function(s,o){return s+o.abono;},0),sal=tot-abn;
    var act=allList.filter(function(o){return!o.completada;}),comp=allList.filter(function(o){return o.completada;}),pend2=act.filter(function(o){return o.pend;});
    var pp=pct(abn,tot);
    // CAMBIO 5: sumar No SAP
    var _nsL=pendSAPporDept(d);
    var _nsCnt=_nsL.length;
    var _nsTot=_nsL.reduce(function(s,p){return s+(Number(p.total)||0);},0);
    var _nsAbn=_nsL.reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
    tot+=_nsTot; abn+=_nsAbn; sal=tot-abn;
    var ordsConAbn=allList.filter(function(o){initP(o.id);return stageProgress[o.id]&&stageProgress[o.id].deposito&&stageProgress[o.id].deposito.stepDates&&stageProgress[o.id].deposito.stepDates[1];});
    var ultimoAbn=ordsConAbn.length?stageProgress[ordsConAbn[ordsConAbn.length-1].id].deposito.stepDates[1]:'';
    var diasAbn=ultimoAbn?daysBetween(ultimoAbn,null):0;

    // Agrupar proveedores
    var pvMap={};
    fl.forEach(function(o){if(!pvMap[o.prov])pvMap[o.prov]=[];pvMap[o.prov].push(o);});
    var pvKeys=Object.keys(pvMap).sort(function(a,b){return pvMap[b].length-pvMap[a].length;});

    // Tabla de proveedores
    var thCols=CU.verCostos
      ?'<tr style="background:var(--surface-1)"><th style="padding:7px 12px;font-size:10px;font-weight:600;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">Proveedor</th><th style="padding:7px 12px;font-size:10px;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">\u00d3rdenes</th><th style="padding:7px 12px;font-size:10px;color:var(--text-muted);text-align:right;border-bottom:0.5px solid var(--border)">Total</th><th style="padding:7px 12px;font-size:10px;color:var(--text-success);text-align:right;border-bottom:0.5px solid var(--border)">Abonado</th><th style="padding:7px 12px;font-size:10px;color:var(--text-danger);text-align:right;border-bottom:0.5px solid var(--border)">Saldo</th></tr>'
      :'<tr style="background:var(--surface-1)"><th style="padding:7px 12px;font-size:10px;font-weight:600;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">Proveedor</th><th style="padding:7px 12px;font-size:10px;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">\u00d3rdenes</th></tr>';

    var pvRows=pvKeys.map(function(pv){
      var pos=pvMap[pv];
      var pvT=pos.reduce(function(s,o){return s+o.valor;},0),pvA=pos.reduce(function(s,o){return s+o.abono;},0);
      var pvNameCell=pos.length>1
        ?'<span onclick="showProvPanel(\''+encodeURIComponent(pv)+'\')" style="cursor:pointer;display:inline-flex;align-items:center;gap:5px;color:var(--text-accent)">'+pv+'<span style="background:var(--fill-accent);color:white;border-radius:10px;padding:0 7px;font-size:10px;font-weight:700">'+pos.length+'</span></span>'
        :pv;
      var ordCells=pos.map(function(o){
        var ec={confirmado:'#185FA5',despachado:'#1D9E75',embarcado:'#7F77DD',pendiente:'#BA7517'}[(o._estadoSap||'').toLowerCase()]||'var(--text-muted)';
        return'<span onclick="openDetail(\''+o.id+'\')" style="display:inline-flex;align-items:center;gap:4px;margin:2px;padding:3px 8px;border-radius:6px;background:var(--surface-0);border:0.5px solid var(--border);cursor:pointer;font-size:10px;white-space:nowrap">'
          +o.emoji+' #'+o.id
          // DKC del proveedor (Vendor Ref No de SAP)
          +(o.num_proveedor?'<span style="color:var(--t-ambar);font-weight:700"> - '+_esc(o.num_proveedor)+'</span>':'')
          +(o._estadoSap?'<span style="color:'+ec+'"> \u00b7 '+o._estadoSap+'</span>':'')
          +(CU.verCostos?(
              '<span style="color:var(--text-muted)">Total </span><span style="font-weight:700">'+fmt(o.valor)+'</span>'
             +'<span style="color:var(--text-muted)"> · Abonado </span><span style="font-weight:700;color:var(--text-success)">'+fmt(o.abono)+'</span>'
             +'<span style="color:var(--text-muted)"> · Saldo </span><span style="font-weight:700;color:var(--text-danger)">'+fmt(o.valor-o.abono)+'</span>'
            ):'')
          +'<span style="color:var(--text-muted)"> '+o.fechaCreacion+'</span>'
          +'</span>';
      }).join('');
      return'<tr style="border-bottom:0.5px solid var(--border)">'
        +'<td style="padding:8px 12px;font-size:12px;font-weight:500;white-space:nowrap;vertical-align:middle">'+pvNameCell+'</td>'
        +'<td style="padding:8px 12px;vertical-align:middle">'+ordCells+'</td>'
        +(CU.verCostos
          ?'<td style="padding:8px 12px;font-size:11px;text-align:right;white-space:nowrap;vertical-align:middle;font-weight:500">'+fmt(pvT)+'</td>'
           +'<td style="padding:8px 12px;font-size:11px;text-align:right;white-space:nowrap;vertical-align:middle;color:var(--text-success)">'+fmt(pvA)+'</td>'
           +'<td style="padding:8px 12px;font-size:11px;text-align:right;white-space:nowrap;vertical-align:middle;color:var(--text-danger)">'+fmt(pvT-pvA)+'</td>'
          :'')
        +'</tr>';
    }).join('');

    // Stats en línea
    var statsLine='<div style="display:flex;gap:16px;flex-wrap:wrap;padding:8px 0 10px;border-bottom:0.5px solid var(--border);margin-bottom:10px">'
      +'<span style="font-size:11px"><strong style="color:var(--text-accent)">'+act.length+'</strong> activas</span>'
      +'<span style="font-size:11px"><strong style="color:var(--text-success)">'+comp.length+'</strong> completadas</span>'
      +(pend2.length?'<span style="font-size:11px"><strong style="color:#BA7517">'+pend2.length+'</strong> sin firmar</span>':'')
      +(CU.verCostos
        ?'<span onclick="_dMF=\'abonado\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;cursor:pointer;color:var(--text-success);text-decoration:underline"><strong>'+fmt(abn)+'</strong> abonado ('+pp+'%)</span>'
         +'<span onclick="_dMF=\'saldo\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;cursor:pointer;color:var(--text-danger);text-decoration:underline"><strong>'+fmt(sal)+'</strong> saldo</span>'
         +(ultimoAbn?'<span style="font-size:11px;color:var(--text-muted)">Último abono: '+ultimoAbn+' ('+diasAbn+'d)</span>':'')
        :'')
      +'</div>';

    return'<div class="dc" data-dept="'+d+'">'
      +'<div class="dh" onclick="this.nextElementSibling.classList.toggle(\'open\')" style="display:flex;align-items:center;gap:11px">'
      +_deptIconHTML(d,50)+'<div style="flex:1"><div style="font-size:15px;font-weight:700">'+dL(d)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+(allList.length+_nsCnt)+' total \u00b7 '+comp.length+' comp. \u00b7 '+act.length+' activas'+(_nsCnt?' \u00b7 <span style="color:var(--t-ambar);font-weight:600">+'+_nsCnt+' Borrador</span>':'')+(fl.length!==allList.length?' \u00b7 <strong>'+fl.length+' con filtro</strong>':'')+'</div></div>'
      +(CU.verCostos
        ?'<div style="text-align:right">'
          +'<div style="font-size:14px;font-weight:500;color:var(--text-accent)">'+fmt(tot)+'</div>'
          +'<div style="display:flex;gap:10px;margin-top:2px;justify-content:flex-end">'
          +'<span onclick="event.stopPropagation();_dMF=\'abonado\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;color:var(--text-success);cursor:pointer;text-decoration:underline">'+fmt(abn)+'</span>'
          +'<span onclick="event.stopPropagation();_dMF=\'saldo\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;color:var(--text-danger);cursor:pointer;text-decoration:underline">Saldo: '+fmt(sal)+'</span>'
          +'</div></div>'
        :'<div style="font-size:14px;font-weight:500;color:var(--text-accent)">'+allList.length+' \u00f3rdenes</div>')
      +'</div>'
      +'<div class="dbody">'
      +statsLine
            +(fl.length||_nsCnt
        ?'<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse"><thead>'+thCols+'</thead><tbody>'+pvRows+_nsapDeptoRows(d)+'</tbody></table></div>'
        :'<div style="font-size:12px;color:var(--text-muted);padding:10px 0">Sin resultados para este filtro.</div>')
      +'</div></div>';
  }).join('');

  document.getElementById('page-deptos').innerHTML=kpiHtml+montoPanel+toolbar
    
    +'<div class="slbl">Toca un departamento para ver el desglose</div>'+rows;

  // Si se llegó desde el dashboard con un departamento elegido, abrirlo y
  // desplazarse hasta él automáticamente (muestra el listado completo del depto).
  if(_deptoAutoAbrir){
    var _da=_deptoAutoAbrir; _deptoAutoAbrir=null;
    setTimeout(function(){
      var card=document.querySelector('#page-deptos .dc[data-dept="'+_da+'"]');
      if(card){
        var body=card.querySelector('.dbody');
        if(body) body.classList.add('open');
        card.scrollIntoView({behavior:'smooth',block:'start'});
      }
    },50);
  }

  // Eventos del toolbar — se adjuntan DESPUÉS de renderizar
  var _inp=document.getElementById('dSQ-inp');
  var _clr=document.getElementById('dSQ-clr');
  var _ss=document.getElementById('dSort-sel');
  var _es=document.getElementById('dEst-sel');
  if(_inp){_inp.addEventListener('input',function(){_dSQ=this.value;rDeptos();var me=document.getElementById('dSQ-inp');if(me){me.focus();me.setSelectionRange(me.value.length,me.value.length);}});}
  if(_clr){_clr.addEventListener('click',function(){_dSQ='';rDeptos();});}
  if(_ss){_ss.addEventListener('change',function(){_dSort=this.value;rDeptos();});}
  if(_es){_es.addEventListener('change',function(){_dEst=this.value;rDeptos();});}
}

// Panel lateral proveedor
function showProvPanel(provEnc){
  var prov=decodeURIComponent(provEnc);
  var ex=document.getElementById('prov-panel');
  if(ex&&ex.dataset.prov===prov){ex.remove();return;}
  if(ex)ex.remove();
  var lista=orders.filter(function(o){return o.prov===prov;}).sort(function(a,b){var da=parseDateStr(a.fechaCreacion)||new Date(0),db=parseDateStr(b.fechaCreacion)||new Date(0);return db-da;});
  var panel=document.createElement('div');panel.id='prov-panel';panel.dataset.prov=prov;
  panel.style.cssText='position:fixed;top:0;right:0;width:min(480px,40vw);height:100vh;background:var(--surface-2);border-left:1px solid var(--border);z-index:250;overflow-y:auto;box-shadow:-6px 0 24px rgba(0,0,0,.18)';
  var ptot=lista.reduce(function(s,o){return s+o.valor;},0),pabn=lista.reduce(function(s,o){return s+o.abono;},0);
  var hdr=document.createElement('div');hdr.style.cssText='position:sticky;top:0;z-index:2;padding:14px 16px;border-bottom:0.5px solid var(--border);background:var(--surface-1);display:flex;align-items:center;gap:10px';
  hdr.innerHTML='<i class="ti ti-building-store" style="color:var(--text-accent);font-size:16px"></i><div style="flex:1;min-width:0"><div style="font-size:14px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+prov+'</div><div style="font-size:11px;color:var(--text-muted)">'+lista.length+' orden'+(lista.length!==1?'es':'')+'</div></div>';
  var cb=document.createElement('button');cb.innerHTML='&times;';cb.style.cssText='background:none;border:none;font-size:24px;cursor:pointer;color:var(--text-muted);line-height:1';cb.onclick=function(){panel.remove();};hdr.appendChild(cb);panel.appendChild(hdr);
  var body=document.createElement('div');body.style.cssText='padding:14px';
  if(CU.verCostos){var kg=document.createElement('div');kg.style.cssText='display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:14px';kg.innerHTML='<div style="background:var(--surface-1);border-radius:var(--radius);padding:10px;text-align:center"><div style="font-size:9px;color:var(--text-muted);margin-bottom:3px">TOTAL</div><div style="font-size:13px;font-weight:600">'+fmt(ptot)+'</div></div><div style="background:var(--bg-success);border-radius:var(--radius);padding:10px;text-align:center"><div style="font-size:9px;color:var(--text-success);margin-bottom:3px">ABONADO</div><div style="font-size:13px;font-weight:600;color:var(--text-success)">'+fmt(pabn)+'</div></div><div style="background:var(--bg-danger);border-radius:var(--radius);padding:10px;text-align:center"><div style="font-size:9px;color:var(--text-danger);margin-bottom:3px">SALDO</div><div style="font-size:13px;font-weight:600;color:var(--text-danger)">'+fmt(ptot-pabn)+'</div></div>';body.appendChild(kg);}
  lista.forEach(function(o){
    var card=document.createElement('div');card.style.cssText='background:var(--surface-1);border:0.5px solid var(--border);border-radius:9px;margin-bottom:9px;padding:12px 14px;cursor:pointer';
    card.onmouseenter=function(){this.style.borderColor='var(--border-accent)';};card.onmouseleave=function(){this.style.borderColor='var(--border)';};
    card.onclick=function(){panel.remove();openDetail(o.id);};
    var ec={confirmado:'#185FA5',despachado:'#1D9E75',embarcado:'#7F77DD',pendiente:'#BA7517'}[(o._estadoSap||'').toLowerCase()]||'var(--text-muted)';
    card.innerHTML='<div style="display:flex;align-items:flex-start;gap:10px"><span style="font-size:22px;line-height:1">'+o.emoji+'</span>'
      +'<div style="flex:1;min-width:0"><div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap"><span style="font-size:13px;font-weight:600">#'+o.id+'</span><span style="font-size:11px;color:var(--text-muted)">'+dL(o.dept)+'</span>'
      +(o._estadoSap?'<span style="font-size:10px;padding:2px 8px;border-radius:8px;background:'+ec+'22;color:'+ec+'">'+o._estadoSap+'</span>':'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px">'+(o.desc||'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+o.fechaCreacion+(o.fechaEst?' \u00b7 ETA: '+o.fechaEst:'')+'</div>'
      +(CU.verCostos?'<div style="display:flex;gap:12px;margin-top:7px;font-size:12px"><span>'+fmt(o.valor)+'</span><span style="color:var(--text-success)">'+fmt(o.abono)+' \u00b7 '+pct(o.abono,o.valor)+'%</span><span style="color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</span></div>':'')
      +'</div><i class="ti ti-chevron-right" style="font-size:14px;color:var(--text-muted);margin-top:4px"></i></div>';
    body.appendChild(card);
  });
  panel.appendChild(body);document.body.appendChild(panel);
}


// Detecta si una orden tiene actividad de arte (adjuntos o pasos hechos en la etapa artes)
function tieneAdjuntoArte(oid){
  // ¿Hay algún adjunto en la etapa de artes (general o en cualquier sub-paso)?
  if(window._atts){
    for(var k in window._atts){
      if(k.indexOf(oid+'artes')===0 && window._atts[k] && window._atts[k].length) return true;
    }
  }
  return false;
}
function tieneActividadArte(oid){ return tieneAdjuntoArte(oid); }
// La marca del estado del arte en la tarjeta. Solo para diseño y gerencia:
// al resto no le aporta y ensucia la ficha.
function _arteBadge(o){
  if(!CU || (CU.role!=='diseno' && CU.role!=='gerencia')) return '';
  if(o.pend || o.completada) return '';
  if(_arteCompleta(o))
    return '<span class="fecha-badge" style="background:var(--pastel-ok);'
      +'color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check" style="font-size:10px"></i>Arte terminado</span>';
  if(_arteEnProceso(o))
    return '<span class="fecha-badge" style="background:var(--pastel-azul);'
      +'color:var(--t-azul);font-weight:600">'
      +'<i class="ti ti-palette" style="font-size:10px"></i>Arte en proceso</span>';
  return '<span class="fecha-badge" style="background:var(--pastel-aviso);'
    +'color:var(--t-ambar);font-weight:600">'
    +'<i class="ti ti-clock" style="font-size:10px"></i>Arte pendiente</span>';
}

// ── ¿Está terminada la etapa de artes de esta orden? ──
// Antes se miraba solo si había un arte adjunto, y eso no dice si la etapa
// se cerró: una orden podía tener el semáforo en verde y seguir contando
// como pendiente para diseño. Ahora manda el avance de la etapa.
function _arteCompleta(o){
  try{
    initP(o.id);
    var sp=stageProgress[o.id];
    var et=STAGES.find(function(x){ return x.key==='artes'; });
    if(!sp || !sp.artes || !et) return false;
    return sp.artes.stepIdx >= et.steps.length;
  }catch(e){ return false; }
}

// Empezada pero sin cerrar: algún paso hecho, o algún arte adjunto
function _arteEnProceso(o){
  if(_arteCompleta(o)) return false;
  try{
    initP(o.id);
    var sp=stageProgress[o.id];
    if(sp && sp.artes && sp.artes.stepIdx>0) return true;
  }catch(e){}
  return tieneAdjuntoArte(o.id);
}

window._mtEstado = window._mtEstado || 'pendientes';
window._mtOrden  = window._mtOrden  || 'nuevo';
window._mtQ      = window._mtQ      || '';

function _mtSetEstado(v){ window._mtEstado=v; rMiTarea(); }
function _mtSetOrden(v){ window._mtOrden=v; rMiTarea(); }
function _mtBuscar(v){
  window._mtQ=String(v||'');
  rMiTarea();
  // Al repintar se perdía el foco y había que volver a pulsar en la casilla
  // por cada letra. Se devuelve el foco con el cursor al final.
  var el=document.getElementById('mt-q');
  if(el){
    el.focus();
    try{ el.setSelectionRange(el.value.length, el.value.length); }catch(e){}
  }
}

// Diseño no interviene en el pedido: su recorrido empieza en Artes.
function _etapasVisibles(){
  if(CU && CU.role==='diseno'){
    return STAGES.filter(function(st){ return st.key!=='pedido'; });
  }
  return STAGES;
}

function rMiTarea(d){dMT=d||dMT;
  if(CU.role==='diseno'){
    var enArtes=vO().filter(function(o){return !o.pend&&!o.completada;});
    if(dMT!=='todos')enArtes=enArtes.filter(function(o){return o.dept===dMT;});

    var completas =enArtes.filter(_arteCompleta);
    var enProceso =enArtes.filter(_arteEnProceso);
    var pendientes=enArtes.filter(function(o){
      return !_arteCompleta(o) && !_arteEnProceso(o); });

    // Lo que se muestra según la pastilla elegida
    var est=window._mtEstado||'pendientes';
    var lista = est==='todas'      ? enArtes
              : est==='proceso'    ? enProceso
              : est==='completas'  ? completas
              : pendientes;

    // Buscador: proveedor, orden, referencia o descripción
    var q=String(window._mtQ||'').toLowerCase().trim();
    if(q){
      lista=lista.filter(function(o){
        return String(o.prov||'').toLowerCase().indexOf(q)>=0
            || String(o.id||'').toLowerCase().indexOf(q)>=0
            || String(o.ref||'').toLowerCase().indexOf(q)>=0
            || String(o.desc||'').toLowerCase().indexOf(q)>=0
            || String(dL(o.dept||'')).toLowerCase().indexOf(q)>=0;
      });
    }

    lista=lista.slice().sort(function(a,b){
      var da=parseDateStr(a.fechaCreacion)||new Date(0);
      var db=parseDateStr(b.fechaCreacion)||new Date(0);
      return window._mtOrden==='viejo' ? da-db : db-da;
    });

    var pastilla=function(k,t,n,col){
      var on=(est===k);
      return '<span onclick="_mtSetEstado(\''+k+'\')" style="cursor:pointer;'
        +'border:1px solid '+(on?col:'var(--border)')+';background:'+(on?col:'var(--surface-0)')
        +';color:'+(on?'#fff':col)+';border-radius:20px;padding:4px 12px;font-size:11px;'
        +'font-weight:600;white-space:nowrap">'+t+' <span style="opacity:.85">'+n+'</span></span>';
    };

    document.getElementById('page-mistarea').innerHTML=
      pills2(dMT,'setDMT','pf-mt',['todos',...DEPTS_ALL])

      +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin:8px 0">'
        +'<input id="mt-q" value="'+_esc(window._mtQ||'')+'" '
        +'placeholder="Buscar proveedor, orden, DKC o descripción…" '
        +'oninput="clearTimeout(window._mtT);window._mtT=setTimeout(function(){_mtBuscar(document.getElementById(\'mt-q\').value)},300)" '
        +'style="flex:1;min-width:230px;padding:7px 11px;border:1px solid var(--border);'
        +'border-radius:8px;font-size:12px;font-family:var(--font-sans);'
        +'background:var(--surface-2);color:var(--text-primary)">'
        +'<select onchange="_mtSetOrden(this.value)" style="padding:7px 9px;border-radius:8px;'
        +'border:1px solid var(--border);font-size:11.5px;background:var(--surface-2);'
        +'color:var(--text-primary);cursor:pointer">'
          +'<option value="nuevo"'+(window._mtOrden==='nuevo'?' selected':'')+'>Más reciente primero</option>'
          +'<option value="viejo"'+(window._mtOrden==='viejo'?' selected':'')+'>Más antigua primero</option>'
        +'</select>'
      +'</div>'

      +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px">'
        + pastilla('pendientes','Pendientes', pendientes.length, '#B45309')
        + pastilla('proceso','En proceso',    enProceso.length,  '#0c447c')
        + pastilla('completas','Terminados',  completas.length,  '#166534')
        + pastilla('todas','Todas',           enArtes.length,    '#5B21B6')
      +'</div>'

      +'<div class="slbl">'+
        (est==='completas' ? '<i class="ti ti-circle-check" style="color:var(--t-verde)"></i>Artes terminados'
        : est==='proceso'  ? '<i class="ti ti-palette"></i>Artes en proceso'
        : est==='todas'    ? '<i class="ti ti-list"></i>Todas las órdenes en artes'
        : '<i class="ti ti-clock" style="color:var(--t-ambar)"></i>Artes pendientes')
        +' ('+lista.length+')'
        +(q?(' <span style="font-weight:400;color:var(--text-muted)">· filtrado por "'+_esc(q)+'"</span>'):'')
      +'</div>'
      +(lista.length
        ? lista.map(function(o){ return oCard(o); }).join('')
        : '<div class="empty">'+(q?'Sin resultados para esa búsqueda'
            : est==='completas' ? 'Todavía no hay artes terminados'
            : est==='proceso'   ? 'No hay artes empezados'
            : 'No hay artes pendientes')+'</div>');
    return;
  }
  let targetS=[];if(CU.role==='importacion')targetS=[4,5];else if(CU.role==='bodega')targetS=[6];const my=vO().filter(o=>!o.pend&&!o.completada&&targetS.includes(getStageIdx(o)));const fil=dMT==='todos'?my:my.filter(o=>o.dept===dMT);const lbl=CU.role==='importacion'?'Embarques y Nacionalización':CU.role==='bodega'?'Órdenes en Bodega':'Mis artes';const ico=CU.role==='importacion'?'ti-ship':CU.role==='bodega'?'ti-building-warehouse':'ti-palette';document.getElementById('page-mistarea').innerHTML=`${pills2(dMT,'setDMT','pf-mt',['todos',...DEPTS_ALL])}<div class="slbl"><i class="ti ${ico}"></i>${lbl} (${fil.length})</div>${fil.length?fil.map(o=>oCard(o)).join(''):'<div class="empty">Sin órdenes en tu área</div>'}`;}
function setDMT(el,d){document.querySelectorAll('#pf-mt .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');rMiTarea(d);}
/* v746: ¿el depósito de la orden ya se hizo? El aviso «Depósito pendiente»
   miraba solo los pasos del portal, y si el depósito se registró en SAP (el
   abono de la orden) o la solicitud se pagó, seguía saliendo durante meses. */
function _depositoHecho(o){
  if(!o) return false;
  if((Number(o.abono)||0) > 0) return true;
  if(o.fechaAbono && String(o.fechaAbono).trim() && String(o.fechaAbono).trim()!=='—') return true;
  try{
    var sp=(window._solPago||[]);
    if(sp.some(function(x){ return String(x.docnum)===String(o.id) && x.tipo==='abono'
                             && (typeof _solPagadaYa==='function' ? _solPagadaYa(x) : !!x.pagado_en); })) return true;
  }catch(e){}
  return false;
}
// ¿La orden ya salió del proveedor? Entonces los artes, si faltan en el
// portal, ya no son lo que la detiene: no se avisa.
function _ordenYaEmbarcada(o){
  return !!(o && (String(o.booking||'').trim() || String(o.contenedor||'').trim() || String(o.num_contenedor_campo||'').trim()
                 || String(o.barco||'').trim()));
}

function buildAlerts(){const vo=vO();let alerts=[];vo.filter(o=>o.alerta).forEach(o=>{alerts.push({type:'orden',o,msg:o.alertaMsg,color:'#e24b4a',responsable:o.resp,dept:o.dept,oid:o.id,role:STAGES[getStageIdx(o)]?.alertRole||'compras'});});vo.filter(o=>{initP(o.id);const sp=stageProgress[o.id];return !o.pend&&!o.completada&&sp.pedido?.stepIdx>=2&&sp.deposito?.stepIdx===0&&!_depositoHecho(o);}).filter(o=>!o.alerta).forEach(o=>{alerts.push({type:'deposito',o,msg:`Depósito pendiente — ${daysBetween(stageProgress[o.id]?.pedido?.stepDates?.[1]||o.fechaCreacion,null)} días sin enviar`,color:'#e24b4a',responsable:USERS.find(u=>u.role==='contabilidad')?.name||'Contabilidad',dept:o.dept,oid:o.id,role:'contabilidad'});});vo.filter(o=>{initP(o.id);return !o.pend&&getStageIdx(o)===2&&stageProgress[o.id]?.artes?.stepIdx===2;}).forEach(o=>{alerts.push({type:'artes',o,msg:`Artes esperando aprobación — ${daysBetween(stageProgress[o.id]?.artes?.stepDates?.[1]||'',null)} días`,color:'#eda100',responsable:'Gerencia',dept:o.dept,oid:o.id,role:'gerencia'});});vo.filter(o=>!o.pend&&!o.completada&&costeoData[o.id]?.status==='uploaded').forEach(o=>{alerts.push({type:'costeo',o,msg:'📊 Costeo subido — abrir para poner precios de venta',color:'#7C3D12',responsable:'Gerencia',dept:o.dept,oid:o.id,role:'gerencia'});});
  // Diseño: órdenes aprobadas/firmadas con +30 días sin tener los artes aprobados
  vo.filter(o=>{initP(o.id);const sp=stageProgress[o.id];if(o.pend||o.completada)return false;var firmada=sp.pedido&&sp.pedido.stepIdx>=2;if(!firmada)return false;var artesAprob=sp.artes&&sp.artes.stepIdx>=3;if(artesAprob)return false;if(_ordenYaEmbarcada(o))return false;var fechaFirma=(sp.pedido&&sp.pedido.stepDates&&sp.pedido.stepDates[1])||o.fechaCreacion;var dias=daysBetween(fechaFirma,null);return dias>30;}).forEach(o=>{initP(o.id);var sp=stageProgress[o.id];var fechaFirma=(sp.pedido&&sp.pedido.stepDates&&sp.pedido.stepDates[1])||o.fechaCreacion;var dias=daysBetween(fechaFirma,null);alerts.push({type:'artes_atrasado',o,msg:`Firmada hace ${dias} días sin artes aprobados`,color:'#e24b4a',responsable:'Diseño',dept:o.dept,oid:o.id,role:'diseno'});});
  // Punto 5: comentarios de gerencia pendientes de leer para el usuario actual
  if(window._comPend&&CU){var _vistos={};vo.forEach(function(o){var k=o.id;if(_vistos[k])return;if(tieneComPendiente(o.id)){_vistos[k]=1;alerts.push({type:'comentario',o:o,msg:'Tienes un comentario de gerencia por leer',color:'#7F77DD',responsable:CU.name,dept:o.dept,oid:o.id,role:CU.role});}});}
  // Punto 3: contenedores atrasados (ETA de llegada cumplida pero sin confirmar arribo)
  vo.filter(function(o){
    if(o.pend||o.completada) return false;
    if(typeof getBK!=='function') return false;
    var bk=getBK(o.id);
    if(!bk||!bk.containers||!bk.containers.length) return false;
    var lg=(typeof getLlegada==='function')?getLlegada(o.id):{confirmado:false};
    if(lg.confirmado) return false;
    var hoy=new Date(); hoy.setHours(0,0,0,0);
    var fechas=bk.containers.map(function(c){return c.etaLlegada?new Date(c.etaLlegada):null;}).filter(Boolean);
    if(!fechas.length) return false;
    var etaMax=new Date(Math.max.apply(null,fechas));
    return hoy>new Date(etaMax.getFullYear(),etaMax.getMonth(),etaMax.getDate());
  }).forEach(function(o){
    var bk=getBK(o.id);
    var fechas=bk.containers.map(function(c){return c.etaLlegada?new Date(c.etaLlegada):null;}).filter(Boolean);
    var etaMax=new Date(Math.max.apply(null,fechas));
    var dias=daysBetween(etaMax.toISOString().slice(0,10),null);
    alerts.push({type:'atraso_llegada',o:o,msg:'Contenedor atrasado — '+dias+' días desde la ETA sin confirmar arribo',color:'#e24b4a',responsable:'Importación',dept:o.dept,oid:o.id,role:'importacion'});
  });
  return alerts;}
function rAlertas(){
  if(!document.getElementById('page-alertas')) return;
  // Contabilidad ve arriba las solicitudes que le mandó compras
  if(CU && (CU.role==='contabilidad'||CU.role==='gerencia'||_esCompras())){
    if(!window._solPagoListo){
      window._solPagoListo=true;
      _solPagoCargar(true).then(function(){ try{ rAlertas(); }catch(e){} });
    }
    // El refresco se dispara al ENTRAR a la pantalla (desde go), no aquí:
    // llamarlo en cada render creaba un bucle que repintaba sin parar y no
    // dejaba escribir en los comentarios.
  }
  const allAlerts=buildAlerts();let visible=(CU.role==='gerencia'||CU.role==='contabilidad')?allAlerts:allAlerts.filter(a=>a.role===CU.role||(_deptAcotado()&&_deptPermitido(a.dept)));if(dAdept!=='todos')visible=visible.filter(a=>a.dept===dAdept);if(dAuser!=='todos')visible=visible.filter(a=>a.responsable===dAuser||a.role===dAuser);const uniqueRoles=[...new Set(allAlerts.map(a=>a.role))];const uniqueDepts=[...new Set(allAlerts.map(a=>a.dept))].filter(Boolean);let _solHTML='';
  // El panel de menciones va AL FINAL de la pantalla, debajo de las alertas
  // operativas: es un aviso de lectura, no algo que haya que trabajar.
  // Se arma aparte porque antes las líneas de abajo lo pisaban con "=" y no
  // se llegaba a ver nunca.
  var _menHTML='';
  try{ _menHTML=_menPanel(); window._alHTML_men=_menHTML; }catch(e){ console.warn('panel menciones:',e); }

  if(CU && (CU.role==='contabilidad'||CU.role==='gerencia')){
    try{
      window._alHTML_solbarra=_solPagoBarraDept();
      window._alHTML_sol_abono=_solPagoSeccion('abono','Solicitudes de depósito (abono)','ti ti-coin','#166534','#dcfce7','#16a34a');
      window._alHTML_sol_canc=_solPagoSeccion('cancelacion','Solicitud de cancelación','ti ti-file-invoice','#B45309','#FEF9F3','#E9C08A');
      _solHTML=window._alHTML_solbarra+window._alHTML_sol_abono+window._alHTML_sol_canc;
    }catch(e){ console.warn('solicitudes:',e); }
  } else if(CU && _esCompras()){
    try{
      _solHTML=_solPagoMisSeccion();
      window._alHTML_sol_abono=_solHTML;
      window._alHTML_sol_canc='';
    }catch(e){ console.warn('mis solicitudes:',e); }
  }
  // Seguimiento de abonos: para gerencia y compras, arriba de todo
  var _segHTML='';
  try{ _segHTML=_segPanel(); window._alHTML_seg=_segHTML; }catch(e){ console.warn('seguimiento:',e); }

  // Gerencia: el listado de lo que espera una acción, por departamento
  var _pgHTML='';
  try{ _pgHTML=_pgPanel(); window._alHTML_pg=_pgHTML; }catch(e){ console.warn('pendientes gerencia:',e); }

  // Reclamos a proveedores, por departamento
  var _reclHTML='';
  try{ _reclHTML=_reclPanel(); window._alHTML_recl=_reclHTML; }catch(e){ console.warn('reclamos:',e); }

  _solHTML=_pgHTML+_reclHTML+_segHTML+_solHTML;
  // Las menciones van ARRIBA: un costeo recién enviado o un @ en un paso
  // hay que verlos al entrar, no al final de la pantalla.
  // Los bloques ya no se apilan encima: cada uno es una sección de la
  // vista elegida, con su color y su número.
  window._alHTML_barraSol=window._alHTML_solbarra||'';
  document.getElementById('page-alertas').innerHTML=`<div style="font-size:13px;font-weight:500;margin-bottom:8px">${CU.role==='contabilidad'?'Otras alertas operativas':'Alertas'} — ${visible.filter(a=>!_alEsLeida(a)).length} sin leer de ${visible.length}</div><div style="margin-bottom:8px"><div style="font-size:11px;color:var(--text-muted);margin-bottom:5px;font-weight:500">Filtrar por departamento:</div><div style="display:flex;gap:5px;flex-wrap:wrap">${['todos',...uniqueDepts].map(d=>`<span class="pill ${dAdept===d?'active':''}" onclick="setAlDept('${d}')">${dL(d)}</span>`).join('')}</div></div>${CU.role==='contabilidad'?'':`<div style="margin-bottom:12px"><div style="font-size:11px;color:var(--text-muted);margin-bottom:5px;font-weight:500">Filtrar por responsable:</div><div style="display:flex;gap:5px;flex-wrap:wrap"><span class="pill ${dAuser==='todos'?'active':''}" onclick="setAlUser('todos')">Todos</span>${uniqueRoles.map(r=>{const label={compras:'Compras',contabilidad:'Contabilidad',diseno:'Diseño',gerencia:'Gerencia',importacion:'Importación',bodega:'Bodega'}[r]||r;return`<span class="pill ${dAuser===r?'active':''}" onclick="setAlUser('${r}')">${label}</span>`;}).join('')}</div></div>`}${_alBandeja(visible)}${_menHTML?`<div style="margin-top:14px">${_menHTML}</div>`:''}`;}
// ═══════════════════════════════════════════════════════════════════════════
//  REPOSICIONES  (restock por proveedor -> PDF con formato SAP)
// ═══════════════════════════════════════════════════════════════════════════
function _esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
var _repProv=[];          // catálogo de proveedores {cardcode,cardname,n_items}
var _repData=null;        // datos del último proveedor consultado
var _repCard='';          // cardcode consultado
var _repCarrito={};       // {itemcode: cantidad} — items seleccionados para restock
var _repImgCache={};      // {itemcode: dataURL} — fotos precargadas para PDF/Excel
var _repMailFiles=[];     // [File] — PDF y Excel generados, para compartir/adjuntar
var _repRutaCompras={ edy:['lorena','sherene'], jimmy:['edgardo'], itay:['yagizel'], henry:['yagizel'], samuel:['lorena','sherene','edy'], gady:['eimy'], ariel:['zeida'], eli:['ariel','zeida'] };
// ═══════════════════════════════════════════════════════════════════════════
//  EQUIPO POR DEPARTAMENTO
//  Las personas del mismo rol y departamento comparten todo: órdenes, pedidos
//  guardados, compras para firma, reposiciones. Sherene ve exactamente lo mismo
//  que Lorena (ambas Compras · Hogar), pero con su propio usuario y su firma.
//  Gerencia no tiene equipo: ve todo.
// ═══════════════════════════════════════════════════════════════════════════
function _equipo(){
  if(!CU) return [];
  // Gerencia SIN departamento ve todo y no tiene equipo.
  // Gerencia CON departamento (Gady en alfombras, Henry en ropa) tiene los
  // mismos permisos que gerencia, pero solo sobre su área: su equipo son
  // todos los que trabajan ese departamento, sea cual sea su rol.
  if(CU.role==='gerencia'){
    if(!_deptAcotado()) return [];             // vacío = sin restricción
    return (USERS||[]).filter(function(u){
      return (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()));
    });
  }
  return (USERS||[]).filter(function(u){
    return u.role===CU.role && (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()));
  });
}
function _equipoIds(){ return _equipo().map(function(u){ return u.id; }); }
function _equipoEmails(){ return _equipo().map(function(u){ return (u.email||'').toLowerCase(); }).filter(Boolean); }
// ¿Este registro es de alguien de mi equipo? (para permisos de editar/borrar)
function _esDeMiEquipo(id){
  var ids=_equipoIds();
  if(!ids.length) return true;               // gerencia
  return ids.indexOf(String(id||''))>=0;
}
// Filtro PostgREST: usuario dentro del equipo
function _filtroEquipo(campo){
  var ids=_equipoIds();
  if(!ids.length) return '';                 // gerencia ve todo
  return '&'+campo+'=in.('+ids.map(encodeURIComponent).join(',')+')';
}

function _repRutaEmails(){ var ids=_repRutaCompras[(CU&&CU.id)]; if(!ids) return []; return ids.map(function(id){ var u=(USERS||[]).find(function(x){return x.id===id;}); return u?u.email:''; }).filter(Boolean); }

// Arma la URL de la foto. El bucket guarda los nombres con la EXTENSIÓN en minúscula
// (ej: 2317920.jpg) aunque SAP la reporte en mayúscula (2317920.JPG). Normalizamos
// la extensión a minúscula para que coincida con el archivo real del bucket.
function _repFotoUrl(picturname){
  var pn=(picturname||'').toString().trim();
  if(!pn) return '';
  // pasar solo la extensión a minúscula: "2317920.JPG" -> "2317920.jpg"
  pn=pn.replace(/\.([A-Za-z0-9]+)$/, function(m,ext){ return '.'+ext.toLowerCase(); });
  return FOTO_BASE+encodeURIComponent(pn);
}

/* ═══════════════════════════════════════════════════════════════════════════
   FOTOS DE KENNEDY DESDE UN EXCEL   (prefijo [FEX] · v731)
   ───────────────────────────────────────────────────────────────────────────
   Se sube un Excel con referencias (la columna «Código», o la primera). El
   portal mira cuáles EXISTEN en el SAP de Kennedy Center (tabla inventario,
   que sincroniza el worker), y de las que existen baja sus fotos (las mismas
   que se ven en el portal, bucket fotos-items) y lo empaqueta todo:
     · un Excel con las que existen (con o sin foto) y las que no;
     · las fotos, cada una con el nombre de la referencia;
   en uno o varios ZIP (de ~40 MB cada uno, por el tope del almacenamiento)
   que se suben a Supabase y quedan en un LINK para mandar o descargar.
   ═══════════════════════════════════════════════════════════════════════════ */

var FEX_MB_POR_ZIP = 40;

function _fexAbrir(){
  window._fex={estado:null, res:null, links:[]};
  var ov=document.createElement('div'); ov.id='fexOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10070;display:flex;align-items:flex-start;'
    +'justify-content:center;padding:22px;overflow:auto';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:820px;width:100%;padding:16px 18px">'
    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px">'
    +'<i class="ti ti-photo-search" style="font-size:22px;color:var(--t-lila)"></i>'
    +'<div style="flex:1"><b style="font-size:14px">Fotos de Kennedy desde un Excel</b>'
    +'<div style="font-size:11px;color:var(--text-muted)">Sube un Excel con referencias: te digo cuáles existen en el SAP de '
    +'Kennedy Center, bajo sus fotos y te lo dejo todo en un link.</div></div>'
    +'<button class="xb" onclick="document.getElementById(\'fexOv\').remove()"><i class="ti ti-x"></i></button></div>'
    +'<label class="btn bp" style="cursor:pointer;display:inline-flex;gap:6px;align-items:center">'
    +'<i class="ti ti-file-upload"></i> Elegir el Excel'
    +'<input type="file" accept=".xlsx,.xls,.csv" style="display:none" onchange="_fexExcel(this)"></label>'
    +'<div id="fexCuerpo" style="margin-top:12px;font-size:12px"></div></div>';
  document.body.appendChild(ov);
}

function _fexPintar(html){ var c=document.getElementById('fexCuerpo'); if(c) c.innerHTML=html; }
function _fexEspera(t, sub){
  _fexPintar('<div style="padding:10px 0"><span class="ai-ring g"></span> <b>'+_esc(t)+'</b>'
    +(sub?('<div style="font-size:11px;color:var(--text-muted);margin-top:3px">'+_esc(sub)+'</div>'):'')+'</div>');
}

// Lee las referencias del Excel: la columna «Código» (o parecida) o la primera
async function _fexLeer(file){
  if(typeof XLSX==='undefined') throw new Error('no está cargado el lector de Excel');
  var wb=XLSX.read(new Uint8Array(await file.arrayBuffer()),{type:'array'});
  var filas=XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]],{header:1, raw:false, defval:''});
  var cab=(filas[0]||[]).map(function(c){ return String(c||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); });
  var ic=cab.findIndex(function(c){ return /^(codigo|cod\.?|itemcode|item code|referencia|ref|sku|articulo)$/.test(c); });
  var id=cab.findIndex(function(c){ return /^(descripcion|nombre|itemname)/.test(c); });
  var desde=1;
  if(ic<0){ ic=0; if(!/[a-z]/i.test(String((filas[0]||[])[0]||''))) desde=0; }
  var vistos={}, refs=[];
  filas.slice(desde).forEach(function(f){
    var c=String((f||[])[ic]==null?'':f[ic]).trim().replace(/\.0+$/,'');
    if(!c || vistos[c.toUpperCase()]) return;
    vistos[c.toUpperCase()]=1;
    refs.push({codigo:c, desc:id>=0?String(f[id]||''):''});
  });
  return refs;
}

async function _fexExcel(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var X=window._fex={archivo:f.name, res:null, links:[]};
  try{
    _fexEspera('Leyendo '+f.name+'…');
    var refs=await _fexLeer(f);
    if(!refs.length) throw new Error('no encontré referencias en el Excel');
    // ¿Cuáles existen en Kennedy? En lotes, por el largo de la URL
    var hay={};
    for(var i=0;i<refs.length;i+=150){
      _fexEspera('Buscando en el SAP de Kennedy Center…', Math.min(i+150,refs.length)+' de '+refs.length+' referencias');
      var lote=refs.slice(i,i+150).map(function(r){ return encodeURIComponent('"'+r.codigo.replace(/"/g,'')+'"'); });
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,picturname,codebars,onhand'
        +'&itemcode=in.('+lote.join(',')+')&limit=1000',{headers:SBH});
      if(!r.ok) throw new Error('inventario: '+r.status);
      ((await r.json())||[]).forEach(function(x){ hay[String(x.itemcode).toUpperCase()]=x; });
    }
    var existen=[], noExisten=[];
    refs.forEach(function(r){
      var x=hay[r.codigo.toUpperCase()];
      if(x) existen.push({codigo:x.itemcode, desc:r.desc, nombre:x.itemname||'', foto:String(x.picturname||'').trim(),
                          barcode:x.codebars||'', existencia:x.onhand});
      else noExisten.push(r);
    });
    X.res={total:refs.length, existen:existen, noExisten:noExisten,
           conFoto:existen.filter(function(x){ return x.foto; })};
    _fexResumen();
  }catch(e){
    _fexPintar('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'+_esc(e.message||String(e))+'</div>');
  }
}

function _fexResumen(){
  var X=window._fex, R=X.res;
  var sinFoto=R.existen.length-R.conFoto.length;
  _fexPintar('<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:8px;margin-bottom:10px">'
    +[['En el Excel',R.total,'var(--surface-1)','var(--text-primary)'],
      ['Existen en Kennedy',R.existen.length,'var(--pastel-ok)','var(--t-verde)'],
      ['…con foto en SAP',R.conFoto.length,'var(--pastel-lila)','var(--t-lila)'],
      ['…sin foto',sinFoto,'var(--pastel-aviso)','var(--t-marron)'],
      ['No existen',R.noExisten.length,'var(--surface-2)','var(--text-muted)']].map(function(k){
        return '<div style="background:'+k[2]+';color:'+k[3]+';border-radius:10px;padding:9px 12px">'
          +'<div style="font-size:10.5px;font-weight:600">'+k[0]+'</div>'
          +'<div style="font-size:20px;font-weight:800">'+Number(k[1]).toLocaleString('es')+'</div></div>'; }).join('')
    +'</div>'
    +(R.existen.length?('<div class="tbx-box" style="max-height:34vh;overflow:auto;margin-bottom:10px"><table class="tbx">'
      +'<thead><tr><th>Código</th><th>Descripción en Kennedy</th><th>Foto</th></tr></thead><tbody>'
      + R.existen.slice(0,300).map(function(x){
          return '<tr><td><b>'+_esc(x.codigo)+'</b></td><td style="font-size:11px">'+_esc(x.nombre)+'</td><td>'
            +(x.foto?('<img src="'+_repFotoUrl(x.foto)+'" loading="lazy" style="height:34px;border-radius:4px" onerror="this.replaceWith(document.createTextNode(\'no se pudo ver\'))">')
                    :'<span style="color:var(--text-muted);font-size:11px">sin foto</span>')+'</td></tr>'; }).join('')
      +'</tbody></table></div>'
      +(R.existen.length>300?('<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 8px">Se muestran 300 de '
        +R.existen.length+'; el Excel lleva todas.</div>'):'')):'')
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end">'
    +'<button class="btn bg2" onclick="_fexSoloExcel()"><i class="ti ti-file-spreadsheet"></i> Solo el listado en Excel</button>'
    +(R.conFoto.length?('<button class="btn bp" style="background:#6D28D9" onclick="_fexEmpaquetar()"><i class="ti ti-link"></i> '
      +'Bajar las '+R.conFoto.length+' fotos y darme el link</button>'):'')
    +'</div>');
}

// El listado en Excel: dos hojas, las que existen y las que no
async function _fexExcelBlob(){
  var R=window._fex.res;
  await _ensureExcelJS();
  var wb=new ExcelJS.Workbook();
  var hoja=function(nombre, cab, filas, anchos){
    var ws=wb.addWorksheet(nombre,{views:[{state:'frozen', ySplit:1}]});
    ws.columns=cab.map(function(c,i){ return {header:c, width:anchos[i]||16}; });
    filas.forEach(function(f){ ws.addRow(f); });
    var h=ws.getRow(1); h.font={bold:true, color:{argb:'FFFFFFFF'}};
    h.eachCell(function(c){ c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF6D28D9'}}; });
    ws.autoFilter={from:{row:1,column:1}, to:{row:1,column:cab.length}};
    return ws;
  };
  hoja('Existen en Kennedy', ['Código','Descripción en Kennedy','Descripción del Excel','Código de barras','Existencia Kennedy',
    '¿Tiene foto?','Nombre de la foto','Link de la foto'],
    R.existen.map(function(x){ return [x.codigo, x.nombre, x.desc, x.barcode, x.existencia==null?'':Number(x.existencia),
      x.foto?'SÍ':'NO', x.foto?_fexNombreFoto(x):'', x.foto?{text:'ver foto', hyperlink:_repFotoUrl(x.foto)}:'']; }),
    [18,42,42,16,14,10,24,12]);
  hoja('No existen', ['Código','Descripción del Excel'], R.noExisten.map(function(x){ return [x.codigo, x.desc]; }), [18,50]);
  var buf=await wb.xlsx.writeBuffer();
  return new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
}

// Cada foto se llama como la referencia (sin caracteres que no valen en un archivo)
function _fexNombreFoto(x){
  var ext=(String(x.foto).match(/\.([A-Za-z0-9]{2,5})$/)||[,'jpg'])[1].toLowerCase();
  return String(x.codigo).replace(/[\\/:*?"<>|]+/g,'_')+'.'+ext;
}

async function _fexSoloExcel(){
  try{
    _fexEspera('Armando el Excel…');
    var b=await _fexExcelBlob();
    var a=document.createElement('a'); a.href=URL.createObjectURL(b);
    a.download='referencias_en_kennedy_'+_hoyISO()+'.xlsx';
    document.body.appendChild(a); a.click(); a.remove();
    _fexResumen(); showT('✓ Excel descargado');
  }catch(e){ showT('No se pudo: '+(e.message||e)); _fexResumen(); }
}

async function _fexSubir(blob, nombre){
  var file=new File([blob], nombre, {type:blob.type||'application/zip'});
  var path=await _subirDocStorage('exportes', 'fotos-kennedy', file);
  if(!path) throw new Error('no se pudo subir '+nombre+(window._attErr?(': '+window._attErr):''));
  return DOCS_BASE+path.split('/').map(encodeURIComponent).join('/');
}

async function _fexEmpaquetar(){
  var X=window._fex, R=X.res;
  try{
    await _ensureJSZip();
    var lista=R.conFoto.slice(), hechas=0, fallos=[], partes=[], zip=new JSZip(), tam=0, n=1;
    var sello=_hoyISO()+'_'+String(new Date().getHours()).padStart(2,'0')+String(new Date().getMinutes()).padStart(2,'0');
    var cerrar=async function(){
      if(!Object.keys(zip.files).length) return;
      // Se aparta la parte llena y las descargas siguen en una nueva: así
      // ninguna foto cae en un ZIP que ya se está comprimiendo
      var viejo=zip, num=n; zip=new JSZip(); tam=0; n++;
      _fexEspera('Comprimiendo y subiendo la parte '+num+'…', hechas+' de '+lista.length+' fotos');
      var b=await viejo.generateAsync({type:'blob'});
      var nombre='fotos_kennedy_'+sello+'_parte'+num+'.zip';
      partes.push({num:num, nombre:nombre, url:await _fexSubir(b, nombre), mb:Math.round(b.size/1048576*10)/10});
    };
    // El listado va en la primera parte y aparte
    var xls=await _fexExcelBlob();
    zip.file('referencias_en_kennedy.xlsx', xls); tam+=xls.size;
    var i=0;
    var siguiente=async function(){
      while(i<lista.length){
        var x=lista[i++];
        try{
          var r=await fetch(_repFotoUrl(x.foto));
          if(!r.ok) throw new Error(r.status);
          var b=await r.blob();
          zip.file('fotos/'+_fexNombreFoto(x), b); tam+=b.size;
        }catch(e){ fallos.push(x.codigo+' ('+x.foto+')'); }
        hechas++;
        if(hechas%10===0) _fexEspera('Bajando las fotos de SAP…', hechas+' de '+lista.length);
        if(tam>FEX_MB_POR_ZIP*1048576) await cerrar();
      }
    };
    // 6 descargas a la vez
    await Promise.all([1,2,3,4,5,6].map(siguiente));
    if(fallos.length) zip.file('fotos_que_no_se_pudieron_bajar.txt', fallos.join('\r\n'));
    await cerrar();
    partes.sort(function(a,b){ return a.num-b.num; });
    var urlXls=await _fexSubir(xls, 'referencias_en_kennedy_'+sello+'.xlsx');
    X.links={partes:partes, excel:urlXls, fallos:fallos};
    _fexLinks();
  }catch(e){
    _fexPintar('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">No se pudo terminar: '
      +_esc(e.message||String(e))+'</div>');
  }
}

function _fexLinks(){
  var X=window._fex, L=X.links, R=X.res;
  var todo=['Fotos de Kennedy Center · '+R.conFoto.length+' foto(s) de '+R.existen.length+' referencias que existen ('
    +R.total+' en el Excel)', '', 'Listado en Excel: '+L.excel]
    .concat(L.partes.map(function(p,i){ return 'Fotos'+(L.partes.length>1?(' parte '+(i+1)):'')+' ('+p.mb+' MB): '+p.url; }))
    .join('\n');
  window._fexTexto=todo;
  _fexPintar('<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde);font-weight:600">'
    +'<i class="ti ti-circle-check"></i> Listo: '+(R.conFoto.length-L.fallos.length)+' foto(s) empaquetadas'
    +(L.fallos.length?(' · '+L.fallos.length+' no se pudieron bajar (van listadas dentro del ZIP)'):'')+'.</div>'
    +'<div style="font-size:12px;line-height:1.9">'
    +'<div><i class="ti ti-file-spreadsheet"></i> <a href="'+L.excel+'" target="_blank">Listado en Excel</a></div>'
    + L.partes.map(function(p,i){ return '<div><i class="ti ti-file-zip"></i> <a href="'+p.url+'" target="_blank">Fotos'
        +(L.partes.length>1?(' · parte '+(i+1)+' de '+L.partes.length):'')+'</a> <span style="color:var(--text-muted)">('+p.mb+' MB)</span></div>'; }).join('')
    +'</div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">'
    +'<button class="btn bp" onclick="navigator.clipboard.writeText(window._fexTexto).then(function(){showT(\'✓ Links copiados: pégalos en el correo o WhatsApp\')})">'
    +'<i class="ti ti-copy"></i> Copiar los links</button></div>');
}

// Muestra la foto en grande (lightbox) al hacer clic
function _repZoomFoto(urlEnc, itemcode){
  var url=decodeURIComponent(urlEnc||'');
  if(!url) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:3000;display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  ov.innerHTML='<div style="position:relative;max-width:92vw;max-height:92vh;text-align:center">'
    +'<img src="'+url+'" style="max-width:92vw;max-height:86vh;object-fit:contain;border-radius:8px;background:var(--surface-2)">'
    +'<div style="color:white;font-size:13px;margin-top:8px;font-weight:600">'+_esc(itemcode||'')+'</div>'
    +'<button style="position:absolute;top:-6px;right:-6px;background:var(--surface-2);border:none;border-radius:50%;width:32px;height:32px;font-size:20px;cursor:pointer;line-height:32px">&times;</button>'
  +'</div>';
  ov.addEventListener('click',function(){ ov.remove(); });
  document.body.appendChild(ov);
}
// Preview flotante al pasar el mouse por encima de una foto (hover)
var _repHoverBox=null;
function _repHoverShow(ev, urlEnc){
  var url=decodeURIComponent(urlEnc||'');
  if(!url) return;
  if(!_repHoverBox){
    _repHoverBox=document.createElement('div');
    _repHoverBox.style.cssText='position:fixed;z-index:3500;pointer-events:none;border:2px solid white;border-radius:8px;box-shadow:0 8px 30px rgba(0,0,0,.4);background:var(--surface-2);overflow:hidden;display:none';
    _repHoverBox.innerHTML='<img style="display:block;width:260px;height:260px;object-fit:contain;background:var(--surface-2)">';
    document.body.appendChild(_repHoverBox);
  }
  var img=_repHoverBox.querySelector('img');
  if(img.getAttribute('src')!==url) img.src=url;
  _repHoverBox.style.display='block';
  _repHoverMove(ev);
}
function _repHoverMove(ev){
  if(!_repHoverBox||_repHoverBox.style.display==='none')return;
  var pad=16, w=264, h=264;
  var x=ev.clientX+pad, y=ev.clientY+pad;
  if(x+w>window.innerWidth) x=ev.clientX-w-pad;
  if(y+h>window.innerHeight) y=window.innerHeight-h-8;
  if(y<8) y=8;
  _repHoverBox.style.left=x+'px';
  _repHoverBox.style.top=y+'px';
}
function _repHoverHide(){
  if(_repHoverBox) _repHoverBox.style.display='none';
}

// Busca un itemcode en las órdenes No SAP. Devuelve [{orden, cantidad, dept, proveedor}, ...]
function _repEnOrdenesNoSAP(itemcode){
  var ic=String(itemcode||'').trim();
  if(!ic) return [];
  var res=[];
  (window._pendSAP||[]).forEach(function(p){
    var items=p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
    (items||[]).forEach(function(it){
      if(String(it.itemcode||'').trim()===ic){
        res.push({orden:p.num_orden||p.dkc, dkc:p.dkc, cantidad:Number(it.cantidad)||0, precio_unit:Number(it.precio_unit)||0, total_linea:Number(it.total_linea)||0, dept:p.dept, proveedor:p.proveedor, fecha:p.fecha||p.creado_en||''});
      }
    });
  });
  return res;
}

function _fmtN2(v){ v=Number(v)||0; return v.toLocaleString('es',{minimumFractionDigits:2,maximumFractionDigits:2}); }
// Formatea una fecha (ISO o dd/mm/yyyy) a un formato corto dd/mm/yy
function _fmtFechaCorta(f){
  if(!f) return '';
  var s=String(f);
  var d=null;
  // Una fecha suelta "2026-08-01" la interpreta como UTC, y en Panamá
  // (UTC-5) eso la corría un día para atrás. Se arma a mano en hora local.
  var m=s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if(m){
    return ('0'+m[3]).slice(-2)+'/'+('0'+m[2]).slice(-2)+'/'+m[1].slice(2);
  }
  if(/^\d{4}-\d{2}-\d{2}/.test(s)){ d=new Date(s); }
  else if(/^\d{1,2}\/\d{1,2}\/\d{2,4}/.test(s)){ return s.slice(0,10); }
  else { d=new Date(s); }
  if(d && !isNaN(d.getTime())){
    return d.toLocaleDateString('es',{day:'2-digit',month:'2-digit',year:'2-digit'});
  }
  return s.slice(0,10);
}

async function _repCargarProveedores(){
  if(_repProv.length) return _repProv;
  if(window._repProvCargando) return window._repProvCargando;
  // Se pagina el inventario completo. Antes se pedía limit=50000 de un tirón y
  // los proveedores que quedaban después de esa fila nunca aparecían en la lista.
  window._repProvCargando=(async function(){
    try{
      // OJO: Supabase corta las respuestas en su tope de filas (por defecto 1000)
      // aunque se pida limit=10000. Antes se cortaba el bucle al recibir menos
      // filas de las pedidas, así que solo se leía la PRIMERA página y quedaban
      // fuera casi todos los proveedores. Ahora se avanza por lo REALMENTE
      // recibido y solo se para cuando una página vuelve vacía.
      var mp={}, offset=0, tanda=1000, vueltas=0, leidas=0;
      while(vueltas<400){
        vueltas++;
        var url=SB+'/rest/v1/inventario?select=cardcode,nombre_proveedor,grupo'
              +'&cardcode=not.is.null&order=cardcode&limit='+tanda+'&offset='+offset;
        var r=await fetch(url,{headers:SBH});
        if(!r.ok) break;
        var rows=await r.json();
        if(!Array.isArray(rows)||!rows.length) break;   // se acabó el inventario
        rows.forEach(function(x){
          var cc=(x.cardcode||'').trim(); if(!cc)return;
          // Si el usuario tiene departamento, solo cuentan los items de su área
          if(_deptAcotado() && !_deptPermitido(normDept(x.grupo))) return;
          if(!mp[cc])mp[cc]={cardcode:cc, cardname:x.nombre_proveedor||'', n_items:0};
          mp[cc].n_items++;
          if(!mp[cc].cardname && x.nombre_proveedor) mp[cc].cardname=x.nombre_proveedor;
        });
        leidas+=rows.length;
        offset+=rows.length;                            // se avanza por lo recibido
        // Se va mostrando lo que ya se tiene, sin esperar a terminar
        _repProv=Object.values(mp).sort(function(a,b){return a.cardcode.localeCompare(b.cardcode);});
        window._repProvParcial=true;
        if(vueltas%5===0){
          try{
            var dd=document.getElementById('rep-provdrop');
            var ii=document.getElementById('rep-code');
            if(dd && dd.style.display!=='none') _repProvFiltrar(ii?ii.value:'');
          }catch(e){}
        }
      }
      window._repProvParcial=false;
      _repProv=Object.values(mp).sort(function(a,b){return a.cardcode.localeCompare(b.cardcode);});
      console.info('[proveedores] '+_repProv.length+' proveedores desde '+leidas+' filas de inventario');
    }catch(e){ _repProv=_repProv||[]; }
    window._repProvCargando=null;
    // Si el desplegable estaba abierto mientras terminaba de cargar, se repinta
    try{
      var d=document.getElementById('rep-provdrop');
      var inp=document.getElementById('rep-code');
      if(d && d.style.display!=='none') _repProvFiltrar(inp?inp.value:'');
    }catch(e){}
    return _repProv;
  })();
  return window._repProvCargando;
}

// ══ DESPLEGABLE DE PROVEEDORES CON SCROLL INFINITO ══
// Antes era un <datalist> nativo: los navegadores limitan cuantas opciones
// muestran (Chrome corta la lista) y no dejan seguir bajando. Este lo
// reemplaza por una lista propia que va cargando de a tandas al hacer scroll.
var _repProvFiltrados=[], _repProvVistos=0, _repProvTanda=40, _repProvSel=-1;

// Abrir la lista al recibir el foco es cómodo, salvo justo después de elegir
function _repProvFoco(txt){
  if(window._repProvRecien && (Date.now()-window._repProvRecien)<600) return;
  _repProvFiltrar(txt);
}

function _repProvCerrar(){
  var d=document.getElementById('rep-provdrop');
  if(d){ d.style.display='none'; }
  _repProvSel=-1;
}

function _repProvFiltrar(txt){
  var d=document.getElementById('rep-provdrop'); if(!d) return;
  var base=_repProv||[];
  var q=_repNorm(txt||'');
  if(!q){ _repProvFiltrados=base.slice(); }
  else {
    // Busca por palabras sueltas y en cualquier orden: "light china" también
    // encuentra "CHINA LIGHT (GUANGZHOU) HOMETREND".
    var pals=q.split(' ').filter(Boolean);
    var exactos=[], parciales=[];
    base.forEach(function(p){
      var cc=_repNorm(p.cardcode), cn=_repNorm(p.cardname);
      var todo=cc+' '+cn;
      if(cc===q || cc.indexOf(q)===0){ exactos.push(p); return; }
      if(pals.every(function(w){ return todo.indexOf(w)>=0; })) parciales.push(p);
    });
    _repProvFiltrados=exactos.concat(parciales);
  }
  _repProvVistos=0; _repProvSel=-1;
  d.innerHTML=''; d.scrollTop=0;
  d.style.display='block';
  // Scroll infinito enganchado al propio desplegable (más fiable que el listener global)
  d.onscroll=function(){
    if(d.scrollTop + d.clientHeight >= d.scrollHeight - 80) _repProvSiguiente();
  };
  // Cabecera fija con el conteo y el aviso de carga
  d.insertAdjacentHTML('beforeend','<div style="position:sticky;top:0;z-index:2;background:var(--surface-2);border-bottom:0.5px solid var(--border);padding:6px 12px;font-size:10.5px;color:var(--text-muted);font-weight:600">'
    +_repProvFiltrados.length+' proveedor(es)'+(q?(' con "'+_esc(String(txt||''))+'"'):'')
    +(window._repProvParcial?' <span style="color:var(--t-ambar)">\u00b7 cargando el resto…</span>':'')
    +'</div>');
  _repProvMas();
  if(!_repProvFiltrados.length){
    d.innerHTML='<div style="padding:10px 12px;font-size:12px;color:var(--text-muted)">'
      +(window._repProvCargando?'Cargando proveedores…':'Sin proveedores que coincidan. Puedes buscar igual por SKU, referencia o descripción.')
      +'</div>';
  }
}

// Carga la siguiente tanda si todavía queda lista por mostrar
function _repProvSiguiente(){
  if(_repProvVistos >= _repProvFiltrados.length) return;
  var mas=document.getElementById('rep-provmas'); if(mas) mas.remove();
  _repProvMas();
}

// Agrega la siguiente tanda al final de la lista (esto es el "bajar infinito").
function _repProvMas(){
  var d=document.getElementById('rep-provdrop'); if(!d) return;
  var hasta=Math.min(_repProvVistos+_repProvTanda, _repProvFiltrados.length);
  var h='';
  for(var i=_repProvVistos;i<hasta;i++){
    var p=_repProvFiltrados[i];
    h+='<div class="rep-provit" data-i="'+i+'" onclick="_repProvElegir('+i+')"'
      +' style="padding:8px 12px;cursor:pointer;font-size:12.5px;border-bottom:0.5px solid var(--border);display:flex;align-items:center;gap:8px;-webkit-tap-highlight-color:transparent">'
      +'<b style="color:var(--text-accent);flex:0 0 auto">'+_esc(p.cardcode)+'</b>'
      +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(p.cardname||'')+'</span>'
      +'<span style="flex:0 0 auto;color:var(--text-muted);font-size:11px">'+(p.n_items||0)+' items</span>'
      +'</div>';
  }
  d.insertAdjacentHTML('beforeend', h);
  _repProvVistos=hasta;
  if(_repProvVistos<_repProvFiltrados.length){
    d.insertAdjacentHTML('beforeend','<div id="rep-provmas" style="padding:7px 12px;font-size:11px;color:var(--text-muted);text-align:center">Baja para ver más… ('+_repProvVistos+' de '+_repProvFiltrados.length+')</div>');
    // Si la tanda no alcanzó a llenar el alto visible no habría scroll y la lista
    // se quedaría trabada: se sigue cargando hasta que sí se pueda desplazar.
    if(d.scrollHeight <= d.clientHeight + 8){
      setTimeout(_repProvSiguiente, 0);
    }
  }
}

function _repProvElegir(i){
  var p=_repProvFiltrados[i]; if(!p) return;
  _repProvElegido(p.cardcode);
}

// Deja el proveedor puesto y cierra el desplegable. Como el campo vuelve a
// abrir la lista al recibir el foco, se le quita el foco y se ignora la
// reapertura durante un instante.
function _repProvElegido(code){
  var inp=document.getElementById('rep-code');
  if(inp) inp.value=code;
  window._repProvRecien=Date.now();
  _repProvCerrar();
  try{ if(inp) inp.blur(); }catch(e){}
  repGenerar();
}

// Flechas para moverse sin ratón; Enter busca; Escape cierra.
function _repProvTecla(ev){
  var d=document.getElementById('rep-provdrop');
  var abierto=d && d.style.display!=='none';
  if(ev.key==='Escape'){ _repProvCerrar(); return; }
  if(ev.key==='Enter'){
    if(abierto && _repProvSel>=0){ ev.preventDefault(); _repProvElegir(_repProvSel); return; }
    _repProvCerrar(); repBuscarUnificado(); return;
  }
  if(!abierto) return;
  if(ev.key==='ArrowDown'||ev.key==='ArrowUp'){
    ev.preventDefault();
    var max=_repProvVistos-1; if(max<0) return;
    _repProvSel += (ev.key==='ArrowDown'?1:-1);
    if(_repProvSel<0) _repProvSel=0;
    if(_repProvSel>max){ _repProvSel=max; _repProvMas(); }
    Array.prototype.forEach.call(d.querySelectorAll('.rep-provit'),function(el){
      var on=Number(el.getAttribute('data-i'))===_repProvSel;
      el.style.background=on?'var(--bg-accent)':'transparent';
      if(on && el.scrollIntoView) el.scrollIntoView({block:'nearest'});
    });
  }
}

// Scroll infinito + cerrar al hacer clic fuera. Se registran una sola vez.
if(!window._repProvInit){
  window._repProvInit=true;
  document.addEventListener('scroll', function(ev){
    var d=ev.target;
    if(!d || d.id!=='rep-provdrop') return;
    if(d.scrollTop + d.clientHeight >= d.scrollHeight - 80){
      _repProvSiguiente();
    }
  }, true);
  // En fase de captura: se evalúa antes de que el re-render borre el nodo.
  document.addEventListener('click', function(ev){
    var t=ev.target;
    if(t && t.closest && (t.closest('#rep-provdrop') || t.closest('#rep-code'))) return;
    _repProvCerrar();
  }, true);
}

// ══════════════════════════════════════════════════════════════════════
//  TOP SELLING ITEMS
//  Los artículos que más se movieron en los últimos 3 años y que hoy
//  están por debajo de la mitad de lo que se compró la última vez, sin
//  nada en camino. Es decir: lo que se vende y se está acabando.
// ══════════════════════════════════════════════════════════════════════

window._topDept = window._topDept || 'todos';
window._topRows = window._topRows || null;

// Cuánto urge reponer cada uno. Manda la cobertura: cuántos meses aguanta
// el stock al ritmo al que se ha vendido. Cuanto menos aguanta y más se
// vende, más arriba sale.
function _topUrgencia(x){
  var disp   = _repDisp(x);
  var vendido= Number(x.vendido_3a)||0;
  var meses  = 36;
  try{
    var m=_repMesesDe(x.primera_venta);
    if(m && m>0 && m<36) meses=m;
  }catch(e){}
  var rot = vendido/Math.max(meses,1);          // piezas por mes
  if(rot<=0) return null;
  var cobertura = disp/rot;                      // meses que aguanta
  // Nota: la puntuación mezcla las dos cosas a propósito. Un artículo que
  // vende mucho y aguanta poco tiene que ir antes que uno que vende poco
  // aunque esté a cero: reponer el primero evita más venta perdida.
  return { rot:rot, cobertura:cobertura, vendido:vendido,
           score: rot / (1 + cobertura) };
}

function _topCalcular(){
  var base=(window._topItems||[]);
  var out=[];
  base.forEach(function(x){
    var ult=Number(x.u_cant_ult_ent)||0;
    if(!(ult>0)) return;                                  // sin compra previa
    var disp=_repDisp(x);
    if(disp > ult*0.5) return;                            // todavía queda medio pedido
    if((Number(x.onorder)||0) > 0) return;                // ya viene en camino
    var u=_topUrgencia(x);
    if(!u) return;                                        // no se ha vendido nunca
    x._topRot=u.rot; x._topCob=u.cobertura; x._topScore=u.score;
    out.push(x);
  });
  out.sort(function(a,b){ return b._topScore-a._topScore; });
  return out;
}

function _topSetDept(d){ window._topDept=d; _topRender(); }

// La pantalla de reposiciones trabaja con UN proveedor por vez, así que sus
// artículos no sirven aquí: hace falta el inventario entero. Se acota en el
// servidor a lo que puede cumplir las condiciones —que se haya vendido, que
// no venga nada en camino y que haya una compra anterior— y el resto se
// filtra aquí. Sin ese acote serían más de cien mil filas.
async function _topCargar(){
  // OJO con los nombres: la tabla usa onhand/iscommited/codebars. Pedir una
  // columna que no existe hace que PostgREST rechace la consulta ENTERA y
  // devuelva vacío, que es justo lo que pasaba: "stock", "comprometido" y
  // "barcode" no existen y tumbaban toda la pantalla.
  var url=SB+'/rest/v1/inventario?select=itemcode,itemname,grupo,grupo_cod,cardcode,'
    +'nombre_proveedor,disponible,onhand,iscommited,onorder,u_cant_ult_ent,fechaentrada,'
    +'vendido_3a,primera_venta,hist_comprado,unidadesbulto,precioventa,lastpurprc,'
    +'picturname,u_color,u_tamano,codebars,subg,salpackun,fob,cif,prox_llegada,ultima_llegada'
    +'&vendido_3a=gt.0&u_cant_ult_ent=gt.0'
    // 8.963 artículos pasan el filtro del servidor. Con 6.000 se dejaban
    // fuera los 2.963 de menos venta; se sube para no perder ninguno.
    +'&order=vendido_3a.desc&limit=12000';
  try{
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      console.error('[top] inventario '+r.status+': '+t.slice(0,300));
      showT('No se pudo leer el inventario ('+r.status+'). Mira la consola.');
      return [];
    }
    var f=await r.json()||[];
    return f.map(function(x){
      return Object.assign({}, x, {
        grupo_nom: x.grupo||'',
        grupo_cod: x.grupo_cod||'',
        // "precio1" no existe en la tabla: es el precio de venta con otro
        // nombre. La pantalla de reposiciones lo arma así, y las columnas
        // se pintan con él, de modo que hay que armarlo igual aquí.
        precio1:   Number(x.precioventa)||0,
        u_fentrada: x.fechaentrada||''
      });
    });
  }catch(e){ console.warn('[top]',e); return []; }
}

async function _topAbrir(){
  window._topRows=null;
  PG='topselling';
  var cont=document.getElementById('page-reposiciones');
  if(cont){
    cont.innerHTML='<div class="empty" style="padding:26px;color:var(--text-muted)">'
      +'<i class="ti ti-flame" style="font-size:24px;color:#EA580C"></i><br>'
      +'Buscando los artículos más vendidos…</div>';
  }
  var todos=await _topCargar();
  // El control de acceso por departamento, igual que en reposiciones
  if(_deptAcotado()){
    todos=todos.filter(function(x){ return _deptPermitido(normDept(x.grupo_nom)); });
  }
  window._topItems=todos;
  _topRender();
}

// ── El informe de top selling, a Excel ──
// Lleva lo mismo que la pantalla y además el proveedor, con su código y su
// nombre, que en el listado no se ve porque cada fila es un artículo.
async function _topExportar(){
  var lista=_topCalcular();
  if(!lista.length){ showT('No hay artículos que exportar'); return; }
  if(window._topDept && window._topDept!=='todos'){
    lista=lista.filter(function(x){ return normDept(x.grupo)===window._topDept; });
  }
  showT('Generando el informe…');
  try{
    await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Top selling');
    ws.columns=[
      {header:'#',                 key:'n',    width:5},
      // La foto va en su columna. Se incrusta a 120 px y calidad 0,55: en la
      // celda se ve a 48 px, así que más resolución solo engordaría el
      // archivo sin verse mejor.
      {header:'Foto',              key:'foto', width:9},
      {header:'SKU',               key:'sku',  width:16},
      {header:'Descripción',       key:'desc', width:44},
      {header:'Departamento',      key:'dep',  width:14},
      // Lo que pediste: el proveedor con código y nombre
      {header:'Código proveedor',  key:'cc',   width:14},
      {header:'Proveedor',         key:'prov', width:34},
      {header:'Existencia',        key:'onh',  width:12},
      {header:'Comprometido',      key:'com',  width:13},
      {header:'Disponible',        key:'disp', width:12},
      {header:'En camino',         key:'ord',  width:11},
      {header:'Meses de stock',    key:'cob',  width:14},
      {header:'Vende al mes',      key:'rot',  width:13},
      {header:'Vendidas 3 años',   key:'v3a',  width:15},
      {header:'Última compra',     key:'ult',  width:14},
      {header:'Fecha última entrada', key:'fe', width:16},
      {header:'Pzs por bulto',     key:'blt',  width:13},
      {header:'Color',             key:'col',  width:14},
      {header:'Medida',            key:'tam',  width:14},
      {header:'Código barras',     key:'bar',  width:16},
      {header:'FOB',               key:'fob',  width:11},
      {header:'CIF',               key:'cif',  width:11},
      {header:'Precio venta',      key:'pv',   width:12}
    ];
    ws.getRow(1).font={bold:true};
    ws.getRow(1).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEDE9FE'}};
    ws.views=[{state:'frozen', ySplit:1}];

    // Las fotos se bajan ANTES y a la vez, no una a una: con 200 artículos
    // en fila india se hacía eterno.
    var fotos={};
    var conFoto=lista.filter(function(x){ return _repFotoUrl(x.picturname); });
    showT('Bajando '+conFoto.length+' foto(s)…');
    for(var b=0; b<conFoto.length; b+=12){
      var tanda=conFoto.slice(b,b+12);
      await Promise.all(tanda.map(async function(x){
        var u=_repFotoUrl(x.picturname);
        if(!u || fotos[u]) return;
        try{ fotos[u]=await _repImgToB64(u, 120, 0.55); }catch(e){ fotos[u]=null; }
      }));
    }

    lista.forEach(function(x,i){
      var cob=x._topCob;
      ws.addRow({
        n:i+1, foto:'',
        sku:x.itemcode||'', desc:x.itemname||'',
        dep:dL(normDept(x.grupo)||''),
        cc:x.cardcode||'', prov:x.nombre_proveedor||'',
        onh:Number(x.onhand)||0, com:Number(x.iscommited)||0,
        disp:_repDisp(x), ord:Number(x.onorder)||0,
        cob:(cob!=null?Number(cob.toFixed(1)):''),
        rot:Math.round(Number(x._topRot)||0),
        v3a:Number(x.vendido_3a)||0,
        ult:Number(x.u_cant_ult_ent)||0,
        fe:(x.fechaentrada?String(x.fechaentrada).slice(0,10):''),
        blt:Number(x.unidadesbulto||x.salpackun)||'',
        col:x.u_color||'', tam:x.u_tamano||'', bar:x.codebars||'',
        fob:Number(x.fob)||0, cif:Number(x.cif)||0, pv:Number(x.precioventa)||0
      });
    });

    // Y ahora se pegan las fotos en su celda
    var puestas=0;
    lista.forEach(function(x,i){
      var u=_repFotoUrl(x.picturname);
      var im=u?fotos[u]:null;
      if(!im || !im.b64) return;
      try{
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, {tl:{col:1.12, row:(i+1)+0.10},
                         ext:{width:46, height:46}, editAs:'oneCell'});
        ws.getRow(i+2).height=38;
        puestas++;
      }catch(e){}
    });
    // Se deja constancia de cuántas entraron. Si salen 0, casi siempre es
    // que las fotos no cargan: mira si hay errores de CORS en la consola.
    var sinFoto=lista.filter(function(x){ return !_repFotoUrl(x.picturname); }).length;
    console.log('[top selling] '+puestas+' foto(s) incrustadas · '
      +sinFoto+' artículo(s) sin foto en la ficha · '+lista.length+' en total');
    if(!puestas && lista.length>sinFoto){
      showT('El informe salió sin fotos: no se pudieron descargar. '
            +'Revisa la consola (F12).');
    }

    // Los que quedan sin stock, en rojo: es lo primero que hay que reponer
    for(var f=2; f<=ws.rowCount; f++){
      var c=ws.getRow(f).getCell('cob').value;
      if(c!=='' && Number(c)<1){
        ws.getRow(f).getCell('cob').font={bold:true, color:{argb:'FFB91C1C'}};
      }
    }
    ['onh','com','disp','ord','rot','v3a','ult','blt'].forEach(function(k){
      ws.getColumn(k).numFmt='#,##0';
    });
    ['fob','cif','pv'].forEach(function(k){ ws.getColumn(k).numFmt='#,##0.00'; });

    var buf=await wb.xlsx.writeBuffer();
    var url=URL.createObjectURL(new Blob([buf],
      {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    var a=document.createElement('a');
    a.href=url;
    a.download='top-selling-'
      +((window._topDept&&window._topDept!=='todos')?(window._topDept+'-'):'')
      +new Date().toISOString().slice(0,10)+'.xlsx';
    a.click();
    showT('✓ '+lista.length+' artículo(s) exportados');
  }catch(e){
    console.warn('[top selling] exportar:', e);
    showT('No se pudo generar el informe');
  }
}

function _topRender(){
  var cont=document.getElementById('page-reposiciones');
  if(!cont) return;
  if(!window._topRows) window._topRows=_topCalcular();

  var todos=window._topRows;
  var deps={};
  todos.forEach(function(x){ var d=normDept(x.grupo_nom||x.grupo||'')||'otros'; deps[d]=(deps[d]||0)+1; });

  var lista = (window._topDept==='todos')
    ? todos
    : todos.filter(function(x){ return (normDept(x.grupo_nom||x.grupo||'')||'otros')===window._topDept; });
  // Si el departamento seleccionado quedó en un valor que ya no existe entre
  // los resultados, la pantalla salía vacía teniendo artículos de sobra.
  // Antes que mostrar nada, se vuelve a "Todos".
  if(!lista.length && todos.length && window._topDept!=='todos'){
    console.warn('[top] el departamento "'+window._topDept+'" no tiene artículos; se muestran todos');
    window._topDept='todos';
    lista=todos;
  }
  var top = lista.slice(0,200);
  console.log('[top] '+todos.length+' artículo(s) · departamento '+window._topDept
    +' · se muestran '+top.length);

  var pills='<span class="pill '+(window._topDept==='todos'?'active':'')+'" onclick="_topSetDept(\'todos\')">'
      +'Todos <span style="opacity:.7">'+todos.length+'</span></span>'
    +Object.keys(deps).sort().map(function(d){
      return '<span class="pill '+(window._topDept===d?'active':'')+'" onclick="_topSetDept(\''+d+'\')">'
        +(EMOJIS2[d]||'')+' '+_esc(dL(d))+' <span style="opacity:.7">'+deps[d]+'</span></span>';
    }).join('');

  var h='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:4px">'
    +'<button onclick="_topVolver()" class="btn bg2" style="padding:5px 12px;font-size:12px">'
      +'<i class="ti ti-arrow-left"></i> Volver a reposiciones</button>'
    +'<span style="font-size:15px;font-weight:700"><i class="ti ti-flame" style="color:#EA580C"></i> '
      +'Top selling items</span>'
    +'<button onclick="_topExportar()" class="btn bg2" '
    +'style="margin-left:auto;padding:5px 12px;font-size:12px">'
    +'<i class="ti ti-file-spreadsheet"></i> Informe Excel</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px;max-width:820px;line-height:1.5">'
      +'Lo que más se vendió en los últimos 3 años y hoy está por debajo de la mitad de la última '
      +'compra, sin nada en camino. Arriba, lo que antes se va a quedar sin existencias al ritmo '
      +'al que se vende. Pulsa un artículo para ir a la reposición de su proveedor.</div>'
    +'<div class="filters" style="margin-bottom:10px">'+pills+'</div>';

  if(!top.length){
    return void (cont.innerHTML = h
      +'<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'<i class="ti ti-mood-check" style="font-size:22px;color:var(--t-verde)"></i><br>'
      +'Ningún artículo cumple las condiciones'
      +(window._topDept!=='todos'?' en este departamento':'')+'.<br>'
      +'<span style="font-size:11px">Se piden tres cosas a la vez: que tenga ventas, que quede '
      +'la mitad o menos de la última compra y que no venga nada en camino.</span></div>');
  }

  h+='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px">'
    +'Mostrando '+top.length+' de '+lista.length+' artículo(s)'
    +(lista.length>200?' · los 200 más urgentes':'')+'</div>';

  // Las mismas columnas que el listado de reposiciones
  h+=top.map(function(x, i){
    var fila=_repFilaItem(x);
    var cob=x._topCob;
    var col=(cob<1)?'#b91c1c':(cob<3?'#B45309':'#166534');
    var etiqueta='<div style="display:flex;align-items:center;gap:7px;padding:2px 0 0 6px">'
      +'<span style="font-size:10px;font-weight:800;color:var(--text-muted);min-width:26px">#'+(i+1)+'</span>'
      +'<span title="Al ritmo al que se vende, el stock aguanta esto" '
        +'style="font-size:10px;font-weight:700;color:'+col+'">'
        +(cob<0.05?'sin stock':(cob.toFixed(1)+' meses de stock'))+'</span>'
      +'<span style="font-size:10px;color:var(--text-muted)">vende ~'+_fmtN2(Math.round(x._topRot))+'/mes'
        +' · '+_fmtN2(x.vendido_3a||0)+' vendidas en 3 años</span>'
      +'<button class="btn bg2" style="margin-left:auto;padding:3px 10px;font-size:10.5px;font-weight:600"'
        +' onclick="event.stopPropagation();_topIrAProveedor(\''+_esc(String(x.itemcode||''))+'\')">'
        +'Reponer con su proveedor <i class="ti ti-arrow-right"></i></button>'
      +'</div>';
    return '<div style="border:0.5px solid var(--border);border-radius:9px;margin-bottom:7px;'
      +'overflow:hidden;background:var(--surface-0);cursor:pointer" '
      +'onclick="_topIrAProveedor(\''+_esc(String(x.itemcode||''))+'\')">'
      +etiqueta+fila+'</div>';
  }).join('');

  cont.innerHTML=h;
}

function _topVolver(){
  PG='reposiciones';
  window._topRows=null;
  rReposiciones();
}

// Lleva a la reposición del proveedor de ese artículo, con el artículo ya
// buscado para no tener que encontrarlo entre cientos.
function _topIrAProveedor(itemcode){
  var cod=String(itemcode||'').trim().toUpperCase();
  var x=(window._topItems||[]).find(function(it){
    return String(it.itemcode||'').trim().toUpperCase()===cod;
  });
  if(!x){ showT('No se encontró el artículo'); return; }
  var prov=String(x.cardcode||'').trim();
  if(!prov){ showT('Ese artículo no tiene proveedor en SAP'); return; }
  PG='reposiciones';
  window._topRows=null;
  window._repFiltroItem=cod;          // deja el artículo filtrado al llegar
  try{ _repProvElegido(prov); }catch(e){ showT('No se pudo abrir el proveedor'); }
}

async function rReposiciones(){
  var cont=document.getElementById('page-reposiciones');
  if(!cont) return;
  // La pantalla se dibuja YA. El catálogo de proveedores se carga en segundo
  // plano: al recorrer todo el inventario tarda varios segundos y, si se
  // esperaba aquí, la primera entrada a Reposiciones quedaba en blanco.
  if(!_repProv.length){
    _repCargarProveedores().then(function(){
      var av=document.getElementById('rep-prov-carga');
      if(av) av.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '+_repProv.length+' proveedores listos</span>';
      setTimeout(function(){ var a2=document.getElementById('rep-prov-carga'); if(a2) a2.remove(); }, 2500);
    }).catch(function(){});
  }
  // El datalist incluye código Y nombre para que el navegador filtre por ambos.
  // El value es el código (lo que se usa al consultar), el texto muestra el nombre.
  // (El <datalist> se reemplazo por #rep-provdrop, que carga por tandas al
  //  hacer scroll; la lista completa vive en _repProv.)
  cont.innerHTML=''
    +'<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-package"></i> Reposiciones — Restock por proveedor'
      +((CU&& _deptAcotado())?' <span style="font-size:11px;font-weight:600;color:var(--t-azul);background:var(--pastel-azul);padding:2px 8px;border-radius:8px">'+_deptEmojis()+' Solo '+_deptEtiqueta()+'</span>':'')
    +'</div>'
    +'<div style="font-size:12px;color:var(--text-muted);background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius);padding:8px 10px;margin-bottom:12px">'
      +'<i class="ti ti-info-circle" style="font-size:12px"></i> Busca por <b>proveedor</b> (código P2232 o nombre Luoyang…), por <b>referencia del ítem</b> (SKU 2317920 o referencia GF-P1124-1171) o por <b>nombre del producto</b> (ej: tenedor, olla). Al buscar por referencia verás todo el proveedor de ese ítem.'
      +((CU&& _deptAcotado())?' Solo verás productos de <b>'+_deptEtiqueta()+'</b>.':'')
    +'</div>'
    // Atajo a los artículos que urge reponer, sin tener que ir proveedor
    // por proveedor buscandolos.
    +'<div style="margin-bottom:12px">'
      +'<button onclick="_topAbrir()" '
      +'title="Los artículos más vendidos de los últimos 3 años que ya están por debajo de la mitad de la última compra y no tienen nada en camino." '
      +'style="border:1px solid #EA580C;background:#FFF7ED;color:#EA580C;border-radius:20px;'
      +'padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap">'
      +'<i class="ti ti-flame"></i> Top selling items</button>'
      +'<span style="font-size:11px;color:var(--text-muted);margin-left:9px">'
      +'Lo que más se vende y se está acabando, ordenado por urgencia</span>'
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:flex-end;margin-bottom:14px">'
      +'<div style="flex:1;min-width:260px;display:flex;flex-direction:column;gap:3px">'
        +'<label style="font-size:11px;color:var(--text-secondary);font-weight:500">Buscar</label>'
        +'<div style="position:relative">'
          +'<input id="rep-code" class="fi2" autocomplete="off" placeholder="Escribe cualquier texto: proveedor, SKU, referencia o descripción (ej: ba-)" value="'+_esc(_repCard)+'" onkeydown="_repProvTecla(event)" oninput="_repProvFiltrar(this.value)" onfocus="_repProvFoco(this.value)" style="background:var(--surface-2);color:var(--text-primary);width:100%">'
          +'<div id="rep-prov-carga" style="font-size:10.5px;color:var(--t-ambar);margin-top:4px">'
            +(_repProv.length?'':'<span class="ai-ring g" style="width:10px;height:10px;border-width:2px;vertical-align:-1px"></span> Cargando el catálogo de proveedores… puedes escribir mientras tanto')
          +'</div>'
          +'<div id="rep-provdrop" style="display:none;position:absolute;top:calc(100% + 4px);left:0;right:0;z-index:9999;background:var(--surface-2);border:0.5px solid var(--border);border-radius:9px;box-shadow:0 10px 34px rgba(0,0,0,.16);max-height:60vh;min-height:180px;overflow-y:auto;-webkit-overflow-scrolling:touch"></div>'
        +'</div>'
      +'</div>'
      +'<button class="btn bp" onclick="repBuscarUnificado()"><i class="ti ti-search"></i> Buscar</button>'
      +'<button class="btn bg2" onclick="_repToggleAlertas()"><i class="ti ti-bell"></i> Alertas de reposición</button>'
    +'</div>'
    +'<div id="rep-alertas" style="margin-bottom:14px"></div>'
    +'<div id="rep-envios" style="margin-bottom:14px"></div>'
    +'<div id="rep-encurso" style="margin-bottom:14px"></div>'
    +'<div id="rep-result"></div>';
  // Cargar las reposiciones en curso (antes "Pedidos guardados")
  _repCargarEnCurso();
  _repEnviosCargar();
  // Proveedor que quedó pendiente al llegar desde otra pantalla (por ejemplo
  // la ficha del inventario). Se consume AQUÍ, cuando el campo ya existe:
  // esta función es asíncrona y antes el salto se hacía con un tiempo fijo,
  // así que si el catálogo tardaba en cargar el código se perdía.
  if(window._repPrefill){
    var _pf=window._repPrefill; window._repPrefill=null;
    var _in=document.getElementById('rep-code');
    if(_in){
      _in.value=_pf;
      var _d=document.getElementById('rep-provdrop'); if(_d) _d.style.display='none';
      try{ repGenerar(); }catch(e){ console.warn('prefill repGenerar:',e); }
    }
  }
}

// Deduce el departamento de un pedido de reposición a partir de sus items
function _repDeptDePedido(p){
  var items=p&&p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
  if(!Array.isArray(items)||!items.length) return '';
  var cuenta={};
  items.forEach(function(it){ var d=normDept(it.grupo_nom||it.grupo||''); cuenta[d]=(cuenta[d]||0)+1; });
  var best='', bn=-1;
  Object.keys(cuenta).forEach(function(d){ if(cuenta[d]>bn){ bn=cuenta[d]; best=d; } });
  return best;
}
function _repEstadoPedidoBadge(e){
  // v767: «orden_creada» salía como «En proceso»
  if(e==='orden_creada') return '<span style="font-size:9px;background:#EDE9FE;color:#5B21B6;padding:1px 7px;border-radius:7px;font-weight:600">Orden creada</span>';
  if(e==='finalizado') return '<span style="font-size:9px;background:var(--pastel-ok);color:var(--t-verde);padding:1px 7px;border-radius:7px;font-weight:600">Enviada a proveedor</span>';
  if(e==='enviado_compras') return '<span style="font-size:9px;background:#dbeafe;color:#1e40af;padding:1px 7px;border-radius:7px;font-weight:600">Enviado a compras</span>';
  return '<span style="font-size:9px;background:var(--pastel-naranja);color:var(--t-ambar);padding:1px 7px;border-radius:7px;font-weight:600">En proceso</span>';
}
// Muestra los pedidos de reposición en curso/guardados como sección dentro de Reposiciones
async function _repCargarEnCurso(){
  var box=document.getElementById('rep-encurso');
  if(!box) return;
  try{
    var filtro=_filtroEquipo('usuario');   // todo el equipo del departamento
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*'+filtro+'&order=actualizado_en.desc&limit=100',{headers:SBH});
    var peds=r.ok?(await r.json()):[];
    // Estas filas son las que de verdad se ven en pantalla: el índice de
    // «ya pedido» se arma con ELLAS, no con otra consulta por mi cuenta,
    // que es lo que fallaba.
    try{ window._repPedidos=peds; _repCargarIndiceEnCurso(true); }catch(e){}
    if(!Array.isArray(peds)||!peds.length){ box.innerHTML=''; return; }
    var h='<div style="border:0.5px solid #C4B5FD;border-radius:10px;overflow:hidden">'
      +'<div style="background:var(--pastel-lila);padding:8px 12px;font-size:12px;font-weight:600;color:var(--t-lila2);display:flex;align-items:center;gap:6px"><i class="ti ti-clipboard-list"></i> Reposiciones en curso <span style="font-size:10px;font-weight:400;background:#6D28D9;color:white;padding:1px 7px;border-radius:8px">'+peds.length+'</span></div>'
      // Antes 220 px: se veían tres o cuatro y había que ir rascando. Ahora
      // usa casi toda la pantalla y se ven todas de una vez.
      +'<div style="max-height:min(62vh,760px);overflow-y:auto">';
    peds.forEach(function(p){
      var fecha=p.actualizado_en?new Date(p.actualizado_en).toLocaleString('es'):'';
      var estBadge=_repEstadoPedidoBadge(p.estado);
      // Departamento de la reposición (según los items del pedido)
      var deptP=_repDeptDePedido(p);
      var deptBadge=deptP?('<span style="font-size:9px;background:var(--pastel-azul);color:var(--t-azul);padding:1px 7px;border-radius:7px;font-weight:600">'+(EMOJIS2[deptP]||'')+' '+_esc(dL(deptP))+'</span>'):'';
      h+='<div style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-top:0.5px solid var(--border)">'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:12px;font-weight:600;display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
          // El identificador por delante: así se habla de «la R-05» y se
          // encuentra de un vistazo
          +(p.num_reposicion
            ? ('<span style="background:#6D28D9;color:#fff;border-radius:7px;'
               +'padding:1px 8px;font-size:11px;font-weight:800;letter-spacing:.3px">'
               +_esc(p.num_reposicion)+'</span>')
            : '<span style="background:var(--surface-2);color:var(--text-muted);'
              +'border:0.5px dashed var(--border);border-radius:7px;padding:1px 8px;'
              +'font-size:10px" title="Todavía no tiene número: se asigna al '
              +'enviarla a compras">sin número</span>')
          +_esc(p.cardcode)+(p.cardname?(' — '+_esc(p.cardname)):'')+' '+estBadge+deptBadge+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'+(p.n_items||0)+' items · '+(p.n_unidades||0)+' und · '+_esc(p.usuario_nom||p.usuario||'?')+' · '+_esc(fecha)+'</div>'
          +(p.enviado_compras_en?('<div style="font-size:9.5px;color:#2563eb;margin-top:1px"><i class="ti ti-send"></i> Enviada a compras: '+new Date(p.enviado_compras_en).toLocaleString('es')+'</div>'):'')
          +(p.terminado_en?('<div style="font-size:9.5px;color:var(--t-verde);margin-top:1px"><i class="ti ti-checks"></i> Enviada a proveedor: '+new Date(p.terminado_en).toLocaleString('es')+'</div>'):'')
        +'</div>'
        +'<button class="btn bp" style="padding:4px 9px;font-size:11px" onclick="repContinuarPedido('+p.id+')"><i class="ti ti-edit"></i> Continuar</button>'
        +'<button class="btn bg2" style="padding:4px 9px;font-size:11px" onclick="repVerPedido('+p.id+')"><i class="ti ti-eye"></i></button>'
        +'<button class="btn bg2" style="padding:4px 9px;font-size:11px;color:var(--text-danger)" onclick="repBorrarPedido('+p.id+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
    h+='</div></div>';
    box.innerHTML=h;
  }catch(e){ box.innerHTML=''; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  ALERTAS DE REPOSICIÓN
//  1) Stock bajo: disponible ≤ 50% de la última llegada (≤ 1.5 años) y SIN orden
//     de compra por llegar  → hay que reponer.
//  2) Separado recién llegado: mercancía que ya está separada y llegó hace poco.
//  3) Alta rotación: vendió ≥ 60% de su última llegada (≤ 1.5 años) y le queda
//     menos del 50% disponible.
//  Click en el ítem → abre el proveedor para pedir. Click en "Sep" → ver quién
//  lo tiene separado (pedido de venta).
// ═══════════════════════════════════════════════════════════════════════════
var _repAlertasVisible=false;
var _repAlertasCache=null;
// Departamento seleccionado para las alertas. Las compradoras quedan fijas a su
// departamento; gerencia puede elegir cualquiera con el selector.
// OJO: esta línea corre al cargar el archivo, cuando todavía no hay nadie
// dentro (CU es null), así que el departamento quedaba SIEMPRE en 'hogar'.
// Gady, que es de alfombras, veía las alertas de hogar y por eso cero.
// Ahora se decide al abrir las alertas, con el usuario ya identificado.
var _repAlertaDept=null;
function _repDeptAlerta(){
  if(_deptAcotado()) return _deptPrimero();
  if(_repAlertaDept) return _repAlertaDept;
  return (DEPTS_ALL && DEPTS_ALL[0]) || 'hogar';
}
// Parseo robusto de fecha (ISO, DD/MM/YYYY, DD/MM/YY)
function _repParseFecha(s){
  if(!s) return null;
  if(s instanceof Date) return isNaN(s)?null:s;
  s=String(s).trim(); if(!s) return null;
  var m=s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
  if(m){
    var dd=+m[1], mm=+m[2], yy=+m[3]; if(yy<100) yy+=2000;
    // Heurística: si el primer número >12, es día; si no, asumimos DD/MM
    var d=new Date(yy, (mm<=12?mm:dd)-1, (mm<=12?dd:mm));
    return isNaN(d)?null:d;
  }
  var d2=new Date(s); return isNaN(d2)?null:d2;
}
// Meses entre una fecha y hoy
function _repMesesDesde(fecha){
  if(!fecha) return Infinity;
  return (Date.now()-fecha.getTime())/(1000*60*60*24*30.44);
}
// Detecta un campo de rotación si existe en la fila (nombres comunes)
function _repRotacionVal(row){
  var claves=['rotacion','rotation','rot','ventas12m','vendido12m','venta12m','salidas12m','consumo','consumomensual','venta_mensual','ventamensual','ventas_ano','ventasanuales'];
  for(var i=0;i<claves.length;i++){ if(row[claves[i]]!=null && row[claves[i]]!==''){ var n=Number(row[claves[i]]); if(!isNaN(n)) return n; } }
  return null;
}
function _repToggleAlertas(){
  var box=document.getElementById('rep-alertas'); if(!box) return;
  _repAlertasVisible=!_repAlertasVisible;
  var enc=document.getElementById('rep-encurso');
  if(!_repAlertasVisible){
    box.innerHTML='';
    if(enc) enc.style.display='';   // volver a mostrar las reposiciones en curso
    return;
  }
  if(enc) enc.style.display='none'; // ocultar reposiciones en curso mientras se ven alertas
  // El caché guarda de qué departamento es. Si se cambia de departamento —o
  // si lo guardado quedó vacío por un fallo—, se vuelve a calcular en vez de
  // repintar un cero que no significa nada.
  if(_repAlertasCache && _repAlertasCache.dept===_repDeptAlerta()
     && (_repAlertasCache.total||0)>0){
    _repRenderAlertas(_repAlertasCache); return;
  }
  _repCargarAlertas();
}
var _repAlertasCargando=false;
async function _repCargarAlertas(force){
  var box=document.getElementById('rep-alertas'); if(!box) return;
  if(_repAlertasCargando) return;   // evitar cargas concurrentes
  _repAlertasCargando=true;
  box.innerHTML='<div class="empty" style="padding:18px"><i class="ti ti-loader-2 spin"></i><br>Analizando inventario para detectar alertas…</div>';
  try{
    // Asegurar datos de pedidos No SAP (para excluir items ya pedidos)
    if(typeof cargarPendSAP==='function' && (!window._pendSAP)){ try{ await cargarPendSAP(); }catch(e){} }
    // Departamento (compradora: su depto; gerencia: el elegido en el selector)
    var deptSel=_repDeptAlerta();
    // Pista para filtrar el grupo en el servidor y reducir datos (normDept confirma después)
    var hint={hogar:'hogar',ropa:'ropa',muebles:'mueble',alfombras:'alfombra',campamento:'campamento',electronica:'electr',ferreteria:'ferret',otros:'art'}[deptSel];
    var deptFilter=hint?('&grupo=ilike.*'+encodeURIComponent(hint)+'*'):'';
    var campos='itemcode,itemname,cardcode,nombre_proveedor,grupo,onhand,iscommited,onorder,'
      +'prox_llegada,ultima_llegada,ordenes_abiertas,fob,cif,precioventa,'
      +'u_cant_ult_ent,hist_comprado,fechaentrada,picturname,unidadesbulto,salpackun';
    // Paginar (el servidor limita ~1000 por página) hasta traer TODO el departamento
    var pageSize=1000, offset=0, maxPages=40, rows=[];
    for(var pg=0; pg<maxPages; pg++){
      // El filtro pedía onhand>0 o comprometido>0, o sea que solo miraba
      // artículos que TODAVÍA tienen algo. Justo los agotados —los más
      // urgentes de reponer— quedaban fuera, y por eso las tres alertas
      // salían en cero. Ahora se piden los que tienen una compra anterior,
      // que es lo que las tres reglas necesitan de verdad.
      var url=SB+'/rest/v1/inventario?select='+campos+'&cardcode=not.is.null'
        +'&u_cant_ult_ent=gt.0'+deptFilter+'&order=itemcode&limit='+pageSize+'&offset='+offset;
      var chunk=[];
      try{
        var r=await fetch(url,{headers:SBH});
        if(!r.ok){
          // Antes se cortaba en silencio y la pantalla decía "sin alertas",
          // que es indistinguible de "no hay nada que reponer".
          var _t=''; try{ _t=await r.text(); }catch(e){}
          console.error('[alertas] inventario '+r.status+': '+_t.slice(0,300));
          try{ showT('No se pudo leer el inventario ('+r.status+'). Mira la consola.'); }catch(e){}
          break;
        }
        chunk=await r.json();
        if(pg===0) console.log('[alertas] '+deptSel+': primera tanda '+((chunk||[]).length)+' artículo(s)');
      }catch(ferr){ console.warn('alertas fetch page '+pg, ferr); break; }
      if(!Array.isArray(chunk)||!chunk.length) break;
      for(var ci=0; ci<chunk.length; ci++){ if(normDept(chunk[ci].grupo)===deptSel) rows.push(chunk[ci]); }
      offset+=pageSize;
      if(chunk.length<pageSize) break;
    }
    var A=[], B=[], C=[];   // A=reponer, B=separado recién llegado, C=alta rotación
    // Cuenta por qué se descarta cada uno. Sin esto, "sin alertas" puede
    // significar cosas muy distintas y no hay forma de saber cuál.
    var _dx={total:0, yaEnNoSap:0, sinUltCompra:0, sinFecha:0, masDe18Meses:0,
             conOrden:0, quedaMasDel50:0};
    rows.forEach(function(x){
      _dx.total++;
      // Excluir si ese item YA tiene reposición en un pedido No SAP
      if(_repEnOrdenesNoSAP(x.itemcode).length){ _dx.yaEnNoSap++; return; }
      var onhand=Number(x.onhand)||0, sep=Number(x.iscommited)||0, onorder=Number(x.onorder)||0;
      var ult=Number(x.u_cant_ult_ent)||0;
      var disp=onhand-sep;
      var fecha=_repParseFecha(x.fechaentrada);
      var meses=_repMesesDesde(fecha);
      var reciente18=(fecha && meses<=18);
      var recienLlego=(fecha && meses<=1.2);      // ~ últimos ~35 días
      var it={
        itemcode:x.itemcode, itemname:x.itemname, cardcode:x.cardcode,
        nombre_proveedor:x.nombre_proveedor||'', grupo:x.grupo||'',
        onhand:onhand, iscommited:sep, onorder:onorder, disp:disp,
        u_cant_ult_ent:ult, fechaentrada:x.fechaentrada, picturname:x.picturname||'',
        unidadesbulto:Number(x.unidadesbulto)||Number(x.salpackun)||0,
        // Costos y fecha de llegada, para verlos también en el tablero
        fob:Number(x.fob)||0, cif:Number(x.cif)||0, precio1:Number(x.precioventa)||0,
        prox_llegada:x.prox_llegada||'', ultima_llegada:x.ultima_llegada||'',
        ordenes_abiertas:Number(x.ordenes_abiertas)||0
      };
      // 1) Reponer: disponible ≤ 50% de última llegada, ≤1.5 años, sin OC por llegar
      if(reciente18 && ult>0 && onorder<=0 && disp<=0.5*ult){
        it._motivo='Disponible '+_fmtN2(disp)+' (≤50% de última llegada '+_fmtN2(ult)+') y sin orden por llegar';
        A.push(it);
      } else {
        if(!ult) _dx.sinUltCompra++;
        else if(!fecha) _dx.sinFecha++;
        else if(!reciente18) _dx.masDe18Meses++;
        else if(onorder>0) _dx.conOrden++;
        else if(disp>0.5*ult) _dx.quedaMasDel50++;
      }
      // 2) Separado y recién llegado
      if(recienLlego && sep>0){
        it._motivoB='Separado '+_fmtN2(sep)+' und y llegó hace '+Math.round(meses*30)+' días';
        B.push(it);
      }
      // 3) Alta rotación con <50% disponible
      var rotVal=_repRotacionVal(x);
      var sellThrough=(ult>0)?((ult-disp)/ult):0;
      var altaRot=(rotVal!=null)?(rotVal>0 && sellThrough>=0.5):(reciente18 && sellThrough>=0.6);
      if(altaRot && ult>0 && disp<0.5*ult){
        it._motivoC='Alta rotación: vendió '+Math.round(sellThrough*100)+'% de su última llegada; quedan '+_fmtN2(disp)+' disponibles';
        C.push(it);
      }
    });
    // Ordenar cada lista por urgencia (menor disponible primero)
    var byDisp=function(a,b){return a.disp-b.disp;};
    A.sort(byDisp); B.sort(function(a,b){return b.iscommited-a.iscommited;}); C.sort(byDisp);
    console.log('[alertas] '+deptSel+': de '+_dx.total+' artículo(s) → A='+A.length
      +' B='+B.length+' C='+C.length);
    console.log('[alertas] descartes: ya en orden BORRADOR '+_dx.yaEnNoSap
      +' · sin última compra '+_dx.sinUltCompra
      +' · sin fecha de entrada '+_dx.sinFecha
      +' · entrada de hace más de 18 meses '+_dx.masDe18Meses
      +' · con orden en camino '+_dx.conOrden
      +' · les queda más del 50% '+_dx.quedaMasDel50);
    _repAlertasCache={A:A, B:B, C:C, total:rows.length, dept:deptSel};
    _repRenderAlertas(_repAlertasCache);
  }catch(e){
    console.error('alertas reposicion:', e);
    if(box) box.innerHTML='<div class="empty" style="padding:18px;color:var(--text-danger)">Error al cargar alertas: '+(e.message||e)+'</div>';
  }finally{
    _repAlertasCargando=false;
  }
}
// Cambia el departamento de las alertas (diferido para no destruir el <select> en pleno evento)
function _repSelDeptAlerta(v){
  try{
    _repAlertaDept=v;
    _repAlertasCache=null;
    setTimeout(function(){ try{ _repCargarAlertas(); }catch(e){ console.error(e); } }, 0);
  }catch(e){ console.error('cambiar dept alerta:', e); }
}
function _repRenderAlertas(data){
  var box=document.getElementById('rep-alertas'); if(!box) return;
  /* v765: lo que ya está en una reposición NO sale como «hace falta
     reponer»: va a un grupo aparte al final. Se parte siempre desde la
     lista original (_orig), para que al recargar el índice se reparta bien. */
  var base=(data&&data._orig)||data;
  var yaVisto={}, R=[];
  var sacar=function(arr, mk){
    return (arr||[]).filter(function(x){
      var e=_repItemEnCurso(x.itemcode);
      if(!e) return true;
      if(!yaVisto[x.itemcode]){
        yaVisto[x.itemcode]=1;
        var y=Object.assign({}, x); y._motivoR=x[mk]||''; R.push(y);
      }
      return false;
    });
  };
  data={A:sacar(base.A,'_motivo'), B:sacar(base.B,'_motivoB'), C:sacar(base.C,'_motivoC'),
        R:R, total:base.total, dept:base.dept, _orig:base};
  _repAlertasCache=data;
  // El índice de lo que ya está pedido: si todavía no está, se trae y se
  // vuelve a pintar en cuanto llegue.
  if(!window._repIdxCurso || !window._repIdxPintado){
    window._repIdxPintado=true;
    _repCargarIndiceEnCurso().then(function(){
      try{ _repRenderAlertas(data); }catch(e){}
    });
  }
  var grupos=[
    {key:'A', titulo:'Reponer — stock bajo sin orden', icono:'ti-alert-triangle', color:'#B45309', bg:'#FEF3E8', bd:'#f5c9a0', motivo:'_motivo', items:data.A},
    {key:'B', titulo:'Separado recién llegado', icono:'ti-package-import', color:'#0c447c', bg:'#e6f1fb', bd:'#a9cdf0', motivo:'_motivoB', items:data.B},
    {key:'C', titulo:'Alta rotación — queda menos del 50%', icono:'ti-flame', color:'#9D174D', bg:'#FBEAF0', bd:'#f0b6cd', motivo:'_motivoC', items:data.C},
    {key:'R', titulo:'Ya están en una reposición — no hace falta pedirlos', icono:'ti-circle-check', color:'#166534', bg:'#E4F0D4', bd:'#9CC79C', motivo:'_motivoR', items:data.R}
  ];
  // Qué sabe el portal de las reposiciones vivas, a la vista
  var _idx=_repIndiceEnCurso();
  var _nIdx=Object.keys(_idx).length;
  var _diag='<span onclick="_repDiagEnCurso()" title="Ver el detalle" '
    +'style="cursor:pointer;font-size:10.5px;border-radius:7px;padding:2px 8px;'
    +'background:'+(_nIdx?'var(--pastel-ok)':'var(--pastel-error)')+';'
    +'color:'+(_nIdx?'var(--t-verde)':'var(--t-rojo)')+';font-weight:700">'
    +'<i class="ti ti-shopping-cart"></i> '
    +(_nIdx? (_nIdx+' ya pedidos') : 'sin datos de reposiciones')+'</span>';

  // Selector de departamento (gerencia elige; compradora ve fijo el suyo)
  var deptActual=_repDeptAlerta();
  var deptCtrl;
  if(CU&& _deptAcotado()){
    deptCtrl='<span style="font-size:11px;font-weight:600;background:var(--surface-2);border:0.5px solid #C4B5FD;color:var(--t-lila2);padding:3px 9px;border-radius:8px">'+_deptEmojis()+' '+_esc(_deptEtiqueta())+'</span>';
  } else {
    deptCtrl='<select onchange="_repSelDeptAlerta(this.value)" style="font-size:11px;font-weight:600;padding:3px 8px;border:0.5px solid #C4B5FD;border-radius:8px;background:var(--surface-2);color:var(--t-lila2);cursor:pointer">'
      +_deptsVisibles().map(function(d){ return '<option value="'+d+'"'+(d===deptActual?' selected':'')+'>'+(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</option>'; }).join('')
      +'</select>';
  }
  var h='<div style="border:0.5px solid #C4B5FD;border-radius:10px;overflow:hidden">'
    +'<div style="background:var(--pastel-lila);padding:9px 12px;font-size:12px;font-weight:700;color:var(--t-lila2);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<i class="ti ti-bell"></i> Alertas de reposición'
      +'<span style="font-size:10px;font-weight:400;background:#6D28D9;color:#fff;padding:1px 7px;border-radius:8px">'+(data.A.length+data.B.length+data.C.length)+'</span>'
      + _diag
      +'<span style="font-size:11px;font-weight:500;color:var(--t-lila2)">Departamento:</span>'+deptCtrl
      +'<button class="btn bg2" style="margin-left:auto;padding:3px 9px;font-size:11px" onclick="_repAlertasCache=null;_repCargarAlertas()"><i class="ti ti-refresh"></i> Actualizar</button>'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:11px" onclick="_repToggleAlertas()"><i class="ti ti-x"></i></button>'
    +'</div>';
  grupos.forEach(function(g){
    h+='<div style="border-top:0.5px solid var(--border)">'
      +'<div style="background:'+g.bg+';border-bottom:0.5px solid '+g.bd+';padding:7px 12px;font-size:12px;font-weight:600;color:'+g.color+';display:flex;align-items:center;gap:7px"><i class="ti '+g.icono+'"></i> '+g.titulo+' <span style="font-size:10px;font-weight:700;background:'+g.color+';color:#fff;padding:1px 7px;border-radius:8px">'+g.items.length+'</span></div>';
    if(!g.items.length){
      h+='<div style="padding:10px 14px;font-size:11px;color:var(--text-muted)">Sin alertas de este tipo.</div>';
    } else {
      // Contenedor con scroll infinito (se van agregando items al hacer scroll)
      h+='<div class="rep-alert-scroll" id="rep-alert-list-'+g.key+'" data-g="'+g.key+'" data-n="0" style="max-height:60vh;overflow-y:auto"></div>';
    }
    h+='</div>';
  });
  h+='</div>';
  box.innerHTML=h;
  // Poblar cada grupo con el primer lote y enganchar el scroll infinito
  grupos.forEach(function(g){
    if(!g.items.length) return;
    var el=document.getElementById('rep-alert-list-'+g.key);
    if(!el) return;
    _repAlertMore(g.key);
    el.onscroll=function(){
      if(el.scrollTop+el.clientHeight >= el.scrollHeight-100) _repAlertMore(g.key);
    };
  });
}
// Agrega el siguiente lote de items al grupo (scroll infinito)
function _repAlertMore(key){
  var el=document.getElementById('rep-alert-list-'+key); if(!el) return;
  if(!_repAlertasCache) return;
  var arr=_repAlertasCache[key]||[];
  var motivoKey={A:'_motivo',B:'_motivoB',C:'_motivoC',R:'_motivoR'}[key];
  // Cargar lotes hasta llenar el contenedor visible (o agotar la lista). Iterativo,
  // con tope de seguridad para no bloquear el hilo.
  var vueltas=0;
  do{
    var n=Number(el.getAttribute('data-n'))||0;
    if(n>=arr.length) break;
    var batch=arr.slice(n, n+40);
    var frag=batch.map(function(x){ return _repAlertaItemHTML(x, x[motivoKey]||''); }).join('');
    el.insertAdjacentHTML('beforeend', frag);
    el.setAttribute('data-n', n+batch.length);
    vueltas++;
  } while(el.scrollHeight<=el.clientHeight && vueltas<8 && (Number(el.getAttribute('data-n'))||0)<arr.length);
}
function _repAlertaItemHTML(x, motivo){
  var ic=_esc(String(x.itemcode));
  var foto=_repFotoUrl(x.picturname);
  var bulto=Math.max(1, Number(x.unidadesbulto)||1);
  var fechaLleg=x.fechaentrada?_esc(String(x.fechaentrada)):'';
  // ¿Ya va en una reposición en curso? Se avisa AQUÍ para no pedirlo dos veces
  var enRepo=_repItemEnCurso(x.itemcode);
  var _colF=enRepo ? (REP_ESTADO_COLOR[String(enRepo.estado||'').toLowerCase()]
                      || {bg:'#FDF0DC'}) : null;
  var fondo=_colF ? ('background:'+_colF.bg+';') : '';
  return '<div style="display:flex;align-items:center;gap:10px;padding:8px 12px;'
    +fondo+'border-top:0.5px solid var(--border)">'
    +'<div style="width:46px;height:46px;flex-shrink:0;border:0.5px solid var(--border);border-radius:6px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center'+(foto?';cursor:zoom-in':'')+'"'+(foto?' onclick="_repZoomFoto(\''+encodeURIComponent(foto)+'\',\''+ic+'\')" onmouseenter="_repHoverShow(event,\''+encodeURIComponent(foto)+'\')" onmousemove="_repHoverMove(event)" onmouseleave="_repHoverHide()"':'')+'>'
      +(foto?'<img src="'+foto+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted)&quot;></i>\'">':'<i class="ti ti-photo-off" style="color:var(--text-muted)"></i>')
    +'</div>'
    +'<div style="flex:1;min-width:0">'
      +'<div style="font-size:12.5px;font-weight:600"><span onclick="repBuscarPorItem(\''+ic+'\')" title="Abrir el proveedor para hacer pedido" style="color:var(--text-accent);cursor:pointer;text-decoration:underline">'+ic+'</span> <span style="font-weight:400;color:var(--text-secondary)">'+_esc(x.itemname||'')+'</span></div>'
      // El aviso, justo debajo del nombre: no hace falta buscarlo
      +(enRepo
        ? (function(){
            var col=REP_ESTADO_COLOR[String(enRepo.estado||'').toLowerCase()]
                  || {c:'#B45309', bg:'#FDF0DC', bd:'#E9C08A'};
            return '<div style="margin-top:3px;font-size:11px;font-weight:700;'
              +'color:'+col.c+';display:inline-flex;align-items:center;gap:5px;'
              +'background:'+col.bg+';border:1px solid '+col.bd+';border-radius:7px;'
              +'padding:2px 8px;cursor:pointer" onclick="_repIrAReposicion(\''
              +_esc(enRepo.codigo)+'\')" title="Ver esa reposición">'
              +'<i class="ti ti-alert-circle"></i> YA SE ENCUENTRA EN LA '
              +_esc(enRepo.codigo)
              +(enRepo.estado?(' · '+_esc(_repTxtEstado(enRepo))):'')+'</div>';
          })()
        : '')
      +'<div style="display:flex;gap:6px 14px;flex-wrap:wrap;font-size:11.5px;color:var(--text-secondary);margin-top:3px">'
        +'<span>Stock: <b>'+_fmtN2(x.onhand)+'</b></span>'
        +'<span onclick="verSeparado(\''+ic+'\')" title="Ver quién lo tiene separado (pedido de venta)" style="cursor:pointer">Sep: <b style="color:var(--t-rojo2);text-decoration:underline">'+_fmtN2(x.iscommited)+'</b></span>'
        +(function(){
            var _ub=Math.max(1, Number(x.u_cxblt)||Number(x.unidadesbulto)||Number(x.salpackun)||1);
            var _d=Number(x.disp)||0;
            return '<span>Disp: <b style="color:var(--text-success)">'+_fmtN2(_d)+'</b>'
              +(_ub>1?(' <span style="color:var(--t-lila2);font-size:11.5px">(bultos: <b>'
                +_fmtN2(Math.floor(_d/_ub))
                +((_d%_ub)?('<span style="font-weight:400"> + '+_fmtN2(_d%_ub)+' pz</span>'):'')
                +'</b>)</span>'):'')
              +'</span>';
          })()
        +'<span>Por lleg: <b style="color:#C9A800">'+_fmtN2(x.onorder)+'</b>'
          +((Number(x.onorder)>0 && _invLlegadaTxt(x))
            ? (' <span style="font-size:10.5px;color:'+_invLlegadaColor(x)+'">('+_esc(_invLlegadaTxt(x))+')</span>')
            : '')
          +'</span>'
        +'<span>Últ. llegada: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b></span>'
        +(fechaLleg?'<span>Fecha llegada: <b>'+fechaLleg+'</b></span>':'')
      +'</div>'
      +(motivo?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px"><i class="ti ti-info-circle" style="font-size:11px"></i> '+_esc(motivo)+'</div>'):'')
    +'</div>'
    +'<button class="btn bp" style="padding:5px 10px;font-size:11px;flex-shrink:0" onclick="repBuscarPorItem(\''+ic+'\')"><i class="ti ti-shopping-cart"></i> Pedir</button>'
  +'</div>';
}
async function repBuscarUnificado(){
  var q=(document.getElementById('rep-code').value||'').trim();
  if(!q){ showT('Escribe algo para buscar'); return; }

  // 1) ¿Es una opción del datalist "CODIGO — nombre (N items)"? -> proveedor directo
  if(q.indexOf(' — ')>=0){ return repGenerar(); }

  // 2) ¿Coincide exactamente con un código de proveedor del catálogo? -> proveedor
  var up=q.toUpperCase();
  var esProv=(_repProv||[]).some(function(p){ return (p.cardcode||'').toUpperCase()===up; });
  if(esProv){ return repGenerar(); }

  // 3) Coincide EXACTO con una referencia de ítem (itemcode o suppcatnum) -> su proveedor
  try{
    var enc=encodeURIComponent(q);
    var r1=await fetch(SB+'/rest/v1/inventario?itemcode=ilike.'+enc+'&select=itemcode&limit=1',{headers:SBH});
    var d1=r1.ok?(await r1.json()):[];
    if(Array.isArray(d1)&&d1.length){ return repBuscarPorItemDirecto(d1[0].itemcode||q); }
    var r2=await fetch(SB+'/rest/v1/inventario?suppcatnum=ilike.'+enc+'&select=itemcode&limit=1',{headers:SBH});
    var d2=r2.ok?(await r2.json()):[];
    if(Array.isArray(d2)&&d2.length){ return repBuscarPorItemDirecto(d2[0].itemcode||q); }
  }catch(e){}

  // 4) Búsqueda AMPLIA: cualquier proveedor o ítem que CONTENGA el texto
  //    (código o nombre de proveedor, SKU, referencia o descripción).
  return repBuscarPorNombreDirecto(q);
}
// Alias que pasan el valor directo (el buscador unificado ya no tiene campos separados)
function repBuscarPorItemDirecto(v){ return repBuscarPorItem(v); }
function repBuscarPorNombreDirecto(v){ return repBuscarPorNombre(v); }

// Busca el proveedor a partir de una referencia (itemcode) y carga su reporte
async function repBuscarPorItem(itemArg){
  var item=(itemArg!=null?String(itemArg):(document.getElementById('rep-item')?document.getElementById('rep-item').value:'')||'').trim();
  if(!item){ showT('Ingresa el código de un producto'); return; }
  var res=document.getElementById('rep-result');
  res.innerHTML='<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Buscando el proveedor de '+_esc(item)+'...</div>';
  try{
    var r=await fetch(SB+'/rest/v1/inventario?itemcode=eq.'+encodeURIComponent(item)+'&select=itemcode,itemname,cardcode,nombre_proveedor,grupo&limit=1',{headers:SBH});
    var d=r.ok?(await r.json()):[];
    var row=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!row){ res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-search-off" style="font-size:22px;color:var(--text-muted)"></i><br>No se encontró el producto <b>'+_esc(item)+'</b> en el inventario.</div>'; return; }
    // Control de acceso: verificar que el producto sea del departamento del usuario
    if(CU && _deptAcotado() && !_deptPermitido(normDept(row.grupo))){
      res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-lock" style="font-size:22px;color:var(--text-warning)"></i><br>El producto <b>'+_esc(item)+'</b> pertenece a otro departamento.<br><span style="font-size:11px;color:var(--text-muted)">Solo puedes ver reposiciones de '+_deptEtiqueta()+'.</span></div>';
      return;
    }
    if(!row.cardcode){ res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-alert-triangle" style="font-size:22px;color:var(--text-warning)"></i><br>El producto <b>'+_esc(item)+'</b> ('+_esc(row.itemname||'')+') no tiene proveedor asignado.</div>'; return; }
    // Cargar el reporte del proveedor de ese producto
    document.getElementById('rep-code').value=row.cardcode;
    showT('Proveedor: '+row.cardcode+(row.nombre_proveedor?(' — '+row.nombre_proveedor):''));
    await repGenerar();
    // Resaltar visualmente el item buscado
    setTimeout(function(){
      var el=document.querySelector('.rep-item-row[data-ic="'+item.replace(/"/g,'')+'"]');
      if(el){ el.scrollIntoView({behavior:'smooth',block:'center'}); el.style.outline='2px solid var(--text-accent)'; setTimeout(function(){el.style.outline='';},2500); }
    },400);
  }catch(e){ res.innerHTML='<div class="empty">Error al buscar. Revisa tu conexión.</div>'; }
}

var _repSearchProvs=[];
// Busca (contiene) en proveedores e ítems con SCROLL INFINITO (sin límite fijo).
async function repBuscarPorNombre(qArg){
  var q=(qArg!=null?String(qArg):(document.getElementById('rep-prodname')?document.getElementById('rep-prodname').value:'')||'').trim();
  if(!q){ showT('Escribe algo para buscar'); return; }
  if(q.length<2){ showT('Escribe al menos 2 caracteres'); return; }
  var res=document.getElementById('rep-result');
  res.innerHTML='<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Buscando "'+_esc(q)+'" en proveedores e ítems...</div>';
  try{
    var qs=q.replace(/[(),"*%\\]/g,' ').replace(/\s+/g,' ').trim();
    var pat='*'+qs+'*';
    var cols=['itemname','itemcode','suppcatnum','nombre_proveedor','cardcode'];
    var orExpr='or=('+cols.map(function(c){return c+'.ilike.'+pat;}).join(',')+')';
    var base=SB+'/rest/v1/inventario?'+orExpr+'&cardcode=not.is.null&select=itemcode,itemname,cardcode,nombre_proveedor,picturname,grupo,suppcatnum&order=cardcode';
    // Paginar sin límite artificial hasta traer TODO
    var pageSize=1000, offset=0, maxPages=60, rows=[];
    for(var pg=0; pg<maxPages; pg++){
      var url=(base+'&limit='+pageSize+'&offset='+offset).replace(/ /g,'%20');
      var chunk=[];
      try{ var r=await fetch(url,{headers:SBH}); if(!r.ok) break; chunk=await r.json(); }catch(e){ break; }
      if(!Array.isArray(chunk)||!chunk.length) break;
      for(var i=0;i<chunk.length;i++){ if(!CU||!_deptAcotado()||_deptPermitido(normDept(chunk[i].grupo))) rows.push(chunk[i]); }
      offset+=pageSize;
      if(chunk.length<pageSize) break;
    }
    if(!rows.length){
      res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-search-off" style="font-size:22px;color:var(--text-muted)"></i><br>No se encontró ningún proveedor ni ítem que contenga "<b>'+_esc(q)+'</b>"'+((CU&& _deptAcotado())?(' en '+_deptEtiqueta()):'')+'.</div>';
      return;
    }
    var porProv={};
    rows.forEach(function(x){ var cc=(x.cardcode||'').trim(); if(!cc)return; if(!porProv[cc])porProv[cc]={cardcode:cc, cardname:x.nombre_proveedor||'', items:[]}; porProv[cc].items.push(x); });
    _repSearchProvs=Object.values(porProv).sort(function(a,b){return b.items.length-a.items.length;});
    var h='<div style="font-size:12px;color:var(--text-muted);margin-bottom:10px">'+rows.length+' coincidencia(s) con "<b>'+_esc(q)+'</b>" en '+_repSearchProvs.length+' proveedor(es). Haz clic en un proveedor para ver su reposición completa.</div>'
      +'<div id="rep-search-scroll" data-n="0" style="max-height:68vh;overflow-y:auto;padding-right:4px"></div>';
    res.innerHTML=h;
    var sc=document.getElementById('rep-search-scroll');
    _repSearchMore();
    if(sc) sc.onscroll=function(){ if(sc.scrollTop+sc.clientHeight>=sc.scrollHeight-120) _repSearchMore(); };
  }catch(e){ res.innerHTML='<div class="empty">Error al buscar. Revisa tu conexión.</div>'; }
}
function _repSearchGrupoHTML(p){
  var h='<div style="border:0.5px solid var(--border);border-radius:10px;margin-bottom:12px;overflow:hidden">'
    +'<div onclick="_repProvElegido(\''+_esc(p.cardcode)+'\')" style="background:var(--surface-2);padding:9px 12px;cursor:pointer;display:flex;align-items:center;gap:8px;border-bottom:0.5px solid var(--border)">'
      +'<i class="ti ti-building-store" style="color:var(--text-accent)"></i>'
      +'<span style="font-size:13px;font-weight:700;color:var(--text-accent)">'+_esc(p.cardcode)+'</span>'
      +(p.cardname?'<span style="font-size:12px;color:var(--text-secondary)">'+_esc(p.cardname)+'</span>':'')
      +'<span style="margin-left:auto;font-size:11px;color:var(--text-muted)">'+p.items.length+' coincidencia(s) · ver todo <i class="ti ti-chevron-right"></i></span>'
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;padding:10px 12px">';
  p.items.slice(0,8).forEach(function(x){
    var foto=_repFotoUrl(x.picturname);
    h+='<div style="width:92px;text-align:center" title="'+_esc(x.itemname||'')+'">'
      +'<div style="width:92px;height:92px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center'+(foto?';cursor:zoom-in':'')+'"'+(foto?' onclick="event.stopPropagation();_repZoomFoto(\''+encodeURIComponent(foto)+'\',\''+_esc(String(x.itemcode))+'\')"':'')+'>'
        +(foto?'<img src="'+foto+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted)&quot;></i>\'">':'<i class="ti ti-photo-off" style="color:var(--text-muted)"></i>')
      +'</div>'
      +'<div style="font-size:9px;font-weight:600;margin-top:3px">'+_esc(x.itemcode)+'</div>'
      +'<div style="font-size:9px;color:var(--text-muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(x.itemname||'')+'</div>'
    +'</div>';
  });
  if(p.items.length>8) h+='<div style="align-self:center;font-size:11px;color:var(--text-muted)">+'+(p.items.length-8)+' más</div>';
  h+='</div></div>';
  return h;
}
function _repSearchMore(){
  var sc=document.getElementById('rep-search-scroll'); if(!sc) return;
  var n=Number(sc.getAttribute('data-n'))||0;
  var vueltas=0;
  do{
    if(n>=_repSearchProvs.length) break;
    var batch=_repSearchProvs.slice(n, n+15);
    sc.insertAdjacentHTML('beforeend', batch.map(function(p){return _repSearchGrupoHTML(p);}).join(''));
    n+=batch.length; sc.setAttribute('data-n', n);
    vueltas++;
  } while(sc.scrollHeight<=sc.clientHeight && vueltas<6 && n<_repSearchProvs.length);
}
// - "P2232 — LUOYANG... (18 items)" (opción del datalist) -> P2232
// - "luoyang" (nombre parcial) -> busca en el catálogo por nombre
function _repResolverCodigo(entrada){
  var t=(entrada||'').trim();
  if(!t) return '';
  // Caso datalist: "CODIGO — nombre (N items)" -> tomar lo antes del " — "
  if(t.indexOf(' — ')>=0){ return t.split(' — ')[0].trim().toUpperCase(); }
  // Caso código exacto: si coincide con algún cardcode del catálogo
  var up=t.toUpperCase();
  var exacto=(_repProv||[]).find(function(p){ return (p.cardcode||'').toUpperCase()===up; });
  if(exacto) return exacto.cardcode;
  // Caso nombre parcial: buscar en los nombres de proveedor
  var low=t.toLowerCase();
  var porNombre=(_repProv||[]).filter(function(p){ return (p.cardname||'').toLowerCase().indexOf(low)>=0; });
  if(porNombre.length===1) return porNombre[0].cardcode;
  if(porNombre.length>1){
    // Varios coinciden: mostrar opciones para elegir
    var res=document.getElementById('rep-result');
    if(res){
      // Lista completa con scroll infinito: antes se cortaba en 15 y el resto
      // no había forma de verlo.
      window._repCoinc=porNombre; window._repCoincVistos=0;
      res.innerHTML='<div style="padding:14px;border:0.5px solid var(--border);border-radius:10px">'
        +'<div style="font-size:12px;font-weight:600;margin-bottom:8px">'+porNombre.length+' proveedores coinciden con "'+_esc(t)+'":</div>'
        +'<div id="rep-coinc" style="max-height:340px;overflow-y:auto;-webkit-overflow-scrolling:touch"></div>'
        +'</div>';
      _repCoincMas();
      var _cd=document.getElementById('rep-coinc');
      if(_cd) _cd.onscroll=function(){
        if(_cd.scrollTop+_cd.clientHeight >= _cd.scrollHeight-70) _repCoincMas();
      };
    }
    return '';  // que el usuario elija
  }
  // Si no coincide con nada del catálogo, asumir que escribió un código directo
  return up;
}

// Muestra los proveedores coincidentes por tandas, con scroll infinito
function _repCoincMas(){
  var d=document.getElementById('rep-coinc'); if(!d) return;
  var todos=window._repCoinc||[];
  var desde=window._repCoincVistos||0;
  if(desde>=todos.length) return;
  var hasta=Math.min(desde+40, todos.length);
  var h='';
  for(var i=desde;i<hasta;i++){
    var p=todos[i];
    h+='<div onclick="_repProvElegido(\''+_esc(p.cardcode)+'\')"'
      +' style="cursor:pointer;padding:6px 8px;border-bottom:0.5px solid var(--border);font-size:12px">'
      +'<b style="color:var(--text-accent)">'+_esc(p.cardcode)+'</b> — '+_esc(p.cardname||'')
      +' <span style="color:var(--text-muted)">('+(p.n_items||0)+' items)</span></div>';
  }
  var viejo=document.getElementById('rep-coincmas'); if(viejo) viejo.remove();
  d.insertAdjacentHTML('beforeend', h);
  window._repCoincVistos=hasta;
  if(hasta<todos.length){
    d.insertAdjacentHTML('beforeend','<div id="rep-coincmas" style="padding:7px 8px;font-size:11px;color:var(--text-muted);text-align:center">Baja para ver más… ('+hasta+' de '+todos.length+')</div>');
    if(d.scrollHeight<=d.clientHeight+8) setTimeout(_repCoincMas,0);
  }
}

async function repGenerar(){
  // Se cierra el desplegable pase lo que pase. Elegir un proveedor siempre
  // termina llamando aquí, así que este es el único lugar donde hace falta
  // acordarse, en vez de en cada sitio desde donde se puede elegir.
  try{ _repProvCerrar(); }catch(e){}
  try{
    var _d=document.getElementById('rep-provdrop'); if(_d) _d.style.display='none';
    var _i=document.getElementById('rep-code'); if(_i) _i.blur();
    window._repProvRecien=Date.now();
  }catch(e){}
  var entrada=(document.getElementById('rep-code').value||'').trim();
  if(!entrada){ showT('Ingresa el código o nombre del proveedor'); return; }
  // El usuario pudo escribir/seleccionar "P2232 — LUOYANG... (18 items)" del datalist,
  // o solo "P2232", o incluso un nombre. Resolvemos el código real:
  var code=_repResolverCodigo(entrada);
  if(!code){ showT('No se encontró ese proveedor. Prueba con el código exacto.'); return; }
  document.getElementById('rep-code').value=code;
  // Si se cambia de proveedor manualmente (no viene de "continuar"), reiniciar carrito y pedido
  if(code!==_repCard){ _repCarrito={}; _repPedidoId=null; }
  _repCard=code;
  var res=document.getElementById('rep-result');
  res.innerHTML='<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Consultando '+_esc(code)+'...</div>';
  try{
    // Leer directo del inventario del portal, filtrando por proveedor (cardcode).
    // Se ordena solo por itemcode (siempre presente); el agrupado por grupo se hace en el cliente.
    var r=await fetch(SB+'/rest/v1/inventario?cardcode=eq.'+encodeURIComponent(code)+'&select=*&order=itemcode&limit=100000',{headers:SBH});
    var raw=r.ok?(await r.json()):[];
    // v765: lo ya pedido en otras reposiciones, listo antes de pintar
    try{ await _repCargarIndiceEnCurso(); }catch(e){}
    // Normalizar los nombres de campos de 'inventario' al formato que usa el reporte
    var rows=raw.map(function(x){
      return {
        cardcode:      x.cardcode,
        cardname:      x.nombre_proveedor||'',
        marca:         x.marca||'',
        itemcode:      x.itemcode,
        itemname:      x.itemname,
        grupo_cod:     x.grupo_cod||'',
        grupo_nom:     x.grupo||'',
        salunitmsr:    x.salunitmsr||'',
        salpackun:     Number(x.salpackun)||0,
        u_bulunie:     '',
        u_cxblt:       Number(x.unidadesbulto)||0,
        onhand:        Number(x.onhand)||0,
        iscommited:    Number(x.iscommited)||0,
        onorder:       Number(x.onorder)||0,
        // Cuándo llega lo que está por llegar
        prox_llegada:     x.prox_llegada||'',
        ultima_llegada:   x.ultima_llegada||'',
        ordenes_abiertas: Number(x.ordenes_abiertas)||0,
        fob:           Number(x.fob)||0,
        cif:           Number(x.cif)||0,
        precio1:       Number(x.precioventa)||0,
        kilos:         Number(x.peso)||0,
        picturname:    x.picturname||'',
        cant_comprada: 0,
        total_fob:     0,
        total_cif:     0,
        u_fentrada:    x.fechaentrada||'',
        u_nentrada:    x.u_nentrada||'',
        u_cant_ult_ent:Number(x.u_cant_ult_ent)||0,
        hist_comprado: Number(x.hist_comprado)||0,   // total comprado histórico
        suppcatnum:    x.suppcatnum||'',
        u_color:       x.u_color||'',
        u_tamano:      x.u_tamano||'',
        // Descripción en INGLÉS (Foreign Name de SAP) para el PDF/Excel de reposición
        frgnname:      x.frgnname||x.foreign_name||x.foreignname||'',
        // Campo definido por usuario "Colores" (según cómo lo haya sincronizado el ETL)
        colores:       x.u_colores||x.colores||x.u_colors||x.u_color||'',
        // Ficha técnica y datos que usa el detalle del producto
        caracteristicas: x.caracteristicas||null,
        codebars:      x.codebars||'',
        usertext:      x.usertext||'',
        marca:         x.marca||'',
        peso:          x.peso||0,
        volumen:       x.volumen||0,
        unidadesbulto: x.unidadesbulto||0,
        precioventa:   Number(x.precioventa)||0,
        lastpurprc:    Number(x.lastpurprc)||0,
        disponible:    x.disponible,
        subg:          x.subg||''
      };
    });
    // ── Control de acceso por departamento ──
    // Si el usuario tiene un departamento asignado (compradora), solo ve los items
    // de su departamento. Gerencia (dept null) ve todo.
    var todosLosRows=rows;
    if(_deptAcotado()){
      rows=rows.filter(function(x){ return _deptPermitido(normDept(x.grupo_nom)); });
    }
    _repData=rows;
    if(!rows.length){
      // Si el proveedor tiene items pero NINGUNO es del departamento del usuario,
      // avisar que ese proveedor no corresponde a su departamento.
      if(CU && _deptAcotado() && todosLosRows.length){
        res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-lock" style="font-size:22px;color:var(--text-warning)"></i><br>El proveedor <b>'+_esc(code)+'</b> no tiene productos de tu departamento (<b>'+_deptEtiqueta()+'</b>).<br><span style="font-size:11px;color:var(--text-muted)">Solo puedes ver reposiciones de '+_deptEtiqueta()+'.</span></div>';
        return;
      }
      // Sugerir proveedores que SÍ tienen datos (del catálogo cargado)
      var conDatos=(_repProv||[]).filter(function(p){return p.n_items>0;})
        .sort(function(a,b){return b.n_items-a.n_items;}).slice(0,8);
      var sug=conDatos.length
        ? '<div style="margin-top:10px;font-size:11px;color:var(--text-muted)">Proveedores con datos disponibles: '
          +conDatos.map(function(p){return '<span onclick="_repProvElegido(\''+_esc(p.cardcode)+'\')" style="cursor:pointer;color:var(--text-accent);text-decoration:underline;margin:0 4px">'+_esc(p.cardcode)+' ('+p.n_items+')</span>';}).join('')+'</div>'
        : '';
      res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-database-off" style="font-size:22px;color:var(--text-muted)"></i><br>No hay ítems para el proveedor <b>'+_esc(code)+'</b>.<br><span style="font-size:11px;color:var(--text-muted)">Puede que el sync del inventario aún no haya poblado este proveedor. Si el resync completo terminó y sigue vacío, verifica el código.</span>'+sug+'</div>';
      return;
    }
    repRenderResumen(rows, code);
  }catch(e){
    res.innerHTML='<div class="empty">Error al consultar. Revisa tu conexión.</div>';
  }
}

// Fila de un item en el listado de reposición (se reusa agrupado y en lista plana)
// ═══════════════════════════════════════════════════════════════════════════
//  SUGERENCIA DE REPOSICIÓN
//  El cálculo se hace aquí con los datos del artículo: rotación estimada,
//  disponible, lo que ya viene en camino y cuándo llegó la última compra.
//  La AI se usa después para afinar los casos dudosos, pero si falla o tarda,
//  la sugerencia igual sale: antes todo dependía de la AI y quedaba en cero.
// ═══════════════════════════════════════════════════════════════════════════
window._repSugIA=window._repSugIA||{};

function _repBultos(x){
  return Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
}

// Meses transcurridos desde una fecha
function _repMesesDe(f){
  var d=_repParseFecha(f);
  if(!d) return null;
  var m=(Date.now()-d.getTime())/(1000*60*60*24*30.44);
  return m>0?m:0.1;
}

// El cálculo por artículo. Devuelve bultos sugeridos y el porqué.
// ── Margen de ganancia del artículo, con lo que se compró y se vendió ──
// El costo es el de la última compra (lastpurprc) y el precio, el de venta
// del inventario. Se devuelve null cuando falta alguno de los dos: no es lo
// mismo "gana poco" que "no sabemos cuánto gana", y marcar en rojo por falta
// de datos sería peor que no marcar nada.
var REP_MARGEN_MIN = 15;   // por debajo de esto, se avisa
window._margenHist = window._margenHist || {};

// Trae de la base el margen histórico de cada artículo: lo que SAP muestra
// en el Sales Analysis Report, o sea TODAS las ventas del artículo desde
// siempre. Es un dato mucho más fiable que comparar el último costo con el
// precio de lista, porque recoge lo que de verdad se cobró.
async function _margenHistCargar(force){
  if(!force && Object.keys(window._margenHist).length) return window._margenHist;
  try{
    var out={}, desde=0;
    while(true){
      var r=await fetch(SB+'/rest/v1/margen_items?select=itemcode,ventas,ganancia,'
        +'margen_pct,unidades,facturas,ultima_venta&offset='+desde+'&limit=1000',{headers:SBH});
      if(!r.ok){
        if(desde===0) console.warn('[margen] no se pudo leer margen_items: '+r.status
          +' (¿falta correr crear_tabla_margen_items.sql?)');
        break;
      }
      var lote=await r.json()||[];
      lote.forEach(function(m){ out[String(m.itemcode||'').trim().toUpperCase()]=m; });
      if(lote.length<1000) break;
      desde+=1000;
    }
    if(Object.keys(out).length) window._margenHist=out;
    console.log('[margen] '+Object.keys(window._margenHist).length+' artículo(s) con margen histórico');
  }catch(e){ console.warn('[margen]',e); }
  return window._margenHist;
}

// El margen histórico de un artículo, o null si no hay ventas registradas
function _margenHistDe(itemcode){
  var k=String(itemcode||'').trim().toUpperCase();
  var m=(window._margenHist||{})[k];
  if(!m || m.margen_pct===null || m.margen_pct===undefined) return null;
  return m;
}

// El margen que se usa para avisar. Manda el histórico —son ventas reales—
// y solo si no hay se estima con el último costo contra el precio de lista.
function _repMargenItem(x){
  if(!x) return null;
  var h=_margenHistDe(x.itemcode);
  if(h) return Number(h.margen_pct);
  var pv=Number(x.precioventa)||Number(x.precio_venta)||Number(x.precio1)||0;
  var costo=Number(x.lastpurprc)||Number(x.u_precio_ult_ent)||Number(x.costo)||0;
  if(!(pv>0) || !(costo>0)) return null;
  return Number((((pv-costo)/pv)*100).toFixed(2));
}

// El margen histórico como un campo más de la fila, al lado del precio.
// Es lo que SAP llama Gross Profit %: la ganancia de TODAS las ventas del
// artículo dividida entre lo que se facturó por él.
function _repMargenCampo(x){
  var h=_margenHistDe(x&&x.itemcode);
  if(!h){
    return '<span title="Este artículo todavía no registra ventas, así que no hay '
      +'margen histórico que calcular." style="color:var(--text-muted)">Margen hist.: <b>—</b></span>';
  }
  var m=Number(h.margen_pct);
  var col = (m<0) ? '#b91c1c' : (m<REP_MARGEN_MIN ? '#B45309' : '#166534');
  var t='Margen histórico sobre todas las ventas del artículo: '
    +fmt(h.ventas)+' facturados, '+fmt(h.ganancia)+' de ganancia'
    +(h.unidades?(', '+_fmtN2(h.unidades)+' unidades'):'')
    +(h.facturas?(' en '+h.facturas+' factura(s)'):'')+'.'
    +(m<REP_MARGEN_MIN?(' Está por debajo del '+REP_MARGEN_MIN+'%.'):'');
  return '<span title="'+_esc(t)+'">Margen hist.: <b style="color:'+col+'">'
    +m.toFixed(1)+'%</b>'
    +(m<REP_MARGEN_MIN?' <i class="ti ti-arrow-down" style="color:var(--t-rojo3);font-size:11px"></i>':'')
    +'</span>';
}

// La marca que se ve junto a la sugerencia
function _repMargenBadge(x){
  var m=_repMargenItem(x);
  if(m===null || m>=REP_MARGEN_MIN) return '';
  var pv=Number(x.precioventa)||Number(x.precio_venta)||Number(x.precio1)||0;
  var costo=Number(x.lastpurprc)||Number(x.u_precio_ult_ent)||Number(x.costo)||0;
  var h=_margenHistDe(x.itemcode);
  var titulo = h
    ? ('Margen histórico: '+m.toFixed(1)+'% sobre todas las ventas del artículo'
       +' ('+fmt(h.ventas)+' vendidos, '+fmt(h.ganancia)+' de ganancia'
       +(h.facturas?(', '+h.facturas+' factura(s)'):'')+').'
       +' Por debajo del '+REP_MARGEN_MIN+'% que se considera aceptable.'
       +(m<0?' El artículo dejó pérdida.':''))
    : ('Margen estimado: '+m.toFixed(1)+'% (costo '+fmt(costo)+' → venta '+fmt(pv)+').'
       +' No hay ventas registradas de este artículo, así que sale de comparar'
       +' la última compra con el precio de lista.'
       +(m<0?' Se vendería por debajo del costo.':''));
  return '<span title="'+_esc(titulo)+'" style="display:inline-flex;align-items:center;gap:1px;'
    +'background:var(--pastel-error);color:var(--t-rojo3);border:0.5px solid #f0b4b4;border-radius:6px;'
    +'padding:1px 5px;font-size:9.5px;font-weight:800;margin-left:5px;white-space:nowrap;cursor:help">'
    +'<i class="ti ti-arrow-down" style="font-size:10px"></i>'+m.toFixed(0)+'%</span>';
}

function _repCalcularSug(x, mesesObjetivo){
  // El objetivo es tener 6 meses de inventario
  mesesObjetivo=mesesObjetivo||6;
  var ub=_repBultos(x);
  var disp=_repDisp(x);
  var porLlegar=Number(x.onorder)||0;
  var ultEnt=Number(x.u_cant_ult_ent)||0;
  var hist=Number(x.hist_comprado)||0;
  // Ventas reales de los últimos 3 años, que es el dato más fiable
  var vendido=Number(x.vendido_3a)||Number(x.vendido)||Number(x.u_vendido)||0;
  var mesesVenta=null;
  if(x.primera_venta){
    var mv=_repMesesDe(x.primera_venta);
    if(mv) mesesVenta=Math.min(mv, 36);      // como mucho, 3 años
  }
  var mesesEnt=_repMesesDe(_repFechaEnt(x));

  // 1) Rotación mensual estimada.
  //    OJO: "mesesEnt" son los meses desde la ÚLTIMA entrada, no la vida del
  //    artículo. Dividir todo el histórico por ese número inflaba la rotación
  //    de forma absurda (un artículo con 8 compras parecía vender 8 veces más).
  var rot=0, base='';

  // a) Lo consumido desde que llegó la última compra.
  //    Solo vale si quedó MENOS de lo que llegó: ahí se sabe que esa
  //    mercancía se movió. Si quedó más, había stock previo y la cuenta
  //    mezclaría cosas distintas.
  var consumo=null;
  if(ultEnt>0 && mesesEnt!=null && mesesEnt>=0.5 && disp<ultEnt){
    var consumido=ultEnt-disp;
    consumo=consumido/mesesEnt;
  }

  // b) El histórico repartido en el PERÍODO DEL DATO.
  //    El histórico que llega es el de los últimos 3 años, así que se reparte
  //    en esos 36 meses. Estimar una "vida" a partir del número de compras
  //    daba disparates: un artículo con 3 compras parecía vivir 8 meses y su
  //    rotación salía 4 veces más alta de lo real.
  var VENTANA_MESES = 36;
  var porHistorico=null;
  if(hist>0){
    // Si el artículo es más nuevo que la ventana, se usa su edad real
    var periodo=VENTANA_MESES;
    if(x.primera_venta){
      var pv=_repMesesDe(x.primera_venta);
      if(pv && pv<VENTANA_MESES) periodo=Math.max(pv, 1);
    } else if(mesesEnt!=null && mesesEnt<VENTANA_MESES && (hist<=ultEnt*1.2)){
      // Una sola compra y reciente: el período es desde esa compra
      periodo=Math.max(mesesEnt, 1);
    }
    porHistorico=hist/periodo;
  }

  if(vendido>0){
    // Lo vendido de verdad, repartido en el período en que se vendió
    var perVenta=mesesVenta || Math.min(_repMesesDe(x.u_fentrada)||36, 36) || 36;
    rot=vendido/Math.max(1, perVenta);
    base='ventas reales ('+Math.round(perVenta)+' meses)';
  } else if(porHistorico!=null && consumo!=null){
    // Se toma la señal más alta SOLO cuando la ventana reciente es corta y no
    // alcanza para concluir nada. Si la ventana ya es larga, más abajo manda
    // lo que está pasando ahora (ver "freno de realidad").
    if(consumo>porHistorico){
      rot=consumo;
      base='consumo reciente ('+_fmtN2(Math.round(ultEnt-disp))+' pz en '
           +mesesEnt.toFixed(1)+' meses)';
    } else {
      rot=porHistorico;
      base='compras de los últimos 3 años';
    }
  } else if(porHistorico!=null){
    rot=porHistorico;
    base='compras de los últimos 3 años';
  } else if(consumo!=null){
    rot=consumo;
    base='consumo desde la última compra';
  }

  // ── FRENO DE REALIDAD ────────────────────────────────────────────────
  // La rotación estimada mira hasta 3 años atrás. Si en los últimos meses el
  // artículo NO se movió, ese promedio ya no describe lo que pasa hoy y hay
  // que hacerle caso a lo reciente, que es evidencia directa.
  //
  // Sin esto, un artículo con 1.436 piezas paradas desde marzo pedía otras
  // 2.616 porque "históricamente rotaba 675 al mes", cuando en 5 meses solo
  // habían salido 4 piezas.
  var frenado=null, consumido=null;
  // El ritmo real manda en cuanto haya un mes de ventana. Antes se exigían 3
  // meses, y en ese hueco la rotación salía de las COMPRAS: comprar 52 piezas
  // hace un mes se leía como "vende 45 al mes" aunque siguieran 48 en bodega.
  if(consumo!=null && mesesEnt!=null && mesesEnt>=1){
    consumido=Math.round(ultEnt-disp);
    if(consumo<rot){
      rot=consumo;
      base='consumo real desde la última compra ('+_fmtN2(consumido)+' pz en '
           +mesesEnt.toFixed(1)+' meses)';
    }
  }
  if(consumo!=null && mesesEnt!=null && mesesEnt>=3){
    consumido=Math.round(ultEnt-disp);
    // Y si a ese ritmo hay para mucho más del objetivo, no se repone
    var cobRec=(disp+porLlegar)/Math.max(consumo, 0.01);
    if(cobRec>mesesObjetivo*2){
      frenado='Desde la última compra (hace '+mesesEnt.toFixed(1)+' meses) solo salieron '
        +_fmtN2(consumido)+' pieza(s). Con '+_fmtN2(disp)+' disponible(s) hay para '
        +(cobRec>240?'años':(Math.round(cobRec)+' meses'))+' a ese ritmo: no hace falta reponer.'
        +' Si esperás que se mueva (temporada, promoción), cárgalo a mano.';
    }
  }
  if(frenado) return {bultos:0, razon:frenado, rot:rot, base:base, enCamino:porLlegar};

  // ── TODAVÍA QUEDA MEDIA COMPRA EN CASA ───────────────────────────────
  // Si de la última compra sobra la mitad o más, no se repone: aún no se
  // sabe a qué ritmo se vende de verdad, y cualquier proyección hecha sobre
  // tan poco movimiento se dispara. Con 48 de 52, o con 80 de 120, lo
  // sensato es esperar.
  if(ultEnt>0 && (disp+porLlegar) >= ultEnt*0.5){
    var _vend=Math.max(0, Math.round(ultEnt-disp));
    return {bultos:0, rot:rot, base:base, enCamino:porLlegar,
      razon:'De la última compra de '+_fmtN2(ultEnt)+' pz todavía quedan '+_fmtN2(disp)
        +(porLlegar>0?(' y vienen '+_fmtN2(porLlegar)):'')+', o sea la mitad o más. '
        +'Solo salieron '+_fmtN2(_vend)+' pieza(s)'
        +((mesesEnt!=null)?(' en '+mesesEnt.toFixed(1)+' meses'):'')+'. '
        +'No se repone hasta que baje del 50%. Si lo necesitás igual, cárgalo a mano.'};
  }

  // 2) Cuánto haría falta para cubrir el objetivo
  var objetivo=rot*mesesObjetivo;
  var faltan=objetivo-disp-porLlegar;

  // 3) Reglas de decisión
  var razon='', bultos=0;

  if(rot<=0){
    // Sin datos de movimiento: solo se repone si está en cero y hubo compras
    if(disp<=0 && ultEnt>0 && porLlegar<=0){
      bultos=Math.max(1, Math.round((ultEnt/ub)/2));
      razon='Sin datos de rotación, pero está agotado. Media última compra.';
    } else {
      razon='Sin movimiento registrado: no se sugiere reponer.';
    }
    return {bultos:bultos, razon:razon, rot:rot, base:base};
  }

  var mesesCobertura=(disp+porLlegar)/rot;

  // ── COMPRA VIEJA CON MERCANCÍA TODAVÍA EN CASA ───────────────────────
  // Si la última compra tiene más de dos años y AÚN quedan piezas, el
  // artículo es lento por definición: se tardó años en vender lo anterior y
  // todavía sobra. No se repone solo.
  //
  // El promedio disimula esto: 1.200 piezas compradas en 2022 de las que
  // quedan 104 dan "22 al mes", pero ese número reparte por igual lo que se
  // vendió el primer año y lo que se vende ahora.
  // Más de dos años sin recomprar es una decisión, no un olvido: si el
  // artículo siguiera vendiéndose se habría repuesto en todo ese tiempo.
  // Vale tanto si sobra mercancía como si está agotado.
  //
  // Con agotados el promedio engaña especialmente: 6.012 piezas compradas en
  // 2021 dan "107 al mes", pero ese número reparte por igual lo que se vendió
  // el primer año y los últimos tres, en los que puede no haberse movido nada.
  var MESES_VIEJO=24;
  if(mesesEnt!=null && mesesEnt>MESES_VIEJO){
    var _anios=(mesesEnt/12).toFixed(1);
    razon=(disp+porLlegar)>0
      ? ('Última compra hace '+_anios+' años y todavía quedan '+_fmtN2(disp)
         +' disponible(s)'+(porLlegar>0?(' más '+_fmtN2(porLlegar)+' por llegar'):'')
         +'. Rota demasiado lento para reponer solo.')
      : ('Agotado, pero la última compra fue hace '+_anios+' años y no se volvió '
         +'a comprar desde entonces: parece descontinuado.');
    razon+=' Si lo quieres igual, cárgalo a mano.';
    return {bultos:0, razon:razon, rot:rot, base:base, enCamino:porLlegar};
  }

  if(faltan<=0){
    if(porLlegar>0){
      razon='Ya vienen '+_fmtN2(porLlegar)+' en camino: cubre '
        +mesesCobertura.toFixed(1)+' meses. No hace falta pedir más.';
    } else {
      razon='Con '+_fmtN2(disp)+' disponibles cubre '+mesesCobertura.toFixed(1)
        +' meses. Todavía no hace falta.';
    }
    return {bultos:0, razon:razon, rot:rot, base:base, enCamino:porLlegar};
  }

  // Si ya viene mercancía en camino, solo se pide más cuando de verdad falta:
  // con 2 meses o más cubiertos se espera a que llegue.
  if(porLlegar>0 && mesesCobertura>=2){
    razon='Vienen '+_fmtN2(porLlegar)+' en camino y cubren '+mesesCobertura.toFixed(1)
      +' meses. Conviene esperar a que lleguen.';
    return {bultos:0, razon:razon, rot:rot, base:base, enCamino:porLlegar};
  }

  bultos=Math.ceil(faltan/ub);

  // ── TOPE DE CRECIMIENTO SOBRE LA ÚLTIMA COMPRA ───────────────────────
  // Una cosa es que la rotación diga que faltan piezas y otra saltar de 120
  // a 672 de golpe. El salto se limita según la EVIDENCIA que hay detrás:
  // con ventas reales medidas durante meses se puede confiar más; con una
  // sola compra en el historial, la proyección se apoya en muy poco.
  //
  // El tope anterior (6 veces la última compra) era tan alto que casi nunca
  // frenaba nada: por eso EK5035-MB pedía 672 piezas habiendo comprado 120
  // en toda su historia.
  var topeInfo=null;
  if(ultEnt>0){
    var factor, motivo;
    var comprasVarias=(hist > ultEnt*1.5);          // hay más de una compra
    var ventaLarga=(vendido>0 && mesesVenta!=null && mesesVenta>=6);
    if(ventaLarga && comprasVarias){ factor=3;   motivo='ventas reales de varios meses y varias compras'; }
    else if(ventaLarga){            factor=2.5; motivo='ventas reales de varios meses'; }
    else if(comprasVarias){         factor=2.5; motivo='varias compras en el historial'; }
    else {                          factor=2;   motivo='una sola compra en el historial'; }

    var topePz=Math.round(ultEnt*factor);
    var topeBultos=Math.max(1, Math.floor(topePz/ub));
    if(bultos>topeBultos){
      topeInfo={pedidoSinTope:bultos*ub, factor:factor, motivo:motivo};
      bultos=topeBultos;
    }
  }

  // Y el tope viejo se mantiene como red de seguridad ante datos absurdos
  if(ultEnt>0){
    var razonable=(rot*mesesObjetivo*1.5)/ub;
    var tope=Math.ceil(Math.max(razonable, (ultEnt*6)/ub));
    if(bultos>tope) bultos=tope;
  }

  razon=(porLlegar>0?'AUNQUE YA VIENEN '+_fmtN2(porLlegar)+', ':'')
    +(consumido!=null?('Desde la última compra salieron '+_fmtN2(consumido)+' pz en '
       +mesesEnt.toFixed(1)+' meses. '):'')
    +'vende ~'+_fmtN2(Math.round(rot))+'/mes ('+base+'), quedan '+_fmtN2(disp)
    +(porLlegar>0?(' y vienen '+_fmtN2(porLlegar)):'')
    +' = '+mesesCobertura.toFixed(1)+' meses. Para '+mesesObjetivo+' meses faltan '
    +_fmtN2(Math.round(faltan))+' piezas.'
    +(topeInfo
      ? (' Harían falta '+_fmtN2(Math.round(topeInfo.pedidoSinTope))+' pz, pero la última '
         +'compra fue de '+_fmtN2(ultEnt)+': se limita a '+topeInfo.factor+' veces esa '
         +'cantidad porque solo hay '+topeInfo.motivo+'. Si quieres más, cárgalo a mano.')
      : ((bultos*ub < faltan-ub) ? ' Se topó la sugerencia para no pedir de más.' : ''));
  return {bultos:bultos, razon:razon, rot:rot, base:base, enCamino:porLlegar};
}

async function _repSugerirIA(){
  if(!_repData || !_repData.length){ showT('Primero abrí un proveedor'); return; }
  var items=_repFiltrarItems(_repData);
  if(!items.length){ showT('No hay artículos que analizar'); return; }

  var btn=document.getElementById('rep-ia-btn');
  function estado(t){ if(btn) btn.innerHTML=t; }
  if(btn) btn.disabled=true;
  estado('<span class="ai-ring"></span> Calculando…');

  // 1) El cálculo local, que siempre funciona
  var conSug=0, sinDatos=0;
  items.forEach(function(x){
    var r=_repCalcularSug(x, window._repMesesObjetivo||6);
    window._repSugIA[String(x.itemcode||'').trim().toUpperCase()]={
      bultos:r.bultos, razon:r.razon, rot:r.rot, base:r.base,
      enCamino:r.enCamino||0, fuente:'cálculo'
    };
    if(r.bultos>0) conSug++;
    if(!r.rot) sinDatos++;
  });

  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
  showT('✓ '+conSug+' artículo(s) con sugerencia de reposición');

  // 2) La AI revisa los que tienen movimiento, para afinar
  var paraIA=items.filter(function(x){
    var s=window._repSugIA[String(x.itemcode||'').trim().toUpperCase()];
    return s && s.rot>0;
  }).slice(0, 120);      // un tope, para no eternizar el análisis

  if(!paraIA.length){
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-sparkles"></i> Sugerencia IA'; }
    return;
  }

  var TANDA=25, total=Math.ceil(paraIA.length/TANDA), hechas=0, ajustados=0;
  for(var i=0;i<paraIA.length;i+=TANDA){
    estado('<span class="ai-ring"></span> Revisando con AI… '+(hechas+1)+'/'+total);
    try{
      var res=await _repSugLote(paraIA.slice(i,i+TANDA));
      (res||[]).forEach(function(r){
        if(!r || !r.sku) return;
        var k=String(r.sku).trim().toUpperCase();
        var prev=window._repSugIA[k];
        if(!prev) return;
        var nb=Number(r.bultos);
        if(!isNaN(nb) && nb>=0 && nb!==prev.bultos){
          prev.bultos=nb;
          prev.razon=String(r.razon||prev.razon).slice(0,200);
          prev.fuente='AI';
          ajustados++;
        }
      });
    }catch(e){ console.warn('[reposición] la AI no pudo revisar esta tanda:', e.message||e); }
    hechas++;
  }

  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-sparkles"></i> Sugerencia IA'; }
  if(ajustados) showT('✓ La AI ajustó '+ajustados+' sugerencia(s)');
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}

async function _repSugLote(lote){
  var filas=lote.map(function(x){
    var k=String(x.itemcode||'').trim().toUpperCase();
    var s=window._repSugIA[k]||{};
    return {
      sku:x.itemcode,
      desc:String(x.itemname||'').slice(0,50),
      disponible:_repDisp(x),
      por_llegar:Number(x.onorder)||0,
      ultima_compra_piezas:Number(x.u_cant_ult_ent)||0,
      meses_desde_ultima_entrada:(function(){ var m=_repMesesDe(_repFechaEnt(x)); return m?Math.round(m*10)/10:null; })(),
      historico_comprado:Number(x.hist_comprado)||0,
      piezas_por_bulto:_repBultos(x),
      rotacion_mensual_estimada:Math.round(s.rot||0),
      sugerencia_calculada_bultos:s.bultos||0
    };
  });

  var prompt='Sos el analista de compras de KENNEDY CENTER CORP, mayorista en Panama.\n'
    +'Ya hay una sugerencia calculada para cada articulo. Tu trabajo es REVISARLA '
    +'y corregirla solo si esta claramente mal.\n\n'
    +'CRITERIOS:\n'
    +'- Objetivo: tener 6 meses de inventario.\n'
    +'- Lo que esta en "por_llegar" YA viene en camino: no hay que volver a pedirlo. '
    +'Solo se pide mas si aun con eso no alcanza para el periodo.\n'
    +'- Si "meses_desde_ultima_entrada" es mayor a 30 y el historico es bajo, el articulo '
    +'rota poco: sugerir 0 o muy poco.\n'
    +'- Si el disponible esta en cero y el articulo rota, priorizar la reposicion.\n'
    +'- La respuesta va en BULTOS ENTEROS, nunca en piezas.\n\n'
    +'ARTICULOS:\n'+JSON.stringify(filas)+'\n\n'
    +'Devuelve SOLO un array JSON, sin texto antes ni despues:\n'
    +'[{"sku":"","bultos":0,"razon":""}]\n\n'
    +'Incluí TODOS los articulos, aunque no cambies su cantidad. '
    +'La "razon" en una frase corta en espanol.';

  var obj=await _iaJSON([{type:'text', text:prompt}], 4000);
  if(Array.isArray(obj)) return obj;
  if(obj && Array.isArray(obj.articulos)) return obj.articulos;
  if(obj && Array.isArray(obj.items)) return obj.items;
  if(obj && Array.isArray(obj.resultado)) return obj.resultado;
  console.warn('[reposición] la AI devolvió algo inesperado:', obj);
  return [];
}

// Pasa la sugerencia al campo de reposición
// El motivo de la sugerencia, al pasar el mouse por el signo de pregunta
function _sugMotivoOcultar(){
  var p=document.getElementById('sugMotivo');
  if(p) p.remove();
}

function _sugMotivo(ev, itemcode){
  _sugMotivoOcultar();
  var k=String(itemcode||'').trim().toUpperCase();
  var s=window._repSugIA[k];
  if(!s) return;
  var x=(_repData||[]).find(function(r){ return String(r.itemcode).toUpperCase()===k; });
  var ub=x?_repBultos(x):1;
  var b=Number(s.bultos)||0;

  var caja=document.createElement('div');
  caja.id='sugMotivo';
  caja.style.cssText='position:fixed;z-index:13500;background:var(--surface-0);'
    +'border:1px solid #5B21B6;border-radius:10px;box-shadow:0 10px 34px rgba(0,0,0,.3);'
    +'padding:11px 13px;max-width:380px;pointer-events:none';

  var h='<div style="font-size:11px;font-weight:800;color:var(--t-lila);text-transform:uppercase;margin-bottom:5px">'
    +'<i class="ti ti-sparkles"></i> Por qué esta sugerencia</div>'
    +'<div style="font-size:12px;font-weight:700;margin-bottom:6px">'
    +(b>0?(b+' bulto(s) · '+(b*ub)+' piezas'):'No hace falta reponer')
    +(b>0&&x?_repMargenBadge(x):'')+'</div>'
    +(function(){
        if(!x || !(b>0)) return '';
        var m=_repMargenItem(x);
        if(m===null || m>=REP_MARGEN_MIN) return '';
        var pv=Number(x.precioventa)||Number(x.precio_venta)||Number(x.precio1)||0;
        var co=Number(x.lastpurprc)||Number(x.u_precio_ult_ent)||Number(x.costo)||0;
        return '<div style="background:var(--pastel-error);border:0.5px solid #f0b4b4;border-radius:8px;'
          +'padding:7px 9px;margin-bottom:7px;font-size:11px;color:var(--t-rojo3);line-height:1.45">'
          +'<b><i class="ti ti-arrow-down"></i> Ganancia baja: '+m.toFixed(1)+'%</b><br>'
          +'La última vez se compró a '+fmt(co)+' y se vende a '+fmt(pv)+'. '
          +(m<0?'Se está vendiendo por debajo del costo. ':'')
          +'Antes de reponer, conviene revisar el precio con el proveedor.</div>';
      })()
    +'<div style="font-size:11.5px;color:var(--text-secondary);line-height:1.5">'+_esc(s.razon||'')+'</div>';

  // El detalle que se usó para el cálculo
  if(x){
    h+='<div style="margin-top:8px;padding-top:7px;border-top:0.5px solid var(--border);'
      +'font-size:10.5px;color:var(--text-muted);line-height:1.6">'
      +'<div>Disponible: <b>'+_fmtN2(_repDisp(x))+'</b>'
        +((Number(x.onorder)||0)>0?(' · Por llegar: <b style="color:#C9A800">'+_fmtN2(x.onorder)+'</b>'):'')+'</div>'
      +'<div>Última compra: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b>'
        +(_repFechaEnt(x)?(' el '+_esc(_fmtFechaCorta(_repFechaEnt(x)))):'')+'</div>'
      +'<div>Histórico comprado: <b>'+_fmtN2(x.hist_comprado)+'</b></div>'
      +(s.rot?('<div>Rotación estimada: <b>'+_fmtN2(Math.round(s.rot))+'/mes</b>'
        +(s.base?(' (según '+_esc(s.base)+')'):'')+'</div>'):'')
      +'<div style="margin-top:4px;font-size:9.5px;font-style:italic">'
        +'La rotación sale de repartir lo comprado (o vendido) en los últimos '
        +'3 años entre esos 36 meses.</div>'
      +'<div>Piezas por bulto: <b>'+ub+'</b></div>'
      +'</div>';
  }
  h+='<div style="margin-top:6px;font-size:9.5px;color:var(--text-muted);font-style:italic">'
    +(s.fuente==='AI'?'Ajustado por la AI':'Calculado con los datos del artículo')+'</div>';
  caja.innerHTML=h;
  document.body.appendChild(caja);

  // Se ubica junto al cursor, sin salirse de la pantalla
  var x0=(ev&&ev.clientX)||100, y0=(ev&&ev.clientY)||100;
  var an=caja.offsetWidth||380, al=caja.offsetHeight||200;
  var izq=x0+14;
  if(izq+an > window.innerWidth-10) izq=Math.max(10, x0-an-14);
  var arr=y0+14;
  if(arr+al > window.innerHeight-10) arr=Math.max(10, window.innerHeight-al-10);
  caja.style.left=izq+'px';
  caja.style.top=arr+'px';
}

function _repUsarSugIA(itemcode){
  var s=window._repSugIA[String(itemcode||'').trim().toUpperCase()];
  if(!s || !(Number(s.bultos)>0)){ showT('No hay sugerencia para ese artículo'); return; }
  var x=(_repData||[]).find(function(r){ return String(r.itemcode)===String(itemcode); });
  if(!x) return;
  var piezas=(Number(s.bultos)||0)*_repBultos(x);
  try{ repCantSet(itemcode, piezas); }catch(e){ console.warn('cargar sugerencia:',e); }
  showT('✓ '+s.bultos+' bulto(s) = '+piezas+' piezas');
}

function _repUsarTodasSugIA(){
  var n=Object.keys(window._repSugIA||{}).filter(function(k){
    return Number(window._repSugIA[k].bultos)>0; }).length;
  if(!n){ showT('Todavía no hay sugerencias. Pulsa "Sugerencia IA".'); return; }
  if(!confirm('¿Cargar las '+n+' sugerencias en la reposición?\n\n'
    +'Se pisan las cantidades que hayas puesto a mano.')) return;
  var puestas=0;
  (_repData||[]).forEach(function(x){
    var s=window._repSugIA[String(x.itemcode||'').trim().toUpperCase()];
    if(!s || !(Number(s.bultos)>0)) return;
    var piezas=(Number(s.bultos)||0)*_repBultos(x);
    try{ repCantSet(x.itemcode, piezas); puestas++; }catch(e){}
  });
  showT('✓ '+puestas+' cantidad(es) cargada(s)');
}

// Cambia el horizonte de cobertura y recalcula
function _repMesesSug(){
  var v=prompt('¿Para cuántos meses de inventario quieres reponer?\n\n'
    +'Por defecto son 6 meses.', String(window._repMesesObjetivo||6));
  if(v===null) return;
  var n=parseFloat(v);
  if(isNaN(n) || n<=0 || n>24){ showT('Poné un número de meses entre 1 y 24'); return; }
  window._repMesesObjetivo=n;
  _repSugerirIA();
}

function _repFilaItem(x){
  var h='';
        var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
        var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);   // piezas por bulto
        // Muchos artículos no tienen picturname en SAP (los tres de P2273, por
        // ejemplo): sin esto la fila ni siquiera intentaba cargar una imagen y
        // pintaba el icono gris. La ficha sí los enseña porque cae a la foto
        // del catálogo NO SAP, que suele ser la única que existe.
        var _fotoAlt=_fotoNoSapDeSku(x.itemcode);
        var foto=_repFotoUrl(x.picturname) || _fotoAlt;
        var ic=_esc(String(x.itemcode));
        h+='<div class="rep-item-row" data-ic="'+ic+'" data-bulto="'+bulto+'" style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-bottom:0.5px solid var(--border)">'
          // Foto
          +'<div style="width:52px;height:52px;flex-shrink:0;border:0.5px solid var(--border);border-radius:6px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center'+(foto?';cursor:zoom-in':'')+'"'+(foto?' onclick="_repZoomFoto(\''+encodeURIComponent(foto)+'\',\''+_esc(String(x.itemcode))+'\')" onmouseenter="_repHoverShow(event,\''+encodeURIComponent(foto)+'\')" onmousemove="_repHoverMove(event)" onmouseleave="_repHoverHide()"':'')+'>'
            // Y si el nombre de SAP existe pero el archivo del bucket tiene otra
            // extensión o mayúsculas, _costFotoAlt prueba las variantes, igual
            // que hace la ficha del artículo.
            +(foto?'<img data-nosap="'+_esc(_fotoAlt||'')+'" src="'+_esc(foto)+'"'
                  +' style="width:100%;height:100%;object-fit:cover"'
                  +' onerror="_costFotoAlt(this,&quot;'
                  // Fuera comillas y barras del nombre: van dentro de una cadena
                  // JS que está dentro de un atributo HTML, y una comilla suelta
                  // rompería la fila entera.
                  +_esc(String(x.picturname||'').replace(/["'\\]/g,''))+'&quot;)">'
                 :'<i class="ti ti-photo-off" style="color:var(--text-muted);font-size:16px"></i>')
          +'</div>'
          // Info
          +'<div style="flex:1;min-width:0">'
            +'<div style="font-size:12px;font-weight:600"><span onclick="event.stopPropagation();_invFicha(\''+ic+'\')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline">'+ic+'</span> <span style="font-weight:400;color:var(--text-secondary)">'+_esc(x.itemname||'')+'</span></div>'
            // v765: si ya va en OTRA reposición, se dice aquí también
            +(function(){
                var er=_repItemEnCurso(x.itemcode, _repPedidoId);
                if(!er) return '';
                var col=REP_ESTADO_COLOR[er.estado]||{c:'#B45309', bg:'#FDF0DC', bd:'#E9C08A'};
                return '<div style="margin-top:3px;font-size:11px;font-weight:700;color:'+col.c+';'
                  +'display:inline-flex;align-items:center;gap:5px;background:'+col.bg+';'
                  +'border:1px solid '+col.bd+';border-radius:7px;padding:2px 8px;cursor:pointer" '
                  +'onclick="event.stopPropagation();_repIrAReposicion(\''+_esc(er.codigo)+'\')" '
                  +'title="Ver esa reposición"><i class="ti ti-alert-circle"></i> YA ESTÁ SOLICITADA EN LA '
                  +_esc(er.codigo)+(er.cant?(' ('+_fmtN2(er.cant)+' pz)'):'')
                  +' · '+_esc(_repTxtEstado(er))+'</div>';
              })()
            +'<div style="display:flex;gap:6px 14px;flex-wrap:wrap;font-size:12.5px;color:var(--text-secondary);margin-top:4px;line-height:1.5">'
              +'<span>Stock: <b>'+_fmtN2(x.onhand)+'</b></span>'
              +'<span onclick="event.stopPropagation();verSeparado(\''+ic+'\')" title="Ver quién lo tiene separado" style="cursor:pointer">Sep: <b style="color:var(--t-rojo2);text-decoration:underline">'+_fmtN2(x.iscommited)+'</b></span>'
              +'<span>Disp: <b style="color:var(--text-success)">'+_fmtN2(disp)+'</b>'
                +(bulto>1?(' <span style="color:var(--t-lila2);font-size:11.5px">(bultos: <b>'
                  +_fmtN2(Math.floor(disp/bulto))
                  +((disp%bulto)?('<span style="font-weight:400"> + '+_fmtN2(disp%bulto)+' pz</span>'):'')
                  +'</b>)</span>'):'')
                +'</span>'
              +'<span>Por lleg: <b style="color:#C9A800">'+_fmtN2(x.onorder)+'</b>'
          +((Number(x.onorder)>0 && _invLlegadaTxt(x))
            ? (' <span style="font-size:10.5px;color:'+_invLlegadaColor(x)+'">('+_esc(_invLlegadaTxt(x))+')</span>')
            : '')
          +'</span>'
              +'<span>Bulto: <b>'+bulto+' pz</b></span>'
              +'<span title="Cantidad de la última compra">Últ. compra: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b>'
                +((bulto>1 && (Number(x.u_cant_ult_ent)||0)>0)
                  ?(' <span style="color:var(--t-lila2);font-size:11.5px">(bultos: <b>'
                    +_fmtN2(Math.floor((Number(x.u_cant_ult_ent)||0)/bulto))
                    +(((Number(x.u_cant_ult_ent)||0)%bulto)?('<span style="font-weight:400"> + '+_fmtN2((Number(x.u_cant_ult_ent)||0)%bulto)+' pz</span>'):'')
                    +'</b>)</span>'):'')+(x.u_nentrada?(' ('+_esc(x.u_nentrada)+')'):'')+'</span>'
              +'<span title="Total histórico comprado: facturas de compra menos notas de crédito. Mismo criterio que el reporte Purchase Analysis by Item de SAP.">Hist. comprado: <b style="color:var(--t-lila)">'+(Number(x.hist_comprado)?_fmtN2(x.hist_comprado):'—')+'</b></span>'
              +(x.u_fentrada?('<span title="Fecha de entrada al inventario">Fecha entrada: <b>'+_esc(_fmtFechaCorta(x.u_fentrada))+'</b></span>'):'')
              +(CU.verCostos
                ? ('<span>FOB: <b>'+_fmtN2(x.fob)+'</b></span>'
                   +'<span title="Costo puesto en bodega: FOB más flete y gastos">CIF: <b style="color:var(--t-marron)">'
                     +_fmtN2(x.cif)+'</b></span>'
                   +'<span>Precio: <b>'+_fmtN2(x.precio1)+'</b></span>'
                   +_repMargenCampo(x))
                : '')
            +'</div>'
            +(function(){
              // Mostrar si esta referencia está en órdenes No SAP (ya pedida)
              var enNoSAP=_repEnOrdenesNoSAP(x.itemcode);
              if(!enNoSAP.length) return '';
              var totNoSAP=enNoSAP.reduce(function(s,o){return s+o.cantidad;},0);
              return '<div style="margin-top:4px;font-size:10px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:6px;padding:4px 8px;color:var(--t-ambar)">'
                +'<i class="ti ti-file-invoice"></i> Ya pedido en Borrador: <b>'+totNoSAP+' und</b> · '
                +enNoSAP.map(function(o){
                  var precioTxt=(CU.verCostos&&o.precio_unit)?(' @'+_fmtN2(o.precio_unit)):'';
                  var fechaTxt=o.fecha?(' · '+_esc(_fmtFechaCorta(o.fecha))):'';
                  return '<span onclick="event.stopPropagation();abrirPendSAP(\''+_esc(String(o.dkc).replace(/\x27/g,''))+'\')" style="cursor:pointer;text-decoration:underline;font-weight:600">'+_esc(o.orden)+' ('+o.cantidad+precioTxt+fechaTxt+')</span>';
                }).join(' · ')
              +'</div>';
            })()
          +'</div>'
          // Sugerencia de la AI, si ya se calculó
          +(function(){
            var sg=window._repSugIA[String(x.itemcode||'').trim().toUpperCase()];
            if(!sg) return '';
            var b=Number(sg.bultos)||0;
            var pz=b*bulto;
            var enCam=Number(sg.enCamino)||0;
            return '<div style="flex-shrink:0;text-align:center;border:1px solid '+(b>0?'#5B21B6':'var(--border)')+';'
              +'border-radius:8px;padding:4px 9px;background:'+(b>0?'#F7F5FF':'var(--surface-1)')+';cursor:'+(b>0?'pointer':'default')+'" '
              +(b>0?('onclick="event.stopPropagation();_repUsarSugIA(\''+ic+'\')" '):'')
              +'title="'+_esc(sg.razon||'Sin sugerencia')+'">'
              +'<div style="font-size:8px;color:var(--t-lila);font-weight:700;text-transform:uppercase;'
                +'display:flex;align-items:center;justify-content:center;gap:3px">Sugerencia IA'
                +'<span class="sug-ayuda" onmouseenter="_sugMotivo(event,\''+ic+'\')" onmouseleave="_sugMotivoOcultar()" '
                +'onclick="event.stopPropagation();_sugMotivo(event,\''+ic+'\')" '
                +'style="display:inline-flex;align-items:center;justify-content:center;width:13px;height:13px;'
                +'border-radius:50%;background:#5B21B6;color:#fff;font-size:9px;font-weight:800;cursor:help;'
                +'flex-shrink:0">?</span></div>'
              +'<div style="font-size:13px;font-weight:800;color:'+(b>0?'#5B21B6':'var(--text-muted)')+'">'+b+' <span style="font-size:9px">blt</span>'
                +(b>0?_repMargenBadge(x):'')+'</div>'
              +(b>0?('<div style="font-size:8.5px;color:var(--text-muted)">'+pz+' pz · usar</div>'):'')
              +(enCam>0?('<div style="font-size:8px;color:#C9A800;font-weight:700">ya viene '+_fmtN2(enCam)+'</div>'):'')
              +'</div>';
          })()
          // Controles: piezas y bultos EN LÍNEA (lado a lado) + conversión bidireccional
          +'<div style="display:flex;flex-direction:row;align-items:center;gap:14px;flex-shrink:0;flex-wrap:wrap;justify-content:flex-end">'
            // Grupo piezas
            +'<div style="display:flex;align-items:center;gap:4px">'
              +'<button onclick="repCantAjustar(\''+ic+'\',-1)" title="Quitar 1 pieza" style="width:24px;height:26px;border:0.5px solid var(--border);background:var(--surface-1);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--text-danger)">−</button>'
              +'<div style="display:flex;flex-direction:column;align-items:center">'
                +'<input id="rep-qty-'+ic+'" type="number" min="0" value="'+(_repCarrito[x.itemcode]||0)+'" onchange="repCantSet(\''+ic+'\',this.value)" style="width:70px;text-align:center;padding:4px;border:0.5px solid var(--border);border-radius:6px;font-size:13px;font-weight:600" title="Piezas">'
                +'<span style="font-size:8px;color:var(--text-muted)">piezas</span>'
              +'</div>'
              +'<button onclick="repCantAjustar(\''+ic+'\',1)" title="Agregar 1 pieza" style="width:24px;height:26px;border:0.5px solid var(--border);background:var(--surface-1);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--text-success)">+</button>'
            +'</div>'
            // Fila bultos
            +'<div style="display:flex;align-items:center;gap:4px">'
              +'<button onclick="repAjustarBulto(\''+ic+'\',-1,'+bulto+')" title="Quitar 1 bulto ('+bulto+' pz)" style="width:24px;height:24px;border:0.5px solid #C4B5FD;background:var(--pastel-lila);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--t-lila2)">−</button>'
              +'<div style="display:flex;flex-direction:column;align-items:center">'
                +'<input id="rep-blt-'+ic+'" type="number" min="0" step="0.01" value="'+(_repCarrito[x.itemcode]?(Math.round((_repCarrito[x.itemcode]/bulto)*100)/100):0)+'" onchange="repBultoSet(\''+ic+'\',this.value,'+bulto+')" style="width:70px;text-align:center;padding:4px;border:0.5px solid #C4B5FD;border-radius:6px;font-size:13px;font-weight:600;color:var(--t-lila2)" title="Bultos">'
                +'<span style="font-size:8px;color:var(--t-lila2)">bultos ×'+bulto+'</span>'
              +'</div>'
              +'<button onclick="repAjustarBulto(\''+ic+'\',1,'+bulto+')" title="Agregar 1 bulto ('+bulto+' pz)" style="width:24px;height:24px;border:0.5px solid #C4B5FD;background:var(--pastel-lila);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--t-lila2)">+</button>'
            +'</div>'
          +'</div>'
        +'</div>';
  return h;
}

// ═══════════════════════════════════════════════════════════════════════════
//  ORDEN Y FILTRO DEL LISTADO DE REPOSICIÓN
//  Se guardan en memoria para que el listado se repinte sin volver a consultar.
// ═══════════════════════════════════════════════════════════════════════════
// Por defecto, la entrada más reciente primero
window._repOrden='entrada';    // entrada | entrada_v | grupo | sku | desc | stock | disp | hist
window._repAgrupar=true;       // agrupar por grupo de artículo
window._repFiltroItem='';      // texto para filtrar dentro del proveedor

var _REP_ORDENES={
  entrada:'Entrada  más reciente primero (por defecto)',
  entrada_v:'Entrada  más vieja primero',
  grupo:  'Grupo de artículo',
  sku:    'SKU  A → Z',
  sku_z:  'SKU  Z → A',
  desc:   'Descripción  A → Z',
  desc_z: 'Descripción  Z → A',
  stock:  'Stock  menor primero',
  disp:   'Disponible  menor primero',
  hist:   'Hist. comprado  mayor primero'
};

function _repCmpTexto(a,b){ return String(a||'').localeCompare(String(b||''),'es',{numeric:true,sensitivity:'base'}); }
function _repDisp(x){ return (Number(x.onhand)||0)-(Number(x.iscommited)||0); }

// Compara por fecha de entrada. Los que no tienen fecha van siempre al final,
// para que no ensucien el orden.
// La fecha de entrada viaja con dos nombres distintos: "fechaentrada" en el
// tablero de reposiciones y "u_fentrada" en el catálogo del proveedor. Se
// miran los dos: buscar solo uno hacía que el orden no se aplicara.
function _repFechaEnt(x){
  return (x && (x.u_fentrada || x.fechaentrada || x.fecha_entrada)) || '';
}

function _repCmpEntrada(viejaPrimero){
  return function(a,b){
    var da=_repParseFecha(_repFechaEnt(a)), db=_repParseFecha(_repFechaEnt(b));
    if(!da && !db) return _repCmpTexto(a.itemcode,b.itemcode);
    if(!da) return 1;
    if(!db) return -1;
    var dif=viejaPrimero ? (da-db) : (db-da);
    return dif!==0 ? dif : _repCmpTexto(a.itemcode,b.itemcode);
  };
}

function _repOrdenar(list){
  var l=list.slice();
  switch(window._repOrden){
    case 'sku':    l.sort(function(a,b){ return _repCmpTexto(a.itemcode,b.itemcode); }); break;
    case 'sku_z':  l.sort(function(a,b){ return _repCmpTexto(b.itemcode,a.itemcode); }); break;
    case 'desc':   l.sort(function(a,b){ return _repCmpTexto(a.itemname,b.itemname); }); break;
    case 'desc_z': l.sort(function(a,b){ return _repCmpTexto(b.itemname,a.itemname); }); break;
    case 'stock':  l.sort(function(a,b){ return (Number(a.onhand)||0)-(Number(b.onhand)||0); }); break;
    case 'disp':   l.sort(function(a,b){ return _repDisp(a)-_repDisp(b); }); break;
    case 'hist':   l.sort(function(a,b){ return (Number(b.hist_comprado)||0)-(Number(a.hist_comprado)||0); }); break;
    case 'entrada':   l.sort(_repCmpEntrada(false)); break;
    case 'entrada_v': l.sort(_repCmpEntrada(true));  break;
    case 'grupo':  l.sort(function(a,b){ return _repCmpTexto(a.itemcode,b.itemcode); }); break;
    // Por defecto: la entrada más reciente primero
    default:       l.sort(_repCmpEntrada(false));
  }
  return l;
}

// Filtro por situación de stock
//  · sin      -> disponible en cero
//  · bajo50   -> tiene disponible, pero cayó por debajo de la mitad de lo que
//                entró en la última compra
window._repFiltroStock='todos';

function _repCumpleStock(x){
  var f=window._repFiltroStock||'todos';
  if(f==='todos') return true;
  var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
  if(f==='sin') return disp<=0;
  if(f==='bajo50'){
    var ult=Number(x.u_cant_ult_ent)||0;
    if(ult<=0) return false;          // sin última entrada no hay con qué comparar
    return disp>0 && disp < (ult/2);
  }
  return true;
}

function _repFiltrarItems(list){
  list=(list||[]).filter(_repCumpleStock);
  var q=String(window._repFiltroItem||'').trim().toLowerCase();
  if(!q) return list;
  return list.filter(function(x){
    return String(x.itemcode||'').toLowerCase().indexOf(q)>=0
        || String(x.itemname||'').toLowerCase().indexOf(q)>=0
        || String(x.frgnname||'').toLowerCase().indexOf(q)>=0
        || String(x.codebars||'').toLowerCase().indexOf(q)>=0;
  });
}

// Repinta el listado con el orden y filtro actuales, sin volver a consultar
function _repReordenar(v){
  if(v!=null) window._repOrden=v;
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}
function _repToggleAgrupar(chk){
  window._repAgrupar=!!chk;
  _repReordenar();
}
function _repFiltrarAhora(v){
  window._repFiltroItem=v;
  if(!_repData || !_repData.length) return;
  // Se repinta solo la lista, para no perder el foco del cuadro de búsqueda
  var cont=document.getElementById('rep-lista');
  if(!cont){ repRenderResumen(_repData, _repCard); return; }
  cont.innerHTML=_repListaHTML(_repData);
  var cnt=document.getElementById('rep-cnt-filtro');
  if(cnt){
    var n=_repFiltrarItems(_repData).length;
    cnt.textContent=(n===_repData.length)?(_repData.length+' referencias'):(n+' de '+_repData.length+' referencias');
  }
  repActualizarCarrito();
}

// HTML del listado, agrupado o en lista única según la preferencia
function _repListaHTML(rows){
  var vis=_repFiltrarItems(rows);
  if(!vis.length){
    return '<div class="empty" style="padding:18px;color:var(--text-muted)">'
      +'<i class="ti ti-search-off" style="font-size:20px"></i><br>Ningún ítem coincide con "'+_esc(window._repFiltroItem)+'".</div>';
  }
  var h='';
  // Al ordenar por fecha de entrada, el agrupamiento por grupo se deja de
  // lado: si no, el orden se aplica solo dentro de cada grupo y en pantalla
  // se ven fechas viejas arriba.
  var _porFecha=(window._repOrden==='entrada'||window._repOrden==='entrada_v');
  if(window._repAgrupar && !_porFecha){
    var porGrupo={};
    vis.forEach(function(x){ var g=(x.grupo_cod||'')+' '+(x.grupo_nom||'Sin grupo'); (porGrupo[g]=porGrupo[g]||[]).push(x); });
    Object.keys(porGrupo).sort(_repCmpTexto).forEach(function(g){
      var list=_repOrdenar(porGrupo[g]);
      h+='<div style="margin-bottom:12px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden">'
        +'<div style="background:var(--surface-2);padding:7px 12px;font-size:12px;font-weight:600;border-bottom:0.5px solid var(--border)">'+_esc(g)+' <span style="color:var(--text-muted);font-weight:400">· '+list.length+' items</span></div>';
      list.forEach(function(x){ h+=_repFilaItem(x); });
      h+='</div>';
    });
  } else {
    var list=_repOrdenar(vis);
    h+='<div style="margin-bottom:12px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden">'
      +'<div style="background:var(--surface-2);padding:7px 12px;font-size:12px;font-weight:600;border-bottom:0.5px solid var(--border)">'+_esc(_porFecha ? ('Por fecha de entrada · '+(window._repOrden==='entrada_v'?'más antigua primero':'más reciente primero')) : 'Todos los ítems')+'<span style="color:var(--text-muted);font-weight:400"> · '+list.length+' items</span></div>';
    list.forEach(function(x){ h+=_repFilaItem(x); });
    h+='</div>';
  }
  return h;
}

// Barra de orden y filtro
// Botones para filtrar por situación de stock
function _repBarraStock(rows){
  var defs=[
    {k:'todos',  l:'Todos',                    c:'var(--text-secondary)', t:'Todas las referencias del proveedor'},
    {k:'sin',    l:'Sin disponible',           c:'#DC2626', t:'Disponible en cero: stock menos separado'},
    {k:'bajo50', l:'Bajó del 50% de la última llegada', c:'#EA580C', t:'Tienen disponible, pero quedan menos de la mitad de las piezas que entraron en la última compra'}
  ];
  var act=window._repFiltroStock||'todos';
  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
    +'<span style="font-size:11.5px;color:var(--text-secondary);font-weight:600"><i class="ti ti-filter"></i> Stock</span>';
  defs.forEach(function(d){
    var cont=(rows||[]).filter(function(x){
      var g=window._repFiltroStock; window._repFiltroStock=d.k;
      var ok=_repCumpleStock(x); window._repFiltroStock=g; return ok;
    }).length;
    var on=(act===d.k);
    h+='<button onclick="_repSetStock(\''+d.k+'\')" title="'+_esc(d.t)+'" style="border:1px solid '+(on?d.c:'var(--border)')+';'
      +'background:'+(on?d.c:'var(--surface-1)')+';color:'+(on?'#fff':d.c)+';'
      +'border-radius:20px;padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +d.l+' <span style="opacity:.8;font-weight:400">'+cont+'</span></button>';
  });
  // Botón para ordenar por fecha de entrada. No filtra: siempre se ven todos
  // los SKU, solo cambia el orden en que aparecen.
  var porEntrada=(window._repOrden==='entrada'||window._repOrden==='entrada_v');
  var vieja=(window._repOrden==='entrada_v');
  // Si se está corrigiendo una reposición ya enviada, se avisa
  try{ h+=_repModificandoAviso(); }catch(e){}

  // Sugerencia de la AI: propone bultos a reponer por artículo
  var haySug=Object.keys(window._repSugIA||{}).length>0;
  h+='<span style="width:1px;height:20px;background:var(--border);margin:0 4px"></span>'
    +'<button id="rep-ia-btn" onclick="_repSugerirIA()" '
    +'title="La AI revisa disponibilidad, última entrada y el histórico de cada artículo y sugiere cuántos bultos reponer." '
    +'style="border:1px solid #5B21B6;background:'+(haySug?'#F7F5FF':'#5B21B6')+';color:'+(haySug?'#5B21B6':'#fff')+';'
    +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
    +'<i class="ti ti-sparkles"></i> Sugerencia IA'+(haySug?' · recalcular':'')+'</button>'
    +(haySug?('<button onclick="_repMesesSug()" title="Cambiar para cuántos meses reponer" '
      +'style="border:1px solid var(--border);background:var(--surface-1);color:var(--text-secondary);'
      +'border-radius:20px;padding:4px 10px;font-size:10.5px;cursor:pointer">'
      +(window._repMesesObjetivo||6)+' meses</button>'):'')
    +(haySug?('<button onclick="_repUsarTodasSugIA()" title="Cargar todas las sugerencias en la reposición" '
      +'style="border:1px solid #5B21B6;background:var(--surface-1);color:var(--t-lila);border-radius:20px;'
      +'padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +'<i class="ti ti-checks"></i> Usar todas</button>'):'')
    +'<span style="width:1px;height:20px;background:var(--border);margin:0 4px"></span>'
    +'<button onclick="_topAbrir()" '
    +'title="Los artículos más vendidos de los últimos 3 años que ya están por debajo de la mitad de la última compra y no tienen nada en camino." '
    +'style="border:1px solid #EA580C;background:var(--surface-1);color:#EA580C;'
    +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
    +'<i class="ti ti-flame"></i> Top selling items</button>'
    +'<span style="width:1px;height:20px;background:var(--border);margin:0 4px"></span>'
    +'<button onclick="_repToggleEntrada()" '
    +'title="Ordena la lista por fecha de llegada. No oculta ningún artículo." '
    +'style="border:1px solid '+(porEntrada?'#1D4ED8':'var(--border)')+';'
    +'background:'+(porEntrada?'#1D4ED8':'var(--surface-1)')+';color:'+(porEntrada?'#fff':'#1D4ED8')+';'
    +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
    +'<i class="ti ti-calendar"></i> Fecha de entrada · '
    +(vieja?'más antigua primero':'más reciente primero')+'</button>';
  return h+'</div>';
}

// Alterna entre reciente primero y antigua primero
function _repToggleEntrada(){
  window._repOrden = (window._repOrden==='entrada') ? 'entrada_v' : 'entrada';
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}

function _repSetStock(k){
  window._repFiltroStock=k;
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}

function _repBarraOrden(rows){
  var n=_repFiltrarItems(rows).length;
  var opts=Object.keys(_REP_ORDENES).map(function(k){
    return '<option value="'+k+'"'+((window._repOrden===k)?' selected':'')+'>'+_REP_ORDENES[k]+'</option>';
  }).join('');
  return '<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;padding:9px 12px;margin-bottom:12px">'
    +'<span style="font-size:11.5px;color:var(--text-secondary);font-weight:600"><i class="ti ti-arrows-sort"></i> Ordenar</span>'
    +'<select onchange="_repReordenar(this.value)" style="padding:5px 9px;border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'+opts+'</select>'
    +'<label style="display:flex;align-items:center;gap:5px;font-size:11.5px;color:var(--text-secondary);cursor:pointer">'
      +'<input type="checkbox" onchange="_repToggleAgrupar(this.checked)"'+(window._repAgrupar?' checked':'')
      +((window._repOrden==='entrada'||window._repOrden==='entrada_v')?' disabled title="Al ordenar por fecha de entrada no se agrupa: la lista va toda seguida por fecha."':'')
      +' style="cursor:pointer"> Agrupar por grupo</label>'
    +'<div style="flex:1;min-width:150px;display:flex;align-items:center;gap:6px">'
      +'<i class="ti ti-search" style="color:var(--text-muted);font-size:13px"></i>'
      +'<input id="rep-filtro-item" value="'+_esc(window._repFiltroItem||'')+'" oninput="_repFiltrarAhora(this.value)" placeholder="Filtrar por SKU, descripción o código de barras" style="flex:1;padding:5px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
      +(window._repFiltroItem?'<span onclick="document.getElementById(\'rep-filtro-item\').value=\'\';_repFiltrarAhora(\'\')" style="cursor:pointer;color:var(--text-muted);font-size:15px" title="Limpiar">&times;</span>':'')
    +'</div>'
    +'<span id="rep-cnt-filtro" style="font-size:11px;color:var(--text-muted);white-space:nowrap">'+((n===rows.length)?(rows.length+' referencias'):(n+' de '+rows.length+' referencias'))+'</span>'
    +'</div>'
    +_repBarraStock(rows);
}

// Trabajar la reposición a pantalla completa: la lista se hace incómoda
// dentro del ancho normal cuando hay cientos de artículos.
function _repPantallaCompleta(){
  window._repFull=!window._repFull;
  var b=document.body;
  if(window._repFull){
    b.classList.add('rep-full');
    // Un botón fijo arriba a la derecha, para salir desde cualquier punto
    if(!document.getElementById('repFullSalir')){
      var btn=document.createElement('button');
      btn.id='repFullSalir';
      btn.className='rep-full-salir';
      btn.innerHTML='<i class="ti ti-arrows-minimize"></i> Salir de pantalla completa';
      btn.onclick=_repPantallaCompleta;
      document.body.appendChild(btn);
    }
    // Se recuerda dónde estaba para volver al mismo punto
    window._repScrollPrev=window.scrollY;
    showT('Pantalla completa · Esc para salir');
    if(!window._repEscHandler){
      window._repEscHandler=function(ev){
        if(ev.key==='Escape' && window._repFull) _repPantallaCompleta();
      };
      document.addEventListener('keydown', window._repEscHandler);
    }
  } else {
    b.classList.remove('rep-full');
    var vb=document.getElementById('repFullSalir');
    if(vb) vb.remove();
  }
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
  if(!window._repFull && window._repScrollPrev!=null){
    setTimeout(function(){ window.scrollTo(0, window._repScrollPrev); }, 30);
  }
}

// Lo que el proveedor tiene HOY: unidades en existencia y cuánto valen, al
// costo y a precio de venta. Es el mismo total que sale en el PDF, pero a la
// vista antes de generarlo.
function _repTotalesHtml(rows){
  var t={unid:0, disp:0, cif:0, venta:0, porLlegar:0};
  (rows||[]).forEach(function(x){
    var ex=Number(x.onhand)||0;
    t.unid+=ex;
    t.disp+=ex-(Number(x.iscommited)||0);
    t.cif+=ex*(Number(x.cif)||0);
    t.venta+=ex*(Number(x.precioventa)||Number(x.precio1)||0);
    t.porLlegar+=Number(x.onorder)||0;
  });
  var dato=function(et, v, col){
    return '<span style="background:var(--surface-0);border:0.5px solid var(--border);'
      +'border-radius:8px;padding:3px 9px;font-size:11px">'
      +'<span style="color:var(--text-muted)">'+et+'</span> '
      +'<b'+(col?(' style="color:'+col+'"'):'')+'>'+v+'</b></span>';
  };
  return '<div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:6px">'
    + dato('En existencia', _fmtN2(t.unid)+' und')
    + dato('Disponible', _fmtN2(t.disp)+' und')
    + (t.porLlegar? dato('Por llegar', _fmtN2(t.porLlegar)+' und') : '')
    + (CU.verCostos ? (dato('Valor al costo', _fmtN2(t.cif), 'var(--t-azul)')
                     + dato('Valor a venta', _fmtN2(t.venta), 'var(--t-verde)')) : '')
    +'</div>';
}

function repRenderResumen(rows, code){
  var res=document.getElementById('rep-result');
  var cardname=(rows[0]&&rows[0].cardname)||'';
  // Agrupar por grupo (solo para el conteo del encabezado)
  var porGrupo={};
  rows.forEach(function(x){ var g=(x.grupo_cod||'')+' '+(x.grupo_nom||'Sin grupo'); (porGrupo[g]=porGrupo[g]||[]).push(x); });
  var h=''
    +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:14px">'
      +'<div style="flex:1;min-width:0"><div style="font-size:15px;font-weight:700">'+_esc(code)+(cardname?(' — '+_esc(cardname)):'')+'</div>'
      +'<div style="font-size:12px;color:var(--text-muted);margin-top:2px">'+rows.length+' referencias · '+Object.keys(porGrupo).length+' grupo(s)</div>'
      + _repTotalesHtml(rows)
      +'</div>'
      +'<button class="btn bg2" onclick="repPDF()"><i class="ti ti-file-type-pdf"></i> PDF completo</button>'
      +'<button class="btn bg2" onclick="repExcel()"><i class="ti ti-file-spreadsheet"></i> Excel completo</button>'
      +'<button class="btn bp" id="rep-full-btn" onclick="_repPantallaCompleta()" '
        +'title="Trabajar la reposición a pantalla completa" style="background:#5B21B6">'
        +'<i class="ti ti-'+(window._repFull?'arrows-minimize':'arrows-maximize')+'"></i> '
        +(window._repFull?'Salir de pantalla completa':'Pantalla completa')+'</button>'
    +'</div>';
  // SKUs de este proveedor que todavía no existen en SAP (creados desde una
  // orden NO SAP). Se muestran aparte y en morado para que se note.
  h+=_catBloqueProveedor(code);
  // Barra de carrito (fija arriba del listado)
  h+='<div id="rep-cart-bar" style="position:sticky;top:0;z-index:5;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:1px solid #C4B5FD;border-radius:10px;padding:10px 14px;margin-bottom:14px;display:flex;align-items:center;gap:10px;flex-wrap:wrap"></div>';

  // Barra de orden / filtro y listado
  h+=_repBarraOrden(rows);
  h+='<div id="rep-lista">'+_repListaHTML(rows)+'</div>';
  res.innerHTML=h;
  repActualizarCarrito();
}

// Ajusta la cantidad de un item en +1 o -1 (unidad)
function repCantAjustar(ic, delta){
  var actual=Number(_repCarrito[ic]||0);
  var nuevo=Math.max(0, actual+delta);
  repCantSet(ic, nuevo);
}
// Ajusta la cantidad por BULTOS: suma o resta 'signo' bultos (cada bulto = N piezas)
function repAjustarBulto(ic, signo, bulto){
  var b=Math.max(1, Number(bulto)||1);
  var actual=Number(_repCarrito[ic]||0);
  var nuevo=Math.max(0, actual + (signo*b));
  repCantSet(ic, nuevo);
}
// Suma un bulto completo (N piezas) — compatibilidad
function repAddBulto(ic, bulto){
  var actual=Number(_repCarrito[ic]||0);
  repCantSet(ic, actual+(Number(bulto)||1));
}
// Fija la cantidad exacta en PIEZAS (manual)
function repCantSet(ic, val){
  var n=Math.max(0, Math.round(Number(val)||0));
  if(n<=0){ delete _repCarrito[ic]; } else { _repCarrito[ic]=n; }
  var inp=document.getElementById('rep-qty-'+ic);
  if(inp)inp.value=n;
  // Sincronizar el input de bultos (piezas → bultos)
  _repSyncBultoInput(ic, n);
  // Resaltar la fila si está seleccionada
  var row=document.querySelector('.rep-item-row[data-ic="'+ic+'"]');
  if(row)row.style.background=n>0?'#F0FDF4':'';
  repActualizarCarrito();
  repAutoguardar();   // guardar en segundo plano
}
// Fija la cantidad a partir de BULTOS (bultos × piezasPorBulto = piezas)
function repBultoSet(ic, val, bulto){
  var b=Math.max(1, Number(bulto)||1);
  var bultos=Math.max(0, Number(val)||0);
  var piezas=Math.round(bultos*b);
  // repCantSet actualizará el input de piezas y re-sincronizará bultos
  repCantSet(ic, piezas);
}
// Actualiza el input de bultos según las piezas actuales
function _repSyncBultoInput(ic, piezas){
  var bInp=document.getElementById('rep-blt-'+ic);
  if(!bInp) return;
  // Obtener el bulto de la fila (está en el título del botón o lo recalculamos del data)
  var row=document.querySelector('.rep-item-row[data-ic="'+ic+'"]');
  var bulto=1;
  if(row){
    var m=(row.getAttribute('data-bulto'));
    if(m) bulto=Math.max(1, Number(m)||1);
  }
  bInp.value = piezas>0 ? (Math.round((piezas/bulto)*100)/100) : 0;
}
// Actualiza la barra de carrito
function repActualizarCarrito(){
  var bar=document.getElementById('rep-cart-bar');
  if(!bar)return;
  var items=Object.keys(_repCarrito).filter(function(k){return _repCarrito[k]>0;});
  var totalUnid=items.reduce(function(s,k){return s+_repCarrito[k];},0);
  if(!items.length){
    bar.innerHTML='<span style="font-size:12px;color:var(--t-lila2)"><i class="ti ti-shopping-cart"></i> Selecciona items con + / − o escribe cantidades para armar tu pedido de reposición.</span>';
    return;
  }
  bar.innerHTML=''
    +'<span id="repNumRepo"></span>'
    +'<span style="font-size:13px;font-weight:700;color:var(--t-lila2)"><i class="ti ti-shopping-cart"></i> '+items.length+' item(s) · '+totalUnid+' unidades</span>'
    +'<div style="flex:1"></div>'
    +'<button class="btn bp" onclick="repGenerarYEnviar()"><i class="ti ti-mail"></i> Generar Excel y PDF</button>'
    +'<button class="btn bg2" onclick="repLimpiarCarrito()" style="color:var(--text-danger)"><i class="ti ti-trash"></i></button>';
  try{ _repPintarNumero(); }catch(e){}
}
function repLimpiarCarrito(){
  _repCarrito={};
  document.querySelectorAll('.rep-item-row').forEach(function(r){
    r.style.background='';
    var inp=r.querySelector('input[type=number]'); if(inp)inp.value=0;
  });
  repActualizarCarrito();
  repAutoguardar();
}

// ═══════════════════════════════════════════════════════════════════════════
//  AUTOGUARDADO DE PEDIDOS DE REPOSICIÓN
// ═══════════════════════════════════════════════════════════════════════════
var _repPedidoId=null;      // id del pedido actual en Supabase (para actualizar)
var _repNumRepo='';         // número consecutivo de esta reposición (R-01, R-02…)

// ═══════════════════════════════════════════════════════════════════════════
//  NÚMERO DE REPOSICIÓN
//  Consecutivo simple: R-01, R-02… Se pide el mayor que haya y se suma uno.
//  Se compara el número, no el texto, para que después de R-09 venga R-10.
// ═══════════════════════════════════════════════════════════════════════════
function _repNumFmt(n){ return 'R-'+(n<10?('0'+n):String(n)); }
function _repNumVal(txt){
  var m=String(txt||'').toUpperCase().match(/R\s*-?\s*(\d+)/);
  return m?parseInt(m[1],10):0;
}
// El siguiente número mira LAS DOS tablas. Un número puede haber quedado
// guardado solo en el envío y no en el pedido; mirando únicamente los pedidos
// ese número parecía libre y se repartía dos veces (así salieron dos R-09).
async function _repSiguienteNumero(){
  var max=0, leyoAlguna=false;

  async function mirar(tabla){
    try{
      var r=await fetch(SB+'/rest/v1/'+tabla+'?select=num_reposicion'
        +'&num_reposicion=not.is.null&order=id.desc&limit=1000',{headers:SBH});
      if(!r.ok){
        var t=''; try{ t=await r.text(); }catch(e){}
        window._repNumError='HTTP '+r.status+' '+String(t).slice(0,180);
        console.warn('[reposición] no se pudo leer el consecutivo en '+tabla+':', window._repNumError);
        return;
      }
      leyoAlguna=true;
      (await r.json()||[]).forEach(function(x){
        var n=_repNumVal(x.num_reposicion);
        if(n>max) max=n;
      });
    }catch(e){
      window._repNumError=String(e && e.message || e);
      console.warn('[reposición] consecutivo en '+tabla+':', e);
    }
  }

  await mirar('reposiciones_pedidos');
  await mirar('reposiciones_envios');

  if(!leyoAlguna) return '';          // no se pudo consultar ninguna: sin número
  window._repNumError='';
  return _repNumFmt(max+1);
}
var _repSaveTimer=null;     // debounce del autoguardado

function repAutoguardar(){
  // Debounce: espera 800ms tras el último cambio para no saturar la BD
  if(_repSaveTimer) clearTimeout(_repSaveTimer);
  _repSaveTimer=setTimeout(_repGuardarAhora, 800);
}

// Fuerza el guardado que estuviera esperando y espera a que termine. Se usa
// antes de generar o enviar, para que el pedido exista de verdad en la base.
async function _repGuardarPendiente(){
  if(_repSaveTimer){ clearTimeout(_repSaveTimer); _repSaveTimer=null; }
  await _repGuardarAhora();
}

async function _repGuardarAhora(){
  if(!_repData||!_repCard) return;
  var items=Object.keys(_repCarrito).filter(function(k){return _repCarrito[k]>0;});
  // Armar el detalle del pedido (con datos para poder continuar/ver luego)
  var detalle=items.map(function(ic){
    var x=_repData.find(function(r){return String(r.itemcode)===String(ic);})||{};
    return {
      itemcode:ic, itemname:x.itemname||'', cant:_repCarrito[ic],
      picturname:x.picturname||'', grupo_nom:x.grupo_nom||'',
      onhand:x.onhand||0, disponible:(Number(x.onhand)||0)-(Number(x.iscommited)||0),
      u_cxblt:x.u_cxblt||0, salpackun:x.salpackun||0, fob:x.fob||0, precio1:x.precio1||0
    };
  });
  var nUnid=items.reduce(function(s,k){return s+_repCarrito[k];},0);
  var cardname=(_repData[0]&&_repData[0].cardname)||'';
  var payload={
    cardcode:_repCard, cardname:cardname,
    usuario:(CU&&CU.id)||'', usuario_nom:(CU&&CU.name)||'',
    estado:'en_proceso', items:detalle,
    n_items:items.length, n_unidades:nUnid,
    actualizado_en:new Date().toISOString()
  };
  // v765: al seguir una reposición que ya existe NO se toca su estado ni su
  // autor. Antes cada autoguardado la devolvía a «en proceso» (aunque ya
  // estuviera enviada a compras o al proveedor) y la ponía a nombre de quien
  // la abriera, con lo que dejaba de marcar sus artículos como pedidos.
  if(_repPedidoId){ delete payload.estado; delete payload.usuario; delete payload.usuario_nom; }
  try{
    if(_repPedidoId){
      // Actualizar el pedido existente. Si viene de antes del consecutivo,
      // aprovecha y le asigna número.
      if(!_repNumRepo && !window._repSinColumna){
        // Se pregunta primero si el pedido ya tiene número
        try{
          var _rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=num_reposicion&id=eq.'
            +encodeURIComponent(_repPedidoId)+'&limit=1',{headers:SBH});
          if(_rp.ok){
            var _dp=await _rp.json()||[];
            if(_dp.length && _dp[0].num_reposicion) _repNumRepo=String(_dp[0].num_reposicion).trim();
          }
        }catch(e){}
        if(!_repNumRepo){
          try{ _repNumRepo=await _repSiguienteNumero(); }catch(e){}
          if(!_repNumRepo) window._repSinColumna=true;
        }
      }
      var _cuerpo=_repNumRepo?Object.assign({}, payload, {num_reposicion:_repNumRepo}):payload;
      var _rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(_cuerpo)
      });
      if(!_rp.ok && _repNumRepo){
        _repNumRepo=''; window._repSinColumna=true;
        await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify(payload)
        });
      }
      try{ _repPintarNumero(); }catch(e){}
    } else if(items.length){
      // Crear un pedido nuevo (solo si ya hay al menos 1 item).
      // Aquí es donde nace el número de reposición.
      if(!_repNumRepo){ try{ _repNumRepo=await _repSiguienteNumero(); }catch(e){} }
      var conNum=_repNumRepo?Object.assign({}, payload, {num_reposicion:_repNumRepo}):payload;
      var r=await fetch(SB+'/rest/v1/reposiciones_pedidos',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(conNum)
      });
      if(!r.ok && _repNumRepo){
        // La columna no está: se guarda igual, sin número
        var _t=''; try{ _t=await r.text(); }catch(e){}
        window._repNumError='HTTP '+r.status+' '+String(_t).slice(0,180);
        console.warn('[reposición] sin columna num_reposicion:', window._repNumError);
        _repNumRepo=''; window._repSinColumna=true;
        r=await fetch(SB+'/rest/v1/reposiciones_pedidos',{
          method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
          body:JSON.stringify(payload)
        });
      }
      if(r.ok){
        var d=await r.json();
        if(Array.isArray(d)&&d[0]){
          _repPedidoId=d[0].id;
          if(d[0].num_reposicion) _repNumRepo=d[0].num_reposicion;
        }
      }
      try{ _repPintarNumero(); }catch(e){}
    }
  }catch(e){ /* si falla el guardado, no interrumpir la edición */ }
}

// ── Vista de pedidos guardados ──
async function rRepPedidos(){
  var cont=document.getElementById('page-reppedidos');
  if(!cont) return;
  cont.innerHTML='<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-clipboard-list"></i> Pedidos de reposición guardados</div>'
    +'<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Cargando...</div>';
  try{
    // Gerencia ve todos; el resto ve los de su equipo (mismo depto)
    var filtro=_filtroEquipo('usuario');
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*'+filtro+'&order=actualizado_en.desc&limit=200',{headers:SBH});
    var peds=r.ok?(await r.json()):[];
    if(!Array.isArray(peds)||!peds.length){
      cont.innerHTML='<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-clipboard-list"></i> Pedidos de reposición guardados</div>'
        +'<div class="empty" style="padding:24px"><i class="ti ti-clipboard-off" style="font-size:22px;color:var(--text-muted)"></i><br>No hay pedidos guardados todavía.<br><span style="font-size:11px;color:var(--text-muted)">Cuando armes un pedido en Reposiciones, se guarda automáticamente aquí.</span></div>';
      return;
    }
    var h='<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-clipboard-list"></i> Pedidos de reposición guardados <span style="font-size:11px;color:var(--text-muted);font-weight:400">('+peds.length+')</span></div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:12px">Se guardan automáticamente mientras armas cada pedido. Puedes continuar uno o revisarlo.</div>';
    peds.forEach(function(p){
      var fecha=p.actualizado_en?new Date(p.actualizado_en).toLocaleString('es'):'';
      var estBadge=p.estado==='finalizado'
        ?'<span style="font-size:10px;background:var(--bg-success);color:var(--text-success);padding:1px 7px;border-radius:8px;font-weight:600">Finalizado</span>'
        :'<span style="font-size:10px;background:var(--pastel-lila);color:var(--t-lila2);padding:1px 7px;border-radius:8px;font-weight:600">En proceso</span>';
      h+='<div style="border:0.5px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:10px;display:flex;align-items:center;gap:12px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:13px;font-weight:700">'+_esc(p.cardcode)+' — '+_esc(p.cardname||'')+' '+estBadge+'</div>'
          +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px">'
            +(p.n_items||0)+' items · '+(p.n_unidades||0)+' unidades · por '+_esc(p.usuario_nom||p.usuario||'?')+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted);margin-top:2px">Actualizado: '+_esc(fecha)+'</div>'
        +'</div>'
        +'<button class="btn bp" onclick="repContinuarPedido('+p.id+')"><i class="ti ti-edit"></i> Continuar</button>'
        +'<button class="btn bg2" onclick="repVerPedido('+p.id+')"><i class="ti ti-eye"></i> Ver</button>'
        +'<button class="btn bg2" style="color:var(--text-danger)" onclick="repBorrarPedido('+p.id+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
    cont.innerHTML=h;
  }catch(e){
    cont.innerHTML='<div class="empty">Error al cargar los pedidos guardados.</div>';
  }
}

// Continuar un pedido: carga el proveedor y restaura las cantidades
async function repContinuarPedido(id){
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+id+'&select=*&limit=1',{headers:SBH});
    var d=r.ok?(await r.json()):[];
    var p=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!p){ showT('No se encontró el pedido'); return; }
    // Ir a reposiciones, cargar el proveedor y restaurar el carrito
    go('reposiciones');
    document.getElementById('rep-code').value=p.cardcode;
    _repPedidoId=p.id;   // seguir guardando sobre el mismo pedido
    _repNumRepo=p.num_reposicion||'';   // y su número de reposición
    await repGenerar();
    // Restaurar cantidades
    var items=(typeof p.items==='string')?JSON.parse(p.items):(p.items||[]);
    _repCarrito={};
    items.forEach(function(it){ if(it.cant>0)_repCarrito[it.itemcode]=it.cant; });
    // Refrescar inputs y resaltado
    Object.keys(_repCarrito).forEach(function(ic){
      var inp=document.getElementById('rep-qty-'+ic);
      if(inp)inp.value=_repCarrito[ic];
      var row=document.querySelector('.rep-item-row[data-ic="'+ic+'"]');
      if(row)row.style.background='#F0FDF4';
    });
    repActualizarCarrito();
    showT('✓ Pedido cargado, puedes continuar');
  }catch(e){ showT('Error al cargar el pedido'); }
}

// Ver un pedido (solo lectura, genera la vista imprimible)
async function repVerPedido(id){
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+id+'&select=*&limit=1',{headers:SBH});
    var d=r.ok?(await r.json()):[];
    var p=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!p){ showT('No se encontró el pedido'); return; }
    var items=(typeof p.items==='string')?JSON.parse(p.items):(p.items||[]);
    // Precargar fotos
    var imgs={};
    await Promise.all(items.map(function(it){
      return _repCargarImg(_repFotoUrl(it.picturname)).then(function(im){ imgs[it.itemcode]=im?im.data:null; });
    }));
    // Reusar la vista HTML imprimible
    var sel=items.map(function(it){ return {
      itemcode:it.itemcode, itemname:it.itemname, _cant:it.cant,
      picturname:it.picturname, u_color:it.u_color, u_tamano:it.u_tamano,
      onhand:it.onhand, iscommited:0, u_cxblt:it.u_cxblt, salpackun:it.salpackun
    };});
    _repCard=p.cardcode; _repData=[{cardname:p.cardname}];
    repPedidoHTML(sel, imgs);
  }catch(e){ showT('Error al abrir el pedido'); }
}

async function repBorrarPedido(id){
  if(!confirm('¿Está seguro de que desea borrar esta reposición en curso?\n\nSe perderán las cantidades que llevabas cargadas.\n\nEsta acción no se puede deshacer.')) return;
  try{
    await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(_repPedidoId===id)_repPedidoId=null;
    showT('Reposición borrada');
    if(document.getElementById('rep-encurso')) _repCargarEnCurso();
    else if(typeof rRepPedidos==='function') rRepPedidos();
  }catch(e){ showT('Error al borrar'); }
}

// ── Generar PDF con formato tipo SAP ──
// Precarga una imagen y la devuelve como dataURL (para incrustarla en el PDF)
// Carga una foto para el PDF, redimensionada al tamaño en que se va a ver.
// Antes se guardaba a resolución completa aunque en el papel midiera 110
// puntos: el archivo pesaba diez veces más de lo necesario.
function _repCargarImg(url, ladoMax, calidad){
  ladoMax=ladoMax||300;                 // ~2.7x el tamaño impreso, se ve nítida
  calidad=(calidad==null?0.62:calidad);
  return new Promise(function(resolve){
    if(!url){ resolve(null); return; }
    var img=new Image();
    img.crossOrigin='anonymous';
    img.onload=function(){
      try{
        var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
        if(!w || !h){ resolve(null); return; }
        var esc=Math.min(1, ladoMax/Math.max(w,h));
        var cw=Math.max(1,Math.round(w*esc)), ch=Math.max(1,Math.round(h*esc));
        var cv=document.createElement('canvas');
        cv.width=cw; cv.height=ch;
        var cx=cv.getContext('2d');
        cx.fillStyle='#ffffff';         // fondo blanco para los PNG con transparencia
        cx.fillRect(0,0,cw,ch);
        cx.drawImage(img,0,0,cw,ch);
        resolve({data:cv.toDataURL('image/jpeg',calidad), w:cw, h:ch});
      }catch(e){ resolve(null); }
    };
    img.onerror=function(){ resolve(null); };
    img.src=url;
    // Margen amplio: con muchas fotos el navegador las pone en cola y un
    // límite corto las descartaba, dejando el PDF sin imágenes.
    setTimeout(function(){ resolve(null); }, 30000);
  });
}

// Carga fotos por tandas, para no saturar al navegador. Cargarlas todas de
// golpe hacía que las últimas quedaran en cola y se perdieran.
async function _repCargarImgs(items, urlDe, porTanda, aviso){
  porTanda=porTanda||10;
  var mapa={}, hechas=0;
  for(var i=0;i<items.length;i+=porTanda){
    var lote=items.slice(i,i+porTanda);
    await Promise.all(lote.map(function(x){
      var u=urlDe(x);
      if(!u){ mapa[x.itemcode]=null; return Promise.resolve(); }
      return _repCargarImg(u).then(function(im){ mapa[x.itemcode]=im; });
    }));
    hechas+=lote.length;
    if(aviso && (i%40===0)) aviso(hechas, items.length);
  }
  var con=Object.keys(mapa).filter(function(k){ return !!mapa[k]; }).length;
  _dbg('[fotos] '+con+' de '+items.length+' cargadas');
  return mapa;
}

async function repPDF(returnBlob){
  if(!_repData||!_repData.length){ showT('Primero consulta un proveedor'); return; }
  if(!window.jspdf||!window.jspdf.jsPDF){ showT('No se pudo cargar el generador de PDF'); return; }
  if(!returnBlob) showT('Generando PDF con fotos…');
  // compress:true reduce bastante el peso del archivo
  var doc=new window.jspdf.jsPDF({unit:'pt',format:'letter',compress:true}); // 612 x 792
  var rows=_repData;
  var code=_repCard, cardname=(rows[0]&&rows[0].cardname)||'';
  var W=612, M=40, y=0;
  var azul=[30,80,165];
  var fecha=new Date().toLocaleDateString('es',{weekday:'long',day:'2-digit',month:'long',year:'numeric'});

  // Las fotos, por tandas: todas a la vez saturaban al navegador
  var imgs=await _repCargarImgs(rows,
    function(x){ return _repFotoUrl(x.picturname); }, 10,
    function(n,t){ if(!returnBlob) showT('Cargando fotos… '+n+'/'+t); });

  // Agrupar por grupo
  var porGrupo={};
  rows.forEach(function(x){ var g=(x.grupo_cod||'')+' '+(x.grupo_nom||'Sin grupo'); (porGrupo[g]=porGrupo[g]||[]).push(x); });
  var totalProv=0;
  // Lo que el proveedor tiene HOY en la bodega: la existencia de cada
  // referencia por su costo y por su precio de venta. Antes el total sumaba
  // el «Tot. CIF» histórico de cada ficha, que casi siempre viene en cero y
  // por eso el pie salía 0,00.
  var tot={refs:0, unid:0, disp:0, cif:0, venta:0, porLlegar:0};
  rows.forEach(function(x){
    var ex=Number(x.onhand)||0;
    var dp=ex-(Number(x.iscommited)||0);
    tot.refs++; tot.unid+=ex; tot.disp+=dp;
    tot.cif   += ex*(Number(x.cif)||0);
    tot.venta += ex*(Number(x.precioventa)||Number(x.precio1)||0);
    tot.porLlegar += Number(x.onorder)||0;
  });

  function header(pageNum){
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(0);
    doc.text(fecha, M, 38);
    doc.text('Página '+pageNum, W-M, 38, {align:'right'});
    doc.setFontSize(15); doc.setTextColor(azul[0],azul[1],azul[2]); doc.setFont('helvetica','bold');
    doc.text('KENNEDY CENTER CORP.', W/2, 56, {align:'center'});
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.8); doc.line(M,62,W-M,62);
    doc.setFontSize(11); doc.setTextColor(0);
    doc.text(code+'   '+cardname, W/2, 78, {align:'center'});
    // Debajo del nombre, lo que tiene hoy: referencias, unidades y plata
    doc.setFont('helvetica','normal'); doc.setFontSize(8.5); doc.setTextColor(60);
    doc.text(_fmtN2(tot.refs)+' referencias · '+_fmtN2(tot.unid)+' unidades en existencia'
      +(CU.verCostos ? ('  ·  costo '+_fmtN2(tot.cif)+'  ·  venta '+_fmtN2(tot.venta)) : ''),
      W/2, 90, {align:'center'});
    doc.setTextColor(0);
    doc.setLineWidth(1.2); doc.line(M,96,W-M,96);
    doc.setFont('helvetica','normal');
    return 112;
  }

  var FICHA_H=118;   // alto aproximado de cada ficha
  var page=1;
  y=header(page);

  Object.keys(porGrupo).sort().forEach(function(g){
    var list=porGrupo[g];
    // Encabezado de grupo
    if(y>760){ doc.addPage(); page++; y=header(page); }
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(0);
    doc.text(g, M+10, y);
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.2); y+=4; doc.line(M,y,W-M,y); y+=14;
    doc.setFont('helvetica','normal');

    list.forEach(function(x){
      if(y+FICHA_H>770){ doc.addPage(); page++; y=header(page); }
      var y0=y;
      var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
      var pctv=(Number(x.precio1)&&Number(x.cif))?((1-(Number(x.cif)/Number(x.precio1)))*100):0;
      var col2=M+300;   // columna derecha de datos
      var col2b=M+230;  // etiqueta col derecha

      // ── Código (azul) + Nombre (negro) ──
      doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
      doc.setTextColor(azul[0],azul[1],azul[2]); doc.text(String(x.itemcode||''), M, y);
      doc.setTextColor(0); doc.text(String(x.itemname||'').toUpperCase(), M+90, y);
      y+=15;

      // ── Bloque de datos (3 líneas, etiqueta en negrita + valor) ──
      doc.setFontSize(8);
      function par(lbl,val,lx,vx,vy,valColor){
        doc.setFont('helvetica','bold'); doc.setTextColor(0); doc.text(lbl,lx,vy);
        doc.setFont('helvetica','normal');
        if(valColor)doc.setTextColor(valColor[0],valColor[1],valColor[2]); else doc.setTextColor(0);
        doc.text(String(val),vx,vy);
        doc.setTextColor(0);
      }
      // Línea 1
      var emp=_fmtN2(x.salpackun)+' '+(x.salunitmsr||'PZAS')+' X C/ '+( (Number(x.u_cxblt)||1) )+' '+(x.u_bulunie||'BTO')+'(S)';
      par('Empaque:', emp, M, M+52, y);
      par('Kilos:', _fmtN2(x.kilos), col2b, col2b+34, y);
      par('P3:', _fmtN2(x.p3), col2b+90, col2b+108, y);
      y+=12;
      // Línea 2
      par('Existencia:', _fmtN2(x.onhand), M, M+56, y);
      par('Separado:', _fmtN2(x.iscommited), M+150, M+205, y);
      par('Disponible:', _fmtN2(disp), col2b, col2b+56, y, azul);
      y+=12;
      // Línea 3 (costos, solo si ve costos)
      if(CU.verCostos){
        par('FOB:', _fmtN2(x.fob), M, M+30, y);
        par('CIF:', _fmtN2(x.cif), M+150, M+180, y);
        par('Precio:', _fmtN2(x.precio1), col2b, col2b+40, y, azul);
        if(pctv){ doc.setFont('helvetica','normal'); doc.setTextColor(90); doc.text(_fmtN2(pctv)+'%', col2b+120, y); doc.setTextColor(0); }
        y+=14;
      } else { y+=2; }

      // ── Recuadro Ult. Compra / Total Comprado ──
      if(CU.verCostos){
        var bx=M, bw=340, bh=30, by=y-2;
        doc.setDrawColor(150); doc.setLineWidth(0.5);
        doc.rect(bx,by,bw,bh);
        doc.line(bx+bw/2,by,bx+bw/2,by+bh); // divisoria vertical
        doc.line(bx,by+12,bx+bw,by+12);      // divisoria horizontal (encabezados)
        doc.setFontSize(6.5); doc.setFont('helvetica','bold'); doc.setTextColor(0);
        doc.text('Ult. Compra:', bx+3, by+8);
        doc.text('Total Comprado:', bx+bw/2+3, by+8);
        doc.setFont('helvetica','normal'); doc.setFontSize(6);
        doc.text('# Entrada    Fecha              Cantidad', bx+3, by+18);
        doc.text('Cantidad     Tot. FOB       Tot. CIF', bx+bw/2+3, by+18);
        doc.setFontSize(6.5);
        doc.text((x.u_nentrada||'-')+'   '+(x.u_fentrada||'')+'   '+_fmtN2(x.u_cant_ult_ent), bx+3, by+27);
        doc.text(_fmtN2(x.cant_comprada)+'   '+_fmtN2(x.total_fob)+'   '+_fmtN2(x.total_cif), bx+bw/2+3, by+27);
        y=by+bh+11;
      }

      // ── Por llegar + Tot. CIF ──
      doc.setFontSize(8);
      par('Por llegar:', _fmtN2(x.onorder), M, M+56, y, azul);
      if(CU.verCostos) par('Tot. CIF.:', _fmtN2(x.total_cif), col2b, col2b+50, y, azul);
      totalProv+=(Number(x.total_cif)||0);
      y+=13;

      // ── Comp / Color / Tamaño ──
      doc.setFontSize(7.5); doc.setTextColor(60);
      var linea3=[];
      if(x.u_color) linea3.push('Color: '+x.u_color);
      if(x.u_tamano) linea3.push('Tamaño: '+x.u_tamano);
      if(linea3.length){ doc.text(linea3.join('     '), M, y); }
      doc.setTextColor(0);

      // ── Foto del producto (a la derecha) ──
      var im=imgs[x.itemcode];
      if(im){
        try{
          var maxW=110, maxH=80;
          var r=Math.min(maxW/im.w, maxH/im.h);
          var iw=im.w*r, ih=im.h*r;
          var ix=W-M-maxW+(maxW-iw)/2, iy=y0+6;
          doc.addImage(im.data,'JPEG',ix,iy,iw,ih);
        }catch(e){}
      }

      // ── Separador entre productos ──
      y=Math.max(y, y0+FICHA_H-10);
      doc.setDrawColor(120); doc.setLineWidth(0.7); doc.line(M,y,W-M,y);
      y+=14;
    });
  });

  // ── Total proveedor: lo que tiene hoy en bodega ──
  if(y>720){ doc.addPage(); page++; y=header(page); }
  doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.8); doc.line(M,y,W-M,y); y+=16;
  doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(azul[0],azul[1],azul[2]);
  doc.text('TOTAL PROVEEDOR --->', M, y);
  doc.setFontSize(9); doc.setTextColor(0);
  doc.text(_fmtN2(tot.refs)+' referencias', M+170, y);
  doc.text(_fmtN2(tot.unid)+' unidades en existencia', M+270, y);
  y+=14;
  if(CU.verCostos){
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
    doc.setTextColor(azul[0],azul[1],azul[2]);
    doc.text('Valor al costo (CIF):', M+170, y);
    doc.text(_fmtN2(tot.cif), M+300, y, {align:'right'});
    doc.text('Valor a precio de venta:', M+330, y);
    doc.text(_fmtN2(tot.venta), W-M, y, {align:'right'});
    y+=13;
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(90);
    doc.text('Disponible: '+_fmtN2(tot.disp)+' und · Por llegar: '+_fmtN2(tot.porLlegar)
             +' und · Total CIF histórico de las fichas: '+_fmtN2(totalProv), M+170, y);
  }
  doc.setTextColor(0); doc.setFont('helvetica','normal');

  var nombrePDF='Reposicion_'+code+'_'+new Date().toISOString().slice(0,10)+'.pdf';
  if(returnBlob){ return new File([doc.output('blob')], nombrePDF, {type:'application/pdf'}); }
  doc.save(nombrePDF);
  showT('✓ PDF generado');
}

// ── Exportar a Excel ──
function repExcel(returnBlob){
  if(!_repData||!_repData.length){ showT('Primero consulta un proveedor'); return; }
  if(typeof XLSX==='undefined'){ showT('No se pudo cargar Excel'); return; }
  var rows=_repData.map(function(x){
    var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
    var o={
      'Código':x.itemcode, 'Descripción':x.itemname, 'Grupo':x.grupo_nom,
      'Existencia':Number(x.onhand)||0, 'Separado':Number(x.iscommited)||0,
      'Disponible':disp, 'Por llegar':Number(x.onorder)||0,
      'Empaque':Number(x.salpackun)||0, 'Unidad':x.salunitmsr,
      'Últ. entrada #':x.u_nentrada, 'Últ. entrada fecha':x.u_fentrada,
      'Cant. últ. entrada':Number(x.u_cant_ult_ent)||0,
      'Color':x.u_color, 'Tamaño':x.u_tamano
    };
    if(CU.verCostos){
      o['FOB']=Number(x.fob||x.cif)||0; o['CIF']=Number(x.cif)||0;
      o['Precio']=Number(x.precio1)||0;
      o['Cant. comprada']=Number(x.cant_comprada)||0;
      o['Total FOB']=Number(x.total_fob)||0; o['Total CIF']=Number(x.total_cif)||0;
    }
    return o;
  });
  var ws=XLSX.utils.json_to_sheet(rows);
  var wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Reposicion');
  var nombreXLS='Reposicion_'+_repCard+'_'+new Date().toISOString().slice(0,10)+'.xlsx';
  if(returnBlob){
    var wbout=XLSX.write(wb,{bookType:'xlsx',type:'array'});
    return new File([wbout], nombreXLS, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  }
  XLSX.writeFile(wb, nombreXLS);
  showT('✓ Excel generado');
}

// ── Enviar el REPORTE COMPLETO del proveedor (PDF + Excel) por correo ──
async function repEnviarReporte(){
  if(!_repData||!_repData.length){ showT('Primero consulta un proveedor'); return; }
  showT('Generando PDF y Excel…');
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var fecha=new Date().toLocaleDateString('es');
  var asunto='Reposición '+code+(cardname?(' - '+cardname):'');
  var cuerpo='Estimados,\n\n'
    +'Adjunto el reporte de reposición del proveedor '+code+(cardname?(' ('+cardname+')'):'')+'.\n\n'
    +'Resumen: '+_repData.length+' referencias · '+fecha+'\n\n'
    +'Saludos,\n'+(CU?CU.name:'')+'\nKennedy Center';
  var filePDF=null, fileXLS=null;
  try{ filePDF=await repPDF(true); }catch(e){}
  try{ fileXLS=await repExcel(true); }catch(e){}
  var nombrePDF=filePDF?filePDF.name:('Reposicion_'+code+'.pdf');
  var nombreXLS=fileXLS?fileXLS.name:('Reposicion_'+code+'.xlsx');
  return _repEnviarConAdjuntos([filePDF,fileXLS].filter(Boolean), asunto, cuerpo, nombrePDF, nombreXLS);
}

// ═══════════════════════════════════════════════════════════════════════════
//  PEDIDO DE REPOSICIÓN — solo los items seleccionados (con cantidades y fotos)
// ═══════════════════════════════════════════════════════════════════════════
function _repItemsSeleccionados(){
  if(!_repData) return [];
  return _repData.filter(function(x){ return (_repCarrito[x.itemcode]||0)>0; })
    .map(function(x){ var c=Object.assign({}, x); c._cant=_repCarrito[x.itemcode]; return c; });
}

async function repGenerarPedido(tipo){
  var sel=_repItemsSeleccionados();
  if(!sel.length){ showT('No hay items seleccionados'); return; }
  try{ await _repGuardarPendiente(); }catch(e){}
  try{ await _repAsegurarNumero(); }catch(e){}
  // Marcar el pedido guardado como finalizado (si existe)
  if(_repPedidoId){
    try{
      await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({actualizado_en:new Date().toISOString()})
      });
    }catch(e){}
  }
  if(tipo==='excel'){ return repPedidoExcel(sel); }
  return repPedidoPDF(sel);
}

// A quién va dirigido el "Dear". Si el proveedor tiene contacto guardado se
// usa su nombre; si no, queda "Vendor" y se cambia a mano en el correo, que
// es editable antes de enviar.
function _repContacto(){
  var c='';
  try{
    c=(window._repProvContacto||'')
      || ((_repData&&_repData[0]&&(_repData[0].contacto||_repData[0].contact))||'');
  }catch(e){}
  c=String(c||'').trim();
  if(!c) return 'Vendor';
  return c.split(/\s+/)[0];        // solo el nombre de pila, como se acostumbra
}

// La firma. Cuando compras manda una reposición que originó gerencia, se
// firma en su nombre: "On behalf of <gerencia>".
function _repFirmaCorreo(){
  var yo=(CU&&CU.name)||'';
  var de='';
  try{ de=String(window._repOrigenNombre||'').trim(); }catch(e){}
  var enNombreDe=(de && de!==yo) ? ('On behalf of '+de+'\n') : '';
  return 'Best regards,\n\n'+enNombreDe+yo+'\nKENNEDY CENTER CORP.';
}

// Genera PDF + Excel del pedido e intenta compartirlos (adjuntar) vía Web Share API
async function repGenerarYEnviar(){
  var sel=_repItemsSeleccionados();
  if(!sel.length){ showT('No hay items seleccionados'); return; }
  // Primero se guarda el pedido. Si el autoguardado quedó pendiente, el envío
  // salía sin pedido_id y las líneas de esa reposición no quedaban en ningún
  // lado: después no había contra qué comparar la orden NO SAP.
  try{ await _repGuardarPendiente(); }catch(e){ console.warn('[reposición] guardar antes de enviar:', e); }
  // El número va en el PDF, el Excel, el asunto y el cuerpo: se resuelve antes
  try{ await _repAsegurarNumero(); }catch(e){}
  if(!_repNumRepo) showT('Ojo: esta reposición sale sin número (falta correr reposiciones_numero.sql)', 6000);
  // Marcar pedido como finalizado
  if(_repPedidoId){
    try{
      await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({actualizado_en:new Date().toISOString()})
      });
    }catch(e){}
  }
  showT('Generando PDF y Excel…');

  var ahora=new Date();
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var totUnid=sel.reduce(function(s,x){return s+(Number(x._cant)||0);},0);
  var totBultos=Math.round(sel.reduce(function(s,x){var b=Math.max(1,Number(x.u_cxblt)||Number(x.salpackun)||1);return s+(x._cant/b);},0)*100)/100;

  // ── Asunto y cuerpo del correo, en INGLÉS y con el formato acordado ──
  var asunto='RE-ORDER '+(_repNumRepo?(_repNumRepo+' '):'')+code+(cardname?(' - '+cardname):'');
  var cuerpo=''
    +'Attention:                    '+(cardname||('Supplier '+code))+'\n'
    +'Vendor Code:            '+code+'\n'
    +(_repNumRepo?('Re-order No.:           '+_repNumRepo+'\n'):'')
    +'\n'
    +'Dear '+_repContacto()+'\n'
    +'\n'
    +'I hope you are doing well.\n'
    +'\n'
    +'Please find attached our repeat order\n'
    +'\n'
    +'Order Summary:\n'
    +'\u2022 '+_repNum(sel.length)+' '+(sel.length===1?'item':'items')+'\n'
    +'\u2022 '+_repNum(totUnid)+' '+(totUnid===1?'unit':'units')+'\n'
    +'\u2022 '+_repNum(totBultos)+' '+(totBultos===1?'carton':'cartons')+'\n'
    +'\u2022 Date: '+_repFechaEN(ahora)+'\n'
    +'\n'
    +'Kindly check and send us your company\u2019s PI as well as our KCC RE-ORDER format for final confirmation.\n'
    +'\n'
    +'Thank you for your cooperation.\n'
    +'\n'
    +_repFirmaCorreo();

  // Generar los archivos como objetos File (para compartir/adjuntar)
  var filePDF=null, fileXLS=null;
  try{ filePDF=await repPedidoPDF(sel, true); }catch(e){}
  try{ fileXLS=await repPedidoExcel(sel, true); }catch(e){}
  var nombrePDF=filePDF?filePDF.name:_repNombreArchivo('pdf', ahora);
  var nombreXLS=fileXLS?fileXLS.name:_repNombreArchivo('xlsx', ahora);
  return _repEnviarConAdjuntos([filePDF, fileXLS].filter(Boolean), asunto, cuerpo, nombrePDF, nombreXLS);
}

// ═══════════════════════════════════════════════════════════════════════════
//  ENVÍO POR CORREO CON ADJUNTOS (PDF + Excel) — Apple y Windows
//  · "Compartir con adjuntos" usa la hoja nativa (Web Share) que SÍ adjunta los
//    archivos de verdad: funciona en iPhone/iPad/Mac y en Windows compatible.
//  · "Abrir correo" usa mailto con destinatarios/CC/asunto/mensaje ya escritos y
//    descarga los 2 archivos para que los adjuntes (los navegadores no permiten
//    adjuntar archivos automáticamente por mailto).
// ═══════════════════════════════════════════════════════════════════════════
function _repEnviarConAdjuntos(files, asunto, cuerpo, nombrePDF, nombreXLS){
  _repMailFiles = files||[];
  _repAbrirModalCorreo(asunto, cuerpo, nombrePDF, nombreXLS);
}
// Abre/descarga un adjunto (PDF o Excel) del correo en preparación
function _repAbrirAdjunto(i){
  var f=(_repMailFiles||[])[i]; if(!f){ showT('Adjunto no disponible'); return; }
  var url=URL.createObjectURL(f);
  var a=document.createElement('a'); a.href=url; a.download=f.name; a.target='_blank';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(function(){URL.revokeObjectURL(url);},4000);
}
// Correos existentes del equipo (definidos en USERS) para elegir con un clic
function _repCorreosEquipo(){
  try{
    return (USERS||[]).filter(function(u){return u&&u.email;})
      .map(function(u){return {email:u.email, name:u.name||u.email};});
  }catch(e){ return []; }
}
// Agrega/quita (toggle) un correo del equipo en el campo "Para"
function _repAddCorreo(email){
  var inp=document.getElementById('repMailPara'); if(!inp)return;
  var actuales=(inp.value||'').split(/[;,\n]/).map(function(s){return s.trim();}).filter(Boolean);
  var i=actuales.indexOf(email);
  if(i>=0){ actuales.splice(i,1); } else { actuales.push(email); }
  inp.value=actuales.join(', ');
  document.querySelectorAll('.rep-mail-chip').forEach(function(c){
    var on=actuales.indexOf(c.getAttribute('data-email'))>=0;
    c.style.background=on?'var(--text-accent)':'var(--surface-2)';
    c.style.color=on?'#fff':'var(--text-secondary)';
    c.style.borderColor=on?'var(--text-accent)':'var(--border)';
  });
}
// Copia los destinatarios (Para + CC) al portapapeles
function _repCopiarCorreos(){
  var para=(document.getElementById('repMailPara').value||'').trim();
  var cc=(document.getElementById('repMailCC').value||'').trim();
  var todos=[para,cc].filter(Boolean).join(', ');
  if(!todos){ showT('No hay correos para copiar'); return; }
  var done=function(){ showT('✓ Correos copiados'); };
  if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(todos).then(done,done); }
  else { var t=document.createElement('textarea'); t.value=todos; document.body.appendChild(t); t.select(); try{document.execCommand('copy');}catch(e){} t.remove(); done(); }
}
// Comparte los archivos ADJUNTOS con la hoja nativa (Web Share)
async function _repCompartirAdjuntos(){
  var files=_repMailFiles||[];
  if(!files.length){ showT('No hay archivos para compartir'); return; }
  var asunto=(document.getElementById('repMailAsunto')?document.getElementById('repMailAsunto').value:'')||'';
  var cuerpo=(document.getElementById('repMailCuerpo')?document.getElementById('repMailCuerpo').value:'')||'';
  var para=(document.getElementById('repMailPara')?document.getElementById('repMailPara').value:'')||'';
  var cc=(document.getElementById('repMailCC')?document.getElementById('repMailCC').value:'')||'';
  // Copiamos los destinatarios al portapapeles para pegarlos rápido en el correo
  var dest=[para,cc].filter(function(s){return (s||'').trim();}).join(', ');
  if(dest){ try{ if(navigator.clipboard&&navigator.clipboard.writeText) await navigator.clipboard.writeText(dest); }catch(e){} }
  if(navigator.canShare && navigator.canShare({files:files})){
    try{
      await navigator.share({ files:files, title:asunto, text:(dest?('Para: '+dest+'\n\n'):'')+cuerpo });
      showT('✓ Compartido — pega los correos (ya copiados) en Para');
      var m=document.querySelector('#repMailPara'); if(m){var mm=m.closest('div[style*=fixed]'); if(mm)mm.remove();}
      return;
    }catch(err){ if(err&&err.name==='AbortError'){ return; } }
  }
  showT('Tu dispositivo no permite adjuntar al compartir. Usa "Abrir correo".');
}
// Modal para componer el correo (elige destinatarios del equipo o escríbelos)
function _repAbrirModalCorreo(asunto, cuerpo, nombrePDF, nombreXLS){
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px';
  var puedeCompartir=false;
  try{ puedeCompartir=!!(navigator.canShare && _repMailFiles && _repMailFiles.length && navigator.canShare({files:_repMailFiles})); }catch(e){}
  var equipo=_repCorreosEquipo();
  var chips=equipo.map(function(u){
    return '<span class="rep-mail-chip" data-email="'+_esc(u.email)+'" onclick="_repAddCorreo(\''+_esc(u.email)+'\')" title="'+_esc(u.email)+'" style="cursor:pointer;font-size:11px;padding:4px 9px;border:0.5px solid var(--border);background:var(--surface-2);color:var(--text-secondary);border-radius:20px;white-space:nowrap">'+_esc(u.name)+'</span>';
  }).join('');
  var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:540px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px"><div style="font-size:15px;font-weight:700"><i class="ti ti-mail" style="color:var(--text-accent)"></i> Enviar por correo</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
  h+='<div style="background:#EAF3DE;border:0.5px solid #B7D89A;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11px;color:#3B5323"><i class="ti ti-paperclip"></i> El PDF y el Excel se adjuntan automáticamente. Elige los destinatarios y pulsa <b>Enviar</b> para mandarlo desde el app, ya con los archivos adjuntos.</div>';
  // Adjuntos clicables (PDF y Excel)
  var adjHTML=(_repMailFiles||[]).map(function(f,i){
    var esPdf=/\.pdf$/i.test(f.name);
    var icon=esPdf?'ti-file-type-pdf':'ti-file-spreadsheet';
    var col=esPdf?'#B91C1C':'#15803D';
    return '<div onclick="_repAbrirAdjunto('+i+')" title="Abrir / descargar el archivo" style="display:flex;align-items:center;gap:8px;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;background:var(--surface-1);cursor:pointer;margin-bottom:6px">'
      +'<i class="ti '+icon+'" style="font-size:18px;color:'+col+'"></i>'
      +'<span style="flex:1;min-width:0;font-size:12px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(f.name)+'</span>'
      +'<span style="font-size:10px;color:var(--text-accent);font-weight:600"><i class="ti ti-eye" style="font-size:12px"></i> ver</span>'
    +'</div>';
  }).join('');
  h+='<div style="margin-bottom:12px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500"><i class="ti ti-paperclip" style="font-size:12px"></i> Adjuntos (clic para abrir)</label><div style="margin-top:5px">'+(adjHTML||'<span style="font-size:11px;color:var(--text-muted)">Generando archivos…</span>')+'</div></div>';
  if(equipo.length){
    h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Correos del equipo (clic para agregar)</label><div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:5px;max-height:104px;overflow-y:auto">'+chips+'</div></div>';
  }
  h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Para (uno o varios, separados por coma)</label><textarea id="repMailPara" rows="2" placeholder="destinatario@ejemplo.com, otro@ejemplo.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-2);color:var(--text-primary);resize:vertical"></textarea></div>';
  h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">CC (opcional)</label><input id="repMailCC" placeholder="copia@ejemplo.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)"></div>';
  h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Asunto</label><input id="repMailAsunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)"></div>';
  h+='<div style="margin-bottom:14px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Mensaje</label><textarea id="repMailCuerpo" rows="8" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;margin-top:3px;background:var(--surface-2);color:var(--text-primary);resize:vertical">'+_esc(cuerpo)+'</textarea></div>';
  h+='<div style="display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap">';
  h+='<button onclick="this.closest(\'div[style*=fixed]\').remove()" class="btn bg2">Cancelar</button>';
  h+='<button onclick="_repEnviarAutomatico()" class="btn bp"><i class="ti ti-send"></i> Enviar</button>';
  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ var ems=_repRutaEmails(); var pi=document.getElementById('repMailPara'); if(pi && !pi.value && ems.length){ pi.value=ems.join(', '); document.querySelectorAll('.rep-mail-chip').forEach(function(c){ if(ems.indexOf(c.getAttribute('data-email'))>=0){ c.style.background='var(--text-accent)'; c.style.color='#fff'; c.style.borderColor='var(--text-accent)'; } }); } }catch(e){}
}
// Descarga los archivos generados (para adjuntarlos manualmente)
function _repDescargarAdjuntos(){
  (_repMailFiles||[]).forEach(function(f){
    if(!f)return;
    var a=document.createElement('a'); a.href=URL.createObjectURL(f); a.download=f.name;
    document.body.appendChild(a); a.click(); a.remove(); setTimeout(function(){URL.revokeObjectURL(a.href);},1500);
  });
}
// Lee los campos del modal y devuelve {para,cc,asunto,cuerpo} normalizados
function _repDatosCorreo(){
  var para=(document.getElementById('repMailPara').value||'').trim();
  var cc=(document.getElementById('repMailCC').value||'').trim();
  var norm=function(s){ return s.split(/[,;\n]/).map(function(x){return x.trim();}).filter(Boolean).join(','); };
  return {
    para: norm(para),
    cc: norm(cc),
    asunto: (document.getElementById('repMailAsunto').value||'').trim(),
    cuerpo: (document.getElementById('repMailCuerpo').value||'')
  };
}
function _repCerrarModalCorreo(){
  var modal=document.querySelector('#repMailPara'); if(modal){ var m=modal.closest('div[style*=fixed]'); if(m)m.remove(); }
}
// Abre el correo PREDETERMINADO del equipo (mailto)
function _repEnviarCorreo(){
  _repDescargarAdjuntos();
  var d=_repDatosCorreo();
  var url='mailto:'+d.para+'?';
  if(d.cc) url+='cc='+d.cc+'&';
  url+='subject='+encodeURIComponent(d.asunto)+'&body='+encodeURIComponent(d.cuerpo);
  window.location.href=url;
  showT('Abriendo tu correo… adjunta los 2 archivos descargados');
  _repCerrarModalCorreo();
}
// ENVIAR AHORA: lleva al Mail/Outlook del usuario con TODO adjunto.
//  · Apple/móvil: usa la hoja de compartir (Web Share) que adjunta los archivos.
//  · Windows/otros: abre Outlook (web) con los archivos ya descargados para pegar.
async function _repEnviarAhora(){
  var files=_repMailFiles||[];
  if(files.length && navigator.canShare && navigator.canShare({files:files})){
    return _repCompartirAdjuntos();
  }
  return _repEnviarOutlook();
}
// Abre la redacción directamente en OUTLOOK (web) — Apple y Windows
function _repEnviarOutlook(){
  var d=_repDatosCorreo();
  // Deeplink de Outlook 365 (empresa). Si el usuario tuviera Outlook personal,
  // el mismo enlace lo redirige al login correcto.
  var url='https://outlook.office.com/mail/deeplink/compose?to='+encodeURIComponent(d.para)
    +'&subject='+encodeURIComponent(d.asunto)+'&body='+encodeURIComponent(d.cuerpo);
  if(d.cc) url+='&cc='+encodeURIComponent(d.cc);
  window.open(url,'_blank');
  showT('Abriendo Outlook… adjunta los 2 archivos descargados');
  _repCerrarModalCorreo();
}
// Carga JSZip (para empaquetar PDF+Excel en un solo adjunto)
var _jszipLoad=null;
function _ensureJSZip(){
  if(window.JSZip) return Promise.resolve(window.JSZip);
  if(_jszipLoad) return _jszipLoad;
  _jszipLoad=new Promise(function(res,rej){
    var s=document.createElement('script');
    s.src='https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    s.onload=function(){res(window.JSZip);}; s.onerror=rej;
    document.head.appendChild(s);
  });
  return _jszipLoad;
}
// ═══════════════════════════════════════════════════════════════════════════
//  ENVÍO AUTOMÁTICO DE LA REPOSICIÓN — por la MISMA ruta de Azure que las etapas
//  Escribe en correos_queue con el formato que ya usa mailEnviar():
//    para_lista[] · adjuntos[{nombre, contenido(base64), mime}] · de_nombre · de_email
//  Así el worker (Microsoft Graph) lo manda igual que los demás correos del
//  portal, con el PDF y el Excel adjuntos de verdad y saliendo desde el correo
//  del usuario que lo genera.
// ═══════════════════════════════════════════════════════════════════════════

// Convierte un File a base64 puro (sin el prefijo "data:...;base64,")
function _repFileABase64(file){
  return new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
    fr.onerror=function(){ rej(new Error('No se pudo leer '+((file&&file.name)||'el archivo'))); };
    fr.readAsDataURL(file);
  });
}

function _repMimeDe(f){
  if(f && f.type) return f.type;
  var n=String((f&&f.name)||'').toLowerCase();
  if(n.slice(-4)==='.pdf')  return 'application/pdf';
  if(n.slice(-5)==='.xlsx') return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  if(n.slice(-4)==='.zip')  return 'application/zip';
  return 'application/octet-stream';
}

// Arma el arreglo `adjuntos` tal como lo espera el worker de Graph
async function _repAdjuntosInline(files){
  var out=[];
  for(var i=0;i<files.length;i++){
    var f=files[i]; if(!f) continue;
    out.push({ nombre:f.name, mime:_repMimeDe(f),
               contenido:await _repFileABase64(f), _kb:Math.round(f.size/1024) });
  }
  return out;
}
function _repAdjKb(adj){ return (adj||[]).reduce(function(a,x){ return a+(x._kb||0); },0); }

// Espera a que el worker lo marque como enviado (mismo criterio que _mailSeguir)
function _repSeguirCorreo(id, nDest){
  if(!id){ showT('✓ Correo en cola — saldrá en unos segundos'); return; }
  var intentos=0;
  var timer=setInterval(async function(){
    if(++intentos>20){
      clearInterval(timer);
      showT('El correo sigue en cola; saldrá en cuanto el sync lo procese');
      return;
    }
    try{
      var r=await fetch(SB+'/rest/v1/correos_queue?select=estado,error_msg&id=eq.'+id+'&limit=1',{headers:SBH});
      var f=r.ok?(await r.json()):[];
      var row=(f&&f[0])||null; if(!row) return;
      if(row.estado==='enviado'){
        clearInterval(timer);
        showT('✅ Enviado a '+nDest+' destinatario(s) con el PDF y el Excel');
      }else if(row.estado==='error'){
        clearInterval(timer);
        showT('⚠ No se pudo enviar: '+(row.error_msg||'sin detalle'));
      }
    }catch(e){}
  },2500);
}

async function _repEnviarAutomatico(){
  var files=(_repMailFiles||[]).filter(Boolean);
  if(!files.length){ showT('No hay archivos para enviar'); return; }
  var d=_repDatosCorreo();
  if(!d.para){ showT('Escribe o elige al menos un destinatario'); return; }
  if(!(d.asunto||'').trim()){ showT('Escribe un asunto'); return; }

  var listaPara=d.para.split(',').map(function(s){return s.trim();}).filter(Boolean);
  var listaCC  =(d.cc||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
  var todos=listaPara.concat(listaCC);
  var destinatarios=todos.join(',');
  var code=_repCard||'reposicion';

  showT('Preparando envío con adjuntos…');
  try{
    // 1) PDF + Excel como adjuntos en línea (base64), igual que en las etapas
    var adjuntos=await _repAdjuntosInline(files);
    var enviados=files.slice();

    // 2) Si pasan del límite de Graph, se empaquetan en un solo ZIP
    if(_repAdjKb(adjuntos)/1024 > MAIL_MAX_MB && files.length>1){
      try{
        var JSZ=await _ensureJSZip();
        var zip=new JSZ();
        files.forEach(function(f){ zip.file(f.name, f); });
        var blob=await zip.generateAsync({type:'blob', compression:'DEFLATE'});
        var nombreZip='Reposicion_'+code+'_'+new Date().toISOString().slice(0,10)+'.zip';
        var zipFile=new File([blob], nombreZip, {type:'application/zip'});
        var zipAdj=await _repAdjuntosInline([zipFile]);
        if(_repAdjKb(zipAdj)/1024 <= MAIL_MAX_MB){ adjuntos=zipAdj; enviados=[zipFile]; }
      }catch(e){ console.warn('ZIP reposición:', e); }
    }

    // 3) Si ni comprimido cabe, mejor avisar que mandar el correo sin los archivos
    if(_repAdjKb(adjuntos)/1024 > MAIL_MAX_MB){
      showT('⚠ Los adjuntos pesan '+(_repAdjKb(adjuntos)/1024).toFixed(1)+' MB y el límite son '
            +MAIL_MAX_MB+' MB. Quita algún archivo o mándalos por separado.');
      return;
    }

    // 4) Copia en el storage, solo para el seguimiento de reposiciones (no bloquea)
    // Se guardan TODOS los archivos, no solo el primero: compras necesita
    // reenviar el PDF y el Excel al proveedor, y antes solo quedaba uno.
    var adjPath=null, adjNombre=enviados[0]?enviados[0].name:null;
    var adjTodos=[];
    try{
      for(var _a=0;_a<enviados.length;_a++){
        var _p=await _subirDocStorage('reposicion', code, enviados[_a]);
        if(!_p) continue;
        adjTodos.push({path:_p, nombre:enviados[_a].name});
        if(!adjPath){ adjPath=_p; adjNombre=enviados[_a].name; }
      }
    }catch(e){ console.warn('subir adjuntos de la reposición:',e); }
    try{ if(!adjPath) adjPath=await _subirDocStorage('reposicion', code, enviados[0]); }
    catch(e){ console.warn('storage reposición:', e); }

    // 5) Misma fila que los correos de las etapas → mismo envío por Azure
    var bodyBase={
      docnum: 'REP-'+code,
      para_lista: todos,
      para_email: todos[0],              // compatibilidad con lo anterior
      asunto: d.asunto,
      cuerpo: _repCuerpoTexto(d.cuerpo),
      adjuntos: adjuntos.map(function(a){
        return {nombre:a.nombre, contenido:a.contenido, mime:a.mime};
      }),
      de_nombre: (CU&&CU.name)||'',
      de_email:  (CU&&CU.email)||'',
      origen: 'Reposición · '+code,
      estado: 'pendiente'
    };
    // Columnas extra propias de reposiciones; si la tabla no las tiene, se reintenta sin ellas
    // OJO: NO se mandan aquí adjunto_path / adjunto_nombre. El worker adjuntaba
    // ese archivo ADEMÁS de los de `adjuntos`, y por eso el PDF llegaba 2 veces.
    // La copia en el storage se sigue guardando, pero solo para el seguimiento.
    var bodyFull=Object.assign({}, bodyBase, {
      proveedor: code,
      creado_por: (CU&&CU.name)||''
    });

    function _postCola(bodyObj){
      return fetch(SB+'/rest/v1/correos_queue',{
        method:'POST',
        headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(bodyObj)
      });
    }

    var r=await _postCola(bodyFull);
    if(!r.ok){
      var t0=await r.text();
      console.warn('correos_queue (columnas extra) falló, reintento sin ellas:', r.status, t0);
      r=await _postCola(bodyBase);
    }

    if(r.ok){
      var creado=null; try{ creado=await r.json(); }catch(e){}
      var filaId=(creado&&creado[0]&&creado[0].id)||null;
      // Si se está corrigiendo una reposición ya enviada, se actualiza esa
      // misma en vez de crear otra: si no, quedaban dos en el seguimiento.
      var _mod=window._repModificando;
      if(_mod && String(_mod.cardcode)===String(code)){
        try{
          await _firmaWrite(SB+'/rest/v1/reposiciones_envios?id=eq.'+_mod.id,'PATCH',{
            archivo_path:adjPath||null, archivo_nombre:adjNombre||null,
            archivos:(adjTodos&&adjTodos.length)?JSON.stringify(adjTodos):null,
            mail_asunto:(d&&d.asunto)||'', mail_cuerpo:(d&&d.cuerpo)||'',
            modificado_en:new Date().toISOString(),
            modificado_por:(CU&&CU.name)||''
          },['modificado_en']);
          showT('✓ Reposición corregida · ya puedes enviarla al proveedor');
          _repModificandoFin();
        }catch(e){ console.warn('actualizar reposición:',e); }
      } else {
        try{ await _repRegistrarEnvio(code, adjPath, adjNombre, d, destinatarios, adjTodos); }
        catch(e){ console.warn('registro envio rep:',e); }
      }
      showT('Enviando…');
      _repCerrarModalCorreo();
      _repSeguirCorreo(filaId, todos.length);
      setTimeout(function(){ try{ _repBadgeActualizar(); }catch(e){} }, 1500);
    } else {
      var t=await r.text(); console.error('correos_queue reposicion:', r.status, t);
      showT('⚠ No se pudo encolar. Revisa correos_queue.');
    }
  }catch(e){
    console.error('envío automático:', e);
    showT('⚠ Error al enviar: '+(e.message||e));
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  HELPERS DE LA REPOSICIÓN EN INGLÉS (RE-ORDER)
//  · Descripción: se usa el Foreign Name de SAP (frgnname). Si el item no lo
//    tiene, cae al itemname para no dejar la línea vacía.
//  · Colores: campo definido por usuario.
//  · Nombre de archivo: RE-ORDER P1276 270726 15-28
//    (se usa "-" en la hora porque Windows no permite ":" en nombres de archivo)
// ═══════════════════════════════════════════════════════════════════════════
function _repDescEN(x){
  return String((x && (x.frgnname || x.itemname)) || '').trim();
}
// ── Traducción de la columna Colors al inglés ──
// El campo de usuario viene cargado en español desde SAP. Lo que no esté en el
// diccionario se deja tal cual (puede ser un código o un color ya en inglés).
var _REP_COLOR_EN={
  // básicos
  'negro':'Black','negra':'Black','blanco':'White','blanca':'White',
  'gris':'Grey','plomo':'Grey','rojo':'Red','roja':'Red','azul':'Blue',
  'verde':'Green','amarillo':'Yellow','amarilla':'Yellow',
  'naranja':'Orange','anaranjado':'Orange','naranjado':'Orange',
  'morado':'Purple','purpura':'Purple','violeta':'Violet','lila':'Lilac',
  'rosa':'Pink','rosado':'Pink','rosada':'Pink','fucsia':'Fuchsia',
  'cafe':'Brown','marron':'Brown','carmelita':'Brown','chocolate':'Chocolate',
  'beige':'Beige','crema':'Cream','hueso':'Ivory','marfil':'Ivory',
  'dorado':'Gold','oro':'Gold','plateado':'Silver','plata':'Silver',
  'bronce':'Bronze','cobre':'Copper','niquel':'Nickel','cromo':'Chrome','cromado':'Chrome',
  'turquesa':'Turquoise','celeste':'Light Blue','aqua':'Aqua','agua':'Aqua',
  'vino':'Burgundy','borgona':'Burgundy','granate':'Maroon',
  'mostaza':'Mustard','coral':'Coral','menta':'Mint','salmon':'Salmon',
  'durazno':'Peach','ocre':'Ochre','arena':'Sand','terracota':'Terracotta',
  'transparente':'Clear','translucido':'Translucent','natural':'Natural',
  'madera':'Wood','bambu':'Bamboo','acero':'Steel','inoxidable':'Stainless',
  'multicolor':'Multicolor','surtido':'Assorted','surtidos':'Assorted',
  'surtida':'Assorted','surtidas':'Assorted','varios':'Assorted','colores':'Colors',
  // compuestos frecuentes
  'azul marino':'Navy Blue','azul rey':'Royal Blue','azul cielo':'Sky Blue',
  'azul claro':'Light Blue','azul oscuro':'Dark Blue',
  'verde oliva':'Olive Green','verde limon':'Lime Green','verde agua':'Aqua Green',
  'verde claro':'Light Green','verde oscuro':'Dark Green',
  'gris claro':'Light Grey','gris oscuro':'Dark Grey','gris perla':'Pearl Grey',
  'blanco mate':'Matt White','negro mate':'Matt Black','acero inoxidable':'Stainless Steel',
  'colores surtidos':'Assorted Colors','color natural':'Natural'
};
var _REP_MODIF_EN={ 'claro':'Light','clara':'Light','oscuro':'Dark','oscura':'Dark',
                    'mate':'Matt','brillante':'Glossy','metalico':'Metallic','pastel':'Pastel' };

function _repNorm(s){
  return String(s||'').toLowerCase().trim()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')   // quitar acentos
    .replace(/\s+/g,' ');
}
function _repCapitalizar(s){
  return String(s||'').replace(/\S+/g,function(w){ return w.charAt(0).toUpperCase()+w.slice(1); });
}
// Traduce un color suelto (puede venir con modificador: "gris claro")
function _repColorUno(txt){
  var n=_repNorm(txt); if(!n) return '';
  if(_REP_COLOR_EN[n]) return _REP_COLOR_EN[n];
  var pal=n.split(' ');
  var base=[], mods=[], reconocidos=0;
  pal.forEach(function(w){
    if(w==='y'||w==='con'||w==='de'||w==='color') return;
    if(_REP_MODIF_EN[w]){ mods.push(_REP_MODIF_EN[w]); reconocidos++; }
    else if(_REP_COLOR_EN[w]){ base.push(_REP_COLOR_EN[w]); reconocidos++; }
    else base.push(w);
  });
  // Si no se reconoció nada es un código o un texto propio: se deja tal cual
  if(!reconocidos) return String(txt).trim();
  var out=mods.concat(base).join(' ').trim();
  return out || String(txt).trim();
}
// Traduce el valor completo, respetando separadores: "negro / blanco y gris"
function _repColorEN(txt){
  var s=String(txt||'').trim(); if(!s) return '';
  var partes=s.split(/\s*[\/,;+|]\s*|\s+y\s+|\s+con\s+|\s+&\s+/i).filter(function(x){ return String(x).trim(); });
  if(partes.length<=1) return _repColorUno(s);
  return partes.map(_repColorUno).filter(Boolean).join(' / ');
}

function _repColores(x){
  return _repColorEN(String((x && x.colores) || '').trim());
}
function _repNum(n){ return Number(n||0).toLocaleString('en-US'); }
// Fecha larga en inglés: July 27, 2026
function _repFechaEN(d){
  return (d||new Date()).toLocaleDateString('en-US',{month:'long', day:'numeric', year:'numeric'});
}
// Sello DDMMYY HH-MM usado en el nombre de archivo
function _repSelloArchivo(d){
  d = d || new Date();
  var p=function(n){ return String(n).padStart(2,'0'); };
  return p(d.getDate())+p(d.getMonth()+1)+String(d.getFullYear()).slice(-2)
       + ' ' + p(d.getHours())+'-'+p(d.getMinutes());
}
function _repNombreArchivo(ext, d){
  return 'RE-ORDER '+(_repNumRepo?(_repNumRepo+' '):'')+(_repCard||'')+' '+_repSelloArchivo(d)+'.'+ext;
}

// Pinta el número de reposición en la pantalla, si hay dónde
function _repPintarNumero(){
  var el=document.getElementById('repNumRepo');
  if(!el) return;
  if(_repNumRepo){
    el.innerHTML='<span title="Número de esta reposición. Va en el PDF, el Excel, '
      +'el asunto y el cuerpo del correo." style="background:var(--pastel-lila);border:1px solid #C4B5FD;'
      +'color:var(--t-lila);border-radius:12px;padding:3px 11px;font-size:13px;font-weight:800;'
      +'margin-right:9px">'+_esc(_repNumRepo)+'</span>';
  } else if(window._repSinColumna){
    // Se muestra el motivo real y se puede reintentar sin recargar
    el.innerHTML='<span onclick="_repReintentarNumero()" title="'
      +_esc(window._repNumError||'No se pudo asignar el número')
      +' — clic para reintentar" style="cursor:pointer;background:var(--pastel-aviso);'
      +'border:1px solid #E9C08A;color:var(--t-marron);border-radius:12px;padding:3px 11px;'
      +'font-size:11.5px;font-weight:700;margin-right:9px">'
      +'<i class="ti ti-refresh"></i> sin número · reintentar</span>';
  } else {
    el.innerHTML='';
  }
}

// Reintenta a mano, sin recargar la página
async function _repReintentarNumero(){
  window._repSinColumna=false;
  showT('Buscando número de reposición…');
  var n=await _repAsegurarNumero();
  showT(n ? ('✓ Esta reposición es la '+n)
          : ('No se pudo: '+(window._repNumError||'revisa la columna num_reposicion')), 6000);
}

// Se asegura de que esta reposición tenga número, aunque el pedido se haya
// creado antes de que existiera el consecutivo.
async function _repAsegurarNumero(){
  if(_repNumRepo) return _repNumRepo;

  // Antes de sacar uno nuevo hay que preguntarle al pedido si YA tiene el
  // suyo. Si no, una reposición podía quedarse con dos números distintos:
  // el pedido con el que se le asignó al guardarlo y el envío con otro
  // sacado más tarde, cuando la página ya no lo recordaba.
  if(_repPedidoId){
    try{
      var rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=num_reposicion&id=eq.'
        +encodeURIComponent(_repPedidoId)+'&limit=1',{headers:SBH});
      if(rp.ok){
        var dp=await rp.json()||[];
        var ya=dp.length?String(dp[0].num_reposicion||'').trim():'';
        if(ya){
          _repNumRepo=ya;
          try{ _repPintarNumero(); }catch(e){}
          return _repNumRepo;
        }
      }
    }catch(e){ console.warn('[reposición] leer el número del pedido:', e); }
  }

  var n='';
  try{ n=await _repSiguienteNumero(); }catch(e){}
  if(!n){ window._repSinColumna=true; try{ _repPintarNumero(); }catch(e){} return ''; }
  _repNumRepo=n;
  if(!_repPedidoId){
    // Sin pedido no hay dónde guardarlo ni líneas que comparar después
    try{ await _repGuardarPendiente(); }catch(e){}
  }
  if(_repPedidoId){
    try{
      var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({num_reposicion:_repNumRepo, actualizado_en:new Date().toISOString()})});
      if(!r.ok){
        console.warn('[reposición] no se pudo guardar el número:', r.status);
        _repNumRepo=''; window._repSinColumna=true;
      }
    }catch(e){ _repNumRepo=''; window._repSinColumna=true; }
  }
  try{ _repPintarNumero(); }catch(e){}
  return _repNumRepo;
}

// El cuerpo va en TEXTO PLANO. El worker (kennedy_live.py) lo escapa y lo
// convierte a HTML poniendo <br> en cada salto de línea, así que aquí solo hay
// que normalizar los saltos y quitar espacios sobrantes al final de cada línea.
function _repCuerpoTexto(txt){
  var t=String(txt==null?'':txt).replace(/\r\n/g,'\n').replace(/\r/g,'\n');
  return t.split('\n').map(function(l){ return l.replace(/\s+$/,''); }).join('\n');
}

// ── PDF del pedido de reposición (con foto y cantidad por línea) ──
async function repPedidoPDF(sel, returnBlob){
  if(!window.jspdf||!window.jspdf.jsPDF){ showT('No se pudo cargar el generador de PDF'); return; }
  showT('Generando pedido PDF con fotos…');
  var doc=new window.jspdf.jsPDF({unit:'pt',format:'letter',compress:true});
  var W=612, M=40, y=0, azul=[30,80,165];
  var COL_COLOR=M+300, COL_BULTO=M+410;   // posiciones de las columnas Colors y Carton
  var ahora=new Date();
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var fecha=_repFechaEN(ahora);

  // Las fotos, por tandas
  var imgs=await _repCargarImgs(sel,
    function(x){ return _repFotoUrl(x.picturname); }, 10,
    function(n,t){ showT('Cargando fotos… '+n+'/'+t); });

  function header(pg){
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(0);
    doc.text(fecha, M, 38);
    doc.text('Page '+pg, W-M, 38, {align:'right'});
    doc.setFontSize(15); doc.setTextColor(azul[0],azul[1],azul[2]); doc.setFont('helvetica','bold');
    doc.text('KENNEDY CENTER CORP.', W/2, 56, {align:'center'});
    doc.setFontSize(12); doc.setTextColor(0);
    doc.text('RE-ORDER'+(_repNumRepo?('   '+_repNumRepo):''), W/2, 72, {align:'center'});
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.8); doc.line(M,78,W-M,78);
    doc.setFontSize(11);
    doc.text(code+'   '+cardname, W/2, 94, {align:'center'});
    doc.setLineWidth(1); doc.line(M,100,W-M,100);
    // Cabecera de columnas (en inglés)
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(80);
    doc.text('Photo', M, 116);
    doc.text('Code / Description', M+70, 116);
    doc.text('Colors', COL_COLOR, 116);
    doc.text('Carton', COL_BULTO, 116);
    doc.text('Quantity', W-M, 116, {align:'right'});
    doc.setDrawColor(180); doc.setLineWidth(0.5); doc.line(M,120,W-M,120);
    doc.setFont('helvetica','normal'); doc.setTextColor(0);
    return 130;
  }

  var page=1; y=header(page);
  var totalUnid=0, totalItems=0, totalBultos=0;

  sel.forEach(function(x){
    if(y+60>770){ doc.addPage(); page++; y=header(page); }
    var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
    var cant=x._cant;
    totalUnid+=cant; totalItems++;
    totalBultos+=cant/bulto;

    var rowY=y;
    // Foto
    var im=imgs[x.itemcode];
    if(im){
      try{
        var mw=46, mh=46, r=Math.min(mw/im.w, mh/im.h);
        doc.addImage(im.data,'JPEG', M, rowY-2, im.w*r, im.h*r);
      }catch(e){}
    } else {
      doc.setDrawColor(210); doc.rect(M, rowY-2, 46, 46);
    }
    // Código + descripción
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(azul[0],azul[1],azul[2]);
    doc.text(String(x.itemcode||''), M+70, rowY+8);
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(0);
    // Descripción en inglés (Foreign Name)
    var nombre=_repDescEN(x);
    doc.text(nombre.length>46?nombre.slice(0,46)+'...':nombre, M+70, rowY+20);
    // Colores
    var col=_repColores(x);
    if(col){
      doc.setFontSize(8); doc.setTextColor(60);
      doc.text(col.length>18?col.slice(0,18)+'...':col, COL_COLOR, rowY+12);
      doc.setTextColor(0);
    }
    // Bulto / carton
    doc.setFontSize(8);
    doc.text(String(bulto)+' pcs', COL_BULTO, rowY+12);
    // Cantidad (grande, azul)
    doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(azul[0],azul[1],azul[2]);
    doc.text(String(cant), W-M, rowY+14, {align:'right'});
    doc.setFont('helvetica','normal'); doc.setTextColor(0);
    // Separador
    y=rowY+52;
    doc.setDrawColor(220); doc.setLineWidth(0.4); doc.line(M,y-4,W-M,y-4);
  });

  // Totales
  if(y+40>770){ doc.addPage(); page++; y=header(page); }
  totalBultos=Math.round(totalBultos*100)/100;
  doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.5); doc.line(M,y,W-M,y); y+=18;
  doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(azul[0],azul[1],azul[2]);
  doc.text(_repNum(totalItems)+' references  -  '+_repNum(totalUnid)+' units  -  '+_repNum(totalBultos)+' cartons', M, y);
  doc.setFont('helvetica','normal'); doc.setTextColor(0);

  var nombrePDF=_repNombreArchivo('pdf', ahora);
  if(returnBlob){
    var blobPDF=doc.output('blob');
    return new File([blobPDF], nombrePDF, {type:'application/pdf'});
  }
  doc.save(nombrePDF);
  showT('✓ Pedido PDF generado');
}

// ── Excel del pedido de reposición (con fotos embebidas y cantidades) ──
// ── Cargar ExcelJS (para incrustar fotos, igual que el portal de ventas) ──
var _exceljsLoad=null;
function _ensureExcelJS(){
  if(window.ExcelJS) return Promise.resolve(window.ExcelJS);
  if(_exceljsLoad) return _exceljsLoad;
  _exceljsLoad=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js';
    sc.onload=function(){ if(window.ExcelJS) res(window.ExcelJS); else rej(new Error('ExcelJS no disponible')); };
    sc.onerror=function(){ rej(new Error('No se pudo cargar la librería de Excel (revisa la conexión)')); };
    document.head.appendChild(sc);
  });
  return _exceljsLoad;
}
// Descarga una imagen y la devuelve como {b64, ext} para incrustarla en Excel
// Baja una imagen y la COMPRIME antes de meterla en el archivo.
// Las fotos del bucket pesan 150-400 KB cada una; en un PDF o Excel de 200
// artículos eso son decenas de MB. Reducidas a 340 px pesan ~15 KB y en el
// papel o la celda se ven igual.
async function _repImgToB64(url, lado, calidad){
  lado=lado||340; calidad=(calidad==null?0.62:calidad);
  try{
    var img=await new Promise(function(res,rej){
      var im=new Image();
      im.crossOrigin='anonymous';
      im.onload=function(){ res(im); };
      im.onerror=function(){ rej(new Error('no carga')); };
      im.src=url;
      setTimeout(function(){ rej(new Error('tardó demasiado')); }, 30000);
    });
    var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
    if(!w || !h) return null;
    // Si ya es chica, no se agranda
    var esc=Math.min(1, lado/Math.max(w,h));
    var cw=Math.max(1,Math.round(w*esc)), ch=Math.max(1,Math.round(h*esc));
    var cv=document.createElement('canvas');
    cv.width=cw; cv.height=ch;
    var cx=cv.getContext('2d');
    cx.fillStyle='#ffffff';       // los PNG transparentes saldrían negros en JPEG
    cx.fillRect(0,0,cw,ch);
    cx.drawImage(img,0,0,cw,ch);
    var b64=cv.toDataURL('image/jpeg', calidad).split(',')[1]||null;
    return b64?{b64:b64, ext:'jpeg', kb:Math.round(b64.length*0.75/1024)}:null;
  }catch(e){
    // Si el canvas falla (por ejemplo por CORS), se usa el original
    try{
      var _ac=new AbortController(); var _to=setTimeout(function(){try{_ac.abort();}catch(_){}} ,7000);
      var r; try{ r=await fetch(url,{mode:'cors',signal:_ac.signal}); } finally { clearTimeout(_to); }
      if(!r.ok) return null;
      var blob=await r.blob();
      var ty=(blob.type||'').toLowerCase();
      var ext = ty.indexOf('png')>=0?'png' : (ty.indexOf('gif')>=0?'gif' : 'jpeg');
      var b2=await new Promise(function(res){
        var fr=new FileReader();
        fr.onload=function(){ res(String(fr.result).split(',')[1]||null); };
        fr.onerror=function(){ res(null); };
        fr.readAsDataURL(blob);
      });
      return b2?{b64:b2, ext:ext, kb:Math.round(b2.length*0.75/1024)}:null;
    }catch(e2){ return null; }
  }
}


async function repPedidoExcel(sel, returnBlob){
  showT('Generando Excel con fotos…');
  var ExcelJS;
  try{ ExcelJS=await _ensureExcelJS(); }
  catch(e){ showT('No se pudo cargar Excel'); return; }

  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var verC=CU.verCostos;
  var _repXlsAhora=new Date();

  // Definir columnas (la primera es la foto)
  var cols=[
    {label:'Photo', width:9, foto:true},
    {label:'Code', width:14},
    {label:'Description', width:44},
    {label:'Colors', width:18},
    {label:'Quantity', width:12, numFmt:'#,##0'},
    {label:'Carton (pcs)', width:13, numFmt:'#,##0'},
    {label:'Cartons', width:10, numFmt:'#,##0.00'}
  ];
  var nc=cols.length;

  // Precargar fotos (base64) en paralelo
  var urls=sel.map(function(x){ return _repFotoUrl(x.picturname); });
  var imgMap={};
  // Por tandas, para no saturar al navegador con cientos de descargas
  for(var _i=0;_i<urls.length;_i+=10){
    var _lote=urls.slice(_i,_i+10);
    await Promise.all(_lote.map(function(u){
      if(!u) return Promise.resolve();
      return _repImgToB64(u).then(function(im){ imgMap[u]=im; });
    }));
    if(_i%40===0) showT('Cargando fotos… '+Math.min(_i+10,urls.length)+'/'+urls.length);
  }

  var wb=new ExcelJS.Workbook();
  var ws=wb.addWorksheet('Re-order', {views:[{state:'frozen', ySplit:4}]});

  // ── Título (fila 1) ──
  ws.mergeCells(1,1,1,nc);
  var c1=ws.getCell(1,1);
  c1.value='RE-ORDER '+(_repNumRepo?(_repNumRepo+' '):'')+'— KENNEDY CENTER CORP.';
  c1.font={bold:true, size:15, color:{argb:'FFFFFFFF'}};
  c1.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF1E50A5'}};
  c1.alignment={vertical:'middle', horizontal:'center'};
  ws.getRow(1).height=26;

  // ── Subtítulo (fila 2) ──
  ws.mergeCells(2,1,2,nc);
  var c2=ws.getCell(2,1);
  c2.value=code+(cardname?('  —  '+cardname):'')+'     ·     '+_repFechaEN(_repXlsAhora)+'     ·     '+_repNum(sel.length)+' references';
  c2.font={size:10, bold:true, color:{argb:'FF1E50A5'}};
  c2.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEFF4FB'}};
  c2.alignment={vertical:'middle', horizontal:'center'};
  ws.getRow(2).height=18;
  // Fila 3 vacía de separación
  ws.getRow(3).height=4;

  // ── Cabecera de columnas (fila 4) con color distinto ──
  cols.forEach(function(c,ci){
    var h=ws.getCell(4,ci+1);
    h.value=c.label;
    h.font={bold:true, size:11, color:{argb:'FFFFFFFF'}};
    h.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFB45309'}}; // naranja Kennedy
    h.alignment={vertical:'middle', horizontal:'center'};
    h.border={bottom:{style:'thin',color:{argb:'FF9A4A08'}}};
    var col=ws.getColumn(ci+1); col.width=c.width||14; if(c.numFmt) col.numFmt=c.numFmt;
  });
  ws.getRow(4).height=20;

  // ── Filas de items ──
  sel.forEach(function(x, ri){
    var rowNum=5+ri;
    var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
    var vals=[
      '', // foto (columna 1) — se incrusta como imagen
      x.itemcode||'',
      _repDescEN(x),          // descripción en inglés (Foreign Name)
      _repColores(x),         // campo definido por usuario "Colores"
      Number(x._cant)||0,
      bulto,
      Math.round((x._cant/bulto)*100)/100
    ];
    vals.forEach(function(v,ci){
      var cell=ws.getCell(rowNum,ci+1);
      if(ci>0) cell.value=v;   // la col 0 es la foto
      cell.alignment={vertical:'middle', horizontal:(ci>=4?'center':'left'), wrapText:(ci===2||ci===3)};
      // Zebra: filas alternas con fondo suave
      if(ri%2===1) cell.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFF7F7F7'}};
      cell.border={bottom:{style:'hair',color:{argb:'FFDDDDDD'}}};
    });
    // Incrustar foto
    ws.getRow(rowNum).height=48;
    var u=_repFotoUrl(x.picturname); var im=u?imgMap[u]:null;
    if(im && im.b64){
      var id=wb.addImage({base64:im.b64, extension:im.ext});
      ws.addImage(id, { tl:{col:0.12, row:(rowNum-1)+0.10}, ext:{width:56,height:56}, editAs:'oneCell' });
    }
  });

  // ── Fila de totales ──
  var totRow=5+sel.length;
  var totUnid=sel.reduce(function(s,x){return s+(Number(x._cant)||0);},0);
  var totBultos=sel.reduce(function(s,x){var b=Math.max(1,Number(x.u_cxblt)||Number(x.salpackun)||1);return s+(x._cant/b);},0);
  totBultos=Math.round(totBultos*100)/100;
  ws.mergeCells(totRow,1,totRow,4);
  var tc=ws.getCell(totRow,1);
  tc.value='TOTAL: '+_repNum(sel.length)+' references';
  tc.font={bold:true, color:{argb:'FF1E50A5'}};
  tc.alignment={vertical:'middle', horizontal:'right'};
  var tCant=ws.getCell(totRow,5); tCant.value=totUnid; tCant.font={bold:true}; tCant.numFmt='#,##0'; tCant.alignment={horizontal:'center'};
  var tBlt=ws.getCell(totRow,7); tBlt.value=totBultos; tBlt.font={bold:true,color:{argb:'FF6D28D9'}}; tBlt.numFmt='#,##0.00'; tBlt.alignment={horizontal:'center'};
  ws.getRow(totRow).height=20;

  var buf=await wb.xlsx.writeBuffer();
  var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var nombreXLS=_repNombreArchivo('xlsx', _repXlsAhora);
  if(returnBlob){
    return new File([blob], nombreXLS, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  }
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download=nombreXLS;
  document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  showT('✓ Pedido Excel generado con fotos');
}

// ── HTML imprimible del pedido, con fotos embebidas (se abre para imprimir/guardar) ──
function repPedidoHTML(sel, imgs){
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var fecha=new Date().toLocaleDateString('es');
  var filas=sel.map(function(x){
    var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
    var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
    var img=imgs[x.itemcode];
    return '<tr>'
      +'<td style="text-align:center">'+(img?'<img src="'+img+'" style="width:60px;height:60px;object-fit:cover;border:1px solid #ccc">':'—')+'</td>'
      +'<td><b>'+_esc(x.itemcode)+'</b><br><span style="font-size:11px">'+_esc(x.itemname||'')+'</span>'
        +((x.u_color||x.u_tamano)?'<br><span style="font-size:10px;color:#666">'+[x.u_color,x.u_tamano].filter(Boolean).join(' · ')+'</span>':'')+'</td>'
      +'<td style="text-align:right">'+_fmtN2(disp)+'</td>'
      +'<td style="text-align:center">'+bulto+' pz</td>'
      +'<td style="text-align:right;font-size:16px;font-weight:bold;color:#1e50a5">'+x._cant+'</td>'
      +'</tr>';
  }).join('');
  var totalUnid=sel.reduce(function(s,x){return s+x._cant;},0);
  var html='<!DOCTYPE html><html><head><meta charset="utf-8"><title>Pedido '+_esc(code)+'</title>'
    +'<style>body{font-family:Arial,sans-serif;margin:24px;color:var(--text-primary)}h1{color:#1e50a5;text-align:center;margin:0}h2{text-align:center;font-weight:normal;margin:4px 0}'
    +'table{width:100%;border-collapse:collapse;margin-top:16px}th{background:#1e50a5;color:#fff;padding:8px;font-size:12px}td{border-bottom:1px solid #ddd;padding:8px;font-size:12px}'
    +'.tot{margin-top:16px;text-align:right;font-size:14px;font-weight:bold;color:#1e50a5}</style></head><body>'
    +'<h1>KENNEDY CENTER CORP.</h1><h2>PEDIDO DE REPOSICIÓN</h2>'
    +'<p style="text-align:center">'+_esc(code)+' — '+_esc(cardname)+' · '+fecha+'</p>'
    +'<table><thead><tr><th>Foto</th><th>Código / Descripción</th><th>Disp.</th><th>Bulto</th><th>Cantidad</th></tr></thead>'
    +'<tbody>'+filas+'</tbody></table>'
    +'<div class="tot">'+sel.length+' items · '+totalUnid+' unidades</div>'
    +'<div style="margin-top:20px;text-align:center"><button onclick="window.print()" style="padding:8px 16px;background:#1e50a5;color:#fff;border:none;border-radius:6px;cursor:pointer">Imprimir / Guardar PDF</button></div>'
    +'</body></html>';
  var w=window.open('','_blank');
  if(w){ w.document.write(html); w.document.close(); }
}


function setAlDept(d){dAdept=d;rAlertas();}
function setAlUser(u){dAuser=u;rAlertas();}
function alCard(a){const key=`${a.oid}_${a.role}`;const recs=recordatorios[key]||[];const labelRole={compras:'Compras',contabilidad:'Contabilidad',diseno:'Diseño',gerencia:'Gerencia',importacion:'Importación',bodega:'Bodega'}[a.role]||a.role;return`<div class="al-card"><div class="al-hdr"><div class="al-dot" style="background:${a.color}"></div><div class="al-body"><div style="font-size:12px;font-weight:500">${a.o.prov} — ${a.oid}</div><div style="font-size:11px;color:var(--text-secondary);margin-top:2px">${dL(a.dept)} · ${a.o.desc}</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">${a.msg}</div><div style="display:flex;gap:5px;margin-top:4px;flex-wrap:wrap"><span style="font-size:10px;background:${a.color}22;color:${a.color};padding:1px 7px;border-radius:8px;border:0.5px solid ${a.color}55">Responsable: ${labelRole}</span><span style="font-size:10px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:1px 7px;color:var(--text-muted)">${EMOJIS2[a.dept]||''} ${dL(a.dept)}</span></div>${recs.length?`<div style="font-size:10px;color:var(--text-success);margin-top:4px;display:flex;align-items:center;gap:4px"><i class="ti ti-send" style="font-size:10px"></i>${recs.length} recordatorio${recs.length>1?'s':''} enviado${recs.length>1?'s':''} · Último: ${recs[recs.length-1].date}</div>`:''}</div></div><div class="al-actions"><button class="btn bg2" style="font-size:11px;padding:4px 10px" onclick="openDetail('${a.oid}')"><i class="ti ti-eye"></i>Ver orden</button>${CU.role==='gerencia'?`<button class="btn brem" onclick="sendRecordatorio('${a.oid}','${a.role}','${labelRole}')"><i class="ti ti-bell"></i>Enviar recordatorio</button>`:''}${_alResolverBotones(a)}</div></div>`;}

/* Las alertas de depósito se resuelven desde la propia alerta: o el abono
   ya se hizo, o esa orden no lleva abono. Antes había que entrar a la
   orden, buscar la etapa y marcar el paso, y por eso se quedaban ahí
   semanas aunque ya estuviera todo pagado. */
function _alResolverBotones(a){
  if(!a || a.type!=='deposito') return '';
  if(!(_esGerencia() || CU.role==='contabilidad' || _esCompras())) return '';
  return '<button class="btn bg2" style="font-size:11px;padding:4px 10px" '
    +'onclick="_alDepositoHecho(\''+a.oid+'\',false)">'
    +'<i class="ti ti-check"></i>Ya abonado</button>'
    +'<button class="btn bg2" style="font-size:11px;padding:4px 10px" '
    +'onclick="_alDepositoHecho(\''+a.oid+'\',true)">'
    +'<i class="ti ti-circle-off"></i>No requiere abono</button>';
}

// Marca el depósito de esa orden y deja dicho por qué, para que quede el
// rastro de quién lo resolvió y cuándo.
async function _alDepositoHecho(oid, sinAbono){
  var o=orders.find(function(x){ return String(x.id)===String(oid); });
  if(!o) return;
  var motivo = sinAbono
    ? 'Esta orden no requiere abono.'
    : 'El abono ya se hizo (se marca desde la alerta).';
  if(!confirm((sinAbono?'NO REQUIERE ABONO':'ABONO YA HECHO')+'\n\nOrden '+oid+' · '
    +(o.prov||'')+'\n\nLa alerta de depósito pendiente desaparece y queda el '
    +'comentario en la etapa Depósito & Pago.\n\n¿Sigo?')) return;
  try{
    initP(oid);
    var sp=stageProgress[oid];
    if(sp && sp.deposito && (sp.deposito.stepIdx||0)===0) advSS(oid,'deposito',0);
  }catch(e){ console.warn('[alerta] marcar depósito:', e); }
  try{ await guardarComentario(oid,'deposito', motivo+' — '+((CU&&CU.name)||'')); }catch(e){}
  showT('✓ Orden '+oid+': '+(sinAbono?'marcada como que no requiere abono'
                                      :'depósito marcado como hecho'));
  try{ rAlertas(); }catch(e){ try{ go('alertas'); }catch(e2){} }
}
function sendRecordatorio(oid,role,labelRole){const o=orders.find(x=>x.id===oid);if(!o)return;document.getElementById('qmc').innerHTML=`<div style="font-size:14px;font-weight:500;margin-bottom:4px">Enviar recordatorio</div><div style="font-size:12px;color:var(--text-muted);margin-bottom:12px">Para: <strong>${labelRole}</strong> · ${o.prov} — ${oid}</div><textarea id="rem-msg" class="cin" rows="3" style="width:100%;font-size:12px;margin-bottom:10px" placeholder="Escribe el mensaje del recordatorio...">Por favor atender urgentemente la alerta en la orden ${oid} de ${dL(o.dept)}.</textarea><div style="display:flex;gap:8px;justify-content:flex-end"><button class="btn bg2" onclick="CQM()">Cancelar</button><button class="btn bp" onclick="confirmarRecordatorio('${oid}','${role}')"><i class="ti ti-send"></i>Enviar</button></div>`;document.getElementById('qmodal').style.display='flex';}
function confirmarRecordatorio(oid,role){const msg=document.getElementById('rem-msg')?.value.trim();if(!msg)return;const key=`${oid}_${role}`;if(!recordatorios[key])recordatorios[key]=[];recordatorios[key].push({by:CU.name,date:dateOnly(),msg});addNotif(role,`📣 Recordatorio de ${CU.name}: ${msg}`,oid,'ti-bell');CQM();showT(`✓ Recordatorio enviado a ${role}`);rAlertas();renderNP();}
function CQM(){document.getElementById('qmodal').style.display='none';}
// ═══════════════════════════════════════════════════════════════════════════
//  COMPRAS PARA FIRMA — subir PDF/Excel, autollenar con AI, firma de gerencia
//  dibujada que queda estampada en el PDF, y notificación al comprador.
//  Requiere la tabla Supabase: ordenes_firma (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
var _firmaArchivo=null, _firmaPendCount=0;
function _fv(id){ var el=document.getElementById(id); return el?String(el.value||'').trim():''; }
function _sv(id,v){ var el=document.getElementById(id); if(el) el.value=v; }
function _fileToBase64(f){ return new Promise(function(res,rej){ var r=new FileReader(); r.onload=function(){ var t=String(r.result||''); res(t.slice(t.indexOf(',')+1)); }; r.onerror=rej; r.readAsDataURL(f); }); }
function _dataURLtoUint8(d){ var b=atob(d.split(',')[1]); var a=new Uint8Array(b.length); for(var i=0;i<b.length;i++)a[i]=b.charCodeAt(i); return a; }
function _firmaCorreoDe(uid){ var u=(USERS||[]).find(function(x){return x.id===uid;}); return u?u.email:''; }
function _ensurePdfLib(){
  if(window.PDFLib) return Promise.resolve(window.PDFLib);
  if(window._pdflibLoad) return window._pdflibLoad;
  window._pdflibLoad=new Promise(function(res,rej){ var s=document.createElement('script'); s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf-lib/1.17.1/pdf-lib.min.js'; s.onload=function(){res(window.PDFLib);}; s.onerror=rej; document.head.appendChild(s); });
  return window._pdflibLoad;
}
function _ffld(id,label,type,ph){ return '<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">'+label+'</label><input id="'+id+'" type="'+type+'" class="fi2" placeholder="'+ph+'"></div>'; }

function _firmaRefrescarLista(){
  try{ _firmaCargarLista(CU && CU.role==='gerencia' ? 'gerencia' : 'compras'); }catch(e){ console.warn('lista firma:', e); }
}

function rNueva(){ var cont=document.getElementById('page-nueva'); if(!cont) return; if(CU.role==='gerencia') _firmaRenderGerencia(cont); else _firmaRenderCompras(cont); }

function _firmaRenderCompras(cont){
  var deptOpts=_deptAcotado()
    ? _deptsVisibles().map(function(d,i){
        return '<option value="'+d+'"'+(i===0?' selected':'')+'>'+dL(d)+'</option>'; }).join('')
    : DEPTS_ALL.map(function(d){return '<option value="'+d+'">'+dL(d)+'</option>';}).join('');
  cont.innerHTML=''
    +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:6px">'
    +'<div style="font-size:13px;font-weight:600"><i class="ti ti-writing"></i> '
    +'Nueva compra para firma</div><span style="flex:1"></span>'
    // Antes de mandarla a gerencia, compras puede revisar los precios
    +'<button class="btn bg2" style="padding:7px 14px;color:var(--t-lila);'
    +'border-color:var(--t-lila)" onclick="_cmpAbrir()">'
    +'<i class="ti ti-scale"></i> Comparación de precios</button></div>'
    +'<div style="font-size:12px;color:var(--text-muted);background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius);padding:8px 10px;margin-bottom:12px"><i class="ti ti-info-circle"></i> Sube el PDF con <b>las dos órdenes</b> (la nuestra y la del proveedor) y usa <b>AI</b> para rellenar los datos. La AI identifica cuál es cuál por el logo de Kennedy Center, las compara línea por línea y te avisa de cualquier diferencia. Al enviar, gerencia firma ambas y te llega el archivo firmado.</div>'
    +'<div style="display:flex;flex-direction:column;gap:7px;margin-bottom:8px">'
      +_nsapCajaArchivo('fprov','PI PROVEEDOR','Proforma Invoice del proveedor','#B45309','#FEF9F3','#E9C08A')
      +_nsapCajaArchivo('fkcc','KCC ORDEN DE COMPRA','Nuestra orden de compra','#0c447c','#e6f1fb','#85B7EB')
    +'</div>'
    +'<div style="margin-bottom:8px">'
      +'<button class="btn bp" onclick="_firmaAI()" style="background:#6D28D9"><i class="ti ti-sparkles"></i> AI rellenar y revisar</button> '
      +'<button class="btn bp" onclick="_firmaCompararRepBoton()" style="background:#0F766E;margin-left:6px">'
      +'<i class="ti ti-package"></i> Comparar contra la reposición</button>'
    +'</div>'
    +'<div id="firma-ai-status" style="font-size:11px;color:var(--text-muted);margin-bottom:6px"></div>'
    +'<div id="firma-ai-errores" style="margin-bottom:10px"></div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:10px">'
      +_ffld('firma-orden','No. de orden (DKC / SKC) *','text','Ej: DKC-25090 o SKC-25090')
      +_ffld('firma-prov','Proveedor *','text','Nombre del proveedor')
      +'<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Departamento *</label><select id="firma-dept" class="fi2" '+((_deptAcotado()&&_deptsVisibles().length===1)?'disabled':'')+'>'+deptOpts+'</select></div>'
      +_ffld('firma-desc','Descripción *','text','Ej: Sofás esquineros')
      +_ffld('firma-monto','Monto total (USD) *','number','0.00')
      +_ffld('firma-uni','Unidades','number','0')
      +_ffld('firma-fecha','Fecha estimada (campo Date del archivo)','date','')
    +'</div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-bottom:16px"><button class="btn bp" onclick="_firmaEnviar()"><i class="ti ti-send"></i> Enviar a firma de gerencia</button></div>'
    +'<div id="firma-lista"></div>';
  _firmaArchivo=null; window._firmaDocs={prov:null,kcc:null};
  _firmaCargarLista('compras');
}
function _firmaRenderGerencia(cont){
  cont.innerHTML=''
    +'<div style="font-size:13px;font-weight:600;margin-bottom:6px"><i class="ti ti-signature"></i> Compras para firmar</div>'
    +'<div style="font-size:12px;color:var(--text-muted);background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius);padding:8px 10px;margin-bottom:12px"><i class="ti ti-info-circle"></i> Revisa el archivo, dibuja tu firma y fírmala. <b>Se firman las dos órdenes: la nuestra y la del proveedor.</b> Si la compra trae revisión AI, mírala antes de firmar. La orden firmada le llega al comprador con el adjunto.</div>'
    +'<div id="firma-lista"></div>';
  _firmaCargarLista('gerencia');
}
function _firmaSetArchivo(input){ var f=input.files&&input.files[0]; if(!f) return; _firmaArchivo=f; window._firmaRevisionIA=null; var el=document.getElementById('firma-file-name'); if(el) el.textContent=f.name; var eb=document.getElementById('firma-ai-errores'); if(eb) eb.innerHTML=''; var st=document.getElementById('firma-ai-status'); if(st) st.innerHTML=''; }

// ── Normaliza el N° de orden extraído: DKC-25090 / SKC-25090 ──
// Acepta "dkc 25090", "DKC25090", "Order No. SKC-25090", etc.
// ═══════════════════════════════════════════════════════════════════════════
//  LLAMADAS A LA IA QUE DEVUELVEN JSON
//  Los documentos con muchas líneas (50+) hacen que la respuesta se corte por
//  el límite de tokens y el JSON quede a medias ("Unexpected end of JSON
//  input"). Aquí se resuelve de dos formas:
//   1. Si la respuesta se cortó, se pide que CONTINÚE donde quedó y se pega.
//   2. Si aun así quedó incompleta, se repara cerrando lo que quedó abierto y
//      se avisa que la lista puede venir recortada.
// ═══════════════════════════════════════════════════════════════════════════
window._iaJSONReparado=false;

function _iaRepararJSON(s){
  var enStr=false, esc=false, ultimoCierre=-1;
  for(var i=0;i<s.length;i++){
    var c=s.charAt(i);
    if(enStr){
      if(esc) esc=false;
      else if(c==='\\') esc=true;
      else if(c==='"') enStr=false;
      continue;
    }
    if(c==='"'){ enStr=true; continue; }
    if(c==='}'||c===']') ultimoCierre=i;
  }
  if(ultimoCierre<0) throw new Error('La AI devolvió una respuesta incompleta');
  var base=s.slice(0, ultimoCierre+1);
  // Recalcular qué corchetes quedaron abiertos y cerrarlos
  var pila=[], inS=false, es=false;
  for(var k=0;k<base.length;k++){
    var ch=base.charAt(k);
    if(inS){
      if(es) es=false;
      else if(ch==='\\') es=true;
      else if(ch==='"') inS=false;
      continue;
    }
    if(ch==='"'){ inS=true; continue; }
    if(ch==='{') pila.push('}');
    else if(ch==='[') pila.push(']');
    else if(ch==='}'||ch===']') pila.pop();
  }
  base=base.replace(/,\s*$/,'');
  while(pila.length) base+=pila.pop();
  return base;
}

function _iaParseJSON(txt){
  window._iaJSONReparado=false;
  var s=String(txt||'').replace(/```json/gi,'').replace(/```/g,'').trim();
  var i=s.indexOf('{');
  if(i<0) throw new Error('La AI no devolvió datos en formato JSON');
  s=s.slice(i);
  var fin=s.lastIndexOf('}');
  if(fin>0){ try{ return JSON.parse(s.slice(0,fin+1)); }catch(e){} }
  try{ return JSON.parse(s); }catch(e){}
  window._iaJSONReparado=true;
  return JSON.parse(_iaRepararJSON(s));
}

// Llama a la IA y devuelve el JSON ya parseado, continuando si se cortó
async function _iaJSON(content, maxTokens, onProgreso){
  var acumulado='', stop='', vueltas=0;
  var max=maxTokens||8000;
  do{
    var msgs=[{role:'user', content:content}];
    if(acumulado) msgs.push({role:'assistant', content:acumulado.replace(/\s+$/,'')});
    var r=await fetch('https://api.anthropic.com/v1/messages',{
      method:'POST',
      headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
      body:JSON.stringify({model:IA_MODELO, max_tokens:max, messages:msgs})
    });
    // Si la respuesta no viene en JSON, r.json() lanza un error con los bytes
    // crudos dentro ("Unexpected token '\uFFFD'..."), que no dice nada. Se lee
    // como texto y se informa del código y de lo que llegó.
    var j, crudo='';
    try{
      crudo=await r.text();          // texto primero: json() consume el cuerpo
      j=JSON.parse(crudo);
    }catch(errJ){
      var pista=String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,200);
      console.error('[IA] respuesta no válida · estado '+r.status+' · '+pista);
      throw new Error(
        r.status===401 ? 'La clave de la IA no es válida o caducó.'
      : r.status===429 ? 'La IA está saturada ahora mismo. Prueba en un minuto.'
      : r.status===413 ? 'El documento es demasiado grande para la IA. '
                        +'Divídelo o súbelo en Excel o CSV.'
      : (r.status>=500 ? 'La IA no respondió bien (error '+r.status+'). Prueba de nuevo.'
                       : 'La IA devolvió algo que no se pudo interpretar (estado '
                         +r.status+'). Mira la consola para el detalle.'));
    }
    if(j&&j.error) throw new Error(j.error.message||'Error de IA');
    acumulado+=(j.content||[]).map(function(c){return c.text||'';}).join('');
    stop=j.stop_reason||'';
    vueltas++;
    if(stop==='max_tokens' && typeof onProgreso==='function'){
      onProgreso(vueltas);
    }
  } while(stop==='max_tokens' && vueltas<6);
  return _iaParseJSON(acumulado);
}

// ── Normaliza el N° de orden extraído: DKC-25090 / SKC-25090 ──
function _firmaNormRef(v){
  var t=String(v||'').toUpperCase().replace(/[_\s]+/g,' ');
  var m=t.match(/\b(DKC|SKC)\s*-?\s*([A-Z0-9]{2,})/);
  if(m) return m[1]+'-'+m[2];
  return '';
}

// ── Normaliza el N° de orden de una orden NO SAP ──
// Nuestra orden escribe "DKC No.  26084" (el número solo, sin prefijo) y la PI
// del proveedor escribe "PO No: DKC-26084". La IA copia lo que ve, así que
// según qué documento mire devolvía 26084 pelado. Aquí se le devuelve el
// prefijo: primero se busca en las otras referencias del mismo análisis
// (el PO del proveedor, el número que citó el otro documento) y, si en
// ninguna aparece, se asume DKC- que es lo habitual.
// Saca el par prefijo+número de un texto. Entre los dos puede haber palabras
// de relleno ("DKC No. 26084", "DKC N° 26084"), y el número siempre lleva
// algún dígito: así "No" no se confunde con el número de orden.
function _nsapRefPartes(txt){
  var t=String(txt||'').toUpperCase();
  var re=/\b(DKC|SKC)\s*(?:NO\.?|N[º°]\.?|NUM(?:ERO)?\.?|#|:)?\s*-?\s*([A-Z0-9\-]{2,})/g, m;
  while((m=re.exec(t))){
    var tok=m[2].replace(/^-+|-+$/g,'');
    if(/\d/.test(tok)) return {pre:m[1], num:tok};
  }
  return null;
}
function _nsapNormRef(valor, alternativas){
  var t=String(valor||'').toUpperCase().replace(/[_\s]+/g,' ').trim();
  if(!t) return '';
  // Ya viene con prefijo: solo se le da forma DKC-26084
  var p=_nsapRefPartes(t);
  if(p) return p.pre+'-'+p.num;
  // Viene el número pelado: se busca el prefijo en las otras referencias
  var num=t.match(/([A-Z0-9]*\d[A-Z0-9]*)/);
  if(!num) return t;
  num=num[1];
  var alts=(alternativas||[]);
  for(var i=0;i<alts.length;i++){
    var a=_nsapRefPartes(alts[i]);
    if(a && a.num===num) return a.pre+'-'+a.num;
  }
  // Ningún documento trae el prefijo: se usa el de la casa
  return 'DKC-'+num;
}

// ── Normaliza la fecha del documento a YYYY-MM-DD (lo que pide <input type=date>) ──
function _firmaNormFecha(v){
  var s=String(v||'').trim();
  if(!s) return '';
  // Ya viene en el formato correcto
  var m=s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m) return m[1]+'-'+m[2]+'-'+m[3];
  var p2=function(n){ return String(n).padStart(2,'0'); };
  var MESES={jan:1,ene:1,feb:2,mar:3,apr:4,abr:4,may:5,jun:6,jul:7,aug:8,ago:8,sep:9,sept:9,oct:10,nov:11,dec:12,dic:12,
             january:1,enero:1,february:2,febrero:2,march:3,marzo:3,april:4,abril:4,mayo:5,june:6,junio:6,
             july:7,julio:7,august:8,agosto:8,september:9,septiembre:9,october:10,octubre:10,
             november:11,noviembre:11,december:12,diciembre:12};
  // "July 27, 2026" / "27 de julio de 2026" / "27-Jul-2026"
  var mm=s.toLowerCase().match(/([a-záéíóú]{3,12})\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})/);
  if(mm && MESES[mm[1]]) return mm[3]+'-'+p2(MESES[mm[1]])+'-'+p2(mm[2]);
  var md=s.toLowerCase().match(/(\d{1,2})[\s\-\/.]*(?:de\s+)?([a-záéíóú]{3,12})\.?[\s\-\/.]*(?:de\s+)?(\d{4})/);
  if(md && MESES[md[2]]) return md[3]+'-'+p2(MESES[md[2]])+'-'+p2(md[1]);
  // Numéricas: DD/MM/YYYY o MM/DD/YYYY. Si un bloque pasa de 12 ese es el día.
  var mn=s.match(/(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})/);
  if(mn){
    var a=Number(mn[1]), b=Number(mn[2]), y=Number(mn[3]);
    if(y<100) y+=2000;
    var dia, mes;
    if(a>12){ dia=a; mes=b; }        // sin ambigüedad: DD/MM
    else if(b>12){ dia=b; mes=a; }   // sin ambigüedad: MM/DD
    else { dia=a; mes=b; }           // ambiguo: se asume DD/MM
    if(mes>=1&&mes<=12&&dia>=1&&dia<=31) return y+'-'+p2(mes)+'-'+p2(dia);
  }
  return '';
}

// ═══════════════════════════════════════════════════════════════════════════
//  REVISIÓN CON IA DE LA COMPRA PARA FIRMA
//  El adjunto puede traer UNA o DOS órdenes en el mismo PDF:
//   · La NUESTRA: la que lleva el logo/membrete de KENNEDY CENTER CORP.
//     Su número empieza con DKC- o SKC-. Es la que se firma.
//   · La DEL PROVEEDOR: la otra (PO, Proforma Invoice, Sales Contract).
//  Cuando vienen las dos, la IA las compara línea por línea y reporta cualquier
//  diferencia entre ellas, además de los errores internos de cada una.
// ═══════════════════════════════════════════════════════════════════════════
function _firmaPromptRevision(){
  return 'Eres el auditor de compras de KENNEDY CENTER CORP. Analizas el archivo adjunto de una compra.\n\n'
  +'LOS DOCUMENTOS PUEDEN VENIR DE DOS FORMAS: (a) como dos archivos separados, rotulados DOCUMENTO A (nuestra orden de compra) y DOCUMENTO B (la PI del proveedor); o (b) como un unico PDF que contiene las dos ordenes en paginas distintas. En cualquiera de los dos casos revisa TODO el contenido, todas las paginas, antes de responder.\n'
  +'COMO IDENTIFICAR CADA DOCUMENTO:\n'
  +'- La orden NUESTRA es SIEMPRE la que lleva el LOGO o el membrete de KENNEDY CENTER CORP (tambien puede decir Kennedy Center, KCC o Kennedy). Su numero de orden normalmente empieza con DKC- o SKC-.\n'
  +'- La orden DEL PROVEEDOR es la otra: lleva el logo o membrete de la empresa proveedora y suele titularse Purchase Order, Proforma Invoice, Sales Contract, Order Confirmation o similar, con su propio numero.\n'
  +'- Regla estricta: si un documento NO tiene el logo ni el membrete de Kennedy Center, es del proveedor. No lo asumas por el contenido.\n'
  +'- Si solo hay un documento, devuelve un solo elemento en "documentos" con su tipo correcto.\n\n'
  +'TU TRABAJO:\n'
  +'1) EXTRAER los datos de cada documento.\n'
  +'2) REVISAR los errores internos de cada documento (aritmetica).\n'
  +'3) Si hay DOS documentos, COMPARARLOS campo por campo y linea por linea, y reportar TODA diferencia.\n\n'
  +'REGLA DE CANTIDADES, MUY IMPORTANTE:\n'
  +'- La cantidad SIEMPRE se toma en PIEZAS (unidades sueltas), NUNCA en cartones ni en cajas.\n'
  +'- La columna correcta es la de la cantidad pedida en piezas: suele rotularse ORDER QTY / Pcs, ORDER QTY, QTY, Qty, Quantity, CANTIDAD, PCS o Order Quantity. En el total del documento suele aparecer como "TOTAL ... PCS".\n'
  +'- NO uses nunca estas columnas como cantidad porque son cartones o empaque: QTY X CTN, QTY/CTN, PCS/CTN, pcs/ctn, No.Ctn, TTL CTNS, CTNS, CARTONS, cartones, inner, INNER, No. de cajas. Esas indican cuantas piezas entran por carton o cuantos cartones hay, no lo que se compra.\n'
  +'- Ejemplo: si una linea dice ORDER QTY/Pcs = 300, QTY X CTN = 6 y TTL CTNS = 50, la cantidad de esa linea es 300 (piezas), no 6 ni 50.\n'
  +'- Verificacion: cantidad_en_piezas x precio_unitario debe dar el total de la linea. Si al usar un numero el total no cuadra, es que tomaste la columna equivocada.\n'
  +'- "unidades" del documento es el TOTAL DE PIEZAS. "cartones" es el total de cartones, y va aparte.\n\n'
  +'QUE COMPARAR entre la orden nuestra y la del proveedor: nombre del proveedor; numero de orden que cada una referencia; fecha; moneda; incoterm; terminos y condiciones de pago; puerto o destino; plazo de entrega; cantidad de lineas; y por cada linea el codigo del item, la descripcion, la cantidad EN PIEZAS, el precio unitario y el total de linea; subtotal, descuentos, impuestos, flete, total general, total de piezas y total de cartones.\n'
  +'Empareja las lineas por codigo de item y, si no hay codigo, por descripcion. Reporta tambien las lineas que aparecen en un documento y NO en el otro.\n\n'
  +'ERRORES INTERNOS a revisar en cada documento: cantidad x precio unitario que no cuadra con el total de la linea; suma de lineas que no cuadra con el subtotal o el total general; subtotal + impuestos + flete - descuentos que no da el total; cantidades o precios en cero o negativos; totales repetidos que no coinciden entre si.\n\n'
  +'Devuelve SOLO un JSON valido, sin texto antes ni despues, con esta forma exacta:\n'
  +'{\n'
  +' "documentos":[{"tipo":"kennedy","titulo":"","identificado_por":"","orden":"","orden_referenciada":"","proveedor":"","fecha":"YYYY-MM-DD","moneda":"","monto":0,"unidades":0,"cartones":0,"n_lineas":0,"pagina_inicial":0,"pagina_final":0}],\n'
  +' "descripcion":"",\n'
  +' "errores":[{"doc":"kennedy","detalle":""}],\n'
  +' "diferencias":[{"campo":"","kennedy":"","proveedor":"","gravedad":"alta","detalle":""}],\n'
  +' "coinciden":true,\n'
  +' "lineas_kennedy":[{"codigo":"","descripcion":"","cantidad":0,"precio":0}]\n'
  +'}\n\n'
  +'REGLAS DEL JSON:\n'
  +'- \"lineas_kennedy\": TODAS las lineas de NUESTRA orden (la de Kennedy Center; si solo viene la del proveedor, las de esa), una por item, con el codigo interno de Kennedy, la cantidad EN PIEZAS y el precio unitario. Sirve para compararla con la reposicion: no te saltes ninguna. Si son muchas, pon solo codigo y cantidad.\n'
  +'- "tipo" solo puede ser "kennedy" o "proveedor".\n'
  +'- "identificado_por": explica en pocas palabras como supiste de quien es el documento (por ejemplo: logo de Kennedy Center Corp en el encabezado).\n'  +'- Cuando cites codigos de item usa SIEMPRE el codigo interno de KENNEDY CENTER (columnas "KCC ITEM No", "KCC ITEM", "Codigo KCC", o "Code" en la PI del proveedor; suele ser numerico de 6-7 digitos o empezar con BA-), NUNCA el del proveedor ("Factory Code", "Item No.", "Supplier Code", que mezclan letras y numeros como B0040MP5L o BBQ4004).\n'
  +'- "orden": el numero de orden propio de ese documento, exactamente como aparece. En el documento nuestro prioriza el que empiece con DKC o SKC.\n'
  +'- "orden_referenciada": el numero de la OTRA orden que ese documento menciona, si aparece.\n'
  +'- "pagina_inicial" y "pagina_final": numero de pagina del ARCHIVO COMPLETO (empezando en 1) donde arranca y donde termina ese documento. La pagina_final es aquella donde aparece el TOTAL GENERAL de ese documento. Cuenta las paginas del PDF entero, no la numeracion impresa dentro de cada documento. Si solo hay un documento, pagina_final es la ultima pagina del archivo.\n'
  +'- "fecha": el campo Date/Fecha del documento, SIEMPRE en formato YYYY-MM-DD. Interpreta bien el formato original antes de convertir. Si no aparece, "".\n'
  +'- "descripcion": resumen breve de los productos de la compra.\n'
  +'- "unidades": total de PIEZAS del documento (no cartones). "cartones": total de cartones/cajas.\n'
  +'- "doc" en errores: "kennedy", "proveedor" o "ambos".\n'
  +'- "gravedad" en diferencias: "alta" si afecta dinero, cantidades o el item comprado; "media" si afecta fechas, terminos o condiciones; "baja" si es solo de forma o redaccion.\n'
  +'- "detalle": explicalo claro y CON LOS NUMEROS involucrados.\n'
  +'- "coinciden": true solo si NO hay ninguna diferencia de gravedad alta o media.\n'
  +'- Si no hay errores devuelve "errores":[]. Si no hay diferencias o solo hay un documento, devuelve "diferencias":[].\n'
  +'- Si un dato no aparece usa "" o 0. Nunca inventes datos.\n'
  +'- Se breve: cada "detalle" en una sola frase. En documentos largos reporta como maximo 40 diferencias, priorizando las de gravedad alta, y en ese caso agrega una ultima diferencia con campo "Nota" indicando cuantas quedaron fuera.';
}

// Tarjeta resumen de cada documento detectado
function _firmaCardDoc(d){
  var esK=(d.tipo==='kennedy');
  var col=esK?'#0c447c':'#B45309', bg=esK?'#e6f1fb':'#FEF9F3', bd=esK?'#85B7EB':'#E9C08A';
  return '<div style="flex:1;min-width:210px;background:'+bg+';border:0.5px solid '+bd+';border-radius:8px;padding:9px 11px">'
    +'<div style="font-size:11px;font-weight:800;color:'+col+';margin-bottom:4px">'
      +'<i class="ti '+(esK?'ti-building-store':'ti-truck-delivery')+'"></i> '
      +(esK?'NUESTRA — Kennedy Center':'PROVEEDOR')+'</div>'
    +(d.titulo?'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:3px">'+_esc(String(d.titulo))+'</div>':'')
    +'<div style="font-size:11.5px;line-height:1.5">'
      +(d.orden?('<div>Orden: <b>'+_esc(String(d.orden))+'</b></div>'):'')
      +(d.proveedor?('<div>Proveedor: <b>'+_esc(String(d.proveedor))+'</b></div>'):'')
      +(d.fecha?('<div>Fecha: <b>'+_esc(String(d.fecha))+'</b></div>'):'')
      +(Number(d.monto)?('<div>Total: <b>'+(d.moneda?_esc(String(d.moneda))+' ':'')+Number(d.monto).toLocaleString('en-US',{minimumFractionDigits:2})+'</b></div>'):'')
      +(Number(d.unidades)?('<div>Piezas: <b>'+Number(d.unidades).toLocaleString('en-US')+'</b></div>'):'')
      +(Number(d.cartones)?('<div>Cartones: <b>'+Number(d.cartones).toLocaleString('en-US')+'</b></div>'):'')
      +(Number(d.n_lineas)?('<div>Líneas: <b>'+Number(d.n_lineas)+'</b></div>'):'')
    +'</div>'
    +(d.identificado_por?('<div style="font-size:9.5px;color:var(--text-muted);margin-top:4px;font-style:italic">'+_esc(String(d.identificado_por))+'</div>'):'')
  +'</div>';
}

/* ═══ LA COMPRA PARA FIRMA CONTRA SU REPOSICIÓN (v719) ═══════════════════
   La orden que se sube para firma tiene que ser lo que se pidió en la
   reposición. La IA saca las líneas de NUESTRA orden y aquí se comparan, en
   código y sin IA, con los artículos de la reposición:
     · artículos de la orden que NO estaban en la reposición;
     · artículos de la reposición que FALTAN en la orden;
     · cantidades distintas, y precios distintos del FOB de la reposición.
   La reposición se busca sola: la viva (enviada a compras, finalizada o
   enviada a proveedor) que más artículos comparte con la orden. Si no es la
   buena, se elige otra en el desplegable. */
async function _firmaRepsVivas(todas){
  var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=id,num_reposicion,cardcode,cardname,estado,items,actualizado_en'
    +'&order=actualizado_en.desc&limit=300',{headers:SBH});
  if(!r.ok) throw new Error('no pude leer las reposiciones ('+r.status+')');
  return ((await r.json())||[]).filter(function(p){
    if(!String(p.num_reposicion||'').trim()) return false;
    return todas || REP_ESTADOS_VIVOS.indexOf(String(p.estado||'').toLowerCase())>=0; })
    .map(function(p){
      var it=p.items; if(typeof it==='string'){ try{ it=JSON.parse(it); }catch(e){ it=[]; } }
      p.items=(it||[]).map(function(l){
        return {codigo:String((l&&(l.itemcode||l.item||l.codigo||l.sku||l.ic))||'').trim(),
                nombre:(l&&l.itemname)||'', cant:Number(l&&(l.cant!=null?l.cant:l.cantidad))||0,
                fob:Number(l&&l.fob)||0}; }).filter(function(l){ return l.codigo; });
      return p;
    });
}

function _firmaLineasOrden(data){
  return (Array.isArray(data.lineas_kennedy)?data.lineas_kennedy:[]).map(function(l){
    return {codigo:String(l.codigo||l.item||'').trim(), desc:String(l.descripcion||''),
            cant:Number(l.cantidad)||0, precio:Number(l.precio)||0}; })
    .filter(function(l){ return l.codigo; });
}

function _firmaCompararCon(lineas, rp){
  var porO={}, porR={};
  lineas.forEach(function(l){ var k=_ocNormSku(l.codigo);
    if(porO[k]){ porO[k].cant+=l.cant; } else porO[k]=Object.assign({},l); });
  rp.items.forEach(function(l){ var k=_ocNormSku(l.codigo);
    if(porR[k]){ porR[k].cant+=l.cant; } else porR[k]=Object.assign({},l); });
  var difs=[], iguales=0, filas=[];
  Object.keys(porO).forEach(function(k){
    var o=porO[k], r=porR[k];
    if(!r){ difs.push({gravedad:'alta', tipo:'No está en la reposición', codigo:o.codigo,
      detalle:o.codigo+(o.desc?(' · '+o.desc):'')+': la orden pide '+o.cant+' pzs y la reposición no lo tiene.'});
      filas.push({codigo:o.codigo, desc:o.desc, cantO:o.cant, cantR:null, precio:o.precio, fob:null, estado:'no_en_rep'});
      return; }
    var ok=true;
    var fila={codigo:o.codigo, desc:o.desc||r.nombre, cantO:o.cant, cantR:r.cant, precio:o.precio, fob:r.fob,
              difCant:Math.abs(o.cant-r.cant)>0.001,
              difPrecio:(o.precio>0 && r.fob>0 && Math.abs(o.precio-r.fob)>0.005)};
    fila.estado=(fila.difCant||fila.difPrecio)?'distinta':'igual';
    filas.push(fila);
    if(Math.abs(o.cant-r.cant)>0.001){ ok=false;
      difs.push({gravedad:'alta', tipo:'Cantidad distinta', codigo:o.codigo, orden:o.cant, reposicion:r.cant,
        detalle:o.codigo+': la orden pide '+o.cant+' pzs y la reposición '+r.cant+' ('+(o.cant>r.cant?'+':'')+(o.cant-r.cant)+').'}); }
    if(o.precio>0 && r.fob>0 && Math.abs(o.precio-r.fob)>0.005){ ok=false;
      difs.push({gravedad:'media', tipo:'Precio distinto del FOB', codigo:o.codigo, orden:o.precio, reposicion:r.fob,
        detalle:o.codigo+': precio en la orden '+o.precio.toFixed(2)+' y FOB en la reposición '+r.fob.toFixed(2)+'.'}); }
    if(ok) iguales++;
  });
  Object.keys(porR).forEach(function(k){
    if(porO[k]) return;
    var r=porR[k];
    difs.push({gravedad:'alta', tipo:'Falta en la orden', codigo:r.codigo,
      detalle:r.codigo+(r.nombre?(' · '+r.nombre):'')+': la reposición pide '+r.cant+' pzs y no está en la orden.'});
    filas.push({codigo:r.codigo, desc:r.nombre, cantO:null, cantR:r.cant, precio:null, fob:r.fob, estado:'falta'});
  });
  var orden={'alta':0,'media':1,'baja':2};
  difs.sort(function(a,b){ return orden[a.gravedad]-orden[b.gravedad]; });
  return {id:rp.id, codigo:rp.num_reposicion, proveedor:rp.cardname||rp.cardcode||'', estado:rp.estado,
          n_orden:Object.keys(porO).length, n_rep:Object.keys(porR).length, iguales:iguales,
          pzs_orden:lineas.reduce(function(a,l){ return a+l.cant; },0),
          pzs_rep:rp.items.reduce(function(a,l){ return a+l.cant; },0), difs:difs, filas:filas};
}

async function _firmaCompararReposicion(data, idElegida, todas){
  var lineas=_firmaLineasOrden(data);
  if(!lineas.length) return {error:'la AI no devolvió las líneas de la orden; vuelve a pulsar «AI rellenar y revisar»'};
  var reps=await _firmaRepsVivas(todas);
  window._firmaRepsCache=reps;
  var claves={}; lineas.forEach(function(l){ claves[_ocNormSku(l.codigo)]=1; });
  var cand=reps.map(function(p){
    var n=p.items.filter(function(l){ return claves[_ocNormSku(l.codigo)]; }).length;
    return {p:p, comunes:n}; }).filter(function(x){ return x.comunes>0; })
    .sort(function(a,b){ return b.comunes-a.comunes; });
  var opciones=cand.slice(0,12).map(function(x){ return {id:x.p.id, codigo:x.p.num_reposicion,
    proveedor:x.p.cardname||x.p.cardcode||'', comunes:x.comunes, n:x.p.items.length}; });
  // La elegida a mano entra siempre en el desplegable aunque no comparta nada
  if(idElegida && !opciones.some(function(o){ return String(o.id)===String(idElegida); })){
    var pe=reps.filter(function(p){ return String(p.id)===String(idElegida); })[0];
    if(pe) opciones.unshift({id:pe.id, codigo:pe.num_reposicion, proveedor:pe.cardname||pe.cardcode||'', comunes:0, n:pe.items.length});
  }
  var elegida = idElegida ? reps.filter(function(p){ return String(p.id)===String(idElegida); })[0]
                          : (cand[0] && cand[0].p);
  if(!elegida) return {sinReposicion:true, opciones:opciones, n_orden:lineas.length};
  var res=_firmaCompararCon(lineas, elegida);
  res.opciones=opciones;
  res.automatica=!idElegida;
  return res;
}

// Elegir otra reposición a mano (en compras, antes de enviar)
async function _firmaElegirReposicion(id, elId){
  var rv=window._firmaRevisionIA; if(!rv || !rv.data) return;
  try{
    rv.data.reposicion = id ? await _firmaCompararReposicion(rv.data, id)
                            : {sinReposicion:true, manual:true, opciones:(rv.data.reposicion||{}).opciones||[]};
    var res=_firmaRenderRevision(rv.data, elId);
    rv.reposicion=rv.data.reposicion.codigo||null;
    rv.n_rep_graves=(rv.data.reposicion.difs||[]).filter(function(d){ return d.gravedad==='alta'; }).length;
  }catch(e){ showT('No pude comparar: '+(e.message||e)); }
}

function _firmaRepHtml(R, elId){
  if(!R) return '';
  var cab='<div style="border:1px solid #6D28D9;border-radius:8px;overflow:hidden;margin-top:9px">'
    +'<div style="background:var(--pastel-lila);padding:8px 11px;font-size:11.5px;font-weight:800;color:var(--t-lila)">'
    +'<i class="ti ti-package"></i> Contra la reposición';
  if(R.error) return cab+'</div><div style="padding:8px 11px;font-size:11.5px;color:var(--t-marron)">No se pudo comparar: '
    +_esc(R.error)+'</div></div>';
  var editable=(elId==='firma-ai-errores' || elId==='firma-revrep-body');
  var manejador=(elId==='firma-revrep-body') ? '_firmaRevRepElegir(this.value)' : ('_firmaElegirReposicion(this.value,\''+elId+'\')');
  var selector=(editable && (R.opciones||[]).length)
    ? ('<select onchange="'+manejador+'" style="margin-left:6px;font-size:11px;padding:2px 6px;'
       +'border-radius:6px;border:0.5px solid var(--border);background:var(--surface-0);color:var(--text-primary)">'
       +'<option value="">— sin reposición —</option>'
       + R.opciones.map(function(o){ return '<option value="'+_esc(o.id)+'"'+(String(o.id)===String(R.id)?' selected':'')+'>'
           +_esc(o.codigo)+' · '+_esc(String(o.proveedor).slice(0,28))+' · '+o.comunes+' de '+o.n+' artículos en común</option>'; }).join('')
       +'</select>') : '';
  if(R.sinReposicion){
    return cab+selector+'</div><div style="padding:8px 11px;font-size:11.5px;color:var(--t-marron)">'
      +(R.manual?'Marcada como compra sin reposición.'
        :'No encontré ninguna reposición viva (enviada a compras, finalizada o enviada a proveedor) con artículos de esta orden. '
         +'Si sale de una reposición, revisa que tenga número y estado.')+'</div></div>';
  }
  var nA=R.difs.filter(function(d){ return d.gravedad==='alta'; }).length;
  var h=cab+' <span style="background:#6D28D9;color:#fff;border-radius:6px;padding:1px 8px">'+_esc(R.codigo)+'</span> '
    +'<span style="font-weight:600">'+_esc(R.proveedor)+'</span>'+selector
    +(R.automatica?' <span style="font-weight:400;font-size:10.5px;opacity:.8">(elegida sola: la que más artículos comparte)</span>':'')
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;padding:8px 11px;font-size:11px;border-bottom:0.5px solid var(--border)">'
    +'<span style="background:var(--surface-1);border-radius:6px;padding:2px 8px">Orden: <b>'+R.n_orden+'</b> artículos · <b>'
      +Number(R.pzs_orden).toLocaleString('en-US')+'</b> pzs</span>'
    +'<span style="background:var(--surface-1);border-radius:6px;padding:2px 8px">Reposición: <b>'+R.n_rep+'</b> artículos · <b>'
      +Number(R.pzs_rep).toLocaleString('en-US')+'</b> pzs</span>'
    +'<span style="background:var(--pastel-ok);color:#166534;border-radius:6px;padding:2px 8px"><b>'+R.iguales+'</b> iguales</span>'
    +'</div>';
  if(!R.difs.length){
    return h+'<div style="padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600;background:var(--pastel-ok)">'
      +'<i class="ti ti-circle-check"></i> La orden es exactamente lo que se pidió en la reposición: mismos artículos y cantidades.</div></div>';
  }
  h+='<div style="padding:7px 11px;font-size:11.5px;font-weight:700;color:'+(nA?'var(--t-rojo)':'var(--t-marron)')+'">'
    +R.difs.length+' diferencia(s) con la reposición'+(nA?(' · '+nA+' grave(s)'):'')+'</div>';
  R.difs.forEach(function(d){
    var c=d.gravedad==='alta'?'#dc2626':'#B45309', bg=d.gravedad==='alta'?'#FEF2F2':'#FEF9F3';
    h+='<div style="padding:6px 11px;border-top:0.5px solid var(--border);background:'+bg+';font-size:11px">'
      +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'
      +_esc(d.tipo)+'</span> '+_esc(d.detalle)+'</div>';
  });
  h+=_firmaRepTablaHtml(R);
  return h+'</div>';
}

// Línea por línea: cada artículo de la orden y de la reposición, con lo distinto marcado
function _firmaRepTablaHtml(R){
  var F=(R.filas||[]).slice();
  if(!F.length) return '';
  var peso={no_en_rep:0, falta:1, distinta:2, igual:3};
  F.sort(function(a,b){ return peso[a.estado]-peso[b.estado] || String(a.codigo).localeCompare(String(b.codigo)); });
  var n=function(v,dec){ return v==null?'—':Number(v).toLocaleString('en-US',{minimumFractionDigits:dec||0, maximumFractionDigits:dec||0}); };
  var rojo='background:#FEE2E2;color:#991B1B;font-weight:800';
  var et={no_en_rep:['No está en la reposición','#dc2626'], falta:['Falta en la orden','#dc2626'],
          distinta:['Distinta','#B45309'], igual:['Igual','#16a34a']};
  var th='padding:6px 8px;font-size:10px;font-weight:700;color:#fff;background:#0F766E;position:sticky;top:0;text-align:right';
  var h='<div style="padding:7px 11px 3px;font-size:11.5px;font-weight:700;border-top:0.5px solid var(--border)">'
    +'Línea por línea ('+F.length+' artículos)</div>'
    +'<div style="max-height:360px;overflow:auto;margin:0 11px 10px;border:0.5px solid var(--border);border-radius:8px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px"><thead><tr>'
    +'<th style="'+th+';text-align:left">Código</th><th style="'+th+';text-align:left">Descripción</th>'
    +'<th style="'+th+'">Pzs orden</th><th style="'+th+'">Pzs reposición</th>'
    +'<th style="'+th+'">Precio orden</th><th style="'+th+'">FOB reposición</th>'
    +'<th style="'+th+';text-align:left">Estado</th></tr></thead><tbody>';
  F.forEach(function(f){
    var td='padding:5px 8px;border-top:0.5px solid var(--border);text-align:right';
    var fondo=f.estado==='igual'?'':(f.estado==='distinta'?'background:#FEF9F3':'background:#FEF2F2');
    var cantMal=f.difCant || f.estado==='no_en_rep' || f.estado==='falta';
    h+='<tr style="'+fondo+'">'
      +'<td style="'+td+';text-align:left;font-weight:700">'+_esc(f.codigo)+'</td>'
      +'<td style="'+td+';text-align:left;color:var(--text-secondary)">'+_esc(String(f.desc||'').slice(0,40))+'</td>'
      +'<td style="'+td+';'+(cantMal?rojo:'')+'">'+n(f.cantO)+'</td>'
      +'<td style="'+td+';'+(cantMal?rojo:'')+'">'+n(f.cantR)+'</td>'
      +'<td style="'+td+';'+(f.difPrecio?'background:#FEF3C7;color:#92400E;font-weight:800':'')+'">'+n(f.precio,2)+'</td>'
      +'<td style="'+td+';'+(f.difPrecio?'background:#FEF3C7;color:#92400E;font-weight:800':'')+'">'+n(f.fob,2)+'</td>'
      +'<td style="'+td+';text-align:left"><span style="font-size:9.5px;font-weight:800;color:#fff;background:'
      +et[f.estado][1]+';border-radius:6px;padding:1px 6px">'+et[f.estado][0]+'</span></td></tr>';
  });
  return h+'</tbody></table></div>';
}

/* ═══ REVISAR UNA ORDEN YA ENVIADA A FIRMA CONTRA SU REPOSICIÓN (v721) ═══
   Para las órdenes que ya están en la lista (pendientes, firmadas o
   enviadas). Si su revisión guardada trae las líneas, se usan; si no, la AI
   lee el PDF guardado de nuestra orden. La reposición se propone sola y se
   puede elegir cualquiera con número (por ejemplo la R-13), esté en el
   estado que esté. El resultado se guarda en la orden: gerencia lo ve en la
   insignia y al firmar. */
async function _firmaRevisarRep(id){
  var prev=document.getElementById('firmaRevRepOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='firmaRevRepOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1004;display:flex;align-items:flex-start;justify-content:center;padding:16px;overflow:auto';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:900px;width:100%">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;padding:14px 16px;border-bottom:0.5px solid var(--border)">'
    +'<div style="font-size:14px;font-weight:700"><i class="ti ti-package" style="color:#0F766E"></i> Orden para firma contra la reposición'
    +'<div id="firma-revrep-tit" style="font-size:11px;font-weight:400;color:var(--text-muted)"></div></div>'
    +'<button onclick="document.getElementById(\'firmaRevRepOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="padding:14px 16px"><div id="firma-revrep-st" style="font-size:12px;margin-bottom:8px"></div>'
    +'<div id="firma-revrep-body"></div></div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  var st=document.getElementById('firma-revrep-st');
  var estado=function(t){ if(st) st.innerHTML=t; };
  try{
    estado('<span class="ai-ring g"></span> Cargando la orden…');
    var r=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*',{headers:SBH});
    var o=r.ok?(((await r.json())||[])[0]):null;
    if(!o) throw new Error('no encontré la orden');
    var tit=document.getElementById('firma-revrep-tit');
    if(tit) tit.textContent=(o.num_orden||'')+' · '+(o.proveedor||'')+' · '+(o.descripcion||'');
    var rv=_firmaRevDe(o) || {fecha:new Date().toISOString(), archivo:o.archivo_nombre||'', n_docs:0, n_errores:0,
                              n_diferencias:0, n_graves:0, data:{soloReposicion:true, documentos:[], errores:[], diferencias:[]}};
    if(!_firmaLineasOrden(rv.data).length){
      // La AI lee las líneas del PDF guardado de nuestra orden
      var path=o.archivo_path||o.archivo_path2, nombre=(o.archivo_path?o.archivo_nombre:o.archivo_nombre2)||'orden.pdf';
      estado('<span class="ai-ring g"></span> La AI está leyendo las líneas de '+_esc(nombre)+'…');
      var rf=await fetch(DOCS_BASE+String(path).split('/').map(encodeURIComponent).join('/'));
      if(!rf.ok) throw new Error('no pude abrir el archivo guardado ('+rf.status+')');
      var blob=await rf.blob();
      var file=new File([blob], nombre, {type:blob.type||'application/pdf'});
      var d=await _iaJSON([{type:'text', text:'ORDEN DE COMPRA ENVIADA A FIRMA:'}, await _nsapContenido(file),
                           {type:'text', text:_firmaPromptLineas}], 8000, function(n){
        estado('<span class="ai-ring g"></span> Orden larga: sigue leyendo líneas ('+n+')…'); });
      rv.data.lineas_kennedy=(d&&d.lineas_kennedy)||[];
      if(!rv.data.lineas_kennedy.length) throw new Error('la AI no encontró líneas en el archivo');
    }
    window._firmaRevRep={id:id, o:o, rv:rv};
    estado('<span class="ai-ring g"></span> Buscando la reposición y comparando…');
    var idPrev=(rv.data.reposicion && rv.data.reposicion.automatica===false) ? rv.data.reposicion.id : null;
    rv.data.reposicion=await _firmaCompararReposicion(rv.data, idPrev, true);
    await _firmaRevRepPintarYGuardar();
  }catch(e){
    estado('<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> No se pudo revisar: '+_esc(e.message||String(e))+'</span>');
  }
}

async function _firmaRevRepElegir(repId){
  var X=window._firmaRevRep; if(!X) return;
  var st=document.getElementById('firma-revrep-st');
  if(st) st.innerHTML='<span class="ai-ring g"></span> Comparando…';
  try{
    X.rv.data.reposicion = repId ? await _firmaCompararReposicion(X.rv.data, repId, true)
      : {sinReposicion:true, manual:true, opciones:(X.rv.data.reposicion||{}).opciones||[]};
    if(repId) X.rv.data.reposicion.automatica=false;
    await _firmaRevRepPintarYGuardar();
  }catch(e){ if(st) st.innerHTML='<span style="color:var(--text-danger)">'+_esc(e.message||String(e))+'</span>'; }
}

async function _firmaRevRepPintarYGuardar(){
  var X=window._firmaRevRep; if(!X) return;
  var R=X.rv.data.reposicion||{};
  var body=document.getElementById('firma-revrep-body');
  if(body) body.innerHTML=_firmaRepHtml(R,'firma-revrep-body');
  X.rv.reposicion=R.codigo||null;
  X.rv.n_rep_graves=(R.difs||[]).filter(function(d){ return d.gravedad==='alta'; }).length;
  var st=document.getElementById('firma-revrep-st');
  var txt = R.error ? ('<span style="color:var(--text-danger)">'+_esc(R.error)+'</span>')
    : R.sinReposicion ? '<span style="color:var(--t-marron)"><i class="ti ti-info-circle"></i> Elige la reposición en el desplegable.</span>'
    : (R.difs||[]).length ? ('<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> <b>'+R.difs.length
        +' diferencia(s)</b> entre la orden '+_esc(X.o.num_orden||'')+' y la reposición <b>'+_esc(R.codigo)+'</b>.</span>')
    : ('<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> La orden '+_esc(X.o.num_orden||'')
        +' es igual a la reposición <b>'+_esc(R.codigo)+'</b>.</span>');
  // Se guarda en la orden: la insignia y gerencia lo ven
  try{
    var w=await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+X.id,'PATCH',{revision_ia:X.rv},[]);
    txt+=(w&&w.ok)?' <span style="color:var(--text-muted);font-size:11px">· guardado en la orden</span>'
                  :' <span style="color:var(--t-marron);font-size:11px">· no se pudo guardar en la orden</span>';
    try{ _firmaCargarLista(CU&&CU.role==='gerencia'?'gerencia':'compras'); }catch(e){}
  }catch(e){}
  if(st) st.innerHTML=txt;
}

/* El botón «Comparar contra la reposición» de compras. Si ya se pasó la
   AI, usa sus líneas (no gasta otra lectura). Si no, la AI solo lee las
   líneas de nuestra orden y se compara. */
var _firmaPromptLineas='Del archivo adjunto toma SOLO la orden de compra de KENNEDY CENTER CORP (la que lleva su logo o '
  +'membrete; su numero empieza con DKC- o SKC-). Si no esta, usa la del proveedor. Devuelve TODAS sus lineas, sin saltarte '
  +'ninguna, con el codigo interno de Kennedy (columna KCC ITEM / Codigo KCC / Code; NUNCA el Factory Code ni el codigo del '
  +'proveedor), la cantidad EN PIEZAS (nunca cartones: no uses QTY/CTN, PCS/CTN, CTNS) y el precio unitario. '
  +'Responde SOLO un JSON: {"orden":"","proveedor":"","lineas_kennedy":[{"codigo":"","descripcion":"","cantidad":0,"precio":0}]}';

async function _firmaCompararRepBoton(){
  var fd=window._firmaDocs||{};
  if(!fd.kcc && !fd.prov && !_firmaArchivo){ showT('Primero sube la orden de compra'); return; }
  var st=document.getElementById('firma-ai-status');
  var rv=window._firmaRevisionIA;
  try{
    if(rv && rv.data && _firmaLineasOrden(rv.data).length){
      if(st) st.innerHTML='<span class="ai-wrap" style="color:#0F766E"><span class="ai-ring"></span> Comparando con la reposición…</span>';
      var idAntes=(rv.data.reposicion&&rv.data.reposicion.automatica===false)?rv.data.reposicion.id:null;
      rv.data.reposicion=await _firmaCompararReposicion(rv.data, idAntes);
    } else {
      if(st) st.innerHTML='<span class="ai-wrap" style="color:#0F766E"><span class="ai-ring"></span> Leyendo las líneas de la orden…</span>';
      var content=[];
      if(fd.kcc){ content.push({type:'text', text:'NUESTRA ORDEN DE COMPRA (KENNEDY CENTER CORP.):'}); content.push(await _nsapContenido(fd.kcc)); }
      else if(fd.prov){ content.push({type:'text', text:'PI DEL PROVEEDOR:'}); content.push(await _nsapContenido(fd.prov)); }
      else content.push(await _nsapContenido(_firmaArchivo));
      content.push({type:'text', text:_firmaPromptLineas});
      var d=await _iaJSON(content, 8000, function(n){
        if(st) st.innerHTML='<span class="ai-wrap" style="color:#0F766E"><span class="ai-ring"></span> Orden larga: sigue leyendo líneas ('+n+')…</span>'; });
      var data={soloReposicion:true, documentos:[], errores:[], diferencias:[],
                lineas_kennedy:(d&&d.lineas_kennedy)||[]};
      if(st) st.innerHTML='<span class="ai-wrap" style="color:#0F766E"><span class="ai-ring"></span> Comparando con la reposición…</span>';
      data.reposicion=await _firmaCompararReposicion(data);
      rv=window._firmaRevisionIA={fecha:new Date().toISOString(),
        archivo:(_firmaArchivo&&_firmaArchivo.name)||(fd.kcc||fd.prov||{}).name||'',
        n_docs:0, n_errores:0, n_diferencias:0, n_graves:0, data:data};
    }
    _firmaRenderRevision(rv.data);
    var R=rv.data.reposicion||{};
    rv.reposicion=R.codigo||null;
    rv.n_rep_graves=(R.difs||[]).filter(function(x){ return x.gravedad==='alta'; }).length;
    if(st){
      if(R.error) st.innerHTML='<span style="color:var(--text-danger)">'+_esc(R.error)+'</span>';
      else if(R.sinReposicion) st.innerHTML='<span style="color:var(--t-marron)"><i class="ti ti-info-circle"></i> No encontré la reposición de esta orden: elígela en el desplegable.</span>';
      else if((R.difs||[]).length) st.innerHTML='<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> <b>'
        +R.difs.length+' diferencia(s)</b> con la reposición '+_esc(R.codigo)+'. Están marcadas en rojo abajo.</span>';
      else st.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> La orden es igual a la reposición '+_esc(R.codigo)+'.</span>';
    }
  }catch(e){
    if(st) st.innerHTML='<span style="color:var(--text-danger)">No se pudo comparar: '+_esc(e.message||String(e))+'</span>';
  }
}

// Pinta el resultado completo: documentos, diferencias y errores
function _firmaRenderRevision(data, elId){
  var eb=document.getElementById(elId||'firma-ai-errores'); if(!eb) return {nErr:0,nDif:0,nAlta:0};
  var docs=Array.isArray(data.documentos)?data.documentos:[];
  var kenn=docs.filter(function(d){return d.tipo==='kennedy';});
  var prov=docs.filter(function(d){return d.tipo==='proveedor';});

  // Normalizar errores y diferencias (aceptan texto suelto u objeto)
  var errs=(Array.isArray(data.errores)?data.errores:[]).map(function(x){
    if(typeof x==='string') return {doc:'', detalle:x};
    return {doc:x.doc||'', detalle:x.detalle||x.error||''};
  }).filter(function(x){ return String(x.detalle||'').trim(); });

  var difs=(Array.isArray(data.diferencias)?data.diferencias:[]).map(function(x){
    if(typeof x==='string') return {campo:'', kennedy:'', proveedor:'', gravedad:'media', detalle:x};
    return {campo:x.campo||'', kennedy:x.kennedy!=null?x.kennedy:'', proveedor:x.proveedor!=null?x.proveedor:'',
            gravedad:String(x.gravedad||'media').toLowerCase(), detalle:x.detalle||''};
  }).filter(function(x){ return String(x.detalle||x.campo||'').trim(); });

  var nAlta=difs.filter(function(d){return d.gravedad==='alta';}).length;
  var h='';

  // ── Documentos detectados ──
  if(docs.length){
    h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:9px">'+docs.map(_firmaCardDoc).join('')+'</div>';
  }

  // ── Aviso si falta uno de los dos ── (no aplica si solo se comparó con la reposición)
  if(data.soloReposicion){ /* nada */ }
  else if(docs.length===1){
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:9px">'
      +'<i class="ti ti-info-circle"></i> Solo se detectó <b>'+(kenn.length?'la orden de Kennedy Center':'la orden del proveedor')+'</b> en este archivo. '
      +'Si el PDF debía traer las dos, revísalo: sin las dos no se puede comparar.</div>';
  } else if(!docs.length){
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:9px">'
      +'<i class="ti ti-info-circle"></i> La AI no logró identificar las órdenes en el archivo. Verifica que el PDF esté legible.</div>';
  }

  // ── Diferencias entre ambas ──
  if(docs.length>1){
    if(difs.length){
      h+='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden;margin-bottom:9px">'
        +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:800;color:var(--t-rojo)">'
          +'<i class="ti ti-git-compare"></i> '+difs.length+' diferencia(s) entre nuestra orden y la del proveedor'
          +(nAlta?(' &middot; <span style="color:var(--t-rojo2)">'+nAlta+' grave(s)</span>'):'')
        +'</div>';
      difs.forEach(function(d){
        var c=d.gravedad==='alta'?'#dc2626':(d.gravedad==='baja'?'#6b7280':'#B45309');
        var bgg=d.gravedad==='alta'?'#FEF2F2':(d.gravedad==='baja'?'var(--surface-1)':'#FEF9F3');
        h+='<div style="padding:8px 11px;border-top:0.5px solid var(--border);background:'+bgg+'">'
          +'<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
            +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'+_esc(d.gravedad)+'</span>'
            +(d.campo?('<b style="font-size:11.5px">'+_esc(String(d.campo))+'</b>'):'')
          +'</div>';
        if(String(d.kennedy)!==''||String(d.proveedor)!==''){
          h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:4px;font-size:11px">'
            +'<span style="flex:1;min-width:150px;background:var(--pastel-azul);border-radius:6px;padding:3px 7px"><b style="color:var(--t-azul)">Nuestra:</b> '+_esc(String(d.kennedy||'—'))+'</span>'
            +'<span style="flex:1;min-width:150px;background:var(--pastel-aviso);border-radius:6px;padding:3px 7px"><b style="color:var(--t-ambar)">Proveedor:</b> '+_esc(String(d.proveedor||'—'))+'</span>'
          +'</div>';
        }
        if(d.detalle) h+='<div style="font-size:11px;color:var(--text-secondary);margin-top:3px">'+_esc(String(d.detalle))+'</div>';
        h+='</div>';
      });
      h+='</div>';
    } else {
      h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600;margin-bottom:9px">'
        +'<i class="ti ti-git-compare"></i> Las dos órdenes coinciden: mismos items, cantidades, precios y totales.</div>';
    }
  }

  // ── Errores internos ──
  if(errs.length){
    var etq={kennedy:'Nuestra orden', proveedor:'Orden del proveedor', ambos:'Ambas'};
    h+='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
      +'<div style="font-weight:800;margin-bottom:4px"><i class="ti ti-alert-triangle"></i> '+errs.length+' error(es) dentro de los documentos. Corrígelos antes de enviar a firma:</div>'
      +'<ul style="margin:4px 0 0 16px;padding:0">'
      +errs.map(function(x){
        var et=etq[x.doc]||'';
        return '<li style="margin-bottom:2px">'+(et?('<b>'+et+':</b> '):'')+_esc(String(x.detalle))+'</li>';
      }).join('')
      +'</ul></div>';
  } else if(docs.length && !data.soloReposicion){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Sin errores de montos, cantidades ni totales dentro de los documentos.</div>';
  }

  h+=_firmaRepHtml(data.reposicion, elId||'firma-ai-errores');

  eb.innerHTML=h;
  return {nErr:errs.length, nDif:difs.length, nAlta:nAlta, nDocs:docs.length, kenn:kenn[0]||null, prov:prov[0]||null};
}

async function _firmaAI(){
  var fd=window._firmaDocs||{};
  if(!fd.kcc && !fd.prov && !_firmaArchivo){ showT('Primero sube los documentos'); return; }
  var st=document.getElementById('firma-ai-status');
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo los documentos y comparándolos con AI…</span>';
  var eb0=document.getElementById('firma-ai-errores'); if(eb0) eb0.innerHTML='';
  try{
    // Los dos documentos van etiquetados para que la AI sepa cuál es cuál
    var content=[];
    if(fd.kcc){
      content.push({type:'text', text:'DOCUMENTO A — NUESTRA ORDEN DE COMPRA (KENNEDY CENTER CORP.):'});
      content.push(await _nsapContenido(fd.kcc));
    }
    if(fd.prov){
      content.push({type:'text', text:'DOCUMENTO B — PI DEL PROVEEDOR (Proforma Invoice):'});
      content.push(await _nsapContenido(fd.prov));
    }
    if(!fd.kcc && !fd.prov && _firmaArchivo){
      content.push(await _nsapContenido(_firmaArchivo));
    }
    content.push({type:'text', text:_firmaPromptRevision()});
    var data=await _iaJSON(content, 8000, function(n){
      if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Documento largo: la AI sigue leyendo las líneas ('+n+')…</span>';
    });
    if(window._iaJSONReparado && st){
      console.warn('JSON de la revisión reparado (respuesta muy larga)');
    }

    // Contra la REPOSICIÓN de la que sale la compra (v719)
    if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Comparando con la reposición…</span>';
    try{ data.reposicion=await _firmaCompararReposicion(data); }
    catch(e){ data.reposicion={error:String(e.message||e)}; }
    var res=_firmaRenderRevision(data);
    var dK=res.kenn||{}, dP=res.prov||{};

    // ── Rellenar el formulario. Manda SIEMPRE nuestra orden (la que se firma);
    //    solo se usa la del proveedor para lo que a la nuestra le falte. ──
    var refIA=_firmaNormRef(dK.orden||'');
    if(!refIA) refIA=_firmaNormRef(dK.orden_referenciada||dP.orden_referenciada||'');
    if(!refIA) refIA=_firmaNormRef(dP.orden||'');
    if(!refIA) refIA=_firmaNormRef((_firmaArchivo&&_firmaArchivo.name)||'');
    if(refIA) _sv('firma-orden', refIA);

    var provNom=dK.proveedor||dP.proveedor||'';
    if(provNom) _sv('firma-prov', provNom);
    if(data.descripcion) _sv('firma-desc', data.descripcion);

    var monto=Number(dK.monto)||Number(dP.monto)||0;
    if(monto) _sv('firma-monto', monto);
    var uni=Number(dK.unidades)||Number(dP.unidades)||0;
    if(uni) _sv('firma-uni', uni);

    // Fecha estimada = campo Date del documento (prioriza el nuestro)
    var fIA=_firmaNormFecha(dK.fecha||'')||_firmaNormFecha(dP.fecha||'');
    if(fIA) _sv('firma-fecha', fIA);

    var faltan=[];
    if(!refIA) faltan.push('el N° de orden (DKC/SKC)');
    if(!fIA)   faltan.push('la fecha');
    var avisoFalta=faltan.length?(' <span style="color:var(--t-ambar)">No se encontró '+faltan.join(' ni ')+': complétalo a mano.</span>'):'';

    var R=data.reposicion||{}, nRep=(R.difs||[]).filter(function(d){ return d.gravedad==='alta'; }).length;
    if(st){
      if(nRep && !res.nAlta){
        st.innerHTML='<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> <b>Revisa antes de enviar:</b> la orden no cuadra con la reposición '
          +_esc(R.codigo||'')+' ('+nRep+' diferencia(s) grave(s)).</span>'+avisoFalta;
      } else if(res.nAlta){
        st.innerHTML='<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> <b>No envíes a firma todavía:</b> hay '+res.nAlta+' diferencia(s) grave(s) entre las dos órdenes.</span>'+avisoFalta;
      } else if(res.nErr || res.nDif){
        st.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Datos rellenados. Revisa lo que la AI encontró abajo.</span>'+avisoFalta;
      } else if(res.nDocs>1){
        st.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Las dos órdenes coinciden y no hay errores.</span>'+avisoFalta;
      } else {
        st.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Datos rellenados y revisados.</span>'+avisoFalta;
      }
    }
    // Se guarda para adjuntar el resultado al enviar a firma
    window._firmaRevisionIA={ fecha:new Date().toISOString(),
                              archivo:(_firmaArchivo&&_firmaArchivo.name)||((window._firmaDocs||{}).kcc||{}).name||'',
                              n_docs:res.nDocs, n_errores:res.nErr, n_diferencias:res.nDif, n_graves:res.nAlta,
                              n_rep_graves:nRep, reposicion:R.codigo||null,
                              data:data };
  }catch(e){
    console.error('firma AI:',e);
    if(st) st.innerHTML='<span style="color:var(--text-danger)">No se pudo leer con AI: '+(e.message||e)+'</span>';
  }
}

async function _firmaEnviar(){
  var num=_fv('firma-orden'), prov=_fv('firma-prov'), dept=(_fv('firma-dept')||_deptPrimero()), desc=_fv('firma-desc');
  var monto=parseFloat(_fv('firma-monto'))||0, uni=parseInt(_fv('firma-uni'))||0;
  if(!num||!prov||!dept||!desc||!monto){ showT('Completa No. de orden, proveedor, departamento, descripcion y monto'); return; }
  showT('Enviando a firma...');
  try{
    // Se suben los dos: nuestra orden y la PI del proveedor
    var fd=window._firmaDocs||{};
    var docKcc=fd.kcc||_firmaArchivo||null;
    var docProv=fd.prov||null;
    var path=null, nombre=null, path2=null, nombre2=null;
    if(docKcc){ path=await _subirDocStorage('firma', dept, docKcc); nombre=docKcc.name; }
    if(docProv){ path2=await _subirDocStorage('firma', dept, docProv); nombre2=docProv.name; }
    var fEst=_fv('firma-fecha')||null;
    var revIA=window._firmaRevisionIA||null;
    var payload={ num_orden:num, proveedor:prov, dept:dept, descripcion:desc, monto:monto, unidades:uni, fecha_estimada:fEst, revision_ia:revIA, archivo_path2:path2, archivo_nombre2:nombre2, creado_por:(CU&&CU.id)||'', creado_por_nom:(CU&&CU.name)||'', creado_por_email:(CU&&CU.email)||'', estado:'pendiente', archivo_path:path, archivo_nombre:nombre, creado_en:new Date().toISOString() };
    var r=await _firmaWrite(SB+'/rest/v1/ordenes_firma','POST',payload,['fecha_estimada','revision_ia','archivo_path2','archivo_nombre2']);
    if(r.ok){ showT('Enviada a gerencia para firma'); ['firma-orden','firma-prov','firma-desc','firma-monto','firma-uni','firma-fecha'].forEach(function(id){_sv(id,'');}); _firmaArchivo=null; window._firmaDocs={prov:null,kcc:null}; window._firmaRevisionIA=null; var el=document.getElementById('firma-file-name'); if(el) el.textContent='Subir PDF o Excel de la compra'; var stx=document.getElementById('firma-ai-status'); if(stx) stx.innerHTML=''; var eb1=document.getElementById('firma-ai-errores'); if(eb1) eb1.innerHTML=''; _firmaCargarLista('compras'); }
    else { var t=await r.text(); console.error('ordenes_firma insert',r.status,t); showT('No se pudo enviar (revisa que exista la tabla ordenes_firma)'); }
  }catch(e){ console.error(e); showT('Error: '+(e.message||e)); }
}

async function _firmaCargarLista(rol){
  var box=document.getElementById('firma-lista'); if(!box) return;
  box.innerHTML='<div class="empty" style="padding:14px"><i class="ti ti-loader-2 spin"></i> Cargando...</div>';
  try{
    var filtro='';
    // Todo el equipo del departamento ve las mismas compras para firma
    if(rol==='compras'){ filtro=(CU&& _deptAcotado())?_deptFiltroURL():_filtroEquipo('creado_por'); }
    else if(CU&& _deptAcotado()){ filtro=_deptFiltroURL(); }
    var r=await fetch(SB+'/rest/v1/ordenes_firma?select=*'+filtro+'&order=creado_en.desc&limit=100',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    await _firmaCargarAmarres(rows);
    window._firmaRows=rows; window._firmaRol=rol;   // cache para el filtro de estado
    _firmaRenderLista(box, rows, rol);
  }catch(e){ box.innerHTML='<div class="empty" style="color:var(--text-danger);padding:14px">Error al cargar: '+(e.message||e)+'</div>'; }
}
// ══ AMARRE POR DKC: orden firmada  <->  orden de compra No-SAP ══
// Flujo: el proveedor manda la orden, gerencia la firma, y compras escribe
// aqui el N° DKC. Cuando existe una orden No-SAP con ese mismo DKC, las dos
// quedan amarradas y se ve que ya esta en proceso con el proveedor.
window._firmaAmarres = window._firmaAmarres || {};

function _firmaNormDKC(v){ return String(v||'').trim().toUpperCase(); }

// El DKC que aparezca escrito en cualquier parte de la orden (título,
// documentos, comentarios): es el que la compradora acabaría copiando.
function _firmaDKCsugerido(o){
  try{
    var t=JSON.stringify(o||{});
    var m=t.match(/DKC[\s\-_]?(\d{4,6})/i);
    return m ? ('DKC-'+m[1]) : '';
  }catch(e){ return ''; }
}

// ¿Hay ya en SAP una orden de compra con ese DKC? (las que trae el Sync)
function _firmaOrdenSAP(dkc){
  var k=_firmaNormDKC(dkc); if(!k) return null;
  var lista=(typeof orders!=='undefined' && orders)?orders:[];
  // En las órdenes de SAP el DKC va en el «Vendor Ref. No.» (num_proveedor).
  // Se compara también solo el número: «DKC-26132» y «26132» son la misma.
  var num=function(v){ var m=String(v||'').match(/(\d{4,})/); return m?m[1]:''; };
  var kn=num(k);
  return lista.find(function(o){
    if(o._noSap) return false;
    var r=_firmaNormDKC(o.num_proveedor);
    return r===k || (kn && num(r)===kn && /^(DKC|SKC|HKC)?-?\s*\d+$/i.test(r.replace(/\s/g,'')));
  })||null;
}

// Busca en compras_pend_sap las ordenes cuyo dkc/num_orden coincida.
async function _firmaCargarAmarres(rows){
  window._firmaAmarres={};
  var dkcs=(rows||[]).map(function(o){ return _firmaNormDKC(o.dkc); }).filter(Boolean);
  if(!dkcs.length) return;
  var unicos=[]; var vistos={};
  dkcs.forEach(function(d){ if(!vistos[d]){ vistos[d]=1; unicos.push(d); } });
  try{
    var inList=unicos.map(function(d){ return '"'+d.replace(/"/g,'')+'"'; }).join(',');
    var r=await fetch(SB+'/rest/v1/compras_pend_sap?select=dkc,num_orden,proveedor,total,saldo,dept&or=(dkc.in.('+inList+'),num_orden.in.('+inList+'))',{headers:SBH});
    var ord=r.ok?(await r.json()):[];
    (Array.isArray(ord)?ord:[]).forEach(function(p){
      var k1=_firmaNormDKC(p.dkc), k2=_firmaNormDKC(p.num_orden);
      if(k1) window._firmaAmarres[k1]=p;
      if(k2 && !window._firmaAmarres[k2]) window._firmaAmarres[k2]=p;
    });
  }catch(e){}
}

/* v771: ¿son el mismo proveedor? Un DKC repetido amarraba la orden firmada
   a la BORRADOR de OTRO proveedor (DKC-26140: Yangjiang en firma, Ningbo
   Unity en BORRADOR) y salía «Amarrada… firmada y en proceso» sin que
   existiera su borrador. Se compara la primera palabra con sentido. */
function _firmaMismoProv(a, b){
  var limpia=function(x){
    return String(x||'').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^A-Z0-9 ]/g,' ').split(/\s+/).filter(function(w){
        return w.length>2 && !/^(CO|LTD|LIMITED|INC|CORP|COMPANY|INTL|INTERNATIONAL|TRADING|TRAING|TRADE|IMPORT|EXPORT|INDUSTRIAL|INDUSTRY|GROUP|THE|AND|HARDWARE|HOUSEWARE|HOUSEWARES|MANUFACTURING|FACTORY|TECHNOLOGY|CHINA)$/.test(w);
      });
  };
  var x=limpia(a), y=limpia(b);
  if(!x.length || !y.length) return true;          // sin datos: no se bloquea
  return x.some(function(w){ return y.indexOf(w)>=0; });
}

// Bloque visual del DKC dentro de cada orden firmada.
function _firmaBloqueDKC(o, rol){
  if(o.estado!=='firmada' && o.estado!=='enviada_proveedor') return '';
  var dkc=_firmaNormDKC(o.dkc);
  var puedeEditar = (rol==='compras') || (CU && _esCompras());
  var h='<div style="margin-top:7px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:8px 10px">';
  h+='<div style="font-size:10.5px;color:var(--text-muted);font-weight:600;margin-bottom:5px"><i class="ti ti-link"></i> N° DKC de la orden de compra</div>';

  if(!dkc){
    if(puedeEditar){
      // El DKC casi siempre ya está escrito en el título o en los documentos
      // de la propia orden: se propone solo, para no tener que copiarlo a
      // mano y quedarse sin depósito ni borrador por ese paso.
      var sug=_firmaDKCsugerido(o);
      h+='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">'
        +'<input id="firma-dkc-'+o.id+'" placeholder="Ej: DKC-25090" value="'+_esc(sug)+'" style="flex:1;min-width:150px;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
        +'<button class="btn bp" style="padding:5px 11px;font-size:11px" onclick="_firmaGuardarDKC('+o.id+')"><i class="ti ti-device-floppy"></i> Guardar DKC</button>'
        +'</div>'
        +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
        +(sug?('Se propone <b>'+_esc(sug)+'</b>, sacado de la propia orden. '):'')
        +'Al guardarlo se amarra con la orden BORRADOR que tenga ese mismo número; '
        +'si no existe, sale el botón para crearla.</div>';
    }else{
      h+='<div style="font-size:11.5px;color:var(--text-muted)">Compras aún no ha registrado el N° DKC.</div>';
    }
    h+='</div>'; return h;
  }

  var p=window._firmaAmarres[dkc];
  var pOtro = (p && !_firmaMismoProv(o.proveedor, p.proveedor)) ? p : null;
  if(pOtro) p=null;
  var osOtro=null;
  h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
    +'<span style="font-size:13px;font-weight:700;color:var(--text-accent)">'+_esc(dkc)+'</span>';
  if(puedeEditar) h+='<button class="btn bg2" style="padding:3px 8px;font-size:10.5px" onclick="_firmaEditarDKC('+o.id+',\''+_esc(dkc)+'\')"><i class="ti ti-pencil"></i> Cambiar</button>';
  h+='</div>';

  if(!p && !pOtro){
    var _os0=_firmaOrdenSAP(dkc);
    if(_os0 && !_firmaMismoProv(o.proveedor, _os0.prov)) osOtro=_os0;
  }
  if(pOtro || osOtro){
    var otroProv=pOtro ? pOtro.proveedor : osOtro.prov;
    var donde=pOtro ? 'una orden BORRADOR' : ('la orden de SAP #'+osOtro.id);
    h+='<div style="margin-top:6px;background:var(--pastel-error);border:1px solid #DC2626;border-radius:8px;'
      +'padding:7px 10px;font-size:11.5px;color:var(--t-rojo);line-height:1.5">'
      +'<b><i class="ti ti-alert-octagon"></i> El '+_esc(dkc)+' ya está usado por '+donde
      +' de otro proveedor: '+_esc(otroProv||'—')+'.</b><br>'
      +'Esta orden es de '+_esc(o.proveedor||'—')+'. Un DKC es de una sola orden: '
      +'cámbiale el número a esta (o a la otra) y entonces se podrá crear su BORRADOR.'
      +(puedeEditar?('<div style="margin-top:6px"><button class="btn bp" style="padding:3px 9px;font-size:10.5px;background:#B91C1C" '
        +'onclick="_firmaEditarDKC('+o.id+',\''+_esc(dkc)+'\')"><i class="ti ti-pencil"></i> Cambiar el DKC de esta orden</button></div>'):'')
      +'</div>';
  }else if(p){
    h+='<div style="margin-top:6px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:12px;font-weight:700;color:var(--t-verde);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<span><i class="ti ti-link"></i> Amarrada a la orden No-SAP '+_esc(p.num_orden||p.dkc)+' &middot; firmada y en proceso con el proveedor</span>'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="abrirPendSAP(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-eye"></i> Ver orden</button>'
      +(puedeEditar?'<button class="btn bp" style="padding:3px 9px;font-size:10.5px;background:#166534" onclick="marcarEnSAP(\''+_esc(dkc)+'\')" title="Pulsa SOLO cuando la hayas creado en SAP"><i class="ti ti-database-import"></i> Marcar: ya está en SAP</button>':'')
      +'</div>';
  }else if(_firmaOrdenSAP(dkc) && !osOtro){
    // v745: la orden ya está en SAP aunque no pasara por BORRADOR (se creó
    // directo en SAP, p. ej. porque se firmó en papel): no falta nada.
    var os=_firmaOrdenSAP(dkc);
    h+='<div style="margin-top:6px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:12px;font-weight:700;color:var(--t-verde);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<span><i class="ti ti-database-check"></i> Ya está creada en SAP · orden #'+_esc(String(os.id))+(os.prov?(' · '+_esc(os.prov)):'')+'</span>'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="openDetail(\''+_esc(String(os.id))+'\')"><i class="ti ti-eye"></i> Ver orden</button>'
      +'</div>';
  }else{
    h+='<div style="margin-top:6px;background:var(--pastel-naranja);border:1px solid #F5B971;border-radius:8px;padding:7px 10px;font-size:11.5px;color:var(--t-ambar);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<span><i class="ti ti-alert-triangle"></i> Falta crear la orden BORRADOR con este DKC.</span>';
    if(puedeEditar) h+='<button class="btn bp" style="padding:3px 9px;font-size:10.5px;background:#B45309" onclick="_firmaCrearNoSAP('+o.id+')"><i class="ti ti-plus"></i> Crear orden BORRADOR</button>';
    h+='</div>';
  }
  h+='</div>';
  return h;
}

async function _firmaGuardarDKC(id){
  var inp=document.getElementById('firma-dkc-'+id);
  var val=_firmaNormDKC(inp?inp.value:'');
  if(!val){ showT('Escribe el N° DKC'); return; }
  try{
    await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',{dkc:val},[]);
    showT('DKC '+val+' guardado');
    _firmaCargarLista((CU&&CU.role==='gerencia')?'gerencia':'compras');
  }catch(e){ showT('Error al guardar el DKC: '+(e.message||e)); }
}

function _firmaEditarDKC(id, actual){
  var v=prompt('N° DKC de la orden de compra:', actual||'');
  if(v===null) return;
  var val=_firmaNormDKC(v);
  if(!val){ showT('DKC vacío, no se cambió'); return; }
  _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',{dkc:val},[])
    .then(function(){ showT('DKC actualizado'); _firmaCargarLista((CU&&CU.role==='gerencia')?'gerencia':'compras'); })
    .catch(function(e){ showT('Error: '+(e.message||e)); });
}

// Abre el formulario de orden BORRADOR ya con el DKC y el proveedor puestos.
/* v732: y con los DOS documentos ya puestos (nuestra orden KCC y la PI del
   proveedor), los mismos de la compra para firma: los FIRMADOS si ya se
   firmó, si no los que se subieron. Antes había que volver a subirlos. Si la
   orden KCC firmada es un PDF y la original era un Excel, el Excel también
   queda a mano para sacar las fotos de los artículos. */
async function _firmaCrearNoSAP(id){
  var o={};
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    o=(d&&d[0])||{};
    abrirNuevaOrdenSinSAP(o.dept||null, { ref:_firmaNormDKC(o.dkc), prov:o.proveedor||'', total:o.monto||0 });
  }catch(e){ showT('Error: '+(e.message||e)); return; }
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Poniendo los documentos de la compra para firma…</span>';
  var poner=async function(clave, path, nombre){
    if(!path) return null;
    var f=await _firmaBajarArchivo(path, nombre);
    _nsapDocElegido(clave, {files:[f]});
    var box=document.getElementById('nsapBox-'+clave);
    if(box) box.style.borderStyle='solid';
    return f;
  };
  var puestos=[], fallos=[];
  try{
    /* v740: la IA tiene que leer los documentos CON SUS LÍNEAS. Si nuestra
       orden original era un Excel, la «orden firmada» es una hoja resumen que
       genera el portal (proveedor, descripción, monto y firma), SIN artículos:
       con ella la IA sacaba una sola línea («Barras tensoras…») sin SKU. Por
       eso se usa la firmada solo si es el mismo documento estampado (cuando
       el original ya era PDF); si no, el original. */
    var origPdf=function(n){ return /\.pdf$/i.test(String(n||'')); };
    var kcc=(o.archivo_firmado_path && origPdf(o.archivo_nombre))
              ? [o.archivo_firmado_path, o.archivo_firmado_nombre||'orden_firmada.pdf', 'firmada']
              : (o.archivo_path ? [o.archivo_path, o.archivo_nombre||'orden_kcc', 'original']
                                : [o.archivo_firmado_path, o.archivo_firmado_nombre||'orden_firmada.pdf', 'firmada']);
    var pi =(o.archivo_firmado_path2 && origPdf(o.archivo_nombre2))
              ? [o.archivo_firmado_path2, o.archivo_firmado_nombre2||'pi_firmada.pdf', 'firmada']
              : (o.archivo_path2 ? [o.archivo_path2, o.archivo_nombre2||'pi_proveedor', 'original']
                                 : [o.archivo_firmado_path2, o.archivo_firmado_nombre2||'pi_firmada.pdf', 'firmada']);
    try{ if(await poner('kcc', kcc[0], kcc[1])) puestos.push('nuestra orden KCC ('+kcc[2]+')'); }
    catch(e){ fallos.push('la orden KCC: '+(e.message||e)); }
    try{ if(await poner('prov', pi[0], pi[1])) puestos.push('la PI del proveedor ('+pi[2]+')'); }
    catch(e){ fallos.push('la PI: '+(e.message||e)); }
    // El Excel original de la orden KCC, para las fotos (si no es ya el que va puesto)
    if(o.archivo_path && /\.xlsx?$/i.test(o.archivo_nombre||'') && kcc[0]!==o.archivo_path){
      try{ window._nsapExcelExtra=await _firmaBajarArchivo(o.archivo_path, o.archivo_nombre); }catch(e){}
    }
  }catch(e){ fallos.push(String(e.message||e)); }
  if(st){
    st.innerHTML=(puestos.length
        ? '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Ya están puestos: '+puestos.join(' y ')
          +'. No hace falta volver a subirlos. Pulsa <b>Revisar y comparar con IA</b>.</span>'
        : '<span style="color:var(--t-marron)"><i class="ti ti-info-circle"></i> Esta compra para firma no tiene documentos guardados: súbelos aquí.</span>')
      +(fallos.length?('<div style="color:var(--text-danger);font-size:11px;margin-top:3px">No pude traer '+_esc(fallos.join(' · '))+'</div>'):'');
  }
}

// Baja un archivo guardado en el almacenamiento y lo deja como un archivo subido
async function _firmaBajarArchivo(path, nombre){
  var r=await fetch(DOCS_BASE+String(path).split('/').map(encodeURIComponent).join('/'));
  if(!r.ok) throw new Error('no se pudo abrir ('+r.status+')');
  var b=await r.blob();
  var ext=(String(nombre||'').match(/\.([A-Za-z0-9]{2,5})$/)||[,''])[1].toLowerCase();
  var tipo=b.type || ({pdf:'application/pdf', xlsx:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                       xls:'application/vnd.ms-excel', jpg:'image/jpeg', jpeg:'image/jpeg', png:'image/png'}[ext]||'application/octet-stream');
  return new File([b], nombre||String(path).split('/').pop(), {type:tipo});
}

function _firmaEstadoColor(e){ return (e==='firmada'||e==='enviada_proveedor')?'#16a34a':(e==='rechazada')?'#9ca3af':'#dc2626'; }
function _firmaBadgeEstado(e){
  var map={firmada:['Firmada','#dcfce7','#166534'],enviada_proveedor:['Enviada a proveedor','#dcfce7','#166534'],rechazada:['Rechazada','#f3f4f6','#6b7280'],pendiente:['Pendiente de firma','#fee2e2','#b91c1c']};
  var m=map[e]||map.pendiente;
  // "Enviada a proveedor" se destaca: es el estado final y antes se perdia
  if(e==='enviada_proveedor'){
    return '<span style="display:inline-flex;align-items:center;gap:4px;font-size:11.5px;background:var(--pastel-ok);'
      +'color:var(--t-verde);border:1px solid #16a34a;padding:3px 10px;border-radius:9px;font-weight:700;white-space:nowrap">'
      +'<i class="ti ti-circle-check" style="font-size:12px"></i>ENVIADA AL PROVEEDOR</span>';
  }
  return '<span style="font-size:9px;background:'+m[1]+';color:'+m[2]+';padding:1px 7px;border-radius:7px;font-weight:600">'+m[0]+'</span>';
}
// ── Resumen de la revisión con IA dentro de la tarjeta de firma ──
window._firmaRevCache={};
function _firmaRevDe(o){
  var rv=o&&o.revision_ia;
  if(typeof rv==='string'){ try{ rv=JSON.parse(rv); }catch(e){ rv=null; } }
  return rv&&rv.data?rv:null;
}
function _firmaResumenIA(o){
  var rv=_firmaRevDe(o); if(!rv) return '';
  window._firmaRevCache[String(o.id)]=rv;
  var g=Number(rv.n_graves)||0, d=Number(rv.n_diferencias)||0, e=Number(rv.n_errores)||0, nd=Number(rv.n_docs)||0;
  var col, bg, bd, txt;
  var rg=Number(rv.n_rep_graves)||0;
  if(rg){ col='#991b1b'; bg='#FEF2F2'; bd='#dc2626'; txt='<b>No cuadra con la reposición '+_esc(rv.reposicion||'')+'</b> ('+rg+' grave(s))'
          +(g?(' · '+g+' diferencia(s) grave(s) con el proveedor'):''); }
  else if(g){ col='#991b1b'; bg='#FEF2F2'; bd='#dc2626'; txt='<b>'+g+' diferencia(s) grave(s)</b> entre nuestra orden y la del proveedor'; }
  else if(d||e){ col='#7C3D12'; bg='#FEF9F3'; bd='#E9C08A'; txt=(d?(d+' diferencia(s)'):'')+((d&&e)?' · ':'')+(e?(e+' error(es)'):''); }
  else if(nd>1){ col='#166534'; bg='#dcfce7'; bd='#16a34a'; txt='Las dos órdenes coinciden'; }
  else { col='#166534'; bg='#dcfce7'; bd='#16a34a'; txt='Revisada por AI, sin observaciones'; }
  return '<div onclick="event.stopPropagation();_firmaVerRevisionIA(\''+o.id+'\')" title="Ver el detalle de la revisión"'
    +' style="margin-top:5px;display:inline-flex;align-items:center;gap:5px;background:'+bg+';border:1px solid '+bd+';color:'+col
    +';border-radius:8px;padding:3px 9px;font-size:10.5px;font-weight:600;cursor:pointer">'
    +'<i class="ti ti-sparkles"></i> AI: '+txt
    +(nd>1?' <span style="font-weight:400;opacity:.75">('+nd+' documentos)</span>':(nd===1?' <span style="font-weight:400;opacity:.75">(1 documento)</span>':''))
    +' <i class="ti ti-chevron-right"></i></div>';
}
function _firmaVerRevisionIA(id){
  var rv=window._firmaRevCache[String(id)]; if(!rv){ showT('Sin revisión guardada'); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1004;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:640px;width:100%;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;padding:14px 16px;border-bottom:0.5px solid var(--border)">'
      +'<div style="font-size:14px;font-weight:700"><i class="ti ti-sparkles" style="color:var(--t-lila2)"></i> Revisión AI de la compra</div>'
      +'<button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="padding:14px 16px">'
      +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:9px">'+_esc(rv.archivo||'')+(rv.fecha?(' · '+new Date(rv.fecha).toLocaleString('es')):'')+'</div>'
      +'<div id="firma-rev-modal-body"></div>'
    +'</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _firmaRenderRevision(rv.data,'firma-rev-modal-body'); }catch(e){}
}

// ── Filtro por estado de la orden de compra ──
window._firmaFiltro='todas';
// Una orden "enviada a proveedor sin orden No SAP" es la que ya salió al
// proveedor pero todavía no tiene una orden No-SAP amarrada por su N° DKC.
function _firmaSinNoSAP(o){
  if(o.estado!=='enviada_proveedor') return false;
  var dkc=_firmaNormDKC(o.dkc);
  if(!dkc) return true;
  return !(window._firmaAmarres && window._firmaAmarres[dkc]);
}
function _firmaCoincide(o, f){
  if(f==='todas') return true;
  if(f==='pendiente') return o.estado==='pendiente';
  if(f==='firmada') return o.estado==='firmada';
  if(f==='enviada_proveedor') return o.estado==='enviada_proveedor';
  if(f==='sin_nosap') return _firmaSinNoSAP(o);
  return true;
}
function _firmaSetFiltro(f){
  window._firmaFiltro=f;
  var box=document.getElementById('firma-lista');
  if(box) _firmaRenderLista(box, window._firmaRows||[], window._firmaRol||(CU&&CU.role));
}
function _firmaBarraFiltro(rows){
  var defs=[
    {k:'todas',              l:'Todas',                          c:'var(--text-secondary)'},
    {k:'pendiente',          l:'Pendiente de firma',             c:'#b91c1c'},
    {k:'firmada',            l:'Firmada',                        c:'#166534'},
    {k:'enviada_proveedor',  l:'Enviada a proveedor',            c:'#0c447c'},
    {k:'sin_nosap',          l:'Enviada sin orden Borrador',       c:'#B45309'}
  ];
  var act=window._firmaFiltro||'todas';
  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;margin:4px 0 10px">';
  defs.forEach(function(d){
    var n=rows.filter(function(o){ return _firmaCoincide(o,d.k); }).length;
    var on=(act===d.k);
    h+='<button onclick="_firmaSetFiltro(\''+d.k+'\')" style="border:1px solid '+(on?d.c:'var(--border)')+';'
      +'background:'+(on?d.c:'var(--surface-1)')+';color:'+(on?'#fff':d.c)+';'
      +'border-radius:20px;padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +d.l+' <span style="opacity:.8;font-weight:400">'+n+'</span></button>';
  });
  return h+'</div>';
}

function _firmaRenderLista(box, rows, rol){
  var todas=rows||[];
  var titulo=rol==='compras'?'Mis compras para firma':'Compras para firmar';
  var barra=_firmaBarraFiltro(todas);
  rows=todas.filter(function(o){ return _firmaCoincide(o, window._firmaFiltro||'todas'); });
  if(!todas.length){ box.innerHTML='<div class="empty" style="padding:16px;color:var(--text-muted)">'+(rol==='compras'?'Aun no has enviado compras para firma.':'No hay compras pendientes de firma.')+'</div>'; return; }
  var h='<div style="font-size:12px;font-weight:600;margin:6px 0 4px">'+titulo+' <span style="color:var(--text-muted);font-weight:400">('+rows.length+(rows.length!==todas.length?(' de '+todas.length):'')+')</span></div>'+barra;
  if(!rows.length){
    box.innerHTML=h+'<div class="empty" style="padding:16px;color:var(--text-muted)">No hay compras en ese estado.</div>';
    return;
  }
  rows.forEach(function(o){
    var col=_firmaEstadoColor(o.estado);
    var fecha=o.creado_en?new Date(o.creado_en).toLocaleDateString('es'):'';
    var fFirm=o.firmado_en?new Date(o.firmado_en).toLocaleString('es'):'';
    var fRec=o.recibido_en?new Date(o.recibido_en).toLocaleString('es'):'';
    var fEnv=o.enviado_proveedor_en?new Date(o.enviado_proveedor_en).toLocaleString('es'):'';
    var title=(o.num_orden?('<b>'+_esc(o.num_orden)+'</b> &middot; '):'')+_esc(o.proveedor||'');
    h+='<div style="border:0.5px solid var(--border);border-left:4px solid '+col+';border-radius:9px;padding:10px 12px;margin-bottom:8px;display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:170px">'
        +'<div style="font-size:12.5px;font-weight:600">'+title+' '+_firmaBadgeEstado(o.estado)
          +((rol==='compras'&&o.estado==='firmada'&&!o.recibido_en)?'<span class="rep-nuevo"><i class="ti ti-writing-sign"></i> sin abrir</span>':'')
        +'</div>'
        +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+_esc(o.descripcion||'')+' &middot; '+fmt(o.monto||0)+' &middot; '+(EMOJIS2[o.dept]||'')+' '+_esc(dL(o.dept||''))+' &middot; '+_esc(o.creado_por_nom||'')+' &middot; '+fecha+'</div>'
        +(fFirm?('<div style="font-size:10.5px;color:var(--t-verde3);margin-top:2px"><i class="ti ti-writing-sign"></i> Firmada por '+_esc(o.firmado_por||'')+' &middot; '+fFirm+'</div>'):'')
        +(fRec?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px"><i class="ti ti-inbox"></i> Recibida firmada por compras: '+fRec+'</div>'):'')
        +(fEnv?('<div style="margin-top:5px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:13px;font-weight:700;color:var(--t-verde)"><i class="ti ti-send"></i> Enviada a proveedor &middot; '+fEnv+'</div>'):'')
        +((o.estado==='rechazada'&&o.motivo_rechazo)?('<div style="font-size:10.5px;color:var(--text-danger);margin-top:2px">Motivo: '+_esc(o.motivo_rechazo)+'</div>'):'')
        +_firmaResumenIA(o)
        +_firmaBloqueDKC(o, rol)
      +'</div>';
    if(o.archivo_path) h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_firmaVer(\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'archivo')+'\')"><i class="ti ti-file"></i> Original</button>';
    // La PI del proveedor: se guardaba y no se enseñaba nunca en la lista,
    // así que de los dos adjuntos solo aparecía uno.
    if(o.archivo_path2) h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px;color:var(--t-ambar)" onclick="_firmaVer(\''+_esc(o.archivo_path2)+'\',\''+_esc(o.archivo_nombre2||'PI del proveedor')+'\')"><i class="ti ti-truck-delivery"></i> PI del proveedor</button>';
    if((o.estado==='firmada'||o.estado==='enviada_proveedor')&&o.archivo_firmado_path){
      if(rol==='compras') h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#16a34a" onclick="_firmaVerFirmadaCompras('+o.id+',\''+_esc(o.archivo_firmado_path)+'\',\''+_esc(o.archivo_firmado_nombre||'firmada')+'\','+(o.recibido_en?'true':'false')+')"><i class="ti ti-writing-sign"></i> Ver orden firmada</button>';
      else h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#16a34a" onclick="_firmaVer(\''+_esc(o.archivo_firmado_path)+'\',\''+_esc(o.archivo_firmado_nombre||'firmada')+'\')"><i class="ti ti-writing-sign"></i> Ver orden firmada</button>';
      if(o.archivo_firmado_path2) h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#B45309" onclick="_firmaVer(\''+_esc(o.archivo_firmado_path2)+'\',\''+_esc(o.archivo_firmado_nombre2||'PI firmada')+'\')"><i class="ti ti-writing-sign"></i> Ver PI firmada</button>';
    }
    if(rol==='compras'&&o.estado==='firmada') h+='<button class="btn bp" style="padding:5px 9px;font-size:11px" onclick="_firmaEnviadaProveedor('+o.id+')"><i class="ti ti-send"></i> Enviada a proveedor</button>';
    // Editar: solo mientras gerencia no la haya firmado
    if(rol==='compras' && o.estado!=='firmada' && o.estado!=='enviada_proveedor'){
      h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px;color:var(--t-ambar)" onclick="_firmaEditar('+o.id+')"><i class="ti ti-pencil"></i> Editar</button>';
    }
    // Borrar: disponible para cualquier usuario y en cualquier estado, siempre
    // con confirmación previa.
    h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px;color:var(--text-danger)" onclick="_firmaBorrar('+o.id+')"><i class="ti ti-trash"></i> Borrar</button>';
    if(rol==='gerencia'&&o.estado==='pendiente') h+='<button class="btn bp" style="padding:5px 9px;font-size:11px" onclick="_firmaAbrir('+o.id+')"><i class="ti ti-signature"></i> Firmar</button>';
    if(o.archivo_path || o.archivo_path2)
      h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#0F766E" onclick="_firmaRevisarRep('+o.id+')" '
        +'title="Compara esta orden con la reposición que se envió a compras"><i class="ti ti-package"></i> Revisar contra la reposición</button>';
    h+=_chatBtn('firma', o.id, (o.num_orden?o.num_orden+' ':'')+(o.proveedor||''));
    h+='</div>';
  });
  box.innerHTML=h;
  try{ _chatBadges('firma', rows.map(function(o){return o.id;})); }catch(e){}
}
// Escritura resiliente: intenta con todas las columnas; si la tabla no tiene alguna
// columna nueva, reintenta sin ellas (para no romper si falta el ALTER).
async function _firmaWrite(url, method, bodyFull, dropKeys){
  var r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(bodyFull)});
  if(!r.ok && dropKeys && dropKeys.length){ var min=Object.assign({},bodyFull); dropKeys.forEach(function(k){delete min[k];}); r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(min)}); }
  return r;
}
function _firmaVerFirmadaCompras(id, path, nombre, yaRecibida){ _firmaVer(path, nombre); if(!yaRecibida) _firmaMarcarRecibida(id); }
async function _firmaRefOrden(id){ try{ var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=num_orden,proveedor&limit=1',{headers:SBH}).then(function(r){return r.json();}); var o=d&&d[0]; return o?((o.num_orden?o.num_orden+' ':'')+(o.proveedor||'')):('#'+id); }catch(e){ return '#'+id; } }
async function _firmaMarcarRecibida(id){
  try{
    await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',{ recibido_en:new Date().toISOString() },['recibido_en']);
    var ref=await _firmaRefOrden(id);
    try{ addNotif('gerencia','Orden '+ref+' recibida (firmada) por compras','','ti-writing-sign'); }catch(e){}
    _firmaCargarLista('compras');
    try{ _firmaActualizarBadge(); }catch(e){}
  }catch(e){ console.warn('marcar recibida:',e); }
}
// ═══════════════════════════════════════════════════════════════════════════
//  ENVIAR LA ORDEN FIRMADA AL PROVEEDOR
//  Abre una pantalla con el correo del proveedor ya cargado (si está en SAP),
//  la orden firmada adjunta y el asunto armado. El cuerpo queda editable.
// ═══════════════════════════════════════════════════════════════════════════
// Busca el correo del proveedor en las órdenes de SAP por nombre
function _firmaCorreoProveedor(nombre){
  var n=_repNorm(nombre);
  if(!n) return '';
  var lista=(typeof orders!=='undefined' && orders)?orders:[];
  var exacto=lista.find(function(o){ return o.vendorEmail && _repNorm(o.prov)===n; });
  if(exacto) return exacto.vendorEmail;
  var parcial=lista.find(function(o){
    if(!o.vendorEmail) return false;
    var p=_repNorm(o.prov);
    return p && (p.indexOf(n)>=0 || n.indexOf(p)>=0);
  });
  return parcial?parcial.vendorEmail:'';
}

// ── Chips de CC: compañeros del departamento + gerencia ──
// Se marcan con un clic y se van escribiendo en el campo CC.
function _firmaCandidatosCC(){
  var yo=((CU&&CU.email)||'').toLowerCase();
  var mios=[], gerencia=[];
  (USERS||[]).forEach(function(u){
    if(!u.email) return;
    if(u.email.toLowerCase()===yo) return;                 // uno mismo no
    if(u.role==='gerencia'){ gerencia.push(u); return; }
    if(CU && u.role===CU.role && (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()))) mios.push(u);
  });
  return {equipo:mios, gerencia:gerencia};
}
function _firmaChipsCC(){
  var c=_firmaCandidatosCC();
  if(!c.equipo.length && !c.gerencia.length) return '';
  function chip(u, color, bg, bd){
    return '<span class="cc-chip" data-mail="'+_esc(u.email)+'" onclick="_firmaToggleCC(this)"'
      +' style="border:1px solid '+bd+';background:var(--surface-1);color:'+color+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name||u.email)+'</span>';
  }
  var h='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:5px">';
  c.equipo.forEach(function(u){ h+=chip(u,'#0c447c','#e6f1fb','#85B7EB'); });
  c.gerencia.forEach(function(u){ h+=chip(u,'#27500A','#EAF3DE','#A9C98A'); });
  h+='</div>';
  h+='<div style="display:flex;gap:8px;margin-top:5px">'
    +'<span onclick="_firmaCCTodos()" style="font-size:10.5px;color:var(--text-accent);cursor:pointer;text-decoration:underline">Marcar todos</span>'
    +'<span onclick="_firmaCCNinguno()" style="font-size:10.5px;color:var(--text-muted);cursor:pointer;text-decoration:underline">Quitar todos</span>'
    +'</div>';
  return h;
}
function _firmaCCSync(){
  var inp=document.getElementById('ep-cc'); if(!inp) return;
  // Respeta los correos escritos a mano que no correspondan a ningún chip
  var chips=Array.prototype.slice.call(document.querySelectorAll('.cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}
function _firmaToggleCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i) i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus');
  if(i) i.style.fontSize='10px';
  _firmaCCSync();
}
function _firmaCCTodos(){
  document.querySelectorAll('.cc-chip').forEach(function(c){ if(!c.classList.contains('on')) _firmaToggleCC(c); });
}
function _firmaCCNinguno(){
  document.querySelectorAll('.cc-chip').forEach(function(c){ if(c.classList.contains('on')) _firmaToggleCC(c); });
}

async function _firmaEnviadaProveedor(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!o){ showT('No se encontró la orden'); return; }
    window._firmaEnvProv=o;

    var correo=_firmaCorreoProveedor(o.proveedor||'');
    // El asunto lleva el N° DKC de la orden: CONFIRMATION DKC-26118
    var dkc=_firmaNormDKC(o.dkc)||_firmaNormRef(o.num_orden||'')||String(o.num_orden||'').trim();
    var asunto='CONFIRMATION'+(dkc?(' '+dkc):'');
    var tieneAdj=!!o.archivo_firmado_path;

    var ov=document.createElement('div');
    ov.id='modalEnvProv';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2002;display:flex;align-items:center;justify-content:center;padding:16px';
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:540px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700"><i class="ti ti-send" style="color:var(--t-azul)"></i> Enviar orden al proveedor</div>'
      +'<button onclick="document.getElementById(\'modalEnvProv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';

    h+='<div style="background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px">'
      +'<b>'+_esc(o.num_orden||'')+'</b> &middot; '+_esc(o.proveedor||'')
      +(o.descripcion?(' &middot; '+_esc(o.descripcion)):'')+'</div>';

    // Adjuntos (v733): LOS DOS firmados, nuestra orden y la PI del proveedor
    var adjs=_firmaAdjuntosProveedor(o);
    h+='<div style="font-size:11px;color:var(--text-secondary);font-weight:600;margin-bottom:4px"><i class="ti ti-paperclip"></i> Adjuntos ('+adjs.length+')</div>';
    adjs.forEach(function(a){
      h+='<div style="display:flex;align-items:center;gap:7px;background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:8px 10px;margin-bottom:6px;font-size:11.5px;color:var(--t-verde)">'
        +'<i class="ti ti-writing-sign"></i><span style="flex:1"><b>'+_esc(a.que)+'</b> · '+_esc(a.nombre)+(a.firmada?'':' <span style="color:var(--t-marron)">(sin firmar)</span>')+'</span>'
        +'<button class="btn bg2" style="padding:3px 8px;font-size:10.5px" onclick="_firmaVer(\''+_esc(a.path)+'\',\''+_esc(a.nombre)+'\')">ver</button></div>';
    });
    if(!adjs.some(function(a){ return a.clave==='kcc'; }))
      h+='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:7px;padding:8px 10px;margin-bottom:6px;font-size:11.5px;color:var(--t-rojo)">'
        +'<i class="ti ti-alert-triangle"></i> Esta compra no tiene nuestra orden firmada guardada.</div>';
    if(!adjs.some(function(a){ return a.clave==='pi'; }))
      h+='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:7px;padding:8px 10px;margin-bottom:6px;font-size:11.5px;color:var(--t-marron)">'
        +'<i class="ti ti-info-circle"></i> Esta compra no tiene la PI del proveedor guardada: sale solo nuestra orden.</div>';
    h+='<div style="margin-bottom:8px"></div>';

    h+='<div style="display:flex;flex-direction:column;gap:9px">';
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Para *</label>'
      +'<input id="ep-para" value="'+_esc(correo)+'" placeholder="correo@proveedor.com (uno o varios, separados por coma)" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)">'
      +(correo?'<div style="font-size:10px;color:var(--text-success);margin-top:3px"><i class="ti ti-circle-check"></i> Correo tomado de SAP</div>'
              :'<div style="font-size:10px;color:var(--t-ambar);margin-top:3px"><i class="ti ti-alert-circle"></i> Este proveedor no tiene correo en SAP: escríbelo a mano</div>')
      +'</div>';
    // CC: el equipo del departamento y gerencia, para marcar con un clic
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">CC — copia interna</label>'
      +_firmaChipsCC()
      +'<input id="ep-cc" placeholder="Marca arriba o escribe: copia@ejemplo.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:5px;background:var(--surface-2);color:var(--text-primary)"></div>';
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Asunto *</label>'
      +'<input id="ep-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)"></div>';
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Mensaje</label>'
      +'<textarea id="ep-cuerpo" rows="16" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;margin-top:3px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical;line-height:1.45">'
      +_esc(_firmaCuerpoProveedor(o))+'</textarea>'
      +'<div style="font-size:10px;color:var(--text-muted);margin-top:3px">Puedes editarlo antes de enviar. El N° DKC ya viene puesto.</div>'
      +'<div style="font-size:11px;color:var(--text-secondary);font-weight:500;margin-top:9px">Firma (se añade sola al final)</div>'
      +'<div style="background:#fff;border:0.5px solid var(--border);border-radius:7px;padding:4px 12px 10px;margin-top:3px">'+_firmaHtmlCorreo()+'</div></div>';
    h+='</div>';

    h+='<div style="display:flex;gap:8px;margin-top:16px">';
    h+='<button class="btn bg2" style="flex:1;padding:10px" onclick="document.getElementById(\'modalEnvProv\').remove()">Cancelar</button>';
    h+='<button class="btn bp" style="flex:2;padding:10px" onclick="_firmaEnviarAlProveedor('+id+')"><i class="ti ti-send"></i> Enviar al proveedor</button>';
    h+='</div></div>';

    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
    document.body.appendChild(ov);
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// Cuerpo por defecto del correo de confirmación al proveedor.
// Queda editable en la pantalla antes de enviar.
function _firmaCuerpoProveedor(o){
  var dkc=_firmaNormDKC(o&&o.dkc)||_firmaNormRef((o&&o.num_orden)||'')||'DKC-';
  return 'Dear Vendor,\n'
+'Kindly find attached your company\u2019s PI and our Purchase Order '+dkc+' duly signed as final confirmation for this order.  Also we included the DKC excel sheet format for your convenience.\n'
+'\n'
+'As you may see, we added the following:\n'
+'   * We included our new '+dkc+' number\n'
+'   * We also included our NEW item and barcode numbers FOR THIS NEW ORDER\n'
+'   * We also included the Spanish name that must be used in the shipping marks only.   Spanish package description for artworks is usually kind of different than shipping marks.\n'
+'\n'
+'Also please follow the instructions below:\n'
+'-            Our '+dkc+' number must be used in all our e-mail communications from now on please.\n'
+'-            Shipping marks will be sent right after confirmation of this order\n'
+'-            Please check if bank details are ok to arrange deposit.  ON a separate email you will be asked for special banking documents\n'
+'\n'
+'Ref. ARTWORKS:  In order to make package design we need the following:\n'
+'\u00b7       Diecuts for all packages, boxes, sleeves cards, hang tags, etc.\n'
+'\u00b7       Photos for each product in HD resolution\n'
+'\u00b7       Any QC certification you carry\n'
+'\n'
+'IMPORTANT:\n'
+'   1. Nominated carrier information will be sent once you are ready for shipment\n'
+'   2. Booking must be arranged 2 weeks before shipment\n'
+'   3. Mass production Inspection photos must be sent before shipment when booked for approval\n'
+'   4. Few Samples might be requested before final shipment\n'
+'\n'
+'Hope all is clear and fine, if any question, please feel free to let me know.\n'
+'Thanks for your great sense of business, we appreciate.\n'
+'\n'
+'Best regards,';
}

/* FIRMA DEL CORREO AL PROVEEDOR (v749)
   Con el bloque de la empresa y, para quien escribe en nombre de un gerente,
   «ON BEHALF OF …» arriba. Pedido de Lorena: los proveedores chinos le
   escribían directo a Edy y a ella no la copiaban; con su firma completa (y
   el «responder a» con su correo, que ya pone el worker) contestan a ella.
   Para añadir a alguien: FIRMA_EN_NOMBRE_DE[id del usuario] = 'NOMBRE'. */
var FIRMA_EN_NOMBRE_DE = { lorena:'EDY GUINDI' };

function _firmaHtmlCorreo(){
  var nom=_firmaNombre(), mail=(CU&&CU.email)||'';
  var onb=FIRMA_EN_NOMBRE_DE[(CU&&CU.id)||''];
  var gris='color:#7a7a7a;font-size:13px;line-height:1.5';
  return '<table cellpadding="0" cellspacing="0" style="font-family:Calibri,Segoe UI,Arial,sans-serif;margin-top:14px">'
    +(onb?('<tr><td style="font-size:14px;font-weight:600;letter-spacing:.02em;color:#1a1a18">ON BEHALF OF '+_esc(onb)+'</td></tr>'):'')
    +'<tr><td style="font-family:\'Brush Script MT\',\'Segoe Script\',\'Lucida Handwriting\',cursive;font-size:24px;font-weight:bold;font-style:italic;color:#1a1a18;padding:2px 0">'+_esc(nom)+'</td></tr>'
    +'<tr><td style="font-size:14px;font-weight:700;color:#1a1a18">KENNEDY CENTER CORP.</td></tr>'
    +'<tr><td style="'+gris+'">Colon Free Zone</td></tr>'
    +'<tr><td style="'+gris+'">Rep. of Panamá</td></tr>'
    +'<tr><td style="'+gris+';font-family:Courier New,monospace">&#9742;&nbsp; (507) 431-8500</td></tr>'
    +'<tr><td style="'+gris+';font-family:Courier New,monospace">&#128439;&nbsp; (507) 447-1753</td></tr>'
    +'<tr><td style="'+gris+';font-family:Courier New,monospace">&#128238;&nbsp; P.O. BOX 0302-00737</td></tr>'
    +(mail?('<tr><td style="font-size:13px;font-family:Courier New,monospace">@&nbsp; <a href="mailto:'+_esc(mail)+'" style="color:#1d4ed8">'+_esc(mail)+'</a></td></tr>'):'')
    +'<tr><td style="font-size:13px;font-family:Courier New,monospace">&#128187;&nbsp; <a href="https://www.kennedyzl.com" style="color:#1d4ed8">www.kennedyzl.com</a></td></tr>'
    +'<tr><td style="padding-top:8px;font-size:13px;font-weight:bold;color:#15803d;font-family:Comic Sans MS,Segoe UI,Arial,sans-serif">&#127794; Before printing, think about the environment.</td></tr>'
    +'</table>';
}

// El texto del correo (lo escrito en la pantalla) en HTML, igual que lo hace el worker
function _correoTextoAHtml(t){
  t=String(t||'').replace(/\r\n/g,'\n').replace(/\r/g,'\n');
  t=t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  t=t.replace(/  +/g,function(m){ return Array(m.length+1).join('&nbsp;'); });
  return "<div style='font-family:Segoe UI,Arial,sans-serif;font-size:14px;line-height:1.55;color:#1a1a18'>"+t.replace(/\n/g,'<br>')+'</div>';
}

async function _firmaEnviarAlProveedor(id){
  var o=window._firmaEnvProv;
  if(!o){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var para=(document.getElementById('ep-para').value||'').split(/[,;]/).map(function(s){return s.trim();}).filter(Boolean);
  var cc=(document.getElementById('ep-cc').value||'').split(/[,;]/).map(function(s){return s.trim();}).filter(Boolean);
  var asunto=(document.getElementById('ep-asunto').value||'').trim();
  var cuerpo=(document.getElementById('ep-cuerpo').value||'');
  if(!para.length){ showT('Escribe al menos un destinatario'); return; }
  if(!asunto){ showT('Falta el asunto'); return; }

  showT('Enviando al proveedor…');
  try{
    var todos=para.concat(cc);
    // La PI firmada va como segundo adjunto (la cola admite uno por ruta y el
    // resto en «adjuntos»). Antes solo salía nuestra orden.
    var adjs=_firmaAdjuntosProveedor(o), principal=adjs.filter(function(a){ return a.clave==='kcc'; })[0];
    var extra=[];
    for(var ai=0; ai<adjs.length; ai++){
      var a=adjs[ai]; if(a===principal) continue;
      var f=await _firmaBajarArchivo(a.path, a.nombre);
      extra.push({name:a.nombre, nombre:a.nombre, contenido:await _fileB64(f), mime:f.type||'application/pdf'});
    }
    if(!principal && adjs.length){                  // sin la nuestra: la PI va como principal
      principal=adjs[0]; extra=[];
    }
    var fila={
      docnum:'PROV-'+id,
      para_lista: todos,
      para_email: todos[0],
      proveedor: o.proveedor||'',
      asunto: asunto,
      // v749: en HTML, con la firma completa al final (ver _firmaHtmlCorreo)
      cuerpo: '<!--HTML-->'+_correoTextoAHtml(_repCuerpoTexto(cuerpo))+_firmaHtmlCorreo(),
      adjunto_path: principal?principal.path:null,
      adjunto_nombre: principal?principal.nombre:null,
      adjuntos: extra,
      de_nombre: (CU&&CU.name)||'',
      de_email: (CU&&CU.email)||'',
      estado:'pendiente',
      creado_por:(CU&&CU.name)||'',
      creado_en:new Date().toISOString()
    };
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok){ var t=await r.text(); console.error('correo proveedor',r.status,t); showT('⚠ No se pudo encolar el correo'); return; }

    // Recién ahora se marca como enviada a proveedor
    var body={ estado:'enviada_proveedor', enviado_proveedor_en:new Date().toISOString(),
               enviado_por:(CU&&CU.name)||'', enviado_proveedor_email:todos.join(','),
               recibido_en:new Date().toISOString() };
    await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',body,
                      ['enviado_proveedor_en','enviado_por','recibido_en','enviado_proveedor_email']);
    var ref=await _firmaRefOrden(id);
    try{ addNotif('gerencia','Orden '+ref+' enviada al proveedor por '+((CU&&CU.name)||''),'','ti-send'); }catch(e){}

    var m=document.getElementById('modalEnvProv'); if(m) m.remove();
    showT('✓ Correo en cola para '+todos.length+' destinatario(s) con '+(adjs.length)+' adjunto(s)');
    _firmaCargarLista('compras'); _firmaActualizarBadge();
  }catch(e){ console.error('enviar proveedor:',e); showT('Error: '+(e.message||e)); }
}
// Lo que se adjunta al proveedor: nuestra orden y su PI, firmadas (o, si la PI
// no se firmó, la que se subió)
function _firmaAdjuntosProveedor(o){
  var L=[];
  if(o.archivo_firmado_path) L.push({clave:'kcc', que:'Nuestra orden firmada', path:o.archivo_firmado_path,
                                     nombre:o.archivo_firmado_nombre||'orden_firmada.pdf', firmada:true});
  if(o.archivo_firmado_path2) L.push({clave:'pi', que:'PI del proveedor firmada', path:o.archivo_firmado_path2,
                                      nombre:o.archivo_firmado_nombre2||'PI_firmada.pdf', firmada:true});
  else if(o.archivo_path2) L.push({clave:'pi', que:'PI del proveedor', path:o.archivo_path2,
                                   nombre:o.archivo_nombre2||'PI_proveedor.pdf', firmada:false});
  return L;
}
function _firmaVer(path,nombre){ if(!path)return; var url=DOCS_BASE+path.split('/').map(encodeURIComponent).join('/'); verArchivo(url,nombre); }

function _firmaAbrir(id){
  fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();}).then(function(d){
    var o=(Array.isArray(d)&&d[0])?d[0]:null; if(!o){ showT('No se encontro la orden'); return; }
    window._firmaOrden=o;
    var ov=document.createElement('div');
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px';
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:560px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><div style="font-size:15px;font-weight:700"><i class="ti ti-signature" style="color:var(--text-accent)"></i> Firmar compra</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
    h+='<div style="font-size:13px;font-weight:600">'+(o.num_orden?('<b>'+_esc(o.num_orden)+'</b> &middot; '):'')+_esc(o.proveedor||'')+'</div><div style="font-size:11px;color:var(--text-muted);margin-bottom:10px">'+_esc(o.descripcion||'')+' &middot; '+fmt(o.monto||0)+' &middot; '+(EMOJIS2[o.dept]||'')+' '+_esc(dL(o.dept||''))+' &middot; '+_esc(o.creado_por_nom||'')+'</div>';
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">';
    if(o.archivo_path) h+='<button class="btn bg2" style="color:var(--t-azul)" onclick="_firmaVer(\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'archivo')+'\')"><i class="ti ti-file"></i> Ver KCC orden de compra</button>';
    if(o.archivo_path2) h+='<button class="btn bg2" style="color:var(--t-ambar)" onclick="_firmaVer(\''+_esc(o.archivo_path2)+'\',\''+_esc(o.archivo_nombre2||'PI proveedor')+'\')"><i class="ti ti-file"></i> Ver PI proveedor</button>';
    h+='</div>';
    if(o.archivo_path2) h+='<div style="font-size:11px;color:var(--t-marron);background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:8px 10px;margin-bottom:12px"><i class="ti ti-writing-sign"></i> Al firmar se firmarán <b>los dos documentos por separado</b>.</div>';
    // Se firma al pie de TODAS las páginas del archivo
    var sug=[];
    try{
      var rv0=o.revision_ia; if(typeof rv0==='string') rv0=JSON.parse(rv0);
      ((rv0&&rv0.data&&rv0.data.documentos)||[]).forEach(function(d){
        var n=Number(d.pagina_final||0);
        if(n>=1 && sug.indexOf(n)<0) sug.push(n);
      });
    }catch(e){}
    sug.sort(function(a,b){return a-b;});
    window._firmaPaginasManual=null;
    h+='<div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:12px">'
      +'<div style="font-size:11px;font-weight:600;margin-bottom:4px"><i class="ti ti-writing-sign"></i> Páginas donde va la firma</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">La firma va abajo a la derecha, debajo del total de cada proforma. Si el archivo trae las dos órdenes, escribe las dos páginas separadas por coma.</div>'
      +'<input id="firma-paginas" value="'+(sug.join(', '))+'" placeholder="Ej: 9, 18 (vacío = última página)" oninput="_firmaSetPaginas(this.value)" style="width:100%;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
      +(sug.length?('<div style="font-size:10px;color:var(--text-success);margin-top:3px"><i class="ti ti-sparkles"></i> Detectado por la AI: fin de cada orden en la(s) página(s) '+sug.join(' y ')+'</div>')
                  :'<div style="font-size:10px;color:var(--t-ambar);margin-top:3px">Sin revisión AI: se firmará solo la última página. Escribe las páginas si el archivo trae dos órdenes.</div>')
      +'</div>';
    _firmaSetPaginas(sug.join(','));
    h+='<div style="font-size:11px;color:var(--text-secondary);font-weight:600;margin-bottom:4px"><i class="ti ti-pencil"></i> Dibuja tu firma</div>';
    h+='<canvas id="firma-canvas" width="520" height="140" style="border:1px solid var(--border);border-radius:8px;background:var(--surface-2);width:100%;touch-action:none;cursor:crosshair"></canvas>';
    h+='<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px;flex-wrap:wrap">';
    h+='<button class="btn bg2" onclick="_firmaLimpiarCanvas()"><i class="ti ti-eraser"></i> Limpiar</button>';
    h+='<button class="btn bg2" style="color:var(--text-danger)" onclick="_firmaRechazar('+o.id+')"><i class="ti ti-x"></i> Rechazar</button>';
    h+='<button class="btn bp" onclick="_firmaFirmar('+o.id+')"><i class="ti ti-check"></i> Firmar y enviar</button>';
    h+='</div></div>';
    ov.innerHTML=h; document.body.appendChild(ov);
    _firmaInitCanvas();
  }).catch(function(e){ showT('Error: '+(e.message||e)); });
}
// ═══════════════════════════════════════════════════════════════════════════
//  EDITAR / BORRAR UNA COMPRA PARA FIRMA
//  Solo mientras gerencia NO la haya firmado, y solo para quien la creó.
//  Se pueden corregir los datos y reemplazar el PDF adjunto.
// ═══════════════════════════════════════════════════════════════════════════
window._firmaEditArchivo=null;

async function _firmaEditar(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!o){ showT('No se encontró la orden'); return; }
    if(o.estado==='firmada'||o.estado==='enviada_proveedor'){ showT('Ya fue firmada: no se puede editar'); _firmaCargarLista('compras'); return; }
    if(!_esDeMiEquipo(o.creado_por)){ showT('Solo el equipo que creó la compra puede editarla'); return; }

    window._firmaEditArchivo=null;
    var deptOpts=DEPTS_ALL.map(function(x){ return '<option value="'+x+'"'+((o.dept===x)?' selected':'')+'>'+dL(x)+'</option>'; }).join('');
    var ov=document.createElement('div');
    ov.id='modalEditarFirma';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2001;display:flex;align-items:center;justify-content:center;padding:16px';
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:520px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700"><i class="ti ti-pencil" style="color:var(--t-ambar)"></i> Editar compra para firma</div>'
      +'<button onclick="document.getElementById(\'modalEditarFirma\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
    h+='<div style="background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-info-circle"></i> Puedes corregirla mientras gerencia no la firme. También puedes reemplazar el PDF adjunto.</div>';
    h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:10px">';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">N° de orden (DKC / SKC) *</label><input id="fe-orden" class="fi2" value="'+_esc(o.num_orden||'')+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Proveedor *</label><input id="fe-prov" class="fi2" value="'+_esc(o.proveedor||'')+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Departamento *</label><select id="fe-dept" class="fi2">'+deptOpts+'</select></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Descripción *</label><input id="fe-desc" class="fi2" value="'+_esc(o.descripcion||'')+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Monto total (USD) *</label><input id="fe-monto" type="number" step="0.01" class="fi2" value="'+(Number(o.monto)||0)+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Unidades</label><input id="fe-uni" type="number" class="fi2" value="'+(Number(o.unidades)||0)+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Fecha estimada</label><input id="fe-fecha" type="date" class="fi2" value="'+_esc(o.fecha_estimada||'')+'"></div>';
    h+='</div>';
    h+='<div style="font-size:11px;color:var(--text-secondary);font-weight:600;margin-bottom:4px">Archivo adjunto</div>';
    h+='<div style="font-size:11.5px;background:var(--surface-1);border-radius:7px;padding:7px 10px;margin-bottom:6px"><i class="ti ti-file"></i> '+_esc(o.archivo_nombre||'sin archivo')+'</div>';
    h+='<label style="display:flex;align-items:center;gap:7px;padding:9px 11px;border:1.5px dashed var(--border-accent);border-radius:8px;cursor:pointer;font-size:12px;color:var(--text-accent);background:var(--bg-accent);margin-bottom:14px">'
      +'<i class="ti ti-upload"></i><span id="fe-file-name">Reemplazar el PDF o Excel (opcional)</span>'
      +'<input type="file" accept=".pdf,.xlsx,.xls,.png,.jpg,.jpeg" style="display:none" onchange="_firmaEditSetArchivo(this)"></label>';
    h+='<div style="display:flex;gap:8px">';
    h+='<button class="btn bg2" style="flex:1;padding:10px" onclick="document.getElementById(\'modalEditarFirma\').remove()">Cancelar</button>';
    h+='<button class="btn bp" style="flex:2;padding:10px" onclick="_firmaGuardarEdicion('+o.id+')"><i class="ti ti-device-floppy"></i> Guardar cambios</button>';
    h+='</div></div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
    document.body.appendChild(ov);
  }catch(e){ showT('Error: '+(e.message||e)); }
}

function _firmaEditSetArchivo(input){
  var f=input.files&&input.files[0]; if(!f) return;
  window._firmaEditArchivo=f;
  var el=document.getElementById('fe-file-name'); if(el) el.textContent=f.name;
}

async function _firmaGuardarEdicion(id){
  var num=(document.getElementById('fe-orden').value||'').trim();
  var prov=(document.getElementById('fe-prov').value||'').trim();
  var dept=document.getElementById('fe-dept').value;
  var desc=(document.getElementById('fe-desc').value||'').trim();
  var monto=parseFloat(document.getElementById('fe-monto').value)||0;
  var uni=parseInt(document.getElementById('fe-uni').value)||0;
  var fEst=document.getElementById('fe-fecha').value||null;
  if(!num||!prov||!dept||!desc||!monto){ showT('Completa N° de orden, proveedor, departamento, descripción y monto'); return; }
  showT('Guardando cambios...');
  try{
    var patch={ num_orden:num, proveedor:prov, dept:dept, descripcion:desc, monto:monto, unidades:uni,
                fecha_estimada:fEst, actualizado_en:new Date().toISOString() };
    if(window._firmaEditArchivo){
      var path=await _subirDocStorage('firma', dept, window._firmaEditArchivo);
      if(path){
        patch.archivo_path=path;
        patch.archivo_nombre=window._firmaEditArchivo.name;
        patch.revision_ia=null;   // el archivo cambió: la revisión anterior ya no aplica
      } else { showT('No se pudo subir el archivo nuevo'); return; }
    }
    var r=await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',patch,['fecha_estimada','revision_ia','actualizado_en']);
    if(!r.ok){ var t=await r.text(); console.error('editar firma',r.status,t); showT('No se pudo guardar'); return; }
    window._firmaEditArchivo=null;
    var m=document.getElementById('modalEditarFirma'); if(m) m.remove();
    showT('✓ Compra actualizada'+(patch.archivo_path?' con el archivo nuevo':''));
    _firmaCargarLista('compras');
  }catch(e){ console.error('guardar edicion firma:',e); showT('Error: '+(e.message||e)); }
}

async function _firmaBorrar(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!o){ showT('No se encontró la orden'); return; }
    // Cualquier usuario puede borrarla, en cualquier estado, pero siempre
    // confirmando. El aviso avisa si ya estaba firmada o enviada al proveedor.
    var ref=(o.num_orden?o.num_orden+' — ':'')+(o.proveedor||'');
    var extra='';
    if(o.estado==='firmada') extra='\n\nOJO: esta orden YA FUE FIRMADA por gerencia.';
    else if(o.estado==='enviada_proveedor') extra='\n\nOJO: esta orden YA FUE ENVIADA AL PROVEEDOR.';
    if(!confirm('¿Seguro que desea eliminar la orden "'+ref+'"?'+extra+'\n\nEsta acción no se puede deshacer.')) return;
    var r=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(!r.ok){ var t=await r.text(); console.error('borrar firma',r.status,t); showT('No se pudo borrar'); return; }
    showT('Compra para firma borrada');
    _firmaCargarLista('compras'); _firmaActualizarBadge();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

function _firmaSetPaginas(v){
  var ns=String(v||'').split(/[,;\s]+/).map(function(x){ return parseInt(x,10); })
    .filter(function(n){ return !isNaN(n) && n>=1; });
  var out=[]; ns.forEach(function(n){ if(out.indexOf(n)<0) out.push(n); });
  window._firmaPaginasManual = out.length?out:null;
}

var _firmaCtx=null, _firmaDibujando=false, _firmaHayTrazo=false;
function _firmaInitCanvas(){
  var c=document.getElementById('firma-canvas'); if(!c) return;
  _firmaCtx=c.getContext('2d'); _firmaCtx.lineWidth=2.2; _firmaCtx.lineCap='round'; _firmaCtx.lineJoin='round'; _firmaCtx.strokeStyle='#0b2e5e'; _firmaHayTrazo=false;
  function pos(e){ var r=c.getBoundingClientRect(); var t=e.touches&&e.touches[0]; var cx=(t?t.clientX:e.clientX)-r.left; var cy=(t?t.clientY:e.clientY)-r.top; return {x:cx*(c.width/r.width), y:cy*(c.height/r.height)}; }
  function down(e){ e.preventDefault(); _firmaDibujando=true; var p=pos(e); _firmaCtx.beginPath(); _firmaCtx.moveTo(p.x,p.y); }
  function move(e){ if(!_firmaDibujando)return; e.preventDefault(); var p=pos(e); _firmaCtx.lineTo(p.x,p.y); _firmaCtx.stroke(); _firmaHayTrazo=true; }
  function up(){ _firmaDibujando=false; }
  c.onmousedown=down; c.onmousemove=move; window.addEventListener('mouseup',up);
  c.ontouchstart=down; c.ontouchmove=move; c.ontouchend=up;
}
function _firmaLimpiarCanvas(){ var c=document.getElementById('firma-canvas'); if(c&&_firmaCtx){ _firmaCtx.clearRect(0,0,c.width,c.height); _firmaHayTrazo=false; } }

// ═══════════════════════════════════════════════════════════════════════════
//  ESTAMPADO DE LA FIRMA
//  · Va en la ÚLTIMA página de cada proforma (la nuestra y la del proveedor),
//    abajo a la derecha, debajo del total.
//  · Siempre HORIZONTAL: si la página trae rotación (/Rotate 90, 180 o 270),
//    se compensa para que la firma se vea derecha y no de lado.
// ═══════════════════════════════════════════════════════════════════════════

// Convierte una posición "como se ve en pantalla" a coordenadas del PDF,
// devolviendo también el giro que hay que aplicar para que salga horizontal.
function _firmaPosEnPagina(page, Xd, Yd){
  var rot=0;
  try{ rot=((page.getRotation&&page.getRotation().angle)||0)%360; }catch(e){ rot=0; }
  if(rot<0) rot+=360;
  var w=page.getWidth(), h=page.getHeight();
  if(rot===90)  return {x:w-Yd, y:Xd,   ang:90,  Wd:h, Hd:w};
  if(rot===180) return {x:w-Xd, y:h-Yd, ang:180, Wd:w, Hd:h};
  if(rot===270) return {x:Yd,   y:h-Xd, ang:270, Wd:h, Hd:w};
  return {x:Xd, y:Yd, ang:0, Wd:w, Hd:h};
}

// Estampa firma + pie en una página concreta
function _firmaEstampar(PDFLib, page, png, texto, font){
  var med=_firmaPosEnPagina(page, 0, 0);
  var m=34;
  var sw=170, sh=sw*(png.height/png.width);
  if(sh>70){ sh=70; sw=sh*(png.width/png.height); }
  // Abajo a la derecha, dejando lugar para el pie de texto
  var Xd=med.Wd-sw-m, Yd=m+13;
  if(Xd<m) Xd=m;
  var p=_firmaPosEnPagina(page, Xd, Yd);
  page.drawImage(png,{ x:p.x, y:p.y, width:sw, height:sh, rotate:PDFLib.degrees(p.ang) });
  var t=_firmaPosEnPagina(page, Xd, m+2);
  var op={ x:t.x, y:t.y, size:7.5, rotate:PDFLib.degrees(t.ang) };
  if(font) op.font=font;
  try{ page.drawText(texto,op); }catch(e){}
}

// Páginas donde termina cada orden. Usa lo que detectó la revisión AI y,
// si no hay nada, firma solo la última página del archivo.
function _firmaPaginasDeFirma(o, totalPaginas){
  var pgs=[];
  try{
    var rv=o.revision_ia;
    if(typeof rv==='string') rv=JSON.parse(rv);
    var docs=(rv&&rv.data&&rv.data.documentos)||[];
    docs.forEach(function(d){
      var n=Number(d.pagina_final||0);
      if(n>=1 && n<=totalPaginas && pgs.indexOf(n)<0) pgs.push(n);
    });
  }catch(e){}
  // Override manual desde el modal de firma
  try{
    var manual=window._firmaPaginasManual;
    if(manual && manual.length) pgs=manual.filter(function(n){ return n>=1&&n<=totalPaginas; });
  }catch(e){}
  if(!pgs.length) pgs=[totalPaginas];
  return pgs.sort(function(a,b){return a-b;});
}

async function _firmaGenerarPDFFirmado(o, firmaPng){
  var esPdf=o.archivo_path && /\.pdf$/i.test(o.archivo_nombre||o.archivo_path||'');
  var nombre=(o._sufijo?('PI_Proveedor_Firmada_'):'Orden_Firmada_')
    +String(o.proveedor||'compra').replace(/[^\w]+/g,'_')+'_'+new Date().toISOString().slice(0,10)+'.pdf';
  if(esPdf){
    try{
      var PDFLib=await _ensurePdfLib();
      var url=DOCS_BASE+o.archivo_path.split('/').map(encodeURIComponent).join('/');
      var bytes=await fetch(url).then(function(r){return r.arrayBuffer();});
      var pdfDoc=await PDFLib.PDFDocument.load(bytes);
      var png=await pdfDoc.embedPng(_dataURLtoUint8(firmaPng));
      var font=null;
      try{ font=await pdfDoc.embedFont(PDFLib.StandardFonts.Helvetica); }catch(e){}
      var pages=pdfDoc.getPages();
      var texto='Firmado por '+((CU&&CU.name)||'')+' - '+new Date().toLocaleDateString('es');
      // En TODAS las páginas, al pie. Antes solo se firmaba la última de
      // cada proforma, y al proveedor le llegaban hojas sin firma: cualquiera
      // podía separar una página y quedarse sin constancia de la aprobación.
      var cuales=[];
      for(var _p=1;_p<=pages.length;_p++) cuales.push(_p);
      cuales.forEach(function(n){
        var pg=pages[n-1];
        if(pg) _firmaEstampar(PDFLib, pg, png, texto, font);
      });
      window._firmaPaginasUsadas=cuales;
      var out=await pdfDoc.save();
      return new File([out], nombre, {type:'application/pdf'});
    }catch(e){ console.warn('pdf-lib estampar fallo, genero PDF resumen:',e); }
  }
  var doc=new window.jspdf.jsPDF({unit:'pt',format:'letter',compress:true});
  var W=612,M=48,y=70;
  doc.setFont('helvetica','bold'); doc.setFontSize(15); doc.setTextColor(30,80,165);
  doc.text('KENNEDY CENTER CORP.',W/2,y,{align:'center'}); y+=22;
  doc.setFontSize(13); doc.setTextColor(0); doc.text('ORDEN DE COMPRA - APROBADA Y FIRMADA',W/2,y,{align:'center'}); y+=30;
  doc.setFontSize(10); doc.setFont('helvetica','normal');
  function line(l,v){ doc.setFont('helvetica','bold'); doc.text(String(l),M,y); doc.setFont('helvetica','normal'); doc.text(String(v==null?'':v),M+130,y); y+=20; }
  line('Proveedor:',o.proveedor); line('Descripcion:',o.descripcion); line('Departamento:',dL(o.dept||''));
  line('Monto total:',fmt(o.monto||0)); line('Unidades:',o.unidades||0); line('Solicitado por:',o.creado_por_nom);
  line('Fecha:',new Date().toLocaleDateString('es'));
  y+=16; doc.setFont('helvetica','bold'); doc.text('Firma de gerencia:',M,y); y+=8;
  try{ doc.addImage(firmaPng,'PNG',M,y,200,66); }catch(e){}
  y+=78; doc.setFont('helvetica','normal'); doc.setFontSize(9);
  doc.text('Firmado por '+((CU&&CU.name)||'')+' - '+new Date().toLocaleString('es'),M,y);
  if(o.archivo_nombre){ y+=16; doc.setTextColor(90); doc.text('Archivo original de la compra: '+o.archivo_nombre,M,y); }
  return new File([doc.output('blob')], nombre, {type:'application/pdf'});
}

async function _firmaFirmar(id){
  if(!_firmaHayTrazo){ showT('Dibuja tu firma primero'); return; }
  var o=window._firmaOrden||{}; var canvas=document.getElementById('firma-canvas'); if(!canvas) return;
  var firmaPng=canvas.toDataURL('image/png');
  showT('Generando orden firmada...');
  try{
    // Se firma NUESTRA orden y, si existe, también la PI del proveedor.
    // Cada una queda como archivo firmado aparte.
    var signedFile=await _firmaGenerarPDFFirmado(o, firmaPng);
    var path=await _subirDocStorage('firma_signed', o.dept||'gen', signedFile);
    if(!path){ showT('No se pudo subir la orden firmada'); return; }

    var path2=null, nombre2=null;
    if(o.archivo_path2){
      try{
        showT('Firmando también la PI del proveedor…');
        var o2=Object.assign({}, o, {
          archivo_path:o.archivo_path2,
          archivo_nombre:o.archivo_nombre2,
          _sufijo:'PI_PROVEEDOR',
          revision_ia:null            // las páginas de firma se recalculan para este archivo
        });
        var signed2=await _firmaGenerarPDFFirmado(o2, firmaPng);
        path2=await _subirDocStorage('firma_signed', o.dept||'gen', signed2);
        nombre2=signed2.name;
        if(!path2) showT('⚠ La orden se firmó, pero no se pudo subir la PI firmada');
      }catch(e){ console.warn('firmar PI proveedor:',e); showT('⚠ No se pudo firmar la PI del proveedor'); }
    }

    var patch={ estado:'firmada', firmado_por:(CU&&CU.name)||'', firmado_en:new Date().toISOString(),
                archivo_firmado_path:path, archivo_firmado_nombre:signedFile.name,
                archivo_firmado_path2:path2, archivo_firmado_nombre2:nombre2 };
    var r=await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',patch,['archivo_firmado_path2','archivo_firmado_nombre2']);
    if(!r.ok){ var t=await r.text(); console.error('firma patch',r.status,t); showT('No se pudo guardar la firma'); return; }
    // Ya está firmada: ahora sí se retira su aviso
    try{ _npCerrarFirma(o.num_orden||o.proveedor||''); }catch(e){}
    try{
      var para=o.creado_por_email||_firmaCorreoDe(o.creado_por);
      if(para){
        await fetch(SB+'/rest/v1/correos_queue',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({
          docnum:'FIRMA-'+id, para_email:para, proveedor:o.proveedor||'',
          asunto:'Orden firmada - '+(o.num_orden?o.num_orden+' - ':'')+(o.proveedor||''),
          cuerpo:'Hola '+((o.creado_por_nom||'').split(' ')[0]||'')+',\n\n'
            +'Tu compra ya fue revisada y firmada por '+((CU&&CU.name)||'gerencia')+'.\n\n'
            +'Detalle:\n'
            +(o.num_orden?('  - Orden: '+o.num_orden+'\n'):'')
            +'  - Proveedor: '+(o.proveedor||'')+'\n'
            +(o.descripcion?('  - Descripcion: '+o.descripcion+'\n'):'')
            +(o.monto?('  - Monto: '+fmt(o.monto)+'\n'):'')
            +(o.unidades?('  - Unidades: '+o.unidades+'\n'):'')
            +'  - Firmada el: '+new Date().toLocaleDateString('es')+'\n\n'
            +'Adjuntamos la orden firmada. Ya puedes enviarsela al proveedor.\n\n'
            +'Saludos,\n'
            +((CU&&CU.name)||'Gerencia')+'\n'
            +'Kennedy Center Corp.',
          adjunto_path:path, adjunto_nombre:signedFile.name,
          // Sale del buzón de QUIEN FIRMA. Sin esto el worker usaba la cuenta
          // por defecto (dan@) y el correo de Edy llegaba como de Dan (v724).
          de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
          estado:'pendiente', creado_por:(CU&&CU.name)||'', creado_en:new Date().toISOString()
        })});
      }
    }catch(e){ console.warn('correo firma:',e); }
    try{ addNotif(o.creado_por,'Tu compra '+(o.proveedor||'')+' fue firmada por '+((CU&&CU.name)||'gerencia'),'','ti-writing-sign'); }catch(e){}
    try{ _accRegistrar('accion','Firmó una compra', o.id||''); }catch(e){}
    showT('Firmada en la(s) página(s) '+((window._firmaPaginasUsadas||[]).join(', ')||'final')+'. Se notificó al comprador.');
    var mm=canvas.closest('div[style*=fixed]'); if(mm) mm.remove();
    _firmaCargarLista('gerencia'); _firmaActualizarBadge();
  }catch(e){ console.error('firmar:',e); showT('Error al firmar: '+(e.message||e)); }
}
async function _firmaRechazar(id){
  // Se pregunta SIEMPRE antes: rechazar avisa al comprador y deja la orden
  // marcada, y de un clic de más no se vuelve atrás.
  var o0=window._firmaOrden||{};
  if(!confirm('¿RECHAZAR esta compra?\n\n'
    +(o0.proveedor?('Proveedor: '+o0.proveedor+'\n'):'')
    +(o0.dkc?('DKC: '+o0.dkc+'\n'):'')
    +(o0.creado_por?('La pidió: '+o0.creado_por+'\n'):'')
    +'\nSe le avisa a quien la pidió y la orden queda marcada como rechazada.\n\n'
    +'Si lo que querías era firmarla, cancela y usa el botón de firmar.')) return;
  var motivo=prompt('Motivo del rechazo (se lo verá quien la pidió):')||'';
  if(motivo===null) return;
  try{
    var o=window._firmaOrden||{};
    await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id,{method:'PATCH',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({estado:'rechazada',motivo_rechazo:motivo,firmado_por:(CU&&CU.name)||'',firmado_en:new Date().toISOString()})});
    try{ addNotif(o.creado_por,'Tu compra '+(o.proveedor||'')+' fue rechazada'+(motivo?': '+motivo:''),'','ti-x'); }catch(e){}
    showT('Orden rechazada');
    var c=document.getElementById('firma-canvas'); if(c){ var mm=c.closest('div[style*=fixed]'); if(mm) mm.remove(); }
    _firmaCargarLista('gerencia'); _firmaActualizarBadge();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// ═══════════════════════════════════════════════════════════════════════════
//  AVISO DE ÓRDENES FIRMADAS
//  Al comprador le queda un círculo ROJO sobre "Nueva compra para firma" con
//  cuántas órdenes suyas firmó gerencia y él todavía no ha abierto. Se apaga
//  cuando abre la orden firmada (ahí se marca como recibida).
//  A gerencia le sigue saliendo el conteo naranja de lo que le falta firmar.
// ═══════════════════════════════════════════════════════════════════════════
var _firmaBadgeTimer=null;
window._firmaFirmadasVistas=null;

async function _firmaActualizarBadge(){
  try{
    if(!(CU&&(CU.role==='gerencia'||_esCompras()))) return;
    var esGer=(CU.role==='gerencia');
    var filtro=esGer
      ? (_deptFiltroURL()+'&estado=eq.pendiente')
      : (((CU&& _deptAcotado())?_deptFiltroURL():_filtroEquipo('creado_por'))+'&estado=eq.firmada&recibido_en=is.null');
    var r=await fetch(SB+'/rest/v1/ordenes_firma?select=id,proveedor,num_orden'+filtro+'&limit=300',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    _firmaPendCount=rows.length;

    // Aviso al comprador cuando aparecen órdenes firmadas nuevas
    if(!esGer){
      var ids=rows.map(function(x){return String(x.id);});
      if(window._firmaFirmadasVistas===null){
        window._firmaFirmadasVistas=ids;   // primera carga: solo pintar
      } else {
        var nuevas=rows.filter(function(x){ return window._firmaFirmadasVistas.indexOf(String(x.id))<0; });
        nuevas.forEach(function(x){
          var ref=(x.num_orden?x.num_orden+' ':'')+(x.proveedor||'');
          try{ addNotif(CU.id, '✍️ Tu compra '+ref+' fue FIRMADA por gerencia', '', 'ti-writing-sign'); }catch(e){}
        });
        if(nuevas.length){
          showT('✍️ '+(nuevas.length===1?'Tu compra fue firmada por gerencia':nuevas.length+' compras tuyas fueron firmadas'));
          try{ renderNP(); }catch(e){}
        }
        window._firmaFirmadasVistas=ids;
      }
    }

    _firmaPintarBadge(esGer);
  }catch(e){}
}

function _firmaPintarBadge(esGer){
  document.querySelectorAll('.nb').forEach(function(b){
    if((b.getAttribute('onclick')||'').indexOf("'nueva'")>=0){
      var ex=b.querySelector('.firma-badge'); if(ex) ex.remove();
      if(_firmaPendCount>0){
        var sp=document.createElement('span');
        sp.className='firma-badge '+(esGer?'':'nb-num');
        sp.textContent=(_firmaPendCount>99?'99+':_firmaPendCount);
        sp.title=esGer?(_firmaPendCount+' compra(s) por firmar')
                      :(_firmaPendCount+' orden(es) firmada(s) sin abrir');
        if(esGer){
          sp.style.cssText='background:#B45309;color:#fff;border-radius:10px;font-size:9px;padding:1px 6px;margin-left:5px;font-weight:700';
        }
        b.appendChild(sp);
      }
    }
  });
}

function _firmaBadgeIniciar(){
  window._firmaFirmadasVistas=null;
  _firmaActualizarBadge();
  if(_firmaBadgeTimer) clearInterval(_firmaBadgeTimer);
  _firmaBadgeTimer=setInterval(_firmaActualizarBadge, 45000);
}

function chkSAP(){const desc=document.getElementById('f-desc')?.value.trim();const box=document.getElementById('sap-alert');if(!box||!desc)return;const s=SAP_STOCK[desc];if(!s){box.style.display='none';return;}let h='',color='',bg='';if(s.status==='high'){color='#27500A';bg='#EAF3DE';h=`<strong>SAP: Stock alto — ${s.stock} und.</strong>`;}else if(s.status==='low'){color='#92400e';bg='#fef3c7';h=`<strong>SAP: Stock bajo — ${s.stock} und.</strong>`;}else{color='#993C1D';bg='#FAECE7';h=`<strong>SAP: Agotado.</strong>`;}box.innerHTML=`<div style="background:${bg};border-radius:var(--radius);padding:10px 12px;font-size:12px;color:${color}">${h}</div>`;box.style.display='block';}
function uploadF(id,msg){const z=document.getElementById(id);if(z){z.classList.add('uok');z.innerHTML=`<i class="ti ti-circle-check" style="font-size:18px;display:block;margin-bottom:3px"></i><div>${msg}</div>`;}}
function crearOrden(){const prov=document.getElementById('f-prov').value.trim();const dept=document.getElementById('f-dept').value||_deptPrimero();const valor=parseFloat(document.getElementById('f-valor').value)||0;const resp=document.getElementById('f-resp').value.trim();const desc=document.getElementById('f-desc').value.trim();if(!prov||!dept||!valor||!resp||!desc){showT('Completa los campos obligatorios (*)');return;}const id=`OC-2024-0${NID++}`;const uni=parseInt(document.getElementById('f-uni').value)||0;const fechaE=document.getElementById('f-fecha').value;let fechaEst='';if(fechaE){const dd=new Date(fechaE);fechaEst=dd.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});}orders.unshift({id,dept,prov,valor,abono:0,desc,alerta:false,resp,fechaCreacion:dateOnly(),fechaEst,uni,emoji:EMOJIS2[dept]||'📦',pend:true,completada:false});initP(id);stageProgress[id].pedido.startDate=dateOnly();addNotif('gerencia',`Nueva orden ${prov} — ${id} · ${dL(dept)}`,id,'ti-writing');showT(`Orden ${id} enviada`);go('ordenes');renderNP();}
// ═══════════════════════════════════════════════════════════════════════════
//  ÓRDENES NO SAP CON EL FLUJO COMPLETO
//  Una orden NO SAP se trabaja igual que una de SAP: mismas etapas, comentarios,
//  adjuntos, solicitudes de abono, artes, etc. Cuando entra a SAP lo único que
//  cambia es dónde aparece; el avance de las etapas se conserva porque se
//  migra de la clave del DKC a la del número de orden de SAP.
// ═══════════════════════════════════════════════════════════════════════════

// La orden NO SAP nace ya firmada por gerencia: la etapa "Pedido" queda
// completa con sus dos pasos y el proceso arranca en Depósito & Pago.
// Sin abono: los tres primeros pasos del depósito quedan hechos (solicitud,
// envío y comprobante) y la etapa se queda esperando en "Solicitud de final
// del balance", que es donde se paga el 100%.
async function _nsapMarcarSinAbono(ref){
  var stage=STAGES.find(function(s){ return s.key==='deposito'; });
  if(!stage) return;
  initP(ref);
  var sp=stageProgress[ref].deposito;
  var hoyIso=new Date().toISOString().slice(0,10);
  var hoyTxt=(typeof isoADisplay==='function')?isoADisplay(hoyIso):hoyIso;
  var HASTA=3;                       // 0,1,2 hechos; el 3 es el balance final
  sp.stepIdx=Math.max(sp.stepIdx||0, HASTA);
  if(!sp.stepDates) sp.stepDates=stage.steps.map(function(){ return ''; });
  if(!sp._isoPasos) sp._isoPasos=stage.steps.map(function(){ return ''; });
  for(var i=0;i<HASTA;i++){
    if(!sp.stepDates[i]) sp.stepDates[i]=hoyTxt;
    if(!sp._isoPasos[i]) sp._isoPasos[i]=hoyIso;
  }
  if(!sp.startDate){ sp.startDate=hoyTxt; sp._isoInicio=hoyIso; }
  try{ await guardarEtapa(ref,'deposito'); }catch(e){ console.warn('sin abono:',e); }
}

async function _nsapMarcarPedidoHecho(ref){
  var stage=STAGES.find(function(s){ return s.key==='pedido'; });
  if(!stage) return;
  initP(ref);
  var sp=stageProgress[ref].pedido;
  var hoyIso=new Date().toISOString().slice(0,10);
  var hoyTxt=(typeof isoADisplay==='function')?isoADisplay(hoyIso):hoyIso;
  sp.stepIdx=stage.steps.length;
  sp.startDate=hoyTxt;
  sp.stepDates=stage.steps.map(function(){ return hoyTxt; });
  sp._isoInicio=hoyIso;
  sp._isoPasos=stage.steps.map(function(){ return hoyIso; });
  try{ await guardarEtapa(ref,'pedido'); }catch(e){ console.warn('marcar pedido:',e); }
  // La siguiente etapa arranca hoy, para que se vea como pendiente de abono
  var dep=stageProgress[ref].deposito;
  if(dep && !dep._isoInicio){
    dep.startDate=hoyTxt; dep._isoInicio=hoyIso;
    try{ await guardarEtapa(ref,'deposito'); }catch(e){}
  }
}

// Convierte un registro de compras_pend_sap al formato que usa el detalle
function _ordenDesdePendSAP(p){
  if(!p) return null;
  var id=String(p.dkc||p.num_orden||'').trim();
  var total=Number(p.total)||0, abon=Number(p.abonado)||0;
  var items=p.items;
  if(typeof items==='string'){ try{ items=JSON.parse(items); }catch(e){ items=[]; } }
  items=Array.isArray(items)?items:[];
  var uni=items.reduce(function(a,it){ return a+(Number(it.cantidad)||0); },0);
  var desc=items.length
    ? (String(items[0].itemname||'').slice(0,60)+(items.length>1?(' +'+(items.length-1)+' más'):''))
    : ('Orden '+id);
  return {
    id:id,
    dept:p.dept||'otros',
    prov:p.proveedor||'-',
    valor:total,
    abono:abon,
    desc:desc,
    alerta:false,
    resp:p.cardcode||'',
    fechaCreacion:p.fecha||p.creado_en||'',
    // La fecha de ALTA, aparte de la de la proforma. El listado ordenaba por
    // la de la proforma, así que un borrador creado hoy con una proforma de
    // junio quedaba enterrado entre las viejas.
    _altaEn:(p.creado_en||''),
    _tocadaEn:(p.actualizado_en||p.creado_en||''),
    fechaEst:p.eta||'',
    uni:uni,
    emoji:deptEmoji(p.dept||'otros'),
    pend:false,
    completada:false,
    _estadoSap:'',
    _docstatus:'',
    vendorEmail:'',
    fechaAbono:p.fecha_abono||'',
    num_proveedor:p.dkc||p.num_orden||'',
    _noSap:true,          // marca para el resto del portal
    _pend:p               // registro original, por si hace falta
  };
}

// Busca una orden por id, primero en SAP y después en las NO SAP
function _ordenPorId(id){
  var o=(typeof orders!=='undefined'&&orders)?orders.find(function(x){return String(x.id)===String(id);}):null;
  if(o) return o;
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(id) || String(x.num_orden)===String(id);
  });
  return p?_ordenDesdePendSAP(p):null;
}

// Abre el detalle completo (con todas las etapas) de una orden NO SAP
function abrirDetalleNoSap(ref){
  var o=_ordenPorId(ref);
  if(!o){ showT('Orden no encontrada'); return; }
  // El detalle trabaja sobre `orders`: se agrega temporalmente si no está
  if(!orders.some(function(x){ return String(x.id)===String(o.id); })) orders.push(o);
  openDetail(o.id);
}

// ── Continuidad al pasar a SAP ──
// El avance vive en stageProgress[id]. Mientras la orden es NO SAP la clave es
// el DKC; en SAP pasa a ser el docnum. Esta función mueve el avance de una a
// otra para que no se pierda nada de lo ya trabajado.
async function _migrarEtapasNoSap(silencioso){
  if(typeof orders==='undefined' || !orders.length) return 0;
  var movidas=0;
  for(var i=0;i<orders.length;i++){
    var o=orders[i];
    if(o._noSap) continue;
    var dkc=String(o.num_proveedor||'').trim();
    if(!dkc) continue;
    var viejo=stageProgress[dkc];
    if(!viejo){
      // La referencia de SAP puede llevar prefijo ("DKC-26088") y el avance
      // haberse guardado con la clave de la orden NO SAP ("26088").
      var pend=(window._pendSAP||[]).find(function(p){
        var s=_ordenSapDeNoSap(p);
        return s && String(s.id)===String(o.id);
      });
      if(pend){
        var otra=String(pend.num_orden||pend.dkc||'').trim();
        if(otra && stageProgress[otra]){ dkc=otra; viejo=stageProgress[otra]; }
      }
    }
    if(!viejo) continue;
    if(String(dkc)===String(o.id)) continue;
    initP(o.id);
    var nuevo=stageProgress[o.id];
    var hubo=false;
    STAGES.forEach(function(st){
      var v=viejo[st.key]||{}, n=nuevo[st.key]||{};
      // Se conserva lo más avanzado de las dos claves
      if((Number(v.stepIdx)||0) > (Number(n.stepIdx)||0)){
        n.stepIdx=v.stepIdx; hubo=true;
        if(v.stepDates) n.stepDates=v.stepDates;
        if(v.startDate && !n.startDate) n.startDate=v.startDate;
      }
      if((v.comments||[]).length > (n.comments||[]).length){ n.comments=v.comments; hubo=true; }
      nuevo[st.key]=n;
    });
    if(hubo){
      movidas++;
      // Se reescriben las etapas con la clave nueva para que quede en la base
      for(var s=0;s<STAGES.length;s++){
        var k=STAGES[s].key;
        if((Number(nuevo[k].stepIdx)||0)>0){
          try{ await guardarEtapa(o.id, k); }catch(e){}
        }
      }
      // ── Los adjuntos ──────────────────────────────────────────────────
      // Se movían SOLO en memoria y solo la llave '__pendsap': al recargar,
      // la orden de SAP aparecía sin ningún documento porque en la base
      // seguían guardados con el número de la orden NO SAP.
      try{
        if(window._atts){
          // Todas las llaves de esa orden (cada etapa y cada subpaso tiene
          // la suya), conservando el sufijo
          Object.keys(window._atts).forEach(function(k){
            if(k.indexOf(dkc)!==0) return;
            var suf=k.slice(dkc.length);
            var nueva=o.id+suf;
            if(!window._atts[k] || !window._atts[k].length) return;
            window._atts[nueva]=_dedupDocs((window._atts[nueva]||[]).concat(window._atts[k]));
          });
        }
      }catch(e){ console.warn('[etapas] adjuntos en memoria:', e); }

      // Y en la base, que es lo que sobrevive a recargar la página
      try{
        var rd=await fetch(SB+'/rest/v1/compras_documentos?docnum=eq.'+encodeURIComponent(dkc),{
          method:'PATCH',
          headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({docnum:String(o.id)})
        });
        if(!rd.ok) console.warn('[etapas] no se pudieron mover los documentos de '+dkc+':', rd.status);
      }catch(e){ console.warn('[etapas] documentos:', e); }
      console.info('[etapas] avance migrado de '+dkc+' a la orden SAP '+o.id);
    }
  }
  if(movidas && !silencioso) showT('Se conservó el avance de '+movidas+' orden(es) que entraron a SAP');
  return movidas;
}

// Alterna el detalle de la orden entre modal normal y pantalla completa
function _ordenPantallaCompleta(){
  window._ordenFull=!window._ordenFull;
  document.body.classList.toggle('orden-full', !!window._ordenFull);
  try{ localStorage.setItem('ordenFull', window._ordenFull?'1':'0'); }catch(e){}
  var b=document.getElementById('ordenFullBtn');
  if(b){
    b.innerHTML='<i class="ti ti-'+(window._ordenFull?'arrows-minimize':'arrows-maximize')+'"></i>';
    b.title=window._ordenFull?'Volver al tamaño normal':'Pantalla completa';
  }
}

// Se recuerda la preferencia entre sesiones
try{
  if(localStorage.getItem('ordenFull')==='1'){
    window._ordenFull=true;
    document.addEventListener('DOMContentLoaded', function(){
      document.body.classList.add('orden-full');
    });
  }
}catch(e){}

function openDetail(id){
  // El icono del botón refleja el estado guardado
  setTimeout(function(){
    var b=document.getElementById('ordenFullBtn');
    if(b) b.innerHTML='<i class="ti ti-'+(window._ordenFull?'arrows-minimize':'arrows-maximize')+'"></i>';
  }, 0);
  // Si el usuario está mirando el costeo, no se reconstruye la pantalla:
  // reconstruirla cerraba esa ventana en medio de la descarga.
  if(document.getElementById('modalCostPrev')){
    console.log('[detalle] hay un costeo abierto: no se repinta');
    return;
  }
  const o=_ordenPorId(id);if(!o)return;initP(id);if(!firmas[id])firmas[id]={};const fd=firmas[id],sap=sapChip(o.desc),pPct=getPct(o),signed=fd['gerencia']?.signed;const sc=CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';let firmaHtml='';if(o.pend){firmaHtml=`<div class="firma-box"><div style="font-size:13px;font-weight:500;margin-bottom:10px;display:flex;align-items:center;gap:6px"><span class="sem sem-y"></span>Revisión y firma</div><div class="po-card"><div style="font-size:26px;color:#e24b4a"><i class="ti ti-file-text"></i></div><div style="flex:1"><div style="font-size:13px;font-weight:500">PO-${id}.pdf</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">${o.prov} · ${o.desc}</div>${sc?`<div style="font-size:11px;color:var(--text-muted);margin-top:2px">${fmt(o.valor)} total</div>`:''}</div><span class="po-btn"><i class="ti ti-eye" style="font-size:11px"></i> Ver</span></div>${CU.role==='gerencia'&&!signed?`<div class="lbl2"><i class="ti ti-pencil"></i>Firma digital</div><canvas id="fc" width="570" height="90"></canvas><div class="br"><button class="btn bg2" onclick="CC()"><i class="ti ti-eraser"></i>Limpiar</button><button class="btn bd" onclick="rejOrden('${id}')"><i class="ti ti-x"></i>Rechazar</button><button class="btn bs" onclick="signOrden('${id}')"><i class="ti ti-check"></i>Aprobar y firmar</button></div>`:CU.role==='gerencia'&&signed?`<div class="aps" style="margin-top:8px;display:inline-flex"><i class="ti ti-circle-check"></i>Firmada por ${fd['gerencia'].by}</div>`:`<div style="font-size:12px;color:var(--text-muted);padding:8px;background:var(--surface-2);border-radius:var(--radius);margin-top:8px">Pendiente firma de gerencia.</div>`}</div>`;}else{firmaHtml=`<div style="padding:8px 12px;background:var(--bg-success);border-radius:var(--radius);margin-bottom:12px;font-size:12px;color:var(--text-success);font-weight:500;display:flex;align-items:center;gap:6px"><span class="sem sem-g"></span>${o.completada?'Proceso completado':'Orden aprobada — activa'}${fd['gerencia']?.signed?' · Firmada por '+fd['gerencia'].by:''}</div>`;}const visibleSts=stagesForUser();const sp=stageProgress[id];const si=getStageIdx(o);const stagesHtml=visibleSts.map(stage=>{const idx=STAGES.indexOf(stage);const stepsDone=sp[stage.key].stepIdx,stepsTotal=stage.steps.length,isDone=stepsDone>=stepsTotal;const isCurr=!o.completada&&!o.pend&&idx===si;const semClass=isDone?'sem-g':isCurr?'sem-y':'sem-r';const groupClass=isDone?'done':isCurr?'active':'';const startDate=sp[stage.key].startDate||'';const endDate=isDone?(sp[stage.key].stepDates?.[stepsTotal-1]||''):'';const daysIn=startDate?daysBetween(startDate,endDate||null):0;const nc=sp[stage.key].comments?.length||0;return`<div class="eg ${groupClass}" id="eg-${id}-${idx}"><div class="eg-hdr" onclick="toggleEG('${id}',${idx})"><span class="sem ${semClass}"></span><i class="ti ${stage.icon}" style="font-size:13px;color:${stage.color}"></i><div style="flex:1"><div style="font-size:12px;font-weight:500">${stage.label}</div><div style="font-size:10px;color:var(--text-muted);display:flex;gap:5px;flex-wrap:wrap;margin-top:1px">${startDate?`<span style="background:var(--bg-accent);color:var(--text-accent);padding:1px 6px;border-radius:6px;font-size:9px">Inicio: ${startDate}</span>`:''}${endDate&&isDone?`<span style="background:var(--bg-success);color:var(--text-success);padding:1px 6px;border-radius:6px;font-size:9px">Fin: ${endDate} · ${daysIn}d</span>`:!isDone&&isCurr&&startDate?`<span style="background:var(--bg-danger);color:var(--text-danger);padding:1px 6px;border-radius:6px;font-size:9px">${daysIn}d en progreso</span>`:''}<span>${stage.resp}</span>${nc>0?`<span style="color:var(--text-accent)">${nc} com.</span>`:''}<span id="egnl-${id}-${idx}">${_comBadgeNoLeido(id,stage.key)}</span></div></div><div style="display:flex;align-items:center;gap:5px"><button class="btn" title="Enviar correo sobre esta etapa" onclick="event.stopPropagation();mailAbrir('${id}','${stage.key}',null)" style="padding:3px 7px;font-size:10px;background:transparent;border:0.5px solid var(--border)"><i class="ti ti-mail" style="font-size:12px;color:var(--text-accent)"></i></button><span style="font-size:10px;color:var(--text-muted)">${stepsDone}/${stepsTotal}</span>${isDone?'<span style="font-size:10px;background:var(--bg-success);color:var(--text-success);padding:1px 6px;border-radius:8px;font-weight:500">✓</span>':''}<i class="ti ti-chevron-down eg-chev" id="egch-${id}-${idx}"></i></div></div><div class="eg-body" id="egb-${id}-${idx}"></div></div>`;}).join('');// Otras ordenes del proveedor
  const otrasAct=orders.filter(x=>x.prov===o.prov&&x.id!==o.id&&!x.completada);
  const otrasComp=orders.filter(x=>x.prov===o.prov&&x.id!==o.id&&x.completada);
  const otrasHtml=(otrasAct.length||otrasComp.length)?`<div style="margin-top:7px;padding:7px 10px;background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius)"><div style="font-size:10px;font-weight:600;color:var(--text-accent);margin-bottom:5px;display:flex;align-items:center;gap:5px"><i class="ti ti-packages" style="font-size:10px"></i> Otras órdenes de este proveedor <span style="background:var(--fill-accent);color:white;border-radius:8px;padding:0 7px;font-size:9px;font-weight:700">${otrasAct.length+otrasComp.length+1} en total</span></div><div style="display:flex;gap:5px;flex-wrap:wrap">${otrasAct.map(x=>`<span onclick="CM();setTimeout(()=>openDetail('`+x.id+`'),80)" style="font-size:10px;padding:2px 9px;background:var(--fill-accent);color:white;border-radius:8px;cursor:pointer">#`+x.id+` `+dL(x.dept)+`</span>`).join('')}${otrasComp.map(x=>`<span onclick="CM();setTimeout(()=>openDetail('`+x.id+`'),80)" style="font-size:10px;padding:2px 9px;background:#534AB7;color:white;border-radius:8px;cursor:pointer">✓ #`+x.id+`</span>`).join('')}</div></div>`:'';
  document.getElementById('mc').innerHTML=`<div class="mt"><div style="font-size:30px">${o.emoji}</div><div style="flex:1"><div style="font-size:14px;font-weight:500">${o.prov} — <span onclick="openPoLines('${o.id}')" title="Ver líneas detalle" style="cursor:pointer;color:var(--text-accent);text-decoration:underline;text-underline-offset:2px">${o.id}</span>${o.num_proveedor?` <span style="color:var(--t-ambar);font-weight:700" title="N.º de orden del portal (DKC / SKC / HIKC)">· ${o.num_proveedor}</span>`:''}</div>
${o.vendorEmail?`<div style="font-size:11px;margin-top:3px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">
  <i class="ti ti-mail" style="font-size:11px;color:var(--text-muted)"></i>
  <a href="mailto:${o.vendorEmail}?subject=OC ${o.id} - ${o.prov}&body=Estimados ${o.prov},%0D%0A%0D%0AHacemos referencia a la orden de compra ${o.id}.%0D%0A%0D%0ASaludos,%0D%0A${CU?CU.name:''}" style="color:var(--text-accent);font-size:11px;text-decoration:underline;cursor:pointer">${o.vendorEmail}</a>
</div>`:''}<div style="font-size:11px;color:var(--text-muted);margin-top:2px">${dL(o.dept)} · ${o.desc} · ${o.uni?.toLocaleString()||0} und · ${o.resp}</div><div style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>Creado: ${o.fechaCreacion}</span>${o.fechaEst?`<span class="fecha-badge"><i class="ti ti-calendar-due" style="font-size:10px"></i>ETA: ${o.fechaEst}</span>`:''}${o.completada?`<span class="fecha-badge ok"><i class="ti ti-circle-check" style="font-size:10px"></i>Completada</span>`:''}</div>${sap?`<div style="margin-top:5px">${sap}</div>`:''}${sc?`<div style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap">
  <div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:7px 12px;min-width:110px">
    <div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Total Orden</div>
    <div style="font-size:15px;font-weight:700;color:var(--text-primary);margin-top:2px">${fmt(o.valor)}</div>
  </div>
  <div onclick="_verCompPago('${id}','abono')" title="${_hayCompPago(id,'abono')?'Ver el comprobante del abono':'Todavía no hay comprobante del abono'}"
       style="background:var(--bg-success);border:0.5px solid var(--border-success);border-radius:8px;padding:7px 12px;min-width:110px;cursor:pointer">
    <div style="font-size:9px;color:var(--text-success);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Abonado · ${pct(o.abono,o.valor)}% ${_hayCompPago(id,'abono')?'<i class="ti ti-paperclip" style="font-size:10px"></i>':''}</div>
    <div style="font-size:15px;font-weight:700;color:var(--text-success);margin-top:2px">${fmt(o.abono)}</div>
  </div>
  <div onclick="_verCompPago('${id}','cancelacion')" title="${_hayCompPago(id,'cancelacion')?'Ver el comprobante del pago final':'Todavía no hay comprobante del pago final'}"
       style="background:var(--bg-danger);border:0.5px solid var(--border-danger);border-radius:8px;padding:7px 12px;min-width:110px;cursor:pointer">
    <div style="font-size:9px;color:var(--text-danger);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Saldo · ${pct(o.valor-o.abono,o.valor)}% ${_hayCompPago(id,'cancelacion')?'<i class="ti ti-paperclip" style="font-size:10px"></i>':''}</div>
    <div style="font-size:15px;font-weight:700;color:var(--text-danger);margin-top:2px">${fmt(o.valor-o.abono)}</div>
  </div>
</div>`:''}${otrasHtml}</div><button id="ordenFullBtn" class="orden-full-btn" onclick="_ordenPantallaCompleta()" title="Pantalla completa"><i class="ti ti-arrows-maximize"></i></button><button class="cb" onclick="CM()">×</button></div><div class="mb">${_revBarraOrden(o)}${_frBarraOrden(o)}${_mrBarraOrden(o)}${_ocBarraSubirSap(o)}${_ocPendPanelOrden(o)}${_entResumenSeguro(o.id)}${_pcsBarraOrden(o)}${_docsBarraOrden(o)}<div style="margin-bottom:12px"><div style="display:flex;justify-content:space-between;font-size:11px;color:var(--text-muted);margin-bottom:4px"><span>Progreso general</span><span>${pPct}%</span></div><div style="height:6px;background:var(--border);border-radius:3px;overflow:hidden"><div style="height:100%;border-radius:3px;background:${o.completada?'#534AB7':'#1D9E75'};width:${pPct}%"></div></div></div>${firmaHtml}<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px"><i class="ti ti-info-circle" style="font-size:11px"></i> Clic en cualquier etapa — puedes revertir pasos con el botón ↩</div><div>${stagesHtml}</div>${!o.completada&&!o.pend&&getPct(o)>=85?`<div style="margin-top:12px"><button class="btn bs" onclick="markComplete('${id}')"><i class="ti ti-circle-check"></i>Marcar proceso completo</button></div>`:''}</div>`;document.getElementById('modal').style.display='flex';if(o.pend)initC();setTimeout(()=>toggleEG(id,si,true),80);
  // La cabecera cambia de alto según el proveedor y los recuadros: se mide de
  // verdad para que el cuerpo sepa cuánto espacio le queda y la última etapa
  // no se corte.
  setTimeout(function(){
    try{
      var md=document.querySelector('#modal .md');
      var hd=md&&md.querySelector('.mh, .mhd, .md > div');
      if(hd) document.documentElement.style.setProperty('--orden-hdr', (hd.offsetHeight+18)+'px');
    }catch(e){}
  }, 120);
  // Carga los documentos ya guardados de esta orden (todas sus etapas) y refresca
  cargarDocsOrden(id).then(function(){
    var abierta=document.querySelector('#modal .eg-body.open');
    if(abierta){ var m=abierta.id.match(/egb-(.+)-(\d+)$/); if(m) buildEGB(m[1], parseInt(m[2]), abierta); }
  });
}
// ═══════════════════════════════════════════════════════════════════════════
//  COMENTARIOS EN VIVO
//  Mientras una etapa está abierta se relee `compras_comentarios` cada pocos
//  segundos, así lo que escribe otra persona aparece solo, sin tener que salir
//  y volver a entrar a la orden.
// ═══════════════════════════════════════════════════════════════════════════
var _comPollTimer=null;

function _comIniciarPoll(){
  if(_comPollTimer) return;
  _comPollTimer=setInterval(_comPollTick, 6000);
}
function _comDetenerPoll(){
  if(_comPollTimer){ clearInterval(_comPollTimer); _comPollTimer=null; }
}
function _comPollTick(){
  var abiertos=document.querySelectorAll('.eg-body.open');
  var subs=document.querySelectorAll('[id^="subcms-"]');
  if(!abiertos.length && !subs.length){ _comDetenerPoll(); return; }
  Array.prototype.forEach.call(abiertos, function(el){
    var m=String(el.id||'').match(/^egb-(.+)-(\d+)$/);
    if(!m) return;
    var st=STAGES[Number(m[2])];
    if(st) _comRefrescar(m[1], st.key);
  });
  // Los comentarios de cada PASO (no solo los de la etapa): antes solo se
  // veían al recargar la página.
  Array.prototype.forEach.call(subs, function(el){
    var m=String(el.id||'').match(/^subcms-(.+)-(\d+)-(\d+)$/);
    if(!m) return;
    _comRefrescarSub(m[1], Number(m[2]), Number(m[3]));
  });
}

// Relee los comentarios de un paso y repinta solo si hay algo nuevo
async function _comRefrescarSub(oid, idx, i){
  var stage=STAGES[idx]; if(!stage) return;
  var subKey=stage.key+'_step'+i;
  var comKey='sub_'+oid+'_'+subKey;
  try{
    var r=await fetch(SB+'/rest/v1/compras_comentarios'
      +'?select=autor,autor_rol,texto,creado_en'
      +'&docnum=eq.'+encodeURIComponent(oid)
      +'&etapa=eq.'+encodeURIComponent(subKey)
      +'&order=creado_en.asc&limit=300',{headers:SBH});
    if(!r.ok) return;
    var rows=await r.json();
    if(!Array.isArray(rows)) return;
    var lista=rows.map(function(c){
      return {autor:(c.autor||'')+(c.autor_rol?(' ('+c.autor_rol+')'):''),
              ini:String(c.autor||'--').slice(0,2).toUpperCase(),
              texto:c.texto, by:c.autor||'', role:c.autor_rol||'',
              time:(typeof isoADisplay==='function'?isoADisplay(c.creado_en):(c.creado_en||''))};
    });
    window._subComs=window._subComs||{};
    var actual=window._subComs[comKey]||[];
    var firma=function(a){
      return a.map(function(x){ return (x.autor||'')+'|'+(x.texto||''); }).join('\u0001'); };
    if(firma(lista)===firma(actual)) return;
    if(lista.length<actual.length) return;   // lo recién escrito aún no llegó
    window._subComs[comKey]=lista;
    var el=document.getElementById('subcms-'+oid+'-'+idx+'-'+i);
    if(el) el.innerHTML=renderSubComs(comKey);
    try{ _comPintarBadgesEtapas(oid); }catch(e){}
  }catch(e){}
}

// Relee los comentarios de una etapa y repinta solo si algo cambió
async function _comRefrescar(oid, stageKey, forzar){
  try{
    var url=SB+'/rest/v1/compras_comentarios?select=autor,autor_rol,texto,creado_en'
      +'&docnum=eq.'+encodeURIComponent(oid)
      +'&etapa=eq.'+encodeURIComponent(stageKey)
      +'&order=creado_en.asc&limit=300';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok) return;
    var rows=await r.json();
    if(!Array.isArray(rows)) return;

    initP(oid);
    var lista=rows.map(function(c){
      return {
        autor:(c.autor||'')+(c.autor_rol?(' ('+c.autor_rol+')'):''),
        ini:String(c.autor||'--').slice(0,2).toUpperCase(),
        texto:c.texto,
        time:(typeof isoADisplay==='function'?isoADisplay(c.creado_en):(c.creado_en||''))
      };
    });

    var actual=stageProgress[oid][stageKey].comments||[];
    var firma=function(a){ return a.map(function(x){return (x.autor||'')+'|'+(x.texto||'');}).join('\u0001'); };
    if(!forzar && firma(lista)===firma(actual)) return;
    // Si el servidor trae menos que lo que ya se ve, es que el comentario recién
    // escrito todavía no llegó: no se pisa lo local para que no parpadee.
    if(!forzar && lista.length<actual.length) return;

    var hayNuevos=lista.length>actual.length;
    stageProgress[oid][stageKey].comments=lista;
    _comRepintar(oid, stageKey);

    if(hayNuevos){
      // Estoy viendo la etapa, así que lo que llegó ya cuenta como leído
      if(_comNoLeidoEtapa(oid, stageKey)){
        marcarComLeido(oid, stageKey);
        _comPintarBadgesEtapas(oid);
        renderNP();
      }
      var box=document.getElementById('cms-'+oid+'-'+stageKey);
      if(box) box.scrollTop=box.scrollHeight;
      // Aviso discreto si el último no es mío
      var ult=lista[lista.length-1];
      var mio=(CU&&CU.name)||'\u0000';
      if(ult && String(ult.autor||'').indexOf(mio)!==0) showT('💬 '+ult.autor+' comentó');
    }
  }catch(e){}
}

function toggleEG(oid,idx,forceOpen=false){const body=document.getElementById(`egb-${oid}-${idx}`);const chev=document.getElementById(`egch-${oid}-${idx}`);if(!body)return;if(!forceOpen&&body.classList.contains('open')){body.classList.remove('open');chev&&chev.classList.remove('open');return;}body.classList.add('open');chev&&chev.classList.add('open');buildEGB(oid,idx,body);const _st=STAGES[idx];if(_st){_comRefrescar(oid,_st.key);_comIniciarPoll();}if(_st&&_comNoLeidoEtapa(oid,_st.key)){marcarComLeido(oid,_st.key);setTimeout(function(){_comRepintar(oid,_st.key);if(typeof rAlertas==='function'&&PG==='alertas')rAlertas();renderNP();_comPintarBadgesEtapas(oid);},150);}}

// ─── FIX 4: Panel lateral líneas de OC ───
var _poCache={};
// Para las órdenes NO SAP: trae foto y descripción del inventario. Los SKU que
// todavía no existen en SAP se completan desde el catálogo NO SAP, que es
// donde vive su descripción mientras SAP no los da de alta.
async function _poCompletarDesdeInventario(lineas){
  var codes=(lineas||[]).map(function(l){return String(l.itemcode||'').trim();}).filter(Boolean);
  if(!codes.length) return;
  var mp={};
  try{
    var inList=Array.from(new Set(codes)).map(function(c){return '"'+c.replace(/"/g,'')+'"';}).join(',');
    var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,picturname,onhand,iscommited&itemcode=in.('+encodeURIComponent(inList)+')&limit=500',{headers:SBH});
    if(r.ok) (await r.json()||[]).forEach(function(x){ mp[String(x.itemcode).toUpperCase()]=x; });
  }catch(e){ console.warn('completar lineas BORRADOR:',e); }
  // Los que no están en SAP: su descripción vive en el catálogo NO SAP
  var faltan=(lineas||[]).filter(function(l){ return !mp[String(l.itemcode||'').toUpperCase()]; });
  var cat={};
  if(faltan.length){
    // Primero lo que ya está en memoria. Se incluyen las fichas degradadas
    // (tipo 'foto'): ya no son artículos del catálogo, pero guardan la única
    // imagen que existe de un SKU que en SAP todavía no tiene la suya.
    (window._catNoSap||[]).forEach(function(c){
      if(c.itemcode && c.tipo!=='proveedor') cat[String(c.itemcode).toUpperCase()]=c;
    });
    // Y si falta alguno, se consulta la tabla
    var sinDato=faltan.filter(function(l){ return !cat[String(l.itemcode||'').toUpperCase()]; });
    if(sinDato.length){
      try{
        var lst=Array.from(new Set(sinDato.map(function(l){return String(l.itemcode||'').trim();}).filter(Boolean)))
                 .map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
        if(lst){
          var rc=await fetch(SB+'/rest/v1/catalogo_nosap?select=itemcode,itemname,foto,colores,tipo&tipo=in.(item,foto)&itemcode=in.('
            +encodeURIComponent(lst)+')&limit=500',{headers:SBH});
          if(rc.ok) (await rc.json()||[]).forEach(function(c){ cat[String(c.itemcode).toUpperCase()]=c; });
        }
      }catch(e){ console.warn('catalogo BORRADOR para lineas:',e); }
    }
  }

  lineas.forEach(function(l){
    var cod=String(l.itemcode||'').toUpperCase();
    var inv=mp[cod];
    if(inv){
      l.picturname=inv.picturname||'';
      if(!l.dscription) l.dscription=inv.itemname||'';
      l._enSap=true;
      // Está en SAP pero sin foto propia: se usa la del proveedor, que para
      // eso se conservó. Antes se salía aquí y la línea quedaba con el
      // cuadrito gris aunque la imagen existiera del otro lado.
      if(!l.picturname){
        var cs=cat[cod];
        var _u=cs && (cs.foto || cs.foto_url || cs.imagen_url);
        if(_u) l._fotoUrl=_fotoNoSapUrl(_u);
      }
      return;
    }
    l._enSap=false;   // SKU nuevo, todavía no está en SAP
    var c=cat[cod];
    if(c){
      if(!l.dscription) l.dscription=c.itemname||'';
      var _uc=c.foto || c.foto_url || c.imagen_url;
      if(_uc) l._fotoUrl=_fotoNoSapUrl(_uc);
      if(c.colores) l.colores=c.colores;
    }
    // Si aun así no hay descripción, al menos no queda la celda vacía
    if(!l.dscription) l.dscription='(sin descripción)';
  });
}
async function openPoLines(docnum){
  var _verPrecio=CU&&CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';
  var ex=document.getElementById('po-panel');
  if(ex){ex.remove();return;}
  var panel=document.createElement('div');
  panel.id='po-panel';
  panel.style.cssText='position:fixed;top:0;right:0;width:min(420px,96vw);height:100vh;background:var(--surface-2);border-left:1px solid var(--border);z-index:250;overflow-y:auto;box-shadow:-6px 0 24px rgba(0,0,0,.18)';
  var hdr=document.createElement('div');
  hdr.style.cssText='position:sticky;top:0;z-index:2;padding:13px 15px;border-bottom:0.5px solid var(--border);background:var(--surface-1);display:flex;align-items:center;gap:8px';
  hdr.innerHTML='<i class="ti ti-file-invoice" style="color:var(--text-accent);font-size:15px"></i>'
    +'<span style="font-size:13px;font-weight:600">OC #'+docnum+'</span>'
    +_catBtnOrdenSAP(docnum)
    +_smBtn(docnum);
  var closeBtn=document.createElement('button');
  closeBtn.innerHTML='&times;';
  closeBtn.style.cssText='margin-left:auto;background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1';
  closeBtn.onclick=function(){panel.remove();};
  hdr.appendChild(closeBtn);
  panel.appendChild(hdr);
  // Los shipping marks enviados quedan guardados con el número de ESTA orden.
  // Se muestran aquí, que es donde está el botón que los mandó.
  var smBox=document.createElement('div');
  smBox.id='po-sm';
  smBox.style.cssText='padding:0 14px';
  panel.appendChild(smBox);
  (async function(){
    try{
      await cargarDocsOrden(String(docnum));
      if(!document.body.contains(panel)) return;
      smBox.innerHTML=_smGuardadosHTML(docnum);
    }catch(e){ console.warn('[orden] shipping marks:', e); }
  })();

  var body=document.createElement('div');
  body.id='po-body';
  body.style.cssText='padding:14px';
  body.innerHTML='<div style="text-align:center;padding:30px;color:var(--text-muted)"><i class="ti ti-loader-2 spin" style="font-size:24px"></i><br><br>Cargando líneas SAP...</div>';
  panel.appendChild(body);
  document.body.appendChild(panel);
  try{
    if(!_poCache[docnum]){
      // Las órdenes NO SAP no viven en opor_lineas: sus artículos están en el
      // registro de compras_pend_sap que se creó al darlas de alta.
      var pNoSap=(window._pendSAP||[]).find(function(x){
        return String(x.dkc)===String(docnum) || String(x.num_orden)===String(docnum);
      });
      if(pNoSap){
        var its=pNoSap.items;
        if(typeof its==='string'){ try{ its=JSON.parse(its); }catch(e){ its=[]; } }
        its=Array.isArray(its)?its:[];
        _poCache[docnum]=its.map(function(it,i){
          var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
          return {
            linenum:i, itemcode:it.itemcode||'', item_code:it.itemcode||'',
            // La tarjeta del detalle imprime l.itemname. Aquí solo se ponía
            // dscription, así que salía "Artículo 1", "Artículo 2"… en vez
            // del nombre que sacó la IA.
            itemname:it.itemname||'', dscription:it.itemname||'',
            cantidad:cant, quantity:cant, precio_unit:pu, price:pu,
            total_linea:Number(it.total_linea)||(cant*pu),
            // La foto y la ficha que sacó la IA al crear la orden. Antes este
            // mapeo copiaba solo seis campos y tiraba el resto: el artículo
            // todavía no está en SAP, así que _poCompletarDesdeInventario no
            // encontraba nada y el detalle salía sin foto y sin descripción.
            foto:it._foto||it.foto||it.foto_url||'',
            foto_url:it.foto_url||'',
            picturname:it.picturname||'',
            descripcion:it.descripcion||'',
            material:it.material||'', color:it.color||'',
            tamano:it.tamano||'', empaque:it.empaque||'',
            carton_size:it.carton_size||'', barcode:it.barcode||'',
            marca:it.marca||'', unidades_x_caja:it.unidades_x_caja||'',
            cbm:it.cbm||'', peso:it.peso||'',
            _noSap:true
          };
        });
        // Se completa con las fotos y descripciones que haya en el inventario
        try{ await _poCompletarDesdeInventario(_poCache[docnum]); }catch(e){}
      } else {
        var r=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'+docnum+'&order=linenum.asc',{headers:SBH});
        _poCache[docnum]=r.ok?(await r.json()):[];
        if(!Array.isArray(_poCache[docnum]))_poCache[docnum]=[];
        // El worker solo guarda las líneas de las órdenes PENDIENTES. Cuando
        // la orden ya está facturada del todo, no hay nada ahí y el panel
        // salía vacío aunque la orden tuviera sus artículos. Se recuperan de
        // la factura reserva, que es la misma mercancía.
        if(!_poCache[docnum].length){
          try{
            var rf=await fetch(SB+'/rest/v1/opch_reserva?select=docentry,docnum'
              +'&ordenes=like.*'+docnum+'*&limit=10',{headers:SBH});
            var frs=(rf.ok?((await rf.json())||[]):[]);
            var acum=[];
            for(var q=0;q<frs.length;q++){
              var rl=await fetch(SB+'/rest/v1/opch_reserva_lineas?select=*&docentry=eq.'
                +frs[q].docentry+'&order=linenum',{headers:SBH});
              if(!rl.ok) continue;
              (await rl.json()||[]).forEach(function(l){
                acum.push({
                  linenum:acum.length,
                  itemcode:l.itemcode||'', item_code:l.itemcode||'',
                  itemname:l.dscription||'', dscription:l.dscription||'',
                  cantidad:Number(l.cantidad)||0, quantity:Number(l.cantidad)||0,
                  precio:Number(l.precio)||0, price:Number(l.precio)||0,
                  total_linea:Number(l.total_linea)||0,
                  _deFactura:frs[q].docnum
                });
              });
            }
            if(acum.length){
              _poCache[docnum]=acum;
              try{ await _poCompletarDesdeInventario(_poCache[docnum]); }catch(e){}
              _dbg('[OC] líneas tomadas de la factura reserva: '+acum.length);
            }
          }catch(e){ _dbg('[OC] líneas por factura: '+(e.message||e)); }
        }
      }
    }
    var lines=_poCache[docnum];
    if(!lines.length){
      var esNoSap=(window._pendSAP||[]).some(function(x){ return String(x.dkc)===String(docnum)||String(x.num_orden)===String(docnum); });
      body.innerHTML='<div class="empty" style="padding:24px"><i class="ti ti-inbox" style="font-size:28px"></i><br>'
        +(esNoSap
          ?'Esta orden BORRADOR se guardó sin productos.<br><span style="font-size:11px">Puedes agregárselos con <b>Editar orden</b>.</span>'
          :'Sin líneas para esta orden<br><span style="font-size:11px">El portal '
           +'guarda las líneas de las órdenes <b>pendientes</b>. Si ya está '
           +'facturada del todo, mira la factura reserva en el mapa de '
           +'relaciones.</span>')
        +'</div>';
      return;
    }
    var total=lines.reduce(function(s,l){return s+(parseFloat(l.total_linea)||parseFloat(l.precio_linea)||0);},0);
    // Si la orden salió de una reposición, arriba de los artículos va el
    // registro de en qué se apartó de lo que se había pedido.
    // Las diferencias con la reposición NO van aquí: se abren desde la etiqueta
    // de la orden en el listado, que es donde se buscan.
    body.innerHTML='<div style="font-size:11px;color:var(--text-muted);margin-bottom:10px">'+lines.length+' artículos'+(_verPrecio?' &middot; Total: <strong style="color:var(--text-primary)">'+fmt(total)+'</strong>':'')+'</div>';
    lines.forEach(function(l,i){
      var card=document.createElement('div');
      card.style.cssText='background:var(--surface-1);border:0.5px solid var(--border);border-radius:9px;margin-bottom:9px;overflow:hidden';
      var variantes=fotoVariantes(l);
      var pu=parseFloat(l.precio)||parseFloat(l.precio_unitario)||parseFloat(l.precio_unit)||0;
      var qty=parseFloat(l.cantidad)||0;
      var tot=parseFloat(l.total_linea)||parseFloat(l.precio_linea)||(pu*qty);
      var row=document.createElement('div');
      row.style.cssText='display:flex;gap:10px;padding:10px 11px;align-items:flex-start';
      // imagen
      var imgEl;
      if(variantes.length){
        imgEl=document.createElement('img');
        var _vi=0;
        imgEl.src=variantes[0];
        imgEl.style.cssText='width:62px;height:62px;object-fit:cover;border-radius:6px;cursor:zoom-in;flex-shrink:0;border:0.5px solid var(--border)';
        imgEl.title='Click para zoom';
        imgEl.onclick=function(){ if(imgEl.src) zoomImg(imgEl.src); };
        // Prueba cada variante (nombre tal cual, minúscula, mayúscula, foto_url).
        // Si todas fallan, muestra 📦.
        imgEl.onerror=function(){
          _vi++;
          if(_vi < variantes.length){ imgEl.src=variantes[_vi]; return; }
          var ph=document.createElement('div');
          ph.style.cssText='width:62px;height:62px;background:var(--surface-0);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:28px;flex-shrink:0;border:0.5px solid var(--border)';
          ph.textContent='📦';
          if(imgEl.parentNode) imgEl.parentNode.replaceChild(ph, imgEl);
        };
      } else {
        imgEl=document.createElement('div');
        imgEl.style.cssText='width:62px;height:62px;background:var(--surface-0);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:28px;flex-shrink:0;border:0.5px solid var(--border)';
        imgEl.textContent='📦';
      }
      row.appendChild(imgEl);
      var info=document.createElement('div');
      info.style.cssText='flex:1;min-width:0';
      info.innerHTML='<div style="font-size:12px;font-weight:500;line-height:1.35;margin-bottom:2px">'+(l.itemname||'Artículo '+(i+1))+'</div>'
        +'<div style="font-size:10px;margin-bottom:6px">'+(l._noSap&&l._enSap===false?'<span class="cat-nuevo" style="margin-right:5px">SKU nuevo</span>':'')+'SKU: <span onclick="_invFicha(\''+(l.itemcode||l.item_code||'')+'\')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">'+(l.itemcode||l.item_code||'-')+'</span></div>'
        +'<div style="display:grid;grid-template-columns:'+(_verPrecio?'1fr 1fr 1fr':'1fr')+';gap:5px">'
        +'<div style="background:var(--surface-2);border-radius:5px;padding:4px 7px"><div style="font-size:9px;color:var(--text-muted)">Cant.</div><div style="font-size:12px;font-weight:600">'+qty.toLocaleString()+'</div></div>'
        +(_verPrecio?('<div style="background:var(--surface-2);border-radius:5px;padding:4px 7px"><div style="font-size:9px;color:var(--text-muted)">P.Unit</div><div style="font-size:12px;font-weight:600">'+fmt(pu)+'</div></div>'
        +'<div style="background:var(--bg-accent);border-radius:5px;padding:4px 7px"><div style="font-size:9px;color:var(--text-accent)">Total</div><div style="font-size:12px;font-weight:600;color:var(--text-accent)">'+fmt(tot)+'</div></div>'):'')
        +'</div>';
      row.appendChild(info);
      card.appendChild(row);
      body.appendChild(card);
    });
    var footer=document.createElement('div');
    footer.style.cssText='margin-top:6px;padding:10px 12px;background:var(--surface-1);border-radius:8px;display:flex;justify-content:space-between;font-size:13px;font-weight:700;border:0.5px solid var(--border)';
    footer.innerHTML='<span>Total OC #'+docnum+'</span><span style="color:var(--text-accent)">'+fmt(total)+'</span>';
    body.appendChild(footer);
  }catch(e){body.innerHTML='<div class="empty">Error: '+e.message+'</div>';}
}

function zoomImg(src){
  verArchivo(src, '');
}
// Visor universal: vista previa (imágenes y PDF inline) + botón de descargar.
// Reemplaza la descarga directa. Funciona para todos los archivos y usuarios.
// Ficha de producto (consulta el inventario en Supabase y la muestra en un modal)
// Extrae un valor de las caracteristicas por palabras clave (como en el portal)
function _caracVal(carac, claves){
  if(!carac) return '';
  var keys=Object.keys(carac);
  for(var i=0;i<claves.length;i++){
    for(var j=0;j<keys.length;j++){
      if(keys[j].toLowerCase().indexOf(claves[i].toLowerCase())>=0){
        var v=carac[keys[j]];
        if(v!=null && String(v).trim()!=='') return String(v).trim();
      }
    }
  }
  return '';
}
// Ficha de producto completa (replica la del portal de ventas)
// Muestra qué clientes tienen separada (comprometida) la mercancía de un item,
// consultando los pedidos de venta abiertos. Permite abrir el pedido de cada cliente.
async function verSeparado(itemcode){
  if(!itemcode){ showT('Sin código de producto'); return; }
  var ov=document.createElement('div');
  // Por encima de la ficha del inventario, que vive en la capa 12000: con
  // 2030 se abría DETRÁS y parecía que el botón «Reservado» no hacía nada.
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:12500;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:460px;width:100%"><div style="font-size:12px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Buscando quién tiene separado '+itemcode+'...</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    // Pedidos de venta ABIERTOS con este item y cantidad pendiente (separada)
    // Se pide TODO lo del artículo y se filtra aquí. Antes se filtraba en la
    // consulta por docstatus='O' y openqty>0, y bastaba con que el sync
    // dejara esos campos vacíos o con otra letra para que saliera «0
    // pedidos» aunque la mercancía estuviera separada.
    // Se busca con «like» y no con «=»: en SAP el código puede venir con
    // espacios al final (campo de ancho fijo) y entonces la igualdad exacta
    // no encuentra nada, que es lo que estaba pasando.
    var rows=[], errTxt='';
    var url1=SB+'/rest/v1/pedidos?select=docnum,cardcode,cardname,openqty,'
      +'quantity,delivrdqty,docdate,docstatus,nombrevendedor,itemcode'
      +'&itemcode=like.'+encodeURIComponent(String(itemcode).trim()+'*')+'&limit=800';
    var r=await fetch(url1, {headers:SBH});
    if(r.ok){
      var j=await r.json();
      if(Array.isArray(j)) rows=j;
    } else { errTxt=r.status+' '+(await r.text()).slice(0,120); }
    // Y si con eso tampoco, se prueba la igualdad exacta de siempre
    if(!rows.length){
      var r0=await fetch(SB+'/rest/v1/pedidos?select=docnum,cardcode,cardname,openqty,'
        +'quantity,delivrdqty,docdate,docstatus,nombrevendedor,itemcode&itemcode=eq.'
        +encodeURIComponent(itemcode)+'&limit=800', {headers:SBH});
      if(r0.ok){
        var j0=await r0.json();
        if(Array.isArray(j0)) rows=j0;
      }
    }
    // Solo las del artículo pedido, por si el «like» trajo códigos parecidos
    rows=rows.filter(function(x){
      return String(x.itemcode||'').trim().toUpperCase()===String(itemcode).trim().toUpperCase();
    });
    if(errTxt) _dbg('[SEP] consulta: '+errTxt);
    var crudos=rows.length;
    var _pend=function(x){
      var ab=Number(x.openqty);
      if(!isNaN(ab) && ab!==0) return ab;
      return (Number(x.quantity)||0)-(Number(x.delivrdqty)||0);     // por si falta openqty
    };
    rows=rows.filter(function(x){
      var st=String(x.docstatus||'').trim().toUpperCase();
      if(st && st!=='O') return false;          // cerrados y anulados, fuera
      return _pend(x)>0;
    }).sort(function(a,b){ return _pend(b)-_pend(a); });
    rows.forEach(function(x){ x.openqty=_pend(x); x._tipo='Pedido'; });

    // Lo reservado no siempre viene de un pedido: las FACTURAS RESERVA DE
    // CLIENTE también separan mercancía, y viven en otra tabla.
    var crudosFr=0;
    try{
      var rf=await fetch(SB+'/rest/v1/reservas_venta?select=*&itemcode=eq.'
        +encodeURIComponent(itemcode)+'&limit=500',{headers:SBH});
      if(rf.ok){
        var frs=await rf.json();
        if(Array.isArray(frs)){
          crudosFr=frs.length;
          frs.forEach(function(x){
            var ab=Number(x.openqty)||((Number(x.quantity)||0)-(Number(x.delivrdqty)||0));
            if(ab>0) rows.push({docnum:x.docnum, cardcode:x.cardcode, cardname:x.cardname,
                                openqty:ab, quantity:x.quantity, delivrdqty:x.delivrdqty,
                                docdate:x.docdate, docstatus:x.docstatus,
                                nombrevendedor:x.nombrevendedor,
                                _tipo:'Factura reserva'});
          });
        }
      }
    }catch(err){}
    crudos+=crudosFr;
    rows.sort(function(a,b){ return (Number(b.openqty)||0)-(Number(a.openqty)||0); });
    _dbg('[SEP] '+itemcode+': '+rows.length+' documento(s) con mercancía separada'
      +' · '+crudos+' línea(s) miradas');
    window._sepUltimo={code:itemcode, crudos:crudos, filtrados:rows.length};
    var totalSep=rows.reduce(function(s,x){return s+(Number(x.openqty)||0);},0);
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:480px;width:100%;max-height:88vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px"><div><div style="font-size:14px;font-weight:600">Mercancía separada</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+itemcode+' · '+rows.length+' pedido(s) · '+totalSep.toLocaleString()+' und separadas</div></div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';
    if(!rows.length){
      // Si en el portal no hay NI UNA línea de ese artículo, el pedido que
      // lo tiene separado es viejo y todavía no se ha sincronizado.
      h+='<div style="font-size:12px;color:var(--text-muted);padding:10px 0">'
        +(crudos
          ? 'Hay '+crudos+' línea(s) de este artículo en el portal, pero ninguna sigue '
            +'abierta con cantidad pendiente.'
          : 'No encuentro líneas de este artículo en la copia del portal.')
        +'</div>'
        +'<button class="btn bg2" style="padding:7px 12px;font-size:11.5px" '
        +'onclick="_sepDiag(\''+_esc(String(itemcode).replace(/'/g,''))+'\')">'
        +'<i class="ti ti-stethoscope"></i> Comprobar en la base</button>'
        +'<div id="sepDiag" style="font-size:11.5px;margin-top:8px"></div>';
    } else {
      h+='<div style="display:flex;flex-direction:column;gap:7px">';
      rows.forEach(function(p){
        var cliente=p.cardname||p.cardcode||'(sin cliente)';
        var sep=Number(p.openqty)||0;
        var vendNom=p.nombrevendedor||'(sin vendedor)';
        var tipo=p._tipo||'Pedido';
        h+='<div style="border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;background:var(--surface-1)">';
        h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px">';
        h+='<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:600">'+cliente+'</div>';
        h+='<div style="font-size:11px;color:var(--text-accent);font-weight:600;margin-top:2px"><i class="ti ti-user" style="font-size:11px"></i> Vendedor: '+_esc(vendNom)+'</div>';
        h+='<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'
          +_esc(tipo)+' #'+(p.docnum||'?')+' · '+(p.docdate||'')+'</div></div>';
        h+='<div style="text-align:right;flex-shrink:0"><div style="font-size:15px;font-weight:700;color:rgb(255,0,0)">'+sep.toLocaleString()+'</div><div style="font-size:9px;color:var(--text-muted)">separadas</div></div>';
        h+='</div>';
        // Botón para abrir el pedido de venta dentro del portal
        h+='<div style="margin-top:8px;display:flex;gap:6px">';
        h+='<button onclick="abrirPedidoVenta(\''+(p.docnum||'')+'\')" style="flex:1;background:var(--fill-accent);color:white;border:none;border-radius:6px;padding:6px 10px;cursor:pointer;font-size:11px;font-weight:600"><i class="ti ti-external-link" style="font-size:11px"></i> Abrir pedido de venta</button>';
        h+='</div>';
        h+='</div>';
      });
      h+='</div>';
    }
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:420px"><div style="font-size:13px;color:var(--text-danger)">Error al buscar: '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}
// ═══════════════════════════════════════════════════════════════════════════
//  PEDIDO DE VENTA
//  Abre el pedido completo dentro del portal, leyendo la tabla `pedidos` de
//  Supabase (una fila por línea). Todo se ve dentro del portal de compras.
// ═══════════════════════════════════════════════════════════════════════════
function _pvNum(v){ return Number(v)||0; }
function _pvEstado(e){
  var m={O:['Abierto','#fee2e2','#b91c1c'], C:['Cerrado','#dcfce7','#166534']};
  var x=m[String(e||'').toUpperCase()]||['—','var(--surface-1)','var(--text-muted)'];
  return '<span style="font-size:9.5px;background:'+x[1]+';color:'+x[2]+';padding:1px 8px;border-radius:7px;font-weight:700">'+x[0]+'</span>';
}

async function abrirPedidoVenta(docnum){
  if(!docnum){ showT('Sin número de pedido'); return; }
  var prev=document.getElementById('pvOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='pvOv';
  // Por delante de todo: se abre desde la ficha del inventario (12000) y
  // desde la ventana de mercancía separada (12500), y salía por detrás.
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:12800;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:460px;width:100%">'
    +'<div style="font-size:12px;color:var(--text-muted)"><span class="ai-ring g" style="vertical-align:-2px"></span> Abriendo pedido #'+_esc(String(docnum))+'…</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);

  try{
    var campos='docnum,docdate,docduedate,cardcode,cardname,doctotal,doccur,docstatus,comments,'
      +'nombrevendedor,linenum,itemcode,dscription,quantity,price,linetotal,delivrdqty,openqty,'
      +'linestatus,unitmsr,whscode';
    var r=await fetch(SB+'/rest/v1/pedidos?select='+campos+'&docnum=eq.'+encodeURIComponent(docnum)+'&order=linenum&limit=500',{headers:SBH});
    if(!r.ok) throw new Error('HTTP '+r.status);
    var lin=await r.json();
    if(!Array.isArray(lin)) lin=[];
    if(!lin.length){
      ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:440px;width:100%">'
        +'<div style="font-size:13px">No se encontró el pedido #'+_esc(String(docnum))+' en el sistema.</div>'
        +'<button onclick="document.getElementById(\'pvOv\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
      return;
    }
    var h0=lin[0];

    // Fotos de los items, para reconocerlos de un vistazo
    var fotos={};
    try{
      var codes=lin.map(function(l){return String(l.itemcode||'');}).filter(Boolean);
      if(codes.length){
        var inList=Array.from(new Set(codes)).map(function(c){return '"'+c.replace(/"/g,'')+'"';}).join(',');
        var rf=await fetch(SB+'/rest/v1/inventario?select=itemcode,picturname&itemcode=in.('+encodeURIComponent(inList)+')&limit=500',{headers:SBH});
        if(rf.ok) (await rf.json()||[]).forEach(function(x){ fotos[x.itemcode]=x.picturname||''; });
      }
    }catch(e){}

    var totPz=lin.reduce(function(a,l){return a+_pvNum(l.quantity);},0);
    var totEnt=lin.reduce(function(a,l){return a+_pvNum(l.delivrdqty);},0);
    var totAb=lin.reduce(function(a,l){return a+_pvNum(l.openqty);},0);
    var moneda=h0.doccur||h0.currency||'';

    var maxSku=lin.reduce(function(m,l){ return Math.max(m, String(l.itemcode||'').length); },0);
    var skuW=Math.min(280, Math.max(116, Math.round(maxSku*7.2)+22));
    var h='<div style="--pv-sku-w:'+skuW+'px;background:var(--surface-0);border-radius:12px;max-width:800px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
      +'<div style="min-width:0">'
        +'<div style="font-size:15px;font-weight:700">Pedido de venta #'+_esc(String(h0.docnum||docnum))+' '+_pvEstado(h0.docstatus)+'</div>'
        +'<div style="font-size:12.5px;color:var(--text-secondary);margin-top:2px">'+_esc(h0.cardname||h0.cardcode||'(sin cliente)')+'</div>'
        +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'
          +(h0.docdate?('Fecha: '+_esc(String(h0.docdate).slice(0,10))):'')
          +(h0.docduedate?(' · Entrega: '+_esc(String(h0.docduedate).slice(0,10))):'')
          +(h0.nombrevendedor?(' · Vendedor: '+_esc(h0.nombrevendedor)):'')
        +'</div>'
      +'</div>'
      +'<button onclick="document.getElementById(\'pvOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';

    h+='<div style="padding:14px 18px">';
    // Totales
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
      +_invCaja('Piezas pedidas', totPz.toLocaleString('en-US'), '#1D4ED8')
      +_invCaja('Entregadas',     totEnt.toLocaleString('en-US'), '#15803D')
      +_invCaja('Abiertas',       totAb.toLocaleString('en-US'), '#DC2626')
      +(CU.verCostos&&_pvNum(h0.doctotal)?_invCaja('Total '+_esc(moneda), fmt(h0.doctotal), '#5B21B6'):'')
      +'</div>';

    // Líneas
    h+='<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden">';
    h+='<div class="pv-hdr"><div style="flex:0 0 40px"></div><div class="pv-sku">SKU</div>'
      +'<div class="pv-desc">Descripción</div>'
      +'<div class="pv-n">Pedidas</div><div class="pv-n">Entreg.</div><div class="pv-n">Abiertas</div>'
      +(CU.verCostos?'<div class="pv-n" style="flex:0 0 84px">Total</div>':'')+'</div>';
    lin.forEach(function(l){
      // Se prueban todas las variantes del nombre y el propio código, como
      // en las demás pantallas: con una sola URL casi ninguna salía.
      var f='';
      try{
        var _u=fotoVariantes({itemcode:l.itemcode, picturname:fotos[l.itemcode]||''})||[];
        f=_u[0]||'';
        l._fotoUrls=_u.slice(0,10);
      }catch(e){ f=_repFotoUrl(fotos[l.itemcode]||''); }
      var ab=_pvNum(l.openqty);
      h+='<div class="pv-row">'
        +'<div style="flex:0 0 40px">'+(f
            ?'<img src="'+_esc(f)+'" loading="lazy" '
              +'data-fotos="'+_esc((l._fotoUrls||[f]).join('|'))+'" data-fi="0" '
              +'onerror="_frFotoSiguiente(this)" '
              +'style="width:34px;height:34px;object-fit:contain;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-2)">'
            :'<div style="width:34px;height:34px;border:0.5px solid var(--border);border-radius:5px;display:flex;align-items:center;justify-content:center;color:var(--text-muted)"><i class="ti ti-photo-off" style="font-size:13px"></i></div>')+'</div>'
        +'<div class="pv-sku" title="'+_esc(l.itemcode||'')+'">'+_esc(l.itemcode||'')+'</div>'
        +'<div class="pv-desc" title="'+_esc(l.dscription||'')+'">'+_esc(l.dscription||'')+'</div>'
        +'<div class="pv-n">'+_pvNum(l.quantity).toLocaleString('en-US')+'</div>'
        +'<div class="pv-n" style="color:#15803D">'+_pvNum(l.delivrdqty).toLocaleString('en-US')+'</div>'
        +'<div class="pv-n" style="color:'+(ab>0?'#DC2626':'var(--text-muted)')+';font-weight:700">'+ab.toLocaleString('en-US')+'</div>'
        +(CU.verCostos?('<div class="pv-n" style="flex:0 0 84px">'+fmt(l.linetotal)+'</div>'):'')
      +'</div>';
    });
    h+='</div>';

    if(h0.comments && String(h0.comments).trim()){
      h+='<div style="margin-top:12px;padding:10px 12px;background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px">'
        +'<div style="font-size:10px;text-transform:uppercase;color:var(--t-oro);font-weight:700;margin-bottom:3px">Comentarios</div>'
        +'<div style="font-size:12.5px;color:#5A4A1F;white-space:pre-wrap">'+_esc(String(h0.comments))+'</div></div>';
    }

    h+='<div style="margin-top:13px;display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end">'
      +'<button class="btn bg2" style="padding:7px 14px;font-size:11.5px" onclick="document.getElementById(\'pvOv\').remove()">Cerrar</button>'
      +'</div>';

    h+='</div></div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    console.error('pedido venta:',e);
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:440px;width:100%">'
      +'<div style="font-size:13px;color:var(--text-danger)">No se pudo abrir el pedido: '+_esc(e.message||String(e))+'</div>'
      +'<button onclick="document.getElementById(\'pvOv\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
  }
}

async function verFichaProducto(itemcode){
  if(!itemcode){ showT('Sin código de producto'); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1000;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:460px;width:100%"><div style="font-size:12px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Cargando ficha de '+itemcode+'...</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    // Traer de vista_inventario (datos) + inventario (frgnname, usertext/nota) + fotos
    var results=await Promise.all([
      fetch(SB+'/rest/v1/vista_inventario?select=*&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1',{headers:SBH}).then(function(r){return r.json();}),
      fetch(SB+'/rest/v1/inventario?select=frgnname,usertext&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1',{headers:SBH}).then(function(r){return r.json();}).catch(function(){return[];}),
      fetch(SB+'/rest/v1/fotos?select=url&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1',{headers:SBH}).then(function(r){return r.json();}).catch(function(){return[];})
    ]);
    var b=(Array.isArray(results[0])&&results[0][0])?results[0][0]:null;
    var invRow=(Array.isArray(results[1])&&results[1][0])?results[1][0]:{};
    var fotoRow=(Array.isArray(results[2])&&results[2][0])?results[2][0]:{};
    if(!b){ ov.querySelector('div>div').innerHTML='<div style="font-size:13px">No se encontró <strong>'+itemcode+'</strong> en el inventario.</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button>'; return; }
    var carac=b.caracteristicas; if(typeof carac==='string'){try{carac=JSON.parse(carac);}catch(e){carac=null;}}
    var nombre=b.itemname||itemcode;
    var frgn=invRow.frgnname||'';
    var nota=invRow.usertext||_caracVal(carac,['nota','note','observ','comentario']);
    var foto=(fotoRow.url)||b.foto_url||'';
    var _verP=CU&&CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';
    var pventa=Number(b.precioventa)||0;
    var dispo=Number(b.disponiblebodega!=null?b.disponiblebodega:b.disponible)||0;
    // Valores GLOBALES (todas las bodegas), como en SAP
    var stockGlobal=Number(b.onhand)||0;
    var enPedidos=Number(b.iscommited)||0;
    var porLlegar=Number(b.onorder)||0;
    var bulto=Math.max(1,Number(b.unidadesbulto)||Number(b.numinbuy)||1);
    // Ficha técnica (campos como en el portal)
    var cub=b.volumen?(Math.round(b.volumen*100000)/100000)+' Pies':_caracVal(carac,['cubicaje','volumen']);
    var pesoP=b.peso?(Math.round(b.peso*100)/100)+' kg':_caracVal(carac,['peso','weight']);
    var ficha=[
      ['Tamaño', _caracVal(carac,['tamano','tama','medida','size','dimens'])],
      ['Cubicaje', cub],
      ['Peso', pesoP],
      ['Marca', b.marca||_caracVal(carac,['marca','brand'])],
      ['Origen', _caracVal(carac,['porigen','origen','origin','pais','country'])],
      ['Piezas por bulto', b.unidadesbulto?String(b.unidadesbulto):''],
      ['Color', _caracVal(carac,['color','colour','tono'])],
      ['Composición', _caracVal(carac,['composic','compo','material','tela','fabric','content','fibra','composition'])]
    ].filter(function(x){ return x[1] && String(x[1]).trim()!==''; });
    function row(lbl,val){ return val?('<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:0.5px solid var(--border);font-size:12px;gap:12px"><span style="color:var(--text-muted);flex-shrink:0">'+lbl+'</span><span style="font-weight:500;text-align:right">'+String(val)+'</span></div>'):''; }
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:460px;width:100%;max-height:90vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px;gap:10px"><div><div style="font-size:15px;font-weight:600;line-height:1.3">'+nombre+'</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+itemcode+(frgn?' · '+frgn:'')+'</div></div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1;flex-shrink:0">&times;</button></div>';
    if(foto) h+='<img src="'+foto+'" style="width:100%;max-height:210px;object-fit:contain;border-radius:8px;background:var(--surface-1);margin-bottom:14px;padding:6px" onerror="this.style.display=\'none\'">';
    // KPIs
    h+='<div style="background:var(--surface-1);border-radius:8px;padding:12px;margin-bottom:12px;display:flex;justify-content:space-around;text-align:center">';
    if(_verP) h+='<div><div style="font-size:9px;color:var(--text-muted);text-transform:uppercase">Precio venta</div><div style="font-size:18px;font-weight:700;color:var(--text-accent)">'+(pventa?fmt(pventa):'—')+'</div></div>';
    h+='<div><div style="font-size:9px;color:var(--text-muted);text-transform:uppercase">Stock</div><div style="font-size:18px;font-weight:700;color:rgb(21,206,43)">'+stockGlobal.toLocaleString()+' <span onclick="verSeparado(\''+itemcode+'\')" style="font-size:11px;font-weight:500;color:rgb(255,0,0);cursor:pointer;text-decoration:underline" title="Ver qué clientes lo tienen separado">('+enPedidos.toLocaleString()+')</span> <span style="font-size:11px;font-weight:500;color:#C9A800">('+porLlegar.toLocaleString()+')</span></div><div style="font-size:9px;color:var(--text-muted)">stock · <span style="color:rgb(255,0,0)">separado</span> · <span style="color:#C9A800">por llegar</span></div></div>';
    h+='</div>';
    // Info del producto
    h+='<div style="margin-bottom:12px">';
    h+=row('Código', '<b>'+itemcode+'</b>');
    h+=row('Código de barras', b.codebars);
    h+=row('Unidades por bulto', bulto);
    h+=row('Unidad compra', b.buyunitmsr);
    h+=row('Unidad venta', b.salunitmsr);
    h+='</div>';
    // Ficha técnica
    if(ficha.length){
      h+='<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--text-muted);margin-bottom:4px">Ficha técnica</div><div style="margin-bottom:12px">';
      ficha.forEach(function(x){ h+=row(x[0],x[1]); });
      h+='</div>';
    }
    // Nota
    if(nota && String(nota).trim()){
      h+='<div style="background:#FEF9E7;border-left:3px solid #E0A82E;border-radius:8px;padding:10px 12px;font-size:11px;color:#5A4A1F;line-height:1.5;white-space:pre-wrap"><strong style="text-transform:uppercase;font-size:9px;color:var(--t-oro)">Nota</strong><br>'+String(nota).replace(/</g,'&lt;')+'</div>';
    }
    // Stock detalle
    h+='<div style="margin-top:12px;display:flex;justify-content:space-around;text-align:center;background:var(--surface-1);border-radius:8px;padding:10px;font-size:11px">';
    h+='<div><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">En stock</div><div style="font-weight:600;color:rgb(21,206,43)">'+stockGlobal.toLocaleString()+'</div></div>';
    h+='<div onclick="verSeparado(\''+itemcode+'\')" style="cursor:pointer"><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">Separado</div><div style="font-weight:600;color:rgb(255,0,0);text-decoration:underline">'+enPedidos.toLocaleString()+'</div></div>';
    h+='<div><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">Por llegar</div><div style="font-weight:600;color:#C9A800">'+porLlegar.toLocaleString()+'</div></div>';
    h+='<div><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">Disponible</div><div style="font-weight:600">'+(stockGlobal-enPedidos).toLocaleString()+'</div></div>';
    h+='</div>';
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:420px"><div style="font-size:13px;color:var(--text-danger)">Error al cargar la ficha: '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}

// URL que fuerza la descarga en vez de abrir el archivo en el navegador.
// Supabase ignora el Content-Disposition que se manda al subir, pero sí
// respeta ?download= en la URL pública. Sirve incluso para los archivos que
// quedaron guardados con el tipo equivocado.
function _urlDescarga(url, nombre){
  if(!url) return url;
  var u=String(url);
  // Un data: no lleva parámetros: pegarle «?download=…» se lo mete dentro del
  // base64 y el archivo sale corrupto. Los adjuntos que vienen de un correo
  // ya enviado llegan así.
  if(u.indexOf('data:')===0) return u;
  if(u.indexOf('download=')>=0) return u;
  var nom=String(nombre||u.split('/').pop()||'archivo').split('?')[0];
  return u + (u.indexOf('?')>=0?'&':'?') + 'download=' + encodeURIComponent(nom);
}

// Estos se pueden ver dentro del portal; el resto se descarga
var _VER_EN_PORTAL=['jpg','jpeg','png','gif','webp','bmp','svg','pdf','xlsx','xls','csv','doc','docx','ppt','pptx','txt'];

function verArchivo(url, nombre){
  if(!url) return;
  nombre = nombre || (url.split('/').pop()||'archivo').split('?')[0];
  try{ nombre=decodeURIComponent(nombre); }catch(e){}
  var ext=(nombre.split('.').pop()||'').toLowerCase();

  // Comprimidos y formatos de diseño: se descargan directo, no hay nada que
  // previsualizar y abrirlos en el navegador mostraba una pantalla de letras.
  if(_VER_EN_PORTAL.indexOf(ext)<0){
    var a=document.createElement('a');
    a.href=_urlDescarga(url, nombre);
    a.download=nombre;
    a.style.display='none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){ a.remove(); }, 1500);
    showT('Descargando '+nombre+'…');
    return;
  }
  var esImg=['jpg','jpeg','png','gif','webp','bmp','svg'].includes(ext);
  var esPdf=ext==='pdf';
  var esOffice=['xlsx','xls','doc','docx','ppt','pptx'].includes(ext);
  var esExcel=['xlsx','xls','csv'].includes(ext);

  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:1000;display:flex;flex-direction:column;padding:0';
  // Barra superior con nombre + descargar + cerrar
  var bar=document.createElement('div');
  bar.style.cssText='display:flex;align-items:center;gap:10px;padding:11px 16px;background:#1e1e24;color:#fff;flex-shrink:0';
  bar.innerHTML='<i class="ti ti-file" style="font-size:15px;color:#c9c9d6"></i><span style="font-size:13px;font-weight:500;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+nombre.replace(/</g,'&lt;')+'</span>';
  var dl=document.createElement('a');
  dl.href=_urlDescarga(url,nombre); dl.download=nombre;
  dl.style.cssText='display:inline-flex;align-items:center;gap:5px;background:#534AB7;color:#fff;text-decoration:none;padding:6px 13px;border-radius:7px;font-size:12px;font-weight:600;cursor:pointer';
  dl.innerHTML='<i class="ti ti-download" style="font-size:13px"></i> Descargar';
  bar.appendChild(dl);
  var cl=document.createElement('button');
  cl.innerHTML='&times;';
  cl.style.cssText='background:none;border:none;color:#fff;font-size:26px;cursor:pointer;line-height:1;padding:0 4px';
  cl.onclick=function(){ov.remove();};
  bar.appendChild(cl);
  ov.appendChild(bar);
  // Cuerpo con la vista previa
  var body=document.createElement('div');
  body.style.cssText='flex:1;display:flex;align-items:center;justify-content:center;overflow:auto;padding:16px';
  if(esImg){
    var img=document.createElement('img');
    img.src=url;
    img.style.cssText='max-width:96%;max-height:96%;object-fit:contain;border-radius:8px;box-shadow:0 8px 40px rgba(0,0,0,.5)';
    body.appendChild(img);
  } else if(esPdf){
    var fr=document.createElement('iframe');
    fr.src=url;
    fr.style.cssText='width:100%;height:100%;border:none;background:var(--surface-2);border-radius:6px';
    body.appendChild(fr);
  } else if(esExcel){
    var xw=document.createElement('div'); xw.style.cssText='width:100%;height:100%;overflow:auto;background:var(--surface-2);border-radius:6px;padding:10px'; xw.innerHTML='<div style="color:#555;font-size:13px;padding:12px"><i class="ti ti-loader-2 spin"></i> Cargando vista previa…</div>'; body.appendChild(xw); _previewExcel(url, xw, nombre);
  } else if(esOffice){
    // Visor de Microsoft Office Online (renderiza Excel/Word/PowerPoint con formato).
    // Requiere que la URL del archivo sea pública (el bucket compras-docs lo es).
    // El visor de Office es un servicio de Microsoft: necesita una URL a la
    // que pueda entrar él. Un data: vive solo en este navegador, así que con
    // esos se ofrece la descarga en vez de un visor que saldría en blanco.
    if(String(url).indexOf('data:')===0){
      var avi=document.createElement('div');
      avi.style.cssText='flex:1;display:flex;flex-direction:column;align-items:center;'
        +'justify-content:center;gap:14px;color:#e8e8f0;text-align:center;padding:24px';
      avi.innerHTML='<i class="ti ti-file-spreadsheet" style="font-size:44px;opacity:.75"></i>'
        +'<div style="font-size:14px;max-width:420px;line-height:1.6">Este archivo llegó '
        +'dentro de un correo, así que no se puede previsualizar aquí.<br>Descárgalo para abrirlo.</div>';
      var bd=document.createElement('a');
      bd.href=url; bd.download=nombre;
      bd.className='btn bp';
      bd.style.cssText='text-decoration:none;padding:9px 18px;border-radius:8px;'
        +'background:#534AB7;color:#fff;font-size:13px';
      bd.innerHTML='<i class="ti ti-download"></i> Descargar '+nombre;
      avi.appendChild(bd);
      ov.appendChild(avi);
      document.body.appendChild(ov);
      return;
    }

    var frO=document.createElement('iframe');
    frO.src='https://view.officeapps.live.com/op/embed.aspx?src='+encodeURIComponent(url);
    frO.style.cssText='width:100%;height:100%;border:none;background:var(--surface-2);border-radius:6px';
    // Si el visor de Office no carga (ej. archivo no accesible), avisar con opción de descargar
    var avisoTimer=setTimeout(function(){
      if(!frO._cargó){
        // No forzamos cierre; el usuario siempre tiene el botón Descargar arriba.
      }
    },8000);
    frO.onload=function(){ frO._cargó=true; clearTimeout(avisoTimer); };
    body.appendChild(frO);
  } else {
    // Otros tipos (Word, Excel): no se pueden previsualizar en el navegador
    var box=document.createElement('div');
    box.style.cssText='text-align:center;color:#fff;max-width:340px';
    box.innerHTML='<div style="font-size:46px;margin-bottom:10px">'+(ext==='xlsx'||ext==='xls'?'📊':ext==='doc'||ext==='docx'?'📝':'📎')+'</div>'
      +'<div style="font-size:14px;font-weight:500;margin-bottom:6px">'+nombre.replace(/</g,'&lt;')+'</div>'
      +'<div style="font-size:12px;color:#b8b8c8;margin-bottom:16px">Este tipo de archivo no se puede previsualizar en el navegador.</div>';
    var dl2=document.createElement('a');
    dl2.href=_urlDescarga(url,nombre); dl2.download=nombre;
    dl2.style.cssText='display:inline-flex;align-items:center;gap:6px;background:#534AB7;color:#fff;text-decoration:none;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:600';
    dl2.innerHTML='<i class="ti ti-download"></i> Descargar archivo';
    box.appendChild(dl2);
    body.appendChild(box);
  }
  ov.appendChild(body);
  // Cerrar al hacer clic en el fondo oscuro (no en el contenido)
  ov.addEventListener('click',function(e){ if(e.target===ov||e.target===body) ov.remove(); });
  document.body.appendChild(ov);
}
async function _previewExcel(url, wrap, nombre){
  try{
    if(typeof XLSX==='undefined') throw new Error('sin XLSX');
    var buf=await fetch(url).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.arrayBuffer(); });
    var wb=XLSX.read(buf,{type:'array'});
    var html='';
    wb.SheetNames.forEach(function(sn){ var ws=wb.Sheets[sn]; html+='<div style="font-size:12px;font-weight:700;color:#075E54;margin:8px 0 4px">'+_esc(sn)+'</div>'+XLSX.utils.sheet_to_html(ws); });
    wrap.innerHTML='<style>#xlsxprev table{border-collapse:collapse;font-size:12px;color:var(--text-primary)}#xlsxprev td,#xlsxprev th{border:0.5px solid #ccc;padding:3px 7px}</style><div id="xlsxprev">'+html+'</div>';
  }catch(e){
    wrap.innerHTML='<div style="text-align:center;color:#555;padding:24px"><div style="font-size:40px">📊</div><div style="margin:8px 0;font-size:13px">No se pudo generar la vista previa aquí.</div><a href="'+url+'" download style="display:inline-flex;gap:6px;align-items:center;background:#534AB7;color:#fff;text-decoration:none;padding:9px 16px;border-radius:8px;font-size:13px;font-weight:600"><i class="ti ti-download"></i> Descargar</a></div>';
  }
}

// ─── FIX 5: Adjuntos por etapa ───
// Encola un correo al proveedor en Supabase. El script Python lo detecta,
// adjunta el comprobante automáticamente y lo envía por Office 365. Sin abrir
// ningún programa de correo y sin adjuntar nada a mano.
async function enviarCorreoProveedor(oid){
  var o = orders.find(function(x){return x.id===oid;});
  if(!o){ showT('Orden no encontrada'); return; }
  var email = (o.vendorEmail||'').trim();
  if(!email){
    showT('⚠ Este proveedor no tiene correo en SAP');
    return;
  }

  // Comprobante de abono adjunto en la etapa de depósito (si existe)
  var docsDep = (window._atts && window._atts[oid+'deposito']) ? window._atts[oid+'deposito'] : [];
  var adj = docsDep.length ? docsDep[docsDep.length-1] : null;   // el último adjuntado

  var fechaAbono = o.fechaAbono || dateOnly();
  var montoAbono = (typeof fmt==='function') ? fmt(o.abono) : ('$'+o.abono);
  var asunto = 'Payment advice - Order '+oid+' - Kennedy Center';
  var cuerpo =
    'Dear '+o.prov+',\n\n'+
    'We are pleased to inform you that we have issued the payment for purchase order '+oid+'.\n\n'+
    'Details:\n'+
    '  - Order: '+oid+'\n'+
    (o.num_proveedor?('  - Reference: '+o.num_proveedor+'\n'):'')+
    '  - Payment amount: '+montoAbono+'\n'+
    '  - Payment date: '+fechaAbono+'\n'+
    '  - Description: '+(o.desc||'')+'\n\n'+
    (adj ? 'Please find the payment receipt attached.\n\n' : '')+
    'We look forward to your confirmation of receipt.\n\n'+
    'Best regards,\n'+
    (CU?CU.name:'')+'\n'+
    'Kennedy Center Corp.';

  if(!confirm('¿Enviar correo del abono a '+o.prov+' ('+email+')'+(adj?' con el comprobante adjunto':'')+'?')) return;

  showT('Encolando correo...');
  try{
    var body = {
      docnum:String(oid), para_email:email, proveedor:o.prov,
      asunto:asunto, cuerpo:cuerpo,
      adjunto_path: adj?adj.url:null,
      adjunto_nombre: adj?adj.name:null,
      // Del buzón de quien lo manda, no de la cuenta por defecto (v724)
      de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
      estado:'pendiente', creado_por:(CU?CU.name:''), creado_en:new Date().toISOString()
    };
    var r = await fetch(SB+'/rest/v1/correos_queue', {
      method:'POST',
      headers:Object.assign({}, SBH, {'Prefer':'return=minimal'}),
      body:JSON.stringify(body)
    });
    if(r.ok){
      showT('✅ Correo en cola — se enviará al proveedor'+(adj?' con el comprobante':''));
    } else {
      var t = await r.text();
      console.error('encolar correo:', r.status, t);
      showT('⚠ No se pudo encolar (revisa la tabla correos_queue)');
    }
  }catch(e){
    console.error('encolar correo:', e);
    showT('⚠ Error: '+e.message);
  }
}

if(!window._atts)window._atts={};

// Bucket de Supabase Storage para documentos de compras (crear una vez en el panel)
const DOCS_BUCKET = 'compras-docs';
const DOCS_BASE = SB + '/storage/v1/object/public/' + DOCS_BUCKET + '/';

// Sube un archivo al bucket y devuelve la ruta pública (o null si falla)
/* Sube un archivo al bucket y devuelve su ruta. Con XHR en vez de fetch por
   dos motivos: se puede ver el avance (un PDF de 60 MB tarda, y sin barra
   parece colgado) y se puede leer el mensaje real del servidor cuando
   rechaza, que antes solo iba a la consola y el usuario veía «no se pudo
   subir» sin más. */
function _subirDocStorage(oid, stageKey, file){
  var limpio = file.name.replace(/[^\w.\-]+/g,'_');
  var path = oid + '/' + stageKey + '/' + Date.now() + '_' + limpio;
  var url = SB + '/storage/v1/object/' + DOCS_BUCKET + '/'
            + path.split('/').map(encodeURIComponent).join('/');
  window._attErr = '';
  return new Promise(function(res){
    try{
      var x=new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('apikey', KEY);
      x.setRequestHeader('Authorization', SBH.Authorization);
      x.setRequestHeader('Content-Type', file.type||'application/octet-stream');
      x.setRequestHeader('x-upsert', 'true');
      x.timeout = 20*60*1000;                 // 20 minutos: los artes pesan
      x.upload.onprogress=function(ev){
        if(!ev.lengthComputable) return;
        _attProgreso(file.name, Math.round(ev.loaded*100/ev.total),
                     Math.round(file.size/1024/1024*10)/10);
      };
      x.onload=function(){
        if(x.status>=200 && x.status<300) return res(path);
        var t=String(x.responseText||'');
        // El tope de tamaño del bucket es el fallo típico con los PDF grandes
        if(x.status===413 || /exceeded the maximum allowed size|Payload too large/i.test(t)){
          window._attErr='el archivo pasa del tamaño máximo permitido en el bucket «'
            +DOCS_BUCKET+'». Hay que subir ese tope (archivo limite_archivos.sql).';
        } else if(x.status===403){
          window._attErr='sin permiso para escribir en el bucket';
        } else {
          window._attErr='error '+x.status+(t?(' · '+t.slice(0,120)):'');
        }
        console.error('subir doc:', x.status, t.slice(0,300));
        res(null);
      };
      x.onerror=function(){
        window._attErr='se cortó la conexión mientras subía';
        res(null);
      };
      x.ontimeout=function(){
        window._attErr='tardó demasiado y se agotó el tiempo';
        res(null);
      };
      x.send(file);
    }catch(e){
      window._attErr=String(e && e.message || e);
      res(null);
    }
  });
}

// El avance de un archivo concreto, dentro del cartel de «cargando»
function _attProgreso(nombre, pct, mb){
  var el=document.getElementById('attCargando');
  if(!el) return;
  var d=document.getElementById('attCargandoPct');
  var txt=(nombre.length>28?(nombre.slice(0,26)+'…'):nombre)
    +' · '+pct+'%'+(mb?(' de '+mb+' MB'):'');
  if(d) d.textContent=txt;
  else el.insertAdjacentHTML('beforeend',
    '<span id="attCargandoPct" style="color:var(--text-muted)">'+_esc(txt)+'</span>');
}

// Registra el documento en la tabla compras_documentos
async function _registrarDoc(oid, stageKey, file, path){
  try{
    var body = {
      docnum:String(oid), etapa:stageKey, paso:null,
      nombre_archivo:file.name, url:path,
      tipo:(file.name.split('.').pop()||'').toLowerCase(),
      subido_por: CU?CU.name:'', subido_en:new Date().toISOString()
    };
    var r = await fetch(SB+'/rest/v1/compras_documentos', {
      method:'POST',
      headers:Object.assign({}, SBH, {'Prefer':'return=representation'}),
      body:JSON.stringify(body)
    });
    if(r.ok){ var arr=await r.json(); return Array.isArray(arr)?arr[0]:null; }
    // El fallo se devuelve, no se traga. Antes esto acababa en un `return
    // null` mudo: el archivo quedaba en Storage, quien lo subía lo veía en su
    // pantalla (se añadía a la lista pasara lo que pasara) y para el resto no
    // existía, porque los demás lo leen de esta tabla.
    var _t=''; try{ _t=await r.text(); }catch(e){}
    console.error('[doc] no se registró:', r.status, _t.slice(0,200));
    return {_error:'estado '+r.status+(_t?(' · '+_t.slice(0,140)):'')};
  }catch(e){
    console.error('registrar doc:', e);
    return {_error:String(e && e.message || e).slice(0,140)};
  }
}

// Los dos nombres con los que puede estar guardada una orden: el número de
// SAP (12306) y nuestra referencia (DKC-25119). Una orden que nació NO SAP
// tiene sus documentos bajo la DKC, y al entrar en SAP se abre por el número:
// buscando solo por uno, los adjuntos salían vacíos para quien la abría por
// el otro lado. Es lo que pasaba con las transferencias de contabilidad.
function _refsDeOrden(oid){
  var ref=String(oid||'').trim();
  var refs=[ref];
  var add=function(v){
    v=String(v||'').trim();
    if(v && refs.indexOf(v)<0) refs.push(v);
  };
  try{
    // Desde el número de SAP: su referencia de proveedor
    var o=(typeof orders!=='undefined'&&orders)
      ? orders.find(function(x){ return String(x.id)===ref; }) : null;
    if(o) add(o.num_proveedor);
    // Desde la DKC: la orden de SAP gemela, si ya existe
    var p=(window._pendSAP||[]).find(function(x){
      return String(x.dkc)===ref || String(x.num_orden)===ref; });
    if(p){
      add(p.dkc); add(p.num_orden);
      var g=_ordenSapDeNoSap(p);
      if(g) add(g.id);
    }
    // Y al revés: una orden de SAP cuya referencia coincide con una NO SAP
    if(o && o.num_proveedor){
      var p2=(window._pendSAP||[]).find(function(x){
        return String(x.dkc)===String(o.num_proveedor); });
      if(p2){ add(p2.dkc); add(p2.num_orden); }
    }
  }catch(e){ console.warn('[docs] refs:', e); }
  return refs;
}

// Los comprobantes de pago NO viven en compras_documentos: se guardan en
// solicitudes_pago.comprobante_path y solo se enseñaban como un enlace dentro
// de la ficha de la solicitud. Aquí se añaden como adjunto de la etapa de
// Depósito & Pago, que es donde la gente los busca.
async function _docsDeSolicitudes(oid){
  try{
    var refs=_refsDeOrden(oid);
    var lista=refs.map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
    var r=await fetch(SB+'/rest/v1/solicitudes_pago?select=docnum,tipo,comprobante_path,'
      +'comprobante_nombre,finalizado_por,finalizado_en&docnum=in.('+encodeURIComponent(lista)+')',
      {headers:SBH});
    if(!r.ok) return 0;
    var filas=await r.json()||[];
    var n=0;
    filas.forEach(function(x){
      if(!x.comprobante_path) return;
      var paso=(x.tipo==='abono')?_PASO_DEP_PROV:_PASO_PAGO_FINAL;
      var k=oid+_subKeyDeposito(paso);
      if(!window._atts[k]) window._atts[k]=[];
      if(window._atts[k].some(function(a){ return a.url===x.comprobante_path; })) return;
      window._atts[k].push({
        name:x.comprobante_nombre||('Comprobante_'+x.docnum+'.pdf'),
        data: DOCS_BASE + String(x.comprobante_path).split('/').map(encodeURIComponent).join('/'),
        url:x.comprobante_path,
        date:String(x.finalizado_en||'').slice(0,10),
        by:x.finalizado_por||'', remoto:true, _deSolicitud:true
      });
      n++;
    });
    return n;
  }catch(e){ console.warn('[docs] comprobantes:', e); return 0; }
}

// Carga los documentos guardados de una orden (todas sus etapas) a window._atts
async function cargarDocsOrden(oid){
  try{
    var refs=_refsDeOrden(oid);
    var lista=refs.map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
    var r = await fetch(SB+'/rest/v1/compras_documentos?select=*&docnum=in.('
      +encodeURIComponent(lista)+')&order=subido_en.asc', {headers:SBH});
    // Los dos `return` que había aquí cortaban la función entera: si esta
    // consulta fallaba, los comprobantes y los adjuntos de correos no se
    // cargaban nunca, aunque no tuvieran nada que ver con ella.
    var docs = r.ok ? await r.json() : null;
    if(!r.ok) _dbg('[docs] compras_documentos: estado '+r.status);
    (Array.isArray(docs)?docs:[]).forEach(function(d){
      // Se guardan SIEMPRE bajo el identificador con el que se abrió la
      // orden, venga la fila con el número de SAP o con la DKC.
      var k = oid + d.etapa;
      if(!window._atts[k]) window._atts[k]=[];
      // No repetir: ni por id ni por nombre. Las versiones anteriores del
      // portal subean el mismo archivo varias veces y quedaron duplicados.
      if(window._atts[k].some(function(a){return a.id===d.id;})) return;
      var _cl=_docClave({name:d.nombre_archivo});
      if(_cl && window._atts[k].some(function(a){ return _docClave(a)===_cl; })) return;
      window._atts[k].push({
        id:d.id, name:d.nombre_archivo,
        data: DOCS_BASE + d.url.split('/').map(encodeURIComponent).join('/'),
        url:d.url, date:(d.subido_en||'').slice(0,10),
        by:d.subido_por, remoto:true
      });
    });
  }catch(e){ console.error('cargarDocsOrden:', e); }
  // Fuera del try de arriba a propósito: son fuentes independientes y no
  // deben depender de que la primera haya ido bien.
  try{ await _docsDeSolicitudes(oid); }catch(e){ console.warn('[docs] solicitudes:', e); }
  try{ await _docsDeCorreos(oid); }catch(e){ console.warn('[docs] correos:', e); }
  try{
    var _k=Object.keys(window._atts||{}).filter(function(x){ return x.indexOf(String(oid))===0; });
    _dbg('[docs] '+oid+' → etapas con archivos:', _k.map(function(x){
      return x+'('+window._atts[x].length+')'; }).join(', ')||'ninguna');
  }catch(e){}
}

async function handleAttach(oid,stageKey,inp){
  var k=oid+stageKey;
  if(!window._atts[k])window._atts[k]=[];
  var files=Array.from(inp.files);
  if(!files.length) return;
  try{ inp.value=''; }catch(e){}
  // Las fotos de los artes salen del móvil o de la cámara y pesan 8 o 10 MB:
  // se reducen antes de subir. Lo que no es imagen (PDF, AI, PSD) va tal cual.
  files=await Promise.all(files.map(_attAligerar));
  // Mientras suben se ve el cartel de «cargando», que antes no había: se
  // decía «adjuntado» y la pantalla seguía igual hasta refrescar.
  _attCargando(files.length, files.length);
  showT('Subiendo '+files.length+' archivo'+(files.length>1?'s':'')+'...');
  var pend=files.length;
  files.forEach(function(f){
    _subirDocStorage(oid, stageKey, f).then(function(path){
      if(path){
        _registrarDoc(oid, stageKey, f, path).then(function(reg){
          var fallo = !reg || reg._error;
          window._atts[k].push({
            id: (reg && !reg._error) ? reg.id : undefined,
            name:f.name,
            data: DOCS_BASE + path.split('/').map(encodeURIComponent).join('/'),
            url:path, date:now2(), by:(CU?CU.name:''), remoto:true,
            _soloMio: fallo ? true : undefined
          });
          if(fallo){
            showT('⚠ «'+f.name+'» se subió pero NO quedó registrado: solo lo ves tú. '
              +'Vuelve a subirlo. ('+((reg&&reg._error)||'sin respuesta')+')', 12000);
          }
          try{ _solPagoDepositoAdjunto(oid, stageKey, path, f.name); }catch(e){}
          _finAttach(oid, stageKey, files.length, --pend);
        });
      } else {
        // Se dice POR QUÉ no subió: antes solo salía «no se pudo subir»
        showT('⚠ No se pudo subir «'+f.name+'»'
          +(window._attErr?(': '+window._attErr):''), 12000);
        _finAttach(oid, stageKey, files.length, --pend);
      }
    });
  });
}
function _finAttach(oid, stageKey, totalFiles, pend){
  _attCargando(totalFiles, pend);
  if(pend<=0){
    _attCargando(0,0);
    showT('✓ '+totalFiles+' archivo'+(totalFiles>1?'s':'')+' guardado'+(totalFiles>1?'s':''));
    _refrescarTrasAdjuntar(oid, stageKey);
  }
}

/* Reduce una imagen pesada antes de subirla: 2000 px de lado mayor y JPEG
   al 82%. Una foto de 9 MB baja a menos de 1, sube en un par de segundos y
   se ve igual en pantalla. Si algo falla, se sube el original. */
var ATT_MAX_MB = 1.6;
function _attAligerar(f){
  return new Promise(function(res){
    try{
      if(!/^image\//.test(f.type||'') || f.size <= ATT_MAX_MB*1024*1024) return res(f);
      var fr=new FileReader();
      fr.onload=function(){
        var img=new Image();
        img.onload=function(){
          try{
            var max=2000, w=img.width, h=img.height;
            if(w>max || h>max){
              if(w>=h){ h=Math.round(h*max/w); w=max; }
              else { w=Math.round(w*max/h); h=max; }
            }
            var cv=document.createElement('canvas');
            cv.width=w; cv.height=h;
            cv.getContext('2d').drawImage(img,0,0,w,h);
            cv.toBlob(function(b){
              if(!b || b.size>=f.size) return res(f);
              var nombre=f.name.replace(/\.[^.]+$/,'')+'.jpg';
              var out=new File([b], nombre, {type:'image/jpeg'});
              _dbg('[att] '+f.name+': '+Math.round(f.size/1024)+' KB -> '
                   +Math.round(out.size/1024)+' KB');
              res(out);
            }, 'image/jpeg', 0.82);
          }catch(e){ res(f); }
        };
        img.onerror=function(){ res(f); };
        img.src=fr.result;
      };
      fr.onerror=function(){ res(f); };
      fr.readAsDataURL(f);
    }catch(e){ res(f); }
  });
}

// El cartel de «cargando archivos», pegado abajo mientras suben
function _attCargando(total, pend){
  var id='attCargando';
  var el=document.getElementById(id);
  if(!total || pend<=0){ if(el) el.remove(); return; }
  if(!el){
    el=document.createElement('div');
    el.id=id;
    el.style.cssText='position:fixed;left:50%;bottom:22px;transform:translateX(-50%);'
      +'z-index:10080;background:var(--surface-0);border:0.5px solid var(--border);'
      +'border-radius:11px;padding:10px 16px;box-shadow:0 8px 26px rgba(0,0,0,.18);'
      +'display:flex;align-items:center;gap:10px;font-size:12.5px';
    document.body.appendChild(el);
  }
  el.innerHTML='<span class="ai-ring g"></span> Cargando archivos… '
    +'<b>'+(total-pend)+' de '+total+'</b> ';
}

// Después de subir se refresca lo que esté abierto: el paso, la ficha de la
// orden o la propia pantalla. Antes solo se intentaba el paso, y si el
// usuario estaba en otra vista no se veía nada hasta recargar.
function _refrescarTrasAdjuntar(oid, stageKey){
  // Se repinta SOLO el paso y se deja al usuario donde estaba: volver a
  // abrir la ficha entera lo sacaba del sitio cada vez que subía un archivo.
  var y=window.scrollY;
  var ok=false;
  try{ ok=(_redibujarPaso(oid, stageKey)!==false); }catch(e){ ok=false; }
  // Si el paso ya no está en pantalla (se cambió de vista), se refresca lo
  // que haya abierto, pero solo en ese caso.
  try{
    var m=String(stageKey).match(/^(.*)_step(\d+)$/);
    var base=m?m[1]:stageKey;
    var si=STAGES.findIndex(function(z){ return z.key===base; });
    if(si>=0 && !document.getElementById('egb-'+oid+'-'+si)){
      var mod=document.getElementById('modal');
      if(mod && mod.style.display!=='none' && typeof openDetail==='function') openDetail(oid);
      else if(typeof PG!=='undefined' && PG) go(PG);
    }
  }catch(e){}
  setTimeout(function(){ window.scrollTo(0, y); }, 30);
}
// Redibuja el paso y REABRE la sub-etapa donde se subió/eliminó el archivo,
// para que el adjunto se vea al instante (sin salir de la pantalla).
// stageKey puede venir como 'artes_step3' (con sub-paso) o 'artes' (etapa).
function _redibujarPaso(oid, stageKey){
  // Caso especial: adjuntos de "Pendientes de SAP" (no es una etapa normal)
  if(stageKey==='__pendsap'){ if(PG==='dashboard'&&dashKpiFilter==='sap')rDash(); return; }
  // Separar la etapa base del índice de sub-paso, si viene como 'etapa_stepN'
  var baseKey=stageKey, subIdx=null;
  var m=String(stageKey).match(/^(.*)_step(\d+)$/);
  if(m){ baseKey=m[1]; subIdx=parseInt(m[2]); }
  var si=STAGES.findIndex(function(s){return s.key===baseKey;});
  if(si<0) return;
  var b=document.getElementById('egb-'+oid+'-'+si);
  if(!b) return;
  buildEGB(oid,si,b);
  // Reabrir la sub-etapa donde estaba el usuario
  if(subIdx!==null){
    setTimeout(function(){
      var sb=document.getElementById('ssb-'+oid+'-'+si+'-'+subIdx);
      var chev=document.getElementById('ssch-'+oid+'-'+si+'-'+subIdx);
      if(sb){ sb.style.display='block'; if(chev)chev.style.transform='rotate(180deg)'; }
    },0);
  }
}
async function delAtt(oid,sk,i,sinPreguntar){
  var k=oid+sk;
  var a = window._atts&&window._atts[k]?window._atts[k][i]:null;
  // Confirmación antes de borrar: el archivo se va también del almacenamiento.
  // El borrado en bloque ya preguntó una vez por todos.
  if(!sinPreguntar && !confirm('¿Está seguro de que desea borrar el archivo "'+((a&&a.name)||'sin nombre')+'"?\n\nSe elimina del portal y del almacenamiento.\n\nEsta acción no se puede deshacer.')) return;
  if(a && a.id){
    // Borra el registro y el archivo del Storage
    try{
      await fetch(SB+'/rest/v1/compras_documentos?id=eq.'+a.id, {method:'DELETE', headers:SBH});
      if(a.url) await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+a.url.split('/').map(encodeURIComponent).join('/'), {method:'DELETE', headers:{'apikey':KEY,'Authorization':SBH.Authorization}});
    }catch(e){ console.error('borrar doc:', e); }
  }
  if(window._atts&&window._atts[k])window._atts[k].splice(i,1);
  _redibujarPaso(oid, sk);
  // Los paneles que viven de esos archivos —el costeo y los precios de
  // venta— se rehacen también: antes había que salir y volver a entrar para
  // que desapareciera el costeo borrado.
  try{
    var _p=document.getElementById('costeopanel-'+oid);
    if(_p) _p.innerHTML=_costPanel(oid);
    var _pv=document.getElementById('pvpanel-'+oid);
    if(_pv) _pv.innerHTML=_pvPanel(oid);
  }catch(e){}
  try{ if(typeof _costRepintar==='function') _costRepintar(oid); }catch(e){}
  showT('Archivo eliminado');
}


function buildEGB(oid,idx,container){
  const o=orders.find(x=>x.id===oid);if(!o)return;
  const stage=STAGES[idx];if(!stage)return;
  initP(oid);
  const sp2=stageProgress[oid][stage.key];
  const si=getStageIdx(o);
  const isCurr=!o.completada&&!o.pend&&idx===si;
  const isDone=sp2.stepIdx>=stage.steps.length;
  // Gerencia puede editar cualquier etapa
  // Diseño ve la etapa de Pedido para consultar la orden y las fotos, pero
  // no la trabaja: ahí solo mira, descarga y comenta en el chat.
  const soloMira = CU && CU.role==='diseno' && stage.key==='pedido';
  const canEdit=!soloMira && CU
    && (CU.role==='gerencia'||(isCurr&&canSeeStage(stage.key)));

  let html='<div class="sub-steps">';
  stage.steps.forEach(function(step,i){
    const done=i<sp2.stepIdx, active=i===sp2.stepIdx&&(isCurr||canEdit);
    // El color del semáforo refleja el ESTADO real del paso (no los permisos):
    // verde=completado, amarillo=paso en curso, rojo=pendiente.
    const esPasoActivo=i===sp2.stepIdx;
    // Punto 1: el "Registro de Booking" queda AMARILLO hasta que se registre al menos
    // un contenedor con su número (aunque el paso se haya marcado como hecho).
    var _bookingIncompleto=false;
    if(stage.key==='logistica' && step.name==='Registro de Booking'){
      var _bk=getBK(oid);
      var _tieneCtn=_bk && _bk.containers && _bk.containers.some(function(c){return c && c.id && String(c.id).trim();});
      if(!_tieneCtn) _bookingIncompleto=true;
    }
    const cls=done?'ss-done':active?'ss-active':'ss-future';
    var sem=done?'sem-g':esPasoActivo?'sem-y':'sem-r';
    if(_bookingIncompleto) sem='sem-y';
    const stepDate=sp2.stepDates&&sp2.stepDates[i]?sp2.stepDates[i]:'';
    const dur=done&&stepDate?daysBetween(stepDate,null):0;
    // Sub-key para adjuntos individuales por sub-etapa
    const subKey=stage.key+'_step'+i;
    // A los adjuntos propios del subpaso se suman los documentos base de la
    // orden (la orden de KCC y la del proveedor). Se muestran en Pedido y en
    // Depósito & Pago, que es donde se necesitan, SIN duplicar el archivo:
    // es la misma URL, solo se referencia.
    const subAtts=_attsDelSubpaso(oid, stage.key, i, subKey);

    html+='<div class="ss '+cls+'" style="border-radius:8px;margin-bottom:8px;border:0.5px solid var(--border);overflow:hidden">';
    // Header de sub-etapa
    html+='<div style="display:flex;align-items:center;gap:8px;padding:9px 12px;background:var(--surface-1);cursor:pointer" onclick="toggleSubStep(\''+oid+'\','+idx+','+i+')">';
    html+='<span class="sem '+sem+'" style="width:10px;height:10px;flex-shrink:0"></span>';
    html+='<div style="flex:1"><div class="ss-name">'+step.name+'</div>';
    var stepBy=(sp2.stepBy&&sp2.stepBy[i])?sp2.stepBy[i]:'';
    if(stepDate)html+='<div class="ss-dates"><i class="ti ti-calendar" style="font-size:9px"></i> '+(done?'Completado':'Iniciado')+': '+stepDate+(done&&dur>0?' ('+dur+'d)':'')+(stepBy?' <span style="color:var(--text-accent)">· por '+stepBy+'</span>':'')+'</div>';
    html+='</div>';
    html+='<div style="display:flex;gap:5px;align-items:center">';
    html+='<button class="btn" title="Enviar correo sobre este paso" onclick="event.stopPropagation();mailAbrir(\''+oid+'\',\''+stage.key+'\','+i+')" style="padding:3px 7px;font-size:10px;background:transparent;border:0.5px solid var(--border)"><i class="ti ti-mail" style="font-size:12px;color:var(--text-accent)"></i></button>';
    if(subAtts.length)html+='<span style="font-size:10px;background:var(--bg-accent);color:var(--text-accent);padding:1px 6px;border-radius:8px"><i class="ti ti-paperclip" style="font-size:9px"></i> '+subAtts.length+'</span>';
    // Los pasos que ejecuta compras (solicitud de abono y pago final) no los
    // puede marcar contabilidad: se completan solos al enviar el correo.
    var _deCompras = stage.key==='deposito' && [_PASO_SOL_ABONO,_PASO_PAGO_FINAL,_PASO_COMP_PROV,_PASO_COMP_FINAL].indexOf(step.name)>=0;
    var _deContab  = stage.key==='deposito' && step.name===_PASO_DEP_PROV;
    var _puedeMarcar = _deCompras
      ? (_esCompras()||CU.role==='gerencia')
      : _deContab
        ? (CU.role==='contabilidad'||CU.role==='gerencia')
        : (CU.role===step.role||CU.role==='gerencia');
    // El botón sale en el paso activo y también en los anteriores sin cerrar:
    // así ningún paso queda sin forma de ponerse en verde.
    var _pendiente = !done && (i <= (sp2.stepIdx||0));
    if((active||_pendiente) && _puedeMarcar)
      html+='<button class="btn" title="Dejar este paso en verde" style="padding:3px 8px;font-size:10px;background:#639922;color:white;white-space:nowrap" onclick="event.stopPropagation();advSS(\''+oid+'\',\''+stage.key+'\','+i+')">✓ Marcar hecho</button>';
    if(done&&(CU.role===step.role||CU.role==='gerencia'))html+='<button class="btn bundo" onclick="event.stopPropagation();undoSS(\''+oid+'\',\''+stage.key+'\','+i+')"><i class="ti ti-arrow-back-up" style="font-size:10px"></i></button>';
    html+='<i class="ti ti-chevron-down" id="ssch-'+oid+'-'+idx+'-'+i+'"></i>';
    html+='</div></div>';
    // Body de sub-etapa (oculto por defecto)
    html+='<div id="ssb-'+oid+'-'+idx+'-'+i+'" style="display:none;padding:10px 12px;border-top:0.5px solid var(--border)">';

    // LOGÍSTICA — Tracker multi-contenedor en todos los pasos
    if(stage.key==='logistica'){
      // Punto 3: en "Llegó a destino", panel de confirmación de arribo
      if(step.name==='Llegó a destino'){
        html+=buildLlegadaDestino(oid);
      }
      var bk=getBK(oid);
      // El editor viejo de booking ya no se usa: los paneles nuevos de
      // Booking, B/L y Aviso de llegada traen esos campos y duplicarlos
      // confundía. Solo queda el resumen visual de los contenedores.
      if(false){
        html+='<div id="log-tracker-'+oid+'"></div>';
      } else {
        // Pasos 2-5: resumen de contenedores (solo lectura) + mini barquitos
        if(bk.naviera||bk.containers.length){
          html+='<div style="background:var(--bg-accent);border-radius:8px;padding:8px 12px;margin-bottom:8px">';
          if(bk.naviera||bk.booking)html+='<div style="font-size:11px;font-weight:600;margin-bottom:6px"><span style="color:var(--text-accent)">'+(NAVIERA_EMOJI[bk.naviera]||'🚢')+' '+bk.naviera+'</span>'+(bk.booking?' · BL/Booking: <code style="font-size:10px;background:var(--surface-1);padding:1px 5px;border-radius:4px">'+bk.booking+'</code>':'')+'</div>';
          bk.containers.forEach(function(ctn,ci){
            var hoy=new Date();
            var sal=ctn.etaSalida?new Date(ctn.etaSalida):null;
            var lle=ctn.etaLlegada?new Date(ctn.etaLlegada):null;
            var pct2=0,enRuta2=false,llegado2=false,diasFalta2=0,diasTrans2=0;
            if(sal&&lle){
              if(hoy<sal){pct2=0;}
              else if(hoy>=lle){pct2=100;llegado2=true;}
              else{diasTrans2=Math.round((hoy-sal)/(1000*60*60*24));diasFalta2=Math.round((lle-hoy)/(1000*60*60*24));var tot=Math.max(1,Math.round((lle-sal)/(1000*60*60*24)));pct2=Math.min(95,Math.round((diasTrans2/tot)*100));enRuta2=true;}
            }
            var sc2=llegado2?'#27500A':enRuta2?'#185FA5':'#888';
            var leftP=Math.max(2,Math.min(92,pct2));
            html+='<div style="margin-bottom:6px;background:linear-gradient(180deg,#E8F4FD,#C8E6F8);border-radius:7px;padding:7px 10px">';
            html+='<div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">';
            html+='<span style="font-size:13px">'+(NAVIERA_EMOJI[bk.naviera]||'🚢')+'</span>';
            html+='<code style="font-size:11px;font-weight:700;letter-spacing:.5px">'+(ctn.id||'Sin número')+'</code>';
            html+='<button data-oid="'+oid+'" data-ci="'+ci+'" class="ctn-track-mini" style="padding:2px 8px;background:'+(NAVIERA_COLOR[bk.naviera]||'#185FA5')+';color:white;border:none;border-radius:5px;font-size:9px;cursor:pointer;margin-left:auto"><i class="ti ti-current-location" style="font-size:9px"></i> Track</button>';
            html+='</div>';
            // Mini barquito
            html+='<div style="position:relative;height:20px">';
            html+='<div style="position:absolute;top:50%;left:14px;right:14px;height:1.5px;background:rgba(255,255,255,.6);transform:translateY(-50%)"></div>';
            if(pct2>0)html+='<div style="position:absolute;top:50%;left:14px;width:calc('+leftP+'% - 14px);height:1.5px;background:'+sc2+';transform:translateY(-50%)"></div>';
            html+='<div style="position:absolute;left:calc('+leftP+'% - 10px);top:0;font-size:16px;line-height:1;filter:drop-shadow(0 1px 2px rgba(0,0,0,.2))">'+(NAVIERA_EMOJI[bk.naviera]||'🚢')+'</div>';
            html+='</div>';
            if(enRuta2)html+='<div style="font-size:9px;color:var(--text-muted);margin-top:2px">'+diasTrans2+'d en ruta · '+diasFalta2+'d restantes</div>';
            else if(llegado2)html+='<div style="font-size:9px;color:var(--t-oliva);font-weight:600;margin-top:2px">✓ Llegó a Panamá</div>';
            html+='</div>';
          });
          if(!bk.containers.length)html+='<div style="font-size:11px;color:var(--text-muted)">Sin contenedores registrados. Agrégalos en el paso Booking.</div>';
          html+='</div>';
        }
      }
    }

    // ARTES ENVIADOS AL PROVEEDOR — panel de WeTransfer + correos
    // ARTES APROBADOS POR GERENCIA — ganchito de aprobación + comentario
    // PEDIDO — revisar orden de compra (Excel/PDF) con IA
    if(stage.key==='pedido' && step.name==='Pedido creado por compras'){
      html+=buildRevisionIAGenerica(oid, subKey, 'excel');
    }
    // DEPÓSITO — verificar datos bancarios con IA
    if(stage.key==='deposito'){
      html+=buildRevisionIAGenerica(oid, subKey, 'deposito');
    }
    // ARTES TERMINADOS — el orden con el que se trabaja: primero se adjuntan
    // los archivos (arriba, con los documentos del paso), después la revisión
    // con IA y, al final, el envío a gerencia.
    if(stage.key==='artes' && step.name==='Artes terminados'){
      html+=_artesZonaSubida(oid, subKey);      // 1 · la caja grande de arriba
      // Para rehacer los artes sin ir borrando uno a uno
      var _nArt=(window._atts&&window._atts[oid+subKey])
        ? _dedupDocs(window._atts[oid+subKey]).length : 0;
      if(_nArt>1){
        html+='<div style="text-align:right;margin:-4px 0 8px">'
          +'<button class="xb" style="font-size:11px;color:var(--t-rojo)" '
          +'onclick="event.stopPropagation();_artesBorrarTodos(\''+oid+'\',\''
          +subKey+'\')"><i class="ti ti-trash"></i> Eliminar los '+_nArt
          +' archivos</button></div>';
      }
      html+=buildRevisionIA(oid, subKey);       // 2 · revisar con IA
    }

    if(stage.key==='artes' && step.name===_PASO_ARTES_FIN){
      try{ html+=_artesBotonEnviar(oid); }catch(e){ html+=_panelErrLog('Artes', e); }
    }
    if(stage.key==='artes' && step.name===_PASO_ARTES_APROB){
      try{ html+=_artesRevisionPanel(oid); }catch(e){ html+=_panelErrLog('Revisión de artes', e); }
      html+=buildArtesAprobacion(oid);
    }

    // BODEGA & VENTA
    if(stage.key==='bodega'){
      if(step.name===_PASO_BOD_REC){
        html+='<div id="bodrec-'+oid+'">';
        try{ html+=_bodRecibidoPanel(oid); }catch(e){ html+=_panelErrLog('Recibido en bodega', e); }
        html+='</div>';
      } else if(step.name===_PASO_BOD_SAP){
        html+='<div id="bodsap-'+oid+'">';
        try{ html+=_bodFaltantesPanel(oid); }catch(e){ html+=_panelErrLog('Disponible en SAP', e); }
        html+='</div>';
      } else if(step.name===_PASO_BOD_SALA){
        html+='<div id="bodsala-'+oid+'">';
        try{ html+=_bodSalaPanel(oid); }catch(e){ html+=_panelErrLog('En sala de venta', e); }
        html+='</div>';
      }
    }

    // ADUANIZACIÓN & COSTEO
    // Si un panel falla, se muestra el error en pantalla en vez de tragarlo:
    // un try/catch mudo hacía desaparecer el panel entero sin dejar rastro.
    if(stage.key==='costeo'){
      function _panelErr(nombre, e){
        console.error('['+nombre+']', e);
        return '<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;margin-bottom:8px;font-size:11.5px;color:var(--t-rojo)">'
          +'<b><i class="ti ti-alert-triangle"></i> No se pudo mostrar el panel de '+nombre+'</b>'
          +'<div style="margin-top:3px;font-family:monospace;font-size:10.5px">'+_esc(e&&(e.message||String(e)))+'</div>'
          +'<div style="margin-top:3px">Pasale este mensaje a soporte.</div></div>';
      }
      if(step.name===_PASO_DMCE){
        html+='<div id="adupanel-'+oid+'">';
        try{ html+=_aduPanel(oid); }catch(e){ html+=_panelErr('DMCE y SIGA', e); }
        html+='</div>';
      } else if(step.name===_PASO_DMCE_SAL){
        html+='<div id="dmcesal-'+oid+'">';
        try{ html+=_dmceSalidaPanel(oid); }catch(e){ html+=_panelErr('DMCE de salida', e); }
        html+='</div>';
        try{ _dmceSalidaCheck(oid); }catch(e){}
      } else if(step.name===_PASO_PRECIOS){
        html+='<div id="pvpanel-'+oid+'">';
        try{ html+=_pvPanel(oid); }catch(e){ html+=_panelErr('Precios de venta', e); }
        html+='</div>';
      } else if(step.name===_PASO_COSTEO){
        html+='<div id="costeopanel-'+oid+'">';
        try{ html+=_costPanel(oid); }catch(e){ html+=_panelErr('Costeo de importación', e); }
        html+='</div>';
      }
    }

    // LOGÍSTICA — booking, B/L y aviso de llegada
    if(stage.key==='logistica'){
      var _kLog = step.name===_PASO_BOOKING ? 'booking'
                : step.name===_PASO_BL      ? 'bl'
                : step.name===_PASO_ARRIVAL ? 'arrival' : '';
      if(_kLog){
        html+='<div id="logpanel-'+_kLog+'-'+oid+'">';
        try{
          html+= _kLog==='booking' ? _logPanelBooking(oid)
               : _kLog==='bl'      ? _logPanelBL(oid)
                                   : _logPanelArrival(oid);
        }catch(e){ html+=_panelErrLog('Logística', e); }
        html+='</div>';
      }
    }

    // PRODUCCIÓN — inspección y aprobación del encargado
    if(stage.key==='produccion' && step.name===_PASO_INSPECCION){
      html+='<div id="insppanel-'+oid+'">';
      try{ html+=_inspPanel(oid); }catch(e){ html+=_panelErrLog('Inspección', e); }
      html+='</div>';
      if(!window._hubDesc['insp_'+oid]){
        _inspDescargasCargar(oid).then(function(ds){ if(ds&&ds.length) _inspRepintar(oid); });
      }
    }

    // ARTES — HUB de diseño: la orden firmada de KCC va sola, más dos zonas
    // para que se suban el Excel de la orden y los archivos del proveedor.
    if(stage.key==='artes' && step.name==='HUB de diseño'){
      html+='<div class="hub-2col">';
      html+='<div class="hub-col-docs">';
      try{ html+=_hubDisenoPanel(oid); }catch(e){ html+=_panelErrLog('HUB de diseño', e); }
      // Vigilancia de las descargas: mientras haya alguna en curso se
      // consulta seguido y, apenas termina, se traen los archivos y se
      // repinta el HUB sin que haya que recargar nada a mano.
      try{ _hubVigilar(oid); }catch(e){ console.warn('vigilar descargas:',e); }
    }

    // DEPÓSITO — envío de correos
    // Compras: en "Solicitud de depósito enviada" puede mandar la solicitud + OC a contabilidad
    if(stage.key==='deposito' && step.name==='Solicitud de depósito enviada'){
      try{ html+=_solAvisoSinSolicitud(oid,'abono',i); }catch(e){}
      try{ html+=_solEnvioPanel(oid,'abono'); }catch(e){}
      // Solo compras y gerencia pueden enviar la solicitud
      if(CU && (_esCompras()||CU.role==='gerencia')){
        try{ html+=_solPagoBotonAbono(oid); }catch(e){}
      } else if(CU && CU.role==='contabilidad'){
        html+='<div style="font-size:11px;color:var(--text-muted);background:var(--surface-1);border-radius:7px;padding:7px 10px;margin-bottom:8px">'
          +'<i class="ti ti-lock"></i> Este paso lo completa compras. Aquí solo puedes consultar los documentos.</div>';
      }
    }
    // Compras: pedir a contabilidad la cancelación del saldo final,
    // eligiendo el destinatario entre los usuarios de contabilidad
    // Pago final: mismo circuito que la solicitud de abono, por Azure
    if(stage.key==='deposito' && step.name==='Solicitud de final del balance'){
      try{ html+=_solAvisoSinSolicitud(oid,'cancelacion',i); }catch(e){}
      try{ html+=_solEnvioPanel(oid,'cancelacion'); }catch(e){}
      if(CU && (_esCompras()||CU.role==='gerencia')){
        try{ html+=_solPagoBotonCancelacion(oid); }catch(e){}
      }
    }
    // Contabilidad: en "Depósito enviado al proveedor" puede mandarlo por correo con copias
    if(stage.key==='deposito' && step.name==='Depósito enviado al proveedor'){
      // Lo que contabilidad ya envió, visible para todos
      try{ html+=_solEnvioPanel(oid,'comprobante_abono'); }catch(e){}
      if(CU && (CU.role==='contabilidad'||CU.role==='gerencia')){
        html+='<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
          +'<div style="font-size:11.5px;font-weight:600;color:var(--t-verde2);margin-bottom:6px"><i class="ti ti-receipt"></i> Enviar el comprobante del depósito a compras</div>'
          +'<button class="btn bp" style="background:#085041;font-size:11px;padding:6px 12px" onclick="_compAbrirModal(\''+oid+'\',\'abono\')">'
          +'<i class="ti ti-send"></i> Redactar comprobante</button></div>';
      }
    }
    // Compras: reenvía al proveedor el comprobante que dejó contabilidad
    if(stage.key==='deposito' && (step.name===_PASO_COMP_PROV || step.name===_PASO_COMP_FINAL)){
      var _esComp=(step.name===_PASO_COMP_PROV);
      try{ html+=_solEnvioPanel(oid, 'proveedor_'+(_esComp?'abono':'cancelacion')); }catch(e){}
      if(CU && (_esCompras()||CU.role==='gerencia')){
        html+='<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
          +'<div style="font-size:11.5px;font-weight:600;color:var(--t-azul);margin-bottom:6px"><i class="ti ti-send"></i> Enviar el comprobante al proveedor</div>'
          +'<button class="btn bp" style="font-size:11px;padding:6px 12px" onclick="_provAbrirModal(\''+oid+'\',\''+(_esComp?'abono':'cancelacion')+'\')">'
          +'<i class="ti ti-mail"></i> Redactar correo al proveedor</button></div>';
      } else if(CU && CU.role==='contabilidad'){
        html+='<div style="font-size:11px;color:var(--text-muted);background:var(--surface-1);border-radius:7px;padding:7px 10px;margin-bottom:8px">'
          +'<i class="ti ti-lock"></i> Este paso lo completa compras. Aquí solo puedes consultar.</div>';
      }
    }
    // Contabilidad: en "Solicitud de final del balance" envía el comprobante de la cancelación
    if(stage.key==='deposito' && step.name==='Solicitud de final del balance'){
      try{ html+=_solEnvioPanel(oid,'comprobante_cancelacion'); }catch(e){}
      if(CU && (CU.role==='contabilidad'||CU.role==='gerencia')){
        html+='<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
          +'<div style="font-size:11.5px;font-weight:600;color:var(--t-verde2);margin-bottom:6px"><i class="ti ti-receipt"></i> Enviar el comprobante de la cancelación a compras</div>'
          +'<button class="btn bp" style="background:#085041;font-size:11px;padding:6px 12px" onclick="_compAbrirModal(\''+oid+'\',\'cancelacion\')">'
          +'<i class="ti ti-send"></i> Redactar comprobante</button></div>';
      }
    }

    if(stage.key==='artes' && step.name===_PASO_ARTES_PROV){
      try{ html+=_artesPanelProveedor(oid); }catch(e){ html+=_panelErrLog('Artes al proveedor', e); }
      html+=buildArtesEnvio(oid);
    }

    // Adjuntos de esta sub-etapa
    var _nBase=subAtts.filter(function(a){return a&&a._base;}).length;
    html+='<div style="font-size:10px;color:var(--text-muted);font-weight:500;margin-bottom:5px"><i class="ti ti-paperclip"></i> Archivos de este paso ('+subAtts.length+')'
      +(_nBase?(' <span style="color:var(--t-lila);font-weight:600">· '+_nBase+' de la orden</span>'):'')+'</div>';
    // Punto 1: el usuario de diseño NO puede eliminar archivos en el pedido ni en
    // "artes aprobados por gerencia" (solo ver y descargar). En sus propios pasos sí.
    var _bloqueDiseno = (CU&&CU.role==='diseno') && (stage.key==='pedido' || (stage.key==='artes' && step.name==='Artes aprobados por gerencia'));
    // En la etapa de Depósito cada rol solo trabaja SUS pasos; en los del otro
    // puede consultar los archivos y usar el chat, pero no modificar nada.
    var _pasosDeCompras = [_PASO_SOL_ABONO, _PASO_PAGO_FINAL, _PASO_COMP_PROV, _PASO_COMP_FINAL];
    var _pasosDeContab  = [_PASO_DEP_PROV];
    var _bloqueContab = (CU&&CU.role==='contabilidad') && stage.key==='deposito'
      && _pasosDeCompras.indexOf(step.name)>=0;
    var _bloqueCompras = (CU&&_esCompras()) && stage.key==='deposito'
      && _pasosDeContab.indexOf(step.name)>=0;
    // Diseño en la etapa de Pedido: solo consulta. Podía subir archivos aunque
    // no pudiera borrarlos, y esa etapa no la trabaja: solo mira, descarga y
    // escribe en el chat.
    var _soloConsulta = _bloqueContab || _bloqueCompras
      || ((CU&&CU.role==='diseno') && stage.key==='pedido');
    var _puedeEliminar = !_bloqueDiseno && !_soloConsulta;
    // Los documentos base de la orden se muestran aquí pero no se borran desde
    // el subpaso: pertenecen a la orden, no a este paso.
    var _esBase=function(a){ return !!(a&&a._base); };
    // Ver todas las imágenes del paso seguidas, sin abrir y cerrar una a una
    var _nImg=subAtts.filter(function(a){
      return ['jpg','jpeg','png','gif','webp'].indexOf(
        (String(a.name||'').split('.').pop()||'').toLowerCase())>=0; }).length;
    if(_nImg>1){
      html+='<div style="margin-bottom:6px;display:flex;gap:7px;flex-wrap:wrap">'
        +'<button class="xb" style="font-size:11px" '
        +'onclick="event.stopPropagation();_visorTodas(\''+oid+'\',\''+subKey+'\')">'
        +'<i class="ti ti-photo-search"></i> Abrir las '+_nImg+' en vista previa</button>'
        +'</div>';
    }
    if(subAtts.length){
      html+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:7px">';
      subAtts.forEach(function(a,ai){
        var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
        var extImg=['jpg','jpeg','png','gif','webp'];
        var _info=(a.by?('Subido por '+a.by):'')+(a.date?(a.by?' · ':'')+a.date:'');
        if(extImg.includes(ext)){
          html+='<div style="position:relative;display:inline-block;margin:2px">'
            +'<img src="'+a.data+'" data-src="'+a.data+'" data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-img" style="width:58px;height:58px;object-fit:cover;border-radius:5px;cursor:zoom-in;border:0.5px solid var(--border)" title="'+a.name+(_info?' — '+_info:'')+'">'
            +((_puedeEliminar&&!_esBase(a))?'<button data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-del" title="Eliminar este archivo" onclick="event.stopPropagation()" style="position:absolute;top:-6px;right:-6px;background:#e24b4a;color:white;border:2px solid var(--surface-0);border-radius:50%;width:22px;height:22px;font-size:12px;cursor:pointer;line-height:18px;padding:0;text-align:center;z-index:3;box-shadow:0 1px 4px rgba(0,0,0,.3)">\xd7</button>':'')+'</div>';
        } else {
          var ic=ext==='pdf'?'📄':ext==='xlsx'||ext==='xls'?'📊':ext==='doc'||ext==='docx'?'📝':'📎';
          var abrir=a.data?(' onclick="verArchivo(\''+a.data+'\',\''+(a.name||'').replace(/'/g,"\\\\'")+'\')" '+_prevAttrs(a.data,a.name)):'';
          html+='<div style="display:inline-flex;align-items:center;gap:5px;padding:3px 8px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:var(--radius);font-size:11px;margin:2px;cursor:pointer" title="'+(_info||a.name)+'"'+abrir+'>'
            +ic+' <span style="max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+a.name+'</span>'
            +((_puedeEliminar&&!_esBase(a))?'<button data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-del" style="background:none;border:none;color:var(--text-danger);cursor:pointer;padding:0;font-size:13px;line-height:1">\xd7</button>':'')+'</div>';
        }
      });
      html+='</div>';
    }
    // Contabilidad no adjunta nada en los pasos que ejecuta compras: ahí solo consulta
    if(_soloConsulta){
      html+='<div style="display:flex;align-items:center;gap:7px;padding:6px 10px;background:var(--surface-1);border-radius:var(--radius);font-size:11px;color:var(--text-muted);margin-bottom:7px">'
        +'<i class="ti ti-lock"></i> Solo lectura: '
        +((CU&&CU.role==='diseno')
            ? 'la etapa de Pedido la trabaja compras'
            : ('este paso lo completa '+(_bloqueCompras?'contabilidad':'compras')))
        +'. Puedes abrir los archivos y escribir en el chat.</div>';
    }
    if(!_soloConsulta) html+='<label style="display:flex;align-items:center;gap:7px;padding:6px 10px;border:1.5px dashed var(--border);border-radius:var(--radius);cursor:pointer;font-size:11px;color:var(--text-secondary);margin-bottom:8px;background:var(--surface-1)"><i class="ti ti-upload" style="font-size:12px;color:var(--text-accent)"></i>Adjuntar a este paso<input type="file" multiple accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" style="display:none" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-input"></label>';
    // Live chat de sub-etapa
    var subComKey='sub_'+oid+'_'+subKey;
    // En el HUB de diseño la conversación es lo principal: se pone a la
    // izquierda y en grande, con los documentos al costado.
    var _dosCol=(stage.key==='artes' && step.name==='HUB de diseño');
    if(_dosCol){
      html+='</div>';   // cierra la columna de documentos
      html+='<div class="hub-col-chat">';
      html+='<div style="font-size:11.5px;color:var(--text-secondary);font-weight:700;margin-bottom:6px"><i class="ti ti-message"></i> Live chat de este paso</div>';
      html+='<div id="subcms-'+oid+'-'+idx+'-'+i+'" data-ck="'+subComKey+'" class="hub-chat-lista">'+renderSubComs(subComKey)+'</div>';
      try{ _chatAlAbrir(subComKey); }catch(e){}
      html+='<div id="submen-'+oid+'-'+idx+'-'+i+'" style="display:none;position:relative;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:200px;overflow-y:auto;z-index:60;margin-bottom:4px"></div>';
      html+='<div class="cir"><textarea class="cin" id="subcin-'+oid+'-'+idx+'-'+i+'" rows="2" placeholder="Escribe en el chat de este paso... usa @ para mencionar" oninput="_menRefrescar(\'subcin-'+oid+'-'+idx+'-'+i+'\',\'submen-'+oid+'-'+idx+'-'+i+'\')" onblur="setTimeout(function(){_menCerrar(\'submen-'+oid+'-'+idx+'-'+i+'\');},150)" style="font-size:12px"></textarea>'
        +'<button class="btn bp" onclick="addSubCom(\''+oid+'\','+idx+','+i+')" style="align-self:flex-end;padding:6px 10px"><i class="ti ti-send"></i></button></div>';
      html+='</div>';       // cierra la columna del chat
      html+='</div>';       // cierra el contenedor de dos columnas
      html+='</div></div>'; // cierra body + div ss (los DOS, como el flujo normal)
      return;
    }
    html+='<div style="font-size:10px;color:var(--text-muted);font-weight:500;margin-bottom:4px"><i class="ti ti-message"></i> Live chat de este paso</div>';
    html+='<div id="subcms-'+oid+'-'+idx+'-'+i+'" data-ck="'+subComKey+'" style="margin-bottom:6px">'+renderSubComs(subComKey)+'</div>';
    try{ _chatAlAbrir(subComKey); }catch(e){}
    html+='<div id="submen-'+oid+'-'+idx+'-'+i+'" style="display:none;position:relative;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:200px;overflow-y:auto;z-index:60;margin-bottom:4px"></div>';
    html+='<div class="cir"><textarea class="cin" id="subcin-'+oid+'-'+idx+'-'+i+'" rows="1" placeholder="Escribe en el chat de este paso... usa @ para mencionar" oninput="_menRefrescar(\'subcin-'+oid+'-'+idx+'-'+i+'\',\'submen-'+oid+'-'+idx+'-'+i+'\')" onblur="setTimeout(function(){_menCerrar(\'submen-'+oid+'-'+idx+'-'+i+'\');},150)" style="font-size:11px"></textarea>'
      +'<button class="btn bp" onclick="addSubCom(\''+oid+'\','+idx+','+i+')" style="align-self:flex-end;padding:5px 8px"><i class="ti ti-send"></i></button></div>';
    html+='</div></div>'; // cierra body + div ss
  });
  html+='</div>'; // cierra sub-steps

  // ── Adjuntos globales de la etapa (nivel etapa, no sub-paso) ──
  var attKey=oid+stage.key;
  var atts=_attsDeLaEtapa(oid, stage);
  html+='<div class="lbl2" style="margin-top:12px"><i class="ti ti-paperclip"></i>Documentos generales de la etapa <span style="font-weight:400;color:var(--text-muted)">('+atts.length+')</span></div>';
  // Punto 1: diseño no elimina docs generales en pedido ni artes aprobados
  var _bloqueDisGen = (CU&&CU.role==='diseno') && (stage.key==='pedido' || stage.key==='artes');
  var _puedeElimGen = !_bloqueDisGen;
  if(atts.length){
    html+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:7px">';
    atts.forEach(function(a,ai){
      var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
      var extImg=['jpg','jpeg','png','gif','webp'];
      var _infoG=(a._dePaso?('De: '+a._dePaso+(a.by||a.date?' · ':'')):'')+(a.by?('Subido por '+a.by):'')+(a.date?(a.by?' · ':'')+a.date:'');
      if(extImg.includes(ext)){
        html+='<div style="position:relative;display:inline-block;margin:2px">'
          +'<img src="'+a.data+'" data-src="'+a.data+'" data-ai="'+(a._idx!=null?a._idx:ai)+'" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-img" style="width:58px;height:58px;object-fit:cover;border-radius:5px;cursor:zoom-in;border:0.5px solid var(--border)" title="'+a.name+(_infoG?' — '+_infoG:'')+'">'
          +(_puedeElimGen && a._idx!=null ?'<button data-ai="'+(a._idx!=null?a._idx:ai)+'" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-del" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:white;border:none;border-radius:50%;width:17px;height:17px;font-size:10px;cursor:pointer;line-height:17px;padding:0;text-align:center">\xd7</button>':'')+'</div>';
      } else {
        var ic=ext==='pdf'?'📄':ext==='xlsx'||ext==='xls'?'📊':ext==='doc'||ext==='docx'?'📝':'📎';
        var abrir=a.data?(' onclick="verArchivo(\''+a.data+'\',\''+(a.name||'').replace(/'/g,"\\\\'")+'\')" '):'';
        html+='<div style="display:inline-flex;align-items:center;gap:5px;padding:3px 8px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:var(--radius);font-size:11px;margin:2px;cursor:pointer" title="'+(_infoG||a.name)+'"'+abrir+'>'
          +ic+' <span style="max-width:90px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+a.name+'</span>'
          +(_puedeElimGen && a._idx!=null ?'<button data-ai="'+(a._idx!=null?a._idx:ai)+'" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-del" style="background:none;border:none;color:var(--text-danger);cursor:pointer;padding:0;font-size:13px;line-height:1">\xd7</button>':'')+'</div>';
      }
    });
    html+='</div>';
  }
  // El adjunto general de la etapa no tenía ningún control: diseño podía
  // subir aquí aunque los pasos estuvieran en solo consulta.
  var _etapaSoloConsulta = (CU&&CU.role==='diseno') && stage.key==='pedido';
  if(!_etapaSoloConsulta)
  html+='<label style="display:flex;align-items:center;gap:7px;padding:7px 11px;border:1.5px dashed var(--border);border-radius:var(--radius);cursor:pointer;font-size:11px;color:var(--text-secondary);margin-bottom:8px;background:var(--surface-1)"><i class="ti ti-upload" style="font-size:13px;color:var(--text-accent)"></i>Adjuntar archivo general de etapa<input type="file" multiple accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" style="display:none" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-input"></label>';

  if(stage.hasArte)html+=`<div class="arte-box">🎨<br><div style="font-size:12px;font-weight:500;margin-top:6px">${o.desc}</div><p>Vista previa simulada</p></div>`;
  // El resumen viejo "Costeo de mercancía" quedaba duplicado con los paneles
  // nuevos de la etapa, y sus tres líneas ya no coinciden con los subpasos.
  // if(stage.key==='costeo'&&CU.role!=='diseno'&&CU.role!=='bodega')html+=buildCosteoSection(oid);

  // ── Comentarios generales de la etapa ──
  const comments=sp2.comments||[];
  html+=`<div class="lbl2" style="margin-top:10px"><i class="ti ti-message"></i>Comentarios generales de la etapa ${_comBadgeNoLeido(oid,stage.key)}</div><div class="cms" id="cms-${oid}-${stage.key}">${_comRenderLista(oid,stage.key,comments)}</div><div class="cir"><textarea class="cin" id="cin-${oid}-${stage.key}" rows="2" placeholder="Escribe un comentario..."></textarea><button class="btn bp" onclick="addComS('${oid}','${stage.key}')" style="align-self:flex-end"><i class="ti ti-send"></i></button></div>`;
  if(isDone)html+=`<div style="margin-top:10px"><div class="aps"><i class="ti ti-circle-check"></i>Etapa completada · ${sp2.stepDates?.[sp2.stepDates.length-1]||''}</div></div>`;
  container.innerHTML=html;
  // Inicializar tracker de logística
  var trackerEl=container.querySelector('[id^="log-tracker-"]');
  if(trackerEl){
    var tOid=trackerEl.id.replace('log-tracker-','');
    trackerEl.innerHTML=buildLogTracker(tOid);
  }
}

// Toggle para mostrar/ocultar body de una sub-etapa
function toggleSubStep(oid,idx,i){
  var b=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
  var chev=document.getElementById('ssch-'+oid+'-'+idx+'-'+i);
  if(!b)return;
  var open=b.style.display!=='none';
  b.style.display=open?'none':'block';
  if(chev)chev.style.transform=open?'':'rotate(180deg)';
}

// Agregar comentario a una sub-etapa
// Documentos base de la orden: la orden de KCC y la PI del proveedor
// Nombre normalizado de un archivo, para reconocer el mismo documento aunque
// se haya subido varias veces con rutas distintas.
// Solo el nombre, normalizado. Sirve para reconocer el MISMO documento
// subido dos veces (dos rutas distintas, un solo archivo).
function _docNombreClave(a){
  if(!a) return '';
  var n=String(a.name||a.nombre_archivo||a.nombre||'').trim().toLowerCase();
  n=n.replace(/\s*\(\d+\)\s*(?=\.[a-z0-9]+$)/,'');   // "factura (1).pdf" = "factura.pdf"
  return n.replace(/[_\s-]+/g,' ');
}

function _docClave(a){
  if(!a) return '';
  // La ruta en el almacenamiento es única y manda sobre el nombre: dos
  // documentos DISTINTOS pueden llamarse igual (pasa siempre que compras
  // guarda la orden de Kennedy y la PI del proveedor como "Copia de
  // DKC-26109.xlsx"), y comparando por nombre se perdía uno de los dos.
  var u=String(a.url||a.path||'').trim().toLowerCase();
  if(u) return 'u:'+u;
  var n=String(a.name||a.nombre_archivo||'').trim().toLowerCase();
  // "DKC 26111 (1).pdf" y "DKC 26111.pdf" son el mismo documento
  n=n.replace(/\s*\(\d+\)\s*(?=\.[a-z0-9]+$)/,'');
  n=n.replace(/[_\s-]+/g,' ');
  return n;
}
// Quita repetidos por nombre. Se queda con el primero, que es el más antiguo
// y el que suele tener el id correcto en la base.
function _dedupDocs(lista){
  var out=[], vistos={};
  (lista||[]).forEach(function(a){
    var k=_docClave(a);
    if(!k){ out.push(a); return; }
    if(vistos[k]) return;
    vistos[k]=1; out.push(a);
  });
  return out;
}

function _docsBaseOrden(oid){
  var todos=[];
  [oid+'pedido', oid+'__pendsap'].forEach(function(k){
    ((window._atts&&window._atts[k])||[]).forEach(function(a){ todos.push(a); });
  });
  return _dedupDocs(todos);
}
// Adjuntos que se ven en un subpaso: los suyos más los documentos base
function _attsDelSubpaso(oid, stageKey, i, subKey){
  var propios=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];

  // El comprobante que contabilidad deja en "Depósito enviado al proveedor"
  // es EL MISMO que compras reenvía en el paso siguiente. Aparece solo, para
  // no tener que subirlo dos veces ni ir a buscarlo al paso anterior.
  // Lo mismo con el pago final y su comprobante.
  if(stageKey==='deposito' && (i===2 || i===4)){
    var previos=(window._atts&&window._atts[oid+'deposito_step'+(i-1)])||[];
    if(previos.length){
      // Se compara por NOMBRE, no por ruta. Es el mismo comprobante: si
      // compras ya lo había subido a mano en este paso, son dos copias con
      // rutas distintas y por ruta no se reconocían como el mismo archivo,
      // así que salía duplicado.
      var res=_dedupDocs(propios), yaEstan={};
      res.forEach(function(a){ yaEstan[_docNombreClave(a)]=1; });
      previos.forEach(function(a){
        var k=_docNombreClave(a);
        if(k && !yaEstan[k]){ yaEstan[k]=1; res.push(Object.assign({}, a, {_delPasoAnterior:true})); }
      });
      propios=res;
    }
  }

  if(stageKey!=='pedido' && stageKey!=='deposito') return propios;
  var base=_docsBaseOrden(oid);
  if(!base.length) return propios;
  var out=_dedupDocs(propios), vistos={};
  out.forEach(function(a){ vistos[_docClave(a)]=1; });
  base.forEach(function(a){
    var k=_docClave(a);
    if(k && !vistos[k]){ vistos[k]=1; out.push(Object.assign({}, a, {_base:true})); }
  });
  return out;
}

if(!window._subComs)window._subComs={};
function addSubCom(oid,idx,i){
  var stage=STAGES[idx];if(!stage)return;
  var subKey=stage.key+'_step'+i;
  var comKey='sub_'+oid+'_'+subKey;
  var inp=document.getElementById('subcin-'+oid+'-'+idx+'-'+i);
  var txt=inp?inp.value.trim():'';
  if(!txt)return;
  if(!window._subComs[comKey])window._subComs[comKey]=[];
  window._subComs[comKey].push({autor:CU.name+' ('+CU.role+')',ini:CU.ini,texto:txt,time:now2(),role:CU.role,by:CU.name});
  guardarComentario(oid, subKey, txt);
  // A quién avisar: los mencionados con @ y, además, quien participó antes en
  // este hilo. Si Lorena etiquetó a Franco y Franco responde, Lorena tiene que
  // enterarse aunque él no la haya etiquetado.
  try{
    var avisar=_menExtraer(txt);
    var yaEsta={};
    avisar.forEach(function(u){ yaEsta[u.id]=1; });
    _menDelHilo(comKey).forEach(function(u){
      if(!yaEsta[u.id] && (!CU || u.id!==CU.id)){ yaEsta[u.id]=1; avisar.push(u); }
    });
    if(avisar.length) _menNotificar(avisar, {
      docnum:oid, contexto:'etapa', etapa:stage.label, texto:txt,
      etiqueta:stage.label+' · '+(stage.steps[i]?stage.steps[i].name:'')
    });
  }catch(e){ console.warn('menciones:',e); }
  // Quien escribe ya leyó todo lo anterior
  try{ _chatMarcarLeido(comKey); }catch(e){}
  // Punto 5: si comenta gerencia, avisar al responsable de la etapa
  if(CU.role==='gerencia') _notificarComentarioEtapa(oid, stage);
  if(inp)inp.value='';
  // Actualizar SOLO la lista de comentarios (no reconstruir la etapa = no cierra el paso)
  var lista=document.getElementById('subcms-'+oid+'-'+idx+'-'+i);
  if(lista) lista.innerHTML=renderSubComs(comKey);
  if(inp) inp.focus();
  try{ _comIniciarPoll(); }catch(e){}
}
// Render de los comentarios de una sub-etapa (con botones editar/borrar del propio autor)
function renderSubComs(comKey){
  var coms=window._subComs&&window._subComs[comKey]?window._subComs[comKey]:[];
  if(!coms.length) return '';
  return coms.map(function(cm,ci){
    var mio=(cm.by===(CU?CU.name:''))||(cm.autor&&cm.autor.indexOf(CU?CU.name:'###')===0);
    var acciones=mio?('<div style="display:flex;gap:6px;margin-top:3px">'
      +'<span onclick="editSubCom(\''+comKey+'\','+ci+')" style="font-size:9px;color:var(--text-accent);cursor:pointer"><i class="ti ti-pencil" style="font-size:9px"></i> Editar</span>'
      +'<span onclick="delSubCom(\''+comKey+'\','+ci+')" style="font-size:9px;color:var(--text-danger);cursor:pointer"><i class="ti ti-trash" style="font-size:9px"></i> Borrar</span></div>'):'';
    return '<div class="ci"><div class="cav2">'+cm.ini+'</div><div class="cbub"><div class="cau">'+cm.autor+'</div><div class="ctx2" id="subctx-'+comKey+'-'+ci+'">'+_menResaltar((cm.texto||'').replace(/</g,'&lt;'))+'</div><div class="ctm">'+(cm.time||'')+(mio?_chatLeidoPor(comKey,ci):'')+'</div>'+acciones+'</div></div>';
  }).join('');
}
// Repinta SOLO el contenedor de este hilo. Antes se repintaban todos los
// contenedores con el mismo contenido, y los comentarios de un paso aparecían
// repetidos en los demás.
// Quiénes vienen conversando en este hilo: autores y mencionados
function _menDelHilo(comKey){
  var coms=(window._subComs&&window._subComs[comKey])?window._subComs[comKey]:[];
  var out=[], vistos={};
  coms.forEach(function(c){
    var u=(USERS||[]).find(function(x){ return String(x.name||'')===String(c.by||c.autor||'').replace(/\s*\([^)]*\)\s*$/,''); });
    if(u && !vistos[u.id]){ vistos[u.id]=1; out.push(u); }
    _menExtraer(c.texto||'').forEach(function(m){
      if(!vistos[m.id]){ vistos[m.id]=1; out.push(m); }
    });
  });
  return out;
}

// ── Leído de cada hilo de chat ──
// Se guarda quién leyó hasta cuántos mensajes, con la fecha.
function _chatLeidoKey(comKey){ return 'chatleido_'+comKey; }
function _chatLeidoGet(comKey){
  if(window._chatLeido && window._chatLeido[comKey]) return window._chatLeido[comKey];
  try{
    var v=localStorage.getItem(_chatLeidoKey(comKey));
    if(v) return JSON.parse(v);
  }catch(e){}
  return {};
}
async function _chatMarcarLeido(comKey){
  if(!CU) return;
  var coms=(window._subComs&&window._subComs[comKey])?window._subComs[comKey]:[];
  var m=_chatLeidoGet(comKey);
  if(Number((m[CU.id]||{}).n||0)>=coms.length) return;
  m[CU.id]={n:coms.length, nombre:CU.name, en:new Date().toISOString()};
  window._chatLeido=window._chatLeido||{};
  window._chatLeido[comKey]=m;
  try{ localStorage.setItem(_chatLeidoKey(comKey), JSON.stringify(m)); }catch(e){}
  // Y en la base, para que lo vean los demás. Si la tabla todavía no está
  // lista, el portal sigue funcionando con el registro local.
  if(window._chatLeidosOff) return;
  try{
    var r=await fetch(SB+'/rest/v1/chat_leidos?on_conflict=com_key,usuario_id',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify({com_key:comKey, usuario_id:CU.id, usuario_nombre:CU.name,
                           leidos:coms.length, leido_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      console.warn('[chat_leidos]', r.status, t);
      // Falta la tabla o el índice: se avisa una vez y se sigue en local
      if(/does not exist|Could not find|no unique|constraint matching/i.test(t)){
        window._chatLeidosOff=true;
        showT('El "leído" queda solo en este equipo: falta preparar la tabla chat_leidos (script chat_leidos.sql).');
      }
    }
  }catch(e){ console.warn('chat_leidos:',e); }
}
async function _chatLeidosCargar(comKey){
  if(window._chatLeidosOff) return;
  try{
    var r=await fetch(SB+'/rest/v1/chat_leidos?select=*&com_key=eq.'+encodeURIComponent(comKey)+'&limit=40',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(/does not exist|Could not find/i.test(t)) window._chatLeidosOff=true;
      return;
    }
    var rows=await r.json()||[];
    var m=_chatLeidoGet(comKey);
    rows.forEach(function(x){
      m[x.usuario_id]={n:x.leidos||0, nombre:x.usuario_nombre||x.usuario_id, en:x.leido_en};
    });
    window._chatLeido=window._chatLeido||{};
    window._chatLeido[comKey]=m;
  }catch(e){}
}

// Quién leyó hasta este mensaje
function _chatLeidoPor(comKey, ci){
  var m=_chatLeidoGet(comKey);
  var yo=(CU&&CU.id)||'';
  var out=[];
  Object.keys(m).forEach(function(uid){
    if(uid===yo) return;
    var d=m[uid]||{};
    if(Number(d.n||0) >= (ci+1)) out.push(d);
  });
  if(!out.length) return '';
  return '<span class="chat-leido" title="'+_esc(out.map(function(d){
      return d.nombre+' · '+_fechaHora(d.en); }).join('\n'))+'">'
    +'<i class="ti ti-checks"></i> Leído por '+_esc(out.map(function(d){return d.nombre;}).join(', '))
    +' · '+_esc(_fechaHora(out[0].en))+'</span>';
}

// Al abrir un paso: se marca lo leído y se traen los leídos de los demás
function _chatAlAbrir(comKey){
  var coms=(window._subComs&&window._subComs[comKey])?window._subComs[comKey]:[];
  if(!coms.length) return;
  _chatLeidosCargar(comKey).then(function(){ _subComRepintar(comKey); });
  setTimeout(function(){ _chatMarcarLeido(comKey); }, 1200);
}

function _subComRepintar(comKey){
  var cont=document.getElementById('subcms-'+comKey);
  if(cont){ cont.innerHTML=renderSubComs(comKey); return; }
  // La clave del contenedor puede diferir: se busca el que ya muestre este hilo
  document.querySelectorAll('[id^="subcms-"]').forEach(function(el){
    if(el.getAttribute('data-ck')===comKey) el.innerHTML=renderSubComs(comKey);
  });
}

async function delSubCom(comKey,ci){
  if(!window._subComs||!window._subComs[comKey]||!window._subComs[comKey][ci])return;
  var c=window._subComs[comKey][ci];
  if(!confirm('¿Está seguro de que desea borrar este comentario?\n\n"'+String(c.texto||'').slice(0,120)+'"\n\nEsta acción no se puede deshacer.')) return;
  // Se borra también de la base: antes solo se quitaba de la pantalla y
  // volvía a aparecer en cuanto se recargaba.
  var ok=true;
  if(c.id){
    try{
      var r=await fetch(SB+'/rest/v1/compras_comentarios?id=eq.'+c.id,{method:'DELETE',headers:SBH});
      ok=r.ok;
    }catch(e){ ok=false; }
  } else {
    // Sin id (recién escrito): se borra por su contenido
    try{
      var q=SB+'/rest/v1/compras_comentarios?texto=eq.'+encodeURIComponent(c.texto||'')
        +'&autor=eq.'+encodeURIComponent(c.by||'');
      var r2=await fetch(q,{method:'DELETE',headers:SBH});
      ok=r2.ok;
    }catch(e){ ok=false; }
  }
  window._subComs[comKey].splice(ci,1);
  _subComRepintar(comKey);
  showT(ok?'Comentario borrado':'⚠ Se quitó de la pantalla, pero no se pudo borrar de la base');
}

async function editSubCom(comKey,ci){
  if(!window._subComs||!window._subComs[comKey]||!window._subComs[comKey][ci])return;
  var c=window._subComs[comKey][ci];
  var actual=c.texto||'';
  var nuevo=prompt('Editar comentario:', actual);
  if(nuevo===null)return;
  nuevo=String(nuevo).trim();
  if(!nuevo){ showT('El comentario no puede quedar vacío'); return; }
  if(nuevo===actual) return;
  c.texto=nuevo;
  c.time=now2()+' (editado)';
  _subComRepintar(comKey);
  var ok=false;
  if(c.id){
    try{
      var r=await fetch(SB+'/rest/v1/compras_comentarios?id=eq.'+c.id,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({texto:nuevo})});
      ok=r.ok;
    }catch(e){}
  }
  showT(ok?'Comentario editado':'⚠ Se cambió en la pantalla, pero no se pudo guardar');
}
// Punto 5: notificar comentario de gerencia al responsable de la etapa
async function guardarComPend(oid, stageKey, rolDestino){
  try{
    await fetch(SB+'/rest/v1/compras_com_pend?on_conflict=docnum,stage,rol', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), stage:String(stageKey), rol:String(rolDestino), leido:false, actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarComPend:', e); }
}
async function cargarComPend(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_com_pend?select=*&leido=eq.false', {headers:SBH});
    var rows=await r.json();
    if(!window._comPend) window._comPend={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      window._comPend[String(row.docnum)+'_'+String(row.stage)+'_'+String(row.rol)]={ role:row.rol, oid:row.docnum, stage:row.stage, read:false };
    });
  }catch(e){ console.error('cargarComPend:', e); }
}
// Marca como leído el comentario pendiente de una etapa para el usuario actual
async function marcarComLeido(oid, stageKey){
  var rol=(CU&&CU.role)||'';
  var key=oid+'_'+stageKey+'_'+rol;
  if(window._comPend && window._comPend[key]) delete window._comPend[key];
  // Compatibilidad con la clave vieja de 2 partes
  if(window._comPend && window._comPend[oid+'_'+stageKey]) delete window._comPend[oid+'_'+stageKey];
  try{
    await fetch(SB+'/rest/v1/compras_com_pend?docnum=eq.'+encodeURIComponent(oid)+'&stage=eq.'+encodeURIComponent(stageKey)+'&rol=eq.'+encodeURIComponent(rol), {
      method:'PATCH', headers: Object.assign({}, SBH, {'Prefer':'return=minimal'}),
      body: JSON.stringify({ leido:true })
    });
  }catch(e){}
}
// ¿El usuario actual tiene comentarios de gerencia pendientes en esta orden?
function tieneComPendiente(oid){
  if(!window._comPend||!CU) return false;
  for(var k in window._comPend){
    var c=window._comPend[k];
    if(c && c.oid===oid && c.role===CU.role && !c.read) return true;
  }
  return false;
}
// ═══════════════════════════════════════════════════════════════════════════
//  ESTADO DE LECTURA DE COMENTARIOS (tipo WhatsApp)
//  Cuando alguien escribe en una etapa, queda "no leído" para todos los roles
//  que participan en esa etapa (menos quien escribió). El indicador desaparece
//  cuando el destinatario abre la etapa.
//  · ✓  = enviado, todavía nadie lo abrió
//  · ✓✓ = ya lo leyeron todos los destinatarios
// ═══════════════════════════════════════════════════════════════════════════
function _comRolesEtapa(stage){
  var roles=[];
  if(stage && stage.alertRole) roles.push(stage.alertRole);
  ((stage&&stage.steps)||[]).forEach(function(s){ if(s&&s.role) roles.push(s.role); });
  roles.push('gerencia');
  var out=[];
  roles.forEach(function(r){ if(r && out.indexOf(r)<0) out.push(r); });
  return out;
}
// Destinatarios de un comentario: todos los de la etapa menos quien escribe
function _comDestinos(stage){
  var mio=(CU&&CU.role)||'';
  return _comRolesEtapa(stage).filter(function(r){ return r!==mio; });
}
// ¿Esta etapa tiene comentarios sin leer PARA MÍ?
function _comNoLeidoEtapa(oid, stageKey){
  if(!window._comPend||!CU) return false;
  for(var k in window._comPend){
    var c=window._comPend[k];
    if(c && String(c.oid)===String(oid) && String(c.stage)===String(stageKey)
       && c.role===CU.role && !c.read) return true;
  }
  return false;
}
// ¿Ya leyeron TODOS los destinatarios lo que escribe en esta etapa?
function _comLeidoPorTodos(oid, stageKey){
  if(!window._comPend||!CU) return true;
  for(var k in window._comPend){
    var c=window._comPend[k];
    if(c && String(c.oid)===String(oid) && String(c.stage)===String(stageKey)
       && c.role!==CU.role && !c.read) return false;
  }
  return true;
}
// Palomitas de estado para un comentario propio
function _comChecks(oid, stageKey){
  var leido=_comLeidoPorTodos(oid, stageKey);
  return '<span class="com-chk'+(leido?' leido':'')+'" title="'+(leido?'Leído':'Enviado, sin leer')+'">'
       + '<i class="ti '+(leido?'ti-checks':'ti-check')+'"></i></span>';
}
// Badge de "sin leer" para la cabecera de la etapa
function _comBadgeNoLeido(oid, stageKey){
  if(!_comNoLeidoEtapa(oid, stageKey)) return '';
  return '<span class="com-nuevo" title="Tienes comentarios sin leer"><i class="ti ti-message-circle"></i> nuevo</span>';
}

// Repinta los avisos "nuevo" de todas las etapas de una orden abierta
function _comPintarBadgesEtapas(oid){
  try{
    STAGES.forEach(function(st, idx){
      var el=document.getElementById('egnl-'+oid+'-'+idx);
      if(el) el.innerHTML=_comBadgeNoLeido(oid, st.key);
    });
  }catch(e){}
}

function _notificarComentarioEtapa(oid, stage){
  if(!stage) return;
  var destinos=_comDestinos(stage);
  if(!window._comPend) window._comPend={};
  var quien=(CU?CU.name:'');
  destinos.forEach(function(rol){
    window._comPend[oid+'_'+stage.key+'_'+rol]={
      role:rol, oid:oid, stage:stage.key, stageLabel:stage.label,
      by:quien, time:now2(), read:false
    };
    addNotif(rol, '💬 '+quien+' comentó en "'+stage.label+'" — '+oid, oid, 'ti-message');
    guardarComPend(oid, stage.key, rol);
  });
}

// Actualizar botón de tracking


function undoSS(oid,stageKey,stepIdx){initP(oid);const sp2=stageProgress[oid];if(sp2[stageKey].stepIdx>stepIdx){sp2[stageKey].stepIdx=stepIdx;sp2[stageKey].stepDates[stepIdx]='';if(sp2[stageKey]._isoPasos)sp2[stageKey]._isoPasos[stepIdx]='';showT('↩ Paso revertido');guardarEtapa(oid,stageKey);const stage=STAGES.find(s=>s.key===stageKey);const stageidx=STAGES.indexOf(stage);const body=document.getElementById(`egb-${oid}-${stageidx}`);if(body){buildEGB(oid,stageidx,body);_reabrirSub(oid,stageidx,stepIdx);}}}
function advSS(oid,stageKey,stepIdx){initP(oid);const sp2=stageProgress[oid];const stage=STAGES.find(s=>s.key===stageKey);if(!stage)return;sp2[stageKey].stepIdx=stepIdx+1;if(!sp2[stageKey].stepDates)sp2[stageKey].stepDates=Array(stage.steps.length).fill('');sp2[stageKey].stepDates[stepIdx]=now2();if(!sp2[stageKey].stepBy)sp2[stageKey].stepBy=Array(stage.steps.length).fill('');sp2[stageKey].stepBy[stepIdx]=(CU?CU.name:'');if(!sp2[stageKey].startDate)sp2[stageKey].startDate=now2();
  // Registrar fechas en ISO para guardar en Supabase
  var hoyIso=new Date().toISOString().slice(0,10);
  if(!sp2[stageKey]._isoPasos)sp2[stageKey]._isoPasos=Array(stage.steps.length).fill('');
  sp2[stageKey]._isoPasos[stepIdx]=hoyIso;
  if(!sp2[stageKey]._isoInicio)sp2[stageKey]._isoInicio=hoyIso;
  const o=orders.find(x=>x.id===oid);const isDoneNow=sp2[stageKey].stepIdx>=stage.steps.length;if(isDoneNow){const idx=STAGES.indexOf(stage);showT(`✓ "${stage.label}" completado`);if(idx+1<STAGES.length){sp2[STAGES[idx+1].key].startDate=dateOnly();sp2[STAGES[idx+1].key]._isoInicio=hoyIso;addNotif(STAGES[idx+1].alertRole,`${oid} — "${stage.label}" completado.`,oid,'ti-bell');}else{if(o)o.completada=true;}}else{showT('Sub-paso marcado ✓');}
  guardarEtapa(oid,stageKey);
  // Aviso a la gerencia del departamento: alguien completó un paso y hay que
  // revisarlo. Antes ningún paso avisaba y la gerencia no se enteraba.
  try{ _avisarGerenciaPaso(oid, stage, stepIdx); }catch(e){ console.warn('aviso gerencia:',e); }
  // Cuando contabilidad paga, el solicitante tiene que enterarse: antes no
  // recibía nada hasta que le mandaban el comprobante.
  try{ _avisarPagoHecho(oid, stage, stepIdx); }catch(e){ console.warn('aviso de pago:',e); }
  const body=document.getElementById(`egb-${oid}-${STAGES.indexOf(stage)}`);if(body){buildEGB(oid,STAGES.indexOf(stage),body);_reabrirSub(oid,STAGES.indexOf(stage),stepIdx);}renderNP();_actualizarContadores();}
// Reabre una sub-etapa tras reconstruir la etapa (para no cerrar el proceso)
// Avisa a la gerencia del departamento cuando se completa un paso.
// La alerta lleva directo a ese paso para que pueda revisarlo.
// Avisa a quien pidió el pago cuando contabilidad lo ejecuta
async function _avisarPagoHecho(oid, stage, stepIdx){
  if(!stage || stage.key!=='deposito') return;
  var paso=(stage.steps[stepIdx]||{}).name||'';
  var esDeposito=(paso===_PASO_DEP_PROV);
  var esFinal=(paso===_PASO_PAGO_FINAL);
  if(!esDeposito && !esFinal) return;

  // La solicitud correspondiente, para saber a quién avisar
  var tipo=esDeposito?'abono':'cancelacion';
  var sols=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && String(x.tipo||'')===tipo;
  });

  var destinos=[];
  sols.forEach(function(x){
    _avSolicitante(x).forEach(function(u){
      if(!destinos.some(function(z){ return z.id===u.id; })) destinos.push(u);
    });
  });
  // Si no hay solicitud registrada, se avisa a las compradoras del departamento
  if(!destinos.length){
    var d=_solPagoDatosOrden(oid);
    destinos=_avUsuariosPorRol('compras', d.dept);
  }
  destinos=destinos.filter(function(u){ return u.id!==((CU&&CU.id)||''); });
  if(!destinos.length) return;

  var dat=_solPagoDatosOrden(oid);
  var monto=sols.length?sols[0].monto:null;
  /* v759: la fecha REAL del pago. El aviso lleva la fecha en que se marca
     el paso; si se ponen al día órdenes viejas (el 23-10 se marcaron pagos
     de hace dos meses), parecía que se habían pagado ese día. Ahora: si el
     abono en SAP tiene más de 7 días, se está poniendo al día y NO se avisa;
     y si se avisa, el texto dice la fecha del pago. */
  var oAb=(typeof orders!=='undefined' && orders ? orders : []).find(function(x){ return String(x.id)===String(oid); })||{};
  var fAb=_fechaAbonoISO(oAb, sols);
  if(esDeposito && fAb){
    var dias=(Date.now()-new Date(fAb+'T12:00:00').getTime())/86400000;
    if(dias>7){ _dbg('[aviso] depósito de '+oid+' pagado el '+fAb+': solo se pone al día, no se avisa'); return; }
  }
  await _menNotificar(destinos, {
    docnum:oid, contexto:'etapa', etapa:'Depósito & Pago', paso:paso,
    texto:(esDeposito?'Contabilidad envió el depósito al proveedor'
                     :'Contabilidad realizó el pago final')
      +(fAb?(' el '+fAb.split('-').reverse().join('/')):'')
      +(dat.proveedor?(' · '+dat.proveedor):'')
      +(monto?(' · '+fmt(monto)):''),
    etiqueta:(esDeposito?'Depósito pagado':'Pago final realizado')
  });
}

async function _avisarGerenciaPaso(oid, stage, stepIdx){
  if(!CU || CU.role==='gerencia') return;      // gerencia no se avisa a sí misma
  var paso=stage.steps[stepIdx];
  if(!paso) return;

  // El departamento de la orden
  var dept='';
  var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
  if(o) dept=o.dept||'';
  if(!dept){
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p) dept=p.dept||'';
  }

  // Gerencia del departamento; si no hay, toda la gerencia
  var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia'; });
  var delDept=gers.filter(function(u){ return dept && String(u.dept||'')===String(dept); });
  var destinos=delDept.length?delDept:gers;
  if(!destinos.length) return;

  var completa=(stageProgress[oid] && stageProgress[oid][stage.key]
                && stageProgress[oid][stage.key].stepIdx>=stage.steps.length);
  var texto=(completa?'Etapa completada: ':'Paso completado: ')+paso.name
    +' — por '+((CU&&CU.name)||'');

  await _menNotificar(destinos, {
    docnum:oid, contexto:'etapa', etapa:stage.label, texto:texto,
    etiqueta:stage.label+' \u00b7 '+paso.name,
    paso:paso.name
  });
}

function _reabrirSub(oid,stageidx,subIdx){
  setTimeout(function(){
    var sb=document.getElementById('ssb-'+oid+'-'+stageidx+'-'+subIdx);
    var chev=document.getElementById('ssch-'+oid+'-'+stageidx+'-'+subIdx);
    if(sb){ sb.style.display='block'; if(chev)chev.style.transform='rotate(180deg)'; }
  },0);
}
// Actualiza solo los contadores de fondo (alertas) sin cerrar el modal
function _actualizarContadores(){
  try{ var ac=document.getElementById('ac'); if(ac)ac.textContent=vO().filter(function(o){return o.alerta;}).length; }catch(e){}
}
function buildCosteoSection(oid){const o=orders.find(x=>x.id===oid);if(!o)return'';if(!costeoData[oid])costeoData[oid]={status:'pending',items:[],uploadedBy:'',pricedBy:''};const cd=costeoData[oid];let html=`<div style="background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:var(--radius);padding:12px 14px;margin:10px 0"><div style="font-size:13px;font-weight:500;color:var(--t-marron);margin-bottom:8px"><i class="ti ti-table"></i> Costeo de mercancía</div>${[{s:'pending',l:'Importación sube Excel',done:cd.status!=='pending'},{s:'uploaded',l:'Gerencia asigna precios',done:['pricing','done'].includes(cd.status)},{s:'pricing',l:'Importación sube al SAP',done:cd.status==='done'}].map(st=>`<div style="display:flex;align-items:center;gap:8px;font-size:12px;margin-bottom:5px"><span class="sem ${st.done?'sem-g':cd.status===st.s?'sem-y':'sem-r'}" style="width:10px;height:10px"></span><span>${st.l}</span></div>`).join('')}</div>`;if(cd.status==='pending'&&CU.role==='importacion')html+=`<div class="uz" onclick="subirCosteo('${oid}')"><i class="ti ti-table" style="font-size:20px;display:block;margin-bottom:4px;color:#1D6F42"></i><div style="font-weight:500;color:#1D6F42">Subir Excel de costeo</div></div>`;if(['uploaded','pricing','done'].includes(cd.status)){const canEdit=cd.status==='uploaded'&&CU.role==='gerencia';const tC=cd.items.reduce((s,i)=>s+(i.costo*i.unidades),0),tV=cd.items.reduce((s,i)=>s+(i.precioVenta*i.unidades),0);html+=`<div class="excel-viewer"><div class="excel-hdr"><i class="ti ti-table" style="font-size:14px;color:white"></i><span>Costeo-${oid}.xlsx</span></div><div style="overflow-x:auto"><table class="excel-table"><thead><tr><th>SKU</th><th>Desc.</th><th>Und.</th><th>Costo</th><th>Tot. costo</th><th style="background:#1a5c38;color:white">P. venta</th><th>Tot. venta</th></tr></thead><tbody>${cd.items.map((item,i2)=>`<tr><td style="font-family:monospace;font-size:10px">${item.sku}</td><td>${item.desc}</td><td style="text-align:right">${item.unidades}</td><td style="text-align:right">$${item.costo}</td><td style="text-align:right">$${(item.costo*item.unidades).toLocaleString()}</td><td style="background:${canEdit?'#f0fff4':'var(--surface-1)'};text-align:center">${canEdit?`<input class="excel-input" type="number" id="pv-${oid}-${i2}" value="${item.precioVenta||''}" placeholder="0">`:`<span>${item.precioVenta>0?'$'+item.precioVenta:'—'}</span>`}</td><td style="text-align:right">${item.precioVenta>0?'$'+(item.precioVenta*item.unidades).toLocaleString():'—'}</td></tr>`).join('')}<tr class="etotal"><td colspan="4"><strong>Total</strong></td><td style="text-align:right"><strong>$${tC.toLocaleString()}</strong></td><td style="text-align:center"><strong>${tV>0?'$'+tV.toLocaleString():'Pendiente'}</strong></td><td style="text-align:right"><strong>${tV>0?'$'+tV.toLocaleString():'—'}</strong></td></tr></tbody></table></div></div>`;if(canEdit)html+=`<div class="br"><button class="btn" style="background:#1D6F42;color:white" onclick="guardarPrecios('${oid}')"><i class="ti ti-check"></i>Guardar precios</button></div>`;if(cd.status==='pricing'&&CU.role==='importacion')html+=`<div class="br" style="margin-top:8px"><button class="btn bsap" onclick="subirSAP('${oid}')"><i class="ti ti-upload"></i>Subir al SAP</button></div>`;if(cd.status==='done')html+=`<div style="background:#EAF3DE;border-radius:var(--radius);padding:10px 12px;margin-top:10px;font-size:12px;color:var(--t-oliva)">✓ Subido al SAP por ${cd.pricedBy}</div>`;}return html;}
function subirCosteo(oid){const o=orders.find(x=>x.id===oid);if(!o)return;const cd=costeoData[oid];cd.status='uploaded';cd.uploadedBy=CU.name;cd.items=[{sku:'ITEM-001',desc:o.desc+' — A',costo:180,precioVenta:0,unidades:Math.ceil((o.uni||150)/2)},{sku:'ITEM-002',desc:o.desc+' — B',costo:195,precioVenta:0,unidades:(o.uni||150)-Math.ceil((o.uni||150)/2)}];initP(oid);stageProgress[oid].costeo.stepIdx=1;stageProgress[oid].costeo.stepDates[0]=dateOnly();addNotif('gerencia',`${oid} — Costeo listo. Asignar precios.`,oid,'ti-table');showT('✓ Costeo subido.');const b=document.getElementById(`egb-${oid}-5`);if(b&&b.classList.contains('open'))buildEGB(oid,5,b);renderNP();}
function guardarPrecios(oid){const cd=costeoData[oid];let all=true;cd.items.forEach((item,i2)=>{const inp=document.getElementById(`pv-${oid}-${i2}`);const val=inp?parseFloat(inp.value):0;if(!val||val<=0)all=false;else item.precioVenta=val;});if(!all){showT('Ingresa todos los precios');return;}cd.status='pricing';cd.pricedBy=CU.name;initP(oid);stageProgress[oid].costeo.stepIdx=2;stageProgress[oid].costeo.stepDates[1]=dateOnly();addNotif('importacion',`${oid} — Precios asignados.`,oid,'ti-circle-check');showT('✓ Precios guardados.');const b=document.getElementById(`egb-${oid}-5`);if(b&&b.classList.contains('open'))buildEGB(oid,5,b);renderNP();}
function subirSAP(oid){const cd=costeoData[oid];cd.status='done';cd.pricedBy=CU.name;initP(oid);stageProgress[oid].costeo.stepIdx=4;stageProgress[oid].costeo.stepDates[2]=dateOnly();stageProgress[oid].costeo.stepDates[3]=dateOnly();addNotif('gerencia',`${oid} — Costeo subido al SAP.`,oid,'ti-circle-check');showT('✅ Costeo subido.');setTimeout(()=>{advSS(oid,'costeo',3);},800);}
// Dibuja la lista de comentarios de una etapa, con palomitas en los propios
function _comRenderLista(oid, stageKey, comments){
  comments=comments||[];
  if(!comments.length) return '<div style="font-size:12px;color:var(--text-muted);margin-bottom:6px">Sin comentarios.</div>';
  var mio=(CU&&CU.name)||'\u0000';
  return comments.map(function(cm){
    var esMio=String(cm.autor||'').indexOf(mio)===0;
    return '<div class="ci"><div class="cav2">'+(cm.ini||'')+'</div>'
      +'<div class="cbub'+(esMio?' cbub-mio':'')+'">'
      +'<div class="cau">'+(cm.autor||'')+'</div>'
      +'<div class="ctx2">'+String(cm.texto||'').replace(/</g,'&lt;')+'</div>'
      +'<div class="ctm">'+(cm.time||'')+(esMio?(' '+_comChecks(oid, stageKey)):'')+'</div>'
      +'</div></div>';
  }).join('');
}
function _comRepintar(oid, stageKey){
  var c=document.getElementById('cms-'+oid+'-'+stageKey);
  if(c) c.innerHTML=_comRenderLista(oid, stageKey, (stageProgress[oid]&&stageProgress[oid][stageKey]&&stageProgress[oid][stageKey].comments)||[]);
}
function addComS(oid,stageKey){
  initP(oid);
  const inp=document.getElementById(`cin-${oid}-${stageKey}`);
  const txt=inp?.value.trim();
  if(!txt)return;
  if(!stageProgress[oid][stageKey].comments)stageProgress[oid][stageKey].comments=[];
  stageProgress[oid][stageKey].comments.push({autor:`${CU.name} (${CU.role})`,ini:CU.ini,texto:txt,time:now2()});
  guardarComentario(oid,stageKey,txt);
  // Antes solo avisaba si escribea gerencia. Ahora cualquier comentario queda
  // como "no leído" para los demás participantes de la etapa.
  const _st=STAGES.find(s=>s.key===stageKey);
  if(_st)_notificarComentarioEtapa(oid,_st);
  inp.value='';
  _comRepintar(oid, stageKey);
  var _box=document.getElementById('cms-'+oid+'-'+stageKey);
  if(_box) _box.scrollTop=_box.scrollHeight;
  renderNP();
  _comIniciarPoll();
  setTimeout(function(){ _comRefrescar(oid, stageKey); }, 1800);
  if(inp)inp.focus();
}
// ── SISTEMA MULTI-CONTENEDOR ──
if(!window._bookingData)window._bookingData={};

// Estructura: _bookingData[oid] = { naviera:'MAERSK', booking:'MAEU123', containers:[{id:'MSCU001',etaSalida:'2024-06-10',etaLlegada:'2024-07-15',origen:'Shanghai',destino:'Panamá'}] }
// ═══ ARTES ENVIADOS AL PROVEEDOR: WeTransfer + correos ═══
if(!window._artesData) window._artesData={};
// ═══ ARTES APROBADOS POR GERENCIA: ganchito + comentario ═══
if(!window._artesAprob) window._artesAprob={};
function getAprob(oid){
  if(!window._artesAprob[oid]) window._artesAprob[oid]={aprobado:false,por:'',fecha:'',comentario:''};
  return window._artesAprob[oid];
}
// ═══ REVISIÓN DE ARTES CON IA ═══
// ⚠️ SEGURIDAD: la API key queda expuesta en el frontend. Ver nota al usuario.
var ANTHROPIC_KEY_ARTES = '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';
var IA_MODELO = 'claude-haiku-4-5-20251001';
if(!window._revIA) window._revIA={};
// Revisión IA genérica de un documento (imagen o PDF) con un prompt específico.
// Devuelve {errores:[...], ok:bool}
// Lee un archivo Excel/CSV y lo convierte a texto tabular (para pasarlo a la IA)
async function _excelATexto(url){
  try{
    if(typeof XLSX==='undefined'){ console.error('SheetJS no cargó'); return ''; }
    var resp=await fetch(url);
    var buf=await resp.arrayBuffer();
    var wb=XLSX.read(buf,{type:'array'});
    var out='';
    wb.SheetNames.forEach(function(sn){
      var ws=wb.Sheets[sn];
      var csv=XLSX.utils.sheet_to_csv(ws,{FS:'\t'});
      if(csv && csv.trim()){
        out+='=== Hoja: '+sn+' ===\n'+csv+'\n\n';
      }
    });
    // Limitar tamaño para no exceder el contexto
    if(out.length>12000) out=out.slice(0,12000)+'\n...(contenido truncado)';
    return out;
  }catch(e){ console.error('_excelATexto:', e); return ''; }
}
async function _revisarDocIA(url, nombre, promptTexto){
  var ext=(nombre.split('.').pop()||'').toLowerCase();
  var esImg=['jpg','jpeg','png','gif','webp'].includes(ext);
  var esPdf=ext==='pdf';
  var content=[];
  if(esImg){
    var b64=await _imgUrlABase64(url);
    content.push({type:'image',source:{type:'base64',media_type:b64.mime,data:b64.data}});
  } else if(esPdf){
    var pb=await _fileUrlABase64(url);
    content.push({type:'document',source:{type:'base64',media_type:'application/pdf',data:pb.data}});
  } else if(['xlsx','xls','csv'].includes(ext)){
    // Excel/CSV: leer el contenido con SheetJS y pasarlo como texto a la IA
    var texto=await _excelATexto(url);
    if(!texto){ return {errores:['No se pudo leer el contenido del Excel.'], ok:false}; }
    content.push({type:'text',text:promptTexto+'\n\nContenido del archivo (hoja de cálculo, filas separadas por saltos de línea y columnas por tabulación):\n\n'+texto});
    var body0={ model:IA_MODELO, max_tokens:1500, messages:[{role:'user',content:content}] };
    var r0=await fetch('https://api.anthropic.com/v1/messages',{method:'POST',headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},body:JSON.stringify(body0)});
    var d0=await r0.json();
    var txt0=(d0.content&&d0.content[0]&&d0.content[0].text)?d0.content[0].text:'{"errores":[]}';
    txt0=txt0.replace(/```json|```/g,'').trim();
    var p0; try{ p0=JSON.parse(txt0); }catch(e){ p0={errores:['No se pudo interpretar la respuesta de la IA.']}; }
    return {errores:p0.errores||[], ok:(p0.errores||[]).length===0};
  } else {
    return {errores:['Este tipo de archivo ('+ext+') no se puede revisar con IA.'], ok:false, noLeible:true};
  }
  content.push({type:'text',text:promptTexto});
  var body={ model:IA_MODELO, max_tokens:1500, messages:[{role:'user',content:content}] };
  var r=await fetch('https://api.anthropic.com/v1/messages',{
    method:'POST',
    headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
    body:JSON.stringify(body)
  });
  var d=await r.json();
  var txt=(d.content&&d.content[0]&&d.content[0].text)?d.content[0].text:'{"errores":[]}';
  txt=txt.replace(/```json|```/g,'').trim();
  var parsed; try{ parsed=JSON.parse(txt); }catch(e){ parsed={errores:['No se pudo interpretar la respuesta de la IA.']}; }
  return {errores:parsed.errores||[], ok:(parsed.errores||[]).length===0};
}
async function _fileUrlABase64(url){
  var resp=await fetch(url);
  var blob=await resp.blob();
  var data=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onloadend=function(){ res(fr.result.split(',')[1]); };
    fr.onerror=rej; fr.readAsDataURL(blob);
  });
  return {data:data};
}
// Badge visual de "AI revisado con éxito" (sin errores)
function _badgeIAok(){
  return '<div style="display:inline-flex;align-items:center;gap:6px;background:#F0FDF4;border:1px solid #86EFAC;border-radius:20px;padding:5px 12px;font-size:11px;font-weight:600;color:var(--t-verde);margin-top:8px"><i class="ti ti-sparkles" style="font-size:13px"></i><i class="ti ti-circle-check" style="font-size:13px"></i> AI: revisado con éxito, sin errores</div>';
}
// Panel de revisión IA genérico para un paso (Excel de pedido, depósito, etc.)
function buildRevisionIAGenerica(oid, subKey, tipo){
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Cualquier archivo adjunto, no una lista cerrada de extensiones
  var revisables=_dedupDocs(atts);
  var titulo=tipo==='excel'?'Revisar orden de compra con IA':tipo==='deposito'?'Verificar datos bancarios con IA':'Revisar con IA';
  var h='';
  h+='<div style="background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:8px;display:flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>'+titulo+'</div>';
  if(!revisables.length){
    h+='<div style="font-size:11px;color:var(--text-muted)">Adjunta el documento (PDF, imagen o Excel) para poder revisarlo con IA.</div>';
  } else {
    var desc=tipo==='excel'?'La IA revisará las órdenes de compra buscando errores en fórmulas, totales, sumatorias y montos.':tipo==='deposito'?'La IA comparará los datos bancarios del comprobante con los de la orden de compra y avisará si hay diferencias.':'La IA revisará el documento.';
    h+='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:9px">'+desc+'</div>';
    h+='<button onclick="revisarGenericaIA(\''+oid+'\',\''+subKey+'\',\''+tipo+'\')" id="btn-reviag-'+oid+'-'+subKey+'" style="background:#5B21B6;color:white;border:none;border-radius:7px;padding:8px 14px;cursor:pointer;font-size:12px;font-weight:600;display:inline-flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>Revisar con IA</button>';
    var res=window._revIA[oid+subKey+'_'+tipo];
    h+='<div id="reviag-res-'+oid+'-'+subKey+'" style="margin-top:10px">'+(res?_renderRevIAGen(res):'')+'</div>';
  }
  h+='</div>';
  return h;
}
function _renderRevIAGen(res){
  if(!res||!res.items) return '';
  var hayError=res.items.some(function(it){return it.errores&&it.errores.length;});
  var h=res.items.map(function(it){
    // Un archivo que no se pudo leer no es "sin errores": se marca aparte
    var color=it.nota?'#B45309':(it.errores&&it.errores.length?'#DC2626':'#16A34A');
    var icon=it.nota?'ti-alert-circle':(it.errores&&it.errores.length?'ti-alert-triangle':'ti-circle-check');
    var x='<div style="background:var(--surface-2);border:0.5px solid var(--border);border-left:3px solid '+color+';border-radius:6px;padding:9px 11px;margin-bottom:7px">';
    x+='<div style="font-size:11px;font-weight:600;color:'+color+';display:flex;align-items:center;gap:5px;margin-bottom:'+((it.errores&&it.errores.length)?'6px':'0')+'"><i class="ti '+icon+'" style="font-size:12px"></i>'+it.nombre+'</div>';
    if(it.errores&&it.errores.length){
      x+='<ul style="margin:0;padding-left:16px;font-size:11px;color:var(--text-secondary);line-height:1.5">';
      it.errores.forEach(function(e){ x+='<li>'+String(e).replace(/</g,'&lt;')+'</li>'; });
      x+='</ul>';
    } else if(it.nota){
      x+='<span style="font-size:11px;color:var(--t-ambar)">'+String(it.nota).replace(/</g,'&lt;')+'</span>';
    } else { x+='<span style="font-size:11px;color:var(--t-verde3)">Sin errores.</span>'; }
    x+='</div>';
    return x;
  }).join('');
  if(!hayError) h+=_badgeIAok();
  return h;
}
async function revisarGenericaIA(oid, subKey, tipo){
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Cualquier archivo adjunto, no una lista cerrada de extensiones
  var revisables=_dedupDocs(atts);
  if(!revisables.length){ showT('No hay documentos revisables'); return; }
  var btn=document.getElementById('btn-reviag-'+oid+'-'+subKey);
  var resDiv=document.getElementById('reviag-res-'+oid+'-'+subKey);
  if(btn){ btn.disabled=true; btn.style.opacity=".7"; btn.innerHTML='<span class="ai-ring" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Revisando…'; }
  var prompt;
  if(tipo==='excel'){
    prompt='Eres un auditor de órdenes de compra. Revisa este documento (una orden de compra con productos, cantidades, precios y totales). Verifica EXCLUSIVAMENTE errores objetivos de cálculo: que cantidad × precio unitario = total de cada línea, que la suma de los totales de línea = total general, que no haya montos inconsistentes o sumatorias incorrectas. Responde SOLO en JSON válido sin texto adicional: {"errores": ["descripción del error con los números involucrados"]}. Si todos los cálculos están correctos, responde {"errores": []}. Responde en español.';
  } else if(tipo==='deposito'){
    prompt='Eres un auditor financiero. Este documento es un comprobante de depósito/pago o una orden de compra. Revisa los DATOS BANCARIOS visibles (número de cuenta, beneficiario, banco, monto) y verifica que sean consistentes y estén completos. Si detectas datos bancarios incompletos, montos que no coinciden, o inconsistencias, infórmalo. Responde SOLO en JSON válido sin texto adicional: {"errores": ["descripción de la diferencia o error"]}. Si todo está correcto y consistente, responde {"errores": []}. Responde en español.';
  } else {
    prompt='Revisa este documento y detecta errores objetivos. Responde SOLO en JSON: {"errores": []}. En español.';
  }
  var resultado={items:[]};
  for(var idx=0; idx<revisables.length; idx++){
    var a=revisables[idx];
    if(resDiv) resDiv.innerHTML='<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Revisando '+(idx+1)+' de '+revisables.length+'...</div>';
    try{
      var res=await _revisarDocIA(a.data, a.name, prompt);
      resultado.items.push({nombre:a.name, errores:res.errores||[]});
    }catch(e){
      resultado.items.push({nombre:a.name, errores:['Error al revisar: '+(e.message||e)]});
    }
  }
  window._revIA[oid+subKey+'_'+tipo]=resultado;
  if(resDiv) resDiv.innerHTML=_renderRevIAGen(resultado);
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-refresh"></i> Volver a revisar'; }
  var conErr=resultado.items.filter(function(it){return it.errores&&it.errores.length;}).length;
  var sinLeer=resultado.items.filter(function(it){return it.nota;}).length;
  showT(conErr?('⚠ '+conErr+' documento(s) con posibles errores'+(sinLeer?(' · '+sinLeer+' sin poder leer'):''))
              :(sinLeer?('✓ Sin errores · '+sinLeer+' archivo(s) no se pudieron leer'):'✓ AI: sin errores'));
}

function buildRevisionIA(oid, subKey){
  // Junta los artes adjuntos de este paso
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Cualquier archivo, no solo imágenes: PDF, Excel, Word, texto…
  var imgs=_dedupDocs(atts);
  var h='';
  h+='<div style="background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:8px;display:flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>Revisión con inteligencia artificial</div>';
  if(!imgs.length){
    h+='<div style="font-size:11px;color:var(--text-muted)">Adjunta los artes para poder revisarlos. Se aceptan PDF, imágenes, Excel y Word.</div>';
  } else {
    h+='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:9px">La IA revisará los '+imgs.length+' arte(s) adjunto(s) buscando errores de ortografía, gramática y otros problemas visibles en el texto.</div>';
    h+='<button onclick="revisarArtesIA(\''+oid+'\',\''+subKey+'\')" id="btn-revia-'+oid+'" style="background:#5B21B6;color:white;border:none;border-radius:7px;padding:8px 14px;cursor:pointer;font-size:12px;font-weight:600;display:inline-flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>Revisar artes con IA</button>';
    // Resultados previos
    var res=window._revIA[oid+subKey];
    if(res) h+='<div id="revia-res-'+oid+'" style="margin-top:10px">'+_renderRevIA(res)+'</div>';
    else h+='<div id="revia-res-'+oid+'" style="margin-top:10px"></div>';
  }
  h+='</div>';
  return h;
}
function _renderRevIA(res){
  if(!res||!res.items) return '';
  var hayError=res.items.some(function(it){return it.errores&&it.errores.length;});
  var out=res.items.map(function(it){
    // Un archivo que no se pudo leer no es "sin errores": se marca aparte
    var color=it.nota?'#B45309':(it.errores&&it.errores.length?'#DC2626':'#16A34A');
    var icon=it.nota?'ti-alert-circle':(it.errores&&it.errores.length?'ti-alert-triangle':'ti-circle-check');
    var h='<div style="background:var(--surface-2);border:0.5px solid var(--border);border-left:3px solid '+color+';border-radius:6px;padding:9px 11px;margin-bottom:7px">';
    h+='<div style="font-size:11px;font-weight:600;color:'+color+';display:flex;align-items:center;gap:5px;margin-bottom:'+((it.errores&&it.errores.length)?'6px':'0')+'"><i class="ti '+icon+'" style="font-size:12px"></i>'+it.nombre+'</div>';
    if(it.errores&&it.errores.length){
      h+='<ul style="margin:0;padding-left:16px;font-size:11px;color:var(--text-secondary);line-height:1.5">';
      it.errores.forEach(function(e){ h+='<li>'+String(e).replace(/</g,'&lt;')+'</li>'; });
      h+='</ul>';
    } else if(it.nota){
      h+='<span style="font-size:11px;color:var(--t-ambar)">'+String(it.nota).replace(/</g,'&lt;')+'</span>';
    } else {
      h+='<span style="font-size:11px;color:var(--t-verde3)">Sin errores detectados.</span>';
    }
    h+='</div>';
    return h;
  }).join('');
  if(!hayError) out+=_badgeIAok();
  return out;
}
async function revisarArtesIA(oid, subKey){
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  var imgs=_dedupDocs(atts);
  if(!imgs.length){ showT('No hay archivos para revisar'); return; }
  if(ANTHROPIC_KEY_ARTES==='PEGA_TU_API_KEY_AQUI'){ showT('Falta configurar la API key de Anthropic'); return; }
  var btn=document.getElementById('btn-revia-'+oid);
  var resDiv=document.getElementById('revia-res-'+oid);
  if(btn){ btn.disabled=true; btn.style.opacity=".7"; btn.innerHTML='<span class="ai-ring" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Revisando… (puede tardar)'; }
  var resultado={items:[]};
  for(var idx=0; idx<imgs.length; idx++){
    var a=imgs[idx];
    if(resDiv) resDiv.innerHTML='<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Revisando '+(idx+1)+' de '+imgs.length+': '+a.name+'...</div>';
    try{
      // Cualquier formato: PDF, imagen, Excel, Word o texto
      var prep=await _iaDesdeStorage(a.url||a.data, a.name||('arte_'+(idx+1)), 7);
      if(!prep || !prep.bloques || !prep.bloques.length){
        resultado.items.push({nombre:a.name||'', errores:[], nota:'No se pudo leer el archivo.'});
        continue;
      }
      // OJO: una nota NO es un fallo. Cuando un PDF pesado se convierte a
      // imágenes viene con nota («convertido a imagen») y aun así se puede
      // revisar perfectamente. Solo se salta si de verdad no hay nada que
      // mandar.
      if(prep.fallo){
        resultado.items.push({nombre:a.name||'', errores:[], nota:prep.nota||'No se pudo leer.'});
        continue;
      }
      var body={
        model:IA_MODELO,
        max_tokens:1024,
        messages:[{role:'user',content:prep.bloques.concat([
          {type:'text',text:'Eres un revisor de artes gráficos para impresión. Revisa este arte/diseño de producto (puede venir como imagen, PDF o texto extraído) y detecta EXCLUSIVAMENTE errores objetivos en el TEXTO visible: errores de ortografía, de gramática, palabras cortadas, texto duplicado, números o unidades inconsistentes. NO comentes sobre gustos de diseño, colores ni composición. Responde SOLO en JSON válido, sin texto adicional, con este formato: {"errores": ["descripción breve del error 1", "error 2"]}. Si no hay errores, responde {"errores": []}. Responde en español.'}
        ])}]
      };
      var r=await fetch('https://api.anthropic.com/v1/messages',{
        method:'POST',
        headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
        body:JSON.stringify(body)
      });
      var d=await r.json();
      var txt=(d.content&&d.content[0]&&d.content[0].text)?d.content[0].text:'{"errores":[]}';
      txt=txt.replace(/```json|```/g,'').trim();
      var parsed; try{ parsed=JSON.parse(txt); }catch(e){ parsed={errores:['No se pudo interpretar la respuesta de la IA.']}; }
      resultado.items.push({nombre:a.name, errores:parsed.errores||[]});
    }catch(e){
      resultado.items.push({nombre:a.name, errores:['Error al revisar: '+(e.message||e)]});
    }
  }
  window._revIA[oid+subKey]=resultado;
  if(resDiv) resDiv.innerHTML=_renderRevIA(resultado);
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-refresh"></i> Volver a revisar'; }
  var conErr=resultado.items.filter(function(it){return it.errores&&it.errores.length;}).length;
  showT(conErr?('⚠ '+conErr+' arte(s) con posibles errores'):'✓ Sin errores detectados');
}
// Convierte una URL de imagen a base64 (para enviarla a la API)
async function _imgUrlABase64(url){
  var resp=await fetch(url);
  var blob=await resp.blob();
  var mime=blob.type||'image/jpeg';
  var data=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onloadend=function(){ res(fr.result.split(',')[1]); };
    fr.onerror=rej;
    fr.readAsDataURL(blob);
  });
  return {mime:mime, data:data};
}

function buildArtesAprobacion(oid){
  var ap=getAprob(oid);
  var esGerencia=CU && CU.role==='gerencia';
  var h='';
  if(esGerencia){
    // Gerencia: puede aprobar y comentar
    h+='<div style="background:#F0FDF4;border:1px solid #BBF7D0;border-radius:9px;padding:12px;margin-bottom:10px">';
    h+='<div style="font-size:12px;font-weight:600;color:var(--t-verde);margin-bottom:10px;display:flex;align-items:center;gap:6px"><i class="ti ti-stamp"></i>Aprobación de gerencia</div>';
    // Checkbox de aprobado
    h+='<label style="display:flex;align-items:center;gap:9px;cursor:pointer;margin-bottom:10px;font-size:13px;font-weight:500">';
    h+='<input type="checkbox" '+(ap.aprobado?'checked':'')+' onchange="toggleAprobArte(\''+oid+'\',this.checked)" style="width:18px;height:18px;cursor:pointer;accent-color:var(--t-verde3)">';
    h+='<span style="color:'+(ap.aprobado?'#166534':'var(--text-secondary)')+'">'+(ap.aprobado?'✓ Artes aprobados':'Marcar artes como aprobados')+'</span></label>';
    // Comentario opcional
    h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">COMENTARIO (opcional)</label>';
    h+='<textarea placeholder="Agregar un comentario sobre la aprobación..." oninput="setAprobComentario(\''+oid+'\',this.value)" rows="2" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans);resize:vertical">'+(ap.comentario||'')+'</textarea>';
    if(ap.aprobado && ap.por)h+='<div style="font-size:10px;color:var(--t-verde);margin-top:7px"><i class="ti ti-circle-check" style="font-size:10px"></i> Aprobado por '+ap.por+(ap.fecha?' el '+ap.fecha:'')+'</div>';
    h+='</div>';
  } else {
    // Diseño y demás: solo ven el estado, sin modificar
    if(ap.aprobado){
      h+='<div style="background:#F0FDF4;border:1px solid #86EFAC;border-radius:9px;padding:12px;margin-bottom:10px">';
      h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:'+(ap.comentario?'8px':'0')+'">';
      h+='<div style="width:26px;height:26px;background:#16A34A;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="ti ti-check" style="color:white;font-size:15px"></i></div>';
      h+='<div><div style="font-size:12px;font-weight:600;color:var(--t-verde)">Aprobado por gerencia</div>';
      h+='<div style="font-size:10px;color:#15803D">'+(ap.por||'Gerencia')+(ap.fecha?' · '+ap.fecha:'')+'</div></div></div>';
      if(ap.comentario){
        h+='<div style="background:var(--surface-2);border-radius:6px;padding:8px 10px;font-size:12px;color:var(--text-secondary);border-left:3px solid #16A34A"><i class="ti ti-message" style="font-size:11px;color:var(--t-verde3)"></i> '+ap.comentario.replace(/</g,'&lt;')+'</div>';
      }
      h+='</div>';
    } else {
      h+='<div style="background:var(--surface-2);border:0.5px dashed var(--border);border-radius:9px;padding:12px;margin-bottom:10px;font-size:12px;color:var(--text-muted);display:flex;align-items:center;gap:7px"><i class="ti ti-clock"></i>Pendiente de aprobación por gerencia</div>';
    }
  }
  return h;
}
function toggleAprobArte(oid,checked){
  var ap=getAprob(oid);
  ap.aprobado=checked;
  if(checked){ ap.por=CU?CU.name:''; ap.fecha=(typeof dateOnly==='function'?dateOnly():new Date().toLocaleDateString()); }
  else { ap.por=''; ap.fecha=''; }
  guardarAprob(oid);
  // Al aprobar, se le avisa a DISEÑO: son quienes tienen que seguir y antes
  // se enteraban de casualidad o por WhatsApp.
  if(checked){ try{ _artesAvisarDiseno(oid); }catch(e){} }
  // Redibujar el panel para reflejar el estado
  var st=STAGES.find(function(s){return s.key==='artes';});
  var si=STAGES.indexOf(st);
  var body=document.getElementById('egb-'+oid+'-'+si);
  if(body){ buildEGB(oid,si,body); _reabrirSub(oid,si,2); }
  showT(checked?'✓ Artes aprobados · diseño avisado':'Aprobación quitada');
}
function setAprobComentario(oid,val){ getAprob(oid).comentario=val; _guardarAprobDebounced(oid); }
var _aprobTimers={};
function _guardarAprobDebounced(oid){
  if(_aprobTimers[oid]) clearTimeout(_aprobTimers[oid]);
  _aprobTimers[oid]=setTimeout(function(){ guardarAprob(oid); }, 600);
}
async function guardarAprob(oid){
  try{
    var ap=getAprob(oid);
    await fetch(SB+'/rest/v1/compras_artes_aprob?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), aprobado:ap.aprobado, aprobado_por:ap.por||'', aprobado_fecha:ap.fecha||'', comentario:ap.comentario||'', actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarAprob:', e); }
}
async function cargarAprob(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_artes_aprob?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._artesAprob) window._artesAprob={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      window._artesAprob[String(row.docnum)]={ aprobado:!!row.aprobado, por:row.aprobado_por||'', fecha:row.aprobado_fecha||'', comentario:row.comentario||'' };
    });
  }catch(e){ console.error('cargarAprob:', e); }
}

// ═══ EMAIL DE DEPÓSITO/PAGO (compras y contabilidad) ═══
if(!window._depMail) window._depMail={};
function getDepMail(oid,paso){
  var k=oid+'_'+paso;
  if(!window._depMail[k]) window._depMail[k]={para:'',copias:[]};
  return window._depMail[k];
}
// Construye un panel de envío por correo. tipo: 'solicitud' (compras->contabilidad) o 'proveedor' (contabilidad->proveedor)
// Fija el destinatario del correo de depósito desde los atajos
function setDepMailPara(oid, paso, email){
  setDepMailField(oid, paso, 'para', email);
  var det=document.getElementById('modal');
  if(det) { try{ openDetail(oid); }catch(e){} }
  showT('Destinatario: '+email);
}
// Pone en copia a todos los de contabilidad que no sean el destinatario
function addDepMailCopiaTodos(oid, paso){
  var m=getDepMail(oid, paso);
  var para=(m.para||'').toLowerCase();
  var cop=Array.isArray(m.copias)?m.copias.slice():[];
  (USERS||[]).forEach(function(u){
    if(u.role!=='contabilidad'||!u.email) return;
    if(u.email.toLowerCase()===para) return;
    if(cop.map(function(c){return String(c||'').toLowerCase();}).indexOf(u.email.toLowerCase())<0) cop.push(u.email);
  });
  m.copias=cop;
  if(!window._depMail) window._depMail={};
  window._depMail[String(oid)+'_'+String(paso)]=m;
  guardarDepMail(oid, paso);
  try{ openDetail(oid); }catch(e){}
  showT(cop.length+' correo(s) en copia');
}

function buildEmailPanel(oid,paso,tipo){
  var m=getDepMail(oid,paso);
  var o=orders.find(function(x){return x.id===oid;});
  var esSolicitud=(tipo==='solicitud');
  var titulo=esSolicitud?'Enviar solicitud de depósito a Contabilidad':'Enviar comprobante por correo';
  var colorBg=esSolicitud?'#FBEAF0':'#E1F5EE';
  var colorBd=esSolicitud?'#F0C4D5':'#A9DFD0';
  var colorTx=esSolicitud?'#72243E':'#085041';
  var placeholderPara=esSolicitud?'contabilidad@kennedyzl.com':'proveedor@empresa.com';
  var h='';
  h+='<div style="background:'+colorBg+';border:1px solid '+colorBd+';border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:'+colorTx+';margin-bottom:10px;display:flex;align-items:center;gap:6px"><i class="ti ti-mail"></i>'+titulo+'</div>';
  // Para (destinatario)
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREO DESTINATARIO</label>';
  // Atajo: los usuarios de contabilidad, para no escribir el correo a mano
  var _cts=(USERS||[]).filter(function(u){ return u.role==='contabilidad' && u.email; });
  if(esSolicitud && _cts.length){
    h+='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:6px">';
    _cts.forEach(function(u){
      var act=((m.para||'').toLowerCase()===u.email.toLowerCase());
      h+='<span onclick="setDepMailPara(\''+oid+'\',\''+paso+'\',\''+u.email+'\')" title="'+_esc(u.email)+'"'
        +' style="cursor:pointer;font-size:10.5px;font-weight:600;padding:3px 9px;border-radius:13px;'
        +'border:1px solid '+(act?colorTx:'var(--border)')+';background:'+(act?colorTx:'var(--surface-0)')+';color:'+(act?'#fff':colorTx)+'">'
        +(act?'<i class="ti ti-check" style="font-size:10px"></i> ':'')+_esc(u.name)+'</span>';
    });
    h+='<span onclick="addDepMailCopiaTodos(\''+oid+'\',\''+paso+'\')" title="Poner al resto en copia"'
      +' style="cursor:pointer;font-size:10.5px;font-weight:600;padding:3px 9px;border-radius:13px;border:1px dashed '+colorTx+';color:'+colorTx+'">'
      +'<i class="ti ti-users" style="font-size:10px"></i> Todos en copia</span>';
    h+='</div>';
  }
  h+='<input type="email" value="'+(m.para||'').replace(/"/g,'&quot;')+'" placeholder="'+placeholderPara+'" oninput="setDepMailField(\''+oid+'\',\''+paso+'\',\'para\',this.value)" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;margin-bottom:10px;font-family:var(--font-sans)">';
  // Copias
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREOS EN COPIA (CC)</label>';
  h+='<div id="depcc-'+oid+'-'+paso+'">';
  (m.copias||[]).forEach(function(c,ci){
    h+='<div style="display:flex;gap:5px;margin-bottom:5px"><input type="email" value="'+(c||'').replace(/"/g,'&quot;')+'" placeholder="correo@empresa.com" oninput="setDepMailCopia(\''+oid+'\',\''+paso+'\','+ci+',this.value)" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans)"><button onclick="delDepMailCopia(\''+oid+'\',\''+paso+'\','+ci+')" style="background:none;border:0.5px solid var(--border-danger);color:var(--text-danger);border-radius:6px;padding:0 9px;cursor:pointer;font-size:14px">&times;</button></div>';
  });
  h+='</div>';
  h+='<button onclick="addDepMailCopia(\''+oid+'\',\''+paso+'\')" style="background:none;border:1px dashed var(--border);color:var(--text-accent);border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px;margin-bottom:10px"><i class="ti ti-plus" style="font-size:11px"></i> Agregar correo en copia</button>';
  h+='<div><button onclick="enviarDepMail(\''+oid+'\',\''+paso+'\',\''+tipo+'\')" style="width:100%;background:'+colorTx+';color:white;border:none;border-radius:6px;padding:8px 12px;cursor:pointer;font-size:12px;font-weight:600;display:flex;align-items:center;justify-content:center;gap:6px"><i class="ti ti-mail"></i>Abrir en Outlook para enviar</button></div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:7px;line-height:1.4"><i class="ti ti-info-circle" style="font-size:10px"></i> Se abrirá tu Outlook con el correo ya armado. Adjunta los archivos manualmente antes de enviar.</div>';
  h+='</div>';
  return h;
}
function setDepMailField(oid,paso,field,val){ getDepMail(oid,paso)[field]=val; _guardarDepMailDebounced(oid,paso); }
function setDepMailCopia(oid,paso,ci,val){ var m=getDepMail(oid,paso); if(m.copias[ci]!==undefined){m.copias[ci]=val; _guardarDepMailDebounced(oid,paso);} }
function addDepMailCopia(oid,paso){ getDepMail(oid,paso).copias.push(''); _redibujarDepCC(oid,paso); guardarDepMail(oid,paso); }
function delDepMailCopia(oid,paso,ci){ getDepMail(oid,paso).copias.splice(ci,1); _redibujarDepCC(oid,paso); guardarDepMail(oid,paso); }
function _redibujarDepCC(oid,paso){
  var cont=document.getElementById('depcc-'+oid+'-'+paso);
  if(cont && cont.parentNode){ cont.parentNode.outerHTML=buildEmailPanel(oid,paso,cont.parentNode.getAttribute('data-tipo')||'solicitud'); }
}
var _depMailTimers={};
function _guardarDepMailDebounced(oid,paso){
  var k=oid+'_'+paso;
  if(_depMailTimers[k]) clearTimeout(_depMailTimers[k]);
  _depMailTimers[k]=setTimeout(function(){ guardarDepMail(oid,paso); }, 600);
}
// Junta los links de descarga de los archivos adjuntos de una etapa (para incluir en el correo)
function _linksArchivosEtapa(oid, stageKey){
  var links=[];
  if(window._atts){
    for(var k in window._atts){
      // archivos de la etapa (general) y de sus sub-pasos
      if(k.indexOf(oid+stageKey)===0 && window._atts[k]){
        window._atts[k].forEach(function(a){
          if(a.data && a.data.indexOf('http')===0){ links.push('- '+(a.name||'archivo')+': '+a.data); }
        });
      }
    }
  }
  return links;
}
function enviarDepMail(oid,paso,tipo){
  var m=getDepMail(oid,paso);
  var o=orders.find(function(x){return x.id===oid;});
  if(!m.para){ showT('Falta el correo destinatario'); return; }
  var esSolicitud=(tipo==='solicitud');
  var asunto,cuerpo;
  if(esSolicitud){
    asunto='Solicitud de depósito - Orden '+oid+(o?(' - '+o.prov):'');

    var _lk1=_linksArchivosEtapa(oid,'deposito');cuerpo='Estimados Contabilidad,\n\nSolicito el envío del depósito para la siguiente orden de compra:\n\nOrden: '+oid+'\nProveedor: '+(o?o.prov:'')+'\nDescripción: '+(o?o.desc:'')+'\n\n'+(_lk1.length?('Archivos adjuntos (descargar):\n'+_lk1.join('\n')+'\n\n'):'Adjunto la orden de compra para su gestión.\n\n')+'Saludos,\n'+(CU?CU.name:'')+'\nKennedy';
  } else {
    asunto='Deposit / Payment - Order '+oid+(o?(' - '+o.prov):'');
    var _lk2=_linksArchivosEtapa(oid,'deposito');cuerpo='Dear Supplier,\n\nPlease find the payment confirmation for order '+oid+(o?(' ('+o.desc+')'):'')+'.\n\n'+(_lk2.length?('Files (download):\n'+_lk2.join('\n')+'\n\n'):'')+'Best regards,\n'+(CU?CU.name:'')+'\nKennedy';
  }
  var cc=(m.copias||[]).filter(function(c){return c && c.trim();}).join(';');
  var url='mailto:'+encodeURIComponent(m.para)+'?';
  if(cc) url+='cc='+encodeURIComponent(cc)+'&';
  url+='subject='+encodeURIComponent(asunto)+'&body='+encodeURIComponent(cuerpo);
  window.location.href=url;
  showT('Abriendo Outlook...');
}
async function guardarDepMail(oid,paso){
  try{
    var m=getDepMail(oid,paso);
    await fetch(SB+'/rest/v1/compras_dep_mail?on_conflict=docnum,paso', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), paso:String(paso), para:m.para||'', copias:m.copias||[], actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarDepMail:', e); }
}
async function cargarDepMail(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_dep_mail?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._depMail) window._depMail={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      var cop=row.copias; if(typeof cop==='string'){try{cop=JSON.parse(cop);}catch(e){cop=[];}}
      window._depMail[String(row.docnum)+'_'+String(row.paso)]={ para:row.para||'', copias:Array.isArray(cop)?cop:[] };
    });
  }catch(e){ console.error('cargarDepMail:', e); }
}

function getArtes(oid){
  if(!window._artesData[oid]) window._artesData[oid]={wetransfer:'',correoProv:'',copias:[]};
  return window._artesData[oid];
}
function buildArtesEnvio(oid){
  var a=getArtes(oid);
  var o=orders.find(function(x){return x.id===oid;});
  var provNombre=o?o.prov:'';
  var h='';
  h+='<div style="background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:10px;display:flex;align-items:center;gap:6px"><i class="ti ti-send"></i>Enviar artes al proveedor</div>';
  // Link WeTransfer
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">LINK DE WETRANSFER (todos los artes)</label>';
  h+='<input type="text" value="'+(a.wetransfer||'').replace(/"/g,'&quot;')+'" placeholder="https://we.tl/t-xxxxxxxx" oninput="setArteField(\''+oid+'\',\'wetransfer\',this.value)" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;margin-bottom:10px;font-family:var(--font-sans)">';
  // Correo proveedor
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREO DEL PROVEEDOR</label>';
  h+='<input type="email" value="'+(a.correoProv||'').replace(/"/g,'&quot;')+'" placeholder="proveedor@empresa.com" oninput="setArteField(\''+oid+'\',\'correoProv\',this.value)" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;margin-bottom:10px;font-family:var(--font-sans)">';
  // Correos en copia
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREOS EN COPIA (CC)</label>';
  h+='<div id="artes-cc-'+oid+'">';
  (a.copias||[]).forEach(function(c,ci){
    h+='<div style="display:flex;gap:5px;margin-bottom:5px"><input type="email" value="'+(c||'').replace(/"/g,'&quot;')+'" placeholder="correo@empresa.com" oninput="setArteCopia(\''+oid+'\','+ci+',this.value)" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans)"><button onclick="delArteCopia(\''+oid+'\','+ci+')" style="background:none;border:0.5px solid var(--border-danger);color:var(--text-danger);border-radius:6px;padding:0 9px;cursor:pointer;font-size:14px">&times;</button></div>';
  });
  h+='</div>';
  h+='<button onclick="addArteCopia(\''+oid+'\')" style="background:none;border:1px dashed var(--border);color:var(--text-accent);border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px;margin-bottom:10px"><i class="ti ti-plus" style="font-size:11px"></i> Agregar correo en copia</button>';
  // Botón enviar por Outlook
  h+='<div style="display:flex;gap:6px"><button onclick="mailAbrir(\''+oid+'\',\'artes\',null)" style="flex:1;background:#5B21B6;color:white;border:none;border-radius:6px;padding:8px 12px;cursor:pointer;font-size:12px;font-weight:600"><i class="ti ti-send"></i> Redactar correo</button></div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:7px;line-height:1.4"><i class="ti ti-info-circle" style="font-size:10px"></i> Se abrirá tu Outlook con el correo ya armado (proveedor, copias, link de WeTransfer). Solo revisa y dale enviar.</div>';
  h+='</div>';
  return h;
}
function setArteField(oid,field,val){ getArtes(oid)[field]=val; _guardarArtesDebounced(oid); }
function setArteCopia(oid,ci,val){ var a=getArtes(oid); if(a.copias[ci]!==undefined){a.copias[ci]=val; _guardarArtesDebounced(oid);} }
function addArteCopia(oid){ getArtes(oid).copias.push(''); _redibujarArtesCC(oid); guardarArtes(oid); }
function delArteCopia(oid,ci){ getArtes(oid).copias.splice(ci,1); _redibujarArtesCC(oid); guardarArtes(oid); }
function _redibujarArtesCC(oid){
  // Redibujar todo el panel de artes (para reflejar los correos en copia)
  var cont=document.getElementById('artes-cc-'+oid);
  if(cont && cont.parentNode){ cont.parentNode.outerHTML=buildArtesEnvio(oid); }
}
var _artesSaveTimers={};
function _guardarArtesDebounced(oid){
  if(_artesSaveTimers[oid]) clearTimeout(_artesSaveTimers[oid]);
  _artesSaveTimers[oid]=setTimeout(function(){ guardarArtes(oid); }, 600);
}
function enviarArtesOutlook(oid){
  var a=getArtes(oid);
  var o=orders.find(function(x){return x.id===oid;});
  if(!a.correoProv){ showT('Falta el correo del proveedor'); return; }
  var asunto='Artwork for Order '+oid+(o?(' - '+o.prov):'');
  var _lkA=_linksArchivosEtapa(oid,'artes');var cuerpo='Dear Supplier,\n\nPlease find below the WeTransfer link with the artwork files for order '+oid+(o?(' ('+o.desc+')'):'')+':\n\n'+(a.wetransfer||'[paste the WeTransfer link here]')+'\n\n'+(_lkA.length?('Additional files (download):\n'+_lkA.join('\n')+'\n\n'):'')+'We look forward to your confirmation.\n\nBest regards,\n'+(CU?CU.name:'')+'\nKennedy';
  var cc=(a.copias||[]).filter(function(c){return c && c.trim();}).join(';');
  var url='mailto:'+encodeURIComponent(a.correoProv)+'?';
  if(cc) url+='cc='+encodeURIComponent(cc)+'&';
  url+='subject='+encodeURIComponent(asunto)+'&body='+encodeURIComponent(cuerpo);
  window.location.href=url;
  showT('Abriendo Outlook...');
}
async function guardarArtes(oid){
  try{
    var a=getArtes(oid);
    await fetch(SB+'/rest/v1/compras_artes_envio?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), wetransfer:a.wetransfer||'', correo_prov:a.correoProv||'', copias:a.copias||[], actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarArtes:', e); }
}
async function cargarArtes(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_artes_envio?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._artesData) window._artesData={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      var cop=row.copias; if(typeof cop==='string'){try{cop=JSON.parse(cop);}catch(e){cop=[];}}
      window._artesData[String(row.docnum)]={ wetransfer:row.wetransfer||'', correoProv:row.correo_prov||'', copias:Array.isArray(cop)?cop:[] };
    });
  }catch(e){ console.error('cargarArtes:', e); }
}

// ═══ LLEGÓ A DESTINO: confirmación de arribo + edición de fecha si hay atraso ═══
if(!window._llegada) window._llegada={};
function getLlegada(oid){
  if(!window._llegada[oid]) window._llegada[oid]={confirmado:false, fechaReal:'', por:''};
  return window._llegada[oid];
}
function buildLlegadaDestino(oid){
  var bk=getBK(oid);
  var lg=getLlegada(oid);
  var hoy=new Date(); hoy.setHours(0,0,0,0);
  // ¿Algún contenedor ya debería haber llegado según su ETA?
  var fechasLleg=(bk.containers||[]).map(function(c){return c.etaLlegada?new Date(c.etaLlegada):null;}).filter(Boolean);
  var etaMax=fechasLleg.length?new Date(Math.max.apply(null,fechasLleg)):null;
  var yaLlego=etaMax && hoy>=new Date(etaMax.getFullYear(),etaMax.getMonth(),etaMax.getDate());
  var atrasado=etaMax && hoy>new Date(etaMax.getFullYear(),etaMax.getMonth(),etaMax.getDate()) && !lg.confirmado;
  var h='';
  h+='<div style="background:'+(lg.confirmado?'#F0FDF4':atrasado?'#FEF2F2':'#EFF6FF')+';border:1px solid '+(lg.confirmado?'#86EFAC':atrasado?'#FCA5A5':'#BFDBFE')+';border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:'+(lg.confirmado?'#166534':atrasado?'#991B1B':'#1E40AF')+';margin-bottom:9px;display:flex;align-items:center;gap:6px"><i class="ti ti-map-pin"></i>Llegada a destino</div>';
  // Estado según ETA
  if(etaMax){
    var etaStr=etaMax.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});
    h+='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:8px">ETA de llegada: <strong>'+etaStr+'</strong>';
    if(yaLlego && !lg.confirmado) h+=' <span style="color:#059669">· la fecha ya se cumplió, el contenedor debería estar en puerto</span>';
    if(atrasado) h+=' <span style="color:var(--t-rojo2);font-weight:600">· ATRASADO</span>';
    h+='</div>';
  } else {
    h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px">Registrá la fecha de llegada (ETA) en los contenedores del paso de Booking.</div>';
  }
  // Confirmación (ganchito)
  h+='<label style="display:flex;align-items:center;gap:9px;cursor:pointer;font-size:13px;font-weight:500;margin-bottom:8px">';
  h+='<input type="checkbox" '+(lg.confirmado?'checked':'')+' onchange="toggleLlegada(\''+oid+'\',this.checked)" style="width:18px;height:18px;cursor:pointer;accent-color:var(--t-verde3)">';
  h+='<span style="color:'+(lg.confirmado?'#166534':'var(--text-secondary)')+'">'+(lg.confirmado?'✓ Contenedor en puerto (confirmado)':'Confirmar que el contenedor llegó a puerto')+'</span></label>';
  if(lg.confirmado && lg.por) h+='<div style="font-size:10px;color:var(--t-verde);margin-bottom:8px"><i class="ti ti-circle-check" style="font-size:10px"></i> Confirmado por '+lg.por+(lg.fechaConfirm?' el '+lg.fechaConfirm:'')+'</div>';
  // Editar fecha de llegada nueva (atraso)
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">FECHA DE LLEGADA REAL (editá si hubo atraso)</label>';
  h+='<input type="date" value="'+(lg.fechaReal||'')+'" onchange="setLlegadaFecha(\''+oid+'\',this.value)" style="padding:6px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans)">';
  if(atrasado) h+='<div style="font-size:11px;color:var(--t-rojo);margin-top:8px;background:#FEE2E2;border-radius:6px;padding:7px 9px"><i class="ti ti-alert-triangle" style="font-size:11px"></i> Este contenedor está atrasado. Se notificó al equipo de Importación. Actualizá la fecha de llegada real arriba.</div>';
  h+='</div>';
  return h;
}
function toggleLlegada(oid,checked){
  var lg=getLlegada(oid);
  lg.confirmado=checked;
  if(checked){ lg.por=CU?CU.name:''; lg.fechaConfirm=(typeof dateOnly==='function'?dateOnly():new Date().toLocaleDateString()); }
  else { lg.por=''; lg.fechaConfirm=''; }
  guardarLlegada(oid);
  var st=STAGES.find(function(s){return s.key==='logistica';});
  var si=STAGES.indexOf(st);
  var body=document.getElementById('egb-'+oid+'-'+si);
  if(body){ buildEGB(oid,si,body); _reabrirSub(oid,si,2); }
  showT(checked?'✓ Llegada confirmada':'Confirmación quitada');
}
function setLlegadaFecha(oid,val){
  getLlegada(oid).fechaReal=val;
  guardarLlegada(oid);
  showT('Fecha de llegada actualizada');
}
async function guardarLlegada(oid){
  try{
    var lg=getLlegada(oid);
    await fetch(SB+'/rest/v1/compras_llegada?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), confirmado:lg.confirmado, confirmado_por:lg.por||'', fecha_real:lg.fechaReal||'', actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarLlegada:', e); }
}
// ═══ ÓRDENES MANUALES SIN SAP (creadas por compradoras, se trabajan antes de existir en SAP) ═══
if(!window._pendSAP) window._pendSAP=[];
// Días transcurridos desde la fecha de creación (YYYY-MM-DD)
function _diasPendSAP(p){
  var f=p.creado_en||p.fecha||'';
  if(!f) return 0;
  try{ return daysBetween(f, null)||0; }catch(e){ return 0; }
}
// Órdenes que TODAVÍA no existen como orden real en SAP.
// Si aparece una orden real (del sync) con el mismo num_orden (num_proveedor), se oculta.
// ═══════════════════════════════════════════════════════════════════════════
//  ¿QUÉ ORDEN DE SAP CORRESPONDE A UNA ORDEN NO SAP?
//  La referencia se escribe a mano en SAP, así que no siempre coincide letra
//  por letra: la orden NO SAP puede llamarse "26088" y en SAP quedar como
//  "DKC-26088".
//
//  Comparar solo los dígitos sería peligroso: en la misma base conviven
//  DKC-26088 (ZHEJIANG) y HIKC-26088 (LONWA), que son órdenes distintas de
//  proveedores distintos. Por eso, cuando la coincidencia no es exacta, hace
//  falta que ADEMÁS coincida el proveedor.
// ═══════════════════════════════════════════════════════════════════════════
function _refNorm(v){ return String(v==null?'':v).toUpperCase().replace(/[^A-Z0-9]/g,''); }
function _refDigitos(v){ return String(v==null?'':v).replace(/\D/g,''); }

function _provParecido(a, b){
  a=String(a||'').toUpperCase().replace(/[^A-Z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  b=String(b||'').toUpperCase().replace(/[^A-Z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  if(!a || !b) return false;
  if(a===b) return true;
  if(a.indexOf(b)>=0 || b.indexOf(a)>=0) return true;
  // Las dos primeras palabras suelen bastar: "ZHEJIANG SUNFLOW ..."
  var pa=a.split(' ').slice(0,2).join(' '), pb=b.split(' ').slice(0,2).join(' ');
  return !!pa && pa===pb;
}

// Devuelve la orden de SAP que corresponde a este pendiente, o null
function _ordenSapDeNoSap(p){
  var ref=String(p.num_orden||p.dkc||'').trim();
  if(!ref) return null;
  var refN=_refNorm(ref), refD=_refDigitos(ref);
  var reales=(typeof orders!=='undefined'?orders:[]).filter(function(o){ return !o._noSap; });

  // 1) Coincidencia exacta de la referencia
  var exacta=reales.find(function(o){ return _refNorm(o.num_proveedor)===refN && refN; });
  if(exacta) return exacta;

  // 2) Misma numeración con otro prefijo: hace falta que el proveedor coincida
  if(refD.length>=4){
    var candidatas=reales.filter(function(o){
      var d=_refDigitos(o.num_proveedor);
      return d && d===refD;
    });
    if(candidatas.length===1 && _provParecido(candidatas[0].prov, p.proveedor)) return candidatas[0];
    if(candidatas.length>1){
      var conProv=candidatas.filter(function(o){ return _provParecido(o.prov, p.proveedor); });
      if(conProv.length===1) return conProv[0];
      _dbg('[BORRADOR] '+ref+' coincide con '+candidatas.length
        +' órdenes de SAP y no se puede decidir: '
        +candidatas.map(function(o){ return o.num_proveedor+' ('+o.prov+')'; }).join(', '));
    }
  }
  return null;
}

function pendientesSAPVisibles(){
  var vis=(window._pendSAP||[]).filter(function(p){
    return !_ordenSapDeNoSap(p);          // se oculta si ya existe en SAP
  });
  // El departamento del usuario acota aquí, en el origen. Estaba filtrado
  // solo en la pantalla de búsqueda, así que el tablero, los paneles de
  // KPI y los totales seguían enseñando las órdenes de otros departamentos:
  // Sherene, de Hogar, veía las de Alfombras.
  if(_deptAcotado()){
    vis=vis.filter(function(p){ return _deptPermitido(normDept(p.dept||'')); });
  }
  // De la más nueva a la más vieja. Si no hay fecha se usa el número de orden,
  // que es correlativo, para que igual queden en orden.
  return vis.slice().sort(function(a,b){
    var fa=String(a.creado_en||a.fecha||''), fb=String(b.creado_en||b.fecha||'');
    if(fa && fb && fa!==fb) return fb.localeCompare(fa);
    if(fa && !fb) return -1;
    if(!fa && fb) return 1;
    var na=parseInt(String(a.num_orden||a.dkc||'').replace(/\D/g,''),10)||0;
    var nb=parseInt(String(b.num_orden||b.dkc||'').replace(/\D/g,''),10)||0;
    return nb-na;
  });
}
// Totales (monto = total de la orden)
// El importe de un total NO SAP. Si la lista no se pudo cargar, un $0 hace
// creer que no hay nada; conviene decir que falta el dato.
function _nsapKpi(v){
  if(window._pendSAPError && !(window._pendSAP||[]).length){
    return '<span title="No se pudo cargar la lista de órdenes BORRADOR. '
      +'Pulsa Sync o recarga la página." style="color:var(--t-ambar)">'
      +'<i class="ti ti-alert-triangle" style="font-size:12px"></i> sin cargar</span>';
  }
  return fmt(v);
}

function totalPendSAP(){
  return pendientesSAPVisibles().reduce(function(s,p){return s+(Number(p.total)||0);},0);
}
function totalAbonPendSAP(){
  return pendientesSAPVisibles().reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
}
function pendSAPporDept(dept){
  return pendientesSAPVisibles().filter(function(p){return String(p.dept||'')===String(dept);});
}
function totalPendSAPporDept(dept){
  return pendSAPporDept(dept).reduce(function(s,p){return s+(Number(p.total)||0);},0);
}
function totalAbonPendSAPporDept(dept){
  return pendSAPporDept(dept).reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
}
// Badge con los días sin subir a SAP (color según antigüedad)
function _badgeDiasSAP(dias){
  var col = dias>=30?'#e24b4a' : dias>=15?'#BA7517' : '#639922';
  var bg  = dias>=30?'#FBE9E9' : dias>=15?'#FEF3E8' : '#EAF3DE';
  return '<span style="font-size:10px;background:'+bg+';color:'+col+';padding:1px 7px;border-radius:8px;white-space:nowrap"><i class="ti ti-clock" style="font-size:9px"></i> '+dias+'d sin SAP</span>';
}

// Bloque de "órdenes sin SAP" que se muestra dentro de cada departamento
// (total del depto + listado). El botón para CREAR está en la etapa Bodega & Venta.
function _deptoPendSAPBloque(dept, totSap, abnSap){
  var lista=pendSAPporDept(dept);
  var total=totalPendSAPporDept(dept), abon=totalAbonPendSAPporDept(dept), saldo=total-abon;
  var h='<div style="background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:'+(lista.length?'8px':'0')+'">';
  h+='<i class="ti ti-clock-pause" style="color:var(--t-lila2);font-size:15px"></i>';
  h+='<span style="font-size:12px;font-weight:600;color:var(--t-lila2)">Órdenes sin SAP</span>';
  h+='<span style="font-size:11px;color:#7C3AED">'+lista.length+' orden'+(lista.length!==1?'es':'')+(CU.verCostos?' · <strong>'+fmt(total)+'</strong> total · <strong style="color:var(--text-success)">'+fmt(abon)+'</strong> abonado · <strong style="color:var(--text-danger)">'+fmt(saldo)+'</strong> saldo':'')+'</span>';
  h+='</div>';
  lista.forEach(function(p){ h+=_pendSAPFila(p, false); });
  // Gran total del departamento (SAP + sin SAP)
  if(CU.verCostos && (totSap!=null)){
    var granTot=(Number(totSap)||0)+total;
    var granAbn=(Number(abnSap)||0)+abon;
    h+='<div style="margin-top:8px;padding-top:8px;border-top:0.5px dashed #C4B5FD;display:flex;gap:16px;flex-wrap:wrap">';
    h+='<span style="font-size:12px;font-weight:700">GRAN TOTAL: <span style="color:var(--text-accent)">'+fmt(granTot)+'</span></span>';
    h+='<span style="font-size:11px;color:var(--text-success)">Abonado total: '+fmt(granAbn)+'</span>';
    h+='<span style="font-size:11px;color:var(--text-danger)">Saldo total: '+fmt(granTot-granAbn)+'</span>';
    h+='<span style="font-size:9px;color:var(--text-muted);width:100%">Suma de órdenes en SAP + sin SAP</span>';
    h+='</div>';
  }
  h+='</div>';
  return h;
}

// Una fila/tarjeta de orden sin SAP (compacta para listados)
function _pendSAPFila(p, mostrarDept){
  var dias=_diasPendSAP(p);
  // Clave segura: si la orden no tiene dkc, p.dkc.replace() reventaba y
  // tumbaba el render completo de "Buscar ordenes" con el filtro No SAP.
  var _k=String(p.dkc||p.num_orden||'').replace(/'/g,'');
  var ref=p.num_orden||p.dkc||'(sin número)';
  var total=Number(p.total)||0, abon=Number(p.abonado)||0, saldo=(p.saldo!=null?Number(p.saldo):total-abon);
  // La fila abre la orden, salvo que el clic caiga en la etiqueta de la
  // reposición. Con stopPropagation bastaría, pero si algo lo deja pasar el
  // detalle se abre encima y se lleva por delante el panel de diferencias.
  var h='<div class="nosap-card" onclick="if(!(event.target.closest&&event.target.closest(\'.nsap-dif-chip\'))) abrirDetalleNoSap(\''+_k+'\')" title="Abrir las etapas de esta orden" style="border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;background:var(--surface-0);margin-bottom:7px;cursor:pointer">';
  h+='<div style="display:flex;align-items:flex-start;gap:8px">';
  h+='<div style="width:30px;height:30px;background:var(--pastel-naranja);border-radius:7px;display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="ti ti-file-invoice" style="color:var(--t-ambar);font-size:15px"></i></div>';
  h+='<div style="flex:1;min-width:0">';
  h+='<div style="font-size:13px;font-weight:600">'+(p.proveedor||'(sin proveedor)')+' <span onclick="event.stopPropagation();abrirAdjuntoPendSAP(\''+_k+'\')" style="font-weight:400;color:var(--text-accent);font-size:11px;cursor:pointer;text-decoration:underline" title="Ver adjunto de esta orden">— '+ref+'</span></div>';
  // De qué reposición viene. Se muestra aunque no haya registro de
  // diferencias: el origen de la orden es un dato por sí solo.
  // De qué reposición viene. Si hay registro de diferencias, la etiqueta es
  // el acceso: un clic aquí lo abre, sin tener que entrar a la orden.
  if(p.num_reposicion){
    var _dif=_nsapDifDe(p);
    var _nd=_dif?((_dif.faltan||[]).length+(_dif.agregados||[]).length+(_dif.distintos||[]).length):0;
    var _clic=_dif
      ? ' onclick="event.stopPropagation();event.stopImmediatePropagation();_nsapVerDif(\''+_esc(_k)+'\')" '
        +'title="Ver las diferencias contra la reposición '+_esc(p.num_reposicion)+'" '
      : ' title="Esta orden salió de la reposición '+_esc(p.num_reposicion)+'" ';
    h+='<div class="nsap-dif-chip" style="margin-top:3px;display:inline-flex;align-items:center;gap:5px'
      +(_dif?';cursor:pointer':'')+'"'+_clic+'>'
      +'<span style="font-size:10px;background:var(--pastel-lila);border:1px solid #C4B5FD;color:var(--t-lila);'
      +'border-radius:8px;padding:1px 7px;font-weight:700">'
      +'<i class="ti ti-repeat" style="font-size:9px"></i> '+_esc(p.num_reposicion)+'</span>'
      +(_dif?('<span style="font-size:10px;font-weight:600;color:'
        +(_dif.cuadra?'#166534':'#B45309')+';text-decoration:underline;text-underline-offset:2px">'
        +(_dif.cuadra?'sin cambios':(_nd+' diferencia(s)'))+'</span>')
        : '<span title="La comparación no quedó guardada con esta orden" '
          +'style="font-size:10px;color:var(--text-muted)">sin registro</span>')
      +'</div>';
  }
  h+=(p.po?'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">PO: '+p.po+'</div>':'');
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'+(mostrarDept&&p.dept?(EMOJIS2[p.dept]||'')+' '+dL(p.dept)+' · ':'')+(p.creado_en||p.fecha||'')+(p.by?' · '+p.by:'')+'</div>';
  h+='<div style="display:flex;gap:5px;margin-top:4px;flex-wrap:wrap">'+_badgeDiasSAP(dias);
  if(window._atts&&window._atts[_k+'__pendsap']&&window._atts[_k+'__pendsap'].length){
    h+='<span style="font-size:10px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:1px 7px;color:var(--text-muted)"><i class="ti ti-paperclip" style="font-size:9px"></i> '+window._atts[_k+'__pendsap'].length+'</span>';
  }
  h+='</div>';
  h+='</div>';
  if(CU.verCostos){
    h+='<div style="text-align:right;flex-shrink:0">';
    h+='<div style="font-size:13px;font-weight:700;color:var(--t-ambar)">'+fmt(total)+'</div>';
    h+='<div style="font-size:10px;color:var(--text-success)">Ab: '+fmt(abon)+'</div>';
    h+='<div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(saldo)+'</div>';
    // El botón, justo debajo del saldo de cada orden del listado. Aquí va
    // compacto: en una lista de veinte tarjetas, veinte botones grandes
    // tapan los datos.
    h+=_ocBotonSubirNoSap(_k, true);
    h+='</div>';
  }
  h+='</div>';
  // Acciones: revisar con IA, ver/editar, eliminar
    // Vista previa adjunto (C1b)
  var _ak2=_k+'__pendsap';
  var _al2=window._atts&&window._atts[_ak2]?window._atts[_ak2]:[];
  if(!_al2.length&&p.adjunto_url)_al2=[{name:p.adjunto_name||'adjunto',data:p.adjunto_url}];
  if(_al2.length){
    h+='<div style="margin-top:8px;display:flex;flex-wrap:wrap;gap:6px">';
    _al2.forEach(function(a){
      var ext2=(a.name||'').split('.').pop().toLowerCase();
      var url2=a.data||a.url||'';
      if(['jpg','jpeg','png','gif','webp'].includes(ext2)){
        h+='<img src="'+url2+'" data-src="'+url2+'" class="att-img" onclick="event.stopPropagation()" style="height:60px;border-radius:6px;border:0.5px solid var(--border);cursor:zoom-in;object-fit:cover" title="'+a.name+'">';
      } else if(ext2==='pdf'){
        h+='<a href="'+url2+'" target="_blank" onclick="event.stopPropagation()" style="display:inline-flex;align-items:center;gap:5px;padding:5px 10px;background:#FEF0F0;border:0.5px solid #f5c9a0;border-radius:7px;font-size:11px;color:var(--t-ambar);text-decoration:none"><i class="ti ti-file-type-pdf" style="font-size:14px"></i>'+a.name+'</a>';
      } else {
        h+='<a href="'+url2+'" target="_blank" onclick="event.stopPropagation()" style="display:inline-flex;align-items:center;gap:5px;padding:5px 10px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:7px;font-size:11px;color:var(--text-accent);text-decoration:none"><i class="ti ti-file-spreadsheet" style="font-size:14px"></i>'+a.name+'</a>';
      }
    });
    h+='</div>';
  }
  h+='<div style="display:flex;gap:6px;margin-top:8px;flex-wrap:wrap">';
  h+='<button onclick="event.stopPropagation();revisarPendSAPIA(\''+_k+'\')" style="background:var(--pastel-lila);color:var(--t-lila);border:none;border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px;font-weight:600"><i class="ti ti-sparkles" style="font-size:11px"></i> AI revisar</button>';
  h+='<button onclick="event.stopPropagation();abrirPendSAP(\''+_k+'\')" style="background:var(--surface-2);border:0.5px solid var(--border);border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px"><i class="ti ti-eye" style="font-size:11px"></i> Ver / adjuntos</button>';
  h+='<button onclick="event.stopPropagation();eliminarPendSAP(\''+_k+'\')" style="background:none;border:0.5px solid var(--border-danger);color:var(--text-danger);border-radius:6px;padding:5px 8px;cursor:pointer;font-size:11px"><i class="ti ti-trash" style="font-size:11px"></i></button>';
  h+=_catBtnOrden(_k);
  h+=_smBtn(_k);
  h+='</div>';
  h+='</div>';
  return h;
}

// Lee el registro guardado de un pendiente (venga como objeto o como texto)
function _nsapDifDe(p){
  if(!p || !p.dif_reposicion) return null;
  var d=p.dif_reposicion;
  if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ return null; } }
  return (d && d.num) ? d : null;
}

// La ventana con el registro completo
// Los documentos de las dos partes: el PDF/Excel de la reposición que se le
// mandó a la compradora, y lo que se adjuntó al crear la orden NO SAP.
function _nsapDocsHTML(titulo, lista, color){
  lista=(lista||[]).filter(function(a){ return a && _docHref(a); });
  if(!lista.length) return '';
  var h='<div style="margin-top:10px"><div style="font-size:10px;font-weight:700;'
    +'text-transform:uppercase;letter-spacing:.4px;color:'+color+';margin-bottom:4px">'
    +_esc(titulo)+'</div><div style="display:flex;gap:6px;flex-wrap:wrap">';
  lista.forEach(function(a){
    var nom=String(a.name||a.nombre_archivo||'archivo');
    var ext=nom.split('.').pop().toLowerCase();
    var ico=(ext==='pdf')?'ti-file-type-pdf'
           :(['xlsx','xls','csv'].indexOf(ext)>=0)?'ti-file-spreadsheet'
           :(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0)?'ti-photo':'ti-file';
    h+='<a href="'+_esc(_docHref(a))+'" target="_blank" rel="noopener" '
      +'style="display:inline-flex;align-items:center;gap:6px;padding:6px 11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:11px;color:var(--text-accent);text-decoration:none;max-width:280px">'
      +'<i class="ti '+ico+'" style="font-size:14px"></i>'
      +'<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(nom)+'</span></a>';
  });
  return h+'</div></div>';
}

// Los archivos que viajaron en el correo de la reposición.
// Ojo con el formato: el envío los guarda como {path, nombre} — no como
// {url, name} —, y por eso antes no aparecía ninguno en el panel.
function _repArchivoNormal(a){
  if(!a) return null;
  var nom=a.nombre||a.name||a.nombre_archivo||'';
  var url=_docHref(a);
  if(!url && a.path){
    url=DOCS_BASE + String(a.path).split('/').map(encodeURIComponent).join('/');
    if(!nom) nom=String(a.path).split('/').pop();
  }
  if(!url) return null;
  return {name:nom||'archivo', url:url};
}

function _repArchivosDe(fila){
  var a=fila && fila.archivos;
  if(!a) return [];
  if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ return []; } }
  if(!Array.isArray(a)) return [];
  return a.map(_repArchivoNormal).filter(Boolean);
}

async function _nsapArchivosRepo(num){
  var n=String(num||'').trim().toUpperCase(), val=_repNumVal(n);
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_envios'
      +'?select=id,num_reposicion,pedido_id,archivos&order=id.desc&limit=500',{headers:SBH});
    if(!r.ok) return [];
    var envs=await r.json()||[];

    // 1) Por número de reposición
    var e=envs.find(function(x){
      var t=String(x.num_reposicion||'').trim().toUpperCase();
      return (t===n || (val && _repNumVal(t)===val)) && _repArchivosDe(x).length; });
    if(e) return _repArchivosDe(e);

    // 2) Si el número no llegó al envío, se busca el pedido y se va por su id
    var ped=null;
    try{ ped=await _repBuscarPedidoPorNum(n); }catch(err){}
    if(ped && ped.id){
      var e2=envs.find(function(x){
        return String(x.pedido_id)===String(ped.id) && _repArchivosDe(x).length; });
      if(e2) return _repArchivosDe(e2);
    }
    return [];
  }catch(err){ console.warn('[reposición] archivos:', err); return []; }
}

async function _nsapVerDif(ref){
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(ref) || String(x.num_orden)===String(ref); });
  var d=_nsapDifDe(p);
  if(!d){ showT('Esta orden no tiene registro de reposición'); return; }

  var prev=document.getElementById('modalDifRepo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalDifRepo';
  // Por encima de cualquier otro panel del portal
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13600;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:760px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px">'
      +'<div><div style="font-size:14px;font-weight:700">'
        +'<i class="ti ti-git-compare"></i> Orden '+_esc(ref)+' contra la reposición '+_esc(d.num||'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'
        +'Comparación hecha al crear la orden'+(d.fecha?(' · '+_esc(d.fecha)):'')
        +(d.por?(' · '+_esc(d.por)):'')+'</div></div>'
      +'<button onclick="document.getElementById(\'modalDifRepo\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    + _nsapDifPanelHTML(d)
    +'<div id="difDocs"><div style="font-size:11px;color:var(--text-muted);margin-top:10px">'
      +'<i class="ti ti-loader-2 spin"></i> Buscando los documentos…</div></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:12px">'
      +'<button class="btn" onclick="_nsapCopiarDif(\''+_esc(ref)+'\')">'
        +'<i class="ti ti-copy"></i> Copiar el detalle</button>'
      +'<button class="btn bg2" onclick="document.getElementById(\'modalDifRepo\').remove()">Cerrar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}

  // Los documentos se cargan después, para que el panel aparezca ya
  var docs=document.getElementById('difDocs');
  var arch=[];
  try{ arch=await _nsapArchivosRepo(d.num); }catch(e){}
  // Los documentos de la orden viven en dos llaves distintas según por dónde
  // se subieron ('__pendsap' al crearla, 'pedido' desde la etapa). Mirar una
  // sola dejaba fuera los de la otra. _docsBaseOrden junta las dos y quita
  // repetidos, que es lo mismo que usa la solicitud de abono.
  var deOrden=[];
  try{ deOrden=_docsBaseOrden(String(ref))||[]; }
  catch(e){ deOrden=(window._atts&&window._atts[String(ref)+'__pendsap'])||[]; }
  // Si todavía no se cargaron, se piden ahora
  if(!deOrden.length){
    try{
      await cargarDocsOrden(String(ref));
      deOrden=_docsBaseOrden(String(ref))||[];
    }catch(e){}
  }
  if(!docs || !document.body.contains(ov)) return;
  var h2=_nsapDocsHTML('Reposición '+(d.num||'')+' — PDF y Excel que se enviaron', arch, '#5B21B6');
  if(!h2){
    // Se dice que no están, en vez de no mostrar el bloque: así se sabe que
    // se buscó y que esa reposición no dejó archivos guardados.
    h2='<div style="margin-top:10px"><div style="font-size:10px;font-weight:700;'
      +'text-transform:uppercase;letter-spacing:.4px;color:var(--t-lila);margin-bottom:4px">'
      +'Reposición '+_esc(d.num||'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-paperclip"></i> '
      +'No quedaron archivos guardados de esta reposición.</div></div>';
  }
  var h3=_nsapDocsHTML('Orden '+ref+' — lo que se adjuntó al crearla', deOrden, '#B45309');
  if(!h3){
    h3='<div style="margin-top:10px"><div style="font-size:10px;font-weight:700;'
      +'text-transform:uppercase;letter-spacing:.4px;color:var(--t-ambar);margin-bottom:4px">'
      +'Orden '+_esc(String(ref))+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-paperclip"></i> '
      +'Esta orden no tiene documentos adjuntos.</div></div>';
  }
  docs.innerHTML=h2+h3;
}

function _nsapCopiarDif(ref){
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(ref) || String(x.num_orden)===String(ref); });
  var d=_nsapDifDe(p); if(!d) return;
  var txt=d.texto||_nsapDifTexto(d);
  try{
    navigator.clipboard.writeText(txt);
    showT('✓ Detalle copiado');
  }catch(e){ showT('No se pudo copiar'); }
}

// Panel del dashboard: lista TODAS las órdenes sin SAP agrupadas por departamento
function buildPendientesSAP(filtroDept, mostrarForm){
  var todas=filtroDept?pendSAPporDept(filtroDept):pendientesSAPVisibles();
  var h='';
  if(!todas.length){ h+='<div class="empty">No hay órdenes sin SAP'+(filtroDept?' en este departamento':'')+'.</div>'; return h; }
  if(filtroDept){
    todas.forEach(function(p){ h+=_pendSAPFila(p, false); });
    return h;
  }
  // Agrupar por departamento
  var porDept={};
  todas.forEach(function(p){ var d=p.dept||'otros'; (porDept[d]=porDept[d]||[]).push(p); });
  DEPTS_ALL.forEach(function(d){
    var lista=porDept[d]; if(!lista||!lista.length) return;
    var total=lista.reduce(function(s,p){return s+(Number(p.total)||0);},0);
    var abon=lista.reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
    h+='<div style="padding:8px 12px;background:var(--surface-1);border-bottom:0.5px solid var(--border);display:flex;align-items:center;gap:8px;flex-wrap:wrap">';
    h+='<span style="font-size:12px;font-weight:600">'+(EMOJIS2[d]||'')+' '+dL(d)+'</span>';
    h+='<span style="font-size:11px;color:var(--text-muted)">'+lista.length+' orden'+(lista.length!==1?'es':'')+(CU.verCostos?' · <strong style="color:var(--t-ambar)">'+fmt(total)+'</strong> · Ab: <strong style="color:var(--text-success)">'+fmt(abon)+'</strong> · Saldo: <strong style="color:var(--text-danger)">'+fmt(total-abon)+'</strong>':'')+'</span>';
    h+='</div>';
    h+='<div style="padding:8px 12px">';
    lista.forEach(function(p){ h+=_pendSAPFila(p, false); });
    h+='</div>';
  });
  return h;
}

// Modal para AGREGAR una orden manual sin SAP (se abre desde la etapa Bodega & Venta)
function abrirNuevaOrdenSinSAP(deptPre, prefill){
  // Si el usuario tiene departamento, ese es el suyo: Henry ve ropa, Gady
  // alfombras, y con ello la plantilla que les toca. Quien no tenga (como
  // gerencia) lo elige a mano y se queda con la de siempre.
  if(!deptPre && CU && CU.dept) deptPre=CU.dept;
  window._nsapCardcode=''; window._nsapProvNuevoOK=false; window._nsapProvUltimo='';
  window._nsapDocs={prov:null, kcc:null, pedido:null}; window._nsapArchivo=null;
  window._vd=null;
  // El Excel de apoyo es de ESTA orden: si no se borra, la siguiente sacaría
  // las fotos del archivo de la anterior.
  window._nsapExcelExtra=null;
  window._nsapItems=[];   // reiniciar productos al abrir
  var ov=document.createElement('div');
  ov.id='modalNuevaSAP';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1002;display:flex;align-items:center;justify-content:center;padding:16px';
  // Arranca en false a propósito: el conmutador de abajo es quien aplica los
  // estilos, y se le llama una vez montado el panel para abrirlo de par en
  // par. Con las columnas de ropa o alfombras no cabe en una ventana chica.
  window._nsapFull=false;
  var opts='<option value="">Departamento…</option>'+DEPTS_ALL.map(function(d){return '<option value="'+d+'"'+(deptPre===d?' selected':'')+'>'+(EMOJIS2[d]||'')+' '+dL(d)+'</option>';}).join('');
  var h='<div id="nsapPanel" style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:1600px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
    +'<div style="font-size:15px;font-weight:600"><i class="ti ti-plus" style="color:var(--t-ambar)"></i> Nueva orden sin SAP</div>'
    +'<div style="display:flex;align-items:center;gap:4px">'
      +'<button onclick="_nsapPantallaCompleta()" id="nsapFullBtn" title="Pantalla completa"'
        +' style="background:none;border:none;cursor:pointer;color:var(--text-muted);padding:2px 6px">'
        +'<i class="ti ti-arrows-maximize" id="nsapFullIco" style="font-size:17px"></i></button>'
      +'<button onclick="_nsapCerrarModal()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div></div>';
  try{ h+=_nsapAvisoDraft(); }catch(e){}
  // Paso 1: adjuntar documento para que la IA extraiga
  h+='<div style="background:var(--pastel-lila);border:0.5px solid #C4B5FD;border-radius:8px;padding:11px;margin-bottom:12px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:6px"><i class="ti ti-sparkles"></i> Extraer datos con AI</div>';
  h+='<div style="font-size:11px;color:var(--t-lila);margin-bottom:8px">Adjunta los dos documentos. La IA extrae los datos y compara uno contra otro para avisarte de cualquier diferencia.</div>';
  h+='<div style="display:flex;flex-direction:column;gap:7px">';
  // Dos adjuntos: la PI del proveedor y nuestra orden de compra
  h+=_nsapCajaArchivo('prov','PI PROVEEDOR','Proforma Invoice del proveedor','#B45309','#FEF9F3','#E9C08A');
  h+=_nsapCajaArchivo('kcc','KCC ORDEN DE COMPRA','Nuestra orden de compra','#0c447c','#e6f1fb','#85B7EB');
  h+='</div>';
  h+='<button id="nsapBtnIA" class="btn bp" style="background:#5B21B6;width:100%;margin-top:9px;padding:9px;font-size:12.5px" onclick="_nsapRevisarConIA()"><i class="ti ti-sparkles"></i> Revisar y comparar con IA</button>';
  h+='<button class="btn bg2" style="width:100%;margin-top:6px;padding:7px;font-size:11.5px" '
    +'onclick="_nsapSacarFotos()" title="Extrae las fotos incrustadas en el Excel del proveedor">'
    +'<i class="ti ti-photo-search"></i> Sacar las fotos del Excel</button>';
  h+='<div id="nsapIAstatus" style="font-size:11px;margin-top:7px"></div>';
  h+='<div id="nsapIAerrores" style="margin-top:7px"></div>';
  h+='</div>';
  // Paso 2: campos (los llena la IA, editables)
  h+='<div style="display:flex;flex-direction:column;gap:9px">';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Departamento *</label><select id="nsapDept" onchange="_nsapRenderItems()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)">'+opts+'</select></div>';
  h+='<div><div style="display:flex;gap:8px">'
    +'<div style="flex:1;min-width:0"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Proveedor *</label>'
      +'<input id="nsapProv" placeholder="Nombre del proveedor" onblur="_nsapBuscarProvSAP()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>'
    +'<div style="flex:0 0 120px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Código SAP</label>'
      +'<input id="nsapProvCod" placeholder="Ej: P1276" onblur="_nsapCodigoManual(this.value)" onkeydown="if(event.key===\'Enter\'){event.preventDefault();_nsapCodigoManual(this.value);}" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;font-weight:700;text-transform:uppercase"></div>'
    +'</div>'
    +'<div id="nsapProvSAP" style="margin-top:4px"></div></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de orden (DKC / SKC) *</label><input id="nsapRef" placeholder="Ej: DKC-25090 o SKC-25090" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="display:flex;gap:8px">'
    +'<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de PO del proveedor</label>'
      +'<input id="nsapPO" placeholder="PO del proveedor" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>'
    +'<div style="flex:0 0 200px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de reposición</label>'
      +'<input id="nsapNumRepo" placeholder="Ej: R-01" oninput="_nsapRepoCambio()" '
      +'title="Si el documento viene de una reposición, la IA lo completa solo. Si no, dejalo vacío." '
      +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;font-weight:700;text-transform:uppercase"></div>'
    +'</div>';
  h+='<div id="nsapRepoBox" style="display:none"></div>';
  h+='<div style="display:flex;gap:8px">';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Total *</label><input id="nsapTotal" type="number" step="0.01" placeholder="0.00" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Por Abonar</label><input id="nsapAbon" type="number" step="0.01" placeholder="0.00" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:0 0 92px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">% Abono</label>'
    +'<input id="nsapAbonPct" type="number" step="0.01" min="0" max="100" placeholder="0" oninput="_nsapAbonoDesdePct()" '
    +'title="Escribe el porcentaje y se calcula el monto sobre el total" '
    +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;font-weight:700"></div>';
  h+='<div style="flex:0 0 168px;display:flex;align-items:flex-end;padding-bottom:1px">'
    +'<label id="nsapContraBLBox" style="display:flex;align-items:center;gap:7px;cursor:pointer;'
    +'border:1px solid var(--border);border-radius:7px;padding:8px 9px;background:var(--surface-1);width:100%">'
      +'<input type="checkbox" id="nsapContraBL" onchange="_nsapContraBLCambio()" style="cursor:pointer">'
      +'<span style="font-size:11px;font-weight:600;line-height:1.25">100% contra<br>copia de B/L</span>'
    +'</label></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Fecha abono</label><input id="nsapFechaAbono" type="date" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Saldo</label><input id="nsapSaldo" type="number" step="0.01" placeholder="0.00" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)" readonly></div>';
  h+='</div>';
  h+='</div>';
  // Sección de productos (obligatoria) — se llena con IA o a mano
  h+='<div style="margin-top:14px;border-top:0.5px solid var(--border);padding-top:12px">';
  h+='<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px">'
    +'<label style="font-size:12px;font-weight:600;color:var(--t-ambar)"><i class="ti ti-list-details"></i> Productos de la orden *</label>'
    +'<button onclick="_nsapAddItemManual()" style="font-size:11px;padding:3px 8px;border:0.5px solid #B45309;background:var(--pastel-aviso);color:var(--t-ambar);border-radius:6px;cursor:pointer"><i class="ti ti-plus"></i> Agregar producto</button>'
  +'</div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-bottom:6px">Se extraen automáticamente del documento con IA. Puedes editarlos o agregarlos a mano. (Obligatorio: al menos 1)</div>';
  h+='<div id="nsapItemsBox"></div>';
  h+='</div>';
  h+='<div style="display:flex;gap:8px;margin-top:16px">'
    +'<button onclick="_nsapGuardarDraft()" style="flex:1;background:var(--surface-1);color:var(--text-secondary);border:0.5px solid var(--border);border-radius:8px;padding:11px;cursor:pointer;font-size:12.5px;font-weight:600"><i class="ti ti-device-floppy"></i> Guardar borrador</button>'
    +'<button onclick="guardarNuevaOrdenSinSAP()" style="flex:2;background:#B45309;color:white;border:none;border-radius:8px;padding:11px;cursor:pointer;font-size:13px;font-weight:600"><i class="ti ti-check"></i> Crear orden sin SAP</button>'
  +'</div>';
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
  document.body.appendChild(ov);
    try{ _nsapPantallaCompleta(); }catch(e){ console.warn('[borrador] expandir:', e); }
    window._nsapItems=window._nsapItems||[];
  _nsapRenderItems();
  // Prellenado al venir desde una orden firmada (amarre por DKC).
  if(prefill){
    try{
      var _r=document.getElementById('nsapRef');   if(_r && prefill.ref)  _r.value=prefill.ref;
      var _p=document.getElementById('nsapProv');  if(_p && prefill.prov) _p.value=prefill.prov;
      var _t=document.getElementById('nsapTotal'); if(_t && prefill.total){ _t.value=prefill.total; if(typeof _nsapCalcSaldo==='function') _nsapCalcSaldo(); }
    }catch(_e){}
  }
}
// Renderiza la lista editable de productos de la orden No SAP
// ── Los campos del artículo en una orden borrador ───────────────────────
// Mientras más se rellene aquí, menos queda por hacer al subirla a SAP: el
// asistente los arrastra tal cual. Se leen de los archivos adjuntos, y lo
// que falte se escribe o se pega desde un Excel, por columnas.
/* ═══════════════════════════════════════════════════════════════════════════
   CAMPOS PROPIOS DE CADA DEPARTAMENTO
   ───────────────────────────────────────────────────────────────────────────
   Ropa y alfombras necesitan datos que los demás no usan. Salen de las
   plantillas con las que hoy se crean los artículos en SAP a mano:
     · ropa      → Kennedy Product Creation Sheet
     · alfombras → Datos Técnicos Artículos (dos hojas)

   Se enseñan al crear la orden borrador y al subirla a SAP, para que lo que
   se rellena una vez no haya que volver a escribirlo.
   ═══════════════════════════════════════════════════════════════════════════ */
// Los de la Product Creation Sheet valen para TODOS los departamentos: es
// el formato con el que se crean los artículos en SAP, venga de donde venga
// la orden. Alfombras suma encima los suyos de ficha técnica.
var CAMPOS_COMUNES=[
    {k:'genero',        t:'Género',            w:'95px',  lista:['Dama','Caballero','Niña','Niño','Bebé','Unisex'], sap:"Genero", sinSap:true},
    {k:'tipo_tejido',   t:'Tipo de tejido',    w:'130px', sap:"Tipo de Tejido", sinSap:true},
    {k:'racion',        t:'Ración',            w:'90px',  ayuda:'La proporción de tallas por caja', sap:"Racion", sinSap:true},
    {k:'pais_origen',   t:'País de origen',    w:'110px', sap:"Pais de origen"},
    {k:'caja_alto',     t:'Alto caja (cm)',    w:'90px',  num:true, sap:"Altura de Caja CM", sinSap:true},
    {k:'caja_largo',    t:'Largo caja (cm)',   w:'90px',  num:true, sap:"Largo de Caja CM", sinSap:true},
    {k:'caja_ancho',    t:'Ancho caja (cm)',   w:'90px',  num:true, sap:"Ancho de Caja CM", sinSap:true},
    {k:'vol_pieza',     t:'Volumen pieza (m³)',w:'105px', num:true, sap:"Volumen Pieza"},
    {k:'peso_pieza',    t:'Peso pieza (kg)',   w:'95px',  num:true, sap:"Peso Pieza"}
];

var CAMPOS_DEPT={

  alfombras:[
    {k:'color_ing',     t:'Color en inglés',   w:'110px', sap:"Color en ingles"},
    {k:'comp_ing',      t:'Composición inglés',w:'160px', sap:"Composicion en ingles"},
    {k:'comp_pelo',     t:'Composición del pelo',    w:'150px', sap:"COMPOSICION DE PELO"},
    {k:'comp_respaldo', t:'Composición del respaldo',w:'150px', sap:"COMPOSICION DE RESPALDO"},
    {k:'tecnica',       t:'Técnica de fabricación',  w:'140px',
     lista:['TEJIDO A MAQUINA','TEJIDO A MANO','ANUDADA A MANO','TUFTING','IMPRESA'], sap:"TECNICA DE FABRICACION"},
    {k:'intensidad',    t:'Intensidad de uso', w:'110px',
     lista:['DOMESTICO','COMERCIAL','DOMESTICO INTENSIVO'], sap:"INTENSIDAD DE USO"},
    {k:'espesor_pelo',  t:'Espesor del pelo (mm)',  w:'100px', sap:"ESPESOR DE PELO"},
    {k:'espesor_total', t:'Espesor total (mm)',     w:'100px', sap:"ESPESOR TOTAL"},
    {k:'peso_pelo',     t:'Peso del pelo (g/m²)',   w:'105px', sap:"PESO DE PELO"},
    {k:'gramaje',       t:'Gramaje (g/m²)',    w:'95px', sap:"GRAMAJE"},
    {k:'dimensiones',   t:'Dimensiones (cm)',  w:'105px', sap:"DIMENSIONES CM"},
    {k:'tejido',        t:'Denominación del tejido', w:'140px', sap:"DENOMINACION DEL TEJIDO"},
    {k:'acabado_color', t:'Acabado por color', w:'130px', sap:"ACABADOS POR COLOR"},
    {k:'otros_acabados',t:'Otros acabados',    w:'120px', sap:"OTROS ACABADOS"},
    {k:'anaquel',       t:'Anaquel',           w:'85px', sap:"Anaquel"},
    {k:'producto',      t:'Producto',          w:'110px', sap:"Producto"}
  ]
};

// Los títulos de las plantillas, para reconocerlos al leer un Excel. Van en
// los dos idiomas porque las hojas circulan mezcladas.
var DEPT_ALIAS=[
  ['genero',        ['GENDER','GENERO']],
  ['tipo_tejido',   ['TYPEOFFABRIC','TIPODETEJIDO','TIPOTEJIDO']],
  ['racion',        ['RATIO','RACION','RACIONES']],
  ['pais_origen',   ['COUNTRYOFORIGIN','PAISDEORIGEN','PAISORIGEN']],
  ['caja_alto',     ['CARTONHEIGHT','ALTURADECAJA','ALTOCAJA']],
  ['caja_largo',    ['CARTONLENGTH','LARGODECAJA','LARDODECAJA','LARGOCAJA']],
  ['caja_ancho',    ['CARTONWIDTH','ANCHODECAJA','ANCHOCAJA']],
  ['vol_pieza',     ['PIECEVOLUME','VOLUMENPIEZA']],
  ['peso_pieza',    ['PIECEWEIGHT','PESOPIEZA']],
  ['comp_pelo',     ['COMPOSICIONDEPELO','COMPOSICIONPELO','PILECOMPOSITION']],
  ['comp_respaldo', ['COMPOSICIONDERESPALDO','COMPOSICIONRESPALDO','BACKINGCOMPOSITION']],
  // Sin «CONSTRUCTION»: la columna de material se llama «MATERIAL,
  // Construction Composition» y se la llevaba esta.
  ['tecnica',       ['TECNICADEFABRICACION','TECNICAFABRICACION']],
  ['intensidad',    ['INTENSIDADDEUSO','INTENSIDADUSO','USAGE']],
  ['espesor_pelo',  ['ESPESORDEPELO','ESPESORPELO','PILEHEIGHT']],
  ['espesor_total', ['ESPESORTOTAL','TOTALTHICKNESS']],
  ['peso_pelo',     ['PESODEPELO','PESOPELO','PILEWEIGHT']],
  ['gramaje',       ['GRAMAJE','TOTALWEIGHT','WEIGHTGM2']],
  ['dimensiones',   ['DIMENCIONESCM','DIMENSIONESCM','DIMENSIONES','DIMENCIONES']],
  ['tejido',        ['DENOMINACIONDELTEJIDO','DENOMINACIONTEJIDO','WEAVE']],
  ['acabado_color', ['ACABADOPORCOLOR']],
  ['otros_acabados',['OTROSACABADOS']],
  ['anaquel',       ['ANAQUEL','SHELF']],
  ['producto',      ['PRODUCTO']],
  ['color_ing',     ['COLORENINGLES','COLORINGLES','COLORENGLISH']],
  ['comp_ing',      ['COMPOSICIONENINGLES','COMPOSICIONINGLES','COMPOSITIONENGLISH']]
];

// El departamento de una orden, normalizado a las claves de arriba
// Los títulos de ropa y alfombras se suman a los que ya reconoce el lector
try{
  // Al PRINCIPIO, no al final: los títulos específicos tienen que ganar a
  // los genéricos. «COMPOSICION DE PELO» contiene «COMPOSICION», y si gana
  // el genérico, la composición del pelo acaba en el campo equivocado.
  for(var _i=DEPT_ALIAS.length-1; _i>=0; _i--){
    var par=DEPT_ALIAS[_i];
    if(!PROF_ALIAS.some(function(x){ return x[0]===par[0]; })) PROF_ALIAS.unshift(par);
  }
}catch(e){ console.warn('[campos] no pude sumar los títulos por departamento:', e); }

function _deptClave(dept){
  var d=_bkNorm(dept||'');
  if(d.indexOf('ALFOMBRA')>=0) return 'alfombras';
  return '';
}

// Los campos extra que toca enseñar para un departamento
function _camposDeDept(dept){
  // Los comunes SIEMPRE, y encima los propios del departamento si los tiene.
  return CAMPOS_COMUNES.concat(CAMPOS_DEPT[_deptClave(dept)] || []);
}

var NSAP_CAMPOS=[
  {k:'itemcode',       t:'Cód. KCC',        w:'105px', req:true},
  {k:'itemname',       t:'Descripción',     w:'190px', req:true},
  {k:'descripcion',    t:'Descripción inglés', w:'180px'},
  {k:'cantidad',       t:'Cantidad',        w:'80px',  num:true, req:true},
  {k:'precio_unit',    t:'Precio',          w:'80px',  num:true},
  {k:'barcode',        t:'Código de barras',w:'125px'},
  {k:'marca',          t:'Marca',           w:'130px'},
  {k:'color',          t:'Color',           w:'95px'},
  {k:'material',       t:'Material',        w:'150px'},
  {k:'tamano',         t:'Tamaño',          w:'120px'},
  {k:'empaque',        t:'Empaque',         w:'90px'},
  {k:'unidades_x_caja',t:'Pzs por bulto',   w:'85px',  num:true},
  {k:'cartones_item',  t:'Bultos',          w:'70px',  num:true},
  {k:'carton_size',    t:'Tamaño bulto',w:'115px'},
  {k:'cbm',            t:'Cubicaje (ft³)',  w:'95px',  num:true},
  {k:'peso',           t:'Peso del bulto',  w:'95px',  num:true},
  {k:'peso_neto',      t:'Peso del artículo', w:'95px', num:true}
];

function _nsapCamposVivos(){
  // Los del departamento van al final, para no mover las columnas de siempre
  var dept=(document.getElementById('nsapDept')||{}).value
        || (window._nsapOrden&&window._nsapOrden.dept) || '';
  return NSAP_CAMPOS.concat(_camposDeDept(dept));
}

function _nsapRenderItems(){
  _tbxEstilos(); _arrInit();
  var box=document.getElementById('nsapItemsBox');
  if(!box) return;
  var items=window._nsapItems||[];
  if(!items.length){
    box.innerHTML='<div style="font-size:11px;color:var(--text-muted);padding:8px;'
      +'text-align:center;border:1px dashed var(--border);border-radius:6px">'
      +'Aún no hay productos. Sube un documento (se leen con IA) o agrégalos a mano.</div>';
    return;
  }

  // La rejilla: se puede escribir y pegar columnas enteras desde un Excel
  var CAMPOS=_nsapCamposVivos();
  _gridRegistrar('nsapitems', CAMPOS.map(function(c){ return c.k; }),
                 items, _nsapTrasEditar);

  var faltan=items.filter(function(it){
    return !String(it.itemcode||'').trim() || !String(it.itemname||'').trim(); }).length;

  var h='<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;'
    +'font-size:11px;color:var(--text-muted);margin-bottom:6px">'
    +'<i class="ti ti-table"></i>'
    +'<span>'+items.length+' artículo(s) · se puede pegar desde un Excel: '
    +'sitúate en una casilla y pega</span>'
    + (faltan ? ('<span style="color:var(--t-rojo)">· '+faltan
        +' sin código o sin descripción</span>') : '')
    +'<span style="flex:1"></span>'
    +'<span id="nsapTotalVivo" style="font-weight:700;color:var(--t-ambar)"></span>'
    +'</div>';

  h+='<div class="tbx-box">'
    +'<table class="tbx"><thead><tr>'
    +'<th style="width:42px"></th>'
    + CAMPOS.map(function(c){
        return '<th style="white-space:nowrap'+(c.req?';color:var(--t-rojo)':'')+'">'
          +_esc(c.t)+(c.req?' *':'')+'</th>';
      }).join('')
    +'<th style="width:60px;text-align:right">Total</th><th style="width:28px"></th>'
    +'</tr></thead><tbody>'
    + items.map(function(it,i){
        var tl=(it.total_linea!=null?it.total_linea
                :((Number(it.cantidad)||0)*(Number(it.precio_unit)||0)));
        return '<tr>'
          +'<td>'+_nsapCeldaFoto(it, i)+'</td>'         + CAMPOS.map(function(c){
              var falta=c.req && !String(it[c.k]||'').trim();
              var celda=_gridCelda('nsapitems', i, c.k, it[c.k], c.w);
              if(falta) celda=celda.replace('border:0.5px solid var(--border)',
                                            'border:1px solid var(--t-rojo)');
              return '<td'+(falta?' style="background:var(--pastel-error)"':'')
                +'>'+celda+'</td>';
            }).join('')
          +'<td style="text-align:right;font-variant-numeric:tabular-nums" '
            +'id="nsapTl'+i+'">'+_fmtN2(tl)+'</td>'
          +'<td><button class="xb" style="padding:1px 5px;color:var(--text-danger)" '
            +'title="Quitar" onclick="_nsapItemDel('+i+')">'
            +'<i class="ti ti-x"></i></button></td>'
          +'</tr>';
      }).join('')
    +'</tbody></table></div>';

  box.innerHTML=h;
  _nsapTrasEditar();
}

// Al escribir o pegar: se recalculan los totales sin repintar la tabla, que
// haría perder el foco de la casilla en la que estás.
function _nsapTrasEditar(){
  var items=window._nsapItems||[];
  var total=0;
  items.forEach(function(it,i){
    var tl=(Number(it.cantidad)||0)*(Number(it.precio_unit)||0);
    it.total_linea=tl;
    total+=tl;
    var e=document.getElementById('nsapTl'+i);
    if(e) e.textContent=_fmtN2(tl);
  });
  var t=document.getElementById('nsapTotalVivo');
  if(t) t.textContent='Total: '+_fmtN2(total);
  try{ if(typeof _nsapRevisarNumerosVivo==='function') _nsapRevisarNumerosVivo(); }catch(e){}
}
// Vuelve a revisar los números cuando se editan los productos a mano
function _nsapRevisarAhora(){
  if(!document.getElementById('nsapIAerrores')) return;
  if(!(window._nsapItems||[]).length) return;
  var el=document.getElementById('nsapTotal');
  var total=el?(parseFloat(el.value)||0):0;
  window._nsapProblemas=_nsapPintarRevision(null, _nsapRevisarNumeros(window._nsapItems, total));
}

function _nsapAddItemManual(){
  window._nsapItems=window._nsapItems||[];
  window._nsapItems.push({itemcode:'',itemname:'',cantidad:0});
  _nsapRenderItems();
}
function _nsapItemEdit(i,campo,val){
  if(!window._nsapItems||!window._nsapItems[i])return;
  var it=window._nsapItems[i];
  if(campo==='cantidad'||campo==='precio_unit'){
    it[campo]=Number(val)||0;
    it.total_linea=(it.cantidad||0)*(it.precio_unit||0);
    _nsapRenderItems();  // refrescar para mostrar el nuevo total
  } else {
    it[campo]=val;
  }
  _nsapRevisarAhora();
}
function _nsapItemDel(i){
  if(!window._nsapItems)return;
  window._nsapItems.splice(i,1);
  _nsapRenderItems();
  _nsapRevisarAhora();
}
// desdePct = lo llamó el campo de porcentaje; no se recalcula el % para no
// pisar lo que se está escribiendo.
function _nsapCalcSaldo(desdePct){
  var elT=document.getElementById('nsapTotal'), elA=document.getElementById('nsapAbon');
  var t=elT?(parseFloat(elT.value)||0):0;
  var a=elA?(parseFloat(elA.value)||0):0;
  var s=document.getElementById('nsapSaldo'); if(s) s.value=(t-a).toFixed(2);
  if(!desdePct){
    var p=document.getElementById('nsapAbonPct');
    if(p) p.value = (t>0 && a) ? (Math.round(a/t*10000)/100) : '';
  }
  try{ _nsapRevisarAhora(); }catch(e){}
}

// El porcentaje manda sobre el monto: 30 sobre un total de 1.000 pone 300
function _nsapAbonoDesdePct(){
  var elT=document.getElementById('nsapTotal');
  var elP=document.getElementById('nsapAbonPct');
  var elA=document.getElementById('nsapAbon');
  if(!elP || !elA) return;
  var t=elT?(parseFloat(elT.value)||0):0;
  var p=parseFloat(elP.value);
  if(isNaN(p)){ _nsapCalcSaldo(true); return; }
  elA.value=(Math.round(t*p)/100).toFixed(2);
  _nsapCalcSaldo(true);
}

// ═══════════════════════════════════════════════════════════════════════════
//  REPOSICIÓN ↔ ORDEN NO SAP
//  Si la orden viene de una reposición, se puede cotejar línea por línea lo
//  que se pidió contra lo que el proveedor está facturando.
// ═══════════════════════════════════════════════════════════════════════════
function _nsapRepoCambio(){
  var el=document.getElementById('nsapNumRepo');
  var box=document.getElementById('nsapRepoBox');
  if(!el || !box) return;
  var v=String(el.value||'').trim().toUpperCase();
  if(!v){ box.style.display='none'; box.innerHTML=''; return; }
  box.style.display='block';
  box.innerHTML='<button class="btn bg2" style="padding:6px 12px;font-size:11.5px;'
    +'border-color:#C4B5FD;color:var(--t-lila);font-weight:600" onclick="_nsapCompararRepo()">'
    +'<i class="ti ti-git-compare"></i> Comparar reposición '+_esc(v)+' contra esta orden</button>'
    +'<div id="nsapRepoDif" style="margin-top:8px"></div>';
}

// Compara lo que se pidió en la reposición contra lo que se está cargando en
// la orden. Función pura: la usan el botón de comparar y el guardado, para
// que el log que queda archivado sea exactamente lo que se vio en pantalla.
function _nsapCalcularDif(lineasRepo, items){
  var enRepo={}, enOrden={};
  (lineasRepo||[]).forEach(function(it){
    var k=String(it.itemcode||'').trim().toUpperCase();
    if(k) enRepo[k]={code:it.itemcode, name:it.itemname||'', cant:Number(it.cant)||0};
  });
  (items||[]).forEach(function(it){
    var k=String(it.itemcode||'').trim().toUpperCase();
    if(k) enOrden[k]={code:it.itemcode, name:it.itemname||'', cant:Number(it.cantidad)||0};
  });

  var faltan=[], agregados=[], distintos=[], iguales=0;
  Object.keys(enRepo).forEach(function(k){
    if(!enOrden[k]){ faltan.push(enRepo[k]); return; }
    if(enRepo[k].cant!==enOrden[k].cant)
      distintos.push({code:enRepo[k].code, name:enRepo[k].name,
                      pedido:enRepo[k].cant, orden:enOrden[k].cant});
    else iguales++;
  });
  Object.keys(enOrden).forEach(function(k){ if(!enRepo[k]) agregados.push(enOrden[k]); });

  var totRepo=Object.keys(enRepo).reduce(function(a,k){ return a+enRepo[k].cant; },0);
  var totOrden=Object.keys(enOrden).reduce(function(a,k){ return a+enOrden[k].cant; },0);

  return { faltan:faltan, agregados:agregados, distintos:distintos, iguales:iguales,
           skuRepo:Object.keys(enRepo).length, skuOrden:Object.keys(enOrden).length,
           totRepo:totRepo, totOrden:totOrden,
           cuadra:(!faltan.length && !agregados.length && !distintos.length) };
}

// El mismo detalle en texto, para el registro que queda guardado
function _nsapDifTexto(d){
  if(!d) return '';
  var L=[];
  L.push('Reposición '+(d.num||'')+' → orden '+(d.dkc||''));
  L.push('Reposición: '+d.skuRepo+' SKU · '+_repNum(d.totRepo)+' pzs');
  L.push('Orden:      '+d.skuOrden+' SKU · '+_repNum(d.totOrden)+' pzs');
  L.push('Coinciden exactos: '+d.iguales);
  if(d.cuadra){ L.push(''); L.push('Todo coincide: mismos artículos y mismas cantidades.'); return L.join('\n'); }
  if(d.faltan.length){
    L.push(''); L.push('NO SE PIDIERON (estaban en la reposición):');
    d.faltan.forEach(function(f){ L.push('  · '+f.code+'  '+f.name+'  — faltan '+_repNum(f.cant)+' pzs'); });
  }
  if(d.agregados.length){
    L.push(''); L.push('AGREGADOS (no estaban en la reposición):');
    d.agregados.forEach(function(f){ L.push('  · '+f.code+'  '+f.name+'  — '+_repNum(f.cant)+' pzs'); });
  }
  if(d.distintos.length){
    L.push(''); L.push('DISTINTA CANTIDAD:');
    d.distintos.forEach(function(f){
      var dif=f.orden-f.pedido;
      L.push('  · '+f.code+'  '+f.name+'  — pedido '+_repNum(f.pedido)+' → orden '
        +_repNum(f.orden)+' ('+(dif>0?'+':'')+_repNum(dif)+')');
    });
  }
  return L.join('\n');
}

// El panel que se ve, tanto al comparar como después en la orden
function _nsapDifPanelHTML(d, compacto){
  if(!d) return '';
  function tabla(titulo, color, filas, cols){
    if(!filas.length) return '';
    var t='<div style="margin-top:8px"><div style="font-size:11px;font-weight:700;color:'+color+';margin-bottom:3px">'
      +titulo+' ('+filas.length+')</div>'
      +'<table style="width:100%;border-collapse:collapse;font-size:11px">';
    filas.forEach(function(f){
      t+='<tr style="border-top:0.5px solid var(--border)">'
        +'<td style="padding:3px 5px;font-family:monospace;white-space:nowrap">'+_esc(f.code||'')+'</td>'
        +'<td style="padding:3px 5px;color:var(--text-secondary)">'+_esc(String(f.name||'').slice(0,44))+'</td>'
        +cols(f)+'</tr>';
    });
    return t+'</table></div>';
  }

  var h='<div style="border:1px solid '+(d.cuadra?'#16a34a':'#E9C08A')+';border-radius:9px;overflow:hidden'
    +(compacto?';margin-bottom:12px':'')+'">'
    +'<div style="background:'+(d.cuadra?'#dcfce7':'#FEF9F3')+';padding:8px 11px;font-size:12px;'
      +'font-weight:700;color:'+(d.cuadra?'#166534':'#7C3D12')+'">'
      +'<i class="ti '+(d.cuadra?'ti-circle-check':'ti-git-compare')+'"></i> '
      +'Diferencias contra la reposición '+_esc(d.num||'')
      +(d.fecha?('<span style="float:right;font-weight:500;font-size:10.5px">'+_esc(d.fecha)+'</span>'):'')
      +'</div>'
    +'<div style="padding:9px 11px;font-size:11.5px">'
    +'<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:8px;color:var(--text-secondary)">'
      +'<span>Reposición: <b>'+d.skuRepo+'</b> SKU · <b>'+_repNum(d.totRepo)+'</b> pzs</span>'
      +'<span>Orden: <b>'+d.skuOrden+'</b> SKU · <b>'+_repNum(d.totOrden)+'</b> pzs</span>'
      +'<span style="color:var(--t-verde)">Coinciden: <b>'+d.iguales+'</b></span>'
    +'</div>';

  if(d.cuadra){
    h+='<div style="color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
      +'Todo coincide: mismos artículos y mismas cantidades.</div>';
  }
  h+=tabla('No se pidieron (estaban en la reposición)', '#991b1b', d.faltan, function(f){
    return '<td style="padding:3px 5px;text-align:right;white-space:nowrap;color:var(--t-rojo)">'
      +_repNum(f.cant)+' pzs pedidas</td>'; });
  h+=tabla('Agregados (no estaban en la reposición)', '#B45309', d.agregados, function(f){
    return '<td style="padding:3px 5px;text-align:right;white-space:nowrap;color:var(--t-ambar)">'
      +_repNum(f.cant)+' pzs agregadas</td>'; });
  h+=tabla('Mismo SKU con distinta cantidad', '#5B21B6', d.distintos, function(f){
    var dd=f.orden-f.pedido;
    return '<td style="padding:3px 5px;text-align:right;white-space:nowrap">'
      +'<span style="color:var(--text-muted)">pedido '+_repNum(f.pedido)+'</span> → '
      +'<b>'+_repNum(f.orden)+'</b> '
      +'<span style="color:'+(dd>0?'#B45309':'#991b1b')+';font-weight:700">('
      +(dd>0?'+':'')+_repNum(dd)+')</span></td>'; });
  return h+'</div></div>';
}

// Busca una reposición por su número.
// Compara por el NÚMERO, no por el texto: así da igual que esté guardada
// como R-4, R-04, "r 04" o con un espacio de más. Buscar con un "=" exacto
// hacía que una reposición que sí existía apareciera como inexistente.
async function _repBuscarPedidoPorNum(num){
  var n=String(num||'').trim().toUpperCase();
  if(!n) return null;
  var val=_repNumVal(n);
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*'
      +'&num_reposicion=not.is.null&order=id.desc&limit=500',{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      window._repNumError='HTTP '+r.status+' '+String(t).slice(0,180);
      console.warn('[reposición] buscar por número:', window._repNumError);
      return null;
    }
    var filas=await r.json()||[];
    // Se deja a mano la lista de números que sí existen, para poder decirlo
    window._repNumsDisponibles=filas
      .map(function(x){ return String(x.num_reposicion||'').trim(); })
      .filter(Boolean);
    var exacto=filas.find(function(x){
      return String(x.num_reposicion||'').trim().toUpperCase()===n; });
    if(exacto) return exacto;
    var porNum=val?filas.find(function(x){ return _repNumVal(x.num_reposicion)===val; }):null;
    if(porNum) return porNum;

    // Puede que el número haya quedado guardado en el ENVÍO y no en el
    // pedido (pasa cuando la reposición se envió desde una pantalla que no
    // tenía el pedido cargado). El envío guarda pedido_id, así que se llega
    // igual, y de paso se le pone el número al pedido para que no vuelva a
    // faltar.
    var re=await fetch(SB+'/rest/v1/reposiciones_envios?select=pedido_id,num_reposicion'
      +'&num_reposicion=not.is.null&order=id.desc&limit=500',{headers:SBH});
    if(re.ok){
      var envs=await re.json()||[];
      (envs||[]).forEach(function(x){
        var t=String(x.num_reposicion||'').trim();
        if(t && window._repNumsDisponibles.indexOf(t)<0) window._repNumsDisponibles.push(t);
      });
      var env=envs.find(function(x){
        var t=String(x.num_reposicion||'').trim().toUpperCase();
        return t===n || (val && _repNumVal(t)===val); });
      if(env && !env.pedido_id){
        // El envío existe pero nunca se guardó su pedido: no hay líneas
        window._repNumError='La reposición '+n+' se envió sin guardar su detalle '
          +'(el envío no quedó ligado a ningún pedido), así que no hay artículos que comparar.';
      }
      if(env && env.pedido_id){
        var rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*&id=eq.'
          +encodeURIComponent(env.pedido_id)+'&limit=1',{headers:SBH});
        if(rp.ok){
          var dp=await rp.json()||[];
          if(dp.length){
            if(!dp[0].num_reposicion){
              try{
                await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+dp[0].id,{
                  method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
                  body:JSON.stringify({num_reposicion:String(env.num_reposicion).trim()})});
                dp[0].num_reposicion=String(env.num_reposicion).trim();
              }catch(e){}
            }
            return dp[0];
          }
        }
      }
    }
    return null;
  }catch(e){
    window._repNumError=String(e&&e.message||e);
    console.warn('[reposición] buscar por número:', e);
    return null;
  }
}

// Trae las líneas de una reposición por su número
async function _nsapLineasRepo(num){
  var p=await _repBuscarPedidoPorNum(num);
  if(!p) return null;
  var lineas=p.items;
  if(typeof lineas==='string'){ try{ lineas=JSON.parse(lineas); }catch(e){ lineas=[]; } }
  return Array.isArray(lineas)?lineas:[];
}

// Poner uno de los números sugeridos y comparar
function _nsapUsarRepo(num){
  var el=document.getElementById('nsapNumRepo');
  if(!el) return;
  el.value=num;
  try{ _nsapRepoCambio(); }catch(e){}
  _nsapCompararRepo();
}

// Busca la reposición de este proveedor que todavía no tiene orden y la deja
// puesta en el campo. Se usa cuando el documento del proveedor no menciona el
// número: el vínculo no puede depender de que alguien se acuerde de escribirlo.
async function _nsapRepoAuto(){
  var el=document.getElementById('nsapNumRepo');
  if(!el || String(el.value||'').trim()) return;      // ya vino en el documento
  var prov=String(((document.getElementById('nsapProv')||{}).value)||'').trim();
  var code=String(window._nsapCardcode||'').trim();
  if(!prov && !code) return;

  var r=await fetch(SB+'/rest/v1/reposiciones_pedidos'
    +'?select=id,num_reposicion,cardcode,cardname,estado'
    +'&num_reposicion=not.is.null&order=id.desc&limit=200',{headers:SBH});
  if(!r.ok) return;
  var filas=await r.json()||[];
  var nprov=_invNorm(prov), ncode=_invNorm(code);

  var m=filas.find(function(x){
    if(x.estado==='orden_creada') return false;       // esa ya tiene su orden
    var c=_invNorm(x.cardcode), n=_invNorm(x.cardname);
    if(ncode && c && c===ncode) return true;
    if(!nprov || !n) return false;
    return n===nprov || n.indexOf(nprov)>=0 || nprov.indexOf(n)>=0;
  });
  if(!m) return;

  el.value=m.num_reposicion;
  try{ _nsapRepoCambio(); }catch(e){}
  showT('Ligada automáticamente a la reposición '+m.num_reposicion
    +' de este proveedor. Si no es esa, cambiá el número.', 8000);
  try{ await _nsapCompararRepo(); }catch(e){}
}

async function _nsapCompararRepo(){
  var el=document.getElementById('nsapNumRepo');
  var out=document.getElementById('nsapRepoDif');
  if(!el || !out) return;
  var num=String(el.value||'').trim().toUpperCase();
  if(!num){ showT('Escribe el número de reposición'); return; }
  var items=(window._nsapItems||[]);
  if(!items.length){ showT('Primero leé el documento con IA'); return; }

  out.innerHTML='<span class="ai-ring g" style="vertical-align:-2px"></span> Buscando la reposición '+_esc(num)+'…';
  var lineas=null;
  try{ lineas=await _nsapLineasRepo(num); }
  catch(e){ console.warn('[reposición] buscar:', e); }

  if(!lineas){
    // Sin la lista de lo que sí hay, este mensaje no deja avanzar a nadie
    var disp=(window._repNumsDisponibles||[]);
    var err=window._repNumError||'';
    out.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;'
      +'padding:9px 11px;font-size:11.5px;color:var(--t-marron)"><i class="ti ti-alert-circle"></i> '
      +'No encontré ninguna reposición con el número '+_esc(num)+'.'
      +(err?('<br><span style="font-size:10.5px">Error al consultar: '+_esc(err)+'</span>'):'')
      +(disp.length
        ? ('<br><span style="font-size:10.5px">Números que sí existen: '
           +disp.slice(0,25).map(function(x){
               return '<span onclick="_nsapUsarRepo(\''+_esc(String(x).replace(/\\/g,''))+'\')" '
                 +'style="cursor:pointer;background:var(--pastel-lila);border:1px solid #C4B5FD;color:var(--t-lila);'
                 +'border-radius:8px;padding:1px 7px;margin:2px 3px 0 0;display:inline-block;'
                 +'font-weight:700">'+_esc(x)+'</span>'; }).join('')
           +(disp.length>25?' …':'')+'</span>')
        : '<br><span style="font-size:10.5px">Todavía no hay ninguna reposición numerada.</span>')
      +'</div>';
    return;
  }

  var dif=_nsapCalcularDif(lineas, items);
  dif.num=num;
  window._nsapRepoDif=dif;
  out.innerHTML=_nsapDifPanelHTML(dif);
}

// 100% contra copia de B/L: no hay abono. El monto queda en cero, el saldo es
// el total, y al crear la orden se dan por hechos los pasos del depósito para
// que el seguimiento arranque directo en la solicitud del balance final.
function _nsapContraBLCambio(){
  var ck=document.getElementById('nsapContraBL');
  var elA=document.getElementById('nsapAbon');
  var elP=document.getElementById('nsapAbonPct');
  var elF=document.getElementById('nsapFechaAbono');
  var caja=document.getElementById('nsapContraBLBox');
  var on=!!(ck&&ck.checked);
  [elA, elP, elF].forEach(function(el){
    if(!el) return;
    el.disabled=on;
    el.style.opacity=on?0.45:1;
    if(on) el.value='';
  });
  if(caja){
    caja.style.background=on?'#dcfce7':'var(--surface-1)';
    caja.style.borderColor=on?'#16a34a':'var(--border)';
    caja.style.color=on?'#166534':'';
  }
  _nsapCalcSaldo(true);
}

// Pantalla completa del panel de la orden
function _nsapPantallaCompleta(){
  var p=document.getElementById('nsapPanel');
  var ov=document.getElementById('modalNuevaSAP');
  if(!p) return;
  window._nsapFull=!window._nsapFull;
  if(window._nsapFull){
    p.style.maxWidth='100%'; p.style.maxHeight='100vh'; p.style.borderRadius='0';
    if(ov) ov.style.padding='0';
  } else {
    p.style.maxWidth='1600px'; p.style.maxHeight='90vh'; p.style.borderRadius='12px';
    if(ov) ov.style.padding='16px';
  }
  var ic=document.getElementById('nsapFullIco');
  if(ic) ic.className='ti '+(window._nsapFull?'ti-arrows-minimize':'ti-arrows-maximize');
  var b=document.getElementById('nsapFullBtn');
  if(b) b.title=window._nsapFull?'Salir de pantalla completa':'Pantalla completa';
}

// Ver en grande la foto que se sacó del Excel
function _nsapVerFoto(i){
  var it=(window._nsapItems||[])[i];
  if(!it || !it._foto) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:10050;'
    +'display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  ov.innerHTML='<div style="max-width:92vw;max-height:92vh;text-align:center">'
    +'<img src="'+_esc(it._foto)+'" style="max-width:92vw;max-height:84vh;object-fit:contain;'
    +'border-radius:10px;background:var(--surface-2);box-shadow:0 20px 60px rgba(0,0,0,.5)">'
    +'<div style="color:#fff;font-size:12.5px;margin-top:10px">'
    +_esc(it.itemcode||'')+(it.itemname?(' — '+_esc(it.itemname)):'')+'</div></div>';
  ov.addEventListener('click', function(){ ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}
// ═══════════════════════════════════════════════════════════════════════════
//  IDENTIFICAR EL PROVEEDOR CONTRA SAP (orden NO SAP)
//  El nombre viene de la proforma y puede traer una letra distinta, un punto
//  de más o el "CO., LTD" escrito de otra forma. Antes de dar por nuevo a un
//  proveedor se buscan los parecidos, para no duplicar en SAP por un typo.
// ═══════════════════════════════════════════════════════════════════════════
window._nsapCardcode='';        // código elegido/confirmado
window._nsapProvNuevoOK=false;  // ya se confirmó que es nuevo

// Distancia de edición (Levenshtein) con dos filas, suficiente para nombres
function _nsapLev(a,b){
  a=String(a||''); b=String(b||'');
  if(a===b) return 0;
  if(!a.length) return b.length;
  if(!b.length) return a.length;
  var prev=new Array(b.length+1), cur=new Array(b.length+1), i, j;
  for(j=0;j<=b.length;j++) prev[j]=j;
  for(i=1;i<=a.length;i++){
    cur[0]=i;
    for(j=1;j<=b.length;j++){
      var cost=(a.charAt(i-1)===b.charAt(j-1))?0:1;
      cur[j]=Math.min(cur[j-1]+1, prev[j]+1, prev[j-1]+cost);
    }
    for(j=0;j<=b.length;j++) prev[j]=cur[j];
  }
  return prev[b.length];
}

// Limpia el nombre: sin acentos, sin sufijos societarios ni puntuación
var _NSAP_RUIDO=/\b(co|company|companies|ltd|limited|inc|corp|corporation|sa|s a|sas|srl|gmbh|bv|llc|plc|pte|pty|group|trading|import|export|imports|exports|international|intl)\b/g;
function _nsapNormProv(s){
  var t=String(s||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9\s]/g,' ')
    .replace(/\s+/g,' ').trim();
  return t;
}
function _nsapNucleo(s){
  return _nsapNormProv(s).replace(_NSAP_RUIDO,' ').replace(/\s+/g,' ').trim();
}

// Parecido 0..1 combinando edición y palabras en común
function _nsapParecido(a,b){
  var na=_nsapNormProv(a), nb=_nsapNormProv(b);
  if(!na||!nb) return 0;
  if(na===nb) return 1;
  var ka=_nsapNucleo(a), kb=_nsapNucleo(b);
  if(ka && kb && ka===kb) return 0.98;
  // Uno contenido en el otro (nombre recortado)
  if(ka && kb && (ka.indexOf(kb)>=0 || kb.indexOf(ka)>=0)) return 0.93;
  // Por edición sobre el núcleo
  var A=ka||na, B=kb||nb;
  var lev=1-(_nsapLev(A,B)/Math.max(A.length,B.length));
  // Por palabras compartidas (nombres largos con orden distinto)
  var pa=A.split(' ').filter(function(w){return w.length>2;});
  var pb=B.split(' ').filter(function(w){return w.length>2;});
  var comunes=pa.filter(function(w){ return pb.indexOf(w)>=0; }).length;
  var tok=(pa.length&&pb.length)?(comunes/Math.max(pa.length,pb.length)):0;
  return Math.max(lev, tok);
}

// Palabras significativas del nombre, para buscar en la base
function _nsapTokens(nombre){
  var t=_nsapNucleo(nombre).split(' ').filter(function(w){ return w.length>=3; });
  if(!t.length) t=_nsapNormProv(nombre).split(' ').filter(function(w){ return w.length>=3; });
  // Las palabras más largas son las más distintivas
  t.sort(function(a,b){ return b.length-a.length; });
  return t.slice(0,5);
}

// Busca proveedores parecidos DIRECTO en la base.
// El catálogo local (_repProv) solo trae proveedores con items del
// departamento del usuario, así que un proveedor de otro departamento —o sin
// items todavía— nunca aparecía. Por eso se consulta también el inventario.
async function _nsapBuscarProvRemoto(nombre){
  var toks=_nsapTokens(nombre);
  if(!toks.length) return [];
  var out={};
  // 1) Proveedores que tienen artículos en el inventario
  try{
    var ors=toks.map(function(w){ return 'nombre_proveedor.ilike.*'+encodeURIComponent(w)+'*'; }).join(',');
    var url=SB+'/rest/v1/inventario?select=cardcode,nombre_proveedor&cardcode=not.is.null'
      +'&nombre_proveedor=not.is.null&or=('+ors+')&limit=4000';
    var r=await fetch(url,{headers:SBH});
    if(r.ok){
      (await r.json()||[]).forEach(function(x){
        var cc=String(x.cardcode||'').trim(); if(!cc) return;
        if(!out[cc]) out[cc]={cardcode:cc, cardname:x.nombre_proveedor||''};
      });
    }
  }catch(e){ console.warn('buscar prov remoto (inventario):',e); }
  // 2) Y el maestro de proveedores. Un proveedor recién dado de alta en SAP
  //    todavía no tiene artículos en el inventario, así que buscandolo solo
  //    ahí salía como nuevo aunque existiera. Es lo que pasó con
  //    "Zhejiang Longstar Manufacture & Trade Co.,Ltd".
  try{
    var ors2=toks.map(function(w){ return 'cardname.ilike.*'+encodeURIComponent(w)+'*'; }).join(',');
    var url2=SB+'/rest/v1/proveedores?select=cardcode,cardname&cardcode=not.is.null'
      +'&or=('+ors2+')&limit=2000';
    var r2=await fetch(url2,{headers:SBH});
    if(r2.ok){
      (await r2.json()||[]).forEach(function(x){
        var cc=String(x.cardcode||'').trim(); if(!cc) return;
        // El maestro manda sobre el inventario para el nombre
        out[cc]={cardcode:cc, cardname:x.cardname||(out[cc]&&out[cc].cardname)||''};
      });
    } else {
      console.warn('[proveedor] la tabla proveedores devolvió '+r2.status);
    }
  }catch(e){ console.warn('buscar prov remoto (proveedores):',e); }
  return Object.keys(out).map(function(k){ return out[k]; });
}

// Devuelve {exacto, candidatos:[{cardcode,cardname,score}]}
function _nsapCandidatos(nombre, extra){
  var base=extra&&extra.length?extra:(_repProv||[]);
  var nn=_nsapNormProv(nombre);
  var exacto=null, todos=[];
  base.forEach(function(pr){
    // Solo se da por exacto si el nombre normalizado es idéntico. Cualquier
    // otra cosa se ofrece para elegir: aceptar automáticamente un 98% podía
    // confundir "MEGA EXPORT" con "MEGA EXPORTS", que pueden ser distintos.
    if(!exacto && nn && _nsapNormProv(pr.cardname)===nn) exacto=pr;
    todos.push({cardcode:pr.cardcode, cardname:pr.cardname,
                score:_nsapParecido(nombre, pr.cardname), n_items:pr.n_items});
  });
  todos.sort(function(a,b){ return b.score-a.score; });
  var lista=todos.filter(function(c){ return c.score>=0.34; });
  // Si quedaron muy pocos, se baja el listón: es mejor mostrar alguno de más
  // que dejar que se duplique un proveedor que sí existe.
  if(lista.length<3) lista=todos.filter(function(c){ return c.score>=0.28; }).slice(0,5);
  return {exacto:exacto, candidatos:lista.slice(0,8)};
}

function _nsapProvMsg(html){
  var d=document.getElementById('nsapProvSAP'); if(d) d.innerHTML=html;
}

// Busca el proveedor en SAP y pinta el resultado debajo del campo
async function _nsapBuscarProvSAP(forzar){
  var inp=document.getElementById('nsapProv'); if(!inp) return null;
  // Si ya hay un código escrito a mano, ese manda: no se busca por nombre
  var ci=document.getElementById('nsapProvCod');
  var codManual=ci?String(ci.value||'').trim():'';
  if(codManual && window._nsapCardcode===codManual.toUpperCase()) return window._nsapCardcode;
  var nombre=(inp.value||'').trim();
  if(!nombre){ _nsapProvMsg(''); window._nsapCardcode=''; window._nsapProvNuevoOK=false; return null; }
  if(!forzar && nombre===window._nsapProvUltimo) return window._nsapCardcode||null;
  window._nsapProvUltimo=nombre;
  window._nsapCardcode=''; window._nsapProvNuevoOK=false;

  _nsapProvMsg('<span style="font-size:10.5px;color:var(--text-muted)"><span class="ai-ring g" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Buscando el código en SAP…</span>');
  try{ await _repCargarProveedores(); }catch(e){}

  // Se juntan el catálogo local y la búsqueda directa en el inventario, para
  // no perder proveedores de otros departamentos.
  var universo={};
  (_repProv||[]).forEach(function(pr){ if(pr.cardcode) universo[pr.cardcode]={cardcode:pr.cardcode, cardname:pr.cardname, n_items:pr.n_items}; });
  var remotos=await _nsapBuscarProvRemoto(nombre);
  remotos.forEach(function(pr){ if(!universo[pr.cardcode]) universo[pr.cardcode]=pr; });
  var lista=Object.keys(universo).map(function(k){ return universo[k]; });

  var r=_nsapCandidatos(nombre, lista);
  if(r.exacto){
    window._nsapCardcode=r.exacto.cardcode;
    var _ce=document.getElementById('nsapProvCod'); if(_ce) _ce.value=r.exacto.cardcode;
    _nsapProvMsg('<div style="font-size:11px;color:var(--t-verde);background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-circle-check"></i> En SAP como <b>'+_esc(r.exacto.cardcode)+'</b> — '+_esc(r.exacto.cardname||'')+'</div>');
    return r.exacto.cardcode;
  }
  if(r.candidatos.length){
    var h='<div style="font-size:11px;background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;padding:9px 10px;color:var(--t-marron)">'
      +'<div style="margin-bottom:8px"><button onclick="_nsapConfirmarNuevo()" style="width:100%;background:#B45309;border:none;color:#fff;border-radius:8px;padding:9px 12px;font-size:12.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px"><i class="ti ti-building-plus" style="font-size:15px"></i> No hay coincidencia, Crear Proveedor BORRADOR</button></div>'
      +'<div style="font-size:10.5px;margin-bottom:5px"><i class="ti ti-alert-circle"></i> Si en realidad ya existe escrito de otra forma, elegilo de la lista:</div>'
      +'<div style="display:flex;flex-direction:column;gap:4px">';

    r.candidatos.forEach(function(c){
      h+='<div onclick="_nsapUsarProv(\''+_esc(c.cardcode)+'\',\''+_esc(String(c.cardname||'').replace(/\'/g,''))+'\')"'
        +' style="display:flex;align-items:center;gap:7px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:6px;padding:5px 8px;cursor:pointer">'
        +'<b style="color:var(--text-accent);flex-shrink:0">'+_esc(c.cardcode)+'</b>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--text-primary)">'+_esc(c.cardname||'')+'</span>'
        +'<span style="flex-shrink:0;font-size:10px;color:var(--text-muted)">'+Math.round(c.score*100)+'%</span>'
        +'</div>';
    });
    h+='</div></div>';


    _nsapProvMsg(h);
    return null;
  }
  // Nada parecido: probablemente sí es nuevo, pero se confirma
  _nsapProvMsg('<div style="font-size:11px;background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:9px 10px;color:var(--t-marron)">'
    +'<div style="margin-bottom:7px"><button onclick="_nsapConfirmarNuevo()" style="width:100%;background:#B45309;border:none;color:#fff;border-radius:8px;padding:9px 12px;font-size:12.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px"><i class="ti ti-building-plus" style="font-size:15px"></i> No hay coincidencia, Crear Proveedor BORRADOR</button></div>'
    +'<div style="font-size:10.5px"><i class="ti ti-info-circle"></i> No existe en SAP ningún proveedor con ese nombre ni parecido.</div>'
    +'</div>');

  return null;
}

// El usuario escribió el código a mano: ese manda.
// Se intenta traer su nombre desde SAP para confirmar que es el correcto.
async function _nsapCodigoManual(v){
  var cod=String(v||'').trim().toUpperCase();
  var ci=document.getElementById('nsapProvCod');
  if(ci) ci.value=cod;
  if(!cod){
    // Se borró el código: se vuelve a resolver por nombre
    window._nsapCardcode=''; window._nsapProvNuevoOK=false; window._nsapProvUltimo='';
    return _nsapBuscarProvSAP(true);
  }
  window._nsapCardcode=cod;
  window._nsapProvNuevoOK=false;
  _nsapProvMsg('<span style="font-size:10.5px;color:var(--text-muted)"><span class="ai-ring g" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Verificando '+_esc(cod)+' en SAP…</span>');

  var nombre=null;
  try{ await _repCargarProveedores(); }catch(e){}
  var local=(_repProv||[]).find(function(p){ return String(p.cardcode||'').toUpperCase()===cod; });
  if(local) nombre=local.cardname;
  if(!nombre){
    try{
      var r=await fetch(SB+'/rest/v1/inventario?select=nombre_proveedor&cardcode=eq.'+encodeURIComponent(cod)+'&limit=1',{headers:SBH});
      if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length) nombre=f[0].nombre_proveedor||''; }
    }catch(e){}
  }
  var inp=document.getElementById('nsapProv');
  if(nombre){
    if(inp) inp.value=nombre;                 // se alinea el nombre con el código
    window._nsapProvUltimo=nombre;
    _nsapProvMsg('<div style="font-size:11px;color:var(--t-verde);background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-circle-check"></i> Código escrito a mano: <b>'+_esc(cod)+'</b> — '+_esc(nombre)+'</div>');
  } else {
    _nsapProvMsg('<div style="font-size:11px;color:var(--t-marron);background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-alert-circle"></i> Se usará el código <b>'+_esc(cod)+'</b> tal como lo escribiste. '
      +'No aparece en el inventario todavía, así que se guardará como proveedor BORRADOR.</div>');
    window._nsapProvNuevoOK=true;             // código propio: no hace falta más confirmación
  }
  return cod;
}

// El usuario eligió uno de los parecidos
function _nsapUsarProv(cardcode, cardname){
  var inp=document.getElementById('nsapProv');
  if(inp && cardname) inp.value=cardname;
  var ci=document.getElementById('nsapProvCod'); if(ci) ci.value=cardcode;
  window._nsapProvUltimo=cardname||'';
  window._nsapCardcode=cardcode;
  window._nsapProvNuevoOK=false;
  _nsapProvMsg('<div style="font-size:11px;color:var(--t-verde);background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:5px 9px">'
    +'<i class="ti ti-circle-check"></i> Se usará <b>'+_esc(cardcode)+'</b> — '+_esc(cardname||'')
    +' <span style="color:var(--text-muted)">(no se creará un proveedor nuevo)</span></div>');
}

// Confirmación explícita de crear proveedor nuevo
function _nsapConfirmarNuevo(){
  var inp=document.getElementById('nsapProv');
  var nombre=(inp&&inp.value||'').trim();
  if(!confirm('¿Deseas crear un nuevo proveedor?\n\n"'+nombre+'"\n\nSe registrará como proveedor BORRADOR hasta que exista en SAP. Si en realidad ya existe con el nombre escrito de otra forma, cancela y elige el correcto de la lista.')) return;
  window._nsapCardcode='';
  window._nsapProvNuevoOK=true;
  var _cn=document.getElementById('nsapProvCod'); if(_cn) _cn.value='';
  _nsapProvMsg('<div style="font-size:11px;color:var(--t-lila);background:var(--pastel-lila);border:0.5px solid #C4B5FD;border-radius:7px;padding:5px 9px">'
    +'<i class="ti ti-plus"></i> Confirmado: <b>'+_esc(nombre)+'</b> se creará como proveedor nuevo (BORRADOR).</div>');
}

// ── Revisión aritmética propia de la orden NO SAP ──
// No depende de la AI: recalcula las líneas y los totales con los números que
// quedaron en el formulario, así se detectan descuadres aunque la AI no avise.
function _nsapRevisarNumeros(items, total, unidadesDoc, cartonesDoc){
  var errs=[];
  var suma=0, piezas=0;
  (items||[]).forEach(function(it, i){
    var n=i+1;
    var c=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
    var tl=Number(it.total_linea)||0;
    var calc=Math.round(c*pu*100)/100;
    suma+=(tl||calc); piezas+=c;
    if(c<=0) errs.push('Línea '+n+' ('+(it.itemcode||it.itemname||'')+'): cantidad en '+c+'.');
    if(pu<0) errs.push('Línea '+n+' ('+(it.itemcode||it.itemname||'')+'): precio unitario negativo.');
    if(tl && Math.abs(tl-calc)>0.02){
      errs.push('Línea '+n+' ('+(it.itemcode||it.itemname||'')+'): '+c+' x '+_fmtN2(pu)+' = '+_fmtN2(calc)+', pero la línea dice '+_fmtN2(tl)+'.');
    }
  });
  suma=Math.round(suma*100)/100;
  var t=Number(total)||0;
  if(t && Math.abs(suma-t)>0.05){
    var nL=(items||[]).length;
    errs.push('La suma de '+(nL===1?'la línea':'las '+nL+' líneas')+' da '+_fmtN2(suma)+' y el total general dice '+_fmtN2(t)+' (diferencia '+_fmtN2(Math.abs(suma-t))+').');
  }
  var ud=Number(unidadesDoc)||0;
  if(ud && piezas && Math.abs(ud-piezas)>0){
    errs.push('El total de piezas declarado es '+ud.toLocaleString('en-US')+' pero la suma de las líneas da '+piezas.toLocaleString('en-US')+'.');
  }
  return {errores:errs, suma:suma, piezas:piezas, cartones:Number(cartonesDoc)||0};
}

function _nsapPintarRevision(errsIA, calc){
  var box=document.getElementById('nsapIAerrores'); if(!box) return 0;
  var todos=[];
  (errsIA||[]).forEach(function(x){ var s=String(x&&x.detalle?x.detalle:x||'').trim(); if(s) todos.push({o:'AI', t:s}); });
  (calc&&calc.errores||[]).forEach(function(s){ todos.push({o:'Cálculo', t:s}); });
  // Quitar repetidos por texto
  var vistos={}, lista=[];
  todos.forEach(function(x){ var k=x.t.toLowerCase().replace(/\s+/g,' '); if(!vistos[k]){ vistos[k]=1; lista.push(x); } });

  if(!lista.length){
    box.innerHTML='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Revisado: las líneas, los totales y las cantidades cuadran.'
      +(calc?('<div style="font-weight:400;margin-top:2px">Suma de líneas '+_fmtN2(calc.suma)+' · '+calc.piezas.toLocaleString('en-US')+' piezas'+(calc.cartones?(' · '+calc.cartones.toLocaleString('en-US')+' cartones'):'')+'</div>'):'')
      +'</div>';
    return 0;
  }
  box.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
    +'<div style="font-weight:800;margin-bottom:4px"><i class="ti ti-alert-triangle"></i> '+lista.length+' problema(s) en los números. Revisa antes de crear la orden:</div>'
    +'<ul style="margin:4px 0 0 16px;padding:0">'
    +lista.map(function(x){ return '<li style="margin-bottom:2px"><b style="opacity:.7">'+x.o+':</b> '+_esc(x.t)+'</li>'; }).join('')
    +'</ul></div>';
  return lista.length;
}

// ═══════════════════════════════════════════════════════════════════════════
//  ORDEN NO SAP — DOS DOCUMENTOS Y COMPARACIÓN
//  Se adjunta la PI del proveedor y nuestra orden de compra. La IA extrae los
//  datos de cada una, llena el formulario con la NUESTRA (que es la que manda)
//  y reporta cualquier diferencia entre las dos.
// ═══════════════════════════════════════════════════════════════════════════
window._nsapDocs = window._nsapDocs || {prov:null, kcc:null};

function _nsapCajaArchivo(clave, titulo, sub, color, bg, bd){
  return '<label id="nsapBox-'+clave+'" style="display:flex;align-items:center;gap:9px;padding:9px 11px;'
    +'border:1.5px dashed '+bd+';border-radius:8px;cursor:pointer;background:'+bg+'">'
    +'<i class="ti ti-upload" style="color:'+color+';font-size:16px"></i>'
    +'<div style="flex:1;min-width:0">'
      +'<div style="font-size:11.5px;font-weight:700;color:'+color+'">'+titulo+'</div>'
      +'<div id="nsapLbl-'+clave+'" style="font-size:10.5px;color:'+color+';opacity:.8;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+sub+'</div>'
    +'</div>'
    +'<i id="nsapChk-'+clave+'" class="ti ti-circle-check" style="color:'+color+';font-size:16px;display:none"></i>'
    +'<input type="file" accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,.txt,image/*" style="display:none" onchange="_nsapDocElegido(\''+clave+'\',this)">'
  +'</label>';
}

window._firmaDocs = window._firmaDocs || {prov:null, kcc:null};
// Sirve para los dos formularios: orden NO SAP (prov/kcc) y compra para firma (fprov/fkcc)
function _nsapDocElegido(clave, input){
  var f=input.files&&input.files[0]; if(!f) return;
  var esFirma=(clave.charAt(0)==='f');
  var k=esFirma?clave.slice(1):clave;
  var store=esFirma?(window._firmaDocs=window._firmaDocs||{prov:null,kcc:null})
                   :(window._nsapDocs=window._nsapDocs||{prov:null,kcc:null});
  store[k]=f;

  var lbl=document.getElementById('nsapLbl-'+clave);
  if(lbl) lbl.textContent=f.name;
  var chk=document.getElementById('nsapChk-'+clave);
  if(chk) chk.style.display='block';

  var faltan=[];
  if(!store.prov) faltan.push('la PI del proveedor');
  if(!store.kcc)  faltan.push('nuestra orden de compra');

  if(esFirma){
    _firmaArchivo = store.kcc || store.prov;      // compatibilidad
    window._firmaRevisionIA=null;
    var eb=document.getElementById('firma-ai-errores'); if(eb) eb.innerHTML='';
    var sf=document.getElementById('firma-ai-status');
    if(sf) sf.innerHTML=faltan.length
      ? '<span style="color:var(--t-ambar)"><i class="ti ti-info-circle"></i> Falta '+faltan.join(' y ')+'. Puedes revisar igual con lo que ya subiste.</span>'
      : '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Los dos documentos listos. Pulsa <b>AI rellenar y revisar</b>.</span>';
    return;
  }

  window._nsapArchivo = store.kcc || store.prov;
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML=faltan.length
    ? '<span style="color:var(--t-marron)"><i class="ti ti-info-circle"></i> Falta '+faltan.join(' y ')+'. Puedes revisar igual con lo que ya subiste.</span>'
    : '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Los dos documentos listos. Pulsa <b>Revisar y comparar con IA</b>.</span>';
}

// Pasa un libro de Excel a texto para la IA.
// El corte es por el MEDIO, nunca por el final: en una proforma los totales,
// el depósito y el saldo están siempre en las últimas filas, así que cortar
// por el final dejaba la orden sin total (era exactamente lo que pasaba con
// las proformas largas: se enviaban las primeras 12.000 letras y la fila
// TOTAL quedaba fuera).
function _iaLibroTexto(wb, tope){
  tope=tope||60000;
  var txt='';
  wb.SheetNames.forEach(function(n){
    txt+='=== HOJA: '+n+' ===\n'+XLSX.utils.sheet_to_csv(wb.Sheets[n],{FS:'\t'})+'\n\n';
  });
  return _iaRecorteMedio(txt, tope);
}

function _iaRecorteMedio(txt, tope){
  txt=String(txt||'');
  if(txt.length<=tope) return txt;
  var cola=Math.floor(tope*0.35), cabeza=tope-cola;
  return txt.slice(0, cabeza)
    +'\n\n[… se omitieron '+(txt.length-tope)+' caracteres del medio del documento. '
    +'Lo que sigue son las ÚLTIMAS filas de la hoja, donde están los totales …]\n\n'
    +txt.slice(txt.length-cola);
}

// Convierte un archivo al bloque de contenido que entiende la IA
async function _nsapContenido(file){
  var ext=(file.name.split('.').pop()||'').toLowerCase();
  if(ext==='xlsx'||ext==='xls'||ext==='csv'){
    var buf=await file.arrayBuffer();
    var wb=XLSX.read(buf,{type:'array'});
    return {type:'text', text:_iaLibroTexto(wb, 60000)};
  }
  if(ext==='pdf'){
    return {type:'document', source:{type:'base64', media_type:'application/pdf', data:await _fileB64(file)}};
  }
  return {type:'image', source:{type:'base64', media_type:(file.type||'image/jpeg'), data:await _fileB64(file)}};
}

// Revisa y compara los dos documentos
// Saca las fotos del Excel a pedido. Sirve cuando la revisión con AI ya
// pasó o cuando el archivo se adjuntó después.
// auto = viene enganchado a la revisión con IA. En ese caso no pisa el
// resumen de la revisión (lo continúa en una segunda línea) y se calla si no
// hay nada que sacar, para no interrumpir con avisos que nadie pidió.
async function _nsapSacarFotos(auto){
  var items=window._nsapItems||[];
  if(!items.length){ if(auto) return; showT('Primero revisa el documento con AI'); return; }

  var cands=[];
  // El Excel adjuntado a mano solo para esto, si lo hay
  if(window._nsapExcelExtra) cands.push(window._nsapExcelExtra);
  [window._nsapDocs, window._firmaDocs].forEach(function(st){
    if(!st) return;
    if(st.prov) cands.push(st.prov);
    if(st.kcc)  cands.push(st.kcc);
  });
  try{
    document.querySelectorAll('#modalNuevaSAP input[type=file]').forEach(function(inp){
      if(inp.files && inp.files[0]) cands.push(inp.files[0]);
    });
  }catch(e){}
  var xls=cands.filter(function(f){ return f && /\.xlsx$/i.test(f.name||''); });

  var st2=document.getElementById('nsapIAstatus');
  // En automático, debajo de lo que dijo la revisión
  var _pre=(auto && window._nsapEstadoIA) ? (window._nsapEstadoIA+'<br>') : '';
  if(!xls.length){
    if(auto) return;
    // Sin Excel no hay fotos, pero en vez de dejarlo ahí se ofrece adjuntar
    // uno: muchas veces la orden llega en PDF y el Excel con las fotos lo
    // manda el proveedor aparte.
    var msg='No hay ningún archivo .xlsx entre los adjuntos'
      +(cands.length?(' (se ve: '+cands.map(function(f){return f.name;}).join(', ')+')')
                    :'')
      +'. Las fotos van incrustadas solo en los .xlsx.';
    if(st2) st2.innerHTML=_pre
      +'<span style="color:var(--t-ambar)"><i class="ti ti-photo-off"></i> '
      +_esc(msg)+'</span> '
      +'<button class="xb" style="font-size:10.5px;padding:2px 9px;margin-left:6px" '
      +'onclick="_nsapPedirExcel()"><i class="ti ti-file-upload"></i> '
      +'Adjuntar un Excel</button>';
    showT('No hay un .xlsx: puedes adjuntar uno con el botón', 7000);
    return;
  }

  if(st2) st2.innerHTML=_pre+'<span class="ai-wrap" style="color:var(--t-lila)">'
    +'<span class="ai-ring"></span> Sacando las fotos del Excel…</span>';
  try{ await _cargarJSZip(); }catch(e){}

  // Antes de emparejar las fotos, se corrigen los códigos de KCC leyéndolos
  // de la propia hoja. Si la IA se equivocó de columna, las fotos se
  // buscarían por un código que no existe y no encontrarían nada.
  for(var c=0;c<xls.length;c++){
    try{ await _nsapCorregirKcc(xls[c], items); }
    catch(e){ console.warn('[kcc] '+xls[c].name+':', e); }
    // El relleno de campos ya lo hace _nsapCompletarTodo, aparte: aquí solo
    // se corrigen los códigos, que es lo que las fotos necesitan.
  }

  var mapa={};
  for(var i=0;i<xls.length;i++){
    try{
      var m=await _nsapFotosPorSku(xls[i], items);
      Object.keys(m||{}).forEach(function(k){ if(!mapa[k]) mapa[k]=m[k]; });
    }catch(e){ console.warn('[nosap] '+xls[i].name+':', e); }
  }
  window._nsapFotosPend=mapa;
  var n=Object.keys(mapa).length;
  if(n){
    items.forEach(function(it){
      var k=String(it.itemcode||'').trim().toUpperCase();
      // Los que ya están en SAP conservan la foto del inventario: es la que
      // usa el resto del portal y la que ya está subida al bucket.
      if(mapa[k] && !it._fotoDeSAP) it._foto='data:'+mapa[k].mime+';base64,'+mapa[k].b64;
      // La de SAP manda, pero si no carga —el archivo no está, o el nombre no
      // coincide— se usa la del Excel. Antes el artículo se quedaba sin
      // ninguna teniendo una a mano.
      else if(mapa[k] && it._fotoDeSAP){
        it._fotoExcel='data:'+mapa[k].mime+';base64,'+mapa[k].b64;
      }
    });
    _nsapRenderItems();
  }
  var d=window._nsapFotosDiag||{};
  if(st2) st2.innerHTML = _pre + (n
    ? ('<span style="color:var(--text-success)"><i class="ti ti-photo-check"></i> '
       +n+' de '+items.length+' artículo(s) con foto</span>')
    : ('<span style="color:var(--t-ambar)"><i class="ti ti-photo-off"></i> Sin fotos · '
       +(!d.jszip ? 'no se pudo abrir el archivo'
        : (d.imagenes===0 ? 'el Excel no trae imágenes'
        : (d.ubicados===0 ? 'no se encontraron los códigos en la hoja'
        : 'las imágenes están fuera de la tabla')))
       +'</span>'));
  if(!auto) showT(n?('✓ '+n+' foto(s)'):'No se encontraron fotos');
}

async function _nsapRevisarConIA(){
  var prov=window._nsapDocs.prov, kcc=window._nsapDocs.kcc;
  if(!prov && !kcc){ showT('Adjunta al menos un documento'); return; }
  window._nsapEstadoIA='';   // resumen de esta revisión, aún sin escribir
  var st=document.getElementById('nsapIAstatus');
  var btn=document.getElementById('nsapBtnIA');
  if(btn){ btn.disabled=true; btn.style.opacity='.7';
    btn.innerHTML='<span class="ai-ring" style="width:12px;height:12px;border-width:2px;vertical-align:-1px"></span> Analizando…'; }
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo los documentos…</span>';

  try{
    var contenido=[];
    if(kcc){
      contenido.push({type:'text', text:'DOCUMENTO A — NUESTRA ORDEN DE COMPRA (KENNEDY CENTER CORP.):'});
      contenido.push(await _nsapContenido(kcc));
    }
    if(prov){
      contenido.push({type:'text', text:'DOCUMENTO B — PI DEL PROVEEDOR (Proforma Invoice):'});
      contenido.push(await _nsapContenido(prov));
    }
    contenido.push({type:'text', text:_nsapPromptComparar(!!kcc, !!prov)});

    // v746: 16 000 de salida en vez de 8 000. Con órdenes largas la IA se
    // quedaba corta y había que pedirle «sigue»: cada vuelta vuelve a mandar
    // los documentos enteros y es lo que más tarda.
    var _t0=Date.now();
    var _reloj=setInterval(function(){
      if(st && /ai-ring/.test(st.innerHTML) && !/sigue leyendo/.test(st.innerHTML))
        st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> La AI está leyendo los documentos… '
          +Math.round((Date.now()-_t0)/1000)+' s</span>';
    }, 1000);
    var obj;
    try{
      obj=await _iaJSON(contenido, 16000, function(n){
        if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Documentos largos: la AI sigue leyendo ('+n+') · '
          +Math.round((Date.now()-_t0)/1000)+' s…</span>';
      });
    } finally { clearInterval(_reloj); }
    console.log('[BORRADOR] la IA tardó '+Math.round((Date.now()-_t0)/1000)+' s');

    // El formulario se llena con NUESTRA orden; si no vino, con la del proveedor
    var base=obj.kcc||obj.proveedor||obj;
    if(base.proveedor) document.getElementById('nsapProv').value=base.proveedor;
    // El número va SIEMPRE con su prefijo. Nuestra orden lo escribe suelto
    // ("DKC No. 26084") y la PI del proveedor con prefijo ("PO No: DKC-26084"):
    // se cruzan las dos para no perderlo.
    if(base.num_orden){
      document.getElementById('nsapRef').value=_nsapNormRef(base.num_orden, [
        base.po,
        (obj.proveedor&&obj.proveedor.po), (obj.proveedor&&obj.proveedor.num_orden),
        (obj.kcc&&obj.kcc.po), (obj.kcc&&obj.kcc.num_orden)
      ]);
    }
    if(base.po){ var poEl=document.getElementById('nsapPO'); if(poEl) poEl.value=base.po; }
    // Número de reposición: si el documento lo trae, se completa solo
    var _nr=String(base.num_reposicion||'').trim().toUpperCase();
    if(_nr){
      var nrEl=document.getElementById('nsapNumRepo');
      if(nrEl){ nrEl.value=_nr; try{ _nsapRepoCambio(); }catch(e){} }
    }
    // Si el documento no traía el número, se busca la reposición abierta de
    // ese mismo proveedor: la orden tiene que quedar ligada sola.
    try{ await _nsapRepoAuto(); }catch(e){ console.warn('[reposición] liga automática:', e); }
    if(base.total!=null) document.getElementById('nsapTotal').value=base.total;
    if(base.abonado!=null) document.getElementById('nsapAbon').value=base.abonado;
    _nsapCalcSaldo();
    // El abono casi nunca viene en dólares: los términos dicen "20% Deposit".
    // Si la IA leyó el porcentaje y no hay monto, se escribe el monto calculado
    // y se deja anotado de dónde salió, para que se pueda corregir a mano.
    window._nsapAbonoDePct=0;
    var _pct=Number(base.deposito_pct||(obj.kcc&&obj.kcc.deposito_pct)||(obj.proveedor&&obj.proveedor.deposito_pct))||0;
    var _elA=document.getElementById('nsapAbon');
    var _elP=document.getElementById('nsapAbonPct');
    if(_pct>0 && _pct<=100 && _elA && !(parseFloat(_elA.value)||0)){
      if(_elP){ _elP.value=_pct; _nsapAbonoDesdePct(); }
      else { _elA.value=(Math.round((Number(base.total)||0)*_pct)/100).toFixed(2); _nsapCalcSaldo(); }
      window._nsapAbonoDePct=_pct;
    }
    var fa=document.getElementById('nsapFechaAbono');
    if(fa && base.fecha_abono) fa.value=base.fecha_abono;

    // Los detalles del OTRO documento, por código, para completar lo que le
    // falte al principal. El código de barras y el cubicaje suelen venir en
    // el PI del proveedor, y la descripción en el nuestro.
    var _otro={};
    [obj.kcc, obj.proveedor].forEach(function(doc){
      ((doc&&doc.items)||[]).forEach(function(it){
        var k=_bkNorm(it.itemcode_kcc||it.itemcode||'');
        if(!k) return;
        _otro[k]=Object.assign({}, it, _otro[k]||{});
      });
    });

    // Todos los campos del artículo, no solo código y precio. Antes se
    // quedaban por el camino: la IA los leía y aquí se tiraban, así que las
    // columnas salían vacías aunque estuvieran en la PO.
    var DETALLES=['descripcion','material','color','tamano','empaque','barcode',
                  'unidades_x_caja','carton_size','cartones_item','cbm','peso',
                  'marca','peso_neto','factory'];
    var crudos=(Array.isArray(base.items)?base.items:[]).map(function(it){
      var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
      var tl=Number(it.total_linea)||(cant*pu);
      var o={itemcode:String(it.itemcode||it.itemcode_kcc||'').trim(),
             itemcode_kcc:String(it.itemcode_kcc||'').trim(),
             itemcode_proveedor:String(it.itemcode_proveedor||'').trim(),
             itemname:String(it.itemname||'').trim(),
             cantidad:cant, precio_unit:pu, total_linea:tl};
      var alt=_otro[_bkNorm(o.itemcode_kcc||o.itemcode)]||{};
      DETALLES.forEach(function(k){
        var v = (it[k]!==undefined && it[k]!=='' && it[k]!==0) ? it[k] : alt[k];
        if(v!==undefined && v!=='' && v!==null) o[k]=v;
      });
      return o;
    });
    // Se comprueban los códigos contra el inventario de SAP: los KCC existen
    // ahí, los del proveedor no. Si vinieron cruzados, se corrigen solos.
    var rc={items:crudos, verificados:0, corregidos:0};
    try{ rc=await _nsapResolverCodigos(crudos); }catch(e){ console.warn('resolver codigos:',e); }
    window._nsapItems=rc.items;
    window._nsapCodigosInfo=rc;
    _nsapRenderItems();

    // Si el documento no traía el total (o la IA no lo encontró), se suma el
    // de las líneas en vez de dejar la orden en cero. Queda avisado abajo,
    // porque un total sumado puede no incluir flete ni descuentos.
    window._nsapTotalSumado=0;
    var _elT=document.getElementById('nsapTotal');
    var _suma=(window._nsapItems||[]).reduce(function(a,it){
      return a+(Number(it.total_linea)||0); }, 0);
    if(_elT && !(Number(base.total)||0) && _suma>0){
      _elT.value=Math.round(_suma*100)/100;
      window._nsapTotalSumado=Math.round(_suma*100)/100;
      _nsapCalcSaldo();
    }

    // Identificar el proveedor contra SAP
    try{ await _nsapBuscarProvSAP(true); }catch(e){}

    // Revisión propia de la aritmética
    var calc=_nsapRevisarNumeros(window._nsapItems, base.total, base.unidades, base.cartones);
    var nProb=_nsapPintarComparacion(obj, calc, !!kcc, !!prov);
    window._nsapProblemas=nProb;

    var nIt=window._nsapItems.length;
    if(st){
      var dif=((obj.diferencias||[]).length);
      var rcI=window._nsapCodigosInfo||{verificados:0,corregidos:0,sinKcc:0};
      var partes=[];
      if(rcI.verificados) partes.push(rcI.verificados+'/'+nIt+' códigos verificados contra SAP');
      if(rcI.corregidos)  partes.push(rcI.corregidos+' código(s) corregido(s) al de Kennedy');
      if(rcI.sinKcc)      partes.push('<b style="color:var(--t-ambar)">'+rcI.sinKcc+' línea(s) sin código KCC reconocible: revisalas</b>');
      if(window._nsapTotalSumado) partes.push('<b style="color:var(--t-ambar)">el total no venía en el documento: '
        +'se sumaron las líneas ('+fmt(window._nsapTotalSumado)+'), verifícalo</b>');
      if(window._nsapAbonoDePct) partes.push('abono calculado con el '+window._nsapAbonoDePct
        +'% de depósito de los términos de pago, edítalo si hace falta');
      var extra=partes.length?(' · '+partes.join(' · ')):'';
      st.innerHTML=nProb
        ? '<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> '+nIt+' productos extraídos'+extra+' · '+nProb+' incidencia(s) para revisar.</span>'
        : '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '+nIt+' productos extraídos'+extra
          +((kcc&&prov)?' · los dos documentos coinciden':'')+'.</span>';
      window._nsapEstadoIA=st.innerHTML;   // las fotos escriben debajo de esto
    }

    // Completar los campos desde los Excel va APARTE de las fotos. Estaba
    // dentro de _nsapSacarFotos, que se sale antes si no hay ningún .xlsx
    // —por ejemplo con la PO de Kennedy en PDF—, y entonces no se rellenaba
    // nada aunque el otro documento sí fuera Excel.
    try{ await _nsapCompletarTodo(); }
    catch(e){ console.warn('[nosap] completar campos:', e); }

    // Las fotos del Excel salen solas: son parte de leer el documento, no un
    // segundo paso que haya que acordarse de pulsar. Si algo falla, la
    // revisión ya está hecha y el botón de mano sigue estando.
    try{ await _nsapSacarFotos(true); }
    catch(e){ console.warn('[nosap] fotos automáticas:', e); }
  }catch(e){
    console.error('comparar BORRADOR:',e);
    if(st) st.innerHTML='<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> No se pudo analizar ('+_esc(e.message||String(e))+'). Completá los campos a mano.</span>';
  }
  if(btn){ btn.disabled=false; btn.style.opacity='1';
    btn.innerHTML='<i class="ti ti-sparkles"></i> Revisar y comparar con IA'; }
}

function _nsapPromptComparar(hayKcc, hayProv){
  var p='Sos el auditor de compras de KENNEDY CENTER CORP. Analiza ';
  p+= (hayKcc&&hayProv) ? 'los DOS documentos adjuntos.\n\n'
     : 'el documento adjunto.\n\n';
  if(hayKcc&&hayProv){
    p+='DOCUMENTO A es NUESTRA orden de compra (Kennedy Center). Su numero suele empezar con DKC- o SKC-.\n'
      +'DOCUMENTO B es la PI (Proforma Invoice) del PROVEEDOR, con su propio numero.\n'
      +'Los dos deberian describir la MISMA compra. Tu trabajo es extraer los datos de cada uno y COMPARARLOS.\n\n';
  }
  p+='REGLA DE CANTIDADES, MUY IMPORTANTE: la cantidad va SIEMPRE en PIEZAS, nunca en cartones. '
    +'Usa la columna de cantidad pedida en piezas (ORDER QTY / Pcs, ORDER QTY, QTY, Quantity, CANTIDAD, PCS). '
    +'NO uses QTY X CTN, QTY/CTN, PCS/CTN, No.Ctn, TTL CTNS, CTNS, CARTONS ni inner: esas son piezas por carton o cantidad de cartones. '
    +'Ejemplo: si dice ORDER QTY/Pcs = 300, QTY X CTN = 6 y TTL CTNS = 50, la cantidad es 300. '
    +'Verifica siempre que cantidad x precio_unitario de el total de la linea.\n\n'
    +'QUE COMPARAR entre los dos documentos: nombre del proveedor; numero de orden que cada uno referencia; fecha; moneda; '
    +'incoterm; terminos de pago; puerto o destino; plazo de entrega; cantidad de lineas; y por cada linea el codigo del item, '
    +'la descripcion, la cantidad en piezas, el precio unitario y el total de linea; subtotal, descuentos, impuestos, flete, '
    +'total general, total de piezas y total de cartones. Empareja las lineas por codigo y, si no hay codigo, por descripcion. '
    +'Reporta tambien las lineas que estan en un documento y NO en el otro.\n\n'
    +'ERRORES INTERNOS a revisar en cada documento: cantidad x precio unitario que no cuadre con el total de la linea; '
    +'suma de lineas que no cuadre con el total general; subtotal + impuestos + flete - descuentos que no de el total; '
    +'cantidades o precios en cero o negativos; totales repetidos que no coincidan entre si.\n\n'
    +'FICHA DE CADA ARTICULO (sirve para armar catalogos para el cliente):\n'
    +'La tabla de productos tiene una columna por dato. Lee la CABECERA de cada\n'
    +'columna y lleva su valor al campo que corresponde. Los encabezados varian\n'
    +'entre proveedores, asi que guiate por el significado, no por el texto exacto.\n\n'
    +'EQUIVALENCIAS HABITUALES:\n'
    +'  "KCC ITEM No." / "KCC ITEM CODE" / "KCC CODE" / "Item No." /\n'
    +'  "Codigo KCC" / "COD KCC" / cualquier encabezado que lleve KCC -> itemcode_kcc\n'
    +'  "Factory Code" / "Vendor Code" / "Supplier Item" / "Ref. fabrica" -> itemcode_proveedor\n'
    +'  "BARCODE No." / "Barcode" / "UPC" / "EAN"          -> barcode\n'
    +'  "PRODUCT Description & Package" / "Description"    -> descripcion\n'
    +'  "SPANISH NAME" / "Descripcion en espanol"          -> itemname\n'
    +'  "ITEM SIZE Dimension / Ounces / Capacity"          -> tamano\n'
    +'  "COLOR Finishing" / "Color"                        -> color\n'
    +'  "MATERIAL, Construction Composition %"             -> material\n'
    +'  "ORDER QTY / Pcs" / "Quantity" / "QTY"             -> cantidad\n'
    +'  "QTY X CTN Packing" / "Pcs per carton"             -> unidades_x_caja\n'
    +'  "CARTON SIZE" / "Medida de caja"                   -> carton_size\n'
    +'  "TTL CTNS" / "Total cartons"                       -> cartones_item\n'
    +'  "CBM X CTN" / "CBM"                                -> cbm\n'
    +'  "N.W." / "G.W." / "Weight" / "Peso"                -> peso\n'
    +'  "UNIT PRICE" / "Precio unitario"                   -> precio_unit\n'
    +'  "TOTAL AMOUNT" / "Amount"                          -> total_linea\n'
    +'  "Brand" / "Marca"                                  -> marca\n\n'
    +'NUMERO DE REPOSICION (campo num_reposicion, a nivel de la orden):\n'
    +'Si el documento menciona un numero de reposicion o re-order con la forma\n'
    +'R-01, R-1, R 01, "RE-ORDER R-05", "Re-order No.: R-12" o "Reposicion R-03",\n'
    +'devolvelo en num_reposicion con el formato R-NN (por ejemplo R-05).\n'
    +'Si no aparece en ninguna parte, devolve num_reposicion vacio. NO lo inventes\n'
    +'ni lo confundas con el DKC, el PO del proveedor ni el codigo de un articulo.\n\n'
    +'REGLAS:\n'
    +'1. Si hay nombre en espanol y descripcion en ingles, el espanol va en\n'
    +'   "itemname" y el ingles en "descripcion". Si solo hay uno, ponelo en ambos.\n'
    +'2. Copia el valor COMPLETO de la celda, con sus saltos de linea y unidades\n'
    +'   (por ejemplo "95% Acrylic\\n3% Iron\\n2% Paper" o "39.5x34x23.5cm").\n'
    +'3. Si una columna no existe en ese documento, deja el campo vacio.\n'
    +'   NUNCA inventes un valor ni lo deduzcas de otra columna.\n'
    +'4. Si una columna tiene un encabezado que no reconoces pero su contenido\n'
    +'   claramente corresponde a uno de los campos, usalo igual.\n'
    +'5. "empaque" se arma con "unidades_x_caja" y "carton_size" si ambos estan:\n'
    +'   por ejemplo "24 pzs x caja · 39.5x34x23.5cm".\n\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues, con esta forma:\n'
    +'{\n'
    +' "kcc":{"proveedor":"","num_orden":"","po":"","fecha":"","moneda":"","total":0,"abonado":0,"deposito_pct":0,"saldo":0,"unidades":0,"cartones":0,'
    +'"items":[{"itemcode_kcc":"","itemcode_proveedor":"","itemname":"","cantidad":0,"precio_unit":0,"total_linea":0,"descripcion":"","material":"","color":"","tamano":"","empaque":"","barcode":"","unidades_x_caja":0,"carton_size":"","cartones_item":0,"cbm":0,"peso":"","marca":""}]},\n'
    // La ficha completa (material, color, empaque, cbm…) solo se usa para armar
    // el catálogo, y eso sale de NUESTRA orden. Cuando están los dos documentos,
    // del proveedor basta con lo que se compara: pedirle la ficha otra vez
    // duplicaba la respuesta y por eso el análisis tardaba tanto.
    +' "proveedor":{"proveedor":"","num_orden":"","po":"","fecha":"","moneda":"","total":0,"deposito_pct":0,"unidades":0,"cartones":0,'
    // Los detalles se piden SIEMPRE de los dos documentos. Antes, con los dos
    // subidos, del PI del proveedor solo se pedían código, nombre, cantidad y
    // precio: el código de barras, el cubicaje y el material están en ese
    // documento, y se quedaban vacíos aunque estuvieran a la vista.
    +'"items":[{"itemcode_kcc":"","itemcode_proveedor":"","itemname":"","cantidad":0,"precio_unit":0,"total_linea":0,"descripcion":"","material":"","color":"","tamano":"","empaque":"","barcode":"","unidades_x_caja":0,"carton_size":"","cartones_item":0,"cbm":0,"peso":"","marca":""}]},\n'
    +' "errores":[{"doc":"kcc","detalle":""}],\n'
    +' "diferencias":[{"campo":"","kcc":"","proveedor":"","gravedad":"alta","detalle":""}],\n'
    +' "coinciden":true\n'
    +'}\n\n'
    +'REGLAS DEL JSON:\n'
    +'- Los DETALLES del articulo (barcode, material, color, tamano, cubicaje,\n'
    +'  cartones, piezas por caja, peso) estan casi siempre en el PI del\n'
    +'  PROVEEDOR, en columnas estrechas a los lados de la foto. Leelos de ahi\n'
    +'  aunque nuestra orden no los traiga, y ponlos en el item que corresponda.\n'
    +'- El barcode es un numero largo, de 12 o 13 cifras, en su propia columna.\n'
    +'  No lo confundas con el codigo KCC (7 cifras) ni con el del proveedor.\n'
    +'- Si un documento esta escaneado, lee igual las columnas: los datos estan\n'
    +'  aunque el texto no sea seleccionable.\n'
    +'- "num_orden" del bloque kcc es el codigo DKC- o SKC-. "po" es el numero del proveedor.\n'
    +'- "num_orden" SIEMPRE lleva su prefijo: DKC-26084, nunca 26084 a secas. Nuestra orden a veces\n'
    +'  lo escribe partido ("DKC No." en una celda y "26084" en la de al lado) y la PI del proveedor\n'
    +'  lo escribe entero ("PO No: DKC-26084"). Juntalo y devolvelo completo. Si un documento lo trae\n'
    +'  sin prefijo y el otro con prefijo, usa el que tiene prefijo.\n'
    +'- "deposito_pct": si los terminos de pago indican un porcentaje de deposito o anticipo\n'
    +'  ("20% Deposit / 80% Balance", "20% DEPOSIT, BALANCE T/T AGAINST COPY OF B/L", "30% anticipo"),\n'
    +'  devuelve solo el numero del deposito (20, 30). Si no hay porcentaje, 0.\n'
    +'- "abonado": solo si el documento dice un MONTO ya abonado en dinero. Si unicamente hay\n'
    +'  porcentaje, deja abonado en 0 y usa deposito_pct: el monto lo calcula el sistema.\n'
    +'- POR CADA LINEA devuelve LOS DOS codigos por separado: "itemcode_kcc" (el nuestro, de Kennedy) e "itemcode_proveedor" (el del proveedor). '
    +'NUNCA los mezcles ni repitas el mismo valor en los dos. Si en esa linea solo aparece uno, deja el otro en "".\n'
    +'- REGLA QUE MANDA SOBRE TODO LO DEMAS: si el encabezado de una columna contiene "KCC" '
    +'(KCC ITEM No., KCC ITEM CODE, KCC CODE, COD KCC, KCC REF...), esa columna es NUESTRA y su valor '
    +'va SIEMPRE en "itemcode_kcc", nunca en "itemcode_proveedor". La palabra "Item Code" sola, SIN KCC '
    +'delante, si es del proveedor. No te dejes llevar por el parecido de los textos.\n'
    +'- CUIDADO: en NUESTRA orden las columnas "Factory Code" y "KCC ITEM No." estan PEGADAS, una al lado de la otra. '
    +'La PRIMERA (Factory Code) es la del proveedor y NO se usa. La SEGUNDA (KCC ITEM No.) es la nuestra y es la que va en "itemcode_kcc".\n'
    +'- COMO RECONOCERLOS POR SU FORMA: el codigo de Kennedy es numerico de 5 a 8 digitos (ej: 2313496, 26274) o empieza con BA- seguido de digitos '
    +'(ej: BA-2324041, BA-2317969). El de fabrica mezcla letras y numeros (ej: V-S12Q, V-S20Q, V-A13-SS, V-M96210-SS, B0040MP5L, BBQ4004, W4068). '
    +'Si el valor que ibas a poner en "itemcode_kcc" tiene letras mezcladas como V-S12Q, ESTA MAL: ese es el de fabrica, busca el que empieza con BA- o el numerico.\n'
    +'- Ejemplo real de una linea nuestra: Factory Code "V-S12Q", KCC ITEM No. "BA-2324041", BARCODE "7450123240419". '
    +'Entonces itemcode_kcc = "BA-2324041", itemcode_proveedor = "V-S12Q". El barcode NO es un codigo de item, no lo uses nunca.\n'
    +'- El codigo de Kennedy ES EL PUNTO MAS IMPORTANTE. Tiene que ser SIEMPRE el codigo interno de KENNEDY CENTER, NUNCA el del proveedor.\n'
    +'  Como distinguirlos: el codigo de Kennedy aparece en columnas rotuladas "KCC ITEM No", "KCC ITEM", "KCC Item No.", "Codigo KCC", '
    +'"Item Kennedy", o simplemente "Code" en la PI del proveedor. Suele ser numerico de 6 a 7 digitos (ej: 2313496, 26274) o empezar con BA- (ej: BA-2317969).\n'
    +'  El codigo del PROVEEDOR aparece como "Factory Code", "Item No.", "Supplier Code", "Ref proveedor", "Vendor Item" y suele tener letras y numeros '
    +'mezclados (ej: B0040MP5L, BBQ4004, KT251008, W4068). ESOS NO SE USAN.\n'
    +'  Si una linea muestra los dos codigos, elige SIEMPRE el de Kennedy. Ejemplo real: si la fila dice Factory Code "BBQ4004" y KCC ITEM "BA-2317969", '
    +'el itemcode correcto es "BA-2317969". Si dice Factory Code "B0040MP5L" y KCC ITEM "2313496", el itemcode correcto es "2313496".\n'
    +'  Toma el codigo de NUESTRA orden (documento A) cuando exista; solo si falta, usa el de la PI del proveedor.\n'
    +'- En "itemname" usa una descripcion CORTA de maximo 60 caracteres.\n'
    +'- "doc" en errores: "kcc", "proveedor" o "ambos".\n'
    +'- "gravedad": "alta" si afecta dinero, cantidades o el item comprado; "media" en fechas, terminos o condiciones; "baja" si es de forma.\n'
    +'- "detalle": una sola frase, CON LOS NUMEROS involucrados.\n'
    +'- "coinciden": true solo si NO hay diferencias de gravedad alta ni media.\n'
    +'- Si solo hay un documento, deja el otro bloque vacio y "diferencias":[].\n'
    +'- En documentos largos reporta como maximo 40 diferencias, priorizando las de gravedad alta.\n'
    +'- Si un dato no aparece usa "" o 0. Nunca inventes datos.';
  return p;
}

// Pinta el reporte de incidencias
function _nsapPintarComparacion(obj, calc, hayKcc, hayProv){
  var box=document.getElementById('nsapIAerrores'); if(!box) return 0;
  var difs=(Array.isArray(obj.diferencias)?obj.diferencias:[]).map(function(d){
    if(typeof d==='string') return {campo:'', kcc:'', proveedor:'', gravedad:'media', detalle:d};
    return {campo:d.campo||'', kcc:(d.kcc!=null?d.kcc:''), proveedor:(d.proveedor!=null?d.proveedor:''),
            gravedad:String(d.gravedad||'media').toLowerCase(), detalle:d.detalle||''};
  }).filter(function(d){ return String(d.detalle||d.campo||'').trim(); });

  var errs=(Array.isArray(obj.errores)?obj.errores:[]).map(function(e){
    if(typeof e==='string') return {doc:'', detalle:e};
    return {doc:e.doc||'', detalle:e.detalle||''};
  }).filter(function(e){ return String(e.detalle||'').trim(); });

  var nAlta=difs.filter(function(d){return d.gravedad==='alta';}).length;
  var h='';

  // Resumen de cada documento
  var k=obj.kcc||{}, pv=obj.proveedor||{};
  if(hayKcc||hayProv){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">';
    if(hayKcc)  h+=_nsapTarjetaDoc('KCC ORDEN DE COMPRA', k, '#0c447c','#e6f1fb','#85B7EB');
    if(hayProv) h+=_nsapTarjetaDoc('PI PROVEEDOR', pv, '#B45309','#FEF9F3','#E9C08A');
    h+='</div>';
  }

  if(hayKcc && hayProv){
    if(difs.length){
      h+='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden;margin-bottom:9px">'
        +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:800;color:var(--t-rojo)">'
        +'<i class="ti ti-git-compare"></i> '+difs.length+' incidencia(s) entre la PI del proveedor y nuestra orden'
        +(nAlta?(' &middot; <span style="color:var(--t-rojo2)">'+nAlta+' grave(s)</span>'):'')+'</div>';
      difs.forEach(function(d){
        var c=d.gravedad==='alta'?'#dc2626':(d.gravedad==='baja'?'#6b7280':'#B45309');
        var bgg=d.gravedad==='alta'?'#FEF2F2':(d.gravedad==='baja'?'var(--surface-1)':'#FEF9F3');
        h+='<div style="padding:8px 11px;border-top:0.5px solid var(--border);background:'+bgg+'">'
          +'<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
            +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'+_esc(d.gravedad)+'</span>'
            +(d.campo?('<b style="font-size:11.5px">'+_esc(String(d.campo))+'</b>'):'')
          +'</div>';
        if(String(d.kcc)!==''||String(d.proveedor)!==''){
          h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:4px;font-size:11px">'
            +'<span style="flex:1;min-width:140px;background:var(--pastel-azul);border-radius:6px;padding:3px 7px"><b style="color:var(--t-azul)">KCC:</b> '+_esc(String(d.kcc||'—'))+'</span>'
            +'<span style="flex:1;min-width:140px;background:var(--pastel-aviso);border-radius:6px;padding:3px 7px"><b style="color:var(--t-ambar)">PI proveedor:</b> '+_esc(String(d.proveedor||'—'))+'</span>'
          +'</div>';
        }
        if(d.detalle) h+='<div style="font-size:11px;color:var(--text-secondary);margin-top:3px">'+_esc(String(d.detalle))+'</div>';
        h+='</div>';
      });
      h+='</div>';
    } else {
      h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600;margin-bottom:9px">'
        +'<i class="ti ti-git-compare"></i> Los dos documentos coinciden: mismos items, cantidades, precios y totales.</div>';
    }
  } else if(hayKcc||hayProv){
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:9px">'
      +'<i class="ti ti-info-circle"></i> Solo se analizó <b>'+(hayKcc?'nuestra orden de compra':'la PI del proveedor')+'</b>. '
      +'Adjunta el otro documento para poder compararlos.</div>';
  }

  // Errores internos + recálculo propio
  var todos=[];
  var etq={kcc:'Nuestra orden', proveedor:'PI proveedor', ambos:'Ambos'};
  errs.forEach(function(e){ todos.push({o:(etq[e.doc]||'AI'), t:e.detalle}); });
  (calc&&calc.errores||[]).forEach(function(t){ todos.push({o:'Cálculo', t:t}); });
  var vistos={}, lista=[];
  todos.forEach(function(x){ var kk=String(x.t).toLowerCase().replace(/\s+/g,' '); if(!vistos[kk]){ vistos[kk]=1; lista.push(x); } });

  if(lista.length){
    h+='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
      +'<div style="font-weight:800;margin-bottom:4px"><i class="ti ti-alert-triangle"></i> '+lista.length+' problema(s) en los números:</div>'
      +'<ul style="margin:4px 0 0 16px;padding:0">'
      +lista.map(function(x){ return '<li style="margin-bottom:2px"><b style="opacity:.7">'+_esc(x.o)+':</b> '+_esc(x.t)+'</li>'; }).join('')
      +'</ul></div>';
  } else if(hayKcc||hayProv){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Las líneas y los totales cuadran.</div>';
  }

  box.innerHTML=h;
  return difs.length+lista.length;
}

function _nsapTarjetaDoc(titulo, d, color, bg, bd){
  return '<div style="flex:1;min-width:180px;background:'+bg+';border:0.5px solid '+bd+';border-radius:8px;padding:8px 10px">'
    +'<div style="font-size:10.5px;font-weight:800;color:'+color+';margin-bottom:3px">'+titulo+'</div>'
    +'<div style="font-size:11px;line-height:1.5">'
      +(d.num_orden?('<div>Orden: <b>'+_esc(String(d.num_orden))+'</b></div>'):'')
      +(d.po?('<div>PO: <b>'+_esc(String(d.po))+'</b></div>'):'')
      +(d.proveedor?('<div>'+_esc(String(d.proveedor))+'</div>'):'')
      +(Number(d.total)?('<div>Total: <b>'+fmt(d.total)+'</b></div>'):'')
      +(Number(d.unidades)?('<div>Piezas: <b>'+Number(d.unidades).toLocaleString('en-US')+'</b></div>'):'')
      +(Array.isArray(d.items)&&d.items.length?('<div>Líneas: <b>'+d.items.length+'</b></div>'):'')
    +'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  BORRADOR DE LA ORDEN NO SAP
//  Guarda lo que se lleva escrito para seguir más tarde. Se guarda en el
//  navegador de la persona, así que no ocupa nada en la base ni ensucia la
//  lista de órdenes hasta que se cree de verdad.
// ═══════════════════════════════════════════════════════════════════════════
// Cerrar guarda el borrador solo si hay algo escrito
function _nsapCerrarModal(){
  var guardado=false;
  try{ guardado=_nsapGuardarDraft(true); }catch(e){}
  var m=document.getElementById('modalNuevaSAP'); if(m) m.remove();
  if(guardado) showT('Se guardó un borrador con lo que llevabas');
}

// Cortina con rueda mientras se crea la orden: toca varias tablas y sube
// archivos, así que puede tardar unos segundos.
function _nsapCreando(txt){
  // Red de seguridad: si algo se cuelga, la rueda se quita sola
  if(window._nsapCreandoTimer) clearTimeout(window._nsapCreandoTimer);
  window._nsapCreandoTimer=setTimeout(function(){
    if(document.getElementById('nsapCreandoOv')){
      _nsapCreandoFin();
      showT('La creación está tardando más de lo normal. Revisa si la orden quedó guardada.');
      try{ _refrescarPantalla(); }catch(e){}
    }
  }, 45000);
  var ov=document.getElementById('nsapCreandoOv');
  if(!ov){
    ov=document.createElement('div');
    ov.id='nsapCreandoOv';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:3000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px';
    ov.innerHTML='<div class="ai-ring" style="width:44px;height:44px;border-width:4px"></div>'
      +'<div id="nsapCreandoTxt" style="color:#fff;font-size:14px;font-weight:600;text-align:center;padding:0 20px"></div>'
      +'<div style="color:#ccc;font-size:11.5px">No cierres esta ventana</div>';
    document.body.appendChild(ov);
  }
  var t=document.getElementById('nsapCreandoTxt');
  if(t) t.textContent=txt||'Creando la orden…';
}
function _nsapCreandoFin(){
  if(window._nsapCreandoTimer){ clearTimeout(window._nsapCreandoTimer); window._nsapCreandoTimer=null; }
  var ov=document.getElementById('nsapCreandoOv'); if(ov) ov.remove();
}

function _nsapDraftKey(){ return 'nsap_draft_'+((CU&&CU.id)||'x'); }

function _nsapLeerForm(){
  function v(id){ var e=document.getElementById(id); return e?e.value:''; }
  return {
    dept:v('nsapDept'), prov:v('nsapProv'), cardcode:v('nsapProvCod'),
    ref:v('nsapRef'), po:v('nsapPO'),
    total:v('nsapTotal'), abon:v('nsapAbon'), saldo:v('nsapSaldo'),
    fechaAbono:v('nsapFechaAbono'),
    items:(window._nsapItems||[]),
    guardado_en:new Date().toISOString(),
    guardado_por:(CU&&CU.name)||''
  };
}

function _nsapGuardarDraft(silencioso){
  var d=_nsapLeerForm();
  var vacio=!d.prov && !d.ref && !d.total && !(d.items||[]).length;
  if(vacio){ if(!silencioso) showT('No hay nada que guardar todavía'); return false; }
  window._nsapDraftMem=d;
  try{ localStorage.setItem(_nsapDraftKey(), JSON.stringify(d)); }catch(e){}
  if(!silencioso){
    showT('✓ Borrador guardado. Puedes cerrar y seguir más tarde.');
    var m=document.getElementById('modalNuevaSAP'); if(m) m.remove();
    try{ _refrescarPantalla(); }catch(e){}
  }
  return true;
}

function _nsapLeerDraft(){
  if(window._nsapDraftMem) return window._nsapDraftMem;
  try{
    var s=localStorage.getItem(_nsapDraftKey());
    if(s) return JSON.parse(s);
  }catch(e){}
  return null;
}

function _nsapBorrarDraft(){
  window._nsapDraftMem=null;
  try{ localStorage.removeItem(_nsapDraftKey()); }catch(e){}
}

function _nsapDescartarDraft(){
  if(!confirm('¿Descartar el borrador guardado?\n\nSe perderá lo que tenías escrito.')) return;
  _nsapBorrarDraft();
  var b=document.getElementById('nsapDraftAviso'); if(b) b.remove();
  showT('Borrador descartado');
}

// Vuelca el borrador en el formulario ya dibujado
function _nsapAplicarDraft(d){
  if(!d) return;
  function s(id,val){ var e=document.getElementById(id); if(e && val!=null && val!=='') e.value=val; }
  s('nsapDept',d.dept); s('nsapProv',d.prov); s('nsapProvCod',d.cardcode);
  s('nsapRef',d.ref); s('nsapPO',d.po);
  s('nsapTotal',d.total); s('nsapAbon',d.abon); s('nsapFechaAbono',d.fechaAbono);
  window._nsapItems=(d.items||[]).slice();
  try{ _nsapCalcSaldo(); }catch(e){}
  try{ _nsapRenderItems(); }catch(e){}
  if(d.cardcode) window._nsapCardcode=d.cardcode;
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-device-floppy"></i> Borrador recuperado del '
    +_esc(_fechaHora(d.guardado_en))+'. Los documentos hay que volver a adjuntarlos.</span>';
}

// Aviso arriba del formulario cuando hay un borrador
function _nsapAvisoDraft(){
  var d=_nsapLeerDraft(); if(!d) return '';
  var n=(d.items||[]).length;
  return '<div id="nsapDraftAviso" style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:12px">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:3px"><i class="ti ti-device-floppy"></i> Tienes un borrador sin terminar</div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-bottom:7px">'
      +_esc(d.prov||'(sin proveedor)')+(d.ref?(' · '+_esc(d.ref)):'')+(n?(' · '+n+' producto(s)'):'')
      +' · guardado el '+_esc(_fechaHora(d.guardado_en))+'</div>'
    +'<div style="display:flex;gap:6px">'
      +'<button class="btn bp" style="background:#B45309;padding:5px 11px;font-size:11px" onclick="_nsapAplicarDraft(_nsapLeerDraft())"><i class="ti ti-restore"></i> Continuar</button>'
      +'<button class="btn bg2" style="padding:5px 11px;font-size:11px;color:var(--text-danger)" onclick="_nsapDescartarDraft()"><i class="ti ti-trash"></i> Descartar</button>'
    +'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CÓDIGOS DE ITEM: SIEMPRE EL DE KENNEDY
//  La IA a veces confunde las columnas porque en la PI del proveedor el código
//  de Kennedy viene rotulado "Code" y el del proveedor "Item No.". Por eso no
//  alcanza con pedírselo: aquí se verifica contra el inventario de SAP, que es
//  la única fuente donde viven los códigos KCC de verdad.
// ═══════════════════════════════════════════════════════════════════════════
// ¿Tiene forma de código de Kennedy?
// Los nuestros son numéricos de 5 a 8 dígitos (2313496, 26274) o BA- seguido
// de dígitos (BA-2324041). Los de fábrica mezclan letras y números
// (V-S12Q, V-M96210-SS, B0040MP5L, BBQ4004, W4068) y nunca calzan.
// Los códigos de barra son de 13 dígitos, así que tampoco entran.
function _esCodigoKCC(c){
  var t=String(c||'').trim().toUpperCase().replace(/\s+/g,'');
  if(!t) return false;
  return /^\d{5,8}$/.test(t) || /^BA-?\d{5,8}$/.test(t);
}

async function _nsapResolverCodigos(items){
  items=items||[];
  if(!items.length) return {items:items, verificados:0, corregidos:0, sinKcc:0};

  // Todos los candidatos que trajo la IA
  var cand={};
  items.forEach(function(it){
    [it.itemcode, it.itemcode_kcc, it.itemcode_proveedor].forEach(function(c){
      c=String(c||'').trim(); if(c) cand[c.toUpperCase()]=c;
    });
  });
  var lista=Object.keys(cand);
  if(!lista.length) return {items:items, verificados:0, corregidos:0, sinKcc:0};

  // ¿Cuáles existen en el inventario? Esos son códigos KCC reales.
  // Se pide también la foto: si el artículo ya está en SAP, su foto sale de
  // ahí y no hay que sacarla del Excel del proveedor.
  var enSap={}, infoSap={};
  try{
    for(var i=0;i<lista.length;i+=200){
      var chunk=lista.slice(i,i+200);
      var inList=chunk.map(function(c){ return '"'+cand[c].replace(/"/g,'')+'"'; }).join(',');
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,picturname&itemcode=in.('+encodeURIComponent(inList)+')&limit=400',{headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){
        var k=String(x.itemcode||'').toUpperCase();
        enSap[k]=x.itemcode; infoSap[k]=x;
      });
    }
  }catch(e){ console.warn('verificar codigos KCC:',e); }

  var verificados=0, corregidos=0, sinKcc=0;
  var out=items.map(function(it){
    var kcc=String(it.itemcode_kcc||'').trim();
    var prov=String(it.itemcode_proveedor||'').trim();
    var actual=String(it.itemcode||'').trim();
    var elegido=kcc||actual;

    var kccOk=kcc && enSap[kcc.toUpperCase()];
    var provOk=prov && enSap[prov.toUpperCase()];
    var actualOk=actual && enSap[actual.toUpperCase()];

    // 1) Existe en el inventario: es un código KCC comprobado
    if(kccOk){ elegido=enSap[kcc.toUpperCase()]; verificados++; }
    else if(actualOk && (!kcc || actual.toUpperCase()===kcc.toUpperCase())){ elegido=enSap[actual.toUpperCase()]; verificados++; }
    else if(provOk){
      // El que la IA marcó como del proveedor sí existe en SAP: venían cruzados
      elegido=enSap[prov.toUpperCase()]; verificados++; corregidos++;
    }
    // 2) SKU nuevo que todavía no está en SAP: manda la FORMA del código.
    //    Esto es lo que evita que se cuele un V-S12Q en lugar de BA-2324041.
    else {
      var cands=[kcc, actual, prov].filter(Boolean);
      var conForma=cands.filter(_esCodigoKCC);
      if(conForma.length){
        var nuevoCod=conForma[0];
        if(elegido && nuevoCod.toUpperCase()!==String(elegido).toUpperCase()) corregidos++;
        elegido=nuevoCod;
      } else if(elegido && !_esCodigoKCC(elegido)){
        sinKcc++;   // ninguna columna tiene forma de código nuestro
      }
    }
    var res=Object.assign({}, it, {itemcode:elegido});
    delete res.itemcode_kcc; delete res.itemcode_proveedor;
    // Si el artículo ya existe en SAP se marca. Su foto sale del inventario,
    // PERO solo si esa foto existe de verdad: SAP rellena picturname aunque la
    // imagen no haya llegado al bucket, y entonces el artículo se quedaba sin
    // nada porque además se descartaba la del Excel del proveedor.
    // La comprobación real se hace después, fuera de este map, porque es async.
    var inf=infoSap[String(elegido||'').toUpperCase()];
    if(inf){
      res._enSAP=true;
      if(!res.itemname && inf.itemname) res.itemname=inf.itemname;
      res._picturnameSAP=String(inf.picturname||'').trim();
    }
    return res;
  });

  // Ahora sí: se comprueba cuáles de esas fotos de SAP se pueden ver. Las que
  // no, se dejan sin marcar para que el Excel del proveedor las cubra.
  var _sinFotoReal=0;
  for(var q=0;q<out.length;q++){
    var _pn=out[q]._picturnameSAP;
    delete out[q]._picturnameSAP;
    if(!_pn) continue;
    var _ok=false;
    try{ _ok=await _fotoSapExiste(_pn); }catch(e){ _ok=false; }
    if(_ok){
      var _u=''; try{ _u=_repFotoUrl(_pn)||''; }catch(e){}
      if(_u){ out[q]._foto=_u; out[q]._fotoDeSAP=true; }
    } else {
      _sinFotoReal++;
      _dbg('[nosap] '+out[q].itemcode+': SAP declara "'+_pn
        +'" pero la imagen no está en el bucket. Se usará la del Excel del proveedor.');
    }
  }
  if(_sinFotoReal){
    console.info('[nosap] '+_sinFotoReal+' artículo(s) en SAP sin foto usable: '
      +'las fotos saldrán del Excel del proveedor.');
  }
  return {items:out, verificados:verificados, corregidos:corregidos, sinKcc:sinKcc};
}

// Guarda temporalmente el archivo elegido y dispara la extracción por IA
window._nsapArchivo=null;
function _nsapArchivoElegido(input){
  var f=input.files&&input.files[0]; if(!f) return;
  document.getElementById('nsapFileLbl').textContent=f.name;
  window._nsapArchivo=f;
  _extraerOrdenIA(f);
}
// Extrae los datos de la orden con la IA (Claude) desde el PDF/Excel/imagen
async function _extraerOrdenIA(file){
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Analizando documento con AI…</span>';
  try{
    var contenido, tipo;
    // Cualquier formato: PDF, imagen, Excel, Word o texto
    var _prep=await _iaDesdeBlob(file, file.name);
    contenido=(_prep && _prep.bloques && _prep.bloques.length)
      ? (_prep.bloques.length===1 ? _prep.bloques[0] : _prep.bloques)
      : {type:'text', text:'ARCHIVO '+file.name+': no se pudo leer.'};
    var prompt='Analizá este documento de una orden de compra a proveedor y devolvé SOLO un JSON (sin explicación, sin backticks) con estos campos exactos: {"proveedor": "nombre del proveedor", "num_orden": "número de referencia interno que empieza con DKC- o SKC- (ej DKC-25090)", "po": "número de PO del proveedor (Purchase Order), distinto del DKC/SKC", "total": número, "abonado": número, "saldo": número, "unidades": número, "cartones": número, "items": [{"itemcode": "código de Kennedy Center", "itemname": "descripción", "cantidad": número, "precio_unit": número, "total_linea": número}], "errores": ["..."]}. El num_orden es el código DKC- o SKC-. El po es el número de orden de compra del proveedor. IMPORTANTE sobre itemcode: usá SIEMPRE el CÓDIGO INTERNO DE KENNEDY CENTER, nunca el del proveedor. El de Kennedy aparece en columnas como "KCC ITEM No", "KCC ITEM", "Código KCC", "Item Kennedy", o "Code" en las PI de proveedor, y suele ser numérico de 6-7 dígitos (2313496, 26274) o empezar con BA- (BA-2317969). El del proveedor aparece como "Factory Code", "Item No.", "Supplier Code" o "Vendor Item" y mezcla letras y números (B0040MP5L, BBQ4004, KT251008, W4068): ESOS NO se usan. Si la fila trae los dos, elige siempre el de Kennedy. En "items" incluí TODAS las líneas de producto.\n'
      +'REGLA DE CANTIDADES, MUY IMPORTANTE: la "cantidad" de cada línea va SIEMPRE en PIEZAS, nunca en cartones. Usá la columna de cantidad pedida en piezas (ORDER QTY / Pcs, ORDER QTY, QTY, Qty, Quantity, CANTIDAD, PCS). NO uses nunca QTY X CTN, QTY/CTN, PCS/CTN, No.Ctn, TTL CTNS, CTNS, CARTONS, inner ni similares: esas son piezas por cartón o cantidad de cartones. Ejemplo: si la línea dice ORDER QTY/Pcs = 300, QTY X CTN = 6 y TTL CTNS = 50, la cantidad es 300. Verificá siempre que cantidad x precio_unit dé el total de la línea; si no cuadra, tomaste la columna equivocada. "unidades" es el total de PIEZAS del documento y "cartones" el total de cartones.\n'
      +'REVISIÓN OBLIGATORIA: además de extraer, revisa la aritmética del documento y poné en "errores" CUALQUIER inconsistencia, con los números involucrados: cantidad x precio unitario que no cuadre con el total de la línea; suma de las líneas que no cuadre con el total general; subtotal + impuestos + flete - descuentos que no dé el total; cantidades o precios en cero o negativos; totales repetidos en el documento que no coincidan entre sí; total de piezas o de cartones declarado que no coincida con la suma de las líneas. Describe cada error en una sola frase clara. Si no encontrás errores, devolvé "errores": [].\n'
      +'NUMERO DE ORDEN: "num_orden" va SIEMPRE con su prefijo (DKC-26084), nunca el número solo (26084). El documento a veces lo escribe partido, con "DKC No." en una celda y el número en la de al lado: juntalo.\\n'
      +'DEPOSITO: agregá el campo "deposito_pct". Si los términos de pago indican un porcentaje de depósito o anticipo ("20% Deposit / 80% Balance", "30% anticipo"), devolvé solo ese número (20, 30); si no hay porcentaje, 0. En "abonado" poné un monto solo si el documento dice cuánto se abonó en dinero; si únicamente hay porcentaje, dejá abonado en 0.\\n'
      +'Si un dato no aparece, poné null (para textos) o 0 (para números). Los montos y cantidades como número sin símbolos ni comas de miles. IMPORTANTE: en "itemname" usá una descripción CORTA de máximo 60 caracteres (el nombre del producto, sin medidas ni materiales ni detalles de empaque), para que la respuesta no se corte en documentos con muchas líneas.';
    var msgContent=[contenido, {type:'text', text:prompt}];
    var obj=await _iaJSON(msgContent, 8000, function(n){
      if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Documento largo: la AI sigue leyendo las líneas ('+n+')…</span>';
    });
    if(obj.proveedor) document.getElementById('nsapProv').value=obj.proveedor;
    if(obj.num_orden) document.getElementById('nsapRef').value=_nsapNormRef(obj.num_orden, [obj.po]);
    if(obj.po){ var poEl=document.getElementById('nsapPO'); if(poEl) poEl.value=obj.po; }
    if(obj.total!=null) document.getElementById('nsapTotal').value=obj.total;
    if(obj.abonado!=null) document.getElementById('nsapAbon').value=obj.abonado;
    _nsapCalcSaldo();
    // Igual que en la comparación: si solo hay porcentaje de depósito, se
    // escribe el monto para no dejar el campo en cero.
    window._nsapAbonoDePct=0;
    var _p1=Number(obj.deposito_pct)||0;
    var _a1=document.getElementById('nsapAbon'), _pp1=document.getElementById('nsapAbonPct');
    if(_p1>0 && _p1<=100 && _a1 && !(parseFloat(_a1.value)||0)){
      if(_pp1){ _pp1.value=_p1; _nsapAbonoDesdePct(); }
      else { _a1.value=(Math.round((Number(obj.total)||0)*_p1)/100).toFixed(2); _nsapCalcSaldo(); }
      window._nsapAbonoDePct=_p1;
    }
    if(obj.saldo!=null && !document.getElementById('nsapAbon').value) document.getElementById('nsapSaldo').value=obj.saldo;
    // Guardar los items extraídos y mostrarlos
    window._nsapItems=(Array.isArray(obj.items)?obj.items:[]).map(function(it){
      var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
      var tl=Number(it.total_linea)|| (cant*pu);
      var o={itemcode:String(it.itemcode||'').trim(), itemname:String(it.itemname||'').trim(), cantidad:cant, precio_unit:pu,
        // La ficha técnica, para el catálogo
        descripcion:String(it.descripcion||'').trim(),
        material:String(it.material||'').trim(),
        color:String(it.color||'').trim(),
        tamano:String(it.tamano||'').trim(),
        // El empaque se arma con las piezas por caja y la medida de la caja
        empaque:String(it.empaque||'').trim()
          || [(Number(it.unidades_x_caja)?(_fmtN2(it.unidades_x_caja)+' pzs x caja'):''),
              String(it.carton_size||'').trim()].filter(Boolean).join(' · '),
        carton_size:String(it.carton_size||'').trim(),
        barcode:String(it.barcode||'').trim(),
        marca:String(it.marca||'').trim(),
        unidades_x_caja:Number(it.unidades_x_caja)||0,
        cartones_item:Number(it.cartones_item)||0,
        cbm:Number(it.cbm)||0,
        peso:String(it.peso||'').trim(),
        // El peso del artículo va aparte del peso del bulto: en la proforma
        // vienen como N.W. y G.W., y en SAP son dos campos distintos.
        peso_neto:String(it.peso_neto||it.net_weight||'').trim(),
        total_linea:tl};
      // Y TODO lo demás que se haya escrito en la tabla: los campos de ropa
      // y alfombras, y cualquiera que se añada mañana. Antes la lista era
      // fija, así que se podían rellenar y se perdían al guardar.
      _nsapCamposVivos().forEach(function(c){
        if(o[c.k]!==undefined) return;              // ya está arriba
        var v=it[c.k];
        if(v===undefined || v===null || String(v).trim()==='') return;
        o[c.k]=v;
      });
      if(it._foto) o._foto=it._foto;
      return o;
    }).filter(function(it){ return it.itemcode||it.itemname; });
    _nsapRenderItems();
    var nIt=window._nsapItems.length;

    // Las fotos incrustadas en el Excel del proveedor: se usan después para
    // armar catálogos de mercancía que todavía no está en SAP.
    // Las fotos incrustadas en el Excel: se buscan en TODOS los archivos
    // adjuntos, no solo en uno, y se avisa en pantalla cómo fue.
    _dbg('[nosap] buscando fotos en los adjuntos…');
    try{
      var _cands=[];
      // El archivo puede estar en varios sitios según cómo se abrió el modal
      [window._nsapDocs, window._firmaDocs].forEach(function(st2){
        if(!st2) return;
        if(st2.prov) _cands.push(st2.prov);
        if(st2.kcc)  _cands.push(st2.kcc);
      });
      if(window._nsapArchivo) _cands.push(window._nsapArchivo);
      if(window._firmaArchivo) _cands.push(window._firmaArchivo);
      // Y como último recurso, lo que haya en los campos de archivo
      try{
        document.querySelectorAll('#modalNuevaSAP input[type=file]').forEach(function(inp){
          if(inp.files && inp.files[0]) _cands.push(inp.files[0]);
        });
      }catch(e){}
      // Sin repetidos
      var _vistos={};
      _cands=_cands.filter(function(f){
        if(!f || !f.name) return false;
        var k=f.name+'|'+(f.size||0);
        if(_vistos[k]) return false;
        _vistos[k]=1; return true;
      });
      var _xls=_cands.filter(function(f){ return /\.xlsx$/i.test(f.name||''); });
      _dbg('[nosap] archivos adjuntos:', _cands.map(function(f){return f.name;}),
                  '· con fotos posibles:', _xls.length);
      // JSZip es lo que abre el .xlsx: sin él no hay fotos
      if(_xls.length && typeof JSZip==='undefined'){
        _dbg('[nosap] JSZip no estaba cargado: se carga ahora');
        try{ await _cargarJSZip(); }catch(e){ console.warn('[nosap] JSZip:', e); }
      }

      if(!_xls.length){
        window._nsapFotosPend={};
        if(_cands.length){
          _dbg('[nosap] ningún .xlsx: los .xls, .csv y .pdf no llevan fotos incrustadas');
        }
      } else {
        if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)">'
          +'<span class="ai-ring"></span> Sacando las fotos del Excel…</span>';
        var _mapa={};
        for(var _q=0;_q<_xls.length;_q++){
          try{
            // De paso se completa lo que la IA no sacó: pesos, cubicaje,
          // código de barras… todo lo que la hoja tenga y falte.
          try{ await _nsapCompletarDesdeHoja(_xls[_q]); }catch(e){}
          var _m=await _nsapFotosPorSku(_xls[_q], window._nsapItems);
            Object.keys(_m||{}).forEach(function(k){ if(!_mapa[k]) _mapa[k]=_m[k]; });
          }catch(e){ console.warn('[nosap] '+_xls[_q].name+':', e); }
        }
        window._nsapFotosPend=_mapa;
        var _nf=Object.keys(_mapa).length;
        if(_nf){
          window._nsapItems.forEach(function(it){
            var k=String(it.itemcode||'').trim().toUpperCase();
            if(_mapa[k]) it._foto='data:'+_mapa[k].mime+';base64,'+_mapa[k].b64;
          });
          _nsapRenderItems();
        }
        // El detalle de por qué salió así, para no quedarse a ciegas
        var _diag=window._nsapFotosDiag||{};
        window._nsapFotosMsg = _nf
          ? ('<span style="color:var(--text-success)"><i class="ti ti-photo-check"></i> '
             +_nf+' de '+window._nsapItems.length+' artículo(s) con foto</span>')
          : ('<span style="color:var(--t-ambar)"><i class="ti ti-photo-off"></i> '
             +'No se pudo sacar ninguna foto · '
             +(_diag.imagenes===0 ? 'el Excel no trae imágenes'
              : (!_diag.jszip ? 'no se pudo abrir el archivo (JSZip)'
              : (_diag.ubicados===0 ? 'no se encontraron los códigos en la hoja'
              : 'las imágenes están fuera de la tabla de artículos')))
             +'</span>');
        _dbg('[nosap] fotos:', _nf+'/'+window._nsapItems.length, _diag);
      }
    }catch(e){
      console.warn('[nosap] fotos del Excel:', e);
      window._nsapFotosMsg='<span style="color:var(--t-ambar)">No se pudieron leer las fotos: '
        +String(e.message||e).slice(0,60)+'</span>';
    }
    // Identificar el proveedor contra SAP con lo que extrajo la AI
    try{ await _nsapBuscarProvSAP(true); }catch(e){}
    // Revisión de cantidades y montos (AI + recálculo propio)
    var calc=_nsapRevisarNumeros(window._nsapItems, obj.total, obj.unidades, obj.cartones);
    var nProb=_nsapPintarRevision(obj.errores, calc);
    window._nsapProblemas=nProb;
    var col=nProb?'#dc2626':(window._iaJSONReparado?'#B45309':'var(--text-success)');
    var ico=nProb?'alert-triangle':(window._iaJSONReparado?'alert-circle':'circle-check');
    // El resultado de las fotos, junto al de la revisión
    var _fmsg=window._nsapFotosMsg||'';
    var msg=nProb
      ? ('Datos extraídos ('+nIt+' productos), pero hay '+nProb+' problema(s) en los números.')
      : ('Datos extraídos'+(nIt?(' ('+nIt+' productos)'):'')+'. '+(window._iaJSONReparado?'El documento es muy largo y la lista pudo quedar incompleta: verificá que estén todas las líneas.':'Revisa y ajustá si hace falta.'));
    if(st) st.innerHTML='<span style="color:'+col+'"><i class="ti ti-'+ico+'"></i> '+msg+'</span>'
      +(_fmsg?('<div style="margin-top:4px;font-size:11px">'+_fmsg+'</div>'):'');
  }catch(e){
    if(st) st.innerHTML='<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> No se pudo extraer automáticamente ('+(e.message||e)+'). Completá los campos a mano.</span>';
  }
}
function _fileB64(file){
  return new Promise(function(res,rej){
    var r=new FileReader();
    r.onload=function(){ res(String(r.result).split(',')[1]); };
    r.onerror=rej;
    r.readAsDataURL(file);
  });
}
// ═══════════════════════════════════════════════════════════════════════════
//  EDITAR UNA ORDEN NO SAP
//  El N° DKC NO cambia nunca: es la llave con la que la orden queda amarrada a
//  la orden firmada. Sí se pueden cambiar proveedor, PO, departamento, montos y
//  productos (si el proveedor no puede fabricar algo o se decide no comprarlo).
//  El motivo del cambio es obligatorio y queda en el historial de la orden.
// ═══════════════════════════════════════════════════════════════════════════
function _pendSAPBuscar(ref){
  return (window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref); });
}
function _pendSAPItems(p){
  var items=p&&p.items;
  if(typeof items==='string'){ try{ items=JSON.parse(items); }catch(e){ items=[]; } }
  return Array.isArray(items)?items:[];
}
function _pendSAPEdiciones(p){
  var e=p&&p.ediciones;
  if(typeof e==='string'){ try{ e=JSON.parse(e); }catch(_){ e=[]; } }
  return Array.isArray(e)?e:[];
}
// Sello visual de "orden editada"
function _pendSAPBadgeEditada(p){
  if(!p||!p.editada) return '';
  var n=_pendSAPEdiciones(p).length;
  return '<span class="ord-editada" title="Orden editada'+(n?(' \u00b7 '+n+' cambio(s)'):'')+'">'
       + '<i class="ti ti-pencil"></i> editada'+(n>1?(' \u00d7'+n):'')+'</span>';
}

function abrirEditarOrdenSinSAP(ref){
  var p=_pendSAPBuscar(ref);
  if(!p){ showT('Orden no encontrada'); return; }
  var itemsAct=_pendSAPItems(p);
  // Copia de trabajo: si cancela, la orden original queda intacta
  window._nsapItems=itemsAct.map(function(it){ return Object.assign({}, it); });
  window._nsapEditRef=String(p.dkc||p.num_orden);
  window._nsapEditAntes={
    proveedor:p.proveedor||'', po:p.po||'', dept:p.dept||'',
    total:Number(p.total)||0, abonado:Number(p.abonado)||0,
    saldo:Number(p.saldo!=null?p.saldo:((p.total||0)-(p.abonado||0))),
    n_items:itemsAct.length
  };

  var ov=document.createElement('div');
  ov.id='modalEditarSAP';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1003;display:flex;align-items:center;justify-content:center;padding:16px';
  var opts='<option value="">Departamento…</option>'+DEPTS_ALL.map(function(d){
    return '<option value="'+d+'"'+((p.dept===d)?' selected':'')+'>'+(EMOJIS2[d]||'')+' '+dL(d)+'</option>';
  }).join('');

  var h='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:480px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
    +'<div style="font-size:15px;font-weight:600"><i class="ti ti-pencil" style="color:var(--t-ambar)"></i> Editar orden sin SAP</div>'
    +'<button onclick="document.getElementById(\'modalEditarSAP\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';

  h+='<div style="background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:10px 12px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
    +'<i class="ti ti-info-circle"></i> El <b>N° DKC no cambia</b>. Puedes ajustar proveedor, montos y productos: quita los items que el proveedor no puede fabricar o los que se decidió no comprar.</div>';

  h+='<div style="display:flex;flex-direction:column;gap:9px">';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de orden (DKC) — no editable</label>'
    +'<input id="nsapRef" value="'+_esc(p.dkc||p.num_orden||'')+'" readonly style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1);color:var(--text-muted);font-weight:700"></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Departamento *</label><select id="nsapDept" onchange="_nsapRenderItems()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)">'+opts+'</select></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Proveedor *</label><input id="nsapProv" value="'+_esc(p.proveedor||'')+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de PO del proveedor</label><input id="nsapPO" value="'+_esc(p.po||'')+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="display:flex;gap:8px">';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Total *</label><input id="nsapTotal" type="number" step="0.01" value="'+(Number(p.total)||0)+'" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Por Abonar</label><input id="nsapAbon" type="number" step="0.01" value="'+(Number(p.abonado)||0)+'" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Fecha abono</label><input id="nsapFechaAbono" type="date" value="'+_esc(p.fecha_abono||'')+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Saldo</label><input id="nsapSaldo" type="number" step="0.01" value="'+((Number(p.total)||0)-(Number(p.abonado)||0)).toFixed(2)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)" readonly></div>';
  h+='</div></div>';

  // Productos (mismos ids que el alta, para reusar _nsapRenderItems y compañía)
  h+='<div style="margin-top:14px;border-top:0.5px solid var(--border);padding-top:12px">';
  h+='<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px">'
    +'<label style="font-size:12px;font-weight:600;color:var(--t-ambar)"><i class="ti ti-list-details"></i> Productos de la orden *</label>'
    +'<button onclick="_nsapAddItemManual()" style="font-size:11px;padding:3px 8px;border:0.5px solid #B45309;background:var(--pastel-aviso);color:var(--t-ambar);border-radius:6px;cursor:pointer"><i class="ti ti-plus"></i> Agregar producto</button>'
  +'</div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-bottom:6px">Usa la × para quitar un producto que ya no se va a comprar.</div>';
  h+='<div id="nsapItemsBox"></div>';
  h+='</div>';

  // Motivo obligatorio
  h+='<div style="margin-top:14px;border-top:0.5px solid var(--border);padding-top:12px">';
  h+='<label style="font-size:12px;font-weight:600;color:var(--text-danger)"><i class="ti ti-alert-circle"></i> Motivo del cambio *</label>';
  h+='<textarea id="nsapMotivo" rows="3" placeholder="Ej: el proveedor no puede fabricar el item KCC-1024; se retira de la orden." style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:5px;background:var(--surface-2);color:var(--text-primary);resize:vertical"></textarea>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:3px">Obligatorio. Queda guardado en el historial de la orden.</div>';
  h+='</div>';

  // Historial de cambios anteriores
  var eds=_pendSAPEdiciones(p);
  if(eds.length){
    h+='<div style="margin-top:12px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden">';
    h+='<div style="background:var(--surface-2);padding:6px 11px;font-size:11px;font-weight:600"><i class="ti ti-history"></i> Cambios anteriores ('+eds.length+')</div>';
    eds.slice().reverse().forEach(function(e){
      h+='<div style="padding:7px 11px;border-top:0.5px solid var(--border);font-size:11px">'
        +'<div style="color:var(--text-muted)">'+_esc(e.fecha||'')+' · '+_esc(e.por||'')+'</div>'
        +'<div style="margin-top:2px">'+_esc(e.motivo||'')+'</div></div>';
    });
    h+='</div>';
  }

  h+='<div style="display:flex;gap:8px;margin-top:16px">';
  h+='<button onclick="document.getElementById(\'modalEditarSAP\').remove()" class="btn bg2" style="flex:1;padding:11px">Cancelar</button>';
  h+='<button onclick="guardarEdicionOrdenSinSAP()" style="flex:2;background:#B45309;color:white;border:none;border-radius:8px;padding:11px;cursor:pointer;font-size:13px;font-weight:600"><i class="ti ti-device-floppy"></i> Guardar cambios</button>';
  h+='</div>';
  h+='</div>';

  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
  document.body.appendChild(ov);
  _nsapRenderItems();
}

async function guardarEdicionOrdenSinSAP(){
  var ref=window._nsapEditRef;
  var p=_pendSAPBuscar(ref);
  if(!p){ showT('Orden no encontrada'); return; }

  var motivo=(document.getElementById('nsapMotivo').value||'').trim();
  if(motivo.length<5){ showT('Escribe el motivo del cambio (obligatorio)'); 
    var mt=document.getElementById('nsapMotivo'); if(mt) mt.focus(); return; }

  var dept=document.getElementById('nsapDept').value;
  var prov=document.getElementById('nsapProv').value.trim();
  var po=(document.getElementById('nsapPO')?document.getElementById('nsapPO').value.trim():'');
  var total=parseFloat(document.getElementById('nsapTotal').value)||0;
  var abon=parseFloat(document.getElementById('nsapAbon').value)||0;
  var saldo=parseFloat(document.getElementById('nsapSaldo').value);
  if(isNaN(saldo)) saldo=total-abon;
  if(!dept){ showT('Seleccioná el departamento'); return; }
  if(!prov){ showT('Falta el proveedor'); return; }
  if(!total||total<=0){ showT('Falta el total'); return; }
  var itemsOrden=(window._nsapItems||[]).filter(function(it){ return (it.itemcode||it.itemname)&&Number(it.cantidad)>0; });
  if(!itemsOrden.length){ showT('La orden debe quedar con al menos 1 producto'); return; }
  if(!_nsapSkusCompletos(itemsOrden)) return;

  var antes=window._nsapEditAntes||{};
  var registro={
    fecha:(typeof now2==='function'?now2():new Date().toLocaleString('es')),
    por:(CU?CU.name:''), rol:(CU?CU.role:''),
    motivo:motivo,
    antes:antes,
    despues:{ proveedor:prov, po:po, dept:dept, total:total, abonado:abon, saldo:saldo, n_items:itemsOrden.length }
  };
  var eds=_pendSAPEdiciones(p); eds.push(registro);

  // El DKC se conserva tal cual: es la llave del amarre
  p.dept=dept; p.proveedor=prov; p.po=po;
  p.total=total; p.abonado=abon; p.saldo=saldo;
  p.fecha_abono=(document.getElementById('nsapFechaAbono')||{}).value||null;
  p.items=itemsOrden;
  p.ediciones=eds;
  p.editada=true;
  p.editado_en=new Date().toISOString();
  p.editado_por=(CU?CU.name:'');
  p.motivo_edicion=motivo;

  await guardarPendSAP(ref);
  try{ addNotif('gerencia','✏️ Orden '+ref+' editada por '+(CU?CU.name:'')+' — '+motivo, '', 'ti-pencil'); }catch(e){}

  var m=document.getElementById('modalEditarSAP'); if(m) m.remove();
  // Refrescar el detalle si estaba abierto detrás
  document.querySelectorAll('div[style*="fixed"]').forEach(function(el){
    if(el.querySelector && el.querySelector('#pendsap-items-'+ref)) el.remove();
  });
  showT('✓ Orden actualizada — cambio registrado');
  renderNP();
  _refrescarPantalla();
  setTimeout(function(){ abrirPendSAP(ref); }, 250);
}

/* Si algo falla aquí dentro, antes no pasaba NADA: el error moría en la
   consola y el botón parecía estropeado. Ahora se ve en pantalla. */
async function guardarNuevaOrdenSinSAP(){
  try{
    return await _guardarNuevaOrdenSinSAP();
  }catch(e){
    console.error('[NSAP] crear orden:', e);
    alert('No pude crear la orden.\n\n'+((e&&e.message)?e.message:String(e))
      +'\n\nNada se ha guardado. Si vuelve a pasar, mándame esta pantalla.');
  }
}

async function _guardarNuevaOrdenSinSAP(){
  var dept=String((document.getElementById('nsapDept')||{}).value||'');
  var prov=document.getElementById('nsapProv').value.trim();
  var ref=String((document.getElementById('nsapRef')||{}).value||'').trim();
  var po=(document.getElementById('nsapPO')?document.getElementById('nsapPO').value.trim():'');
  var total=parseFloat(document.getElementById('nsapTotal').value)||0;
  // 100% contra copia de B/L: no hay abono, el saldo es el total
  var contraBL=!!((document.getElementById('nsapContraBL')||{}).checked);
  var numRepo=String(((document.getElementById('nsapNumRepo')||{}).value)||'').trim().toUpperCase();
  var abon=contraBL?0:(parseFloat((document.getElementById('nsapAbon')||{}).value)||0);
  var saldo=contraBL?total:(parseFloat(document.getElementById('nsapSaldo').value)||(total-abon));
  if(!dept){ showT('Seleccioná el departamento'); return; }
  if(!prov){ showT('Falta el proveedor'); return; }
  // El proveedor tiene que estar resuelto: o es uno de SAP, o se confirmó que
  // es nuevo. Así no se duplica un proveedor por un error de escritura.
  if(!window._nsapCardcode && !window._nsapProvNuevoOK){
    var _cod=await _nsapBuscarProvSAP(true);
    if(!_cod && !window._nsapProvNuevoOK){
      showT('Revisa el proveedor: elige el de SAP o confirmá que es nuevo');
      var _pi=document.getElementById('nsapProv'); if(_pi) _pi.focus();
      return;
    }
  }
  if(!ref){ showT('Falta el número de orden'); return; }
  if(!total||total<=0){ showT('Falta el total'); return; }
  var itemsOrden=(window._nsapItems||[]).filter(function(it){return (it.itemcode||it.itemname)&&it.cantidad>0;});
  if(!itemsOrden.length){ showT('Agrega al menos 1 producto con cantidad'); return; }
  if(!_nsapSkusCompletos(itemsOrden)) return;
  if((window._pendSAP||[]).some(function(p){return String(p.num_orden||p.dkc).toUpperCase()===ref.toUpperCase();})){ showT('Ya existe una orden con esa referencia'); return; }
  if((orders||[]).some(function(o){return String(o.num_proveedor||'').toUpperCase()===ref.toUpperCase();})){ showT('Esa orden ya existe en SAP'); return; }
  // Revisión final de números antes de crear
  var _rev=_nsapRevisarNumeros(itemsOrden, total);
  if(_rev.errores.length){
    if(!confirm('La revisión encontró '+_rev.errores.length+' problema(s) en los números:\n\n· '
        +_rev.errores.slice(0,6).join('\n· ')
        +(_rev.errores.length>6?('\n· … y '+(_rev.errores.length-6)+' más'):'')
        +'\n\n¿Crear la orden de todas formas?')) return;
  }
  var fecha=(typeof dateOnly==='function'?dateOnly():new Date().toISOString().slice(0,10));
  var fAbono=(document.getElementById('nsapFechaAbono')||{}).value||null;
  // Aviso de progreso: crear la orden toca varias tablas y sube archivos
  _nsapCreando('Creando la orden…');
  // Registro de diferencias contra la reposición. Se calcula SIEMPRE que la
  // orden venga de una reposición, se haya pulsado el botón de comparar o no:
  // es lo que después ve gerencia para saber en qué se apartó la orden de lo
  // que se había pedido.
  var difRepo=null;
  if(numRepo){
    try{
      var _lineas=await _nsapLineasRepo(numRepo);
      if(_lineas){
        difRepo=_nsapCalcularDif(_lineas, itemsOrden);
        difRepo.num=numRepo;
        difRepo.dkc=ref;
        difRepo.fecha=new Date().toLocaleString('es');
        difRepo.por=(CU&&CU.name)||'';
        difRepo.texto=_nsapDifTexto(difRepo);
      } else {
        console.warn('[orden BORRADOR] no se encontró la reposición '+numRepo);
      }
    }catch(e){ console.warn('[orden BORRADOR] diferencias:', e); }
  }

  if(contraBL) fAbono=null;
  var reg=Object.assign({}, {dkc:ref, num_orden:ref, po:po, dept:dept, proveedor:prov, cardcode:(window._nsapCardcode||''), total:total, fecha_abono:fAbono, abonado:abon, saldo:saldo, by:(CU?CU.name:''), fecha:fecha, creado_en:fecha, items:itemsOrden, pago_contra_bl:contraBL, num_reposicion:numRepo||null,
    dif_reposicion:difRepo?JSON.stringify(difRepo):null});
  window._pendSAP.push(reg);
  // Se adjuntan los DOS documentos: nuestra orden y la PI del proveedor
  var _docs=[];
  if(window._nsapDocs && window._nsapDocs.kcc)  _docs.push(window._nsapDocs.kcc);
  if(window._nsapDocs && window._nsapDocs.prov) _docs.push(window._nsapDocs.prov);
  if(window._nsapDocs && window._nsapDocs.pedido) _docs.push(window._nsapDocs.pedido);
  if(!_docs.length && window._nsapArchivo) _docs.push(window._nsapArchivo);
  // Cada archivo se sube UNA SOLA VEZ al almacenamiento. Después se referencia
  // en las etapas que lo necesitan, sin volver a subirlo ni volver a
  // registrarlo: antes se subea dos veces y se veía duplicado.
  window._nsapDocsSubidos=[];
  for(var _di=0; _di<_docs.length; _di++){
    _nsapCreando('Subiendo documento '+(_di+1)+' de '+_docs.length+'…');
    try{
      var _pth=await _subirDocStorage(ref, 'pedido', _docs[_di]);
      if(_pth){
        var _reg=await _registrarDoc(ref, 'pedido', _docs[_di], _pth);
        var _doc={ id:_reg?_reg.id:undefined, name:_docs[_di].name,
                   data: DOCS_BASE + _pth.split('/').map(encodeURIComponent).join('/'),
                   url:_pth, date:now2(), by:(CU?CU.name:''), remoto:true };
        window._nsapDocsSubidos.push(_doc);
        if(!window._atts) window._atts={};
        // La ficha de adjuntos de la orden y la etapa Pedido apuntan al MISMO archivo
        [ref+'__pendsap', ref+'pedido'].forEach(function(kk){
          if(!window._atts[kk]) window._atts[kk]=[];
          if(!window._atts[kk].some(function(a){ return a.url===_doc.url; })) window._atts[kk].push(_doc);
        });
      }
    }catch(e){ console.warn('subir doc:',e); }
  }
  if(_docs.length){
    try{
      var _attsK=window._atts&&window._atts[ref+'__pendsap'];
      if(_attsK&&_attsK.length){reg.adjunto_url=_attsK[0].data||_attsK[0].url||null;reg.adjunto_name=_attsK[0].name||null;}
    }catch(e){}
  }
  window._nsapArchivo=null;
  window._nsapDocs={prov:null, kcc:null, pedido:null};
  _nsapCreando('Guardando la orden…');
  await guardarPendSAP(ref);
  var modal=document.getElementById('modalNuevaSAP'); if(modal) modal.remove();
  _nsapCreando('Preparando las etapas…');
  try{ _nsapBorrarDraft(); }catch(e){}
  // Ya viene firmada por gerencia: la etapa Pedido queda completa
  try{ await _nsapMarcarPedidoHecho(ref); }catch(e){ console.warn('pedido hecho:',e); }
  // Sin abono: los pasos del depósito quedan hechos y el seguimiento espera
  // en la solicitud del balance final
  // Si viene de una reposición, esa reposición queda como orden aprobada y
  // firmada: en el seguimiento pasa a verde y se sabe que ya está cerrada.
  if(numRepo){
    try{
      var _ok=await _repMarcarOrdenCreada(numRepo, ref);
      if(_ok) showT('Reposición '+numRepo+' marcada como orden aprobada y firmada');
      else console.warn('[reposición] no se encontró '+numRepo+' para marcarla');
    }catch(e){ console.warn('[reposición] marcar:', e); }
    var _drop=(window._pendSapDrop||[]);
    if(difRepo && _drop.indexOf('dif_reposicion')>=0){
      // Se calculó y se mostró, pero no se pudo guardar. Se muestra la
      // respuesta literal del servidor, que es lo único que dice la causa.
      alert('La orden SÍ se guardó, pero el detalle de diferencias no.\n\n'
        +'Le faltan estas columnas a compras_pend_sap:\n  '
        +(window._pendSapDrop||[]).join(', ')
        +'\n\nCorré el script compras_pend_sap_columnas.sql en Supabase.\n\n'
        +'Respuesta del servidor:\n'+(window._pendSapError||'(sin detalle)'));
    } else if(difRepo && !difRepo.cuadra){
      showT('Ojo: la orden se apartó de la reposición '+numRepo+' · '
        +difRepo.faltan.length+' sin pedir, '+difRepo.agregados.length+' agregados, '
        +difRepo.distintos.length+' con otra cantidad. Queda registrado en la orden.', 8000);
    }
  }
  if(contraBL){
    try{
      await _nsapMarcarSinAbono(ref);
      showT('Sin abono · 100% contra copia de B/L: el depósito queda cerrado y '
        +'la orden espera en la solicitud del balance final', 6500);
    }catch(e){ console.warn('sin abono:',e); }
  }
  // Proveedor y SKUs que todavía no existen en SAP: se guardan como fichas
  // temporales para poder trabajarlos mientras SAP los da de alta.
  // OJO: esto va ANTES de cerrar la rueda. Antes se cerraba aquí y este bloque
  // la volvía a abrir sin cerrarla nunca, así que se quedaba girando.
  try{
    _nsapCreando('Registrando proveedor y SKU nuevos…');
    if(!(window._catNoSap||[]).length) await _catNoSapCargar(true);
    var nuevo=await _catNoSapRegistrarDeOrden(reg);
    _catNoSapBadge();   // el numerito se actualiza de inmediato
    if(nuevo.error){
      showT('⚠ No se registró en Proveedores y SKU BORRADOR: '+nuevo.error);
    } else if(nuevo.proveedor || nuevo.items){
      var partes=[];
      if(nuevo.proveedor) partes.push('proveedor nuevo');
      if(nuevo.items) partes.push(nuevo.items+' SKU nuevo(s)');
      showT('Registrado en BORRADOR: '+partes.join(' y '));
      _catNoSapBadge();
      // La pantalla se refresca en el momento: antes había que salir y
      // volver a entrar para ver el proveedor recién creado.
      try{ if(PG==='catnosap') rCatNoSap(); }catch(e){ console.warn('refrescar BORRADOR:',e); }
      // Si se registró el proveedor pero ningún artículo, se explica por qué:
      // quedarse con un proveedor vacío sin motivo desconcierta.
      if(nuevo.proveedor && !nuevo.items && nuevo.omitidos){
        setTimeout(function(){
          showT('Ningún SKU se agregó · '+(nuevo.motivo||''), 7000);
        }, 2600);
      }
    } else if(nuevo.omitidos){
      showT('No se registró ningún SKU · '+(nuevo.motivo||''), 7000);
    }
  }catch(e){ console.warn('catalogo no sap:',e); }
  finally{
    // Pase lo que pase, la rueda se cierra y la pantalla se refresca
    _nsapCreandoFin();
    try{ _refrescarPantalla(); }catch(e){ console.warn('refrescar:',e); }
    // Un ganchito grande en vez del mensajito de la esquina, que se pierde
    try{
      var _ref=(window._nsapOrdenCreada||{}).ref||'';
      var _n=(window._nsapItems||[]).length;
      _okGrande('Orden BORRADOR creada',
        (_ref?('<b>'+_esc(_ref)+'</b><br>'):'')
        + _n+' artículo(s) · pendiente de abono<br>'
        +'<span style="font-size:11.5px;color:var(--text-muted)">Ya puedes '
        +'subirla a SAP cuando esté lista, con el botón SUBIR A SAP.</span>');
    }catch(e){ showT('✓ Orden BORRADOR creada — pendiente de abono'); }
  }
}
// Adjunta un archivo a la orden usando el sistema real de documentos
// (sube a Storage + registra en compras_documentos) para que PERSISTA.
async function _adjuntarArchivoPendSAP(ref, file){
  var k=ref+'__pendsap';
  if(!window._atts) window._atts={};
  if(!window._atts[k]) window._atts[k]=[];
  try{
    var path=await _subirDocStorage(ref, '__pendsap', file);
    if(path){
      var reg=await _registrarDoc(ref, '__pendsap', file, path);
      window._atts[k].push({
        id: reg?reg.id:undefined,
        name:file.name,
        data: DOCS_BASE + path.split('/').map(encodeURIComponent).join('/'),
        url:path, date:now2(), by:(CU?CU.name:''), remoto:true
      });
    }
  }catch(e){ console.error('_adjuntarArchivoPendSAP:', e); }
}
// Revisar una orden ya creada con IA (busca errores/detalles en sus adjuntos)
async function revisarPendSAPIA(ref){
  var p=(window._pendSAP||[]).find(function(x){return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref);});
  var atts=(window._atts&&window._atts[ref+'__pendsap'])?window._atts[ref+'__pendsap']:[];
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1003;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:26px;max-width:460px;width:100%;text-align:center">'
    +'<div class="ai-ring" style="width:34px;height:34px;border-width:4px;margin:0 auto 12px"></div>'
    +'<div style="font-size:13px;font-weight:600;color:var(--t-lila)">AI revisando la orden '+ref+'…</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:4px">Puede tardar unos segundos según el tamaño del documento.</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    if(!atts.length){ throw new Error('Esta orden no tiene documento adjunto para revisar.'); }
    var a=atts[0];
    var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
    var contenido;
    // Obtener base64 del adjunto: si es remoto (URL), descargarlo; si es local, ya viene en data:...
    var b64, arrBuf;
    if(a.remoto || /^https?:/.test(a.data)){
      var rf=await fetch(a.data);
      arrBuf=await rf.arrayBuffer();
      var bytes=new Uint8Array(arrBuf), bin=''; for(var bi=0;bi<bytes.length;bi++)bin+=String.fromCharCode(bytes[bi]);
      b64=btoa(bin);
    } else {
      b64=a.data.split(',')[1];
    }
    // Cualquier formato, con el mismo criterio que el resto del portal
    var _bin=atob(b64), _u8=new Uint8Array(_bin.length);
    for(var _i=0;_i<_bin.length;_i++) _u8[_i]=_bin.charCodeAt(_i);
    var _blob=new Blob([_u8], {type:(a.mime||'')});
    var _prep=await _iaDesdeBlob(_blob, a.name||('archivo.'+ext));
    if(!_prep || !_prep.bloques || !_prep.bloques.length) throw new Error('No se pudo leer el archivo para revisar.');
    contenido=(_prep.bloques.length===1)?_prep.bloques[0]:_prep.bloques;
    var datosActuales='Datos cargados: proveedor='+(p&&p.proveedor||'?')+', num_orden='+(p&&(p.num_orden||p.dkc)||'?')+', total='+(p&&p.total||0)+', abonado='+(p&&p.abonado||0)+', saldo='+(p&&p.saldo||0)+'.';
    var prompt='Sos un revisor de órdenes de compra. '+datosActuales+' Revisa el documento adjunto y decime en español, en pocas líneas: 1) si los datos cargados coinciden con el documento, 2) cualquier error, inconsistencia o dato faltante que veas (montos que no cuadran, saldo mal calculado, etc). Sé breve y claro.';
    var msgContent=[contenido, {type:'text', text:prompt}];
    var resp=await fetch('https://api.anthropic.com/v1/messages',{
      method:'POST',
      headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
      body:JSON.stringify({model:IA_MODELO, max_tokens:600, messages:[{role:'user', content:msgContent}]})
    });
    // Se lee como TEXTO y luego se interpreta. Al revés no funciona: json()
  // consume el cuerpo, y si falla, el text() posterior devuelve vacío y no
  // hay forma de ver qué llegó. Por eso el aviso no decía nada útil.
  var data, crudoTxt='';
  try{
    crudoTxt=await resp.text();
    data=JSON.parse(crudoTxt);
  }catch(errJ){
    // Sin esto, una respuesta que no sea JSON hace saltar el error con los
    // bytes crudos dentro y en pantalla sale "Unexpected token '\uFFFD'".
    var crudo=crudoTxt;
    console.error('[IA] estado '+resp.status
      +' · tipo: '+((resp.headers&&resp.headers.get&&resp.headers.get('content-type'))||'?')
      +' · '+String(crudo||'').length+' caracteres recibidos');
    console.error('[IA] primeros 300: '
      +String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,300));
    console.error('[IA] error original: '+((errJ&&errJ.message)||errJ));
    throw new Error(
      resp.status===413 ? 'El documento es demasiado grande para la IA. '
                         +'Súbelo en Excel o CSV, o divídelo.'
    : resp.status===401 ? 'La clave de la IA no es válida o caducó.'
    : resp.status===429 ? 'La IA está saturada. Prueba dentro de un minuto.'
    : resp.status>=500  ? 'La IA no respondió bien (error '+resp.status+').'
    : (resp.status===200
        ? ('La IA respondió, pero el navegador no pudo leer la respuesta. '
           +'Suele ser una extensión del navegador o un antivirus que se '
           +'interponen. Prueba en una ventana de incógnito. En la consola '
           +'queda el detalle de lo que llegó.')
        : 'La IA devolvió una respuesta ilegible (estado '+resp.status+').'));
  }
    if(data.error){ throw new Error(data.error.message||'Error de IA'); }
    var txt=(data.content||[]).map(function(c){return c.text||'';}).join('').trim();
    var h='<div class="ia-informe" data-imp-titulo="Revisión AI — '+_esc(String(ref))+'" style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:480px;width:100%;max-height:88vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px"><div style="font-size:14px;font-weight:600;color:var(--t-lila)"><i class="ti ti-sparkles"></i> Revisión AI — '+ref+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
    h+='<div style="font-size:13px;line-height:1.6;color:var(--text-primary);white-space:pre-wrap">'+txt.replace(/</g,'&lt;')+'</div>';
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:420px"><div style="font-size:13px;color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}
// Ver/editar una orden sin SAP con sus adjuntos y chat (modal reutilizando buildPendItem)
function abrirPendSAP(ref){
  window._pendSAPDeptAbierto=null;
  var p=(window._pendSAP||[]).find(function(x){return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref);});
  if(!p){ showT('Orden no encontrada'); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1002;display:flex;align-items:center;justify-content:center;padding:16px';
  var h='<div style="background:var(--surface-0);border-radius:12px;padding:0;max-width:520px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;padding:16px 18px;border-bottom:0.5px solid var(--border)"><div style="font-size:15px;font-weight:600">'+(p.proveedor||'')+' — '+(p.num_orden||p.dkc)+' '+_pendSAPBadgeEditada(p)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
  h+='<div class="pend-detalle">'+buildPendItemDetalle(p)+'</div>';
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  // Cargar las fotos de los items desde el inventario (por itemcode)
  _pendSAPCargarFotos(p);
  // Y traer de la base los documentos de la orden: los shipping marks y todo
  // lo enviado por correo se guardan ahí, y sin esto no aparecen hasta que
  // algo más los cargue.
  (async function(){
    try{
      await cargarDocsOrden(String(p.dkc||p.num_orden));
      if(!document.body.contains(ov)) return;
      var cont=ov.querySelector('.pend-detalle');
      if(cont) cont.innerHTML=buildPendItemDetalle(p);
    }catch(e){ console.warn('[orden] documentos:', e); }
  })();
}
// Busca en inventario las fotos de los items de la orden y las coloca en cada línea
async function _pendSAPCargarFotos(p){
  var items=p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
  items=(items||[]).filter(function(it){return it.itemcode;});
  if(!items.length) return;
  var codes=items.map(function(it){return String(it.itemcode);});
  try{
    // Consultar el inventario por esos itemcodes (in.())
    var inList=codes.map(function(c){return '"'+c.replace(/"/g,'')+'"';}).join(',');
    var r=await fetch(SB+'/rest/v1/inventario?itemcode=in.('+encodeURIComponent(inList)+')&select=itemcode,picturname&limit=1000',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    var mp={};
    (Array.isArray(rows)?rows:[]).forEach(function(x){ mp[String(x.itemcode)]=x.picturname||''; });
    // Colocar cada foto en su línea
    var cont=document.getElementById('pendsap-items-'+p.dkc);
    if(!cont) return;
    cont.querySelectorAll('.pendsap-item-linea').forEach(function(linea){
      var ic=linea.getAttribute('data-ic');
      var pn=mp[ic];
      var cont2=linea.querySelector('.pendsap-item-foto');
      // Solo las que siguen sin foto: si el artículo ya traía la suya, no se
      // pisa con la de SAP.
      if(cont2 && cont2.querySelector('img')) return;
      if(pn&&cont2){
        var url=_repFotoUrl(pn);
        cont2.style.cursor='zoom-in';
        cont2.onclick=function(){ _repZoomFoto(encodeURIComponent(url), ic); };
        cont2.innerHTML='<img src="'+url+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted);font-size:14px&quot;></i>\'">';
      }
    });
  }catch(e){}
}
// Junta los adjuntos de una orden estén en la clave que estén (documentos de
// la orden, de cada etapa, shipping marks…), poniéndole a cada uno de dónde
// viene para no perder el contexto.
function _attsTodosDeOrden(ref){
  ref=String(ref||''); if(!ref) return [];
  // Si esta orden NO SAP ya tiene su gemela en SAP, lo que se guardó allí
  // (los shipping marks, por ejemplo) también le pertenece.
  var refs=[ref];
  try{
    var p=(window._pendSAP||[]).find(function(x){
      return String(x.dkc)===ref || String(x.num_orden)===ref; });
    if(p){
      var o=_ordenSapDeNoSap(p);
      if(o && String(o.id)!==ref) refs.push(String(o.id));
    }
  }catch(e){}
  var etiquetas={ '__pendsap':'', 'pedido':'Pedido', 'shipping_mark':'Shipping marks',
                  'artes':'Artes', 'produccion':'Producción', 'logistica':'Logística',
                  'aduanizacion':'Aduanización', 'bodega':'Bodega' };
  var out=[];
  Object.keys(window._atts||{}).forEach(function(k){
    var base=refs.find(function(r){ return k.indexOf(r)===0; });
    if(!base) return;
    var suf=k.slice(base.length);
    var et=etiquetas[suf];
    if(et===undefined){                       // deposito_step1, artes_step2…
      et=suf.replace(/_step(\d+)/, ' · paso ').replace(/^_+/,'');
      et=et.charAt(0).toUpperCase()+et.slice(1);
    }
    ((window._atts[k])||[]).forEach(function(a){
      if(a && _docHref(a)) out.push(Object.assign({}, a, {_de:et}));
    });
  });
  try{ return _dedupDocs(out); }catch(e){ return out; }
}

function buildPendItemDetalle(p){
  // Clave segura de la orden (sin dkc no debe reventar el render)
  var _k=String(p.dkc||p.num_orden||'').replace(/'/g,'');
  // TODOS los adjuntos de la orden, no solo los de la clave '__pendsap'.
  // Los shipping marks y lo que se mande por correo se guardan en su propia
  // clave, y mirando una sola quedaban invisibles.
  var atts=_attsTodosDeOrden(p.dkc||p.num_orden);
  var h='<div style="padding:14px 18px">';
  // Datos de cabecera
  h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:12px;font-size:12px">';
  h+='<span>Proveedor: <strong>'+_esc(p.proveedor||'-')+'</strong></span>';
  h+='<span>Orden: <strong>'+_esc(p.num_orden||p.dkc)+'</strong></span>';
  if(p.po)h+='<span>PO: <strong>'+_esc(p.po)+'</strong></span>';
  if(p.dept)h+='<span>Depto: <strong>'+dL(p.dept)+'</strong></span>';
  h+='</div>';
  h+='<div style="margin-bottom:12px;display:flex;gap:7px;flex-wrap:wrap">'
    +((CU&&(CU.role==='gerencia'||_esCompras()))?('<button class="btn bg2" style="font-size:11px;padding:6px 12px" title="Deja una sola copia de cada documento" onclick="_limpiarDocsDuplicados(\''+_esc(String(p.dkc||p.num_orden))+'\').then(function(){ abrirPendSAP(\''+_esc(String(p.dkc||p.num_orden))+'\'); })"><i class="ti ti-copy-off"></i> Quitar archivos duplicados</button>'):'')
    
    +'<button class="btn bp" style="font-size:11px;padding:6px 12px" onclick="this.closest(\'div[style*=fixed]\').remove();abrirDetalleNoSap(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-list-check"></i> Abrir etapas de la orden</button>'
    +((CU&&CU.role==='contabilidad')?'':('<button class="btn bp" style="background:#B45309;font-size:11px;padding:6px 12px" onclick="abrirEditarOrdenSinSAP(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-pencil"></i> Editar orden</button>'))
    +(_esGerencia()?('<button class="btn bp" style="background:var(--text-danger);font-size:11px;padding:6px 12px" onclick="this.closest(\'div[style*=fixed]\').remove();_gerBorrarOrdenNoSap(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-trash"></i> Borrar orden completa</button>'):'')
    +((CU&&CU.role==='contabilidad')?'':('<button class="btn bp" style="background:#166534;font-size:11px;padding:6px 12px" onclick="marcarEnSAP(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-database-import"></i> Ya está en SAP (quitar de Borrador y Firma)</button>'))
  +'</div>';
  // Historial de ediciones
  var _eds=_pendSAPEdiciones(p);
  if(_eds.length){
    h+='<div style="border:0.5px solid #E9C08A;background:var(--pastel-aviso);border-radius:8px;overflow:hidden;margin-bottom:12px">';
    h+='<div style="padding:7px 12px;font-size:11.5px;font-weight:700;color:var(--t-marron)"><i class="ti ti-history"></i> Historial de cambios ('+_eds.length+')</div>';
    _eds.slice().reverse().forEach(function(e){
      var a=e.antes||{}, d=e.despues||{};
      var cambios=[];
      if(a.proveedor!==d.proveedor) cambios.push('proveedor: '+_esc(a.proveedor||'-')+' → '+_esc(d.proveedor||'-'));
      if(Number(a.total)!==Number(d.total)) cambios.push('total: '+fmt(a.total||0)+' → '+fmt(d.total||0));
      if(Number(a.abonado)!==Number(d.abonado)) cambios.push('abonado: '+fmt(a.abonado||0)+' → '+fmt(d.abonado||0));
      if(Number(a.n_items)!==Number(d.n_items)) cambios.push('productos: '+(a.n_items||0)+' → '+(d.n_items||0));
      h+='<div style="padding:8px 12px;border-top:0.5px solid #E9C08A;font-size:11.5px">'
        +'<div style="color:var(--text-muted);font-size:10.5px">'+_esc(e.fecha||'')+' &middot; '+_esc(e.por||'')+'</div>'
        +'<div style="margin-top:2px;font-weight:600">'+_esc(e.motivo||'')+'</div>'
        +(cambios.length?('<div style="margin-top:3px;color:var(--text-secondary);font-size:10.5px">'+cambios.join(' &middot; ')+'</div>'):'')
      +'</div>';
    });
    h+='</div>';
  }
  if(CU.verCostos){
    h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:12px;font-size:12px">';
    h+='<span>Total: <strong style="color:var(--t-ambar)">'+fmt(p.total||0)+'</strong></span>';
    h+='<span>Abonado: <strong style="color:var(--text-success)">'+fmt(p.abonado||0)+'</strong></span>';
    h+='<span>Saldo: <strong style="color:var(--text-danger)">'+fmt((p.saldo!=null?p.saldo:(p.total||0)-(p.abonado||0)))+'</strong></span>';
    h+='<span style="flex:1"></span>';
    h+=_ocBotonSubirNoSap(String(p.dkc||p.num_orden));
    h+='</div>';
  } else {
    // Sin ver costos no hay fila de saldos, pero el botón tiene que estar
    h+='<div style="display:flex;justify-content:flex-end;margin-bottom:12px">'
      +_ocBotonSubirNoSap(String(p.dkc||p.num_orden))+'</div>';
  }
  // ── Detalle de items (con fotos, cantidades y precios) ──
  var items=p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
  items=items||[];
  if(items.length){
    h+='<div style="border:0.5px solid var(--border);border-radius:8px;overflow:hidden;margin-bottom:12px">';
    h+='<div style="background:var(--surface-2);padding:7px 12px;font-size:12px;font-weight:600;border-bottom:0.5px solid var(--border)"><i class="ti ti-list-details"></i> Productos ('+items.length+')</div>';
    h+='<div id="pendsap-items-'+p.dkc+'">';
    items.forEach(function(it){
      var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
      var tl=Number(it.total_linea)||(cant*pu);
      h+='<div class="pendsap-item-linea" data-ic="'+_esc(String(it.itemcode||''))+'" style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-bottom:0.5px solid var(--border)">'
        // La foto que el artículo ya trae encima: la incrustada del Excel del
        // proveedor o la del catálogo NO SAP. Se pinta de una vez, sin esperar
        // a la consulta al inventario, porque estos artículos todavía no están
        // en SAP y allí no hay nada que encontrar.
        +'<div class="pendsap-item-foto" style="width:44px;height:44px;flex-shrink:0;'
          +'border:0.5px solid var(--border);border-radius:6px;overflow:hidden;'
          +'background:var(--surface-2);display:flex;align-items:center;justify-content:center'
          +(_pendSAPFotoDe(it)?';cursor:zoom-in':'')+'"'
          +(_pendSAPFotoDe(it)?(' onclick="_repZoomFoto(\''+encodeURIComponent(_pendSAPFotoDe(it))
              +'\',\''+_esc(String(it.itemcode||''))+'\')"'):'')+'>'
          +(_pendSAPFotoDe(it)
            ? '<img src="'+_esc(_pendSAPFotoDe(it))+'" style="width:100%;height:100%;'
              +'object-fit:cover" onerror="_costFotoAlt(this,&quot;&quot;)">'
            : '<i class="ti ti-photo" style="color:var(--text-muted);font-size:14px"></i>')
          +'</div>'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(it.itemcode||'-')+'</div>'
          +'<div style="font-size:11px;color:var(--text-secondary);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(it.itemname||'')+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0">'
          +'<div style="font-size:13px;font-weight:700">'+cant+' <span style="font-size:10px;color:var(--text-muted);font-weight:400">und</span></div>'
          +(CU.verCostos&&pu?'<div style="font-size:10px;color:var(--text-muted)">@'+_fmtN2(pu)+' = '+_fmtN2(tl)+'</div>':'')
        +'</div>'
      +'</div>';
    });
    h+='</div></div>';
  } else {
    h+='<div style="font-size:11px;color:var(--text-muted);background:var(--surface-1);border:0.5px solid var(--border);border-radius:6px;padding:8px;margin-bottom:12px"><i class="ti ti-info-circle"></i> Esta orden no tiene detalle de productos guardado.</div>';
  }
  if(atts.length){
    h+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:9px">';
    atts.forEach(function(a,ai){
      var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
      if(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0){
        // Los guardados en el almacenamiento traen url; los subidos a mano, data
        var _src=a.data||a.url||'';
        h+='<div style="position:relative;display:inline-block;margin:2px" title="'+_esc(a.name||'')+(a._de?(' \u00b7 '+a._de):'')+'"><img src="'+_src+'" data-src="'+_src+'" data-ai="'+ai+'" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-img" style="width:52px;height:52px;object-fit:cover;border-radius:5px;cursor:zoom-in;border:0.5px solid var(--border)">'
          +(a._de?'':'<button data-ai="'+ai+'" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-del" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:white;border:none;border-radius:50%;width:17px;height:17px;font-size:10px;cursor:pointer;line-height:17px;padding:0;text-align:center">\u00d7</button>')
          +'</div>';
      } else {
        var ic=ext==='pdf'?'\ud83d\udcc4':ext==='xlsx'||ext==='xls'?'\ud83d\udcca':'\ud83d\udcce';
        var _u=a.data||a.url||'';
        var abrir=_u?(' onclick="verArchivo(\''+_u+'\',\''+(a.name||'').replace(/\'/g,"\\'")+'\')" '):'';
        h+='<div title="'+_esc(a.name||'')+'" style="display:inline-flex;align-items:center;gap:5px;padding:3px 8px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:var(--radius);font-size:11px;margin:2px;cursor:pointer"'+abrir+'>'+ic
          +' <span style="max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+a.name+'</span>'
          +(a._de?('<span style="font-size:9px;background:#EEF2FF;color:var(--t-indigo2);border-radius:6px;padding:0 5px;font-weight:700">'+_esc(a._de)+'</span>')
                 :('<button data-ai="'+ai+'" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-del" style="background:none;border:none;color:var(--text-danger);cursor:pointer;padding:0;font-size:13px;line-height:1">\u00d7</button>'))
          +'</div>';
      }
    });
    h+='</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:7px;padding:6px 10px;border:1.5px dashed var(--border);border-radius:var(--radius);cursor:pointer;font-size:11px;color:var(--text-secondary);background:var(--surface-1);margin-bottom:6px"><i class="ti ti-upload" style="font-size:12px;color:var(--t-ambar)"></i>Adjuntar documento<input type="file" multiple accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" style="display:none" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-input"></label>';
  h+='<button onclick="event.stopPropagation();revisarPendSAPIA(\''+_k+'\')" style="background:var(--pastel-lila);color:var(--t-lila);border:none;border-radius:6px;padding:6px 11px;cursor:pointer;font-size:11px;font-weight:600;margin-bottom:10px"><i class="ti ti-sparkles"></i> AI revisar detalles y errores</button>';
  // Live chat
  var chatKey='pendsap_'+p.dkc;
  h+='<div style="margin-top:6px"><div style="font-size:10px;color:var(--text-muted);font-weight:500;margin-bottom:4px"><i class="ti ti-message"></i> Live chat de esta orden</div>';
  h+='<div id="pendsap-cms-'+p.dkc+'" style="margin-bottom:6px">'+renderSubComs(chatKey)+'</div>';
  h+='<div class="cir"><textarea class="cin" id="pendsap-cin-'+p.dkc+'" rows="1" placeholder="Escribe en el chat..." style="font-size:11px"></textarea>';
  h+='<button class="btn bp" onclick="addPendSAPCom(\''+_k+'\')" style="align-self:flex-end;padding:5px 8px"><i class="ti ti-send"></i></button></div></div>';
  h+='</div>';
  return h;
}

function agregarPendSAP(){ abrirNuevaOrdenSinSAP(); }  // compatibilidad
// Resumen GENERAL de órdenes sin SAP (todas) para la cabecera de la sección Departamentos.
// Muestra total, abonado, saldo de las sin SAP, y el GRAN TOTAL (SAP + sin SAP).

// Genera filas <tr> de No SAP para integrar en la tabla de departamentos
function _nsapDeptoRows(dept){
  var lista=pendSAPporDept(dept);
  if(!lista.length)return'';
  var rows='';
  lista.forEach(function(p){
    // Clave segura de la orden (sin dkc no debe reventar el render)
    var _k=String(p.dkc||p.num_orden||'').replace(/'/g,'');
    var ref=p.num_orden||p.dkc||'?';
    var tot=Number(p.total)||0,abn=Number(p.abonado)||0,sal=Number(p.saldo!=null?p.saldo:tot-abn);
    var _ak=p.dkc+'__pendsap';
    var _al=window._atts&&window._atts[_ak]?window._atts[_ak]:[];
    if(!_al.length&&p.adjunto_url)_al=[{name:p.adjunto_name||'adj',data:p.adjunto_url}];
    var adjCell='';
    if(_al.length){var a=_al[0];var url=a.data||a.url||'';var ext=(a.name||'').split('.').pop().toLowerCase();
      if(['jpg','jpeg','png','webp'].includes(ext))adjCell='<img src="'+url+'" data-src="'+url+'" class="att-img" style="height:24px;width:24px;object-fit:cover;border-radius:4px;cursor:zoom-in;border:0.5px solid var(--border);vertical-align:middle;margin-left:4px" title="'+a.name+'">';
      else adjCell='<a href="'+url+'" target="_blank" onclick="event.stopPropagation()" style="font-size:9px;margin-left:4px;color:var(--text-accent)"><i class="ti ti-paperclip" style="font-size:10px"></i>'+a.name+'</a>';}
    rows+='<tr style="border-bottom:0.5px solid var(--border);background:var(--pastel-aviso)">'
      +'<td style="padding:7px 12px;font-size:12px;font-weight:500;white-space:nowrap;vertical-align:middle">'
      +'<span style="font-size:9px;background:var(--pastel-naranja);color:var(--t-ambar);border-radius:4px;padding:1px 5px;margin-right:4px;font-weight:700">BORRADOR</span>'
      +(p.proveedor||'?')+_pendSAPBadgeEditada(p)+adjCell+'</td>'
      +'<td style="padding:7px 12px;vertical-align:middle">'
      +'<span data-abrir="'+_k+'" class="nsap-abrir-btn" style="display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:6px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;cursor:pointer;font-size:10px;color:var(--t-ambar)">'
      +'<i class="ti ti-file-invoice" style="font-size:10px"></i> '+ref+'</span>'
      +'<span data-ia="'+_k+'" class="nsap-ia-btn" style="display:inline-flex;align-items:center;gap:3px;padding:2px 6px;border-radius:6px;background:var(--pastel-lila);border:0.5px solid #c4b5fd;cursor:pointer;font-size:10px;margin-left:4px;color:var(--t-lila)">'
      +'<i class="ti ti-sparkles" style="font-size:9px"></i> IA</span>'
      +'</td>'
      +(CU.verCostos
        ?'<td style="padding:7px 12px;font-size:11px;text-align:right;white-space:nowrap;color:var(--t-ambar);font-weight:600">'+fmt(tot)+'</td>'
         +'<td style="padding:7px 12px;font-size:11px;text-align:right;white-space:nowrap;color:var(--text-success)">'+fmt(abn)+'</td>'
         +'<td style="padding:7px 12px;font-size:11px;text-align:right;white-space:nowrap;color:var(--text-danger)">'+fmt(sal)+'</td>'
        :'')
      +'</tr>';
  });
  return rows;
}
function _resumenGeneralSinSAP(gTotSap, gAbnSap){
  if(!CU.verCostos) return '';
  var lista=pendientesSAPVisibles();
  if(!lista.length && !(Number(gTotSap)>0)) return '';
  var nsapTot=totalPendSAP(), nsapAbn=totalAbonPendSAP(), nsapSaldo=nsapTot-nsapAbn;
  var granTot=(Number(gTotSap)||0)+nsapTot;
  var granAbn=(Number(gAbnSap)||0)+nsapAbn;
  var h='<div style="background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:0.5px solid #C4B5FD;border-radius:10px;padding:12px 14px;margin-bottom:14px">';
  h+='<div style="display:flex;align-items:center;gap:6px;margin-bottom:8px"><i class="ti ti-clock-pause" style="color:var(--t-lila2);font-size:16px"></i><span style="font-size:13px;font-weight:600;color:var(--t-lila2)">Órdenes sin SAP — resumen general</span><span style="font-size:11px;color:#7C3AED;margin-left:auto">'+lista.length+' orden'+(lista.length!==1?'es':'')+'</span></div>';
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(90px,1fr));gap:8px">';
  h+='<div style="background:var(--surface-2);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#7C3AED;text-transform:uppercase">Total sin SAP</div><div style="font-size:15px;font-weight:700;color:var(--t-lila2)">'+fmt(nsapTot)+'</div></div>';
  h+='<div style="background:var(--surface-2);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#639922;text-transform:uppercase">Abonado</div><div style="font-size:15px;font-weight:700;color:#639922">'+fmt(nsapAbn)+'</div></div>';
  h+='<div style="background:var(--surface-2);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#e24b4a;text-transform:uppercase">Saldo</div><div style="font-size:15px;font-weight:700;color:#e24b4a">'+fmt(nsapSaldo)+'</div></div>';
  h+='</div>';
  // Gran total
  h+='<div style="margin-top:10px;padding-top:10px;border-top:0.5px dashed #C4B5FD;display:grid;grid-template-columns:repeat(auto-fit,minmax(90px,1fr));gap:8px">';
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:var(--text-muted);text-transform:uppercase">Gran total</div><div style="font-size:16px;font-weight:800;color:var(--text-accent)">'+fmt(granTot)+'</div></div>';
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#639922;text-transform:uppercase">Abonado total</div><div style="font-size:15px;font-weight:700;color:#639922">'+fmt(granAbn)+'</div></div>';
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#e24b4a;text-transform:uppercase">Saldo total</div><div style="font-size:15px;font-weight:700;color:#e24b4a">'+fmt(granTot-granAbn)+'</div></div>';
  h+='</div>';
  h+='<div style="font-size:9px;color:var(--text-muted);margin-top:6px;text-align:center">Gran total = órdenes en SAP + órdenes sin SAP</div>';
  h+='</div>';
  return h;
}
// Casilla "Órdenes sin SAP" para la tarjeta de departamento en el dashboard.
// Muestra cantidad, total, abonado, saldo, promedio de días, y el gran total (SAP + sin SAP).
// Color elegante distinto (violeta suave).
function _dashDeptSinSAP(dept, totSap, abnSap){
  var lista=pendSAPporDept(dept);
  var nsapTot=lista.reduce(function(s,p){return s+(Number(p.total)||0);},0);
  var nsapAbn=lista.reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
  var nsapSaldo=nsapTot-nsapAbn;
  var diasProm=lista.length?Math.round(lista.reduce(function(s,p){return s+_diasPendSAP(p);},0)/lista.length):0;
  var granTot=(Number(totSap)||0)+nsapTot;
  var granAbn=(Number(abnSap)||0)+nsapAbn;
  var h='<div style="margin-top:9px;padding:8px 10px;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:0.5px solid #C4B5FD;border-radius:8px">';
  h+='<div style="display:flex;align-items:center;gap:5px;margin-bottom:5px"><i class="ti ti-clock-pause" style="font-size:12px;color:var(--t-lila2)"></i><span style="font-size:11px;font-weight:600;color:var(--t-lila2)">Órdenes sin SAP</span><span style="font-size:10px;color:#7C3AED;margin-left:auto">'+lista.length+' orden'+(lista.length!==1?'es':'')+'</span></div>';
  if(CU.verCostos){
    h+='<div class="sem-row"><span class="sem-label" style="color:var(--t-lila2)">Total</span><span class="sem-val" style="color:var(--t-lila2);font-weight:600">'+fmt(nsapTot)+'</span></div>';
    h+='<div class="sem-row"><span class="sem-label" style="color:#639922">Abonado</span><span class="sem-val" style="color:#639922">'+fmt(nsapAbn)+'</span></div>';
    h+='<div class="sem-row"><span class="sem-label" style="color:#e24b4a">Saldo</span><span class="sem-val" style="color:#e24b4a">'+fmt(nsapSaldo)+'</span></div>';
  }
  h+='<div style="font-size:10px;color:#7C3AED;margin-top:2px"><i class="ti ti-clock" style="font-size:9px"></i> Promedio: '+diasProm+' días sin SAP</div>';
  // Gran total (SAP + sin SAP)
  if(CU.verCostos){
    h+='<div style="margin-top:7px;padding-top:6px;border-top:0.5px dashed #C4B5FD">';
    h+='<div class="sem-row"><span class="sem-label" style="font-weight:700">GRAN TOTAL</span><span class="sem-val" style="font-weight:700;color:var(--text-accent)">'+fmt(granTot)+'</span></div>';
    h+='<div class="sem-row"><span class="sem-label" style="color:#639922;font-size:10px">Abonado total</span><span class="sem-val" style="color:#639922;font-size:11px">'+fmt(granAbn)+'</span></div>';
    h+='<div style="font-size:9px;color:var(--text-muted);margin-top:1px">SAP + sin SAP</div>';
    h+='</div>';
  }
  h+='</div>';
  return h;
}
// Abre el adjunto (PDF/imagen/Excel) de una orden sin SAP en vista previa.
function abrirAdjuntoPendSAP(ref){
  var atts=(window._atts&&window._atts[ref+'__pendsap'])?window._atts[ref+'__pendsap']:[];
  if(!atts.length){ showT('Esta orden no tiene adjunto. Abrí "Ver / adjuntos" para agregar uno.'); abrirPendSAP(ref); return; }
  var a=atts[0]; // el primero (el documento de la orden)
  if(typeof verArchivo==='function'){ verArchivo(a.data, a.name); }
  else { window.open(a.data, '_blank'); }
}
// Sync global: recarga todos los datos desde Supabase y redibuja la pantalla actual.
async function hacerSyncGlobal(){
  var icon=document.getElementById('syncIcon');
  var btn=document.getElementById('btnSync');
  if(icon) icon.style.animation='spin 1s linear infinite';
  if(btn){ btn.style.opacity='.7'; btn.disabled=true; }
  try{
    await cargarDatosReales();
    var ahora=new Date();
    var f=ahora.toLocaleDateString('es',{day:'2-digit',month:'2-digit',year:'numeric'});
    var h=ahora.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'});
    window._ultimoSync=f+' '+h;
    try{ localStorage.setItem('kcc_ultimoSync', window._ultimoSync); }catch(e){}
    var st=document.getElementById('syncTime'); if(st) st.textContent=window._ultimoSync;
    // Redibujar la pantalla actual
    if(PG==='dashboard') rDash();
    else if(PG==='deptos') rDeptos();
    else if(PG==='ordenes') rOrdenes(dO);
    else if(PG==='completadas') rCompletadas(dComp);
    else if(PG==='pendientes') rPendientes(dP);
    else if(PG==='contab') rContab(dC);
    else if(PG==='mistarea') rMiTarea(dMT);
    else if(PG==='alertas') rAlertas();
    else if(PG==='nueva') _firmaRefrescarLista();
    showT('✓ Actualizado');
  }catch(e){
    showT('Error al sincronizar');
    console.error('sync global:', e);
  }finally{
    if(icon) icon.style.animation='';
    if(btn){ btn.style.opacity='1'; btn.disabled=false; }
  }
}
// ═══════════════════════════════════════════════════════════════════════════
//  REFRESCO AUTOMÁTICO DE LA PANTALLA
//  Se llama después de crear, editar o borrar cualquier orden No SAP para que
//  el cambio se vea al instante, sin tener que pulsar Sync. Repinta la página
//  activa y, además, las secciones de No SAP que viven fuera de ella.
// ═══════════════════════════════════════════════════════════════════════════
function _refrescarPantalla(){
  try{
    if(PG==='ordenes' && typeof refreshSearchResults==='function') refreshSearchResults();
    else if(PG==='deptos' && typeof rDeptos==='function') rDeptos();
    else if(PG==='contab' && typeof rContab==='function') rContab();
    else if(PG==='completadas' && typeof rCompletadas==='function') rCompletadas();
    else if(PG==='pendientes' && typeof rPendientes==='function') rPendientes();
    else if(PG==='alertas' && typeof rAlertas==='function') rAlertas();
    // v745: en «Compras para firma» se vuelve a leer la lista (antes se
    // repintaba el inicio y la pestaña seguía diciendo «Falta crear la orden
    // BORRADOR» hasta salir y volver a entrar)
    else if(PG==='nueva') _firmaRefrescarLista();
    else if(typeof rDash==='function') rDash();
  }catch(e){ console.warn('refrescar pagina:',e); }
  try{ if(typeof _renderNoSap==='function') _renderNoSap(); }catch(e){}
  try{ if(typeof renderNP==='function') renderNP(); }catch(e){}
  try{ if(typeof _firmaActualizarBadge==='function') _firmaActualizarBadge(); }catch(e){}
}

function eliminarPendSAP(ref){
  // Gerencia borra la orden con todo lo que cuelga de ella
  if(_esGerencia()) return _gerBorrarOrdenNoSap(ref);
  if(!confirm('¿Está seguro de que desea borrar esta orden BORRADOR?\n\nEsta acción no se puede deshacer.')) return;
  window._pendSAP=(window._pendSAP||[]).filter(function(p){return String(p.dkc)!==String(ref)&&String(p.num_orden)!==String(ref);});
  borrarPendSAP(ref);
  _refrescarPantalla();
  showT('Orden eliminada');
}
async function marcarEnSAP(ref){
  if(!confirm('¿Confirmas que esta orden YA está registrada en SAP?\n\nSe eliminará de "Órdenes Borrador" y de "Compras para firmar". Quedará solo como una orden normal de SAP.')) return;
  var refN=String(ref||'').trim().toUpperCase();
  try{
    try{ await fetch(SB+'/rest/v1/compras_pend_sap?dkc=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }catch(e){}
    try{ await fetch(SB+'/rest/v1/compras_pend_sap?num_orden=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }catch(e){}
    try{ await fetch(SB+'/rest/v1/ordenes_firma?dkc=eq.'+encodeURIComponent(refN),{method:'DELETE',headers:SBH}); }catch(e){}
    window._pendSAP=(window._pendSAP||[]).filter(function(pp){return String(pp.dkc||'').trim().toUpperCase()!==refN && String(pp.num_orden||'').trim().toUpperCase()!==refN;});
    var mm=document.querySelector('div[style*=fixed]'); if(mm && mm.querySelector && mm.querySelector('.ti-database-import')) mm.remove();
    // El avance de las etapas se conserva bajo el número de orden de SAP
    try{ await _migrarEtapasNoSap(); }catch(e){ console.warn('migrar etapas:',e); }
    showT('✓ Orden marcada como registrada en SAP — se conservó el avance de las etapas');
    if(PG==='ordenes') rOrdenes(); else _refrescarPantalla();
    if(typeof _firmaCargarLista==='function'){ try{ _firmaCargarLista((CU&&CU.role==='gerencia')?'gerencia':'compras'); }catch(e){} }
  }catch(e){ showT('Error: '+(e.message||e)); }
}
// Live chat de una orden sin SAP
function addPendSAPCom(ref){
  var comKey='pendsap_'+ref;
  var inp=document.getElementById('pendsap-cin-'+ref);
  var txt=inp?inp.value.trim():'';
  if(!txt)return;
  if(!window._subComs) window._subComs={};
  if(!window._subComs[comKey])window._subComs[comKey]=[];
  window._subComs[comKey].push({autor:CU.name+' ('+CU.role+')',ini:CU.ini,texto:txt,time:now2(),role:CU.role,by:CU.name});
  guardarComentario(ref, comKey, txt);
  if(inp)inp.value='';
  var lista=document.getElementById('pendsap-cms-'+ref);
  if(lista) lista.innerHTML=renderSubComs(comKey);
  if(inp) inp.focus();
}
async function guardarPendSAP(ref){
  try{
    var p=(window._pendSAP||[]).find(function(x){return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref);});
    if(!p)return;
    var base={ dkc:String(p.dkc), num_orden:p.num_orden||p.dkc, po:p.po||null, dept:p.dept||null, proveedor:p.proveedor||null, total:p.total||0, abonado:p.abonado||0, saldo:p.saldo||0, agregado_por:p.by||'', fecha:p.fecha||'', creado_en:p.creado_en||new Date().toISOString()  /* la fecha de ALTA, no la de la proforma: con p.fecha una orden creada hoy con proforma de junio se guardaba como de junio y quedaba enterrada en el listado */, actualizado_en:new Date().toISOString(), items:p.items||[] };
    // Columnas del control de ediciones. Si la tabla todavía no las tiene, se
    // reintenta sin ellas para no perder el guardado.
    var full=Object.assign({}, base, {
      fecha_abono: p.fecha_abono||null,
      editada: !!p.editada,
      editado_en: p.editado_en||null,
      editado_por: p.editado_por||null,
      motivo_edicion: p.motivo_edicion||null,
      ediciones: p.ediciones||[]
    });
    async function _post(body){
      return fetch(SB+'/rest/v1/compras_pend_sap?on_conflict=dkc', {
        method:'POST',
        headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
        body: JSON.stringify(body)
      });
    }
    // Se intenta guardar con todo. Si alguna columna nueva no existe todavía
    // en la tabla, se va soltando de a UNA para no perder las demás: antes un
    // solo campo que faltara tiraba abajo los otros dos sin decir nada, y el
    // registro de diferencias se perdía en silencio.
    window._pendSapDrop=[];
    window._pendSapError='';
    // El registro va como objeto, no como texto: la columna es jsonb.
    var _dif=p.dif_reposicion||null;
    if(typeof _dif==='string'){ try{ _dif=JSON.parse(_dif); }catch(e){} }

    // Se intenta guardar TODO. Si la tabla no tiene alguna columna, PostgREST
    // dice cuál: se quita ESA y se reintenta. Antes se iban soltando campos a
    // ciegas y una columna que faltaba (ediciones) hacía perder otras que sí
    // existían, como el registro de diferencias.
    var cuerpo=Object.assign({}, full, {
      pago_contra_bl: !!p.pago_contra_bl,
      num_reposicion: p.num_reposicion||null,
      dif_reposicion: _dif,
      // Venta directa: el pedido del cliente y la comprobación de los tres
      venta_directa: !!p.venta_directa,
      pedido_venta: p.pedido_venta||null,
      comprobacion_vd: p.comprobacion_vd||null
    });
    var OBLIGATORIAS=['dkc','num_orden','items','total'];   // sin esto no hay orden
    var r=null;
    for(var intento=0; intento<8; intento++){
      r=await _post(cuerpo);
      if(r.ok) break;
      var txt='';
      try{ txt=await r.clone().text(); }catch(e){}
      window._pendSapError='HTTP '+r.status+' — '+String(txt).slice(0,400);
      // "Could not find the 'X' column of 'tabla' in the schema cache"
      var m=String(txt).match(/find the '([^']+)' column/i)
         || String(txt).match(/column "?([a-z0-9_]+)"? of relation/i);
      var col=m?m[1]:null;
      if(!col || OBLIGATORIAS.indexOf(col)>=0 || !(col in cuerpo)){
        console.warn('[orden BORRADOR] no se pudo guardar y no puedo identificar la columna:',
                     window._pendSapError);
        break;
      }
      console.warn('[orden BORRADOR] la tabla no tiene la columna "'+col+'": se guarda sin ella');
      window._pendSapDrop.push(col);
      delete cuerpo[col];
    }

    if(window._pendSapDrop.length){
      console.warn('[orden BORRADOR] columnas que no existen en compras_pend_sap:',
                   window._pendSapDrop.join(', '));
      // Lo que no se pudo guardar tampoco se deja en memoria: si no,
      // "desaparece" en el siguiente Sync y nadie entiende por qué.
      window._pendSapDrop.forEach(function(c){ if(c in p) p[c]=null; });
    }
  }catch(e){ console.error('guardarPendSAP:', e); }
}
async function borrarPendSAP(ref){
  try{
    await fetch(SB+'/rest/v1/compras_pend_sap?dkc=eq.'+encodeURIComponent(ref), {method:'DELETE', headers:SBH});
  }catch(e){ console.error('borrarPendSAP:', e); }
}
// Todas las columnas MENOS "items". Esa lleva dentro todas las líneas de
// la orden y es la que pesa: con ella, 16 órdenes tardaban 17 segundos y la
// respuesta llegaba a 6 MB. Para LISTAR las órdenes no hace falta ninguna
// línea, así que se piden aparte y en segundo plano.
var _NSAP_COLS = ['dkc','num_orden','po','dept','proveedor','cardcode',
  'total','abonado','saldo','agregado_por','fecha','creado_en','fecha_abono',
  'editada','editado_en','editado_por','motivo_edicion','num_reposicion',
  'dif_reposicion','pago_contra_bl'].join(',');

// Las líneas de cada orden, después y sin bloquear. Se piden solo cuando
// hacen falta de verdad.
async function _nsapCargarItems(){
  var pend=(window._pendSAP||[]).filter(function(o){ return !o.__items; });
  if(!pend.length) return 0;
  var puestos=0;
  for(var i=0;i<pend.length;i+=10){
    var grupo=pend.slice(i,i+10);
    var lista=grupo.map(function(o){ return '"'+String(o.dkc).replace(/"/g,'')+'"'; }).join(',');
    try{
      var r=await fetch(SB+'/rest/v1/compras_pend_sap?select=dkc,items'
        +'&dkc=in.('+encodeURIComponent(lista)+')', {headers:SBH});
      if(!r.ok) continue;
      var filas=await r.json()||[];
      filas.forEach(function(f){
        var o=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(f.dkc); });
        if(o){ o.items=f.items||[]; o.__items=1; puestos++; }
      });
    }catch(e){ console.warn('[BORRADOR] líneas:', e); }
  }
  if(puestos){
    _dbg('[BORRADOR] líneas de '+puestos+' orden(es) cargadas');
    try{ _refrescarPantalla(); }catch(e){}
  }
  return puestos;
}

async function cargarPendSAP(){
  try{
    // POR TANDAS. Pedirlo todo de un golpe daba una respuesta de casi 6 MB
    // —cada orden lleva dentro TODAS sus líneas en la columna items— que
    // llegaba cortada: "Unterminated string in JSON", 100 segundos, y la
    // lista vacía. En tandas de 25 cada respuesta es manejable.
    var rows=[], desde=0, tanda=25, vueltas=0;
    while(vueltas<200){
      vueltas++;
      // Sin la columna items. Es la que pesa: lleva TODAS las líneas de la
      // orden y hacía que 16 órdenes tardaran 17 segundos. Para listarlas no
      // hace falta ninguna, así que se piden aparte y en segundo plano.
      var r=await fetch(SB+'/rest/v1/compras_pend_sap?select='+_NSAP_COLS
        +'&order=creado_en.desc&limit='+tanda+'&offset='+desde, {headers:SBH});
      if(!r.ok){
        var _t=''; try{ _t=await r.text(); }catch(e){}
        console.error('[BORRADOR] no se pudieron cargar: '+r.status+' · '+_t.slice(0,160));
        // Si ya se leyó algo, se usa lo que hay en vez de perderlo todo
        if(rows.length){ _dbg('[BORRADOR] se usan las '+rows.length+' ya leídas'); break; }
        window._pendSAPError='No se pudo cargar la lista (error '+r.status+')';
        throw new Error('http '+r.status);
      }
      var lote;
      try{
        lote=await r.json();
      }catch(errJ){
        console.error('[BORRADOR] respuesta cortada en la tanda '+vueltas+':', errJ.message);
        if(rows.length){ _dbg('[BORRADOR] se usan las '+rows.length+' ya leídas'); break; }
        window._pendSAPError='La respuesta llegó cortada';
        throw errJ;
      }
      if(!Array.isArray(lote)) break;
      rows=rows.concat(lote);
      if(lote.length<tanda) break;      // última tanda
      desde+=lote.length;
    }
    _dbg('[BORRADOR] '+rows.length+' orden(es) en '+vueltas+' tanda(s)');
    window._pendSAPError=null;
    // La fila se rearma campo por campo. Todo lo que no se copie aquí SE PIERDE
    // en cada Sync, aunque esté guardado en la base: era lo que hacía
    // desaparecer la línea de diferencias al sincronizar.
    if(Array.isArray(rows)) window._pendSAP=rows.map(function(row){return {
      dkc:row.dkc, num_orden:row.num_orden||row.dkc, po:row.po||'',
      dept:row.dept||'', proveedor:row.proveedor||'', cardcode:row.cardcode||'',
      total:Number(row.total)||0, abonado:Number(row.abonado)||0, saldo:Number(row.saldo)||0,
      by:row.agregado_por||'', fecha:row.fecha||'', creado_en:row.creado_en||row.fecha||'',
      items:(row.items||[]), fecha_abono:row.fecha_abono||'',
      editada:!!row.editada, editado_en:row.editado_en||'', editado_por:row.editado_por||'',
      motivo_edicion:row.motivo_edicion||'', ediciones:(row.ediciones||[]),
      // De dónde viene la orden y en qué se apartó de la reposición
      num_reposicion:row.num_reposicion||'',
      dif_reposicion:(row.dif_reposicion!=null?row.dif_reposicion:null),
      pago_contra_bl:!!row.pago_contra_bl
    };});
    // La pantalla se repinta AQUÍ, en cuanto están las órdenes. Antes solo se
    // repintaba si la carga fallaba y entraba el reintento: en un equipo
    // lento (el iPad) la pantalla ya se había dibujado con la lista vacía y
    // se quedaba diciendo "Sin órdenes No SAP" hasta que se cambiaba de
    // pestaña. En el escritorio la carga terminaba antes de dibujar y por eso
    // ahí sí se veían.
    try{ _refrescarPantalla(); }catch(e){}
    try{ if(typeof rDash==='function' && PG==='dashboard') rDash(); }catch(e){}

    // Las líneas, por detrás. La pantalla ya está pintada.
    setTimeout(function(){ _nsapCargarItems().catch(function(){}); }, 400);

    // Los adjuntos van DESPUÉS y sin bloquear: son para cuando se abre una
    // orden, no para verlas listadas. Esperarlos uno a uno retrasaba todo.
    if(Array.isArray(window._pendSAP)){
      // Se copia la lista: si mientras tanto alguien recarga y la deja en
      // nulo, este bucle seguía apuntando a la de antes y reventaba.
      var _paraDocs=window._pendSAP.slice();
      (async function(){
        for(var i=0;i<_paraDocs.length;i++){
          try{ await cargarDocsOrden(_paraDocs[i].dkc); }catch(e){}
        }
      })();
    }
  }catch(e){
    console.error('cargarPendSAP:', e);
    // Un reintento a los cinco segundos. Casi todos estos fallos son de red
    // momentánea y con una segunda oportunidad se resuelven.
    if(!window._pendSAPReintento){
      window._pendSAPReintento=1;
      setTimeout(function(){
        _dbg('[BORRADOR] reintentando la carga…');
        cargarPendSAP().then(function(){
          try{ _refrescarPantalla(); }catch(e2){}
        });
      }, 5000);
    }
  }
}

async function cargarLlegadas(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_llegada?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._llegada) window._llegada={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      window._llegada[String(row.docnum)]={ confirmado:!!row.confirmado, por:row.confirmado_por||'', fechaReal:row.fecha_real||'', fechaConfirm:'' };
    });
  }catch(e){ console.error('cargarLlegadas:', e); }
}

function getBK(oid){
  if(!window._bookingData[oid]) window._bookingData[oid]={naviera:'',booking:'',containers:[]};
  return window._bookingData[oid];
}
function setBKField(oid,field,val){
  getBK(oid)[field]=val;
  // Al escribir el booking (texto) NO redibujamos nada: eso recreaba el input
  // y perdía el foco (solo dejaba 1 tecla). Solo guardamos.
  // Al cambiar la naviera (un select, no pierde foco) sí redibujamos para
  // actualizar los colores/íconos del barquito.
  if(field==='naviera'){
    var trackerEl=document.getElementById('log-tracker-'+oid);
    if(trackerEl) trackerEl.innerHTML=buildLogTracker(oid);
  }
  _guardarBookingDebounced(oid);
}
// Guarda tras 600ms sin cambios (evita guardar en cada tecla)
var _bkSaveTimers={};
function _guardarBookingDebounced(oid){
  if(_bkSaveTimers[oid]) clearTimeout(_bkSaveTimers[oid]);
  _bkSaveTimers[oid]=setTimeout(function(){ guardarBooking(oid); }, 600);
}
function addContainer(oid){
  _syncLogFromDOM(oid);
  getBK(oid).containers.push({id:'',etaSalida:'',etaLlegada:'',origen:'Shanghai, China',destino:'Colón, Panamá'});
  _redibujarTracker(oid);
  guardarBooking(oid);
}
function removeContainer(oid,i){
  _syncLogFromDOM(oid);
  getBK(oid).containers.splice(i,1);
  _redibujarTracker(oid);
  guardarBooking(oid);
}
function _syncLogFromDOM(oid){
  var trackerEl=document.getElementById('log-tracker-'+oid);
  if(!trackerEl)return;
  var bk=getBK(oid);
  var selNav=trackerEl.querySelector('.bk-sel');
  if(selNav&&selNav.value)bk.naviera=selNav.value;
  var inpBk=trackerEl.querySelector('.bk-inp');
  if(inpBk)bk.booking=inpBk.value;
  trackerEl.querySelectorAll('.ctn-inp').forEach(function(inp){
    var i=parseInt(inp.getAttribute('data-ctn-i'));
    var field=inp.getAttribute('data-ctn-field');
    if(!isNaN(i)&&field&&bk.containers[i])bk.containers[i][field]=inp.value;
  });
}
function _redibujarTracker(oid){
  var trackerEl=document.getElementById('log-tracker-'+oid);
  if(trackerEl){ trackerEl.innerHTML=buildLogTracker(oid); return; }
  _rebuildLogStep(oid);
}
function setContainerField(oid,i,field,val){
  var bk=getBK(oid);
  if(!bk.containers[i])return;
  bk.containers[i][field]=val;
  // NO rerenderizar — solo guardar el valor, el barquito se actualiza al abrir
  _guardarBookingDebounced(oid);
}
function _rebuildLogStep(oid){
  // Guardar valores actuales del DOM al tracker antes de reconstruir
  var trackerEl=document.getElementById('log-tracker-'+oid);
  if(trackerEl){
    var bk=getBK(oid);
    var selNav=trackerEl.querySelector('.bk-sel');
    if(selNav&&selNav.value)bk.naviera=selNav.value;
    var inpBk=trackerEl.querySelector('.bk-inp');
    if(inpBk)bk.booking=inpBk.value;
    trackerEl.querySelectorAll('.ctn-inp').forEach(function(inp){
      var i=parseInt(inp.getAttribute('data-ctn-i'));
      var field=inp.getAttribute('data-ctn-field');
      if(!isNaN(i)&&field&&bk.containers[i])bk.containers[i][field]=inp.value;
    });
  }
  var logIdx=STAGES.findIndex(function(s){return s.key==='logistica';});
  if(logIdx<0)return;
  var body=document.getElementById('egb-'+oid+'-'+logIdx);
  if(body&&body.classList.contains('open'))buildEGB(oid,logIdx,body);
}
function rerenderLogTracker(oid){
  _rebuildLogStep(oid);
}
function attachTrackerListeners(root,oid){
  // no-op: listeners manejados por event delegation
}

const TRACKING_URLS={
  'MAERSK':'https://www.maersk.com/tracking/',
  'CMA':'https://www.cma-cgm.com/ebusiness/tracing/search?SearchBy=Container&Reference=',
  'EVERGREEN':'https://www.shipmentlink.com/servlet/TDB1_CargoTracking.do?container_id=',
  'COSCO':'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=CONTAINER&number=',
  'PANAMA CARRIER':'https://www.pancarrier.com/track/?ctn=',
  'MSC':'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber=',
  'AIR SEA WORLDWIDE':'',
  'CAPITAL PACIFICO':'',
  'ETERNITY':'',
};

// Tracking por tipo de referencia. Cada naviera usa una URL distinta segun
// se busque por contenedor, por B/L o por booking; algunas aceptan cualquiera
// en el mismo buscador.
const TRACKING_POR_TIPO={
  'MAERSK':{
    contenedor:'https://www.maersk.com/tracking/',
    bl:'https://www.maersk.com/tracking/',
    booking:'https://www.maersk.com/tracking/'
  },
  'CMA':{
    contenedor:'https://monitor.cma-cgm.com/ebusiness/tracking/search?SearchBy=Container&Reference=',
    bl:'https://monitor.cma-cgm.com/ebusiness/tracking/search?SearchBy=BL&Reference=',
    booking:'https://monitor.cma-cgm.com/ebusiness/tracking/search?SearchBy=Booking&Reference=',
    base:'https://monitor.cma-cgm.com/ebusiness/tracking'
  },
  'MSC':{
    contenedor:'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber=',
    bl:'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber=',
    booking:'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber='
  },
  'EVERGREEN':{
    contenedor:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do?container_id=',
    bl:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do?bl_no=',
    booking:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do?bkg_no=',
    base:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do'
  },
  'COSCO':{
    contenedor:'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=CONTAINER&number=',
    bl:'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=BILLOFLADING&number=',
    booking:'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=BOOKING&number='
  },
  'PANAMA CARRIER':{
    contenedor:'https://www.pancarrier.com/track/?ctn=',
    bl:'https://www.pancarrier.com/track/?bl=',
    booking:'https://www.pancarrier.com/track/?bkg='
  }
};

// Devuelve la URL de tracking, o '' si esa naviera no tiene buscador propio
function _trackURL(naviera, tipo, valor){
  var nav=String(naviera||'').toUpperCase().trim();
  var v=String(valor||'').trim();
  if(!nav || !v) return '';
  var m=TRACKING_POR_TIPO[nav];
  if(m && m[tipo]) return m[tipo]+encodeURIComponent(v);
  // Sin buscador propio (Air Sea Worldwide, Capital Pacífico, Eternity):
  // se ofrece un rastreador general que cubre muchas navieras
  return 'https://www.trackingmore.com/es/container-tracking.html?number='+encodeURIComponent(v);
}

// Página de rastreo de la naviera, para abrirla y buscar a mano
function _trackBase(naviera){
  var nav=String(naviera||'').toUpperCase().trim();
  var m=TRACKING_POR_TIPO[nav];
  if(m && m.base) return m.base;
  if(m && m.contenedor) return String(m.contenedor).split('?')[0];
  return '';
}

// Chip clickeable con la referencia y su enlace de rastreo
function _trackChip(naviera, tipo, valor, etiqueta){
  var v=String(valor||'').trim();
  if(!v) return '';
  var url=_trackURL(naviera, tipo, v);
  var propio=!!(TRACKING_POR_TIPO[String(naviera||'').toUpperCase().trim()]||{})[tipo];
  if(!url) return '';
  return '<a href="'+_esc(url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
    +'title="Rastrear '+_esc(etiqueta||tipo)+' '+_esc(v)+(propio?(' en '+_esc(naviera)):' (rastreador general)')+'" '
    +'style="display:inline-flex;align-items:center;gap:5px;background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:20px;padding:3px 11px;font-size:11px;text-decoration:none;color:var(--text-accent);font-weight:600">'
    +'<i class="ti ti-radar" style="font-size:12px"></i>'+_esc(etiqueta||tipo)
    +(propio?'':' <span style="font-size:9px;color:var(--text-muted)">general</span>')
    +'</a>';
}

// Barra de rastreo de una subetapa
function _trackBarra(oid, tipoPaso){
  var d=_logLeer(oid);
  var nav=(d.booking&&d.booking.naviera)||'';
  var chips=[];
  var bk=(d.booking&&d.booking.numero)||'';
  var bl=(d.bl&&d.bl.numero)||(d.arrival&&d.arrival.bl)||'';
  if(bk) chips.push(_trackChip(nav,'booking',bk,'Booking '+bk));
  if(bl) chips.push(_trackChip(nav,'bl',bl,'B/L '+bl));
  chips=chips.filter(Boolean);
  // El buscador de la naviera, para entrar aunque falte la referencia
  var base=_trackBase(nav);
  if(base){
    chips.push('<a href="'+_esc(base)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
      +'title="Abrir el rastreador de '+_esc(nav)+'" '
      +'style="display:inline-flex;align-items:center;gap:4px;font-size:10.5px;text-decoration:none;color:var(--text-muted)">'
      +'<i class="ti ti-external-link" style="font-size:11px"></i>abrir '+_esc(nav)+'</a>');
  }
  if(!chips.length) return '';
  return '<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;background:var(--surface-0);'
    +'border:0.5px solid var(--border);border-radius:8px;padding:7px 10px;margin-bottom:8px">'
    +'<span style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase">Rastrear'
    +(nav?(' en '+_esc(nav)):'')+'</span>'
    +chips.join('')
    +'</div>';
}

// Emojis/logos por naviera (texto fallback)
const NAVIERA_EMOJI={'MAERSK':'🔷','CMA':'🔴','EVERGREEN':'🟢','COSCO':'⭐','PANAMA CARRIER':'🇵🇦','MSC':'🟡','AIR SEA WORLDWIDE':'✈️','CAPITAL PACIFICO':'🔵','ETERNITY':'⚫'};
const NAVIERA_COLOR={'MAERSK':'#42B0D5','CMA':'#E30613','EVERGREEN':'#009E60','COSCO':'#1C4FA0','PANAMA CARRIER':'#003580','MSC':'#0A2B6B','AIR SEA WORLDWIDE':'#0F766E','CAPITAL PACIFICO':'#1D4ED8','ETERNITY':'#374151'};
// Iniciales para el ícono de cada naviera
const NAVIERA_INI={'MAERSK':'MSK','CMA':'CMA','EVERGREEN':'EMC','COSCO':'COS','PANAMA CARRIER':'PCL','MSC':'MSC','AIR SEA WORLDWIDE':'ASW','CAPITAL PACIFICO':'CAP','ETERNITY':'ETN'};

// Ícono de naviera: cuadro con el color oficial y las iniciales (identifica la marca sin usar el logo con copyright)
function navieraIcono(nav, size){
  size=size||18;
  if(!nav) return '<span style="font-size:'+size+'px;line-height:1">🚢</span>';
  var color=NAVIERA_COLOR[nav]||'#185FA5';
  var ini=NAVIERA_INI[nav]||nav.slice(0,3).toUpperCase();
  var fs=Math.round(size*0.42);
  return '<span style="display:inline-flex;align-items:center;justify-content:center;width:'+size+'px;height:'+size+'px;background:'+color+';color:#fff;border-radius:4px;font-size:'+fs+'px;font-weight:800;letter-spacing:.3px;font-family:var(--font-sans);box-shadow:0 1px 2px rgba(0,0,0,.2);flex-shrink:0" title="'+nav+'">'+ini+'</span>';
}

function openTrackingCtn(oid, i){
  var bk=getBK(oid);
  var ctn=(bk.containers[i]||{}).id||'';
  var nav=bk.naviera;
  if(!ctn.trim()){showT('Ingresa el número de contenedor');return;}
  var url=TRACKING_URLS[nav];
  if(url) window.open(url+encodeURIComponent(ctn.trim()),'_blank');
  else window.open('https://www.google.com/search?q=track+container+'+encodeURIComponent(ctn.trim()),'_blank');
}

function buildLogTracker(oid){
  var bk=getBK(oid);
  var navieras=['MAERSK','CMA','MSC','EVERGREEN','COSCO','PANAMA CARRIER','AIR SEA WORLDWIDE','CAPITAL PACIFICO','ETERNITY'];
  var navColor=NAVIERA_COLOR[bk.naviera]||'#185FA5';
  var navEmoji=NAVIERA_EMOJI[bk.naviera]||'🚢';
  var html='';
  // Campos globales
  html+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px">'
    +'<div><label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px;text-transform:uppercase;letter-spacing:.4px">Naviera</label>'
    +'<select data-bk-oid="'+oid+'" data-bk-field="naviera" class="bk-sel" style="width:100%;padding:7px 8px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);font-size:12px;font-family:var(--font-sans)">'
    +'<option value="">-- Seleccionar --</option>'
    +navieras.map(function(n){return'<option value="'+n+'"'+(bk.naviera===n?' selected':'')+'>'+NAVIERA_EMOJI[n]+' '+n+'</option>';}).join('')
    +'</select></div>'
    +'<div><label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px;text-transform:uppercase;letter-spacing:.4px">N° Booking / BL</label>'
    +'<input type="text" value="'+bk.booking+'" placeholder="Ej: MAEU12345678" data-bk-oid="'+oid+'" data-bk-field="booking" class="bk-inp" style="width:100%;padding:7px 8px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);font-size:12px;font-family:var(--font-sans)"></div>'
    +'</div>';

  if(!bk.containers.length){
    html+='<div style="font-size:11px;color:var(--text-muted);padding:8px 0;margin-bottom:4px">Sin contenedores. Agrega uno abajo.</div>';
  } else {
    html+='<div style="font-size:10px;color:var(--text-muted);font-weight:600;text-transform:uppercase;letter-spacing:.4px;margin-bottom:6px">Contenedores ('+bk.containers.length+')</div>';
    bk.containers.forEach(function(ctn,i){
      var hoy=new Date();
      var sal=ctn.etaSalida?new Date(ctn.etaSalida):null;
      var lle=ctn.etaLlegada?new Date(ctn.etaLlegada):null;
      var pct=0,diasRuta=0,diasTrans=0,diasFalta=0,enRuta=false,llegado=false;
      if(sal&&lle){
        diasRuta=Math.max(1,Math.round((lle-sal)/(1000*60*60*24)));
        if(hoy<sal){pct=0;diasFalta=Math.round((lle-hoy)/(1000*60*60*24));}
        else if(hoy>=lle){pct=100;llegado=true;}
        else{diasTrans=Math.round((hoy-sal)/(1000*60*60*24));diasFalta=Math.round((lle-hoy)/(1000*60*60*24));pct=Math.min(95,Math.round((diasTrans/diasRuta)*100));enRuta=true;}
      }
      var leftPct=Math.max(2,Math.min(92,pct));
      var statusColor=llegado?'#27500A':enRuta?'#185FA5':'#888780';
      var statusLabel=llegado?'Llegó a Panamá':enRuta?'En tránsito':'Pendiente salida';

      html+='<div class="ctn-card">';
      html+='<div style="display:flex;align-items:flex-start;gap:8px;margin-bottom:8px">';
      html+='<div style="padding-top:2px">'+navieraIcono(bk.naviera,20)+'</div>';
      html+='<div style="flex:1;min-width:0">';
      html+='<input type="text" value="'+(ctn.id||'')+'" placeholder="N° Contenedor (Ej: MSCU1234567)" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="id" class="ctn-inp" style="width:100%;padding:5px 8px;border:0.5px solid var(--border);border-radius:6px;background:var(--surface-1);font-size:12px;font-weight:600;font-family:monospace;letter-spacing:.5px;margin-bottom:4px">';
      html+='<div style="display:flex;gap:6px;flex-wrap:wrap">';
      html+='<div style="flex:1;min-width:100px"><label style="font-size:9px;color:var(--text-muted);display:block">Salida estimada</label><input type="date" value="'+(ctn.etaSalida||'')+'" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="etaSalida" class="ctn-inp" style="width:100%;padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-1);font-size:11px;font-family:var(--font-sans)"></div>';
      html+='<div style="flex:1;min-width:100px"><label style="font-size:9px;color:var(--text-muted);display:block">ETA llegada</label><input type="date" value="'+(ctn.etaLlegada||'')+'" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="etaLlegada" class="ctn-inp" style="width:100%;padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-1);font-size:11px;font-family:var(--font-sans)"></div>';
      html+='<div style="flex:1;min-width:80px"><label style="font-size:9px;color:var(--text-muted);display:block">Origen</label><input type="text" value="'+(ctn.origen||'Shanghai, China')+'" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="origen" class="ctn-inp" style="width:100%;padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-1);font-size:11px;font-family:var(--font-sans)"></div>';
      html+='</div></div>';
      html+='<div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0">';
      html+='<button data-oid="'+oid+'" data-ci="'+i+'" class="ctn-track-btn" style="padding:5px 10px;background:'+(bk.naviera&&ctn.id?navColor:'#aaa')+';color:white;border:none;border-radius:6px;font-size:10px;cursor:pointer;display:flex;align-items:center;gap:4px;white-space:nowrap"><i class="ti ti-current-location" style="font-size:11px"></i>Live Track</button>';
      html+='<button data-oid="'+oid+'" data-ci="'+i+'" class="ctn-del-btn" style="padding:4px 8px;background:none;border:0.5px solid var(--border-danger);border-radius:6px;font-size:10px;cursor:pointer;color:var(--text-danger)"><i class="ti ti-trash" style="font-size:10px"></i></button>';
      html+='</div></div>';

      // Barquito animado
      html+='<div style="margin-top:6px;padding:8px 10px;background:linear-gradient(180deg,#E8F4FD 0%,#C8E6F8 60%,#A8D4F0 100%);border-radius:8px;position:relative;overflow:hidden">';
      html+='<div style="position:absolute;bottom:0;left:0;right:0;height:18px;opacity:.3"><svg viewBox="0 0 400 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="width:100%;height:100%"><path d="M0,10 C50,0 100,20 150,10 C200,0 250,20 300,10 C350,0 400,20 400,10 L400,20 L0,20 Z" fill="#185FA5" opacity="0.4"/><path d="M0,14 C60,6 120,18 180,12 C240,6 300,18 360,12 L400,14 L400,20 L0,20 Z" fill="#185FA5" opacity="0.3"/></svg></div>';
      html+='<div style="position:relative;height:44px">';
      html+='<div style="position:absolute;top:50%;left:14px;right:14px;height:2px;background:rgba(255,255,255,.5);border-radius:1px;transform:translateY(-50%)"></div>';
      if(pct>0)html+='<div style="position:absolute;top:50%;left:14px;width:calc('+leftPct+'% - 14px);height:2px;background:'+statusColor+';border-radius:1px;transform:translateY(-50%)"></div>';
      html+='<div style="position:absolute;left:4px;top:50%;transform:translateY(-50%)"><div style="width:10px;height:16px;background:#185FA5;border-radius:2px 2px 0 0"></div><div style="font-size:8px;color:#185FA5;white-space:nowrap;margin-top:2px;max-width:60px;overflow:hidden;text-overflow:ellipsis">'+(ctn.origen||'Origen')+'</div></div>';
      html+='<div style="position:absolute;right:4px;top:50%;transform:translateY(-50%);text-align:right"><div style="width:10px;height:16px;background:#27500A;border-radius:2px 2px 0 0;margin-left:auto"></div><div style="font-size:8px;color:var(--t-oliva);white-space:nowrap;margin-top:2px">'+(ctn.destino||'Colón, Panamá')+'</div></div>';
      html+='<div style="position:absolute;left:calc('+leftPct+'% - 12px);top:4px;font-size:20px;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.25));transition:left .8s ease">'+navEmoji+'</div>';
      if(bk.naviera)html+='<div style="position:absolute;left:calc('+leftPct+'% - 10px);top:-6px;font-size:8px;font-weight:700;color:'+navColor+';white-space:nowrap;background:var(--surface-2);border-radius:3px;padding:0 3px;line-height:14px">'+bk.naviera+'</div>';
      html+='</div>';
      html+='<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px">';
      html+='<div style="font-size:10px;font-weight:600;color:'+statusColor+';display:flex;align-items:center;gap:4px"><span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:'+statusColor+'"></span>'+statusLabel+'</div>';
      if(enRuta)html+='<div style="font-size:10px;color:var(--text-muted)"><span style="color:#185FA5;font-weight:600">'+diasTrans+'d</span> en ruta · <span style="color:var(--t-oliva);font-weight:600">'+diasFalta+'d</span> para llegar</div>';
      else if(!llegado&&sal)html+='<div style="font-size:10px;color:var(--text-muted)">Sale '+formatDateDisplay(ctn.etaSalida)+' · Llega '+formatDateDisplay(ctn.etaLlegada)+'</div>';
      else if(llegado)html+='<div style="font-size:10px;color:var(--t-oliva);font-weight:600">\u2713 '+diasRuta+'d de tr\u00e1nsito total</div>';
      html+='</div>';
      html+='<div style="height:4px;background:rgba(0,0,0,.1);border-radius:2px;margin-top:5px;overflow:hidden"><div style="height:100%;background:'+statusColor+';border-radius:2px;width:'+pct+'%;transition:width .8s ease"></div></div>';
      html+='</div>'; // cierra ocean box
      html+='</div>'; // cierra ctn-card
    });
  }
  html+='<button data-oid="'+oid+'" class="ctn-add-btn"><i class="ti ti-plus" style="font-size:12px"></i> Agregar contenedor</button>';
  return html;
}

function formatDateDisplay(iso){
  if(!iso)return'—';
  var d=new Date(iso+'T00:00:00');
  return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short'});
}

let DRW=false,CTX=null;
var _recentActivity=[]; // {docnum, etapa, autor, ts} ordenado desc
function initC(){const c=document.getElementById('fc');if(!c)return;CTX=c.getContext('2d');CTX.strokeStyle='#185FA5';CTX.lineWidth=2.5;CTX.lineCap='round';CTX.lineJoin='round';function gxy(e){const r=c.getBoundingClientRect();return{x:(e.clientX-r.left)*(c.width/r.width),y:(e.clientY-r.top)*(c.height/r.height)};}function gxyt(e){const r=c.getBoundingClientRect(),t=e.touches[0];return{x:(t.clientX-r.left)*(c.width/r.width),y:(t.clientY-r.top)*(c.height/r.height)};}c.addEventListener('mousedown',e=>{DRW=true;CTX.beginPath();const p=gxy(e);CTX.moveTo(p.x,p.y);});c.addEventListener('mousemove',e=>{if(!DRW)return;const p=gxy(e);CTX.lineTo(p.x,p.y);CTX.stroke();});c.addEventListener('mouseup',()=>DRW=false);c.addEventListener('mouseleave',()=>DRW=false);c.addEventListener('touchstart',e=>{e.preventDefault();DRW=true;CTX.beginPath();const p=gxyt(e);CTX.moveTo(p.x,p.y);},{passive:false});c.addEventListener('touchmove',e=>{e.preventDefault();if(!DRW)return;const p=gxyt(e);CTX.lineTo(p.x,p.y);CTX.stroke();},{passive:false});c.addEventListener('touchend',()=>DRW=false);}
function CC(){const c=document.getElementById('fc');if(c&&CTX)CTX.clearRect(0,0,c.width,c.height);}
function isBlank2(c){const d=c.getContext('2d').getImageData(0,0,c.width,c.height).data;for(let i=3;i<d.length;i+=4)if(d[i]>0)return false;return true;}
function signOrden(id){const c=document.getElementById('fc');if(!c||isBlank2(c)){showT('Dibuja tu firma primero');return;}if(!firmas[id])firmas[id]={};firmas[id]['gerencia']={signed:true,by:CU.name,date:now2()};const o=orders.find(x=>x.id===id);if(o){o.pend=false;initP(id);stageProgress[id].pedido.stepIdx=2;stageProgress[id].pedido.stepDates=[o.fechaCreacion,dateOnly()];stageProgress[id].deposito.startDate=dateOnly();}showT('✓ Orden firmada');CM();setTimeout(()=>{go(PG,null,true);openDetail(id);},80);}
function rejOrden(id){showT('Orden rechazada.');CM();setTimeout(()=>go(PG,null,true),80);}
function markComplete(id){const o=orders.find(x=>x.id===id);if(o){o.completada=true;STAGES.forEach(s=>{if(stageProgress[id])stageProgress[id][s.key].stepIdx=s.steps.length;});}showT('✓ Proceso completo');CM();setTimeout(()=>go(PG,null,true),80);}
function CM(){document.getElementById('modal').style.display='none';try{document.getElementById('mc').classList.remove('md-ancho');}catch(e){}try{_comDetenerPoll();}catch(e){}}

// ── El comprobante detrás de "Abonado" y "Saldo" ──────────────────────
// El del abono está en los pasos del depósito (el que dejó contabilidad o el
// que compras reenvió al proveedor); el del pago final, en los dos últimos.
function _compsPago(oid, tipo){
  var pasos=(tipo==='cancelacion') ? [4,3] : [2,1];
  var out=[];
  pasos.forEach(function(i){
    ((window._atts&&window._atts[String(oid)+'deposito_step'+i])||[]).forEach(function(a){
      if(a && _docHref(a)) out.push(a);
    });
  });
  return _dedupDocs(out);
}
function _hayCompPago(oid, tipo){ return _compsPago(oid, tipo).length>0; }

function _verCompPago(oid, tipo){
  var lista=_compsPago(oid, tipo);
  var qué=(tipo==='cancelacion')?'del pago final':'del abono';
  if(!lista.length){ showT('Todavía no hay comprobante '+qué+' adjunto'); return; }
  // Uno solo: se abre directo, que es lo que se espera al hacer clic
  if(lista.length===1){ window.open(lista[0].url||lista[0].data, '_blank', 'noopener'); return; }

  var prev=document.getElementById('modalCompPago'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCompPago';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13600;'
    +'display:flex;align-items:center;justify-content:center;padding:22px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:520px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">'
      +'<div style="font-size:13.5px;font-weight:700">Comprobantes '+qué+' &middot; orden '+_esc(String(oid))+'</div>'
      +'<button onclick="document.getElementById(\'modalCompPago\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    +_nsapDocsHTML('', lista, 'var(--text-muted)')
    +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}
// ═══════════════════════════════════════════════════════════════════════════
//  SEGUIMIENTO DE REPOSICIONES ENVIADAS (gerencia -> compras -> proveedor)
//  Requiere la tabla Supabase: reposiciones_envios (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
function _repDeptDeData(){ try{ if(!_repData||!_repData.length) return null; var c={}; _repData.forEach(function(x){ var dd=normDept(x.grupo_nom||''); c[dd]=(c[dd]||0)+1; }); var b='',n=-1; Object.keys(c).forEach(function(k){ if(c[k]>n){n=c[k];b=k;} }); return b; }catch(e){ return null; } }
async function _repRegistrarEnvio(code, adjPath, adjNombre, d, destinatarios, adjTodos){
  var dept=(CU&& _deptAcotado())||_repDeptDeData()||null;
  var pedidoId=_repPedidoId||null;
  var payload={ cardcode:code, cardname:(_repData&&_repData[0]&&_repData[0].cardname)||'', dept:dept, resumen:(d&&d.asunto)||('Reposicion '+code),
    // El asunto y el cuerpo completos, para que compras pueda reenviarlos
    // al proveedor tal cual los escribió gerencia.
    mail_asunto:(d&&d.asunto)||'', mail_cuerpo:(d&&d.cuerpo)||'',
    para_email:destinatarios||'', enviado_por:(CU&&CU.name)||'', enviado_por_email:(CU&&CU.email)||'', enviado_en:new Date().toISOString(), estado:'enviada', archivo_path:adjPath||null, archivo_nombre:adjNombre||null,
    archivos:(adjTodos&&adjTodos.length)?JSON.stringify(adjTodos):null, pedido_id:pedidoId,
    num_reposicion:_repNumRepo||null, creado_en:new Date().toISOString() };
  await _firmaWrite(SB+'/rest/v1/reposiciones_envios','POST',payload,['pedido_id','num_reposicion']);
  // El número tiene que quedar TAMBIÉN en el pedido: es donde lo busca la
  // orden NO SAP para comparar. Si solo queda en el envío, la comparación
  // dice que la reposición no existe.
  if(_repNumRepo && pedidoId){
    try{
      await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+encodeURIComponent(pedidoId)
        +'&num_reposicion=is.null',{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({num_reposicion:_repNumRepo})});
    }catch(e){ console.warn('[reposición] número en el pedido:', e); }
  }
  if(pedidoId){ try{ await _firmaWrite(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+pedidoId,'PATCH',{estado:'enviado_compras', enviado_compras_en:new Date().toISOString(), actualizado_en:new Date().toISOString()},['enviado_compras_en']); }catch(e){} }
}
// ═══════════════════════════════════════════════════════════════════════════
//  CONTADOR DE REPOSICIONES NUEVAS
//  Muestra un número rojo sobre el botón "Reposiciones" del inicio con las
//  reposiciones que le llegaron a esta persona y todavía no ha abierto.
//  El número baja solo cuando la abre (ahí se marca como recibida).
// ═══════════════════════════════════════════════════════════════════════════
var _repBadgeTimer=null;
window._repNuevas=0;

function _repBadgePintar(n){
  var el=document.getElementById('nbNumRep');
  if(!el) return;
  if(n>0){ el.textContent=(n>99?'99+':String(n)); el.style.display='block'; el.title=n+' reposición(es) sin abrir'; }
  else { el.textContent=''; el.style.display='none'; el.title=''; }
}

async function _repBadgeActualizar(){
  try{
    var email=(CU&&CU.email)||'';
    if(!email){ _repBadgePintar(0); return; }
    // Cuenta las que le llegaron a cualquiera del equipo del departamento
    var correos=_equipoEmails(); if(!correos.length) correos=[email];
    var orRep=correos.map(function(e){ return 'para_email.ilike.*'+e+'*'; }).join(',');
    var url=SB+'/rest/v1/reposiciones_envios?select=id&recibido_en=is.null'
      +'&or=('+orRep+')&limit=200';
    var r=await fetch(url,{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    window._repNuevas=Array.isArray(rows)?rows.length:0;
    _repBadgePintar(window._repNuevas);
  }catch(e){ /* sin conexión: se deja el número anterior */ }
}

function _repBadgeIniciar(){
  _repBadgeActualizar();
  if(_repBadgeTimer) clearInterval(_repBadgeTimer);
  _repBadgeTimer=setInterval(_repBadgeActualizar, 60000);
}

async function _repEnviosCargar(){
  var box=document.getElementById('rep-envios'); if(!box) return;
  try{
    var esGer=(CU&&CU.role==='gerencia');
    var email=(CU&&CU.email)||'';
    // El equipo del departamento ve los mismos envíos
    var _cs=_equipoEmails(); if(!_cs.length) _cs=[email];
    var _or=_cs.map(function(e){ return 'enviado_por_email.eq.'+e+',para_email.ilike.*'+e+'*'; }).join(',');
    var filtro='&or=('+_or+')';
    var r=await fetch(SB+'/rest/v1/reposiciones_envios?select=*'+filtro+'&order=enviado_en.desc&limit=100',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)||!rows.length){ window._repEnvios=[]; box.innerHTML=''; return; }
    window._repEnvios=rows;
    try{ _repCargarIndiceEnCurso(true); }catch(e){}
    _repEnviosRender(box, rows, esGer);
  }catch(e){ box.innerHTML=''; }
}
// La comparación contra la orden NO SAP que salió de esta reposición. Se ve
// aquí también, para no tener que ir a buscarla al listado de órdenes.
function _repDifLinea(o){
  var dkc=String(o.orden_dkc||'').trim();
  if(!dkc) return '';
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===dkc || String(x.num_orden)===dkc; });
  var d=p?_nsapDifDe(p):null;
  if(!d){
    return '<div style="margin-top:4px;font-size:11px;color:var(--text-muted)">'
      +'<i class="ti ti-git-compare"></i> Sin registro de diferencias con esta reposición.</div>';
  }
  var n=(d.faltan||[]).length+(d.agregados||[]).length+(d.distintos||[]).length;
  return '<div onclick="event.stopPropagation();_nsapVerDif(\''+_esc(dkc.replace(/\\/g,''))+'\')" '
    +'title="Ver el detalle de las diferencias" '
    +'style="margin-top:4px;display:inline-flex;align-items:center;gap:6px;cursor:pointer;'
    +'background:'+(d.cuadra?'#dcfce7':'#FEF9F3')+';border:1px solid '+(d.cuadra?'#16a34a':'#E9C08A')+';'
    +'border-radius:8px;padding:5px 10px;font-size:11.5px;font-weight:600;'
    +'color:'+(d.cuadra?'#166534':'#7C3D12')+'">'
    +'<i class="ti '+(d.cuadra?'ti-circle-check':'ti-git-compare')+'"></i> '
    +(d.cuadra?'La orden respetó la reposición':(n+' diferencia(s) con la reposición'))
    +'<span style="text-decoration:underline;text-underline-offset:2px;font-weight:500">ver</span></div>';
}

// ¿Ya salió al proveedor? Comparar solo contra 'enviada_proveedor' dejaba
// fuera el estado siguiente ('orden_creada'), y al crearse la orden volvían a
// aparecer los botones de modificar y enviar sobre algo ya cerrado.
function _repYaEnviada(o){
  if(!o) return false;
  if(o.enviado_proveedor_en) return true;
  return o.estado==='enviada_proveedor' || o.estado==='orden_creada';
}

function _repEnvioColor(e){
  return (e==='orden_creada')?'#15803d'
       : (e==='enviada_proveedor')?'#16a34a'
       : (e==='recibida')?'#2563eb':'#dc2626';
}
function _repEnvioBadge(e){
  var map={enviada:['Enviada por gerencia','#fee2e2','#b91c1c'],
           recibida:['Recibida por compras','#dbeafe','#1e40af'],
           enviada_proveedor:['Enviada a proveedor','#dcfce7','#166534'],
           orden_creada:['Orden aprobada y firmada','#bbf7d0','#14532d']};
  var m=map[e]||map.enviada; return '<span style="font-size:9px;background:'+m[1]+';color:'+m[2]+';padding:1px 7px;border-radius:7px;font-weight:600">'+m[0]+'</span>';
}

// La reposición se convirtió en orden NO SAP: queda cerrada y en verde
async function _repMarcarOrdenCreada(numRepo, dkc){
  numRepo=String(numRepo||'').trim();
  if(!numRepo) return false;
  try{
    // Se busca con la misma tolerancia que el resto: por número, no por texto
    var ped=await _repBuscarPedidoPorNum(numRepo);
    if(!ped) return false;
    var peds=[ped];
    var cambios={ estado:'orden_creada', orden_dkc:String(dkc||''),
                  orden_creada_en:new Date().toISOString() };
    for(var i=0;i<peds.length;i++){
      try{
        await _firmaWrite(SB+'/rest/v1/reposiciones_envios?pedido_id=eq.'+peds[i].id,
          'PATCH', cambios, ['orden_dkc','orden_creada_en']);
      }catch(e){ console.warn('[reposición] marcar envío:', e); }
      try{
        await _firmaWrite(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+peds[i].id,
          'PATCH', {estado:'orden_creada', actualizado_en:new Date().toISOString()}, []);
      }catch(e){}
    }
    return true;
  }catch(e){ console.warn('[reposición] orden creada:', e); return false; }
}
function _repEnviosRender(box, rows, esGer){
  var email=((CU&&CU.email)||'').toLowerCase();
  var h='<div style="border:0.5px solid #C4B5FD;border-radius:10px;overflow:hidden">'
    +'<div style="background:var(--pastel-lila);padding:9px 12px;font-size:12px;font-weight:700;color:var(--t-lila2);display:flex;align-items:center;gap:8px"><i class="ti ti-send"></i> Seguimiento de reposiciones <span style="font-size:10px;font-weight:400;background:#6D28D9;color:#fff;padding:1px 7px;border-radius:8px">'+rows.length+'</span></div>'
    +'<div style="max-height:360px;overflow-y:auto">';
  rows.forEach(function(o){
    // Destinatario = cualquiera del equipo del departamento
    var _pe=(o.para_email||'').toLowerCase();
    var _mios=_equipoEmails(); if(!_mios.length) _mios=[email];
    var soyDestino=_mios.some(function(e){ return e && _pe.indexOf(e)>=0; });
    var col=_repEnvioColor(o.estado);
    var fEnv=o.enviado_en?new Date(o.enviado_en).toLocaleString('es'):'';
    var fRec=o.recibido_en?new Date(o.recibido_en).toLocaleString('es'):'';
    var fProv=o.enviado_proveedor_en?new Date(o.enviado_proveedor_en).toLocaleString('es'):'';
    h+='<div style="border-top:0.5px solid var(--border);border-left:4px solid '+col+';padding:10px 12px;display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:180px">'
        +'<div style="font-size:12.5px;font-weight:600">'
          +(o.num_reposicion?('<span style="background:var(--pastel-lila);border:1px solid #C4B5FD;color:var(--t-lila);'
            +'border-radius:10px;padding:1px 8px;font-size:11px;margin-right:6px">'+_esc(o.num_reposicion)+'</span>'):'')
          +_esc(o.cardcode||'')+(o.cardname?(' — '+_esc(o.cardname)):'')+' '+_repEnvioBadge(o.estado)
          // Para el destinatario: aviso rojo mientras no la abra
          +((soyDestino && !o.recibido_en)?'<span class="rep-nuevo"><i class="ti ti-mail"></i> sin abrir</span>':'')
          // Para quien la envió: palomitas de entregado / leído
          +((!soyDestino)?('<span class="com-chk'+(o.recibido_en?' leido':'')+'" title="'+(o.recibido_en?'Abierta por compras':'Enviada, sin abrir')+'"><i class="ti '+(o.recibido_en?'ti-checks':'ti-check')+'"></i></span>'):'')
        +'</div>'
        +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+(o.dept?((EMOJIS2[o.dept]||'')+' '+_esc(dL(o.dept))+' &middot; '):'')+'Enviada por '+_esc(o.enviado_por||'')+(o.para_email?(' &middot; para '+_esc(o.para_email)):'')+'</div>'
        +(fEnv?('<div style="font-size:11px;color:var(--text-muted);margin-top:2px"><i class="ti ti-send"></i> Reposición enviada a compras: <b>'+fEnv+'</b></div>'):'')
        +(fRec?('<div style="font-size:11px;color:#2563eb;margin-top:1px"><i class="ti ti-inbox"></i> Recibida por compras: <b>'+fRec+'</b>'+(o.recibido_por?(' ('+_esc(o.recibido_por)+')'):'')+'</div>'):'')
        +(fProv?('<div style="margin-top:5px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:13px;font-weight:700;color:var(--t-verde)"><i class="ti ti-send"></i> Enviada a proveedor &middot; '+fProv+(o.enviado_proveedor_por?(' ('+_esc(o.enviado_proveedor_por)+')'):'')+'</div>'):'')
        +(o.estado==='orden_creada'?('<div style="margin-top:5px;background:#bbf7d0;border:1px solid #15803d;border-radius:8px;padding:7px 10px;font-size:13px;font-weight:700;color:#14532d"><i class="ti ti-circle-check"></i> Orden aprobada y firmada'+(o.orden_dkc?(' &middot; '+_esc(o.orden_dkc)):'')+'</div>'
            +_repDifLinea(o)):'')
      +'</div>';
    if(o.archivo_path){
      if(soyDestino) h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_repEnvioVer('+o.id+',\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'reposicion')+'\','+(o.recibido_en?'true':'false')+')"><i class="ti ti-file"></i> Ver</button>';
      else h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_repEnvioVerGer(\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'reposicion')+'\')"><i class="ti ti-file"></i> Ver</button>';
    }
    // La compradora puede corregir la reposición antes de mandarla: a veces
    // gerencia se equivoca en una cantidad y no hay que rehacer todo.
    if(soyDestino && !_repYaEnviada(o) && o.cardcode)
      h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" title="Abrir la reposición para corregir cantidades" onclick="_repEnvioModificar('+o.id+',\''+_esc(o.cardcode)+'\','+(o.pedido_id||'null')+')"><i class="ti ti-edit"></i> Modificar</button>';
    if(soyDestino && !_repYaEnviada(o)) h+='<button class="btn bp" style="padding:5px 9px;font-size:11px" onclick="_repEnvioProveedor('+o.id+','+(o.pedido_id||'null')+')"><i class="ti ti-send"></i> Enviar a proveedor</button>';
    // Gerencia puede borrar cualquier reposición, con su archivo
    if(_esGerencia()) h+='<button class="btn bg2" title="Borrar esta reposición y su archivo" style="padding:5px 9px;font-size:11px;color:var(--text-danger);font-weight:600" onclick="_gerBorrarReposicion('+o.id+',\''+_esc(o.archivo_path||'')+'\')"><i class="ti ti-trash"></i></button>';
    else if(email && (o.enviado_por_email||'').toLowerCase()===email) h+='<button class="btn bg2" title="Eliminar esta reposición" style="padding:5px 9px;font-size:11px;color:var(--text-danger)" onclick="_repEnvioBorrar('+o.id+')"><i class="ti ti-trash"></i></button>';
    h+=_chatBtn('reposicion', o.id, (o.cardcode||'')+' '+(o.cardname||''));
    h+='</div>';
  });
  h+='</div></div>';
  box.innerHTML=h;
  try{ _chatBadges('reposicion', rows.map(function(o){return o.id;})); }catch(e){}
}
function _repEnvioVerGer(path,nombre){ if(!path)return; verArchivo(DOCS_BASE+path.split('/').map(encodeURIComponent).join('/'),nombre); }
function _repEnvioVer(id,path,nombre,yaRec){ _repEnvioVerGer(path,nombre); if(!yaRec) _repEnvioRecibir(id); }
async function _repEnvioRecibir(id){
  try{
    await _firmaWrite(SB+'/rest/v1/reposiciones_envios?id=eq.'+id,'PATCH',{estado:'recibida',recibido_en:new Date().toISOString(),recibido_por:(CU&&CU.name)||''},['recibido_por']);
    try{ addNotif('gerencia','Reposición recibida por compras ('+((CU&&CU.name)||'')+')','','ti-inbox'); }catch(e){}
    _repEnviosCargar();
    try{ _repBadgeActualizar(); }catch(e){}
  }catch(e){ console.warn('rep recibir:',e); }
}
// La compradora reenvía la reposición al proveedor con el mismo correo que
// le mandó gerencia. Antes solo se marcaba el estado, sin enviar nada.
// Abre la reposición del proveedor para corregirla. Lo que se guarde
// reemplaza al archivo original cuando se mande al proveedor.
async function _repEnvioModificar(id, cardcode, pedidoId){
  var o=(window._repEnvios||[]).find(function(x){ return String(x.id)===String(id); });
  if(!o){ showT('No se encontró la reposición'); return; }
  if(!confirm('¿Abrir la reposición de '+(o.cardname||cardcode)+' para modificarla?\n\n'
    +'Vas a poder cambiar las cantidades. Cuando termines, generá el archivo de nuevo '
    +'y usá "Enviar a proveedor" desde aquí.')) return;

  // Queda anotado para poder volver y saber qué se está corrigiendo
  window._repModificando={id:id, cardcode:cardcode, pedidoId:pedidoId,
                          cardname:o.cardname||'', desde:Date.now()};
  // Quién la mandó desde gerencia: va en el "On behalf of" del correo
  window._repOrigenNombre=o.enviado_por||'';
  try{ localStorage.setItem('repModificando', JSON.stringify(window._repModificando)); }catch(e){}

  go('reposiciones');
  setTimeout(function(){
    var inp=document.getElementById('rep-code');
    if(inp){ inp.value=cardcode; }
    _repPedidoId=pedidoId||null;
    try{ repGenerar(); }catch(e){ console.warn('abrir reposición:',e); }
    showT('Corregí las cantidades y volvé a generar el archivo');
  }, 260);
}

// Aviso mientras se está corrigiendo una reposición ya enviada
function _repModificandoAviso(){
  var m=window._repModificando;
  if(!m){
    try{
      var v=localStorage.getItem('repModificando');
      if(v){ m=JSON.parse(v); window._repModificando=m; }
    }catch(e){}
  }
  if(!m || !m.cardcode) return '';
  // A las dos horas se olvida solo, para no quedar pegado
  if(m.desde && (Date.now()-m.desde)>2*60*60*1000){ _repModificandoFin(); return ''; }
  if(String(_repCard||'')!==String(m.cardcode)) return '';
  return '<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;'
    +'padding:9px 12px;margin-bottom:10px;display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
    +'<i class="ti ti-edit" style="color:var(--t-marron)"></i>'
    +'<span style="font-size:11.5px;color:var(--t-marron);flex:1">'
      +'Estás <b>corrigiendo</b> la reposición que te envió gerencia'
      +(m.cardname?(' para '+_esc(m.cardname)):'')+'. '
      +'Cuando termines, generá el archivo y enviá al proveedor desde el seguimiento.</span>'
    +'<button class="btn bg2" style="padding:4px 10px;font-size:10.5px" onclick="_repModificandoFin()">'
      +'Ya no la estoy corrigiendo</button>'
    +'</div>';
}

function _repModificandoFin(){
  window._repModificando=null;
  try{ localStorage.removeItem('repModificando'); }catch(e){}
  try{ if(_repData && _repData.length) repRenderResumen(_repData, _repCard); }catch(e){}
}

async function _repEnvioProveedor(id, pedidoId){
  var o=(window._repEnvios||[]).find(function(x){ return String(x.id)===String(id); });
  if(!o){ showT('No se encontró la reposición'); return; }
  window._repProvCtx={id:id, pedidoId:pedidoId, envio:o};
  window._repOrigenNombre=o.enviado_por||'';
  window._mailAdj=[];

  // El proveedor, con su correo si lo tenemos
  var prov=null;
  try{
    var r=await fetch(SB+'/rest/v1/proveedores?select=cardcode,cardname,email&cardcode=eq.'
      +encodeURIComponent(o.cardcode||'')+'&limit=1',{headers:SBH});
    if(r.ok){ var a=await r.json(); prov=(Array.isArray(a)&&a[0])?a[0]:null; }
  }catch(e){}
  var correoProv=(prov&&prov.email)||'';

  var asunto=o.mail_asunto || o.resumen || ('Reposicion '+(o.cardcode||''));
  var cuerpo=o.mail_cuerpo || ('Estimados,\n\n'
    +'Adjunto el pedido de reposición.\n\n'
    +'Proveedor: '+(o.cardname||o.cardcode||'')+'\n\n'
    +'Quedamos atentos a su confirmación.\n\n'
    +'Saludos cordiales,\n'+_firmaNombre()+'\nKennedy Center Corp.');

  var prev=document.getElementById('modalRepProv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalRepProv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:660px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)">'
        +'<i class="ti ti-send"></i> Enviar la reposición al proveedor</div>'
      +'<button onclick="_repProvModalCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:9px 11px;'
      +'margin-bottom:12px;font-size:11.5px;color:var(--t-azul)">'
      +'<b>'+_esc(o.cardcode||'')+'</b> '+_esc(o.cardname||'')
      +'<div style="margin-top:2px">Es el mismo correo que te envió '
      +_esc(o.enviado_por||'gerencia')+'. Puedes ajustarlo antes de mandarlo.</div></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">PARA · el proveedor</div>'
    +'<input id="repprov-para" value="'+_esc(correoProv)+'" '
      +'placeholder="correo@proveedor.com — separá varios con coma" '
      +'style="width:100%;padding:8px 10px;border:0.5px solid '+(correoProv?'var(--border)':'#E9C08A')
      +';border-radius:8px;font-size:13px;margin-bottom:4px;background:var(--surface-2);color:var(--text-primary)">'
    +(correoProv?'':'<div style="font-size:10.5px;color:var(--t-marron);margin-bottom:8px">'
      +'<i class="ti ti-alert-circle"></i> Este proveedor no tiene correo guardado. Escribilo aquí.</div>')
    +'<div style="font-size:11px;color:var(--text-muted);margin:8px 0 5px">CON COPIA · marcá a quien quieras</div>'
    +'<div id="repprov-users" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); })
        .map(function(u){
          var marcado=(String(u.email||'').toLowerCase()===String(o.enviado_por_email||'').toLowerCase());
          return '<label style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
            +(marcado?'#0c447c':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;'
            +'background:'+(marcado?'#e6f1fb':'var(--surface-0)')+'">'
            +'<input type="checkbox" value="'+_esc(u.email)+'"'+(marcado?' checked':'')
            +' style="margin:0;cursor:pointer">'
            +'<span>'+_esc(u.name)+'</span>'
            +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
            +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
        }).join('')
    +'</div>'
    +'<input id="repprov-cc" placeholder="Otros correos, separados por coma" '
      +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="repprov-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;'
      +'background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="repprov-cuerpo" rows="14" style="width:100%;padding:8px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;'
      +'background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTO</div>'
    +'<div id="repprov-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px">'
      +'<span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando la reposición…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_repProvModalCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="repprov-btn" style="background:#0c447c" onclick="_repProvEnviar()">'
        +'<i class="ti ti-send"></i> Enviar al proveedor</button>'
    +'</div></div>';
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
  _modalEsc(ov);

  // El archivo de la reposición, el mismo que mandó gerencia
  var aviso=document.getElementById('repprov-auto');

  // El PDF y el Excel: los dos archivos que mandó gerencia
  var lista=[];
  try{
    var arch=o.archivos;
    if(typeof arch==='string'){ try{ arch=JSON.parse(arch); }catch(e){ arch=null; } }
    if(Array.isArray(arch) && arch.length) lista=arch;
  }catch(e){}
  if(!lista.length && o.archivo_path){
    lista=[{path:o.archivo_path, nombre:o.archivo_nombre||('Reposicion_'+(o.cardcode||'')+'.xlsx')}];
  }

  if(lista.length){
    var puestos=[], fallos=[];
    for(var i=0;i<lista.length;i++){
      try{
        var motivo={};
        var adj=await _solPagoAdjuntarDeStorage(lista[i].path, lista[i].nombre, motivo);
        if(adj){ window._mailAdj.push(adj); puestos.push(adj.nombre); }
        else fallos.push(lista[i].nombre+(motivo.txt?(' ('+motivo.txt+')'):''));
      }catch(e){ fallos.push(lista[i].nombre); }
    }
    mailPintarAdjuntos();
    if(aviso){
      aviso.innerHTML=(puestos.length
        ? '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '
          +_esc(puestos.join(' · '))+'</span>'
        : '')
        +(fallos.length
          ? ('<div style="color:var(--t-ambar);margin-top:3px"><i class="ti ti-alert-circle"></i> '
             +'No se pudo adjuntar: '+_esc(fallos.join(', '))+'. Adjuntalo a mano.</div>')
          : '');
    }
  } else {
    if(aviso) aviso.innerHTML='<span style="color:var(--t-ambar)">'
      +'<i class="ti ti-alert-circle"></i> Esta reposición no tiene archivos guardados. Adjuntalos a mano.</span>';
  }
}

// Cierra el modal de "enviar al proveedor". Antes se llamaba igual que el
// del desplegable de proveedores y, al estar definida después, lo pisaba:
// elegir un proveedor ejecutaba ESTA y el desplegable nunca se cerraba.
function _repProvModalCerrar(){
  var m=document.getElementById('modalRepProv'); if(m) m.remove();
  window._mailAdj=[]; window._repProvCtx=null;
}

async function _repProvEnviar(){
  var ctx=window._repProvCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var o=ctx.envio;

  var para=((document.getElementById('repprov-para')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var cc=((document.getElementById('repprov-cc')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  // Los usuarios del portal que se marcaron
  var box=document.getElementById('repprov-users');
  if(box){
    Array.prototype.slice.call(box.querySelectorAll('input:checked')).forEach(function(c){
      if(cc.indexOf(c.value)<0) cc.push(c.value);
    });
  }
  if(!para.length){ _mailMsg('Escribe el correo del proveedor.','err'); return; }

  var asunto=(document.getElementById('repprov-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('repprov-cuerpo')||{}).value||'';
  if(!(window._mailAdj||[]).length){
    if(!confirm('No hay ningún archivo adjunto.\n\n¿Enviar igual?')) return;
  }

  var btn=document.getElementById('repprov-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:'', para_lista:todos, para_email:para[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Reposición al proveedor · '+(o.cardcode||''), estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
    return;
  }

  // Recién con el correo enviado se marca el estado
  try{
    await _firmaWrite(SB+'/rest/v1/reposiciones_envios?id=eq.'+ctx.id,'PATCH',
      {estado:'enviada_proveedor', enviado_proveedor_en:new Date().toISOString(),
       enviado_proveedor_por:(CU&&CU.name)||'', enviado_proveedor_a:para.join(', ')},
      ['enviado_proveedor_en']);
    if(ctx.pedidoId){
      try{
        await _firmaWrite(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+ctx.pedidoId,'PATCH',
          {estado:'finalizado', terminado_en:new Date().toISOString(),
           actualizado_en:new Date().toISOString()},['terminado_en']);
      }catch(e){}
    }
  }catch(e){ console.warn('marcar enviada:',e); }

  // Y se avisa a quien la mandó, más la gerencia del departamento
  try{
    var destinos=[];
    var quien=(USERS||[]).find(function(u){
      return String(u.email||'').toLowerCase()===String(o.enviado_por_email||'').toLowerCase()
          || u.name===o.enviado_por;
    });
    if(quien) destinos.push(quien);
    (USERS||[]).forEach(function(u){
      if(u.role!=='gerencia' || !u.id) return;
      if(o.dept && u.dept && String(u.dept)!==String(o.dept)) return;
      if(destinos.some(function(z){ return z.id===u.id; })) return;
      destinos.push(u);
    });
    destinos=destinos.filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length){
      await _menNotificar(destinos, {
        docnum:'', contexto:'reposicion',
        texto:'Reposición enviada al proveedor '+(o.cardname||o.cardcode||'')
          +' por '+((CU&&CU.name)||'')+' · a '+para.join(', '),
        etiqueta:'Reposición enviada al proveedor'
      });
    }
    addNotif('gerencia','Reposición enviada al proveedor por '+((CU&&CU.name)||''),'','ti-send', true);
  }catch(e){ console.warn('aviso a gerencia:',e); }

  _repProvModalCerrar();
  showT('✓ Reposición enviada al proveedor');
  _repEnviosCargar();
}

async function _repEnvioBorrar(id){
  if(!confirm('¿Seguro que deseas eliminar esta reposición? Esta acción no se puede deshacer.')) return;
  try{ await fetch(SB+'/rest/v1/reposiciones_envios?id=eq.'+id,{method:'DELETE',headers:SBH}); showT('Reposición eliminada'); _repEnviosCargar(); }catch(e){ showT('Error al eliminar: '+(e.message||e)); }
}

// ═══════════════════════════════════════════════════════════════════════════
//  CHAT DE COMENTARIOS (live) con acuse tipo WhatsApp
//  Doble check gris = entregado · Doble check verde = leído
//  Requiere la tabla Supabase: comentarios_chat (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
var _chatCtx=null, _chatRef=null, _chatTitulo='', _chatTimer=null;
function _chatIdActual(){ return (CU&&CU.id)||''; }
async function _chatAbrir(contexto, refId, titulo){
  _chatCtx=contexto; _chatRef=refId; _chatTitulo=titulo||'';
  var ov=document.createElement('div');
  ov.id='chat-overlay';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2100;display:flex;align-items:center;justify-content:center;padding:14px';
  var h='<div style="background:var(--surface-0);border-radius:12px;width:100%;max-width:480px;height:80vh;max-height:640px;display:flex;flex-direction:column;overflow:hidden">';
  h+='<div style="background:#075E54;color:#fff;padding:11px 14px;display:flex;align-items:center;gap:8px"><i class="ti ti-message-circle"></i><div style="flex:1;min-width:0"><div style="font-size:13px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">Comentarios</div><div style="font-size:10px;opacity:.85;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(_chatTitulo)+'</div></div><button onclick="_chatCerrar()" style="background:none;border:none;color:#fff;font-size:22px;cursor:pointer;line-height:1">&times;</button></div>';
  h+='<div id="chat-body" style="flex:1;overflow-y:auto;padding:12px;background:#ECE5DD;display:flex;flex-direction:column;gap:6px"><div style="text-align:center;color:#667;font-size:11px;margin:auto"><i class="ti ti-loader-2 spin"></i> Cargando...</div></div>';
  h+='<div style="display:flex;gap:6px;padding:9px;background:var(--surface-1);border-top:0.5px solid var(--border)"><input id="chat-input" placeholder="Escribe un comentario..." onkeydown="if(event.key===\'Enter\')_chatEnviar()" style="flex:1;padding:9px 12px;border:0.5px solid var(--border);border-radius:20px;font-size:13px;background:var(--surface-2);color:var(--text-primary)"><button onclick="_chatEnviar()" class="btn bp" style="border-radius:50%;width:40px;height:40px;padding:0"><i class="ti ti-send"></i></button></div>';
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) _chatCerrar(); });
  document.body.appendChild(ov);
  await _chatCargar();
  _chatTimer=setInterval(_chatCargar, 4000);
}
function _chatCerrar(){
  if(_chatTimer){ clearInterval(_chatTimer); _chatTimer=null; }
  var ov=document.getElementById('chat-overlay'); if(ov) ov.remove();
  try{ if(_chatCtx!=null && _chatRef!=null) _chatBadges(_chatCtx,[_chatRef]); }catch(e){}
}
function _chatChecks(m){
  if(m.autor!==_chatIdActual()) return '';
  var otros=(m.leido_por||'').split(',').map(function(s){return s.trim();}).filter(function(x){return x && x!==_chatIdActual();});
  var leido=otros.length>0;
  return '<i class="ti ti-checks" style="font-size:13px;margin-left:5px;vertical-align:-1px;color:'+(leido?'#34B7F1':'#9aa4a0')+'" title="'+(leido?'Leído':'Entregado')+'"></i>';
}
async function _chatCargar(){
  var body=document.getElementById('chat-body'); if(!body || _chatRef==null) return;
  try{
    var r=await fetch(SB+'/rest/v1/comentarios_chat?contexto=eq.'+encodeURIComponent(_chatCtx)+'&ref_id=eq.'+encodeURIComponent(_chatRef)+'&select=*&order=creado_en.asc&limit=500',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    var yo=_chatIdActual();
    var h='';
    if(!rows.length){ h='<div style="text-align:center;color:#667;font-size:11px;margin:auto">Sin comentarios todavía. Escribe el primero.</div>'; }
    rows.forEach(function(m){
      var mio=(m.autor===yo);
      var hora=m.creado_en?new Date(m.creado_en).toLocaleString('es',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
      h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';max-width:82%;background:'+(mio?'#DCF8C6':'#fff')+';border-radius:9px;padding:6px 9px;box-shadow:0 1px 1px rgba(0,0,0,.08)">'
        +(mio?'':'<div style="font-size:10px;font-weight:700;color:#075E54;margin-bottom:1px">'+_esc(m.autor_nom||m.autor||'')+(m.autor_rol?(' · '+_esc(m.autor_rol)):'')+'</div>')
        +'<div style="font-size:12.5px;color:var(--text-primary);white-space:pre-wrap;word-break:break-word">'+_esc(m.mensaje||'')+'</div>'
        +'<div style="font-size:9px;color:#8a938f;text-align:right;margin-top:2px">'+hora+_chatChecks(m)+'</div>'
      +'</div>';
    });
    var nearBottom=(body.scrollTop+body.clientHeight >= body.scrollHeight-60);
    body.innerHTML=h;
    if(nearBottom) body.scrollTop=body.scrollHeight;
    // Marcar como leídos los que no son míos
    _chatMarcarLeidos(rows);
  }catch(e){ /* silencioso */ }
}
async function _chatMarcarLeidos(rows){
  var yo=_chatIdActual(); if(!yo) return;
  var pend=rows.filter(function(m){ var l=(m.leido_por||''); return m.autor!==yo && l.split(',').map(function(s){return s.trim();}).indexOf(yo)<0; });
  for(var i=0;i<pend.length;i++){
    var m=pend[i];
    var nuevo=((m.leido_por||'').trim()? (m.leido_por.trim()+','+yo) : yo);
    try{ await fetch(SB+'/rest/v1/comentarios_chat?id=eq.'+m.id,{method:'PATCH',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({leido_por:nuevo})}); }catch(e){}
  }
}
async function _chatEnviar(){
  var inp=document.getElementById('chat-input'); if(!inp) return;
  var txt=(inp.value||'').trim(); if(!txt) return;
  inp.value='';
  var payload={ contexto:_chatCtx, ref_id:_chatRef, autor:(CU&&CU.id)||'', autor_nom:(CU&&CU.name)||'', autor_rol:(CU&&CU.role)||'', mensaje:txt, leido_por:'', creado_en:new Date().toISOString() };
  try{
    var r=await fetch(SB+'/rest/v1/comentarios_chat',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(payload)});
    if(!r.ok){ var t=await r.text(); console.error('chat insert',r.status,t); showT('No se pudo enviar (¿existe la tabla comentarios_chat?)'); inp.value=txt; return; }
    await _chatCargar();
  }catch(e){ console.error(e); showT('Error: '+(e.message||e)); inp.value=txt; }
}
// Actualiza el badge de no-leídos en los botones "Comentarios" de una lista
async function _chatBadges(contexto, ids){
  try{
    ids=(ids||[]).filter(function(x){return x!=null;});
    if(!ids.length) return;
    var yo=_chatIdActual();
    var inList='('+ids.join(',')+')';
    var r=await fetch(SB+'/rest/v1/comentarios_chat?contexto=eq.'+encodeURIComponent(contexto)+'&ref_id=in.'+inList+'&select=ref_id,autor,leido_por&limit=2000',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    var cnt={};
    rows.forEach(function(m){
      var l=(m.leido_por||'').split(',').map(function(s){return s.trim();});
      if(m.autor!==yo && l.indexOf(yo)<0){ cnt[m.ref_id]=(cnt[m.ref_id]||0)+1; }
    });
    ids.forEach(function(id){
      var b=document.getElementById('chatbtn-'+contexto+'-'+id); if(!b) return;
      var badge=b.querySelector('.chat-badge'); if(!badge) return;
      var n=cnt[id]||0;
      badge.textContent=n>0?n:'';
      badge.style.display=n>0?'inline-flex':'none';
    });
  }catch(e){}
}
// HTML del botón de comentarios (con badge de no leídos)
function _chatBtn(contexto, id, titulo){
  var t=String(titulo||'').replace(/['"\\]/g,'').slice(0,60);
  return '<button id="chatbtn-'+contexto+'-'+id+'" class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_chatAbrir(\''+contexto+'\','+id+',\''+_esc(t)+'\')"><i class="ti ti-message"></i> Comentarios<span class="chat-badge" style="display:none;align-items:center;justify-content:center;min-width:16px;height:16px;padding:0 4px;margin-left:5px;background:#dc2626;color:#fff;border-radius:9px;font-size:9px;font-weight:700"></span></button>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  LIVE CHAT entre usuarios (estilo WhatsApp) — mensajes directos + adjuntos
//  Doble check gris = entregado · Doble check verde = leído
//  Requiere la tabla Supabase: mensajes_dm (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════════════
//  LIVE CHAT entre usuarios (estilo WhatsApp) — texto, voz, stickers, adjuntos,
//  fotos de perfil, editar/borrar/reenviar, marcar no leído, vaciar chat.
//  Tablas: mensajes_dm, perfiles, dm_marcas (ver SQL).
// ═══════════════════════════════════════════════════════════════════════════
var _dmPartner=null, _dmTimer=null, _dmArchivo=null, _dmMsgs={}, _dmLimpiadoEn=null, _dmFwd=null;
var _dmRec=null, _dmRecChunks=[];
window._perfiles=window._perfiles||{};
window._dmMarcas=window._dmMarcas||{};
var _dmColores={gerencia:'#EAF3DE',compras:'#e6f1fb',diseno:'#EEEDFE',importacion:'#E1F5EE',contabilidad:'#FBEAF0',bodega:'#FEF3E8'};
var _dmTc={gerencia:'#27500A',compras:'#0c447c',diseno:'#3C3489',importacion:'#085041',contabilidad:'#72243E',bodega:'#7C3D12'};
var _DM_STICKERS=['👍','🔥','🎉','💪','✅','🚀','☕','😎','🙌','🤝','💯','🧠'];
function _dmYo(){ return (CU&&CU.id)||''; }
function _dmUser(id){ return (USERS||[]).find(function(u){return u.id===id;})||{id:id,name:id,role:''}; }
async function _dmWrite(url,method,body,dropKeys){
  var r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(body)});
  if(!r.ok && dropKeys && dropKeys.length){ var b=Object.assign({},body); dropKeys.forEach(function(k){delete b[k];}); r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(b)}); }
  return r;
}

// ── Perfiles (foto) ──
async function _perfilesCargar(){
  try{ var r=await fetch(SB+'/rest/v1/perfiles?select=id,foto_path&limit=500',{headers:SBH}); var rows=r.ok?(await r.json()):[]; var mp={}; (rows||[]).forEach(function(x){ if(x&&x.foto_path) mp[x.id]=x.foto_path; }); window._perfiles=mp; _perfilRefrescarTop(); }catch(e){}
}
function _fotoPerfil(uid){ var p=window._perfiles&&window._perfiles[uid]; return p?(DOCS_BASE+p.split('/').map(encodeURIComponent).join('/')):null; }
function _avatarHTML(uid,name,role,size){
  var url=_fotoPerfil(uid); var s=size||38;
  if(url) return '<div style="width:'+s+'px;height:'+s+'px;border-radius:50%;flex-shrink:0;background:#ddd;background-image:url('+url+');background-size:cover;background-position:center"></div>';
  var u=_dmUser(uid);
  return '<div style="width:'+s+'px;height:'+s+'px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:'+Math.round(s*0.34)+'px;font-weight:700;background:'+(_dmColores[role||u.role]||'#eee')+';color:'+(_dmTc[role||u.role]||'#333')+'">'+_esc(u.ini||ini(name||uid||'?'))+'</div>';
}
function _perfilRefrescarTop(){ var el=document.getElementById('topAvatar'); if(el){ var url=_fotoPerfil(_dmYo()); if(url){ el.style.backgroundImage='url('+url+')'; el.style.backgroundSize='cover'; el.style.backgroundPosition='center'; el.textContent=''; } } }
function _perfilCambiar(){
  var inp=document.createElement('input'); inp.type='file'; inp.accept='image/*';
  inp.onchange=async function(){ var f=inp.files&&inp.files[0]; if(!f)return; showT('Subiendo foto...'); try{ var path=await _subirDocStorage('perfil', _dmYo(), f); await fetch(SB+'/rest/v1/perfiles?on_conflict=id',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),body:JSON.stringify({id:_dmYo(),foto_path:path,actualizado_en:new Date().toISOString()})}); await _perfilesCargar(); showT('✓ Foto actualizada'); if(PG==='livechat'){ if(_dmPartner) _dmAbrir(_dmPartner); else rLiveChat(); } }catch(e){ showT('Error: '+(e.message||e)); } };
  inp.click();
}

// ── Marcas (no leído / vaciado) ──
async function _dmMarca(con, obj){ try{ await fetch(SB+'/rest/v1/dm_marcas?on_conflict=usuario,con',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),body:JSON.stringify(Object.assign({usuario:_dmYo(),con:con},obj))}); }catch(e){} }
async function _dmMarcasCargar(){
  try{ var r=await fetch(SB+'/rest/v1/dm_marcas?usuario=eq.'+encodeURIComponent(_dmYo())+'&select=con,no_leido,limpiado_en&limit=500',{headers:SBH}); var rows=r.ok?(await r.json()):[]; var mp={}; (rows||[]).forEach(function(x){ mp[x.con]=x; }); window._dmMarcas=mp; }catch(e){ window._dmMarcas={}; }
}

// ── Lista de contactos ──
async function rLiveChat(){
  if(_dmTimer){ clearInterval(_dmTimer); _dmTimer=null; }
  _dmPartner=null;
  var cont=document.getElementById('page-livechat'); if(!cont) return;
  cont.innerHTML='<div style="font-size:14px;font-weight:700;margin-bottom:4px"><i class="ti ti-messages"></i> Live Chat</div><div id="dm-contactos"><div class="empty" style="padding:16px"><i class="ti ti-loader-2 spin"></i> Cargando...</div></div>';
  try{
    await _perfilesCargar(); await _dmMarcasCargar();
    var yo=_dmYo();
    var r=await fetch(SB+'/rest/v1/mensajes_dm?or=(de.eq.'+encodeURIComponent(yo)+',para.eq.'+encodeURIComponent(yo)+')&select=de,para,mensaje,adjunto_nombre,tipo,borrado,leido_en,creado_en&order=creado_en.desc&limit=1500',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    var last={}, unread={};
    rows.forEach(function(m){
      var other=(m.de===yo)?m.para:m.de;
      if(!last[other]) last[other]=m;
      if(m.para===yo && m.de===other && !m.leido_en) unread[other]=(unread[other]||0)+1;
    });
    var otros=(USERS||[]).filter(function(u){ return u.id!==yo; });
    otros.sort(function(a,b){ var ta=last[a.id]?new Date(last[a.id].creado_en).getTime():0; var tb=last[b.id]?new Date(last[b.id].creado_en).getTime():0; return tb-ta; });
    var h='<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px">Elige a quién escribirle. Cualquier usuario puede escribirte.</div><div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">';
    otros.forEach(function(u){
      var lm=last[u.id]; var n=unread[u.id]||0; var marca=window._dmMarcas[u.id]||{};
      var prevTxt = lm ? (lm.borrado?'Mensaje eliminado':(lm.tipo==='voz'?'🎤 Mensaje de voz':(lm.tipo==='sticker'?(lm.mensaje||'Sticker'):(lm.adjunto_nombre?('📎 '+lm.adjunto_nombre):(lm.mensaje||''))))) : 'Sin mensajes aún';
      var prev=(lm&&lm.de===yo?'Tú: ':'')+prevTxt;
      var hora=lm?new Date(lm.creado_en).toLocaleString('es',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
      h+='<div style="display:flex;align-items:center;gap:10px;padding:9px 12px;border-top:0.5px solid var(--border)">'
        +'<div onclick="_dmAbrir(\''+u.id+'\')" style="display:flex;align-items:center;gap:10px;flex:1;min-width:0;cursor:pointer">'
          +_avatarHTML(u.id,u.name,u.role,40)
          +'<div style="flex:1;min-width:0"><div style="font-size:13px;font-weight:600;display:flex;justify-content:space-between;gap:8px"><span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(u.name)+'</span><span style="font-size:9px;color:var(--text-muted);font-weight:400;flex-shrink:0">'+hora+'</span></div>'
            +'<div style="font-size:11px;color:var(--text-muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(prev)+'</div></div>'
        +'</div>'
        +(n>0?'<span style="background:#16a34a;color:#fff;border-radius:999px;min-width:18px;height:18px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;padding:0 5px;flex-shrink:0">'+n+'</span>':'')
        +((marca.no_leido&&!n)?'<span title="Marcado como no leído" style="width:11px;height:11px;border-radius:50%;background:#16a34a;flex-shrink:0"></span>':'')
        +'<span onclick="event.stopPropagation();_dmContactoMenu(\''+u.id+'\')" style="cursor:pointer;color:var(--text-muted);padding:2px 4px;flex-shrink:0"><i class="ti ti-dots-vertical"></i></span>'
      +'</div>';
    });
    h+='</div>';
    document.getElementById('dm-contactos').innerHTML=h;
    _dmActualizarBadge();
  }catch(e){ document.getElementById('dm-contactos').innerHTML='<div class="empty" style="color:var(--text-danger);padding:14px">Error al cargar: '+(e.message||e)+'</div>'; }
}
function _dmContactoMenu(uid){
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  function it(icon,txt,fn,col){ return '<div onclick="'+fn+'" style="padding:12px 16px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:10px;border-bottom:0.5px solid var(--border);color:'+(col||'var(--text)')+'"><i class="ti '+icon+'"></i> '+txt+'</div>'; }
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;min-width:220px">'+it('ti-mail-off','Marcar como no leído','_dmCerrarMenu();_dmMarcarNoLeido(\''+uid+'\')')+it('ti-eraser','Vaciar chat (solo para mí)','_dmCerrarMenu();_dmVaciarCon(\''+uid+'\')','#dc2626')+it('ti-x','Cancelar','_dmCerrarMenu()')+'</div>';
  ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
async function _dmMarcarNoLeido(uid){ await _dmMarca(uid,{no_leido:true}); rLiveChat(); }
async function _dmVaciarCon(uid){ if(!confirm('¿Vaciar el chat con este usuario? (solo se oculta para ti)'))return; await _dmMarca(uid,{limpiado_en:new Date().toISOString(),no_leido:false}); rLiveChat(); }

// ── Conversación ──
function _dmAbrir(uid){
  if(_dmTimer){ clearInterval(_dmTimer); _dmTimer=null; }
  _dmPartner=uid; _dmArchivo=null;
  var marca=(window._dmMarcas&&window._dmMarcas[uid])||{}; _dmLimpiadoEn=marca.limpiado_en?new Date(marca.limpiado_en).getTime():null;
  _dmMarca(uid,{no_leido:false});
  var u=_dmUser(uid);
  var cont=document.getElementById('page-livechat'); if(!cont) return;
  var h='<div style="display:flex;flex-direction:column;height:78vh;border:0.5px solid var(--border);border-radius:12px;overflow:hidden">';
  h+='<div style="background:#075E54;color:#fff;padding:9px 12px;display:flex;align-items:center;gap:10px"><button onclick="rLiveChat()" style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer"><i class="ti ti-arrow-left"></i></button>'
    +_avatarHTML(uid,u.name,u.role,34)
    +'<div style="flex:1;min-width:0"><div style="font-size:13px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(u.name)+'</div><div style="font-size:10px;opacity:.85">'+_esc((u.role||'')+(u.dept?(' · '+dL(u.dept)):''))+'</div></div>'
    +'<button onclick="_dmConvMenu()" style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer"><i class="ti ti-dots-vertical"></i></button></div>';
  h+='<div id="dm-conv" style="flex:1;overflow-y:auto;padding:12px;background:#ECE5DD;display:flex;flex-direction:column;gap:6px"><div style="text-align:center;color:#667;font-size:11px;margin:auto"><i class="ti ti-loader-2 spin"></i></div></div>';
  h+='<div id="dm-file-hint" style="display:none;font-size:11px;color:#075E54;background:#e7f3f0;padding:5px 12px"></div>';
  h+='<div id="dm-stickerbar" style="display:none;flex-wrap:wrap;gap:6px;padding:8px;background:var(--surface-1);border-top:0.5px solid var(--border);max-height:120px;overflow-y:auto"></div>';
  h+='<div style="display:flex;gap:4px;padding:8px;background:var(--surface-1);border-top:0.5px solid var(--border);align-items:center">'
    +'<button onclick="_dmToggleStickers()" title="Stickers" style="background:none;border:none;color:var(--text-muted);cursor:pointer;padding:5px"><i class="ti ti-mood-smile" style="font-size:19px"></i></button>'
    +'<label style="cursor:pointer;color:var(--text-muted);padding:5px"><i class="ti ti-paperclip" style="font-size:18px"></i><input type="file" onchange="_dmSetArchivo(this)" style="display:none"></label>'
    +'<button id="dm-mic" onclick="_dmGrabarToggle()" title="Mensaje de voz" style="background:none;border:none;color:var(--text-muted);cursor:pointer;padding:5px"><i class="ti ti-microphone" style="font-size:19px"></i></button>'
    +'<input id="dm-input" placeholder="Escribe un mensaje..." onkeydown="if(event.key===\'Enter\')_dmEnviar()" style="flex:1;padding:9px 12px;border:0.5px solid var(--border);border-radius:20px;font-size:13px;background:var(--surface-2);color:var(--text-primary)">'
    +'<button onclick="_dmEnviar()" class="btn bp" style="border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0"><i class="ti ti-send"></i></button></div>';
  h+='</div>';
  cont.innerHTML=h;
  _dmCargarConv();
  _dmTimer=setInterval(_dmCargarConv, 3500);
}
function _dmConvMenu(){
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  function it(icon,txt,fn,col){ return '<div onclick="'+fn+'" style="padding:12px 16px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:10px;border-bottom:0.5px solid var(--border);color:'+(col||'var(--text)')+'"><i class="ti '+icon+'"></i> '+txt+'</div>'; }
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;min-width:220px">'+it('ti-mail-off','Marcar como no leído','_dmCerrarMenu();_dmMarcarNoLeidoDesdeConv()')+it('ti-eraser','Vaciar chat (solo para mí)','_dmCerrarMenu();_dmVaciarConv()','#dc2626')+it('ti-x','Cancelar','_dmCerrarMenu()')+'</div>';
  ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
async function _dmMarcarNoLeidoDesdeConv(){ if(_dmPartner){ await _dmMarca(_dmPartner,{no_leido:true}); rLiveChat(); } }
async function _dmVaciarConv(){ if(!_dmPartner)return; if(!confirm('¿Vaciar este chat? (solo para ti)'))return; await _dmMarca(_dmPartner,{limpiado_en:new Date().toISOString(),no_leido:false}); _dmLimpiadoEn=Date.now(); _dmCargarConv(); }
function _dmToggleStickers(){
  var bar=document.getElementById('dm-stickerbar'); if(!bar)return;
  if(bar.style.display==='flex'){ bar.style.display='none'; return; }
  bar.innerHTML=_DM_STICKERS.map(function(s){ return '<div onclick="_dmSticker(\''+s+'\')" style="font-size:30px;cursor:pointer;padding:4px 6px;border-radius:8px">'+s+'</div>'; }).join('');
  bar.style.display='flex';
}
async function _dmSticker(emoji){ var b=document.getElementById('dm-stickerbar'); if(b)b.style.display='none'; await _dmInsertar({tipo:'sticker',mensaje:emoji}); _dmCargarConv(); }
function _dmSetArchivo(input){ var f=input.files&&input.files[0]; _dmArchivo=f||null; var hint=document.getElementById('dm-file-hint'); if(hint){ if(f){ hint.style.display='block'; hint.innerHTML='<i class="ti ti-paperclip"></i> Adjunto listo: '+_esc(f.name)+' — escribe (opcional) y envía'; } else hint.style.display='none'; } }
function _dmChecks(m){ if(m.de!==_dmYo()) return ''; var leido=!!m.leido_en; return '<i class="ti ti-checks" style="font-size:13px;margin-left:5px;vertical-align:-1px;color:'+(leido?'#34B7F1':'#9aa4a0')+'" title="'+(leido?'Leído':'Entregado')+'"></i>'; }
async function _dmInsertar(extra){
  var payload=Object.assign({ de:_dmYo(), de_nom:(CU&&CU.name)||'', para:_dmPartner, mensaje:'', adjunto_path:null, adjunto_nombre:null, tipo:'texto', leido_en:null, creado_en:new Date().toISOString() }, extra||{});
  return _dmWrite(SB+'/rest/v1/mensajes_dm','POST',payload,['tipo','borrado','borrado_para','editado_en']);
}
async function _dmCargarConv(){
  var conv=document.getElementById('dm-conv'); if(!conv || !_dmPartner || PG!=='livechat'){ if(_dmTimer){clearInterval(_dmTimer);_dmTimer=null;} return; }
  try{
    var yo=_dmYo(), ot=_dmPartner;
    var flt='or=(and(de.eq.'+encodeURIComponent(yo)+',para.eq.'+encodeURIComponent(ot)+'),and(de.eq.'+encodeURIComponent(ot)+',para.eq.'+encodeURIComponent(yo)+'))';
    var r=await fetch(SB+'/rest/v1/mensajes_dm?'+flt+'&select=*&order=creado_en.asc&limit=1000',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    _dmMsgs={}; var h='', vis=0;
    rows.forEach(function(m){
      _dmMsgs[m.id]=m;
      if(_dmLimpiadoEn && new Date(m.creado_en).getTime()<=_dmLimpiadoEn) return;
      var bp=(m.borrado_para||'').split(',').map(function(s){return s.trim();});
      if(bp.indexOf(yo)>=0) return;
      vis++;
      var mio=(m.de===yo);
      var hora=m.creado_en?new Date(m.creado_en).toLocaleString('es',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
      if(m.borrado){
        h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';max-width:82%;background:'+(mio?'#DCF8C6':'#fff')+';border-radius:9px;padding:6px 9px;font-style:italic;color:#8a938f;font-size:12px"><i class="ti ti-ban"></i> Mensaje eliminado</div>';
        return;
      }
      if(m.tipo==='sticker'){
        h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';display:flex;flex-direction:column;align-items:'+(mio?'flex-end':'flex-start')+'"><div style="font-size:54px;line-height:1" onclick="_dmMenu('+m.id+')">'+_esc(m.mensaje||'')+'</div><div style="font-size:9px;color:#8a938f">'+hora+_dmChecks(m)+'</div></div>';
        return;
      }
      var adj='';
      if(m.adjunto_path){
        var url=DOCS_BASE+m.adjunto_path.split('/').map(encodeURIComponent).join('/');
        var nm=(m.adjunto_nombre||m.adjunto_path||'');
        var esImg=/\.(png|jpe?g|gif|webp)$/i.test(nm);
        var esAudio=(m.tipo==='voz')||/\.(webm|ogg|mp3|m4a|wav)$/i.test(nm);
        if(esAudio) adj='<audio controls src="'+url+'" style="max-width:210px;display:block;margin-bottom:3px"></audio>';
        else if(esImg) adj='<img src="'+url+'" onclick="verArchivo(\''+url+'\',\''+_esc(nm)+'\')" style="max-width:180px;max-height:180px;border-radius:8px;cursor:zoom-in;display:block;margin-bottom:3px">';
        else adj='<div onclick="verArchivo(\''+url+'\',\''+_esc(nm)+'\')" style="display:flex;align-items:center;gap:6px;background:rgba(0,0,0,.05);border-radius:7px;padding:6px 8px;cursor:pointer;margin-bottom:3px"><i class="ti ti-file"></i><span style="font-size:11px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:150px">'+_esc(nm)+'</span></div>';
      }
      h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';max-width:82%;background:'+(mio?'#DCF8C6':'#fff')+';border-radius:9px;padding:6px 9px 5px;box-shadow:0 1px 1px rgba(0,0,0,.08);position:relative">'
        +'<span onclick="_dmMenu('+m.id+')" style="position:absolute;top:2px;right:3px;cursor:pointer;color:#9aa4a0;font-size:13px"><i class="ti ti-chevron-down"></i></span>'
        +adj
        +(m.mensaje?('<div style="font-size:12.5px;color:var(--text-primary);white-space:pre-wrap;word-break:break-word;padding-right:12px">'+_esc(m.mensaje)+'</div>'):'')
        +'<div style="font-size:9px;color:#8a938f;text-align:right;margin-top:2px">'+(m.editado_en?'<span style="font-style:italic;margin-right:4px">editado</span>':'')+hora+_dmChecks(m)+'</div>'
      +'</div>';
    });
    if(!vis) h='<div style="text-align:center;color:#667;font-size:11px;margin:auto">Sin mensajes. Escribe el primero.</div>';
    var nb=(conv.scrollTop+conv.clientHeight >= conv.scrollHeight-60);
    conv.innerHTML=h;
    if(nb) conv.scrollTop=conv.scrollHeight;
    if(rows.some(function(m){return m.para===yo && m.de===ot && !m.leido_en;})){
      try{ await fetch(SB+'/rest/v1/mensajes_dm?para=eq.'+encodeURIComponent(yo)+'&de=eq.'+encodeURIComponent(ot)+'&leido_en=is.null',{method:'PATCH',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({leido_en:new Date().toISOString()})}); _dmActualizarBadge(); }catch(e){}
    }
  }catch(e){}
}
async function _dmEnviar(){
  var inp=document.getElementById('dm-input'); if(!inp||!_dmPartner) return;
  var txt=(inp.value||'').trim();
  if(!txt && !_dmArchivo) return;
  inp.value='';
  var path=null, nombre=null, tipo='texto';
  try{ if(_dmArchivo){ path=await _subirDocStorage('dm', _dmYo()+'_'+_dmPartner, _dmArchivo); nombre=_dmArchivo.name; tipo='archivo'; } }catch(e){}
  await _dmInsertar({mensaje:txt, adjunto_path:path, adjunto_nombre:nombre, tipo:tipo});
  _dmArchivo=null; var hint=document.getElementById('dm-file-hint'); if(hint) hint.style.display='none';
  await _dmCargarConv();
}
// ── Mensaje de voz ──
async function _dmGrabarToggle(){
  var mic=document.getElementById('dm-mic');
  if(_dmRec && _dmRec.state==='recording'){ _dmRec.stop(); return; }
  if(!navigator.mediaDevices || !window.MediaRecorder){ showT('Tu navegador no soporta grabar audio'); return; }
  try{
    var stream=await navigator.mediaDevices.getUserMedia({audio:true});
    _dmRecChunks=[]; _dmRec=new MediaRecorder(stream);
    _dmRec.ondataavailable=function(e){ if(e.data && e.data.size) _dmRecChunks.push(e.data); };
    _dmRec.onstop=async function(){
      stream.getTracks().forEach(function(t){t.stop();});
      if(mic){ mic.style.color='var(--text-muted)'; mic.querySelector('i').className='ti ti-microphone'; }
      var blob=new Blob(_dmRecChunks,{type:(_dmRec.mimeType||'audio/webm')});
      if(!blob.size) return;
      var ext=(blob.type.indexOf('ogg')>=0)?'ogg':'webm';
      var file=new File([blob],'voz_'+Date.now()+'.'+ext,{type:blob.type});
      showT('Enviando voz...');
      try{ var p=await _subirDocStorage('dm', _dmYo()+'_'+_dmPartner, file); await _dmInsertar({tipo:'voz', adjunto_path:p, adjunto_nombre:file.name}); _dmCargarConv(); }catch(e){ showT('Error al enviar voz'); }
    };
    _dmRec.start();
    if(mic){ mic.style.color='#dc2626'; mic.querySelector('i').className='ti ti-player-stop-filled'; }
    showT('Grabando... toca de nuevo para enviar');
  }catch(e){ showT('No se pudo acceder al micrófono'); }
}
// ── Menú de mensaje: editar / borrar / reenviar ──
function _dmMenu(id){
  var m=_dmMsgs[id]; if(!m||m.borrado) return;
  var mio=(m.de===_dmYo());
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  function it(icon,txt,fn,col){ return '<div onclick="'+fn+'" style="padding:12px 16px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:10px;border-bottom:0.5px solid var(--border);color:'+(col||'var(--text)')+'"><i class="ti '+icon+'"></i> '+txt+'</div>'; }
  var h='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;min-width:230px">';
  if(mio && (m.tipo==='texto'||!m.tipo) && m.mensaje) h+=it('ti-edit','Editar','_dmCerrarMenu();_dmEditar('+id+')');
  h+=it('ti-arrow-forward-up','Reenviar','_dmCerrarMenu();_dmReenviar('+id+')');
  h+=it('ti-trash','Borrar para mí','_dmCerrarMenu();_dmBorrarMi('+id+')');
  if(mio) h+=it('ti-trash-x','Borrar para todos','_dmCerrarMenu();_dmBorrarTodos('+id+')','#dc2626');
  h+=it('ti-x','Cancelar','_dmCerrarMenu()');
  h+='</div>'; ov.innerHTML=h; ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
function _dmCerrarMenu(){ document.querySelectorAll('.dm-menu-ov').forEach(function(o){o.remove();}); }
async function _dmEditar(id){ var m=_dmMsgs[id]; if(!m)return; var nv=prompt('Editar mensaje:', m.mensaje||''); if(nv==null)return; nv=nv.trim(); if(!nv)return; await _dmWrite(SB+'/rest/v1/mensajes_dm?id=eq.'+id,'PATCH',{mensaje:nv, editado_en:new Date().toISOString()},['editado_en']); _dmCargarConv(); }
async function _dmBorrarMi(id){ var m=_dmMsgs[id]; if(!m)return; var yo=_dmYo(); var l=(m.borrado_para||'').split(',').map(function(s){return s.trim();}).filter(Boolean); if(l.indexOf(yo)<0)l.push(yo); await _dmWrite(SB+'/rest/v1/mensajes_dm?id=eq.'+id,'PATCH',{borrado_para:l.join(',')},['borrado_para']); _dmCargarConv(); }
async function _dmBorrarTodos(id){ if(!confirm('¿Borrar este mensaje para todos?'))return; await _dmWrite(SB+'/rest/v1/mensajes_dm?id=eq.'+id,'PATCH',{borrado:true, mensaje:'', adjunto_path:null, adjunto_nombre:null, tipo:'texto'},['borrado']); _dmCargarConv(); }
function _dmReenviar(id){
  var m=_dmMsgs[id]; if(!m)return; _dmFwd=id;
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  var yo=_dmYo();
  var lista=(USERS||[]).filter(function(u){return u.id!==yo;}).map(function(u){ return '<div onclick="_dmReenviarA(\''+u.id+'\')" style="display:flex;align-items:center;gap:9px;padding:9px 14px;cursor:pointer;border-bottom:0.5px solid var(--border)">'+_avatarHTML(u.id,u.name,u.role,30)+'<span style="font-size:13px;font-weight:600">'+_esc(u.name)+'</span></div>'; }).join('');
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;width:100%;max-width:340px;max-height:70vh;display:flex;flex-direction:column"><div style="padding:11px 14px;font-weight:700;font-size:13px;border-bottom:0.5px solid var(--border)"><i class="ti ti-arrow-forward-up"></i> Reenviar a…</div><div style="overflow-y:auto">'+lista+'</div><div onclick="_dmCerrarMenu()" style="padding:11px 14px;text-align:center;font-size:13px;cursor:pointer;color:var(--text-muted)">Cancelar</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
async function _dmReenviarA(dest){
  var m=_dmMsgs[_dmFwd]; _dmCerrarMenu(); if(!m)return;
  var payload={ de:_dmYo(), de_nom:(CU&&CU.name)||'', para:dest, mensaje:m.mensaje||'', adjunto_path:m.adjunto_path||null, adjunto_nombre:m.adjunto_nombre||null, tipo:m.tipo||'texto', leido_en:null, creado_en:new Date().toISOString() };
  await _dmWrite(SB+'/rest/v1/mensajes_dm','POST',payload,['tipo']);
  showT('✓ Reenviado a '+(_dmUser(dest).name||dest));
}
// ── Badge del menú (verde) ──
// El número de mensajes sin leer, en la pestaña del navegador. Con varias
// pestañas abiertas, así se ve que hay algo nuevo sin tener que entrar.
window._dmTituloBase = window._dmTituloBase || null;

function _dmTituloPestana(n){
  try{
    if(window._dmTituloBase===null){
      // El título tal cual, sin el contador de una vuelta anterior
      window._dmTituloBase=String(document.title||'').replace(/^\(\d+\)\s*/,'');
    }
    var base=window._dmTituloBase;
    document.title = (n>0) ? ('('+(n>99?'99+':n)+') '+base) : base;
  }catch(e){}
}

async function _dmActualizarBadge(){
  try{
    var yo=_dmYo(); if(!yo) return;
    var r=await fetch(SB+'/rest/v1/mensajes_dm?para=eq.'+encodeURIComponent(yo)+'&leido_en=is.null&borrado=is.false&select=id&limit=500',{headers:SBH});
    if(!r.ok){ r=await fetch(SB+'/rest/v1/mensajes_dm?para=eq.'+encodeURIComponent(yo)+'&leido_en=is.null&select=id&limit=500',{headers:SBH}); }
    var rows=r.ok?(await r.json()):[];
    var n=Array.isArray(rows)?rows.length:0;
    _dmTituloPestana(n);
    document.querySelectorAll('.nb').forEach(function(b){
      if((b.getAttribute('onclick')||'').indexOf("'livechat'")>=0){
        var ex=b.querySelector('.dm-badge'); if(ex) ex.remove();
        if(n>0){ var sp=document.createElement('span'); sp.className='dm-badge'; sp.textContent=n; sp.style.cssText='display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;margin-left:6px;background:#16a34a;color:#fff;border-radius:999px;font-size:10px;font-weight:700;box-shadow:0 0 0 2px rgba(22,163,74,.18)'; b.appendChild(sp); }
      }
    });
  }catch(e){}
}
function _dmInit(){ _perfilesCargar(); _dmActualizarBadge(); if(!window._dmPollerOn){ window._dmPollerOn=true; setInterval(_dmActualizarBadge, 20000); } }
function abrirInvProveedor(code){
  code=String(code||'').trim(); if(!code){ showT('Sin código de proveedor'); return; }
  go('reposiciones');
  var tries=0;
  (function attempt(){ var el=document.getElementById('rep-code'); if(el){ el.value=code; if(typeof repGenerar==='function'){ try{ repGenerar(); }catch(e){} } return; } if(tries++<25) setTimeout(attempt,150); })();
}
// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO TEMPORAL: PROVEEDORES Y SKU QUE TODAVÍA NO ESTÁN EN SAP
//  Cuando se crea una orden NO SAP con un proveedor nuevo o con SKUs nuevos,
//  se guardan aquí para poder trabajarlos mientras SAP los da de alta.
//  En cuanto el mismo cardcode / itemcode aparece en `inventario`, la ficha
//  temporal se borra sola: SAP manda.
//  Tabla Supabase: catalogo_nosap
// ═══════════════════════════════════════════════════════════════════════════
window._catNoSap = window._catNoSap || [];

// ── ¿Esta ficha sigue siendo un artículo NO SAP de verdad? ──
// No lo es si ya se degradó a solo-foto, ni si su código apareció en SAP.
// Todas las pantallas que listan o cuentan fichas pasan por aquí, para que
// no vuelva a haber un sitio que enseñe lo que otro ya oculta.
function _catFichaViva(f){
  if(!f || f.tipo==='proveedor' || f.tipo==='foto') return false;
  try{ if((window._catEnSap||{})[_catKeyItem(f.itemcode)]) return false; }catch(e){}
  return true;
}

function _catKeyProv(c){ return String(c||'').trim().toUpperCase(); }
function _catKeyItem(c){ return String(c||'').trim().toUpperCase(); }

// ── Carga desde Supabase y depura lo que ya existe en SAP ──
async function _catNoSapCargar(silencioso){
  try{
    var r=await fetch(SB+'/rest/v1/catalogo_nosap?select=*&order=creado_en.desc&limit=1000',{headers:SBH});
    if(!r.ok){ if(!silencioso) console.warn('catalogo_nosap:', r.status); window._catNoSap=[]; return []; }
    var rows=await r.json();
    window._catNoSap=Array.isArray(rows)?rows:[];
    await _catNoSapDepurar();
    return window._catNoSap;
  }catch(e){ console.warn('cargar catalogo_nosap:',e); return window._catNoSap||[]; }
}

// ── ¿La foto que SAP declara existe de verdad en el bucket? ──
// SAP rellena picturname cuando alguien asigna la imagen en el ERP, pero eso
// no garantiza que el archivo haya llegado al bucket. Fiarse del nombre costó
// las 33 fichas de la DKC-26084: se borraron por "ya tienen foto en SAP" y las
// imágenes buenas del proveedor quedaron sin nada que las apuntara.
// Se comprueba de verdad, probando las mismas variantes que usa el portal al
// pintar. Ante la duda (sin red, error raro) se responde false: no borrar.
async function _fotoSapExiste(picturname){
  var pn=String(picturname||'').trim();
  if(!pn) return false;
  var variantes=[pn];
  if(pn.toLowerCase()!==pn) variantes.push(pn.toLowerCase());
  if(pn.toUpperCase()!==pn) variantes.push(pn.toUpperCase());
  for(var i=0;i<variantes.length;i++){
    try{
      var r=await fetch(FOTO_BASE+encodeURIComponent(variantes[i]));
      if(r.ok) return true;
    }catch(e){ return false; }   // sin conexión: no se borra nada
  }
  return false;
}

// ── ¿Este artículo tiene en SAP una foto que se pueda ver? ──
// Consulta el picturname del inventario y comprueba que el archivo exista.
// Un nombre sin archivo detrás cuenta como SIN foto.
async function _sapTieneFotoReal(itemcode){
  var c=String(itemcode||'').trim();
  if(!c) return false;
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select=picturname&itemcode=eq.'
      +encodeURIComponent(c)+'&limit=1',{headers:SBH});
    if(!r.ok) return false;
    var f=await r.json();
    if(!Array.isArray(f)||!f.length) return false;
    return await _fotoSapExiste(f[0].picturname);
  }catch(e){ return false; }
}

// ── Borra las fichas temporales cuyo código ya existe en SAP ──
async function _catNoSapDepurar(){
  var filas=window._catNoSap||[];
  if(!filas.length) return 0;
  var provs=[], items=[];
  filas.forEach(function(f){
    if(f.tipo==='proveedor' && f.cardcode) provs.push(_catKeyProv(f.cardcode));
    if(f.tipo==='item' && f.itemcode) items.push(_catKeyItem(f.itemcode));
  });
  var enSapProv={}, enSapItem={};
  try{
    if(provs.length){
      var lp=provs.map(function(x){return '"'+x.replace(/"/g,'')+'"';}).join(',');
      var rp=await fetch(SB+'/rest/v1/inventario?select=cardcode&cardcode=in.('+encodeURIComponent(lp)+')&limit=2000',{headers:SBH});
      if(rp.ok){ (await rp.json()||[]).forEach(function(x){ enSapProv[_catKeyProv(x.cardcode)]=true; }); }
    }
    if(items.length){
      // Se pide también la foto: un SKU que ya existe en SAP pero todavía sin
      // foto necesita que su ficha temporal siga viva, porque ahí está la
      // única imagen que hay (la que se sacó del Excel del proveedor).
      var li=items.map(function(x){return '"'+x.replace(/"/g,'')+'"';}).join(',');
      var ri=await fetch(SB+'/rest/v1/inventario?select=itemcode,picturname&itemcode=in.('+encodeURIComponent(li)+')&limit=2000',{headers:SBH});
      if(ri.ok){
        var _filas=await ri.json()||[];
        // No basta con que SAP declare un nombre: se comprueba que la imagen
        // esté realmente en el bucket. Si el nombre no tiene archivo detrás,
        // el SKU cuenta como SIN foto y su ficha se conserva.
        for(var _f=0;_f<_filas.length;_f++){
          var _x=_filas[_f];
          var _pn=String(_x.picturname||'').trim();
          var _real=_pn ? await _fotoSapExiste(_pn) : false;
          enSapItem[_catKeyItem(_x.itemcode)]=_real?'con_foto':'sin_foto';
          if(_pn && !_real){
            console.warn('[catalogo_nosap] '+_x.itemcode+': SAP declara "'+_pn
              +'" pero esa imagen no está en el bucket. Se conserva solo la foto.');
          }
        }
      }
    }
  }catch(e){ console.warn('depurar catalogo:',e); return 0; }

  // En cuanto un SKU existe en SAP deja de ser un artículo NO SAP y sale del
  // catálogo. Lo ÚNICO que se conserva es la foto, y solo mientras SAP no
  // tenga la suya: la ficha se degrada a tipo 'foto', que no aparece en
  // ninguna pantalla pero sigue alimentando la imagen del artículo de SAP.
  // Cuando SAP ya trae foto, se borra del todo.
  var soloFoto=[];      // se degradan: siguen dando la imagen
  var aBorrar=filas.filter(function(f){
    if(f.tipo==='proveedor'){
      // El proveedor se va con sus artículos: si ya no le queda ninguno
      // como artículo NO SAP, no pinta nada en el catálogo.
      var suyos=_catItemsDeProveedor(f.cardcode);
      var algunoSigue=suyos.some(function(it){
        return !enSapItem[_catKeyItem(it.itemcode)];
      });
      if(algunoSigue) return false;
      return true;
    }
    if(f.tipo==='item'){
      var st=enSapItem[_catKeyItem(f.itemcode)];
      if(!st) return false;                 // no está en SAP: sigue igual
      if(st==='con_foto') return true;      // SAP ya tiene foto: fuera del todo
      // Está en SAP y sin foto: solo se guarda la imagen, si la hay
      if(f.foto){ soloFoto.push(f); return false; }
      return true;                          // sin foto que guardar: fuera
    }
    return false;
  });

  // Degradar las que solo aportan la foto
  var degradadas=0;
  for(var d=0; d<soloFoto.length; d++){
    try{
      var rd=await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+soloFoto[d].id,
        {method:'PATCH', headers:Object.assign({}, SBH, {'Content-Type':'application/json'}),
         body:JSON.stringify({tipo:'foto'})});
      if(rd.ok){ soloFoto[d].tipo='foto'; degradadas++; }
      else if(rd.status===400){
        // La columna 'tipo' de la tabla solo admite 'item' y 'proveedor'.
        // No es grave: el portal ya los oculta usando _catEnSap. Pero hasta
        // que se amplíe la restricción, la marca no queda guardada y hay que
        // recalcularla en cada carga.
        if(!window._catAvisoTipo){
          window._catAvisoTipo=1;
          console.warn('[catalogo_nosap] la tabla no acepta tipo="foto" (400). '
            +'Se ocultan igual, pero conviene ampliar la restricción de la columna '
            +'"tipo" para que la marca quede guardada. Ver catalogo_nosap_tipo_foto.sql');
        }
      }
      else console.warn('[catalogo_nosap] no se pudo degradar '+soloFoto[d].itemcode+': '+rd.status);
    }catch(e){ console.warn('degradar ficha:',e); }
  }
  if(degradadas){
    console.info('[catalogo_nosap] '+degradadas+' ficha(s) salen del catálogo pero conservan '
      +'la foto porque SAP todavía no tiene imagen → '
      +soloFoto.slice(0,10).map(function(f){return f.itemcode;}).join(', '));
  }
  window._catEsperandoFoto=soloFoto.map(function(f){ return f.itemcode; });
  // Qué códigos se sabe que YA están en SAP. La consulta de inventario lo usa
  // para no mostrar la fila NO SAP de un artículo que ya existe, sin depender
  // de que ese artículo haya entrado en la página que se cargó.
  window._catEnSap=enSapItem;

  if(!aBorrar.length && !degradadas) return 0;
  for(var i=0;i<aBorrar.length;i++){
    try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+aBorrar[i].id,{method:'DELETE',headers:SBH}); }catch(e){}
  }
  var ids=aBorrar.map(function(f){ return f.id; });
  window._catNoSap=filas.filter(function(f){ return ids.indexOf(f.id)<0; });
  if(aBorrar.length) console.info('[catalogo_nosap] '+aBorrar.length+' ficha(s) ya están en SAP y se eliminaron');
  try{ _catNoSapBadge(); }catch(e){}
  return aBorrar.length+degradadas;
}

// ── ¿Existe ya en SAP? (consulta directa a inventario) ──
async function _catExisteEnSAP(campo, valor){
  var v=String(valor||'').trim();
  if(!v) return true;   // sin código, no se registra nada
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select='+campo+'&'+campo+'=eq.'+encodeURIComponent(v)+'&limit=1',{headers:SBH});
    if(!r.ok) return false;
    var f=await r.json();
    return Array.isArray(f)&&f.length>0;
  }catch(e){ return false; }
}

// ── Busca un proveedor por NOMBRE (la orden NO SAP no guarda el código) ──
async function _catBuscarProvPorNombre(nombre){
  var n=String(nombre||'').trim();
  if(n.length<3) return null;
  // Primero en el catálogo que ya está en memoria
  var nn=_repNorm(n);
  var local=(_repProv||[]).find(function(p){ return _repNorm(p.cardname)===nn; })
         || (_repProv||[]).find(function(p){
              var pn=_repNorm(p.cardname);
              return pn && (pn.indexOf(nn)>=0 || nn.indexOf(pn)>=0);
            });
  if(local) return {cardcode:local.cardcode, cardname:local.cardname};
  // Si no, se consulta el inventario y el maestro de proveedores
  try{
    var url=SB+'/rest/v1/inventario?select=cardcode,nombre_proveedor'
      +'&nombre_proveedor=ilike.*'+encodeURIComponent(n)+'*&cardcode=not.is.null&limit=1';
    var r=await fetch(url,{headers:SBH});
    if(r.ok){
      var f=await r.json();
      if(Array.isArray(f)&&f.length) return {cardcode:f[0].cardcode, cardname:f[0].nombre_proveedor};
    }
  }catch(e){}
  // El maestro: un proveedor dado de alta en SAP sin artículos todavía no
  // aparece en el inventario, y se estaba creando ficha temporal por nada.
  try{
    var url2=SB+'/rest/v1/proveedores?select=cardcode,cardname'
      +'&cardname=ilike.*'+encodeURIComponent(n)+'*&cardcode=not.is.null&limit=1';
    var r2=await fetch(url2,{headers:SBH});
    if(r2.ok){
      var f2=await r2.json();
      if(Array.isArray(f2)&&f2.length) return {cardcode:f2[0].cardcode, cardname:f2[0].cardname};
    }
  }catch(e){}
  return null;
}

// ── Registra proveedor e items nuevos a partir de una orden NO SAP ──
// Devuelve {proveedor:0|1, items:N} con lo que se creó.
async function _catNoSapRegistrarDeOrden(o){
  var res={proveedor:0, items:0};
  if(!o) return res;
  var cardcode=String(o.cardcode||o.proveedor_codigo||'').trim();
  var cardname=String(o.proveedor||'').trim();
  var ref=String(o.dkc||o.num_orden||'').trim();
  var yaCat=window._catNoSap||[];

  // ── Proveedor ──
  // La orden NO SAP solo guarda el NOMBRE del proveedor, no su código. Así que
  // primero se busca por nombre en el inventario: si ya está en SAP se toma su
  // cardcode real y no se crea ficha temporal, solo se revisan sus SKUs.
  var provEnSAP=false;
  if(cardcode){
    provEnSAP=await _catExisteEnSAP('cardcode', cardcode);
  } else {
    var hallado=await _catBuscarProvPorNombre(cardname);
    if(hallado){ cardcode=hallado.cardcode; provEnSAP=true; }
    else { cardcode='TMP-'+cardname.toUpperCase().replace(/[^A-Z0-9]+/g,'').slice(0,12); }
  }
  if(!provEnSAP && cardname){
    var dupP=yaCat.some(function(f){ return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===_catKeyProv(cardcode); });
    if(!dupP){
      var filaP={ tipo:'proveedor', cardcode:cardcode, cardname:cardname,
                  dept:o.dept||null, dkc_origen:ref||null,
                  creado_por:(CU&&CU.name)||'', creado_en:new Date().toISOString() };
      // Se pinta ya y después se confirma contra la base
      window._catNoSap.push(filaP); res.proveedor=1;
      try{ _catNoSapBadge(); }catch(e){}
      var rp=await fetch(SB+'/rest/v1/catalogo_nosap',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(filaP)});
      if(rp.ok){
        var cr=null; try{ cr=await rp.json(); }catch(e){}
        if(cr&&cr[0]){ var ix=window._catNoSap.indexOf(filaP); if(ix>=0) window._catNoSap[ix]=cr[0]; }
      } else {
        var ixe=window._catNoSap.indexOf(filaP); if(ixe>=0) window._catNoSap.splice(ixe,1);
        res.proveedor=0;
        var tp=await rp.text();
        console.warn('cat prov', rp.status, tp);
        res.error=_catNoSapExplicar(rp.status, tp);
      }
    }
  }

  // ── Items ──
  var items=(o.items||[]).filter(function(it){ return it && (it.itemcode||it.itemname); });
  // Se anota por qué se descarta cada artículo: antes se saltaban en
  // silencio y el proveedor quedaba sin ningún SKU sin explicación.
  var _descartes={sinCodigo:[], enSAP:[], repetidos:[]};
  var _soloFoto={};   // SKU que ya están en SAP y solo aportan la foto
  _dbg('[nosap] artículos a registrar:', items.length,
              items.map(function(x){ return x.itemcode; }));

  for(var i=0;i<items.length;i++){
    var it=items[i];
    var code=String(it.itemcode||'').trim();
    if(!code){ _descartes.sinCodigo.push(it.itemname||'(sin nombre)'); continue; }
    // Estar en SAP NO basta para descartarlo. Si SAP no tiene la foto —o la
    // tiene declarada pero el archivo no está en el bucket— la única imagen
    // del artículo es la del Excel del proveedor, y hay que guardarla igual.
    // Así fue como se perdieron las 33 de la DKC-26084.
    var _enSap = it._enSAP || await _catExisteEnSAP('itemcode', code);
    if(_enSap){
      var _tieneFoto=false;
      try{ _tieneFoto=await _sapTieneFotoReal(code); }catch(e){ _tieneFoto=false; }
      if(_tieneFoto){ _descartes.enSAP.push(code); continue; }
      // Está en SAP pero sin foto usable: no entra al catálogo NO SAP, solo
      // se guarda la imagen (tipo 'foto') para que el artículo de SAP tenga
      // algo que mostrar hasta que le carguen la suya.
      _soloFoto[_catKeyItem(code)]=1;
      console.info('[catalogo_nosap] '+code+' ya está en SAP pero sin foto: '
        +'se guarda solo la imagen, no la ficha.');
    }
    var dupI=(window._catNoSap||[]).some(function(f){ return f.tipo==='item' && _catKeyItem(f.itemcode)===_catKeyItem(code); });
    if(dupI){ _descartes.repetidos.push(code); continue; }
    var filaI={ tipo:(_soloFoto[_catKeyItem(code)]?'foto':'item'), itemcode:code, itemname:it.itemname||'',
                cardcode:cardcode, cardname:cardname,
                cantidad:Number(it.cantidad)||0, precio:Number(it.precio_unit)||0,
                total_linea:Number(it.total_linea)||0, moneda:'USD',
                colores:it.colores||it.color||null,
                // La ficha técnica que leyó la AI, para armar el catálogo
                descripcion:it.descripcion||null, material:it.material||null,
                color:it.color||null, tamano:it.tamano||null,
                empaque:it.empaque||null, barcode:it.barcode||null,
                carton_size:it.carton_size||null, marca:it.marca||null,
                unidades_x_caja:Number(it.unidades_x_caja)||null,
                cartones_item:Number(it.cartones_item)||null,
                cbm:Number(it.cbm)||null,
                peso:(it.peso!=null&&it.peso!=='')?String(it.peso):null,
                // La foto que se sacó del Excel del proveedor
                foto:(await _catSubirFotoSku(code, cardcode, it)) || it.foto || null,
                dept:o.dept||null, dkc_origen:ref||null,
                creado_por:(CU&&CU.name)||'', creado_en:new Date().toISOString() };
    try{
      window._catNoSap.push(filaI); res.items++;
      try{ _catNoSapBadge(); }catch(e){}
      var ri=await fetch(SB+'/rest/v1/catalogo_nosap',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(filaI)});
      if(ri.ok){
        var ci=null; try{ ci=await ri.json(); }catch(e){}
        if(ci&&ci[0]){ var ii=window._catNoSap.indexOf(filaI); if(ii>=0) window._catNoSap[ii]=ci[0]; }
      } else {
        var iie=window._catNoSap.indexOf(filaI); if(iie>=0) window._catNoSap.splice(iie,1);
        res.items--;
        var ti=await ri.text();
        console.warn('cat item', ri.status, ti);
        if(/foto/i.test(ti)){
          _dbg('[nosap] la columna "foto" rechazó el valor. '
            +'Si es varchar corto, cambiala a text en Supabase.');
        }
        res.error=_catNoSapExplicar(ri.status, ti);
      }
    }catch(e){ console.warn('cat item:',e); }
  }
  // El detalle de lo que no entró, para saber qué pasó
  try{
    var _d=_descartes||{sinCodigo:[],enSAP:[],repetidos:[]};
    var _tot=_d.sinCodigo.length+_d.enSAP.length+_d.repetidos.length;
    if(_tot){
      _dbg('[nosap] artículos NO registrados: '+_tot, _d);
      var _partes=[];
      if(_d.enSAP.length)     _partes.push(_d.enSAP.length+' ya existen en SAP ('+_d.enSAP.slice(0,4).join(', ')+')');
      if(_d.repetidos.length) _partes.push(_d.repetidos.length+' ya estaban en la lista');
      if(_d.sinCodigo.length) _partes.push(_d.sinCodigo.length+' sin código');
      res.omitidos=_tot;
      res.motivo=_partes.join(' · ');
    }
  }catch(e){}
  try{ _catResumenFotos(); }catch(e){}
  return res;
}

// Cuántas fichas quedaron con foto, para saber si el catálogo va a servir
function _catResumenFotos(){
  var items=(window._catNoSap||[]).filter(_catFichaViva);
  var con=items.filter(function(f){ return !!(f.foto||f.foto_url); }).length;
  _dbg('[nosap] catálogo: '+con+' de '+items.length+' artículo(s) con foto');
  if(con<items.length){
    _dbg('[nosap] los que no tienen:',
      items.filter(function(f){ return !f.foto; }).map(function(f){ return f.itemcode; }));
  }
  return {con:con, total:items.length};
}

// Traduce el error de Supabase a algo entendible
function _catNoSapExplicar(status, texto){
  var t=String(texto||'');
  if(status===404 || /does not exist|Could not find the table/i.test(t))
    return 'La tabla catalogo_nosap no existe todavía en Supabase. Hay que crearla (script catalogo_nosap.sql).';
  if(status===401 || status===403 || /row-level security|permission denied/i.test(t))
    return 'La tabla existe pero no da permiso de escritura (RLS). Hay que habilitar el acceso.';
  if(status===400 && /column .* does not exist/i.test(t))
    return 'A la tabla le falta alguna columna. Volver a correr el script completo.';
  return 'Error '+status+' al escribir en catalogo_nosap: '+t.slice(0,140);
}

// Diagnóstico: dice exactamente qué pasa con la tabla
async function _catNoSapDiag(){
  var box=document.getElementById('cat-diag');
  function pinta(color, borde, fondo, msg){
    if(box) box.innerHTML='<div style="border:1px solid '+borde+';background:'+fondo+';color:'+color
      +';border-radius:8px;padding:9px 11px;font-size:11.5px;margin-bottom:10px">'+msg+'</div>';
  }
  pinta('var(--text-muted)','var(--border)','var(--surface-1)','<span class="ai-ring g" style="vertical-align:-2px"></span> Probando la tabla catalogo_nosap…');
  try{
    // Lectura
    var r=await fetch(SB+'/rest/v1/catalogo_nosap?select=id&limit=1',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      pinta('#991b1b','#dc2626','#FEF2F2','<b>No se puede leer.</b><br>'+_esc(_catNoSapExplicar(r.status,t)));
      return;
    }
    // Escritura: se inserta una fila de prueba y se borra
    var prueba={ tipo:'item', itemcode:'__TEST__'+Date.now(), itemname:'prueba de conexion',
                 cardcode:'__TEST__', cardname:'prueba', creado_por:'diagnostico',
                 creado_en:new Date().toISOString() };
    var w=await fetch(SB+'/rest/v1/catalogo_nosap',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(prueba)});
    if(!w.ok){
      var tw=await w.text();
      pinta('#991b1b','#dc2626','#FEF2F2','<b>Lee pero no puede escribir.</b><br>'+_esc(_catNoSapExplicar(w.status,tw)));
      return;
    }
    var creada=null; try{ creada=await w.json(); }catch(e){}
    var idp=(creada&&creada[0]&&creada[0].id)||null;
    if(idp){ try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+idp,{method:'DELETE',headers:SBH}); }catch(e){} }
    pinta('#166534','#16a34a','#dcfce7','<b>Todo bien:</b> la tabla existe y acepta lectura y escritura. Si no se llenó, usa "Revisar órdenes existentes".');
  }catch(e){
    pinta('#991b1b','#dc2626','#FEF2F2','<b>Error de conexión:</b> '+_esc(e.message||String(e)));
  }
}

// Relleno retroactivo: recorre las órdenes NO SAP ya creadas y registra
// los proveedores y SKUs que falten. Sirve para las órdenes hechas antes
// de que existiera esta pantalla.
async function _catNoSapRellenar(){
  var ordenes=(window._pendSAP||[]);
  if(!ordenes.length){ showT('No hay órdenes BORRADOR para revisar'); return; }
  var box=document.getElementById('cat-diag');
  if(box) box.innerHTML='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Revisando '+ordenes.length+' orden(es) BORRADOR…</div>';
  await _catNoSapCargar(true);
  var tp=0, ti=0, err='';
  for(var i=0;i<ordenes.length;i++){
    var o=ordenes[i];
    if(typeof o.items==='string'){ try{ o=Object.assign({},o,{items:JSON.parse(o.items)}); }catch(e){} }
    try{
      var r=await _catNoSapRegistrarDeOrden(o);
      tp+=r.proveedor; ti+=r.items;
      if(r.error) err=r.error;
    }catch(e){ console.warn('rellenar:',e); }
  }
  if(err){
    if(box) box.innerHTML='<div style="border:1px solid #dc2626;background:var(--pastel-error);color:var(--t-rojo);border-radius:8px;padding:9px 11px;font-size:11.5px;margin-bottom:10px"><b>No se pudo guardar.</b><br>'+_esc(err)+'</div>';
    return;
  }
  showT(tp||ti ? ('Agregados: '+tp+' proveedor(es) y '+ti+' SKU(s)') : 'Todo estaba ya registrado o ya existe en SAP');
  rCatNoSap();
}

// ── Items temporales de un proveedor (para pintarlos dentro de su ficha) ──
// Cuántas piezas de este SKU vienen en camino, sumando todas las órdenes NO
// SAP que lo llevan. Es el dato que le interesa al cliente en el catálogo de
// mercancía por llegar: no cuánto hay, sino cuánto va a haber.
function _catPorLlegar(sku){
  sku=String(sku||'').trim().toUpperCase();
  if(!sku) return 0;
  var t=0;
  (window._pendSAP||[]).forEach(function(p){
    var its=p.items;
    if(typeof its==='string'){ try{ its=JSON.parse(its); }catch(e){ its=[]; } }
    (Array.isArray(its)?its:[]).forEach(function(it){
      if(String(it.itemcode||'').trim().toUpperCase()===sku) t+=Number(it.cantidad)||0;
    });
  });
  return t;
}

// De dónde salen las fichas del catálogo. Normalmente del catálogo NO SAP,
// pero una orden de SAP arma las suyas al vuelo desde el inventario y las
// deja aquí, para poder usar la misma pantalla de revisión.
function _catFuenteFilas(){
  return (window._catFuente && window._catFuente.length)
    ? window._catFuente
    : (window._catNoSap||[]);
}

function _catItemsDeProveedor(cardcode){
  var k=_catKeyProv(cardcode);
  return (window._catNoSap||[]).filter(function(f){
    return f.tipo==='item' && _catKeyProv(f.cardcode)===k;
  });
}
function _catEsProveedorNuevo(cardcode){
  var k=_catKeyProv(cardcode);
  return (window._catNoSap||[]).some(function(f){
    return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===k;
  });
}

// Completa el departamento de cada ficha del catálogo NO SAP
function _catCompletarDept(filas){
  // 1) El que ya trae la ficha
  filas.forEach(function(f){ f._dept=f.dept||f.departamento||''; });

  // 2) Si no lo trae, el de la orden NO SAP donde se usó ese código
  var porProv={}, porItem={};
  (window._pendSAP||[]).forEach(function(o){
    var d=o.dept||o.departamento||'';
    if(!d) return;
    var cc=String(o.cardcode||o.proveedor_codigo||'').trim().toUpperCase();
    if(cc && !porProv[cc]) porProv[cc]=d;
    var lns=o.lineas||o.items||[];
    if(Array.isArray(lns)) lns.forEach(function(l){
      var ic=String(l.itemcode||'').trim().toUpperCase();
      if(ic && !porItem[ic]) porItem[ic]=d;
    });
  });

  filas.forEach(function(f){
    if(f._dept) return;
    if(f.tipo==='proveedor'){
      var cc=String(f.cardcode||'').trim().toUpperCase();
      if(porProv[cc]) f._dept=porProv[cc];
    } else {
      var ic=String(f.itemcode||'').trim().toUpperCase();
      if(porItem[ic]) f._dept=porItem[ic];
    }
  });

  // 3) Los artículos heredan el departamento de su proveedor
  var deptProv={};
  filas.forEach(function(f){
    if(f.tipo==='proveedor' && f._dept) deptProv[_catKeyProv(f.cardcode)]=f._dept;
  });
  filas.forEach(function(f){
    if(!f._dept && f.tipo!=='proveedor' && f.cardcode){
      var k=_catKeyProv(f.cardcode);
      if(deptProv[k]) f._dept=deptProv[k];
    }
  });
}

// ═══════════════════════════════════════════════════════════════════════════
//  FOTOS DE LOS SKU NO SAP
//  Los Excel de los proveedores traen las fotos incrustadas. Un .xlsx es un
//  ZIP: las imágenes están en xl/media/ y la relación con cada fila en los
//  dibujos de la hoja. Se extraen para armar catálogos de mercancía que
//  todavía no existe en SAP.
// ═══════════════════════════════════════════════════════════════════════════
window._nsapFotos = window._nsapFotos || {};   // itemcode -> {b64, mime}

// Lee un .xlsx y devuelve las imágenes con la fila donde están ancladas
// Carga JSZip bajo demanda. El <script> de la cabecera puede no haber
// terminado, o fallar si no hay internet en ese momento.
function _cargarJSZip(){
  if(typeof JSZip!=='undefined') return Promise.resolve(true);
  if(window._jszipCargando) return window._jszipCargando;
  window._jszipCargando=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    sc.onload=function(){ res(true); };
    sc.onerror=function(){ rej(new Error('no se pudo cargar JSZip')); };
    document.head.appendChild(sc);
    setTimeout(function(){ rej(new Error('JSZip tardó demasiado')); }, 15000);
  });
  return window._jszipCargando;
}

async function _nsapExtraerFotos(file){
  var ext=(file.name.split('.').pop()||'').toLowerCase();
  if(ext!=='xlsx'){
    _dbg('[fotos] solo los .xlsx traen imágenes incrustadas');
    return [];
  }
  if(typeof JSZip==='undefined'){
    try{ await _cargarJSZip(); }catch(e){}
  }
  if(typeof JSZip==='undefined'){
    _dbg('[fotos] falta JSZip: no se pueden extraer las imágenes');
    return [];
  }
  try{
    var zip=await JSZip.loadAsync(await file.arrayBuffer());

    // 1) Las imágenes del archivo
    var medios={};
    var tareas=[];
    zip.forEach(function(ruta, f){
      if(!/^xl\/media\//i.test(ruta) || f.dir) return;
      tareas.push(f.async('base64').then(function(b64){
        var e=(ruta.split('.').pop()||'png').toLowerCase();
        medios[ruta.split('/').pop().toLowerCase()]={
          b64:b64,
          mime:(e==='jpg'||e==='jpeg')?'image/jpeg':(e==='gif'?'image/gif':'image/png')
        };
      }));
    });
    await Promise.all(tareas);
    if(!Object.keys(medios).length){
      _dbg('[fotos] el Excel no trae imágenes');
      return [];
    }

    // 2) En qué fila está anclada cada una
    var dibujos=[];
    zip.forEach(function(ruta, f){
      if(/^xl\/drawings\/drawing\d+\.xml$/i.test(ruta) && !f.dir) dibujos.push(ruta);
    });

    var out=[];
    for(var i=0;i<dibujos.length;i++){
      var xml=await zip.file(dibujos[i]).async('string');
      // La relación de ese dibujo, para saber qué archivo es cada r:embed
      var relRuta=dibujos[i].replace(/drawings\/(drawing\d+\.xml)/i,'drawings/_rels/$1.rels');
      var rels={};
      var relFile=zip.file(relRuta);
      if(relFile){
        var relXml=await relFile.async('string');
        var re=/Id="([^"]+)"[^>]*Target="([^"]+)"/g, m;
        while((m=re.exec(relXml))) rels[m[1]]=m[2].split('/').pop().toLowerCase();
      }
      // Cada anclaje: la fila y la imagen
      var anclas=xml.split(/<xdr:(?:twoCellAnchor|oneCellAnchor)/);
      anclas.forEach(function(a){
        var mf=a.match(/<xdr:from>[\s\S]*?<xdr:col>(\d+)<\/xdr:col>[\s\S]*?<xdr:row>(\d+)<\/xdr:row>/);
        var mt=a.match(/<xdr:to>[\s\S]*?<xdr:row>(\d+)<\/xdr:row>/);
        var mi=a.match(/r:embed="([^"]+)"/);
        if(!mf || !mi) return;
        var arch=rels[mi[1]];
        if(!arch || !medios[arch]) return;
        var col=parseInt(mf[1],10);
        var desde=parseInt(mf[2],10);
        // Una foto puede abarcar varias filas: en ese caso vale para todos
        // los artículos que quedan debajo de ella.
        var hasta=mt?parseInt(mt[1],10):desde;
        out.push({fila:desde, hasta:Math.max(hasta,desde), col:col,
                  b64:medios[arch].b64, mime:medios[arch].mime});
      });
    }

    // Sin anclajes se devuelven en orden, que suele coincidir con las filas
    if(!out.length){
      Object.keys(medios).sort().forEach(function(k,i){
        out.push({fila:i+1, hasta:i+1, b64:medios[k].b64, mime:medios[k].mime});
      });
    }
    _dbg('[fotos] '+out.length+' imagen(es) extraídas del Excel');
    return out;
  }catch(e){
    console.warn('[fotos] no se pudo leer el Excel:', e);
    return [];
  }
}

// Une cada foto con su SKU. Las fotos se anclan a una fila y una columna;
// los SKU están en su propia columna. Se empareja por FILA, que es lo que
// de verdad los relaciona: antes se buscaba el texto del SKU en la fila y
// fallaba porque la hoja tiene tres códigos distintos por artículo.
// ── Rescatar el código de KCC leyendo la hoja ──
// La IA se equivoca de columna con facilidad: en la PI de Delite tomó
// "Style no." —vacía en 15 de 18 filas— en vez de "KCC ITEM CODE". Esto no
// se arregla insistiendo en el prompt: se busca la columna cuyo encabezado
// lleva KCC y se leen los códigos de ahí, que es un dato exacto.
// Las filas se emparejan por código de barras, y si no lo hay, por importe
// y cantidad.
async function _nsapCorregirKcc(file, items){
  if(!items || !items.length) return 0;
  var filas=[];
  try{
    var wb=XLSX.read(await file.arrayBuffer(),{type:'array'});
    filas=XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]],
      {header:1, defval:'', blankrows:true});
  }catch(e){ console.warn('[kcc] no se pudo leer la hoja:', e); return 0; }

  // La fila de encabezados es la que tenga una celda con KCC
  var filaH=-1, colKcc=-1, colBar=-1, colCant=-1, colImp=-1;
  for(var r=0; r<Math.min(filas.length, 60); r++){
    var c=(filas[r]||[]).map(function(x){ return String(x==null?'':x).toUpperCase().replace(/\s+/g,' ').trim(); });
    var k=c.findIndex(function(t){ return t.indexOf('KCC')>=0; });
    if(k>=0){
      filaH=r; colKcc=k;
      colBar =c.findIndex(function(t){ return t.indexOf('BARCODE')>=0 || t.indexOf('UPC')>=0 || t.indexOf('EAN')>=0; });
      colCant=c.findIndex(function(t){ return t==='QTY' || t.indexOf('QTY')>=0 || t.indexOf('CANT')>=0; });
      colImp =c.findIndex(function(t){ return t.indexOf('AMOUNT')>=0 || t.indexOf('TOTAL AMOUNT')>=0 || t.indexOf('IMPORTE')>=0; });
      break;
    }
  }
  if(filaH<0){ _dbg('[kcc] la hoja no tiene ninguna columna con KCC'); return 0; }
  _dbg('[kcc] encabezado en la fila '+(filaH+1)+' · columna KCC: "'
    +String((filas[filaH]||[])[colKcc]||'').trim()+'"');

  // Las filas con código, en orden
  var datos=[];
  for(var r2=filaH+1; r2<filas.length; r2++){
    var f=filas[r2]||[];
    var cod=String(f[colKcc]==null?'':f[colKcc]).trim();
    if(!cod || cod.length<3) continue;
    if(/^(TOTAL|GRAND TOTAL|SUBTOTAL)/i.test(cod)) continue;
    datos.push({
      cod:cod,
      bar:colBar>=0?String(f[colBar]==null?'':f[colBar]).replace(/\D/g,''):'',
      cant:colCant>=0?(parseFloat(String(f[colCant]).replace(/[^0-9.\-]/g,''))||0):0,
      imp: colImp>=0?(parseFloat(String(f[colImp]).replace(/[^0-9.\-]/g,''))||0):0
    });
  }
  if(!datos.length){ _dbg('[kcc] la columna KCC no tiene valores'); return 0; }

  var usados={}, arreglados=0;
  function tomar(i){ usados[i]=1; return datos[i].cod; }

  items.forEach(function(it, n){
    var barIt=String(it.barcode||'').replace(/\D/g,'');
    var cantIt=Number(it.cantidad)||0;
    var impIt=Number(it.total_linea)||0;
    var idx=-1;
    // 1) por código de barras, que es único
    if(barIt) idx=datos.findIndex(function(d,i){ return !usados[i] && d.bar && d.bar===barIt; });
    // 2) por importe y cantidad
    if(idx<0 && impIt) idx=datos.findIndex(function(d,i){
      return !usados[i] && Math.abs(d.imp-impIt)<0.02 && (!cantIt || d.cant===cantIt); });
    // 3) por posición, si la cuenta de líneas coincide
    if(idx<0 && datos.length===items.length && !usados[n]) idx=n;
    if(idx<0) return;
    var bueno=tomar(idx);
    var antes=String(it.itemcode||it.itemcode_kcc||'').trim();
    if(antes.toUpperCase()!==bueno.toUpperCase()){
      it.itemcode=bueno;
      it.itemcode_kcc=bueno;
      arreglados++;
      if(arreglados<=6) _dbg('[kcc] línea '+(n+1)+': "'+(antes||'(vacío)')+'" → "'+bueno+'"');
    }
  });
  if(arreglados) _dbg('[kcc] '+arreglados+' de '+items.length+' código(s) corregidos desde la hoja');
  else _dbg('[kcc] los códigos de la IA ya coincidían con la hoja');
  return arreglados;
}

// El parámetro "estricto" es para el catálogo: ahí una foto equivocada se
// ve al momento y va al cliente. En ese modo NO se empareja por descripción
// (dos alfombras "ALFOMBRA DE ENTRADA" caerían en la misma fila), NO se
// rellena por cercanía y NO se reparte una imagen entre varios SKU salvo
// que de verdad ocupe varias filas.
async function _nsapFotosPorSku(file, items, opciones){
  var estricto = !!(opciones && opciones.estricto);
  var fotos=await _nsapExtraerFotos(file);
  window._nsapFotosDiag={jszip:(typeof JSZip!=='undefined'), imagenes:fotos.length,
                         articulos:(items||[]).length, ubicados:0};
  if(!fotos.length){ _dbg('[fotos] el Excel no trae imágenes'); return {}; }
  if(!items || !items.length){ _dbg('[fotos] no hay artículos que emparejar'); return {}; }

  var filas=[], merges=[];
  try{
    var wb=XLSX.read(await file.arrayBuffer(),{type:'array'});
    var hoja=wb.Sheets[wb.SheetNames[0]];
    filas=XLSX.utils.sheet_to_json(hoja,{header:1, defval:'', blankrows:true});
    merges=hoja['!merges']||[];
  }catch(e){ console.warn('[fotos] no se pudo leer la hoja:', e); return {}; }

  // Cuando varias referencias comparten foto, el proveedor suele COMBINAR las
  // celdas de esa columna. El dibujo entonces se ancla a una sola fila y el
  // rango del propio dibujo no dice nada. Se mira la celda combinada: si la
  // foto cae dentro de una, su alcance son todas las filas de esa combinación.
  var ampliadas=0;
  fotos.forEach(function(f){
    for(var m=0;m<merges.length;m++){
      var mg=merges[m];
      var dentroFila = f.fila>=mg.s.r && f.fila<=mg.e.r;
      var dentroCol  = (f.col==null) || (f.col>=mg.s.c && f.col<=mg.e.c);
      if(dentroFila && dentroCol && mg.e.r>mg.s.r){
        if(mg.s.r<f.fila) f.fila=mg.s.r;
        if(mg.e.r>(f.hasta||f.fila)){ f.hasta=mg.e.r; ampliadas++; }
        break;
      }
    }
  });
  if(ampliadas){
    _dbg('[fotos] '+ampliadas+' imagen(es) están en celdas combinadas: '
      +'se reparten entre todos los artículos de esas filas');
  }

  // La fila donde está cada artículo: se busca su código en CUALQUIER celda,
  // porque la AI puede haber tomado el código de fábrica, el de KCC o el
  // código de barras.
  var filaDe={};
  items.forEach(function(it){
    var sku=String(it.itemcode||'').trim().toUpperCase();
    if(!sku) return;
    var nom=String(it.itemname||'').trim().toUpperCase().slice(0,18);
    for(var r=0;r<filas.length;r++){
      var celdas=(filas[r]||[]).map(function(c){ return String(c==null?'':c).trim().toUpperCase(); });
      var hay=celdas.some(function(c){
        if(!c) return false;
        if(c===sku) return true;
        // El código puede venir con espacios o saltos, como "P55762\n  4x6"
        return c.replace(/\s+/g,'')===sku.replace(/\s+/g,'');
      });
      // Si no aparece el código, se intenta por la descripción. En modo
      // estricto no: descripciones repetidas dan filas equivocadas.
      if(!hay && !estricto && nom.length>8){
        hay=celdas.some(function(c){ return c.length>8 && c.indexOf(nom)>=0; });
      }
      if(hay){ filaDe[sku]=r; break; }
    }
  });

  var ubicados=Object.keys(filaDe).length;
  window._nsapFotosDiag={
    jszip:(typeof JSZip!=='undefined'),
    imagenes:fotos.length,
    articulos:items.length,
    ubicados:ubicados
  };
  _dbg('[fotos] '+fotos.length+' imagen(es) · '+ubicados+' de '+items.length
    +' artículo(s) ubicados en la hoja');
  _dbg('[fotos] filas de las imágenes:', fotos.map(function(f){ return f.fila; }));
  _dbg('[fotos] filas de los artículos:', filaDe);

  var mapa={}, usadas={};

  // 1) Emparejado por rango: una foto puede abarcar varias filas y entonces
  //    vale para todos los artículos que quedan dentro. Es lo que pasa cuando
  //    varias referencias comparten la misma imagen.
  Object.keys(filaDe).forEach(function(sku){
    var fila=filaDe[sku];
    // La foto cuyo rango CONTIENE esta fila
    for(var k=0;k<fotos.length;k++){
      var f=fotos[k];
      if(fila>=f.fila && fila<=(f.hasta||f.fila)){
        // En estricto, una imagen anclada a UNA fila vale para UN artículo:
        // si ya se usó, no se repite. Así no salen fotos duplicadas.
        if(estricto && usadas[k] && (f.hasta||f.fila)===f.fila) continue;
        mapa[sku]=f;
        usadas[k]=1;                       // usada, pero puede repetirse
        if((f.hasta||f.fila)>f.fila){
          _dbg('[fotos] '+sku+' comparte la foto de las filas '
            +f.fila+'-'+f.hasta);
        }
        return;
      }
    }
  });

  // 1c) Si un artículo sigue sin foto y el de la fila anterior sí tiene una
  //     que abarca varias filas, la comparte. Cubre el caso de la combinación
  //     que XLSX no llegó a leer.
  var ordenados=Object.keys(filaDe).sort(function(a,b){ return filaDe[a]-filaDe[b]; });
  for(var q=1;q<ordenados.length;q++){
    var actual=ordenados[q], previo=ordenados[q-1];
    if(mapa[actual] || !mapa[previo]) continue;
    var fp=mapa[previo];
    // Solo si la del anterior llega hasta esta fila o justo antes
    if((fp.hasta||fp.fila) >= filaDe[actual]-1 && (fp.hasta||fp.fila) > fp.fila){
      mapa[actual]=fp;
      _dbg('[fotos] '+actual+' comparte la foto de '+previo);
    }
  }

  // 1b) Los que quedaron sin foto: la más cercana, a lo sumo una fila
  if(!estricto) Object.keys(filaDe).forEach(function(sku){
    if(mapa[sku]) return;
    var fila=filaDe[sku], mejor=null, dist=99, idx=-1;
    fotos.forEach(function(f,k){
      if(usadas[k]) return;
      var d=Math.min(Math.abs(f.fila-fila), Math.abs((f.hasta||f.fila)-fila));
      if(d<dist){ dist=d; mejor=f; idx=k; }
    });
    if(mejor && dist<=1){ mapa[sku]=mejor; usadas[idx]=1; }
  });

  // 2) Lo que quedó sin foto, solo si las imágenes libres caen DENTRO del
  //    rango de filas de los artículos. Fuera de ese rango están el logo
  //    del proveedor y las firmas, que no son fotos de producto.
  var filasArt=Object.keys(filaDe).map(function(k){ return filaDe[k]; });
  if(filasArt.length && !estricto){
    var minF=Math.min.apply(null, filasArt)-1;
    var maxF=Math.max.apply(null, filasArt)+1;
    var sinFoto=items.filter(function(it){
      var k=String(it.itemcode||'').trim().toUpperCase();
      return k && !mapa[k];
    });
    var libres=[];
    fotos.forEach(function(f,k){
      if(usadas[k]) return;
      if((f.hasta||f.fila)<minF || f.fila>maxF) return;    // logo o firma
      libres.push(f);
    });
    if(sinFoto.length && libres.length){
      libres.sort(function(a,b){ return a.fila-b.fila; });
      var n=Math.min(sinFoto.length, libres.length);
      for(var q=0;q<n;q++){
        var sku=String(sinFoto[q].itemcode||'').trim().toUpperCase();
        mapa[sku]=libres[q];
      }
      _dbg('[fotos] '+n+' emparejada(s) por cercanía');
    }
    var descartadas=fotos.filter(function(f,k){
      return !usadas[k] && ((f.hasta||f.fila)<minF || f.fila>maxF);
    }).length;
    if(descartadas){
      _dbg('[fotos] '+descartadas+' imagen(es) descartadas: están fuera de la tabla '
        +'(logo del proveedor, firmas, etc.)');
    }
  }

  _dbg('[fotos] resultado: '+Object.keys(mapa).length+' SKU con foto');
  return mapa;
}

// Sube las fotos al storage y las deja guardadas en el catálogo NO SAP
async function _nsapGuardarFotos(mapa, cardcode){
  var skus=Object.keys(mapa||{});
  if(!skus.length) return 0;
  var n=0;
  for(var i=0;i<skus.length;i++){
    var sku=skus[i], f=mapa[sku];
    try{
      var ext=(f.mime==='image/jpeg')?'jpg':(f.mime==='image/gif'?'gif':'png');
      var nombre='nosap/'+String(cardcode||'sin-prov').replace(/[^\w-]/g,'')+'/'
        +sku.replace(/[^\w.-]/g,'_')+'.'+ext;
      // El base64 pasa a binario para subirlo
      var bin=atob(f.b64), arr=new Uint8Array(bin.length);
      for(var j=0;j<bin.length;j++) arr[j]=bin.charCodeAt(j);
      var r=await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+nombre,{
        method:'POST',
        headers:{'apikey':KEY,'Authorization':SBH.Authorization,'Content-Type':f.mime,'x-upsert':'true'},
        body:arr});
      if(!r.ok && r.status!==409){ _dbg('[fotos] no se subió '+sku, r.status); continue; }
      var url=DOCS_BASE+nombre.split('/').map(encodeURIComponent).join('/');
      window._nsapFotos[sku]={url:url, mime:f.mime};
      // Y en la ficha del catálogo, para que quede después de recargar
      try{
        await fetch(SB+'/rest/v1/catalogo_nosap?itemcode=eq.'+encodeURIComponent(sku),{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({foto_url:url})});
      }catch(e){}
      n++;
    }catch(e){ console.warn('[fotos] '+sku+':', e); }
  }
  _dbg('[fotos] '+n+' foto(s) guardadas');
  return n;
}

// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO DE MERCANCÍA POR LLEGAR
//  Arma un catálogo con los SKU que todavía no están en SAP, usando las
//  fotos que la AI extrajo del Excel del proveedor.
// ═══════════════════════════════════════════════════════════════════════════
window._catSel = window._catSel || {};     // itemcode -> true si está elegido

// Botón para armar el catálogo de un solo proveedor
// ═══════════════════════════════════════════════════════════════════════════
//  EDITOR DEL CATÁLOGO
//  Antes de generar se revisa cada artículo: precio de venta y los datos de
//  la ficha que falten. El catálogo va al cliente, así que conviene que
//  esté completo.
// ═══════════════════════════════════════════════════════════════════════════
window._catEdit = window._catEdit || {};     // itemcode -> {precio, material, ...}

var _CAT_CAMPOS = [
  {k:'descripcion',     t:'Descripción'},
  {k:'material',        t:'Composición'},
  {k:'color',           t:'Color'},
  {k:'tamano',          t:'Medida'},
  {k:'unidades_x_caja', t:'Pzs/caja'},
  {k:'carton_size',     t:'Medida caja'},
  {k:'peso',            t:'Peso'},
  {k:'barcode',         t:'Código barras'},
  {k:'marca',           t:'Marca'},
  // Lo que viene en camino de esa referencia: al cliente le importa saber
  // si hay reposición y cuándo. Se puede editar antes de generar.
  {k:'por_llegar',      t:'Por llegar'},
  // Cuándo llega: junto a la cantidad, al cliente le dice si esperar
  {k:'eta',             t:'ETA'}
];

// Lo que se va a usar: lo editado manda sobre lo guardado
function _catValor(f, campo){
  // Las fichas armadas desde el inventario traen sus datos ya resueltos y no
  // deben mezclarse con lo que se editó a mano en el catálogo NO SAP.
  if(f && f.__sinEdit) return f[campo]||'';
  var sku=String(f.itemcode||'').toUpperCase();
  var e=window._catEdit[sku]||{};
  if(e[campo]!=null && String(e[campo]).trim()!=='') return e[campo];
  return f[campo]||'';
}

// ═══════════════════════════════════════════════════════════════════════════
//  LEER LA FICHA DEL EXCEL
//  Los SKU creados antes de que la AI leyera la ficha quedaron sin datos.
//  Con esto se vuelve a leer el Excel original y se completan, emparejando
//  por código. No depende de la AI: se leen las columnas directamente.
// ═══════════════════════════════════════════════════════════════════════════

// Cómo se llama cada columna en los documentos de los proveedores.
// Se compara sin acentos ni signos, así que "MATERIAL, Construction
// Composition %" encuentra "material".
var _CAT_COLS = [
  {campo:'barcode',         claves:['barcode','codigo de barras','upc','ean','cod barras']},
  {campo:'descripcion',     claves:['product description','description','descripcion & package','product desc']},
  {campo:'itemname',        claves:['spanish name','nombre en espanol','descripcion en espanol','nombre']},
  {campo:'tamano',          claves:['item size','size','dimension','medida del producto','capacity']},
  {campo:'color',           claves:['color','colour','finishing']},
  {campo:'material',        claves:['material','composition','composicion','construction']},
  {campo:'unidades_x_caja', claves:['qty x ctn','pcs per carton','pcs x ctn','packing','unidades por caja','pzs x caja']},
  {campo:'carton_size',     claves:['carton size','medida de caja','box size','ctn size']},
  {campo:'cartones_item',   claves:['ttl ctns','total ctns','cartones','ctns']},
  {campo:'cbm',             claves:['cbm x ctn','cbm']},
  {campo:'peso',            claves:['n.w','g.w','weight','peso','kgs']},
  {campo:'marca',           claves:['brand','marca']}
];

function _catNorm(t){
  return String(t||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
}

// Encuentra la fila de cabecera y a qué campo va cada columna
function _catMapearColumnas(filas){
  var mejor={fila:-1, mapa:{}, aciertos:0};
  for(var r=0; r<Math.min(filas.length, 40); r++){
    var mapa={}, aciertos=0;
    (filas[r]||[]).forEach(function(celda, c){
      var t=_catNorm(celda);
      if(t.length<2) return;
      for(var i=0;i<_CAT_COLS.length;i++){
        var def=_CAT_COLS[i];
        if(mapa[def.campo]!=null) continue;
        for(var j=0;j<def.claves.length;j++){
          if(t.indexOf(def.claves[j])>=0){ mapa[def.campo]=c; aciertos++; return; }
        }
      }
    });
    if(aciertos>mejor.aciertos) mejor={fila:r, mapa:mapa, aciertos:aciertos};
  }
  return mejor;
}

// Lee el Excel y devuelve la ficha de cada código encontrado
async function _catFichaDelExcel(file){
  var filas=[];
  try{
    var wb=XLSX.read(await file.arrayBuffer(),{type:'array'});
    var hoja=wb.Sheets[wb.SheetNames[0]];
    filas=XLSX.utils.sheet_to_json(hoja,{header:1, defval:'', blankrows:true});
  }catch(e){
    console.warn('[ficha] no se pudo leer el Excel:', e);
    return {};
  }

  var det=_catMapearColumnas(filas);
  console.log('[ficha] cabecera en la fila '+det.fila+' · '+det.aciertos+' columna(s) reconocidas:', det.mapa);
  if(det.aciertos<2){
    console.warn('[ficha] no se reconocieron suficientes columnas');
    return {};
  }

  // Los códigos posibles de cada fila, para emparejar con los SKU
  var out={};
  for(var r=det.fila+1; r<filas.length; r++){
    var fila=filas[r]||[];
    var ficha={};
    Object.keys(det.mapa).forEach(function(campo){
      var v=fila[det.mapa[campo]];
      if(v==null || String(v).trim()==='') return;
      var t=String(v).trim();
      // Las fórmulas del Excel no sirven
      if(t.charAt(0)==='=') return;
      if(campo==='unidades_x_caja' || campo==='cartones_item' || campo==='cbm'){
        var n=parseFloat(String(t).replace(/,/g,''));
        if(!isNaN(n)) ficha[campo]=n;
      } else {
        ficha[campo]=t;
      }
    });
    if(!Object.keys(ficha).length) continue;

    // Se guarda bajo TODOS los códigos de esa fila: no se sabe cuál usó la orden
    fila.forEach(function(celda){
      var t=String(celda==null?'':celda).trim().toUpperCase();
      if(t.length<4 || t.length>24) return;
      if(!/[0-9]/.test(t)) return;
      var k=t.replace(/\s+/g,'');
      if(!out[k]) out[k]=ficha;
    });
  }
  console.log('[ficha] '+Object.keys(out).length+' código(s) con datos');
  return out;
}

// Pide el Excel y completa la ficha de los artículos elegidos
// Completa la ficha desde el Excel que YA está guardado con la orden.
// No hay que volver a subirlo: el documento quedó en la orden al crearla.
// ── Las fotos que faltan, del Excel adjunto a la orden ──
// Cuando SAP no tiene imagen, casi siempre sí la tiene el Excel que se
// adjuntó en la etapa de Pedido: la PI del proveedor o nuestra orden
// llevan la foto pegada al lado del SKU. Se busca sola, sin pedirle nada
// al usuario; solo si tampoco está ahí se ofrece adjuntarla a mano.
async function _catAutoFotos(filas){
  var sinFoto=(filas||[]).filter(function(f){ return !String(f.foto||'').trim(); });
  if(!sinFoto.length) return 0;

  var ordenes={};
  sinFoto.forEach(function(f){ if(f.dkc_origen) ordenes[f.dkc_origen]=1; });
  var refs=Object.keys(ordenes);
  if(!refs.length){
    _dbg('[fotos] los artículos sin imagen no tienen orden de origen');
    return 0;
  }

  try{ await _cargarJSZip(); }catch(e){}
  var puestas=0;

  for(var i=0;i<refs.length;i++){
    var ref=refs[i];
    var docs=[];
    try{
      var r=await fetch(SB+'/rest/v1/compras_documentos?select=url,nombre_archivo,tipo'
        +'&docnum=eq.'+encodeURIComponent(ref)+'&limit=60',{headers:SBH});
      if(r.ok) docs=await r.json()||[];
    }catch(e){ console.warn('[fotos] documentos de '+ref+':', e); }

    var xls=docs.filter(function(d){
      var n=String(d.nombre_archivo||d.url||'');
      return /\.(xlsx|xls|xlsm)$/i.test(n) || /^xlsx?$/i.test(String(d.tipo||''));
    });
    // Y lo que esté en la sesión, si la orden se acaba de crear
    try{
      var enMem=(window._atts&&window._atts[ref+'pedido'])||[];
      enMem.forEach(function(a){
        if(/\.(xlsx|xls|xlsm)$/i.test(String(a.name||'')) && a.url){
          xls.push({url:a.url, nombre_archivo:a.name});
        }
      });
    }catch(e){}

    if(!xls.length){
      _dbg('[fotos] la orden '+ref+' no tiene Excel adjunto');
      continue;
    }

    for(var k=0;k<xls.length && sinFoto.some(function(f){ return !f.foto; });k++){
      try{
        var url=DOCS_BASE+String(xls[k].url).split('/').map(encodeURIComponent).join('/');
        var resp=await fetch(url);
        if(!resp.ok){ _dbg('[fotos] no se pudo bajar '+xls[k].nombre_archivo); continue; }
        var blob=await resp.blob();
        var file=new File([blob], xls[k].nombre_archivo||'orden.xlsx');

        var delaOrden=sinFoto.filter(function(f){ return String(f.dkc_origen||'')===ref; });
        var mapa=await _nsapFotosPorSku(file, delaOrden.map(function(x){
          return {itemcode:x.itemcode, itemname:x.itemname,
                  barcode:x.barcode, cantidad:x.por_llegar||0}; }),
          {estricto:true});

        Object.keys(mapa||{}).forEach(function(sku){
          var d=mapa[sku];
          if(!d || !d.b64) return;
          var ficha=delaOrden.find(function(x){
            return String(x.itemcode||'').toUpperCase()===String(sku).toUpperCase(); });
          if(ficha && !String(ficha.foto||'').trim()){
            ficha.foto='data:'+(d.mime||'image/jpeg')+';base64,'+d.b64;
            ficha.__fotoOk=1;
            puestas++;
          }
        });
        _dbg('[fotos] '+xls[k].nombre_archivo+': '
          +Object.keys(mapa||{}).length+' SKU con imagen');
      }catch(e){ console.warn('[fotos] '+ref+':', e); }
    }
  }

  var quedan=sinFoto.filter(function(f){ return !String(f.foto||'').trim(); }).length;
  if(puestas) _dbg('[fotos] '+puestas+' imagen(es) sacadas del Excel de la orden');
  if(quedan)  _dbg('[fotos] '+quedan+' artículo(s) siguen sin imagen');
  return puestas;
}

async function _catAutoFicha(filas){
  // Los artículos a los que les falta algo
  var faltos=filas.filter(function(f){
    return !f.material && !f.color && !f.tamano && !f.barcode;
  });
  if(!faltos.length) return 0;

  // Las órdenes de donde vinieron esos artículos
  var ordenes={};
  faltos.forEach(function(f){ if(f.dkc_origen) ordenes[f.dkc_origen]=1; });
  var refs=Object.keys(ordenes);
  if(!refs.length){
    console.log('[ficha] los artículos sin datos no tienen orden de origen');
    return 0;
  }

  var puestos=0;
  for(var i=0;i<refs.length;i++){
    var ref=refs[i];
    // El Excel adjunto de esa orden
    var docs=[];
    try{
      // La columna es nombre_archivo, no nombre: por eso no encontraba nada
      var r=await fetch(SB+'/rest/v1/compras_documentos?select=url,nombre_archivo,tipo'
        +'&docnum=eq.'+encodeURIComponent(ref)+'&limit=60',{headers:SBH});
      if(r.ok) docs=await r.json()||[];
      console.log('[ficha] orden '+ref+': '+docs.length+' documento(s)',
        docs.map(function(d){ return d.nombre_archivo; }));
    }catch(e){ console.warn('[ficha] documentos de '+ref+':', e); }

    var xls=docs.filter(function(d){
      var n=String(d.nombre_archivo||d.url||'');
      return /\.(xlsx|xls)$/i.test(n) || /^xlsx?$/i.test(String(d.tipo||''));
    });
    if(!xls.length){
      console.log('[ficha] la orden '+ref+' no tiene Excel adjunto');
      // Puede estar en la memoria de la sesión, si la orden se creó recién
      try{
        var enMem=(window._atts&&window._atts[ref+'pedido'])||[];
        enMem.forEach(function(a){
          if(/\.(xlsx|xls)$/i.test(String(a.name||'')) && a.url){
            xls.push({url:a.url, nombre_archivo:a.name});
          }
        });
        if(xls.length) console.log('[ficha] encontrado en la sesión: '+xls[0].nombre_archivo);
      }catch(e){}
      if(!xls.length) continue;
    }

    for(var k=0;k<xls.length;k++){
      try{
        var url=DOCS_BASE+String(xls[k].url).split('/').map(encodeURIComponent).join('/');
        var resp=await fetch(url);
        if(!resp.ok) continue;
        var blob=await resp.blob();
        var file=new File([blob], xls[k].nombre_archivo||'orden.xlsx');
        var fichas=await _catFichaDelExcel(file);
        if(!Object.keys(fichas).length){
          console.log('[ficha] '+file.name+': no se reconocieron columnas');
          continue;
        }

        faltos.forEach(function(f){
          if(String(f.dkc_origen||'')!==ref) return;
          var sku=String(f.itemcode||'').trim().toUpperCase().replace(/\s+/g,'');
          var ficha=fichas[sku];
          if(!ficha) return;
          var algo=false;
          Object.keys(ficha).forEach(function(c){
            if(f[c]!=null && String(f[c]).trim()!=='') return;
            _catEditSet(sku, c, ficha[c]);
            algo=true;
          });
          if(algo) puestos++;
        });
      }catch(e){ console.warn('[ficha] '+ref+':', e); }
    }
  }
  if(puestos) console.log('[ficha] '+puestos+' artículo(s) completados desde el Excel de la orden');
  return puestos;
}

function _catLeerFichaExcel(){
  var inp=document.createElement('input');
  inp.type='file';
  inp.accept='.xlsx,.xls,.csv';
  inp.onchange=async function(){
    var f=inp.files && inp.files[0];
    if(!f) return;
    showT('Leyendo el archivo…');
    var fichas=await _catFichaDelExcel(f);
    var n=Object.keys(fichas).length;
    if(!n){
      showT('No se reconocieron las columnas del archivo', 6000);
      return;
    }

    var filas=(window._catNoSap||[]).filter(function(x){
      return x.tipo!=='proveedor' && window._catSel[String(x.itemcode||'').toUpperCase()];
    });
    var puestos=0, campos=0;
    filas.forEach(function(x){
      var sku=String(x.itemcode||'').trim().toUpperCase().replace(/\s+/g,'');
      var ficha=fichas[sku];
      // Si no está por el código KCC, se prueba por el del proveedor
      if(!ficha && x.itemcode_proveedor){
        ficha=fichas[String(x.itemcode_proveedor).trim().toUpperCase().replace(/\s+/g,'')];
      }
      if(!ficha) return;
      var algo=false;
      Object.keys(ficha).forEach(function(k){
        // No se pisa lo que ya tiene valor
        if(x[k]!=null && String(x[k]).trim()!=='') return;
        _catEditSet(sku, k, ficha[k]);
        campos++; algo=true;
      });
      if(algo) puestos++;
    });

    showT(puestos
      ? ('✓ '+puestos+' artículo(s) completados · '+campos+' dato(s)')
      : 'No se encontró ninguno de los códigos en ese archivo', 6000);
    if(puestos) _catRevisarAbrir(true);
  };
  inp.click();
}

async function _catRevisarAbrir(saltarAuto){
  var skus=Object.keys(window._catSel||{});
  if(!skus.length){ showT('Elige al menos un artículo'); return; }
  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  if(!filas.length){ showT('No se encontraron los artículos'); return; }

  // Lo que falte se completa solo con el Excel que ya está en la orden
  if(!saltarAuto){
    var faltan=filas.filter(function(f){
      return !_catValor(f,'material') && !_catValor(f,'color') && !_catValor(f,'tamano');
    }).length;
    if(faltan){
      showT('Completando la ficha desde la orden…');
      try{
        var n=await _catAutoFicha(filas);
        if(n) showT('✓ '+n+' artículo(s) completados desde el documento de la orden');
      }catch(e){ console.warn('[ficha] auto:', e); }
    }
  }

  // Se cierra el selector: si no, quedan dos ventanas encimadas
  var sel=document.getElementById('modalCatalogo'); if(sel) sel.remove();
  var prev=document.getElementById('modalCatRev'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCatRev';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10003;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:16px;overflow-y:auto';

  var sinPrecio=filas.filter(function(f){ return !Number(_catValor(f,'precio_venta')); }).length;
  var sinFicha=filas.filter(function(f){
    return !_catValor(f,'material') && !_catValor(f,'color') && !_catValor(f,'tamano');
  }).length;

  var h='<div style="background:var(--surface-2);border-radius:14px;padding:16px;'
    +'width:100%;max-width:1180px;max-height:94vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)">'
        +'<i class="ti ti-list-check"></i> Revisar antes de generar</div>'
      +'<button onclick="_catRevCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
      +'Este catálogo va al cliente. Completá lo que falte y poné el precio de venta.</div>';

  // Cuántos van a salir sin imagen en el catálogo
  var sinFoto=filas.filter(function(f){
    return !String(f.foto||'').trim(); }).length;

  if(sinPrecio || sinFicha || sinFoto){
    h+='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;'
      +'padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-alert-circle"></i> '
      +[sinPrecio?(sinPrecio+' sin precio de venta'):'',
        sinFicha?(sinFicha+' sin datos de ficha'):'',
        sinFoto?('<b>'+sinFoto+' sin foto</b>'):''].filter(Boolean).join(' · ')
      +'</div>';
  }

  // El botón va SIEMPRE, tenga o no avisos: sirve también para actualizar
  // fotos y datos que ya estén puestos.
  h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:10px">'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
    +'onclick="_catFotosDesdeDoc()">'
    +'<i class="ti ti-photo-plus"></i> Completar o actualizar desde un Excel</button>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">Adjunta el Excel del '
    +'proveedor: saca las fotos y los datos, emparejando por SKU.</span></div>';

  // Herramientas para llenar rápido
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px;align-items:center">'
    +'<span style="font-size:11px;color:var(--text-muted);font-weight:600">Rellenar todos</span>'
    +'<input id="catMasivoCampo" list="catCamposLst" placeholder="Campo" '
      +'style="width:120px;padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11.5px">'
    +'<datalist id="catCamposLst">'
      +_CAT_CAMPOS.map(function(c){ return '<option value="'+c.t+'">'; }).join('')
      +'<option value="Precio venta"></datalist>'
    +'<input id="catMasivoValor" placeholder="Valor para todos" '
      +'style="flex:1;min-width:150px;padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11.5px">'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catMasivo()">Aplicar</button>'
    +'<span style="flex:1"></span>'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catMargen()">'
      +'<i class="ti ti-percentage"></i> Precio por margen</button>'
    +(sinFicha
      ? ('<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
         +'onclick="_catLeerFichaExcel()" '
         +'title="Si el documento no estaba guardado, subilo a mano">'
         +'<i class="ti ti-file-import"></i> Subir el Excel a mano</button>')
      : '')
    +'</div>';

  // La tabla editable
  h+='<div style="border:0.5px solid var(--border);border-radius:9px;overflow:auto;max-height:56vh">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0;z-index:2">'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Foto</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +_CAT_CAMPOS.map(function(c){
          return '<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;'
            +'color:var(--text-muted)">'+_esc(c.t)+'</th>'; }).join('')
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--t-verde)">Precio venta</th>'
    +'</tr></thead><tbody>';

  // Las filas quedan guardadas: los campos de la tabla trabajan por POSICIÓN,
  // no metiendo el código dentro del onchange. Así no hay comillas que armar
  // y da igual lo que traiga el SKU.
  window._catRevFilas=filas;

  filas.forEach(function(f, _fi){
    var sku=String(f.itemcode||'').toUpperCase();
    var _alt=f.foto_nosap || _fotoNoSapDeSku(sku);
    var foto=f.foto || f.foto_url || _alt || '';
    // SAP a veces declara un picturname cuyo archivo no está en el bucket:
    // la imagen no carga y quedaba el hueco. Si eso pasa y tenemos la del
    // proveedor, se cambia sola sin recargar nada.
    var _onerr=(_alt && _alt!==foto)
      ? (' onerror="if(!this.dataset.alt){this.dataset.alt=1;this.src=\''+_esc(_alt)+'\';}"')
      : '';
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:4px 6px">'
        +(foto?('<img src="'+_esc(foto)+'" class="cat-foto-mini" onclick="_catVerFoto('+_fi+')" '
                +'title="Pasá el mouse para verla grande · pulsa para abrirla"'+_onerr+'>')
              :('<span style="display:flex;width:38px;height:38px;border-radius:5px;'
                +'background:var(--surface-1);align-items:center;justify-content:center;'
                +'color:var(--text-muted)"><i class="ti ti-photo-off" style="font-size:13px"></i></span>'))
      +'</td>'
      +'<td style="padding:4px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'
        +_esc(f.itemcode||'')+'</td>';
    _CAT_CAMPOS.forEach(function(c, _ci){
      var v=_catValor(f, c.k);
      h+='<td style="padding:3px 5px">'
        +'<input value="'+_esc(String(v||''))+'" '
        +'onchange="_catRevSet('+_fi+','+_ci+',this.value)" '
        +'placeholder="—" style="width:100%;min-width:90px;padding:4px 6px;border:0.5px solid '
        +(v?'var(--border)':'#E9C08A')+';border-radius:5px;font-size:10.5px;'
        +'background:'+(v?'var(--surface-0)':'#FEF9F3')+';color:var(--text-primary)"></td>';
    });
    var pv=_catValor(f,'precio_venta');
    var costo=Number(f.precio)||0;
    // El margen es solo para decidir el precio aquí: NO va al catálogo final.
    // Se puede escribir en cualquiera de los dos campos y el otro se ajusta,
    // para poder dar un descuento distinto a cada artículo.
    var mg=(costo>0 && Number(pv)>0) ? Math.round(((Number(pv)-costo)/Number(pv))*1000)/10 : null;
    h+='<td style="padding:3px 5px;white-space:nowrap">'
      +'<input id="catpv-'+_fi+'" type="number" step="0.01" value="'+(pv||'')+'" '
      +'onchange="_catPrecioLinea('+_fi+',this.value)" '
      +'placeholder="0.00" style="width:82px;padding:4px 6px;border:1px solid '
      +(pv?'#16a34a':'#E9C08A')+';border-radius:5px;font-size:11px;text-align:right;'
      +'font-weight:700;background:'+(pv?'#dcfce7':'#FEF9F3')+';color:var(--t-verde)">'
      +(costo>0
        ? ('<input id="catmg-'+_fi+'" type="number" step="0.1" min="0" max="99.9" '
           +'value="'+(mg==null?'':mg)+'" '
           +'onchange="_catMargenLinea('+_fi+',this.value)" '
           +'title="Margen sobre el precio de venta · costo '+fmt(costo)+'. '
           +'Cambialo y el precio se recalcula solo." '
           +'placeholder="%" style="width:52px;margin-left:5px;padding:4px 5px;border:1px solid '
           +(mg==null?'var(--border)':'#C4B5FD')+';border-radius:5px;font-size:10.5px;'
           +'text-align:right;font-weight:700;background:var(--surface-0);color:'
           +(mg==null?'var(--text-muted)':(mg>=40?'#166534':(mg>=20?'#B45309':'#991b1b')))+'">'
           +'<span style="font-size:10px;color:var(--text-muted);margin-left:2px">%</span>')
        : '<span style="font-size:9.5px;color:var(--text-muted);margin-left:5px" '
          +'title="Este artículo no tiene costo cargado: poné el precio a mano">sin costo</span>')
      +'<div id="catmgtxt-'+_fi+'" style="font-size:9.5px;color:var(--text-muted);'
      +'text-align:right;margin-top:2px">'
      +(costo>0?('costo '+fmt(costo)+(mg==null?'':(' · margen '+mg+'%'))):'')
      +'</div>'
      +'</td></tr>';
  });
  h+='</tbody></table></div>';

  h+='<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;'
    +'margin-top:12px;flex-wrap:wrap">'
    +'<span style="font-size:11px;color:var(--text-muted)">'+filas.length+' artículo(s)</span>'
    +'<div style="display:flex;gap:8px">'
      +'<button class="btn" onclick="_catRevCerrar()">Cerrar</button>'
      +'<button class="btn bg2" onclick="_catGuardarFicha()"><i class="ti ti-device-floppy"></i> Guardar los datos</button>'
      +'<button class="btn bg2" onclick="_catGenerar(\'excel\')"><i class="ti ti-file-spreadsheet"></i> Excel</button>'
      +'<button class="btn bg2" style="border-color:#C7C3F5;color:var(--t-indigo)" onclick="_catGenerar(\'pdf\',true)">'
        +'<i class="ti ti-mail"></i> Generar y enviar</button>'
      +'<button class="btn bp" style="background:#7C3D12" onclick="_catGenerar(\'pdf\')">'
        +'<i class="ti ti-file-type-pdf"></i> Generar catálogo</button>'
    +'</div></div></div>';

  ov.innerHTML=h;
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
  _modalEsc(ov);
}

// ── Sacar las fotos que faltan de un Excel o un PDF ──
// Cuando SAP no tiene imagen de un artículo, casi siempre sí la tiene el
// documento del proveedor: la PI o nuestra orden en Excel llevan la foto
// pegada al lado del SKU. Se leen de ahí y se emparejan por código.
// Un velo con la rueda mientras se lee el Excel o se genera el catálogo.
// Sin esto parecía que el portal se había quedado colgado: leer un Excel
// con cien imágenes tarda sus segundos.
function _catTrabajando(texto){
  var ov=document.getElementById('cat-trabajando');
  if(!ov){
    ov=document.createElement('div');
    ov.id='cat-trabajando';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10099;'
      +'display:flex;align-items:center;justify-content:center';
    document.body.appendChild(ov);
  }
  ov.innerHTML='<div style="background:var(--surface-2);border:0.5px solid var(--border);'
    +'border-radius:12px;padding:22px 30px;text-align:center;min-width:250px;'
    +'box-shadow:0 8px 30px rgba(0,0,0,.25)">'
    +'<div class="ai-ring g" style="margin:0 auto 12px;display:block"></div>'
    +'<div id="cat-trabajando-txt" style="font-size:13px;font-weight:600;'
    +'color:var(--text-primary)">'+_esc(texto||'Trabajando…')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:5px">'
    +'Puede tardar unos segundos</div></div>';
  ov.style.display='flex';
}

function _catTrabajandoTexto(t){
  var el=document.getElementById('cat-trabajando-txt');
  if(el) el.textContent=t;
}

function _catListo(){
  var ov=document.getElementById('cat-trabajando');
  if(ov) ov.remove();
}

async function _catFotosDesdeDoc(){
  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  // Antes se cortaba aquí si todos tenían algo en el campo foto. Pero "tener
  // foto" no significa que la imagen exista ni que sea la buena: puede estar
  // rota o ser vieja. Y a veces se quiere actualizar a propósito. Así que
  // siempre se deja subir el Excel.
  var sinFoto=filas.filter(function(f){ return !String(f.foto||'').trim(); });
  if(!filas.length){ showT('No hay artículos seleccionados'); return; }

  var inp=document.createElement('input');
  inp.type='file';
  inp.accept='.xlsx,.xls,.xlsm,.pdf';
  inp.multiple=true;
  inp.onchange=async function(){
    var files=Array.prototype.slice.call(inp.files||[]);
    if(!files.length) return;
    _catTrabajando('Leyendo el Excel…');
    try{ await _cargarJSZip(); }catch(e){}

    var puestas=0, delPdf=0, datos=0;
    for(var i=0;i<files.length;i++){
      var f=files[i];
      _catTrabajandoTexto('Leyendo '+f.name+(files.length>1?(' ('+(i+1)+' de '+files.length+')'):'')+'…');
      var esPdf=/\.pdf$/i.test(f.name);
      try{
        if(esPdf){
          delPdf++;
          console.log('[catálogo] '+f.name+' es un PDF: las fotos se sacan del Excel, '
            +'no del PDF. Si solo hay PDF, hay que pedirle el Excel al proveedor.');
          continue;
        }

        // Del mismo Excel salen también los datos de ficha: composición,
        // color, medida, piezas por caja, peso, código de barras y marca.
        // Traer solo la foto y dejar el resto en blanco no tiene sentido.
        try{
          var fichas=await _catFichaDelExcel(f);
          Object.keys(fichas||{}).forEach(function(sku){
            var ficha=fichas[sku];
            var destino=filas.find(function(x){
              return String(x.itemcode||'').trim().toUpperCase().replace(/\s+/g,'')===sku; });
            if(!destino) return;
            Object.keys(ficha).forEach(function(c){
              // Lo que ya está puesto no se pisa
              if(destino[c]!=null && String(destino[c]).trim()!=='') return;
              _catEditSet(String(destino.itemcode||'').toUpperCase(), c, ficha[c]);
              datos++;
            });
          });
        }catch(e){ console.warn('[catálogo] ficha del Excel:', e); }
        // Se reutiliza el lector de fotos de las órdenes NO SAP: empareja por
        // SKU y por fila, y ya sabe de celdas combinadas.
        var mapa=await _nsapFotosPorSku(f, filas.map(function(x){
          return {itemcode:x.itemcode, itemname:x.itemname,
                  barcode:x.barcode, cantidad:x.por_llegar||0}; }),
          {estricto:true});
        // El lector devuelve {mime, b64, ...}: se arma la imagen incrustada,
        // igual que hacen las órdenes NO SAP.
        Object.keys(mapa||{}).forEach(function(sku){
          var d=mapa[sku];
          if(!d || !d.b64) return;
          var url='data:'+(d.mime||'image/jpeg')+';base64,'+d.b64;
          var ficha=filas.find(function(x){
            return String(x.itemcode||'').toUpperCase()===String(sku).toUpperCase(); });
          if(!ficha) return;
          // La del Excel manda: es la que el proveedor mandó para ESA orden.
          // Solo se respeta la que ya venga incrustada (data:), que es una
          // que se puso antes desde otro Excel.
          var actual=String(ficha.foto||'');
          if(!actual.trim() || actual.indexOf('data:')!==0){
            ficha.foto=url; ficha.__fotoOk=1; puestas++;
          }
        });
      }catch(e){ console.warn('[catálogo] '+f.name+':', e); }
    }

    _catListo();
    if(puestas || datos){
      showT('✓ '+[puestas?(puestas+' foto(s)'):'', datos?(datos+' dato(s)'):'']
        .filter(Boolean).join(' y ')+' del Excel');
      _catRevisarAbrir(false);        // repintar con lo añadido
    } else {
      showT(delPdf
        ? 'Del PDF no se pueden extraer: adjuntá el Excel del proveedor'
        : 'No se encontraron fotos que emparejaran con estos SKU', 6000);
    }
  };
  inp.click();
}

function _catRevCerrar(){
  window._catFuente=null;      // se vuelve al catálogo BORRADOR
  var m=document.getElementById('modalCatRev'); if(m) m.remove();
}

function _catEditSet(sku, campo, valor){
  sku=String(sku).toUpperCase();
  window._catEdit[sku]=window._catEdit[sku]||{};
  window._catEdit[sku][campo]=(campo==='precio_venta')?(Number(valor)||0):String(valor||'').trim();
}

// Rellena un campo en todos los artículos de una vez
function _catMasivo(){
  var campoTxt=((document.getElementById('catMasivoCampo')||{}).value||'').trim();
  var valor=((document.getElementById('catMasivoValor')||{}).value||'').trim();
  if(!campoTxt || !valor){ showT('Elige el campo y escribe el valor'); return; }
  var campo=null;
  if(/precio/i.test(campoTxt)) campo='precio_venta';
  else {
    var c=_CAT_CAMPOS.find(function(x){ return x.t.toLowerCase()===campoTxt.toLowerCase(); });
    campo=c?c.k:null;
  }
  if(!campo){ showT('No reconozco ese campo'); return; }
  var n=0;
  Object.keys(window._catSel||{}).forEach(function(sku){
    _catEditSet(sku, campo, valor); n++;
  });
  showT('✓ '+n+' artículo(s) actualizados');
  _catRevisarAbrir(true);
}

// La fila que se está editando, por posición en la tabla
function _catRevFila(i){ return (window._catRevFilas||[])[i]||null; }
function _catRevSku(i){ var f=_catRevFila(i); return f?String(f.itemcode||'').toUpperCase():''; }

// Un campo cualquiera de la ficha (descripción, color, medida…)
function _catRevSet(i, campoIdx, valor){
  var sku=_catRevSku(i); if(!sku) return;
  var c=_CAT_CAMPOS[campoIdx]; if(!c) return;
  _catEditSet(sku, c.k, valor);
}

// Margen de UNA línea: se escribe el % y se recalcula su precio. Sirve para
// dar un descuento distinto a cada artículo sin tocar los demás.
function _catMargenLinea(i, valor){
  var f=_catRevFila(i); if(!f) return;
  var costo=Number(f.precio)||0;
  var elP=document.getElementById('catpv-'+i);
  var elM=document.getElementById('catmg-'+i);
  if(!costo){ showT('Ese artículo no tiene costo: poné el precio a mano'); return; }
  var txt=String(valor==null?'':valor).trim();
  if(txt===''){ return; }                       // se vació: no se toca el precio
  var m=parseFloat(txt);
  if(isNaN(m) || m<0 || m>=100){
    showT('El margen tiene que estar entre 0 y 99,9', 4000);
    if(elM) elM.value='';
    return;
  }
  var pv=Math.round((costo/(1-m/100))*100)/100;
  _catEditSet(String(f.itemcode||'').toUpperCase(), 'precio_venta', pv);
  if(elP){ elP.value=pv; elP.style.borderColor='#16a34a'; elP.style.background='#dcfce7'; }
  _catPintarMargen(elM, m);
  _catPieLinea(i, costo, m);
}

// Al escribir el precio a mano, el margen se recalcula para no quedar mintiendo
function _catPrecioLinea(i, valor){
  var f=_catRevFila(i); if(!f) return;
  var costo=Number(f.precio)||0;
  _catEditSet(String(f.itemcode||'').toUpperCase(), 'precio_venta', valor);
  var pv=Number(valor)||0;
  var elP=document.getElementById('catpv-'+i);
  if(elP && pv>0){ elP.style.borderColor='#16a34a'; elP.style.background='#dcfce7'; }
  var elM=document.getElementById('catmg-'+i);
  if(costo>0 && pv>0){
    var m=Math.round(((pv-costo)/pv)*1000)/10;
    if(elM){ elM.value=m; _catPintarMargen(elM, m); }
    _catPieLinea(i, costo, m);
  } else {
    if(elM) elM.value='';
    _catPieLinea(i, costo, null);
  }
}

function _catPintarMargen(el, m){
  if(!el) return;
  var c=(m>=40?'#166534':(m>=20?'#B45309':'#991b1b'));
  el.style.color=c; el.style.borderColor='#C4B5FD';
}

// La línea de abajo: costo y a cuánto margen equivale el precio puesto
function _catPieLinea(i, costo, m){
  var el=document.getElementById('catmgtxt-'+i);
  if(!el) return;
  el.innerHTML=(costo>0)
    ? ('costo '+fmt(costo)+(m==null?'':(' · margen <b style="color:'
       +(m>=40?'#166534':(m>=20?'#B45309':'#991b1b'))+'">'+m+'%</b>')))
    : '';
}

// Ver en grande la foto de la ficha
function _catVerFoto(i){
  var f=_catRevFila(i); if(!f) return;
  var sku=String(f.itemcode||'').toUpperCase();
  var url=f.foto || f.foto_url || ((window._nsapFotos||{})[sku]||{}).url || '';
  if(!url) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:10060;'
    +'display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  ov.innerHTML='<div style="max-width:92vw;max-height:92vh;text-align:center">'
    +'<img src="'+_esc(url)+'" style="max-width:92vw;max-height:84vh;object-fit:contain;'
    +'border-radius:10px;background:var(--surface-2);box-shadow:0 20px 60px rgba(0,0,0,.5)">'
    +'<div style="color:#fff;font-size:12.5px;margin-top:10px">'
    +_esc(f.itemcode||'')+(f.itemname?(' — '+_esc(f.itemname)):'')+'</div></div>';
  ov.addEventListener('click', function(){ ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}

// Calcula el precio de venta aplicando un margen sobre el costo
// El margen es sobre el PRECIO DE VENTA, no sobre el costo:
//   precio = costo / (1 - margen/100)
// Con un costo de 100 y un 50% de margen el precio es 200, y de esos 200 la
// mitad es ganancia. (Aplicarlo sobre el costo daba 150, que es un margen
// real del 33%.)
function _catMargen(){
  var v=prompt('¿Qué margen quieres sobre el precio de venta?\n\n'
    +'Ejemplo: un costo de 100 con 50% de margen da un precio de 200.\n'
    +'El margen es la parte del precio que es ganancia.','50');
  if(v===null) return;
  var m=parseFloat(v);
  if(isNaN(m) || m<0){ showT('El margen no es válido'); return; }
  if(m>=100){ showT('El margen tiene que ser menor a 100%', 4000); return; }
  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  var n=0, sin=0;
  filas.forEach(function(f){
    var costo=Number(f.precio)||0;
    if(!costo){ sin++; return; }
    var pv=Math.round((costo/(1-m/100))*100)/100;
    _catEditSet(String(f.itemcode||'').toUpperCase(), 'precio_venta', pv);
    n++;
  });
  showT('✓ '+n+' precio(s) calculados'+(sin?(' · '+sin+' sin costo'):''));
  _catRevisarAbrir(true);
}

// Guarda en la base lo que se completó a mano
async function _catGuardarFicha(){
  var skus=Object.keys(window._catEdit||{});
  if(!skus.length){ showT('No hay cambios que guardar'); return; }
  showT('Guardando…');
  var n=0, err=0;
  for(var i=0;i<skus.length;i++){
    var sku=skus[i];
    var f=(window._catNoSap||[]).find(function(x){
      return x.tipo!=='proveedor' && String(x.itemcode||'').toUpperCase()===sku; });
    if(!f || !f.id) continue;
    var cambios=window._catEdit[sku];
    try{
      var r=await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+f.id,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(cambios)});
      if(r.ok){
        Object.keys(cambios).forEach(function(k){ f[k]=cambios[k]; });
        n++;
      } else {
        err++;
        var t=await r.text();
        console.warn('[catálogo] no se guardó '+sku+':', r.status, t.slice(0,140));
        if(/column/i.test(t)){
          showT('Faltan columnas en la base · corré catalogo_nosap.sql', 6000);
          return;
        }
      }
    }catch(e){ err++; console.warn('[catálogo] '+sku+':', e); }
  }
  showT(n?('✓ '+n+' artículo(s) guardados'+(err?(' · '+err+' con error'):'')):'No se pudo guardar');
  try{ if(PG==='catnosap') rCatNoSap(); }catch(e){}
}

// Botón para armar el catálogo de los SKU de una orden concreta
// ═══════════════════════════════════════════════════════════════════════════
//  CONCILIACIÓN BANCARIA
//  Compara el extracto del banco contra el libro mayor de SAP, mes a mes y
//  cuenta por cuenta. El orden y la fecha exacta no importan —el banco puede
//  registrar el 17 lo que SAP asienta el 18—, pero sí importa que no falte
//  ninguna partida y que los totales cuadren.
//
//  La comprobación clave: la diferencia entre el saldo del banco y el del
//  libro tiene que explicarse ENTERA con las partidas que quedaron sin
//  conciliar. Si no cuadra, es que falta algo por leer o por registrar.
// ═══════════════════════════════════════════════════════════════════════════

var CONCIL_CUENTAS = [
  {n:'Banco General'},
  {n:'Banistmo, S.A.',                 c:'0100154112'},
  {n:'Banistmo, S.A. - TARJETAS',      c:'0100977231'},
  {n:'Banistmo, S.A. - EUROS',         c:'0118109520'},
  {n:'Bac Intl Bank',                  c:'104000856'},
  {n:'St. Georges Bank'},
  {n:'Banco Leon, Rep. Dominicana'},
  {n:'Banco Lafise'},
  {n:'Mercantil Banco, S.A.'},
  {n:'BHD Panamá'},
  {n:'BHD Panamá (Plazo Fijo)'},
  {n:'Banesco'},
  {n:'Towerbank'},
  {n:'Multibank'},
  {n:'BCT Panamá'},
  {n:'BCT Costa Rica Colones'},
  {n:'BCT Costa Rica Dólares'},
  {n:'Profuturo'}
];

var MESES_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio',
                'Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

// Palabras que delatan un cargo del banco que rara vez está en el libro
var CONCIL_COMISION = /comisi|timbre|iva|itbms|anualidad|mantenimiento|cargo|manejo|sobregiro|chequera|bancanet|impuesto|interes|inter\u00e9s/i;

function _concEs(v){ return CONCIL_COMISION.test(String(v||'')); }

// ── La pantalla ───────────────────────────────────────────────────────
function rConcil(){
  var box=document.getElementById('page-concil'); if(!box) return;
  // La conciliación es de contabilidad y de la gerencia general. Una gerencia
  // acotada a un departamento (Gady en alfombras, Henry en ropa) no la ve:
  // ocultar solo el botón no basta, porque a la pantalla se puede llegar por
  // otras vías.
  if(!(CU && (CU.role==='contabilidad' || (CU.role==='gerencia' && !_deptAcotado())))){
    box.innerHTML='<div class="empty" style="padding:24px;color:var(--text-muted)">'
      +'<i class="ti ti-lock" style="font-size:22px"></i><br>'
      +'La conciliación bancaria es de contabilidad y gerencia general.</div>';
    return;
  }
  // Las cuentas salen del plan de cuentas de SAP; la lista fija es el respaldo
  if(!window._concCuentasSAP && !window._concPidiendoCtas){
    window._concPidiendoCtas=true;
    _concCargarCuentas().then(function(){ try{ rConcil(); }catch(e){} });
  }
  var hoy=new Date();
  // Primero el estado: más abajo se lee st.cuenta, y usarlo antes de crearlo
  // dejaba la pantalla en blanco.
  var st=window._concEstado||(window._concEstado={
    cuenta:'Banco Lafise', mes:hoy.getMonth(), anio:hoy.getFullYear(),
    extracto:null, libro:null, res:null
  });

  var CUENTAS=window._concCuentasSAP||CONCIL_CUENTAS;
  // El valor del desplegable es el CÓDIGO de la cuenta cuando existe: el
  // nombre de la lista fija no coincide con el de SAP.
  window._concCtaSAP={}; window._concCtaNombre={};
  CUENTAS.forEach(function(x){
    var v=x.c||x.n;
    window._concCtaSAP[v]=v;
    window._concCtaNombre[v]=x.n+(x.c?('  ·  '+x.c):'');
  });
  if(!window._concCtaNombre[st.cuenta]){
    // Se recupera la cuenta elegida por nombre, o se toma la primera
    var hall=CUENTAS.find(function(x){
      return String(x.n||'').toLowerCase().replace(/[^a-z0-9]/g,'')
           === String(st.cuenta||'').toLowerCase().replace(/[^a-z0-9]/g,''); });
    st.cuenta=hall?(hall.c||hall.n):((CUENTAS[0]&&(CUENTAS[0].c||CUENTAS[0].n))||'');
  }

  // La primera vez se comprueba el mes en curso
  if(!window._concIniciado){
    window._concIniciado=true;
    setTimeout(function(){
      try{ _concRevisarLibro(); }catch(e){}
      try{ _concBuscarExtracto(); }catch(e){}
      try{ _concBuscarConciliacion(); }catch(e){}
    }, 200);
  }

  var h='<div class="slbl"><i class="ti ti-scale"></i>Conciliación bancaria</div>'
   +'<div style="background:var(--surface-0);border:0.5px solid var(--border);'
     +'border-radius:var(--radius);padding:14px;margin-bottom:12px">'

   +'<div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;margin-bottom:12px">'
     +'<div style="flex:1;min-width:220px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Cuenta</label>'
       +'<select id="conc-cta" onchange="_concSet(\'cuenta\',this.value)" '
       +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;'
       +'font-size:12.5px;margin-top:3px;font-family:var(--font-sans)">'
       + CUENTAS.map(function(x){
           var v=x.c||x.n;
           return '<option value="'+_esc(v)+'"'+(st.cuenta===v?' selected':'')+'>'
             +_esc(x.n)+(x.c?('  ·  '+x.c):'')+'</option>'; }).join('')
       +'</select></div>'
     +'<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Mes</label>'
       +'<select id="conc-mes" onchange="_concSet(\'mes\',this.value)" '
       +'style="padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;'
       +'font-size:12.5px;margin-top:3px;font-family:var(--font-sans)">'
       + MESES_ES.map(function(m,i){ return '<option value="'+i+'"'+(st.mes===i?' selected':'')+'>'+m+'</option>'; }).join('')
       +'</select></div>'
     +'<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Año</label>'
       +'<input id="conc-anio" type="number" value="'+st.anio+'" onchange="_concSet(\'anio\',this.value)" '
       +'style="width:92px;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;'
       +'font-size:12.5px;margin-top:3px"></div>'
   +'</div>'

   +'<div style="display:flex;gap:10px;flex-wrap:wrap">'
     + _concCajaExtracto(st)
     + '<div id="conc-libro" style="flex:1;min-width:250px">'+_concLibroEstadoHTML()+'</div>'
   +'</div>'
   + _concCajaConciliacion(st)

   +'<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:12px;flex-wrap:wrap">'
     +'<span style="font-size:11px;color:var(--text-muted)">'
       +'El libro mayor sale del reporte de SAP filtrando la cuenta y el mes. '
       +'Se aceptan PDF, Excel o CSV.</span>'
     +'<button class="btn bp" onclick="_concConciliar()" style="background:#72243E">'
       +'<i class="ti ti-scale"></i> Conciliar el mes</button>'
   +'</div></div>'

   +(window._concCtasError
     ? ('<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;'
        +'padding:9px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:12px">'
        +'<i class="ti ti-alert-circle"></i> No se pudo leer la lista de cuentas de SAP: '
        +_esc(window._concCtasError)
        +'. Se está usando la lista de respaldo, que no tiene los códigos y no puede '
        +'consultar el libro mayor.</div>')
     : '')
   +((!st.res && window._concGuardadaInfo)
     ? ('<div style="background:'+(window._concGuardadaInfo.cuadra?'#dcfce7':'#FEF9F3')
        +';border:1px solid '+(window._concGuardadaInfo.cuadra?'#16a34a':'#E9C08A')
        +';border-radius:9px;padding:10px 12px;font-size:11.5px;margin-bottom:12px;'
        +'color:'+(window._concGuardadaInfo.cuadra?'#166534':'#7C3D12')+'">'
        +'<i class="ti '+(window._concGuardadaInfo.cuadra?'ti-circle-check':'ti-alert-triangle')+'"></i> '
        +'Este mes ya está conciliado'
        +(window._concGuardadaInfo.por?(' por '+_esc(window._concGuardadaInfo.por)):'')
        +(window._concGuardadaInfo.cuando?(' el '+String(window._concGuardadaInfo.cuando).slice(0,10)):'')
        +' · '+(window._concGuardadaInfo.cuadra?'cuadró':'quedó con diferencia de '
              +_concFmt2(window._concGuardadaInfo.diferencia))
        +'. Volvé a conciliar para verlo en detalle, o '
        +'<a href="#" onclick="_concBorrarConciliacion();return false" '
        +'style="color:var(--text-danger)">borralo</a>.</div>')
     : '')
   +'<div id="conc-res">'+(st.res?_concResultadoHTML(st.res):'')+'</div>';

  box.innerHTML=h;
}

// El estado del libro mayor: viene de SAP, no se sube. Se comprueba que ese
// mes esté sincronizado antes de conciliar, para no descubrirlo a mitad.
// La caja del extracto: el recién subido, o el que ya estaba archivado
function _concCajaExtracto(st){
  var base='flex:1;min-width:250px;border-radius:10px;padding:12px;';
  var h='<div style="'+base+'border:1px dashed var(--border);background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-azul);margin-bottom:7px">'
    +'<i class="ti ti-building-bank"></i> Extracto del banco</div>';

  if(st.extracto){                       // recién elegido en esta sesión
    h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px">'
      +'<i class="ti ti-file-check" style="color:var(--text-success);font-size:16px"></i>'
      +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'
        +_esc(st.extracto.name)+'</span>'
      +'<button onclick="_concQuitar(\'extracto\')" style="background:none;border:0;'
        +'color:var(--text-muted);cursor:pointer;font-size:15px">&times;</button></div>';
  } else if(st.extractoGuardado){        // ya archivado en un mes anterior
    var g=st.extractoGuardado;
    h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px">'
      +'<i class="ti ti-file-check" style="color:var(--text-success);font-size:16px"></i>'
      +'<a href="'+_esc(_concUrlExtracto(g))+'" target="_blank" rel="noopener" '
        +'style="flex:1;color:var(--text-accent);text-decoration:none;overflow:hidden;'
        +'text-overflow:ellipsis;white-space:nowrap">'+_esc(g.nombre_archivo||'extracto')+'</a>'
      +'</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">'
      +'Archivado'+(g.subido_por?(' por '+_esc(g.subido_por)):'')
      +(g.subido_en?(' el '+String(g.subido_en).slice(0,10)):'')+'</div>'
      +'<div style="display:flex;gap:10px;align-items:center;margin-top:5px">'
      +'<label style="cursor:pointer;font-size:10.5px;color:var(--text-accent)">'
        +'<i class="ti ti-refresh"></i> Reemplazar'
        +'<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" '
        +'onchange="_concArchivo(\'extracto\',this)"></label>'
      +'<button onclick="_concBorrarExtracto()" style="background:none;border:0;padding:0;'
        +'cursor:pointer;font-size:10.5px;color:var(--text-danger)">'
        +'<i class="ti ti-trash"></i> Borrar</button>'
      +'</div>';
  } else {
    h+='<label style="cursor:pointer;font-size:11.5px;color:var(--text-accent)">'
      +'<i class="ti ti-upload"></i> Subir el extracto del mes'
      +'<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" '
      +'onchange="_concArchivo(\'extracto\',this)"></label>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:5px">'
      +'Queda archivado por cuenta y mes.</div>';
  }
  return h+'</div>';
}

// El PDF de la conciliación guardada de ese mes, junto al extracto
function _concCajaConciliacion(st){
  var g=window._concGuardadaInfo;
  if(!g || !g.pdf_ruta) return '';
  var url=DOCS_BASE+String(g.pdf_ruta).split('/').map(encodeURIComponent).join('/');
  return '<div style="margin-top:10px;border-radius:10px;padding:12px;'
    +'border:1px solid '+(g.cuadra?'#16a34a':'#E9C08A')+';'
    +'background:'+(g.cuadra?'#dcfce7':'#FEF9F3')+'">'
    +'<div style="font-size:11.5px;font-weight:700;color:'+(g.cuadra?'#166534':'#7C3D12')
      +';margin-bottom:7px"><i class="ti ti-file-check"></i> Conciliación guardada</div>'
    +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;font-size:11.5px">'
      +'<i class="ti ti-file-type-pdf" style="font-size:17px;color:var(--text-accent)"></i>'
      +'<span style="flex:1;min-width:160px;overflow:hidden;text-overflow:ellipsis;'
        +'white-space:nowrap">'+_esc(g.pdf_nombre||'conciliación.pdf')+'</span>'
      +'<a href="'+_esc(url)+'" target="_blank" rel="noopener" '
        +'style="color:var(--text-accent);text-decoration:none;border:0.5px solid var(--border);'
        +'border-radius:7px;padding:4px 10px;background:var(--surface-0)">'
        +'<i class="ti ti-eye"></i> Ver</a>'
      +'<a href="'+_esc(url)+'" download="'+_esc(g.pdf_nombre||'conciliacion.pdf')+'" '
        +'style="color:var(--text-accent);text-decoration:none;border:0.5px solid var(--border);'
        +'border-radius:7px;padding:4px 10px;background:var(--surface-0)">'
        +'<i class="ti ti-download"></i> Bajar</a>'
      +'<button onclick="_concBorrarConciliacion()" style="background:none;border:0;'
        +'cursor:pointer;font-size:11.5px;color:var(--text-danger)">'
        +'<i class="ti ti-trash"></i> Borrar</button>'
    +'</div>'
    +(g.comentarios?('<div style="font-size:11px;color:var(--text-secondary);margin-top:7px;'
      +'white-space:pre-wrap">'+_esc(g.comentarios)+'</div>'):'')
    +'</div>';
}

function _concUrlExtracto(g){
  if(!g) return '';
  if(/^https?:/i.test(g.ruta||'')) return g.ruta;
  return DOCS_BASE+String(g.ruta||'').split('/').map(encodeURIComponent).join('/');
}

function _concLibroEstadoHTML(){
  var e=window._concLibroInfo;
  var base='flex:1;min-width:250px;border-radius:10px;padding:12px;';
  if(!e) return '<div style="'+base+'border:1px solid var(--border);background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-vino);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Comprobando…</div></div>';

  if(e.hay) return '<div style="'+base+'border:1px solid #16a34a;background:var(--pastel-ok)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
    +e.n+' asiento(s) sincronizados · saldo final '+_concFmt(e.saldo)+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-verde);opacity:.8;margin-top:3px">'
    +'No hay que subir nada: lo trae el worker desde SAP.</div>'
    // El libro mayor se sincroniza UNA VEZ POR HORA. Si contabilidad asienta
    // algo y concilia enseguida, esos asientos aún no están y el saldo no
    // cuadra con SAP. Antes no había forma de saberlo: decía "sincronizados"
    // y punto.
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-top:6px;'
    +'padding-top:6px;border-top:0.5px dashed var(--border)">'
    +'<i class="ti ti-clock"></i> Se actualiza una vez por hora. Si acabas de '
    +'asentar algo en SAP, puede que todavía no esté aquí: '
    +'<b>compara el saldo final con el de SAP</b> antes de dar el mes por '
    +'cuadrado.</div></div>';

  // Sincronizado pero sin movimientos: la cuenta no se movió ese mes. No es
  // un fallo y no hay nada que esperar.
  if(e.sincronizado) return '<div style="'+base+'border:1px solid var(--border);background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-vino);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-secondary)"><i class="ti ti-circle-minus"></i> '
    +'Sin movimientos en SAP este mes.</div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">'
    +'La cuenta no tuvo asientos'
    +(e.otrasCuentas?' este mes, aunque otras cuentas sí':'')
    +'. Si el extracto del banco tampoco trae nada, '
    +'el mes cuadra sin más. Si el banco SÍ trae movimientos, falta '
    +'asentarlos en SAP.</div></div>';

  // Ni asientos ni rastro del worker: aún no lo ha traído
  return '<div style="'+base+'border:1px solid #E9C08A;background:var(--pastel-aviso)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--t-marron)"><i class="ti ti-alert-circle"></i> '
    +'Ese mes todavía no está sincronizado.</div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-top:3px">'
    +'El worker lo trae una vez por hora. Si no aparece, revisa que esté corriendo.'
    +(e.ultimo?(' Lo último que trajo de esta cuenta es '+_esc(e.ultimo)+'.'):'')
    +'</div></div>';
}

function _concFmt(v){
  return '$'+Number(v||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}

// Comprueba en Supabase si el mes elegido ya está
async function _concRevisarLibro(){
  var st=window._concEstado; if(!st) return;
  window._concLibroInfo=null;
  var el=document.getElementById('conc-libro');
  if(el) el.innerHTML=_concLibroEstadoHTML();
  var cta=st.cuenta;      // ya es el código de la cuenta
  // "Sin asientos" puede significar dos cosas muy distintas: que el worker
  // todavía no trajo ese mes, o que la cuenta no tuvo movimientos. Se
  // distinguen mirando si el worker ya pasó por ahí.
  var info={hay:false, n:0, saldo:0, sincronizado:false};
  try{
    var r=await fetch(SB+'/rest/v1/libro_mayor?select=clave&cuenta=eq.'+encodeURIComponent(cta)
      +'&anio=eq.'+st.anio+'&mes=eq.'+(st.mes+1)+'&limit=1000',{headers:SBH});
    if(r.ok) info.n=(await r.json()||[]).length;

    // La fila de saldos existe en cuanto el worker procesa el mes, tenga
    // movimientos o no. Es la prueba de que sí se sincronizó.
    var rs=await fetch(SB+'/rest/v1/libro_mayor_saldos?select=saldo_final,saldo_inicial&cuenta=eq.'
      +encodeURIComponent(cta)+'&anio=eq.'+st.anio+'&mes=eq.'+(st.mes+1)+'&limit=1',{headers:SBH});
    if(rs.ok){
      var d=(await rs.json()||[])[0];
      if(d){ info.saldo=Number(d.saldo_final)||0; info.sincronizado=true; }
    }
    info.hay=info.n>0;

    // Y si tampoco hay saldo guardado: si el worker ya trajo meses
    // POSTERIORES de esta cuenta, es que pasó por aquí y no había nada.
    if(!info.hay && !info.sincronizado){
      var rp=await fetch(SB+'/rest/v1/libro_mayor?select=anio,mes&cuenta=eq.'
        +encodeURIComponent(cta)+'&order=anio.desc,mes.desc&limit=1',{headers:SBH});
      if(rp.ok){
        var u=(await rp.json()||[])[0];
        if(u){
          var pedido=st.anio*12+(st.mes+1);
          var ultimo=Number(u.anio)*12+Number(u.mes);
          if(ultimo>pedido) info.sincronizado=true;
          info.ultimo=String(u.anio)+'-'+String(u.mes).padStart(2,'0');
        }
      }

      // Y si esta cuenta no tiene meses posteriores —porque lleva tiempo
      // parada— se mira si el worker trajo ese mes para CUALQUIER OTRA
      // cuenta de banco. La consulta las trae todas de una vez, así que si
      // hay asientos de agosto en otra cuenta, agosto está sincronizado y
      // esta simplemente no se movió.
      //
      // Sin esto, una cuenta sin movimiento en el último mes salía siempre
      // como "todavía no sincronizado" y no dejaba conciliar.
      if(!info.sincronizado){
        try{
          var ro=await fetch(SB+'/rest/v1/libro_mayor?select=cuenta'
            +'&anio=eq.'+st.anio+'&mes=eq.'+(st.mes+1)+'&limit=1',{headers:SBH});
          if(ro.ok && (await ro.json()||[]).length){
            info.sincronizado=true;
            info.otrasCuentas=true;
          }
        }catch(e){}
      }
    }
  }catch(e){ console.warn('[conciliación] revisar libro:', e); }
  window._concLibroInfo=info;
  var el2=document.getElementById('conc-libro');
  if(el2) el2.innerHTML=_concLibroEstadoHTML();
}

function _concCaja(cual, titulo, icono, color, arch, nota){
  return '<div style="flex:1;min-width:250px;border:1px dashed var(--border);border-radius:10px;'
    +'padding:12px;background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:'+color+';margin-bottom:7px">'
      +'<i class="ti '+icono+'"></i> '+titulo+'</div>'
    +(nota&&!arch?('<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'+nota+'</div>'):'')
    +(arch
      ? ('<div style="display:flex;align-items:center;gap:7px;font-size:11.5px">'
         +'<i class="ti ti-file-check" style="color:var(--text-success);font-size:16px"></i>'
         +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(arch.name)+'</span>'
         +'<button onclick="_concQuitar(\''+cual+'\')" style="background:none;border:0;'
           +'color:var(--text-muted);cursor:pointer;font-size:15px">&times;</button></div>')
      : ('<label style="cursor:pointer;font-size:11.5px;color:var(--text-accent)">'
         +'<i class="ti ti-upload"></i> Subir archivo'
         +'<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" '
         +'onchange="_concArchivo(\''+cual+'\',this)"></label>'))
    +'</div>';
}

function _concSet(campo, valor){
  var st=window._concEstado;
  st[campo]=(campo==='mes'||campo==='anio')?Number(valor):valor;
  st.extracto=null; st.res=null;      // cambió el periodo: se empieza de nuevo
  window._concGuardadaInfo=null;
  try{ _concRevisarLibro(); }catch(e){}
  try{ _concBuscarExtracto(); }catch(e){}
  try{ _concBuscarConciliacion(); }catch(e){}
}
function _concArchivo(cual, input){
  var f=input.files&&input.files[0]; if(!f) return;
  window._concEstado[cual]=f;
  rConcil();
  // El extracto se guarda apenas se sube: es el documento que llega de
  // afuera y hay que poder consultarlo meses después.
  if(cual==='extracto') _concGuardarExtracto(f);
}

// Guarda el extracto del mes en el almacenamiento y lo registra
async function _concGuardarExtracto(file){
  var st=window._concEstado;
  var cta=st.cuenta;
  var ref=_concRefExtracto(st.cuenta, st.mes, st.anio);
  showT('Archivando el extracto…');
  try{
    var path=await _subirDocStorage(ref, 'extracto', file);
    if(!path){ showT('No se pudo archivar el extracto'); return; }
    try{ await _registrarDoc(ref, 'extracto', file, path); }catch(e){}
    var fila={
      clave: ref,
      cuenta: cta,
      cuenta_nombre: (window._concCtaNombre&&window._concCtaNombre[st.cuenta])||st.cuenta,
      anio: st.anio, mes: st.mes+1,
      nombre_archivo: file.name,
      ruta: path,
      subido_por: (CU&&CU.name)||'',
      subido_en: new Date().toISOString()
    };
    var r=await fetch(SB+'/rest/v1/extractos_bancarios?on_conflict=clave',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      console.warn('[conciliación] guardar extracto:', t);
      showT('El extracto se subió pero no se registró (¿falta la tabla extractos_bancarios?)', 7000);
      return;
    }
    st.extractoGuardado=fila;
    showT('✓ Extracto de '+MESES_ES[st.mes]+' '+st.anio+' archivado');
    rConcil();
  }catch(e){ console.warn('[conciliación] extracto:', e); }
}

function _concRefExtracto(cuenta, mes, anio){
  return 'EXT-'+anio+String(mes+1).padStart(2,'0')+'-'
    +String(cuenta).replace(/[^A-Za-z0-9]+/g,'').slice(0,16).toUpperCase();
}

// El extracto que ya esté archivado para esa cuenta y mes
// La conciliación que ya se haya guardado de ese mes
// ── Los documentos de referencia de la conciliación ──
// Se archivan igual que el extracto y se vuelven a mostrar cada vez que se
// consulta ese mes y esa cuenta.
function _concOtrosAdjuntos(){
  var docs=(window._concOtrosDocs||[]);
  var lista = docs.length
    ? docs.map(function(d,i){
        return '<span style="display:inline-flex;align-items:center;gap:5px;'
          +'background:var(--surface-2);border:0.5px solid var(--border);border-radius:8px;'
          +'padding:3px 9px;font-size:11px;margin:3px 5px 0 0">'
          +'<a href="'+_esc(DOCS_BASE+String(d.ruta||'').split("/").map(encodeURIComponent).join("/"))+'" '
          +'target="_blank" style="color:var(--t-azul);text-decoration:none">'
          +'<i class="ti ti-file"></i> '+_esc(d.nombre_archivo||'documento')+'</a>'
          +'<i class="ti ti-x" title="Quitar" style="cursor:pointer;color:var(--text-muted)" '
          +'onclick="_concOtrosQuitar('+i+')"></i></span>';
      }).join('')
    : '<span style="font-size:10.5px;color:var(--text-muted)">Sin documentos adjuntos.</span>';

  return '<div style="margin-top:8px">'+lista+'</div>'
    +'<button class="btn bg2" style="font-size:11px;padding:4px 10px;margin-top:7px" '
    +'onclick="_concOtrosSubir()"><i class="ti ti-upload"></i> Adjuntar documento</button>';
}

function _concOtrosSubir(){
  var st=window._concEstado; if(!st) return;
  var inp=document.createElement('input');
  inp.type='file'; inp.multiple=true;
  inp.accept='.pdf,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.doc,.docx';
  inp.onchange=async function(){
    var files=Array.prototype.slice.call(inp.files||[]);
    if(!files.length) return;
    var ref=_concRefConc(st.cuenta, st.mes, st.anio);
    showT('Archivando '+files.length+' documento(s)…');
    window._concOtrosDocs=window._concOtrosDocs||[];
    for(var i=0;i<files.length;i++){
      try{
        var path=await _subirDocStorage(ref, 'otros', files[i]);
        if(!path){ showT('No se pudo archivar '+files[i].name); continue; }
        try{ await _registrarDoc(ref, 'otros', files[i], path); }catch(e){}
        window._concOtrosDocs.push({nombre_archivo:files[i].name, ruta:path,
          subido_por:(CU&&CU.name)||'', subido_en:new Date().toISOString()});
      }catch(e){ console.warn('[conciliación] adjuntar:', e); }
    }
    showT('✓ '+window._concOtrosDocs.length+' documento(s) adjuntos');
    // Se guardan de inmediato: si no, se pierden al cerrar la pantalla
    try{ await _concGuardarOtros(); }catch(e){}
    try{ rConcil(); }catch(e){}
  };
  inp.click();
}

function _concOtrosQuitar(i){
  var docs=window._concOtrosDocs||[];
  if(!docs[i]) return;
  if(!confirm('¿Quitar "'+(docs[i].nombre_archivo||'')+'" de esta conciliación?')) return;
  docs.splice(i,1);
  _concGuardarOtros().catch(function(){});
  try{ rConcil(); }catch(e){}
}

// Guarda el texto y la lista de documentos en la fila de la conciliación
async function _concGuardarOtros(){
  var st=window._concEstado; if(!st) return false;
  var ref=_concRefConc(st.cuenta, st.mes, st.anio);
  var txt='';
  try{ txt=(document.getElementById('conc-otros')||{}).value||''; }catch(e){}
  var fila={
    referencia: ref,
    cuenta: st.cuenta,
    anio: st.anio, mes: st.mes+1,
    otros_detalles: txt,
    otros_docs: JSON.stringify(window._concOtrosDocs||[])
  };
  try{
    var r=await fetch(SB+'/rest/v1/conciliaciones?on_conflict=referencia',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      console.warn('[conciliación] guardar otros detalles:', t.slice(0,200));
      showT('No se pudo guardar. ¿Faltan las columnas otros_detalles y otros_docs?', 7000);
      return false;
    }
    if(st.res){ st.res.otros_detalles=txt; }
    return true;
  }catch(e){
    console.warn('[conciliación] otros detalles:', e);
    return false;
  }
}

async function _concBuscarConciliacion(){
  var st=window._concEstado; if(!st) return;
  try{
    var r=await fetch(SB+'/rest/v1/conciliaciones?select=*&referencia=eq.'
      +encodeURIComponent(_concRefConc(st.cuenta, st.mes, st.anio))+'&limit=1',{headers:SBH});
    if(!r.ok) return;
    var g=(await r.json()||[])[0];
    if(!g) return;
    window._concGuardadaInfo={
      referencia:g.referencia, saldo_banco:g.saldo_banco, saldo_libro:g.saldo_libro,
      diferencia:g.diferencia, cuadra:g.cuadra, por:g.hecha_por, cuando:g.creado_en,
      comentarios:g.comentarios||'', pdf_nombre:g.pdf_nombre||'', pdf_ruta:g.pdf_ruta||'',
      otros_detalles:g.otros_detalles||''
    };
    // Los documentos de referencia de ese mes, para volver a mostrarlos
    try{
      window._concOtrosDocs = g.otros_docs
        ? (typeof g.otros_docs==='string' ? JSON.parse(g.otros_docs) : g.otros_docs)
        : [];
    }catch(e){ window._concOtrosDocs=[]; }
    if(st.res){ st.res.otros_detalles=g.otros_detalles||''; }
    try{ rConcil(); }catch(e){}
  }catch(e){ console.warn('[conciliación] buscar guardada:', e); }
}

async function _concBuscarExtracto(){
  var st=window._concEstado; if(!st) return;
  st.extractoGuardado=null;
  try{
    var r=await fetch(SB+'/rest/v1/extractos_bancarios?select=*&clave=eq.'
      +encodeURIComponent(_concRefExtracto(st.cuenta, st.mes, st.anio))+'&limit=1',{headers:SBH});
    if(r.ok){ st.extractoGuardado=(await r.json()||[])[0]||null; }
  }catch(e){ console.warn('[conciliación] buscar extracto:', e); }
  try{ rConcil(); }catch(e){}
}
function _concQuitar(cual){ window._concEstado[cual]=null; rConcil(); }

// ── El libro mayor, directo de SAP ────────────────────────────────────
// Lo sincroniza el worker (sync_libro_mayor) a la tabla libro_mayor. Así
// contabilidad solo sube el extracto del banco, que es lo único que viene
// de afuera. Si no hay datos, la pantalla deja subir el PDF como antes.
// El último saldo conocido de la cuenta ANTES del mes pedido. Cuando un mes
// no tiene movimientos, su saldo es el que traía: darlo por cero hace que la
// conciliación nunca cuadre.
async function _concSaldoArrastrado(cuenta, mes, anio){
  var pedido=anio*12+(mes+1);
  try{
    var r=await fetch(SB+'/rest/v1/libro_mayor_saldos?select=anio,mes,saldo_final'
      +'&cuenta=eq.'+encodeURIComponent(cuenta)
      +'&order=anio.desc,mes.desc&limit=60',{headers:SBH});
    if(r.ok){
      var f=await r.json()||[];
      for(var i=0;i<f.length;i++){
        if((Number(f[i].anio)*12+Number(f[i].mes)) < pedido){
          var de=String(f[i].anio)+'-'+String(f[i].mes).padStart(2,'0');
          console.log('[conciliación] '+cuenta+' sin movimientos: se arrastra el saldo de '
            +de+' ('+(Number(f[i].saldo_final)||0)+')');
          return {saldo:Number(f[i].saldo_final)||0, de:de};
        }
      }
    }
  }catch(e){ console.warn('[conciliación] saldo arrastrado:', e); }
  console.warn('[conciliación] '+cuenta+': no hay ningún saldo anterior guardado, '
    +'se toma 0. Si el banco trae saldo, la diferencia será ese importe.');
  return {saldo:0, de:null};
}

async function _concLibroDeSAP(cuenta, mes, anio){
  var m1=String(anio)+'-'+String(mes+1).padStart(2,'0')+'-01';
  var r=await fetch(SB+'/rest/v1/libro_mayor?select=fecha,detalle,ref1,contra_nombre,cardname,monto'
    +'&cuenta=eq.'+encodeURIComponent(cuenta)
    +'&anio=eq.'+anio+'&mes=eq.'+(mes+1)
    +'&order=fecha.asc&limit=5000',{headers:SBH});
  if(!r.ok) throw new Error('No se pudo leer el libro mayor ('+r.status+')');
  var filas=await r.json()||[];

  var rs=await fetch(SB+'/rest/v1/libro_mayor_saldos?select=saldo_inicial,saldo_final'
    +'&cuenta=eq.'+encodeURIComponent(cuenta)
    +'&anio=eq.'+anio+'&mes=eq.'+(mes+1)+'&limit=1',{headers:SBH});
  var sal=rs.ok?(await rs.json()||[])[0]:null;

  // Sin filas y sin saldo hay dos posibilidades: que el worker no haya
  // traído el mes, o que la cuenta no se moviera. Si ya trajo meses
  // POSTERIORES de esta cuenta, es lo segundo: se concilia con un libro
  // vacío, que es lo correcto.
  if(!filas.length && !sal){
    var vacio=false;
    try{
      var rp=await fetch(SB+'/rest/v1/libro_mayor?select=anio,mes&cuenta=eq.'
        +encodeURIComponent(cuenta)+'&order=anio.desc,mes.desc&limit=1',{headers:SBH});
      if(rp.ok){
        var u=(await rp.json()||[])[0];
        if(u && (Number(u.anio)*12+Number(u.mes)) > (anio*12+(mes+1))) vacio=true;
      }
    }catch(e){}

    // Si esta cuenta no tiene meses posteriores —porque lleva tiempo
    // parada, como Banco León— se mira si el worker trajo ese mes para
    // CUALQUIER otra cuenta de banco. Las trae todas de una vez, así que
    // si hay asientos de agosto en otra cuenta, agosto está sincronizado
    // y esta simplemente no se movió.
    //
    // Sin esto, una cuenta sin movimiento en el último mes no dejaba
    // conciliar: decía que el worker no había traído el mes.
    if(!vacio){
      try{
        var ro=await fetch(SB+'/rest/v1/libro_mayor?select=cuenta'
          +'&anio=eq.'+anio+'&mes=eq.'+(mes+1)+'&limit=1',{headers:SBH});
        if(ro.ok && (await ro.json()||[]).length) vacio=true;
      }catch(e){}
    }
    if(!vacio) return null;                  // ese mes no está sincronizado
    // Sin movimientos, el saldo no es cero: es el que venía arrastrando.
    // Se busca el último saldo conocido ANTES de este mes; si no se hace,
    // el libro sale en 0 y la conciliación no cuadra nunca.
    var arr=await _concSaldoArrastrado(cuenta, mes, anio);
    return {origen:'SAP', saldo_inicial:arr.saldo, saldo_final:arr.saldo,
            movimientos:[], sinMovimientos:true, saldoDe:arr.de};
  }
  // Con saldo guardado pero sin asientos: el mes está, la cuenta no se movió
  if(!filas.length && sal){
    var si=Number(sal.saldo_inicial)||0, sf=Number(sal.saldo_final)||0;
    if(!si && !sf){
      var arr2=await _concSaldoArrastrado(cuenta, mes, anio);
      si=sf=arr2.saldo;
      return {origen:'SAP', saldo_inicial:si, saldo_final:sf,
              movimientos:[], sinMovimientos:true, saldoDe:arr2.de};
    }
    return {origen:'SAP', saldo_inicial:si, saldo_final:sf,
            movimientos:[], sinMovimientos:true};
  }

  return {
    origen:'SAP',
    saldo_inicial:Number(sal&&sal.saldo_inicial)||0,
    saldo_final:Number(sal&&sal.saldo_final)||0,
    movimientos:filas.map(function(x){
      return {fecha:String(x.fecha||''),
              detalle:String(x.detalle||x.contra_nombre||x.cardname||''),
              ref:String(x.ref1||''),
              monto:Number(x.monto)||0};
    }).filter(function(m){ return m.monto!==0; })
  };
}

// Las cuentas de banco, tal como están en el plan de cuentas de SAP
async function _concCargarCuentas(){
  window._concCtasError='';
  // 1) La lista que arma el worker
  try{
    var r=await fetch(SB+'/rest/v1/cuentas_bancos?select=cuenta,nombre,moneda'
      +'&order=cuenta.asc&limit=200',{headers:SBH});
    if(r.ok){
      var filas=await r.json()||[];
      if(filas.length){
        window._concCuentasSAP=filas.map(function(x){
          return {n:(x.nombre||x.cuenta), c:x.cuenta, moneda:x.moneda||''};
        });
        return;
      }
      window._concCtasError='La tabla cuentas_bancos está vacía';
    } else {
      var t=''; try{ t=await r.text(); }catch(e){}
      window._concCtasError='cuentas_bancos: HTTP '+r.status+' '+String(t).slice(0,120);
    }
  }catch(e){ window._concCtasError='cuentas_bancos: '+(e.message||e); }

  // 2) Si esa tabla no está, se deducen del propio libro mayor, que es donde
  //    de verdad hacen falta. Así la pantalla funciona aunque el worker no
  //    haya llegado a escribir la lista de cuentas.
  try{
    var r2=await fetch(SB+'/rest/v1/libro_mayor?select=cuenta,cuenta_nombre'
      +'&order=cuenta.asc&limit=2000',{headers:SBH});
    if(!r2.ok){
      var t2=''; try{ t2=await r2.text(); }catch(e){}
      window._concCtasError+=' · libro_mayor: HTTP '+r2.status+' '+String(t2).slice(0,120);
      return;
    }
    var vistos={}, out=[];
    (await r2.json()||[]).forEach(function(x){
      var c=String(x.cuenta||'').trim(); if(!c || vistos[c]) return;
      vistos[c]=1; out.push({n:(x.cuenta_nombre||c), c:c});
    });
    if(out.length){ window._concCuentasSAP=out; window._concCtasError=''; }
  }catch(e){ window._concCtasError+=' · libro_mayor: '+(e.message||e); }
}

// ── Leer un documento con la IA ───────────────────────────────────────
// ── Leer un documento con la IA, por tandas ───────────────────────────
// Un extracto de un mes movido puede tener 300 líneas, y la respuesta de la
// IA se corta antes de terminarlas (así se perdió todo lo posterior al 6 de
// febrero). Por eso se pide en tandas: cada llamada devuelve un tramo, y se
// le dice desde dónde seguir. Cada respuesta es corta y no se trunca.
var CONC_TANDA = 45;          // movimientos por llamada
var CONC_MAX_VUELTAS = 40;    // tope de seguridad: hasta 1.800 movimientos

async function _concPreparar(file){
  var prep=await _iaDesdeBlob(file, file.name);
  if(!prep || !prep.bloques || !prep.bloques.length)
    throw new Error('No se pudo leer '+file.name);
  // Si el archivo no se pudo interpretar, se dice AQUÍ y con claridad. Antes
  // se mandaba igual a la IA y el fallo aparecía después, disfrazado de
  // error de JSON con caracteres raros.
  if(prep.nota){
    throw new Error('No se pudo leer "'+file.name+'". '
      +'El extracto tiene que ser PDF, Excel (.xlsx/.xls) o CSV. '
      +'Si es un Excel antiguo o está protegido, ábrelo y vuelve a guardarlo '
      +'como .xlsx.');
  }
  // Un PDF muy pesado no lo admite la IA y el fallo aparece después,
  // disfrazado. Mejor decirlo aquí.
  try{
    var mb=(file.size||0)/1024/1024;
    console.log('[conciliación] leyendo '+file.name+' · '+mb.toFixed(1)+' MB · '
      +(file.type||'sin tipo'));
    if(mb>28){
      throw new Error('"'+file.name+'" pesa '+mb.toFixed(1)+' MB y no se puede '
        +'procesar entero. Súbelo en Excel o CSV, o divide el PDF por quincenas.');
    }
  }catch(e){ if(e && e.message && e.message.indexOf('pesa')>=0) throw e; }
  return (prep.bloques.length===1)?prep.bloques[0]:prep.bloques;
}

async function _concLeerTanda(contenido, cual, cuenta, mes, anio, desde, nombre){
  var comun=''
    +'Devolve SOLO un JSON valido, sin explicaciones ni markdown, con esta forma:\n'
    +'{"saldo_inicial":0,"saldo_final":0,"fin":false,"movimientos":[{"fecha":"AAAA-MM-DD",'
    +'"detalle":"...","referencia":"...","debito":0,"credito":0,"saldo":0}]}\n\n'
    +'NO interpretes ni calcules nada: copia los numeros tal como estan en el documento.\n'
    +'  debito  = lo que figura en la columna de debito (0 si esa fila no tiene).\n'
    +'  credito = lo que figura en la columna de credito (0 si esa fila no tiene).\n'
    +'  saldo   = el saldo que muestra ESA fila (0 si el documento no lo trae).\n'
    +'Manten las filas EN EL MISMO ORDEN en que aparecen en el documento.\n\n'
    +'IMPORTANTE - LEES POR TANDAS:\n'
    +'Devolve como maximo '+CONC_TANDA+' movimientos en esta respuesta.\n'
    +(desde
      ? ('Ya se leyeron los movimientos hasta este, INCLUIDO:\n'
         +'   fecha "'+desde.fecha+'", detalle "'+String(desde.detalle||'').slice(0,70)+'"'
         +(desde.saldo!=null?(', saldo '+desde.saldo):'')+'\n'
         +'Empeza EXACTAMENTE en el siguiente y no repitas ninguno anterior.\n'
         +'saldo_inicial y saldo_final pueden ir en 0 en esta tanda.\n')
      : 'Empeza por el PRIMER movimiento del documento.\n')
    +'Poné "fin":true solo si con esta tanda llegaste al ULTIMO movimiento del documento.\n\n'
    +'No inventes movimientos ni montos. Incluye TODOS los del tramo, tambien los\n'
    +'cargos chicos del banco (comisiones, timbres, IVA, ITBMS, anualidades).\n';

  var especifico = (cual==='extracto')
    ? ('Es un EXTRACTO BANCARIO de la cuenta '+cuenta+'.\n')
    : ('Es un LIBRO MAYOR de SAP Business One de la cuenta bancaria '+cuenta+'.\n'
       +'saldo_inicial es el "Periodic Opening Balance" y saldo_final el '
       +'"Periodic Closing Balance".\n');

  var prompt=especifico+'Periodo: '+MESES_ES[mes]+' '+anio+'.\n\n'+comun;

  var resp=await fetch('https://api.anthropic.com/v1/messages',{
    method:'POST',
    headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,
             'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
    body:JSON.stringify({model:IA_MODELO, max_tokens:8000,
      messages:[{role:'user', content:[contenido, {type:'text', text:prompt}]}]})
  });
  // Se lee como TEXTO y luego se interpreta. Al revés no funciona: json()
  // consume el cuerpo, y si falla, el text() posterior devuelve vacío y no
  // hay forma de ver qué llegó. Por eso el aviso no decía nada útil.
  var data, crudoTxt='';
  try{
    crudoTxt=await resp.text();
    data=JSON.parse(crudoTxt);
  }catch(errJ){
    // Sin esto, una respuesta que no sea JSON hace saltar el error con los
    // bytes crudos dentro y en pantalla sale "Unexpected token '\uFFFD'".
    var crudo=crudoTxt;
    console.error('[IA] estado '+resp.status
      +' · tipo: '+((resp.headers&&resp.headers.get&&resp.headers.get('content-type'))||'?')
      +' · '+String(crudo||'').length+' caracteres recibidos');
    console.error('[IA] primeros 300: '
      +String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,300));
    console.error('[IA] error original: '+((errJ&&errJ.message)||errJ));
    throw new Error(
      resp.status===413 ? 'El documento es demasiado grande para la IA. '
                         +'Súbelo en Excel o CSV, o divídelo.'
    : resp.status===401 ? 'La clave de la IA no es válida o caducó.'
    : resp.status===429 ? 'La IA está saturada. Prueba dentro de un minuto.'
    : resp.status>=500  ? 'La IA no respondió bien (error '+resp.status+').'
    : (resp.status===200
        ? ('La IA respondió, pero el navegador no pudo leer la respuesta. '
           +'Suele ser una extensión del navegador o un antivirus que se '
           +'interponen. Prueba en una ventana de incógnito. En la consola '
           +'queda el detalle de lo que llegó.')
        : 'La IA devolvió una respuesta ilegible (estado '+resp.status+').'));
  }
  if(data.error) throw new Error(data.error.message||'Error de IA');
  var txt=(data.content||[]).map(function(c){ return c.text||''; }).join('').trim();
  txt=txt.replace(/```json|```/g,'').trim();
  var i=txt.indexOf('{');
  if(i<0) throw new Error('La IA no devolvió datos de '+nombre);
  return _concParsear(txt.slice(i), nombre);
}

async function _concLeer(file, cual, cuenta, mes, anio, aviso){
  // El extracto de Banistmo se lee directo del PDF, sin IA: trae el saldo en
  // cada fila, así que la lectura se puede comprobar contra el SALDO FINAL
  // impreso en vez de confiar en que la IA no se perdió. Devuelve null si el
  // archivo no es de Banistmo, y entonces sigue el camino de siempre.
  if(cual==='extracto'){
    var directo=await _concLeerBanistmo(file, mes, anio, aviso);
    if(directo) return directo;
  }
  var contenido=await _concPreparar(file);
  var todos=[], desde=null, ini=null, fin=null, cortado=false, vacias=0;

  for(var v=0; v<CONC_MAX_VUELTAS; v++){
    if(aviso) aviso(todos.length, cual);
    var o=await _concLeerTanda(contenido, cual, cuenta, mes, anio, desde, file.name);
    var ms=(o.movimientos||[]).map(function(m){
      var deb=Math.abs(Number(m.debito)||0), cre=Math.abs(Number(m.credito)||0);
      var monto=Number(m.monto);
      if(!isFinite(monto) || (deb||cre)) monto=cre-deb;
      return {fecha:String(m.fecha||''), detalle:String(m.detalle||''),
              ref:String(m.referencia||''), monto:monto||0,
              saldo:(m.saldo==null||m.saldo===''||m.saldo===0)?null:Number(m.saldo)};
    });

    if(v===0){
      if(isFinite(Number(o.saldo_inicial)) && Number(o.saldo_inicial)!==0) ini=Number(o.saldo_inicial);
    }
    if(isFinite(Number(o.saldo_final)) && Number(o.saldo_final)!==0) fin=Number(o.saldo_final);
    if(o.__cortado) cortado=true;

    // Se descartan los que ya estaban: si la IA repite, no se duplican
    var nuevos=ms.filter(function(m){
      return !todos.some(function(t){
        return t.fecha===m.fecha && t.detalle===m.detalle
            && Math.abs(t.monto-m.monto)<0.005
            && (t.saldo==null||m.saldo==null||Math.abs(t.saldo-m.saldo)<0.005);
      });
    });
    todos=todos.concat(nuevos);

    if(!nuevos.length){
      // Sin movimientos nuevos: puede ser el final o que repitió la tanda.
      // Se insiste dos veces antes de darlo por terminado.
      vacias++;
      if(vacias>=3) break;
      continue;
    }
    vacias=0;
    desde=todos[todos.length-1];

    // NO se corta por "fin":true ni porque la tanda venga corta. Esas dos
    // señales daban por terminado el extracto a mitad: primero en el día 6 y
    // después en el 26. La única parada fiable es dejar de encontrar
    // movimientos nuevos.
    // Con una excepción: si el saldo de la última fila leída coincide con el
    // saldo final del documento, se llegó de verdad al final.
    if(o.fin===true && fin!=null && desde && desde.saldo!=null
       && Math.abs(desde.saldo-fin)<0.02) break;
  }

  var o2={saldo_inicial:(ini==null?0:ini), saldo_final:(fin==null?0:fin),
          movimientos:todos.filter(function(m){ return m.monto!==0 || m.saldo!=null; })};
  if(cortado) o2.__cortado=true;

  // Comprobación de que se llegó al final: el saldo de la última fila leída
  // tiene que ser el saldo final del documento. Si no, faltan movimientos y
  // hay que decirlo: una conciliación sobre un extracto incompleto engaña.
  var ult=o2.movimientos[o2.movimientos.length-1];
  if(fin!=null && ult && ult.saldo!=null && Math.abs(ult.saldo-fin)>0.02){
    o2.__incompleto={leido:ult.saldo, esperado:fin, hasta:ult.fecha};
  }
  _concCorregirPorSaldo(o2);
  o2.movimientos=o2.movimientos.filter(function(m){ return m.monto!==0; });
  return o2;
}

// Lee el JSON de la IA aunque venga cortado. Con extractos largos la
// respuesta puede terminarse a mitad de un movimiento; en ese caso se
// recuperan los que estén completos en vez de perder todo el trabajo.
function _concParsear(txt, nombre){
  try{ return JSON.parse(txt); }catch(e){}

  // Cerrar por las bravas suele bastar cuando solo faltó el final
  var t=txt.replace(/,\s*$/,'');
  for(var cierre of ['}]}', ']}', '}}', '}']){
    try{ return JSON.parse(t+cierre); }catch(e){}
  }

  // Si no, se recortan los movimientos completos uno a uno
  var im=txt.indexOf('"movimientos"');
  var ia=(im>=0)?txt.indexOf('[', im):-1;
  if(ia>=0){
    var ultimo=-1, prof=0;
    for(var k=ia;k<txt.length;k++){
      var c=txt[k];
      if(c==='{') prof++;
      else if(c==='}'){ prof--; if(prof===0) ultimo=k; }
      else if(c===']' && prof===0) break;
    }
    if(ultimo>0){
      var cab=txt.slice(0, ia+1);
      var cuerpo=txt.slice(ia+1, ultimo+1);
      try{
        var o=JSON.parse(cab+cuerpo+']}');
        console.warn('[conciliación] la respuesta de '+nombre+' venía cortada: '
          +'se recuperaron '+(o.movimientos||[]).length+' movimientos');
        o.__cortado=true;
        return o;
      }catch(e){}
    }
  }
  throw new Error('La IA devolvió una respuesta cortada o mal formada para '+nombre
    +'. Probá de nuevo; si el extracto es muy largo, subilo en Excel o CSV.');
}

// ── El saldo manda ────────────────────────────────────────────────────
// Cada fila del extracto trae el saldo después del movimiento. La diferencia
// entre dos saldos consecutivos ES el movimiento, con su signo verdadero.
// Con eso se corrigen los débitos y créditos que la IA haya leído al revés
// (le pasó con ALMACEN RODRIGUEZ y las transferencias) y se deduce el saldo
// inicial aunque el documento no lo diga.
function _concCorregirPorSaldo(o){
  var ms=o.movimientos||[];
  var conSaldo=ms.filter(function(m){ return m.saldo!=null && isFinite(m.saldo); });
  if(conSaldo.length < 3) return;          // sin saldos no hay nada que comprobar

  // El documento puede venir del más nuevo al más viejo: se prueban los dos
  // sentidos y gana el que encadene mejor.
  function puntuar(arr){
    var ok=0;
    for(var i=1;i<arr.length;i++){
      if(arr[i].saldo==null || arr[i-1].saldo==null) continue;
      var d=arr[i].saldo-arr[i-1].saldo;
      if(Math.abs(Math.abs(d)-Math.abs(arr[i].monto))<0.02) ok++;
    }
    return ok;
  }
  var normal=ms.slice(), invertido=ms.slice().reverse();
  var usar=(puntuar(invertido) > puntuar(normal)) ? invertido : normal;
  if(puntuar(usar) < Math.floor((usar.length-1)*0.6)) return;   // no encadena: se deja como está

  var corregidos=0;
  for(var i=1;i<usar.length;i++){
    if(usar[i].saldo==null || usar[i-1].saldo==null) continue;
    var d=Math.round((usar[i].saldo-usar[i-1].saldo)*100)/100;
    if(Math.abs(Math.abs(d)-Math.abs(usar[i].monto))<0.02 && d!==usar[i].monto){
      usar[i].monto=d; corregidos++;
    }
  }

  // El saldo inicial sale de la primera fila: saldo mostrado menos su movimiento
  if(usar[0] && usar[0].saldo!=null){
    var ini=Math.round((usar[0].saldo-usar[0].monto)*100)/100;
    var declarado=Number(o.saldo_inicial);
    if(!isFinite(declarado) || Math.abs(declarado-ini)>0.02){
      // Si el declarado no encaja con la cadena, puede que la primera fila
      // tenga el signo cambiado: se prueba al revés.
      var alt=Math.round((usar[0].saldo+usar[0].monto)*100)/100;
      if(isFinite(declarado) && Math.abs(declarado-alt)<0.02){ usar[0].monto=-usar[0].monto; }
      else { o.saldo_inicial=ini; }
    }
  }
  // Y el final es el saldo de la última fila
  var ult=usar[usar.length-1];
  if(ult && ult.saldo!=null) o.saldo_final=ult.saldo;

  o.movimientos=usar;
  if(corregidos) console.info('[conciliación] '+corregidos
    +' movimiento(s) corregidos con el saldo del documento');
}

// ── El cruce ──────────────────────────────────────────────────────────
// Empareja por importe y signo. La fecha no tiene que coincidir, pero entre
// varios candidatos del mismo importe se elige el de fecha más cercana.
function _concCruzar(banco, libro){
  var B=(banco.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i,par:null}); });
  var L=(libro.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i,par:null}); });

  function dias(a,b){
    var x=Date.parse(a), y=Date.parse(b);
    if(isNaN(x)||isNaN(y)) return 999;
    return Math.abs(x-y)/86400000;
  }

  B.forEach(function(b){
    var mejor=null, mejorD=1e9;
    L.forEach(function(l){
      if(l.par!==null) return;
      if(Math.abs(l.monto-b.monto)>0.005) return;
      var d=dias(b.fecha,l.fecha);
      if(d<mejorD){ mejorD=d; mejor=l; }
    });
    if(mejor){ b.par=mejor; mejor.par=b; b.dist=mejorD; }
  });

  var conciliados=B.filter(function(x){ return x.par; });
  var soloBanco  =B.filter(function(x){ return !x.par; });
  var soloLibro  =L.filter(function(x){ return !x.par; });

  var sumB=function(a){ return a.reduce(function(s,x){ return s+x.monto; },0); };
  var difSaldos=(Number(banco.saldo_final)||0)-(Number(libro.saldo_final)||0);

  // ── Partidas que se compensan entre sí ──
  // Una corrección se registra en el libro con el signo contrario al del
  // banco: el banco carga -16.292 y el libro anota +16.292. El emparejado
  // normal exige el MISMO signo, así que las dejaba sueltas, y al restarlas
  // el importe se contaba dos veces (16.292 × 2 = 32.584 de descuadre
  // fantasma) aunque los dos saldos coincidieran.
  var compensadas=[];
  soloBanco.slice().forEach(function(mb){
    if(mb.__comp) return;
    var mismoImporte=soloLibro.filter(function(ml){
      return !ml.__comp
          && Math.abs(Math.abs(ml.monto)-Math.abs(mb.monto))<0.01
          && (ml.monto>0)!==(mb.monto>0);      // signo contrario
    });
    if(!mismoImporte.length) return;
    var ml=mismoImporte[0];
    mb.__comp=1; ml.__comp=1;
    compensadas.push({banco:mb, libro:ml, monto:Math.abs(mb.monto)});
  });

  var bancoLibre=soloBanco.filter(function(x){ return !x.__comp; });
  var libroLibre=soloLibro.filter(function(x){ return !x.__comp; });
  var netoSinConciliar=sumB(bancoLibre)-sumB(libroLibre);

  return {
    banco:banco, libro:libro,
    conciliados:conciliados, soloBanco:soloBanco, soloLibro:soloLibro,
    // Las que se compensan siguen listadas, pero no cuentan para el descuadre
    compensadas:compensadas,
    totalBanco:sumB(B), totalLibro:sumB(L),
    difSaldos:difSaldos, netoSinConciliar:netoSinConciliar,
    cuadra:Math.abs(difSaldos-netoSinConciliar)<0.01,
    descuadre:difSaldos-netoSinConciliar
  };
}

async function _concConciliar(){
  var st=window._concEstado;
  var fuente=st.extracto;
  if(!fuente && st.extractoGuardado){
    // Se recupera el archivado, para poder rehacer la conciliación de un mes
    try{
      var rr=await fetch(_concUrlExtracto(st.extractoGuardado));
      if(rr.ok){
        var bb=await rr.blob();
        // El nombre importa: por su extensión se decide cómo leerlo. Si se
        // usa 'extracto.pdf' por defecto y el archivo era un Excel, se manda
        // como PDF y la lectura falla con caracteres raros.
        var nom = st.extractoGuardado.nombre_archivo
               || String(st.extractoGuardado.ruta||'').split('/').pop()
               || 'extracto';
        if(!/\.[a-z0-9]{2,5}$/i.test(nom)){
          var t=(bb.type||'').toLowerCase();
          nom += /pdf/.test(t) ? '.pdf'
               : /sheet|excel/.test(t) ? '.xlsx'
               : /csv/.test(t) ? '.csv' : '.pdf';
        }
        fuente=new File([bb], nom, {type:bb.type});
        console.log('[conciliación] extracto recuperado: '+nom+' ('+(bb.type||'sin tipo')+')');
      }
    }catch(e){ console.warn('[conciliación] bajar extracto:', e); }
  }
  if(!fuente){ showT('Sube el extracto del banco de ese mes'); return; }
  st.extracto=fuente;
  var out=document.getElementById('conc-res');
  out.innerHTML='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:20px;text-align:center;font-size:12.5px;color:var(--text-muted)">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Leyendo los dos documentos…</div>';

  try{
    var banco=await _concLeer(st.extracto,'extracto',st.cuenta,st.mes,st.anio,
      function(n){
        out.innerHTML='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
          +'border-radius:var(--radius);padding:20px;text-align:center;font-size:12.5px;'
          +'color:var(--text-muted)"><span class="ai-ring g" style="vertical-align:-2px"></span> '
          +'Leyendo el extracto… '+(n?(n+' movimientos hasta ahora'):'')+'</div>';
      });
    out.innerHTML='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
      +'border-radius:var(--radius);padding:20px;text-align:center;font-size:12.5px;color:var(--text-muted)">'
      +'<span class="ai-ring g" style="vertical-align:-2px"></span> Extracto leído ('
      +banco.movimientos.length+' movimientos). Buscando el libro mayor…</div>';

    // Primero SAP: es el dato de origen y no hay que subir nada
    var libro=null;
    try{ libro=await _concLibroDeSAP(st.cuenta, st.mes, st.anio); }
    catch(e){ console.warn('[conciliación] libro de SAP:', e); }

    if(!libro) throw new Error('El libro mayor de '+st.cuenta+' para '
      +MESES_ES[st.mes]+' '+st.anio+' todavía no está en Supabase. '
      +'Lo trae el worker desde SAP una vez por hora: revisa que esté corriendo.');

    if(libro.sinMovimientos){
      showT('En SAP esta cuenta no tuvo movimientos en '+MESES_ES[st.mes]+' '+st.anio+'. '
        +(libro.saldoDe
           ? ('El saldo del libro se arrastra desde '+libro.saldoDe+': '+_concFmt2(libro.saldo_final)+'.')
           : (libro.saldo_final
              ? ''
              : 'No hay ningún saldo anterior guardado en SAP, así que el libro parte de cero: '
                +'si el banco trae saldo, esa será toda la diferencia.'))
        +' Lo que traiga el banco quedará como partida por registrar.', 12000);
    }

    if(banco.__incompleto){
      var inc=banco.__incompleto;
      showT('Ojo: el extracto quedó leído solo hasta el '+(inc.hasta||'?')
        +'. El saldo llega a '+_concFmt2(inc.leido)+' y el documento cierra en '
        +_concFmt2(inc.esperado)+': faltan movimientos.', 12000);
      // Y sobre todo: que quede EN el informe. El globo se va a los doce
      // segundos y el resultado falso se queda, impreso y compartido.
      window._concIncompleto=inc;
    } else if(banco.__cortado){
      showT('Ojo: la lectura del extracto quedó incompleta. '
        +'Revisa que estén todos los movimientos.', 9000);
    }
    var res=_concCruzar(banco, libro);
    res.cortado=!!banco.__cortado;
    res.incompleto=banco.__incompleto||null;
    res.cuenta=st.cuenta; res.mes=st.mes; res.anio=st.anio;
    res.fecha=new Date().toLocaleString('es');
    res.por=(CU&&CU.name)||'';
    st.res=res;
    out.innerHTML=_concResultadoHTML(res);
  }catch(e){
    console.warn('[conciliación]', e);
    out.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;'
      +'padding:12px;font-size:12px;color:var(--t-marron)"><i class="ti ti-alert-circle"></i> '
      +'No se pudo conciliar: '+_esc(e.message||e)+'</div>';
  }
}

// ── El resultado ──────────────────────────────────────────────────────
function _concResultadoHTML(r){
  var f=_concFmt2;
  var nom=(window._concCtaNombre&&window._concCtaNombre[r.cuenta])||r.cuenta;

  // Si el extracto se leyó a medias, eso va ARRIBA DE TODO y sin rodeos. Una
  // conciliación sobre un extracto incompleto no es una conciliación que no
  // cuadra: es una lectura que no terminó, y presentarla como lo primero
  // hace perder días persiguiendo diferencias que no existen.
  var aviso='';
  if(r.incompleto){
    aviso='<div style="background:var(--pastel-error);border:1px solid var(--t-rojo);'
      +'border-radius:var(--radius);padding:14px;margin-bottom:12px;color:var(--t-rojo)">'
      +'<div style="font-size:13.5px;font-weight:700">'
      +'<i class="ti ti-alert-triangle"></i> El extracto se leyó incompleto</div>'
      +'<div style="font-size:12px;margin-top:6px;line-height:1.5">'
      +'La lectura llegó hasta el '+_esc(r.incompleto.hasta||'?')+' con saldo '
      +f(r.incompleto.leido)+', y el documento cierra en '+f(r.incompleto.esperado)+'. '
      +'<b>Los totales de abajo no sirven</b>: el saldo del banco es de mitad de mes y '
      +'la diferencia que salga será, sobre todo, los movimientos que faltan por leer. '
      +'Vuelve a cargar el extracto antes de trabajar sobre este resultado.</div></div>';
  }

  var h=aviso+'<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:14px;margin-bottom:12px">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:8px">'
      +'<div><div style="font-size:13.5px;font-weight:700">'+_esc(nom)+' · '
        +MESES_ES[r.mes]+' '+r.anio+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">Conciliado el '
        +_esc(r.fecha||'')+(r.por?(' por '+_esc(r.por)):'')
        +(r.guardada?' · <span style="color:var(--text-success)">guardada</span>':'')+'</div></div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
        +'<button class="btn bg2" style="padding:5px 11px;font-size:11.5px" onclick="_concCopiar()">'
          +'<i class="ti ti-copy"></i> Copiar</button>'
        +'<button class="btn bp" style="padding:5px 11px;font-size:11.5px" onclick="_concGuardar()">'
          +'<i class="ti ti-device-floppy"></i> Guardar</button>'
        +(r.guardada?('<button class="btn bg2" style="padding:5px 11px;font-size:11.5px;'
          +'color:var(--text-danger)" onclick="_concBorrarConciliacion()">'
          +'<i class="ti ti-trash"></i> Borrar</button>'):'')
      +'</div></div>'

    + _concVeredictoHTML(r)

    +'<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(155px,1fr));gap:9px;margin-top:12px">'
      + _concKpi('Saldo del libro (SAP)', f(r.libro.saldo_final), '#72243E')
      + _concKpi('Saldo del banco', f(r.banco.saldo_final), '#0c447c')
      + _concKpi('Diferencia', f(r.difSaldos), r.cuadra?'#166534':'#B45309')
      + _concKpi('Pendiente de registrar', f(r.netoSinConciliar), r.cuadra?'#B45309':'#991b1b')
    +'</div></div>';

  // Comentarios: lo que la persona quiera dejar dicho sobre este mes
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:12px;margin-bottom:12px">'
    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">'
    +'Comentarios de la conciliación (se guardan en el PDF)</label>'
    +'<textarea id="conc-coment" rows="3" placeholder="Por ejemplo: los timbres y comisiones '
    +'se asientan en el cierre; el pago del pedido 1037422 queda pendiente de aplicar." '
    +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
    +'font-size:12px;margin-top:4px;font-family:var(--font-sans);resize:vertical">'
    +_esc(r.comentarios||'')+'</textarea></div>';

  // Otros detalles: lo que acompaña a la conciliación y conviene tener a
  // mano al volver a consultar el mes. Por ejemplo, el informe acumulado de
  // intereses de Banistmo o el Excel del banco con las correcciones.
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:12px;margin-bottom:12px">'
    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">'
    +'<i class="ti ti-paperclip"></i> Otros detalles y documentos de referencia</label>'
    +'<textarea id="conc-otros" rows="3" placeholder="Por ejemplo: el informe acumulado '
    +'de intereses del mes, o el Excel del banco con las correcciones aplicadas." '
    +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
    +'font-size:12px;margin-top:4px;font-family:var(--font-sans);resize:vertical">'
    +_esc(r.otros_detalles||'')+'</textarea>'
    + _concOtrosAdjuntos()
    +'</div>';

  // ── Las dos columnas, una al lado de la otra ──
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(330px,1fr));gap:12px">'
    + _concColumna('Libro mayor · SAP', '#72243E', r.libro, r.soloLibro,
        'Sin asiento correspondiente en el banco')
    + _concColumna('Extracto del banco', '#0c447c', r.banco, r.soloBanco,
        'Sin registrar en el libro mayor')
    +'</div>';
  return h;
}

// Uno de los cuatro números de arriba
function _concKpi(t, v, c){
  return '<div style="background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:9px;padding:9px 11px">'
    +'<div style="font-size:9.5px;text-transform:uppercase;letter-spacing:.4px;'
    +'color:var(--text-muted)">'+t+'</div>'
    +'<div style="font-size:15px;font-weight:700;color:'+c+';margin-top:2px">'+v+'</div></div>';
}

// El veredicto. Hay TRES estados, no dos: que la aritmética cierre no
// significa que esté todo registrado. Los cargos del banco que faltan en SAP
// hacen que la conciliación cuadre igual —explican la diferencia— pero
// siguen siendo trabajo pendiente, y decir solo "cuadra" lo escondía.
// El análisis en frases sueltas. Una sola fuente para la pantalla, el PDF y
// el texto que se copia: si cambia el criterio, cambian los tres a la vez.
function _concAnalisis(r){
  var f=_concFmt2;
  // Las que se compensan entre sí no son trabajo pendiente: ya están en los
  // dos lados. Contarlas hacía que el aviso pidiera registrar algo que ya
  // estaba registrado.
  var nComp=((r.compensadas||[]).length)*2;
  var pend=Math.max(0, r.soloBanco.length+r.soloLibro.length-nComp);
    // Las que se compensan ya se explican aparte: si se listaran otra vez
  // como "sin registrar", parecería que hay que asentarlas.
  var bancoPend=r.soloBanco.filter(function(m){ return !m.__comp; });
  var libroPend=r.soloLibro.filter(function(m){ return !m.__comp; });
var cargos=bancoPend.filter(function(m){ return _concEs(m.detalle); });
  var otros =bancoPend.filter(function(m){ return !_concEs(m.detalle); });
  var sum=function(a){ return a.reduce(function(s,x){ return s+x.monto; },0); };

  var o={titulo:'', explica:'', detalles:[], estado:''};

  // Lo primero que se dice: las partidas que se anulan entre sí. Es lo que
  // antes salía como un descuadre enorme sin explicación.
  var comp=r.compensadas||[];
  if(comp.length){
    var totalComp=comp.reduce(function(a,c){ return a+c.monto; },0);
    o.detalles.push({
      n:comp.length, monto:totalComp,
      texto:comp.length+' partida(s) se compensan entre sí por '+f(totalComp)
        +': el banco y el libro llevan el mismo importe con signo contrario, '
        +'que es como se registra una corrección. '
        +comp.map(function(c){
            return (c.banco.fecha||'')+' '+String(c.banco.detalle||'').slice(0,40)
              +' contra '+(c.libro.fecha||'')+' '+String(c.libro.detalle||'').slice(0,40);
          }).join(' · ')
    });
  }

  if(!r.cuadra){
    o.estado='descuadre';
    o.titulo='No cuadra: quedan '+f(r.descuadre)+' sin explicar';
    o.explica='La diferencia entre los dos saldos no coincide con las partidas sin conciliar. '
      +'Puede faltar un movimiento por leer en el extracto, o un asiento por traer de SAP.';
  } else if(!pend){
    o.estado='limpia';
    o.titulo='Conciliada y sin pendientes';
    o.explica='Todos los movimientos cruzaron y los dos saldos coinciden. '
      +'No queda nada por registrar.';
  } else {
    o.estado='pendientes';
    o.titulo='Los saldos se explican, pero quedan '+pend+' partida(s) por registrar en SAP';
    o.explica='La diferencia de '+f(r.difSaldos)+' entre los dos saldos es exactamente lo que '
      +'falta asentar. La conciliación no está cerrada hasta que se registren.';
  }

  if(cargos.length) o.detalles.push({
    n:cargos.length, monto:sum(cargos),
    texto:cargos.length+' cargo(s) del banco por '+f(sum(cargos))+': '
      +cargos.map(function(x){ return x.detalle; }).join(', ')});
  if(otros.length) o.detalles.push({
    n:otros.length, monto:sum(otros),
    texto:otros.length+' movimiento(s) del banco sin registrar por '+f(sum(otros))+': '
      +otros.map(function(x){ return x.detalle; }).join(', ')});
  if(libroPend.length) o.detalles.push({
    n:libroPend.length, monto:sum(libroPend),
    texto:libroPend.length+' asiento(s) del libro que el banco no muestra, por '
      +f(sum(libroPend))});
  return o;
}

function _concVeredictoHTML(r){
  var f=_concFmt2;
  var an=_concAnalisis(r);
  var pend=(r.soloBanco.length+r.soloLibro.length);
  var cargos=r.soloBanco.filter(function(m){ return _concEs(m.detalle); });
  var otros =r.soloBanco.filter(function(m){ return !_concEs(m.detalle); });

  if(!r.cuadra){
    return '<div style="margin-top:12px;background:#FEE2E2;border:1px solid #dc2626;'
      +'border-radius:9px;padding:11px 13px">'
      +'<div style="font-size:13px;font-weight:700;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> No cuadra: quedan '+f(r.descuadre)+' sin explicar</div>'
      +'<div style="font-size:11.5px;color:var(--t-rojo);margin-top:4px">'
      +'La diferencia entre los dos saldos no coincide con las partidas sin conciliar. '
      +'Puede faltar un movimiento por leer en el extracto, o un asiento por traer de SAP.'
      +'</div></div>';
  }

  if(!pend){
    return '<div style="margin-top:12px;background:var(--pastel-ok);border:1px solid #16a34a;'
      +'border-radius:9px;padding:11px 13px">'
      +'<div style="font-size:13px;font-weight:700;color:var(--t-verde)">'
      +'<i class="ti ti-circle-check"></i> Conciliada y sin pendientes</div>'
      +'<div style="font-size:11.5px;color:var(--t-verde);margin-top:4px">'
      +'Todos los movimientos cruzaron y los dos saldos coinciden. No queda nada por registrar.'
      +'</div></div>';
  }

  // Cuadra, pero hay trabajo pendiente
  var h='<div style="margin-top:12px;background:var(--pastel-aviso);border:1px solid #E9C08A;'
    +'border-radius:9px;padding:11px 13px">'
    +'<div style="font-size:13px;font-weight:700;color:var(--t-marron)">'
    +'<i class="ti ti-alert-circle"></i> Los saldos se explican, pero quedan '
    +pend+' partida(s) por registrar en SAP</div>'
    +'<div style="font-size:11.5px;color:var(--t-marron);margin-top:4px">'
    +'La diferencia de '+f(r.difSaldos)+' entre los dos saldos es exactamente lo que falta '
    +'asentar. La conciliación no está cerrada hasta que se registren.</div>';

  if(cargos.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-top:7px">'
      +'<b>'+cargos.length+' cargo(s) del banco</b> por '
      +f(cargos.reduce(function(a,x){ return a+x.monto; },0))+': '
      +_esc(cargos.map(function(x){ return x.detalle; }).join(', '))+'</div>';
  }
  if(otros.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-top:5px">'
      +'<b>'+otros.length+' movimiento(s)</b> por '
      +f(otros.reduce(function(a,x){ return a+x.monto; },0))+': '
      +_esc(otros.map(function(x){ return x.detalle; }).join(', '))+'</div>';
  }
  if(r.soloLibro.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-top:5px">'
      +'<b>'+r.soloLibro.length+' asiento(s) del libro</b> que el banco no muestra, por '
      +f(r.soloLibro.reduce(function(a,x){ return a+x.monto; },0))+'</div>';
  }
  return h+'</div>';
}

function _concFmt2(v){
  return (v<0?'-':'')+'$'+Math.abs(Number(v)||0).toLocaleString('en-US',
    {minimumFractionDigits:2,maximumFractionDigits:2});
}

// Una de las dos mitades: todos sus movimientos, marcando los que no cruzaron
function _concColumna(titulo, color, lado, sinCruzar, notaSin){
  var f=_concFmt2;
  var sin={}; (sinCruzar||[]).forEach(function(m){ sin[m.i]=true; });
  var movs=(lado.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i}); });

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);overflow:hidden">'
    +'<div style="background:'+color+';color:#fff;padding:8px 12px;font-size:12px;font-weight:700">'
      + titulo
      +'<span style="float:right;font-weight:500">'+movs.length+' movimiento(s)</span></div>'

    +'<div style="display:flex;justify-content:space-between;padding:7px 12px;'
      +'background:var(--surface-1);font-size:11px;border-bottom:0.5px solid var(--border)">'
      +'<span>Saldo inicial <b>'+f(lado.saldo_inicial)+'</b></span>'
      +'<span>Saldo final <b>'+f(lado.saldo_final)+'</b></span></div>'

    +'<div style="max-height:520px;overflow-y:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">';

  movs.forEach(function(m){
    var falta=sin[m.i];
    h+='<tr style="border-top:0.5px solid var(--border);'
      +(falta?'background:var(--pastel-aviso)':'')+'">'
      +'<td style="padding:5px 4px 5px 10px;width:16px;vertical-align:top">'
        +(falta?'<i class="ti ti-alert-triangle" style="color:var(--t-ambar);font-size:12px"></i>'
               :'<i class="ti ti-check" style="color:var(--t-verde3);font-size:12px"></i>')+'</td>'
      +'<td style="padding:5px 4px;white-space:nowrap;color:var(--text-muted);vertical-align:top">'
        +_esc(String(m.fecha||'').slice(5))+'</td>'
      +'<td style="padding:5px 6px;vertical-align:top">'+_esc(m.detalle||'')
        +(falta&&_concEs(m.detalle)
          ? ' <span style="font-size:9px;background:#FEF3C7;color:var(--t-marron);border-radius:6px;'
            +'padding:1px 6px;font-weight:700">CARGO DEL BANCO</span>' : '')
      +'</td>'
      +'<td style="padding:5px 10px 5px 4px;text-align:right;white-space:nowrap;font-weight:600;'
        +'color:'+(m.monto<0?'#991b1b':'#166534')+';vertical-align:top">'+f(m.monto)+'</td></tr>';
  });

  h+='</table></div>';

  if(sinCruzar && sinCruzar.length){
    h+='<div style="background:var(--pastel-aviso);border-top:1px solid #E9C08A;padding:8px 12px;'
      +'font-size:11px;color:var(--t-marron)">'
      +'<b>'+sinCruzar.length+' sin conciliar</b> · '+notaSin
      +' · neto '+f(sinCruzar.reduce(function(a,x){ return a+x.monto; },0))+'</div>';
  } else {
    h+='<div style="background:var(--pastel-ok);border-top:1px solid #16a34a;padding:8px 12px;'
      +'font-size:11px;color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
      +'Todos sus movimientos cruzaron con el otro lado.</div>';
  }
  return h+'</div>';
}

// ── El PDF de la conciliación ─────────────────────────────────────────
// Deja constancia de lo que se vio en pantalla: los dos lados completos, qué
// cruzó y qué no, y los comentarios de quien la hizo. Se guarda junto al
// extracto para poder consultarla meses después sin rehacerla.
async function _concPDF(r, comentarios){
  var doc=new window.jspdf.jsPDF({unit:'pt', format:'a4', orientation:'landscape', compress:true});
  var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
  var M=28;
  var nom=(window._concCtaNombre&&window._concCtaNombre[r.cuenta])||r.cuenta;
  var f=function(v){ return (v<0?'-':'')+'$'+Math.abs(Number(v)||0)
    .toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); };

  function cabecera(pag){
    doc.setFillColor(114,36,62); doc.rect(0,0,W,52,'F');
    doc.setTextColor(255); doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.text('CONCILIACIÓN BANCARIA', M, 24);
    doc.setFont('helvetica','normal'); doc.setFontSize(10);
    doc.text(nom+'  ·  '+MESES_ES[r.mes]+' '+r.anio, M, 40);
    doc.setFontSize(8);
    doc.text('KENNEDY CENTER CORP.', W-M, 24, {align:'right'});
    doc.text((r.fecha||'')+(r.por?('  ·  '+r.por):''), W-M, 40, {align:'right'});
    doc.setTextColor(20);
    if(pag>1){
      doc.setFontSize(8); doc.setTextColor(120);
      doc.text('continuación', W/2, 66, {align:'center'});
      doc.setTextColor(20);
    }
  }
  cabecera(1);

  // El veredicto y el análisis completo
  var an=_concAnalisis(r);
  var vCol=(an.estado==='descuadre')?[153,27,27]
          :(an.estado==='limpia')?[22,101,52]:[180,83,9];
  doc.setFillColor(vCol[0],vCol[1],vCol[2]);
  doc.roundedRect(M, 64, W-M*2, 22, 4, 4, 'F');
  doc.setTextColor(255); doc.setFont('helvetica','bold'); doc.setFontSize(10);
  doc.text(an.titulo, M+10, 79);
  doc.setTextColor(20);

  // La explicación y el desglose, que es lo que de verdad hay que leer
  var y=96;
  doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(70);
  var ex=doc.splitTextToSize(an.explica, W-M*2-6);
  doc.text(ex, M+3, y+8);
  y+=8+ex.length*10;

  an.detalles.forEach(function(d){
    doc.setFillColor(254,249,243);
    var ls=doc.splitTextToSize(d.texto, W-M*2-24);
    doc.roundedRect(M, y, W-M*2, 10+ls.length*10, 3, 3, 'F');
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(124,61,18);
    doc.text(ls, M+9, y+11);
    y+=14+ls.length*10;
  });
  doc.setTextColor(20);

  // Los cuatro números
  y+=6;
  var cw=(W-M*2-24)/4;
  [['Saldo del libro (SAP)', f(r.libro.saldo_final)],
   ['Saldo del banco',       f(r.banco.saldo_final)],
   ['Diferencia',            f(r.difSaldos)],
   ['Pendiente de registrar',f(r.netoSinConciliar)]].forEach(function(k,i){
    var x=M+i*(cw+8);
    doc.setDrawColor(210); doc.setLineWidth(0.6);
    doc.roundedRect(x, y, cw, 34, 4, 4, 'D');
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(120);
    doc.text(k[0], x+8, y+13);
    doc.setFont('helvetica','bold'); doc.setFontSize(12); doc.setTextColor(20);
    doc.text(k[1], x+8, y+27);
  });

  // Las dos columnas
  var top=y+48, colW=(W-M*2-14)/2, fila=13;
  if(top > H-160){ doc.addPage(); cabecera(2); top=80; }
  var lados=[
    {t:'LIBRO MAYOR · SAP', c:[114,36,62], d:r.libro, sin:r.soloLibro, x:M},
    {t:'EXTRACTO DEL BANCO', c:[12,68,124], d:r.banco, sin:r.soloBanco, x:M+colW+14}
  ];
  var maxFilas=Math.floor((H-top-60)/fila);
  var paginas=1;
  lados.forEach(function(L){
    paginas=Math.max(paginas, Math.ceil((L.d.movimientos||[]).length/maxFilas)||1);
  });

  for(var p=0; p<paginas; p++){
    if(p>0){ doc.addPage(); cabecera(p+1); }
    var ty=(p===0)?top:80;
    lados.forEach(function(L){
      var sin={}; (L.sin||[]).forEach(function(m){ sin[m.i]=true; });
      var movs=(L.d.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i}); })
                .slice(p*maxFilas, (p+1)*maxFilas);
      doc.setFillColor(L.c[0],L.c[1],L.c[2]);
      doc.rect(L.x, ty, colW, 16, 'F');
      doc.setTextColor(255); doc.setFont('helvetica','bold'); doc.setFontSize(8);
      doc.text(L.t, L.x+7, ty+11);
      doc.text((L.d.movimientos||[]).length+' movimiento(s)', L.x+colW-7, ty+11, {align:'right'});
      doc.setTextColor(20);

      if(p===0){
        doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
        doc.text('Saldo inicial '+f(L.d.saldo_inicial), L.x+7, ty+27);
        doc.text('Saldo final '+f(L.d.saldo_final), L.x+colW-7, ty+27, {align:'right'});
      }
      var ry=ty+(p===0?34:22);
      movs.forEach(function(m){
        if(sin[m.i]){ doc.setFillColor(254,249,243); doc.rect(L.x, ry-9, colW, fila, 'F'); }
        doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor(120);
        doc.text(sin[m.i]?'!':'ok', L.x+5, ry);
        doc.text(String(m.fecha||'').slice(5), L.x+16, ry);
        doc.setTextColor(20); doc.setFontSize(7);
        doc.text(String(m.detalle||'').slice(0,58), L.x+44, ry);
        doc.setFont('helvetica','bold');
        if(m.monto<0) doc.setTextColor(153,27,27); else doc.setTextColor(22,101,52);
        doc.text(f(m.monto), L.x+colW-7, ry, {align:'right'});
        doc.setTextColor(20);
        ry+=fila;
      });
    });
  }

  // Los comentarios, al final
  if(String(comentarios||'').trim()){
    doc.addPage(); cabecera(paginas+1);
    doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(20);
    doc.text('Comentarios', M, 80);
    doc.setFont('helvetica','normal'); doc.setFontSize(9);
    doc.text(doc.splitTextToSize(String(comentarios), W-M*2), M, 98);
  }

  // Pie con la numeración
  var tot=doc.getNumberOfPages();
  for(var q=1;q<=tot;q++){
    doc.setPage(q);
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(140);
    doc.text('Conciliación generada por el portal · '+(r.fecha||''), M, H-16);
    doc.text('Página '+q+' de '+tot, W-M, H-16, {align:'right'});
  }
  return doc;
}

// ── Guardar y copiar ──────────────────────────────────────────────────
function _concTexto(r){
  var f=function(v){ return (v<0?'-':'')+'$'+Math.abs(Number(v)||0).toFixed(2); };
  var L=[];
  L.push('CONCILIACIÓN BANCARIA · '+r.cuenta+' · '+MESES_ES[r.mes]+' '+r.anio);
  L.push('Hecha el '+(r.fecha||'')+(r.por?(' por '+r.por):''));
  L.push('');
  L.push('Saldo del banco:      '+f(r.banco.saldo_final));
  L.push('Saldo del libro:      '+f(r.libro.saldo_final));
  L.push('Diferencia:           '+f(r.difSaldos));
  L.push('Neto sin conciliar:   '+f(r.netoSinConciliar));
  var an=_concAnalisis(r);
  L.push('RESULTADO: '+an.titulo);
  L.push(an.explica);
  an.detalles.forEach(function(d){ L.push('  · '+d.texto); });
  function bloque(t, arr){
    if(!arr.length) return;
    L.push(''); L.push(t.toUpperCase()+' ('+arr.length+')');
    arr.forEach(function(m){
      L.push('  '+(m.fecha||'').padEnd(12)+f(m.monto).padStart(14)+'  '+(m.detalle||''));
    });
  }
  bloque('Solo en el banco', r.soloBanco);
  bloque('Solo en el libro mayor', r.soloLibro);
  L.push(''); L.push('Conciliados: '+r.conciliados.length+' partida(s)');
  return L.join('\n');
}

function _concCopiar(){
  var r=(window._concEstado||{}).res; if(!r) return;
  try{ navigator.clipboard.writeText(_concTexto(r)); showT('✓ Conciliación copiada'); }
  catch(e){ showT('No se pudo copiar'); }
}

// Borra la conciliación guardada de ese mes (el extracto no se toca)
async function _concBorrarConciliacion(){
  var st=window._concEstado, r=st&&st.res;
  var ref=(r&&r.referencia)||_concRefConc(st.cuenta, st.mes, st.anio);
  if(!confirm('¿Borrar la conciliación guardada de '+MESES_ES[st.mes]+' '+st.anio+'?\n\n'
    +'El extracto del banco no se borra: sigue archivado.')) return;
  try{
    var resp=await fetch(SB+'/rest/v1/conciliaciones?referencia=eq.'+encodeURIComponent(ref),{
      method:'DELETE', headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    if(!resp.ok){ showT('No se pudo borrar: '+resp.status); return; }
    if(r){ r.guardada=false; }
    showT('✓ Conciliación borrada');
    rConcil();
  }catch(e){ showT('No se pudo borrar: '+(e.message||e)); }
}

// Borra el extracto archivado de ese mes
async function _concBorrarExtracto(){
  var st=window._concEstado;
  var g=st&&st.extractoGuardado;
  if(!g){ showT('No hay extracto archivado de ese mes'); return; }
  if(!confirm('¿Borrar el extracto de '+MESES_ES[st.mes]+' '+st.anio+'?\n\n'
    +_esc(g.nombre_archivo||'')+'\n\nHabrá que volver a subirlo para conciliar ese mes.')) return;
  try{
    var resp=await fetch(SB+'/rest/v1/extractos_bancarios?clave=eq.'+encodeURIComponent(g.clave),{
      method:'DELETE', headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    if(!resp.ok){ showT('No se pudo borrar: '+resp.status); return; }
    st.extractoGuardado=null; st.extracto=null; st.res=null;
    showT('✓ Extracto borrado');
    rConcil();
  }catch(e){ showT('No se pudo borrar: '+(e.message||e)); }
}

function _concRefConc(cuenta, mes, anio){
  return 'CONC-'+anio+String(mes+1).padStart(2,'0')+'-'
    +String(cuenta).replace(/[^A-Za-z0-9]+/g,'').slice(0,16).toUpperCase();
}

async function _concGuardar(){
  var st=window._concEstado, r=st&&st.res;
  if(!r){ showT('Primero conciliá el mes'); return; }
  showT('Guardando…');
  var ref=_concRefConc(r.cuenta, r.mes, r.anio);

  // El comentario que se haya escrito viaja al PDF y a la base
  var coment=String(((document.getElementById('conc-coment')||{}).value)||'').trim();
  r.comentarios=coment;
  // Y los otros detalles, que se guardan en la misma fila
  var otros=String(((document.getElementById('conc-otros')||{}).value)||'').trim();
  r.otros_detalles=otros;

  // El PDF con todo lo que se ve en pantalla, archivado junto al extracto
  var pdfNombre='CONCILIACION '+((window._concCtaNombre&&window._concCtaNombre[r.cuenta])||r.cuenta)
    .replace(/[^\w .-]+/g,'')+' '+MESES_ES[r.mes]+' '+r.anio+'.pdf';
  try{
    var doc=await _concPDF(r, coment);
    var blob=doc.output('blob');
    var file=new File([blob], pdfNombre, {type:'application/pdf'});
    var pathPdf=await _subirDocStorage(ref, 'conciliacion', file);
    if(pathPdf){
      try{ await _registrarDoc(ref, 'conciliacion', file, pathPdf); }catch(e){}
      st.conciliacionPdf={nombre:pdfNombre, ruta:pathPdf};
    }
  }catch(e){
    console.warn('[conciliación] PDF:', e);
    showT('La conciliación se guarda, pero no se pudo generar el PDF: '+(e.message||e), 8000);
  }

  try{
    // on_conflict: rehacer la conciliación de un mes la reemplaza, no falla
    var resp=await fetch(SB+'/rest/v1/conciliaciones?on_conflict=referencia',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify({
        referencia:ref, cuenta:r.cuenta, mes:r.mes+1, anio:r.anio,
        saldo_banco:Number(r.banco.saldo_final)||0,
        saldo_libro:Number(r.libro.saldo_final)||0,
        diferencia:r.difSaldos, cuadra:r.cuadra,
        detalle:{conciliados:r.conciliados.length, soloBanco:r.soloBanco, soloLibro:r.soloLibro},
        comentarios:coment,
    otros_detalles: otros,
    otros_docs: JSON.stringify(window._concOtrosDocs||[]),
        pdf_nombre:(st.conciliacionPdf&&st.conciliacionPdf.nombre)||null,
        pdf_ruta:(st.conciliacionPdf&&st.conciliacionPdf.ruta)||null,
        hecha_por:(CU&&CU.name)||'', creado_en:new Date().toISOString()
      })
    });
    if(!resp.ok){
      var t=await resp.text();
      alert('Los documentos se archivaron, pero la conciliación no se pudo guardar.\n\n'
        +'Respuesta del servidor:\n'+t.slice(0,300)
        +'\n\nProbablemente falta la tabla "conciliaciones" (script conciliaciones.sql).');
      return;
    }
    r.guardada=true; r.referencia=ref;
    showT('✓ Conciliación guardada · el PDF queda junto al extracto', 7000);
    try{ await _concBuscarConciliacion(); }catch(e){}
    try{ rConcil(); }catch(e){}
  }catch(e){
    alert('No se pudo guardar: '+(e.message||e));
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  INSTRUCCIONES DE SHIPPING MARK PARA EL PROVEEDOR
//  No se genera nada: se le mandan al proveedor las PLANTILLAS de Kennedy
//  —el formato del shipping mark, el ejemplo de etiqueta de código de barras
//  y el dibujo de la caja— para que las use como referencia al marcar los
//  cartones. Van adjuntas en un correo con los destinatarios que se elijan.
// ═══════════════════════════════════════════════════════════════════════════

// Las plantillas van incrustadas para que el envío funcione sin depender de
// que estén subidas a ningún lado.
function _b64aBlob(b64, mime){
  var bin=atob(String(b64||''));
  var n=bin.length, arr=new Uint8Array(n);
  for(var i=0;i<n;i++) arr[i]=bin.charCodeAt(i);
  return new Blob([arr], {type:mime||'application/octet-stream'});
}

// ── Las plantillas que se le mandan al proveedor ──
// Antes viajaban dentro del propio archivo, en base64: eran 1,5 MB de los
// 3,3 que pesaba el portal, y se descargaban siempre aunque nadie pulsara
// el botón. Ahora viven en el bucket, junto al resto de documentos, y se
// bajan la primera vez que hacen falta.
var SM_TPL_RUTA='plantillas/';
var SM_TPL_ARCHIVOS=[
  {nombre:'SHIPPING MARK TEMPLATE - KENNEDY CENTER.xlsx',
   mime:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
  {nombre:'BARCODE LABEL EXAMPLE.pdf', mime:'application/pdf'},
  {nombre:'BOX DRAWING PRINT EXAMPLE.jpg', mime:'image/jpeg'},
  // El logo que va impreso en la caja: el proveedor lo necesita en alta
  // calidad para llevarlo a imprenta.
  {nombre:'KENNEDYS HOME LOGO.jpg', mime:'image/jpeg'}
];
window._smCache = window._smCache || null;

async function _smPlantillas(){
  if(window._smCache) return window._smCache;
  var out=[], fallos=[];
  for(var i=0;i<SM_TPL_ARCHIVOS.length;i++){
    var a=SM_TPL_ARCHIVOS[i];
    var url=DOCS_BASE+(SM_TPL_RUTA+a.nombre).split('/').map(encodeURIComponent).join('/');
    try{
      var r=await fetch(url);
      if(!r.ok){ fallos.push(a.nombre+' ('+r.status+')'); continue; }
      var b=await r.blob();
      if(!b || !b.size){ fallos.push(a.nombre+' (vacío)'); continue; }
      out.push({nombre:a.nombre, blob:b, mime:a.mime});
    }catch(e){ fallos.push(a.nombre+' ('+(e.message||e)+')'); }
  }
  if(fallos.length){
    console.error('[shipping mark] no se pudieron bajar: '+fallos.join(', ')
      +'. Tienen que estar en el bucket '+DOCS_BUCKET+', carpeta '+SM_TPL_RUTA);
  }
  // Solo se guarda en memoria si vinieron todas: si faltó alguna, la próxima
  // vez se vuelve a intentar en vez de mandarle al proveedor un envío corto.
  if(out.length===SM_TPL_ARCHIVOS.length) window._smCache=out;
  return out;
}

async function _smAbrir(ref){
  ref=String(ref||'').trim();
  showT('Preparando las plantillas…');
  var arch=await _smPlantillas();
  if(!arch.length){
    showT('No se pudieron cargar las plantillas. Mira la consola.');
    return;
  }
  if(arch.length<SM_TPL_ARCHIVOS.length){
    showT('Atención: solo se cargaron '+arch.length+' de '+SM_TPL_ARCHIVOS.length+' plantillas');
  }
  if(!arch.length){ showT('No están cargadas las plantillas de shipping mark'); return; }

  // Datos de la orden. Vale para una NO SAP y para una de SAP: en el segundo
  // caso se busca si vino de una NO SAP, porque el número que el proveedor
  // tiene que marcar en la caja es el DKC, no el docnum de SAP.
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===ref || String(x.num_orden)===ref; });
  if(!p){
    try{
      p=(window._pendSAP||[]).find(function(x){
        var o=_ordenSapDeNoSap(x);
        return o && String(o.id)===ref;
      });
    }catch(e){}
  }
  var o=(typeof orders!=='undefined')
    ? orders.find(function(x){ return String(x.id)===ref; }) : null;

  var prov=(p && p.proveedor) || (o && o.prov) || '';
  var dkc=String((p && (p.dkc||p.num_orden)) || (o && o.num_proveedor) || ref).toUpperCase();
  var po=(p && p.po) || (o && o.po) || '';

  // El correo del proveedor, si el portal lo conoce
  var correoProv='';
  try{ correoProv=_provEmailDeOrden(ref)||''; }catch(e){}

  var cuerpo=''
    +'Dear '+(prov||'Supplier')+',\n'
    +'\n'
    +'Please find attached our Shipping Marks Template for the following order:\n'
    +'\n'
    +'Supplier:      '+(prov||'')+'\n'
    +'Order No.:     '+dkc+'\n'
    +(po?('Your PO:       '+po+'\n'):'')
    +'\n'
    +'Please use the attached template as the model and prepare the shipping marks '
    +'for the complete order, following exactly the same format and information structure.\n'
    +'\n'
    +'Once all shipping marks are ready, please send them back to us for review and '
    +'final confirmation before printing.\n'
    +'\n'
    +'Please do not proceed with printing until you receive our approval.\n'
    +'\n'
    +'Thank you.\n'
    +'\n'
    +'Best regards,\n'
    +'\n'
    +((CU&&CU.name)||'')+'\n'
    +'KENNEDY CENTER CORP.';

  await _catMailAbrir(arch,
    'Shipping Marks Template \u2013 Supplier '+(prov||'')+' \u2013 Order #'+dkc,
    {para:correoProv, cuerpo:cuerpo, ref:ref});
}

// Lo que ya se le envió al proveedor de esta orden, para poder consultarlo
// La dirección real de un adjunto. Ojo: en los documentos guardados, `url`
// es la RUTA dentro del almacenamiento (12650/shipping_mark/…) y `data` es la
// dirección completa. Usar `url` a secas hacía que el navegador la buscara
// en el disco local y la descarga fallara.
function _docHref(a){
  if(!a) return '';
  var d=String(a.data||'');
  if(/^(https?:|data:|blob:)/i.test(d)) return d;
  var u=String(a.url||'');
  if(/^(https?:|data:|blob:)/i.test(u)) return u;
  var ruta=u||String(a.path||'');
  if(!ruta) return d||'';
  return DOCS_BASE + ruta.split('/').map(encodeURIComponent).join('/');
}

// Una sola línea con la cuenta; al pulsarla se abre la lista completa para
// verlos y descargarlos. Ocupa poco y no tapa las líneas de la orden.
function _smGuardadosHTML(ref){
  var lista=((window._atts||{})[String(ref)+'shipping_mark'])||[];
  lista=lista.filter(function(a){ return a && _docHref(a); });
  if(!lista.length) return '';
  return '<div onclick="_smVerGuardados(\'' + String(ref).replace(/'/g,'') + '\')" '
    +'title="Ver y descargar lo que se le envió al proveedor" '
    +'style="display:flex;align-items:center;gap:8px;cursor:pointer;background:#EEF2FF;'
    +'border:0.5px solid #C7D2FE;border-radius:9px;padding:9px 12px;margin-bottom:12px;'
    +'font-size:12px;font-weight:600;color:var(--t-indigo2)">'
    +'<i class="ti ti-box" style="font-size:15px"></i>'
    +'<span>Shipping marks enviados ('+lista.length+')</span>'
    +'<i class="ti ti-chevron-right" style="margin-left:auto;font-size:15px"></i>'
    +'</div>';
}

// La lista completa, en su propia ventana
function _smVerGuardados(ref){
  var lista=((window._atts||{})[String(ref)+'shipping_mark'])||[];
  lista=lista.filter(function(a){ return a && _docHref(a); });
  if(!lista.length){ showT('Esta orden no tiene shipping marks guardados'); return; }

  var prev=document.getElementById('modalSMFiles'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalSMFiles';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13650;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';

  var h='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:620px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div><div style="font-size:14px;font-weight:700">'
        +'<i class="ti ti-box"></i> Shipping marks enviados</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">Orden '+_esc(String(ref))
        +' \u00b7 '+lista.length+' archivo(s)</div></div>'
      +'<button onclick="document.getElementById(\'modalSMFiles\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div><div style="display:flex;flex-direction:column;gap:6px">';

  lista.forEach(function(a){
    var u=_docHref(a);
    var ext=String(a.name||'').split('.').pop().toLowerCase();
    var ico=(ext==='pdf')?'ti-file-type-pdf'
           :(['xlsx','xls','csv'].indexOf(ext)>=0)?'ti-file-spreadsheet'
           :(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0)?'ti-photo':'ti-file';
    h+='<div style="display:flex;align-items:center;gap:9px;padding:9px 11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:9px">'
      +'<i class="ti '+ico+'" style="font-size:19px;color:var(--text-accent);flex-shrink:0"></i>'
      +'<span style="flex:1;font-size:12px;overflow:hidden;text-overflow:ellipsis;'
        +'white-space:nowrap">'+_esc(a.name||'archivo')+'</span>'
      +'<a href="'+_esc(u)+'" target="_blank" rel="noopener" title="Abrir" '
        +'style="color:var(--text-accent);text-decoration:none;font-size:11.5px;'
        +'border:0.5px solid var(--border);border-radius:7px;padding:4px 10px">'
        +'<i class="ti ti-eye"></i> Ver</a>'
      +'<a href="'+_esc(u)+'" download="'+_esc(a.name||'archivo')+'" title="Descargar" '
        +'style="color:var(--text-accent);text-decoration:none;font-size:11.5px;'
        +'border:0.5px solid var(--border);border-radius:7px;padding:4px 10px">'
        +'<i class="ti ti-download"></i> Bajar</a>'
      +'</div>';
  });

  h+='</div><div style="display:flex;justify-content:flex-end;margin-top:12px">'
    +'<button class="btn bg2" onclick="document.getElementById(\'modalSMFiles\').remove()">Cerrar</button>'
    +'</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}

// El botón, en la orden NO SAP
// Rojo mientras no se haya enviado nada, para que se vea que está pendiente.
// Una vez enviado pasa a verde y lleva entre paréntesis cuándo y quién lo hizo.
function _smBtn(ref){
  var r=String(ref||'').replace(/'/g,'');
  var lista=((window._atts||{})[String(ref)+'shipping_mark'])||[];
  lista=lista.filter(function(a){ return a && _docHref(a); });

  if(!lista.length){
    return '<button onclick="event.stopPropagation();_smAbrir(\'' + r + '\')" '
      +'title="Pendiente: enviar al proveedor las plantillas de shipping mark, etiqueta y dibujo de la caja" '
      +'style="background:var(--pastel-error);color:var(--t-rojo);border:0.5px solid #f0b4b4;border-radius:6px;'
      +'padding:5px 10px;font-size:11px;cursor:pointer;font-weight:600">'
      +'<i class="ti ti-box" style="font-size:11px"></i> Enviar shipping marks</button>';
  }

  // El último envío: de ahí salen la fecha, la hora y el usuario.
  // Las fechas se guardan como "19 ago 2026 · 14:32", que comparado como texto
  // da un orden equivocado entre meses distintos, así que se convierten.
  var _ord=function(a){
    var d=null;
    try{ d=parseDateStr(a&&a.date); }catch(e){}
    if(!d) return -1;
    var hm=String((a&&a.date)||'').match(/(\d{1,2}):(\d{2})/);
    return d.getTime() + (hm ? (Number(hm[1])*3600000 + Number(hm[2])*60000) : 0);
  };
  var ult=null, mejor=-2;
  lista.forEach(function(a){
    var v=_ord(a);
    if(v>=mejor){ mejor=v; ult=a; }
  });
  if(!ult) ult=lista[lista.length-1];
  var cuando=(ult&&ult.date)?String(ult.date):'';
  var quien=(ult&&ult.by)?String(ult.by):'';
  var detalle=[cuando, quien].filter(Boolean).join(' · ');

  return '<button onclick="event.stopPropagation();_smAbrir(\'' + r + '\')" '
    +'title="Ya se enviaron. Se puede volver a enviar." '
    +'style="background:var(--pastel-ok);color:var(--t-verde);border:0.5px solid #86D9AC;border-radius:6px;'
    +'padding:5px 10px;font-size:11px;cursor:pointer;font-weight:600">'
    +'<i class="ti ti-box-seam" style="font-size:11px"></i> Shipping marks enviados'
    +(detalle?(' <span style="font-weight:500;opacity:.9">('+_esc(detalle)+')</span>'):'')
    +'</button>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO DESDE UNA ORDEN DE SAP
//  Las órdenes NO SAP arman su catálogo con las fichas temporales que
//  crearon. Una orden de SAP no tiene fichas: sus artículos ya existen, así
//  que la ficha se arma al vuelo cruzando las líneas de la orden con el
//  inventario. De ahí en adelante es la misma pantalla de revisión, el mismo
//  PDF y el mismo envío por correo.
// ═══════════════════════════════════════════════════════════════════════════
async function _catDesdeOrdenSAP(docnum){
  docnum=String(docnum||'').trim();
  if(!docnum){ showT('Orden no válida'); return; }

  showT('Leyendo los artículos de la orden ' + docnum + '…');

  // 1) Las líneas de la orden (se aprovecha lo que ya haya en caché)
  var lineas=[];
  try{
    if(window._poCache && window._poCache[docnum]) lineas=window._poCache[docnum];
    else{
      var r=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'
        +encodeURIComponent(docnum)+'&order=linenum.asc',{headers:SBH});
      if(r.ok) lineas=await r.json()||[];
    }
  }catch(e){ console.warn('[catálogo SAP] líneas:', e); }
  lineas=Array.isArray(lineas)?lineas:[];
  if(!lineas.length){ showT('Esta orden no tiene líneas para el catálogo'); return; }

  // La fecha de llegada vive en la CABECERA de la orden, no en las líneas.
  // Sin esto el catálogo salía con la ETA vacía.
  var _etaOrden='';
  try{
    var _o=(typeof orders!=='undefined')
      ? orders.find(function(x){
          return String(x.id)===String(docnum)
              || String(x.ref||'')===String(docnum)
              || String(x.docnum||'')===String(docnum); })
      : null;
    if(_o) _etaOrden=_o.fechaEst||'';
    // Si la orden no está cargada en el portal, se pide a la base
    if(!_etaOrden){
      // La cabecera de la orden de compra está en opor_ordenes, no en
      // pedidos: ahí la columna se llama "eta", y "duedate" es el respaldo.
      var _re=await fetch(SB+'/rest/v1/opor_ordenes?select=eta,duedate&docnum=eq.'
        +encodeURIComponent(docnum)+'&limit=1',{headers:SBH});
      if(_re.ok){
        var _p=(await _re.json()||[])[0]||{};
        var _v=_p.eta||_p.duedate||'';
        if(_v) _etaOrden=isoADisplay(String(_v).slice(0,10));
      }
    }
  }catch(e){ console.warn('[catálogo SAP] ETA:', e); }
  console.log('[catálogo SAP] ETA de la orden '+docnum+': '+(_etaOrden||'(sin fecha)'));

  // 2) Los datos de cada artículo, del inventario
  var codes=[], vistos={};
  lineas.forEach(function(l){
    var c=String(l.itemcode||'').trim();
    if(c && !vistos[c.toUpperCase()]){ vistos[c.toUpperCase()]=1; codes.push(c); }
  });
  var inv={};
  for(var i=0;i<codes.length;i+=200){
    var lote=codes.slice(i,i+200).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
    try{
      var ri=await fetch(SB+'/rest/v1/inventario?select='+_INV_CAMPOS
        +'&itemcode=in.('+encodeURIComponent(lote)+')&limit=200',{headers:SBH});
      if(ri.ok) (await ri.json()||[]).forEach(function(x){
        inv[String(x.itemcode||'').toUpperCase()]=x; });
    }catch(e){ console.warn('[catálogo SAP] inventario:', e); }
  }

  // 3) La ficha de cada línea. El costo sale del precio de la orden, que es
  //    el de esta compra en concreto y no un promedio.
  var filas=lineas.map(function(l){
    var sku=String(l.itemcode||'').trim();
    var x=inv[sku.toUpperCase()]||{};
    // La columna de opor_lineas se llama "precio", a secas. Con precio_unit
    // y price —que no existen— el costo salía en cero y la casilla de margen
    // respondía "sin costo". Detrás quedan los respaldos del inventario.
    var costo=Number(l.precio)||Number(l.precio_unit)||Number(l.price)
             ||Number(x.lastpurprc)||Number(x.avgprice)||Number(x.cif)||Number(x.fob)||0;
    return {
      tipo:'item',
      itemcode:sku,
      itemname:l.itemname||l.dscription||x.itemname||'',
      descripcion:x.itemname||l.itemname||l.dscription||'',
      marca:x.marca||'',
      _dept:String(x.grupo||'').replace(/^[.\s]+/,''),
      material:'', 
      color:x.u_color||'',
      tamano:x.u_tamano||'',
      medida:x.u_tamano||'',
      unidades_x_caja:x.unidadesbulto||x.salpackun||'',
      carton_size:'',
      peso:x.peso||'',
      cbm:x.volumen||'',
      barcode:x.codebars||'',
      precio:costo,                                   // costo, para el margen
      precio_venta:Number(x.precioventa)||0,
      disponible:_invDisp(x),
      por_llegar:Number(l.cantidad)||Number(l.quantity)||0,
      // Si SAP no tiene foto, se usa la del catálogo NO SAP. Y aunque SAP
      // declare una, se guarda la otra como respaldo: el picturname puede
      // apuntar a un archivo que no está en el bucket.
      foto:l.foto_url||_repFotoUrl(x.picturname)||_fotoNoSapDeSku(sku)||'',
      foto_nosap:_fotoNoSapDeSku(sku)||'',
      __pic:(x.picturname||l.picturname||''),
      __fotoNoSap:_fotoNoSapDeSku(sku)||'',
      __fotoOk:(l.foto_url?1:0),
      cardname:'',                                    // no va al catálogo
      // La ETA de la orden vale para todas sus líneas: llegan en el mismo
      // embarque. Si la línea trae una propia, esa manda.
      eta:(l.eta||l.u_eta||_etaOrden||''),
      dkc_origen:docnum
    };
  }).filter(function(f){ return f.itemcode; });

  if(!filas.length){ showT('No se pudo armar ninguna ficha'); return; }

  // 4) Se usa como fuente y se abre la revisión de siempre
  window._catFuente=filas;
  window._catSel={};
  filas.forEach(function(f){ window._catSel[String(f.itemcode).toUpperCase()]=true; });
  // Qué foto existe de verdad: en el PDF no hay reintento si la URL falla
  _catTrabajando('Comprobando las fotos…');
  try{ await _catResolverFotos(filas); }catch(e){ console.warn('[catálogo] fotos:',e); }
  // Las que sigan faltando: del Excel que se adjuntó en la etapa de Pedido,
  // donde el proveedor suele traerlas todas junto a su SKU.
  try{
    _catTrabajandoTexto('Buscando las fotos en el Excel de la orden…');
    var nf=await _catAutoFotos(filas);
    if(nf) showT('✓ '+nf+' foto(s) sacadas del Excel de la orden');
  }catch(e){ console.warn('[catálogo] fotos del Excel:',e); }
  _catListo();
  showT(filas.length+' artículo(s) listos para revisar');
  await _catRevisarAbrir(true);          // sin autocompletar: no hay Excel de proveedor
}

// El botón que va en el detalle de una orden de SAP
function _catBtnOrdenSAP(docnum){
  var r=String(docnum||'').replace(/'/g,'');
  return '<button onclick="event.stopPropagation();_catDesdeOrdenSAP(\'' + r + '\')" '
    +'title="Revisar y generar el catálogo con los artículos de esta orden" '
    +'style="background:var(--pastel-aviso);color:var(--t-marron);border:0.5px solid #E9C08A;border-radius:7px;'
    +'padding:4px 9px;font-size:11px;cursor:pointer;font-weight:600">'
    +'<i class="ti ti-book"></i> Catálogo</button>';
}

function _catBtnOrden(ref){
  var r=String(ref||'').replace(/'/g,'');
  // Solo si esa orden dejó SKU en el catálogo NO SAP
  var n=(window._catNoSap||[]).filter(function(f){
    return _catFichaViva(f) && String(f.dkc_origen||'')===r; }).length;
  if(!n) return '';
  return '<button onclick="event.stopPropagation();_catCatalogoAbrir(null,\''+_esc(r)+'\')" '
    +'title="Armar el catálogo con los '+n+' artículo(s) de esta orden" '
    +'style="background:var(--pastel-aviso);color:var(--t-marron);border:0.5px solid #E9C08A;border-radius:7px;'
    +'padding:4px 9px;font-size:11px;cursor:pointer;font-weight:600">'
    +'<i class="ti ti-book"></i> Catálogo ('+n+')</button>';
}

function _catBtnProv(code){
  var c=String(code||'').replace(/'/g,'');
  return '<button onclick="event.stopPropagation();_catCatalogoAbrir(\''+_esc(c)+'\')" '
    +'title="Armar el catálogo solo de este proveedor" '
    +'style="border:1px solid #7C3D12;background:var(--surface-0);color:var(--t-marron);'
    +'border-radius:16px;padding:3px 10px;font-size:10.5px;font-weight:600;'
    +'cursor:pointer;white-space:nowrap"><i class="ti ti-book"></i> Catálogo</button>';
}

function _catCatalogoAbrir(soloProv, soloOrden){
  // Solo los que TODAVÍA no existen en SAP. Los que ya están allí no son
  // mercancía por dar de alta: de ellos solo se conserva la foto.
  var filas=(window._catNoSap||[]).filter(_catFichaViva);
  // Se puede acotar a un proveedor o a una orden concreta
  if(soloProv){
    filas=filas.filter(function(f){ return _catKeyProv(f.cardcode)===_catKeyProv(soloProv); });
  }
  if(soloOrden){
    filas=filas.filter(function(f){ return String(f.dkc_origen||'')===String(soloOrden); });
  }
  // Al acotar, se marcan todos por defecto: es lo que se va a querer
  if(soloProv || soloOrden){
    window._catSel={};
    filas.forEach(function(f){ window._catSel[String(f.itemcode||'').toUpperCase()]=true; });
  }
  if(_deptAcotado()){
    filas=filas.filter(function(f){ return !f.dept || _deptPermitido(f.dept); });
  }
  if(!filas.length){ showT('No hay SKU BORRADOR para armar el catálogo'); return; }

  // Agrupados por proveedor
  var porProv={};
  filas.forEach(function(f){
    var k=(f.cardcode||'sin')+'|'+(f.cardname||'Sin proveedor');
    (porProv[k]=porProv[k]||[]).push(f);
  });

  var prev=document.getElementById('modalCatalogo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCatalogo';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';

  var h='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:840px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)">'
        +'<i class="ti ti-book"></i> Armar catálogo de mercancía por llegar</div>'
      +'<button onclick="_catCatalogoCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">'
      +'Elige los artículos que quieres incluir. Son los que todavía no existen en SAP, '
      +'con las fotos que se sacaron del Excel del proveedor.</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
      +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catSelTodos(true)">'
        +'<i class="ti ti-checks"></i> Marcar todos</button>'
      +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catSelTodos(false)">'
        +'Desmarcar todos</button>'
      +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catSelConFoto()">'
        +'<i class="ti ti-photo"></i> Solo los que tienen foto</button>'
      +'<span style="flex:1"></span>'
      +'<span id="catSelN" style="font-size:11.5px;font-weight:700;color:var(--t-marron)"></span>'
    +'</div>';

  Object.keys(porProv).sort().forEach(function(k){
    var partes=k.split('|');
    var lista=porProv[k];
    h+='<div style="border:0.5px solid var(--border);border-radius:9px;margin-bottom:10px;overflow:hidden">'
      +'<div style="background:var(--surface-1);padding:8px 12px;display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
        +'<label style="display:flex;align-items:center;gap:6px;cursor:pointer;flex:1">'
          +'<input type="checkbox" onchange="_catSelProv(\''+_esc(k.replace(/\x27/g,''))+'\',this.checked)" style="cursor:pointer">'
          +'<span style="font-size:12px;font-weight:700;color:var(--t-marron)">'+_esc(partes[0])+' — '+_esc(partes[1])+'</span>'
        +'</label>'
        +'<span style="font-size:10.5px;color:var(--text-muted)">'+lista.length+' artículo(s)</span>'
      +'</div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:8px;padding:10px 12px">';
    lista.forEach(function(f){
      var sku=String(f.itemcode||'').toUpperCase();
      var foto=f.foto || f.foto_url || _fotoNoSapDeSku(sku) || '';
      var on=!!window._catSel[sku];
      h+='<label data-catprov="'+_esc(k)+'" style="display:flex;flex-direction:column;gap:4px;'
        +'width:132px;border:1.5px solid '+(on?'#7C3D12':'var(--border)')+';border-radius:8px;'
        +'padding:7px;cursor:pointer;background:'+(on?'#FEF9F3':'var(--surface-0)')+'">'
        +'<div style="display:flex;align-items:center;gap:5px">'
          +'<input type="checkbox" data-catsku="'+_esc(sku)+'"'+(on?' checked':'')
          +' onchange="_catSelUno(\''+_esc(sku)+'\',this.checked)" style="cursor:pointer;margin:0">'
          +'<span style="font-size:10px;font-family:monospace;overflow:hidden;text-overflow:ellipsis;'
          +'white-space:nowrap">'+_esc(f.itemcode||'')+'</span></div>'
        +(foto
          ? ('<img src="'+_esc(foto)+'" style="width:100%;height:88px;object-fit:contain;'
             +'border-radius:5px;background:var(--surface-1)" onerror="this.style.display=\'none\'">')
          : ('<div style="width:100%;height:88px;border-radius:5px;background:var(--surface-1);'
             +'display:flex;align-items:center;justify-content:center;color:var(--text-muted)">'
             +'<i class="ti ti-photo-off" style="font-size:20px"></i></div>'))
        +'<div style="font-size:9.5px;color:var(--text-muted);line-height:1.25;height:24px;overflow:hidden">'
          +_esc(String(f.descripcion||f.itemname||'').slice(0,44))+'</div>'
        +(function(){
            // Cuánta ficha tiene: sin datos el catálogo queda pobre
            var n=['material','color','tamano','empaque'].filter(function(k){ return f[k]; }).length;
            return '<div style="font-size:8.5px;color:'+(n?'#166534':'#B45309')+'">'
              +(n?('<i class="ti ti-list-check"></i> '+n+' dato(s)')
                 :'<i class="ti ti-alert-circle"></i> sin ficha')+'</div>';
          })()
        +'</label>';
    });
    h+='</div></div>';
  });

  h+='<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:8px;'
    +'position:sticky;bottom:0;background:var(--surface-2);padding-top:10px">'
    +'<button class="btn" onclick="_catCatalogoCerrar()">Cancelar</button>'
    +'<button class="btn bp" style="background:#7C3D12" onclick="_catRevisarAbrir()">'
      +'<i class="ti ti-list-check"></i> Revisar y generar</button>'
    +'</div></div>';

  ov.innerHTML=h;
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
  _modalEsc(ov);
  _catSelContar();
}

function _catCatalogoCerrar(){
  var m=document.getElementById('modalCatalogo'); if(m) m.remove();
}

function _catSelUno(sku, on){
  if(on) window._catSel[sku]=true; else delete window._catSel[sku];
  var lb=document.querySelector('[data-catsku="'+sku+'"]');
  if(lb && lb.parentNode && lb.parentNode.parentNode){
    var caja=lb.parentNode.parentNode;
    caja.style.borderColor=on?'#7C3D12':'var(--border)';
    caja.style.background=on?'#FEF9F3':'var(--surface-0)';
  }
  _catSelContar();
}

function _catSelTodos(on){
  document.querySelectorAll('[data-catsku]').forEach(function(c){
    c.checked=on;
    _catSelUno(c.getAttribute('data-catsku'), on);
  });
}

function _catSelProv(k, on){
  document.querySelectorAll('[data-catprov="'+k+'"] [data-catsku]').forEach(function(c){
    c.checked=on;
    _catSelUno(c.getAttribute('data-catsku'), on);
  });
}

function _catSelConFoto(){
  document.querySelectorAll('[data-catsku]').forEach(function(c){
    var sku=c.getAttribute('data-catsku');
    var caja=c.parentNode.parentNode;
    var tiene=!!caja.querySelector('img');
    c.checked=tiene;
    _catSelUno(sku, tiene);
  });
}

function _catSelContar(){
  var n=Object.keys(window._catSel||{}).length;
  var e=document.getElementById('catSelN');
  if(e) e.textContent=n+' artículo(s) elegido(s)';
}

// Genera el catálogo con lo elegido
// ═══════════════════════════════════════════════════════════════════════════
//  EL CATÁLOGO IMPRESO
//  El formato es el de la ficha de Kennedy: una cuadrícula de 2 x 5 fichas
//  por página, cabecera negra con el logo y pie con el número de página.
//  Los datos salen del catálogo NO SAP (tabla catalogo_nosap).
// ═══════════════════════════════════════════════════════════════════════════

// El código de barras se dibuja con JsBarcode, que se pide solo cuando hace
// falta. Si no carga (sin internet, por ejemplo) el catálogo igual sale: en
// lugar del código se imprime el número.
var _jsbarcodeLoad=null;
function _ensureJsBarcode(){
  if(window.JsBarcode) return Promise.resolve(window.JsBarcode);
  if(_jsbarcodeLoad) return _jsbarcodeLoad;
  _jsbarcodeLoad=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js';
    sc.onload=function(){
      if(window.JsBarcode) res(window.JsBarcode);
      else rej(new Error('JsBarcode no quedó disponible'));
    };
    sc.onerror=function(){ rej(new Error('no se pudo cargar JsBarcode')); };
    document.head.appendChild(sc);
  });
  return _jsbarcodeLoad;
}

// Dibuja el código en un canvas y lo devuelve como PNG para meterlo en el PDF.
// Si son 13 dígitos se usa EAN-13 y si son 12 UPC; cualquier otra cosa va como
// CODE128, que acepta letras. Si el número no es válido para su formato se
// reintenta con CODE128 antes de rendirse.
function _catBarcodePNG(codigo){
  var txt=String(codigo||'').trim();
  if(!txt || !window.JsBarcode) return null;
  try{
    var cv=document.createElement('canvas');
    var fmt=/^\d{13}$/.test(txt)?'EAN13':(/^\d{12}$/.test(txt)?'UPC':'CODE128');
    var ok=true;
    var opts={width:2, height:60, margin:0, displayValue:false,
              valid:function(v){ ok=v; }};
    window.JsBarcode(cv, txt, Object.assign({format:fmt}, opts));
    if(!ok){
      ok=true;
      window.JsBarcode(cv, txt, Object.assign({format:'CODE128'}, opts));
    }
    if(!ok) return null;
    return {data:cv.toDataURL('image/png'), w:cv.width, h:cv.height};
  }catch(e){ return null; }
}

// El logo se mide una sola vez y queda guardado para las demás páginas
function _catPdfLogo(){
  if(window._catLogoImg!==undefined) return Promise.resolve(window._catLogoImg);
  return new Promise(function(res){
    var im=new Image();
    im.onload=function(){
      window._catLogoImg={data:KCC_LOGO, w:im.naturalWidth, h:im.naturalHeight};
      res(window._catLogoImg);
    };
    im.onerror=function(){ window._catLogoImg=null; res(null); };
    im.src=KCC_LOGO;
    setTimeout(function(){
      if(window._catLogoImg===undefined){ window._catLogoImg=null; res(null); }
    }, 5000);
  });
}

// Tamaño de las fotos dentro del PDF y lo ya descargado, para no repetir
// trabajo. Cuanto más chico el lado y la calidad, más liviano sale el archivo.
var // La foto de cada ficha ocupa unos 8 cm en el papel: con 220 px de lado y
// calidad 0.5 se ve igual de bien impresa y el PDF pesa menos de la mitad,
// que es lo que importa para mandarlo por correo.
_CAT_FOTO={lado:220, q:0.5};
var _catImgCache={};

// Arma el PDF completo con las fichas que se le pasen y lo devuelve sin
// guardarlo. Lo usan el catálogo NO SAP y la búsqueda con IA del inventario.
//   opts.foto = {lado, q}   tamaño y calidad de las fotos
// La ETA en formato corto: "2026-08-30" y "30 ago 2026" quedan igual de
// claras, pero en la ficha no cabe una fecha larga.
function _catEtaCorta(v){
  var t=String(v||'').trim();
  if(!t) return '';
  var m=t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m){
    var mes=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    return parseInt(m[3],10)+' '+(mes[parseInt(m[2],10)-1]||'')+' '+m[1];
  }
  return t.slice(0,14);
}

async function _catPdfDocumento(filas, opts){
  opts=opts||{};
  var fotoPrev=_CAT_FOTO;
  if(opts.foto) _CAT_FOTO={lado:opts.foto.lado||220, q:(opts.foto.q==null?0.5:opts.foto.q)};

  try{
    var doc=new window.jspdf.jsPDF({unit:'pt', format:'letter', compress:true});
    var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
    var M=30, COLS=2, ROWS=5, GAPX=10, GAPY=2;
    var cw=(W-M*2-GAPX)/COLS, ch=126;
    var Y0=96;        // la cuadrícula arranca debajo de la cabecera
    var lw=152;       // ancho de la parte de datos; el resto de la ficha es la foto

    // El código de barras es un extra: si la librería no carga, va el número
    try{ await _ensureJsBarcode(); }
    catch(e){ console.warn('[catálogo] códigos de barras:', e.message||e); }
    var logo=await _catPdfLogo();

    var porPagina=COLS*ROWS;
    var totPag=Math.max(1, Math.ceil(filas.length/porPagina));
    var pag=1;
    _catPdfCabecera(doc, W, logo, pag, filas.length, opts);
    _catPdfPie(doc, W, H, pag, totPag, opts);

    for(var i=0;i<filas.length;i++){
      var pos=i%porPagina;
      if(i && pos===0){
        doc.addPage(); pag++;
        _catPdfCabecera(doc, W, logo, pag, filas.length, opts);
        _catPdfPie(doc, W, H, pag, totPag, opts);
      }
      var x=M+(pos%COLS)*(cw+GAPX);
      var y=Y0+Math.floor(pos/COLS)*(ch+GAPY);
      await _catPdfFicha(doc, filas[i], x, y, cw, ch, lw);
    }
    return doc;
  } finally {
    _CAT_FOTO=fotoPrev;
  }
}

// Cabecera: barra negra, el logo a la izquierda y "Mercancía por llegar" a la
// derecha. El logo es oscuro, así que va sobre un recuadro blanco para que se
// lea sobre el negro.
function _catPdfCabecera(doc, W, logo, pag, totalItems, opts){
  opts=opts||{};
  var M=30, h=44, y=26;
  doc.setFillColor(78,78,78);          // gris, no negro
  doc.rect(M, y, W-M*2, h, 'F');

  if(logo){
    var ih=24, iw=ih*(logo.w/logo.h);
    doc.setFillColor(255,255,255);
    doc.roundedRect(M+7, y+(h-ih-10)/2, iw+16, ih+10, 3, 3, 'F');
    try{ doc.addImage(logo.data,'PNG', M+15, y+(h-ih)/2, iw, ih); }catch(e){}
  } else {
    doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(255,255,255);
    doc.text('KENNEDY CENTER', M+14, y+h/2+4);
  }

  doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(255,255,255);
  doc.text(opts.titulo||'CATÁLOGO', W/2, y+h/2+4, {align:'center'});

  doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(70,70,70);
  var f=new Date();
  var fecha=('0'+f.getDate()).slice(-2)+'/'+('0'+(f.getMonth()+1)).slice(-2)+'/'+f.getFullYear();
  doc.text((pag===1?('Items: '+totalItems+'   ·   '):'')+fecha, W/2, y+h+16, {align:'center'});
}

// Pie: barra negra con la nota y el número de página
function _catPdfPie(doc, W, H, pag, totPag, opts){
  opts=opts||{};
  var M=30, h=26, y=H-M-h+6;
  doc.setFillColor(17,17,17);
  doc.rect(M, y, W-M*2, h, 'F');
  doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor(225,225,225);
  doc.text(opts.subtitulo
    ? ('Kennedy Center Corp.  ·  '+opts.subtitulo)
    : 'Kennedy Center Corp.  ·  Mercancía en tránsito. Precios y disponibilidad sujetos a cambio sin previo aviso.',
           M+12, y+h/2+2.5);
  doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor(255,255,255);
  doc.text('Página '+pag+' de '+totPag, W-M-12, y+h/2+3, {align:'right'});
}

// Una fila de la ficha técnica: arriba los títulos en gris, abajo los valores.
// Las celdas se reparten el ancho en partes iguales y devuelve dónde termina.
function _catPdfTabla(doc, x, y, w, celdas){
  var n=celdas.length, cw=w/n;
  doc.setLineWidth(0.4); doc.setDrawColor(160,160,160);
  doc.setFillColor(241,240,236);
  doc.rect(x, y, w, 8, 'FD');
  doc.rect(x, y+8, w, 10, 'D');
  for(var i=1;i<n;i++) doc.line(x+cw*i, y, x+cw*i, y+18);

  celdas.forEach(function(c,i){
    doc.setFont('helvetica','normal'); doc.setFontSize(5.2); doc.setTextColor(95,95,95);
    doc.text(String(c.t||''), x+cw*i+cw/2, y+5.6, {align:'center'});

    var col=c.c||[25,25,25];
    doc.setFont('helvetica','bold'); doc.setFontSize(6.6);
    doc.setTextColor(col[0],col[1],col[2]);
    var v=String(c.v==null?'':c.v).replace(/\s+/g,' ').trim();
    while(v && doc.getTextWidth(v)>cw-5) v=v.slice(0,-1);
    doc.text(v||'—', x+cw*i+cw/2, y+15.4, {align:'center'});
  });
  return y+18;
}

// Una ficha completa dentro de la cuadrícula
async function _catPdfFicha(doc, f, x, y, cw, ch, lw){
  var sku=String(f.itemcode||'').toUpperCase();

  doc.setDrawColor(25,25,25); doc.setLineWidth(0.9);
  doc.rect(x, y, cw, ch, 'D');

  // El código, arriba a la izquierda
  doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(15,15,15);
  var cod=String(f.itemcode||'');
  while(cod && doc.getTextWidth(cod)>lw-14) cod=cod.slice(0,-1);
  doc.text(cod, x+7, y+14);

  // La descripción, centrada y en dos líneas como mucho
  doc.setFont('helvetica','bold'); doc.setFontSize(7); doc.setTextColor(35,35,35);
  var desc=doc.splitTextToSize(String(_catValor(f,'descripcion')||f.itemname||''), lw-14);
  doc.text(desc.slice(0,2), x+lw/2, y+25, {align:'center'});

  // La ficha técnica
  var ty=y+40;
  ty=_catPdfTabla(doc, x+7, ty, lw-14, [
    {t:'Categoria', v:dL(f._dept||f.dept||'')},
    {t:'Marca',     v:_catValor(f,'marca')}
  ]);
  ty=_catPdfTabla(doc, x+7, ty, lw-14, [
    {t:'Pzs/caja',    v:_catValor(f,'unidades_x_caja')},
    {t:'Medida',      v:_catValor(f,'medida')||_catValor(f,'carton_size')||_catValor(f,'tamano')},
    {t:'CBM',         v:f.cbm||''},
    {t:'Peso',        v:_catValor(f,'peso')}
  ]);
  var pv=Number(_catValor(f,'precio_venta'))||0;
  // La cantidad disponible solo la traen las fichas armadas desde el
  // inventario. Las del catálogo NO SAP todavía no tienen existencia, así que
  // en esas la celda ni aparece y la fila queda de dos columnas.
  var celdas3=[{t:'Color', v:_catValor(f,'color')}];
  if(f.disponible!=null && f.disponible!==''){
    celdas3.push({t:'Disponible',
                  v:(Number(f.disponible)||0).toLocaleString('es'),
                  c:[12,74,124]});
  }
  // Lo que viene en camino va SIEMPRE que haya algo, tenga o no existencia.
  // Antes salía solo si NO había disponible, así que en los catálogos hechos
  // desde el inventario nunca aparecía.
  var _pl=(_catValor(f,'por_llegar')!=null && _catValor(f,'por_llegar')!=='')
    ? Number(String(_catValor(f,'por_llegar')).replace(/[^0-9.\-]/g,''))||0
    : ((f.por_llegar!=null && f.por_llegar!=='')
        ? Number(f.por_llegar)||0
        : _catPorLlegar(f.itemcode));
  if(_pl>0) celdas3.push({t:'Por llegar', v:_pl.toLocaleString('es'), c:[180,83,9]});
  // La fecha estimada de llegada, si la hay. Va junto a la cantidad porque
  // las dos responden a la misma pregunta del cliente: cuánto y cuándo.
  var _eta=String(_catValor(f,'eta')||f.eta||f.fechaEst||'').trim();
  if(_eta) celdas3.push({t:'ETA', v:_catEtaCorta(_eta), c:[12,68,124]});
  celdas3.push({t:'Precio', v:pv?fmt(pv):'', c:[22,101,52]});
  ty=_catPdfTabla(doc, x+7, ty, lw-14, celdas3);

  // El código de barras
  var bc=String(_catValor(f,'barcode')||'').trim();
  if(bc){
    var bi=_catBarcodePNG(bc);
    if(bi){
      var bw=lw-42, bh=16;
      try{ doc.addImage(bi.data,'PNG', x+7+((lw-14)-bw)/2, ty+4, bw, bh); }catch(e){}
      doc.setFont('helvetica','normal'); doc.setFontSize(5.8); doc.setTextColor(70,70,70);
      doc.text(bc, x+7+(lw-14)/2, ty+4+bh+6.5, {align:'center'});
    } else {
      doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(70,70,70);
      doc.text(bc, x+7+(lw-14)/2, ty+14, {align:'center'});
    }
  }

  // La foto, a la derecha
  var px=x+lw+2, pw=cw-lw-8, py=y+7, ph=ch-16;
  var foto=f.foto || f.foto_url || ((window._nsapFotos||{})[sku]||{}).url || '';
  if(foto){
    try{
      var im=null;
      if(foto.indexOf('data:')===0){
        im=await new Promise(function(res){
          var i2=new Image();
          i2.onload=function(){ res({data:foto, w:i2.naturalWidth, h:i2.naturalHeight}); };
          i2.onerror=function(){ res(null); };
          i2.src=foto;
          setTimeout(function(){ res(null); }, 6000);
        });
      } else {
        // Se guarda lo ya bajado: en un catálogo largo se repiten fotos y
        // volver a descargarlas y recomprimirlas es lo que lo hace lento.
        var clave=foto+'|'+_CAT_FOTO.lado+'|'+_CAT_FOTO.q;
        if(_catImgCache[clave]!==undefined){
          im=_catImgCache[clave];
        } else {
          im=await _repCargarImg(foto, _CAT_FOTO.lado, _CAT_FOTO.q);
          _catImgCache[clave]=im||null;
        }
      }
      if(im){
        var r=Math.min(pw/im.w, ph/im.h);
        doc.addImage(im.data,'JPEG', px+(pw-im.w*r)/2, py+(ph-im.h*r)/2, im.w*r, im.h*r);
      }
    }catch(e){}
  }

  // Ojo: aquí NO va el proveedor. El catálogo lo lee el cliente y de quién
  // se compra la mercancía es información interna.
}

async function _catGenerar(tipo, porCorreo){
  var skus=Object.keys(window._catSel||{});
  if(!skus.length){ showT('Elige al menos un artículo'); return; }

  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  if(!filas.length){ showT('No se encontraron los artículos elegidos'); return; }

  showT('Armando el catálogo con '+filas.length+' artículo(s)…');

  if(tipo==='excel'){ return _catExcel(filas); }

  // PDF: la ficha de catálogo de Kennedy, 2 x 5 por página
  var doc=await _catPdfDocumento(filas);
  var _nom='Catalogo_'+new Date().toISOString().slice(0,10)+'.pdf';
  if(porCorreo){
    await _catMailAbrir([{nombre:_nom, blob:doc.output('blob'), mime:'application/pdf'}],
                        'Catálogo Kennedy Center');
  } else {
    doc.save(_nom);
    // La ventana queda abierta: se suele generar el PDF, mirarlo y volver a
    // ajustar precios. Se cierra con el botón Cerrar o con Escape.
    showT('✓ Catálogo generado · la ventana queda abierta para seguir ajustando');
  }
}

async function _catExcel(filas){
  // ExcelJS se carga bajo demanda: hay que pedirlo, no solo comprobarlo
  try{
    await _ensureExcelJS();
  }catch(e){
    showT('No se pudo cargar el generador de Excel: '+(e.message||e), 6000);
    console.warn('[catálogo] ExcelJS:', e);
    return;
  }
  if(typeof ExcelJS==='undefined'){
    showT('El generador de Excel no quedó disponible. Probá de nuevo.', 5000);
    return;
  }
  showT('Armando el Excel…');
  var wb=new ExcelJS.Workbook();
  var ws=wb.addWorksheet('Catálogo');
  ws.columns=[
    {header:'Foto', key:'foto', width:14},
    {header:'SKU', key:'sku', width:18},
    {header:'Descripción', key:'desc', width:42},
    {header:'Material', key:'material', width:24},
    {header:'Color', key:'color', width:16},
    {header:'Medida', key:'tamano', width:22},
    {header:'Pzs x caja', key:'upc', width:11},
    {header:'Medida caja', key:'carton', width:20},
    {header:'Peso', key:'peso', width:11},
    {header:'Marca', key:'marca', width:14},
    {header:'CBM', key:'cbm', width:9},
    {header:'Código de barras', key:'barcode', width:18},
    {header:'Precio venta', key:'precio', width:13},
    {header:'Por llegar', key:'porllegar', width:12},
    {header:'ETA', key:'eta', width:13},
    {header:'Departamento', key:'dept', width:15}
    // El proveedor NO va: este archivo también termina en manos del cliente.
  ];
  ws.getRow(1).font={bold:true, color:{argb:'FFFFFFFF'}};
  ws.getRow(1).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF7C3D12'}};

  for(var i=0;i<filas.length;i++){
    var f=filas[i];
    var sku=String(f.itemcode||'').toUpperCase();
    var fila=ws.addRow({foto:'', sku:f.itemcode||'',
                        desc:_catValor(f,'descripcion')||f.itemname||'',
                        material:_catValor(f,'material'), color:_catValor(f,'color'),
                        tamano:_catValor(f,'tamano'),
                        carton:_catValor(f,'carton_size'),
                        peso:_catValor(f,'peso'), marca:_catValor(f,'marca'),
                        precio:Number(_catValor(f,'precio_venta'))||'',
                        upc:_catValor(f,'unidades_x_caja')||'', cbm:f.cbm||'',
                        barcode:f.barcode||'',
                        porllegar:(_catValor(f,'por_llegar')||_catPorLlegar(f.itemcode)||''),
                        eta:_catEtaCorta(_catValor(f,'eta')||f.eta||f.fechaEst||''),
                        dept:f._dept?dL(f._dept):''});
    fila.alignment={vertical:'middle', wrapText:true};
    fila.height=64;
    var foto=f.foto || f.foto_url || _fotoNoSapDeSku(sku) || '';
    if(foto){
      try{
        var im=null;
        if(foto.indexOf('data:')===0){
          // Ya está embebida: no hace falta descargarla
          var pr=foto.split(',');
          im={b64:pr[1], ext:(/jpe?g/.test(pr[0])?'jpeg':'png')};
        } else {
          im=await _repImgToB64(foto, 240, 0.6);
        }
        if(im){
          var id=wb.addImage({base64:im.b64, extension:im.ext});
          ws.addImage(id, {tl:{col:0.12, row:fila.number-1+0.08},
                           ext:{width:74, height:74}, editAs:'oneCell'});
        }
      }catch(e){}
    }
  }
  var buf=await wb.xlsx.writeBuffer();
  var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download='Catalogo_por_llegar_'+new Date().toISOString().slice(0,10)+'.xlsx';
  a.click();
  showT('✓ Catálogo en Excel generado · la ventana queda abierta');
}

// Sube la foto que la AI sacó del Excel y devuelve su enlace
async function _catSubirFotoSku(code, cardcode, it){
  try{
    var sku=String(code||'').trim().toUpperCase();
    if(!sku) return null;
    var pend=(window._nsapFotosPend||{})[sku];
    // Si ya la trae el propio artículo, se usa esa
    if(!pend && it && it._foto && it._foto.indexOf('data:')===0){
      var pr=it._foto.split(',');
      pend={b64:pr[1], mime:(pr[0].match(/data:([^;]+)/)||[])[1]||'image/png'};
    }
    if(!pend || !pend.b64) return null;

    var ext=(pend.mime==='image/jpeg')?'jpg':(pend.mime==='image/gif'?'gif':'png');
    var ruta='nosap/'+String(cardcode||'sin-prov').replace(/[^\w-]/g,'')+'/'
      +sku.replace(/[^\w.-]/g,'_')+'.'+ext;
    var bin=atob(pend.b64), arr=new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    var r=await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+ruta,{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':SBH.Authorization,'Content-Type':pend.mime,'x-upsert':'true'},
      body:arr});
    if(!r.ok && r.status!==409){
      var t='';
      try{ t=await r.text(); }catch(e){}
      _dbg('[nosap] no se subió la foto de '+sku+' ('+r.status+'):', t.slice(0,160));
      // Si el storage falla, se guarda la imagen en la propia ficha para no
      // perderla. Ocupa más, pero el catálogo la necesita.
      if(pend.b64.length < 700000){
        _dbg('[nosap] '+sku+': se guarda la foto en la ficha');
        return 'data:'+pend.mime+';base64,'+pend.b64;
      }
      return null;
    }
    var url=DOCS_BASE+ruta.split('/').map(encodeURIComponent).join('/');
    window._nsapFotos[sku]={url:url, mime:pend.mime};
    _dbg('[nosap] foto guardada para '+sku+' → '+ruta);
    return url;
  }catch(e){
    console.warn('[nosap] foto de '+code+':', e);
    // Último recurso: la imagen va dentro de la ficha
    try{
      var pf=(window._nsapFotosPend||{})[String(code||'').trim().toUpperCase()];
      if(pf && pf.b64 && pf.b64.length<700000) return 'data:'+pf.mime+';base64,'+pf.b64;
    }catch(e2){}
    return null;
  }
}

function _catSetDept(k){
  window._catFiltroDept=k;
  rCatNoSap();
}

// ── Pantalla: Proveedores y SKU NO SAP ──
async function rCatNoSap(){
  var box=document.getElementById('page-catnosap'); if(!box) return;
  box.innerHTML='<div class="empty" style="padding:16px"><i class="ti ti-loader-2 spin"></i> Cargando...</div>';
  await _catNoSapCargar(true);
  var filas=window._catNoSap||[];
  if(CU&& _deptAcotado()) filas=filas.filter(function(f){ return !f.dept || _deptPermitido(f.dept); });

  // El departamento de cada ficha. Muchas no lo traen guardado, así que se
  // deduce de la orden NO SAP que la creó, y los artículos heredan el de su
  // proveedor.
  _catCompletarDept(filas);

  var deptos={};
  filas.forEach(function(f){ var d=f._dept; if(d) deptos[d]=(deptos[d]||0)+1; });
  var sinDept=filas.filter(function(f){ return !f._dept; }).length;
  var fd=window._catFiltroDept||'todos';
  if(fd && fd!=='todos'){
    filas = (fd==='sin')
      ? filas.filter(function(f){ return !f._dept; })
      : filas.filter(function(f){ return f._dept===fd; });
  }

  var provs=filas.filter(function(f){ return f.tipo==='proveedor'; });
  // Se listan solo los que TODAVÍA no están en SAP. Los que ya existen allí
  // no son artículos por dar de alta: de ellos solo se aprovecha la foto,
  // y se ocultan aunque la base todavía no admita marcarlos como tales.
  var items=filas.filter(_catFichaViva);

  var h='<div style="font-size:13px;font-weight:600;margin-bottom:3px"><i class="ti ti-alert-square-rounded" style="color:var(--t-ambar)"></i> Proveedores y SKU BORRADOR</div>';
  h+='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'Fichas temporales creadas desde órdenes BORRADOR. Cuando el mismo código aparece en SAP, la ficha se elimina sola.</div>';

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
    +'<span style="font-size:11.5px;background:var(--pastel-naranja);color:var(--t-marron);border:0.5px solid #E9C08A;border-radius:14px;padding:4px 11px;font-weight:600">'+provs.length+' proveedor(es) nuevo(s)</span>'
    +'<span style="font-size:11.5px;background:var(--pastel-lila);color:var(--t-lila);border:0.5px solid #C4B5FD;border-radius:14px;padding:4px 11px;font-weight:600">'+items.length+' SKU nuevo(s)</span>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catNoSapRevisar()"><i class="ti ti-refresh"></i> Revisar contra SAP</button>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catNoSapRellenar()"><i class="ti ti-database-import"></i> Revisar órdenes existentes</button>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catNoSapDiag()"><i class="ti ti-stethoscope"></i> Probar tabla</button>'
    +'<span style="flex:1"></span>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catTodos(true)"><i class="ti ti-chevrons-down"></i> Expandir</button>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catTodos(false)"><i class="ti ti-chevrons-up"></i> Contraer</button>'
    +(_esGerencia()?('<button class="btn bg2" style="padding:4px 11px;font-size:11px;color:var(--text-danger)" onclick="_gerVaciarCatalogoNoSap()"><i class="ti ti-trash"></i> Vaciar todo</button>'):'')
    +'</div>';
  // Barra de departamentos: siempre visible, para poder acotar la consulta
  var totalSinFiltro=(window._catNoSap||[]).filter(_catFichaViva).length;
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px;'
    +'background:var(--surface-1);border-radius:9px;padding:7px 10px">'
    +'<span style="font-size:11px;color:var(--text-secondary);font-weight:700">'
    +'<i class="ti ti-filter"></i> Departamento</span>';
  var defs=[{k:'todos', l:'Todos', n:totalSinFiltro}];
  Object.keys(deptos).sort().forEach(function(d){ defs.push({k:d, l:dL(d), n:deptos[d]}); });
  if(sinDept) defs.push({k:'sin', l:'Sin asignar', n:sinDept});
  defs.forEach(function(x){
    var on=(fd===x.k)||(x.k==='todos'&&(!fd||fd==='todos'));
    h+='<button onclick="_catSetDept(\''+x.k+'\')" style="border:1px solid '+(on?'#7C3D12':'var(--border)')+';'
      +'background:'+(on?'#7C3D12':'var(--surface-0)')+';color:'+(on?'#fff':'#7C3D12')+';'
      +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +(EMOJIS2[x.k]||'')+' '+_esc(x.l)+' <span style="opacity:.85;font-weight:400">'+x.n+'</span></button>';
  });
  if(defs.length<=1){
    h+='<span style="font-size:10.5px;color:var(--text-muted)">Ninguna ficha tiene departamento asignado.</span>';
  }
  h+='</div>';
  // Catálogo de la mercancía que todavía no está en SAP
  var conFoto=filas.filter(function(f){
    return f.tipo!=='proveedor' &&
      (f.foto || _fotoNoSapDeSku(f.itemcode));
  }).length;
  var totalSku=filas.filter(function(f){ return f.tipo!=='proveedor'; }).length;
  if(totalSku){
    h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;background:var(--pastel-aviso);'
      +'border:1px solid #E9C08A;border-radius:9px;padding:9px 12px;margin-bottom:12px">'
      +'<i class="ti ti-book" style="color:var(--t-marron)"></i>'
      +'<span style="font-size:11.5px;color:var(--t-marron);flex:1">'
        +'Armá un catálogo de esta mercancía por llegar · '
        +'<b>'+conFoto+'</b> de '+totalSku+' artículo(s) tienen foto</span>'
      +'<button class="btn bp" style="background:#7C3D12;padding:5px 12px;font-size:11px" '
        +'onclick="_catCatalogoAbrir()"><i class="ti ti-book"></i> Armar catálogo</button>'
      +'</div>';
  }
  h+='<div id="cat-diag"></div>';
  if(fd && fd!=='todos'){
    h+='<div style="font-size:11px;color:var(--t-marron);margin-bottom:8px">'
      +'<i class="ti ti-info-circle"></i> Mostrando solo '
      +(fd==='sin'?'las fichas sin departamento':('el departamento '+_esc(dL(fd))))
      +' · '+filas.length+' ficha(s) de '+totalSinFiltro+'</div>';
  }

  if(!filas.length){
    h+='<div class="empty" style="padding:20px;color:var(--text-muted)"><i class="ti ti-circle-check" style="font-size:22px;color:var(--text-success)"></i><br>No hay proveedores ni SKU pendientes de crearse en SAP.</div>';
    box.innerHTML=h; _catNoSapBadge(); return;
  }

  // Agrupar por proveedor
  var grupos={};
  provs.forEach(function(p){ grupos[_catKeyProv(p.cardcode)]={prov:p, items:[]}; });
  items.forEach(function(it){
    var k=_catKeyProv(it.cardcode);
    if(!grupos[k]) grupos[k]={prov:null, cardcode:it.cardcode, cardname:it.cardname, items:[]};
    grupos[k].items.push(it);
  });

  window._catGrupos=grupos;
  Object.keys(grupos).forEach(function(k){
    var g=grupos[k];
    var esProvNuevo=!!g.prov;
    var nombre=(g.prov?g.prov.cardname:g.cardname)||'(sin nombre)';
    var codigo=(g.prov?g.prov.cardcode:g.cardcode)||k;
    var col=esProvNuevo?'#B45309':'#5B21B6';
    var bg=esProvNuevo?'#FEF9F3':'var(--surface-1)';
    h+='<div style="border:0.5px solid var(--border);border-left:4px solid '+col+';border-radius:9px;margin-bottom:10px;overflow:hidden">';
    var gid='catg-'+String(k).replace(/[^A-Za-z0-9]/g,'');
    var abierto=(window._catAbiertos&&window._catAbiertos[k])?true:false;
    h+='<div onclick="_catToggleProv(\''+_esc(String(k).replace(/\\/g,''))+'\')" title="Clic para mostrar u ocultar los SKU"'
      +' style="background:'+bg+';padding:9px 12px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;cursor:pointer;user-select:none">'
      +'<i class="ti ti-chevron-down" id="'+gid+'-chev" style="color:'+col+';font-size:15px;transition:transform .15s ease;transform:rotate('+(abierto?'0':'-90')+'deg)"></i>'
      +'<b style="font-size:12.5px;color:'+col+'">'+_esc(codigo)+'</b>'
      +'<span style="font-size:12.5px;flex:1;min-width:120px">'+_esc(nombre)+'</span>'
      +(function(){
          var d=(g.prov&&g.prov._dept)||(g.items[0]&&g.items[0]._dept)||'';
          if(!d) return '';
          return '<span style="font-size:10px;font-weight:700;background:var(--surface-0);'
            +'border:0.5px solid var(--border);border-radius:10px;padding:1px 8px;color:var(--t-marron)">'
            +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</span>';
        })()
      +(g.items.length ? _catBtnProv(g.cardcode||k) : '')
      +(esProvNuevo?'<span class="cat-nuevo">proveedor nuevo</span>':'<span style="font-size:10px;color:var(--text-muted)">proveedor ya en SAP</span>')
      +'<span style="font-size:10.5px;font-weight:700;color:'+col+';background:var(--surface-0);border-radius:10px;padding:1px 9px">'+g.items.length+' SKU</span>'
      +'</div>';
    if(g.items.length){
      h+='<div id="'+gid+'" style="padding:2px 0;display:'+(abierto?'block':'none')+'">';
      g.items.forEach(function(it){
        h+='<div style="display:flex;align-items:center;gap:9px;padding:7px 12px;border-top:0.5px solid var(--border)">'
          +(function(){
              // La foto puede estar en la ficha, en el enlace o en memoria
              var _f=it.foto || it.foto_url
                || _fotoNoSapDeSku(it.itemcode) || '';
              return _f
                ? ('<img src="'+_esc(_f)+'" style="width:34px;height:34px;object-fit:cover;'
                   +'border-radius:6px;border:0.5px solid var(--border)" '
                   +'onerror="this.outerHTML=\'<div style=&quot;width:34px;height:34px;border-radius:6px;'
                   +'background:var(--surface-1)&quot;></div>\'">')
                : '';
            })()
          +((it.foto||it.foto_url||_fotoNoSapDeSku(it.itemcode))?''
                   :'<div style="width:34px;height:34px;border-radius:6px;background:var(--surface-1);display:flex;align-items:center;justify-content:center"><i class="ti ti-photo-off" style="color:var(--text-muted);font-size:14px"></i></div>')
          +'<div style="flex:1;min-width:0">'
            +'<div style="font-size:12px;font-weight:600"><span class="cat-sku">'+_esc(it.itemcode||'')+'</span> '+_esc(it.itemname||'')+'</div>'
            // La ficha técnica que leyó la AI, para ver qué tiene el catálogo
            +(function(){
                var d=[];
                if(it.material) d.push(['Material', it.material]);
                if(it.color)    d.push(['Color', it.color]);
                if(it.tamano)   d.push(['Medida', it.tamano]);
                if(it.empaque)  d.push(['Empaque', it.empaque]);
                if(it.unidades_x_caja) d.push(['Pzs/caja', it.unidades_x_caja]);
                if(!d.length) return '';
                return '<div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:3px">'
                  +d.map(function(p){
                      return '<span style="font-size:9.5px;background:var(--surface-1);'
                        +'border-radius:9px;padding:1px 7px;color:var(--text-secondary)" '
                        +'title="'+_esc(p[0])+'">'+_esc(String(p[1]).replace(/\n/g,' ').slice(0,34))+'</span>';
                    }).join('')
                  +'</div>';
              })()
            +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'
              +(it.dkc_origen?('Orden '+_esc(it.dkc_origen)+' · '):'')
              +(it.cantidad?(Number(it.cantidad).toLocaleString('en-US')+' pcs · '):'')
              +(it.precio?(fmt(it.precio)+' c/u'):'')
              +(it.colores?(' · '+_esc(it.colores)):'')
            +'</div>'
          +'</div>'
          +'<button class="btn bg2" style="padding:4px 8px;font-size:10.5px;color:var(--text-danger)" onclick="_catNoSapBorrar('+it.id+')"><i class="ti ti-trash"></i></button>'
          +'</div>';
      });
      h+='</div>';
    }
    // El pie sale siempre que haya algo que borrar en bloque. Antes solo
    // aparecía con proveedor nuevo, así que los SKU de un proveedor que ya
    // estaba en SAP había que borrarlos de uno en uno.
    if(esProvNuevo || g.items.length){
      var _cod=_esc(String(codigo).replace(/\\/g,''));
      h+='<div id="'+gid+'-pie" style="padding:7px 12px;border-top:0.5px solid var(--border);display:'+(abierto?'flex':'none')+';justify-content:flex-end;gap:6px;flex-wrap:wrap">'
        +((_esGerencia() && g.items.length)?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger);font-weight:600" onclick="event.stopPropagation();_gerBorrarSkuDeProveedor(\''+_cod+'\')"><i class="ti ti-trash"></i> Quitar los '+g.items.length+' SKU</button>'):'')
        +((_esGerencia() && esProvNuevo)?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger);font-weight:600" onclick="event.stopPropagation();_gerBorrarProveedorNoSap(\''+_cod+'\')"><i class="ti ti-trash"></i> Borrar proveedor y sus '+g.items.length+' SKU</button>'):'')
        +(esProvNuevo?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_catNoSapBorrar('+g.prov.id+')"><i class="ti ti-trash"></i> Quitar solo el proveedor</button>'):'')
        +'</div>';
    }
    h+='</div>';
  });
  box.innerHTML=h;
  _catNoSapBadge();   // el numerito rojo tiene que seguir a la lista
}

// Plegar y desplegar los SKU de un proveedor. Se arranca contraído para que
// un proveedor con 100 items nuevos no ocupe toda la pantalla.
window._catAbiertos=window._catAbiertos||{};
function _catToggleProv(k){
  window._catAbiertos[k]=!window._catAbiertos[k];
  var gid='catg-'+String(k).replace(/[^A-Za-z0-9]/g,'');
  var cont=document.getElementById(gid);
  var chev=document.getElementById(gid+'-chev');
  var pie=document.getElementById(gid+'-pie');
  var ab=window._catAbiertos[k];
  if(cont) cont.style.display=ab?'block':'none';
  if(pie)  pie.style.display=ab?'flex':'none';
  if(chev) chev.style.transform='rotate('+(ab?'0':'-90')+'deg)';
}
function _catTodos(abrir){
  var claves=Object.keys(window._catGrupos||{});
  claves.forEach(function(k){ window._catAbiertos[k]=!!abrir; });
  rCatNoSap();
}

async function _catNoSapRevisar(){
  showT('Revisando contra SAP…');
  var n=await _catNoSapDepurar();
  var esp=(window._catEsperandoFoto||[]).length;
  if(n && esp)      showT('✓ '+n+' ficha(s) quitadas · '+esp+' se conservan porque su SKU en SAP todavía no tiene foto', 7000);
  else if(n)        showT('✓ '+n+' ficha(s) ya están en SAP y se quitaron');
  else if(esp)      showT(esp+' ficha(s) ya están en SAP pero sin foto: se conservan hasta que la carguen', 7000);
  else              showT('Ninguna está todavía en SAP');
  rCatNoSap();
}

async function _catNoSapBorrar(id){
  var f0=(window._catNoSap||[]).find(function(f){ return String(f.id)===String(id); });
  var esProv=f0 && f0.tipo==='proveedor';
  var nSku=esProv?_catItemsDeProveedor(f0.cardcode).length:0;
  var quees=f0?(esProv?('el proveedor "'+(f0.cardcode||'')+' — '+(f0.cardname||'')+'"'):('el SKU "'+(f0.itemcode||'')+' — '+(f0.itemname||'')+'"')):'esta ficha temporal';
  var msg='¿Está seguro de que desea borrar '+quees+'?';
  if(esProv && nSku) msg+='\n\nOJO: este proveedor tiene '+nSku+' SKU asociado(s), que quedarán listados sin proveedor nuevo.';
  msg+='\n\nSe quita solo de este sistema, no afecta a SAP.';
  if(!confirm(msg)) return;
  try{
    var r=await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(!r.ok){ showT('No se pudo eliminar'); return; }
    window._catNoSap=(window._catNoSap||[]).filter(function(f){ return String(f.id)!==String(id); });
    _catNoSapBadge();
    showT('Ficha eliminada');
    rCatNoSap();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// Bloque de SKUs temporales de un proveedor, para verlos dentro de su ficha
function _catBloqueProveedor(code){
  var its=_catItemsDeProveedor(code);
  var provNuevo=_catEsProveedorNuevo(code);
  if(!its.length && !provNuevo) return '';
  var h='<div style="border:1px solid #C4B5FD;background:#F7F5FF;border-radius:10px;padding:11px 13px;margin-bottom:14px">';
  h+='<div style="font-size:12px;font-weight:700;color:var(--t-lila);margin-bottom:'+(its.length?'7px':'0')+'">'
    +'<i class="ti ti-tags"></i> '+(provNuevo?'Proveedor nuevo':'')+(provNuevo&&its.length?' · ':'')
    +(its.length?(its.length+' SKU todavía no están en SAP'):'todavía no está en SAP')+'</div>';
  if(provNuevo && !its.length){
    h+='<div style="font-size:11px;color:var(--t-lila)">Se creó desde una orden BORRADOR. Desaparece de aquí en cuanto exista en SAP.</div>';
  }
  its.forEach(function(it){
    h+='<div style="display:flex;align-items:center;gap:8px;padding:6px 0;border-top:0.5px solid #DDD6FE">'
      +'<span class="cat-sku">'+_esc(it.itemcode||'')+'</span>'
      +'<span style="flex:1;min-width:0;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(it.itemname||'')+'</span>'
      +(((window._catEsperandoFoto||[]).indexOf(it.itemcode)>=0)
        ? ('<span title="Ya existe en SAP, pero todavía sin foto: la ficha se '
           +'conserva porque guarda la única imagen que hay" '
           +'style="font-size:9px;font-weight:700;background:#FEF3C7;color:var(--t-marron);'
           +'border-radius:7px;padding:1px 6px;flex-shrink:0">EN SAP · SIN FOTO</span>')
        : '')
      +'<span style="font-size:11px;color:var(--text-muted);flex-shrink:0">'
        +(it.cantidad?(Number(it.cantidad).toLocaleString('en-US')+' pcs'):'')
        +(it.precio?(' · '+fmt(it.precio)):'')+'</span>'
      +'</div>';
  });
  h+='<div style="font-size:10px;color:var(--t-lila);margin-top:6px;opacity:.85">Se quitan solos cuando el mismo código exista en SAP.</div>';
  h+='</div>';
  return h;
}

// Contador en el menú de lo que falta crear en SAP
function _catNoSapBadge(){
  var el=document.getElementById('nbNumCat'); if(!el) return;
  // Se cuentan solo las fichas vivas: ni las degradadas a foto ni las de
  // artículos que ya existen en SAP, que no hay que dar de alta.
  var _vivas=(window._catNoSap||[]).filter(function(f){
    return f.tipo==='proveedor' ? true : _catFichaViva(f);
  });
  var n=_vivas.length;
  if(CU&& _deptAcotado()) n=_vivas.filter(function(f){ return !f.dept||_deptPermitido(f.dept); }).length;
  if(n>0){ el.textContent=(n>99?'99+':String(n)); el.style.display='block'; el.title=n+' ficha(s) pendientes de crearse en SAP'; }
  else { el.textContent=''; el.style.display='none'; }
}
function _catNoSapIniciar(){
  try{ _margenHistCargar(); }catch(e){}
  _catNoSapCargar(true).then(_catNoSapBadge).catch(function(){});
}

// ═══════════════════════════════════════════════════════════════════════════
//  CONSULTA DE INVENTARIO
//  Listado de todos los items con scroll infinito, zoom de foto al pasar el
//  mouse y ficha técnica al hacer clic. Desde la ficha se puede saltar al
//  proveedor y arrancar una reposición con él ya cargado.
// ═══════════════════════════════════════════════════════════════════════════
var _invRows=[];            // lo que se ha traído hasta ahora
var _invOffset=0;
var _invTanda=60;
var _invFin=false;
var _invCargando=false;
var _invQ='';
var _invOrden='fechaentrada.desc.nullslast';   // lo más nuevo primero
var _invDept='todos';
var _invBuscarTimer=null;

var _INV_CAMPOS='itemcode,itemname,frgnname,onhand,iscommited,onorder,disponible,'
  +'prox_llegada,ultima_llegada,ordenes_abiertas,'
  +'precioventa,fob,cif,picturname,cardcode,nombre_proveedor,marca,grupo,subg,'
  +'peso,volumen,unidadesbulto,salpackun,codebars,usertext,caracteristicas,'
  +'u_color,u_tamano,lastpurprc,avgprice,u_cant_ult_ent,hist_comprado,fechaentrada';

// Una columna de la cabecera que ordena al pulsarla. Alterna entre mayor a
// menor y menor a mayor, y muestra la flecha del sentido activo.
// La fecha en que llega lo pendiente. Sin fecha, el número solo no dice
// si la mercancía llega la semana que viene o en tres meses.
// Comprueba si las fechas de llegada ya están sincronizadas.
// Se escribe _verFechas() en la consola del navegador (F12).
// Revisa una vez si las fechas están cargadas y lo dice en pantalla
async function _invChequearFechas(){
  var box=document.getElementById('invFechasAviso');
  if(!box) return;
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,prox_llegada'
      +'&onorder=gt.0&limit=40',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(/prox_llegada/.test(t)){
        box.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;'
          +'padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-rojo)">'
          +'<i class="ti ti-alert-triangle"></i> <b>Falta la columna de fechas de llegada.</b> '
          +'Hay que correr el script <code>llegadas.sql</code> en Supabase.</div>';
      }
      return;
    }
    var filas=await r.json()||[];
    if(!filas.length){ box.innerHTML=''; return; }
    var con=filas.filter(function(f){ return f.prox_llegada; }).length;
    if(con){ box.innerHTML=''; return; }     // todo bien, no molesta
    box.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;'
      +'padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-clock"></i> Las fechas de llegada todavía no se sincronizaron. '
      +'Aparecerán en cuanto el worker corra la próxima sincronización de inventario.</div>';
  }catch(e){}
}

async function _verFechas(){
  try{
    var url=SB+'/rest/v1/inventario?select=itemcode,onorder,prox_llegada,ordenes_abiertas'
      +'&onorder=gt.0&order=onorder.desc&limit=15';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(/prox_llegada/.test(t) && /does not exist|column/i.test(t)){
        console.log('%c FALTA LA COLUMNA ','background:#dc2626;color:#fff;font-weight:700');
        console.log('Hay que correr el script llegadas.sql en Supabase.');
      } else {
        console.log('Error '+r.status+': '+t.slice(0,200));
      }
      return;
    }
    var filas=await r.json()||[];
    if(!filas.length){
      console.log('No hay artículos con cantidad por llegar.');
      return;
    }
    var con=filas.filter(function(f){ return f.prox_llegada; }).length;
    console.log('%c FECHAS DE LLEGADA ','background:#0c447c;color:#fff;font-weight:700');
    console.log(con+' de '+filas.length+' artículos revisados tienen fecha.');
    if(!con){
      console.log('La columna existe pero está vacía: falta reiniciar el worker '
        +'y esperar a que sincronice el inventario.');
    }
    console.table(filas.map(function(f){
      return {SKU:f.itemcode, 'Por llegar':f.onorder,
              'Llega el':f.prox_llegada||'(sin fecha)',
              'Órdenes':f.ordenes_abiertas||0};
    }));
  }catch(e){ console.log('No se pudo consultar:', e.message||e); }
}

function _invLlegadaTxt(x){
  var f=(x&&(x.prox_llegada||x.ultima_llegada))||'';
  if(!f) return '';
  var d=_repParseFecha(f);
  var txt=_fmtFechaCorta(f);
  if(!d) return txt;
  var dias=Math.round((d.getTime()-Date.now())/86400000);
  return txt+(dias<0 ? ' · vencida'
            : (dias===0 ? ' · hoy'
            : (dias<=30 ? (' · en '+dias+'d') : '')));
}

function _invLlegadaColor(x){
  var f=(x&&(x.prox_llegada||x.ultima_llegada))||'';
  var d=f?_repParseFecha(f):null;
  if(!d) return 'var(--text-muted)';
  var dias=Math.round((d.getTime()-Date.now())/86400000);
  if(dias<0)  return '#991b1b';     // debía haber llegado
  if(dias<=15) return '#166534';    // ya viene en camino
  return '#B45309';
}

function _invColOrden(titulo, campo, clase, estilo){
  var act=String(_invOrden||'');
  var esta=(act.indexOf(campo+'.')===0);
  var desc=esta && act.indexOf('.desc')>0;
  var flecha=esta ? (desc?' ▼':' ▲') : '';
  return '<div class="inv-num'+(clase?(' '+clase):'')+'"'
    +(estilo?(' style="'+estilo+';cursor:pointer;user-select:none"'):' style="cursor:pointer;user-select:none"')
    +' onclick="_invOrdenarPor(\''+campo+'\')"'
    +' title="Pulsa para ordenar por '+_esc(titulo)+'">'
    +'<span'+(esta?' style="color:var(--text-accent);font-weight:700"':'')+'>'
    +_esc(titulo)+flecha+'</span></div>';
}

// Alterna el sentido y recarga
function _invOrdenarPor(campo){
  var act=String(_invOrden||'');
  var esta=(act.indexOf(campo+'.')===0);
  var desc=esta && act.indexOf('.desc')>0;
  // La primera vez, de mayor a menor: es lo que se suele querer ver
  var nuevo = esta ? (desc ? (campo+'.asc.nullslast') : (campo+'.desc.nullslast'))
                   : (campo+'.desc.nullslast');
  // El desplegable de arriba refleja el orden elegido
  var sel=document.querySelector('select[onchange^="_invSetOrden"]');
  if(sel){
    if(!Array.prototype.some.call(sel.options, function(o){ return o.value===nuevo; })){
      var op=document.createElement('option');
      op.value=nuevo;
      op.textContent=(_INV_ORDENES[nuevo]||_invNombreOrden(campo, nuevo.indexOf('.desc')>0));
      sel.appendChild(op);
    }
    sel.value=nuevo;
  }
  _invSetOrden(nuevo);
  // Se repinta la cabecera para mover la flecha
  setTimeout(function(){
    var hdr=document.querySelector('.inv-hdr');
    if(!hdr) return;
    var cols=hdr.querySelectorAll('.inv-num');
    var defs=[['Existencia','onhand'],['Reservado','iscommited'],['Disponible','disponible'],
              ['Por llegar','onorder'],['Precio venta','precioventa']];
    // (la última columna es el ganchito del catálogo, sin orden)
    for(var i=0;i<cols.length && i<defs.length;i++){
      var esta=(String(_invOrden||'').indexOf(defs[i][1]+'.')===0);
      var desc=esta && String(_invOrden).indexOf('.desc')>0;
      cols[i].innerHTML='<span'+(esta?' style="color:var(--text-accent);font-weight:700"':'')+'>'
        +defs[i][0]+(esta?(desc?' ▼':' ▲'):'')+'</span>';
    }
  }, 30);
}

function _invNombreOrden(campo, desc){
  var n={onhand:'Existencia', iscommited:'Reservado', disponible:'Disponible',
         onorder:'Por llegar', precioventa:'Precio venta'}[campo]||campo;
  return n+(desc?'  mayor primero':'  menor primero');
}

var _INV_ORDENES={
  'fechaentrada.desc.nullslast': 'Más nueva primero',
  'fechaentrada.asc.nullslast':  'Más vieja primero',
  'itemcode.asc':   'SKU  A → Z',
  'itemcode.desc':  'SKU  Z → A',
  'itemname.asc':   'Descripción  A → Z',
  'onhand.desc':    'Más stock primero',
  'onhand.asc':     'Menos stock primero',
  'onorder.desc':   'Más por llegar primero',
  'precioventa.desc':'Precio venta  mayor primero'
};

// Departamentos del inventario. El valor es el trozo que se busca dentro del
// campo `grupo` de SAP (que llega como "..Hogar", "Home Deco", etc.).
var _INV_DEPTS=[
  {k:'todos',       l:'Todos',       p:''},
  {k:'hogar',       l:'Hogar',       p:'hogar'},
  {k:'muebles',     l:'Muebles',     p:'mueble'},
  {k:'alfombras',   l:'Alfombras',   p:'alfombra'},
  {k:'ropa',        l:'Ropa',        p:'ropa'},
  {k:'homedeco',    l:'Home Deco',   p:'deco'},
  {k:'campamento',  l:'Campamento',  p:'campamento'},
  {k:'electronica', l:'Electrónica', p:'electr'}
];
function _invDeptPatron(k){
  var d=_INV_DEPTS.find(function(x){ return x.k===k; });
  return d?d.p:'';
}

function _invNum(v){ return Number(v)||0; }
function _invDisp(x){
  if(x.disponible!=null && x.disponible!=='') return _invNum(x.disponible);
  return _invNum(x.onhand)-_invNum(x.iscommited);
}

// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO POR CORREO
//  El archivo generado se manda adjunto usando la misma cola de correos que
//  el resto del portal (correos_queue), así que sale con el remitente y las
//  reglas de siempre. Se usa desde todos los sitios donde se arma un catálogo.
// ═══════════════════════════════════════════════════════════════════════════

// El PDF/Excel se convierte a base64, que es como viajan los adjuntos
function _catBlobBase64(blob){
  return new Promise(function(res, rej){
    var fr=new FileReader();
    fr.onload=function(){
      var s=String(fr.result||'');
      res(s.slice(s.indexOf(',')+1));      // se quita el "data:...;base64,"
    };
    fr.onerror=function(){ rej(new Error('no se pudo leer el archivo')); };
    fr.readAsDataURL(blob);
  });
}

// archivos: [{nombre, blob, mime}]
// opciones = {para, cuerpo}: sirve para abrir el correo ya encaminado, como
// en las instrucciones de shipping mark, que van dirigidas al proveedor.
async function _catMailAbrir(archivos, titulo, opciones){
  opciones=opciones||{};
  archivos=(archivos||[]).filter(function(a){ return a && a.blob; });
  if(!archivos.length){ showT('No hay ningún archivo que enviar'); return; }

  // Los adjuntos se guardan como archivos vivos: así se pueden agregar más
  // o quitar alguno antes de enviar, y el peso se recalcula solo.
  window._catMailArch=archivos.map(function(a){
    return {nombre:a.nombre, blob:a.blob,
            mime:a.mime||a.blob.type||'application/octet-stream',
            url:URL.createObjectURL(a.blob)};
  });
  window._catMailRef=String(opciones.ref||'');       // orden donde se guardarán
  var limite=(typeof MAIL_MAX_MB!=='undefined')?MAIL_MAX_MB:20;

  var prev=document.getElementById('modalCatMail'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCatMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13700;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';

  var chips=(typeof USERS!=='undefined'?USERS:[])
    .filter(function(u){ return u && u.email; })
    .map(function(u){
      return '<span onclick="_catMailAgregar(\'' + '' + '\')" data-mail="'+_esc(u.email)+'" '
        +'class="cat-mail-chip" style="cursor:pointer;font-size:10.5px;background:var(--surface-1);'
        +'border:0.5px solid var(--border);border-radius:12px;padding:3px 9px;'
        +'color:var(--text-secondary)">'+_esc(u.name||u.email)+'</span>';
    }).join('');

  ov.innerHTML='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:620px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">'
      +'<div style="font-size:14px;font-weight:700"><i class="ti ti-mail"></i> Enviar el catálogo por correo</div>'
      +'<button onclick="document.getElementById(\'modalCatMail\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">'
      +'<span style="font-size:10px;font-weight:700;color:var(--text-muted);'
        +'text-transform:uppercase;letter-spacing:.4px">Se adjunta</span>'
      +'<label style="cursor:pointer;font-size:10.5px;color:var(--text-accent);'
        +'border:0.5px dashed var(--border-accent);border-radius:7px;padding:2px 9px">'
        +'<i class="ti ti-paperclip"></i> Agregar archivo'
        +'<input type="file" multiple style="display:none" '
        +'onchange="_catMailAdjuntarArchivos(this)"></label>'
    +'</div>'
    +'<div id="catmail-adj"></div>'

    +'<div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;'
      +'letter-spacing:.4px;margin-bottom:4px">Del equipo (clic para agregar)</div>'
    +'<div style="display:flex;gap:5px;flex-wrap:wrap;max-height:96px;overflow-y:auto;margin-bottom:10px">'
      +chips+'</div>'

    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">Para (uno o varios, separados por coma)</label>'
    +'<textarea id="catmail-para" rows="2" placeholder="cliente@ejemplo.com, otro@ejemplo.com" '
      +'data-pre="'+_esc(opciones.para||'')+'" '
      +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin:3px 0 10px;font-family:var(--font-sans);resize:vertical"></textarea>'

    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">Asunto</label>'
    +'<input id="catmail-asunto" value="'+_esc(titulo||'Catálogo')+'" '
      +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin:3px 0 10px">'

    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">Mensaje</label>'
    +'<textarea id="catmail-cuerpo" rows="5" style="width:100%;padding:9px 11px;'
      +'border:1px solid var(--border);border-radius:8px;font-size:12.5px;margin:3px 0 4px;'
      +'font-family:var(--font-sans);resize:vertical">'
      +_esc(opciones.cuerpo || ('Buen día,\n\nAdjunto el catálogo.\n\nSaludos,\n'
        +((typeof CU!=='undefined'&&CU.name)||'')+'\nKENNEDY CENTER CORP.'))+'</textarea>'

    +'<div id="catmail-msg" style="font-size:11.5px;margin:6px 0;min-height:16px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalCatMail\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="catmail-btn" onclick="_catMailEnviar()">'
        +'<i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';

  // A propósito NO se cierra al hacer clic fuera: se perdía el texto escrito
  // y los adjuntos ya preparados. Solo con Cancelar, con la × o al enviar.
  document.body.appendChild(ov);
  // Los chips agregan su dirección al campo
  ov.querySelectorAll('.cat-mail-chip').forEach(function(el){
    el.onclick=function(){ _catMailAgregar(el.getAttribute('data-mail')); };
  });
  // El destinatario que venga dado (el proveedor, por ejemplo)
  var _pa=document.getElementById('catmail-para');
  if(_pa && _pa.getAttribute('data-pre')) _pa.value=_pa.getAttribute('data-pre');
  _catMailPintarAdj();
  try{ _modalEsc(ov); }catch(e){}
}

// Pinta la lista de adjuntos con su peso y el aviso si se pasa del límite
function _catMailPintarAdj(){
  var d=document.getElementById('catmail-adj'); if(!d) return;
  var lista=(window._catMailArch||[]);
  var limite=(typeof MAIL_AVISO_MB!=='undefined')?MAIL_AVISO_MB:3;
  var kb=lista.reduce(function(a,x){ return a+Math.round((x.blob.size||0)/1024); },0);
  var mb=kb/1024;

  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:4px">';
  lista.forEach(function(a,i){
    var ext=String(a.nombre).split('.').pop().toLowerCase();
    var ico=(ext==='pdf')?'ti-file-type-pdf'
           :(['xlsx','xls','csv'].indexOf(ext)>=0)?'ti-file-spreadsheet'
           :(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0)?'ti-photo':'ti-file';
    var p=Math.round((a.blob.size||0)/1024);
    h+='<span style="display:inline-flex;align-items:center;gap:6px;padding:6px 8px 6px 11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:11.5px;max-width:330px">'
      +'<a href="'+a.url+'" target="_blank" rel="noopener" title="Abrir para revisarlo antes de enviar" '
        +'style="display:inline-flex;align-items:center;gap:7px;color:var(--text-accent);'
        +'text-decoration:none;overflow:hidden">'
        +'<i class="ti '+ico+'" style="font-size:16px"></i>'
        +'<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.nombre)+'</span>'
        +'<span style="color:var(--text-muted);font-size:10px;white-space:nowrap">'
        +(p<1024?(p+' KB'):((p/1024).toFixed(1)+' MB'))+'</span></a>'
      +'<button onclick="_catMailQuitarAdj('+i+')" title="Quitar este adjunto" '
        +'style="background:none;border:0;color:var(--text-muted);cursor:pointer;'
        +'font-size:15px;line-height:1;padding:0 2px">&times;</button>'
      +'</span>';
  });
  h+='</div><div style="font-size:10.5px;color:var(--text-muted);margin-bottom:12px">'
    +lista.length+' archivo(s) · '+(mb<1?(kb+' KB'):(mb.toFixed(1)+' MB'))
    +' · clic para abrirlos antes de enviar'
    +(mb>limite?(' · <b style="color:var(--t-ambar)">son más de '+limite+' MB: Outlook puede '
      +'rechazarlo, pero se intenta igual</b>'):'')
    +'</div>';
  d.innerHTML=h;
}

// Agrega archivos elegidos por la persona (logo, fotos, instrucciones…)
function _catMailAdjuntarArchivos(input){
  var fs=input && input.files ? Array.prototype.slice.call(input.files) : [];
  if(!fs.length) return;
  if(!window._catMailArch) window._catMailArch=[];
  fs.forEach(function(f){
    window._catMailArch.push({
      nombre:f.name, blob:f, mime:f.type||'application/octet-stream',
      url:URL.createObjectURL(f)
    });
  });
  input.value='';
  _catMailPintarAdj();
  showT(fs.length+' archivo(s) agregado(s)');
}

function _catMailQuitarAdj(i){
  var l=(window._catMailArch||[]);
  if(i<0 || i>=l.length) return;
  if(l.length===1){ showT('Tiene que quedar al menos un adjunto'); return; }
  l.splice(i,1);
  _catMailPintarAdj();
}

function _catMailAgregar(email){
  var t=document.getElementById('catmail-para'); if(!t || !email) return;
  var actual=String(t.value||'').split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  if(actual.indexOf(email)>=0) return;      // ya estaba
  actual.push(email);
  t.value=actual.join(', ');
}

function _catMailMsg(txt, tipo){
  var d=document.getElementById('catmail-msg'); if(!d) return;
  var c=(tipo==='err')?'var(--text-danger)':(tipo==='ok'?'var(--text-success)':'var(--text-muted)');
  d.innerHTML='<span style="color:'+c+'">'+txt+'</span>';
}

async function _catMailEnviar(){
  var para=String(((document.getElementById('catmail-para')||{}).value)||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  if(!para.length){ _catMailMsg('Poné al menos un destinatario.','err'); return; }
  var malos=para.filter(function(x){ return !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(x); });
  if(malos.length){ _catMailMsg('Dirección no válida: '+_esc(malos[0]),'err'); return; }

  var asunto=String(((document.getElementById('catmail-asunto')||{}).value)||'').trim();
  if(!asunto){ _catMailMsg('Escribe un asunto.','err'); return; }
  var cuerpo=String(((document.getElementById('catmail-cuerpo')||{}).value)||'');

  var btn=document.getElementById('catmail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  _catMailMsg('','info');

  // Los adjuntos se convierten ahora, para que entren también los que se
  // hayan agregado a mano después de abrir la ventana.
  var lista=(window._catMailArch||[]);
  if(!lista.length){ _catMailMsg('No hay ningún adjunto.','err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; } return; }
  _catMailMsg('Preparando '+lista.length+' adjunto(s)…','info');
  var adj=[];
  for(var i=0;i<lista.length;i++){
    try{
      var b64=await _catBlobBase64(lista[i].blob);
      adj.push({nombre:lista[i].nombre, contenido:b64, mime:lista[i].mime});
    }catch(e){ console.warn('[correo] adjunto:', e); }
  }
  if(!adj.length){ _catMailMsg('No se pudieron preparar los adjuntos.','err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; } return; }
  window._catMailAdj=adj;

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(window._catMailRef||'catalogo'),
        para_lista:para, para_email:para[0],
        asunto:asunto, cuerpo:cuerpo,
        adjuntos:(window._catMailAdj||[]),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Catálogo', estado:'pendiente'
      })
    });
    if(!r.ok){
      var t=await r.text();
      _catMailMsg('No se pudo enviar: '+_esc(t.slice(0,180)),'err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
    _catMailMsg('✓ En cola. Sale en unos segundos, cuando el worker lo procese.','ok');
    showT('✓ Enviado a '+para.length+' destinatario(s)');
    // Los adjuntos quedan guardados en la orden, para poder revisarlos
    // después: lo que se le mandó al proveedor no debe perderse.
    try{ await _catMailGuardarEnOrden(); }catch(e){ console.warn('[correo] guardar:', e); }
    setTimeout(function(){
      var m=document.getElementById('modalCatMail'); if(m) m.remove();
    }, 1600);
  }catch(e){
    _catMailMsg('Error de conexión: '+_esc(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
  }
}

// Guarda en la orden (SAP o NO SAP) todo lo que se acaba de enviar, en su
// propia etapa, para poder consultarlo en cualquier momento.
async function _catMailGuardarEnOrden(){
  var ref=String(window._catMailRef||'').trim();
  var lista=(window._catMailArch||[]);
  if(!ref || !lista.length) return;

  var k=ref+'shipping_mark';
  if(!window._atts) window._atts={};
  if(!window._atts[k]) window._atts[k]=[];

  var n=0, fallos=[];
  for(var i=0;i<lista.length;i++){
    try{
      var f=(lista[i].blob instanceof File)
        ? lista[i].blob
        : new File([lista[i].blob], lista[i].nombre, {type:lista[i].mime});
      var path=await _subirDocStorage(ref, 'shipping_mark', f);
      if(!path){ fallos.push(lista[i].nombre+' (no se pudo subir)'); continue; }
      // Si el registro falla, el archivo existe pero la orden no lo ve nunca:
      // por eso el error se muestra en vez de quedar solo en la consola.
      try{ await _registrarDoc(ref, 'shipping_mark', f, path); }
      catch(e){ fallos.push(lista[i].nombre+' (no se registró: '+(e.message||e)+')'); continue; }
      window._atts[k].push({
        name:lista[i].nombre,
        url:DOCS_BASE+path.split('/').map(encodeURIComponent).join('/')
      });
      n++;
    }catch(e){ console.warn('[correo] guardar adjunto:', e); }
  }
  if(n){
    try{ window._atts[k]=_dedupDocs(window._atts[k]); }catch(e){}
    showT('✓ '+n+' adjunto(s) guardados en la orden '+ref);
  }
  if(fallos.length){
    alert('El correo se envió, pero NO se pudieron guardar en la orden '+ref+':\n\n  \u00b7 '
      +fallos.join('\n  \u00b7 ')
      +'\n\nSe pueden volver a adjuntar a mano desde \"Ver / adjuntos\".');
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  SELECCIÓN DE ARTÍCULOS EN LA CONSULTA DE INVENTARIO
//  Un ganchito por fila para armar el catálogo con lo que se elija.
// ═══════════════════════════════════════════════════════════════════════════
window._invSel = window._invSel || {};

function _invSelMarcar(sku, on, ev){
  if(ev && ev.stopPropagation) ev.stopPropagation();
  sku=String(sku||'').toUpperCase();
  if(on) window._invSel[sku]=true; else delete window._invSel[sku];
  _invSelBadge();
  // Si se está viendo solo lo marcado, lo que se desmarca sale de la lista
  if(window._invSoloSel && !on){
    var sel=_invSelFilas();
    var b=document.getElementById('invBody');
    if(b){
      b.innerHTML='';
      if(sel.length) _invPintar(sel);
      else { window._invSoloSel=false; _invVerSoloSel(); _invVerSoloSel(); }
    }
    var mas=document.getElementById('invMas');
    if(mas && sel.length) mas.innerHTML='Mostrando solo los '+sel.length+' artículo(s) marcados';
  }
}

function _invSelBadge(){
  var n=Object.keys(window._invSel||{}).length;
  var b=document.getElementById('invSelN');
  if(b) b.textContent=n;
  var btn=document.getElementById('invSelBtn');
  if(btn){ btn.style.display=n?'inline-flex':'none'; }
}

function _invSelLimpiar(){
  window._invSel={};
  document.querySelectorAll('.inv-check').forEach(function(c){ c.checked=false; });
  if(window._invSoloSel) _invVerSoloSel();      // se sale del modo "solo marcados"
  _invSelBadge();
}

// Muestra únicamente los artículos marcados, para revisar la selección antes
// de generar el catálogo. Se vuelve a la lista completa con el mismo botón.
function _invVerSoloSel(){
  var b=document.getElementById('invBody'); if(!b) return;
  window._invSoloSel=!window._invSoloSel;

  var btn=document.getElementById('invVerSelBtn');
  var mas=document.getElementById('invMas');

  if(window._invSoloSel){
    var sel=_invSelFilas();
    if(!sel.length){
      window._invSoloSel=false;
      showT('No hay artículos marcados');
      return;
    }
    b.innerHTML=''; _invPintar(sel);
    if(btn){
      btn.innerHTML='<i class="ti ti-list"></i> Ver todos';
      btn.style.background='#EEEDFE'; btn.style.color='#3C3489'; btn.style.borderColor='#C7C3F5';
    }
    if(mas) mas.innerHTML='Mostrando solo los '+sel.length+' artículo(s) marcados';
  } else {
    b.innerHTML=''; _invPintar(_invRows||[]);
    if(btn){
      btn.innerHTML='<i class="ti ti-list-check"></i> Ver marcados';
      btn.style.background='var(--surface-1)'; btn.style.color='var(--text-secondary)';
      btn.style.borderColor='var(--border)';
    }
    if(mas) mas.innerHTML=_invFin
      ? (_invRows.length?('Fin del listado · '+_invRows.length+' artículos'):'')
      : 'Baja para cargar más…';
  }
}

// Los artículos elegidos, tomados de lo que está cargado en la tabla
function _invSelFilas(){
  var sel=window._invSel||{};
  return (_invRows||[]).filter(function(x){
    return sel[String(x.itemcode||'').toUpperCase()];
  });
}

// Un artículo del inventario con la forma de ficha del catálogo. A
// diferencia de _invIAFicha, esta SÍ se puede editar en la revisión: lleva el
// costo para calcular el margen y no trae la marca __sinEdit.
// ── Averiguar qué foto existe de verdad, antes de generar el catálogo ──
// SAP guarda el nombre del archivo con mayúsculas o con otra extensión que
// la del bucket. En pantalla eso se salva reintentando cuando la imagen
// falla, pero en el PDF no hay segunda oportunidad: si la URL está mal, el
// artículo sale sin foto. Aquí se prueban las variantes con antelación y se
// deja la que carga.
function _catFotoVariantes(pic){
  var base=String(pic||'').trim();
  if(!base) return [];
  var sinExt=base.replace(/\.[^.]+$/,'');
  var out=[];
  ['', '.jpg', '.JPG', '.jpeg', '.png', '.PNG', '.webp'].forEach(function(ext){
    var n = ext ? (sinExt+ext) : base;
    [n, n.toLowerCase(), n.toUpperCase()].forEach(function(v){
      var u=FOTO_BASE+encodeURIComponent(v);
      if(out.indexOf(u)<0) out.push(u);
    });
  });
  return out;
}

function _catProbarFoto(url){
  return new Promise(function(res){
    var im=new Image();
    var listo=false;
    var fin=function(ok){ if(!listo){ listo=true; res(ok?url:null); } };
    im.onload =function(){ fin(im.naturalWidth>0); };
    im.onerror=function(){ fin(false); };
    setTimeout(function(){ fin(false); }, 7000);   // que no se quede colgado
    im.src=url;
  });
}

async function _catResolverFotos(fichas){
  var pend=(fichas||[]).filter(function(f){ return f.__pic && !f.__fotoOk; });
  if(!pend.length) return 0;
  var arreglos=0, i=0;
  // De ocho en ocho: ni una a una (lento) ni todas de golpe (satura)
  async function unaTanda(){
    while(i<pend.length){
      var f=pend[i++];
      var alts=_catFotoVariantes(f.__pic);
      for(var k=0;k<alts.length;k++){
        var ok=await _catProbarFoto(alts[k]);
        if(ok){
          if(f.foto!==ok){ f.foto=ok; arreglos++; }
          f.__fotoOk=1;
          break;
        }
      }
      if(!f.__fotoOk && f.__fotoNoSap){    // último recurso: la del catálogo BORRADOR
        f.foto=f.__fotoNoSap; f.__fotoOk=1; arreglos++;
      }
    }
  }
  await Promise.all([unaTanda(),unaTanda(),unaTanda(),unaTanda(),
                     unaTanda(),unaTanda(),unaTanda(),unaTanda()]);
  var sin=pend.filter(function(f){ return !f.__fotoOk; }).length;
  console.log('[catálogo] fotos: '+arreglos+' corregida(s)'
    +(sin?(' · '+sin+' sin imagen en el bucket'):''));
  return arreglos;
}

function _invFichaCatalogo(x){
  // Orden de preferencia para el costo: última compra, promedio, CIF y FOB.
  // Sin costo, la casilla de margen no puede calcular el precio de venta, y
  // en artículos viejos lastpurprc suele venir en cero.
  var costo=Number(x.lastpurprc)||Number(x.avgprice)||Number(x.cif)||Number(x.fob)||0;
  return {
    tipo:'item',
    itemcode:x.itemcode||'',
    itemname:x.itemname||'',
    descripcion:x.itemname||x.frgnname||'',
    marca:x.marca||'',
    _dept:String(x.grupo||'').replace(/^[.\s]+/,''),
    material:'',
    color:x.u_color||'',
    tamano:x.u_tamano||'',
    medida:x.u_tamano||'',
    unidades_x_caja:x.unidadesbulto||x.salpackun||'',
    carton_size:'',
    peso:x.peso||'',
    cbm:x.volumen||'',
    barcode:x.codebars||'',
    precio:costo,                                  // costo, para el margen
    precio_venta:Number(x.precioventa)||0,
    disponible:_invDisp(x),
    foto:(x.foto || _repFotoUrl(x.picturname) || ''),
    __pic:(x.picturname||''),                       // para probar variantes
    __fotoNoSap:(function(){ try{ return _fotoNoSapDeSku(x.itemcode)||''; }catch(e){ return ''; } })(),
    __fotoOk:(x.foto?1:0)                           // la del catálogo BORRADOR ya vale
  };
}

// Igual que en las órdenes: primero la revisión, y desde ahí se genera o se
// envía. Así el precio de venta se puede ajustar antes de que salga.

// ══════════════════════════════════════════════════════════════════════
//  VENTAS POR DEPARTAMENTO  ·  solo gerencia
//  El año fiscal en curso hasta hoy, contra el mismo periodo del año
//  pasado. Sale de la consulta que gerencia ya usa en SAP: facturas menos
//  notas de crédito, con los cancelados invertidos.
// ══════════════════════════════════════════════════════════════════════
window._vtaDep      = window._vtaDep || null;
window._vtaDepVista = window._vtaDepVista || 'tabla';

async function _vtaDepCargar(forzar){
  if(window._vtaDep && window._vtaDep.length && !forzar) return window._vtaDep;
  window._vtaDepError=null;
  try{
    var r=await fetch(SB+'/rest/v1/ventas_departamento?select=*&order=monto.desc&limit=200',
      {headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      window._vtaDepError = r.status+' · '+t.slice(0,200);
      console.error('[ventas dept] '+r.status+': '+t.slice(0,300));
      window._vtaDep=[];
      return window._vtaDep;
    }
    window._vtaDep = await r.json() || [];
    console.log('[ventas dept] '+window._vtaDep.length+' fila(s) leídas');
  }catch(e){
    window._vtaDepError = e && e.message || String(e);
    console.error('[ventas dept]',e);
    window._vtaDep=window._vtaDep||[];
  }
  return window._vtaDep;
}

async function _vtaDepRecargar(){
  showT('Actualizando las ventas…');
  window._vtaDep=null; window._vtaDepError=null; window._vtaDepReintento=0;
  await _vtaDepCargar(true);
  try{ rDash(); }catch(e){}
}

function _vtaDepSetVista(v){ window._vtaDepVista=v; try{ rDash(); }catch(e){} }

// La variación contra el año pasado, en color
function _vtaDepVar(actual, previo){
  var a=Number(actual)||0, p=Number(previo)||0;
  if(!p) return '<span style="color:var(--text-muted)">—</span>';
  var pct=(a-p)/Math.abs(p)*100;
  var col = pct>=0 ? '#166534' : '#b91c1c';
  var ic  = pct>=0 ? '▲' : '▼';
  return '<span style="color:'+col+';font-weight:700;white-space:nowrap">'
    +ic+' '+Math.abs(pct).toFixed(1)+'%</span>';
}

function _vtaDepPanel(){
  if(!CU || CU.role!=='gerencia') return '';
  if(window._vtaDep===null || (!window._vtaDep.length && !window._vtaDepError
                               && !window._vtaDepReintento)){
    if(window._vtaDep!==null) window._vtaDepReintento=1;
    _vtaDepCargar(true).then(function(){ try{ rDash(); }catch(e){} });
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-trending-up"></i>'
      +'Ventas por departamento</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +'Calculando…</div>';
  }

  var filas=window._vtaDep||[];
  if(!filas.length){
    var err=window._vtaDepError;
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-trending-up"></i>'
      +'Ventas por departamento</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +(err ? ('<b style="color:var(--t-rojo3)">No se pudo leer la tabla</b><br>'
               +'<span style="font-size:11px">'+_esc(err)+'</span>')
            : ('Todavía no hay datos. '
               +'<button onclick="_vtaDepRecargar()" class="btn bg2" '
               +'style="padding:2px 9px;font-size:10.5px">Reintentar</button><br>'
               +'<span style="font-size:11px">Si el worker ya cargó filas, revisa la '
               +'política de lectura de <b>ventas_departamento</b>.</span>'))
      +'</div>';
  }

  // Solo departamentos con movimiento: los de todo a cero estorban
  filas=filas.filter(function(f){
    return (Number(f.monto)||0)!==0 || (Number(f.monto_prev)||0)!==0; });
  // Y acotado al departamento de quien mira, si lo tiene
  if(_deptAcotado()) filas=filas.filter(function(f){
    return _deptPermitido(normDept(f.grupo)); });

  var tot=filas.reduce(function(a,f){
    a.cant+=Number(f.cantidad)||0;   a.cantP+=Number(f.cantidad_prev)||0;
    a.monto+=Number(f.monto)||0;     a.montoP+=Number(f.monto_prev)||0;
    a.bruto+=Number(f.bruto)||0;     a.brutoP+=Number(f.bruto_prev)||0;
    return a;
  },{cant:0,cantP:0,monto:0,montoP:0,bruto:0,brutoP:0});

  var vista=window._vtaDepVista||'tabla';
  var btnV=function(k,t,ic){
    var on=(vista===k);
    return '<button onclick="_vtaDepSetVista(\''+k+'\')" class="btn '+(on?'bp':'bg2')+'" '
      +'style="padding:3px 11px;font-size:10.5px'+(on?';background:#0F6E56':'')+'">'
      +'<i class="ti '+ic+'"></i> '+t+'</button>';
  };

  // El periodo, para que se sepa qué se está comparando
  var per='';
  try{
    var d1=new Date(filas[0].desde), d2=new Date(filas[0].hasta);
    if(!isNaN(d1)&&!isNaN(d2)){
      per='Año fiscal desde el '+d1.toLocaleDateString('es')+' hasta hoy, '
        +'comparado con el mismo periodo del año pasado.';
    }
  }catch(e){}

  var h='<div class="slbl" style="margin-top:16px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
    +'<span><i class="ti ti-trending-up"></i>Ventas por departamento</span>'
    +'<span style="flex:1"></span>'
    +btnV('tabla','Tabla','ti-table')+btnV('grafica','Gráfica','ti-chart-pie')
    +'<button onclick="_vtaDepRecargar()" class="btn bg2" '
    +'style="padding:3px 10px;font-size:10.5px"><i class="ti ti-refresh"></i> Actualizar</button></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 8px">'+_esc(per)+'</div>';

  if(vista==='grafica'){
    var datos=filas.filter(function(f){ return (Number(f.monto)||0)>0; })
      .map(function(f){ return {nombre:_invValNombre(f.grupo), valor:Number(f.monto)||0}; });
    h+=_invValRueda(datos, datos.reduce(function(a,d){return a+d.valor;},0),
                    'VENTAS DEL AÑO FISCAL');
    return h;
  }

  var cuerpo=filas.map(function(f){
    var m=Number(f.monto)||0, b=Number(f.bruto)||0;
    var margen = m ? (b/m*100) : 0;
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:6px 9px"><b>'+_esc(_invValNombre(f.grupo))+'</b></td>'
      +'<td style="padding:6px 9px;text-align:right">'+_fmtN2(Math.round(Number(f.cantidad)||0))+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:#0F6E56">'+fmt(m)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--text-muted)">'+fmt(f.monto_prev)+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+_vtaDepVar(m, f.monto_prev)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--t-lila)">'+fmt(b)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600;color:'
        +(margen<15?'#b91c1c':'var(--text-primary)')+'">'+margen.toFixed(1)+'%</td>'
      +'</tr>';
  }).join('');

  var margenTot = tot.monto ? (tot.bruto/tot.monto*100) : 0;
  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:7px 9px;text-align:left;font-size:9.5px;text-transform:uppercase">Departamento</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Unidades</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Vendido</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Año pasado</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Variación</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Ganancia</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Margen</th>'
    +'</tr></thead><tbody>'+cuerpo+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td style="padding:8px 9px;font-weight:800">GRAN TOTAL</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+_fmtN2(Math.round(tot.cant))+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:#0F6E56">'+fmt(tot.monto)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;color:var(--text-muted)">'+fmt(tot.montoP)+'</td>'
      +'<td style="padding:8px 9px;text-align:right">'+_vtaDepVar(tot.monto, tot.montoP)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(tot.bruto)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+margenTot.toFixed(1)+'%</td>'
    +'</tr></tfoot></table></div>';
  return h;
}

// ══════════════════════════════════════════════════════════════════════
//  VALOR DEL INVENTARIO  ·  solo gerencia
//  Cuánto vale en dinero lo que hay hoy en existencias, por departamento y
//  por proveedor. Sale del "Pivote de Inventario" de SAP, que el worker
//  agrega y deja en la tabla inventario_valores.
//
//  Tres niveles: departamentos → proveedores de uno → artículos de uno.
//  Desde el último se arma un catálogo o cotización para el cliente.
// ══════════════════════════════════════════════════════════════════════

window._invVal      = window._invVal || null;   // filas de la tabla
window._invValDept  = null;                     // departamento abierto
window._invValCard  = null;                     // proveedor abierto

async function _invValCargar(forzar){
  // OJO: un array vacío también es "truthy". Si una carga anterior falló
  // —por ejemplo antes de crear la política de lectura— quedaba guardado
  // como [] y no se volvía a pedir nunca, aunque la tabla ya tuviera datos.
  if(window._invVal && window._invVal.length && !forzar) return window._invVal;
  window._invValError=null;
  try{
    var out=[], desde=0;
    while(true){
      var url=SB+'/rest/v1/inventario_valores?select=*&offset='+desde+'&limit=1000';
      var r=await fetch(url,{headers:SBH});
      if(!r.ok){
        var t=''; try{ t=await r.text(); }catch(e){}
        // "Vacío" y "no se pudo leer" son cosas distintas: si se confunden,
        // se busca el fallo donde no está.
        window._invValError = r.status+' · '+t.slice(0,200);
        console.error('[inv valor] '+r.status+' al leer inventario_valores: '+t.slice(0,300));
        break;
      }
      var lote=await r.json()||[];
      out=out.concat(lote);
      if(lote.length<1000) break;
      desde+=1000;
    }
    window._invVal=out;
    console.log('[inv valor] '+out.length+' fila(s) leídas de inventario_valores');
    if(!out.length && !window._invValError){
      console.warn('[inv valor] la consulta funcionó pero devolvió 0 filas. '
        +'Si el worker ya cargó datos, casi seguro es que falta la política de '
        +'lectura: la tabla tiene RLS activo y la clave anónima no ve nada.');
    }
  }catch(e){
    window._invValError = e && e.message || String(e);
    console.error('[inv valor]',e);
    window._invVal=window._invVal||[];
  }
  return window._invVal;
}

// Vuelve a pedir los datos, sin usar lo que hubiera guardado.
async function _invValRecargar(){
  showT('Actualizando el valor del inventario…');
  window._invVal=null; window._invValError=null; window._invValReintento=0;
  await _invValCargar(true);
  try{ rDash(); }catch(e){}
  var n=(window._invVal||[]).length;
  showT(n ? (n+' fila(s) cargadas') : 'Sigue sin devolver filas · mira la consola');
}

// ── La rueda de colores, como el pivote de SAP ──
// Se dibuja con SVG: nada de librerías, y así funciona también sin red.
window._invValVista = window._invValVista || 'tabla';

var INVVAL_COLORES = ['#5B21B6','#0F6E56','#B45309','#0c447c','#72243E','#3C3489',
                      '#D4537E','#7C3D12','#166534','#9D174D','#1D4ED8','#A16207',
                      '#0E7490','#4D7C0F','#6D28D9','#BE123C'];

function _invValRueda(datos, total, titulo){
  if(!total) return '';
  var R=118, CX=150, CY=140, ang=-Math.PI/2, partes='', leyenda='';
  datos.forEach(function(d, i){
    var frac=(d.valor||0)/total;
    if(frac<=0) return;
    var col=INVVAL_COLORES[i%INVVAL_COLORES.length];
    var fin=ang+frac*Math.PI*2;
    var x1=CX+R*Math.cos(ang),  y1=CY+R*Math.sin(ang);
    var x2=CX+R*Math.cos(fin),  y2=CY+R*Math.sin(fin);
    var grande = frac>0.5 ? 1 : 0;
    // Una porción del 100% no se puede dibujar con un arco: se usa un círculo
    if(frac>0.999){
      partes+='<circle cx="'+CX+'" cy="'+CY+'" r="'+R+'" fill="'+col+'"></circle>';
    } else {
      partes+='<path d="M '+CX+' '+CY+' L '+x1.toFixed(2)+' '+y1.toFixed(2)
        +' A '+R+' '+R+' 0 '+grande+' 1 '+x2.toFixed(2)+' '+y2.toFixed(2)+' Z" '
        +'fill="'+col+'" stroke="var(--surface-0)" stroke-width="1.5">'
        +'<title>'+_esc(d.nombre)+': '+fmt(d.valor)+' · '+(frac*100).toFixed(2)+'%</title>'
        +'</path>';
    }
    leyenda+='<div style="display:flex;align-items:center;gap:7px;padding:2px 0;font-size:11px'
      +(d.onclick?';cursor:pointer':'')+'"'+(d.onclick?(' onclick="'+d.onclick+'"'):'')+'>'
      +'<span style="width:11px;height:11px;border-radius:3px;background:'+col+';flex-shrink:0"></span>'
      +'<span style="flex:1">'+_esc(d.nombre)+'</span>'
      +'<b style="white-space:nowrap">'+(frac*100).toFixed(2)+'%</b>'
      +'<span style="color:var(--text-muted);white-space:nowrap;min-width:96px;text-align:right">'
      +fmt(d.valor)+'</span></div>';
    ang=fin;
  });

  return '<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:flex-start;'
    +'border:0.5px solid var(--border);border-radius:10px;padding:14px;background:var(--surface-0)">'
    +'<div style="flex-shrink:0"><div style="font-size:12px;font-weight:700;color:var(--t-azul);'
    +'text-align:center;margin-bottom:4px">'+_esc(titulo||'MONTO CIF')+'</div>'
    +'<svg viewBox="0 0 300 280" style="width:300px;max-width:100%;height:auto">'+partes
    +'<circle cx="'+CX+'" cy="'+CY+'" r="46" fill="var(--surface-0)"></circle>'
    +'<text x="'+CX+'" y="'+(CY-4)+'" text-anchor="middle" style="font-size:11px;'
    +'fill:var(--text-muted)">TOTAL</text>'
    +'<text x="'+CX+'" y="'+(CY+13)+'" text-anchor="middle" style="font-size:12.5px;'
    +'font-weight:700;fill:var(--text-primary)">'+_esc(fmt(total))+'</text>'
    +'</svg></div>'
    +'<div style="flex:1;min-width:280px">'+leyenda+'</div></div>';
}

function _invValSetVista(v){ window._invValVista=v; try{ rDash(); }catch(e){} }

function _invValSuma(filas){
  var t={cantidad:0, fob:0, cif:0, precio:0, promedio:0};
  (filas||[]).forEach(function(f){
    t.cantidad += Number(f.cantidad)||0;
    t.fob      += Number(f.fob)||0;
    t.cif      += Number(f.cif)||0;
    t.precio   += Number(f.precio)||0;
    t.promedio += Number(f.promedio)||0;
  });
  return t;
}

// El nombre del grupo de SAP viene con puntos: '..Hogar'
function _invValNombre(g){ return String(g||'').replace(/^\.+/,'').trim(); }

function _invValPanel(){
  if(!CU || CU.role!=='gerencia') return '';
  // Se pide cuando no hay nada, y también cuando lo guardado quedó vacío
  // sin error: eso pasa si la primera carga se hizo antes de que la tabla
  // tuviera datos o permisos. Antes solo se pedía con null, así que el
  // panel se quedaba clavado en el mensaje de vacío para siempre.
  // Lo pendiente por llegar se usa en las tarjetas de departamento: se pide
  // una vez y el tablero se repinta al llegar.
  if(window._ocPend===null && !window._ocPendPidiendo){
    window._ocPendPidiendo=1;
    _ocPendCargar(true).then(function(){ try{ rDash(); }catch(e){} });
  }
  if(window._invVal===null || (!window._invVal.length && !window._invValError
                               && !window._invValReintento)){
    if(window._invVal!==null) window._invValReintento=1;   // solo una vez
    _invValCargar(true).then(function(){ try{ rDash(); }catch(e){} });
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-coin"></i>'
      +'Valor del inventario</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +'Calculando…</div>';
  }
  var filas=window._invVal||[];
  // Quien lleva un departamento ve solo el suyo: Gady alfombras, Henry ropa.
  if(_deptAcotado()) filas=filas.filter(function(f){
    return _deptPermitido(normDept(f.grupo)); });
  if(!filas.length){
    var err=window._invValError;
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-coin"></i>'
      +'Valor del inventario</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +(err
        ? ('<b style="color:var(--t-rojo3)">No se pudo leer la tabla</b><br>'
           +'<span style="font-size:11px">'+_esc(err)+'</span><br>'
           +'<span style="font-size:11px">Comprueba que exista <b>inventario_valores</b> '
           +'y que tenga política de lectura.</span>')
        : ('La tabla responde pero está vacía para el portal. '
           +'<button onclick="_invValRecargar()" class="btn bg2" '
           +'style="padding:2px 9px;font-size:10.5px"><i class="ti ti-refresh"></i> '
           +'Reintentar</button><br>'
           +'<span style="font-size:11px">Si el worker ya cargó filas (lo dice su log), '
           +'lo más probable es que falte la <b>política de lectura</b>: con RLS activo '
           +'y sin política, la clave del portal no ve nada. Está en el paso 2 de '
           +'crear_tabla_inventario_valores.sql.</span>'))
      +'</div>';
  }

  // Agrupar por departamento
  var porDept={};
  filas.forEach(function(f){
    var g=f.grupo||'(sin grupo)';
    (porDept[g]=porDept[g]||[]).push(f);
  });
  var deps=Object.keys(porDept).sort(function(a,b){
    return _invValSuma(porDept[b]).cif - _invValSuma(porDept[a]).cif;
  });
  var gran=_invValSuma(filas);

  var vista=window._invValVista||'tabla';
  var btnV=function(k,t,ic){
    var on=(vista===k);
    return '<button onclick="_invValSetVista(\''+k+'\')" class="btn '+(on?'bp':'bg2')+'" '
      +'style="padding:3px 11px;font-size:10.5px'+(on?';background:#5B21B6':'')+'">'
      +'<i class="ti '+ic+'"></i> '+t+'</button>';
  };
  var h='<div class="slbl" style="margin-top:16px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
    +'<span><i class="ti ti-coin"></i>Valor del inventario · lo que hay hoy en existencias</span>'
    +'<span style="flex:1"></span>'
    +btnV('tabla','Tabla','ti-table')
    +btnV('grafica','Gráfica','ti-chart-pie')
    +'<button onclick="_invValRecargar()" class="btn bg2" '
    +'style="padding:3px 10px;font-size:10.5px">'
    +'<i class="ti ti-refresh"></i> Actualizar</button></div>'
    // La hora de la carga es importante: comparado con el pivote de SAP en
    // vivo, los departamentos con venta ese día NO van a cuadrar, y sin este
    // dato parece un error de cálculo cuando solo es diferencia de momento.
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 8px">'
    +'Pulsa un departamento para ver sus proveedores. '
    +(function(){
        var f=(filas[0]||{}).actualizado;
        if(!f) return 'Lo actualiza el worker una vez por hora.';
        var d=new Date(f);
        if(isNaN(d)) return 'Lo actualiza el worker una vez por hora.';
        var min=Math.round((Date.now()-d.getTime())/60000);
        var hace = min<1 ? 'ahora mismo'
                 : (min<60 ? ('hace '+min+' min')
                 : ('hace '+Math.round(min/60)+' h'));
        return '<b>Existencias de las '+d.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'})
          +'</b> ('+hace+'). Si lo comparas con SAP en vivo, los departamentos que '
          +'hayan vendido desde entonces darán menos.';
      })()
    +'</div>';

  // La rueda: cada porción es un departamento, por monto CIF
  if(vista==='grafica'){
    var datos=deps.map(function(g){
      return {nombre:_invValNombre(g), valor:_invValSuma(porDept[g]).cif,
              onclick:"_invValAbrirDept('"+_esc(String(g).replace(/'/g,''))+"')"};
    });
    h+=_invValRueda(datos, gran.cif, 'MONTO CIF POR DEPARTAMENTO');
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +'Pulsa un departamento de la lista para ver sus proveedores.</div>';
    return h;
  }

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:7px 9px;text-align:left;font-size:9.5px;text-transform:uppercase">Departamento</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Cantidad</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">FOB</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Promedio</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">CIF</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Precio venta</th>'
    +'</tr></thead><tbody>';

  deps.forEach(function(g){
    var t=_invValSuma(porDept[g]);
    var pct = gran.cif ? (t.cif/gran.cif*100) : 0;
    h+='<tr onclick="_invValAbrirDept(\''+_esc(String(g).replace(/'/g,''))+'\')" '
      +'style="border-top:0.5px solid var(--border);cursor:pointer">'
      +'<td style="padding:6px 9px">'
        +'<b>'+_esc(_invValNombre(g))+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'
          +porDept[g].length+' proveedor(es) · '+pct.toFixed(1)+'% del CIF</div></td>'
      +'<td style="padding:6px 9px;text-align:right">'+_fmtN2(Math.round(t.cantidad))+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+fmt(t.fob)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--text-muted)">'+fmt(t.promedio)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:var(--t-lila)">'+fmt(t.cif)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600;color:var(--t-verde)">'+fmt(t.precio)+'</td>'
      +'</tr>';
  });

  h+='</tbody><tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
    +'<td style="padding:8px 9px;font-weight:800">GRAN TOTAL</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+_fmtN2(Math.round(gran.cantidad))+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+fmt(gran.fob)+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:700;color:var(--text-muted)">'+fmt(gran.promedio)+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(gran.cif)+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(gran.precio)+'</td>'
    +'</tr></tfoot></table></div>';
  return h;
}

// ── Nivel 2: los proveedores de un departamento ──
function _invValAbrirDept(grupo){
  // Aunque el panel ya viene filtrado, esta función se puede llamar con
  // cualquier grupo: se vuelve a comprobar aquí.
  if(_deptAcotado() && !_deptPermitido(normDept(grupo))){
    showT('Ese departamento no es tuyo'); return;
  }
  window._invValDept=grupo;
  var filas=(window._invVal||[]).filter(function(f){
    return String(f.grupo||'').replace(/'/g,'')===grupo; });
  filas.sort(function(a,b){ return (Number(b.cif)||0)-(Number(a.cif)||0); });
  var t=_invValSuma(filas);

  var cuerpo=filas.map(function(f){
    return '<tr onclick="_invValAbrirProv(\''+_esc(String(f.cardcode||'').replace(/'/g,''))+'\')" '
      +'style="border-top:0.5px solid var(--border);cursor:pointer">'
      +'<td style="padding:6px 9px"><b>'+_esc(f.cardname||'')+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(f.cardcode||'')+'</div></td>'
      +'<td style="padding:6px 9px;text-align:right">'+_fmtN2(Math.round(Number(f.cantidad)||0))+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+fmt(f.fob)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--text-muted)">'+fmt(f.promedio)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:var(--t-lila)">'+fmt(f.cif)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600;color:var(--t-verde)">'+fmt(f.precio)+'</td>'
      +'</tr>';
  }).join('');

  // La rueda del departamento: una porción por proveedor, como en el pivote
  var vistaD=window._invValVistaDept||'tabla';
  var btnD=function(k,t,ic){
    var on=(vistaD===k);
    return '<button onclick="window._invValVistaDept=\''+k+'\';_invValAbrirDept(\''
      +_esc(String(grupo).replace(/'/g,''))+'\')" class="btn '+(on?'bp':'bg2')+'" '
      +'style="padding:3px 11px;font-size:10.5px'+(on?';background:#5B21B6':'')+'">'
      +'<i class="ti '+ic+'"></i> '+t+'</button>';
  };
  var rueda='';
  if(vistaD==='grafica'){
    // Con muchos proveedores la rueda se vuelve ilegible: se muestran los 12
    // mayores y el resto se agrupa.
    var top=filas.slice(0,12).map(function(f){
      return {nombre:(f.cardname||f.cardcode||''), valor:Number(f.cif)||0,
              onclick:"_invValAbrirProv('"+_esc(String(f.cardcode||'').replace(/'/g,''))+"')"};
    });
    var resto=filas.slice(12).reduce(function(a,f){ return a+(Number(f.cif)||0); },0);
    if(resto>0) top.push({nombre:'Otros ('+(filas.length-12)+' proveedores)', valor:resto});
    rueda=_invValRueda(top, t.cif, 'MONTO CIF · '+_invValNombre(grupo).toUpperCase());
  }

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">📦</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">'+_esc(_invValNombre(grupo))+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
      +filas.length+' proveedor(es) · pulsa uno para ver su inventario</div></div>'
    +btnD('tabla','Tabla','ti-table')+btnD('grafica','Gráfica','ti-chart-pie')
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'
    +(rueda?('<div style="margin-top:10px">'+rueda+'</div>'):'')
    +'<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden;margin-top:10px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:7px 9px;text-align:left;font-size:9.5px;text-transform:uppercase">Proveedor</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Cantidad</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">FOB</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Promedio</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">CIF</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Precio venta</th>'
    +'</tr></thead><tbody>'+cuerpo+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td style="padding:8px 9px;font-weight:800">TOTAL</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+_fmtN2(Math.round(t.cantidad))+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+fmt(t.fob)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;color:var(--text-muted)">'+fmt(t.promedio)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(t.cif)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(t.precio)+'</td>'
    +'</tr></tfoot></table></div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// ── Nivel 3: los artículos de un proveedor ──
async function _invValAbrirProv(cardcode){
  window._invValCard=cardcode;
  var mc=document.getElementById('mc');
  mc.innerHTML='<div class="empty" style="padding:26px;color:var(--text-muted)">'
    +'<i class="ti ti-package" style="font-size:22px"></i><br>Buscando su inventario…</div>';
  document.getElementById('modal').style.display='flex';

  var items=[];
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,grupo,onhand,iscommited,'
      // El costo hace falta para el margen del catálogo: sin lastpurprc ni
      // avgprice, la casilla de margen dice "no tiene costo" y no calcula.
      +'fob,cif,precioventa,picturname,ultima_venta,fechaentrada,vendido_3a,unidadesbulto,'
      +'lastpurprc,avgprice,codebars,u_color,u_tamano,marca,peso,volumen,salpackun,frgnname'
      +'&cardcode=eq.'+encodeURIComponent(cardcode)+'&onhand=gt.0&order=onhand.desc&limit=3000',
      {headers:SBH});
    if(r.ok) items=await r.json()||[];
    else {
      var t=''; try{ t=await r.text(); }catch(e){}
      console.error('[inv valor] artículos '+r.status+': '+t.slice(0,200));
    }
  }catch(e){ console.warn('[inv valor]',e); }

  window._invValItems=items;
  _invValPintarProv();
}

function _invValPintarProv(){
  var items=window._invValItems||[];
  var cardcode=window._invValCard;
  var f=(window._invVal||[]).find(function(x){ return String(x.cardcode)===String(cardcode); })||{};
  var filtro=window._invValFiltro||'todos';

  var lista=items.slice();
  if(filtro==='antiguos') lista=lista.filter(_invValEsAntiguo);
  if(filtro==='sinventa') lista=lista.filter(function(x){ return !(Number(x.vendido_3a)>0); });

  var tot=lista.reduce(function(a,x){
    var q=Number(x.onhand)||0;
    a.cant+=q; a.fob+=q*(Number(x.fob)||0);
    a.cif+=q*(Number(x.cif)||0); a.pv+=q*(Number(x.precioventa)||0);
    return a;
  },{cant:0,fob:0,cif:0,pv:0});

  var pastilla=function(k,t,n){
    var on=(filtro===k);
    return '<span onclick="window._invValFiltro=\''+k+'\';_invValPintarProv()" '
      +'style="cursor:pointer;border:1px solid '+(on?'#5B21B6':'var(--border)')+';'
      +'background:'+(on?'#5B21B6':'var(--surface-0)')+';color:'+(on?'#fff':'#5B21B6')+';'
      +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600">'
      +t+' <span style="opacity:.8">'+n+'</span></span>';
  };

  var cuerpo=lista.slice(0,400).map(function(x){
    var q=Number(x.onhand)||0;
    var ant=_invValEsAntiguo(x);
    return '<tr style="border-top:0.5px solid var(--border);'+(ant?'background:var(--pastel-aviso)':'')+'">'
      +'<td style="padding:5px 8px;font-size:10.5px"><b>'+_esc(x.itemcode||'')+'</b>'
        +(ant?' <span style="font-size:9px;color:var(--t-ambar);font-weight:700">ANTIGUO</span>':'')+'</td>'
      +'<td style="padding:5px 8px;font-size:10.5px">'+_esc(x.itemname||'')+'</td>'
      +'<td style="padding:5px 8px;text-align:right">'+_fmtN2(q)+'</td>'
      +'<td style="padding:5px 8px;text-align:right">'+fmt(q*(Number(x.fob)||0))+'</td>'
      +'<td style="padding:5px 8px;text-align:right;color:var(--t-lila)">'+fmt(q*(Number(x.cif)||0))+'</td>'
      +'<td style="padding:5px 8px;text-align:right;color:var(--t-verde)">'+fmt(q*(Number(x.precioventa)||0))+'</td>'
      +'<td style="padding:5px 8px;font-size:10px;color:var(--text-muted);white-space:nowrap">'
        +_esc(_invValUltMov(x))+'</td>'
      +'</tr>';
  }).join('');

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">🏭</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">'+_esc(f.cardname||cardcode)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'+_esc(cardcode)+' · '
      +items.length+' artículo(s) con existencias</div></div>'
    +'<button class="btn bg2" onclick="_invValAbrirDept(\''
      +_esc(String(window._invValDept||'').replace(/'/g,''))+'\')">'
      +'<i class="ti ti-arrow-left"></i> Proveedores</button>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin:10px 0">'
      +pastilla('todos','Todos', items.length)
      +pastilla('antiguos','Sin movimiento +2 años', items.filter(_invValEsAntiguo).length)
      +pastilla('sinventa','Nunca vendidos', items.filter(function(x){return !(Number(x.vendido_3a)>0);}).length)
      +'<span style="flex:1"></span>'
      +'<button class="btn bp" style="background:#5B21B6" onclick="_invValCatalogo()">'
        +'<i class="ti ti-book"></i> Armar catálogo o cotización</button>'
    +'</div>'

    +'<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:6px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">SKU</th>'
      +'<th style="padding:6px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Descripción</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">Existencia</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">FOB</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">CIF</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">Precio venta</th>'
      +'<th style="padding:6px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Último mov.</th>'
    +'</tr></thead><tbody>'+cuerpo+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td colspan="2" style="padding:7px 8px;font-weight:800">TOTAL '
        +(filtro==='todos'?'':'(filtrado)')+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800">'+_fmtN2(Math.round(tot.cant))+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800">'+fmt(tot.fob)+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(tot.cif)+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(tot.pv)+'</td>'
      +'<td></td></tr></tfoot></table></div>'
    +(lista.length>400?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +'Se muestran los 400 primeros de '+lista.length+'. El catálogo los incluye todos.</div>'):'');
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
}

// Sin movimiento en más de dos años
function _invValEsAntiguo(x){
  var f=x.ultima_venta || x.fechaentrada;
  if(!f) return true;                       // sin rastro: cuenta como antiguo
  var d=new Date(f);
  if(isNaN(d)) return true;
  return (Date.now()-d.getTime()) > 730*24*3600*1000;
}

function _invValUltMov(x){
  var f=x.ultima_venta || x.fechaentrada;
  if(!f) return 'sin datos';
  var d=new Date(f);
  if(isNaN(d)) return String(f).slice(0,10);
  var meses=(Date.now()-d.getTime())/(1000*60*60*24*30.4);
  return String(f).slice(0,10)+' · '+Math.round(meses)+' meses';
}

// El catálogo con lo que hay en pantalla: reutiliza el armador que ya
// existe, donde se editan precios y se genera el PDF para el cliente.
async function _invValCatalogo(){
  var items=window._invValItems||[];
  var filtro=window._invValFiltro||'todos';
  var lista=items.slice();
  if(filtro==='antiguos') lista=lista.filter(_invValEsAntiguo);
  if(filtro==='sinventa') lista=lista.filter(function(x){ return !(Number(x.vendido_3a)>0); });
  if(!lista.length){ showT('No hay artículos con este filtro'); return; }
  if(lista.length>400 && !confirm(lista.length+' artículos son '+Math.ceil(lista.length/10)
      +' páginas. ¿Seguimos?')) return;

  // Se reutiliza el armador de catálogos que ya existe: allí se revisan los
  // datos, se cambian los precios de venta y se genera el PDF para el
  // cliente. Solo hay que darle los artículos con la forma que espera.
  try{
    window._catFuente = lista.map(_invFichaCatalogo);
    window._catSel = {};
    window._catFuente.forEach(function(f){
      window._catSel[String(f.itemcode).toUpperCase()] = true; });
    _catTrabajando('Comprobando las fotos…');
    try{ await _catResolverFotos(window._catFuente); }catch(e){ console.warn('[catálogo] fotos:',e); }
    _catListo();
    CM();
    try{ _accRegistrar('accion','Generó catálogo de '+lista.length+' artículo(s)'); }catch(e){}
  showT(lista.length+' artículo(s) listos para revisar');
    await _catRevisarAbrir(true);     // sin autocompletar: no hay Excel de proveedor
  }catch(e){
    showT('No se pudo abrir el catálogo');
    console.warn('[inv valor] catálogo:', e);
  }
}

async function _invSelCatalogo(){
  var sel=_invSelFilas();
  if(!sel.length){ showT('Marca al menos un artículo'); return; }
  if(sel.length>400 && !confirm(sel.length+' artículos son '+Math.ceil(sel.length/10)
      +' páginas. ¿Seguimos?')) return;

  window._catFuente=sel.map(_invFichaCatalogo);
  window._catSel={};
  window._catFuente.forEach(function(f){
    window._catSel[String(f.itemcode).toUpperCase()]=true; });
  // Antes de abrir, se comprueba qué foto existe: en el PDF no hay reintento
  _catTrabajando('Comprobando las fotos…');
  try{ await _catResolverFotos(window._catFuente); }catch(e){ console.warn('[catálogo] fotos:',e); }
  _catListo();
  showT(sel.length+' artículo(s) listos para revisar');
  await _catRevisarAbrir(true);      // sin autocompletar: no hay Excel de proveedor
}

// ═══════════════════════════════════════════════════════════════════════════
//  SKU NO SAP DENTRO DE LA CONSULTA DE INVENTARIO
//  Son los artículos que todavía no existen en SAP, creados desde una orden
//  NO SAP. Se muestran arriba y en ámbar, para no confundirlos con los reales.
// ═══════════════════════════════════════════════════════════════════════════
function _invNoSapFilas(){
  var q=String(_invQ||'').trim().toLowerCase();
  var patron=((CU&&_deptAcotado())?_deptPrimero():_invDeptPatron(_invDept)||'').toLowerCase();

  return (window._catNoSap||[]).filter(function(f){
    // Solo los artículos que TODAVÍA no están en SAP. Las fichas degradadas
    // a tipo 'foto' ya existen en SAP: su artículo real sale de la consulta
    // normal y de ellas solo se aprovecha la imagen.
    if(!_catFichaViva(f)) return false;
    if(patron){
      var d=String(f.dept||f._dept||'').toLowerCase();
      if(d && d.indexOf(patron)<0) return false;
    }
    if(!q) return true;
    var blob=[f.itemcode,f.itemname,f.descripcion,f.cardname,f.marca,f.barcode]
      .map(function(v){ return String(v==null?'':v); }).join(' ').toLowerCase();
    return blob.indexOf(q)>=0;
  }).map(function(f){
    // Se le da la forma de una fila de inventario para poder pintarla igual
    var sku=String(f.itemcode||'');
    return {
      itemcode:sku,
      itemname:f.itemname||f.descripcion||'',
      onhand:0, iscommited:0, disponible:0,
      onorder:_catPorLlegar(sku),
      precioventa:Number(_catValor(f,'precio_venta'))||0,
      picturname:'', foto:f.foto||f.foto_url||'',
      marca:f.marca||'', grupo:f.dept||f._dept||'',
      nombre_proveedor:f.cardname||'', cardcode:f.cardcode||'',
      u_color:_catValor(f,'color')||'', u_tamano:_catValor(f,'tamano')||'',
      peso:_catValor(f,'peso')||'', volumen:f.cbm||'',
      unidadesbulto:_catValor(f,'unidades_x_caja')||'',
      codebars:_catValor(f,'barcode')||'',
      _nosap:true
    };
  });
}

// ═══════════════════════════════════════════════════════════════════════════
//  BÚSQUEDA CON IA EN EL INVENTARIO
//  Se escribe lo que se busca en español ("mesas negras de madera con
//  existencia, del proveedor Luoyang") y la IA lo traduce a un filtro sobre
//  las columnas del inventario. La IA NO ve el inventario: solo arma el
//  filtro. El cruce contra los artículos se hace aquí, en el navegador, así
//  que da igual que haya diez mil referencias y no se manda nada afuera.
//  Con lo que sale se puede armar el catálogo, con el mismo formato de ficha.
// ═══════════════════════════════════════════════════════════════════════════

window._invIARes = window._invIARes || [];   // lo que devolvió la última búsqueda
window._invIASel = window._invIASel || {};   // itemcode -> true
window._invIAPlan = null;                    // el filtro que armó la IA

// Texto comparable: sin mayúsculas, sin acentos y sin espacios de más
function _invNorm(s){
  if(s && typeof s==='object'){ try{ s=JSON.stringify(s); }catch(e){ s=''; } }
  return String(s==null?'':s).toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/\s+/g,' ').trim();
}

// Todo el texto de un artículo, para buscar dentro
function _invBlob(x){
  return _invNorm([x.itemcode, x.itemname, x.frgnname, x.marca, x.grupo, x.subg,
                   x.u_color, x.u_tamano, x.usertext, x.caracteristicas,
                   x.nombre_proveedor, x.cardcode].map(function(v){
    return (v && typeof v==='object') ? JSON.stringify(v) : (v||'');
  }).join(' '));
}

function _invIAAbrir(){
  var prev=document.getElementById('modalInvIA'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalInvIA';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10004;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto';

  var ejemplos=[
    'mesas negras de madera con existencia',
    'sillas sin existencia pero con mercancía por llegar',
    'alfombras del proveedor Luoyang con disponible mayor a 50',
    'todo lo que tenga cantidad reservada y precio de venta arriba de 100',
    'lámparas doradas sin nada por llegar'
  ];

  var h='<div style="background:var(--surface-0);border-radius:14px;padding:20px;'
    +'max-width:620px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">'
      +'<div style="font-size:14px;font-weight:700;color:var(--t-indigo)">'
        +'<i class="ti ti-sparkles"></i> Buscar en el inventario con IA</div>'
      +'<button onclick="_invIACerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">'
      +'Escribe lo que buscas como se lo dirías a una persona. Puedes pedir por color, '
      +'material, proveedor, marca y por cualquier columna: con o sin existencia, '
      +'con o sin reservado, con o sin mercancía por llegar, rango de precio…</div>'

    +'<textarea id="invIAQ" rows="3" placeholder="Ej: mesas negras de madera con existencia y sin nada por llegar" '
      +'style="width:100%;padding:10px 12px;border:1px solid var(--border);border-radius:9px;'
      +'font-size:13px;font-family:var(--font-sans);background:var(--surface-1);'
      +'color:var(--text-primary);resize:vertical"></textarea>'

    +'<div style="margin:9px 0 4px;font-size:10px;font-weight:700;color:var(--text-muted);'
      +'text-transform:uppercase;letter-spacing:.5px">Ejemplos</div>'
    +'<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:14px">'
      +ejemplos.map(function(e){
        return '<span onclick="document.getElementById(\'invIAQ\').value='
          +JSON.stringify(e).replace(/"/g,'&quot;')+'" '
          +'style="cursor:pointer;font-size:10.5px;background:var(--surface-1);'
          +'border:0.5px solid var(--border);border-radius:12px;padding:3px 9px;'
          +'color:var(--text-secondary)">'+_esc(e)+'</span>';
      }).join('')
    +'</div>'

    +'<div id="invIAEstado" style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_invIACerrar()">Cancelar</button>'
      +'<button class="btn bp" id="invIABtnBuscar" style="background:#3C3489" onclick="_invIABuscar()">'
        +'<i class="ti ti-search"></i> Buscar</button>'
    +'</div>'
    +'</div>';

  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ if(e.target===ov) _invIACerrar(); });
  document.body.appendChild(ov);
  setTimeout(function(){
    var t=document.getElementById('invIAQ');
    if(t){
      t.focus();
      t.addEventListener('keydown', function(ev){
        if(ev.key==='Enter' && (ev.ctrlKey||ev.metaKey)) _invIABuscar();
      });
    }
  }, 60);
}

function _invIACerrar(){
  var m=document.getElementById('modalInvIA'); if(m) m.remove();
}

function _invIAEstado(txt, color){
  var e=document.getElementById('invIAEstado');
  if(e) e.innerHTML='<span style="color:'+(color||'var(--text-muted)')+'">'+txt+'</span>';
}

// ── 1) La IA traduce la frase a un filtro ────────────────────────────────
async function _invIAPlanear(frase){
  var sistema='Sos un traductor de búsquedas para el inventario de una tienda de importación.\n'
    +'Recibís una frase en español y devolvés SOLO un objeto JSON, sin explicaciones y sin markdown.\n\n'
    +'Columnas disponibles del inventario:\n'
    +'  itemcode (SKU), itemname y frgnname (descripción), marca, grupo (departamento),\n'
    +'  subg (subgrupo), u_color (color), u_tamano (medida), usertext y caracteristicas (ficha),\n'
    +'  nombre_proveedor y cardcode (proveedor), codebars,\n'
    +'  onhand (existencia), iscommited (reservado), disponible, onorder (por llegar),\n'
    +'  precioventa, lastpurprc (último costo), peso, volumen (CBM), unidadesbulto.\n\n'
    +'Formato de la respuesta:\n'
    +'{\n'
    +'  "texto": [["mesa","table"],["negro","negra","black"],["madera","wood","wooden"]],\n'
    +'  "excluir": ["plastico"],\n'
    +'  "proveedores": [],\n'
    +'  "marca": "",\n'
    +'  "numeros": {"onhand": {"op": ">", "v": 0}},\n'
    +'  "orden": "onhand.desc",\n'
    +'  "limite": 300,\n'
    +'  "resumen": "Mesas negras de madera con existencia"\n'
    +'}\n\n'
    +'Reglas:\n'
    +'- "texto" es una lista de condiciones que se cumplen TODAS. Cada condición es una lista de\n'
    +'  sinónimos de los que basta que aparezca UNO. Como las descripciones vienen mezcladas en\n'
    +'  español y en inglés, incluí siempre las dos variantes y el singular/plural.\n'
    +'- "numeros" acepta las columnas numéricas con op entre >, >=, <, <=, =, !=.\n'
    +'  "con existencia" es {"onhand":{"op":">","v":0}} y "sin existencia" es {"op":"=","v":0}.\n'
    +'  Lo mismo con iscommited (reservado), onorder (por llegar), disponible y precioventa.\n'
    +'  Si la frase no dice nada de una columna, NO la incluyas: no filtres de más.\n'
    +'- NO existe un campo de departamento. Si la frase nombra uno (muebles, hogar, ropa…),\n'
    +'  metelo como una condición más dentro de "texto", con sus variantes. El grupo de SAP\n'
    +'  se llama distinto en cada caso, así que nunca inventes el departamento de un artículo:\n'
    +'  una silla de oficina NO tiene por qué estar en el grupo "muebles".\n'
    +'- "proveedores" solo si nombra proveedores.\n'
    +'- "limite": cuántos artículos como mucho. Por defecto 300.\n'
    +'- "resumen": una línea en español describiendo lo que se buscó.\n'
    +'Devolvé únicamente el JSON.';

  var resp=await fetch('https://api.anthropic.com/v1/messages',{
    method:'POST',
    headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,
             'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
    body:JSON.stringify({model:IA_MODELO, max_tokens:900, system:sistema,
                         messages:[{role:'user', content:String(frase||'')}]})
  });
  // Se lee como TEXTO y luego se interpreta. Al revés no funciona: json()
  // consume el cuerpo, y si falla, el text() posterior devuelve vacío y no
  // hay forma de ver qué llegó. Por eso el aviso no decía nada útil.
  var data, crudoTxt='';
  try{
    crudoTxt=await resp.text();
    data=JSON.parse(crudoTxt);
  }catch(errJ){
    // Sin esto, una respuesta que no sea JSON hace saltar el error con los
    // bytes crudos dentro y en pantalla sale "Unexpected token '\uFFFD'".
    var crudo=crudoTxt;
    console.error('[IA] estado '+resp.status
      +' · tipo: '+((resp.headers&&resp.headers.get&&resp.headers.get('content-type'))||'?')
      +' · '+String(crudo||'').length+' caracteres recibidos');
    console.error('[IA] primeros 300: '
      +String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,300));
    console.error('[IA] error original: '+((errJ&&errJ.message)||errJ));
    throw new Error(
      resp.status===413 ? 'El documento es demasiado grande para la IA. '
                         +'Súbelo en Excel o CSV, o divídelo.'
    : resp.status===401 ? 'La clave de la IA no es válida o caducó.'
    : resp.status===429 ? 'La IA está saturada. Prueba dentro de un minuto.'
    : resp.status>=500  ? 'La IA no respondió bien (error '+resp.status+').'
    : (resp.status===200
        ? ('La IA respondió, pero el navegador no pudo leer la respuesta. '
           +'Suele ser una extensión del navegador o un antivirus que se '
           +'interponen. Prueba en una ventana de incógnito. En la consola '
           +'queda el detalle de lo que llegó.')
        : 'La IA devolvió una respuesta ilegible (estado '+resp.status+').'));
  }
  if(data.error) throw new Error(data.error.message||'Error de IA');
  var txt=(data.content||[]).map(function(c){ return c.text||''; }).join('').trim();
  txt=txt.replace(/```json/gi,'').replace(/```/g,'').trim();
  var ini=txt.indexOf('{'), fin=txt.lastIndexOf('}');
  if(ini<0 || fin<ini) throw new Error('La IA no devolvió un filtro válido');
  var plan=JSON.parse(txt.slice(ini, fin+1));
  plan.texto=Array.isArray(plan.texto)?plan.texto:[];
  plan.excluir=Array.isArray(plan.excluir)?plan.excluir:[];
  plan.proveedores=Array.isArray(plan.proveedores)?plan.proveedores.filter(Boolean):[];
  plan.numeros=(plan.numeros&&typeof plan.numeros==='object')?plan.numeros:{};
  plan.limite=Math.min(1000, Math.max(1, Number(plan.limite)||300));
  return plan;
}

// ── 2) Se traen los candidatos de Supabase ───────────────────────────────
// Lo que se puede filtrar en la base (departamento, proveedor, números) va en
// la consulta. El texto se cruza después aquí, porque una descripción puede
// decir "black wooden table" y la frase pedir "mesa negra de madera".
var _INV_IA_OPS={'>':'gt','>=':'gte','<':'lt','<=':'lte','=':'eq','!=':'neq'};

// Lo que se lee para decidir. El resto de las columnas se piden después, solo
// de los artículos que quedaron.
var _INV_IA_SCAN='itemcode,itemname,frgnname,marca,grupo,subg,u_color,u_tamano,'
  +'usertext,caracteristicas,nombre_proveedor,cardcode,'
  +'onhand,iscommited,onorder,disponible,precioventa,picturname';

// La comprobación exacta de los números, ya con el artículo en la mano.
// "disponible" se calcula con _invDisp, que cubre el caso de que la columna
// venga vacía (existencia menos reservado).
function _invIANumOk(x, plan){
  var nums=plan.numeros||{};
  var cols=Object.keys(nums);
  for(var i=0;i<cols.length;i++){
    var c=cols[i], n=nums[c];
    if(!n || !_INV_IA_OPS[n.op]) continue;
    var v=(c==='disponible') ? _invDisp(x) : (Number(x[c])||0);
    var t=Number(n.v)||0;
    var ok = n.op==='>'  ? v>t  : n.op==='>=' ? v>=t
           : n.op==='<'  ? v<t  : n.op==='<=' ? v<=t
           : n.op==='='  ? v===t : n.op==='!=' ? v!==t : true;
    if(!ok) return false;
  }
  return true;
}

// Con los artículos ya elegidos se piden todas sus columnas, por tandas
async function _invIACompletar(res){
  var TANDA=200, mapa={};
  for(var i=0;i<res.length;i+=TANDA){
    var lote=res.slice(i,i+TANDA).map(function(x){
      return '"'+String(x.itemcode||'').replace(/"/g,'')+'"'; }).join(',');
    try{
      var r=await fetch(SB+'/rest/v1/inventario?select='+_INV_CAMPOS
        +'&itemcode=in.('+encodeURIComponent(lote)+')&limit='+TANDA,{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(x){ mapa[String(x.itemcode)]=x; });
    }catch(e){ console.warn('[inventario IA] completar:', e); }
  }
  // Se conserva el orden con el que venían
  return res.map(function(x){ return mapa[String(x.itemcode)]||x; });
}

// Las condiciones en palabras, para poder ver por qué no salió nada
function _invIAPlanTxt(plan){
  var p=[];
  (plan.texto||[]).forEach(function(c){
    var alts=(Array.isArray(c)?c:[c]).filter(Boolean);
    if(alts.length) p.push(alts.join(' / '));
  });
  (plan.excluir||[]).forEach(function(e){ if(e) p.push('sin "'+e+'"'); });
  if((plan.proveedores||[]).length) p.push('proveedor: '+plan.proveedores.join(' / '));
  if(plan.marca) p.push('marca: '+plan.marca);
  var ETI={onhand:'existencia', iscommited:'reservado', onorder:'por llegar',
           disponible:'disponible', precioventa:'precio venta'};
  Object.keys(plan.numeros||{}).forEach(function(c){
    var n=plan.numeros[c];
    if(n && _INV_IA_OPS[n.op]) p.push((ETI[c]||c)+' '+n.op+' '+(Number(n.v)||0));
  });
  return p;
}

async function _invIATraer(plan, aviso){
  // Se leen solo las columnas que hacen falta para decidir si el artículo
  // entra o no. Las demás se piden después, y únicamente de los que quedaron:
  // así se puede recorrer un inventario grande sin traerlo entero.
  var url=SB+'/rest/v1/inventario?select='+_INV_IA_SCAN;

  // El departamento sale del filtro de la pantalla (o del usuario, que manda
  // siempre). NO del que adivine la IA: el grupo de SAP se llama a su manera
  // y una silla de oficina puede no estar en "muebles".
  var patron=(CU&&_deptAcotado()) ? _deptPrimero() : _invDeptPatron(_invDept);
  if(patron) url+='&grupo=ilike.*'+encodeURIComponent(patron)+'*';

  // Un solo proveedor se filtra en la base; si son varios, se cruzan aquí
  if(plan.proveedores.length===1){
    var p=encodeURIComponent(plan.proveedores[0]);
    url+='&or=(nombre_proveedor.ilike.*'+p+'*,cardcode.ilike.*'+p+'*)';
  }
  if(plan.marca) url+='&marca=ilike.*'+encodeURIComponent(plan.marca)+'*';

  // Los números se vuelven a comprobar aquí abajo, artículo por artículo. En la
  // consulta solo van los que acotan sin riesgo de dejar fuera algo válido.
  ['onhand','iscommited','onorder','precioventa'].forEach(function(c){
    var n=plan.numeros[c];
    if(!n || !_INV_IA_OPS[n.op]) return;
    url+='&'+c+'='+_INV_IA_OPS[n.op]+'.'+(Number(n.v)||0);
  });
  // "disponible" puede venir vacío en la tabla, y filtrarlo en la consulta
  // dejaría fuera esas filas. Como disponible = existencia - reservado, nunca
  // es mayor que la existencia: se acota por ahí y el corte exacto se hace aquí.
  var nd=plan.numeros.disponible;
  if(nd && (nd.op==='>' || nd.op==='>=')){
    url+='&onhand='+_INV_IA_OPS[nd.op]+'.'+(Number(nd.v)||0);
  }

  var orden=(plan.orden && /^[a-z_]+\.(asc|desc)/.test(plan.orden)) ? plan.orden : 'itemcode.asc';
  url+='&order='+orden;

  var TOPE=20000, TANDA=1000, out=[], off=0, reintento=false;
  while(off<TOPE){
    var r=await fetch(url+'&limit='+TANDA+'&offset='+off,{headers:SBH});
    if(!r.ok){
      // Alguna columna opcional puede no existir todavía, igual que en la tabla
      if(!reintento){
        reintento=true;
        var basico=_INV_IA_SCAN.split(',').filter(function(c){
          return ['caracteristicas','subg','u_color','u_tamano'].indexOf(c)<0;
        }).join(',');
        url=url.replace('select='+_INV_IA_SCAN, 'select='+basico);
        continue;
      }
      throw new Error('No se pudo consultar el inventario (HTTP '+r.status+')');
    }
    var rows=await r.json();
    if(!Array.isArray(rows)) rows=[];
    out=out.concat(rows);
    if(aviso) aviso(out.length);
    if(rows.length<TANDA) break;
    off+=TANDA;
  }
  return out;
}

// ── 3) Se cruza el texto aquí ─────────────────────────────────────────────
function _invIAFiltrar(rows, plan){
  var cond=(plan.texto||[]).map(function(c){
    return (Array.isArray(c)?c:[c]).map(_invNorm).filter(Boolean);
  }).filter(function(c){ return c.length; });

  // Varios proveedores: se piden como una condición más
  if((plan.proveedores||[]).length>1){
    cond.push(plan.proveedores.map(_invNorm).filter(Boolean));
  }
  var fuera=(plan.excluir||[]).map(_invNorm).filter(Boolean);

  return rows.filter(function(x){
    if(!_invIANumOk(x, plan)) return false;
    var blob=_invBlob(x);
    for(var i=0;i<cond.length;i++){
      var ok=false;
      for(var j=0;j<cond[i].length;j++){
        if(blob.indexOf(cond[i][j])>=0){ ok=true; break; }
      }
      if(!ok) return false;
    }
    for(var k=0;k<fuera.length;k++){ if(blob.indexOf(fuera[k])>=0) return false; }
    return true;
  });
}

// ── El botón: planear, traer, filtrar y mostrar ──────────────────────────
async function _invIABuscar(){
  var frase=String((document.getElementById('invIAQ')||{}).value||'').trim();
  if(!frase){ _invIAEstado('Escribe qué quieres buscar.', 'var(--text-danger)'); return; }
  if(ANTHROPIC_KEY_ARTES==='PEGA_TU_API_KEY_AQUI'){
    _invIAEstado('Falta configurar la API key de la IA.', 'var(--text-danger)'); return;
  }
  var btn=document.getElementById('invIABtnBuscar');
  if(btn){ btn.disabled=true; btn.style.opacity=.6; }

  try{
    _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> Entendiendo la búsqueda…');
    var plan=await _invIAPlanear(frase);
    window._invIAPlan=plan;

    _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> Revisando el inventario…');
    var rows=await _invIATraer(plan, function(n){
      _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> Revisando el inventario… '
        +n+' artículo(s) leídos');
    });

    var res=_invIAFiltrar(rows, plan);
    var recortado=false;
    if(res.length>plan.limite){ res=res.slice(0, plan.limite); recortado=true; }

    if(res.length){
      _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> '
        +'Completando la ficha de '+res.length+' artículo(s)…');
      res=await _invIACompletar(res);
    }

    window._invIARes=res;
    window._invIASel={};
    res.forEach(function(x){ window._invIASel[x.itemcode]=true; });

    if(!res.length){
      // Se muestra el filtro que armó la IA: casi siempre se ve enseguida cuál
      // es la condición que sobra.
      var cond=_invIAPlanTxt(plan);
      _invIAEstado('No encontré artículos que cumplan con todo esto '
        +'(revisé '+rows.length+'):<br>'
        +cond.map(function(c){
            return '<span style="display:inline-block;background:var(--surface-1);'
              +'border:0.5px solid var(--border);border-radius:10px;padding:2px 8px;'
              +'margin:3px 3px 0 0;font-size:10.5px;color:var(--text-secondary)">'
              +_esc(c)+'</span>'; }).join('')
        +'<br><span style="font-size:10.5px">Quitá alguna condición y probá de nuevo.</span>',
        'var(--text-warning)');
      if(btn){ btn.disabled=false; btn.style.opacity=1; }
      return;
    }
    _invIACerrar();
    _invIAResultados(plan, res, rows.length, recortado);
  }catch(e){
    console.warn('[inventario IA]', e);
    _invIAEstado('<i class="ti ti-alert-triangle"></i> '+_esc(e.message||String(e)), 'var(--text-danger)');
  }
  if(btn){ btn.disabled=false; btn.style.opacity=1; }
}

// ── Resultados, con la selección para el catálogo ────────────────────────
function _invIAResultados(plan, res, leidos, recortado){
  var prev=document.getElementById('modalInvIARes'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalInvIARes';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10004;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div id="invIAResBox" style="background:var(--surface-0);border-radius:14px;'
    +'padding:18px;max-width:1600px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)"></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  _invIAPintarRes(plan, res, leidos, recortado);
}

function _invIAPintarRes(plan, res, leidos, recortado){
  var box=document.getElementById('invIAResBox'); if(!box) return;
  res=res||window._invIARes||[];
  var sel=Object.keys(window._invIASel||{}).filter(function(k){ return window._invIASel[k]; }).length;

  var h='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:3px">'
    +'<div><div style="font-size:14px;font-weight:700;color:var(--t-indigo)">'
      +'<i class="ti ti-sparkles"></i> '+_esc((plan&&plan.resumen)||'Resultado de la búsqueda')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'
      +res.length+' artículo(s) de '+leidos+' revisados'
      +(recortado?(' · recortado al tope de '+plan.limite):'')+'</div></div>'
    +'<button onclick="document.getElementById(\'modalInvIARes\').remove()" '
      +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>';

  h+='<div style="display:flex;gap:7px;align-items:center;flex-wrap:wrap;margin:10px 0">'
    +'<button class="btn bg2" style="padding:4px 10px;font-size:11px" onclick="_invIATodos(true)">Marcar todos</button>'
    +'<button class="btn" style="padding:4px 10px;font-size:11px" onclick="_invIATodos(false)">Ninguno</button>'
    +'<span id="invIASelN" style="font-size:11px;color:var(--text-muted)">'+sel+' elegidos</span>'
    +'<div style="flex:1"></div>'
    +'<button class="btn" style="padding:5px 11px;font-size:11px" onclick="_invIAAbrir()">'
      +'<i class="ti ti-search"></i> Otra búsqueda</button>'
    +'<button class="btn bp" style="background:#7C3D12;padding:6px 13px;font-size:11.5px" '
      +'onclick="_invIACatalogo()"><i class="ti ti-file-type-pdf"></i> Generar catálogo</button>'
    +'<button class="btn bg2" style="padding:6px 13px;font-size:11.5px;border-color:#C7C3F5;color:var(--t-indigo)" '
      +'onclick="_invIACatalogo(true)"><i class="ti ti-mail"></i> Generar y enviar</button>'
    +'</div>';

  h+='<div style="max-height:56vh;overflow-y:auto;border:0.5px solid var(--border);border-radius:10px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0;z-index:2">'
      +'<th style="padding:6px 8px;width:30px"></th>'
      +'<th style="padding:6px;width:46px;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Foto</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Descripción</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Proveedor</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Exist.</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Reserv.</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Dispon.</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Por llegar</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--t-verde)">Precio</th>'
    +'</tr></thead><tbody>';

  res.forEach(function(x){
    var sku=String(x.itemcode||'');
    var foto=_repFotoUrl(x.picturname);
    var on=!!(window._invIASel||{})[sku];
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:4px 8px;text-align:center">'
        +'<input type="checkbox"'+(on?' checked':'')+' onchange="_invIAMarcar(\''
        +_esc(sku.replace(/'/g,''))+'\',this.checked)"></td>'
      +'<td style="padding:3px 4px">'
        +(foto?('<img src="'+_esc(foto)+'" loading="lazy" style="width:34px;height:34px;'
                +'object-fit:contain;border-radius:4px;background:var(--surface-1)">')
              :'<span style="color:var(--text-muted)"><i class="ti ti-photo-off"></i></span>')
      +'</td>'
      +'<td style="padding:4px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'+_esc(sku)+'</td>'
      +'<td style="padding:4px 6px">'+_esc(x.itemname||'')+'</td>'
      +'<td style="padding:4px 6px;color:var(--text-secondary);white-space:nowrap;'
        +'max-width:150px;overflow:hidden;text-overflow:ellipsis" title="'
        +_esc((x.nombre_proveedor||'')+(x.cardcode?(' · '+x.cardcode):''))+'">'
        +_esc(x.nombre_proveedor||x.cardcode||'—')+'</td>'
      +'<td style="padding:4px 6px;text-align:right">'+_fmtN2(x.onhand)+'</td>'
      +'<td style="padding:4px 6px;text-align:right;color:var(--t-rojo)">'+_fmtN2(x.iscommited)+'</td>'
      +'<td style="padding:4px 6px;text-align:right;font-weight:600">'+_fmtN2(_invDisp(x))+'</td>'
      +'<td style="padding:4px 6px;text-align:right;color:var(--t-ambar)">'+_fmtN2(x.onorder)+'</td>'
      +'<td style="padding:4px 6px;text-align:right;color:var(--t-verde);font-weight:600">'
        +(Number(x.precioventa)?fmt(x.precioventa):'—')+'</td>'
    +'</tr>';
  });
  h+='</tbody></table></div>';
  box.innerHTML=h;
}

function _invIAMarcar(sku, on){
  window._invIASel=window._invIASel||{};
  if(on) window._invIASel[sku]=true; else delete window._invIASel[sku];
  var n=document.getElementById('invIASelN');
  if(n) n.textContent=Object.keys(window._invIASel).length+' elegidos';
}

function _invIATodos(on){
  window._invIASel={};
  if(on) (window._invIARes||[]).forEach(function(x){ window._invIASel[x.itemcode]=true; });
  _invIAPintarRes(window._invIAPlan, window._invIARes, (window._invIARes||[]).length, false);
}

// ── El artículo del inventario, con la forma que espera la ficha ─────────
function _invIAFicha(x){
  return {
    __sinEdit:true,                     // no mezclar con lo editado del catálogo BORRADOR
    itemcode: x.itemcode||'',
    itemname: x.itemname||'',
    descripcion: x.itemname||x.frgnname||'',
    marca: x.marca||'',
    _dept: String(x.grupo||'').replace(/^[.\s]+/,''),
    unidades_x_caja: x.unidadesbulto||x.salpackun||'',
    medida: x.u_tamano||'',
    cbm: x.volumen||'',
    peso: x.peso||'',
    color: x.u_color||'',
    disponible: _invDisp(x),
    precio_venta: Number(x.precioventa)||0,
    barcode: x.codebars||'',
    foto: _repFotoUrl(x.picturname)||''
  };
}

// ── El catálogo de lo seleccionado ───────────────────────────────────────
async function _invIACatalogo(porCorreo){
  var sel=(window._invIARes||[]).filter(function(x){
    return (window._invIASel||{})[x.itemcode]; });
  if(!sel.length){ showT('Elige al menos un artículo'); return; }
  if(sel.length>400 && !confirm(sel.length+' artículos son '+Math.ceil(sel.length/10)
      +' páginas. ¿Seguimos?')) return;

  showT('Armando el catálogo con '+sel.length+' artículo(s)…');
  try{
    // Fotos chicas y bien comprimidas: es lo único que hace pesado el PDF.
    // A 200 px y calidad 0.42 cada foto queda en 8-12 KB y en el papel se
    // ve igual, así que 300 artículos dan un archivo de pocos MB.
    var doc=await _catPdfDocumento(sel.map(_invIAFicha), {foto:{lado:200, q:0.42}});
    var _nom='Catalogo_'+new Date().toISOString().slice(0,10)+'.pdf';
    if(porCorreo){
      await _catMailAbrir([{nombre:_nom, blob:doc.output('blob'), mime:'application/pdf'}],
                          'Catálogo Kennedy Center — '+sel.length+' artículo(s)');
    } else {
      doc.save(_nom);
      showT('✓ Catálogo generado · la lista queda abierta');
    }
  }catch(e){
    console.warn('[catálogo inventario]', e);
    showT('No se pudo generar: '+(e.message||e), 5000);
  }
}

// ══════════════════════════════════════════════════════════════════════
//  ÓRDENES DE COMPRA PENDIENTES POR PROVEEDOR
//
//  Una orden sigue abierta hasta que llega toda la mercancía. Si llegó una
//  parte, SAP la factura con una factura de reserva y en POR1.OpenQty queda
//  lo que falta. Aquí se ve esa diferencia, que es el dinero que de verdad
//  está por recibir.
//
//  Dos situaciones distintas, con color distinto:
//    · Sin recibir       — no ha llegado nada de la orden
//    · Recibida a medias — llegó parte y queda un resto abierto
// ══════════════════════════════════════════════════════════════════════
window._ocPend      = window._ocPend || null;
window._ocPendFiltro= window._ocPendFiltro || 'todas';
window._ocPendDept  = window._ocPendDept || 'todos';
window._ocPendQ     = window._ocPendQ || '';

async function _ocPendCargar(forzar){
  if(window._ocPend && window._ocPend.length && !forzar) return window._ocPend;
  window._ocPendError=null;
  try{
    var out=[], desde=0;
    while(true){
      var r=await fetch(SB+'/rest/v1/ordenes_pendientes?select=*'
        +'&order=monto_pendiente.desc&offset='+desde+'&limit=1000',{headers:SBH});
      if(!r.ok){
        var t=''; try{ t=await r.text(); }catch(e){}
        window._ocPendError=r.status+' · '+t.slice(0,200);
        console.error('[oc pendientes] '+r.status+': '+t.slice(0,300));
        break;
      }
      var lote=await r.json()||[];
      out=out.concat(lote);
      if(lote.length<1000) break;
      desde+=1000;
    }
    window._ocPend=out;
    console.log('[oc pendientes] '+out.length+' línea(s) pendientes');
  }catch(e){
    window._ocPendError=(e&&e.message)||String(e);
    console.error('[oc pendientes]',e);
    window._ocPend=window._ocPend||[];
  }
  return window._ocPend;
}

// Las líneas agrupadas por orden: una fila por orden, como en el listado
// que usa gerencia en SAP.
function _ocPendPorOrden(){
  var por={};
  (window._ocPend||[]).forEach(function(l){
    var k=String(l.docnum);
    var o=por[k];
    if(!o){
      o=por[k]={docnum:l.docnum, referencia:l.referencia||'', cardcode:l.cardcode||'',
        cardname:l.cardname||'', grupo:l.grupo||'', fecha:l.fecha||'',
        fecha_llegada:l.fecha_llegada||'', eta:l.eta||'', estado:l.estado_compra||'',
        terminos:l.terminos||'', abono_pct:Number(l.abono_pct)||0,
        fecha_abono:l.fecha_abono||'', contenedor:l.contenedor||'',
        doc_total:Number(l.doc_total)||0, pendiente:0, lineas:[]};
    }
    o.pendiente += Number(l.monto_pendiente)||0;
    o.lineas.push(l);
  });
  return Object.keys(por).map(function(k){
    var o=por[k];
    o.despachado = Math.max(0, o.doc_total - o.pendiente);
    // Si no se ha recibido nada, lo pendiente es prácticamente el total
    o.completa = (o.despachado <= Math.max(0.5, o.doc_total*0.005));
    return o;
  });
}

function _ocPendSetFiltro(v){ window._ocPendFiltro=v; rOcPend(); }
function _ocPendSetDept(v){ window._ocPendDept=v; rOcPend(); }
function _ocPendBuscar(v){ window._ocPendQ=String(v||''); rOcPend(); }

function _ocPendLista(){
  // Esta pantalla es SOLO de las recibidas a medias: las que no ha llegado
  // nada están en Buscar órdenes, y tener dos pantallas para lo mismo
  // confundía más que ayudaba.
  var todas=_ocPendPorOrden().filter(function(o){ return !o.completa; });
  var d=window._ocPendDept;
  if(d && d!=='todos') todas=todas.filter(function(o){
    return (normDept(o.grupo)||'otros')===d; });
  // El departamento del usuario acota, como en el resto del portal
  if(_deptAcotado()) todas=todas.filter(function(o){
    return _deptPermitido(normDept(o.grupo)||'otros'); });
  // Buscador: proveedor, código, número de orden o referencia
  var q=String(window._ocPendQ||'').toLowerCase().trim();
  if(q) todas=todas.filter(function(o){
    return String(o.cardname||'').toLowerCase().indexOf(q)>=0
        || String(o.cardcode||'').toLowerCase().indexOf(q)>=0
        || String(o.referencia||'').toLowerCase().indexOf(q)>=0
        || String(o.docnum||'').toLowerCase().indexOf(q)>=0;
  });
  return todas.sort(function(a,b){ return b.pendiente-a.pendiente; });
}

function rOcPend(){
  var box=document.getElementById('page-ocpend'); if(!box) return;

  if(window._ocPend===null || (!window._ocPend.length && !window._ocPendError
                               && !window._ocPendReintento)){
    if(window._ocPend!==null) window._ocPendReintento=1;
    _ocPendCargar(true).then(function(){ try{ rOcPend(); }catch(e){} });
    box.innerHTML='<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'<span class="ai-ring g"></span> Buscando lo que falta por llegar…</div>';
    return;
  }

  if(!(window._ocPend||[]).length){
    box.innerHTML='<div class="slbl"><i class="ti ti-package-off"></i> '
      +'Órdenes pendientes por proveedor</div>'
      +'<div class="empty" style="padding:20px;color:var(--text-muted);font-size:12px">'
      +(window._ocPendError
        ? ('<b style="color:var(--t-rojo3)">No se pudo leer la tabla</b><br>'
           +'<span style="font-size:11px">'+_esc(window._ocPendError)+'</span><br>'
           +'<span style="font-size:11px">Comprueba que exista <b>ordenes_pendientes</b> '
           +'y que tenga política de lectura.</span>')
        : ('<i class="ti ti-mood-check" style="font-size:22px;color:var(--t-verde)"></i><br>'
           +'No hay nada pendiente de llegar.'))
      +'</div>';
    return;
  }

  var lista=_ocPendLista();
  // Las cuentas de las pastillas tienen que respetar el departamento
  // elegido: antes salían siempre las de la empresa entera, así que al
  // filtrar Hogar los números de abajo no cuadraban con la tabla.
  var todas=_ocPendPorOrden().filter(function(o){ return !o.completa; }).filter(function(o){
    var d=normDept(o.grupo)||'otros';
    if(_deptAcotado()) return _deptPermitido(d);
    if(window._ocPendDept && window._ocPendDept!=='todos') return d===window._ocPendDept;
    return true;
  });
  // Y el buscador también
  var _q=String(window._ocPendQ||'').toLowerCase().trim();
  if(_q) todas=todas.filter(function(o){
    return String(o.cardname||'').toLowerCase().indexOf(_q)>=0
        || String(o.cardcode||'').toLowerCase().indexOf(_q)>=0
        || String(o.referencia||'').toLowerCase().indexOf(_q)>=0
        || String(o.docnum||'').toLowerCase().indexOf(_q)>=0;
  });
  var tot=lista.reduce(function(a,o){
    a.pedido+=o.doc_total; a.desp+=o.despachado; a.pend+=o.pendiente; return a;
  },{pedido:0,desp:0,pend:0});

  var h='<div class="slbl"><i class="ti ti-package-off"></i> '
    +'Órdenes recibidas a medias</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 9px">'
    +'Las órdenes que han llegado <b>a medias</b>: SAP facturó una parte con su factura '
    +'reserva y aquí queda lo que falta. Las que no ha llegado nada están en Buscar '
    +'órdenes. Pulsa una orden para ver qué artículos faltan.</div>';

  // Departamentos: los que el usuario puede ver. Si tiene uno asignado,
  // esta barra no aparece porque no hay nada que elegir.
  if(!_deptAcotado()){
    // Estos chips cuentan sobre TODO: si contaran sobre lo filtrado, al
    // elegir Hogar los demás saldrían a cero y no se podría cambiar.
    var conDept={}, _todasSinDept=_ocPendPorOrden().filter(function(o){ return !o.completa; });
    _todasSinDept.forEach(function(o){ var k=normDept(o.grupo)||'otros'; conDept[k]=(conDept[k]||0)+1; });
    var chip=function(k,t,n){
      var on=(window._ocPendDept===k);
      return '<span onclick="_ocPendSetDept(\''+k+'\')" style="cursor:pointer;'
        +'border:1px solid '+(on?'#5B21B6':'var(--border)')+';background:'+(on?'#5B21B6':'var(--surface-0)')
        +';color:'+(on?'#fff':'var(--text-primary)')+';border-radius:20px;padding:3px 11px;'
        +'font-size:10.5px;font-weight:600;white-space:nowrap">'+t
        +(n!=null?(' <span style="opacity:.75">'+n+'</span>'):'')+'</span>';
    };
    h+='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:8px">'
      + chip('todos','Todos', _todasSinDept.length)
      + _deptsVisibles().filter(function(d){ return conDept[d]; })
          .map(function(d){ return chip(d, dL(d), conDept[d]); }).join('')
      +'</div>';
  }

  h+=_ocPendResumen();

  h+='<div style="margin-bottom:8px">'
    +'<input id="ocp-q" value="'+_esc(window._ocPendQ||'')+'" '
    +'placeholder="Buscar proveedor, código, número de orden o DKC…" '
    +'oninput="clearTimeout(window._ocpT);window._ocpT=setTimeout(function(){'
    +'_ocPendBuscar(document.getElementById(\'ocp-q\').value)},300)" '
    +'style="width:100%;padding:8px 12px;border:1px solid var(--border);border-radius:8px;'
    +'font-size:12px;font-family:var(--font-sans);background:var(--surface-2);'
    +'color:var(--text-primary)"></div>';

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    +'<span style="font-size:11px;color:var(--text-muted)">'+todas.length+' orden(es) recibidas a medias</span>'
    +'<span style="flex:1"></span>'
    +'<span style="font-size:11px;color:var(--text-muted)">Pendiente de llegar: '
    +'<b style="color:var(--t-ambar);font-size:13px">'+fmt(tot.pend)+'</b></span>'
    +'</div>';

  var filas=lista.slice(0,300).map(function(o){
    var pct = o.doc_total ? (o.despachado/o.doc_total*100) : 0;
    return '<tr onclick="_ocPendDetalle('+o.docnum+')" '
      +'style="border-top:0.5px solid var(--border);cursor:pointer;'
      +'background:'+(o.completa?'var(--pastel-aviso)':'var(--pastel-lila)')+'">'
      +'<td style="padding:6px 9px"><b>'+_esc(o.cardcode)+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(o.cardname).slice(0,34)+'</div></td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600">'+_esc(o.docnum)+'</td>'
      +'<td style="padding:6px 9px;font-weight:600;color:var(--t-azul)">'+_esc(o.referencia)+'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px">'+_esc(dL(normDept(o.grupo)||o.grupo))+'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px;white-space:nowrap">'+_esc(o.fecha)+'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px;white-space:nowrap">'+_esc(o.fecha_llegada)+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+fmt(o.doc_total)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--t-verde)">'
        +(o.despachado>0.5?fmt(o.despachado):'—')+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:var(--t-ambar)">'
        +fmt(o.pendiente)+'</td>'
      +'<td style="padding:6px 9px;text-align:center;font-size:10px">'
        +'<span style="color:var(--t-lila);font-weight:700">'+pct.toFixed(0)+'% recibido</span>'
        +'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px">'+_esc(o.terminos)+'</td>'
      +'</tr>';
  }).join('');

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px;min-width:1050px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +['Proveedor','Pedido','Orden','Depto','Fec. orden','Fec. llegada',
        'Monto pedido','Despachado','Pendiente','Estado','Cond.']
        .map(function(t,i){
          var der=(i>=6&&i<=8);
          return '<th style="padding:7px 9px;text-align:'+(der?'right':'left')
            +';font-size:9.5px;text-transform:uppercase;white-space:nowrap">'+t+'</th>';
        }).join('')
    +'</tr></thead><tbody>'+filas+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td colspan="6" style="padding:8px 9px;font-weight:800">'
        +lista.length+' orden(es)</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+fmt(tot.pedido)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(tot.desp)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-ambar)">'+fmt(tot.pend)+'</td>'
      +'<td colspan="2"></td></tr></tfoot></table></div>'
    +(lista.length>300?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +'Se muestran las 300 primeras de '+lista.length+'.</div>'):'');

  box.innerHTML=h;
}

// Cuadro por departamento, como el de Inicio pero solo de lo que llegó a
// medias: cuántas órdenes, cuánto se pidió, cuánto llegó y cuánto falta.
function _ocPendResumen(){
  var base=_ocPendPorOrden().filter(function(o){ return !o.completa; });
  if(_deptAcotado()) base=base.filter(function(o){
    return _deptPermitido(normDept(o.grupo)||'otros'); });
  var q=String(window._ocPendQ||'').toLowerCase().trim();
  if(q) base=base.filter(function(o){
    return String(o.cardname||'').toLowerCase().indexOf(q)>=0
        || String(o.cardcode||'').toLowerCase().indexOf(q)>=0
        || String(o.referencia||'').toLowerCase().indexOf(q)>=0
        || String(o.docnum||'').toLowerCase().indexOf(q)>=0;
  });
  if(!base.length) return '';

  var por={}, tot={n:0, pedido:0, desp:0, pend:0};
  base.forEach(function(o){
    var d=normDept(o.grupo)||'otros';
    var a=por[d]||(por[d]={n:0, pedido:0, desp:0, pend:0});
    a.n++; a.pedido+=o.doc_total; a.desp+=o.despachado; a.pend+=o.pendiente;
    tot.n++; tot.pedido+=o.doc_total; tot.desp+=o.despachado; tot.pend+=o.pendiente;
  });

  var tarjeta=function(clave, titulo, a, esTotal){
    var pct = a.pedido ? (a.desp/a.pedido*100) : 0;
    var on = esTotal ? ((window._ocPendDept||'todos')==='todos')
                     : (window._ocPendDept===clave);
    return '<div onclick="_ocPendSetDept(\''+(esTotal?'todos':clave)+'\')" '
      +'style="cursor:pointer;flex:1;min-width:172px;background:var(--surface-0);'
      +'border:'+(on?'1.5px solid #5B21B6':'0.5px solid var(--border)')+';border-radius:11px;'
      +'padding:10px 13px">'
      +'<div style="display:flex;align-items:center;gap:6px;font-size:12px;font-weight:700">'
      +(esTotal?'<i class="ti ti-sum"></i>':(EMOJIS2[clave]||'📦'))+' '+_esc(titulo)
      +'<span style="margin-left:auto;font-size:10.5px;color:var(--text-muted);font-weight:600">'
      +a.n+' orden(es)</span></div>'
      +'<div style="font-size:18px;font-weight:800;color:var(--t-ambar);margin-top:3px">'
      +fmt(a.pend)+'</div>'
      +'<div style="font-size:10px;color:var(--text-muted)">pendiente de llegar</div>'
      +'<div style="height:5px;background:var(--border);border-radius:3px;overflow:hidden;margin:6px 0 4px">'
      +'<div style="height:100%;width:'+pct.toFixed(0)+'%;background:#5B21B6"></div></div>'
      +'<div style="display:flex;gap:9px;font-size:10px;color:var(--text-muted);flex-wrap:wrap">'
      +'<span>Pedido <b style="color:var(--text-primary)">'+fmt(a.pedido)+'</b></span>'
      +'<span>Recibido <b style="color:var(--t-verde)">'+fmt(a.desp)+'</b></span>'
      +'<span>'+pct.toFixed(0)+'%</span></div></div>';
  };

  var claves=Object.keys(por).sort(function(a,b){ return por[b].pend-por[a].pend; });
  return '<div style="font-size:11.5px;font-weight:700;color:var(--text-secondary);'
    +'margin:2px 0 6px">Resumen por departamento</div>'
    +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:12px">'
    + claves.map(function(k){ return tarjeta(k, dL(k), por[k], false); }).join('')
    + tarjeta('todos','Total', tot, true)
    +'</div>';
}

// El detalle: qué artículos faltan de esa orden
function _ocPendDetalle(docnum){
  var lineas=(window._ocPend||[]).filter(function(l){
    return String(l.docnum)===String(docnum); });
  if(!lineas.length) return;
  var o=_ocPendPorOrden().find(function(x){ return String(x.docnum)===String(docnum); })||{};

  var cuerpo=lineas.sort(function(a,b){ return (a.linenum||0)-(b.linenum||0); })
    .map(function(l){
      var recibido=(Number(l.cantidad)||0)-(Number(l.pendiente)||0);
      return '<tr style="border-top:0.5px solid var(--border)">'
        +'<td style="padding:5px 8px"><b>'+_esc(l.itemcode||'')+'</b></td>'
        +'<td style="padding:5px 8px;font-size:10.5px">'+_esc(l.descripcion||'')+'</td>'
        +'<td style="padding:5px 8px;text-align:right">'+_fmtN2(l.cantidad)+'</td>'
        +'<td style="padding:5px 8px;text-align:right;color:var(--t-verde)">'
          +(recibido>0?_fmtN2(recibido):'—')+'</td>'
        +'<td style="padding:5px 8px;text-align:right;font-weight:700;color:var(--t-ambar)">'
          +_fmtN2(l.pendiente)+'</td>'
        +'<td style="padding:5px 8px;text-align:right">'+fmt(l.precio)+'</td>'
        +'<td style="padding:5px 8px;text-align:right;font-weight:700">'
          +fmt(l.monto_pendiente)+'</td>'
        +'</tr>';
    }).join('');

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">📦</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">Orden '+_esc(docnum)
      +' · '+_esc(o.referencia||'')+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'+_esc(o.cardname||'')
      +' · '+_esc(dL(normDept(o.grupo)||o.grupo))+'</div></div>'
    +'<button class="btn bp" style="background:var(--t-rojo3)" '
      +'onclick="_ocPendReclamo('+docnum+')">'
      +'<i class="ti ti-mail-forward"></i> Reclamar</button>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin:10px 0">'
      +'<div style="flex:1;min-width:130px;border:0.5px solid var(--border);border-radius:9px;padding:9px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Monto pedido</div>'
        +'<div style="font-size:14px;font-weight:700">'+fmt(o.doc_total)+'</div></div>'
      +'<div style="flex:1;min-width:130px;border:0.5px solid var(--border);border-radius:9px;padding:9px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Ya despachado</div>'
        +'<div style="font-size:14px;font-weight:700;color:var(--t-verde)">'+fmt(o.despachado)+'</div></div>'
      +'<div style="flex:1;min-width:130px;border:0.5px solid var(--border);border-radius:9px;padding:9px;'
        +'background:var(--pastel-aviso)">'
        +'<div style="font-size:9.5px;color:var(--t-marron);text-transform:uppercase">Falta por llegar</div>'
        +'<div style="font-size:14px;font-weight:800;color:var(--t-ambar)">'+fmt(o.pendiente)+'</div></div>'
    +'</div>'

    +'<div style="border:0.5px solid var(--border);border-radius:10px;overflow:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +['SKU','Descripción','Pedido','Recibido','Falta','Precio','Monto pendiente']
        .map(function(t,i){
          return '<th style="padding:6px 8px;text-align:'+(i>=2?'right':'left')
            +';font-size:9.5px;text-transform:uppercase">'+t+'</th>';
        }).join('')
    +'</tr></thead><tbody>'+cuerpo+'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:8px">'
    +'Solo salen las líneas con algo pendiente. Las que llegaron completas ya no '
    +'aparecen: SAP las cerró con la factura de reserva.</div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// El resumen que va bajo el nombre del departamento en el tablero: cuánto
// falta de verdad por llegar, separando las órdenes de las que no ha
// llegado nada de las que llegaron a medias. Cada una con su color, el
// mismo que en la pantalla de pendientes.
function _ocPendResumenDept(dept){
  var r=_ocPendDeptDetalle(dept);
  if(!r || (!r.sinRecibir && !r.parcial)) return '';
  var trozos=[];
  if(r.sinRecibir) trozos.push('<span style="color:var(--t-marron);font-weight:600" '
    +'title="Órdenes de las que todavía no ha llegado nada">'
    +r.nSinRecibir+' sin recibir</span>');
  if(r.parcial) trozos.push('<span style="color:var(--t-lila);font-weight:600" '
    +'title="Órdenes de las que ya llegó una parte">'
    +r.nParcial+' a medias</span>');
  return '<div class="dept-sem-count" style="margin-top:2px;cursor:pointer" '
    +'onclick="event.stopPropagation();window._ocPendDept=\''+dept+'\';'
    +'window._ocPendFiltro=\'todas\';go(\'ocpend\')">'
    +'<i class="ti ti-package-off"></i> '+trozos.join(' · ')+'</div>';
}

// ── Reclamar al proveedor lo que no ha llegado ──
// Reutiliza el reclamo que ya existe para faltantes de una entrada, pero
// alimentado con las líneas abiertas de la orden: lo que se pidió, lo que
// llegó y lo que falta, con su importe.
function _ocPendReclamo(docnum){
  var lineas=(window._ocPend||[]).filter(function(l){
    return String(l.docnum)===String(docnum); });
  if(!lineas.length){ showT('Esa orden no tiene nada pendiente'); return; }
  var o=_ocPendPorOrden().find(function(x){ return String(x.docnum)===String(docnum); })||{};

  // La forma que espera el reclamo
  var filas=lineas.map(function(l){
    var pedido=Number(l.cantidad)||0, falta=Number(l.pendiente)||0;
    return {
      sku:l.itemcode||'', descripcion:l.descripcion||'',
      cantidad:pedido, cantidad_recibida:Math.max(0,pedido-falta),
      cantidad_abierta:falta, precio:Number(l.precio)||0,
      monto_faltante:Number(l.monto_pendiente)||0,
      factura:'', fecha:l.fecha||''
    };
  });

  window._mailAdj=[];
  window._reclamoCtx={oid:(o.referencia||String(docnum)), lineas:filas, _desdeOC:true,
    proveedor:(o.cardname||''), dept:(normDept(o.grupo)||''), docnum:docnum};

  var dept=normDept(o.grupo)||'';
  var comprasDept=(USERS||[]).filter(function(u){
    return _esComprasU(u) && u.email && dept && String(u.dept||'')===String(dept); });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado=comprasDept.some(function(c){ return c.id===u.id; });
    return '<label style="display:inline-flex;align-items:center;gap:5px;font-size:11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;'
      +'padding:3px 9px;margin:0 5px 5px 0;cursor:pointer">'
      +'<input type="checkbox" value="'+_esc(u.email)+'"'+(marcado?' checked':'')+'> '
      +_esc(u.name)+'</label>';
  }).join('');

  var tot=filas.reduce(function(a,l){ return a+l.monto_faltante; },0);
  // El proveedor es chino, indio o egipcio: el correo va en inglés.
  var asunto='Pending delivery · PO '+(o.referencia||docnum)
    +' · '+(o.cardname||'');

  var cuerpo='Dear Sirs,\n\n'
    +'Reviewing our purchase order '+(o.referencia||docnum)
    +(o.docnum?(' (SAP order '+o.docnum+')'):'')+' dated '+(o.fecha||'')+', '
    +'we note that the following items are still pending delivery:\n\n';
  filas.forEach(function(l){
    cuerpo+='  · '+l.sku+' — '+l.descripcion+'\n'
      +'      ordered '+_fmtN2(l.cantidad)+' · received '+_fmtN2(l.cantidad_recibida)
      +' · pending '+_fmtN2(l.cantidad_abierta)
      +'  =  '+fmt(l.monto_faltante)+'\n';
  });
  cuerpo+='\nTotal pending: '+fmt(tot)+'\n'
    +'Total order value: '+fmt(o.doc_total)+'\n'
    +(o.despachado>0.5?('Already shipped and invoiced: '+fmt(o.despachado)+'\n'):'')
    +'\nPlease confirm the shipping date for the pending quantities, or let us '
    +'know if any reference will not be shipped so we can close the order.\n\n'
    +'The purchase order is attached for your reference.\n\n'
    +'Best regards,\n'+((CU&&CU.name)||'')+'\nKennedy Center Corp.';

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">📧</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">Reclamar lo que falta por llegar</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Orden '+_esc(o.referencia||docnum)
      +' · '+_esc(o.cardname||'')+' · pendiente <b>'+fmt(tot)+'</b></div></div>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Para</div>'
    +'<div id="reclamo-dests" style="margin-bottom:8px">'+chips+'</div>'
    +'<input id="reclamo-extra" placeholder="Otros correos, separados por coma" '
      +'style="width:100%;padding:7px 10px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12px;margin-bottom:9px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Asunto</div>'
    +'<input id="reclamo-asunto" value="'+_esc(asunto)+'" '
      +'style="width:100%;padding:7px 10px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12px;margin-bottom:9px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Mensaje</div>'
    +'<textarea id="reclamo-cuerpo" rows="14" style="width:100%;padding:9px 11px;'
      +'border:1px solid var(--border);border-radius:8px;font-size:12px;'
      +'font-family:var(--font-sans);resize:vertical;background:var(--surface-2);'
      +'color:var(--text-primary)">'+_esc(cuerpo)+'</textarea>'

    // Los adjuntos usan los mismos identificadores que el reclamo de
    // faltantes: así el envío funciona sin duplicar nada.
    +'<div style="font-size:11px;color:var(--text-muted);margin:9px 0 4px">ADJUNTOS</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" '
      +'style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'
      +'Adjunta la orden de compra para que el proveedor la tenga a la vista.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:10px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">'
      +'<button class="btn bg2" onclick="CM()">Cancelar</button>'
      +'<button class="btn bp" id="reclamo-btn" onclick="_reclamoEnviar()">'
      +'<i class="ti ti-send"></i> Enviar reclamo</button></div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// La fila de "por despachar" dentro de la tarjeta del departamento: el
// dinero de las órdenes abiertas descontando lo que YA llegó con factura
// de reserva. Sumar el total de la orden abultaba la cifra.
function _ocPendFilaDept(dept){
  var r=_ocPendDeptDetalle(dept);
  if(!r || r.total<=0.5) return '';
  return '<div class="sem-row" style="cursor:pointer" '
    +'onclick="event.stopPropagation();window._ocPendDept=\''+dept+'\';'
    +'window._ocPendFiltro=\'todas\';go(\'ocpend\')" '
    +'title="Órdenes abiertas, ya descontado lo que llegó con factura de reserva. '
    +'Pulsa para ver el detalle.">'
    +'<span class="sem-label" style="color:var(--t-ambar)">Por despachar</span>'
    +'<span class="sem-val" style="color:var(--t-ambar);font-weight:700;'
    +'text-decoration:underline">'+fmt(r.total)+'</span></div>';
}

// Para cruzar una orden del portal con lo que le falta por llegar. El
// portal las identifica por su referencia (DKC-25066) y SAP por su número
// de pedido (12095): se indexan las dos formas.
function _ocPendClave(o){
  return String((o&&(o.ref||o.referencia||o.id))||'').trim().toUpperCase();
}

function _ocPendIndice(){
  if(window._ocPendIdx && window._ocPendIdxN===(window._ocPend||[]).length)
    return window._ocPendIdx;
  var idx={};
  _ocPendPorOrden().forEach(function(o){
    if(o.referencia) idx[String(o.referencia).trim().toUpperCase()]=o;
    if(o.docnum)     idx[String(o.docnum).trim().toUpperCase()]=o;
  });
  window._ocPendIdx=idx;
  window._ocPendIdxN=(window._ocPend||[]).length;
  return idx;
}

// El desglose dentro del detalle de la orden: cuánto ya tiene factura de
// reserva y cuánto sigue por llegar. Solo aparece si falta algo.
function _ocPendPanelOrden(o){
  var p=null;
  try{ p=_ocPendDeOrden(o); }catch(e){}
  if(!p || p.pendiente<=0.5) return '';

  var pct = p.doc_total ? Math.round(p.despachado/p.doc_total*100) : 0;
  var col = p.completa ? 'var(--t-marron)' : 'var(--t-lila)';
  var bg  = p.completa ? 'var(--pastel-aviso)' : 'var(--pastel-lila)';

  return '<div style="background:'+bg+';border:0.5px solid var(--border);'
    +'border-radius:9px;padding:10px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:7px">'
      +'<i class="ti ti-package-off" style="color:'+col+'"></i>'
      +'<b style="font-size:12px;color:'+col+'">'
      +(p.completa ? 'Todavía no ha llegado nada de esta orden'
                   : 'Recibida a medias · falta el '+(100-pct)+'%')+'</b>'
      +'<span style="flex:1"></span>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10.5px" '
      +'onclick="event.stopPropagation();_ocPendDetalle('+p.docnum+')">'
      +'<i class="ti ti-list-details"></i> Ver qué falta</button>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10.5px;'
      +'color:var(--t-rojo3)" '
      +'onclick="event.stopPropagation();_ocPendReclamo('+p.docnum+')">'
      +'<i class="ti ti-mail-forward"></i> Reclamar al proveedor</button>'
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:110px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Pedido</div>'
        +'<div style="font-size:13px;font-weight:700">'+fmt(p.doc_total)+'</div></div>'
      +'<div style="flex:1;min-width:110px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">'
        +'Ya llegó · con factura reserva</div>'
        +'<div style="font-size:13px;font-weight:700;color:var(--t-verde)">'
        +(p.despachado>0.5?fmt(p.despachado):'—')+'</div></div>'
      +'<div style="flex:1;min-width:110px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Falta por llegar</div>'
        +'<div style="font-size:13px;font-weight:800;color:var(--t-ambar)">'
        +fmt(p.pendiente)+'</div></div>'
    +'</div>'
    +'<div style="height:5px;background:var(--border);border-radius:3px;overflow:hidden;margin-top:7px">'
      +'<div style="height:100%;width:'+pct+'%;background:var(--t-verde)"></div></div>'
    +'</div>';
}

// Lo que falta por llegar de UNA orden, si es que falta algo
function _ocPendDeOrden(o){
  return _ocPendIndice()[_ocPendClave(o)] || null;
}

// Lo pendiente de un departamento, separado por situación
function _ocPendDeptDetalle(dept){
  var r={sinRecibir:0, parcial:0, nSinRecibir:0, nParcial:0, total:0, despachado:0};
  if(!(window._ocPend||[]).length) return r;
  _ocPendPorOrden().forEach(function(o){
    if((normDept(o.grupo)||'otros')!==dept) return;
    r.total+=o.pendiente;
    r.despachado+=o.despachado;
    if(o.completa){ r.sinRecibir+=o.pendiente; r.nSinRecibir++; }
    else          { r.parcial   +=o.pendiente; r.nParcial++; }
  });
  return r;
}

// Lo pendiente de un departamento, para restarlo de los totales
function _ocPendDeDept(dept){
  var t=0;
  (window._ocPend||[]).forEach(function(l){
    if((normDept(l.grupo)||'otros')===dept) t+=Number(l.monto_pendiente)||0;
  });
  return t;
}

// ── La pantalla: quién entró y qué hizo ──
// Solo para la gerencia general. Los encargados por departamento no la ven:
// es información de todo el equipo.
window._acc      = window._acc || null;
window._accUser  = window._accUser || 'todos';
window._accDesde = window._accDesde || '';
window._accHasta = window._accHasta || '';
window._accTipo  = window._accTipo || 'todos';

function _accPuedeVer(){
  return !!(CU && CU.role==='gerencia' && !_deptAcotado());
}

async function _accCargar(forzar){
  if(window._acc && !forzar) return window._acc;
  window._accError=null;
  try{
    // Por defecto, los últimos treinta días: el registro crece rápido y
    // traerlo entero no aporta nada.
    var desde=window._accDesde
      || new Date(Date.now()-30*24*3600*1000).toISOString().slice(0,10);
    var url=SB+'/rest/v1/accesos?select=*&creado_en=gte.'+desde
      +'&order=creado_en.desc&limit=3000';
    if(window._accHasta) url+='&creado_en=lte.'+window._accHasta+'T23:59:59';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      window._accError=r.status+' · '+t.slice(0,180);
      console.error('[accesos] '+r.status+': '+t.slice(0,200));
      window._acc=[];
      return window._acc;
    }
    window._acc=await r.json()||[];
    console.log('[accesos] '+window._acc.length+' registro(s) desde '+desde);
  }catch(e){
    window._accError=(e&&e.message)||String(e);
    window._acc=window._acc||[];
  }
  return window._acc;
}

function _accSetUser(v){ window._accUser=v; rAccesos(); }
function _accSetTipo(v){ window._accTipo=v; rAccesos(); }
async function _accSetFechas(){
  window._accDesde=(document.getElementById('acc-desde')||{}).value||'';
  window._accHasta=(document.getElementById('acc-hasta')||{}).value||'';
  await _accCargar(true);
  rAccesos();
}

function _accFiltrado(){
  var l=(window._acc||[]).slice();
  if(window._accUser!=='todos') l=l.filter(function(x){
    return String(x.usuario_id||'')===window._accUser; });
  if(window._accTipo!=='todos') l=l.filter(function(x){
    return String(x.tipo||'')===window._accTipo; });
  return l;
}

// Cuándo entró cada uno por última vez
function _accResumen(){
  var por={};
  (window._acc||[]).forEach(function(x){
    var k=x.usuario_id||'?';
    var o=por[k]||(por[k]={id:k, nombre:x.usuario||k, rol:x.rol||'',
                           entradas:0, acciones:0, ultima:'', ultimaEntrada:''});
    if(x.tipo==='entrada'){
      o.entradas++;
      if(!o.ultimaEntrada || x.creado_en>o.ultimaEntrada) o.ultimaEntrada=x.creado_en;
    }
    if(x.tipo==='accion') o.acciones++;
    if(!o.ultima || x.creado_en>o.ultima) o.ultima=x.creado_en;
  });
  return Object.keys(por).map(function(k){ return por[k]; })
    .sort(function(a,b){ return String(b.ultima).localeCompare(String(a.ultima)); });
}

function _accCuando(iso){
  if(!iso) return 'nunca';
  var d=new Date(iso);
  if(isNaN(d)) return String(iso).slice(0,16);
  var min=Math.round((Date.now()-d.getTime())/60000);
  if(min<1)    return 'ahora mismo';
  if(min<60)   return 'hace '+min+' min';
  if(min<1440) return 'hace '+Math.round(min/60)+' h';
  var dias=Math.round(min/1440);
  if(dias<30)  return 'hace '+dias+' día(s)';
  return d.toLocaleDateString('es');
}

function _accFechaHora(iso){
  var d=new Date(iso);
  if(isNaN(d)) return String(iso||'').slice(0,16);
  return d.toLocaleDateString('es')+' '
    +d.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'});
}

var _ACC_TIPOS={entrada:{t:'Entradas', c:'var(--t-verde)'},
                salida:{t:'Salidas',   c:'var(--text-muted)'},
                pantalla:{t:'Pantallas', c:'var(--t-azul)'},
                accion:{t:'Acciones', c:'var(--t-lila)'}};

function rAccesos(){
  var box=document.getElementById('page-accesos'); if(!box) return;
  if(!_accPuedeVer()){
    box.innerHTML='<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'Esta pantalla es solo para gerencia.</div>';
    return;
  }

  if(window._acc===null){
    _accCargar().then(function(){ try{ rAccesos(); }catch(e){} });
    box.innerHTML='<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'<span class="ai-ring g"></span> Leyendo el registro…</div>';
    return;
  }

  if(!(window._acc||[]).length){
    box.innerHTML='<div class="slbl"><i class="ti ti-history"></i> Registro de accesos</div>'
      +'<div class="empty" style="padding:20px;color:var(--text-muted);font-size:12px">'
      +(window._accError
        ? ('<b style="color:var(--t-rojo3)">No se pudo leer el registro</b><br>'
           +'<span style="font-size:11px">'+_esc(window._accError)+'</span><br>'
           +'<span style="font-size:11px">Comprueba que exista la tabla <b>accesos</b>. '
           +'Está en crear_tabla_accesos.sql.</span>')
        : 'Todavía no hay actividad registrada en este periodo.')
      +'</div>';
    return;
  }

  var res=_accResumen();
  var lista=_accFiltrado();

  var h='<div class="slbl"><i class="ti ti-history"></i> Registro de accesos y actividad</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 10px">'
    +'Entradas, pantallas abiertas y acciones que dejan rastro. '
    +'No se guardan contraseñas ni lo que la gente escribe.</div>';

  // Último acceso de cada persona
  h+='<div class="slbl" style="font-size:11px"><i class="ti ti-users"></i> Último acceso</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px">'
    + res.map(function(u){
        var act=(window._accUser===u.id);
        return '<div onclick="_accSetUser(\'' + (act?'todos':u.id) + '\')" '
          +'style="cursor:pointer;border:1px solid '+(act?'#5B21B6':'var(--border)')+';'
          +'background:'+(act?'var(--pastel-lila)':'var(--surface-0)')+';'
          +'border-radius:10px;padding:8px 12px;min-width:150px">'
          +'<div style="font-size:12px;font-weight:700">'+_esc(u.nombre)+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(u.rol)+'</div>'
          +'<div style="font-size:11px;margin-top:3px;color:'
            +(u.ultimaEntrada?'var(--t-verde)':'var(--text-muted)')+'">'
            +'<i class="ti ti-login" style="font-size:10px"></i> '
            +_accCuando(u.ultimaEntrada)+'</div>'
          +'<div style="font-size:9.5px;color:var(--text-muted)">'
            +u.entradas+' entrada(s) · '+u.acciones+' acción(es)</div>'
          +'</div>';
      }).join('')
    +'</div>';

  // Filtros
  var desde=window._accDesde
    || new Date(Date.now()-30*24*3600*1000).toISOString().slice(0,10);
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:9px">'
    +'<select onchange="_accSetUser(this.value)" style="padding:6px 9px;border-radius:8px;'
      +'border:1px solid var(--border);font-size:11.5px;background:var(--surface-2);'
      +'color:var(--text-primary)">'
      +'<option value="todos">Todos los usuarios</option>'
      + res.map(function(u){
          return '<option value="'+_esc(u.id)+'"'
            +((window._accUser===u.id)?' selected':'')+'>'+_esc(u.nombre)+'</option>';
        }).join('')
    +'</select>'
    +'<label style="font-size:11px;color:var(--text-muted)">Desde</label>'
    +'<input type="date" id="acc-desde" value="'+_esc(desde)+'" onchange="_accSetFechas()" '
      +'style="padding:5px 8px;border-radius:8px;border:1px solid var(--border);'
      +'font-size:11.5px;background:var(--surface-2);color:var(--text-primary)">'
    +'<label style="font-size:11px;color:var(--text-muted)">hasta</label>'
    +'<input type="date" id="acc-hasta" value="'+_esc(window._accHasta||'')+'" '
      +'onchange="_accSetFechas()" style="padding:5px 8px;border-radius:8px;'
      +'border:1px solid var(--border);font-size:11.5px;background:var(--surface-2);'
      +'color:var(--text-primary)">'
    +'<span style="flex:1"></span>'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
      +'onclick="_accExportar()"><i class="ti ti-download"></i> Excel</button>'
    +'</div>';

  // Tipo
  var chip=function(k,t,c,n){
    var on=(window._accTipo===k);
    return '<span onclick="_accSetTipo(\'' + k + '\')" style="cursor:pointer;'
      +'border:1px solid '+(on?c:'var(--border)')+';background:'+(on?c:'var(--surface-0)')
      +';color:'+(on?'#fff':c)+';border-radius:20px;padding:3px 11px;font-size:10.5px;'
      +'font-weight:600">'+t+' <span style="opacity:.8">'+n+'</span></span>';
  };
  var base=(window._acc||[]).filter(function(x){
    return window._accUser==='todos' || String(x.usuario_id)===window._accUser; });
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px">'
    + chip('todos','Todo','#0c447c', base.length)
    + Object.keys(_ACC_TIPOS).map(function(k){
        return chip(k,_ACC_TIPOS[k].t,_ACC_TIPOS[k].c,
          base.filter(function(x){ return x.tipo===k; }).length);
      }).join('')
    +'</div>';

  var filas=lista.slice(0,500).map(function(x){
    var ti=_ACC_TIPOS[x.tipo]||{t:x.tipo, c:'var(--text-muted)'};
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:5px 9px;white-space:nowrap;font-size:10.5px">'
        +_esc(_accFechaHora(x.creado_en))+'</td>'
      +'<td style="padding:5px 9px"><b>'+_esc(x.usuario||x.usuario_id||'')+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(x.rol||'')
        +(x.dept?(' · '+_esc(dL(x.dept))):'')+'</div></td>'
      +'<td style="padding:5px 9px"><span style="font-size:10px;font-weight:700;'
        +'color:'+ti.c+'">'+_esc(ti.t)+'</span></td>'
      +'<td style="padding:5px 9px;font-size:11px">'+_esc(x.detalle||'')+'</td>'
      +'<td style="padding:5px 9px;font-size:10.5px;color:var(--text-muted)">'
        +_esc(x.referencia||'')+'</td>'
      +'</tr>';
  }).join('');

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px;min-width:700px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +['Cuándo','Quién','Qué','Detalle','Referencia'].map(function(t){
          return '<th style="padding:7px 9px;text-align:left;font-size:9.5px;'
            +'text-transform:uppercase;white-space:nowrap">'+t+'</th>';
        }).join('')
    +'</tr></thead><tbody>'+filas+'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
    + lista.length+' registro(s)'
    +(lista.length>500?(' · se muestran los 500 más recientes'):'')+'</div>';

  box.innerHTML=h;
}

// El registro filtrado, a Excel
async function _accExportar(){
  var lista=_accFiltrado();
  if(!lista.length){ showT('No hay nada que exportar'); return; }
  try{
    await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Accesos');
    ws.columns=[
      {header:'Fecha y hora', key:'f', width:20},
      {header:'Usuario',      key:'u', width:20},
      {header:'Rol',          key:'r', width:14},
      {header:'Departamento', key:'d', width:14},
      {header:'Tipo',         key:'t', width:12},
      {header:'Detalle',      key:'x', width:44},
      {header:'Referencia',   key:'e', width:18}
    ];
    ws.getRow(1).font={bold:true};
    lista.forEach(function(a){
      ws.addRow({f:_accFechaHora(a.creado_en), u:a.usuario||a.usuario_id||'',
                 r:a.rol||'', d:a.dept?dL(a.dept):'',
                 t:(_ACC_TIPOS[a.tipo]||{t:a.tipo}).t,
                 x:a.detalle||'', e:a.referencia||''});
    });
    var buf=await wb.xlsx.writeBuffer();
    var url=URL.createObjectURL(new Blob([buf],
      {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    var a=document.createElement('a');
    a.href=url; a.download='accesos-'+new Date().toISOString().slice(0,10)+'.xlsx';
    a.click();
    showT('✓ '+lista.length+' registro(s) exportados');
  }catch(e){
    console.warn('[accesos] exportar:', e);
    showT('No se pudo generar el Excel');
  }
}

// ── Página ──
function rInventario(){
  var box=document.getElementById('page-inventario'); if(!box) return;
  var opts=Object.keys(_INV_ORDENES).map(function(k){
    return '<option value="'+k+'"'+((_invOrden===k)?' selected':'')+'>'+_INV_ORDENES[k]+'</option>';
  }).join('');
  var h='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:3px">'
    +'<div style="font-size:13px;font-weight:600"><i class="ti ti-package" '
    +'style="color:var(--text-accent)"></i> Consulta de inventario</div>'
    +'<span style="flex:1"></span>'
    +(CU.verCostos
      ? ('<button class="btn bp" style="padding:8px 15px;background:var(--t-verde)" '
         +'onclick="_cpAbrir()"><i class="ti ti-tag"></i> CONTROL DE PRECIOS</button>')
      : '')
    +'</div>';
  h+='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">Todos los artículos. Pasa el mouse por la foto para verla grande y pulsa cualquier fila para abrir su ficha técnica.</div>';
  // Estado de las fechas de llegada, para saber si ya sincronizaron
  h+='<div id="invFechasAviso"></div>';
  setTimeout(function(){ _invChequearFechas(); }, 600);

  // Acceso a la consulta de entradas de mercancía
  if(_puedeAduana()){
    h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;background:var(--pastel-azul);'
      +'border:0.5px solid #85B7EB;border-radius:9px;padding:8px 12px;margin-bottom:10px">'
      +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i>'
      +'<span style="font-size:11.5px;color:var(--t-azul);flex:1">'
        +'¿Buscas una entrada de mercancía? Consultá por su número sin abrir la orden.</span>'
      +'<button class="btn bp" style="background:#0c447c;padding:5px 12px;font-size:11px" onclick="_entBuscar()">'
        +'<i class="ti ti-search"></i> Buscar entrada</button>'
      +'</div>';
  }
  h+='<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;padding:9px 12px;margin-bottom:10px">'
    +'<div style="flex:1;min-width:190px;display:flex;align-items:center;gap:6px">'
      +'<i class="ti ti-search" style="color:var(--text-muted);font-size:13px"></i>'
      +'<input id="invQ" value="'+_esc(_invQ)+'" oninput="_invBuscar(this.value)" placeholder="SKU, descripción, código de barras o proveedor" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
    +'</div>'
    +'<select onchange="_invSetOrden(this.value)" style="padding:5px 9px;border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'+opts+'</select>'
    +'<span id="invCnt" style="font-size:11px;color:var(--text-muted);white-space:nowrap"></span>'
    +'<button onclick="_invIAAbrir()" title="Buscar con lenguaje natural y armar el catálogo" '
      +'style="background:#EEEDFE;color:var(--t-indigo);border:0.5px solid #C7C3F5;border-radius:8px;'
      +'padding:6px 12px;font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap;'
      +'font-family:var(--font-sans)"><i class="ti ti-sparkles"></i> Buscar con IA</button>'
    +'<span id="invSelBtn" style="display:none;align-items:center;gap:6px">'
      +'<span style="font-size:11px;color:var(--text-muted);white-space:nowrap">'
        +'<b id="invSelN">0</b> marcado(s)</span>'
      +'<button onclick="_invSelCatalogo()" title="Revisar los datos y los precios antes de generar el catálogo" '
        +'style="background:#7C3D12;color:#fff;border:0;border-radius:8px;padding:6px 12px;'
        +'font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap;'
        +'font-family:var(--font-sans)"><i class="ti ti-book"></i> Catálogo</button>'
      +'<button id="invVerSelBtn" onclick="_invVerSoloSel()" title="Mostrar solo los marcados" '
        +'style="background:var(--surface-1);color:var(--text-secondary);border:0.5px solid var(--border);'
        +'border-radius:8px;padding:6px 12px;font-size:11.5px;font-weight:600;cursor:pointer;'
        +'white-space:nowrap;font-family:var(--font-sans)">'
        +'<i class="ti ti-list-check"></i> Ver marcados</button>'
      +'<button onclick="_invSelLimpiar()" title="Quitar todos los marcados" '
        +'style="background:var(--surface-1);color:var(--text-danger);border:0.5px solid var(--border);'
        +'border-radius:8px;padding:6px 12px;font-size:11.5px;font-weight:600;cursor:pointer;'
        +'white-space:nowrap;font-family:var(--font-sans)">'
        +'<i class="ti ti-eraser"></i> Quitar todo</button>'
    +'</span>'
    +'</div>';
  // Filtro por departamento (solo para quien ve todos los departamentos)
  if(!(CU&& _deptAcotado())){
    h+='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:10px">'
      +_INV_DEPTS.map(function(d){
        var on=(_invDept===d.k);
        return '<span onclick="_invSetDept(\''+d.k+'\')" style="cursor:pointer;font-size:11px;font-weight:600;padding:4px 11px;border-radius:14px;'
          +'border:1px solid '+(on?'var(--fill-accent)':'var(--border)')+';'
          +'background:'+(on?'var(--fill-accent)':'var(--surface-1)')+';color:'+(on?'#fff':'var(--text-secondary)')+'">'
          +_esc(d.l)+'</span>';
      }).join('')
      +'</div>';
  }
  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">'
    +'<div class="inv-hdr">'
      +'<div style="flex:0 0 52px">Foto</div>'
      +'<div class="inv-sku">SKU</div>'
      +'<div class="inv-desc">Descripción</div>'
      +_invColOrden('Existencia',   'onhand',      'inv-exi')
      +_invColOrden('Reservado',    'iscommited',  'inv-res')
      +_invColOrden('Disponible',   'disponible',  'inv-dis')
      +_invColOrden('Por llegar',   'onorder',     'inv-lle')
      +_invColOrden('Precio venta', 'precioventa', '', 'flex:0 0 96px')
      +'<div style="flex:0 0 38px;justify-content:center;text-align:center" '
        +'title="Marca los artículos que quieres en el catálogo">Catálogo</div>'
      +'<div class="inv-fill"></div>'
    +'</div>'
    +'<div id="invBody"></div>'
    +'<div id="invMas" style="padding:10px;text-align:center;font-size:11.5px;color:var(--text-muted)"></div>'
  +'</div>';
  box.innerHTML=h;

  // Al regresar desde otra pantalla se conserva lo ya cargado
  if(window._invVolviendo && _invRows.length){
    window._invVolviendo=false;
    var prev=_invRows; _invRows=[];
    _invPintar(prev); _invRows=prev;
    var c0=document.getElementById('invCnt');
    if(c0) c0.textContent=_invRows.length+(_invFin?' artículos':'+ artículos');
    var m0=document.getElementById('invMas');
    if(m0) m0.innerHTML=_invFin?('Fin del listado · '+_invRows.length+' artículos'):'Baja para cargar más…';
  } else {
    window._invVolviendo=false;
    _invRows=[]; _invOffset=0; _invFin=false;
    _invCargarMas();
  }

  // Scroll infinito sobre la ventana
  if(!window._invScrollHook){
    window._invScrollHook=true;
    window.addEventListener('scroll', function(){
      if(PG!=='inventario' || _invCargando || _invFin) return;
      var mas=document.getElementById('invMas'); if(!mas) return;
      var r=mas.getBoundingClientRect();
      if(r.top < (window.innerHeight+300)) _invCargarMas();
    }, {passive:true});
  }
}

function _invSetDept(k){
  _invDept=k;
  rInventario();
}
function _invSetOrden(v){
  _invOrden=v; _invRows=[]; _invOffset=0; _invFin=false;
  var b=document.getElementById('invBody'); if(b) b.innerHTML='';
  _invCargarMas();
}
function _invBuscar(v){
  _invQ=v;
  clearTimeout(_invBuscarTimer);
  _invBuscarTimer=setTimeout(function(){
    _invRows=[]; _invOffset=0; _invFin=false;
    var b=document.getElementById('invBody'); if(b) b.innerHTML='';
    _invCargarMas();
  }, 350);
}

async function _invCargarMas(){
  if(_invCargando||_invFin) return;
  _invCargando=true;
  var mas=document.getElementById('invMas');
  if(mas) mas.innerHTML='<span class="ai-ring g" style="vertical-align:-2px"></span> Cargando…';
  try{
    var url=SB+'/rest/v1/inventario?select='+_INV_CAMPOS
      +'&order='+_invOrden+'&limit='+_invTanda+'&offset='+_invOffset;
    // El departamento del usuario acota lo que ve, igual que en el resto del
    // portal. Si ve todos, manda el chip elegido en la tabla.
    var patron=(CU&&_deptAcotado())?_deptPrimero():_invDeptPatron(_invDept);
    if(patron) url+='&grupo=ilike.*'+encodeURIComponent(patron)+'*';
    var q=String(_invQ||'').trim();
    if(q){
      /* v768: por PALABRAS, no la frase exacta. «tabla planchar» encuentra
         «TABLA DE PLANCHAR Metal», «FORRO P/TABLA D/PLANCHAR»…: cada palabra
         tiene que estar en algún campo, en cualquier orden y con lo que sea
         en medio. Las palabras de relleno (de, para, con…) no cuentan. */
      var _vacias={de:1,del:1,la:1,el:1,los:1,las:1,para:1,con:1,y:1,en:1,por:1,
                   a:1,al:1,un:1,una:1,sin:1,of:1,the:1,and:1,'for':1,with:1};
      var pals=q.replace(/[(),*"\\]/g,' ').split(/\s+/).filter(function(w){
        return w && !_vacias[w.toLowerCase()];
      });
      if(!pals.length) pals=[q.replace(/[(),*"\\]/g,' ').trim()];
      var campoOr=function(w){
        var e=encodeURIComponent(w);
        return 'or(itemcode.ilike.*'+e+'*,itemname.ilike.*'+e+'*,frgnname.ilike.*'+e
          +'*,codebars.ilike.*'+e+'*,nombre_proveedor.ilike.*'+e+'*,cardcode.ilike.*'+e+'*)';
      };
      if(pals.length===1) url+='&'+campoOr(pals[0]).replace(/^or\(/,'or=(');
      else url+='&and=('+pals.map(campoOr).join(',')+')';
    }
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      // Alguna columna opcional puede no existir todavía (por ejemplo
      // hist_comprado o caracteristicas). Se reintenta con lo básico.
      var t=await r.text();
      console.warn('inventario, reintento sin columnas opcionales:', r.status, t);
      var basico=_INV_CAMPOS.split(',').filter(function(c){
        return ['hist_comprado','caracteristicas','subg','u_cant_ult_ent','fechaentrada','u_color','u_tamano'].indexOf(c)<0;
      }).join(',');
      url=url.replace('select='+_INV_CAMPOS, 'select='+basico);
      r=await fetch(url,{headers:SBH});
      if(!r.ok){ throw new Error('HTTP '+r.status); }
    }
    var rows=await r.json();
    if(!Array.isArray(rows)) rows=[];
    if(rows.length<_invTanda) _invFin=true;
    _invOffset+=rows.length;
    _invRows=_invRows.concat(rows);
    _invPintar(rows);
  }catch(e){
    console.warn('inventario:',e);
    if(mas) mas.innerHTML='<span style="color:var(--text-danger)">No se pudo cargar: '+_esc(e.message||String(e))+'</span>';
    _invCargando=false; return;
  }
  // Los SKU que todavía no están en SAP se agregan arriba, en la primera
  // tanda. Vienen del catálogo NO SAP, no de la consulta a inventario.
  if(_invOffset<=_invTanda){
    try{
      var _ns=_invNoSapFilas();
      // Si el mismo código ya vino de SAP, no se duplica la fila: se queda la
      // de SAP —que es la real, con existencias— y se le pasa la foto de la
      // ficha, que muchas veces es la única imagen que hay.
      var _cambioFoto=false;
      if(_ns.length && _invRows.length){
        var _ySap={};
        _invRows.forEach(function(r){
          if(!r._nosap && r.itemcode) _ySap[String(r.itemcode).trim().toUpperCase()]=r;
        });
        _ns=_ns.filter(function(n){
          var fila=_ySap[String(n.itemcode||'').trim().toUpperCase()];
          if(!fila) return true;
          if(!fila.foto && n.foto){ fila.foto=n.foto; _cambioFoto=true; }
          return false;
        });
      }
      // Se repinta si hay filas nuevas O si a alguna de SAP se le puso foto.
      // Antes solo se repintaba con filas nuevas, así que cuando el duplicado
      // se descartaba la foto se asignaba pero la pantalla no se enteraba.
      if(_ns.length || _cambioFoto){
        if(_ns.length) _invRows=_ns.concat(_invRows);
        var _b=document.getElementById('invBody');
        if(_b){ _b.innerHTML=''; _invPintar(_invRows); }
      }
    }catch(e){ console.warn('[inventario] SKU no SAP:', e); }
  }
  _invCargando=false;
  if(mas) mas.innerHTML=_invFin
    ? (_invRows.length?('Fin del listado · '+_invRows.length+' artículos'):'')
    : 'Baja para cargar más…';
  var c=document.getElementById('invCnt');
  if(c) c.textContent=_invRows.length+(_invFin?' artículos':'+ artículos');
  if(!_invRows.length){
    var b=document.getElementById('invBody');
    if(b) b.innerHTML='<div class="empty" style="padding:20px;color:var(--text-muted)"><i class="ti ti-search-off" style="font-size:20px"></i><br>Ningún artículo coincide con la búsqueda.</div>';
  }
  // Si la primera tanda no llenó la pantalla, se pide la siguiente
  if(!_invFin && document.body.scrollHeight<=window.innerHeight+50) setTimeout(_invCargarMas,60);
}

// Ajusta el ancho de la columna SKU al código más largo que se haya cargado,
// para que ninguna referencia salga cortada y la tabla siga cuadrada.
function _invAjustarSKU(){
  var max=0;
  (_invRows||[]).forEach(function(x){
    var l=String(x.itemcode||'').length;
    if(l>max) max=l;
  });
  if(!max) return;
  var w=Math.min(280, Math.max(116, Math.round(max*7.2)+22));   // ancho del texto + holgura
  var box=document.getElementById('page-inventario');
  if(box) box.style.setProperty('--inv-sku-w', w+'px');
}

// Cuando la foto que declara SAP no carga, se prueba la del catálogo NO SAP
// antes de dar el artículo por sin imagen. SAP declara el nombre aunque el
// archivo no esté en el bucket, así que el fallo solo se ve al intentarlo.
function _invFotoFalla(img){
  try{
    // El listado probaba UNA sola forma del nombre y se rendía; la ficha
    // técnica probaba veinte y por eso allí sí aparecía la imagen. Ahora el
    // listado recorre las mismas: SAP guarda el nombre con mayúsculas o
    // extensiones que no coinciden con el archivo del bucket.
    var pn=img.getAttribute('data-pic')||'';
    if(pn){
      var i=Number(img.dataset.intento||0);
      var alts=[];
      var base=String(pn).trim(), sinExt=base.replace(/\.[^.]+$/,'');
      ['', '.jpg', '.JPG', '.jpeg', '.png', '.PNG', '.webp'].forEach(function(ext){
        var n = ext ? (sinExt+ext) : base;
        [n, n.toLowerCase(), n.toUpperCase()].forEach(function(v){
          var u=FOTO_BASE+encodeURIComponent(v);
          if(alts.indexOf(u)<0) alts.push(u);
        });
      });
      if(i<alts.length){
        img.dataset.intento=String(i+1);
        img.src=alts[i];
        return;
      }
    }
    // Agotadas las de SAP: la del catálogo NO SAP, si la hay
    var alt=img.getAttribute('data-alt')||'';
    if(alt && !img.dataset.probado){
      img.dataset.probado='1';
      img.dataset.intento='999';
      img.src=alt;
      return;
    }
    if(img.classList && img.classList.contains('inv-zoom')){ img.remove(); return; }
    if(img.parentNode) img.parentNode.innerHTML='<i class="ti ti-photo-off"></i>';
  }catch(e){}
}

function _invPintar(rows){
  var b=document.getElementById('invBody'); if(!b) return;
  var h='';
  rows.forEach(function(x){
    // Los SKU no SAP traen su foto en la ficha (viene del Excel del
    // proveedor); los de SAP la arman a partir de picturname.
    // Los SKU no SAP traen su foto en la ficha (viene del Excel del
    // proveedor); los de SAP la arman a partir de picturname. Y si el
    // artículo está en SAP pero todavía sin imagen, se usa la del proveedor:
    // es la única que hay hasta que alguien la cargue en el ERP.
    // SAP declara un nombre de foto aunque el archivo no esté en el bucket,
    // así que no basta con encadenar: la URL de SAP existe pero no carga.
    // Se pinta la de SAP y, si falla, se cambia sola por la del proveedor.
    var _fotoSap=x.foto || _repFotoUrl(x.picturname);
    var _fotoAlt=_fotoNoSapDeSku(x.itemcode);
    var foto=_fotoSap || _fotoAlt;
    var idx=_invRows.indexOf(x);
    var _sku=String(x.itemcode||'').replace(/'/g,'');
    var _marcado=!!(window._invSel||{})[_sku.toUpperCase()];
    h+='<div class="inv-row'+(x._nosap?' inv-nosap':'')+'" onclick="_invFicha(\''+_esc(_sku)+'\')">'
      +'<div style="flex:0 0 52px">'
        +(foto
          ?'<div class="inv-foto"><img src="'+_esc(foto)+'" loading="lazy" data-pic="'+_esc(x.picturname||'')+'" data-alt="'+_esc(_fotoAlt||'')+'" onerror="_invFotoFalla(this)"><img class="inv-zoom" src="'+_esc(foto)+'" loading="lazy" data-pic="'+_esc(x.picturname||'')+'" data-alt="'+_esc(_fotoAlt||'')+'" onerror="_invFotoFalla(this)"></div>'
          :'<div class="inv-foto"><i class="ti ti-photo-off"></i></div>')
      +'</div>'
      +'<div class="inv-sku" title="'+_esc(x.itemcode||'')+'">'+_esc(x.itemcode||'')+'</div>'
      +'<div class="inv-desc" title="'+_esc(x.itemname||'')+'">'+_esc(x.itemname||'')+'</div>'
      +'<div class="inv-num inv-exi">'+_fmtN2(x.onhand)+'</div>'
      +'<div class="inv-num inv-res">'+_fmtN2(x.iscommited)+'</div>'
      +'<div class="inv-num inv-dis">'+_fmtN2(_invDisp(x))+'</div>'
      +(function(){
          var lleg=_invLlegadaTxt(x);
          return '<div class="inv-num inv-lle"'+(lleg?(' title="Llega el '+_esc(lleg)+'"'):'')+'>'
            +_fmtN2(x.onorder)
            +((Number(x.onorder)>0 && lleg)
              ? ('<div style="font-size:9px;font-weight:600;color:'+_invLlegadaColor(x)+'">('+_esc(lleg)+')</div>')
              : '')
            +'</div>';
        })()
      +'<div class="inv-num" style="flex:0 0 96px;font-weight:600">'+(_invNum(x.precioventa)?fmt(x.precioventa):'—')+'</div>'
      +'<div style="flex:0 0 38px;display:flex;justify-content:center" onclick="event.stopPropagation()">'
        +'<input type="checkbox" class="inv-check"'+(_marcado?' checked':'')
        +' title="Agregar al catálogo"'
        +' onchange="_invSelMarcar(\''+_esc(_sku)+'\',this.checked,event)"'
        +' style="cursor:pointer;width:15px;height:15px">'
      +'</div>'
      +'<div class="inv-fill"></div>'
    +'</div>';
  });
  b.insertAdjacentHTML('beforeend', h);
  _invAjustarSKU();
}

// ── Ficha técnica del artículo ──
function _invCarac(c, claves){
  if(!c) return '';
  if(typeof c==='string'){ try{ c=JSON.parse(c); }catch(e){ return ''; } }
  if(typeof c!=='object') return '';
  var keys=Object.keys(c);
  for(var i=0;i<keys.length;i++){
    var kl=keys[i].toLowerCase();
    for(var j=0;j<claves.length;j++){
      if(kl.indexOf(claves[j])>=0 && c[keys[i]]!=null && c[keys[i]]!=='') return String(c[keys[i]]);
    }
  }
  return '';
}

// Ficha del artículo. Se puede abrir desde Consulta de inventario, desde el
// listado de una reposición o desde cualquier otro lado: si el artículo no
// está en memoria se trae del inventario, así siempre se ve lo mismo.
window._invFichaCache = window._invFichaCache || {};

async function _invFicha(itemcode){
  var cod=String(itemcode||'').trim();
  if(!cod){ showT('Sin código de producto'); return; }
  // Se busca primero en lo que ya está cargado, para abrir al instante
  var x=(_invRows||[]).find(function(r){ return String(r.itemcode)===cod; })
     || window._invFichaCache[cod.toUpperCase()];
  if(!x){
    var enRep=(typeof _repData!=='undefined'&&_repData)
      ? _repData.find(function(r){ return String(r.itemcode)===cod; }) : null;
    // Solo sirve si trae la ficha técnica; si no, se consulta el inventario
    if(enRep && enRep.caracteristicas) x=enRep;
  }
  if(!x){
    try{
      var url=SB+'/rest/v1/inventario?select='+_INV_CAMPOS+'&itemcode=eq.'+encodeURIComponent(cod)+'&limit=1';
      var r=await fetch(url,{headers:SBH});
      if(!r.ok){
        // Alguna columna opcional puede no existir todavía
        var basico=_INV_CAMPOS.split(',').filter(function(c){
          return ['hist_comprado','caracteristicas','subg','u_cant_ult_ent','fechaentrada','u_color','u_tamano'].indexOf(c)<0;
        }).join(',');
        r=await fetch(SB+'/rest/v1/inventario?select='+basico+'&itemcode=eq.'+encodeURIComponent(cod)+'&limit=1',{headers:SBH});
      }
      if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length) x=f[0]; }
    }catch(e){ console.warn('ficha producto:',e); }
    if(x) window._invFichaCache[cod.toUpperCase()]=x;
  }
  if(!x){
    // Puede ser un SKU nuevo que todavía no está en SAP
    var nuevo=(window._catNoSap||[]).find(function(c){
      return c.tipo==='item' && String(c.itemcode||'').toUpperCase()===cod.toUpperCase();
    });
    if(nuevo){
      x={ itemcode:nuevo.itemcode, itemname:nuevo.itemname, onhand:0, iscommited:0, onorder:0,
          precioventa:0, fob:nuevo.precio||0, cif:0, picturname:'',
          cardcode:nuevo.cardcode, nombre_proveedor:nuevo.cardname,
          colores:nuevo.colores||'', _skuNuevo:true };
    }
  }
  if(!x){ showT('No se encontró el artículo '+cod); return; }
  return _invFichaRender(x);
}

function _invFichaRender(x){
  var carac=x.caracteristicas;
  function cv(k){ return _invCarac(carac,k); }

  // Si SAP no tiene imagen usable, se usa la del catálogo NO SAP, igual
  // que en el listado. El onerror de abajo cubre el caso de que SAP
  // declare un nombre cuyo archivo no está en el bucket.
  var _fotoAlt=_fotoNoSapDeSku(x.itemcode);
  var foto=_repFotoUrl(x.picturname) || _fotoAlt;
  var disp=_invDisp(x);

  var ficha=[
    {ic:'ti-ruler',        c:'#E0A82E', l:'Tamaño',        v:(x.u_tamano||cv(['tamano','tama','medida','size','dimens']))},
    {ic:'ti-cube',         c:'#1FA6A6', l:'Cubicaje',      v:(x.volumen?(Math.round(x.volumen*100000)/100000)+' pies³':cv(['cxblt','cubicaje','volumen']))},
    {ic:'ti-weight',       c:'#6B7280', l:'Peso producto', v:(x.peso?(Math.round(x.peso*100)/100)+' kg':cv(['peso','weight']))},
    {ic:'ti-tag',          c:'#E0457B', l:'Marca',         v:(x.marca||cv(['marca','brand']))},
    {ic:'ti-world',        c:'#2E9E5B', l:'Origen',        v:cv(['porigen','origen','origin','pais','country'])},
    {ic:'ti-weight',       c:'#B98A3E', l:'Peso bulto',    v:cv(['pxblt','pesobulto','peso bulto'])},
    {ic:'ti-box',          c:'#D98C3A', l:'Tamaño bulto',  v:cv(['cartonsize','tamanobulto','carton'])},
    {ic:'ti-stack-2',      c:'#3B82C4', l:'Piezas por bulto', v:(x.unidadesbulto||x.salpackun||cv(['piezas','pcs']))},
    {ic:'ti-palette',      c:'#9B4DCA', l:'Color',         v:(x.u_color||cv(['color']))},
    {ic:'ti-list-details', c:'#7C6FD0', l:'Composición',   v:cv(['composic','compo','material','tela','fabric','content','hecho','confeccion','fibra','algod','poliest','composition'])},
    {ic:'ti-barcode',      c:'#4B5563', l:'Código de barras', v:x.codebars}
  ].filter(function(i){ return i.v!=null && String(i.v).trim()!==''; });

  var nota=x.usertext||cv(['nota','note','remarks','observacion','comentario']);

  var ovPrev=document.getElementById('invFichaOv'); if(ovPrev) ovPrev.remove();
  var ov=document.createElement('div');
  ov.id='invFichaOv';
  // Por encima de cualquier modal abierto: desde el costeo se abría detrás
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:12000;display:flex;align-items:center;justify-content:center;padding:16px';
  var h='<div style="background:var(--surface-0);border-radius:12px;max-width:620px;width:100%;max-height:92vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;padding:15px 18px;border-bottom:0.5px solid var(--border);gap:10px">'
    +'<div style="min-width:0"><div style="font-size:15px;font-weight:700">'+_esc(x.itemcode||'')+'</div>'
    +'<div style="font-size:12px;color:var(--text-secondary);margin-top:2px">'+_esc(x.itemname||'')+'</div>'
    +(x.frgnname?('<div style="font-size:11px;color:var(--text-muted);margin-top:1px">'+_esc(x.frgnname)+'</div>'):'')
    +'</div>'
    +'<button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';

  h+='<div style="padding:16px 18px">';
  if(x._skuNuevo){
    h+='<div style="background:var(--pastel-lila);border:1px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-lila)">'
      +'<i class="ti ti-tags"></i> <b>SKU nuevo:</b> todavía no existe en SAP, así que no tiene stock ni precios. '
      +'Está registrado en <b>Proveedores y SKU BORRADOR</b>.</div>';
  }
  // Foto + stocks
  h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:14px">';
  h+=foto
    ?'<img data-nosap="'+_esc(_fotoAlt||'')+'" src="'+_esc(foto)+'" onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(x.itemcode||'')+' '+String(x.itemname||'').replace(/\x27/g,''))+'\')" onerror="_costFotoAlt(this,\''+_esc(String(x.picturname||'').replace(/\x27/g,''))+'\')" title="Clic para ver la foto en grande" style="width:130px;height:130px;object-fit:contain;border:0.5px solid var(--border);border-radius:9px;background:var(--surface-2);flex-shrink:0;cursor:zoom-in">'
    :'<div style="width:130px;height:130px;border:0.5px solid var(--border);border-radius:9px;display:flex;align-items:center;justify-content:center;background:var(--surface-1);flex-shrink:0"><i class="ti ti-photo-off" style="font-size:26px;color:var(--text-muted)"></i></div>';
  h+='<div style="flex:1;min-width:190px;display:grid;grid-template-columns:1fr 1fr;gap:7px">'
    +_invCaja('Existencia', _fmtN2(x.onhand), '#1D4ED8')
    +_invCajaClic('Reservado', _fmtN2(x.iscommited), '#DC2626',
        _invNum(x.iscommited)>0 ? ('verSeparado(\''+_esc(String(x.itemcode||'').replace(/'/g,''))+'\')') : '',
        'Ver quién tiene esta mercancía separada')
    +_invCaja('Disponible', _fmtN2(disp), '#15803D')
    +_invCaja('Por llegar', _fmtN2(x.onorder)
        +((Number(x.onorder)>0 && _invLlegadaTxt(x))
          ? ('<div style="font-size:10px;font-weight:600;color:'+_invLlegadaColor(x)+';margin-top:2px">'
             +'llega '+_esc(_invLlegadaTxt(x))
             +((Number(x.ordenes_abiertas)||0)>1
               ? ('<br><span style="font-weight:400;color:var(--text-muted)">'
                  +x.ordenes_abiertas+' órdenes abiertas</span>')
               : '')
             +'</div>')
          : ''), '#EA580C')
    +'</div>';
  h+='</div>';

  // Precios
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:14px">'
    +_invPrecio('Precio venta', x.precioventa, '#166534')
    +(CU.verCostos?_invPrecio('FOB', x.fob, '#B45309'):'')
    +(CU.verCostos?_invPrecio('CIF', x.cif, '#5B21B6'):'')
    +(CU.verCostos&&_invNum(x.lastpurprc)?_invPrecio('Última compra', x.lastpurprc, '#0c447c'):'')
    // El margen histórico: la ganancia de todas las ventas del artículo,
    // igual que el Gross Profit % del reporte de ventas de SAP.
    +(function(){
        var hm=_margenHistDe(x.itemcode);
        if(!hm) return '';
        var m=Number(hm.margen_pct);
        var col=(m<0)?'#b91c1c':(m<REP_MARGEN_MIN?'#B45309':'#166534');
        var t='Sobre todas las ventas del artículo: '+fmt(hm.ventas)+' facturados y '
          +fmt(hm.ganancia)+' de ganancia'
          +(hm.unidades?(', '+_fmtN2(hm.unidades)+' unidades'):'')
          +(hm.facturas?(' en '+hm.facturas+' factura(s)'):'')+'.';
        return '<div title="'+_esc(t)+'" style="border:0.5px solid var(--border);border-radius:9px;'
          +'padding:6px 11px;background:var(--surface-1);cursor:help">'
          +'<div style="font-size:9px;color:var(--text-muted);text-transform:uppercase;letter-spacing:.03em">'
            +'Margen histórico</div>'
          +'<div style="font-size:15px;font-weight:800;color:'+col+'">'+m.toFixed(1)+'%'
          +(m<REP_MARGEN_MIN?' <i class="ti ti-arrow-down" style="font-size:12px;color:var(--t-rojo3)"></i>':'')
          +'</div></div>';
      })()
    +'</div>';

  // Proveedor
  if(x.cardcode||x.nombre_proveedor){
    var cc=String(x.cardcode||'').replace(/'/g,'');
    h+='<div style="border:1px solid #85B7EB;background:var(--pastel-azul);border-radius:9px;padding:10px 12px;margin-bottom:14px">'
      +'<div style="font-size:10.5px;text-transform:uppercase;letter-spacing:.05em;color:var(--t-azul);font-weight:700;margin-bottom:4px">Proveedor</div>'
      +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +(cc?('<span onclick="_invIrAProveedor(\''+_esc(cc)+'\')" title="Ver este proveedor y hacer reposición" style="background:#0c447c;color:#fff;border-radius:6px;padding:3px 9px;font-size:12px;font-weight:700;cursor:pointer">'+_esc(cc)+' <i class="ti ti-arrow-right" style="font-size:11px"></i></span>'):'')
      +'<span style="font-size:12.5px;color:var(--t-azul);flex:1;min-width:120px">'+_esc(x.nombre_proveedor||'')+'</span>'
      +'</div>'
      +(cc?'<div style="font-size:10px;color:var(--t-azul);opacity:.8;margin-top:5px">Pulsa el código para ir al proveedor y arrancar una reposición.</div>':'')
      +'</div>';
  }

  // Ficha técnica
  if(ficha.length){
    h+='<div style="font-size:12px;font-weight:700;margin-bottom:4px"><i class="ti ti-clipboard-list"></i> Ficha técnica</div>';
    h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));gap:2px 18px;margin-bottom:6px">';
    ficha.forEach(function(i){
      h+='<div style="display:flex;gap:10px;align-items:flex-start;padding:9px 2px">'
        +'<div style="flex:0 0 34px;height:34px;border-radius:9px;background:'+i.c+'1f;display:flex;align-items:center;justify-content:center;color:'+i.c+'"><i class="'+i.ic+'" style="font-size:16px"></i></div>'
        +'<div style="min-width:0"><div style="font-size:10px;letter-spacing:.05em;text-transform:uppercase;color:var(--text-muted);font-weight:600">'+_esc(i.l)+'</div>'
        +'<div style="font-size:13px;font-weight:600;word-break:break-word">'+_esc(String(i.v))+'</div></div></div>';
    });
    h+='</div>';
  }

  // Movimiento de compra
  if(_invNum(x.hist_comprado)||_invNum(x.u_cant_ult_ent)||x.fechaentrada){
    h+='<div style="border-top:0.5px solid var(--border);margin-top:8px;padding-top:9px;display:flex;gap:14px;flex-wrap:wrap;font-size:11.5px;color:var(--text-secondary)">'
      +(_invNum(x.u_cant_ult_ent)?('<span>Últ. compra: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b></span>'):'')
      +(_invNum(x.hist_comprado)?('<span>Hist. comprado: <b style="color:var(--t-lila)">'+_fmtN2(x.hist_comprado)+'</b></span>'):'')
      +(x.fechaentrada?('<span>Fecha entrada: <b>'+_esc(String(x.fechaentrada).slice(0,10))+'</b></span>'):'')
      +'</div>';
  }

  if(nota && String(nota).trim()){
    h+='<div style="margin-top:12px;padding:11px 13px;background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px">'
      +'<div style="font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:var(--t-oro);font-weight:700;margin-bottom:3px">Nota</div>'
      +'<div style="font-size:12.5px;color:#5A4A1F;line-height:1.5;white-space:pre-wrap;word-break:break-word">'+_esc(String(nota))+'</div></div>';
  }

  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// Recuadro con acción (el de Reservado abre los pedidos que la tienen separada)
function _invCajaClic(lbl, val, col, accion, titulo){
  if(!accion) return _invCaja(lbl, val, col);
  return '<div onclick="event.stopPropagation();'+accion+'" title="'+_esc(titulo||'')+'"'
    +' style="background:var(--surface-1);border:1px solid '+col+'66;border-radius:8px;padding:7px 10px;cursor:pointer">'
    +'<div style="font-size:9.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-muted);font-weight:600">'+lbl
      +' <i class="ti ti-external-link" style="font-size:10px;color:'+col+'"></i></div>'
    +'<div style="font-size:15px;font-weight:700;color:'+col+';text-decoration:underline;text-decoration-style:dotted;text-underline-offset:3px">'+val+'</div></div>';
}
// Foto del artículo a pantalla completa
function _invFotoGrande(url, titulo){
  if(!url) return;
  var ov=document.createElement('div');
  ov.id='invFotoOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.88);z-index:12500;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  // Si la imagen tampoco carga aquí, se dice: antes quedaba un hueco negro
  // y no había forma de saber si el problema era la foto o el visor.
  ov.innerHTML='<img src="'+_esc(url)+'" onerror="this.style.display=\'none\';'
    +'var a=this.nextElementSibling; if(a) a.style.display=\'block\';"'
    +' style="max-width:96vw;max-height:84vh;object-fit:contain;border-radius:10px;background:var(--surface-2)">'
    +'<div style="display:none;color:#fff;background:rgba(255,255,255,.08);'
    +'border:1px solid rgba(255,255,255,.25);border-radius:10px;padding:18px 22px;'
    +'text-align:center;max-width:520px">'
    +'<div style="font-size:26px">🖼️</div>'
    +'<div style="font-size:14px;margin-top:8px">Esta imagen no está en el bucket</div>'
    +'<div style="font-size:11.5px;color:#bbb;margin-top:6px;word-break:break-all">'
    +_esc(url)+'</div></div>'
    +'<div style="color:#fff;font-size:13px;margin-top:12px;text-align:center;max-width:90vw">'+_esc(titulo||'')+'</div>'
    +'<div style="color:#bbb;font-size:11px;margin-top:5px">Clic en cualquier lado para cerrar</div>'
    +'<button onclick="event.stopPropagation();window.open(\''+_esc(url)+'\',\'_blank\')" style="margin-top:10px;background:rgba(255,255,255,.15);color:#fff;border:1px solid rgba(255,255,255,.35);border-radius:8px;padding:6px 14px;cursor:pointer;font-size:12px"><i class="ti ti-external-link"></i> Abrir en pestaña nueva</button>';
  ov.addEventListener('click', function(){ ov.remove(); });
  document.body.appendChild(ov);
}

function _invCaja(lbl, val, col){
  return '<div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:7px 10px">'
    +'<div style="font-size:9.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-muted);font-weight:600">'+lbl+'</div>'
    +'<div style="font-size:15px;font-weight:700;color:'+col+'">'+val+'</div></div>';
}
function _invPrecio(lbl, v, col){
  if(!_invNum(v)) return '';
  return '<div style="border:1px solid '+col+'55;border-radius:8px;padding:5px 11px">'
    +'<div style="font-size:9.5px;text-transform:uppercase;color:var(--text-muted);font-weight:600">'+lbl+'</div>'
    +'<div style="font-size:13.5px;font-weight:700;color:'+col+'">'+fmt(v)+'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  BARRA DE "VOLVER"
//  Cuando se salta de una pantalla a otra (por ejemplo del inventario a
//  reposiciones), queda una barra arriba para regresar de donde se vino.
//  Se pinta sobre el body, así sobrevive a los repintados de la página.
// ═══════════════════════════════════════════════════════════════════════════
window._navVolver=null;   // {a:'inventario', l:'Consulta inventario', en:'reposiciones'}

function _navSetVolver(a, etiqueta, en){
  window._navVolver={a:a, l:etiqueta, en:en};
  _navPintarVolver();
}
function _navLimpiarVolver(){
  window._navVolver=null;
  var b=document.getElementById('navVolverBar');
  if(b) b.remove();
}
function _navPintarVolver(){
  var v=window._navVolver;
  var b=document.getElementById('navVolverBar');
  if(!v || PG!==v.en){ if(b) b.remove(); return; }
  if(b) return;
  var d=document.createElement('div');
  d.id='navVolverBar';
  d.innerHTML='<span onclick="_navHacerVolver()" style="display:inline-flex;align-items:center;gap:6px;cursor:pointer">'
    +'<i class="ti ti-arrow-left"></i> Volver a '+_esc(v.l)+'</span>'
    +'<span onclick="_navLimpiarVolver()" title="Quitar" style="cursor:pointer;opacity:.6;font-size:15px;line-height:1">&times;</span>';
  document.body.appendChild(d);
}
function _navHacerVolver(){
  var v=window._navVolver; if(!v) return;
  var destino=v.a;
  _navLimpiarVolver();
  if(destino==='inventario') window._invVolviendo=true;   // no recargar la lista
  go(destino);
}

// ── Saltar al proveedor y ofrecer la reposición ──
function _invIrAProveedor(cardcode){
  var nombre='';
  var it=_invRows.find(function(r){ return String(r.cardcode)===String(cardcode); });
  if(it) nombre=it.nombre_proveedor||'';
  var msg='Proveedor '+cardcode+(nombre?('\n'+nombre):'')+'\n\n¿Quieres hacer una reposición de este proveedor?';
  if(!confirm(msg)) return;
  var ovF=document.getElementById('invFichaOv'); if(ovF) ovF.remove();   // cerrar la ficha
  _navSetVolver('inventario', 'Consulta inventario', 'reposiciones');
  // Se deja el proveedor pendiente: rReposiciones() lo toma cuando termina de
  // dibujar. Así no depende de cuánto tarde en cargar el catálogo.
  window._repPrefill=cardcode;
  showT('Abriendo reposición de '+cardcode+'…');
  go('reposiciones');
  // Respaldo por si la página ya estaba dibujada y no se vuelve a renderizar
  _invEsperarCampo(cardcode, 0);
}

function _invEsperarCampo(cardcode, intento){
  if(!window._repPrefill) return;          // ya lo tomó rReposiciones()
  if(PG!=='reposiciones') return;          // el usuario se fue a otro lado
  var inp=document.getElementById('rep-code');
  if(!inp){
    if(intento>100) return;                // ~15 s y se rinde en silencio
    return setTimeout(function(){ _invEsperarCampo(cardcode, intento+1); }, 150);
  }
  window._repPrefill=null;
  inp.value=cardcode;
  var d=document.getElementById('rep-provdrop'); if(d) d.style.display='none';
  try{
    var r=repGenerar();
    if(r && typeof r.catch==='function') r.catch(function(e){ console.warn('repGenerar:',e); });
  }catch(e){
    console.warn('repGenerar:',e);
    showT('No se pudo cargar el proveedor '+cardcode);
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUDES DE PAGO (ABONO / CANCELACIÓN)
//  Compras pide a contabilidad que deposite un abono o que cancele el saldo
//  final de una orden. Contabilidad las ve agrupadas por departamento en
//  Alertas y puede sacar un reporte imprimible con los totales.
//  Tabla Supabase: solicitudes_pago
// ═══════════════════════════════════════════════════════════════════════════
window._solPago=[];

async function _solPagoCargar(silencioso){
  try{
    // nullslast y un tope alto: con «order=solicitado_en.desc» a secas,
    // PostgreSQL pone los NULL PRIMERO. Las solicitudes cargadas por SQL no
    // llevan fecha, así que ocupaban el principio de la lista y, al llegar
    // al tope de 600, las nuevas se quedaban fuera y no le salían a nadie.
    var r=await fetch(SB+'/rest/v1/solicitudes_pago'
      +'?select=*&order=solicitado_en.desc.nullslast&limit=3000',{headers:SBH});
    if(!r.ok){ if(!silencioso) console.warn('solicitudes_pago:', r.status); window._solPago=[]; return []; }
    var rows=await r.json();
    window._solPago=Array.isArray(rows)?rows:[];
    _solSanarRecibidas();
  }catch(e){ console.warn('cargar solicitudes_pago:',e); window._solPago=[]; }
  return window._solPago;
}

// Las que tienen fecha de recepción pero se quedaron con el estado viejo:
// se corrigen en la base una sola vez por sesión, para que el reporte y los
// contadores digan lo mismo que la pantalla.
async function _solSanarRecibidas(){
  if(window._solSanadas) return;
  window._solSanadas=true;
  var malas=(window._solPago||[]).filter(function(x){
    var e=String(x.estado||'').trim().toLowerCase();
    return x.recibido_en && (e==='' || e==='pendiente');
  });
  if(!malas.length) return;
  _dbg('[SOL] '+malas.length+' solicitud(es) recibidas con el estado atrasado: se corrigen');
  for(var i=0;i<malas.length;i++){
    var ok=await _solPagoPatch(malas[i].id,{estado:'recibida'});
    if(ok) malas[i].estado='recibida';
    else break;              // la base no acepta «recibida»: ya avisó _solPagoPatch
  }
}

// Datos de la orden (SAP o NO SAP) para completar la solicitud
function _solPagoDatosOrden(oid){
  var o=(orders||[]).find(function(x){ return String(x.id)===String(oid); });
  if(o) return { proveedor:o.prov||'', dkc:o.num_proveedor||'', dept:o.dept||'',
                 total:Number(o.valor)||0, abonado:Number(o.abono)||0,
                 saldo:(Number(o.valor)||0)-(Number(o.abono)||0), eta:o.fechaEst||'' };
  var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
  if(p) return { proveedor:p.proveedor||'', dkc:p.dkc||p.num_orden||'', dept:p.dept||'',
                 total:Number(p.total)||0, abonado:Number(p.abonado)||0,
                 saldo:Number(p.saldo!=null?p.saldo:((Number(p.total)||0)-(Number(p.abonado)||0))), eta:'' };
  return { proveedor:'', dkc:'', dept:'', total:0, abonado:0, saldo:0, eta:'' };
}

// Crea (o actualiza) una solicitud
async function _solPagoCrear(oid, tipo, monto, nota){
  var d=_solPagoDatosOrden(oid);
  var fila={
    docnum:String(oid), tipo:tipo,
    proveedor:d.proveedor, dkc:d.dkc, dept:d.dept,
    monto:Number(monto)||0, eta:d.eta||null, nota:nota||null,
    estado:'pendiente',
    solicitado_por:(CU&&CU.name)||'', solicitado_en:new Date().toISOString()
  };
  try{
    var r=await fetch(SB+'/rest/v1/solicitudes_pago',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      console.warn('crear solicitud', r.status, t);
      showT('⚠ No se registró la solicitud: '+(/does not exist/i.test(t)?'falta la tabla solicitudes_pago':('error '+r.status)));
      return null;
    }
    var cr=null; try{ cr=await r.json(); }catch(e){}
    var nueva=(cr&&cr[0])||fila;
    window._solPago.unshift(nueva);
    try{ addNotif('contabilidad','💵 '+(tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación')+' — orden '+oid+' · '+fmt(fila.monto), oid, 'ti-coin', true); }catch(e){}

    // Y el aviso persistente, que no se pierde al recargar. Quien la manda
    // tiene que saber A QUIÉN le llegó: antes, si fallaba, solo se enteraba
    // la consola y se daba por enviada.
    var destinos=_avUsuariosPorRol('contabilidad');
    if(!destinos.length){
      showT('⚠ La solicitud quedó registrada, pero NO hay nadie con rol de '
        +'contabilidad a quien avisar. Dilo a sistemas.', 12000);
    } else {
      try{
        await _avSolicitud(destinos, nueva,
          (tipo==='abono'?'Nueva solicitud de abono':'Nueva solicitud de cancelación')
          +' · '+(nueva.proveedor||'')+' · '+fmt(nueva.monto),
          (tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación'));
        showT('✓ '+(tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación')
          +' enviada a contabilidad: '+destinos.map(function(u){ return u.name; }).join(', '),
          9000);
      }catch(e){
        console.warn('aviso a contabilidad:',e);
        showT('⚠ La solicitud quedó registrada, pero el aviso a contabilidad no salió. '
          +'Avísales por otra vía. ('+(e.message||e)+')', 14000);
      }
    }
    return nueva;
  }catch(e){ console.warn('crear solicitud:',e); return null; }
}

// Botón para pedir la cancelación del saldo final
function _solPagoBotonCancelacion(oid){
  var d=_solPagoDatosOrden(oid);
  if(d.saldo<=0) return '';
  return '<div style="background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-top:8px">'
    +'<div style="font-size:11.5px;font-weight:600;color:var(--t-marron);margin-bottom:5px"><i class="ti ti-file-invoice"></i> Solicitar cancelación del saldo final</div>'
    +'<div style="font-size:11px;color:var(--t-marron);margin-bottom:7px">Saldo pendiente: <b>'+fmt(d.saldo)+'</b></div>'
    +'<button class="btn bp" style="background:#B45309;font-size:11px;padding:6px 12px" onclick="_solPagoAbrirModal(\''+_esc(String(oid))+'\',\'cancelacion\')">'
    +'<i class="ti ti-send"></i> Solicitar cancelación a contabilidad</button></div>';
}

// Botón para pedir el abono
function _solPagoBotonAbono(oid){
  var d=_solPagoDatosOrden(oid);
  return '<div style="background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
    +'<div style="font-size:11.5px;font-weight:600;color:var(--t-verde);margin-bottom:5px"><i class="ti ti-coin"></i> Solicitar abono a contabilidad</div>'
    +'<div style="font-size:11px;color:var(--t-verde);margin-bottom:7px">Total '+fmt(d.total)+' · Abonado '+fmt(d.abonado)+' · Saldo <b>'+fmt(d.saldo)+'</b></div>'
    +'<button class="btn bp" style="background:#166534;font-size:11px;padding:6px 12px" onclick="_solPagoAbrirModal(\''+_esc(String(oid))+'\',\'abono\')">'
    +'<i class="ti ti-send"></i> Enviar solicitud de abono</button></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUD DE ABONO / CANCELACIÓN — pantalla emergente
//  Funciona igual que los correos de las etapas: sale por Azure desde el
//  correo de la compradora, con la orden firmada por gerencia ya adjunta y la
//  posibilidad de sumar otros documentos (debida diligencia, instrucciones de
//  abono, etc.). Al enviar, queda registrada para contabilidad y entra al
//  reporte de abonos y cancelaciones.
// ═══════════════════════════════════════════════════════════════════════════

// Descarga un archivo del storage y lo deja listo como adjunto en base64
// Busca el comprobante del abono ya pagado y lo suma a los adjuntos
async function _solPagoComprobanteAbono(oid, yaPuestos){
  yaPuestos=yaPuestos||{};
  // Los archivos del paso donde contabilidad sube el comprobante
  var claves=[];
  try{
    claves.push(oid+_subKeyDeposito(_PASO_DEP_PROV));
    claves.push(oid+_subKeyDeposito(_PASO_COMP_PROV));
  }catch(e){}
  claves.push(oid+'deposito_step1', oid+'deposito_step2');

  var vistos={}, cand=[];
  claves.forEach(function(k){
    if(!k || vistos[k]) return;
    vistos[k]=1;
    ((window._atts&&window._atts[k])||[]).forEach(function(a){
      if(a && a.url && !yaPuestos[a.url]) cand.push(a);
    });
  });
  if(!cand.length) return {puesto:false, motivo:'todavía no se subió'};

  // Se prefiere lo que parezca un comprobante de pago
  cand.sort(function(a,b){
    function pts(x){
      var n=String(x.name||'').toLowerCase();
      return (/comprob|transfer|pago|swift|wire|abono|deposit/.test(n)?0:1);
    }
    return pts(a)-pts(b);
  });

  var a=cand[0];
  var motivo={};
  var adj=await _solPagoAdjuntarDeStorage(a.url, a.name||('Comprobante_abono_'+oid+'.pdf'), motivo);
  if(!adj) return {puesto:false, motivo:motivo.txt||'no se pudo adjuntar'};
  window._mailAdj.push(adj);
  yaPuestos[a.url]=1;
  return {puesto:true, nombre:a.name};
}

async function _solPagoAdjuntarDeStorage(path, nombre, motivo){
  if(!path) return null;
  try{
    var url=DOCS_BASE + String(path).split('/').map(encodeURIComponent).join('/');
    var r=await fetch(url);
    if(!r.ok){
      if(motivo) motivo.txt='no se pudo descargar del servidor (error '+r.status+')';
      return null;
    }
    var blob=await r.blob();
    if(blob.size>MAIL_MAX_MB*1024*1024){
      // Antes se devolvía null sin decir nada y parecía un fallo cualquiera
      if(motivo) motivo.txt='pesa '+(blob.size/1048576).toFixed(1)+' MB y el límite del correo son '+MAIL_MAX_MB+' MB';
      return null;
    }
    var b64=await new Promise(function(res,rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=rej;
      fr.readAsDataURL(blob);
    });
    return { nombre:nombre||String(path).split('/').pop(),
             mime:blob.type||'application/octet-stream',
             contenido:b64, kb:Math.round(blob.size/1024) };
  }catch(e){ console.warn('adjuntar de storage:',e); return null; }
}

// Busca la orden firmada por gerencia para esta orden de compra
async function _solPagoOrdenFirmada(oid){
  var d=_solPagoDatosOrden(oid);
  var ors=[];
  var claves=[String(oid), d.dkc||''].filter(Boolean);
  for(var i=0;i<claves.length;i++){
    try{
      var url=SB+'/rest/v1/ordenes_firma?select=id,num_orden,dkc,archivo_firmado_path,archivo_firmado_nombre,estado'
        +'&or=(num_orden.eq.'+encodeURIComponent(claves[i])+',dkc.eq.'+encodeURIComponent(claves[i])+')'
        +'&archivo_firmado_path=not.is.null&limit=3';
      var r=await fetch(url,{headers:SBH});
      if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length){ ors=f; break; } }
    }catch(e){}
  }
  return ors[0]||null;
}

// Base del porcentaje: el total de la orden
function _solPagoBase(){
  var ctx=window._solPagoCtx; if(!ctx) return 0;
  var d=_solPagoDatosOrden(ctx.oid);
  return Number(d.total)||0;
}
// Se escribe el %: se calcula el monto
function _solPagoCalcMonto(){
  var pc=parseFloat((document.getElementById('sp-pct')||{}).value);
  var base=_solPagoBase();
  var inp=document.getElementById('sp-monto'); if(!inp) return;
  if(isNaN(pc)){ _solPagoNota(''); return; }
  var monto=Math.round(base*(pc/100)*100)/100;
  inp.value=monto.toFixed(2);
  _solPagoNota(pc.toFixed(2)+'% de '+fmt(base)+' = <b>'+fmt(monto)+'</b>');
  _solPagoSyncCuerpo();
}
// Se escribe el monto: se calcula el %
function _solPagoCalcPct(){
  var monto=parseFloat((document.getElementById('sp-monto')||{}).value);
  var base=_solPagoBase();
  var inp=document.getElementById('sp-pct'); if(!inp||!base) return;
  if(isNaN(monto)){ _solPagoNota(''); return; }
  var pc=Math.round((monto/base)*10000)/100;
  inp.value=pc.toFixed(2);
  _solPagoNota(fmt(monto)+' es el <b>'+pc.toFixed(2)+'%</b> de '+fmt(base));
  _solPagoSyncCuerpo();
}
function _solPagoSetPct(v, modo){
  var inp=document.getElementById('sp-pct'); if(!inp) return;
  inp.value=v; _solPagoCalcMonto();
  // "100% contra B/L" es el caso sin abono: se deja dicho en el correo, que es
  // lo que contabilidad necesita saber para no buscar un depósito anterior.
  if(modo==='bl'){
    _solPagoNota('Base: total de la orden '+fmt(_solPagoBase())
      +' · <b style="color:var(--t-verde)">100% contra copia de B/L, sin abono previo</b>');
    try{
      var c=document.getElementById('mail-cuerpo');
      if(c && c.value.indexOf('contra copia de B/L')<0){
        c.value=c.value.replace(/\n\nSaludos,/,
          '\n\nEsta orden se paga al 100% contra copia del B/L: no lleva abono previo.\n\nSaludos,');
      }
    }catch(e){}
  }
}
function _solPagoNota(txt){
  var d=document.getElementById('sp-calc'); if(!d) return;
  d.innerHTML=txt||('Base: total de la orden '+fmt(_solPagoBase()));
}

// Refleja el monto calculado en el cuerpo del correo, en la línea
// "Monto solicitado:". Si la persona reescribió el texto, respeta lo suyo y
// solo cambia esa línea.
function _solPagoSyncCuerpo(){
  var ta=document.getElementById('mail-cuerpo'); if(!ta) return;
  var monto=parseFloat((document.getElementById('sp-monto')||{}).value);
  if(isNaN(monto)) return;
  var pc=parseFloat((document.getElementById('sp-pct')||{}).value);
  var linea='Monto solicitado: '+fmt(monto)+(isNaN(pc)?'':(' ('+pc.toFixed(2)+'% de la orden)'));
  var lineas=String(ta.value||'').split('\n');
  var i=lineas.findIndex(function(l){ return /^\s*Monto solicitado\s*:/i.test(l); });
  if(i>=0) lineas[i]=linea;
  else {
    // Si no existe, se agrega antes de la despedida
    var j=lineas.findIndex(function(l){ return /^\s*(Adjunto|Saludos)/i.test(l); });
    if(j<0) j=lineas.length;
    lineas.splice(j,0,linea,'');
  }
  ta.value=lineas.join('\n');
}
// Chips de CC: se marcan y se escriben en el campo
function _solPagoToggleCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('sp-cc'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('.sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUD DE ABONO — ADJUNTOS Y DATOS DE TRANSFERENCIA
//  Se adjuntan solas las DOS órdenes firmadas por gerencia (la nuestra y la
//  del proveedor), la compradora suma la debida diligencia, y la IA lee las
//  instrucciones bancarias de esos documentos para escribirlas en el correo.
// ═══════════════════════════════════════════════════════════════════════════

// Trae las dos órdenes firmadas de la compra
async function _solPagoFirmadas(oid){
  var d=_solPagoDatosOrden(oid);
  var claves=[String(oid), d.dkc||''].filter(Boolean);
  for(var i=0;i<claves.length;i++){
    try{
      var url=SB+'/rest/v1/ordenes_firma?select=id,num_orden,dkc,proveedor,'
        +'archivo_firmado_path,archivo_firmado_nombre,archivo_firmado_path2,archivo_firmado_nombre2,'
        +'archivo_path,archivo_nombre,archivo_path2,archivo_nombre2,estado'
        +'&or=(num_orden.eq.'+encodeURIComponent(claves[i])+',dkc.eq.'+encodeURIComponent(claves[i])+')&limit=3';
      var r=await fetch(url,{headers:SBH});
      if(r.ok){
        var f=await r.json();
        if(Array.isArray(f)&&f.length){
          // Se prefiere la que ya está firmada
          var firmada=f.find(function(x){ return x.archivo_firmado_path; });
          return firmada||f[0];
        }
      }
    }catch(e){ console.warn('firmadas:',e); }
  }
  return null;
}

// Adjunta las dos órdenes firmadas y avisa qué se pudo y qué no
// Cortina con rueda grande mientras se preparan los adjuntos y se leen los
// datos bancarios: son varias descargas y una llamada a la IA.
function _spCargando(txt, sub){
  var ov=document.getElementById('spCargandoOv');
  if(!ov){
    ov=document.createElement('div');
    ov.id='spCargandoOv';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:10050;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px';
    ov.innerHTML='<div class="ai-ring" style="width:58px;height:58px;border-width:5px"></div>'
      +'<div id="spCargandoTxt" style="color:#fff;font-size:15px;font-weight:600;text-align:center;padding:0 24px"></div>'
      +'<div id="spCargandoSub" style="color:#c9c9c9;font-size:12px;text-align:center;padding:0 24px"></div>';
    document.body.appendChild(ov);
  }
  var t=document.getElementById('spCargandoTxt'); if(t) t.textContent=txt||'Preparando…';
  var u=document.getElementById('spCargandoSub'); if(u) u.textContent=sub||'';
}
function _spCargandoFin(){
  var ov=document.getElementById('spCargandoOv'); if(ov) ov.remove();
}

async function _solPagoAdjuntarFirmadas(oid){
  var res={puestos:[], faltan:[]};
  var yaPuestos={};

  // 1) Los documentos que compras subió al crear la orden NO SAP: son la
  //    orden de KCC y la del proveedor, y ya están en la etapa Pedido.
  var base=[];
  try{ base=_docsBaseOrden(oid); }catch(e){}
  // Se confirma contra la base que cada documento es DE ESTA ORDEN. En memoria
  // pueden quedar archivos de otras órdenes vistas antes, y así se colaba
  // cualquier cosa en la solicitud.
  var deLaOrden=null;
  try{
    var rv=await fetch(SB+'/rest/v1/compras_documentos?select=url&docnum=eq.'
      +encodeURIComponent(oid)+'&limit=200',{headers:SBH});
    if(rv.ok){
      var filasDoc=(await rv.json()||[]);
      // v740: si la orden no tiene NINGÚN documento registrado con su número
      // (pasa con las que nacieron como BORRADOR desde la compra para firma:
      // sus documentos se registraron con el número provisional), no se puede
      // usar el registro para filtrar: se descartaban TODOS y había que volver
      // a adjuntarlos a mano.
      if(filasDoc.length){
        deLaOrden={};
        filasDoc.forEach(function(d){ if(d.url) deLaOrden[d.url]=1; });
      }
    }
  }catch(e){ console.warn('verificar documentos:',e); }

  // v740: y los archivos que se subieron AL PROPIO PASO de la solicitud
  // («Archivos de este paso»): son de esta orden y de este paso, y antes no
  // se adjuntaban.
  try{
    var tipoSol=String((window._solPagoTipoActual)||'abono');
    var idxPaso=_pasoIdxDeposito(tipoSol==='cancelacion' ? _PASO_PAGO_FINAL : _PASO_SOL_ABONO);
    var propios=(idxPaso>=0 && window._atts) ? (window._atts[oid+'deposito_step'+idxPaso]||[]) : [];
    propios.forEach(function(a){ if(a && a.url) base.push(Object.assign({}, a, {_delPaso:true})); });
  }catch(e){ console.warn('archivos del paso:', e); }

  for(var b=0;b<base.length;b++){
    var a=base[b];
    if(!a.url || yaPuestos[a.url]) continue;
    // No pertenece a esta orden: se descarta
    if(deLaOrden && !deLaOrden[a.url] && !a._delPaso){
      console.warn('[solicitud] se descarta un documento que no es de la orden '+oid+':', a.name);
      continue;
    }
    // Solo documentos de compra: la orden y la proforma son PDF. Un Excel o
    // una foto sueltos no tienen nada que hacer en una solicitud de pago.
    // La orden y la proforma llegan en PDF, en imagen o en Excel: los tres
    // valen. Lo que se quiere dejar fuera es cualquier otro adjunto suelto.
    var ext=String(a.name||'').split('.').pop().toLowerCase();
    if(['pdf','jpg','jpeg','png','xlsx','xls','doc','docx'].indexOf(ext)<0){
      console.warn('[solicitud] se descarta por tipo de archivo:', a.name);
      continue;
    }
    var adjB=await _solPagoAdjuntarDeStorage(a.url, a.name||('documento_'+(b+1)+'.pdf'));
    if(adjB){ window._mailAdj.push(adjB); yaPuestos[a.url]=1; res.puestos.push(a.name||'documento de la orden'); }
  }

  // 2) Si la compra pasó por firma, se prefieren las versiones FIRMADAS
  var fr=await _solPagoFirmadas(oid);
  if(!fr){
    if(!res.puestos.length) res.faltan.push('las órdenes de compra (no se encontraron documentos de esta orden)');
    return res;
  }

  var docs=[
    {path:fr.archivo_firmado_path,  nombre:fr.archivo_firmado_nombre  || ('Orden_KCC_firmada_'+oid+'.pdf'), etiqueta:'orden de Kennedy firmada'},
    {path:fr.archivo_firmado_path2, nombre:fr.archivo_firmado_nombre2 || ('PI_proveedor_firmada_'+oid+'.pdf'), etiqueta:'orden del proveedor firmada'}
  ];
  // Si alguna no está firmada todavía, se manda la original
  if(!docs[0].path && fr.archivo_path)  docs[0]={path:fr.archivo_path,  nombre:fr.archivo_nombre  || 'Orden_KCC.pdf',      etiqueta:'orden de Kennedy (sin firmar)'};
  if(!docs[1].path && fr.archivo_path2) docs[1]={path:fr.archivo_path2, nombre:fr.archivo_nombre2 || 'PI_proveedor.pdf',   etiqueta:'orden del proveedor (sin firmar)'};

  for(var i=0;i<docs.length;i++){
    if(!docs[i].path){ if(!res.puestos.length) res.faltan.push(docs[i].etiqueta); continue; }
    if(yaPuestos[docs[i].path]) continue;                    // ya iba adjunto
    var adj=await _solPagoAdjuntarDeStorage(docs[i].path, docs[i].nombre);
    if(!adj){ res.faltan.push(docs[i].etiqueta+' (pesa demasiado o no se pudo leer)'); continue; }
    // Si es la versión firmada del mismo documento, reemplaza a la sin firmar
    var mismoNombre=String(docs[i].nombre||'').toLowerCase();
    window._mailAdj=window._mailAdj.filter(function(x){
      return !(x._base && String(x.nombre||'').toLowerCase()===mismoNombre);
    });
    window._mailAdj.push(adj);
    yaPuestos[docs[i].path]=1;
    res.puestos.push(docs[i].etiqueta);
  }
  // En una cancelación se adjunta también el comprobante del abono que ya se
  // pagó: contabilidad necesita verlo para calcular el saldo a cancelar.
  if(String(tipo||'')==='cancelacion'){
    try{
      var comp=await _solPagoComprobanteAbono(oid, yaPuestos);
      if(comp && comp.puesto) res.puestos.push('comprobante del abono');
      else if(comp && comp.motivo) res.faltan.push('el comprobante del abono ('+comp.motivo+')');
    }catch(e){ console.warn('comprobante del abono:',e); }
  }

  // Una sola copia de cada documento, comparando por nombre normalizado
  var vistos={};
  window._mailAdj=(window._mailAdj||[]).filter(function(a){
    var k=_docClave({name:a.nombre});
    if(!k) return true;
    if(vistos[k]) return false;
    vistos[k]=1; return true;
  });
  // El aviso también sin repetir
  var vp={};
  res.puestos=res.puestos.filter(function(x){ var k=String(x).toLowerCase(); if(vp[k]) return false; vp[k]=1; return true; });
  return res;
}

// ── Instrucciones bancarias leídas con IA ──
var _SP_CAMPOS=[
  {k:'beneficiary_customer', l:'BENEFICIARY CUSTOMER'},
  {k:'beneficiary_bank',     l:'BENEFICIARY BANK'},
  {k:'swift_code',           l:'SWIFT CODE'},
  {k:'account_number',       l:'ACCOUNT NUMBER'},
  {k:'beneficiary_address',  l:'BENEFICIARY ADDRESS'},
  {k:'bank_address',         l:'BANK ADDRESS'}
];
var _SP_FALTA='SOLICITAR INFO AL PROVEEDOR';

function _solPagoBloqueBanco(b){
  var t='\nDATOS DE TRANSFERENCIA:\n';
  _SP_CAMPOS.forEach(function(c){
    var v=String((b&&b[c.k])||'').trim();
    t+=c.l+': '+(v||_SP_FALTA)+'\n';
  });
  return t;
}

// Lee las instrucciones bancarias de los documentos ya adjuntos
async function _solPagoLeerBanco(oid){
  // Las rutas se buscan en TODOS lados: antes solo miraba `ordenes_firma`, así
  // que en una orden NO SAP que no pasó por firma no encontraba nada que leer.
  var rutas=[];
  function agregar(r){ if(r && rutas.indexOf(r)<0) rutas.push(r); }

  // 1) Los documentos que compras subió a la orden (aquí está la PI del proveedor)
  try{ _docsBaseOrden(oid).forEach(function(a){ agregar(a.url); }); }catch(e){}

  // 2) Lo que haya en compras_documentos por si no está en memoria
  try{
    var rd=await fetch(SB+'/rest/v1/compras_documentos?select=url,nombre_archivo&docnum=eq.'
      +encodeURIComponent(oid)+'&order=subido_en.asc&limit=50',{headers:SBH});
    if(rd.ok) (await rd.json()||[]).forEach(function(d){ agregar(d.url); });
  }catch(e){}

  // 3) Y las versiones firmadas, si la compra pasó por firma
  try{
    var fr=await _solPagoFirmadas(oid);
    if(fr) [fr.archivo_path2, fr.archivo_firmado_path2, fr.archivo_path, fr.archivo_firmado_path].forEach(agregar);
  }catch(e){}

  if(!rutas.length){ console.warn('[banco] no hay documentos donde buscar para', oid); return null; }

  // Los datos bancarios están en el documento del PROVEEDOR, así que ese va
  // primero. Nuestra orden (DKC/SKC) se deja para el final.
  function prioridad(r){
    // Solo el nombre del archivo: la ruta lleva el DKC y confundiría el orden
    var n=String(r||'').split('/').pop().toLowerCase();
    if(/proforma|invoice|\bpi\b|bank/.test(n)) return 0;   // el del proveedor primero
    if(/^dkc|^skc|kcc|kennedy/.test(n)) return 3;          // el nuestro al final
    return 1;
  }
  rutas.sort(function(a,b){ return prioridad(a)-prioridad(b); });
  rutas=rutas.slice(0,5);   // con 5 basta; no se gasta IA de más
  console.info('[banco] revisando '+rutas.length+' documento(s) de '+oid, rutas);

  var prompt='Del documento adjunto extrae UNICAMENTE las instrucciones bancarias del PROVEEDOR.\n'
    +'DONDE BUSCAR: suele estar al final del documento, en una seccion titulada BANK INSTRUCTIONS, BANK INFORMATION, '
    +'BANK DETAILS, BANKING DETAILS, BENEFICIARY, BENEFICIARY INFORMATION, WIRE INSTRUCTIONS, PAYMENT INSTRUCTIONS, '
    +'DATOS BANCARIOS o INSTRUCCIONES BANCARIAS. A veces viene resaltada en amarillo o en un recuadro aparte. '
    +'Revisa TODAS las paginas, incluida la ultima, antes de responder.\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues, con estas claves exactas:\n'
    +'{"beneficiary_customer":"","beneficiary_bank":"","swift_code":"","account_number":"","beneficiary_address":"","bank_address":"","deposito_pct":0,"terminos_pago":""}\n'
    +'REGLAS:\n'
    +'- "beneficiary_customer": el nombre de la empresa beneficiaria (BENEFICIARY / ACCOUNT NAME / NAME).\n'
    +'- "beneficiary_bank": el nombre del banco (BANK NAME / ADVISING BANK).\n'
    +'- "swift_code": el codigo SWIFT o BIC, tal cual, sin espacios.\n'
    +'- "account_number": el numero de cuenta o IBAN (A/C, ACCOUNT NO., ACCOUNT NUMBER).\n'
    +'- "beneficiary_address": la direccion de la empresa beneficiaria (BENEFICIARY ADDRESS).\n'
    +'- "bank_address": la direccion del banco (BANK ADDRESS / BANK ADD).\n'
    +'- Copia los valores EXACTAMENTE como aparecen. No los traduzcas ni los reformatees.\n'
    +'- "deposito_pct": el PORCENTAJE DE ANTICIPO que pide el proveedor, como numero sin el simbolo %. '
    +'Buscalo en los terminos de pago (PAYMENT TERMS, TERMS OF PAYMENT, CONDICIONES DE PAGO). '
    +'Ejemplos: "30% deposit, 70% balance" -> 30. "20% T/T in advance" -> 20. "50% down payment" -> 50. '
    +'"100% T/T before shipment" -> 100. Si no encontras ningun porcentaje, deja 0.\n'
    +'- "terminos_pago": la frase completa de los terminos, tal cual aparece.\n'
    +'- Si un dato NO aparece en el documento, deja esa clave como cadena vacia "". Nunca lo inventes.';

  for(var i=0;i<rutas.length;i++){
    try{
      var url=DOCS_BASE + String(rutas[i]).split('/').map(encodeURIComponent).join('/');
      var r=await fetch(url);
      if(!r.ok) continue;
      var blob=await r.blob();
      if(blob.size>8*1024*1024) continue;
      // Cualquier formato, no solo PDF o imagen
      var prep=await _iaDesdeBlob(blob, String(rutas[i]).split('/').pop());
      if(!prep) continue;
      var contenido=prep.bloques.concat([{type:'text', text:prompt}]);
      var obj=await _iaJSON(contenido, 1500);
      if(obj && (obj.swift_code||obj.account_number||obj.beneficiary_bank||obj.beneficiary_customer)){
        console.info('[banco] datos encontrados en', rutas[i]);
        return obj;
      }
    }catch(e){ console.warn('leer banco:',e); }
  }
  console.warn('[banco] ninguno de los '+rutas.length+' documentos traía instrucciones bancarias');
  return null;
}

// Vuelve a escribir el bloque bancario en el cuerpo del correo
function _solPagoPonerBanco(b){
  var ta=document.getElementById('mail-cuerpo'); if(!ta) return;
  var txt=String(ta.value||'');
  var bloque=_solPagoBloqueBanco(b).replace(/^\n/,'');
  var re=/DATOS DE TRANSFERENCIA:[\s\S]*?(?=\n\s*\n|$)/;
  if(re.test(txt)) ta.value=txt.replace(re, bloque.trim());
  else {
    // Se inserta antes de la despedida
    var lineas=txt.split('\n');
    var j=lineas.findIndex(function(l){ return /^\s*(Adjunto|Saludos|Best regards)/i.test(l); });
    if(j<0) j=lineas.length;
    lineas.splice(j,0,bloque.trim(),'');
    ta.value=lineas.join('\n');
  }
  window._spBanco=b;
}

// Botón para releer las instrucciones bancarias
async function _solPagoReleerBanco(){
  var ctx=window._solPagoCtx; if(!ctx) return;
  var av=document.getElementById('sp-banco');
  if(av) av.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo las instrucciones bancarias con AI…</span>';
  _spCargando('Leyendo las instrucciones bancarias con AI…','Puede tardar unos segundos');
  try{
    var b=await _solPagoLeerBanco(ctx.oid);
    _solPagoPonerBanco(b||{});
    _solPagoAvisoBanco(b);
  }catch(e){ _solPagoAvisoBanco(null); }
  _spCargandoFin();
}

// Escribe el % de anticipo que leyó la AI. Se puede editar a mano.
function _solPagoAplicarPct(b){
  var pc=Number(b&&b.deposito_pct)||0;
  var inp=document.getElementById('sp-pct');
  if(!inp || pc<=0 || pc>100) return;
  // No se pisa lo que la persona ya escribió
  var actual=parseFloat(inp.value);
  if(!isNaN(actual) && actual>0) return;
  inp.value=pc;
  _solPagoCalcMonto();
  var nota=document.getElementById('sp-calc');
  if(nota){
    nota.innerHTML+=' <span style="color:var(--t-lila);font-weight:600">\u00b7 '+pc+'% leído del documento'
      +(b.terminos_pago?(' ('+_esc(String(b.terminos_pago).slice(0,60))+')'):'')+'</span>';
  }
}

function _solPagoAvisoBanco(b){
  var av=document.getElementById('sp-banco'); if(!av) return;
  var faltan=_SP_CAMPOS.filter(function(c){ return !String((b&&b[c.k])||'').trim(); });
  if(!b){
    av.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No se pudieron leer las instrucciones bancarias. '
      +'En el correo quedan como <b>'+_SP_FALTA+'</b>. '
      +'<span onclick="_solPagoReleerBanco()" style="text-decoration:underline;cursor:pointer">Reintentar</span></span>';
    return;
  }
  if(!faltan.length){
    av.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Datos de transferencia leídos del documento del proveedor.</span>';
  } else {
    av.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Faltan '+faltan.length+' dato(s) bancario(s): <b>'
      +faltan.map(function(c){return c.l;}).join(', ')+'</b>. Quedan marcados como '+_SP_FALTA+' en el correo. '
      +'<span onclick="_solPagoReleerBanco()" style="text-decoration:underline;cursor:pointer">Reintentar</span></span>';
  }
}

// La compradora adjunta la debida diligencia
function _solPagoDD(input){
  var f=input.files&&input.files[0]; if(!f) return;
  _solPagoAdjuntarFile(f, 'dd');
}
async function _solPagoAdjuntarFile(f, marca){
  var kb=Math.round(f.size/1024);
  var b64=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
    fr.onerror=rej; fr.readAsDataURL(f);
  });
  window._mailAdj=window._mailAdj||[];
  // Si ya había una debida diligencia, se reemplaza
  if(marca==='dd') window._mailAdj=window._mailAdj.filter(function(a){ return a._marca!=='dd'; });
  window._mailAdj.push({nombre:f.name, mime:f.type||'application/octet-stream', contenido:b64, kb:kb, _marca:marca});
  mailPintarAdjuntos();
  var lbl=document.getElementById('sp-dd-lbl');
  if(lbl && marca==='dd'){
    lbl.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '+_esc(f.name);
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  COMPROBANTE DE PAGO — de contabilidad a compras
//  Contabilidad procesa el depósito o la cancelación y le manda el comprobante
//  a las compradoras que lo pidieron. Al enviarlo, el paso queda en verde y
//  compras solo puede consultar: ver los adjuntos, leer el correo y chatear.
// ═══════════════════════════════════════════════════════════════════════════

// Quién pidió el abono/cancelación de esta orden. Si no hay solicitud
// registrada, se cae al equipo de compras del departamento de la orden.
// Índice de un paso de Depósito por su nombre. Antes estaban escritos a mano
// (0, 1, 2) y al insertar pasos nuevos quedaban corridos.
function _pasoIdxDeposito(nombre){
  var st=STAGES.find(function(z){ return z.key==='deposito'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
var _PASO_SOL_ABONO   = 'Solicitud de depósito enviada';
var _PASO_DEP_PROV    = 'Depósito enviado al proveedor';
var _PASO_COMP_PROV   = 'Comprobante enviado al proveedor';
var _PASO_PAGO_FINAL  = 'Solicitud de final del balance';
var _PASO_COMP_FINAL  = 'Comprobante de pago final';
function _subKeyDeposito(nombre){
  var i=_pasoIdxDeposito(nombre);
  return i<0 ? '' : ('deposito_step'+i);
}

function _compDestinatarios(oid, tipo){
  var sols=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && (!tipo || x.tipo===tipo);
  });
  var nombres={}, dept='';
  sols.forEach(function(x){
    if(x.solicitado_por) nombres[String(x.solicitado_por).toLowerCase()]=1;
    if(x.dept && !dept) dept=x.dept;
  });
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(z){return String(z.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
    if(!dept){
      var p=(window._pendSAP||[]).find(function(z){ return String(z.dkc)===String(oid)||String(z.num_orden)===String(oid); });
      if(p) dept=p.dept||'';
    }
  }
  var out=[];
  (USERS||[]).forEach(function(u){
    if(u.role!=='compras' || !u.email) return;
    var pidio = nombres[String(u.name||'').toLowerCase()];
    var mismoDept = dept && String(u.dept||'')===String(dept);
    if(pidio || mismoDept) out.push({u:u, pidio:!!pidio});
  });
  // Los que pidieron van primero y marcados
  out.sort(function(a,b){ return (b.pidio?1:0)-(a.pidio?1:0); });
  return {lista:out, dept:dept, solicitudes:sols};
}

// Monto ya solicitado, para escribirlo en el correo
function _compMonto(oid, tipo){
  var sols=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(oid) && x.tipo===tipo; });
  if(sols.length) return Number(sols[0].monto)||0;
  var d=_solPagoDatosOrden(oid);
  return (tipo==='abono') ? (Number(d.abonado)||0) : (Number(d.saldo)||0);
}

// ═══════════════════════════════════════════════════════════════════════════
//  COMPROBANTE AL PROVEEDOR — lo manda compras
//  Contabilidad deja el comprobante en su paso; compras lo reenvía al
//  proveedor desde el paso siguiente, con el correo que tenga en SAP.
// ═══════════════════════════════════════════════════════════════════════════

// Correo del proveedor según SAP, buscando por la orden y por el nombre
// ── HUB de diseño: tres bloques de documentos ──
// 1) la orden de KCC firmada, que llega sola desde la etapa de firma
// 2) el Excel de la orden, que se sube a mano
// 3) los archivos de arte que manda el proveedor
// ═══════════════════════════════════════════════════════════════════════════
//  ARTES → GERENCIA
//  Diseño manda los artes terminados a la gerencia que elija. Los archivos del
//  paso viajan solos, el paso queda en verde y a gerencia le llega una alerta
//  que la lleva directo a revisar.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_ARTES_FIN   = 'Artes terminados';
var _PASO_ARTES_APROB = 'Artes aprobados por gerencia';

function _pasoIdxArtes(nombre){
  var st=STAGES.find(function(z){ return z.key==='artes'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyArtes(nombre){
  var i=_pasoIdxArtes(nombre);
  return i<0 ? '' : ('artes_step'+i);
}

/* La caja grande para soltar los artes. Ocupa todo el ancho del paso y
   acepta varios archivos a la vez, arrastrados desde el escritorio o
   elegidos con un clic. Las imágenes pesadas se reducen antes de subir. */
function _artesZonaSubida(oid, subKey){
  var files=(window._atts&&window._atts[oid+subKey])?_dedupDocs(window._atts[oid+subKey]):[];
  return '<div id="azs-'+oid+'" class="artes-drop" '
    +'ondragover="_artesDragOver(event,this)" ondragleave="_artesDragOut(this)" '
    +'ondrop="_artesDrop(event,this,\''+oid+'\',\''+subKey+'\')" '
    +'onclick="document.getElementById(\'azsf-'+oid+'\').click()" '
    +'style="border:2.5px dashed #7C3AED;border-radius:14px;background:#F5F3FF;'
    +'padding:26px 18px;text-align:center;cursor:pointer;margin-bottom:12px">'
    +'<div style="font-size:40px;line-height:1">🎨</div>'
    +'<div style="font-size:15px;font-weight:800;color:#5B21B6;margin-top:6px">'
    +'Arrastra aquí los artes</div>'
    +'<div style="font-size:12px;color:#6D28D9;margin-top:3px">'
    +'o pulsa para elegirlos · varios a la vez · PDF, JPG, PNG, AI o PSD</div>'
    +(files.length?('<div style="font-size:12px;font-weight:700;color:#5B21B6;margin-top:8px">'
      +files.length+' archivo(s) en este paso</div>'):'')
    +'<input type="file" id="azsf-'+oid+'" multiple style="display:none" '
    +'accept="image/*,.pdf,.ai,.psd,.eps,.zip,.rar" '
    +'data-oid="'+oid+'" data-sk="'+subKey+'" class="att-input" '
    +'onclick="event.stopPropagation()"></div>';
}

function _artesDragOver(ev, el){
  ev.preventDefault();
  el.style.background='#EDE9FE';
  el.style.borderColor='#5B21B6';
}
function _artesDragOut(el){
  el.style.background='#F5F3FF';
  el.style.borderColor='#7C3AED';
}
function _artesDrop(ev, el, oid, subKey){
  ev.preventDefault();
  _artesDragOut(el);
  var fs=(ev.dataTransfer&&ev.dataTransfer.files)||[];
  if(!fs.length) return;
  var inp=document.getElementById('azsf-'+oid);
  if(!inp) return;
  // Se reutiliza el mismo camino que el botón: subir, registrar y refrescar
  try{
    var dt=new DataTransfer();
    Array.prototype.forEach.call(fs, function(f){ dt.items.add(f); });
    inp.files=dt.files;
    handleAttach(oid, subKey, inp);
  }catch(e){
    handleAttach(oid, subKey, {files:Array.prototype.slice.call(fs), value:''});
  }
}

// Archivos que hay en un paso de artes
function _artesArchivos(oid, nombrePaso){
  var sk=_subKeyArtes(nombrePaso);
  if(!sk) return [];
  var a=(window._atts&&window._atts[oid+sk])?window._atts[oid+sk]:[];
  return _dedupDocs(a);
}

// ── Botón: enviar artes a gerencia ──
function _artesBotonEnviar(oid){
  var files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var env=_solEnvioLeer(oid,'artes_gerencia');
  var h='<div style="background:#F7F5FF;border:1px solid #C4B5FD;border-radius:9px;padding:10px 12px;margin-bottom:10px">';
  if(env){
    h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:4px"><i class="ti ti-circle-check"></i> Artes enviados a gerencia</div>'
      +'<div style="font-size:11px;color:var(--t-verde)">'
        +(env.por?('Enviado por <b>'+_esc(env.por)+'</b>'):'')
        +(env.fecha?(' · '+_esc(_fechaHora(env.fecha))):'')
        +(env.para&&env.para.length?('<br>Para revisar: '+_esc(env.para.join(', '))):'')
        +(env.copia&&env.copia.length?('<br>Copia a compras: '+_esc(env.copia.join(', '))):'')
        +(env.adjuntos&&env.adjuntos.length?('<br>'+env.adjuntos.length+' archivo(s): '+_esc(env.adjuntos.map(function(a){return a.nombre;}).join(', '))):'')
      +'</div>';
  }
  if(CU && (CU.role==='diseno'||CU.role==='gerencia')){
    h+='<div style="font-size:11.5px;font-weight:600;color:var(--t-lila);margin:'+(env?'8px 0 5px':'0 0 5px')+'">'
      +'<i class="ti ti-send"></i> '+(env?'Volver a enviar los artes':'Enviar los artes a gerencia para revisar')+'</div>'
      +'<div style="font-size:10.5px;color:var(--t-lila);margin-bottom:7px">'+files.length+' archivo(s) en este paso se enviarán con la solicitud.</div>'
      +'<button class="btn bp" style="background:#5B21B6;font-size:11px;padding:6px 12px" onclick="_artesEnviarModal(\'' + oid + '\')">'
      +'<i class="ti ti-send"></i> Enviar artes a gerencia</button>';
  }
  return h+'</div>';
}

function _artesEnviarModal(oid){
  var files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var d=_solPagoDatosOrden(oid);
  var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia'; });
  if(!gers.length){ showT('No hay usuarios de gerencia cargados'); return; }

  // Compradores: primero los del departamento de la orden, que son quienes
  // llevan esta compra y tienen que enterarse del envío.
  var dept=d.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  var compDept=(USERS||[]).filter(function(u){ return _esComprasU(u) && dept && String(u.dept||'')===String(dept); });
  var compOtros=(USERS||[]).filter(function(u){ return _esComprasU(u) && compDept.indexOf(u)<0; });

  function chip(u, marcado, etiqueta){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#5B21B6':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#F7F5FF':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.id)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')
      +';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700">'
      +_esc(String(u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_esc(u.name)+'</span>'
      +(etiqueta?('<span style="font-size:9px;color:var(--t-lila);font-weight:700">'+etiqueta+'</span>'):'')
      +'</label>';
  }
  var chips=gers.map(function(u){ return chip(u,false,''); }).join('');
  var chipsComp=compDept.map(function(u){ return chip(u,true,'lleva la orden'); }).join('')
              + compOtros.map(function(u){ return chip(u,false,''); }).join('');

  var prev=document.getElementById('modalArtes'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalArtes';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:center;justify-content:center;padding:20px';
  var h='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-lila)"><i class="ti ti-palette"></i> Enviar artes a gerencia</div>'
      +'<button onclick="document.getElementById(\'modalArtes\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="background:#F7F5FF;border:1px solid #C4B5FD;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-lila)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> · orden '+_esc(d.dkc||oid)+'</div>';

  if(files.length){
    h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">SE ENVÍAN ESTOS ARCHIVOS</div>'
      +'<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:8px 10px;margin-bottom:12px">';
    files.forEach(function(a){
      h+='<div style="font-size:11.5px;padding:2px 0"><i class="ti ti-file" style="color:var(--t-lila)"></i> '+_esc(a.name||'')+'</div>';
    });
    h+='</div>';
  } else {
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-alert-circle"></i> No hay archivos en "Artes terminados". Puedes enviarlo igual, pero gerencia no verá los artes.</div>';
  }

  h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">GERENCIA — quién revisa los artes</div>'
    +'<div id="artes-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'+chips+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">COMPRAS — a quién más le aviso'
      +(dept?(' <span style="color:var(--t-lila)">· '+_esc(dL(dept))+' viene marcado</span>'):'')+'</div>'
    +'<div id="artes-comp" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'
      +(chipsComp||'<span style="font-size:11.5px;color:var(--text-muted)">No hay compradores cargados.</span>')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">NOTA (opcional)</div>'
    +'<textarea id="artes-nota" rows="3" placeholder="Algo que gerencia deba tener en cuenta…" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical"></textarea>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalArtes\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="artes-btn" style="background:#5B21B6" onclick="_artesEnviarConfirmar(\'' + oid + '\')"><i class="ti ti-send"></i> Enviar a gerencia</button>'
    +'</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

async function _artesEnviarConfirmar(oid){
  var box=document.getElementById('artes-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ showT('Elige al menos una persona de gerencia'); return; }
  var boxC=document.getElementById('artes-comp');
  var marcadosC=boxC?Array.prototype.slice.call(boxC.querySelectorAll('input:checked')):[];

  var nombres=marcados.map(function(c){ return c.getAttribute('data-nom'); });
  var nombresC=marcadosC.map(function(c){ return c.getAttribute('data-nom'); });
  var files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var nota=(document.getElementById('artes-nota')||{}).value||'';

  if(!confirm('¿Está seguro de enviar los artes a gerencia?\n\n'
    +'Para revisar: '+nombres.join(', ')+'\n'
    +(nombresC.length?('Con copia a compras: '+nombresC.join(', ')+'\n'):'')
    +files.length+' archivo(s)\n\n'
    +'El paso "Artes terminados" quedará completado y pasará a revisión.')) return;

  var btn=document.getElementById('artes-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  // Los archivos se copian al paso de revisión, apuntando al mismo archivo
  var skDestino=_subKeyArtes(_PASO_ARTES_APROB);
  try{
    if(skDestino && files.length){
      if(!window._atts) window._atts={};
      var k=oid+skDestino;
      if(!window._atts[k]) window._atts[k]=[];
      files.forEach(function(a){
        if(!window._atts[k].some(function(z){ return _docClave(z)===_docClave(a); })){
          window._atts[k].push(Object.assign({}, a));
        }
      });
    }
  }catch(e){ console.warn('copiar artes:',e); }

  // El paso "Artes terminados" queda completado
  try{
    var st=STAGES.find(function(z){ return z.key==='artes'; });
    var pasoIdx=_pasoIdxArtes(_PASO_ARTES_FIN);
    initP(oid);
    var sp=stageProgress[oid].artes;
    if(pasoIdx>=0 && (sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'artes');
    }
  }catch(e){ console.warn('marcar artes:',e); }

  // Alerta para la gerencia que tiene que revisar
  var texto='Tienes artes pendientes de confirmar'+(nota?(' — '+nota):'');
  var destinos=marcados.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean);
  try{
    await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Artes', texto:texto,
      etiqueta:'Artes — pendientes de confirmar',
      paso:_PASO_ARTES_APROB
    });
  }catch(e){ console.warn('alerta artes:',e); }

  // Aviso a compras: es informativo, no les toca aprobar nada
  var destC=marcadosC.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean).filter(function(u){ return !destinos.some(function(g){ return g.id===u.id; }); });
  if(destC.length){
    try{
      await _menNotificar(destC, {
        docnum:oid, contexto:'etapa', etapa:'Artes',
        texto:'Los artes se enviaron a gerencia para revisar ('+nombres.join(', ')+')'+(nota?(' — '+nota):''),
        etiqueta:'Artes — enviados a revisión',
        paso:_PASO_ARTES_APROB
      });
    }catch(e){ console.warn('alerta compras:',e); }
  }

  var info={ fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:nombres, copia:nombresC,
             nota:nota, adjuntos:files.map(function(a){ return {nombre:a.name}; }) };
  _solEnvioGuardar(oid, 'artes_gerencia', info);

  var m=document.getElementById('modalArtes'); if(m) m.remove();
  showT('✓ Artes enviados a '+nombres.join(', ')+(nombresC.length?(' · copia a '+nombresC.join(', ')):''));
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  REVISIÓN DE ARTES POR GERENCIA
//  Gerencia revisa con AI o a mano, y notifica los errores a quien elija.
// ═══════════════════════════════════════════════════════════════════════════
function _artesRevisionPanel(oid){
  var rev=_solEnvioLeer(oid,'artes_revision');
  var h='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;padding:10px 12px;margin-bottom:10px">';
  h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:6px"><i class="ti ti-eye-check"></i> Revisión de los artes</div>';

  if(rev && rev.observaciones){
    h+='<div style="background:var(--surface-0);border-radius:8px;padding:8px 10px;margin-bottom:8px">'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:3px">'
        +'Última revisión de <b>'+_esc(rev.por||'')+'</b> · '+_esc(_fechaHora(rev.fecha))
        +(rev.para&&rev.para.length?(' · avisado a '+_esc(rev.para.join(', '))):'')+'</div>'
      +'<div style="font-size:12px;white-space:pre-wrap">'+_esc(rev.observaciones)+'</div></div>';
  }

  if(CU && CU.role==='gerencia'){
    h+='<div style="display:flex;gap:6px;flex-wrap:wrap">'
      +'<button class="btn bp" style="background:#5B21B6;font-size:11px;padding:6px 12px" onclick="_artesRevisarIA(\'' + oid + '\')">'
        +'<i class="ti ti-sparkles"></i> Revisar con AI</button>'
      +'<button class="btn bp" style="background:#B45309;font-size:11px;padding:6px 12px" onclick="_artesNotificarModal(\'' + oid + '\')">'
        +'<i class="ti ti-message-report"></i> Notificar errores / comentarios</button>'
      +'</div>';
    h+='<div id="artes-ia-'+oid+'" style="margin-top:8px"></div>';
  } else if(rev && rev.observaciones){
    h+='<div style="font-size:10.5px;color:var(--t-marron)">Estas observaciones las escribió gerencia.</div>';
  }
  return h+'</div>';
}

// Revisión con AI de los artes adjuntos
async function _artesRevisarIA(oid){
  var files=_artesArchivos(oid, _PASO_ARTES_APROB);
  if(!files.length) files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var cont=document.getElementById('artes-ia-'+oid);
  if(!files.length){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No hay artes adjuntos para revisar.</div>';
    return;
  }
  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Revisando los artes con AI…</span>';

  var d=_solPagoDatosOrden(oid);
  // Cualquier formato: PDF, imagen, Excel, Word o texto
  var contenido=[], puestos=0, notas=[];
  for(var i=0;i<files.length && puestos<5;i++){
    if(!files[i].url) continue;
    var prep=await _iaDesdeStorage(files[i].url, files[i].name||('arte_'+(i+1)), 7);
    if(!prep) { notas.push((files[i].name||'archivo')+': no se pudo abrir'); continue; }
    contenido.push({type:'text', text:'ARCHIVO: '+(files[i].name||'')});
    prep.bloques.forEach(function(b){ contenido.push(b); });
    if(prep.nota) notas.push(prep.nota);
    puestos++;
  }
  if(!puestos){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">No se pudo leer ninguno de los archivos.'
      +(notas.length?('<br>'+_esc(notas.join(' · '))):'')+'</div>';
    return;
  }
  window._artesNotas=notas;
  // Si todo lo que se pudo meter fueron avisos de archivo ilegible, la IA no
  // ha revisado nada y hay que decirlo claro al pintar el resultado.
  window._artesFalloTodo = (puestos===0) ||
    (notas.length>0 && notas.length>=puestos &&
     notas.every(function(t){ return /pesado|no se pudo/i.test(String(t)); }));

  contenido.push({type:'text', text:
     'Sos el revisor de artes de KENNEDY CENTER CORP. Revisa el arte adjunto de este producto:\n'
    +'Proveedor: '+(d.proveedor||'')+'\nOrden: '+(d.dkc||oid)+'\n\n'
    +'QUE REVISAR:\n'
    +'- Ortografia y gramatica en TODOS los textos, en español y en ingles.\n'
    +'- Que el nombre del producto y la descripcion sean coherentes entre si.\n'
    +'- Codigo de barras: que este presente y legible.\n'
    +'- Datos obligatorios: pais de origen, contenido, medidas, marca.\n'
    +'- Que la marca y el logo esten bien escritos.\n'
    +'- Textos cortados, superpuestos o ilegibles.\n'
    +'- Cualquier dato que se contradiga entre partes del arte.\n\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
    +'{"observaciones":[{"gravedad":"alta","punto":"","detalle":""}],"resumen":"","todo_bien":true}\n'
    +'REGLAS:\n'
    +'- "gravedad": "alta" si es un error que no puede salir a produccion (ortografia visible, dato equivocado, codigo de barras ilegible); "media" si conviene corregirlo; "baja" si es una sugerencia.\n'
    +'- "punto": donde esta, en pocas palabras.\n'
    +'- "detalle": que esta mal y como deberia decir.\n'
    +'- "todo_bien": true solo si no hay observaciones de gravedad alta ni media.\n'
    +'- Si no podes leer bien el arte, decilo en "resumen" en vez de inventar.'});

  try{
    var obj=await _iaJSON(contenido, 3000);
    var obs=(obj && Array.isArray(obj.observaciones))?obj.observaciones:[];
    window._artesIA=window._artesIA||{};
    window._artesIA[oid]=obj;
    if(!cont) return;
    var avisoArch=(window._artesNotas&&window._artesNotas.length)
      ? ('<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:7px 10px;font-size:11px;color:var(--t-marron);margin-bottom:7px">'
         +'<i class="ti ti-alert-circle"></i> '+_esc(window._artesNotas.join(' · '))+'</div>')
      : '';
    if(!obs.length){
      // Si NINGÚN archivo se pudo leer, decir «no encontró problemas» es
      // mentira y además peligrosa: nadie revisó nada. Se avisa en ámbar.
      var _noLeyo=!!(window._artesFalloTodo);
      cont.innerHTML=avisoArch
        + (_noLeyo
           ? ('<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;'
              +'border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-marron)">'
              +'<i class="ti ti-alert-triangle"></i> <b>No se revisó nada.</b> '
              +'No pude leer el archivo, así que esto NO quiere decir que esté '
              +'bien. Vuelve a intentarlo o súbelo más liviano.'
              +(obj&&obj.resumen?('<div style="margin-top:3px">'+_esc(obj.resumen)
                 +'</div>'):'')+'</div>')
           : ('<div style="background:var(--pastel-ok);border:1px solid #16a34a;'
              +'border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
              +'<i class="ti ti-circle-check"></i> La AI no encontró problemas.'
              +(obj&&obj.resumen?('<div style="margin-top:3px">'+_esc(obj.resumen)
                 +'</div>'):'')+'</div>'));
      return;
    }
    var h=avisoArch+'<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden">'
      +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:700;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> '+obs.length+' observación(es) de la AI</div>';
    obs.forEach(function(o){
      var g=String(o.gravedad||'media').toLowerCase();
      var c=g==='alta'?'#dc2626':(g==='baja'?'#6b7280':'#B45309');
      h+='<div style="padding:7px 11px;border-top:0.5px solid var(--border);background:var(--surface-0)">'
        +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'+_esc(g)+'</span> '
        +(o.punto?('<b style="font-size:11.5px">'+_esc(o.punto)+'</b>'):'')
        +'<div style="font-size:11.5px;color:var(--text-secondary);margin-top:2px">'+_esc(o.detalle||'')+'</div></div>';
    });
    h+='<div style="padding:8px 11px;border-top:0.5px solid var(--border);background:var(--surface-1)">'
      +'<button class="btn bp" style="background:#B45309;font-size:11px;padding:5px 11px" onclick="_artesNotificarModal(\'' + oid + '\',true)">'
      +'<i class="ti ti-send"></i> Notificar estas observaciones</button></div></div>';
    cont.innerHTML=h;
  }catch(e){
    console.error('revisar artes:',e);
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">No se pudo revisar: '+_esc(e.message||String(e))+'</div>';
  }
}

// Modal para notificar los errores a quien elija gerencia
function _artesNotificarModal(oid, conIA){
  var texto='';
  if(conIA && window._artesIA && window._artesIA[oid]){
    var obs=window._artesIA[oid].observaciones||[];
    texto=obs.map(function(o){
      return '• ['+String(o.gravedad||'media').toUpperCase()+'] '+(o.punto?(o.punto+': '):'')+(o.detalle||'');
    }).join('\n');
  }
  var cand=(USERS||[]).filter(function(u){
    return u.id!==((CU&&CU.id)||'') && ['diseno','compras','gerencia'].indexOf(u.role)>=0;
  });
  var chips=cand.map(function(u){
    var marcado=(u.role==='diseno');   // por defecto, a diseño
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#5B21B6':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#F7F5FF':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.id)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)+'</span></label>';
  }).join('');

  var prev=document.getElementById('modalArtesNot'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalArtesNot';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-ambar)"><i class="ti ti-message-report"></i> Notificar observaciones</div>'
      +'<button onclick="document.getElementById(\'modalArtesNot\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">OBSERVACIONES</div>'
    +'<textarea id="artesnot-txt" rows="8" placeholder="Escribe lo que hay que corregir…" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(texto)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">¿A QUIÉN LE AVISO?</div>'
    +'<div id="artesnot-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'+chips+'</div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalArtesNot\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="artesnot-btn" style="background:#B45309" onclick="_artesNotificarEnviar(\'' + oid + '\')"><i class="ti ti-send"></i> Enviar observaciones</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

async function _artesNotificarEnviar(oid){
  var txt=(document.getElementById('artesnot-txt')||{}).value||'';
  if(!txt.trim()){ showT('Escribe las observaciones'); return; }
  var box=document.getElementById('artesnot-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ showT('Elige a quién avisarle'); return; }

  var btn=document.getElementById('artesnot-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var nombres=marcados.map(function(c){ return c.getAttribute('data-nom'); });
  var destinos=marcados.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean);

  // Queda como comentario del paso, para que el hilo no se pierda
  try{
    var sk=_subKeyArtes(_PASO_ARTES_APROB);
    var comKey='sub_'+oid+'_'+sk;
    if(!window._subComs) window._subComs={};
    if(!window._subComs[comKey]) window._subComs[comKey]=[];
    window._subComs[comKey].push({autor:(CU&&CU.name)+' ('+(CU&&CU.role)+')', ini:(CU&&CU.ini)||'--',
                                  texto:txt, time:now2(), role:(CU&&CU.role)||'', by:(CU&&CU.name)||''});
    guardarComentario(oid, sk, txt);
  }catch(e){ console.warn('comentario artes:',e); }

  try{
    await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Artes', texto:txt,
      etiqueta:'Artes — observaciones de gerencia',
      paso:_PASO_ARTES_APROB
    });
  }catch(e){ console.warn('notificar artes:',e); }

  _solEnvioGuardar(oid, 'artes_revision', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:nombres, observaciones:txt
  });

  var m=document.getElementById('modalArtesNot'); if(m) m.remove();
  showT('✓ Observaciones enviadas a '+nombres.join(', '));
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  ARTES AL PROVEEDOR
//  Compras manda al proveedor los artes que aprobó gerencia, más los enlaces
//  de descarga que se hayan cargado en el HUB.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_ARTES_PROV = 'Artes enviados al proveedor';

function _artesPanelProveedor(oid){
  var aprob=_artesParaProveedor(oid);
  var env=_solEnvioLeer(oid,'artes_proveedor');
  var h='<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:10px 12px;margin-bottom:10px">';
  if(env){
    h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:4px"><i class="ti ti-circle-check"></i> Artes enviados al proveedor</div>'
      +'<div style="font-size:11px;color:var(--t-verde)">'
        +(env.por?('Enviado por <b>'+_esc(env.por)+'</b>'):'')
        +(env.fecha?(' \u00b7 '+_esc(_fechaHora(env.fecha))):'')
        +(env.para&&env.para.length?('<br>Para: '+_esc(env.para.join(', '))):'')
        +(env.adjuntos&&env.adjuntos.length?('<br>'+env.adjuntos.length+' archivo(s) adjunto(s)'):'')
      +'</div>';
    if(env.cuerpo){
      h+='<details style="margin-top:5px"><summary style="font-size:10.5px;color:var(--t-verde);cursor:pointer;font-weight:600">Ver el correo enviado</summary>'
        +'<div style="font-size:11px;color:var(--t-verde);white-space:pre-wrap;background:var(--surface-0);border-radius:7px;padding:8px 10px;margin-top:5px;max-height:240px;overflow-y:auto">'+_esc(env.cuerpo)+'</div></details>';
    }
  }
  if(CU && (_esCompras()||CU.role==='gerencia')){
    h+='<div style="font-size:11.5px;font-weight:600;color:var(--t-azul);margin:'+(env?'8px 0 5px':'0 0 5px')+'">'
      +'<i class="ti ti-mail"></i> '+(env?'Volver a enviar los artes':'Enviar los artes al proveedor')+'</div>'
      +'<div style="font-size:10.5px;color:var(--t-azul);margin-bottom:7px">'+aprob.length+' arte(s) aprobado(s) se adjuntan solos.</div>'
      +'<button class="btn bp" style="font-size:11px;padding:6px 12px" onclick="_artesProvModal(\'' + oid + '\')">'
      +'<i class="ti ti-send"></i> Redactar correo al proveedor</button>';
  }
  return h+'</div>';
}

async function _artesProvModal(oid){
  var d=_solPagoDatosOrden(oid);
  var ordenTxt=d.dkc||String(oid);
  var provEmail=_provEmailDeOrden(oid);
  var aprob=_artesParaProveedor(oid);
  var links=[];
  try{ links=_hubLeerLinks(oid); }catch(e){}
  window._mailAdj=[];
  window._artesProvCtx={oid:oid, paso:_pasoIdxArtes(_PASO_ARTES_PROV)};

  // ARTWORK Order #12429 – KC #DKC-26031
  var asunto='ARTWORK Order #'+String(oid)
    + (d.dkc ? (' \u2013 KC #'+d.dkc) : '');

  var cuerpo='Dear '+(d.proveedor||'Vendor')+',\n\n'
    +'I\u2019m attaching the link to download the artwork for this order. '
    +'Please download and review the files, and let us know if you have any '
    +'questions or notice anything that needs our attention.\n\n'
    +'Before printing production, please send us the final artwork proof so we '
    +'can review and approve how it will look.\n\n'
    +'Thank you,\n\n'
    +_firmaNombre()+'\n'
    +'KENNEDY CENTER CORP.';

  // Los enlaces de descarga, justo debajo del primer párrafo
  if(links.length){
    var bloque='\nDownload link'+(links.length>1?'s':'')+':\n'
      +links.map(function(l){ return l.url; }).join('\n')+'\n';
    cuerpo=cuerpo.replace('Before printing production,', bloque+'\nBefore printing production,');
  }

  var ccChips=(USERS||[]).filter(function(u){
    if(!u.email) return false;
    return String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){
    var marcado=(u.role==='diseno');
    return '<span class="sp-cc-chip'+(marcado?' on':'')+'" data-mail="'+_esc(u.email)+'" onclick="_artesProvCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti '+(marcado?'ti-check':'ti-plus')+'" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');
  var ccIni=(USERS||[]).filter(function(u){
    return u.email && u.role==='diseno' && String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){ return u.email; }).join(', ');

  var prev=document.getElementById('modalArtesProv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalArtesProv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:700px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)"><i class="ti ti-palette"></i> Enviar artes al proveedor</div>'
      +'<button onclick="_artesProvCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-azul)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> \u00b7 orden '+_esc(ordenTxt)+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">PARA — proveedor</div>'
    +'<input id="ap-para" value="'+_esc(provEmail)+'" placeholder="correo@proveedor.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:10px;margin:3px 0 12px">'
      +(provEmail?'<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Correo tomado de SAP. Puedes cambiarlo.</span>'
                 :'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Este proveedor no tiene correo en SAP: escríbelo a mano.</span>')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">CC</div>'
    +'<div id="ap-cc-chips" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:5px">'+ccChips+'</div>'
    +'<input id="ap-cc" value="'+_esc(ccIni)+'" placeholder="otros@correo.com, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="ap-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="ap-cuerpo" rows="16" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ARTES APROBADOS</div>'
    +'<div id="ap-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando los artes…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_artesProvCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="ap-btn" onclick="_artesProvEnviar()"><i class="ti ti-send"></i> Enviar al proveedor</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Los artes aprobados se adjuntan solos
  var aviso=document.getElementById('ap-auto');
  if(!aprob.length){
    if(aviso) aviso.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No hay artes aprobados adjuntos. Súbelos a mano o usa los enlaces del HUB.</span>';
    return;
  }
  var puestos=[], pesados=[];
  for(var i=0;i<aprob.length;i++){
    if(!aprob[i].url) continue;
    try{
      var adj=await _solPagoAdjuntarDeStorage(aprob[i].url, aprob[i].name||('arte_'+(i+1)));
      if(adj){ window._mailAdj.push(adj); puestos.push(aprob[i].name); }
      else pesados.push(aprob[i].name);
    }catch(e){ pesados.push(aprob[i].name); }
  }
  mailPintarAdjuntos();
  if(aviso){
    var h2='';
    if(puestos.length) h2+='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '+_esc(puestos.join(', '))+'</span>';
    if(pesados.length) h2+=(h2?'<br>':'')+'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No se pudieron adjuntar (muy pesados): '+_esc(pesados.join(', '))
      +'. Manda el enlace de descarga en el cuerpo.</span>';
    aviso.innerHTML=h2;
  }
}

function _artesProvCerrar(){
  var m=document.getElementById('modalArtesProv'); if(m) m.remove();
  window._mailAdj=[]; window._artesProvCtx=null;
}

function _artesProvCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('ap-cc'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('#ap-cc-chips .sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); }).map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

async function _artesProvEnviar(){
  var ctx=window._artesProvCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid;
  var para=((document.getElementById('ap-para')||{}).value||'').split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var cc=((document.getElementById('ap-cc')||{}).value||'').split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var asunto=(document.getElementById('ap-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('ap-cuerpo')||{}).value||'';
  if(!para.length){ _mailMsg('Escribe el correo del proveedor.','err'); return; }
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(!(window._mailAdj||[]).length){
    if(!confirm('No hay artes adjuntos.\n\n¿Enviar el correo igual? (asegúrate de que el enlace de descarga esté en el mensaje)')) return;
  }
  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB. Manda el enlace de descarga en el cuerpo.','err');
    return;
  }
  var btn=document.getElementById('ap-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:para[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:_dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
                 .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Artes al proveedor \u00b7 '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      var t=await r.text(); console.error('artes proveedor:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
    return;
  }

  // El paso queda completado
  try{
    var st=STAGES.find(function(z){ return z.key==='artes'; });
    var pi=ctx.paso;
    initP(oid);
    var sp=stageProgress[oid].artes;
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pi]=hoyIso;
      guardarEtapa(oid,'artes');
    }
  }catch(e){ console.warn('marcar artes proveedor:',e); }

  _solEnvioGuardar(oid, 'artes_proveedor', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo,
    adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; })
  });

  _artesProvCerrar();
  showT('✓ Artes enviados al proveedor');
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  ARCHIVOS PARA LA IA
//  Un solo lugar que convierte cualquier archivo al formato que entiende la
//  AI. Antes cada pantalla lo resolvía a su manera y varias trataban todo lo
//  que no fuera PDF como si fuera una imagen, así que un Excel o un AI se
//  mandaban rotos.
// ═══════════════════════════════════════════════════════════════════════════
var _IA_IMG  = ['jpg','jpeg','png','gif','webp','bmp'];
var _IA_XLS  = ['xlsx','xls','csv','tsv'];
var _IA_TXT  = ['txt','md','json','xml','html','htm','csv','log'];
// Formatos que la AI no lee directo, pero se pueden describir
var _IA_OTRO = ['ai','psd','psb','eps','indd','idml','cdr','sketch','fig','zip','rar','7z','dwg','tiff','tif'];

function _iaExt(nombre){
  return String(nombre||'').split('?')[0].split('.').pop().toLowerCase();
}

// Convierte un Blob al bloque que entiende la AI.
// Devuelve {bloques:[…], nota:'' } o null si no se puede leer.
// ¿Esto es texto de verdad o son bytes de un binario? Se mira una muestra:
// si hay bytes nulos, muchos caracteres de reemplazo, o menos del 85% de
// caracteres legibles, es binario y no se le manda a la IA.
function _iaPareceTexto(t){
  var m=String(t||'').slice(0, 3000);
  if(!m) return false;
  if(m.indexOf('\u0000')>=0) return false;              // byte nulo: binario
  var repl=(m.match(/\uFFFD/g)||[]).length;
  if(repl > m.length*0.02) return false;                // demasiada basura
  var buenos=(m.match(/[\x09\x0A\x0D\x20-\x7E\u00A0-\u024F\u20AC]/g)||[]).length;
  return (buenos / m.length) >= 0.85;
}

async function _iaDesdeBlob(blob, nombre){
  var ext=_iaExt(nombre);
  var mime=(blob.type||'').toLowerCase();

  // Formatos de diseño y comprimidos primero: algunos declaran un mime de
  // imagen (el .psd dice image/vnd.adobe.photoshop) pero la AI no los abre.
  if(_IA_OTRO.indexOf(ext)>=0){
    return {bloques:[{type:'text', text:'ARCHIVO ADJUNTO: '+nombre+' (formato .'+ext+'). '
      +'No se puede leer su contenido: tenelo en cuenta al revisar y pedí una versión en PDF o imagen si hace falta.'}],
            nota:nombre+': formato .'+ext+' no legible, pedí PDF o imagen'};
  }
  // PDF
  if(ext==='pdf' || /pdf/.test(mime)){
    var b64=await _blobB64(blob);
    return {bloques:[{type:'document', source:{type:'base64', media_type:'application/pdf', data:b64}}]};
  }
  // Imágenes
  if(_IA_IMG.indexOf(ext)>=0 || /^image\//.test(mime)){
    var mt=mime && /^image\//.test(mime) ? mime
         : (ext==='png'?'image/png':ext==='gif'?'image/gif':ext==='webp'?'image/webp':'image/jpeg');
    var b64i=await _blobB64(blob);
    return {bloques:[{type:'image', source:{type:'base64', media_type:mt, data:b64i}}]};
  }
  // Excel y CSV: se leen las hojas como texto
  if(_IA_XLS.indexOf(ext)>=0){
    try{
      if(typeof XLSX==='undefined') throw new Error('sin lector de Excel');
      var buf=await blob.arrayBuffer();
      var wb=XLSX.read(buf,{type:'array'});
      var txt=_iaLibroTexto(wb, 60000);
      if(!txt.trim()) throw new Error('hoja vacía');
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+txt}]};
    }catch(e){
      return {bloques:[{type:'text', text:'ARCHIVO '+nombre+': no se pudo leer el Excel ('+(e.message||e)+').'}],
              nota:nombre+': no se pudo leer'};
    }
  }
  // Texto plano
  if(_IA_TXT.indexOf(ext)>=0 || /^text\//.test(mime)){
    try{
      var t=await blob.text();
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+String(t).slice(0,14000)}]};
    }catch(e){ return null; }
  }
  // Word: el navegador puede sacar el texto con mammoth
  if(ext==='docx'){
    try{
      if(typeof mammoth==='undefined') throw new Error('sin lector de Word');
      var ab=await blob.arrayBuffer();
      var res=await mammoth.extractRawText({arrayBuffer:ab});
      var tx=(res&&res.value)||'';
      if(!tx.trim()) throw new Error('documento vacío');
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+tx.slice(0,14000)}]};
    }catch(e){
      return {bloques:[{type:'text', text:'ARCHIVO '+nombre+': documento de Word que no se pudo leer.'}],
              nota:nombre+': no se pudo leer'};
    }
  }
  // Cualquier otro: se intenta como texto, pero SOLO si de verdad lo es.
  // Antes bastaba con encontrar un carácter legible entre los 200 primeros,
  // y casi cualquier binario tiene alguno: así se mandaban los bytes crudos
  // de un Excel o un ZIP a la IA, que respondía cualquier cosa y reventaba
  // al interpretarla ("Unexpected token '\uFFFD'").
  try{
    var t2=await blob.text();
    if(t2 && _iaPareceTexto(t2)){
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+String(t2).slice(0,10000)}]};
    }
  }catch(e){}
  return {bloques:[{type:'text', text:'ARCHIVO ADJUNTO: '+nombre+' (no se pudo interpretar).'}],
          nota:nombre+': no se pudo interpretar'};
}

function _blobB64(blob){
  return new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
    fr.onerror=rej; fr.readAsDataURL(blob);
  });
}

// Baja un archivo del storage y lo prepara para la AI
async function _iaDesdeStorage(urlRel, nombre, topeMB){
  try{
    var url=DOCS_BASE + String(urlRel).split('/').map(encodeURIComponent).join('/');
    var r=await fetch(url);
    if(!r.ok) return null;
    var blob=await r.blob();
    if(blob.size > (topeMB||8)*1024*1024){
      // Un arte de 87 MB no cabe en la petición, pero eso no quiere decir que
      // no se pueda revisar: si es PDF, se convierte a imágenes de pantalla,
      // que es lo que la IA necesita para leerlo, y pesan una fracción.
      var liviano=await _iaPdfAImagenes(blob, nombre);
      if(liviano) return liviano;
      return {bloques:[{type:'text', text:'ARCHIVO '+nombre+': pesa '
        +(blob.size/1048576).toFixed(1)+' MB y no se pudo enviar a revisar.'}],
              nota:nombre+': demasiado pesado', fallo:true};
    }
    return await _iaDesdeBlob(blob, nombre);
  }catch(e){ console.warn('preparar para IA:',e); return null; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  PRODUCCIÓN — INSPECCIÓN
//  La compradora sube fotos, documentos y enlaces de la inspección, y al
//  marcarla como revisada le avisa al encargado del departamento. El encargado
//  da el visto bueno y la etapa pasa a verde.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_INSPECCION = 'Producción terminada — Inspección de producción finalizada';
var _PASO_INSP_OK    = _PASO_INSPECCION;   // todo ocurre en el mismo paso

function _pasoIdxProd(nombre){
  var st=STAGES.find(function(z){ return z.key==='produccion'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyProd(nombre){
  var i=_pasoIdxProd(nombre);
  return i<0 ? '' : ('produccion_step'+i);
}

// ── Panel de la compradora ──
// Cuántas evidencias hay cargadas
function _inspCuantos(oid){
  var sk=_subKeyProd(_PASO_INSPECCION);
  var f=((window._atts&&window._atts[oid+sk+'_fotos'])||[]).length;
  var d=((window._atts&&window._atts[oid+sk+'_docs'])||[]).length;
  var l=_inspLeerLinks(oid).length;
  return {fotos:f, docs:d, links:l, total:f+d+l};
}

function _inspPanel(oid){
  var sk=_subKeyProd(_PASO_INSPECCION);
  var rev=_solEnvioLeer(oid,'inspeccion');
  var n=_inspCuantos(oid);
  var listo=!!rev;

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';

  // El semáforo del paso, siempre a la vista
  var col = listo ? ['#166534','#dcfce7','#16a34a','Revisada']
          : (n.total ? ['#B45309','#FEF3E8','#E9C08A','Pendiente de revisar']
                     : ['#991b1b','#FEF2F2','#dc2626','Sin evidencia cargada']);
  h+='<div style="display:flex;align-items:center;gap:8px;background:'+col[1]+';border:1px solid '+col[2]
    +';border-radius:8px;padding:8px 11px;margin-bottom:9px">'
    +'<span class="sem '+(listo?'sem-g':(n.total?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="flex:1;min-width:0">'
      +'<div style="font-size:12px;font-weight:700;color:'+col[0]+'">'+col[3]+'</div>'
      +'<div style="font-size:10.5px;color:'+col[0]+';opacity:.85">'
        +n.fotos+' foto(s) · '+n.docs+' documento(s) · '+n.links+' enlace(s)'
        +(listo?(' · revisada por '+_esc(rev.por||'')+' el '+_esc(_fechaHora(rev.fecha))):'')
      +'</div>'
    +'</div></div>';

  h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:8px">'
    +'<i class="ti ti-clipboard-check"></i> Inspección de la producción</div>';

  // Tres formas de cargar evidencia, igual que en el HUB de diseño
  h+=_inspZona(oid, sk+'_fotos', '1 · FOTOS DE LA INSPECCIÓN',
               'Fotos de los productos, empaque y etiquetado', '#B45309', 'ti-photo', 'image/*');
  h+=_inspZona(oid, sk+'_docs', '2 · DOCUMENTOS',
               'Reporte de inspección, certificados, packing list', '#0c447c', 'ti-file-text',
               '.pdf,.xlsx,.xls,.doc,.docx,.csv');
  h+=_inspLinks(oid);

  if(rev){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Inspección revisada</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">'
        +'Por <b>'+_esc(rev.por||'')+'</b> · '+_esc(_fechaHora(rev.fecha))
        +(rev.para&&rev.para.length?('<br>Avisado a: '+_esc(rev.para.join(', '))):'')
        +(rev.nota?('<br>'+_esc(rev.nota)):'')
      +'</div></div>';
  }

  // Compras y gerencia marcan la revisión desde aquí mismo
  if(CU && (_esCompras()||CU.role==='gerencia')){
    h+='<div style="margin-top:9px;display:flex;gap:7px;flex-wrap:wrap">';
    if(!listo){
      h+='<button class="btn bp" style="background:'+(n.total?'#16a34a':'#9ca3af')+';font-size:12px;padding:8px 15px;font-weight:700"'
        +(n.total?'':' title="Primero cargá fotos, documentos o enlaces"')
        +' onclick="_inspRevisadoModal(\'' + oid + '\')">'
        +'<i class="ti ti-check"></i> Marcar inspección como revisada</button>';
    } else {
      h+='<button class="btn bg2" style="font-size:11.5px;padding:7px 13px" onclick="_inspRevisadoModal(\'' + oid + '\')">'
        +'<i class="ti ti-refresh"></i> Volver a marcar</button>'
        +'<button class="btn bg2" style="font-size:11.5px;padding:7px 13px;color:var(--t-ambar)" onclick="_inspReabrir(\'' + oid + '\')">'
        +'<i class="ti ti-arrow-back-up"></i> Reabrir para corregir</button>';
    }
    h+='</div>';
  }
  return h+'</div>';
}

// Vuelve a dejar el paso pendiente, para seguir cargando o corrigiendo
async function _inspReabrir(oid){
  if(!CU || (CU.role!=='compras' && CU.role!=='gerencia')) return;
  if(!confirm('¿Reabrir la inspección?\n\nEl paso vuelve a quedar pendiente y puedes seguir cargando o corrigiendo la evidencia.')) return;
  try{
    initP(oid);
    var pi=_pasoIdxProd(_PASO_INSPECCION);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)>pi){
      sp.stepIdx=pi;
      if(sp.stepDates) sp.stepDates[pi]='';
      guardarEtapa(oid,'produccion');
    }
  }catch(e){}
  _solEnvioGuardar(oid, 'inspeccion', null);
  showT('Inspección reabierta');
  _inspRepintar(oid);
}

// Zona de subida, con lista y borrado
function _inspZona(oid, sub, titulo, ayuda, color, icono, accept){
  var files=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    // Las fotos se muestran como miniaturas
    var esFoto=/fotos$/.test(sub);
    if(esFoto){
      h+='<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:4px">';
      files.forEach(function(a,i){
        h+='<div style="position:relative">'
          +'<img src="'+_esc(a.data||'')+'" onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" '
          +'style="width:62px;height:62px;object-fit:cover;border-radius:6px;border:0.5px solid var(--border);cursor:zoom-in" title="'+_esc(a.name||'')+'">'
          +((CU&&CU.role!=='bodega')?('<span onclick="event.stopPropagation();_inspBorrar(\''+oid+'\',\''+sub+'\','+i+')" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:#fff;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-size:10px;cursor:pointer">×</span>'):'')
          +'</div>';
      });
      h+='</div>';
    } else {
      files.forEach(function(a,i){
        h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
          +'<i class="ti '+icono+'" style="color:'+color+'"></i>'
          +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
          +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px"'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
          +((CU&&CU.role!=='bodega')?('<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_inspBorrar(\''+oid+'\',\''+sub+'\','+i+')"><i class="ti ti-trash"></i></button>'):'')
          +'</div>';
      });
    }
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple'+(accept?(' accept="'+accept+'"'):'')+' style="display:none" onchange="_inspSubir(\''+oid+'\',\''+sub+'\',this.files)"></label>';
  return h+'</div>';
}

// Enlaces externos de la inspección
function _inspLinks(oid){
  var links=_inspLeerLinks(oid);
  var h='<div style="background:var(--surface-0);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-lila);margin-bottom:4px">3 · ENLACES DE DESCARGA '
    +'<span style="font-weight:400;color:var(--text-muted)">(WeTransfer, TransferNow…)</span></div>';
  if(links.length){
    links.forEach(function(l,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:4px 0;border-top:0.5px solid var(--border)">'
        +'<i class="ti ti-link" style="color:var(--t-lila)"></i>'
        +'<div style="flex:1;min-width:0">'
          +'<a href="'+_esc(l.url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="color:var(--text-accent);text-decoration:underline;word-break:break-all">'+_esc(l.url)+'</a>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(l.por||'')+(l.fecha?(' \u00b7 '+_esc(l.fecha)):'')+(l.nota?(' \u00b7 '+_esc(l.nota)):'')+'</div>'
        +'</div>'
        +'<button class="btn bg2" style="padding:3px 8px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_inspBorrarLink(\''+oid+'\','+i+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
  }
  h+=_inspDescargasPanel(oid);
  h+='<div style="display:flex;gap:5px;margin-top:6px">'
    +'<input id="insplink-'+oid+'" placeholder="Pegá el enlace de descarga" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:11px;background:var(--surface-0);color:var(--text-primary)" onclick="event.stopPropagation()">'
    +'<button class="btn bp" style="padding:6px 11px;font-size:11px" onclick="event.stopPropagation();_inspAgregarLink(\''+oid+'\')">Guardar</button>'
    +'</div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
    +'El servidor descarga el contenido solo y lo deja aquí arriba.</div>';
  return h+'</div>';
}

function _inspDescargasPanel(oid){
  var ds=(window._hubDesc['insp_'+oid]||[]);
  if(!ds.length) return '';
  var col={pendiente:['#B45309','#FEF3E8','En cola'], procesando:['#5B21B6','#EDE9FE','Descargando…'],
           listo:['#166534','#dcfce7','Descargado'], error:['#991b1b','#FEF2F2','No se pudo']};
  var h='';
  ds.forEach(function(d){
    var c=col[d.estado]||col.pendiente;
    var arch=d.archivos;
    if(typeof arch==='string'){ try{ arch=JSON.parse(arch); }catch(e){ arch=null; } }
    h+='<div style="border-top:0.5px solid var(--border);padding:5px 0;font-size:10.5px">'
      +'<span style="background:'+c[1]+';color:'+c[0]+';border-radius:6px;padding:1px 7px;font-weight:700">'+c[2]+'</span> '
      +'<span style="color:var(--text-muted)">'+_esc(String(d.url||'').slice(0,46))+'…</span>'
      +(d.detalle?('<div style="color:'+c[0]+';margin-top:2px">'+_esc(d.detalle)+'</div>'):'')
      +(arch&&arch.length?('<div style="color:var(--text-success);margin-top:2px"><i class="ti ti-check"></i> '+_esc(arch.join(', '))+'</div>'):'')
      +(_esGerencia()?('<span onclick="event.stopPropagation();_inspBorrarLog(\''+oid+'\','+(d.id||0)+')" style="float:right;color:var(--text-danger);cursor:pointer;margin-top:-14px"><i class="ti ti-x"></i></span>'):'')
      +'</div>';
  });
  return h;
}

async function _inspSubir(oid, sub, files){
  if(!files||!files.length) return;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir inspeccion:',e); }
  }
  showT('✓ Archivos adjuntados');
  _inspRepintar(oid);
}

async function _inspBorrar(oid, sub, i){
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Está seguro de que desea borrar "'+(a.name||'')+'"?\n\nEsta acción no se puede deshacer.')) return;
  await _borrarArchivoStorage(a.url, a.id);
  window._atts[oid+sub].splice(i,1);
  showT('Archivo eliminado');
  _inspRepintar(oid);
}

// Repinta solo el panel de inspección, sin cerrar la etapa
function _inspRepintar(oid){
  var c=document.getElementById('insppanel-'+oid);
  if(c) c.innerHTML=_inspPanel(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { _dbg('[panel] no está visible: no se repinta'); }
  // El semáforo del subpaso vive fuera del panel: se repinta también para
  // que el color cambie apenas se sube o se borra algo.
  try{ _inspRepintarPaso(oid); }catch(e){}
}

// Repinta el subpaso completo dejando todo como estaba
function _inspRepintarPaso(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='produccion'; });
  if(idx<0) return;
  var i=_pasoIdxProd(_PASO_INSPECCION);
  if(i<0) return;
  var body=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
  var abierto=!!(body && body.style.display!=='none');
  var cont=document.getElementById('egb-'+oid+'-'+idx);
  if(!cont) return;
  var scrollY=window.scrollY;
  var borrador='';
  try{ var inp=document.getElementById('subcin-'+oid+'-'+idx+'-'+i); if(inp) borrador=inp.value||''; }catch(e){}

  try{ buildEGB(oid, idx, cont); }catch(e){ console.warn('repintar inspeccion:',e); return; }

  if(abierto){
    var b2=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
    if(b2) b2.style.display='block';
    var ch=document.getElementById('ssch-'+oid+'-'+idx+'-'+i);
    if(ch) ch.style.transform='rotate(180deg)';
  }
  if(borrador){
    var inp2=document.getElementById('subcin-'+oid+'-'+idx+'-'+i);
    if(inp2) inp2.value=borrador;
  }
  window.scrollTo(0, scrollY);
}

// ── Enlaces de la inspección ──
function _inspLinksKey(oid){ return 'insplinks_'+oid; }
function _inspLeerLinks(oid){
  if(window._inspLinks && window._inspLinks[oid]) return window._inspLinks[oid];
  try{ var v=localStorage.getItem(_inspLinksKey(oid)); if(v){ var l=JSON.parse(v); if(Array.isArray(l)) return l; } }catch(e){}
  return [];
}
function _inspGuardarLinks(oid, links){
  window._inspLinks=window._inspLinks||{};
  window._inspLinks[oid]=links;
  try{ localStorage.setItem(_inspLinksKey(oid), JSON.stringify(links)); }catch(e){}
}
async function _inspAgregarLink(oid){
  var inp=document.getElementById('insplink-'+oid);
  var url=(inp&&inp.value||'').trim();
  if(!url){ showT('Pegá un enlace primero'); return; }
  if(!/^https?:\/\//i.test(url)){ showT('El enlace tiene que empezar con http:// o https://'); return; }
  var links=_inspLeerLinks(oid).slice();
  if(links.some(function(l){ return l.url===url; })){ showT('Ese enlace ya está guardado'); return; }
  var nota=prompt('¿Qué contiene este enlace? (opcional)\n\nPor ejemplo: fotos de la inspección','')||'';
  links.push({url:url, por:(CU&&CU.name)||'', fecha:now2(), nota:nota});
  _inspGuardarLinks(oid, links);
  if(inp) inp.value='';
  showT('Enlace guardado. Poniéndolo en cola de descarga…');
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({ docnum:String(oid), etapa:_subKeyProd(_PASO_INSPECCION)+'_fotos',
        url:url, nota:nota, pedido_por:(CU&&CU.name)||'', estado:'pendiente',
        creado_en:new Date().toISOString() })});
    if(r.ok) showT('✓ En cola. Los archivos van a aparecer solos aquí.');
  }catch(e){ console.warn('encolar:',e); }
  await _inspDescargasCargar(oid);
  _inspRepintar(oid);
  _inspVigilar(oid);
}
function _inspBorrarLink(oid, i){
  var links=_inspLeerLinks(oid).slice();
  if(!links[i]) return;
  if(!confirm('¿Borrar este enlace?\n\n'+links[i].url)) return;
  links.splice(i,1);
  _inspGuardarLinks(oid, links);
  _inspRepintar(oid);
}
async function _inspBorrarLog(oid, id){
  if(!_esGerencia() || !id) return;
  try{ await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+id,{method:'DELETE',headers:SBH}); }catch(e){}
  window._hubDesc['insp_'+oid]=(window._hubDesc['insp_'+oid]||[]).filter(function(d){ return String(d.id)!==String(id); });
  _inspRepintar(oid);
}
async function _inspDescargasCargar(oid){
  try{
    var et=_subKeyProd(_PASO_INSPECCION)+'_fotos';
    var r=await fetch(SB+'/rest/v1/descargas_queue?select=*&docnum=eq.'+encodeURIComponent(oid)
      +'&etapa=eq.'+encodeURIComponent(et)+'&order=creado_en.desc&limit=20',{headers:SBH});
    if(!r.ok) return [];
    var rows=await r.json();
    window._hubDesc['insp_'+oid]=Array.isArray(rows)?rows:[];
    return window._hubDesc['insp_'+oid];
  }catch(e){ return []; }
}
function _inspVigilar(oid, intento){
  intento=intento||0;
  var espera = intento===0 ? 1500 : (intento<20 ? 3000 : 8000);
  setTimeout(function(){
    var antes=(window._hubDesc['insp_'+oid]||[]).map(function(d){return d.id+':'+d.estado;}).join('|');
    _inspDescargasCargar(oid).then(async function(ds){
      ds=ds||[];
      var ahora=ds.map(function(d){return d.id+':'+d.estado;}).join('|');
      if(ahora!==antes){
        try{ await cargarDocsOrden(oid); }catch(e){}
        _inspRepintar(oid);
      }
      if(ds.some(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; }) && intento<100){
        _inspVigilar(oid, intento+1);
      }
    });
  }, espera);
}

// ── Marcar la inspección como revisada y avisar al encargado ──
function _inspRevisadoModal(oid){
  var d=_solPagoDatosOrden(oid);
  var dept=d.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  // El encargado: gerencia del departamento, o toda la gerencia
  var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia'; });
  var delDept=gers.filter(function(u){ return dept && String(u.dept||'')===String(dept); });
  var chips=gers.map(function(u){
    var marcado=delDept.length ? delDept.some(function(z){return z.id===u.id;}) : true;
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#B45309':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#FEF9F3':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.id)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +(delDept.some(function(z){return z.id===u.id;})?'<span style="font-size:9px;color:var(--t-ambar);font-weight:700">'+_esc(dL(dept))+'</span>':'')
      +'</label>';
  }).join('');

  var sk=_subKeyProd(_PASO_INSPECCION);
  var nF=((window._atts&&window._atts[oid+sk+'_fotos'])||[]).length;
  var nD=((window._atts&&window._atts[oid+sk+'_docs'])||[]).length;

  var prev=document.getElementById('modalInsp'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalInsp';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:500px;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-ambar)"><i class="ti ti-clipboard-check"></i> Inspección revisada</div>'
      +'<button onclick="document.getElementById(\'modalInsp\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> · orden '+_esc(d.dkc||oid)
      +'<div style="margin-top:3px">'+nF+' foto(s) · '+nD+' documento(s) adjuntos</div></div>'
    +(nF+nD===0?'<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-rojo)"><i class="ti ti-alert-triangle"></i> No hay nada adjunto todavía. El encargado no va a poder revisar.</div>':'')
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">¿A QUIÉN LE AVISO? (opcional)</div>'
    +'<div id="insp-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'+chips+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">NOTA (opcional)</div>'
    +'<textarea id="insp-nota" rows="3" placeholder="Algo que el encargado deba mirar…" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical"></textarea>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalInsp\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="insp-btn" style="background:#B45309" onclick="_inspRevisadoEnviar(\'' + oid + '\')"><i class="ti ti-send"></i> Marcar revisada y avisar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

async function _inspRevisadoEnviar(oid){
  var box=document.getElementById('insp-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  var nombres=marcados.map(function(c){ return c.getAttribute('data-nom'); });
  var nota=(document.getElementById('insp-nota')||{}).value||'';
  var n=_inspCuantos(oid);

  if(!n.total){
    if(!confirm('No hay fotos, documentos ni enlaces cargados.\n\n¿Marcarla como revisada igual?')) return;
  }
  if(!confirm('¿Marcar la inspección como revisada?\n\n'
    +(nombres.length?('Se le avisa a: '+nombres.join(', ')+'\n\n'):'')
    +'La etapa de Producción queda en verde. Puedes seguir subiendo o borrando archivos después.')) return;

  var btn=document.getElementById('insp-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  // El paso de la compradora queda completado
  try{
    var st=STAGES.find(function(z){ return z.key==='produccion'; });
    var pi=_pasoIdxProd(_PASO_INSPECCION);
    initP(oid);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pi]=hoyIso;
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'produccion');
    }
  }catch(e){ console.warn('marcar inspeccion:',e); }

  // Alerta al encargado, que lo lleva al paso de aprobación
  var destinos=marcados.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean);
  if(destinos.length){
    try{
      await _menNotificar(destinos, {
        docnum:oid, contexto:'etapa', etapa:'Producción',
        texto:'Inspección de producción finalizada'+(nota?(' — '+nota):''),
        etiqueta:'Producción — inspección finalizada',
        paso:_PASO_INSPECCION
      });
    }catch(e){ console.warn('alerta inspeccion:',e); }
  }

  _solEnvioGuardar(oid, 'inspeccion', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:nombres, nota:nota
  });

  var m=document.getElementById('modalInsp'); if(m) m.remove();
  showT('✓ Inspección revisada. Se avisó a '+nombres.join(', '));
  _inspRepintar(oid);
}

// ── Panel del encargado: aprobar o devolver ──
function _inspAprobarPanel(oid){
  var rev=_solEnvioLeer(oid,'inspeccion');
  var apr=_solEnvioLeer(oid,'inspeccion_ok');
  var sk=_subKeyProd(_PASO_INSPECCION);
  var fotos=(window._atts&&window._atts[oid+sk+'_fotos'])?_dedupDocs(window._atts[oid+sk+'_fotos']):[];
  var docs=(window._atts&&window._atts[oid+sk+'_docs'])?_dedupDocs(window._atts[oid+sk+'_docs']):[];

  var h='<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-verde2);margin-bottom:6px">'
    +'<i class="ti ti-eye-check"></i> Revisión del encargado</div>';

  if(!rev){
    h+='<div style="font-size:11px;color:var(--t-verde2)">La compradora todavía no marcó la inspección como revisada.</div>';
    return h+'</div>';
  }

  h+='<div style="font-size:11px;color:var(--t-verde2);margin-bottom:7px">'
    +'Enviada por <b>'+_esc(rev.por||'')+'</b> · '+_esc(_fechaHora(rev.fecha))
    +(rev.nota?('<div style="margin-top:3px;font-style:italic">'+_esc(rev.nota)+'</div>'):'')+'</div>';

  // La evidencia, a la vista
  if(fotos.length){
    h+='<div style="font-size:10.5px;color:var(--t-verde2);font-weight:700;margin-bottom:4px">FOTOS ('+fotos.length+')</div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:7px">';
    fotos.forEach(function(a){
      h+='<img src="'+_esc(a.data||'')+'" onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" '
        +'style="width:70px;height:70px;object-fit:cover;border-radius:6px;border:0.5px solid var(--border);cursor:zoom-in" title="'+_esc(a.name||'')+'">';
    });
    h+='</div>';
  }
  if(docs.length){
    h+='<div style="font-size:10.5px;color:var(--t-verde2);font-weight:700;margin-bottom:4px">DOCUMENTOS ('+docs.length+')</div>';
    docs.forEach(function(a){
      h+='<div style="font-size:11.5px;padding:2px 0"><i class="ti ti-file" style="color:var(--t-verde2)"></i> '
        +'<span'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" style="color:var(--text-accent);text-decoration:underline;cursor:pointer">'+_esc(a.name||'')+'</span></div>';
    });
  }

  if(apr){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Inspección aprobada</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">Por <b>'+_esc(apr.por||'')+'</b> · '+_esc(_fechaHora(apr.fecha))
      +(apr.nota?('<br>'+_esc(apr.nota)):'')+'</div></div>';
  } else if(CU && CU.role==='gerencia'){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:9px">'
      +'<button class="btn bp" style="background:#16a34a;font-size:12px;padding:8px 16px;font-weight:700" onclick="_inspAprobar(\'' + oid + '\')">'
        +'<i class="ti ti-check"></i> OK — Aprobar inspección</button>'
      +'<button class="btn bp" style="background:#B45309;font-size:11.5px;padding:8px 13px" onclick="_inspDevolver(\'' + oid + '\')">'
        +'<i class="ti ti-arrow-back-up"></i> Devolver con observaciones</button>'
      +'</div>';
  }
  return h+'</div>';
}

async function _inspAprobar(oid){
  if(!CU || CU.role!=='gerencia'){ showT('Solo el encargado puede aprobar'); return; }
  if(!confirm('¿Aprobar la inspección de producción?\n\nLa etapa queda completada y la orden pasa a Logística.')) return;
  var nota=prompt('Comentario (opcional):','')||'';

  try{
    var st=STAGES.find(function(z){ return z.key==='produccion'; });
    var pi=_pasoIdxProd(_PASO_INSP_OK);
    initP(oid);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pi]=hoyIso;
      guardarEtapa(oid,'produccion');
    }
  }catch(e){ console.warn('aprobar inspeccion:',e); }

  _solEnvioGuardar(oid, 'inspeccion_ok', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', nota:nota
  });

  // Se le avisa a quien la envió
  try{
    var rev=_solEnvioLeer(oid,'inspeccion');
    var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String((rev&&rev.por)||''); });
    if(quien) await _menNotificar([quien], {
      docnum:oid, contexto:'etapa', etapa:'Producción',
      texto:'Inspección aprobada'+(nota?(' — '+nota):'')+'. La orden pasa a Logística.',
      etiqueta:'Producción — inspección aprobada',
      paso:_PASO_INSP_OK
    });
  }catch(e){}

  showT('✓ Inspección aprobada. La orden pasa a Logística.');
  try{ openDetail(oid); }catch(e){}
}

async function _inspDevolver(oid){
  if(!CU || CU.role!=='gerencia'){ showT('Solo el encargado puede devolverla'); return; }
  var obs=prompt('¿Qué hay que corregir?\n\nSe le avisa a quien envió la inspección.','');
  if(obs===null) return;
  obs=String(obs).trim();
  if(!obs){ showT('Escribe las observaciones'); return; }

  // El paso de la compradora vuelve a quedar pendiente
  try{
    initP(oid);
    var pi=_pasoIdxProd(_PASO_INSPECCION);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)>pi){
      sp.stepIdx=pi;
      if(sp.stepDates) sp.stepDates[pi]='';
      guardarEtapa(oid,'produccion');
    }
  }catch(e){}

  try{
    var rev=_solEnvioLeer(oid,'inspeccion');
    var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String((rev&&rev.por)||''); });
    var destinos=quien?[quien]:(USERS||[]).filter(function(u){ return _esComprasU(u); });
    await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Producción',
      texto:'Inspección devuelta: '+obs,
      etiqueta:'Producción — inspección con observaciones',
      paso:_PASO_INSPECCION
    });
  }catch(e){}

  _solEnvioGuardar(oid, 'inspeccion', null);
  showT('Inspección devuelta con observaciones');
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  LOGÍSTICA — BOOKING, B/L Y AVISO DE LLEGADA
//  Cada subetapa recibe su documento, la IA lo lee y llena los datos. Las
//  tarifas se separan por moneda: lo que está en dólares lo paga Kennedy y lo
//  que viene en otra moneda lo paga el proveedor. Al cargar el B/L y el aviso
//  de llegada, los montos se cotejan contra el booking.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_BOOKING = 'Booking';
var _PASO_BL      = 'Bill of Lading (B/L)';
var _PASO_ARRIVAL = 'Aviso de llegada';

// ── Control de la revisión con AI ──
// Los pasos que tienen lectura por AI no se pueden enviar sin haberla hecho:
// antes se podía mandar un documento sin que nadie lo hubiera revisado.
window._iaRevisado=window._iaRevisado||{};

function _iaClave(oid, paso){ return String(oid)+'|'+String(paso||''); }

function _iaMarcarRevisado(oid, paso){
  window._iaRevisado[_iaClave(oid,paso)]={por:(CU&&CU.name)||'', en:new Date().toISOString()};
  try{ localStorage.setItem('iarev_'+_iaClave(oid,paso), JSON.stringify(window._iaRevisado[_iaClave(oid,paso)])); }catch(e){}
}

function _iaEstaRevisado(oid, paso){
  var k=_iaClave(oid,paso);
  if(window._iaRevisado[k]) return window._iaRevisado[k];
  try{
    var v=localStorage.getItem('iarev_'+k);
    if(v){ window._iaRevisado[k]=JSON.parse(v); return window._iaRevisado[k]; }
  }catch(e){}
  return null;
}

// Devuelve true si se puede seguir; si no, avisa y devuelve false
function _iaExigirRevision(oid, paso, queEs){
  var r=_iaEstaRevisado(oid, paso);
  if(r) return true;
  alert('Falta la revisión con AI.\n\n'
    +'Antes de enviar hay que revisar '+(queEs||'los documentos')+' con el botón '
    +'"Revisar con AI" o "Leer con AI" de este paso.\n\n'
    +'Así se confirma que los datos del documento son correctos.');
  return false;
}

// Aviso visible cuando un panel de etapa falla, en vez de desaparecer callado
function _panelErrLog(nombre, e){
  console.error('[panel '+nombre+']', e);
  return '<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;margin-bottom:8px;font-size:11.5px;color:var(--t-rojo)">'
    +'<b><i class="ti ti-alert-triangle"></i> No se pudo mostrar el panel de '+_esc(nombre)+'</b>'
    +'<div style="margin-top:3px;font-family:monospace;font-size:10.5px">'+_esc(e&&(e.message||String(e)))+'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CIERRE MANUAL DE SUBETAPAS
//  Algunas subetapas se cierran solas al enviar un correo o adjuntar un
//  documento. Las que no, necesitan un botón para poder dejarlas en verde.
// ═══════════════════════════════════════════════════════════════════════════
function _cerrarPaso(oid, stageKey, nombrePaso, silencioso){
  var st=STAGES.find(function(z){ return z.key===stageKey; });
  if(!st) return false;
  var pi=st.steps.findIndex(function(p){ return p.name===nombrePaso; });
  if(pi<0) return false;
  initP(oid);
  var sp=stageProgress[oid][stageKey];
  if(!sp) return false;
  if((sp.stepIdx||0)>pi) return true;        // ya estaba cerrado
  var hoyIso=new Date().toISOString().slice(0,10);
  sp.stepIdx=pi+1;
  if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
  sp.stepDates[pi]=now2();
  if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
  sp.stepBy[pi]=(CU&&CU.name)||'';
  if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
  sp._isoPasos[pi]=hoyIso;
  if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
  guardarEtapa(oid, stageKey);
  if(!silencioso) showT('✓ "'+nombrePaso+'" marcado como hecho');
  return true;
}

// Botón para dejar un paso en verde a mano, con lo que falta si falta algo
function _btnCerrarPaso(oid, stageKey, nombrePaso, opts){
  opts=opts||{};
  var st=STAGES.find(function(z){ return z.key===stageKey; });
  if(!st) return '';
  var pi=st.steps.findIndex(function(p){ return p.name===nombrePaso; });
  if(pi<0) return '';
  initP(oid);
  var sp=(stageProgress[oid]||{})[stageKey]||{};
  var hecho=((sp.stepIdx||0)>pi);
  var quien=(sp.stepBy||[])[pi]||'';
  var cuando=(sp.stepDates||[])[pi]||'';

  if(hecho){
    return '<div style="display:flex;align-items:center;gap:8px;background:var(--pastel-ok);border:1px solid #16a34a;'
      +'border-radius:8px;padding:8px 11px;margin-top:8px">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde)"></i>'
      +'<div style="flex:1;font-size:11.5px;color:var(--t-verde)">'
        +'<b>Paso completado</b>'+(quien?(' · '+_esc(quien)):'')+(cuando?(' · '+_esc(cuando)):'')+'</div>'
      +((CU && (CU.role===st.steps[pi].role || CU.role==='gerencia'))
        ? ('<button class="btn bg2" style="padding:3px 9px;font-size:10px" onclick="event.stopPropagation();_reabrirPaso(\''+oid+'\',\''+stageKey+'\',\''+String(nombrePaso).replace(/'/g,'')+'\')">Reabrir</button>')
        : '')
      +'</div>';
  }

  var puede = CU && (CU.role===st.steps[pi].role || CU.role==='gerencia'
              || (opts.roles && opts.roles.indexOf(CU.role)>=0));
  if(!puede) return '';

  var falta=opts.falta||'';
  return '<div style="display:flex;align-items:center;gap:8px;background:var(--surface-0);'
    +'border:0.5px solid var(--border);border-radius:8px;padding:8px 11px;margin-top:8px;flex-wrap:wrap">'
    +'<div style="flex:1;min-width:150px;font-size:11px;color:var(--text-muted)">'
      +(falta?('<i class="ti ti-alert-circle" style="color:var(--t-ambar)"></i> '+_esc(falta))
             :'Cuando termines este paso, marcalo para que quede en verde.')+'</div>'
    +'<button class="btn bp" style="background:#639922;padding:5px 12px;font-size:11px;font-weight:600" '
    +'onclick="event.stopPropagation();_cerrarPasoUI(\''+oid+'\',\''+stageKey+'\',\''+String(nombrePaso).replace(/'/g,'')+'\')">'
    +'<i class="ti ti-check"></i> Marcar como realizado</button>'
    +'</div>';
}

function _cerrarPasoUI(oid, stageKey, nombrePaso){
  if(!confirm('¿Marcar "'+nombrePaso+'" como realizado?')) return;
  if(_cerrarPaso(oid, stageKey, nombrePaso)){
    try{ _avisarGerenciaPaso(oid, stageKey, _pasoIdxDe(stageKey, nombrePaso)); }catch(e){}
    try{ openDetail(oid); }catch(e){}
  }
}

function _pasoIdxDe(stageKey, nombrePaso){
  var st=STAGES.find(function(z){ return z.key===stageKey; });
  return st ? st.steps.findIndex(function(p){ return p.name===nombrePaso; }) : -1;
}

function _reabrirPaso(oid, stageKey, nombrePaso){
  if(!confirm('¿Reabrir "'+nombrePaso+'"?\n\nLa etapa vuelve a este punto.')) return;
  var pi=_pasoIdxDe(stageKey, nombrePaso);
  if(pi<0) return;
  initP(oid);
  var sp=stageProgress[oid][stageKey];
  if(!sp) return;
  sp.stepIdx=pi;
  if(sp.stepDates) sp.stepDates[pi]='';
  if(sp.stepBy) sp.stepBy[pi]='';
  guardarEtapa(oid, stageKey);
  showT('Paso reabierto');
  try{ openDetail(oid); }catch(e){}
}

function _pasoIdxLog(nombre){
  var st=STAGES.find(function(z){ return z.key==='logistica'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyLog(nombre){
  var i=_pasoIdxLog(nombre);
  return i<0 ? '' : ('logistica_step'+i);
}

// ── Datos de logística guardados por orden ──
window._logData=window._logData||{};

function _logLeer(oid){
  if(window._logData[oid]) return window._logData[oid];
  var d=null;
  try{ var v=localStorage.getItem('log_'+oid); if(v) d=JSON.parse(v); }catch(e){}
  if(!d){
    // Puede venir guardado en la propia orden
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p && p.logistica){
      d=p.logistica;
      if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
    }
  }
  d=d||{booking:{}, bl:{}, arrival:{}, contenedores:[]};
  d.booking=d.booking||{}; d.bl=d.bl||{}; d.arrival=d.arrival||{};
  d.contenedores=d.contenedores||[];
  window._logData[oid]=d;
  return d;
}

async function _logGuardar(oid){
  var d=_logLeer(oid);
  try{ localStorage.setItem('log_'+oid, JSON.stringify(d)); }catch(e){}
  try{
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p){
      p.logistica=d;
      await fetch(SB+'/rest/v1/compras_pend_sap?dkc=eq.'+encodeURIComponent(p.dkc||p.num_orden),{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({logistica:d})});
    } else {
      await fetch(SB+'/rest/v1/compras_logistica?on_conflict=docnum',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
        body:JSON.stringify({docnum:String(oid), datos:d, actualizado_en:new Date().toISOString()})});
    }
  }catch(e){ console.warn('guardar logistica:',e); }
}

// ── Tarifas: lo que paga Kennedy vs el proveedor ──
function _logTotales(tarifas){
  var kcc=0, prov=0, monedas={};
  (tarifas||[]).forEach(function(t){
    var m=String(t.moneda||'').toUpperCase().trim();
    var v=Number(t.monto)||0;
    monedas[m]=(monedas[m]||0)+v;
    // Los cargos en dólares los paga Kennedy; el resto, el proveedor
    if(m==='USD' || m==='US$' || m==='$' || m==='DOLAR' || m==='DÓLAR') kcc+=v;
    else prov+=v;
  });
  return {kcc:kcc, prov:prov, monedas:monedas};
}

function _logTablaTarifas(tarifas, editable, oid, donde){
  var t=_logTotales(tarifas);
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;overflow:hidden;margin-bottom:8px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<tr style="background:var(--surface-1)">'
      +'<th style="text-align:left;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Concepto</th>'
      +'<th style="text-align:right;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Monto</th>'
      +'<th style="text-align:center;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Moneda</th>'
      +'<th style="text-align:center;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Paga</th>'
      +(editable?'<th style="width:28px"></th>':'')
    +'</tr>';
  if(!(tarifas||[]).length){
    h+='<tr><td colspan="'+(editable?5:4)+'" style="padding:9px;text-align:center;color:var(--text-muted);font-size:11px">Sin tarifas cargadas</td></tr>';
  }
  (tarifas||[]).forEach(function(x,i){
    var m=String(x.moneda||'').toUpperCase().trim();
    var esKcc=(m==='USD'||m==='US$'||m==='$');
    // Todo editable: la AI puede leer mal un monto o una moneda
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:3px 6px">'+(editable
          ? ('<input value="'+_esc(x.concepto||'')+'" onclick="event.stopPropagation()" onchange="_logSetTarifa(\'' + oid + '\',\'' + donde + '\','+i+',\'concepto\',this.value)" style="width:100%;padding:3px 6px;border:0.5px solid transparent;border-radius:5px;font-size:11.5px;background:transparent;color:var(--text-primary)" onfocus="this.style.borderColor=\'var(--border)\';this.style.background=\'var(--surface-0)\'" onblur="this.style.borderColor=\'transparent\';this.style.background=\'transparent\'">')
          : _esc(x.concepto||''))+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+(editable
          ? ('<input value="'+_esc(_fmtN2(x.monto))+'" onclick="event.stopPropagation()" onchange="_logSetTarifa(\'' + oid + '\',\'' + donde + '\','+i+',\'monto\',this.value)" style="width:92px;padding:3px 6px;border:0.5px solid transparent;border-radius:5px;font-size:11.5px;font-weight:600;text-align:right;background:transparent;color:var(--text-primary)" onfocus="this.style.borderColor=\'var(--border)\';this.style.background=\'var(--surface-0)\'" onblur="this.style.borderColor=\'transparent\';this.style.background=\'transparent\'">')
          : ('<span style="font-weight:600">'+_fmtN2(x.monto)+'</span>'))+'</td>'
      +'<td style="padding:3px 6px;text-align:center">'+(editable
          ? ('<input value="'+_esc(m)+'" placeholder="USD" onclick="event.stopPropagation()" onchange="_logSetTarifa(\'' + oid + '\',\'' + donde + '\','+i+',\'moneda\',this.value)" style="width:58px;padding:3px 6px;border:0.5px solid transparent;border-radius:5px;font-size:11.5px;text-align:center;text-transform:uppercase;background:transparent;color:var(--text-primary)" onfocus="this.style.borderColor=\'var(--border)\';this.style.background=\'var(--surface-0)\'" onblur="this.style.borderColor=\'transparent\';this.style.background=\'transparent\'">')
          : _esc(m||'—'))+'</td>'
      +'<td style="padding:5px 9px;text-align:center">'
        +'<span style="font-size:10px;font-weight:700;border-radius:6px;padding:1px 7px;background:'
        +(esKcc?'#e6f1fb;color:var(--t-azul)':'#FEF3E8;color:var(--t-marron)')+'">'+(esKcc?'KENNEDY':'PROVEEDOR')+'</span></td>'
      +(editable?('<td style="text-align:center"><span onclick="event.stopPropagation();_logBorrarTarifa(\'' + oid + '\',\'' + donde + '\','+i+')" style="color:var(--text-danger);cursor:pointer">×</span></td>'):'')
      +'</tr>';
  });
  h+='</table>'
    +'<div style="display:flex;gap:9px;padding:8px 9px;background:var(--surface-1);border-top:0.5px solid var(--border);flex-wrap:wrap">'
      +'<div style="flex:1;min-width:130px"><div style="font-size:9.5px;color:var(--t-azul);font-weight:700;text-transform:uppercase">Paga Kennedy</div>'
        +'<div style="font-size:14px;font-weight:700;color:var(--t-azul)">'+fmt(t.kcc)+'</div></div>'
      +'<div style="flex:1;min-width:130px"><div style="font-size:9.5px;color:var(--t-marron);font-weight:700;text-transform:uppercase">Paga el proveedor</div>'
        +'<div style="font-size:14px;font-weight:700;color:var(--t-marron)">'
        +Object.keys(t.monedas).filter(function(m){ return !(m==='USD'||m==='US$'||m==='$'); })
           .map(function(m){ return _fmtN2(t.monedas[m])+' '+m; }).join(' · ')
        +(t.prov?'':'—')+'</div></div>'
    +'</div></div>';
  if(editable){
    h+='<button class="btn bg2" style="font-size:10.5px;padding:4px 10px;margin-bottom:8px" onclick="event.stopPropagation();_logAgregarTarifa(\'' + oid + '\',\'' + donde + '\')">'
      +'<i class="ti ti-plus"></i> Agregar cargo a mano</button>';
  }
  return h;
}

// Corrige un dato de una tarifa que la AI pudo leer mal
function _logSetTarifa(oid, donde, i, campo, valor){
  var d=_logLeer(oid);
  if(!d[donde] || !d[donde].tarifas || !d[donde].tarifas[i]) return;
  if(campo==='monto'){
    var n=parseFloat(String(valor).replace(/,/g,''));
    if(isNaN(n)){ showT('Ese monto no es válido'); _logRepintar(oid); return; }
    d[donde].tarifas[i].monto=n;
  } else if(campo==='moneda'){
    d[donde].tarifas[i].moneda=String(valor||'').toUpperCase().trim();
  } else {
    d[donde].tarifas[i][campo]=String(valor||'').trim();
  }
  _logGuardar(oid);
  _logRepintar(oid);       // los totales y el cotejo se recalculan
}

function _logAgregarTarifa(oid, donde){
  var concepto=prompt('Concepto del cargo:\n\nPor ejemplo: OCEAN FREIGHT, THC, BL FEE','');
  if(concepto===null || !concepto.trim()) return;
  var montoTxt=prompt('Monto:','');
  if(montoTxt===null) return;
  var monto=parseFloat(String(montoTxt).replace(/,/g,''));
  if(isNaN(monto)){ showT('El monto no es válido'); return; }
  var moneda=(prompt('Moneda (USD, CNY, EUR…):','USD')||'USD').toUpperCase().trim();
  var d=_logLeer(oid);
  d[donde].tarifas=d[donde].tarifas||[];
  d[donde].tarifas.push({concepto:concepto.trim(), monto:monto, moneda:moneda});
  _logGuardar(oid);
  _logRepintar(oid);
}

function _logBorrarTarifa(oid, donde, i){
  var d=_logLeer(oid);
  if(!d[donde].tarifas || !d[donde].tarifas[i]) return;
  if(!confirm('¿Borrar el cargo "'+(d[donde].tarifas[i].concepto||'')+'"?')) return;
  d[donde].tarifas.splice(i,1);
  _logGuardar(oid);
  _logRepintar(oid);
}

// ── Contenedores: los que hagan falta por booking ──
function _logContenedores(oid, editable){
  var d=_logLeer(oid);
  var cs=d.contenedores||[];
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10.5px;font-weight:700;color:var(--text-secondary);margin-bottom:5px">'
    +'No. OF CONTAINERS <span style="font-weight:400;color:var(--text-muted)">('+cs.length+')</span>'
    +'<span style="font-weight:400;color:var(--text-muted);font-size:10px"> \u00b7 container no. y sello</span></div>';
  if(cs.length){
    h+='<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:5px">';
    cs.forEach(function(c,i){
      var nav=d.booking.naviera||'';
      var url=_trackURL(nav,'contenedor',c.numero);
      h+='<span style="display:inline-flex;align-items:center;gap:5px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:20px;padding:3px 10px;font-size:11.5px;font-family:monospace">'
        +(url?('<a href="'+_esc(url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="color:var(--text-accent);text-decoration:none" title="Rastrear '+_esc(c.numero||'')+(nav?(' en '+_esc(nav)):'')+'">'+_esc(c.numero||'')+'</a>')
             :_esc(c.numero||''))
        +(c.tipo?('<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(c.tipo)+'</span>'):'')
        +(c.sello?('<span style="font-size:9.5px;color:var(--t-marron);background:var(--pastel-naranja);border-radius:5px;padding:0 5px" title="Sello">\ud83d\udd12 '+_esc(c.sello)+'</span>'):'')
        +(editable?('<span onclick="event.stopPropagation();_logEditarCont(\'' + oid + '\','+i+')" title="Corregir" style="color:var(--text-muted);cursor:pointer;font-size:10px"><i class="ti ti-pencil"></i></span>'):'')
        +(editable?('<span onclick="event.stopPropagation();_logBorrarCont(\'' + oid + '\','+i+')" style="color:var(--text-danger);cursor:pointer;font-weight:700">×</span>'):'')
        +'</span>';
    });
    h+='</div>';
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">Todavía no hay contenedores cargados.</div>';
  }
  if(editable){
    h+='<button class="btn bg2" style="font-size:10.5px;padding:4px 10px" onclick="event.stopPropagation();_logAgregarCont(\'' + oid + '\')">'
      +'<i class="ti ti-plus"></i> Agregar contenedor</button>';
  }
  return h+'</div>';
}

function _logAgregarCont(oid){
  var txt=prompt('Número(s) de contenedor:\n\nPuedes pegar varios separados por coma o salto de línea.','');
  if(txt===null) return;
  var nums=String(txt).split(/[,;\n]/).map(function(x){return x.trim().toUpperCase();}).filter(Boolean);
  if(!nums.length) return;
  var tipo=prompt('Tipo (40HQ, 20GP, 40GP…) — opcional, se aplica a todos:','')||'';
  var sello=(nums.length===1)?(prompt('Sello / No. — opcional:','')||''):'';
  var d=_logLeer(oid);
  d.contenedores=d.contenedores||[];
  var nuevos=0;
  nums.forEach(function(n){
    if(d.contenedores.some(function(c){ return String(c.numero||'').toUpperCase()===n; })) return;
    d.contenedores.push({numero:n, tipo:tipo.trim().toUpperCase(), sello:sello.trim().toUpperCase()});
    nuevos++;
  });
  _logGuardar(oid);
  showT(nuevos?('✓ '+nuevos+' contenedor(es) agregado(s)'):'Ya estaban cargados');
  _logRepintar(oid);
}

// Corrige un contenedor mal leído
function _logEditarCont(oid, i){
  var d=_logLeer(oid);
  if(!d.contenedores[i]) return;
  var num=prompt('Número de contenedor:', d.contenedores[i].numero||'');
  if(num===null) return;
  num=String(num).toUpperCase().trim();
  if(!num){ showT('El número no puede quedar vacío'); return; }
  var tipo=prompt('Tipo (40HQ, 20GP…):', d.contenedores[i].tipo||'');
  if(tipo===null) tipo=d.contenedores[i].tipo||'';
  var sello=prompt('Sello / No.:', d.contenedores[i].sello||'');
  if(sello===null) sello=d.contenedores[i].sello||'';
  d.contenedores[i].numero=num;
  d.contenedores[i].tipo=String(tipo).toUpperCase().trim();
  d.contenedores[i].sello=String(sello).toUpperCase().trim();
  _logGuardar(oid);
  _logRepintar(oid);
}

function _logBorrarCont(oid, i){
  var d=_logLeer(oid);
  if(!d.contenedores[i]) return;
  if(!confirm('¿Borrar el contenedor '+(d.contenedores[i].numero||'')+'?')) return;
  d.contenedores.splice(i,1);
  _logGuardar(oid);
  _logRepintar(oid);
}

// Repinta los paneles de logística sin cerrar la etapa
function _logRepintar(oid){
  ['booking','bl','arrival'].forEach(function(k){
    var c=document.getElementById('logpanel-'+k+'-'+oid);
    if(c){
      try{
        c.innerHTML = k==='booking' ? _logPanelBooking(oid)
                    : k==='bl'      ? _logPanelBL(oid)
                                    : _logPanelArrival(oid);
      }catch(e){ console.warn('repintar logistica:',e); }
    }
  });
}

// Campo editable de un dato
function _logCampo(oid, donde, clave, etiqueta, valor, ancho){
  return '<div style="flex:1;min-width:'+(ancho||140)+'px">'
    +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:600;text-transform:uppercase;margin-bottom:2px">'+_esc(etiqueta)+'</div>'
    +'<input value="'+_esc(valor||'')+'" placeholder="—" onclick="event.stopPropagation()" '
    +'onchange="_logSetCampo(\'' + oid + '\',\'' + donde + '\',\'' + clave + '\',this.value)" '
    +'style="width:100%;padding:5px 8px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;background:var(--surface-0);color:var(--text-primary)"></div>';
}

function _logSetCampo(oid, donde, clave, valor){
  var d=_logLeer(oid);
  d[donde]=d[donde]||{};
  d[donde][clave]=valor;
  _logGuardar(oid);
}

// ── A) BOOKING ──
// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUD DE PAGO DE FLETE
//  Logística le pide a contabilidad el pago del flete, con copia a las
//  compradoras del departamento. Se adjuntan solos el aviso de llegada y el B/L.
// ═══════════════════════════════════════════════════════════════════════════
async function _fleteModal(oid){
  // Sin la lectura por AI del aviso de llegada no se pide el pago
  if(!_iaExigirRevision(oid, _PASO_ARRIVAL, 'el aviso de llegada')) return;
  var d=_logLeer(oid);
  // El número de entrada es obligatorio: va en el cuerpo del correo
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
  if(!entrada){
    var txt=prompt('Falta el NÚMERO DE ENTRADA y es obligatorio para pedir el pago del flete.\n\n'
      +'Escribilo ahora:','');
    if(txt===null) return;
    entrada=String(txt).trim();
    if(!entrada){ showT('Sin el número de entrada no se puede enviar la solicitud'); return; }
    d.arrival=d.arrival||{};
    d.arrival.entrada=entrada;
    await _logGuardar(oid);
    _logRepintar(oid);
  }
  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var dept=dat.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  window._mailAdj=[];
  window._fleteCtx={oid:oid};

  // Destinatarios: contabilidad y las compradoras del departamento
  var contab=(USERS||[]).filter(function(u){ return u.role==='contabilidad' && u.email; });
  var compras=(USERS||[]).filter(function(u){ return _esComprasU(u) && u.email && (!dept || String(u.dept||'')===String(dept)); });
  function chip(u, marcado, etiqueta, color){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?color:'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'var(--surface-1)':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +(etiqueta?('<span style="font-size:9px;color:'+color+';font-weight:700">'+etiqueta+'</span>'):'')
      +'</label>';
  }
  var chipsC=contab.map(function(u){ return chip(u,true,'contabilidad','#166534'); }).join('');
  var chipsP=compras.map(function(u){ return chip(u,true,dept?dL(dept):'compras','#0c447c'); }).join('');

  // El total que paga Kennedy sale del aviso; si no hay, del booking
  var tar=(d.arrival&&d.arrival.tarifas&&d.arrival.tarifas.length)?d.arrival.tarifas:(d.booking.tarifas||[]);
  var tot=_logTotales(tar);
  var cs=d.contenedores||[];
  var tipos={};
  cs.forEach(function(c){ var t=String(c.tipo||'').trim()||'—'; tipos[t]=(tipos[t]||0)+1; });
  var tipoTxt=Object.keys(tipos).map(function(t){ return (tipos[t]>1?(tipos[t]+' x '):'')+t; }).join(', ')||'—';

  var asunto='SOLICITUD DE PAGO DE FLETE '+ordenTxt;
  var cuerpo='Estimados,\n\n'
    +'Información del embarque:\n\n'
    +'  • NUMERO-DKC: '+ordenTxt+'\n'
    +'  • Fecha de llegada (ETA): '+((d.arrival&&d.arrival.fecha_llegada)||(d.bl&&d.bl.fecha_llegada)||'—')+'\n'
    +'  • Departamento: '+(dept?dL(dept):'—')+'\n'
    +'  • Número de BL: '+((d.arrival&&d.arrival.bl)||(d.bl&&d.bl.numero)||'—')+'\n'
    +'  • Número de entrada: '+entrada+'\n'
    +'  • Proveedor: '+(dat.proveedor||'—')+'\n'
    +'  • Cantidad de contenedores: '+(cs.length||'—')+'\n'
    +'  • Tipo de contenedor: '+tipoTxt+'\n'
    +'  • Naviera: '+((d.booking&&d.booking.naviera)||'—')+'\n'
    +'  • Total a pagar: '+fmt(tot.kcc)+'\n\n'
    +'Agradecemos realizar el pago a la mayor brevedad posible y, una vez efectuado, '
    +'agradeceremos compartir el comprobante por este mismo medio para continuar con el proceso.\n\n'
    +'Quedamos atentos.\n\n'
    +'Saludos cordiales,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalFlete'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalFlete';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)"><i class="ti ti-cash"></i> Solicitud de pago de flete</div>'
      +'<button onclick="_fleteCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<b>'+_esc(dat.proveedor||'')+'</b> · orden '+_esc(ordenTxt)
      +'<div style="margin-top:3px">Total a pagar por Kennedy: <b>'+fmt(tot.kcc)+'</b> · '+cs.length+' contenedor(es)</div></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — contabilidad</div>'
    +'<div id="flete-contab" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px">'
      +(chipsC||'<span style="font-size:11.5px;color:var(--text-danger)">No hay usuarios de contabilidad</span>')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">COPIA — compras'
      +(dept?(' · '+_esc(dL(dept))):'')+'</div>'
    +'<div id="flete-compras" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +(chipsP||'<span style="font-size:11.5px;color:var(--text-muted)">Sin compradoras en este departamento</span>')+'</div>'
    +'<input id="flete-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="flete-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="flete-cuerpo" rows="18" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="flete-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando el aviso de llegada y el B/L…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_fleteCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="flete-btn" style="background:#7C3D12" onclick="_fleteEnviar()"><i class="ti ti-send"></i> Enviar solicitud</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // El aviso de llegada y el B/L se adjuntan solos
  var aviso=document.getElementById('flete-auto');
  var puestos=[], faltan=[];
  var pares=[[_subKeyLog(_PASO_ARRIVAL),'aviso de llegada'], [_subKeyLog(_PASO_BL),'B/L']];
  for(var p=0;p<pares.length;p++){
    var fs=(window._atts&&window._atts[oid+pares[p][0]])?_dedupDocs(window._atts[oid+pares[p][0]]):[];
    if(!fs.length){ faltan.push(pares[p][1]); continue; }
    for(var i=0;i<fs.length;i++){
      if(!fs[i].url) continue;
      try{
        var adj=await _solPagoAdjuntarDeStorage(fs[i].url, fs[i].name||(pares[p][1]+'.pdf'));
        if(adj){ window._mailAdj.push(adj); puestos.push(fs[i].name); }
      }catch(e){ console.warn('adjuntar flete:',e); }
    }
  }
  mailPintarAdjuntos();
  if(aviso){
    var h2='';
    if(puestos.length) h2+='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '+_esc(puestos.join(', '))+'</span>';
    if(faltan.length)  h2+=(h2?'<br>':'')+'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Falta el '+_esc(faltan.join(' y el '))+'. Adjuntalo a mano.</span>';
    aviso.innerHTML=h2||'<span style="color:var(--t-ambar)">No hay documentos para adjuntar.</span>';
  }
}

function _fleteCerrar(){
  var m=document.getElementById('modalFlete'); if(m) m.remove();
  window._mailAdj=[]; window._fleteCtx=null;
}

async function _fleteEnviar(){
  var ctx=window._fleteCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid;
  function marcados(id){
    var b=document.getElementById(id);
    return b?Array.prototype.slice.call(b.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  }
  var para=marcados('flete-contab');
  var cc=marcados('flete-compras');
  var extra=((document.getElementById('flete-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  if(!para.length && !cc.length && !extra.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('flete-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('flete-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('flete-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc).concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:(para[0]||todos[0]),
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:_dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
                 .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Solicitud de pago de flete · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      var t=await r.text(); console.error('flete:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar solicitud'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar solicitud'; }
    return;
  }

  _solEnvioGuardar(oid, 'flete', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo,
    adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; })
  });

  // Aviso en el portal a contabilidad y compras
  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Logística',
      texto:'Solicitud de pago de flete enviada',
      etiqueta:'Logística — pago de flete', paso:_PASO_ARRIVAL
    });
  }catch(e){}

  _fleteCerrar();
  showT('✓ Solicitud de pago de flete enviada a '+todos.length+' destinatario(s)');
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  ADUANIZACIÓN — DMCE Y SIGA
//  Se adjuntan los dos documentos, la AI los lee y los valores se cotejan
//  contra la orden de compra y contra el flete del aviso de llegada.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_DMCE    = 'DMCE y SIGA';
var _PASO_DMCE_SAL= 'DMCE de salida';
var _PASO_COSTEO  = 'Costeo de importación';
var _PASO_PRECIOS = 'Precios de venta por gerencia';
var _PASO_SAP     = 'Precios de venta por gerencia';   // el paso final de la etapa

// Quién puede operar Aduanización & Costeo y Logística.
// Compras también participa: las compradoras siguen sus propias órdenes hasta
// el final, y antes quedaban sin los botones aunque veían la etapa.
function _puedeAduana(){
  return !!(CU && ['importacion','gerencia','compras','contabilidad'].indexOf(CU.role)>=0);
}

function _pasoIdxCost(nombre){
  var st=STAGES.find(function(z){ return z.key==='costeo'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyCost(nombre){
  var i=_pasoIdxCost(nombre);
  return i<0 ? '' : ('costeo_step'+i);
}

// Los datos de aduana viven junto a los de logística
function _aduLeer(oid){
  var d=_logLeer(oid);
  d.dmce=d.dmce||{};
  d.siga=d.siga||{};
  return d;
}

function _aduPanel(oid){
  var d=_aduLeer(oid);
  var sk=_subKeyCost(_PASO_DMCE);
  var dmce=(window._atts&&window._atts[oid+sk+'_dmce'])?_dedupDocs(window._atts[oid+sk+'_dmce']):[];
  var siga=(window._atts&&window._atts[oid+sk+'_siga'])?_dedupDocs(window._atts[oid+sk+'_siga']):[];
  var leido=!!(d.dmce.total_cif || d.dmce.total_fob);

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(leido?'sem-g':((dmce.length||siga.length)?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-file-certificate"></i> DMCE y SIGA</div></div>';

  // Accesos a los portales donde se sacan los documentos
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">'
    +'<a href="https://dmce2.zonalibredecolon.gob.pa/TFBFTZ/cusLogin/login.cl?language=es" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
      +'style="display:inline-flex;align-items:center;gap:6px;background:var(--surface-0);border:0.5px solid #7C3D12;border-radius:8px;padding:7px 12px;font-size:11.5px;font-weight:700;color:var(--t-marron);text-decoration:none">'
      +'<i class="ti ti-external-link"></i> Abrir DMCE <span style="font-weight:400;font-size:10px;color:var(--text-muted)">Zona Libre de Colón</span></a>'
    +'<a href="https://siga.ana.gob.pa/pcus/jsf/homepage/home.jsf" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
      +'style="display:inline-flex;align-items:center;gap:6px;background:var(--surface-0);border:0.5px solid #0c447c;border-radius:8px;padding:7px 12px;font-size:11.5px;font-weight:700;color:var(--t-azul);text-decoration:none">'
      +'<i class="ti ti-external-link"></i> Abrir SIGA <span style="font-weight:400;font-size:10px;color:var(--text-muted)">Aduanas Panamá</span></a>'
    +'</div>';
  h+=_aduZona(oid, sk+'_dmce', 'DOCUMENTO DMCE', 'Adjunta la declaración DMCE', '#7C3D12');
  h+=_aduZona(oid, sk+'_siga', 'DOCUMENTO SIGA', 'Adjunta el SIGA', '#0c447c');

  if((dmce.length||siga.length) && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_aduLeerIA(\'' + oid + '\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y verificar</button>'
      +'<div id="aduia-'+oid+'" style="margin-bottom:9px"></div>';
  }

  // Los datos que salieron del DMCE
  var m=d.dmce;
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','numero','N° de DMCE', m.numero, 150)
    +_logCampo(oid,'dmce','conocimiento','Conocimiento de guía / embarque', m.conocimiento, 190)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','total_fob','Total FOB', m.total_fob, 120)
    +_logCampo(oid,'dmce','flete','Flete', m.flete, 110)
    +_logCampo(oid,'dmce','otros','Otros', m.otros, 110)
    +_logCampo(oid,'dmce','total_cif','Total CIF', m.total_cif, 120)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','bultos','Total de bultos', m.bultos, 120)
    +_logCampo(oid,'dmce','puerto_origen','Puerto de origen', m.puerto_origen, 150)
    +_logCampo(oid,'dmce','puerto_entrada','Puerto de entrada', m.puerto_entrada, 150)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','embarcante','Nombre del embarcante', m.embarcante, 200)
    +_logCampo(oid,'dmce','pais_embarcante','País del embarcante', m.pais_embarcante, 150)
    +'</div>';

  // El SIGA solo aporta su número de DMCE, para cotejarlo
  if(d.siga.numero || siga.length){
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
      +'<div style="font-size:10px;font-weight:700;color:var(--t-azul);margin-bottom:4px">N° DE DMCE SEGÚN EL SIGA</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:flex-end">'
      +_logCampo(oid,'siga','numero','N° de DMCE en el SIGA', d.siga.numero, 170)
      +'</div>'
      +_aduCotejoSiga(d)
      +'</div>';
  }

  h+=_aduComparaciones(oid);
  h+=_btnCerrarPaso(oid, 'costeo', _PASO_DMCE,
      {falta: completo ? '' : 'Faltan datos del DMCE. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// ¿El número de DMCE coincide entre los dos documentos?
function _aduCotejoSiga(d){
  var a=String(d.dmce.numero||'').replace(/[\s-]/g,'').toUpperCase();
  var b=String(d.siga.numero||'').replace(/[\s-]/g,'').toUpperCase();
  if(!a || !b) return '';
  if(a===b){
    return '<div style="font-size:11px;color:var(--t-verde);font-weight:600;margin-top:5px">'
      +'<i class="ti ti-circle-check"></i> El número de DMCE coincide en los dos documentos.</div>';
  }
  return '<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:7px;padding:7px 9px;margin-top:5px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-rojo)">'
    +'<i class="ti ti-alert-triangle"></i> El número de DMCE NO coincide</div>'
    +'<div style="font-size:11px;color:var(--t-rojo);margin-top:2px">'
    +'DMCE: <b>'+_esc(d.dmce.numero||'')+'</b> · SIGA: <b>'+_esc(d.siga.numero||'')+'</b></div></div>';
}

// Total de la orden y bultos, para comparar
function _aduDatosOrden(oid){
  var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
  var total=0, bultos=0;
  if(o){
    total=Number(o.total)||0;
    (o.lines||[]).forEach(function(l){ bultos+=Number(l.quantity||l.cantidad||0)||0; });
  }
  if(!total){
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p){
      total=Number(p.total)||0;
      var its=p.items;
      if(typeof its==='string'){ try{ its=JSON.parse(its); }catch(e){ its=null; } }
      if(Array.isArray(its)) its.forEach(function(l){ bultos+=Number(l.cantidad||l.quantity||0)||0; });
    }
  }
  return {total:total, bultos:bultos};
}

// Las tres comparaciones que pediste
function _aduComparaciones(oid){
  var d=_aduLeer(oid);
  var m=d.dmce;
  if(!m.total_fob && !m.flete && !m.bultos) return '';
  var ord=_aduDatosOrden(oid);
  // El flete que paga Kennedy sale del aviso de llegada, o del booking
  var tar=(d.arrival&&d.arrival.tarifas&&d.arrival.tarifas.length)?d.arrival.tarifas:((d.booking&&d.booking.tarifas)||[]);
  var flete=_logTotales(tar).kcc;

  function num(v){ return Number(String(v==null?'':v).replace(/[^\d.-]/g,''))||0; }
  var filas=[
    {q:'Total FOB', doc:num(m.total_fob), ref:ord.total,  refNom:'total de la orden de compra', money:true},
    {q:'Flete',     doc:num(m.flete),     ref:flete,      refNom:'flete del aviso de llegada',  money:true},
    {q:'Total de bultos', doc:num(m.bultos), ref:ord.bultos, refNom:'bultos de la orden',       money:false}
  ].filter(function(f){ return f.doc || f.ref; });
  if(!filas.length) return '';

  var h='<div style="border:0.5px solid var(--border);border-radius:8px;overflow:hidden;background:var(--surface-0)">'
    +'<div style="background:var(--surface-1);padding:7px 10px;font-size:10.5px;font-weight:700;color:var(--text-secondary)">'
    +'VERIFICACIÓN CONTRA LA ORDEN Y EL FLETE</div>';
  var hayDif=false;
  filas.forEach(function(f){
    var dif=Math.abs(f.doc-f.ref);
    var ok=(f.ref===0)? null : (dif<0.01 || (f.money && dif<1));
    if(ok===false) hayDif=true;
    var col = ok===null ? '#6b7280' : (ok?'#166534':'#991b1b');
    h+='<div style="padding:7px 10px;border-top:0.5px solid var(--border)">'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">'
        +'<span style="font-size:11.5px;font-weight:600;flex:1;min-width:110px">'+_esc(f.q)+'</span>'
        +'<span style="font-size:11.5px">DMCE: <b>'+(f.money?fmt(f.doc):_fmtN2(f.doc))+'</b></span>'
        +'<span style="font-size:11.5px;color:var(--text-muted)">vs</span>'
        +'<span style="font-size:11.5px">'+(f.money?fmt(f.ref):_fmtN2(f.ref))+'</span>'
        +'<span style="font-size:9.5px;font-weight:700;border-radius:6px;padding:1px 7px;color:#fff;background:'+col+'">'
          +(ok===null?'SIN REFERENCIA':(ok?'COINCIDE':'DIFIERE'))+'</span>'
      +'</div>'
      +'<div style="font-size:10px;color:var(--text-muted);margin-top:2px">Comparado con el '+_esc(f.refNom)
        +(ok===false?(' · diferencia de <b style="color:var(--t-rojo)">'+(f.money?fmt(dif):_fmtN2(dif))+'</b>'):'')+'</div>'
      +'</div>';
  });
  if(hayDif){
    h+='<div style="padding:7px 10px;border-top:0.5px solid var(--border);background:var(--pastel-error);font-size:11px;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> Revisa las diferencias antes de seguir con el costeo.</div>';
  }
  return h+'</div>';
}

// Zona de documentos de aduana
function _aduZona(oid, sub, titulo, ayuda, color){
  var files=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    files.forEach(function(a,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti ti-file" style="color:'+color+'"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
        +'<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_aduBorrarDoc(\'' + oid + '\',\'' + sub + '\','+i+')"><i class="ti ti-trash"></i></button>'
        +'</div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,image/*" style="display:none" onchange="_aduSubirDoc(\'' + oid + '\',\'' + sub + '\',this.files)"></label>';
  return h+'</div>';
}

async function _aduSubirDoc(oid, sub, files){
  if(!files||!files.length) return;
  var _y=window.scrollY;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir aduana:',e); }
  }
  showT('✓ Adjuntado. Pulsa "Leer con AI" para llenar los datos.');
  _aduRefrescarPanel(oid, sub);          // solo el panel de esa subetapa
  setTimeout(function(){ window.scrollTo(0,_y); }, 0);
}

async function _aduBorrarDoc(oid, sub, i){
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Está seguro de que desea borrar este archivo?\n\n'
    +(a.name||'')+'\n\nEsta acción no se puede deshacer.')) return;

  // Desaparece de la pantalla al instante; el borrado sigue por detrás
  window._atts[oid+sub].splice(i,1);
  _aduRefrescarPanel(oid, sub);
  showT('Eliminando…');

  var ok=true;
  try{ ok=await _borrarArchivoStorage(a.url, a.id); }catch(e){ ok=false; }
  if(ok===false){
    showT('⚠ No se pudo borrar del servidor. Va a reaparecer al recargar.');
  } else {
    showT('✓ Archivo eliminado');
  }
  _aduRefrescarPanel(oid, sub);
}

// Repinta el panel al que pertenece ese archivo, y solo ese: cada subetapa
// tiene el suyo y antes se repintaba siempre el de aduana.
function _aduRefrescarPanel(oid, sub){
  var s=String(sub||'');
  if(s.indexOf(_subKeyCost(_PASO_COSTEO))===0){ _costRepintar(oid); return; }
  if(s.indexOf(_subKeyCost(_PASO_DMCE_SAL))===0){
    var c=document.getElementById('dmcesal-'+oid);
    if(c){ c.innerHTML=_dmceSalidaPanel(oid); return; }
  }
  _aduRepintar(oid);
}

function _aduRepintar(oid){
  var c=document.getElementById('adupanel-'+oid);
  if(c) c.innerHTML=_aduPanel(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { _dbg('[panel] no está visible: no se repinta'); }
}

// ── Lectura con AI del DMCE y el SIGA ──
async function _aduLeerIA(oid){
  var sk=_subKeyCost(_PASO_DMCE);
  var cont=document.getElementById('aduia-'+oid);
  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo los documentos…</span>';

  var d=_aduLeer(oid);
  var resumen=[];

  for(var par=0; par<2; par++){
    var sub = par===0 ? (sk+'_dmce') : (sk+'_siga');
    var quien = par===0 ? 'dmce' : 'siga';
    var files=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
    if(!files.length) continue;

    var contenido=[], puestos=0;
    for(var i=0;i<files.length && puestos<3;i++){
      if(!files[i].url) continue;
      var prep=await _iaDesdeStorage(files[i].url, files[i].name||('doc_'+(i+1)), 7);
      if(!prep) continue;
      contenido.push({type:'text', text:'ARCHIVO: '+(files[i].name||'')});
      prep.bloques.forEach(function(b){ contenido.push(b); });
      puestos++;
    }
    if(!puestos) continue;
    contenido.push({type:'text', text:_aduPrompt(quien)});

    try{
      var obj=await _iaJSON(contenido, 3000);
      d[quien]=d[quien]||{};
      var n=0;
      Object.keys(obj||{}).forEach(function(k){
        if(k==='nota') return;
        var v=obj[k];
        if(v==null || String(v).trim()==='') return;
        d[quien][k]=String(v).trim();
        n++;
      });
      resumen.push((quien==='dmce'?'DMCE':'SIGA')+': '+n+' dato(s)');
    }catch(e){
      console.error('leer aduana '+quien+':',e);
      resumen.push((quien==='dmce'?'DMCE':'SIGA')+': no se pudo leer');
    }
  }

  await _logGuardar(oid);
  _iaMarcarRevisado(oid, _PASO_DMCE);
  _aduRepintar(oid);

  // Aviso si algo no cuadra
  var a=String(d.dmce.numero||'').replace(/[\s-]/g,'').toUpperCase();
  var b=String(d.siga.numero||'').replace(/[\s-]/g,'').toUpperCase();
  if(a && b && a!==b) showT('⚠ El número de DMCE no coincide entre el DMCE y el SIGA');

  var cont2=document.getElementById('aduia-'+oid);
  if(cont2) cont2.innerHTML='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
    +'<i class="ti ti-circle-check"></i> '+_esc(resumen.join(' · ')||'sin datos')+'</div>';
}

function _aduPrompt(quien){
  if(quien==='siga'){
    return 'Sos el analista de aduanas de KENNEDY CENTER CORP en Panama. Lee el documento SIGA adjunto '
      +'y extrae UNICAMENTE el numero de DMCE que figura en el.\\n\\n'
      +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\\n'
      +'{"numero":"","nota":""}\\n\\n'
      +'REGLAS:\\n'
      +'- "numero": el numero de DMCE (Declaracion de Mercancia, DMCE No., No. de declaracion). '
      +'Copialo tal cual, con guiones si los tiene.\\n'
      +'- Si no lo encontras, deja "" y explicalo en "nota".';
  }
  return 'Sos el analista de aduanas de KENNEDY CENTER CORP en Panama. Lee la declaracion DMCE adjunta.\\n\\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\\n'
    +'{"numero":"","total_fob":"","flete":"","otros":"","total_cif":"","bultos":"",'
    +'"conocimiento":"","puerto_origen":"","puerto_entrada":"","embarcante":"","pais_embarcante":"","nota":""}\\n\\n'
    +'QUE ES CADA CAMPO:\\n'
    +'- "numero": el numero de DMCE (Declaracion de Mercancia, DMCE No.).\\n'
    +'- "total_fob": el TOTAL FOB (valor FOB de la mercancia). Solo el numero.\\n'
    +'- "flete": el monto del FLETE. Solo el numero.\\n'
    +'- "otros": OTROS gastos (seguro u otros cargos). Solo el numero.\\n'
    +'- "total_cif": el TOTAL CIF. Solo el numero.\\n'
    +'- "bultos": el TOTAL DE BULTOS (cantidad de bultos o piezas). Solo el numero.\\n'
    +'- "conocimiento": el CONOCIMIENTO DE GUIA O EMBARQUE (numero de B/L o guia aerea).\\n'
    +'- "puerto_origen": el PUERTO DE ORIGEN o de embarque.\\n'
    +'- "puerto_entrada": el PUERTO DE ENTRADA a Panama (Manzanillo, Cristobal, Balboa, Colon...).\\n'
    +'- "embarcante": el NOMBRE DEL EMBARCANTE (shipper, exportador).\\n'
    +'- "pais_embarcante": el PAIS DEL EMBARCANTE.\\n\\n'
    +'REGLAS:\\n'
    +'- Los montos van como numero, sin simbolos ni separadores de miles. Ejemplo: 13006.19\\n'
    +'- Si un dato no aparece, deja "". Nunca lo inventes.\\n'
    +'- El documento puede venir en espanol o ingles.';
}

// ── DMCE DE SALIDA ──
// Se adjunta el documento y con eso el paso queda hecho.
function _dmceSalidaPanel(oid){
  var sk=_subKeyCost(_PASO_DMCE_SAL);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var listo=files.length>0;
  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(listo?'sem-g':'sem-r')+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-file-export"></i> DMCE de salida</div>'
    +'<span style="font-size:10.5px;color:var(--t-marron)">'+files.length+' documento(s)</span></div>';
  h+=_aduZona(oid, sk, 'DOCUMENTO DMCE DE SALIDA', 'Adjunta el DMCE de salida', '#7C3D12');
  if(listo){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Adjuntado: el paso queda completado.</div>';
  }
  h+=_btnCerrarPaso(oid, 'costeo', _PASO_DMCE_SAL,
      {falta: listo ? '' : 'Todavía no hay documento adjunto. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// Al adjuntar el DMCE de salida, el paso se marca solo
async function _dmceSalidaCheck(oid){
  var sk=_subKeyCost(_PASO_DMCE_SAL);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  if(!files.length) return;
  try{
    var pi=_pasoIdxCost(_PASO_DMCE_SAL);
    initP(oid);
    var sp=stageProgress[oid].costeo;
    var st=STAGES.find(function(z){ return z.key==='costeo'; });
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      guardarEtapa(oid,'costeo');
    }
  }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  COSTEO DE IMPORTACIÓN
//  Importación sube el costeo o lo genera desde SAP, lo manda a revisar, y
//  cuando los precios ya están cargados en SAP marca el visto.
// ═══════════════════════════════════════════════════════════════════════════
function _costPanel(oid){
  var sk=_subKeyCost(_PASO_COSTEO);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var env=_solEnvioLeer(oid,'costeo');
  var d=_logLeer(oid);
  // El paso se da por hecho cuando el costeo se envió a gerencia
  var enviado=!!env;

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  // El costeo guardado se recupera al abrir la orden: si ya se generó una
  // vez, no hay que volver a generarlo para poder trabajar con él.
  try{
    var _g=(_logLeer(oid).costeo||{}).datos;
    if(_g && (_g.lineas||[]).length){
      window._costDatos=window._costDatos||{};
      if(!window._costDatos[oid]) window._costDatos[oid]=_g;
    }
  }catch(e){}

  // Quién pidió los precios a gerencia y cuándo: queda a la vista en la
  // etapa, no solo en el buzón de quien lo mandó.
  var _sol=null;
  try{ _sol=(_logLeer(oid).costeo||{}).solicitado||null; }catch(e){}

  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(enviado?'sem-g':(files.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-table"></i> Costeo de importación</div>'
    // El sello de la solicitud, debajo del título
    + (_sol ? ('<span style="background:var(--pastel-ok);color:var(--t-verde);'
        +'border-radius:999px;padding:2px 9px;font-size:10.5px;font-weight:700;'
        +'white-space:nowrap" title="'+_esc('Enviado a: '+(_sol.para||''))+'">'
        +'<i class="ti ti-send"></i> Precios solicitados · '+_esc(_sol.por||'')
        +' · '+_esc(_fechaHora(_sol.fecha))+'</span>') : '')
    +(enviado?'<span style="font-size:10px;font-weight:700;color:var(--t-verde);background:var(--pastel-ok);border-radius:6px;padding:2px 8px">ENVIADO A GERENCIA</span>':'')
    +'</div>';

  h+=_aduZona(oid, sk, 'ARCHIVO DEL COSTEO', 'Sube el Excel o el PDF del costeo, o generalo desde SAP', '#7C3D12');

  if(_puedeAduana()){
    var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
    var yaBajado=!!(d.costeo && d.costeo.sap);
    // Se miran las entradas de la orden en segundo plano y se avisa si hay
    // más de una, para que nadie cuente solo la del aviso de llegada.
    setTimeout(function(){ try{ _costAvisarEntradas(oid); }catch(e){} }, 400);

    // Se explica de dónde sale el costeo, para no tener que adivinarlo
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;margin-bottom:9px">'
      +'<div style="font-size:10.5px;font-weight:700;color:var(--t-azul);margin-bottom:3px">'
        +'<i class="ti ti-database"></i> TRAER EL COSTEO DESDE SAP</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:7px">'
        +(entrada
          ? ('Número de entrada <b style="color:var(--t-azul);font-size:12px">'+_esc(entrada)+'</b> '
             +'<span style="font-size:10px">(tomado del aviso de llegada)</span>. '
             +'Se consulta la pantalla Landed Costs de SAP y primero se muestra aquí.'
             // Si la orden llegó en varios embarques, se avisa AQUÍ, antes de
             // pulsar nada: el aviso de llegada solo guarda un número y había
             // que adivinar que faltaban entradas.
             +'<div id="costents-'+oid+'" style="margin-top:5px"></div>')
          : '<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Falta el número de entrada del aviso de llegada. Al pulsar te lo va a pedir.</span>')
      +'</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
        +'<button class="btn bp" style="background:#0c447c;font-size:12px;padding:8px 15px;font-weight:700" onclick="event.stopPropagation();_costGenerar(\'' + oid + '\')">'
          +'<i class="ti ti-database-import"></i> '+(yaBajado?'Volver a consultar SAP':'Generar costeo desde SAP')+'</button>'
        +(yaBajado?('<button class="btn bp" style="background:#166534;font-size:12px;padding:8px 15px;font-weight:700" onclick="event.stopPropagation();_costVerUltimo(\'' + oid + '\')">'
          +'<i class="ti ti-file-spreadsheet"></i> Ver y descargar el Excel</button>'):'')
        +(files.length?('<button class="btn bp" style="background:#7C3D12;font-size:12px;padding:8px 15px" onclick="event.stopPropagation();_costEnviarModal(\'' + oid + '\')">'
          +'<i class="ti ti-mail"></i> Enviar por correo</button>'):'')
      +'</div>'
      +'<div id="costgen-'+oid+'" style="margin-top:8px"></div>'
      +'</div>';
  }

  if(env){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-bottom:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Costeo enviado a revisión</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">'
        +'Por <b>'+_esc(env.por||'')+'</b> · '+_esc(_fechaHora(env.fecha))
        +(env.para&&env.para.length?('<br>A: '+_esc(env.para.join(', '))):'')
      +'</div></div>';
  }

  return h+'</div>';
}

// Genera el costeo con las líneas de la orden traídas de SAP
// ═══════════════════════════════════════════════════════════════════════════
//  COSTEO DESDE SAP
//  Se pide con el número de entrada del aviso de llegada. El worker consulta
//  la pantalla Landed Costs de SAP y devuelve las líneas y los gastos. Aquí se
//  muestran en pantalla y, si se confirma, se arma el Excel.
// ═══════════════════════════════════════════════════════════════════════════
async function _costGenerar(oid){
  // Si ya hay un costeo guardado, se avisa: generar otro lo reemplaza y se
  // pierden los precios puestos encima.
  try{
    var _ya=(_logLeer(oid).costeo||{}).datos;
    if(_ya && (_ya.lineas||[]).length){
      if(!confirm('Esta orden ya tiene un costeo guardado con '
        +_ya.lineas.length+' línea(s).\n\nGenerar uno nuevo lo reemplaza y se '
        +'pierden los precios de venta que ya se le pusieron.\n\n¿Sigo?')) return;
    }
  }catch(e){}

  var cont=document.getElementById('costgen-'+oid);
  var d=_logLeer(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();

  /* Una orden puede llegar en VARIOS embarques y tener varias entradas, cada
     una con su costeo en SAP. El aviso de llegada solo guarda un número, así
     que antes se costeaba una y las demás se quedaban fuera. Se buscan todas
     y se piden todas. */
  var _todas=[];
  try{
    if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)">'
      +'<span class="ai-ring g"></span> Buscando las entradas de esta orden…</span>';
    var _ents=await _pvEntradasDeLaOrden(oid);
    _todas=[...new Set(_ents.map(function(x){
      return String(x.num_doc_com||'').trim(); }).filter(Boolean))];
  }catch(e){}
  if(entrada && _todas.indexOf(entrada)<0) _todas.push(entrada);

  if(_todas.length>1){
    if(!confirm('Esta orden tiene '+_todas.length+' entradas de mercancía:\n\n  · '
      + _todas.join('\n  · ')
      + '\n\nVoy a traer el costeo de TODAS y juntarlas en una sola pantalla '
      + 'para ponerles precio. ¿Sigo?')) return;
    return await _costGenerarVarias(oid, _todas);
  }
  if(_todas.length===1) entrada=_todas[0];

  if(!entrada){
    var txt=prompt('Para traer el costeo de SAP hace falta el NÚMERO DE ENTRADA.\n\n'
      +'Es el que se carga en el aviso de llegada (por ejemplo: 153/26).\n\nEscribilo:','');
    if(txt===null) return;
    entrada=String(txt).trim();
    if(!entrada){ showT('Sin número de entrada no se puede consultar SAP'); return; }
    d.arrival=d.arrival||{};
    d.arrival.entrada=entrada;
    await _logGuardar(oid);
  }

  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
    +'Consultando SAP con la entrada '+_esc(entrada)+'…</span>';

  // Se encola el pedido para el worker
  var fid=null;
  try{
    var r=await fetch(SB+'/rest/v1/costeo_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({docnum:String(oid), entrada:entrada,
                           pedido_por:(CU&&CU.name)||'', estado:'pendiente',
                           creado_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">'
        +(/does not exist|Could not find the table/i.test(t)
          ? 'Falta la tabla costeo_queue en Supabase (script costeo_sap.sql).'
          : ('No se pudo pedir el costeo (error '+r.status+').'))+'</div>';
      return;
    }
    var f=await r.json();
    fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  }catch(e){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">Error de conexión: '+_esc(e.message||e)+'</div>';
    return;
  }
  if(!fid){ if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">No se pudo registrar el pedido.</div>'; return; }
  _costEsperar(oid, fid, 0);
}

// Espera la respuesta del worker
function _costEsperar(oid, fid, intento){
  var cont=document.getElementById('costgen-'+oid);
  var espera = intento===0 ? 2000 : (intento<20 ? 3000 : 6000);
  setTimeout(async function(){
    var fila=null;
    try{
      var r=await fetch(SB+'/rest/v1/costeo_queue?select=*&id=eq.'+fid+'&limit=1',{headers:SBH});
      if(r.ok){ var a=await r.json(); fila=(Array.isArray(a)&&a[0])?a[0]:null; }
    }catch(e){}
    if(!fila){
      if(intento<40) return _costEsperar(oid, fid, intento+1);
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">SAP no respondió. Probá de nuevo en un momento.</div>';
      return;
    }
    if(fila.estado==='pendiente'||fila.estado==='procesando'){
      if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
        +(fila.estado==='procesando'?'Leyendo el costeo en SAP':'En cola')+'… ('+(intento*3)+'s)</span>';
      if(intento<60) return _costEsperar(oid, fid, intento+1);
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">La consulta está tardando demasiado. Revisa que el worker esté corriendo.</div>';
      return;
    }
    if(fila.estado==='error'){
      if(cont) cont.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
        +'<i class="ti ti-alert-triangle"></i> '+_esc(fila.detalle||'No se pudo traer el costeo')+'</div>';
      return;
    }
    // Llegó el costeo
    var datos=fila.datos;
    if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
    if(!datos || !Array.isArray(datos.lineas)){
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">SAP respondió pero sin líneas.</div>';
      return;
    }
    window._costDatos=window._costDatos||{};
    window._costDatos[oid]=datos;
    // Y se GUARDA con la orden: antes solo vivía en memoria, así que al
    // salir y volver a entrar había que generarlo otra vez para poder
    // mandárselo a los vendedores.
    try{ _costGuardarEnOrden(oid, datos); }catch(e){ console.warn('guardar costeo:',e); }
    if(cont) cont.innerHTML='';
    _costPreview(oid, datos);
  }, espera);
}

// Vista previa antes de descargar
// Vista previa con el mismo formato que el PDF de SAP
// Completa las líneas del costeo con los datos del inventario del portal:
// la foto y el precio de venta que ya se ven bien en Consulta de inventario.
// Antes cada uno se resolvía por separado y no coincidían.
async function _costEnriquecer(datos){
  if(!datos || !Array.isArray(datos.lineas) || !datos.lineas.length) return datos;
  var codigos=Array.from(new Set(datos.lineas
    .map(function(l){ return String(l.referencia||'').trim(); })
    .filter(Boolean)));
  if(!codigos.length) return datos;

  var mapa={};
  // Lo que ya esté cargado en memoria
  try{
    (_invRows||[]).forEach(function(r){
      if(r && r.itemcode) mapa[String(r.itemcode).trim().toUpperCase()]=r;
    });
  }catch(e){}

  // Y lo que falte, del inventario
  var faltan=codigos.filter(function(c){ return !mapa[c.toUpperCase()]; });
  for(var i=0;i<faltan.length;i+=120){
    var lote=faltan.slice(i,i+120);
    var lst=lote.map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
    try{
      // Los mismos campos que usa la ficha, para que el precio sea idéntico
      var url=SB+'/rest/v1/inventario?select='+_INV_CAMPOS
        +'&itemcode=in.('+encodeURIComponent(lst)+')&limit=500';
      var r=await fetch(url,{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(x){
        if(!x || !x.itemcode) return;
        var k=String(x.itemcode).trim().toUpperCase();
        mapa[k]=x;
        // Se guarda para que la ficha abra al instante
        window._invFichaCache=window._invFichaCache||{};
        window._invFichaCache[k]=x;
      });
    }catch(e){ console.warn('inventario para el costeo:',e); }
  }

  var conFoto=0, conPV=0;
  datos.lineas.forEach(function(l){
    var x=mapa[String(l.referencia||'').trim().toUpperCase()];
    if(!x) return;
    // La foto del inventario manda: usa el mismo nombre que ya funciona ahí
    if(x.picturname){ l.foto=x.picturname; conFoto++; }
    // Y el precio de venta también: es el que se ve en Consulta de
    // inventario. OJO: «precio1» es la lista 1, que en Kennedy es el FOB;
    // usarlo de recambio ponía el costo como precio de venta. Si no hay
    // precio de venta, se deja VACÍO, igual que en SAP.
    var pv=Number(x.precioventa)||0;
    if(pv>0){
      l.precio_venta=pv;
      var cif=Number(l.cif_unit)||0;
      l.margen=pv?Number((((pv-cif)/pv)*100).toFixed(4)):0;
      conPV++;
    }
    if(!l.descripcion && x.itemname) l.descripcion=x.itemname;
  });
  var sinPV=datos.lineas.filter(function(l){ return !(Number(l.precio_venta)>0); })
                       .map(function(l){ return l.referencia; });
  console.log('[costeo] inventario: '+conFoto+' foto(s) y '+conPV+' precio(s) de '+datos.lineas.length+' línea(s)');
  if(sinPV.length) console.warn('[costeo] sin precio de venta en el inventario:', sinPV);
  datos._enriquecido={fotos:conFoto, precios:conPV, total:datos.lineas.length, sinPrecio:sinPV};
  return datos;
}

async function _costPreview(oid, datos){
  // Las fotos y los precios se traen del inventario SIEMPRE, venga el costeo
  // recién de SAP o se esté reabriendo uno guardado.
  try{ datos=await _costEnriquecer(datos); }catch(e){ console.warn('enriquecer:',e); }
  window._costDatos=window._costDatos||{};
  window._costDatos[oid]=datos;
  var t=datos.totales||{};
  var prev=document.getElementById('modalCostPrev'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCostPrev';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:14px;overflow-y:auto';

  // Siempre en-US: con el navegador en español salía "1305,04" en vez de "1,305.04"
  function n2(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function n4(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }
  function n5(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:5,maximumFractionDigits:5}); }
  function ent(v){ return (Number(v)||0).toLocaleString('en-US'); }

  var filas=datos.lineas.map(function(l,i){
    var ref=String(l.referencia||'');
    // Se resuelve igual que en el inventario, con sus alternativas de nombre
    var foto='';
    try{ foto=l.foto?_repFotoUrl(l.foto):''; }catch(e){ foto=l.foto?(FOTO_BASE+encodeURIComponent(l.foto)):''; }
    return '<tr style="border-bottom:0.5px solid var(--border)">'
      +'<td style="padding:3px 6px;color:var(--text-muted);text-align:right">'+(l.nro||i+1)+'</td>'
      // La miniatura crece al pasar el mouse, sin abrir nada
      +'<td style="padding:2px 4px;width:38px">'
        +(foto?('<img src="'+_esc(foto)+'" class="cost-mini" alt="" '
                +'onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(ref.replace(/\x27/g,''))+'\')" '
                +'onerror="_costFotoAlt(this,\''+_esc(String(l.foto||'').replace(/\x27/g,''))+'\')">')
             :'<span style="display:inline-block;width:30px;height:30px;border-radius:5px;background:var(--surface-1)"></span>')
      +'</td>'
      +'<td style="padding:3px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'
        +'<span onclick="event.stopPropagation();_invFicha(\''+_esc(ref.replace(/\x27/g,''))+'\')" '
        +'style="color:var(--text-accent);cursor:pointer;text-decoration:underline" title="Ver la ficha del producto">'
        +_esc(ref)+'</span></td>'
      +'<td style="padding:3px 6px;max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="'+_esc(l.descripcion||'')+'">'+_esc(l.descripcion||'')+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n2(l.piezas_x_bulto)+'</td>'
      +'<td style="padding:3px 6px;text-align:center">'+_esc(l.empaque||'PZA')+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+ent(l.bultos)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n5(l.medida)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n5(l.medida_total)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+ent(l.cantidad)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n4(l.fob_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:600">'+n4(l.fob_total)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-marron)">'+n4(l.gasto_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n4(l.cif_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:700">'+n2(l.cif_total)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-verde)">'+n2(l.precio_venta)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-verde);font-weight:600">'+n4(l.margen)+'</td>'
      +'</tr>';
  }).join('');

  var gastos=(datos.gastos||[]).map(function(g){
    var cod=String(g.codigo||'');
    var solocod=(cod && String(g.concepto||'')===cod);   // no se encontró el nombre
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:3px 7px">'
        +(solocod?('<span style="color:var(--t-ambar)" title="No se encontró el nombre de este código en SAP">'+_esc(cod)+'</span>')
                 :(_esc(g.concepto||'')+(cod?('<span style="font-size:9.5px;color:var(--text-muted);margin-left:6px">'+_esc(cod)+'</span>'):'')))
      +'</td>'
      +'<td style="padding:3px 7px;text-align:right;font-weight:600">'+n2(g.monto)+'</td>'
      +'<td style="padding:3px 7px;font-size:10px;color:var(--text-muted)">'+_esc(g.prorrateo||'')+'</td>'
      +'</tr>';
  }).join('');

  function th(txt, ali){
    return '<th style="padding:5px 6px;text-align:'+(ali||'left')+';font-size:9px;text-transform:uppercase;'
      +'color:var(--text-muted);font-weight:700;white-space:nowrap;background:var(--surface-1);'
      +'position:sticky;top:0;z-index:2;border-bottom:1px solid var(--border)">'+txt+'</th>';
  }

  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:16px;width:100%;max-width:1240px;max-height:94vh;overflow-y:auto">'
    // Cabecera igual al PDF
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:10px">'
      +'<div style="font-size:12px;line-height:1.5">'
        +'<div style="font-size:14px;font-weight:800">KENNEDY CENTER CORP.</div>'
        +'<div><b>COSTO DE IMPORTACION:</b> '+_esc(datos.costo_importacion||'')+'</div>'
        +'<div><b>ENTRADA No:</b> '+_esc(datos.entrada||'')+(datos.fecha?('   <b>FECHA:</b> '+_esc(datos.fecha)):'')+'</div>'
        +'<div><b>FACTURA No:</b> '+_esc(datos.factura||'')
          +'   <b>SUPLIDOR:</b> '+_esc(datos.suplidor_codigo||'')+' '+_esc(datos.suplidor||'')+'</div>'
      +'</div>'
      +'<button onclick="_costPrevCerrar(\'' + oid + '\')" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>'

    +'<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden;margin-bottom:12px">'
      +'<div style="max-height:430px;overflow:auto">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
      +'<thead><tr>'
        +th('','left')+th('#','right')+th('Referencia')+th('Descripción')
        +th('Blt x/c','right')+th('Empaque','center')+th('Cant. blts','right')
        +th('Medida x bto','right')+th('Medida total','right')+th('Cant.','right')
        +th('F.O.B.','right')+th('Costo total','right')
        +th('Gastos','right')+th('C.I.F.','right')+th('Costo total','right')
        +th('Precio venta','right')+th('%','right')
      +'</tr></thead><tbody>'+filas+'</tbody>'
      +'<tfoot><tr style="background:var(--surface-1);font-weight:800;position:sticky;bottom:0">'
        +'<td colspan="6" style="padding:6px;text-align:right">TOTAL</td>'
        +'<td style="padding:6px;text-align:right">'+ent(t.bultos)+'</td>'
        +'<td></td>'
        +'<td style="padding:6px;text-align:right">'+n5(t.medida)+'</td>'
        +'<td style="padding:6px;text-align:right">'+ent(t.cantidad)+'</td>'
        +'<td></td>'
        +'<td style="padding:6px;text-align:right">'+n4(t.fob)+'</td>'
        +'<td></td><td></td>'
        +'<td style="padding:6px;text-align:right">$ '+n2(t.cif)+'</td>'
        +'<td></td><td></td>'
      +'</tr></tfoot></table></div></div>'

    +((datos.gastos||[]).length?('<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden;margin-bottom:14px;max-width:640px">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
      +'<tbody>'+gastos+'</tbody>'
      +'<tfoot><tr style="background:var(--surface-1);font-weight:800;border-top:1px solid var(--border)">'
        +'<td style="padding:5px 7px">TOTAL GASTOS</td>'
        +'<td style="padding:5px 7px;text-align:right">'+n2(t.gastos)+'</td><td></td>'
      +'</tr></tfoot></table></div>'):'')

    // Control: FOB + gastos = CIF
    // De dónde salieron los precios, para poder contrastarlo
    +((datos._enriquecido)?('<div style="background:'+(datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length?'#FEF3E8':'#e6f1fb')
      +';border:1px solid '+(datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length?'#E9C08A':'#85B7EB')
      +';border-radius:8px;padding:7px 11px;margin-bottom:10px;font-size:11px;color:'
      +(datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length?'#7C3D12':'#0c447c')+'">'
      +'<i class="ti ti-info-circle"></i> Precio de venta y fotos tomados del inventario del portal · '
      +datos._enriquecido.precios+'/'+datos._enriquecido.total+' con precio · '
      +datos._enriquecido.fotos+'/'+datos._enriquecido.total+' con foto'
      +((datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length)
        ?('<br>Sin precio en el inventario: '+_esc(datos._enriquecido.sinPrecio.slice(0,8).join(', '))
          +(datos._enriquecido.sinPrecio.length>8?(' y '+(datos._enriquecido.sinPrecio.length-8)+' más'):''))
        :'')
      +'</div>'):'')
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px">'
      +_costKpi('Total F.O.B.', n2(t.fob), '#166534')
      +_costKpi('Total gastos', n2(t.gastos), '#7C3D12')
      +_costKpi('Total C.I.F.', n2(t.cif), '#991b1b')
      +(Math.abs(((t.fob||0)+(t.gastos||0))-(t.cif||0))<1
        ? '<div style="flex:1;min-width:170px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px">'
          +'<div style="font-size:9.5px;color:var(--t-verde);font-weight:700;text-transform:uppercase">Verificación</div>'
          +'<div style="font-size:12px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> FOB + gastos = CIF</div></div>'
        : '<div style="flex:1;min-width:170px;background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:7px 10px">'
          +'<div style="font-size:9.5px;color:var(--t-rojo);font-weight:700;text-transform:uppercase">Verificación</div>'
          +'<div style="font-size:11.5px;font-weight:700;color:var(--t-rojo)">No cuadra por '
          +n2(Math.abs(((t.fob||0)+(t.gastos||0))-(t.cif||0)))+'</div></div>')
    +'</div>'

    +'<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div id="costprev-pie" style="font-size:11.5px;color:var(--text-muted)">'+datos.lineas.length+' línea(s). ¿Descargar en Excel y adjuntar a la etapa?</div>'
      +'<div style="display:flex;gap:8px">'
        +'<button class="btn" onclick="_costPrevCerrar(\'' + oid + '\')">Cerrar</button>'
        +'<button class="btn bp" id="costpdf-btn" style="background:#B91C1C" onclick="_costPDF(\'' + oid + '\')">'
          +'<i class="ti ti-file-type-pdf"></i> Descargar PDF</button>'
        +'<button class="btn bp" id="costprev-btn" style="background:#166534" onclick="_costDescargar(\'' + oid + '\')">'
          +'<i class="ti ti-file-spreadsheet"></i> Descargar Excel y adjuntar</button>'
      +'</div></div>'
    +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

// Si la foto no cargó con el primer nombre, se prueban las variantes
// (minúsculas, otra extensión) igual que hace el inventario.
// ═══════════════════════════════════════════════════════════════════════════
//  VISTA PREVIA DE ADJUNTOS
//  Al pasar el mouse sobre el nombre de un archivo se ve una miniatura sin
//  tener que abrirlo. Las imágenes se muestran directo y los PDF con su
//  primera página.
// ═══════════════════════════════════════════════════════════════════════════
window._prevCache=window._prevCache||{};

function _prevTipo(nombre){
  var e=String(nombre||'').split('?')[0].split('.').pop().toLowerCase();
  if(['jpg','jpeg','png','gif','webp','bmp','svg'].indexOf(e)>=0) return 'img';
  if(e==='pdf') return 'pdf';
  if(['xlsx','xls','csv'].indexOf(e)>=0) return 'xls';
  if(['doc','docx'].indexOf(e)>=0) return 'doc';
  return 'otro';
}

// Atributos para que un elemento muestre la vista previa al pasar el mouse
function _prevAttrs(url, nombre){
  if(!url) return '';
  return ' onmouseenter="_prevMostrar(event,\''+_esc(String(url).replace(/'/g,''))+'\',\''
    +_esc(String(nombre||'').replace(/'/g,''))+'\')"'
    +' onmouseleave="_prevOcultar()"';
}

function _prevOcultar(){
  var p=document.getElementById('prevFlota');
  if(p) p.remove();
  if(window._prevTimer){ clearTimeout(window._prevTimer); window._prevTimer=null; }
}

function _prevMostrar(ev, url, nombre){
  _prevOcultar();
  var tipo=_prevTipo(nombre);
  if(tipo==='otro') return;

  var x=(ev&&ev.clientX)||100, y=(ev&&ev.clientY)||100;
  var caja=document.createElement('div');
  caja.id='prevFlota';
  caja.style.cssText='position:fixed;z-index:13000;background:var(--surface-0);'
    +'border:1px solid var(--border);border-radius:12px;box-shadow:0 14px 44px rgba(0,0,0,.32);'
    +'padding:9px;pointer-events:none;max-width:660px';
  // El tamaño se ajusta a la pantalla, sin pasarse de lo que entra
  var ANCHO=Math.min(620, Math.max(320, window.innerWidth-120));
  var ALTO =Math.min(430, Math.max(220, window.innerHeight-180));
  caja.innerHTML='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:6px;font-weight:600;'
    +'max-width:'+ANCHO+'px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(nombre||'')+'</div>'
    +'<div id="prev-cuerpo" style="width:'+ANCHO+'px;height:'+ALTO+'px;display:flex;align-items:center;'
    +'justify-content:center;background:var(--surface-1);border-radius:8px;color:var(--text-muted);font-size:11px">'
    +'<span class="ai-ring g"></span></div>';
  document.body.appendChild(caja);

  // Se coloca sin salirse de la pantalla. Si no entra a la derecha del cursor,
  // se pone a la izquierda; lo mismo arriba y abajo.
  var an=ANCHO+22, al=ALTO+46;
  var izq=x+18;
  if(izq+an > window.innerWidth-10) izq=Math.max(10, x-an-18);
  var arr=y+18;
  if(arr+al > window.innerHeight-10) arr=Math.max(10, window.innerHeight-al-10);
  caja.style.left=izq+'px';
  caja.style.top =arr+'px';

  var cuerpo=document.getElementById('prev-cuerpo');
  if(tipo==='img'){
    var im=new Image();
    im.onload=function(){
      if(!document.getElementById('prevFlota')) return;
      cuerpo.innerHTML='';
      im.style.cssText='max-width:'+ANCHO+'px;max-height:'+ALTO+'px;object-fit:contain;border-radius:7px';
      cuerpo.appendChild(im);
    };
    im.onerror=function(){ if(cuerpo) cuerpo.innerHTML='No se pudo cargar la imagen'; };
    im.src=url;
    return;
  }
  if(tipo==='pdf'){
    // La primera página del PDF, en un visor sin controles
    cuerpo.innerHTML='<iframe src="'+_esc(url)+'#page=1&toolbar=0&navpanes=0&view=FitH" '
      +'style="width:'+ANCHO+'px;height:'+ALTO+'px;border:0;border-radius:7px;background:var(--surface-2)"></iframe>';
    return;
  }
  if(tipo==='xls' || tipo==='doc'){
    cuerpo.innerHTML='<div style="text-align:center;padding:14px">'
      +'<i class="ti ti-'+(tipo==='xls'?'file-spreadsheet':'file-text')+'" '
      +'style="font-size:56px;color:'+(tipo==='xls'?'#15803D':'#0c447c')+'"></i>'
      +'<div style="margin-top:9px;font-size:12.5px">Pulsa el archivo para abrirlo</div></div>';
  }
}

function _costFotoAlt(img, nombre){
  if(!img) return;
  if(!nombre){ _costFotoVacia(img); return; }
  var i=Number(img.getAttribute('data-alt')||0);
  var alts=[];
  // Primero las variantes que ya conoce el portal
  try{ if(typeof _fotoUrls==='function') alts=_fotoUrls(nombre)||[]; }catch(e){}
  var base=String(nombre).trim();
  var sinExt=base.replace(/\.[^.]+$/,'');
  ['', '.jpg', '.JPG', '.jpeg', '.png', '.PNG', '.webp'].forEach(function(ext){
    var n = ext ? (sinExt+ext) : base;
    [n, n.toLowerCase(), n.toUpperCase()].forEach(function(v){
      var u=FOTO_BASE+encodeURIComponent(v);
      if(alts.indexOf(u)<0) alts.push(u);
    });
  });
  // Antes de rendirse: la foto del catálogo NO SAP, si el artículo tiene una.
  // SAP declara nombres de imágenes que no están en el bucket, y esa suele
  // ser la única que existe de verdad.
  if(i>=alts.length){
    try{
      var _alt=img.getAttribute('data-nosap')||'';
      if(_alt && !img.dataset.nosapProbado){
        img.dataset.nosapProbado='1';
        img.src=_alt;
        return;
      }
    }catch(e){}
    _costFotoVacia(img); return;
  }
  img.setAttribute('data-alt', i+1);
  img.src=alts[i];
}

// Cuando ninguna variante sirve: en vez de un icono roto, un recuadro gris
function _costFotoVacia(img){
  try{
    var w=img.offsetWidth||img.width||30, h=img.offsetHeight||img.height||30;
    var rep=document.createElement('div');
    rep.style.cssText='width:'+w+'px;height:'+h+'px;border-radius:6px;background:var(--surface-1);'
      +'border:0.5px solid var(--border);display:flex;align-items:center;justify-content:center;'
      +'color:var(--text-muted);font-size:'+Math.max(9,Math.round(w/4))+'px';
    rep.innerHTML='<i class="ti ti-photo-off"></i>';
    rep.title='Este artículo no tiene foto en el sistema';
    if(img.parentNode) img.parentNode.replaceChild(rep, img);
  }catch(e){ img.style.visibility='hidden'; }
}

function _costKpi(etiqueta, valor, color){
  return '<div style="flex:1;min-width:112px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:7px 10px">'
    +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:600;text-transform:uppercase">'+_esc(etiqueta)+'</div>'
    +'<div style="font-size:14px;font-weight:700;color:'+color+'">'+valor+'</div></div>';
}

// Arma el Excel con el formato del PDF de SAP y lo adjunta
// Arma el Excel con el formato del PDF de SAP, con las fotos incrustadas
// ── PDF del costeo, con el mismo contenido que el Excel ──
// Cierra la ventana del costeo y recién ahí refresca la etapa
function _costPrevCerrar(oid){
  var m=document.getElementById('modalCostPrev');
  if(m) m.remove();
  // Al cerrar la vista previa se refrescan los paneles: si se generó el
  // costeo mientras estaba abierta, el botón «Enviar por correo» ya sale.
  try{ _costRefrescarPaneles(oid); }catch(e){ try{ _costRepintar(oid); }catch(e2){} }
}

async function _costPDF(oid){
  var datos=(window._costDatos||{})[oid];
  if(!datos){ showT('No hay datos del costeo'); return; }
  if(!window.jspdf || !window.jspdf.jsPDF){ showT('No se pudo cargar el generador de PDF'); return; }

  var btn=document.getElementById('costpdf-btn');
  function estado(t){ if(btn) btn.innerHTML=t; }
  if(btn) btn.disabled=true;
  estado('Armando el PDF…');

  try{
    var t=datos.totales||{};
    var dat=_solPagoDatosOrden(oid);
    var jsPDF=window.jspdf.jsPDF;
    // Apaisado: son 16 columnas
    var doc=new jsPDF({orientation:'landscape', unit:'pt', format:'letter', compress:true});
    var W=doc.internal.pageSize.getWidth();

    function n2(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    function n4(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }
    function n5(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:5,maximumFractionDigits:5}); }
    function ent(v){ return (Number(v)||0).toLocaleString('en-US'); }

    // Las fotos, para incrustarlas en la tabla
    estado('Bajando fotos…');
    var fotos={};
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      if(i%10===0) estado('Bajando fotos… '+i+'/'+datos.lineas.length);
      try{
        // Comprimida, igual que en el Excel
        var im=await _costFotoChica(l.foto, 140, 0.5);
        if(im) fotos[i]=im.dataUrl;
      }catch(e){}
    }
    estado('Generando…');

    // Cabecera, igual que el PDF de SAP
    doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.text('KENNEDY CENTER CORP.', 30, 34);
    doc.setFontSize(9);
    doc.text('COSTO DE IMPORTACION: '+(datos.costo_importacion||''), 30, 50);
    doc.text('ENTRADA No: '+(datos.entrada||'')+(datos.fecha?('    FECHA: '+datos.fecha):''), 30, 63);
    doc.text('FACTURA No: '+(datos.factura||'')
      +'    SUPLIDOR: '+(datos.suplidor_codigo||'')+' '+(datos.suplidor||''), 30, 76);
    doc.setFont('helvetica','normal'); doc.setFontSize(8);
    doc.text('Generado el '+now2()+' por '+((CU&&CU.name)||''), W-30, 34, {align:'right'});

    var cuerpo=datos.lineas.map(function(l,i){
      return ['', String(l.nro||i+1), l.referencia||'', l.descripcion||'',
        n2(l.piezas_x_bulto), l.empaque||'PZA', ent(l.bultos),
        n5(l.medida), n5(l.medida_total||((l.medida||0)*(l.bultos||0))),
        ent(l.cantidad), n4(l.fob_unit), n4(l.fob_total),
        n4(l.gasto_unit), n4(l.cif_unit), n2(l.cif_total),
        n2(l.precio_venta), n4(l.margen)];
    });
    cuerpo.push(['', '', 'TOTAL', '', '', '', ent(t.bultos), '', n5(t.medida),
                 ent(t.cantidad), '', n4(t.fob), '', '', '$ '+n2(t.cif), '', '']);

    doc.autoTable({
      startY: 88,
      head: [['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
              'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL',
              'GASTOS','C.I.F.','COSTO TOTAL','PRECIO VENTA','%']],
      body: cuerpo,
      theme: 'grid',
      styles: {fontSize:6.2, cellPadding:2, overflow:'ellipsize', valign:'middle'},
      headStyles: {fillColor:[240,240,240], textColor:[40,40,40], fontStyle:'bold', fontSize:5.8, halign:'center'},
      columnStyles: {
        0:{cellWidth:26, minCellHeight:26},
        1:{cellWidth:16, halign:'right'},
        2:{cellWidth:52},
        3:{cellWidth:120},
        4:{cellWidth:32, halign:'right'}, 5:{cellWidth:34, halign:'center'},
        6:{cellWidth:36, halign:'right'}, 7:{cellWidth:46, halign:'right'},
        8:{cellWidth:48, halign:'right'}, 9:{cellWidth:36, halign:'right'},
        10:{cellWidth:40, halign:'right'}, 11:{cellWidth:48, halign:'right'},
        12:{cellWidth:38, halign:'right'}, 13:{cellWidth:38, halign:'right'},
        14:{cellWidth:48, halign:'right'}, 15:{cellWidth:42, halign:'right'},
        16:{cellWidth:34, halign:'right'}
      },
      // La última fila es la de totales
      didParseCell: function(d){
        if(d.section==='body' && d.row.index===cuerpo.length-1){
          d.cell.styles.fontStyle='bold';
          d.cell.styles.fillColor=[245,245,245];
        }
      },
      // Las fotos se dibujan dentro de su celda
      didDrawCell: function(d){
        if(d.section!=='body' || d.column.index!==0) return;
        if(d.row.index>=datos.lineas.length) return;
        var src=fotos[d.row.index];
        if(!src) return;
        try{
          doc.addImage(src, 'JPEG', d.cell.x+2, d.cell.y+2,
                       d.cell.width-4, Math.min(d.cell.height-4, d.cell.width-4));
        }catch(e){}
      },
      margin: {left:20, right:20, bottom:40}
    });

    // Los gastos
    var y=doc.lastAutoTable.finalY+18;
    if((datos.gastos||[]).length){
      if(y > doc.internal.pageSize.getHeight()-120){ doc.addPage(); y=40; }
      doc.autoTable({
        startY: y,
        head: [['CONCEPTO','MONTO','PRORRATEO']],
        body: (datos.gastos||[]).map(function(g){
          return [ (g.concepto||'')+(g.codigo&&g.concepto!==g.codigo?('  ('+g.codigo+')'):''),
                   n2(g.monto), g.prorrateo||'' ];
        }).concat([['TOTAL GASTOS', n2(t.gastos), '']]),
        theme: 'grid',
        styles: {fontSize:7.5, cellPadding:3},
        headStyles: {fillColor:[240,240,240], textColor:[40,40,40], fontStyle:'bold', fontSize:7},
        columnStyles: {0:{cellWidth:230}, 1:{cellWidth:80, halign:'right'}, 2:{cellWidth:160}},
        didParseCell: function(d){
          if(d.section==='body' && d.row.index===(datos.gastos||[]).length){
            d.cell.styles.fontStyle='bold';
            d.cell.styles.fillColor=[245,245,245];
          }
        },
        margin: {left:20, right:20}
      });
      y=doc.lastAutoTable.finalY+16;
    }

    // Resumen
    if(y > doc.internal.pageSize.getHeight()-70){ doc.addPage(); y=40; }
    doc.setFont('helvetica','bold'); doc.setFontSize(9);
    doc.text('TOTAL F.O.B.: '+n2(t.fob)
      +'      TOTAL GASTOS: '+n2(t.gastos)
      +'      TOTAL C.I.F.: '+n2(t.cif), 20, y);

    // Numeración de páginas
    var n=doc.internal.getNumberOfPages();
    for(var pg=1; pg<=n; pg++){
      doc.setPage(pg);
      doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
      doc.text('Costo de importación '+(datos.costo_importacion||'')+' · entrada '+(datos.entrada||''),
               20, doc.internal.pageSize.getHeight()-18);
      doc.text('Página '+pg+' de '+n, W-20, doc.internal.pageSize.getHeight()-18, {align:'right'});
    }

    var nombre='Costeo_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.pdf';
    doc.save(nombre);

    // Y se adjunta a la etapa, sin cerrar la ventana
    try{
      var blob=doc.output('blob');
      var file=new File([blob], nombre, {type:'application/pdf'});
      await _costAdjuntarSilencioso(oid, _subKeyCost(_PASO_COSTEO), file);
    }catch(e){ console.warn('adjuntar PDF:',e); }

    showT('✓ PDF descargado y adjuntado a la etapa');
    if(btn){
      btn.disabled=false;
      btn.style.background='#0c447c';
      btn.innerHTML='<i class="ti ti-check"></i> PDF listo · volver a bajar';
    }
    var pie=document.getElementById('costprev-pie');
    if(pie) pie.innerHTML='<span style="color:var(--text-success);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> PDF descargado y adjuntado a la etapa</span>';
  }catch(e){
    console.error('pdf costeo:',e);
    showT('No se pudo armar el PDF: '+(e.message||e));
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-file-type-pdf"></i> Descargar PDF'; }
  }
}

// Adjunta un archivo al paso sin repintar la pantalla, para no cerrar
// la ventana que el usuario está mirando.
async function _costAdjuntarSilencioso(oid, sub, file){
  try{
    var pth=await _subirDocStorage(oid, sub, file);
    if(!pth) return false;
    var reg=await _registrarDoc(oid, sub, file, pth);
    if(!window._atts) window._atts={};
    if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
    window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:file.name,
      data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
      url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    // Se repintan SOLO los paneles, no el paso entero: repintar el paso
    // reconstruye la pantalla y cierra la ventana del costeo que está
    // abierta. Con esto el botón «Enviar por correo» aparece al momento.
    setTimeout(function(){ try{ _costRefrescarPaneles(oid); }catch(e){} }, 100);
    return true;
  }catch(e){ console.warn('adjuntar costeo:',e); return false; }
}

/* Rehace los paneles del costeo y de los precios sin tocar el resto de la
   etapa: es lo que hace que salga el botón de enviar en cuanto se genera el
   costeo, sin salir de la orden. */
function _costRefrescarPaneles(oid){
  var hecho=false;
  try{
    var p=document.getElementById('costeopanel-'+oid);
    if(p){ p.innerHTML=_costPanel(oid); hecho=true; }
  }catch(e){}
  try{
    var pv=document.getElementById('pvpanel-'+oid);
    if(pv){ pv.innerHTML=_pvPanel(oid); hecho=true; }
  }catch(e){}
  // Si los paneles no están en pantalla (se cambió de vista), se repinta el
  // paso, que es el camino largo pero seguro.
  if(!hecho){
    try{ _redibujarPaso(oid, _subKeyCost(_PASO_COSTEO)); }catch(e){}
  }
  return hecho;
}

async function _costDescargar(oid){
  var datos=(window._costDatos||{})[oid];
  if(!datos){ showT('No hay datos del costeo'); return; }
  var btn=document.getElementById('costprev-btn');
  function estado(t){ if(btn) btn.innerHTML=t; }
  if(btn) btn.disabled=true;
  estado('Armando el Excel…');

  try{
    var t=datos.totales||{};
    var dat=_solPagoDatosOrden(oid);
    var nombre='Costeo_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.xlsx';

    var ExcelJS=await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Costeo');

    // Cabecera, igual que el PDF
    ws.addRow(['KENNEDY CENTER CORP.']);
    ws.addRow(['COSTO DE IMPORTACION:', datos.costo_importacion||'']);
    ws.addRow(['ENTRADA No:', datos.entrada||'', 'FECHA:', datos.fecha||'']);
    ws.addRow(['FACTURA No:', datos.factura||'', 'SUPLIDOR:',
               (datos.suplidor_codigo||'')+' '+(datos.suplidor||'')]);
    ws.addRow([]);
    ws.getRow(1).font={bold:true, size:13};
    for(var r=2;r<=4;r++) ws.getRow(r).font={bold:true, size:10};

    var enc=['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
             'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL',
             'GASTOS','C.I.F.','COSTO TOTAL','PRECIO VENTA','%'];
    var filaEnc=ws.addRow(enc);
    filaEnc.font={bold:true, size:9};
    filaEnc.alignment={vertical:'middle', horizontal:'center', wrapText:true};
    filaEnc.eachCell(function(c){
      c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEEEEEE'}};
      c.border={bottom:{style:'thin'}};
    });

    var filaBase=ws.rowCount;
    datos.lineas.forEach(function(l,i){
      var f=ws.addRow(['', l.nro||i+1, l.referencia||'', l.descripcion||'',
        Number(l.piezas_x_bulto)||0, l.empaque||'PZA', Number(l.bultos)||0,
        Number((l.medida||0).toFixed(5)),
        Number((l.medida_total||((l.medida||0)*(l.bultos||0))).toFixed(5)),
        Number(l.cantidad)||0,
        Number((l.fob_unit||0).toFixed(4)), Number((l.fob_total||0).toFixed(4)),
        Number((l.gasto_unit||0).toFixed(4)), Number((l.cif_unit||0).toFixed(4)),
        Number((l.cif_total||0).toFixed(2)),
        Number((l.precio_venta||0).toFixed(2)), Number((l.margen||0).toFixed(4))]);
      f.height=46;                       // alto para que entre la foto
      f.alignment={vertical:'middle'};
    });

    // Totales
    ws.addRow([]);
    var ft=ws.addRow(['', '', 'TOTAL', '', '', '', Number(t.bultos)||0, '',
                      Number(t.medida)||0, Number(t.cantidad)||0, '',
                      Number(t.fob)||0, '', '', Number(t.cif)||0, '', '']);
    ft.font={bold:true};

    // Gastos
    if((datos.gastos||[]).length){
      ws.addRow([]);
      datos.gastos.forEach(function(g){
        ws.addRow(['', g.concepto||'', Number(g.monto)||0, g.prorrateo||'', g.codigo||'']);
      });
      var fg=ws.addRow(['', 'TOTAL GASTOS', Number(t.gastos)||0]);
      fg.font={bold:true};
    }

    ws.columns=[{width:8},{width:5},{width:15},{width:44},{width:9},{width:10},
                {width:11},{width:13},{width:14},{width:10},{width:11},{width:13},
                {width:11},{width:11},{width:13},{width:13},{width:10}];

    // Las fotos, una por línea
    var conFoto=0, pesoFotos=0;
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      if(i%10===0) estado('Agregando fotos… '+i+'/'+datos.lineas.length);
      try{
        // Comprimida: el archivo tiene que poder mandarse por correo
        var im=await _costFotoChica(l.foto, 150, 0.55);
        if(!im) continue;
        pesoFotos+=im.kb||0;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, { tl:{col:0.15, row:(filaBase+i)+0.10},
                          ext:{width:52, height:52}, editAs:'oneCell' });
        conFoto++;
      }catch(e){}
    }

    estado('Descargando…');
    var buf=await wb.xlsx.writeBuffer();
    var blob=new Blob([buf], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    // Se descarga en el equipo
    var a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download=nombre;
    document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 3000);

    // Y se adjunta a la etapa, sin repintar nada por debajo: el repintado
    // reconstruía la pantalla y cerraba esta ventana.
    var file=new File([blob], nombre, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    await _costAdjuntarSilencioso(oid, _subKeyCost(_PASO_COSTEO), file);

    var d=_logLeer(oid);
    d.costeo=d.costeo||{};
    d.costeo.sap=datos;
    d.costeo.generado_en=new Date().toISOString();
    d.costeo.generado_por=(CU&&CU.name)||'';
    await _logGuardar(oid);

    // La ventana se queda abierta: la cierra el usuario cuando quiera
    showT('✓ Costeo descargado'+(conFoto?(' con '+conFoto+' foto(s), '+Math.round(pesoFotos/1024*10)/10+' MB en imágenes'):'')+' y adjuntado a la etapa');
    if(btn){
      btn.disabled=false;
      btn.style.background='#0c447c';
      btn.innerHTML='<i class="ti ti-check"></i> Descargado · volver a bajar';
    }
    // Aviso dentro de la ventana, para no depender del mensaje que se va
    try{
      var pie=document.getElementById('costprev-pie');
      if(pie) pie.innerHTML='<span style="color:var(--text-success);font-weight:600">'
        +'<i class="ti ti-circle-check"></i> Descargado y adjuntado a la etapa'
        +(conFoto?(' · '+conFoto+' foto(s)'):'')+'</span>';
    }catch(e){}

    // v742: aquí YA NO se avisa a gerencia. Descargar el Excel no es pasarle
    // el costeo a nadie (se puede bajar varias veces); el aviso sale UNA vez,
    // al enviarlo por correo. Antes salían dos alertas del mismo costeo.
    // El panel de la etapa se refresca al cerrar esta ventana
  }catch(e){
    console.error('excel costeo:',e);
    showT('No se pudo armar el Excel: '+(e.message||e));
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-file-spreadsheet"></i> Descargar Excel y adjuntar'; }
  }
}


// Vuelve a abrir el último costeo consultado, sin pedirlo otra vez a SAP
function _costVerUltimo(oid){
  var d=_logLeer(oid);
  var datos=(d.costeo&&d.costeo.sap)||((window._costDatos||{})[oid]);
  if(!datos){ showT('Todavía no se consultó ningún costeo. Pulsa "Generar costeo desde SAP".'); return; }
  window._costDatos=window._costDatos||{};
  window._costDatos[oid]=datos;
  _costPreview(oid, datos);
}

function _costRepintar(oid){
  var _y=window.scrollY;
  setTimeout(function(){ window.scrollTo(0,_y); }, 0);
  // El contenedor se llama «costeopanel-» en la etapa; había código
  // buscando «costpanel-», que no existe, y por eso el panel no se
  // refrescaba y el botón de enviar no aparecía hasta recargar.
  var c=document.getElementById('costeopanel-'+oid)
      || document.getElementById('costpanel-'+oid);
  if(c) c.innerHTML=_costPanel(oid);
  else { _dbg('[panel] el costeo no está en pantalla: no se repinta'); }
  try{
    var pv=document.getElementById('pvpanel-'+oid);
    if(pv) pv.innerHTML=_pvPanel(oid);
  }catch(e){}
}

// Marca que los precios ya están en SAP
async function _costPreciosSap(oid, valor){
  var d=_logLeer(oid);
  d.costeo=d.costeo||{};
  if(valor){
    d.costeo.precios_sap=true;
    d.costeo.precios_sap_por=(CU&&CU.name)||'';
    d.costeo.precios_sap_en=new Date().toISOString();
  } else {
    if(!confirm('¿Desmarcar "Precios en SAP"?\n\nLa etapa vuelve a quedar pendiente.')){ _costRepintar(oid); return; }
    d.costeo.precios_sap=false;
    d.costeo.precios_sap_por='';
    d.costeo.precios_sap_en='';
  }
  await _logGuardar(oid);

  // El paso avanza o retrocede según el visto
  try{
    var st=STAGES.find(function(z){ return z.key==='costeo'; });
    var pi=_pasoIdxCost(_PASO_COSTEO);
    initP(oid);
    var sp=stageProgress[oid].costeo;
    if(valor && pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'costeo');
    } else if(!valor && pi>=0 && (sp.stepIdx||0)>pi){
      sp.stepIdx=pi;
      if(sp.stepDates) sp.stepDates[pi]='';
      guardarEtapa(oid,'costeo');
    }
  }catch(e){}

  showT(valor?'✓ Precios en SAP. La etapa pasa a verde.':'Precios en SAP desmarcado');
  _costRepintar(oid);
  try{ openDetail(oid); }catch(e){}
}

// ── Enviar el costeo por correo ──
// Los archivos del costeo son los que empiezan por "Costeo"
function _costArchivos(oid){
  var sk=_subKeyCost(_PASO_COSTEO);
  var todos=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  return todos.filter(function(a){
    var n=String(a.name||'').trim().toLowerCase();
    return n.indexOf('costeo')===0 && /\.(xlsx|xls|pdf)$/i.test(n);
  });
}

// Arma un Excel liviano del costeo, sin fotos, para poder mandarlo por
// correo: el que lleva las fotos supera el límite de adjuntos.
// Baja una foto y la comprime para que quepa en el correo.
// En el Excel se ve a unos 52 puntos, así que 150 px de lado sobran: el peso
// pasa de ~200 KB a ~10 KB por foto y el archivo entra sin problema.
async function _costFotoChica(nombreArchivo, lado, calidad){
  lado=lado||150; calidad=(calidad==null?0.55:calidad);
  var urls=[];
  try{ urls.push(_repFotoUrl(nombreArchivo)); }catch(e){}
  urls.push(FOTO_BASE+encodeURIComponent(nombreArchivo));
  urls.push(FOTO_BASE+encodeURIComponent(String(nombreArchivo).toLowerCase()));
  urls.push(FOTO_BASE+encodeURIComponent(String(nombreArchivo).replace(/\.[^.]+$/,'.jpg')));

  for(var i=0;i<urls.length;i++){
    var u=urls[i];
    if(!u) continue;
    try{
      var img=await new Promise(function(res,rej){
        var im=new Image();
        im.crossOrigin='anonymous';
        im.onload=function(){ res(im); };
        im.onerror=function(){ rej(new Error('no carga')); };
        im.src=u;
        setTimeout(function(){ rej(new Error('tardó demasiado')); }, 30000);
      });
      // Se redimensiona manteniendo la proporción
      var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
      if(!w || !h) continue;
      var esc=Math.min(1, lado/Math.max(w,h));
      var cw=Math.max(1, Math.round(w*esc)), ch=Math.max(1, Math.round(h*esc));
      var cv=document.createElement('canvas');
      cv.width=cw; cv.height=ch;
      var cx=cv.getContext('2d');
      cx.fillStyle='#ffffff';           // fondo blanco: los PNG con transparencia salen negros
      cx.fillRect(0,0,cw,ch);
      cx.drawImage(img, 0, 0, cw, ch);
      var dataUrl=cv.toDataURL('image/jpeg', calidad);
      var b64=dataUrl.split(',')[1]||'';
      if(!b64) continue;
      return {b64:b64, ext:'jpeg', dataUrl:dataUrl,
              kb:Math.round(b64.length*0.75/1024), w:cw, h:ch};
    }catch(e){ /* se prueba la siguiente URL */ }
  }
  return null;
}

// Arma el Excel para el correo: mismos datos y con fotos, pero comprimidas
// para no pasarse del límite de adjuntos.
async function _costExcelCorreo(oid){
  var datos=(window._costDatos||{})[oid] || ((_logLeer(oid).costeo||{}).sap);
  if(!datos || !Array.isArray(datos.lineas) || !datos.lineas.length) return null;
  try{
    var t=datos.totales||{};
    var ExcelJS=await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Costeo');

    ws.addRow(['KENNEDY CENTER CORP.']);
    ws.addRow(['COSTO DE IMPORTACION:', datos.costo_importacion||'']);
    ws.addRow(['ENTRADA No:', datos.entrada||'', 'FECHA:', datos.fecha||'']);
    ws.addRow(['FACTURA No:', datos.factura||'', 'SUPLIDOR:',
               (datos.suplidor_codigo||'')+' '+(datos.suplidor||'')]);
    ws.addRow([]);
    ws.getRow(1).font={bold:true, size:13};
    for(var r=2;r<=4;r++) ws.getRow(r).font={bold:true, size:10};

    var filaEnc=ws.addRow(['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
      'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL','GASTOS','C.I.F.',
      'COSTO TOTAL','PRECIO VENTA','%']);
    filaEnc.font={bold:true, size:9};
    filaEnc.alignment={vertical:'middle', horizontal:'center', wrapText:true};
    filaEnc.eachCell(function(c){
      c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEEEEEE'}};
      c.border={bottom:{style:'thin'}};
    });

    var filaBase=ws.rowCount;
    datos.lineas.forEach(function(l,i){
      var f=ws.addRow(['', l.nro||i+1, l.referencia||'', l.descripcion||'',
        Number(l.piezas_x_bulto)||0, l.empaque||'PZA', Number(l.bultos)||0,
        Number((l.medida||0).toFixed(5)),
        Number((l.medida_total||((l.medida||0)*(l.bultos||0))).toFixed(5)),
        Number(l.cantidad)||0,
        Number((l.fob_unit||0).toFixed(4)), Number((l.fob_total||0).toFixed(4)),
        Number((l.gasto_unit||0).toFixed(4)), Number((l.cif_unit||0).toFixed(4)),
        Number((l.cif_total||0).toFixed(2)),
        Number((l.precio_venta||0).toFixed(2)), Number((l.margen||0).toFixed(4))]);
      f.height=46;
      f.alignment={vertical:'middle'};
    });

    ws.addRow([]);
    var ft=ws.addRow(['', '', 'TOTAL', '', '', '', Number(t.bultos)||0, '',
                      Number(t.medida)||0, Number(t.cantidad)||0, '',
                      Number(t.fob)||0, '', '', Number(t.cif)||0, '', '']);
    ft.font={bold:true};

    if((datos.gastos||[]).length){
      ws.addRow([]);
      datos.gastos.forEach(function(g){
        ws.addRow(['', g.concepto||'', Number(g.monto)||0, g.prorrateo||'', g.codigo||'']);
      });
      var fg=ws.addRow(['', 'TOTAL GASTOS', Number(t.gastos)||0]);
      fg.font={bold:true};
    }

    ws.columns=[{width:8},{width:5},{width:15},{width:44},{width:9},{width:10},
                {width:11},{width:13},{width:14},{width:10},{width:11},{width:13},
                {width:11},{width:11},{width:13},{width:13},{width:10}];

    // Las fotos, bien comprimidas para que el correo las acepte
    var conFoto=0;
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      try{
        var im=await _costFotoChica(l.foto, 120, 0.45);
        if(!im) continue;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, { tl:{col:0.15, row:(filaBase+i)+0.10},
                          ext:{width:52, height:52}, editAs:'oneCell' });
        conFoto++;
      }catch(e){}
    }

    var buf=await wb.xlsx.writeBuffer();
    var dat=_solPagoDatosOrden(oid);
    var nombre='Costeo_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.xlsx';
    var b64=await new Promise(function(res,rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=rej;
      fr.readAsDataURL(new Blob([buf]));
    });
    var kb=Math.round(buf.byteLength/1024);
    if(buf.byteLength > MAIL_MAX_MB*1024*1024){
      console.warn('[costeo] el excel comprimido sigue pesando', kb, 'KB');
      return null;
    }
    return { nombre:nombre,
             mime:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             contenido:b64, kb:kb, fotos:conFoto };
  }catch(e){ console.warn('excel para el correo:',e); return null; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  PRECIOS DE VENTA POR GERENCIA
//  Se muestra el mismo costeo de la etapa anterior, pero con el precio de
//  venta editable. Al cambiarlo se recalcula el margen de esa línea. Cuando
//  gerencia guarda, puede enviarlo a las compradoras del departamento con el
//  Excel de los precios nuevos.
// ═══════════════════════════════════════════════════════════════════════════
/* Qué costeo es este. Una orden puede tener varias entradas y, por tanto,
   varios costeos; los precios que se ponen en uno NO deben aparecer como
   cambios en otro. Antes se guardaban por orden y se mezclaban. */
function _pvClaveCosteo(base){
  if(!base) return 'x';
  return String(base.num_doc_com || base.entrada || base.costeo || 'x')
    .replace(/[^0-9A-Za-z\-\/]/g,'');
}

// Los precios editados de ESTE costeo
function _pvEditados(d, base){
  d=d||{}; d.precios=d.precios||{};
  var k=_pvClaveCosteo(base);
  d.precios.porCosteo=d.precios.porCosteo||{};
  // Lo guardado ANTES de separar por costeo se hereda SOLO si se sabe con
  // certeza que era de este mismo costeo. Si no consta, no se aplica: más
  // vale traer el precio de SAP que un precio de otra entrada marcado como
  // si fuera un cambio.
  if(!d.precios.porCosteo[k] && d.precios.valores && d.precios.costeo===k){
    d.precios.porCosteo[k]=d.precios.valores;
  }
  return d.precios.porCosteo[k] || {};
}

function _pvDatos(oid){
  var d=_logLeer(oid);
  // Los precios editados se guardan aparte, para no pisar el costeo original
  d.precios=d.precios||{};
  // El costeo se busca en memoria y, si no está, en lo guardado con la
  // orden. Lo último generado se conserva hasta que se genere otro.
  var base=(window._costDatos&&window._costDatos[oid])
        || (d.costeo && (d.costeo.datos || d.costeo.sap))
        || null;
  if(base && !(window._costDatos&&window._costDatos[oid])){
    window._costDatos=window._costDatos||{};
    window._costDatos[oid]=base;
  }
  return {d:d, base:base};
}

// Marca un paso de Aduanización como completado. Se usa cuando se envía el
// correo: ese envío es lo que da el paso por terminado.
function _costeoMarcarPaso(oid, nombrePaso){
  var pi=_pasoIdxCost(nombrePaso);
  if(pi<0) return;
  var st=STAGES.find(function(z){ return z.key==='costeo'; });
  initP(oid);
  var sp=stageProgress[oid].costeo;
  if((sp.stepIdx||0)>pi) return;          // ya estaba completado
  var hoyIso=new Date().toISOString().slice(0,10);
  sp.stepIdx=pi+1;
  if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
  sp.stepDates[pi]=now2();
  if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
  sp.stepBy[pi]=(CU&&CU.name)||'';
  if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
  sp._isoPasos[pi]=hoyIso;
  if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
  guardarEtapa(oid,'costeo');
}

function _pvPanel(oid){
  var r=_pvDatos(oid);
  var base=r.base, d=r.d;
  var guardado=d.precios&&d.precios.guardado_en;
  var env=_solEnvioLeer(oid,'precios');

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(env?'sem-g':(guardado?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-tag"></i> Precios de venta</div>'
    +(env?('<span style="font-size:10px;color:var(--t-verde);background:var(--pastel-ok);border-radius:6px;padding:2px 8px;font-weight:700">ENVIADO A COMPRAS</span>')
          :(guardado?('<span style="font-size:10px;color:var(--t-ambar);background:var(--pastel-naranja);border-radius:6px;padding:2px 8px;font-weight:700">GUARDADOS · falta enviar</span>'):''))
    +'</div>';

  if(!base || !Array.isArray(base.lineas) || !base.lineas.length){
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-alert-circle" style="color:var(--t-ambar)"></i> Todavía no hay costeo cargado. '
      +'Primero hay que traerlo desde SAP en el paso <b>Costeo de importación</b>.'
      +(CU && _puedeAduana()
        ? '<div style="margin-top:7px"><button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="event.stopPropagation();_pvTraer(\'' + oid + '\')">'
          +'<i class="ti ti-refresh"></i> Buscar el costeo guardado</button></div>'
        : '')
      +'</div>';
    return h+'</div>';
  }

  var puedeEditar = CU && (CU.role==='gerencia');
  h+='<div style="font-size:11px;color:var(--t-marron);margin-bottom:8px">'
    +'Costo de importación <b>'+_esc(base.costo_importacion||'')+'</b>'
    +(base.entrada?(' · entrada <b>'+_esc(base.entrada)+'</b>'):'')
    +' · '+base.lineas.length+' línea(s)'
    +(puedeEditar?' · <span style="color:var(--t-verde);font-weight:600">puedes editar los precios de venta</span>'
                 :' · <span style="color:var(--text-muted)">solo gerencia puede editarlos</span>')
    +'</div>';

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">'
    +'<button class="btn bp" style="background:#0c447c;font-size:11.5px;padding:7px 13px" onclick="event.stopPropagation();_pvAbrir(\'' + oid + '\')">'
      +'<i class="ti ti-table"></i> '+(puedeEditar?'Abrir y editar los precios':'Ver el costeo con precios')+'</button>'
    // Un solo botón de envío: a IMPORTACIÓN, que es quien los sube a SAP.
    // Cuando ya se mandó, se queda en verde con quién y cuándo.
    +((guardado && (_puedeAduana() || _esGerencia()))
      ? (_pvEnviado(oid)
         ? ('<span style="display:inline-flex;align-items:center;gap:6px;'
            +'background:var(--pastel-ok);color:var(--t-verde);border-radius:8px;'
            +'padding:7px 12px;font-size:11.5px;font-weight:700">'
            +'<i class="ti ti-circle-check"></i> Enviado a importación · '
            +_esc(_pvEnviado(oid).por||'')+' · '+_esc(_fechaHora(_pvEnviado(oid).fecha))
            +'</span>')
         : ('<button class="btn bp" style="background:#7C3D12;font-size:11.5px;'
            +'padding:7px 13px" onclick="event.stopPropagation();_pvEnviarModal(\''+oid+'\')">'
            +'<i class="ti ti-mail"></i> Enviar a importación</button>'))
      :'')
    // Importación los sube a SAP, y queda el sello de cuándo y quién
    +((guardado && _puedeAduana())
      ? (_pvEnSap(oid)
         ? ('<span style="display:inline-flex;align-items:center;gap:6px;'
            +'background:var(--pastel-ok);color:var(--t-verde);border-radius:8px;'
            +'padding:7px 12px;font-size:11.5px;font-weight:700" title="'
            +_esc((_pvEnSap(oid).articulos||0)+' artículo(s)')+'">'
            +'<i class="ti ti-database-check"></i> Precios actualizados en SAP · '
            +_esc(_pvEnSap(oid).por||'')+' · '+_esc(_fechaHora(_pvEnSap(oid).fecha))
            +'</span>'
            +'<button class="btn bg2" style="font-size:11.5px;padding:7px 13px" '
            +'onclick="event.stopPropagation();_pvSubirASap(\''+oid+'\')">'
            +'<i class="ti ti-refresh"></i> Volver a subir</button>')
         : ('<button class="btn bp" style="background:#166534;font-size:11.5px;'
            +'padding:7px 13px" onclick="event.stopPropagation();'
            +'_pvSubirASap(\''+oid+'\')"><i class="ti ti-database-edit"></i> '
            +'Confirmar y subir a SAP</button>'))
      :'')
    // El informe de recepción, aquí mismo: con los precios recién puestos
    +((guardado)?('<button class="btn bg2" style="font-size:11.5px;padding:7px 13px" '
      +'onclick="event.stopPropagation();_pvVerInforme(\''+oid+'\')">'
      +'<i class="ti ti-file-type-pdf"></i> Ver el informe</button>'
      +(_pvVendEnviado(oid)
        ? ('<span style="display:inline-flex;align-items:center;gap:6px;'
           +'background:var(--pastel-ok);color:var(--t-verde);border-radius:8px;'
           +'padding:7px 12px;font-size:11.5px;font-weight:700">'
           +'<i class="ti ti-circle-check"></i> Enviado a vendedores · '
           +_esc(_pvVendEnviado(oid).por||'')+' · '
           +_esc(_fechaHora(_pvVendEnviado(oid).fecha))+'</span>'
           +'<button class="btn bg2" style="font-size:11.5px;padding:7px 13px" '
           +'onclick="event.stopPropagation();_pvEnviarVendedores(\''+oid+'\')">'
           +'<i class="ti ti-send"></i> Volver a enviar</button>')
        : ('<button class="btn bp" style="background:#0C447C;font-size:11.5px;'
           +'padding:7px 13px" onclick="event.stopPropagation();'
           +'_pvEnviarVendedores(\''+oid+'\')">'
           +'<i class="ti ti-mail"></i> Enviar a vendedores</button>'))):'')
    +'</div>';

  if(guardado){
    var n=Object.keys(d.precios.valores||{}).length;
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:8px 11px;font-size:11px;margin-bottom:8px">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde)"></i> '
      +n+' precio(s) modificado(s) · guardado por <b>'+_esc(d.precios.guardado_por||'')+'</b> · '
      +_esc(_fechaHora(d.precios.guardado_en))+'</div>';
  }

  if(env){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
      +'<div style="font-weight:700"><i class="ti ti-mail-check"></i> Precios enviados a compras</div>'
      +'<div style="margin-top:2px;font-size:11px">Por <b>'+_esc(env.por||'')+'</b> · '+_esc(_fechaHora(env.fecha))
      +(env.para&&env.para.length?('<br>A: '+_esc(env.para.join(', '))):'')+'</div></div>';
  }
  return h+'</div>';
}

function _pvRepintar(oid){
  var c=document.getElementById('pvpanel-'+oid);
  if(c) c.innerHTML=_pvPanel(oid);
}

// Trae el costeo guardado en la orden, si no está en memoria
async function _pvTraer(oid){
  var d=_logLeer(oid);
  if(d.costeo && d.costeo.sap){
    window._costDatos=window._costDatos||{};
    window._costDatos[oid]=d.costeo.sap;
    showT('✓ Costeo recuperado');
    _pvRepintar(oid);
    return;
  }
  showT('No hay ningún costeo guardado en esta orden. Generalo en el paso anterior.');
}

// ── La tabla editable ──
async function _pvAbrir(oid){
  var r=_pvDatos(oid);
  var base=r.base, d=r.d;
  if(!base){ showT('No hay costeo cargado'); return; }

  // Se enriquece por si faltaran fotos o precios
  try{ base=await _costEnriquecer(base); }catch(e){}

  // Los precios ya editados de ESTE costeo mandan sobre los de SAP
  var editados=_pvEditados(d, base);
  var puedeEditar = CU && (CU.role==='gerencia');

  var prev=document.getElementById('modalPV'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPV';
  // A pantalla completa: aquí se trabaja, no se mira de pasada
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:12200;'
    +'display:flex;flex-direction:column;padding:10px 12px;overflow:hidden';

  function n2(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function n4(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }

  var filas=base.lineas.map(function(l,i){
    var ref=String(l.referencia||'');
    var refSeguro=ref.replace(/'/g,'');           // para meterlo en el onclick
    var pvOrig=Number(l.precio_venta)||0;
    var pv=(editados[ref]!=null)?Number(editados[ref]):pvOrig;
    var cif=Number(l.cif_unit)||0;
    var mg=pv?(((pv-cif)/pv)*100):0;
    var foto='';
    try{ foto=l.foto?_repFotoUrl(l.foto):''; }catch(e){ foto=l.foto?(FOTO_BASE+encodeURIComponent(l.foto)):''; }
    var fotoNom=String(l.foto||'').replace(/'/g,'');
    var cambiado=(editados[ref]!=null && Math.abs(pv-pvOrig)>0.001);

    var celdaFoto = foto
      ? ('<img src="'+_esc(foto)+'" class="cost-mini" alt="" '
         +'onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(refSeguro)+'\')" '
         +'onerror="_costFotoAlt(this,\''+_esc(fotoNom)+'\')">')
      : '<span style="display:inline-block;width:30px;height:30px;border-radius:5px;background:var(--surface-1)"></span>';

    return '<tr style="border-bottom:0.5px solid var(--border)" data-ref="'+_esc(ref)+'">'
      +'<td style="padding:2px 4px;width:38px">'+celdaFoto+'</td>'
      +'<td style="padding:3px 6px;color:var(--text-muted);text-align:right">'+(l.nro||i+1)+'</td>'
      +'<td style="padding:3px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'
        +'<span onclick="event.stopPropagation();_invFicha(\''+_esc(refSeguro)+'\')" '
        +'style="color:var(--text-accent);cursor:pointer;text-decoration:underline" title="Ver la ficha del producto">'
        +_esc(ref)+'</span></td>'
      +'<td style="padding:3px 6px;max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="'+_esc(l.descripcion||'')+'">'+_esc(l.descripcion||'')+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n2(l.cantidad)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n4(l.fob_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-marron)">'+n4(l.gasto_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:700">'+n4(cif)+'</td>'
      +'<td style="padding:2px 5px;text-align:right;background:'+(cambiado?'#FEF9E7':'transparent')+'">'
        +(puedeEditar
          ? ('<div style="display:flex;gap:4px;align-items:center;justify-content:flex-end">'
             +'<input type="text" inputmode="decimal" '
             +'title="Precio de venta. También acepta /.50 · /50 · x2 · +30% sobre el CIF" '
             +'placeholder="—" value="'+(pv?pv.toFixed(2):'')+'" '
             +'id="pv-'+i+'" data-ref="'+_esc(ref)+'" data-cif="'+cif+'" data-orig="'+pvOrig+'" '
             +'oninput="_pvCambio('+i+')" onclick="event.stopPropagation()" '
             +'onkeydown="_pvTecla(event,'+i+')" onfocus="this.select()" '
             +'style="width:84px;padding:4px 7px;border:0.5px solid '+(cambiado?'#E0A82E':'var(--border)')+';'
             +'border-radius:6px;font-size:12px;font-weight:700;text-align:right;'
             +'background:var(--surface-0);color:'+(cambiado?'#7C3D12':'var(--text-primary)')+'">'
             // La casilla del MARGEN, como en «Generar catálogo»: se escribe
             // 50 y el precio sale solo a partir del CIF.
             +'</div>'
             +'<div id="pvpie-'+i+'" style="font-size:9.5px;color:var(--text-muted);'
             +'text-align:right;margin-top:1px">'
             +(cif>0?('CIF '+n2(cif)):'')
             +'</div>')
          : ('<b>'+(pv>0?n2(pv):'—')+'</b>'))
      +'</td>'
      // El margen, en SU columna: antes iba pegado al precio y la cabecera
      // no cuadraba con lo que había debajo.
      +'<td style="padding:3px 6px;text-align:right" id="mg-'+i+'">'
        +(puedeEditar
          ? ('<div style="display:flex;gap:3px;align-items:center;justify-content:flex-end">'
             +'<input type="text" inputmode="decimal" id="pvmg-'+i+'" '
             +'title="Escribe 50 y el precio se calcula desde el CIF" placeholder="—" '
             +'value="'+(pv>0&&cif>0?(Math.round(mg*10)/10):'')+'" '
             +'oninput="_pvMargenLinea('+i+',this.value)" onclick="event.stopPropagation()" '
             +'onkeydown="_pvTecla(event,'+i+',true)" onfocus="this.select()" '
             +'style="width:58px;padding:4px 6px;border:0.5px solid #C4B5FD;border-radius:6px;'
             +'font-size:12px;font-weight:700;text-align:right;background:var(--surface-0);'
             +'color:'+(mg<0?'#991b1b':(mg<25?'#B45309':'#166534'))+'">'
             +'<span style="font-size:10.5px;color:var(--text-muted)">%</span></div>')
          : (pv>0
             ? ('<b style="color:'+(mg<0?'#991b1b':(mg<25?'#B45309':'#166534'))+'">'
                +n4(mg)+'</b>')
             : '<span style="color:var(--text-muted)">—</span>'))
      +'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-size:10px;color:var(--text-muted)">'
        +(pvOrig?n2(pvOrig):'—')+'</td>'
      +'</tr>';
  }).join('');

  function th(txt, ali, w){
    return '<th style="padding:5px 6px;text-align:'+(ali||'left')+';font-size:9px;text-transform:uppercase;'
      +'color:var(--text-muted);font-weight:700;white-space:nowrap;background:var(--surface-1);'
      +'position:sticky;top:0;z-index:2;border-bottom:1px solid var(--border)'+(w?(';width:'+w):'')+'">'+txt+'</th>';
  }

  // Ancho completo y alto completo: la tabla es para trabajar en ella, no
  // para mirarla por una rendija de 1120 px con diez filas visibles.
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:12px;padding:14px 16px;'
    +'width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:10px">'
      +'<div style="font-size:12px;line-height:1.5">'
        +'<div style="font-size:14px;font-weight:800">PRECIOS DE VENTA</div>'
        +'<div><b>COSTO DE IMPORTACION:</b> '+_esc(base.costo_importacion||'')
          +'   <b>ENTRADA:</b> '+_esc(base.entrada||'')+'</div>'
        +'<div style="color:var(--text-muted)">'+_esc(base.suplidor||'')+'</div>'
      +'</div>'
      +'<button onclick="_pvCerrar(\'' + oid + '\')" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>'

    +(puedeEditar
      ? '<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:8px;padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-azul)">'
        +'<i class="ti ti-pencil"></i> Escribe el precio de venta que corresponda en cada línea. '
        +'El porcentaje se recalcula solo. Las líneas que cambies quedan resaltadas.</div>'
      : '<div style="background:var(--surface-1);border-radius:8px;padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--text-muted)">'
        +'<i class="ti ti-lock"></i> Solo gerencia puede modificar los precios de venta.</div>')

    +'<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden;'
      +'margin-bottom:10px;flex:1;display:flex;flex-direction:column;min-height:0">'
      +'<div style="flex:1;overflow:auto;min-height:0">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
      +'<thead><tr>'
        +th('','left')+th('#','right')+th('Referencia')+th('Descripción')
        +th('Cant.','right')+th('F.O.B.','right')+th('Gastos','right')+th('C.I.F.','right')
        +th('Precio venta','right','110px')+th('Margen %','right','90px')
        +th('Precio anterior','right')
      +'</tr></thead><tbody>'+filas+'</tbody></table></div></div>'

    +'<div style="font-size:10.5px;color:var(--text-muted);margin:4px 0 8px">'
    +'<i class="ti ti-arrows-move-vertical"></i> Escribe un precio o un % y '
    +'<b>arrastra el cuadradito</b> de la esquina hacia abajo para repetirlo. '
    +'Doble clic en él llena hasta el final; Ctrl+D hace lo mismo; Enter y las '
    +'flechas bajan de línea.</div>'
    +'<div id="pv-resumen" style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px"></div>'

    +'<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div id="pv-pie" style="font-size:11.5px;color:var(--text-muted)">'+base.lineas.length+' línea(s)</div>'
      +'<div style="display:flex;gap:8px">'
        +'<button class="btn" onclick="_pvCerrar(\'' + oid + '\')">Cerrar</button>'
        +(puedeEditar
          ? ('<button class="btn bg2" '
             +'onclick="_pvPreciosDeSap(\''+oid+'\')" '
             +'title="Lee el precio de venta directamente de SAP, sin esperar al Sync">'
             +'<i class="ti ti-refresh"></i> Traer precios de SAP</button>'
             +'<button class="btn bg2" style="color:var(--t-lila);border-color:var(--t-lila)" '
             +'onclick="_pvMargenTodos()"><i class="ti ti-percentage"></i> '
             +'Precio por margen</button>'
             +'<button class="btn bg2" style="color:var(--t-rojo);border-color:#F3C9C9" '
             +'onclick="_pvOlvidarGuardados(\''+oid+'\')" '
             +'title="Descarta lo guardado y deja los precios tal como están en SAP">'
             +'<i class="ti ti-eraser"></i> Olvidar lo guardado</button>'
             +'<button class="btn bg2" onclick="_pvRestaurar(\'' + oid + '\')"><i class="ti ti-arrow-back-up"></i> Volver a los originales</button>'
             +'<button class="btn bp" id="pv-btn" style="background:#166534" onclick="_pvGuardar(\'' + oid + '\')">'
             +'<i class="ti ti-device-floppy"></i> Guardar precios</button>')
          : '')
      +'</div></div>'
    +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
  window._pvCtx={oid:oid, base:base};
  _pvResumen();
}

// Al escribir un precio se recalcula su margen
/* La casilla del precio entiende, además del precio a secas:
     /.50   → el CIF dividido entre 0,50 (margen del 50%)
     /50    → lo mismo, escrito en porcentaje
     *2     → el CIF multiplicado por 2
     +30%   → el CIF más un 30%
   Es la misma forma de calcular que en el generador de catálogo. */
function _pvFormula(txt, cif){
  var t=String(txt||'').trim().replace(',', '.');
  if(!t || !(cif>0)) return null;
  var m;
  if((m=t.match(/^\/\s*([0-9.]+)\s*%?$/))){
    var div=parseFloat(m[1]);
    if(!(div>0)) return null;
    if(div>1) div=div/100;                    // «/50» es lo mismo que «/.50»
    if(!(div>0) || div>=1) return null;
    return cif/div;
  }
  if((m=t.match(/^[x*]\s*([0-9.]+)$/i))){
    var f=parseFloat(m[1]);
    return f>0 ? cif*f : null;
  }
  if((m=t.match(/^\+\s*([0-9.]+)\s*%$/))){
    var p=parseFloat(m[1]);
    return p>=0 ? cif*(1+p/100) : null;
  }
  return null;
}

function _pvCambio(i, desdeMargen){
  var inp=document.getElementById('pv-'+i);
  if(!inp) return;
  var cif0=parseFloat(inp.getAttribute('data-cif'))||0;
  // Si se escribió una fórmula, se convierte en precio y se deja el número
  var calc=_pvFormula(inp.value, cif0);
  if(calc!=null){
    inp.value=(Math.round(calc*100)/100).toFixed(2);
    inp.type='number';
  }
  var pv=parseFloat(inp.value);
  var cif=cif0;
  var orig=parseFloat(inp.getAttribute('data-orig'))||0;
  var mg=(pv>0)?(((pv-cif)/pv)*100):0;
  var col=(!pv||isNaN(pv))?'var(--text-muted)':(mg<0?'#991b1b':(mg<25?'#B45309':'#166534'));
  // OJO: la celda del margen lleva dentro la casilla donde se escribe. Si se
  // reescribe entera, el campo se destruye a media escritura y «50» se queda
  // en «5». Solo se cambia el COLOR, nunca el contenido.
  var em=document.getElementById('pvmg-'+i);
  if(em){
    em.style.color=col;
  } else {
    var celda=document.getElementById('mg-'+i);
    if(celda){
      celda.innerHTML='<b style="color:'+col+'">'
        +((!pv||isNaN(pv))?'—'
          :(mg).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}))
        +'</b>';
    }
  }
  // Se marca la línea si cambió
  // Las dos casillas se mantienen a la par y el pie muestra CIF y margen
  try{
    // El % solo se reescribe si NO se está escribiendo en él
    if(!desdeMargen && em && document.activeElement!==em){
      em.value=(pv>0&&cif>0)?(Math.round((((pv-cif)/pv)*100)*10)/10):'';
    }
    _pvPieLinea(i, cif, pv);
  }catch(e){}
  var cambiado=(!isNaN(pv) && Math.abs(pv-orig)>0.001);
  inp.style.borderColor=cambiado?'#E0A82E':'var(--border)';
  inp.style.color=cambiado?'#7C3D12':'var(--text-primary)';
  if(inp.parentElement) inp.parentElement.style.background=cambiado?'#FEF9E7':'transparent';
  // Aviso si el precio queda por debajo del costo
  if(!isNaN(pv) && pv>0 && pv<cif){
    inp.style.borderColor='#dc2626';
    inp.title='Este precio está por debajo del costo CIF ('+cif.toFixed(4)+')';
  } else {
    inp.title='';
  }
  _pvResumen();
}

// Resumen de lo que se lleva editado
function _pvResumen(){
  var cont=document.getElementById('pv-resumen');
  if(!cont) return;
  var inputs=Array.prototype.slice.call(document.querySelectorAll('input[id^="pv-"]'));
  var cambiados=0, bajoCosto=0, sinPrecio=0, sumaMg=0, conMg=0;
  inputs.forEach(function(inp){
    var pv=parseFloat(inp.value);
    var cif=parseFloat(inp.getAttribute('data-cif'))||0;
    var orig=parseFloat(inp.getAttribute('data-orig'))||0;
    if(isNaN(pv) || pv<=0){ sinPrecio++; return; }
    if(Math.abs(pv-orig)>0.001) cambiados++;
    if(pv<cif) bajoCosto++;
    sumaMg+=((pv-cif)/pv)*100; conMg++;
  });
  cont.innerHTML=
     _costKpi('Líneas', String(inputs.length), '#0c447c')
    +_costKpi('Precios cambiados', String(cambiados), cambiados?'#B45309':'#6b7280')
    +_costKpi('Margen promedio', conMg?((sumaMg/conMg).toFixed(2)+'%'):'—', '#166534')
    +(bajoCosto?('<div style="flex:1;min-width:150px;background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:7px 10px">'
      +'<div style="font-size:9.5px;color:var(--t-rojo);font-weight:700;text-transform:uppercase">Atención</div>'
      +'<div style="font-size:12px;font-weight:700;color:var(--t-rojo)">'+bajoCosto+' bajo el costo</div></div>'):'')
    +(sinPrecio?('<div style="flex:1;min-width:150px;background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:7px 10px">'
      +'<div style="font-size:9.5px;color:var(--t-marron);font-weight:700;text-transform:uppercase">Sin precio</div>'
      +'<div style="font-size:12px;font-weight:700;color:var(--t-marron)">'+sinPrecio+' línea(s)</div></div>'):'');
}

function _pvCerrar(oid){
  var m=document.getElementById('modalPV');
  if(m) m.remove();
  window._pvCtx=null;
  try{ _pvRepintar(oid); }catch(e){}
}

// Vuelve a los precios que trajo el costeo
async function _pvRestaurar(oid){
  if(!confirm('¿Volver a los precios originales del costeo?\n\nSe pierden los cambios que hiciste.')) return;
  var d=_logLeer(oid);
  d.precios={};
  await _logGuardar(oid);
  var m=document.getElementById('modalPV'); if(m) m.remove();
  showT('Precios restaurados');
  _pvAbrir(oid);
}

// Guarda los precios editados
async function _pvGuardar(oid){
  var ctx=window._pvCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var inputs=Array.prototype.slice.call(document.querySelectorAll('input[id^="pv-"]'));
  var valores={}, cambiados=0, bajoCosto=[];
  inputs.forEach(function(inp){
    var ref=inp.getAttribute('data-ref');
    var pv=parseFloat(inp.value);
    var cif=parseFloat(inp.getAttribute('data-cif'))||0;
    var orig=parseFloat(inp.getAttribute('data-orig'))||0;
    if(isNaN(pv) || pv<=0) return;
    valores[ref]=Number(pv.toFixed(2));
    if(Math.abs(pv-orig)>0.001) cambiados++;
    if(pv<cif) bajoCosto.push(ref);
  });

  if(bajoCosto.length){
    if(!confirm(bajoCosto.length+' artículo(s) quedaron con el precio por debajo del costo CIF:\n\n'
      +bajoCosto.slice(0,10).join(', ')+(bajoCosto.length>10?'…':'')
      +'\n\n¿Guardar igual?')) return;
  }

  var btn=document.getElementById('pv-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Guardando…'; }

  var d=_logLeer(oid);
  // Se guardan BAJO SU COSTEO: una orden con tres entradas tiene tres
  // costeos, y los precios de uno no pueden salir marcados como cambios en
  // otro, que es lo que pasaba y pintaba líneas en amarillo con precios de
  // otra entrada.
  var clave=_pvClaveCosteo(ctx.base || (_pvDatos(oid)||{}).base);
  d.precios=d.precios||{};
  d.precios.porCosteo=d.precios.porCosteo||{};
  d.precios.porCosteo[clave]=valores;
  d.precios.valores=valores;          // el último, para lo que lo lea suelto
  d.precios.costeo=clave;
  d.precios.guardado_por=(CU&&CU.name)||'';
  d.precios.guardado_en=new Date().toISOString();
  d.precios.cambiados=cambiados;
  await _logGuardar(oid);

  // Guardar no cierra el paso: lo cierra el envío del correo a compras

  showT('✓ '+Object.keys(valores).length+' precio(s) guardado(s)'
    +(cambiados?(' · '+cambiados+' modificado(s)'):''));
  if(btn){
    btn.disabled=false;
    btn.style.background='#0c447c';
    btn.innerHTML='<i class="ti ti-check"></i> Guardado';
  }
  var pie=document.getElementById('pv-pie');
  if(pie) pie.innerHTML='<span style="color:var(--text-success);font-weight:600">'
    +'<i class="ti ti-circle-check"></i> Precios guardados. Cerrá y pulsa "Enviar a las compradoras" '
    +'para dar por terminada la etapa.</span>';
}

// Los datos con los precios ya editados, para el Excel y el correo
function _pvConEditados(oid){
  var r=_pvDatos(oid);
  if(!r.base) return null;
  var editados=_pvEditados(r.d, r.base);
  var copia=JSON.parse(JSON.stringify(r.base));
  copia.lineas.forEach(function(l){
    var ref=String(l.referencia||'');
    if(editados[ref]!=null){
      var pv=Number(editados[ref])||0;
      var cif=Number(l.cif_unit)||0;
      l.precio_venta=pv;
      l.margen=pv?Number((((pv-cif)/pv)*100).toFixed(4)):0;
    }
  });
  copia._precios={ por:(r.d.precios&&r.d.precios.guardado_por)||'',
                   en:(r.d.precios&&r.d.precios.guardado_en)||'',
                   cambiados:(r.d.precios&&r.d.precios.cambiados)||0 };
  return copia;
}

// ── Enviar los precios a las compradoras del departamento ──
async function _pvEnviarModal(oid){
  var datos=_pvConEditados(oid);
  if(!datos){ showT('No hay costeo con precios para enviar'); return; }
  var d=_logLeer(oid);
  if(!(d.precios && d.precios.guardado_en)){
    alert('Primero guarda los precios.\n\nAbrí la tabla, revisa los precios de venta y pulsa "Guardar precios".');
    return;
  }

  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||datos.entrada||'').trim();
  var dept=dat.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  window._mailAdj=[];
  window._pvMailCtx={oid:oid};

  // IMPORTACIÓN marcada por defecto: son quienes ajustan los precios en SAP
  var comprasDept=(USERS||[]).filter(function(u){
    return u.email && String(u.role||'')==='importacion';
  });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado = comprasDept.length
      ? comprasDept.some(function(z){ return z.id===u.id; })
      : (_esComprasU(u));
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#0c447c':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#e6f1fb':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
        +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
  }).join('');

  var nCambios=(d.precios&&d.precios.cambiados)||0;
  var asunto='PRECIOS DE VENTA - '+ordenTxt+(entrada?(' - ENTRADA '+entrada):'');
  var cuerpo='Estimadas,\n\n'
    +'Adjunto el costeo con los precios de venta ya asignados por gerencia.\n\n'
    +'  • Orden: '+ordenTxt+'\n'
    +(entrada?('  • Número de entrada: '+entrada+'\n'):'')
    +(datos.costo_importacion?('  • Costo de importación: '+datos.costo_importacion+'\n'):'')
    +(dat.proveedor?('  • Proveedor: '+dat.proveedor+'\n'):'')
    +(dept?('  • Departamento: '+dL(dept)+'\n'):'')
    +'  • Artículos: '+datos.lineas.length+'\n'
    +(nCambios?('  • Precios modificados: '+nCambios+'\n'):'')
    +'\nQuedamos atentos.\n\n'
    +'Saludos cordiales,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalPVMail'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPVMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:640px">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)"><i class="ti ti-tag"></i> Enviar los precios a compras</div>'
      +'<button onclick="_pvMailCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA'
      +(comprasDept.length?(' <span style="color:var(--t-azul);font-weight:600">· compras de '+_esc(dL(dept))+' marcadas</span>'):'')+'</div>'
    +'<div id="pvmail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="pvmail-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="pvmail-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="pvmail-cuerpo" rows="13" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTO</div>'
    +'<div id="pvmail-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Armando el Excel con los precios nuevos…</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_pvMailCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="pvmail-btn" style="background:#0c447c" onclick="_pvMailEnviar()"><i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // El Excel con los precios editados
  var aviso=document.getElementById('pvmail-auto');
  var arch=await _pvExcel(oid, datos, true);
  if(arch){
    window._mailAdj.push(arch);
    mailPintarAdjuntos();
    if(aviso) aviso.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '
      +_esc(arch.nombre)+' · '+arch.kb+' KB'+(arch.fotos?(' · '+arch.fotos+' fotos'):'')+'</span>';
  } else {
    if(aviso) aviso.innerHTML='<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> '
      +'No se pudo armar el Excel. Probá de nuevo.</span>';
  }
}

/* El aviso dentro del portal para quien recibe uno de estos correos. El
   correo puede tardar o perderse entre cien más; el aviso aparece en el
   acto y lleva a la orden. */
function _avisarPorCorreo(destinos, oid, titulo, icono){
  var lista=(destinos||[]).map(function(e){ return String(e||'').trim().toLowerCase(); })
              .filter(function(e){ return e.indexOf('@')>0; });
  if(!lista.length) return 0;
  var n=0;
  (typeof USERS!=='undefined'?USERS:[]).forEach(function(u){
    var em=String(u.email||'').trim().toLowerCase();
    if(!em || lista.indexOf(em)<0) return;
    if(CU && u.id===CU.id) return;               // a uno mismo, no
    try{ addNotif(u.id, titulo, oid, icono||'ti-mail'); n++; }catch(e){}
  });
  // Y a los encargados del área, aunque no estén en copia del correo
  return n;
}

function _pvMailCerrar(){
  var m=document.getElementById('modalPVMail'); if(m) m.remove();
  window._mailAdj=[]; window._pvMailCtx=null;
}

async function _pvMailEnviar(){
  var ctx=window._pvMailCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('pvmail-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('pvmail-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }
  if(!(window._mailAdj||[]).length){
    _mailMsg('No hay adjunto. El correo tiene que llevar el Excel con los precios.','err');
    return;
  }

  var asunto=(document.getElementById('pvmail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('pvmail-cuerpo')||{}).value||'';
  var btn=document.getElementById('pvmail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Precios de venta · '+oid, estado:'pendiente'
      })});
    // El mismo aviso, dentro del portal, y queda constancia del envío
    try{
      _avisarPorCorreo(todos, oid,
        'Precios de venta enviados · orden '+oid+' · revisa y ajusta si hace falta',
        'ti-tag');
    }catch(e){}
    try{ _pvMarcarEnviado(oid, todos); }catch(e){}
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
    return;
  }

  // El Excel queda también adjunto al paso, para que puedan bajarlo desde ahí
  try{
    var a=(window._mailAdj||[])[0];
    if(a && a.blob){
      var file=new File([a.blob], a.nombre, {type:a.mime});
      await _costAdjuntarSilencioso(oid, _subKeyCost(_PASO_PRECIOS), file);
    }
  }catch(e){ console.warn('adjuntar al paso:',e); }

  _solEnvioGuardar(oid, 'precios', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo
  });

  // El envío del correo cierra el paso y con él la etapa
  try{ _costeoMarcarPaso(oid, _PASO_PRECIOS); }catch(e){ console.warn('marcar precios:',e); }

  // Aviso en el portal, que las lleva a este paso
  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Aduanización & Costeo',
      texto:'Precios de venta asignados por gerencia. El Excel está adjunto en el paso.',
      etiqueta:'Precios de venta listos', paso:_PASO_PRECIOS
    });
  }catch(e){}

  _pvMailCerrar();
  showT('✓ Precios enviados a '+todos.length+' destinatario(s)');
  _pvRepintar(oid);
}

// Arma el Excel de precios, con el mismo formato del costeo
async function _pvExcel(oid, datos, paraCorreo){
  datos=datos||_pvConEditados(oid);
  if(!datos) return null;
  try{
    var t=datos.totales||{};
    var ExcelJS=await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Precios');

    ws.addRow(['KENNEDY CENTER CORP.']);
    ws.addRow(['PRECIOS DE VENTA']);
    ws.addRow(['COSTO DE IMPORTACION:', datos.costo_importacion||'']);
    ws.addRow(['ENTRADA No:', datos.entrada||'', 'FECHA:', datos.fecha||'']);
    ws.addRow(['SUPLIDOR:', (datos.suplidor_codigo||'')+' '+(datos.suplidor||'')]);
    if(datos._precios && datos._precios.por){
      ws.addRow(['PRECIOS ASIGNADOS POR:', datos._precios.por,
                 datos._precios.en?_fechaHora(datos._precios.en):'']);
    }
    ws.addRow([]);
    ws.getRow(1).font={bold:true, size:13};
    ws.getRow(2).font={bold:true, size:11};
    for(var r=3;r<=6;r++) ws.getRow(r).font={bold:true, size:10};

    var filaEnc=ws.addRow(['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
      'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL','GASTOS','C.I.F.',
      'COSTO TOTAL','PRECIO VENTA','%']);
    filaEnc.font={bold:true, size:9};
    filaEnc.alignment={vertical:'middle', horizontal:'center', wrapText:true};
    filaEnc.eachCell(function(c){
      c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEEEEEE'}};
      c.border={bottom:{style:'thin'}};
    });

    var filaBase=ws.rowCount;
    datos.lineas.forEach(function(l,i){
      var f=ws.addRow(['', l.nro||i+1, l.referencia||'', l.descripcion||'',
        Number(l.piezas_x_bulto)||0, l.empaque||'PZA', Number(l.bultos)||0,
        Number((l.medida||0).toFixed(5)),
        Number((l.medida_total||((l.medida||0)*(l.bultos||0))).toFixed(5)),
        Number(l.cantidad)||0,
        Number((l.fob_unit||0).toFixed(4)), Number((l.fob_total||0).toFixed(4)),
        Number((l.gasto_unit||0).toFixed(4)), Number((l.cif_unit||0).toFixed(4)),
        Number((l.cif_total||0).toFixed(2)),
        Number((l.precio_venta||0).toFixed(2)), Number((l.margen||0).toFixed(4))]);
      f.height=46;
      f.alignment={vertical:'middle'};
      // El precio de venta, resaltado: es lo que se revisó en esta etapa
      f.getCell(16).font={bold:true};
      f.getCell(16).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFFEF9E7'}};
    });

    ws.addRow([]);
    var ft=ws.addRow(['', '', 'TOTAL', '', '', '', Number(t.bultos)||0, '',
                      Number(t.medida)||0, Number(t.cantidad)||0, '',
                      Number(t.fob)||0, '', '', Number(t.cif)||0, '', '']);
    ft.font={bold:true};

    if((datos.gastos||[]).length){
      ws.addRow([]);
      datos.gastos.forEach(function(g){
        ws.addRow(['', g.concepto||'', Number(g.monto)||0, g.prorrateo||'', g.codigo||'']);
      });
      var fg=ws.addRow(['', 'TOTAL GASTOS', Number(t.gastos)||0]);
      fg.font={bold:true};
    }

    ws.columns=[{width:8},{width:5},{width:15},{width:44},{width:9},{width:10},
                {width:11},{width:13},{width:14},{width:10},{width:11},{width:13},
                {width:11},{width:11},{width:13},{width:13},{width:10}];

    var conFoto=0;
    var lado=paraCorreo?120:150, cal=paraCorreo?0.45:0.55;
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      try{
        var im=await _costFotoChica(l.foto, lado, cal);
        if(!im) continue;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, { tl:{col:0.15, row:(filaBase+i)+0.10},
                          ext:{width:52, height:52}, editAs:'oneCell' });
        conFoto++;
      }catch(e){}
    }

    var buf=await wb.xlsx.writeBuffer();
    var dat=_solPagoDatosOrden(oid);
    var nombre='Precios_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.xlsx';
    var blob=new Blob([buf], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    if(!paraCorreo){
      var a=document.createElement('a');
      a.href=URL.createObjectURL(blob);
      a.download=nombre;
      document.body.appendChild(a); a.click();
      setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 3000);
      return {nombre:nombre, kb:Math.round(buf.byteLength/1024), fotos:conFoto, blob:blob};
    }

    var b64=await new Promise(function(res,rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=rej;
      fr.readAsDataURL(blob);
    });
    return { nombre:nombre,
             mime:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             contenido:b64, kb:Math.round(buf.byteLength/1024), fotos:conFoto, blob:blob };
  }catch(e){ console.warn('excel de precios:',e); return null; }
}

async function _costEnviarModal(oid){
  // Antes se exigía tener el DMCE y el SIGA revisados con IA para poder
  // mandar el costeo, y eso frenaba envíos legítimos. La revisión sigue
  // estando donde siempre; aquí ya no bloquea.
  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var d=_logLeer(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
  var sk=_subKeyCost(_PASO_COSTEO);
  var files=_costArchivos(oid);

  // Sin el costeo adjunto no tiene sentido enviar el correo
  if(!files.length){
    var todos=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
    alert('No se puede enviar el correo todavía.\n\n'
      +'No hay ningún archivo de costeo adjunto en este paso.\n'
      +'Tiene que ser un Excel o un PDF cuyo nombre empiece por "Costeo".\n\n'
      +(todos.length
        ? ('Archivos que hay ahora:\n'+todos.map(function(a){ return '  · '+(a.name||''); }).join('\n')
           +'\n\nGenerá el costeo desde SAP o subilo a mano.')
        : 'Generá el costeo desde SAP con el botón de arriba, o subilo a mano.'));
    return;
  }

  window._mailAdj=[];
  window._costCtx={oid:oid};

  // Por defecto solo la gerencia DEL DEPARTAMENTO de esta orden
  var _dept=dat.dept||'';
  if(!_dept){
    var _o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(_o) _dept=_o.dept||'';
  }
  var gersDept=(USERS||[]).filter(function(u){
    return u.role==='gerencia' && u.email && _dept && String(u.dept||'')===String(_dept);
  });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    // Si el departamento tiene su gerencia, solo esa; si no, toda la gerencia
    var marcado = gersDept.length
      ? gersDept.some(function(z){ return z.id===u.id; })
      : (u.role==='gerencia');
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#7C3D12':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#FBEEDD':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
        +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
  }).join('');

  var asunto='COSTEO - '+ordenTxt+(entrada?(' - ENTRADA '+entrada):'');
  var cimp=(d.costeo&&d.costeo.sap&&d.costeo.sap.costo_importacion)||'';
  var cuerpo='Estimados,\n\n'
    +'Adjunto costeo para su revisión y colocación de precios.\n\n'
    +'  • Orden: '+ordenTxt+'\n'
    +(entrada?('  • Número de entrada: '+entrada+'\n'):'')
    +(cimp?('  • Costo de importación: '+cimp+'\n'):'')
    +(dat.proveedor?('  • Proveedor: '+dat.proveedor+'\n'):'')
    +(dat.dept?('  • Departamento: '+dL(dat.dept)+'\n'):'')
    +'\nQuedamos atentos.\n\n'
    +'Saludos cordiales,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalCosteo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCosteo';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:640px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)"><i class="ti ti-table"></i> Enviar costeo</div>'
      +'<button onclick="_costCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA</div>'
    +'<div id="cost-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="cost-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="cost-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="cost-cuerpo" rows="12" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="cost-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando el costeo…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_costCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="cost-btn" style="background:#7C3D12" onclick="_costEnviar()"><i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  var aviso=document.getElementById('cost-auto');
  var puestos=[], fallidos=[];
  for(var i=0;i<files.length;i++){
    if(!files[i].url) continue;
    var motivo={};
    try{
      var adj=await _solPagoAdjuntarDeStorage(files[i].url, files[i].name||'Costeo.xlsx', motivo);
      if(adj){ window._mailAdj.push(adj); puestos.push(files[i].name); }
      else fallidos.push((files[i].name||'')+': '+(motivo.txt||'no se pudo adjuntar'));
    }catch(e){ fallidos.push((files[i].name||'')+': '+(e.message||e)); }
  }
  mailPintarAdjuntos();
  // Si el del paso no entró por peso, se arma uno nuevo con las fotos
  // comprimidas, que sí cabe en el correo.
  if(!puestos.length){
    if(aviso) aviso.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
      +'El archivo del paso es muy pesado: armando una versión con las fotos comprimidas…</span>';
    var liv=await _costExcelCorreo(oid);
    if(liv){
      window._mailAdj.push(liv);
      puestos.push(liv.nombre+' ('+liv.kb+' KB'+(liv.fotos?(', '+liv.fotos+' fotos'):'')+')');
      mailPintarAdjuntos();
    }
  }

  if(aviso){
    if(puestos.length){
      aviso.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '
        +_esc(puestos.join(', '))+'</span>'
        +(fallidos.length?('<br><span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> '+_esc(fallidos.join(' · '))+'</span>'):'');
    } else {
      aviso.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:8px 10px;color:var(--t-rojo)">'
        +'<b><i class="ti ti-alert-triangle"></i> No se pudo adjuntar el costeo</b>'
        +(fallidos.length?('<div style="margin-top:3px">'+_esc(fallidos.join(' · '))+'</div>'):'')
        +'<div style="margin-top:4px">Generá el PDF, que pesa mucho menos que el Excel con fotos, '
        +'y adjuntalo con el botón de abajo.</div></div>';
    }
  }
}

function _costCerrar(){
  var m=document.getElementById('modalCosteo'); if(m) m.remove();
  window._mailAdj=[]; window._costCtx=null;
}

async function _costEnviar(){
  var ctx=window._costCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('cost-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('cost-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }
  // El correo tiene que llevar el costeo: sin eso no se envía
  if(!(window._mailAdj||[]).length){
    _mailMsg('No hay ningún archivo adjunto. El correo tiene que llevar el costeo en Excel o PDF.','err');
    return;
  }
  var traeCosteo=(window._mailAdj||[]).some(function(a){
    return String(a.nombre||'').trim().toLowerCase().indexOf('costeo')===0;
  });
  if(!traeCosteo){
    if(!confirm('Ninguno de los adjuntos parece ser el costeo.\n\n'
      +'Se esperaba un archivo cuyo nombre empiece por "Costeo".\n\n¿Enviar igual?')) return;
  }

  var asunto=(document.getElementById('cost-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('cost-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('cost-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Costeo · '+oid, estado:'pendiente'
      })});
    // Queda la constancia en la etapa: quién lo pidió y cuándo, que es lo
    // que antes solo sabía quien lo había mandado.
    try{
      var _d=_logLeer(oid);
      _d.costeo=_d.costeo||{};
      _d.costeo.solicitado={por:(CU&&CU.name)||'', fecha:new Date().toISOString(),
                            para:todos.join(', ')};
      _logGuardar(oid);
      _costRefrescarPaneles(oid);
      // Si la orden llegó en dos embarques, se avisa de la otra entrada
      setTimeout(function(){ _pvAvisarOtraEntrada(oid, null); }, 1500);
    }catch(e){}
    // NO se manda aviso aquí: más abajo se envía la mención que lleva
    // directa al paso del costeo, y mandar los dos dejaba al destinatario
    // con dos alertas de lo mismo, una de ellas sin enlace útil.
    if(!r.ok){
      var t=await r.text(); console.error('costeo:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
    return;
  }

  _solEnvioGuardar(oid, 'costeo', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo
  });

  // El envío del correo es lo que cierra este paso
  try{ _costeoMarcarPaso(oid, _PASO_COSTEO); }catch(e){ console.warn('marcar costeo:',e); }

  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    });
    // El único aviso del costeo (v742): lleva el costo de importación y abre
    // directamente el paso donde gerencia pone los precios de venta.
    var _ci='';
    try{ var _lc=_logLeer(oid); _ci=(_lc&&_lc.costeo&&_lc.costeo.sap&&_lc.costeo.sap.costo_importacion)||''; }catch(e){}
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Aduanización & Costeo',
      texto:'Costeo enviado para revisión y colocación de precios'+(_ci?(' · costo de importación '+_ci):''),
      etiqueta:'Costeo — pendiente de precios', paso:_PASO_PRECIOS
    });
  }catch(e){}

  _costCerrar();
  showT('✓ Costeo enviado a '+todos.length+' destinatario(s)');
  _costRepintar(oid);
}

/* ── Lo que ya está escrito en SAP ────────────────────────────────────────
   La orden en SAP trae el contenedor, el barco, el estado de la compra y la
   «Marca de Cliente», donde las compradoras suelen escribir el BL así:
   «RAINBOW / BL: ROECHN26091692D». De ahí se saca el número de BL, el
   contenedor y la naviera, y se ofrecen para rellenar el booking sin
   copiarlos a mano.                                                        */
function _sapEmbarque(oid){
  var o=(orders||[]).find(function(x){ return String(x.id)===String(oid); });
  if(!o) return null;
  var marca=String(o.marca_cliente||o.marcaCliente||'');
  var bl='';
  var m=marca.match(/B\s*\/?\s*L\s*[:#]?\s*([A-Z0-9][A-Z0-9\-\/]{5,})/i);
  if(m) bl=m[1].toUpperCase();
  else {
    // A veces va suelto, sin la etiqueta: una palabra larga con letras y números
    var suelto=marca.match(/\b([A-Z]{4}[A-Z0-9]{6,})\b/);
    if(suelto) bl=suelto[1];
  }
  var cont=String(o.contenedor||o.num_contenedor_campo||'').trim().toUpperCase();
  var nav='';
  try{ nav=_fipNaviera(bl)||_fipNaviera(cont)||''; }catch(e){}
  return {bl:bl, contenedor:cont, barco:String(o.barco||'').trim(),
          naviera:nav, marca:marca.replace(/\s+/g,' ').trim(),
          estado:String(o.estado_compra||o._estadoSap||'').trim(),
          puerto:String(o.puerto_embarque||'').trim(),
          eta:o.eta_sap||o.eta||''};
}

// Lo que dice SAP del embarque, con un botón para volcarlo al booking
function _sapEmbarqueHtml(oid){
  var e=_sapEmbarque(oid);
  if(!e) return '';
  if(!e.bl && !e.contenedor && !e.barco && !e.estado) return '';
  var dato=function(t,v,extra){
    if(!v) return '';
    return '<span style="background:var(--surface-0);border-radius:7px;padding:2px 8px">'
      +'<span style="color:var(--text-muted)">'+t+':</span> <b>'+_esc(v)+'</b>'
      +(extra||'')+'</span>';
  };
  return '<div style="background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:9px;padding:9px 11px;margin-bottom:10px">'
    +'<div style="font-size:11.5px;font-weight:700;margin-bottom:5px">'
    +'<i class="ti ti-database"></i> Lo que ya está en SAP</div>'
    +'<div style="display:flex;gap:6px;flex-wrap:wrap;font-size:11px;margin-bottom:7px">'
    + dato('BL', e.bl)
    + dato('Contenedor', e.contenedor)
    + dato('Naviera', e.naviera)
    + dato('Barco', e.barco)
    + dato('Puerto', e.puerto)
    + dato('Estado', _sapEstadoTxt(e.estado))
    +'</div>'
    +(e.marca?('<div style="font-size:10px;color:var(--text-muted);margin-bottom:7px">'
      +'Marca de cliente en SAP: '+_esc(e.marca)+'</div>'):'')
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
    +'onclick="_sapEmbarqueUsar(\''+oid+'\')"><i class="ti ti-arrow-down"></i> '
    +'Usar estos datos en el booking</button></div>';
}

// Los estados que maneja SAP en «Estado de Orden de Compra»
var SAP_ESTADOS={P:'PENDIENTE', D:'DESPACHADO', C:'CONFIRMADO', S:'EMBARCADO'};
function _sapEstadoTxt(v){
  var k=String(v||'').trim().toUpperCase();
  if(!k) return '';
  return SAP_ESTADOS[k] || k;
}

function _sapEmbarqueUsar(oid){
  var e=_sapEmbarque(oid);
  if(!e) return;
  var d=_logLeer(oid);
  d.booking=d.booking||{};
  var b=d.booking, puesto=[];
  if(e.bl && !b.numero){ b.numero=e.bl; puesto.push('BL'); }
  if(e.naviera && !b.naviera){ b.naviera=e.naviera; puesto.push('naviera'); }
  if(e.barco && !b.barco){ b.barco=e.barco; puesto.push('barco'); }
  if(e.puerto && !b.origen){ b.origen=e.puerto; puesto.push('origen'); }
  if(e.eta && !b.eta){ b.eta=String(e.eta).slice(0,10); puesto.push('ETA'); }
  if(e.contenedor){
    b.containers=b.containers||[];
    if(!b.containers.some(function(c){
        return String(c.id||'').toUpperCase()===e.contenedor; })){
      b.containers.push({id:e.contenedor, sello:''});
      puesto.push('contenedor');
    }
  }
  if(!puesto.length){ showT('El booking ya tenía esos datos'); return; }
  _logGuardar(oid, d);
  showT('✓ '+puesto.join(', ')+' puestos desde SAP');
  try{ _redibujarPaso(oid, _subKeyLog(_PASO_BOOKING)); }catch(e2){}
}

function _logPanelBooking(oid){
  var d=_logLeer(oid), b=d.booking||{};
  var sk=_subKeyLog(_PASO_BOOKING);
  var docs=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var t=_logTotales(b.tarifas);
  var completo=!!(b.numero && b.origen && b.destino);

  var h='<div style="background:#D6EFE7;border:1px solid #7FC9B4;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(completo?'sem-g':(docs.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-verde2);flex:1"><i class="ti ti-ship"></i> Booking</div>'
    +(b.naviera?('<span style="font-size:10.5px;font-weight:700;color:var(--t-verde2)">'+_esc(b.naviera)+'</span>'):'')
    +'</div>';

  h+=_sapEmbarqueHtml(oid);

  // Lo leído del booking se manda a los campos de la orden en SAP
  h+='<div style="display:flex;justify-content:flex-end;margin-bottom:9px">'
    +'<button class="btn bp" style="background:#0C447C;font-size:11.5px;padding:7px 13px" '
    +'onclick="event.stopPropagation();_bkMandarASap(\''+oid+'\')" '
    +'title="Escribe naviera, booking, contenedores, ETA y puertos en la orden de SAP">'
    +'<i class="ti ti-database-export"></i> Actualizar datos del booking en SAP</button></div>';

  // Documentos del booking
  h+=_logZonaDocs(oid, sk, 'DOCUMENTO DEL BOOKING Y TARIFAS',
                  'Adjunta el booking y el tarifario para que la AI los lea', '#085041');

  if(docs.length && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_logLeerIA(\'' + oid + '\',\'booking\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y llenar los datos</button>'
      +'<div id="logia-booking-'+oid+'" style="margin-bottom:9px"></div>';
  }

  // Datos del booking
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','numero','Booking No.', b.numero, 160)
    +_logCampo(oid,'booking','naviera','Naviera', b.naviera, 140)
    +_logCampo(oid,'booking','service_type','Service Type', b.service_type, 140)
    +_logCampo(oid,'booking','service_contract','Service Contract', b.service_contract, 150)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','shipper','Shipper', b.shipper, 200)
    +_logCampo(oid,'booking','consignee','Consignee', b.consignee, 200)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','origen','Origin', b.origen, 150)
    +_logCampo(oid,'booking','destino','Destination', b.destino, 150)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','fecha_salida','ETD', b.fecha_salida, 130)
    +_logCampo(oid,'booking','fecha_llegada','ETA', b.fecha_llegada, 130)
    +'</div>';

  h+=_trackBarra(oid,'booking');
  h+=_logContenedores(oid, true);
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">'
    +'<span style="font-size:10.5px;font-weight:700;color:var(--t-verde2);flex:1">TARIFAS DEL BOOKING</span>'
    +((b.numero||(b.tarifas||[]).length)?('<button class="btn bg2" style="padding:3px 9px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_logVaciarDatos(\'' + oid + '\',\'booking\',\'Booking\')" title="Borra los datos, deja los documentos"><i class="ti ti-eraser"></i> Vaciar datos</button>'):'')
    +'</div>';
  h+=_logTablaTarifas(b.tarifas, true, oid, 'booking');
  h+=_entResumenSeguro(oid);
  h+=_btnCerrarPaso(oid, 'logistica', _PASO_BOOKING,
      {falta: completo ? '' : 'Faltan datos del booking. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// ── B) BILL OF LADING ──
function _logPanelBL(oid){
  var d=_logLeer(oid), b=d.bl||{}, bk=d.booking||{};
  var sk=_subKeyLog(_PASO_BL);
  var docs=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var completo=!!(b.numero && b.shipper && b.consignee);

  var h='<div style="background:#D5E6F7;border:1px solid #6BA5DF;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(completo?'sem-g':(docs.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-azul);flex:1"><i class="ti ti-file-text"></i> Bill of Lading</div></div>';

  h+=_logZonaDocs(oid, sk, 'DOCUMENTO DEL B/L', 'Adjunta el B/L para que la AI lo lea', '#0c447c');

  if(docs.length && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_logLeerIA(\'' + oid + '\',\'bl\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y verificar contra el booking</button>'
      +'<div id="logia-bl-'+oid+'" style="margin-bottom:9px"></div>';
  }

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'bl','numero','B/L No.', b.numero, 160)
    +_logCampo(oid,'bl','vessel','Vessel No.', b.vessel, 150)
    +_logCampo(oid,'bl','viaje','Voyage', b.viaje, 120)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'bl','shipper','Shipper', b.shipper, 200)
    +_logCampo(oid,'bl','consignee','Consignee', b.consignee, 200)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'bl','origen','Puerto de origen', b.origen, 150)
    +_logCampo(oid,'bl','destino','Puerto de destino', b.destino, 150)
    +_logCampo(oid,'bl','fecha_salida','ETD', b.fecha_salida, 120)
    +'</div>';

  h+=_trackBarra(oid,'bl');
  h+=_logContenedores(oid, true);
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">'
    +'<span style="font-size:10.5px;font-weight:700;color:var(--t-azul);flex:1">TARIFAS DEL B/L</span>'
    +((b.numero||(b.tarifas||[]).length)?('<button class="btn bg2" style="padding:3px 9px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_logVaciarDatos(\'' + oid + '\',\'bl\',\'B/L\')" title="Borra los datos, deja los documentos"><i class="ti ti-eraser"></i> Vaciar datos</button>'):'')
    +'</div>';
  h+=_logTablaTarifas(b.tarifas, true, oid, 'bl');
  h+=_logComparar(bk.tarifas, b.tarifas, 'booking', 'B/L');
  h+=_entResumenSeguro(oid);
  h+=_btnCerrarPaso(oid, 'logistica', _PASO_BL,
      {falta: completo ? '' : 'Faltan datos del B/L. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// ── C) AVISO DE LLEGADA ──
// ═══════════════════════════════════════════════════════════════════════════
//  ENTRADA DE MERCANCÍA
//  Los datos que contabilidad carga en SAP en la pestaña "Entradas" de la
//  factura de compra: número de entrada, BL, naviera, contenedores, puerto
//  y todas las fechas del proceso.
// ═══════════════════════════════════════════════════════════════════════════
// Versión compacta para la cabecera de la orden: una línea con lo esencial
// Envoltura segura: la cabecera se arma con plantillas y un error ahí
// dejaría toda la orden en blanco.
// Buscar una entrada sin abrir ninguna orden
async function _entBuscar(){
  var q=prompt('Buscar por número de entrada\n\n'
    +'Escribe el número tal como está en SAP, por ejemplo 145/26:','');
  if(q===null) return;
  q=String(q).trim();
  if(!q){ return; }

  showT('Buscando la entrada '+q+'…');
  var fid=null;
  try{
    var r=await fetch(SB+'/rest/v1/entradas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({docnum:'', entrada:q, pedido_por:(CU&&CU.name)||'',
                           estado:'pendiente', creado_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      showT(/does not exist|Could not find the table/i.test(t)
        ? 'Falta la tabla entradas_queue en Supabase'
        : 'No se pudo buscar (error '+r.status+')');
      return;
    }
    var f=await r.json();
    fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  }catch(e){ showT('Error de conexión'); return; }
  if(!fid) return;
  _entBuscarEsperar(q, fid, 0);
}

function _entBuscarEsperar(q, fid, intento){
  setTimeout(async function(){
    var fila=null;
    try{
      var r=await fetch(SB+'/rest/v1/entradas_queue?select=*&id=eq.'+fid+'&limit=1',{headers:SBH});
      if(r.ok){ var a=await r.json(); fila=(Array.isArray(a)&&a[0])?a[0]:null; }
    }catch(e){}
    if(!fila || fila.estado==='pendiente' || fila.estado==='procesando'){
      if(intento<40) return _entBuscarEsperar(q, fid, intento+1);
      showT('SAP no respondió. Revisa que el worker esté corriendo.');
      return;
    }
    if(fila.estado==='error'){ showT(fila.detalle||'No se encontró esa entrada'); return; }
    var datos=fila.datos;
    if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
    var lista=(datos&&datos.entradas)||[];
    if(!lista.length){ showT('No se encontró la entrada '+q); return; }

    var prev=document.getElementById('modalEnt'); if(prev) prev.remove();
    var ov=document.createElement('div');
    ov.id='modalEnt';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;'
      +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
    ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
      +'width:100%;max-width:760px;max-height:92vh;overflow-y:auto">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
        +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)">'
          +'<i class="ti ti-search"></i> Entrada '+_esc(q)+'</div>'
        +'<button onclick="document.getElementById(\'modalEnt\').remove()" '
          +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
      +lista.map(function(e,i){ return _entFicha(e, lista.length>1?(i+1):0); }).join('')
      +'<div style="display:flex;justify-content:flex-end;margin-top:6px">'
        +'<button class="btn" onclick="document.getElementById(\'modalEnt\').remove()">Cerrar</button>'
      +'</div></div>';
    // No se cierra al tocar fuera: se perdía lo que se estaba mirando por un
  // clic al costado. Solo con el botón Cerrar, la ✕ o la tecla Esc.
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  _modalEsc(ov);
    document.body.appendChild(ov);
    showT('✓ '+lista.length+' entrada(s) encontrada(s)');
  }, intento===0?1800:3000);
}

function _entResumenSeguro(oid){
  try{
    var h=_entResumen(oid)||'';
    // Se marca para poder reemplazarlo sin reconstruir toda la orden
    return h ? h.replace('<div ', '<div data-entresumen="1" ') : '';
  }catch(e){ console.warn('resumen de entrada:',e); return ''; }
}

function _entResumen(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  if(!ents.length){
    if(!_puedeAduana()) return '';
    return '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;'
      +'background:var(--surface-1);border:0.5px dashed var(--border);border-radius:8px;'
      +'padding:6px 11px;margin-bottom:8px">'
      +'<i class="ti ti-truck-delivery" style="color:var(--text-muted);font-size:13px"></i>'
      +'<span style="font-size:11px;color:var(--text-muted);flex:1">Entrada de mercancía en SAP</span>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10px" onclick="event.stopPropagation();_entTraer(\''+oid+'\')">'
      +'<i class="ti ti-database-import"></i> Traer de SAP</button>'
      +'<span id="entcarga-'+oid+'"></span></div>';
  }
  var e=ents[0];
  return '<div onclick="event.stopPropagation();_entVerModal(\''+oid+'\')" '
    +'title="Ver todos los datos de la entrada" '
    +'style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;background:var(--pastel-azul);'
    +'border:0.5px solid #85B7EB;border-radius:8px;padding:7px 11px;margin-bottom:8px;cursor:pointer">'
    +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i>'
    +'<span style="font-size:11.5px;font-weight:700;color:var(--t-azul)">Entrada '+_esc(e.entrada||'—')+'</span>'
    +(e.bl?('<span style="font-size:11px;color:var(--t-azul)">B/L '+_esc(e.bl)+'</span>'):'')
    +(e.naviera?('<span style="font-size:11px;color:var(--t-azul)">'+_esc(e.naviera)+'</span>'):'')
    +(e.num_contenedores?('<span style="font-size:11px;color:var(--t-azul)">'+_esc(e.num_contenedores)+' cont.'
      +(e.tipo_contenedor?(' '+_esc(e.tipo_contenedor)):'')+'</span>'):'')
    +(e.eta?('<span style="font-size:11px;color:var(--t-azul)">ETA '+_esc(_fmtFechaCorta(e.eta))+'</span>'):'')
    +(e.estatus_bodega?('<span style="font-size:9.5px;font-weight:700;background:var(--pastel-ok);color:var(--t-verde);'
      +'border-radius:9px;padding:1px 8px">'+_esc(e.estatus_bodega)+'</span>'):'')
    +'<span style="flex:1"></span>'
    +(ents.length>1?('<span style="font-size:10px;color:var(--text-muted)">+'+(ents.length-1)+' más</span>'):'')
    +'<i class="ti ti-maximize" style="color:var(--t-azul);font-size:12px"></i>'
    +'</div>';
}

// La ficha completa, en una ventana
function _entVerModal(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  if(!ents.length){ _entTraer(oid); return; }
  var prev=document.getElementById('modalEnt'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalEnt';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:760px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)">'
        +'<i class="ti ti-truck-delivery"></i> Entrada de mercancía · orden '+_esc(oid)+'</div>'
      +'<button onclick="document.getElementById(\'modalEnt\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +ents.map(function(e,i){ return _entFicha(e, ents.length>1?(i+1):0); }).join('')
    +'<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:6px">'
      +'<button class="btn bg2" onclick="_entTraer(\''+oid+'\')"><i class="ti ti-refresh"></i> Actualizar desde SAP</button>'
      +'<button class="btn" onclick="document.getElementById(\'modalEnt\').remove()">Cerrar</button>'
    +'</div><div id="entcarga-'+oid+'" style="margin-top:8px"></div></div>';
  // No se cierra al tocar fuera: se perdía lo que se estaba mirando por un
  // clic al costado. Solo con el botón Cerrar, la ✕ o la tecla Esc.
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  _modalEsc(ov);
  document.body.appendChild(ov);
}

// ═══════════════════════════════════════════════════════════════════════════
//  BODEGA & VENTA
//  Recibido en bodega: los datos de la entrada y las fotos de la descarga.
//  Disponible en SAP: qué se facturó contra qué llegó de verdad.
//  En sala de venta: las muestras enviadas y recibidas en oficina.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_BOD_REC  = 'Recibido en bodega';
var _PASO_BOD_SAP  = 'Disponible en SAP';
var _PASO_BOD_SALA = 'En sala de venta';

function _subKeyBodega(nombre){
  var st=STAGES.find(function(z){ return z.key==='bodega'; });
  if(!st) return '';
  var i=st.steps.findIndex(function(p){ return p.name===nombre; });
  return i<0?'':('bodega_step'+i);
}

// ── Recibido en bodega ──
// El número de entrada, editable. Es la clave con la que se consulta SAP,
// así que conviene poder corregirlo antes de pedir los datos.
function _bodEntradaCampo(oid){
  var d=_logLeer(oid);
  var val=String((d.arrival&&d.arrival.entrada)||'').trim();
  var puede=CU && ['bodega','importacion','gerencia','compras','contabilidad'].indexOf(CU.role)>=0;
  var ents=(d.entradas&&d.entradas.lista)||[];

  return '<div style="background:'+(val?'#e6f1fb':'#FEF9F3')+';border:1px solid '
    +(val?'#85B7EB':'#E9C08A')+';border-radius:9px;padding:10px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
      +'<i class="ti ti-hash" style="color:'+(val?'#0c447c':'#7C3D12')+'"></i>'
      +'<span style="font-size:10px;font-weight:700;color:'+(val?'#0c447c':'#7C3D12')
        +';text-transform:uppercase">Número de entrada</span>'
      +(puede
        ? ('<input id="bodent-'+oid+'" value="'+_esc(val)+'" placeholder="Por ejemplo 153/26" '
           +'onclick="event.stopPropagation()" '
           +'onchange="_bodSetEntrada(\''+oid+'\',this.value)" '
           +'style="padding:5px 10px;border:0.5px solid var(--border);border-radius:7px;'
           +'font-size:13px;font-weight:700;width:140px;background:var(--surface-0);color:var(--text-primary)">')
        : ('<span style="font-size:14px;font-weight:800;color:var(--t-azul)">'+_esc(val||'—')+'</span>'))
      +'<span style="flex:1"></span>'
      +(puede
        ? ('<button class="btn bp" style="background:'+(val?'#0c447c':'#9ca3af')+';padding:5px 12px;font-size:11px" '
           +(val?'':'title="Escribe primero el número de entrada" ')
           +'onclick="event.stopPropagation();_bodConsultar(\''+oid+'\')">'
           +'<i class="ti ti-database-import"></i> '+(ents.length?'Actualizar de SAP':'Consultar SAP')+'</button>')
        : '')
    +'</div>'
    +(val
      ? ''
      : '<div style="font-size:10.5px;color:var(--t-marron);margin-top:5px">'
        +'<i class="ti ti-alert-circle"></i> Sin este número no se puede consultar la entrada en SAP. '
        +'Está en la factura de reserva, campo «# de Entrada».</div>')
    +'<div id="entcarga-'+oid+'" style="margin-top:7px"></div>'
    +'</div>';
}

async function _bodSetEntrada(oid, valor){
  var d=_logLeer(oid);
  d.arrival=d.arrival||{};
  d.arrival.entrada=String(valor||'').trim();
  await _logGuardar(oid);
  _bodRepintar(oid);
  try{ _logRepintar(oid); }catch(e){}
}

// Consulta usando lo que esté escrito en el campo, aunque no se haya guardado
async function _bodConsultar(oid){
  var inp=document.getElementById('bodent-'+oid);
  if(inp){
    var v=String(inp.value||'').trim();
    if(!v){
      showT('Escribe el número de entrada antes de consultar');
      inp.focus();
      return;
    }
    var d=_logLeer(oid);
    if(String((d.arrival&&d.arrival.entrada)||'').trim()!==v){
      d.arrival=d.arrival||{};
      d.arrival.entrada=v;
      await _logGuardar(oid);
    }
  }
  _entTraer(oid);
}

function _bodRecibidoPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var h=_bodEntradaCampo(oid);
  h+='';

  // Todos los campos de la entrada, que es lo que bodega necesita ver
  if(ents.length){
    h+=ents.map(function(e,i){ return _entFicha(e, ents.length>1?(i+1):0); }).join('');
  } else {
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
      +'padding:10px 12px;margin-bottom:10px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i> '
      +'Todavía no se trajeron los datos de la entrada.'
      +'<div style="margin-top:5px;font-size:10.5px">Usá el botón <b>Consultar SAP</b> de arriba.</div>'
      +'</div>';
  }

  // Las fotos de la descarga y de la salida del contenedor
  h+=_bodFotos(oid, 'descarga', 'Fotos de la descarga del contenedor',
               'Cómo venía la mercancía al abrir el contenedor', '#0c447c');
  h+=_bodFotos(oid, 'salida', 'Fotos de la salida',
               'El contenedor vacío y precintado al retirarse', '#7C3D12');
  return h;
}

// Un bloque de fotos con miniaturas
function _bodFotos(oid, clave, titulo, ayuda, color){
  var sub=_subKeyBodega(_PASO_BOD_REC)+'_'+clave;
  var fotos=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
  var puede=CU && ['bodega','importacion','gerencia','compras'].indexOf(CU.role)>=0;

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
    +'padding:10px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:7px">'
      +'<i class="ti ti-camera" style="color:'+color+'"></i>'
      +'<span style="font-size:11.5px;font-weight:700;color:'+color+';flex:1">'+_esc(titulo)+'</span>'
      +'<span style="font-size:10.5px;color:var(--text-muted)">'+fotos.length+'</span>'
    +'</div>';

  if(fotos.length){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:7px">';
    fotos.forEach(function(a,i){
      var url=a.data||a.url||'';
      var esImg=/\.(jpe?g|png|gif|webp|heic)$/i.test(String(a.name||''));
      h+='<div style="position:relative">'
        +(esImg
          ? ('<img src="'+_esc(url)+'" class="cost-mini" style="width:82px;height:82px" '
             +'onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" '
             +'onerror="this.style.opacity=.3">')
          : ('<span style="display:flex;width:82px;height:82px;border-radius:6px;background:var(--surface-1);'
             +'border:0.5px solid var(--border);align-items:center;justify-content:center;font-size:10px;'
             +'padding:4px;text-align:center;overflow:hidden">'+_esc(a.name||'')+'</span>'))
        +(puede?('<span onclick="event.stopPropagation();_bodBorrarFoto(\'' + oid + '\',\'' + clave + '\','+i+')" '
          +'title="Borrar" style="position:absolute;top:-5px;right:-5px;background:var(--text-danger);'
          +'color:#fff;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;'
          +'justify-content:center;font-size:11px;cursor:pointer;font-weight:700">×</span>'):'')
        +'</div>';
    });
    h+='</div>';
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:7px">'+_esc(ayuda)+'</div>';
  }

  if(puede){
    h+='<label style="display:inline-flex;align-items:center;gap:6px;padding:6px 11px;'
      +'border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+'">'
      +'<i class="ti ti-camera-plus"></i> Agregar fotos'
      +'<input type="file" multiple accept="image/*,.pdf" style="display:none" '
      +'onchange="_bodSubirFotos(\'' + oid + '\',\'' + clave + '\',this.files)"></label>';
  }
  return h+'</div>';
}

async function _bodSubirFotos(oid, clave, files){
  if(!files||!files.length) return;
  var sub=_subKeyBodega(_PASO_BOD_REC)+'_'+clave;
  showT('Subiendo '+files.length+' foto(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir foto:',e); }
  }
  showT('✓ Fotos agregadas');
  _bodRepintar(oid);
}

async function _bodBorrarFoto(oid, clave, i){
  var sub=_subKeyBodega(_PASO_BOD_REC)+'_'+clave;
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Borrar esta foto?\n\n'+(a.name||'')+'\n\nNo se puede deshacer.')) return;
  window._atts[oid+sub].splice(i,1);
  _bodRepintar(oid);
  try{ await _borrarArchivoStorage(a.url, a.id); }catch(e){}
  showT('Foto eliminada');
}

// El paso de sala se cierra solo cuando hay fecha de muestras recibidas
function _bodSalaCerrar(oid){
  var st=STAGES.find(function(z){ return z.key==='bodega'; });
  if(!st) return false;
  var pi=st.steps.findIndex(function(p){ return p.name===_PASO_BOD_SALA; });
  if(pi<0) return false;
  initP(oid);
  var sp=stageProgress[oid].bodega;
  if(!sp || (sp.stepIdx||0)>pi) return true;      // ya estaba cerrado
  var hoyIso=new Date().toISOString().slice(0,10);
  sp.stepIdx=pi+1;
  if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
  sp.stepDates[pi]=now2();
  if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
  sp.stepBy[pi]='Muestras recibidas en SAP';
  if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
  sp._isoPasos[pi]=hoyIso;
  if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
  guardarEtapa(oid,'bodega');
  console.log('[bodega] paso "En sala de venta" cerrado por muestras recibidas');
  return true;
}

function _bodRepintar(oid){
  ['rec','sap','sala'].forEach(function(k){
    var c=document.getElementById('bod'+k+'-'+oid);
    if(!c) return;
    try{
      c.innerHTML = k==='rec' ? _bodRecibidoPanel(oid)
                  : k==='sap' ? _bodFaltantesPanel(oid)
                              : _bodSalaPanel(oid);
    }catch(e){ console.warn('bodega:',e); }
  });
}

// ── Disponible en SAP: lo facturado contra lo recibido ──
// Bodega reporta mercancía en mal estado. No sale de SAP: la ve al abrir
// el contenedor, así que se carga a mano.
// El estado del reclamo, con su historial y el botón de enviar.
// Antes solo se podía cambiar desde Alertas, y ahí no se ve el detalle.
function _reclEstadoBloque(oid){
  var d=_logLeer(oid);
  var env=_solEnvioLeer(oid,'reclamo');
  var re=d.reclamo||{};
  var estado=re.estado || (env?'enviado':'pendiente');
  var st=_RECL_ESTADOS[estado]||_RECL_ESTADOS.pendiente;
  var puede=CU && ['compras','importacion','gerencia','bodega'].indexOf(CU.role)>=0;

  var h='<div style="border:1px solid '+st.c+';border-radius:9px;overflow:hidden;margin-top:9px">'
    +'<div style="background:'+st.bg+';padding:9px 12px;display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
      +'<i class="ti '+st.i+'" style="color:'+st.c+'"></i>'
      +'<span style="font-size:11.5px;font-weight:700;color:'+st.c+'">Estado del reclamo</span>'
      +'<span style="flex:1"></span>'
      +(puede
        ? ('<select onclick="event.stopPropagation()" '
           +'onchange="_reclSetEstado(\''+oid+'\',this.value)" '
           +'style="padding:4px 10px;border:1px solid '+st.c+';border-radius:14px;font-size:11px;'
           +'font-weight:700;background:var(--surface-0);color:'+st.c+';cursor:pointer">'
           +Object.keys(_RECL_ESTADOS).map(function(k){
               return '<option value="'+k+'"'+((estado===k)?' selected':'')+'>'+_RECL_ESTADOS[k].t+'</option>';
             }).join('')
           +'</select>'
        // Anotar la respuesta del proveedor y borrar el reclamo si se creó
        // por error. Antes solo se podía cambiar el estado.
        +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px" '
          +'title="Anotar la respuesta del proveedor" '
          +'onclick="event.stopPropagation();_reclNota(&quot;'+_esc(String(r.oid))+'&quot;)">'
          +'<i class="ti ti-message-2"></i></button>'
        +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--t-rojo3)" '
          +'title="Borrar este reclamo" '
          +'onclick="event.stopPropagation();_reclBorrar(&quot;'+_esc(String(r.oid))+'&quot;)">'
          +'<i class="ti ti-trash"></i></button>')
        : ('<span style="font-size:11px;font-weight:700;color:'+st.c+'">'+st.t+'</span>'))
    +'</div>';

  // El historial de lo que fue pasando
  h+='<div style="padding:9px 12px;background:var(--surface-0);font-size:11px">';
  if(env){
    h+='<div style="margin-bottom:5px"><i class="ti ti-mail-check" style="color:var(--t-verde)"></i> '
      +'<b>Enviado</b> por '+_esc(env.por||'')+' · '+_esc(_fechaHora(env.fecha))
      +(env.para&&env.para.length?('<br><span style="color:var(--text-muted);margin-left:17px">A: '
        +_esc(env.para.join(', '))+'</span>'):'')+'</div>';
  } else {
    h+='<div style="margin-bottom:5px;color:var(--text-muted)">'
      +'<i class="ti ti-alert-circle" style="color:var(--t-ambar)"></i> Todavía no se envió el reclamo.</div>';
  }
  if(re.resuelto_en){
    h+='<div style="margin-bottom:5px"><i class="ti ti-circle-check" style="color:var(--t-verde)"></i> '
      +'<b>Resuelto</b> por '+_esc(re.resuelto_por||'')+' · '+_esc(_fechaHora(re.resuelto_en))+'</div>';
  }
  if(re.nota){
    h+='<div style="background:var(--surface-1);border-radius:7px;padding:7px 9px;margin-bottom:5px">'
      +'<b style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Cómo se resolvió</b><br>'
      +'<span style="white-space:pre-wrap">'+_esc(re.nota)+'</span></div>';
  }

  if(puede){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:7px">'
      +'<button class="btn bp" style="background:#991b1b;font-size:11px;padding:6px 12px" '
        +'onclick="event.stopPropagation();_reclamoModal(\''+oid+'\')">'
        +'<i class="ti ti-mail"></i> '+(env?'Volver a enviar':'Preparar reclamo al proveedor')+'</button>'
      +(estado!=='resuelto'
        ? ('<button class="btn bp" style="background:#166534;font-size:11px;padding:6px 12px" '
           +'onclick="event.stopPropagation();_reclSetEstado(\''+oid+'\',\'resuelto\')">'
           +'<i class="ti ti-circle-check"></i> Marcar como resuelto</button>')
        : ('<button class="btn bg2" style="font-size:11px;padding:6px 12px" '
           +'onclick="event.stopPropagation();_reclSetEstado(\''+oid+'\',\'enviado\')">'
           +'<i class="ti ti-arrow-back-up"></i> Reabrir el reclamo</button>'))
      +'</div>';
    if(estado!=='resuelto'){
      h+='<div style="font-size:10px;color:var(--text-muted);margin-top:5px">'
        +'Cuando el proveedor mande la nota de crédito, marcalo como resuelto '
        +'y anotá el número: sale del listado de reclamos abiertos.</div>';
    }
  }
  return h+'</div></div>';
}

function _bodDaniosPanel(oid){
  var d=_logLeer(oid);
  var lista=(d.danios&&d.danios.lista)||[];
  var puede=CU && ['bodega','importacion','gerencia','compras'].indexOf(CU.role)>=0;
  var total=lista.reduce(function(a,x){ return a+((Number(x.cantidad)||0)*(Number(x.precio)||0)); },0);

  var h='<div style="background:var(--surface-0);border:0.5px solid '
    +(lista.length?'#dc2626':'var(--border)')+';border-radius:9px;padding:11px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<i class="ti ti-alert-octagon" style="color:var(--t-rojo)"></i>'
      +'<span style="font-size:12px;font-weight:700;color:var(--t-rojo);flex:1">Mercancía en mal estado</span>'
      +(lista.length?('<span style="font-size:12px;font-weight:700;color:var(--t-rojo)">'+fmt(total)+'</span>'):'')
    +'</div>';

  if(lista.length){
    h+='<table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:8px">'
      +'<tr style="background:var(--surface-1)">'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Problema</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Cant.</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Precio</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Monto</th>'
      +(puede?'<th style="width:26px"></th>':'')+'</tr>';
    lista.forEach(function(x,i){
      h+='<tr style="border-top:0.5px solid var(--border)">'
        +'<td style="padding:4px 7px;font-family:monospace;font-size:10.5px">'+_esc(x.sku||'')+'</td>'
        +'<td style="padding:4px 7px">'+_esc(x.motivo||'')+'</td>'
        +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(x.cantidad)+'</td>'
        +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(x.precio)+'</td>'
        +'<td style="padding:4px 7px;text-align:right;font-weight:700;color:var(--t-rojo)">'
          +fmt((Number(x.cantidad)||0)*(Number(x.precio)||0))+'</td>'
        +(puede?('<td style="text-align:center"><span onclick="event.stopPropagation();_bodBorrarDanio(\''+oid+'\','+i+')" '
          +'style="color:var(--text-danger);cursor:pointer;font-weight:700">×</span></td>'):'')
        +'</tr>';
    });
    h+='</table>';
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:7px">'
      +'Si al abrir el contenedor hay mercancía rota, mojada o incompleta, cargala aquí '
      +'para sumarla al reclamo.</div>';
  }

  if(puede){
    h+='<button class="btn bg2" style="font-size:10.5px;padding:5px 11px" '
      +'onclick="event.stopPropagation();_bodAgregarDanio(\''+oid+'\')">'
      +'<i class="ti ti-plus"></i> Reportar mercancía dañada</button>';
  }
  return h+'</div>';
}

async function _bodAgregarDanio(oid){
  var sku=prompt('SKU del artículo dañado:','');
  if(sku===null || !String(sku).trim()) return;
  var motivo=prompt('¿Qué le pasó?\n\nPor ejemplo: cajas mojadas, producto roto, empaque abierto.','');
  if(motivo===null) return;
  var cantTxt=prompt('¿Cuántas unidades?','');
  if(cantTxt===null) return;
  var cant=parseFloat(String(cantTxt).replace(/,/g,''));
  if(isNaN(cant) || cant<=0){ showT('La cantidad no es válida'); return; }

  // El precio se busca en las líneas de la factura, si está
  var precio=0;
  var d=_logLeer(oid);
  ((d.entradas&&d.entradas.lista)||[]).forEach(function(e){
    (e.lineas||[]).forEach(function(l){
      if(String(l.sku||'').toUpperCase()===String(sku).trim().toUpperCase()){
        precio=Number(l.precio)||0;
      }
    });
  });
  if(!precio){
    var pTxt=prompt('Precio unitario (no se encontró en la factura):','');
    if(pTxt===null) return;
    precio=parseFloat(String(pTxt).replace(/,/g,''))||0;
  }

  d.danios=d.danios||{lista:[]};
  d.danios.lista.push({sku:String(sku).trim().toUpperCase(), motivo:String(motivo).trim(),
                       cantidad:cant, precio:precio,
                       por:(CU&&CU.name)||'', en:new Date().toISOString()});
  await _logGuardar(oid);
  showT('✓ Registrado');
  _bodRepintar(oid);
}

async function _bodBorrarDanio(oid, i){
  var d=_logLeer(oid);
  if(!d.danios || !d.danios.lista[i]) return;
  if(!confirm('¿Borrar este reporte?\n\n'+(d.danios.lista[i].sku||''))) return;
  d.danios.lista.splice(i,1);
  await _logGuardar(oid);
  _bodRepintar(oid);
}

function _bodFaltantesPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var lineas=[];
  ents.forEach(function(e){
    (e.lineas||[]).forEach(function(l){
      lineas.push(Object.assign({}, l, {factura:e.apri_numero, entrada:e.entrada}));
    });
  });

  var h=_bodEntradaCampo(oid);
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
    +'padding:11px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<i class="ti ti-package-import" style="color:var(--t-azul)"></i>'
      +'<span style="font-size:12px;font-weight:700;color:var(--t-azul);flex:1">Facturado contra recibido</span>'

    +'</div>';

  if(!lineas.length){
    return h+'<div style="font-size:11px;color:var(--text-muted)">'
      +'Se necesita traer la entrada desde SAP para comparar lo facturado con lo que llegó.</div></div>';
  }

  var faltantes=lineas.filter(function(l){ return (Number(l.cantidad_abierta)||0)>0; });
  var totalFact=lineas.reduce(function(a,l){ return a+(Number(l.total_linea)||0); },0);
  var totalFalta=faltantes.reduce(function(a,l){ return a+(Number(l.monto_faltante)||0); },0);
  var uFalta=faltantes.reduce(function(a,l){ return a+(Number(l.cantidad_abierta)||0); },0);

  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:9px">'
    +_costKpi('Líneas', String(lineas.length), '#0c447c')
    +_costKpi('Total facturado', fmt(totalFact), '#166534')
    +_costKpi('Líneas con faltante', String(faltantes.length), faltantes.length?'#991b1b':'#6b7280')
    +_costKpi('Unidades faltantes', _fmtN2(uFalta), faltantes.length?'#991b1b':'#6b7280')
    +_costKpi('Valor del faltante', fmt(totalFalta), faltantes.length?'#991b1b':'#6b7280')
    +'</div>';

  var hayDanios=((d.danios&&d.danios.lista)||[]).length>0;
  if(!faltantes.length && !hayDanios){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;'
      +'font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Llegó todo lo facturado. No hay cantidades abiertas.</div>';
    h+=_bodDaniosPanel(oid);
    return h+'</div>';
  }
  if(!faltantes.length){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;'
      +'font-size:11.5px;color:var(--t-verde);font-weight:600;margin-bottom:9px">'
      +'<i class="ti ti-circle-check"></i> Las cantidades llegaron completas.</div>'
      +_bodDaniosPanel(oid);
    h+=_reclEstadoBloque(oid);
    return h+'</div>';
  }

  h+='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden;margin-bottom:9px">'
    +'<div style="background:var(--pastel-error);padding:7px 11px;font-size:11.5px;font-weight:700;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> '+faltantes.length+' artículo(s) no llegaron completos</div>'
    +'<div style="max-height:320px;overflow:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0">'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Descripción</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Facturado</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Recibido</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Falta</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Precio</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Monto</th>'
    +'</tr></thead><tbody>';
  faltantes.forEach(function(l){
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:4px 7px;font-family:monospace;font-size:10.5px">'+_esc(l.sku||'')+'</td>'
      +'<td style="padding:4px 7px;max-width:230px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" '
        +'title="'+_esc(l.descripcion||'')+'">'+_esc(l.descripcion||'')+'</td>'
      +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(l.cantidad)+'</td>'
      +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(l.cantidad_recibida)+'</td>'
      +'<td style="padding:4px 7px;text-align:right;font-weight:700;color:var(--t-rojo)">'+_fmtN2(l.cantidad_abierta)+'</td>'
      +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(l.precio)+'</td>'
      +'<td style="padding:4px 7px;text-align:right;font-weight:700;color:var(--t-rojo)">'+fmt(l.monto_faltante)+'</td>'
    +'</tr>';
  });
  h+='<tr style="background:var(--surface-1);font-weight:800">'
    +'<td colspan="4" style="padding:6px 7px;text-align:right">TOTAL</td>'
    +'<td style="padding:6px 7px;text-align:right;color:var(--t-rojo)">'+_fmtN2(uFalta)+'</td>'
    +'<td></td>'
    +'<td style="padding:6px 7px;text-align:right;color:var(--t-rojo)">'+fmt(totalFalta)+'</td>'
    +'</tr></tbody></table></div></div>';

  h+=_bodDaniosPanel(oid);

  h+=_reclEstadoBloque(oid);
  return h+'</div>';
}

// ── En sala de venta: las muestras ──
function _bodSalaPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var e=ents[0]||{};
  var env=e.muestras_enviadas, rec=e.muestras_recibidas;

  var h=_bodEntradaCampo(oid);
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
    +'padding:11px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<i class="ti ti-box-seam" style="color:#3B6D11"></i>'
      +'<span style="font-size:12px;font-weight:700;color:#3B6D11;flex:1">Muestras de oficina</span>'

    +'</div>';

  if(!ents.length){
    return h+'<div style="font-size:11px;color:var(--text-muted)">'
      +'Se necesita traer la entrada desde SAP para ver las muestras.</div></div>';
  }

  h+='<div style="display:flex;gap:10px;flex-wrap:wrap">'
    +'<div style="flex:1;min-width:190px;background:var(--surface-1);border-radius:8px;padding:9px 11px">'
      +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:700;text-transform:uppercase;margin-bottom:3px">'
        +'<i class="ti ti-arrow-up-right" style="color:var(--t-azul)"></i> Muestras enviadas a oficina</div>'
      +'<div style="font-size:13px;font-weight:700;color:'+(env?'#0c447c':'var(--text-muted)')+'">'
        +_esc(env||'Sin registrar')+'</div></div>'
    +'<div style="flex:1;min-width:190px;background:var(--surface-1);border-radius:8px;padding:9px 11px">'
      +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:700;text-transform:uppercase;margin-bottom:3px">'
        +'<i class="ti ti-arrow-down-left" style="color:var(--t-verde)"></i> Muestras recibidas en oficina</div>'
      +'<div style="font-size:13px;font-weight:700;color:'+(rec?'#166534':'var(--text-muted)')+'">'
        +_esc(rec||'Sin registrar')+'</div></div>'
    +'</div>';

  if(!env && !rec){
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-top:7px">'
      +'Estos datos se cargan en SAP, en la factura de reserva de esta orden.</div>';
  }

  // Con las muestras recibidas el paso se da por terminado
  if(rec){
    var cerrado=false;
    try{ cerrado=_bodSalaCerrar(oid); }catch(e){}
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;'
      +'padding:8px 11px;margin-top:8px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Muestras recibidas en oficina: el paso queda completado.</div>';
  }
  return h+'</div>';
}

// ── Reclamo al proveedor por mercancía faltante ──
async function _reclamoModal(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var lineas=[];
  ents.forEach(function(e){
    (e.lineas||[]).forEach(function(l){
      if((Number(l.cantidad_abierta)||0)>0){
        lineas.push(Object.assign({}, l, {factura:e.apri_numero, fecha:e.fecha}));
      }
    });
  });
  // La mercancía dañada se reclama igual que la faltante
  ((d.danios&&d.danios.lista)||[]).forEach(function(x){
    lineas.push({
      sku:x.sku, descripcion:(x.motivo?('DAMAGED · '+x.motivo):'DAMAGED'),
      cantidad:Number(x.cantidad)||0, cantidad_recibida:0,
      cantidad_abierta:Number(x.cantidad)||0, precio:Number(x.precio)||0,
      monto_faltante:(Number(x.cantidad)||0)*(Number(x.precio)||0),
      _danio:true
    });
  });
  if(!lineas.length){ showT('No hay faltantes ni daños que reclamar'); return; }

  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var e0=ents[0]||{};
  var dept=dat.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  window._mailAdj=[];
  window._reclamoCtx={oid:oid, lineas:lineas};

  // Las compradoras del departamento, marcadas por defecto
  var comprasDept=(USERS||[]).filter(function(u){
    return _esComprasU(u) && u.email && dept && String(u.dept||'')===String(dept);
  });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado = comprasDept.length
      ? comprasDept.some(function(z){ return z.id===u.id; })
      : (_esComprasU(u));
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;'
      +'border:0.5px solid '+(marcado?'#991b1b':'var(--border)')+';border-radius:8px;cursor:pointer;'
      +'font-size:12px;background:'+(marcado?'#FEF2F2':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
        +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
  }).join('');

  var totalU=lineas.reduce(function(a,l){ return a+(Number(l.cantidad_abierta)||0); },0);
  var totalM=lineas.reduce(function(a,l){ return a+(Number(l.monto_faltante)||0); },0);
  var po=dat.po||dat.numAtCard||ordenTxt;

  // La tabla, alineada para que se lea bien en el correo
  var anchoSku=Math.max(6, Math.max.apply(null, lineas.map(function(l){ return String(l.sku||'').length; })));
  var anchoDes=Math.min(40, Math.max(12, Math.max.apply(null, lineas.map(function(l){ return String(l.descripcion||'').length; }))));
  function col(t,n,der){
    t=String(t==null?'':t);
    if(t.length>n) t=t.slice(0,n-1)+'…';
    return der ? (' '.repeat(n-t.length)+t) : (t+' '.repeat(n-t.length));
  }
  var tabla=col('SKU',anchoSku)+'  '+col('DESCRIPTION',anchoDes)+'  '
    +col('INVOICED',10,1)+'  '+col('RECEIVED',10,1)+'  '+col('MISSING',9,1)+'  '+col('AMOUNT',13,1)+'\n'
    +'-'.repeat(anchoSku+anchoDes+52)+'\n'
    +lineas.map(function(l){
        return col(l.sku,anchoSku)+'  '+col(l.descripcion,anchoDes)+'  '
          +col(_fmtN2(l.cantidad),10,1)+'  '+col(_fmtN2(l.cantidad_recibida),10,1)+'  '
          +col(_fmtN2(l.cantidad_abierta),9,1)+'  '+col('US$ '+_fmtN2(l.monto_faltante),13,1);
      }).join('\n');

  var hayDanio=lineas.some(function(l){ return l._danio; });
  var asunto=(hayDanio?'Missing / Damaged Merchandise Claim - PO #'
                      :'Missing Merchandise Claim - PO #')+po+' / Credit Note Request';
  var cuerpo='Dear Supplier,\n\n'
    +'After reviewing the merchandise received for PO #'+po+', we found some missing items '
    +'when comparing the quantities on your invoice with the quantities we actually received.\n\n'
    +'Order Information:\n'
    +'  * Supplier: '+(dat.proveedor||'')+'\n'
    +'  * PO Number: '+po+'\n'
    +'  * Invoice Number: '+(e0.apri_numero||'')+'\n'
    +'  * Invoice Date: '+(e0.fecha?_fmtFechaCorta(e0.fecha):'')+'\n\n'
    +(lineas.some(function(l){ return l._danio; })
      ? 'Missing and Damaged Merchandise:\n\n'
      : 'Missing Merchandise:\n\n')
    +tabla+'\n\n'
    +'Total Missing Units: '+_fmtN2(totalU)+'\n'
    +'Total Value of Missing Merchandise: US$ '+_fmtN2(totalM)+'\n\n'
    +'Please review the above information and issue a CREDIT NOTE for the total amount of '
    +'US$ '+_fmtN2(totalM)+' corresponding to the missing merchandise.\n\n'
    +'Please send us the official credit note document as soon as possible. This credit will '
    +'remain on our account and will be used toward our future orders with you.\n\n'
    +'Please give priority to this claim and confirm once the credit note has been issued.\n\n'
    +'Thank you for your prompt attention and cooperation.\n\n'
    +'Best regards,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalReclamo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalReclamo';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:820px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-rojo)">'
        +'<i class="ti ti-alert-triangle"></i> Reclamo por mercancía faltante</div>'
      +'<button onclick="_reclamoCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:9px;padding:9px 11px;'
      +'margin-bottom:12px;font-size:11.5px;color:var(--t-rojo)">'
      +'<b>'+lineas.length+' artículo(s)</b> · '+_fmtN2(totalU)+' unidades · '
      +'<b>US$ '+_fmtN2(totalM)+'</b> a reclamar</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA'
      +(comprasDept.length?(' <span style="color:var(--t-rojo);font-weight:600">· compras de '+_esc(dL(dept))+' marcadas</span>'):'')
      +'</div>'
    +'<div id="reclamo-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="reclamo-extra" placeholder="Otros correos, separados por coma" '
      +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="reclamo-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="reclamo-cuerpo" rows="20" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);'
      +'border-radius:8px;font-size:11.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);'
      +'font-family:monospace;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'
      +'Puedes adjuntar las fotos de la descarga como respaldo del reclamo.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_reclamoCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="reclamo-btn" style="background:#991b1b" onclick="_reclamoEnviar()">'
        +'<i class="ti ti-send"></i> Enviar reclamo</button>'
    +'</div></div>';
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
}

function _reclamoCerrar(){
  var m=document.getElementById('modalReclamo'); if(m) m.remove();
  window._mailAdj=[]; window._reclamoCtx=null;
}

async function _reclamoEnviar(){
  var ctx=window._reclamoCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('reclamo-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('reclamo-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('reclamo-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('reclamo-cuerpo')||{}).value||'';
  var btn=document.getElementById('reclamo-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Reclamo por faltantes · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }
    return;
  }

  // Desde aquí, PASE LO QUE PASE el botón se libera. Es la única forma de
  // garantizar que no se quede en "Enviando…": cualquier paso de los de
  // abajo puede fallar según desde dónde se abriera el reclamo.
  try{
  var totalM=(ctx.lineas||[]).reduce(function(a,l){ return a+(Number(l.monto_faltante)||0); },0);
  // Esto NO estaba protegido: si fallaba —por ejemplo al reclamar desde una
  // orden abierta, donde el identificador es la referencia y no un id de
  // orden— la función se cortaba aquí. El correo salía, pero el botón se
  // quedaba en "Enviando…" para siempre.
  try{
    _solEnvioGuardar(oid, 'reclamo', {
      fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
      asunto:asunto, cuerpo:cuerpo, monto:totalM, lineas:(ctx.lineas||[]).length,
      estado:'enviado'
    });
  }catch(e){ console.warn('[reclamo] guardar envío:', e); }

  // También en memoria, de inmediato. Así el reclamo aparece en las alertas
  // sin esperar a la tabla: si falta la columna o la tabla, al menos quien
  // lo envió lo ve al momento.
  try{
    window._reclEstados=window._reclEstados||{};
    window._reclEstados[String(oid)]=Object.assign(
      window._reclEstados[String(oid)]||{}, {
        estado:'enviado', enviado_en:new Date().toISOString(),
        enviado_por:(CU&&CU.name)||'', monto:totalM,
        lineas:(ctx.lineas||[]).length, para:todos.join(', '),
        proveedor:ctx.proveedor||'', dept:ctx.dept||''
      });
    console.log('[reclamo] '+oid+' · '+(ctx.lineas||[]).length+' línea(s) · '
      +totalM.toFixed(2)+' · registrado en las alertas');
  }catch(e){ console.warn('[reclamo] memoria:', e); }
  // El estado va a su tabla, para que lo vea cualquiera y no dependa
  // del navegador de quien envió el correo.
  var ahoraIso=new Date().toISOString();
  try{
    await _reclGuardarEstado(oid, {
      estado:'enviado', enviado_en:ahoraIso, enviado_por:(CU&&CU.name)||'',
      monto:totalM, lineas:(ctx.lineas||[]).length,
      para:todos.join(', '),
      proveedor:ctx.proveedor||'', dept:ctx.dept||''
    });
  }catch(e){}
  try{
    var dRe=_logLeer(oid);
    dRe.reclamo=dRe.reclamo||{};
    dRe.reclamo.estado='enviado';
    dRe.reclamo.fecha=ahoraIso;
    dRe.reclamo.por=(CU&&CU.name)||'';
    dRe.reclamo.monto=totalM;
    await _logGuardar(oid);
  }catch(e){}

  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Bodega & Venta', paso:_PASO_BOD_SAP,
      texto:'Reclamo por mercancía faltante · '+(ctx.lineas||[]).length+' artículo(s) · US$ '+_fmtN2(totalM),
      etiqueta:'Reclamo al proveedor'
    });
  }catch(e){}

  // El botón vuelve a su estado ANTES de cerrar: si algo falla al cerrar o
  // al repintar, no se queda en "Enviando…" para siempre, que es lo que
  // pasaba al reclamar desde una orden abierta.
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }

  // El reclamo se abre desde dos sitios y cada uno tiene su ventana:
  // la de faltantes de una entrada, y la de una orden abierta. Se cierra la
  // que corresponda, y el repintado va protegido.
  try{
    if(ctx._desdeOC){ CM(); }
    else { _reclamoCerrar(); }
  }catch(e){ try{ CM(); }catch(e2){} }

  try{ _accRegistrar('accion','Envió reclamo al proveedor', oid); }catch(e){}
  showT('✓ Reclamo enviado a '+todos.length+' destinatario(s)');

  try{
    if(ctx._desdeOC){
      window._ocPend=null; window._ocPendPidiendo=0;   // se recarga el estado
      _ocPendCargar(true).then(function(){
        try{ if(PG==='ocpend') rOcPend(); else rDash(); }catch(e){}
      });
      _reclCargarEstados().then(function(){ try{ rAlertas(); }catch(e){} })
        .catch(function(){});
    } else {
      _bodRepintar(oid);
    }
    // El panel de reclamos de la pantalla de Alertas, venga de donde venga
    try{ if(PG==='alertas') rAlertas(); }catch(e){}
  }catch(e){ console.warn('[reclamo] repintar:', e); }
  }catch(errFin){
    console.error('[reclamo] falló después de encolar el correo:', errFin);
    showT('El correo salió, pero no se pudo registrar el reclamo. '
      +'Mira la consola.', 7000);
  }finally{
    var b2=document.getElementById('reclamo-btn');
    if(b2){ b2.disabled=false; b2.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }
  }
}

// Cierra un modal con la tecla Esc, y limpia el escuchador al salir
function _modalEsc(ov){
  if(!ov) return;
  var f=function(ev){
    if(ev.key!=='Escape') return;
    // Solo el modal de más arriba responde a Esc
    var todos=document.querySelectorAll('[data-modal-esc="1"]');
    if(todos.length && todos[todos.length-1]!==ov) return;
    document.removeEventListener('keydown', f);
    if(ov.parentNode) ov.remove();
  };
  ov.setAttribute('data-modal-esc','1');
  document.addEventListener('keydown', f);
  // Si lo cierra un botón, el escuchador se quita solo
  var obs=new MutationObserver(function(){
    if(!document.body.contains(ov)){
      document.removeEventListener('keydown', f);
      obs.disconnect();
    }
  });
  obs.observe(document.body, {childList:true, subtree:true});
}

// ═══════════════════════════════════════════════════════════════════════════
//  REPORTES
//  Un lugar con los reportes del portal. El primero es el estado de las
//  entradas: dónde está cada embarque según las fechas cargadas en SAP.
// ═══════════════════════════════════════════════════════════════════════════
var _REPORTES = [
  {k:'entradas', t:'Estado de las entradas', i:'ti-truck-delivery', c:'#0c447c',
   d:'Dónde está cada embarque: en puerto, en rampa, descargando, en trámite o ya actualizado.'}
];
window._repActual='entradas';

// Las etapas por las que pasa una entrada, en orden. La última fecha con
// dato marca dónde está: si tiene fecha de rampa pero no de descarga,
// entonces está en rampa.
var _ENT_ETAPAS = [
  {k:'anunciada',  t:'Anunciada',     campo:null,                  c:'#6b7280', i:'ti-file-text',
   d:'La factura existe pero todavía no llegó el barco'},
  {k:'puerto',     t:'En puerto',     campo:'eta',                 c:'#0c447c', i:'ti-anchor',
   d:'El barco llegó a puerto'},
  {k:'rampa',      t:'En rampa',      campo:'fecha_rampa',         c:'#5B21B6', i:'ti-truck-loading',
   d:'El contenedor salió del puerto'},
  {k:'descarga',   t:'Descargado',    campo:'fecha_descarga',      c:'#B45309', i:'ti-package-import',
   d:'Se descargó la mercancía'},
  {k:'devuelto',   t:'Contenedor devuelto', campo:'fecha_devuelto', c:'#7C3D12', i:'ti-arrow-back-up',
   d:'El contenedor vacío volvió a la naviera'},
  {k:'tramite',    t:'En trámite',    campo:'fecha_tramite',       c:'#0891B2', i:'ti-file-search',
   d:'En trámite aduanero'},
  {k:'actualizada',t:'Actualizada',   campo:'fecha_actualizacion', c:'#166534', i:'ti-circle-check',
   d:'Ya está en el inventario'}
];

// En qué etapa está una entrada
function _entEtapaDe(e){
  var ult=_ENT_ETAPAS[0];
  for(var i=1;i<_ENT_ETAPAS.length;i++){
    var c=_ENT_ETAPAS[i].campo;
    if(c && e[c]) ult=_ENT_ETAPAS[i];
  }
  // El estatus de bodega manda si dice que ya se actualizó
  if(String(e.estatus_bodega||'').toUpperCase().indexOf('ACTUALIZ')>=0){
    ult=_ENT_ETAPAS[_ENT_ETAPAS.length-1];
  }
  return ult;
}

// Días detenida en la etapa actual
function _entDiasEn(e, etapa){
  var f=etapa.campo?e[etapa.campo]:(e.fecha||'');
  if(!f) return null;
  var d=_repParseFecha(f);
  if(!d) return null;
  return Math.floor((Date.now()-d.getTime())/86400000);
}

// Todas las entradas conocidas, de todas las órdenes
function _repEntradasTodas(){
  var out=[];
  Object.keys(window._logData||{}).forEach(function(oid){
    var d=window._logData[oid];
    var lista=(d && d.entradas && d.entradas.lista)||[];
    lista.forEach(function(e){
      var dat={};
      try{ dat=_solPagoDatosOrden(oid)||{}; }catch(x){}
      var dept=dat.dept||'';
      if(!dept){
        var o=(typeof orders!=='undefined')?orders.find(function(z){return String(z.id)===String(oid);}):null;
        if(o) dept=o.dept||'';
        if(!dept){
          var p=(window._pendSAP||[]).find(function(z){
            return String(z.dkc)===String(oid)||String(z.num_orden)===String(oid); });
          if(p) dept=p.dept||'';
        }
      }
      out.push(Object.assign({}, e, {
        _oid:oid, _dept:dept||'otros',
        _proveedor:e.proveedor||dat.proveedor||''
      }));
    });
  });
  return out;
}

async function rReportes(){
  var box=document.getElementById('page-reportes'); if(!box) return;

  var h='<div style="font-size:13px;font-weight:600;margin-bottom:3px">'
    +'<i class="ti ti-report" style="color:var(--text-accent)"></i> Reportes</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">'
    +'Vistas de conjunto para seguir el trabajo sin entrar orden por orden.</div>';

  // Los reportes disponibles
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:14px">';
  _REPORTES.forEach(function(r){
    var on=(window._repActual===r.k);
    h+='<button onclick="_repIr(\''+r.k+'\')" style="border:1px solid '+(on?r.c:'var(--border)')+';'
      +'background:'+(on?r.c:'var(--surface-1)')+';color:'+(on?'#fff':r.c)+';'
      +'border-radius:9px;padding:8px 14px;font-size:12px;font-weight:600;cursor:pointer;'
      +'text-align:left;max-width:280px">'
      +'<i class="ti '+r.i+'"></i> '+_esc(r.t)
      +'<div style="font-size:10px;font-weight:400;opacity:.85;margin-top:2px">'+_esc(r.d)+'</div>'
      +'</button>';
  });
  h+='</div>';

  h+='<div id="rep-cuerpo"></div>';
  box.innerHTML=h;

  // Los datos pueden no estar cargados todavía
  if(!window._reclCargado){
    var c=document.getElementById('rep-cuerpo');
    if(c) c.innerHTML='<div style="padding:20px;text-align:center;color:var(--text-muted);font-size:12px">'
      +'<span class="ai-ring g"></span> Cargando las entradas…</div>';
    try{ await _reclPrecargar(); }catch(e){}
  }
  _repPintar();
}

function _repIr(k){
  window._repActual=k;
  rReportes();
}

function _repPintar(){
  var c=document.getElementById('rep-cuerpo'); if(!c) return;
  try{
    if(window._repActual==='entradas') c.innerHTML=_repEntradasVista();
    else c.innerHTML='<div style="color:var(--text-muted);font-size:12px">Reporte no disponible.</div>';
  }catch(e){
    c.innerHTML='<div style="color:var(--text-danger);font-size:12px">No se pudo armar el reporte: '
      +_esc(e.message||e)+'</div>';
    console.error('[reportes]', e);
  }
}

// ── Reporte: estado de las entradas ──
function _repEntradasVista(){
  var todas=_repEntradasTodas();

  // Compras ve su departamento; el resto ve todo
  if(CU && _esCompras() && _deptAcotado()){
    todas=todas.filter(function(e){ return _deptPermitido(e._dept); });
  }

  var fEtapa=window._repFiltroEtapa||'todas';
  var fDept=window._repFiltroDept||'todos';

  // Se clasifica cada una
  todas.forEach(function(e){
    e._etapa=_entEtapaDe(e);
    e._dias=_entDiasEn(e, e._etapa);
  });

  if(!todas.length){
    return '<div style="background:var(--surface-1);border-radius:10px;padding:24px;text-align:center;'
      +'color:var(--text-muted);font-size:12px">'
      +'<i class="ti ti-inbox" style="font-size:26px;display:block;margin-bottom:8px"></i>'
      +'No hay entradas cargadas todavía.<br>'
      +'<span style="font-size:11px">Se cargan al consultar SAP desde la etapa de Logística o Bodega.</span>'
      +'</div>';
  }

  // Conteo por etapa, para los botones
  var porEtapa={};
  todas.forEach(function(e){ porEtapa[e._etapa.k]=(porEtapa[e._etapa.k]||0)+1; });

  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    +'<span style="font-size:11px;color:var(--text-muted);font-weight:600">Etapa</span>'
    +'<button onclick="_repSetEtapa(\'' + 'todas' + '\')" style="border:1px solid '
      +((fEtapa==='todas')?'#0c447c':'var(--border)')+';background:'
      +((fEtapa==='todas')?'#0c447c':'var(--surface-1)')+';color:'
      +((fEtapa==='todas')?'#fff':'#0c447c')+';border-radius:20px;padding:4px 12px;'
      +'font-size:11px;font-weight:600;cursor:pointer">Todas '+todas.length+'</button>';
  _ENT_ETAPAS.forEach(function(et){
    var n=porEtapa[et.k]||0;
    if(!n) return;
    var on=(fEtapa===et.k);
    h+='<button onclick="_repSetEtapa(\''+et.k+'\')" title="'+_esc(et.d)+'" '
      +'style="border:1px solid '+(on?et.c:'var(--border)')+';background:'+(on?et.c:'var(--surface-1)')
      +';color:'+(on?'#fff':et.c)+';border-radius:20px;padding:4px 12px;font-size:11px;'
      +'font-weight:600;cursor:pointer;white-space:nowrap">'
      +'<i class="ti '+et.i+'" style="font-size:11px"></i> '+_esc(et.t)+' '+n+'</button>';
  });
  h+='</div>';

  // Filtro por departamento
  var deptos={};
  todas.forEach(function(e){ deptos[e._dept]=(deptos[e._dept]||0)+1; });
  if(Object.keys(deptos).length>1){
    h+='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
      +'<span style="font-size:11px;color:var(--text-muted);font-weight:600">Departamento</span>'
      +'<button onclick="_repSetDept(\'' + 'todos' + '\')" style="border:1px solid '
        +((fDept==='todos')?'#7C3D12':'var(--border)')+';background:'
        +((fDept==='todos')?'#7C3D12':'var(--surface-1)')+';color:'
        +((fDept==='todos')?'#fff':'#7C3D12')+';border-radius:20px;padding:4px 11px;'
        +'font-size:11px;font-weight:600;cursor:pointer">Todos</button>';
    Object.keys(deptos).sort().forEach(function(d){
      var on=(fDept===d);
      h+='<button onclick="_repSetDept(\''+d+'\')" style="border:1px solid '
        +(on?'#7C3D12':'var(--border)')+';background:'+(on?'#7C3D12':'var(--surface-1)')
        +';color:'+(on?'#fff':'#7C3D12')+';border-radius:20px;padding:4px 11px;font-size:11px;'
        +'font-weight:600;cursor:pointer">'+(EMOJIS2[d]||'')+' '+_esc(dL(d))+' '+deptos[d]+'</button>';
    });
    h+='</div>';
  }

  // Se aplican los filtros
  var lista=todas.filter(function(e){
    if(fEtapa!=='todas' && e._etapa.k!==fEtapa) return false;
    if(fDept!=='todos' && String(e._dept)!==fDept) return false;
    return true;
  });

  // De la más detenida a la más reciente
  lista.sort(function(a,b){ return (b._dias||0)-(a._dias||0); });

  h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:7px">'
    +lista.length+' entrada(s)'+(fEtapa!=='todas'?(' en '+(_ENT_ETAPAS.find(function(x){return x.k===fEtapa;})||{}).t):'')
    +' · ordenadas por tiempo detenido</div>';

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">';
  lista.forEach(function(e,i){
    var et=e._etapa;
    var col=(e._dias!=null && e._dias>=15) ? '#991b1b'
          : (e._dias!=null && e._dias>=7) ? '#B45309' : 'var(--text-muted)';
    h+='<div onclick="_repIrEntrada(\''+_esc(String(e._oid).replace(/\x27/g,''))+'\')" '
      +'style="padding:9px 13px;'+(i?'border-top:0.5px solid var(--border);':'')
      +'background:var(--surface-0);cursor:pointer;display:flex;align-items:center;gap:11px;flex-wrap:wrap">'
      // La etapa, como distintivo
      +'<div style="min-width:118px">'
        +'<span style="display:inline-flex;align-items:center;gap:5px;background:'+et.c
        +';color:#fff;border-radius:14px;padding:3px 10px;font-size:10.5px;font-weight:700">'
        +'<i class="ti '+et.i+'" style="font-size:11px"></i>'+_esc(et.t)+'</span></div>'
      +'<div style="flex:1;min-width:180px">'
        +'<div style="font-size:12px;font-weight:600">Entrada '+_esc(e.entrada||'—')
          +'<span style="font-weight:400;color:var(--text-muted)"> · '+_esc(e._proveedor||'')+'</span></div>'
        +'<div style="font-size:10.5px;color:var(--text-muted)">'
          +'Orden '+_esc(e._oid)+' · '+(EMOJIS2[e._dept]||'')+' '+_esc(dL(e._dept))
          +(e.bl?(' · B/L '+_esc(e.bl)):'')
          +(e.naviera?(' · '+_esc(e.naviera)):'')
          +(e.num_contenedores?(' · '+_esc(e.num_contenedores)+' cont.'):'')
        +'</div></div>'
      +'<div style="text-align:right;min-width:92px">'
        +(e._dias!=null
          ? ('<div style="font-size:15px;font-weight:800;color:'+col+';line-height:1.1">'+e._dias+'</div>'
             +'<div style="font-size:8px;color:var(--text-muted);text-transform:uppercase">días aquí</div>')
          : '<div style="font-size:11px;color:var(--text-muted)">sin fecha</div>')
      +'</div>'
      +'<div style="min-width:86px;text-align:right">'
        +(e.eta?('<div style="font-size:10px;color:var(--text-muted)">ETA</div>'
                +'<div style="font-size:11.5px;font-weight:600">'+_esc(_fmtFechaCorta(e.eta))+'</div>'):'')
      +'</div>'
      +'</div>';
  });
  h+='</div>';

  // Resumen del recorrido
  h+='<div style="margin-top:14px;background:var(--surface-1);border-radius:10px;padding:11px 13px">'
    +'<div style="font-size:10.5px;font-weight:700;color:var(--text-secondary);margin-bottom:7px">'
    +'RECORRIDO DE UNA ENTRADA</div>'
    +'<div style="display:flex;gap:5px;flex-wrap:wrap;align-items:center">';
  _ENT_ETAPAS.forEach(function(et,i){
    h+=(i?'<i class="ti ti-chevron-right" style="color:var(--text-muted);font-size:11px"></i>':'')
      +'<span title="'+_esc(et.d)+'" style="font-size:10.5px;color:'+et.c+';font-weight:600;'
      +'background:var(--surface-0);border:0.5px solid '+et.c+'44;border-radius:12px;padding:2px 9px">'
      +_esc(et.t)+((porEtapa[et.k])?(' '+porEtapa[et.k]):'')+'</span>';
  });
  h+='</div></div>';
  return h;
}

function _repSetEtapa(k){ window._repFiltroEtapa=k; _repPintar(); }
function _repSetDept(k){ window._repFiltroDept=k; _repPintar(); }

// Abre la orden en la etapa de logística
function _repIrEntrada(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='logistica'; });
  window._abrirEtapa={oid:String(oid), key:'logistica', paso:2};
  try{ _solPagoAbrir(oid); }catch(e){ try{ openDetail(oid); }catch(e2){} }
  try{ _abrirEtapaPedida(0); }catch(e){}
}

function _entPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var puede=_puedeAduana();

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
    +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i>'
    +'<span style="font-size:12px;font-weight:700;color:var(--t-azul);flex:1">Entrada de mercancía en SAP</span>'
    +(puede?('<button class="btn bg2" style="padding:4px 11px;font-size:10.5px" onclick="event.stopPropagation();_entTraer(\'' + oid + '\')">'
      +'<i class="ti ti-database-import"></i> '+(ents.length?'Actualizar':'Traer de SAP')+'</button>'):'')
    +'</div>';

  if(!ents.length){
    h+='<div style="font-size:11px;color:var(--text-muted)">'
      +'Todavía no se trajeron los datos. Son los que carga contabilidad en la '
      +'factura de compra: número de entrada, B/L, naviera y las fechas del proceso.</div>'
      +'<div id="entcarga-'+oid+'" style="margin-top:7px"></div>';
    return h+'</div>';
  }

  h+='<div id="entcarga-'+oid+'"></div>';
  ents.forEach(function(e, i){
    h+=_entFicha(e, ents.length>1?(i+1):0);
  });
  if(d.entradas&&d.entradas.en){
    h+='<div style="font-size:10px;color:var(--text-muted);margin-top:6px">'
      +'Traído de SAP el '+_esc(_fechaHora(d.entradas.en))+'</div>';
  }
  return h+'</div>';
}

// Un contenedor real son 4 letras + 7 dígitos (MEDU7469395). Lo que no
// cumple ese formato suele ser un sello o una referencia, y no debería
// mostrarse como contenedor.
function _esContenedor(c){
  return /^[A-Z]{4}\s?\d{6,7}$/.test(String(c||'').trim().toUpperCase().replace(/[\s-]/g,''));
}

function _entDato(etiqueta, valor, color){
  var v=(valor==null||String(valor).trim()==='')?'—':String(valor);
  var vacio=(v==='—');
  return '<div style="min-width:118px">'
    +'<div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase">'+_esc(etiqueta)+'</div>'
    +'<div style="font-size:12px;font-weight:'+(vacio?'400':'600')+';color:'
      +(vacio?'var(--text-muted)':(color||'var(--text-primary)'))+'">'+_esc(v)+'</div></div>';
}

function _entFicha(e, nro){
  var h='<div style="border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;'
    +'margin-bottom:8px;background:var(--surface-1)">';

  // Cabecera: entrada, factura y proveedor
  h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:9px;'
    +'padding-bottom:8px;border-bottom:0.5px solid var(--border)">'
    +(nro?('<span style="font-size:10px;font-weight:700;background:#0c447c;color:#fff;'
      +'border-radius:10px;padding:1px 8px">'+nro+'</span>'):'')
    +'<span style="font-size:14px;font-weight:800;color:var(--t-azul)">Entrada '+_esc(e.entrada||'—')+'</span>'
    +(e.apri_numero?('<span style="font-size:11px;color:var(--text-muted)">Factura '+_esc(e.apri_numero)+'</span>'):'')
    +(e.fecha?('<span style="font-size:11px;color:var(--text-muted)">'+_esc(_fmtFechaCorta(e.fecha))+'</span>'):'')
    +'<span style="flex:1"></span>'
    +(e.total?('<span style="font-size:13px;font-weight:700;color:var(--t-verde)">'+fmt(e.total)+'</span>'):'')
    +'</div>';

  if(e.proveedor){
    h+='<div style="font-size:11.5px;margin-bottom:8px">'
      +'<b>'+_esc(e.proveedor_codigo||'')+'</b> '+_esc(e.proveedor)
      +(e.ref_proveedor?('<span style="color:var(--text-muted)"> · ref. '+_esc(e.ref_proveedor)+'</span>'):'')
      +'</div>';
  }

  // Embarque
  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:9px">'
    +_entDato('B/L', e.bl, '#0c447c')
    +_entDato('Naviera', e.naviera)
    +(e.barco?_entDato('Barco', e.barco):'')
    +_entDato('Contenedores', e.num_contenedores)
    +_entDato('Tipo', e.tipo_contenedor)
    +'</div>';

  if(e.series_contenedores){
    // Se separan los contenedores de lo que no lo es: en el mismo campo
    // vienen sellos y referencias, y mezclarlos confunde al leer la ficha.
    var piezas=String(e.series_contenedores).split(/[\/,;]/)
      .map(function(c){ return c.trim(); }).filter(Boolean);
    var conts=piezas.filter(_esContenedor);
    var otros=piezas.filter(function(c){ return !_esContenedor(c); });

    h+='<div style="margin-bottom:9px">'
      +'<div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase;margin-bottom:3px">'
        +'Series de contenedores'+(conts.length?(' ('+conts.length+')'):'')+'</div>'
      +'<div style="display:flex;gap:5px;flex-wrap:wrap">'
      +(conts.length
        ? conts.map(function(c){
            return '<span style="font-family:monospace;font-size:11px;background:var(--surface-0);'
              +'border:0.5px solid var(--border);border-radius:12px;padding:2px 9px">'+_esc(c)+'</span>';
          }).join('')
        : '<span style="font-size:11px;color:var(--text-muted)">Sin contenedores con formato válido</span>')
      +'</div>';

    if(otros.length){
      h+='<div style="margin-top:6px">'
        +'<div style="font-size:9px;color:var(--t-marron);font-weight:600;text-transform:uppercase;margin-bottom:3px">'
          +'Otros valores del campo U_Contenedor</div>'
        +'<div style="display:flex;gap:5px;flex-wrap:wrap">'
        +otros.map(function(c){
            return '<span title="Viene en el campo U_Contenedor de la factura '
              +_esc(e.apri_numero||'')+', junto al contenedor. No tiene formato de contenedor." '
              +'style="font-family:monospace;font-size:10.5px;background:var(--pastel-naranja);'
              +'border:0.5px solid #E9C08A;color:var(--t-marron);border-radius:12px;padding:2px 9px">'
              +_esc(c)+'</span>';
          }).join('')
        +'</div>'
        +'<div style="font-size:9.5px;color:var(--text-muted);margin-top:3px">'
          +'Está guardado en <b>U_Contenedor</b> de la factura '+_esc(e.apri_numero||'')
          +'. Si en SAP no aparece, puede estar en otro campo del mismo documento.</div>'
        +'</div>';
    }
    // El otro campo de contenedores, si trae algo distinto
    if(e.series_alterna && String(e.series_alterna).trim()
       && String(e.series_alterna).trim()!==String(e.series_contenedores||'').trim()){
      h+='<div style="margin-top:6px">'
        +'<div style="font-size:9px;color:var(--t-azul);font-weight:600;text-transform:uppercase;margin-bottom:3px">'
          +'Campo U_Contenedor_serie</div>'
        +'<div style="display:flex;gap:5px;flex-wrap:wrap">'
        +String(e.series_alterna).split(/[\/,;]/).map(function(c){
            c=c.trim();
            if(!c) return '';
            return '<span style="font-family:monospace;font-size:10.5px;background:var(--surface-0);'
              +'border:0.5px solid #85B7EB;color:var(--t-azul);border-radius:12px;padding:2px 9px">'+_esc(c)+'</span>';
          }).join('')
        +'</div></div>';
    }
    h+='</div>';
  }

  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:9px">'
    +_entDato('Puerto de embarque', e.puerto_embarque)
    +(e.pais?_entDato('País', e.pais):'')
    +_entDato('Descripción de carga', e.descripcion_carga)
    +(e.terminos?_entDato('Términos', e.terminos):'')
    +'</div>';

  // Volúmenes, pesos y los costos estimados de la importación
  var med=[
    (Number(e.volumen)?_entDato('Volumen', _fmtN2(e.volumen)):''),
    (Number(e.peso)?_entDato('Peso', _fmtN2(e.peso)):''),
    (Number(e.volumen_estimado)?_entDato('Volumen estimado', _fmtN2(e.volumen_estimado)):''),
    (Number(e.flete_estimado)?_entDato('Flete estimado', fmt(e.flete_estimado), '#7C3D12'):''),
    (Number(e.gasto_estimado)?_entDato('Gasto estimado', fmt(e.gasto_estimado), '#7C3D12'):'')
  ].filter(Boolean);
  if(med.length){
    h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:9px">'+med.join('')+'</div>';
  }

  // Las fechas del proceso, en orden
  var fechas=[
    ['ETA',            e.eta,                 '#0c447c'],
    ['En rampa',       e.fecha_rampa,         ''],
    ['Descarga',       e.fecha_descarga,      ''],
    ['Devuelto',       e.fecha_devuelto,      ''],
    ['Almacenaje',     e.fecha_almacenaje,    ''],
    ['Retención',      e.fecha_retencion,     '#B45309'],
    ['Documento',      e.fecha_doc,           ''],
    ['Trámite',        e.fecha_tramite,       ''],
    ['Entrega',        e.fecha_entrega,       ''],
    ['Actualización',  e.fecha_actualizacion, '#166534']
  ].filter(function(f){ return f[1]; });

  if(fechas.length){
    h+='<div style="border-top:0.5px solid var(--border);padding-top:8px">'
      +'<div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase;margin-bottom:5px">Fechas del proceso</div>'
      +'<div style="display:flex;gap:12px;flex-wrap:wrap">'
      +fechas.map(function(f){ return _entDato(f[0], _fmtFechaCorta(f[1]), f[2]); }).join('')
      +'</div></div>';
  }

  // Días libres de almacenaje y retención: si se pasan, hay recargo
  if(e.dias_libres_almacenaje || e.dias_libres_retencion){
    h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-top:8px;padding-top:8px;'
      +'border-top:0.5px solid var(--border)">'
      +(e.dias_libres_almacenaje?_entDato('Días libres almacenaje', e.dias_libres_almacenaje, '#B45309'):'')
      +(e.dias_libres_retencion?_entDato('Días libres retención', e.dias_libres_retencion, '#B45309'):'')
      +'</div>';
  }

  if(e.estatus_bodega){
    h+='<div style="margin-top:8px">'
      +'<span style="font-size:10.5px;font-weight:700;background:var(--pastel-ok);color:var(--t-verde);'
      +'border-radius:10px;padding:3px 10px">'+_esc(e.estatus_bodega)+'</span></div>';
  }

  // Los comentarios que dejan importación y bodega en SAP
  [['Importación', e.comentario_importacion, '#0c447c'],
   ['Bodega',      e.comentario_bodega,      '#7C3D12']].forEach(function(c){
    if(!c[1]) return;
    h+='<div style="margin-top:7px;font-size:11px;background:var(--surface-0);'
      +'border-left:3px solid '+c[2]+';border-radius:0 7px 7px 0;padding:6px 10px">'
      +'<b style="color:'+c[2]+';font-size:9.5px;text-transform:uppercase">'+c[0]+'</b><br>'
      +'<span style="white-space:pre-wrap">'+_esc(c[1])+'</span></div>';
  });
  if(e.comentarios){
    h+='<div style="margin-top:8px;font-size:11px;color:var(--text-secondary);'
      +'background:var(--surface-0);border-radius:7px;padding:7px 9px;white-space:pre-wrap">'
      +_esc(e.comentarios)+'</div>';
  }
  return h+'</div>';
}

// Pide los datos a SAP a través del worker
// El aviso de carga aparece en varios sitios a la vez (cabecera, subetapas,
// modal) y todos usan el mismo id. Al terminar hay que limpiarlos TODOS:
// antes se limpiaba solo el primero y los demás seguían girando.
function _entAviso(oid, html){
  var els=document.querySelectorAll('[id="entcarga-'+oid+'"]');
  for(var i=0;i<els.length;i++) els[i].innerHTML=html||'';
}

async function _entTraer(oid){
  var d=_logLeer(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
  _entAviso(oid, '<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> Consultando SAP…</span>');

  var fid=null;
  try{
    var r=await fetch(SB+'/rest/v1/entradas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({docnum:String(oid), entrada:entrada,
                           pedido_por:(CU&&CU.name)||'', estado:'pendiente',
                           creado_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      _entAviso(oid, '<div style="font-size:11px;color:var(--text-danger)">'
        +(/does not exist|Could not find the table/i.test(t)
          ? 'Falta la tabla entradas_queue en Supabase (script entradas_sap.sql).'
          : ('No se pudo pedir la información (error '+r.status+').'))+'</div>');
      return;
    }
    var f=await r.json();
    fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  }catch(e){
    _entAviso(oid, '<div style="font-size:11px;color:var(--text-danger)">Error de conexión: '+_esc(e.message||e)+'</div>');
    return;
  }
  if(!fid){ _entAviso(oid, ''); return; }
  _entEsperar(oid, fid, 0);
}

function _entEsperar(oid, fid, intento){
  setTimeout(async function(){
    var fila=null;
    try{
      var r=await fetch(SB+'/rest/v1/entradas_queue?select=*&id=eq.'+fid+'&limit=1',{headers:SBH});
      if(r.ok){ var a=await r.json(); fila=(Array.isArray(a)&&a[0])?a[0]:null; }
    }catch(e){}
    if(!fila || fila.estado==='pendiente' || fila.estado==='procesando'){
      if(intento<50){
        var seg=Math.round((0.9+Math.min(intento,6)*1.2+Math.max(0,intento-6)*2.5));
        _entAviso(oid, '<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
          +'Consultando SAP… ('+seg+'s)</span>');
        return _entEsperar(oid, fid, intento+1);
      }
      _entAviso(oid, '<div style="font-size:11px;color:var(--t-ambar)">SAP no respondió. Revisa que el worker esté corriendo.</div>');
      return;
    }
    if(fila.estado==='error'){
      // Si ya había datos, se conservan: un fallo al actualizar no debe
      // hacer parecer que la entrada no existe.
      var d0=_logLeer(oid);
      var teniaDatos=!!(d0.entradas && (d0.entradas.lista||[]).length);
      _entAviso(oid, '<div style="background:'+(teniaDatos?'#FEF3E8':'#FEF2F2')+';border:1px solid '
        +(teniaDatos?'#E9C08A':'#dc2626')+';border-radius:8px;padding:8px 11px;font-size:11.5px;color:'
        +(teniaDatos?'#7C3D12':'#991b1b')+'"><i class="ti ti-alert-triangle"></i> '
        +(teniaDatos
          ? 'No se pudo actualizar, pero se mantienen los datos traídos antes.'
          : _esc(fila.detalle||'No se encontró la información'))
        +'</div>');
      return;
    }
    var datos=fila.datos;
    if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
    var lista=(datos&&datos.entradas)||[];
    if(!lista.length){
      _entAviso(oid, '<div style="font-size:11px;color:var(--t-ambar)">SAP respondió pero sin datos.</div>');
      return;
    }
    var d=_logLeer(oid);
    d.entradas={lista:lista, en:new Date().toISOString(), por:(CU&&CU.name)||''};

    // Lo que sirva se copia a los campos de logística, si están vacíos
    var e=lista[0];
    d.arrival=d.arrival||{}; d.bl=d.bl||{}; d.booking=d.booking||{};
    if(e.entrada && !d.arrival.entrada) d.arrival.entrada=e.entrada;
    if(e.bl){
      if(!d.bl.numero)  d.bl.numero=e.bl;
      if(!d.arrival.bl) d.arrival.bl=e.bl;
    }
    if(e.naviera && !d.booking.naviera) d.booking.naviera=String(e.naviera).toUpperCase();
    if(e.eta && !d.arrival.fecha_llegada) d.arrival.fecha_llegada=_fmtFechaCorta(e.eta);
    if(e.puerto_embarque && !d.bl.origen) d.bl.origen=e.puerto_embarque;
    // Los contenedores que vengan en la serie
    if(e.series_contenedores){
      d.contenedores=d.contenedores||[];
      var descartados=[];
      String(e.series_contenedores).split(/[\/,;]/).forEach(function(c){
        c=c.trim().toUpperCase();
        if(!c) return;
        // Solo lo que tenga formato de contenedor: antes entraban sellos
        // y referencias como si fueran contenedores.
        if(!_esContenedor(c)){ descartados.push(c); return; }
        if(d.contenedores.some(function(z){ return String(z.numero||'').toUpperCase()===c; })) return;
        d.contenedores.push({numero:c, tipo:String(e.tipo_contenedor||'').toUpperCase().trim()});
      });
      if(descartados.length){
        console.warn('[entradas] no tienen formato de contenedor:', descartados);
      }
    }
    await _logGuardar(oid);
    // Se apaga el aviso ANTES de repintar, para que no quede ninguno girando
    _entAviso(oid, '');
    showT('✓ '+lista.length+' entrada(s) traída(s) de SAP');
    _entRepintar(oid);
    try{ _logRepintar(oid); }catch(e2){}
    // Si la ventana está abierta, se refresca con los datos nuevos
    try{
      if(document.getElementById('modalEnt')){
        document.getElementById('modalEnt').remove();
        _entVerModal(oid);
      }
    }catch(e3){}
    // Se repintan SOLO los paneles afectados. Antes se llamaba a openDetail(),
    // que reconstruye la orden entera y sacaba al usuario del panel donde
    // estaba trabajando.
    try{ _bodRepintar(oid); }catch(e4){}
    try{
      // El resumen de la cabecera, sin tocar el resto
      var cab=document.querySelector('.mb');
      if(cab){
        var viejo=cab.querySelector('[data-entresumen="1"]');
        if(viejo) viejo.outerHTML=_entResumenSeguro(oid);
      }
    }catch(e5){}
    // El primer intento espera poco y luego se va espaciando: la consulta
    // suele resolverse en 1 o 2 segundos y no tiene sentido esperar 3.
  }, intento===0?900:(intento<6?1200:2500));
}

function _entRepintar(oid){
  var c=document.getElementById('entpanel-'+oid);
  if(c) c.innerHTML=_entPanel(oid);
}

function _logPanelArrival(oid){
  var d=_logLeer(oid), a=d.arrival||{}, bk=d.booking||{};
  var sk=_subKeyLog(_PASO_ARRIVAL);
  var docs=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var completo=!!(a.fecha_llegada && a.bl);

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(completo?'sem-g':(docs.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-flag"></i> Aviso de llegada</div></div>';

  h+=_logZonaDocs(oid, sk, 'AVISO DE LLEGADA', 'Adjunta el arrival notice para que la AI lo lea', '#7C3D12');

  if(docs.length && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_logLeerIA(\'' + oid + '\',\'arrival\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y verificar contra el booking</button>'
      +'<div id="logia-arrival-'+oid+'" style="margin-bottom:9px"></div>';
  }

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'arrival','bl','B/L No.', a.bl, 160)
    +_logCampo(oid,'arrival','vessel','Vessel No.', a.vessel, 150)
    +_logCampo(oid,'arrival','viaje','Voyage', a.viaje, 120)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'arrival','shipper','Shipper', a.shipper, 200)
    +_logCampo(oid,'arrival','consignee','Consignee', a.consignee, 200)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'arrival','fecha_salida','ETD', a.fecha_salida, 120)
    +_logCampo(oid,'arrival','fecha_llegada','ETA', a.fecha_llegada, 120)
    +'</div>';

  // El número de entrada lo escribe importación a mano y es obligatorio
  // para pedir el pago del flete.
  var falta=!String(a.entrada||'').trim();
  h+='<div style="background:'+(falta?'#FEF2F2':'var(--surface-0)')+';border:1px solid '
    +(falta?'#dc2626':'var(--border)')+';border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10px;font-weight:700;color:'+(falta?'#991b1b':'#7C3D12')+';margin-bottom:4px">'
      +'NÚMERO DE ENTRADA <span style="color:var(--t-rojo2)">*</span>'
      +'<span style="font-weight:400;color:var(--text-muted);text-transform:none"> · lo escribe importación</span></div>'
    +'<input value="'+_esc(a.entrada||'')+'" placeholder="Escribe el número de entrada" onclick="event.stopPropagation()" '
    +'onchange="_logSetCampo(\'' + oid + '\',\'arrival\',\'entrada\',this.value);_logRepintar(\'' + oid + '\')" '
    +'style="width:100%;max-width:280px;padding:6px 9px;border:0.5px solid '+(falta?'#dc2626':'var(--border)')
    +';border-radius:6px;font-size:13px;font-weight:600;background:var(--surface-0);color:var(--text-primary)">'
    +(falta?('<div style="font-size:10.5px;color:var(--t-rojo);margin-top:4px">'
      +'<i class="ti ti-alert-circle"></i> Hace falta para solicitar el pago del flete: va en el cuerpo del correo.</div>'):'')
    +'</div>';

  h+=_trackBarra(oid,'arrival');
  h+=_logContenedores(oid, true);
  if(a.fecha_llegada||a.bl||a.entrada||(a.tarifas||[]).length){
    h+='<div style="display:flex;justify-content:flex-end;margin-bottom:6px">'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_logVaciarDatos(\'' + oid + '\',\'arrival\',\'aviso de llegada\')" title="Borra los datos, deja los documentos"><i class="ti ti-eraser"></i> Vaciar datos</button></div>';
  }
  if((a.tarifas||[]).length){
    h+='<div style="font-size:10.5px;font-weight:700;color:var(--t-marron);margin-bottom:4px">CARGOS DEL AVISO</div>';
    h+=_logTablaTarifas(a.tarifas, true, oid, 'arrival');
    h+=_logComparar(bk.tarifas, a.tarifas, 'booking', 'aviso de llegada');
  }

  // Solicitud de pago del flete a contabilidad
  var env=_solEnvioLeer(oid,'flete');
  if(env){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Solicitud de pago de flete enviada</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">'
        +'Por <b>'+_esc(env.por||'')+'</b> · '+_esc(_fechaHora(env.fecha))
        +(env.para&&env.para.length?('<br>A: '+_esc(env.para.join(', '))):'')
        +(env.adjuntos&&env.adjuntos.length?('<br>'+env.adjuntos.length+' adjunto(s)'):'')
      +'</div>';
    if(env.cuerpo){
      h+='<details style="margin-top:5px"><summary style="font-size:10.5px;color:var(--t-verde);cursor:pointer;font-weight:600">Ver el correo enviado</summary>'
        +'<div style="font-size:11px;color:var(--t-verde);white-space:pre-wrap;background:var(--surface-0);border-radius:7px;padding:8px 10px;margin-top:5px;max-height:260px;overflow-y:auto">'+_esc(env.cuerpo)+'</div></details>';
    }
    h+='</div>';
  }
  if(_puedeAduana()){
    var sinEntrada=!String(a.entrada||'').trim();
    h+='<div style="margin-top:9px">'
      +'<button class="btn bp" style="background:'+(sinEntrada?'#9ca3af':'#7C3D12')+';font-size:11.5px;padding:7px 13px"'
      +(sinEntrada?' title="Primero escribe el número de entrada"':'')
      +' onclick="event.stopPropagation();_fleteModal(\'' + oid + '\')">'
      +'<i class="ti ti-cash"></i> '+(env?'Volver a enviar la solicitud':'Solicitar el pago del flete')+'</button>'
      +(sinEntrada?('<div style="font-size:10.5px;color:var(--t-rojo);margin-top:4px"><i class="ti ti-alert-circle"></i> Falta el número de entrada.</div>'):'')
      +'</div>';
  }
  // Los datos que carga contabilidad en SAP
  h+='<div id="entpanel-'+oid+'">';
  try{ h+=_entPanel(oid); }catch(e){ console.warn('entradas:',e); }
  h+='</div>';

  h+=_btnCerrarPaso(oid, 'logistica', _PASO_ARRIVAL,
      {falta: env ? '' : 'Todavía no se pidió el pago del flete. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// Zona de documentos de una subetapa
function _logZonaDocs(oid, sk, titulo, ayuda, color){
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    files.forEach(function(a,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti ti-file" style="color:'+color+'"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
        +'<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_logBorrarDoc(\'' + oid + '\',\'' + sk + '\','+i+')"><i class="ti ti-trash"></i></button>'
        +'</div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,image/*" style="display:none" onchange="_logSubirDoc(\'' + oid + '\',\'' + sk + '\',this.files)"></label>';
  return h+'</div>';
}

async function _logSubirDoc(oid, sk, files){
  if(!files||!files.length) return;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sk, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sk, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sk]) window._atts[oid+sk]=[];
      window._atts[oid+sk].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir logistica:',e); }
  }
  showT('✓ Adjuntado. Pulsa "Leer con AI" para llenar los datos.');
  _logRepintar(oid);
}

// Borrar el documento borra TODA la subetapa: los datos que la AI sacó de él
// dejan de tener respaldo, así que se limpian juntos.
async function _logBorrarDoc(oid, sk, i){
  var a=(window._atts&&window._atts[oid+sk])?window._atts[oid+sk][i]:null;
  if(!a) return;

  // ¿A qué subetapa pertenece este documento?
  var mapa=[[_subKeyLog(_PASO_BOOKING),'booking','Booking'],
            [_subKeyLog(_PASO_BL),'bl','Bill of Lading'],
            [_subKeyLog(_PASO_ARRIVAL),'arrival','Aviso de llegada']];
  var cual=mapa.find(function(m){ return m[0]===sk; });
  if(!cual){
    if(!confirm('¿Borrar "'+(a.name||'')+'"?')) return;
    await _borrarArchivoStorage(a.url, a.id);
    window._atts[oid+sk].splice(i,1);
    showT('Archivo eliminado');
    _logRepintar(oid);
    return;
  }

  var donde=cual[1], nombre=cual[2];
  var d=_logLeer(oid);
  var dat=d[donde]||{};
  var campos=Object.keys(dat).filter(function(k){
    return k!=='tarifas' && String(dat[k]||'').trim();
  }).length;
  var nTar=(dat.tarifas||[]).length;
  var otros=((window._atts&&window._atts[oid+sk])||[]).length-1;

  var msg='¿Está seguro de que desea borrar el documento del '+nombre+'?\n\n'
    +'Archivo: '+(a.name||'')+'\n\n';
  if(campos||nTar){
    msg+='Se borrará TODA la subetapa:\n';
    if(campos) msg+='  · '+campos+' dato(s) cargado(s)\n';
    if(nTar)   msg+='  · '+nTar+' tarifa(s)\n';
    if(otros>0) msg+='  · '+otros+' documento(s) más de esta subetapa\n';
    msg+='\nLos contenedores NO se borran: son de la orden, no de esta subetapa.\n';
  }
  msg+='\nEsta acción no se puede deshacer.';
  if(!confirm(msg)) return;

  // Segunda confirmación cuando hay datos de por medio
  if(campos||nTar){
    if(!confirm('Confirmá una vez más.\n\nSe va a vaciar la subetapa "'+nombre+'" por completo.\n\n¿Continuar?')) return;
  }

  showT('Borrando la subetapa…');
  // Todos los documentos de esa subetapa
  var docs=((window._atts&&window._atts[oid+sk])||[]).slice();
  for(var k=0;k<docs.length;k++){
    await _borrarArchivoStorage(docs[k].url, docs[k].id);
  }
  window._atts[oid+sk]=[];

  // Y los datos que salieron de él
  d[donde]={};
  await _logGuardar(oid);

  // El paso vuelve a quedar pendiente
  try{
    var idx=_pasoIdxLog(cual===mapa[0]?_PASO_BOOKING:(cual===mapa[1]?_PASO_BL:_PASO_ARRIVAL));
    initP(oid);
    var sp=stageProgress[oid].logistica;
    if(idx>=0 && (sp.stepIdx||0)>idx){
      sp.stepIdx=idx;
      if(sp.stepDates) sp.stepDates[idx]='';
      guardarEtapa(oid,'logistica');
    }
  }catch(e){}

  showT('✓ Subetapa "'+nombre+'" vaciada. Puedes volver a cargarla.');
  _logRepintar(oid);
  try{ openDetail(oid); }catch(e){}
}

// Vacía una subetapa sin borrar los documentos
async function _logVaciarDatos(oid, donde, nombre){
  var d=_logLeer(oid);
  var dat=d[donde]||{};
  var campos=Object.keys(dat).filter(function(k){ return k!=='tarifas' && String(dat[k]||'').trim(); }).length;
  var nTar=(dat.tarifas||[]).length;
  if(!campos && !nTar){ showT('No hay datos que borrar'); return; }
  if(!confirm('¿Borrar los datos del '+nombre+'?\n\n'
    +'  · '+campos+' dato(s)\n  · '+nTar+' tarifa(s)\n\n'
    +'Los documentos adjuntos se mantienen: puedes volver a leerlos con AI.\n\n'
    +'Esta acción no se puede deshacer.')) return;
  d[donde]={};
  await _logGuardar(oid);
  showT('✓ Datos del '+nombre+' borrados');
  _logRepintar(oid);
}

// ── Comparación de montos entre documentos ──
function _logComparar(tarBase, tarNueva, nomBase, nomNueva){
  if(!(tarBase||[]).length || !(tarNueva||[]).length) return '';
  var a=_logTotales(tarBase), b=_logTotales(tarNueva);
  var difs=[];
  if(Math.abs(a.kcc-b.kcc)>0.01){
    difs.push({q:'Total que paga Kennedy', a:fmt(a.kcc), b:fmt(b.kcc), d:fmt(Math.abs(a.kcc-b.kcc))});
  }
  Object.keys(a.monedas).concat(Object.keys(b.monedas)).forEach(function(m){
    if(m==='USD'||m==='US$'||m==='$') return;
    var va=a.monedas[m]||0, vb=b.monedas[m]||0;
    if(Math.abs(va-vb)>0.01 && !difs.some(function(x){ return x.q.indexOf(m)>=0; })){
      difs.push({q:'Total en '+m+' (proveedor)', a:_fmtN2(va)+' '+m, b:_fmtN2(vb)+' '+m, d:_fmtN2(Math.abs(va-vb))+' '+m});
    }
  });
  // Conceptos que aparecen en uno y no en el otro
  function clave(x){ return String(x.concepto||'').toUpperCase().replace(/\s+/g,' ').trim(); }
  var enBase={}, enNueva={};
  (tarBase||[]).forEach(function(x){ enBase[clave(x)]=x; });
  (tarNueva||[]).forEach(function(x){ enNueva[clave(x)]=x; });
  Object.keys(enBase).forEach(function(k){
    if(!enNueva[k]) difs.push({q:k, a:_fmtN2(enBase[k].monto)+' '+(enBase[k].moneda||''), b:'no aparece', d:''});
    else if(Math.abs((Number(enBase[k].monto)||0)-(Number(enNueva[k].monto)||0))>0.01){
      difs.push({q:k, a:_fmtN2(enBase[k].monto)+' '+(enBase[k].moneda||''),
                 b:_fmtN2(enNueva[k].monto)+' '+(enNueva[k].moneda||''), d:''});
    }
  });
  Object.keys(enNueva).forEach(function(k){
    if(!enBase[k]) difs.push({q:k, a:'no aparece', b:_fmtN2(enNueva[k].monto)+' '+(enNueva[k].moneda||''), d:''});
  });

  if(!difs.length){
    return '<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Los montos coinciden con el '+_esc(nomBase)+'.</div>';
  }
  var h='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden">'
    +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:700;color:var(--t-rojo)">'
    +'<i class="ti ti-alert-triangle"></i> '+difs.length+' diferencia(s) entre el '+_esc(nomBase)+' y el '+_esc(nomNueva)+'</div>';
  difs.forEach(function(x){
    h+='<div style="padding:7px 11px;border-top:0.5px solid var(--border);background:var(--surface-0)">'
      +'<div style="font-size:11.5px;font-weight:600">'+_esc(x.q)+'</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:3px;font-size:11px">'
        +'<span style="flex:1;min-width:120px;background:#E6F7F1;border-radius:6px;padding:3px 7px"><b style="color:var(--t-verde2)">'+_esc(nomBase)+':</b> '+_esc(x.a)+'</span>'
        +'<span style="flex:1;min-width:120px;background:var(--pastel-azul);border-radius:6px;padding:3px 7px"><b style="color:var(--t-azul)">'+_esc(nomNueva)+':</b> '+_esc(x.b)+'</span>'
      +'</div>'
      +(x.d?('<div style="font-size:11px;color:var(--t-rojo);margin-top:2px">Diferencia: <b>'+_esc(x.d)+'</b></div>'):'')
      +'</div>';
  });
  return h+'</div>';
}

// ── Lectura con AI de booking, B/L y aviso de llegada ──
async function _logLeerIA(oid, tipo){
  var nombres={booking:_PASO_BOOKING, bl:_PASO_BL, arrival:_PASO_ARRIVAL};
  var sk=_subKeyLog(nombres[tipo]);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var cont=document.getElementById('logia-'+tipo+'-'+oid);
  if(!files.length){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">No hay documentos adjuntos.</div>';
    return;
  }
  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo el documento…</span>';

  // Cualquier formato: PDF, imagen, Excel o texto
  var contenido=[], puestos=0, notas=[];
  for(var i=0;i<files.length && puestos<5;i++){
    if(!files[i].url) continue;
    var prep=await _iaDesdeStorage(files[i].url, files[i].name||('doc_'+(i+1)), 7);
    if(!prep){ notas.push((files[i].name||'archivo')+': no se pudo abrir'); continue; }
    contenido.push({type:'text', text:'ARCHIVO: '+(files[i].name||'')});
    prep.bloques.forEach(function(b){ contenido.push(b); });
    if(prep.nota) notas.push(prep.nota);
    puestos++;
  }
  if(!puestos){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">No se pudo leer ningún archivo.'
      +(notas.length?('<br>'+_esc(notas.join(' · '))):'')+'</div>';
    return;
  }
  contenido.push({type:'text', text:_logPrompt(tipo)});

  try{
    var obj=await _iaJSON(contenido, 4000);
    var d=_logLeer(oid);
    d[tipo]=d[tipo]||{};
    var puestas=[];

    function set(clave, valor){
      if(valor==null || String(valor).trim()==='') return;
      d[tipo][clave]=String(valor).trim();
      puestas.push(clave);
    }
    set('numero', obj.numero);
    set('naviera', obj.naviera);
    set('service_type', obj.service_type);
    set('service_contract', obj.service_contract);
    set('vessel', obj.vessel);
    set('origen', obj.origen);
    set('destino', obj.destino);
    set('fecha_salida', obj.fecha_salida);
    set('fecha_llegada', obj.fecha_llegada);
    set('shipper', obj.shipper);
    set('consignee', obj.consignee);
    set('viaje', obj.viaje);
    // El número de entrada NO lo llena la AI: lo escribe importación a mano,
    // porque se asigna en destino y no viene en el documento.
    if(tipo==='arrival') set('bl', obj.bl||obj.numero);

    // Contenedores: se suman los que no estaban
    var nuevos=0;
    if(Array.isArray(obj.contenedores)){
      d.contenedores=d.contenedores||[];
      obj.contenedores.forEach(function(c){
        var num=String((typeof c==='string'?c:(c.numero||c.number||''))||'').toUpperCase().trim();
        var tip=String((c&&(c.tipo||c.type||c.size))||'').toUpperCase().trim();
        // En el booking el contenedor todavía NO tiene número: solo dice
        // «Quantity 1 · 40 DRY». Antes se descartaba por no tener número y
        // la orden quedaba con 0 contenedores. Ahora entra con su tipo y el
        // número se rellena cuando llegue el BL.
        if(!num){
          if(!tip) return;
          d.contenedores.push({numero:'', tipo:tip, sello:'', _sinNumero:true});
          nuevos++;
          return;
        }
        if(d.contenedores.some(function(z){ return String(z.numero||'').toUpperCase()===num; })) return;
        // Si ya había uno sin número y del mismo tipo, se le pone el número
        // en vez de duplicar la línea
        var hueco=d.contenedores.filter(function(z){
          return !String(z.numero||'').trim()
            && (!tip || String(z.tipo||'').toUpperCase()===tip); })[0];
        if(hueco){ hueco.numero=num; hueco._sinNumero=false; nuevos++; return; }
        d.contenedores.push({numero:num,
                             tipo:String((c&&c.tipo)||'').toUpperCase().trim(),
                             sello:String((c&&(c.sello||c.seal))||'').toUpperCase().trim()});
        nuevos++;
      });
    }

    // Tarifas
    var nTar=0;
    if(Array.isArray(obj.tarifas) && obj.tarifas.length){
      d[tipo].tarifas=obj.tarifas.map(function(t){
        return {concepto:String(t.concepto||'').trim(),
                monto:Number(t.monto)||0,
                moneda:String(t.moneda||'').toUpperCase().trim()};
      }).filter(function(t){ return t.concepto || t.monto; });
      nTar=d[tipo].tarifas.length;
    }

    await _logGuardar(oid);
    _iaMarcarRevisado(oid, nombres[tipo]);
    _logRepintar(oid);

    // Resumen de lo que encontró
    var tot=_logTotales(d[tipo].tarifas);
    var h='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
      +'<div style="font-weight:700"><i class="ti ti-circle-check"></i> Documento leído</div>'
      +'<div style="margin-top:3px">'
        +(puestas.length?(puestas.length+' dato(s) completados'):'sin datos nuevos')
        +(nuevos?(' · '+nuevos+' contenedor(es)'):'')
        +(nTar?(' · '+nTar+' cargo(s): Kennedy '+fmt(tot.kcc)
                +(tot.prov?(' / proveedor '+Object.keys(tot.monedas).filter(function(m){return !(m==='USD'||m==='US$'||m==='$');})
                    .map(function(m){ return _fmtN2(tot.monedas[m])+' '+m; }).join(' · ')):'')):'')
      +'</div>';
    if(obj.nota) h+='<div style="margin-top:3px;font-style:italic">'+_esc(obj.nota)+'</div>';
    if(notas.length) h+='<div style="margin-top:3px;color:var(--t-ambar)">'+_esc(notas.join(' · '))+'</div>';
    h+='</div>';
    if(cont) cont.innerHTML=h;

    // Al leer el B/L o el aviso, se avisa si los montos no cuadran
    if(tipo!=='booking'){
      var difs=_logHayDiferencias(d.booking.tarifas, d[tipo].tarifas);
      if(difs){
        showT('⚠ Los montos del '+(tipo==='bl'?'B/L':'aviso de llegada')+' no coinciden con el booking');
        try{ await _logAvisarDiferencia(oid, tipo, difs); }catch(e){}
      }
    }
  }catch(e){
    console.error('leer logistica:',e);
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">No se pudo leer: '+_esc(e.message||String(e))+'</div>';
  }
}

// ¿Hay diferencias de monto entre dos juegos de tarifas?
function _logHayDiferencias(tarBase, tarNueva){
  if(!(tarBase||[]).length || !(tarNueva||[]).length) return 0;
  var a=_logTotales(tarBase), b=_logTotales(tarNueva);
  var n=0;
  if(Math.abs(a.kcc-b.kcc)>0.01) n++;
  Object.keys(a.monedas).forEach(function(m){
    if(m==='USD'||m==='US$'||m==='$') return;
    if(Math.abs((a.monedas[m]||0)-(b.monedas[m]||0))>0.01) n++;
  });
  return n;
}

// Aviso a importación y gerencia cuando los montos no cuadran
async function _logAvisarDiferencia(oid, tipo, cuantas){
  var d=_logLeer(oid);
  var a=_logTotales(d.booking.tarifas), b=_logTotales(d[tipo].tarifas);
  var quien=(tipo==='bl')?'B/L':'aviso de llegada';
  var texto='Los montos del '+quien+' no coinciden con el booking: '
    +'Kennedy pagaría '+fmt(b.kcc)+' y el booking decía '+fmt(a.kcc)+'.';
  var destinos=(USERS||[]).filter(function(u){
    return (u.role==='importacion' || u.role==='gerencia') && u.id!==((CU&&CU.id)||'');
  });
  if(!destinos.length) return;
  await _menNotificar(destinos, {
    docnum:oid, contexto:'etapa', etapa:'Logística', texto:texto,
    etiqueta:'Logística — diferencia de montos',
    paso:(tipo==='bl')?_PASO_BL:_PASO_ARRIVAL
  });
}

// El prompt de cada documento
function _logPrompt(tipo){
  var comun='IDIOMA: el documento puede venir en ingles, chino, espanol u otro. Reconoce los campos '
    +'aunque esten en otro idioma y devolve los valores tal como figuran. Si un dato NO aparece, '
    +'deja "" o []. Nunca inventes.\n\n'
    +'CONTENEDORES: traelos TODOS, cada uno con su numero, su tipo (40HQ, 20GP, 40GP...) y su '
    +'SELLO (Seal No., Seal, precinto, 铅封号). El sello suele ir al lado del numero de contenedor.\n\n'
    +'RATE / TARIFAS, muy importante:\n'
    +'- Sacá TODOS los cargos con su concepto, su monto y su MONEDA.\n'
    +'- La moneda define quien paga: los cargos en USD los paga Kennedy y los que estan en otra '
    +'moneda (CNY, RMB, EUR...) los paga el proveedor. Por eso hay que registrar bien la moneda.\n'
    +'- Si un cargo no dice moneda pero el documento tiene una moneda principal, usa esa.\n'
    +'- Los montos van como numero, sin simbolos ni separadores de miles.\n'
    +'- Las fechas van en formato DD/MM/AAAA.\n\n';

  if(tipo==='booking'){
    return 'Sos el analista de importaciones de KENNEDY CENTER CORP. Lee el BOOKING adjunto '
      +'(y el tarifario, si viene).\n\n'+comun
      +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
      +'{"numero":"","shipper":"","consignee":"","service_type":"","service_contract":"","naviera":"",'
      +'"origen":"","destino":"","fecha_salida":"","fecha_llegada":"",'
      +'"contenedores":[{"numero":"","tipo":"","sello":""}],'
      +'"tarifas":[{"concepto":"","monto":0,"moneda":""}],"nota":""}\n\n'
      +'QUE ES CADA CAMPO:\n'
      +'- "numero": Booking No. (Booking Number, Booking Ref, No. de reserva, 订舱号).\n'
      +'- "shipper": el embarcador, quien envia (Shipper, Consignor, 发货人).\n'
      +'- "consignee": el consignatario (Consignee, 收货人).\n'
      +'- "service_type": Service Type (CY/CY, CY/DOOR, FCL/FCL, LCL, Door to Door...).\n'
      +'- "service_contract": SERVICE CONTRACT, el numero del contrato de servicio con la naviera. '
      +'Puede figurar como Service Contract No., S/C No., SC No., Contract No., o en chino como '
      +'服务合同, 服务合同号 o 合同号. Suele ser un codigo alfanumerico. Si no aparece, deja "".\n'
      +'- "naviera": la linea naviera (MAERSK, CMA CGM, MSC, EVERGREEN, COSCO...).\n'
      +'- "origen": Origin (Port of Loading, POL, puerto o ciudad de salida, 起运港).\n'
      +'- "destino": Destination (Port of Discharge, POD, puerto o ciudad de llegada, 目的港).\n'
      +'- "fecha_salida": ETD (Estimated Time of Departure, Sailing Date, fecha de zarpe).\n'
      +'- "fecha_llegada": ETA (Estimated Time of Arrival, fecha estimada de llegada).\n'
      +'- "contenedores": MUY IMPORTANTE. Mira la tabla "Equipment" (Container, '
      +'Equipment Details). Si dice Quantity 1 y Size/Type "40 DRY", devuelve UN objeto '
      +'con tipo "40 DRY"; si dice 2, devuelve DOS. El numero del contenedor puede no '
      +'estar todavia: deja "numero" vacio pero DEVUELVE el objeto con su tipo. Nunca '
      +'devuelvas la lista vacia si la tabla Equipment dice que hay contenedores.\\n'
      +'- Para la ETA, en los booking de Maersk mira el "Intended Transport Plan": la '
      +'buena es la de la ULTIMA fila, la del destino final.\\n'
      +'- "tarifas": el RATE con todos sus cargos.';
  }
  if(tipo==='bl'){
    return 'Sos el analista de importaciones de KENNEDY CENTER CORP. Lee el BILL OF LADING (B/L).\n\n'+comun
      +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
      +'{"numero":"","shipper":"","consignee":"","vessel":"","viaje":"",'
      +'"origen":"","destino":"","fecha_salida":"",'
      +'"contenedores":[{"numero":"","tipo":"","sello":""}],'
      +'"tarifas":[{"concepto":"","monto":0,"moneda":""}],"nota":""}\n\n'
      +'QUE ES CADA CAMPO:\n'
      +'- "numero": B/L No. (Bill of Lading Number, documento de transporte, 提单号).\n'
      +'- "shipper": el embarcador (Shipper, Consignor, 发货人).\n'
      +'- "consignee": el consignatario (Consignee, 收货人).\n'
      +'- "vessel": Vessel No., el NOMBRE del buque (Vessel, Vessel Name, nave, 船名). '
      +'Ejemplo: "MSC LEANNE".\n'
      +'- "viaje": Voyage (Voy., Voyage No., viaje, 航次). Ejemplo: "528W". '
      +'Va SEPARADO del nombre del buque.\n'
      +'- "origen": Port of Loading (puerto de embarque).\n'
      +'- "destino": Port of Discharge o Place of Delivery (puerto de destino).\n'
      +'- "fecha_salida": ETD (Shipped on Board, fecha de embarque o de emision).\n'
      +'- "contenedores": No. of Containers, con Container No., tipo y Sello / No.\n'
      +'- "tarifas": el Rate con todos sus cargos (Freight, THC, BL Fee...).';
  }
  return 'Sos el analista de importaciones de KENNEDY CENTER CORP. Lee el AVISO DE LLEGADA '
    +'(Arrival Notice).\n\n'+comun
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
    +'{"bl":"","shipper":"","consignee":"","vessel":"","viaje":"",'
    +'"fecha_salida":"","fecha_llegada":"",'
    +'"contenedores":[{"numero":"","tipo":"","sello":""}],'
    +'"tarifas":[{"concepto":"","monto":0,"moneda":""}],"nota":""}\n\n'
    +'QUE ES CADA CAMPO:\n'
    +'- "bl": B/L No., el numero de conocimiento de embarque.\n'
    +'- "shipper": el embarcador (Shipper, Consignor).\n'
    +'- "consignee": el consignatario (Consignee).\n'
    +'- "vessel": Vessel No., el NOMBRE del buque.\n'
    +'- "viaje": Voyage, el numero de viaje. Va SEPARADO del nombre del buque.\n'

    +'- "fecha_salida": ETD, la fecha de zarpe.\n'
    +'- "fecha_llegada": ETA, la FECHA DE LLEGADA del buque (Arrival Date, fecha de arribo).\n'
    +'- "contenedores": No. of Containers, con Container No., tipo y Sello / No.\n'
    +'- "tarifas": el Rate, los cargos a pagar en destino.';
}


// Correo para avisar a diseño que ya tiene todo para arrancar los artes
async function _hubMailDiseno(oid){
  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var dept=dat.dept||'';
  window._mailAdj=[];
  window._hubMailCtx={oid:oid};

  var disenadores=(USERS||[]).filter(function(u){ return u.role==='diseno' && u.email; });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado=(u.role==='diseno');
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#3C3489':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#F7F5FF':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)+'</span></label>';
  }).join('');

  // Los enlaces de descarga que haya cargados
  var d=_logLeer(oid);
  var enlaces=((d.hub&&d.hub.enlaces)||[]).map(function(e){ return e.url||e; }).filter(Boolean);

  var asunto='ARTES - '+ordenTxt+(dat.proveedor?(' - '+dat.proveedor):'');
  var cuerpo='Hola,\n\n'
    +'Ya está lista la información para trabajar los artes de esta orden.\n\n'
    +'  • Orden: '+ordenTxt+'\n'
    +(dat.proveedor?('  • Proveedor: '+dat.proveedor+'\n'):'')
    +(dept?('  • Departamento: '+dL(dept)+'\n'):'')
    +'\nEn el portal, dentro de la etapa Artes, está el HUB de diseño con la orden '
    +'de compra y los archivos para arte.\n'
    +(enlaces.length?('\nEnlaces de descarga:\n'+enlaces.map(function(u){ return '  '+u; }).join('\n')+'\n'):'')
    +'\nCualquier duda me avisan por el chat del paso.\n\n'
    +'Saludos,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalHubMail'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalHubMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:620px">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-indigo)"><i class="ti ti-palette"></i> Avisar a diseño</div>'
      +'<button onclick="_hubMailCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA · diseño marcado</div>'
    +'<div id="hubmail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="hubmail-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="hubmail-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="hubmail-cuerpo" rows="13" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="hubmail-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando los documentos del HUB…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_hubMailCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="hubmail-btn" style="background:#3C3489" onclick="_hubMailEnviar()"><i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Los documentos del HUB (v748). Los ORIGINALES ya están en el HUB de
  // diseño: al correo solo van copias LIGERAS. Antes se bajaban enteros, uno
  // detrás de otro y sin tiempo límite: con muchos archivos la ventana se
  // quedaba 15 minutos en «Adjuntando…», y el correo, por encima de ~3 MB,
  // no habría salido de todos modos.
  //   · fotos e imágenes: se reducen (1600 px, JPEG) → pocos cientos de KB;
  //   · PDF y demás: van si son pequeños; si no, NO se adjuntan y en el
  //     mensaje queda su enlace al HUB;
  //   · como mucho HUB_ADJ_TOTAL_MB en total; 4 descargas a la vez, y cada
  //     una con tope de 25 s.
  var aviso=document.getElementById('hubmail-auto');
  var puestos=[], enlazados=[];
  try{
    var files=(window._atts&&window._atts[oid+'artes_step0'])?_dedupDocs(window._atts[oid+'artes_step0']):[];
    files=files.filter(function(f){ return f && f.url; });
    var total=0, hechos=0, idx=0;
    var pintar=function(){ if(aviso) aviso.innerHTML='<span class="ai-ring g" style="vertical-align:-2px"></span> Preparando copias ligeras de los documentos del HUB… '
      +hechos+' de '+files.length; };
    pintar();
    var uno=async function(){
      while(idx<files.length){
        var f=files[idx++], nom=f.name||'documento';
        try{
          var adj=await _hubAdjLigero(f.url, nom);
          if(adj && total+adj.kb<=HUB_ADJ_TOTAL_MB*1024){ window._mailAdj.push(adj); total+=adj.kb; puestos.push(adj.nombre); }
          else enlazados.push({nombre:nom, url:DOCS_BASE+String(f.url).split('/').map(encodeURIComponent).join('/')});
        }catch(e){ enlazados.push({nombre:nom, url:DOCS_BASE+String(f.url).split('/').map(encodeURIComponent).join('/')}); }
        hechos++; pintar();
      }
    };
    await Promise.all([uno(),uno(),uno(),uno()]);
  }catch(e){}
  mailPintarAdjuntos();
  // Lo que no va adjunto, con su enlace en el mensaje
  if(enlazados.length){
    var tx=document.getElementById('hubmail-cuerpo');
    if(tx && tx.value.indexOf('Archivos en el HUB')<0){
      tx.value=tx.value.replace(/\n\nCualquier duda/,'\n\nArchivos en el HUB (originales, no van adjuntos por su tamaño):\n'
        +enlazados.map(function(x){ return '  • '+x.nombre+': '+x.url; }).join('\n')+'\n\nCualquier duda');
    }
  }
  if(aviso) aviso.innerHTML=(puestos.length||enlazados.length)
    ? ((puestos.length?('<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntos ligeros: '+_esc(puestos.join(', '))+'</span>'):'')
      +(enlazados.length?('<div style="color:var(--text-muted);margin-top:3px"><i class="ti ti-link"></i> '+enlazados.length
        +' archivo(s) grandes van como enlace en el mensaje: '+_esc(enlazados.map(function(x){ return x.nombre; }).join(', '))+'</div>'):''))
    : '<span style="color:var(--text-muted)">Sin documentos en el HUB. Puedes adjuntar a mano.</span>';
}

var HUB_ADJ_TOTAL_MB = 2.5;     // Microsoft admite ~3 MB de adjuntos por correo
var HUB_ADJ_UNO_MB   = 1.2;     // un PDF/archivo más grande que esto va como enlace

// Una copia ligera de un archivo del HUB para el correo, o null si no cabe
async function _hubAdjLigero(path, nombre){
  var url=DOCS_BASE + String(path).split('/').map(encodeURIComponent).join('/');
  var ctrl=(typeof AbortController!=='undefined')?new AbortController():null;
  var t=setTimeout(function(){ try{ ctrl&&ctrl.abort(); }catch(e){} }, 25000);
  var r;
  try{ r=await fetch(url, ctrl?{signal:ctrl.signal}:{}); } finally { clearTimeout(t); }
  if(!r.ok) return null;
  var blob=await r.blob();
  var esImg=/^image\/(jpe?g|png|webp|bmp)/i.test(blob.type||'') || /\.(jpe?g|png|webp|bmp)$/i.test(nombre);
  if(esImg && blob.size>300*1024){
    try{
      var bmp=await createImageBitmap(blob);
      var k=Math.min(1, 1600/Math.max(bmp.width, bmp.height));
      var cv=document.createElement('canvas'); cv.width=Math.round(bmp.width*k); cv.height=Math.round(bmp.height*k);
      cv.getContext('2d').drawImage(bmp, 0, 0, cv.width, cv.height);
      var chica=await new Promise(function(res){ cv.toBlob(res, 'image/jpeg', 0.78); });
      if(chica && chica.size<blob.size){ blob=chica; nombre=String(nombre).replace(/\.[^.]+$/,'')+'.jpg'; }
    }catch(e){}
  }
  if(blob.size>HUB_ADJ_UNO_MB*1024*1024) return null;
  var b64=await new Promise(function(res,rej){
    var fr=new FileReader(); fr.onload=function(){ res(String(fr.result).split(',')[1]||''); }; fr.onerror=rej; fr.readAsDataURL(blob); });
  return {nombre:nombre, mime:blob.type||'application/octet-stream', contenido:b64, kb:Math.round(blob.size/1024)};
}

function _hubMailCerrar(){
  var m=document.getElementById('modalHubMail'); if(m) m.remove();
  window._mailAdj=[]; window._hubMailCtx=null;
}

async function _hubMailEnviar(){
  var ctx=window._hubMailCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('hubmail-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('hubmail-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('hubmail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('hubmail-cuerpo')||{}).value||'';
  var btn=document.getElementById('hubmail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Aviso a diseño · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
    return;
  }

  _solEnvioGuardar(oid, 'diseno', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos, asunto:asunto, cuerpo:cuerpo
  });
  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Artes',
      texto:'Ya tienes todo para trabajar los artes de esta orden',
      etiqueta:'Artes — listo para diseñar', paso:'HUB de diseño'
    });
  }catch(e){}

  _hubMailCerrar();
  showT('✓ Aviso enviado a '+todos.length+' persona(s)');
}

function _hubDisenoPanel(oid){
  return '<div id="hubpanel-'+oid+'">'+_hubDisenoInterior(oid)+'</div>';
}
// Repinta SOLO el HUB. Antes se llamaba a openDetail() y eso reconstruía el
// modal entero, cerrando las etapas que estaban abiertas.
function _hubRepintar(oid){
  var c=document.getElementById('hubpanel-'+oid);
  if(c) c.innerHTML=_hubDisenoInterior(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { _dbg('[panel] no está visible: no se repinta'); }
  // Los archivos bajados viven en el subpaso "Archivos para arte": ese
  // bloque está fuera del panel del HUB, así que se repinta aparte.
  try{ _hubRepintarArchivos(oid); }catch(e){}
}

// Repinta la lista de "Archivos de este paso" del HUB dejando todo como
// estaba: la etapa abierta, el subpaso abierto y el scroll donde iba.
function _hubRepintarArchivos(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='artes'; });
  if(idx<0) return;
  var st=STAGES[idx];
  var i=st.steps.findIndex(function(p){ return p.name==='HUB de diseño'; });
  if(i<0) return;

  var body=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
  var abierto = !!(body && body.style.display!=='none');
  var cont=document.getElementById('egb-'+oid+'-'+idx);
  if(!cont) return;                       // la etapa no está desplegada

  // Qué estaba escrito y dónde iba el scroll, para no perderlo
  var borrador='';
  try{ var inp=document.getElementById('subcin-'+oid+'-'+idx+'-'+i); if(inp) borrador=inp.value||''; }catch(e){}
  var scrollY=window.scrollY;
  var chatTop=0;
  try{ var lst=document.getElementById('subcms-'+oid+'-'+idx+'-'+i); if(lst) chatTop=lst.scrollTop; }catch(e){}

  try{ buildEGB(oid, idx, cont); }catch(e){ console.warn('repintar archivos:',e); return; }

  // Se deja el subpaso como estaba
  if(abierto){
    var b2=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
    if(b2) b2.style.display='block';
    var ch=document.getElementById('ssch-'+oid+'-'+idx+'-'+i);
    if(ch) ch.style.transform='rotate(180deg)';
  }
  if(borrador){
    var inp2=document.getElementById('subcin-'+oid+'-'+idx+'-'+i);
    if(inp2) inp2.value=borrador;
  }
  try{
    var lst2=document.getElementById('subcms-'+oid+'-'+idx+'-'+i);
    if(lst2 && chatTop) lst2.scrollTop=chatTop;
  }catch(e){}
  window.scrollTo(0, scrollY);
}
function _hubDisenoInterior(oid){
  var kcc=_hubOrdenKcc(oid);
  var h='<div style="background:#F7F5FF;border:1px solid #C4B5FD;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  var envDis=_solEnvioLeer(oid,'diseno');
  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
    +'<span style="font-size:11.5px;font-weight:700;color:var(--t-lila);flex:1"><i class="ti ti-folders"></i> Documentos para diseñar</span>'
    +(CU && ['compras','gerencia','importacion'].indexOf(CU.role)>=0
      ? ('<button class="btn bp" style="background:#3C3489;padding:4px 11px;font-size:10.5px" onclick="event.stopPropagation();_hubMailDiseno(\'' + oid + '\')">'
         +'<i class="ti ti-mail"></i> '+(envDis?'Volver a avisar a diseño':'Avisar a diseño')+'</button>')
      : '')
    +'</div>';
  if(envDis){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;margin-bottom:8px;font-size:11px;color:var(--t-verde)">'
      +'<i class="ti ti-mail-check"></i> Aviso enviado por <b>'+_esc(envDis.por||'')+'</b> · '+_esc(_fechaHora(envDis.fecha))
      +(envDis.para&&envDis.para.length?('<br>A: '+_esc(envDis.para.join(', '))):'')+'</div>';
  }

  // 1) PDF de la orden de compra (automático)
  h+='<div style="background:var(--surface-0);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-azul);margin-bottom:4px">1 · PDF ORDEN DE COMPRA KCC <span style="font-weight:400;color:var(--text-muted)">(automático, de la orden firmada)</span></div>';
  if(kcc.length){
    kcc.forEach(function(a){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti ti-file-type-pdf" style="color:var(--t-rojo2)"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px"'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button></div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Todavía no hay orden de KCC firmada para esta compra.</div>';
  }
  h+='</div>';

  // 2) Excel de la orden (manual)
  h+=_hubZona(oid,'artes_excel','2 · EXCEL ORDEN DE COMPRA','Sube el Excel de la orden','#166534','ti-file-spreadsheet','.xlsx,.xls,.csv');
  // 3) Archivos de arte del proveedor (manual)
  h+=_hubZona(oid,'artes_files','3 · ARCHIVOS PARA ARTE','Diecuts, fotos HD, certificados que manda el proveedor','#B45309','ti-palette','');
  // 4) Enlaces externos: WeTransfer, TransferNow, Drive, etc.
  h+=_hubLinks(oid);
  h+='</div>';
  return h;
}

// ── Enlaces externos de descarga ──
// El navegador no puede bajar el contenido de WeTransfer o TransferNow: esas
// páginas no permiten lectura desde otro sitio y el archivo real vive detrás
// de un token temporal. Así que el enlace se guarda aquí, a la vista y con un
// clic para abrirlo, y los archivos que se bajen se suben al bloque 3.
function _hubLinks(oid){
  var links=_hubLeerLinks(oid);
  var h='<div style="background:var(--surface-0);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-lila);margin-bottom:4px">4 · ENLACES DE DESCARGA '
    +'<span style="font-weight:400;color:var(--text-muted)">(WeTransfer, TransferNow, Drive…)</span></div>';
  if(links.length){
    links.forEach(function(l,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:4px 0;border-top:0.5px solid var(--border)">'
        +'<i class="ti ti-link" style="color:var(--t-lila)"></i>'
        +'<div style="flex:1;min-width:0">'
          +'<a href="'+_esc(l.url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="color:var(--text-accent);text-decoration:underline;word-break:break-all">'+_esc(l.url)+'</a>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(l.por||'')+(l.fecha?(' \u00b7 '+_esc(l.fecha)):'')+(l.nota?(' \u00b7 '+_esc(l.nota)):'')+'</div>'
        +'</div>'
        +'<button class="btn bg2" style="padding:3px 8px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_hubBorrarLink(\''+oid+'\','+i+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
  }
  h+=_hubDescargasPanel(oid);
  h+='<div style="display:flex;gap:5px;margin-top:6px">'
    +'<input id="hublink-'+oid+'" placeholder="Pegá el enlace de descarga" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:11px;background:var(--surface-0);color:var(--text-primary)" onclick="event.stopPropagation()">'
    +'<button class="btn bp" style="padding:6px 11px;font-size:11px" onclick="event.stopPropagation();_hubAgregarLink(\''+oid+'\')">Guardar</button>'
    +'</div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
    +'El servidor descarga el contenido solo y lo deja en <b>Archivos para arte</b>. Suele tardar un par de minutos. '
    +'<span onclick="event.stopPropagation();_hubLimpiarBasura(\''+oid+'\')" style="text-decoration:underline;cursor:pointer;color:var(--text-accent)">Revisar los archivos bajados</span></div>';
  return h+'</div>';
}

function _hubLinksKey(oid){ return 'hublinks_'+oid; }
function _hubLeerLinks(oid){
  if(window._hubLinks && window._hubLinks[oid]) return window._hubLinks[oid];
  try{
    var v=localStorage.getItem(_hubLinksKey(oid));
    if(v){ var l=JSON.parse(v); if(Array.isArray(l)) return l; }
  }catch(e){}
  return [];
}
function _hubGuardarLinks(oid, links){
  window._hubLinks=window._hubLinks||{};
  window._hubLinks[oid]=links;
  try{ localStorage.setItem(_hubLinksKey(oid), JSON.stringify(links)); }catch(e){}
  // También en la orden, para que lo vean los demás
  try{
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p){ p.links_arte=links; guardarPendSAP(p.dkc||p.num_orden); }
  }catch(e){}
}
async function _hubAgregarLink(oid){
  var inp=document.getElementById('hublink-'+oid);
  var url=(inp&&inp.value||'').trim();
  if(!url){ showT('Pegá un enlace primero'); return; }
  if(!/^https?:\/\//i.test(url)){ showT('El enlace tiene que empezar con http:// o https://'); return; }
  var links=_hubLeerLinks(oid).slice();
  if(links.some(function(l){ return l.url===url; })){ showT('Ese enlace ya está guardado'); return; }
  var nota=prompt('¿Qué contiene este enlace? (opcional)\n\nPor ejemplo: diecuts y fotos HD','')||'';
  links.push({url:url, por:(CU&&CU.name)||'', fecha:now2(), nota:nota});
  _hubGuardarLinks(oid, links);
  if(inp) inp.value='';

  // Se encola para que el worker lo descargue y suba los archivos solo
  showT('Enlace guardado. Poniéndolo en cola de descarga…');
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), etapa:'artes_files', url:url, nota:nota,
        pedido_por:(CU&&CU.name)||'', estado:'pendiente',
        creado_en:new Date().toISOString()
      })});
    if(r.ok) showT('✓ En cola. Los archivos van a aparecer solos aquí abajo, sin salir de la etapa.');
    else {
      var t=await r.text();
      console.warn('descargas_queue', r.status, t);
      showT(/does not exist|Could not find the table/i.test(t)
        ? '⚠ Falta la tabla descargas_queue (script descargas_queue.sql). El enlace igual quedó guardado.'
        : '⚠ El enlace quedó guardado, pero no se pudo encolar la descarga.');
    }
  }catch(e){ console.warn('encolar descarga:',e); showT('⚠ El enlace quedó guardado, pero no se pudo encolar.'); }
  await _hubDescargasCargar(oid);
  _hubRepintar(oid);
  // Se arranca la vigilancia AHORA. Antes solo se activaba al abrir el paso,
  // así que tras pegar un enlace nadie miraba si la descarga terminaba y los
  // archivos no aparecían hasta salir y volver a entrar.
  window._hubVig[oid]=false;      // por si quedó una vigilancia vieja
  _hubVigilarCiclo(oid, 0);
  // El cursor vuelve al campo, por si hay más enlaces que pegar
  setTimeout(function(){
    var i=document.getElementById('hublink-'+oid);
    if(i) i.focus();
  }, 120);
}

// ── Estado de las descargas automáticas ──
window._hubDesc=window._hubDesc||{};
async function _hubDescargasCargar(oid){
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue?select=*&docnum=eq.'+encodeURIComponent(oid)
      +'&order=creado_en.desc&limit=20',{headers:SBH});
    if(!r.ok) return [];
    var rows=await r.json();
    window._hubDesc[oid]=Array.isArray(rows)?rows:[];
    return window._hubDesc[oid];
  }catch(e){ return []; }
}

// ── Vigilancia de las descargas del HUB ──
// Mientras hay algo bajando se consulta cada 4 segundos. Al terminar, se
// traen los archivos de la orden y se repinta el HUB de inmediato.
window._hubVig=window._hubVig||{};

function _hubVigilar(oid){
  if(window._hubVig[oid]) return;          // ya hay una vigilancia activa
  var primera=!window._hubDesc[oid];
  _hubDescargasCargar(oid).then(function(ds){
    ds=ds||[];
    if(primera && ds.length) _hubRepintar(oid);
    var enCurso=ds.some(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; });
    if(enCurso) _hubVigilarCiclo(oid, 0);
  });
}

function _hubVigilarCiclo(oid, intento){
  window._hubVig[oid]=true;
  // Al principio se pregunta seguido; después se espacia para no cargar la base.
  // El worker revisa su cola cada 5 s, así que 3 s de arranque alcanza para
  // ver el cambio a "procesando" casi al instante.
  var espera = intento===0 ? 1500 : (intento<20 ? 3000 : (intento<45 ? 8000 : 15000));
  setTimeout(function(){
    var antes=(window._hubDesc[oid]||[]).map(function(d){ return d.id+':'+d.estado; }).join('|');
    _hubDescargasCargar(oid).then(async function(ds){
      ds=ds||[];
      var ahora=ds.map(function(d){ return d.id+':'+d.estado; }).join('|');
      var listas=ds.filter(function(d){ return d.estado==='listo'; });
      var enCurso=ds.some(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; });

      if(ahora!==antes){
        // Cambió algo: se recargan los archivos y se repinta
        if(listas.length){
          try{ await cargarDocsOrden(oid); }catch(e){}
          var nuevos=[];
          listas.forEach(function(d){
            var a=d.archivos;
            if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ a=null; } }
            if(Array.isArray(a)) nuevos=nuevos.concat(a);
          });
          if(nuevos.length) showT('✓ '+nuevos.length+' archivo(s) descargado(s): '+nuevos.slice(0,3).join(', '));
        }
        var conError=ds.filter(function(d){ return d.estado==='error'; });
        if(conError.length && conError.length!==(window._hubErrAvisado||{})[oid]){
          window._hubErrAvisado=window._hubErrAvisado||{};
          window._hubErrAvisado[oid]=conError.length;
          showT('⚠ Una descarga no se pudo completar. Mira el detalle en el HUB.');
        }
        _hubRepintar(oid);
      }

      if(enCurso && intento<150){          // ~15 min de vigilancia
        _hubVigilarCiclo(oid, intento+1);
      } else {
        window._hubVig[oid]=false;
        if(!enCurso && listas.length){
          try{ await cargarDocsOrden(oid); }catch(e){}
          _hubRepintar(oid);
        }
      }
    }).catch(function(){ window._hubVig[oid]=false; });
  }, espera);
}

// ── Limpiar el historial de descargas (solo gerencia) ──
async function _hubBorrarLog(oid, id){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar los registros'); return; }
  if(!id){ showT('Registro sin identificar'); return; }
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(!r.ok){ showT('No se pudo borrar el registro'); return; }
  }catch(e){ showT('Error de conexión'); return; }
  window._hubDesc[oid]=(window._hubDesc[oid]||[]).filter(function(d){ return String(d.id)!==String(id); });
  showT('Registro eliminado');
  _hubRepintar(oid);
}

async function _hubLimpiarLogs(oid, soloCerradas){
  if(!_esGerencia()){ showT('Solo gerencia puede limpiar el historial'); return; }
  var ds=window._hubDesc[oid]||[];
  var objetivo=soloCerradas
    ? ds.filter(function(d){ return d.estado==='listo'||d.estado==='error'; })
    : ds.slice();
  if(!objetivo.length){ showT('No hay registros que limpiar'); return; }
  var enCurso=ds.filter(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; }).length;
  if(!confirm('¿Borrar '+objetivo.length+' registro(s) de descarga?\n\n'
    +(soloCerradas
        ? 'Se quitan los terminados y los que fallaron.'+(enCurso?(' Los '+enCurso+' en curso se mantienen.'):'')
        : 'Se borra TODO el historial'+(enCurso?(', incluidos '+enCurso+' que siguen bajando'):'')+'.')
    +'\n\nLos archivos ya descargados NO se tocan.')) return;

  var ok=0;
  for(var i=0;i<objetivo.length;i++){
    try{
      var r=await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+objetivo[i].id,{method:'DELETE',headers:SBH});
      if(r.ok) ok++;
    }catch(e){}
  }
  var ids={};
  objetivo.forEach(function(d){ ids[String(d.id)]=1; });
  window._hubDesc[oid]=(window._hubDesc[oid]||[]).filter(function(d){ return !ids[String(d.id)]; });
  showT('✓ '+ok+' registro(s) eliminado(s)');
  _hubRepintar(oid);
}

function _hubDescargasPanel(oid){
  var ds=window._hubDesc[oid]||[];
  if(!ds.length) return '';
  var col={pendiente:['#B45309','#FEF3E8','En cola'],
           procesando:['#5B21B6','#EDE9FE','Descargando…'],
           listo:['#166534','#dcfce7','Descargado'],
           error:['#991b1b','#FEF2F2','No se pudo']};
  var h='';
  // Gerencia puede limpiar el historial de descargas
  if(_esGerencia() && ds.length){
    var cerradas=ds.filter(function(d){ return d.estado==='listo'||d.estado==='error'; }).length;
    h+='<div style="display:flex;align-items:center;gap:6px;padding:4px 0;border-top:0.5px solid var(--border)">'
      +'<span style="font-size:10px;color:var(--text-muted);flex:1">'+ds.length+' registro(s) de descarga</span>'
      +(cerradas?('<button class="btn bg2" style="padding:2px 8px;font-size:10px" onclick="event.stopPropagation();_hubLimpiarLogs(\''+oid+'\',true)" title="Quita los terminados y con error, deja los que siguen bajando"><i class="ti ti-eraser"></i> Limpiar</button>'):'')
      +'<button class="btn bg2" style="padding:2px 8px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_hubLimpiarLogs(\''+oid+'\',false)" title="Borra todo el historial"><i class="ti ti-trash"></i> Borrar todo</button>'
      +'</div>';
  }
  ds.forEach(function(d){
    var c=col[d.estado]||col.pendiente;
    var archivos=d.archivos;
    if(typeof archivos==='string'){ try{ archivos=JSON.parse(archivos); }catch(e){ archivos=null; } }
    h+='<div style="border-top:0.5px solid var(--border);padding:5px 0;font-size:10.5px">'
      +'<span style="background:'+c[1]+';color:'+c[0]+';border-radius:6px;padding:1px 7px;font-weight:700">'+c[2]+'</span> '
      +'<span style="color:var(--text-muted)">'+_esc(String(d.url||'').slice(0,52))+(String(d.url||'').length>52?'…':'')+'</span>'
      +(d.detalle?('<div style="color:'+c[0]+';margin-top:2px">'+_esc(d.detalle)+'</div>'):'')
      +(d.diagnostico?('<details style="margin-top:3px"><summary style="cursor:pointer;color:var(--text-muted);font-size:10px">Ver el detalle técnico</summary>'
        +'<pre style="white-space:pre-wrap;word-break:break-all;font-size:9.5px;background:var(--surface-1);border-radius:6px;padding:6px;margin-top:3px;max-height:220px;overflow:auto">'
        +_esc(String(d.diagnostico).slice(0,3000))+'</pre></details>'):'')
      +(archivos&&archivos.length?('<div style="color:var(--text-success);margin-top:2px"><i class="ti ti-check"></i> '+_esc(archivos.join(', '))+'</div>'):'')
      +(_esGerencia()?('<span onclick="event.stopPropagation();_hubBorrarLog(\''+oid+'\','+(d.id||0)+')" title="Borrar este registro" style="float:right;color:var(--text-danger);cursor:pointer;font-size:11px;margin-top:-16px"><i class="ti ti-x"></i></span>'):'')
      +'</div>';
  });
  return h;
}
// Revisa los archivos bajados y quita los que no sirven.
// Las descargas anteriores pudieron guardar la página web del servicio como
// si fuera el archivo: pesan poco y no abren.
async function _hubLimpiarBasura(oid){
  var sk='artes_files';
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  if(!files.length){ showT('No hay archivos descargados que revisar'); return; }
  showT('Revisando '+files.length+' archivo(s)…');
  var malos=[];
  for(var i=0;i<files.length;i++){
    var a=files[i];
    if(!a.url) continue;
    try{
      var url=DOCS_BASE + String(a.url).split('/').map(encodeURIComponent).join('/');
      var r=await fetch(url, {headers:{'Range':'bytes=0-31'}});
      if(!r.ok) continue;
      var buf=new Uint8Array(await r.arrayBuffer());
      var ext=String(a.name||'').split('.').pop().toLowerCase();
      var cab=String.fromCharCode.apply(null, buf.slice(0,20)).toLowerCase().replace(/^\s+/,'');
      var esWeb=/^(<!doctype|<html|<\?xml|<head|<script|<meta)/.test(cab);
      var firmas={zip:[[0x50,0x4B]], xlsx:[[0x50,0x4B]], docx:[[0x50,0x4B]],
                  pdf:[[0x25,0x50,0x44,0x46]], png:[[0x89,0x50,0x4E,0x47]],
                  jpg:[[0xFF,0xD8,0xFF]], jpeg:[[0xFF,0xD8,0xFF]], rar:[[0x52,0x61,0x72,0x21]]};
      var esp=firmas[ext];
      var mal=esWeb || (esp && !esp.some(function(f){
        return f.every(function(b,ix){ return buf[ix]===b; }); }));
      if(mal) malos.push({a:a, i:i, motivo:esWeb?'es una página web':'no es un .'+ext+' válido'});
    }catch(e){ console.warn('revisar archivo:',e); }
  }
  if(!malos.length){ showT('✓ Todos los archivos descargados están bien'); return; }
  if(!confirm('Se encontraron '+malos.length+' archivo(s) que no sirven:\n\n'
    +malos.map(function(m){ return '· '+(m.a.name||'')+' — '+m.motivo; }).join('\n')
    +'\n\nEstos quedaron de descargas que fallaron. ¿Borrarlos?')) return;
  for(var k=0;k<malos.length;k++){
    await _borrarArchivoStorage(malos[k].a.url, malos[k].a.id);
  }
  window._atts[oid+sk]=(window._atts[oid+sk]||[]).filter(function(x){
    return !malos.some(function(m){ return m.a.url===x.url; });
  });
  showT('✓ '+malos.length+' archivo(s) dañado(s) eliminado(s)');
  _hubRepintar(oid);
}

async function _hubBorrarLink(oid, i){
  var links=_hubLeerLinks(oid).slice();
  if(!links[i]) return;
  var url=links[i].url;

  // Lo que se descargó de ese enlace, para poder limpiarlo también
  var cola=(window._hubDesc[oid]||[]).filter(function(d){ return String(d.url)===String(url); });
  var nombres=[];
  cola.forEach(function(d){
    var a=d.archivos;
    if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ a=null; } }
    if(Array.isArray(a)) nombres=nombres.concat(a);
  });
  var sk='artes_files';
  var bajados=((window._atts&&window._atts[oid+sk])||[]).filter(function(f){
    return nombres.some(function(n){ return _docClave({name:n})===_docClave(f); });
  });

  var msg='¿Está seguro de que desea borrar este enlace?\n\n'+url;
  if(bajados.length) msg+='\n\nSe borrarán también '+bajados.length+' archivo(s) que se bajaron de él:\n'
    +bajados.map(function(f){ return '  · '+(f.name||''); }).join('\n');
  msg+='\n\nDespués vas a poder volver a subirlo.';
  if(!confirm(msg)) return;

  showT('Borrando…');
  // Los archivos que vinieron de ese enlace
  for(var b=0;b<bajados.length;b++){
    await _borrarArchivoStorage(bajados[b].url, bajados[b].id);
  }
  if(bajados.length){
    window._atts[oid+sk]=(window._atts[oid+sk]||[]).filter(function(f){
      return !bajados.some(function(z){ return z.url===f.url; });
    });
  }
  // El registro de la descarga, para que el estado no quede en verde
  for(var c=0;c<cola.length;c++){
    try{ await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+cola[c].id,{method:'DELETE',headers:SBH}); }catch(e){}
  }
  window._hubDesc[oid]=(window._hubDesc[oid]||[]).filter(function(d){ return String(d.url)!==String(url); });

  links.splice(i,1);
  _hubGuardarLinks(oid, links);
  showT(bajados.length
    ? ('✓ Enlace y '+bajados.length+' archivo(s) eliminados. Puedes volver a subirlo.')
    : '✓ Enlace eliminado. Puedes volver a subirlo.');
  _hubRepintar(oid);
}

// La orden de KCC firmada, nunca la del proveedor
function _hubOrdenKcc(oid){
  var out=[], vistos={};
  // 1) De la etapa de firma, si existe
  var fr=(window._firmaRows||[]).find(function(f){
    return String(f.num_orden)===String(oid) || String(f.dkc)===String(oid);
  });
  if(fr && (fr.archivo_firmado_path||fr.archivo_path)){
    var pth=fr.archivo_firmado_path||fr.archivo_path;
    var nom=fr.archivo_firmado_nombre||fr.archivo_nombre||('Orden_KCC_'+oid+'.pdf');
    out.push({name:nom, url:pth, data:DOCS_BASE+String(pth).split('/').map(encodeURIComponent).join('/')});
    vistos[_docClave({name:nom})]=1;
  }
  // 2) Si no, el documento de la orden cuyo nombre NO es del proveedor
  if(!out.length){
    try{
      _docsBaseOrden(oid).forEach(function(a){
        var n=String(a.name||'').toLowerCase();
        var esProveedor=/proforma|\bpi\b|invoice|fut|supplier/.test(n);
        var esPdf=/\.pdf$/.test(n);
        if(!esProveedor && esPdf && !vistos[_docClave(a)]){ vistos[_docClave(a)]=1; out.push(a); }
      });
    }catch(e){}
  }
  return out;
}

// Zona de subida para una clave concreta
function _hubZona(oid, sub, titulo, ayuda, color, icono, accept){
  var k=oid+sub;
  var files=(window._atts&&window._atts[k])?_dedupDocs(window._atts[k]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    files.forEach(function(a,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti '+icono+'" style="color:'+color+'"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px"'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
        +((CU&&CU.role!=='bodega')?('<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_hubBorrar(\''+oid+'\',\''+sub+'\','+i+')"><i class="ti ti-trash"></i></button>'):'')
        +'</div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple'+(accept?(' accept="'+accept+'"'):'')+' style="display:none" onchange="_hubSubir(\''+oid+'\',\''+sub+'\',this.files)"></label>';
  return h+'</div>';
}

async function _hubSubir(oid, sub, files){
  if(!files||!files.length) return;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir hub:',e); }
  }
  showT('✓ Archivos adjuntados');
  _hubRepintar(oid);
}

async function _hubBorrar(oid, sub, i){
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Está seguro de que desea borrar el archivo "'+(a.name||'')+'"?\n\nEsta acción no se puede deshacer.')) return;
  await _borrarArchivoStorage(a.url, a.id);
  window._atts[oid+sub].splice(i,1);
  // Si venía de una descarga, se corrige ese registro para que el estado no
  // siga diciendo "Descargado" con archivos que ya no están.
  try{ await _hubDepurarDescargas(oid); }catch(e){}
  showT('Archivo eliminado');
  _hubRepintar(oid);
}

// Revisa los registros de descarga contra los archivos que quedan.
// Si de un registro ya no queda nada, se elimina; si quedan algunos, se
// actualiza la lista para que el estado refleje la realidad.
async function _hubDepurarDescargas(oid){
  var ds=window._hubDesc[oid]||[];
  if(!ds.length) return;
  var presentes=((window._atts&&window._atts[oid+'artes_files'])||[]).map(_docClave);
  for(var i=0;i<ds.length;i++){
    var d=ds[i];
    if(d.estado!=='listo') continue;
    var arch=d.archivos;
    if(typeof arch==='string'){ try{ arch=JSON.parse(arch); }catch(e){ arch=null; } }
    if(!Array.isArray(arch) || !arch.length) continue;
    var quedan=arch.filter(function(n){ return presentes.indexOf(_docClave({name:n}))>=0; });
    if(quedan.length===arch.length) continue;      // no cambió nada

    if(!quedan.length){
      // No queda ninguno: el registro pasa a pendiente para poder rebajarlo
      try{
        await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+d.id,{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({estado:'error', archivos:null,
            detalle:'Los archivos se borraron a mano. Volvé a pegar el enlace si los necesitás.'})});
        d.estado='error'; d.archivos=null;
        d.detalle='Los archivos se borraron a mano. Volvé a pegar el enlace si los necesitás.';
      }catch(e){}
    } else {
      try{
        await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+d.id,{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({archivos:JSON.stringify(quedan),
            detalle:quedan.length+' archivo(s) · '+(arch.length-quedan.length)+' borrado(s) a mano'})});
        d.archivos=JSON.stringify(quedan);
        d.detalle=quedan.length+' archivo(s) · '+(arch.length-quedan.length)+' borrado(s) a mano';
      }catch(e){}
    }
  }
}

function _provEmailDeOrden(oid){
  var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
  if(o && o.vendorEmail) return o.vendorEmail;
  var d=_solPagoDatosOrden(oid);
  try{ var e=_firmaCorreoProveedor(d.proveedor||''); if(e) return e; }catch(err){}
  return '';
}

// Encargado de compras del departamento de la orden
function _encargadosCompras(oid){
  var d=_solPagoDatosOrden(oid);
  var dept=d.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  return (USERS||[]).filter(function(u){
    return _esComprasU(u) && u.email && (!dept || String(u.dept||'')===String(dept));
  });
}

async function _provAbrirModal(oid, tipo){
  // tipo: 'abono' -> comprobante del depósito | 'cancelacion' -> pago final
  var esAbono=(tipo!=='cancelacion');
  var d=_solPagoDatosOrden(oid);
  var monto=_compMonto(oid, tipo);
  var ordenTxt=d.dkc||String(oid);
  window._mailAdj=[];
  window._provCtx={oid:oid, tipo:tipo,
    paso:_pasoIdxDeposito(esAbono?_PASO_COMP_PROV:_PASO_COMP_FINAL)};

  var provEmail=_provEmailDeOrden(oid);
  var encargados=_encargadosCompras(oid);

  var palabra = esAbono ? 'depósito' : 'pago final';
  var titulo  = esAbono ? 'Deposit Payment Confirmation' : 'Final Balance Payment Confirmation';
  var asunto  = titulo+' '+ordenTxt;

  // El concepto lleva el % del anticipo si se conoce
  var pct=0;
  try{ if(d.total>0 && monto>0) pct=Math.round((monto/d.total)*100); }catch(e){}
  var concepto = esAbono
    ? ((pct>0&&pct<100)?(pct+'% Deposit'):'Deposit')
    : 'Final Balance';

  var cuerpo='Dear Vendor,\n\n'
    +'Subject:    '+titulo+' '+ordenTxt+'\n\n'
    +'Please be informed that the following '+(esAbono?'deposit':'final balance')+' payment has been sent to your account:\n\n'
    +'PO:                                 '+ordenTxt+'\n'
    +'Supplier:                      '+(d.proveedor||'')+'\n'
    +'Description:               '+concepto+'\n'
    +'Amount:                       US'+fmt(monto)+'\n\n'
    +'Kindly confirm receipt of the funds at your earliest convenience.\n\n'
    +(esAbono
      ? 'Please start production to comply with shipment schedule on time.\n\n'
      : 'Please proceed with the shipment as agreed.\n\n')
    +'Thank you for your cooperation.\n\n'
    +'Best Regards,\n\n'
    +_firmaNombre()+'\n'
    +'KENNEDY CENTER CORP.';

  // CC: el equipo de compras del departamento, marcado por defecto
  var ccChips=encargados.filter(function(u){
    return String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){
    return '<span class="sp-cc-chip on" data-mail="'+_esc(u.email)+'" onclick="_provToggleCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-check" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');
  var ccOtros=(USERS||[]).filter(function(u){
    if(!u.email) return false;
    if(String(u.email).toLowerCase()===String((CU&&CU.email)||'').toLowerCase()) return false;
    return !encargados.some(function(e){ return e.id===u.id; });
  }).map(function(u){
    return '<span class="sp-cc-chip" data-mail="'+_esc(u.email)+'" onclick="_provToggleCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');
  var ccIniciales=encargados.filter(function(u){
    return String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){ return u.email; }).join(', ');

  var prev=document.getElementById('modalProv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalProv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)"><i class="ti ti-send"></i> Enviar comprobante de '+palabra+' al proveedor</div>'
      +'<button onclick="_provCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-azul)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> \u00b7 orden '+_esc(ordenTxt)
      +(monto?('<div style="margin-top:3px">Monto del '+palabra+': <b>'+fmt(monto)+'</b></div>'):'')
    +'</div>'

    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">Firmarás el correo como <b>'+_esc(_firmaNombre())+'</b>'
      +' \u00b7 <span onclick="_firmaPedirNombre()" style="text-decoration:underline;cursor:pointer">cambiar</span></div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">PARA — proveedor</div>'
    +'<input id="prov-para" value="'+_esc(provEmail)+'" placeholder="correo@proveedor.com (uno o varios, separados por coma)" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:10px;margin:3px 0 12px">'
      +(provEmail
        ?'<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Correo tomado de SAP. Puedes cambiarlo.</span>'
        :'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Este proveedor no tiene correo en SAP: escríbelo a mano.</span>')
    +'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">CC — copia</div>'
    +'<div id="prov-cc-chips" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:5px">'+ccChips+ccOtros+'</div>'
    +'<input id="prov-cc" value="'+_esc(ccIniciales)+'" placeholder="otros@correo.com, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="prov-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="prov-cuerpo" rows="12" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="prov-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Buscando el comprobante de contabilidad…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_provCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="prov-btn" onclick="_provEnviar()"><i class="ti ti-send"></i> Enviar al proveedor</button>'
    +'</div>'
  +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Se trae el comprobante que dejó contabilidad en su paso.
  // OJO: la clave de adjuntos es SIEMPRE oid+subKey. Antes se buscaba solo por
  // subKey y nunca encontraba nada, de ahí el aviso falso de "no lo subió".
  var origen=_subKeyDeposito(esAbono?_PASO_DEP_PROV:_PASO_PAGO_FINAL);
  var aviso=document.getElementById('prov-auto');
  var docs=[];
  if(origen){
    // Si todavía no está en memoria, se leen los documentos de la orden
    if(!(window._atts && window._atts[oid+origen] && window._atts[oid+origen].length)){
      try{ await cargarDocsOrden(oid); }catch(e){ console.warn('cargar docs:',e); }
    }
    docs=(window._atts&&window._atts[oid+origen])?_dedupDocs(window._atts[oid+origen]):[];
  }
  var base={};
  try{ _docsBaseOrden(oid).forEach(function(a){ base[_docClave(a)]=1; }); }catch(e){}
  docs=docs.filter(function(a){ return !base[_docClave(a)]; });

  // Si no hay nada en el paso, se cae al comprobante que se mandó por correo
  if(!docs.length){
    var env=_solEnvioLeer(oid,'comprobante_'+(esAbono?'abono':'cancelacion'));
    if(env && env.adjuntos && env.adjuntos.length && aviso){
      aviso.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> El comprobante se envió por correo pero no quedó archivado en el paso. Adjuntalo a mano: '
        +_esc(env.adjuntos.map(function(a){return a.nombre;}).join(', '))+'</span>';
      return;
    }
    if(aviso) aviso.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Contabilidad todavía no subió el comprobante en su paso. Adjuntalo a mano.</span>';
    return;
  }
  var puestos=[];
  for(var i=0;i<docs.length;i++){
    if(!docs[i].url) continue;
    try{
      var adj=await _solPagoAdjuntarDeStorage(docs[i].url, docs[i].name||('comprobante_'+(i+1)+'.pdf'));
      if(adj){ window._mailAdj.push(adj); puestos.push(docs[i].name); }
    }catch(e){ console.warn('adjuntar comprobante:',e); }
  }
  mailPintarAdjuntos();
  if(aviso) aviso.innerHTML=puestos.length
    ? '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado de contabilidad: '+_esc(puestos.join(', '))+'</span>'
    : '<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No se pudo adjuntar el comprobante. Subilo a mano.</span>';
}

function _provCerrar(){
  var m=document.getElementById('modalProv'); if(m) m.remove();
  window._mailAdj=[]; window._provCtx=null;
}

function _provToggleCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('prov-cc'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('#prov-cc-chips .sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

async function _provEnviar(){
  var ctx=window._provCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid, tipo=ctx.tipo, pasoIdx=ctx.paso;

  var para=((document.getElementById('prov-para')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var cc=((document.getElementById('prov-cc')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var asunto=(document.getElementById('prov-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('prov-cuerpo')||{}).value||'';

  if(!para.length){ _mailMsg('Escribe el correo del proveedor.','err'); return; }
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(!(window._mailAdj||[]).length){
    if(!confirm('No hay ningún comprobante adjunto.\n\n¿Enviar el correo igual?')) return;
  }
  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('prov-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  var fila={
    docnum:String(oid), para_lista:todos, para_email:para[0],
    asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
    adjuntos:_dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
             .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
    de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
    origen:'Comprobante al proveedor · '+(tipo==='cancelacion'?'pago final':'depósito')+' · '+oid,
    estado:'pendiente'
  };
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text(); console.error('correo proveedor:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
    return;
  }

  // El paso queda en verde
  try{
    var st=STAGES.find(function(z){ return z.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid].deposito;
    if((sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      guardarEtapa(oid,'deposito');
    }
  }catch(e){ console.warn('marcar paso proveedor:',e); }

  var info={ fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
             asunto:asunto, cuerpo:cuerpo,
             adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; }) };
  _solEnvioGuardar(oid, 'proveedor_'+tipo, info);

  // Queda registrado en la solicitud, para verlo en las alertas
  try{
    var sols=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(oid) && x.tipo===tipo; });
    var campo=(tipo==='cancelacion')?'envio_final_proveedor':'envio_prov';
    for(var i=0;i<sols.length;i++){
      sols[i][campo]=info;
      var patch={}; patch[campo]=info;
      await _solPagoPatch(sols[i].id, patch);
    }
  }catch(e){ console.warn('registrar envio proveedor:',e); }

  _provCerrar();
  showT('✓ Comprobante enviado al proveedor');
  try{ openDetail(oid); }catch(e){}
  try{ _solPagoRefrescar(); }catch(e){}
}


// Archivos ya adjuntos en el subpaso: el comprobante que contabilidad subió
// ahí tiene que viajar en el correo a la compradora.
function _compAdjuntosDelPaso(oid, tipo){
  var esDeposito=(tipo!=='cancelacion');
  var subKey=_subKeyDeposito(esDeposito?_PASO_DEP_PROV:_PASO_PAGO_FINAL);
  var propios=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Sin los documentos base de la orden: esos ya los tiene compras
  var base={};
  try{ _docsBaseOrden(oid).forEach(function(a){ base[_docClave(a)]=1; }); }catch(e){}
  return _dedupDocs(propios).filter(function(a){ return !base[_docClave(a)]; });
}

async function _compAbrirModal(oid, tipo){
  // tipo: 'abono' -> depósito | 'cancelacion' -> cancelación
  var esDeposito=(tipo!=='cancelacion');
  var d=_solPagoDatosOrden(oid);
  var dest=_compDestinatarios(oid, tipo);
  var monto=_compMonto(oid, tipo);
  window._mailAdj=[];
  window._compCtx={oid:oid, tipo:tipo, paso:_pasoIdxDeposito(esDeposito?_PASO_DEP_PROV:_PASO_PAGO_FINAL)};

  var palabra = esDeposito ? 'depósito' : 'cancelación';
  var frase   = esDeposito ? 'del depósito realizado' : 'de la cancelación realizada';
  var pasoNom = esDeposito ? 'Depósito enviado al proveedor' : 'Solicitud de final del balance';
  var ordenTxt = d.dkc || String(oid);

  var asunto='['+ordenTxt+'] COMPROBANTE DE PAGO \u2192 '+pasoNom
    +(monto?(' \u00b7 '+fmt(monto)):'');

  var cuerpo='Estimada compradora,\n\n'
    +'Adjunto encontrará el comprobante '+frase+' al proveedor correspondiente.\n\n'
    +'Detalles del pago:\n'
    +'  \u2022 Proveedor: '+(d.proveedor||'')+'\n'
    +'  \u2022 Orden de Compra: '+ordenTxt+'\n'
    +(monto?('  \u2022 Monto: '+fmt(monto)+'\n'):'')
    +'\n'
    +'Favor de enviar este comprobante al proveedor y solicitar la confirmación de recibido.\n\n'
    +'Una vez que el proveedor confirme la recepción, le agradecemos responder este mismo correo '
    +'informando que el pago fue recibido, para mantener el seguimiento y control del proceso.\n\n'
    +'Quedamos atentos a cualquier consulta.\n\n'
    +'Saludos cordiales,\n'
    +'Departamento de Contabilidad\n'
    +(_firmaNombre()?(_firmaNombre()+'\n'):'')
    +'Kennedy Center Corp.';

  var chips=dest.lista.map(function(x){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(x.pidio?'#085041':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(x.pidio?'#E1F5EE':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(x.u.email)+'"'+(x.pidio?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(x.u.color||'#eee')+';color:'+(x.u.tc||'#333')
      +';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700">'
      +_esc((x.u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_esc(x.u.name)+'</span>'
      +(x.pidio?'<span style="font-size:9px;color:var(--t-verde2);font-weight:700">solicitó</span>':'')
      +'</label>';
  }).join('');

  // Los demás del equipo, para sumarlos con un clic
  var yaEn={}; dest.lista.forEach(function(x){ yaEn[String(x.u.email).toLowerCase()]=1; });
  var chipsOtros=(USERS||[]).filter(function(u){
    return u.email && !yaEn[String(u.email).toLowerCase()]
        && String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){
    return '<span class="sp-cc-chip" data-mail="'+_esc(u.email)+'" onclick="_compToggleExtra(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');

  var prev=document.getElementById('modalComprob'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalComprob';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-verde2)"><i class="ti ti-receipt"></i> Comprobante de '+palabra+'</div>'
      +'<button onclick="_compCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-verde2)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> \u00b7 orden '+_esc(ordenTxt)
      +'<div style="margin-top:3px">Total '+fmt(d.total)+' \u00b7 Abonado '+fmt(d.abonado)+' \u00b7 Saldo <b>'+fmt(d.saldo)+'</b></div>'
    +'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc((CU&&CU.name)||'')+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">Sale con tu dirección: las respuestas de compras te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — compradoras que solicitaron'
      +(dest.dept?(' \u00b7 '+_esc(dL(dest.dept))):'')+'</div>'
    +'<div id="comp-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +(chips||'<span style="font-size:12px;color:var(--text-danger)">No se encontraron compradoras para esta orden.</span>')+'</div>'
    +'<div id="comp-mas-chips" style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:6px">'+chipsOtros+'</div>'
    +'<input id="comp-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="comp-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="comp-cuerpo" rows="14" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">COMPROBANTE</div>'
    +'<label style="display:flex;align-items:center;gap:8px;padding:9px 11px;border:1.5px dashed #A9DFD0;border-radius:8px;cursor:pointer;background:var(--pastel-verde2);margin-bottom:7px">'
      +'<i class="ti ti-file-dollar" style="color:var(--t-verde2);font-size:16px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:11.5px;font-weight:700;color:var(--t-verde2)">COMPROBANTE DE LA TRANSFERENCIA</div>'
      +'<div id="comp-file-lbl" style="font-size:10.5px;color:var(--t-verde2);opacity:.8">Adjunta el comprobante del banco</div></div>'
      +'<input type="file" accept=".pdf,image/*,.xlsx,.xls,.doc,.docx" style="display:none" onchange="_compArchivo(this)"></label>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_compCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="comp-btn" style="background:#085041" onclick="_compEnviar()"><i class="ti ti-send"></i> Enviar comprobante a compras</button>'
    +'</div>'
  +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Se adjunta solo lo que ya está en este paso: el comprobante que
  // contabilidad subió ahí viaja en el correo a la compradora.
  var yaDelPaso=_compAdjuntosDelPaso(oid, tipo);
  if(yaDelPaso.length){
    _spCargando('Adjuntando el comprobante del paso…', yaDelPaso.length+' archivo(s)');
    var puestos=[];
    for(var i=0;i<yaDelPaso.length;i++){
      var a=yaDelPaso[i];
      if(!a.url) continue;
      try{
        var adj=await _solPagoAdjuntarDeStorage(a.url, a.name||('comprobante_'+(i+1)+'.pdf'));
        if(adj){ adj._marca='comprobante'; window._mailAdj.push(adj); puestos.push(a.name); }
      }catch(e){ console.warn('adjuntar del paso:',e); }
    }
    _spCargandoFin();
    mailPintarAdjuntos();
    var lbl=document.getElementById('comp-file-lbl');
    if(lbl && puestos.length){
      lbl.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '
        +_esc(puestos.join(', '))+' <span style="opacity:.75">(ya estaba en el paso)</span>';
    }
  }
}

// Marca o desmarca un destinatario extra
function _compToggleExtra(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('comp-extra'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('#comp-mas-chips .sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

function _compCerrar(){
  var m=document.getElementById('modalComprob'); if(m) m.remove();
  window._mailAdj=[]; window._compCtx=null;
}

function _compArchivo(input){
  var f=input.files&&input.files[0]; if(!f) return;
  _solPagoAdjuntarFile(f, 'comprobante');
  var lbl=document.getElementById('comp-file-lbl');
  if(lbl) lbl.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '+_esc(f.name);
}

async function _compEnviar(){
  var ctx=window._compCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid, tipo=ctx.tipo, pasoIdx=ctx.paso;

  var box=document.getElementById('comp-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ _mailMsg('Marca al menos una compradora.','err'); return; }

  var asunto=(document.getElementById('comp-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('comp-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(!(window._mailAdj||[]).length){
    if(!confirm('No adjuntaste el comprobante.\n\n¿Enviar el correo igual?')) return;
  }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('comp-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var extra=((document.getElementById('comp-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=marcados.map(function(c){ return c.value; }).concat(extra);
  // Sin repetidos, por si un correo está marcado y además escrito
  var vistosD={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistosD[k]) return false; vistosD[k]=1; return true; });
  var fila={
    docnum:String(oid),
    para_lista: todos,
    para_email: todos[0],
    asunto: asunto,
    cuerpo: _repCuerpoTexto(cuerpo),
    adjuntos: _dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
              .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
    de_nombre:(CU&&CU.name)||'',
    de_email:(CU&&CU.email)||'',
    origen:'Comprobante de '+(tipo==='cancelacion'?'cancelación':'depósito')+' · '+oid,
    estado:'pendiente'
  };
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text(); console.error('correo comprobante:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar comprobante a compras'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar comprobante a compras'; }
    return;
  }

  // El paso queda en verde y se guarda lo que se envió
  try{
    var st=STAGES.find(function(z){ return z.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid].deposito;
    if((sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      guardarEtapa(oid,'deposito');
    }
  }catch(e){ console.warn('marcar paso comprobante:',e); }

  var info={
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo,
    adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; })
  };
  _solEnvioGuardar(oid, 'comprobante_'+tipo, info);

  // Lo que se adjuntó en el correo y todavía no estaba en el paso, se sube ahí:
  // así el comprobante queda archivado en la etapa aunque se haya elegido
  // desde el modal.
  try{
    var subKey=_subKeyDeposito((tipo==='cancelacion')?_PASO_PAGO_FINAL:_PASO_DEP_PROV);
    var yaEnPaso={};
    ((window._atts&&window._atts[oid+subKey])||[]).forEach(function(a){ yaEnPaso[_docClave(a)]=1; });
    var baseOrden={};
    try{ _docsBaseOrden(oid).forEach(function(a){ baseOrden[_docClave(a)]=1; }); }catch(e){}
    var nuevos=(window._mailAdj||[]).filter(function(a){
      var k=_docClave({name:a.nombre});
      return k && !yaEnPaso[k] && !baseOrden[k] && a.contenido;
    });
    for(var n=0;n<nuevos.length;n++){
      var a=nuevos[n];
      var bin=atob(a.contenido);
      var arr=new Uint8Array(bin.length);
      for(var b=0;b<bin.length;b++) arr[b]=bin.charCodeAt(b);
      var file=new File([arr], a.nombre, {type:a.mime||'application/octet-stream'});
      var pth=await _subirDocStorage(oid, subKey, file);
      if(pth){
        var regDoc=await _registrarDoc(oid, subKey, file, pth);
        if(!window._atts) window._atts={};
        if(!window._atts[oid+subKey]) window._atts[oid+subKey]=[];
        window._atts[oid+subKey].push({ id:regDoc?regDoc.id:undefined, name:a.nombre,
          data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
          url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
      }
    }
  }catch(e){ console.warn('guardar comprobante en el paso:',e); }

  // La solicitud pasa a "abono enviado" o "cancelación realizada"
  try{
    var sols=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(oid) && x.tipo===tipo; });
    var nuevo=(tipo==='cancelacion')?'cancelacion_realizada':'abono_enviado';
    for(var i=0;i<sols.length;i++){
      sols[i].estado=nuevo; sols[i].finalizado_en=new Date().toISOString();
      await _solPagoPatch(sols[i].id,{estado:nuevo, finalizado_en:sols[i].finalizado_en, envio_comprobante:info});
      try{ _solPagoAvisarSolicitante(sols[i], null); }catch(e){}
    }
  }catch(e){ console.warn('estado solicitud:',e); }

  // Con el comprobante del DEPÓSITO se escribe el abono en la propia orden
  // de SAP: U_ABONO con el monto y U_FecAbono con la fecha de hoy, por DI
  // API. Así el portal y SAP dicen lo mismo sin que nadie lo copie a mano.
  if(tipo!=='cancelacion'){
    try{ await _abonoAnotarEnSAP(oid); }catch(e){ console.warn('[abono] SAP:', e); }
  }

  _compCerrar();
  showT('✓ Comprobante enviado a '+todos.length+' compradora(s)');
  try{ openDetail(oid); }catch(e){}
  try{ _solPagoRefrescar(); }catch(e){}
}

async function _solPagoAbrirModal(oid, tipo, ctx){
  window._solPagoTipoActual=tipo;
  // «ctx» permite abrir esta misma pantalla para algo que no es una orden
  // —una factura reserva, por ejemplo— sin duplicar la plantilla del correo.
  var d = (ctx && ctx.datos) ? ctx.datos : _solPagoDatosOrden(oid);
  var esAbono=(tipo==='abono');
  // El abono ya viene leído de la proforma cuando se cargó la orden (los
  // términos de pago dicen el porcentaje del depósito), así que se propone ese
  // monto en vez de arrancar en cero. Sigue siendo editable, por monto o por
  // porcentaje, igual que hasta ahora.
  // En cancelación se propone el saldo pendiente, que es lo que se cancela.
  var montoSug=esAbono ? (Number(d.abonado)||0) : d.saldo;
  if(montoSug<0) montoSug=0;
  var pctSug=(d.total>0 && montoSug>0) ? (Math.round((montoSug/d.total)*10000)/100) : null;
  var _abonoDeProforma=esAbono && montoSug>0;
  window._mailAdj=[];
  window._spc=null;
  window._solPagoCtx={oid:oid, tipo:tipo, factura:(ctx&&ctx.factura)||null};

  var cts=(USERS||[]).filter(function(u){ return u.role==='contabilidad' && u.email; });
  var chips=cts.map(function(u){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid var(--border);border-radius:8px;cursor:pointer;font-size:12px;background:var(--surface-0)">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" checked style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')+';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700">'
      +_esc((u.name||'?').split(' ').map(function(x){return x[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_esc(u.name)+'</span></label>';
  }).join('');

  // Sugerencias de CC: el equipo de compras del departamento y gerencia
  var yo=((CU&&CU.email)||'').toLowerCase();
  var ccCand=(USERS||[]).filter(function(u){
    if(!u.email || u.email.toLowerCase()===yo) return false;
    if(u.role==='gerencia') return true;
    return CU && u.role===CU.role && (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()));
  });
  var ccChips=ccCand.map(function(u){
    return '<span class="sp-cc-chip" data-mail="'+_esc(u.email)+'" onclick="_solPagoToggleCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');

  var titulo=esAbono?'Solicitud de abono':'Solicitud de cancelación de saldo';
  var color=esAbono?'#166534':'#B45309';
  var bg=esAbono?'#dcfce7':'#FEF9F3';
  var bd=esAbono?'#16a34a':'#E9C08A';

  var fac=(ctx&&ctx.factura)||null;
  var asunto, cuerpo;
  if(fac){
    // Misma plantilla, con los datos de la factura reserva
    asunto='Solicitud de cancelación - Factura reserva '
      +(fac.numatcard||('#'+fac.docnum))
      +(fac.cardname?(' - '+fac.cardname):'');
    cuerpo='Estimados Contabilidad,\n\n'
      +'Solicito la cancelación de la siguiente factura de reserva:\n\n'
      +'Factura de reserva: '+(fac.numatcard||'')+'\n'
      +'N.º en SAP: '+fac.docnum+'\n'
      +'Proveedor: '+(fac.cardname||fac.cardcode||'')+'\n'
      +(fac.ordenes?('Órdenes de compra: '+fac.ordenes+'\n'):'')
      +'Fecha: '+_fechaCorta(fac.docdate)+'\n'
      +(fac.docduedate?('Vencimiento: '+_fechaCorta(fac.docduedate)+'\n'):'')
      +'Total de la factura: '+fmt(fac.doctotal)+'\n'
      +(Number(fac.paidsum)?('Ya pagado: '+fmt(fac.paidsum)+'\n'):'')
      +(fac.bl?('BL: '+fac.bl+'\n'):'')
      +(fac.contenedores?('Contenedores: '+fac.contenedores+'\n'):'')
      +(fac.naviera?('Naviera: '+fac.naviera+'\n'):'')
      +(fac.fecha_eta?('ETA: '+_fechaCorta(fac.fecha_eta)+'\n'):'')
      +'\nMonto solicitado: '+fmt(montoSug)+'\n\n'
      +_solPagoBloqueBanco(null)
      +'\nAdjunto la factura de reserva.\n\n'
      +'Saludos,\n'+_firmaNombre()+'\nKennedy Center Corp.';
  } else {
  var asunto2=titulo+' - Orden '+oid+(d.dkc?(' / '+d.dkc):'')+(d.proveedor?(' - '+d.proveedor):'');
  asunto=asunto2;
  cuerpo='Estimados Contabilidad,\n\n'
    +(esAbono
      ? 'Solicito el envío del abono para la siguiente orden de compra:\n\n'
      : 'Solicito la cancelación del saldo final de la siguiente orden de compra:\n\n')
    +'Orden: '+oid+'\n'
    +(d.dkc?('DKC (Vendor Ref No): '+d.dkc+'\n'):'')
    +'Proveedor: '+d.proveedor+'\n'
    +'Departamento: '+dL(d.dept||'')+'\n'
    +'Total de la orden: '+fmt(d.total)+'\n'
    +(d.eta?('ETA (fecha de llegada): '+d.eta+'\n'):'')
    +'\nMonto solicitado: '+fmt(montoSug)+'\n\n'
    +_solPagoBloqueBanco(null)
    +'\nAdjunto la orden de Kennedy y la del proveedor firmadas por gerencia, y la debida diligencia.\n\n'
    +'Saludos,\n'+_firmaNombre()+'\nKennedy Center Corp.';
  }

  var ov=document.createElement('div');
  ov.id='modalSolPago';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:'+color+'"><i class="ti '+(esAbono?'ti-coin':'ti-file-invoice')+'"></i> '+titulo+'</div>'
      +'<button onclick="_solPagoCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="background:'+bg+';border:1px solid '+bd+';border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:'+color+'">'
      +'<b>'+_esc(d.proveedor||'')+'</b> · orden '+_esc(String(oid))+(d.dkc?(' · DKC <b>'+_esc(d.dkc)+'</b>'):'')
      +'<div style="margin-top:3px">Total '+fmt(d.total)+' · Abonado '+fmt(d.abonado)+' · Saldo <b>'+fmt(d.saldo)+'</b>'+(d.eta?(' · ETA '+_esc(d.eta)):'')+'</div>'
    +'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc((CU&&CU.name)||'')+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">Sale con tu dirección y las respuestas te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — equipo de contabilidad</div>'
    +'<div id="mail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'
      +(chips||'<span style="font-size:12px;color:var(--text-danger)">No hay usuarios de contabilidad con correo.</span>')+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">CC — copia (opcional)</div>'
    +'<div id="sp-cc-chips" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:5px">'+ccChips+'</div>'
    +'<input id="sp-cc" placeholder="otros@correo.com, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MONTO SOLICITADO</div>'
    +'<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;margin-bottom:4px">'
      +'<div><div style="font-size:10px;color:var(--text-muted);margin-bottom:2px">% de la factura</div>'
        +'<div style="display:flex;align-items:center;gap:4px">'
          +'<input id="sp-pct" type="number" step="0.01" min="0" max="100" value="'+(esAbono?(pctSug!=null?pctSug:''):'100')+'" placeholder="0" oninput="_solPagoCalcMonto()" '
          +'style="width:92px;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:14px;font-weight:700;background:var(--surface-2);color:var(--text-primary)">'
          +'<span style="font-size:14px;font-weight:700;color:var(--text-muted)">%</span></div></div>'
      +'<div style="font-size:18px;color:var(--text-muted);padding-bottom:6px">=</div>'
      +'<div><div style="font-size:10px;color:var(--text-muted);margin-bottom:2px">Monto a enviar</div>'
        +'<input id="sp-monto" type="number" step="0.01" value="'+montoSug.toFixed(2)+'" oninput="_solPagoCalcPct()" '
        +'style="width:170px;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:15px;font-weight:700;background:var(--surface-2);color:var(--text-primary)"></div>'
      +'<div style="display:flex;gap:4px;padding-bottom:6px">'
        +'<span onclick="_solPagoSetPct(10)" class="sp-q">10%</span>'
        +'<span onclick="_solPagoSetPct(20)" class="sp-q">20%</span>'
        +'<span onclick="_solPagoSetPct(25)" class="sp-q">25%</span>'
        +'<span onclick="_solPagoSetPct(50)" class="sp-q">50%</span>'
        +'<span onclick="_solPagoSetPct(100,\'bl\')" class="sp-q" '
        +'style="border-color:var(--t-verde3);color:var(--t-verde);background:var(--pastel-ok)" '
        +'title="Sin abono previo: se paga el total contra la copia del B/L">'
        +'100% contra B/L</span>'
      +'</div>'
    +'</div>'
    +'<div id="sp-calc" style="font-size:10.5px;color:var(--text-muted);margin-bottom:12px">Base: total de la orden '+fmt(d.total)+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="mail-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="mail-cuerpo" rows="9" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'

    +(esAbono?'':_spcBloqueHtml())
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="sp-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Buscando las órdenes firmadas…</div>'
    +'<label style="display:flex;align-items:center;gap:8px;padding:9px 11px;border:1.5px dashed #C4B5FD;border-radius:8px;cursor:pointer;background:#F7F5FF;margin-bottom:7px">'
      +'<i class="ti ti-file-certificate" style="color:var(--t-lila);font-size:16px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:11.5px;font-weight:700;color:var(--t-lila)">DEBIDA DILIGENCIA DEL PROVEEDOR</div>'
      +'<div id="sp-dd-lbl" style="font-size:10.5px;color:var(--t-lila);opacity:.8">Adjunta el documento de debida diligencia</div></div>'
      +'<input type="file" accept=".pdf,.doc,.docx,.xlsx,.xls,image/*" style="display:none" onchange="_solPagoDD(this)"></label>'
    +'<div id="sp-banco" style="font-size:11px;margin-bottom:7px"></div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_solPagoCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="mail-btn" style="background:'+color+'" onclick="_solPagoEnviar()"><i class="ti ti-send"></i> Enviar a contabilidad</button>'
    +'</div>'
  +'</div>';
  // No se cierra al hacer clic fuera: hay datos escritos
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
  // La comprobación contra la factura reserva arranca ya, en paralelo
  if(!esAbono){ try{ _spcIniciar(oid, fac); }catch(e){ console.warn('[SPC]', e); } }

  // El monto propuesto viene de la proforma: se deja dicho para que se sepa
  // de dónde salió y se pueda cambiar con confianza.
  if(_abonoDeProforma){
    try{ _solPagoNota('Monto tomado de la proforma: '+(pctSug!=null?(pctSug.toFixed(2)+'% de '+fmt(d.total)+' = '):'')
      +'<b>'+fmt(montoSug)+'</b>. Puedes cambiarlo por monto o por porcentaje.'); }catch(e){}
  }

  // Adjuntar solas las DOS órdenes firmadas por gerencia
  var aviso=document.getElementById('sp-auto');
  _spCargando('Analizando los documentos de la orden…','Buscando las órdenes firmadas por gerencia');
  try{
    var r=await _solPagoAdjuntarFirmadas(oid);
    mailPintarAdjuntos();
    if(aviso){
      var h2='';
      if(r.puestos.length) h2+='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '+r.puestos.join(' y ')+'.</span>';
      if(r.faltan.length)  h2+=(h2?'<br>':'')+'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Falta '+r.faltan.join(' y ')+'. Adjuntalo a mano.</span>';
      aviso.innerHTML=h2||'<span style="color:var(--t-ambar)">No se encontraron documentos firmados para esta compra.</span>';
    }
  }catch(e){ console.warn('adjuntar firmadas:',e); if(aviso) aviso.innerHTML='<span style="color:var(--text-danger)">No se pudieron adjuntar las órdenes firmadas.</span>'; }

  // Leer las instrucciones bancarias del documento del proveedor
  if(esAbono){
    var av=document.getElementById('sp-banco');
    if(av) av.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo las instrucciones bancarias con AI…</span>';
    _spCargando('Leyendo las instrucciones bancarias con AI…','Puede tardar unos segundos según el tamaño del documento');
    try{
      var banco=await _solPagoLeerBanco(oid);
      _solPagoPonerBanco(banco||{});
      _solPagoAvisoBanco(banco);
      // El porcentaje de anticipo que pide el proveedor se escribe solo
      try{ _solPagoAplicarPct(banco); }catch(e){}
    }catch(e){ console.warn('banco:',e); _solPagoAvisoBanco(null); }
  } else {
    var av2=document.getElementById('sp-banco'); if(av2) av2.style.display='none';
  }
  _spCargandoFin();
}

function _solPagoCerrar(){
  _spCargandoFin();
  var m=document.getElementById('modalSolPago'); if(m) m.remove();
  window._mailAdj=[];
  window._solPagoCtx=null;
  window._spc=null;
}

async function _solPagoEnviar(){
  var ctx=window._solPagoCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid, tipo=ctx.tipo;

  var box=document.getElementById('mail-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ _mailMsg('Marca al menos un destinatario de contabilidad.','err'); return; }

  var asunto=(document.getElementById('mail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('mail-cuerpo')||{}).value||'';
  var monto=parseFloat((document.getElementById('sp-monto')||{}).value)||0;
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(monto<=0){ _mailMsg('El monto solicitado tiene que ser mayor a cero.','err'); return; }

  // Cancelación: antes, la factura del proveedor contra la factura reserva
  var _spcV=(tipo==='cancelacion') ? _spcValidar() : {ok:true};
  if(!_spcV.ok){
    _mailMsg(_spcV.msg,'err');
    try{ document.getElementById('sp-comprob').scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){}
    return;
  }
  if(_spcV.texto) cuerpo=cuerpo.replace(/\s+$/,'')+'\n\n'+_spcV.texto;

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('mail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  _mailMsg('','info');

  var d=_solPagoDatosOrden(oid);
  var cc=((document.getElementById('sp-cc')||{}).value||'')
          .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=marcados.map(function(c){return c.value;}).concat(cc);
  var fila={
    docnum: String(oid),
    para_lista: todos,
    para_email: marcados[0].value,
    asunto: asunto,
    cuerpo: _repCuerpoTexto(cuerpo),
    adjuntos: _dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
                .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
    de_nombre: (CU&&CU.name)||'',
    de_email:  (CU&&CU.email)||'',
    origen: (tipo==='abono'?'Solicitud de abono · ':'Solicitud de cancelación · ')+oid,
    estado: 'pendiente'
  };

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      console.error('correo solicitud:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar a contabilidad'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar a contabilidad'; }
    return;
  }

  // Registrar la solicitud para las alertas y el reporte de contabilidad
  var nota=(window._mailAdj||[]).length+' adjunto(s) · enviado a '+fila.para_lista.join(', ');
  var reg=await _solPagoCrear(oid, tipo, monto, nota);
  // El resultado de la comprobación queda en la solicitud, para contabilidad
  if(reg && _spcV.resumen){
    reg.comprobacion=_spcV.resumen;
    try{
      var _okC=await _solPagoPatch(reg.id,{comprobacion:_spcV.resumen});
      if(!_okC) console.warn('[SPC] no se guardó la comprobación: ¿corriste solicitudes_comprobacion.sql?');
    }catch(e){}
  }
  // OJO: el resumen del correo se arma MÁS ABAJO. Aquí todavía no existe, así
  // que este era el motivo de que el correo nunca llegara a la solicitud y
  // contabilidad viera "el detalle se ve desde el equipo que lo envió".
  // Se guarda al final, ya con el id de la solicitud.

  // El paso queda en verde y se guarda todo lo que se envió
  try{
    var pasoIdx=_pasoIdxDeposito((tipo==='abono')?_PASO_SOL_ABONO:_PASO_PAGO_FINAL);
    var st=STAGES.find(function(z){ return z.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid].deposito;
    if((sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'deposito');
    }
    // Resumen del correo, para que contabilidad vea qué se mandó.
    // Se guarda también la ruta de cada adjunto: así cualquier equipo puede
    // abrirlos e imprimirlos, no solo el que envió.
    window._solEnvioPendiente={
      fecha:new Date().toISOString(),
      por:(CU&&CU.name)||'',
      para:todos,
      asunto:asunto,
      cuerpo:cuerpo,
      adjuntos:(window._mailAdj||[]).map(function(a){
        return {nombre:a.nombre, kb:a.kb||0, path:a.path||a.url||'', mime:a.mime||''};
      }),
      monto:monto
    };
    if(reg) reg.envio=window._solEnvioPendiente;
    _solEnvioGuardar(oid, tipo, window._solEnvioPendiente, reg && reg.id);
  }catch(e){ console.warn('marcar paso deposito:',e); }

  _solPagoCerrar();
  showT('✓ '+(tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación')+' enviada a contabilidad'
        +(reg?'':' (el correo salió, pero no se registró en el listado)'));
  try{ renderNP(); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  Solicitudes de pago — recibido, comentarios, estados y avisos (v45)
// ═══════════════════════════════════════════════════════════════════════════
function _fechaHora(iso){ if(!iso) return ''; try{ var d=new Date(iso); if(isNaN(d)) return String(iso); return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'})+' · '+d.toLocaleTimeString('es-PA',{hour:'2-digit',minute:'2-digit'}); }catch(e){ return String(iso); } }
function _solPagoPorId(id){ return (window._solPago||[]).find(function(x){ return String(x.id)===String(id); }); }
function _solMias(x){ return CU && (String(x.solicitado_por||'')===String(CU.name||'') || (_deptAcotado() && _deptPermitido(normDept(x.dept||'')))); }
function _solComents(x){ var c=x&&x.comentarios; if(!c) return []; if(typeof c==='string'){ try{ c=JSON.parse(c); }catch(e){ return []; } } return Array.isArray(c)?c:[]; }
function _solSeenKey(){ return 'solpago_seen_'+((CU&&CU.id)||'x'); }
// Respaldo en memoria: si localStorage está bloqueado (modo privado, iframe de
// Shopify, cookies restringidas) el marcador de leído se perdía y el punto rojo
// volvía a aparecer en cada repintado.
window._solSeenMem = window._solSeenMem || {};
function _solSeenGet(){
  var m={};
  try{ m=JSON.parse(localStorage.getItem(_solSeenKey())||'{}')||{}; }catch(e){ m={}; }
  var mem=window._solSeenMem||{};
  for(var k in mem){ if(Number(mem[k]||0) > Number(m[k]||0)) m[k]=mem[k]; }
  return m;
}
function _solSeenSet(m){
  window._solSeenMem=Object.assign({}, window._solSeenMem||{}, m||{});
  try{ localStorage.setItem(_solSeenKey(), JSON.stringify(m)); }catch(e){}
}
// Cuántos comentarios leyó cada usuario, guardado en la propia solicitud.
// Así el estado sobrevive al recargar y lo ve también la otra parte.
function _solLeidos(x){
  var l=x&&x.leidos;
  if(typeof l==='string'){ try{ l=JSON.parse(l); }catch(e){ l={}; } }
  return (l&&typeof l==='object')?l:{};
}
function _solMarcarLeido(x){
  if(!x||!CU) return;
  var cs=_solComents(x);
  var l=_solLeidos(x);
  if(Number(l[CU.id]||0)>=cs.length) { var s0=_solSeenGet(); s0[x.id]=cs.length; _solSeenSet(s0); return; }
  l[CU.id]=cs.length;
  l['_n_'+CU.id]=(CU.name||'');
  l['_f_'+CU.id]=new Date().toISOString();
  x.leidos=l;
  var seen=_solSeenGet(); seen[x.id]=cs.length; _solSeenSet(seen);
  _solPagoPatch(x.id,{leidos:l});   // si la columna no existe, el patch la descarta solo
}
function _solTieneComentNuevo(x){
  var cs=_solComents(x);
  if(!cs.length) return false;
  var last=cs[cs.length-1];
  if(!last) return false;
  if(String(last.autor||'')===String((CU&&CU.name)||'')) return false;
  // Primero lo guardado en la solicitud; si no, el respaldo local
  var l=_solLeidos(x);
  if(CU && l.hasOwnProperty(CU.id)) return Number(l[CU.id]||0) < cs.length;
  var seen=_solSeenGet();
  return (Number(seen[x.id]||0) < cs.length);
}
// Quién leyó los comentarios, para que el solicitante lo sepa
function _solLeidoPor(x){
  var l=_solLeidos(x), cs=_solComents(x);
  if(!cs.length) return '';
  var yo=(CU&&CU.id)||'';
  var otros=[];
  for(var k in l){
    if(k.indexOf('_n_')===0 || k.indexOf('_f_')===0) continue;
    if(k===yo) continue;
    if(Number(l[k]||0)>=cs.length) otros.push(l['_n_'+k]||k);
  }
  if(!otros.length) return '';
  return '<span title="Ya vio los comentarios" style="font-size:10px;color:#2a9df4;font-weight:600;white-space:nowrap">'
    +'<i class="ti ti-checks" style="font-size:12px;vertical-align:-2px"></i> Leído por '+_esc(otros.join(', '))+'</span>';
}

// Resumen de lo que compras envió, para que contabilidad lo vea en la etapa
window._solEnvios=window._solEnvios||{};
function _solEnvioKey(oid,tipo){ return String(oid)+'_'+tipo; }
function _solEnvioGuardar(oid,tipo,info,solId){
  window._solEnvios[_solEnvioKey(oid,tipo)]=info;
  try{ localStorage.setItem('sol_envio_'+_solEnvioKey(oid,tipo), JSON.stringify(info)); }catch(e){}
  // También en la solicitud, para que el correo se vea desde CUALQUIER equipo
  // y no solo desde el navegador de quien lo envió.
  if(solId){
    try{
      Promise.resolve(_solPagoPatch(solId, {envio:info})).then(function(ok){
        if(!ok){
          // Antes esto solo iba a la consola, que nadie mira. El envío se
          // quedaba en el navegador de quien lo mandó y el resto del equipo
          // no veía ni el correo ni sus adjuntos, sin enterarse de por qué.
          console.error('[solicitud] el correo no se pudo guardar en la base. '
            +'Si falta la columna "envio" en solicitudes_pago, hay que crearla; '
            +'mientras tanto el detalle solo se verá en este equipo.');
          try{
            showT('⚠ El correo se envió, pero el detalle y sus adjuntos solo se '
              +'ven en ESTE equipo. Falta la columna «envio» en solicitudes_pago '
              +'(script solicitudes_envio.sql).', 14000);
          }catch(e){}
        }
      });
    }catch(e){ console.warn('guardar envío:',e); }
  } else {
    console.warn('[solicitud] sin id: el correo queda solo en este equipo.');
  }
}
function _solEnvioLeer(oid,tipo){
  var k=_solEnvioKey(oid,tipo);
  // 1) Lo guardado en la solicitud: lo ve cualquiera, también contabilidad
  var x=(window._solPago||[]).find(function(s){ return String(s.docnum)===String(oid) && s.tipo===tipo; });
  if(x && x.envio){
    var e=x.envio;
    if(typeof e==='string'){ try{ e=JSON.parse(e); }catch(err){ e=null; } }
    if(e && (e.cuerpo||e.asunto)) return e;
  }
  // 2) Lo del propio navegador
  if(window._solEnvios[k]) return window._solEnvios[k];
  try{ var v=localStorage.getItem('sol_envio_'+k); if(v) return JSON.parse(v); }catch(e){}
  // 3) Como último recurso, lo básico de la solicitud
  if(x) return {fecha:x.solicitado_en, por:x.solicitado_por, monto:x.monto, nota:x.nota, _parcial:true};
  return null;
}

// Panel de solo lectura con lo que se envió
var _SOL_TITULOS={
  'abono':'Solicitud de abono enviada a contabilidad',
  'cancelacion':'Solicitud de cancelación enviada a contabilidad',
  'comprobante_abono':'Comprobante del depósito enviado a compras',
  'comprobante_cancelacion':'Comprobante del pago final enviado a compras',
  'proveedor_abono':'Comprobante del depósito enviado al proveedor',
  'proveedor_cancelacion':'Comprobante del pago final enviado al proveedor'
};
function _solEnvioPanel(oid, tipo){
  var e=_solEnvioLeer(oid,tipo);
  if(!e) return '';
  var titulo=_SOL_TITULOS[tipo]||'Correo enviado';
  var h='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:5px"><i class="ti ti-circle-check"></i> '+titulo+'</div>'
    +'<div style="font-size:11px;color:var(--t-verde);line-height:1.6">'
      +(e.por?('Enviado por <b>'+_esc(e.por)+'</b>'):'')
      +(e.fecha?(' · '+_esc(_fechaHora(e.fecha))):'')
      +(e.monto?('<br>Monto solicitado: <b>'+fmt(e.monto)+'</b>'):'')
      +(e.para&&e.para.length?('<br>Para: '+_esc(e.para.join(', '))):'')
      +(e.asunto?('<br>Asunto: '+_esc(e.asunto)):'')
    +'</div>';
  if(e.adjuntos&&e.adjuntos.length){
    h+='<div style="margin-top:6px"><div style="font-size:10px;text-transform:uppercase;color:var(--t-verde);font-weight:700;margin-bottom:3px">Adjuntos enviados</div>';
    e.adjuntos.forEach(function(a){
      h+='<div style="font-size:11px;color:var(--t-verde)"><i class="ti ti-paperclip" style="font-size:11px"></i> '+_esc(a.nombre)+(a.kb?(' · '+a.kb+' KB'):'')+'</div>';
    });
    h+='</div>';
  }
  if(e.cuerpo){
    // Para contabilidad el cuerpo es lo que tiene que leer para trabajar la
    // solicitud, así que en las solicitudes viene abierto en vez de plegado.
    var _abierto=(tipo==='abono'||tipo==='cancelacion') && CU && (CU.role==='contabilidad'||CU.role==='gerencia');
    h+='<details'+(_abierto?' open':'')+' style="margin-top:6px"><summary style="font-size:10.5px;color:var(--t-verde);cursor:pointer;font-weight:600">Ver el mensaje enviado</summary>'
      +'<div style="font-size:11px;color:var(--t-verde);white-space:pre-wrap;background:var(--surface-0);border-radius:7px;padding:8px 10px;margin-top:5px;max-height:260px;overflow-y:auto">'+_esc(e.cuerpo)+'</div></details>';
  }
  // Imprimir la solicitud tal como llegó: el cuerpo del correo y la lista de
  // adjuntos (PI del proveedor, orden de KCC y debida diligencia si la hubo).
  if(tipo==='abono'||tipo==='cancelacion'){
    h+='<div style="margin-top:8px">'
      +'<button class="btn bg2" style="padding:5px 11px;font-size:10.5px;font-weight:600;color:var(--t-verde)"'
      +' onclick="_solImprimirSolicitud(\''+_esc(String(oid))+'\',\''+tipo+'\')">'
      +'<i class="ti ti-printer"></i> Imprimir solicitud</button></div>';
  }
  if(e._parcial) h+='<div style="font-size:10px;color:var(--t-verde);opacity:.8;margin-top:5px">El detalle completo del correo se ve desde el equipo que lo envió.</div>';
  h+='</div>';
  return h;
}

// Hitos del proceso con fecha, hora y quién lo hizo
// Los archivos que acompañan a un hito, para poder abrirlos desde la alerta
function _solHitoAdjuntos(info){
  var a=(info&&info.adjuntos)||[];
  if(!a.length) return '';
  return '<div style="display:flex;gap:4px;flex-wrap:wrap;margin-top:3px">'
    +a.map(function(f){
      var nom=String(f.nombre||f.name||'');
      var url=f.url?(DOCS_BASE+String(f.url).split('/').map(encodeURIComponent).join('/')):'';
      var t=_prevTipo(nom);
      var ico=(t==='img')?'ti-photo':((t==='pdf')?'ti-file-type-pdf':'ti-file');
      return '<span'+(url?_prevAttrs(url,nom):'')
        +(url?(' onclick="event.stopPropagation();verArchivo(\''+_esc(url)+'\',\''+_esc(nom.replace(/\x27/g,''))+'\')"'):'')
        +' style="display:inline-flex;align-items:center;gap:4px;background:var(--surface-1);'
        +'border:0.5px solid var(--border);border-radius:14px;padding:2px 8px;font-size:10px;'
        +(url?'cursor:pointer;color:var(--text-accent)':'color:var(--text-muted)')+'" title="'+_esc(nom)+'">'
        +'<i class="ti '+ico+'" style="font-size:11px"></i>'
        +_esc(nom.length>26?(nom.slice(0,24)+'…'):nom)+'</span>';
    }).join('')+'</div>';
}

function _solHitos(x){
  if(!x) return '';
  var hitos=[];
  if(_solFechaSol(x)) hitos.push({t:'Solicitada', q:x.solicitado_por, f:_solFechaSol(x), c:'#0c447c'});
  if(x.recibido_en)   hitos.push({t:'Recibida en contabilidad', q:x.recibido_por, f:x.recibido_en, c:'#B45309'});
  var ec=x.envio_comprobante;
  if(typeof ec==='string'){ try{ ec=JSON.parse(ec); }catch(e){ ec=null; } }
  if(ec && ec.fecha) hitos.push({t:(x.tipo==='cancelacion'?'Pago final enviado a compras':'Abono enviado a compras'),
                                 q:ec.por, f:ec.fecha, c:'#166534', info:ec});
  else if(x.finalizado_en) hitos.push({t:(x.tipo==='cancelacion'?'Cancelación realizada':'Abono enviado'), q:'', f:x.finalizado_en, c:'#166534'});
  var ep=(x.tipo==='cancelacion')?x.envio_final_proveedor:x.envio_prov;
  if(typeof ep==='string'){ try{ ep=JSON.parse(ep); }catch(e){ ep=null; } }
  if(ep && ep.fecha) hitos.push({t:(x.tipo==='cancelacion'?'Pago final enviado al proveedor':'Comprobante enviado al proveedor'),
                                 q:ep.por, f:ep.fecha, c:'#5B21B6', info:ep});
  if(!hitos.length) return '';
  return '<div style="margin-top:5px;display:flex;flex-direction:column;gap:2px">'
    +hitos.map(function(z){
      return '<div style="font-size:10px;color:var(--text-muted);display:flex;align-items:center;gap:5px">'
        +'<span style="width:6px;height:6px;border-radius:50%;background:'+z.c+';flex-shrink:0"></span>'
        +'<b style="color:'+z.c+'">'+_esc(z.t)+'</b>'
        +(z.q?(' \u00b7 '+_esc(z.q)):'')
        +' \u00b7 '+_esc(_fechaHoraDia(z.f))
        +(z.info?_solHitoAdjuntos(z.info):'')+'</div>';
    }).join('')+'</div>';
}

// ── La casilla de "pagada", solo para las cargadas del Excel ──
// Las 21 solicitudes que venían del Excel de pagos son órdenes viejas que
// contabilidad trabaja a mano: no pasan por las etapas del portal, así que
// no tienen forma de darse por cerradas. Con esta casilla se marcan como
// pagadas y dejan de aparecer en las alertas.
// Las solicitudes nacidas dentro del portal NO la llevan: esas se cierran
// con su comprobante, como siempre.
function _esDelExcel(x){
  return !!(x && (x.origen==='excel' || /^Del Excel de pagos/.test(String(x.nota||''))));
}

function _solPagadaYa(x){
  return !!(x && (x.pagado===true || x.pagado==='true'));
}

// La casilla existe en dos sitios: el panel del reporte y la pantalla de
// alertas. Se repinta el que esté abierto, para no cerrar el panel al
// marcar ni dejar la otra pantalla desactualizada.
function _solRepintarDondeEste(){
  var abierto=false;
  try{
    var m=document.getElementById('modal');
    abierto = m && m.style.display==='flex'
              && (document.getElementById('mc')||{}).innerHTML.indexOf('Abonos y cancelaciones')>=0;
  }catch(e){}
  if(abierto){ try{ _solPagoPanel(); }catch(e){} return; }
  try{ rAlertas(); }catch(e){}
}

// La marca de financiada, tal como venía en la columna FINAN del Excel.
// Es informativa: dice que ese pago se financió con el banco.
function _solFinanciadoChip(x){
  if(!_esDelExcel(x) || x.financiado!==true) return '';
  return '<span title="Pago financiado con el banco'
    + (x.banco?(' · '+_esc(x.banco)):'') + '" '
    + 'style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;'
    + 'background:#EEF2FF;color:var(--t-indigo2);border:0.5px solid #C7D2FE">Financiada'
    + (x.banco?(' · '+_esc(x.banco)):'') + '</span>';
}

function _solPagadoCheck(x){
  if(!_esDelExcel(x)) return '';
  // El mismo desplegable que en el panel del reporte: así se marca igual
  // desde los dos sitios y no hay dos formas de hacer lo mismo.
  var t = _solPagadaYa(x)
    ? ('Pagada' + (x.pagado_por?(' por '+x.pagado_por):'')
       + (x.pagado_en?(' · '+_fechaHora(x.pagado_en)):''))
    : 'Marcar cuando el pago salga';
  return '<span title="'+_esc(t)+'">'
    + _solDesplegable(x,'pagado',[
        {v:null,  t:'—',        c:'var(--text-muted)'},
        {v:true,  t:'Pagada',   c:'#166534'},
        {v:false, t:'Por pagar',c:'#B45309'}
      ],'95px')
    + '</span>';
}

// El estado de verdad de una solicitud. El guardado a veces se queda atrás:
// si la base rechazó «recibida» (restricción vieja) solo se grabó la fecha,
// y hay filas con el estado escrito distinto («Pendiente», «enviada»…).
// Con fecha de recepción, la solicitud está RECIBIDA salvo que ya esté más
// adelante (abono enviado, cancelación realizada, devuelta o trabajada).
function _solEstadoEf(x){
  var e=String((x&&x.estado)||'').trim().toLowerCase();
  var adelante=['abono_enviado','cancelacion_realizada','devuelta','procesada'];
  if(x && x.recibido_en && adelante.indexOf(e)<0) return 'recibida';
  return e;
}

// Cuándo se pidió. Las cargadas por SQL o del Excel no traen solicitado_en,
// pero sí creado_en.
function _solFechaSol(x){ return (x && (x.solicitado_en || x.creado_en)) || ''; }

// Día de la semana, fecha y hora: «martes 22 sept 2026 · 11:21 a. m.»
function _fechaHoraDia(iso){
  if(!iso) return '';
  try{
    var d=new Date(iso); if(isNaN(d)) return String(iso);
    return d.toLocaleDateString('es-PA',{weekday:'long',day:'2-digit',month:'short',year:'numeric'})
      +' · '+d.toLocaleTimeString('es-PA',{hour:'2-digit',minute:'2-digit'});
  }catch(e){ return String(iso); }
}

function _solEstadoLabel(x){
  var e=_solEstadoEf(x);
  if(e==='abono_enviado') return {t:'Abono enviado'+(x.finalizado_en?(' · '+_fechaHora(x.finalizado_en)):''), c:'#166534', bg:'#dcfce7'};
  if(e==='cancelacion_realizada') return {t:'Cancelación realizada'+(x.finalizado_en?(' · '+_fechaHora(x.finalizado_en)):''), c:'#166534', bg:'#dcfce7'};
  if(e==='recibida') return {t:'Recibida'+(x.recibido_por?(' por '+x.recibido_por):'')+(x.recibido_en?(' · '+_fechaHora(x.recibido_en)):''), c:'#B45309', bg:'#FEF9F3'};
  if(e==='devuelta') return {t:'Devuelta a compras'+((x.devuelta&&x.devuelta.motivo)?(' · '+x.devuelta.motivo):''), c:'#991b1b', bg:'#FEF2F2'};
  if(e==='procesada') return {t:'Trabajada', c:'#555', bg:'#eceae4'};
  return {t:'Pendiente de recibir', c:'#9a3412', bg:'#FEF3E8'};
}

// PATCH con reintento quitando columnas que aún no existan en Supabase
async function _solPagoPatch(id, campos){
  if(!id) return false;
  var body=Object.assign({}, campos);
  for(var intento=0;intento<5;intento++){
    try{
      var r=await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+id,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(body)});
      if(r.ok) return true;
      var t=await r.text();
      // Columna que todavía no existe: se quita y se reintenta sin ella
      var m=t.match(/column "?([a-z_]+)"? .*does not exist/i) || t.match(/Could not find the '([a-z_]+)' column/i);
      if(m && body.hasOwnProperty(m[1])){ delete body[m[1]]; if(Object.keys(body).length===0) return false; continue; }
      // La tabla rechaza el estado: le falta la restricción actualizada.
      // Es un problema de configuración, así que hay que decirlo claro en vez
      // de fallar en silencio y dejar el estado como estaba.
      if(/violates check constraint|estado_check/i.test(t)){
        window._solPagoAvisoEstado=true;
        console.error('[solicitudes_pago] la tabla no acepta el estado "'+(body.estado||'')+'".'
          +' Hay que correr solicitudes_pago_fix.sql en Supabase.');
        try{ showT('⚠ La base no acepta ese estado. Hay que actualizar la tabla solicitudes_pago (script solicitudes_pago_fix.sql).'); }catch(e){}
        return false;
      }
      console.warn('solPagoPatch', r.status, t); return false;
    }catch(e){ console.warn('solPagoPatch', e); return false; }
  }
  return false;
}

// ITEM 1 — al abrir la solicitud, contabilidad la marca como recibida
async function _solPagoMarcarRecibidas(docnum){
  // Solo las que NUNCA se recibieron. Con fecha de recepción ya no se tocan:
  // una vez recibida, queda recibida.
  var pend=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(docnum) && !x.recibido_en && _solEstadoEf(x)!=='recibida' && (x.estado==='pendiente'||!x.estado); });
  if(!pend.length) return;
  for(var i=0;i<pend.length;i++){
    var x=pend[i];
    x.recibido_por=(CU&&CU.name)||''; x.recibido_en=new Date().toISOString(); x.estado='recibida';
    var _ok=await _solPagoPatch(x.id,{recibido_por:x.recibido_por, recibido_en:x.recibido_en, estado:'recibida'});
    if(!_ok) await _solPagoPatch(x.id,{recibido_por:x.recibido_por, recibido_en:x.recibido_en});
    try{ var u=(USERS||[]).find(function(us){return us.name===x.solicitado_por;}); addNotif((u&&u.id)||'compras','📩 Solicitud recibida por '+(CU&&CU.name)+' — orden '+x.docnum, x.docnum, 'ti-check'); }catch(e){}
  }
  try{ _solPagoBadges(); }catch(e){}
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// ITEM 5 — comentarios
function _solComentBtn(x){
  var cs=_solComents(x); var nuevo=_solTieneComentNuevo(x);
  var abierto=(String(window._solComentOpen)===String(x.id));
  return '<button class="btn bg2" title="Comentarios de esta solicitud"'
    +' style="padding:6px 13px;font-size:13px;font-weight:600;position:relative;display:inline-flex;align-items:center;gap:6px;'
    +(abierto?'border-color:var(--fill-accent);color:var(--fill-accent);':'')+'"'
    +' onclick="_solToggleComent(\''+x.id+'\')">'
    +'<i class="ti ti-message-2" style="font-size:18px"></i>'
    +'<span>'+cs.length+'</span>'
    +(nuevo?'<span style="position:absolute;top:-5px;right:-5px;width:12px;height:12px;background:#dc2626;border-radius:50%;border:2px solid var(--surface-0)"></span>':'')
    +'</button>';
}
function _solComentBox(x, color){
  var abierto=(String(window._solComentOpen)===String(x.id));
  var cs=_solComents(x);
  var lst=cs.map(function(c,ci){
    var mio=(String(c.autor||'')===String((CU&&CU.name)||''));
    // Solo el autor (o gerencia) puede editar o borrar su comentario
    var puede=mio||(CU&&CU.role==='gerencia');
    var acciones=puede?('<span style="margin-left:auto;display:inline-flex;gap:6px;flex-shrink:0">'
        +'<i class="ti ti-pencil" title="Editar" onclick="_solEditarComent(\''+x.id+'\','+ci+')" style="cursor:pointer;color:var(--text-muted);font-size:14px"></i>'
        +'<i class="ti ti-trash" title="Borrar" onclick="_solBorrarComent(\''+x.id+'\','+ci+')" style="cursor:pointer;color:var(--text-danger);font-size:14px"></i>'
      +'</span>'):'';
    return '<div style="font-size:11px;padding:5px 8px;background:'+(mio?'#eef5fd':'var(--surface-1)')+';border-radius:7px;margin-bottom:4px">'
      +'<div style="display:flex;align-items:center;gap:5px;font-weight:600;color:'+(color||'#333')+'">'+_esc(c.autor||'')+(c.rol?(' <span style="font-weight:400;color:var(--text-muted)">('+_esc(c.rol)+')</span>'):'')+' <span style="font-weight:400;color:var(--text-muted);font-size:9.5px">'+_esc(_fechaHora(c.en))+'</span>'+acciones+'</div>'
      +'<div style="margin-top:1px">'+_menResaltar(_esc(c.texto||''))
      +(c.editado?'<span style="font-size:9.5px;color:var(--text-muted);font-style:italic"> \u00b7 editado</span>':'')
      +'</div></div>';
  }).join('') || '<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">Sin comentarios todavía.</div>';
  return '<div id="solcom-box-'+x.id+'" style="display:'+(abierto?'block':'none')+';margin-top:7px;padding:8px;border:0.5px solid var(--border);border-radius:8px;background:var(--surface-0)">'
    +lst
    +'<div style="display:flex;gap:5px;margin-top:5px">'
      +'<div style="flex:1;position:relative">'
        +'<input id="solcom-in-'+x.id+'" value="'+_esc(_solPreTag(x))+'" placeholder="Escribe un comentario... usa @ para mencionar" autocomplete="off" style="width:100%;padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11px;background:var(--surface-0);color:var(--text-primary)"'
        +' oninput="_menRefrescar(\'solcom-in-'+x.id+'\',\'solmen-'+x.id+'\')"'
        +' onblur="setTimeout(function(){_menCerrar(\'solmen-'+x.id+'\');},150)"'
        +' onkeydown="if(event.key===\'Escape\'){_menCerrar(\'solmen-'+x.id+'\');} else if(event.key===\'Enter\'){event.preventDefault();_solAddComent(\''+x.id+'\');}">'
        +'<div id="solmen-'+x.id+'" style="display:none;position:absolute;bottom:100%;left:0;right:0;margin-bottom:4px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:220px;overflow-y:auto;z-index:60"></div>'
      +'</div>'
      +'<button class="btn bp" style="padding:5px 9px" onclick="_solAddComent(\''+x.id+'\')"><i class="ti ti-send"></i></button>'
    +'</div></div>';
}
// Si el último comentario me mencionó, la respuesta arranca con esa persona
// ya etiquetada: contestar a quien te habló es lo normal.
function _solPreTag(x){
  var cs=_solComents(x);
  if(!cs.length || !CU) return '';
  // Se busca el comentario más reciente que me haya mencionado
  for(var i=cs.length-1;i>=0;i--){
    var c=cs[i];
    if(String(c.autor||'')===String(CU.name||'')) return '';   // el último es mío: sin pre-tag
    var men=_menExtraer(c.texto||'');
    if(men.some(function(u){ return u.id===CU.id; })){
      var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(c.autor||''); });
      return quien?(_menToken(quien)+' '):'';
    }
  }
  return '';
}

function _solToggleComent(id){
  if(String(window._solComentOpen)===String(id)){ window._solComentOpen=null; }
  else{
    window._solComentOpen=id;
    var x=_solPagoPorId(id);
    if(x) _solMarcarLeido(x);
  }
  _solPagoRefrescar();
}
// Edita un comentario propio
async function _solEditarComent(id, ci){
  var x=_solPagoPorId(id); if(!x) return;
  var cs=_solComents(x); var c=cs[ci]; if(!c) return;
  if(!(String(c.autor||'')===String((CU&&CU.name)||'') || (CU&&CU.role==='gerencia'))){
    showT('Solo puedes editar tus propios comentarios'); return; }
  var txt=prompt('Editar comentario:', c.texto||'');
  if(txt===null) return;
  txt=String(txt).trim();
  if(!txt){ showT('El comentario no puede quedar vacío'); return; }
  if(txt===c.texto) return;
  cs[ci]=Object.assign({},c,{texto:txt, editado:true, editado_en:new Date().toISOString(), editado_por:(CU&&CU.name)||''});
  x.comentarios=cs;
  window._solComentOpen=id;
  var ok=await _solPagoPatch(id,{comentarios:cs});
  showT(ok?'Comentario actualizado':'\u26a0 No se pudo guardar el cambio');
  _solPagoRefrescar();
}

// Borra un comentario propio
async function _solBorrarComent(id, ci){
  var x=_solPagoPorId(id); if(!x) return;
  var cs=_solComents(x); var c=cs[ci]; if(!c) return;
  if(!(String(c.autor||'')===String((CU&&CU.name)||'') || (CU&&CU.role==='gerencia'))){
    showT('Solo puedes borrar tus propios comentarios'); return; }
  if(!confirm('¿Borrar este comentario?\n\n"'+String(c.texto||'').slice(0,120)+'"\n\nNo se puede deshacer.')) return;
  cs.splice(ci,1);
  x.comentarios=cs;
  window._solComentOpen=id;
  var seen=_solSeenGet(); seen[id]=cs.length; _solSeenSet(seen);
  var ok=await _solPagoPatch(id,{comentarios:cs});
  showT(ok?'Comentario borrado':'\u26a0 No se pudo borrar');
  _solPagoRefrescar();
}

async function _solAddComent(id){
  var inp=document.getElementById('solcom-in-'+id); if(!inp) return;
  var txt=(inp.value||'').trim(); if(!txt) return;
  var x=_solPagoPorId(id); if(!x){ showT('No se encontró la solicitud'); return; }
  var cs=_solComents(x);
  cs.push({autor:(CU&&CU.name)||'', rol:(CU&&CU.role)||'', texto:txt, en:new Date().toISOString()});
  // Aviso a los usuarios mencionados con @
  try{
    var mencionados=_menExtraer(txt);
    if(mencionados.length) _menNotificar(mencionados, {
      docnum:x.docnum, contexto:'solicitud', solId:x.id, texto:txt,
      etiqueta:'una solicitud de '+(x.tipo==='abono'?'abono':'cancelación')
    });
  }catch(e){ console.warn('menciones:',e); }
  x.comentarios=cs; inp.value='';
  var seen=_solSeenGet(); seen[id]=cs.length; _solSeenSet(seen);
  window._solComentOpen=id;
  // Se repinta solo la caja de comentarios, para no perder el foco
  try{
    var caja=document.getElementById('solcom-box-'+id);
    if(caja){
      var tmp=document.createElement('div');
      tmp.innerHTML=_solComentBox(x,'#0c447c');
      var nueva=tmp.firstChild;
      if(nueva){ caja.parentNode.replaceChild(nueva, caja); }
      var i2=document.getElementById('solcom-in-'+id); if(i2) i2.focus();
    }
  }catch(e){}
  var ok=await _solPagoPatch(id,{comentarios:cs});
  if(!ok) showT('⚠ No se pudo guardar el comentario (revisa la columna comentarios en Supabase)');
  // avisar a la otra parte
  try{
    if(CU && _esCompras()){
      addNotif('contabilidad','💬 Nuevo comentario en solicitud — orden '+x.docnum, x.docnum, 'ti-message-2', true);
      // Aviso persistente: el de arriba se pierde al recargar
      _avSolicitud(_avUsuariosPorRol('contabilidad'), x,
        'Nuevo comentario de '+((CU&&CU.name)||'compras')+' en la solicitud',
        'Comentario en solicitud');
    } else {
      var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
      addNotif((u&&u.id)||'compras','💬 Nuevo comentario de contabilidad — orden '+x.docnum, x.docnum, 'ti-message-2', true);
      _avSolicitud(_avSolicitante(x), x,
        'Nuevo comentario de contabilidad ('+((CU&&CU.name)||'')+') en tu solicitud',
        'Comentario en solicitud');
    }
  }catch(e){}
  try{ _solPagoBadges(); }catch(e){}
}

// ITEM 1 — badges / refresco
function _solPagoBadges(){
  var n=0;
  if(CU){
    // El número del menú cuenta lo que está SIN VER. Una vez que contabilidad
    // abre la solicitud queda 'recibida' y sigue en la lista hasta trabajarla,
    // pero deja de contar como aviso: si no, el número no bajaba nunca.
    if(CU.role==='contabilidad'||CU.role==='gerencia'){
      n=_solPagoPendientes(null).filter(function(x){
        return !x.recibido_en && (!x.estado || x.estado==='pendiente');
      }).length;
    }
    else if(_esCompras()){ n=(window._solPago||[]).filter(function(x){ return _solMias(x) && _solTieneComentNuevo(x); }).length; }
  }
  var el=document.getElementById('nbNumSol');
  if(el){ if(n>0){ el.textContent=n; el.style.display='inline-flex'; } else el.style.display='none'; }
}
function _solPagoRefrescar(){ try{ if(PG==='alertas') rAlertas(); }catch(e){} try{ _solPagoBadges(); }catch(e){} }

// Recarga las solicitudes desde la base y repinta. Se usa al entrar a
// Alertas para que compras vea de inmediato si contabilidad ya la recibió.
async function _solPagoRecargar(){
  try{ await _solPagoCargar(true); }catch(e){}
  try{ _solPagoBadges(); }catch(e){}
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

async function _solPagoBadgeIniciar(){
  if(!CU) return;
  if(CU.role==='contabilidad'||CU.role==='gerencia'||_esCompras()){
    try{ await _solPagoCargar(true); }catch(e){}
    window._solPagoListo=true;
    try{ _solPagoBadges(); }catch(e){}
    try{ if(PG==='dashboard') rDash(); }catch(e){}
    try{ if(PG==='alertas') rAlertas(); }catch(e){}
    if(!window._solPagoPoller){
      window._solPagoPoller=true;
      setInterval(function(){
        // No repintar si hay una caja de comentarios abierta o con texto:
        // el repintado borraría lo que la persona está escribiendo.
        var escribiendo=false;
        try{
          var act=document.activeElement;
          if(act && /^(solcom-in-|subcin-)/.test(act.id||'')) escribiendo=true;
          document.querySelectorAll('input[id^="solcom-in-"]').forEach(function(i){ if(i.value) escribiendo=true; });
        }catch(e){}
        _solPagoCargar(true).then(function(){
          try{ _solPagoBadges(); }catch(e){}
          if(escribiendo) return;
          if(PG==='alertas'){ try{ rAlertas(); }catch(e){} }
          if(PG==='dashboard'){ try{ rDash(); }catch(e){} }
        });
      }, 30000);
    }
  }
}

// ITEM 1 — banner rojo en el dashboard de contabilidad
function _solPagoDashBanner(){
  if(!CU || CU.role!=='contabilidad') return '';
  var lista=_solPagoPendientes(null);
  if(!lista.length) return '';
  var ab=lista.filter(function(x){return x.tipo==='abono';}).length;
  var ca=lista.filter(function(x){return x.tipo==='cancelacion';}).length;
  return '<div style="background:#FBEAF0;border:0.5px solid #e6a9bf;border-radius:var(--radius);padding:10px 12px;margin-bottom:10px;display:flex;align-items:center;gap:11px;cursor:pointer" onclick="go(\'alertas\')">'
    +'<span style="position:relative;display:inline-flex"><i class="ti ti-coin" style="font-size:20px;color:var(--t-vino)"></i>'
    +'<span style="position:absolute;top:-7px;right:-9px;background:#dc2626;color:#fff;border-radius:10px;min-width:17px;height:17px;padding:0 4px;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;border:1.5px solid #fff">'+lista.length+'</span></span>'
    +'<div style="flex:1"><div style="font-size:12px;color:var(--t-vino);font-weight:600">'+lista.length+' solicitud'+(lista.length>1?'es':'')+' de abono o cancelación pendiente'+(lista.length>1?'s':'')+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-vino);margin-top:2px">'+ab+' de abono · '+ca+' de cancelación</div></div>'
    +'<button class="btn" style="background:#72243E;color:#fff;padding:5px 11px;font-size:11px"><i class="ti ti-eye"></i> Ver</button></div>';
}

// ITEM 1 — sección para el que solicita (compras): ve sus solicitudes y el estado
function _solPagoMisSeccion(){
  var mias=(window._solPago||[]).filter(_solMias);
  if(!mias.length){
    return '<div style="border:1px solid #cfe0f5;background:#eef5fd;border-radius:10px;margin-bottom:12px;padding:10px 13px;font-size:11.5px;color:var(--t-azul)"><i class="ti ti-coin"></i> No tienes solicitudes de abono o cancelación enviadas.</div>';
  }
  mias=mias.slice().sort(function(a,b){ return String(_solFechaSol(b)).localeCompare(String(_solFechaSol(a))); });
  var h='<div style="border:1px solid #cfe0f5;background:#eef5fd;border-radius:10px;margin-bottom:12px;overflow:hidden">';
  h+='<div style="padding:9px 13px;font-size:12.5px;font-weight:700;color:var(--t-azul)"><i class="ti ti-coin"></i> Mis solicitudes de abono / cancelación <span style="font-weight:400;font-size:11px">· '+mias.length+'</span></div>';
  mias.forEach(function(x){
    var st=_solEstadoLabel(x);
    h+='<div style="border-top:0.5px solid #cfe0f5;padding:8px 13px;background:var(--surface-0)">'
      +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:150px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+' <span style="font-weight:400;color:var(--text-muted);font-size:10.5px">'+(x.tipo==='abono'?'Abono':'Cancelación')+'</span></div>'
          +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'+_solRefLinks(x)+(_solFechaSol(x)?(' \u00b7 Solicitada el <b>'+_esc(_fechaHoraDia(_solFechaSol(x)))+'</b>'):'')+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0"><div style="font-size:13px;font-weight:700;color:var(--t-azul)">'+fmt(x.monto)+'</div></div>'
      +'</div>'
      +'<div style="margin-top:5px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
        +'<span style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;background:'+st.bg+';color:'+st.c+'">'+_esc(st.t)+'</span>'
        +_solDeptChip(x)
        +_solComprobChip(x)
        +(x.comprobante_path?('<a href="'+DOCS_BASE+String(x.comprobante_path).split('/').map(encodeURIComponent).join('/')+'" target="_blank" style="font-size:10px;color:var(--text-accent);text-decoration:underline"><i class="ti ti-paperclip"></i> Comprobante</a>'):'')
        +_solComentBtn(x)
        +_solLeidoPor(x)
      +'</div>'
      +_solHitos(x)
      +_solComentBox(x,'#0c447c')
    +'</div>';
  });
  return h+'</div>';
}

// ITEM 6 — al adjuntar el comprobante en la etapa de depósito, cambiar estado + avisar
async function _solPagoDepositoAdjunto(oid, stageKey, path, nombre){
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia')) return;
  var tipo=null;
  if(stageKey===_subKeyDeposito(_PASO_DEP_PROV)) tipo='abono';
  else if(stageKey===_subKeyDeposito(_PASO_PAGO_FINAL)) tipo='cancelacion';
  else return;
  if(!(window._solPago && window._solPago.length)){ try{ await _solPagoCargar(true); }catch(e){} }
  var cand=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && x.tipo===tipo && x.estado!=='abono_enviado' && x.estado!=='cancelacion_realizada';
  });
  if(!cand.length) return;
  var nuevoEstado=(tipo==='abono')?'abono_enviado':'cancelacion_realizada';
  for(var i=0;i<cand.length;i++){
    var x=cand[i];
    x.estado=nuevoEstado; x.comprobante_path=path; x.comprobante_nombre=nombre||'';
    x.finalizado_por=(CU&&CU.name)||''; x.finalizado_en=new Date().toISOString();
    await _solPagoPatch(x.id,{estado:nuevoEstado, comprobante_path:path, comprobante_nombre:x.comprobante_nombre, finalizado_por:x.finalizado_por, finalizado_en:x.finalizado_en});
    try{ await _solPagoAvisarSolicitante(x); }catch(e){}
  }
  showT('✓ Solicitud de '+(tipo==='abono'?'abono':'cancelación')+' actualizada a "'+(tipo==='abono'?'Abono enviado':'Cancelación realizada')+'"');
  try{ _solPagoBadges(); }catch(e){}
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// ITEM 6 — avisar al solicitante y mandarle el comprobante adjunto
async function _solPagoAvisarSolicitante(x, texto){
  var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
  var correo=u&&u.email;
  var esAbono=(x.tipo==='abono');
  // Lo que le queda por hacer a la compradora: reenviarle el comprobante al
  // proveedor. Se lo dice la alerta y el clic la deja en ese mismo subpaso.
  var _pendiente=esAbono
    ? 'Pendiente: enviar el comprobante del abono al proveedor'
    : 'Pendiente: enviar el comprobante de la cancelación al proveedor';
  var _pasoDestino=esAbono?_PASO_COMP_PROV:_PASO_COMP_FINAL;
  try{ addNotif((u&&u.id)||'compras', '📤 '+_pendiente+' — orden '+x.docnum, x.docnum, 'ti-send', true); }catch(e){}

  // Y la alerta con globo rojo, que es la que se ve arriba. addNotif sola no
  // alimenta ese contador, por eso el solicitante no se enteraba.
  try{
    if(u) await _menNotificar([u], {
      docnum:x.docnum, contexto:'etapa', etapa:'deposito', paso:_pasoDestino, solId:x.id,
      texto: texto || (_pendiente+' · '+(x.proveedor||'')+' · '+fmt(x.monto)
              +' · '+(esAbono?'el abono ya salió':'la cancelación ya se hizo')),
      etiqueta:_pendiente
    });
  }catch(e){ console.warn('alerta al solicitante:',e); }
  if(!correo) return;
  var adj=[];
  try{ var a=await _solPagoAdjuntarDeStorage(x.comprobante_path, x.comprobante_nombre||('Comprobante_'+x.docnum+'.pdf')); if(a) adj.push({nombre:a.nombre, contenido:a.contenido, mime:a.mime}); }catch(e){}
  var fila={
    docnum:String(x.docnum),
    para_lista:[correo], para_email:correo,
    asunto:(esAbono?'Abono enviado':'Cancelación realizada')+' - Orden '+x.docnum+(x.proveedor?(' - '+x.proveedor):''),
    cuerpo:_repCuerpoTexto('Hola '+(x.solicitado_por||'')+',\n\n'+(esAbono?'El abono que solicitaste ya fue enviado al proveedor.':'La cancelación del saldo final que solicitaste ya fue realizada.')+'\n\nOrden: '+x.docnum+'\nProveedor: '+(x.proveedor||'')+'\nMonto: '+fmt(x.monto)+'\n'+(adj.length?'\nAdjunto el comprobante.\n':'')+'\nContabilidad — Kennedy Center Corp.'),
    adjuntos:adj,
    de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
    origen:(esAbono?'Abono enviado · ':'Cancelación realizada · ')+x.docnum,
    estado:'pendiente'
  };
  try{ await fetch(SB+'/rest/v1/correos_queue',{ method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}), body:JSON.stringify(fila) }); }catch(e){}
}

// ── Vista para contabilidad dentro de Alertas ──
// Filtro de departamento (solo gerencia)
window._solDeptFiltro='todos';
// Una solicitud no se da por cerrada hasta que el comprobante llegó al
// proveedor. Que contabilidad haya pagado no cierra el circuito: el proveedor
// tiene que recibir el comprobante, y hasta entonces sigue habiendo algo que
// hacer. Los pasos son los de la etapa Depósito & Pago:
//   0 solicitud · 1 depósito enviado · 2 comprobante al proveedor
//   3 solicitud del balance · 4 comprobante del pago final
function _solComprobanteEnviado(x){
  var todo=(typeof stageProgress!=='undefined')?stageProgress:null;
  var sp=(todo && todo[String(x.docnum)] && todo[String(x.docnum)].deposito) || null;
  // Si no hay avance cargado para esa orden —a contabilidad no siempre le
  // llegan todas— NO se puede saber si el comprobante salió. En ese caso se
  // respeta el estado de la solicitud: dejarla pendiente por falta de dato la
  // dejaba en Alertas para siempre, incluso con el abono ya hecho.
  if(!sp) return true;
  var idx=Number(sp.stepIdx)||0;
  return (x.tipo==='cancelacion') ? idx>=5 : idx>=3;
}

function _solPagoPendientes(tipo){
  var esGer=(CU&&CU.role==='gerencia');
  var cerradas=['procesada','abono_enviado','cancelacion_realizada'];
  return (window._solPago||[]).filter(function(x){
    // Quien tiene departamento asignado ve solo el suyo. Contabilidad y la
    // gerencia general los ven todos, que es su trabajo.
    if(CU && _deptAcotado() && !_deptPermitido(normDept(x.dept||''))) return false;
    // Las cargadas del Excel se cierran con su casilla de "pagada": son
    // órdenes viejas que no recorren las etapas del portal, así que no hay
    // comprobante que esperar. Una vez marcadas, salen de las alertas para
    // todos, incluida gerencia.
    if(_esDelExcel(x) && _solPagadaYa(x)) return false;
    // Gerencia ve TODAS, también las cerradas, para poder auditarlas
    // Trabajada es trabajada: en cuanto contabilidad la cierra, sale de las
    // pendientes aunque todavía no haya subido el comprobante. Antes se
    // exigían las dos cosas y se quedaban ahí dando guerra.
    if(!esGer && cerradas.indexOf(_solEstadoEf(x))>=0) return false;
    if(tipo && x.tipo!==tipo) return false;
    if(esGer && window._solDeptFiltro && window._solDeptFiltro!=='todos'
       && String(x.dept||'otros')!==window._solDeptFiltro) return false;
    return true;
  });
}

// Botones de departamento para gerencia
function _solPagoBarraDept(){
  if(!CU || CU.role!=='gerencia') return '';
  var todas=(window._solPago||[]);
  if(!todas.length) return '';
  var depts={};
  todas.forEach(function(x){ depts[x.dept||'otros']=(depts[x.dept||'otros']||0)+1; });
  var act=window._solDeptFiltro||'todos';
  function btn(k,txt,n){
    var on=(act===k);
    return '<button onclick="_solSetDept(\''+k+'\')" style="border:1px solid '+(on?'var(--fill-accent)':'var(--border)')+';'
      +'background:'+(on?'var(--fill-accent)':'var(--surface-1)')+';color:'+(on?'#fff':'var(--text-secondary)')+';'
      +'border-radius:20px;padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer">'
      +txt+' <span style="opacity:.8;font-weight:400">'+n+'</span></button>';
  }
  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    +'<span style="font-size:11.5px;color:var(--text-secondary);font-weight:600"><i class="ti ti-filter"></i> Departamento</span>'
    +btn('todos','Todos',todas.length);
  Object.keys(depts).sort().forEach(function(d){
    h+=btn(d, (EMOJIS2[d]||'')+' '+_esc(dL(d)), depts[d]);
  });
  return h+'</div>';
}
function _solSetDept(d){ window._solDeptFiltro=d; try{ rAlertas(); }catch(e){} }

// Editar el monto de una solicitud (solo gerencia)
async function _solPagoEditar(id){
  if(!CU || CU.role!=='gerencia'){ showT('Solo gerencia puede editar solicitudes'); return; }
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  var txt=prompt('Editar el monto de la solicitud\n\n'+(x.proveedor||'')+' \u00b7 orden '+(x.docnum||'')
    +'\nConcepto: '+(x.tipo==='abono'?'Abono':'Cancelación')
    +'\n\nMonto actual: '+fmt(x.monto), String(Number(x.monto||0).toFixed(2)));
  if(txt===null) return;
  var m=parseFloat(String(txt).replace(/,/g,''));
  if(isNaN(m)||m<=0){ showT('El monto tiene que ser mayor a cero'); return; }
  var nota=prompt('Motivo del cambio (queda registrado):','')||'';
  var antes=Number(x.monto)||0;
  x.monto=m;
  x.nota=(x.nota?(x.nota+' | '):'')+'Editado por '+((CU&&CU.name)||'')+': '+fmt(antes)+' \u2192 '+fmt(m)+(nota?(' ('+nota+')'):'');
  var ok=await _solPagoPatch(id,{monto:m, nota:x.nota});
  showT(ok?('✓ Monto actualizado a '+fmt(m)):'⚠ No se pudo guardar el cambio');
  _solPagoRefrescar();
}

// ═══════════════════════════════════════════════════════════════════════════
//  PENDIENTES DE GERENCIA
//  Tres listados de lo que todavía espera una acción, agrupados por
//  departamento. Se arman con los estados que ya usa el portal, así que en
//  cuanto la acción se completa la fila desaparece sola.
// ═══════════════════════════════════════════════════════════════════════════

// Los días y horas desde una fecha
// ═══════════════════════════════════════════════════════════════════════════
//  ESCALAMIENTO POR DEMORA
//  Cuando una solicitud lleva demasiados días sin resolverse, se avisa a
//  gerencia. Antes los días se veían en el panel pero nadie recibía nada.
// ═══════════════════════════════════════════════════════════════════════════
// A partir de SEIS días sin procesar ni recibir. Con cinco saltaba el aviso
// por solicitudes que aún estaban dentro de lo normal y nadie lo miraba.
var ESCALAR_DIAS = 6;

function _escClave(x){ return 'esc_'+String(x.id||x.docnum||''); }

// La marca de "ya se avisó" va en la BASE, no en el navegador.
// Antes se guardaba en localStorage, que es privado de cada equipo: el
// navegador de cada persona que entraba creía que avisaba por primera vez
// y volvía a mandarlo todo. Con 29 usuarios y 20 solicitudes atrasadas
// salían cientos de avisos repetidos.
function _escYaAvisado(x, nivel){
  var n=Number(x.escalado_nivel)||0;
  if(n>=nivel) return true;
  // Respaldo local, por si falta la columna en la base
  try{ return localStorage.getItem(_escClave(x)+'_'+nivel)==='1'; }catch(e){ return false; }
}

async function _escMarcar(x, nivel){
  x.escalado_nivel=nivel;
  try{ localStorage.setItem(_escClave(x)+'_'+nivel,'1'); }catch(e){}
  try{
    await _solPagoPatch(x.id, {escalado_nivel:nivel, escalado_en:new Date().toISOString()});
  }catch(e){
    console.warn('[escalamiento] no se pudo marcar en la base. '
      +'¿Faltan las columnas escalado_nivel y escalado_en? '
      +'Están en escalamiento_columnas.sql');
  }
}

// Revisa las solicitudes atrasadas y avisa a gerencia UNA vez por nivel.
// El aviso va agrupado: una notificación con el resumen, no una por
// solicitud, que era lo que llenaba la pantalla.
async function _escRevisar(){
  if(!CU) return;
  // Solo lo dispara contabilidad, que es quien lleva las solicitudes. Antes
  // corría en el navegador de todos, y cada uno mandaba su tanda.
  if(CU.role!=='contabilidad' && CU.role!=='gerencia') return;
  if(window._escCorriendo) return;
  window._escCorriendo=1;

  try{
    var pend=(window._solPago||[]).filter(function(x){
      var e=String(x.estado||'');
      return e!=='abono_enviado' && e!=='cancelacion_realizada'
          && e!=='anulada' && e!=='procesada';
    });
    if(!pend.length) return;

    var porNivel={1:[], 2:[]};
    pend.forEach(function(x){
      var ref=x.creado_en||x.solicitado_en;
      if(!ref) return;
      var dias=Math.floor((Date.now()-new Date(ref).getTime())/86400000);
      if(isNaN(dias)) return;
      var nivel=(dias>=ESCALAR_DIAS*2)?2:(dias>=ESCALAR_DIAS?1:0);
      if(!nivel || _escYaAvisado(x, nivel)) return;
      x.__dias=dias;
      porNivel[nivel].push(x);
    });

    for(var nivel=2; nivel>=1; nivel--){
      var lista=porNivel[nivel];
      if(!lista.length) continue;

      var gers=(USERS||[]).filter(function(u){
        return u.role==='gerencia' && u.id;
      });
      if(!gers.length) continue;

      // UNA notificación con el resumen, no una por solicitud
      var total=lista.reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
      var muestra=lista.slice(0,5).map(function(x){
        return (x.proveedor||'')+' '+fmt(x.monto)+' ('+x.__dias+'d)';
      }).join(' · ');

      try{
        await _menNotificar(gers, {
          docnum:'', contexto:'solicitud',
          texto:(nivel===2?'MUY ATRASADAS: ':'Atrasadas: ')
            +lista.length+' solicitud(es) de pago por '+fmt(total)
            +' llevan más de '+(nivel===2?ESCALAR_DIAS*2:ESCALAR_DIAS)+' días'
            +'. '+muestra+(lista.length>5?(' y '+(lista.length-5)+' más'):''),
          etiqueta:(nivel===2?'Solicitudes muy atrasadas':'Solicitudes atrasadas')
        });
        for(var k=0;k<lista.length;k++) await _escMarcar(lista[k], nivel);
        console.log('[escalamiento] aviso agrupado de nivel '+nivel+': '
          +lista.length+' solicitud(es)');
      }catch(e){ console.warn('[escalamiento]', e); }
    }
  } finally {
    window._escCorriendo=0;
  }
}

// Se revisa al entrar y cada media hora
function _escIniciar(){
  // Con guarda: si esto se llama dos veces (al reentrar, al cambiar de
  // usuario, al recargar el panel) antes quedaban DOS relojes corriendo y
  // cada aviso de atraso salía duplicado.
  if(window._escTimer) clearInterval(window._escTimer);
  if(window._escArranque) clearTimeout(window._escArranque);
  window._escArranque=setTimeout(function(){
    try{ _escRevisar(); }catch(e){} }, 12000);
  window._escTimer=setInterval(function(){
    try{ _escRevisar(); }catch(e){} }, 30*60*1000);
}

// ═══════════════════════════════════════════════════════════════════════════
//  DEVOLVER UNA SOLICITUD A COMPRAS
//  Contabilidad puede devolverla con un motivo, en vez de solo comentar.
// ═══════════════════════════════════════════════════════════════════════════
async function _solDevolver(id){
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia')){
    showT('Solo contabilidad puede devolver una solicitud'); return;
  }

  var motivo=prompt('¿Por qué devolvés esta solicitud a compras?\n\n'
    +'Por ejemplo: faltan las instrucciones bancarias, el monto no coincide '
    +'con la proforma, falta la orden firmada…\n\n'
    +'El motivo le llega a quien la pidió.','');
  if(motivo===null) return;
  motivo=String(motivo).trim();
  if(!motivo){ showT('Hace falta escribir el motivo'); return; }

  var info={
    por:(CU&&CU.name)||'', en:new Date().toISOString(), motivo:motivo
  };
  x.estado='devuelta';
  x.devuelta=info;
  _solPagoRefrescar();

  var ok=await _solPagoPatch(id,{estado:'devuelta', devuelta:info});
  if(!ok){
    // Si la columna no existe, al menos queda como comentario
    try{
      var cs=_solComents(x);
      cs.push({por:(CU&&CU.name)||'', en:new Date().toISOString(),
               txt:'DEVUELTA: '+motivo});
      x.comentarios=cs;
      await _solPagoPatch(id,{comentarios:cs});
    }catch(e){}
  }

  // Aviso al solicitante y a su gerencia
  try{
    var destinos=_avSolicitante(x);
    (USERS||[]).forEach(function(u){
      if(u.role==='gerencia' && u.id && (!x.dept || !u.dept || String(u.dept)===String(x.dept))
         && !destinos.some(function(z){ return z.id===u.id; })) destinos.push(u);
    });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:x.docnum, contexto:'solicitud', solId:x.id,
      texto:'Contabilidad devolvió la solicitud: '+motivo,
      etiqueta:'Solicitud devuelta'
    });
  }catch(e){}

  // Y el correo, para que no dependa de que entren al portal
  try{
    var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
    if(u && u.email){
      await fetch(SB+'/rest/v1/correos_queue',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({
          docnum:String(x.docnum), para_lista:[u.email], para_email:u.email,
          asunto:'Solicitud devuelta - Orden '+x.docnum+(x.proveedor?(' - '+x.proveedor):''),
          cuerpo:_repCuerpoTexto('Hola '+(x.solicitado_por||'')+',\n\n'
            +'Contabilidad devolvió tu solicitud de '
            +(x.tipo==='cancelacion'?'cancelación':'abono')+' por este motivo:\n\n'
            +'  '+motivo+'\n\n'
            +'Orden: '+x.docnum+'\n'
            +(x.proveedor?('Proveedor: '+x.proveedor+'\n'):'')
            +'Monto: '+fmt(x.monto)+'\n\n'
            +'Cuando lo corrijas, volvé a enviarla desde el portal.\n\n'
            +'Saludos,\n'+((CU&&CU.name)||'')+'\nKennedy Center Corp.'),
          adjuntos:[], de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
          origen:'Solicitud devuelta · '+x.docnum, estado:'pendiente'
        })});
    }
  }catch(e){ console.warn('correo de devolución:',e); }

  showT('✓ Solicitud devuelta a compras');
  _solPagoRefrescar();
}

// ═══════════════════════════════════════════════════════════════════════════
//  RECLAMOS A PROVEEDORES
//  Faltantes y mercancía en mal estado que bodega detecta al recibir.
//  Cada reclamo tiene un estado y sale del listado cuando se resuelve.
// ═══════════════════════════════════════════════════════════════════════════
// El estado del reclamo vive en su propia tabla. Antes dependía de
// localStorage, así que solo lo veía quien había enviado el correo, y de
// _logGuardar, que puede fallar según el tipo de orden.
window._reclEstados=window._reclEstados||{};

async function _reclCargarEstados(){
  try{
    var r=await fetch(SB+'/rest/v1/reclamos?select=*&limit=2000',{headers:SBH});
    if(!r.ok) return false;
    var filas=await r.json()||[];
    filas.forEach(function(f){
      if(f.docnum) window._reclEstados[String(f.docnum)]=f;
    });
    console.log('[reclamos] '+filas.length+' estado(s) cargados de la base');
    return true;
  }catch(e){ console.warn('[reclamos] estados:',e); return false; }
}

async function _reclGuardarEstado(oid, datos){
  var fila=Object.assign({
    docnum:String(oid),
    actualizado_en:new Date().toISOString(),
    actualizado_por:(CU&&CU.name)||''
  }, datos);
  window._reclEstados[String(oid)]=Object.assign(
    window._reclEstados[String(oid)]||{}, fila);
  try{
    var r=await fetch(SB+'/rest/v1/reclamos?on_conflict=docnum',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      if(/does not exist|Could not find the table/i.test(t)){
        console.warn('[reclamos] falta la tabla "reclamos" en Supabase (reclamos.sql)');
      } else {
        console.warn('[reclamos] no se pudo guardar:', r.status, t.slice(0,140));
      }
      return false;
    }
    return true;
  }catch(e){ console.warn('[reclamos] guardar:',e); return false; }
}

// El estado que manda, mirando las tres fuentes
function _reclEstadoDe(oid, info){
  var rank={pendiente:0, enviado:1, resuelto:2};
  var cands=[];
  var base=window._reclEstados[String(oid)];
  if(base && base.estado) cands.push(base.estado);
  if(info && info.estado) cands.push(info.estado);
  try{
    var d=(window._logData||{})[oid];
    if(d && d.reclamo && d.reclamo.estado) cands.push(d.reclamo.estado);
  }catch(e){}
  var mejor='', r=-1;
  cands.forEach(function(c){
    var v=rank[c]!=null?rank[c]:-1;
    if(v>r){ r=v; mejor=c; }
  });
  // Si hay fecha de envío en cualquier lado, al menos está enviado
  if(r<1){
    var hayFecha=(base&&base.enviado_en) || (info&&info.fecha);
    try{
      var d2=(window._logData||{})[oid];
      if(d2&&d2.reclamo&&d2.reclamo.fecha) hayFecha=true;
    }catch(e){}
    if(hayFecha) return 'enviado';
  }
  return mejor||'pendiente';
}

var _RECL_ESTADOS = {
  pendiente: {t:'Pendiente',  c:'#991b1b', bg:'#FEF2F2', i:'ti-alert-circle'},
  enviado:   {t:'Enviado',    c:'#B45309', bg:'#FEF3E8', i:'ti-mail-forward'},
  resuelto:  {t:'Resuelto',   c:'#166534', bg:'#dcfce7', i:'ti-circle-check'}
};

// Todos los reclamos guardados, con lo que hace falta para el listado
// Precarga los datos de logística de TODAS las órdenes. Sin esto, los
// reclamos solo aparecían después de abrir cada orden a mano, porque
// _logLeer carga bajo demanda.
window._reclCargado=false;

async function _reclPrecargar(){
  if(window._reclCargando) return;
  window._reclCargando=true;
  var n=0;
  // Los estados primero: son los que definen qué sigue abierto
  try{ await _reclCargarEstados(); }catch(e){}

  // 1) Lo que ya está en la memoria del navegador
  try{
    for(var i=0;i<localStorage.length;i++){
      var k=localStorage.key(i);
      if(!k || k.indexOf('log_')!==0) continue;
      var oid=k.slice(4);
      if(window._logData[oid]) continue;
      try{
        var d=JSON.parse(localStorage.getItem(k));
        if(d){ window._logData[oid]=d; n++; }
      }catch(e){}
    }
  }catch(e){}

  // 2) Lo guardado en las órdenes NO SAP
  try{
    (window._pendSAP||[]).forEach(function(p){
      var oid=p.dkc||p.num_orden;
      if(!oid || window._logData[oid]) return;
      var d=p.logistica;
      if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
      if(d){ window._logData[oid]=d; n++; }
    });
  }catch(e){}

  // 3) Y lo de las órdenes de SAP, que vive en su propia tabla
  try{
    var r=await fetch(SB+'/rest/v1/compras_logistica?select=docnum,datos&limit=2000',{headers:SBH});
    if(r.ok){
      (await r.json()||[]).forEach(function(f){
        var oid=String(f.docnum||'');
        if(!oid) return;
        var d=f.datos;
        if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
        if(!d) return;
        // Lo que ya está en memoria manda: puede tener cambios sin guardar
        if(!window._logData[oid]){ window._logData[oid]=d; n++; }
      });
    }
  }catch(e){ console.warn('[reclamos] no se pudo precargar de la base:', e); }

  window._reclCargado=true;
  window._reclCargando=false;

  // Las entradas traídas de SAP se guardan aparte: si una orden tiene datos
  // de entrada pero no de logística, igual puede tener faltantes.
  try{
    var r2=await fetch(SB+'/rest/v1/entradas_queue?select=docnum,datos&estado=eq.listo'
      +'&order=creado_en.desc&limit=500',{headers:SBH});
    if(r2.ok){
      var puestas=0;
      (await r2.json()||[]).forEach(function(f){
        var oid=String(f.docnum||'');
        if(!oid) return;
        var d=window._logData[oid];
        // Solo si esa orden no tiene ya sus entradas cargadas
        if(d && d.entradas && (d.entradas.lista||[]).length) return;
        var dd=f.datos;
        if(typeof dd==='string'){ try{ dd=JSON.parse(dd); }catch(e){ dd=null; } }
        var lista=(dd&&dd.entradas)||[];
        if(!lista.length) return;
        window._logData[oid]=window._logData[oid]||{booking:{}, bl:{}, arrival:{}, contenedores:[]};
        window._logData[oid].entradas={lista:lista, en:'', por:''};
        puestas++;
      });
      if(puestas) console.log('[reclamos] '+puestas+' orden(es) con entradas recuperadas');
    }
  }catch(e){}
  console.log('[reclamos] precargadas '+n+' orden(es) con datos de logística');
  // Si el usuario ya está mirando las alertas, se refrescan
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
  return n;
}

function _reclTodos(){
  var out=[];
  var vistos={};

  function agregar(oid, info){
    if(!info || vistos[oid]) return;
    vistos[oid]=1;
    // El estado vive en dos sitios: el envío del correo y la orden. Si
    // cualquiera dice que ya se envió, se respeta: antes el listado seguía
    // marcándolo "sin enviar" aunque el correo ya hubiera salido.
    try{
      info.estado=_reclEstadoDe(oid, info);
      var base=window._reclEstados[String(oid)]||{};
      var dOrd=(window._logData||{})[oid]||{};
      var re=dOrd.reclamo||{};
      if(!info.fecha) info.fecha=base.enviado_en||re.fecha||'';
      if(!info.por)   info.por=base.enviado_por||re.por||'';
      if(!info.nota)  info.nota=base.nota||re.nota||'';
      if(!info.resuelto_en)  info.resuelto_en=base.resuelto_en||re.resuelto_en||'';
      if(!info.resuelto_por) info.resuelto_por=base.resuelto_por||re.resuelto_por||'';
    }catch(e){}
    var dat={};
    try{ dat=_solPagoDatosOrden(oid)||{}; }catch(e){}
    // El departamento que trae el reclamo manda: al reclamar desde una orden
    // abierta se guarda ahí, y buscarlo por el id no funciona porque el
    // identificador es la referencia DKC. Por eso salía como "otros".
    var dept=info.dept||dat.dept||'';
    if(!dept){
      var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
      if(o) dept=o.dept||'';
      if(!dept){
        var p=(window._pendSAP||[]).find(function(x){
          return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
        if(p) dept=p.dept||'';
      }
    }
    out.push({
      oid:oid,
      dept:dept||'otros',
      proveedor:info.proveedor||dat.proveedor||'',
      monto:Number(info.monto)||0,
      lineas:Number(info.lineas)||0,
      tipo:info.tipo||'faltante',
      estado:info.estado||(info.fecha?'enviado':'pendiente'),
      fecha:info.fecha||'',
      por:info.por||'',
      para:info.para||[],
      resuelto_en:info.resuelto_en||'',
      resuelto_por:info.resuelto_por||'',
      nota:info.nota||''
    });
  }

  // Los reclamos ya enviados
  try{
    var envios=window._solEnvios||{};
    Object.keys(envios).forEach(function(k){
      if(k.indexOf('|reclamo')<0) return;
      var oid=k.split('|')[0];
      agregar(oid, envios[k]);
    });
  }catch(e){}

  // Y los que están en la tabla de reclamos. Es la fuente que sobrevive al
  // navegador, y la única que recoge los enviados desde una orden abierta:
  // ahí el envío no pasa por el registro de la orden y se quedaban fuera
  // del listado de alertas.
  try{
    var est=window._reclEstados||{};
    Object.keys(est).forEach(function(oid){
      if(vistos[oid]) return;
      var e=est[oid]||{};
      if(!e.estado && !e.enviado_en) return;
      agregar(oid, {
        estado:e.estado||'enviado',
        fecha:e.enviado_en||'', por:e.enviado_por||'',
        monto:Number(e.monto)||0, lineas:Number(e.lineas)||0,
        para:e.para||'', nota:e.nota||'',
        resuelto_en:e.resuelto_en||'', resuelto_por:e.resuelto_por||'',
        proveedor:e.proveedor||'', dept:e.dept||''
      });
    });
  }catch(e){}

  // Y los detectados en bodega que todavía no se enviaron
  try{
    Object.keys(window._logData||{}).forEach(function(oid){
      if(vistos[oid]) return;
      var d=window._logData[oid];
      var ents=(d && d.entradas && d.entradas.lista)||[];
      var falt=[], monto=0;
      ents.forEach(function(e){
        (e.lineas||[]).forEach(function(l){
          if((Number(l.cantidad_abierta)||0)>0){
            falt.push(l);
            monto+=Number(l.monto_faltante)||0;
          }
        });
      });
      // La mercancía dañada también es motivo de reclamo
      var dan=(d.danios&&d.danios.lista)||[];
      dan.forEach(function(x){
        falt.push(x);
        monto+=(Number(x.cantidad)||0)*(Number(x.precio)||0);
      });
      if(!falt.length) return;
      // Si ya se marcó resuelto a mano, no vuelve a aparecer
      var st=(d.reclamo&&d.reclamo.estado)||'pendiente';
      agregar(oid, {monto:monto, lineas:falt.length, estado:st,
                    fecha:(d.reclamo&&d.reclamo.fecha)||'',
                    resuelto_en:(d.reclamo&&d.reclamo.resuelto_en)||'',
                    resuelto_por:(d.reclamo&&d.reclamo.resuelto_por)||'',
                    nota:(d.reclamo&&d.reclamo.nota)||''});
    });
  }catch(e){}
  return out;
}

// Los que siguen abiertos: los resueltos salen del listado
function _reclAbiertos(){
  var todos=_reclTodos().filter(function(r){ return r.estado!=='resuelto'; });
  // Compras solo ve su departamento; gerencia ve todo
  if(CU && _esCompras() && _deptAcotado()){
    todos=todos.filter(function(r){ return _deptPermitido(r.dept); });
  }
  return todos;
}

// Anotar la respuesta del proveedor
async function _reclNota(oid){
  var base=(window._reclEstados||{})[String(oid)]||{};
  var txt=prompt('Respuesta del proveedor o nota para "'+oid+'":', base.nota||'');
  if(txt===null) return;
  try{
    window._reclEstados=window._reclEstados||{};
    window._reclEstados[String(oid)]=Object.assign(
      window._reclEstados[String(oid)]||{}, {nota:txt});
    await _reclGuardarEstado(oid, {nota:txt});
    showT(txt?'Nota guardada':'Nota borrada');
  }catch(e){ console.warn('[reclamo] nota:', e); showT('No se pudo guardar la nota'); }
  try{ rAlertas(); }catch(e){}
}

// Quitar un reclamo del listado
async function _reclBorrar(oid){
  if(!confirm('¿Borrar el reclamo de la orden '+oid+'?\n\n'
    +'Desaparece del listado. El correo que ya salió no se deshace.')) return;
  try{
    var r=await fetch(SB+'/rest/v1/reclamos?docnum=eq.'+encodeURIComponent(oid),
      {method:'DELETE', headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    if(!r.ok && r.status!==404) console.warn('[reclamo] borrar:', r.status);
  }catch(e){ console.warn('[reclamo] borrar:', e); }
  // Y de las dos fuentes en memoria, o volvería a salir al repintar
  try{ delete (window._reclEstados||{})[String(oid)]; }catch(e){}
  try{ delete (window._solEnvios||{})[oid+'|reclamo']; }catch(e){}
  try{
    var d=(window._logData||{})[oid];
    if(d && d.reclamo) d.reclamo.estado='resuelto';
  }catch(e){}
  showT('Reclamo borrado');
  try{ rAlertas(); }catch(e){}
}

function _reclPanel(){
  if(!CU || ['gerencia','compras','importacion','bodega'].indexOf(CU.role)<0) return '';
  var lista=_reclAbiertos();
  var abierto=!!window._reclAbierto;

  var totalM=lista.reduce(function(a,r){ return a+r.monto; },0);
  var pend=lista.filter(function(r){ return r.estado==='pendiente'; }).length;

  var cargando=!!window._reclCargando;
  var h='<div style="border:1px solid '+(pend?'#dc2626':'#E9C08A')+';border-radius:11px;'
    +'background:'+(pend?'#FEF2F2':'#FEF9F3')+';margin-bottom:12px;overflow:hidden">';
  h+='<div onclick="_reclToggle()" style="padding:10px 14px;display:flex;align-items:center;'
    +'gap:9px;flex-wrap:wrap;cursor:pointer">'
    +'<i class="ti ti-package-off" style="color:'+(pend?'#991b1b':'#7C3D12')+';font-size:16px"></i>'
    +'<span style="font-size:13px;font-weight:700;color:'+(pend?'#991b1b':'#7C3D12')+'">'
      +'Reclamos a proveedores</span>'
    +(cargando
      ? '<span class="ai-wrap" style="font-size:11px;color:var(--t-marron)"><span class="ai-ring g"></span> buscando…</span>'
      : ('<span style="font-size:11.5px;color:'+(pend?'#991b1b':'#7C3D12')+';opacity:.9">'
         +lista.length+' abierto(s) · '+fmt(totalM)+'</span>'))
    +(pend?('<span style="font-size:10px;font-weight:800;background:#dc2626;color:#fff;'
      +'border-radius:11px;padding:2px 9px">'+pend+' sin enviar</span>'):'')
    +'<span style="flex:1"></span>'
    +'<span onclick="event.stopPropagation();_reclRefrescar()" title="Volver a buscar en todas las órdenes" '
      +'style="font-size:11px;color:var(--text-muted);cursor:pointer;padding:2px 6px">'
      +'<i class="ti ti-refresh"></i></span>'
    +'<i class="ti ti-chevron-'+(abierto?'up':'down')+'" style="color:var(--text-muted)"></i>'
    +'</div>';

  if(!lista.length){
    return h+'<div style="padding:10px 14px;font-size:11.5px;color:var(--text-muted);'
      +'border-top:0.5px solid var(--border)">'
      +(cargando
        ? 'Buscando reclamos en las órdenes…'
        : ('<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> No hay reclamos abiertos.'))
      +'</div></div>';
  }

  // Totales por departamento, siempre visibles
  var porDept={};
  lista.forEach(function(r){ (porDept[r.dept]=porDept[r.dept]||[]).push(r); });
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;padding:0 14px 10px">';
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var m=g.reduce(function(a,r){ return a+r.monto; },0);
    var sinEnviar=g.filter(function(r){ return r.estado==='pendiente'; }).length;
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;'
      +'padding:7px 11px;min-width:140px">'
      +'<div style="font-size:10px;color:var(--text-muted);font-weight:600">'
        +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</div>'
      +'<div style="font-size:14px;font-weight:700;color:var(--t-rojo)">'+fmt(m)+'</div>'
      +'<div style="font-size:10px;color:var(--text-muted)">'+g.length+' reclamo(s)'
        +(sinEnviar?(' · <b style="color:var(--t-rojo2)">'+sinEnviar+' sin enviar</b>'):'')+'</div>'
      +'</div>';
  });
  h+='</div>';

  if(!abierto) return h+'</div>';

  // El detalle, por departamento y del más caro al más barato
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d].sort(function(a,b){ return b.monto-a.monto; });
    h+='<div style="padding:6px 14px;background:rgba(0,0,0,.03);font-size:11px;font-weight:700;color:var(--t-marron)">'
      +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</div>';
    g.forEach(function(r){
      var st=_RECL_ESTADOS[r.estado]||_RECL_ESTADOS.pendiente;
      h+='<div style="padding:9px 14px;border-top:0.5px solid var(--border);background:var(--surface-0);'
        +'display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:180px;cursor:pointer" onclick="_reclIr(\''+_esc(String(r.oid).replace(/\x27/g,''))+'\')">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(r.proveedor||'(sin proveedor)')+'</div>'
          +'<div style="font-size:10.5px;color:var(--text-muted)">Orden '+_esc(r.oid)
            +' · '+r.lineas+' artículo(s)'
            +(r.fecha?(' · enviado el '+_esc(_fechaHora(r.fecha))):'')
            +(r.por?(' por '+_esc(r.por)):'')
            +(r.nota?('<br><i>'+_esc(r.nota)+'</i>'):'')
          +'</div></div>'
        +'<div style="text-align:right;min-width:96px">'
          +'<div style="font-size:14px;font-weight:700;color:var(--t-rojo)">'+fmt(r.monto)+'</div></div>'
        +'<select onclick="event.stopPropagation()" onchange="_reclSetEstado(\''+_esc(String(r.oid).replace(/\x27/g,''))+'\',this.value)" '
          +'style="padding:4px 9px;border:1px solid '+st.c+';border-radius:14px;font-size:10.5px;'
          +'font-weight:700;background:'+st.bg+';color:'+st.c+';cursor:pointer">'
          +Object.keys(_RECL_ESTADOS).map(function(k){
              return '<option value="'+k+'"'+((r.estado===k)?' selected':'')+'>'+_RECL_ESTADOS[k].t+'</option>';
            }).join('')
        +'</select>'
        // Borrar desde aquí mismo: si el reclamo se creó por error, había
        // que entrar a la orden para quitarlo y casi nadie lo encontraba.
        +((_esGerencia()||_esCompras())
          ? ('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;'
             +'color:var(--t-rojo)" title="Borrar este reclamo" '
             +'onclick="event.stopPropagation();_reclBorrar(&quot;'
             +_esc(String(r.oid).replace(/\x27/g,''))+'&quot;)">'
             +'<i class="ti ti-trash"></i></button>')
          : '')
        +'</div>';
    });
  });
  return h+'</div>';
}

// Vuelve a buscar en todas las órdenes
async function _reclRefrescar(){
  window._reclCargado=false;
  window._logData=window._logData||{};
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
  var n=await _reclPrecargar();
  showT('✓ Revisadas '+(n||0)+' orden(es)');
}

function _reclToggle(){
  window._reclAbierto=!window._reclAbierto;
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// Lleva a la orden, al paso donde está el comparativo
function _reclIr(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='bodega'; });
  if(idx<0) return;
  var st=STAGES[idx];
  var pi=st.steps.findIndex(function(p){ return p.name===_PASO_BOD_SAP; });
  if(pi<0) pi=0;

  window._abrirEtapa={oid:String(oid), key:'bodega', paso:pi};
  try{ _solPagoAbrir(oid); }catch(e){ try{ openDetail(oid); }catch(e2){} }

  // Se espera a que la orden esté realmente en pantalla. Con un tiempo fijo
  // a veces el detalle todavía no se había armado y no pasaba nada.
  _reclIrPaso(oid, idx, pi, 0);
}

function _reclIrPaso(oid, idx, pi, intento){
  setTimeout(function(){
    var eg=document.getElementById('egb-'+oid+'-'+idx);
    if(!eg){
      if(intento<40) return _reclIrPaso(oid, idx, pi, intento+1);
      console.warn('[reclamos] no se encontró la etapa en pantalla');
      return;
    }
    // La etapa, si viene plegada
    try{ toggleEG(String(oid), idx, true); }catch(e){}

    setTimeout(function(){
      var cuerpo=document.getElementById('ssb-'+oid+'-'+idx+'-'+pi);
      if(!cuerpo){
        if(intento<40) return _reclIrPaso(oid, idx, pi, intento+1);
        return;
      }
      if(cuerpo.style.display==='none'){
        try{ toggleSubStep(String(oid), idx, pi); }catch(e){}
      }
      // Ya abierto, se baja hasta el panel del reclamo
      setTimeout(function(){
        var destino=document.getElementById('bodsap-'+oid)
                 || cuerpo.previousElementSibling
                 || cuerpo;
        if(destino && destino.scrollIntoView){
          destino.scrollIntoView({behavior:'smooth', block:'center'});
          destino.style.transition='box-shadow .3s';
          destino.style.boxShadow='0 0 0 3px var(--fill-accent)';
          setTimeout(function(){ destino.style.boxShadow='none'; }, 2600);
        }
      }, 180);
    }, 200);
  }, intento===0?260:180);
}


// Cambia el estado del reclamo
async function _reclSetEstado(oid, estado){
  var d=_logLeer(oid);
  d.reclamo=d.reclamo||{};
  var antes=d.reclamo.estado||'pendiente';
  if(estado==='resuelto'){
    var nota=prompt('¿Cómo se resolvió el reclamo?\n\n'
      +'Por ejemplo: nota de crédito NC-4471 recibida, o el proveedor envió la reposición.\n\n'
      +'Queda registrado en el historial:','');
    if(nota===null){ try{ if(PG==='alertas') rAlertas(); }catch(e){} return; }
    d.reclamo.nota=String(nota).trim();
    d.reclamo.resuelto_en=new Date().toISOString();
    d.reclamo.resuelto_por=(CU&&CU.name)||'';
  }
  d.reclamo.estado=estado;
  if(estado!=='resuelto'){
    d.reclamo.resuelto_en=''; d.reclamo.resuelto_por='';
  }
  await _logGuardar(oid);
  // Y en su tabla, que es la fuente que ven todos
  try{
    await _reclGuardarEstado(oid, {
      estado:estado,
      nota:d.reclamo.nota||'',
      resuelto_en:d.reclamo.resuelto_en||null,
      resuelto_por:d.reclamo.resuelto_por||''
    });
  }catch(e){}

  // El estado también se guarda en el envío, para que no se pierda
  try{
    var k=String(oid)+'|reclamo';
    if(window._solEnvios && window._solEnvios[k]){
      window._solEnvios[k].estado=estado;
      window._solEnvios[k].nota=d.reclamo.nota||'';
      window._solEnvios[k].resuelto_en=d.reclamo.resuelto_en||'';
      window._solEnvios[k].resuelto_por=d.reclamo.resuelto_por||'';
      _solEnvioGuardar(oid, 'reclamo', window._solEnvios[k]);
    }
  }catch(e){}

  showT('Reclamo marcado como '+((_RECL_ESTADOS[estado]||{}).t||estado).toLowerCase());

  // Al resolverse se avisa a gerencia y a quien lo hizo
  if(estado==='resuelto' && antes!=='resuelto'){
    try{
      var dat=_solPagoDatosOrden(oid);
      var dept=dat.dept||'';
      var destinos=(USERS||[]).filter(function(u){
        if(!u.id || u.id===((CU&&CU.id)||'')) return false;
        if(u.role==='gerencia') return !dept || !u.dept || String(u.dept)===String(dept);
        return _esComprasU(u) && dept && String(u.dept||'')===String(dept);
      });
      if(destinos.length) await _menNotificar(destinos, {
        docnum:oid, contexto:'etapa', etapa:'Bodega & Venta', paso:_PASO_BOD_SAP,
        texto:'Reclamo resuelto · '+(dat.proveedor||'')+(d.reclamo.nota?(' · '+d.reclamo.nota):''),
        etiqueta:'Reclamo resuelto'
      });
    }catch(e){}
  }
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
  try{ _bodRepintar(oid); }catch(e){}
}

function _pgDesde(iso){
  if(!iso) return {txt:'—', dias:null};
  var d=new Date(iso);
  if(isNaN(d)) return {txt:'—', dias:null};
  var ms=Date.now()-d.getTime();
  var dias=Math.floor(ms/86400000);
  var hs=Math.floor((ms%86400000)/3600000);
  return {
    dias:dias,
    txt:(dias>0?(dias+'d '):'')+hs+'h',
    fecha:_fechaHora(iso)
  };
}

function _pgColor(dias){
  if(dias==null) return 'var(--text-muted)';
  if(dias>=7) return '#991b1b';
  if(dias>=3) return '#B45309';
  return '#166534';
}

// ── 1) Abonos pedidos y sin comprobante al proveedor ──
// Una solicitud sale de las alertas cuando ya no hay nada que perseguir.
// Además del estado, cuenta el interruptor "Pagada" del reporte de abonos y
// cancelaciones: al marcarlo, el portal dice literalmente "sale de las
// alertas", pero estos filtros nunca miraban ese campo y la solicitud seguía
// sumando días. Es lo que pasaba con la proforma GKC-26/78, pagada y con
// catorce días de espera en el panel.
function _pgCerrada(x){
  if(!x) return true;
  if(x.pagado === true) return true;              // el reporte la da por pagada
  var e=String(x.estado||'');
  return e==='anulada' || e==='procesada';
}

function _pgAbonos(){
  return (window._solPago||[]).filter(function(x){
    if(String(x.tipo||'')!=='abono') return false;
    if(_pgCerrada(x)) return false;
    // Y el comprobante al proveedor también la cierra
    if(String(x.estado||'')==='abono_enviado') return false;
    return true;
  });
}

// ── 2) Cancelaciones recibidas y sin enviar al proveedor ──
function _pgCancelaciones(){
  return (window._solPago||[]).filter(function(x){
    if(String(x.tipo||'')!=='cancelacion') return false;
    if(_pgCerrada(x)) return false;
    if(String(x.estado||'')==='cancelacion_realizada') return false;
    return true;
  });
}

// ── 3) Órdenes esperando artes ──
// Entran cuando la orden llega al HUB y salen cuando gerencia aprueba los artes.
function _pgArtes(){
  var out=[];
  var st=STAGES.find(function(z){ return z.key==='artes'; });
  if(!st) return out;
  var iAprob=st.steps.findIndex(function(p){ return p.name===_PASO_ARTES_APROB; });
  if(iAprob<0) return out;

  function revisar(oid, dept, proveedor, docTxt){
    if(!oid) return;
    var sp=(stageProgress[oid]||{}).artes;
    if(!sp) return;
    var idx=sp.stepIdx||0;
    // Ya pasó la aprobación de gerencia: deja de estar pendiente
    if(idx>iAprob) return;
    // Todavía no llegó a artes
    var iPedido=STAGES.findIndex(function(z){ return z.key==='pedido'; });
    var iArtes=STAGES.findIndex(function(z){ return z.key==='artes'; });
    var actual=(typeof getStageIdx==='function')?getStageIdx({id:oid}):null;
    if(actual!=null && actual<iArtes) return;

    // Desde cuándo espera: la fecha del archivo que subió compras al HUB
    var desde='';
    try{
      var sk=oid+'artes_step0';
      var docs=(window._atts&&window._atts[sk])?_dedupDocs(window._atts[sk]):[];
      // El Excel de compra es el que marca el arranque
      var excel=docs.find(function(a){ return /\.(xlsx|xls|csv)$/i.test(String(a.name||'')); });
      var ref=excel||docs[0];
      if(ref && ref.date) desde=ref.date;
    }catch(e){}
    if(!desde && sp.startDate) desde=sp.startDate;
    if(!desde){
      try{ desde=(sp.stepDates||[])[0]||''; }catch(e){}
    }

    out.push({
      oid:oid, dept:dept||'otros', proveedor:proveedor||'', doc:docTxt||oid,
      desde:_pgIsoDe(desde),
      paso:(st.steps[Math.min(idx, st.steps.length-1)]||{}).name||''
    });
  }

  (typeof orders!=='undefined'?orders:[]).forEach(function(o){
    if(o.pend || o.comp) return;
    revisar(o.id, o.dept, o.prov||o.proveedor, o.id);
  });
  (window._pendSAP||[]).forEach(function(p){
    var oid=p.dkc||p.num_orden;
    revisar(oid, p.dept, p.proveedor||p.cardname, p.dkc||oid);
  });
  return out;
}

// Las fechas del portal vienen como "dd/mm/aaaa hh:mm"; se pasan a ISO
function _pgIsoDe(f){
  if(!f) return '';
  var s=String(f).trim();
  if(/^\d{4}-\d{2}-\d{2}/.test(s)) return s;
  var m=s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ ,]+(\d{1,2}):(\d{2}))?/);
  if(m){
    var yy=+m[3], mm=+m[2], dd=+m[1], hh=+(m[4]||0), mi=+(m[5]||0);
    var d=new Date(yy, mm-1, dd, hh, mi);
    return isNaN(d)?'':d.toISOString();
  }
  var d2=new Date(s);
  return isNaN(d2)?'':d2.toISOString();
}

// ── El panel ──
function _pgPanel(){
  if(!CU || CU.role!=='gerencia') return '';

  var abonos=_pgAbonos();
  var cancel=_pgCancelaciones();
  var artes=_pgArtes();
  var total=abonos.length+cancel.length+artes.length;

  var h='<div style="border:1px solid #E0A82E;border-radius:11px;background:var(--surface-0);'
    +'margin-bottom:14px;overflow:hidden">';
  h+='<div style="padding:10px 14px;background:var(--pastel-aviso);display:flex;align-items:center;gap:9px;flex-wrap:wrap;'
    +'border-bottom:0.5px solid #E9C08A">'
    +'<i class="ti ti-checklist" style="color:var(--t-marron);font-size:16px"></i>'
    +'<span style="font-size:13px;font-weight:700;color:var(--t-marron)">Pendientes de seguimiento</span>'
    +'<span style="font-size:11px;color:var(--t-marron);opacity:.85">'+total+' en total</span>'
    +'<span style="flex:1"></span>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">Desaparecen solos al completarse</span>'
    +'</div>';

  h+=_pgBloque('Solicitudes de abono', 'ti-coin', '#166534', abonos, 'abono');
  h+=_pgBloque('Solicitudes de cancelación', 'ti-file-invoice', '#B45309', cancel, 'cancelacion');
  h+=_pgBloqueArtes(artes);

  return h+'</div>';
}

function _pgBloque(titulo, icono, color, lista, tipo){
  var h='<div style="border-bottom:0.5px solid var(--border)">'
    +'<div style="padding:8px 14px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;background:var(--surface-1)">'
      +'<i class="ti '+icono+'" style="color:'+color+'"></i>'
      +'<span style="font-size:12px;font-weight:700;color:'+color+'">'+_esc(titulo)+'</span>'
      +'<span style="font-size:11px;color:var(--text-muted)">'+lista.length+' pendiente(s)'
      +(lista.length?(' · '+fmt(lista.reduce(function(a,x){return a+(Number(x.monto)||0);},0))):'')+'</span>'
    +'</div>';

  if(!lista.length){
    return h+'<div style="padding:9px 14px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> Nada pendiente.</div></div>';
  }

  // Agrupadas por departamento
  var porDept={};
  lista.forEach(function(x){ var d=x.dept||'otros'; (porDept[d]=porDept[d]||[]).push(x); });

  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var tot=g.reduce(function(a,x){return a+(Number(x.monto)||0);},0);
    var peor=0;
    g.forEach(function(x){
      var t=_pgDesde(x.creado_en||x.solicitado_en);
      if(t.dias!=null && t.dias>peor) peor=t.dias;
    });
    h+='<div style="padding:6px 14px;background:rgba(0,0,0,.02);font-size:11px;font-weight:700;color:'+color+'">'
      +(EMOJIS2[d]||'')+' '+_esc(dL(d))
      +' <span style="font-weight:400;color:var(--text-muted)">· '+g.length+' · '+fmt(tot)
      +' · el más viejo '+peor+' día(s)</span></div>';

    g.sort(function(a,b){
      var da=_pgDesde(a.creado_en||a.solicitado_en).dias||0;
      var db=_pgDesde(b.creado_en||b.solicitado_en).dias||0;
      return db-da;
    }).forEach(function(x){
      // El reloj arranca cuando se generó la solicitud; en cancelaciones,
      // cuando contabilidad la recibió.
      var refIso=(tipo==='cancelacion')
        ? (x.recibido_en||x.creado_en||x.solicitado_en)
        : (x.creado_en||x.solicitado_en);
      var t=_pgDesde(refIso);
      var col=_pgColor(t.dias);
      var st=_solEstadoLabel(x);
      h+='<div id="solcard-'+_esc(String(x.id||''))+'" data-soldoc="'+_esc(String(x.docnum||''))+'"'
        +' onclick="_solPagoVerSolicitud('+(x.id||0)+')"'
        +' style="padding:8px 14px;border-top:0.5px solid var(--border);display:flex;align-items:center;'
        +'gap:10px;flex-wrap:wrap;cursor:pointer">'
        +'<div style="min-width:56px;text-align:center">'
          +'<div style="font-size:15px;font-weight:800;color:'+col+';line-height:1.1">'+_esc(t.txt)+'</div>'
          +'<div style="font-size:8px;color:var(--text-muted);text-transform:uppercase">esperando</div></div>'
        +'<div style="flex:1;min-width:170px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
          +'<div style="font-size:10.5px;color:var(--text-muted)">Orden '+_esc(x.docnum||'')
            +_solChipOrden(x)
            +' · pedido por '+_esc(x.solicitado_por||'')
            +'<br>Solicitada: <b>'+_esc(_fechaHoraDia(_solFechaSol(x))||'—')+'</b>'
            +(x.recibido_en?('<br>Recibida en contabilidad: '+_esc(_fechaHoraDia(x.recibido_en))
                             +(x.recibido_por?(' · '+_esc(x.recibido_por)):'')):'')
            +'</div></div>'
        +'<div style="text-align:right;min-width:110px">'
          +'<div style="font-size:13px;font-weight:700;color:'+color+'">'+fmt(x.monto)+'</div>'
          +'<span style="font-size:9.5px;font-weight:700;background:'+(st.bg||'#eee')+';color:'+(st.c||'#333')
            +';border-radius:10px;padding:1px 8px">'+_esc(String(st.t||'').split(' · ')[0])+'</span>'
        +'</div>'
        +'<span style="font-size:9.5px;font-weight:800;color:#fff;background:#dc2626;border-radius:10px;padding:2px 9px">PENDIENTE</span>'
        +'</div>';
    });
  });
  return h+'</div>';
}

function _pgBloqueArtes(lista){
  var h='<div>'
    +'<div style="padding:8px 14px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;background:var(--surface-1)">'
      +'<i class="ti ti-palette" style="color:var(--t-lila)"></i>'
      +'<span style="font-size:12px;font-weight:700;color:var(--t-lila)">Órdenes esperando artes</span>'
      +'<span style="font-size:11px;color:var(--text-muted)">'+lista.length+' pendiente(s)</span>'
    +'</div>';

  if(!lista.length){
    return h+'<div style="padding:9px 14px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> Nada pendiente.</div></div>';
  }

  var porDept={};
  lista.forEach(function(x){ var d=x.dept||'otros'; (porDept[d]=porDept[d]||[]).push(x); });

  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var peor=0;
    g.forEach(function(x){ var t=_pgDesde(x.desde); if(t.dias!=null && t.dias>peor) peor=t.dias; });
    h+='<div style="padding:6px 14px;background:rgba(0,0,0,.02);font-size:11px;font-weight:700;color:var(--t-lila)">'
      +(EMOJIS2[d]||'')+' '+_esc(dL(d))
      +' <span style="font-weight:400;color:var(--text-muted)">· '+g.length+' orden(es)'
      +' · la más vieja '+peor+' día(s)</span></div>';

    g.sort(function(a,b){
      return (_pgDesde(b.desde).dias||0)-(_pgDesde(a.desde).dias||0);
    }).forEach(function(x){
      var t=_pgDesde(x.desde);
      var col=_pgColor(t.dias);
      h+='<div onclick="_pgIrAArtes(\''+_esc(String(x.oid).replace(/\x27/g,''))+'\')"'
        +' style="padding:8px 14px;border-top:0.5px solid var(--border);display:flex;align-items:center;'
        +'gap:10px;flex-wrap:wrap;cursor:pointer">'
        +'<div style="min-width:56px;text-align:center">'
          +'<div style="font-size:15px;font-weight:800;color:'+col+';line-height:1.1">'+_esc(t.txt)+'</div>'
          +'<div style="font-size:8px;color:var(--text-muted);text-transform:uppercase">esperando</div></div>'
        +'<div style="flex:1;min-width:170px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
          +'<div style="font-size:10.5px;color:var(--text-muted)">Orden '+_esc(x.doc||'')
            +'<br>Compras subió el Excel: '+_esc(t.fecha||'—')+'</div></div>'
        +'<div style="text-align:right;min-width:120px">'
          +'<div style="font-size:10.5px;color:var(--t-lila);font-weight:600">'+_esc(x.paso||'')+'</div></div>'
        +'<span style="font-size:9.5px;font-weight:800;color:#fff;background:#dc2626;border-radius:10px;padding:2px 9px">PENDIENTE</span>'
        +'</div>';
    });
  });
  return h+'</div>';
}

// Abre la orden directamente en la etapa de artes
function _pgIrAArtes(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='artes'; });
  if(idx<0) return;
  initP(oid);
  var sp=(stageProgress[oid]||{}).artes||{};
  window._abrirEtapa={oid:String(oid), key:'artes', paso:(sp.stepIdx||0)};
  try{ _solPagoAbrir(oid); }catch(e){ try{ openDetail(oid); }catch(e2){} }
  _abrirEtapaPedida(0);
}

// ═══════════════════════════════════════════════════════════════════════════
//  SEGUIMIENTO DE ABONOS
//  Los que compras ya pidió a contabilidad y todavía no salieron al proveedor.
//  Muestra los días que llevan esperando y los totales por departamento.
// ═══════════════════════════════════════════════════════════════════════════
function _segDias(iso){
  if(!iso) return null;
  var d=new Date(iso);
  if(isNaN(d)) return null;
  return Math.floor((Date.now()-d.getTime())/(1000*60*60*24));
}

function _segColorDias(n){
  if(n==null) return 'var(--text-muted)';
  if(n>=7)  return '#991b1b';       // más de una semana: urge
  if(n>=4)  return '#B45309';
  return '#166534';
}

// Las solicitudes pedidas y sin comprobante enviado al proveedor
function _segPendientes(){
  return (window._solPago||[]).filter(function(x){
    if(String(x.tipo||'')!=='abono') return false;
    var e=String(x.estado||'');
    // Ya salió al proveedor: deja de estar en seguimiento
    if(e==='abono_enviado' || e==='cancelacion_realizada' || e==='anulada') return false;
    return true;
  });
}

function _segPanel(){
  if(!CU || ['gerencia','compras','contabilidad'].indexOf(CU.role)<0) return '';
  var todas=_segPendientes();

  // Compras ve lo de su departamento; gerencia, todo
  var lista=todas;
  if(_esCompras() && _deptAcotado()){
    lista=todas.filter(function(x){ return _deptPermitido(normDept(x.dept||'')); });
  }
  var abierto=!!window._segAbierto;

  var porDept={}, totalGeneral=0, masViejo=0;
  lista.forEach(function(x){
    var d=x.dept||'otros';
    if(!porDept[d]) porDept[d]={n:0, monto:0, dias:0};
    porDept[d].n++;
    porDept[d].monto+=Number(x.monto)||0;
    var dd=_segDias(x.creado_en||x.solicitado_en);
    if(dd!=null){
      if(dd>porDept[d].dias) porDept[d].dias=dd;
      if(dd>masViejo) masViejo=dd;
    }
    totalGeneral+=Number(x.monto)||0;
  });

  var h='<div style="border:1px solid '+(masViejo>=7?'#dc2626':'#E9C08A')+';border-radius:10px;'
    +'background:'+(masViejo>=7?'#FEF2F2':'#FEF9F3')+';margin-bottom:12px;overflow:hidden">';
  h+='<div onclick="_segToggle()" style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;cursor:pointer">'
    +'<i class="ti ti-clock-dollar" style="color:'+(masViejo>=7?'#991b1b':'#B45309')+'"></i>'
    +'<span style="font-size:12.5px;font-weight:700;color:'+(masViejo>=7?'#991b1b':'#7C3D12')+'">'
      +'Abonos pedidos y sin enviar al proveedor</span>'
    +'<span style="font-size:11px;color:'+(masViejo>=7?'#991b1b':'#7C3D12')+';opacity:.9">'
      +lista.length+' solicitud(es) · '+fmt(totalGeneral)+'</span>'
    +(masViejo>0?('<span style="font-size:10.5px;font-weight:700;background:'+(masViejo>=7?'#dc2626':'#E0A82E')
      +';color:#fff;border-radius:12px;padding:2px 9px">el más viejo: '+masViejo+' día(s)</span>'):'')
    +'<span style="flex:1"></span>'
    +'<i class="ti ti-chevron-'+(abierto?'up':'down')+'" style="color:var(--text-muted)"></i>'
    +'</div>';

  if(!lista.length){
    h+='<div style="padding:10px 13px;font-size:11.5px;color:var(--text-muted);border-top:0.5px solid var(--border)">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> No hay abonos esperando.</div>';
    return h+'</div>';
  }

  // Totales por departamento, siempre visibles
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;padding:0 13px 9px">';
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:6px 10px;min-width:130px">'
      +'<div style="font-size:10px;color:var(--text-muted);font-weight:600">'+(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</div>'
      +'<div style="font-size:13px;font-weight:700;color:var(--t-marron)">'+fmt(g.monto)+'</div>'
      +'<div style="font-size:10px;color:'+_segColorDias(g.dias)+'">'+g.n+' orden(es) · hasta '+g.dias+' día(s)</div>'
      +'</div>';
  });
  h+='</div>';

  if(!abierto) return h+'</div>';

  // El detalle, ordenado por antigüedad
  var orden=lista.slice().sort(function(a,b){
    var da=_segDias(a.creado_en||a.solicitado_en)||0;
    var db=_segDias(b.creado_en||b.solicitado_en)||0;
    return db-da;
  });
  orden.forEach(function(x){
    var dd=_segDias(x.creado_en||x.solicitado_en);
    var col=_segColorDias(dd);
    var st=_solEstadoLabel(x);
    h+='<div id="solcard-'+_esc(String(x.id||''))+'" data-soldoc="'+_esc(String(x.docnum||''))+'"'
      +' onclick="_solPagoAbrir(\''+_esc(String(x.docnum||''))+'\')"'
      +' style="border-top:0.5px solid var(--border);padding:8px 13px;background:var(--surface-0);cursor:pointer;display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div style="min-width:52px;text-align:center">'
        +'<div style="font-size:17px;font-weight:800;color:'+col+';line-height:1">'+(dd==null?'—':dd)+'</div>'
        +'<div style="font-size:8.5px;color:var(--text-muted);text-transform:uppercase">días</div></div>'
      +'<div style="flex:1;min-width:160px">'
        +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
        +'<div style="font-size:10.5px;color:var(--text-muted)">'
          +'Orden '+_esc(x.docnum||'')+_solChipOrden(x)
          +' · '+(EMOJIS2[x.dept]||'')+' '+_esc(dL(x.dept||''))
          +' · pedido por '+_esc(x.solicitado_por||'')
          +(_solFechaSol(x)?(' · '+_esc(_fechaHoraDia(_solFechaSol(x)))):'')+'</div></div>'
      +'<div style="text-align:right;min-width:100px">'
        +'<div style="font-size:13px;font-weight:700;color:var(--t-verde)">'+fmt(x.monto)+'</div>'
        +(st?('<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(st.t||st)+'</div>'):'')
      +'</div>'
      +'</div>';
  });
  return h+'</div>';
}

function _segToggle(){
  window._segAbierto=!window._segAbierto;
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

function _solPagoSeccion(tipo, titulo, icono, color, bg, bd){
  var lista=_solPagoPendientes(tipo);
  var total0=lista.length;
  lista=_solFiltrarSeccion(lista, tipo);
  var h='<div style="border:1px solid '+bd+';background:'+bg+';border-radius:10px;margin-bottom:12px;overflow:hidden">';
  h+='<div style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
    +'<i class="'+icono+'" style="color:'+color+'"></i>'
    +'<span style="font-size:12.5px;font-weight:700;color:'+color+'">'+titulo+'</span>'
    +'<span style="font-size:11px;color:'+color+';opacity:.85">'+lista.length+' orden(es) · '+fmt(lista.reduce(function(a,x){return a+(Number(x.monto)||0);},0))+'</span>'
    +'<button class="btn bg2" style="margin-left:auto;padding:3px 10px;font-size:10.5px" onclick="_solPagoReporte(\''+tipo+'\')"><i class="ti ti-printer"></i> Reporte</button>'
    +'</div>'
    + _solBarraFiltro(tipo, total0, lista.length, bd);
  if(!lista.length){
    var f=(window._solSecFiltro||{})[tipo]||{};
    h+='<div style="padding:10px 13px;font-size:11.5px;color:var(--text-muted);'
      +'border-top:0.5px solid '+bd+'">'
      +((f.q||f.dept)?('Ninguna solicitud con ese filtro'
         +(total0?(' · hay '+total0+' en total'):'')
         +' · <span onclick="_solSecLimpiar(\''+tipo+'\')" style="cursor:pointer;'
         +'text-decoration:underline">quitar el filtro</span>')
        :'Sin solicitudes pendientes.')
      +'</div>';
    return h+'</div>';
  }
  // Agrupadas por departamento solicitante
  var porDept={};
  lista.forEach(function(x){ var d=x.dept||'otros'; (porDept[d]=porDept[d]||[]).push(x); });
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var tot=g.reduce(function(a,x){return a+(Number(x.monto)||0);},0);
    h+='<div style="border-top:0.5px solid '+bd+';padding:7px 13px;background:rgba(255,255,255,.45);font-size:11px;font-weight:700;color:'+color+'">'
      +(EMOJIS2[d]||'')+' '+dL(d)+' <span style="font-weight:400">· '+g.length+' orden(es) · '+fmt(tot)+'</span></div>';
    g.forEach(function(x){
      var st=_solEstadoLabel(x);
      // Con id y docnum se puede llegar a esta solicitud desde una alerta
      h+='<div id="solcard-'+_esc(String(x.id||''))+'" data-soldoc="'+_esc(String(x.docnum||''))+'"'
        +' style="border-top:0.5px solid '+bd+';padding:8px 13px;background:var(--surface-0)">'
        +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
          +'<div style="flex:1;min-width:150px">'
            +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
            +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'
              +_solRefLinks(x)
              +(x.eta?(' · ETA '+_esc(x.eta)):'')
            +'</div>'
            +'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'+(x.solicitado_por?('Solicitó '+_esc(x.solicitado_por)):'Solicitada')+(_solFechaSol(x)?(' · <b>'+_esc(_fechaHoraDia(_solFechaSol(x)))+'</b>'):'')+'</div>'
          +'</div>'
          +'<div style="text-align:right;flex-shrink:0"><div style="font-size:13px;font-weight:700;color:'+color+'">'+fmt(x.monto)+'</div></div>'
          +'<button class="btn bp" style="padding:5px 11px;font-size:10.5px;font-weight:600" onclick="_solPagoVerSolicitud('+(x.id||0)+')" title="Abrir la orden en la etapa de Depósito y revisar los adjuntos"><i class="ti ti-folder-open"></i> Ver solicitud</button>'
        +((CU && (CU.role==='contabilidad'||CU.role==='gerencia') && String(x.estado||'')!=='devuelta')
          ? ('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--t-rojo)" onclick="_solDevolver('+(x.id||0)+')" title="Devolver a compras con un motivo"><i class="ti ti-arrow-back-up"></i> Devolver</button>')
          : '')
        +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px" onclick="_solPagoProcesar('+(x.id||0)+')" title="Marcar como trabajada"><i class="ti ti-check"></i></button>'
        +(_esGerencia()?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--t-ambar)" onclick="_solPagoEditar('+(x.id||0)+')" title="Editar el monto"><i class="ti ti-pencil"></i></button>'
          +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger)" onclick="_gerBorrarSolicitud('+(x.id||0)+')" title="Borrar esta solicitud"><i class="ti ti-trash"></i></button>'):'')
        +'</div>'
      +_solHitos(x)
        +'<div style="margin-top:5px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
          +'<span style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;background:'+st.bg+';color:'+st.c+'">'+_esc(st.t)+'</span>'
          +_solDeptChip(x)
          +_solComprobChip(x)
          +_solFinanciadoChip(x)
          +_solPagadoCheck(x)
          +_solComentBtn(x)
          +_solLeidoPor(x)
        +'</div>'
        +_solComentBox(x, color)
      +'</div>';
    });
  });
  return h+'</div>';
}

// Número de orden y Vendor Ref No, ambos clickeables hacia la orden
function _solRefLinks(x, colorDkc){
  var oid=String(x.docnum||'').replace(/'/g,'');
  var est='color:var(--text-accent);text-decoration:underline;cursor:pointer;font-weight:700';
  var estD='color:'+(colorDkc||'#B45309')+';text-decoration:underline;cursor:pointer;font-weight:700';
  var h='<span onclick="event.stopPropagation();_solPagoAbrir(\''+oid+'\')" title="Abrir la orden" style="'+est+'">#'+_esc(oid)+'</span>';
  if(x.dkc) h+=' - <span onclick="event.stopPropagation();_solPagoAbrir(\''+oid+'\')" title="Abrir la orden" style="'+estD+'">'+_esc(x.dkc)+'</span>';
  return h;
}

// Abre la orden en la etapa de Depósito & Pago, que es donde contabilidad
// trabaja, y marca la solicitud como recibida.
async function _solPagoVerSolicitud(id){
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  var oid=String(x.docnum||'');

  // Gerencia solo mira: al abrirla, su alerta se da por leída y desaparece.
  // Antes quedaba en el contador aunque ya la hubiera visto.
  try{
    var mias=(window._menciones||[]).filter(function(m){
      return String(m.docnum)===oid
        && (String(m.contexto||'')==='solicitud'
            || /solicitud|abono|dep[oó]sito|pago/i.test(String(m.etiqueta||'')+' '+String(m.texto||'')));
    });
    for(var i=0;i<mias.length;i++){
      await fetch(SB+'/rest/v1/menciones?id=eq.'+mias[i].id,{method:'PATCH',
        headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})});
    }
    if(mias.length){
      var ids={};
      mias.forEach(function(m){ ids[String(m.id)]=1; });
      window._menciones=(window._menciones||[]).filter(function(m){ return !ids[String(m.id)]; });
      _menBadge();
    }
  }catch(e){ console.warn('marcar alerta como leída:',e); }
  // Al abrirla, contabilidad la da por recibida. Se espera a que el cambio
  // quede guardado: si el PATCH falla, hay que avisar en vez de fingir.
  if(CU && CU.role==='contabilidad' && !x.recibido_en && (!x.estado || x.estado==='pendiente')){
    x.estado='recibida';
    x.recibido_por=(CU&&CU.name)||'';
    x.recibido_en=new Date().toISOString();
    _solPagoRefrescar();   // se ve el cambio de inmediato
    var ok=await _solPagoPatch(id,{estado:'recibida', recibido_por:x.recibido_por, recibido_en:x.recibido_en});
    if(!ok){
      // Si la tabla rechazó el estado, al menos se guarda la fecha y quién la
      // abrió: con eso el portal ya la muestra como recibida y no se pierde.
      ok=await _solPagoPatch(id,{recibido_por:x.recibido_por, recibido_en:x.recibido_en});
    }
    if(ok){
      try{
        _avSolicitud(_avSolicitante(x), x,
          'Contabilidad recibió tu solicitud · '+(x.recibido_por||''),
          'Solicitud recibida');
      }catch(e){}
      showT('Solicitud RECIBIDA · '+_fechaHora(x.recibido_en)+' — compras ya lo ve');
    } else {
      showT('⚠ No se pudo guardar la recepción. Revisa la conexión o la tabla solicitudes_pago.');
    }
    _solPagoRefrescar();
  }
  // Se deja pedido que al abrir el detalle se despliegue la etapa de depósito,
  // y dentro de ella el subpaso exacto de esta solicitud: el abono se pide en
  // "Solicitud de depósito enviada" y la cancelación en "Solicitud de final
  // del balance". Antes se abría la etapa entera y había que buscarlo.
  var _pasoNombre=(x.tipo==='cancelacion')?'Solicitud de final del balance':'Solicitud de depósito enviada';
  var _et=STAGES.find(function(s){ return s.key==='deposito'; });
  var _pasoIdx=_et?_et.steps.findIndex(function(p){ return p.name===_pasoNombre; }):-1;
  window._abrirEtapa={oid:oid, key:'deposito', paso:(_pasoIdx>=0?_pasoIdx:null)};
  _solPagoAbrir(oid);
  _abrirEtapaPedida(0);
}

// Despliega la etapa que quedó pedida y hace scroll hasta ella.
// Espera a que el detalle esté dibujado en vez de asumir un tiempo fijo:
// abrir una orden NO SAP puede tardar en cargar sus líneas.
function _abrirEtapaPedida(intento){
  var p=window._abrirEtapa; if(!p) return;
  intento=intento||0;
  var idx=STAGES.findIndex(function(s){ return s.key===p.key; });
  if(idx<0){ window._abrirEtapa=null; return; }
  var cab=document.getElementById('egb-'+p.oid+'-'+idx);
  if(!cab){
    if(intento>40){ window._abrirEtapa=null; return; }   // ~6 s y se rinde
    return setTimeout(function(){ _abrirEtapaPedida(intento+1); }, 150);
  }
  var paso=p.paso;               // el subpaso concreto, si se sabe cuál
  window._abrirEtapa=null;
  try{ toggleEG(p.oid, idx, true); }catch(e){ return; }
  setTimeout(function(){
    // Si se sabe el subpaso, se va directo a él; si no, a la etapa
    var destino=null;
    if(paso!=null && paso>=0){
      var cuerpo=document.getElementById('ssb-'+p.oid+'-'+idx+'-'+paso);
      if(cuerpo){
        // El subpaso viene plegado: se abre para que se vea el contenido
        if(cuerpo.style.display==='none'){
          try{ toggleSubStep(p.oid, idx, paso); }catch(e){}
        }
        destino=cuerpo.previousElementSibling || cuerpo;
      }
    }
    var el=destino || document.getElementById('egb-'+p.oid+'-'+idx);
    if(el && el.scrollIntoView) el.scrollIntoView({behavior:'smooth', block:'center'});
    if(el){
      el.style.transition='box-shadow .3s';
      el.style.boxShadow='0 0 0 3px var(--fill-accent)';
      setTimeout(function(){ el.style.boxShadow='none'; }, 2200);
    }
  }, 260);
}

function _solPagoAbrir(oid){
  try{
    if(CU && CU.role==='contabilidad'){
      // Se marca como recibida y se repinta: antes el aviso quedaba igual
      // hasta recargar la página.
      Promise.resolve(_solPagoMarcarRecibidas(oid))
        .then(function(){ try{ _solPagoRefrescar(); }catch(e){} });
    }
  }catch(e){}
  // Siempre el detalle CON ETAPAS. Antes, si la orden era NO SAP, se abría la
  // ficha simple de adjuntos y contabilidad no veía el proceso.
  if((orders||[]).some(function(o){return String(o.id)===String(oid);})) openDetail(oid);
  else if((window._pendSAP||[]).some(function(p){return String(p.dkc)===String(oid)||String(p.num_orden)===String(oid);})) abrirDetalleNoSap(oid);
  else _solPagoAbrirPorFactura(oid);
}

/* Algunas solicitudes se guardan con el número de la FACTURA RESERVA en vez
   del de la orden (las que nacen al registrar la factura). Entonces no hay
   ninguna orden con ese número y salía «Orden no encontrada» sin más. Aquí
   se busca de qué orden viene esa factura y se abre esa. */
async function _solPagoAbrirPorFactura(num){
  var n=String(num||'').replace(/[^0-9]/g,'');
  if(!n){ showT('Esta solicitud no trae número de orden'); return; }
  showT('Buscando la orden de la factura #'+n+'…');
  var ordenes='';
  try{
    var r=await fetch(SB+'/rest/v1/opch_reserva?select=docnum,ordenes,cardname'
      +'&docnum=eq.'+n+'&limit=1',{headers:SBH});
    var f=(r.ok?((await r.json())||[]):[])[0];
    if(f) ordenes=String(f.ordenes||'');
  }catch(e){}
  // Y si no, por las líneas de la factura, que llevan la orden de origen
  if(!ordenes){
    try{
      var r2=await fetch(SB+'/rest/v1/opdn_lineas?select=orden_num&factura_num=eq.'+n
        +'&limit=5',{headers:SBH});
      var l=(r2.ok?((await r2.json())||[]):[]);
      ordenes=[...new Set(l.map(function(x){ return x.orden_num; }).filter(Boolean))].join(', ');
    }catch(e){}
  }
  var primera=String(ordenes||'').replace(/[^0-9]/g,' ').trim().split(/\s+/)[0];
  if(primera){
    var existe=(orders||[]).some(function(o){ return String(o.id)===String(primera); });
    if(existe){
      showT('La solicitud es de la factura #'+n+' · abriendo la orden '+primera, 7000);
      openDetail(primera);
      return;
    }
  }
  // Sin una orden que abrir, se trabaja la solicitud por sí sola
  var sol=(window._solPago||[]).filter(function(z){
    return String(z.docnum||'')===String(num) || String(z.docnum||'')===String(n); })[0];
  if(sol){ _solFichaSuelta(sol); return; }
  alert('No puedo abrir la orden de esta solicitud.\n\n'
    +'El número que trae («'+n+'») es de una FACTURA RESERVA, no de una orden'
    +(ordenes?(', y viene de la orden '+ordenes+', que no está cargada en el portal'):'')
    +'.\n\nDale a Sync y vuelve a intentarlo.');
}

async function _solPagoProcesar(id){
  if(!id){ return; }
  if(!confirm('¿Marcar esta solicitud como trabajada?\n\nDejará de aparecer en el listado de pendientes.')) return;
  try{
    var r=await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+id,{
      method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({estado:'procesada', procesado_por:(CU&&CU.name)||'', procesado_en:new Date().toISOString()})});
    if(!r.ok){ showT('No se pudo actualizar'); return; }
    (window._solPago||[]).forEach(function(x){ if(String(x.id)===String(id)) x.estado='procesada'; });
    showT('Solicitud marcada como trabajada');
    rAlertas();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// Entrada desde el menú: se asegura de tener las solicitudes cargadas
async function _solPagoReporteMenu(){
  // Mismo criterio que la conciliación: contabilidad y gerencia general.
  if(!(CU && (CU.role==='contabilidad' || (CU.role==='gerencia' && !_deptAcotado())))){
    showT('Ese reporte es de contabilidad y gerencia general');
    return;
  }
  showT('Cargando las solicitudes…');
  await _solPagoCargar(true);
  _solPagoPanel();
}

// ══════════════════════════════════════════════════════════════════════
//  PANEL PREVIO AL REPORTE
//  Antes se iba directo a imprimir. Contabilidad necesita ver la lista,
//  marcar lo que ya se pagó y solo entonces sacar el papel.
// ══════════════════════════════════════════════════════════════════════
window._solPanelFiltro = window._solPanelFiltro || 'todas';

// ── Edición en el propio panel ──
// Contabilidad necesita corregir sobre la marcha: la ETA que cambió, el
// estado, quién lo preparó, si va financiado… Cada celda se guarda al salir
// de ella, y si la base lo rechaza se avisa y se deja el valor anterior.
function _solEditable(x, campo, valor, extra){
  var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
  if(!puede) return _esc(valor||'');
  return '<span contenteditable="true" spellcheck="false"'
    +' data-id="'+(x.id||0)+'" data-campo="'+campo+'"'
    +' onblur="_solGuardarCampo(this)"'
    +' oninput="_solMarcarSucio(this)"'
    +' onkeydown="if(event.key===\'Enter\'){event.preventDefault();this.blur();}'
    +'if(event.key===\'Escape\'){this.textContent=this.dataset.orig||\'\';'
    +'_solLimpiarSucio(this);this.blur();}"'
    +' onfocus="this.dataset.orig=this.textContent"'
    +' style="display:inline-block;min-width:34px;border-bottom:1px dashed var(--border);'
    +'padding:1px 3px;border-radius:3px;outline:none;'+(extra||'')+'"'
    +' title="Pulsa para editar · Intro guarda · Escape cancela">'
    +_esc(valor||'')+'</span>';
}

// Los campos de dos o tres valores van con desplegable: se ve de un vistazo
// qué opciones hay y no hace falta adivinar qué pasa al pulsar.
function _solDesplegable(x, campo, opciones, ancho){
  var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
  var v=x[campo];
  var actual = opciones.find(function(o){ return o.v===v; }) || opciones[0];
  if(!puede) return '<b style="color:'+(actual.c||'inherit')+'">'+_esc(actual.t)+'</b>';
  return '<select onchange="_solElegir('+(x.id||0)+',\''+campo+'\', this.value)" '
    +'style="font-size:10.5px;font-weight:600;padding:2px 4px;border-radius:7px;cursor:pointer;'
    +'border:0.5px solid var(--border);background:var(--surface-0);'
    +'color:'+(actual.c||'inherit')+';'+(ancho?('width:'+ancho+';'):'')+'">'
    + opciones.map(function(o){
        return '<option value="'+_esc(String(o.v))+'"'
          +((o.v===v)?' selected':'')+'>'+_esc(o.t)+'</option>';
      }).join('')
    +'</select>';
}

// SÍ / NO / sin dato, para financiado y pagado
function _solSiNo(x, campo){
  return _solDesplegable(x, campo, [
    {v:null,  t:'—',  c:'var(--text-muted)'},
    {v:true,  t:'SÍ', c:'#3730A3'},
    {v:false, t:'NO', c:'var(--text-muted)'}
  ], '62px');
}

// Guarda la opción elegida. El valor viaja como texto desde el desplegable,
// así que hay que devolverlo a su tipo antes de guardarlo.
async function _solElegir(id, campo, valor){
  var x=(window._solPago||[]).find(function(s){ return String(s.id)===String(id); });
  if(!x) return;
  var nuevo = (valor==='true') ? true : (valor==='false' ? false
              : (valor==='null'||valor==='') ? null : valor);
  var antes = x[campo];
  if(nuevo===antes) return;
  var envio={}; envio[campo]=nuevo;
  // Al marcarla como pagada se guarda también quién y cuándo, que es lo que
  // se enseña debajo y lo que sale en el reporte.
  if(campo==='pagado'){
    if(nuevo===true){
      envio.pagado_en=new Date().toISOString();
      envio.pagado_por=(CU&&CU.name)||'';
    } else {
      envio.pagado_en=null; envio.pagado_por=null;
    }
  }
  var ok=false;
  try{ ok = await _solPagoPatch(id, envio); }catch(e){}
  if(!ok){
    showT('No se pudo guardar "'+campo+'". ¿Falta esa columna en solicitudes_pago?');
    console.error('[solicitud] no se guardó '+campo+' de la solicitud '+id);
    _solRepintarDondeEste();          // devuelve el desplegable a su valor
    return;
  }
  Object.keys(envio).forEach(function(k){ x[k]=envio[k]; });

  // Si se acaba de pagar y la solicitud cuelga de una orden, se marca
  // también en la etapa de Depósito & Pago y se deja constancia escrita.
  var enOrden=null;
  if(campo==='pagado' && nuevo===true){
    enOrden = await _solConstanciaEnOrden(x);
  }

  showT(campo==='pagado'
    ? (nuevo===true
        ? ('Pagada · sale del listado'
           + (enOrden ? (' · marcado en la orden '+enOrden.oid+': '+enOrden.paso) : ''))
        : (nuevo===false?'Queda por pagar':'Sin dato de pago'))
    : 'Guardado', enOrden?6000:3500);
  _solRepintarDondeEste();
  // El panel de pendientes de seguimiento vive en otra pantalla: si no se
  // repinta, la solicitud sigue ahí contando días hasta la próxima recarga
  // y parece que el interruptor no hizo nada.
  if(campo==='pagado'){
    try{ if(document.getElementById('page-alertas')) rAlertas(); }catch(e){}
    try{ if(document.getElementById('page-completadas')) rCompletadas(); }catch(e){}
    try{ if(typeof _pgRefrescar==='function') _pgRefrescar(); }catch(e){}
  }
}

// Los campos que se pueden escribir a mano y cómo se guardan
var SOL_CAMPOS = {
  dkc:            {col:'dkc',            texto:true},
  monto:          {col:'monto',          numero:true},
  eta:            {col:'eta_texto',      texto:true},
  estado_excel:   {col:'estado_excel',   texto:true, mayus:true},
  solicitado_por: {col:'solicitado_por', texto:true},
  banco:          {col:'banco',          texto:true},
  proveedor:      {col:'proveedor',      texto:true}
};

async function _solGuardarCampo(el){
  if(!el) return;
  var id=el.getAttribute('data-id'), campo=el.getAttribute('data-campo');
  var def=SOL_CAMPOS[campo];
  var antes=String(el.dataset.orig||'');
  var texto=String(el.textContent||'').trim();
  if(!def || texto===antes.trim()) return;          // nada que hacer

  var x=(window._solPago||[]).find(function(s){ return String(s.id)===String(id); });
  if(!x){ el.textContent=antes; return; }

  var valor=texto;
  if(def.mayus) valor=texto.toUpperCase();
  if(def.numero){
    var n=parseFloat(texto.replace(/[^0-9.\-]/g,''));
    if(isNaN(n)){
      showT('"'+texto+'" no es un número');
      el.textContent=antes; return;
    }
    valor=n;
  }

  var envio={}; envio[def.col]=valor;
  // La ETA escrita a mano se guarda como texto: puede ser "ANTES DE ARRIBO"
  if(campo==='eta') envio.eta=null;

  var ok=false;
  try{ ok = await _solPagoPatch(id, envio); }catch(e){}
  if(!ok){
    showT('No se pudo guardar. ¿Falta la columna "'+def.col+'" en solicitudes_pago?');
    console.error('[solicitud] no se guardó '+def.col+' de la solicitud '+id);
    el.textContent=antes;
    return;
  }
  x[def.col]=valor;
  if(campo==='eta'){ x.eta=null; x.eta_texto=valor; }
  el.dataset.orig=el.textContent;
  el.style.background='#dcfce7';
  setTimeout(function(){ try{ el.style.background=''; }catch(e){} }, 900);
  showT('Guardado');
  // El monto cambia los totales de arriba
  if(def.numero) _solRepintarDondeEste();
}

function _solPanelLista(){
  var todas=(window._solPago||[]).slice().filter(_solPasaFiltros);
  var f=window._solPanelFiltro;
  if(f==='excel')   todas=todas.filter(_esDelExcel);
  if(f==='pagadas') todas=todas.filter(function(x){ return _solPagadaYa(x); });
  if(f==='abiertas')todas=todas.filter(function(x){ return !_solPagadaYa(x); });
  return todas.sort(function(a,b){
    var d=String(a.dept||'').localeCompare(String(b.dept||''));
    if(d) return d;
    return String(a.proveedor||'').localeCompare(String(b.proveedor||''));
  });
}

// ── De la solicitud a su orden ──────────────────────────────────────────
// Las referencias se escriben de mil formas y comparar cadenas no basta.
// En SAP los GKC van "GKC-26/63" y en el Excel de contabilidad "GKC2663";
// los DKC van "DKC-26016" y "DKC026049". Todas siguen el mismo patrón:
// PREFIJO + AÑO de dos dígitos + NÚMERO. Lo que cambia es cómo se escribe
// el número: con ceros delante, sin ellos, con guion o con barra.
//
// Así que en vez de limpiar caracteres se lleva todo a una forma canónica:
// prefijo + año(2) + número(3 con ceros). Entonces GKC-26/63, GKC2663 y
// GKC26063 son la misma cosa, y DKC026049 es DKC26049.
function _solCanon(ref){
  var n=_bkNorm(ref||'');
  if(!n) return '';
  var m=/^([A-Z]{2,4})0*(\d{2})(\d{1,3})$/.exec(n);
  if(!m) return n;                       // formatos raros: se deja tal cual
  return m[1]+m[2]+('00'+m[3]).slice(-3);
}

// Todos los candidatos que se pueden sacar de una solicitud. El campo puede
// traer la referencia sola o metida en el texto de la factura.
function _solRefsDe(x){
  var out=[];
  [x && x.dkc, x && x.docnum].forEach(function(t){
    var txt=String(t||'');
    if(!txt) return;
    var c=_solCanon(txt);
    if(c && out.indexOf(c)<0) out.push(c);
    (txt.toUpperCase().match(/[DSGW]KC[\s\-\/]?\d[\d\s\-\/]*/g)||[]).forEach(function(r){
      var cc=_solCanon(r);
      if(cc && out.indexOf(cc)<0) out.push(cc);
    });
  });
  return out;
}

// Devuelve {o, como}. `como` es 'numero' (el docnum de SAP), 'exacta' (la
// referencia coincide) o 'probable' (coinciden año y número pero no el
// prefijo: DKC26007 contra WKC26007). Las probables se enseñan en ámbar y
// avisando, porque son una suposición.
function _solOrdenDe(x){
  if(!x) return null;
  var lista=(typeof orders!=='undefined' && orders) ? orders : [];
  if(!lista.length) return null;

  var dn=String(x.docnum||'').trim();
  if(dn){
    var porNum=lista.find(function(o){ return String(o.id)===dn; });
    if(porNum) return {o:porNum, como:'numero'};
  }

  var refs=_solRefsDe(x);
  if(!refs.length) return null;

  var canon=lista.map(function(o){ return {o:o, c:_solCanon(o.num_proveedor||'')}; })
                 .filter(function(z){ return z.c; });

  var ex=null, prob=null;
  for(var i=0;i<canon.length && !ex;i++){
    for(var j=0;j<refs.length;j++){
      if(canon[i].c===refs[j]){ ex={o:canon[i].o, como:'exacta'}; break; }
      // Mismo año y número, distinto prefijo
      if(!prob && canon[i].c.slice(3)===refs[j].slice(3)
         && canon[i].c.length===refs[j].length && canon[i].c.length>=8)
        prob={o:canon[i].o, como:'probable'};
    }
  }
  return ex || prob;
}

// El enlace a la orden, para meterlo dentro de una tarjeta de alerta.
// Devuelve '' si la solicitud no tiene orden en el portal, y entonces la
// tarjeta sigue enseñando el texto de siempre.
function _solChipOrden(x){
  try{
    var h=_solOrdenDe(x);
    if(!h) return '';
    var dudosa=(h.como==='probable');
    return ' · <span onclick="event.stopPropagation();_solIrAOrden(\''
      +_esc(String(h.o.id))+'\')" '
      +'style="color:'+(dudosa?'var(--t-marron)':'var(--text-accent)')+';cursor:pointer;'
      +'text-decoration:underline;font-weight:700" title="'
      +(dudosa?'Coincide el número pero no el prefijo: comprueba que sea esta orden'
              :'Abrir la orden y seguir desde su etapa')+'">'
      +'<i class="ti ti-external-link" style="font-size:10px"></i> abrir orden'
      +(dudosa?' (comprobar)':'')+'</span>';
  }catch(e){ return ''; }
}

// Abre la orden para que contabilidad pague desde su etapa. El reporte y el
// detalle comparten el mismo modal, así que uno sustituye al otro.
function _solIrAOrden(oid){
  try{
    var o=(typeof orders!=='undefined' && orders
           ? orders.find(function(y){ return String(y.id)===String(oid); }) : null);
    if(!o){ showT('Esa orden ya no está cargada en el portal'); return; }
    openDetail(String(oid));
  }catch(e){
    console.warn('[reporte] abrir orden:', e);
    showT('No se pudo abrir la orden');
  }
}

function _solPanelSetFiltro(v){ window._solPanelFiltro=v; _solPagoPanel(); }

// El reporte abre mostrando lo que falta por pagar: es la lista de trabajo.
// Lo pagado ya no está pendiente y solo estorba; sigue a un clic, en la
// pastilla "Pagadas".
if(window._solPanelFiltro===undefined) window._solPanelFiltro='abiertas';

function _solPagoPanel(){
  var lista=_solPanelLista();
  var todas=(window._solPago||[]);
  var pastilla=function(k,t,n){
    var on=(window._solPanelFiltro===k);
    return '<span onclick="_solPanelSetFiltro(\''+k+'\')" style="cursor:pointer;'
      +'border:1px solid '+(on?'#72243E':'var(--border)')+';background:'+(on?'#72243E':'var(--surface-0)')
      +';color:'+(on?'#fff':'#72243E')+';border-radius:20px;padding:4px 12px;font-size:11px;'
      +'font-weight:600;white-space:nowrap">'+t+' <span style="opacity:.8">'+n+'</span></span>';
  };

  var totAb=lista.filter(function(x){return x.tipo==='abono';})
                 .reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  var totCa=lista.filter(function(x){return x.tipo==='cancelacion';})
                 .reduce(function(a,x){return a+(Number(x.monto)||0);},0);

  var filas=lista.map(function(x){
    var esEx=_esDelExcel(x);
    var pag=_solPagadaYa(x);
    var st=_solEstadoLabel(x);
    var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
    return '<tr data-solid="'+(x.id||0)+'" class="sol-fila" '
        +'style="border-top:0.5px solid var(--border);'
        +(pag?'background:var(--pastel-ok2)':'')+'">'
      +'<td style="padding:6px 8px">'
        +'<div style="font-size:11.5px;font-weight:600">'
          +_solEditable(x,'proveedor',x.proveedor,'font-weight:600')+'</div>'
        +_solBotonGuardar(x)
        +'</td>'
      +'<td style="padding:6px 8px;font-size:10.5px;max-width:250px;word-break:break-word">'
        + (function(){
            var h=_solOrdenDe(x);
            if(h){
              var o=h.o, dudosa=(h.como==='probable');
              return '<div style="margin-bottom:2px">'
              +'<span onclick="event.stopPropagation();_solIrAOrden(\''+_esc(String(o.id))+'\')" '
              +'style="color:'+(dudosa?'var(--t-marron)':'var(--text-accent)')+';cursor:pointer;'
              +'text-decoration:underline;font-weight:700" title="'
              +(dudosa?'Coincide el número pero no el prefijo: comprueba que sea esta orden'
                      :'Abrir la orden y pagar desde su etapa')+'">'
              +_esc(o.prov||'')+' — '+_esc(String(o.id))+'</span>'
              +(o.num_proveedor?(' <span style="font-size:9px;color:var(--t-ambar);font-weight:700">'
                 +_esc(o.num_proveedor)+'</span>'):'')
              +(dudosa?' <span style="font-size:9px;background:var(--pastel-aviso);'
                 +'color:var(--t-marron);padding:1px 5px;border-radius:7px">comprobar</span>':'')
              +'</div>';
            }
            return '<div style="margin-bottom:2px"><span style="font-size:9px;'
              +'background:var(--pastel-error);color:var(--t-rojo);padding:1px 6px;'
              +'border-radius:7px" title="No hay una orden con esa referencia en el portal. '
              +'Se marca a mano en la columna Pagado.">sin orden en el portal</span></div>';
          })()
        +_solEditable(x,'dkc',(x.dkc||x.docnum||''))+'</td>'
      // El departamento va en su propia columna, como en la hoja de
      // contabilidad. Como desplegable y no texto libre: es un valor de
      // lista, y escribirlo a mano rompería los filtros y los emojis del
      // resto de pantallas.
      +'<td style="padding:6px 8px;font-size:10.5px;white-space:nowrap">'
        +_solDesplegable(x,'dept',
            [{v:null,t:'—',c:'var(--text-muted)'}].concat(
              DEPTS_ALL.map(function(d){ return {v:d, t:dL(d)}; })),'118px')+'</td>'
      +'<td style="padding:6px 8px;text-align:right;font-weight:700;font-size:12px;'
        +'color:'+(x.tipo==='abono'?'#166534':'#B45309')+';white-space:nowrap">'
        +_solEditable(x,'monto',fmt(x.monto),'font-weight:700;text-align:right')+'</td>'
      +'<td style="padding:6px 8px;font-size:10.5px">'
        +_solDesplegable(x,'tipo',[
            {v:'abono',      t:'Abono',       c:'#166534'},
            {v:'cancelacion',t:'Cancelación', c:'#B45309'}
          ],'110px')+'</td>'
      +'<td style="padding:6px 8px;font-size:10.5px;white-space:nowrap">'
        +_solEtaCelda(x)+'</td>'
      // En las cargadas del Excel manda el STATUS de la hoja de contabilidad
      // (REVISADO…), que es como Yeini las tiene clasificadas. En las nacidas
      // dentro del portal se sigue mostrando el estado del proceso.
      +'<td style="padding:6px 8px"><span style="font-size:9.5px;font-weight:600;padding:2px 7px;'
        +'border-radius:8px;white-space:nowrap;background:'+(esEx?'#EEF2FF':st.bg)+';'
        +'color:'+(esEx?'#3730A3':st.c)+'">'
        +(esEx ? _solEditable(x,'estado_excel',(x.estado_excel||'SIN ESTADO'),
                   'font-weight:600;color:var(--t-indigo2);border-bottom-color:#c7d2fe')
               : _esc(st.t))
        +'</span></td>'
      +'<td style="padding:6px 8px;font-size:10.5px">'
        +_solEditable(x,'solicitado_por',x.solicitado_por)
        +(x.solicitado_en?('<div style="font-size:9px;color:#666">'
            +_esc(_fechaHora(x.solicitado_en))+'</div>'):'')+'</td>'
      +'<td style="padding:6px 8px;text-align:center;font-size:10.5px">'
        +_solSiNo(x,'financiado')+'</td>'
      // El desplegable va en TODAS las filas. Antes solo salía en las que
      // venían marcadas como "Del Excel", así que las cargadas por SQL o
      // creadas desde una orden mostraban un guion y no había forma de
      // marcarlas pagadas desde aquí.
      +'<td style="padding:6px 8px;text-align:center">'
        +_solDesplegable(x,'pagado',[
             {v:null,  t:'—',        c:'var(--text-muted)'},
             {v:true,  t:'Pagada',   c:'#166534'},
             {v:false, t:'Por pagar',c:'#B45309'}
           ],'95px')
        +(pag&&x.pagado_en?('<div style="font-size:9px;color:#666">'
            +_esc(_fechaHora(x.pagado_en))+'</div>'):'')
        +'</td>'
      // Borrar la solicitud: para las órdenes de prueba o anuladas en SAP,
      // que si no se quedan en el reporte para siempre.
      +'<td style="padding:6px 4px;text-align:center">'
        +(_esGerencia()
          ? ('<button class="xb" style="padding:2px 6px;color:var(--text-danger)" '
             +'title="Borrar esta solicitud del portal" '
             +'onclick="event.stopPropagation();_solPanelBorrar('+(x.id||0)+')">'
             +'<i class="ti ti-trash"></i></button>')
          : '')
        +'</td>'
      +'</tr>';
  }).join('');

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">💵</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">Abonos y cancelaciones</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Revisa la lista, marca lo que '
    +'ya se pagó y genera el reporte cuando esté al día. '
    +'<b>Pulsa cualquier dato para corregirlo</b>: se guarda solo al salir de la celda.</div></div>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin:10px 0">'
      +pastilla('abiertas','Por pagar', todas.filter(function(x){return !_solPagadaYa(x);}).length)
      +pastilla('pagadas','Pagadas',   todas.filter(_solPagadaYa).length)
      +pastilla('excel','Del Excel',   todas.filter(_esDelExcel).length)
      +pastilla('todas','Todas',       todas.length)
      +(Object.keys(window._solFiltros||{}).length
        ? ('<span onclick="_solLimpiarFiltros()" style="cursor:pointer;font-size:11px;'
          +'background:var(--pastel-aviso);color:var(--t-marron);border-radius:20px;'
          +'padding:4px 12px;font-weight:600">'
          +'<i class="ti ti-filter-off"></i> Quitar filtros ('
          +Object.keys(window._solFiltros).length+')</span>') : '')
      +'<span style="flex:1"></span>'
      +'<span style="font-size:11px;color:var(--text-muted)">'
        +'Abonos <b>'+fmt(totAb)+'</b> · Cancelaciones <b>'+fmt(totCa)+'</b></span>'
    +'</div>'

    +(lista.length
      // Sin altura tope: la tabla se ve entera y el que hace scroll es el
      // modal, no una caja dentro de otra caja.
      ? ('<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden">'
        +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
        +'<thead><tr style="background:var(--surface-2)">'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Proveedor</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Orden / Factura</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Depto</th>'
          +'<th style="padding:7px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">Monto</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Concepto</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">ETA</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Estado</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Preparado por</th>'
          +'<th style="padding:7px 8px;text-align:center;font-size:9.5px;text-transform:uppercase">Financ.</th>'
          +'<th style="padding:7px 8px;text-align:center;font-size:9.5px;text-transform:uppercase">Pagado</th>'
          +'<th style="width:26px"></th>'
        +'</tr>'+_solFilaFiltros()+'</thead><tbody>'+filas+'</tbody>'
        // Los mismos totales que salen en el reporte impreso, aquí abajo:
        // así se comprueba el gran total sin tener que generarlo.
        +'<tfoot>'
          +'<tr style="background:var(--surface-2);border-top:1.5px solid var(--border)">'
            +'<td colspan="3" style="padding:7px 8px;font-size:10.5px;font-weight:700;'
            +'text-transform:uppercase;color:#166534">Total abonos</td>'
            +'<td style="padding:7px 8px;text-align:right;font-weight:800;font-size:12px;'
            +'color:#166534;white-space:nowrap">'+fmt(totAb)+'</td>'
            +'<td colspan="7"></td></tr>'
          +'<tr style="background:var(--surface-2)">'
            +'<td colspan="3" style="padding:7px 8px;font-size:10.5px;font-weight:700;'
            +'text-transform:uppercase;color:#B45309">Total cancelaciones</td>'
            +'<td style="padding:7px 8px;text-align:right;font-weight:800;font-size:12px;'
            +'color:#B45309;white-space:nowrap">'+fmt(totCa)+'</td>'
            +'<td colspan="7"></td></tr>'
          +'<tr style="background:var(--surface-1);border-top:1.5px solid var(--border)">'
            +'<td colspan="3" style="padding:8px;font-size:11.5px;font-weight:800;'
            +'text-transform:uppercase">Gran total</td>'
            +'<td style="padding:8px;text-align:right;font-weight:800;font-size:13.5px;'
            +'white-space:nowrap">'+fmt(totAb+totCa)+'</td>'
            +'<td colspan="7" style="padding:8px;font-size:10px;color:var(--text-muted)">'
            +lista.length+' partida(s)</td></tr>'
        +'</tfoot></table></div>')
      : '<div class="empty" style="padding:22px;color:var(--text-muted)">'
        +'<i class="ti ti-mood-check" style="font-size:22px;color:var(--t-verde)"></i><br>'
        +'Nada que mostrar con este filtro.</div>')

    +'<div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin-top:12px">'
      +'<span style="flex:1;font-size:10.5px;color:var(--text-muted);align-self:center">'
        +lista.length+' solicitud(es) · el reporte sale con lo que ves aquí</span>'
      +'<div style="display:flex;flex-direction:column;gap:6px;align-items:flex-end">'
        +'<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;justify-content:flex-end">'
          +'<span style="font-size:10.5px;font-weight:700;color:#72243E;width:44px"><i class="ti ti-file-type-pdf"></i> PDF</span>'
          +'<button class="btn bg2" onclick="_solPagoReporte(\'abono\')"><i class="ti ti-printer"></i> Solo abonos</button>'
          +'<button class="btn bg2" onclick="_solPagoReporte(\'cancelacion\')"><i class="ti ti-printer"></i> Solo cancelaciones</button>'
          +'<button class="btn bp" style="background:#72243E" onclick="_solPagoReporte(\'\')"><i class="ti ti-printer"></i> Generar reporte</button>'
        +'</div>'
        +'<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;justify-content:flex-end">'
          +'<span style="font-size:10.5px;font-weight:700;color:#166534;width:44px"><i class="ti ti-file-spreadsheet"></i> Excel</span>'
          +'<button class="btn bg2" onclick="_solPagoReporteExcel(\'abono\')"><i class="ti ti-file-spreadsheet"></i> Solo abonos</button>'
          +'<button class="btn bg2" onclick="_solPagoReporteExcel(\'cancelacion\')"><i class="ti ti-file-spreadsheet"></i> Solo cancelaciones</button>'
          +'<button class="btn bp" style="background:#166534" onclick="_solPagoReporteExcel(\'\')"><i class="ti ti-file-spreadsheet"></i> Generar Excel</button>'
        +'</div>'
      +'</div>'
    +'</div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

/* El mismo reporte en EXCEL (v729): mismas solicitudes que el PDF (lo que hay
   en pantalla), con montos como números para poder sumar y filtrar, la
   cabecera fija, filtros en cada columna y los totales abajo. */
async function _solPagoReporteExcel(tipo){
  var lista=_solReporteLista(tipo);
  if(!lista) return;
  try{
    await _ensureExcelJS();
    var titulo=tipo==='abono'?'Solicitudes de abono'
             :tipo==='cancelacion'?'Solicitudes de cancelación'
             :'Solicitudes de abono y cancelación';
    var wb=new ExcelJS.Workbook();
    wb.creator='Kennedy Center Corp.';
    var ws=wb.addWorksheet(tipo==='abono'?'Abonos':(tipo==='cancelacion'?'Cancelaciones':'Abonos y cancelaciones'),
      {views:[{state:'frozen', ySplit:4}]});
    var cols=[
      ['Proveedor',34],['Orden',10],['DKC / Factura',16],['Monto',14],['Departamento',16],['Concepto',14],
      ['ETA',14],['Preparado por',20],['Solicitado el',18],['Estado',16],['Financiado',11],['Pagado',9],['Pagado el',18]];
    ws.columns=cols.map(function(c){ return {width:c[1]}; });
    ws.mergeCells(1,1,1,cols.length);
    var t=ws.getCell(1,1); t.value='KENNEDY CENTER CORP. · '+titulo.toUpperCase();
    t.font={bold:true, size:14, color:{argb:'FF72243E'}};
    ws.mergeCells(2,1,2,cols.length);
    var sub=ws.getCell(2,1);
    sub.value='Generado el '+new Date().toLocaleString('es-PA',{dateStyle:'long', timeStyle:'short'})
      +' por '+((CU&&CU.name)||'')+' · '+lista.length+' partida(s) · con los filtros que había en pantalla';
    sub.font={size:10, color:{argb:'FF666666'}};
    var hr=ws.getRow(4);
    cols.forEach(function(c,i){
      var cell=hr.getCell(i+1); cell.value=c[0];
      cell.font={bold:true, color:{argb:'FFFFFFFF'}};
      cell.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF72243E'}};
      cell.alignment={vertical:'middle', horizontal:(i===3?'right':'left')};
    });
    hr.height=20;
    // Excel no sabe de zonas horarias: se pasa a la hora local (Panamá) para
    // que salga la misma hora que en el portal y no la de Londres
    var fecha=function(v){ if(!v) return null; var d=new Date(v); if(isNaN(d)) return null;
      return new Date(d.getTime()-d.getTimezoneOffset()*60000); };
    lista.forEach(function(x, ri){
      var r=ws.getRow(5+ri);
      var vals=[x.proveedor||'', x.docnum!=null?Number(x.docnum)||String(x.docnum):'', x.dkc||'',
        Number(x.monto)||0, dL(x.dept||''), x.tipo==='abono'?'ABONO':'CANCELACIÓN',
        x.eta_texto||x.eta||'', x.solicitado_por||'', fecha(x.solicitado_en), _solEstadoLabel(x).t,
        x.financiado===true?'SÍ':(x.financiado===false?'NO':''), _solPagadaYa(x)?'SÍ':'NO',
        _solPagadaYa(x)?fecha(x.pagado_en):null];
      vals.forEach(function(v,ci){
        var cell=r.getCell(ci+1); cell.value=v;
        if(ci===3) cell.numFmt='$#,##0.00';
        if((ci===8||ci===12) && v) cell.numFmt='dd/mm/yyyy hh:mm';
        if(ci===5) cell.font={bold:true, color:{argb:x.tipo==='abono'?'FF166534':'FFB45309'}};
        if(ri%2===1) cell.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFF7F7F7'}};
        cell.border={bottom:{style:'hair', color:{argb:'FFDDDDDD'}}};
      });
    });
    var ult=4+lista.length;
    ws.autoFilter={from:{row:4, column:1}, to:{row:ult, column:cols.length}};
    // Totales con fórmulas: si se filtra o se corrige un monto, se recalculan
    var tot=function(fila, texto, formula, color){
      var r=ws.getRow(fila);
      ws.mergeCells(fila,1,fila,3);
      var a=r.getCell(1); a.value=texto; a.font={bold:true, color:{argb:color}}; a.alignment={horizontal:'right'};
      var b=r.getCell(4); b.value={formula:formula}; b.numFmt='$#,##0.00'; b.font={bold:true, color:{argb:color}};
      [1,2,3,4].forEach(function(ci){ r.getCell(ci).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFF3F4F6'}}; });
    };
    var rango='D5:D'+ult, conc='F5:F'+ult;
    tot(ult+2, 'TOTAL ABONOS', 'SUMIF('+conc+',"ABONO",'+rango+')', 'FF166534');
    tot(ult+3, 'TOTAL CANCELACIONES', 'SUMIF('+conc+',"CANCELACIÓN",'+rango+')', 'FFB45309');
    tot(ult+4, 'GRAN TOTAL', 'SUM('+rango+')', 'FF111111');
    var buf=await wb.xlsx.writeBuffer();
    var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    var a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download=(tipo==='abono'?'abonos':(tipo==='cancelacion'?'cancelaciones':'abonos_y_cancelaciones'))+'_'+_hoyISO()+'.xlsx';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function(){ URL.revokeObjectURL(a.href); }, 2000);
    showT('✓ Excel generado: '+lista.length+' partida(s)');
  }catch(e){
    showT('No se pudo generar el Excel: '+(e.message||e), 8000);
  }
}

// Borra una solicitud desde el panel del reporte. Reutiliza el borrado de
// gerencia: pide confirmación, la quita de la base y repinta el panel.
async function _solPanelBorrar(id){
  await _gerBorrarSolicitud(id);
  try{ _solPagoPanel(); }catch(e){}
}

// ── Reporte imprimible ──
// tipo: 'abono' | 'cancelacion' | '' (ambos)
function _solPagoReporte(tipo){
  var lista=_solReporteLista(tipo);
  if(!lista) return;
  var totAb=lista.filter(function(x){return x.tipo==='abono';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  var totCa=lista.filter(function(x){return x.tipo==='cancelacion';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  return _solPagoReportePDF(tipo, lista, totAb, totCa);
}

/* Las solicitudes del reporte (PDF y Excel salen con LAS MISMAS): lo que hay
   en pantalla, con las pastillas y los filtros de cada columna. Ordenadas por
   departamento y proveedor. null si no hay nada. */
function _solReporteLista(tipo){
  // Se imprime LO QUE HAY EN PANTALLA: se leen las filas pintadas del panel
  // y se toman esas solicitudes, así que valen tanto las pastillas (Por
  // pagar, Pagadas…) como los filtros de cada columna. Si el panel no está
  // abierto, se cae a la lista filtrada de siempre.
  var lista=[];
  try{
    var _filas=document.querySelectorAll('tr.sol-fila[data-solid]');
    if(_filas.length){
      var _ids={};
      Array.prototype.forEach.call(_filas, function(tr){
        _ids[String(tr.getAttribute('data-solid'))]=1; });
      lista=(window._solPago||[]).filter(function(x){ return _ids[String(x.id||0)]; });
    }
  }catch(e){}
  if(!lista.length){
    try{ lista=_solPanelLista(); }catch(e){ lista=(window._solPago||[]); }
  }
  lista=lista.filter(function(x){ return !tipo || x.tipo===tipo; });
  if(!lista.length){
    showT((window._solPanelFiltro||'todas')==='todas'
      ? 'No hay solicitudes para el reporte'
      : 'No hay solicitudes con el filtro puesto');
    return null;
  }
  return lista.slice().sort(function(a,b){
    var d=String(a.dept||'').localeCompare(String(b.dept||''));
    return d!==0?d:String(a.proveedor||'').localeCompare(String(b.proveedor||''));
  });
}

function _solPagoReportePDF(tipo, lista, totAb, totCa){
  var filas=lista.map(function(x){
    var conc=(x.tipo==='abono')?'ABONO':'CANCELACIÓN';
    var col=(x.tipo==='abono')?'#166534':'#B45309';
    return '<tr>'
      +'<td>'+_esc(x.proveedor||'')+'</td>'
      +'<td class="ref"><a href="#" onclick="_solPagoAbrir(\''+_esc(String(x.docnum))+'\');return false;">#'+_esc(String(x.docnum))+'</a>'
        +(x.dkc?('<br><a href="#" class="dkc" onclick="_solPagoAbrir(\''+_esc(String(x.docnum))+'\');return false;">'+_esc(x.dkc)+'</a>'):'')+'</td>'
      +'<td class="num">'+fmt(x.monto)+'</td>'
      +'<td>'+_esc(dL(x.dept||''))+'</td>'
      +'<td><span class="conc" style="color:'+col+'">'+conc+'</span></td>'
      // La fecha vive en eta_texto (admite "PREVIO DESPACHO", "S/F"…).
      // Leyendo solo x.eta el reporte salía con la columna vacía.
      +'<td>'+_esc(x.eta_texto||x.eta||'—')+'</td>'
      +'<td>'+_esc(x.solicitado_por||'')+(x.solicitado_en?('<br><span style="font-size:9.5px;color:#666">'+_esc(_fechaHora(x.solicitado_en))+'</span>'):'')+'</td>'
      +'<td>'+_esc(_solEstadoLabel(x).t)+(x.recibido_en&&x.estado==='recibida'?'':'')+'</td>'
      // Antes solo se imprimían en las filas "del Excel": las cargadas por
      // SQL o nacidas de una orden salían en blanco.
      +'<td>'+(x.financiado===true?'SÍ':(x.financiado===false?'NO':'—'))+'</td>'
      +'<td>'+(_solPagadaYa(x)
              ? ('SÍ'+(x.pagado_en?('<br><span style="font-size:9px;color:#666">'
                    +_esc(_fechaHora(x.pagado_en))+'</span>'):''))
              : 'NO')+'</td>'
      +'</tr>';
  }).join('');

  var titulo=tipo==='abono'?'Solicitudes de abono'
           :tipo==='cancelacion'?'Solicitudes de cancelación'
           :'Solicitudes de abono y cancelación';

  var w=window.open('','_blank');
  if(!w){ showT('El navegador bloqueó la ventana del reporte'); return; }
  w.document.write('<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"><title>'+titulo+'</title>'
    +'<style>:root{--surface-0:#fff;--surface-1:#fff;--surface-2:#fff;--text-primary:#111;--text-secondary:#444;--text-muted:#666;--border:rgba(0,0,0,.15);--border-strong:rgba(0,0,0,.3)}body{background:#fff;color:#111}</style>'
    +'<style>'
    +'*{box-sizing:border-box}'
    +'body{font-family:Segoe UI,Helvetica,Arial,sans-serif;color:var(--text-primary);margin:24px;font-size:12px}'
    +'h1{font-size:17px;margin:0 0 2px}'
    +'.sub{font-size:11px;color:#666;margin-bottom:14px}'
    +'table{width:100%;border-collapse:collapse}'
    +'th{background:var(--pastel-gris);text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.04em;padding:7px 8px;border-bottom:1.5px solid #d9d7d0}'
    +'td{padding:7px 8px;border-bottom:.5px solid #e6e4dd;vertical-align:top}'
    +'tr:nth-child(even) td{background:var(--surface-0)}'
    +'.num{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}'
    +'th.num{text-align:right}'
    +'.ref a{color:var(--t-azul);font-weight:700;text-decoration:underline}'
    +'.dkc{font-size:10px;color:var(--t-ambar);font-weight:700;text-decoration:underline}'
    +'.conc{font-weight:700;font-size:10.5px}'
    +'tfoot td{border-top:1.5px solid #d9d7d0;font-weight:700;background:var(--surface-2)}'
    +'.gt td{border-top:2px solid #1a1a18;font-size:13px}'
    +'@media print{body{margin:10mm}.noprint{display:none}}'
    +'</style></head><body>'
    +'<h1>'+titulo+'</h1>'
    +'<div class="sub">Kennedy Center Corp. · '+lista.length+' solicitud(es)'
      // Que el papel diga con qué filtro se sacó: si no, no se sabe si están
      // todas o solo las que faltan por pagar.
      +({abiertas:' · solo las que FALTAN POR PAGAR', pagadas:' · solo las PAGADAS',
         excel:' · solo las cargadas del EXCEL', todas:''}[window._solPanelFiltro||'todas']||'')
      +' · Generado el '+new Date().toLocaleString('es')+' por '+((CU&&CU.name)||'')+'</div>'
    +'<table><thead><tr>'
      +'<th>Proveedor</th><th>Orden / DKC</th><th class="num">Monto</th>'
      +'<th>Departamento</th><th>Concepto</th><th>ETA</th><th>Solicitó</th><th>Estado</th>'
      // Financiado y Pagado vienen del Excel de contabilidad. Solo tienen
      // valor en las solicitudes cargadas de ahí; en las demás van vacías.
      +'<th>Financ.</th><th>Pagado</th>'
    +'</tr></thead><tbody>'+filas+'</tbody>'
    +'<tfoot>'
      +'<tr><td colspan="2">TOTAL ABONOS</td><td class="num">'+fmt(totAb)+'</td><td colspan="5"></td></tr>'
      +'<tr><td colspan="2">TOTAL CANCELACIONES</td><td class="num">'+fmt(totCa)+'</td><td colspan="5"></td></tr>'
      +'<tr class="gt"><td colspan="2">GRAN TOTAL</td><td class="num">'+fmt(totAb+totCa)+'</td><td colspan="5"></td></tr>'
    +'</tfoot></table>'
    +'<div class="noprint" style="margin-top:16px"><button onclick="window.print()" '
      +'style="background:#0c447c;color:#fff;border:none;border-radius:7px;padding:9px 18px;font-size:13px;cursor:pointer">Imprimir</button></div>'
    +'</body></html>');
  w.document.close();
  // El clic en la orden vuelve a esta ventana
  try{ w._solPagoAbrir=function(id){ w.close(); _solPagoAbrir(id); }; }catch(e){}
}

// ── Imprimir UNA solicitud tal como llegó a contabilidad ──
// Solo la solicitud: los datos de la orden y el cuerpo del correo que escribió
// la compradora. Los adjuntos se listan por su nombre, pero no se vuelcan:
// se abren desde la propia solicitud si hace falta verlos.
function _solImprimirSolicitud(oid, tipo){
  var e=_solEnvioLeer(oid, tipo);
  if(!e){ showT('No hay correo guardado para esta solicitud'); return; }
  var x=(window._solPago||[]).find(function(s){ return String(s.docnum)===String(oid) && s.tipo===tipo; });
  var d=_solPagoDatosOrden(oid);
  var titulo=(tipo==='abono')?'Solicitud de abono':'Solicitud de cancelación de saldo';

  var meta=[];
  meta.push(['Orden', String(oid)+((x&&x.dkc)?(' · '+x.dkc):(d.dkc?(' · '+d.dkc):''))]);
  meta.push(['Proveedor', (x&&x.proveedor)||d.proveedor||'—']);
  meta.push(['Departamento', dL((x&&x.dept)||d.dept||'')||'—']);
  if(d.total) meta.push(['Total de la orden', fmt(d.total)]);
  meta.push(['Monto solicitado', fmt((e.monto!=null?e.monto:(x&&x.monto))||0)]);
  meta.push(['Solicitó', (e.por||(x&&x.solicitado_por)||'—')+(e.fecha?(' · '+_fechaHora(e.fecha)):'')]);
  if(e.para && e.para.length) meta.push(['Enviado a', e.para.join(', ')]);
  if(e.asunto) meta.push(['Asunto', e.asunto]);
  if(x && x.recibido_en) meta.push(['Recibida por', (x.recibido_por||'')+' · '+_fechaHora(x.recibido_en)]);

  var filasMeta=meta.map(function(m){
    return '<tr><th>'+_esc(m[0])+'</th><td>'+_esc(String(m[1]))+'</td></tr>';
  }).join('');

  var adj=(e.adjuntos||[]);
  var listaAdj=adj.length
    ? '<ul class="adj">'+adj.map(function(a){
        return '<li>'+_esc(a.nombre||'')+(a.kb?(' <span class="kb">· '+a.kb+' KB</span>'):'')+'</li>';
      }).join('')+'</ul>'
    : '<div class="vacio">No quedó registro de adjuntos en esta solicitud.</div>';

  var w=window.open('','_blank');
  if(!w){ showT('El navegador bloqueó la ventana de impresión'); return; }
  w.document.write('<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"><title>'+_esc(titulo+' - '+oid)+'</title>'
    +'<style>:root{--surface-0:#fff;--surface-1:#fff;--surface-2:#fff;--text-primary:#111;--text-secondary:#444;--text-muted:#666;--border:rgba(0,0,0,.15);--border-strong:rgba(0,0,0,.3)}body{background:#fff;color:#111}</style>'
    +'<style>'
    +'*{box-sizing:border-box}'
    +'body{font-family:Segoe UI,Helvetica,Arial,sans-serif;color:var(--text-primary);margin:24px;font-size:12px}'
    +'h1{font-size:17px;margin:0 0 2px}'
    +'.sub{font-size:11px;color:#666;margin-bottom:14px}'
    +'table.meta{width:100%;border-collapse:collapse;margin-bottom:16px}'
    +'table.meta th{background:var(--pastel-gris);text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.04em;'
      +'padding:6px 8px;border-bottom:.5px solid #e6e4dd;width:170px;vertical-align:top}'
    +'table.meta td{padding:6px 8px;border-bottom:.5px solid #e6e4dd;vertical-align:top}'
    +'h2{font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#555;margin:16px 0 6px}'
    +'.cuerpo{white-space:pre-wrap;background:var(--surface-0);border:.5px solid #e6e4dd;border-radius:6px;padding:12px 14px;line-height:1.55}'
    +'ul.adj{margin:0;padding-left:18px}'
    +'ul.adj li{padding:2px 0}'
    +'.kb{color:#666;font-size:10.5px}'
    +'.vacio{color:#888;font-style:italic}'
    +'@page{size:A4 portrait;margin:14mm}'
    +'@media print{body{margin:0}.noprint{display:none}}'
    +'</style></head><body>'
    +'<h1>'+_esc(titulo)+'</h1>'
    +'<div class="sub">Kennedy Center Corp. · Impreso el '+new Date().toLocaleString('es')
      +' por '+_esc((CU&&CU.name)||'')+'</div>'
    +'<table class="meta">'+filasMeta+'</table>'
    +'<h2>Mensaje enviado</h2>'
    +'<div class="cuerpo">'+_esc(e.cuerpo||'(no quedó guardado el cuerpo del mensaje)')+'</div>'
    +'<h2>Adjuntos enviados</h2>'+listaAdj
    +'<div class="noprint" style="margin-top:18px"><button onclick="window.print()" '
      +'style="background:#0c447c;color:#fff;border:none;border-radius:7px;padding:9px 18px;font-size:13px;cursor:pointer">Imprimir</button></div>'
    +'</body></html>');
  w.document.close();
}

function go(id,btn){
  // El botón «atrás» del navegador se queda DENTRO del portal: cada pantalla
  // deja su marca en el historial, así que atrás vuelve a la pantalla
  // anterior en vez de salirse de la aplicación.
  try{ _navMarcar(id); }catch(e){}
  // Al cambiar de pantalla se sale del modo completo, si estaba puesto
  if(window._repFull && id!=='reposiciones'){
    try{ _repPantallaCompleta(); }catch(e){}
  }
  // Las pantallas de dinero del banco no se abren por URL ni con el botón
  // «atrás»: si no hay permiso, al inicio. Antes bastaba con poner #bancos
  // en la dirección para colarse.
  // Accionistas: reservada a cuatro personas, ni por URL ni por «atrás»
  if(id==='planilla' && !_plaPuede()){
    showT('No tienes acceso a esa pantalla');
    id='dashboard';
  }
  if(id==='accionistas' && !_acnPuede()){
    showT('No tienes acceso a esa pantalla');
    id='dashboard';
  }
  if(['bancos','concil','banco','conciliacion'].indexOf(id)>=0){
    var _okBanco=false;
    try{ _okBanco=_bkPuede(); }catch(e){}
    if(!_okBanco){
      showT('Esa pantalla es de contabilidad y de la gerencia general');
      id='dashboard';
    }
  }
  PG=id;try{ _accPantalla(id); }catch(e){}
  try{document.getElementById('modal').style.display='none';document.getElementById('qmodal').style.display='none';}catch(e){}document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));document.querySelectorAll('.nb').forEach(b=>b.classList.remove('active'));const pg=document.getElementById('page-'+id);if(pg)pg.classList.add('active');if(btn)btn.classList.add('active');else document.querySelectorAll('.nb').forEach(b=>{if((b.getAttribute('onclick')||'').includes(`'${id}'`))b.classList.add('active');});if(id==='pautdia'){ if(_pautPuede()) rPautDia(); else { showT('Esa pantalla es de la gerencia general'); go('dashboard'); return; } }else if(id==='dashboard')rDash();else if(id==='ordenes')rOrdenes(dO);else if(id==='completadas')rCompletadas(dComp);else if(id==='pendientes')rPendientes(dP);else if(id==='contab')rContab(dC);else if(id==='deptos')rDeptos();else if(id==='mistarea')rMiTarea(dMT);else if(id==='alertas')rAlertas();else if(id==='reposiciones')rReposiciones();else if(id==='reppedidos')rReposiciones();else if(id==='nueva')rNueva();else if(id==='livechat')rLiveChat();else if(id==='reportes')rReportes();else if(id==='catnosap')rCatNoSap();else if(id==='inventario')rInventario();else if(id==='ocpend')rOcPend();else if(id==='accesos')rAccesos();else if(id==='concil')rConcil();else if(id==='pcs')rPCS();else if(id==='bancos')rBancos();else if(id==='hojassap')rHojasSap();else if(id==='ordensap')rOrdenSap();else if(id==='factreserva')rFactReserva();else if(id==='entradas')rEntradas();else if(id==='facturasres')rFacturasRes();else if(id==='ventadirecta')rVentaDirecta();
  // Al entrar a Alertas se releen las solicitudes, una sola vez
  if(id==='alertas' && CU && ['contabilidad','gerencia','compras'].indexOf(CU.role)>=0 && window._solPagoListo){
    if(!window._solPagoRefrescando){
      window._solPagoRefrescando=true;
      _solPagoCargar(true).then(function(){
        window._solPagoRefrescando=false;
        if(PG==='alertas'){ try{ rAlertas(); }catch(e){} }
      }).catch(function(){ window._solPagoRefrescando=false; });
    }
  }try{_navPintarVolver();}catch(e){}}
/* ═══ IMPRIMIR LOS INFORMES DE LA IA (prefijo [IMP] · v722) ════════════════
   Una impresora en la esquina de TODOS los informes y revisiones que hace la
   IA, en todas las etapas. No se toca cada pantalla: un vigilante del DOM
   (MutationObserver) mira los sitios donde la IA deja sus informes y, en
   cuanto tienen contenido y ya no están «pensando», les pone el botón. Si la
   pantalla se repinta, el botón vuelve a salir solo.
   Para que un informe nuevo tenga impresora basta con darle la clase
   «ia-informe» (y si se quiere, data-imp-titulo="…"). */
var IMP_IA_SITIOS=[
  ['#firma-ai-errores',          'Compra para firma · revisión AI'],
  ['#firma-rev-modal-body',      'Compra para firma · revisión AI'],
  ['#firma-revrep-body',         'Orden para firma contra la reposición'],
  ['#pla-resultado',             'Planilla · revisión AI'],
  ['[id^="revia-res-"]',         'Artes · revisión AI'],
  ['[id^="artes-ia-"]',          'Artes · revisión AI'],
  ['[id^="aduia-"]',             'Aduana · lectura AI'],
  ['[id^="logia-"]',             'Logística · lectura AI'],
  ['#nsapItemsBox',              'Orden BORRADOR · productos'],
  ['.ia-informe',                'Informe AI']
];

function _impIAMarcar(){
  IMP_IA_SITIOS.forEach(function(par){
    var lista;
    try{ lista=document.querySelectorAll(par[0]); }catch(e){ return; }
    lista.forEach(function(el){
      var hijo=el.querySelector(':scope > .imp-ia-btn');
      var texto=(el.textContent||'').replace(/\s+/g,' ').trim();
      var pensando=!!el.querySelector('.ai-ring, .ti-loader-2.spin');
      var vale=texto.length>25 && !pensando;
      if(vale && !hijo){
        if(!el.getAttribute('data-imp-titulo')) el.setAttribute('data-imp-titulo', par[1]);
        if(getComputedStyle(el).position==='static') el.style.position='relative';
        var b=document.createElement('button');
        b.className='imp-ia-btn';
        b.type='button';
        b.title='Imprimir este informe';
        b.innerHTML='<i class="ti ti-printer"></i>';
        b.setAttribute('onclick','event.stopPropagation();_impIA(this)');
        b.style.cssText='position:absolute;top:6px;right:6px;z-index:5;width:30px;height:30px;border-radius:8px;'
          +'border:0.5px solid var(--border);background:var(--surface-0);color:var(--text-primary);cursor:pointer;'
          +'display:flex;align-items:center;justify-content:center;font-size:16px;box-shadow:0 2px 6px rgba(0,0,0,.12)';
        el.insertBefore(b, el.firstChild);
        // Que el botón no tape lo de arriba a la derecha
        if(!el.style.paddingTop) el.style.paddingTop='34px';
      } else if(!vale && hijo){
        hijo.remove();
      }
    });
  });
}

var _impIAPend=null;
function _impIAIniciar(){
  if(window._impIAObs || typeof MutationObserver==='undefined' || !document.body) return;
  window._impIAObs=new MutationObserver(function(muts){
    // Los cambios que hace el propio botón no cuentan
    if(muts.every(function(m){ return [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes))
          .every(function(n){ return n.classList && n.classList.contains('imp-ia-btn'); }); })) return;
    clearTimeout(_impIAPend);
    _impIAPend=setTimeout(_impIAMarcar, 250);
  });
  window._impIAObs.observe(document.body, {childList:true, subtree:true});
  _impIAMarcar();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', _impIAIniciar);
else setTimeout(_impIAIniciar, 0);

// Imprime el informe donde está el botón, en una página limpia
function _impIA(btn){
  var el=btn && btn.parentNode; if(!el) return;
  var titulo=el.getAttribute('data-imp-titulo')||'Informe AI';
  var copia=el.cloneNode(true);
  // v746: la orden BORRADOR se imprime con su cabecera (proveedor, DKC,
  // total) y el resultado de la revisión de la IA encima de los productos.
  // Antes la impresora estaba en la línea de estado y salía casi en blanco.
  if(el.id==='nsapItemsBox'){
    var val=function(id){ var x=document.getElementById(id); return x?String(x.value||x.textContent||'').trim():''; };
    var cab=document.createElement('div');
    cab.style.cssText='font-size:12px;margin-bottom:8px;line-height:1.6';
    cab.innerHTML='<b>Proveedor:</b> '+_esc(val('nsapProv'))+' &nbsp; <b>Orden:</b> '+_esc(val('nsapRef'))
      +' &nbsp; <b>PO del proveedor:</b> '+_esc(val('nsapPO'))+' &nbsp; <b>Total:</b> '+_esc(val('nsapTotal'))
      +'<div style="margin-top:4px">'+(document.getElementById('nsapIAstatus')||{}).innerHTML+'</div>';
    copia.insertBefore(cab, copia.firstChild);
  }
  // Fuera botones; los campos se imprimen como texto
  copia.querySelectorAll('.imp-ia-btn, button, .ai-ring').forEach(function(x){ x.remove(); });
  var origSel=el.querySelectorAll('select'), copSel=copia.querySelectorAll('select');
  copSel.forEach(function(x,i){
    var o=origSel[i], t=(o && o.options[o.selectedIndex]) ? o.options[o.selectedIndex].text : '';
    var sp=document.createElement('span'); sp.textContent=t; sp.style.fontWeight='600'; x.replaceWith(sp); });
  var origIn=el.querySelectorAll('input, textarea'), copIn=copia.querySelectorAll('input, textarea');
  copIn.forEach(function(x,i){
    var sp=document.createElement('span'); sp.textContent=(origIn[i]&&origIn[i].value)||''; x.replaceWith(sp); });
  // Que se imprima TODO: sin alturas máximas ni barras de desplazamiento
  [copia].concat([].slice.call(copia.querySelectorAll('*'))).forEach(function(x){
    if(x.style){ x.style.maxHeight='none'; x.style.overflow='visible'; if(x.style.position==='sticky') x.style.position='static'; }
  });
  copia.style.paddingTop='0';
  var estilos=[].slice.call(document.querySelectorAll('style, link[rel="stylesheet"]'))
    .map(function(x){ return x.outerHTML; }).join('\n');
  var cuando=new Date().toLocaleString('es-PA',{dateStyle:'long', timeStyle:'short'});
  var w=window.open('', '_blank');
  if(!w){ showT('El navegador bloqueó la ventana de impresión: permite las ventanas emergentes para este sitio', 8000); return; }
  w.document.open();
  w.document.write('<!DOCTYPE html><html lang="es" data-theme="light"><head><meta charset="utf-8">'
    +'<meta name="color-scheme" content="light"><title>'+_esc(titulo)+'</title>'+estilos
    +'<style>html,body{background:#fff!important;color:#111!important;color-scheme:light}'
    +'body{font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;margin:22px}'
    +'*{-webkit-print-color-adjust:exact;print-color-adjust:exact}'
    +'.imp-cab{display:flex;align-items:flex-end;justify-content:space-between;border-bottom:2px solid #111;'
    +'padding-bottom:8px;margin-bottom:14px}.imp-cab h1{font-size:17px;margin:0}.imp-cab div{font-size:11px;color:#555}'
    +'table{page-break-inside:auto}tr{page-break-inside:avoid}'
    +'@page{margin:12mm'+((copia.querySelector('table') && copia.querySelector('tr') && copia.querySelector('tr').children.length>8)?';size:landscape':'')+'}</style></head><body>'
    +'<div class="imp-cab"><div><div style="font-size:11px;letter-spacing:.06em;color:#555">KENNEDY CENTER CORP.</div>'
    +'<h1>'+_esc(titulo)+'</h1></div><div style="text-align:right">'+_esc(cuando)
    +'<br>'+_esc((CU&&CU.name)||'')+'</div></div>'
    +'<div id="imp-cuerpo"></div></body></html>');
  w.document.close();
  w.document.getElementById('imp-cuerpo').appendChild(w.document.importNode(copia, true));
  var imprimir=function(){ try{ w.focus(); w.print(); }catch(e){} };
  // Que carguen los estilos y los iconos antes de imprimir
  if(w.document.readyState==='complete') setTimeout(imprimir, 600);
  else w.addEventListener('load', function(){ setTimeout(imprimir, 300); });
}

function showT(msg, ms){
  const t=document.createElement('div');
  t.className='toast';
  t.textContent=msg;
  document.body.appendChild(t);
  // Los avisos largos necesitan más tiempo para poder leerse
  setTimeout(()=>t.remove(), Number(ms)>0?Number(ms):3500);
}


/* ═══════════════════════════════════════════════════════════════════════════
   PRODUCT CREATION SHEET  ·  módulo para compras-app.js
   ───────────────────────────────────────────────────────────────────────────
   Se suben los documentos del proveedor (PDF, Excel o imagen), la IA saca una
   fila por línea de producto, se revisa y se corrige en pantalla, y se baja
   el Excel con el formato de la plantilla de Kennedy.

   VARIOS DOCUMENTOS EN UNA HOJA
   Un proveedor manda a veces dos o tres proformas de la misma compra. Se
   pueden elegir todas de una vez, o añadirlas después a una hoja que ya
   existe. Cada documento se manda a la IA POR SEPARADO y luego se juntan las
   filas: pegar tres PDF en una sola llamada revienta el límite de tokens y
   la IA empieza a mezclar los datos de un documento con los del otro.
   Cada fila recuerda de qué archivo salió.

   LA COMPROBACIÓN QUE IMPORTA
   La suma de precio x piezas de todas las filas contra la suma de los totales
   impresos en los documentos. Si cuadra al centavo, no se perdió ni se
   duplicó ninguna línea. Y aparte se avisa de códigos de barras repetidos,
   que es lo que pasa cuando el proveedor manda una proforma corregida y se
   sube junto a la vieja.

   DEPENDE de lo que ya existe en el portal:
     _iaDesdeBlob(blob, nombre)   convierte el archivo al formato de la IA
     _iaJSON(content, maxTokens)  llama a la IA y repara el JSON si se corta
     _subirDocStorage(oid, etapa, file)   guarda el archivo en el bucket
     _confirmarBorrado(), _borrarArchivoStorage(), _esGerencia()
     SB, KEY, SBH, DOCS_BASE, CU, showT()
     XLSX (SheetJS), ya cargado en page.compras.liquid

   DÓNDE PEGARLO: al final de compras-app.js, antes de renderLogin().
   ═══════════════════════════════════════════════════════════════════════════ */

// ── Quién entra ──────────────────────────────────────────────────────────
// Ropa (compras y encargado) y gerencia general. El resto no ve el botón.
// La hoja nació para Ropa y su formato es el de esa área, pero cualquier
// departamento puede usarla: el aviso de la pantalla lo deja claro y así
// nadie se queda sin ella por una restricción que no aporta nada.
function _pcsPuede(){
  if(!CU) return false;
  // Abierta a compras y gerencia de cualquier departamento. El formato es el
  // de Ropa, y así lo dice la pantalla, pero quien lo necesite puede usarlo:
  // dejar fuera a los demás no protegía nada.
  return _esCompras() || CU.role==='gerencia';
}

// Borrar: quien la creó, y gerencia cualquiera. Una compradora que subió el
// PDF equivocado tiene que poder deshacerlo sin pedirle permiso a nadie.
function _pcsPuedeBorrar(h){
  if(!_pcsPuede() || !h) return false;
  if(_esGerencia()) return true;
  return String(h.creado_por||'') === String((CU&&CU.name)||'');
}

var PCS_TABLA = 'pcs_hojas';

// Las columnas de la plantilla, en orden. `k` es la clave que devuelve la IA.
// Las que van después de S se llenan al despachar y aquí quedan vacías.
var PCS_COLS = [
  {c:'B', k:'style',   t:'Referencia',        w:16, num:false},
  {c:'C', k:'desc',    t:'Descripción',       w:46, num:false},
  {c:'D', k:'ean',     t:'Código de barra',   w:16, num:true},
  {c:'E', k:'precio',  t:'Precio USD',        w:11, num:true},
  {c:'F', k:'piezas',  t:'Piezas',            w:10, num:true},
  {c:'G', k:'pxc',     t:'Pzs x cartón',      w:11, num:true},
  {c:'H', k:'genero',  t:'Género',            w:10, num:false},
  {c:'I', k:'marca',   t:'Marca',             w:12, num:false},
  {c:'J', k:'comp',    t:'Composición',       w:24, num:false},
  {c:'K', k:'tejido',  t:'Tejido',            w:11, num:false},
  {c:'L', k:'ratio',   t:'Ratio',             w:30, num:false},
  {c:'M', k:'color',   t:'Color',             w:22, num:false},
  {c:'N', k:'origen',  t:'Origen',            w:12, num:false},
  {c:'O', k:'vendor',  t:'Proveedor',         w:20, num:false},
  {c:'P', k:'vcode',   t:'Cód. prov.',        w:10, num:true},
  {c:'Q', k:'po',      t:'N° orden prov.',    w:16, num:false},
  {c:'R', k:'hikc',    t:'N° HIKC',           w:14, num:false}
];

// ═══════════════════════════════════════════════════════════════════════════
//  LO QUE SE LE PIDE A LA IA
//  Las reglas van aquí y en un solo sitio. Si mañana cambia un criterio
//  (por ejemplo que la composición acepte el nombre del programa), se toca
//  este texto y nada más.
// ═══════════════════════════════════════════════════════════════════════════
function _pcsPrompt(){
  return [
'Eres el asistente de compras de Kennedy Center Corp. Te paso el documento de un',
'proveedor de ropa (proforma, order confirmation, contrato o Excel). Saca los datos',
'para la Product Creation Sheet.',
'',
'REGLA DE ORO: no inventes. Si un dato no está en el documento, devuélvelo como null.',
'Es preferible una celda vacía que un dato inventado: la celda vacía se ve y se',
'completa a mano, el dato inventado se cuela hasta SAP.',
'',
'UNA FILA POR LÍNEA DE PRODUCTO. Cada renglón con su propio código de barras es una',
'fila. Si el mismo renglón lleva varios colores con varios códigos de barras (viene',
'surtido), es UNA sola fila y en "color" se ponen todos los colores separados por " / ".',
'',
'IMPORTANTE — NO REPITAS LO QUE NO CAMBIA. Casi todos los datos (marca, proveedor,',
'número de orden, ratio, origen…) son los mismos para todo el documento. Van UNA sola',
'vez en "generales". En cada línea pon solo lo que varía de una a otra. Si una línea',
'concreta se aparta de los generales (por ejemplo un documento con hombre y mujer',
'mezclados), repite ESE campo dentro de esa línea y manda el resto.',
'',
'GENERALES (una sola vez):',
'  marca   Marca del comprador (Morelli, etc.), casi siempre en la página de',
'          empaque o de firmas, no en el encabezado del proveedor.',
'  vendor  Nombre del proveedor que emite el documento, del encabezado.',
'  vcode   Los dígitos de la referencia ANTES del primer guion. De "415-M26-3390"',
'          es 415. Como número.',
'  po      Número de orden, contrato o confirmación del documento. Sin espacios',
'          internos: "SC-2029 3875" se escribe "SC-20293875".',
'  hikc    Número HIKC si aparece (formato HIKC-#####). Casi nunca está: null.',
'  origen  País de fabricación. Si no está explícito, dedúcelo del puerto de carga',
'          (Yantian, Ningbo, Shanghai = China). Si no hay ni puerto, null.',
'  genero  "Mens" o "Ladies". Dedúcelo del texto aunque no haya un campo de género.',
'  tejido  "Woven" o "Knitted". Dedúcelo: camisetas, rib, jersey, interlock,',
'          piqué y punto son Knitted; camisa, blusa, pantalón de tela son Woven.',
'  pxc     Piezas por cartón. Si el documento no lo dice en ningún sitio, pon 24.',
'  ratio   El surtido por talla, con este formato exacto:',
'          "S    M     L     XL   /  1   2   2  1"',
'          Las tallas en el orden del documento y debajo su cantidad.',
'',
'DE CADA LÍNEA (solo esto):',
'  style   Referencia o style number, tal cual aparece.',
'  desc    Descripción del artículo, EN MAYÚSCULAS. Si el documento agrupa los',
'          artículos bajo un encabezado de programa o tela (por ejemplo',
'          "180 gsm ICE Cotton Spandex") y debajo pone la descripción concreta',
'          ("Mens Long Sleeve Tshirt"), únelos así: "ENCABEZADO - DESCRIPCIÓN".',
'          Sin el encabezado, dos telas distintas quedan con la misma descripción.',
'  ean     Código de barras / EAN, solo dígitos, como número.',
'  precio  Precio unitario en USD, como número.',
'  piezas  Piezas compradas de esa línea, como número.',
'  color   El color tal como lo escribe el proveedor, con su código si lo trae',
'          ("Black 32", "Beige as 415-M25-1412"). No lo limpies ni lo traduzcas.',
'  comp    Composición SOLO si el documento da porcentajes de material',
'          ("80% POLIÉSTER 20% VISCOSA"). Un nombre de tela o de programa',
'          ("Double Jersey", "Interlock 260gsm") NO es composición: pon null.',
'',
'ADEMÁS, devuelve el total impreso del documento en "total_documento" (el gran total',
'en dinero, no los subtotales por página) y el total de piezas si viene impreso.',
'Sirve para comprobar la extracción; si el documento no lo trae, pon null.',
'',
'Responde SOLO con este JSON, sin texto alrededor y sin ```:',
'{"total_documento":98670.00,"total_piezas":27000,',
' "generales":{"marca":"Morelli","vendor":"CENTWAY LIMITED","vcode":415,',
'   "po":"SC-20293875","hikc":null,"origen":"China","genero":"Mens","tejido":"Knitted",',
'   "pxc":24,"ratio":"S    M     L     XL   /  1   2   2  1"},',
' "lineas":[',
'  {"style":"415-M26-3390","desc":"TECH TSHIRT MANGO PERFORMANCE - SHORT SLEEVE MUSCULAR TSHIRT",',
'   "ean":7450123233312,"precio":3.25,"piezas":480,"color":"Black 32","comp":null},',
'  {"style":"415-M26-3391","desc":"TECH TSHIRT MANGO PERFORMANCE - SHORT SLEEVE MUSCULAR TSHIRT",',
'   "ean":7450123233329,"precio":3.25,"piezas":480,"color":"White 2","comp":null}',
']}'
  ].join('\n');
}

// ═══════════════════════════════════════════════════════════════════════════
//  PANTALLA
// ═══════════════════════════════════════════════════════════════════════════
window._pcsHojas = window._pcsHojas || [];
window._pcsActual = null;

async function rPCS(){
  var pg=document.getElementById('page-pcs');
  if(!pg) return;
  if(!_pcsPuede()){ pg.innerHTML='<div class="empty">Esta pantalla es del departamento de Ropa.</div>'; return; }

  pg.innerHTML=
   '<div class="sec">'
  +  '<div class="sec-h"><h2>Product Creation Sheet</h2>'
  +    '<div style="display:flex;gap:8px;align-items:center">'
  +      '<input type="file" id="pcsFile" multiple style="display:none" '
  +            'accept=".pdf,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.webp" onchange="_pcsSubir(this)">'
  +      '<button class="lb" style="max-width:260px" onclick="document.getElementById(\'pcsFile\').click()">'
  +        '<i class="ti ti-file-upload"></i> Subir documentos del proveedor</button>'
  +      '<button class="btn bp" style="padding:9px 15px;background:var(--t-azul)" '
  +            'onclick="_isAbrir()"><i class="ti ti-database-import"></i> '
  +        'SUBIR ITEMS A SAP</button>'
  +    '</div>'
  +  '</div>'
  +  '<p style="font-size:12px;color:var(--text-secondary);margin:0 0 14px">'
  +    'Sube la proforma o el contrato en PDF, Excel o foto. Puedes elegir varios archivos a la vez '
  +    'y todos caen en la misma hoja. Se saca una fila por línea de producto, la revisas aquí y '
  +    'bajas el Excel con el formato de la plantilla.</p>'
  +  '<div id="pcsEstado"></div>'
  +  '<div id="pcsLista"></div>'
  +'</div>';

  await _pcsCargar();
}

async function _pcsCargar(){
  var cont=document.getElementById('pcsLista');
  if(cont) cont.innerHTML='<div class="empty">Cargando…</div>';
  try{
    // cache:'no-store' es obligatorio: la URL es siempre la misma, así que
    // el navegador servía la respuesta del arranque (con la tabla vacía) y
    // la hoja recién creada no aparecía hasta la recarga siguiente.
    var r=await fetch(SB+'/rest/v1/'+PCS_TABLA+'?select=*&order=creado_en.desc&limit=100',
      {headers:Object.assign({},SBH,{'Cache-Control':'no-cache'}), cache:'no-store'});
    if(!r.ok) throw new Error('estado '+r.status);
    window._pcsHojas = await r.json();
  }catch(e){
    // Una lista vacía y una lista que no cargó se ven igual, y eso hace
    // perder media hora buscando un dato que sí estaba guardado.
    window._pcsHojas=[];
    if(cont){
      cont.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
       +'<i class="ti ti-alert-triangle"></i> No se pudo leer la lista de hojas ('
       +_pcsEsc(e.message||e)+'). Si la tabla pcs_hojas no existe todavía, corre el SQL.</div>';
    }
    return;
  }
  _pcsPintarLista();
}

function _pcsPintarLista(){
  // Si el panel abierto es el de una orden, se repinta ese
  if(document.getElementById('pcsListaOrden')){ _pcsPintarListaOrden(); return; }
  var cont=document.getElementById('pcsLista');
  if(!cont) return;
  var hs=window._pcsHojas||[];
  if(!hs.length){
    cont.innerHTML= window._pcsTrabajando
      ? '<div class="empty">Leyendo el documento. No cierres esta pestaña.</div>'
      : '<div class="empty">Todavía no hay hojas. Sube el primer documento de proveedor.</div>';
    return;
  }
  cont.innerHTML='<table class="tb"><thead><tr>'
   +'<th>Orden</th><th>Proveedor</th><th>Marca</th><th style="text-align:center">Docs</th>'
   +'<th style="text-align:right">Líneas</th><th style="text-align:right">Piezas</th>'
   +'<th style="text-align:right">Monto</th><th>Creada por</th><th style="width:96px"></th></tr></thead><tbody>'
   +hs.map(function(h){
      var ls=h.lineas||[];
      var pzs=ls.reduce(function(a,l){return a+(Number(l.piezas)||0);},0);
      var mto=ls.reduce(function(a,l){return a+(Number(l.piezas)||0)*(Number(l.precio)||0);},0);
      var docs=_pcsArchivos(h).length;
      return '<tr style="cursor:pointer" onclick="_pcsAbrir(\''+h.id+'\')">'
        +'<td style="font-weight:600">'+_pcsEsc(h.po||'—')+'</td>'
        +'<td>'+_pcsEsc(h.proveedor||'—')+'</td>'
        +'<td>'+_pcsEsc(h.marca||'—')+'</td>'
        +'<td style="text-align:center">'+(docs>1
             ? '<span class="badge" style="background:var(--pastel-lila);color:var(--t-lila)">'+docs+'</span>'
             : '<span style="color:var(--text-muted)">'+docs+'</span>')+'</td>'
        +'<td style="text-align:right">'+ls.length+'</td>'
        +'<td style="text-align:right">'+pzs.toLocaleString('en-US')+'</td>'
        +'<td style="text-align:right">USD '+mto.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})+'</td>'
        +'<td style="font-size:11px;color:var(--text-muted)">'+_pcsEsc(h.creado_por||'')+'</td>'
        +'<td style="white-space:nowrap">'
        +  '<button class="xb" title="Descargar Excel" onclick="event.stopPropagation();_pcsExcel(\''+h.id+'\')">'
        +  '<i class="ti ti-file-spreadsheet"></i></button>'
        +  (_pcsPuedeBorrar(h)
            ? '<button class="xb" title="Borrar la hoja" style="color:var(--text-danger)" '
              +'onclick="event.stopPropagation();_pcsBorrar(\''+h.id+'\')"><i class="ti ti-trash"></i></button>'
            : '')
        +'</td></tr>';
    }).join('')
   +'</tbody></table>';
}

// Los archivos de una hoja. Las hojas creadas antes de que existiera el
// campo `archivos` solo tienen archivo_nombre/archivo_url sueltos, así que
// se les arma la lista al vuelo y el resto del código no se entera.
function _pcsArchivos(h){
  if(!h) return [];
  if(Array.isArray(h.archivos) && h.archivos.length) return h.archivos;
  if(h.archivo_nombre) return [{nombre:h.archivo_nombre, url:h.archivo_url||null,
                                total:h.total_documento||null, lineas:(h.lineas||[]).length}];
  return [];
}

// ── Escapar: todo lo que sale de la IA o del proveedor pasa por aquí ──
// El portal pinta con innerHTML, así que un nombre con < > rompería la
// tabla (o algo peor). Ninguna cadena de fuera se concatena sin esto.
function _pcsEsc(s){
  return String(s==null?'':s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

// ═══════════════════════════════════════════════════════════════════════════
//  LEER LOS DOCUMENTOS
//  Uno por uno: cada archivo es su propia llamada a la IA. Si uno falla,
//  los demás siguen y al final se dice cuál no se pudo leer, en vez de
//  perder el trabajo entero por un PDF escaneado torcido.
// ═══════════════════════════════════════════════════════════════════════════
async function _pcsLeerArchivos(files, paso){
  var lineas=[], archivos=[], fallos=[];
  for(var i=0;i<files.length;i++){
    var f=files[i];
    var deN=files.length>1 ? ' ('+(i+1)+' de '+files.length+')' : '';
    try{
      if(f.size > 12*1024*1024) throw new Error('pesa más de 12 MB');
      paso('Leyendo '+f.name+deN+'…');
      var prep=await _iaDesdeBlob(f, f.name);
      if(!prep || !prep.bloques) throw new Error('no se pudo abrir, prueba en PDF o Excel');

      paso('Sacando las líneas de '+f.name+deN+'…');
      // max_tokens alto a propósito. Con 8000 una proforma de 60 estilos no
      // cabía en una respuesta, así que _iaJSON pedía la continuación y
      // reenviaba el PDF entero en cada vuelta, hasta seis veces. Con los
      // datos de cabecera fuera de las líneas y este margen, entra de una.
      var j=await _iaJSON([{type:'text', text:_pcsPrompt()}].concat(prep.bloques), 24000,
        function(v){ paso('Documento muy largo: la IA va por la parte '+(v+1)+' de '+f.name+'…'); });

      var ls=(j&&j.lineas)||[];
      if(!ls.length) throw new Error('no se encontró ninguna línea de producto');

      // Los generales rellenan cada línea. Si la línea trae el campo (porque
      // se aparta del resto del documento), el de la línea manda.
      var gen=(j&&j.generales)||{};
      ls=ls.map(function(l){
        var o={};
        PCS_COLS.forEach(function(c){
          var v = (l[c.k]!==undefined && l[c.k]!==null) ? l[c.k]
                : (gen[c.k]!==undefined ? gen[c.k] : null);
          o[c.k]=(v===undefined?null:v);
        });
        if(!o.pxc) o.pxc=24;                                  // regla fija
        if(!o.vcode && o.style){                              // por si la IA no lo sacó
          var m=String(o.style).match(/^(\d+)\s*-/);
          if(m) o.vcode=Number(m[1]);
        }
        o._src=f.name;                                        // de qué archivo salió
        return o;
      });

      paso('Guardando '+f.name+deN+'…');
      var ruta=await _subirDocStorage('pcs','origen',f);
      archivos.push({nombre:f.name, url:ruta,
                     total:(j&&Number(j.total_documento))||null, lineas:ls.length});
      lineas=lineas.concat(ls);

    }catch(e){
      fallos.push(f.name+': '+(e.message||e));
    }
  }
  return {lineas:lineas, archivos:archivos, fallos:fallos};
}

// El estado en pantalla, con el reloj corriendo. Sin él, un minuto largo
// mirando una línea de texto quieta se lee como "se colgó", y la gente
// recarga a media extracción.
window._pcsReloj = null;

function _pcsPasoEn(idDiv){
  var t0=Date.now();
  return function(txt){
    if(window._pcsReloj){ clearInterval(window._pcsReloj); window._pcsReloj=null; }
    function pintar(){
      var d=document.getElementById(idDiv);
      if(!d){ return; }
      var s=Math.floor((Date.now()-t0)/1000);
      var reloj=Math.floor(s/60)+':'+('0'+(s%60)).slice(-2);
      d.innerHTML='<div class="nota" style="background:var(--pastel-azul);color:var(--t-azul)">'
        +'<i class="ti ti-loader-2"></i> '+_pcsEsc(txt)
        +' <span style="opacity:.7;font-variant-numeric:tabular-nums">('+reloj+')</span></div>';
    }
    pintar();
    window._pcsReloj=setInterval(pintar, 1000);
  };
}

function _pcsPasoFin(idDiv){
  if(window._pcsReloj){ clearInterval(window._pcsReloj); window._pcsReloj=null; }
  var d=document.getElementById(idDiv);
  if(d) d.innerHTML='';
}

// ── Hoja nueva, con uno o varios documentos ──────────────────────────────
async function _pcsSubir(input){
  var files=input && input.files ? Array.prototype.slice.call(input.files) : [];
  input.value='';
  if(!files.length) return;

  var paso=_pcsPasoEn('pcsEstado');
  window._pcsTrabajando=true;
  _pcsPintarLista();
  try{
    var res=await _pcsLeerArchivos(files, paso);
    if(!res.lineas.length){
      throw new Error('No se pudo sacar ninguna línea. '+res.fallos.join(' · '));
    }
    var g=res.lineas[0]||{};
    var totales=res.archivos.map(function(a){return a.total;}).filter(function(t){return t;});
    var body={
      po:g.po||null, proveedor:g.vendor||null, marca:g.marca||null,
      archivos:res.archivos,
      archivo_nombre:res.archivos.length?res.archivos[0].nombre:null,
      archivo_url:res.archivos.length?res.archivos[0].url:null,
      total_documento:totales.length?totales.reduce(function(a,b){return a+b;},0):null,
      lineas:res.lineas, dept:'ropa',
      creado_por:CU?CU.name:'', creado_en:new Date().toISOString(),
      orden: window._pcsOrden || null
    };
    var r=await fetch(SB+'/rest/v1/'+PCS_TABLA,{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(body)
    });
    if(!r.ok){
      var det=''; try{ det=' · '+(await r.text()).slice(0,200); }catch(e2){}
      throw new Error('No se pudo guardar la hoja (estado '+r.status+')'+det);
    }
    var creada=(await r.json())[0];
    if(!creada) throw new Error('Supabase aceptó la hoja pero no devolvió la fila.');

    // La fila que acaba de devolver Supabase se mete directamente en la
    // lista y se abre con ella. Antes se recargaba la lista y se buscaba
    // la hoja ahí dentro: si esa recarga venía vacía o cacheada, el trabajo
    // parecía perdido aunque estuviera guardado.
    _pcsPasoFin('pcsEstado');
    window._pcsTrabajando=false;
    window._pcsHojas=[creada].concat(window._pcsHojas||[]);
    _pcsPintarLista();
    _pcsAbrir(creada);

    if(res.fallos.length) showT('No se pudieron leer: '+res.fallos.join(' · '), 8000);
    if(window._iaJSONReparado) showT('Aviso: una respuesta venía cortada y se reparó. Revisa que estén todas las líneas.', 7000);
    _pcsCargar();          // en segundo plano, para quedar al día con el servidor

  }catch(e){
    if(window._pcsReloj){ clearInterval(window._pcsReloj); window._pcsReloj=null; }
    window._pcsTrabajando=false;
    _pcsPintarLista();
    var est=document.getElementById('pcsEstado');
    if(est) est.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> '+_pcsEsc(e.message||e)+'</div>';
  }
}

// ── Añadir documentos a una hoja que ya existe ───────────────────────────
async function _pcsAnadir(input){
  var files=input && input.files ? Array.prototype.slice.call(input.files) : [];
  input.value='';
  var h=window._pcsActual;
  if(!files.length || !h) return;

  var paso=_pcsPasoEn('pcsEstadoModal');
  try{
    var res=await _pcsLeerArchivos(files, paso);
    if(!res.lineas.length) throw new Error('No se pudo sacar ninguna línea. '+res.fallos.join(' · '));

    h.lineas=(h.lineas||[]).concat(res.lineas);
    h.archivos=_pcsArchivos(h).concat(res.archivos);
    var totales=h.archivos.map(function(a){return a.total;}).filter(function(t){return t;});
    h.total_documento=totales.length?totales.reduce(function(a,b){return a+b;},0):null;
    // Los datos de cabecera solo se rellenan si faltaban: el primer documento manda
    var g=res.lineas[0]||{};
    if(!h.po) h.po=g.po||null;
    if(!h.proveedor) h.proveedor=g.vendor||null;
    if(!h.marca) h.marca=g.marca||null;

    await _pcsGuardar(true);
    _pcsPasoFin('pcsEstadoModal');
    _pcsPintarRevision();
    if(res.fallos.length) showT('No se pudieron leer: '+res.fallos.join(' · '), 8000);
    else showT('Añadidas '+res.lineas.length+' líneas de '+res.archivos.length+' documento(s)');

  }catch(e){
    if(window._pcsReloj){ clearInterval(window._pcsReloj); window._pcsReloj=null; }
    var d=document.getElementById('pcsEstadoModal');
    if(d) d.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> '+_pcsEsc(e.message||e)+'</div>';
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  BORRAR
// ═══════════════════════════════════════════════════════════════════════════
async function _pcsBorrar(id){
  var h=(window._pcsHojas||[]).find(function(x){return String(x.id)===String(id);});
  if(!h){ showT('No se encontró la hoja'); return; }
  if(!_pcsPuedeBorrar(h)){ showT('Solo la puede borrar quien la creó, o gerencia'); return; }

  var archivos=_pcsArchivos(h);
  var arrastra=[(h.lineas||[]).length+' líneas de producto'];
  if(archivos.length) arrastra.push(archivos.length+' documento(s) subidos: '
    +archivos.map(function(a){return a.nombre;}).join(', '));

  if(!_confirmarBorrado('la hoja de "'+(h.po||'sin número de orden')+'"',
      'El Excel que ya hayas descargado no se toca. Esto borra la hoja del portal.',
      arrastra)) return;

  showT('Borrando…');
  for(var i=0;i<archivos.length;i++){
    if(archivos[i].url) await _borrarArchivoStorage(archivos[i].url, null);
  }
  try{
    var r=await fetch(SB+'/rest/v1/'+PCS_TABLA+'?id=eq.'+encodeURIComponent(id),
      {method:'DELETE', headers:SBH});
    if(!r.ok) throw new Error('estado '+r.status);
  }catch(e){ showT('No se pudo borrar: '+(e.message||e)); return; }

  window._pcsHojas=(window._pcsHojas||[]).filter(function(x){return String(x.id)!==String(id);});
  if(window._pcsActual && String(window._pcsActual.id)===String(id)) _pcsCerrar();
  _pcsPintarLista();
  showT('✓ Hoja eliminada');
  try{ _accRegistrar('pcs','Borró la hoja '+(h.po||id)); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  REVISIÓN
//  Se edita en la misma tabla. La comprobación del total y el aviso de
//  códigos repetidos van arriba y se recalculan con cada cambio.
// ═══════════════════════════════════════════════════════════════════════════
// Admite el id, o la fila entera. Lo segundo importa justo después de crear
// una hoja: se abre con lo que devolvió Supabase, sin depender de que una
// segunda petición la encuentre.
function _pcsAbrir(ref){
  var h = (ref && typeof ref==='object')
    ? ref
    : (window._pcsHojas||[]).find(function(x){return String(x.id)===String(ref);});
  if(!h){ showT('No se encontró la hoja'); return; }
  window._pcsActual=JSON.parse(JSON.stringify(h));   // copia: se edita sin tocar la lista
  _pcsPintarRevision();
  document.getElementById('modal').style.display='flex';
}

function _pcsCuadre(){
  var h=window._pcsActual; if(!h) return null;
  var calc=(h.lineas||[]).reduce(function(a,l){
    return a+(Number(l.piezas)||0)*(Number(l.precio)||0);
  },0);
  var arch=_pcsArchivos(h);
  var conTotal=arch.filter(function(a){return Number(a.total);});
  var doc=conTotal.reduce(function(a,x){return a+Number(x.total);},0);
  if(!conTotal.length && Number(h.total_documento)) doc=Number(h.total_documento);
  var faltan=arch.length - conTotal.length;
  // Si a algún documento le falta el total impreso, la comparación no vale:
  // las líneas de ese documento SÍ suman de este lado pero no del otro, así
  // que daría "no cuadra" siempre. Es información incompleta, no un error,
  // y decir lo contrario entrena a la gente a ignorar el aviso rojo.
  var comparable = doc>0 && faltan===0;
  return {calc:calc, doc:doc>0?doc:null,
          ok: comparable ? (Math.abs(calc-doc)<0.5) : null,
          faltanTotales: faltan, docs: arch.length};
}

// Códigos de barras que aparecen más de una vez. Es la señal de que se
// subió dos veces el mismo documento, o una proforma corregida junto a la
// vieja. Sin este aviso el Excel sale con líneas duplicadas.
function _pcsRepetidos(){
  var h=window._pcsActual; if(!h) return [];
  var vistos={}, rep=[];
  (h.lineas||[]).forEach(function(l){
    var k=String(l.ean==null?'':l.ean).trim();
    if(!k) return;
    if(vistos['#'+k]){ if(rep.indexOf(k)<0) rep.push(k); }
    else vistos['#'+k]=true;
  });
  return rep;
}

function _pcsPintarRevision(){
  var h=window._pcsActual; if(!h) return;
  var mc=document.getElementById('mc'); if(!mc) return;
  var q=_pcsCuadre();
  var rep=_pcsRepetidos();
  var piezas=(h.lineas||[]).reduce(function(a,l){return a+(Number(l.piezas)||0);},0);
  var arch=_pcsArchivos(h);

  var aviso;
  if(q.ok===null){
    aviso='<div class="nota" style="background:var(--pastel-gris);color:var(--text-secondary)">'
     +'<i class="ti ti-help-circle"></i> No se pudo comprobar la extracción: '
     +(q.faltanTotales>=q.docs
        ? 'ningún documento traía un total impreso.'
        : q.faltanTotales+' de '+q.docs+' documentos no traen total impreso, así que la suma '
          +'de los otros no sirve para comparar.')
     +' Aquí suman '+(h.lineas||[]).length+' líneas y USD '
     +q.calc.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})
     +'. Revísalas contra el original antes de descargar.</div>';
  } else if(q.ok){
    aviso='<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde)">'
     +'<i class="ti ti-circle-check"></i> Cuadra con '+(q.docs>1?'los documentos':'el documento')+': '
     +(h.lineas||[]).length+' líneas, '+piezas.toLocaleString('en-US')+' piezas, '
     +'USD '+q.calc.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})+'. '
     +'No falta ni sobra ninguna línea.</div>';
  } else {
    aviso='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
     +'<i class="ti ti-alert-triangle"></i> No cuadra. Sumado aquí: USD '
     +q.calc.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})
     +' · impreso en '+(q.docs>1?'los documentos':'el documento')+': USD '
     +q.doc.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})
     +' · diferencia USD '+Math.abs(q.calc-q.doc).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})
     +'. Falta una línea, sobra una, o un precio o cantidad está mal leído.</div>';
  }

  if(rep.length){
    aviso+='<div class="nota" style="background:var(--pastel-naranja);color:var(--t-marron)">'
     +'<i class="ti ti-copy"></i> '+rep.length+' código(s) de barras repetidos: '
     +_pcsEsc(rep.slice(0,6).join(', '))+(rep.length>6?'…':'')
     +'. Suele pasar cuando se sube dos veces el mismo documento o una proforma corregida '
     +'junto a la anterior. Las filas van marcadas en ámbar: borra las que sobren.</div>';
  }

  // Los documentos de la hoja, con la opción de añadir otro
  var chips=arch.map(function(a){
    return '<span class="badge" style="background:var(--pastel-lila);color:var(--t-lila)" '
      +'title="'+_pcsEsc((a.lineas||0)+' líneas'+(a.total?' · USD '+a.total:''))+'">'
      +'<i class="ti ti-file-text" style="font-size:10px"></i> '+_pcsEsc(a.nombre)+'</span>';
  }).join(' ');

  mc.innerHTML=
   '<div class="md-h"><h3>'+_pcsEsc(h.po||'Sin número de orden')+' · '+_pcsEsc(h.proveedor||'')+'</h3>'
  +  '<button class="xb" onclick="_pcsCerrar()"><i class="ti ti-x"></i></button></div>'
  +'<div class="md-b">'
  +  '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-bottom:10px">'
  +    chips
  +    '<input type="file" id="pcsFileAdd" multiple style="display:none" '
  +          'accept=".pdf,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.webp" onchange="_pcsAnadir(this)">'
  +    '<button class="xb" onclick="document.getElementById(\'pcsFileAdd\').click()">'
  +      '<i class="ti ti-plus"></i> Añadir documento</button>'
  +  '</div>'
  +  '<div id="pcsEstadoModal"></div>'
  +  aviso
  +  '<div style="overflow:auto;max-height:54vh;border:1px solid var(--border);border-radius:8px">'
  +    '<table class="tb" style="font-size:11px"><thead><tr><th style="width:38px">#</th>'
  +      (arch.length>1?'<th>Documento</th>':'')
  +      PCS_COLS.map(function(c){return '<th>'+c.t+'</th>';}).join('')
  +      '<th style="width:34px"></th></tr></thead><tbody>'
  +      (h.lineas||[]).map(function(l,i){
          var dup = l.ean && rep.indexOf(String(l.ean).trim())>=0;
          return '<tr'+(dup?' style="background:var(--pastel-naranja)"':'')+'>'
           +'<td style="color:var(--text-muted)">'+(i+1)+'</td>'
           +(arch.length>1?'<td style="font-size:10px;color:var(--text-muted);max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="'+_pcsEsc(l._src||'')+'">'+_pcsEsc(l._src||'—')+'</td>':'')
           +PCS_COLS.map(function(c){
              return '<td><input class="li" style="font-size:11px;padding:3px 5px;min-width:'+(c.w*6)+'px" '
                +'value="'+_pcsEsc(l[c.k]==null?'':l[c.k])+'" '
                +'onchange="_pcsEditar('+i+',\''+c.k+'\',this.value,'+(c.num?'1':'0')+')"></td>';
            }).join('')
           +'<td><button class="xb" title="Quitar esta fila" onclick="_pcsQuitar('+i+')">'
           +'<i class="ti ti-trash"></i></button></td></tr>';
        }).join('')
  +    '</tbody></table>'
  +  '</div>'
  +  '<p style="font-size:11px;color:var(--text-muted);margin-top:10px">'
  +    'De "Piezas despachadas" en adelante el Excel sale vacío: eso se llena al despachar.</p>'
  +'</div>'
  +'<div class="md-f">'
  +  '<button class="xb" onclick="_pcsAgregarFila()"><i class="ti ti-plus"></i> Añadir fila</button>'
  +  '<button class="xb" onclick="_pcsGuardar()"><i class="ti ti-device-floppy"></i> Guardar cambios</button>'
  +  (_pcsPuedeBorrar(h)
      ? '<button class="xb" style="color:var(--text-danger)" onclick="_pcsBorrar(\''+h.id+'\')">'
        +'<i class="ti ti-trash"></i> Borrar hoja</button>' : '')
  +  '<button class="lb" style="max-width:220px" onclick="_pcsExcel()">'
  +    '<i class="ti ti-file-spreadsheet"></i> Descargar Excel</button>'
  +'</div>';
}

function _pcsEditar(i, k, v, esNum){
  var h=window._pcsActual; if(!h||!h.lineas[i]) return;
  var val=String(v).trim();
  h.lineas[i][k] = !val ? null : (esNum ? (isNaN(Number(val))?val:Number(val)) : val);
  if(k==='piezas'||k==='precio'||k==='ean') _pcsPintarRevision();  // cambió el cuadre o los repetidos
}

function _pcsQuitar(i){
  var h=window._pcsActual; if(!h) return;
  h.lineas.splice(i,1);
  _pcsPintarRevision();
}

function _pcsAgregarFila(){
  var h=window._pcsActual; if(!h) return;
  var ult=h.lineas[h.lineas.length-1]||{};
  var nueva={};
  // Los datos de cabecera se repiten en todas las filas: se copian de la última
  PCS_COLS.forEach(function(c){
    nueva[c.k] = ['pxc','genero','marca','tejido','ratio','origen','vendor','vcode','po','hikc'].indexOf(c.k)>=0
      ? (ult[c.k]==null?null:ult[c.k]) : null;
  });
  nueva._src='(añadida a mano)';
  h.lineas.push(nueva);
  _pcsPintarRevision();
}

function _pcsCerrar(){ document.getElementById('modal').style.display='none'; }

async function _pcsGuardar(silencioso){
  var h=window._pcsActual; if(!h) return;
  var g=h.lineas[0]||{};
  try{
    var r=await fetch(SB+'/rest/v1/'+PCS_TABLA+'?id=eq.'+encodeURIComponent(h.id),{
      method:'PATCH', headers:SBH,
      body:JSON.stringify({lineas:h.lineas, archivos:_pcsArchivos(h),
                           total_documento:h.total_documento||null,
                           po:h.po||g.po||null, proveedor:h.proveedor||g.vendor||null,
                           marca:h.marca||g.marca||null, editado_por:CU?CU.name:'',
                           editado_en:new Date().toISOString()})
    });
    if(!r.ok) throw new Error('estado '+r.status);
    // Igual que al crear: la lista se actualiza aquí, y la recarga del
    // servidor va después y sin bloquear.
    window._pcsHojas=(window._pcsHojas||[]).map(function(x){
      return String(x.id)===String(h.id) ? JSON.parse(JSON.stringify(h)) : x;
    });
    _pcsPintarLista();
    if(!silencioso) showT('Cambios guardados');
    _pcsCargar();
  }catch(e){ showT('No se pudo guardar: '+(e.message||e)); }
}

// ═══════════════════════════════════════════════════════════════════════════
//  EXCEL
//  Se arma la plantilla completa: dos filas de título, los encabezados en
//  inglés y en español, la fila EXAMPLE y luego los datos desde la 7.
//  Las columnas de T en adelante llevan las MISMAS fórmulas de la plantilla,
//  para que al escribir cartones y medidas se calcule todo solo.
// ═══════════════════════════════════════════════════════════════════════════
var PCS_ENC_EN=['','Style Number','Description','Barcode','Price (USD)','Pcs Purchased',
 'Pieces x Carton','Gender','Brand','Composition','Type of Fabric','Ratio','Color',
 'Country of Origin','Vendor','Vendor Code','PO Order Number','HIKC NUMBER','Pieces Shipped',
 'Cartons Shipped','Carton Height CM','Carton Length CM','Carton Width CM',
 'Carton Measurement (cm)','Carton Cubic Feet','Piece Volume (cubic meters)',
 'Carton Cubic METERS','Piece Volume (cubic meters)','Carton Weight (KG)','Piece Weight (KG)'];

var PCS_ENC_ES=['Num','Referencia','Descripcion','Codigo de Barra','Precio (USD)',
 'Piezas Compradas','Piezas x Carton','Genero','Marca','Composicion','Tipo de Tejido',
 'Racion','Color','Pais de Origen','Proveedor','Codigo Proveedor',
 'Numero de Orden de proveedor','Numero de Orden HIKC','Piezas Despachadas',
 'Cartones Despachados','Altura de Caja CM','Lardo de Caja CM','Ancho de Caja CM',
 'Medida de Caja (CM)','Pies Cubicos Carton','Volumen Pieza (Metros Cubicos)',
 'Metros Cubicos Carton','Volumen Pieza (Metros Cubicos)','Peso Caja (KG)','Peso Pieza (KG)'];

function _pcsExcel(id){
  var h = id ? (window._pcsHojas||[]).find(function(x){return String(x.id)===String(id);})
             : window._pcsActual;
  if(!h){ showT('No se encontró la hoja'); return; }

  // Si no cuadra o hay repetidos, se avisa antes de bajar el archivo
  if(!id){
    var q=_pcsCuadre(), rp=_pcsRepetidos();
    if(q && q.ok===false &&
       !confirm('Los totales no cuadran con los documentos.\n\nSumado aquí: USD '+q.calc.toFixed(2)
                +'\nImpreso: USD '+q.doc.toFixed(2)+'\n\n¿Descargar de todas formas?')) return;
    if(rp.length &&
       !confirm('Hay '+rp.length+' código(s) de barras repetidos.\n\n'
                +'El Excel saldrá con líneas duplicadas.\n\n¿Descargar de todas formas?')) return;
  }

  var aoa=[];
  aoa.push(['Kennedy Center Corp']);
  aoa.push(['Product Creation Template']);
  var r3=new Array(30).fill(''); r3[21]='TO BE FILLED OUT ONCE GOODS ARE SHIPPED or READY TO SHIP';
  aoa.push(r3);
  aoa.push(PCS_ENC_EN);
  aoa.push(PCS_ENC_ES);
  aoa.push(['EXAMPLE','523-L24-129','LADIES CROPPED SHORT SLEEVE SHIRTS',7450123093787,4.10,
            720,24,'Ladies','Morelli','80% POLIÉSTER 20% VISCOSA','Woven',
            'S    M     L     XL   /  4   8   8  4','White','India','MOR INDIA',523,
            '1010589/24','HIKC-17025',720,'','','','','','','','','','','']);

  (h.lineas||[]).forEach(function(l,i){
    var f=[i+1];
    PCS_COLS.forEach(function(c){ f.push(l[c.k]==null?'':l[c.k]); });
    while(f.length<30) f.push('');
    aoa.push(f);
  });

  var ws=XLSX.utils.aoa_to_sheet(aoa);

  // Fórmulas, fila por fila de datos. Se usa el operador & en lugar de
  // CONCAT: CONCAT es posterior a Excel 2007 y hay que escribirlo como
  // _xlfn.CONCAT o sale #NAME?; con & funciona en cualquier versión.
  for(var i=0;i<(h.lineas||[]).length;i++){
    var r=7+i;                                   // fila 7 = primera de datos
    ws['T'+r] ={t:'n', f:'ROUNDUP(S'+r+'/G'+r+',0)'};
    ws['X'+r] ={t:'s', f:'U'+r+'&"x"&V'+r+'&"x"&W'+r+'&"CM"'};
    ws['Y'+r] ={t:'n', f:'AA'+r+'*35.3147'};
    ws['Z'+r] ={t:'n', f:'Y'+r+'/E'+r};
    ws['AA'+r]={t:'n', f:'(U'+r+'*V'+r+'*W'+r+')/1000000'};
    ws['AB'+r]={t:'n', f:'AA'+r+'/G'+r};
    ws['AD'+r]={t:'n', f:'AC'+r+'/G'+r};
  }
  ws['!ref']=XLSX.utils.encode_range({s:{r:0,c:0},e:{r:6+(h.lineas||[]).length, c:29}});
  ws['!cols']=[{wch:8}].concat(PCS_COLS.map(function(c){return {wch:c.w};}))
                       .concat(new Array(12).fill({wch:13}));
  ws['!freeze']={xSplit:'2', ySplit:'5'};

  var wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Product Creation Chart');

  var nombre='Product_Creation_Sheet_'
    +String(h.po||'sin_orden').replace(/[^\w\-]+/g,'_')+'_'
    +String(h.marca||'').replace(/[^\w\-]+/g,'_')+'.xlsx';
  XLSX.writeFile(wb, nombre.replace(/_+/g,'_').replace(/_\.xlsx$/,'.xlsx'));
  try{ _accRegistrar('pcs','Descargó '+nombre); }catch(e){}
}



/* ═══════════════════════════════════════════════════════════════════════════
   EXTRACTO DE BANISTMO · lectura directa, sin IA
   ───────────────────────────────────────────────────────────────────────────
   El extracto de Banistmo trae el saldo en cada fila. Eso lo vuelve
   verificable: la diferencia entre dos saldos consecutivos ES el movimiento,
   con su signo verdadero. No hay nada que interpretar.

   Leer 728 movimientos preguntándole a una IA de a 45 por vuelta, reenviando
   el PDF entero cada vez, es caro, lento y se pierde: en la conciliación de
   agosto se detuvo en el movimiento 276 y tomó un saldo de media tarde del
   día 13 como si fuera el saldo de cierre del mes. Aquí se leen los 728 de
   una pasada, en el navegador, y al final se comprueba la cadena completa
   contra el SALDO FINAL impreso.

   SI LA COMPROBACIÓN FALLA, NO DEVUELVE NADA. Media conciliación es peor que
   ninguna: la de agosto parecía terminada y estaba a un 37%.

   Formatos que no reconozca siguen yendo a la IA como hasta ahora.
   ═══════════════════════════════════════════════════════════════════════════ */

// ── pdf.js, cargado solo cuando hace falta ───────────────────────────────
// Mismo patrón que _ensurePdfLib() para pdf-lib.
function _ensurePdfJs(){
  if(window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
  if(window._pdfjsLoad) return window._pdfjsLoad;
  window._pdfjsLoad=new Promise(function(res,rej){
    var s=document.createElement('script');
    s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    s.onload=function(){
      try{
        window.pdfjsLib.GlobalWorkerOptions.workerSrc=
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      }catch(e){}
      res(window.pdfjsLib);
    };
    s.onerror=function(){ rej(new Error('No se pudo cargar el lector de PDF.')); };
    document.head.appendChild(s);
  });
  return window._pdfjsLoad;
}

// ── El PDF, convertido a palabras con su posición ────────────────────────
// Hace falta la posición porque un extracto es una tabla: el mismo número
// significa débito, crédito o saldo según la columna en la que cae.
async function _pdfPaginas(blob){
  var pdfjs=await _ensurePdfJs();
  var buf=await blob.arrayBuffer();
  var doc=await pdfjs.getDocument({data:new Uint8Array(buf)}).promise;
  var pags=[];
  for(var p=1;p<=doc.numPages;p++){
    var page=await doc.getPage(p);
    var vp=page.getViewport({scale:1});
    var tc=await page.getTextContent();
    var items=[], crudo=[];
    tc.items.forEach(function(it){
      var s=it.str;
      if(!s || !s.trim()) return;
      crudo.push(s);
      var x0=it.transform[4], y=it.transform[5];
      var top=vp.height-y;                       // en PDF la Y crece hacia arriba
      var w=it.width||0;
      // pdf.js a veces entrega la fila entera en un solo item. Se parte en
      // palabras y se reparte el ancho a prorrata de los caracteres, que es
      // exacto de sobra para decidir en qué columna cae cada número.
      var largo=s.length||1, cur=0;
      s.split(/\s+/).forEach(function(tok){
        if(!tok) return;
        var i=s.indexOf(tok,cur); if(i<0) i=cur;
        items.push({t:tok,
                    x0:x0+w*(i/largo),
                    x1:x0+w*((i+tok.length)/largo),
                    top:top});
        cur=i+tok.length;
      });
    });
    pags.push({items:items, texto:crudo.join(' ')});
  }
  try{ doc.destroy(); }catch(e){}
  return pags;
}

var _BAN_NUM=/^-?[\d,]+\.\d\d$/;
var _BAN_FECHA=/^\d{4}-\d{2}-\d{2}$/;
function _banNum(s){ return Number(String(s).replace(/,/g,'')); }
function _banSinTildes(s){
  return String(s||'').toUpperCase()
    .replace(/[ÁÀÄÂ]/g,'A').replace(/[ÉÈËÊ]/g,'E').replace(/[ÍÌÏÎ]/g,'I')
    .replace(/[ÓÒÖÔ]/g,'O').replace(/[ÚÙÜÛ]/g,'U').trim();
}

function _banEsBanistmo(pags){
  var t=_banSinTildes((pags[0]&&pags[0].texto)||'');
  return t.indexOf('BANISTMO')>=0 && t.indexOf('ESTADO DE MOVIMIENTOS')>=0;
}

// ── El parser ────────────────────────────────────────────────────────────
function _banistmoDeItems(pags){
  var movs=[], ini=null, fin=null, desde=null, hasta=null;

  pags.forEach(function(pag){
    var txt=pag.texto||'', m;
    if((m=/SALDO\s+INICIAL:?\s*(-?[\d,]+\.\d\d)/i.exec(txt))) ini=_banNum(m[1]);
    if((m=/SALDO\s+FINAL:?\s*(-?[\d,]+\.\d\d)/i.exec(txt)))   fin=_banNum(m[1]);
    if((m=/DESDE:?\s*(\d{4}-\d{2}-\d{2})/i.exec(txt))) desde=desde||m[1];
    if((m=/HASTA:?\s*(\d{4}-\d{2}-\d{2})/i.exec(txt))) hasta=m[1];

    // Las columnas se localizan por el encabezado DE CADA PÁGINA. No van
    // fijas: si el banco mueve una columna, el lector la sigue solo.
    var cols={}, yEnc=null;
    pag.items.forEach(function(w){
      var k=_banSinTildes(w.t);
      if(k==='DESCRIPCION') k='DESC';
      if(['DEBITO','CREDITO','SALDO','SUCURSAL','FECHA','DESC'].indexOf(k)>=0 && !cols[k]){
        cols[k]=[w.x0,w.x1];
        if(k==='SALDO') yEnc=w.top;
      }
    });
    if(!(cols.DEBITO && cols.CREDITO && cols.SALDO)) return;   // página sin tabla

    var centro={};
    ['DEBITO','CREDITO','SALDO'].forEach(function(k){ centro[k]=(cols[k][0]+cols[k][1])/2; });
    var xTexto=cols.DEBITO[0];       // a la izquierda de DÉBITO todo es descripción

    // Las palabras se agrupan en renglones por su altura, con tolerancia:
    // redondear parte filas justo en el borde.
    var cuerpo=pag.items.filter(function(w){ return yEnc===null || w.top>yEnc+2; })
                        .sort(function(a,b){ return a.top-b.top || a.x0-b.x0; });
    var lineas=[], act=null;
    cuerpo.forEach(function(w){
      if(!act || Math.abs(w.top-act.top)>2.5){ act={top:w.top, ws:[]}; lineas.push(act); }
      act.ws.push(w);
    });

    lineas.forEach(function(ln){
      var ws=ln.ws.sort(function(a,b){ return a.x0-b.x0; });
      if(!ws.length) return;

      // El pie de la última página ("SALDO INICIAL: … SALDO FINAL: …") cae a
      // la izquierda de la columna de débito, así que sin esto se pegaba al
      // final de la descripción del último movimiento.
      if(/SALDO\s+(INICIAL|FINAL)/i.test(ws.map(function(w){return w.t;}).join(' '))) return;

      if(_BAN_FECHA.test(ws[0].t)){
        var f={fecha:ws[0].t, desc:[], deb:0, cred:0, saldo:null};
        for(var i=1;i<ws.length;i++){
          var w=ws[i];
          if(_BAN_NUM.test(w.t)){
            // Cada número cae en la columna cuyo centro tiene más cerca.
            var c=(w.x0+w.x1)/2, mejor='SALDO', d=Infinity;
            ['DEBITO','CREDITO','SALDO'].forEach(function(k){
              var dd=Math.abs(c-centro[k]);
              if(dd<d){ d=dd; mejor=k; }
            });
            if(mejor==='SALDO')      f.saldo=_banNum(w.t);
            else if(mejor==='DEBITO')f.deb=_banNum(w.t);
            else                     f.cred=_banNum(w.t);
          } else if(w.x1<xTexto){
            f.desc.push(w.t);
          }
        }
        movs.push(f);
      } else if(movs.length){
        // Renglón de continuación: la descripción de Banistmo ocupa
        // varias líneas y la fecha solo aparece en la primera.
        ws.forEach(function(w){
          if(w.x1<xTexto && !_BAN_NUM.test(w.t)) movs[movs.length-1].desc.push(w.t);
        });
      }
    });
  });

  if(!movs.length) throw new Error('No se encontró ninguna fila de movimientos en el PDF.');
  if(ini===null || fin===null)
    throw new Error('El PDF no trae el SALDO INICIAL y SALDO FINAL del pie. '
                   +'¿Está completo el archivo?');

  movs.forEach(function(f){ f.desc=f.desc.join(' ').replace(/\s+/g,' ').trim(); });

  // ── LA COMPROBACIÓN ────────────────────────────────────────────────────
  // El movimiento verdadero es la diferencia entre dos saldos consecutivos.
  // Si el débito o el crédito leído no coincide EN SIGNO, manda el saldo: es
  // el único dato que el banco calculó y que no depende de cómo se lea la
  // tabla.
  //
  // Y aquí está la verificación de verdad. Las columnas de débito y crédito
  // se leen por separado de la columna de saldo, así que si el IMPORTE de
  // las dos coincide en las 728 filas, la tabla se leyó bien y no falta
  // ninguna. Si faltara una página, la fila siguiente al hueco tendría un
  // salto de saldo que no se parece a su propio débito, y salta aquí.
  //
  // (No sirve comparar la suma de los montos contra saldo_final - saldo_inicial:
  // como cada monto es una resta de saldos, esa suma se telescopa y da bien
  // SIEMPRE, incluso con la mitad del extracto sin leer. Esa comprobación
  // parecía sólida y no comprobaba nada.)
  var prev=ini, sinSaldo=[], descuadres=[], signos=0;
  movs.forEach(function(f,i){
    if(f.saldo===null){ sinSaldo.push(i); return; }
    f.monto=Math.round((f.saldo-prev)*100)/100;
    var declarado=Math.round((f.cred-f.deb)*100)/100;
    if(Math.abs(f.monto-declarado)>0.005){
      if(Math.abs(Math.abs(f.monto)-Math.abs(declarado))<0.005) signos++;
      else descuadres.push({i:i, fecha:f.fecha, desc:f.desc.slice(0,45),
                            declarado:declarado, porSaldo:f.monto});
    }
    prev=f.saldo;
  });
  if(sinSaldo.length)
    throw new Error('Hay '+sinSaldo.length+' fila(s) sin saldo legible. No se puede comprobar la lectura.');

  if(descuadres.length){
    var d0=descuadres[0];
    throw new Error('La lectura no cuadra en '+descuadres.length+' fila(s). '
      +'La primera es del '+d0.fecha+' ("'+d0.desc+'"): el documento dice '
      +d0.declarado.toFixed(2)+' pero el salto de saldo es '+d0.porSaldo.toFixed(2)
      +'. Suele significar que falta una página del PDF.');
  }

  var ult=movs[movs.length-1];
  if(Math.abs(ult.saldo-fin)>0.02){
    throw new Error('La lectura quedó incompleta: se llegó hasta el '+ult.fecha
      +' con saldo '+ult.saldo.toFixed(2)+', y el documento cierra en '+fin.toFixed(2)
      +'. No se concilia con un extracto a medias.');
  }

  return {
    saldo_inicial:ini, saldo_final:fin, desde:desde, hasta:hasta,
    movimientos:movs.filter(function(f){ return f.monto!==0; }).map(function(f){
      var r=/\b(TR[RE]\d{6,}|\d{5,})\b/.exec(f.desc);
      return {fecha:f.fecha, detalle:f.desc, ref:r?r[1]:'', monto:f.monto, saldo:f.saldo};
    }),
    __leidas:movs.length
  };
}

// ── La puerta de entrada ─────────────────────────────────────────────────
// Devuelve null si el archivo no es un extracto de Banistmo, y entonces
// sigue el camino de siempre con la IA.
async function _concLeerBanistmo(file, mes, anio, aviso){
  if(!/\.pdf$/i.test(file.name||'') && !/pdf/i.test(file.type||'')) return null;

  var pags;
  try{
    if(aviso) aviso(0,'extracto');
    pags=await _pdfPaginas(file);
  }catch(e){
    console.warn('[conciliación] no se pudo abrir el PDF con pdf.js:', e);
    return null;                       // que lo intente la IA
  }
  if(!pags.length || !_banEsBanistmo(pags)) return null;

  // A partir de aquí SÍ es Banistmo, así que un fallo se dice en voz alta
  // en vez de pasárselo a la IA, que con este documento ya se perdió.
  var d=_banistmoDeItems(pags);

  if(d.desde && d.hasta){
    var mIni=Number(d.desde.slice(5,7))-1, aIni=Number(d.desde.slice(0,4));
    if(mIni!==mes || aIni!==anio){
      throw new Error('El extracto es de '+MESES_ES[mIni]+' '+aIni
        +' ('+d.desde+' al '+d.hasta+') y en pantalla está seleccionado '
        +MESES_ES[mes]+' '+anio+'.');
    }
  }
  console.log('[conciliación] Banistmo leído sin IA: '+d.__leidas+' movimientos, '
    +d.desde+' al '+d.hasta+', saldo '+d.saldo_inicial.toFixed(2)+' → '+d.saldo_final.toFixed(2));
  return d;
}



/* ═══════════════════════════════════════════════════════════════════════════
   SALDOS Y PRÉSTAMOS BANCARIOS  ·  módulo para compras-app.js
   ───────────────────────────────────────────────────────────────────────────
   Contabilidad sube los dos Excel del día, los revisa y corrige en pantalla,
   y los manda a gerencia en un solo correo. Cada envío queda guardado para
   consultarlo cuando haga falta.

   POR QUÉ SE ABRE EL EXCEL DE VERDAD Y NO SE REDIBUJA
   El archivo se lee con ExcelJS conservando fuentes, rellenos, anchos,
   celdas combinadas y formatos de número, se le cambian SOLO los valores
   que edite el usuario, y se vuelve a escribir. El adjunto que recibe
   gerencia es la plantilla de contabilidad con otros números, no una
   imitación. Por eso los archivos tienen que estar en .xlsx: el .xls de
   Excel 97 no conserva el formato al pasar por el navegador.

   LAS FÓRMULAS
   Las dos hojas tienen 156 fórmulas y solo usan SUM y TODAY. El módulo las
   recalcula en pantalla mientras se edita, así los totales se mueven como
   en Excel, y al insertar una línea desplaza las referencias igual que
   Excel: un SUM(B4:B17) con la fila nueva en la 17 pasa a SUM(B4:B18), y
   si la fila entra en la 18 se queda como está.

   Las celdas con fórmula salen en gris y no se pueden escribir: las calcula
   la hoja. Si una fórmula viene rota de origen (hoy el TOTAL GENERAL del
   reporte de préstamos, E77, arrastra un #REF!) la celda sale en rojo con
   el error a la vista en vez de un cero silencioso.

   DEPENDE de lo que ya existe en el portal:
     _ensureExcelJS()  (se define aquí si no estuviera)
     _subirDocStorage(), _confirmarBorrado(), _esGerencia()
     SB, KEY, SBH, DOCS_BASE, CU, showT(), MESES_ES
   ═══════════════════════════════════════════════════════════════════════════ */

var BK_TABLA='bancos_reportes';
// El orden manda: es el que llevan las pestañas y el que sale en el correo.
var BK_DOCS=[
  {k:'saldos',    t:'Saldos bancarios',    arch:'Saldos_Bancarios'},
  {k:'prestamos', t:'Préstamos bancarios', arch:'Prestamos_Bancarios'},
  {k:'ach',       t:'ACH enviadas',        arch:'ACH_Enviadas'},
  {k:'cheques',   t:'Cheques realizados',  arch:'Cheques_Realizados'}
];

function _bkPuede(){
  if(!CU) return false;
  if(CU.role==='contabilidad') return true;
  // Gerencia GENERAL, no la de un departamento. Henry (ropa) y Gady
  // (alfombras) tienen rol gerencia pero llevan su área, no la empresa: los
  // saldos y préstamos de la compañía no son asunto suyo. Es el mismo
  // criterio que ya se usa para los destinatarios del correo de saldos.
  // _deptAcotado() es el criterio que ya usa el resto del portal y cubre
  // también a quien lleva varios departamentos (CU.depts), no solo uno.
  return CU.role==='gerencia' && !_deptAcotado();
}

// ── ExcelJS bajo demanda ─────────────────────────────────────────────────
function _bkExcelJS(){
  if(window.ExcelJS) return Promise.resolve(window.ExcelJS);
  if(window._exceljsLoad) return window._exceljsLoad;
  window._exceljsLoad=new Promise(function(res,rej){
    var s=document.createElement('script');
    s.src='https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js';
    s.onload=function(){ res(window.ExcelJS); };
    s.onerror=function(){ rej(new Error('No se pudo cargar el lector de Excel.')); };
    document.head.appendChild(s);
  });
  return window._exceljsLoad;
}

// ═══════════════════════════════════════════════════════════════════════════
//  REFERENCIAS Y FÓRMULAS
// ═══════════════════════════════════════════════════════════════════════════
var _BK_A1=/(\$?)([A-Z]{1,3})(\$?)(\d+)/g;
function _bkColN(s){ var n=0; for(var i=0;i<s.length;i++) n=n*26+(s.charCodeAt(i)-64); return n; }
function _bkColS(n){ var s=''; while(n>0){ var r=(n-1)%26; s=String.fromCharCode(65+r)+s; n=(n-r-1)/26; } return s; }

// Al insertar una fila en `ins`, toda referencia a una fila >= ins baja una.
// Es lo que hace Excel, incluido el detalle de que un rango que TERMINA justo
// antes de la fila nueva no se estira.
function _bkDesplazar(f, ins){
  return String(f).replace(_BK_A1, function(m,d1,c,d2,fl){
    var n=Number(fl);
    return d1+c+d2+(n>=ins ? n+1 : n);
  });
}

// Evaluador. Solo SUM y TODAY, que es todo lo que usan las dos hojas.
// Devuelve {v:número} o {err:'#REF!'} — una fórmula rota se ve, no se
// convierte en un cero que nadie nota.
function _bkEval(formula, leer, prof){
  prof=prof||0;
  if(prof>12) return {err:'#CICLO!'};
  var f=String(formula).replace(/^=/,'').trim();
  if(/#(REF|VALUE|DIV\/0|NAME|N\/A)/i.test(f)) return {err:(/#[A-Z\/0]+!?/i.exec(f)||['#REF!'])[0]};

  f=f.replace(/TODAY\(\)/gi, function(){
    return String(Math.floor((new Date()-new Date(1899,11,30))/86400000));
  });

  var guardia=0, roto=null;
  while(/SUM\s*\(/i.test(f)){
    if(++guardia>60) return {err:'#CICLO!'};
    f=f.replace(/SUM\s*\(([^()]*)\)/i, function(m,args){
      var t=0;
      args.split(/[,;]/).forEach(function(a){
        a=a.trim(); if(!a) return;
        var r=/^\$?([A-Z]{1,3})\$?(\d+)\s*:\s*\$?([A-Z]{1,3})\$?(\d+)$/i.exec(a);
        if(r){
          var c1=_bkColN(r[1].toUpperCase()), f1=+r[2], c2=_bkColN(r[3].toUpperCase()), f2=+r[4];
          for(var c=Math.min(c1,c2);c<=Math.max(c1,c2);c++)
            for(var ff=Math.min(f1,f2);ff<=Math.max(f1,f2);ff++)
              t+=Number(leer(_bkColS(c)+ff))||0;
        } else {
          var s=_bkEval(a, leer, prof+1);
          if(s.err){ roto=s.err; return; }
          t+=Number(s.v)||0;
        }
      });
      return '('+t+')';
    });
    if(roto) return {err:roto};
  }

  f=f.replace(_BK_A1, function(m,d1,c,d2,fl){
    return '('+(Number(leer(c.toUpperCase()+fl))||0)+')';
  });
  if(!/^[-+*/().,\d\s%eE]*$/.test(f)) return {err:'#VALOR!'};
  f=f.replace(/(\d)%/g,'($1/100)');
  try{
    var v=Function('"use strict";return ('+(f||'0')+')')();
    if(!isFinite(v)) return {err:'#DIV/0!'};
    return {v:Math.round(v*1e6)/1e6};
  }catch(e){ return {err:'#VALOR!'}; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  MODELO EN MEMORIA
//  Un documento cargado = el libro de ExcelJS (que se vuelve a escribir tal
//  cual) + una caché de valores para recalcular en pantalla sin tocarlo.
// ═══════════════════════════════════════════════════════════════════════════
window._bkDoc=window._bkDoc||{saldos:null, prestamos:null};
// El resumen es lo primero que se ve: quien entra viene a mirar los saldos
// del día, no a subir un archivo. Las pestañas de cada Excel siguen ahí.
window._bkTab=window._bkTab||'resumen';

// Excel guarda una fórmula repetida en muchas filas como "fórmula
// compartida": la escribe entera una vez y en las demás celdas deja una
// referencia. ExcelJS entrega esas celdas como {sharedFormula:...} y no como
// {formula:...}. Mirar solo `formula` las tomaba por un valor cualquiera, y
// una columna entera de totales salía como [object Object] valiendo cero.
// El getter cell.formula sí las devuelve ya traducidas a su propia fila.
function _bkFormula(cell){
  try{
    var f=cell.formula;
    if(f) return String(f);
  }catch(e){}
  var v=cell.value;
  if(v && typeof v==='object' && (v.formula||v.sharedFormula))
    return String(v.formula||v.sharedFormula);
  return null;
}

// Una fecha llega como objeto Date, no como número de serie.
function _bkEsFecha(v){ return v instanceof Date || (v && typeof v==='object' && typeof v.getTime==='function'); }

// Hasta dónde llega el contenido DE VERDAD.
// Hace falta porque Excel guarda formato en filas vacías: el archivo de ACH
// enviadas dice tener 63.437 filas y solo 28 llevan datos. Recorrerlas todas
// (y peor, dibujarlas) colgaba el navegador con medio millón de celdas.
// eachRow con includeEmpty:false solo pasa por las que existen de verdad.
function _bkExtension(ws){
  var maxF=0, maxC=0;
  ws.eachRow({includeEmpty:false}, function(row, rn){
    var hay=false;
    row.eachCell({includeEmpty:false}, function(cell, cn){
      var f=_bkFormula(cell);
      var v=cell.value;
      // Una celda con solo espacios cuenta como vacía. En el archivo de ACH
      // hay un espacio suelto en la fila 63.437 que, tomado por contenido,
      // estiraba la hoja entera.
      var vacia = (v===null || v===undefined || v==='' ||
                   (typeof v==='string' && v.trim()===''));
      if(f || !vacia){
        hay=true;
        if(cn>maxC) maxC=cn;
      }
    });
    if(hay && rn>maxF) maxF=rn;
  });
  // Las celdas combinadas pueden estirar la tabla más allá del último dato
  ((ws.model&&ws.model.merges)||[]).forEach(function(rng){
    var m=/^([A-Z]+)(\d+):([A-Z]+)(\d+)$/.exec(String(rng)); if(!m) return;
    if(+m[2]<=maxF+1 || +m[4]<=maxF+1){
      var c2=_bkColN(m[3]); if(c2>maxC) maxC=c2;
    }
  });
  // Un tope duro, por si algún archivo viniera con decenas de miles de filas
  // reales: mejor enseñar 3.000 que dejar el navegador clavado.
  return {filas:Math.min(maxF, 3000), cols:Math.min(maxC, 60), recortado:maxF>3000};
}

function _bkRecachear(d){
  var ws=d.ws, cache={};
  if(!d.ext) d.ext=_bkExtension(ws);
  ws.eachRow({includeEmpty:false}, function(row, rn){
    if(rn>d.ext.filas) return;
    row.eachCell({includeEmpty:false}, function(cell, cn){
      var ref=_bkColS(cn)+rn;
      if(_bkFormula(cell)){ cache[ref]=null; return; }
      var v=cell.value;
      if(v===null||v===undefined){ cache[ref]=0; return; }
      if(typeof v==='number'){ cache[ref]=v; return; }
      if(_bkEsFecha(v)){ cache[ref]=v; return; }
      if(typeof v==='object'){
        // Aquí caben varias formas: texto con formato, hipervínculo, y sobre
        // todo una celda cuyo VALOR es un error de Excel ({error:'#REF!'}),
        // que es lo que salía como [object Object] arrastrando el total a
        // cero sin que se notara. Un error se ve; un cero silencioso no.
        if(v.error){ cache[ref]=0; d.errores=d.errores||{}; d.erroresVal=d.erroresVal||{};
                     d.erroresVal[ref]=String(v.error); return; }
        cache[ref]= v.richText ? v.richText.map(function(t){return t.text;}).join('')
                  : (v.text!==undefined ? v.text
                  : (v.result!==undefined && typeof v.result!=='object' ? v.result : ''));
        return;
      }
      cache[ref]=v;
    });
  });
  var leer=function(a){ var x=cache[a]; return (x===null||x===undefined)?0:x; };
  var errVal=d.erroresVal||{};
  d.errores={};
  Object.keys(errVal).forEach(function(a){ d.errores[a]=errVal[a]; });
  for(var pasada=0; pasada<6; pasada++){
    var cambio=false;
    ws.eachRow({includeEmpty:false}, function(row, rn){
      if(rn>d.ext.filas) return;
      row.eachCell({includeEmpty:false}, function(cell, cn){
        var f=_bkFormula(cell); if(!f) return;
        var a=_bkColS(cn)+rn;
        var r=_bkEval(f, leer);
        var nuevo = r.err ? 0 : r.v;
        if(r.err) d.errores[a]=r.err;
        if(cache[a]!==nuevo){ cache[a]=nuevo; cambio=true; }
      });
    });
    if(!cambio) break;
  }
  d.cache=cache;
}

// ── Formato de una celda para pintarla en pantalla ───────────────────────
function _bkArgb(c){
  if(!c) return null;
  var a=c.argb||c.rgb;
  if(!a) return null;
  a=String(a);
  return '#'+(a.length===8?a.slice(2):a);
}
function _bkFecha(d){
  if(!_bkEsFecha(d)) return '';
  return ('0'+d.getUTCDate()).slice(-2)+'-'+MESES_ES[d.getUTCMonth()].slice(0,3)
         +'-'+d.getUTCFullYear();
}
function _bkFmtNum(v, fmt){
  if(v===null||v===undefined||v==='') return '';
  // Una fecha llega como Date. Sin esto salía "Wed Mar 06 2026 00:00:00
  // GMT+0000", que además de ilegible reventaba el ancho de la columna.
  if(_bkEsFecha(v)) return _bkFecha(v);
  // Red de seguridad: si por lo que sea llega un objeto, se muestra vacío
  // antes que un "[object Object]" que nadie sabe interpretar.
  if(typeof v==='object') return v.error ? String(v.error) : '';
  // Una casilla de verificación llega como true/false. Sin esto salía la
  // palabra "true" en medio de la tabla del correo.
  if(typeof v==='boolean') return v ? '\u2713' : '';
  if(typeof v!=='number') return String(v);
  fmt=String(fmt||'');
  if(/%/.test(fmt)) return (v*100).toFixed((/\.0+/.exec(fmt)||['.00'])[0].length-1)+'%';
  if(/(yy|mmm|dd)/i.test(fmt) && v>20000 && v<80000)
    return _bkFecha(new Date(Date.UTC(1899,11,30+Math.floor(v))));
  var dec=/0\.00/.test(fmt)||/#,##0\.00/.test(fmt)?2:(/0\.0(?!0)/.test(fmt)?1:(/\.\d/.test(fmt)?2:0));
  var s=Math.abs(v).toLocaleString('en-US',{minimumFractionDigits:dec, maximumFractionDigits:dec});
  if(/B\/\./.test(fmt)) s='B/. '+s;
  return (v<0?'-':'')+s;
}

// ═══════════════════════════════════════════════════════════════════════════
//  PANTALLA
// ═══════════════════════════════════════════════════════════════════════════
async function rBancos(){
  var pg=document.getElementById('page-bancos');
  if(!pg) return;
  if(!_bkPuede()){ pg.innerHTML='<div class="empty">Esta pantalla es de contabilidad y gerencia.</div>'; return; }

  pg.innerHTML=
   '<div class="sec">'
  +  '<div class="sec-h"><h2>Saldos y préstamos bancarios</h2></div>'
  +  '<div id="bkTabs" style="display:flex;gap:6px;margin-bottom:12px;flex-wrap:wrap">'
  +    _bkTabsHTML()
  +  '</div>'
  +  '<div id="bkCargando" style="display:flex;align-items:center;gap:10px;'
  +    'background:var(--surface-1);border:0.5px solid var(--border);'
  +    'border-radius:10px;padding:12px 15px;margin-bottom:12px">'
  +    '<span class="bk-spin" style="width:16px;height:16px;border:2px solid var(--border);'
  +      'border-top-color:var(--t-azul);border-radius:50%;display:inline-block;'
  +      'animation:bkGirar .8s linear infinite"></span>'
  +    '<span style="font-size:12.5px;color:var(--text-secondary)">'
  +      'Cargando los saldos y los archivos del banco…</span>'
  +  '</div>'
  +  '<style>@keyframes bkGirar{to{transform:rotate(360deg)}}</style>'
  +  '<div id="bkCuerpo"></div>'
  +'</div>';

  _bkIrA(window._bkTab||'resumen');
  await _bkCargarEnvios();
  // Los cheques van PRIMERO. Iban después de _bkAbrirHoy(), que carga los
  // archivos ya enviados: si el correo de hoy ya salió, ahí quedaba metido
  // el .xlsx adjunto y la consulta a SAP no llegaba a correr nunca. La
  // pestaña pintaba ese libro como si fueran datos y decía "no hay cheques".
  if(!window._bkDoc.cheques){
    try{ await _bkCargarCheques(); }catch(e){ console.warn('[cheques]', e); }
  }
  await _bkAbrirHoy();
  // Ya está todo: fuera la ruedita
  try{
    var av=document.getElementById('bkCargando');
    if(av) av.remove();
  }catch(e){}
  _bkIrA(window._bkTab||'resumen');
}

function _bkTabsHTML(){
  return BK_DOCS.map(function(x){
        var d=window._bkDoc[x.k];
        var cuando = d ? (d.solo ? 'enviado '+_bkFechaHora(d.solo)
                                 : 'cargado '+_bkFechaHora(d.cargado)) : '';
      return '<button class="nb" id="bkTab-'+x.k+'" onclick="_bkIrA(\''+x.k+'\')">'
        +x.t
        +(cuando?'<span style="font-size:10px;color:var(--text-muted);margin-left:6px">'
                 +_bkEsc(cuando)+'</span>':'')
        +'</button>';
    }).join('')
    +'<button class="nb" id="bkTab-resumen" onclick="_bkIrA(\'resumen\')">'
    +'<i class="ti ti-layout-list"></i> Resumen</button>'
    +'<button class="nb" id="bkTab-envios" onclick="_bkIrA(\'envios\')">'
    +'<i class="ti ti-history"></i> Envíos anteriores</button>';
}

// Si los reportes de hoy ya se enviaron, se abren solos al entrar: es lo que
// gerencia viene a mirar, y bajarse el Excel para verlo no tiene sentido.
// Nunca pisa un archivo que alguien esté editando.
async function _bkAbrirHoy(){
  var hoy=new Date().toISOString().slice(0,10);
  var e=(window._bkMes||[]).filter(function(x){
      return x.fecha===hoy && x.estado==='enviado'; }).pop();
  if(!e) return;
  for(var i=0;i<BK_DOCS.length;i++){
    var k=BK_DOCS[i].k;
    if(window._bkDoc[k]) continue;          // hay trabajo en curso: no se toca
    if(!e[k+'_url']) continue;
    try{ await _bkVerDetalle(e.id, k, true); }catch(err){ console.warn('[bancos] abrir hoy:',err); }
  }
  _bkIrA(window._bkTab||'resumen');
}

function _bkIrA(tab){
  window._bkTab=tab;
  // Las pestañas llevan la fecha de cada documento, así que se repintan
  // cada vez que se carga o se quita uno.
  var barra=document.getElementById('bkTabs');
  if(barra) barra.innerHTML=_bkTabsHTML();
  BK_DOCS.concat([{k:'resumen'},{k:'envios'}]).forEach(function(x){
    var b=document.getElementById('bkTab-'+x.k);
    if(b) b.style.background = (x.k===tab) ? 'var(--pastel-azul)' : '';
  });
  if(tab==='envios') _bkPintarEnvios();
  else if(tab==='resumen') _bkPintarResumen();
  else _bkPintarDoc(tab);
}

function _bkPintarDoc(k){
  var cont=document.getElementById('bkCuerpo'); if(!cont) return;
  var meta=BK_DOCS.find(function(x){return x.k===k;});
  var d=window._bkDoc[k];

  var titulo = d
    ? '<div style="margin-bottom:8px">'
      +'<span style="font-size:14px;font-weight:600">'+_bkEsc(meta.t)+'</span>'
      +'<span style="font-size:12px;color:var(--text-muted);margin-left:8px">'
      + (d.solo ? 'enviado el '+_bkEsc(_bkFechaHora(d.solo))
                : 'cargado el '+_bkEsc(_bkFechaHora(d.cargado)))
      +'</span></div>'
    : '';
  var cab= titulo+
   '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:10px">'
  +  '<input type="file" id="bkFile-'+k+'" accept=".xlsx" style="display:none" '
  +        'onchange="_bkCargarArchivo(\''+k+'\',this)">'
  +  '<button class="xb" onclick="document.getElementById(\'bkFile-'+k+'\').click()">'
  +    '<i class="ti ti-file-upload"></i> '+(d?'Cambiar archivo':'Cargar '+meta.t.toLowerCase())+'</button>'
  +  (d?'<span class="badge" style="background:var(--pastel-lila);color:var(--t-lila)">'
       +'<i class="ti ti-file-spreadsheet" style="font-size:10px"></i> '+_bkEsc(d.nombre)+'</span>':'')
  +  (d?'<button class="xb" onclick="_bkDescargar(\''+k+'\')">'
       +'<i class="ti ti-download"></i> Descargar</button>':'')
  +  (d && !d.solo
      ? '<button class="xb" style="color:var(--text-danger)" onclick="_bkQuitarDoc(\''+k+'\')">'
        +'<i class="ti ti-x"></i> Quitar</button>' : '')
  +  '<div style="flex:1"></div>'
  +  (d && d.solo
      ? '<button class="xb" onclick="_bkCerrarDetalle(\''+k+'\')">'
        +'<i class="ti ti-x"></i> Salir de la consulta</button>'
      : _bkCargados().length
      ? '<button class="lb" style="max-width:250px" onclick="_bkAbrirEnvio()">'
        +'<i class="ti ti-mail"></i> Guardar y enviar a gerencia</button>'
        +(_bkCargados().length<BK_DOCS.length
          ? '<span style="font-size:11px;color:var(--text-muted);margin-left:8px">'
            +'Faltan '+(BK_DOCS.length-_bkCargados().length)+'; se puede enviar con los que haya</span>' : '')
      : '<span style="font-size:11px;color:var(--text-muted)">Carga un archivo para poder enviar</span>')
  +'</div>'
  +'<div id="bkEstado-'+k+'"></div>';

  if(k==='cheques'){ _bkPintarCheques(cont); return; }

  if(!d){
    cont.innerHTML=cab+'<div class="empty">Sube el Excel del día en formato .xlsx. '
      +'Se abre con su formato original y podrás corregir o añadir líneas antes de enviarlo.</div>';
    return;
  }
  cont.innerHTML=cab
    + (d.solo
      ? '<div class="nota" style="background:var(--pastel-lila);color:var(--t-lila);margin-bottom:8px">'
        +'<i class="ti ti-lock"></i> Estás viendo la hoja tal como se envió el '+_bkEsc(d.solo)
        +'. Es solo consulta: no se puede editar ni volver a enviar. '
        +'Para trabajar con el día de hoy, carga el archivo de hoy.</div>'
      : '<p style="font-size:11px;color:var(--text-muted);margin:0 0 8px">'
        +'Las celdas en gris llevan fórmula y las calcula la hoja. Con <i class="ti ti-plus"></i> '
        +'añades una línea debajo, y los totales se ajustan solos.</p>')
    +'<div id="bkGrid-'+k+'" style="overflow:auto;max-height:64vh;border:1px solid var(--border);'
    +'border-radius:8px;background:#fff">'+_bkGridHTML(k)+'</div>';
}

function _bkEsc(s){
  return String(s==null?'':s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

// ── La rejilla, con el aspecto de la hoja ────────────────────────────────
function _bkGridHTML(k){
  var d=window._bkDoc[k], ws=d.ws;
  if(!d.ext) d.ext=_bkExtension(ws);
  // Se dibuja hasta donde hay datos, con un poco de aire para poder escribir
  // debajo. Antes se usaba ws.rowCount, que en un archivo con formato
  // sobrante son decenas de miles de filas vacías.
  var nCols=Math.max(d.ext.cols, 1), nFilas=Math.max(d.ext.filas+5, 1);

  // Celdas combinadas: la principal lleva el rowspan/colspan y las tapadas
  // no se pintan.
  var tapada={}, span={};
  ((ws.model&&ws.model.merges)||[]).forEach(function(rng){
    var m=/^([A-Z]+)(\d+):([A-Z]+)(\d+)$/.exec(String(rng)); if(!m) return;
    var c1=_bkColN(m[1]), f1=+m[2], c2=_bkColN(m[3]), f2=+m[4];
    span[_bkColS(c1)+f1]={cs:c2-c1+1, rs:f2-f1+1};
    for(var c=c1;c<=c2;c++) for(var f=f1;f<=f2;f++)
      if(!(c===c1&&f===f1)) tapada[_bkColS(c)+f]=true;
  });

  var h='<table style="border-collapse:collapse;font-size:11.5px;font-family:Arial,sans-serif">'
       +'<colgroup><col style="width:44px">';
  for(var c=1;c<=nCols;c++){
    var an=ws.getColumn(c).width;
    // min-width, no width: en Excel el ancho es en caracteres y aquí la
    // fuente es otra, así que se toma como mínimo y se deja que la columna
    // crezca si el contenido lo pide. Antes iba fijo y con overflow:hidden,
    // y los textos largos salían cortados a media palabra.
    h+='<col style="min-width:'+Math.max(46, Math.round((an||9)*7.6+10))+'px">';
  }
  h+='</colgroup><thead><tr>'
    +'<th style="position:sticky;top:0;background:var(--surface-1);border:1px solid #d0d0d0;z-index:2"></th>';
  for(var c2=1;c2<=nCols;c2++)
    h+='<th style="position:sticky;top:0;background:var(--surface-1);border:1px solid #d0d0d0;'
      +'font-size:10px;color:var(--text-muted);font-weight:600;z-index:2">'+_bkColS(c2)+'</th>';
  h+='</tr></thead><tbody>';

  for(var r=1;r<=nFilas;r++){
    var row=ws.getRow(r);
    h+='<tr>'
      +'<td style="background:var(--surface-1);border:1px solid #d0d0d0;text-align:center;'
      +'font-size:9.5px;color:var(--text-muted);white-space:nowrap">'+r
      +(d.solo ? '' :
        ' <span style="cursor:pointer;color:var(--t-azul)" title="Insertar una línea aquí" '
        +'onclick="_bkInsertar(\''+k+'\','+r+')">+</span>')+'</td>';
    for(var c3=1;c3<=nCols;c3++){
      var ref=_bkColS(c3)+r;
      if(tapada[ref]) continue;
      var cell=row.getCell(c3);
      var form=_bkFormula(cell);
      var esF = !!form;
      var err = d.errores[ref];
      var v=cell.value;
      var val = esF ? d.cache[ref]
              : (v && typeof v==='object' && !_bkEsFecha(v) && v.richText
                 ? v.richText.map(function(t){return t.text;}).join('') : v);
      var texto = err ? err : _bkFmtNum(val, cell.numFmt);

      var st='border:1px solid #d0d0d0;padding:1px 5px;white-space:nowrap;';
      var fo=cell.font||{};
      if(fo.bold) st+='font-weight:700;';
      if(fo.italic) st+='font-style:italic;';
      if(fo.size) st+='font-size:'+Math.min(Number(fo.size),16)+'px;';
      var colFuente=_bkArgb(fo.color); if(colFuente && colFuente!=='#000000') st+='color:'+colFuente+';';
      var relleno=cell.fill && cell.fill.fgColor ? _bkArgb(cell.fill.fgColor) : null;
      if(relleno && relleno!=='#FFFFFF') st+='background:'+relleno+';';
      var al=(cell.alignment&&cell.alignment.horizontal)
             || (typeof val==='number' ? 'right' : 'left');
      st+='text-align:'+al+';';
      if(err) st+='background:var(--pastel-error);color:var(--t-rojo);font-weight:700;';
      else if(esF) st+='background:#f4f4f4;color:#555;';

      var sp=span[ref]||{};
      var attr=(sp.cs>1?' colspan="'+sp.cs+'"':'')+(sp.rs>1?' rowspan="'+sp.rs+'"':'');

      if(d.solo || esF || err){
        h+='<td'+attr+' style="'+st+'" title="'+_bkEsc(form?('= '+form):'')+'">'+_bkEsc(texto)+'</td>';
      } else {
        h+='<td'+attr+' style="'+st+'padding:0"><input value="'+_bkEsc(texto)+'" '
          +'onchange="_bkEditar(\''+k+'\',\''+ref+'\',this.value)" '
          +'style="width:100%;min-width:100%;border:0;background:transparent;font:inherit;'
          +'color:inherit;text-align:inherit;padding:1px 5px;outline:none;box-sizing:border-box"></td>';
      }
    }
    h+='</tr>';
  }
  return h+'</tbody></table>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CARGAR, EDITAR, INSERTAR
// ═══════════════════════════════════════════════════════════════════════════
async function _bkCargarArchivo(k, input){
  var f=input && input.files && input.files[0];
  input.value='';
  if(!f) return;
  var est=document.getElementById('bkEstado-'+k);
  function msg(t,c){ if(est) est.innerHTML='<div class="nota" style="background:var(--pastel-'+(c||'azul')
      +');color:var(--t-'+(c==='error'?'rojo':'azul')+')">'+_bkEsc(t)+'</div>'; }

  if(/\.xls$/i.test(f.name)){
    msg('Ese archivo es .xls (Excel 97) y al pasar por el navegador pierde colores, bordes y '
       +'formatos. Ábrelo en Excel y usa Guardar como → Libro de Excel (.xlsx).','error');
    return;
  }
  try{
    msg('Abriendo '+f.name+'…');
    var ExcelJSlib=await _bkExcelJS();
    var wb=new ExcelJSlib.Workbook();
    await wb.xlsx.load(await f.arrayBuffer());
    var ws=wb.worksheets[0];                       // solo la primera hoja
    if(!ws) throw new Error('el archivo no tiene ninguna hoja');

    // Cargar un archivo nuevo sale de la consulta: ya no hay nada archivado
    // que devolver.
    if(window._bkPrevio) window._bkPrevio[k]=null;
    var d={nombre:f.name, tam:f.size, wb:wb, ws:ws, cache:{}, errores:{}, tocado:false,
           cargado:new Date().toISOString()};
    _bkRecachear(d);
    window._bkDoc[k]=d;
    if(est) est.innerHTML='';
    _bkPintarDoc(k);

    var nErr=Object.keys(d.errores).length;
    if(nErr) showT('Ojo: '+nErr+' celda(s) con fórmula rota en el archivo, marcadas en rojo.', 7000);
  }catch(e){
    msg('No se pudo abrir: '+(e.message||e),'error');
  }
}

function _bkEditar(k, ref, txt){
  var d=window._bkDoc[k]; if(!d) return;
  var cell=d.ws.getCell(ref);
  var eraFecha=_bkEsFecha(cell.value);
  var s=String(txt).trim();
  var val;
  if(s===''){
    val=null;
  } else if(eraFecha){
    // Si la celda era una fecha se intenta devolver una fecha: guardarla
    // como texto la sacaría de cualquier orden o cálculo por fecha.
    var m=/^(\d{1,2})[-\/]([A-Za-zÁÉÍÓÚáéíóú]{3,}|\d{1,2})[-\/](\d{2,4})$/.exec(s);
    var f=null;
    if(m){
      var mes=isNaN(Number(m[2])) ? MESES_ES.findIndex(function(x){
                 return x.slice(0,3).toLowerCase()===m[2].slice(0,3).toLowerCase(); })
             : Number(m[2])-1;
      var anio=Number(m[3]); if(anio<100) anio+=2000;
      if(mes>=0) f=new Date(Date.UTC(anio, mes, Number(m[1])));
    }
    val = f && !isNaN(f.getTime()) ? f : s;
  } else {
    // Un número escrito con separadores de miles o con B/. sigue siendo un
    // número: guardado como texto, los SUM lo ignorarían en silencio.
    var limpio=s.replace(/^B\/\.\s*/,'').replace(/,/g,'').replace(/\s+/g,'');
    val = /^-?\d+(\.\d+)?$/.test(limpio) ? Number(limpio) : s;
  }
  cell.value=val;
  d.tocado=true;
  _bkRecachear(d);
  var g=document.getElementById('bkGrid-'+k);
  if(g) g.innerHTML=_bkGridHTML(k);
}

function _bkInsertar(k, fila){
  var d=window._bkDoc[k]; if(!d) return;
  var ws=d.ws;
  ws.duplicateRow(fila, 1, true);          // copia el estilo de la fila modelo
  // Todas las fórmulas de la hoja se desplazan, igual que haría Excel. Se
  // toma cell.formula (ya traducida) para que las compartidas no se pierdan.
  // includeEmpty:false a propósito: una fórmula siempre vive en una celda que
  // existe, y recorrer las vacías en una hoja que declara 63.000 filas deja
  // el navegador clavado.
  ws.eachRow({includeEmpty:false}, function(row){
    row.eachCell({includeEmpty:false}, function(cell){
      var f=_bkFormula(cell);
      if(f) cell.value={formula:_bkDesplazar(f, fila), result:undefined};
    });
  });
  // La fila nueva queda con el formato del modelo pero en blanco. Sus
  // fórmulas propias sí se conservan, apuntando a SU fila: tras duplicar y
  // desplazar, la copia quedó referenciando la fila de abajo (la modelo),
  // así que sin esto un banco nuevo mostraría el saldo del banco siguiente.
  var reProp=new RegExp('(\\$?[A-Z]{1,3}\\$?)'+(fila+1)+'\\b','g');
  ws.getRow(fila).eachCell({includeEmpty:false}, function(cell){
    var f=_bkFormula(cell);
    if(f) cell.value={formula:String(f).replace(reProp, '$1'+fila), result:undefined};
    else  cell.value=null;
  });
  d.tocado=true;
  d.ext=null;                 // la hoja creció: hay que volver a medirla
  _bkRecachear(d);
  var g=document.getElementById('bkGrid-'+k);
  if(g) g.innerHTML=_bkGridHTML(k);
  showT('Línea insertada en la fila '+fila);
}

// ── El archivo de salida ─────────────────────────────────────────────────
async function _bkBuffer(k){
  var d=window._bkDoc[k];
  if(!d) throw new Error('falta el archivo de '+k);
  // Los cheques no vienen de un Excel subido: se arman con los datos de SAP.
  if(d.tipo==='datos') return await _bkChequesExcel(d);
  return await d.wb.xlsx.writeBuffer();
}
var BK_DIAS=['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
// "lunes 8 de septiembre de 2026, 10:35"
function _bkFechaHora(iso){
  if(!iso) return '';
  // Primero el caso "solo fecha". Es lo contrario de lo que parece: new Date
  // ('2026-09-09') SÍ es válida, pero la interpreta como medianoche UTC, y
  // leída en hora local de Panamá sale el día ANTERIOR a las 19:00. Por eso
  // hay que reconocerla antes de intentar parsearla.
  var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso).trim());
  if(m){
    var f=new Date(Number(m[1]), Number(m[2])-1, Number(m[3]));
    return BK_DIAS[f.getDay()]+' '+f.getDate()+' de '+MESES_ES[f.getMonth()].toLowerCase()
          +' de '+f.getFullYear();
  }
  var d=new Date(iso);
  if(isNaN(d.getTime())) return String(iso);
  return BK_DIAS[d.getDay()]+' '+d.getDate()+' de '+MESES_ES[d.getMonth()].toLowerCase()
    +' de '+d.getFullYear()+', '+_bkDosDig(d.getHours())+':'+_bkDosDig(d.getMinutes());
}
function _bkNombre(k, fecha){
  var m=BK_DOCS.find(function(x){return x.k===k;});
  // Los cheques se nombran con SU día (el anterior), no con el del envío.
  var d=window._bkDoc[k];
  if(k==='cheques' && d && d.fecha) return m.arch+'_'+d.fecha+'.xlsx';
  return m.arch+'_'+(fecha||new Date().toISOString().slice(0,10))+'.xlsx';
}
async function _bkDescargar(k){
  var buf=await _bkBuffer(k);
  var b=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(b); a.download=_bkNombre(k);
  document.body.appendChild(a); a.click();
  setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 1000);
}

// ═══════════════════════════════════════════════════════════════════════════
//  RESUMEN DE DISPONIBLES
//  Lo que gerencia quiere ver al abrir un día sin bajarse el Excel. Se saca
//  BUSCANDO LAS ETIQUETAS, no por número de fila: en esta pantalla se pueden
//  insertar bancos, y un resumen atado a "de la fila 4 a la 17" empezaría a
//  mentir en cuanto alguien añadiera uno.
// ═══════════════════════════════════════════════════════════════════════════
function _bkNorm(s){
  return String(s==null?'':s).toUpperCase()
    .replace(/[ÁÀÄÂ]/g,'A').replace(/[ÉÈËÊ]/g,'E').replace(/[ÍÌÏÎ]/g,'I')
    .replace(/[ÓÒÖÔ]/g,'O').replace(/[ÚÙÜÛ]/g,'U')
    .replace(/[^A-Z0-9]/g,'');
}

function _bkResumen(d){
  var ws=d.ws, cache=d.cache;
  // Una celda vacía se guarda como 0 en la caché, para que los SUM cuadren.
  // Aquí eso no sirve: hay que distinguir "vale cero" de "no hay nada
  // escrito". Sin esta distinción el recorrido no paraba en la fila de
  // totales y seguía leyendo hasta las hipotecas, y un banco sin disponible
  // anotado aparecía con 0.00 como si lo tuviera.
  var vacia=function(r,c){
    var cell=ws.getCell(_bkColS(c)+r);
    if(_bkFormula(cell)) return false;
    var v=cell.value;
    return v===null || v===undefined || v==='';
  };
  var txt=function(r,c){
    if(vacia(r,c)) return '';
    var v=cache[_bkColS(c)+r];
    // Un nombre de banco es texto. Si ahí hay un número, no es un nombre.
    if(typeof v!=='string') return '';
    return v.trim();
  };
  var num=function(r,c){
    if(vacia(r,c)) return null;
    var v=cache[_bkColS(c)+r];
    return typeof v==='number'?v:null;
  };
  var nFilas=Math.min(ws.rowCount, 200), nCols=Math.min(ws.columnCount, 20);

  // 1. La cabecera de la tabla de bancos: la fila que tiene BANCO y
  //    "Saldo disponible" a la vez. La tabla de monedas extranjeras repite
  //    los mismos títulos más abajo, así que vale la primera.
  var hFila=null, cBanco=null, cDisp=null, cLibro=null;
  for(var r=1; r<=nFilas && hFila===null; r++){
    var b=null, dsp=null, lib=null;
    for(var c=1;c<=nCols;c++){
      var t=_bkNorm(txt(r,c));
      if(t==='BANCO' && b===null) b=c;
      if(t==='SALDODISPONIBLE' && dsp===null) dsp=c;
      if(t==='SALDOSLIBRO' && lib===null) lib=c;
    }
    if(b!==null && dsp!==null){ hFila=r; cBanco=b; cDisp=dsp; cLibro=lib; }
  }
  if(hFila===null) return null;

  // 2. Los bancos, hasta el primer renglón sin nombre (la fila de totales).
  var bancos=[];
  for(var r2=hFila+1; r2<=nFilas; r2++){
    var nom=txt(r2,cBanco);
    if(!nom || /^TOTAL/.test(_bkNorm(nom))) break;
    bancos.push({banco:nom, disponible:num(r2,cDisp), libro:cLibro?num(r2,cLibro):null});
  }
  if(!bancos.length) return null;

  // 3. El bloque de sobregiro: cada etiqueta con el primer número que tenga
  //    a su derecha.
  var ETQ={'LIMITESGIRO':'Límite sobregiro','SGLIBRO':'S/G libro',
           'SGDISPONIBLE':'S/G disponible','DEPRETENIDO':'Depósito retenido',
           'SALDODISPBANCO':'Saldo disponible banco'};
  var sobregiro=[], pend=null, enPend=false;
  for(var r3=1; r3<=nFilas; r3++){
    for(var c3=1;c3<=nCols;c3++){
      var et=_bkNorm(txt(r3,c3));
      if(!et) continue;
      if(et==='PENDIENTES'){ enPend=true; continue; }
      var val=null;
      for(var c4=c3+1;c4<=Math.min(c3+3,nCols);c4++){
        var v=num(r3,c4); if(v!==null){ val=v; break; }
      }
      if(ETQ[et] && val!==null) sobregiro.push({etiqueta:ETQ[et], valor:val});
      else if(et==='TOTAL' && enPend && pend===null && val!==null) pend=val;
    }
  }

  var conValor=bancos.filter(function(b){ return typeof b.disponible==='number'; });
  return {
    bancos:bancos,
    // Esta suma la calcula el portal: el Excel no trae un total de la columna
    // de disponibles. Va etiquetada como tal para que nadie la tome por un
    // dato del archivo.
    suma: conValor.reduce(function(a,b){ return a+b.disponible; }, 0),
    conValor: conValor.length,
    sobregiro: sobregiro,
    pendientes: pend
  };
}

function _bkMoneda(v){
  if(typeof v!=='number') return '—';
  return (v<0?'-':'')+Math.abs(v).toLocaleString('en-US',
    {minimumFractionDigits:2, maximumFractionDigits:2});
}

function _bkResumenHTML(res){
  if(!res) return '<div style="font-size:12px;color:var(--text-muted)">'
    +'No se pudo sacar el resumen de este archivo.</div>';
  var h='<table class="tb" style="font-size:12px;max-width:470px"><thead><tr>'
    +'<th>Banco</th><th style="text-align:right">Disponible</th></tr></thead><tbody>'
    +res.bancos.map(function(b){
        var sin=typeof b.disponible!=='number';
        return '<tr><td'+(sin?' style="color:var(--text-muted)"':'')+'>'+_bkEsc(b.banco)+'</td>'
          +'<td style="text-align:right;font-variant-numeric:tabular-nums'
          +(sin?';color:var(--text-muted)':'')+'">'+(sin?'—':_bkMoneda(b.disponible))+'</td></tr>';
      }).join('')
    +'<tr style="font-weight:700;border-top:1.5px solid var(--border)">'
    +'<td>Suma de los '+res.conValor+' disponibles</td>'
    +'<td style="text-align:right;font-variant-numeric:tabular-nums">'+_bkMoneda(res.suma)+'</td></tr>'
    +'</tbody></table>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:4px">'
    +'La suma la calcula el portal: el Excel no trae un total de esa columna. '
    +'Los bancos con “—” no tienen disponible anotado en la hoja.</div>';
  if(res.sobregiro.length || res.pendientes!==null){
    h+='<div style="font-size:11px;color:var(--text-muted);margin:12px 0 5px;'
      +'text-transform:uppercase;font-weight:600">Sobregiro Banistmo</div>'
      +'<table class="tb" style="font-size:12px;max-width:470px"><tbody>'
      +res.sobregiro.map(function(s){
          return '<tr><td>'+_bkEsc(s.etiqueta)+'</td><td style="text-align:right;'
            +'font-variant-numeric:tabular-nums">'+_bkMoneda(s.valor)+'</td></tr>'; }).join('')
      +(res.pendientes!==null
         ? '<tr><td>Pendientes por aplicar</td><td style="text-align:right;'
           +'font-variant-numeric:tabular-nums">'+_bkMoneda(res.pendientes)+'</td></tr>' : '')
      +'</tbody></table>';
  }
  return h;
}

// ═══════════════════════════════════════════════════════════════════════════
//  GUARDAR Y ENVIAR
// ═══════════════════════════════════════════════════════════════════════════
// El diálogo sigue la misma estructura que mailAbrir(), el de las órdenes:
// su propia capa, el bloque DE, los destinatarios como fichas marcables y
// los mismos estilos. Antes usaba el modal genérico y salía descuadrado.
function _bkAbrirEnvio(){
  if(!_bkCargados().length){ showT('Carga al menos un archivo'); return; }
  var hoy=new Date().toISOString().slice(0,10);
  var f=new Date();
  var fLarga=f.getDate()+' de '+MESES_ES[f.getMonth()].toLowerCase()+' de '+f.getFullYear();

  // Destinatarios: gerencia. Copia: contabilidad, más lo que se escriba a
  // mano. Ninguna dirección va escrita en el código, así que si entra o sale
  // alguien del equipo esto lo sigue solo.
  function fichas(lista, clase, marcadas){
    return lista.map(function(u){
      return '<label style="display:flex;align-items:center;gap:6px;padding:5px 8px;'
        +'border:0.5px solid var(--border);border-radius:8px;cursor:pointer;font-size:12px;'
        +'background:var(--surface-2)">'
        +'<input type="checkbox" class="'+clase+'" value="'+_bkEsc(u.email)+'"'
        +(marcadas?' checked':'')+' style="margin:0;cursor:pointer">'
        +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')
        +';color:'+(u.tc||'#333')+';display:flex;align-items:center;justify-content:center;'
        +'font-size:9px;font-weight:600;flex-shrink:0">'
        +_bkEsc((u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
        +'<span>'+_bkEsc(u.name)+'</span></label>';
    }).join('');
  }
  // PARA: gerencia general, o sea los de rol gerencia SIN departamento.
  // Henry (ropa) y Gady (alfombras) son gerentes de su área, no destinatarios
  // de los saldos de la empresa. Se filtra por `dept` y no por sus correos:
  // así, si mañana entra otro gerente de departamento, queda fuera solo, y si
  // a alguno le quitan el departamento, entra sin tocar el código.
  var gers=(USERS||[]).filter(function(u){
    return u.email && u.role==='gerencia' && !u.dept; });
  var cont=(USERS||[]).filter(function(u){
    return u.email && u.role==='contabilidad' && u.email!==((CU&&CU.email)||''); });
  if(!gers.length){ showT('No hay ningún usuario de gerencia con correo configurado'); return; }

  // Qué se adjunta. Lo normal es mandar los dos, pero no se obliga.
  function docChk(k,label,hay){
    return '<label style="display:flex;align-items:center;gap:7px;padding:6px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:12px;'
      +'background:var(--surface-1);'+(hay?'cursor:pointer':'opacity:.5')+'">'
      +'<input type="checkbox" class="bk-doc" value="'+k+'"'+(hay?' checked':' disabled')
      +' onchange="_bkRevisarDocs()" style="margin:0">'
      +'<i class="ti ti-file-spreadsheet"></i><span>'+label+'</span>'
      +'<span style="color:var(--text-muted);font-size:11px">'
      +(hay?_bkEsc(_bkNombre(k,hoy)):'sin cargar')+'</span></label>';
  }

  var cuerpo='Buenos días,\n\nAdjunto los saldos bancarios y el reporte de préstamos al '
    +fLarga+'.\n\nSaludos,\n'+(CU?CU.name:'');

  var ov=document.createElement('div');
  ov.id='modalBkMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10000;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
      +'width:100%;max-width:660px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
      +'<div style="font-size:15px;font-weight:600"><i class="ti ti-mail" style="color:var(--text-accent)"></i>'
      +' Enviar los saldos del día</div>'
      +'<button onclick="_bkCerrarEnvio()" style="background:none;border:none;font-size:22px;'
      +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_bkEsc(CU?CU.name:'')+' &lt;'+_bkEsc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">'
      +'El correo sale con tu dirección, y las respuestas te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — gerencia</div>'
    +'<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'
      +fichas(gers,'bk-dest',true)+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">'
      +'COPIA — contabilidad'+(cont.length?'':' (nadie más configurado)')+'</div>'
    +(cont.length?'<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +fichas(cont,'bk-cc',false)+'</div>':'')
    +'<input id="bkCcExtra" placeholder="Otras direcciones en copia, separadas por coma" '
      +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);'
      +'box-sizing:border-box">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="bkAsunto" value="Saldos y préstamos bancarios · '+_bkEsc(fLarga)+'" '
      +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);'
      +'box-sizing:border-box">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="bkCuerpo2" rows="7" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);'
      +'border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);'
      +'color:var(--text-primary);box-sizing:border-box;font-family:inherit;resize:vertical">'
      +_bkEsc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">QUÉ SE ADJUNTA</div>'
    +'<div style="display:flex;flex-direction:column;gap:5px;margin-bottom:12px">'
      +BK_DOCS.map(function(m){ return docChk(m.k, m.t, !!window._bkDoc[m.k]); }).join('')
      +'</div>'

    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">'
      +'<input type="file" id="bkExtraFile" multiple style="display:none" '
      +'onchange="_bkAgregarExtra(this)">'
      +'<button class="xb" onclick="document.getElementById(\'bkExtraFile\').click()">'
      +'<i class="ti ti-paperclip"></i> Añadir otro archivo</button>'
      +'<span id="bkPeso" style="font-size:11px;color:var(--text-muted)"></span></div>'
    +'<div id="bkExtraLista" style="display:flex;flex-direction:column;gap:4px;'
      +'margin-bottom:12px">'+_bkExtraHTML()+'</div>'

    +'<div id="bkEnvEstado" style="font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_bkCerrarEnvio()">Cancelar</button>'
      +'<button class="btn bp" id="bk-btn" onclick="_bkEnviar()">'
      +'<i class="ti ti-send"></i> Guardar y enviar</button></div>'
  +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _bkCerrarEnvio(); });
  document.body.appendChild(ov);
  _bkPintarExtras();
}

// Avisa si se va a mandar uno solo teniendo los dos cargados: lo normal es
// que vayan juntos, y desmarcar uno sin querer es fácil.
function _bkRevisarDocs(){
  var sel=Array.prototype.slice.call(document.querySelectorAll('.bk-doc:checked'));
  var dis=Array.prototype.slice.call(document.querySelectorAll('.bk-doc:not(:disabled)'));
  var peso=_bkPesoAprox(), pasado=peso>BK_TOPE;

  var p=document.getElementById('bkPeso');
  if(p){
    p.style.color = pasado ? '#A32D2D' : 'var(--text-muted)';
    p.innerHTML = 'aprox. '+_bkTam(peso)+' de '+_bkTam(BK_TOPE)
                + (pasado ? ' · demasiado para un correo' : '');
  }

  var est=document.getElementById('bkEnvEstado'); if(!est) return;
  if(!sel.length){
    est.style.color='#A32D2D'; est.innerHTML='Marca al menos un archivo para enviar.';
  } else if(pasado){
    est.style.color='#A32D2D';
    est.innerHTML='Los adjuntos pesan demasiado. El correo saldría por Microsoft Graph, '
      +'que admite unos 3 MB en total. Quita alguno o mándalo aparte.';
  } else if(sel.length===1 && dis.length===2){
    est.style.color='var(--text-muted)';
    est.innerHTML='Vas a enviar solo '+(sel[0].value==='saldos'?'los saldos':'los préstamos')+'.';
  } else est.innerHTML='';
}

function _bkCerrarEnvio(){
  var m=document.getElementById('modalBkMail'); if(m) m.remove();
}

// ── Adjuntos extra ───────────────────────────────────────────────────────
// El worker manda los adjuntos dentro de la propia petición y Graph admite
// unos 3 MB en total, sin trocear. Pasarse no da un error al pulsar enviar:
// el correo entra en la cola y falla después, en el worker, donde nadie lo
// mira. Por eso el límite se comprueba aquí.
var BK_TOPE=2.2*1024*1024;      // bytes reales; en base64 crecen un 37%
window._bkExtra=window._bkExtra||[];

function _bkTam(n){
  return n>=1048576 ? (n/1048576).toFixed(1)+' MB' : Math.max(1,Math.round(n/1024))+' KB';
}
// Estimación para la pantalla: los .xlsx que se van a generar pesan más o
// menos como los que se cargaron. El cálculo exacto se hace al enviar, ya
// con los archivos generados.
function _bkPesoAprox(){
  var t=0;
  Array.prototype.slice.call(document.querySelectorAll('.bk-doc:checked')).forEach(function(c){
    var d=window._bkDoc[c.value];
    if(d && d.tam) t+=d.tam;
  });
  (window._bkExtra||[]).forEach(function(f){ t+=f.size; });
  return t;
}

function _bkExtraHTML(){
  var ex=window._bkExtra||[];
  return ex.map(function(f,i){
    return '<div style="display:flex;align-items:center;gap:8px;padding:6px 10px;'
      +'background:var(--surface-1);border-radius:8px;font-size:12px">'
      +'<i class="ti ti-paperclip"></i><span style="flex:1;overflow:hidden;'
      +'text-overflow:ellipsis;white-space:nowrap">'+_bkEsc(f.name)+'</span>'
      +'<span style="color:var(--text-muted);font-size:11px">'+_bkTam(f.size)+'</span>'
      +'<button class="xb" style="color:var(--text-danger);padding:2px 5px" '
      +'onclick="_bkQuitarExtra('+i+')"><i class="ti ti-x"></i></button></div>';
  }).join('');
}

function _bkAgregarExtra(input){
  var fs=input && input.files ? Array.prototype.slice.call(input.files) : [];
  input.value='';
  fs.forEach(function(f){
    if(!(window._bkExtra||[]).some(function(x){ return x.name===f.name && x.size===f.size; }))
      window._bkExtra.push(f);
  });
  _bkPintarExtras();
}
function _bkQuitarExtra(i){
  window._bkExtra.splice(i,1);
  _bkPintarExtras();
}
function _bkPintarExtras(){
  var c=document.getElementById('bkExtraLista');
  if(c) c.innerHTML=_bkExtraHTML();
  _bkRevisarDocs();
}

function _bkB64(buf){
  var b=new Uint8Array(buf), s='';
  for(var i=0;i<b.length;i+=0x8000) s+=String.fromCharCode.apply(null, b.subarray(i,i+0x8000));
  return btoa(s);
}

async function _bkEnviar(){
  var est=document.getElementById('bkEnvEstado');
  var btn=document.getElementById('bk-btn');
  function msg(t,tipo){
    if(!est) return;
    est.style.color = tipo==='ok' ? '#27500A' : (tipo==='err' ? '#A32D2D' : 'var(--text-muted)');
    est.innerHTML=_bkEsc(t);
  }
  var sel=function(q){ return Array.prototype.slice.call(document.querySelectorAll(q))
                              .map(function(c){ return c.value; }); };
  var para=sel('.bk-dest:checked');
  if(!para.length){ msg('Marca al menos un destinatario.','err'); return; }

  // Copia: los de contabilidad marcados más lo escrito a mano.
  var manual=String((document.getElementById('bkCcExtra')||{}).value||'')
               .split(/[,;\s]+/).map(function(s){return s.trim();}).filter(Boolean);
  var malas=manual.filter(function(e){ return !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e); });
  if(malas.length){ msg('Estas direcciones no parecen correos: '+malas.join(', '),'err'); return; }
  var cc=sel('.bk-cc:checked').concat(manual).filter(function(e,i,a){
    return a.indexOf(e)===i && para.indexOf(e)<0;   // sin repetir ni duplicar a los de PARA
  });

  var docs=sel('.bk-doc:checked');
  if(!docs.length){ msg('Marca al menos un archivo para enviar.','err'); return; }

  var hoy=new Date().toISOString().slice(0,10);
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  try{
    var MIME='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    var adj=[], fila={
      fecha:hoy, para:para, cc:cc,
      asunto:(document.getElementById('bkAsunto')||{}).value||'',
      enviado_por:CU?CU.name:'', enviado_en:new Date().toISOString(), estado:'pendiente'
    };

    for(var i=0;i<docs.length;i++){
      var k=docs[i];
      msg('Generando '+(k==='saldos'?'los saldos':'los préstamos')+'…');
      var buf=await _bkBuffer(k), nom=_bkNombre(k,hoy);
      adj.push({nombre:nom, contenido:_bkB64(buf), mime:MIME});
      msg('Guardando la copia de '+nom+'…');
      var ruta=await _subirDocStorage('bancos',k, new File([buf], nom, {type:MIME}));
      fila[k+'_nombre']=nom;
      fila[k+'_url']=ruta;
      // El resumen se guarda junto al envío para que gerencia lo vea al abrir
      // el día sin tener que bajarse el Excel ni recalcular nada.
      if(k==='saldos'){
        try{ fila.resumen=_bkResumen(window._bkDoc.saldos)||null; }catch(e){ fila.resumen=null; }
      }
    }

    // Los archivos que haya añadido el usuario, tal cual, sin tocarlos.
    var extra=window._bkExtra||[];
    fila.extras=[];
    for(var j=0;j<extra.length;j++){
      var fx=extra[j];
      msg('Adjuntando '+fx.name+'…');
      var bx=await fx.arrayBuffer();
      adj.push({nombre:fx.name, contenido:_bkB64(bx),
                mime:fx.type||'application/octet-stream'});
      var rx=await _subirDocStorage('bancos','extra', fx);
      fila.extras.push({nombre:fx.name, url:rx, tam:fx.size});
    }

    // La comprobación de verdad, ya con los archivos generados. La de la
    // pantalla era una estimación sobre el tamaño de los originales.
    // La vista previa se arma aquí, antes de pesar: el cuerpo viaja dentro
    // de la misma petición que los adjuntos y también cuenta para el límite.
    msg('Armando la vista previa del correo…');
    var cuerpoHtml=await _bkCuerpoConPrevia(
      (document.getElementById('bkCuerpo2')||{}).value||'', docs);

    var pesoReal=adj.reduce(function(a,x){ return a+Math.ceil(x.contenido.length*3/4); }, 0)
               + cuerpoHtml.length;
    if(pesoReal>BK_TOPE){
      throw new Error('Los adjuntos suman '+_bkTam(pesoReal)+' y el correo admite unos '
        +_bkTam(BK_TOPE)+'. Quita algún archivo y vuelve a enviar. '
        +'(La copia no se ha guardado.)');
    }

    // La copia entra como 'pendiente'. Solo pasa a 'enviado' cuando el correo
    // está en cola de verdad. Si se guardara ya como enviado y el correo
    // fallara, el historial diría que gerencia recibió algo que nunca salió.
    var r=await fetch(SB+'/rest/v1/'+BK_TABLA,{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok) throw new Error('no se pudo guardar la copia (estado '+r.status+')');
    var guardado=(await r.json())[0];

    msg('Poniendo el correo en cola…');
    // Los mismos campos que usa mailEnviar() para las órdenes. `docnum` es
    // obligatorio en correos_queue, y los envíos que no vienen de una orden
    // usan un prefijo, igual que 'PROV-' en los correos a proveedores.
    var base={
      docnum:'BANCOS-'+hoy,
      para_lista:para,
      para_email:para[0],
      asunto:fila.asunto,
      cuerpo:cuerpoHtml,
      adjuntos:adj,
      de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
      origen:'Saldos y préstamos bancarios',
      estado:'pendiente'
    };
    function _cola(b){
      return fetch(SB+'/rest/v1/correos_queue',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(b)
      });
    }
    // La cola de correos todavía no tiene columna de copia; el worker solo
    // usa el CORREOS_CC global. Se intenta con `cc_lista` por si ya está
    // puesta, y si la tabla la rechaza se mandan como destinatarios, que es
    // preferible a que el correo no le llegue a contabilidad.
    var rc, comoCopia=true;
    if(cc.length){
      rc=await _cola(Object.assign({}, base, {cc_lista:cc}));
      if(!rc.ok){
        comoCopia=false;
        rc=await _cola(Object.assign({}, base, {para_lista:para.concat(cc), para_email:para[0]}));
      }
    } else {
      rc=await _cola(base);
    }
    if(!rc.ok){
      var t=await rc.text();
      throw new Error('el correo no entró en cola: '+t.slice(0,160)
        +' · La copia queda guardada como pendiente en Envíos anteriores.');
    }

    try{
      await fetch(SB+'/rest/v1/'+BK_TABLA+'?id=eq.'+encodeURIComponent(guardado.id),
        {method:'PATCH', headers:SBH, body:JSON.stringify({estado:'enviado'})});
      guardado.estado='enviado';
    }catch(e){}

    // El calendario salta al mes de hoy y marca el día, para que el envío
    // recién hecho se vea sin buscarlo.
    window._bkExtra=[];      // el próximo envío empieza sin adjuntos sueltos
    var hy=new Date();
    window._bkCal={anio:hy.getFullYear(), mes:hy.getMonth(), dia:hoy};
    _bkCargarEnvios();
    _bkCerrarEnvio();
    showT('✓ Enviado a '+para.length+' destinatario(s)'
      +(cc.length?(comoCopia?(' con '+cc.length+' en copia'):(' y '+cc.length+' más, como destinatarios')):'')
      +'. La copia queda en Envíos anteriores.', 6000);
    try{ _accRegistrar('bancos','Envió '+docs.join(' y ')+' del '+hoy); }catch(e){}
  }catch(e){
    msg(e.message||String(e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Guardar y enviar'; }
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  ENVÍOS ANTERIORES · calendario
//  Un listado corrido se vuelve inmanejable en dos meses: son envíos de
//  todos los días. En calendario se ve de un vistazo qué días se mandó y
//  cuáles se saltaron, que es justo lo que hay que vigilar.
//  Se carga un mes por vez, así da igual que haya tres años de historia.
// ═══════════════════════════════════════════════════════════════════════════
window._bkCal=window._bkCal||{anio:new Date().getFullYear(), mes:new Date().getMonth(), dia:null};
window._bkMes=window._bkMes||[];

function _bkDosDig(n){ return ('0'+n).slice(-2); }
function _bkISO(a,m,d){ return a+'-'+_bkDosDig(m+1)+'-'+_bkDosDig(d); }

async function _bkCargarEnvios(){
  var c=window._bkCal;
  var desde=_bkISO(c.anio, c.mes, 1);
  var ultimo=new Date(c.anio, c.mes+1, 0).getDate();
  var hasta=_bkISO(c.anio, c.mes, ultimo);
  try{
    var r=await fetch(SB+'/rest/v1/'+BK_TABLA+'?select=*&fecha=gte.'+desde+'&fecha=lte.'+hasta
        +'&order=enviado_en.asc',
      {headers:Object.assign({},SBH,{'Cache-Control':'no-cache'}), cache:'no-store'});
    window._bkMes = r.ok ? await r.json() : [];
    window._bkMesError = r.ok ? null : ('estado '+r.status);
  }catch(e){ window._bkMes=[]; window._bkMesError=e.message||String(e); }
  if(window._bkTab==='envios') _bkPintarEnvios();
}

function _bkCalIr(delta){
  var c=window._bkCal;
  var d=new Date(c.anio, c.mes+delta, 1);
  c.anio=d.getFullYear(); c.mes=d.getMonth(); c.dia=null;
  _bkCargarEnvios();
}
function _bkCalAnio(a){ window._bkCal.anio=Number(a); window._bkCal.dia=null; _bkCargarEnvios(); }
function _bkCalMes(m){ window._bkCal.mes=Number(m);  window._bkCal.dia=null; _bkCargarEnvios(); }
function _bkCalDia(f){
  window._bkCal.dia = (window._bkCal.dia===f) ? null : f;
  _bkPintarEnvios();
}

function _bkPintarEnvios(){
  var cont=document.getElementById('bkCuerpo'); if(!cont) return;
  var c=window._bkCal, es=window._bkMes||[];

  // Los envíos del mes, agrupados por día
  var porDia={};
  es.forEach(function(e){ (porDia[e.fecha]=porDia[e.fecha]||[]).push(e); });

  var hoyISO=new Date().toISOString().slice(0,10);
  var ultimo=new Date(c.anio, c.mes+1, 0).getDate();
  var primerDia=new Date(c.anio, c.mes, 1).getDay();       // 0=domingo
  var offset=(primerDia+6)%7;                              // la semana empieza el lunes

  var anioAct=new Date().getFullYear();
  var anios=''; for(var a=anioAct+1; a>=anioAct-6; a--)
    anios+='<option value="'+a+'"'+(a===c.anio?' selected':'')+'>'+a+'</option>';
  var meses=MESES_ES.map(function(m,i){
    return '<option value="'+i+'"'+(i===c.mes?' selected':'')+'>'+m+'</option>'; }).join('');

  var h=
   '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:12px">'
  +  '<button class="xb" onclick="_bkCalIr(-1)"><i class="ti ti-chevron-left"></i></button>'
  +  '<select class="fi2" style="width:auto" onchange="_bkCalMes(this.value)">'+meses+'</select>'
  +  '<select class="fi2" style="width:auto" onchange="_bkCalAnio(this.value)">'+anios+'</select>'
  +  '<button class="xb" onclick="_bkCalIr(1)"><i class="ti ti-chevron-right"></i></button>'
  +  '<span style="font-size:11.5px;color:var(--text-muted);margin-left:6px">'
  +    es.length+' envío(s) este mes</span>'
  +'</div>';

  if(window._bkMesError){
    h+='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> No se pudo leer el historial ('
      +_bkEsc(window._bkMesError)+').</div>';
  }

  h+='<table style="width:100%;max-width:760px;border-collapse:separate;border-spacing:5px;'
    +'table-layout:fixed"><thead><tr>'
    +['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'].map(function(d){
        return '<th style="font-size:10.5px;color:var(--text-muted);font-weight:600;'
              +'text-transform:uppercase;padding-bottom:2px">'+d+'</th>'; }).join('')
    +'</tr></thead><tbody><tr>';

  for(var i=0;i<offset;i++) h+='<td></td>';
  for(var d=1; d<=ultimo; d++){
    if((offset+d-1)%7===0 && d!==1) h+='</tr><tr>';
    var f=_bkISO(c.anio,c.mes,d);
    var lista=porDia[f]||[];
    var pend=lista.some(function(e){ return e.estado!=='enviado'; });
    var sel=(c.dia===f);

    var st='height:56px;border-radius:9px;padding:5px 6px;vertical-align:top;'
          +'border:1px solid var(--border);';
    if(lista.length){
      st+= pend ? 'background:var(--pastel-error);border-color:var(--t-rojo);'
                : 'background:var(--pastel-ok);border-color:var(--t-verde);';
      st+='cursor:pointer;';
    } else {
      st+='background:var(--surface-1);color:var(--text-muted);';
    }
    if(sel) st+='outline:2px solid var(--text-accent);outline-offset:1px;';
    if(f===hoyISO) st+='box-shadow:inset 0 0 0 1.5px var(--text-accent);';

    h+='<td style="'+st+'"'+(lista.length?' onclick="_bkAbrirDia(\''+f+'\')"':'')+'>'
      +'<div style="font-size:12px;font-weight:'+(lista.length?'700':'400')+'">'+d+'</div>'
      +(lista.length
         ? '<div style="font-size:10px;margin-top:2px;color:'+(pend?'var(--t-rojo)':'var(--t-verde)')+'">'
           +'<i class="ti ti-'+(pend?'alert-triangle':'mail-check')+'" style="font-size:11px"></i>'
           +(lista.length>1?(' '+lista.length):'')+'</div>'
         : '')
      +'</td>';
  }
  var resto=(7-((offset+ultimo)%7))%7;
  for(var j=0;j<resto;j++) h+='<td></td>';
  h+='</tr></tbody></table>';

  // Detalle del día elegido
  if(c.dia && porDia[c.dia]){
    h+='<div style="margin-top:14px;border:0.5px solid var(--border);border-radius:var(--radius);'
      +'padding:12px;background:var(--surface-0)">'
      +'<div style="font-size:13px;font-weight:700;margin-bottom:8px">'
      +_bkEsc(c.dia)+' · '+porDia[c.dia].length+' envío(s)</div>'
      +porDia[c.dia].map(function(e){
        var para=Array.isArray(e.para)?e.para.join(', '):(e.para||'');
        var pend=e.estado!=='enviado';
        var hora=e.enviado_en?String(e.enviado_en).slice(11,16):'';
        return '<div style="border-top:0.5px solid var(--border);padding:9px 0">'
          +'<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:5px">'
          +(pend
            ? '<span class="badge" style="background:var(--pastel-error);color:var(--t-rojo)" '
              +'title="La copia se guardó pero el correo no llegó a salir">no enviado</span>'
            : '<span class="badge" style="background:var(--pastel-ok);color:var(--t-verde)">enviado</span>')
          +'<span style="font-size:12px">'+_bkEsc(e.enviado_por||'')
          +(hora?(' · '+hora):'')+'</span></div>'
          +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:6px">Para: '+_bkEsc(para)
          +(Array.isArray(e.cc)&&e.cc.length?('<br>Copia: '+_bkEsc(e.cc.join(', '))):'')
          +(_bkDocsDe(e).length<BK_DOCS.length
             ? '<br><span style="color:var(--t-marron)">Solo se envió '
               +_bkEsc(_bkDocsDe(e).map(function(m){ return m.t.toLowerCase(); }).join(', '))
               +'</span>' : '')
          +'</div>'
          +'<div style="display:flex;gap:6px;flex-wrap:wrap">'
          + _bkDocsDe(e).map(function(m){
              return '<a class="xb" href="'+DOCS_BASE+e[m.k+'_url']+'" target="_blank">'
                +'<i class="ti ti-file-spreadsheet"></i> '+_bkEsc(m.t)+'</a>'
                +'<button class="xb" onclick="_bkVerDetalle(\''+e.id+'\',\''+m.k+'\')">'
                +'<i class="ti ti-table"></i> Ver</button>';
            }).join('')
          + ((e.extras||[]).map(function(x){
                return x.url ? '<a class="xb" href="'+DOCS_BASE+x.url+'" target="_blank">'
                  +'<i class="ti ti-paperclip"></i> '+_bkEsc(x.nombre)+'</a>' : ''; }).join(''))
          + (_esGerencia()
              ? '<button class="xb" style="color:var(--text-danger)" '
                +'onclick="_bkBorrarEnvio(\''+e.id+'\')"><i class="ti ti-trash"></i> Borrar</button>' : '')
          +'</div>'
          + (e.resumen
             ? '<div style="margin-top:10px">'
               +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px;'
               +'text-transform:uppercase;font-weight:600">Saldos disponibles</div>'
               +_bkResumenHTML(e.resumen)+'</div>'
             : (_bkDocsDe(e).length
                ? '<div style="font-size:11.5px;color:var(--text-muted);margin-top:8px">'
                  +'Este envío es anterior al resumen automático. Pulsa “Ver detalle” '
                  +'para abrir la hoja completa.</div>' : ''))
          +'</div>';
      }).join('')
      +'</div>';
  } else if(es.length){
    h+='<p style="font-size:11.5px;color:var(--text-muted);margin-top:12px">'
      +'Pulsa un día marcado para ver los archivos que se enviaron.</p>';
  } else {
    h+='<div class="empty" style="margin-top:12px">Ningún envío en '
      +MESES_ES[c.mes]+' de '+c.anio+'.</div>';
  }
  cont.innerHTML=h;
}

async function _bkBorrarEnvio(id){
  var e=(window._bkMes||[]).find(function(x){return String(x.id)===String(id);});
  if(!e) return;
  if(!_esGerencia()){ showT('Solo gerencia puede borrar un envío guardado'); return; }
  if(!_confirmarBorrado('el envío del '+(e.fecha||''),
      e.estado==='enviado'
        ? 'El correo ya salió; esto solo borra la copia guardada en el portal.'
        : 'Ese envío quedó sin salir; esto borra la copia guardada.',
      ['los dos Excel adjuntos'])) return;
  var urls=BK_DOCS.map(function(m){ return e[m.k+'_url']; }).concat(
    (e.extras||[]).map(function(x){ return x.url; }));
  for(var u of urls) if(u) await _borrarArchivoStorage(u, null);
  try{
    var r=await fetch(SB+'/rest/v1/'+BK_TABLA+'?id=eq.'+encodeURIComponent(id),
      {method:'DELETE', headers:SBH});
    if(!r.ok) throw new Error('estado '+r.status);
  }catch(err){ showT('No se pudo borrar: '+(err.message||err)); return; }
  window._bkMes=(window._bkMes||[]).filter(function(x){return String(x.id)!==String(id);});
  _bkPintarEnvios();
  showT('✓ Envío eliminado');
}

// ═══════════════════════════════════════════════════════════════════════════
//  CONSULTAR UNA HOJA YA ENVIADA
//  Abre el Excel guardado en la misma rejilla, en solo lectura. Gerencia ve
//  el detalle completo sin bajarse el archivo, y sin riesgo de editar por
//  error algo que ya se mandó.
// ═══════════════════════════════════════════════════════════════════════════
window._bkPrevio=window._bkPrevio||{};

// Abrir un día = cargar todos sus archivos y enseñar el resumen, igual que
// al entrar en la pantalla. Antes había que pulsar el día, luego "Ver" en
// cada documento y saltar entre pestañas para ver lo mismo.
async function _bkAbrirDia(fecha){
  var delDia=(window._bkMes||[]).filter(function(x){ return x.fecha===fecha; });
  if(!delDia.length){ _bkCalDia(fecha); return; }
  var e=delDia[delDia.length-1];            // el último envío de ese día
  var docs=_bkDocsDe(e);
  if(!docs.length){ _bkCalDia(fecha); return; }

  window._bkCal.dia=fecha;
  showT('Abriendo el envío del '+_bkFechaHora(fecha)+'…');
  // Lo que estuviera cargado se guarda para devolverlo al salir
  for(var i=0;i<docs.length;i++){
    try{ await _bkVerDetalle(e.id, docs[i].k, true); }
    catch(err){ console.warn('[bancos] abrir día:', err); }
  }
  _bkIrA('resumen');
}

async function _bkVerDetalle(id, k, callado){
  var e=(window._bkMes||[]).find(function(x){ return String(x.id)===String(id); });
  if(!e){ if(!callado) showT('No se encontró el envío'); return; }
  var url=e[k+'_url'];
  if(!url){ if(!callado) showT('Ese envío no llevaba '+(k==='saldos'?'saldos':'préstamos')); return; }

  if(!callado) showT('Abriendo la hoja del '+(e.fecha||'')+'…');
  try{
    var ExcelJSlib=await _bkExcelJS();
    var r=await fetch(DOCS_BASE+url);
    if(!r.ok) throw new Error('no se pudo descargar (estado '+r.status+')');
    var wb=new ExcelJSlib.Workbook();
    await wb.xlsx.load(await r.arrayBuffer());
    var ws=wb.worksheets[0];
    if(!ws) throw new Error('el archivo guardado no tiene hojas');

    // Lo que hubiera cargado el usuario se guarda aparte, para devolvérselo
    // al salir de la consulta. Perder el trabajo del día por mirar el de
    // ayer sería un mal negocio.
    if(!window._bkPrevio[k]) window._bkPrevio[k]=window._bkDoc[k]||null;

    var d={nombre:e[k+'_nombre']||url.split('/').pop(), wb:wb, ws:ws,
           cache:{}, errores:{}, tocado:false,
           // `solo` guarda CUÁNDO se envió, no solo el día: es lo que se
           // pinta al lado del título y en la pestaña.
           solo:(e.enviado_en||e.fecha||'')};
    _bkRecachear(d);
    window._bkDoc[k]=d;
    // Al abrir un día guardado se enseña el resumen, que es la vista útil;
    // desde ahí se salta a la hoja concreta si hace falta.
    if(!callado) _bkIrA('resumen');
  }catch(err){
    if(!callado) showT('No se pudo abrir: '+(err.message||err), 6000);
    else console.warn('[bancos] no se pudo abrir el archivo del día:', err);
  }
}

function _bkCerrarDetalle(k){
  window._bkDoc[k]=window._bkPrevio[k]||null;
  window._bkPrevio[k]=null;
  _bkPintarDoc(k);
}

// Quitar de la pantalla el archivo que se estaba preparando. Antes, una vez
// cargado no había forma de sacarlo: si te equivocabas de archivo o decidías
// no enviar nada, la hoja se quedaba ahí puesta.
function _bkQuitarDoc(k){
  var d=window._bkDoc[k];
  if(!d) return;
  if(d.tocado && !confirm('Ese archivo tiene cambios sin enviar.\n\n¿Lo quitas igual?')) return;
  window._bkDoc[k]=null;
  if(window._bkPrevio) window._bkPrevio[k]=null;
  _bkPintarDoc(k);
  var meta=BK_DOCS.find(function(x){ return x.k===k; });
  showT('Se quitó '+(meta?meta.t.toLowerCase():'el archivo')+' de la pantalla');
}




/* ═══════════════════════════════════════════════════════════════════════════
   IMPORTAR LA LISTA DE PENDIENTES DE CONTABILIDAD
   ───────────────────────────────────────────────────────────────────────────
   Contabilidad lleva su propio Excel ("Listado de Transferencias · Pagos a
   proveedores") con lo único que tiene pendiente de abonar o cancelar. Esto
   lo lee y crea en el portal las solicitudes que falten, como si compras se
   las hubiera pedido.

   LEE EL ARCHIVO, NO UNA TRANSCRIPCIÓN. Al intentar sacar las cifras del
   escaneo la suma daba 1.280.770,23 contra los 1.280.568,23 impresos: 202
   dólares de diferencia por un dígito mal leído. En una lista de pagos eso
   es una solicitud por el importe equivocado. Aquí los números salen del
   .xlsx y, antes de proponer nada, se comprueba que la columna VALOR sume
   exactamente el TOTAL que trae el propio archivo. Si no cuadra, no sigue.

   NO CREA NADA SIN QUE SE VEA. Primero muestra fila por fila qué orden
   encontró y qué va a hacer. Las coincidencias exactas vienen marcadas; las
   dudosas y las que no encuentra orden, sin marcar, para que las mire una
   persona.
   ═══════════════════════════════════════════════════════════════════════════ */

// El botón de esta pantalla se quitó de la barra de arriba: para esta lista
// se usa el SQL (solicitudes_solo_listado.sql), que no depende del navegador.
// El código sigue aquí por si hace falta el importador desde Excel otra vez.
// Para devolver el botón, en renderApp(), junto al de "Reporte abonos y
// cancelaciones", volver a poner:
//   ${_impPuede()?`<button class="nb" style="color:var(--t-indigo)"
//     onclick="_impAbrir()"><i class="ti ti-file-import"></i>
//     Importar pendientes de contabilidad</button>`:''}
function _impPuede(){
  return !!CU && (CU.role==='contabilidad' || CU.role==='gerencia');
}

// ── Referencias de orden ────────────────────────────────────────────────
// En la columna FACTURA la referencia viene de mil formas: "DKC26016",
// "DKC026049", "GKC-26/63", "DKC25114/26011/26053". Se sacan todas.
// En la columna FACTURA la referencia viene de mil formas: "DKC26016",
// "DKC026049", "GKC-26/63", "DKC25114/26011/26053". Se capturan el prefijo y
// los dígitos que le siguen, TAL CUAL: en DKC26016 el cero no es relleno,
// es parte del número (año 26, orden 016). Quitarlo daba DKC2616 y ninguna
// orden coincidía.
// Un separador como mucho, y entre dos grupos de dígitos: si no, en
// "DKC25114/26011" se tragaba la barra y salía DKC2511426011.
var IMP_REF=/\b([DSGW]KC)[\s\-\/]?(\d{2,4})[\s\-\/]?(\d{1,5})\b/gi;

function _impNorm(s){
  return String(s==null?'':s).toUpperCase().replace(/[^A-Z0-9]/g,'');
}

// Devuelve los candidatos de una celda. Para cada referencia se ofrecen dos
// formas: la literal y otra sin el cero que algunos escriben después del
// prefijo (DKC026049 ↔ DKC26049). El cruce prueba las dos.
function _impRefs(txt){
  var t=String(txt||''), out=[], m;
  function push(v){ v=_impNorm(v); if(v && out.indexOf(v)<0) out.push(v); }

  IMP_REF.lastIndex=0;
  var pref='';
  while((m=IMP_REF.exec(t))){
    var p=m[1].toUpperCase(), dig=(m[2]+m[3]).replace(/[^\d]/g,'');
    if(!pref) pref=p;
    push(p+dig);
    if(/^0\d/.test(dig)) push(p+dig.replace(/^0+/,''));   // DKC026049 → DKC26049
  }
  // "DKC25114/26011/26053": tras la primera, las siguientes van sin prefijo
  if(pref){
    var cola=t.split(new RegExp(pref,'i')).slice(1).join(' ');
    (cola.match(/[\/,]\s*(\d{5})\b/g)||[]).forEach(function(x){
      push(pref+x.replace(/[^\d]/g,''));
    });
  }
  return out;
}

// Una orden puede llamarse por su DocNum de SAP o por su referencia DKC.
// Se compara con las dos, y se dice CÓMO se encontró: exacta o aproximada.
function _impBuscarOrden(refs, facturaTxt){
  var lista=(typeof orders!=='undefined' && orders) ? orders : [];
  var i, o, n;
  // 1. Coincidencia exacta contra la referencia del proveedor (NumAtCard)
  for(i=0;i<lista.length;i++){
    o=lista[i]; n=_impNorm(o.num_proveedor);
    if(!n) continue;
    for(var j=0;j<refs.length;j++){
      if(n===_impNorm(refs[j])) return {o:o, como:'exacta', ref:refs[j]};
    }
  }
  // 2. Exacta contra el número de orden de SAP
  for(i=0;i<lista.length;i++){
    o=lista[i];
    for(var k=0;k<refs.length;k++){
      if(_impNorm(o.id)===_impNorm(refs[k])) return {o:o, como:'exacta', ref:refs[k]};
    }
  }
  // 3. Aproximada: los mismos dígitos aunque cambien ceros o separadores.
  //    Nunca se marca sola; la confirma una persona.
  for(i=0;i<lista.length;i++){
    o=lista[i]; n=_impNorm(o.num_proveedor);
    if(!n) continue;
    for(var q=0;q<refs.length;q++){
      var r=_impNorm(refs[q]);
      var dn=n.replace(/^[A-Z]+/,'').replace(/^0+/,'');
      var dr=r.replace(/^[A-Z]+/,'').replace(/^0+/,'');
      if(dn && dn===dr && n.slice(0,3)===r.slice(0,3))
        return {o:o, como:'aproximada', ref:refs[q]};
    }
  }
  return null;
}

// ── Leer el Excel ───────────────────────────────────────────────────────
async function _impLeer(file){
  var ExcelJSlib=await _bkExcelJS();
  var wb=new ExcelJSlib.Workbook();
  await wb.xlsx.load(await file.arrayBuffer());
  var ws=wb.worksheets[0];
  if(!ws) throw new Error('el archivo no tiene ninguna hoja');

  var val=function(r,c){
    var v=ws.getCell(_bkColS(c)+r).value;
    if(v===null||v===undefined) return '';
    if(typeof v==='object'){
      if(v.richText) return v.richText.map(function(t){return t.text;}).join('');
      if(v.text!==undefined) return v.text;
      if(v.result!==undefined) return v.result;
      if(v.error) return '';
      return '';
    }
    return v;
  };
  var num=function(r,c){
    var v=val(r,c);
    if(typeof v==='number') return v;
    var s=String(v).replace(/[^\d.,\-]/g,'').replace(/,/g,'');
    var n=parseFloat(s);
    return isNaN(n)?null:n;
  };

  var nF=Math.min(ws.rowCount,400), nC=Math.min(ws.columnCount,30);

  // Las columnas se buscan por su título, no por posición: el Excel de
  // contabilidad cambia de orden de columnas entre versiones.
  var col={}, hFila=null;
  var QUIERO={'PROVEEDOR':'prov','FACTURA':'fact','VALOR':'valor','DPTO':'dept',
              'DEPARTAMENTO':'dept','CONCEPTO':'concepto','STATUS':'status',
              'ESTATUS':'status','FECHAETA':'eta','ETA':'eta'};
  for(var r=1;r<=nF && hFila===null;r++){
    var hall={};
    for(var c=1;c<=nC;c++){
      var t=_bkNorm(val(r,c));
      if(QUIERO[t] && hall[QUIERO[t]]===undefined) hall[QUIERO[t]]=c;
    }
    if(hall.prov!==undefined && hall.valor!==undefined && hall.concepto!==undefined){
      hFila=r; col=hall;
    }
  }
  if(hFila===null)
    throw new Error('No encontré la cabecera. La hoja debe tener columnas '
      +'PROVEEDOR, FACTURA, VALOR, DPTO y CONCEPTO.');

  var filas=[], totalArchivo=null;
  for(var r2=hFila+1;r2<=nF;r2++){
    var prov=String(val(r2,col.prov)||'').trim();
    var v=num(r2,col.valor);
    if(/^TOTAL/i.test(_bkNorm(prov)) || /^TOTAL/i.test(_bkNorm(String(val(r2,col.fact===undefined?col.prov:col.fact))))){
      if(v!==null) totalArchivo=v;
      continue;
    }
    // El TOTAL a veces está suelto, sin etiqueta en la columna de proveedor
    if(!prov){
      if(v!==null && totalArchivo===null){
        for(var cc=1;cc<=nC;cc++){
          if(/^TOTAL/i.test(_bkNorm(val(r2,cc)))){ totalArchivo=v; break; }
        }
      }
      continue;
    }
    if(v===null) continue;
    var concepto=_bkNorm(val(r2,col.concepto));
    filas.push({
      prov:prov,
      factura:String(col.fact!==undefined?val(r2,col.fact):'').trim(),
      monto:v,
      dept:String(col.dept!==undefined?val(r2,col.dept):'').trim(),
      concepto:concepto.indexOf('ABONO')>=0?'abono':'cancelacion',
      conceptoTxt:String(col.concepto!==undefined?val(r2,col.concepto):'').trim(),
      status:String(col.status!==undefined?val(r2,col.status):'').trim(),
      eta:String(col.eta!==undefined?val(r2,col.eta):'').trim(),
      fila:r2
    });
  }
  if(!filas.length) throw new Error('No encontré ninguna fila con datos.');

  // LA COMPROBACIÓN. Si la columna no suma el total del propio archivo, algo
  // se leyó mal y no se puede proponer nada: son solicitudes de pago.
  var suma=filas.reduce(function(a,f){ return a+f.monto; },0);
  if(totalArchivo!==null && Math.abs(suma-totalArchivo)>0.02){
    throw new Error('La columna VALOR suma '+_bkMoneda(suma)+' y el TOTAL del archivo dice '
      +_bkMoneda(totalArchivo)+' (diferencia '+_bkMoneda(Math.abs(suma-totalArchivo))+'). '
      +'No sigo: con una lista de pagos, leer mal una cifra significa pedir el importe '
      +'equivocado. Revisa el archivo o mándamelo tal cual.');
  }
  return {filas:filas, total:totalArchivo, suma:suma};
}


// ── La pantalla ─────────────────────────────────────────────────────────
window._impDatos=null;

function _impAbrir(){
  if(!_impPuede()){ showT('Esto es de contabilidad y gerencia'); return; }
  var ov=document.createElement('div');
  ov.id='modalImp';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10000;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
      +'width:100%;max-width:1040px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:600">'
      +'<i class="ti ti-file-import" style="color:var(--text-accent)"></i> '
      +'Importar los pendientes de contabilidad</div>'
      +'<button onclick="_impCerrar()" style="background:none;border:none;font-size:22px;'
      +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<p style="font-size:12px;color:var(--text-secondary);margin:0 0 12px;line-height:1.5">'
      +'Sube el Excel de contabilidad («Listado de transferencias · Pagos a proveedores») '
      +'en formato .xlsx. Se busca cada fila entre las órdenes del portal —abiertas y '
      +'cerradas— y se te muestra qué encontró antes de crear nada.</p>'
    +'<div style="display:flex;gap:8px;align-items:center;margin-bottom:12px">'
      +'<input type="file" id="impFile" accept=".xlsx" style="display:none" onchange="_impCargar(this)">'
      +'<button class="xb" onclick="document.getElementById(\'impFile\').click()">'
      +'<i class="ti ti-file-upload"></i> Elegir el Excel</button>'
      +'</div>'
    +'<div id="impEstado" style="font-size:12px;margin-bottom:10px;line-height:1.5"></div>'
    +'<div id="impCuerpo"></div>'
  +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _impCerrar(); });
  document.body.appendChild(ov);
}
function _impCerrar(){
  var m=document.getElementById('modalImp'); if(m) m.remove();
  window._impDatos=null;
}
function _impMsg(t,tipo){
  var e=document.getElementById('impEstado'); if(!e) return;
  e.style.color = tipo==='err' ? '#A32D2D' : (tipo==='ok' ? '#27500A' : 'var(--text-muted)');
  e.innerHTML=_bkEsc(t);
}

// Con qué docnum se guarda una fila. Se decide AQUÍ y en un solo sitio:
// antes el nombre se calculaba al crear pero no al comparar, así que una fila
// sin orden se creaba y a la pasada siguiente se contaba como sobrante y se
// borraba. Cuadrar dos veces seguidas daba resultados distintos.
function _impDocnum(f){
  if(f.orden) return String(f.orden.id);
  return f.refs[0] || ('SIN-SAP-'+String(f.factura||f.prov).slice(0,18));
}

// Lo que el portal tiene vivo y el listado no menciona
// Con `todo` en true entran también las ya pagadas y las cerradas: hace falta
// cuando el listado no es "lo que falta por pagar" sino "lo único que debe
// existir". Sin eso quedaban en pantalla cosas de listados viejos, como la
// orden de Oriental Weavers de 144 mil.
function _impSobrantes(d, todo){
  var enLista={}, yaCasadas={};
  d.filas.forEach(function(f){
    enLista[_impDocnum(f)+'|'+f.concepto]=true;
    // Una fila del listado puede haberse reconocido por proveedor y monto,
    // sin compartir número de orden. Si solo se mirara el docnum, esa misma
    // solicitud se daba por buena y acto seguido se borraba por "sobrante".
    if(f.existente && f.existente.id!=null) yaCasadas[String(f.existente.id)]=true;
  });
  return (window._solPago||[]).filter(function(x){
    if(enLista[String(x.docnum)+'|'+String(x.tipo)]) return false;
    if(x.id!=null && yaCasadas[String(x.id)]) return false;
    if(todo) return true;
    return !_pgCerrada(x)
      && String(x.estado||'')!=='abono_enviado'
      && String(x.estado||'')!=='cancelacion_realizada';
  });
}

// Cruza y pinta, venga de donde venga
function _impPreparar(d){
  d.filas.forEach(function(fl){
    fl.refs=_impRefs(fl.factura);
    var h=_impBuscarOrden(fl.refs, fl.factura);
    fl.orden = h ? h.o : null;
    fl.como  = h ? h.como : null;
    var dn=_impDocnum(fl);
    fl.existente = (window._solPago||[]).find(function(x){
      return String(x.docnum)===dn && String(x.tipo)===fl.concepto && !_pgCerrada(x);
    }) || null;
    fl.yaExiste = !!fl.existente;
    // Si ya está pero por otro importe, no hay que duplicarla: hay que
    // corregirle el monto, o el portal seguiría sin cuadrar con contabilidad.
    fl.montoDistinto = !!(fl.existente
      && Math.abs((Number(fl.existente.monto)||0) - fl.monto) > 0.005);
    fl.marcar = !!(fl.orden && fl.como==='exacta' && !fl.yaExiste);
  });
  window._impDatos=d;
  _impMsg('Leídas '+d.filas.length+' filas · '+_bkMoneda(d.suma)
    +(d.total!==null?' · cuadra con el total':' · sin total que comprobar')
    +(d.fuente?(' · de '+d.fuente):''),'ok');
  _impPintar();
}

async function _impCargar(input){
  var f=input && input.files && input.files[0];
  input.value='';
  if(!f) return;
  if(/\.xls$/i.test(f.name)){
    _impMsg('Ese archivo es .xls. Ábrelo en Excel y usa Guardar como → Libro de Excel (.xlsx).','err');
    return;
  }
  try{
    _impMsg('Leyendo '+f.name+'…');
    var d=await _impLeer(f);
    d.fuente='el archivo '+f.name;
    _impPreparar(d);
  }catch(e){
    _impMsg(e.message||String(e),'err');
    var c=document.getElementById('impCuerpo'); if(c) c.innerHTML='';
  }
}

function _impPintar(){
  var d=window._impDatos, c=document.getElementById('impCuerpo');
  if(!d||!c) return;

  var nEx=d.filas.filter(function(f){return f.como==='exacta';}).length;
  var nAp=d.filas.filter(function(f){return f.como==='aproximada';}).length;
  var nNo=d.filas.filter(function(f){return !f.orden;}).length;
  var nYa=d.filas.filter(function(f){return f.yaExiste;}).length;

  // Lo que el portal cree pendiente y no está en el Excel de contabilidad
  var sobran=_impSobrantes(d);

  var h='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px;font-size:11.5px">'
    +'<span class="badge" style="background:var(--pastel-ok);color:var(--t-verde)">'+nEx+' con orden exacta</span>'
    +(nAp?'<span class="badge" style="background:var(--pastel-aviso);color:var(--t-marron)">'+nAp+' aproximadas</span>':'')
    +(nNo?'<span class="badge" style="background:var(--pastel-error);color:var(--t-rojo)">'+nNo+' sin orden</span>':'')
    +(nYa?'<span class="badge" style="background:var(--pastel-gris);color:var(--text-muted)">'+nYa+' ya existen</span>':'')
    +'</div>'
    +'<div style="overflow:auto;max-height:46vh;border:1px solid var(--border);border-radius:8px">'
    +'<table class="tb" style="font-size:11.5px"><thead><tr>'
    +'<th style="width:30px"><input type="checkbox" onchange="_impTodas(this.checked)"></th>'
    +'<th>Proveedor</th><th>Factura</th><th>Orden</th><th>Depto</th>'
    +'<th>Concepto</th><th style="text-align:right">Monto</th><th>Qué se hará</th>'
    +'</tr></thead><tbody>';

  d.filas.forEach(function(f,i){
    var acc, col;
    if(f.yaExiste){ acc='Ya hay una solicitud viva'; col='var(--text-muted)'; }
    else if(f.orden && f.como==='exacta'){ acc='Crear solicitud en la orden'; col='var(--t-verde)'; }
    else if(f.orden){ acc='Coincidencia dudosa — revisa'; col='var(--t-marron)'; }
    else { acc='Sin orden: se crea como pendiente de subir a SAP'; col='var(--t-rojo)'; }

    h+='<tr'+(f.yaExiste?' style="opacity:.55"':'')+'>'
      +'<td><input type="checkbox" class="imp-chk" data-i="'+i+'"'
        +(f.marcar?' checked':'')+(f.yaExiste?' disabled':'')+'></td>'
      +'<td>'+_bkEsc(f.prov)+'</td>'
      +'<td style="font-size:10.5px;color:var(--text-muted)">'+_bkEsc(f.factura||'—')+'</td>'
      +'<td>'+(f.orden
          ? '<b>'+_bkEsc(f.orden.id)+'</b>'
            +(f.orden.num_proveedor?('<br><span style="font-size:10px;color:var(--text-muted)">'
              +_bkEsc(f.orden.num_proveedor)+'</span>'):'')
            +(f.orden.cerradaSap?'<br><span style="font-size:9.5px;color:var(--t-lila)">cerrada en SAP</span>':'')
          : '<span style="color:var(--t-rojo)">'+_bkEsc(f.refs.join(', ')||'sin referencia')+'</span>')+'</td>'
      +'<td>'+_bkEsc(f.orden?dL(f.orden.dept):f.dept)+'</td>'
      +'<td>'+(f.concepto==='abono'?'Abono':'Cancelación')+'</td>'
      +'<td style="text-align:right;font-variant-numeric:tabular-nums">'+_bkMoneda(f.monto)+'</td>'
      +'<td style="font-size:10.5px;color:'+col+'">'+_bkEsc(acc)+'</td></tr>';
  });
  h+='</tbody></table></div>';

  if(sobran.length){
    h+='<div style="margin-top:12px;border:1px solid #E0A82E;border-radius:9px;padding:10px 12px;'
      +'background:var(--pastel-aviso)">'
      +'<div style="font-size:12px;color:var(--t-marron);line-height:1.5;margin-bottom:7px">'
      +'<b>'+sobran.length+' solicitud(es) del portal no están en esta lista.</b> Si la de '
      +'contabilidad es la buena, es que ya no están pendientes.</div>'
      +'<label style="display:flex;gap:8px;align-items:center;cursor:pointer;font-size:12px;'
      +'color:var(--t-marron);margin-bottom:4px">'
      +'<input type="radio" name="impSobras" value="no" checked onchange="_impVerSobras()"> '
      +'Dejarlas como están</label>'
      +'<label style="display:flex;gap:8px;align-items:center;cursor:pointer;font-size:12px;'
      +'color:var(--t-marron);margin-bottom:4px">'
      +'<input type="radio" name="impSobras" value="pagar" onchange="_impVerSobras()"> '
      +'Darlas por pagadas · salen de las alertas y queda el registro</label>'
      +'<label style="display:flex;gap:8px;align-items:center;cursor:pointer;font-size:12px;'
      +'color:var(--text-danger)">'
      +'<input type="radio" name="impSobras" value="borrar" onchange="_impVerSobras()"> '
      +'Borrarlas del portal · no se puede deshacer</label>'
      +'<div style="font-size:10.5px;color:var(--t-marron);opacity:.85;margin-top:6px">'
      + _bkEsc(sobran.map(function(x){ return (x.proveedor||'?')+' #'+x.docnum
          +' '+_bkMoneda(Number(x.monto)||0); }).join(' · '))
      +'</div></div>';
  }

  var nCrear=d.filas.filter(function(f){ return !f.yaExiste; }).length;
  var nAjustar=d.filas.filter(function(f){ return f.montoDistinto; }).length;

  h+='<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;'
    +'margin-top:14px;flex-wrap:wrap">'
    +'<span style="font-size:10.5px;color:var(--text-muted);flex:1;min-width:200px">'
    +'Crea las '+nCrear+' que faltan'
    +(nAjustar?(', corrige el monto de '+nAjustar):'')
    +'. Lo que sobre se decide en las opciones de arriba.</span>'
    +'<span style="display:flex;gap:8px">'
    +'<button class="btn" onclick="_impCerrar()">Cancelar</button>'
    +'<button class="btn bp" id="imp-btn" onclick="_impAplicar()">'
    +'<i class="ti ti-check"></i> Solo lo marcado</button></span></div>';

  c.innerHTML=h;
}

// La opción de las sobrantes se lee al aplicar, así que aquí no hay que
// repintar nada; existe para que el onchange no falle.
function _impVerSobras(){}

// Reemplazo completo: el listado de contabilidad manda. Crea todo lo que
// falta (con orden o sin ella), corrige los montos que no coincidan y borra
// del portal lo que el listado no menciona.
function _impTodas(v){
  Array.prototype.slice.call(document.querySelectorAll('.imp-chk')).forEach(function(ch){
    if(!ch.disabled) ch.checked=v;
  });
}

async function _impAplicar(yaConfirmado){
  var d=window._impDatos; if(!d) return;
  var sel=Array.prototype.slice.call(document.querySelectorAll('.imp-chk:checked'))
            .map(function(ch){ return d.filas[Number(ch.getAttribute('data-i'))]; });
  var quePasa=(document.querySelector('input[name="impSobras"]:checked')||{}).value||'no';
  if(!sel.length && quePasa==='no'){ _impMsg('No hay nada marcado.','err'); return; }

  var btn=document.getElementById('imp-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Creando…'; }

  var hechas=0, fallos=[];
  for(var i=0;i<sel.length;i++){
    var f=sel[i];
    _impMsg('Creando '+(i+1)+' de '+sel.length+'…');
    try{
      // Ya existe con otro importe: se corrige, no se duplica
      if(f.existente){
        if(f.montoDistinto){
          var okm=await _solPagoPatch(f.existente.id, {monto:Number(f.monto)||0});
          if(okm){ f.existente.monto=Number(f.monto)||0; hechas++; }
          else fallos.push(f.prov+': no se pudo corregir el monto');
        }
        continue;
      }
      if(f.orden){
        // Igual que si compras la pidiera desde la orden
        var nota='Importada del listado de contabilidad del '
          + new Date().toLocaleDateString('es-PA')
          + (f.factura?(' · factura '+f.factura):'')
          + (f.status?(' · '+f.status):'');
        var res=await _solPagoCrear(f.orden.id, f.concepto, f.monto, nota);
        if(res) hechas++; else fallos.push(f.prov+': no se pudo crear');
      }else{
        // Sin orden en SAP: se guarda igual, marcada para que alguien la suba
        var fila={
          docnum: f.refs[0] || ('SIN-SAP-'+(f.factura||f.prov).slice(0,18)),
          tipo:f.concepto, proveedor:f.prov, dkc:(f.refs[0]||''),
          dept:String(f.dept||'').toLowerCase()||null,
          monto:Number(f.monto)||0, eta:null,
          nota:'PENDIENTE DE SUBIR A SAP LA ORDEN · importada del listado de contabilidad'
               +(f.factura?(' · factura '+f.factura):''),
          estado:'pendiente',
          solicitado_por:(CU&&CU.name)||'', solicitado_en:new Date().toISOString()
        };
        var r=await fetch(SB+'/rest/v1/solicitudes_pago',{
          method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
          body:JSON.stringify(fila)});
        if(r.ok){
          var cr=null; try{ cr=await r.json(); }catch(e){}
          (window._solPago=window._solPago||[]).unshift((cr&&cr[0])||fila);
          hechas++;
        } else fallos.push(f.prov+': error '+r.status);
      }
    }catch(e){ fallos.push(f.prov+': '+(e.message||e)); }
  }

  var cerradas=0;
  if(quePasa!=='no'){
    // Desde el cuadre completo se borra todo lo ajeno al listado; desde la
    // opción manual, solo lo que sigue pendiente.
    var sobran=_impSobrantes(d, !!yaConfirmado && quePasa==='borrar');
    if(quePasa==='borrar' && !yaConfirmado
       && !confirm('Vas a BORRAR '+sobran.length+' solicitud(es) del portal.\n\n'
        +'No se puede deshacer. ¿Sigo?')) quePasa='no';
    for(var s=0;s<sobran.length && quePasa!=='no';s++){
      _impMsg((quePasa==='borrar'?'Borrando ':'Cerrando ')+(s+1)+' de '+sobran.length+'…');
      try{
        if(quePasa==='borrar'){
          var rd=await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+encodeURIComponent(sobran[s].id),
            {method:'DELETE', headers:SBH});
          if(rd.ok){
            window._solPago=(window._solPago||[]).filter(function(x){ return x.id!==sobran[s].id; });
            cerradas++;
          }
        } else {
          var ok=await _solPagoPatch(sobran[s].id, {
            pagado:true, pagado_en:new Date().toISOString(),
            pagado_por:(CU&&CU.name)||''
          });
          if(ok){ sobran[s].pagado=true; cerradas++; }
        }
      }catch(e){}
    }
  }

  // La comprobación que importa: ¿el portal dice ahora lo mismo que el
  // listado? Decir "listo, 24 creadas" no prueba nada; esto sí.
  var vivas=(window._solPago||[]).filter(function(x){
    // Tras el cuadre completo no debe quedar NADA fuera del listado, ni
    // siquiera pagadas: por eso se cuentan todas.
    return yaConfirmado ? true
      : (!_pgCerrada(x)
         && String(x.estado||'')!=='abono_enviado'
         && String(x.estado||'')!=='cancelacion_realizada');
  });
  var sumaPortal=vivas.reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
  var cuadra = vivas.length===d.filas.length && Math.abs(sumaPortal-d.suma)<0.02;

  _impMsg('Listo: '+hechas+' solicitud(es) creada(s) o corregida(s)'
    +(cerradas?(' y '+cerradas+(quePasa==='borrar'?' borrada(s)':' dada(s) por pagada(s)')):'')
    +(fallos.length?(' · '+fallos.length+' con problemas: '+fallos.slice(0,3).join(' · ')):'')
    +' — El portal queda con '+vivas.length+' pendientes por '+_bkMoneda(sumaPortal)
    +'; el listado dice '+d.filas.length+' por '+_bkMoneda(d.suma)+'. '
    +(cuadra?'CUADRA.':'NO CUADRA todavía: revisa la lista de arriba.'),
    (fallos.length||!cuadra)?'err':'ok');
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-check"></i> Crear las solicitudes marcadas'; }

  try{ if(document.getElementById('page-alertas')) rAlertas(); }catch(e){}
  try{ if(document.getElementById('page-completadas')) rCompletadas(); }catch(e){}
  try{ _accRegistrar('reporteabonos','Importó '+hechas+' solicitudes del listado de contabilidad'); }catch(e){}
  if(!fallos.length && cuadra) setTimeout(_impCerrar, 3500);
  else _impPreparar(d);      // se repinta con el estado nuevo, para ver qué falta
}


/* ═══════════════════════════════════════════════════════════════════════════
   MANTENIMIENTO · poner las alertas y los avisos a cero
   ───────────────────────────────────────────────────────────────────────────
   Hay dos cosas distintas y conviene no confundirlas:

   LOS AVISOS son mensajes guardados en la tabla `menciones`: los que salen en
   la campana y sobreviven a la recarga. Esos SÍ se pueden borrar y no vuelven.

   LAS ALERTAS de órdenes no están guardadas en ninguna parte: buildAlerts()
   las calcula cada vez a partir del estado de las órdenes. "Borrarlas" no
   existe: mientras una orden lleve treinta días sin depósito, su alerta se
   vuelve a dibujar en la siguiente carga. Lo que sí desaparece es lo que ya
   se arregló, como las solicitudes pagadas del punto 6.

   Por eso esto borra los avisos y deja las alertas recalculándose limpias.
   ═══════════════════════════════════════════════════════════════════════════ */

function _mantPuede(){ return !!CU && CU.role==='gerencia' && !CU.dept; }

async function _mantBorrarAvisos(){
  if(!_mantPuede()){ showT('Solo gerencia general puede hacer esto'); return; }

  var n='?';
  try{
    var rc=await fetch(SB+'/rest/v1/menciones?select=id',{headers:SBH});
    if(rc.ok) n=(await rc.json()).length;
  }catch(e){}

  if(!_confirmarBorrado(
      'TODOS los avisos guardados del portal ('+n+')',
      'Esto vacía la campana de todos los usuarios, no solo la tuya. '
      +'Las alertas de órdenes no se borran porque no se guardan: se vuelven a '
      +'calcular solas, y solo desaparecen las que ya estén resueltas.',
      ['los avisos y menciones de todos los usuarios',
       'el historial de quién avisó a quién'])) return;

  showT('Borrando los avisos…');
  try{
    // PostgREST exige un filtro para borrar en masa; id no nulo los coge todos
    var r=await fetch(SB+'/rest/v1/menciones?id=not.is.null',{method:'DELETE',headers:SBH});
    if(!r.ok){
      var t=await r.text();
      throw new Error('estado '+r.status+' · '+t.slice(0,140));
    }
  }catch(e){
    showT('No se pudieron borrar: '+(e.message||e), 7000);
    return;
  }

  // Y lo que está en memoria en esta sesión
  try{ notifications.length=0; }catch(e){}
  try{ window._menPend=[]; }catch(e){}
  try{ if(typeof renderApp==='function') renderApp(); }catch(e){}

  showT('✓ Avisos borrados ('+n+'). Las alertas de órdenes se recalculan solas.', 7000);
  try{ _accRegistrar('mantenimiento','Borró todos los avisos del portal ('+n+')'); }catch(e){}
}


/* ═══════════════════════════════════════════════════════════════════════════
   PRODUCT CREATION SHEET · dentro de la orden
   ───────────────────────────────────────────────────────────────────────────
   La hoja se hace a partir de la proforma de una orden concreta, así que vive
   dentro de la orden y no en una pantalla aparte de la barra de arriba.
   Sirve igual para las órdenes de SAP y para las Borrador: las dos tienen su
   id en `orders`, y la hoja se guarda con ese id en la columna `orden`.
   ═══════════════════════════════════════════════════════════════════════════ */

// A qué orden pertenece lo que se está subiendo (null = suelta)
window._pcsOrden = window._pcsOrden || null;

function _pcsHojasDe(oid){
  return (window._pcsHojas||[]).filter(function(h){
    return String(h.orden||'')===String(oid);
  });
}

// La barra que se ve dentro de la orden
function _pcsBarraOrden(o){
  try{
    if(!o || !_pcsPuede()) return '';
    var n=_pcsHojasDe(o.id).length;
    return '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;'
      +'background:'+(n?'var(--pastel-lila)':'var(--surface-1)')+';'
      +'border:0.5px '+(n?'solid #C9BEF0':'dashed var(--border)')+';border-radius:8px;'
      +'padding:6px 11px;margin-bottom:8px">'
      +'<i class="ti ti-table-plus" style="font-size:13px;color:'
      +(n?'var(--t-lila)':'var(--text-muted)')+'"></i>'
      +'<span style="font-size:11px;color:'+(n?'var(--t-lila)':'var(--text-muted)')+';flex:1">'
      +'Product Creation Sheet <span style="opacity:.75">· formato de Ropa</span>'
      +(n?(' · '+n+' hoja'+(n>1?'s':'')+' de esta orden'):' · sin hojas todavía')+'</span>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10px" '
      +'onclick="event.stopPropagation();_pcsAbrirDeOrden(\''+_esc(String(o.id))+'\')">'
      +'<i class="ti ti-table-plus"></i> '+(n?'Ver / añadir':'Crear hoja')+'</button></div>';
  }catch(e){ console.warn('[pcs] barra de orden:',e); return ''; }
}

// El panel, en su propia capa para no pelearse con el modal de la orden
async function _pcsAbrirDeOrden(oid){
  if(!_pcsPuede()){ showT('Esta opción es del departamento de Ropa'); return; }
  window._pcsOrden=String(oid);
  if(!(window._pcsHojas||[]).length){
    try{ await _pcsCargar(); }catch(e){}
  }
  var o=(typeof orders!=='undefined'?orders:[]).find(function(x){ return String(x.id)===String(oid); });

  var ov=document.createElement('div');
  ov.id='modalPcsOrden';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10050;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
      +'width:100%;max-width:900px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">'
      +'<div style="font-size:15px;font-weight:600">'
      +'<i class="ti ti-table-plus" style="color:var(--t-lila)"></i> Product Creation Sheet</div>'
      +'<button onclick="_pcsCerrarOrden()" style="background:none;border:none;font-size:22px;'
      +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:12px;color:var(--text-muted);margin-bottom:12px">'
      +'Orden '+_esc(String(oid))+(o?(' · '+_esc(o.prov||'')):'')
      +(o&&o.num_proveedor?(' · '+_esc(o.num_proveedor)):'')+'</div>'
    +'<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:10px">'
      +'<input type="file" id="pcsFileOrden" multiple style="display:none" '
      +'accept=".pdf,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.webp" onchange="_pcsSubir(this)">'
      +'<button class="xb" onclick="document.getElementById(\'pcsFileOrden\').click()">'
      +'<i class="ti ti-file-upload"></i> Subir la proforma del proveedor</button>'
      +'<span style="flex:1"></span>'
      +'<button class="xb" onclick="_pcsCerrarOrden();go(\'pcs\')">'
      +'<i class="ti ti-list"></i> Ver todas las hojas</button></div>'
    +'<div id="pcsEstado"></div>'
    +'<div id="pcsListaOrden"></div>'
  +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _pcsCerrarOrden(); });
  document.body.appendChild(ov);
  _pcsPintarListaOrden();
}

function _pcsCerrarOrden(){
  var m=document.getElementById('modalPcsOrden'); if(m) m.remove();
  window._pcsOrden=null;
}

function _pcsPintarListaOrden(){
  var cont=document.getElementById('pcsListaOrden'); if(!cont) return;
  var hs=_pcsHojasDe(window._pcsOrden);
  if(!hs.length){
    cont.innerHTML= window._pcsTrabajando
      ? '<div class="empty">Leyendo el documento. No cierres esta ventana.</div>'
      : '<div class="empty">Todavía no hay hojas para esta orden. '
        +'Sube la proforma en PDF, Excel o foto.</div>';
    return;
  }
  cont.innerHTML='<table class="tb"><thead><tr>'
   +'<th>Orden prov.</th><th>Proveedor</th><th>Marca</th><th style="text-align:right">Líneas</th>'
   +'<th style="text-align:right">Piezas</th><th style="text-align:right">Monto</th>'
   +'<th>Creada por</th><th style="width:96px"></th></tr></thead><tbody>'
   +hs.map(function(h){
      var ls=h.lineas||[];
      var pzs=ls.reduce(function(a,l){return a+(Number(l.piezas)||0);},0);
      var mto=ls.reduce(function(a,l){return a+(Number(l.piezas)||0)*(Number(l.precio)||0);},0);
      return '<tr style="cursor:pointer" onclick="_pcsAbrir(\''+h.id+'\')">'
        +'<td style="font-weight:600">'+_pcsEsc(h.po||'—')+'</td>'
        +'<td>'+_pcsEsc(h.proveedor||'—')+'</td>'
        +'<td>'+_pcsEsc(h.marca||'—')+'</td>'
        +'<td style="text-align:right">'+ls.length+'</td>'
        +'<td style="text-align:right">'+pzs.toLocaleString('en-US')+'</td>'
        +'<td style="text-align:right">USD '+mto.toLocaleString('en-US',
            {minimumFractionDigits:2,maximumFractionDigits:2})+'</td>'
        +'<td style="font-size:11px;color:var(--text-muted)">'+_pcsEsc(h.creado_por||'')+'</td>'
        +'<td style="white-space:nowrap">'
        +'<button class="xb" title="Descargar Excel" onclick="event.stopPropagation();'
        +'_pcsExcel(\''+h.id+'\')"><i class="ti ti-file-spreadsheet"></i></button>'
        +(_pcsPuedeBorrar(h)
          ? '<button class="xb" title="Borrar la hoja" style="color:var(--text-danger)" '
            +'onclick="event.stopPropagation();_pcsBorrar(\''+h.id+'\')">'
            +'<i class="ti ti-trash"></i></button>' : '')
        +'</td></tr>';
    }).join('')
   +'</tbody></table>';
}

/* ═══════════════════════════════════════════════════════════════════════════
   REPORTE DE ABONOS Y CANCELACIONES · edición y filtros
   ═══════════════════════════════════════════════════════════════════════════ */

// ── La celda de ETA ─────────────────────────────────────────────────────
// No puede ser solo un calendario: en la hoja de contabilidad esa columna
// lleva fechas de verdad ("15-sep-26") pero también textos como
// "PREVIO DESPACHO", "ANTES DE ARRIBO" o "S/F". Así que se deja escribir a
// mano Y se pone un calendario al lado para las que sí son fechas.
var SOL_MESES=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

function _solEtaCelda(x){
  var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
  var txt = x.eta_texto || x.eta || '';
  if(!puede) return _esc(txt);
  // El icono llevaba el input escondido con pointer-events:none, así que el
  // clic nunca le llegaba y no pasaba nada. Ahora el input está encima del
  // icono, transparente pero clicable, y además se le pide el selector
  // nativo con showPicker() donde el navegador lo admite.
  var iid='soleta-'+(x.id||0);
  return '<span style="display:inline-flex;align-items:center;gap:5px">'
    + _solEditable(x,'eta',txt)
    + '<span onclick="_solEtaAbrir(\''+iid+'\')" '
    + 'style="position:relative;display:inline-flex;width:17px;height:17px;'
    + 'align-items:center;justify-content:center;cursor:pointer;color:var(--text-muted)" '
    + 'title="Elegir una fecha del calendario">'
    + '<i class="ti ti-calendar" style="font-size:13px;pointer-events:none"></i>'
    + '<input id="'+iid+'" type="date" onchange="_solEtaFecha('+(x.id||0)+',this.value)" '
    + 'style="position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;'
    + 'cursor:pointer;border:0;padding:0;margin:0">'
    + '</span></span>';
}

// Abre el selector nativo. showPicker() existe en Chrome y Edge modernos;
// donde no, el clic en el input transparente ya lo abre solo.
function _solEtaAbrir(id){
  var inp=document.getElementById(id);
  if(!inp) return;
  try{ if(typeof inp.showPicker==='function'){ inp.showPicker(); return; } }catch(e){}
  try{ inp.focus(); inp.click(); }catch(e){}
}

// Del calendario al formato de la hoja: 2026-09-15 → 15-sep-26
function _solEtaFecha(id, iso){
  if(!iso) return;
  var p=String(iso).split('-');
  if(p.length!==3) return;
  var txt=p[2]+'-'+SOL_MESES[Number(p[1])-1]+'-'+p[0].slice(-2);
  var x=(window._solPago||[]).find(function(s){ return String(s.id)===String(id); });
  if(!x) return;
  _solPagoPatch(id, {eta_texto:txt}).then(function(ok){
    if(ok){ x.eta_texto=txt; x.eta=null; _solRepintarDondeEste(); showT('ETA: '+txt); }
    else showT('No se pudo guardar la ETA');
  });
}

// ── Aviso de cambios sin guardar ────────────────────────────────────────
// La edición guarda al salir de la celda, pero eso no se ve. Ahora la celda
// se pone en ámbar mientras hay algo escrito sin guardar y aparece un botón
// para confirmarlo, que es lo que la gente busca.
function _solMarcarSucio(el){
  if(!el) return;
  var sucio = String(el.textContent||'') !== String(el.dataset.orig||'');
  el.style.background = sucio ? 'var(--pastel-aviso)' : '';
  var id=el.getAttribute('data-id');
  var b=document.getElementById('solguardar-'+id);
  if(b) b.style.display = sucio ? 'inline-flex' : 'none';
  window._solSucio = sucio ? true : window._solSucio;
}
function _solLimpiarSucio(el){
  if(!el) return;
  el.style.background='';
  var b=document.getElementById('solguardar-'+el.getAttribute('data-id'));
  if(b) b.style.display='none';
}
// El botón: fuerza el guardado de lo que esté abierto en esa fila
function _solGuardarFila(id){
  var celdas=document.querySelectorAll('[data-id="'+id+'"][contenteditable]');
  Array.prototype.slice.call(celdas).forEach(function(el){
    if(String(el.textContent||'')!==String(el.dataset.orig||'')) el.blur();
  });
  var b=document.getElementById('solguardar-'+id);
  if(b) b.style.display='none';
  showT('Guardado');
}
function _solBotonGuardar(x){
  var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
  if(!puede) return '';
  return '<button id="solguardar-'+(x.id||0)+'" onclick="_solGuardarFila(\''+(x.id||0)+'\')" '
    +'style="display:none;align-items:center;gap:3px;background:var(--t-verde);color:#fff;'
    +'border:none;border-radius:6px;padding:2px 7px;font-size:9.5px;font-weight:700;'
    +'cursor:pointer" title="Guardar los cambios de esta fila">'
    +'<i class="ti ti-device-floppy" style="font-size:11px"></i> Guardar</button>';
}

// ── Filtros por columna ─────────────────────────────────────────────────
window._solFiltros = window._solFiltros || {};

function _solSetFiltro(campo, valor){
  if(valor===''||valor==null) delete window._solFiltros[campo];
  else window._solFiltros[campo]=valor;
  _solPagoPanel();
  // Devuelve el cursor a la casilla que se estaba escribiendo
  var el=document.getElementById('solf-'+campo);
  if(el && el.tagName==='INPUT'){ el.focus();
    try{ el.setSelectionRange(el.value.length, el.value.length); }catch(e){} }
}
function _solLimpiarFiltros(){ window._solFiltros={}; _solPagoPanel(); }

function _solPasaFiltros(x){
  var f=window._solFiltros||{};
  var como=function(v, q){ return String(v==null?'':v).toLowerCase()
                                 .indexOf(String(q).toLowerCase())>=0; };
  if(f.proveedor && !como(x.proveedor, f.proveedor)) return false;
  if(f.orden){
    var h=_solOrdenDe(x);
    var texto=[x.docnum, x.dkc, h?h.o.id:'', h?h.o.prov:'', h?h.o.num_proveedor:''].join(' ');
    if(!como(texto, f.orden)) return false;
  }
  if(f.dept && String(x.dept||'')!==f.dept) return false;
  if(f.tipo && String(x.tipo||'')!==f.tipo) return false;
  if(f.eta && !como(x.eta_texto||x.eta||'', f.eta)) return false;
  if(f.estado && !como(_esDelExcel(x)?(x.estado_excel||''):_solEstadoLabel(x).t, f.estado)) return false;
  if(f.solicitado_por && !como(x.solicitado_por, f.solicitado_por)) return false;
  if(f.financiado){
    var fin = x.financiado===true?'si':(x.financiado===false?'no':'—');
    if(fin!==f.financiado) return false;
  }
  // "Por pagar" cuenta también las que están sin marcar, igual que la
  // pastilla de arriba. Exigir un "No" explícito dejaba la lista vacía.
  if(f.pagado==='si' && !_solPagadaYa(x)) return false;
  if(f.pagado==='no' &&  _solPagadaYa(x)) return false;
  if(f.montoMin!=null && f.montoMin!=='' && (Number(x.monto)||0) < Number(f.montoMin)) return false;
  if(f.montoMax!=null && f.montoMax!=='' && (Number(x.monto)||0) > Number(f.montoMax)) return false;
  return true;
}

function _solFilaFiltros(){
  var f=window._solFiltros||{};
  var caja=function(campo, ph, ancho){
    return '<input id="solf-'+campo+'" value="'+_esc(f[campo]||'')+'" placeholder="'+_esc(ph)+'" '
      +'oninput="_solSetFiltro(\''+campo+'\',this.value)" '
      +'style="width:'+(ancho||'100%')+';box-sizing:border-box;font-size:10px;padding:2px 5px;'
      +'border:0.5px solid var(--border);border-radius:5px;background:var(--surface-0)">';
  };
  var lista=function(campo, ops){
    return '<select id="solf-'+campo+'" onchange="_solSetFiltro(\''+campo+'\',this.value)" '
      +'style="width:100%;box-sizing:border-box;font-size:10px;padding:2px 4px;'
      +'border:0.5px solid var(--border);border-radius:5px;background:var(--surface-0)">'
      + ops.map(function(o){
          return '<option value="'+_esc(o.v)+'"'+((f[campo]||'')===o.v?' selected':'')+'>'
            +_esc(o.t)+'</option>'; }).join('')
      +'</select>';
  };
  var td=function(h){ return '<td style="padding:3px 5px;background:var(--surface-1)">'+h+'</td>'; };

  return '<tr>'
    + td(caja('proveedor','Buscar…'))
    + td(caja('orden','Orden, DKC…'))
    + td(lista('dept',[{v:'',t:'Todos'}].concat(DEPTS_ALL.map(function(d){
          return {v:d,t:dL(d)}; }))))
    + td('<div style="display:flex;gap:3px">'
         +caja('montoMin','Desde','50%')+caja('montoMax','Hasta','50%')+'</div>')
    + td(lista('tipo',[{v:'',t:'Todos'},{v:'abono',t:'Abono'},{v:'cancelacion',t:'Cancelación'}]))
    + td(caja('eta','Fecha…'))
    + td(caja('estado','Estado…'))
    + td(caja('solicitado_por','Quién…'))
    + td(lista('financiado',[{v:'',t:'—'},{v:'si',t:'Sí'},{v:'no',t:'No'}]))
    + td(lista('pagado',[{v:'',t:'—'},{v:'si',t:'Pagada'},{v:'no',t:'Por pagar'}]))
    + td('')                      // la columna del botón de borrar
    +'</tr>';
}

/* ═══════════════════════════════════════════════════════════════════════════
   VISTA PREVIA DE LOS ADJUNTOS EN EL CUERPO DEL CORREO
   ───────────────────────────────────────────────────────────────────────────
   Hasta ahora contabilidad pegaba a mano capturas de pantalla de cada hoja
   dentro del correo, además de adjuntar los archivos. Esto lo hace solo, y
   en vez de una imagen genera la TABLA en HTML: se ve nítida a cualquier
   tamaño, se puede copiar, y pesa una fracción de lo que pesa un PNG.

   El HTML va con estilos en cada celda y sin variables CSS: Outlook de
   escritorio usa el motor de Word, que ignora las hojas de estilo y las
   variables. Lo que no va en el atributo style de la propia celda, se pierde.
   ═══════════════════════════════════════════════════════════════════════════ */

// Convierte un color de ExcelJS a #RRGGBB, o null si no hay
function _bkColorCorreo(c){
  var h=_bkArgb(c);
  return (h && h.toUpperCase()!=='#FFFFFF') ? h : null;
}

// La tabla de una hoja, lista para meter en un correo
function _bkTablaCorreo(d, titulo){
  var ws=d.ws;
  if(!d.ext) d.ext=_bkExtension(ws);
  var ultFila=d.ext.filas, ultCol=d.ext.cols;
  if(!ultCol || !ultFila) return '';

  var tapada={}, span={};
  ((ws.model&&ws.model.merges)||[]).forEach(function(rng){
    var m=/^([A-Z]+)(\d+):([A-Z]+)(\d+)$/.exec(String(rng)); if(!m) return;
    var c1=_bkColN(m[1]), f1=+m[2], c2=_bkColN(m[3]), f2=+m[4];
    span[_bkColS(c1)+f1]={cs:c2-c1+1, rs:f2-f1+1};
    for(var c=c1;c<=c2;c++) for(var f=f1;f<=f2;f++)
      if(!(c===c1&&f===f1)) tapada[_bkColS(c)+f]=true;
  });

  var h='<div style="margin:0 0 26px 0">'
    +'<div style="font:700 15px Arial,sans-serif;color:#1a1a18;margin:0 0 7px 0">'
    +_bkEsc(titulo)+'</div>'
    +'<table cellspacing="0" cellpadding="0" border="0" '
    +'style="border-collapse:collapse;font:11px Arial,sans-serif;color:#1a1a18">';

  for(var r2=1;r2<=ultFila;r2++){
    var fila='', algo=false;
    for(var c3=1;c3<=ultCol;c3++){
      var ref=_bkColS(c3)+r2;
      if(tapada[ref]) continue;
      var cell=ws.getCell(ref);
      var form=_bkFormula(cell);
      var val = form ? d.cache[ref]
              : (cell.value && typeof cell.value==='object' && !_bkEsFecha(cell.value)
                 && cell.value.richText
                 ? cell.value.richText.map(function(t){return t.text;}).join('') : cell.value);
      var err=d.errores[ref];
      var texto = err ? err : _bkFmtNum(val, cell.numFmt);
      if(texto!=='') algo=true;

      var st='border:1px solid #d4d4d4;padding:2px 6px;white-space:nowrap;';
      var fo=cell.font||{};
      if(fo.bold) st+='font-weight:700;';
      if(fo.italic) st+='font-style:italic;';
      if(fo.size) st+='font-size:'+Math.min(Math.max(Number(fo.size),8),15)+'px;';
      var cf=_bkColorCorreo(fo.color); if(cf) st+='color:'+cf+';';
      var rel=cell.fill && cell.fill.fgColor ? _bkColorCorreo(cell.fill.fgColor) : null;
      if(rel) st+='background-color:'+rel+';';
      st+='text-align:'+((cell.alignment&&cell.alignment.horizontal)
                         || (typeof val==='number'?'right':'left'))+';';

      var sp=span[ref]||{};
      fila+='<td'+(sp.cs>1?' colspan="'+sp.cs+'"':'')+(sp.rs>1?' rowspan="'+sp.rs+'"':'')
        +' style="'+st+'">'+(_bkEsc(texto)||'&nbsp;')+'</td>';
    }
    // Las filas del todo vacías se saltan: en el correo solo son ruido
    if(algo) h+='<tr>'+fila+'</tr>';
  }
  return h+'</table></div>';
}

// Lee un adjunto suelto (si es .xlsx) para poder previsualizarlo igual
async function _bkPreviaDeArchivo(file){
  if(!/\.xlsx$/i.test(file.name||'')) return '';
  try{
    var ExcelJSlib=await _bkExcelJS();
    var wb=new ExcelJSlib.Workbook();
    await wb.xlsx.load(await file.arrayBuffer());
    var ws=wb.worksheets[0];
    if(!ws) return '';
    var d={ws:ws, wb:wb, cache:{}, errores:{}};
    _bkRecachear(d);
    return _bkTablaCorreo(d, file.name.replace(/\.xlsx$/i,''));
  }catch(e){ console.warn('[correo] previa de '+file.name+':', e); return ''; }
}

// El cuerpo completo: el mensaje escrito + una tabla por cada adjunto
async function _bkCuerpoConPrevia(texto, docs){
  var partes=[];
  for(var i=0;i<docs.length;i++){
    var k=docs[i], d=window._bkDoc[k];
    if(!d) continue;
    var meta=BK_DOCS.find(function(x){ return x.k===k; });
    partes.push(d.tipo==='datos'
      ? _bkChequesTabla(d, true)
      : _bkTablaCorreo(d, (meta?meta.t:k)+' · '+_bkFechaHora(new Date().toISOString())));
  }
  for(var j=0;j<(window._bkExtra||[]).length;j++){
    var extra=await _bkPreviaDeArchivo(window._bkExtra[j]);
    if(extra) partes.push(extra);
  }
  var msg=String(texto||'')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/\n/g,'<br>');
  // La marca le dice al worker que esto ya viene en HTML y no lo escape.
  return '<!--HTML--><div style="font:14px Segoe UI,Arial,sans-serif;line-height:1.55;'
    +'color:#1a1a18">'+msg+'</div>'
    +(partes.length?('<div style="margin-top:22px">'+partes.join('')+'</div>'):'');
}

/* ═══════════════════════════════════════════════════════════════════════════
   AL MARCAR PAGADA · dejar constancia en la etapa de la orden
   ───────────────────────────────────────────────────────────────────────────
   Marcar "Pagada" en el listado la saca de los pendientes, pero si esa
   solicitud cuelga de una orden, en la orden no quedaba ni rastro: la etapa
   de Depósito & Pago seguía en rojo y nadie sabía que ya se había pagado.
   Ahora se marca también allí, y se deja un comentario diciendo que se hizo
   a mano desde el reporte y quién lo hizo.

   Qué paso se marca, según la etapa que el propio portal ya usa para avisar
   de un pago hecho:
     abono       → "Depósito enviado al proveedor"
     cancelación → "Solicitud de final del balance", que es el momento del
                   pago del saldo en este flujo.
   El comprobante al proveedor NO se marca: eso lo manda compras después, y
   darlo por hecho sería mentir sobre algo que nadie ha enviado.
   ═══════════════════════════════════════════════════════════════════════════ */

function _solPasoDePago(tipo){
  var st=(typeof STAGES!=='undefined'?STAGES:[]).find(function(x){ return x.key==='deposito'; });
  if(!st) return -1;
  var buscado = (String(tipo)==='abono') ? _PASO_DEP_PROV : _PASO_PAGO_FINAL;
  for(var i=0;i<st.steps.length;i++) if(st.steps[i].name===buscado) return i;
  return -1;
}

async function _solConstanciaEnOrden(x){
  try{
    var h=_solOrdenDe(x);
    if(!h) return null;                       // sin orden: solo queda en el listado
    var oid=String(h.o.id);
    var idx=_solPasoDePago(x.tipo);
    if(idx<0) return null;

    var st=STAGES.find(function(s){ return s.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid] && stageProgress[oid].deposito;
    var yaEstaba = sp && Number(sp.stepIdx||0) > idx;

    // Nunca hacia atrás: si la etapa ya iba más adelante, se respeta.
    if(!yaEstaba) advSS(oid, 'deposito', idx);

    var quien=(CU&&CU.name)||'';
    var txt='Pago registrado a mano desde el reporte de abonos y cancelaciones · '
      + (x.tipo==='abono' ? 'ABONO' : 'CANCELACIÓN') + ' de ' + fmt(x.monto||0)
      + (x.dkc?(' · '+x.dkc):'')
      + ' · marcado por '+quien
      + (yaEstaba ? ' (la etapa ya estaba más avanzada, no se movió)' : '');
    await guardarComentario(oid, 'deposito', txt);

    return {oid:oid, paso:st.steps[idx].name, movida:!yaEstaba};
  }catch(e){
    console.warn('[pago] constancia en la orden:', e);
    return null;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   VISTA DEL CORREO EN PANTALLA
   ───────────────────────────────────────────────────────────────────────────
   Gerencia abre la pantalla y ve exactamente lo que le llegó por correo: el
   saludo y debajo la tabla de cada Excel, en el mismo orden. Antes había que
   ir pestaña por pestaña, o abrir el correo.
   ═══════════════════════════════════════════════════════════════════════════ */

// Los documentos que hay cargados ahora mismo, en el orden de BK_DOCS
function _bkCargados(){
  return BK_DOCS.filter(function(m){ return !!window._bkDoc[m.k]; });
}
// Los que llevaba un envío guardado
function _bkDocsDe(e){
  return BK_DOCS.filter(function(m){ return e && e[m.k+'_url']; });
}

// El saludo, igual que el del correo
// El saludo que se propone en el diálogo de envío. En pantalla no se muestra
// (ahí estorba), pero en el correo sí va.
function _bkSaludo(fecha){
  var f=fecha?new Date(fecha):new Date();
  var larga=f.getDate()+' de '+MESES_ES[f.getMonth()].toLowerCase()+' de '+f.getFullYear();
  return 'Buenos días,\n\nAdjunto los saldos bancarios y el reporte de préstamos al '
    +larga+'.\n\nSaludos,\n'+((CU&&CU.name)||'');
}

function _bkPintarResumen(){
  var cont=document.getElementById('bkCuerpo'); if(!cont) return;
  var docs=_bkCargados();
  if(!docs.length){
    cont.innerHTML='<div class="empty">Carga los Excel o abre un día del calendario '
      +'para ver aquí el resumen.</div>';
    return;
  }
  var enviado=docs.map(function(m){ return window._bkDoc[m.k].solo; })
                  .filter(Boolean)[0] || null;

  var partes=docs.map(function(m){
    try{
      var dd=window._bkDoc[m.k];
      if(dd.tipo==='datos') return _bkChequesTabla(dd, true);
      return _bkTablaCorreo(dd, m.t);
    }catch(e){ console.warn('[resumen] '+m.k+':', e); return ''; }
  }).filter(Boolean);

  // Sin el saludo: en pantalla estorba. En el correo sigue yendo, que ahí
  // sí hace falta.
  cont.innerHTML=
     '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:10px">'
    +'<span style="font-size:11.5px;color:'+(enviado?'var(--t-verde)':'var(--text-muted)')+'">'
    +'<i class="ti ti-'+(enviado?'mail-check':'file-text')+'"></i> '
    +(enviado ? ('Enviado el '+_bkEsc(_bkFechaHora(enviado)))
              : ('Todavía sin enviar · '+docs.length+' archivo(s) cargados'))
    +'</span>'
    +(docs.some(function(m){ return window._bkDoc[m.k].solo; })
      ? '<button class="xb" onclick="_bkSalirDelDia()">'
        +'<i class="ti ti-arrow-back-up"></i> Volver al día de hoy</button>' : '')
    +'<span style="flex:1"></span>'
    +docs.map(function(m){
        return '<button class="xb" onclick="_bkDescargar(\''+m.k+'\')" '
          +'title="Descargar '+_bkEsc(m.t)+'">'
          +'<i class="ti ti-download"></i> '+_bkEsc(m.t)+'</button>';
      }).join('')
    +'</div>'
    +'<div style="background:#fff;border:1px solid var(--border);border-radius:10px;'
    +'padding:18px;overflow:auto;max-height:74vh">'
    +partes.join('')
    +'</div>';
}


/* ═══════════════════════════════════════════════════════════════════════════
   CHEQUES REALIZADOS · se arman desde SAP, no se suben
   ───────────────────────────────────────────────────────────────────────────
   Los otros tres reportes son Excel que prepara contabilidad. Éste no: sale
   de SAP (ODSC → OCHO → CHO1), lo trae el worker a `cheques_girados` y aquí
   se arma la tabla.

   Siempre del DÍA ANTERIOR al envío: el correo de hoy lleva los cheques de
   ayer, porque los de hoy aún se están girando.

   Un cheque puede tener varias líneas en CHO1, así que llegan varias filas
   por cheque y se agrupan: banco → cheque → líneas, con subtotal por banco y
   total general, como en el reporte que saca contabilidad.
   ═══════════════════════════════════════════════════════════════════════════ */

// El día anterior a una fecha (por defecto, a hoy)
// La pantalla de la pestaña de cheques
function _bkPintarCheques(cont){
  var d=window._bkDoc.cheques;
  var hoy=new Date().toISOString().slice(0,10);
  var f=(d&&d.fecha)||_bkDiaAnterior();
  var cab='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:10px">'
    +'<span style="font-size:14px;font-weight:600">Cheques realizados</span>'
    +'<span style="font-size:12px;color:var(--text-muted)">del '
      +_bkEsc(_bkFechaHora(f))+'</span>'
    +'<input type="date" id="bkChFecha" value="'+_bkEsc(f)+'" max="'+hoy+'" '
      +'onchange="_bkChequesOtroDia(this.value)" '
      +'style="font-size:11px;padding:3px 6px;border:0.5px solid var(--border);'
      +'border-radius:6px;background:var(--surface-2);color:var(--text-primary)">'
    +'<button class="xb" onclick="_bkChequesOtroDia(document.getElementById(\'bkChFecha\').value)">'
      +'<i class="ti ti-refresh"></i> Actualizar</button>'
    +(d?'<button class="xb" onclick="_bkDescargar(\'cheques\')">'
       +'<i class="ti ti-download"></i> Descargar</button>':'')
    +'<div style="flex:1"></div>'
    +(_bkCargados().length
      ? '<button class="lb" style="max-width:250px" onclick="_bkAbrirEnvio()">'
        +'<i class="ti ti-mail"></i> Guardar y enviar a gerencia</button>' : '')
    +'</div>'
    +'<p style="font-size:11px;color:var(--text-muted);margin:0 0 10px">'
    +'Estos no se suben: salen de SAP. Por defecto los del día anterior al envío, '
    +'que son los que van en el correo de hoy.</p>';

  if(!d){ cont.innerHTML=cab+'<div class="empty">Cargando los cheques…</div>'; return; }

  // Si lo que hay cargado es el Excel de un envío guardado (al consultar un
  // día del calendario) se pinta como cualquier otra hoja. Pasarlo por la
  // tabla de cheques daba "No hay cheques girados el ." sin fecha, porque
  // ese documento no trae ni filas ni día.
  if(d.tipo!=='datos'){
    cont.innerHTML=cab
      +'<div class="nota" style="background:var(--pastel-lila);color:var(--t-lila);margin-bottom:8px">'
      +'<i class="ti ti-file-spreadsheet"></i> Estás viendo el archivo que se envió'
      +(d.solo?(' el '+_bkEsc(_bkFechaHora(d.solo))):'')
      +'. Para consultar otro día en SAP, elige la fecha y pulsa Actualizar.</div>'
      +'<div id="bkGrid-cheques" style="overflow:auto;max-height:60vh;border:1px solid '
      +'var(--border);border-radius:8px;background:#fff">'+_bkGridHTML('cheques')+'</div>';
    return;
  }

  cont.innerHTML=cab
    +'<div style="overflow:auto;max-height:64vh;border:1px solid var(--border);'
    +'border-radius:8px;background:#fff;padding:10px">'+_bkChequesTabla(d,false)+'</div>';
}

async function _bkChequesOtroDia(fecha){
  var cont=document.getElementById('bkCuerpo');
  if(cont) cont.innerHTML='<div class="empty">Cargando los cheques…</div>';
  try{ await _bkCargarCheques(fecha); }
  catch(e){ showT('No se pudieron leer los cheques: '+(e.message||e), 6000); }
  _bkPintarDoc('cheques');
}

function _bkDiaAnterior(base){
  var d=base?new Date(base+'T12:00:00'):new Date();
  d.setDate(d.getDate()-1);
  return d.getFullYear()+'-'+_bkDosDig(d.getMonth()+1)+'-'+_bkDosDig(d.getDate());
}

async function _bkCargarCheques(fecha){
  var f=fecha||_bkDiaAnterior();
  var r=await fetch(SB+'/rest/v1/cheques_girados?select=*&checkdate=eq.'+f
      +'&order=bankname.asc,checknum.asc',
    {headers:Object.assign({},SBH,{'Cache-Control':'no-cache'}), cache:'no-store'});
  if(!r.ok) throw new Error('no se pudo leer los cheques (estado '+r.status+')');
  var filas=await r.json();
  window._bkDoc.cheques = {
    tipo:'datos', fecha:f, filas:filas,
    nombre:'Cheques_Realizados_'+f+'.xlsx',
    cargado:new Date().toISOString()
  };
  return window._bkDoc.cheques;
}

// Agrupa: banco → cheque → líneas
function _bkChequesAgrupados(d){
  var bancos={}, orden=[];
  (d.filas||[]).forEach(function(x){
    var b=String(x.bankname||'SIN BANCO').trim();
    if(!bancos[b]){ bancos[b]={nombre:b, cheques:{}, ordenCh:[], total:0}; orden.push(b); }
    var g=bancos[b];
    var k=String(x.checknum);
    if(!g.cheques[k]){
      g.cheques[k]={num:x.checknum, fecha:x.checkdate, beneficiario:x.vendorname||'',
                    concepto:x.details||'', lineas:[], total:0};
      g.ordenCh.push(k);
    }
    var m=Number(x.totalline)||0;
    g.cheques[k].lineas.push({detalle:x.linedetail||'', monto:m});
    g.cheques[k].total+=m;
    g.total+=m;
  });
  return {bancos:orden.map(function(b){ return bancos[b]; }),
          total:orden.reduce(function(a,b){ return a+bancos[b].total; },0)};
}

// La tabla, con los mismos estilos en línea que el resto del correo
function _bkChequesTabla(d, paraCorreo){
  var g=_bkChequesAgrupados(d);
  var borde='border:1px solid #d4d4d4;padding:3px 7px;';
  var num=function(v){ return (Number(v)||0).toLocaleString('en-US',
    {minimumFractionDigits:2, maximumFractionDigits:2}); };

  if(!g.bancos.length){
    return '<div style="font:13px Arial,sans-serif;color:#666;padding:10px 0">'
      +'No hay cheques girados el '+_bkEsc(d.fecha||'(sin fecha)')+'.'
      +(paraCorreo?'':' Si sabes que sí los hubo, revisa que el worker haya '
        +'corrido su sync: en el log sale como “[sync] cheques girados”.')
      +'</div>';
  }

  var h='<table cellspacing="0" cellpadding="0" border="0" '
    +'style="border-collapse:collapse;font:11.5px Arial,sans-serif;color:#1a1a18">'
    +'<tr>'
      +'<th style="'+borde+'background-color:#B7CDE8;text-align:center;width:70px">CHEQUE</th>'
      +'<th style="'+borde+'background-color:#B7CDE8;text-align:center;width:85px">FECHA</th>'
      +'<th style="'+borde+'background-color:#B7CDE8;text-align:left">BENEFICIARIO</th>'
      +'<th style="'+borde+'background-color:#B7CDE8;text-align:left">DETALLE</th>'
      +'<th style="'+borde+'background-color:#B7CDE8;text-align:right;width:110px">MONTO</th>'
    +'</tr>';

  g.bancos.forEach(function(b){
    h+='<tr><td colspan="5" style="'+borde+'background-color:#7BB040;color:#fff;'
      +'font-weight:700;font-size:13px;text-align:center">'+_bkEsc(b.nombre)+'</td></tr>';
    b.ordenCh.forEach(function(k){
      var c=b.cheques[k];
      c.lineas.forEach(function(l,i){
        h+='<tr>'
          +(i===0
            ? '<td rowspan="'+c.lineas.length+'" style="'+borde+'text-align:center;'
              +'font-weight:700">'+_bkEsc(c.num)+'</td>'
              +'<td rowspan="'+c.lineas.length+'" style="'+borde+'text-align:center">'
              +_bkEsc(_bkFecha(new Date(c.fecha+'T12:00:00')))+'</td>'
              +'<td rowspan="'+c.lineas.length+'" style="'+borde+'">'
              +_bkEsc(c.beneficiario)+'</td>'
            : '')
          +'<td style="'+borde+'">'+_bkEsc(l.detalle||c.concepto)+'</td>'
          +'<td style="'+borde+'text-align:right">'+num(l.monto)+'</td></tr>';
      });
    });
    h+='<tr><td colspan="4" style="'+borde+'text-align:right;font-weight:700">SUBTOTAL ————&gt;</td>'
      +'<td style="'+borde+'text-align:right;font-weight:700;background-color:#FFF2A8">'
      +num(b.total)+'</td></tr>';
  });

  h+='<tr><td colspan="4" style="'+borde+'text-align:right;font-weight:800;font-size:12.5px">'
    +'TOTAL ————&gt;</td>'
    +'<td style="'+borde+'text-align:right;font-weight:800;font-size:12.5px;'
    +'background-color:#FFE066">'+num(g.total)+'</td></tr>'
    +'</table>';

  return paraCorreo
    ? ('<div style="margin:0 0 26px 0">'
       +'<div style="font:700 15px Arial,sans-serif;color:#1a1a18;margin:0 0 7px 0">'
       +'Cheques realizados · '+_bkEsc(_bkFechaHora(d.fecha))+'</div>'+h+'</div>')
    : h;
}

// El .xlsx que se adjunta, armado con los mismos datos
async function _bkChequesExcel(d){
  var ExcelJSlib=await _bkExcelJS();
  var wb=new ExcelJSlib.Workbook();
  var ws=wb.addWorksheet('Cheques '+d.fecha);
  ws.columns=[{width:12},{width:13},{width:38},{width:52},{width:16}];
  var g=_bkChequesAgrupados(d);

  var tit=ws.addRow(['LISTADO DE CHEQUES GIRADOS · '+d.fecha]);
  tit.font={bold:true, size:13}; ws.mergeCells(tit.number,1,tit.number,5);
  tit.getCell(1).alignment={horizontal:'center'};
  ws.addRow([]);
  var cab=ws.addRow(['CHEQUE','FECHA','BENEFICIARIO','DETALLE','MONTO']);
  cab.eachCell(function(c){
    c.font={bold:true};
    c.fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFB7CDE8'}};
    c.border={top:{style:'thin'},left:{style:'thin'},bottom:{style:'thin'},right:{style:'thin'}};
  });

  g.bancos.forEach(function(b){
    var fb=ws.addRow([b.nombre]);
    ws.mergeCells(fb.number,1,fb.number,5);
    fb.getCell(1).font={bold:true, color:{argb:'FFFFFFFF'}};
    fb.getCell(1).fill={type:'pattern',pattern:'solid',fgColor:{argb:'FF7BB040'}};
    fb.getCell(1).alignment={horizontal:'center'};
    b.ordenCh.forEach(function(k){
      var c=b.cheques[k];
      c.lineas.forEach(function(l,i){
        var r=ws.addRow([ i===0?c.num:'', i===0?c.fecha:'', i===0?c.beneficiario:'',
                          l.detalle||c.concepto, l.monto ]);
        r.getCell(5).numFmt='#,##0.00';
      });
    });
    var fs=ws.addRow(['','','','SUBTOTAL ---->', b.total]);
    fs.getCell(4).font={bold:true}; fs.getCell(5).font={bold:true};
    fs.getCell(5).numFmt='#,##0.00';
    fs.getCell(5).fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFFFF2A8'}};
  });
  var ft=ws.addRow(['','','','TOTAL ---->', g.total]);
  ft.getCell(4).font={bold:true,size:12}; ft.getCell(5).font={bold:true,size:12};
  ft.getCell(5).numFmt='#,##0.00';
  ft.getCell(5).fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFFFE066'}};
  return await wb.xlsx.writeBuffer();
}

// Sale de la consulta de un día guardado y devuelve lo que hubiera cargado
function _bkSalirDelDia(){
  BK_DOCS.forEach(function(m){
    if(window._bkDoc[m.k] && window._bkDoc[m.k].solo){
      window._bkDoc[m.k]=(window._bkPrevio && window._bkPrevio[m.k]) || null;
      if(window._bkPrevio) window._bkPrevio[m.k]=null;
    }
  });
  // Los cheques se vuelven a pedir a SAP, que es su fuente
  if(!window._bkDoc.cheques){
    _bkCargarCheques().then(function(){ _bkIrA('resumen'); })
                      .catch(function(){ _bkIrA('resumen'); });
  } else _bkIrA('resumen');
}

/* ═══════════════════════════════════════════════════════════════════════════
   HOJAS DE CREACIÓN PARA SAP · desde la proforma de Kennedy
   ───────────────────────────────────────────────────────────────────────────
   Saca los tres archivos que contabilidad sube a SAP a partir de nuestra
   proforma (la de Kennedy, no la del proveedor):

     · Creación de artículos   20 columnas
     · Creación empaque        11 columnas
     · Creación UDF            13 columnas

   Son .txt delimitados por tabulaciones. El formato se copió del archivo
   real de la DKC-26073 y está comprobado: de 141 filas generadas, 138
   salieron IDÉNTICAS byte a byte a las que hizo contabilidad a mano. Las
   otras tres eran retoques a mano de la descripción, no errores de cálculo.

   Tres detalles del formato que no se ven a simple vista y que hay que
   respetar o SAP lo lee distinto:
     · La codificación es Windows-1252, NO UTF-8. Con UTF-8 los acentos
       llegan rotos.
     · Las líneas acaban en CRLF.
     · Excel entrecomilla los campos que llevan punto y coma (es el separador
       de lista en configuración española), salto de línea o comillas. Las
       comas NO las entrecomilla.
   ═══════════════════════════════════════════════════════════════════════════ */

function _txtPuede(){
  return !!CU && (_esCompras() || CU.role==='gerencia');
}

// ── Escritura del texto delimitado por tabulaciones ─────────────────────
function _txtCampo(v){
  if(v===null||v===undefined) return '';
  var s=String(v);
  if(/[\t\r\n";]/.test(s)) s='"'+s.replace(/"/g,'""')+'"';
  return s;
}
function _txtArmar(filas){
  return filas.map(function(f){ return f.map(_txtCampo).join('\t'); }).join('\r\n')+'\r\n';
}
// Windows-1252. Los caracteres que no existen en esa tabla se dejan sin
// acento antes que romper el archivo.
function _txtLatin1(str){
  var sin={'Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U','á':'a','é':'e','í':'i','ó':'o',
           'ú':'u','Ñ':'Ñ','ñ':'ñ','Ü':'U','ü':'u','¿':'?','¡':'!','–':'-','—':'-',
           '“':'"','”':'"','‘':"'",'’':"'",'…':'...'};
  var out=[];
  for(var i=0;i<str.length;i++){
    var c=str[i], n=str.charCodeAt(i);
    if(n<256){ out.push(n); continue; }
    var r=sin[c];
    if(r!==undefined && r.charCodeAt(0)<256){ out.push(r.charCodeAt(0)); continue; }
    out.push(63);                                   // '?'
  }
  return new Uint8Array(out);
}
function _txtDescargar(nombre, texto){
  var blob=new Blob([_txtLatin1(texto)], {type:'text/plain;charset=windows-1252'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob); a.download=nombre;
  document.body.appendChild(a); a.click();
  setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 400);
}

// El precio va como lo enseña Excel: dos decimales. En crudo, 4.20 salía
// "4.2" y no coincidía con el archivo que hace contabilidad.
function _txtPrecio(v){
  var n=Number(v);
  return isNaN(n) ? (v==null?'':String(v)) : n.toFixed(2);
}

// ── Leer la proforma ────────────────────────────────────────────────────
// Las columnas se buscan por su título, no por posición: cada proforma
// puede tener la tabla empezando en una fila distinta.
var TXT_COLS={
  'FACTORYNO':'factory', 'KENNEDYITEM':'item', 'BARCODE':'barcode',
  'ENGLISHDESCRIPTION':'ing', 'SPANISHDESCRIPTION':'esp',
  'MATERIALCOMP':'comp', 'COLOR':'color', 'SIZECM':'size',
  'KENNEDYQTYPCS':'qty', 'QTYXCTN':'qtyCtn', 'TOTALCTNS':'ctns',
  'CARTONSIZE':'carton', 'CBMXCTN':'cbm', 'UNITPRICE':'precio',
  'ITEMSPHOTO':'colorIng'
};

async function _txtLeerProforma(file){
  var ExcelJSlib=await _bkExcelJS();
  var wb=new ExcelJSlib.Workbook();
  await wb.xlsx.load(await file.arrayBuffer());

  var d=_profDetectar(wb, ['itemcode','barcode','precio']);
  if(!d) throw new Error('No encontré la tabla de artículos. La proforma debe tener '
    +'una fila de títulos con el código del artículo, el código de barras y el precio.');
  var ws=d.ws, col=d.col;

  var lineas=[];
  for(var r=d.cab+1; r<=ws.rowCount; r++){
    var item=String(_profVal(ws,r,col.itemcode)).trim();
    if(!item || /^TOTAL/i.test(_bkNorm(item))) break;
    if(_profEsCabecera(item)) continue;      // fila de títulos repetida
    lineas.push({
      item:item,
      // Sin recortar espacios: el archivo original conserva los finales
      // ("CESTO PARA ROPA ") y SAP los recibe así.
      factory:String(_profVal(ws,r,col.factory)),
      barcode:String(_profVal(ws,r,col.barcode)),
      ing:String(_profVal(ws,r,col.ing)),
      esp:String(_profVal(ws,r,col.esp)),
      comp:String(_profVal(ws,r,col.comp)),
      color:String(_profVal(ws,r,col.color)),
      colorIng:String(_profVal(ws,r,col.colorIng)),
      size:String(_profVal(ws,r,col.size)),
      carton:String(_profVal(ws,r,col.carton)),
      qtyCtn:_profVal(ws,r,col.qtyCtn),
      precio:_profVal(ws,r,col.precio),
      compEsp:''                    // no está en la proforma: se escribe aquí
    });
  }
  if(!lineas.length) throw new Error('Encontré la cabecera pero ninguna línea de artículo debajo.');
  return {lineas:lineas, hoja:ws.name};
}

// ── Los tres archivos ───────────────────────────────────────────────────
function _txtCreacion(d){
  var k=d.k;
  return _txtArmar(d.lineas.map(function(l){
    return [l.item, String(l.esp).toUpperCase(), String(l.ing).toUpperCase(), k.dept,
            l.barcode, k.prov, k.marca, k.arancel, k.clase, l.item+'.JPG', '',
            k.codPrecios, _txtPrecio(l.precio), k.moneda, '', '', '', '',
            k.codMedida, l.factory];
  }));
}
function _txtEmpaque(d){
  var k=d.k;
  return _txtArmar(d.lineas.map(function(l){
    return [l.item, k.umCompra, 1, k.ueCompra, l.qtyCtn, '', '',
            k.umVenta, 1, k.ueVenta, l.qtyCtn];
  }));
}
function _txtUdf(d){
  var k=d.k;
  return _txtArmar(d.lineas.map(function(l){
    return [l.item, l.color, '', l.size, l.compEsp, k.pais, l.colorIng, l.comp,
            k.producto, k.categoria, k.coleccion, k.dptoUdf, l.carton];
  }));
}

// ── La pantalla ─────────────────────────────────────────────────────────
// Los datos que NO están en la proforma y hay que poner una vez por orden.
// Se recuerdan de una orden a la siguiente, que casi siempre se repiten.
var TXT_FIJOS=[
  {k:'dept',      t:'Departamento',        d:'..Hogar',            g:'Artículos'},
  {k:'prov',      t:'Proveedor',           d:'589',                g:'Artículos'},
  {k:'marca',     t:'Marca',               d:'HOME DETAILS',       g:'Artículos'},
  {k:'arancel',   t:'Arancel',             d:'ART. DE POLIESTER',  g:'Artículos'},
  {k:'clase',     t:'Clase de expedición', d:'3',                  g:'Artículos'},
  {k:'codPrecios',t:'Código precios',      d:'01',                 g:'Artículos'},
  {k:'moneda',    t:'Moneda',              d:'$',                  g:'Artículos'},
  {k:'codMedida', t:'Código medida',       d:'MANUAL',             g:'Artículos'},
  {k:'umCompra',  t:'Unidad compra',       d:'PIEZA',              g:'Empaque'},
  {k:'ueCompra',  t:'Empaque compra',      d:'BULTO',              g:'Empaque'},
  {k:'umVenta',   t:'Unidad venta',        d:'PIEZA',              g:'Empaque'},
  {k:'ueVenta',   t:'Empaque venta',       d:'BULTO',              g:'Empaque'},
  {k:'pais',      t:'País de origen',      d:'CN',                 g:'UDF'},
  {k:'producto',  t:'Producto',            d:'581',                g:'UDF'},
  {k:'categoria', t:'Categoria',           d:'014',                g:'UDF'},
  {k:'coleccion', t:'Colección',           d:'115',                g:'UDF'},
  {k:'dptoUdf',   t:'Dpto. UDF',           d:'MAL',                g:'UDF'}
];

function _txtFijosGuardados(){
  var g={};
  try{ g=JSON.parse(localStorage.getItem('kcc_txt_fijos')||'{}')||{}; }catch(e){}
  var k={};
  TXT_FIJOS.forEach(function(f){ k[f.k]=(g[f.k]!==undefined?g[f.k]:f.d); });
  return k;
}
function _txtGuardarFijos(k){
  try{ localStorage.setItem('kcc_txt_fijos', JSON.stringify(k)); }catch(e){}
}

window._txtDatos=null;

// Pantalla propia, no ventana emergente: se trabaja con ella un rato
// (revisar 47 líneas y escribir las composiciones) y un modal se cierra sin
// querer al pulsar fuera.
function rHojasSap(){
  var pg=document.getElementById('page-hojassap');
  if(!pg) return;
  if(!_txtPuede()){
    pg.innerHTML='<div class="empty">Esta pantalla es de compras y gerencia.</div>';
    return;
  }
  var d=window._txtDatos;

  pg.innerHTML=
     '<div class="sec">'
    +  '<div class="sec-h"><h2>Hojas de creación para SAP</h2></div>'
    +  (d ? _txtBarraArchivo(d) : _txtZonaSoltar())
    +  '<input type="file" id="txtFile" accept=".xlsx" style="display:none" onchange="_txtCargar(this)">'
    +  '<div id="txtEstado" style="font-size:12px;margin:10px 0;line-height:1.5"></div>'
    +  '<div id="txtCuerpo"></div>'
    +'</div>';

  if(d) _txtPintar();
  else _txtEnganchaSoltar();
}

// El punto de partida: una zona grande para soltar el archivo. Es lo único
// que se puede hacer aquí todavía, así que ocupa el sitio y lo dice claro.
function _txtZonaSoltar(){
  return '<div id="txtDrop" onclick="document.getElementById(\'txtFile\').click()" '
    +'style="border:1.5px dashed var(--border-accent);border-radius:14px;padding:34px 20px;'
    +'text-align:center;cursor:pointer;background:var(--bg-accent);transition:background .15s">'
    +'<i class="ti ti-file-spreadsheet" style="font-size:34px;color:var(--t-lila)"></i>'
    +'<div style="font-size:15px;font-weight:600;margin-top:10px;color:var(--text-primary)">'
    +'Suelta aquí nuestra proforma</div>'
    +'<div style="font-size:12.5px;color:var(--text-secondary);margin-top:5px;line-height:1.6;'
    +'max-width:520px;margin-left:auto;margin-right:auto">'
    +'La de Kennedy en .xlsx, no la del proveedor. De ella salen los tres archivos '
    +'que se cargan en SAP.</div>'
    +'<div style="margin-top:14px"><span class="btn bp" style="pointer-events:none">'
    +'<i class="ti ti-file-upload"></i> Elegir el archivo</span></div>'
    +'</div>'
    +'<div style="display:flex;gap:22px;justify-content:center;margin-top:16px;flex-wrap:wrap">'
    + [['ti-list-details','Creación de artículos','20 columnas'],
       ['ti-package','Creación empaque','11 columnas'],
       ['ti-tags','Creación UDF','13 columnas']].map(function(x){
        return '<div style="text-align:center;color:var(--text-muted)">'
          +'<i class="ti '+x[0]+'" style="font-size:17px"></i>'
          +'<div style="font-size:12px;font-weight:600;color:var(--text-secondary);margin-top:3px">'
          +x[1]+'</div><div style="font-size:10.5px">'+x[2]+'</div></div>';
      }).join('')
    +'</div>'
    +'<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron);margin-top:18px">'
    +'<i class="ti ti-alert-triangle"></i> Los .txt que salen de aquí no se abren en Excel: '
    +'convierte los códigos de barras a notación científica y se pierden los dígitos. '
    +'Si hay que corregir algo, se corrige en la proforma y se vuelve a generar.</div>';
}

function _txtEnganchaSoltar(){
  var z=document.getElementById('txtDrop'); if(!z) return;
  var pinta=function(on){ z.style.background = on ? 'var(--pastel-lila)' : 'var(--bg-accent)'; };
  ['dragenter','dragover'].forEach(function(ev){
    z.addEventListener(ev, function(e){ e.preventDefault(); pinta(true); }); });
  ['dragleave','drop'].forEach(function(ev){
    z.addEventListener(ev, function(e){ e.preventDefault(); pinta(false); }); });
  z.addEventListener('drop', function(e){
    var f=e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if(f) _txtCargar({files:[f], value:''});
  });
}

// Con el archivo dentro, la zona grande sobra: se queda una barra con lo que
// hay cargado y el número de DKC, que es lo que nombra los archivos.
function _txtBarraArchivo(d){
  return '<div style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;'
    +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:11px;'
    +'padding:11px 14px;margin-bottom:14px">'
    +'<i class="ti ti-file-spreadsheet" style="font-size:20px;color:var(--t-lila)"></i>'
    +'<div style="min-width:150px">'
      +'<div style="font-size:13px;font-weight:600">'+_esc(d.archivo||'Proforma')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)">'
      +d.lineas.length+' artículos · hoja «'+_esc(d.hoja)+'»</div>'
    +'</div>'
    +'<label style="font-size:11px;color:var(--text-muted)">Número de DKC<br>'
      +'<input id="txtDkc" value="'+_esc(d.dkc||'')+'" placeholder="DKC-26073" '
      +'oninput="if(window._txtDatos)window._txtDatos.dkc=this.value" '
      +'style="font-size:13px;font-weight:600;padding:5px 9px;border:0.5px solid var(--border);'
      +'border-radius:7px;background:var(--surface-0);color:var(--text-primary);width:160px">'
      +'</label>'
    +'<div style="flex:1"></div>'
    +'<button class="xb" onclick="document.getElementById(\'txtFile\').click()">'
      +'<i class="ti ti-refresh"></i> Cambiar</button>'
    +'<button class="xb" style="color:var(--text-danger)" onclick="_txtQuitar()">'
      +'<i class="ti ti-x"></i> Quitar</button>'
    +'</div>';
}

function _txtQuitar(){
  window._txtDatos=null;
  rHojasSap();
}

function _txtMsg(t,tipo){
  var e=document.getElementById('txtEstado'); if(!e) return;
  e.style.color = tipo==='err' ? '#A32D2D' : (tipo==='ok' ? '#27500A' : 'var(--text-muted)');
  e.innerHTML=t;
}

async function _txtCargar(input){
  var f=input && input.files && input.files[0];
  input.value='';
  if(!f) return;
  try{
    _txtMsg('Leyendo '+_esc(f.name)+'…');
    var d=await _txtLeerProforma(f);
    d.k=_txtFijosGuardados();
    d.sel={creacion:true, empaque:true, udf:true};
    // El DKC se conserva si ya se había escrito, y si no se intenta sacar
    // del nombre del archivo (Copia de DKC-26073.xlsx).
    var previo=(document.getElementById('txtDkc')||{}).value||'';
    var m=/([DSGW]KC[-\s]?\d{4,6})/i.exec(f.name||'');
    d.dkc=previo.trim() || (m?m[1].toUpperCase().replace(/\s/g,''):'');
    window._txtDatos=d;
    rHojasSap();
  }catch(e){
    _txtMsg(_esc(e.message||String(e)),'err');
    var c=document.getElementById('txtCuerpo'); if(c) c.innerHTML='';
  }
}

function _txtSetFijo(k,v){
  if(!window._txtDatos) return;
  window._txtDatos.k[k]=v;
  _txtGuardarFijos(window._txtDatos.k);
}
function _txtSetLinea(i,campo,v){
  if(!window._txtDatos) return;
  window._txtDatos.lineas[i][campo]=v;
  if(campo==='compEsp') _txtPintarAviso();
}
function _txtSetHoja(k,v){
  if(!window._txtDatos) return;
  window._txtDatos.sel[k]=v;
  _txtPintar();          // las tarjetas cambian de color al marcarse
}

function _txtPintar(){
  var d=window._txtDatos, c=document.getElementById('txtCuerpo');
  if(!d||!c) return;

  var faltan=d.lineas.filter(function(l){ return !String(l.compEsp||'').trim(); }).length;
  var listas=d.lineas.length-faltan;

  // Las tres salidas, como tarjetas que se marcan. Cada una dice cuántas
  // líneas lleva y qué le falta, que es lo que hay que decidir aquí.
  var hojas=[
    {k:'creacion', t:'Creación de artículos', ic:'ti-list-details', cols:20,
     nota:d.lineas.length+' artículos'},
    {k:'empaque',  t:'Creación empaque',      ic:'ti-package',      cols:11,
     nota:'piezas por bulto de la proforma'},
    {k:'udf',      t:'Creación UDF',          ic:'ti-tags',         cols:13,
     nota: faltan ? (faltan+' sin composición en español') : 'completa'}
  ];

  var h='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(230px,1fr));'
    +'gap:10px;margin-bottom:16px">'
    + hojas.map(function(x){
        var on=!!d.sel[x.k];
        var alerta=(x.k==='udf' && faltan && on);
        return '<label style="display:flex;gap:10px;align-items:flex-start;cursor:pointer;'
          +'border:1px solid '+(on?'var(--border-accent)':'var(--border)')+';border-radius:12px;'
          +'padding:12px 14px;background:'+(on?'var(--bg-accent)':'var(--surface-1)')+';'
          +'transition:background .12s">'
          +'<input type="checkbox" '+(on?'checked':'')+' style="margin-top:2px" '
          +'onchange="_txtSetHoja(\''+x.k+'\',this.checked)">'
          +'<div style="min-width:0">'
            +'<div style="font-size:13px;font-weight:600;display:flex;align-items:center;gap:6px">'
            +'<i class="ti '+x.ic+'" style="color:'+(on?'var(--t-lila)':'var(--text-muted)')+'"></i>'
            +_esc(x.t)+'</div>'
            +'<div style="font-size:11px;color:'+(alerta?'var(--t-marron)':'var(--text-muted)')
            +';margin-top:3px">'+_esc(x.nota)+'</div>'
            +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'
            +x.cols+' columnas</div>'
          +'</div></label>';
      }).join('')
    +'</div>';

  // Los datos fijos van plegados: se ponen una vez y se recuerdan. Abiertos
  // llenaban la pantalla de casillas antes de llegar a lo importante.
  var grupos={};
  TXT_FIJOS.forEach(function(f){ (grupos[f.g]=grupos[f.g]||[]).push(f); });
  h+='<details'+(window._txtAbiertos?' open':'')+' ontoggle="window._txtAbiertos=this.open" '
    +'style="border:0.5px solid var(--border);border-radius:11px;background:var(--surface-1);'
    +'margin-bottom:16px">'
    +'<summary style="cursor:pointer;padding:11px 14px;font-size:12.5px;font-weight:600;'
    +'display:flex;align-items:center;gap:8px;list-style:none">'
    +'<i class="ti ti-adjustments" style="color:var(--t-lila)"></i>'
    +'Datos fijos de la orden'
    +'<span style="font-weight:400;color:var(--text-muted);font-size:11.5px">'
    +'proveedor '+_esc(d.k.prov)+', '+_esc(d.k.marca)+', '+_esc(d.k.dept)+'</span>'
    +'</summary>'
    +'<div style="padding:0 14px 13px">'
    +'<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 10px;line-height:1.5">'
    +'No vienen en la proforma. Se guardan para la próxima orden.</p>'
    + Object.keys(grupos).map(function(g){
        return '<div style="margin-bottom:10px">'
          +'<div style="font-size:11px;color:var(--text-secondary);font-weight:600;'
          +'margin-bottom:5px">'+g+'</div>'
          +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
          + grupos[g].map(function(f){
              return '<label style="font-size:10.5px;color:var(--text-muted)">'+_esc(f.t)+'<br>'
                +'<input value="'+_esc(d.k[f.k])+'" onchange="_txtSetFijo(\''+f.k+'\',this.value)" '
                +'style="font-size:12px;padding:5px 8px;border:0.5px solid var(--border);'
                +'border-radius:7px;background:var(--surface-0);color:var(--text-primary);'
                +'width:132px"></label>';
            }).join('')
          +'</div></div>';
      }).join('')
    +'</div></details>';

  // El único dato que hay que escribir. Con barra de avance, porque son 47
  // y conviene ver cuánto queda.
  h+='<div id="txtAviso" style="margin-bottom:12px">'+_txtAvisoHTML()+'</div>';

  h+='<div style="overflow:auto;max-height:46vh;border:0.5px solid var(--border);'
    +'border-radius:11px;background:var(--surface-0)">'
    +'<table class="tb" style="font-size:11.5px"><thead><tr>'
    +'<th style="width:80px">Referencia</th>'
    +'<th>Descripción español</th><th>Descripción inglés</th>'
    +'<th style="width:80px">Color</th>'
    +'<th style="width:60px;text-align:right">Pzs/blt</th>'
    +'<th style="width:70px;text-align:right">Precio</th>'
    +'<th style="min-width:240px">Composición español</th>'
    +'</tr></thead><tbody>'
    + d.lineas.map(function(l,i){
        var falta=!String(l.compEsp||'').trim();
        var edit=function(campo,val,extra){
          return '<input value="'+_esc(val)+'" onchange="_txtSetLinea('+i+',\''+campo+'\',this.value)" '
            +'style="width:100%;box-sizing:border-box;font-size:11.5px;padding:3px 6px;'
            +'border:0.5px solid '+(extra||'var(--border)')+';border-radius:6px;'
            +'background:var(--surface-0);color:var(--text-primary)">';
        };
        return '<tr>'
          +'<td style="font-weight:600">'+_esc(l.item)+'</td>'
          +'<td>'+edit('esp',l.esp)+'</td>'
          +'<td>'+edit('ing',l.ing)+'</td>'
          +'<td style="font-size:11px;color:var(--text-secondary)">'+_esc(l.color)+'</td>'
          +'<td style="text-align:right">'+_esc(l.qtyCtn)+'</td>'
          +'<td style="text-align:right;font-variant-numeric:tabular-nums">'
            +_txtPrecio(l.precio)+'</td>'
          +'<td>'+edit('compEsp',l.compEsp, falta?'var(--t-marron)':null)
            +'<div style="font-size:10px;color:var(--text-muted);margin-top:3px" '
            +'title="'+_esc(l.comp)+'">'+_esc(String(l.comp).slice(0,62))+'</div></td>'
          +'</tr>';
      }).join('')
    +'</tbody></table></div>';

  h+='<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;'
    +'margin-top:14px;flex-wrap:wrap">'
    +'<span style="font-size:11.5px;color:var(--text-muted)">'
    +'Se descarga un .txt por cada hoja marcada.</span>'
    +'<button class="btn bp" onclick="_txtGenerar()">'
    +'<i class="ti ti-download"></i> Generar los archivos</button></div>';

  c.innerHTML=h;
}

function _txtAvisoHTML(){
  var d=window._txtDatos; if(!d) return '';
  var faltan=d.lineas.filter(function(l){ return !String(l.compEsp||'').trim(); }).length;
  var listas=d.lineas.length-faltan;
  var pct=d.lineas.length ? Math.round(listas/d.lineas.length*100) : 100;
  if(!faltan){
    return '<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde)">'
      +'<i class="ti ti-circle-check"></i> Las '+d.lineas.length
      +' composiciones en español están escritas.</div>';
  }
  return '<div style="background:var(--pastel-aviso);border:0.5px solid #E0A82E;'
    +'border-radius:11px;padding:11px 14px">'
    +'<div style="font-size:12.5px;color:var(--t-marron);line-height:1.5">'
    +'<b>Faltan '+faltan+' composiciones en español.</b> Ese dato no viene en la proforma, '
    +'hay que escribirlo. Debajo de cada casilla está la versión en inglés como referencia. '
    +'Lo que dejes vacío sale en blanco y habrá que llenarlo dentro de SAP.</div>'
    +'<div style="height:5px;background:#fff;border-radius:3px;overflow:hidden;margin-top:9px">'
    +'<div style="height:100%;width:'+pct+'%;background:var(--t-marron)"></div></div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-top:4px">'
    +listas+' de '+d.lineas.length+' listas</div></div>';
}

function _txtPintarAviso(){
  var e=document.getElementById('txtAviso');
  if(e) e.innerHTML=_txtAvisoHTML();
}

function _txtGenerar(){
  var d=window._txtDatos; if(!d) return;
  var dkc=String((document.getElementById('txtDkc')||{}).value||d.dkc||'').trim().replace(/\s+/g,'');
  if(!dkc){ _txtMsg('Pon el número de DKC para nombrar los archivos.','err'); return; }

  var hechos=[];
  try{
    if(d.sel.creacion){ _txtDescargar('CREACION'+dkc+'.txt', _txtCreacion(d)); hechos.push('artículos'); }
    if(d.sel.empaque){  _txtDescargar('EMPAQUE'+dkc+'.txt',  _txtEmpaque(d));  hechos.push('empaque'); }
    if(d.sel.udf){      _txtDescargar('UDF_'+dkc+'.txt',     _txtUdf(d));      hechos.push('UDF'); }
  }catch(e){ _txtMsg('No se pudo generar: '+_esc(e.message||e),'err'); return; }

  if(!hechos.length){ _txtMsg('No hay ninguna hoja marcada.','err'); return; }
  _txtMsg('✓ Descargado(s): '+hechos.join(', ')+' · '+d.lineas.length+' artículo(s) en cada uno.','ok');
  try{ _accRegistrar('ordennosap','Generó las hojas de creación de '+dkc); }catch(e){}
}

// La foto de un artículo de una orden NO SAP, mirando en el mismo orden que
// el resto del portal: la que trae el artículo, la del catálogo NO SAP y por
// último la de SAP si el nombre de archivo está guardado.
function _pendSAPFotoDe(it){
  if(!it) return '';
  var propia = it._foto || it.foto || it.foto_url || it.imagen_url || '';
  if(propia) return propia;
  try{
    var cat=_fotoNoSapDeSku(it.itemcode);
    if(cat) return cat;
  }catch(e){}
  if(it.picturname){ try{ return _repFotoUrl(it.picturname); }catch(e){} }
  return '';
}

/* ═══════════════════════════════════════════════════════════════════════════
   ORDEN DE COMPRA EN SAP  ·  desde la proforma
   ───────────────────────────────────────────────────────────────────────────
   Se lee la proforma, se comprueba contra lo que el portal ya tiene de SAP
   (proveedores e inventario) y se deja la petición en la cola. El worker la
   crea por DI API: cabecera OPOR, líneas POR1.

   Lo que SAP necesita de verdad son cinco cosas: proveedor, Vendor Ref. No.,
   y por cada línea el código de artículo, la cantidad y el precio. Todo lo
   demás lo pone SAP.

   Aquí NO se crea nada: solo se pide. El worker vuelve a comprobarlo todo
   contra SAP antes de tocar nada, porque el portal trabaja con una copia que
   puede estar desfasada.
   ═══════════════════════════════════════════════════════════════════════════ */

function _ocPuede(){
  return !!CU && (_esCompras() || CU.role==='gerencia');
}

window._ocDatos=null;

// Las columnas se buscan por su título, como en las hojas de creación.
var OC_COLS={
  'KENNEDYITEM':'itemcode', 'ITEMNO':'itemcode', 'SKU':'itemcode',
  'UNITPRICE':'precio', 'PRECIO':'precio',
  'KENNEDYQTYPCS':'cantidad', 'QUANTITY':'cantidad', 'CANTIDAD':'cantidad',
  'ENGLISHDESCRIPTION':'desc', 'ITEMDESCRIPTION':'desc', 'DESCRIPCION':'desc'
};

async function _ocLeerProforma(file){
  var ExcelJSlib=await _bkExcelJS();
  var wb=new ExcelJSlib.Workbook();
  await wb.xlsx.load(await file.arrayBuffer());

  var d=_profDetectar(wb, ['itemcode','cantidad','precio']);
  if(!d) throw new Error('No encontré la tabla de artículos. La proforma debe tener '
    +'una fila de títulos con el código del artículo (KCC ITEM No. o KENNEDY ITEM #), '
    +'la cantidad (ORDER QTY o KENNEDY QTY) y el precio (UNIT PRICE).');
  var ws=d.ws, col=d.col;

  var lineas=[];
  for(var r=d.cab+1; r<=ws.rowCount; r++){
    var code=String(_profVal(ws,r,col.itemcode)).trim();
    // Se corta en la primera fila sin artículo: debajo vienen los totales.
    // No se exige que el código sea numérico: los hay como MUESTRA-HOGAR.
    if(!code || /^TOTAL/i.test(_bkNorm(code))) break;
    if(_profEsCabecera(code)) continue;      // fila de títulos repetida
    var cant=Number(_profVal(ws,r,col.cantidad))||0;
    var pu=Number(_profVal(ws,r,col.precio))||0;
    if(!cant) continue;
    // Se guarda todo lo que la proforma tenga del artículo: si hay que
    // crearlo en SAP, la rejilla ya sale rellena y no hay que teclearlo.
    lineas.push({
      itemcode:code, cantidad:cant, precio:pu,
      desc:String(_profVal(ws,r,col.ing)||_profVal(ws,r,col.esp)||'').trim(),
      itemname:String(_profVal(ws,r,col.esp)||_profVal(ws,r,col.ing)||'').trim(),
      foreign_name:String(_profVal(ws,r,col.ing)||'').trim(),
      barcode:String(_profVal(ws,r,col.barcode)||'').trim(),
      mfr_catalog:String(_profVal(ws,r,col.factory)||'').trim(),
      // Empaque
      pzs_bulto_compra:_profVal(ws,r,col.qtyCtn)||'',
      pzs_bulto_venta:_profVal(ws,r,col.qtyCtn)||'',
      volumen_compra:_profVal(ws,r,col.cbm)||'',
      // Campos de usuario: lo que la proforma sí trae
      udf_color:String(_profVal(ws,r,col.color)||'').trim(),
      udf_color_ing:String(_profVal(ws,r,col.colorIng)||'').trim(),
      udf_tamano:String(_profVal(ws,r,col.size)||'').trim(),
      udf_comp_ing:String(_profVal(ws,r,col.comp)||'').trim(),
      udf_bulto:String(_profVal(ws,r,col.carton)||'').trim()
    });
  }
  if(!lineas.length) throw new Error('Encontré la cabecera pero ninguna línea con cantidad.');

  var txt=(file.name||'')+' '+ws.name;
  var m=/([DSGW]KC[-\s]?[A-Z0-9]{3,8})/i.exec(txt);
  var prov=null;
  try{ prov=_ocProveedorDeProforma(ws, d.cab); }
  catch(e){ console.warn('[OC] datos del proveedor:', e); }
  return {lineas:lineas, hoja:ws.name, archivo:file.name,
          dkc:m?m[1].toUpperCase().replace(/\s/g,''):'',
          cardcode:'', cardname:'', provNuevo:prov||undefined};
}

// ── Comprobación contra lo que el portal tiene de SAP ───────────────────
async function _ocComprobar(d){
  var codes=d.lineas.map(function(l){ return l.itemcode; });
  var mapa={};
  for(var i=0;i<codes.length;i+=80){
    var lote=codes.slice(i,i+80)
      .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    try{
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,cardcode'
        +'&itemcode=in.('+encodeURIComponent(lote)+')&limit=500',{headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){ mapa[String(x.itemcode)]=x; });
    }catch(e){ console.warn('[OC] comprobar artículos:', e); }
  }
  d.lineas.forEach(function(l){
    var it=mapa[l.itemcode];
    l.enSap=!!it;
    l.nombreSap=it?(it.itemname||''):'';
    if(it && it.cardcode) l.provSugerido=it.cardcode;
  });
  // El proveedor, POR SU NOMBRE. Esto faltaba: se cruzaban los artículos pero
  // nunca se buscaba al proveedor, así que uno que ya existía en SAP salía
  // como «Nuevo» hasta que el worker lo encontraba al crear la orden. El aviso
  // llegaba tarde y asustaba.
  if(!d.cardcode && d.provNuevo && d.provNuevo.cardname){
    var hallado=await _ocBuscarProveedor(d.provNuevo.cardname);
    if(hallado){
      d.cardcode=hallado.cardcode;
      d.cardname=hallado.cardname;
      d.provPorNombre=true;          // para poder decir cómo se encontró
    }
  }

  // Si aún no hay proveedor, se propone el más repetido entre los artículos
  if(!d.cardcode){
    var cuenta={};
    d.lineas.forEach(function(l){ if(l.provSugerido) cuenta[l.provSugerido]=(cuenta[l.provSugerido]||0)+1; });
    var mejor=Object.keys(cuenta).sort(function(a,b){ return cuenta[b]-cuenta[a]; })[0];
    if(mejor) d.cardcode=mejor;
  }
  if(d.cardcode){
    try{
      var rp=await fetch(SB+'/rest/v1/proveedores?select=cardcode,cardname&cardcode=eq.'
        +encodeURIComponent(d.cardcode)+'&limit=1',{headers:SBH});
      if(rp.ok){ var p=(await rp.json()||[])[0]; if(p) d.cardname=p.cardname||''; }
    }catch(e){}
  }
  return d;
}

// ── La pantalla ─────────────────────────────────────────────────────────
function rOrdenSap(){
  _tbxEstilos(); _arrInit();
  var pg=document.getElementById('page-ordensap');
  if(!pg) return;
  if(!_ocPuede()){
    pg.innerHTML='<div class="empty">Esta pantalla es de compras y gerencia.</div>';
    return;
  }
  var d=window._ocDatos;
  // Si no hay nada cargado pero quedó un borrador, se recupera solo: es lo
  // que se espera al volver de hacer otra cosa.
  if(!d){
    try{
      var _b=_ocLeerBorrador();
      if(_b && _b.datos && ((_b.datos.lineas)||[]).length){
        window._ocDatos=_b.datos;
        window._ocFotos=window._ocFotos||{};
        Object.keys(_b.fotos||{}).forEach(function(k){
          if(!window._ocFotos[k]) window._ocFotos[k]=_b.fotos[k]; });
        d=window._ocDatos;
        setTimeout(function(){
          showT('Seguimos donde lo dejaste · '+((d.lineas)||[]).length+' línea(s)'); }, 350);
      }
    }catch(e){}
  }
  pg.innerHTML=
     '<div class="sec">'
    +  '<div class="sec-h"><h2>Crear orden de compra en SAP</h2></div>'
    +  (d ? _ocBarra(d) : (_ocBorradorCartel() + _ocZona()))
    +  '<input type="file" id="ocFile" accept=".xlsx" style="display:none" onchange="_ocCargar(this)">'
    +  '<div id="ocEstado" style="font-size:12px;margin:10px 0;line-height:1.5"></div>'
    +  '<div id="ocCuerpo"></div>'
    +'</div>';
  if(d) _ocPintarTodo(); else _ocEngancha();
  _ocCargarHistorial();
}

function _ocZona(){
  return '<div id="ocDrop" onclick="document.getElementById(\'ocFile\').click()" '
    +'style="border:1.5px dashed var(--border-accent);border-radius:14px;padding:32px 20px;'
    +'text-align:center;cursor:pointer;background:var(--bg-accent)">'
    +'<i class="ti ti-file-invoice" style="font-size:32px;color:var(--t-azul)"></i>'
    +'<div style="font-size:15px;font-weight:600;margin-top:10px">Suelta aquí la proforma</div>'
    +'<div style="font-size:12.5px;color:var(--text-secondary);margin-top:5px;line-height:1.6;'
    +'max-width:540px;margin:5px auto 0">Se leen el proveedor, los artículos, las cantidades '
    +'y los precios, y con eso se crea la orden de compra directamente en SAP.</div>'
    +'<div style="margin-top:14px"><span class="btn bp" style="pointer-events:none">'
    +'<i class="ti ti-file-upload"></i> Elegir el archivo</span></div></div>'
    +'<div id="ocHist" style="margin-top:18px"></div>';
}
function _ocEngancha(){
  var z=document.getElementById('ocDrop'); if(!z) return;
  ['dragenter','dragover'].forEach(function(ev){
    z.addEventListener(ev,function(e){ e.preventDefault(); z.style.background='var(--pastel-azul)'; }); });
  ['dragleave','drop'].forEach(function(ev){
    z.addEventListener(ev,function(e){ e.preventDefault(); z.style.background='var(--bg-accent)'; }); });
  z.addEventListener('drop',function(e){
    var f=e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0];
    if(f) _ocCargar({files:[f], value:''});
  });
}

function _ocBarra(d){
  var deOrden=!!d.desdeNoSap;
  return '<div style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;'
    +'background:'+(deOrden?'var(--pastel-azul)':'var(--surface-1)')+';'
    +'border:0.5px solid '+(deOrden?'#85B7EB':'var(--border)')+';border-radius:11px;'
    +'padding:11px 14px;margin-bottom:14px">'
    +'<i class="ti '+(deOrden?'ti-clipboard-check':'ti-file-invoice')
    +'" style="font-size:20px;color:var(--t-azul)"></i>'
    +'<div><div style="font-size:13px;font-weight:600">'+_esc(d.archivo||'Proforma')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">'+d.lineas.length+' líneas'
    +(deOrden?' · los datos salen de la orden, no de un Excel':'')+'</div></div>'
    +(deOrden?('<button class="xb" onclick="go(\'ordenes\')">'
      +'<i class="ti ti-arrow-back-up"></i> Volver a la orden</button>'):'')
    // Guardar a mano, además del guardado automático. Al lado dice cuándo
    // fue la última vez, para saber que está a salvo.
    +'<button class="btn bg2" style="padding:7px 12px;font-size:11.5px" '
    +'onclick="_ocGuardarDraftBoton()" title="Se guarda solo cada pocos segundos; '
    +'este botón lo fuerza ahora"><i class="ti ti-device-floppy"></i> '
    +'Guardar borrador</button>'
    +'<span id="ocDraftAviso" style="font-size:10.5px;color:var(--text-muted)">'
    +_esc(_ocDraftCuando())+'</span>'
    +'<label style="font-size:11px;color:var(--text-muted)">Proveedor en SAP<br>'
      +'<input id="ocCard" value="'+_esc(d.cardcode||'')+'" placeholder="P1526" '
      +'onchange="window._ocDatos.cardcode=this.value.trim();_ocProvALasLineas();_ocRevisar()" '
      +'style="font-size:13px;font-weight:600;padding:5px 9px;border:0.5px solid var(--border);'
      +'border-radius:7px;background:var(--surface-0);color:var(--text-primary);width:120px"></label>'
    +'<label style="font-size:11px;color:var(--text-muted)">Vendor Ref. No.<br>'
      +'<input id="ocDkc" value="'+_esc(d.dkc||'')+'" placeholder="DKC-26107" '
      +'oninput="window._ocDatos.dkc=this.value.trim()" '
      +'style="font-size:13px;font-weight:600;padding:5px 9px;border:0.5px solid var(--border);'
      +'border-radius:7px;background:var(--surface-0);color:var(--text-primary);width:150px"></label>'
    +'<div style="flex:1"></div>'
    +'<button class="xb" onclick="document.getElementById(\'ocFile\').click()">'
      +'<i class="ti ti-refresh"></i> Cambiar</button>'
    +'<button class="xb" style="color:var(--text-danger)" onclick="_ocQuitar()">'
      +'<i class="ti ti-x"></i> Quitar</button></div>';
}
// Baja el código del proveedor a la columna Proveedor de cada línea
function _ocProvALasLineas(){
  var d=window._ocDatos; if(!d) return;
  var cc=String(d.cardcode||'').trim();
  var viejo=String((_txtFijosGuardados()||{}).prov||'').trim();
  (d.lineas||[]).forEach(function(l){
    if(l.enSap) return;
    var v=String(l.proveedor||'').trim();
    if(!v || v===viejo || v==='589' || v!==cc) l.proveedor=cc;
  });
  try{ _ocPintarTodo(); }catch(e){}
}

function _ocQuitar(){
  if(window._ocDatos && (window._ocDatos.lineas||[]).length
     && !confirm('¿Descartar lo que tienes preparado?\n\n'
       +'Se guarda igualmente como borrador y puedes retomarlo al volver.')) return;
  _ocGuardarBorrador();
  window._ocDatos=null;
  rOrdenSap();
}
function _ocMsg(t,tipo){
  var e=document.getElementById('ocEstado'); if(!e) return;
  e.style.color = tipo==='err'?'#A32D2D':(tipo==='ok'?'#27500A':'var(--text-muted)');
  e.innerHTML=t;
}
async function _ocRevisar(){
  if(!window._ocDatos) return;
  await _ocComprobar(window._ocDatos);
  _ocPintar();
}

/* ── El borrador de la orden, guardado solo ───────────────────────────────
   Todo lo que se escribe en esta pantalla se guarda en el propio navegador
   cada pocos segundos y al salir. Al volver a entrar se recupera tal cual,
   aunque la orden no se haya mandado a SAP: antes, salir de la pantalla lo
   borraba todo y había que empezar de cero.                                */
var OC_BORRADOR_KEY='oc_borrador_v1';

function _ocGuardarBorrador(silencio){
  var d=window._ocDatos;
  if(!d || !(d.lineas||[]).length) return false;
  try{
    var copia=_ocPlano(d);
    localStorage.setItem(OC_BORRADOR_KEY, JSON.stringify({
      guardado:new Date().toISOString(),
      por:(CU&&CU.name)||'', dkc:d.dkc||d.docnum||d.desdeNoSap||'',
      fotos:_ocFotosGuardables(), datos:copia
    }));
    // Se comprueba que de verdad quedó: si el navegador lo rechaza (sin
    // espacio, modo privado…), mejor saberlo ahora que al volver y
    // encontrarse la pantalla vacía.
    var ok=!!localStorage.getItem(OC_BORRADOR_KEY);
    if(!ok) throw new Error('el navegador no lo guardó');
    return true;
  }catch(e){
    var msg=String(e && e.message || e);
    try{ _dbg('[OC] borrador: '+msg); }catch(x){}
    if(!silencio) showT('No pude guardar el borrador: '+msg, 9000);
    return false;
  }
}

/* Una copia LIMPIA de lo que hay en pantalla: solo texto, números y
   sí/no. Antes se usaba JSON.stringify del objeto entero y bastaba con que
   una línea llevara un archivo, una imagen o una referencia circular para
   que reventara y no se guardara nada. */
function _ocPlano(d){
  var val=function(v){
    if(v===null || v===undefined) return undefined;
    var t=typeof v;
    if(t==='number' || t==='boolean') return v;
    if(t==='string') return (v.length>4000 || v.indexOf('data:')===0) ? undefined : v;
    return undefined;                       // objetos, archivos, funciones: fuera
  };
  var plano=function(o){
    var out={};
    if(!o || typeof o!=='object') return out;
    Object.keys(o).forEach(function(k){
      var v=val(o[k]);
      if(v!==undefined) out[k]=v;
    });
    return out;
  };
  var out=plano(d);
  out.lineas=(d.lineas||[]).map(plano);
  if(d.provNuevo) out.provNuevo=plano(d.provNuevo);
  if(d.prov && typeof d.prov==='object') out.prov=plano(d.prov);
  if(Array.isArray(d.ordenes)) out.ordenes=d.ordenes.map(function(x){
    return (x && typeof x==='object') ? plano(x) : x; });
  return out;
}

// Las fotos ya subidas se guardan por su dirección, no por su contenido
function _ocFotosGuardables(){
  var out={};
  try{
    Object.keys(window._ocFotos||{}).forEach(function(k){
      var f=window._ocFotos[k];
      if(f && f.url) out[k]={url:f.url, origen:f.origen||''};
    });
  }catch(e){}
  return out;
}

// «Guardado hace un momento», para que se vea que no se pierde nada
function _ocDraftCuando(){
  var b=_ocLeerBorrador();
  if(!b || !b.guardado) return '';
  var seg=Math.max(0, Math.round((Date.now()-new Date(b.guardado).getTime())/1000));
  if(seg<60) return 'borrador guardado hace un momento';
  if(seg<3600) return 'borrador guardado hace '+Math.round(seg/60)+' min';
  return 'borrador guardado el '+_fechaHora(b.guardado);
}

function _ocGuardarDraftBoton(){
  _ocGuardarBorrador();
  var e=document.getElementById('ocDraftAviso');
  if(e){
    e.textContent='✓ guardado ahora';
    e.style.color='var(--t-verde)';
    setTimeout(function(){
      e.textContent=_ocDraftCuando(); e.style.color='var(--text-muted)'; }, 4000);
  }
  showT('✓ Guardado como borrador · lo retomas cuando quieras');
}

function _ocLeerBorrador(){
  try{
    var t=localStorage.getItem(OC_BORRADOR_KEY);
    return t ? JSON.parse(t) : null;
  }catch(e){ return null; }
}

function _ocBorrarBorrador(){
  try{ localStorage.removeItem(OC_BORRADOR_KEY); }catch(e){}
}

function _ocRecuperarBorrador(){
  var b=_ocLeerBorrador();
  if(!b || !b.datos) return;
  window._ocDatos=b.datos;
  try{
    window._ocFotos=window._ocFotos||{};
    Object.keys(b.fotos||{}).forEach(function(k){
      if(!window._ocFotos[k]) window._ocFotos[k]=b.fotos[k]; });
  }catch(e){}
  rOrdenSap();
  showT('✓ Recuperado lo que estabas preparando');
}

// El aviso de que hay algo a medias, para retomarlo o descartarlo
function _ocBorradorCartel(soloSiHay){
  var b=_ocLeerBorrador();
  if(!b || !b.datos) return '';
  var n=((b.datos.lineas)||[]).length;
  return '<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron);'
    +'display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:10px">'
    +'<i class="ti ti-device-floppy" style="font-size:17px"></i>'
    +'<div style="flex:1;font-size:12px">Tienes una orden a medias'
    +(b.dkc?(' · <b>'+_esc(b.dkc)+'</b>'):'')+' · '+n+' línea(s) · guardada el '
    +_esc(_fechaHora(b.guardado))+'</div>'
    +'<button class="btn bp" style="padding:6px 12px;font-size:11.5px" '
    +'onclick="_ocRecuperarBorrador()"><i class="ti ti-arrow-back-up"></i> Retomarla</button>'
    +'<button class="xb" onclick="_ocBorrarBorrador();rOrdenSap()">Descartar</button></div>';
}

// Se guarda al escribir en cualquier casilla y cada 5 segundos
(function _ocAutoguardado(){
  try{
    setInterval(function(){
      if(window._ocDatos && (window._ocDatos.lineas||[]).length) _ocGuardarBorrador();
    }, 5000);
    window.addEventListener('beforeunload', _ocGuardarBorrador);
    // Y en cuanto se toca una casilla o se cambia de pestaña
    document.addEventListener('change', function(e){
      if(!window._ocDatos) return;
      var t=e.target;
      if(t && t.closest && t.closest('#page-ordensap')) _ocGuardarBorrador();
    }, true);
    document.addEventListener('visibilitychange', function(){
      if(document.hidden) _ocGuardarBorrador();
    });
  }catch(e){}
})();

async function _ocCargar(input){
  var f=input&&input.files&&input.files[0];
  input.value='';
  if(!f) return;
  try{
    _ocMsg('Leyendo '+_esc(f.name)+'…');
    var d=await _ocLeerProforma(f);
    _ocMsg('Comprobando los artículos contra SAP…');
    await _ocComprobar(d);
    window._ocDatos=d;
    _ocGuardarBorrador();
    rOrdenSap();
  }catch(e){
    _ocMsg(_esc(e.message||String(e)),'err');
    var c=document.getElementById('ocCuerpo'); if(c) c.innerHTML='';
  }
}

// La pantalla vieja quedó viva y _ocSetProv seguía llamándola: al escribir
// el nombre del proveedor saltaba a ella y salían sus avisos («falta el
// código de proveedor»), que en el asistente ya no tienen sentido. Ahora hay
// una sola.
function _ocPintar(){ return _ocPintarTodo(); }

async function _ocEnviar(){
  var d=window._ocDatos; if(!d) return;
  if(!d.cardcode){ _ocMsg('Falta el proveedor.','err'); return; }
  if(d.lineas.some(function(l){ return !l.enSap; })){
    _ocMsg('Hay artículos que no están en SAP.','err'); return;
  }
  var total=d.lineas.reduce(function(a,l){ return a+(l.cantidad*l.precio); },0);
  if(!confirm('Crear la orden de compra en SAP\n\n'
    +'Proveedor: '+d.cardcode+(d.cardname?(' · '+d.cardname):'')+'\n'
    +'Vendor Ref. No.: '+(d.dkc||'(sin referencia)')+'\n'
    +'Líneas: '+d.lineas.length+'\n'
    +'Total: '+_fmtN2(total)+'\n\n¿Sigo?')) return;

  _ocMsg('Enviando la petición al worker…');
  try{
    var fila={
      dkc:d.dkc||null, numatcard:d.dkc||null,
      cardcode:d.cardcode, cardname:d.cardname||null,
      docdate:new Date().toISOString().slice(0,10),
      comments:'Creada desde el portal · '+(d.archivo||''),
      lineas:d.lineas.map(function(l){
        return {itemcode:l.itemcode, quantity:l.cantidad, price:l.precio};
      }),
      total:total, estado:'pendiente', creado_por:(CU&&CU.name)||'',
      // Venta directa: el worker cuelga la orden del pedido del cliente,
      // como hace SAP con el asistente de aprovisionamiento.
      venta_directa:!!_vdDeLaOrden(d.dkc),
      pedido_venta:_vdDeLaOrden(d.dkc)
    };
    var r=await fetch(SB+'/rest/v1/ordenes_compra_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      if(t.indexOf('duplicate')>=0 || r.status===409)
        throw new Error('Ya hay una petición viva con esa referencia ('+(d.dkc||'')+').');
      throw new Error('error '+r.status+' · '+t.slice(0,160));
    }
    _ocMsg('✓ Petición enviada. El worker la crea en SAP en el próximo ciclo; '
      +'el resultado sale abajo.','ok');
    window._ocDatos=null;
    setTimeout(rOrdenSap, 1200);
  }catch(e){
    _ocMsg('No se pudo enviar: '+_esc(e.message||e),'err');
  }
}

// ── Lo que ya se pidió ──────────────────────────────────────────────────
async function _ocCargarHistorial(){
  var c=document.getElementById('ocHist'); if(!c) return;
  try{
    var r=await fetch(SB+'/rest/v1/ordenes_compra_queue?select=*&order=creado_en.desc&limit=12',
      {headers:Object.assign({},SBH,{'Cache-Control':'no-cache'}), cache:'no-store'});
    if(!r.ok) throw new Error('estado '+r.status);
    var filas=await r.json()||[];
    if(!filas.length){ c.innerHTML=''; return; }
    var color={pendiente:['var(--pastel-aviso)','var(--t-marron)','En cola'],
               en_curso:['var(--pastel-azul)','var(--t-azul)','Creándose'],
               creada:['var(--pastel-ok)','var(--t-verde)','Creada'],
               error:['var(--pastel-error)','var(--t-rojo)','Falló']};
    // Una que lleva mucho «creándose» es que se quedó a medias: el worker se
    // reinició o SAP no respondió. Se marca para no estar mirando la pantalla.
    var _atasco=function(f){
      if(String(f.estado)!=='en_curso') return false;
      var t=Date.parse(f.creado_en||'');
      return t && (Date.now()-t) > 10*60*1000;
    };
    c.innerHTML=await _ocPanelFotos()
      +_colaAviso(filas)
      +'<div style="font-size:12px;font-weight:600;margin-bottom:8px">'
      +'Últimas peticiones</div>'
      +'<table class="tb" style="font-size:11.5px"><thead><tr>'
      +'<th>Ref.</th><th>Proveedor</th><th style="text-align:right">Líneas</th>'
      +'<th style="text-align:right">Total</th><th>Estado</th><th>Orden en SAP</th>'
      +'<th>Cuándo</th></tr></thead><tbody>'
      + filas.map(function(f){
          var col=color[f.estado]||['var(--surface-1)','var(--text-muted)',f.estado];
          if(_atasco(f)) col=['var(--pastel-aviso)','var(--t-marron)','Atascada'];
          var n=Array.isArray(f.lineas)?f.lineas.length:0;
          return '<tr>'
            +'<td style="font-weight:600">'+_esc(f.dkc||'—')+'</td>'
            +'<td>'+_esc(f.cardcode||'')+(f.cardname?(' <span style="color:var(--text-muted)">'
                +_esc(f.cardname)+'</span>'):'')+'</td>'
            +'<td style="text-align:right">'+n+'</td>'
            +'<td style="text-align:right">'+_fmtN2(f.total||0)+'</td>'
            +'<td><span class="badge" style="background:'+col[0]+';color:'+col[1]+'">'
              +col[2]+'</span></td>'
            +'<td>'+(f.docnum_sap?('<b>#'+_esc(f.docnum_sap)+'</b>'):'—')+'</td>'
            +'<td style="font-size:10.5px;color:var(--text-muted);white-space:nowrap">'
              +_esc(_fechaHora(f.creado_en))
              +(f.error_msg
                ? ('<button class="xb" style="padding:1px 6px;font-size:10px;'
                   +'margin-left:6px" title="Ver el detalle" '
                   +'onclick="_ocVerDetalle('+Number(f.id)+')">'
                   +(f.estado==='error'?'ver error':'ver avisos')+'</button>')
                : '')
              +'</td>'
            +'</tr>'
            ;
        }).join('')
      +'</tbody></table>';
    // Se sigue solo mientras haya algo esperando
    _colaSeguir('OC','ordensap', _ocCargarHistorial,
      filas.some(function(f){ return f.estado==='pendiente'||f.estado==='en_curso'; }));
  }catch(e){
    c.innerHTML='<div style="font-size:11.5px;color:var(--text-muted)">'
      +'No se pudo leer el historial ('+_esc(e.message||e)+'). '
      +'¿Corriste ordenes_compra_queue.sql?</div>';
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   DETECTAR LAS COLUMNAS DE UNA PROFORMA DE KENNEDY
   ───────────────────────────────────────────────────────────────────────────
   Cada proveedor rellena nuestra plantilla con los títulos algo distintos:
   una dice «KENNEDY ITEM #» y otra «KCC ITEM No.»; una «KENNEDY QTY PCS» y
   otra «ORDER QTY / Pcs». Buscarlos por un solo nombre fallaba con la mitad
   de los archivos.

   Aquí hay una lista de alias por campo, y se comprueba por CONTENIDO sobre
   el título normalizado. El orden importa: los patrones más específicos van
   primero, porque «CARTON SIZE» también contiene «SIZE» y «SPANISH
   Description» también contiene «DESCRIPTION».
   ═══════════════════════════════════════════════════════════════════════════ */
// A la lista general se le suman los títulos propios de ropa y alfombras,
// que vienen de sus plantillas. Se añaden al final para no estorbar a los
// de siempre.
var PROF_ALIAS=[
  // [campo, [patrones, del más específico al más general]]
  ['carton',   ['CARTONSIZE','TAMANOBULTO']],
  ['qtyCtn',   ['QTYXCTN','QTYCTN','PCSXCTN','UNIDADESXCAJA','PIEZASPORBULTO']],
  // Cubicaje y pesos. Las proformas chinas los rotulan casi siempre en
  // inglés y abreviados: N.W. es peso neto, G.W. peso bruto, MEAS medidas.
  ['cbm',        ['CBMXCTN','CBMPORBULTO','TOTALCBM','MEASUREMENT','MEAS','CBM','M3']],
  // Sin «NW» ni «GW» sueltos: son dos letras y aparecen dentro de otras
  // palabras. «Carton Width CM» contiene «NW» y se leía como peso neto.
  ['peso_neto',  ['NETWEIGHT','NWKGS','NWKG','PESONETO','PESOITEM']],
  ['peso_bruto', ['GROSSWEIGHT','GWKGS','GWKG','PESOBRUTO','PESOBULTO','PESOCAJA']],
  ['ctns',       ['TOTALCTNS','TOTALCARTONS','CTNS','CARTONS','BULTOS','CAJAS']],
  // Una factura del proveedor rotula distinto que nuestra proforma, y casi
  // siempre en inglés: ITEM NO., MODEL, ART NO., QTY, U/PRICE, AMOUNT.
  ['itemcode', ['KCCITEMNO','KENNEDYITEM','KCCITEM','ITEMNO','ITEMCODE','ARTNO',
                'ARTICLENO','MODELNO','MODEL','PARTNO','PN','REFNO','REFERENCE',
                'CODIGOKCC','CODIGO','SKU']],
  // El precio va ANTES que la cantidad a propósito: «Price/pcs» contiene
  // «PCS» y se leía como cantidad, con lo que el precio acababa en la
  // columna equivocada. Ningún título de cantidad contiene «PRICE».
  ['precio',   ['UNITPRICE','UPRICE','PRICEUSD','FOBPRICE','FOBUNITPRICE',
                'PRICEPCS','UNITCOST','PRICE','PRECIOUNITARIO','PRECIOUNIT',
                'PRECIO']],
  ['cantidad', ['ORDERQTY','KENNEDYQTY','QTYPCS','QUANTITY','TOTALQTY','QTY',
                'PCS','CANTIDAD','UNIDADES']],
  ['esp',      ['SPANISHDESCRIPTION','SPANISHNAME','DESCRIPCIONESPANOL','NOMBREESPANOL']],
  ['ing',      ['ENGLISHDESCRIPTION','PRODUCTDESCRIPTION','ITEMDESCRIPTION',
                'ENGLISHNAME','GOODSDESCRIPTION','COMMODITY','PRODUCTNAME',
                'DESCRIPTIONOFGOODS','DESCRIPTION','ITEMNAME']],
  ['factory',  ['FACTORYNO','FACTORYCODE','FACTORY','NODEFABRICA']],
  ['barcode',  ['BARCODE','CODIGODEBARRAS']],
  ['size',     ['ITEMSIZE','SIZECM','TAMANO','SIZE']],
  ['color',    ['COLORFINISHING','COLOR']],
  ['comp',     ['MATERIALCONSTRUCTION','MATERIALCOMP','MATERIAL','COMPOSICION']],
  ['colorIng', ['ITEMSPHOTO']]      // la 2ª columna de la foto trae el color en inglés
];

// Busca en TODAS las hojas la fila de títulos. Devuelve {ws, cab, col} o null.
// `obligatorios` son los campos sin los cuales no vale la pena seguir.
function _profDetectar(wb, obligatorios){
  var mejor=null;
  for(var h=0; h<wb.worksheets.length; h++){
    var w=wb.worksheets[h];
    var nF=Math.min(w.rowCount, 80), nC=Math.min(w.columnCount, 40);
    for(var r=1;r<=nF;r++){
      var col={}, usadas={};
      for(var c=1;c<=nC;c++){
        var v=w.getCell(_bkColS(c)+r).value;
        if(v && typeof v==='object')
          v=v.richText?v.richText.map(function(t){return t.text;}).join('')
             :(v.text!==undefined?v.text:(v.result!==undefined?v.result:''));
        var t=_bkNorm(v);
        if(!t) continue;
        for(var a=0;a<PROF_ALIAS.length;a++){
          var campo=PROF_ALIAS[a][0], pats=PROF_ALIAS[a][1];
          // colorIng se queda con la ÚLTIMA columna que coincide: «ITEM'S
          // PHOTO» ocupa dos y la primera es la imagen.
          if(col[campo]!==undefined && campo!=='colorIng') continue;
          if(usadas[c] && campo!=='colorIng') continue;
          for(var q=0;q<pats.length;q++){
            if(t.indexOf(pats[q])>=0){ col[campo]=c; usadas[c]=1; break; }
          }
          if(col[campo]===c) break;
        }
      }
      var faltan=obligatorios.filter(function(k){ return col[k]===undefined; });
      if(!faltan.length) return {ws:w, cab:r, col:col};
      // Se guarda el intento más completo, para poder decir qué faltó
      if(!mejor || faltan.length<mejor.faltan.length)
        mejor={ws:w, cab:r, col:col, faltan:faltan};
    }
  }
  return mejor && mejor.faltan.length<obligatorios.length ? null : null;
}

// Algunas proformas repiten la fila de títulos (DKC-TEST la tiene en la 14 y
// en la 15). Sin esto, la segunda se colaba como si fuera un artículo.
function _profEsCabecera(txt){
  var t=_bkNorm(txt);
  if(!t) return false;
  var pats=PROF_ALIAS.filter(function(a){ return a[0]==='itemcode'; })[0][1];
  for(var i=0;i<pats.length;i++) if(t.indexOf(pats[i])>=0) return true;
  return false;
}

// El valor de una celda, ya desenvuelto
function _profVal(ws, r, c){
  if(c===undefined) return '';
  var v=ws.getCell(_bkColS(c)+r).value;
  if(v===null||v===undefined) return '';
  if(typeof v==='object'){
    if(v.richText) return v.richText.map(function(t){return t.text;}).join('');
    if(v.result!==undefined) return v.result;
    if(v.text!==undefined) return v.text;
    return '';
  }
  return v;
}

/* ═══════════════════════════════════════════════════════════════════════════
   REPARAR ADJUNTOS  ·  los que están en Storage pero no en la tabla
   ───────────────────────────────────────────────────────────────────────────
   Un archivo de una etapa vive en dos sitios: el fichero en Storage y una
   fila en compras_documentos. La pantalla de quien lo sube lo enseña nada más
   subirlo; los demás lo leen de la tabla. Si la fila no llegó a escribirse,
   el archivo existe pero solo lo ve quien lo subió.

   Esto compara las dos cosas y escribe las filas que faltan. No sube ni borra
   nada: solo registra lo que ya está.
   ═══════════════════════════════════════════════════════════════════════════ */

async function _stListar(prefijo){
  var r=await fetch(SB+'/storage/v1/object/list/'+DOCS_BUCKET, {
    method:'POST',
    headers:Object.assign({}, SBH, {'Content-Type':'application/json'}),
    body:JSON.stringify({prefix:prefijo, limit:1000, offset:0,
                         sortBy:{column:'name', order:'asc'}})
  });
  if(!r.ok) throw new Error('Storage respondió '+r.status);
  var j=await r.json();
  return Array.isArray(j)?j:[];
}

async function _repararAdjuntos(oid){
  oid=String(oid||'').trim();
  if(!oid){ showT('Falta la orden'); return; }
  if(!CU || (CU.role!=='gerencia' && CU.role!=='compras' && CU.role!=='contabilidad')){
    showT('Esto es de compras, contabilidad y gerencia'); return;
  }
  // Una orden puede tener dos nombres: el de SAP y la DKC. Se miran los dos,
  // o en una orden que nació NO SAP diría que no hay nada.
  var refs=_refsDeOrden(oid);
  showT('Revisando los adjuntos de '+refs.join(' / ')+'…');
  try{
    // Lo que ya está registrado, bajo cualquiera de sus nombres
    var _in=refs.map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
    var r=await fetch(SB+'/rest/v1/compras_documentos?select=url,docnum&docnum=in.('
      +encodeURIComponent(_in)+')&limit=2000',{headers:SBH});
    var registrados={}, nReg=0, porEtapa={};
    if(r.ok) (await r.json()||[]).forEach(function(d){
      registrados[String(d.url)]=1; nReg++;
      var e=String(d.url||'').split('/')[1]||'?';
      porEtapa[e]=(porEtapa[e]||0)+1;
    });

    // Lo que hay de verdad en Storage, bajo cualquiera de sus nombres
    var huerfanos=[];
    for(var q=0;q<refs.length;q++){
     var base=refs[q];
     var carpetas=await _stListar(base+'/');
     for(var i=0;i<carpetas.length;i++){
      var c=carpetas[i];
      if(c.id) continue;                       // es un archivo suelto, no carpeta
      var etapa=c.name;
      var files=await _stListar(base+'/'+etapa+'/');
      files.forEach(function(f){
        if(!f.id) return;                      // subcarpeta
        var url=base+'/'+etapa+'/'+f.name;
        if(registrados[url]) return;
        // El nombre real va detrás del sello de tiempo: 1736...._archivo.pdf
        var nombre=String(f.name).replace(/^\d{10,}_/,'');
        huerfanos.push({url:url, etapa:etapa, nombre:nombre, base:base,
                        subido_en:(f.created_at||new Date().toISOString())});
      });
     }
    }

    if(!huerfanos.length){
      // Sirve de diagnóstico: si aquí dice que están todos registrados y aun
      // así alguien no los ve, el problema NO es el guardado sino lo que se
      // pinta, y hay que mirar por otro lado.
      // Si no hay nada en compras_documentos, el archivo puede estar en otro
      // sitio. Se mira en todos antes de decir que no existe: perseguir esto
      // a ciegas ya costó varias vueltas.
      var otros=await _dondeEstaElArchivo(refs);
      var detalle=Object.keys(porEtapa).map(function(e){
        return e+': '+porEtapa[e]; }).join(' · ');
      var msg='Adjuntos de '+refs.join(' / ')+':  '
        +nReg+' en documentos de la orden'
        +(detalle?(' ['+detalle+']'):'')
        +' · '+otros.comprobantes+' comprobante(s) de pago'
        +' · '+otros.correos+' en correos enviados.';
      if(!nReg && !otros.comprobantes && !otros.correos)
        msg+='  No hay NINGÚN archivo guardado en el servidor para esta orden. '
          +'Si alguien lo ve en su pantalla, es que se quedó solo en su navegador '
          +'y hay que volver a subirlo.';
      else if(!nReg && otros.comprobantes)
        msg+='  El comprobante está en la solicitud de pago: ya sale como adjunto '
          +'de la etapa Depósito & Pago.';
      showT(msg, 20000);
      _dbg('[adjuntos] '+refs.join('/')+' →', {tabla:nReg, porEtapa:porEtapa, otros:otros});
      return;
    }

    if(!confirm('Adjuntos que solo ve quien los subió: '+huerfanos.length+'\n\n'
      + huerfanos.slice(0,10).map(function(h){ return '· '+h.etapa+' / '+h.nombre; }).join('\n')
      + (huerfanos.length>10?('\n· … y '+(huerfanos.length-10)+' más'):'')
      + '\n\n¿Los registro para que los vean todos?')) return;

    var ok=0, mal=[];
    for(var j=0;j<huerfanos.length;j++){
      var h=huerfanos[j];
      try{
        var rr=await fetch(SB+'/rest/v1/compras_documentos',{
          method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({
            docnum:oid, etapa:h.etapa, paso:null,
            nombre_archivo:h.nombre, url:h.url,
            tipo:(h.nombre.split('.').pop()||'').toLowerCase(),
            subido_por:'(recuperado)', subido_en:h.subido_en
          })});
        if(rr.ok) ok++;
        else { var t=''; try{ t=await rr.text(); }catch(e){} mal.push(h.nombre+': '+rr.status+' '+t.slice(0,90)); }
      }catch(e){ mal.push(h.nombre+': '+(e.message||e)); }
    }

    if(ok){
      try{ delete window._atts[oid]; }catch(e){}
      try{ await cargarDocsOrden(oid); }catch(e){}
      try{ if(typeof _refrescarPantalla==='function') _refrescarPantalla(); }catch(e){}
    }
    showT(ok+' adjunto(s) registrados · ahora los ven todos'
      +(mal.length?(' · '+mal.length+' fallaron: '+mal[0]):''), mal.length?14000:7000);
    if(mal.length) console.error('[reparar adjuntos]', mal);
  }catch(e){
    showT('No se pudo revisar: '+(e.message||e), 9000);
    console.error('[reparar adjuntos]', e);
  }
}

// La barra de mantenimiento de adjuntos dentro de una orden. Estaba solo en
// el panel de las órdenes NO SAP, así que en una orden de SAP no había forma
// de llegar a la reparación: justo donde hacía falta.
// _docsBarraOrden se quitó: solo servía para el botón de reparar adjuntos,
// que ya no hace falta. El botón de «Subir mis envíos» tampoco: el problema
// que lo motivó se arregló creando la columna `envio` en solicitudes_pago.
function _docsBarraOrden(o){ return ''; }


// ¿Dónde está el archivo? Busca en los sitios donde el portal guarda cosas
// de una orden que NO son documentos de etapa. Sirve para no volver a
// perseguir un adjunto a ciegas.
async function _dondeEstaElArchivo(refs){
  var out={comprobantes:0, correos:0, detalle:[]};
  var lista=refs.map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
  // 1. Comprobantes de pago guardados en la solicitud
  try{
    var r=await fetch(SB+'/rest/v1/solicitudes_pago?select=docnum,tipo,comprobante_path,'
      +'comprobante_nombre&docnum=in.('+encodeURIComponent(lista)+')',{headers:SBH});
    if(r.ok) (await r.json()||[]).forEach(function(x){
      if(x.comprobante_path){
        out.comprobantes++;
        out.detalle.push('comprobante '+(x.tipo||'')+': '+(x.comprobante_nombre||x.comprobante_path));
      }
    });
  }catch(e){ console.warn('[adjuntos] solicitudes:', e); }
  // 2. Correos ya enviados que llevaban adjuntos de esta orden
  try{
    var r2=await fetch(SB+'/rest/v1/correos_queue?select=docnum,asunto,adjuntos,estado'
      +'&docnum=in.('+encodeURIComponent(lista)+')&limit=50',{headers:SBH});
    if(r2.ok) (await r2.json()||[]).forEach(function(c){
      var a=c.adjuntos;
      if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ a=[]; } }
      if(Array.isArray(a) && a.length){
        out.correos+=a.length;
        out.detalle.push('correo «'+String(c.asunto||'').slice(0,40)+'»: '
          +a.map(function(z){ return z.nombre||''; }).join(', '));
      }
    });
  }catch(e){ console.warn('[adjuntos] correos:', e); }
  return out;
}

// Los archivos que se mandaron por correo desde una etapa quedan dentro del
// correo (correos_queue.adjuntos, en base64) y no como documento de la orden.
// Quien los adjuntó los ve en su pantalla mientras dura la sesión; los demás
// no los ven nunca. Aquí se sacan de ahí y se enseñan en su etapa.
async function _docsDeCorreos(oid){
  try{
    var refs=_refsDeOrden(oid);
    var lista=refs.map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
    var r=await fetch(SB+'/rest/v1/correos_queue?select=docnum,asunto,adjuntos,origen,'
      +'de_nombre,creado_en,estado&docnum=in.('+encodeURIComponent(lista)+')'
      +'&limit=100',{headers:SBH});
    if(!r.ok){
      var _t=''; try{ _t=await r.text(); }catch(e){}
      _dbg('[docs] correos: estado '+r.status+' · '+_t.slice(0,160));
      return 0;
    }
    var filas=await r.json()||[];
    var n=0;
    for(var fi=0; fi<filas.length; fi++){
      var c=filas[fi];
      var adj=c.adjuntos;
      if(typeof adj==='string'){ try{ adj=JSON.parse(adj); }catch(e){ adj=[]; } }
      if(!Array.isArray(adj) || !adj.length) continue;

      var suf=_etapaDesdeOrigen(c.origen);
      var k=oid+suf;
      if(!window._atts[k]) window._atts[k]=[];

      for(var ai=0; ai<adj.length; ai++){
        var a=adj[ai];
        if(!a || !a.nombre || !a.contenido) continue;
        // Ya estaba, venga de donde venga
        if(window._atts[k].some(function(x){
             return _docNombreClave(x)===_docNombreClave({name:a.nombre}); })) continue;

        // Se COPIA a Storage y se registra como un documento más de la orden.
        // Antes se servía como data: dentro del propio HTML, y eso metía el
        // archivo entero en base64 en un atributo onclick: cientos de KB por
        // archivo, y todos los caminos de descarga y vista previa había que
        // tratarlos aparte. Copiándolo una vez se comporta como cualquier
        // otro adjunto y lo ve todo el equipo.
        var guardado=null;
        try{ guardado=await _guardarAdjuntoDeCorreo(oid, suf, a); }
        catch(e){ console.warn('[docs] copiar adjunto de correo:', e); }

        window._atts[k].push(guardado ? {
          id:guardado.id, name:a.nombre,
          data: DOCS_BASE + guardado.url.split('/').map(encodeURIComponent).join('/'),
          url:guardado.url, date:String(c.creado_en||'').slice(0,10),
          by:c.de_nombre||'', remoto:true, _deCorreo:true
        } : {
          // Si la copia falla, al menos se ve desde el propio correo
          name:a.nombre,
          data:'data:'+(a.mime||'application/octet-stream')+';base64,'+a.contenido,
          date:String(c.creado_en||'').slice(0,10),
          by:c.de_nombre||'', remoto:true, _deCorreo:true
        });
        n++;
      }
    }
    return n;
  }catch(e){ console.warn('[docs] correos:', e); return 0; }
}

// Copia a Storage un adjunto que vino dentro de un correo y lo registra en
// compras_documentos. Devuelve {id, url} o null.
async function _guardarAdjuntoDeCorreo(oid, subKey, a){
  // base64 → Blob, sin pasar por fetch(data:) que algunos navegadores cortan
  var bin=atob(String(a.contenido||''));
  var buf=new Uint8Array(bin.length);
  for(var i=0;i<bin.length;i++) buf[i]=bin.charCodeAt(i);
  var file=new File([buf], a.nombre, {type:a.mime||'application/octet-stream'});

  var path=await _subirDocStorage(oid, subKey, file);
  if(!path) return null;
  var reg=await _registrarDoc(oid, subKey, file, path);
  if(!reg || reg._error){
    _dbg('[docs] el adjunto se copió pero no se registró:',
      (reg&&reg._error)||'sin respuesta');
    return {id:undefined, url:path};
  }
  return {id:reg.id, url:path};
}

// `origen` se guarda como «Depósito & Pago → Comprobante enviado al proveedor».
// De ahí salen la etapa y el paso, que es donde tiene que verse el archivo.
function _etapaDesdeOrigen(origen){
  var txt=String(origen||'').trim();
  if(!txt) return 'pedido';
  var partes=txt.split('\u2192');                 // la flecha que usa el envío
  var etiqueta=String(partes[0]||'').trim();
  var paso=String(partes[1]||'').trim();
  var st=(STAGES||[]).find(function(x){
    return x.label===etiqueta || x.key===etiqueta;
  });
  if(!st){
    // Por si la etiqueta cambió de texto: se busca por parecido
    st=(STAGES||[]).find(function(x){
      return etiqueta && (etiqueta.indexOf(x.label)>=0 || String(x.label).indexOf(etiqueta)>=0);
    });
  }
  if(!st) return 'pedido';
  if(paso && st.steps){
    var i=st.steps.findIndex(function(p){ return p.name===paso; });
    if(i>=0) return st.key+'_step'+i;
  }
  return st.key;
}

// ═══════════════════════════════════════════════════════════════════════════
//  RECUPERAR LOS ENVÍOS QUE SE QUEDARON EN ESTE NAVEGADOR
//  Mientras faltó la columna `envio`, cada correo que mandó contabilidad se
//  guardó solo en su localStorage. Esto los sube a la base para que los vea
//  todo el equipo. Hay que correrlo DESDE EL EQUIPO de quien los envió.
// ═══════════════════════════════════════════════════════════════════════════
async function _solSubirEnviosLocales(){
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia' && CU.role!=='compras')){
    showT('Esto es de contabilidad, compras y gerencia'); return;
  }
  var pend=[];
  try{
    for(var i=0;i<localStorage.length;i++){
      var k=localStorage.key(i);
      if(!k || k.indexOf('sol_envio_')!==0) continue;
      var info=null;
      try{ info=JSON.parse(localStorage.getItem(k)); }catch(e){ continue; }
      if(!info || (!info.cuerpo && !info.asunto)) continue;
      // La clave es sol_envio_<docnum>_<tipo>, con UN guion bajo. Y el tipo
      // puede llevar los suyos (comprobante_abono, proveedor_cancelacion),
      // así que se parte por el PRIMERO: el número de orden no lleva.
      var resto=k.slice('sol_envio_'.length);
      var pos=resto.indexOf('_');
      if(pos<0) continue;
      pend.push({docnum:resto.slice(0,pos), tipo:resto.slice(pos+1), info:info});
    }
  }catch(e){ showT('No pude leer los envíos de este navegador'); return; }

  if(!pend.length){ showT('No hay envíos guardados solo en este equipo.'); return; }

  if(!confirm('Envíos que ahora mismo solo se ven en este equipo: '+pend.length+'\n\n'
    + pend.slice(0,10).map(function(p){
        return '· '+p.docnum+' ('+p.tipo+') '+(p.info.asunto||'').slice(0,40); }).join('\n')
    + (pend.length>10?('\n· … y '+(pend.length-10)+' más'):'')
    + '\n\n¿Los subo para que los vea todo el equipo?')) return;

  var ok=0, mal=[];
  for(var j=0;j<pend.length;j++){
    var p=pend[j];
    var x=(window._solPago||[]).find(function(s){
      return String(s.docnum)===String(p.docnum) && String(s.tipo)===String(p.tipo); });
    if(!x){ mal.push(p.docnum+' ('+p.tipo+'): no encuentro la solicitud'); continue; }
    try{
      var r=await _solPagoPatch(x.id, {envio:p.info});
      if(r){ x.envio=p.info; ok++; }
      else mal.push(p.docnum+': la base no lo aceptó (¿falta la columna «envio»?)');
    }catch(e){ mal.push(p.docnum+': '+(e.message||e)); }
  }
  showT(ok+' envío(s) subidos · ahora los ve todo el equipo'
    +(mal.length?(' · '+mal.length+' no se pudieron: '+mal[0]):''), mal.length?14000:8000);
  if(mal.length) console.error('[envíos locales]', mal);
  try{ _solRepintarDondeEste(); }catch(e){}
}

// Todo lo que hay en una etapa: sus documentos generales MÁS los de cada uno
// de sus pasos. Antes «Documentos generales» solo enseñaba lo que se subía a
// la etapa entera, así que un archivo adjuntado a un paso concreto (o llegado
// en un correo) no aparecía ahí y había que ir paso por paso a buscarlo.
function _attsDeLaEtapa(oid, stage){
  var propios=(window._atts && window._atts[oid+stage.key]) ? window._atts[oid+stage.key] : [];
  // Cada uno se lleva su posición REAL en el array de la etapa. El botón de
  // borrar trabaja por índice, y al mezclar listas ese índice dejaba de
  // apuntar al archivo correcto: se habría borrado otro.
  var out=_dedupDocs(propios.map(function(a,i){
    return Object.assign({}, a, {_idx:i});
  }));
  var vistos={};
  out.forEach(function(a){ vistos[_docNombreClave(a)]=1; });

  (stage.steps||[]).forEach(function(p, i){
    var lista=(window._atts && window._atts[oid+stage.key+'_step'+i]) || [];
    lista.forEach(function(a){
      var k=_docNombreClave(a);
      // Por nombre, no por ruta: el mismo comprobante puede estar subido a
      // mano en un paso y llegado por correo en otro, con rutas distintas.
      if(!k || vistos[k]) return;
      vistos[k]=1;
      // Se marca de qué paso viene y que aquí no se borra: se borra en su
      // paso, donde está el original.
      out.push(Object.assign({}, a, {_dePaso:p.name, _base:true, _idx:null}));
    });
  });
  return out;
}

/* ═══════════════════════════════════════════════════════════════════════════
   REJILLA EDITABLE  ·  pegar desde Excel
   ───────────────────────────────────────────────────────────────────────────
   Una tabla de celdas donde se puede escribir y, sobre todo, PEGAR varias
   columnas y filas de una vez desde un Excel abierto. Al pegar, el texto
   viene separado por tabuladores y saltos de línea, y se reparte a partir de
   la celda donde estás, creando filas si hacen falta.
   ═══════════════════════════════════════════════════════════════════════════ */

function _gridCelda(gid, fila, campo, valor, ancho){
  return '<input class="gc" data-g="'+gid+'" data-f="'+fila+'" data-c="'+campo+'" '
    +'value="'+_esc(valor==null?'':valor)+'" '
    +'onpaste="_gridPegar(event,this)" onkeydown="_gridTecla(event,this)" oninput="_gridCambio(this)" '
    +'style="width:'+(ancho||'100%')+';box-sizing:border-box;font-size:11.5px;'
    +'padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;'
    +'background:var(--surface-0);color:var(--text-primary)">';
}

// Una columna de valores cerrados. Sigue admitiendo pegar: si lo pegado
// coincide con una opción se selecciona, y si no, se deja en blanco antes que
// mandar a SAP un grupo que no existe.
function _gridLista(gid, fila, campo, valor, opciones, ancho){
  var v=String(valor==null?'':valor);
  return '<select class="gc" data-g="'+gid+'" data-f="'+fila+'" data-c="'+campo+'" '
    +'onchange="_gridCambio(this)" '
    +'style="width:'+(ancho||'100%')+';box-sizing:border-box;font-size:11.5px;'
    +'padding:4px 5px;border:0.5px solid var(--border);border-radius:5px;'
    +'background:var(--surface-0);color:var(--text-primary)">'
    +'<option value="">—</option>'
    + opciones.map(function(o){
        return '<option value="'+_esc(o)+'"'+(o===v?' selected':'')+'>'+_esc(o)+'</option>';
      }).join('')
    +'</select>';
}

// Dónde está cada rejilla y con qué columnas, para poder repartir lo pegado
window._grids = window._grids || {};

function _gridRegistrar(gid, cols, filas, alCambiar){
  window._grids[gid]={cols:cols, filas:filas, alCambiar:alCambiar};
}

function _gridCambio(el){
  var g=window._grids[el.getAttribute('data-g')];
  if(!g) return;
  var f=Number(el.getAttribute('data-f'));
  if(!g.filas[f]) g.filas[f]={};
  g.filas[f][el.getAttribute('data-c')]=el.value;
  if(g.alCambiar) try{ g.alCambiar(); }catch(e){}
}

/* Rellenar hacia abajo, como el cuadradito de Excel. Con el cursor en una
   casilla: Ctrl+D copia su valor a TODAS las filas de abajo, hasta el final
   de la tabla, se vean o no en pantalla; Ctrl+Shift+D lo pone en toda la
   columna. Antes solo se podía arrastrar sobre lo visible. */
function _gridRellenar(gid, campo, desde, valor, haciaArriba){
  var g=window._grids[gid]; if(!g) return 0;
  var n=0;
  for(var f=(haciaArriba?0:desde); f<g.filas.length; f++){
    if(!haciaArriba && f<desde) continue;
    if(!g.filas[f]) continue;
    g.filas[f][campo]=valor;
    var el=document.querySelector('.gc[data-g="'+gid+'"][data-f="'+f+'"][data-c="'+campo+'"]');
    if(el){
      el.value=valor;
      el.style.background='var(--pastel-ok)';
      (function(e){ setTimeout(function(){ e.style.background=''; }, 600); })(el);
    }
    n++;
  }
  if(g.alCambiar) try{ g.alCambiar(); }catch(e){}
  showT('✓ «'+(valor||'(vacío)')+'» puesto en '+n+' fila(s)');
  return n;
}

// Se engancha a cada casilla del grid
function _gridTecla(ev, el){
  if(!(ev.ctrlKey||ev.metaKey) || String(ev.key||'').toLowerCase()!=='d') return;
  ev.preventDefault();
  var gid=el.getAttribute('data-g'), campo=el.getAttribute('data-c');
  var f=Number(el.getAttribute('data-f'))||0;
  _gridRellenar(gid, campo, ev.shiftKey?0:f, el.value, ev.shiftKey);
}

function _gridPegar(ev, el){
  var txt=(ev.clipboardData||window.clipboardData).getData('text');
  if(!txt || txt.indexOf('\t')<0 && txt.indexOf('\n')<0) return;   // un solo valor: normal
  ev.preventDefault();

  var gid=el.getAttribute('data-g');
  var g=window._grids[gid]; if(!g) return;
  var f0=Number(el.getAttribute('data-f'));
  var c0=g.cols.indexOf(el.getAttribute('data-c'));
  if(c0<0) c0=0;

  // Excel manda \r\n y a veces deja una línea vacía al final
  var filas=txt.replace(/\r\n?/g,'\n').replace(/\n+$/,'').split('\n');
  var puestas=0, fuera=0;
  filas.forEach(function(linea, i){
    var celdas=linea.split('\t');
    var f=f0+i;
    if(!g.filas[f]){ fuera++; return; }        // se pegó más largo que la tabla
    celdas.forEach(function(v, j){
      var campo=g.cols[c0+j];
      if(!campo) return;                       // o más ancho
      var val=v.trim();
      g.filas[f][campo]=val;
      // Y AQUÍ estaba el fallo: se actualizaban los datos pero no las
      // casillas, así que al pegar no se veía nada y parecía que no hacía
      // nada. Hay que escribir también en lo que se ve.
      var el=document.querySelector('.gc[data-g="'+gid+'"][data-f="'+f+'"]'
                                    +'[data-c="'+campo+'"]');
      if(el){
        el.value=val;
        if(el.tagName==='SELECT' && el.value!==val) el.value='';  // no está en la lista
        el.style.background='var(--pastel-ok)';
        setTimeout(function(){ el.style.background=''; }, 700);
        puestas++;
      }
    });
  });
  showT('Pegadas '+puestas+' casilla(s) en '+Math.min(filas.length, filas.length-fuera)
    +' fila(s)'+(fuera?(' · '+fuera+' se salían de la tabla'):''));
  if(g.alCambiar) try{ g.alCambiar(); }catch(e){}
}

/* ═══════════════════════════════════════════════════════════════════════════
   ORDEN DE COMPRA COMPLETA  ·  proveedor + artículos + orden
   ───────────────────────────────────────────────────────────────────────────
   Tres colores para tres cosas distintas, que es lo que más confunde al
   revisar: el proveedor va en lila, los artículos en ámbar y la orden en
   azul. Y dentro de cada bloque se distingue lo que YA EXISTE en SAP (verde)
   de lo que se va a CREAR (borde de color).

   Nada se crea aquí: se deja todo en la cola y el worker lo hace en orden
   —proveedor, artículos, orden— comprobándolo otra vez contra SAP.
   ═══════════════════════════════════════════════════════════════════════════ */

// Las etiquetas con las que los proveedores rotulan sus datos. Casi todas
// las proformas vienen en inglés, así que van las dos formas. El orden
// importa: las más específicas primero, o «Tel» se queda con «Tel Fax».
var OC_ETIQUETAS=[
  ['contacto', /\b(?:CONTACT\s*PERSON|CONTACT|ATTN|ATENCION|A\s*LA\s*ATENCION|PERSONA\s*DE\s*CONTACTO)\b\s*[:.\-]?\s*(.+)$/i],
  ['movil',    /\b(?:MOBILE|CELL(?:ULAR)?|WHATSAPP|M[OÓ]VIL|CELULAR)\b\s*[:.\-]?\s*(.+)$/i],
  ['fax',      /\bFAX\b\s*[:.\-]?\s*(.+)$/i],
  ['tel1',     /\b(?:TEL(?:EPHONE|EFONO|\.)?|PHONE|TLF)\b\s*[:.\-]?\s*(.+)$/i],
  ['email',    /\b(?:E-?\s*MAIL|CORREO)\b\s*[:.\-]?\s*(.+)$/i],
  ['web',      /\b(?:WEB\s*SITE|WEBSITE|HTTP|WWW)\b\s*[:.\-]?\s*(.+)$/i],
  ['zip',      /\b(?:ZIP\s*CODE|ZIP|POST(?:AL)?\s*CODE|C[OÓ]DIGO\s*POSTAL|CP)\b\s*[:.\-]?\s*(.+)$/i],
  ['ciudad',   /\b(?:CITY|CIUDAD)\b\s*[:.\-]?\s*(.+)$/i],
  ['estado',   /\b(?:STATE|PROVINCE|PROVINCIA|ESTADO)\b\s*[:.\-]?\s*(.+)$/i],
  ['pais',     /\b(?:COUNTRY|PA[IÍ]S)\b\s*[:.\-]?\s*(.+)$/i],
  ['tax_id',   /\b(?:TAX\s*ID|VAT(?:\s*NO)?|RUC|NIT|TAX\s*NUMBER)\b\s*[:.\-]?\s*(.+)$/i],
  ['calle',    /\b(?:ADD?RESS|DIRECCI[OÓ]N|DOMICILIO)\b\s*[:.\-]?\s*(.+)$/i]
];

// Saca lo que pueda de un bloque de líneas del vendedor. Primero las que
// vienen rotuladas —«Country: China»—, que son las seguras; lo que quede sin
// rótulo se reparte entre nombre y dirección.
function _ocProvDeLineas(bloque){
  var p={}, resto=[];

  // Los rótulos, sin la parte del valor: hacen falta sueltos para poder
  // encontrar VARIOS en la misma línea. «Tel: 123  Fax: 456» es una sola
  // línea con dos datos, y es lo normal en las proformas.
  var ROT=[
    ['contacto', /\b(?:CONTACT\s*PERSON|CONTACTO?|ATTN|ATENCI[OÓ]N|PERSONA\s*DE\s*CONTACTO)\b/i],
    ['movil',    /\b(?:MOBILE|CELL(?:ULAR)?|WHATSAPP|M[OÓ]VIL|CELULAR)\b/i],
    ['fax',      /\bFAX\b/i],
    ['tel1',     /\b(?:TELEPHONE|TELEFONO|TEL|PHONE|TLF)\b/i],
    ['email',    /\b(?:E-?\s*MAIL|CORREO)\b/i],
    ['web',      /\b(?:WEB\s*SITE|WEBSITE)\b/i],
    ['zip',      /\b(?:ZIP\s*CODE|ZIP|POST(?:AL)?\s*CODE|C[OÓ]DIGO\s*POSTAL)\b/i],
    ['ciudad',   /\b(?:CITY|CIUDAD)\b/i],
    ['estado',   /\b(?:STATE|PROVINCE|PROVINCIA|ESTADO)\b/i],
    ['pais',     /\b(?:COUNTRY|PA[IÍ]S)\b/i],
    ['tax_id',   /\b(?:TAX\s*ID|VAT\s*NO|VAT|RUC|NIT|TAX\s*NUMBER)\b/i],
    ['calle',    /\b(?:ADD?RESS|DIRECCI[OÓ]N|DOMICILIO)\b/i]
  ];

  (bloque||[]).forEach(function(t){
    var txt=String(t||'').trim();
    if(!txt) return;

    // Todos los rótulos de esta línea, con su posición
    var marcas=[];
    ROT.forEach(function(r){
      var m=r[1].exec(txt);
      if(m) marcas.push({campo:r[0], ini:m.index, fin:m.index+m[0].length});
    });
    marcas.sort(function(a,b){ return a.ini-b.ini; });

    if(!marcas.length){
      var mail=/([\w.+-]+@[\w-]+\.[\w.]+)/.exec(txt);
      if(mail && !p.email) p.email=mail[1];
      else resto.push(txt);
      return;
    }

    // Cada valor va desde su rótulo hasta el rótulo siguiente
    marcas.forEach(function(mk, idx){
      if(p[mk.campo]) return;
      var hasta = (idx+1<marcas.length) ? marcas[idx+1].ini : txt.length;
      var v=txt.slice(mk.fin, hasta)
              .replace(/^[\s:.\-–—]+/,'')
              .replace(/[\s;,]+$/,'')
              .trim();
      if(v) p[mk.campo]=v;
    });

    // Lo que hubiera antes del primer rótulo no se pierde
    var antes=txt.slice(0, marcas[0].ini).trim();
    if(antes.length>3) resto.push(antes);
  });
  return {campos:p, resto:resto};
}

// Limpia un nombre de contacto: fuera el correo y lo que sobra
function _ocLimpiaContacto(t){
  return String(t||'')
    .replace(/E-?MAIL.*/i,'')
    .replace(/\([^)]*@[^)]*\)/g,'')
    .replace(/[\w.+-]+@[\w-]+\.[\w.]+/g,'')
    .replace(/\b(MR|MRS|MS|SR|SRA)\.?\s*/i,'')
    .replace(/[\s,;:\-]+$/,'')
    .trim();
}

// El país sale de la dirección. SAP lo quiere en código de dos letras, así
// que hay una tabla con los países de donde compramos de verdad. Si no se
// reconoce, se deja en blanco: mejor vacío que un código inventado, que SAP
// rechazaría el socio entero.
var OC_PAISES=[
  [/\bP\.?\s?R\.?\s?CHINA\b|\bCHINA\b|\bCN\b/i, 'CN', 'China'],
  [/\bINDIA\b/i,        'IN', 'India'],
  [/\bVIET\s?NAM\b/i,   'VN', 'Vietnam'],
  [/\bINDONESIA\b/i,    'ID', 'Indonesia'],
  [/\bTAIWAN\b/i,       'TW', 'Taiwán'],
  [/\bTHAILAND\b|\bTAILANDIA\b/i, 'TH', 'Tailandia'],
  [/\bTURK[EI]Y\b|\bTURQU[IÍ]A\b/i, 'TR', 'Turquía'],
  [/\bBANGLADESH\b/i,   'BD', 'Bangladés'],
  [/\bPAKISTAN\b/i,     'PK', 'Pakistán'],
  [/\bMALAYSIA\b|\bMALASIA\b/i, 'MY', 'Malasia'],
  [/\bKOREA\b|\bCOREA\b/i, 'KR', 'Corea del Sur'],
  [/\bJAPAN\b|\bJAP[OÓ]N\b/i, 'JP', 'Japón'],
  [/\bU\.?S\.?A\.?\b|\bUNITED STATES\b/i, 'US', 'Estados Unidos'],
  [/\bSPAIN\b|\bESPA[NÑ]A\b/i, 'ES', 'España'],
  [/\bITALY\b|\bITALIA\b/i, 'IT', 'Italia'],
  [/\bPANAM[AÁ]\b/i,    'PA', 'Panamá'],
  [/\bCOLOMBIA\b/i,     'CO', 'Colombia'],
  [/\bBRAZIL\b|\bBRASIL\b/i, 'BR', 'Brasil'],
  [/\bMEXICO\b|\bM[EÉ]XICO\b/i, 'MX', 'México']
];
function _ocPaisDe(txt){
  var t=String(txt||'');
  for(var i=0;i<OC_PAISES.length;i++) if(OC_PAISES[i][0].test(t)) return OC_PAISES[i][1];
  return '';
}

var OC_COLOR={
  prov:  {bg:'var(--pastel-lila)',  tx:'var(--t-lila)',  bd:'#C9BEF0'},
  items: {bg:'var(--pastel-aviso)', tx:'var(--t-marron)',bd:'#E0A82E'},
  orden: {bg:'var(--pastel-azul)',  tx:'var(--t-azul)',  bd:'#85B7EB'},
  ok:    {bg:'var(--pastel-ok)',    tx:'var(--t-verde)', bd:'#16a34a'}
};

function _ocCabBloque(tipo, titulo, sub, insignia){
  var c=OC_COLOR[tipo]||OC_COLOR.orden;
  return '<div style="display:flex;align-items:center;gap:9px;background:'+c.bg+';'
    +'border:1px solid '+c.bd+';border-radius:10px 10px 0 0;padding:9px 13px">'
    +'<span style="font-size:13px;font-weight:700;color:'+c.tx+'">'+_esc(titulo)+'</span>'
    +(sub?('<span style="font-size:11px;color:'+c.tx+';opacity:.8">'+_esc(sub)+'</span>'):'')
    +'<span style="flex:1"></span>'
    +(insignia||'')+'</div>';
}
function _ocInsignia(texto, nuevo){
  var c=nuevo?OC_COLOR.items:OC_COLOR.ok;
  return '<span style="font-size:10.5px;font-weight:700;background:#fff;color:'+c.tx+';'
    +'border:1px solid '+c.bd+';border-radius:20px;padding:2px 10px">'+_esc(texto)+'</span>';
}

// ── El proveedor ────────────────────────────────────────────────────────
var OC_CAMPOS_PROV=[
  {k:'cardname', t:'Nombre', req:true, w:'220px'},
  {k:'foreign_name', t:'Nombre extranjero', w:'170px'},
  {k:'currency', t:'Moneda', w:'80px', d:'USD'},
  {k:'tax_id', t:'Federal Tax ID', w:'130px'},
  {k:'contacto', t:'Persona de contacto', w:'160px'},
  {k:'tel1', t:'Teléfono', w:'130px'},
  {k:'movil', t:'Móvil', w:'130px'},
  {k:'email', t:'Correo', w:'190px'},
  {k:'web', t:'Web', w:'150px'},
  {k:'calle', t:'Dirección', w:'200px'},
  {k:'ciudad', t:'Ciudad', w:'130px'},
  {k:'zip', t:'Código postal', w:'100px'},
  {k:'estado', t:'Estado', w:'110px'},
  {k:'pais', t:'País', w:'150px',
   lista:OC_PAISES.map(function(x){ return {v:x[1], t:x[2]+' ('+x[1]+')'}; })}
];

function _ocBloqueProveedor(d){
  var c=OC_COLOR.prov;
  var existe=!!d.cardcode && d.cardname;
  var h=_ocCabBloque('prov','1 · Proveedor',
      existe
        ? (d.provPorNombre ? 'encontrado en SAP por su nombre' : 'ya está en SAP')
        : 'no existe todavía: se va a crear',
      _ocInsignia(existe?('Existe · '+d.cardcode):'Nuevo', !existe));
  h+='<div style="border:1px solid '+c.bd+';border-top:none;border-radius:0 0 10px 10px;'
    +'padding:12px 13px;background:var(--surface-1);margin-bottom:16px">';

  if(existe){
    h+='<div style="display:flex;gap:14px;align-items:center;flex-wrap:wrap">'
      +'<div><div style="font-size:10.5px;color:var(--text-muted)">Código</div>'
      +'<div style="font-size:15px;font-weight:700">'+_esc(d.cardcode)+'</div></div>'
      +'<div><div style="font-size:10.5px;color:var(--text-muted)">Nombre</div>'
      +'<div style="font-size:13px">'+_esc(d.cardname)+'</div></div>'
      + (d.provPorNombre && d.provNuevo
         && _ocClaveNombre(d.provNuevo.cardname)!==_ocClaveNombre(d.cardname)
         ? ('<div style="font-size:10.5px;color:var(--t-marron);max-width:220px">'
            +'En la proforma viene como «'+_esc(d.provNuevo.cardname)+'». '
            +'Comprueba que sea el mismo.</div>')
         : '')
      +'<div style="flex:1"></div>'
      +'<button class="xb" onclick="_ocProvOtro()">'
      +'<i class="ti ti-edit"></i> Es otro proveedor</button></div>';
  } else {
    h+='<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 10px">'
      +'El código lo pone SAP, consecutivo. Se crea como <b>proveedor</b>. '
      +'Solo el nombre es obligatorio; el resto se puede completar después.</p>'
      +'<div style="display:flex;gap:9px;flex-wrap:wrap">'
      + OC_CAMPOS_PROV.map(function(f){
          var v=(d.provNuevo&&d.provNuevo[f.k])||f.d||'';
          return '<label style="font-size:10.5px;color:var(--text-muted)">'+_esc(f.t)
            +(f.req?' <span style="color:var(--t-rojo)">*</span>':'')+'<br>'
            +(f.lista
              ? ('<select onchange="_ocSetProv(\''+f.k+'\',this.value)" '
                 +'style="width:'+f.w+';font-size:12px;padding:5px 8px;border:0.5px solid '
                 +'var(--border);border-radius:6px;background:var(--surface-0);'
                 +'color:var(--text-primary)"><option value="">—</option>'
                 + f.lista.map(function(o){
                     return '<option value="'+_esc(o.v)+'"'+(o.v===v?' selected':'')+'>'
                       +_esc(o.t)+'</option>'; }).join('')
                 +'</select>')
              : ('<input value="'+_esc(v)+'" onchange="_ocSetProv(\''+f.k+'\',this.value)" '
                 +'style="width:'+f.w+';font-size:12px;padding:5px 8px;border:0.5px solid '
                 +(f.req&&!v?'var(--t-rojo)':'var(--border)')+';border-radius:6px;'
                 +'background:var(--surface-0);color:var(--text-primary)">'))
            +'</label>';
        }).join('')
      +'</div>';
  }
  return h+'</div>';
}
function _ocSetProv(k,v){
  if(!window._ocDatos) return;
  window._ocDatos.provNuevo=window._ocDatos.provNuevo||{};
  window._ocDatos.provNuevo[k]=v.trim();
  // Sin repintar: hacerlo al escribir el nombre borraba el resto de campos a
  // medio llenar y devolvía el foco al principio. Solo se refresca el botón
  // de crear, que es lo único que depende de esto.
  _ocRevisarListo();
}

// Enciende o apaga el botón de crear según lo que falte
function _ocRevisarListo(){
  var d=window._ocDatos; if(!d) return;
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  var faltaProv = !d.cardcode && !(d.provNuevo && String(d.provNuevo.cardname||'').trim());
  var faltaItem = nuevos.some(function(l){
    return !String(l.itemcode||'').trim() || !String(l.itemname||'').trim(); });
  var b=document.getElementById('ocBtnCrear');
  var a=document.getElementById('ocFalta');
  var listo=!faltaProv && !faltaItem && d.lineas.length>0;
  if(b){ b.disabled=!listo; b.style.opacity=listo?'':'0.45';
         b.style.cursor=listo?'':'not-allowed'; }
  if(a) a.innerHTML = listo ? '' :
    '<i class="ti ti-alert-triangle"></i> '
    +(faltaProv?'Falta el nombre del proveedor. ':'')
    +(faltaItem?'Faltan códigos o descripciones de artículos.':'');
}
function _ocProvOtro(){
  if(!window._ocDatos) return;
  window._ocDatos.cardcode=''; window._ocDatos.cardname='';
  _ocPintar();
}

// ── Los artículos ───────────────────────────────────────────────────────
// Las columnas son las mismas que pide la importación de Excel de SAP, en su
// orden: así lo que se ve aquí es lo que va a OITM.
// Los grupos de artículos que existen en SAP. Se manda el NOMBRE y el worker
// lo traduce a su código mirando OITB: escribirlo a mano se presta a poner
// uno que no existe y que SAP rechace la creación entera.
var OC_GRUPOS=['..Hogar','..Muebles','..Muebles2','..Muebles3','..Ropa','..Ropa XX',
  '..Electronica','..ElectronicaXX','..Alfombra','..Calzados','..Campamento',
  '..Construccion','..Empaques','..Ferreteria','..Home Deco','..House Candle',
  '..Lentes','..Maletas','..Navidad','..Relojes','..Wallpaper','..Bolsas de Regalos',
  'Artículos','REPUESTOS'];

// OC_COLS_ITEM se quitó: la sustituye OC_CAMPOS_ITEM, que trae los tres
// grupos completos (básicos, empaque y campos de usuario).

// ── Todos los campos de un artículo, en tres grupos ─────────────────────
// Son los mismos que las tres hojas de creación de SAP: datos básicos,
// empaque y campos de usuario. Los obligatorios van marcados: sin ellos SAP
// rechaza el artículo. El resto puede quedar en blanco y completarse
// después en SAP.
var OC_CAMPOS_ITEM=[
  // ── Básicos ──
  {k:'itemcode',    t:'Referencia',        g:'Básicos', w:'110px', req:true},
  {k:'itemname',    t:'Descripción',       g:'Básicos', w:'230px', req:true},
  {k:'foreign_name',t:'Descripción inglés',g:'Básicos', w:'210px'},
  {k:'grupo',       t:'Departamento',      g:'Básicos', w:'140px', req:true, lista:'grupos'},
  {k:'barcode',     t:'Código de barras',  g:'Básicos', w:'130px'},
  {k:'proveedor',   t:'Proveedor',         g:'Básicos', w:'90px',  fijo:'prov'},
  {k:'marca',       t:'Marca',             g:'Básicos', w:'140px', fijo:'marca'},
  // Sin valor por defecto a propósito: «ART. DE POLIESTER» y «3» son los
  // nombres que entiende la importación por Excel de SAP, pero la DI API
  // quiere códigos. En blanco, el worker deduce el arancel del departamento
  // y acierta más que rellenándolo con algo que SAP no reconoce.
  {k:'arancel',     t:'Arancel',           g:'Básicos', w:'150px'},
  {k:'shipping_type',t:'Clase expedición', g:'Básicos', w:'85px'},
  {k:'imagen',      t:'Imagen',            g:'Básicos', w:'120px'},
  {k:'remarks',     t:'Comentarios',       g:'Básicos', w:'150px'},
  {k:'lista_precios',t:'Cód. precios',     g:'Básicos', w:'85px',  fijo:'codPrecios'},
  {k:'precio',      t:'Precio',            g:'Básicos', w:'85px'},
  {k:'moneda',      t:'Moneda',            g:'Básicos', w:'75px',  fijo:'moneda'},
  {k:'cod_medida',  t:'Cód. medida',       g:'Básicos', w:'95px',  fijo:'codMedida'},
  {k:'mfr_catalog', t:'Cat. fabricante',   g:'Básicos', w:'120px'},
  // ── Empaque ──
  {k:'um_compra',   t:'Unidad compra',     g:'Empaque', w:'95px',  fijo:'umCompra'},
  {k:'cant_compra', t:'Cantidad',          g:'Empaque', w:'70px',  d:'1'},
  {k:'empaque_compra',t:'Empaque',         g:'Empaque', w:'90px',  fijo:'ueCompra'},
  {k:'pzs_bulto_compra',t:'Pzs por bulto', g:'Empaque', w:'90px'},
  {k:'volumen_compra',t:'Volumen',         g:'Empaque', w:'85px'},
  {k:'peso_compra', t:'Peso',              g:'Empaque', w:'85px'},
  {k:'peso_item', t:'Peso del artículo', g:'Empaque', w:'95px'},
  {k:'um_venta',    t:'Unidad venta',      g:'Empaque', w:'95px',  fijo:'umVenta'},
  {k:'cant_venta',  t:'Cantidad',          g:'Empaque', w:'70px',  d:'1'},
  {k:'empaque_venta',t:'Empaque',          g:'Empaque', w:'90px',  fijo:'ueVenta'},
  {k:'pzs_bulto_venta',t:'Pzs por bulto',  g:'Empaque', w:'90px'},
  // ── Campos de usuario ──
  {k:'udf_color',   t:'Colores',             g:'UDF', w:'100px'},
  {k:'udf_cubicaje',t:'Cubicaje por Bulto',g:'UDF', w:'110px'},
  {k:'udf_tamano',  t:'Tamaño',            g:'UDF', w:'150px'},
  {k:'udf_comp_esp',t:'Composicion',g:'UDF', w:'200px'},
  {k:'udf_color_ing',t:'Color en ingles',     g:'UDF', w:'110px'},
  {k:'udf_comp_ing',t:'Composicion en ingles',g:'UDF', w:'220px'},
  {k:'udf_producto',t:'Producto',          g:'UDF', w:'80px',  fijo:'producto'},
  {k:'udf_categoria',t:'Categoria',        g:'UDF', w:'80px',  fijo:'categoria'},
  {k:'udf_coleccion',t:'Colección',        g:'UDF', w:'80px',  fijo:'coleccion'},
  {k:'udf_dpto',    t:'Depto',             g:'UDF', w:'70px',  fijo:'dptoUdf'},
  {k:'udf_bulto',   t:'Tamaño bulto',  g:'UDF', w:'130px'}
];

var OC_GRUPO_COLOR={
  'Básicos': {bg:'var(--pastel-azul)',  tx:'var(--t-azul)'},
  'Empaque': {bg:'var(--pastel-verde2)',tx:'var(--t-verde2)'},
  'UDF':     {bg:'var(--pastel-lila)',  tx:'var(--t-lila)'},
  // Los propios de ropa y alfombras, en su propio color para que se vea de
  // un vistazo qué parte es la de la plantilla del departamento
  'Del departamento': {bg:'var(--pastel-aviso)', tx:'var(--t-marron)'},
  'Otros':   {bg:'var(--surface-1)',    tx:'var(--text-muted)'}
};

// Rellena lo que no venga de la proforma con los valores fijos de la orden
/* ═══════════════════════════════════════════════════════════════════════════
   ARANCELES  ·  los grupos de aduana de SAP
   ───────────────────────────────────────────────────────────────────────────
   La lista va aquí dentro para que el desplegable y la sugerencia funcionen
   al instante, sin esperar a ninguna consulta. A SAP se le manda el NOMBRE,
   no el número: el worker lo traduce contra la tabla real, así que si algún
   código cambiara en SAP se seguiría acertando.
   ═══════════════════════════════════════════════════════════════════════════ */
var OC_ARANCELES="ABANICOS|898~ABRIDOR D/LATAS ELEC|1089~ACCE. EXTRACT. GRASA|1110~ACCE. P/ SANITARIO|694~ACCES. P/ IMPRESORA|1093~ACCES. PARTES DE PC|1099~ACCESORIO P/BEBE|650~ACCESORIO P/ESTUFA|977~ACCESORIO PC|1080~ACERO INOXIDABLE|1136~ADORNO CERAMIC/PORC|1266~ADORNO D/VIDRIO|850~ADORNO DECORATIVO|831~ADORNO P/NAVIDAD|969~ADORNO POLIRESINA|637~ADORNOS|1262~AIRE ACONDICIONADO|1047~ALBUMNES|713~ALFOM. PLAS CARRO|928~ALFOMBRA|723~ALFOMBRA D CAUCHO|1216~ALFOMBRA D POLYESTER|1213~ALFOMBRA D/ALGODON|719~ALFOMBRA D/BAMBOO|720~ALFOMBRA D/LANA|1214~ALFOMBRA D/NYLON|722~ALFOMBRA DE CUERO|998~ALFOMBRA DE VISCOSER|1273~ALFOMBRA DE YUTE|1321~ALFOMBRA FIBRA COCO|1186~ALFOMBRA FIBRA COCO.|1175~ALFOMBRA FIBRA COCO1|984~ALFOMBRA PLAS.BA\u00d1O|718~ALFOMBRA POLYPRO.|721~ALICATE|1247~ALMOHADAS|964~ARBOL DE NAVIDAD|830~ART. BA\u00d1O CERAMICA|1313~ART. BA\u00d1O PLASTICO|678~ART. BA\u00d1O VIDRIO|1314~ART. COCINA D MARMOL|1238~ART. COCINA PLAST.|664~ART. COCINA VIDRIO|845~ART. D/POLIESTIRENO|1141~ART. DE ACRILICO|1194~ART. DE HIERRO|1315~ART. DE POLIESTER|1146~ART. ELECTRICOS|918~ART. HIERRO FUNDIDO|1264~ART. P/BA\u00d1O|1022~ART. P/COCINA BAMBOO|1219~ART. POLIETILENO|1310~ART. POLIPROPILENO|1284~ART.COCINA ACER.INOX|1316~ART.COCINA D.PIZARRA|1276~ART.COCINA PORCELA|679~ART.COCINA(GUANTE)|1184~ART.COCINA(GUANTE).|1173~ART.COCINA(GUANTE)1|982~ART.CONST.  ALUMINIO|1235~ART.D/BARRO /ARCILLA|1050~ART.MADERA COCINA|1288~ART.P/COCINA D/PORCE|983~ART.P/COCINA METAL|871~ART.P/COCINAD/PORCE1|1174~ART.P/ESCRITORIO|682~ART.P/GIMNA. DEP.|971~ART.P/GIMNASIA/DEP.|1176~ART.P/GIMNASIA/DEP.1|985~ART.P/GIMNASIA/DEP.2|1187~ART.P/PORCELANA|841~ART.PARA MASCOTAS|1318~ART.PCOCINA D/PORCE|1185~ART.PLASTICO|692~ARTICULO DE ALGODON|717~ARTICULO DE BAMBOO|1094~ARTICULO DE CAUCHO|1154~ARTICULO DE CAUCHO1|1172~ARTICULO DE CAUCHO2|1164~ARTICULO DE METAL|1285~ARTICULO DE NYLON|1134~ARTICULO DE SILICONE|1135~ARTICULOS DE BAMBU|1270~ARTICULOS DE MDF|1271~ARTICULOS ELECTRICO1|1177~ARTICULOS ELECTRICO2|1188~ARTICULOS ELECTRICOS|986~ASADOR P/BARBACOA|1116~ASIENTO BA\u00d1O MADERA|1035~ASIENTO BA\u00d1O MADERA1|1034~ASIENTO BA\u00d1O PLASTIC|645~ASPIRADORA|907~AUDIO CASSETTE|1011~AURICULARES|1098~AZULEJOS|833~BALANZA ALIMENTOS|904~BANCAS P/ RECAMARA|1211~BANCOS|1198~BANDEJA D/VIDRIO|1026~BANDEJA DE PINTURA|1260~BANDEJA PLAS.LAPTOP|1105~BANDEJA PLASTICAS|654~BAR|1229~BARANDA D/VIDRIO|1092~BASE PARAGUA METAL|897~BASURERO METAL|875~BASURERO-CESTO PLAST|670~BATERIA|1061~BATERIA PARA PC|1128~BATIDOR MANUAL|881~BAUL DE CUERO|1005~BAUL DE MADERA|1239~BAUL PLEGABLE|1143~BA\u00d1ERA P/BEBE|643~BERMUDA P/HOMBRE|728~BERMUDA P/NI\u00d1O|729~BLUSA P/NI\u00d1A|999~BLUSA P/NI\u00d1A 1|788~BLUSA P/SRA|787~BOCINAS|920~BOLIGRAFO|1124~BOLSA P/BASURA|649~BOLSA P/ROPA DELICAD|1046~BOLSA PAPEL D\u00c9COR.|712~BOLSA REUTILIZABLE|1132~BOLSAS|814~BOLSAS P/REGALOS|1002~BOLSO|697~BOLSOS P/COSMETIC|1227~BOMBILLO|1033~BRASO METAL COLGAR|894~BRASSIER P/SRA|795~BROCAS PARA TALADRO|1291~BROCHAS PARA PINTAR|1272~BUTACA|1168~CABALLETE|1240~CABECERA DE CAMA|1210~CABLE COAXIAL|1064~CABLES DE ARRANQUE|1290~CACEROL TAPA MICRO|837~CAFETERA ELECTRICA|916~CAJA DE CARTON|711~CAJA DE HERRAMIENTA|1259~CAJA FUERTE|895~CAJA ORG. D POLIESTE|1140~CAJA ORGANIZADORA|1222~CALCULADORA|1059~CALENT. D AGUA A GAS|1111~CALZADOR|691~CALZON P/H  ALG.|789~CALZON P/NI\u00d1O ALG.|790~CAMA|1167~CAMA D/MADERA|950~CAMARA DIGITALES|1044~CAMISA NINO MEZCLA|1299~CAMISA NI\u00d1O ALG.|786~CAMISA P/DAMA|784~CAMISA P/H ALGODON|785~CAMISA P/H MEZCLA|1300~CAMISETA DAMA PUNTO|1301~CAMISETA P/BEBE|737~CAMISETA P/H|742~CAMISETA P/NI\u00d1OS|1179~CAMISETA P/NI\u00d1OS.|1190~CAMISETA P/NI\u00d1OS1|988~CAMISETA P/NI\u00d1OS2|991~CANASTA D/METAL|872~CANASTA DE BAMBOO|710~CANASTA DE FIELTRO|1274~CANASTA DE LANA|1275~CANASTA DE MIMBRE|1311~CANASTA DE TELA|1246~CANASTA PLASTICA|672~CANDADOS|1281~CANDELABRO|896~CAPOTES PLASTICOS|684~CARGADOR D/BATERIAS|1062~CARGADOR P/TABLET|1208~CARPA P/SOL|811~CARRETILLA D/METAL|930~CARTERAS|695~CASCO DE SEGURIDAD|1153~CASCO DE SEGURIDAD1|1163~CATALOGO|1106~CENEFAS|809~CENICEROS|852~CEPILLO P/DIENTES|974~CEPILLO P/LAVANDERIA|909~CEPILLOP/LAVANDERIA1|989~CEPILLOP/LAVANDERIA2|1180~CEPILLOP/LAVANDERIA3|1191~CERRADURA|893~CHANCLE.C/S CAUCHO|818~CHANCLETAS|817~CHAPA D/ALUMINIO|1095~CHIMENEA|1197~CINCEL|1254~CINTA ANTIDES (PVC)|1298~CINTA DE AMARRE|1269~CINTA METRICA|1257~COBERTOR P/SILLA|804~COBERTOR PARA IPHONE|1225~CODO|854~COFFE TABLE|1195~COFRES|933~COJINES|963~COLCHON|962~COLUMPIO|970~COLUMPIOS, TOBOGANES|1162~COMPUTADORA|1079~CONDENSADOR DE AIRE|1205~CONGELADOR HORIZONTA|1056~CONGELADOR VERTICAL|1304~CONJ OVERRAL INFANT1|1189~CONJ OVERRAL INFANT2|1178~CONJ. DE BA\u00d1O P/NI\u00d1O|724~CONJ. INTERIOR P/SRA|732~CONJ. NI\u00d1A  EJER.|794~CONJ. OVERRAL INFANT|987~CONJ. SHORT P/NI\u00d1A|1192~CONJ. SHORT P/NI\u00d1A1|990~CONJ. SHORT P/NI\u00d1A2|1181~CONJ. SHORT P/NI\u00d1OS|725~CONJ. SRA. EJERCICIO|793~CONJUNTO P/INFANTE|792~CONJUNTO P/NI\u00d1A|769~CONJUNTO P/NI\u00d1O|761~CONJUNTO P/SRA|768~CONSOLA|1171~CONTROL P/JUEGOS|1065~CONTROL REMOTO UNI.|1048~CONTROLADOR DE VOLTA|1206~CONVERTIDOR VOLTAJE|1202~CORBATAS Y LAZOS|1117~CORDON DECO. CORTINA|675~CORNIZA P/CORTINA|876~CORREA P/DAMA|701~CORREA P/HOMBRE|700~CORREA P/NI\u00d1OS|685~CORTA U\u00d1A|887~CORTADOR PARA PIZZA|1006~CORTINAS|676~CORTINAS DE BA\u00d1O|1308~CUADRO DECORATIVO|716~CUADROS|980~CUBETAS PARA HIELO|665~CUBIERTO DE A.INOX|1147~CUBIERTO DE A.INOX1|1157~CUBIERTO DESECHABLE|653~CUBO DE PLASTICO|669~CUBRECAMAS|800~CUCHARA D/MADERA|1038~CUCHARA P/HELADO|652~CUCHARONES DE COCINA|892~CUCHILLA|1255~CUCHILLO|884~CUCHILLO ELECTRICO|1120~DELANTAL C/BOLSILLO|1036~DESTORNILLADOR|1248~DESTORNILLADOR ELECT|1286~DISPENS. D/CEPILLO|1021~DISPENSADOR D/PAPEL|683~DISPENSADOR DE JABON|663~DIVICIONES P/GAVETA|1142~DUCHA D/ VIDRIO TEMP|1161~DUCHA D/VIDRIO TEMP1|1151~DUCHAS DE BA\u00d1O|644~DVD|1078~ENVASE DE VIDRIO|846~ENVASES PLASTICOS|647~EQUIPOS D/SONIDO|1049~ESCALERA DE METAL|877~ESCOBAS|973~ESCULTURA DE CRISTAL|1242~ESCULTURA DE METAL|1232~ESCULTURA DE PIEDRA|1241~ESCULTURA DE RESINA|1243~ESCURRIDOR  PLATOS|667~ESPATULA|1258~ESPEJO|842~ESPEJO P/BA\u00d1O|849~ESPONJA (CHAMOIS)|995~ESPONJA P/BA\u00d1O|642~ESQUINERA|946~ESTUCHE P/ LIPSTICK|698~ESTUCHE P/BA\u00d1O|633~ESTUCHE P/LENTE|699~ESTUFA|1009~ESTUFA D/GAS|1086~ESTUFA ELECTRICA|1114~ETIQUETA|1220~EXHIBIDOR PLASTICOS|629~EXIBIDOR DE MCIA|1084~EXPRIMIDOR DE JUGO|1083~EXTENSION ELECTRICA|925~EXTRACTOR DE AIRE|899~EXTRACTOR DE AIRE1|1076~EXTRACTOR DE GRASA|1008~FAJAS|1145~FALDA P/NI\u00d1A|777~FALDA P/SRA|727~FALDA PARA LAVADORA|689~FIELTRO|1295~FLORERO|840~FLORES ARTIFICIALES|1204~FOAMI (GOMA EVA)|1296~FOCOS|972~FORRO CAJA D/KLINNEX|812~FORRO P/COJINES|813~FORRO P/MUEBLE|1127~FORROS|801~FORROS PLASTICOS|688~FREGADOR D/METAL|860~FREIDORA DE AIRE|1283~FRUTAS PLASTICAS|677~FRUTEROS|844~FUENTE DE AGUA|901~FUNDAS P/ALMOHADAS|799~GABINETE|1201~GANCHO MADERA ROPA|705~GANCHO METAL ROPA|863~GANCHO PLASTICO ROPA|956~GAZEBO|1317~GORRA|1294~GORRO PLASTICO  BA\u00d1O|827~GRABADORA MINI|1068~GRANITO|627~GRAPADORA|1253~GRIFO P/FREGADOR|906~GUANTE DELANTAL|808~GUANTE P/BA\u00d1O|797~HIELERA|656~HORQUILLA P/ROPA|668~INDIVIDUALES|648~INDIVIDUALES  BAMBOO|703~INODORO D/PORCELANA|838~JABONERA PLASTICA|674~JACKET P/HOMBRE|755~JACKET P/NI\u00d1A|726~JACKET P/NI\u00d1O|756~JACKET P/SRA|759~JARRA|886~JARRA PLASTICA|639~JEANS P/HOMBRE|764~JEANS P/NI\u00d1A ALGODON|779~JEANS P/NI\u00d1O|767~JEANS P/SRA.|780~JGO. D/REGADERA|861~JGO. DE COMEDOR|1166~JGO. DE CUBIERTO|889~JGO. DE CUCHARONES|890~JGO.D/DESAYUNADOR|954~JGO.MESA DE VIDRIO|959~JOYERO D/METAL|874~JUEGO DE OLLAS|859~JUEGO DE SILLONES|957~JUGUETE|967~LAMINA ACERO INOX.|855~LAMINA D/ALUMINIO **|1027~LAMINA D/POLICARBONA|1122~LAMINA P/PISO(HDF)|702~LAMINA PISO D/BAMBOO|709~LAMINAS D/ACERO INOX|1057~LAMPARA EMERGENCIA|1137~LAMPARAS|965~LAVADORA|1125~LAVAMANO P/BA\u00d1O|834~LENTES PARA SOL|931~LETRERO LUMINOSO|1138~LIMAS DE METAL|1256~LINTERNA|1073~LLAVES|1251~LUCES RECARGABLES|1016~L\u00d1mp. Mesa Ceramica|1107~L\u00d1mpara M/P Metal|1109~L\u00d1mpara P/T Metal|1108~MACETERO DE CEMENTO|1212~MACETERO PLASTICO|690~MAJADOR DE PAPA|880~MALETAS|696~MANIGUETAS|1203~MANIQUE|979~MANTEL P/MESA|802~MANTEL PLASTICO|655~MANUAL INSTRUCCIONES|715~MAQ.AFEITADORA|1060~MAQ.CORTAR CABELLO|1066~MAQ.P/HACER HIELO|993~MAQUINAS Y APARATOS|1319~MARAQUITAS P/BEBE|968~MARCO P/FOTO|686~MARTILLO|1249~MAZO DE GOMA|1250~MECEDORA|944~MEDIAS P/HOMBRE|752~MEDIAS P/NI\u00d1O|751~MEDIAS P/SRA|750~MEMORIAS USB|1067~MESA|948~MESA P/JGOS (SOCCER)|1115~MESA+SILLA|1231~MICROONDAS|913~MIMBRE,RATAN,BAMBOO|961~MINI COLCHON D.FOAM|1183~MINI FALDA P/SRA.|776~MINI REFRIGERADOR|900~MOLDE PARA PALETAS|631~MOLDES D/ALUMINIO|1028~MOLDURA DECORATIVA|641~MONITOR D/PRESION|1072~MONITORES|1042~MONTACARGA|1160~MONTACARGA1|1150~MOSAICO|832~MOSQUITEROS|1087~MOTA P/TRAPEADOR|1144~MUEB.MAD.DORMITORIO|992~MUEBLE C/BOCINA|1085~MUEBLE D/MADERA|955~MUEBLE D/METAL|949~MUEBLE DE COCINA|1209~MUEBLE MADERA COCINA|953~MUEBLE MADERA D/OFIC|952~MUEBLE P/BA\u00d1O|1020~MUEBLE P/BA\u00d1O HIERRO|1245~MUEBLE PLASTICO|958~MUESTRA VENDEDOR|997~NETBOOK|1052~NIVELES|1282~OLLA ARROCERA|1091~OLLA DE METAL|869~OLLA DE PRESION|1131~OLLA ELECTRICA|914~OLLA FREIDORA|1012~OLLAS DE ALUMINIO(P)|1237~ORG D/POLIPROPILENO1|1155~ORG. D POLIPROPILENO|1165~ORG. NYLON P/GAVETA|1312~ORG.COCINA METAL MBL|951~ORG.D/METAL|947~ORG.P/BA\u00d1O|673~ORG.P/COCINA|660~ORG.PLASTICO V/USOS|632~ORGANIZADOR DE JOYAS|1226~OVERALL P/INFANTE|791~OVERALL P/NI\u00d1A|744~PALA|1277~PALILLOS DE ALGODON|630~PALILLOS DE DIENTES|707~PANEL DECORATIVO|866~PANTALLA LUMINOSA|1230~PANTALON P/DAMA|783~PANTALON P/H ALGODON|765~PANTALON P/INFANTE|1001~PANTALON P/NI\u00d1AS|782~PANTALON P/NI\u00d1O|766~PANTY FAJAS P/SRA|796~PANTY HOSE|749~PANTY P/NI\u00d1A|734~PANTY P/SRA|733~PAPEL ALUMINIO|1306~PAPEL DECO. P/ PARED|1100~PAPEL DECORATIVO|1215~PAPEL PERGAMINO|1307~PARAGUAS|828~PARTES / ACCES. PC|1112~PARTES P/COMPUTADORA|1053~PARTES P/MUEBLES|1014~PASTA P/PULIR ACERO|635~PATINETA ELECTRICA|1236~PA\u00d1ALES|714~PA\u00d1UELOS P/H|1293~PELADOR DE ALIMENTOS|666~PELOTAS|1088~PERSIANA DE BAMBOO|708~PERSIANA DE MADERA|706~PERSIANA DE PVC|681~PESA P/BA\u00d1O|903~PIANO|1075~PIANO DE COLA|1104~PICADOR ELECTRICO|1082~PICO|1279~PIECERO/BUTACA|941~PIEDRAS DECO. VIDRIO|1292~PIJAMA P/HOMBRE|730~PIJAMA P/NI\u00d1A|736~PIJAMA P/NI\u00d1O|731~PIJAMA P/SRA|735~PISO D/CAUCHO|1156~PISO D/CAUCHO1|1169~PISO D/MARMOL|1032~PISO DE GRANITO|1015~PISO DE VINYL|640~PLACAS PLASTIC. LED|1263~PLANCHA   P/CABELLO|1070~PLANCHA CALENTADORA|1119~PLANCHA DE VAPOR|1045~PLANCHA ELECTRICA|912~PLANTAS ARTIFICIALES|829~PLASTICO DE BURBUJA|1244~PLATO  PLAST.P/ENSAL|1023~PLATO D/VIDRIO|1025~PLATO P/MICROWAVE|848~PLATO PARA DULCE|1007~PLATO PLASTICO|1024~PLATO/VASO/ PLAST.|657~PLAYSTATION|1118~PLUMA UNIVERSAL|1223~PLUMERO|976~POLO SINTETICO|1302~POLVO P/ AFEITAR|1133~PORCELANATO|1029~PORTAFOLIO PARA IPAD|1224~PORTARETRATO|687~POTPOURRI|634~PROC. JUGO Y VEGE.|882~PROCESADOR ALIMENTOS|908~PUERTA|945~RACK DE ESPECIAS|661~RADIO A/M, F/M|922~RADIO INTER.|1113~RADIO RELOJ|923~RALLADOR D/VEGETALES|857~RALLADOR DE ALIMENTO|858~RALLADOR DE QUESO|885~RAMA SECA DECORATIVA|1031~REBANADOR D/ALIMENTO|883~RECEPTOR D/MENSAJE|1069~REFRIGERADOR|1004~REGLETA ELECTRICA|1081~RELOJ|932~RELOJ D/PARED|1103~RELOJ DE PULSO|1121~REMACHE|1252~REP. P/REFRIGERADOR|902~REP.P/CAFETE/TOSTAH|919~REPRODUCTOR IPOD|1054~REPUESTO COMPUTADORA|994~REPUESTO FILTRO AGUA|996~REPUESTO P/COCHES|929~REPUESTO P/MICROONDA|927~REPUESTO P/MUEBLE|856~REPUESTO P/TELEVISOR|1018~REPUESTOS|1017~REVESTIMIENTO PLASTI|1058~RIEL P/CORTINA|864~RIEL P/CORTINA MADER|1037~RIELES|1010~RODILLO P/PELUSA|1199~ROLLO P/SUNCHO|693~ROLLOS D/FOAMY P/VEN|1097~ROMPECABEZA|966~RUEDA P/PULIR METAL|905~RUNNER|803~S/DAduan|626~SABANAS|798~SABANILLA P/BEBE|760~SACA CORCHO|865~SACO TRAJE|1303~SANDALIA P/BEBE|821~SANDALIA P/DAMA|819~SANDALIA P/NI\u00d1A|820~SANDWICHERAS|1090~SARTEN  CAF\u00c9. MAN.|870~SARTEN DE COCINA|867~SARTEN ELECTRICO|1123~SECADOR DE MANOS|1159~SECADOR DE MANOS1|1149~SECADOR P/CABELLO|911~SECADORA PARA ROPA|1126~SELFIE|1234~SERVILLETA DE TELA|805~SET DE BALCON|1221~SET DE BA\u00d1O|646~SET DE COCINA|659~SET DE HERRAMIENTA|1268~SET DE RECAMARA|1170~SET DE TAZAS|836~SET P/CONDIMENTOS|651~SHORT P/DAMA|778~SHORT P/HOMBRE|762~SHORT P/NI\u00d1AS|781~SHORT P/NI\u00d1OS|763~SILLA|1228~SILLA COMER NI\u00d1O|1320~SILLA D/MADERA|936~SILLA D/MASAJE|1074~SILLA D/METAL|938~SILLA P/OFICINA|934~SILLA PLASTICA|940~SILLA PLEGABLE|1218~SILLAS DE MIMBRE|1196~SILLON D/MADERA|942~SILLON RECLINALE|939~SOBRECAMA P/BEBE|757~SOFA CAMA D/MADERA|937~SOFA CAMA D/METAL|943~SOFA DE CUERINA|935~SOFA DE CUERO|1003~SOFAS|1200~SOPORTE D/METAL|1040~SOPORTE PLASTICO|1129~SUJETADOR P/CORTINA|671~SUJETADOR P/SABANA|862~SWEATER P/N S/CUELLO|743~SWEATER P/NI\u00d1O|1102~SWEATER SUD. P/NI\u00d1A|746~SWEATER SUD. P/NI\u00d1O|747~SWEATER SUD. P/SRA|745~TABLA D/PICAR|1139~TABLA DE PICAR MAD|704~TABLA P/PLANCHAR|873~TABLA TOMACORRIENTE|926~TABLETA DIGITAL|1148~TABLETA DIGITAL1|1158~TALADRO ELECTRICO|1287~TAPE|981~TAPETE|810~TAPETE P/PARED|806~TARJETA INTELIGENTE|1267~TAZA D/VIDRIO|851~TEFLON (PTFE)|1297~TELA|1217~TELA SIN TEJER|1265~TELA SINTETICA|1030~TELEFONO|910~TELEFONO1|1055~TELEVISOR, LED, LCD|628~TENAZA|1261~TENDEDERO PLASTICO|638~TENEDOR D/MADERA|1039~TENEDORES|891~TERMOSTATO PROGRAMAB|1207~TETERA ELECTRICA|1233~TETERAS|1130~THERMO|978~TIJERA P/COCINA|868~TIJERAS|1280~TOALLA P/BA\u00d1O|1000~TOALLA P/BA\u00d1O1|758~TOALLA P/COCINA|807~TOLDA ALUM P/VENTANA|1096~TOMA 110V-WTH|924~TOP P/NI\u00d1A|754~TOP P/SRA|753~TOSTA HORNO|915~TOSTADORA ELECTRICA|917~TRAJE P/NI\u00d1A|773~TRAJE P/SRA|772~TRAPEADOR|975~TRINCHE DE JARDIN|1278~TRITU. MANUAL P/VEG.|879~TRITURADOR MANUAL|878~TUBO D/METAL|853~UNIDAD DE MEMORIA|1077~UTENCILIO P/COCINA|888~VAJILLA ENV.PORCELAN|835~VAJILLAS D/CERAMICA|839~VAJILLAS DE PLASTICO|662~VASO DE VIDRIO|847~VASO TERMICO|1051~VELAS|636~VESTIDO BA\u00d1O P/DAMA1|1193~VESTIDO BA\u00d1O P/DAMA2|1182~VESTIDO BA\u00d1O P/NI\u00d1A|748~VESTIDO P/DAMA|770~VESTIDO P/INFANTE|1013~VESTIDO P/NI\u00d1A|771~VIDEOCAM./FILMADORA|1043~VIDRIOS|843~VINERA|1305~VITRINA|960~ZAPATILLA|815~ZAPATILLA P/NI\u00a5A|816~ZAPATITO P/BEBE|826~ZAPATO P/DAMA|825~ZAPATO P/HOMBRE|822~ZAPATO P/NI\u00d1A|823~ZAPATO P/NI\u00d1O|824"
  .split('~').map(function(x){ var p=x.split('|'); return {n:p[0], c:p[1]}; });

var OC_MARCAS="- Ning\u00fan fabricante -|-1~3|735~4 KIDS|42~612|724~ACER|229~ACM|242~AD BASICS|224~ADX|163~AG ART|222~AIRELOOM|250~AIRELOOM1|244~AK|238~ALBERTO BELINI|14~ALMAYS FRESH|219~ALPEX|13~ANTIK DENIM|86~APPLE BOTTOMS|233~ARMSTRONG/SHAW/MOHAUK|168~AUDIO KIT|134~BABY CRIBS|192~BABY FELIX|60~BAKERS SECRET|621~BARNIE|72~BATH BLISS|153~BATH CLIP|625~BB&B|154~BELKIN|108~BELLE'|36~BELLE FASHION|39~BELLE STRECH|44~BETTER HOMES|626~BETTY CROCKER|562~BIEKE SPORT|68~BIZZ|114~BLACK|729~BLACK & DECKER|210~BLACK WITH SILVER|731~BOB SPONGE|74~BOHEMIA|264~BON APETITE|733~BON APPETIT|147~BOSI|30~BRAUN|116~BRAVISIMA|37~BRITTO COLLECTION|247~BUGSBUNNY|78~CAMISETA P/HOMBRE|214~CANON|227~CAROLINA BAY|622~CARRARO|35~CASE LOGIC|130~CELEBRITY|232~CHICKEE DUCK|10~CHRISTMAS HOME|252~CHRISTMAS HOME / KENNEDY CARPE|721~CIRCLE GLASS|260~CITIZEN|118~CLOSETCANDIE|249~COCO FIBRE TEX|213~COLLEGE|230~COMFORT|75~COMPAQ|174~CONAIR|211~CROCKER|45~CUISINART|209~DANILUX|616~DAWN|164~DID|204~DIGIPOWER|125~DILLY HOME GARDEN|619~DISNEY|127~D'ITALIA|25~DN|199~DO|19~DOG & CAT|59~DORA THE EXPLORER|65~DORCY|131~DULCE BEBE|53~DUQUESA SPORT|69~DURACELL|128~DXG|120~ECONOMICO|71~EKO|732~ELECTRO PLUS|718~EMERSON|169~EXOTIC ESSENTIALS|201~EXPENSIVE|56~EXPOSE|23~EZY STORAGE|269~FAMILY MAID|144~FELIX THE CAT|66~FIREPLACE COLLECTION|150~FIRST ACT|136~FLIGHT LINE|180~FREE|17~FREE HOME BASICS|714~FRIGIDAIRE|212~GABY|223~GALAXY|93~GEL SKINS|132~GENERAL ELECTRIC|95~GFORCE|85~GODINGER|547~GRANDECO WALLFASHION GROUP|166~GRIFFIN|126~GTIME|87~HAIER|186~HAMILTON BEECH|97~HEWLETT  PACKARD|107~HOME DETAILS|727~HOMECENTRE|716~HOT BEACH|63~HP|173~HP1|203~IGRIP|135~IMPECCA|181~INNOVATIVE TECHNOLOGY|98~INTEX|207~ISSAC MIZRAHI|248~JARDIN|254~JOSEPH & JOSEPH|258~JUST RELAX|156~JUST RUGS|148~JVC|138~K|41~K.C.|8~K.C. STAR|9~KAREN RHODES COLLECTION|145~KENNDEY KITCHEN|560~KENNEDY|6~KENNEDY BAMBOO CARPET|61~KENNEDY BASIC|225~KENNEDY BATH COLLECTION|20~KENNEDY CARPETS|21~KENNEDY CARPET-SOHO|158~KENNEDY CARPTES (R)|90~KENNEDY CENTER|73~KENNEDY CLUB|48~KENNEDY DISPLAY|83~KENNEDY ELECTRIC|84~KENNEDY GARDEN COLLECTION|613~KENNEDY GFORCE COLLECTION|179~KENNEDY HOME|18~KENNEDY HOME COLLECTION|11~KENNEDY HOME FURNITURE|7~KENNEDY HOME PRODUCTS|4~KENNEDY KIDS|22~KENNEDY KITCHENWARE|620~KENNEDY PLASTIC|3~KENNEDY QUALITY KITCHEN|100~KENNEDY STRUCTURES|155~KENNEDY TELECOM|27~KENNEDY TOOLS|259~KETER|208~KING KOIL|253~KING KOIL LAURA ASHLEY|263~KINGSDOWN|457~KITCHEN DETAILS|185~KITCHEN HELPER|103~KLIC BOX|615~KODAK|110~KOMAR|190~KONAMI|139~LAKEWOOD|94~LAMPARAMA|170~LAURA ASHLEY|161~LAZAR|82~LEGGETT & PLATT|251~LG|218~LIBBEY|257~LIFE POWER|167~LIFE STORY|623~LILY|31~LOGITECH|99~MACBETH COLLECTION|172~MAGEFESA|245~MAGNASONIC|91~MAHARAJA|624~Marca|723~MARCA PROPIA|726~MARVEL|177~MAX CONFORT|178~MAXELL|104~MEDALLION|142~MIAMI STYLE|617~MICROSOFT|197~MI-NI-\u00d1A|54~MI-NINO|50~MISS VIE|49~MOBILITY EXPENDED|115~MONSTER CABLE|137~MORELLI|162~MORELLI FURNITURE|33~MOTOROLA|187~NANA BAILA|234~NATURAL COLLECTION|38~NATURALLY CANDIES|28~NAVIGON|113~NEW OCEAN|1~NINTENDO|124~NO|57~OLYMPUS|111~ONE TOUCH|96~OREO|627~OSTER|196~P2252|734~P2275|736~P2289|737~PAMPERED GIRL|239~PAMPOLINA|43~PANASONIC|228~PAOLA BELLE|16~PHILIPS|109~PICKHARDT|221~PIKACHU|200~PILLOW TALK|67~PINK SODA|34~PLASTITEK|226~PLATINUM SPORT|143~PLAYTECH|122~PLAZA SESAMO|79~PNY|202~POLAROID|105~POPEYE|151~POWER SURFER EXPEDITION|58~POWERADE|255~PRECIOUS CHRISTMAS|88~PRECIOUS MOMENTS|81~PRECIOUS XMAS|76~PREMIER|70~PROGRESSIVE|240~PROTECT-A-BED|236~PRUEBA MARCA|561~Q MOTIONS|140~RASCH|191~REALES|267~REMINGTON|112~RESTONIC|243~REVE|152~REVERIE|261~REVLON|141~ROYAL|52~SAINT MORIS|24~SAMSUNG|133~SANYO|119~SCALA|47~SCOOBY|77~SEALY|713~SEDA FRANCE|206~SERTA|193~SEXY WOMAN|171~SHUT|205~SILVER|730~SIMPLIFY|146~SIN MARCA|12~SIN MARCA DE FABRICA|5~SING COLLECTION|40~SKYWORTH|241~SOHO|157~SOHO BEDDING|266~SOHO CARPET|159~SOHO CARPETS|612~SOHO CLEAN|725~SOHO FURNITURE|62~SOHO GLASSWARE|262~SOHO HANGER|265~SOHO HOME DECO|235~SOHO HOTEL COLLECTION|717~SOHO MATTRESS|195~SOHO OFFICE|194~SOHO OFFICE FURNITURE|231~SOHO OUTDOOR|256~SOL|715~SONY|188~SPORTS FREE|26~SUNBEAM|216~TARGUS|198~TERRAGAVE|614~TEXAM HOME LTD|237~TITIZ|618~TOP HEAT|89~TOTALLY BRIGHT|101~TOTALLY HOME CARPET COLLE|51~TOTALLY HOME COLLECTION|2~TOTALLY LIGHTS|189~TRANSCEND|184~TREVALLA|720~TRIFIL|46~TRUE ROCK|217~TWEETY|80~U. RIGHT|32~UNIDEN|182~UPDU|64~VARIAS|165~VIDAL SASSOON|129~VIGOLD|220~VISCO-PRO|92~VTECH|183~WALK SAFARI|106~WD|215~WHITE|728~WII|123~WOOLITE|175~XBOX|121~YAK PACK|246~YAKPACK|176~YAMAHA|117~YES|55~YIO FU|15~You&Me|102~YUPI-DU|29~ZAGG|160~Z-LINE DESIGN|719"
  .split('~').map(function(x){ var p=x.split('|'); return {n:p[0], c:p[1]}; });

// Las dos listas que se eligen de un desplegable con buscador. El selector es
// el mismo para las dos: cambiar de una a otra solo cambia de dónde lee.
var OC_LISTAS={
  arancel: {datos:function(){ return OC_ARANCELES; }, t:'arancel'},
  marca:   {datos:function(){ return OC_MARCAS; },    t:'marca'}
};

// Busca el arancel que más se parece a un artículo. Mira su descripción y su
// composición, porque el material es lo que manda en aduana: una caja de
// poliéster va por «ART. DE POLIESTER», no por «CAJA».
//
// Las abreviaturas de la lista se expanden antes de comparar: en SAP están
// escritas como «ART. P/COCINA D/PORCE» y nadie describe así un artículo.
var _OC_ABREV={
  'ART':'ARTICULO','ARTS':'ARTICULOS','P':'PARA','D':'DE','C':'CON','S':'SIN',
  'ACCE':'ACCESORIO','ACCES':'ACCESORIO','JGO':'JUEGO','ORG':'ORGANIZADOR',
  'PORCE':'PORCELANA','PLAST':'PLASTICO','ALG':'ALGODON','ELEC':'ELECTRICO',
  'INOX':'INOXIDABLE','DEP':'DEPORTE','SRA':'SENORA','MAD':'MADERA',
  'DECO':'DECORATIVO','REP':'REPUESTO','MBL':'MUEBLE','VEG':'VEGETALES',
  'DESECH':'DESECHABLE','POLYPRO':'POLIPROPILENO','POLYESTER':'POLIESTER'
};

function _ocPalabras(txt){
  var t=String(txt||'').toUpperCase()
    .replace(/[ÁÀÄÂ]/g,'A').replace(/[ÉÈËÊ]/g,'E').replace(/[ÍÌÏÎ]/g,'I')
    .replace(/[ÓÒÖÔ]/g,'O').replace(/[ÚÙÜÛ]/g,'U').replace(/Ñ/g,'N')
    .replace(/[^A-Z0-9]+/g,' ').trim();
  if(!t) return [];
  return t.split(' ').map(function(p){
    return _OC_ABREV[p] || p;
  }).filter(function(p){
    // Fuera las palabras que no distinguen nada
    return p.length>2 && ['PARA','DE','CON','SIN','LOS','LAS','DEL','UNA'].indexOf(p)<0;
  });
}

function _ocArancelSugerido(l){
  var texto=[l.itemname, l.foreign_name, l.udf_comp_esp, l.udf_comp_ing, l.desc]
    .filter(Boolean).join(' ');
  var pal=_ocPalabras(texto);
  if(!pal.length) return null;

  var mejor=null, mejorPunt=0;
  OC_ARANCELES.forEach(function(a){
    var pa=_ocPalabras(a.n);
    if(!pa.length) return;
    var punt=0, casaCabeza=false, casadas=0;
    pa.forEach(function(p, idx){
      for(var i=0;i<pal.length;i++){
        var vale=0;
        if(pal[i]===p) vale=p.length*2;                      // palabra exacta
        else if(p.length>=4 && pal[i].indexOf(p)===0) vale=p.length;
        else if(pal[i].length>=4 && p.indexOf(pal[i])===0) vale=pal[i].length;
        if(!vale) continue;
        // La PRIMERA palabra del arancel es el sustantivo —ALFOMBRA, CUCHILLO,
        // SARTEN— y pesa el triple. Sin esto, «CESTO PARA ROPA» de poliéster
        // se iba a «ALFOMBRA D POLYESTER» solo por el material.
        if(idx===0){ vale*=3; if(i===0) { vale*=1.5; casaCabeza=true; } }
        punt+=vale; casadas++; return;
      }
    });
    if(!punt) return;
    // Y si el sustantivo del arancel no aparece en el artículo, la
    // coincidencia es de material suelto: se penaliza fuerte.
    if(!casaCabeza) punt*=0.45;
    // Si TODAS las palabras del arancel están en el artículo, gana la
    // específica sobre la genérica: «ALFOMBRA D/ALGODON» antes que
    // «ALFOMBRA» a secas. Sin esto, el nombre más corto ganaba siempre.
    // Cuando casan TODAS, no se divide por la longitud: si no, «ALFOMBRA»
    // a secas ganaba a «ALFOMBRA D/ALGODON» por ser más corta, justo al
    // revés de lo que interesa.
    punt = (casadas===pa.length) ? punt*1.8 : punt/Math.sqrt(pa.length);
    if(punt>mejorPunt){ mejorPunt=punt; mejor=a; }
  });

  // Por debajo de este listón la coincidencia es casual y es peor que nada:
  // el worker deduce del departamento y suele acertar más.
  return (mejorPunt >= 9) ? {a:mejor, punt:Math.round(mejorPunt)} : null;
}

// ── El selector de arancel ──────────────────────────────────────────────
// Un botón al lado de cada celda abre la lista completa con buscador. Es la
// salida cuando la sugerencia no acierta o cuando no hay ninguna.
// ── El selector de lista ────────────────────────────────────────────────
// Un botón al lado de la celda abre la lista completa con buscador. Sirve
// igual para el arancel y para la marca: lo único que cambia es de dónde lee.
function _ocListaBtn(campo, fila){
  var todos = (fila==='TODOS');
  var arg = todos ? "'TODOS'" : fila;
  return '<button onclick="_ocListaAbrir(\'' + campo + '\',' + arg + ')" '
    +'title="'+(todos?'Elegir y aplicar a todos los artículos':'Elegir de la lista')+'" '
    +'style="border:0.5px solid var(--border);background:var(--surface-1);'
    +'border-radius:5px;cursor:pointer;padding:'+(todos?'5px 9px':'2px 6px')+';'
    +'font-size:'+(todos?'12px':'11px')+';color:var(--t-azul);margin-left:4px">'
    +(todos?'<i class="ti ti-list-search"></i> Elegir':'▾')+'</button>';
}
// El nombre de antes sigue valiendo, para no tocar lo que ya lo llamaba
function _ocArancelBtn(fila){ return _ocListaBtn('arancel', fila); }

window._ocLista={campo:'arancel', fila:0};

function _ocListaAbrir(campo, fila){
  window._ocLista={campo:campo, fila:fila};
  var def=OC_LISTAS[campo]||OC_LISTAS.arancel;
  var ov=document.createElement('div');
  ov.id='modalLista';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10050;'
    +'display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:16px;'
      +'width:100%;max-width:520px;max-height:80vh;display:flex;flex-direction:column;'
      +'box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">'
      +'<div style="font-size:14px;font-weight:600">Elegir '+_esc(def.t)
      +(fila==='TODOS'?' <span style="font-weight:400;color:var(--text-muted)">'
        +'· se aplica a todos</span>':'')+'</div>'
      +'<button onclick="_ocListaCerrar()" style="background:none;border:none;'
      +'font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div id="ocLsCuenta" style="font-size:11px;color:var(--text-muted);margin-bottom:8px"></div>'
    +'<input id="ocLsBuscar" placeholder="Escribe para filtrar…" oninput="_ocListaFiltrar()" '
      +'style="font-size:13px;padding:8px 11px;border:0.5px solid var(--border);'
      +'border-radius:8px;background:var(--surface-0);color:var(--text-primary);'
      +'margin-bottom:10px">'
    +'<div id="ocLsLista" style="overflow-y:auto;flex:1;border:0.5px solid var(--border);'
      +'border-radius:8px;background:var(--surface-0)"></div></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _ocListaCerrar(); });
  document.body.appendChild(ov);
  _ocListaFiltrar();
  var b=document.getElementById('ocLsBuscar'); if(b) b.focus();
}

function _ocListaCerrar(){
  var m=document.getElementById('modalLista'); if(m) m.remove();
}

function _ocListaFiltrar(){
  var def=OC_LISTAS[window._ocLista.campo]||OC_LISTAS.arancel;
  var todos=def.datos();
  var q=_ocPalabras((document.getElementById('ocLsBuscar')||{}).value||'');
  var lista=todos;
  if(q.length){
    lista=todos.filter(function(a){
      var pa=_ocPalabras(a.n);
      return q.every(function(t){
        return pa.some(function(p){ return p.indexOf(t)===0 || t.indexOf(p)===0; });
      });
    });
  }
  var n=document.getElementById('ocLsCuenta');
  if(n) n.textContent = q.length ? (lista.length+' de '+todos.length)
                                 : (todos.length+' en total');
  var c=document.getElementById('ocLsLista'); if(!c) return;
  // Sin recortar: con un tope de 300 la lista se cortaba en la G y parecía
  // que faltaban aranceles. Son unos cientos de filas, se pintan de sobra.
  c.innerHTML = lista.length
    ? lista.map(function(a){
        return '<div onclick="_ocListaElegir(\'' + _esc(a.n).replace(/'/g,"\\'")
          +'\')" style="padding:7px 11px;font-size:12.5px;cursor:pointer;'
          +'border-bottom:0.5px solid var(--border);display:flex;gap:10px" '
          +'onmouseover="this.style.background=\'var(--bg-accent)\'" '
          +'onmouseout="this.style.background=\'\'">'
          +'<span style="flex:1">'+_esc(a.n)+'</span>'
          +'<span style="color:var(--text-muted);font-size:11px">'+_esc(a.c)+'</span></div>';
      }).join('')
    : '<div class="empty">Nada con esa palabra.</div>';
}

function _ocListaElegir(nombre){
  var d=window._ocDatos;
  var campo=window._ocLista.campo, fila=window._ocLista.fila;
  _ocListaCerrar();
  if(!d) return;
  if(fila==='TODOS'){
    _ocPonerEnTodos(campo, nombre);
    var caja=document.querySelector('#ocBarraTodos input[data-todos="'+campo+'"]');
    if(caja) caja.value=nombre;
    return;
  }
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  if(nuevos[fila]) nuevos[fila][campo]=nombre;
  var el=document.querySelector('.gc[data-g="ocitems"][data-f="'+fila+'"]'
                                +'[data-c="'+campo+'"]');
  if(el){
    el.value=nombre;
    el.style.background='var(--pastel-ok)';
    setTimeout(function(){ el.style.background=''; }, 700);
  }
}

function _ocRellenarItem(l, fijos){
  OC_CAMPOS_ITEM.forEach(function(c){
    if(l[c.k]!==undefined && l[c.k]!=='') return;
    if(c.fijo && fijos && fijos[c.fijo]) l[c.k]=fijos[c.fijo];
    else if(c.d) l[c.k]=c.d;
  });
  // La imagen se llama como la referencia, que es como lo hace contabilidad
  if(!l.imagen && l.itemcode) l.imagen=l.itemcode+'.JPG';
  // Y si nadie puso arancel, se propone el que más se parece. Si ninguno se
  // parece lo bastante se deja vacío: el worker lo deduce del departamento y
  // acierta más que una coincidencia de casualidad.
  if(!String(l.arancel||'').trim()){
    var sug=_ocArancelSugerido(l);
    if(sug){ l.arancel=sug.a.n; l._arancelSugerido=true; }
  }
  return l;
}

// La tabla de artículos nuevos, con los tres grupos y una cabecera por grupo
/* ═══════════════════════════════════════════════════════════════════════════
   FOTOS DE LOS ARTÍCULOS NUEVOS
   ───────────────────────────────────────────────────────────────────────────
   Al crear artículos en SAP, cada uno lleva su foto al lado. Salen de los
   archivos que ya están en la orden borrador —la PI del proveedor o la
   proforma de Kennedy— sin volver a pedir nada.

   Se pueden cambiar una a una, quitar, o reemplazar todas de golpe desde otro
   Excel. Y se puede subir sin ninguna: la foto no bloquea la creación.

   Al crear el artículo, la foto va al bucket `fotos-items` y se anota en
   `fotos_queue`; el worker la baja a la carpeta de red con el nombre
   «SKU.jpg», que es como las espera SAP.
   ═══════════════════════════════════════════════════════════════════════════ */

var FOTOS_BUCKET='fotos-items';

// SKU -> {b64, mime, origen}. Vive mientras dura la pantalla.
window._ocFotos = window._ocFotos || {};

// Las imágenes del navegador vienen en PNG casi siempre; SAP las quiere en
// JPG. Se convierten aquí, que además pesan bastante menos.
function _ocAJpeg(dataUrl, maxLado){
  return new Promise(function(res){
    try{
      var img=new Image();
      img.onload=function(){
        try{
          var m=maxLado||900;
          var w=img.width, h=img.height;
          if(w>m || h>m){ var f=Math.min(m/w, m/h); w=Math.round(w*f); h=Math.round(h*f); }
          var c=document.createElement('canvas');
          c.width=w; c.height=h;
          var cx=c.getContext('2d');
          // Fondo blanco: un PNG con transparencia en JPG saldría negro
          cx.fillStyle='#FFFFFF'; cx.fillRect(0,0,w,h);
          cx.drawImage(img,0,0,w,h);
          res(c.toDataURL('image/jpeg', 0.86));
        }catch(e){ res(dataUrl); }
      };
      img.onerror=function(){ res(dataUrl); };
      img.src=dataUrl;
    }catch(e){ res(dataUrl); }
  });
}

// Reúne las fotos que ya hay para los artículos de la orden. Mira, por este
// orden: la que quedó de la sesión de creación, la del catálogo borrador y la
// que el propio artículo trae encima.
async function _ocReunirFotos(d){
  var pend=window._nsapFotosPend||{};
  var n=0;
  for(var i=0;i<d.lineas.length;i++){
    var l=d.lineas[i];
    var sku=String(l.itemcode||'').trim();
    if(!sku || window._ocFotos[sku]) continue;

    var p=pend[sku.toUpperCase()];
    if(p && p.b64){
      window._ocFotos[sku]={b64:p.b64, mime:p.mime||'image/png', origen:'la proforma'};
      n++; continue;
    }
    if(l._foto && String(l._foto).indexOf('data:')===0){
      var pr=String(l._foto).split(',');
      window._ocFotos[sku]={b64:pr[1], mime:(pr[0].match(/data:([^;]+)/)||[])[1]||'image/png',
                            origen:'el artículo'};
      n++; continue;
    }
    // La del catálogo borrador, o la que ya esté en el servidor de fotos.
    // Se guarda la URL y se descarga solo al subir.
    try{
      var url=_fotoNoSapDeSku(sku);
      if(!url && l.picturname){ try{ url=_repFotoUrl(l.picturname); }catch(e){} }
      if(url){ window._ocFotos[sku]={url:url, origen:'el catálogo'}; n++; }
    }catch(e){}
  }
  _dbg('[fotos] '+n+' foto(s) encontradas para los artículos nuevos');
  return n;
}

function _ocFotoSrc(sku){
  var f=window._ocFotos[String(sku||'').trim()];
  if(!f) return '';
  if(f.url) return f.url;
  if(f.b64) return 'data:'+(f.mime||'image/png')+';base64,'+f.b64;
  return '';
}

// ── La celda de la foto, en la tabla de artículos ───────────────────────
// Al pasar el ratón aparecen las dos acciones: cambiar y quitar. Sin ratón
// (tableta) se ven igual, solo que siempre.
function _ocCeldaFoto(sku, fila){
  var src=_ocFotoSrc(sku);
  var id='ocf_'+fila;
  return '<div id="'+id+'" style="position:relative;width:46px;height:46px;'
    +'border:0.5px solid var(--border);border-radius:7px;overflow:hidden;'
    +'background:var(--surface-1);display:flex;align-items:center;justify-content:center" '
    +'onmouseover="this.querySelector(\'.ocf-acc\').style.opacity=1" '
    +'onmouseout="this.querySelector(\'.ocf-acc\').style.opacity=0">'
    + (src
       ? ('<img src="'+_esc(src)+'" style="width:100%;height:100%;object-fit:cover" '
          +'onclick="_ocFotoVer('+fila+')" title="Ver en grande" '
          +'onmouseenter="_fotoLupa(this)" onmouseleave="_fotoLupaFuera()">')
       : ('<i class="ti ti-photo-off" style="color:var(--text-muted);font-size:15px" '
          +'title="Sin foto · se creará igual"></i>'))
    +'<div class="ocf-acc" style="position:absolute;inset:0;background:rgba(0,0,0,.55);'
      +'opacity:0;transition:opacity .12s;display:flex;align-items:center;'
      +'justify-content:center;gap:3px">'
      +'<button onclick="event.stopPropagation();_ocFotoCambiar('+fila+')" '
      +'title="Cambiar la foto" style="border:none;background:#fff;border-radius:4px;'
      +'cursor:pointer;padding:2px 4px;font-size:10px;line-height:1">'
      +'<i class="ti ti-upload"></i></button>'
      + (src ? ('<button onclick="event.stopPropagation();_ocFotoQuitar('+fila+')" '
          +'title="Quitar la foto" style="border:none;background:#fff;border-radius:4px;'
          +'cursor:pointer;padding:2px 4px;font-size:10px;line-height:1;color:#A32D2D">'
          +'<i class="ti ti-x"></i></button>') : '')
    +'</div></div>';
}

function _ocLineasNuevas(){
  var d=window._ocDatos;
  return d ? d.lineas.filter(function(l){ return !l.enSap; }) : [];
}

function _ocRepintarFoto(fila){
  var nuevos=_ocLineasNuevas();
  var sku=String((nuevos[fila]||{}).itemcode||'').trim();
  var c=document.getElementById('ocf_'+fila);
  if(c && c.parentNode) c.parentNode.innerHTML=_ocCeldaFoto(sku, fila);
  _ocFotosResumen();
}

function _ocFotoCambiar(fila){
  var nuevos=_ocLineasNuevas();
  var sku=String((nuevos[fila]||{}).itemcode||'').trim();
  if(!sku){ showT('Esa línea no tiene código de artículo todavía'); return; }
  var inp=document.createElement('input');
  inp.type='file'; inp.accept='image/*';
  inp.onchange=async function(){
    var f=inp.files && inp.files[0];
    if(!f) return;
    var fr=new FileReader();
    fr.onload=async function(){
      var jpg=await _ocAJpeg(String(fr.result));
      window._ocFotos[sku]={b64:jpg.split(',')[1], mime:'image/jpeg', origen:'subida a mano'};
      _ocRepintarFoto(fila);
      showT('Foto cambiada para '+sku);
    };
    fr.readAsDataURL(f);
  };
  inp.click();
}

function _ocFotoQuitar(fila){
  var nuevos=_ocLineasNuevas();
  var sku=String((nuevos[fila]||{}).itemcode||'').trim();
  if(!sku) return;
  delete window._ocFotos[sku];
  _ocRepintarFoto(fila);
  showT(sku+' se creará sin foto');
}

function _ocFotoVer(fila){
  var nuevos=_ocLineasNuevas();
  var sku=String((nuevos[fila]||{}).itemcode||'').trim();
  var src=_ocFotoSrc(sku);
  if(src) verArchivo(src, sku+'.jpg');
}

// ── Todas a la vez ──────────────────────────────────────────────────────
function _ocFotosResumen(){
  var nuevos=_ocLineasNuevas();
  var con=nuevos.filter(function(l){ return !!_ocFotoSrc(l.itemcode); }).length;
  var e=document.getElementById('ocFotosCuenta');
  if(e){
    e.innerHTML = con+' de '+nuevos.length+' con foto'
      + (con<nuevos.length
         ? (' · <span style="color:var(--text-muted)">'+(nuevos.length-con)
            +' se crearán sin foto</span>')
         : '');
  }
  return con;
}

function _ocFotosBarra(){
  var nuevos=_ocLineasNuevas();
  if(!nuevos.length) return '';
  return '<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;'
    +'background:var(--surface-0);border:0.5px dashed var(--border);border-radius:9px;'
    +'padding:8px 12px;margin-bottom:10px">'
    +'<i class="ti ti-photo" style="font-size:14px;color:var(--t-lila)"></i>'
    +'<span id="ocFotosCuenta" style="font-size:11.5px;color:var(--text-secondary)"></span>'
    +'<span style="flex:1"></span>'
    +'<input type="file" id="ocFotosXls" accept=".xlsx" style="display:none" '
      +'onchange="_ocFotosDesdeExcel(this)">'
    +'<button class="btn bp" style="font-size:13px;padding:10px 18px;background:var(--t-lila);'
      +'display:inline-flex;align-items:center;gap:8px" '
      +'onclick="document.getElementById(\'ocFotosXls\').click()" '
      +'title="Saca las fotos de otro Excel y reemplaza las que coincidan por SKU">'
      +'<i class="ti ti-photo-plus" style="font-size:20px"></i> '
      +'TRAER FOTOS DE UN EXCEL</button>'
    +'<button class="xb" style="font-size:10.5px;padding:3px 9px;color:var(--text-danger)" '
      +'onclick="_ocFotosQuitarTodas()">'
      +'<i class="ti ti-photo-off"></i> Quitar todas</button>'
    +'</div>';
}

// Ninguna orden sale a SAP con artículos sin foto: la foto es la que se
// copia a la carpeta de red y la que después ve todo el mundo en la ficha.
function _ocSinFoto(){
  // _ocFotoSrc espera la REFERENCIA, no la línea: al pasarle el objeto
  // devolvía siempre vacío y la orden se bloqueaba diciendo que ningún
  // artículo tenía foto, aunque las tuviera todas.
  return _ocLineasNuevas().filter(function(l){
    var sku=String(l.itemcode||'').trim();
    if(!sku) return false;
    return !_ocFotoSrc(sku);
  });
}

function _ocAvisarSinFoto(){
  var sin=_ocSinFoto();
  if(!sin.length) return true;
  // Las fotos ya no BLOQUEAN: se avisa y se decide. Se pueden subir después
  // en bloque desde «Subir fotos a SAP», y la orden no tiene por qué
  // esperar a eso.
  return confirm(sin.length+' artículo(s) se van a crear SIN FOTO:\n\n'
    + sin.slice(0,10).map(function(l){ return '· '+l.itemcode; }).join('\n')
    + (sin.length>10?('\n· … y '+(sin.length-10)+' más'):'')
    + '\n\nLa orden se crea igual y las fotos se pueden subir después en bloque '
    + 'desde «Subir fotos a SAP», con el código como nombre del archivo.\n\n'
    + '¿Sigo y creo la orden?');
}

function _ocFotosQuitarTodas(){
  var nuevos=_ocLineasNuevas();
  var n=0;
  nuevos.forEach(function(l){
    var sku=String(l.itemcode||'').trim();
    if(sku && window._ocFotos[sku]){ delete window._ocFotos[sku]; n++; }
  });
  nuevos.forEach(function(l,i){ _ocRepintarFoto(i); });
  showT(n+' foto(s) quitadas · los artículos se crearán sin foto');
}

// Reemplazo masivo desde otro Excel: se emparejan por SKU y solo se cambian
// las que coincidan. Sirve cuando las de la proforma salen feas y el
// proveedor manda un archivo mejor.
async function _ocFotosDesdeExcel(input){
  var f=input && input.files && input.files[0];
  input.value='';
  if(!f) return;
  var nuevos=_ocLineasNuevas();
  if(!nuevos.length) return;
  showT('Buscando fotos en '+f.name+'…');
  try{
    var items=nuevos.map(function(l){ return {itemcode:l.itemcode}; });
    var mapa=await _nsapFotosPorSku(f, items);
    var n=0;
    nuevos.forEach(function(l){
      var sku=String(l.itemcode||'').trim();
      var p=mapa[sku.toUpperCase()];
      if(p && p.b64){
        window._ocFotos[sku]={b64:p.b64, mime:p.mime||'image/png', origen:f.name};
        n++;
      }
    });
    nuevos.forEach(function(l,i){ _ocRepintarFoto(i); });
    showT(n ? (n+' foto(s) reemplazadas desde '+f.name)
            : ('Ese archivo no trae fotos que coincidan con estos SKU'), 8000);
  }catch(e){
    showT('No pude leer las fotos: '+(e.message||e), 9000);
    console.warn('[fotos] excel:', e);
  }
}

// ── Subirlas al servidor ────────────────────────────────────────────────
// Va al bucket y se anota en fotos_queue; el worker la baja a la carpeta de
// red con el nombre «SKU.jpg», que es como las espera SAP.
async function _ocSubirFotos(skus){
  var hechas=0, fallos=[], ok={};
  for(var i=0;i<skus.length;i++){
    var sku=String(skus[i]||'').trim();
    if(!sku) continue;
    var f=window._ocFotos[sku];
    if(!f) continue;
    try{
      var b64=f.b64;
      if(!b64 && f.url){
        // La del catálogo: se descarga y se convierte
        var rr=await fetch(f.url);
        if(!rr.ok) throw new Error('no se pudo descargar ('+rr.status+')');
        var blob=await rr.blob();
        var dataUrl=await new Promise(function(res,rej){
          var fr=new FileReader(); fr.onload=function(){res(String(fr.result));};
          fr.onerror=rej; fr.readAsDataURL(blob);
        });
        b64=(await _ocAJpeg(dataUrl)).split(',')[1];
      } else {
        b64=(await _ocAJpeg('data:'+(f.mime||'image/png')+';base64,'+b64)).split(',')[1];
      }

      var nombre=sku+'.jpg';                    // como las espera SAP
      // El bucket distingue mayúsculas. Ponerla en minúsculas hacía que el
      // portal —que la busca por el nombre exacto de PicturName— recibiera
      // un 400 y el artículo saliera sin foto aunque estuviera subida.
      // Solo la extensión en minúscula, igual que _repFotoUrl.
      var ruta=nombre.replace(/\.([A-Za-z0-9]+)$/, function(m,e){
        return '.'+e.toLowerCase(); });
      var bin=atob(b64), arr=new Uint8Array(bin.length);
      for(var k=0;k<bin.length;k++) arr[k]=bin.charCodeAt(k);

      var r=await fetch(SB+'/storage/v1/object/'+FOTOS_BUCKET+'/'+encodeURIComponent(ruta),{
        method:'POST',
        headers:{'apikey':KEY,'Authorization':SBH.Authorization,
                 'Content-Type':'image/jpeg','x-upsert':'true'},
        body:arr});
      if(!r.ok && r.status!==409){
        var t=''; try{ t=await r.text(); }catch(e){}
        // El error de permisos viene envuelto y no dice qué hacer. Se traduce:
        // pasó una vez y costó tres vueltas averiguar que era una política.
        if(t.indexOf('row-level security')>=0 || t.indexOf('Unauthorized')>=0){
          throw new Error('el bucket de fotos no deja escribir. Hay que correr '
            +'permisos_bucket_fotos.sql en Supabase.');
        }
        if(r.status===404){
          throw new Error('no existe el bucket «'+FOTOS_BUCKET+'» en Supabase.');
        }
        throw new Error('bucket '+r.status+' '+t.slice(0,90));
      }

      // Si esa misma foto ya está esperando, no se encola otra vez. Subir
      // dos veces la misma orden dejaba la misma imagen repetida en la cola
      // y el worker la bajaba dos veces.
      try{
        var yaq=await fetch(SB+'/rest/v1/fotos_queue?select=id&estado=eq.pendiente'
          +'&archivo=eq.'+encodeURIComponent(ruta)+'&limit=1',{headers:SBH});
        if(yaq.ok && (await yaq.json()||[]).length){
          hechas++; ok[sku]=true;          // ya está en camino: cuenta igual
          continue;
        }
      }catch(e){}

      var rq=await fetch(SB+'/rest/v1/fotos_queue',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        // Las columnas reales de fotos_queue, comprobadas contra la base:
        // id, archivo, itemcode, nombre_orig, estado, error_msg, subido_por,
        // created_at, procesado_en. El 400 de antes era por pedir «creado_en»
        // al LEER —la columna es created_at—, no por esto.
        body:JSON.stringify({archivo:ruta, itemcode:sku, nombre_orig:nombre,
                             estado:'pendiente', subido_por:(CU&&CU.name)||''})});
      if(!rq.ok){
        var t2=''; try{ t2=await rq.text(); }catch(e){}
        // El permiso de la TABLA es distinto del permiso del bucket: la
        // imagen ya está subida y aun así la fila se rechaza.
        if(t2.indexOf('row-level security')>=0 || rq.status===401 || rq.status===403){
          throw new Error('la tabla fotos_queue no deja escribir. Hay que correr '
            +'permisos_fotos_queue.sql en Supabase. (La imagen sí se subió.)');
        }
        if(t2.indexOf('column')>=0){
          throw new Error('a fotos_queue le falta o le sobra una columna · '+t2.slice(0,110));
        }
        throw new Error('cola '+rq.status+' '+t2.slice(0,90));
      }
      hechas++;
      ok[sku]=true;                 // esta sí llegó al servidor
    }catch(e){
      // Solo se guarda: al final sale un único resumen. Uno por foto llenaba
      // la consola de rojo y escondía lo que importaba.
      fallos.push(sku+': '+(e.message||e));
    }
  }
  return {hechas:hechas, fallos:fallos, ok:ok};
}

// ── Completar lo que falte desde los archivos de la orden ───────────────
// La orden borrador guarda lo que la IA sacó al crearla, y a veces se deja
// alguna columna: el código de barras suele venir en la PI del proveedor
// aunque no esté en la proforma de Kennedy, o al revés.
//
// Antes de montar la orden de SAP se miran TODOS los Excel adjuntos y se
// rellena solo lo que esté vacío. Ninguno pisa un dato que ya venía: se
// completa, no se sustituye.
var OC_DESDE_ARCHIVO=[
  // campo del artículo   columna de la proforma
  ['barcode',      'barcode'],
  ['mfr_catalog',  'factory'],
  ['foreign_name', 'ing'],
  ['itemname',     'esp'],
  ['udf_comp_ing', 'comp'],
  ['udf_comp_esp', 'comp'],
  ['udf_color',    'color'],
  ['udf_tamano',   'size'],
  ['udf_bulto',    'carton'],
  ['pzs_bulto_compra','qtyCtn'],
  ['volumen_compra','cbm'],
  ['precio',       'precio']
];

// Los Excel que cuelgan de una orden, mirando todas sus etapas
function _ocExcelDeOrden(ref){
  var out=[], vistos={};
  try{
    var refs=_refsDeOrden(ref).map(String);
    Object.keys(window._atts||{}).forEach(function(k){
      if(!refs.some(function(r){ return k.indexOf(r)===0; })) return;
      (window._atts[k]||[]).forEach(function(a){
        var nom=String(a.name||'');
        if(!/\.(xlsx|xlsm|xls)$/i.test(nom)) return;
        var src=a.url ? (DOCS_BASE+String(a.url).split('/').map(encodeURIComponent).join('/'))
                      : (a.data||'');
        if(!src || vistos[src]) return;
        vistos[src]=1;
        out.push({nombre:nom, src:src});
      });
    });
  }catch(e){ console.warn('[OC] buscar excel:', e); }
  return out;
}

// Lee un Excel y devuelve lo que sepa de cada SKU
async function _ocLeerFichasDeExcel(src, nombre, archivo){
  var fichas={};
  try{
    // Vale una dirección o un archivo suelto: el Revised PO llega como
    // archivo y no tiene sentido darle una vuelta por una URL temporal.
    var buf;
    if(archivo && archivo.arrayBuffer){
      buf=await archivo.arrayBuffer();
    } else {
      var r=await fetch(src);
      if(!r.ok) throw new Error('estado '+r.status);
      buf=await r.arrayBuffer();
    }
    var ExcelJSlib=await _bkExcelJS();
    var wb=new ExcelJSlib.Workbook();
    await wb.xlsx.load(buf);

    var d=_profDetectar(wb, ['itemcode']);
    if(!d){ _dbg('[OC] '+nombre+': no tiene tabla de artículos'); return fichas; }

    for(var r2=d.cab+1; r2<=d.ws.rowCount; r2++){
      var code=String(_profVal(d.ws, r2, d.col.itemcode)).trim();
      if(!code) break;
      if(_profEsCabecera(code)) continue;
      var f={};
      Object.keys(d.col).forEach(function(k){
        var v=_profVal(d.ws, r2, d.col[k]);
        if(v!==null && v!==undefined && String(v).trim()!=='') f[k]=v;
      });
      fichas[code.toUpperCase()]=f;
    }
    _dbg('[OC] '+nombre+': '+Object.keys(fichas).length+' artículo(s)');
  }catch(e){
    console.warn('[OC] no pude leer '+nombre+':', e);
  }
  return fichas;
}

// Rellena los huecos de las líneas con lo que encuentre en los adjuntos
async function _ocCompletarDesdeArchivos(d, ref){
  var faltan=_ocHuecos(d);
  if(!faltan.total){ _dbg('[OC] no falta ningún dato'); return 0; }

  var archivos=_ocExcelDeOrden(ref);
  if(!archivos.length){
    _dbg('[OC] faltan datos pero la orden no tiene ningún Excel adjunto');
    return 0;
  }
  _dbg('[OC] faltan '+faltan.total+' dato(s); se miran '+archivos.length+' archivo(s)');

  var puestos=0, deDonde={};
  for(var i=0;i<archivos.length;i++){
    if(!_ocHuecos(d).total) break;               // ya no falta nada
    var fichas=await _ocLeerFichasDeExcel(archivos[i].src, archivos[i].nombre);
    if(!Object.keys(fichas).length) continue;

    d.lineas.forEach(function(l){
      var f=fichas[String(l.itemcode||'').trim().toUpperCase()];
      if(!f) return;
      OC_DESDE_ARCHIVO.forEach(function(par){
        var campo=par[0], col=par[1];
        if(String(l[campo]||'').trim()!=='') return;   // ya lo tenía
        if(f[col]===undefined) return;
        l[campo]=f[col];
        puestos++;
        deDonde[archivos[i].nombre]=(deDonde[archivos[i].nombre]||0)+1;
      });
    });
  }

  if(puestos){
    var det=Object.keys(deDonde).map(function(n){ return n+' ('+deDonde[n]+')'; }).join(', ');
    _dbg('[OC] completados '+puestos+' dato(s) desde '+det);
    d._completados={n:puestos, de:det};
  }
  return puestos;
}

// Qué columnas están vacías y en cuántas líneas
function _ocHuecos(d){
  var res={total:0, porCampo:{}};
  (d.lineas||[]).forEach(function(l){
    if(l.enSap) return;                          // los que ya existen no se tocan
    OC_DESDE_ARCHIVO.forEach(function(par){
      if(String(l[par[0]]||'').trim()==='') {
        res.total++;
        res.porCampo[par[0]]=(res.porCampo[par[0]]||0)+1;
      }
    });
  });
  return res;
}

function _ocTablaItems(nuevos, fijos, d){
  // El proveedor de la columna es el de ESTA orden. El 589 sale del valor
  // por defecto de las hojas de creación y no pinta nada aquí.
  try{
    var _dd=d||window._ocDatos||{};
    var _pv=String((_dd.prov&&(_dd.prov.cardcode||_dd.prov.codigo))
                   || _dd.cardcode || (_dd.provNuevo&&_dd.provNuevo.cardcode) || '').trim();
    // El valor guardado en las hojas (589 y compañía) no vale aquí: o va el
    // proveedor de ESTA orden, o la casilla se deja vacía para que no se
    // suba un proveedor que no es.
    var _viejo=String((_txtFijosGuardados()||{}).prov||'').trim();
    fijos=Object.assign({}, fijos||{}, {prov:_pv});
    (nuevos||[]).forEach(function(l){
      var v=String(l.proveedor||'').trim();
      if(!v || v===_viejo || v==='589') l.proveedor=_pv;
    });
  }catch(e){}
  // «d» hacía falta para saber el departamento y no estaba en la firma: la
  // función reventaba al pintar y el panel salía en blanco. Si no llega, se
  // deduce del grupo del primer artículo.
  d = d || window._ocDatos || {lineas:nuevos};
  nuevos.forEach(function(l){ _ocRellenarItem(l, fijos); });

  // Si a alguna línea le falta el arancel —a la primera le pasaba casi
  // siempre, porque su descripción no se parecía a ninguno— se le pone el
  // que más se repite entre las demás. Vale más un arancel coherente con el
  // resto de la orden que una casilla vacía.
  try{
    var _cuenta={}, _falta=false;
    (nuevos||[]).forEach(function(l){
      var a=String(l.arancel||'').trim();
      if(a) _cuenta[a]=(_cuenta[a]||0)+1; else _falta=true;
    });
    if(_falta){
      var _may='', _n=0;
      Object.keys(_cuenta).forEach(function(k){ if(_cuenta[k]>_n){ _n=_cuenta[k]; _may=k; } });
      if(!_may) _may=String((fijos&&fijos.arancel)||'').trim();
      if(_may){
        (nuevos||[]).forEach(function(l){
          if(!String(l.arancel||'').trim()){ l.arancel=_may; l._arancelSugerido=true; }
        });
      }
    }
  }catch(e){}

  // Cabecera de grupos: una celda por grupo, del ancho de sus columnas
  // Los grupos, de las MISMAS columnas que se van a pintar. Con la lista
  // fija, las de ropa y alfombras quedaban fuera de la cabecera: los anchos
  // no cuadraban y la tabla salía descuadrada y casi vacía.
  var CAMPOS=_ocCamposVivos(d);
  var grupos=[], ult=null;
  CAMPOS.forEach(function(c){
    var g=c.g || (c.dept ? 'Del departamento' : 'Otros');
    if(g!==ult){ grupos.push({g:g, n:1}); ult=g; }
    else grupos[grupos.length-1].n++;
  });

  var h='<div class="tbx-box">'
    +'<table class="tbx" style="font-size:11.5px"><thead>'
    +'<tr><th style="background:var(--surface-1)"></th>'+grupos.map(function(x){
        var c=OC_GRUPO_COLOR[x.g]||{bg:'var(--surface-1)',tx:'var(--text-muted)'};
        return '<th colspan="'+x.n+'" style="background:'+c.bg+';color:'+c.tx+';'
          +'text-align:center;font-size:11px;letter-spacing:.3px">'+_esc(x.g)+'</th>';
      }).join('')+'</tr>'
    +'<tr><th style="width:52px">Foto</th>'+CAMPOS.map(function(c){
        return '<th style="white-space:nowrap'
          +(c.req?';color:var(--t-rojo)':'')
          +(c.sinSap?';opacity:.65':'')+'"'
          +(c.sinSap?' title="Este dato no tiene campo en SAP: se guarda en el '
            +'borrador pero no se sube"':'')+'>'+_esc(c.t)
          +(c.req?' *':'')
          +(c.sinSap?' <span style="font-weight:400;font-size:10px">(solo '
            +'borrador)</span>':'')+'</th>';
      }).join('')+'</tr></thead><tbody>'
    + nuevos.map(function(l,i){
        return '<tr><td>'+_ocCeldaFoto(l.itemcode, i)+'</td>'
          +CAMPOS.map(function(c){
          var falta=c.req && !String(l[c.k]||'').trim();
          var celda = (c.lista==='grupos')
            ? _gridLista('ocitems', i, c.k, l[c.k], OC_GRUPOS, c.w)
            : _gridCelda('ocitems', i, c.k, l[c.k], c.w);
          // Arancel y marca llevan su botón de lista al lado
          if(OC_LISTAS[c.k]){
            celda='<div style="display:flex;align-items:center">'+celda
              +_ocListaBtn(c.k, i)+'</div>';
          }
          if(falta) celda=celda.replace('border:0.5px solid var(--border)',
                                        'border:1px solid var(--t-rojo)');
          return '<td'+(falta?' style="background:var(--pastel-error)"':'')+'>'+celda+'</td>';
        }).join('')+'</tr>';
      }).join('')
    +'</tbody></table></div>';
  return h;
}

/* ═══════════════════════════════════════════════════════════════════════════
   COMPARAR CONTRA LA FACTURA DEL PROVEEDOR
   ───────────────────────────────────────────────────────────────────────────
   La proforma es lo que se pidió; la factura es lo que el proveedor va a
   cobrar de verdad. Entre una y otra cambian cantidades, precios y a veces
   hasta las referencias.

   Si se adjunta la factura, manda ella: a SAP va lo que dice la factura. Si
   no se adjunta, se sube el borrador tal cual, que es como estaba.

   Nada se aplica solo: primero se enseña el informe de diferencias y la
   persona decide.
   ═══════════════════════════════════════════════════════════════════════════ */

function _ocNormSku(s){
  return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
}

// Lee la factura con el mismo detector que la proforma: la cabecera puede
// venir con otros títulos y ya sabe reconocerlos.
async function _ocLeerFactura(file){
  var ExcelJSlib=await _bkExcelJS();
  var wb=new ExcelJSlib.Workbook();
  await wb.xlsx.load(await file.arrayBuffer());

  var d=_profDetectar(wb, ['itemcode','cantidad','precio']);
  if(!d) throw new Error('No encontré la tabla de artículos en la factura. '
    +'Necesita una fila de títulos con el código, la cantidad y el precio.');

  var lineas=[];
  for(var r=d.cab+1; r<=d.ws.rowCount; r++){
    var code=String(_profVal(d.ws,r,d.col.itemcode)).trim();
    if(!code || /^TOTAL/i.test(_bkNorm(code))) break;
    if(_profEsCabecera(code)) continue;
    var cant=Number(_profVal(d.ws,r,d.col.cantidad))||0;
    if(!cant) continue;
    lineas.push({
      itemcode:code,
      cantidad:cant,
      precio:Number(_profVal(d.ws,r,d.col.precio))||0,
      itemname:String(_profVal(d.ws,r,d.col.esp)||_profVal(d.ws,r,d.col.ing)||'').trim(),
      foreign_name:String(_profVal(d.ws,r,d.col.ing)||'').trim(),
      barcode:String(_profVal(d.ws,r,d.col.barcode)||'').trim()
    });
  }
  if(!lineas.length) throw new Error('La factura no trae ninguna línea con cantidad.');
  return {nombre:file.name, hoja:d.ws.name, lineas:lineas};
}

// Compara la factura contra lo que hay ahora en la orden
function _ocCompararFactura(d, fac){
  var porSku={};
  d.lineas.forEach(function(l,i){ porSku[_ocNormSku(l.itemcode)]={l:l, i:i}; });

  var dif={cantidad:[], precio:[], nuevas:[], faltan:[], iguales:0};
  var vistos={};

  fac.lineas.forEach(function(f){
    var k=_ocNormSku(f.itemcode);
    vistos[k]=1;
    var p=porSku[k];
    if(!p){ dif.nuevas.push(f); return; }
    var cambio=false;
    var ca=Number(p.l.cantidad)||0, cb=Number(f.cantidad)||0;
    var pa=Number(p.l.precio)||0,   pb=Number(f.precio)||0;
    if(Math.abs(ca-cb)>0.0001){
      dif.cantidad.push({itemcode:p.l.itemcode, antes:ca, ahora:cb,
                         nombre:p.l.itemname||f.itemname});
      cambio=true;
    }
    if(Math.abs(pa-pb)>0.0001){
      dif.precio.push({itemcode:p.l.itemcode, antes:pa, ahora:pb,
                       nombre:p.l.itemname||f.itemname});
      cambio=true;
    }
    if(!cambio) dif.iguales++;
  });

  d.lineas.forEach(function(l){
    if(!vistos[_ocNormSku(l.itemcode)]){
      dif.faltan.push({itemcode:l.itemcode, nombre:l.itemname,
                       cantidad:l.cantidad, precio:l.precio});
    }
  });

  dif.total = dif.cantidad.length + dif.precio.length
            + dif.nuevas.length + dif.faltan.length;

  // El dinero, que es lo que más importa de un vistazo
  dif.totalAntes = d.lineas.reduce(function(a,l){
    return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);
  dif.totalAhora = fac.lineas.reduce(function(a,l){
    return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);
  return dif;
}

// ── El bloque en la pantalla ────────────────────────────────────────────
function _ocBloqueFactura(d){
  var c={bg:'var(--pastel-verde2)', tx:'var(--t-verde2)', bd:'#7FBF9A'};
  var f=d.factura;

  var h=_ocCabBloque('orden','2b · Factura del proveedor',
      f ? ('manda la factura: '+_esc(f.nombre)) : 'opcional · si no hay, se sube el borrador',
      _ocInsignia(f?('Comparada · '+f.lineas.length+' líneas'):'Sin factura', !!f));
  h+='<div style="border:1px solid '+OC_COLOR.orden.bd+';border-top:none;'
    +'border-radius:0 0 10px 10px;padding:12px 13px;background:var(--surface-1);'
    +'margin-bottom:16px">';

  if(!f){
    h+='<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 10px;line-height:1.5">'
      +'La proforma es lo que se pidió; la factura es lo que el proveedor va a cobrar. '
      +'Si la adjuntas, se comparan y <b>manda la factura</b>: a SAP va lo que ella diga.<br>'
      +'Si no adjuntas nada, se sube el borrador tal como está.</p>'
      +'<input type="file" id="ocFacFile" accept=".xlsx" style="display:none" '
      +'onchange="_ocFacturaCargar(this)">'
      +'<button class="xb" onclick="document.getElementById(\'ocFacFile\').click()">'
      +'<i class="ti ti-file-invoice"></i> Comparar con la factura</button>';
    return h+'</div>';
  }

  h+=_ocFacturaInforme(d, f.dif);
  h+='<div style="display:flex;gap:8px;margin-top:11px;flex-wrap:wrap">'
    +(f.aplicada
      ? '<span style="font-size:11.5px;color:var(--t-verde);align-self:center">'
        +'<i class="ti ti-circle-check"></i> Aplicada: la tabla de abajo ya es la factura.</span>'
      : ('<button class="btn bp" onclick="_ocFacturaAplicar()">'
         +'<i class="ti ti-check"></i> Usar la factura</button>'
         +'<span style="font-size:11px;color:var(--text-muted);align-self:center">'
         +'Sustituye cantidades y precios por los de la factura.</span>'))
    +'<span style="flex:1"></span>'
    +'<button class="xb" style="color:var(--text-danger)" onclick="_ocFacturaQuitar()">'
    +'<i class="ti ti-x"></i> Quitar la factura</button></div>';
  return h+'</div>';
}

function _ocFacturaInforme(d, dif){
  if(!dif.total){
    return '<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde)">'
      +'<i class="ti ti-circle-check"></i> La factura coincide con el borrador en '
      +'las '+dif.iguales+' líneas. No hay nada que cambiar.</div>';
  }

  var fila=function(tit, items, pinta){
    if(!items.length) return '';
    return '<div style="margin-bottom:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:3px">'
      +_esc(tit)+' ('+items.length+')</div>'
      +'<div style="font-size:11.5px;line-height:1.7">'
      + items.slice(0,12).map(pinta).join('')
      + (items.length>12 ? ('<div style="color:var(--text-muted)">… y '
          +(items.length-12)+' más</div>') : '')
      +'</div></div>';
  };

  var dinero=dif.totalAhora-dif.totalAntes;
  var h='<div style="background:var(--pastel-aviso);border:0.5px solid #E0A82E;'
    +'border-radius:10px;padding:11px 14px">'
    +'<div style="font-size:12.5px;font-weight:700;color:var(--t-marron);margin-bottom:8px">'
    +'<i class="ti ti-arrows-diff"></i> '+dif.total+' diferencia(s) entre la proforma y la factura'
    +'</div>';

  h+=fila('Cambió la cantidad', dif.cantidad, function(x){
    return '<div>· <b>'+_esc(x.itemcode)+'</b> '+_esc(String(x.nombre||'').slice(0,26))
      +' — <span style="text-decoration:line-through;opacity:.6">'+_fmtN2(x.antes)+'</span> '
      +'→ <b>'+_fmtN2(x.ahora)+'</b></div>';
  });
  h+=fila('Cambió el precio', dif.precio, function(x){
    return '<div>· <b>'+_esc(x.itemcode)+'</b> '+_esc(String(x.nombre||'').slice(0,26))
      +' — <span style="text-decoration:line-through;opacity:.6">'+_fmtN2(x.antes)+'</span> '
      +'→ <b>'+_fmtN2(x.ahora)+'</b></div>';
  });
  h+=fila('Solo en la factura · se añadirán', dif.nuevas, function(x){
    return '<div>· <b>'+_esc(x.itemcode)+'</b> '+_esc(String(x.itemname||'').slice(0,26))
      +' — '+_fmtN2(x.cantidad)+' × '+_fmtN2(x.precio)+'</div>';
  });
  h+=fila('No están en la factura · se quitarán', dif.faltan, function(x){
    return '<div>· <b>'+_esc(x.itemcode)+'</b> '+_esc(String(x.nombre||'').slice(0,26))
      +' — '+_fmtN2(x.cantidad)+' × '+_fmtN2(x.precio)+'</div>';
  });

  h+='<div style="border-top:0.5px solid #E0A82E;margin-top:6px;padding-top:7px;'
    +'font-size:12px;color:var(--t-marron)">'
    +'Total de la orden: '+_fmtN2(dif.totalAntes)+' → <b>'+_fmtN2(dif.totalAhora)+'</b>'
    +' <span style="font-weight:700">('+(dinero>=0?'+':'')+_fmtN2(dinero)+')</span></div>';
  return h+'</div>';
}

// ── Cargar, aplicar y quitar ────────────────────────────────────────────
async function _ocFacturaCargar(input){
  var file=input && input.files && input.files[0];
  input.value='';
  if(!file) return;
  var d=window._ocDatos; if(!d) return;
  _ocMsg('Leyendo la factura '+_esc(file.name)+'…');
  try{
    var fac=await _ocLeerFactura(file);
    fac.dif=_ocCompararFactura(d, fac);
    fac.aplicada=false;
    d.factura=fac;
    _ocMsg(fac.dif.total
      ? ('Factura leída: '+fac.dif.total+' diferencia(s) con el borrador. '
         +'Míralas antes de aplicarla.')
      : 'Factura leída: coincide con el borrador en todo.', 'ok');
    _ocPintarTodo();
  }catch(e){
    _ocMsg('No pude leer la factura: '+_esc(e.message||e),'err');
  }
}

function _ocFacturaQuitar(){
  var d=window._ocDatos; if(!d) return;
  if(d.factura && d.factura.aplicada){
    if(!confirm('La factura ya se aplicó: las cantidades y precios de la tabla '
      +'son los suyos.\n\nQuitarla NO deshace ese cambio. ¿Sigo?')) return;
  }
  delete d.factura;
  _ocPintarTodo();
  showT('Factura quitada · se subirá lo que haya en la tabla');
}

// Aplica la factura: manda ella. Cambia cantidades y precios, añade lo que
// solo está en la factura y quita lo que ya no aparece.
async function _ocFacturaAplicar(){
  var d=window._ocDatos; if(!d || !d.factura) return;
  var fac=d.factura, dif=fac.dif;

  var aviso='SE VA A APLICAR LA FACTURA\n\n';
  if(dif.cantidad.length) aviso+='· '+dif.cantidad.length+' cambio(s) de cantidad\n';
  if(dif.precio.length)   aviso+='· '+dif.precio.length+' cambio(s) de precio\n';
  if(dif.nuevas.length)   aviso+='· '+dif.nuevas.length+' línea(s) que se AÑADEN\n';
  if(dif.faltan.length)   aviso+='· '+dif.faltan.length+' línea(s) que se QUITAN\n';
  aviso+='\nTotal: '+_fmtN2(dif.totalAntes)+' → '+_fmtN2(dif.totalAhora)+'\n\n'
    +'A partir de aquí, a SAP va lo que dice la factura. ¿Sigo?';
  if(!confirm(aviso)) return;

  var porSku={};
  d.lineas.forEach(function(l){ porSku[_ocNormSku(l.itemcode)]=l; });

  var nuevas=[];
  fac.lineas.forEach(function(f){
    var l=porSku[_ocNormSku(f.itemcode)];
    if(l){
      l.cantidad=f.cantidad;
      l.precio=f.precio;
      // El nombre y el barcode solo si la línea no los tenía: la proforma
      // suele traerlos mejor puestos que la factura.
      if(!String(l.itemname||'').trim() && f.itemname) l.itemname=f.itemname;
      if(!String(l.barcode||'').trim() && f.barcode) l.barcode=f.barcode;
      nuevas.push(l);
    } else {
      // Referencia que solo está en la factura
      nuevas.push(_ocRellenarItem({
        itemcode:f.itemcode, itemname:f.itemname||f.itemcode,
        foreign_name:f.foreign_name||'', barcode:f.barcode||'',
        cantidad:f.cantidad, precio:f.precio,
        grupo:(d.lineas[0]||{}).grupo||''
      }, d.k||_txtFijosGuardados()));
    }
  });

  d.lineas=nuevas;
  fac.aplicada=true;

  // Las referencias nuevas hay que volver a mirarlas contra SAP, y las que
  // se fueron dejan de necesitar foto.
  _ocMsg('Aplicando la factura…');
  try{ await _ocComprobar(d); }catch(e){ console.warn('[OC] comprobar:', e); }
  try{ await _ocReunirFotos(d); }catch(e){ console.warn('[OC] fotos:', e); }
  try{ await _ocRevisarBarcodes(d); }catch(e){ console.warn('[OC] barcodes:', e); }

  _ocMsg('✓ Factura aplicada: la orden que se subirá es la de la factura · '
    +d.lineas.length+' líneas · '+_fmtN2(dif.totalAhora),'ok');
  _ocPintarTodo();
}

function _ocBloqueItems(d){
  var c=OC_COLOR.items;
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  var viejos=d.lineas.length-nuevos.length;

  d.k = d.k || _txtFijosGuardados();
  var h=_ocCabBloque('items','2 · Artículos',
      viejos+' ya en SAP · '+nuevos.length+' por crear',
      _ocInsignia(nuevos.length?(nuevos.length+' nuevos'):'todos existen', !!nuevos.length));
  h+='<div style="border:1px solid '+c.bd+';border-top:none;border-radius:0 0 10px 10px;'
    +'padding:12px 13px;background:var(--surface-1);margin-bottom:16px">';

  if(!nuevos.length){
    h+='<div style="font-size:12px;color:var(--t-verde)">'
      +'<i class="ti ti-circle-check"></i> Los '+d.lineas.length
      +' artículos de la proforma ya existen en SAP. No hay que crear ninguno.</div>';
    return h+'</div>';
  }

  h+='<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 9px;line-height:1.5">'
    +'Lo que se pudo leer de la proforma está relleno. Puedes escribir encima o '
    +'<b>pegar varias columnas de una vez</b> desde un Excel abierto: sitúate en la '
    +'primera celda y pega.<br>'
    +'Solo el código y la descripción son obligatorios; lo que falte se completa '
    +'después en SAP.</p>';

  // Las que ya existen: solo para verlas, no se tocan
  if(viejos){
    h+='<div style="font-size:11px;color:var(--t-verde);margin-bottom:8px">'
      +'<i class="ti ti-check"></i> '+viejos+' ya existen y no se tocan: '
      +_esc(d.lineas.filter(function(l){ return l.enSap; })
             .slice(0,8).map(function(l){ return l.itemcode; }).join(', '))
      +(viejos>8?' …':'')+'</div>';
  }

  h+=_ocAvisoHuecos(d);
  h+=_ocAvisoRevision(d);
  h+=_ocAplicarATodos(nuevos);
  h+=_ocFotosBarra();
  // El proveedor de cada artículo es el de ESTA orden, no el que quedó
  // guardado en las hojas de creación (de ahí salía siempre el 589).
  var _fijos=Object.assign({}, d.k||_txtFijosGuardados());
  var _provOrden=String((d.prov&&(d.prov.cardcode||d.prov.codigo))||d.cardcode||'').trim();
  if(_provOrden){
    _fijos.prov=_provOrden;
    nuevos.forEach(function(l){
      if(!l.enSap && (!l.proveedor || l.proveedor===(d.k||_txtFijosGuardados()).prov)){
        l.proveedor=_provOrden;
      }
    });
  }
  h+=_ocTablaItems(nuevos, _fijos, d);

  var faltan=nuevos.filter(function(l){
    return !String(l.itemcode||'').trim() || !String(l.itemname||'').trim(); }).length;
  if(faltan){
    h+='<div style="font-size:11.5px;color:var(--t-rojo);margin-top:8px">'
      +'<i class="ti ti-alert-triangle"></i> '+faltan
      +' artículo(s) sin código o sin descripción. Sin eso SAP no los acepta.</div>';
  }
  return h+'</div>';
}

// ── La orden ────────────────────────────────────────────────────────────
function _ocBloqueOrden(d){
  var c=OC_COLOR.orden;
  var total=d.lineas.reduce(function(a,l){
    return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);
  // CANTIDAD y PRECIO van primero: son de la línea de la orden, no de la
  // ficha del artículo, y no estaban en la lista de columnas. Por eso la
  // orden se creaba bien pero no había forma de ver ni corregir las
  // cantidades pedidas.
  var CAMPOS=[{k:'cantidad', t:'Cantidad', w:'90px', num:true, req:true},
              {k:'precio',   t:'Precio',   w:'90px', num:true}]
             .concat(_ocCamposVivos(d));
  var yaEnSap=d.lineas.filter(function(l){ return l.enSap; }).length;

  var h=_ocCabBloque('orden','3 · Orden de compra',
      d.lineas.length+' líneas · '+_fmtN2(total),
      _ocInsignia('Se crea en SAP', true));
  h+='<div style="border:1px solid '+c.bd+';border-top:none;'
    +'border-radius:0 0 10px 10px;padding:12px 13px;background:var(--surface-1);'
    +'margin-bottom:16px">';

  // La tabla lleva TODOS los campos del artículo, no solo cantidad y precio.
  // Cuando los artículos ya existen en SAP el bloque de arriba no enseña
  // nada, y aquí no había forma de revisar ni corregir lo demás.
  if(yaEnSap){
    h+='<div class="nota" style="background:var(--pastel-azul);color:var(--t-azul)">'
      +'<i class="ti ti-info-circle"></i> <b>'+yaEnSap+' de '+d.lineas.length
      +' artículo(s) ya existen en SAP.</b> Puedes editar aquí sus datos, pero '
      +'por defecto no se toca una ficha que ya está creada: solo se aplicará '
      +'si marcas la casilla.'
      +'<label style="display:flex;align-items:center;gap:7px;margin-top:6px;'
      +'cursor:pointer;font-weight:600">'
      +'<input type="checkbox" '+(d.actualizarExistentes?'checked':'')+' '
      +'onchange="window._ocDatos.actualizarExistentes=this.checked">'
      +'Actualizar también en SAP los artículos que ya existen</label></div>';
  }

  _gridRegistrar('oclineas', CAMPOS.map(function(x){ return x.k; }),
                 d.lineas, _ocTotalesVivos);

  h+='<div id="ocLineasCaja">'
    +'<div class="tbx-box" style="max-height:46vh">'
    +'<table class="tbx"><thead>'
    +'<tr><th style="width:26px"></th><th style="width:52px">Foto</th>'
    + CAMPOS.map(function(x){
        return '<th style="white-space:nowrap'
          +(x.req?';color:var(--t-rojo)':'')
          +(x.sinSap?';opacity:.65':'')+'">'+_esc(x.t)
          +(x.sinSap?' <span style="font-weight:400;font-size:10px">(solo '
            +'borrador)</span>':'')+'</th>';
      }).join('')
    +'<th style="text-align:right;width:95px">Total</th></tr></thead><tbody>'
    + d.lineas.map(function(l,i){
        return '<tr>'
          +'<td>'+(l.enSap
            ? '<i class="ti ti-check" style="color:var(--t-verde)" '
              +'title="Ya existe en SAP"></i>'
            : '<i class="ti ti-plus" style="color:var(--t-marron)" '
              +'title="Se crea ahora"></i>')+'</td>'
          +'<td>'+_ocCeldaFoto(l.itemcode, i)+'</td>'
          + CAMPOS.map(function(x){
              var celda = x.lista==='grupos'
                ? _gridLista('oclineas', i, x.k, l[x.k], OC_GRUPOS, x.w)
                : (x.lista
                   ? _gridLista('oclineas', i, x.k, l[x.k], x.lista, x.w)
                   : _gridCelda('oclineas', i, x.k, l[x.k], x.w));
              if(OC_LISTAS[x.k]){
                celda='<div style="display:flex;align-items:center">'+celda
                  +_ocListaBtn(x.k, i)+'</div>';
              }
              return '<td>'+celda+'</td>';
            }).join('')
          +'<td style="text-align:right;font-variant-numeric:tabular-nums" '
          +'id="ocTl'+i+'">'
          +_fmtN2((Number(l.cantidad)||0)*(Number(l.precio)||0))+'</td></tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="text-align:right;font-size:13px;font-weight:700;margin-top:8px">'
    +'Total <span id="ocTotalVivo">'+_fmtN2(total)+'</span></div>'
    +'</div>';                       // cierra #ocLineasCaja
  return h+'</div>';
}

// Recalcula los totales al escribir, sin repintar y perder el foco
function _ocTotalesVivos(){
  var d=window._ocDatos; if(!d) return;
  var t=0;
  d.lineas.forEach(function(l,i){
    var x=(Number(l.cantidad)||0)*(Number(l.precio)||0);
    t+=x;
    var e=document.getElementById('ocTl'+i);
    if(e) e.textContent=_fmtN2(x);
  });
  var g=document.getElementById('ocTotalVivo');
  if(g) g.textContent=_fmtN2(t);
}

// ── Pintar y enviar ─────────────────────────────────────────────────────
function _ocPintarTodo(){
  var d=window._ocDatos, c=document.getElementById('ocCuerpo');
  if(!d||!c) return;

  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  _gridRegistrar('ocitems', OC_CAMPOS_ITEM.map(function(x){ return x.k; }),
                 nuevos, _ocRecalcular);
  _gridRegistrar('oclineas', ['cantidad','precio'], d.lineas, _ocRecalcular);

  var faltaProv = !d.cardcode && !(d.provNuevo && String(d.provNuevo.cardname||'').trim());
  var faltaItem = nuevos.some(function(l){
    return !String(l.itemcode||'').trim() || !String(l.itemname||'').trim(); });
  var listo = !faltaProv && !faltaItem && d.lineas.length>0;

  c.innerHTML=
     _ocBloqueProveedor(d)
    +_ocBloqueItems(d)
    +_ocBloqueRPO(d)
    +_ocBloqueFactura(d)
    +_ocBloqueOrden(d)
    +'<div style="display:flex;justify-content:space-between;align-items:center;gap:12px;'
    +'flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:10px;padding:11px 14px">'
    +'<span style="font-size:11.5px;color:var(--text-muted);flex:1;min-width:240px">'
    +'Se crea en este orden: <b style="color:var(--t-lila)">proveedor</b> → '
    +'<b style="color:var(--t-marron)">artículos</b> → <b style="color:var(--t-azul)">orden</b>. '
    +'Todo por DI API. Si algo falla se para ahí y te dice en qué paso.</span>'
    +'<span id="ocFalta" style="font-size:11.5px;color:var(--t-rojo)">'
    + (listo ? '' :
       '<i class="ti ti-alert-triangle"></i> '
       +(faltaProv?'Falta el nombre del proveedor. ':'')
       +(faltaItem?'Faltan códigos o descripciones de artículos.':''))+'</span>'
    +'<button class="btn bp" id="ocBtnCrear" '
    +(listo?'':'disabled style="opacity:.45;cursor:not-allowed"')+' '
    +'onclick="_ocEnviarTodo()"><i class="ti ti-cloud-upload"></i> '
    +'Revisar y crear en SAP</button></div>'
    +'<div id="ocHist" style="margin-top:18px"></div>';

  _ocCargarHistorial();
}

function _ocRecalcular(){
  _ocRevisarListo();
  // Lo editado arriba (artículos) se refleja abajo (orden de compra): las
  // dos tablas trabajan sobre las mismas líneas, pero la de abajo había que
  // repintarla o se quedaba con lo viejo.
  try{ _ocRefrescarLineas(); }catch(e){}
  // Y se guarda el borrador, que es cuando de verdad hay algo que perder
  try{ _ocGuardarBorrador(true); }catch(e){}
  // Al escribir en la rejilla solo cambian los totales y los avisos: no se
  // repinta todo, o se perdería el foco de la celda en la que estás.
  try{
    var d=window._ocDatos;
    var t=d.lineas.reduce(function(a,l){
      return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);
    var e=document.getElementById('ocTotalVivo');
    if(e) e.textContent=_fmtN2(t);
  }catch(e){}
}

// Repinta solo la tabla de la orden de compra, sin tocar donde se escribe
function _ocRefrescarLineas(){
  var caja=document.getElementById('ocLineasCaja');
  if(!caja) return;
  var d=window._ocDatos; if(!d) return;
  clearTimeout(window._ocRefT);
  window._ocRefT=setTimeout(function(){
    try{
      var act=document.activeElement;
      // Si el cursor está en esa misma tabla, no se toca: se repinta al salir
      if(act && act.closest && act.closest('#ocLineasCaja')) return;
      // Se rehace el bloque entero de la orden y se vuelve a quedar solo con
      // su parte interna, que es la que vive dentro de #ocLineasCaja
      var tmp=document.createElement('div');
      tmp.innerHTML=_ocBloqueOrden(d);
      var nuevo=tmp.querySelector('#ocLineasCaja');
      if(nuevo) caja.innerHTML=nuevo.innerHTML;
      _gridRegistrar('oclineas', ['cantidad','precio'], d.lineas, _ocRecalcular);
    }catch(e){}
  }, 250);
}

async function _ocEnviarTodo(){
  var d=window._ocDatos; if(!d) return;
  // Sin foto no se sube: se avisa y no se manda nada
  if(!_ocAvisarSinFoto()) return;
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  var total=d.lineas.reduce(function(a,l){
    return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);

  var resumen='SE VA A CREAR EN SAP\n\n';
  if(d.cardcode) resumen+='Proveedor: '+d.cardcode+' (ya existe)\n';
  else resumen+='Proveedor NUEVO: '+((d.provNuevo&&d.provNuevo.cardname)||'')
    +'\n  el código lo pone SAP, consecutivo\n';
  resumen+='Artículos nuevos: '+nuevos.length+'\n';
  var sinBc=nuevos.filter(function(l){ return !String(l.barcode||'').trim(); }).length;
  if(sinBc) resumen+='  '+sinBc+' sin código de barras\n';
  // Los avisos de barcode van en el último momento: es donde se para a leer
  if(d._bcRepes && d._bcRepes.length){
    resumen+='\n⚠ '+d._bcRepes.length+' código(s) de barras YA los usa otro '
      +'artículo en SAP:\n'
      + d._bcRepes.slice(0,5).map(function(x){
          return '   · '+x.itemcode+' → '+x.barcode+' (lo tiene '+x.de[0]+')'; }).join('\n')
      + (d._bcRepes.length>5 ? ('\n   · … y '+(d._bcRepes.length-5)+' más') : '')
      + '\n   No impide crearlos; decides tú.\n';
  }
  if(d._bcDentro && d._bcDentro.length){
    resumen+='\n⚠ '+d._bcDentro.length+' código(s) de barras repetidos DENTRO de '
      +'esta orden.\n';
  }
  var conFoto=nuevos.filter(function(l){ return !!_ocFotoSrc(l.itemcode); }).length;
  resumen+='  con foto: '+conFoto+' · sin foto: '+(nuevos.length-conFoto)+'\n';
  resumen+='Orden: '+d.lineas.length+' líneas · '+_fmtN2(total)+'\n';
  resumen+='Vendor Ref. No.: '+(d.dkc||'(sin referencia)')+'\n\n¿Sigo?';
  if(!confirm(resumen)) return;

  _ocMsg('Enviando la petición al worker…');
  try{
    // Las fotos van primero: así la petición ya puede decir qué artículos
    // llevan imagen, y el worker se la pone al artículo en SAP. Sin eso el
    // .jpg queda en la carpeta pero el artículo sale sin foto.
    var conFotoSkus=nuevos.map(function(l){ return l.itemcode; })
      .filter(function(sku){ return !!_ocFotoSrc(sku); });
    var rf={hechas:0, fallos:[], ok:{}};
    if(conFotoSkus.length){
      _ocMsg('Subiendo '+conFotoSkus.length+' foto(s) al servidor…');
      try{ rf=await _ocSubirFotos(conFotoSkus); }
      catch(e){ rf.fallos.push(String(e.message||e)); }
    }

    var fila={
      dkc:d.dkc||null, numatcard:d.dkc||null,
      cardcode:d.cardcode||null,
      cardname:d.cardname||(d.provNuevo&&d.provNuevo.cardname)||null,
      proveedor_nuevo: d.cardcode ? null : (d.provNuevo||null),
      items_nuevos: nuevos.map(function(l){
        var o={}, udf={};
        _ocCamposVivos(d).forEach(function(x){
          var v=l[x.k];
          if(v===undefined || String(v).trim()==='') return;
          // Los campos de usuario van aparte, con su TÍTULO: el worker los
          // empareja con los U_ reales de SAP leyendo CUFD. Inventarme los
          // nombres seria poner datos en el campo equivocado.
          if(x.k.indexOf('udf_')===0) udf[x.t]=v;
          // Los de ropa y alfombras van como campo de usuario, buscándolos
          // por el título que tienen en la plantilla de SAP.
          // Los que no tienen campo en SAP no se mandan: quedan en el
          // borrador, y así el worker no avisa de algo que no existe.
          else if(x.sinSap) return;
          // Volumen y peso de pieza son campos normales de SAP (SVolume y
          // SWeight1), no campos de usuario: el worker los pone por su
          // propiedad de la DI API.
          else if(x.k==='vol_pieza'){ o.vol_pieza=v; }
          else if(x.k==='peso_pieza'){ o.peso_pieza=v; }
          else if(x.dept && x.sap) udf[x.sap]=v;
          else o[x.k]=v;
        });
        if(Object.keys(udf).length) o.udf_titulos=udf;
        // Solo si la foto llegó de verdad al servidor: prometerle a SAP una
        // imagen que no está deja el artículo con la foto rota.
        if(rf.ok && rf.ok[l.itemcode]) o.foto=l.itemcode+'.jpg';
        return o;
      }),
      docdate:new Date().toISOString().slice(0,10),
      comments:((d.factura && d.factura.aplicada)
        ? ('Segun factura '+(d.factura.nombre||'')+' · borrador '+(d.desdeNoSap||''))
        : (d.desdeNoSap
           ? ('Desde la orden BORRADOR '+d.desdeNoSap)
           : ('Creada desde el portal · '+(d.archivo||'')))).slice(0,254),
      lineas:d.lineas.map(function(l){
        return {itemcode:l.itemcode, quantity:Number(l.cantidad)||0,
                price:Number(l.precio)||0};
      }),
      total:total, estado:'pendiente', creado_por:(CU&&CU.name)||'',
      // Venta directa: el worker cuelga la orden del pedido del cliente,
      // como hace SAP con el asistente de aprovisionamiento.
      venta_directa:!!_vdDeLaOrden(d.dkc),
      pedido_venta:_vdDeLaOrden(d.dkc)
    };
    // El cuerpo se mide antes de salir: con muchos artículos y sus fotos la
    // petición se iba de tamaño y el navegador la cortaba con «Failed to
    // fetch», sin más explicación.
    var cuerpo=JSON.stringify(fila);
    try{ _dbg('[OC] petición de '+Math.round(cuerpo.length/1024)+' KB'); }catch(e){}
    var _envia=function(){
      return fetch(SB+'/rest/v1/ordenes_compra_queue',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:cuerpo});
    };
    var r;
    try{
      r=await _envia();
    }catch(eRed){
      await new Promise(function(res){ setTimeout(res, 1500); });
      try{
        r=await _envia();
      }catch(eRed2){
        throw new Error('la petición no llegó al servidor · pesa '
          +Math.round(cuerpo.length/1024)+' KB · '+(eRed2.message||eRed2)
          +'. Lo que tienes en pantalla queda guardado como borrador: '
          +'comprueba la conexión y vuelve a darle.');
      }
    }
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      if(t.indexOf('duplicate')>=0 || r.status===409)
        throw new Error('Ya hay una petición viva con la referencia '+(d.dkc||'')+'.');
      // Los errores de PostgREST vienen en crudo y no dicen qué hacer. Estos
      // tres son los que salen de verdad, así que se traducen.
      if(t.indexOf('"cardcode"')>=0 && t.indexOf('not-null')>=0)
        throw new Error('La cola todavía exige el código del proveedor, y este es '
          +'nuevo. Hay que correr ordenes_compra_cardcode.sql en Supabase.');
      if(t.indexOf('proveedor_nuevo')>=0 || t.indexOf('items_nuevos')>=0)
        throw new Error('Faltan columnas en la cola: corre otra vez '
          +'ordenes_compra_queue.sql.');
      if(t.indexOf('proveedor_chk')>=0)
        throw new Error('Falta el proveedor: pon su código o el nombre del nuevo.');
      throw new Error('error '+r.status+' · '+t.slice(0,180));
    }
    _ocMsg('✓ Enviado. El worker crea el proveedor, los artículos y la orden en el '
      +'próximo ciclo.'
      + (conFotoSkus.length
         ? ('  Fotos: '+rf.hechas+' de '+conFotoSkus.length+' subidas como SKU.jpg'
            + (rf.fallos.length ? (' · '+rf.fallos.length+' fallaron: '+rf.fallos[0]) : ''))
         : '  Sin fotos: los artículos se crean igual.')
      +'  El resultado sale abajo.','ok');
    // Y el ganchito, que el mensaje de la pantalla se queda arriba
    try{
      _okGrande('Orden enviada a SAP',
        (d.dkc?('<b>'+_esc(d.dkc)+'</b><br>'):'')
        + nuevos.length+' artículo(s) nuevos · '+d.lineas.length+' línea(s)<br>'
        + (conFotoSkus.length?(rf.hechas+' de '+conFotoSkus.length+' foto(s) subidas<br>'):'')
        +'<span style="font-size:11.5px;color:var(--text-muted)">El worker la crea '
        +'en el próximo ciclo. Abajo verás el estado sin salir de aquí.</span>');
    }catch(e){}
    if(rf.fallos.length) console.error('[fotos] fallos al subir:', rf.fallos);
    window._ocDatos=null;
    setTimeout(rOrdenSap, 1500);
  }catch(e){
    _ocMsg('No se pudo enviar: '+_esc(e.message||e),'err');
  }
}

// ── Los datos del proveedor, sacados de la propia proforma ──────────────
// La PI trae arriba el bloque «Seller:» con nombre, dirección, teléfonos y
// contacto. Teclearlo otra vez a mano no tiene sentido y se presta a erratas.
function _ocProveedorDeProforma(ws, cabFila){
  var txt=[];
  for(var r=1; r<Math.max(2, cabFila); r++){
    for(var c=1;c<=10;c++){
      var v=_profVal(ws,r,c);
      if(v===null||v===undefined) continue;
      v=String(v).trim();
      if(v) txt.push({r:r, t:v});
    }
  }
  // Quitar repetidos: las celdas combinadas devuelven el mismo texto varias veces
  var vistos={}, lineas=[];
  txt.forEach(function(x){
    var k=x.r+'|'+x.t;
    if(vistos[k]) return;
    vistos[k]=1; lineas.push(x);
  });

  // El bloque del vendedor acaba donde empieza cualquiera de estas: el
  // comprador, el título de la proforma o las columnas de uso interno. Sin
  // este corte, la dirección se llevaba por delante «For KENNEDY use only».
  var CORTES=['BUYER','COMPRADOR','PROFORMAINVOICE','FORKENNEDYUSEONLY',
              'DATE','VENDORSPO','DKCNO','INCOTERMS'];
  var iSeller=-1, iBuyer=lineas.length;
  lineas.forEach(function(x,i){
    var n=_bkNorm(x.t);
    if(iSeller<0 && (n.indexOf('SELLER')===0 || n.indexOf('SUPPLIER')===0
                     || n.indexOf('VENDOR')===0)) iSeller=i;
    if(iSeller>=0 && i>iSeller && iBuyer===lineas.length
       && CORTES.some(function(c){ return n.indexOf(c)===0; })) iBuyer=i;
  });
  if(iSeller<0) return null;

  // Lo del vendedor: desde «Seller:» hasta que empieza el bloque del comprador
  var bloque=lineas.slice(iSeller, iBuyer)
    .map(function(x){ return x.t; })
    .filter(function(t){ return !/^(seller|supplier|vendor)\s*:?\s*$/i.test(t); });

  // Primero lo que viene ROTULADO —«Country: China», «Tel: 123»—, que es lo
  // seguro. Casi todas las proformas están en inglés, así que los rótulos se
  // reconocen en los dos idiomas.
  var _r=_ocProvDeLineas(bloque);
  var p=_r.campos, resto=_r.resto;
  if(p.contacto) p.contacto=_ocLimpiaContacto(p.contacto);
  // Lo de antes, para las proformas sin rótulos
  (p.tel1&&p.fax&&p.email ? [] : bloque).forEach(function(t){
    var tel=/TEL[.:\s]*([+\d][\d\s\-()+,]{6,})/i.exec(t);
    var fax=/FAX[.:\s]*([+\d][\d\s\-()+,]{6,})/i.exec(t);
    var mail=/([\w.+-]+@[\w-]+\.[\w.]+)/.exec(t);
    var cont=/CONTACT[O]?[.:\s]*([^,;]{2,40})/i.exec(t);
    if(tel && !p.tel1) p.tel1=tel[1].trim();
    if(fax && !p.fax) p.fax=fax[1].trim();
    if(mail && !p.email) p.email=mail[1].trim();
    if(cont && !p.contacto){
      // El nombre del contacto, limpio: sin el correo entre paréntesis ni el
      // «E-MAIL:» que suelen pegar detrás. SAP guarda ahí un nombre.
      p.contacto=cont[1]
        .replace(/E-?MAIL.*/i,'')
        .replace(/\([^)]*@[^)]*\)/g,'')
        .replace(/[\w.+-]+@[\w-]+\.[\w.]+/g,'')
        .replace(/[\s,;:-]+$/,'')
        .trim();
    }
    if(!tel && !fax && !mail && !cont) resto.push(t);
  });

  // La primera línea que no es un dato suelto es el nombre; las siguientes,
  // la dirección.
  if(resto.length){
    p.cardname=p.cardname
      || resto[0].replace(/^(seller|supplier|vendor)\s*:\s*/i,'').trim();
    var dir=resto.slice(1)
      .filter(function(t){
        // Fuera lo que no es dirección aunque se cuele en el bloque
        var n=_bkNorm(t);
        return n && !CORTES.some(function(c){ return n.indexOf(c)>=0; });
      })
      .join(', ').replace(/,\s*,/g,',').replace(/\s+/g,' ').trim();
    if(dir && !p.calle) p.calle=dir;
    // El país se busca en toda la dirección, no solo al final: «P.R.China»
    // venía pegado a la ciudad y se perdía.
    // El país en código de dos letras: si vino rotulado («Country: China»)
    // se traduce igual, porque SAP lo quiere como CN, no como «China».
    var pais=_ocPaisDe(p.pais || bloque.join(' '));
    if(pais) p.pais=pais;
    else if(p.pais && p.pais.length>2) delete p.pais;
    // La ciudad NO se adivina: sacarla de la dirección daba cosas como
    // «PROFORMA INVOICE». Se deja en blanco para escribirla, que es un campo.
  }
  p.moneda='USD';
  return p.cardname ? p : null;
}

// Poner un valor de golpe en toda la columna. En una orden de cuarenta
// artículos, cambiar el departamento uno a uno no lo hace nadie.
var OC_A_TODOS=[
  {k:'grupo',    t:'Departamento', lista:'grupos', w:'150px'},
  {k:'arancel',  t:'Arancel',      w:'170px', selector:true},
  {k:'marca',    t:'Marca',        w:'160px', selector:true},
  {k:'pais_origen', t:'País de origen', w:'110px'}
];

function _ocAplicarATodos(nuevos){
  return '<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;'
    +'background:var(--surface-0);border:0.5px dashed var(--border);border-radius:9px;'
    +'padding:9px 12px;margin-bottom:10px" id="ocBarraTodos">'
    +'<span style="font-size:11px;color:var(--text-muted);align-self:center">'
    +'<i class="ti ti-arrow-bar-to-down"></i> Poner en los '+nuevos.length+':</span>'
    + OC_A_TODOS.map(function(c){
        var comun=nuevos.length ? nuevos[0][c.k] : '';
        var todosIgual=nuevos.every(function(l){ return (l[c.k]||'')===(comun||''); });
        var val=todosIgual?(comun||''):'';
        return '<label style="font-size:10.5px;color:var(--text-muted)">'+_esc(c.t)+'<br>'
          + (c.lista==='grupos'
             ? ('<select onchange="_ocPonerEnTodos(\'' + c.k + '\',this.value)" '
                +'style="width:'+c.w+';font-size:12px;padding:5px 7px;border:0.5px solid '
                +'var(--border);border-radius:6px;background:var(--surface-2);'
                +'color:var(--text-primary)">'
                +'<option value="">'+(todosIgual?'—':'(varios)')+'</option>'
                + OC_GRUPOS.map(function(o){
                    return '<option value="'+_esc(o)+'"'+(o===val?' selected':'')+'>'
                      +_esc(o)+'</option>'; }).join('')
                +'</select>')
             : ('<input value="'+_esc(val)+'" placeholder="'+(todosIgual?'':'(varios)')+'" '
                +'data-todos="'+c.k+'" '
                +'onchange="_ocPonerEnTodos(\'' + c.k + '\',this.value)" '
                +'style="width:'+c.w+';font-size:12px;padding:5px 8px;border:0.5px solid '
                +'var(--border);border-radius:6px;background:var(--surface-2);'
                +'color:var(--text-primary)">'))
          + (c.selector ? _ocListaBtn(c.k, 'TODOS') : '')
          +'</label>';
      }).join('')
    +'<span style="font-size:10.5px;color:var(--text-muted);flex:1;min-width:180px">'
    +'Se aplica a todas las filas de la tabla. Después puedes cambiar las que '
    +'sean distintas.</span></div>';
}

function _ocPonerEnTodos(campo, valor){
  var d=window._ocDatos; if(!d) return;
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  nuevos.forEach(function(l,i){
    l[campo]=valor;
    var el=document.querySelector('.gc[data-g="ocitems"][data-f="'+i+'"]'
                                  +'[data-c="'+campo+'"]');
    if(el){
      el.value=valor;
      el.style.background='var(--pastel-ok)';
      setTimeout(function(){ el.style.background=''; }, 700);
    }
  });
  showT(valor ? ('Puesto «'+valor+'» en los '+nuevos.length+' artículos')
              : ('Vaciado en los '+nuevos.length+' artículos'));
  try{ _ocRevisarListo(); }catch(e){}
}

// Busca un proveedor por su nombre, tolerando las diferencias de escritura.
// En SAP puede estar como «HANGZHOU EXCO INDUSTRIES LTD» y en la proforma
// venir «Hangzhou EXCO Industries Ltd.», con el punto final: es el mismo y
// hay que reconocerlo, o se acaba creando un duplicado.
function _ocClaveNombre(t){
  return String(t||'').toUpperCase()
    .replace(/[ÁÀÄÂ]/g,'A').replace(/[ÉÈËÊ]/g,'E').replace(/[ÍÌÏÎ]/g,'I')
    .replace(/[ÓÒÖÔ]/g,'O').replace(/[ÚÙÜÛ]/g,'U')
    .replace(/[^A-Z0-9]/g,'');
}

async function _ocBuscarProveedor(nombre){
  var txt=String(nombre||'').trim();
  if(txt.length<4) return null;
  var clave=_ocClaveNombre(txt);
  if(clave.length<4) return null;
  try{
    // Se acota por las primeras letras para no traerse los miles de socios.
    // Se prueban tres longitudes: si la proforma escribe «Hangzhou EXCO» y
    // SAP «HANGZHOU  EXCO», con seis letras ya coinciden.
    var vistos={}, cand=[];
    for(var n=0;n<3;n++){
      var pre=txt.slice(0, [8,6,4][n]).replace(/[%*,()]/g,'');
      if(!pre) continue;
      var r=await fetch(SB+'/rest/v1/proveedores?select=cardcode,cardname'
        +'&cardname=ilike.'+encodeURIComponent(pre+'*')+'&limit=60',{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(x){
        if(vistos[x.cardcode]) return;
        vistos[x.cardcode]=1; cand.push(x);
      });
      if(cand.some(function(x){ return _ocClaveNombre(x.cardname)===clave; })) break;
    }
    var exacto=cand.filter(function(x){ return _ocClaveNombre(x.cardname)===clave; })[0];
    if(exacto) return exacto;
    // Uno contenido en el otro: «EXCO INDUSTRIES» contra «EXCO INDUSTRIES CO LTD»
    var parecido=cand.filter(function(x){
      var k=_ocClaveNombre(x.cardname);
      return k.length>6 && (k.indexOf(clave)===0 || clave.indexOf(k)===0);
    }).sort(function(a,b){
      return Math.abs(_ocClaveNombre(a.cardname).length-clave.length)
           - Math.abs(_ocClaveNombre(b.cardname).length-clave.length);
    })[0];
    return parecido||null;
  }catch(e){
    console.warn('[OC] buscar proveedor:', e);
    return null;
  }
}

// Adjuntar los papeles en el paso NO es pedir el pago. Son dos cosas y se
// parecen: se suben la proforma y la orden, se da por hecho que contabilidad
// ya lo tiene, y en realidad no le ha llegado nada. Pasó con una cancelación
// que nadie vio hasta el día siguiente.
//
// Si hay archivos en el paso pero no existe la solicitud, se dice aquí.
function _solAvisoSinSolicitud(oid, tipo, pasoIdx){
  try{
    if(!CU || (CU.role!=='compras' && CU.role!=='gerencia')) return '';
    var st=(STAGES||[]).filter(function(x){ return x.key==='deposito'; })[0];
    if(!st) return '';
    var k=oid+'deposito_step'+pasoIdx;
    var docs=(window._atts && window._atts[k]) ? window._atts[k].length : 0;
    if(!docs) return '';                    // sin archivos no hay nada que avisar

    // ¿Existe ya la solicitud de este tipo para esta orden?
    var refs=_refsDeOrden(oid).map(String);
    var hay=(window._solPago||[]).some(function(x){
      return String(x.tipo)===tipo && refs.indexOf(String(x.docnum))>=0;
    });
    if(hay) return '';

    var etq = (tipo==='abono') ? 'de depósito' : 'de cancelación';
    return '<div style="background:var(--pastel-error);border:1px solid #E28B8B;'
      +'border-radius:9px;padding:10px 13px;margin:8px 0">'
      +'<div style="font-size:12px;font-weight:700;color:var(--t-rojo);margin-bottom:4px">'
      +'<i class="ti ti-alert-triangle"></i> Los archivos están subidos, pero la '
      +'solicitud '+etq+' NO se ha enviado</div>'
      +'<div style="font-size:11.5px;color:var(--t-rojo);line-height:1.5">'
      +'Contabilidad no ha recibido nada: adjuntar los documentos no les avisa. '
      +'Usa el botón de abajo para enviársela.</div></div>';
  }catch(e){ console.warn('[solicitud] aviso:', e); return ''; }
}

// ── De una orden NO SAP al asistente de SAP ─────────────────────────────
// Es el mismo asistente de siempre —proveedor, artículos, orden— pero en vez
// de leer una proforma, se alimenta de lo que ya está cargado en la orden NO
// SAP. Así no hay que volver a subir el Excel: lo que se revisó al crearla
// vale, y aquí solo se completa lo que SAP pide de más.

// El departamento de la orden es «hogar»; el grupo de artículos de SAP es
// «..Hogar». Se traduce para que el desplegable salga ya puesto.
function _ocGrupoDeDept(dept){
  var d=String(dept||'').toLowerCase();
  var mapa={hogar:'..Hogar', muebles:'..Muebles', ropa:'..Ropa',
            electronica:'..Electronica', alfombras:'..Alfombra',
            alfombra:'..Alfombra', campamento:'..Campamento',
            calzados:'..Calzados', navidad:'..Navidad'};
  if(mapa[d]) return mapa[d];
  // Por si aparece un departamento nuevo: se busca por parecido en la lista
  var n=_bkNorm(d);
  var hallado=(OC_GRUPOS||[]).filter(function(g){
    return _bkNorm(g.replace(/^\.+/,''))===n; })[0];
  return hallado||'';
}

async function _ocDesdeNoSap(ref){
  if(!_ocPuede()){ showT('Esto es de compras y gerencia'); return; }
  ref=String(ref||'').trim();

  // Si ya se estaba preparando ESTA misma orden, se retoma en vez de
  // rehacerla desde cero: era lo que borraba todo lo editado al volver a
  // entrar por el botón «Subir a SAP».
  try{
    var _b=_ocLeerBorrador();
    if(_b && _b.datos && ((_b.datos.lineas)||[]).length
       && String(_b.dkc||'')===ref){
      window._ocDatos=_b.datos;
      window._ocFotos=window._ocFotos||{};
      Object.keys(_b.fotos||{}).forEach(function(k){
        if(!window._ocFotos[k]) window._ocFotos[k]=_b.fotos[k]; });
      go('ordensap');
      setTimeout(function(){
        rOrdenSap();
        showT('Seguimos donde lo dejaste con '+ref+' · '
          +((_b.datos.lineas)||[]).length+' línea(s) · '
          +'si prefieres empezar de cero, pulsa Quitar', 9000);
      }, 60);
      return;
    }
  }catch(e){}
  var p=(window._pendSAP||[]).filter(function(x){
    return String(x.dkc)===ref || String(x.num_orden)===ref; })[0];
  if(!p){ showT('No encuentro la orden '+ref); return; }

  // Las líneas de las órdenes borrador se cargan en segundo plano para no
  // frenar el listado. La primera vez que se pulsa el botón pueden no haber
  // llegado todavía, y antes se salía diciendo que la orden no tenía
  // artículos; a la segunda ya estaban y funcionaba. Aquí se esperan.
  if(!p.__items){
    showT('Cargando las líneas de '+ref+'…');
    try{ await _nsapCargarItemsDe(ref); }catch(e){ console.warn('[OC] líneas:', e); }
    p=(window._pendSAP||[]).filter(function(x){
      return String(x.dkc)===ref || String(x.num_orden)===ref; })[0] || p;
  }

  var items=_pendSAPItems(p).filter(function(it){
    return (it.itemcode||it.itemname) && Number(it.cantidad)>0; });
  if(!items.length){
    showT('La orden '+ref+' no tiene artículos con cantidad. '
      +'Ábrela y comprueba que tenga líneas.', 9000);
    return;
  }

  showT('Preparando la orden '+ref+' para SAP…');
  var grupo=_ocGrupoDeDept(p.dept);

  var d={
    lineas: items.map(function(it){
      var linea={
        itemcode:String(it.itemcode||'').trim(),
        itemname:String(it.itemname||'').trim(),
        cantidad:Number(it.cantidad)||0,
        precio:Number(it.precio_unit)||0,
        desc:String(it.descripcion||'').trim(),
        // Lo que la orden NO SAP ya tiene del artículo, en su sitio
        foreign_name:String(it.descripcion||it.itemname||'').trim(),
        barcode:String(it.barcode||'').trim(),
        marca:String(it.marca||'').trim(),
        grupo:grupo,
        pzs_bulto_compra:it.unidades_x_caja||'',
        pzs_bulto_venta:it.unidades_x_caja||'',
        volumen_compra:it.cbm||'',
        peso_compra:it.peso||'',
        udf_color:String(it.color||'').trim(),
        udf_tamano:String(it.tamano||'').trim(),
        // El material viene en inglés en la proforma. La inglesa se guarda
        // tal cual y la española se traduce.
        udf_comp_ing:String(it.material||'').trim(),
        udf_comp_esp:_traducirComposicion(it.material||''),
        udf_bulto:String(it.carton_size||'').trim(),
        // Los tres que se quedaban por el camino
        empaque_compra:it.empaque||'',
        /* v760: «Cantidad» de la unidad de compra (NumInBuy, «artículos por
           unidad de compra») NO es el número de cartones. Antes se ponía aquí
           «cartones_item» (TTL CTNS / Bultos de la proforma): un artículo
           quedaba, p. ej., con 288 artículos por unidad de compra, y SAP
           multiplicaba por 288 todo lo que se compraba (la factura reserva
           #26003 metió 312 × 288 = 89.856 en el stock). En Kennedy se compra
           por piezas: se deja vacío y SAP pone 1. Las piezas por caja van en
           «Pzs por bulto». */
        cant_compra:'',
        peso_item:it.peso_neto||'',
        // La descripción en inglés es la del Excel, no el nombre en español
        udf_cubicaje:it.cbm||'',
        // La foto que el artículo trae encima. Se quedaba aquí: el asistente
        // la buscaba en el artículo y nunca llegaba, así que los artículos se
        // creaban en SAP sin imagen aunque la orden borrador sí la tuviera.
        _foto:it._foto||it.foto||it.foto_url||'',
        picturname:it.picturname||''
      };
      // Y lo propio del departamento —ropa o alfombras—, que ya se rellenó
      // al crear el borrador. Si no se arrastra, habría que escribirlo dos
      // veces, que es justo lo que se quería evitar.
      _camposDeDept(p.dept).forEach(function(c){
        if(it[c.k]!==undefined && it[c.k]!==null && String(it[c.k]).trim()!=='')
          linea[c.k]=it[c.k];
      });
      return linea;
    }),
    hoja:'orden BORRADOR',
    archivo:'Orden BORRADOR '+ref,
    dkc:ref,
    desdeNoSap:ref,
    cardcode:'', cardname:''
  };

  // Si la orden ya trae el código de SAP del proveedor, se respeta
  var cc=String(p.cardcode||'').trim();
  if(cc && cc.indexOf('TMP-')!==0) d.cardcode=cc;
  if(!d.cardcode && p.proveedor){
    d.provNuevo={cardname:String(p.proveedor).trim(), moneda:'USD'};
  }

  window._ocDatos=d;
  try{ _ocGuardarBorrador(); }catch(e){}
  // Los adjuntos de la orden tienen que estar cargados para poder leerlos
  try{ await cargarDocsOrden(ref); }catch(e){}
  try{ await _ocComprobar(d); }catch(e){ console.warn('[OC] comprobar:', e); }
  // Antes de montar nada: lo que falte se busca en los Excel de la orden
  try{ await _ocCompletarDesdeArchivos(d, ref); }catch(e){ console.warn('[OC] completar:', e); }
  // Y los datos del proveedor: al venir de un borrador solo se tenía el
  // nombre, porque el extractor solo corría al subir una proforma a mano.
  try{ await _ocProveedorDesdeArchivos(d, ref); }catch(e){ console.warn('[OC] proveedor:', e); }
  try{ await _ocReunirFotos(d); }catch(e){ console.warn('[OC] fotos:', e); }
  try{ await _ocRevisarBarcodes(d); }catch(e){ console.warn('[OC] barcodes:', e); }
  go('ordensap');
  rOrdenSap();
}

// El botón, para ponerlo donde haga falta
function _ocBotonSubirNoSap(ref, compacto){
  if(!_ocPuede()) return '';
  var est = compacto
    ? 'font-size:10.5px;font-weight:700;padding:4px 9px;border-radius:7px;margin-top:6px'
    : 'font-size:13px;font-weight:700;padding:9px 18px;border-radius:9px;letter-spacing:.3px';
  return '<button class="btn bp" style="'+est+'" '
    +'title="Revisar y crear en SAP el proveedor, los artículos y la orden" '
    +'onclick="event.stopPropagation();_ocDesdeNoSap(\'' + _esc(String(ref)) + '\')">'
    +'<i class="ti ti-cloud-upload"></i> SUBIR A SAP</button>';
}

// El botón de subir a SAP dentro del detalle de la orden. Estaba solo en el
// panel de pendientes, y a la orden se entra casi siempre desde Buscar
// órdenes, que usa otra pantalla: por eso no salía.
function _ocBarraSubirSap(o){
  try{
    // Deja dicho POR QUÉ no sale, que es lo que costó averiguar las dos
    // veces anteriores. Se ve en la consola con F12.
    if(!o){ _dbg('[subir a SAP] no hay orden'); return ''; }
    if(!o._noSap){
      _dbg('[subir a SAP] la orden '+o.id+' NO está marcada como BORRADOR '
        +'(_noSap='+o._noSap+'): el botón es solo para las que faltan por subir');
      return '';
    }
    if(!_ocPuede()){
      _dbg('[subir a SAP] tu rol es '+((CU&&CU.role)||'?')
        +'; el botón es de compras y gerencia');
      return '';
    }
    _dbg('[subir a SAP] botón dibujado para '+o.id);
    var ref=String(o.id||'');
    return '<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;'
      +'background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:11px;'
      +'padding:11px 14px;margin-bottom:12px">'
      +'<i class="ti ti-cloud-upload" style="font-size:20px;color:var(--t-azul)"></i>'
      +'<div style="flex:1;min-width:200px">'
        +'<div style="font-size:12.5px;font-weight:600;color:var(--t-azul)">'
        +'Esta orden todavía no está en SAP</div>'
        +'<div style="font-size:11px;color:var(--t-azul);opacity:.85">'
        +'Se revisa antes de subir: proveedor, artículos y orden.</div>'
      +'</div>'
      +_ocBotonSubirNoSap(ref)
      +'<button class="xb" style="font-size:12px;padding:8px 13px;margin-left:7px" '
      +'title="Comparar con la orden revisada que devolvió el proveedor" '
      +'onclick="event.stopPropagation();_rpoDesdeBorrador(\''+_esc(ref)+'\')">'
      +'<i class="ti ti-file-diff"></i> Revised PO</button>'
      +'</div>';
  }catch(e){ console.warn('[OC] barra subir:', e); return ''; }
}

// Una orden borrador sin SKU no sirve para nada: no se puede subir a SAP, no
// cruza con el inventario y la reposición no la reconoce. Es mejor pararla
// aquí que dejar que alguien la descubra tres semanas después.
//
// El SKU sale de la PI del proveedor o de la proforma de Kennedy, que es lo
// que se adjunta al crearla.
function _nsapSkusCompletos(items){
  var sin=[];
  (items||[]).forEach(function(it, i){
    if(!String(it.itemcode||'').trim()){
      sin.push({n:i+1, nombre:String(it.itemname||'(sin nombre)').slice(0,42)});
    }
  });
  if(!sin.length) return true;

  var lista=sin.slice(0,8).map(function(x){ return '  · línea '+x.n+': '+x.nombre; }).join('\n');
  alert('Faltan '+sin.length+' SKU\n\n'
    + lista + (sin.length>8 ? ('\n  · … y '+(sin.length-8)+' más') : '')
    + '\n\nSin el código de artículo la orden no se puede subir a SAP ni cruzar '
    + 'con el inventario.\n\nEl SKU viene en la PI del proveedor o en la proforma '
    + 'de Kennedy: complétalos y vuelve a intentarlo.');

  // Se marca en rojo lo que falta, para no tener que buscarlo a mano
  try{
    sin.forEach(function(x){
      var el=document.querySelector('#nsapItems tr:nth-child('+x.n+') input[data-c="itemcode"]')
          || document.querySelectorAll('.nsap-itemcode')[x.n-1];
      if(el){
        el.style.border='1px solid var(--t-rojo)';
        el.style.background='var(--pastel-error)';
      }
    });
  }catch(e){}
  return false;
}

// Lo que se completó desde los adjuntos y lo que sigue vacío. Se dice antes
// de subir, no después: una orden que llega a SAP sin códigos de barras hay
// que corregirla artículo por artículo.
/* ═══════════════════════════════════════════════════════════════════════════
   REVISIÓN ANTES DE CREAR EN SAP
   ───────────────────────────────────────────────────────────────────────────
   Lo que conviene saber antes de pulsar el botón: qué artículos son nuevos y
   si algún código de barras ya lo está usando otro artículo.
   Un barcode repetido no impide crear nada —a veces es a propósito, cuando
   son variantes del mismo producto— así que se avisa y decide la persona.
   ═══════════════════════════════════════════════════════════════════════════ */

// Busca en el inventario quién usa cada código de barras
async function _ocRevisarBarcodes(d){
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  var conBc=nuevos.filter(function(l){ return String(l.barcode||'').trim(); });
  d._bcRepes=[]; d._bcDentro=[];
  if(!conBc.length) return d._bcRepes;

  // Repetidos dentro de la propia orden: dos líneas con el mismo barcode
  var vistos={};
  conBc.forEach(function(l){
    var b=String(l.barcode).trim();
    (vistos[b]=vistos[b]||[]).push(l.itemcode);
  });
  Object.keys(vistos).forEach(function(b){
    if(vistos[b].length>1) d._bcDentro.push({barcode:b, skus:vistos[b]});
  });

  // Y contra lo que ya hay en SAP
  var codigos=conBc.map(function(l){ return String(l.barcode).trim(); });
  var mapa={};
  for(var i=0;i<codigos.length;i+=60){
    var lote=codigos.slice(i,i+60)
      .map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
    try{
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,codebars'
        +'&codebars=in.('+encodeURIComponent(lote)+')&limit=500',{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(x){
        var b=String(x.codebars||'').trim();
        if(b) (mapa[b]=mapa[b]||[]).push(x);
      });
    }catch(e){ console.warn('[OC] barcodes:', e); }
  }

  conBc.forEach(function(l){
    var b=String(l.barcode).trim();
    var duenos=(mapa[b]||[]).filter(function(x){
      return _ocNormSku(x.itemcode)!==_ocNormSku(l.itemcode);
    });
    if(duenos.length){
      d._bcRepes.push({itemcode:l.itemcode, barcode:b,
                       de:duenos.slice(0,3).map(function(x){
                         return x.itemcode+' ('+String(x.itemname||'').slice(0,26)+')'; })});
    }
  });
  _dbg('[OC] barcodes: '+d._bcRepes.length+' repetido(s) en SAP · '
    +d._bcDentro.length+' repetido(s) dentro de la orden');
  return d._bcRepes;
}

// El aviso en pantalla, encima de la tabla de artículos
function _ocAvisoRevision(d){
  var nuevos=d.lineas.filter(function(l){ return !l.enSap; });
  var h='';
  if(!nuevos.length) return h;

  var sinBc=nuevos.filter(function(l){ return !String(l.barcode||'').trim(); }).length;

  h+='<div class="nota" style="background:var(--pastel-azul);color:var(--t-azul)">'
    +'<i class="ti ti-sparkles"></i> <b>'+nuevos.length+' artículo(s) nuevos</b> '
    +'se van a crear en SAP'
    +(sinBc?(' · '+sinBc+' sin código de barras'):'')+'.</div>';

  if(d._bcDentro && d._bcDentro.length){
    h+='<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron)">'
      +'<i class="ti ti-barcode"></i> <b>Mismo código de barras en varias líneas '
      +'de esta orden:</b><br>'
      + d._bcDentro.slice(0,6).map(function(x){
          return '· '+_esc(x.barcode)+' → '+_esc(x.skus.join(', ')); }).join('<br>')
      +'<br><span style="font-size:11px">Si son variantes del mismo producto puede '
      +'estar bien. No impide crearlos.</span></div>';
  }

  if(d._bcRepes && d._bcRepes.length){
    h+='<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron)">'
      +'<i class="ti ti-barcode-off"></i> <b>'+d._bcRepes.length+' código(s) de barras '
      +'ya los usa otro artículo en SAP:</b><br>'
      + d._bcRepes.slice(0,8).map(function(x){
          return '· <b>'+_esc(x.itemcode)+'</b> con '+_esc(x.barcode)
            +' — ya lo tiene '+_esc(x.de.join(', ')); }).join('<br>')
      + (d._bcRepes.length>8?('<br>· … y '+(d._bcRepes.length-8)+' más'):'')
      +'<br><span style="font-size:11px">No impide crear nada: decides tú. Si es un '
      +'error, cámbialo en la columna del código de barras antes de subir.</span></div>';
  }
  return h;
}

function _ocAvisoHuecos(d){
  var h='';
  try{
    if(d._completados){
      h+='<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde)">'
        +'<i class="ti ti-wand"></i> Se completaron <b>'+d._completados.n+'</b> dato(s) '
        +'que faltaban, leyéndolos de '+_esc(d._completados.de)+'.</div>';
    }
    var hu=_ocHuecos(d);
    if(hu.total){
      var nombres={barcode:'código de barras', mfr_catalog:'catálogo de fabricante',
        foreign_name:'descripción en inglés', itemname:'descripción',
        udf_comp_ing:'composición', udf_color:'color', udf_tamano:'tamaño',
        udf_bulto:'tamaño del bulto', pzs_bulto_compra:'piezas por bulto',
        volumen_compra:'volumen', precio:'precio'};
      var lista=Object.keys(hu.porCampo)
        .sort(function(a,b){ return hu.porCampo[b]-hu.porCampo[a]; })
        .map(function(k){ return (nombres[k]||k)+' ('+hu.porCampo[k]+')'; });
      h+='<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron)">'
        +'<i class="ti ti-alert-triangle"></i> Sigue faltando: '+_esc(lista.join(' · '))
        +'.<br><span style="font-size:11px">No impide crear la orden, pero esos campos '
        +'quedarán vacíos en SAP. Puedes pegarlos en la tabla o traerlos de otro Excel.'
        +'</span></div>';
    }
  }catch(e){ console.warn('[OC] aviso huecos:', e); }
  return h;
}

// ── ¿Subieron las fotos? ────────────────────────────────────────────────
// El worker las baja del bucket a la carpeta de red y marca la fila. Aquí se
// enseña ese estado: antes solo salía un aviso al momento de subirlas y, si
// te ibas de la pantalla, no había forma de saberlo.
async function _ocPanelFotos(){
  try{
    // select=* a propósito: esta tabla no tiene las mismas columnas en todas
    // las instalaciones y pedir una que falta tumba la consulta entera.
    var r=await fetch(SB+'/rest/v1/fotos_queue?select=*&order=id.desc&limit=40',
      {headers:Object.assign({},SBH,{'Cache-Control':'no-cache'}), cache:'no-store'});
    if(!r.ok) return '';
    var filas=await r.json()||[];
    if(!filas.length) return '';

    var cuenta={pendiente:0, ok:0, error:0};
    filas.forEach(function(f){
      var e=String(f.estado||'pendiente');
      if(e==='ok'||e==='hecha'||e==='procesada') cuenta.ok++;
      else if(e==='error') cuenta.error++;
      else cuenta.pendiente++;
    });

    var malas=filas.filter(function(f){ return String(f.estado)==='error'; });
    var col = cuenta.error ? ['var(--pastel-error)','var(--t-rojo)']
            : (cuenta.pendiente ? ['var(--pastel-aviso)','var(--t-marron)']
                                : ['var(--pastel-ok)','var(--t-verde)']);

    return '<div style="background:'+col[0]+';border-radius:9px;padding:10px 13px;'
      +'margin-bottom:14px">'
      +'<div style="font-size:12px;font-weight:700;color:'+col[1]+';margin-bottom:3px">'
      +'<i class="ti ti-photo"></i> Fotos al servidor · últimas '+filas.length+'</div>'
      +'<div style="font-size:11.5px;color:'+col[1]+'">'
      + cuenta.ok+' guardadas en la carpeta · '
      + cuenta.pendiente+' esperando al worker · '
      + cuenta.error+' con error'
      + (cuenta.pendiente
         ? '<br><span style="font-size:10.5px">Las pendientes se bajan en el próximo '
           +'ciclo del worker. Si se quedan así, el worker no está corriendo.</span>'
         : '')
      + (malas.length
         ? ('<br><span style="font-size:10.5px">Fallaron: '
            + _esc(malas.slice(0,4).map(function(f){
                return (f.itemcode||f.nombre_orig||f.archivo); }).join(', '))
            + (malas.length>4?(' y '+(malas.length-4)+' más'):'')
            + ' · <span style="cursor:pointer;text-decoration:underline" '
            + 'onclick="_ocVerFallosFoto()">ver por qué</span></span>')
         : '')
      +'</div></div>';
  }catch(e){
    console.warn('[fotos] panel:', e);
    return '';
  }
}

// Saca los datos del proveedor de los Excel que cuelgan de la orden. Solo
// rellena lo que esté vacío: si alguien ya escribió la dirección a mano, no
// se le pisa.
async function _ocProveedorDesdeArchivos(d, ref){
  if(d.cardcode) return 0;                 // ya existe en SAP: no hace falta
  var archivos=_ocExcelDeOrden(ref);
  if(!archivos.length) return 0;

  var puestos=0;
  for(var i=0;i<archivos.length;i++){
    try{
      var r=await fetch(archivos[i].src);
      if(!r.ok) continue;
      var ExcelJSlib=await _bkExcelJS();
      var wb=new ExcelJSlib.Workbook();
      await wb.xlsx.load(await r.arrayBuffer());

      var det=_profDetectar(wb, ['itemcode']);
      if(!det) continue;
      var p=_ocProveedorDeProforma(det.ws, det.cab);
      if(!p) continue;

      d.provNuevo=d.provNuevo||{};
      Object.keys(p).forEach(function(k){
        if(String(d.provNuevo[k]||'').trim()==='') {
          d.provNuevo[k]=p[k];
          puestos++;
        }
      });
      if(puestos) _dbg('[OC] proveedor: '+puestos+' dato(s) de '+archivos[i].nombre);
      if(d.provNuevo.calle && d.provNuevo.pais) break;   // ya hay bastante
    }catch(e){ console.warn('[OC] proveedor desde '+archivos[i].nombre+':', e); }
  }
  return puestos;
}

// Las líneas de UNA orden borrador, ya. El cargador general va por tandas y
// en segundo plano; esto pide solo la que hace falta y espera.
async function _nsapCargarItemsDe(ref){
  var o=(window._pendSAP||[]).filter(function(x){
    return String(x.dkc)===String(ref) || String(x.num_orden)===String(ref); })[0];
  if(!o) return 0;
  if(o.__items) return 1;
  try{
    var r=await fetch(SB+'/rest/v1/compras_pend_sap?select=dkc,items&dkc=eq.'
      +encodeURIComponent(String(o.dkc))+'&limit=1', {headers:SBH});
    if(!r.ok){ _dbg('[BORRADOR] líneas de '+ref+': estado '+r.status); return 0; }
    var f=(await r.json()||[])[0];
    if(!f) return 0;
    o.items=f.items||[];
    o.__items=1;
    _dbg('[BORRADOR] líneas de '+ref+' cargadas: '+_pendSAPItems(o).length);
    return 1;
  }catch(e){
    console.warn('[BORRADOR] líneas de '+ref+':', e);
    return 0;
  }
}

// ── Mensajes de depuración ──────────────────────────────────────────────
// El portal escribía en la consola cada paso de cada proceso. Para trabajar
// estorba: los avisos de verdad se pierden entre decenas de líneas normales.
//
// Ahora esos mensajes solo salen si se piden. Para verlos, en la consola:
//     _verLog(true)     · y para volver a callarlos: _verLog(false)
// Queda guardado, así que aguanta al recargar la página.
function _dbg(){
  if(!window._verLogOn) return;
  try{ console.log.apply(console, arguments); }catch(e){}
}

function _verLog(on){
  window._verLogOn = (on!==false);
  try{ localStorage.setItem('kcc_verlog', window._verLogOn?'1':'0'); }catch(e){}
  console.log(window._verLogOn
    ? 'Mensajes de depuración ENCENDIDOS. Para apagarlos: _verLog(false)'
    : 'Mensajes de depuración apagados.');
  return window._verLogOn;
}

try{ window._verLogOn = (localStorage.getItem('kcc_verlog')==='1'); }catch(e){}

// El detalle de una petición, solo cuando se pide. Antes salía entero debajo
// de cada fila: con veinte peticiones la pantalla era un muro de texto y no
// se distinguía lo importante de lo normal.
async function _ocVerDetalle(id){
  try{
    var r=await fetch(SB+'/rest/v1/ordenes_compra_queue?select=*&id=eq.'+Number(id)+'&limit=1',
      {headers:SBH});
    var f=(await r.json()||[])[0];
    if(!f){ showT('No encuentro esa petición'); return; }

    // Los avisos vienen separados por « | »: se leen mucho mejor en líneas
    var msg=String(f.error_msg||'(sin detalle)')
      .replace(/^Avisos:\s*/,'')
      .split(' | ').map(function(x){ return '· '+x.trim(); }).join('\n');

    alert(
      (f.estado==='error' ? 'FALLÓ' : 'AVISOS') + ' · ' + (f.dkc||'') + '\n'
      + (f.cardcode ? ('Proveedor: '+f.cardcode+' '+(f.cardname||'')+'\n') : '')
      + (f.docnum_sap ? ('Orden en SAP: #'+f.docnum_sap+'\n') : '')
      + '\n' + msg);
  }catch(e){
    showT('No pude leer el detalle: '+(e.message||e));
  }
}

// Por qué fallaron las fotos, cuando se pide
async function _ocVerFallosFoto(){
  try{
    var r=await fetch(SB+'/rest/v1/fotos_queue?select=*&estado=eq.error'
      +'&order=id.desc&limit=25',{headers:SBH});
    var filas=await r.json()||[];
    if(!filas.length){ showT('Ninguna foto con error'); return; }
    alert('FOTOS QUE NO SE GUARDARON ('+filas.length+')\n\n'
      + filas.map(function(f){
          return '· '+(f.itemcode||f.nombre_orig||f.archivo)+'\n   '
            +String(f.error_msg||'(sin motivo)').slice(0,150);
        }).join('\n'));
  }catch(e){ showT('No pude leer los errores: '+(e.message||e)); }
}


// Rellena desde los Excel adjuntos todo lo que la IA no sacó. Es la misma
// idea que al subir a SAP, pero aquí: mientras más se complete al crear el
// borrador, menos queda por hacer después.
var NSAP_DESDE_HOJA=[
  ['barcode','barcode'], ['marca','marca'], ['color','color'],
  ['material','comp'],   ['tamano','size'], ['carton_size','carton'],
  ['unidades_x_caja','qtyCtn'], ['cartones_item','ctns'],
  ['cbm','cbm'],         ['peso','peso_bruto'], ['peso_neto','peso_neto'],
  ['descripcion','ing'], ['itemname','esp'],   ['precio_unit','precio']
];

async function _nsapCompletarDesdeHoja(file, lista){
  try{
    var ExcelJSlib=await _bkExcelJS();
    var wb=new ExcelJSlib.Workbook();
    await wb.xlsx.load(await file.arrayBuffer());
    var d=_profDetectar(wb, ['itemcode']);
    if(!d){ _dbg('[kcc] ese archivo no tiene tabla de artículos'); return 0; }

    var fichas={}, vacias=0;
    for(var r=d.cab+1; r<=d.ws.rowCount; r++){
      var code=String(_profVal(d.ws,r,d.col.itemcode)).trim();
      if(/^TOTAL/i.test(_bkNorm(code))) break;
      // Una fila vacía no termina la tabla: hay proformas con una línea en
      // blanco entre grupos de artículos. Se paran tras tres seguidas.
      if(!code){ vacias++; if(vacias>=3) break; continue; }
      vacias=0;
      if(_profEsCabecera(code)) continue;
      var f={};
      Object.keys(d.col).forEach(function(k){
        var v=_profVal(d.ws,r,d.col[k]);
        if(v!==null && v!==undefined && String(v).trim()!=='') f[k]=v;
      });
      f.itemcode=code;
      fichas[_ocNormSku(code)]=f;
    }

    // Hay datos que están en la CABECERA, no en una columna: el país de
    // origen, los incoterms, la marca. Valen para todas las líneas.
    var cab=_nsapDatosDeCabecera(d.ws, d.cab);

    var puestos=0;
    var items=lista||window._nsapItems||[];
    items.forEach(function(it){
      var f=fichas[_ocNormSku(it.itemcode)];
      if(!f) return;
      NSAP_DESDE_HOJA.forEach(function(par){
        if(String(it[par[0]]||'').trim()!=='') return;   // no se pisa lo que ya hay
        if(f[par[1]]===undefined) return;
        var v=f[par[1]];
        // La composición llega en inglés: se traduce al pasarla al campo
        // español, y se deja tal cual en el inglés.
        if(par[0]==='udf_comp_esp') v=_traducirComposicion(v);
        // Las proformas dan el cubicaje en metros cúbicos y aquí se trabaja
        // en pies cúbicos, que es como lo pide el flete. 1 m³ = 35,3147 ft³.
        if(par[0]==='cbm' && Number(v)) v=Math.round(Number(v)*35.3147*10000)/10000;
        it[par[0]]=v;
        puestos++;
      });
      // Y lo de la cabecera, igual: solo donde falte
      Object.keys(cab).forEach(function(k){
        if(String(it[k]||'').trim()==='' && cab[k]){ it[k]=cab[k]; puestos++; }
      });
    });
    if(puestos){
      _dbg('[kcc] completados '+puestos+' dato(s) desde '+file.name);
      try{ _nsapRenderItems(); }catch(e){}
    }
    return puestos;
  }catch(e){
    console.warn('[kcc] completar desde la hoja:', e);
    return 0;
  }
}

// Los campos de la tabla de artículos en la pantalla de SAP: los de siempre
// más los del departamento de la orden.
function _ocCamposVivos(d){
  try{
    var dept=(d && d.dept) || '';
    if(!dept && d && d.lineas && d.lineas.length){
      // Se deduce del grupo del artículo: «..Alfombra» → alfombras
      dept=String((d.lineas[0]||{}).grupo||'').replace(/^\.+/,'');
    }
    var extra=_camposDeDept(dept);
    if(!extra.length) return OC_CAMPOS_ITEM;
    // Se marcan como del departamento para poder mandarlas como UDF
    return OC_CAMPOS_ITEM.concat(extra.map(function(c){
      return {k:c.k, t:c.t, w:c.w, lista:c.lista, sap:c.sap, dept:true};
    }));
  }catch(e){
    console.warn('[OC] campos del departamento:', e);
    return OC_CAMPOS_ITEM;
  }
}

// Lo que vive en la cabecera de la proforma y vale para toda la orden.
// «Country of Origin: CHINA» está arriba del todo, no en una columna, así
// que la lectura por columnas no lo veía nunca.
var NSAP_CABECERA=[
  ['pais_origen', /^(COUNTRY\s*OF\s*ORIGIN|PA[IÍ]S\s*DE\s*ORIGEN)/i],
  ['incoterms',   /^(INCOTERMS?)/i],
  ['marca',       /^(BRAND|MARCA)(\s*,?\s*LABELLING)?/i],
  ['puerto',      /^(PORT\s*OF\s*LOADING|PUERTO\s*DE\s*(CARGA|EMBARQUE))/i]
];

function _nsapDatosDeCabecera(ws, filaCab){
  var out={};
  try{
    var hasta=Math.max(1,(filaCab||14)-1);
    for(var r=1;r<=hasta;r++){
      for(var c=1;c<=20;c++){
        var t='';
        try{ t=String(_profVal(ws,r,c)||'').trim(); }catch(e){ continue; }
        if(!t || t.length>40) continue;
        NSAP_CABECERA.forEach(function(par){
          if(out[par[0]] || !par[1].test(t)) return;
          // El valor está en alguna de las celdas de la derecha
          for(var k=c+1;k<=c+5;k++){
            var v='';
            try{ v=String(_profVal(ws,r,k)||'').trim(); }catch(e){ continue; }
            if(v && v!==t && !par[1].test(v)){ out[par[0]]=v; break; }
          }
        });
      }
    }
    if(Object.keys(out).length) _dbg('[kcc] de la cabecera:', out);
  }catch(e){ console.warn('[kcc] cabecera:', e); }
  return out;
}

// La miniatura del artículo. Tres casos, en este orden:
//   1. la foto de SAP, que es la buena y la que ve el resto del portal
//   2. si esa no carga, la del Excel adjunto
//   3. si tampoco hay, un hueco que lo dice
function _nsapCeldaFoto(it, i){
  var hueco=function(txt, color){
    return '<span title="'+_esc(txt)+'" style="width:32px;height:32px;'
      +'border-radius:5px;border:0.5px dashed '+color+';display:flex;'
      +'align-items:center;justify-content:center;color:'+color+'">'
      +'<i class="ti ti-photo-off" style="font-size:12px"></i></span>';
  };
  if(!it._foto) return hueco('Sin foto en el Excel','var(--border)');

  var alFallar;
  if(it._fotoExcel){
    // Se cambia por la del Excel. onerror=null antes, o si esa también
    // falla se entra en bucle.
    alFallar='this.onerror=null;this.src=&quot;'
      + _esc(it._fotoExcel).replace(/"/g,'&quot;') + '&quot;';
  } else {
    alFallar='this.onerror=null;this.replaceWith('
      +'Object.assign(document.createElement(&quot;span&quot;),'
      +'{title:&quot;La foto no se pudo cargar&quot;,'
      +'textContent:&quot;·&quot;}))';
  }
  return '<img src="'+_esc(it._foto)+'" class="nsap-foto-mini" '
    +'onclick="_nsapVerFoto('+i+')" title="Pulsa para verla grande" '+'onmouseenter="_fotoLupa(this)" onmouseleave="_fotoLupaFuera()" '
    +'onerror="'+alFallar+'">';
}

/* ═══════════════════════════════════════════════════════════════════════════
   FACTURA RESERVA
   ───────────────────────────────────────────────────────────────────────────
   Lo mismo que «Pasar a factura reserva» desde una orden en SAP, pero
   pudiendo elegir qué se factura: rara vez viene todo en un contenedor.

   Se parte de un DKC —el Vendor Ref. No.— y se traen sus líneas. Si la
   factura lleva artículos de otras órdenes, se añaden desde aquí: cada
   línea recuerda de qué orden viene, que es lo que SAP necesita para
   enlazarlas.
   ═══════════════════════════════════════════════════════════════════════════ */

window._fr = window._fr || null;

// ── Los nombres reales de las columnas ──────────────────────────────────
// Esta tabla mezcla estilos: «docnum» va junto y «doc_status» con guion
// bajo. Adivinarlos ha costado varias vueltas, así que se leen una vez de
// la propia base y se recuerdan.
window._frCols = window._frCols || null;

async function _frColumnas(){
  if(window._frCols) return window._frCols;
  var mapa={};
  try{
    var r=await fetch(SB+'/rest/v1/opor_ordenes?select=*&limit=1',{headers:SBH});
    if(!r.ok) throw new Error('estado '+r.status);
    var fila=(await r.json()||[])[0];
    if(!fila) throw new Error('la tabla está vacía');

    var claves=Object.keys(fila);
    // Para cada dato que necesito, el nombre que exista de verdad
    // Los nombres REALES de esta tabla, sacados de cómo la lee el resto del
    // portal: la referencia del proveedor es «num_proveedor», y el proveedor
    // va en «vendor_code» y «vendor_name». Adivinarlos costó varias vueltas.
    var quiero={
      docentry:['docentry','doc_entry'],
      docnum:['docnum','doc_num'],
      numatcard:['num_proveedor','numatcard','num_at_card','vendor_ref'],
      cardcode:['vendor_code','cardcode','card_code'],
      cardname:['vendor_name','cardname','card_name'],
      doctotal:['total','doctotal','doc_total'],
      docdate:['docdate','doc_date','fecha'],
      docstatus:['doc_status','docstatus','estado']
    };
    Object.keys(quiero).forEach(function(k){
      for(var i=0;i<quiero[k].length;i++){
        if(claves.indexOf(quiero[k][i])>=0){ mapa[k]=quiero[k][i]; return; }
      }
      // Último recurso: una que se le parezca sin guiones
      var n=k.replace(/_/g,'');
      var hallada=claves.filter(function(c){ return c.replace(/_/g,'')===n; })[0];
      if(hallada) mapa[k]=hallada;
    });
    window._frCols=mapa;
    _dbg('[FR] columnas de opor_ordenes:', mapa);
  }catch(e){
    console.warn('[FR] no pude leer las columnas:', e);
    window._frCols={docentry:'docentry', docnum:'docnum', numatcard:'numatcard',
                    cardcode:'cardcode', cardname:'cardname', doctotal:'doctotal',
                    docdate:'docdate', docstatus:'docstatus'};
  }
  return window._frCols;
}

// Lee un dato de una fila sea cual sea el nombre que tenga la columna
function _frVal(fila, dato){
  var c=window._frCols||{};
  if(c[dato] && fila[c[dato]]!==undefined) return fila[c[dato]];
  return fila[dato];
}

function _frPuede(){
  // Contabilidad también: paga contra la factura reserva, así que necesita
  // verla y ver su entrada de mercancía. Crearlas sigue siendo de compras.
  return !!(CU && (_esCompras() || CU.role==='gerencia'
                   || CU.role==='importacion' || CU.role==='contabilidad'));
}

// Crear o cancelar facturas sigue siendo de quien lo hacía antes
function _frPuedeCrear(){
  return !!(CU && (_esCompras() || CU.role==='gerencia' || CU.role==='importacion'));
}

async function _frAbrir(dkcInicial){
  if(!_frPuedeCrear()){ showT('Crear facturas reserva es de compras, importación y gerencia'); return; }
  window._fr={dkc:String(dkcInicial||'').trim(), lineas:[], ordenes:[],
              cardcode:'', cardname:'', numatcard:'', num_factura:'',
              docdate:_hoyISO(), docduedate:'', udf:{}};
  window._fip=null;
  go('factreserva');
  rFactReserva();
  if(dkcInicial) await _frBuscar(String(dkcInicial).trim());
}

// Busca la orden. Primero entre las que el portal ya tiene cargadas —son
// las mismas que salen en «Buscar órdenes»—, y solo si no está se pregunta
// a la base. Así lo que se ve en una pantalla se encuentra en la otra.
async function _frBuscar(texto, anadir){
  var q=String(texto||'').trim();
  var d=window._fr; if(!d) return;
  d.dkc=q;                       // se recuerda, o al repintar se borra
  if(!q){ _frMsg('Escribe el DKC o el número de la orden','err'); return; }
  _frMsg('Buscando «'+_esc(q)+'»…');

  try{
    var qn=_bkNorm(q);
    var enMemoria=(typeof orders!=='undefined' && orders ? orders : [])
      .filter(function(o){
        if(o._noSap) return false;                 // las borrador no valen
        return _bkNorm(o.id)===qn
            || _bkNorm(o.num_proveedor||'')===qn
            || (qn.length>3 && _bkNorm(o.num_proveedor||'').indexOf(qn)>=0);
      });
    _dbg('[FR] en memoria: '+enMemoria.length+' orden(es) para «'+q+'»');

    if(enMemoria.length>1 && !anadir){ _frElegirOrden(enMemoria); return; }
    if(enMemoria.length){
      var antes=d.lineas.length, sumadas=0;
      for(var k=0;k<enMemoria.length;k++){
        sumadas += (await _frCargarLineas(enMemoria[k], anadir)) || 0;
      }
      if(anadir && !sumadas && d.lineas.length===antes){
        // Sin esto el botón parecía no hacer nada
        _frMsg('No se añadió ninguna línea de «'+_esc(q)+'». '
          +'O ya estaban en la lista, o esa orden no tiene nada pendiente, '
          +'o es de otro proveedor.','err');
      }
      rFactReserva();
      return;
    }

    // No está cargada: se pregunta a la base con los nombres reales
    var C=await _frColumnas();
    var ords=[], vistos={};
    var sumar=function(lista){
      (lista||[]).forEach(function(o){
        var dn=_frVal(o,'docnum');
        if(o && dn!=null && !vistos[dn]){ vistos[dn]=1; ords.push(_frDesdeFila(o)); }
      });
    };
    var pedir=async function(filtro){
      try{
        var r=await fetch(SB+'/rest/v1/opor_ordenes?select=*&'+filtro+'&limit=25',
          {headers:SBH});
        if(!r.ok){
          var t=''; try{ t=await r.text(); }catch(e){}
          _dbg('[FR] búsqueda ('+filtro+'): '+r.status+' '+t.slice(0,140));
          return [];
        }
        return await r.json()||[];
      }catch(e){ _dbg('[FR] búsqueda:', e); return []; }
    };
    if(/^\d+$/.test(q) && C.docnum) sumar(await pedir(C.docnum+'=eq.'+encodeURIComponent(q)));
    if(!ords.length && C.numatcard)
      sumar(await pedir(C.numatcard+'=ilike.*'+encodeURIComponent(q).replace(/%/g,'')+'*'));
    if(!ords.length && C.docnum)
      sumar(await pedir(C.docnum+'=ilike.*'+encodeURIComponent(q).replace(/%/g,'')+'*'));

    if(!ords.length){
      _frMsg('No encuentro ninguna orden con «'+_esc(q)+'».<br>'
        +'<span style="font-size:11px">Búscala primero en <b>Buscar órdenes</b>: '
        +'si tampoco sale ahí, el portal no la tiene sincronizada.</span>','err');
      return;
    }
    if(ords.length>1 && !anadir){ _frElegirOrden(ords); return; }
    for(var z=0;z<ords.length;z++) await _frCargarLineas(ords[z], anadir);
    rFactReserva();
  }catch(e){
    _frMsg('No pude buscar: '+_esc(e.message||e),'err');
    console.warn('[FR] buscar:', e);
  }
}

// Una fila de la base, con la misma forma que las órdenes en memoria
function _frDesdeFila(o){
  return {id:String(_frVal(o,'docnum')||''), num_proveedor:_frVal(o,'numatcard')||'',
          prov:_frVal(o,'cardname')||'', resp:_frVal(o,'cardcode')||'',
          valor:Number(_frVal(o,'doctotal'))||0, fechaCreacion:_frVal(o,'docdate')||''};
}

function _frElegirOrden(ords){
  /* v754: la lista recibe las órdenes que tiene el portal en memoria (las de
     «Buscar órdenes»), que se llaman id / num_proveedor / prov / valor /
     fechaCreacion, y no docnum / numatcard / cardname / doctotal / docdate
     como las de la base. Por eso salía «# · · 0,00» y al pulsar no hacía
     nada. Ahora vale para las dos formas. */
  var h=ords.map(function(o){
    var num=o.id||o.docnum||'';
    var ref=o.num_proveedor||o.numatcard||'';
    var prov=o.prov||o.cardname||o.resp||o.cardcode||'';
    var tot=(o.valor!=null?o.valor:o.doctotal)||0;
    var fe=o.fechaCreacion||(o.docdate?_fechaCorta(o.docdate):'');
    var abierta=String(o._docstatus||o.doc_status||'O').toUpperCase()!=='C';
    return '<div onclick="_frTomarOrden(\''+_esc(String(num))+'\')" style="padding:9px 12px;'
      +'border-bottom:0.5px solid var(--border);cursor:pointer;font-size:12.5px;display:flex;gap:8px;align-items:center" '
      +'onmouseover="this.style.background=\'var(--bg-accent)\'" '
      +'onmouseout="this.style.background=\'\'">'
      +'<b style="color:var(--t-azul)">#'+_esc(num)+'</b>'
      +'<span>'+_esc(ref)+'</span>'
      +'<span style="flex:1;color:var(--text-secondary)">'+_esc(prov)+'</span>'
      +'<b>'+_fmtN2(tot)+'</b>'
      +'<span style="color:var(--text-muted);font-size:11px">'+_esc(fe)+'</span>'
      +(abierta?'':'<span style="font-size:10px;padding:1px 6px;border-radius:5px;background:var(--surface-1);color:var(--text-muted)">cerrada</span>')
      +'</div>';
  }).join('');
  window._frOpciones=ords;          // para encontrarla al pulsar, venga de donde venga
  _frModal('Hay varias órdenes con esa referencia: elige cuál', h);
}

async function _frTomarOrden(docnum){
  _frCerrarModal();
  var d=window._fr; if(!d) return;
  var o=(window._frOpciones||[]).filter(function(x){ return String(x.id||x.docnum)===String(docnum); })[0]
       || (typeof orders!=='undefined' && orders ? orders : [])
            .filter(function(x){ return String(x.id)===String(docnum); })[0];
  if(!o){ _frMsg('No encuentro la orden #'+_esc(docnum),'err'); return; }
  await _frCargarLineas(o, true);
  rFactReserva();
}

// Trae las líneas de una orden y las añade a la factura
async function _frCargarLineas(orden, anadir){
  var d=window._fr; if(!d) return 0;
  if(!anadir){ d.lineas=[]; d.ordenes=[]; }

  var docnum=String(orden.id||orden.docnum||'').trim();
  var cc=String(orden.resp||'').trim();
  var nombre=String(orden.prov||'').trim();

  // Un mismo proveedor para toda la factura: SAP no admite mezclar
  if(d.cardcode && cc && d.cardcode!==cc){
    _frMsg('La orden #'+_esc(docnum)+' es del proveedor '+_esc(nombre||cc)
      +', y la factura es de '+_esc(d.cardname||d.cardcode)
      +'. Una factura no puede mezclar proveedores.','err');
    return 0;
  }
  if(!d.cardcode){ d.cardcode=cc; d.cardname=nombre; }
  if(!d.numatcard) d.numatcard=orden.num_proveedor||'';
  // La ETA de la orden se propone como vencimiento, que es lo que SAP pone
  // en Due Date. Se puede cambiar antes de crear la factura.
  if(!d.docduedate){
    try{
      var re=await fetch(SB+'/rest/v1/opor_ordenes?select=eta,duedate&docnum=eq.'
        +encodeURIComponent(docnum),{headers:SBH});
      var eo=re.ok ? ((await re.json())||[])[0] : null;
      var eta=eo && (eo.eta||eo.duedate);
      if(eta) d.docduedate=String(eta).slice(0,10);
    }catch(e){ _dbg('[FR] ETA de la orden: '+(e.message||e)); }
  }

  // Las líneas se piden por NÚMERO de orden: es el dato que siempre tenemos.
  // La tabla trae además el docentry, que es lo que SAP necesita para
  // enlazar la factura con su orden.
  var r=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'
    +encodeURIComponent(docnum)+'&order=linenum&limit=500',{headers:SBH});
  if(!r.ok){
    var t=''; try{ t=await r.text(); }catch(e){}
    _frMsg('No pude leer las líneas de la orden #'+_esc(docnum)+' ('+r.status+')','err');
    _dbg('[FR] líneas: '+r.status+' '+t.slice(0,140));
    return 0;
  }
  var ls=await r.json()||[];
  // v769: si por el número no sale nada, se busca el número REAL de la orden
  // por su referencia (DKC/HIKC…) y se vuelve a pedir. Pasa cuando lo que llega
  // como «número» es la referencia, o cuando la misma referencia tiene una
  // orden BORRADOR y otra ya en SAP.
  if(!ls.length){
    try{
      var refs=[orden.num_proveedor, docnum].filter(function(x){ return x && !/^\d+$/.test(String(x)); });
      for(var ri=0; ri<refs.length && !ls.length; ri++){
        var ro=await fetch(SB+'/rest/v1/opor_ordenes?select=docnum,vendor_code,vendor_name'
          +'&num_proveedor=eq.'+encodeURIComponent(refs[ri])+'&limit=1',{headers:SBH});
        var oo=ro.ok ? ((await ro.json())||[])[0] : null;
        if(oo && oo.docnum){
          docnum=String(oo.docnum);
          if(!d.cardcode || d.cardcode===cc){ d.cardcode=oo.vendor_code||d.cardcode; d.cardname=oo.vendor_name||d.cardname; }
          var r2=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'
            +encodeURIComponent(docnum)+'&order=linenum&limit=500',{headers:SBH});
          if(r2.ok) ls=await r2.json()||[];
        }
      }
    }catch(e){ _dbg('[FR] número real por referencia: '+(e.message||e)); }
  }
  _dbg('[FR] orden #'+docnum+': '+ls.length+' línea(s) en la base');
  if(!ls.length){
    _frMsg('La orden #'+_esc(docnum)+' no tiene líneas guardadas en el portal.','err');
    return 0;
  }

  // Los nombres REALES de opor_lineas, los que escribe el worker:
  //   cantidad · cantidad_pendiente · precio · itemname
  // Con quantity, openqty y price —que no existen— salían catorce líneas
  // de la base y ninguna en pantalla.
  var n=0, servidas=0;
  ls.forEach(function(l){
    var pedida =Number(l.cantidad!=null?l.cantidad:l.quantity)||0;
    var abierta=Number(l.cantidad_pendiente!=null?l.cantidad_pendiente
                       :(l.openqty!=null?l.openqty:pedida))||0;
    if(abierta<=0){ servidas++; return; }
    if(d.lineas.some(function(x){
      return String(x.docentry)===String(l.docentry) && x.linenum===l.linenum; })) return;
    d.lineas.push({
      docentry:l.docentry, linenum:l.linenum, docnum:docnum,
      itemcode:l.itemcode,
      dscription:l.itemname||l.dscription||'',
      pedida:pedida, abierta:abierta, cantidad:abierta,
      precio:Number(l.precio!=null?l.precio:l.price)||0,
      picturname:l.picturname||l.foto_nombre||'',
      foto_url:l.foto_url||'',
      // Para peso, volumen y bultos (los baja el worker de SAP)
      peso_pdf_unit:Number(l.peso_pdf_unit)||0,
      pcub_unit:Number(l.pcub_unit)||0,
      peso_unit_kg:Number(l.peso_unit_kg)||0,
      volumen_unit_m3:Number(l.volumen_unit_m3)||0,
      unid_por_bulto:Number(l.unid_por_bulto)||0,
      unidad_empaque:Number(l.unidad_empaque)||0,
      bultos_linea:Number(l.cantidad_empaque)||0,
      udf_kilos:Number(l.udf_kilos)||0,
      udf_bultos:Number(l.udf_bultos)||0,
      udf_cbm:Number(l.udf_cbm)||0
    });
    n++;
  });
  if(!d.ordenes.some(function(o){ return String(o.docnum)===docnum; })){
    d.ordenes.push({docnum:docnum, numatcard:orden.num_proveedor||''});
  }
  _frMsg(n ? ('Se trajeron '+n+' línea(s) de la orden #'+_esc(docnum)
              + (servidas?(' · '+servidas+' ya servida(s) del todo'):''))
           : ('La orden #'+_esc(docnum)+' no tiene nada pendiente: sus '
              +ls.length+' línea(s) ya están servidas.'),
         n?'ok':'err');
  setTimeout(_frCompletarFotos, 80);
  return n;
}

function _frQuitar(i){
  var d=window._fr; if(!d) return;
  d.lineas.splice(i,1);
  rFactReserva();
}

function _frTodoDeOrden(docnum, poner){
  var d=window._fr; if(!d) return;
  d.lineas.forEach(function(l){
    if(String(l.docnum)!==String(docnum)) return;
    l.cantidad = poner ? l.abierta : 0;
  });
  rFactReserva();
}

function _frTotal(){
  var d=window._fr; if(!d) return 0;
  return d.lineas.reduce(function(a,l){
    return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);
}

// BTOS., Peso y P. Cub. (pies cúbicos) de lo que se va a facturar en la
// línea, igual que en la orden de compra impresa de SAP. El worker calibra
// de qué campo de SAP sale cada dato contra una orden impresa real y lo
// deja «por unidad» (peso_pdf_unit, pcub_unit). Si no pudo, se cae a los
// datos del artículo o a los campos de usuario de la línea.
var PIE3_POR_M3=35.3146667;
// La fila del cuadro «Medidas del packing list» que corresponde a una línea
function _fipMedidaDeLinea(l){
  var S=window._fip;
  if(!S || !S.medidas || !S.medidas.length) return null;
  var k=_ocNormSku(l.itemcode);
  for(var i=0;i<S.medidas.length;i++){
    var m=S.medidas[i];
    if(m.clave===k || (m.sap && _ocNormSku(m.sap)===k)) return m;
  }
  return null;
}

function _frPVB(l){
  var q=Number(l.cantidad)||0, ped=Number(l.pedida)||0;
  var prop = ped>0 ? q/ped : 0;
  /* v757: si la línea está en el cuadro «Medidas del packing list», sus
     números salen DE AHÍ, siempre y al momento. Es lo que se manda a la
     ficha del artículo antes de crear la factura, y de la ficha lo toma
     SAP: lo que se ve en la línea tiene que ser eso mismo. Antes las líneas
     usaban los datos crudos del packing, que en algunos archivos vienen en
     otra escala (Hebei: P. Cub. 272.746 pies³ en una línea de 486 piezas). */
  var md=_fipMedidaDeLinea(l);
  if(md){
    var pxbM=Number(md.piezas_x_bulto)||0;
    var pu=Number(md.peso_pieza_kg)||0, vu=Number(md.vol_pieza_pie3)||0;
    if(pxbM>0 || pu>0 || vu>0){
      return {peso: pu>0 ? pu*q : null,
              vol:  vu>0 ? vu*q : null,
              bultos: pxbM>0 ? Math.ceil(q/pxbM-0.0001) : (Number(md.bultos)||null),
              empaque: pxbM>0 ? pxbM : 0};
    }
  }
  // Si la línea vino de la factura y su packing list, mandan esos datos:
  // son los del embarque real, no los que tenía la ficha en SAP.
  if(l._fipPesoUnit>0 || l._fipPcubUnit>0 || l._fipBultos>0
     || l._fipPesoTotal>0 || l._fipPcubTotal>0){
    // Lo declarado en el packing, a prorrata de lo que factura la línea; si
    // la factura despacha lo mismo que se empacó, sale el número exacto del
    // packing. Si no hubiera total, se cae al valor por pieza.
    var prop2 = l._fipQtyPk>0 ? q/l._fipQtyPk : 0;
    // Los bultos de esta línea: si se factura todo lo empacado son los del
    // packing; si se factura una parte, las cajas que hacen falta a ese
    // empaque (una caja a medias cuenta como caja).
    var pxb=Number(l._fipPxb)||0;
    var bultos = (l._fipQtyPk>0 && Math.abs(q-l._fipQtyPk)<0.001 && l._fipBultos>0)
               ? l._fipBultos
               : (pxb>0 ? Math.ceil(q/pxb-0.0001) : (l._fipBultos>0?l._fipBultos:null));
    return {peso: l._fipPesoTotal>0 && prop2 ? l._fipPesoTotal*prop2
                 : (l._fipPesoUnit>0 ? l._fipPesoUnit*q : null),
            vol:  l._fipPcubTotal>0 && prop2 ? l._fipPcubTotal*prop2
                 : (l._fipPcubUnit>0 ? l._fipPcubUnit*q : null),
            bultos: bultos,
            empaque: pxb>0 ? pxb : (bultos>0 ? q/bultos : 0)};
  }
  var peso = l.peso_pdf_unit>0 ? l.peso_pdf_unit*q
           : l.peso_unit_kg>0 ? l.peso_unit_kg*q
           : (l.udf_kilos>0 ? l.udf_kilos*prop : null);
  var pcub = l.pcub_unit>0 ? l.pcub_unit*q
           : l.volumen_unit_m3>0 ? l.volumen_unit_m3*q*PIE3_POR_M3
           : (l.udf_cbm>0 ? l.udf_cbm*prop*PIE3_POR_M3 : null);
  var emp=_frEmpaque(l);
  // Como SAP: la cantidad facturada entre el empaque, y lo que sobra cuenta
  // como un bulto más. Una caja a medias también viaja.
  var bul  = emp>0 ? Math.ceil(q/emp - 0.0001)
           : l.bultos_linea>0 ? Math.ceil(l.bultos_linea*prop - 0.0001)
           : (l.udf_bultos>0 ? Math.ceil(l.udf_bultos*prop - 0.0001) : null);
  return {peso:peso, vol:pcub, bultos:bul, empaque:emp};
}

// Cuántas piezas van en cada bulto. En SAP puede estar en el empaque de
// compra o en el de venta: se queda con el que reproduce los bultos que la
// propia orden tiene calculados.
function _frEmpaque(l){
  var ped=Number(l.pedida)||0, bl=Number(l.bultos_linea)||0;
  var cands=[Number(l.unid_por_bulto)||0, Number(l.unidad_empaque)||0].filter(function(x){ return x>0; });
  if(!cands.length) return 0;
  if(ped>0 && bl>0){
    for(var i=0;i<cands.length;i++){
      if(Math.abs(Math.ceil(ped/cands[i]-0.0001)-bl)<=0.51) return cands[i];
    }
  }
  return cands[0];
}

// Los bultos, enteros cuando lo son (como en la orden impresa)
function _frFmtBul(v){
  if(v==null) return _frFmt(null,0);
  return _frFmt(v, Math.abs(v-Math.round(v))<0.001 ? 0 : 1);
}

function _frTotales(){
  var d=window._fr||{lineas:[]};
  var t={lineas:0, unidades:0, bultos:0, peso:0, vol:0, importe:0, empaques:0,
         sinPeso:0, sinVol:0, sinBultos:0};
  d.lineas.forEach(function(l){
    var q=Number(l.cantidad)||0;
    if(q<=0) return;
    var x=_frPVB(l);
    t.lineas++; t.unidades+=q; t.importe+=q*(Number(l.precio)||0);
    if(x.peso==null) t.sinPeso++; else t.peso+=x.peso;
    if(x.vol==null) t.sinVol++; else t.vol+=x.vol;
    if(x.bultos==null) t.sinBultos++; else t.bultos+=x.bultos;
  });
  return t;
}

function _frFmt(v, dec){
  if(v==null) return '<span style="color:var(--text-muted)" title="Sin dato en SAP">—</span>';
  return Number(v).toLocaleString('es',{minimumFractionDigits:dec,maximumFractionDigits:dec});
}

function _frPintarTotales(){
  var t=_frTotales();
  var poner=function(id, html){ var e=document.getElementById(id); if(e) e.innerHTML=html; };
  var falta=function(n){ return n?(' <span style="font-size:10px;color:var(--t-marron)" '
    +'title="Líneas sin ese dato en SAP: no suman">('+n+' sin dato)</span>'):''; };
  poner('frSumLin', String(t.lineas));
  poner('frSumUni', _frFmt(t.unidades,0));
  poner('frSumBul', _frFmtBul(t.bultos)+falta(t.sinBultos));
  poner('frSumPeso', _frFmt(t.peso,2)+falta(t.sinPeso));
  poner('frSumVol', _frFmt(t.vol,2)+falta(t.sinVol));
  poner('frSumImp', _fmtN2(t.importe));
  poner('frPieUni', _frFmt(t.unidades,0));
  poner('frPieBul', _frFmtBul(t.bultos));
  poner('frPiePeso', _frFmt(t.peso,2));
  poner('frPieVol', _frFmt(t.vol,2));
  poner('frPieImp', _fmtN2(t.importe));
  var pm=t.unidades>0 ? t.importe/t.unidades : 0;
  poner('frSumPm', _fmtN2(pm));
}

function _frTrasEditar(){
  var d=window._fr; if(!d) return;
  d.lineas.forEach(function(l,i){
    var e=document.getElementById('frTl'+i);
    if(e) e.textContent=_fmtN2((Number(l.cantidad)||0)*(Number(l.precio)||0));
    var x=_frPVB(l);
    var eb=document.getElementById('frBu'+i); if(eb) eb.innerHTML=_frFmtBul(x.bultos);
    var ep=document.getElementById('frPe'+i); if(ep) ep.innerHTML=_frFmt(x.peso,2);
    var ev=document.getElementById('frVo'+i); if(ev) ev.innerHTML=_frFmt(x.vol,2);
    // En rojo lo que pase de lo pendiente: SAP lo rechazaría
    var c=document.querySelector('.gc[data-g="frlineas"][data-f="'+i+'"][data-c="cantidad"]');
    if(c){
      var pasa=(Number(l.cantidad)||0) > (Number(l.abierta)||0)+0.0001;
      c.style.background = pasa ? 'var(--pastel-error)' : '';
      c.title = pasa ? ('En la orden solo quedan '+_fmtN2(l.abierta)+' pendientes') : '';
    }
  });
  var t=document.getElementById('frTotalVivo');
  if(t) t.textContent=_fmtN2(_frTotal());
  _frPintarTotales();
}

// La foto de una línea, probando todos los nombres posibles: el que trae la
// línea, el de la ficha del artículo y el propio código, con y sin
// extensión y en mayúscula o minúscula. Antes se probaba UNA sola URL y, si
// el bucket la tenía con otro nombre, la foto simplemente no salía.
function _frImgFoto(l){
  var urls=[];
  try{ urls=(fotoVariantes(l)||[]).slice(0,14); }catch(e){}
  if(!urls.length) return '';
  return '<img src="'+_esc(urls[0])+'" data-fotos="'+_esc(urls.join('|'))+'" data-fi="0" '
    +'style="width:32px;height:32px;object-fit:cover;border-radius:5px" '
    +'onmouseenter="_fotoLupa(this)" onmouseleave="_fotoLupaFuera()" '
    +'onerror="_frFotoSiguiente(this)">';
}

// Si una no existe, se prueba la siguiente; al acabarse, se esconde
function _frFotoSiguiente(img){
  var us=String(img.getAttribute('data-fotos')||'').split('|');
  var i=(parseInt(img.getAttribute('data-fi'),10)||0)+1;
  if(i>=us.length || !us[i]){ img.style.visibility='hidden'; return; }
  img.setAttribute('data-fi', String(i));
  img.src=us[i];
}

// Las líneas de la orden no siempre traen el nombre de la foto, pero la
// ficha del artículo en SAP sí lo tiene. Se rellenan las que falten para
// que salgan todas las fotos, no solo algunas.
async function _frCompletarFotos(){
  var d=window._fr; if(!d || !d.lineas) return;
  var faltan=d.lineas.filter(function(l){ return !l.picturname && !l.foto_url; });
  if(!faltan.length) return;
  var codigos=[...new Set(faltan.map(function(l){ return String(l.itemcode||'').trim(); })
                .filter(Boolean))];
  var hay={};
  try{
    for(var i=0;i<codigos.length;i+=80){
      var lote=_skuVariantes(codigos.slice(i,i+80));
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,picturname&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){
        if(x.picturname) hay[String(x.itemcode).trim().toUpperCase()]=x.picturname; });
    }
  }catch(e){ _dbg('[FR] fotos: '+(e.message||e)); return; }
  var n=0;
  d.lineas.forEach(function(l){
    if(l.picturname || l.foto_url) return;
    var pn=hay[String(l.itemcode).trim().toUpperCase()];
    if(pn){ l.picturname=pn; n++; }
  });
  if(n){ _dbg('[FR] '+n+' foto(s) completadas desde la ficha del artículo'); rFactReserva(); }
}

// ── La pantalla ─────────────────────────────────────────────────────────
var FR_CAMPOS=[
  {k:'itemcode',   t:'Artículo',   w:'140px'},
  {k:'dscription', t:'Descripción',w:'240px'},
  {k:'cantidad',   t:'Cantidad',   w:'90px',  num:true},
  {k:'precio',     t:'Precio',     w:'90px',  num:true}
];

function rFactReserva(){
  _tbxEstilos(); _arrInit();
  var c=document.getElementById('page-factreserva');
  if(!c) return;
  var d=window._fr||{lineas:[], ordenes:[]};

  var h='<div style="max-width:1400px;margin:0 auto">'
    +'<h2 style="font-size:17px;margin:0 0 3px"><i class="ti ti-file-invoice"></i> '
    +'Crear factura reserva</h2>'
    +'<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 14px">'
    +'Es lo mismo que «Pasar a factura reserva» en SAP, pero eligiendo qué se '
    +'factura. Cada línea queda enlazada a la suya de la orden de compra.</p>';

  // Buscador
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:flex-end;'
    +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:11px;'
    +'padding:12px 14px;margin-bottom:14px">'
    +'<div style="flex:1;min-width:220px">'
      +'<label style="font-size:11px;color:var(--text-muted)">DKC o número de orden</label>'
      +'<input id="frBuscar" value="'+_esc(d.lineas.length?'':(d.dkc||''))+'" '
      +'placeholder="'+(d.lineas.length?'Otra orden: DKC o número':'DKC-26110 o 12738')+'" '
      +'onkeydown="if(event.key===\'Enter\')_frBuscar(this.value, '
      +(d.lineas.length?'true':'false')+')" '
      +'style="width:100%;padding:8px 11px;border:0.5px solid var(--border);'
      +'border-radius:7px;font-size:13px;margin-top:3px"></div>'
    +'<button class="btn bp" onclick="_frBuscar(document.getElementById(\'frBuscar\').value,'
      +(d.lineas.length?'true':'false')+')">'
      +'<i class="ti ti-search"></i> '+(d.lineas.length?'Añadir otra orden':'Buscar')+'</button>'
    + (d.lineas.length ? ('<button class="xb" onclick="_frAbrir(\'\')">'
        +'<i class="ti ti-refresh"></i> Empezar de nuevo</button>') : '')
    +'</div>';

  // v769: el último aviso se vuelve a pintar. Se guardaba en d._msg pero la
  // zona se creaba vacía: si la búsqueda no traía líneas, el portal repintaba
  // y el motivo («no tiene líneas», «ya está servida»…) desaparecía. Quedaba
  // la pantalla en blanco, como si el botón no hiciera nada.
  var _m=d._msg;
  var _mc=_m&&_m.tipo==='err' ? ['var(--pastel-error)','var(--t-rojo)']
        : _m&&_m.tipo==='ok'  ? ['var(--pastel-ok)','var(--t-verde)']
                              : ['var(--surface-1)','var(--text-secondary)'];
  h+='<div id="frMsg">'+((_m&&_m.txt&&!/^Buscando/.test(String(_m.txt)))
      ? ('<div style="background:'+_mc[0]+';color:'+_mc[1]+';border-radius:8px;'
         +'padding:9px 12px;font-size:12px;margin-bottom:12px">'+_m.txt+'</div>') : '')+'</div>';

  if(!d.lineas.length){
    h+='<div class="empty" style="padding:30px;text-align:center">'
      +'Busca una orden por su DKC para traer sus líneas.</div></div>';
    c.innerHTML=h; return;
  }

  // Cabecera de la factura
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));'
    +'gap:10px;background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:11px;padding:12px 14px;margin-bottom:12px">'
    +_frCampo('Proveedor', _esc((d.cardcode||'')+' · '+(d.cardname||'')), true)
    +_frCampo('N.º de factura del proveedor',
       '<input id="frNumFact" value="'+_esc(d.num_factura||'')+'" '
       +'placeholder="MY260428B" onchange="window._fr.num_factura=this.value" '
       +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);'
       +'border-radius:7px;font-size:12.5px">')
    +_frCampo('Vendor Ref. No.',
       '<input id="frNumAt" value="'+_esc(d.numatcard||'')+'" '
       +'onchange="window._fr.numatcard=this.value" '
       +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);'
       +'border-radius:7px;font-size:12.5px">')
    // En SAP el vencimiento de la factura reserva es la ETA del embarque, y
    // la fecha del documento es la del momento en que se crea.
    +_frCampo('Fecha ETA · vencimiento en SAP',
       '<input type="date" id="frEta" value="'+_esc(d.docduedate||'')+'" '
       +'onchange="window._fr.docduedate=this.value" '
       +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);'
       +'border-radius:7px;font-size:12.5px">')
    +_frCampo('Fecha de la factura',
       '<div style="font-size:12.5px;font-weight:600;padding:7px 0">'+_fechaCorta(_hoyISO())
       +' <span style="font-size:10.5px;color:var(--text-muted);font-weight:400">'
       +'· se pone la del momento de crearla</span></div>')
    +'</div>';

  h+=_fruBloque();

  h+=_frBloqueReparto();

  // Las órdenes de las que salen las líneas
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;'
    +'font-size:11.5px;margin-bottom:9px">'
    +'<span style="color:var(--text-muted)">Órdenes:</span>'
    + d.ordenes.map(function(o){
        var n=d.lineas.filter(function(l){ return String(l.docnum)===String(o.docnum); }).length;
        return '<span style="background:var(--pastel-azul);color:var(--t-azul);'
          +'padding:3px 9px;border-radius:20px;font-weight:600">#'+_esc(o.docnum)
          +' · '+_esc(o.numatcard||'')+' · '+n+' línea(s) '
          +'<a onclick="_frTodoDeOrden(\''+_esc(o.docnum)+'\',true)" '
          +'style="cursor:pointer;text-decoration:underline">todo</a> · '
          +'<a onclick="_frTodoDeOrden(\''+_esc(o.docnum)+'\',false)" '
          +'style="cursor:pointer;text-decoration:underline">nada</a></span>';
      }).join('')
    +'<span style="flex:1"></span>'
    +'<span>Total: <b id="frTotalVivo" style="color:var(--t-ambar)">'
    +_fmtN2(_frTotal())+'</b></span></div>';

  // Forma nueva: llenarla desde la factura y el packing list del proveedor
  h+=_fipBloque();

  // Los totales de lo que se va a facturar, para cotejar con la factura
  // del proveedor antes de crearla. Se recalculan al cambiar una cantidad.
  var tarjeta=function(id, tit, fondo, color){
    return '<div style="flex:1;min-width:120px;background:'+fondo+';border-radius:10px;'
      +'padding:8px 12px"><div style="font-size:10.5px;color:'+color+'">'+tit+'</div>'
      +'<div id="'+id+'" style="font-size:16px;font-weight:700;color:'+color+'"></div></div>';
  };
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px">'
    + tarjeta('frSumLin','Líneas','var(--surface-1)','var(--text-primary)')
    + tarjeta('frSumUni','Unidades','var(--pastel-azul)','var(--t-azul)')
    + tarjeta('frSumBul','BTOS.','var(--pastel-aviso)','var(--t-marron)')
    + tarjeta('frSumPeso','Peso','var(--pastel-aviso)','var(--t-marron)')
    + tarjeta('frSumVol','P. Cub. (pies³)','var(--pastel-aviso)','var(--t-marron)')
    + tarjeta('frSumPm','Precio medio / unidad','var(--surface-1)','var(--text-primary)')
    + tarjeta('frSumImp','Importe','var(--pastel-ok)','var(--t-verde)')
    +'</div>';

  // La tabla
  _gridRegistrar('frlineas', FR_CAMPOS.map(function(x){ return x.k; }),
                 d.lineas, _frTrasEditar);

  h+='<div class="tbx-box">'
    +'<table class="tbx"><thead><tr>'
    +'<th style="width:44px">Foto</th><th style="width:64px">Orden</th>'
    + FR_CAMPOS.map(function(x){ return '<th>'+_esc(x.t)+'</th>'; }).join('')
    +'<th style="width:72px">Pendiente</th>'
    +'<th style="width:62px;text-align:right" title="Bultos de lo que se factura">BTOS.</th>'
    +'<th style="width:70px;text-align:right" title="Piezas por bulto, igual que en SAP">Empaque</th>'
    +'<th style="width:80px;text-align:right" title="Peso de lo que se factura, como en la orden impresa">Peso</th>'
    +'<th style="width:80px;text-align:right" title="Pies cúbicos de lo que se factura, como en la orden impresa">P. Cub.</th>'
    +'<th style="width:70px;text-align:right">Total</th><th style="width:28px"></th>'
    +'</tr></thead><tbody>'
    + d.lineas.map(function(l,i){
        return '<tr>'
          +'<td>'+_frImgFoto(l)+'</td>'
          +'<td style="font-size:10.5px;color:var(--text-muted)">#'+_esc(l.docnum)+'</td>'
          + FR_CAMPOS.map(function(x){
              return '<td>'+_gridCelda('frlineas', i, x.k, l[x.k], x.w)+'</td>';
            }).join('')
          +'<td style="font-size:11px;color:var(--text-muted)">'+_fmtN2(l.abierta)+'</td>'
          +(function(){ var x=_frPVB(l);
              return '<td style="text-align:right" id="frBu'+i+'">'+_frFmtBul(x.bultos)+'</td>'
                +'<td style="text-align:right;color:var(--text-muted)">'
                +(x.empaque>0?(_frFmt(x.empaque,0)+' X 1'):'—')+'</td>'
                +'<td style="text-align:right" id="frPe'+i+'">'+_frFmt(x.peso,2)+'</td>'
                +'<td style="text-align:right" id="frVo'+i+'">'+_frFmt(x.vol,2)+'</td>'; })()
          +'<td style="text-align:right" id="frTl'+i+'">'
          +_fmtN2((Number(l.cantidad)||0)*(Number(l.precio)||0))+'</td>'
          +'<td><button class="xb" style="padding:1px 5px;color:var(--text-danger)" '
          +'onclick="_frQuitar('+i+')" title="Quitar esta línea">'
          +'<i class="ti ti-x"></i></button></td></tr>';
      }).join('')
    +'</tbody><tfoot><tr style="font-weight:700;background:var(--surface-1)">'
    +'<td colspan="4" style="text-align:right">TOTALES</td>'
    +'<td style="text-align:right" id="frPieUni"></td><td></td><td></td>'
    +'<td style="text-align:right" id="frPieBul"></td><td></td>'
    +'<td style="text-align:right" id="frPiePeso"></td>'
    +'<td style="text-align:right" id="frPieVol"></td>'
    +'<td style="text-align:right" id="frPieImp"></td><td></td></tr></tfoot>'
    +'</table></div>';

  // Flete y otros gastos: SIEMPRE se pueden poner (v739). Antes solo salían
  // en el cuadro de totales de la factura leída por el FIP, y en una factura
  // reserva individual (sin FIP) no había dónde meterlos.
  h+=_frGastosHtml();

  // Con varias órdenes en pantalla, lo normal en Kennedy es UNA factura
  // reserva por orden: el botón principal las crea todas, una por orden.
  var _nOrd=_frOrdenesEnPantalla().length;
  h+='<div style="display:flex;gap:10px;margin-top:14px;flex-wrap:wrap">'
    +'<button class="btn bp" style="flex:1;min-width:240px;font-size:14px;padding:11px" '
    +'onclick="'+(_nOrd>1?'_frCrearPorOrden()':'_frEnviar()')+'">'
    +'<i class="ti ti-file-invoice"></i> '
    +(_nOrd>1 ? ('Crear '+_nOrd+' facturas reserva en SAP · una por orden')
              : 'Crear factura reserva en SAP')+'</button>'
    +(_nOrd>1
      ? ('<button class="btn bg2" style="min-width:210px;font-size:12.5px;padding:11px" '
         +'onclick="_frEnviar()" title="Una sola factura que cubra las '+_nOrd
         +' órdenes">Crear una sola para todas</button>')
      : '')
    +'</div>'
    +(_nOrd>1?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:5px">'
      +'Cada factura lleva las líneas de su orden, su parte del flete y el Vendor Ref. '
      +'No. con su letra (A, B, C…).</div>'):'');

  h+='<div id="frHist" style="margin-top:20px"></div></div>';
  c.innerHTML=h;
  // El último aviso, otra vez, que el repintado se lo acaba de llevar
  try{
    if(d._msg && d._msg.txt){
      var g=document.getElementById('frMsg');
      if(g){
        var col=d._msg.tipo==='err' ? ['var(--pastel-error)','var(--t-rojo)']
              : d._msg.tipo==='ok'  ? ['var(--pastel-ok)','var(--t-verde)']
                                    : ['var(--surface-1)','var(--text-secondary)'];
        g.innerHTML='<div style="background:'+col[0]+';color:'+col[1]+';'
          +'border-radius:8px;padding:9px 12px;font-size:12px;margin-bottom:12px">'
          +d._msg.txt+'</div>';
      }
    }
  }catch(e){}
  _frTrasEditar();
  try{ _frRepartoPintar(); }catch(e){}
  _frCargarHistorial();
}

function _frCampo(tit, html, plano){
  return '<div><div style="font-size:10.5px;color:var(--text-muted);margin-bottom:3px">'
    +_esc(tit)+'</div>'+(plano?('<div style="font-size:12.5px;font-weight:600">'+html+'</div>'):html)+'</div>';
}

function _frMsg(txt, tipo){
  // Se guarda: rFactReserva() recrea la zona de avisos vacía, así que sin
  // esto el mensaje desaparecía justo al repintar y no daba tiempo a leerlo.
  try{ if(window._fr) window._fr._msg={txt:txt, tipo:tipo}; }catch(e){}
  var e=document.getElementById('frMsg');
  if(!e){ showT(String(txt).replace(/<[^>]+>/g,'')); return; }
  var col=tipo==='err' ? ['var(--pastel-error)','var(--t-rojo)']
        : tipo==='ok'  ? ['var(--pastel-ok)','var(--t-verde)']
                       : ['var(--surface-1)','var(--text-secondary)'];
  e.innerHTML='<div style="background:'+col[0]+';color:'+col[1]+';border-radius:8px;'
    +'padding:9px 12px;font-size:12px;margin-bottom:12px">'+txt+'</div>';
}

function _frModal(tit, cuerpo){
  var ov=document.createElement('div');
  ov.id='frModal';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10050;'
    +'display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:16px;'
    +'width:100%;max-width:560px;max-height:75vh;display:flex;flex-direction:column">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;'
    +'margin-bottom:9px"><div style="font-size:14px;font-weight:600">'+_esc(tit)+'</div>'
    +'<button onclick="_frCerrarModal()" style="background:none;border:none;'
    +'font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="overflow-y:auto;border:0.5px solid var(--border);border-radius:8px">'
    +cuerpo+'</div></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _frCerrarModal(); });
  document.body.appendChild(ov);
}
function _frCerrarModal(){ var m=document.getElementById('frModal'); if(m) m.remove(); }

// ── Enviar a SAP ────────────────────────────────────────────────────────
async function _frEnviar(){
  var d=window._fr; if(!d) return;
  var lineas=d.lineas.filter(function(l){ return (Number(l.cantidad)||0)>0; });
  if(!lineas.length){ _frMsg('No hay ninguna línea con cantidad.','err'); return; }

  // Si la factura del proveedor trajo referencias que no están en ninguna
  // orden, hay que decidir antes: corregirlas, seguir sin ellas o abortar.
  var _fv=_fipValidarEnvio();
  if(!_fv.ok){
    _frMsg(_esc(_fv.msg),'err');
    try{ document.getElementById('fipBox').scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){}
    return;
  }

  // Lo que SAP rechazaría, dicho antes de mandarlo
  var pasadas=lineas.filter(function(l){
    return (Number(l.cantidad)||0) > (Number(l.abierta)||0)+0.0001; });
  if(pasadas.length){
    _frMsg('<b>'+pasadas.length+' línea(s) piden más de lo que queda pendiente '
      +'en la orden</b><br>'
      + pasadas.slice(0,5).map(function(l){
          return '· '+_esc(l.itemcode)+': '+_fmtN2(l.cantidad)+' pedidos, '
            +_fmtN2(l.abierta)+' pendientes (orden #'+_esc(l.docnum)+')';
        }).join('<br>')
      +(pasadas.length>5?('<br>· … y '+(pasadas.length-5)+' más'):'')
      +'<br>SAP las rechazaría. Puedes ajustar las órdenes en SAP con las cantidades '
      +'que vinieron, y después crear la factura.'
      +'<br><button class="btn bp" style="margin-top:7px;padding:7px 12px;font-size:12px" '
      +'onclick="_frAjustarOrdenes()"><i class="ti ti-eye"></i> '
      +'Ver las '+pasadas.length+' diferencia(s) con las órdenes</button>','err');
    return;
  }

  var ordenes=[...new Set(lineas.map(function(l){ return l.docnum; }))];
  var resumen='CREAR LA FACTURA RESERVA\n\n'
    +'Proveedor: '+(d.cardcode||'')+' · '+(d.cardname||'')+'\n'
    +'Órdenes:   #'+ordenes.join(', #')+'\n'
    +'Líneas:    '+lineas.length+'\n'
    +'Total:     '+_fmtN2(_frTotal())+'\n'
    +'Fecha:     '+_fechaCorta(_hoyISO())+'\n'
    + (function(){
        var cg=_frCargosDeEstaFactura(lineas);
        if(!cg.length) return '';
        return 'Gastos:    '+cg.map(function(x){
          return x.concepto+' '+_fmtN2(x.monto); }).join(' · ')+'\n';
      })()
    +'ETA (vencimiento): '+(d.docduedate?_fechaCorta(d.docduedate)
        :'sin poner, SAP lo calculará por las condiciones de pago')+'\n';
  var parciales=lineas.filter(function(l){
    return (Number(l.cantidad)||0) < (Number(l.abierta)||0)-0.0001; });
  if(parciales.length) resumen+='\n'+parciales.length+' línea(s) van PARCIALES: el '
    +'resto queda pendiente en la orden.\n';
  var _gs=_frCargosDeEstaFactura(lineas);
  if(_gs.length) resumen+='\nGastos: '+_gs.map(function(c){ return c.concepto+' '+fmt(c.monto); }).join(' · ')+'\n';
  resumen+='\nSe crea en SAP enlazada a las órdenes. ¿Sigo?';
  if(!confirm(resumen)) return;

  _frMsg('Enviando…');
  try{
    var fila={
      dkc:d.dkc||null, cardcode:d.cardcode, cardname:d.cardname||null,
      numatcard:d.numatcard||null, num_factura:d.num_factura||null,
      // La fecha del documento es la de AHORA, no la que se vio al abrir la
      // pantalla: si alguien la dejó abierta desde ayer, SAP la contabilizaba
      // con fecha de ayer.
      docdate:_hoyISO(), docduedate:d.docduedate||null,
      comments:('Factura reserva desde el portal · órdenes #'+ordenes.join(', #')
                +(d.num_factura?(' · factura '+d.num_factura):'')).slice(0,254),
      lineas:lineas.map(function(l){
        return {docentry:l.docentry, linenum:l.linenum, docnum:l.docnum,
                itemcode:l.itemcode, dscription:l.dscription,
                cantidad:Number(l.cantidad)||0, precio:Number(l.precio)||0};
      }),
      campos_usuario:(window._fr.udf||{}),
      // Flete y demás gastos marcados en el panel de la factura, en la
      // parte que le toca a esta factura reserva
      cargos:_frCargosDeEstaFactura(lineas),
      total:_frTotal(),
      // Cuánto de esta factura lleva cada orden, para poder consultarlo
      // después: cuánto se facturó y se pagó de cada DKC.
      reparto:_frReparto().map(function(x){
        return {docnum:x.docnum, dkc:x.dkc, monto:Number(x.monto)||0}; }),
      estado:'pendiente',
      creado_por:(CU&&CU.name)||''
    };
    _frwAbrir();
    var r=await _postTolerante(SB+'/rest/v1/facturas_reserva_queue', fila);
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      if(t.indexOf('does not exist')>=0 || t.indexOf('relation')>=0){
        throw new Error('falta la tabla de la cola. Hay que correr '
          +'facturas_reserva.sql en Supabase.');
      }
      throw new Error(r.status+' '+t.slice(0,140));
    }
    var reg=((await r.json())||[])[0];
    // Con la factura van también las medidas del packing a la ficha de cada
    // artículo: antes había que acordarse de pulsar el botón aparte.
    var _med=0;
    try{ _med=await _fipMandarMedidas(true)||0; }catch(e){}
    _frMsg('✓ Enviado. El worker la está creando en SAP.'
      +(_med?(' Y las medidas de '+_med+' artículo(s) van a su ficha.'):''),'ok');
    _frCargarHistorial();
    // La rueda y, al terminar, el número de factura en grande
    if(reg && reg.id) _frwSeguir(reg.id, Date.now());
    else _frwPintarEspera('Enviada a la cola…','El resultado sale en el historial de abajo.');
  }catch(e){
    _frwCerrar();
    _frMsg('No se pudo enviar: '+_esc(e.message||e),'err');
  }
}

async function _frCargarHistorial(){
  var c=document.getElementById('frHist');
  if(!c) return;
  try{
    var r=await fetch(SB+'/rest/v1/facturas_reserva_queue?select=*&order=id.desc&limit=10',
      {headers:SBH});
    if(!r.ok) return;
    var filas=await r.json()||[];
    if(!filas.length) return;
    var col={pendiente:['var(--pastel-aviso)','var(--t-marron)','En cola'],
             en_curso:['var(--pastel-azul)','var(--t-azul)','Creándose'],
             creada:['var(--pastel-ok)','var(--t-verde)','Creada'],
             error:['var(--pastel-error)','var(--t-rojo)','Falló']};
    c.innerHTML=_colaAviso(filas)
      +'<div style="font-size:12px;font-weight:600;margin-bottom:8px">'
      +'Últimas facturas reserva</div>'
      +'<table class="tb" style="font-size:11.5px"><thead><tr>'
      +'<th>Ref.</th><th>Proveedor</th><th>Líneas</th><th>Total</th>'
      +'<th>Estado</th><th>En SAP</th><th>Cuándo</th></tr></thead><tbody>'
      + filas.map(function(f){
          var k=col[f.estado]||['var(--surface-1)','var(--text-muted)',f.estado];
          var n=(f.lineas&&f.lineas.length)||0;
          return '<tr><td>'+_esc(f.numatcard||f.dkc||'')+'</td>'
            +'<td>'+_esc(f.cardname||f.cardcode||'')+'</td>'
            +'<td>'+n+'</td><td>'+_fmtN2(f.total||0)+'</td>'
            +'<td><span style="background:'+k[0]+';color:'+k[1]+';padding:2px 8px;'
            +'border-radius:20px;font-size:10.5px;font-weight:600">'+k[2]+'</span></td>'
            +'<td>'+(f.docnum_sap?('<b>#'+_esc(f.docnum_sap)+'</b>'):'—')+'</td>'
            +'<td style="font-size:10.5px;color:var(--text-muted);white-space:nowrap">'
            +_esc(_fechaHora(f.creado_en))
            +(f.error_msg?('<button class="xb" style="padding:1px 6px;font-size:10px;'
              +'margin-left:6px" onclick="alert('+JSON.stringify(
                 JSON.stringify(String(f.error_msg))).replace(/"/g,'&quot;')
              +')">ver error</button>'):'')
            +'</td></tr>';
        }).join('')
      +'</tbody></table>';
    _colaSeguir('FR','factreserva', _frCargarHistorial,
      filas.some(function(f){ return f.estado==='pendiente'||f.estado==='en_curso'; }));
  }catch(e){ console.warn('[FR] historial:', e); }
}

// Dos auxiliares que faltaban
function _hoyISO(){
  var d=new Date();
  return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')
         +'-'+String(d.getDate()).padStart(2,'0');
}
function _fechaCorta(v){
  if(!v) return '';
  try{
    var d=new Date(v);
    if(isNaN(d)) return String(v).slice(0,10);
    return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});
  }catch(e){ return String(v).slice(0,10); }
}

// El acceso directo desde una orden de compra que ya está en SAP: es de
// donde se parte casi siempre, y así el DKC va puesto.
function _frBarraOrden(o){
  try{
    if(!o || o._noSap) return '';          // las borrador no tienen orden en SAP
    if(!_frPuede()) return '';
    var ref=String(o.num_proveedor||o.id||'').trim();
    if(!ref) return '';
    return '<div style="display:flex;align-items:center;gap:11px;flex-wrap:wrap;'
      +'background:var(--pastel-verde2);border:1px solid #7FBF9A;border-radius:11px;'
      +'padding:10px 14px;margin-bottom:12px">'
      +'<i class="ti ti-file-invoice" style="font-size:19px;color:var(--t-verde2)"></i>'
      +'<div style="flex:1;min-width:180px;font-size:12px;color:var(--t-verde2)">'
      +'Cuando llegue el contenedor, se pasa a factura reserva. Puedes facturar '
      +'solo lo que vino.</div>'
      +'<button class="btn bp" style="font-size:12.5px;font-weight:700;padding:8px 15px" '
      +'onclick="event.stopPropagation();_frAbrir(\'' + _esc(ref) + '\')">'
      +'<i class="ti ti-file-invoice"></i> CREAR FACTURA RESERVA</button></div>';
  }catch(e){ console.warn('[FR] barra:', e); return ''; }
}

// ── Seguir una cola sin salir de la pantalla ────────────────────────────
// Mientras haya algo en cola o creándose, la tabla se refresca sola cada
// pocos segundos. Antes había que salir y volver a entrar para saber si la
// orden ya estaba en SAP.
window._colas = window._colas || {};

function _colaSeguir(id, pagina, recargar, quedan){
  var e=window._colas[id] || (window._colas[id]={});
  if(e.timer){ clearTimeout(e.timer); e.timer=null; }

  if(!quedan){                       // ya no queda nada esperando
    e.desde=0;
    return;
  }
  if(!e.desde) e.desde=Date.now();

  // Se deja de mirar a los diez minutos: si en ese tiempo no se resolvió,
  // el worker no está corriendo y seguir preguntando no arregla nada.
  if(Date.now()-e.desde > 10*60*1000){
    _dbg('['+id+'] dejo de seguir la cola: diez minutos sin resolverse');
    e.desde=0;
    return;
  }

  e.timer=setTimeout(function(){
    e.timer=null;
    // Si ya no estás en esa pantalla, no se gasta nada
    if(typeof PG!=='undefined' && PG!==pagina){ e.desde=0; return; }
    try{ recargar(); }catch(err){ console.warn('['+id+'] seguir:', err); }
  }, 4000);
}

// Un aviso vivo de lo que está esperando, para no quedarse mirando la tabla
function _colaAviso(filas){
  var pend=(filas||[]).filter(function(f){
    return f.estado==='pendiente' || f.estado==='en_curso'; });
  if(!pend.length) return '';
  var enCurso=pend.filter(function(f){ return f.estado==='en_curso'; }).length;
  return '<div style="display:flex;align-items:center;gap:9px;'
    +'background:var(--pastel-azul);border:0.5px solid #85B7EB;border-radius:9px;'
    +'padding:8px 12px;margin-bottom:9px">'
    +'<span style="width:14px;height:14px;border:2px solid #85B7EB;'
    +'border-top-color:var(--t-azul);border-radius:50%;display:inline-block;'
    +'animation:bkGirar .8s linear infinite"></span>'
    +'<span style="font-size:12px;color:var(--t-azul)">'
    + (enCurso ? 'Creándose en SAP…' : 'Esperando al worker…')
    + ' Esto se actualiza solo.</span>'
    +'<style>@keyframes bkGirar{to{transform:rotate(360deg)}}</style></div>';
}

// ── Las tablas grandes de artículos ─────────────────────────────────────
// Las de crear borrador, crear orden en SAP y factura reserva. Son hojas de
// cálculo de verdad: cabecera fija al hacer scroll, títulos más grandes que
// el contenido, y sitio para muchas filas.
function _tbxEstilos(){
  if(document.getElementById('tbxCss')) return;
  var e=document.createElement('style');
  e.id='tbxCss';
  e.textContent =
    '.tbx{border-collapse:separate;border-spacing:0;font-size:12.5px;width:max-content;min-width:100%}'
  + '.tbx thead th{position:sticky;top:0;z-index:5;'
  +   'font-size:13px;font-weight:800;letter-spacing:.2px;'
  +   'padding:9px 8px;white-space:nowrap;text-align:left;'
  +   'background:var(--surface-2);color:var(--text-primary);'
  +   'box-shadow:inset 0 -1px 0 var(--border),inset 0 1px 0 var(--border)}'
  // La fila de grupos va encima de la de títulos y también se queda fija
  + '.tbx thead tr:first-child th{top:0;font-size:12px;font-weight:800;'
  +   'text-transform:uppercase;letter-spacing:.6px;padding:7px 8px}'
  + '.tbx thead tr:nth-child(2) th{top:34px}'
  + '.tbx tbody td{padding:4px 6px;border-bottom:0.5px solid var(--border);'
  +   'vertical-align:middle}'
  + '.tbx tbody tr:hover td{background:var(--bg-accent)}'
  // Las casillas, cómodas de leer
  + '.tbx input,.tbx select{font-size:12.5px;padding:5px 7px}'
  // El contenedor: que ocupe la pantalla
  + '.tbx-box{overflow:auto;max-height:68vh;border:0.5px solid var(--border);'
  +   'border-radius:9px;background:var(--surface-0);position:relative}';
  document.head.appendChild(e);
}

// ── Arrastrar hacia abajo, como en Excel ────────────────────────────────
// Se escribe un valor en una casilla, se coge el cuadradito de su esquina y
// se baja: el valor se copia a todas las de esa columna por las que pasas.
// Es lo que más tiempo ahorra cuando cuarenta artículos llevan la misma
// marca o el mismo país.
window._arr = window._arr || null;

function _arrInit(){
  if(window._arrPuesto) return;
  window._arrPuesto=true;

  // El cuadradito aparece en la casilla donde estás
  document.addEventListener('focusin', function(e){
    var el=e.target;
    if(!el || !el.classList || !el.classList.contains('gc')) return;
    if(el.tagName==='SELECT') return;            // en los desplegables no
    _arrPonerTirador(el);
  });

  document.addEventListener('mousedown', function(e){
    var t=e.target;
    if(!t || !t.classList || !t.classList.contains('arr-tirador')) return;
    e.preventDefault();
    var celda=t._celda;
    if(!celda) return;
    window._arr={gid:celda.dataset.g, campo:celda.dataset.c,
                 desde:Number(celda.dataset.f), hasta:Number(celda.dataset.f),
                 valor:celda.value};
    document.body.style.userSelect='none';
  });

  document.addEventListener('mousemove', function(e){
    var a=window._arr; if(!a) return;
    // Al llegar al borde, la tabla se desplaza sola: antes el arrastre se
    // acababa donde acababa la pantalla y no se podía llegar al final.
    _arrAutoScroll(e.clientY);
    var bajo=document.elementFromPoint(e.clientX, e.clientY);
    if(!bajo || !bajo.classList || !bajo.classList.contains('gc')) return;
    if(bajo.dataset.g!==a.gid || bajo.dataset.c!==a.campo) return;
    a.hasta=Number(bajo.dataset.f);
    _arrPintarRango();
  });

  // Doble clic en el cuadradito: rellena hasta la ÚLTIMA fila, como en Excel
  document.addEventListener('dblclick', function(e){
    var t=e.target;
    if(!t || !t.classList || !t.classList.contains('arr-tirador')) return;
    e.preventDefault();
    var celda=t._celda; if(!celda) return;
    var g=(window._grids||{})[celda.dataset.g];
    var ultima=g ? (g.filas.length-1)
                 : (document.querySelectorAll('.gc[data-g="'+celda.dataset.g
                    +'"][data-c="'+celda.dataset.c+'"]').length-1);
    if(ultima<=Number(celda.dataset.f)) return;
    _arrRellenar({gid:celda.dataset.g, campo:celda.dataset.c,
                  desde:Number(celda.dataset.f), hasta:ultima, valor:celda.value});
  });

  document.addEventListener('mouseup', function(){
    var a=window._arr;
    document.body.style.userSelect='';
    if(!a){ return; }
    window._arr=null;
    _arrPintarRango(true);
    if(a.hasta===a.desde) return;
    _arrRellenar(a);
  });
}

// El contenedor con scroll que contiene la tabla, y su desplazamiento solo
function _arrAutoScroll(y){
  var a=window._arr; if(!a) return;
  var celda=document.querySelector('.gc[data-g="'+a.gid+'"][data-c="'+a.campo+'"]');
  var cont=celda;
  while(cont && cont!==document.body){
    var st=getComputedStyle(cont);
    if((st.overflowY==='auto'||st.overflowY==='scroll') && cont.scrollHeight>cont.clientHeight) break;
    cont=cont.parentElement;
  }
  var margen=45, paso=22;
  if(cont && cont!==document.body){
    var r=cont.getBoundingClientRect();
    if(y > r.bottom-margen) cont.scrollTop += paso;
    else if(y < r.top+margen) cont.scrollTop -= paso;
  }
  // Y la página, por si la tabla es la que crece
  if(y > window.innerHeight-margen) window.scrollBy(0, paso);
  else if(y < margen) window.scrollBy(0, -paso);
}

function _arrPonerTirador(celda){
  var v=document.getElementById('arrTirador');
  if(!v){
    v=document.createElement('div');
    v.id='arrTirador';
    v.className='arr-tirador';
    v.style.cssText='position:absolute;width:9px;height:9px;background:var(--t-azul);'
      +'border:1.5px solid #fff;border-radius:2px;cursor:crosshair;z-index:20;'
      +'box-shadow:0 0 0 1px var(--t-azul)';
    v.title='Arrastra hacia abajo para copiar este valor · doble clic para '
      +'llenar hasta la última fila';
    document.body.appendChild(v);
  }
  v._celda=celda;
  var r=celda.getBoundingClientRect();
  v.style.left=(window.scrollX+r.right-5)+'px';
  v.style.top =(window.scrollY+r.bottom-5)+'px';
  v.style.display='block';
}

// Marca en azul claro por dónde va el arrastre
function _arrPintarRango(limpiar){
  var a=window._arr;
  document.querySelectorAll('.gc[data-arr]').forEach(function(el){
    el.style.background=''; el.removeAttribute('data-arr');
  });
  if(limpiar || !a) return;
  var ini=Math.min(a.desde,a.hasta), fin=Math.max(a.desde,a.hasta);
  for(var f=ini; f<=fin; f++){
    var el=document.querySelector('.gc[data-g="'+a.gid+'"][data-f="'+f+'"]'
                                  +'[data-c="'+a.campo+'"]');
    if(el && f!==a.desde){ el.style.background='var(--pastel-azul)'; el.dataset.arr='1'; }
  }
}

function _arrRellenar(a){
  var ini=Math.min(a.desde,a.hasta), fin=Math.max(a.desde,a.hasta);
  var n=0;
  for(var f=ini; f<=fin; f++){
    if(f===a.desde) continue;
    var el=document.querySelector('.gc[data-g="'+a.gid+'"][data-f="'+f+'"]'
                                  +'[data-c="'+a.campo+'"]');
    if(!el) continue;
    el.value=a.valor;
    try{ _gridCambio(el); }catch(e){}
    // Un parpadeo para ver qué se ha rellenado
    el.style.background='var(--pastel-ok)';
    (function(x){ setTimeout(function(){ x.style.background=''; }, 600); })(el);
    n++;
  }
  if(n) showT('Copiado a '+n+' fila(s)');
}

// ── El ganchito de confirmación ─────────────────────────────────────────
// Un aviso grande y claro cuando algo se ha creado de verdad. El mensajito
// de la esquina se pierde de vista y no queda claro si funcionó.
function _okGrande(titulo, detalle, alCerrar){
  var ov=document.createElement('div');
  ov.id='okGrande';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10060;'
    +'display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:16px;'
      +'padding:26px 30px;max-width:440px;text-align:center;'
      +'box-shadow:0 20px 60px rgba(0,0,0,.3)">'
    +'<div style="width:62px;height:62px;border-radius:50%;margin:0 auto 14px;'
      +'background:var(--pastel-ok);display:flex;align-items:center;'
      +'justify-content:center">'
      +'<i class="ti ti-check" style="font-size:34px;color:var(--t-verde)"></i></div>'
    +'<div style="font-size:17px;font-weight:700;margin-bottom:7px">'+_esc(titulo)+'</div>'
    +'<div style="font-size:12.5px;color:var(--text-secondary);line-height:1.6">'
      +detalle+'</div>'
    +'<button class="btn bp" style="margin-top:18px;padding:9px 26px" '
      +'onclick="_okCerrar()">Entendido</button></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _okCerrar(); });
  window._okAlCerrar=alCerrar||null;
  document.body.appendChild(ov);
}

function _okCerrar(){
  var m=document.getElementById('okGrande');
  if(m) m.remove();
  var f=window._okAlCerrar; window._okAlCerrar=null;
  if(typeof f==='function'){ try{ f(); }catch(e){} }
}

// La fecha por la que se ordena el listado. Se prefiere la de alta —cuándo
// entró la orden al portal— porque es lo que la gente espera al pedir «más
// reciente primero». Si no la hay, la de la proforma, como antes.
function _fechaOrden(o){
  try{
    var alta=o && o._altaEn, tocada=o && o._tocadaEn;
    // Una fecha de alta de verdad lleva hora («2026-09-17T19:04:22Z»). Las
    // guardadas antes de arreglar esto traen la fecha pelada de la proforma
    // («2026-06-12»): esas no valen y se usa la de la última edición.
    var conHora=function(v){ return /\d{4}-\d{2}-\d{2}T/.test(String(v||'')); };
    if(conHora(alta)){
      var d1=new Date(alta);
      if(!isNaN(d1)) return d1;
    }
    if(conHora(tocada)){
      var d2=new Date(tocada);
      if(!isNaN(d2)) return d2;
    }
    if(alta){
      var d3=new Date(alta);
      if(!isNaN(d3) && d3.getFullYear()>2000) return d3;
    }
  }catch(e){}
  return parseDateStr(o && o.fechaCreacion) || new Date(0);
}

// ── La foto en grande al pasar el ratón ─────────────────────────────────
// Las miniaturas son de 32 píxeles y no se distingue un termo de otro. Al
// pasar por encima se ve a tamaño útil, sin tener que pulsar.
function _fotoLupa(img){
  if(!img || !img.src) return;
  var v=document.getElementById('fotoLupa');
  if(!v){
    v=document.createElement('div');
    v.id='fotoLupa';
    v.style.cssText='position:fixed;z-index:10090;pointer-events:none;'
      +'background:var(--surface-2);border:1px solid var(--border);border-radius:10px;'
      +'padding:5px;box-shadow:0 14px 40px rgba(0,0,0,.28);display:none';
    v.innerHTML='<img style="display:block;max-width:260px;max-height:260px;'
      +'border-radius:6px">';
    document.body.appendChild(v);
  }
  v.querySelector('img').src=img.src;
  var r=img.getBoundingClientRect();
  // A la derecha, salvo que no quepa
  var x=r.right+12, y=r.top-40;
  if(x+280>window.innerWidth) x=Math.max(8, r.left-292);
  if(y<8) y=8;
  if(y+280>window.innerHeight) y=Math.max(8, window.innerHeight-288);
  v.style.left=x+'px'; v.style.top=y+'px'; v.style.display='block';
}

function _fotoLupaFuera(){
  var v=document.getElementById('fotoLupa');
  if(v) v.style.display='none';
}

/* ═══════════════════════════════════════════════════════════════════════════
   REVISED PO
   ───────────────────────────────────────────────────────────────────────────
   El proveedor devuelve la orden con cambios: cantidades, precios, a veces
   descripciones o códigos de barras. Esto lo lee, lo compara contra lo que
   hay ahora en la pantalla y enseña las diferencias una por una.

   Nada se aplica hasta que se aprueba. Y se puede aprobar por partes: si el
   precio nuevo está bien pero la descripción la prefieres como estaba, se
   marca solo lo que interesa.
   ═══════════════════════════════════════════════════════════════════════════ */

// Qué se compara y cómo se llama en pantalla
var RPO_CAMPOS=[
  ['cantidad',        'cantidad',    'Cantidad',            true],
  ['precio',          'precio',      'Precio',              true],
  ['barcode',         'barcode',     'Código de barras',    false],
  ['itemname',        'esp',         'Descripción',         false],
  ['foreign_name',    'ing',         'Descripción inglés',  false],
  ['udf_color',       'color',       'Color',               false],
  ['udf_comp_esp',    'comp',        'Material',            false],
  ['udf_tamano',      'size',        'Tamaño',              false],
  ['udf_bulto',       'carton',      'Tamaño del bulto',    false],
  ['pzs_bulto_compra','qtyCtn',      'Piezas por bulto',    true],
  ['volumen_compra',  'cbm',         'Cubicaje',            true],
  ['mfr_catalog',     'factory',     'Código de fábrica',   false]
];

function _rpoIgual(a, b, numerico){
  if(numerico){
    var na=Number(a)||0, nb=Number(b)||0;
    return Math.abs(na-nb) < 0.0001;
  }
  return _bkNorm(a)===_bkNorm(b);
}

async function _rpoCargar(input){
  var file=input && input.files && input.files[0];
  input.value='';
  if(!file) return;
  var d=window._ocDatos; if(!d) return;
  _ocMsg('Leyendo el Revised PO '+_esc(file.name)
    + (/\.pdf$/i.test(file.name||'') ? ' con IA, esto tarda unos segundos…' : '…'));
  try{
    var fichas=await _rpoFichas(file);
    d.rpo=_rpoComparar(d, fichas, file.name);
    _ocMsg(d.rpo.total
      ? ('Revised PO leído: '+d.rpo.total+' diferencia(s). Revísalas abajo.')
      : 'El Revised PO coincide con la orden en todo.', 'ok');
    _ocPintarTodo();
  }catch(e){
    _ocMsg('No pude leer el Revised PO: '+_esc(e.message||e),'err');
    console.warn('[RPO]', e);
  }
}

function _rpoComparar(d, fichas, nombre){
  var r={nombre:nombre, cambios:[], nuevas:[], faltan:[], iguales:0, total:0};
  var vistos={};

  // Índice propio, normalizado. El lector guarda las fichas con el código
  // tal cual viene del Excel, y basta un guion o un espacio de más para que
  // no empareje nada: salían los 16 artículos como «nuevos».
  var idx={};
  Object.keys(fichas).forEach(function(k){
    idx[_ocNormSku(fichas[k].itemcode || k)]=fichas[k];
  });
  fichas=idx;

  var _cod=Object.keys(fichas);
  r.emparejadas=[];
  d.lineas.forEach(function(l, i){
    var k=_ocNormSku(l.itemcode);
    var f=fichas[k];
    if(!f){
      // El escáner parte el código en dos líneas y se pierde el prefijo
      var m=_refEmparejar(_cod, l.itemcode);
      if(m && fichas[m.codigo]){
        f=fichas[m.codigo]; k=m.codigo;
        if(m.modo!=='exacta'){
          r.emparejadas.push({sap:l.itemcode, archivo:m.codigo, modo:m.modo});
        }
      }
    }
    if(!f){ r.faltan.push({i:i, itemcode:l.itemcode, nombre:l.itemname}); return; }
    vistos[k]=1;
    var cambio=false;
    RPO_CAMPOS.forEach(function(par){
      var campo=par[0], col=par[1], tit=par[2], num=par[3];
      if(f[col]===undefined) return;                 // no viene en el archivo
      var antes=l[campo], ahora=f[col];
      if(String(antes||'').trim()==='' && String(ahora||'').trim()==='') return;
      if(_rpoIgual(antes, ahora, num)) return;
      r.cambios.push({i:i, itemcode:l.itemcode, campo:campo, tit:tit,
                      antes:antes, ahora:ahora, num:num, aplicar:true});
      cambio=true;
    });
    if(!cambio) r.iguales++;
  });

  Object.keys(fichas).forEach(function(k){
    if(vistos[k]) return;
    if(d.lineas.some(function(l){ return _ocNormSku(l.itemcode)===k; })) return;
    var f=fichas[k];
    r.nuevas.push({itemcode:f.itemcode||k, nombre:f.esp||f.ing||'',
                   cantidad:f.cantidad, precio:f.precio});
  });

  r.total=r.cambios.length + r.nuevas.length + r.faltan.length;
  return r;
}

// ── El bloque del Revised PO en la pantalla ─────────────────────────────
function _ocBloqueRPO(d){
  var r=d.rpo;
  var h=_ocCabBloque('orden','2c · Revised PO',
      r ? ('comparado: '+_esc(r.nombre)) : 'opcional · la orden que devolvió el proveedor',
      _ocInsignia(r?(r.total? (r.total+' diferencia(s)') : 'Sin cambios')
                    :'Sin Revised PO', !!r && !!r.total));
  h+='<div style="border:1px solid '+OC_COLOR.orden.bd+';border-top:none;'
    +'border-radius:0 0 10px 10px;padding:12px 13px;background:var(--surface-1);'
    +'margin-bottom:16px">';

  if(!r){
    h+='<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 10px;line-height:1.5">'
      +'Si el proveedor devolvió la orden con cambios, súbela aquí. Se compara '
      +'con lo que hay arriba y se enseñan las diferencias una por una, para '
      +'aprobar solo las que quieras.</p>'
      +'<input type="file" id="ocRpoFile" accept=".xlsx,.pdf" style="display:none" '
      +'onchange="_rpoCargar(this)">'
      +'<button class="xb" onclick="document.getElementById(\'ocRpoFile\').click()">'
      +'<i class="ti ti-file-diff"></i> Subir el Revised PO</button>';
    return h+'</div>';
  }

  if(!r.total){
    h+='<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde)">'
      +'<i class="ti ti-circle-check"></i> El Revised PO coincide con la orden en '
      +'las '+r.iguales+' líneas. No hay nada que aprobar.</div>';
    h+=_rpoBotones(false);
    return h+'</div>';
  }

  // Los cambios, agrupados por campo
  var porCampo={};
  r.cambios.forEach(function(c){ (porCampo[c.tit]=porCampo[c.tit]||[]).push(c); });

  // Antes de nada, la consecuencia: cómo queda la orden si se aplica
  h+=_rpoResumen(d, r);

  h+='<div style="background:var(--pastel-aviso);border:0.5px solid #E0A82E;'
    +'border-radius:10px;padding:11px 14px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'font-size:12.5px;font-weight:700;color:var(--t-marron);margin-bottom:9px">'
    +'<i class="ti ti-arrows-diff"></i> '+r.total+' diferencia(s) con el Revised PO'
    +'<span style="flex:1"></span>'
    +'<button class="xb" style="font-size:10.5px;padding:2px 9px" '
    +'onclick="_rpoMarcarTodo(true)">Aprobar todas</button>'
    +'<button class="xb" style="font-size:10.5px;padding:2px 9px" '
    +'onclick="_rpoMarcarTodo(false)">Ninguna</button></div>';

  Object.keys(porCampo).forEach(function(tit){
    var lista=porCampo[tit];
    h+='<div style="margin-bottom:9px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);'
      +'margin-bottom:3px">'+_esc(tit)+' ('+lista.length+')</div>';
    lista.slice(0,15).forEach(function(c){
      var idx=r.cambios.indexOf(c);
      h+='<label style="display:flex;align-items:center;gap:8px;font-size:11.5px;'
        +'padding:3px 0;cursor:pointer">'
        +'<input type="checkbox" '+(c.aplicar?'checked':'')+' '
        +'onchange="_rpoMarcar('+idx+',this.checked)">'
        +'<b style="min-width:110px">'+_esc(c.itemcode)+'</b>'
        +'<span style="text-decoration:line-through;opacity:.6;max-width:210px;'
        +'overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'
        +_esc(String(c.antes||'(vacío)'))+'</span>'
        +'<span>→</span>'
        +'<b style="max-width:230px;overflow:hidden;text-overflow:ellipsis;'
        +'white-space:nowrap">'+_esc(String(c.ahora))+'</b></label>';
    });
    if(lista.length>15) h+='<div style="font-size:11px;color:var(--text-muted)">'
      +'… y '+(lista.length-15)+' más, que se aplican igual</div>';
    h+='</div>';
  });

  if(r.nuevas.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-bottom:6px">'
      +'<b>Solo en el Revised PO ('+r.nuevas.length+')</b> · se añadirán:<br>'
      + r.nuevas.slice(0,8).map(function(x){
          return '· '+_esc(x.itemcode)+' '+_esc(String(x.nombre||'').slice(0,28))
            +' — '+_fmtN2(x.cantidad)+' × '+_fmtN2(x.precio); }).join('<br>')
      +'</div>';
  }
  if(r.faltan.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron)">'
      +'<b>No están en el Revised PO ('+r.faltan.length+')</b> · se QUITARÁN '
      +'de la orden:<br>'
      + r.faltan.slice(0,8).map(function(x){
          return '· '+_esc(x.itemcode)+' '+_esc(String(x.nombre||'').slice(0,28));
        }).join('<br>')
      +'</div>';
  }
  h+='</div>';
  h+=_rpoBotones(true);
  return h+'</div>';
}

function _rpoBotones(hayCambios){
  var d=window._ocDatos||{};
  var r=d.rpo||{};
  return '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">'
    + (r.aplicado
       ? '<span style="font-size:11.5px;color:var(--t-verde)">'
         +'<i class="ti ti-circle-check"></i> Aplicado: la tabla de arriba ya es '
         +'la del Revised PO.</span>'
       : (hayCambios
          ? ('<button class="btn bp" onclick="_rpoAplicar()">'
             +'<i class="ti ti-check"></i> Aplicar lo aprobado</button>')
          : ''))
    +'<span style="flex:1"></span>'
    +'<button class="xb" style="color:var(--text-danger)" onclick="_rpoQuitar()">'
    +'<i class="ti ti-x"></i> Quitar el Revised PO</button></div>';
}

function _rpoMarcar(i, v){
  var r=(window._ocDatos||{}).rpo; if(!r || !r.cambios[i]) return;
  r.cambios[i].aplicar=!!v;
}

function _rpoMarcarTodo(v){
  var r=(window._ocDatos||{}).rpo; if(!r) return;
  r.cambios.forEach(function(c){ c.aplicar=!!v; });
  _ocPintarTodo();
}

function _rpoQuitar(){
  var d=window._ocDatos; if(!d) return;
  if(d.rpo && d.rpo.aplicado
     && !confirm('El Revised PO ya se aplicó. Quitarlo NO deshace los cambios. ¿Sigo?')) return;
  delete d.rpo;
  _ocPintarTodo();
}

async function _rpoAplicar(){
  var d=window._ocDatos; if(!d || !d.rpo) return;
  var r=d.rpo;
  var marcados=r.cambios.filter(function(c){ return c.aplicar; });
  if(!marcados.length && !r.nuevas.length){
    showT('No hay ninguna diferencia aprobada'); return;
  }

  var aviso='APLICAR EL REVISED PO\n\n'
    + marcados.length+' cambio(s) aprobados\n'
    + (r.cambios.length-marcados.length ? (r.cambios.length-marcados.length)
        +' sin aprobar, se quedan como están\n' : '')
    + (r.nuevas.length ? r.nuevas.length+' línea(s) que se AÑADEN\n' : '')
    + (r.faltan.length ? r.faltan.length+' línea(s) que se QUITAN: no vienen '
        +'en el Revised PO\n' : '')
    + '\nLa orden pasará a ser la del Revised PO: '
    + (d.lineas.length - r.faltan.length + r.nuevas.length)+' línea(s).\n'
    + '\n¿Sigo?';
  if(!confirm(aviso)) return;

  // 1. Los cambios aprobados
  marcados.forEach(function(c){
    var l=d.lineas[c.i];
    if(l) l[c.campo]=c.ahora;
  });

  // 2. El Revised PO MANDA: la orden pasa a ser la suya. Lo que no viene en
  // él se quita, no se conserva. Antes se sumaban las nuevas a las viejas y
  // salía una orden que no era ni la una ni la otra.
  var fuera=r.faltan.map(function(x){ return x.i; });
  if(fuera.length){
    d.lineas=d.lineas.filter(function(l, i){ return fuera.indexOf(i)<0; });
  }

  // 3. Y lo que solo estaba en el Revised PO se añade
  var grupoBase=(d.lineas[0]||{}).grupo||'';
  r.nuevas.forEach(function(x){
    d.lineas.push(_ocRellenarItem({
      itemcode:x.itemcode, itemname:x.nombre||x.itemcode,
      cantidad:Number(x.cantidad)||0, precio:Number(x.precio)||0,
      grupo:grupoBase
    }, d.k||_txtFijosGuardados()));
  });

  r.aplicado=true;
  _ocMsg('Aplicando el Revised PO…');
  try{ await _ocComprobar(d); }catch(e){ console.warn('[RPO] comprobar:', e); }
  try{ await _ocReunirFotos(d); }catch(e){ console.warn('[RPO] fotos:', e); }
  try{ await _ocRevisarBarcodes(d); }catch(e){ console.warn('[RPO] barcodes:', e); }

  _ocMsg('✓ Revised PO aplicado · '+marcados.length+' cambio(s) · '
    +d.lineas.length+' línea(s) en la orden','ok');
  _ocPintarTodo();
}

// ── Traducir la composición al español ──────────────────────────────────
// Las proformas dan el material en inglés —«60%PP+40%GLASS LINER»— y en SAP
// hacen falta las dos: la inglesa tal cual y la española. Se traduce
// respetando los porcentajes y los separadores.
var COMP_ES={
  // Textiles
  'POLYESTER':'poliéster', 'POLYESTHER':'poliéster', 'PES':'poliéster',
  'COTTON':'algodón', 'VISCOSE':'viscosa', 'RAYON':'rayón',
  'ACRYLIC':'acrílico', 'NYLON':'nylon', 'POLYAMIDE':'poliamida',
  'WOOL':'lana', 'SILK':'seda', 'LINEN':'lino', 'FLAX':'lino',
  'SPANDEX':'elastano', 'ELASTANE':'elastano', 'LYCRA':'elastano',
  'JUTE':'yute', 'SISAL':'sisal', 'COIR':'fibra de coco', 'HEMP':'cáñamo',
  'CHENILLE':'chenilla', 'MICROFIBER':'microfibra', 'MICROFIBRE':'microfibra',
  'FELT':'fieltro', 'VELVET':'terciopelo', 'CANVAS':'lona',
  'POLYPROPYLENE':'polipropileno',
  // Plásticos y derivados
  'PP':'polipropileno', 'PE':'polietileno', 'PVC':'PVC', 'ABS':'ABS',
  'PET':'PET', 'PU':'poliuretano', 'POLYURETHANE':'poliuretano',
  'PLASTIC':'plástico', 'ACRYLONITRILE':'acrilonitrilo',
  'SILICONE':'silicona', 'RESIN':'resina', 'MELAMINE':'melamina',
  'FOAM':'espuma', 'SPONGE':'esponja',
  // Metales
  'STAINLESS STEEL':'acero inoxidable', 'STAINLESS':'acero inoxidable',
  'STEEL':'acero', 'IRON':'hierro', 'ALUMINUM':'aluminio',
  'ALUMINIUM':'aluminio', 'BRASS':'latón', 'COPPER':'cobre',
  'ZINC':'zinc', 'CHROME':'cromo', 'METAL':'metal',
  // Otros
  'GLASS':'vidrio', 'CERAMIC':'cerámica', 'PORCELAIN':'porcelana',
  'STONEWARE':'gres', 'BAMBOO':'bambú', 'WOOD':'madera', 'MDF':'MDF',
  'RUBBER':'caucho', 'LEATHER':'cuero', 'PAPER':'papel',
  'MARBLE':'mármol', 'CEMENT':'cemento', 'CLAY':'arcilla',
  'LINER':'forro', 'COATING':'recubrimiento', 'COATED':'recubierto',
  'HANDLE':'asa', 'LID':'tapa', 'BODY':'cuerpo', 'BACKING':'respaldo',
  'PILE':'pelo', 'FRAME':'estructura', 'FILLING':'relleno'
};

// Las claves más largas primero: «STAINLESS STEEL» antes que «STEEL», o
// quedaría «acero inoxidable» convertido en «acero inoxidable inoxidable».
var COMP_ORDEN=Object.keys(COMP_ES).sort(function(a,b){ return b.length-a.length; });

function _traducirComposicion(txt){
  var t=String(txt||'').trim();
  if(!t) return '';
  // Si ya está en español, no se toca
  if(/[áéíóúñ]/i.test(t)) return t;

  var res=t, hubo=false;
  COMP_ORDEN.forEach(function(en){
    // Palabra entera, sin distinguir mayúsculas
    var re=new RegExp('(^|[^A-Za-z])'+en.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')
                      +'(?![A-Za-z])', 'gi');
    if(re.test(res)){
      res=res.replace(re, function(m, antes){ return antes+COMP_ES[en]; });
      hubo=true;
    }
  });
  // Los conectores, que si no quedan a medias
  res=res.replace(/(^|[^A-Za-z])WITH(?![A-Za-z])/gi, '$1con')
         .replace(/(^|[^A-Za-z])AND(?![A-Za-z])/gi, '$1y')
         .replace(/(^|[^A-Za-z])OF(?![A-Za-z])/gi, '$1de');

  // El español pone el sustantivo delante: «vidrio forro» suena a máquina,
  // «forro de vidrio» es como se escribe.
  var PARTES='forro|recubrimiento|respaldo|relleno|pelo|asa|tapa|cuerpo|estructura|esponja|espuma';
  res=res.replace(new RegExp('([a-záéíóúñ]+)\\s+('+PARTES+')(?![a-záéíóúñ])','gi'),
                  function(m, mat, parte){
    if(new RegExp('^('+PARTES+')$','i').test(mat)) return m;   // ya lo está
    return parte+' de '+mat;
  });

  return hubo ? res.replace(/\s{2,}/g,' ').trim() : t;
}

// Cómo queda la orden si se aplica el Revised PO. Se enseña ANTES de la
// lista de diferencias: lo primero que hay que ver es la consecuencia.
function _rpoResumen(d, r){
  var antesN=d.lineas.length;
  var despuesN=antesN - r.faltan.length + r.nuevas.length;
  var tot=function(ls){
    return ls.reduce(function(a,l){
      return a+(Number(l.cantidad)||0)*(Number(l.precio)||0); },0);
  };
  var antesT=tot(d.lineas);

  // El total de después: las que se quedan con sus valores nuevos, más las
  // que entran
  var fuera={}; r.faltan.forEach(function(x){ fuera[x.i]=1; });
  var nuevosValores={};
  r.cambios.forEach(function(c){
    if(!c.aplicar) return;
    if(c.campo==='cantidad' || c.campo==='precio'){
      (nuevosValores[c.i]=nuevosValores[c.i]||{})[c.campo]=Number(c.ahora)||0;
    }
  });
  var despuesT=0;
  d.lineas.forEach(function(l,i){
    if(fuera[i]) return;
    var v=nuevosValores[i]||{};
    despuesT += (v.cantidad!=null?v.cantidad:(Number(l.cantidad)||0))
              * (v.precio  !=null?v.precio  :(Number(l.precio)||0));
  });
  r.nuevas.forEach(function(x){
    despuesT += (Number(x.cantidad)||0)*(Number(x.precio)||0);
  });

  var dif=despuesT-antesT;
  var caja=function(tit, n, t, col){
    return '<div style="flex:1;min-width:150px;background:var(--surface-0);'
      +'border:0.5px solid var(--border);border-radius:9px;padding:9px 12px">'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:2px">'
      +_esc(tit)+'</div>'
      +'<div style="font-size:15px;font-weight:700;color:'+col+'">'+_fmtN2(t)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)">'+n+' línea(s)</div></div>';
  };

  return '<div style="margin-bottom:11px">'
    +'<div style="font-size:11.5px;color:var(--text-secondary);margin-bottom:6px">'
    +'<b>El Revised PO manda:</b> la orden pasará a ser la suya. Lo que no venga '
    +'en él se quita.</div>'
    +'<div style="display:flex;gap:9px;align-items:stretch;flex-wrap:wrap">'
    + caja('La orden ahora', antesN, antesT, 'var(--text-secondary)')
    +'<div style="display:flex;align-items:center;font-size:20px;'
    +'color:var(--text-muted)">→</div>'
    + caja('Con el Revised PO', despuesN, despuesT,
           dif>0?'var(--t-rojo)':(dif<0?'var(--t-verde)':'var(--text-primary)'))
    +'<div style="flex:1;min-width:150px;background:'
    + (Math.abs(dif)<0.005 ? 'var(--surface-0)' : 'var(--pastel-aviso)')
    +';border:0.5px solid var(--border);border-radius:9px;padding:9px 12px">'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:2px">'
      +'Diferencia</div>'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)">'
      +(dif>=0?'+':'')+_fmtN2(dif)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)">'
      + (despuesN-antesN>=0?'+':'')+(despuesN-antesN)+' línea(s)</div></div>'
    +'</div></div>';
}

// Abre el asistente desde una orden borrador ya con el Revised PO pedido:
// es el mismo camino que SUBIR A SAP, pero yendo directo a la comparación.
async function _rpoDesdeBorrador(ref){
  await _ocDesdeNoSap(ref);
  // Se espera a que la pantalla esté montada para abrir el selector
  setTimeout(function(){
    var f=document.getElementById('ocRpoFile');
    if(f){ f.click(); return; }
    showT('Sube el Revised PO en el bloque «2c» de la pantalla');
  }, 900);
}

/* ═══════════════════════════════════════════════════════════════════════════
   EL REPARTO DE LA FACTURA ENTRE LAS ÓRDENES
   ───────────────────────────────────────────────────────────────────────────
   Una factura de $100.000 puede cubrir tres órdenes: DKC-40 $4.000,
   DKC-60 $50.000 y DKC-80 $46.000. Aquí se dice cuánto lleva cada una y se
   comprueba que la suma cuadre con el total de la factura.

   Después, la cancelación se pide UNA vez por el total, detallando el
   reparto, en vez de una solicitud por orden.
   ═══════════════════════════════════════════════════════════════════════════ */

// Lo que suman las líneas de cada orden, que es la propuesta de partida
function _frPorOrden(){
  var d=window._fr; if(!d) return {};
  var acc={};
  d.lineas.forEach(function(l){
    var k=String(l.docnum);
    acc[k]=(acc[k]||0)+(Number(l.cantidad)||0)*(Number(l.precio)||0);
  });
  return acc;
}

// El reparto vivo: lo escrito a mano manda; lo que no, sale de las líneas
function _frReparto(){
  var d=window._fr; if(!d) return [];
  var porLinea=_frPorOrden();
  d._reparto=d._reparto||{};
  return d.ordenes.map(function(o){
    var k=String(o.docnum);
    var propuesto=Number(porLinea[k]||0);
    var puesto=d._reparto[k];
    return {docnum:o.docnum, dkc:o.numatcard||'',
            propuesto:propuesto,
            monto:(puesto!=null && puesto!=='') ? Number(puesto)||0 : propuesto};
  });
}

function _frRepartoSet(docnum, valor){
  var d=window._fr; if(!d) return;
  d._reparto=d._reparto||{};
  d._reparto[String(docnum)]=valor;
  _frRepartoPintar();
}

function _frRepartoIgualar(){
  var d=window._fr; if(!d) return;
  d._reparto={};                      // vuelve a lo que suman las líneas
  rFactReserva();
}

// La suma del reparto contra el total de la factura
function _frRepartoCuadre(){
  var rep=_frReparto();
  var suma=rep.reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
  var total=Number((window._fr||{}).total_factura);
  if(!total && total!==0) total=_frTotal();
  return {suma:suma, total:total, dif:suma-total, cuadra:Math.abs(suma-total)<0.005};
}

function _frRepartoPintar(){
  var c=_frRepartoCuadre();
  var e=document.getElementById('frCuadre');
  if(!e) return;
  e.innerHTML = c.cuadra
    ? ('<span style="color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
       +'Cuadra: '+_fmtN2(c.suma)+'</span>')
    : ('<span style="color:var(--t-rojo)"><i class="ti ti-alert-triangle"></i> '
       +'Repartido '+_fmtN2(c.suma)+' de '+_fmtN2(c.total)+' · '
       +(c.dif>0?'sobran ':'faltan ')+_fmtN2(Math.abs(c.dif))+'</span>');
}

function _frBloqueReparto(){
  var d=window._fr; if(!d || !d.ordenes.length) return '';
  var rep=_frReparto();
  var c=_frRepartoCuadre();

  var h='<div style="background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:11px;padding:12px 14px;margin-bottom:12px">'
    +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'margin-bottom:8px">'
    +'<div style="font-size:12.5px;font-weight:700">'
    +'<i class="ti ti-arrows-split"></i> Reparto entre las órdenes</div>'
    +'<span style="font-size:11px;color:var(--text-muted)">Cuánto de esta '
    +'factura corresponde a cada DKC</span>'
    +'<span style="flex:1"></span>'
    +'<button class="xb" style="font-size:10.5px;padding:2px 9px" '
    +'onclick="_frRepartoIgualar()">Recalcular por líneas</button></div>';

  h+='<div style="display:flex;gap:9px;flex-wrap:wrap;align-items:flex-end">';
  h+='<div style="min-width:170px">'
    +'<label style="font-size:10.5px;color:var(--text-muted)">'
    +'Total de la factura</label>'
    +'<input id="frTotalFactura" value="'+_esc(_fmtN2(c.total))+'" '
    +'onchange="window._fr.total_factura=parseFloat(String(this.value).replace(/[^0-9.-]/g,\'\'))||0;'
    +'_frRepartoPintar()" '
    +'style="width:100%;padding:7px 10px;border:1px solid var(--t-ambar);'
    +'border-radius:7px;font-size:13px;font-weight:700;margin-top:3px"></div>';

  rep.forEach(function(x){
    h+='<div style="min-width:150px">'
      +'<label style="font-size:10.5px;color:var(--text-muted)">'
      +'#'+_esc(x.docnum)+(x.dkc?(' · '+_esc(x.dkc)):'')+'</label>'
      +'<input value="'+_esc(_fmtN2(x.monto))+'" '
      +'onchange="_frRepartoSet(\''+_esc(String(x.docnum))+'\', '
      +'parseFloat(String(this.value).replace(/[^0-9.-]/g,\'\'))||0)" '
      +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);'
      +'border-radius:7px;font-size:12.5px;margin-top:3px">'
      + (Math.abs(x.monto-x.propuesto)>0.005
         ? ('<div style="font-size:10px;color:var(--text-muted);margin-top:2px">'
            +'las líneas suman '+_fmtN2(x.propuesto)+'</div>')
         : '')
      +'</div>';
  });
  h+='</div>';
  h+='<div id="frCuadre" style="font-size:12px;font-weight:600;margin-top:9px"></div>';
  return h+'</div>';
}

// ── Una sola solicitud de cancelación por toda la factura ───────────────
// Antes había que pedir una por cada DKC. Ahora va una, por el total, con
// el desglose de qué corresponde a cada orden.
async function _frPedirCancelacion(){
  var d=window._fr; if(!d) return;
  var rep=_frReparto().filter(function(x){ return Number(x.monto)>0; });
  if(!rep.length){ _frMsg('No hay ningún reparto con monto.','err'); return; }
  var c=_frRepartoCuadre();
  if(!c.cuadra){
    if(!confirm('El reparto no cuadra con el total de la factura:\n\n'
      +'  repartido  '+_fmtN2(c.suma)+'\n'
      +'  factura    '+_fmtN2(c.total)+'\n'
      +'  diferencia '+_fmtN2(c.dif)+'\n\n'
      +'¿Mando la solicitud igualmente?')) return;
  }

  var detalle=rep.map(function(x){
    return (x.dkc||('#'+x.docnum))+': '+_fmtN2(x.monto); }).join('\n');
  var resumen='SOLICITUD DE CANCELACIÓN\n\n'
    +'Factura de reserva: '+(d.num_factura||'(sin número)')+'\n'
    +'Proveedor: '+(d.cardname||d.cardcode||'')+'\n\n'
    +detalle+'\n\n'
    +'Total por cancelar: '+_fmtN2(c.suma)+'\n\n'
    +'Se manda UNA sola solicitud a contabilidad. ¿Sigo?';
  if(!confirm(resumen)) return;

  _frMsg('Enviando la solicitud a contabilidad…');
  try{
    var texto='Factura de reserva: '+(d.num_factura||'')+'\n'
      +'Proveedor: '+(d.cardname||d.cardcode||'')+'\n'
      + rep.map(function(x){
          return (x.dkc||('#'+x.docnum))+': '+_fmtN2(x.monto); }).join('\n')
      +'\nTotal por cancelar: '+_fmtN2(c.suma);

    // Se cuelga de la PRIMERA orden, que es la que abre la solicitud, pero
    // el detalle lleva todas: contabilidad ve de un vistazo qué cubre.
    var principal=rep[0];
    var fila={
      docnum: String(principal.dkc||principal.docnum),
      tipo:'cancelacion',
      monto:c.suma,
      proveedor:d.cardname||d.cardcode||'',
      dept:(d.dept||''),
      nota:texto,
      estado:'pendiente',
      solicitado_por:(CU&&CU.name)||'',
      solicitado_en:new Date().toISOString()
    };
    var r=await fetch(SB+'/rest/v1/solicitudes_pago',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      throw new Error(r.status+' '+t.slice(0,150));
    }
    var creada=(await r.json()||[])[0]||{};

    // Y el aviso a contabilidad, como en las demás solicitudes
    var destinos=_avUsuariosPorRol('contabilidad');
    if(destinos.length){
      try{
        await _avSolicitud(destinos, creada,
          'Cancelación de la factura '+(d.num_factura||'')+' · '
          +rep.length+' orden(es) · '+_fmtN2(c.suma),
          'Solicitud de cancelación');
      }catch(e){ console.warn('[FR] aviso:', e); }
    }

    d._solicitada=true;
    _frMsg('✓ Solicitud enviada a contabilidad'
      + (destinos.length ? (': '+destinos.map(function(u){ return u.name; }).join(', ')) : '')
      + ' · '+rep.length+' orden(es) · '+_fmtN2(c.suma), 'ok');
    try{
      _okGrande('Cancelación solicitada',
        '<b>'+_esc(d.num_factura||'')+'</b><br>'
        + rep.length+' orden(es) · '+_fmtN2(c.suma)+'<br>'
        +'<span style="font-size:11.5px;color:var(--text-muted)">'
        +'Una sola solicitud con el desglose por DKC.</span>');
    }catch(e){}
    rFactReserva();
  }catch(e){
    _frMsg('No se pudo enviar la solicitud: '+_esc(e.message||e),'err');
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   REVISED PO CONTRA UNA ORDEN QUE YA ESTÁ EN SAP
   ───────────────────────────────────────────────────────────────────────────
   Se sube la orden revisada, se compara con lo que hay hoy en SAP y se
   enseñan las diferencias. Lo que se apruebe se aplica a la orden REAL por
   DI API: cambia cantidades y precios, añade líneas y quita las que ya no
   vienen.

   Lo que NO se puede tocar desde aquí son los datos del artículo —color,
   composición, código de barras—: eso es la ficha del artículo, no la
   orden, y se cambia en la pantalla de artículos.
   ═══════════════════════════════════════════════════════════════════════════ */

window._rev = window._rev || null;

function _revPuede(){
  return !!(CU && (_esCompras() || CU.role==='gerencia' || CU.role==='importacion'));
}

// El botón, en la orden de SAP, encima del de factura reserva
function _revBarraOrden(o){
  try{
    if(!o || o._noSap || !_revPuede()) return '';
    var docnum=String(o.id||'').trim();
    if(!/^\d+$/.test(docnum)) return '';
    return '<div style="display:flex;align-items:center;gap:11px;flex-wrap:wrap;'
      +'background:var(--surface-1);border:1px solid var(--border);border-radius:11px;'
      +'padding:10px 14px;margin-bottom:12px">'
      +'<i class="ti ti-refresh" style="font-size:19px;color:var(--t-marron)"></i>'
      +'<div style="flex:1;min-width:190px;font-size:12px">'
      +'¿Cambió algo después de subirla? Precios, pesos, cubicajes, descripciones… '
      +'Edítalo aquí y se actualiza en SAP por DI API.</div>'
      +'<button class="btn bp" style="background:var(--t-marron);padding:8px 16px" '
      +'onclick="_reoAbrir(\''+docnum+'\')"><i class="ti ti-refresh"></i> '
      +'RE ACTUALIZAR EN SAP</button></div>'
      +'<div style="display:flex;align-items:center;gap:11px;flex-wrap:wrap;'
      +'background:var(--pastel-aviso);border:1px solid #E0A82E;border-radius:11px;'
      +'padding:10px 14px;margin-bottom:12px">'
      +'<i class="ti ti-file-diff" style="font-size:19px;color:var(--t-marron)"></i>'
      +'<div style="flex:1;min-width:190px;font-size:12px;color:var(--t-marron)">'
      +'¿El proveedor devolvió la orden con cambios? Súbela y se compara con lo '
      +'que hay en SAP; tú apruebas y se aplica.</div>'
      +'<input type="file" id="revFile'+_esc(docnum)+'" accept=".xlsx,.pdf" '
      +'style="display:none" onchange="_revCargar(this,\''+_esc(docnum)+'\')">'
      +'<button class="btn bp" style="font-size:12.5px;font-weight:700;'
      +'padding:8px 15px;background:#B45309" '
      +'onclick="event.stopPropagation();'
      +'document.getElementById(\'revFile'+_esc(docnum)+'\').click()">'
      +'<i class="ti ti-file-diff"></i> REVISED PO</button></div>';
  }catch(e){ console.warn('[REV] barra:', e); return ''; }
}

// Lee el Revised PO y lo compara con las líneas que hay hoy en SAP
async function _revCargar(input, docnum){
  var file=input && input.files && input.files[0];
  input.value='';
  if(!file) return;
  showT(/\.pdf$/i.test(file.name||'')
    ? 'Leyendo el Revised PO con IA, esto tarda unos segundos…'
    : 'Leyendo el Revised PO…', 9000);
  try{
    var r=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'
      +encodeURIComponent(docnum)+'&order=linenum&limit=500',{headers:SBH});
    if(!r.ok) throw new Error('no pude leer las líneas de la orden ('+r.status+')');
    var ls=await r.json()||[];
    if(!ls.length) throw new Error('la orden #'+docnum+' no tiene líneas en el portal');

    var fichas=await _rpoFichas(file);
    // Índice normalizado: el lector guarda el código tal cual viene
    var _tot=fichas.__totales||null;
    var idx={};
    Object.keys(fichas).forEach(function(k){
      if(k==='__totales') return;
      idx[_ocNormSku(fichas[k].itemcode || k)]=fichas[k];
    });

    // Las referencias del archivo, para emparejarlas con tolerancia
    var _codigosRev=Object.keys(idx);

    var enSap=ls.map(function(l){
      return {linenum:l.linenum, itemcode:l.itemcode,
              nombre:l.itemname||l.dscription||'',
              cantidad:Number(l.cantidad!=null?l.cantidad:l.quantity)||0,
              abierta:Number(l.cantidad_pendiente!=null?l.cantidad_pendiente
                             :(l.openqty!=null?l.openqty:l.cantidad))||0,
              precio:Number(l.precio!=null?l.precio:l.price)||0};
    });

    var rev={docnum:docnum, archivo:file.name, cambios:[], nuevas:[], quitar:[],
             iguales:0, lineas:enSap};
    var vistos={};

    rev.emparejadas=[];
    enSap.forEach(function(l){
      var k=_ocNormSku(l.itemcode);
      var f=idx[k];
      if(!f){
        // El escáner parte el código: «BA-319994» llega como «319994»
        var m=_refEmparejar(_codigosRev, l.itemcode);
        if(m){
          f=idx[_ocNormSku(m.codigo)] || idx[m.codigo];
          if(f){
            k=_ocNormSku(m.codigo);
            if(m.modo!=='exacta'){
              rev.emparejadas.push({sap:l.itemcode, archivo:m.codigo, modo:m.modo});
            }
          }
        }
      }
      if(!f){
        rev.quitar.push({linenum:l.linenum, itemcode:l.itemcode,
                         nombre:l.nombre, cantidad:l.cantidad,
                         servida:l.cantidad-l.abierta, aplicar:true});
        return;
      }
      vistos[k]=1;
      var hubo=false;
      [['cantidad','cantidad','Cantidad'],['precio','precio','Precio']]
        .forEach(function(par){
          var antes=Number(l[par[0]])||0, ahora=Number(f[par[1]])||0;
          if(f[par[1]]===undefined) return;
          if(Math.abs(antes-ahora)<0.0001) return;
          rev.cambios.push({linenum:l.linenum, itemcode:l.itemcode,
                            nombre:l.nombre, campo:par[0], tit:par[2],
                            antes:antes, ahora:ahora, aplicar:true,
                            servida:l.cantidad-l.abierta});
          hubo=true;
        });
      if(!hubo) rev.iguales++;
    });

    Object.keys(idx).forEach(function(k){
      if(vistos[k]) return;
      var f=idx[k];
      rev.nuevas.push({itemcode:f.itemcode||k, nombre:f.esp||f.ing||'',
                       cantidad:Number(f.cantidad)||0,
                       precio:Number(f.precio)||0, aplicar:true});
    });

    // Los totales: las líneas cambian una cosa y los cargos otra. Un coste
    // de etiquetas no es ninguna línea y sube la orden igual.
    var totalSap=enSap.reduce(function(a,l){ return a+l.cantidad*l.precio; },0);
    var sumaRev=Object.keys(idx).reduce(function(a,k){
      var f=idx[k]; return a+(Number(f.cantidad)||0)*(Number(f.precio)||0); },0);
    rev.totales={
      sap:totalSap,
      lineas:(_tot && _tot.suma_lineas) || sumaRev,
      cargos:(_tot && _tot.cargos) || [],
      total:(_tot && _tot.total) || sumaRev
    };
    rev.totales.difCargos=rev.totales.cargos.reduce(function(a,c){
      return a+(Number(c.monto)||0); },0);
    // Si el documento da un total mayor que la suma de líneas y no listó los
    // cargos, se deja constancia del hueco en vez de pasarlo por alto.
    var hueco=rev.totales.total - rev.totales.lineas - rev.totales.difCargos;
    if(Math.abs(hueco)>0.5){
      rev.totales.cargos=rev.totales.cargos.concat(
        [{concepto:'sin identificar en el documento', monto:hueco}]);
      rev.totales.difCargos+=hueco;
    }
    rev.totales.dif=rev.totales.total - totalSap;

    rev.total=rev.cambios.length+rev.nuevas.length+rev.quitar.length
              + (Math.abs(rev.totales.dif)>0.5 ? 1 : 0);
    window._rev=rev;
    _revPanel();
  }catch(e){
    showT('No pude leer el Revised PO: '+(e.message||e), 9000);
    console.warn('[REV]', e);
  }
}

// El panel de aprobación. Nada se manda hasta que se aprueba aquí.
function _revPanel(){
  var r=window._rev; if(!r) return;
  var ov=document.createElement('div');
  ov.id='modalRev';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10055;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;'
      +'padding:18px 20px;width:100%;max-width:980px;max-height:88vh;'
      +'display:flex;flex-direction:column">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;'
      +'margin-bottom:6px">'
      +'<div style="font-size:15px;font-weight:700">'
      +'<i class="ti ti-file-diff"></i> Revised PO · orden #'+_esc(r.docnum)+'</div>'
      +'<button onclick="_revCerrar()" style="background:none;border:none;'
      +'font-size:24px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
      +'Comparado con lo que hay ahora en SAP · '+_esc(r.archivo)+'</div>'
    +'<div id="revCuerpo" style="overflow-y:auto;flex:1"></div>'
    +'<div style="display:flex;gap:9px;margin-top:12px;flex-wrap:wrap;'
      +'align-items:center">'
      +'<button class="xb" onclick="_revMarcarTodo(true)">Aprobar todo</button>'
      +'<button class="xb" onclick="_revMarcarTodo(false)">Ninguno</button>'
      +'<span style="flex:1"></span>'
      +'<span id="revResumen" style="font-size:12px"></span>'
      +'<button class="btn bp" style="background:#B45309;font-weight:700" '
      +'onclick="_revAplicar()"><i class="ti ti-check"></i> '
      +'Aplicar en SAP lo aprobado</button></div></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) _revCerrar(); });
  document.body.appendChild(ov);
  _revPintar();
}

function _revCerrar(){
  var m=document.getElementById('modalRev'); if(m) m.remove();
  window._rev=null;
}

function _revPintar(){
  var r=window._rev, c=document.getElementById('revCuerpo');
  if(!r || !c) return;

  var h=_revTotales(r);

  if(!r.total){
    c.innerHTML=h+'<div class="nota" style="background:var(--pastel-ok);'
      +'color:var(--t-verde)"><i class="ti ti-circle-check"></i> El Revised PO '
      +'coincide con la orden de SAP en las '+r.iguales+' líneas y en el total. '
      +'No hay nada que cambiar.</div>';
    _revResumen(); return;
  }
  var fila=function(idx, tipo, marcado, izq, der, aviso){
    return '<label style="display:flex;align-items:flex-start;gap:9px;'
      +'padding:6px 0;border-bottom:0.5px solid var(--border);cursor:pointer;'
      +'font-size:12px">'
      +'<input type="checkbox" '+(marcado?'checked':'')+' style="margin-top:2px" '
      +'onchange="_revMarcar(\''+tipo+'\','+idx+',this.checked)">'
      +'<span style="flex:1">'+izq
      + (aviso?('<div style="font-size:10.5px;color:var(--t-rojo);margin-top:2px">'
                +'<i class="ti ti-alert-triangle"></i> '+_esc(aviso)+'</div>'):'')
      +'</span>'
      +'<span style="white-space:nowrap">'+der+'</span></label>';
  };

  if(r.cambios.length){
    h+='<div style="font-size:12px;font-weight:700;margin:10px 0 3px">'
      +'Cambios en las líneas ('+r.cambios.length+')</div>';
    r.cambios.forEach(function(x,i){
      var aviso=null;
      if(x.campo==='cantidad' && x.ahora < x.servida-0.0001){
        aviso='ya se recibieron '+_fmtN2(x.servida)+': SAP no deja bajar de ahí';
      }
      h+=fila(i,'cambios',x.aplicar,
        '<b>'+_esc(x.itemcode)+'</b> <span style="color:var(--text-muted)">'
        +_esc(String(x.nombre||'').slice(0,34))+'</span> · '+_esc(x.tit),
        '<span style="text-decoration:line-through;opacity:.6">'+_fmtN2(x.antes)
        +'</span> → <b>'+_fmtN2(x.ahora)+'</b>', aviso);
    });
  }
  if(r.nuevas.length){
    h+='<div style="font-size:12px;font-weight:700;margin:12px 0 3px">'
      +'Líneas que se AÑADEN ('+r.nuevas.length+')</div>';
    r.nuevas.forEach(function(x,i){
      h+=fila(i,'nuevas',x.aplicar,
        '<b>'+_esc(x.itemcode)+'</b> <span style="color:var(--text-muted)">'
        +_esc(String(x.nombre||'').slice(0,34))+'</span>',
        _fmtN2(x.cantidad)+' × '+_fmtN2(x.precio), null);
    });
  }
  if(r.quitar.length){
    h+='<div style="font-size:12px;font-weight:700;margin:12px 0 3px">'
      +'Líneas que se QUITAN ('+r.quitar.length+') · no vienen en el Revised PO</div>';
    r.quitar.forEach(function(x,i){
      var aviso = x.servida>0.0001
        ? ('ya se recibieron '+_fmtN2(x.servida)+': no se puede quitar')
        : null;
      h+=fila(i,'quitar',x.aplicar,
        '<b>'+_esc(x.itemcode)+'</b> <span style="color:var(--text-muted)">'
        +_esc(String(x.nombre||'').slice(0,34))+'</span>',
        _fmtN2(x.cantidad), aviso);
    });
  }

  if(r.emparejadas && r.emparejadas.length){
    h+='<div class="nota" style="background:var(--pastel-aviso);'
      +'color:var(--t-marron)"><i class="ti ti-link"></i> '
      +'<b>'+r.emparejadas.length+' referencia(s) se emparejaron por parecido</b> '
      +'—el escaneo parte el código en dos líneas y se pierde el prefijo:<br>'
      + r.emparejadas.slice(0,6).map(function(x){
          return '· en SAP <b>'+_esc(x.sap)+'</b> ↔ en el archivo '
            +_esc(x.archivo)+' ('+x.modo+')'; }).join('<br>')
      +'<br><span style="font-size:11px">Compruébalo: si alguna no es la misma, '
      +'desmarca sus cambios.</span></div>';
  }

  h+='<div class="nota" style="background:var(--pastel-azul);color:var(--t-azul);'
    +'margin-top:12px"><i class="ti ti-info-circle"></i> Esto cambia la '
    +'<b>orden de compra</b> en SAP: cantidades, precios y líneas. Los datos del '
    +'artículo —color, composición, código de barras— son de su ficha y se '
    +'cambian en la pantalla de artículos.</div>';
  c.innerHTML=h;
  _revResumen();
}

function _revMarcar(tipo, i, v){
  var r=window._rev; if(!r || !r[tipo] || !r[tipo][i]) return;
  r[tipo][i].aplicar=!!v;
  _revResumen();
}

function _revMarcarTodo(v){
  var r=window._rev; if(!r) return;
  ['cambios','nuevas','quitar'].forEach(function(t){
    (r[t]||[]).forEach(function(x){ x.aplicar=!!v; });
  });
  _revPintar();
}

function _revResumen(){
  var r=window._rev, e=document.getElementById('revResumen');
  if(!r || !e) return;
  var n=['cambios','nuevas','quitar'].reduce(function(a,t){
    return a+(r[t]||[]).filter(function(x){ return x.aplicar; }).length; },0);
  n+=((r.totales&&r.totales.cargos)||[])
      .filter(function(c){ return c.aplicar!==false && Number(c.monto); }).length;
  e.innerHTML=n
    ? ('<b>'+n+'</b> cambio(s) aprobados')
    : '<span style="color:var(--text-muted)">nada aprobado</span>';
}

// Manda a la cola solo lo aprobado. El worker lo aplica por DI API.
async function _revAplicar(){
  var r=window._rev; if(!r) return;
  var cambios=(r.cambios||[]).filter(function(x){ return x.aplicar; });
  var nuevas =(r.nuevas ||[]).filter(function(x){ return x.aplicar; });
  var quitar =(r.quitar ||[]).filter(function(x){ return x.aplicar; });
  // Los cargos cuentan como cambio: si lo único que trae el Revised PO es un
  // coste de etiquetas, no hay ninguna línea distinta y aun así hay que
  // aplicarlo. Antes esta comprobación los ignoraba y decía que no había nada.
  var cargos=((r.totales&&r.totales.cargos)||[])
    .filter(function(c){ return c.aplicar!==false && Number(c.monto); });

  if(!cambios.length && !nuevas.length && !quitar.length && !cargos.length){
    showT('No has aprobado ningún cambio'); return;
  }

  // Lo que SAP va a rechazar, dicho antes de mandarlo
  var malos=cambios.filter(function(x){
      return x.campo==='cantidad' && x.ahora < x.servida-0.0001; })
    .concat(quitar.filter(function(x){ return x.servida>0.0001; }));
  if(malos.length){
    if(!confirm(malos.length+' cambio(s) chocan con mercancía ya recibida y SAP '
      +'los va a rechazar:\n\n'
      + malos.slice(0,5).map(function(x){ return '  · '+x.itemcode; }).join('\n')
      +'\n\n¿Mando el resto igualmente?')) return;
  }

  var resumen='APLICAR LA REVISIÓN EN SAP\n\n'
    +'Orden #'+r.docnum+'\n'
    + (cambios.length? ('· '+cambios.length+' cambio(s) de cantidad o precio\n'):'')
    + (nuevas.length ? ('· '+nuevas.length+' línea(s) que se AÑADEN\n'):'')
    + (quitar.length ? ('· '+quitar.length+' línea(s) que se QUITAN\n'):'')
    + (cargos.length ? ('· '+cargos.length+' cargo(s) a gastos adicionales: '
        + cargos.map(function(c){
            return c.concepto+' '+_fmtN2(c.monto); }).join(', ')+'\n'):'')
    + ((r.totales && Math.abs(r.totales.dif)>0.5)
       ? ('\nEl total pasa de '+_fmtN2(r.totales.sap)+' a '
          +_fmtN2(r.totales.total)+'\n') : '')
    +'\nSe cambia la orden REAL en SAP, por DI API. ¿Sigo?';
  if(!confirm(resumen)) return;

  showT('Enviando la revisión…');
  try{
    var fila={
      docnum:Number(r.docnum), dkc:null, archivo:r.archivo,
      cambios:cambios.map(function(x){
        return {linenum:x.linenum, itemcode:x.itemcode, campo:x.campo,
                antes:x.antes, ahora:x.ahora}; }),
      nuevas:nuevas.map(function(x){
        return {itemcode:x.itemcode, cantidad:x.cantidad, precio:x.precio}; }),
      quitar:quitar.map(function(x){
        return {linenum:x.linenum, itemcode:x.itemcode,
                motivo:'no viene en el Revised PO'}; }),
      // Los cargos van como gastos adicionales de la orden
      cargos:cargos.map(function(c){
        return {concepto:c.concepto, monto:Number(c.monto)||0}; }),
      total_antes:(r.totales&&r.totales.sap)||null,
      total_despues:(r.totales&&r.totales.total)||null,
      estado:'pendiente', creado_por:(CU&&CU.name)||''
    };
    var rr=await fetch(SB+'/rest/v1/revisiones_orden_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!rr.ok){
      var t=''; try{ t=await rr.text(); }catch(e){}
      if(t.indexOf('does not exist')>=0 || t.indexOf('relation')>=0){
        throw new Error('falta la tabla de la cola: corre revisiones_orden.sql '
          +'en Supabase.');
      }
      throw new Error(rr.status+' '+t.slice(0,150));
    }
    _revCerrar();
    _okGrande('Revisión enviada',
      '<b>Orden #'+_esc(r.docnum)+'</b><br>'
      + (cambios.length+nuevas.length+quitar.length+cargos.length)
      +' cambio(s) aprobados<br>'
      + (cargos.length ? ('incluye '+_fmtN2(cargos.reduce(function(a,c){
            return a+Number(c.monto)||0; },0))+' en gastos adicionales<br>') : '')
      +'<span style="font-size:11.5px;color:var(--text-muted)">El worker los '
      +'aplica en SAP en el próximo ciclo, por DI API.</span>');
  }catch(e){
    showT('No se pudo enviar: '+(e.message||e), 10000);
    console.warn('[REV] aplicar:', e);
  }
}

// Recorre los Excel adjuntos y completa lo que la IA no sacó. Va aparte de
// las fotos a propósito: son dos cosas distintas y una no debe depender de
// la otra.
async function _nsapCompletarTodo(){
  var items=window._nsapItems||[];
  if(!items.length) return 0;

  var cands=[];
  // El Excel adjuntado a mano solo para esto, si lo hay
  if(window._nsapExcelExtra) cands.push(window._nsapExcelExtra);
  [window._nsapDocs, window._firmaDocs].forEach(function(st){
    if(!st) return;
    if(st.prov) cands.push(st.prov);
    if(st.kcc)  cands.push(st.kcc);
  });
  try{
    document.querySelectorAll('#modalNuevaSAP input[type=file]').forEach(function(inp){
      if(inp.files && inp.files[0]) cands.push(inp.files[0]);
    });
  }catch(e){}

  var vistos={}, xls=[];
  cands.forEach(function(f){
    if(!f || !/\.xlsx$/i.test(f.name||'')) return;
    var k=(f.name||'')+'|'+(f.size||0);
    if(vistos[k]) return;
    vistos[k]=1; xls.push(f);
  });
  if(!xls.length){
    _dbg('[kcc] no hay ningún .xlsx del que completar');
    return 0;
  }

  var total=0;
  for(var i=0;i<xls.length;i++){
    // Primero el código de KCC: si la IA se equivocó de columna, nada
    // emparejará después.
    try{ await _nsapCorregirKcc(xls[i], items); }
    catch(e){ console.warn('[kcc] '+xls[i].name+':', e); }
    try{ total += (await _nsapCompletarDesdeHoja(xls[i], items)) || 0; }
    catch(e){ console.warn('[kcc] completar '+xls[i].name+':', e); }
  }

  if(total){
    _nsapRenderItems();
    showT('Se completaron '+total+' dato(s) leyendo '
      + xls.map(function(f){ return f.name; }).join(' y '), 8000);
  } else {
    _dbg('[kcc] no había nada que completar en '+xls.length+' archivo(s)');
  }
  return total;
}

// Adjuntar un Excel solo para sacar de él las fotos y los campos. No
// sustituye a los documentos de la orden: es un archivo de apoyo, y por eso
// no se guarda como adjunto de la orden.
function _nsapPedirExcel(){
  var inp=document.createElement('input');
  inp.type='file';
  inp.accept='.xlsx';
  inp.onchange=async function(){
    var f=inp.files && inp.files[0];
    if(!f) return;
    if(!/\.xlsx$/i.test(f.name||'')){
      showT('Tiene que ser un .xlsx: es el único formato con fotos dentro');
      return;
    }
    window._nsapExcelExtra=f;
    showT('Leyendo '+f.name+'…');
    // Primero los campos y después las fotos, que es el orden útil: si el
    // Excel trae los códigos buenos, las fotos emparejan mejor.
    try{ await _nsapCompletarTodo(); }
    catch(e){ console.warn('[nosap] completar desde el Excel suelto:', e); }
    try{ await _nsapSacarFotos(); }
    catch(e){ console.warn('[nosap] fotos del Excel suelto:', e); }
  };
  inp.click();
}

// ── Leer un Revised PO venga como venga ─────────────────────────────────
// En Excel se lee por columnas, que es exacto. En PDF —y casi siempre son
// escaneos de fotocopiadora, sin texto— hay que pasarlo por la IA.
async function _rpoFichas(file){
  var nombre=String(file.name||'');
  if(/\.xlsx$/i.test(nombre)){
    var f=await _ocLeerFichasDeExcel(null, nombre, file);
    if(f && Object.keys(f).length) return f;
    throw new Error('el Excel no tiene una tabla de artículos reconocible');
  }

  // PDF o imagen: lo lee la IA
  var doc=await _iaDesdeBlob(file, nombre);
  if(!doc || !doc.bloques || !doc.bloques.length){
    throw new Error('no pude preparar «'+nombre+'» para leerlo');
  }

  var prompt='Este documento es una ORDEN DE COMPRA REVISADA de Kennedy Center.\n'
    +'Devuelve SOLO un JSON, sin texto alrededor ni ```:\n'
    +'{"items":[{"itemcode":"","itemname":"","cantidad":0,"precio":0,'
    +'"barcode":"","material":"","color":"","tamano":"","carton":"",'
    +'"qtyCtn":0,"ctns":0,"cbm":0,"factory":""}],\n'
    +' "suma_lineas":0, "cargos":[{"concepto":"","monto":0}], "total":0}\n\n'
    +'REGLAS:\n'
    +'- "itemcode" es el codigo de Kennedy (KCC ITEM No.), de unas 7 cifras.\n'
    +'  NO el del proveedor ni el de fabrica.\n'
    +'- Si el codigo aparece partido en dos lineas de la celda («BA-» arriba y\n'
    +'  «319994» abajo), JUNTALO: es un solo codigo, «BA-319994». No devuelvas\n'
    +'  solo la segunda parte.\n'
    +'- "cantidad" es la cantidad pedida de esa linea; "precio" el unitario.\n'
    +'- "barcode" es el numero largo de 12 o 13 cifras, en su propia columna.\n'
    +'- Si el documento esta escaneado, lee igual: los datos estan aunque el\n'
    +'  texto no sea seleccionable.\n'
    +'- Una fila por articulo. No inventes ninguna: si no ves un dato, dejalo\n'
    +'  vacio o en 0.\n'
    +'- No incluyas las filas de totales entre los "items".\n'
    +'- "suma_lineas" es el subtotal de los articulos; "total" es el importe\n'
    +'  FINAL del documento, el de abajo del todo (suele ir resaltado).\n'
    +'- "cargos" son los importes que NO son articulos y suman al total: coste\n'
    +'  de etiquetas («label cost»), moldes, muestras, flete, recargos. Pon el\n'
    +'  texto tal cual aparece en "concepto", incluida cualquier nota como\n'
    +'  «$230 refundable next order».\n'
    +'- Si total y suma_lineas no coinciden, la diferencia son cargos: buscalos\n'
    +'  y ponlos. No devuelvas la lista vacia si el total es mayor.';

  var contenido=doc.bloques.concat([{type:'text', text:prompt}]);
  var obj=await _iaJSON(contenido, 8000);
  var items=(obj && obj.items) || [];
  if(!items.length) throw new Error('la IA no encontró artículos en el documento');

  var fichas={};
  items.forEach(function(it){
    var code=String(it.itemcode||'').trim();
    if(!code) return;
    fichas[code]={itemcode:code,
                  esp:it.itemname||'', ing:it.itemname||'',
                  cantidad:Number(it.cantidad)||0,
                  precio:Number(it.precio)||0,
                  barcode:it.barcode||'', comp:it.material||'',
                  color:it.color||'', size:it.tamano||'',
                  carton:it.carton||'', qtyCtn:Number(it.qtyCtn)||0,
                  ctns:Number(it.ctns)||0, cbm:Number(it.cbm)||0,
                  factory:it.factory||''};
  });
  if(!Object.keys(fichas).length){
    throw new Error('la IA leyó el documento pero ningún artículo traía código KCC');
  }
  // Los cargos que no son artículos —etiquetas, moldes, flete— y el total.
  // Sin esto solo se comparaban las líneas y un cargo de $530 pasaba entero
  // sin que nadie lo viera.
  fichas.__totales={
    suma_lineas:Number(obj.suma_lineas)||0,
    cargos:(obj.cargos||[]).filter(function(c){
      return c && Number(c.monto); }).map(function(c){
      return {concepto:String(c.concepto||'cargo').trim(), monto:Number(c.monto)||0}; }),
    total:Number(obj.total)||0
  };
  _dbg('[RPO] la IA leyó '+Object.keys(fichas).length+' artículo(s) de '+nombre);
  return fichas;
}

// ── Emparejar referencias que el escáner parte en dos ───────────────────
// En SAP el código es «BA-319994». En un PDF escaneado el prefijo suele
// quedar en una línea y el número en la siguiente, y la IA devuelve solo
// «319994». Si se comparan tal cual, salen cuatro artículos nuevos y cuatro
// que se quitan, cuando son los mismos cuatro.
//
// Se empareja así, por orden: igual, uno termina en el otro, o los dígitos
// coinciden. Solo cuando la correspondencia es ÚNICA: si dos referencias de
// SAP acabaran en el mismo número, no se adivina.
// (_refDigitos ya existe más arriba en el archivo: se reutiliza)

function _refEmparejar(codigos, buscado){
  var k=_ocNormSku(buscado);
  if(!k) return null;

  // 1. Igual
  for(var i=0;i<codigos.length;i++){
    if(_ocNormSku(codigos[i])===k) return {codigo:codigos[i], modo:'exacta'};
  }
  // 2. Uno termina en el otro: «BA319994» contra «319994»
  var porFinal=codigos.filter(function(c){
    var n=_ocNormSku(c);
    return n!==k && n.length>3 && k.length>3 && (n.endsWith(k) || k.endsWith(n));
  });
  if(porFinal.length===1) return {codigo:porFinal[0], modo:'prefijo'};
  // 3. Los mismos dígitos: «BA-319994» contra «319.994»
  var d=_refDigitos(buscado);
  if(d.length>=4){
    var porNum=codigos.filter(function(c){ return _refDigitos(c)===d; });
    if(porNum.length===1) return {codigo:porNum[0], modo:'dígitos'};
  }
  return null;
}

// El cuadro de totales del Revised PO. Va lo primero del panel: un cargo por
// etiquetas no cambia ninguna línea y sube la orden igual, y comparando solo
// los artículos pasaba entero sin que nadie lo viera.
function _revTotales(r){
  var t=r.totales; if(!t) return '';
  var hayDif=Math.abs(t.dif)>0.5;

  var caja=function(tit, val, col, pie){
    return '<div style="flex:1;min-width:140px;background:var(--surface-0);'
      +'border:0.5px solid var(--border);border-radius:9px;padding:9px 12px">'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:2px">'
      +_esc(tit)+'</div>'
      +'<div style="font-size:15px;font-weight:700;color:'+col+'">'
      +_fmtN2(val)+'</div>'
      +(pie?('<div style="font-size:10.5px;color:var(--text-muted)">'+pie+'</div>'):'')
      +'</div>';
  };

  var h='<div style="margin-bottom:12px">'
    +'<div style="display:flex;gap:9px;flex-wrap:wrap;align-items:stretch">'
    + caja('La orden en SAP', t.sap, 'var(--text-secondary)')
    +'<div style="display:flex;align-items:center;font-size:20px;'
    +'color:var(--text-muted)">→</div>'
    + caja('Total del Revised PO', t.total,
           hayDif?'var(--t-rojo)':'var(--text-primary)',
           t.difCargos ? ('líneas '+_fmtN2(t.lineas)+' + cargos '
                          +_fmtN2(t.difCargos)) : null)
    + caja('Diferencia', t.dif,
           hayDif?'var(--t-marron)':'var(--t-verde)',
           hayDif ? (t.dif>0?'la orden SUBE':'la orden BAJA') : 'cuadra')
    +'</div>';

  if(t.cargos && t.cargos.length){
    h+='<div style="background:var(--pastel-aviso);border:1px solid #E0A82E;'
      +'border-radius:9px;padding:10px 13px;margin-top:9px">'
      +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);'
      +'margin-bottom:5px"><i class="ti ti-receipt"></i> '
      +'Cargos que no son artículos ('+t.cargos.length+')</div>'
      + t.cargos.map(function(c,i){
          return '<label style="display:flex;align-items:center;gap:8px;'
            +'font-size:12px;padding:2px 0;cursor:pointer">'
            +'<input type="checkbox" checked '
            +'onchange="_revCargoMarcar('+i+',this.checked)">'
            +'<span style="flex:1">'+_esc(c.concepto)+'</span>'
            +'<b>'+_fmtN2(c.monto)+'</b></label>';
        }).join('')
      +'<div style="font-size:11px;color:var(--t-marron);margin-top:6px">'
      +'Se añaden a la orden de SAP como <b>gastos adicionales</b>, que es '
      +'donde van: no son artículos y no deben inventarse como línea.</div>'
      +'</div>';
  } else if(hayDif){
    h+='<div class="nota" style="background:var(--pastel-error);'
      +'color:var(--t-rojo);margin-top:9px"><i class="ti ti-alert-triangle"></i> '
      +'El total del Revised PO no cuadra con la orden y no encontré ningún '
      +'cargo que lo explique. Revísalo a mano antes de aplicar.</div>';
  }
  return h+'</div>';
}

function _revCargoMarcar(i, v){
  var r=window._rev;
  if(!r || !r.totales || !r.totales.cargos[i]) return;
  r.totales.cargos[i].aplicar=(v!==false);
  _revResumen();
}

/* ═══════════════════════════════════════════════════════════════════════════
   FACTURAS RESERVA · la lista
   ───────────────────────────────────────────────────────────────────────────
   Las que hay en SAP de los últimos dos años. Se entra en una y desde ahí se
   pide la cancelación a contabilidad, con la factura adjunta.
   ═══════════════════════════════════════════════════════════════════════════ */

window._fres = window._fres || {filas:[], q:'', estado:'', cargando:false};

async function rFacturasRes(){
  var c=document.getElementById('page-facturasres');
  if(!c) return;
  _tbxEstilos();
  if(!_frPuede()){
    c.innerHTML='<div class="empty">Esta pantalla es de compras, importación, '
      +'contabilidad y gerencia.</div>';
    return;
  }
  var d=window._fres;

  var h='<div style="max-width:1700px;margin:0 auto">'
    +'<h2 style="font-size:17px;margin:0 0 3px">'
    +'<i class="ti ti-file-invoice"></i> Facturas reserva</h2>'
    +'<p style="font-size:11.5px;color:var(--text-muted);margin:0 0 13px">'
    +'Las de SAP de los últimos dos años. Entra en una para ver el detalle y '
    +'pedir su cancelación.</p>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;'
    +'margin-bottom:12px">'
    +'<input id="fresQ" value="'+_esc(d.q||'')+'" '
    +'placeholder="Proveedor, N.º, DKC, BL, contenedor…" '
    +'oninput="window._fres.q=this.value;_fresPintar()" '
    +'style="flex:1;min-width:240px;padding:8px 12px;border:0.5px solid var(--border);'
    +'border-radius:8px;font-size:13px">'
    + ['','POR ARRIBAR','EN PUERTO','RECIBIDA'].map(function(e){
        return '<span class="pill '+(d.estado===e?'active':'')+'" '
          +'onclick="window._fres.estado=\''+e+'\';_fresPintar()">'
          +(e||'Todas')+'</span>'; }).join('')
    +'<button class="xb" onclick="_fresCargar(true)">'
    +'<i class="ti ti-refresh"></i> Actualizar</button></div>'
    +'<div id="fresCuerpo"></div></div>';
  c.innerHTML=h;

  if(!d.filas.length) await _fresCargar();
  else _fresPintar();
}

async function _fresCargar(forzar){
  var d=window._fres;
  if(d.cargando) return;
  d.cargando=true;
  var cu=document.getElementById('fresCuerpo');
  if(cu) cu.innerHTML='<div class="empty" style="padding:24px">Cargando…</div>';
  try{
    var desde=new Date(); desde.setFullYear(desde.getFullYear()-2);
    var r=await fetch(SB+'/rest/v1/opch_reserva?select=*'
      +'&docdate=gte.'+desde.toISOString().slice(0,10)
      +'&order=docdate.desc&limit=2000',{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      if(t.indexOf('does not exist')>=0 || t.indexOf('relation')>=0){
        throw new Error('falta la tabla: corre facturas_reserva_lista.sql en '
          +'Supabase y espera un ciclo del worker.');
      }
      throw new Error(r.status+' '+t.slice(0,140));
    }
    d.filas=await r.json()||[];
    _dbg('[FRES] '+d.filas.length+' factura(s) reserva');
  }catch(e){
    if(cu) cu.innerHTML='<div class="nota" style="background:var(--pastel-error);'
      +'color:var(--t-rojo)">No pude cargar: '+_esc(e.message||e)+'</div>';
    d.cargando=false;
    return;
  }
  d.cargando=false;
  _fresPintar();
}

function _fresFiltradas(){
  var d=window._fres;
  var q=_bkNorm(d.q||'');
  return d.filas.filter(function(f){
    if(d.estado && _bkNorm(f.estado_bodega||'').indexOf(_bkNorm(d.estado))<0) return false;
    if(!q) return true;
    return [f.docnum, f.cardname, f.cardcode, f.numatcard, f.bl, f.contenedores,
            f.naviera, f.comments, f.ordenes]
      .some(function(v){ return _bkNorm(v||'').indexOf(q)>=0; });
  });
}

var FRES_COLS=[
  ['docnum',        '#',                  function(f){ return '<b>'+_esc(f.docnum)+'</b>'; }],
  ['docdate',       'Fecha',              function(f){ return _fechaCorta(f.docdate); }],
  ['cardname',      'Proveedor',          function(f){ return _esc(String(f.cardname||'').slice(0,30)); }],
  ['docduedate',    'Vencimiento',        function(f){ return _fechaCorta(f.docduedate); }],
  ['comments',      'Comentarios',        function(f){ return '<span title="'+_esc(f.comments||'')+'">'
                                                    +_esc(String(f.comments||'').slice(0,44))+'</span>'; }],
  ['doctotal',      'Total',              function(f){ return '<b>'+_fmtN2(f.doctotal)+'</b>'; }],
  ['numatcard',     'Ref1',               function(f){ return _esc(f.numatcard||''); }],
  ['num_doc_com',   'N.º Doc. Com.',      function(f){ return _esc(f.num_doc_com||''); }],
  ['fecha_eta',     'ETA',                function(f){ return _fechaCorta(f.fecha_eta); }],
  ['estado_bodega', 'Estatus / Bodega',   function(f){ return _fresChip(f.estado_bodega); }],
  ['flete_estimado','Flete est.',         function(f){ return _fmtN2(f.flete_estimado); }],
  ['bl',            'BL',                 function(f){ return _esc(f.bl||''); }],
  ['contenedores',  'Conts.',             function(f){ return _esc(f.contenedores||''); }],
  ['naviera',       'Naviera',            function(f){ return _esc(f.naviera||''); }]
];

function _fresChip(e){
  var t=String(e||'').trim();
  if(!t) return '';
  var col=_bkNorm(t).indexOf('PUERTO')>=0 ? ['var(--pastel-aviso)','var(--t-marron)']
        : _bkNorm(t).indexOf('ARRIBAR')>=0 ? ['var(--pastel-azul)','var(--t-azul)']
        : ['var(--pastel-ok)','var(--t-verde)'];
  return '<span style="background:'+col[0]+';color:'+col[1]+';padding:2px 8px;'
    +'border-radius:20px;font-size:10.5px;font-weight:600;white-space:nowrap">'
    +_esc(t)+'</span>';
}

function _fresPintar(){
  var cu=document.getElementById('fresCuerpo');
  if(!cu) return;
  var filas=_fresFiltradas();
  if(!filas.length){
    cu.innerHTML='<div class="empty" style="padding:26px">'
      + (window._fres.filas.length
         ? 'Ninguna factura coincide con el filtro.'
         : 'No hay facturas reserva de los últimos dos años. Si acabas de correr '
           +'el SQL, espera un ciclo del worker.')
      +'</div>';
    return;
  }
  var total=filas.reduce(function(a,f){ return a+(Number(f.doctotal)||0); },0);

  window._fresSel=window._fresSel||{};
  var sel=Object.keys(window._fresSel).filter(function(k){ return window._fresSel[k]; });

  cu.innerHTML='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'margin-bottom:7px">'
    +'<span style="font-size:11.5px;color:var(--text-muted)">'
    +filas.length+' factura(s) · '+_fmtN2(total)+'</span>'
    // Varias facturas a la vez: se marcan y se pide la cancelación de todas
    // en un solo correo, con el desglose por orden y el total.
    +(sel.length?('<span style="flex:1"></span>'
      +'<span style="font-size:11.5px;font-weight:700;color:var(--t-vino)">'
      +sel.length+' seleccionada(s) · '+_fmtN2(_fresSelTotal())+'</span>'
      +'<button class="xb" onclick="_fresSelLimpiar()">Quitar la selección</button>'
      +'<button class="btn bp" style="padding:7px 14px;background:var(--t-vino)" '
      +'onclick="_fresCancelarVarias()"><i class="ti ti-file-off"></i> '
      +'Solicitar la cancelación de las '+sel.length+'</button>'):'')
    +'</div>'
    +'<div class="tbx-box" style="max-height:72vh"><table class="tbx"><thead><tr>'
    +'<th style="width:34px"><input type="checkbox" onclick="_fresSelTodas(this.checked)" '
    +'title="Marcar todas las que se ven"></th>'
    + FRES_COLS.map(function(c){ return '<th>'+_esc(c[1])+'</th>'; }).join('')
    +'</tr></thead><tbody>'
    + filas.map(function(f){
        var m=!!window._fresSel[String(f.docentry)];
        return '<tr'+(m?' style="background:var(--pastel-lila)"':'')+'>'
          +'<td onclick="event.stopPropagation()"><input type="checkbox"'
          +(m?' checked':'')+' onchange="_fresSelUno('+f.docentry+',this.checked)"></td>'
          + FRES_COLS.map(function(c){
              return '<td style="cursor:pointer" onclick="_fresAbrir('+f.docentry+')">'
                +c[2](f)+'</td>'; }).join('')
          +'</tr>';
      }).join('')
    +'</tbody></table></div>';
}

// ── El detalle de una factura reserva ───────────────────────────────────
async function _fresAbrir(docentry){
  var f=(window._fres.filas||[]).filter(function(x){
    return String(x.docentry)===String(docentry); })[0];
  if(!f){ showT('No encuentro esa factura'); return; }
  window._fresActual=f;

  var ov=document.createElement('div');
  ov.id='modalFres';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10058;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';

  var dato=function(t, v, ancho){
    return '<div style="min-width:'+(ancho||150)+'px">'
      +'<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(t)+'</div>'
      +'<div style="font-size:12.5px;font-weight:600">'+(v||'—')+'</div></div>';
  };

  var saldo=Number(f.saldo);
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;'
      +'padding:18px 20px;width:100%;max-width:960px;max-height:88vh;'
      +'display:flex;flex-direction:column">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;'
      +'margin-bottom:10px"><div>'
      +'<div style="font-size:16px;font-weight:700">Factura reserva #'
      +_esc(f.docnum)+'</div>'
      +'<div style="font-size:12px;color:var(--text-muted)">'
      +_esc(f.cardcode||'')+' · '+_esc(f.cardname||'')+'</div></div>'
      +'<button onclick="_fresCerrar()" style="background:none;border:none;'
      +'font-size:24px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="overflow-y:auto;flex:1">'
      +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:12px">'
        +'<div style="flex:1;min-width:150px;background:var(--pastel-azul);'
        +'border-radius:10px;padding:10px 13px">'
        +'<div style="font-size:10.5px;color:var(--t-azul)">Total</div>'
        +'<div style="font-size:18px;font-weight:700;color:var(--t-azul)">'
        +_fmtN2(f.doctotal)+'</div></div>'
        +'<div style="flex:1;min-width:150px;background:var(--pastel-ok);'
        +'border-radius:10px;padding:10px 13px">'
        +'<div style="font-size:10.5px;color:var(--t-verde)">Pagado</div>'
        +'<div style="font-size:18px;font-weight:700;color:var(--t-verde)">'
        +_fmtN2(f.paidsum)+'</div></div>'
        +'<div style="flex:1;min-width:150px;background:'
        +(saldo>0.005?'var(--pastel-aviso)':'var(--surface-1)')+';'
        +'border-radius:10px;padding:10px 13px">'
        +'<div style="font-size:10.5px;color:var(--t-marron)">Saldo</div>'
        +'<div style="font-size:18px;font-weight:700;color:var(--t-marron)">'
        +_fmtN2(saldo)+'</div></div></div>'

      +'<div style="display:flex;gap:14px;flex-wrap:wrap;background:var(--surface-1);'
      +'border:0.5px solid var(--border);border-radius:11px;padding:13px 15px;'
      +'margin-bottom:11px">'
        + dato('Fecha', _fechaCorta(f.docdate))
        + dato('Vencimiento', _fechaCorta(f.docduedate))
        + dato('Ref1', _esc(f.numatcard||''))
        + dato('N.º Doc. Com.', _esc(f.num_doc_com||''))
        + dato('Órdenes de compra', _esc(f.ordenes||''), 180)
        + dato('Moneda', _esc(f.moneda||''))
        + dato('Estado', (String(f.docstatus||'').toUpperCase()==='C'
                          ? 'Cerrada' : 'Abierta')
               + (String(f.canceled||'').toUpperCase()==='Y'?' · CANCELADA':''))
      +'</div>'

      +'<div style="display:flex;gap:14px;flex-wrap:wrap;background:var(--surface-1);'
      +'border:0.5px solid var(--border);border-radius:11px;padding:13px 15px;'
      +'margin-bottom:11px">'
        + dato('Estatus / Bodega', _fresChip(f.estado_bodega))
        + dato('ETA', _fechaCorta(f.fecha_eta))
        + dato('BL', _esc(f.bl||''))
        + dato('Contenedores', _esc(f.contenedores||''))
        + dato('Naviera', _esc(f.naviera||''))
        + dato('Flete estimado', _fmtN2(f.flete_estimado))
      +'</div>'

      + (f.comments ? ('<div style="background:var(--surface-1);border:0.5px solid '
          +'var(--border);border-radius:11px;padding:11px 14px;margin-bottom:11px">'
          +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:3px">'
          +'Comentarios</div>'
          +'<div style="font-size:12.5px;white-space:pre-wrap">'
          +_esc(f.comments)+'</div></div>') : '')

      +'<div id="fresLineas"><div style="font-size:11.5px;color:var(--text-muted)">'
      +'Cargando las líneas…</div></div>'
    +'</div>'

    +'<div style="display:flex;gap:9px;margin-top:12px;flex-wrap:wrap;'
      +'align-items:center">'
      +'<span style="font-size:11px;color:var(--text-muted);flex:1">'
      +'La solicitud va a contabilidad con la factura adjunta.</span>'
      +'<button class="xb" style="padding:10px 16px" onclick="_fresDescargar()">'
      +'<i class="ti ti-download"></i> Descargar factura</button>'
      +'<button class="btn bp" style="font-weight:700;padding:10px 18px" '
      +'onclick="_fresPedirCancelacion()"><i class="ti ti-cash"></i> '
      +'Solicitar cancelación</button></div></div>';

  ov.addEventListener('click', function(e){ if(e.target===ov) _fresCerrar(); });
  document.body.appendChild(ov);
  _fresLineas(f);
}

function _fresCerrar(){
  var m=document.getElementById('modalFres'); if(m) m.remove();
  window._fresActual=null;
}

// Las líneas de la factura, de las órdenes que cubre
async function _fresLineas(f){
  var c=document.getElementById('fresLineas');
  if(!c) return;
  try{
    // La MISMA fuente que el PDF: así lo que ves es lo que se imprime
    var ls=await _fresTraerLineas(f.docentry);
    if(!ls.length){
      c.innerHTML='<div style="font-size:11.5px;color:var(--text-muted)">'
        +'Esta factura no tiene líneas todavía en el portal.</div>';
      return;
    }
    var total=ls.reduce(function(a,l){ return a+(Number(l.total_linea)||0); },0);
    c.innerHTML='<div style="font-size:12px;font-weight:700;margin-bottom:6px">'
      +'Artículos ('+ls.length+') · '+_fmtN2(total)+'</div>'
      +'<div class="tbx-box" style="max-height:38vh"><table class="tbx"><thead><tr>'
      +'<th style="width:46px">Foto</th><th>Artículo</th><th>Descripción</th>'
      +'<th>Cantidad</th><th>UM</th><th>Precio</th>'
      +'<th style="text-align:right">Total</th></tr></thead><tbody>'
      + ls.map(function(l){
          // La foto, con las MISMAS variantes que el resto del portal: antes
          // se probaba una sola dirección y, si fallaba, la celda quedaba
          // vacía aunque el artículo tuviera foto.
          return '<tr><td>'+_frImgFoto(l)+'</td>'
            +'<td><b>'+_esc(l.itemcode||'')+'</b></td>'
            +'<td>'+_esc(String(l.descripcion||'').slice(0,46))+'</td>'
            +'<td>'+_fmtN2(l.cantidad)+'</td>'
            +'<td>'+_esc(l.um||'')+'</td>'
            +'<td>'+_fmtN2(l.precio)+'</td>'
            +'<td style="text-align:right">'+_fmtN2(l.total_linea)+'</td></tr>';
        }).join('')
      +'</tbody></table></div>';
  }catch(e){
    c.innerHTML='<div style="font-size:11.5px;color:var(--text-muted)">'
      +'No pude cargar las líneas: '+_esc(e.message||e)+'</div>';
  }
}

// ── Pedir la cancelación de la factura ──────────────────────────────────
// Como las demás solicitudes a contabilidad, pero eligiendo a quién se
// manda y con la factura adjunta al correo.
async function _fresPedirCancelacion(){
  var f=window._fresActual;
  if(!f){ showT('No hay ninguna factura abierta'); return; }

  // La MISMA pantalla que las solicitudes de abono y cancelación de siempre:
  // mismo asunto, mismo cuerpo editable, mismos destinatarios y adjuntos.
  // Tener dos plantillas distintas para lo mismo confunde a contabilidad.
  var datos={
    proveedor:f.cardname||f.cardcode||'',
    dkc:f.numatcard||'',
    dept:'',
    total:Number(f.doctotal)||0,
    abonado:Number(f.paidsum)||0,
    saldo:Number(f.saldo!=null?f.saldo
          :((Number(f.doctotal)||0)-(Number(f.paidsum)||0))),
    eta:_fechaCorta(f.fecha_eta)
  };

  showT('Armando la factura en PDF…');
  await _solPagoAbrirModal(String(f.docnum), 'cancelacion',
                           {datos:datos, factura:f});

  // Por DELANTE del detalle de la factura. La solicitud vive en la capa
  // 10001 y el detalle en la 10058: se abría detrás y parecía que el botón
  // no hacía nada.
  try{
    var sp=document.getElementById('modalSolPago');
    if(sp) sp.style.zIndex='10070';
  }catch(e){}

  // Y el PDF de la factura, ya adjunto al abrir
  try{
    var ls=await _fresTraerLineas(f.docentry);
    var pdf=await _fresPdf(f, ls);
    var b64=pdf.output('datauristring').split(',')[1];
    if(b64){
      window._mailAdj=window._mailAdj||[];
      window._mailAdj.push({nombre:_fresNombrePdf(f), mime:'application/pdf',
                            contenido:b64,
                            kb:Math.round(b64.length*0.75/1024)});
      try{ mailPintarAdjuntos(); }catch(e){ console.warn('[FRES] adjuntos:', e); }
    }
  }catch(e){
    console.warn('[FRES] no pude adjuntar el PDF:', e);
    showT('La solicitud se abrió, pero el PDF de la factura no se pudo armar', 8000);
  }
}


// ── El PDF de la factura reserva ────────────────────────────────────────
// Con el mismo reparto de columnas que SAP: piezas, kilos, bultos, empaque,
// referencia, descripción, cantidad, unidad, precio y total.
async function _fresPdf(f, lineas){
  if(!window.jspdf || !window.jspdf.jsPDF){
    throw new Error('la librería de PDF no cargó; recarga la página');
  }
  var doc=new window.jspdf.jsPDF({unit:'pt', format:'letter'});
  var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
  var M=32, y=44;

  var txt=function(t, x, yy, size, bold, align){
    doc.setFont('helvetica', bold?'bold':'normal');
    doc.setFontSize(size||9);
    doc.text(String(t==null?'':t), x, yy, align?{align:align}:undefined);
  };

  // Cabecera
  txt('KENNEDY CENTER CORP.', M, y, 13, true); y+=15;
  txt('No. Factura #: '+(f.docnum||''), M, y, 10, true);
  txt('Fecha contabilización: '+_fechaCorta(f.docdate), W-M, y, 9, false, 'right');
  y+=13;
  txt((f.cardcode||'')+'  '+(f.cardname||''), M, y, 10);
  txt('Vencimiento: '+_fechaCorta(f.docduedate), W-M, y, 9, false, 'right');
  y+=12;
  if(f.numatcard){ txt('Ref.: '+f.numatcard, M, y, 9); }
  if(f.ordenes){ txt('Órdenes: '+f.ordenes, W-M, y, 9, false, 'right'); }
  y+=10;
  doc.setDrawColor(150); doc.line(M, y, W-M, y); y+=14;

  // Las columnas, con el ancho que pide cada dato
  var cols=[
    ['#',           26, 'right'],
    ['Pc3',         42, 'right'],
    ['Kilos',       48, 'right'],
    ['Bulto',       34, 'right'],
    ['Empaque',     54, 'left'],
    ['Referencia',  64, 'left'],
    ['Descripción',130, 'left'],
    ['Cantidad',    46, 'right'],
    ['UM',          28, 'left'],
    ['Precio',      44, 'right'],
    ['Total',       52, 'right']
  ];
  var xs=[], x=M;
  cols.forEach(function(c){ xs.push(x); x+=c[1]; });

  var cabecera=function(){
    doc.setFillColor(238,238,238);
    doc.rect(M, y-9, W-M*2, 14, 'F');
    cols.forEach(function(c,i){
      txt(c[0], c[2]==='right' ? xs[i]+c[1]-3 : xs[i]+2, y, 7.5, true,
          c[2]==='right'?'right':null);
    });
    y+=13;
  };
  cabecera();

  var n=function(v, d){ return _fmtN2(Number(v)||0, d); };
  var sum={pcs:0, kilos:0, bultos:0, cant:0, total:0};

  (lineas||[]).forEach(function(l, i){
    if(y > H-96){ doc.addPage(); y=48; cabecera(); }
    var desc=String(l.descripcion||'');
    if(desc.length>34) desc=desc.slice(0,33)+'…';
    var vals=[String(i+1), n(l.pcs), n(l.kilos), n(l.bultos),
              String(l.empaque||''), String(l.itemcode||''), desc,
              n(l.cantidad), String(l.um||''), n(l.precio), n(l.total_linea)];
    vals.forEach(function(v, k){
      txt(v, cols[k][2]==='right' ? xs[k]+cols[k][1]-3 : xs[k]+2, y, 7.5, false,
          cols[k][2]==='right'?'right':null);
    });
    sum.pcs+=Number(l.pcs)||0; sum.kilos+=Number(l.kilos)||0;
    sum.bultos+=Number(l.bultos)||0; sum.cant+=Number(l.cantidad)||0;
    sum.total+=Number(l.total_linea)||0;
    y+=11;
  });

  // La fila de sumas, como en SAP
  doc.setDrawColor(150); doc.line(M, y, W-M, y); y+=11;
  [['',0],[n(sum.pcs),1],[n(sum.kilos),2],[n(sum.bultos),3],[ '',4],[ '',5],
   ['',6],[n(sum.cant),7]].forEach(function(p){
    var k=p[1];
    txt(p[0], cols[k][2]==='right' ? xs[k]+cols[k][1]-3 : xs[k]+2, y, 7.5, true,
        cols[k][2]==='right'?'right':null);
  });
  y+=18;

  if(f.comments){
    doc.setDrawColor(200); doc.line(M, y-8, W-M, y-8);
    var lineasC=doc.splitTextToSize(String(f.comments), W-M*2);
    lineasC.slice(0,4).forEach(function(l){ txt(l, M, y, 8); y+=10; });
    y+=4;
  }

  txt('Total  '+_fmtN2(f.doctotal)+' '+(f.moneda||''), W-M, y+6, 12, true, 'right');
  if(Number(f.paidsum)){
    y+=16;
    txt('Pagado  '+_fmtN2(f.paidsum), W-M, y+6, 9, false, 'right');
    y+=12;
    txt('Saldo  '+_fmtN2(f.saldo), W-M, y+6, 10, true, 'right');
  }

  return doc;
}

function _fresNombrePdf(f){
  return 'Factura-reserva-'+(f.docnum||'')
    + (f.numatcard ? ('-'+String(f.numatcard).replace(/[^\w-]/g,'')) : '')
    + '.pdf';
}

// Las líneas de la factura, de la tabla que baja el worker
// Las líneas de la factura. Primero las de la propia factura (PCH1, que baja
// el worker); si aún no están, las de las órdenes que cubre, que es lo mismo
// que enseña la pantalla. Antes el PDF solo miraba la primera fuente: si el
// worker no la había bajado todavía, salía vacío mientras la pantalla sí
// tenía las líneas.
async function _fresTraerLineas(docentry){
  var f=(window._fres.filas||[]).filter(function(x){
    return String(x.docentry)===String(docentry); })[0] || window._fresActual || {};
  try{
    var r=await fetch(SB+'/rest/v1/opch_reserva_lineas?select=*&docentry=eq.'
      +Number(docentry)+'&order=linenum&limit=500',{headers:SBH});
    if(r.ok){
      var ls=await r.json()||[];
      if(ls.length){ _dbg('[FRES] '+ls.length+' línea(s) de la factura'); return ls; }
    }
  }catch(e){ console.warn('[FRES] líneas de la factura:', e); }

  // Respaldo: las de las órdenes de compra
  try{
    var nums=String(f.ordenes||'').split(',')
      .map(function(x){ return x.replace(/[^0-9]/g,''); }).filter(Boolean);
    if(!nums.length) return [];
    var r2=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=in.('
      +nums.join(',')+')&order=docnum,linenum&limit=500',{headers:SBH});
    if(!r2.ok) return [];
    var ol=await r2.json()||[];
    _dbg('[FRES] usando '+ol.length+' línea(s) de las órdenes como respaldo');
    return ol.map(function(l){
      var cant=Number(l.cantidad!=null?l.cantidad:l.quantity)||0;
      var pre=Number(l.precio!=null?l.precio:l.price)||0;
      return {itemcode:l.itemcode, descripcion:l.itemname||l.dscription||'',
              cantidad:cant, precio:pre, total_linea:cant*pre,
              um:l.um||l.unidad||'', pcs:Number(l.volumen||l.cbm)||0,
              kilos:Number(l.peso)||0, bultos:Number(l.bultos||l.cartones)||0,
              empaque:l.empaque||'', picturname:l.picturname||'',
              foto_url:l.foto_url||'', docnum:l.docnum};
    });
  }catch(e){ console.warn('[FRES] líneas de las órdenes:', e); return []; }
}

async function _fresDescargar(){
  var f=window._fresActual; if(!f) return;
  showT('Armando el PDF…');
  try{
    var ls=await _fresTraerLineas(f.docentry);
    var doc=await _fresPdf(f, ls);
    doc.save(_fresNombrePdf(f));
    if(!ls.length){
      showT('El PDF salió sin líneas: el worker aún no las ha bajado', 8000);
    }
  }catch(e){
    showT('No pude armar el PDF: '+(e.message||e), 9000);
    console.warn('[FRES] pdf:', e);
  }
}

renderLogin();


/* ═══════════════════════════════════════════════════════════════════════════
   MAPA DE RELACIONES · orden de compra -> facturas reserva
   ───────────────────────────────────────────────────────────────────────────
   Lo mismo que el "Relationship Map" de SAP, dentro de cada orden. Las
   relaciones las lee el worker por DI API (tabla mapa_oc_reserva); aquí solo
   se dibujan. Cada factura se abre con un clic en el mismo detalle de la
   pantalla Facturas Reserva (datos, líneas, PDF y cancelación).
   El botón "Actualizar desde SAP" deja la orden en mapa_relaciones_queue y
   el worker la relee al momento, sin esperar a la pasada de fondo.
   ═══════════════════════════════════════════════════════════════════════════ */

window._mrCache = window._mrCache || {};
window._mrSigue = window._mrSigue || {};

var MR_CAJA = 112, MR_HUECO = 12, MR_ANCHO_FLECHAS = 74;

function _mrBarraOrden(o){
  try{
    if(!o || o._noSap || !_frPuede()) return '';
    var dn=String(o.id||'').trim();
    if(!/^\d+$/.test(dn)) return '';
    setTimeout(function(){ _mrCargar(dn); }, 30);
    return '<div style="background:var(--surface-1);border:0.5px solid var(--border);'
      +'border-radius:11px;padding:11px 14px;margin-bottom:12px">'
      +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:9px">'
      +'<i class="ti ti-sitemap" style="font-size:18px;color:var(--t-azul)"></i>'
      +'<div style="flex:1;min-width:170px"><div style="font-size:13px;font-weight:700">'
      +'Mapa de relaciones</div><div id="mrRes'+dn+'" style="font-size:11px;'
      +'color:var(--text-muted)">Facturas reserva que salieron de esta orden</div></div>'
      +'<span id="mrEst'+dn+'" style="font-size:11px;color:var(--text-muted)"></span>'
      +'<button class="xb" id="mrBtn'+dn+'" onclick="event.stopPropagation();'
      +'_mrPedir(\''+dn+'\')" title="El worker relee las facturas de este proveedor '
      +'en SAP por DI API"><i class="ti ti-refresh"></i> Actualizar desde SAP</button></div>'
      +'<div id="mrMapa'+dn+'" style="overflow-x:auto">'
      +(window._mrCache[dn] ? _mrDibujar(o, window._mrCache[dn])
        : '<div style="font-size:11.5px;color:var(--text-muted)">Cargando el mapa…</div>')
      +'</div></div>';
  }catch(e){ console.warn('[MAPA] barra:', e); return ''; }
}

function _mrOrden(dn){
  try{
    return (orders || []).filter(function(x){
      return String(x.id)===String(dn); })[0] || {id:dn};
  }catch(e){ return {id:dn}; }
}

async function _mrCargar(dn){
  var c=document.getElementById('mrMapa'+dn);
  if(!c) return;
  try{
    var r=await fetch(SB+'/rest/v1/mapa_oc_reserva?select=*&po_docnum=eq.'+dn
      +'&order=fr_fecha.asc,fr_docnum.asc',{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      if(t.indexOf('does not exist')>=0 || t.indexOf('relation')>=0 || r.status===404)
        throw new Error('falta la tabla: corre mapa_relaciones.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,140));
    }
    var filas=await r.json()||[];
    // Ventas directas: de qué pedido de venta cuelga la orden
    try{
      var rp=await fetch(SB+'/rest/v1/mapa_oc_pedido?select=*&po_docnum=eq.'+dn,{headers:SBH});
      window._mrPedido=window._mrPedido||{};
      window._mrPedido[dn]= rp.ok ? ((await rp.json())||[])[0]||null : null;
    }catch(e){ _dbg('[MAPA] pedido de venta: '+(e.message||e)); }
    // Las ENTRADAS de mercancía: el mapa de SAP las enseña y aquí faltaban.
    // Pueden colgar de la orden o de sus facturas reserva.
    try{
      var nums=[dn].concat(filas.map(function(f){ return String(f.fr_docnum||''); }))
                .filter(Boolean);
      var ents=[];
      for(var i=0;i<nums.length && ents.length<6;i++){
        var re=await fetch(SB+'/rest/v1/opdn_entradas?select=docentry,docnum,docdate,total,'
          +'num_doc_com,ordenes,facturas&or=(ordenes.like.*'+nums[i]+'*,facturas.like.*'
          +nums[i]+'*)&limit=5',{headers:SBH});
        if(!re.ok) continue;
        (await re.json()||[]).forEach(function(e){
          if(!ents.some(function(z){ return z.docentry===e.docentry; })) ents.push(e);
        });
      }
      window._mrEntradas=window._mrEntradas||{};
      window._mrEntradas[dn]=ents;
    }catch(e){ _dbg('[MAPA] entradas: '+(e.message||e)); }

    window._mrCache[dn]=filas;
    c=document.getElementById('mrMapa'+dn);
    if(c) c.innerHTML=_mrDibujar(_mrOrden(dn), filas)+_mrEntradasHtml(dn);
    _mrResumen(dn, filas);
  }catch(e){
    c=document.getElementById('mrMapa'+dn);
    if(c) c.innerHTML='<div class="nota" style="background:var(--pastel-error);'
      +'color:var(--t-rojo)">No pude cargar el mapa: '+_esc(e.message||e)+'</div>';
  }
}

function _mrResumen(dn, filas){
  var el=document.getElementById('mrRes'+dn);
  if(!el) return;
  var vivas=filas.filter(function(f){ return !f.fr_cancelada; });
  var fact=vivas.reduce(function(a,f){ return a+(Number(f.importe)||0); },0);
  var o=_mrOrden(dn), tot=Number(o.valor)||0;
  var leido=filas.reduce(function(a,f){ return f.leido_en>a?f.leido_en:a; },'');
  el.innerHTML = filas.length
    ? (vivas.length+' factura(s) reserva'
       +(filas.length>vivas.length?' · '+(filas.length-vivas.length)+' cancelada(s)':'')
       +' · facturado de esta orden <b>'+_fmtN2(fact)+'</b>'
       +(tot>0?' de '+_fmtN2(tot)+' ('+Math.round(fact*100/tot)+'%)':'')
       +(leido?' · leído de SAP '+_fechaCorta(leido):''))
    : 'Facturas reserva que salieron de esta orden';
}

function _mrCaja(titulo, fondo, cuerpo, extra){
  return '<div style="width:196px;flex-shrink:0;background:var(--surface-2);'
    +'border:1px solid #9DB3D9;border-radius:6px;overflow:hidden;'
    +'box-shadow:2px 2px 0 rgba(0,0,0,.06);'+(extra||'')+'">'
    +'<div style="background:'+fondo+';font-size:11px;font-weight:700;text-align:center;'
    +'padding:4px 6px;border-bottom:1px solid #9DB3D9;color:#1E3A5F">'+titulo+'</div>'
    +'<div style="padding:6px 9px;font-size:11.5px;line-height:1.45;text-align:right">'
    +cuerpo+'</div></div>';
}

function _mrDibujar(o, filas){
  var dn=String(o.id);
  var bp=_mrCaja('Socio de negocio','#D9E4F5',
      '<div style="text-align:left"><b>'+_esc(o.resp||'')+'</b><br>'
      +_esc(String(o.prov||'').slice(0,40))+'</div>');
  var ped=((window._mrPedido||{})[dn])||null;
  var cajaPed = ped ? (_mrCaja('Pedido de venta','#FFF6C8',
      '<b>'+_esc(ped.so_docnum)+'</b><br>'+_esc(_fechaCorta(ped.so_fecha))
      +'<br>'+_esc(String(ped.so_cardname||'').slice(0,26))
      +'<br><b>'+_fmtN2(ped.so_total)+'</b>', 'border-color:#E0B64A')
      +_mrLineaRecta()) : '';
  var po=_mrCaja('Orden de compra','#FFE9A8',
      '<b>'+_esc(dn)+'</b><br>'+_esc(o.fechaCreacion||'')
      +(o.num_proveedor?'<br>'+_esc(o.num_proveedor):'')
      +'<br><b>'+_fmtN2(o.valor)+'</b>', 'border-color:#E0B64A');

  if(!filas.length){
    return '<div style="display:flex;align-items:center;gap:0;padding:4px 2px">'
      +bp+_mrLineaRecta()+cajaPed+po
      +'<div style="margin-left:18px;font-size:11.5px;color:var(--text-muted);'
      +'max-width:320px">Esta orden no tiene facturas reserva en SAP todavía. '
      +'Si se acaba de crear una, pulsa <b>Actualizar desde SAP</b>.</div></div>';
  }

  var n=filas.length, H=n*MR_CAJA+(n-1)*MR_HUECO, mid=H/2, W=MR_ANCHO_FLECHAS;
  var svg='<svg width="'+W+'" height="'+H+'" style="flex-shrink:0;display:block">'
    +'<defs><marker id="mrPunta'+dn+'" viewBox="0 0 10 10" refX="9" refY="5" '
    +'markerWidth="7" markerHeight="7" orient="auto-start-reverse">'
    +'<path d="M0,0 L10,5 L0,10 z" fill="#6B8FD6"/></marker></defs>'
    + filas.map(function(f,i){
        var y=i*(MR_CAJA+MR_HUECO)+MR_CAJA/2;
        return '<path d="M0,'+mid+' C'+(W*0.55)+','+mid+' '+(W*0.45)+','+y+' '+(W-2)+','+y+'" '
          +'fill="none" stroke="'+(f.fr_cancelada?'#D08A8A':'#6B8FD6')+'" stroke-width="2" '
          +(f.fr_cancelada?'stroke-dasharray="4 3" ':'')
          +'marker-end="url(#mrPunta'+dn+')"/>';
      }).join('')
    +'</svg>';

  var facturas='<div style="display:flex;flex-direction:column;gap:'+MR_HUECO+'px">'
    + filas.map(function(f){
        var barra = f.fr_cancelada ? ['#C62828','CANCELADA']
                  : String(f.fr_estado)==='C' ? ['#8A94A6','Cerrada'] : ['#2E7D32','Abierta'];
        return '<div onclick="event.stopPropagation();_mrAbrirFactura('+Number(f.fr_docentry)+')" '
          +'title="Abrir la factura reserva #'+_esc(f.fr_docnum)+'" '
          +'onmouseover="this.style.transform=\'translateX(3px)\';this.style.boxShadow=\'0 3px 10px rgba(30,58,95,.25)\'" '
          +'onmouseout="this.style.transform=\'\';this.style.boxShadow=\'\'" '
          +'style="cursor:pointer;height:'+MR_CAJA+'px;width:214px;box-sizing:border-box;'
          +'background:var(--surface-2);border:1px solid #9DB3D9;border-radius:6px;'
          +'overflow:hidden;display:flex;flex-direction:column;transition:all .12s;'
          +(f.fr_cancelada?'opacity:.7;':'')+'">'
          +'<div style="background:#D9E4F5;font-size:11px;font-weight:700;text-align:center;'
          +'padding:3px 6px;border-bottom:1px solid #9DB3D9;color:#1E3A5F">'
          +'Factura reserva <i class="ti ti-external-link" style="font-size:10px"></i></div>'
          +'<div style="flex:1;overflow:hidden;padding:4px 9px;font-size:11.5px;line-height:1.35;text-align:right">'
          +'<b style="color:var(--t-azul);text-decoration:underline">'+_esc(f.fr_docnum)+'</b>'
          +'<br>'+_esc(_fechaCorta(f.fr_fecha))
          +(f.fr_numatcard?'<br>'+_esc(f.fr_numatcard):'')
          +'<br><b>'+_esc(f.fr_moneda||'')+' '+_fmtN2(f.fr_total)+'</b>'
          +(Math.abs((Number(f.importe)||0)-(Number(f.fr_total)||0))>0.01
            ? '<br><span style="font-size:10px;color:var(--text-muted)">de esta orden '
              +_fmtN2(f.importe)+'</span>' : '')+'</div>'
          +'<div style="background:'+barra[0]+';color:#fff;font-size:9.5px;font-weight:700;'
          +'text-align:center;padding:1px 0;letter-spacing:.4px">'+barra[1]+'</div></div>';
      }).join('')
    +'</div>';

  return '<div style="display:flex;align-items:center;padding:4px 2px;min-width:max-content">'
    +bp+_mrLineaRecta()+cajaPed+po+svg+facturas+'</div>'
    +(ped?('<div style="font-size:10.5px;color:var(--t-verde);margin-top:5px">'
      +'<i class="ti ti-user-check"></i> Venta directa: esta orden cuelga del pedido '
      +'de venta <b>#'+_esc(ped.so_docnum)+'</b> de '+_esc(ped.so_cardname||'')+'.</div>'):'');
}

function _mrLineaRecta(){
  return '<div style="width:26px;height:2px;background:#6B8FD6;flex-shrink:0"></div>';
}

// Abre la factura en el mismo detalle de la pantalla Facturas Reserva
async function _mrAbrirFactura(docentry){
  window._fres = window._fres || {filas:[], q:'', estado:'', cargando:false};
  var d=window._fres;
  var ya=(d.filas||[]).some(function(x){ return String(x.docentry)===String(docentry); });
  if(!ya){
    try{
      var r=await fetch(SB+'/rest/v1/opch_reserva?select=*&docentry=eq.'+docentry,
                        {headers:SBH});
      var f=r.ok ? ((await r.json())||[])[0] : null;
      if(!f){
        showT('Esa factura todavía no ha bajado al portal. Pulsa Sync y vuelve a probar.', 6000);
        return;
      }
      d.filas=(d.filas||[]).concat([f]);
    }catch(e){ showT('No pude abrir la factura: '+(e.message||e)); return; }
  }
  _fresAbrir(docentry);
}

// El botón: pide al worker que relea esta orden en SAP por DI API
async function _mrPedir(dn){
  var btn=document.getElementById('mrBtn'+dn), est=document.getElementById('mrEst'+dn);
  if(btn) btn.disabled=true;
  if(est) est.innerHTML='<i class="ti ti-loader-2"></i> Esperando al worker…';
  try{
    var h=Object.assign({}, SBH, {'Prefer':'return=representation'});
    var r=await fetch(SB+'/rest/v1/mapa_relaciones_queue',{method:'POST',headers:h,
      body:JSON.stringify({po_docnum:Number(dn), estado:'pendiente',
                           creado_por:(function(){ try{ return CU.email||''; }catch(e){ return ''; } })()})});
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));
    var reg=((await r.json())||[])[0];
    _mrSeguir(dn, reg.id, Date.now());
  }catch(e){
    if(btn) btn.disabled=false;
    if(est) est.innerHTML='<span style="color:var(--t-rojo)">No pude pedirlo: '
      +_esc(e.message||e)+'</span>';
  }
}

// Mismo ritmo que las otras colas: cada 4 s, hasta 10 minutos
function _mrSeguir(dn, id, desde){
  clearTimeout(window._mrSigue[dn]);
  window._mrSigue[dn]=setTimeout(async function(){
    var btn=document.getElementById('mrBtn'+dn), est=document.getElementById('mrEst'+dn);
    try{
      var r=await fetch(SB+'/rest/v1/mapa_relaciones_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q && q.estado==='hecha'){
        if(btn) btn.disabled=false;
        if(est) est.innerHTML='<span style="color:var(--t-verde)"><i class="ti ti-check"></i> '
          +'Leído de SAP · '+(q.encontradas||0)+' factura(s)</span>';
        return _mrCargar(dn);
      }
      if(q && q.estado==='error'){
        if(btn) btn.disabled=false;
        if(est) est.innerHTML='<span style="color:var(--t-rojo)" title="'+_esc(q.error_msg||'')+'">'
          +'<i class="ti ti-alert-triangle"></i> Error: '+_esc(String(q.error_msg||'').slice(0,90))+'</span>';
        return;
      }
      if(Date.now()-desde > 10*60*1000){
        if(btn) btn.disabled=false;
        if(est) est.innerHTML='<span style="color:var(--t-marron)">El worker no responde: '
          +'revisa que esté corriendo.</span>';
        return;
      }
      if(est && q) est.innerHTML='<i class="ti ti-loader-2"></i> '
        +(q.estado==='en_curso'?'Leyendo SAP por DI API…':'Esperando al worker…');
    }catch(e){}
    _mrSeguir(dn, id, desde);
  }, 4000);
}


/* ═══════════════════════════════════════════════════════════════════════════
   COMPROBACIÓN ANTES DE PEDIR LA CANCELACIÓN DEL SALDO   (prefijo [SPC])
   ───────────────────────────────────────────────────────────────────────────
   Antes de mandar la solicitud de cancelación a contabilidad se adjunta la
   factura del proveedor y se compara contra la factura reserva de SAP de esa
   orden: artículo por artículo (cantidad, precio, importe, y bultos y peso
   cuando los dos documentos los traen) y el total.
   · Si coincide, se envía normal.
   · Si hay diferencias, o la orden no tiene factura reserva, solo se puede
     enviar marcando que se envía así y explicando el motivo. El resultado
     queda en la solicitud (columna comprobacion) y contabilidad lo ve.
   ═══════════════════════════════════════════════════════════════════════════ */

window._spc = null;

var SPC_TOL_TOTAL = 0.05;     // diferencia de total que se da por buena
var SPC_TOL_PRECIO = 0.005;

function _spcBloqueHtml(){
  return '<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">'
    +'COMPROBACIÓN · FACTURA DEL PROVEEDOR CONTRA FACTURA RESERVA</div>'
    +'<div id="sp-comprob" style="border:1.5px solid #E9C08A;background:#FFFBF3;'
    +'border-radius:9px;padding:10px 12px;margin-bottom:12px;font-size:11.5px">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Buscando la factura reserva de la orden…</div>';
}

async function _spcIniciar(oid, fac){
  window._spc={oid:String(oid), facturas:[], elegidas:{}, lineas:[], prov:null,
               res:null, estado:'cargando', archivo:'', acepta:false, motivo:''};
  var S=window._spc;
  try{
    var facs=[];
    if(fac){
      facs=[fac];
    } else if(/^\d+$/.test(String(oid))){
      // Primero el mapa de relaciones (leído de SAP por DI API)
      try{
        var rm=await fetch(SB+'/rest/v1/mapa_oc_reserva?select=fr_docentry,fr_cancelada'
          +'&po_docnum=eq.'+encodeURIComponent(oid),{headers:SBH});
        var mm=rm.ok ? (await rm.json()||[]) : [];
        var ents=mm.filter(function(x){ return !x.fr_cancelada; })
                   .map(function(x){ return x.fr_docentry; });
        if(ents.length){
          var rf=await fetch(SB+'/rest/v1/opch_reserva?select=*&docentry=in.('
            +ents.join(',')+')',{headers:SBH});
          if(rf.ok) facs=await rf.json()||[];
        }
      }catch(e){ _dbg('[SPC] mapa: '+(e.message||e)); }
      // Si el mapa aún no la tiene, por la lista de órdenes de la factura
      if(!facs.length){
        var r2=await fetch(SB+'/rest/v1/opch_reserva?select=*&ordenes=ilike.'
          +encodeURIComponent('*#'+oid+'*'),{headers:SBH});
        var cand=r2.ok ? (await r2.json()||[]) : [];
        facs=cand.filter(function(f){
          return String(f.ordenes||'').split(/[,\s]+/).some(function(t){
            return t.replace('#','')===String(oid); });
        });
      }
    } else {
      S.estado='no_aplica';
      return _spcPintar();
    }
    facs=facs.filter(function(f){
      var c=String(f.canceled||'').toUpperCase();
      return c!=='Y' && c!=='C';
    });
    S.facturas=facs;
    if(!facs.length){ S.estado='sin_fr'; return _spcPintar(); }
    facs.forEach(function(f){ S.elegidas[f.docentry]=true; });

    var rl=await fetch(SB+'/rest/v1/opch_reserva_lineas?select=*&docentry=in.('
      +facs.map(function(f){ return f.docentry; }).join(',')+')&order=docentry,linenum',
      {headers:SBH});
    S.lineas=rl.ok ? (await rl.json()||[]) : [];
    S.estado='listo';
  }catch(e){
    S.estado='error'; S.error=e.message||String(e);
  }
  _spcPintar();
}

function _spcElegir(de, v){
  var S=window._spc; if(!S) return;
  S.elegidas[de]=!!v;
  if(S.prov) S.res=_spcComparar();
  _spcPintar();
}

// Lo de la factura reserva, agrupado por artículo
function _spcReserva(){
  var S=window._spc, por={}, total=0, n=0;
  S.facturas.forEach(function(f){ if(S.elegidas[f.docentry]){ total+=Number(f.doctotal)||0; n++; } });
  S.lineas.forEach(function(l){
    if(!S.elegidas[l.docentry]) return;
    var k=_ocNormSku(l.itemcode);
    var a=por[k]||(por[k]={itemcode:l.itemcode, nombre:l.descripcion||'',
                           cantidad:0, importe:0, bultos:0, kilos:0});
    a.cantidad+=Number(l.cantidad)||0;
    a.importe+=Number(l.total_linea)||((Number(l.cantidad)||0)*(Number(l.precio)||0));
    a.bultos+=Number(l.bultos)||0;
    a.kilos+=Number(l.kilos)||0;
  });
  Object.keys(por).forEach(function(k){
    var a=por[k]; a.precio=a.cantidad ? a.importe/a.cantidad : 0; });
  return {items:por, total:total, facturas:n};
}

async function _spcArchivo(input){
  var file=input && input.files && input.files[0];
  input.value='';
  if(!file) return;
  var S=window._spc; if(!S) return;
  // También va adjunta al correo para contabilidad
  try{ mailAddFiles([file]); }catch(e){}
  S.archivo=file.name; S.estado='leyendo'; S.prov=null; S.res=null;
  _spcPintar();
  try{
    S.prov=await _spcLeerFacturaProveedor(file);
    S.res=_spcComparar();
    S.estado='comparado';
  }catch(e){
    S.estado='error_lectura'; S.error=e.message||String(e);
  }
  _spcPintar();
}

async function _spcLeerFacturaProveedor(file){
  var nombre=String(file.name||'');
  var doc=await _iaDesdeBlob(file, nombre);
  if(!doc || !doc.bloques || !doc.bloques.length) throw new Error('no pude preparar «'+nombre+'»');
  var prompt='Este documento es la FACTURA COMERCIAL (commercial invoice) de un proveedor\n'
    +'de Kennedy Center. Devuelve SOLO un JSON, sin texto alrededor ni ```:\n'
    +'{"numero":"","fecha":"","proveedor":"","moneda":"",\n'
    +' "items":[{"itemcode":"","descripcion":"","cantidad":0,"precio":0,"importe":0,\n'
    +'           "bultos":0,"peso_kg":0,"cbm":0}],\n'
    +' "suma_lineas":0,"cargos":[{"concepto":"","monto":0}],"total":0,\n'
    +' "total_bultos":0,"total_peso_kg":0,"total_cbm":0}\n\n'
    +'REGLAS:\n'
    +'- "itemcode" es el codigo de Kennedy (KCC ITEM No.), no el del proveedor ni\n'
    +'  el de fabrica. Si aparece partido en dos lineas («BA-» y «319994»), JUNTALO.\n'
    +'- "cantidad" son las unidades (pcs) facturadas; "precio" el unitario;\n'
    +'  "importe" el total de la linea.\n'
    +'- "bultos" son los cartones (CTNS); "peso_kg" el peso bruto (G.W.) de la\n'
    +'  linea en kg; "cbm" el volumen en m3. Si no vienen, deja 0.\n'
    +'- Una fila por articulo. No incluyas filas de totales. No inventes nada.\n'
    +'- "total" es el importe FINAL de la factura; "cargos" lo que suma al total\n'
    +'  sin ser articulo (flete, etiquetas, descuentos en negativo).\n'
    +'- Si esta escaneado, lee igual.';
  var obj=await _iaJSON(doc.bloques.concat([{type:'text', text:prompt}]), 8000);
  var items=(obj && obj.items) || [];
  if(!items.length) throw new Error('la IA no encontró artículos en la factura del proveedor');
  var por={};
  items.forEach(function(it){
    var code=String(it.itemcode||'').trim();
    if(!code) return;
    var k=_ocNormSku(code);
    var a=por[k]||(por[k]={itemcode:code, nombre:it.descripcion||'', cantidad:0,
                           importe:0, bultos:0, kilos:0, cbm:0});
    var q=Number(it.cantidad)||0, p=Number(it.precio)||0;
    a.cantidad+=q;
    a.importe+=Number(it.importe)||(q*p);
    a.bultos+=Number(it.bultos)||0;
    a.kilos+=Number(it.peso_kg)||0;
    a.cbm+=Number(it.cbm)||0;
  });
  Object.keys(por).forEach(function(k){
    var a=por[k]; a.precio=a.cantidad ? a.importe/a.cantidad : 0; });
  _dbg('[SPC] factura del proveedor: '+Object.keys(por).length+' artículo(s)');
  return {items:por, numero:obj.numero||'', fecha:obj.fecha||'', moneda:obj.moneda||'',
          total:Number(obj.total)||0, suma:Number(obj.suma_lineas)||0,
          cargos:(obj.cargos||[]).filter(function(c){ return c && Number(c.monto); }),
          bultos:Number(obj.total_bultos)||0, kilos:Number(obj.total_peso_kg)||0};
}

function _spcComparar(){
  var S=window._spc, R=_spcReserva(), P=S.prov;
  var filas=[], usadas={};
  var codigosP=Object.keys(P.items).map(function(k){ return P.items[k].itemcode; });

  Object.keys(R.items).forEach(function(k){
    var r=R.items[k], p=P.items[k], modo='exacta';
    if(!p){
      var m=null; try{ m=_refEmparejar(codigosP, r.itemcode); }catch(e){}
      if(m){ p=P.items[_ocNormSku(m.codigo)]; modo=m.modo; }
    }
    if(!p){ filas.push({tipo:'falta_prov', r:r}); return; }
    usadas[_ocNormSku(p.itemcode)]=true;
    var dif=[];
    if(Math.abs(r.cantidad-p.cantidad)>0.0001) dif.push('cantidad');
    if(Math.abs(r.precio-p.precio)>SPC_TOL_PRECIO) dif.push('precio');
    if(Math.abs(r.importe-p.importe)>SPC_TOL_TOTAL) dif.push('importe');
    if(r.bultos>0 && p.bultos>0 && Math.abs(r.bultos-p.bultos)>0.01) dif.push('bultos');
    if(r.kilos>0 && p.kilos>0 && Math.abs(r.kilos-p.kilos)>Math.max(0.5, r.kilos*0.01)) dif.push('peso');
    filas.push({tipo:dif.length?'dif':'ok', r:r, p:p, dif:dif, modo:modo});
  });
  Object.keys(P.items).forEach(function(k){
    if(!usadas[k]) filas.push({tipo:'sobra_prov', p:P.items[k]});
  });

  var difTotal=(P.total||P.suma)-R.total;
  var nDif=filas.filter(function(f){ return f.tipo!=='ok'; }).length;
  var coincide = nDif===0 && Math.abs(difTotal)<=SPC_TOL_TOTAL;
  return {filas:filas, nDif:nDif, difTotal:difTotal, totalR:R.total,
          totalP:(P.total||P.suma), coincide:coincide};
}

function _spcPintar(){
  var box=document.getElementById('sp-comprob');
  var S=window._spc;
  if(!box || !S) return;
  var h='';
  if(S.estado==='cargando'){
    h='<span class="ai-ring g" style="vertical-align:-2px"></span> Buscando la factura reserva de la orden…';
  } else if(S.estado==='no_aplica'){
    h='<span style="color:var(--text-muted)">Esta orden todavía no está en SAP: no hay factura '
      +'reserva contra la que comparar.</span>';
  } else if(S.estado==='error'){
    h='<span style="color:var(--t-rojo)">No pude buscar la factura reserva: '+_esc(S.error||'')+'</span>';
  } else if(S.estado==='sin_fr'){
    h='<div style="color:var(--t-rojo);font-weight:700;margin-bottom:5px">'
      +'<i class="ti ti-alert-triangle"></i> La orden '+_esc(S.oid)+' no tiene factura reserva en SAP.</div>'
      +'<div style="color:var(--t-marron);margin-bottom:6px">La cancelación se compara contra la factura '
      +'reserva. Créala primero; si de verdad hay que pedirla sin ella, márcalo y explica por qué.</div>'
      + _spcAceptarHtml('Enviar sin comprobación');
  } else {
    // Las facturas reserva encontradas
    h+='<div style="margin-bottom:7px"><b style="color:var(--t-marron)">Factura(s) reserva de la orden:</b>'
      +'<div style="display:flex;flex-direction:column;gap:3px;margin-top:4px">'
      + S.facturas.map(function(f){
          return '<label style="display:flex;align-items:center;gap:7px;cursor:pointer">'
            +'<input type="checkbox" '+(S.elegidas[f.docentry]?'checked':'')+' '
            +'onchange="_spcElegir('+f.docentry+',this.checked)">'
            +'<span><b>#'+_esc(f.docnum)+'</b> · '+_esc(_fechaCorta(f.docdate))
            +(f.numatcard?(' · '+_esc(f.numatcard)):'')
            +' · <b>'+_fmtN2(f.doctotal)+'</b>'
            +(f.ordenes?(' <span style="color:var(--text-muted)">('+_esc(f.ordenes)+')</span>'):'')
            +'</span></label>';
        }).join('')
      +'</div></div>';

    h+='<label style="display:flex;align-items:center;gap:8px;padding:8px 10px;'
      +'border:1.5px dashed #E0A82E;border-radius:8px;cursor:pointer;background:var(--surface-0);'
      +'margin-bottom:7px"><i class="ti ti-file-upload" style="color:var(--t-marron);font-size:17px"></i>'
      +'<div style="flex:1"><div style="font-weight:700;color:var(--t-marron)">'
      +(S.archivo?'Cambiar la factura del proveedor':'ADJUNTAR LA FACTURA DEL PROVEEDOR')+'</div>'
      +'<div style="font-size:10.5px;color:var(--t-marron);opacity:.85">'
      +(S.archivo?_esc(S.archivo):'PDF, foto o Excel. Se compara sola y va adjunta al correo.')
      +'</div></div>'
      +'<input type="file" accept=".pdf,.xlsx,.xls,.csv,image/*" style="display:none" '
      +'onchange="_spcArchivo(this)"></label>';

    if(S.estado==='leyendo'){
      h+='<div style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo la factura del proveedor '
        +'con IA y comparando…</div>';
    } else if(S.estado==='error_lectura'){
      h+='<div style="color:var(--t-rojo)">No pude leer la factura: '+_esc(S.error||'')
        +'. Prueba con otro archivo (mejor PDF o Excel).</div>';
    } else if(S.res){
      h+=_spcResultadoHtml(S.res);
    } else {
      h+='<div style="color:var(--t-marron)"><i class="ti ti-info-circle"></i> Falta adjuntar la factura '
        +'del proveedor: sin ella no se puede enviar.</div>';
    }
  }
  box.innerHTML=h;
}

function _spcResultadoHtml(res){
  var S=window._spc, P=S.prov;
  var h='';
  if(res.coincide){
    h+='<div style="background:var(--pastel-ok);color:var(--t-verde);border-radius:7px;padding:7px 10px;'
      +'font-weight:700;margin-bottom:6px"><i class="ti ti-circle-check"></i> Coinciden: '
      +res.filas.length+' artículo(s) y el total '+_fmtN2(res.totalR)+'.</div>';
  } else {
    h+='<div style="background:var(--pastel-error);color:var(--t-rojo);border-radius:7px;padding:7px 10px;'
      +'font-weight:700;margin-bottom:6px"><i class="ti ti-alert-triangle"></i> No coinciden: '
      +res.nDif+' artículo(s) con diferencias'
      +(Math.abs(res.difTotal)>SPC_TOL_TOTAL?(' · el total difiere en '+_fmtN2(res.difTotal)):'')+'.</div>';
  }
  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:6px">'
    +'<span>Factura reserva: <b>'+_fmtN2(res.totalR)+'</b></span>'
    +'<span>Factura proveedor'+(P.numero?(' '+_esc(P.numero)):'')+': <b>'+_fmtN2(res.totalP)+'</b>'
    +(P.moneda?(' '+_esc(P.moneda)):'')+'</span>'
    +'<span style="color:'+(Math.abs(res.difTotal)>SPC_TOL_TOTAL?'var(--t-rojo)':'var(--t-verde)')+'">'
    +'Diferencia: <b>'+_fmtN2(res.difTotal)+'</b></span></div>';
  if(P.cargos && P.cargos.length){
    h+='<div style="font-size:10.5px;color:var(--t-marron);margin-bottom:6px">Cargos en la factura del '
      +'proveedor: '+P.cargos.map(function(c){ return _esc(c.concepto)+' '+_fmtN2(c.monto); }).join(' · ')
      +'</div>';
  }
  var celda=function(v, dec, marcar){
    return '<td style="text-align:right;'+(marcar?'background:var(--pastel-error);color:var(--t-rojo);font-weight:700':'')+'">'
      +(v==null?'—':Number(v).toLocaleString('es',{minimumFractionDigits:dec,maximumFractionDigits:dec}))+'</td>';
  };
  var ord=res.filas.slice().sort(function(a,b){ return (a.tipo==='ok')-(b.tipo==='ok'); });
  h+='<div style="max-height:260px;overflow:auto;border:0.5px solid var(--border);border-radius:7px;'
    +'background:var(--surface-0);margin-bottom:6px"><table style="width:100%;border-collapse:collapse;font-size:10.5px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0">'
    +'<th style="text-align:left;padding:4px 6px">Artículo</th>'
    +'<th>Cant. FR</th><th>Cant. prov.</th><th>Precio FR</th><th>Precio prov.</th>'
    +'<th>Importe FR</th><th>Importe prov.</th><th>Bultos FR/prov.</th><th></th></tr></thead><tbody>'
    + ord.map(function(f){
        var r=f.r||{}, p=f.p||{}, d=f.dif||[];
        var icono = f.tipo==='ok' ? '<i class="ti ti-check" style="color:var(--t-verde)"></i>'
                  : f.tipo==='falta_prov' ? '<span style="color:var(--t-rojo)">no está en la del proveedor</span>'
                  : f.tipo==='sobra_prov' ? '<span style="color:var(--t-rojo)">no está en la reserva</span>'
                  : '<i class="ti ti-alert-triangle" style="color:var(--t-rojo)"></i>';
        return '<tr style="border-top:0.5px solid var(--border)">'
          +'<td style="padding:3px 6px"><b>'+_esc(r.itemcode||p.itemcode||'')+'</b>'
          +(f.modo&&f.modo!=='exacta'?(' <span style="color:var(--t-marron)" title="Emparejado por parecido">≈ '
             +_esc(p.itemcode)+'</span>'):'')
          +'<div style="color:var(--text-muted);font-size:9.5px">'+_esc(String(r.nombre||p.nombre||'').slice(0,40))+'</div></td>'
          + celda(f.r?r.cantidad:null,0,d.indexOf('cantidad')>=0||f.tipo==='sobra_prov')
          + celda(f.p?p.cantidad:null,0,d.indexOf('cantidad')>=0||f.tipo==='falta_prov')
          + celda(f.r?r.precio:null,4,d.indexOf('precio')>=0)
          + celda(f.p?p.precio:null,4,d.indexOf('precio')>=0)
          + celda(f.r?r.importe:null,2,d.indexOf('importe')>=0)
          + celda(f.p?p.importe:null,2,d.indexOf('importe')>=0)
          +'<td style="text-align:right;'+(d.indexOf('bultos')>=0?'color:var(--t-rojo);font-weight:700':'')+'">'
          +(f.r&&r.bultos?_fmtN2(r.bultos):'—')+' / '+(f.p&&p.bultos?_fmtN2(p.bultos):'—')+'</td>'
          +'<td style="padding:3px 6px">'+icono+'</td></tr>';
      }).join('')
    +'</tbody></table></div>';
  if(!res.coincide) h+=_spcAceptarHtml('Enviar con estas diferencias');
  return h;
}

function _spcAceptarHtml(texto){
  var S=window._spc;
  return '<label style="display:flex;align-items:center;gap:7px;cursor:pointer;font-weight:600;'
    +'color:var(--t-rojo);margin-top:4px"><input type="checkbox" '+(S.acepta?'checked':'')+' '
    +'onchange="window._spc.acepta=this.checked"> '+_esc(texto)+'</label>'
    +'<input placeholder="Motivo (obligatorio): lo lee contabilidad" value="'+_esc(S.motivo||'')+'" '
    +'oninput="window._spc.motivo=this.value" style="width:100%;margin-top:5px;padding:6px 9px;'
    +'border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-2);'
    +'color:var(--text-primary)">';
}

// Lo llama _solPagoEnviar. Devuelve {ok, msg} y, si se puede enviar, el
// resumen que va en el correo y en la solicitud.
function _spcValidar(){
  var S=window._spc;
  if(!S || S.estado==='no_aplica') return {ok:true};
  if(S.estado==='cargando' || S.estado==='leyendo')
    return {ok:false, msg:'Espera a que termine la comprobación de la factura.'};
  var conMotivo=function(){ return S.acepta && String(S.motivo||'').trim().length>=5; };
  if(S.estado==='sin_fr' || S.estado==='error'){
    if(!conMotivo()) return {ok:false, msg:'La orden no tiene factura reserva para comparar. '
      +'Marca «Enviar sin comprobación» y escribe el motivo.'};
    return {ok:true, resumen:{estado:'sin_factura_reserva', motivo:S.motivo,
            por:(CU&&CU.name)||'', en:new Date().toISOString()},
            texto:'COMPROBACIÓN: la orden no tiene factura reserva en SAP. Motivo: '+S.motivo};
  }
  if(!S.res) return {ok:false, msg:'Adjunta la factura del proveedor: se compara contra la '
    +'factura reserva antes de enviar.'};
  var fr=S.facturas.filter(function(f){ return S.elegidas[f.docentry]; })
                   .map(function(f){ return '#'+f.docnum; }).join(', ');
  var base={facturas_reserva:fr, factura_proveedor:S.prov.numero||'', archivo:S.archivo,
            total_reserva:S.res.totalR, total_proveedor:S.res.totalP,
            diferencia:S.res.difTotal, articulos:S.res.filas.length, con_diferencia:S.res.nDif,
            detalle:S.res.filas.filter(function(f){ return f.tipo!=='ok'; }).slice(0,40).map(function(f){
              return {itemcode:(f.r||f.p).itemcode, tipo:f.tipo, campos:f.dif||[],
                      reserva:f.r?{cantidad:f.r.cantidad, precio:f.r.precio, importe:f.r.importe}:null,
                      proveedor:f.p?{cantidad:f.p.cantidad, precio:f.p.precio, importe:f.p.importe}:null};
            }),
            por:(CU&&CU.name)||'', en:new Date().toISOString()};
  var cab='COMPROBACIÓN contra factura reserva '+fr+': ';
  if(S.res.coincide){
    base.estado='coincide';
    return {ok:true, resumen:base,
      texto:cab+'la factura del proveedor '+(S.prov.numero||'')+' COINCIDE ('
        +S.res.filas.length+' artículos, total '+_fmtN2(S.res.totalR)+').'};
  }
  if(!conMotivo()) return {ok:false, msg:'La factura del proveedor no coincide con la factura '
    +'reserva. Revisa las diferencias; para enviar igual, marca la casilla y escribe el motivo.'};
  base.estado='diferencias'; base.motivo=S.motivo;
  return {ok:true, resumen:base,
    texto:cab+'CON DIFERENCIAS. '+S.res.nDif+' artículo(s) distintos; total reserva '
      +_fmtN2(S.res.totalR)+', total proveedor '+_fmtN2(S.res.totalP)
      +' (diferencia '+_fmtN2(S.res.difTotal)+'). Motivo para enviar: '+S.motivo};
}

// El departamento de la solicitud, corregible desde la propia alerta. Las
// solicitudes sin orden en el portal (SIN-SAP-…) no siempre traen el
// departamento bien, y entonces salen donde no tocan.
function _solDeptChip(x){
  if(!(CU && (CU.role==='contabilidad' || _esGerencia()))){
    return x.dept ? ('<span style="font-size:10px;padding:2px 8px;border-radius:8px;'
      +'background:var(--surface-1);color:var(--text-muted)">'+(EMOJIS2[x.dept]||'')+' '
      +_esc(dL(x.dept))+'</span>') : '';
  }
  return '<span title="Departamento de la solicitud">'
    + _solDesplegable(x,'dept',
        [{v:null,t:'— sin departamento',c:'var(--text-muted)'}].concat(
          DEPTS_ALL.map(function(d){ return {v:d, t:dL(d)}; })),'140px')
    +'</span>';
}

/* ── Buscar y filtrar dentro de las solicitudes ───────────────────────────
   Contabilidad ve de golpe todas las solicitudes de abono y de cancelación
   de todos los departamentos. Con un buscador por proveedor (o por orden,
   DKC o quien la pidió) y un filtro por departamento, se llega a la que se
   busca sin recorrer la lista entera. */
window._solSecFiltro = window._solSecFiltro || {};

function _solSecSet(tipo, campo, valor){
  var f=window._solSecFiltro[tipo]=window._solSecFiltro[tipo]||{};
  f[campo]=valor;
  try{ rAlertas(); }catch(e){}
  setTimeout(function(){
    var el=document.getElementById('solq-'+tipo);
    if(el && campo==='q'){ el.focus(); el.selectionStart=el.value.length; }
  }, 40);
}

function _solSecLimpiar(tipo){
  window._solSecFiltro[tipo]={};
  try{ rAlertas(); }catch(e){}
}

function _solFiltrarSeccion(lista, tipo){
  var f=window._solSecFiltro[tipo]||{};
  var q=String(f.q||'').toLowerCase().trim();
  return (lista||[]).filter(function(x){
    if(f.dept && String(x.dept||'otros')!==f.dept) return false;
    if(!q) return true;
    var o=_solPagoDatosOrden(x.docnum)||{};
    return [x.proveedor, o.prov, o.resp, x.docnum, x.dkc, o.num_proveedor,
            x.solicitado_por, x.nota]
      .map(function(v){ return String(v||'').toLowerCase(); })
      .some(function(v){ return v.indexOf(q)>=0; });
  });
}

function _solBarraFiltro(tipo, total, visibles, bd){
  var f=window._solSecFiltro[tipo]||{};
  var lista=_solPagoPendientes(tipo);
  var deptos={};
  lista.forEach(function(x){ var d=x.dept||'otros'; deptos[d]=(deptos[d]||0)+1; });
  var pastilla=function(k, txt, n){
    var on=(f.dept||'')===k;
    return '<span onclick="_solSecSet(\''+tipo+'\',\'dept\',\''+k+'\')" '
      +'style="cursor:pointer;font-size:10.5px;padding:2px 9px;border-radius:20px;'
      +'border:0.5px solid '+(on?'transparent':'var(--border)')+';'
      +'background:'+(on?'var(--fill-accent)':'var(--surface-0)')+';'
      +'color:'+(on?'#fff':'var(--text-secondary)')+'">'+txt
      +(n!=null?(' <b>'+n+'</b>'):'')+'</span>';
  };
  return '<div style="border-top:0.5px solid '+bd+';padding:8px 13px;display:flex;'
    +'gap:7px;flex-wrap:wrap;align-items:center;background:rgba(255,255,255,.35)">'
    +'<i class="ti ti-search" style="font-size:13px;color:var(--text-muted)"></i>'
    +'<input id="solq-'+tipo+'" value="'+_esc(f.q||'')+'" '
    +'placeholder="Buscar proveedor, orden, DKC o quién la pidió…" '
    +'oninput="clearTimeout(window._solQT);window._solQT=setTimeout(function(){'
    +'_solSecSet(\''+tipo+'\',\'q\',document.getElementById(\'solq-'+tipo+'\').value)},300)" '
    +'style="flex:1;min-width:210px;font-size:11.5px;padding:5px 9px;'
    +'border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);'
    +'color:var(--text-primary)">'
    + pastilla('','Todos', total)
    + Object.keys(deptos).sort().map(function(d){
        return pastilla(d, (EMOJIS2[d]||'')+' '+dL(d), deptos[d]); }).join('')
    +((f.q||f.dept)?('<span onclick="_solSecLimpiar(\''+tipo+'\')" '
      +'style="cursor:pointer;font-size:10.5px;color:var(--t-rojo)">'
      +'<i class="ti ti-x"></i> quitar filtro ('+visibles+' de '+total+')</span>'):'')
    +'</div>';
}

// La marca que ve contabilidad en la solicitud
function _solComprobChip(x){
  var c=x && x.comprobacion;
  if(typeof c==='string'){ try{ c=JSON.parse(c); }catch(e){ c=null; } }
  if(!c || x.tipo!=='cancelacion') return '';
  var m = c.estado==='coincide' ? ['var(--pastel-ok)','var(--t-verde)','ti-circle-check','Factura proveedor coincide']
        : c.estado==='diferencias' ? ['var(--pastel-error)','var(--t-rojo)','ti-alert-triangle','Factura proveedor con diferencias']
        : ['var(--pastel-aviso)','var(--t-marron)','ti-alert-circle','Sin factura reserva'];
  var tit=(c.facturas_reserva?('Reserva '+c.facturas_reserva+'. '):'')
    +(c.total_reserva!=null?('Total reserva '+_fmtN2(c.total_reserva)+' · proveedor '+_fmtN2(c.total_proveedor)+'. '):'')
    +(c.motivo?('Motivo: '+c.motivo):'');
  return '<span title="'+_esc(tit)+'" style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;'
    +'background:'+m[0]+';color:'+m[1]+'"><i class="ti '+m[2]+'" style="font-size:11px"></i> '+m[3]+'</span>';
}


/* ═══════════════════════════════════════════════════════════════════════════
   CAMPOS DE USUARIO DE LA FACTURA RESERVA   (prefijo [FRU])
   ───────────────────────────────────────────────────────────────────────────
   Los de la cabecera de la factura en SAP: Marca de Cliente, Estado de Orden
   de Compra, Barco, Contenedor, Naviera, Estatus/Bodega, BL # y Descripción
   de Carga. Sus nombres internos (U_xxx) los descubre el worker leyendo CUFD
   y los deja en campos_usuario_opch con su título y sus valores válidos, así
   que aquí se pintan solos: si en SAP se agrega otro campo, aparece.
   ═══════════════════════════════════════════════════════════════════════════ */

// Los que se enseñan de entrada, por su título en SAP (sin tildes ni signos)
var FRU_PRINCIPALES=['marcadecliente','estadodeordendecompra','barco','contenedor',
                     'naviera','estatusbodega','bl','bln','descripciondecarga'];

function _fruClave(t){
  return String(t||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9]/g,'');
}

async function _fruCargar(){
  if(window._fruCampos) return window._fruCampos;
  try{
    var r=await fetch(SB+'/rest/v1/campos_usuario_opch?select=*&order=titulo',{headers:SBH});
    window._fruCampos = r.ok ? (await r.json()||[]) : [];
  }catch(e){
    _dbg('[FRU] '+(e.message||e));
    window._fruCampos=[];
  }
  return window._fruCampos;
}

function _fruPrincipal(c){
  var k=_fruClave(c.titulo);
  return FRU_PRINCIPALES.some(function(p){ return k===p || k.indexOf(p)===0; });
}

// El bloque de la pantalla. Se pinta vacío y se rellena al llegar los campos.
function _fruBloque(){
  setTimeout(_fruPintar, 30);
  return '<div id="fruBox" style="margin-bottom:12px"></div>';
}

async function _fruPintar(){
  var box=document.getElementById('fruBox');
  if(!box) return;
  var campos=await _fruCargar();
  box=document.getElementById('fruBox');
  if(!box) return;
  if(!campos.length){
    box.innerHTML='<div style="font-size:11px;color:var(--text-muted)">'
      +'Los campos de usuario de la factura aparecerán aquí en cuanto el worker '
      +'los lea de SAP (hace falta la tabla <b>campos_usuario_opch</b>).</div>';
    return;
  }
  var d=window._fr; if(!d) return;
  d.udf=d.udf||{};
  var ver=window._fruVerTodos;
  var lista=campos.filter(function(c){ return ver || _fruPrincipal(c); });
  var ocultos=campos.length-lista.length;

  box.innerHTML='<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">'
    +'DATOS DEL EMBARQUE (campos de la factura en SAP)</div>'
    +'<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:9px">'
    + lista.map(_fruCampoHtml).join('')
    +'</div>'
    +(ocultos>0||ver
      ? ('<div onclick="window._fruVerTodos=!window._fruVerTodos;_fruPintar()" '
        +'style="font-size:10.5px;color:var(--text-accent);cursor:pointer;margin-top:6px">'
        +(ver?'Ver solo los del embarque':'Ver los otros '+ocultos+' campos de la factura')
        +'</div>') : '');
}

function _fruCampoHtml(c){
  var d=window._fr||{udf:{}};
  var v=(d.udf&&d.udf[c.alias])||'';
  var estilo='width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  var control;
  if((c.opciones||[]).length){
    control='<select onchange="_fruSet(\''+c.alias+'\',this.value)" style="'+estilo+'">'
      +'<option value="">—</option>'
      + c.opciones.map(function(o){
          return '<option value="'+_esc(o.v)+'"'+(String(v)===String(o.v)?' selected':'')+'>'
            +_esc(o.t||o.v)+'</option>'; }).join('')
      +'</select>';
  } else if(String(c.tipo||'').toUpperCase()==='D'){
    control='<input type="date" value="'+_esc(String(v).slice(0,10))+'" '
      +'onchange="_fruSet(\''+c.alias+'\',this.value)" style="'+estilo+'">';
  } else {
    control='<input value="'+_esc(v)+'" '+(c.largo?('maxlength="'+c.largo+'" '):'')
      +'onchange="_fruSet(\''+c.alias+'\',this.value)" style="'+estilo+'">';
  }
  return '<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">'
    +_esc(c.titulo||c.alias)+'</label><div style="margin-top:3px">'+control+'</div></div>';
}

function _fruSet(alias, valor){
  window._fr=window._fr||{};
  window._fr.udf=window._fr.udf||{};
  if(valor==='' || valor==null) delete window._fr.udf[alias];
  else window._fr.udf[alias]=valor;
}

/* ═══════════════════════════════════════════════════════════════════════════
   EL AVISO MIENTRAS SAP CREA LA FACTURA   (prefijo [FRW])
   ───────────────────────────────────────────────────────────────────────────
   Antes se enviaba a la cola y había que mirar el historial de abajo para
   saber si salió. Ahora sale una rueda mientras el worker la crea y, cuando
   SAP la devuelve, el número de factura en grande.
   ═══════════════════════════════════════════════════════════════════════════ */

function _frwAbrir(){
  _frwCerrar();
  var ov=document.createElement('div');
  ov.id='frwOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:10070;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';
  ov.innerHTML='<div id="frwCaja" style="background:var(--surface-0);border-radius:16px;'
    +'padding:30px 34px;max-width:440px;width:100%;text-align:center;'
    +'box-shadow:0 18px 50px rgba(0,0,0,.3)"></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
  _frwPintarEspera('Creando la factura reserva en SAP…');
}

function _frwCerrar(){
  var o=document.getElementById('frwOv'); if(o) o.remove();
  clearTimeout(window._frwT);
}

function _frwPintarEspera(txt, sub){
  var c=document.getElementById('frwCaja'); if(!c) return;
  c.innerHTML='<div style="width:62px;height:62px;margin:0 auto 16px;border:5px solid var(--border);'
    +'border-top-color:var(--fill-accent);border-radius:50%;animation:frwGira .9s linear infinite"></div>'
    +'<div style="font-size:15px;font-weight:700">'+_esc(txt)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:6px">'
    +_esc(sub||'El worker la está enviando por DI API. No cierres esta ventana.')+'</div>'
    +'<style>@keyframes frwGira{to{transform:rotate(360deg)}}</style>';
}

function _frwPintarOK(docnum){
  var c=document.getElementById('frwCaja'); if(!c) return;
  c.innerHTML='<div style="width:78px;height:78px;margin:0 auto 14px;border-radius:50%;'
    +'background:var(--pastel-ok);display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-check" style="font-size:46px;color:var(--t-verde)"></i></div>'
    +'<div style="font-size:16px;font-weight:700;color:var(--t-verde)">'
    +'Factura reserva creada en SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin:10px 0 4px">'
    +'N.º de factura reserva</div>'
    +'<div style="font-size:52px;font-weight:800;letter-spacing:1px;line-height:1.1">'
    +_esc(docnum||'—')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:10px">'
    +'Ya está en SAP enlazada a la orden. En Facturas Reserva aparece tras el '
    +'siguiente Sync.</div>'
    +'<button class="btn bp" style="margin-top:16px;width:100%;padding:11px" '
    +'onclick="_frwCerrar()">Listo</button>';
}

/* Admite «_frwPintarError(motivo)» como siempre, y también
   «_frwPintarError(titulo, detalle)», que es lo que hacía falta: antes el
   detalle se pasaba como segundo argumento y se tiraba a la basura, así que
   solo se veía el título y no había forma de saber qué pasó. */
function _frwPintarError(motivo, detalle){
  var c=document.getElementById('frwCaja'); if(!c) return;
  var titulo = detalle!=null ? motivo : 'SAP no la creó';
  var cuerpo = detalle!=null ? detalle : motivo;
  c.innerHTML='<div style="width:70px;height:70px;margin:0 auto 14px;border-radius:50%;'
    +'background:var(--pastel-error);display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-alert-triangle" style="font-size:38px;color:var(--t-rojo)"></i></div>'
    +'<div style="font-size:15px;font-weight:700;color:var(--t-rojo)">'+_esc(titulo||'')+'</div>'
    +'<div style="font-size:12px;color:var(--text-secondary);margin-top:10px;text-align:left;'
    +'background:var(--surface-1);border-radius:9px;padding:10px;max-height:220px;overflow:auto">'
    + String(cuerpo||'') + '</div>'
    +'<button class="btn bg2" style="margin-top:14px;width:100%;padding:10px" '
    +'onclick="_frwCerrar()">Cerrar</button>';
}

// Sigue la fila de la cola hasta que el worker la cierre
function _frwSeguir(id, desde){
  clearTimeout(window._frwT);
  window._frwT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;      // la cerraron
    try{
      var r=await fetch(SB+'/rest/v1/facturas_reserva_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q && q.estado==='creada'){
        _frwPintarOK(q.docnum_sap);
        try{ _frCargarHistorial(); }catch(e){}
        return;
      }
      if(q && q.estado==='error'){
        _frwPintarError(q.error_msg||'SAP no dijo el motivo');
        try{ _frCargarHistorial(); }catch(e){}
        return;
      }
      if(q && q.estado==='en_curso') _frwPintarEspera('Creándola en SAP…',
        'El worker ya la está metiendo por DI API.');
      if(Date.now()-desde > 8*60*1000){
        _frwPintarError('El worker no ha respondido en 8 minutos. Comprueba que esté '
          +'corriendo; la petición sigue en la cola y se creará cuando arranque.');
        return;
      }
    }catch(e){}
    _frwSeguir(id, desde);
  }, 2500);
}


function _vdDeLaOrden(dkc){
  if(!dkc) return null;
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(dkc) || String(x.num_orden)===String(dkc); });
  if(!p || !p.venta_directa) return null;
  var pv=p.pedido_venta;
  if(typeof pv==='string'){ try{ pv=JSON.parse(pv); }catch(e){ pv=null; } }
  return pv||null;
}

// Lo que mira guardarNuevaOrdenSinSAP antes de crear la orden
function _vdValidar(){
  var S=window._vd;
  if(!S || !S.activa) return {ok:true};
  if(!S.pedido) return {ok:false, msg:'Elige el pedido de venta del cliente.'};
  if(!(window._nsapDocs&&window._nsapDocs.pedido))
    return {ok:false, msg:'Adjunta el documento original del pedido del cliente.'};
  if(!S.res) return {ok:false, msg:'Falta comparar los tres documentos: pedido del '
    +'cliente, borrador y documento del proveedor.'};
  if(!S.res.coincide && !S.aprobado)
    return {ok:false, msg:'La comparación encontró diferencias. Corrígelas o pide a '
      +'gerencia que las apruebe antes de crear la orden.'};
  return {ok:true, datos:{
    venta_directa:true,
    pedido_venta:{docnum:S.pedido.docnum, cardcode:S.pedido.cardcode,
                  cardname:S.pedido.cardname, docdate:S.pedido.docdate,
                  marca_cliente:S.pedido.marca_cliente||'',
                  lineas:S.lineas.length},
    comprobacion_vd:{
      estado:(S.res.coincide?'coincide':'con_diferencias_aprobadas'),
      diferencias:S.res.nDif, avisos:S.res.nAvisos,
      total_orden:S.res.totalBor, total_proveedor:S.res.totalProv,
      detalle:S.res.filas.filter(function(f){ return f.dif.length||f.avisos.length; }).slice(0,40)
                .map(function(f){
                  return {itemcode:(f.borrador||f.pedido||f.proveedor||{}).itemcode,
                          motivos:f.dif, avisos:f.avisos,
                          pedido:f.pedido?f.pedido.cantidad:null,
                          orden:f.borrador?f.borrador.cantidad:null,
                          proveedor:f.proveedor?f.proveedor.cantidad:null}; }),
      aprobado:S.aprobado||null,
      por:(CU&&CU.name)||'', en:new Date().toISOString()
    }}};
}


/* ═══════════════════════════════════════════════════════════════════════════
   VENTAS DIRECTAS   (prefijo [VD])
   ───────────────────────────────────────────────────────────────────────────
   Flujo propio, aparte de las órdenes borrador:

     1. NUEVA VENTA DIRECTA · cliente, vendedor y una tabla tipo Excel con
        referencia, cantidad y precio de venta. Se puede pegar en bloque
        desde Excel. Aparte, los gastos (flete y demás).
     2. Antes de crear nada se COMPRUEBA que todas las referencias existan
        en SAP. Si falta alguna, no se crea el pedido.
     3. El pedido de venta se crea en SAP por DI API, con su numeración
        propia de venta directa.
     4. Desde el listado se entra a cualquier venta directa, se ve el pedido
        completo del cliente y desde ahí se GENERA LA ORDEN DE COMPRA al
        proveedor: las mismas líneas, editables, con los precios de compra
        que se pueden escribir a mano, pegar en bloque o leer de la proforma
        del proveedor. La orden se crea por DI API igual que las demás y
        queda colgada del pedido.
   ═══════════════════════════════════════════════════════════════════════════ */

window._vdLista = null;

async function rVentaDirecta(){
  var el=document.getElementById('page-ventadirecta');
  if(!el) return;
  el.innerHTML='<div class="slbl"><i class="ti ti-truck-delivery"></i> Ventas directas</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'Ventas que se compran expresamente para un cliente. Primero el pedido de venta '
    +'con sus precios; después, desde el propio pedido, la orden de compra al proveedor, '
    +'que en SAP queda colgada de ese pedido.</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px">'
    +'<button class="btn bp" onclick="_vdpNueva()" style="padding:10px 16px">'
    +'<i class="ti ti-file-spreadsheet"></i> Nueva venta directa desde la proforma</button>'
    +'<button class="btn bg2" onclick="_vdNueva()" style="padding:10px 16px">'
    +'<i class="ti ti-plus"></i> Venta directa a mano (referencias ya creadas)</button>'
    +'<button class="btn bg2" onclick="_vdpArreglarLista4()" style="padding:10px 16px;color:var(--t-marron)" '
    +'title="Los /VD creados antes del worker 2026-10-15-a tienen el precio de venta en la lista 3">'
    +'<i class="ti ti-tag"></i> Corregir precio VD (lista 4)</button></div>'
    +'<div id="vdListaBox"><div style="font-size:11.5px;color:var(--text-muted)">Cargando…</div></div>';
  _vdCargarLista();
}

async function _vdCargarLista(){
  var box=document.getElementById('vdListaBox'); if(!box) return;
  try{
    var r=await fetch(SB+'/rest/v1/ventas_directas_queue?select=*&order=creado_en.desc&limit=200',
      {headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0 || r.status===404)
        throw new Error('falta la tabla: corre ventas_directas.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,120));
    }
    window._vdLista=await r.json()||[];
  }catch(e){
    box.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +_esc(e.message||e)+'</div>';
    return;
  }
  var L=window._vdLista;
  if(!L.length){
    box.innerHTML='<div class="empty"><i class="ti ti-truck-delivery" style="font-size:22px"></i>'
      +'<br>Todavía no hay ventas directas</div>';
    return;
  }
  box.innerHTML='<div class="tbx-box"><table class="tbx"><thead><tr>'
    +'<th style="width:110px">Pedido SAP</th><th>Cliente</th><th>Vendedor</th>'
    +'<th style="width:70px;text-align:right">Líneas</th>'
    +'<th style="width:110px;text-align:right">Total venta</th>'
    +'<th style="width:130px">Estado</th><th style="width:150px">Orden de compra</th>'
    +'<th style="width:140px">Creada</th></tr></thead><tbody>'
    + L.map(function(v){
        var e=String(v.estado||'');
        var col = e==='creada' ? ['var(--pastel-ok)','var(--t-verde)']
                : e==='error' ? ['var(--pastel-error)','var(--t-rojo)']
                : ['var(--pastel-aviso)','var(--t-marron)'];
        var lin=(v.lineas||[]).length;
        return '<tr style="cursor:pointer" onclick="_vdAbrir(\''+v.id+'\')" '
          +'onmouseover="this.style.background=\'var(--surface-1)\'" '
          +'onmouseout="this.style.background=\'\'">'
          +'<td><b style="font-size:13px;color:var(--t-azul)">'
          +(v.docnum_sap?('#'+_esc(v.docnum_sap)):(v.docnum_manual?('('+_esc(v.docnum_manual)+')'):'—'))+'</b>'
          +(v.modo==='proforma'?'<div style="font-size:9.5px;color:var(--t-verde)">desde proforma</div>':'')
          +'</td>'
          +'<td>'+_esc(v.cliente_nombre||v.cliente_cardcode||'')+'</td>'
          +'<td>'+_esc(v.vendedor_nombre||'')+'</td>'
          +'<td style="text-align:right">'+lin+'</td>'
          +'<td style="text-align:right">'+_fmtN2(v.total||0)+'</td>'
          +'<td><span style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;'
          +'background:'+col[0]+';color:'+col[1]+'">'+_esc(_vdEstadoTxt(v))+'</span>'
          +((v.modo==='proforma' && e!=='creada' && e!=='error')
            ? ('<div style="font-size:9.5px;color:var(--t-azul);margin-top:2px">'
               +_esc(_vdpProgresoTxt(v).txt)+'</div>') : '')
          +(v.error_msg?('<div style="font-size:9.5px;color:var(--t-rojo)" title="'
            +_esc(v.error_msg)+'">'+_esc(String(v.error_msg).slice(0,40))+'…</div>'):'')
          +'</td>'
          +'<td style="font-size:11px">'+(v.modo==='proforma'
            ? (function(){ var pr=_vdpProgresoTxt(v);
                return pr.nTot ? ('<span style="color:'+(pr.nOk===pr.nTot?'var(--t-verde)':'var(--t-marron)')
                  +'">'+pr.nOk+'/'+pr.nTot+(pr.nOk?(' · #'+Object.keys(pr.ocs).map(function(k){
                    return _esc(pr.ocs[k].docnum); }).join(', #')):'')+'</span>') : ''; })()
            : (v.oc_docnum
            ? ('<span style="color:var(--t-verde)"><i class="ti ti-check"></i> #'
               +_esc(v.oc_docnum)+'</span>')
            : (v.docnum_sap?'<span style="color:var(--text-muted)">pendiente</span>':'')))+'</td>'
          +'<td style="font-size:10.5px;color:var(--text-muted)">'+_esc(_fechaCorta(v.creado_en))
          +'<div>'+_esc(v.creado_por||'')+'</div></td>'
          +'</tr>';
      }).join('')
    +'</tbody></table></div>';
  // Mientras alguna esté en marcha, la lista se vuelve a leer sola cada 5 s
  clearTimeout(window._vdListaT);
  if(L.some(function(v){ return v.estado==='pendiente' || v.estado==='en_curso'; })){
    window._vdListaT=setTimeout(function(){
      var b=document.getElementById('vdListaBox');
      if(b && b.offsetParent!==null) _vdCargarLista();
    }, 5000);
  }
}

// El estado en palabras: «pendiente» entre trozos de trabajo no es «sin empezar»
function _vdEstadoTxt(v){
  var e=String(v.estado||'');
  if(v.modo==='proforma' && (e==='pendiente'||e==='en_curso')){
    var p=_vdpProgresoTxt(v).p;
    return (p && p.paso) ? 'en proceso' : 'en cola';
  }
  return e;
}

// ── El asistente de una venta directa nueva ───────────────────────────────
function _vdNueva(){
  window._vdN={cliente:null, vendedor:null, series:null, numatcard:'',
               lineas:[], cargos:[], archivo:'', leyendo:false,
               vendedores:[], series_lista:[], comprobado:false, avisos:[]};
  var ov=document.createElement('div');
  ov.id='modalVD';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10060;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1100px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="vdCuerpo"></div></div>';
  document.body.appendChild(ov);
  _vdAddLinea(6);
  _vdPintarN();
  _vdCargarCatalogos();
}

function _vdCerrar(){
  var m=document.getElementById('modalVD'); if(m) m.remove();
  window._vdN=null;
}

async function _vdCargarCatalogos(){
  var N=window._vdN; if(!N) return;
  N.avisos=[];
  try{
    var r=await fetch(SB+'/rest/v1/vendedores?select=*&order=slpname',{headers:SBH});
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,120));
    N.vendedores=await r.json()||[];
  }catch(e){
    N.vendedores=[]; N.avisos.push('vendedores: '+(e.message||e));
  }
  if(!N.vendedores.length){
    try{
      var rv=await fetch(SB+'/rest/v1/clientes?select=slpcode,nombrevendedor'
        +'&slpcode=not.is.null&limit=3000',{headers:SBH});
      var visto={};
      (rv.ok?(await rv.json()||[]):[]).forEach(function(x){
        var k=String(x.slpcode);
        if(k && k!=='-1' && !visto[k] && x.nombrevendedor){
          visto[k]=true; N.vendedores.push({slpcode:x.slpcode, slpname:x.nombrevendedor});
        }
      });
      N.vendedores.sort(function(a,b){
        return String(a.slpname||'').localeCompare(String(b.slpname||'')); });
    }catch(e){}
  }
  try{
    var rs=await fetch(SB+'/rest/v1/series_pedido?select=*&order=nombre',{headers:SBH});
    if(!rs.ok) throw new Error(rs.status+' '+(await rs.text()).slice(0,120));
    N.series_lista=(await rs.json()||[]).filter(function(x){ return !x.bloqueada; });
  }catch(e){
    N.series_lista=[]; N.avisos.push('numeraciones: '+(e.message||e));
  }
  _vdPintarN();
}

function _vdPintarN(){
  var c=document.getElementById('vdCuerpo'); if(!c) return;
  var N=window._vdN; if(!N) return;
  c.innerHTML=
    '<div style="display:flex;align-items:center;gap:10px;margin-bottom:12px">'
    +'<i class="ti ti-truck-delivery" style="font-size:22px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">Nueva venta directa</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Referencias, cantidades y precios '
    +'de venta. Las referencias tienen que existir en SAP.</div></div>'
    +'<button class="xb" onclick="_vdCerrar()"><i class="ti ti-x"></i></button></div>'
    +((N.avisos&&N.avisos.length)?('<div class="nota" style="background:var(--pastel-aviso);'
      +'color:var(--t-marron);margin-bottom:9px;font-size:11px">No pude cargar: '
      +_esc(N.avisos.join(' · '))+'</div>'):'')
    + _vdCabeceraHtml(N)
    + _vdBarraHtml(N)
    + _vdTablaHtml(N)
    + _vdCargosHtml(N)
    + _vdPieHtml(N);
}

function _vdCampo(lbl, ctrl){
  return '<div style="flex:1;min-width:190px;position:relative">'
    +'<label style="font-size:11px;color:var(--text-muted)">'+lbl+'</label>'
    +'<div style="margin-top:3px">'+ctrl+'</div></div>';
}

function _vdCabeceraHtml(N){
  var est='width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  return '<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:12px">'
    + _vdCampo('Cliente <span style="color:var(--t-rojo)">*</span>',
        '<input id="vdCli" value="'+_esc(N.cliente?(N.cliente.cardcode+' · '+N.cliente.cardname):'')
        +'" placeholder="Busca por nombre o código…" oninput="_vdBuscarCliente(this.value)" '
        +'style="'+est+'"><div id="vdCliRes"></div>')
    + _vdCampo('Vendedor'+((N.vendedores||[]).length?'':' <span style="color:var(--t-marron)">'
        +'(la lista aún no ha bajado)</span>'),
        '<select onchange="window._vdN.vendedor=this.value" style="'+est+'">'
        +'<option value="">—</option>'
        + (N.vendedores||[]).map(function(v){
            var cod=v.slpcode!=null?v.slpcode:v.codigo;
            return '<option value="'+_esc(cod)+'"'+(String(N.vendedor)===String(cod)?' selected':'')
              +'>'+_esc(v.slpname||v.nombre||cod)+'</option>'; }).join('')
        +'</select>')
    + _vdCampo('Numeración del pedido',
        '<select onchange="window._vdN.series=this.value" style="'+est+'">'
        +'<option value="">La que SAP ponga por defecto</option>'
        + (N.series_lista||[]).map(function(s){
            return '<option value="'+_esc(s.series)+'"'+(String(N.series)===String(s.series)?' selected':'')
              +'>'+_esc(s.nombre)+(s.siguiente?(' · siguiente '+_esc(s.siguiente)):'')+'</option>';
          }).join('')
        +'</select>')
    + _vdCampo('Referencia del cliente',
        '<input value="'+_esc(N.numatcard)+'" onchange="window._vdN.numatcard=this.value" '
        +'placeholder="Su n.º de pedido" style="'+est+'">')
    +'</div>';
}

async function _vdBuscarCliente(q){
  var N=window._vdN; if(!N) return;
  q=String(q||'').trim();
  var box=document.getElementById('vdCliRes'); if(!box) return;
  if(q.length<2){ box.innerHTML=''; return; }
  try{
    var t=encodeURIComponent('*'+q+'*');
    var l=[], err='';
    var r=await fetch(SB+'/rest/v1/clientes?select=cardcode,cardname'
      +'&or=(cardname.ilike.'+t+',cardcode.ilike.'+t+')&limit=12',{headers:SBH});
    if(r.ok) l=await r.json()||[];
    else err=r.status+' '+(await r.text()).slice(0,120);
    if(!l.length){
      var rp=await fetch(SB+'/rest/v1/pedidos?select=cardcode,cardname'
        +'&or=(cardname.ilike.'+t+',cardcode.ilike.'+t+')&limit=200',{headers:SBH});
      var visto={};
      (rp.ok?(await rp.json()||[]):[]).forEach(function(x){
        var k=String(x.cardcode||'');
        if(k && !visto[k]){ visto[k]=true; l.push(x); }
      });
      l=l.slice(0,12);
    }
    if(!l.length){
      box.innerHTML='<div style="font-size:10.5px;color:'
        +(err?'var(--t-rojo)':'var(--text-muted)')+';margin-top:3px">'
        +(err?('No pude leer los clientes ('+_esc(err)+')')
             :'Ningún cliente con eso')+'</div>';
      return;
    }
    box.innerHTML='<div style="position:absolute;z-index:5;width:100%;'
      +'border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);'
      +'box-shadow:0 8px 22px rgba(0,0,0,.18);max-height:190px;overflow:auto;margin-top:3px">'
      + l.map(function(x){
          return '<div onclick="_vdElegirCliente(\''+_esc(x.cardcode)+'\',\''
            +_esc(String(x.cardname||'').replace(/'/g,''))+'\')" '
            +'style="padding:5px 8px;cursor:pointer;font-size:11.5px;'
            +'border-bottom:0.5px solid var(--border)"><b>'+_esc(x.cardcode)+'</b> · '
            +_esc(x.cardname)+'</div>'; }).join('')
      +'</div>';
  }catch(e){
    box.innerHTML='<div style="font-size:10.5px;color:var(--t-rojo)">'+_esc(e.message||e)+'</div>';
  }
}

function _vdElegirCliente(cardcode, cardname){
  var N=window._vdN; if(!N) return;
  N.cliente={cardcode:cardcode, cardname:cardname};
  _vdPintarN();
}

function _vdBarraHtml(N){
  return '<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:8px">'
    +'<label class="xb" style="cursor:pointer"><i class="ti ti-file-spreadsheet"></i> '
    +(N.archivo?('Excel: '+_esc(N.archivo)):'Cargar Excel del pedido')
    +'<input type="file" accept=".xlsx,.xls,.csv" style="display:none" '
    +'onchange="_vdExcel(this)"></label>'
    +'<button class="xb" onclick="_vdAddLinea(5)"><i class="ti ti-plus"></i> 5 líneas más</button>'
    +'<button class="xb" onclick="_vdComprobar()"><i class="ti ti-search"></i> '
    +'Comprobar en SAP</button>'
    +(N.leyendo?'<span class="ai-ring g"></span>':'')
    +'<span style="flex:1"></span>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">Se edita como un Excel: '
    +'escribe, o ponte en una celda y pega un bloque copiado de Excel.</span></div>';
}

// ── La tabla tipo Excel ───────────────────────────────────────────────────
var VD_COLS=[
  {k:'itemcode',    t:'Referencia',      w:170},
  {k:'itemname',    t:'Descripción',     w:320, ro:true},
  {k:'cantidad',    t:'Cantidad',        w:100, num:2},
  {k:'precio',      t:'Precio de venta', w:110, num:4}
];

function _vdAddLinea(n){
  var N=window._vdN; if(!N) return;
  for(var i=0;i<(n||1);i++){
    N.lineas.push({itemcode:'', itemname:'', cantidad:0, precio:0, existe:null});
  }
  if(document.getElementById('vdCuerpo')) _vdPintarN();
}

function _vdSet(i, campo, v){
  var N=window._vdN; if(!N||!N.lineas[i]) return;
  var col=VD_COLS.filter(function(c){ return c.k===campo; })[0];
  if(col && col.num!=null) N.lineas[i][campo]=Number(String(v).replace(',','.'))||0;
  else {
    N.lineas[i][campo]=String(v).trim();
    if(campo==='itemcode'){ N.lineas[i].existe=null; N.lineas[i].itemname=''; }
  }
  _vdTotales();
}

// Pegado en bloque, como en un Excel
function _vdPaste(ev, fila, campo){
  var texto='';
  try{ texto=(ev.clipboardData||window.clipboardData).getData('text'); }catch(e){ return; }
  if(!texto || (texto.indexOf('\t')<0 && texto.indexOf('\n')<0)) return;
  ev.preventDefault();
  var N=window._vdN; if(!N) return;
  var col0=VD_COLS.map(function(c){ return c.k; }).indexOf(campo);
  var lineas=texto.replace(/\r/g,'').split('\n').filter(function(x){ return x.trim()!==''; });
  lineas.forEach(function(linea, r){
    var celdas=linea.split('\t');
    while(N.lineas.length<=fila+r) N.lineas.push({itemcode:'',itemname:'',cantidad:0,precio:0,existe:null});
    var l=N.lineas[fila+r];
    celdas.forEach(function(v, cc){
      var col=VD_COLS[col0+cc];
      if(!col || col.ro || v==null || v==='') return;
      if(col.num!=null) l[col.k]=Number(String(v).trim().replace(/[^0-9.,-]/g,'').replace(',','.'))||0;
      else { l[col.k]=String(v).trim(); if(col.k==='itemcode'){ l.existe=null; l.itemname=''; } }
    });
  });
  _vdPintarN();
  showT('✓ '+lineas.length+' fila(s) pegadas · pulsa «Comprobar en SAP»');
  _vdComprobar();
}

function _vdTablaHtml(N){
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;'
    +'font-size:12px;padding:4px 5px;color:var(--text-primary)';
  return '<div class="tbx-box" style="max-height:44vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:34px">#</th>'
    + VD_COLS.map(function(c){
        return '<th style="width:'+c.w+'px'+(c.num!=null?';text-align:right':'')+'">'
          +_esc(c.t)+'</th>'; }).join('')
    +'<th style="width:110px;text-align:right">Total</th>'
    +'<th style="width:130px">En SAP</th><th style="width:28px"></th></tr></thead><tbody>'
    + N.lineas.map(function(l,i){
        var marca = !String(l.itemcode||'').trim()
          ? ''
          : (l.existe===null
             ? '<span style="font-size:10px;color:var(--text-muted)">sin comprobar</span>'
             : (l.existe
                ? '<span style="font-size:10px;color:var(--t-verde)"><i class="ti ti-check"></i> existe</span>'
                : '<span style="font-size:10px;color:var(--t-rojo)"><i class="ti ti-alert-triangle"></i> no existe</span>'));
        return '<tr'+(l.existe===false?' style="background:rgba(220,38,38,.06)"':'')+'>'
          +'<td style="color:var(--text-muted)">'+(i+1)+'</td>'
          + VD_COLS.map(function(c){
              var v=(l[c.k]==null?'':l[c.k]);
              if(c.ro) return '<td style="font-size:11px;color:var(--text-muted)">'
                +_esc(String(v).slice(0,44))+'</td>';
              return '<td style="padding:0"><input '+(c.num!=null?'inputmode="decimal" ':'')
                +'value="'+_esc(c.num!=null?(v||''):v)+'" '
                +'onchange="_vdSet('+i+',\''+c.k+'\',this.value)" '
                +(c.k==='itemcode'?'onblur="_vdComprobar()" ':'')
                +'onpaste="_vdPaste(event,'+i+',\''+c.k+'\')" '
                +'onfocus="this.select();this.style.background=\'var(--bg-accent)\'" '
                +'onblur="this.style.background=\'\'" '
                +'style="'+inp+(c.num!=null?';text-align:right':'')
                +(c.k==='itemcode'?';font-weight:600':'')+'"></td>';
            }).join('')
          +'<td style="text-align:right" id="vdTl'+i+'">'
          +_fmtN2((l.cantidad||0)*(l.precio||0))+'</td>'
          +'<td>'+marca+'</td>'
          +'<td><button class="xb" onclick="window._vdN.lineas.splice('+i+',1);_vdPintarN()">'
          +'<i class="ti ti-x"></i></button></td></tr>';
      }).join('')
    +'</tbody><tfoot><tr style="font-weight:700;background:var(--surface-1)">'
    +'<td colspan="3" style="text-align:right">TOTALES</td>'
    +'<td style="text-align:right" id="vdTotUni"></td><td></td>'
    +'<td style="text-align:right" id="vdTotImp"></td><td colspan="2"></td>'
    +'</tr></tfoot></table></div>';
}

async function _vdExcel(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var N=window._vdN; if(!N) return;
  N.leyendo=true; N.archivo=f.name; _vdPintarN();
  try{
    var fichas=await _ocLeerFichasDeExcel(null, f.name, f);
    if(!fichas || !fichas.length) throw new Error('no encontré artículos en el Excel');
    N.lineas=fichas.map(function(x){
      return {itemcode:String(x.itemcode||'').trim(), itemname:'',
              cantidad:Number(x.cantidad)||0,
              precio:Number(x.precio_unit||x.precio)||0, existe:null};
    }).filter(function(l){ return l.itemcode; });
    showT('✓ '+N.lineas.length+' línea(s) leídas del Excel');
  }catch(e){ showT('No pude leer el Excel: '+(e.message||e)); }
  N.leyendo=false; _vdPintarN();
  _vdComprobar();
}

// ── La comprobación contra SAP ────────────────────────────────────────────
async function _vdComprobar(){
  var N=window._vdN; if(!N) return;
  var codigos=[...new Set(N.lineas.map(function(l){ return String(l.itemcode||'').trim(); })
                           .filter(Boolean))];
  if(!codigos.length) return;
  try{
    var hay={};
    for(var i=0;i<codigos.length;i+=80){
      var lote=codigos.slice(i,i+80).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){ hay[String(x.itemcode)]=x; });
    }
    N.lineas.forEach(function(l){
      var k=String(l.itemcode||'').trim();
      if(!k){ l.existe=null; return; }
      l.existe=!!hay[k];
      if(hay[k]) l.itemname=hay[k].itemname||'';
    });
    N.comprobado=true;
  }catch(e){ showT('No pude comprobar en SAP: '+(e.message||e)); }
  _vdPintarN();
}

// ── Los gastos (flete y demás) ────────────────────────────────────────────
function _vdCargosHtml(N){
  var cg=N.cargos||[];
  return '<div style="margin-top:10px;border:0.5px solid var(--border);border-radius:9px;'
    +'padding:9px 11px;background:var(--surface-0)">'
    +'<div style="font-size:11.5px;font-weight:700;margin-bottom:5px">Flete y otros gastos</div>'
    + (cg.length
       ? cg.map(function(c,i){
           return '<div style="display:flex;gap:7px;align-items:center;margin-bottom:4px">'
             +'<input value="'+_esc(c.concepto)+'" onchange="window._vdN.cargos['+i+'].concepto=this.value" '
             +'style="flex:1;padding:5px 8px;border:0.5px solid var(--border);border-radius:6px;'
             +'font-size:12px;background:var(--surface-2);color:var(--text-primary)">'
             +'<input inputmode="decimal" value="'+(c.monto||0)+'" '
             +'onchange="window._vdN.cargos['+i+'].monto=Number(String(this.value).replace(\',\',\'.\'))||0;_vdTotales()" '
             +'style="width:120px;text-align:right;padding:5px 8px;border:0.5px solid var(--border);'
             +'border-radius:6px;font-size:12px;background:var(--surface-2);color:var(--text-primary)">'
             +'<button class="xb" onclick="window._vdN.cargos.splice('+i+',1);_vdPintarN()">'
             +'<i class="ti ti-x"></i></button></div>';
         }).join('')
       : '<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:4px">'
         +'Sin gastos. Se suman al pedido como gastos adicionales en SAP.</div>')
    +'<button class="xb" style="font-size:10.5px;padding:2px 8px" onclick="_vdAddCargo()">'
    +'<i class="ti ti-plus"></i> Añadir gasto</button></div>';
}

function _vdAddCargo(){
  var N=window._vdN; if(!N) return;
  N.cargos=N.cargos||[];
  N.cargos.push({concepto:'Flete', monto:0});
  _vdPintarN();
}

function _vdTotales(){
  var N=window._vdN; if(!N) return {uni:0, imp:0, gastos:0, malas:0, sinComprobar:0};
  var t={uni:0, imp:0, gastos:0, malas:0, sinComprobar:0};
  N.lineas.forEach(function(l,i){
    var q=Number(l.cantidad)||0, p=Number(l.precio)||0;
    t.uni+=q; t.imp+=q*p;
    if(String(l.itemcode||'').trim()){
      if(l.existe===false) t.malas++;
      else if(l.existe===null) t.sinComprobar++;
    }
    var e=document.getElementById('vdTl'+i);
    if(e) e.textContent=_fmtN2(q*p);
  });
  (N.cargos||[]).forEach(function(c){ t.gastos+=Number(c.monto)||0; });
  var a=document.getElementById('vdTotUni'); if(a) a.textContent=_fmtN2(t.uni);
  var b=document.getElementById('vdTotImp'); if(b) b.textContent=_fmtN2(t.imp);
  var r=document.getElementById('vdResumen'); if(r) r.innerHTML=_vdResumenTxt(t);
  return t;
}

function _vdResumenTxt(t){
  return '<b>'+_fmtN2(t.imp+t.gastos)+'</b> del pedido'
    +(t.gastos?(' ('+_fmtN2(t.imp)+' + '+_fmtN2(t.gastos)+' de gastos)'):'')
    +' · '+_fmtN2(t.uni)+' unidad(es)'
    +(t.malas?(' · <span style="color:var(--t-rojo)">'+t.malas
      +' referencia(s) NO existen en SAP</span>'):'')
    +(t.sinComprobar?(' · <span style="color:var(--t-marron)">'+t.sinComprobar
      +' sin comprobar</span>'):'');
}

function _vdPieHtml(N){
  var t={uni:0, imp:0, gastos:0, malas:0, sinComprobar:0};
  N.lineas.forEach(function(l){
    var q=Number(l.cantidad)||0;
    t.uni+=q; t.imp+=q*(Number(l.precio)||0);
    if(String(l.itemcode||'').trim()){
      if(l.existe===false) t.malas++;
      else if(l.existe===null) t.sinComprobar++;
    }
  });
  (N.cargos||[]).forEach(function(c){ t.gastos+=Number(c.monto)||0; });
  return '<div style="display:flex;align-items:center;gap:10px;margin-top:12px;flex-wrap:wrap">'
    +'<div id="vdResumen" style="flex:1;font-size:12px">'+_vdResumenTxt(t)+'</div>'
    +'<button class="btn bg2" onclick="_vdCerrar()" style="padding:9px 14px">Cancelar</button>'
    +'<button class="btn bp" onclick="_vdCrearPedido()" style="padding:9px 18px">'
    +'<i class="ti ti-send"></i> Crear el pedido de venta en SAP</button></div>';
}

async function _vdCrearPedido(){
  var N=window._vdN; if(!N) return;
  if(!N.cliente){ showT('Elige el cliente'); return; }
  var lineas=N.lineas.filter(function(l){
    return String(l.itemcode||'').trim() && (Number(l.cantidad)||0)>0; });
  if(!lineas.length){ showT('Hace falta al menos una línea con referencia y cantidad'); return; }

  await _vdComprobar();
  lineas=N.lineas.filter(function(l){
    return String(l.itemcode||'').trim() && (Number(l.cantidad)||0)>0; });
  var malas=lineas.filter(function(l){ return l.existe===false; });
  if(malas.length){
    showT('No puedo crear el pedido: '+malas.length+' referencia(s) no existen en SAP ('
      +malas.slice(0,3).map(function(l){ return l.itemcode; }).join(', ')
      +(malas.length>3?'…':'')+'). Créalas primero o quítalas.', 9000);
    return;
  }
  var sinPrecio=lineas.filter(function(l){ return !(Number(l.precio)>0); }).length;
  var t=lineas.reduce(function(a,l){ return a+(l.cantidad*l.precio); },0);
  var gastos=(N.cargos||[]).reduce(function(a,c){ return a+(Number(c.monto)||0); },0);
  if(!confirm('CREAR EL PEDIDO DE VENTA EN SAP\n\n'
      +'Cliente:  '+N.cliente.cardcode+' · '+N.cliente.cardname+'\n'
      +'Líneas:   '+lineas.length+'\n'
      +'Total:    '+_fmtN2(t)+(gastos?(' + '+_fmtN2(gastos)+' de gastos'):'')+'\n'
      +'Todas las referencias existen en SAP.\n'
      +(sinPrecio?('\nOJO: '+sinPrecio+' línea(s) van sin precio.\n'):'')
      +'\n¿Sigo?')) return;

  var fila={
    cliente_cardcode:N.cliente.cardcode, cliente_nombre:N.cliente.cardname,
    vendedor_code:N.vendedor||null,
    vendedor_nombre:((N.vendedores||[]).filter(function(v){
      return String(v.slpcode!=null?v.slpcode:v.codigo)===String(N.vendedor); })[0]||{}).slpname||null,
    series:N.series?Number(N.series):null,
    numatcard:N.numatcard||null, fecha:_hoyISO(), almacen:'VD',
    total:t+gastos,
    cargos:(N.cargos||[]).filter(function(c){ return Number(c.monto); }),
    lineas:lineas.map(function(l){
      return {itemcode:String(l.itemcode).trim(), itemname:l.itemname||'',
              cantidad:Number(l.cantidad)||0, precio:Number(l.precio)||0, crear:false}; }),
    estado:'pendiente', creado_por:(CU&&CU.name)||''
  };
  try{
    _frwAbrir();
    _frwPintarEspera('Creando el pedido de venta en SAP…','Por DI API, con su numeración.');
    var r=await _postTolerante(SB+'/rest/v1/ventas_directas_queue', fila);
    if(!r.ok){
      var t2=await r.text();
      if(t2.indexOf('does not exist')>=0) throw new Error('falta la tabla: corre '
        +'ventas_directas.sql en Supabase');
      throw new Error(r.status+' '+t2.slice(0,160));
    }
    var reg=((await r.json())||[])[0];
    _vdCerrar();
    _vdSeguir(reg.id, Date.now());
  }catch(e){
    _frwCerrar();
    showT('No se pudo enviar: '+(e.message||e));
  }
}

function _vdSeguir(id, desde){
  clearTimeout(window._vdT2);
  window._vdT2=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    try{
      var r=await fetch(SB+'/rest/v1/ventas_directas_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q && q.estado==='creada'){
        _frwPintarOK(q.docnum_sap);
        var c=document.getElementById('frwCaja');
        if(c) c.innerHTML=c.innerHTML
          .replace('Factura reserva creada en SAP','Pedido de venta directa creado en SAP')
          .replace('N.º de factura reserva','N.º de pedido de venta')
          .replace('Ya está en SAP enlazada a la orden. En Facturas Reserva aparece tras el '
                   +'siguiente Sync.',
                   'Entra al pedido desde la lista para generar la orden de compra.');
        _vdCargarLista();
        return;
      }
      if(q && q.estado==='error'){ _frwPintarError(q.error_msg||''); _vdCargarLista(); return; }
      if(Date.now()-desde > 8*60*1000){
        _frwPintarError('El worker no ha respondido en 8 minutos. Sigue en la cola.');
        return;
      }
    }catch(e){}
    _vdSeguir(id, desde);
  }, 2500);
}

/* ═══════════════════════════════════════════════════════════════════════════
   EL PEDIDO DE VENTA DIRECTA POR DENTRO, Y SU ORDEN DE COMPRA
   ═══════════════════════════════════════════════════════════════════════════ */
function _vdAbrir(id){
  var v=(window._vdLista||[]).filter(function(x){ return String(x.id)===String(id); })[0];
  if(!v) return;
  window._vdVer=v;
  var ov=document.createElement('div');
  ov.id='modalVDVer';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10061;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1060px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="vdVerCuerpo"></div></div>';
  document.body.appendChild(ov);
  _vdVerPintar();
}

function _vdVerCerrar(){
  var m=document.getElementById('modalVDVer'); if(m) m.remove();
  window._vdVer=null;
}

function _vdVerPintar(){
  var c=document.getElementById('vdVerCuerpo'); if(!c) return;
  var v=window._vdVer; if(!v) return;
  var lineas=v.lineas||[];
  var total=lineas.reduce(function(a,l){
    return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
  var gastos=(v.cargos||[]).reduce(function(a,x){ return a+(Number(x.monto)||0); },0);

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-file-invoice" style="font-size:22px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:16px;font-weight:700">'
    +'Pedido de venta directa '+(v.docnum_sap?('#'+_esc(v.docnum_sap)):'(sin crear)')+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +_esc(v.cliente_cardcode||'')+' · '+_esc(v.cliente_nombre||'')
    +(v.vendedor_nombre?(' · vendedor '+_esc(v.vendedor_nombre)):'')
    +(v.numatcard?(' · ref. del cliente '+_esc(v.numatcard)):'')
    +' · '+_esc(_fechaCorta(v.creado_en))+'</div></div>'
    +'<button class="xb" onclick="_vdVerCerrar()"><i class="ti ti-x"></i></button></div>'
    +(v.error_msg?('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo);'
      +'margin-bottom:9px">'+_esc(v.error_msg)+'</div>'):'')
    +'<div class="tbx-box" style="max-height:46vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:34px">#</th><th style="width:170px">Referencia</th>'
    +'<th>Descripción</th><th style="width:100px;text-align:right">Cantidad</th>'
    +'<th style="width:110px;text-align:right">Precio venta</th>'
    +'<th style="width:110px;text-align:right">Total</th></tr></thead><tbody>'
    + lineas.map(function(l,i){
        return '<tr><td style="color:var(--text-muted)">'+(i+1)+'</td>'
          +'<td><b>'+_esc(l.itemcode)+'</b></td>'
          +'<td style="font-size:11px">'+_esc(String(l.itemname||'').slice(0,46))+'</td>'
          +'<td style="text-align:right">'+_fmtN2(l.cantidad)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(l.precio)+'</td>'
          +'<td style="text-align:right">'+_fmtN2((l.cantidad||0)*(l.precio||0))+'</td></tr>';
      }).join('')
    +'</tbody><tfoot><tr style="font-weight:700;background:var(--surface-1)">'
    +'<td colspan="5" style="text-align:right">TOTAL DEL PEDIDO</td>'
    +'<td style="text-align:right">'+_fmtN2(total+gastos)+'</td></tr></tfoot></table></div>'
    +(gastos?('<div style="font-size:11px;color:var(--text-muted);margin-top:5px">Gastos: '
      + (v.cargos||[]).map(function(x){
          return _esc(x.concepto)+' '+_fmtN2(x.monto); }).join(' · ')+'</div>'):'')
    +'<div style="display:flex;gap:9px;margin-top:14px;flex-wrap:wrap">'
    +'<div style="flex:1"></div>'
    +(v.oc_docnum
      ? ('<span style="font-size:12px;color:var(--t-verde);align-self:center">'
         +'<i class="ti ti-check"></i> Orden de compra #'+_esc(v.oc_docnum)+' creada</span>')
      : '')
    +(v.modo==='proforma' ? _vdpVerExtraHtml(v) : '')
    +'<button class="btn bg2" onclick="_vdVerCerrar()" style="padding:9px 14px">Cerrar</button>'
    +(v.modo==='proforma' && v.estado==='error'
      ? ('<button class="btn bp" onclick="_vdpReintentar(\''+v.id+'\')" style="padding:9px 18px">'
         +'<i class="ti ti-refresh"></i> Reintentar desde donde se quedó</button>') : '')
    +(v.docnum_sap && v.modo!=='proforma'
      ? ('<button class="btn bp" onclick="_vdOrdenCompra(\''+v.id+'\')" '
         +'style="padding:9px 18px"><i class="ti ti-shopping-cart"></i> '
         +(v.oc_docnum?'Generar otra orden de compra':'Generar orden de compra para el proveedor')
         +'</button>')
      : '')
    +'</div>';
}


/* ── La orden de compra de una venta directa ──────────────────────────────
   Se carga con las mismas líneas del pedido del cliente, pero los precios
   son OTROS: los que cotice el proveedor. Se escriben a mano, se pegan en
   bloque desde Excel, o se leen de la proforma que mande el proveedor.
   Los precios de venta al cliente no aparecen por ningún lado.
   Al crearla se manda a la misma cola que las demás órdenes: el worker la
   crea por DI API y la cuelga del pedido de venta. */
function _vdOrdenCompra(id){
  var v=(window._vdLista||[]).filter(function(x){ return String(x.id)===String(id); })[0];
  if(!v || !v.docnum_sap){ showT('Ese pedido todavía no está en SAP'); return; }
  window._vdOC={vd:v, prov:'', cardcode:'', dkc:'', leyendo:false, archivo:'',
                lineas:(v.lineas||[]).map(function(l){
                  return {itemcode:l.itemcode, itemname:l.itemname||'',
                          cantidad:Number(l.cantidad)||0, precio:0}; })};
  var ov=document.createElement('div');
  ov.id='modalVDOC';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10063;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1060px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="vdOcCuerpo"></div></div>';
  document.body.appendChild(ov);
  _vdOcPintar();
}

function _vdOcCerrar(){
  var m=document.getElementById('modalVDOC'); if(m) m.remove();
  window._vdOC=null;
}

var VDOC_COLS=[
  {k:'itemcode', t:'Referencia',       w:170},
  {k:'itemname', t:'Descripción',      w:300, ro:true},
  {k:'cantidad', t:'Cantidad',         w:100, num:2},
  {k:'precio',   t:'Precio de compra', w:120, num:4}
];

function _vdOcSet(i, campo, v){
  var O=window._vdOC; if(!O||!O.lineas[i]) return;
  var col=VDOC_COLS.filter(function(c){ return c.k===campo; })[0];
  O.lineas[i][campo]= (col && col.num!=null)
    ? (Number(String(v).replace(',','.'))||0) : String(v).trim();
  _vdOcPintar();
}

function _vdOcPaste(ev, fila, campo){
  var texto='';
  try{ texto=(ev.clipboardData||window.clipboardData).getData('text'); }catch(e){ return; }
  if(!texto || (texto.indexOf('\t')<0 && texto.indexOf('\n')<0)) return;
  ev.preventDefault();
  var O=window._vdOC; if(!O) return;
  var col0=VDOC_COLS.map(function(c){ return c.k; }).indexOf(campo);
  var lineas=texto.replace(/\r/g,'').split('\n').filter(function(x){ return x.trim()!==''; });
  var n=0;
  lineas.forEach(function(linea, r){
    var celdas=linea.split('\t');
    var l=O.lineas[fila+r];
    if(!l) return;
    celdas.forEach(function(v, cc){
      var col=VDOC_COLS[col0+cc];
      if(!col || col.ro || v==null || v==='') return;
      l[col.k]= col.num!=null
        ? (Number(String(v).trim().replace(/[^0-9.,-]/g,'').replace(',','.'))||0)
        : String(v).trim();
      n++;
    });
  });
  _vdOcPintar();
  showT('✓ '+n+' celda(s) pegadas');
}

// Los precios, leídos de la proforma del proveedor
async function _vdOcProforma(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var O=window._vdOC; if(!O) return;
  O.leyendo=true; O.archivo=f.name; _vdOcPintar();
  try{
    var doc=null;
    if(/\.(xlsx|xls|csv)$/i.test(f.name||'')){
      try{ doc=await _fipLeerExcelFactura(f); }catch(e){}
    }
    if(!doc) doc=await _spcLeerFacturaProveedor(f);      // PDF o foto: lo lee la IA
    var items=doc.items||{};
    var puestos=0, sin=[];
    O.lineas.forEach(function(l){
      var it=items[_ocNormSku(l.itemcode)];
      if(!it){
        // Por si la proforma trae la referencia del proveedor
        var m=null;
        try{ m=_refEmparejar(Object.keys(items).map(function(k){
          return items[k].itemcode; }), l.itemcode); }catch(e){}
        if(m) it=items[_ocNormSku(m.codigo)];
      }
      if(it && Number(it.precio)>0){ l.precio=Number(it.precio); puestos++; }
      else sin.push(l.itemcode);
    });
    showT('✓ '+puestos+' precio(s) leídos de la proforma'
      +(sin.length?(' · '+sin.length+' sin precio: '+sin.slice(0,3).join(', ')
        +(sin.length>3?'…':'')):''), 8000);
  }catch(e){
    showT('No pude leer la proforma: '+(e.message||e));
  }
  O.leyendo=false; _vdOcPintar();
}

function _vdOcPintar(){
  var c=document.getElementById('vdOcCuerpo'); if(!c) return;
  var O=window._vdOC; if(!O) return;
  var est='width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;'
    +'font-size:12px;padding:4px 5px;color:var(--text-primary)';
  var total=O.lineas.reduce(function(a,l){
    return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
  var sinPrecio=O.lineas.filter(function(l){ return !(Number(l.precio)>0); }).length;

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-shopping-cart" style="font-size:20px;color:var(--t-azul)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +'Orden de compra de la venta directa</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Del pedido de venta <b>#'
    +_esc(O.vd.docnum_sap)+'</b> · '+_esc(O.vd.cliente_nombre||'')
    +' · en SAP la orden queda colgada de ese pedido.</div></div>'
    +'<button class="xb" onclick="_vdOcCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:9px">'
    + _vdCampo('Proveedor <span style="color:var(--t-rojo)">*</span>',
        '<input value="'+_esc(O.cardcode)+(O.prov?(' · '+_esc(O.prov)):'')
        +'" placeholder="Busca por nombre o código…" oninput="_vdOcProv(this.value)" '
        +'style="'+est+'"><div id="vdOcProvRes"></div>')
    + _vdCampo('Vendor Ref. No. (DKC)',
        '<input value="'+_esc(O.dkc)+'" onchange="window._vdOC.dkc=this.value" style="'+est+'">')
    +'</div>'
    +'<div style="display:flex;gap:7px;align-items:center;flex-wrap:wrap;margin-bottom:7px">'
    +'<label class="xb" style="cursor:pointer"><i class="ti ti-file-upload"></i> '
    +(O.archivo?('Proforma: '+_esc(O.archivo)):'Cargar la proforma del proveedor')
    +'<input type="file" accept=".pdf,.xlsx,.xls,.csv,image/*" style="display:none" '
    +'onchange="_vdOcProforma(this)"></label>'
    +(O.leyendo?'<span class="ai-ring"></span> Leyendo los precios…':'')
    +'<span style="flex:1"></span>'
    +'<span style="font-size:10.5px;color:var(--t-marron)">Estos son los precios de COMPRA. '
    +'Los de venta al cliente no se enseñan aquí ni viajan al proveedor.</span></div>'
    +'<div class="tbx-box" style="max-height:44vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:34px">#</th>'
    + VDOC_COLS.map(function(x){
        return '<th style="width:'+x.w+'px'+(x.num!=null?';text-align:right':'')+'">'
          +_esc(x.t)+'</th>'; }).join('')
    +'<th style="width:110px;text-align:right">Total</th>'
    +'<th style="width:28px"></th></tr></thead><tbody>'
    + O.lineas.map(function(l,i){
        return '<tr'+(!(Number(l.precio)>0)?' style="background:rgba(217,119,6,.07)"':'')+'>'
          +'<td style="color:var(--text-muted)">'+(i+1)+'</td>'
          + VDOC_COLS.map(function(x){
              var v=(l[x.k]==null?'':l[x.k]);
              if(x.ro) return '<td style="font-size:11px;color:var(--text-muted)">'
                +_esc(String(v).slice(0,42))+'</td>';
              return '<td style="padding:0"><input '+(x.num!=null?'inputmode="decimal" ':'')
                +'value="'+_esc(x.num!=null?(v||''):v)+'" '
                +'onchange="_vdOcSet('+i+',\''+x.k+'\',this.value)" '
                +'onpaste="_vdOcPaste(event,'+i+',\''+x.k+'\')" '
                +'onfocus="this.select();this.style.background=\'var(--bg-accent)\'" '
                +'onblur="this.style.background=\'\'" '
                +'style="'+inp+(x.num!=null?';text-align:right':'')
                +(x.k==='itemcode'?';font-weight:600':'')+'"></td>';
            }).join('')
          +'<td style="text-align:right">'+_fmtN2((l.cantidad||0)*(l.precio||0))+'</td>'
          +'<td><button class="xb" onclick="window._vdOC.lineas.splice('+i+',1);_vdOcPintar()">'
          +'<i class="ti ti-x"></i></button></td></tr>';
      }).join('')
    +'</tbody><tfoot><tr style="font-weight:700;background:var(--surface-1)">'
    +'<td colspan="4" style="text-align:right">TOTAL DE COMPRA</td>'
    +'<td></td><td style="text-align:right">'+_fmtN2(total)+'</td><td></td>'
    +'</tr></tfoot></table></div>'
    +'<div style="display:flex;align-items:center;gap:10px;margin-top:12px;flex-wrap:wrap">'
    +'<div style="flex:1;font-size:12px">'+O.lineas.length+' línea(s) · '
    +'<b>'+_fmtN2(total)+'</b>'
    +(sinPrecio?(' · <span style="color:var(--t-marron)">'+sinPrecio
      +' sin precio de compra</span>'):'')+'</div>'
    +'<button class="btn bg2" onclick="_vdOcCerrar()" style="padding:9px 14px">Cancelar</button>'
    +'<button class="btn bp" onclick="_vdOcCrear()" style="padding:9px 18px">'
    +'<i class="ti ti-send"></i> Crear la orden de compra en SAP</button></div>';
}

async function _vdOcProv(q){
  var O=window._vdOC; if(!O) return;
  O.cardcode=String(q||'').trim().split(' ')[0];
  var box=document.getElementById('vdOcProvRes'); if(!box) return;
  q=String(q||'').trim();
  if(q.length<2){ box.innerHTML=''; return; }
  try{
    var t=encodeURIComponent('*'+q+'*');
    var r=await fetch(SB+'/rest/v1/proveedores?select=cardcode,cardname'
      +'&or=(cardname.ilike.'+t+',cardcode.ilike.'+t+')&limit=10',{headers:SBH});
    var l=r.ok ? (await r.json()||[]) : [];
    box.innerHTML = l.length ? ('<div style="position:absolute;z-index:5;width:100%;'
      +'border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);'
      +'box-shadow:0 8px 22px rgba(0,0,0,.18);max-height:170px;overflow:auto;margin-top:3px">'
      + l.map(function(x){
          return '<div onclick="_vdOcElegirProv(\''+_esc(x.cardcode)+'\',\''
            +_esc(String(x.cardname||'').replace(/'/g,''))+'\')" '
            +'style="padding:5px 8px;cursor:pointer;font-size:11.5px;'
            +'border-bottom:0.5px solid var(--border)"><b>'+_esc(x.cardcode)+'</b> · '
            +_esc(x.cardname)+'</div>'; }).join('')
      +'</div>') : '';
  }catch(e){ box.innerHTML=''; }
}

function _vdOcElegirProv(cardcode, cardname){
  var O=window._vdOC; if(!O) return;
  O.cardcode=cardcode; O.prov=cardname;
  _vdOcPintar();
}

async function _vdOcCrear(){
  var O=window._vdOC; if(!O) return;
  var cc=String(O.cardcode||'').trim();
  if(!cc){ showT('Elige el proveedor'); return; }
  var lineas=O.lineas.filter(function(l){
    return String(l.itemcode||'').trim() && (Number(l.cantidad)||0)>0; });
  if(!lineas.length){ showT('No hay líneas con cantidad'); return; }
  var sinPrecio=lineas.filter(function(l){ return !(Number(l.precio)>0); });
  if(sinPrecio.length && !confirm(sinPrecio.length+' línea(s) van SIN precio de compra.\n\n'
    +'¿Las mando así?')) return;
  var total=lineas.reduce(function(a,l){ return a+(l.cantidad*l.precio); },0);
  if(!confirm('CREAR LA ORDEN DE COMPRA EN SAP\n\nProveedor: '+cc+(O.prov?(' · '+O.prov):'')
      +'\nLíneas: '+lineas.length+'\nTotal de compra: '+_fmtN2(total)
      +'\n\nQuedará colgada del pedido de venta #'+O.vd.docnum_sap+'.\n\n¿Sigo?')) return;
  try{
    _frwAbrir();
    _frwPintarEspera('Creando la orden de compra en SAP…',
      'Se cuelga del pedido de venta, como el asistente de aprovisionamiento.');
    var fila={
      dkc:O.dkc||null, numatcard:O.dkc||null, cardcode:cc, cardname:O.prov||null,
      docdate:_hoyISO(), comments:'Venta directa · pedido #'+O.vd.docnum_sap,
      lineas:lineas.map(function(l){
        return {itemcode:l.itemcode, quantity:l.cantidad, price:l.precio}; }),
      total:total, estado:'pendiente', creado_por:(CU&&CU.name)||'',
      venta_directa:true,
      pedido_venta:{docnum:O.vd.docnum_sap, docentry:O.vd.docentry_sap||null,
                    cardcode:O.vd.cliente_cardcode, cardname:O.vd.cliente_nombre}
    };
    var r=await _postTolerante(SB+'/rest/v1/ordenes_compra_queue', fila);
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,160));
    var reg=((await r.json())||[])[0];
    _vdOcCerrar(); _vdVerCerrar();
    _vdOcSeguir(reg.id, Date.now(), O.vd.id);
  }catch(e){
    _frwCerrar();
    showT('No se pudo enviar: '+(e.message||e));
  }
}

function _vdOcSeguir(id, desde, vdId){
  clearTimeout(window._vdT3);
  window._vdT3=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    try{
      var r=await fetch(SB+'/rest/v1/ordenes_compra_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q && (q.estado==='creada'||q.estado==='creado')){
        _frwPintarOK(q.docnum_sap);
        var c=document.getElementById('frwCaja');
        if(c) c.innerHTML=c.innerHTML
          .replace('Factura reserva creada en SAP','Orden de compra creada en SAP')
          .replace('N.º de factura reserva','N.º de orden de compra')
          .replace('Ya está en SAP enlazada a la orden. En Facturas Reserva aparece tras el '
                   +'siguiente Sync.',
                   'Cuelga del pedido de venta. El resto del flujo es el de siempre.');
        // Se anota en la venta directa, para verlo en el listado
        if(vdId){
          try{
            await fetch(SB+'/rest/v1/ventas_directas_queue?id=eq.'+vdId,{method:'PATCH',
              headers:SBH, body:JSON.stringify({oc_docnum:q.docnum_sap})});
          }catch(e){}
        }
        _vdCargarLista();
        return;
      }
      if(q && q.estado==='error'){ _frwPintarError(q.error_msg||''); return; }
      if(Date.now()-desde > 8*60*1000){
        _frwPintarError('El worker no ha respondido en 8 minutos. Sigue en la cola.');
        return;
      }
    }catch(e){}
    _vdOcSeguir(id, desde, vdId);
  }, 2500);
}


/* ═══════════════════════════════════════════════════════════════════════════
   VENTA DIRECTA DESDE LA PROFORMA DE VENTA   (prefijo [VDP] · v713)
   ───────────────────────────────────────────────────────────────────────────
   El flujo acordado:

     1. Se sube la PROFORMA DE VENTA (Excel). Columnas: ref (con /VD), id,
        ref adicional, precio venta, precio costo factura, Costo en Sistema,
        Diferencia, piezas, Total Compra, Total Venta, barcode. Si una
        referencia no termina en /VD se le añade; si ya lo trae, se respeta.
     2. El PREFIJO de la referencia (415, 074, 022, 485, 0012…) es el código
        del proveedor en SAP. Se comprueba que exista.
     3. Pesos, cubicajes, cajas y empaque salen de los PACKING LISTS, con el
        lector del FIP (_fipLeerExcelPacking, y la IA si es PDF) y su tabla
        editable de medidas, que aquí trabaja con su propio estado (cx='vd')
        para no pisar una factura reserva a medias.
     4. Se manda TODO a la cola de ventas directas en una sola fila. El
        worker, por pasos y anotando cada uno: crea los artículos /VD con
        bodega VD (copiando la ficha del artículo base de la «ref adicional»),
        les pone las medidas, crea la orden de venta con el NÚMERO MANUAL y
        una orden de compra POR PROVEEDOR colgada de ella.
   Las facturas (de proveedor y al cliente) quedan fuera: se hacen en SAP.
   ═══════════════════════════════════════════════════════════════════════════ */

window._vdP = null;

// Los avisos de showT quedaban detrás de las ventanas del portal (z-index
// 10060 en adelante): por eso en la venta directa «no se veía nada».
(function(){
  try{
    var st=document.createElement('style');
    st.textContent='.toast{z-index:2147483000 !important}';
    (document.head||document.documentElement).appendChild(st);
  }catch(e){}
})();

// Referencia sin el /VD y normalizada: así casa con el packing, que nunca lo trae
function _vdpNorm(ref){ return _ocNormSku(String(ref||'').trim().replace(/\/\s*VD\s*$/i,'')); }
function _vdpConVD(ref){
  ref=String(ref||'').trim();
  return /\/\s*VD$/i.test(ref) ? ref.replace(/\/\s*VD$/i,'/VD') : (ref+'/VD');
}
// El prefijo TAL CUAL, con sus ceros: «0012» no es «12»
function _vdpPrefijo(ref){
  var m=String(ref||'').trim().match(/^([A-Z0-9]+)-/i);
  return m ? m[1].toUpperCase() : '';
}
function _vdpTit(c){
  return String(c==null?'':c).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/\s+/g,' ').trim();
}
function _vdpNum(v){
  if(typeof v==='number') return v;
  var n=_fipNum(v); return n==null?0:n;
}

function _vdpNueva(){
  window._vdP={archivo:'', lineas:[], avisos:[], proveedores:{}, packing:{}, packs:[],
               medidas:null, cliente:null, vendedor:'', vendedores:[], numero:'',
               numatcard:'', comentarios:'', cargos:[], leyendo:false, comprobando:false,
               udf:{}, udfCampos:null, udfTodos:false};
  var ov=document.createElement('div');
  ov.id='modalVDP';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10060;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1240px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="vdpCuerpo"></div></div>';
  document.body.appendChild(ov);
  _vdpPintar();
  _vdpCargarVendedores();
  _vdpCargarUdf();
}

function _vdpCerrar(){
  var S=window._vdP;
  if(S && S.lineas.length && !S.enviado
     && !confirm('Se pierde lo cargado (proforma y packing lists). ¿Cierro?')) return;
  var m=document.getElementById('modalVDP'); if(m) m.remove();
  window._vdP=null;
}

async function _vdpCargarVendedores(){
  var S=window._vdP; if(!S) return;
  try{
    var r=await fetch(SB+'/rest/v1/vendedores?select=*&order=slpname',{headers:SBH});
    if(r.ok) S.vendedores=await r.json()||[];
  }catch(e){}
  _vdpPintar();
}

// ── 1. La proforma ────────────────────────────────────────────────────────
async function _vdpLeerProforma(file){
  if(typeof XLSX==='undefined') throw new Error('no está cargado el lector de Excel');
  var buf=await file.arrayBuffer();
  var wb=XLSX.read(new Uint8Array(buf),{type:'array'});
  var lineas=[], avisos=[], vistas={};
  wb.SheetNames.some(function(nombre){
    var filas=XLSX.utils.sheet_to_json(wb.Sheets[nombre],{header:1, raw:true, defval:''});
    var col=null;
    for(var i=0;i<filas.length;i++){
      var f=filas[i]||[];
      if(!col){
        var t=f.map(_vdpTit);
        var donde=function(re){ for(var j=0;j<t.length;j++){ if(re.test(t[j])) return j; } return -1; };
        var cRef=donde(/^ref(erencia)?$/);
        var cVenta=donde(/^precio( de)? venta/);
        if(cRef<0 || cVenta<0) continue;
        col={ref:cRef, venta:cVenta, id:donde(/^id$/),
             adicional:donde(/^ref(erencia)? adicional/),
             costo:donde(/^precio( de)? costo/),
             sistema:donde(/^costo en sistema/),
             piezas:donde(/^(piezas|pzas|cantidad|qty)$/),
             barcode:donde(/^(barcode|codigo de barras?)$/)};
        if(col.piezas<0) throw new Error('la proforma no tiene la columna «piezas»');
        if(col.costo<0) throw new Error('la proforma no tiene la columna «precio costo factura»');
        continue;
      }
      var ref=String(f[col.ref]==null?'':f[col.ref]).trim();
      if(!ref) continue;                       // filas vacías y el pie de totales
      if(/^total/i.test(ref)) continue;
      var conVD=_vdpConVD(ref);
      var adic=col.adicional>=0 ? String(f[col.adicional]||'').trim() : '';
      var base=adic || conVD.replace(/\/VD$/,'');
      var bc=col.barcode>=0 ? String(f[col.barcode]==null?'':f[col.barcode]).trim()
                                .replace(/\.0+$/,'').replace(/^'/,'') : '';
      var l={ref:conVD, refOriginal:ref, base:base, clave:_vdpNorm(base),
             prefijo:_vdpPrefijo(conVD), id:col.id>=0?String(f[col.id]||''):'',
             venta:_vdpNum(f[col.venta]), costo:_vdpNum(f[col.costo]),
             sistema:col.sistema>=0?_vdpNum(f[col.sistema]):null,
             piezas:_vdpNum(f[col.piezas]), barcode:bc, barcodeProf:bc,
             barcodeFuente:bc?'proforma':'', barcodeManual:false,
             cantCompra:null, empaque:null, unidad:'PZA',
             existeVD:null, baseNombre:'', baseExiste:null, baseBarcode:''};
      if(!l.prefijo) avisos.push(ref+': no tiene prefijo de proveedor (NNN-…)');
      if(vistas[l.ref]) avisos.push(l.ref+' viene repetida en la proforma');
      vistas[l.ref]=true;
      if(_vdpNorm(base)!==_vdpNorm(conVD))
        avisos.push(l.ref+': la «ref adicional» ('+base+') no es la misma referencia sin /VD');
      lineas.push(l);
    }
    return lineas.length>0;
  });
  if(!lineas.length) throw new Error('no encontré la cabecera «ref · precio venta · piezas» '
    +'ni ninguna línea debajo');
  return {lineas:lineas, avisos:avisos};
}

async function _vdpProforma(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var S=window._vdP; if(!S) return;
  S.leyendo=true; S.archivo=f.name; _vdpPintar();
  try{
    var r=await _vdpLeerProforma(f);
    S.lineas=r.lineas; S.avisos=r.avisos;
    S.medidas=null;                           // las medidas se vuelven a casar
    showT('✓ '+S.lineas.length+' línea(s) de la proforma');
  }catch(e){
    S.lineas=[]; S.avisos=['No pude leer la proforma: '+(e.message||e)];
  }
  S.leyendo=false; _vdpPintar();
  if(S.lineas.length) _vdpComprobar();
}

// Lo que dice SAP (por Supabase) de cada referencia, de su base y de los proveedores
async function _vdpBuscarEn(tabla, campo, valores, select){
  var res=[];
  for(var i=0;i<valores.length;i+=60){
    var lote=valores.slice(i,i+60).map(function(v){
      return encodeURIComponent('"'+String(v).replace(/"/g,'')+'"'); });
    var r=await fetch(SB+'/rest/v1/'+tabla+'?select='+select+'&'+campo+'=in.('+lote.join(',')+')'
      +'&limit=5000',{headers:SBH});
    if(!r.ok) throw new Error(tabla+': '+r.status+' '+(await r.text()).slice(0,120));
    res=res.concat(await r.json()||[]);
  }
  return res;
}

async function _vdpComprobar(){
  var S=window._vdP; if(!S||!S.lineas.length) return;
  S.comprobando=true; _vdpPintar();
  var fallos=[];
  try{
    var vd=await _vdpBuscarEn('inventario','itemcode',
      [...new Set(S.lineas.map(function(l){ return l.ref; }))],'itemcode,itemname');
    var hayVD={}; vd.forEach(function(x){ hayVD[String(x.itemcode).toUpperCase()]=x; });
    var bs=await _vdpBuscarEn('inventario','itemcode',
      [...new Set(S.lineas.map(function(l){ return l.base; }))],'itemcode,itemname,codebars');
    var hayB={}; bs.forEach(function(x){ hayB[String(x.itemcode).toUpperCase()]=x; });
    S.lineas.forEach(function(l){
      l.existeVD=!!hayVD[l.ref.toUpperCase()];
      var b=hayB[l.base.toUpperCase()];
      l.baseExiste=!!b;
      l.baseNombre=b?(b.itemname||''):(l.existeVD?(hayVD[l.ref.toUpperCase()].itemname||''):'');
      l.baseBarcode=b?String(b.codebars||'').trim():'';
    });
    _vdpRellenarBarcodes(S);
  }catch(e){ fallos.push('artículos: '+(e.message||e)); }
  try{
    var prefs=[...new Set(S.lineas.map(function(l){ return l.prefijo; }).filter(Boolean))];
    var pr=await _vdpBuscarEn('proveedores','cardcode',prefs,'cardcode,cardname');
    var hay={}; pr.forEach(function(x){ hay[String(x.cardcode).toUpperCase()]=x; });
    prefs.forEach(function(p){
      var prev=S.proveedores[p]||{};
      var x=hay[p];
      S.proveedores[p]={cardcode:p, cardname:x?x.cardname:'', ok:!!x,
                        numatcard:prev.numatcard||''};
    });
  }catch(e){ fallos.push('proveedores: '+(e.message||e)); }
  S.fallosComprobar=fallos;
  S.comprobando=false; _vdpPintar();
}

// ── 2. Los packing lists (varios a la vez, uno por proveedor) ─────────────
async function _vdpPacking(input){
  var files=[].slice.call(input.files||[]); input.value='';
  var S=window._vdP; if(!S||!files.length) return;
  S.leyendo=true; _vdpPintar();
  for(var i=0;i<files.length;i++){
    var f=files[i], pk=null, como='Excel';
    try{
      if(/\.(xlsx|xls|csv)$/i.test(f.name||'')){
        try{ pk=await _fipLeerExcelPacking(f); }catch(e){ _dbg('[VDP] packing Excel: '+(e.message||e)); }
      }
      if(!pk || !Object.keys(pk).length){ pk=await _fipLeerPacking(f); como='IA'; }
      var n=0, rep=0;
      Object.keys(pk||{}).forEach(function(k){
        if(S.packing[k]) rep++;
        S.packing[k]=pk[k]; n++;
      });
      S.packs=S.packs.filter(function(x){ return x.name!==f.name; });
      S.packs.push({name:f.name, n:n, como:como, rep:rep});
    }catch(e){
      S.packs.push({name:f.name, n:0, error:(e.message||String(e))});
    }
  }
  S.medidas=null;                    // se recalculan con todo lo leído
  _vdpRellenarBarcodes(S);
  S.leyendo=false; _vdpPintar();
}

/* El código de barras de cada línea (v715). Manda, por este orden: lo que
   se escriba a mano, la proforma, el del artículo base en SAP y el del
   packing list. En Ecotelas la proforma no trae el de 50 líneas: 34 salen
   del packing de VI-1107, 11 del de Lonwa y 5 (Marco) del artículo base, si
   lo tiene; si no, se escriben en la tabla. */
function _vdpRellenarBarcodes(S){
  (S.lineas||[]).forEach(function(l){
    if(l.barcodeManual) return;
    var pk=(S.packing||{})[l.clave];
    if(l.barcodeProf){ l.barcode=l.barcodeProf; l.barcodeFuente='proforma'; }
    else if(l.baseBarcode){ l.barcode=l.baseBarcode; l.barcodeFuente='SAP (artículo base)'; }
    else if(pk && pk.barcode){ l.barcode=pk.barcode; l.barcodeFuente='packing list'; }
    else { l.barcode=''; l.barcodeFuente=''; }
  });
}

/* ── La tabla de líneas, editable como un Excel ──────────────────────────
   Código de barras, piezas por unidad de compra (NumInBuy) y unidad de
   empaque (piezas por caja, PurPackUn). Se escribe celda a celda o se pega
   un bloque copiado del Excel: rellena hacia abajo y hacia la derecha desde
   la celda donde se pega. */
/* La FICHA DE PRODUCTO completa (v728): todo lo que va a SAP de cada /VD, en
   una tabla tipo Excel. Lo que tiene ✎ se edita: escribir, pegar un bloque,
   arrastrar el cuadrito, flechas. El orden de VDP_EDITABLES es el de las
   columnas: al pegar un bloque del Excel se reparte así. */
var VDP_EDITABLES=['itemname','costo','venta','barcode','unidad','empaque','cantCompra',
                   'peso_bulto','vol_bulto','medida'];
var VDP_NOMBRES={itemname:'Descripción', costo:'Costo FOB (lista 1)', venta:'Precio venta (lista 4 VD)',
  barcode:'Código de barras', unidad:'Unidad', empaque:'Bulto por unidad (piezas por caja)',
  cantCompra:'Piezas por unidad de compra', peso_bulto:'Peso por bulto (kg)',
  vol_bulto:'Cubicaje por bulto (pie³)', medida:'Medida del cartón'};

/* Las medidas de una línea: las del packing (revisadas en la tabla del FIP)
   o, si la referencia no venía en ningún packing, las escritas a mano aquí.
   Devuelve el objeto que se edita (siempre el mismo para esa línea). */
function _vdpMedEditable(l){
  var m=_vdpMedDe(l);
  if(m) return m;
  l.medManual=l.medManual||{itemcode:l.base, sap:l.ref, piezas_x_bulto:l.empaque||0,
    peso_bulto_kg:0, vol_bulto_pie3:0, peso_pieza_kg:0, vol_pieza_pie3:0, medida_carton:''};
  return l.medManual;
}
// Lo que de verdad se manda a SAP: bulto, pesos y cubicajes cuadrados entre sí
function _vdpMedFinal(l){
  var m=_vdpMedDe(l)||l.medManual;
  var bulto=Number(_vdpBultoDe(l))||0;
  if(!m) return null;
  var pb=Number(m.peso_bulto_kg)||0, vb=Number(m.vol_bulto_pie3)||0;
  if(!pb && !vb && !m.medida_carton) return null;
  return {piezas_x_bulto:bulto||Number(m.piezas_x_bulto)||0, peso_bulto_kg:pb, vol_bulto_pie3:vb,
          peso_pieza_kg:bulto?pb/bulto:(Number(m.peso_pieza_kg)||0),
          vol_pieza_pie3:bulto?vb/bulto:(Number(m.vol_pieza_pie3)||0),
          medida_carton:m.medida_carton||''};
}
// El valor de una columna, tal como se ve en la ficha
function _vdpValor(l, campo){
  var mf=_vdpMedFinal(l);
  switch(campo){
    case 'itemname':   return l.itemnameManual!=null ? l.itemnameManual : (l.baseNombre||'');
    case 'costo':      return l.costo;
    case 'venta':      return l.venta;
    case 'barcode':    return l.barcode||'';
    case 'unidad':     return l.unidad||'PZA';
    case 'empaque':    return _vdpBultoDe(l)||'';
    case 'cantCompra': return l.cantCompra==null?'':l.cantCompra;
    case 'peso_bulto': return mf&&mf.peso_bulto_kg ? Math.round(mf.peso_bulto_kg*1000)/1000 : '';
    case 'vol_bulto':  return mf&&mf.vol_bulto_pie3 ? Math.round(mf.vol_bulto_pie3*10000)/10000 : '';
    case 'medida':     return mf ? (mf.medida_carton||'') : '';
  }
  return '';
}

function _vdpSetLinea(i, campo, valor, sinPintar){
  var S=window._vdP; if(!S) return;
  var l=S.lineas[i]; if(!l || l.existeVD) return;
  var v=String(valor==null?'':valor).trim();
  if(campo==='barcode'){
    l.barcode=v.replace(/\.0+$/,'').replace(/[^0-9]/g,'');
    l.barcodeManual=true;
    l.barcodeFuente=l.barcode?'a mano':'';
  } else if(campo==='unidad'){
    l.unidad=v.toUpperCase().slice(0,20);
  } else if(campo==='cantCompra'){
    var n=Number(v.replace(',','.'));
    l.cantCompra=(v && n>0)?n:null;
  } else if(campo==='empaque'){
    var e=Number(v.replace(',','.'));
    l.empaque=(v && e>0)?e:null;
    // Y las medidas por pieza salen de este empaque: un solo número manda
    var m=_vdpMedDe(l)||l.medManual;
    if(m && l.empaque){
      m.piezas_x_bulto=l.empaque;
      m.vol_pieza_pie3=(Number(m.vol_bulto_pie3)||0)/l.empaque;
      m.peso_pieza_kg=(Number(m.peso_bulto_kg)||0)/l.empaque;
    }
  } else if(campo==='itemname'){
    l.itemnameManual=(v && v!==l.baseNombre) ? v.slice(0,100) : null;
  } else if(campo==='costo' || campo==='venta'){
    var p=Number(v.replace(/[$,\s]/g,''));
    if(v!=='' && !isNaN(p) && p>=0) l[campo]=Math.round(p*10000)/10000;
  } else if(campo==='peso_bulto' || campo==='vol_bulto'){
    var x=Number(v.replace(',','.')); if(v!=='' && isNaN(x)) return;
    var me=_vdpMedEditable(l), bu=Number(_vdpBultoDe(l))||0;
    if(campo==='peso_bulto'){ me.peso_bulto_kg=x||0; me.peso_pieza_kg=bu?(x||0)/bu:0; }
    else { me.vol_bulto_pie3=x||0; me.vol_pieza_pie3=bu?(x||0)/bu:0; }
  } else if(campo==='medida'){
    _vdpMedEditable(l).medida_carton=v.slice(0,60);
  }
  if(!sinPintar) _vdpPintar();
}

function _vdpPegarLinea(ev, fila, campo){
  var t=(ev.clipboardData||window.clipboardData).getData('text')||'';
  if(t.indexOf('\n')<0 && t.indexOf('\t')<0) return;      // una sola celda: normal
  ev.preventDefault();
  var S=window._vdP; if(!S) return;
  var filas=t.replace(/\r/g,'').split('\n');
  if(filas.length && filas[filas.length-1]==='') filas.pop();
  var c0=VDP_EDITABLES.indexOf(campo), n=0;
  filas.forEach(function(f, r){
    f.split('\t').forEach(function(v, j){
      var k=VDP_EDITABLES[c0+j], i=fila+r;
      if(!k || i>=S.lineas.length || S.lineas[i].existeVD) return;
      _vdpSetLinea(i, k, v, true); n++;
    });
  });
  _vdpPintar();
  showT('✓ '+n+' celda(s) pegadas');
}

// El bulto por unidad de una línea: lo escrito a mano o, si no, el del packing
function _vdpBultoDe(l){
  if(l.empaque) return l.empaque;
  var m=_vdpMedDe(l);
  return (m && m.piezas_x_bulto) ? Math.round(m.piezas_x_bulto*1000)/1000 : null;
}

// Arrastrar el cuadrito de la celda (como el «controlador de relleno» de Excel)
function _vdpAsaIni(ev, fila, campo){
  ev.preventDefault(); ev.stopPropagation();
  var td=ev.target.closest('td'); var inp=td && td.querySelector('input');
  var valor=inp?inp.value:'';
  var A={fila:fila, campo:campo, valor:valor, hasta:fila};
  window._vdpAsa=A;
  var marcar=function(){
    document.querySelectorAll('.vdp-ed.vdp-rango').forEach(function(x){ x.classList.remove('vdp-rango'); });
    var a=Math.min(A.fila,A.hasta), b=Math.max(A.fila,A.hasta);
    document.querySelectorAll('.vdp-ed[data-c="'+campo+'"]').forEach(function(x){
      var r=Number(x.getAttribute('data-r')); if(r>=a && r<=b) x.classList.add('vdp-rango'); });
  };
  var mover=function(e){
    var el=document.elementFromPoint(e.clientX, e.clientY);
    var t=el && el.closest && el.closest('tr');
    var c=t && t.querySelector('.vdp-ed[data-c="'+campo+'"]');
    if(c){ A.hasta=Number(c.getAttribute('data-r')); marcar(); }
    // Si se llega al borde de la tabla, que se desplace sola
    var caja=td.closest('.tbx-box');
    if(caja){ var rc=caja.getBoundingClientRect();
      if(e.clientY>rc.bottom-20) caja.scrollTop+=18; else if(e.clientY<rc.top+30) caja.scrollTop-=18; }
  };
  var soltar=function(){
    document.removeEventListener('mousemove', mover);
    document.removeEventListener('mouseup', soltar);
    window._vdpAsa=null;
    var a=Math.min(A.fila,A.hasta), b=Math.max(A.fila,A.hasta);
    if(a===b){ _vdpSetLinea(A.fila, campo, A.valor); return; }
    _vdpRellenar(a, b, campo, A.valor);
  };
  document.addEventListener('mousemove', mover);
  document.addEventListener('mouseup', soltar);
  marcar();
}
function _vdpAsaHastaFin(fila, campo){
  var S=window._vdP; if(!S) return;
  var td=document.querySelector('.vdp-ed[data-r="'+fila+'"][data-c="'+campo+'"] input');
  _vdpRellenar(fila, S.lineas.length-1, campo, td?td.value:'');
}
function _vdpRellenar(a, b, campo, valor){
  var S=window._vdP; if(!S) return;
  var n=0;
  for(var i=a;i<=b;i++){ if(S.lineas[i] && !S.lineas[i].existeVD){ _vdpSetLinea(i, campo, valor, true); n++; } }
  _vdpPintar();
  showT('✓ «'+valor+'» copiado en '+n+' fila(s)');
}
// Flechas y Enter para moverse por la columna, como en Excel
function _vdpTecla(ev, fila, campo){
  var k=ev.key, d=(k==='ArrowDown'||k==='Enter')?1:(k==='ArrowUp'?-1:0);
  if(!d) return;
  ev.preventDefault();
  var actual=ev.target, valor=actual.value;
  var sig=document.querySelector('.vdp-ed[data-r="'+(fila+d)+'"][data-c="'+campo+'"] input');
  var S=window._vdP, l=S&&S.lineas[fila];
  // Se guarda sin repintar, para no perder el foco
  var cambio=l && String(valor)!==String(_vdpValor(l, campo));
  if(cambio) _vdpSetLinea(fila, campo, valor, true);
  if(sig){ sig.focus(); sig.select(); }
  if(cambio){ _vdpRefrescarFila(fila); _vdpRefrescarResumen(); }
}

// Un mismo valor para toda la columna (solo las referencias que se crean)
function _vdpTodaColumna(campo){
  var S=window._vdP; if(!S) return;
  var nom=VDP_NOMBRES[campo]||campo;
  var v=prompt(nom+' para TODAS las referencias nuevas.\n(Vacío = quitar lo escrito a mano)');
  if(v===null) return;
  S.lineas.forEach(function(l,i){ if(!l.existeVD) _vdpSetLinea(i, campo, v, true); });
  _vdpPintar();
}

// ── Datos del embarque: los campos de usuario de SAP ──────────────────────
// Son los de la cabecera de los documentos de marketing (los mismos en la
// orden de venta y en las de compra): el worker los lee de CUFD.
var VDP_UDF_PRINCIPALES=/barco|contenedor|naviera|^bl|puerto|pais|tamano|tipo|eta|booking|estatus|arrib|marcadecliente|descripciondecarga|embarque|fecha/;

async function _vdpCargarUdf(){
  var S=window._vdP; if(!S) return;
  S.udfCampos=await _fruCargar();
  _vdpPintar();
}
function _vdpSetUdf(alias, valor){
  var S=window._vdP; if(!S) return;
  S.udf=S.udf||{};
  if(valor==='' || valor==null) delete S.udf[alias]; else S.udf[alias]=valor;
}
function _vdpUdfHtml(S){
  var campos=S.udfCampos;
  if(!campos) return '<div style="font-size:11px;color:var(--text-muted)"><span class="ai-ring g"></span> '
    +'Cargando los campos de SAP…</div>';
  if(!campos.length) return '<div style="font-size:11px;color:var(--text-muted)">El worker todavía no '
    +'ha leído los campos de usuario de SAP (tabla campos_usuario_opch).</div>';
  var ver=S.udfTodos;
  var lista=campos.filter(function(c){ return ver || VDP_UDF_PRINCIPALES.test(_fruClave(c.titulo||c.alias)); });
  var est='width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  var hayPais=campos.some(function(c){ return /pais/.test(_fruClave(c.titulo||c.alias)); });
  return '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:9px">'
    + lista.map(function(c){
        var v=(S.udf||{})[c.alias]||'';
        var ctl;
        if((c.opciones||[]).length){
          ctl='<select onchange="_vdpSetUdf(\''+c.alias+'\',this.value)" style="'+est+'">'
            +'<option value="">—</option>'+c.opciones.map(function(o){
              return '<option value="'+_esc(o.v)+'"'+(String(v)===String(o.v)?' selected':'')+'>'
                +_esc(o.t||o.v)+'</option>'; }).join('')+'</select>';
        } else if(String(c.tipo||'').toUpperCase()==='D'){
          ctl='<input type="date" value="'+_esc(String(v).slice(0,10))+'" '
            +'onchange="_vdpSetUdf(\''+c.alias+'\',this.value)" style="'+est+'">';
        } else {
          ctl='<input value="'+_esc(v)+'" '+(c.largo?('maxlength="'+c.largo+'" '):'')
            +'onchange="_vdpSetUdf(\''+c.alias+'\',this.value)" style="'+est+'">';
        }
        return '<div><label style="font-size:11px;color:var(--text-muted)">'+_esc(c.titulo||c.alias)
          +'</label><div style="margin-top:3px">'+ctl+'</div></div>';
      }).join('')+'</div>'
    +'<div style="display:flex;gap:12px;margin-top:6px;font-size:10.5px;flex-wrap:wrap">'
    +'<span onclick="window._vdP.udfTodos=!window._vdP.udfTodos;_vdpPintar()" '
    +'style="color:var(--text-accent);cursor:pointer">'
    +(ver?'Ver solo los del embarque':('Ver los '+(campos.length-lista.length)+' campos restantes'))+'</span>'
    +'<span style="color:var(--text-muted)">Van a la orden de venta y a todas las órdenes de compra.'
    +(hayPais?'':' No hay ningún campo «País» en SAP: si hace falta, hay que crearlo allí y aparece solo.')
    +'</span></div>';
}

function _vdpQuitarPacking(name){
  var S=window._vdP; if(!S) return;
  if(!confirm('Quito lo leído de todos los packing y vuelvo a empezar con ellos. ¿Sigo?')) return;
  S.packing={}; S.packs=[]; S.medidas=null; _vdpPintar();
}

// La referencia /VD de la proforma que casa con una clave del packing
function _vdpRefDeClave(k){
  var S=window._vdP; if(!S) return '';
  var l=S.lineas.filter(function(x){ return x.clave===k; })[0];
  return l ? l.ref : '';
}

/* Corregir una referencia del packing que no casó (el equivalente a
   _fipCorregirRef de la factura reserva): se escribe en la columna
   «Artículo en SAP» la referencia de la proforma, con o sin /VD, y la fila
   de medidas pasa a ser de esa línea. */
function _vdpTrasCorregirSap(m, callado){
  var S=window._vdP; if(!S||!m) return;
  var k=_vdpNorm(m.sap);
  var l=S.lineas.filter(function(x){ return x.clave===k; })[0];
  if(!l){
    if(!callado) showT('«'+m.sap+'» no está en la proforma');
    m.sap='';
  } else {
    var otra=(S.medidas||[]).filter(function(x){ return x!==m && x.sap===l.ref; })[0];
    if(otra && !callado && !confirm(l.ref+' ya tiene medidas de otra fila del packing ('
      +otra.itemcode+'). ¿Uso estas en su lugar?')){ m.sap=''; _vdpPintar(); return; }
    if(otra) otra.sap='';
    m.sap=l.ref;
    if(S.packing[m.clave] && m.clave!==l.clave){
      S.packing[l.clave]=S.packing[m.clave];
      delete S.packing[m.clave];
    }
    m.clave=l.clave;
    if(!callado) showT('✓ '+m.itemcode+' → '+l.ref);
  }
  if(!callado) _vdpPintar();
}

// Las medidas (ya revisadas en la tabla) de una línea de la proforma
function _vdpMedDe(l){
  var L=_fipMedidasLista('vd');
  return L.filter(function(m){ return m.sap===l.ref; })[0] || null;
}

// ── Cálculos ──────────────────────────────────────────────────────────────
function _vdpPorProveedor(){
  var S=window._vdP, por={};
  (S?S.lineas:[]).forEach(function(l){
    var p=l.prefijo||'—';
    var a=por[p]||(por[p]={prefijo:p, n:0, pzs:0, compra:0, venta:0});
    a.n++; a.pzs+=l.piezas; a.compra+=l.piezas*l.costo; a.venta+=l.piezas*l.venta;
  });
  return por;
}

function _vdpProblemas(){
  var S=window._vdP, bloquean=[], avisos=[];
  if(!S) return {bloquean:['no hay venta directa abierta'], avisos:[]};
  if(!S.lineas.length) bloquean.push('Carga la proforma de venta.');
  if(!S.cliente) bloquean.push('Elige el cliente.');
  var num=String(S.numero||'').trim();
  if(!num) bloquean.push('Escribe el número de la orden de venta.');
  else if(!/^\d{1,9}$/.test(num)) bloquean.push('El número de la orden de venta tiene que ser '
    +'solo dígitos (SAP lo guarda como número).');
  var prov=S.proveedores||{};
  Object.keys(_vdpPorProveedor()).forEach(function(p){
    var x=prov[p];
    if(p==='—') bloquean.push('Hay líneas sin prefijo de proveedor.');
    else if(x && x.ok===false) bloquean.push('El proveedor '+p+' no existe en SAP (socio de negocio).');
    else if(!x) avisos.push('No pude comprobar el proveedor '+p+'; lo comprobará el worker.');
  });
  var sinCant=S.lineas.filter(function(l){ return !(l.piezas>0); }).length;
  if(sinCant) bloquean.push(sinCant+' línea(s) sin piezas.');
  var sinVenta=S.lineas.filter(function(l){ return !(l.venta>0); }).length;
  if(sinVenta) bloquean.push(sinVenta+' línea(s) sin precio de venta.');
  var sinCosto=S.lineas.filter(function(l){ return !(l.costo>0); }).length;
  if(sinCosto) avisos.push(sinCosto+' línea(s) sin precio de costo: la orden de compra irá a 0.');
  // Un artículo /VD nuevo se crea copiando la ficha del artículo base
  var sinBase=S.lineas.filter(function(l){ return l.existeVD===false && l.baseExiste===false; });
  if(sinBase.length) bloquean.push(sinBase.length+' referencia(s) nuevas cuyo artículo base '
    +'(la «ref adicional») no existe en SAP: '+sinBase.slice(0,3).map(function(l){
      return l.base; }).join(', ')+(sinBase.length>3?'…':'')
    +'. Sin él no hay descripción, departamento ni arancel que copiar.');
  if(S.lineas.some(function(l){ return l.existeVD===null; }))
    avisos.push('Falta comprobar las referencias en SAP.');
  var sinMed=S.lineas.filter(function(l){ return l.existeVD!==true && !_vdpMedFinal(l); }).length;
  if(sinMed) avisos.push(sinMed+' artículo(s) nuevos sin peso ni cubicaje (ni del packing ni escritos en la '
    +'ficha): se crean sin ellos.');
  var sinBc=S.lineas.filter(function(l){ return l.existeVD===false && !l.barcode; }).length;
  if(sinBc) avisos.push(sinBc+' artículo(s) nuevos sin código de barras (en rojo en la tabla).');
  var sinBu=S.lineas.filter(function(l){ return l.existeVD===false && !_vdpBultoDe(l); }).length;
  if(sinBu) avisos.push(sinBu+' artículo(s) nuevos sin bulto por unidad: en la orden saldría 1 (en rojo en la tabla).');
  var difPzs=S.lineas.filter(function(l){
    var pk=S.packing[l.clave]; return pk && Math.abs((pk.cantidad||0)-l.piezas)>0.001; });
  if(difPzs.length) avisos.push(difPzs.length+' línea(s) con piezas distintas a las del packing '
    +'(manda la proforma).');
  return {bloquean:bloquean, avisos:avisos};
}

// ── La pantalla ───────────────────────────────────────────────────────────
function _vdpPintar(){
  var c=document.getElementById('vdpCuerpo'); if(!c) return;
  // Se guarda dónde estaba uno (la ventana y la ficha) para volver ahí
  var ov=document.getElementById('modalVDP'), fb=c.querySelector('.vdp-ficha');
  fb=fb && fb.closest('.tbx-box');
  var pos={ov:ov?ov.scrollTop:0, t:fb?fb.scrollTop:0, l:fb?fb.scrollLeft:0};
  setTimeout(function(){
    if(ov) ov.scrollTop=pos.ov;
    var f2=c.querySelector('.vdp-ficha'); f2=f2 && f2.closest('.tbx-box');
    if(f2){ f2.scrollTop=pos.t; f2.scrollLeft=pos.l; }
  }, 0);
  var S=window._vdP; if(!S) return;
  var por=_vdpPorProveedor();
  var tot=Object.keys(por).reduce(function(a,k){
    a.compra+=por[k].compra; a.venta+=por[k].venta; a.pzs+=por[k].pzs; return a; },
    {compra:0, venta:0, pzs:0});
  var gastos=(S.cargos||[]).reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
  var prob=_vdpProblemas();
  var est='width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  var caja=function(titulo, cuerpo){
    return '<div style="border:0.5px solid var(--border);border-radius:10px;padding:11px 13px;'
      +'background:var(--surface-0);margin-bottom:11px">'
      +'<div style="font-size:12.5px;font-weight:700;margin-bottom:7px">'+titulo+'</div>'
      +cuerpo+'</div>';
  };

  var h='<div style="display:flex;align-items:center;gap:10px;margin-bottom:12px">'
    +'<i class="ti ti-file-spreadsheet" style="font-size:22px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +'Nueva venta directa desde la proforma</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Proforma → packing lists → '
    +'artículos /VD en bodega VD → orden de venta con su número → una orden de compra '
    +'por proveedor.</div></div>'
    +'<button class="xb" onclick="_vdpCerrar()"><i class="ti ti-x"></i></button></div>';

  // 1 · Proforma
  h+=caja('1 · Proforma de venta',
    '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
    +'<label class="xb" style="cursor:pointer"><i class="ti ti-file-upload"></i> '
    +(S.archivo?_esc(S.archivo):'Cargar la proforma (Excel)')
    +'<input type="file" accept=".xlsx,.xls" style="display:none" onchange="_vdpProforma(this)"></label>'
    +(S.leyendo?'<span class="ai-ring g"></span>':'')
    +(S.lineas.length?('<button class="xb" onclick="_vdpComprobar()"><i class="ti ti-refresh"></i> '
      +'Comprobar otra vez en SAP</button>'):'')
    +(S.comprobando?'<span style="font-size:11px;color:var(--text-muted)">comprobando…</span>':'')
    +'</div>'
    +(S.lineas.length?('<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:8px;font-size:11.5px">'
      +'<span class="vdp-chip"><b>'+S.lineas.length+'</b> líneas</span>'
      +'<span class="vdp-chip">'+_fmtN2(tot.pzs)+' pzas</span>'
      +'<span class="vdp-chip">Compra <b>'+_fmtN2(tot.compra)+'</b></span>'
      +'<span class="vdp-chip">Venta <b>'+_fmtN2(tot.venta)+'</b></span>'
      +'<span class="vdp-chip" style="background:var(--pastel-ok);color:var(--t-verde)">Margen <b>'
      +_fmtN2(tot.venta-tot.compra)+'</b>'
      +(tot.venta?(' · '+((tot.venta-tot.compra)/tot.venta*100).toFixed(1)+' %'):'')+'</span>'
      +'<span class="vdp-chip">'+S.lineas.filter(function(l){ return l.existeVD===true; }).length
      +' ya existen /VD</span></div>'):'')
    +((S.avisos||[]).length?('<div class="nota" style="background:var(--pastel-aviso);'
      +'color:var(--t-marron);margin-top:8px;font-size:11px">'
      + S.avisos.slice(0,8).map(_esc).join('<br>')
      +(S.avisos.length>8?('<br>… y '+(S.avisos.length-8)+' más'):'')+'</div>'):'')
    +((S.fallosComprobar||[]).length?('<div class="nota" style="background:var(--pastel-error);'
      +'color:var(--t-rojo);margin-top:8px;font-size:11px">No pude comprobar: '
      +_esc(S.fallosComprobar.join(' · '))+'</div>'):''));

  if(S.lineas.length){
    // 2 · Datos de la orden de venta
    h+=caja('2 · La orden de venta',
      '<div style="display:flex;gap:9px;flex-wrap:wrap">'
      + _vdCampo('Cliente <span style="color:var(--t-rojo)">*</span>',
          '<input value="'+_esc(S.cliente?(S.cliente.cardcode+' · '+S.cliente.cardname):'')
          +'" placeholder="Busca por nombre o código…" oninput="_vdpBuscarCliente(this.value)" '
          +'style="'+est+'"><div id="vdpCliRes"></div>')
      + _vdCampo('N.º de la orden de venta <span style="color:var(--t-rojo)">*</span>',
          '<input value="'+_esc(S.numero)+'" inputmode="numeric" placeholder="El que se pone a mano" '
          +'onchange="window._vdP.numero=this.value.trim();_vdpPintar()" style="'+est
          +';font-weight:700'+(S.numero?'':';border-color:var(--t-rojo)')+'">')
      + _vdCampo('Vendedor',
          '<select onchange="window._vdP.vendedor=this.value" style="'+est+'">'
          +'<option value="">—</option>'
          +(S.vendedores||[]).map(function(v){
              var cod=v.slpcode!=null?v.slpcode:v.codigo;
              return '<option value="'+_esc(cod)+'"'+(String(S.vendedor)===String(cod)?' selected':'')
                +'>'+_esc(v.slpname||v.nombre||cod)+'</option>'; }).join('')
          +'</select>')
      + _vdCampo('Referencia del cliente',
          '<input value="'+_esc(S.numatcard)+'" onchange="window._vdP.numatcard=this.value" '
          +'style="'+est+'">')
      +'</div>'
      +'<div style="margin-top:8px">'+_vdCampo('Comentarios',
          '<input value="'+_esc(S.comentarios)+'" onchange="window._vdP.comentarios=this.value" '
          +'style="'+est+'">')+'</div>'
      + _vdpCargosHtml(S));

    h+=caja('Datos del embarque · campos de usuario de SAP', _vdpUdfHtml(S));

    // 3 · Proveedores
    h+=caja('3 · Una orden de compra por proveedor (el prefijo de la referencia)',
      '<div class="tbx-box"><table class="tbx"><thead><tr>'
      +'<th style="width:70px">Prefijo</th><th>Proveedor en SAP</th>'
      +'<th style="width:60px;text-align:right">Líneas</th>'
      +'<th style="width:80px;text-align:right">Piezas</th>'
      +'<th style="width:100px;text-align:right">Compra</th>'
      +'<th style="width:100px;text-align:right">Venta</th>'
      +'<th style="width:100px;text-align:right">Margen</th>'
      +'<th style="width:170px">Vendor Ref. No. de la OC</th></tr></thead><tbody>'
      + Object.keys(por).sort(function(a,b){ return por[b].compra-por[a].compra; }).map(function(p){
          var a=por[p], x=(S.proveedores||{})[p];
          var nom = !x ? '<span style="color:var(--text-muted)">sin comprobar</span>'
                  : (x.ok ? ('<b>'+_esc(x.cardcode)+'</b> · '+_esc(x.cardname))
                          : '<span style="color:var(--t-rojo);font-weight:600">'
                            +'<i class="ti ti-alert-triangle"></i> no existe en SAP</span>');
          return '<tr><td><b>'+_esc(p)+'</b></td><td>'+nom+'</td>'
            +'<td style="text-align:right">'+a.n+'</td>'
            +'<td style="text-align:right">'+_fmtN2(a.pzs)+'</td>'
            +'<td style="text-align:right">'+_fmtN2(a.compra)+'</td>'
            +'<td style="text-align:right">'+_fmtN2(a.venta)+'</td>'
            +'<td style="text-align:right">'+_fmtN2(a.venta-a.compra)+'</td>'
            +'<td style="padding:0"><input value="'+_esc(x?x.numatcard:'')+'" '
            +'placeholder="PI / factura del proveedor" '
            +'onchange="_vdpSetNumatcard(\''+_esc(p)+'\',this.value)" '
            +'style="width:100%;box-sizing:border-box;border:none;background:transparent;'
            +'font-size:12px;padding:4px 6px;color:var(--text-primary)"></td></tr>';
        }).join('')
      +'</tbody></table></div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:4px">El Vendor Ref. No. es '
      +'opcional. Si se pone, sirve además para que SAP no cree dos veces la misma orden.</div>');

    // 4 · Packing lists y medidas
    var leidas=Object.keys(S.packing||{}).length;
    h+=caja('4 · Packing lists: peso, cubicaje, cajas y empaque',
      '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
      +'<label class="xb" style="cursor:pointer"><i class="ti ti-file-upload"></i> '
      +'Añadir packing lists (Excel o PDF, varios a la vez)'
      +'<input type="file" multiple accept=".xlsx,.xls,.csv,.pdf,image/*" style="display:none" '
      +'onchange="_vdpPacking(this)"></label>'
      +(S.leyendo?'<span class="ai-ring g"></span> Leyendo…':'')
      +(S.packs.length?('<button class="xb" onclick="_vdpQuitarPacking()"><i class="ti ti-trash">'
        +'</i> Empezar de nuevo</button>'):'')
      +'</div>'
      +(S.packs.length?('<div style="font-size:11px;margin-top:6px">'
        + S.packs.map(function(x){
            return '<div>'+(x.error?'<span style="color:var(--t-rojo)">✗</span>':'✓')+' '
              +_esc(x.name)+' · '+(x.error?_esc(x.error):(x.n+' referencia(s)'
              +(x.como==='IA'?' (leído con IA)':'')
              +(x.rep?(' · '+x.rep+' ya venían de otro packing'):'')))+'</div>'; }).join('')
        +'</div>'):'')
      +(leidas?_fipMedidasHtml('vd'):''));

    // 5 · La ficha de producto completa
    h+=caja('5 · Ficha de producto · lo que se crea en SAP', _vdpLineasHtml(S));
  }

  // Pie: pegado abajo de la pantalla, para que el botón y lo que está pasando
  // se vean siempre, aunque la tabla de 180 líneas quede arriba (v714)
  h+='<div style="position:sticky;bottom:-18px;z-index:3;background:var(--surface-2);'
    +'margin:0 -18px -18px;padding:10px 18px 14px;border-top:1px solid var(--border);'
    +'border-radius:0 0 14px 14px;box-shadow:0 -6px 16px rgba(0,0,0,.08)">'
    +'<div id="vdpEstado">'+_vdpEstadoHtml(S.estadoUI)+'</div>'
    +'<div style="display:flex;align-items:flex-start;gap:10px;flex-wrap:wrap">'
    +'<div id="vdpProblemas" style="flex:1;min-width:300px;font-size:11.5px">'+_vdpProblemasHtml(S)+'</div>'
    +'<button class="btn bg2" onclick="_vdpCerrar()" style="padding:9px 14px">Cancelar</button>'
    +'<button class="btn bp" id="vdpBtnCrear" onclick="_vdpCrear()" style="padding:9px 18px'
    +(prob.bloquean.length?';opacity:.55" title="Falta lo que está en rojo"':'"')
    +(S.enviando?' disabled':'')+'>'
    +(S.enviando?'<span class="ai-ring g"></span> Trabajando…':'<i class="ti ti-send"></i> Crear todo en SAP')
    +'</button></div></div>'
    +'<style>.vdp-chip{background:var(--surface-1);border-radius:8px;padding:3px 9px}</style>';
  c.innerHTML=h;
}

function _vdpSetNumatcard(p, v){
  var S=window._vdP; if(!S) return;
  S.proveedores[p]=S.proveedores[p]||{cardcode:p, ok:null, cardname:''};
  S.proveedores[p].numatcard=String(v||'').trim();
}

// Una fila de la ficha (se repinta sola al editar una celda, sin tocar el resto)
function _vdpFilaHtml(S, l, i){
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;font-size:11.5px;'
    +'padding:4px 5px;color:var(--text-primary);font-family:inherit';
  var izq={itemname:1, barcode:1, unidad:1, medida:1};
  var celda=function(l, i, campo, ancho, falta){
    var valor=_vdpValor(l, campo);
    if(l.existeVD) return '<td style="color:var(--text-muted);font-size:11px;padding:4px 6px;white-space:nowrap" '
      +'title="Ya existe en SAP: no se toca">'+_esc(valor==null?'':valor)+'</td>';
    return '<td class="vdp-ed" data-r="'+i+'" data-c="'+campo+'" style="padding:0;background:'
      +(falta?'rgba(220,38,38,.10)':'var(--surface-2)')+';min-width:'+ancho+'px">'
      +'<input value="'+_esc(valor==null?'':valor)+'" placeholder="'+(falta?'falta':'')+'" '
      +'onchange="_vdpCelda('+i+',\''+campo+'\',this.value)" '
      +'onpaste="_vdpPegarLinea(event,'+i+',\''+campo+'\')" '
      +'onkeydown="_vdpTecla(event,'+i+',\''+campo+'\')" '
      +'style="'+inp+(izq[campo]?'':';text-align:right')+'">'
      +'<div class="vdp-asa" title="Arrastra hacia abajo para copiar · doble clic: hasta el final" '
      +'onmousedown="_vdpAsaIni(event,'+i+',\''+campo+'\')" ondblclick="_vdpAsaHastaFin('+i+',\''+campo+'\')"></div></td>';
  };
  var ro=function(v, extra){ return '<td style="padding:4px 6px;text-align:right;white-space:nowrap;'+(extra||'')+'">'+v+'</td>'; };
  var fijo='position:sticky;left:0;z-index:2;background:var(--surface-0)';
  var fijo2='position:sticky;left:30px;z-index:2;background:var(--surface-0);box-shadow:2px 0 0 var(--border)';
        var pk=S.packing[l.clave];
        var difP=pk && Math.abs((pk.cantidad||0)-l.piezas)>0.001;
        var mf=_vdpMedFinal(l);
        var mg=l.venta?((l.venta-l.costo)/l.venta*100):0;
        var sap = l.existeVD===null ? '<span style="color:var(--text-muted)">sin comprobar</span>'
          : l.existeVD ? '<span style="color:var(--t-azul)"><i class="ti ti-check"></i> ya existe</span>'
          : l.baseExiste ? '<span style="color:var(--t-verde)"><i class="ti ti-plus"></i> se crea</span>'
          : '<span style="color:var(--t-rojo)"><i class="ti ti-alert-triangle"></i> sin base</span>';
        var difCosto = (l.sistema!=null && Math.abs(l.sistema-l.costo)>0.001);
        var bcCelda=celda(l, i, 'barcode', 125, !l.barcode);
        if(!l.existeVD && l.barcodeFuente) bcCelda=bcCelda.replace('<td class="vdp-ed"',
          '<td title="Sale de: '+_esc(l.barcodeFuente)+'" class="vdp-ed"');
        var costoCelda=celda(l, i, 'costo', 72, !(l.costo>0));
        if(difCosto) costoCelda=costoCelda.replace('<td class="vdp-ed"','<td title="Costo en sistema '+_fmtN2(l.sistema)+'" class="vdp-ed"')
          .replace('text-align:right">','text-align:right;color:var(--t-marron);font-weight:700">');
        return '<tr data-vdpfila="'+i+'"'+((l.existeVD===false && l.baseExiste===false)?' style="background:rgba(220,38,38,.06)"':'')+'>'
          +'<td style="color:var(--text-muted);'+fijo+'">'+(i+1)+'</td>'
          +'<td style="white-space:nowrap;'+fijo2+'"><b>'+_esc(l.ref)+'</b>'+(l.refOriginal!==l.ref?'<div style="font-size:9px;'
            +'color:var(--t-marron)">se le añadió /VD</div>':'')+'</td>'
          + celda(l, i, 'itemname', 220, !_vdpValor(l,'itemname'))
          +'<td>'+_esc(l.prefijo)+'</td>'
          + ro(_fmtN2(l.piezas))
          + ro(pk?_fmtN2(pk.cantidad):'—', difP?'background:var(--pastel-aviso);color:var(--t-marron);font-weight:700':'color:var(--text-muted)')
          + costoCelda
          + celda(l, i, 'venta', 72, !(l.venta>0))
          + ro(mg.toFixed(0)+'%','font-size:11px')
          + bcCelda
          + celda(l, i, 'unidad', 56, !l.unidad)
          + celda(l, i, 'empaque', 70, !_vdpBultoDe(l))
          + celda(l, i, 'cantCompra', 62, false)
          + celda(l, i, 'peso_bulto', 74, !(mf&&mf.peso_bulto_kg))
          + ro(mf&&mf.peso_pieza_kg?(mf.peso_pieza_kg).toFixed(3):'—','color:var(--text-secondary)')
          + celda(l, i, 'vol_bulto', 86, !(mf&&mf.vol_bulto_pie3))
          + ro(mf&&mf.vol_pieza_pie3?(mf.vol_pieza_pie3).toFixed(4):'—','color:var(--text-secondary)')
          + celda(l, i, 'medida', 100, false)
          +'<td style="font-size:10.5px;color:var(--text-muted);white-space:nowrap">'+_esc(String(l.ref).replace(/\/\s*VD$/i,''))+'.jpg</td>'
          +'<td style="font-size:10.5px">VD</td>'
          +'<td style="font-size:10.5px;white-space:nowrap">'+sap+'</td></tr>';
}

function _vdpLineasHtml(S){
  var nuevas=S.lineas.filter(function(l){ return !l.existeVD; });
  var cuenta=function(f){ return nuevas.filter(f).length; };
  var faltan=[['sin código de barras', cuenta(function(l){ return !l.barcode; })],
              ['sin bulto por unidad', cuenta(function(l){ return !_vdpBultoDe(l); })],
              ['sin peso', cuenta(function(l){ var m=_vdpMedFinal(l); return !(m&&m.peso_bulto_kg); })],
              ['sin cubicaje', cuenta(function(l){ var m=_vdpMedFinal(l); return !(m&&m.vol_bulto_pie3); })],
              ['sin descripción', cuenta(function(l){ return !_vdpValor(l,'itemname'); })]]
    .filter(function(x){ return x[1]; });
  var fuentes={};
  nuevas.forEach(function(l){ if(l.barcode) fuentes[l.barcodeFuente]=(fuentes[l.barcodeFuente]||0)+1; });
  var btn=function(campo,t){ return '<button class="xb" style="font-size:10.5px" onclick="_vdpTodaColumna(\''+campo+'\')">'
    +'<i class="ti ti-arrow-bar-to-down"></i> '+t+'</button>'; };
  var th=function(t, w, ed, tit, der){
    return '<th style="min-width:'+w+'px;'+(der?'text-align:right;':'')+(ed?'background:var(--pastel-azul)':'')+'"'
      +(tit?(' title="'+_esc(tit)+'"'):'')+'>'+t+(ed?' ✎':'')+'</th>'; };
  var fijo='position:sticky;left:0;z-index:2;background:var(--surface-0)';
  var fijo2='position:sticky;left:30px;z-index:2;background:var(--surface-0);box-shadow:2px 0 0 var(--border)';
  return '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:6px;font-size:11px">'
    +'<span id="vdpFichaRes" style="display:flex;gap:8px;flex-wrap:wrap"><span><b>'+nuevas.length+'</b> artículo(s) nuevos · códigos de barras: '+Object.keys(fuentes).map(function(k){
        return '<b>'+fuentes[k]+'</b> de '+_esc(k); }).join(' · ')+'</span>'
    +(faltan.length?('<span style="color:var(--t-rojo);font-weight:700">Falta: '+faltan.map(function(x){
        return x[1]+' '+x[0]; }).join(' · ')+'</span>'):'<span style="color:var(--t-verde);font-weight:700">'
        +'<i class="ti ti-circle-check"></i> Ficha completa</span>')+'</span>'
    +'<span style="flex:1"></span>'
    + btn('unidad','Unidad') + btn('empaque','Bulto') + btn('cantCompra','Pzs/unidad')
    +'<button class="xb" style="font-size:10.5px" onclick="_vdpFichaExcel()"><i class="ti ti-file-spreadsheet"></i> Descargar en Excel</button>'
    +'</div>'
    +'<style>.vdp-ed{position:relative}.vdp-ed .vdp-asa{display:none;position:absolute;right:-4px;bottom:-4px;'
    +'width:8px;height:8px;background:#0F766E;border:1px solid #fff;cursor:crosshair;z-index:3}'
    +'.vdp-ed:focus-within{outline:2px solid #0F766E;outline-offset:-2px}.vdp-ed:focus-within .vdp-asa{display:block}'
    +'.vdp-ed.vdp-rango{background:rgba(15,118,110,.18)!important}'
    +'.vdp-ficha th{position:sticky;top:0;z-index:3;white-space:nowrap}.vdp-ficha th:nth-child(1),.vdp-ficha th:nth-child(2){z-index:4}</style>'
    +'<div class="tbx-box" style="max-height:60vh;overflow:auto"><table class="tbx vdp-ficha">'
    +'<thead><tr>'
    +'<th style="min-width:30px;'+fijo+'">#</th><th style="min-width:140px;'+fijo2+'">Referencia /VD</th>'
    + th('Descripción',220,true,'Sale del artículo base en SAP; si se cambia aquí, va la de aquí')
    + th('Prov.',44) + th('Piezas',56,false,'',true) + th('Packing',58,false,'Piezas según el packing',true)
    + th('Costo FOB',72,true,'Lista 1 · FOB',true) + th('Venta',72,true,'Lista 4 · VD',true) + th('Marg.',46,false,'',true)
    + th('Código de barras',125,true) + th('Unidad',56,true)
    + th('Bulto x unidad',70,true,'Piezas por caja: el «Bulto por Unidad» de la orden de venta',true)
    + th('Pzs/unidad',62,true,'Artículos por unidad de compra',true)
    + th('Peso bulto kg',74,true,'',true) + th('Peso pieza kg',70,false,'= peso del bulto / bulto por unidad',true)
    + th('Cubicaje bulto pie³',86,true,'',true) + th('Cubicaje pieza pie³',84,false,'= cubicaje del bulto / bulto por unidad',true)
    + th('Medida cartón',100,true) + th('Foto',110,false,'Nombre de la imagen: la referencia sin /VD')
    + th('Bodega',50) + th('En SAP',90)
    +'</tr></thead><tbody>'
    + S.lineas.map(function(l,i){ return _vdpFilaHtml(S, l, i);
      }).join('')
    +'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:4px;line-height:1.5">'
    +'Es la <b>ficha completa</b> que se crea en SAP. Lo que tiene ✎ se edita como en Excel: escribe en la celda, '
    +'<b>pega un bloque copiado del Excel</b> (rellena hacia abajo y a la derecha desde ahí), <b>arrastra el cuadrito verde</b> '
    +'de la esquina hacia abajo para copiar el valor (doble clic: hasta el final), flechas ↑↓ y Enter para moverse. '
    +'<b>En rojo lo que falta.</b> Peso y cubicaje por pieza se calculan solos con el bulto por unidad. El código de barras sale de la '
    +'proforma, si no del artículo base en SAP y si no del packing (pasa el ratón para ver de dónde). Costo en ámbar: no coincide '
    +'con el costo en sistema. «Packing» en ámbar: piezas distintas; manda la proforma. Los /VD que ya existen no se tocan.'
    +'</div>';
}


// Al cambiar una celda de la ficha: se guarda y se repinta SOLO esa fila, el
// resumen de lo que falta y el pie. Así no se pierde ni el sitio en la tabla
// ni la celda en la que uno está.
function _vdpCelda(i, campo, valor){
  var S=window._vdP; if(!S) return;
  _vdpSetLinea(i, campo, valor, true);
  _vdpRefrescarFila(i);
  _vdpRefrescarResumen();
}
function _vdpRefrescarFila(i){
  var S=window._vdP; if(!S) return;
  var tr=document.querySelector('tr[data-vdpfila="'+i+'"]'); if(!tr) return;
  var act=document.activeElement, enFila=act && tr.contains(act);
  var td=enFila && act.closest('td'), campo=td && td.getAttribute('data-c');
  var tmp=document.createElement('tbody');
  tmp.innerHTML=_vdpFilaHtml(S, S.lineas[i], i);
  var nuevo=tmp.firstElementChild; if(!nuevo) return;
  tr.replaceWith(nuevo);
  if(campo){ var otro=nuevo.querySelector('td[data-c="'+campo+'"] input'); if(otro){ otro.focus(); } }
}
function _vdpRefrescarResumen(){
  var S=window._vdP; if(!S) return;
  var box=document.getElementById('vdpFichaRes');
  if(box){
    var tmp=document.createElement('div');
    tmp.innerHTML=_vdpLineasHtml(S);
    var nuevo=tmp.querySelector('#vdpFichaRes'); if(nuevo) box.innerHTML=nuevo.innerHTML;
  }
  var pb=document.getElementById('vdpProblemas'); if(pb) pb.innerHTML=_vdpProblemasHtml(S);
}


// Lo que falta o hay que mirar, y los totales, en el pie de la pantalla
function _vdpProblemasHtml(S){
  var prob=_vdpProblemas(), por=_vdpPorProveedor();
  var tot=Object.keys(por).reduce(function(a,k){ a.compra+=por[k].compra; a.venta+=por[k].venta; return a; },{compra:0, venta:0});
  var gastos=(S.cargos||[]).reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
  return (prob.bloquean.length?('<div style="color:var(--t-rojo)">'+prob.bloquean.map(function(x){
        return '<div><i class="ti ti-circle-x"></i> '+_esc(x)+'</div>'; }).join('')+'</div>'):'')
    +(prob.avisos.length?('<div style="color:var(--t-marron);margin-top:3px">'+prob.avisos.map(function(x){
        return '<div><i class="ti ti-alert-triangle"></i> '+_esc(x)+'</div>'; }).join('')+'</div>'):'')
    +(S.lineas.length?('<div style="margin-top:5px"><b>'+_fmtN2(tot.venta+gastos)+'</b> la orden de '
      +'venta'+(gastos?(' ('+_fmtN2(gastos)+' de gastos)'):'')+' · '+Object.keys(por).length
      +' orden(es) de compra por '+_fmtN2(tot.compra)+'</div>'):'');
}

// La ficha en un Excel, para revisarla fuera o pasarla a alguien
function _vdpFichaExcel(){
  var S=window._vdP; if(!S || !S.lineas.length) return;
  if(typeof XLSX==='undefined'){ showT('No está cargado el lector de Excel'); return; }
  var cab=['Referencia /VD','Descripción','Proveedor','Piezas','Piezas packing','Costo FOB (lista 1)','Precio venta (lista 4)',
           'Código de barras','Origen del código','Unidad','Bulto por unidad','Pzs por unidad de compra','Peso bulto kg',
           'Peso pieza kg','Cubicaje bulto pie3','Cubicaje pieza pie3','Medida cartón','Foto','Bodega','En SAP'];
  var filas=[cab].concat(S.lineas.map(function(l){
    var mf=_vdpMedFinal(l), pk=S.packing[l.clave];
    return [l.ref, _vdpValor(l,'itemname'), l.prefijo, l.piezas, pk?pk.cantidad:'', l.costo, l.venta,
            l.barcode||'', l.barcodeFuente||'', l.unidad||'PZA', _vdpBultoDe(l)||'', l.cantCompra||'',
            mf?mf.peso_bulto_kg:'', mf?Math.round(mf.peso_pieza_kg*1000)/1000:'',
            mf?mf.vol_bulto_pie3:'', mf?Math.round(mf.vol_pieza_pie3*10000)/10000:'',
            mf?mf.medida_carton:'', String(l.ref).replace(/\/\s*VD$/i,'')+'.jpg', 'VD',
            l.existeVD?'ya existe':(l.baseExiste?'se crea':'sin base')];
  }));
  var ws=XLSX.utils.aoa_to_sheet(filas);
  ws['!cols']=cab.map(function(c,i){ return {wch:i===1?40:Math.max(12,c.length+2)}; });
  var wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Ficha VD');
  XLSX.writeFile(wb, 'ficha_VD_'+(S.numero||_hoyISO())+'.xlsx');
}

// Los gastos de la orden de venta (flete y demás), como en la venta directa de siempre
function _vdpCargosHtml(S){
  var cg=S.cargos||[];
  return '<div style="margin-top:9px">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Flete y otros gastos '
    +'de la orden de venta (no pasan a las órdenes de compra)</div>'
    + cg.map(function(c,i){
        return '<div style="display:flex;gap:7px;align-items:center;margin-bottom:4px">'
          +'<input value="'+_esc(c.concepto)+'" onchange="window._vdP.cargos['+i+'].concepto=this.value" '
          +'style="flex:1;padding:5px 8px;border:0.5px solid var(--border);border-radius:6px;'
          +'font-size:12px;background:var(--surface-2);color:var(--text-primary)">'
          +'<input inputmode="decimal" value="'+(c.monto||0)+'" '
          +'onchange="window._vdP.cargos['+i+'].monto=Number(String(this.value).replace(\',\',\'.\'))||0;_vdpPintar()" '
          +'style="width:120px;text-align:right;padding:5px 8px;border:0.5px solid var(--border);'
          +'border-radius:6px;font-size:12px;background:var(--surface-2);color:var(--text-primary)">'
          +'<button class="xb" onclick="window._vdP.cargos.splice('+i+',1);_vdpPintar()">'
          +'<i class="ti ti-x"></i></button></div>';
      }).join('')
    +'<button class="xb" style="font-size:10.5px;padding:2px 8px" '
    +'onclick="window._vdP.cargos.push({concepto:\'Flete\',monto:0});_vdpPintar()">'
    +'<i class="ti ti-plus"></i> Añadir gasto</button></div>';
}

async function _vdpBuscarCliente(q){
  var S=window._vdP; if(!S) return;
  q=String(q||'').trim();
  var box=document.getElementById('vdpCliRes'); if(!box) return;
  if(q.length<2){ box.innerHTML=''; return; }
  try{
    var t=encodeURIComponent('*'+q+'*');
    var r=await fetch(SB+'/rest/v1/clientes?select=cardcode,cardname'
      +'&or=(cardname.ilike.'+t+',cardcode.ilike.'+t+')&limit=12',{headers:SBH});
    var l=r.ok?(await r.json()||[]):[];
    box.innerHTML = !l.length
      ? '<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">Ningún cliente con eso</div>'
      : ('<div style="position:absolute;z-index:5;width:100%;border:0.5px solid var(--border);'
        +'border-radius:7px;background:var(--surface-0);box-shadow:0 8px 22px rgba(0,0,0,.18);'
        +'max-height:190px;overflow:auto;margin-top:3px">'
        + l.map(function(x){
            return '<div onclick="_vdpElegirCliente(\''+_esc(x.cardcode)+'\',\''
              +_esc(String(x.cardname||'').replace(/'/g,''))+'\')" '
              +'style="padding:5px 8px;cursor:pointer;font-size:11.5px;'
              +'border-bottom:0.5px solid var(--border)"><b>'+_esc(x.cardcode)+'</b> · '
              +_esc(x.cardname)+'</div>'; }).join('')+'</div>');
  }catch(e){ box.innerHTML=''; }
}

function _vdpElegirCliente(cardcode, cardname){
  var S=window._vdP; if(!S) return;
  S.cliente={cardcode:cardcode, cardname:cardname};
  _vdpPintar();
}

// ── 5. Mandarlo todo a SAP ────────────────────────────────────────────────
/* La barra de estado del pie. Antes los mensajes salían con showT, que dura
   unos segundos y puede quedar DETRÁS de esta ventana: al pulsar «Crear» no
   se veía nada, ni lo que faltaba ni el error. Ahora se queda escrito aquí
   hasta que cambie. tipo: info · error · ok · aviso */
function _vdpEstadoHtml(e){
  if(!e || !e.txt) return '';
  var col={info:['var(--pastel-azul)','var(--t-azul)','ti-loader-2'],
           error:['var(--pastel-error)','var(--t-rojo)','ti-circle-x'],
           aviso:['var(--pastel-aviso)','var(--t-marron)','ti-alert-triangle'],
           ok:['var(--pastel-ok)','var(--t-verde)','ti-circle-check']}[e.tipo]||[];
  return '<div style="background:'+col[0]+';color:'+col[1]+';border-radius:8px;padding:8px 11px;'
    +'margin-bottom:9px;font-size:12px;font-weight:600;white-space:pre-line">'
    +(e.tipo==='info'?'<span class="ai-ring g" style="vertical-align:middle"></span> '
                     :'<i class="ti '+col[2]+'"></i> ')+_esc(e.txt)+'</div>';
}
function _vdpEstado(tipo, txt){
  var S=window._vdP; if(!S) return;
  S.estadoUI = txt ? {tipo:tipo, txt:txt} : null;
  var el=document.getElementById('vdpEstado');
  if(el){ el.innerHTML=_vdpEstadoHtml(S.estadoUI); }
}

async function _vdpCrear(){
  var S=window._vdP; if(!S) return;
  if(S.enviando) return;
  S.enviando=true;
  try{ await _vdpCrearDe(S); }
  finally{
    if(window._vdP===S){ S.enviando=false; _vdpPintar(); }
  }
}

async function _vdpCrearDe(S){
  _vdpEstado('info','Comprobando referencias y proveedores en SAP…');
  await _vdpComprobar();
  var prob=_vdpProblemas();
  if(prob.bloquean.length){
    _vdpEstado('error','Todavía no se puede crear. Falta:\n· '+prob.bloquean.join('\n· '));
    return;
  }
  var num=Number(String(S.numero).trim());

  // Que nadie haya mandado ya una venta directa con ese número
  try{
    var rq=await fetch(SB+'/rest/v1/ventas_directas_queue?select=id,estado,docnum_manual'
      +'&docnum_manual=eq.'+num+'&estado=neq.error',{headers:SBH});
    if(rq.ok){
      var ya=await rq.json()||[];
      if(ya.length){ _vdpEstado('error','Ya hay una venta directa con la orden de venta '+num
        +' (estado: '+ya[0].estado+'). Usa otro número o mírala en la lista.'); return; }
    } else {
      var tq=await rq.text();
      if(tq.indexOf('docnum_manual')>=0){
        _vdpEstado('error','Falta correr vd_proforma.sql en Supabase: la tabla no tiene la '
          +'columna docnum_manual. No se mandó nada.'); return; }
      _vdpEstado('error','No pude consultar la cola de ventas directas ('+rq.status+'): '
        +tq.slice(0,160)); return;
    }
  }catch(e){
    _vdpEstado('error','No hay conexión con Supabase: '+(e.message||e)); return;
  }

  var por=_vdpPorProveedor();
  var tot=Object.keys(por).reduce(function(a,k){
    a.compra+=por[k].compra; a.venta+=por[k].venta; return a; },{compra:0, venta:0});
  var gastos=(S.cargos||[]).reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
  var nuevos=S.lineas.filter(function(l){ return !l.existeVD; }).length;
  if(!confirm('CREAR LA VENTA DIRECTA EN SAP\n\n'
      +'Orden de venta:  '+num+' (número puesto a mano)\n'
      +'Cliente:  '+S.cliente.cardcode+' · '+S.cliente.cardname+'\n'
      +'Líneas:   '+S.lineas.length+' · venta '+_fmtN2(tot.venta)
      +(gastos?(' + '+_fmtN2(gastos)+' de gastos'):'')+'\n'
      +'Artículos /VD nuevos: '+nuevos+' (bodega VD)\n'
      +'Órdenes de compra: '+Object.keys(por).length+' · '+_fmtN2(tot.compra)+'\n'
      +'   '+Object.keys(por).map(function(p){ return p+' ('+por[p].n+')'; }).join(' · ')+'\n'
      +(prob.avisos.length?('\nOJO:\n· '+prob.avisos.join('\n· ')+'\n'):'')
      +'\n¿Sigo?')){ _vdpEstado('aviso','Cancelado: no se mandó nada a SAP.'); return; }
  _vdpEstado('info','Mandando la venta directa a la cola del worker…');

  var vend=(S.vendedores||[]).filter(function(v){
    return String(v.slpcode!=null?v.slpcode:v.codigo)===String(S.vendedor); })[0];
  var fila={
    modo:'proforma',
    docnum_manual:num,
    cliente_cardcode:S.cliente.cardcode, cliente_nombre:S.cliente.cardname,
    vendedor_code:S.vendedor||null, vendedor_nombre:vend?(vend.slpname||null):null,
    numatcard:S.numatcard||null, comentarios:S.comentarios||null,
    fecha:_hoyISO(), almacen:'VD', total:tot.venta+gastos,
    cargos:(S.cargos||[]).filter(function(c){ return Number(c.monto); }),
    lineas:S.lineas.map(function(l){
      var m=l.existeVD?null:_vdpMedFinal(l);
      var emp=_vdpBultoDe(l) || null;
      return {itemcode:l.ref, base:l.base, prefijo:l.prefijo, cantidad:l.piezas,
              precio:l.venta, costo:l.costo, barcode:l.barcode||null,
              cant_compra:l.cantCompra||null,
              unidad:l.unidad||'PZA',
              pzs_bulto_compra:emp?Math.round(Number(emp)*1000)/1000:null,
              // La foto: la referencia SIN el /VD, en .jpg
              foto:String(l.ref).replace(/\/\s*VD$/i,'')+'.jpg',
              itemname:_vdpValor(l,'itemname')||l.baseNombre||'',
              itemname_manual:l.itemnameManual||null, crear:!l.existeVD,
              medidas:m?{piezas_x_bulto:m.piezas_x_bulto, vol_pieza_pie3:m.vol_pieza_pie3,
                         vol_bulto_pie3:m.vol_bulto_pie3, peso_pieza_kg:m.peso_pieza_kg,
                         peso_bulto_kg:m.peso_bulto_kg, medida_carton:m.medida_carton}:null};
    }),
    ocs:Object.keys(por).map(function(p){
      var x=S.proveedores[p]||{};
      return {prefijo:p, cardcode:x.cardcode||p, cardname:x.cardname||'',
              numatcard:x.numatcard||'', lineas:por[p].n,
              total:Math.round(por[p].compra*100)/100};
    }),
    campos_usuario:S.udf||{},
    proforma:{archivo:S.archivo, packings:S.packs.map(function(x){ return x.name; }),
              compra:Math.round(tot.compra*100)/100, venta:Math.round(tot.venta*100)/100},
    estado:'pendiente', creado_por:(CU&&CU.name)||''
  };
  try{
    // Sin _postTolerante a propósito: si falta una columna (el número manual,
    // las órdenes por proveedor…) NO se puede mandar sin ella.
    var r=await fetch(SB+'/rest/v1/ventas_directas_queue',{method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      if(/column|does not exist/i.test(t)) throw new Error('falta correr vd_proforma.sql en Supabase ('
        +t.slice(0,140)+')');
      throw new Error(r.status+' '+t.slice(0,180));
    }
    var reg=((await r.json())||[])[0];
    if(!reg || !reg.id) throw new Error('Supabase no devolvió la fila creada');
    S.enviado=true;
    var m=document.getElementById('modalVDP'); if(m) m.remove();
    window._vdP=null;
    _frwAbrir();
    _vdpPintarEspera({estado:'pendiente', docnum_manual:fila.docnum_manual, ocs:fila.ocs},
                     Date.now());
    _vdpSeguir(reg.id, Date.now());
    try{ _vdCargarLista(); }catch(e){}
  }catch(e){
    _vdpEstado('error','No se pudo enviar, no se creó nada en SAP:\n'+(e.message||e));
  }
}

function _vdpProgresoTxt(q){
  var p=q.progreso||{};
  if(typeof p==='string'){ try{ p=JSON.parse(p); }catch(e){ p={}; } }
  var ocs=p.ocs||{}, nOk=Object.keys(ocs).length, nTot=(q.ocs||[]).length;
  return {p:p, txt:(p.paso||'en cola')
    +(p.items_total?(' · artículos '+(p.items_hechos||0)+'/'+p.items_total):'')
    +(p.pedido&&p.pedido.docnum?(' · orden de venta #'+p.pedido.docnum):'')
    +(nTot?(' · órdenes de compra '+nOk+'/'+nTot):''), nOk:nOk, nTot:nTot, ocs:ocs};
}

// La ventana de espera con todo lo que se sabe: en qué paso va, cuánto
// lleva, qué órdenes ya salieron, y si el worker todavía no la ha tomado.
function _vdpPintarEspera(q, desde){
  var c=document.getElementById('frwCaja'); if(!c) return;
  var pr=_vdpProgresoTxt(q), p=pr.p;
  var seg=Math.round((Date.now()-desde)/1000);
  var lleva=seg<60?(seg+' s'):(Math.floor(seg/60)+' min '+(seg%60)+' s');
  var sinTocar=!p.paso && !(p.items_hechos>0);
  var paso=function(hecho, actual, txt){
    return '<div style="display:flex;gap:8px;align-items:center;padding:3px 0;'
      +(actual?'font-weight:700':'')+';color:'+(hecho?'var(--t-verde)':(actual?'var(--t-azul)':'var(--text-muted)'))+'">'
      +(hecho?'<i class="ti ti-circle-check"></i>':(actual?'<span class="ai-ring g"></span>':'<i class="ti ti-circle"></i>'))
      +' '+txt+'</div>';
  };
  var itemsListos = p.items_total!=null && (p.items_hechos||0)>=(p.items_total||0)
                    && /medidas|pesos|orden|terminada/.test(String(p.paso||''));
  var medListos = !!(p.pedido&&p.pedido.docnum) || /orden|terminada/.test(String(p.paso||''));
  var pedListo = !!(p.pedido&&p.pedido.docnum);
  c.innerHTML='<div style="font-size:15px;font-weight:700;margin-bottom:4px">Creando la venta directa en SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">Orden de venta '
    +_esc(q.docnum_manual||'')+' · lleva '+lleva+'</div>'
    +'<div style="text-align:left;font-size:12.5px">'
    + paso(!sinTocar, sinTocar, sinTocar?'En la cola, esperando al worker':'El worker la tomó')
    + paso(itemsListos, !sinTocar && !itemsListos, 'Artículos /VD'
        +(p.items_total?(' · '+(p.items_hechos||0)+' de '+p.items_total):''))
    + paso(medListos, itemsListos && !medListos, 'Pesos y cubicajes')
    + paso(pedListo, medListos && !pedListo, 'Orden de venta'+(pedListo?(' #'+_esc(p.pedido.docnum)):''))
    + paso(pr.nTot && pr.nOk>=pr.nTot, pedListo && pr.nOk<pr.nTot, 'Órdenes de compra · '
        +pr.nOk+' de '+(pr.nTot||(q.ocs||[]).length)
        +(pr.nOk?(' (#'+Object.keys(pr.ocs).map(function(k){ return _esc(pr.ocs[k].docnum); }).join(', #')+')'):''))
    +'</div>'
    +(sinTocar && seg>90?('<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron);'
      +'margin-top:12px;font-size:11px;text-align:left">Lleva más de un minuto y medio sin que el '
      +'worker la tome. Comprueba en el servidor SAP que el servicio esté corriendo y que sea la '
      +'versión <b>2026-10-14-a</b> o posterior (sale en el log al arrancar). La petición no se '
      +'pierde: se hará en cuanto arranque.</div>'):'')
    +'<button class="btn bg2" style="margin-top:14px;width:100%;padding:9px" onclick="_frwCerrar()">'
    +'Cerrar · sigue en segundo plano (el estado se ve en la lista)</button>';
}

function _vdpSeguir(id, desde){
  clearTimeout(window._vdpT);
  window._vdpT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    try{
      var r=await fetch(SB+'/rest/v1/ventas_directas_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q){
        var pr=_vdpProgresoTxt(q);
        if(q.estado==='creada'){ _vdpPintarOK(q, pr); try{ _vdCargarLista(); }catch(e){} return; }
        if(q.estado==='error'){
          _frwPintarError((q.error_msg||'SAP no dijo el motivo')
            +'\n\nLo hecho hasta ahí queda anotado: '+pr.txt
            +'. Corrige la causa y pulsa «Reintentar» en la venta, en la lista: sigue desde '
            +'ese punto sin repetir nada.');
          try{ _vdCargarLista(); }catch(e){}
          return;
        }
        _vdpPintarEspera(q, desde);
      }
      if(Date.now()-desde > 20*60*1000){
        _frwPintarError('El worker no ha terminado en 20 minutos. La petición sigue en la cola: '
          +'mira el estado en la lista de ventas directas.');
        return;
      }
    }catch(e){}
    _vdpSeguir(id, desde);
  }, 3000);
}

function _vdpPintarOK(q, pr){
  var c=document.getElementById('frwCaja'); if(!c) return;
  var av=q.avisos||[]; if(typeof av==='string'){ try{ av=JSON.parse(av); }catch(e){ av=[av]; } }
  c.innerHTML='<div style="width:70px;height:70px;margin:0 auto 12px;border-radius:50%;'
    +'background:var(--pastel-ok);display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-check" style="font-size:40px;color:var(--t-verde)"></i></div>'
    +'<div style="font-size:16px;font-weight:700;color:var(--t-verde)">Venta directa creada en SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin:8px 0 2px">Orden de venta</div>'
    +'<div style="font-size:40px;font-weight:800">'+_esc(q.docnum_sap||q.docnum_manual||'—')+'</div>'
    +'<div style="font-size:12px;margin-top:8px;text-align:left">'
    + Object.keys(pr.ocs).map(function(k){
        return '<div>Orden de compra <b>#'+_esc(pr.ocs[k].docnum)+'</b> · proveedor '+_esc(k)+'</div>';
      }).join('')+'</div>'
    +(pr.p.items_creados!=null?('<div style="font-size:11px;color:var(--text-muted);margin-top:6px">'
      +pr.p.items_creados+' artículo(s) /VD creados en la bodega VD</div>'):'')
    +(av.length?('<div style="font-size:10.5px;color:var(--t-marron);margin-top:8px;text-align:left;'
      +'max-height:140px;overflow:auto">'+av.slice(0,30).map(_esc).join('<br>')+'</div>'):'')
    +'<button class="btn bp" style="margin-top:14px;width:100%;padding:10px" '
    +'onclick="_frwCerrar()">Cerrar</button>';
}

// En el detalle de una venta directa hecha desde la proforma: en qué paso
// va, qué órdenes de compra salieron y los avisos del worker
function _vdpVerExtraHtml(v){
  var pr=_vdpProgresoTxt(v);
  var av=v.avisos||[]; if(typeof av==='string'){ try{ av=JSON.parse(av); }catch(e){ av=[av]; } }
  return '<div style="flex-basis:100%;font-size:11.5px;border:0.5px solid var(--border);'
    +'border-radius:8px;padding:8px 10px;background:var(--surface-0)">'
    +'<div><b>Orden de venta</b> '+_esc(v.docnum_manual||'—')+' (número manual) · '+_esc(pr.txt)+'</div>'
    + (v.ocs||[]).map(function(o){
        var hecha=pr.ocs[o.prefijo];
        return '<div>'+(hecha?'<span style="color:var(--t-verde)">✓ #'+_esc(hecha.docnum)+'</span>'
                              :'<span style="color:var(--text-muted)">pendiente</span>')
          +' · '+_esc(o.prefijo)+' '+_esc(o.cardname||'')+' · '+o.lineas+' línea(s) · '
          +_fmtN2(o.total)+(o.numatcard?(' · ref. '+_esc(o.numatcard)):'')+'</div>';
      }).join('')
    +(av.length?('<div style="color:var(--t-marron);margin-top:5px;max-height:120px;overflow:auto">'
      +av.slice(0,40).map(_esc).join('<br>')+'</div>'):'')
    +'</div>';
}

/* ═══ CORREGIR EL PRECIO DE LOS /VD YA CREADOS (v723) ═════════════════════
   Hasta el worker 2026-10-14-b el precio de venta de los /VD se ponía en la
   lista 3 (VENTAS) y no en la 4 (VD). Esto junta los /VD que creó el portal
   desde la proforma, con el precio de venta de su proforma, y los manda a la
   cola de precios con la LISTA 4: el worker la busca por su número.
   Se puede repetir sin problema: poner otra vez el mismo precio no cambia nada.
   La lista 3 no se toca. */
var VDP_LISTA_VD=4;

async function _vdpArreglarLista4(){
  var ov=document.getElementById('vdpL4Ov'); if(ov) ov.remove();
  ov=document.createElement('div'); ov.id='vdpL4Ov';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10070;display:flex;align-items:flex-start;'
    +'justify-content:center;padding:22px;overflow:auto';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:760px;width:100%;padding:16px 18px">'
    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px"><i class="ti ti-tag" style="font-size:20px;color:var(--t-marron)"></i>'
    +'<b style="flex:1;font-size:14px">Corregir el precio de venta de los /VD · lista 4 «VD»</b>'
    +'<button class="xb" onclick="document.getElementById(\'vdpL4Ov\').remove()"><i class="ti ti-x"></i></button></div>'
    +'<div id="vdpL4Cuerpo" style="font-size:12px"><span class="ai-ring g"></span> Buscando los /VD creados desde la proforma…</div></div>';
  document.body.appendChild(ov);
  var c=document.getElementById('vdpL4Cuerpo');
  try{
    var r=await fetch(SB+'/rest/v1/ventas_directas_queue?select=id,docnum_manual,docnum_sap,cliente_nombre,lineas,progreso,estado'
      +'&modo=eq.proforma&order=creado_en.desc&limit=200',{headers:SBH});
    if(!r.ok) throw new Error('no pude leer las ventas directas ('+r.status+')');
    var filas=(await r.json())||[], porCod={};
    filas.forEach(function(v){
      var p=v.progreso||{}; if(typeof p==='string'){ try{ p=JSON.parse(p); }catch(e){ p={}; } }
      var creados={}; (p.creados||[]).forEach(function(x){ creados[x]=1; });
      var L=v.lineas||[]; if(typeof L==='string'){ try{ L=JSON.parse(L); }catch(e){ L=[]; } }
      L.forEach(function(l){
        var cod=String(l.itemcode||'').trim();
        if(!cod || !creados[cod] || !(Number(l.precio)>0)) return;
        if(!porCod[cod]) porCod[cod]={itemcode:cod, precio:Number(l.precio), ov:v.docnum_sap||v.docnum_manual||'', cliente:v.cliente_nombre||''};
      });
    });
    var items=Object.keys(porCod).sort().map(function(k){ return porCod[k]; });
    window._vdpL4=items;
    if(!items.length){
      c.innerHTML='<div class="nota">No encontré ningún artículo /VD creado por el portal desde la proforma. '
        +'Si los creaste a mano en SAP, hay que corregirlos allí.</div>';
      return;
    }
    c.innerHTML='<div style="margin-bottom:8px">Encontré <b>'+items.length+'</b> artículo(s) /VD creados por el portal. A cada uno se le pone '
      +'su precio de venta de la proforma en la <b>lista 4 «VD»</b>. La lista 3 no se toca.</div>'
      +'<div class="tbx-box" style="max-height:48vh;overflow:auto"><table class="tbx"><thead><tr>'
      +'<th>Artículo</th><th style="text-align:right">Precio venta → lista 4</th><th>Orden de venta</th><th>Cliente</th></tr></thead><tbody>'
      + items.map(function(x){ return '<tr><td><b>'+_esc(x.itemcode)+'</b></td><td style="text-align:right">'+_fmtN2(x.precio)
          +'</td><td>'+_esc(x.ov)+'</td><td style="font-size:11px">'+_esc(x.cliente)+'</td></tr>'; }).join('')
      +'</tbody></table></div>'
      +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">'
      +'<button class="btn bg2" onclick="document.getElementById(\'vdpL4Ov\').remove()">Cancelar</button>'
      +'<button class="btn bp" onclick="_vdpArreglarLista4Enviar()"><i class="ti ti-send"></i> Poner los '+items.length
      +' precios en la lista 4</button></div>';
  }catch(e){
    c.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'+_esc(e.message||String(e))+'</div>';
  }
}

async function _vdpArreglarLista4Enviar(){
  var items=window._vdpL4||[], c=document.getElementById('vdpL4Cuerpo');
  if(!items.length || !c) return;
  c.innerHTML='<span class="ai-ring g"></span> Mandando '+items.length+' precio(s) a la cola…';
  try{
    // Sin _postTolerante: si la tabla no tuviera la columna «lista», se iría
    // a la lista que el worker deduzca, y eso es justo lo que no queremos.
    var fila={items:items.map(function(x){ return {itemcode:x.itemcode, precio:x.precio}; }),
      lista:VDP_LISTA_VD, origen:'venta directa: precio a la lista 4 VD', estado:'pendiente',
      creado_por:(CU&&CU.name)||''};
    var r, t='';
    for(var intento=0; intento<4; intento++){
      r=await fetch(SB+'/rest/v1/precios_venta_queue',{method:'POST',
        headers:Object.assign({},SBH,{'Prefer':'return=representation'}), body:JSON.stringify(fila)});
      if(r.ok) break;
      t=await r.text();
      var m=t.match(/Could not find the '([^']+)' column/);
      // Las columnas de adorno se pueden quitar; «lista» e «items» no
      if(m && m[1]!=='lista' && m[1]!=='items' && fila[m[1]]!==undefined){ delete fila[m[1]]; continue; }
      if(m && m[1]==='lista') throw new Error('la tabla precios_venta_queue no tiene la columna «lista»: '
        +'el worker pondría el precio en otra lista. Hay que añadirla en Supabase.');
      break;
    }
    if(!r.ok) throw new Error(r.status+' '+t.slice(0,160));
    var reg=((await r.json())||[])[0];
    _vdpArreglarLista4Seguir(reg.id, Date.now());
  }catch(e){
    c.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">No se pudo mandar: '+_esc(e.message||String(e))+'</div>';
  }
}

function _vdpArreglarLista4Seguir(id, desde){
  setTimeout(async function(){
    var c=document.getElementById('vdpL4Cuerpo'); if(!c) return;
    try{
      var r=await fetch(SB+'/rest/v1/precios_venta_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok?(((await r.json())||[])[0]):null;
      if(q && (q.estado==='hecha' || q.estado==='error')){
        var av=q.avisos||[]; if(typeof av==='string'){ try{ av=JSON.parse(av); }catch(e){ av=[av]; } }
        c.innerHTML=(q.estado==='hecha'
          ? ('<div class="nota" style="background:var(--pastel-ok);color:var(--t-verde);font-weight:600"><i class="ti ti-circle-check"></i> '
             +(q.actualizados||0)+' de '+(window._vdpL4||[]).length+' precio(s) puestos en la lista '+_esc(q.lista||VDP_LISTA_VD)+' «VD».</div>')
          : ('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">Error: '+_esc(q.error_msg||'')+'</div>'))
          +(av.length?('<div style="font-size:11px;color:var(--t-marron);margin-top:6px">'+av.map(_esc).join('<br>')+'</div>'):'')
          +'<div style="text-align:right;margin-top:10px"><button class="btn bp" onclick="document.getElementById(\'vdpL4Ov\').remove()">Cerrar</button></div>';
        return;
      }
      var seg=Math.round((Date.now()-desde)/1000);
      c.innerHTML='<span class="ai-ring g"></span> El worker está poniendo los precios en SAP… ('+seg+' s)'
        +(seg>90?'<div style="font-size:11px;color:var(--t-marron);margin-top:6px">Tarda más de lo normal: '
          +'comprueba que el worker esté corriendo. La petición no se pierde.</div>':'');
    }catch(e){}
    _vdpArreglarLista4Seguir(id, desde);
  }, 3000);
}

// Desde la lista: volver a intentar una que se quedó en error. Es seguro: el
// worker sigue desde el último paso anotado y busca en SAP lo que ya hizo.
async function _vdpReintentar(id){
  if(!confirm('Vuelvo a mandar esta venta directa al worker. Sigue desde donde se quedó y '
    +'no repite lo que ya está en SAP. ¿Sigo?')) return;
  try{
    var r=await fetch(SB+'/rest/v1/ventas_directas_queue?id=eq.'+id+'&estado=eq.error',
      {method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
       body:JSON.stringify({estado:'pendiente', error_msg:null})});
    if(!r.ok || !((await r.json())||[]).length) throw new Error('no estaba en error');
    _vdVerCerrar();
    _frwAbrir();
    _frwPintarEspera('Reintentando la venta directa…','En la cola del worker.');
    _vdpSeguir(id, Date.now());
  }catch(e){ showT('No se pudo reintentar: '+(e.message||e)); }
}


/* ── Lector del Excel de la factura, tal como lo manda el proveedor ───────
   El Excel viene por grupos: una cabecera «AS PER S/C NO. 20293621/ PI:
   HIKC-26039» y debajo sus artículos. Ese PI es el DKC de la orden de
   compra, así que cada artículo se sabe de qué orden viene sin adivinar.
   Al final trae TOTAL FOB, el flete, el DTHC y el TOTAL CIF.
   Si el archivo no tiene esa forma (o es PDF), se lee con la IA como antes. */

function _fipNum(v){
  if(v==null || v==='') return null;
  if(typeof v==='number') return v;
  var t=String(v).replace(/[^0-9.,-]/g,'').replace(/,/g,'');
  if(!t || t==='-' || t==='.') return null;
  var n=parseFloat(t);
  return isNaN(n)?null:n;
}

// El valor que va justo detrás de una etiqueta en la misma fila, saltándose
// las columnas de la derecha (los números de pedido del proveedor).
function _fipTrasEtiqueta(textos, re){
  for(var i=0;i<textos.length;i++){
    if(!re.test(String(textos[i]||'').trim())) continue;
    for(var j=i+1;j<textos.length;j++){
      var t=String(textos[j]||'').trim();
      if(!t) continue;
      if(/^\d{4}\s*\d{4}$/.test(t)) return '';     // la columna de ORDER NO
      return t;
    }
  }
  return '';
}

async function _fipLeerExcelFactura(file){
  if(typeof XLSX==='undefined') return null;
  var buf=await file.arrayBuffer();
  var wb=XLSX.read(new Uint8Array(buf),{type:'array', cellDates:true});
  var items={}, cargos=[], tot={}, emb={};
  var grupo=null, nItems=0;

  var pack={}, etas={};
  wb.SheetNames.forEach(function(nombre){
    var filas=XLSX.utils.sheet_to_json(wb.Sheets[nombre],{header:1, raw:true, defval:''});
    var cm=null;           // columnas por título (v755), si la hoja es una tabla
    filas.forEach(function(f){
      var textos=f.map(function(c){ return String(c==null?'':c).trim(); });
      var linea=textos.join(' ').replace(/\s+/g,' ').trim();
      if(!linea) return;
      var may=linea.toUpperCase();

      /* v755: facturas en TABLA, con títulos (Hebei Popna: «Bulto por Unidad
         L | UoM Name | SKU | Item Description | Quantity | Unit Price | Total
         (LC) | No. of Packages | … | Documento de Compra | Total Weight KG |
         Total Volume Cubic Feet»). Se leen por el título de cada columna:
         antes se buscaban «código al principio y cantidad, precio e importe
         al final», y aquí la primera columna es el bulto y al final van peso
         y cubicaje: no salía ninguna línea. */
      if(!cm){
        var tcm=_fipColumnasFactura(textos);
        if(tcm){ cm=tcm; return; }
      } else {
        // v770: el código tal cual, en MAYÚSCULAS (en SAP mayúsculas y
        // minúsculas son lo mismo y se guardan en mayúsculas)
        var cod=String(textos[cm.code]||'').trim().toUpperCase();
        if(cm.qty==='auto'){
          var _pr=_fipNum(textos[cm.price]), _tt=_fipNum(textos[cm.total]);
          if(cod && _pr>0 && _tt>0){
            for(var _j=0;_j<textos.length;_j++){
              if(_j===cm.code||_j===cm.price||_j===cm.total||_j===cm.pxb||_j===cm.pkgs) continue;
              var _v=_fipNum(textos[_j]);
              if(_v>0 && Math.abs(_v*_pr-_tt) <= Math.max(0.05, _tt*0.01)){ cm.qty=_j; break; }
            }
          }
          if(cm.qty==='auto') return;          // aún no: se espera a una fila que lo diga
        }
        var can=_fipNum(textos[cm.qty]), pre=_fipNum(textos[cm.price]);
        var imp=cm.total!=null?_fipNum(textos[cm.total]):null;
        if(cod && can>0 && pre>0){
          if(!(imp>0)) imp=Math.round(can*pre*100)/100;
          var cl=_ocNormSku(cod);
          var ocTxt=cm.oc!=null?String(textos[cm.oc]||''):'';
          var mo=ocTxt.match(/(?:OC|PO|ORDEN)?[\s\-#:]*(\d{4,})/i);
          var me=ocTxt.match(/ETA\.?\s*:?\s*([A-Za-z]{3,9})\.?\s+(\d{1,2}),?\s+(\d{4})/i);
          var _bc=cm.barcode!=null?String(textos[cm.barcode]||'').replace(/\.0+$/,'').replace(/^'/,'').trim():'';
          var it=items[cl]||(items[cl]={itemcode:cod, nombre:cm.desc!=null?String(textos[cm.desc]||'').trim():'',
            barcode:/^\d{8,14}$/.test(_bc)?_bc:'', cantidad:0, importe:0, precio:0, bultos:0, kilos:0, pi:'', sc:'', oc:''});
          it.cantidad+=can; it.importe+=imp; it.precio=it.cantidad?it.importe/it.cantidad:pre;
          if(mo && !it.oc) it.oc=mo[1];
          if(me){ var fe=_fipFechaEta(me[1],me[2],me[3]); if(fe) etas[fe]=1; }
          // Lo que trae la factura de empaque: sirve de packing si no hay otro
          var bul=cm.pkgs!=null?_fipNum(textos[cm.pkgs]):null;
          var kg=cm.peso!=null?_fipNum(textos[cm.peso]):null;
          var p3=cm.vol!=null?_fipNum(textos[cm.vol]):null;
          if(bul||kg||p3){
            var pk=pack[cl]||(pack[cl]={itemcode:cod, cantidad:0, bultos:0, kilos:0, pie3:0});
            pk.cantidad+=can; pk.bultos+=bul||0; pk.kilos+=kg||0;
            pk.pie3+=(cm.volEsM3?(p3||0)*FIP_M3_A_PIE3:(p3||0));
            if(cm.pxb!=null && _fipNum(textos[cm.pxb])) pk.piezas_x_bulto=_fipNum(textos[cm.pxb]);
          }
          nItems++;
          return;
        }
        // Las filas sin artículo (Subtotal, Freight, total) siguen abajo
      }

      // Cabecera de grupo: S/C y PI (el DKC de la orden)
      var m=may.match(/S\/C\s*NO\.?\s*([0-9 ]+)[^A-Z0-9]*(?:PI\s*:?\s*)([A-Z0-9\-\/]+)/);
      if(m){
        grupo={sc:m[1].replace(/\s+/g,''), pi:m[2].trim()};
        return;
      }
      // Los datos generales del embarque, que van a los campos de la
      // factura en SAP: barco, BL, marcas, contenedor, n.º y fecha de factura
      if(!emb.numero){
        // Cada proveedor lo escribe distinto: «INVOICE NO.: VI-1104»,
        // «INV. VI-1104», «INV NO VI-1104», «FACTURA N.º …». Se queda solo
        // el número: el «INV» sobra en el Vendor Ref. No. de SAP.
        var mn=linea.match(/(?:INVOICE|INV|FACTURA)[\s.]*(?:NO|N[º°]|NUM(?:BER)?)?[\s.:]*([A-Z]{1,4}[-\/]?\d[A-Z0-9\-\/]*)/i);
        if(mn){
          var num=String(mn[1]).trim()
            .replace(/^(?:INV(?:OICE)?|FACTURA)[\s.\-:]*/i,'')   // por si se coló
            .replace(/[.,;]+$/,'');
          if(num && num.toUpperCase()!=='NO' && /\d/.test(num)) emb.numero=num;
        }
      }
      if(!emb.fecha){
        for(var q=0;q<f.length;q++){
          if(/DATE/i.test(textos[q]||'')){
            for(var w=q+1;w<f.length;w++){
              if(f[w] instanceof Date){ emb.fecha=f[w].toISOString().slice(0,10); break; }
              var pf=String(f[w]||'').match(/(\d{4})-(\d{2})-(\d{2})/);
              if(pf){ emb.fecha=pf[0]; break; }
            }
          }
        }
      }
      if(!emb.barco){
        var iv=_fipTrasEtiqueta(textos, /^VESSEL/i);
        if(iv) emb.barco=iv.slice(0,60);
      }
      if(!emb.bl){
        var ib=_fipTrasEtiqueta(textos, /^B\/L\s*NO/i);
        if(ib) emb.bl=ib.slice(0,40);
      }
      if(!emb.contenedor){
        var mc=may.match(/(\d+\s*X\s*\d{2}\s*'?\s*(?:HQ|GP|RF|OT)\b)/);
        if(mc) emb.contenedor=mc[1].replace(/\s+/g,'').replace("'","");
      }
      if(!emb.bultos){
        var mt=linea.match(/TOTAL\s*:?\s*([\d,]+)\s*CTNS/i);
        if(mt) emb.bultos=_fipNum(mt[1]);
      }
      // Las marcas van en la primera columna, debajo de la palabra MARKS
      if(/^MARKS$/i.test(textos[0]||'')){ emb._marcas=[]; return; }
      if(emb._marcas && !emb.marca){
        var t0=(textos[0]||'').trim();
        if(!t0 || /^C\/NO/i.test(t0) || /STYLE\s*NO/i.test(t0)){
          emb.marca=emb._marcas.join(' · ').slice(0,60);
          delete emb._marcas;
        } else {
          emb._marcas.push(t0);
        }
      }

      // Cargos y totales del final
      var n=null;
      for(var i=textos.length-1;i>=0;i--){ n=_fipNum(textos[i]); if(n!=null) break; }
      /* Un gasto de verdad es una LÍNEA DE GASTO: poco texto, un solo
         importe y nada que se parezca a un artículo. Ayer abrí demasiado
         estos patrones y cualquier fila que mencionara «insurance» o
         «document» se colaba como gasto con el último número de la fila;
         de ahí salieron un seguro de 548 y una documentación de 7 que no
         existen en la factura. */
      var celdasConTexto=textos.filter(function(t){
        return t && isNaN(Number(String(t).replace(/[,$\s]/g,''))); });
      var celdasConNumero=textos.filter(function(t){
        var v=_fipNum(t); return v!=null && v!==0; });
      var etiqueta=(celdasConTexto[0]||'').toUpperCase();
      var pareceGasto = n!=null
        && celdasConTexto.length<=2            // una etiqueta, no una descripción
        && celdasConNumero.length<=2           // un importe, no cantidad+precio+total
        && etiqueta.length<=34;

      // «Frieght», «Freigth», «Frght»… viene mal escrito en media Asia, así
      // que se acepta cualquier orden de esas vocales. Por eso se perdió un
      // flete de 9.880 de la factura VI-1104.
      if(n!=null && pareceGasto
         && /(^|\W)(FR[IE]*GH?T|FREIGHT|FLETE|OCEAN\s*FRT|SEA\s*FRT)(\W|$|\s*COST)/.test(may)
         && !/TOTAL\s*(FOB|CIF)|^TOTAL\b/.test(etiqueta)){
        cargos.push({concepto:'Flete', monto:n}); return;
      }
      if(pareceGasto && /(^|\W)D?THC(\W|$)|TERMINAL HANDLING/.test(may)){
        cargos.push({concepto:'GASTOS THC', monto:n}); return;
      }
      if(pareceGasto && /(^|\W)(INSURANCE|SEGURO)S?(\W|$)/.test(etiqueta)){
        cargos.push({concepto:'SEGUROS', monto:n}); return;
      }
      if(pareceGasto && /(^|\W)INSPECC?ION(\W|$)/.test(etiqueta)){
        cargos.push({concepto:'INSPECCION', monto:n}); return;
      }
      if(pareceGasto && /(^|\W)(ETIQUETADO|LABELLING|LABELING)(\W|$)/.test(etiqueta)){
        cargos.push({concepto:'GASTO DE ETIQUETADO', monto:n}); return;
      }
      if(pareceGasto && /(^|\W)(DOCUMENTATION|DOCUMENTACION|DOC\.?\s*FEE)(\W|$)/.test(etiqueta)){
        cargos.push({concepto:'DOCUMENTACION.', monto:n}); return;
      }
      if(/TOTAL\s*QTY/.test(may)){
        var mq=may.match(/TOTAL\s*QTY\D*([\d,]+)/);
        if(mq) tot.qty=_fipNum(mq[1]);
      }
      if(/TOTAL\s*FOB/.test(may) && n!=null){ tot.fob=n; return; }
      if(/TOTAL\s*CIF/.test(may) && n!=null){ tot.cif=n; return; }
      if(/^B\/D|^C\/D/.test(may)) return;          // los arrastres de página

      // Línea de artículo: cantidad, precio e importe, y que el importe
      // cuadre con cantidad x precio. Así no se cuela ninguna otra fila.
      var nums=[], idx=[];
      textos.forEach(function(t,i){
        var v=_fipNum(t);
        if(v!=null && t!==''){ nums.push(v); idx.push(i); }
      });
      if(nums.length<3) return;
      var imp=nums[nums.length-1], pre=nums[nums.length-2], can=nums[nums.length-3];
      if(!(can>0 && pre>0 && imp>0)) return;
      if(Math.abs(can*pre-imp) > Math.max(0.05, imp*0.01)) return;

      var code=textos[0];
      if(!code){ for(var j=0;j<textos.length;j++){ if(textos[j]){ code=textos[j]; break; } } }
      // Un código puede llevar letras y guiones (415-L26-2556). Lo único que
      // se descarta es que sea un número largo, que sería un código de barras.
      if(!code || /^'?\d{10,}$/.test(code)) return;
      // Lo que va entre el código y los números: talla, color y el barcode
      var desc=[], barcode='';
      for(var k=1;k<idx[idx.length-3];k++){
        var t=textos[k]; if(!t) continue;
        if(/^'?\d{12,14}$/.test(t)) { barcode=t.replace(/'/g,''); continue; }
        desc.push(t);
      }
      var clave=_ocNormSku(code);
      var a=items[clave]||(items[clave]={itemcode:code, nombre:desc.join(' · '),
        barcode:barcode, cantidad:0, importe:0, precio:0, bultos:0, kilos:0,
        pi:(grupo&&grupo.pi)||'', sc:(grupo&&grupo.sc)||''});
      a.cantidad+=can; a.importe+=imp;
      a.precio=a.cantidad?a.importe/a.cantidad:pre;
      if(!a.barcode) a.barcode=barcode;
      if(!a.pi && grupo) { a.pi=grupo.pi; a.sc=grupo.sc; }
      nItems++;
    });
  });
  if(!nItems) return null;
  var suma=Object.keys(items).reduce(function(x,k){ return x+items[k].importe; },0);
  _dbg('[FIP] Excel del proveedor: '+nItems+' línea(s), '+Object.keys(items).length
       +' referencia(s), FOB '+(tot.fob||suma));
  // La ETA: lo que diga el BL y, si no dice nada, 40 días después de la
  // fecha de la factura, que es el promedio que maneja Kennedy.
  if(!emb.eta && emb.fecha){
    var fx=new Date(emb.fecha+'T00:00:00');
    if(!isNaN(fx)){
      fx.setDate(fx.getDate()+40);
      emb.eta=fx.toISOString().slice(0,10);
      emb.eta_estimada=true;
    }
  }
  var le=Object.keys(etas).sort();
  if(le.length && !emb.eta){ emb.eta=le[0]; }          // la primera, si hay varias órdenes
  return {items:items, cargos:cargos, total:(tot.cif||tot.fob||suma), suma:suma,
          fob:tot.fob||suma, cif:tot.cif||null, qty:tot.qty||null,
          numero:emb.numero||'', moneda:'', embarque:emb,
          packing:Object.keys(pack).length?pack:null};
}

// ¿Es una fila de títulos de una factura en tabla? Devuelve las columnas
function _fipColumnasFactura(textos){
  var t=textos.map(function(x){ return String(x||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/\s+/g,' ').trim(); });
  var busca=function(re, no){ for(var i=0;i<t.length;i++){ if(t[i] && re.test(t[i]) && !(no && no.test(t[i]))) return i; } return null; };
  var c={
    code: busca(/^(sku|item no\.?|item code|kcc( item)?( no\.?)?|codigo|cod\.? kcc|style( no\.?)?|referencia)$/),
    desc: busca(/description|descripcion/),
    qty:  busca(/^(quantity|qty|cantidad|pcs|piezas)\b/, /package|ctn|carton|bulto|per/),
    price:busca(/unit price|^price|precio/),
    total:busca(/^total( \(lc\)| usd| amount)?$|^amount|importe/),
    pkgs: busca(/no\.? of packages|^packages|^ctns?$|cartons|bultos$/),
    pxb:  busca(/bulto por unidad|pcs\/ctn|pcs per|qty\/ctn|pi[a-z]*s per (carton|ctn|box)|per carton|per ctn/),
    barcode: busca(/barco|bar code|codigo de barra|ean/),
    peso: busca(/total weight|gross weight|^g\.?w|peso total/),
    // El volumen TOTAL de la línea; no el «por pieza» (Cubic Feet. Pc)
    vol:  (function(){ var v=busca(/total volume|total cbm|total cubic/);
            if(v==null) v=busca(/^cbm|^volume|^m3/, /pc|per|unit/);
            if(v==null) v=busca(/cubic/, /pc|per|unit/);
            return v; })(),
    oc:   busca(/documento de compra|^po\b|purchase order|orden de compra|^oc\b/)
  };
  /* v770: la cantidad con un título raro. Hebei Popna titula «COSTO» la
     columna de las piezas («(pcs)/prs» va en la fila de abajo). Si hay
     código, precio e importe pero ninguna columna se llama cantidad, se
     decide con la primera línea de datos: la columna cuyo valor × precio da
     el importe. Antes la factura no se leía y la leía la IA, que cortaba las
     referencias en la barra (26221681005/NAVY → 26221681005) y juntaba
     colores distintos en una sola. */
  if(c.qty==null && c.code!=null && c.price!=null && c.total!=null) c.qty='auto';
  if(c.code==null || c.qty==null || c.price==null) return null;
  c.volEsM3 = c.vol!=null && /cbm|m3/.test(t[c.vol]) && !/cubic f/.test(t[c.vol]);
  return c;
}
function _fipFechaEta(mes, dia, anio){
  var m={jan:1,feb:2,mar:3,apr:4,may:5,jun:6,jul:7,aug:8,sep:9,oct:10,nov:11,dec:12,
         ene:1,abr:4,ago:8,dic:12}[String(mes).slice(0,3).toLowerCase()];
  if(!m) return null;
  return anio+'-'+String(m).padStart(2,'0')+'-'+String(dia).padStart(2,'0');
}


/* ── El packing list: medidas por pieza y por bulto ───────────────────────
   Kennedy maneja el cubicaje en PIES CÚBICOS y el peso en KG, pero los
   packing list vienen casi siempre en CBM (m³) y a veces en libras. Aquí se
   lee lo que declare el documento y se convierte:

     m³ -> pies³ (x 35,3147)     ·     libras -> kg (x 0,45359)

   De cada artículo salen: cubicaje por pieza y por bulto, peso por pieza y
   por bulto, y la medida del cartón. Eso es lo que después se manda a la
   ficha del artículo en SAP (BVolume y SVolume, peso de compra y de venta,
   y los campos de usuario U_CxBlt, U_PxBlt y la medida del cartón). */

var FIP_M3_A_PIE3 = 35.3146667;
var FIP_LB_A_KG   = 0.45359237;

function _fipUnidadVol(txt){
  var t=String(txt||'').toUpperCase();
  // «Cubic Feet», «Cubic Ft», «C.F.T.»: pies³. Antes «Cubic Feet» no se
  // reconocía, se tomaba como m³ y el cubicaje salía 35 veces más grande.
  if(/CFT|CU\.?\s*FT|PIE|FT3|FT³|CUBIC\s*F(?:EE|OO)?T|C\.\s*F\.\s*T|\bFEET\b/.test(t)) return 'pie3';
  return 'm3';                       // CBM, M3, M³ o sin decir nada
}
function _fipUnidadPeso(txt){
  var t=String(txt||'').toUpperCase();
  if(/\bLBS?\b|POUND|LIBRA/.test(t)) return 'lb';
  return 'kg';
}

// Cuántas cajas hay en la fila. Si no viene el número, se saca del rango de
// cartones: «1-14» son catorce cajas.
function _fipCajas(valorCtns, rango, hasta){
  var n=_fipNum(valorCtns);
  if(n>0 && String(valorCtns||'').indexOf('-')<0) return n;
  var t=String(rango||valorCtns||'').replace(/\s/g,'');
  var m=t.match(/^(\d+)[-–](\d+)$/);
  if(m) return Math.abs(parseInt(m[2],10)-parseInt(m[1],10))+1;
  // Y cuando el rango viene en DOS columnas, «fm» y «to»
  var d=String(hasta||'').replace(/[^0-9]/g,'');
  var i0=String(rango||'').replace(/[^0-9]/g,'');
  if(i0 && d) return Math.abs(parseInt(d,10)-parseInt(i0,10))+1;
  return n>0?n:0;
}

// Medidas del cartón: 60X40X50, «60 x 40 x 50 cms», o tres columnas de
// largo, ancho y alto. Salga como salga, termina en «60x40x50 cm».
function _fipMedida(txt, unidad){
  var t=String(txt||'').trim();
  if(!t) return '';
  var u=String(unidad||t).toUpperCase();
  var f = /INCH|INCHES|"|\bIN\b|PULG/.test(u) ? 2.54
        : (/\bM\b|METRO|MTS/.test(u) && !/CM|MM/.test(u)) ? 100
        : /\bMM\b/.test(u) ? 0.1 : 1;
  var nums=(t.match(/\d+(?:[.,]\d+)?/g)||[]).map(function(x){
    return Math.round(parseFloat(x.replace(',','.'))*f*10)/10; });
  if(nums.length<3) return '';
  return nums.slice(0,3).join('x')+' cm';
}

/* Lee el Excel del packing list.

   Dos cosas que traen todos los packing list y hay que entender:

   · Cada referencia suele venir en DOS filas: la de los bultos COMPLETOS y
     la de los bultos parciales o mezclados. Lo que se aprende para la ficha
     de SAP sale de los bultos completos, que son los que dicen de verdad
     cuántas piezas, cuánto pesa y cuánto cubica una caja.

   · El peso y el CBM tanto pueden venir por CAJA como en TOTAL de esas
     cajas. Se averigua mirando las filas del mismo artículo: si el valor
     crece con el número de cajas es total; si se repite igual con distinto
     número de cajas, es por caja. Con eso se llega siempre al valor por
     caja, y de ahí al valor por pieza.

   Unidades: el peso, en kg (si dice libras, se convierte); el cubicaje, en
   pies cúbicos (los CBM se multiplican por 35,3147). */
// ¿La fila trae datos de un artículo? Un código de barras, una referencia
// tipo «415-L26-2546» o un rango de cartones «1-3». Una fila así nunca es
// cabecera, aunque diga «STYLE NO.» y «PCS» (Lonwa pone las dos cosas en la
// misma fila del resumen de arriba).
function _fipFilaDeDatos(textos){
  return (textos||[]).some(function(t){
    t=String(t==null?'':t).trim();
    return /^'?\d{12,14}(\.0+)?$/.test(t)
        || /^[A-Z0-9]{2,6}-[A-Z]{0,3}\d{2,4}-\d{1,6}/i.test(t)
        || /^\d{1,4}\s*[-–]\s*\d{1,4}$/.test(t);
  });
}
// ¿Es una fila de títulos o de unidades? Tres celdas o más, ninguna con un
// número ni con datos de artículo: «(PCS) (KGS) (CM)» o la cabecera en chino.
function _fipFilaDeTitulos(fila){
  var t=(fila||[]).map(function(c){ return String(c==null?'':c).trim(); })
                  .filter(function(x){ return x; });
  if(t.length<3 || _fipFilaDeDatos(t)) return false;
  return !t.some(function(x){ return /^-?\d+([.,]\d+)?$/.test(x); });
}

async function _fipLeerExcelPacking(file){
  if(typeof XLSX==='undefined') return null;
  var buf=await file.arrayBuffer();
  var wb=XLSX.read(new Uint8Array(buf),{type:'array', cellDates:true});
  var filasItem=[], n=0, vistas={}, barcodeDe={};

  wb.SheetNames.forEach(function(nombre){
    var filas=XLSX.utils.sheet_to_json(wb.Sheets[nombre],{header:1, raw:true, defval:''});
    var col=null, uPeso='kg', uVol='m3', ultimo='';

    for(var fi=0; fi<filas.length; fi++){
      var f=filas[fi];
      var textos=f.map(function(c){ return String(c==null?'':c).trim(); });
      var may=textos.map(function(t){ return t.toUpperCase().replace(/\s+/g,' '); });
      var linea=may.join(' ');

      // Una fila con UNA referencia y UN código de barras, esté donde esté:
      // Lonwa los pone en un resumen encima de cada bloque («STYLE NO. :
      // 022-L25-1251 · 72 PCS · BARCODE 7450…»), fuera de la tabla (v715).
      var refsF=textos.filter(function(t){ return /^[A-Z0-9]{2,6}-[A-Z]{0,3}\d{2,4}-\d{1,6}/i.test(t); });
      var bcsF=textos.map(function(t){ return t.replace(/\.0+$/,'').replace(/^'/,''); })
                     .filter(function(t){ return /^\d{12,14}$/.test(t); });
      if(refsF.length===1 && bcsF.length===1){
        var kb=_ocNormSku(refsF[0]);
        if(!barcodeDe[kb]) barcodeDe[kb]=bcsF[0];
      }

      // ── La fila de títulos ────────────────────────────────────────────
      // Muchos packing list parten la cabecera en dos o tres filas: arriba
      // «Carton Meas. (cms)» y debajo «L  W  H», o «pcs/ctn» arriba y
      // «(PCS)» abajo. Se juntan hasta tres filas para clasificar cada
      // columna, que es lo que antes hacía que solo se leyera la referencia.
      if(!col && /REFERENC|STYLE|ITEM|MODEL|SKU/.test(linea)
              && /(QTY|PCS|CTN|CARTON|CANT)/.test(linea)
              && !_fipFilaDeDatos(textos)){
        /* Qué filas forman la cabecera (v713). Antes se juntaban SIEMPRE la
           fila de títulos y las dos siguientes, y se saltaba la siguiente:
           · en Lonwa la fila siguiente ya es un artículo, y se perdía;
           · en Lonwa las unidades «(PCS) (KGS) (CM)» van ENCIMA de los títulos;
           · en Wenzhou Hongshen la fila de encima es la cabecera en chino,
             y es la única que dice que el peso es TOTAL («总毛重»).
           Ahora se añade la fila de encima si es de títulos o de unidades, y
           de las de debajo solo las que no traen datos de un artículo. */
        var filasCab=[fi];
        var previa=fi>0?(filas[fi-1]||[]):[];
        if(_fipFilaDeTitulos(previa)) filasCab.unshift(fi-1);
        var nSig=0;
        for(var k=1;k<=2 && fi+k<filas.length;k++){
          var sig=(filas[fi+k]||[]).map(function(c){ return String(c==null?'':c).trim(); });
          if(_fipFilaDeDatos(sig)) break;
          filasCab.push(fi+k); nSig=k;
        }
        var junta=[];
        filasCab.forEach(function(nf){
          (filas[nf]||[]).forEach(function(c, idx){
            var t=String(c==null?'':c).trim().toUpperCase().replace(/\s+/g,' ');
            if(!t) return;
            junta[idx]=(junta[idx]?junta[idx]+' ':'')+t;
          });
        });
        col={};
        // La columna del código: primero la que diga STYLE/REFERENCIA/SKU;
        // «Item No.» solo si no hay otra, porque en Marco es el número de fila.
        junta.forEach(function(t, idx){
          if(col.code==null && t && /REFERENC|STYLE|SKU|MODEL/.test(t)) col.code=idx; });
        junta.forEach(function(t, idx){
          if(!t) return;
          var porCtn=/(PER|POR|\/|X)\s*(CTN|CARTON|CAJA|BOX)|\b(CTN|BOX)\b\s*$/.test(t);
          var total=/\bTOTAL|\bTT\b|\bTTL\b|总/.test(t);

          if(idx===col.code) return;
          /* v770: packing con «BOX» en vez de CTN/CARTON (Hebei Popna):
             BOX NO. · BOX QTY · SIZE · PCS/BOX · QTY IN BOX · TOTAL ·
             NET/GROSS WEIGHT BOX · TOTAL … · CBM BOX · TOTAL CBM.
             «BOX QTY» son los CARTONES; «QTY IN BOX» las piezas de un cartón;
             «PCS/BOX» es el reparto por TALLA dentro del cartón (8 S, 16 M…)
             y NO las piezas del cartón; «TOTAL» son las piezas de la fila.
             Antes «QTY IN BOX» se tomaba como piezas totales, «CBM BOX» como
             volumen total y las piezas por cartón salían de las tallas. */
          if(col.ctnno==null && /^(BOX|CTN|CARTON)E?S?\s*(NO\.?|N[º°O]\.?|NUMBER|#)$/.test(t)){ col.ctnno=idx; return; }
          if(col.ctns==null && /^(BOX|CTN|CARTON)E?S?\s*(QTY|QUANTITY)$|^(NO\.?|QTY) OF (BOX|CTN|CARTON)/.test(t)){ col.ctns=idx; return; }
          if(/(QTY|PCS|PIECES?)\s+(IN|PER)\s+(THE\s+)?(BOX|CTN|CARTON)/.test(t) && !total){ col.pxcIn=idx; return; }
          if(col.qty==null && /^TOTAL$|^TOTAL\s*(QTY|PCS|PIECES)$/.test(t)){ col.qty=idx; return; }
          if(col.code==null && /REFERENC|STYLE|ITEM|MODEL|SKU|ART/.test(t)) col.code=idx;
          else if(col.barcode==null && /BARCODE|BAR CODE|CODIGO DE BARRA/.test(t)) col.barcode=idx;
          else if(col.ctnno==null && /CTNS?\s*\/?\s*N|CARTONS? N|C\/NO|\bFM\b|\bFROM\b/.test(t)) col.ctnno=idx;
          else if(col.ctnto==null && /^TO$|\bTO\b/.test(t) && col.ctnno!=null) col.ctnto=idx;
          else if(col.color==null && /COLOR|COLOUR/.test(t)) col.color=idx;
          // piezas por cartón: «pcs/ctn», «qty per ctn», «CTN QTY PCS»
          else if(col.pxc==null && /(PCS|QTY|UNIT).{0,8}(CTN|CARTON)|(CTN|CARTON).{0,8}(QTY|PCS)/.test(t)
                   && !total) col.pxc=idx;
          // cuántos cartones: «carton quantity», «CTNS», «bultos»
          else if(col.ctns==null && /CARTON QUANT|CTNS?\b|BULTOS?|CAJAS?|\bBOXES\b/.test(t)
                   && !/N[ºO°]|NUMBER|MEAS|SIZE/.test(t)) col.ctns=idx;
          // piezas totales de la fila: «ttl qty», «QTY PCS», «total qty»
          else if(col.qty==null && /(TTL|TOTAL).{0,6}(QTY|PCS)|^QTY|\(PCS\)|QUANTITY|CANT/.test(t)
                   && !/CTN|CARTON/.test(t)) col.qty=idx;
          // «N.W.», «NW», «Nt.Wt.», «NET»
          else if(/\bN(ET|T)?\.?\s*W|NET/.test(t)){
            if(total){ if(col.nw==null) col.nw=idx; }
            else if(col.nw_ctn==null) col.nw_ctn=idx;
          }
          // «G.W.», «GW», «Gr.Wt», «GROSS»
          else if(/\bG(R)?\.?\s*W|GROSS|PESO/.test(t)){
            if(total){ if(col.gw==null) col.gw=idx; }
            else if(col.gw_ctn==null) col.gw_ctn=idx;
            if(/LBS?\b|POUND|LIBRA/.test(t)) uPeso='lb';
          }
          else if(/CBM|M3|M³|CFT|CU\.?\s*FT|VOLUM|CUBICA/.test(t)){
            if(porCtn && !total){ if(col.cbm_ctn==null) col.cbm_ctn=idx; }
            else if(col.cbm==null) col.cbm=idx;
            if(/CFT|CU\.?\s*FT|PIE/.test(t)) uVol='pie3';
          }
          // La medida del cartón puede venir en UNA columna de texto o en
          // tres columnas separadas de largo, ancho y alto
          else if(/MEAS|MEDIDA|DIMENS|SIZE\s*\(?CM|CMS/.test(t)){
            if(col.meas==null) col.meas=idx;
            if(col.medL==null) col.medL=idx;
          }
          // Largo, ancho y alto SOLO después de la columna de medidas: la
          // «L» suelta de antes es la TALLA L, y por ahí se colaba un 2 en
          // lugar de los 50 cm de la caja.
          else if(col.meas!=null && idx>col.meas && col.medW==null
                   && /(^|\s)W(\s|$)|ANCHO|WIDTH/.test(t)) col.medW=idx;
          else if(col.medW!=null && idx>col.medW && col.medH==null
                   && /(^|\s)H(\s|$)|ALTO|HEIGHT/.test(t)) col.medH=idx;
        });
        // Largo, ancho y alto en tres columnas SIN título de medidas encima
        // («箱规 L | W | H» en Wenzhou Hongshen): una L seguida de W y de H.
        if(col.meas==null){
          for(var q0=0;q0<junta.length && col.meas==null;q0++){
            if(!/(^|\s)L$/.test(junta[q0]||'')) continue;
            var iw=-1, ih=-1;
            for(var q1=q0+1;q1<=q0+4 && q1<junta.length;q1++){
              if(iw<0 && /(^|\s)W$/.test(junta[q1]||'')) iw=q1;
              else if(iw>=0 && /(^|\s)H$/.test(junta[q1]||'')){ ih=q1; break; }
            }
            if(iw>0 && ih>0){ col.meas=q0; col.medL=q0; col.medW=iw; col.medH=ih; }
          }
        }
        // v770: «QTY IN BOX» manda sobre «PCS/BOX» (que puede ser por talla)
        if(col.pxcIn!=null) col.pxc=col.pxcIn;
        if(col.qty===col.pxc) col.qty=null;
        // Si la medida vino como L / W / H sueltas, se arma el texto
        if(col.medL!=null && col.medW==null){
          // «L X W X H»: las columnas con la equis en medio
          var pos=[col.medL];
          for(var q=col.medL+1;q<col.medL+6;q++){
            var muestra=String((filas[fi+3]||[])[q]||'').trim().toUpperCase();
            if(muestra==='X') continue;
            if(muestra && !isNaN(Number(muestra))) pos.push(q);
            if(pos.length===3) break;
          }
          if(pos.length===3){ col.medL=pos[0]; col.medW=pos[1]; col.medH=pos[2]; }
        }
        // Una hoja sin NINGUNA columna de packing es la factura (VI-1107 y
        // HS26086 traen factura y packing en el mismo libro). Antes se leía
        // también y las piezas, cajas y kilos salían el doble.
        if(col.ctns==null && col.pxc==null && col.gw==null && col.nw==null
           && col.gw_ctn==null && col.nw_ctn==null && col.cbm==null
           && col.cbm_ctn==null && col.meas==null && col.ctnno==null){
          _dbg('[FIP] hoja «'+nombre+'»: sin columnas de packing, se salta');
          col=null;
          continue;
        }
        fi+=nSig;                    // las de debajo que eran cabecera
        continue;
      }
      if(!col || col.code==null || col.qty==null) continue;

      var code=textos[col.code];
      var rango=col.ctnno!=null?textos[col.ctnno]:'';
      // Las filas de grupo («VS-1157 · HIKC-26070») traen referencia pero no
      // cantidades: son separadores, no artículos.
      var qty=_fipNum(textos[col.qty]);
      /* v770: piezas SUELTAS metidas en otra caja: la fila trae referencia y
         las piezas en «QTY IN BOX», pero ni cartones ni total (Hebei Popna:
         «26221681005/NAVY · 10»). Cuentan como piezas, sin bulto. */
      var suelta=false;
      if(!(qty>0) && code && col.pxc!=null && !String(rango||'').trim()
         && !(col.ctns!=null && _fipNum(textos[col.ctns])>0)){
        var _q=_fipNum(textos[col.pxc]);
        if(_q>0 && !/TOTAL/.test(String(code).toUpperCase())){ qty=_q; suelta=true; }
      }
      if(!(qty>0)) continue;               // fila de grupo o de totales
      /* v770: CAJA MIXTA. Si la fila dice N cartones de X piezas pero su
         total es MAYOR que N×X, ese total es el de la caja entera, que lleva
         también piezas de otra referencia (las «sueltas» de debajo). Las de
         esta referencia son N×X. Ej.: 1 caja · 22 en la caja · total 44. */
      if(!suelta && col.pxc!=null && col.ctns!=null){
        var _nc=_fipNum(textos[col.ctns]), _px=_fipNum(textos[col.pxc]);
        if(_nc>0 && _px>0 && qty > _nc*_px + 0.001) qty=_nc*_px;
      }
      // Las filas de «resto» vienen sin referencia: son del artículo de
      // arriba y SIEMPRE traen su número de cartón. El pie del packing
      // (totales) tampoco trae referencia pero no tiene número de cartón:
      // así se distingue y no se suma dos veces todo.
      var hastaTxt=col.ctnto!=null?textos[col.ctnto]:'';
      if(!code){
        if(!ultimo) continue;
        if(!String(rango||'').trim() && !String(hastaTxt||'').trim()) continue;
        // El subtotal de cada bloque (Lonwa: «3 · 72 · 42 · 39») tampoco
        // trae referencia y en la primera columna lleva el número de cajas,
        // que parece un cartón. Una fila de resto de verdad dice cuántas
        // piezas van por caja; el subtotal no.
        if(col.pxc!=null && !(_fipNum(textos[col.pxc])>0)) continue;
        code=ultimo;
      }
      if(/TOTAL/.test(String(code).toUpperCase())) continue;
      ultimo=code;

      var huella=[code, rango, qty, col.ctns!=null?textos[col.ctns]:'', suelta?'s'+fi:''].join('|');
      if(vistas[huella]) continue;
      vistas[huella]=true;

      // La medida: de una columna de texto o de las tres sueltas
      var meas='';
      if(col.medL!=null && col.medW!=null && col.medH!=null){
        var L=_fipNum(textos[col.medL]), W=_fipNum(textos[col.medW]), H=_fipNum(textos[col.medH]);
        if(L>0 && W>0 && H>0) meas=_fipMedida(L+'x'+W+'x'+H, 'cm');
      }
      if(!meas && col.meas!=null) meas=_fipMedida(textos[col.meas], linea||'cm');
      // Marco pone la medida «39*32*29» en la columna titulada «MEAS. CBM
      // (CM)»: es una medida, no un volumen. Antes salían 4,6 millones de
      // pies³ por caja.
      var volTxt=col.cbm!=null?String(textos[col.cbm]||''):'';
      var volEsMedida=/\d\s*[*xX×]\s*\d+(?:[.,]\d+)?\s*[*xX×]\s*\d/.test(volTxt);
      if(volEsMedida && !meas) meas=_fipMedida(volTxt,'cm');

      code=String(code).trim().toUpperCase();      // v770: en mayúsculas
      filasItem.push({
        code:code, clave:_ocNormSku(code),
        qty:qty,
        ctns:suelta?0:_fipCajas(col.ctns!=null?textos[col.ctns]:'', rango, hastaTxt),
        pxc:suelta?0:(col.pxc!=null?(_fipNum(textos[col.pxc])||0):0),
        gw:suelta?0:Math.max(col.gw!=null?(_fipNum(textos[col.gw])||0):0,
                             col.nw!=null?(_fipNum(textos[col.nw])||0):0),
        nw:suelta?0:(col.nw!=null?(_fipNum(textos[col.nw])||0):0),
        vol:(!suelta && col.cbm!=null && !volEsMedida)?(_fipNum(textos[col.cbm])||0):0,
        // v770: el MAYOR de bruto y neto por caja (hay proveedores que los
        // ponen al revés: neto 29, bruto 28)
        gw_ctn:Math.max(col.gw_ctn!=null?(_fipNum(textos[col.gw_ctn])||0):0,
                        col.nw_ctn!=null?(_fipNum(textos[col.nw_ctn])||0):0),
        vol_ctn:col.cbm_ctn!=null?(_fipNum(textos[col.cbm_ctn])||0):0,
        color:col.color!=null?textos[col.color]:'',
        // El código de barras, si el packing lo trae (v715): la venta directa
        // lo usa cuando la proforma no lo tiene
        barcode:col.barcode!=null ? String(textos[col.barcode]||'').trim()
                  .replace(/\.0+$/,'').replace(/^'/,'') : '',
        meas:meas, uVol:uVol, uPeso:uPeso
      });
      n++;
    }
  });
  if(!n) return null;

  // De cada referencia se aprende SOLO de las cajas completas.
  var grupos={};
  filasItem.forEach(function(f){ (grupos[f.clave]=grupos[f.clave]||[]).push(f); });

  var porCaja=function(valor, cajas, min, max){
    var v=Number(valor)||0, c=Number(cajas)||0;
    if(!(v>0)) return 0;
    if(c<=1) return v;
    var siTotal=v/c;
    var vOk=(v>=min && v<=max), tOk=(siTotal>=min && siTotal<=max);
    if(vOk && !tOk) return v;
    return siTotal;
  };

  var por={};
  Object.keys(grupos).forEach(function(k){
    var g=grupos[k];
    var completas=null;
    g.forEach(function(f){
      if(f.ctns<=0 || f.qty<=0) return;
      var px=f.pxc>0?f.pxc:(f.qty/f.ctns);
      var exacta=Math.abs(px-Math.round(px))<0.001;
      if(!completas){ completas=f; return; }
      var pxA=completas.pxc>0?completas.pxc:(completas.qty/completas.ctns);
      var exactaA=Math.abs(pxA-Math.round(pxA))<0.001;
      if(exacta && !exactaA) completas=f;
      else if(exacta===exactaA && f.ctns>completas.ctns) completas=f;
    });
    if(!completas) completas=g[0];

    var pxc = completas.pxc>0 ? completas.pxc
            : (completas.ctns>0 ? Math.round(completas.qty/completas.ctns) : 0);
    var pesoCaja = completas.gw_ctn>0 ? completas.gw_ctn
                 : porCaja(completas.gw||completas.nw, completas.ctns, 2, 60);
    if(completas.uPeso==='lb') pesoCaja*=FIP_LB_A_KG;
    var volCaja = completas.vol_ctn>0 ? completas.vol_ctn
                : porCaja(completas.vol, completas.ctns, 0.005, 0.5);
    if(completas.uVol==='m3') volCaja*=FIP_M3_A_PIE3;
    // Sin volumen en el documento pero con la medida del cartón (Lonwa,
    // Marco): largo x ancho x alto en cm, a m³ y de ahí a pies³.
    if(!(volCaja>0)){
      var mm=(String(completas.meas||'').match(/[\d.]+/g)||[]).map(Number);
      if(mm.length>=3 && mm[0]>0 && mm[1]>0 && mm[2]>0)
        volCaja=mm[0]*mm[1]*mm[2]/1e6*FIP_M3_A_PIE3;
    }

    var tot={qty:0, ctns:0, kilos:0, pie3:0};
    g.forEach(function(f){
      tot.qty+=f.qty; tot.ctns+=f.ctns;
      var kg = f.gw>0 ? f.gw : (f.gw_ctn>0 ? f.gw_ctn*f.ctns : 0);   // las sueltas: ctns 0 → 0
      if(f.uPeso==='lb') kg*=FIP_LB_A_KG;
      var v  = f.vol>0 ? f.vol : (f.vol_ctn>0 ? f.vol_ctn*f.ctns : 0);
      if(f.uVol==='m3') v*=FIP_M3_A_PIE3;
      tot.kilos+=kg; tot.pie3+=v;
    });
    var medida=(g.filter(function(f){ return f.meas; })[0]||{}).meas||'';
    var color=(g.filter(function(f){ return f.color; })[0]||{}).color||'';
    var barcode=(g.filter(function(f){ return /^\d{8,14}$/.test(f.barcode||''); })[0]||{}).barcode
             || barcodeDe[k] || '';

    por[k]={itemcode:completas.code, cantidad:tot.qty, bultos:tot.ctns,
            medida:medida, color:color, piezas_x_bulto:pxc,
            peso_bulto_kg:pesoCaja, vol_bulto_pie3:volCaja,
            kilos:tot.kilos||pesoCaja*tot.ctns, pie3:tot.pie3||volCaja*tot.ctns,
            cajas_aprendidas:completas.ctns, barcode:barcode};
  });
  _dbg('[FIP] packing list: '+n+' línea(s), '+Object.keys(por).length+' referencia(s)');
  return por;
}

// Lo que se le pondrá a la ficha del artículo en SAP
function _fipMedidas(pk){
  if(!pk) return null;
  var q=Number(pk.cantidad)||0, b=Number(pk.bultos)||0;
  // Lo de la caja completa manda; si no se pudo sacar, se reparte el total
  var pxb = pk.piezas_x_bulto>0 ? pk.piezas_x_bulto : (b ? q/b : 0);
  var pesoB = pk.peso_bulto_kg>0 ? pk.peso_bulto_kg : (b ? pk.kilos/b : 0);
  var volB  = pk.vol_bulto_pie3>0 ? pk.vol_bulto_pie3 : (b ? pk.pie3/b : 0);
  return {
    itemcode: pk.itemcode,
    cantidad: q, bultos: b,
    piezas_x_bulto: pxb,
    vol_bulto_pie3: volB,                      // OITM U_CxBlt
    vol_pieza_pie3: pxb ? volB/pxb : 0,        // OITM BVolume y SVolume
    peso_bulto_kg:  pesoB,                     // OITM U_PxBlt
    peso_pieza_kg:  pxb ? pesoB/pxb : 0,       // peso de compra y de venta
    medida_carton:  pk.medida || ''
  };
}

/* ═══════════════════════════════════════════════════════════════════════════
   FACTURA Y PACKING LIST DEL PROVEEDOR EN LA FACTURA RESERVA   (prefijo [FIP])
   ───────────────────────────────────────────────────────────────────────────
   Es una forma NUEVA de llenar la factura reserva, que se suma a la de
   siempre (elegir la orden y marcar las líneas a mano).

   Se adjuntan la factura del proveedor y su packing list (Excel o PDF). La
   IA los lee y vincula cada referencia con la línea de la orden de compra a
   la que pertenece. Una misma factura puede traer artículos de diez órdenes
   del mismo proveedor: por eso la tabla dice a qué orden va cada referencia
   y, si algo quedó mal emparejado, se puede cambiar a mano.

   Además compara contra la orden:
     · el PRECIO de costo de la factura contra el de la orden,
     · la CANTIDAD contra lo que queda pendiente; si se aparta más de un 10%
       por arriba o por abajo, se resalta como diferencia.

   Con eso se puede sacar un reporte para el proveedor, en Excel o en PDF,
   eligiendo antes qué diferencias se le reportan y cuáles se omiten.
   ═══════════════════════════════════════════════════════════════════════════ */

window._fip = null;
var FIP_TOL_CANT = 0.10;       // 10% arriba o abajo
var FIP_TOL_PRECIO = 0.005;

function _fipNuevo(){
  return {fac:null, pack:null, items:[], filas:[], faltan:[], leyendo:false,
          usarPrecio:false, aplicado:false, error:''};
}

function _fipBloque(){
  if(!window._fip) window._fip=_fipNuevo();
  setTimeout(_fipPintar, 30);
  return '<div id="fipBox" style="margin-bottom:12px"></div>';
}

function _fipPintar(){
  var box=document.getElementById('fipBox'); if(!box) return;
  var S=window._fip||_fipNuevo();
  var caja=function(clave, titulo, sub, archivo){
    return '<label style="flex:1;min-width:230px;display:flex;align-items:center;gap:9px;'
      +'padding:9px 11px;border:1.5px dashed #6B8FD6;border-radius:8px;cursor:pointer;'
      +'background:var(--surface-0)">'
      +'<i class="ti ti-file-invoice" style="color:var(--t-azul);font-size:17px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:11.5px;font-weight:700;'
      +'color:var(--t-azul)">'+titulo+'</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);overflow:hidden;'
      +'text-overflow:ellipsis;white-space:nowrap">'+_esc(archivo||sub)+'</div></div>'
      +(archivo?'<i class="ti ti-circle-check" style="color:var(--t-verde);font-size:16px"></i>':'')
      +'<input type="file" accept=".pdf,.xlsx,.xls,.csv,image/*" style="display:none" '
      +'onchange="_fipArchivo(this,\''+clave+'\')"></label>';
  };
  box.innerHTML='<div style="border:1px solid #9DB3D9;border-radius:10px;padding:11px 13px;'
    +'background:var(--surface-1)">'
    +'<div style="font-size:12.5px;font-weight:700;margin-bottom:3px">'
    +'<i class="ti ti-sparkles" style="color:var(--t-lila)"></i> '
    +'Llenarla desde la factura y el packing list del proveedor</div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:8px">'
    +'La IA lee los documentos y vincula cada referencia con su orden de compra. '
    +'Compara precio y cantidad, y resalta lo que no cuadra. Se puede seguir llenando '
    +'a mano como siempre.</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
    + caja('fac','FACTURA DEL PROVEEDOR','PDF, Excel o foto', S.fac&&S.fac.name)
    + caja('pack','PACKING LIST','PDF o Excel (opcional)', S.pack&&S.pack.name)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center">'
    +'<button class="btn bp" style="background:#5B21B6;padding:8px 14px;font-size:12px" '
    +'onclick="_fipLeer()"'+(S.leyendo?' disabled':'')+'>'
    +(S.leyendo?'<span class="ai-ring"></span> Leyendo y vinculando…'
              :'<i class="ti ti-wand"></i> Leer y vincular con las órdenes')+'</button>'
    +(S.filas.length?('<button class="xb" onclick="_fipAplicar()">'
      +'<i class="ti ti-check"></i> Aplicar a la factura reserva</button>'
      +'<button class="xb" onclick="_fipReporte()"><i class="ti ti-file-export"></i> '
      +'Diferencias y reporte para el proveedor</button>'):'')
    +(S.error?('<span style="font-size:11px;color:var(--t-rojo)">'+_esc(S.error)+'</span>'):'')
    +'</div>'
    +(S.filas.length?_fipTablaHtml():'')
    +'</div>';
}

function _fipArchivo(input, cual){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  window._fip=window._fip||_fipNuevo();
  window._fip[cual]=f;
  _fipPintar();
}

// Lee el packing list: cantidades, bultos y pesos por referencia
async function _fipLeerPacking(file){
  var doc=await _iaDesdeBlob(file, file.name);
  var prompt='Este documento es el PACKING LIST de un proveedor. Devuelve SOLO un JSON,\n'
    +'sin texto alrededor ni ```:\n'
    +'{"items":[{"itemcode":"","descripcion":"","cantidad":0,"bultos":0,"peso_kg":0,"cbm":0}],\n'
    +' "total_bultos":0,"total_peso_kg":0,"total_cbm":0}\n\n'
    +'REGLAS:\n'
    +'- "itemcode" es el codigo de Kennedy (KCC ITEM No.). Si viene partido en dos\n'
    +'  lineas, juntalo. No uses el codigo del proveedor si hay uno de Kennedy.\n'
    +'- "cantidad" son las piezas; "bultos" los cartones (CTNS); "peso_kg" el peso\n'
    +'  bruto de la linea en kg; "cbm" el volumen en m3.\n'
    +'- Una fila por articulo, sin filas de totales. No inventes datos.';
  var obj=await _iaJSON(doc.bloques.concat([{type:'text', text:prompt}]), 8000);
  var por={};
  ((obj&&obj.items)||[]).forEach(function(it){
    var c=String(it.itemcode||'').trim(); if(!c) return;
    var k=_ocNormSku(c);
    var a=por[k]||(por[k]={itemcode:c, cantidad:0, bultos:0, kilos:0, cbm:0});
    a.cantidad+=Number(it.cantidad)||0;
    a.bultos+=Number(it.bultos)||0;
    a.kilos+=Number(it.peso_kg)||0;
    a.cbm+=Number(it.cbm)||0;
  });
  // _fipMedidas trabaja en pies³ (pk.pie3): la IA los da en m³
  Object.keys(por).forEach(function(k){ por[k].pie3=(por[k].cbm||0)*FIP_M3_A_PIE3; });
  return por;
}

async function _fipLeer(){
  var S=window._fip=window._fip||_fipNuevo();
  var d=window._fr;
  if(!S.fac){ showT('Adjunta la factura del proveedor'); return; }
  if(!d || !d.lineas || !d.lineas.length){
    showT('Primero elige la orden (o las órdenes) del proveedor, para tener sus líneas');
    return;
  }
  S.leyendo=true; S.error=''; _fipPintar();
  try{
    // El Excel del proveedor se lee tal cual, por grupos de PI: es exacto y
    // además dice de qué orden viene cada artículo. Si no tiene esa forma,
    // o es un PDF, se lee con la IA como antes.
    var fac=null;
    if(/\.(xlsx|xls|csv)$/i.test(S.fac.name||'')){
      try{ fac=await _fipLeerExcelFactura(S.fac); }
      catch(e){ _dbg('[FIP] Excel: '+(e.message||e)); }
    }
    if(!fac) fac=await _spcLeerFacturaProveedor(S.fac);  // el lector de la IA
    var pack={};
    if(S.pack){
      if(/\.(xlsx|xls|csv)$/i.test(S.pack.name||'')){
        try{ pack=await _fipLeerExcelPacking(S.pack)||{}; }
        catch(e){ _dbg('[FIP] packing Excel: '+(e.message||e)); }
      }
      if(!Object.keys(pack).length) pack=await _fipLeerPacking(S.pack);
    }
    // v755: si la factura trae bultos, peso y volumen y el packing no dio nada
    if(!Object.keys(pack||{}).length && fac && fac.packing) pack=fac.packing;
    // v756: y si el packing list SÍ dio algo pero le faltan datos (peso 0,
    // bultos 0) o el volumen está en otra unidad (35 veces más), se completa
    // con lo que dice la propia factura, línea por línea.
    else if(fac && fac.packing){
      Object.keys(fac.packing).forEach(function(k){
        var fp=fac.packing[k], pp=pack[k];
        if(!pp){ pack[k]=fp; return; }
        if(!(pp.kilos>0) && fp.kilos>0) pp.kilos=fp.kilos;
        if(!(pp.bultos>0) && fp.bultos>0) pp.bultos=fp.bultos;
        if(!(pp.piezas_x_bulto>0) && fp.piezas_x_bulto>0) pp.piezas_x_bulto=fp.piezas_x_bulto;
        if(!(pp.pie3>0) && fp.pie3>0) pp.pie3=fp.pie3;
        else if(fp.pie3>0 && pp.pie3>0){
          var r=pp.pie3/fp.pie3;
          if(Math.abs(r-FIP_M3_A_PIE3)<3 || Math.abs(r-1/FIP_M3_A_PIE3)<0.01) pp.pie3=fp.pie3;
        }
      });
    }
    S.items=fac.items; S.factura=fac; S.packing=pack;
    S.cargos=(fac.cargos||[]).map(function(c){
      // «Flete» a secas se cambia por la cuenta del departamento, que es la
      // que espera SAP; los gastos generales (THC, seguros…) se dejan.
      var con=String(c.concepto||'');
      if(/^FLETE$/i.test(con.trim())) con=_fipFleteDelDepto();
      return {concepto:con, monto:Number(c.monto)||0, inc:true}; });
    try{ _fipCargarGastos(); }catch(e){}
    S.fobDeclarado=fac.fob||fac.suma||0;
    S.cifDeclarado=fac.cif||0;
    S.qtyDeclarada=fac.qty||0;
    S.embarque=fac.embarque||{};
    S.numeroFactura=fac.numero||'';
    _fipPonerDatosEmbarque();
    // Antes de emparejar: la factura casi siempre trae artículos de varias
    // órdenes del proveedor. Se buscan TODAS las órdenes abiertas suyas que
    // tengan esas referencias pendientes y se añaden a la factura.
    await _fipTraducir();
    await _fipTraerOrdenes();
    _fipVincular();
    if(!S.filas.length) throw new Error('la IA no sacó artículos de la factura');
    // La lista de la factura reserva se queda con lo del documento, sin
    // tener que pulsar nada: era lo que despistaba, ver todavía las líneas
    // de la orden después de cargar el Excel.
    if(S.filas.some(function(f){ return f.linea>=0; })) _fipAplicar(true);
    var sinOrden=S.filas.filter(function(f){ return f.linea<0; }).length;
    if(sinOrden===S.filas.length && !S.error){
      S.error=S.diag || ('Ninguna referencia de la factura está pedida a este proveedor con cantidad '
        +'pendiente en SAP. Comprueba que la factura traiga el código de Kennedy.');
    } else if(S.diag && !S.error){
      showT(S.diag, 12000);
    }
    showT('✓ '+S.filas.length+' referencia(s) leídas y vinculadas');
  }catch(e){
    S.error='No pude leer los documentos: '+(e.message||e);
  }
  S.leyendo=false; _fipPintar();
}

// La factura del proveedor casi nunca trae el código de SAP: trae SU
// referencia (STYLE NO.) o el código de barras. Aquí se traduce cada una al
// artículo de Kennedy buscándola en el inventario por código, por referencia
// del proveedor (suppcatnum) y por código de barras.
/* SAP no distingue mayúsculas en los códigos (P2248-0006 = p2248-0006);
   Supabase SÍ. Para buscar un código en Supabase se pregunta por él tal
   cual, en mayúsculas y en minúsculas (v752), y después se compara siempre
   normalizado. Devuelve la lista ya entrecomillada para un filtro in.(…). */
function _skuVariantes(codigos){
  var out=[], visto={};
  (codigos||[]).forEach(function(c){
    var t=String(c==null?'':c).trim().replace(/"/g,'');
    if(!t) return;
    [t, t.toUpperCase(), t.toLowerCase()].forEach(function(v){
      if(!visto[v]){ visto[v]=1; out.push('"'+v+'"'); }
    });
  });
  return out;
}

async function _fipTraducir(){
  var S=window._fip;
  S.trad={};            // clave normalizada de la factura -> [itemcode de SAP]
  S.comoSalio={};       // por cuál de los tres campos casó
  var codigos=Object.keys(S.items||{}).map(function(k){ return S.items[k].itemcode; })
                .filter(Boolean);
  if(!codigos.length) return;
  var campos=[['itemcode','código de SAP'], ['suppcatnum','referencia del proveedor'],
              ['codebars','código de barras']];
  try{
    for(var c=0;c<campos.length;c++){
      var campo=campos[c][0];
      // Solo se busca lo que todavía no se ha podido traducir
      var faltan=codigos.filter(function(x){ return !S.trad[_ocNormSku(x)]; });
      if(!faltan.length) break;
      for(var i=0;i<faltan.length;i+=60){
        var lote=_skuVariantes(faltan.slice(i,i+60));
        var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,suppcatnum,codebars&'
          +campo+'=in.('+lote.join(',')+')&limit=2000',{headers:SBH});
        if(!r.ok) continue;
        (await r.json()||[]).forEach(function(x){
          var k=_ocNormSku(x[campo]);
          if(!k) return;
          (S.trad[k]=S.trad[k]||[]).push(x.itemcode);
          S.comoSalio[k]=campos[c][1];
        });
      }
    }
    var n=Object.keys(S.trad).length;
    _dbg('[FIP] traducidas '+n+' de '+codigos.length+' referencia(s) de la factura');
  }catch(e){
    _dbg('[FIP] traducir referencias: '+(e.message||e));
  }
}

// Todos los códigos de SAP con los que puede casar una referencia: el suyo
// propio y los que salieron de la traducción.
function _fipClaves(codigo){
  var S=window._fip, k=_ocNormSku(codigo);
  var lista=[k];
  ((S.trad||{})[k]||[]).forEach(function(ic){
    var n=_ocNormSku(ic);
    if(lista.indexOf(n)<0) lista.push(n);
  });
  return lista;
}

// Busca las referencias de la factura en todas las órdenes abiertas del
// proveedor, no solo en las que ya estaban elegidas, y añade las que hagan
// falta. Es lo normal: una factura cubre varias órdenes del mismo proveedor.
async function _fipTraerOrdenes(){
  var S=window._fip, d=window._fr;
  if(!d || !d.cardcode) return;
  // El código de la factura y los de SAP a los que se tradujo
  var codigos=[];
  Object.keys(S.items||{}).forEach(function(k){
    var it=S.items[k];
    if(it.itemcode) codigos.push(String(it.itemcode).trim());
    ((S.trad||{})[_ocNormSku(it.itemcode)]||[]).forEach(function(ic){ codigos.push(ic); });
  });
  codigos=[...new Set(codigos.filter(Boolean))];
  if(!codigos.length) return;
  S.anadidas=[];

  try{
    // 0. Lo más fiable: el PI de cada grupo del Excel es el DKC de la orden
    var pis=[...new Set(Object.keys(S.items||{})
      .map(function(k){ return String(S.items[k].pi||'').trim(); }).filter(Boolean))];
    if(pis.length){
      var lp=_skuVariantes(pis).join(',');     // «dkc-26132» = «DKC-26132»
      var rp=await fetch(SB+'/rest/v1/opor_ordenes?select=docnum,vendor_code,vendor_name,'
        +'num_proveedor&num_proveedor=in.('+lp+')&limit=200',{headers:SBH});
      if(rp.ok){
        var yaC={};
        d.lineas.forEach(function(l){ yaC[String(l.docnum)]=true; });
        var ords=(await rp.json()||[]).filter(function(o){
          return String(o.vendor_code||'').trim()===String(d.cardcode).trim(); });
        for(var z=0;z<ords.length;z++){
          if(yaC[String(ords[z].docnum)]) continue;
          var okz=await _frCargarLineas({id:String(ords[z].docnum), resp:d.cardcode,
            prov:d.cardname||ords[z].vendor_name||'',
            num_proveedor:ords[z].num_proveedor||''}, true);
          if(okz) S.anadidas.push(String(ords[z].docnum));
        }
        _dbg('[FIP] por PI: '+pis.length+' DKC de la factura · '+ords.length+' orden(es)');
      }
    }

    // 0b. v755: la factura dice de qué orden es cada artículo («OC-12828»)
    var ocs=[...new Set(Object.keys(S.items||{}).map(function(k){ return String(S.items[k].oc||'').trim(); }).filter(Boolean))];
    if(ocs.length){
      var rq=await fetch(SB+'/rest/v1/opor_ordenes?select=docnum,vendor_code,vendor_name,num_proveedor'
        +'&docnum=in.('+ocs.join(',')+')&limit=100',{headers:SBH});
      if(rq.ok){
        var yaO={}; d.lineas.forEach(function(l){ yaO[String(l.docnum)]=true; });
        var lst=(await rq.json()||[]).filter(function(o){
          return String(o.vendor_code||'').trim().toUpperCase()===String(d.cardcode).trim().toUpperCase(); });
        for(var y=0;y<lst.length;y++){
          if(yaO[String(lst[y].docnum)]) continue;
          var oky=await _frCargarLineas({id:String(lst[y].docnum), resp:d.cardcode,
            prov:d.cardname||lst[y].vendor_name||'', num_proveedor:lst[y].num_proveedor||''}, true);
          if(oky){ S.anadidas.push(String(lst[y].docnum)); yaO[String(lst[y].docnum)]=true; }
        }
        _dbg('[FIP] por la orden escrita en la factura: '+ocs.join(', '));
      }
    }

    // 1. ¿En qué órdenes están pedidas esas referencias? Se pregunta por las
    //    LÍNEAS, no por las órdenes: así da igual cuántas órdenes tenga el
    //    proveedor y no hay que listarlas todas antes.
    var conRef={}, sinPend={};
    S.diag='';
    for(var i=0;i<codigos.length;i+=50){
      var lote=_skuVariantes(codigos.slice(i,i+50));
      var rl=await fetch(SB+'/rest/v1/opor_lineas?select=docnum,itemcode,cantidad_pendiente'
        +'&itemcode=in.('+lote.join(',')+')&limit=5000',{headers:SBH});
      if(!rl.ok){
        throw new Error('opor_lineas '+rl.status+': '+(await rl.text()).slice(0,160));
      }
      (await rl.json()||[]).forEach(function(l){
        if((Number(l.cantidad_pendiente)||0)>0) conRef[String(l.docnum)]=true;
        else sinPend[String(l.docnum)]=true;
      });
    }
    var nums=Object.keys(conRef);
    if(!nums.length){
      var vistas=Object.keys(sinPend);
      if(!vistas.length){
        S.diag='Ninguna de estas referencias aparece en las órdenes de compra que tiene el portal. '
          +'Si la orden es nueva o se cambió hace poco en SAP, pulsa Sync y vuelve a leer la factura.';
        _dbg('[FIP] ninguna referencia de la factura está en opor_lineas');
        return;
      }
      /* v753: las referencias SÍ están pedidas, pero en el portal figuran sin
         pendiente (dato viejo del sync, o una orden a medias). Antes se
         descartaban y salía «no está pedida». Ahora se cargan igual: al crear
         la factura reserva el worker comprueba en SAP lo que queda de verdad
         y no deja pasar nada que ya esté servido. */
      nums=vistas;
      S.diag='Las referencias están en la(s) orden(es) #'+vistas.slice(0,6).join(', #')
        +', pero en el portal figuran sin cantidad pendiente (puede ser un dato viejo). Se cargan igual: '
        +'al crear la factura reserva SAP dirá lo que queda de verdad. Si quieres el dato al día, pulsa Sync.';
      _dbg('[FIP] referencias pedidas pero sin pendiente en el portal: '+vistas.join(', '));
    }

    // 2. De esas órdenes, solo las de ESTE proveedor. La columna se llama
    //    vendor_code / vendor_name (no cardcode / cardname): pedir un nombre
    //    de columna que no existe hacía que PostgREST devolviera error y la
    //    búsqueda se quedara sin resultados sin decir nada.
    var suyas=[], otras=[], halladas={};
    var normProv=function(t){ return String(t||'').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^A-Z0-9]/g,''); };
    for(var j=0;j<nums.length;j+=150){
      var ln=nums.slice(j,j+150).join(',');
      var ro=await fetch(SB+'/rest/v1/opor_ordenes?select=docnum,vendor_code,vendor_name,'
        +'num_proveedor&docnum=in.('+ln+')&limit=500',{headers:SBH});
      if(!ro.ok){
        throw new Error('opor_ordenes '+ro.status+': '+(await ro.text()).slice(0,160));
      }
      (await ro.json()||[]).forEach(function(o){
        halladas[String(o.docnum)]=1;
        // El mismo proveedor por código, o por nombre si en SAP tiene dos códigos
        var mismo=String(o.vendor_code||'').trim().toUpperCase()===String(d.cardcode).trim().toUpperCase()
          || (d.cardname && normProv(o.vendor_name) && normProv(o.vendor_name)===normProv(d.cardname));
        if(mismo) suyas.push(o); else otras.push(o);
      });
    }
    var noEstan=nums.filter(function(n){ return !halladas[n]; });
    if(!suyas.length){
      S.diag = otras.length
        ? ('Las referencias están pedidas en la(s) orden(es) '+otras.slice(0,5).map(function(o){
            return '#'+o.docnum+' de '+(o.vendor_name||o.vendor_code); }).join(', ')
          +', y esta factura reserva es de '+(d.cardname||d.cardcode)+' ('+d.cardcode+'). '
          +'Si la factura es de ese otro proveedor, empieza la factura reserva desde una orden suya.')
        : ('Las referencias están en la(s) orden(es) #'+noEstan.slice(0,6).join(', #')
          +', pero el portal no tiene la cabecera de esa orden. Pulsa Sync y vuelve a leer la factura.');
      _dbg('[FIP] '+S.diag);
      return;
    }

    // 3. Se cargan las que no estaban ya en la pantalla
    var yaCargadas={};
    d.lineas.forEach(function(l){ yaCargadas[String(l.docnum)]=true; });
    for(var k=0;k<suyas.length;k++){
      var o=suyas[k];
      if(yaCargadas[String(o.docnum)]) continue;
      var res=await _frCargarLineas({id:String(o.docnum), resp:d.cardcode,
        prov:d.cardname||o.vendor_name||'', num_proveedor:o.num_proveedor||''}, true);
      if(res) S.anadidas.push(String(o.docnum));
    }
    if(S.anadidas.length){
      _dbg('[FIP] añadidas '+S.anadidas.length+' orden(es): '+S.anadidas.join(', '));
      showT('Se añadieron '+S.anadidas.length+' orden(es) del proveedor con referencias '
        +'de esta factura');
    }
  }catch(e){
    // Si esto falla, el usuario tiene que enterarse: antes se quedaba mudo y
    // parecía que la referencia no estaba pedida.
    S.error='No pude buscar las órdenes del proveedor: '+(e.message||e);
    _dbg('[FIP] '+S.error);
  }
}

// El DKC de una orden según lo que dijo la factura (el PI de su grupo)
function _fipDkcDeFilas(docnum){
  var S=window._fip, d=window._fr;
  var f=((S&&S.filas)||[]).filter(function(x){
    return x.linea>=0 && String(d.lineas[x.linea].docnum)===String(docnum) && x.pi; })[0];
  return f?f.pi:'';
}

// El DKC (num. de proveedor) de una orden ya cargada
function _fipDkcDeOrden(docnum){
  var d=window._fr||{ordenes:[]};
  var o=(d.ordenes||[]).filter(function(x){ return String(x.docnum)===String(docnum); })[0];
  return String((o&&o.numatcard)||'').trim().toUpperCase();
}

// Empareja cada referencia de la factura con la línea de su orden de compra
function _fipVincular(){
  var S=window._fip, d=window._fr;
  var porCodigo={};
  d.lineas.forEach(function(l,i){
    var k=_ocNormSku(l.itemcode);
    (porCodigo[k]=porCodigo[k]||[]).push(i);
  });
  var codigosOC=d.lineas.map(function(l){ return l.itemcode; });

  var usados={};
  S.filas=Object.keys(S.items).map(function(k){
    var it=S.items[k];
    var cand=[], modo='exacta';
    _fipClaves(it.itemcode).forEach(function(cl, n){
      if(cand.length || !porCodigo[cl]) return;
      cand=porCodigo[cl];
      if(n>0) modo=(S.comoSalio||{})[_ocNormSku(it.itemcode)]||'referencia del proveedor';
    });
    if(!cand.length){
      var m=null; try{ m=_refEmparejar(codigosOC, it.itemcode); }catch(e){}
      if(m){ cand=porCodigo[_ocNormSku(m.codigo)]||[]; modo=m.modo; }
    }
    // Si el mismo artículo está en varias órdenes, se propone la que más
    // cantidad tiene pendiente; se puede cambiar en la tabla.
    var libres=cand.filter(function(i){ return !usados[i]; });
    // Si el Excel dice de qué PI (DKC) viene, manda esa orden
    var dkc=String(it.pi||'').trim().toUpperCase();
    libres.sort(function(a,b){
      if(dkc){
        var da=_fipDkcDeOrden(d.lineas[a].docnum)===dkc ? 1 : 0;
        var db=_fipDkcDeOrden(d.lineas[b].docnum)===dkc ? 1 : 0;
        if(da!==db) return db-da;
      }
      return d.lineas[b].abierta-d.lineas[a].abierta;
    });
    var idx = libres.length ? libres[0] : (cand.length?cand[0]:-1);
    if(idx>=0) usados[idx]=true;
    var pk=(S.packing||{})[k]||null;
    return {clave:k, itemcode:it.itemcode, nombre:it.nombre||'', pi:it.pi||'',
            cantidad:it.cantidad, precio:it.precio, importe:it.importe,
            bultos:(pk?pk.bultos:it.bultos)||0, kilos:(pk?pk.kilos:it.kilos)||0,
            packing:pk?pk.cantidad:null,
            linea:idx, candidatos:cand, modo:modo};
  });

  // Lo que está en las órdenes elegidas y NO viene en la factura
  var enFactura={};
  S.filas.forEach(function(f){ if(f.linea>=0) enFactura[f.linea]=true; });
  S.faltan=d.lineas.map(function(l,i){ return i; })
                   .filter(function(i){ return !enFactura[i]; });
  // Copia de lo que la orden tiene pendiente y la factura no trae: al
  // aplicar, esas líneas se quitan de la pantalla, pero siguen haciendo
  // falta para el reporte al proveedor.
  S.faltanInfo=S.faltan.map(function(i){
    var l=d.lineas[i];
    return {docnum:l.docnum, itemcode:l.itemcode, dscription:l.dscription,
            abierta:l.abierta};
  });
  S.aplicado=false;
}

// Devuelve lo que NO cuadra. Dos niveles: «dif» es lo que se marca en rojo
// (precio distinto, y cantidad que se aparta más del 10%) y «avisos» es lo
// que solo se enseña, como una cantidad que difiere poco: se ve, pero no
// enciende la alarma ni cuenta como diferencia.
function _fipDifs(f, conAvisos){
  var d=window._fr, dif=[], avisos=[];
  if(f.linea<0){
    dif.push({t:'sin_orden', txt:'no está en ninguna de las órdenes elegidas'});
    return conAvisos?{dif:dif, avisos:avisos}:dif;
  }
  var l=d.lineas[f.linea];
  if(l.precio>0 && f.precio>0 && Math.abs(l.precio-f.precio)>FIP_TOL_PRECIO){
    dif.push({t:'precio', txt:'precio: OC '+_fmtN2(l.precio)+' · factura '+_fmtN2(f.precio),
              oc:l.precio, fac:f.precio});
  }
  var ab=Number(l.abierta)||0, cf=Number(f.cantidad)||0;
  if(ab>0 && Math.abs(cf-ab)>0.0001){
    var pct=(cf-ab)/ab*100;
    var texto='cantidad: pendiente en la OC '+_fmtN2(ab)+' · factura '+_fmtN2(cf)
      +' ('+(pct>0?'+':'')+pct.toFixed(0)+'%)';
    if(Math.abs(cf-ab) > ab*FIP_TOL_CANT) dif.push({t:'cantidad', txt:texto, oc:ab, fac:cf});
    else avisos.push({t:'cantidad_leve', txt:texto, oc:ab, fac:cf});
  }
  return conAvisos?{dif:dif, avisos:avisos}:dif;
}

function _fipTablaHtml(){
  var S=window._fip, d=window._fr;
  var ordenes=[...new Set(d.lineas.map(function(l){ return l.docnum; }))];
  var porOrden={};
  S.filas.forEach(function(f){
    var o = f.linea>=0 ? d.lineas[f.linea].docnum : '—';
    porOrden[o]=(porOrden[o]||0)+1;
  });
  var nDif=S.filas.filter(function(f){ return _fipDifs(f).length; }).length;
  var nLeves=S.filas.filter(function(f){ return _fipDifs(f,true).avisos.length; }).length;

  return '<div style="margin-top:10px">'
    +'<div style="display:flex;gap:9px;flex-wrap:wrap;font-size:11px;margin-bottom:6px">'
    +'<span><b>'+S.filas.length+'</b> referencia(s) en la factura</span>'
    +((S.anadidas&&S.anadidas.length)?('<span style="background:var(--pastel-ok);'
      +'color:var(--t-verde);border-radius:8px;padding:2px 8px">+'+S.anadidas.length
      +' orden(es) del proveedor añadidas: #'+S.anadidas.join(', #')+'</span>'):'')
    + Object.keys(porOrden).map(function(o){
        return '<span style="background:var(--pastel-azul);color:var(--t-azul);'
          +'border-radius:8px;padding:2px 8px">'+(o==='—'?'sin orden':'#'+_esc(o))
          +': '+porOrden[o]+'</span>'; }).join('')
    +(nDif?('<span style="background:var(--pastel-error);color:var(--t-rojo);border-radius:8px;'
      +'padding:2px 8px"><b>'+nDif+'</b> con diferencias</span>'):'')
    +(nLeves?('<span style="background:var(--surface-1);color:var(--text-muted);'
      +'border-radius:8px;padding:2px 8px">'+nLeves+' con diferencia de cantidad '
      +'menor al 10%</span>'):'')
    +((S.faltanInfo||[]).length?('<span style="background:var(--pastel-aviso);'
      +'color:var(--t-marron);border-radius:8px;padding:2px 8px">'+S.faltanInfo.length
      +' línea(s) de las órdenes no vienen en la factura'
      +(S.aplicado?' · quitadas de la lista':'')+'</span>'):'')
    +'</div>'
    +'<label style="font-size:11px;display:flex;align-items:center;gap:6px;margin-bottom:6px">'
    +'<input type="checkbox"'+(S.usarPrecio?' checked':'')
    +' onchange="window._fip.usarPrecio=this.checked"> '
    +'Usar el precio de la factura en la factura reserva (si no, se deja el de la orden)</label>'
    +'<div class="tbx-box" style="max-height:38vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:130px">Referencia</th><th>Descripción</th>'
    +'<th style="width:105px">PI / S/C</th>'
    +'<th style="width:120px">Orden de compra</th>'
    +'<th style="width:80px;text-align:right">Cant. factura</th>'
    +'<th style="width:80px;text-align:right">Pend. OC</th>'
    +'<th style="width:85px;text-align:right">Precio factura</th>'
    +'<th style="width:75px;text-align:right">Precio OC</th>'
    +'<th>Diferencias</th></tr></thead><tbody>'
    + S.filas.map(function(f,i){
        var l = f.linea>=0 ? d.lineas[f.linea] : null;
        var r2=_fipDifs(f, true), dif=r2.dif, avisos=r2.avisos;
        var tipos=dif.map(function(x){ return x.t; });
        var pinta=function(cond){ return cond?'background:var(--pastel-error);'
          +'color:var(--t-rojo);font-weight:700':''; };
        // Las órdenes donde SÍ está esa referencia
        var ops=f.candidatos.map(function(ix){
          return '<option value="'+ix+'"'+(ix===f.linea?' selected':'')+'>#'
            +_esc(d.lineas[ix].docnum)+' · pend. '+_fmtN2(d.lineas[ix].abierta)+'</option>';
        }).join('');
        return '<tr'+(dif.length?' style="background:rgba(220,38,38,.05)"':'')+'>'
          +'<td><b>'+_esc(f.itemcode)+'</b>'
          +(f.modo!=='exacta'?('<div style="font-size:9px;color:var(--t-marron)">'
            +(f.modo==='parecido'?'emparejada por parecido':('por '+_esc(f.modo)))
            +(f.linea>=0?(' · SAP: '+_esc(d.lineas[f.linea].itemcode)):'')
            +'</div>'):'')+'</td>'
          +'<td style="font-size:11px">'+_esc(String(f.nombre||(l?l.dscription:'')).slice(0,42))+'</td>'
          +'<td style="font-size:10.5px;color:var(--text-muted)">'+_esc(f.pi||'—')+'</td>'
          +'<td>'+(f.candidatos.length
            ? ('<select onchange="_fipCambiarOrden('+i+',this.value)" '
               +'style="width:100%;font-size:11px;padding:2px;border:0.5px solid var(--border);'
               +'border-radius:5px;background:var(--surface-0);color:var(--text-primary)">'
               +'<option value="-1">— sin asignar —</option>'+ops+'</select>')
            : '<span style="font-size:10.5px;color:var(--t-rojo)">no está en las órdenes</span>')
          +'</td>'
          +'<td style="text-align:right;'+pinta(tipos.indexOf('cantidad')>=0)+'">'
          +_fmtN2(f.cantidad)+'</td>'
          +'<td style="text-align:right">'+(l?_fmtN2(l.abierta):'—')+'</td>'
          +'<td style="text-align:right;'+pinta(tipos.indexOf('precio')>=0)+'">'
          +_fmtN2(f.precio)+'</td>'
          +'<td style="text-align:right">'+(l?_fmtN2(l.precio):'—')+'</td>'
          +'<td style="font-size:10.5px">'
          +(dif.length?('<span style="color:var(--t-rojo)">'
             + dif.map(function(x){ return _esc(x.txt); }).join('<br>')+'</span>'):'')
          +(avisos.length?('<div style="color:var(--text-muted)">'
             + avisos.map(function(x){ return _esc(x.txt); }).join('<br>')+'</div>'):'')
          +'</td></tr>';
      }).join('')
    +'</tbody></table></div>'
    + _fipSinOrdenHtml()
    + _fipMedidasHtml()
    + _fipTotalesHtml()
    +'</div>';
}

/* ¿La factura reserva va a salir por otro importe que la factura? (v730)
   Este cuadro suma cantidad x precio DE LA FACTURA; el «Importe» verde de
   abajo suma las líneas de la factura reserva, que llevan el precio DE LA
   ORDEN salvo que se marque «Usar el precio de la factura». Si en alguna
   línea los dos precios no coinciden, los dos totales no cuadran y la
   factura reserva iría por el importe de la orden. Se dice cuáles y cuánto. */
function _fipPreciosDistintosHtml(){
  var S=window._fip, d=window._fr;
  if(!S || !d) return '';
  var dif=[], total=0;
  (S.filas||[]).forEach(function(f){
    if(f.linea<0) return;
    var l=d.lineas[f.linea]; if(!l) return;
    var pf=Number(f.precio)||0, pl=Number(l.precio)||0;
    if(!(pf>0) || Math.abs(pf-pl)<0.00005) return;
    var q=Number(l.cantidad)||Number(f.cantidad)||0;
    var imp=Math.round((pl-pf)*q*100)/100;
    total+=imp;
    dif.push({ref:l.itemcode||f.ref||'', orden:l.docnum, pl:pl, pf:pf, q:q, imp:imp});
  });
  if(!dif.length) return '';
  total=Math.round(total*100)/100;
  return '<div style="margin-top:8px;border:1px solid #F59E0B;background:var(--pastel-aviso);border-radius:8px;'
    +'padding:8px 10px;font-size:11.5px;color:var(--t-marron)">'
    +'<b><i class="ti ti-alert-triangle"></i> '+dif.length+' línea(s) con precio distinto en la orden y en la factura.</b> '
    +'La factura reserva irá con el precio de la <b>orden</b>: '+(total>0?'+':'−')+_fmtN2(Math.abs(total))
    +' respecto a la factura del proveedor (por eso el «Importe» de abajo no es igual a este total).'
    +'<table style="width:100%;border-collapse:collapse;margin-top:6px;font-size:11px">'
    +'<tr style="text-align:left"><th>Artículo</th><th>Orden</th><th style="text-align:right">Piezas</th>'
    +'<th style="text-align:right">Precio orden</th><th style="text-align:right">Precio factura</th>'
    +'<th style="text-align:right">Diferencia</th></tr>'
    + dif.map(function(x){
        return '<tr><td><b>'+_esc(x.ref)+'</b></td><td>#'+_esc(x.orden)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(x.q)+'</td>'
          +'<td style="text-align:right">'+x.pl.toFixed(4).replace(/0{1,2}$/,'')+'</td>'
          +'<td style="text-align:right">'+x.pf.toFixed(4).replace(/0{1,2}$/,'')+'</td>'
          +'<td style="text-align:right;font-weight:700">'+(x.imp>0?'+':'−')+_fmtN2(Math.abs(x.imp))+'</td></tr>'; }).join('')
    +'</table>'
    +'<div style="display:flex;gap:8px;align-items:center;margin-top:7px;flex-wrap:wrap">'
    +'<button class="xb" style="background:#B45309;color:#fff;border-color:#B45309" onclick="_fipUsarPreciosFactura()">'
    +'<i class="ti ti-arrows-exchange"></i> Usar el precio de la factura en estas líneas</button>'
    +'<span style="font-size:10.5px">Si el bueno es el de la orden, déjalo así: es el proveedor quien tiene que corregir su factura.</span>'
    +'</div></div>';
}

function _fipUsarPreciosFactura(){
  var S=window._fip, d=window._fr; if(!S||!d) return;
  var n=0;
  (S.filas||[]).forEach(function(f){
    if(f.linea<0 || !(Number(f.precio)>0)) return;
    var l=d.lineas[f.linea]; if(!l) return;
    if(Math.abs((Number(l.precio)||0)-Number(f.precio))>=0.00005){ l.precio=Number(f.precio); n++; }
  });
  S.usarPrecio=true;
  try{ rFactReserva(); }catch(e){}
  showT('✓ '+n+' línea(s) con el precio de la factura: el importe ya cuadra con ella');
}

// Los totales tal como los presenta la factura: por cada orden (su PI), la
// suma de todas ellas, y aparte el flete y los demás gastos, que se suman o
// no según se marquen.
function _fipTotalesHtml(){
  var S=window._fip, d=window._fr;
  var por={}, sinOrden={u:0, i:0, n:0};
  S.filas.forEach(function(f){
    var l=f.linea>=0?d.lineas[f.linea]:null;
    var imp=(Number(f.cantidad)||0)*(Number(f.precio)||0);
    if(!l){ sinOrden.u+=Number(f.cantidad)||0; sinOrden.i+=imp; sinOrden.n++; return; }
    var k=String(l.docnum);
    var a=por[k]||(por[k]={docnum:k, dkc:_fipDkcDeOrden(k)||f.pi||'', n:0, u:0, i:0});
    a.n++; a.u+=Number(f.cantidad)||0; a.i+=imp;
  });
  var claves=Object.keys(por);
  if(!claves.length && !sinOrden.n) return '';
  var tot={n:0,u:0,i:0};
  claves.forEach(function(k){ tot.n+=por[k].n; tot.u+=por[k].u; tot.i+=por[k].i; });

  var cargos=S.cargos||[];
  var sumaCargos=cargos.reduce(function(a,c){ return a+(c.inc?(Number(c.monto)||0):0); },0);
  var granTotal=tot.i+sinOrden.i+sumaCargos;

  var difFob = S.fobDeclarado ? (tot.i+sinOrden.i)-S.fobDeclarado : 0;

  return '<div style="margin-top:10px;border:0.5px solid var(--border);border-radius:9px;'
    +'background:var(--surface-0);padding:10px 12px">'
    + _fipEmbarqueHtml()
    +'<div style="font-size:12px;font-weight:700;margin-bottom:6px">'
    +'<i class="ti ti-sum"></i> Totales de la factura, orden por orden</div>'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-1)">'
    +'<th style="text-align:left;padding:4px 6px">Orden</th>'
    +'<th style="text-align:left">PI · DKC</th>'
    +'<th style="text-align:right">Referencias</th>'
    +'<th style="text-align:right">Unidades</th>'
    +'<th style="text-align:right">Importe</th>'
    +'<th style="text-align:left">Ref. de la factura reserva</th>'
    +'<th></th></tr></thead><tbody>'
    + claves.sort(function(a,b){ return por[b].i-por[a].i; }).map(function(k){
        var a=por[k];
        return '<tr style="border-top:0.5px solid var(--border)">'
          +'<td style="padding:3px 6px"><b>#'+_esc(a.docnum)+'</b></td>'
          +'<td>'+_esc(a.dkc||'—')+'</td>'
          +'<td style="text-align:right">'+a.n+'</td>'
          +'<td style="text-align:right">'+_fmtN2(a.u)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(a.i)+'</td>'
          +'<td><b>'+_esc(_fipRefFactura(a.docnum)||'—')+'</b></td>'
          +'<td><button class="xb" style="font-size:10.5px;padding:2px 8px" '
          +'onclick="_fipSoloOrden(\''+a.docnum+'\')">Dejar solo esta</button></td></tr>';
      }).join('')
    +(sinOrden.n?('<tr style="border-top:0.5px solid var(--border);color:var(--t-rojo)">'
      +'<td style="padding:3px 6px">sin orden</td><td>—</td>'
      +'<td style="text-align:right">'+sinOrden.n+'</td>'
      +'<td style="text-align:right">'+_fmtN2(sinOrden.u)+'</td>'
      +'<td style="text-align:right">'+_fmtN2(sinOrden.i)+'</td><td colspan="2"></td></tr>'):'')
    +'</tbody><tfoot><tr style="font-weight:700;background:var(--surface-1)">'
    +'<td colspan="2" style="padding:4px 6px">SUMA DE LAS ÓRDENES (FOB)</td>'
    +'<td style="text-align:right">'+(tot.n+sinOrden.n)+'</td>'
    +'<td style="text-align:right">'+_fmtN2(tot.u+sinOrden.u)+'</td>'
    +'<td style="text-align:right">'+_fmtN2(tot.i+sinOrden.i)+'</td>'
    +'<td colspan="2"></td></tr></tfoot></table>'
    + (S.fobDeclarado?('<div style="font-size:10.5px;margin-top:4px;color:'
        +(Math.abs(difFob)<=0.05?'var(--t-verde)':'var(--t-rojo)')+'">'
        +'La factura declara FOB '+_fmtN2(S.fobDeclarado)
        +(S.qtyDeclarada?(' · '+_fmtN2(S.qtyDeclarada)+' pzas'):'')
        +(Math.abs(difFob)<=0.05?' · cuadra':' · difiere en '+_fmtN2(difFob))+'</div>'):'')
    + _fipPreciosDistintosHtml()
    + (cargos.length?('<div style="margin-top:8px;border-top:0.5px solid var(--border);'
        +'padding-top:7px"><div style="font-size:11px;color:var(--text-muted);'
        +'margin-bottom:4px">Flete y gastos adicionales · marca lo que quieras sumar</div>'
        + cargos.map(function(c,i){
            // El concepto se ELIGE de los gastos dados de alta en SAP: si se
            // escribe a mano, SAP rechaza el nombre y la factura se queda a
            // medias. El flete viene propuesto según el departamento.
            var lista=_fipGastosLista();
            var suyo=String(c.concepto||'');
            var enLista=lista.some(function(g){
              return g.toUpperCase()===suyo.toUpperCase(); });
            return '<label style="display:flex;align-items:center;gap:7px;margin-bottom:3px;'
              +'font-size:11.5px"><input type="checkbox"'+(c.inc?' checked':'')
              +' onchange="window._fip.cargos['+i+'].inc=this.checked;_fipPintar()"> '
              +'<select onchange="window._fip.cargos['+i+'].concepto=this.value;_fipPintar()" '
              +'style="flex:1;min-width:170px;font-size:11.5px;padding:3px 6px;'
              +'border:0.5px solid var(--border);border-radius:6px;'
              +'background:var(--surface-0);color:var(--text-primary)">'
              +(enLista?'':('<option value="'+_esc(suyo)+'" selected>'+_esc(suyo)
                 +' (no está en SAP)</option>'))
              + lista.map(function(g){
                  return '<option value="'+_esc(g)+'"'
                    +(g.toUpperCase()===suyo.toUpperCase()?' selected':'')+'>'
                    +_esc(g)+'</option>'; }).join('')
              +'</select>'
              +' <input type="number" step="any" value="'+(c.monto||0)+'" '
              +'onchange="window._fip.cargos['+i+'].monto=Number(this.value)||0;_fipPintar()" '
              +'style="width:110px;text-align:right;padding:3px 6px;border:0.5px solid '
              +'var(--border);border-radius:6px;background:var(--surface-2);'
              +'color:var(--text-primary)"></label>';
          }).join('')
        +'<button class="xb" style="font-size:10.5px;padding:2px 8px;margin-top:3px" '
        +'onclick="_fipAddCargo()"><i class="ti ti-plus"></i> Añadir gasto</button>'
        +'</div>')
      :('<div style="margin-top:8px;border-top:0.5px solid var(--border);padding-top:7px">'
        +'<button class="xb" style="font-size:10.5px;padding:2px 8px" '
        +'onclick="_fipAddCargo()"><i class="ti ti-plus"></i> Añadir flete o gasto</button>'
        +'</div>'))
    +'<div style="display:flex;align-items:center;gap:10px;margin-top:8px;'
    +'border-top:0.5px solid var(--border);padding-top:7px">'
    +'<div style="flex:1;font-size:12px;font-weight:700">'
    +(sumaCargos?'TOTAL CON FLETE Y GASTOS':'TOTAL DE LAS ÓRDENES')+'</div>'
    +'<div style="font-size:17px;font-weight:800">'+_fmtN2(granTotal)+'</div>'
    +'<button class="xb" onclick="_fipPonerTotal()" title="Lo pone como total de la '
    +'factura y reparte por orden">Usar en el reparto</button></div>'
    + (S.cifDeclarado?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">'
        +'La factura declara CIF '+_fmtN2(S.cifDeclarado)+'</div>'):'')
    +'</div>';
}

// Lleva estos totales al reparto entre las órdenes de arriba
function _fipPonerTotal(){
  var S=window._fip, d=window._fr;
  var por={}, suma=0, cargos=(S.cargos||[]).reduce(function(a,c){
    return a+(c.inc?(Number(c.monto)||0):0); },0);
  S.filas.forEach(function(f){
    if(f.linea<0) return;
    var l=d.lineas[f.linea];
    var imp=(Number(f.cantidad)||0)*(Number(f.precio)||0);
    por[String(l.docnum)]=(por[String(l.docnum)]||0)+imp;
    suma+=imp;
  });
  d._reparto={};
  Object.keys(por).forEach(function(k){
    // El flete y los gastos se reparten a prorrata de lo que pesa cada orden
    var extra = suma>0 ? cargos*(por[k]/suma) : 0;
    d._reparto[k]=Math.round((por[k]+extra)*100)/100;
  });
  d.total_factura=Math.round((suma+cargos)*100)/100;
  try{ rFactReserva(); }catch(e){}
  showT('✓ Total y reparto puestos desde la factura'
    +(cargos?' (flete y gastos repartidos a prorrata)':''));
}

function _fipCambiarOrden(i, idx){
  var S=window._fip; if(!S||!S.filas[i]) return;
  S.filas[i].linea=Number(idx);
  S.aplicado=false;
  _fipPintar();
}

// Pasa lo leído a las líneas de la factura reserva
// Deja en la factura reserva SOLO lo que viene en la factura del proveedor:
// las líneas de las órdenes que no estén en el documento se quitan, no se
// dejan en cero. Lo quitado queda guardado para el reporte al proveedor.
function _fipAplicar(callado){
  var S=window._fip, d=window._fr;
  if(!S||!d) return;
  // Copia de cómo estaba la pantalla, por si se aborta el proceso
  if(!S.previas){
    S.previas={lineas:d.lineas.map(function(l){ return Object.assign({}, l); }),
               ordenes:(d.ordenes||[]).slice(),
               numatcard:d.numatcard, total:d.total_factura};
  }
  var puestas=0, sobran=0, quitadas=0;
  var nuevas=[];
  S.filas.forEach(function(f){
    if(f.linea<0) return;                       // sin orden: no se puede facturar
    var l=d.lineas[f.linea];
    if(!l || l._fipUsada) return;               // la misma línea no va dos veces
    var c=Number(f.cantidad)||0;
    // Antes se recortaba a lo pendiente en la orden y los totales de la
    // pantalla ya no cuadraban con la factura. Se deja lo que dice el
    // documento; si se pasa, se marca y el envío a SAP lo avisa.
    if(c>l.abierta+0.0001) sobran++;
    l.cantidad=c;
    l._fipPasada=(c>l.abierta+0.0001);
    if(S.usarPrecio && f.precio>0) l.precio=f.precio;
    // Bultos, peso y cubicaje del packing list, que es lo que de verdad vino
    var pk=(S.packing||{})[f.clave];
    var med=pk?_fipMedidas(pk):null;
    if(f.bultos>0) l._fipBultos=f.bultos;
    if(pk && pk.bultos>0) l._fipBultos=pk.bultos;
    if(pk){
      // Las piezas por bulto que dice el packing (las de las cajas
      // completas). Antes el empaque se sacaba dividiendo piezas entre
      // bultos, y con la caja parcial salían cosas como 23 X 1 o 25 X 1
      // donde el empaque real es 24.
      if(pk.piezas_x_bulto>0) l._fipPxb=pk.piezas_x_bulto;
      // El peso y el cubicaje de la pantalla salen del TOTAL que declara el
      // packing para esa referencia, repartido según lo que factura la
      // línea. Así las tarjetas cuadran con el pie del packing list, que es
      // lo que hay que casar con el BL y con el flete. Lo que sube a la
      // ficha de SAP sigue siendo el valor por pieza de los cartones
      // completos, que es el dato limpio.
      l._fipPesoTotal=Number(pk.kilos)||0;
      l._fipPcubTotal=Number(pk.pie3)||0;
      l._fipQtyPk=Number(pk.cantidad)||0;
    }
    if(med){
      if(med.peso_pieza_kg>0) l._fipPesoUnit=med.peso_pieza_kg;
      if(med.vol_pieza_pie3>0) l._fipPcubUnit=med.vol_pieza_pie3;
    }
    l._fipUsada=true;
    nuevas.push(l);
    puestas++;
  });
  if(!nuevas.length){
    showT('Ninguna referencia de la factura casó con una línea de las órdenes: '
      +'no quito nada.');
    return;
  }
  quitadas=d.lineas.length-nuevas.length;
  nuevas.forEach(function(l){ delete l._fipUsada; });
  d.lineas=nuevas;
  // Las órdenes que quedan son las de esas líneas
  // Las órdenes que quedan, CON su DKC: el reparto de arriba espera objetos
  // {docnum, numatcard}. Al dejarlas como texto, el recuadro salía vacío.
  var antes=(S.previas&&S.previas.ordenes)||d.ordenes||[];
  var nums=[...new Set(nuevas.map(function(l){ return String(l.docnum); }))];
  d.ordenes=nums.map(function(k){
    var o=antes.filter(function(x){ return x && String(x.docnum)===k; })[0];
    return o || {docnum:k, numatcard:_fipDkcDeFilas(k)};
  });
  setTimeout(_frCompletarFotos, 60);

  // Los índices cambiaron: se vuelven a apuntar para que la tabla siga bien
  S.filas.forEach(function(f){
    if(f.linea<0) return;
    var l=d.lineas.filter(function(x){
      return String(x.itemcode).trim().toUpperCase()===String(f.itemcode).trim().toUpperCase()
          || _ocNormSku(x.itemcode)===f.clave; })[0];
    f.linea = l ? d.lineas.indexOf(l) : -1;
    f.candidatos = f.linea>=0 ? [f.linea] : [];
  });

  S.aplicado=true;
  // v756: el cuadro de medidas (lo revisable) manda sobre las líneas
  try{ _fipMedidasLista(); _fipSyncDesdeMedidas(); }catch(e){}
  try{ rFactReserva(); }catch(e){}
  if(callado) return;
  showT('✓ '+puestas+' línea(s) de la factura'
    +(quitadas?(' · se quitaron '+quitadas+' línea(s) de las órdenes que no vienen en '
      +'el documento'):'')
    +(sobran?(' · OJO: '+sobran+' piden más de lo que queda pendiente en la orden'):'')
    +'. Recuerda: una factura reserva por cada orden.');
}

// ── El reporte de diferencias para el proveedor ───────────────────────────
function _fipReporte(){
  var S=window._fip, d=window._fr;
  if(!S||!S.filas.length) return;
  var lista=[];
  S.filas.forEach(function(f){
    var l=f.linea>=0?d.lineas[f.linea]:null;
    _fipDifs(f).forEach(function(x){
      lista.push({inc:true, orden:l?l.docnum:'', itemcode:f.itemcode,
                  nombre:f.nombre||(l?l.dscription:''), tipo:x.t, texto:x.txt,
                  oc:x.oc!=null?x.oc:'', fac:x.fac!=null?x.fac:''});
    });
  });
  (S.faltanInfo||[]).forEach(function(l){
    lista.push({inc:true, orden:l.docnum, itemcode:l.itemcode, nombre:l.dscription,
                tipo:'no_facturada',
                texto:'está en la orden y no viene en la factura (pendiente '
                      +_fmtN2(l.abierta)+')', oc:l.abierta, fac:0});
  });
  if(!lista.length){ showT('No hay diferencias que reportar'); return; }
  window._fipRep=lista;

  var ov=document.createElement('div');
  ov.id='modalFipRep';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10064;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1000px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="fipRepCuerpo"></div></div>';
  document.body.appendChild(ov);
  _fipRepPintar();
}

function _fipRepCerrar(){
  var m=document.getElementById('modalFipRep'); if(m) m.remove();
}

var FIP_TIPOS={precio:'Precio distinto', cantidad:'Cantidad fuera del 10%',
               packing:'Factura y packing no cuadran', sin_orden:'No está en ninguna orden',
               no_facturada:'De la orden, no facturada'};

function _fipRepPintar(){
  var c=document.getElementById('fipRepCuerpo'); if(!c) return;
  var L=window._fipRep||[];
  var n=L.filter(function(x){ return x.inc; }).length;
  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-report-search" style="font-size:20px;color:var(--t-rojo)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +'Diferencias para reportar al proveedor</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Desmarca lo que no quieras '
    +'reportar. Se exporta solo lo marcado: <b>'+n+'</b> de '+L.length+'.</div></div>'
    +'<button class="xb" onclick="_fipRepCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<div style="display:flex;gap:7px;margin-bottom:8px">'
    +'<button class="xb" onclick="_fipRepTodas(true)">Marcar todas</button>'
    +'<button class="xb" onclick="_fipRepTodas(false)">Desmarcar todas</button></div>'
    +'<div class="tbx-box" style="max-height:52vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:34px"></th><th style="width:85px">Orden</th>'
    +'<th style="width:130px">Referencia</th><th>Descripción</th>'
    +'<th style="width:150px">Tipo</th><th>Detalle</th></tr></thead><tbody>'
    + L.map(function(x,i){
        return '<tr><td><input type="checkbox"'+(x.inc?' checked':'')
          +' onchange="window._fipRep['+i+'].inc=this.checked;_fipRepPintar()"></td>'
          +'<td>'+(x.orden?('#'+_esc(x.orden)):'—')+'</td>'
          +'<td><b>'+_esc(x.itemcode)+'</b></td>'
          +'<td style="font-size:11px">'+_esc(String(x.nombre||'').slice(0,40))+'</td>'
          +'<td style="font-size:11px">'+_esc(FIP_TIPOS[x.tipo]||x.tipo)+'</td>'
          +'<td style="font-size:11px">'+_esc(x.texto)+'</td></tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="display:flex;gap:8px;margin-top:12px;justify-content:flex-end">'
    +'<button class="btn bg2" onclick="_fipRepCerrar()" style="padding:9px 14px">Cerrar</button>'
    +'<button class="btn bg2" onclick="_fipRepExcel()" style="padding:9px 14px">'
    +'<i class="ti ti-file-spreadsheet"></i> Exportar a Excel</button>'
    +'<button class="btn bp" onclick="_fipRepPDF()" style="padding:9px 16px">'
    +'<i class="ti ti-printer"></i> Reporte en PDF</button></div>';
}

function _fipRepTodas(v){
  (window._fipRep||[]).forEach(function(x){ x.inc=!!v; });
  _fipRepPintar();
}

function _fipRepSeleccion(){
  return (window._fipRep||[]).filter(function(x){ return x.inc; });
}

function _fipRepExcel(){
  var L=_fipRepSeleccion();
  if(!L.length){ showT('No hay nada marcado'); return; }
  if(typeof XLSX==='undefined'){ showT('No está cargado el lector de Excel'); return; }
  var d=window._fr||{};
  var filas=L.map(function(x){
    return {'Orden de compra':x.orden?('#'+x.orden):'', 'Referencia':x.itemcode,
            'Descripción':x.nombre, 'Tipo de diferencia':FIP_TIPOS[x.tipo]||x.tipo,
            'Según la orden':x.oc, 'Según la factura':x.fac, 'Detalle':x.texto};
  });
  var hoja=XLSX.utils.json_to_sheet(filas);
  var libro=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, 'Diferencias');
  var nombre='Diferencias_'+(d.cardcode||'proveedor')+'_'+_hoyISO()+'.xlsx';
  XLSX.writeFile(libro, nombre);
  showT('✓ '+L.length+' diferencia(s) exportadas');
}

function _fipRepPDF(){
  var L=_fipRepSeleccion();
  if(!L.length){ showT('No hay nada marcado'); return; }
  var d=window._fr||{};
  var w=window.open('','_blank');
  if(!w){ showT('El navegador bloqueó la ventana'); return; }
  w.document.write('<html><head><meta charset="utf-8"><title>Diferencias '
    +_esc(d.cardcode||'')+'</title>'
    +'<style>body{font-family:Arial,Helvetica,sans-serif;padding:26px;color:#111}'
    +'h1{font-size:18px;margin:0 0 4px}h2{font-size:12px;font-weight:400;color:#555;margin:0 0 16px}'
    +'table{width:100%;border-collapse:collapse;font-size:11px}'
    +'th{background:#eef2f7;text-align:left;padding:6px;border:1px solid #cbd5e1}'
    +'td{padding:5px 6px;border:1px solid #e2e8f0}'
    +'.noprint{margin-top:18px}@media print{.noprint{display:none}}</style></head><body>'
    +'<h1>KENNEDY CENTER CORP · Diferencias encontradas</h1>'
    +'<h2>Proveedor: '+_esc(d.cardname||d.cardcode||'')
    +' · Fecha: '+_esc(_fechaCorta(_hoyISO()))
    +' · '+L.length+' diferencia(s)</h2>'
    +'<table><thead><tr><th>Orden de compra</th><th>Referencia</th><th>Descripción</th>'
    +'<th>Tipo</th><th>Según la orden</th><th>Según la factura</th><th>Detalle</th></tr></thead><tbody>'
    + L.map(function(x){
        return '<tr><td>'+(x.orden?('#'+_esc(x.orden)):'')+'</td><td>'+_esc(x.itemcode)+'</td>'
          +'<td>'+_esc(x.nombre||'')+'</td><td>'+_esc(FIP_TIPOS[x.tipo]||x.tipo)+'</td>'
          +'<td>'+_esc(x.oc)+'</td><td>'+_esc(x.fac)+'</td><td>'+_esc(x.texto)+'</td></tr>';
      }).join('')
    +'</tbody></table>'
    +'<div class="noprint"><button onclick="window.print()" style="background:#0c447c;color:#fff;'
    +'border:none;border-radius:7px;padding:9px 18px;font-size:13px;cursor:pointer">'
    +'Imprimir o guardar como PDF</button></div></body></html>');
  w.document.close();
}

/* ── Los datos generales del embarque, a los campos de la factura en SAP ──
   De la factura del proveedor salen barco, BL, marcas, tipo de contenedor y
   la fecha de la factura. La ETA es la del BL y, si no la dice, 40 días
   después de la factura, que es el promedio de Kennedy. Todo eso se pone en
   los campos de usuario de la factura reserva (los que baja el worker de
   CUFD) y en el vencimiento, que es donde SAP guarda la ETA. */
function _fipPonerDatosEmbarque(){
  var S=window._fip, d=window._fr;
  var e=S && S.embarque;
  if(!e || !d) return;
  d.udf=d.udf||{};

  if(e.eta && !d.docduedate) d.docduedate=e.eta;
  if(S.numeroFactura && !d.num_factura) d.num_factura=S.numeroFactura;

  var campos=(window._fruCampos||[]);
  var poner=function(re, valor){
    if(!valor) return;
    var c=campos.filter(function(x){ return re.test(_fruClave(x.titulo)); })[0];
    if(!c || d.udf[c.alias]) return;
    if((c.opciones||[]).length){
      // Si el campo es de lista, se busca el valor que más se le parezca
      var v=String(valor).toUpperCase();
      var op=c.opciones.filter(function(o){
        var t=String(o.t||o.v).toUpperCase();
        return v.indexOf(t)>=0 || t.indexOf(v)>=0; })[0];
      if(op) d.udf[c.alias]=op.v;
      return;
    }
    d.udf[c.alias]=String(valor).slice(0, c.largo||100);
  };
  poner(/^barco/, e.barco);
  poner(/^bl/, e.bl);
  poner(/^marca/, e.marca);
  poner(/contenedor/, e.contenedor);
  poner(/naviera/, e.naviera || _fipNaviera(e.bl));
  poner(/puerto/, e.puerto);
  try{ _fruPintar(); }catch(x){}
}

// La naviera por el prefijo del BL, que es como se reconoce a simple vista
var FIP_NAVIERAS={EGLV:'EVERGREEN', MAEU:'MAERSK', MSCU:'MSC', COSU:'COSCO',
                  OOLU:'OOCL', HLCU:'HAPAG LLOYD', CMDU:'CMA CGM', ONEY:'ONE',
                  YMLU:'YANG MING', HDMU:'HMM', ZIMU:'ZIM'};
function _fipNaviera(bl){
  var t=String(bl||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
  var k=t.slice(0,4);
  return FIP_NAVIERAS[k]||'';
}

/* ── Una factura reserva por orden, con su letra ──────────────────────────
   Cuando una sola factura del proveedor da varias facturas reserva, el
   Vendor Ref. No. de cada una es el número de la factura con una letra al
   final: C2953-A, C2953-B, C2953-C… así se distinguen en SAP. */
function _fipLetraOrden(docnum){
  var S=window._fip, d=window._fr;
  var ords=[...new Set((S.filas||[]).filter(function(f){ return f.linea>=0; })
    .map(function(f){ return String(d.lineas[f.linea].docnum); }))].sort();
  var i=ords.indexOf(String(docnum));
  if(i<0) return '';
  // Con UNA sola orden va el número de factura tal cual, sin letra: la letra
  // solo sirve para distinguir las partes de una factura repartida.
  if(ords.length<2) return '';
  return String.fromCharCode(65+i);           // A, B, C…
}

/* El Vendor Ref. No. de SAP es el NÚMERO DE FACTURA DEL PROVEEDOR con su
   letra pegada: VI-1104A, VI-1104B… Nunca el DKC ni el HIKC, que son
   nuestros. Si la factura no trae número legible, se pregunta. */
/* El número de factura del proveedor: el que se escribió arriba, en «N.º de
   factura del proveedor», manda; si no, el que se leyó de la factura (v728).
   Antes solo se miraba lo leído, y aunque estuviera escrito arriba se volvía
   a preguntar antes de crear las facturas reserva. */
function _fipNumeroFactura(){
  var S=window._fip||{}, d=window._fr||{};
  var el=document.getElementById('frNumFact');
  var escrito=String((el&&el.value)||d.num_factura||'').trim();
  if(escrito){ d.num_factura=escrito; return escrito; }
  return String(S.numeroFactura||'').trim();
}

function _fipRefFactura(docnum){
  var num=_fipNumeroFactura();
  if(!num) return '';
  var l=_fipLetraOrden(docnum);
  return num+(l||'');
}

// Se asegura de tener el número de factura del proveedor antes de crear
function _fipPedirNumeroFactura(){
  var S=window._fip; if(!S) return '';
  var num=_fipNumeroFactura();
  if(num) return num;
  var v=prompt('¿Cuál es el NÚMERO DE FACTURA DEL PROVEEDOR?\n\n'
    +'Es lo que va en el Vendor Ref. No. de SAP, con su letra al final por '
    +'cada orden: VI-1104A, VI-1104B…\n\n'
    +'No lo pude leer de la factura.');
  v=String(v||'').trim();
  if(v){
    S.numeroFactura=v;
    // Y se queda escrito arriba: no se vuelve a preguntar en la siguiente orden
    if(window._fr) window._fr.num_factura=v;
    var el=document.getElementById('frNumFact'); if(el) el.value=v;
  }
  return v;
}

// Deja en la pantalla solo una de las órdenes, lista para crear su factura
function _fipSoloOrden(docnum){
  var S=window._fip, d=window._fr;
  if(!S||!d) return;
  if(!S.aplicado) _fipAplicar(true);
  var ref=_fipRefFactura(docnum);
  S.guardadas=S.guardadas||{};
  d.lineas.forEach(function(l){
    if(String(l.docnum)!==String(docnum)) S.guardadas[String(l.docnum)]=true;
  });
  d.lineas=d.lineas.filter(function(l){ return String(l.docnum)===String(docnum); });
  d.ordenes=(d.ordenes||[]).filter(function(o){ return String(o.docnum)===String(docnum); });
  if(ref) d.numatcard=ref;
  d._reparto={};
  d.total_factura=d.lineas.reduce(function(a,l){
    return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
  try{ rFactReserva(); }catch(e){}
  showT('Lista la factura reserva de la orden #'+docnum
    +(ref?(' · Vendor Ref. No. '+ref):'')
    +'. Al crearla, vuelve a cargar la factura para la siguiente orden.');
}

// Lo que se sacó de la cabecera de la factura, para verlo de un vistazo
function _fipEmbarqueHtml(){
  var S=window._fip, e=S&&S.embarque;
  if(!e || !Object.keys(e).length) return '';
  var dato=function(t,v,extra){
    if(!v) return '';
    return '<span style="background:var(--surface-1);border-radius:7px;padding:2px 8px">'
      +'<span style="color:var(--text-muted)">'+t+':</span> <b>'+_esc(v)+'</b>'
      +(extra||'')+'</span>';
  };
  return '<div style="display:flex;gap:6px;flex-wrap:wrap;font-size:10.5px;margin-bottom:8px">'
    + dato('Factura', S.numeroFactura)
    + dato('Fecha', e.fecha?_fechaCorta(e.fecha):'')
    + dato('Barco', e.barco)
    + dato('BL', e.bl)
    + dato('Naviera', _fipNaviera(e.bl))
    + dato('Contenedor', e.contenedor)
    + dato('Marcas', e.marca)
    + dato('Bultos', e.bultos?_fmtN2(e.bultos):'')
    + dato('ETA', e.eta?_fechaCorta(e.eta):'',
        e.eta_estimada?' <span style="color:var(--t-marron)">(estimada, 40 días)</span>':'')
    +'<span style="color:var(--text-muted)">· puestos en los campos del embarque '
    +'y en el vencimiento</span></div>';
}

/* ── Las medidas del packing list, a la ficha del artículo en SAP ─────────
   Cubicaje por pieza (BVolume y SVolume), cubicaje por bulto (U_CxBlt),
   peso por pieza (peso de compra y de venta), peso por bulto (U_PxBlt) y la
   medida del cartón. Todo en pies cúbicos y kilos. */
/* La tabla de medidas sirve a DOS pantallas (v713): la factura reserva
   (sin contexto, como siempre) y la venta directa por proforma (cx='vd').
   Cada una guarda sus medidas en su propio estado, así abrir una no pisa a
   la otra aunque las dos estén a medias. */
function _fipMedEstado(cx){
  return cx==='vd' ? window._vdP : window._fip;
}
function _fipMedRepintar(cx){
  if(cx==='vd'){ try{ _vdpPintar(); }catch(e){} }
  else _fipPintar();
}
function _fipMedArg(cx){ return cx ? (",'"+cx+"'") : ''; }

function _fipMedidasLista(cx){
  var S=_fipMedEstado(cx);
  if(!S) return [];
  // Se calculan una vez y a partir de ahí se pueden editar a mano
  if(!S.medidas){
    S.medidas=Object.keys(S.packing||{}).map(function(k){
      var m=_fipMedidas(S.packing[k]);
      if(!m) return null;
      m.clave=k;
      if(cx==='vd'){
        m.sap=_vdpRefDeClave(k);
      } else {
        var f=(S.filas||[]).filter(function(x){ return x.clave===k; })[0];
        var d=window._fr;
        m.sap=(f && f.linea>=0) ? d.lineas[f.linea].itemcode : '';
      }
      return m;
    }).filter(function(m){ return m; });
  }
  return S.medidas;
}

var FIP_MED_COLS=[
  {k:'itemcode',       t:'Referencia',    w:130},
  {k:'sap',            t:'Artículo en SAP', w:140},
  {k:'cantidad',       t:'Pzas',          w:70,  num:0},
  {k:'bultos',         t:'Bultos',        w:70,  num:0},
  {k:'piezas_x_bulto', t:'Pzas/bulto',    w:80,  num:2},
  {k:'vol_pieza_pie3', t:'Pies³ pieza',   w:90,  num:4},
  {k:'vol_bulto_pie3', t:'Pies³ bulto',   w:90,  num:3},
  {k:'peso_pieza_kg',  t:'Kg pieza',      w:85,  num:4},
  {k:'peso_bulto_kg',  t:'Kg bulto',      w:85,  num:2},
  {k:'medida_carton',  t:'Medida del cartón', w:130}
];

/* v756: lo que se corrige en «Medidas del packing list» pasa a las líneas
   de la factura reserva (peso, cubicaje y bultos). Antes cada cuadro tenía
   sus propios números: las líneas usaban los totales crudos del packing y
   corregir el cuadro de medidas no cambiaba nada. Ahora el cuadro, que es
   lo revisado, manda: peso y cubicaje = lo de la pieza × las piezas de la
   línea, y bultos = piezas / piezas por bulto (redondeado hacia arriba). */
function _fipSyncDesdeMedidas(){
  var S=window._fip, d=window._fr;
  if(!S || !d || !d.lineas || !S.medidas) return 0;
  var por={};
  S.medidas.forEach(function(m){
    if(m.clave) por[m.clave]=m;
    if(m.sap) por[_ocNormSku(m.sap)]=por[_ocNormSku(m.sap)]||m;
  });
  var n=0;
  d.lineas.forEach(function(l){
    var m=por[_ocNormSku(l.itemcode)];
    if(!m) return;
    var pu=Number(m.peso_pieza_kg)||0, vu=Number(m.vol_pieza_pie3)||0, pxb=Number(m.piezas_x_bulto)||0;
    if(!(pu>0 || vu>0 || pxb>0)) return;
    l._fipPesoUnit=pu>0?pu:null;
    l._fipPcubUnit=vu>0?vu:null;
    if(pxb>0) l._fipPxb=pxb;
    l._fipPesoTotal=0; l._fipPcubTotal=0;      // ya no los totales crudos del packing
    var q=Number(l.cantidad)||0;
    l._fipBultos = pxb>0 ? Math.ceil(q/pxb-0.0001) : (Number(m.bultos)||null);
    l._fipQtyPk=q;
    n++;
  });
  return n;
}

function _fipMedSet(i, campo, valor, cx){
  var L=_fipMedidasLista(cx);
  if(!L[i]) return;
  var col=FIP_MED_COLS.filter(function(c){ return c.k===campo; })[0];
  L[i][campo]= (col && col.num!=null) ? (Number(String(valor).replace(',','.'))||0)
                                      : String(valor).trim();
  if(cx==='vd' && campo==='sap'){ _vdpTrasCorregirSap(L[i]); return; }
  // Si cambian las piezas por bulto, lo de la pieza se recalcula solo
  if(campo==='piezas_x_bulto' && L[i].piezas_x_bulto>0){
    L[i].vol_pieza_pie3=L[i].vol_bulto_pie3/L[i].piezas_x_bulto;
    L[i].peso_pieza_kg=L[i].peso_bulto_kg/L[i].piezas_x_bulto;
    _fipMedRepintar(cx);
  }
  if((campo==='vol_bulto_pie3'||campo==='peso_bulto_kg') && L[i].piezas_x_bulto>0){
    L[i].vol_pieza_pie3=L[i].vol_bulto_pie3/L[i].piezas_x_bulto;
    L[i].peso_pieza_kg=L[i].peso_bulto_kg/L[i].piezas_x_bulto;
    _fipMedRepintar(cx);
  }
  // Y lo de la pieza escrito a mano: el bulto se recalcula
  if((campo==='vol_pieza_pie3'||campo==='peso_pieza_kg') && L[i].piezas_x_bulto>0){
    L[i].vol_bulto_pie3=L[i].vol_pieza_pie3*L[i].piezas_x_bulto;
    L[i].peso_bulto_kg=L[i].peso_pieza_kg*L[i].piezas_x_bulto;
    _fipMedRepintar(cx);
  }
  if(cx!=='vd'){ _fipSyncDesdeMedidas(); _frRepintarLineas(); }
}

// Repinta la factura reserva sin perder el sitio en la pantalla
function _frRepintarLineas(){
  var y=window.scrollY;
  try{ rFactReserva(); }catch(e){}
  setTimeout(function(){ window.scrollTo(0,y); },0);
}

function _fipMedidasHtml(cx){
  var L=_fipMedidasLista(cx), A=_fipMedArg(cx);
  if(!L.length) return '';
  var conSap=L.filter(function(m){ return m.sap; }).length;
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;'
    +'font-size:11.5px;padding:3px 4px;color:var(--text-primary)';
  return '<div style="margin-top:10px;border:0.5px solid var(--border);border-radius:9px;'
    +'background:var(--surface-0);padding:10px 12px">'
    +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:6px">'
    +'<div style="font-size:12px;font-weight:700"><i class="ti ti-ruler-measure"></i> '
    +'Medidas del packing list</div>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">Cubicaje en pies³ y peso en kg, '
    +'sacados de los bultos completos. Todo se puede corregir aquí antes de subirlo.</span>'
    +'<span style="flex:1"></span>'
    +'<button class="xb" onclick="_fipMedPegar('+(cx?("'"+cx+"'"):'')+')"><i class="ti ti-clipboard"></i> '
    +'Pegar desde Excel</button>'
    +(cx==='vd' ? '' : ('<button class="xb" onclick="_fipMandarMedidas()"'+(conSap?'':' disabled')+'>'
    +'<i class="ti ti-database-edit"></i> Actualizar la ficha de los artículos en SAP'
    +'</button>'))+'</div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-bottom:4px">'
    +'Se edita como un Excel: escribe en cualquier celda, o ponte en una y pega '
    +'un bloque copiado de Excel (se rellena hacia abajo y a la derecha).</div>'
    +'<div class="tbx-box" style="max-height:32vh;overflow:auto"><table class="tbx">'
    +'<thead><tr>'
    + FIP_MED_COLS.map(function(c){
        return '<th style="width:'+c.w+'px'+(c.num!=null?';text-align:right':'')+'">'
          +_esc(c.t)+'</th>'; }).join('')
    +'<th style="width:28px"></th></tr></thead><tbody>'
    + L.map(function(m,i){
        return '<tr>'
          + FIP_MED_COLS.map(function(c){
              var v=m[c.k];
              var txt = c.num!=null ? (Number(v)||0).toFixed(c.num) : (v||'');
              var rojo = (c.k==='sap' && !m.sap)
                      || (cx!=='vd' && (c.k==='piezas_x_bulto'||c.k==='cantidad'||c.k==='bultos') && !_fipMedCuadra(m));
              return '<td style="padding:0"><input value="'+_esc(txt)+'" '
                +'onchange="_fipMedSet('+i+',\''+c.k+'\',this.value'+A+')" '
                +'onpaste="_fipMedPaste(event,'+i+',\''+c.k+'\''+A+')" '
                +'onfocus="this.select();this.style.background=\'var(--bg-accent)\'" '
                +'onblur="this.style.background=\'\'" '
                +'style="'+inp+(c.num!=null?';text-align:right':'')
                +(rojo?';color:var(--t-rojo)':'')+'" '
                +(rojo?('placeholder="'+(cx==='vd'?'escribe la ref. /VD':'sin artículo')+'"'):'')+'></td>';
            }).join('')
          +'<td><button class="xb" onclick="_fipMedQuitar('+i+A+')">'
          +'<i class="ti ti-x"></i></button></td></tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
    +'Al cambiar las piezas por bulto o los valores del bulto, lo de la pieza se '
    +'recalcula solo. '+(cx==='vd'
      ? 'Las filas en rojo son del packing y no casan con ninguna referencia de la proforma: escribe en «Artículo en SAP» la referencia /VD que les toca.'
      : 'Solo se suben a SAP las filas con artículo. Las piezas, bultos o pzas/bulto en rojo no cuadran entre sí (piezas ≠ bultos × pzas/bulto): esas filas NO se suben a la ficha hasta corregirlas.')+'</div></div>';
}

/* Pegado directo en la tabla, como en un Excel: te pones en una celda,
   pegas un bloque de celdas y se rellena desde ahí hacia abajo y hacia la
   derecha, respetando el orden de las columnas. */
function _fipMedQuitar(i, cx){
  var S=_fipMedEstado(cx);
  if(S && S.medidas) S.medidas.splice(i,1);
  _fipMedRepintar(cx);
}

function _fipMedPaste(ev, fila, campo, cx){
  var texto='';
  try{ texto=(ev.clipboardData||window.clipboardData).getData('text'); }catch(e){ return; }
  if(!texto || (texto.indexOf('\t')<0 && texto.indexOf('\n')<0)) return;  // una celda: normal
  ev.preventDefault();
  var L=_fipMedidasLista(cx);
  var col0=FIP_MED_COLS.map(function(c){ return c.k; }).indexOf(campo);
  var lineas=texto.replace(/\r/g,'').split('\n').filter(function(x){ return x.trim()!==''; });
  var puestas=0;
  lineas.forEach(function(linea, r){
    var celdas=linea.split('\t');
    var m=L[fila+r];
    if(!m){
      m={clave:'', itemcode:'', sap:'', cantidad:0, bultos:0, piezas_x_bulto:0,
         vol_pieza_pie3:0, vol_bulto_pie3:0, peso_pieza_kg:0, peso_bulto_kg:0,
         medida_carton:''};
      L.push(m);
    }
    celdas.forEach(function(v, c){
      var col=FIP_MED_COLS[col0+c];
      if(!col || v==null || v==='') return;
      m[col.k]= col.num!=null ? (Number(String(v).trim().replace(',','.'))||0) : String(v).trim();
      puestas++;
    });
    if(m.piezas_x_bulto>0){
      if(m.vol_bulto_pie3>0) m.vol_pieza_pie3=m.vol_bulto_pie3/m.piezas_x_bulto;
      if(m.peso_bulto_kg>0) m.peso_pieza_kg=m.peso_bulto_kg/m.piezas_x_bulto;
    }
  });
  if(cx==='vd') L.forEach(function(m){ if(m.sap) _vdpTrasCorregirSap(m, true); });
  _fipMedRepintar(cx);
  showT('✓ '+puestas+' celda(s) pegadas en '+lineas.length+' fila(s)');
}

/* Pegar desde Excel: se pega el bloque tal cual, una fila por línea y las
   columnas separadas por tabulador. La primera columna es la referencia; si
   ya está en la tabla se actualiza, y si no, se añade. */
function _fipMedPegar(cx){
  window._fipMedPegarCx=cx||null;
  var ov=document.createElement('div');
  ov.id='modalMedPegar';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10066;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:30px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:860px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div style="font-size:15px;font-weight:700;margin-bottom:4px">Pegar las medidas '
    +'desde Excel</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:8px">'
    +'Copia las celdas en Excel y pégalas aquí. El orden de las columnas es: '
    +'<b>referencia · artículo en SAP · pzas · bultos · pzas por bulto · pies³ pieza · '
    +'pies³ bulto · kg pieza · kg bulto · medida del cartón</b>. Basta con las primeras; '
    +'lo que no venga se deja como está.</div>'
    +'<textarea id="medPegarTxt" rows="12" style="width:100%;box-sizing:border-box;'
    +'font-family:monospace;font-size:11.5px;padding:9px;border:0.5px solid var(--border);'
    +'border-radius:8px;background:var(--surface-0);color:var(--text-primary)" '
    +'placeholder="7446018&#9;BS-MF-DL10-WHT&#9;429&#9;18&#9;24&#9;0.35&#9;8.4&#9;0.22&#9;5.3&#9;60x40x50 cm"></textarea>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">'
    +'<button class="btn bg2" style="padding:8px 14px" onclick="_fipMedPegarCerrar()">'
    +'Cancelar</button>'
    +'<button class="btn bp" style="padding:8px 16px" onclick="_fipMedPegarAplicar()">'
    +'Aplicar a la tabla</button></div></div>';
  document.body.appendChild(ov);
  setTimeout(function(){ var t=document.getElementById('medPegarTxt'); if(t) t.focus(); },50);
}

function _fipMedPegarCerrar(){
  var m=document.getElementById('modalMedPegar'); if(m) m.remove();
}

function _fipMedPegarAplicar(){
  var t=document.getElementById('medPegarTxt');
  if(!t) return;
  var cx=window._fipMedPegarCx||null;
  var L=_fipMedidasLista(cx), nuevas=0, tocadas=0;
  String(t.value||'').split(/\r?\n/).forEach(function(linea){
    if(!linea.trim()) return;
    var c=linea.split(/\t|;|\|/).map(function(x){ return String(x).trim(); });
    if(c.length<2) c=linea.split(/\s{2,}/).map(function(x){ return String(x).trim(); });
    var ref=c[0];
    if(!ref || /^(referencia|style|item)$/i.test(ref)) return;      // la fila de títulos
    var m=L.filter(function(x){
      return _ocNormSku(x.itemcode)===_ocNormSku(ref)
          || _ocNormSku(x.sap)===_ocNormSku(ref); })[0];
    if(!m){
      m={clave:_ocNormSku(ref), itemcode:ref, sap:'', cantidad:0, bultos:0,
         piezas_x_bulto:0, vol_pieza_pie3:0, vol_bulto_pie3:0, peso_pieza_kg:0,
         peso_bulto_kg:0, medida_carton:''};
      L.push(m); nuevas++;
    } else tocadas++;
    FIP_MED_COLS.forEach(function(col, i){
      if(i===0 || c[i]==null || c[i]==='') return;
      m[col.k] = col.num!=null ? (Number(String(c[i]).replace(',','.'))||0) : c[i];
    });
    if(m.piezas_x_bulto>0){
      if(!m.vol_pieza_pie3 && m.vol_bulto_pie3) m.vol_pieza_pie3=m.vol_bulto_pie3/m.piezas_x_bulto;
      if(!m.peso_pieza_kg && m.peso_bulto_kg) m.peso_pieza_kg=m.peso_bulto_kg/m.piezas_x_bulto;
    }
  });
  _fipMedPegarCerrar();
  if(cx==='vd') L.forEach(function(m){ if(m.sap) _vdpTrasCorregirSap(m, true); });
  _fipMedRepintar(cx);
  showT('✓ '+tocadas+' fila(s) actualizadas'+(nuevas?(' · '+nuevas+' añadidas'):''));
}

/* v770: ¿cuadran las piezas con los cartones? Si no, las piezas por bulto
   están mal leídas, y con ellas el peso y el cubicaje POR PIEZA que irían a
   la ficha del artículo (peso del bulto ÷ piezas por bulto). Se admite hasta
   un cartón de diferencia (piezas sueltas o un cartón incompleto). */
function _fipMedCuadra(m){
  var q=Number(m.cantidad)||0, b=Number(m.bultos)||0, x=Number(m.piezas_x_bulto)||0;
  if(!(x>0)) return false;
  if(!(b>0)) return true;                       // sin cartones no hay contra qué
  return q >= (b-1)*x - 0.001 && q <= (b+1)*x + 0.001;
}

async function _fipMandarMedidas(auto, esperar){
  var todas=_fipMedidasLista().filter(function(m){
    return m.sap && (m.vol_pieza_pie3>0 || m.peso_pieza_kg>0 || m.medida_carton); });
  var malas=todas.filter(function(m){ return !_fipMedCuadra(m); });
  var L=todas.filter(function(m){ return _fipMedCuadra(m); });
  if(malas.length){
    showT('No se tocan en SAP las medidas de '+malas.length+' artículo(s) cuyas piezas no cuadran '
      +'con los cartones ('+malas.slice(0,4).map(function(m){ return m.sap; }).join(', ')
      +(malas.length>4?'…':'')+'). Revisa «Pzas/bulto» en el cuadro.', 10000);
  }
  if(!L.length){
    if(!auto) showT('No hay artículos de SAP a los que ponerles las medidas');
    return 0;
  }
  if(!auto && !confirm('Se van a actualizar en SAP las medidas de '+L.length+' artículo(s):\n\n'
    +'· cubicaje por pieza (compra y venta)\n· cubicaje por bulto (U_CxBlt)\n'
    +'· peso por pieza (compra y venta)\n· peso por bulto (U_PxBlt)\n'
    +'· medida del cartón\n\nTodo en pies cúbicos y kilos. ¿Sigo?')) return 0;
  try{
    var fila={ origen:'factura reserva', creado_por:(CU&&CU.name)||'', estado:'pendiente',
      items:L.map(function(m){
        return {itemcode:m.sap, vol_pieza_pie3:m.vol_pieza_pie3,
                vol_bulto_pie3:m.vol_bulto_pie3, peso_pieza_kg:m.peso_pieza_kg,
                peso_bulto_kg:m.peso_bulto_kg, medida_carton:m.medida_carton,
                piezas_x_bulto:m.piezas_x_bulto}; }) };
    var r=await fetch(SB+'/rest/v1/items_medidas_queue',{method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0) throw new Error('falta la tabla: corre '
        +'items_medidas.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,150));
    }
    // Si la factura va detrás, se espera a que el worker las aplique: SAP
    // toma el peso y el cubicaje de la ficha en el momento de crearla.
    if(esperar){
      var reg=((await r.json())||[])[0];
      if(reg && reg.id){
        for(var t=0;t<40;t++){                       // hasta ~2 minutos
          await new Promise(function(res){ setTimeout(res, 3000); });
          try{
            var rq=await fetch(SB+'/rest/v1/items_medidas_queue?select=estado,error_msg'
              +'&id=eq.'+reg.id,{headers:SBH});
            var f=(rq.ok?((await rq.json())||[]):[])[0];
            if(f && f.estado==='ok'){
              _dbg('[FIP] medidas aplicadas en SAP');
              break;
            }
            if(f && f.estado==='error'){
              showT('Las medidas no se pudieron poner: '+(f.error_msg||'')
                +'. La factura se crea igual.', 9000);
              break;
            }
          }catch(e){}
        }
      }
    }
    if(!auto && !esperar) showT('✓ '+L.length+' artículo(s) en cola. El worker les pone '
      +'las medidas en SAP.');
    return L.length;
  }catch(e){
    showT('No se pudieron mandar las medidas de los artículos: '+(e.message||e));
    return 0;
  }
}

/* ── Referencias de la factura que no están en ninguna orden ──────────────
   Puede ser un artículo que aún no se ha creado, o una referencia mal
   escrita en la factura. Se listan aparte para decidir: corregir la
   referencia (si al corregirla aparece en una orden, entra en la factura
   reserva), seguir sin ellas, o abortar y crear primero los artículos. */
function _fipSinOrdenHtml(){
  var S=window._fip;
  var malas=(S.filas||[]).filter(function(f){ return f.linea<0; });
  if(!malas.length) return '';
  var imp=malas.reduce(function(a,f){
    return a+((Number(f.cantidad)||0)*(Number(f.precio)||0)); },0);

  return '<div style="margin-top:10px;border:1.5px solid #E0A82E;border-radius:9px;'
    +'background:#FFFBF3;padding:10px 12px">'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);margin-bottom:3px">'
    +'<i class="ti ti-alert-triangle"></i> '+malas.length+' referencia(s) de la factura '
    +'no están pedidas en ninguna orden · '+_fmtN2(imp)+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-bottom:7px">'
    +'Corrige la referencia si está mal escrita en la factura: al cambiarla se busca '
    +'otra vez y, si aparece en alguna orden del proveedor, entra sola en la factura '
    +'reserva. Si son artículos que todavía no existen, puedes seguir sin ellas o '
    +'parar y crearlos primero.</div>'
    +'<div class="tbx-box" style="max-height:26vh;overflow:auto;background:var(--surface-0)">'
    +'<table class="tbx"><thead><tr>'
    +'<th style="width:180px">Referencia de la factura</th><th>Descripción</th>'
    +'<th style="width:80px;text-align:right">Cantidad</th>'
    +'<th style="width:80px;text-align:right">Precio</th>'
    +'<th style="width:95px">PI · DKC</th><th style="width:120px"></th></tr></thead><tbody>'
    + malas.map(function(f){
        var i=S.filas.indexOf(f);
        return '<tr><td><input value="'+_esc(f.itemcode)+'" '
          +'onchange="_fipCorregirRef('+i+',this.value)" '
          +'style="width:100%;box-sizing:border-box;font-size:12px;font-weight:600;'
          +'padding:3px 5px;border:0.5px solid var(--border);border-radius:5px;'
          +'background:var(--surface-2);color:var(--text-primary)"></td>'
          +'<td style="font-size:11px">'+_esc(String(f.nombre||'').slice(0,40))+'</td>'
          +'<td style="text-align:right">'+_fmtN2(f.cantidad)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(f.precio)+'</td>'
          +'<td style="font-size:10.5px;color:var(--text-muted)">'+_esc(f.pi||'—')+'</td>'
          +'<td><button class="xb" style="font-size:10.5px;padding:2px 8px" '
          +'onclick="_fipCorregirRef('+i+',null)">Buscar otra vez</button></td></tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px;align-items:center">'
    +(S.seguirSinEllas
      ? '<span style="font-size:11.5px;color:var(--t-verde);font-weight:600">'
        +'<i class="ti ti-check"></i> Se seguirá sin esas referencias</span>'
      : '<button class="btn bg2" style="padding:7px 12px;font-size:12px" '
        +'onclick="_fipSeguirSin()"><i class="ti ti-arrow-right"></i> '
        +'Seguir sin esas referencias</button>')
    +'<button class="btn bg2" style="padding:7px 12px;font-size:12px;color:var(--t-rojo)" '
    +'onclick="_fipAbortar()"><i class="ti ti-x"></i> Abortar y crear primero los artículos'
    +'</button></div></div>';
}

// Corrige una referencia y la vuelve a buscar en el sistema
async function _fipCorregirRef(i, valor){
  var S=window._fip, d=window._fr;
  if(!S || !S.filas[i]) return;
  var f=S.filas[i];
  if(valor!=null){
    var v=String(valor).trim();
    if(!v) return;
    // El artículo cambia de nombre: se mueve también en la lista de la factura
    var viejo=f.clave;
    f.itemcode=v; f.clave=_ocNormSku(v);
    if(S.items[viejo]){
      S.items[f.clave]=Object.assign({}, S.items[viejo], {itemcode:v});
      if(f.clave!==viejo) delete S.items[viejo];
    }
  }
  showT('Buscando '+f.itemcode+'…');
  try{
    await _fipTraducir();          // por código, referencia del proveedor o barcode
    await _fipTraerOrdenes();      // y en todas las órdenes del proveedor
  }catch(e){}
  var antes=S.aplicado;
  _fipVincular();
  var nueva=(S.filas||[]).filter(function(x){ return x.clave===f.clave; })[0];
  if(nueva && nueva.linea>=0){
    showT('✓ '+f.itemcode+' encontrada en la orden #'+d.lineas[nueva.linea].docnum
      +' · entra en la factura reserva');
    _fipAplicar(true);
  } else {
    showT(f.itemcode+' sigue sin aparecer en ninguna orden del proveedor');
    if(antes) _fipAplicar(true);
  }
  _fipPintar();
}

function _fipSeguirSin(){
  var S=window._fip; if(!S) return;
  S.seguirSinEllas=true;
  _fipAplicar(true);
  var n=(S.filas||[]).filter(function(f){ return f.linea<0; }).length;
  showT('La factura reserva se crea sin esas '+n+' referencia(s). Quedan listadas en '
    +'el reporte de diferencias para el proveedor.');
  _fipPintar();
}

// Deja la pantalla como estaba antes de cargar la factura
function _fipAbortar(){
  var S=window._fip, d=window._fr;
  if(!S||!d) return;
  if(!confirm('Se descarta lo leído de la factura y la pantalla vuelve a como estaba.\n\n'
    +'¿Sigo?')) return;
  if(S.previas){
    d.lineas=S.previas.lineas;
    d.ordenes=S.previas.ordenes;
    d.numatcard=S.previas.numatcard;
    d.total_factura=S.previas.total;
    d._reparto={};
  }
  window._fip=_fipNuevo();
  try{ rFactReserva(); }catch(e){}
  showT('Proceso abortado. Crea primero los artículos que faltan y vuelve a cargar '
    +'la factura.');
}

// Lo que mira _frEnviar antes de mandar la factura reserva a SAP
function _fipValidarEnvio(){
  var S=window._fip;
  if(!S || !S.filas || !S.filas.length) return {ok:true};
  var malas=S.filas.filter(function(f){ return f.linea<0; });
  if(!malas.length || S.seguirSinEllas) return {ok:true};
  return {ok:false, msg:malas.length+' referencia(s) de la factura no están en ninguna '
    +'orden. Corrígelas, pulsa «Seguir sin esas referencias» o aborta el proceso.'};
}

/* ── Ajustar las órdenes de compra a lo que de verdad llegó ───────────────
   Cuando el proveedor manda más de lo pedido, SAP no deja facturar por
   encima de lo pendiente. En vez de recortar la factura, se corrigen las
   cantidades de la orden de compra en SAP —por DI API, con la misma cola de
   revisiones que usa el botón «Revised PO»— y después ya se puede crear la
   factura reserva por lo que llegó. La cantidad nueva de cada línea es lo
   que ya se sirvió más lo que trae esta factura. */
async function _frAjustarOrdenes(){
  var d=window._fr; if(!d) return;
  var pasadas=d.lineas.filter(function(l){
    return (Number(l.cantidad)||0) > (Number(l.abierta)||0)+0.0001; });
  if(!pasadas.length){ showT('No hay líneas que se pasen de lo pendiente'); return; }

  // Primero se enseña TODO lo que cambiaría, línea por línea, y solo se
  // toca SAP si se aprueba. Cada línea se puede dejar fuera.
  window._frAj=pasadas.map(function(l){
    var servida=(Number(l.pedida)||0)-(Number(l.abierta)||0);   // lo ya recibido
    return {inc:true, linea:l, servida:servida,
            nueva:servida+(Number(l.cantidad)||0)};
  });
  _frAjPintar();
}

function _frAjPintar(){
  var L=window._frAj||[];
  var ov=document.getElementById('modalFrAj');
  if(!ov){
    ov=document.createElement('div');
    ov.id='modalFrAj';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10068;'
      +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
    ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
      +'width:100%;max-width:1020px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
      +'<div id="frAjCuerpo"></div></div>';
    document.body.appendChild(ov);
  }
  var c=document.getElementById('frAjCuerpo'); if(!c) return;
  var marcadas=L.filter(function(x){ return x.inc; });
  var ordenes=[...new Set(marcadas.map(function(x){ return String(x.linea.docnum); }))];

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px">'
    +'<i class="ti ti-edit" style="font-size:20px;color:var(--t-marron)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +'Diferencias con las órdenes de compra</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Esto es lo que se cambiaría en '
    +'SAP: la cantidad pedida de cada línea pasa a ser lo ya recibido más lo que trae '
    +'esta factura. Desmarca lo que no quieras tocar. <b>Nada se toca hasta que pulses '
    +'el botón de abajo.</b></div></div>'
    +'<button class="xb" onclick="_frAjCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<div style="display:flex;gap:7px;margin-bottom:8px">'
    +'<button class="xb" onclick="_frAjTodas(true)">Marcar todas</button>'
    +'<button class="xb" onclick="_frAjTodas(false)">Desmarcar todas</button></div>'
    +'<div class="tbx-box" style="max-height:52vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:34px"></th><th style="width:80px">Orden</th>'
    +'<th style="width:140px">Referencia</th><th>Descripción</th>'
    +'<th style="text-align:right">Pedido hoy</th>'
    +'<th style="text-align:right">Ya recibido</th>'
    +'<th style="text-align:right">Llegó ahora</th>'
    +'<th style="text-align:right">Queda pedido</th></tr></thead><tbody>'
    + L.map(function(x,i){
        var l=x.linea;
        return '<tr'+(x.inc?'':' style="opacity:.45"')+'>'
          +'<td><input type="checkbox"'+(x.inc?' checked':'')
          +' onchange="window._frAj['+i+'].inc=this.checked;_frAjPintar()"></td>'
          +'<td>#'+_esc(l.docnum)+'</td>'
          +'<td><b>'+_esc(l.itemcode)+'</b></td>'
          +'<td style="font-size:11px">'+_esc(String(l.dscription||'').slice(0,40))+'</td>'
          +'<td style="text-align:right">'+_fmtN2(l.pedida)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(x.servida)+'</td>'
          +'<td style="text-align:right;font-weight:700">'+_fmtN2(l.cantidad)+'</td>'
          +'<td style="text-align:right;font-weight:700;color:var(--t-marron)">'
          +_fmtN2(x.nueva)+'</td></tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="display:flex;align-items:center;gap:10px;margin-top:12px">'
    +'<div style="flex:1;font-size:12px">'+marcadas.length+' línea(s) en '
    +ordenes.length+' orden(es)'+(ordenes.length?(': #'+ordenes.join(', #')):'')+'</div>'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_frAjCerrar()">'
    +'No tocar nada</button>'
    +'<button class="btn bp" style="padding:9px 18px" onclick="_frAjAplicar()"'
    +(marcadas.length?'':' disabled')+'><i class="ti ti-send"></i> '
    +'Ajustar en SAP y seguir</button></div>';
}

function _frAjTodas(v){
  (window._frAj||[]).forEach(function(x){ x.inc=!!v; });
  _frAjPintar();
}

function _frAjCerrar(){
  var m=document.getElementById('modalFrAj'); if(m) m.remove();
}

async function _frAjAplicar(){
  var L=(window._frAj||[]).filter(function(x){ return x.inc; });
  if(!L.length) return;
  _frAjCerrar();

  var porOrden={};
  L.forEach(function(x){
    var k=String(x.linea.docnum);
    (porOrden[k]=porOrden[k]||[]).push({linea:x.linea, nueva:x.nueva});
  });
  var ordenes=Object.keys(porOrden);

  _frwAbrir();
  _frwPintarEspera('Ajustando las órdenes en SAP…',
    'El worker las corrige por DI API, una por una.');
  var ids=[], fallos=[];
  for(var i=0;i<ordenes.length;i++){
    var k=ordenes[i];
    // Las mismas columnas que usa el Revised PO: la tabla no tiene «origen»,
    // y con esa columna de más PostgREST devolvía 400 y no entraba nada.
    var fila={ docnum:Number(k), estado:'pendiente', creado_por:(CU&&CU.name)||'',
      cambios:porOrden[k].map(function(x){
        return {linenum:x.linea.linenum, itemcode:x.linea.itemcode, campo:'cantidad',
                antes:Number(x.linea.pedida)||0, ahora:x.nueva}; }),
      nuevas:[], quitar:[] };
    try{
      var r=await fetch(SB+'/rest/v1/revisiones_orden_queue',{method:'POST',
        headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(fila)});
      if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));
      var reg=((await r.json())||[])[0];
      ids.push({id:reg.id, docnum:k});
    }catch(e){ fallos.push('#'+k+': '+(e.message||e)); }
  }
  if(!ids.length){ _frwPintarError(fallos.join('\n')||'no pude encolar nada'); return; }
  _frAjusteSeguir(ids, porOrden, Date.now(), fallos);
}

function _frAjusteSeguir(ids, porOrden, desde, fallos){
  clearTimeout(window._frAjT);
  window._frAjT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    var listas=0, errores=fallos.slice();
    for(var i=0;i<ids.length;i++){
      try{
        var r=await fetch(SB+'/rest/v1/revisiones_orden_queue?select=*&id=eq.'+ids[i].id,
          {headers:SBH});
        var q=r.ok ? ((await r.json())||[])[0] : null;
        if(!q) continue;
        if(q.estado==='aplicada'){ listas++; ids[i].ok=true; }
        else if(q.estado==='error'){
          listas++; ids[i].ok=false;
          errores.push('#'+ids[i].docnum+': '+String(q.error_msg||'').slice(0,160));
        }
      }catch(e){}
    }
    _frwPintarEspera('Ajustando las órdenes en SAP…',
      listas+' de '+ids.length+' orden(es) listas');
    if(listas>=ids.length){
      var bien=ids.filter(function(x){ return x.ok; }).map(function(x){ return x.docnum; });
      // En la pantalla, esas líneas pasan a tener como pendiente lo que llegó
      bien.forEach(function(k){
        (porOrden[k]||[]).forEach(function(x){
          var l=x.linea;
          l.pedida=x.nueva;
          l.abierta=Number(l.cantidad)||0;
        });
      });
      try{ rFactReserva(); }catch(e){}
      if(errores.length){
        _frwPintarError('Ajustadas '+bien.length+' de '+ids.length+' orden(es).\n\n'
          +errores.join('\n'));
      } else {
        _frwPintarOK(bien.length);
        var c=document.getElementById('frwCaja');
        if(c) c.innerHTML=c.innerHTML
          .replace('Factura reserva creada en SAP','Órdenes ajustadas en SAP')
          .replace('N.º de factura reserva','Órdenes corregidas')
          .replace('Ya está en SAP enlazada a la orden. En Facturas Reserva aparece tras el '
                   +'siguiente Sync.',
                   'Ya puedes crear la factura reserva con las cantidades que llegaron.');
      }
      return;
    }
    if(Date.now()-desde > 8*60*1000){
      _frwPintarError('El worker no ha respondido en 8 minutos. Las revisiones siguen '
        +'en la cola.');
      return;
    }
    _frAjusteSeguir(ids, porOrden, desde, fallos);
  }, 2500);
}

/* ── Enviar sin que una columna nueva tumbe todo ──────────────────────────
   Cuando se añade un campo al portal y todavía no se ha corrido el SQL en
   Supabase, PostgREST responde 400 diciendo qué columna no conoce. En vez de
   dejar al usuario tirado, se quita ese campo y se reintenta, avisando por
   consola de qué SQL falta. Lo importante (crear la factura) sale igual. */
async function _postTolerante(url, fila, intentos){
  var cuerpo=Object.assign({}, fila);
  // Antes de encolar un CORREO se mira si ya salió uno igual hace poco. Los
  // duplicados que aparecían no eran del doble clic: eran dos envíos hechos
  // a mano con minutos de diferencia, creyendo que el primero no había ido.
  if(String(url).indexOf('/correos_queue')>=0 && !cuerpo._forzar){
    var rep=await _correoYaSalio(cuerpo);
    if(rep && !confirm('OJO: este mismo correo ya se envió.\n\n'
      + (rep.asunto||'') + '\n'
      + 'Salió ' + _correoHaceCuanto(rep.creado_en)
      + (rep.de_nombre?(' · lo mandó '+rep.de_nombre):'')
      + '\n\n¿Lo mando otra vez igualmente?')){
      // Se avisa con una excepción propia: así el código que llamaba NO
      // sigue dando el correo por enviado ni marca nada como hecho.
      var err=new Error('ENVIO_CANCELADO');
      err.cancelado=true;
      throw err;
    }
  }
  delete cuerpo._forzar;
  var quitadas=[];
  for(var i=0;i<(intentos||4);i++){
    var r=await fetch(url,{method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(cuerpo)});
    if(r.ok){
      if(quitadas.length){
        _dbg('[SUPA] fue sin '+quitadas.join(', ')+': falta correr el SQL de esas columnas');
        showT('Se envió, pero sin '+quitadas.join(', ')+': falta correr el SQL de esa '
          +'columna en Supabase.', 7000);
      }
      return r;
    }
    var t=''; try{ t=await r.clone().text(); }catch(e){}
    var m=t.match(/Could not find the '([^']+)' column/);
    if(!m || !(m[1] in cuerpo)) return new Response(t, {status:r.status});
    delete cuerpo[m[1]];
    quitadas.push(m[1]);
  }
  return new Response('{"message":"no se pudo enviar"}', {status:400});
}

/* ── El flete y los demás gastos que van en esta factura reserva ──────────
   En el panel de la factura del proveedor se marca qué gastos se suman. Como
   de una misma factura salen varias facturas reserva (una por orden), a cada
   una le toca la parte proporcional a lo que factura: si esta cubre el 20%
   del FOB de la factura, lleva el 20% del flete. Si cubre la factura entera,
   se los lleva todos. */
function _frCargosDeEstaFactura(lineas){
  return _frCargosFIP(lineas).concat(_frCargosManuales(lineas));
}

/* Los gastos escritos a mano en el panel «Flete y otros gastos» de la
   factura reserva (v739). Si en pantalla hay varias órdenes y se crea una
   factura reserva por orden, a cada una le toca la parte de su importe; si
   se crea una sola, se los lleva enteros. */
function _frCargosManuales(lineas){
  var d=window._fr||{};
  var L=(d.cargosManual||[]).filter(function(c){ return String(c.concepto||'').trim() && Number(c.monto)>0; });
  if(!L.length) return [];
  var totalPantalla=_frTotal();
  var deEsta=(lineas||[]).reduce(function(a,l){ return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
  var parte = totalPantalla>0 ? Math.min(1, deEsta/totalPantalla) : 1;
  return L.map(function(c){
    return {concepto:String(c.concepto).trim(), monto:Math.round((Number(c.monto)||0)*parte*100)/100,
            proporcion:Math.round(parte*10000)/100, manual:true};
  }).filter(function(c){ return c.monto>0; });
}

function _frGastosHtml(){
  var d=window._fr||{}; d.cargosManual=d.cargosManual||[];
  var fip=_frCargosFIP(d.lineas||[]);
  var nOrd=_frOrdenesEnPantalla().length;
  var conceptos=[...new Set(Object.keys(FIP_FLETE_DEPTO).map(function(k){ return FIP_FLETE_DEPTO[k]; })
    .concat(['FLETE','SEGUROS','FLETE Y ACARREO','COURRIER','GASTOS VARIOS','ALMACENAJE','GASTOS THC','OTROS GASTOS VD']))];
  var tot=d.cargosManual.reduce(function(a,c){ return a+(Number(c.monto)||0); },0);
  var est='padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  return '<div style="margin-top:14px;border:0.5px solid var(--border);border-radius:10px;padding:10px 13px;background:var(--surface-0)">'
    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">'
    +'<i class="ti ti-truck" style="color:var(--t-azul)"></i><b style="font-size:13px;flex:1">Flete y otros gastos de esta factura reserva</b>'
    +(tot?('<b style="font-size:13px">'+fmt(tot)+'</b>'):'')+'</div>'
    +'<datalist id="frGastosLista">'+conceptos.map(function(c){ return '<option value="'+_esc(c)+'">'; }).join('')+'</datalist>'
    + d.cargosManual.map(function(c,i){
        return '<div style="display:flex;gap:7px;align-items:center;margin-bottom:5px">'
          +'<input list="frGastosLista" value="'+_esc(c.concepto||'')+'" placeholder="Concepto (FLETE-ROPA, SEGUROS…)" '
          +'onchange="window._fr.cargosManual['+i+'].concepto=this.value" style="flex:1;'+est+'">'
          +'<input inputmode="decimal" value="'+(c.monto||'')+'" placeholder="0.00" '
          +'onchange="window._fr.cargosManual['+i+'].monto=Number(String(this.value).replace(/[$,\\s]/g,\'\'))||0;rFactReserva()" '
          +'style="width:130px;text-align:right;'+est+'">'
          +'<button class="xb" onclick="window._fr.cargosManual.splice('+i+',1);rFactReserva()"><i class="ti ti-x"></i></button></div>';
      }).join('')
    +'<button class="xb" style="font-size:11px" onclick="_frAddGasto()"><i class="ti ti-plus"></i> Añadir flete o gasto</button>'
    +(fip.length?('<div style="font-size:11px;color:var(--text-muted);margin-top:6px">Además, de la factura leída: '
      +fip.map(function(c){ return _esc(c.concepto)+' '+fmt(c.monto); }).join(' · ')+'.</div>'):'')
    +(nOrd>1 && d.cargosManual.length?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:5px">Si se crea una '
      +'factura reserva por orden, cada una lleva la parte de su importe.</div>'):'')
    +'</div>';
}

function _frAddGasto(){
  var d=window._fr; if(!d) return;
  d.cargosManual=d.cargosManual||[];
  var dep='';
  try{
    var o=(orders||[]).filter(function(x){ return String(x.docnum||x.id)===String(((d.lineas||[])[0]||{}).docnum); })[0];
    dep=String((o&&o.dept)||(CU&&CU.dept)||'').toLowerCase();
  }catch(e){}
  d.cargosManual.push({concepto:FIP_FLETE_DEPTO[dep]||'FLETE', monto:0});
  rFactReserva();
}

// Los gastos de la factura leída por el FIP, en la parte de esta factura reserva
function _frCargosFIP(lineas){
  var S=window._fip;
  if(!S || !S.cargos || !S.cargos.length) return [];
  var marcados=S.cargos.filter(function(c){ return c.inc && Number(c.monto); });
  if(!marcados.length) return [];

  var totalFactura=Number(S.fobDeclarado)||0;
  if(!totalFactura){
    totalFactura=(S.filas||[]).reduce(function(a,f){
      return a+((Number(f.cantidad)||0)*(Number(f.precio)||0)); },0);
  }
  var deEsta=(lineas||[]).reduce(function(a,l){
    return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
  var parte = totalFactura>0 ? Math.min(1, deEsta/totalFactura) : 1;

  return marcados.map(function(c){
    return {concepto:c.concepto, monto:Math.round((Number(c.monto)||0)*parte*100)/100,
            proporcion:Math.round(parte*10000)/100};
  }).filter(function(c){ return c.monto>0; });
}

/* ── Una factura reserva por cada orden, de una sola vez ──────────────────
   Kennedy registra UNA factura reserva por orden de compra, pero una
   factura del proveedor suele cubrir varias órdenes. Esto crea todas de
   golpe: una por orden, cada una con sus líneas, su Vendor Ref. No. con la
   letra correspondiente (C2953-A, C2953-B…), su parte del flete y los
   mismos datos del embarque. */
function _frOrdenesEnPantalla(){
  var d=window._fr; if(!d) return [];
  var por={};
  d.lineas.forEach(function(l){
    if((Number(l.cantidad)||0)<=0) return;
    (por[String(l.docnum)]=por[String(l.docnum)]||[]).push(l);
  });
  return Object.keys(por).sort().map(function(k){ return {docnum:k, lineas:por[k]}; });
}

async function _frCrearPorOrden(){
  var d=window._fr; if(!d) return;
  var grupos=_frOrdenesEnPantalla();
  if(grupos.length<2){ return _frEnviar(); }        // una sola: el flujo normal

  // Lo que SAP rechazaría, dicho antes de empezar
  var pasadas=d.lineas.filter(function(l){
    return (Number(l.cantidad)||0) > (Number(l.abierta)||0)+0.0001; });
  if(pasadas.length){
    _frMsg('<b>'+pasadas.length+' línea(s) piden más de lo que queda pendiente</b>'
      +'<br>Ajusta las órdenes primero.'
      +'<br><button class="btn bp" style="margin-top:7px;padding:7px 12px;font-size:12px" '
      +'onclick="_frAjustarOrdenes()"><i class="ti ti-eye"></i> Ver las diferencias</button>',
      'err');
    return;
  }
  var v=_fipValidarEnvio();
  if(!v.ok){ _frMsg(_esc(v.msg),'err'); return; }

  var resumen='CREAR '+grupos.length+' FACTURAS RESERVA, UNA POR ORDEN\n\n'
    + grupos.map(function(g){
        var t=g.lineas.reduce(function(a,l){
          return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
        var cg=_frCargosDeEstaFactura(g.lineas);
        return '· #'+g.docnum+' · '+g.lineas.length+' línea(s) · '+_fmtN2(t)
          +(cg.length?(' + gastos '+_fmtN2(cg.reduce(function(a,x){
              return a+x.monto; },0))):'')
          +' · Ref. '+(_fipRefFactura(g.docnum)||'(falta el n.º de factura)');
      }).join('\n')
    +'\n\nCada una se crea en SAP enlazada a su orden. ¿Sigo?';
  if(!confirm(resumen)) return;

  _frwAbrir();
  // Las MEDIDAS van primero: el peso y el cubicaje los toma SAP de la ficha
  // del artículo al crear la factura, así que si se mandan después la
  // factura sale sin ellos. Era justo lo que estaba pasando.
  _frwPintarEspera('Actualizando las medidas de los artículos…',
    'El peso y el cubicaje tienen que estar en la ficha ANTES de crear la factura.');
  try{ await _fipMandarMedidas(true, true); }catch(e){ _dbg('[FIP] medidas: '+e); }

  _frwPintarEspera('Creando '+grupos.length+' facturas reserva en SAP…',
    'Una por orden. No cierres esta ventana.');
  var ids=[], fallos=[];
  for(var i=0;i<grupos.length;i++){
    var g=grupos[i];
    // Si no hay número de factura del proveedor se pregunta; el DKC no vale
    var ref=_fipRefFactura(g.docnum);
    if(!ref){
      _fipPedirNumeroFactura();
      ref=_fipRefFactura(g.docnum)||null;
    }
    var total=g.lineas.reduce(function(a,l){
      return a+((Number(l.cantidad)||0)*(Number(l.precio)||0)); },0);
    var fila={
      dkc:d.dkc||null, cardcode:d.cardcode, cardname:d.cardname||null,
      numatcard:ref, num_factura:d.num_factura||null,
      docdate:_hoyISO(), docduedate:d.docduedate||null,
      comments:('Factura reserva desde el portal · orden #'+g.docnum
                +(d.num_factura?(' · factura '+d.num_factura):'')).slice(0,254),
      lineas:g.lineas.map(function(l){
        return {docentry:l.docentry, linenum:l.linenum, docnum:l.docnum,
                itemcode:l.itemcode, dscription:l.dscription,
                cantidad:Number(l.cantidad)||0, precio:Number(l.precio)||0}; }),
      campos_usuario:(window._fr.udf||{}),
      cargos:_frCargosDeEstaFactura(g.lineas),
      total:total,
      reparto:[{docnum:g.docnum, dkc:_fipDkcDeOrden(g.docnum), monto:total}],
      estado:'pendiente', creado_por:(CU&&CU.name)||''
    };
    try{
      var r=await _postTolerante(SB+'/rest/v1/facturas_reserva_queue', fila);
      if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));
      var reg=((await r.json())||[])[0];
      ids.push({id:reg.id, docnum:g.docnum});
    }catch(e){ fallos.push('#'+g.docnum+': '+(e.message||e)); }
  }
  if(!ids.length){ _frwPintarError(fallos.join('\n')||'no pude encolar ninguna'); return; }
  _frCargarHistorial();
  _frLoteSeguir(ids, Date.now(), fallos);
}

function _frLoteSeguir(ids, desde, fallos){
  clearTimeout(window._frLoteT);
  window._frLoteT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    var listas=0;
    for(var i=0;i<ids.length;i++){
      if(ids[i].fin){ listas++; continue; }
      try{
        var r=await fetch(SB+'/rest/v1/facturas_reserva_queue?select=*&id=eq.'+ids[i].id,
          {headers:SBH});
        var q=r.ok ? ((await r.json())||[])[0] : null;
        if(!q) continue;
        if(q.estado==='creada'){ ids[i].fin=true; ids[i].docnum_sap=q.docnum_sap; listas++; }
        else if(q.estado==='error'){
          ids[i].fin=true; listas++;
          ids[i].error=String(q.error_msg||'').slice(0,200);
        }
      }catch(e){}
    }
    var hechas=ids.filter(function(x){ return x.docnum_sap; });
    _frwPintarEspera('Creando las facturas reserva en SAP…',
      listas+' de '+ids.length+' listas'
      +(hechas.length?(' · '+hechas.map(function(x){ return '#'+x.docnum_sap; }).join(' ')):''));
    if(listas>=ids.length){
      var malas=ids.filter(function(x){ return x.error; });
      _frCargarHistorial();
      var c=document.getElementById('frwCaja');
      if(!malas.length && c){
        c.innerHTML='<div style="width:78px;height:78px;margin:0 auto 14px;border-radius:50%;'
          +'background:var(--pastel-ok);display:flex;align-items:center;justify-content:center">'
          +'<i class="ti ti-check" style="font-size:46px;color:var(--t-verde)"></i></div>'
          +'<div style="font-size:16px;font-weight:700;color:var(--t-verde)">'
          +hechas.length+' facturas reserva creadas en SAP</div>'
          +'<div style="margin-top:12px;font-size:13px;line-height:1.7">'
          + hechas.map(function(x){
              return 'Orden #'+_esc(x.docnum)+' → <b style="font-size:17px">#'
                +_esc(x.docnum_sap)+'</b>'; }).join('<br>')
          +'</div>'
          +'<button class="btn bp" style="margin-top:16px;width:100%;padding:11px" '
          +'onclick="_frwCerrar()">Listo</button>';
      } else {
        _frwPintarError('Creadas '+hechas.length+' de '+ids.length+'.\n\n'
          + hechas.map(function(x){ return '#'+x.docnum+' → SAP #'+x.docnum_sap; }).join('\n')
          + (malas.length?('\n\nFallaron:\n'
              + malas.map(function(x){ return '#'+x.docnum+': '+x.error; }).join('\n')):'')
          + (fallos.length?('\n\n'+fallos.join('\n')):''));
      }
      return;
    }
    if(Date.now()-desde > 12*60*1000){
      _frwPintarError('El worker no ha respondido en 12 minutos. Las que falten siguen '
        +'en la cola y se crearán cuando arranque.');
      return;
    }
    _frLoteSeguir(ids, desde, fallos);
  }, 2500);
}

// Añadir a mano un flete o gasto que la factura no traiga escrito
function _fipAddCargo(){
  var S=window._fip; if(!S) return;
  S.cargos=S.cargos||[];
  S.cargos.push({concepto:_fipFleteDelDepto(), monto:0, inc:true});
  _fipPintar();
  showT('Elige el gasto en la lista y escribe el importe');
}

/* Los gastos tal como están dados de alta en SAP. Se eligen de aquí para no
   inventarse nombres que luego SAP no reconoce. La lista se actualiza sola
   si el worker ha bajado los gastos de SAP; si no, vale esta. */
var FIP_GASTOS=[
  'ACARREO- CAMPAMENTO','ALMACENAJE','CERTIFICADO DE ORIGE','COURRIER',
  'DOCUMENTACION.','FLETE-ALFOMBRAS','FLETE-ELECTRONICA','FLETE-FERRETERIA',
  'FLETE-HOGAR','FLETE-MUEBLE','FLETE-ROPA','FLETE','FLETE VD-ALFOMBRA',
  'FLETE VD-CALZADO','FLETE VD-CONSTRUCCIO','FLETE VD-ELECTRONICA',
  'FLETE VD-HOGAR','FLETE VD-MUEBLE','FLETE VD-ROPA','FLETE VD',
  'FLETE Y ACARREO','GASTO DE ETIQUETADO','GASTO DE REEMPAQUE','GASTO DE SELLO',
  'GASTOS THC','GASTOS VARIOS','INSPECCION','OTROS GASTOS VD','REGALIA',
  'RETENCION DE EQUIPO','SALIDA','SALIDA.','SEGUROS','TRASPASO'
];

// El flete que le toca al departamento de la orden
var FIP_FLETE_DEPTO={
  ropa:'FLETE-ROPA', hogar:'FLETE-HOGAR', muebles:'FLETE-MUEBLE',
  alfombras:'FLETE-ALFOMBRAS', electronica:'FLETE-ELECTRONICA',
  ferreteria:'FLETE-FERRETERIA', homedeco:'FLETE-HOGAR',
  campamento:'ACARREO- CAMPAMENTO'
};

function _fipFleteDelDepto(){
  var S=window._fip||{};
  var dep='';
  try{
    // El departamento sale de la orden que se está facturando
    var oid=(S.ordenes&&S.ordenes[0]&&S.ordenes[0].docnum)||'';
    var o=(orders||[]).filter(function(x){
      return String(x.docnum||x.id)===String(oid); })[0];
    dep=String((o&&o.dept)||(CU&&CU.dept)||'').toLowerCase();
  }catch(e){ dep=String((CU&&CU.dept)||'').toLowerCase(); }
  return FIP_FLETE_DEPTO[dep] || 'FLETE';
}

// La lista para el desplegable, con lo que haya en SAP por delante
function _fipGastosLista(){
  var base=(window._fipGastosSap&&window._fipGastosSap.length)
    ? window._fipGastosSap : FIP_GASTOS;
  return base.slice().sort(function(a,b){ return a.localeCompare(b); });
}

// Los gastos de SAP, si la tabla existe
async function _fipCargarGastos(){
  try{
    var r=await fetch(SB+'/rest/v1/gastos_sap?select=nombre&order=nombre',{headers:SBH});
    if(!r.ok) return;
    var l=(await r.json()||[]).map(function(x){ return x.nombre; }).filter(Boolean);
    if(l.length){ window._fipGastosSap=l; _dbg('[FIP] '+l.length+' gasto(s) de SAP'); }
  }catch(e){}
}

/* ═══════════════════════════════════════════════════════════════════════════
   EL BOTÓN «ATRÁS» DEL NAVEGADOR   (prefijo [NAV])
   ───────────────────────────────────────────────────────────────────────────
   Antes, al pulsar atrás en cualquier punto se salía del portal y había que
   volver a entrar. Ahora cada pantalla y cada ventana dejan su marca en el
   historial, así que atrás hace lo que uno espera:
     · si hay una ventana abierta, la cierra,
     · si no, vuelve a la pantalla anterior,
     · y solo sale del portal cuando ya no queda nada atrás.
   ═══════════════════════════════════════════════════════════════════════════ */

window._navPila = window._navPila || [];
window._navVolviendo = false;

// Las ventanas del portal, de la de más arriba a la de más abajo
var NAV_MODALES=['frwOv','modalFipRep','modalMedPegar','modalFrAj','modalVDOC',
                 'modalVDVer','modalVD','modalSolPago','modalFres','qmodal','modal'];

function _navModalAbierto(){
  for(var i=0;i<NAV_MODALES.length;i++){
    var el=document.getElementById(NAV_MODALES[i]);
    if(el && el.style.display!=='none' && document.body.contains(el)) return NAV_MODALES[i];
  }
  return '';
}

function _navCerrarModal(id){
  var cierres={
    frwOv:function(){ try{ _frwCerrar(); }catch(e){} },
    modalFipRep:function(){ try{ _fipRepCerrar(); }catch(e){} },
    modalMedPegar:function(){ try{ _fipMedPegarCerrar(); }catch(e){} },
    modalFrAj:function(){ try{ _frAjCerrar(); }catch(e){} },
    modalVDOC:function(){ try{ _vdOcCerrar(); }catch(e){} },
    modalVDVer:function(){ try{ _vdVerCerrar(); }catch(e){} },
    modalVD:function(){ try{ _vdCerrar(); }catch(e){} },
    modalSolPago:function(){ try{ _solPagoCerrar(); }catch(e){} },
    modalFres:function(){ try{ _fresCerrar(); }catch(e){} },
    qmodal:function(){ try{ document.getElementById('qmodal').style.display='none'; }catch(e){} },
    modal:function(){ try{ CM(); }catch(e){
      try{ document.getElementById('modal').style.display='none'; }catch(e2){} } }
  };
  if(cierres[id]) cierres[id]();
  else { var el=document.getElementById(id); if(el) el.remove(); }
}

// Cada pantalla deja su marca
function _navMarcar(id){
  if(window._navVolviendo) return;
  var ultimo=window._navPila[window._navPila.length-1];
  if(ultimo===id) return;
  window._navPila.push(id);
  try{ history.pushState({kfPag:id}, '', '#'+id); }catch(e){}
}

// Y cada ventana también, para que atrás la cierre
function _navMarcarModal(){
  if(window._navVolviendo) return;
  try{ history.pushState({kfModal:1}, '', location.hash||''); }catch(e){}
}

window.addEventListener('popstate', function(ev){
  // 1. Si hay una ventana abierta, atrás la cierra y nada más
  var m=_navModalAbierto();
  if(m){
    window._navVolviendo=true;
    _navCerrarModal(m);
    setTimeout(function(){ window._navVolviendo=false; }, 60);
    return;
  }
  // 2. Si no, se vuelve a la pantalla anterior del portal
  var destino=(ev.state && ev.state.kfPag) || '';
  if(!destino){
    window._navPila.pop();
    destino=window._navPila[window._navPila.length-1] || 'dashboard';
  }
  window._navVolviendo=true;
  try{ go(destino); }catch(e){}
  setTimeout(function(){ window._navVolviendo=false; }, 60);
});

// Al abrir el portal se deja una marca de fondo: así el primer «atrás»
// tiene adónde volver y no se sale de la aplicación.
(function _navArrancar(){
  try{
    if(!history.state || !history.state.kfPag){
      history.replaceState({kfPag:'dashboard'}, '', location.hash||'#dashboard');
    }
    window._navPila=['dashboard'];
  }catch(e){}
})();

/* ── El abono, anotado en la orden de SAP ─────────────────────────────────
   Cuando contabilidad manda el comprobante del depósito a las compradoras,
   el mismo movimiento escribe en la orden de compra de SAP el campo
   U_ABONO (el monto abonado) y U_FecAbono (la fecha de hoy). Lo hace el
   worker por DI API; el portal solo deja la petición en su cola.
   El monto sale de las solicitudes de abono de esa orden; si hay varias, se
   suman, y si no hubiera ninguna se pregunta. */
function _abonoMontoDeLaOrden(oid){
  var sols=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && x.tipo!=='cancelacion'; });
  var suma=sols.reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
  return Math.round(suma*100)/100;
}

async function _abonoAnotarEnSAP(oid){
  if(!/^\d+$/.test(String(oid))) return;        // las NO-SAP no tienen orden
  var monto=_abonoMontoDeLaOrden(oid);
  if(!monto){
    var v=prompt('¿Qué monto se abonó de la orden '+oid+'?\n\n'
      +'Se escribirá en U_ABONO de la orden en SAP, con la fecha de hoy.');
    monto=Number(String(v||'').replace(/[^0-9.,-]/g,'').replace(',','.'))||0;
    if(!monto) return;
  }
  var fila={docnum:Number(oid), abono:monto, fecha:_hoyISO(),
            estado:'pendiente', creado_por:(CU&&CU.name)||''};
  try{
    var r=await _postTolerante(SB+'/rest/v1/abonos_orden_queue', fila);
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre abonos_orden.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,140));
    }
    showT('El abono de '+_fmtN2(monto)+' se está anotando en la orden #'+oid+' de SAP', 6000);
  }catch(e){
    showT('El comprobante salió, pero no pude anotar el abono en SAP: '+(e.message||e), 9000);
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   RE ACTUALIZAR UNA ORDEN QUE YA ESTÁ EN SAP   (prefijo [REO])
   ───────────────────────────────────────────────────────────────────────────
   La orden ya existe en SAP y el proveedor manda cambios: pesos y cubicajes
   nuevos, una descripción corregida, un precio que sube. Esta pantalla abre
   la orden con TODO editable, marca en otro color lo que se ha tocado, y al
   pulsar «Revisar y actualizar» enseña un resumen de cada cambio para
   aprobarlo antes de que salga nada hacia SAP.

   Lo que se manda, siempre por DI API:
     · cantidades y precios de las líneas, y la cabecera (referencia del
       proveedor, fecha de entrega, comentarios) → cola de revisiones
     · peso, cubicaje y medida del cartón → a la ficha del artículo, que es
       donde viven de verdad esos datos
   ═══════════════════════════════════════════════════════════════════════════ */

window._reo = null;

var REO_COLS=[
  {k:'itemcode',   t:'Referencia',      w:140, ro:true},
  {k:'dscription', t:'Descripción',     w:260},
  {k:'cantidad',   t:'Cantidad',        w:90,  num:2, sap:true},
  {k:'precio',     t:'Precio',          w:95,  num:4, sap:true},
  {k:'peso_kg',    t:'Peso pieza (kg)', w:100, num:4, ficha:true},
  {k:'pcub',       t:'Pies³ pieza',     w:95,  num:4, ficha:true},
  {k:'pxb',        t:'Pzas por bulto',  w:95,  num:2, ficha:true},
  {k:'medida',     t:'Medida cartón',   w:120, ficha:true}
];

async function _reoAbrir(docnum){
  showT('Abriendo la orden #'+docnum+'…');
  var S={docnum:String(docnum), lineas:[], orig:[], cab:{}, cabOrig:{}, cargando:true};
  window._reo=S;
  try{
    var ro=await fetch(SB+'/rest/v1/opor_ordenes?select=*&docnum=eq.'+encodeURIComponent(docnum),
      {headers:SBH});
    S.orden=(ro.ok?((await ro.json())||[]):[])[0]||{};
    var rl=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'+encodeURIComponent(docnum)
      +'&order=linenum',{headers:SBH});
    var ls=rl.ok ? (await rl.json()||[]) : [];
    if(!ls.length) throw new Error('no encuentro las líneas de la orden en el portal');

    // Las medidas de la ficha del artículo, que son las que se editan
    var codigos=[...new Set(ls.map(function(l){ return String(l.itemcode||'').trim(); }))];
    var inv={};
    for(var i=0;i<codigos.length;i+=80){
      var lote=codigos.slice(i,i+80).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/inventario?select=*&itemcode=in.('+lote.join(',')+')',
        {headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){ inv[String(x.itemcode)]=x; });
    }
    S.lineas=ls.map(function(l){
      var f=inv[String(l.itemcode)]||{};
      return {
        linenum:l.linenum, docentry:l.docentry, itemcode:l.itemcode,
        dscription:l.dscription||f.itemname||'',
        cantidad:Number(l.cantidad)||0,
        precio:Number(l.precio)||0,
        peso_kg:Number(l.peso_pdf_unit||l.peso_unit_kg||f.peso)||0,
        pcub:Number(l.pcub_unit)||0,
        pxb:Number(l.unid_por_bulto||f.unidadesbulto||f.salpackun)||0,
        medida:String(f.medida_carton||'')
      };
    });
    S.orig=S.lineas.map(function(l){ return Object.assign({}, l); });
    S.cab={numatcard:S.orden.num_proveedor||'', docduedate:(S.orden.duedate||'').slice(0,10),
           comentarios:S.orden.comentarios||''};
    S.cabOrig=Object.assign({}, S.cab);
    S.cargando=false;
  }catch(e){
    window._reo=null;
    showT('No pude abrir la orden: '+(e.message||e), 8000);
    return;
  }
  var ov=document.createElement('div');
  ov.id='modalREO';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10065;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1240px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="reoCuerpo"></div></div>';
  document.body.appendChild(ov);
  _reoPintar();
}

function _reoCerrar(){
  var m=document.getElementById('modalREO'); if(m) m.remove();
  window._reo=null;
}

function _reoSet(i, campo, v){
  var S=window._reo; if(!S||!S.lineas[i]) return;
  var col=REO_COLS.filter(function(c){ return c.k===campo; })[0];
  S.lineas[i][campo]= (col && col.num!=null)
    ? (Number(String(v).replace(',','.'))||0) : String(v).trim();
  _reoPintar();
}

function _reoSetCab(campo, v){
  var S=window._reo; if(!S) return;
  S.cab[campo]=String(v);
  _reoPintar();
}

function _reoCambiado(i, campo){
  var S=window._reo;
  var a=S.orig[i], b=S.lineas[i];
  if(!a||!b) return false;
  var col=REO_COLS.filter(function(c){ return c.k===campo; })[0];
  if(col && col.num!=null) return Math.abs((Number(a[campo])||0)-(Number(b[campo])||0))>0.00001;
  return String(a[campo]||'')!==String(b[campo]||'');
}

// Todo lo que se ha tocado, para el resumen y para mandarlo
function _reoCambios(){
  var S=window._reo, out={lineasSap:[], fichas:[], cab:[]};
  if(!S) return out;
  Object.keys(S.cab).forEach(function(k){
    if(String(S.cab[k]||'')!==String(S.cabOrig[k]||'')){
      out.cab.push({campo:k, antes:S.cabOrig[k]||'', ahora:S.cab[k]||''});
    }
  });
  S.lineas.forEach(function(l,i){
    REO_COLS.forEach(function(c){
      if(c.ro || !_reoCambiado(i,c.k)) return;
      var reg={itemcode:l.itemcode, linenum:l.linenum, campo:c.k, titulo:c.t,
               antes:S.orig[i][c.k], ahora:l[c.k]};
      if(c.sap || c.k==='dscription') out.lineasSap.push(reg);
      else out.fichas.push(reg);
    });
  });
  return out;
}

function _reoPintar(){
  var c=document.getElementById('reoCuerpo'); if(!c) return;
  var S=window._reo; if(!S) return;
  var cam=_reoCambios();
  var nCam=cam.lineasSap.length+cam.fichas.length+cam.cab.length;
  var est='width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;'
    +'font-size:12px;padding:4px 5px;color:var(--text-primary)';
  var marca='background:var(--pastel-aviso);color:var(--t-marron);font-weight:700';

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-refresh" style="font-size:21px;color:var(--t-marron)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +'Re actualizar en SAP · orden #'+_esc(S.docnum)+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">'
    +_esc(S.orden.vendor_code||'')+' · '+_esc(S.orden.vendor_name||'')
    +' · Edita lo que haga falta: lo que cambies se marca en ámbar y se resume antes '
    +'de tocar SAP.</div></div>'
    +'<button class="xb" onclick="_reoCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:10px">'
    + _vdCampo('Vendor Ref. No. (DKC)',
        '<input value="'+_esc(S.cab.numatcard)+'" onchange="_reoSetCab(\'numatcard\',this.value)" '
        +'style="'+est+(S.cab.numatcard!==S.cabOrig.numatcard?(';'+marca):'')+'">')
    + _vdCampo('Fecha de entrega',
        '<input type="date" value="'+_esc(S.cab.docduedate)+'" '
        +'onchange="_reoSetCab(\'docduedate\',this.value)" '
        +'style="'+est+(S.cab.docduedate!==S.cabOrig.docduedate?(';'+marca):'')+'">')
    + _vdCampo('Comentarios',
        '<input value="'+_esc(S.cab.comentarios)+'" '
        +'onchange="_reoSetCab(\'comentarios\',this.value)" '
        +'style="'+est+(S.cab.comentarios!==S.cabOrig.comentarios?(';'+marca):'')+'">')
    +'</div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">'
    +'Cantidad y precio cambian la orden en SAP. Peso, pies³, piezas por bulto y medida '
    +'del cartón se escriben en la ficha del artículo. Ctrl+D rellena hacia abajo.</div>'
    +'<div class="tbx-box" style="max-height:52vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:34px">#</th>'
    + REO_COLS.map(function(x){
        return '<th style="width:'+x.w+'px'+(x.num!=null?';text-align:right':'')+'">'
          +_esc(x.t)+(x.ficha?' <span style="color:var(--t-lila)">•</span>':'')+'</th>'; }).join('')
    +'</tr></thead><tbody>'
    + S.lineas.map(function(l,i){
        return '<tr>'
          +'<td style="color:var(--text-muted)">'+(i+1)+'</td>'
          + REO_COLS.map(function(x){
              var v=(l[x.k]==null?'':l[x.k]);
              if(x.ro) return '<td style="font-weight:600">'+_esc(v)+'</td>';
              var ch=_reoCambiado(i,x.k);
              return '<td style="padding:0"><input '+(x.num!=null?'inputmode="decimal" ':'')
                +'value="'+_esc(x.num!=null?(v||''):v)+'" '
                +'onchange="_reoSet('+i+',\''+x.k+'\',this.value)" '
                +'title="'+(ch?('Antes: '+_esc(S.orig[i][x.k])):'')+'" '
                +'style="'+inp+(x.num!=null?';text-align:right':'')+(ch?(';'+marca):'')
                +'"></td>';
            }).join('')
          +'</tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="display:flex;align-items:center;gap:10px;margin-top:12px;flex-wrap:wrap">'
    +'<div style="flex:1;font-size:12px">'
    +(nCam? ('<b style="color:var(--t-marron)">'+nCam+' cambio(s)</b> · '
       +cam.lineasSap.length+' en la orden · '+cam.fichas.length+' en las fichas'
       +(cam.cab.length?(' · '+cam.cab.length+' en la cabecera'):''))
      : 'Sin cambios todavía')+'</div>'
    +'<button class="btn bg2" onclick="_reoCerrar()" style="padding:9px 14px">Cancelar</button>'
    +'<button class="btn bp" onclick="_reoResumen()" style="padding:9px 18px"'
    +(nCam?'':' disabled')+'><i class="ti ti-checklist"></i> '
    +'Revisar y actualizar en SAP</button></div>';
}

// El resumen para aprobar antes de tocar nada
function _reoResumen(){
  var cam=_reoCambios();
  var S=window._reo;
  var fila=function(x, donde){
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:3px 6px"><b>'+_esc(x.itemcode||'—')+'</b></td>'
      +'<td>'+_esc(x.titulo||x.campo)+'</td>'
      +'<td style="color:var(--text-muted)">'+_esc(x.antes===''?'(vacío)':x.antes)+'</td>'
      +'<td style="color:var(--t-marron);font-weight:700">'+_esc(x.ahora===''?'(vacío)':x.ahora)+'</td>'
      +'<td style="font-size:10.5px;color:var(--text-muted)">'+donde+'</td></tr>';
  };
  var ov=document.createElement('div');
  ov.id='modalREORes';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10067;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:26px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:900px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div style="font-size:16px;font-weight:700;margin-bottom:3px">'
    +'Esto es lo que se va a actualizar en SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'Orden #'+_esc(S.docnum)+' · todo por DI API. Nada se toca hasta que apruebes.</div>'
    +'<div class="tbx-box" style="max-height:52vh;overflow:auto"><table class="tbx">'
    +'<thead><tr><th style="width:140px">Artículo</th><th style="width:150px">Campo</th>'
    +'<th>Antes</th><th>Ahora</th><th style="width:150px">Dónde</th></tr></thead><tbody>'
    + cam.cab.map(function(x){
        return fila({itemcode:'(cabecera)', titulo:x.campo, antes:x.antes, ahora:x.ahora},
                    'Cabecera de la orden'); }).join('')
    + cam.lineasSap.map(function(x){ return fila(x,'Línea de la orden'); }).join('')
    + cam.fichas.map(function(x){ return fila(x,'Ficha del artículo'); }).join('')
    +'</tbody></table></div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px">'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_reoResCerrar()">'
    +'Volver a editar</button>'
    +'<button class="btn bp" style="padding:9px 18px" onclick="_reoAplicar()">'
    +'<i class="ti ti-send"></i> Aprobar y actualizar en SAP</button></div></div>';
  document.body.appendChild(ov);
}

function _reoResCerrar(){
  var m=document.getElementById('modalREORes'); if(m) m.remove();
}

async function _reoAplicar(){
  var S=window._reo; if(!S) return;
  var cam=_reoCambios();
  _reoResCerrar();
  _frwAbrir();
  _frwPintarEspera('Actualizando la orden #'+S.docnum+' en SAP…',
    'Por DI API: primero la orden, después las fichas de los artículos.');

  var ids=[], fallos=[];
  // 1. La orden: cantidades, precios y cabecera
  var porLinea={};
  cam.lineasSap.forEach(function(x){
    if(x.campo!=='cantidad' && x.campo!=='precio') return;
    (porLinea[x.linenum]=porLinea[x.linenum]||[]).push(x);
  });
  var cambios=[];
  Object.keys(porLinea).forEach(function(ln){
    porLinea[ln].forEach(function(x){
      cambios.push({linenum:Number(ln), itemcode:x.itemcode, campo:x.campo,
                    antes:x.antes, ahora:x.ahora});
    });
  });
  if(cambios.length || cam.cab.length){
    try{
      var fila={docnum:Number(S.docnum), estado:'pendiente', creado_por:(CU&&CU.name)||'',
        cambios:cambios, nuevas:[], quitar:[],
        cabecera:(cam.cab.length?{numatcard:S.cab.numatcard,
                                  docduedate:S.cab.docduedate||null,
                                  comentarios:S.cab.comentarios}:null)};
      var r=await _postTolerante(SB+'/rest/v1/revisiones_orden_queue', fila);
      if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));
      ids.push({id:((await r.json())||[])[0].id, que:'orden'});
    }catch(e){ fallos.push('la orden: '+(e.message||e)); }
  }

  // 2. Las fichas de los artículos: peso, cubicaje, piezas por bulto y medida
  var porItem={};
  cam.fichas.forEach(function(x){ porItem[x.itemcode]=true; });
  var items=Object.keys(porItem).map(function(code){
    var l=S.lineas.filter(function(z){ return String(z.itemcode)===String(code); })[0]||{};
    return {itemcode:code, peso_pieza_kg:Number(l.peso_kg)||0,
            vol_pieza_pie3:Number(l.pcub)||0,
            peso_bulto_kg:(Number(l.peso_kg)||0)*(Number(l.pxb)||0),
            vol_bulto_pie3:(Number(l.pcub)||0)*(Number(l.pxb)||0),
            medida_carton:l.medida||'', piezas_x_bulto:Number(l.pxb)||0};
  });
  if(items.length){
    try{
      var r2=await _postTolerante(SB+'/rest/v1/items_medidas_queue',
        {items:items, origen:'re actualizar orden #'+S.docnum,
         estado:'pendiente', creado_por:(CU&&CU.name)||''});
      if(!r2.ok) throw new Error(r2.status+' '+(await r2.text()).slice(0,140));
      ids.push({id:((await r2.json())||[])[0].id, que:'fichas'});
    }catch(e){ fallos.push('las fichas: '+(e.message||e)); }
  }

  if(!ids.length){ _frwPintarError(fallos.join('\n')||'no había nada que mandar'); return; }
  _reoCerrar();
  _reoSeguir(ids, Date.now(), fallos, S.docnum);
}

function _reoSeguir(ids, desde, fallos, docnum){
  clearTimeout(window._reoT);
  window._reoT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    var listas=0, errores=fallos.slice();
    for(var i=0;i<ids.length;i++){
      if(ids[i].fin){ listas++; continue; }
      var tabla = ids[i].que==='orden' ? 'revisiones_orden_queue' : 'items_medidas_queue';
      try{
        var r=await fetch(SB+'/rest/v1/'+tabla+'?select=*&id=eq.'+ids[i].id,{headers:SBH});
        var q=r.ok ? ((await r.json())||[])[0] : null;
        if(!q) continue;
        if(q.estado==='aplicada' || q.estado==='hecha'){ ids[i].fin=true; listas++; }
        else if(q.estado==='error'){
          ids[i].fin=true; listas++;
          errores.push(ids[i].que+': '+String(q.error_msg||'').slice(0,200));
        }
      }catch(e){}
    }
    _frwPintarEspera('Actualizando en SAP…', listas+' de '+ids.length+' listo(s)');
    if(listas>=ids.length){
      if(errores.length) _frwPintarError('Orden #'+docnum+'\n\n'+errores.join('\n'));
      else{
        _frwPintarOK(docnum);
        var c=document.getElementById('frwCaja');
        if(c) c.innerHTML=c.innerHTML
          .replace('Factura reserva creada en SAP','Orden actualizada en SAP')
          .replace('N.º de factura reserva','Orden')
          .replace('Ya está en SAP enlazada a la orden. En Facturas Reserva aparece tras el '
                   +'siguiente Sync.',
                   'Los cambios ya están en SAP. En el portal se verán tras el siguiente Sync.');
      }
      return;
    }
    if(Date.now()-desde > 8*60*1000){
      _frwPintarError('El worker no ha respondido en 8 minutos. Sigue en la cola.');
      return;
    }
    _reoSeguir(ids, desde, fallos, docnum);
  }, 2500);
}

/* ═══════════════════════════════════════════════════════════════════════════
   COMPARACIÓN DE PRECIOS ANTES DE LA FIRMA   (prefijo [CMP])
   ───────────────────────────────────────────────────────────────────────────
   Un borrador para que compras revise la orden ANTES de mandarla a gerencia.
   Se sube la orden que manda el proveedor y, al lado del precio que ofrece,
   se ponen dos referencias que ya están en el sistema:

     · el ÚLTIMO FOB pagado, el de la última factura reserva de ese artículo
       en SAP (con su fecha y su factura), y
     · el FOB de lo que está POR LLEGAR: órdenes de compra abiertas de ese
       artículo que todavía no tienen factura reserva.

   Así se ve de un golpe si el proveedor sube el precio respecto a lo último
   pagado o respecto a lo que ya viene en camino. La revisión se imprime
   junto con el documento del proveedor.
   ═══════════════════════════════════════════════════════════════════════════ */

window._cmp = null;

function _cmpAbrir(){
  window._cmp={archivo:'', leyendo:false, items:[], filas:[], error:'', doc:null};
  var ov=document.createElement('div');
  ov.id='modalCMP';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10066;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1180px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="cmpCuerpo"></div></div>';
  document.body.appendChild(ov);
  _cmpPintar();
}

function _cmpCerrar(){
  var m=document.getElementById('modalCMP'); if(m) m.remove();
  window._cmp=null;
}

async function _cmpArchivo(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var S=window._cmp; if(!S) return;
  S.archivo=f.name; S.leyendo=true; S.error=''; S.filas=[];
  S.fileObj=f;
  _cmpPintar();
  try{
    var doc=null;
    if(/\.(xlsx|xls|csv)$/i.test(f.name||'')){
      try{ doc=await _fipLeerExcelFactura(f); }catch(e){}
    }
    if(!doc) doc=await _spcLeerFacturaProveedor(f);   // PDF o foto: lo lee la IA
    S.doc=doc;
    S.items=doc.items||{};
    if(!Object.keys(S.items).length) throw new Error('no saqué artículos del documento');
    await _cmpBuscarReferencias();
  }catch(e){
    S.error='No pude leer el documento: '+(e.message||e);
  }
  S.leyendo=false;
  _cmpPintar();
}

// Busca, para cada referencia, el último FOB facturado y el de lo que viene
async function _cmpBuscarReferencias(){
  var S=window._cmp;
  var claves=Object.keys(S.items);
  var codigos=claves.map(function(k){ return S.items[k].itemcode; }).filter(Boolean);
  if(!codigos.length) return;

  // 1. Traducción: la factura puede venir con la referencia del proveedor
  var trad={};
  try{
    var campos=['itemcode','suppcatnum','codebars'];
    for(var c=0;c<campos.length;c++){
      var faltan=codigos.filter(function(x){ return !trad[_ocNormSku(x)]; });
      if(!faltan.length) break;
      for(var i=0;i<faltan.length;i+=60){
        var lote=faltan.slice(i,i+60).map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; });
        var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,suppcatnum,codebars&'
          +campos[c]+'=in.('+lote.join(',')+')&limit=2000',{headers:SBH});
        if(!r.ok) continue;
        (await r.json()||[]).forEach(function(x){
          var k=_ocNormSku(x[campos[c]]);
          if(k && !trad[k]) trad[k]={itemcode:x.itemcode, itemname:x.itemname};
        });
      }
    }
  }catch(e){ _dbg('[CMP] traducir: '+(e.message||e)); }

  // 1b. v762: las que no salen IGUALES. En una PI escaneada la referencia
  // suele llegar sin el prefijo de SAP o con otros separadores («231-8102»
  // contra «XX-231-8102» o «2318102»), y la búsqueda exacta no la encontraba:
  // salían todas sin precio que comparar. Se buscan por sus números y se
  // emparejan con _refEmparejar, que solo acepta una correspondencia ÚNICA.
  try{
    var sinTrad=claves.filter(function(k){ return !trad[k]; });
    var buscarUna=async function(k){
      var code=S.items[k].itemcode;
      var tok=String(code||'').toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
      var num=tok.filter(function(t){ return /\d/.test(t); });
      var usar=(num.join('').length>=4) ? num : tok;
      if(usar.join('').length<4) return;
      var pat='*'+usar.join('*')+'*';
      var q='(itemcode.ilike.'+pat+',suppcatnum.ilike.'+pat+',codebars.ilike.'+pat+')';
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,suppcatnum,codebars'
        +'&or='+encodeURIComponent(q)+'&limit=40',{headers:SBH});
      if(!r.ok) return;
      var cands=await r.json()||[];
      var campos2=['itemcode','suppcatnum','codebars'];
      for(var c2=0;c2<campos2.length;c2++){
        var mapa={};
        cands.forEach(function(x){ if(x[campos2[c2]]) mapa[x[campos2[c2]]]=x; });
        var m=null; try{ m=_refEmparejar(Object.keys(mapa), code); }catch(e){}
        if(m){
          var x=mapa[m.codigo];
          trad[k]={itemcode:x.itemcode, itemname:x.itemname, modo:m.modo};
          return;
        }
      }
    };
    for(var i=0;i<sinTrad.length;i+=6){
      await Promise.all(sinTrad.slice(i,i+6).map(buscarUna));
    }
  }catch(e){ _dbg('[CMP] emparejar: '+(e.message||e)); }

  var sap=claves.map(function(k){
    return (trad[k] && trad[k].itemcode) || S.items[k].itemcode; });
  var unicos=[...new Set(sap.filter(Boolean))];

  // 2. El último FOB facturado: líneas de facturas reserva de ese artículo
  var ultimo={};
  try{
    for(var i=0;i<unicos.length;i+=60){
      var lote=unicos.slice(i,i+60).map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/opch_reserva_lineas?select=itemcode,precio,docentry'
        +'&itemcode=in.('+lote.join(',')+')&limit=8000',{headers:SBH});
      if(!r.ok) continue;
      var ls=await r.json()||[];
      var entries=[...new Set(ls.map(function(x){ return x.docentry; }))];
      var cab={};
      for(var j=0;j<entries.length;j+=200){
        var rc=await fetch(SB+'/rest/v1/opch_reserva?select=docentry,docnum,docdate'
          +'&docentry=in.('+entries.slice(j,j+200).join(',')+')',{headers:SBH});
        if(rc.ok) (await rc.json()||[]).forEach(function(x){ cab[String(x.docentry)]=x; });
      }
      ls.forEach(function(l){
        var h=cab[String(l.docentry)]||{};
        var k=String(l.itemcode);
        var f=String(h.docdate||'');
        if(!ultimo[k] || f>ultimo[k].fecha){
          ultimo[k]={precio:Number(l.precio)||0, fecha:f, docnum:h.docnum};
        }
      });
    }
  }catch(e){ _dbg('[CMP] facturas reserva: '+(e.message||e)); }

  // 3. Lo que está por llegar: líneas de órdenes con cantidad pendiente
  var enCamino={};
  try{
    for(var i=0;i<unicos.length;i+=60){
      var lote=unicos.slice(i,i+60).map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/opor_lineas?select=itemcode,precio,docnum,cantidad_pendiente'
        +'&itemcode=in.('+lote.join(',')+')&limit=8000',{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(l){
        if((Number(l.cantidad_pendiente)||0)<=0) return;
        var k=String(l.itemcode);
        if(!enCamino[k] || Number(l.docnum)>Number(enCamino[k].docnum)){
          enCamino[k]={precio:Number(l.precio)||0, docnum:l.docnum,
                       pendiente:Number(l.cantidad_pendiente)||0};
        }
      });
    }
  }catch(e){ _dbg('[CMP] por llegar: '+(e.message||e)); }

  S.filas=claves.map(function(k){
    var it=S.items[k];
    var code=(trad[k] && trad[k].itemcode) || it.itemcode;
    return {clave:k, ofrecido:it.itemcode, sap:code,
            nombre:(trad[k]&&trad[k].itemname)||it.nombre||'',
            cantidad:Number(it.cantidad)||0,
            precio:Number(it.precio)||0,
            enSap:!!trad[k],
            ultimo:ultimo[String(code)]||null,
            camino:enCamino[String(code)]||null};
  }).sort(function(a,b){ return String(a.sap).localeCompare(String(b.sap)); });
}

function _cmpPct(nuevo, viejo){
  if(!(viejo>0) || !(nuevo>0)) return null;
  return (nuevo-viejo)/viejo*100;
}

function _cmpCelda(v, pct){
  if(v==null) return '<td style="text-align:right;color:var(--text-muted)">—</td>';
  var col = pct==null ? '' : (pct>0.5 ? 'color:var(--t-rojo);font-weight:700'
                           : (pct<-0.5 ? 'color:var(--t-verde);font-weight:700' : ''));
  return '<td style="text-align:right;'+col+'">'+_fmtN2(v)
    +(pct!=null?('<div style="font-size:9.5px">'+(pct>0?'+':'')+pct.toFixed(1)+'%</div>'):'')
    +'</td>';
}

function _cmpPintar(){
  var c=document.getElementById('cmpCuerpo'); if(!c) return;
  var S=window._cmp; if(!S) return;
  var suben=S.filas.filter(function(f){
    var p=_cmpPct(f.precio, f.ultimo&&f.ultimo.precio); return p!=null && p>0.5; }).length;
  var bajan=S.filas.filter(function(f){
    var p=_cmpPct(f.precio, f.ultimo&&f.ultimo.precio); return p!=null && p<-0.5; }).length;
  var sinRef=S.filas.filter(function(f){ return !f.ultimo && !f.camino; }).length;

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-scale" style="font-size:21px;color:var(--t-lila)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +'Comparación de precios · revisión de compras</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Borrador para revisar antes de '
    +'mandar a gerencia. Se compara el precio que ofrece el proveedor con el último FOB '
    +'pagado y con el FOB de lo que viene en camino.</div></div>'
    +'<button class="xb" onclick="_cmpCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<label style="display:flex;align-items:center;gap:10px;padding:11px 14px;'
    +'border:1.5px dashed var(--t-lila);border-radius:10px;cursor:pointer;'
    +'background:var(--surface-0);margin-bottom:10px">'
    +'<i class="ti ti-file-upload" style="font-size:20px;color:var(--t-lila)"></i>'
    +'<div style="flex:1"><div style="font-size:12.5px;font-weight:700;color:var(--t-lila)">'
    +(S.archivo?('Documento: '+_esc(S.archivo)):'SUBIR LA ORDEN DEL PROVEEDOR')+'</div>'
    +'<div style="font-size:10.5px;color:var(--text-muted)">PDF, Excel o foto. La IA saca '
    +'las referencias y los precios ofrecidos.</div></div>'
    +(S.leyendo?'<span class="ai-ring"></span>':'')
    +'<input type="file" accept=".pdf,.xlsx,.xls,.csv,image/*" style="display:none" '
    +'onchange="_cmpArchivo(this)"></label>'
    +(S.error?('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +_esc(S.error)+'</div>'):'')
    +(S.filas.length?(
        '<div style="display:flex;gap:8px;flex-wrap:wrap;font-size:11px;margin-bottom:7px">'
        +'<span><b>'+S.filas.length+'</b> referencia(s)</span>'
        +(suben?('<span style="background:var(--pastel-error);color:var(--t-rojo);'
          +'border-radius:8px;padding:2px 8px"><b>'+suben+'</b> suben de precio</span>'):'')
        +(bajan?('<span style="background:var(--pastel-ok);color:var(--t-verde);'
          +'border-radius:8px;padding:2px 8px"><b>'+bajan+'</b> bajan</span>'):'')
        +(sinRef?('<span style="background:var(--surface-1);color:var(--text-muted);'
          +'border-radius:8px;padding:2px 8px">'+sinRef+' sin referencia previa</span>'):'')
        +'</div>'
        +'<div class="tbx-box" style="max-height:52vh;overflow:auto"><table class="tbx">'
        +'<thead><tr><th style="width:140px">Referencia</th><th>Descripción</th>'
        +'<th style="width:80px;text-align:right">Cantidad</th>'
        +'<th style="width:95px;text-align:right">FOB ofrecido</th>'
        +'<th style="width:110px;text-align:right">FOB última factura</th>'
        +'<th style="width:110px;text-align:right">FOB por llegar</th>'
        +'<th style="width:150px">De dónde salen</th></tr></thead><tbody>'
        + S.filas.map(function(f){
            var pU=_cmpPct(f.precio, f.ultimo&&f.ultimo.precio);
            var pC=_cmpPct(f.precio, f.camino&&f.camino.precio);
            return '<tr>'
              +'<td><b>'+_esc(f.sap)+'</b>'
              +(String(f.sap)!==String(f.ofrecido)
                ? ('<div style="font-size:9.5px;color:var(--t-marron)">proveedor: '
                   +_esc(f.ofrecido)+'</div>') : '')+'</td>'
              +'<td style="font-size:11px">'+_esc(String(f.nombre||'').slice(0,42))+'</td>'
              +'<td style="text-align:right">'+_fmtN2(f.cantidad)+'</td>'
              +'<td style="text-align:right;font-weight:700">'+_fmtN2(f.precio)+'</td>'
              + _cmpCelda(f.ultimo?f.ultimo.precio:null, pU)
              + _cmpCelda(f.camino?f.camino.precio:null, pC)
              +'<td style="font-size:10px;color:var(--text-muted)">'
              +(f.ultimo?('Factura #'+_esc(f.ultimo.docnum)+' · '+_esc(_fechaCorta(f.ultimo.fecha))):'')
              +(f.camino?('<div>Orden #'+_esc(f.camino.docnum)+' · '
                 +_fmtN2(f.camino.pendiente)+' pend.</div>'):'')
              +(!f.ultimo&&!f.camino
                 ?(f.enSap?'sin compras en los últimos 2 años'
                  :'<span style="color:var(--text-danger)">no encontrada en SAP</span>'):'')
              +'</td></tr>';
          }).join('')
        +'</tbody></table></div>'
        +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px">'
        +'<button class="btn bg2" style="padding:9px 14px" onclick="_cmpCerrar()">Cerrar</button>'
        +'<button class="btn bg2" style="padding:9px 14px" onclick="_cmpExcel()">'
        +'<i class="ti ti-file-spreadsheet"></i> Excel</button>'
        +'<button class="btn bp" style="padding:9px 16px" onclick="_cmpImprimir()">'
        +'<i class="ti ti-printer"></i> Imprimir la revisión</button></div>')
      :'');
}

function _cmpExcel(){
  var S=window._cmp;
  if(!S||!S.filas.length) return;
  if(typeof XLSX==='undefined'){ showT('No está cargado el lector de Excel'); return; }
  var filas=S.filas.map(function(f){
    return {'Referencia':f.sap, 'Ref. del proveedor':f.ofrecido, 'Descripción':f.nombre,
            'Cantidad':f.cantidad, 'FOB ofrecido':f.precio,
            'FOB última factura':f.ultimo?f.ultimo.precio:'',
            'Factura':f.ultimo?('#'+f.ultimo.docnum+' '+String(f.ultimo.fecha).slice(0,10)):'',
            'FOB por llegar':f.camino?f.camino.precio:'',
            'Orden en camino':f.camino?('#'+f.camino.docnum):'',
            '% vs última':_cmpPct(f.precio, f.ultimo&&f.ultimo.precio),
            '% vs por llegar':_cmpPct(f.precio, f.camino&&f.camino.precio)};
  });
  var h=XLSX.utils.json_to_sheet(filas), w=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(w, h, 'Comparación');
  XLSX.writeFile(w, 'Comparacion_precios_'+_hoyISO()+'.xlsx');
}

// La revisión, lista para imprimir junto al documento del proveedor
function _cmpImprimir(){
  var S=window._cmp;
  if(!S||!S.filas.length) return;
  var w=window.open('','_blank');
  if(!w){ showT('El navegador bloqueó la ventana'); return; }
  var fila=function(f){
    var pU=_cmpPct(f.precio, f.ultimo&&f.ultimo.precio);
    var pC=_cmpPct(f.precio, f.camino&&f.camino.precio);
    var col=function(p){ return p==null?'':(p>0.5?'color:#b91c1c;font-weight:bold'
                                          :(p<-0.5?'color:#15803d;font-weight:bold':'')); };
    return '<tr><td><b>'+_esc(f.sap)+'</b>'
      +(String(f.sap)!==String(f.ofrecido)?('<br><span class="peq">prov: '
        +_esc(f.ofrecido)+'</span>'):'')+'</td>'
      +'<td>'+_esc(f.nombre||'')+'</td>'
      +'<td class="d">'+_fmtN2(f.cantidad)+'</td>'
      +'<td class="d"><b>'+_fmtN2(f.precio)+'</b></td>'
      +'<td class="d" style="'+col(pU)+'">'+(f.ultimo?_fmtN2(f.ultimo.precio):'—')
      +(pU!=null?('<br><span class="peq">'+(pU>0?'+':'')+pU.toFixed(1)+'%</span>'):'')+'</td>'
      +'<td class="d" style="'+col(pC)+'">'+(f.camino?_fmtN2(f.camino.precio):'—')
      +(pC!=null?('<br><span class="peq">'+(pC>0?'+':'')+pC.toFixed(1)+'%</span>'):'')+'</td>'
      +'<td class="peq">'+(f.ultimo?('Fact. #'+_esc(f.ultimo.docnum)+' '
        +_esc(_fechaCorta(f.ultimo.fecha))):'')
      +(f.camino?('<br>Orden #'+_esc(f.camino.docnum)):'')
      +(!f.ultimo&&!f.camino?(f.enSap?'sin compras en 2 años':'no encontrada en SAP'):'')+'</td></tr>';
  };
  w.document.write('<html><head><meta charset="utf-8">'
    +'<title>Comparación de precios</title><style>'
    +'body{font-family:Arial,Helvetica,sans-serif;padding:24px;color:#111}'
    +'h1{font-size:17px;margin:0 0 3px}h2{font-size:12px;font-weight:400;color:#555;margin:0 0 14px}'
    +'table{width:100%;border-collapse:collapse;font-size:10.5px}'
    +'th{background:#eef2f7;text-align:left;padding:5px;border:1px solid #cbd5e1}'
    +'td{padding:4px 5px;border:1px solid #e2e8f0;vertical-align:top}'
    +'.d{text-align:right}.peq{font-size:9px;color:#666}'
    +'.noprint{margin-top:16px}@media print{.noprint{display:none}}</style></head><body>'
    +'<h1>KENNEDY CENTER CORP · Comparación de precios antes de la firma</h1>'
    +'<h2>Documento del proveedor: '+_esc(S.archivo||'')+' · '+_esc(_fechaCorta(_hoyISO()))
    +' · revisado por '+_esc((CU&&CU.name)||'')+' · '+S.filas.length+' referencias</h2>'
    +'<table><thead><tr><th>Referencia</th><th>Descripción</th><th>Cant.</th>'
    +'<th>FOB ofrecido</th><th>FOB última factura</th><th>FOB por llegar</th>'
    +'<th>Origen</th></tr></thead><tbody>'
    + S.filas.map(fila).join('')
    +'</tbody></table>'
    +'<div class="noprint"><button onclick="window.print()" style="background:#0c447c;'
    +'color:#fff;border:none;border-radius:7px;padding:9px 18px;font-size:13px;'
    +'cursor:pointer">Imprimir o guardar como PDF</button>'
    +'<p style="font-size:11px;color:#555">Imprime esta hoja y el documento del proveedor '
    +'juntos: son las dos caras de la misma revisión.</p></div></body></html>');
  w.document.close();
}

/* ═══════════════════════════════════════════════════════════════════════════
   CONTROL DE PRECIOS   (prefijo [CP])
   ───────────────────────────────────────────────────────────────────────────
   Una hoja tipo Excel para revisar y montar precios de venta: referencia,
   costo FOB, costo CIF, precio de venta y el margen que deja ese precio
   sobre el FOB y sobre el CIF.

   De dónde salen los artículos, a elegir:
     · todo el inventario, filtrando por departamento y por marca
     · solo la mercancía POR LLEGAR (lo que está pedido y no ha entrado)
     · los de una ORDEN DE COMPRA o de una FACTURA RESERVA concretas

   Se exporta a Excel, se puede pegar de vuelta una lista de precios en
   bloque, y con un botón los precios se escriben en SAP por DI API.
   ═══════════════════════════════════════════════════════════════════════════ */

window._cp = null;

function _cpAbrir(){
  window._cp={fuente:'inventario', dept:'', marca:'', q:'', doc:'',
              filas:[], orig:{}, cargando:false, error:'', marcas:[],
              fc:{}, lim:120, lista:3};
  var ov=document.createElement('div');
  ov.id='modalCP';
  // A pantalla completa: esta hoja se usa para trabajar, no para mirar
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:10066;'
    +'display:flex;flex-direction:column;padding:12px 14px;overflow:hidden';
  ov.innerHTML='<div id="cpCuerpo" style="display:flex;flex-direction:column;'
    +'height:100%;min-height:0"></div>';
  document.body.appendChild(ov);
  _cpPintar();
  _cpCargar();
}

function _cpCerrar(){
  var m=document.getElementById('modalCP'); if(m) m.remove();
  window._cp=null;
}

function _cpSet(campo, v){
  var S=window._cp; if(!S) return;
  S[campo]=v;
  if(campo==='fuente'){ S.doc=''; }
  _cpPintar();
  if(campo!=='q') _cpCargar();
}

// Trae una tabla entera por páginas, sin quedarse en el primer tope
async function _cpTraerTodo(url, paso, clave){
  // Sin un orden fijo, cada página puede devolver filas repetidas: por eso
  // salían 40.000 artículos de los 12.491 que hay. Se pide ordenado y se
  // quitan los repetidos por su código.
  var n=paso||1000, off=0, todo=[], vistos={}, k=clave||'itemcode';
  var sep=(url.indexOf('?')>=0)?'&':'?';
  for(var v=0; v<40; v++){
    var r=await fetch(url+sep+'order='+k+'.asc&limit='+n+'&offset='+off,{headers:SBH});
    if(!r.ok) throw new Error(url.split('/rest/v1/')[1].split('?')[0]+' '+r.status);
    var lote=await r.json()||[];
    lote.forEach(function(x){
      var id=String(x[k]||'');
      if(id && vistos[id]) return;
      if(id) vistos[id]=1;
      todo.push(x);
    });
    if(lote.length<n) break;
    off+=n;
  }
  return todo;
}

async function _cpCargar(){
  var S=window._cp; if(!S) return;
  S.cargando=true; S.error=''; _cpPintar();
  try{
    var codigos=null;     // si la fuente es un documento, los artículos de ahí
    var extra={};         // cantidades de ese documento
    if(S.fuente==='oc' || S.fuente==='fr'){
      if(!String(S.doc||'').trim()){ S.filas=[]; S.cargando=false; return _cpPintar(); }
      if(S.fuente==='oc'){
        var r=await fetch(SB+'/rest/v1/opor_lineas?select=itemcode,cantidad,cantidad_pendiente,'
          +'precio&docnum=eq.'+encodeURIComponent(S.doc)+'&limit=3000',{headers:SBH});
        if(!r.ok) throw new Error('orden '+r.status);
        var ls=await r.json()||[];
        if(!ls.length) throw new Error('la orden #'+S.doc+' no tiene líneas en el portal');
        codigos=[]; ls.forEach(function(l){
          codigos.push(String(l.itemcode));
          extra[String(l.itemcode)]={cant:Number(l.cantidad)||0,
                                     pend:Number(l.cantidad_pendiente)||0,
                                     fobDoc:Number(l.precio)||0};
        });
      } else {
        var rc=await fetch(SB+'/rest/v1/opch_reserva?select=docentry&docnum=eq.'
          +encodeURIComponent(S.doc),{headers:SBH});
        var cab=(rc.ok?((await rc.json())||[]):[])[0];
        if(!cab) throw new Error('no encuentro la factura reserva #'+S.doc);
        var rl=await fetch(SB+'/rest/v1/opch_reserva_lineas?select=itemcode,cantidad,precio'
          +'&docentry=eq.'+cab.docentry+'&limit=3000',{headers:SBH});
        var ls2=rl.ok ? (await rl.json()||[]) : [];
        codigos=[]; ls2.forEach(function(l){
          codigos.push(String(l.itemcode));
          extra[String(l.itemcode)]={cant:Number(l.cantidad)||0, fobDoc:Number(l.precio)||0};
        });
      }
      codigos=[...new Set(codigos.filter(Boolean))];
    }

    var filas=[];
    if(codigos){
      for(var i=0;i<codigos.length;i+=80){
        var lote=codigos.slice(i,i+80).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
        var r2=await fetch(SB+'/rest/v1/inventario?select=*&itemcode=in.('+lote.join(',')+')',
          {headers:SBH});
        if(r2.ok) filas=filas.concat(await r2.json()||[]);
      }
    } else {
      // El departamento NO se filtra en la consulta: en el inventario el
      // grupo viene escrito como «163 ..Hogar», no como la clave «hogar»,
      // y por eso el filtro no devolvía nada. Se filtra aquí con la misma
      // función que usa el resto del portal.
      // El inventario tiene más de 12.000 artículos y antes se pedían 8.000
      // de una vez: lo que quedaba fuera no aparecía nunca. Ahora se trae
      // por páginas hasta acabar.
      filas=await _cpTraerTodo(SB+'/rest/v1/inventario?select=*'
        +(S.fuente==='porllegar'?'&onorder=gt.0':''));

      // «Por llegar» según SAP es onorder, pero si ese campo viniera en cero
      // se completa con las órdenes que tienen cantidad pendiente.
      if(S.fuente==='porllegar'){
        var pend={};
        var ls=await _cpTraerTodo(SB+'/rest/v1/opor_lineas'
          +'?select=id,itemcode,cantidad_pendiente&cantidad_pendiente=gt.0', 1000, 'id');
        ls.forEach(function(l){
          var k=String(l.itemcode||'').trim();
          if(k) pend[k]=(pend[k]||0)+(Number(l.cantidad_pendiente)||0);
        });
        var ya={};
        filas.forEach(function(x){ ya[String(x.itemcode)]=1; });
        var faltan=Object.keys(pend).filter(function(k){ return !ya[k]; });
        for(var i=0;i<faltan.length;i+=80){
          var lote=faltan.slice(i,i+80).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
          var rr=await fetch(SB+'/rest/v1/inventario?select=*&itemcode=in.('
            +lote.join(',')+')',{headers:SBH});
          if(rr.ok) filas=filas.concat(await rr.json()||[]);
        }
        filas.forEach(function(x){
          var p=pend[String(x.itemcode)];
          if(p && !(Number(x.onorder)>0)) x.onorder=p;
        });
      }
    }

    S.filas=filas.map(function(x){
      var k=String(x.itemcode);
      var e=extra[k]||{};
      return {itemcode:k, itemname:x.itemname||'', marca:x.marca||'', grupo:x.grupo||'',
              fob:Number(e.fobDoc||x.fob)||0, cif:Number(x.cif)||0,
              precio:Number(x.precioventa)||0,
              stock:Number(x.onhand)||0, porllegar:Number(x.onorder)||0,
              cantDoc:Number(e.cant||0), pendDoc:Number(e.pend||0)};
    });
    S.orig={};
    S.filas.forEach(function(f){ S.orig[f.itemcode]=f.precio; });
    S.lim=120;
    // TODAS las marcas del inventario, no solo las de lo que se ve ahora
    if(!S.marcas.length){
      try{
        var rm=await fetch(SB+'/rest/v1/inventario?select=marca&marca=not.is.null&limit=20000',
          {headers:SBH});
        var mm={};
        (rm.ok?(await rm.json()||[]):[]).forEach(function(x){
          var v=String(x.marca||'').trim(); if(v) mm[v]=1; });
        S.marcas=Object.keys(mm).sort();
        _dbg('[CP] marcas en el inventario: '+S.marcas.length);
      }catch(e){}
    }
  }catch(e){
    S.error=String(e.message||e); S.filas=[];
  }
  S.cargando=false;
  _cpPintar();
}

function _cpVisibles(){
  var S=window._cp;
  var q=String(S.q||'').toLowerCase().trim();
  var fc=S.fc||{};
  var num=function(v, filtro){
    // «>10», «<5», «10-20» o un número suelto
    var t=String(filtro||'').replace(/\s/g,'');
    if(!t) return true;
    var n=Number(v)||0;
    var m;
    if((m=t.match(/^>=?(-?[\d.,]+)$/))) return n>=Number(m[1].replace(',','.'));
    if((m=t.match(/^<=?(-?[\d.,]+)$/))) return n<=Number(m[1].replace(',','.'));
    if((m=t.match(/^(-?[\d.,]+)-(-?[\d.,]+)$/)))
      return n>=Number(m[1].replace(',','.')) && n<=Number(m[2].replace(',','.'));
    return String(v).indexOf(t)>=0;
  };
  var lista=(S.filas||[]).filter(function(f){
    if(S.dept && normDept(f.grupo)!==S.dept) return false;
    if(S.marca && f.marca!==S.marca) return false;
    if(q && (f.itemcode+' '+f.itemname+' '+f.marca).toLowerCase().indexOf(q)<0) return false;
    if(fc.itemcode && String(f.itemcode).toLowerCase().indexOf(fc.itemcode.toLowerCase())<0) return false;
    if(fc.itemname && String(f.itemname).toLowerCase().indexOf(fc.itemname.toLowerCase())<0) return false;
    if(fc.marca && String(f.marca).toLowerCase().indexOf(fc.marca.toLowerCase())<0) return false;
    if(!num(f.stock, fc.stock)) return false;
    if(!num(f.porllegar, fc.porllegar)) return false;
    if(!num(f.fob, fc.fob)) return false;
    if(!num(f.cif, fc.cif)) return false;
    if(!num(f.precio, fc.precio)) return false;
    if(fc.mfob && !num(_cpMargen(f.precio,f.fob)||0, fc.mfob)) return false;
    if(fc.mcif && !num(_cpMargen(f.precio,f.cif)||0, fc.mcif)) return false;
    return true;
  });
  if(S.ord){
    var k=S.ord, dir=S.ordDesc?-1:1;
    var val=function(f){
      if(k==='mfob') return _cpMargen(f.precio,f.fob);
      if(k==='mcif') return _cpMargen(f.precio,f.cif);
      return f[k];
    };
    lista=lista.slice().sort(function(a,b){
      var x=val(a), y=val(b);
      var nx=(x===''||x==null), ny=(y===''||y==null);
      if(nx&&ny) return 0;
      if(nx) return 1;            // lo vacío, siempre al final
      if(ny) return -1;
      if(typeof x==='number' || typeof y==='number' ||
         (!isNaN(Number(x)) && !isNaN(Number(y)) && String(x).trim()!=='')){
        return (Number(x)-Number(y))*dir;
      }
      return String(x).localeCompare(String(y), 'es', {numeric:true})*dir;
    });
  }
  return lista;
}

// Ordenar por cualquier columna, con su flechita
function _cpOrden(campo){
  var S=window._cp; if(!S) return;
  if(S.ord===campo) S.ordDesc=!S.ordDesc;
  else { S.ord=campo; S.ordDesc=false; }
  S.lim=120;
  _cpPintar();
}

function _cpFlecha(campo){
  var S=window._cp||{};
  if(S.ord!==campo) return '<span style="opacity:.35">↕</span>';
  return '<span style="color:var(--fill-accent)">'+(S.ordDesc?'▼':'▲')+'</span>';
}

function _cpFc(campo, v){
  var S=window._cp; if(!S) return;
  S.fc=S.fc||{};
  S.fc[campo]=v;
  S.lim=120;
  _cpPintar();
  // Si se busca una referencia concreta y no aparece, se pregunta por ella
  // directamente: puede que esté en SAP pero fuera de lo que se cargó.
  if(campo==='itemcode' && String(v||'').trim().length>=4 && !_cpVisibles().length){
    clearTimeout(window._cpBT);
    window._cpBT=setTimeout(function(){ _cpBuscarSuelto(v); }, 350);
  }
  setTimeout(function(){
    var el=document.getElementById('cpf-'+campo);
    if(el){ el.focus(); el.selectionStart=el.value.length; }
  }, 30);
}

// Busca una referencia suelta en el inventario y la añade a la hoja
async function _cpBuscarSuelto(q){
  var S=window._cp; if(!S) return;
  try{
    var t=encodeURIComponent('*'+String(q).trim()+'*');
    var r=await fetch(SB+'/rest/v1/inventario?select=*'
      +'&or=(itemcode.ilike.'+t+',itemname.ilike.'+t+')&limit=50',{headers:SBH});
    if(!r.ok) return;
    var nuevos=(await r.json()||[]).filter(function(x){
      return !(S.filas||[]).some(function(f){
        return String(f.itemcode)===String(x.itemcode); }); });
    if(!nuevos.length) return;
    nuevos.forEach(function(x){
      var f={itemcode:String(x.itemcode), itemname:x.itemname||'', marca:x.marca||'',
             grupo:x.grupo||'', fob:Number(x.fob)||0, cif:Number(x.cif)||0,
             precio:Number(x.precioventa)||0, stock:Number(x.onhand)||0,
             porllegar:Number(x.onorder)||0, cantDoc:0, pendDoc:0};
      S.filas.push(f);
      S.orig[f.itemcode]=f.precio;
    });
    _cpPintar();
    showT('✓ '+nuevos.length+' artículo(s) encontrados y añadidos a la hoja');
  }catch(e){}
}

// Scroll infinito: se van pintando más filas según se baja
function _cpScroll(el){
  var S=window._cp; if(!S) return;
  if(el.scrollTop+el.clientHeight < el.scrollHeight-120) return;
  var vis=_cpVisibles();
  if(S.lim>=vis.length) return;
  S.lim+=120;
  _cpPintar();
  var n=document.getElementById('cpTabla');
  if(n) n.scrollTop=el.scrollTop;
}

// Moverse como en un Excel: Enter y flechas bajan, Ctrl+D rellena
function _cpTecla(ev, code){
  var k=String(ev.key||'');
  if((ev.ctrlKey||ev.metaKey) && k.toLowerCase()==='d'){
    ev.preventDefault();
    var S=window._cp, vis=_cpVisibles();
    var i=vis.findIndex(function(f){ return f.itemcode===code; });
    if(i<0) return;
    var v=Number(String(ev.target.value).replace(',','.'))||0;
    var n=0;
    for(var j=i;j<Math.min(vis.length, S.lim);j++){ vis[j].precio=v; n++; }
    _cpPintar();
    showT('✓ '+_fmtN2(v)+' puesto en '+n+' fila(s)');
    return;
  }
  if(k!=='Enter' && k!=='ArrowDown' && k!=='ArrowUp') return;
  ev.preventDefault();
  var vis2=_cpVisibles();
  var idx=vis2.findIndex(function(f){ return f.itemcode===code; });
  var sig=vis2[idx+(k==='ArrowUp'?-1:1)];
  if(!sig) return;
  var el=document.getElementById('cpp-'+_cpId(sig.itemcode));
  if(el){ el.focus(); el.select(); }
}

function _cpId(code){ return String(code).replace(/[^A-Za-z0-9]/g,'_'); }

function _cpMargen(precio, costo){
  if(!(precio>0) || !(costo>0)) return null;
  return (precio-costo)/precio*100;      // margen sobre el precio de venta
}

function _cpSetPrecio(code, v){
  var S=window._cp; if(!S) return;
  var f=(S.filas||[]).filter(function(x){ return x.itemcode===code; })[0];
  if(!f) return;
  f.precio=Number(String(v).replace(',','.'))||0;
  _cpPintar();
}

function _cpPaste(ev, code){
  var texto='';
  try{ texto=(ev.clipboardData||window.clipboardData).getData('text'); }catch(e){ return; }
  if(!texto || (texto.indexOf('\t')<0 && texto.indexOf('\n')<0)) return;
  ev.preventDefault();
  var S=window._cp;
  var vis=_cpVisibles();
  var desde=vis.findIndex(function(f){ return f.itemcode===code; });
  if(desde<0) desde=0;
  var lineas=texto.replace(/\r/g,'').split('\n').filter(function(x){ return x.trim()!==''; });
  var n=0, porRef=0;
  lineas.forEach(function(linea, r){
    var celdas=linea.split('\t').map(function(x){ return String(x).trim(); });
    // Si la primera casilla es una referencia conocida, se pega POR
    // REFERENCIA: así da igual el orden de la lista que traigan.
    var ref=celdas[0];
    var f=(S.filas||[]).filter(function(x){
      return _ocNormSku(x.itemcode)===_ocNormSku(ref); })[0];
    if(f && celdas.length>1){
      var v=Number(String(celdas[celdas.length-1]).replace(/[^0-9.,-]/g,'').replace(',','.'));
      if(v>0){ f.precio=v; n++; porRef++; }
      return;
    }
    var g=vis[desde+r];
    if(!g) return;
    var v2=Number(String(celdas[0]).replace(/[^0-9.,-]/g,'').replace(',','.'));
    if(v2>0){ g.precio=v2; n++; }
  });
  _cpPintar();
  showT('✓ '+n+' precio(s) pegados'+(porRef?(' · '+porRef+' emparejados por referencia'):''));
}

function _cpPintar(){
  var c=document.getElementById('cpCuerpo'); if(!c) return;
  var S=window._cp; if(!S) return;
  var vis=_cpVisibles();
  var cambiados=(S.filas||[]).filter(function(f){
    return Math.abs((Number(f.precio)||0)-(Number(S.orig[f.itemcode])||0))>0.001; });
  var est='padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;'
    +'font-size:12px;background:var(--surface-0);color:var(--text-primary)';
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;'
    +'font-size:12.5px;padding:5px 6px;text-align:right;color:var(--text-primary)';
  var fuente=function(k,t){
    var on=(S.fuente===k);
    return '<span onclick="_cpSet(\'fuente\',\''+k+'\')" style="cursor:pointer;font-size:11px;'
      +'padding:4px 11px;border-radius:20px;border:0.5px solid '
      +(on?'transparent':'var(--border)')+';background:'+(on?'var(--fill-accent)':'var(--surface-0)')
      +';color:'+(on?'#fff':'var(--text-secondary)')+'">'+t+'</span>';
  };
  var fcaja=function(campo, ph){
    return '<input id="cpf-'+campo+'" value="'+_esc((S.fc||{})[campo]||'')+'" '
      +'placeholder="'+_esc(ph||'')+'" '
      +'oninput="clearTimeout(window._cpFT);var v=this.value;'
      +'window._cpFT=setTimeout(function(){_cpFc(\''+campo+'\',v)},250)" '
      +'style="width:100%;box-sizing:border-box;font-size:10.5px;padding:2px 5px;'
      +'border:0.5px solid var(--border);border-radius:5px;background:var(--surface-0);'
      +'color:var(--text-primary)">';
  };
  var col=function(m){
    return m==null?'' : (m<15?'color:var(--t-rojo);font-weight:700'
                       : (m>=30?'color:var(--t-verde)':'color:var(--t-marron)'));
  };

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px">'
    +'<i class="ti ti-tag" style="font-size:21px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">Control de precios</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Costo FOB y CIF, precio de venta y '
    +'el margen que deja. Enter baja a la siguiente fila, Ctrl+D copia el precio hacia abajo, '
    +'y se puede pegar una lista entera desde Excel.</div></div>'
    +'<button class="btn bg2" style="padding:7px 13px" onclick="_cpCerrar()">'
    +'<i class="ti ti-x"></i> Cerrar</button></div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:7px">'
    + fuente('inventario','Todo el inventario')
    + fuente('porllegar','Solo lo que viene en camino')
    + fuente('oc','De una orden de compra')
    + fuente('fr','De una factura reserva')
    +((S.fuente==='oc'||S.fuente==='fr')
      ? ('<input value="'+_esc(S.doc)+'" placeholder="'
         +(S.fuente==='oc'?'N.º de orden (12625)':'N.º de factura reserva (25698)')+'" '
         +'onchange="_cpSet(\'doc\',this.value)" style="'+est+';width:180px">')
      : '')
    +'<select onchange="_cpSet(\'dept\',this.value)" style="'+est+'">'
    +'<option value="">Todos los departamentos</option>'
    + DEPTS_ALL.map(function(d){
        return '<option value="'+_esc(d)+'"'+(S.dept===d?' selected':'')+'>'
          +_esc(dL(d))+'</option>'; }).join('')
    +'</select>'
    +'<select onchange="_cpSet(\'marca\',this.value)" style="'+est+'">'
    +'<option value="">Todas las marcas'+((S.marcas||[]).length?(' ('+S.marcas.length+')'):'')+'</option>'
    + (S.marcas||[]).map(function(m){
        return '<option value="'+_esc(m)+'"'+(S.marca===m?' selected':'')+'>'
          +_esc(m)+'</option>'; }).join('')
    +'</select>'
    +'<span style="flex:1;font-size:11px;color:var(--text-muted);text-align:right">'
    +(S.cargando?'cargando…':(_fmtN2(vis.length)+' de '+_fmtN2((S.filas||[]).length)+' artículo(s)'))
    +(cambiados.length?(' · <b style="color:var(--t-marron)">'+cambiados.length
      +' con precio nuevo</b>'):'')+'</span>'
    +'</div>'
    +(S.error?('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +_esc(S.error)+'</div>'):'')
    +'<div id="cpTabla" onscroll="_cpScroll(this)" '
    +'style="flex:1;min-height:0;overflow:auto;border:0.5px solid var(--border);'
    +'border-radius:9px;background:var(--surface-0)">'
    +'<table class="tbx" style="width:100%;border-collapse:separate;border-spacing:0">'
    +'<thead><tr style="background:var(--surface-1)">'
    +'<th onclick="_cpOrden(\'itemcode\')" style="width:150px;position:sticky;top:0;z-index:3;'
    +'height:30px;background:var(--surface-1);cursor:pointer">Referencia '
    +_cpFlecha('itemcode')+'</th>'
    +'<th onclick="_cpOrden(\'itemname\')" style="width:300px;position:sticky;top:0;z-index:3;'
    +'background:var(--surface-1);cursor:pointer">Descripción '+_cpFlecha('itemname')+'</th>'
    +'<th onclick="_cpOrden(\'marca\')" style="width:120px;position:sticky;top:0;z-index:3;'
    +'background:var(--surface-1);cursor:pointer">Marca '+_cpFlecha('marca')+'</th>'
    +'<th onclick="_cpOrden(\'stock\')" style="width:85px;text-align:right;'
    +'position:sticky;top:0;z-index:3;background:var(--surface-1);cursor:pointer">Stock '
    +_cpFlecha('stock')+'</th>'
    +'<th onclick="_cpOrden(\'porllegar\')" style="width:90px;text-align:right;'
    +'position:sticky;top:0;z-index:3;background:var(--surface-1);cursor:pointer">Por llegar '
    +_cpFlecha('porllegar')+'</th>'
    +'<th onclick="_cpOrden(\'fob\')" style="width:90px;text-align:right;'
    +'position:sticky;top:0;z-index:3;background:var(--surface-1);cursor:pointer">FOB '
    +_cpFlecha('fob')+'</th>'
    +'<th onclick="_cpOrden(\'cif\')" style="width:90px;text-align:right;'
    +'position:sticky;top:0;z-index:3;background:var(--surface-1);cursor:pointer">CIF '
    +_cpFlecha('cif')+'</th>'
    +'<th style="width:130px;text-align:right;position:sticky;top:0;z-index:3;'
    +'background:#0c447c;color:#fff;border-left:2px solid #0c447c;'
    +'border-right:2px solid #0c447c;cursor:pointer" onclick="_cpOrden(\'precio\')">'
    +'PRECIO DE VENTA '+_cpFlecha('precio')+'</th>'
    +'<th onclick="_cpOrden(\'mfob\')" style="width:95px;text-align:right;'
    +'position:sticky;top:0;z-index:3;background:var(--surface-1);cursor:pointer">Margen /FOB '
    +_cpFlecha('mfob')+'</th>'
    +'<th onclick="_cpOrden(\'mcif\')" style="width:95px;text-align:right;'
    +'position:sticky;top:0;z-index:3;background:var(--surface-1);cursor:pointer">'
    +'Margen /CIF '+_cpFlecha('mcif')+'</th></tr>'
    // Una casilla de filtro por columna. En las de números valen >10, <5 o 10-20
    +'<tr>'
    + ['itemcode','itemname','marca','stock','porllegar','fob','cif','precio','mfob','mcif']
      .map(function(k){
        var ph={itemcode:'filtrar…', itemname:'filtrar…', marca:'filtrar…', stock:'>0',
                porllegar:'>0', fob:'<5', cif:'<5', precio:'>0', mfob:'>30', mcif:'<15'}[k];
        var esPrecio=(k==='precio');
        return '<th style="position:sticky;top:30px;z-index:3;padding:3px 4px;'
          +'background:'+(esPrecio?'#0c447c':'var(--surface-1)')+';'
          +(esPrecio?'border-left:2px solid #0c447c;border-right:2px solid #0c447c;':'')
          +'box-shadow:0 2px 4px rgba(0,0,0,.10)">'+fcaja(k, ph)+'</th>';
      }).join('')
    +'</tr></thead><tbody>'
    + vis.slice(0, S.lim).map(function(f, i){
        var mf=_cpMargen(f.precio, f.fob), mc=_cpMargen(f.precio, f.cif);
        var ch=Math.abs((Number(f.precio)||0)-(Number(S.orig[f.itemcode])||0))>0.001;
        var zebra=(i%2)?'background:var(--bg-accent)':'background:var(--surface-0)';
        return '<tr style="'+zebra+'" '
          +'onmouseover="this.style.filter=\'brightness(.97)\'" '
          +'onmouseout="this.style.filter=\'\'">'
          +'<td><b>'+_esc(f.itemcode)+'</b></td>'
          +'<td style="font-size:11.5px;max-width:300px;overflow:hidden;'
          +'text-overflow:ellipsis;white-space:nowrap" title="'+_esc(f.itemname)+'">'
          +_esc(String(f.itemname).slice(0,40))+'</td>'
          +'<td style="font-size:11px;color:var(--text-muted)">'+_esc(f.marca)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(f.stock)+'</td>'
          +'<td style="text-align:right">'+(f.porllegar?_fmtN2(f.porllegar):'—')+'</td>'
          +'<td style="text-align:right">'+_fmtN2(f.fob)+'</td>'
          +'<td style="text-align:right">'+_fmtN2(f.cif)+'</td>'
          +'<td style="padding:0;border-left:2px solid #0c447c;border-right:2px solid #0c447c;'
          +'background:'+(ch?'var(--pastel-aviso)':'#eef4fb')+'">'
          +'<input id="cpp-'+_cpId(f.itemcode)+'" inputmode="decimal" '
          +'value="'+(f.precio||'')+'" '
          +'onchange="_cpSetPrecio(\''+_esc(f.itemcode)+'\',this.value)" '
          +'onkeydown="_cpTecla(event,\''+_esc(f.itemcode)+'\')" '
          +'onpaste="_cpPaste(event,\''+_esc(f.itemcode)+'\')" '
          +'onfocus="this.select();this.parentNode.style.outline=\'2px solid #0c447c\'" '
          +'onblur="this.parentNode.style.outline=\'\'" style="'+inp
          +';font-size:13px;font-weight:700;color:'+(ch?'var(--t-marron)':'#0c447c')
          +'"></td>'
          +'<td style="text-align:right;'+col(mf)+'">'+(mf==null?'—':(mf.toFixed(1)+'%'))+'</td>'
          +'<td style="text-align:right;'+col(mc)+'">'+(mc==null?'—':(mc.toFixed(1)+'%'))+'</td>'
          +'</tr>';
      }).join('')
    +'</tbody></table>'
    +(S.lim<vis.length
      ? ('<div style="padding:10px;text-align:center;font-size:11px;color:var(--text-muted)">'
         +'Bajando salen más… ('+_fmtN2(S.lim)+' de '+_fmtN2(vis.length)+')</div>')
      : '')
    +'</div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px;flex-wrap:wrap">'
    +'<span style="font-size:11px;color:var(--text-muted);align-self:center">Escribir en</span>'
    +'<select onchange="window._cp.lista=Number(this.value)" style="'+est+'">'
    + [[3,'Precio de venta (lista 3)'],[1,'FOB (lista 1)'],[2,'CIF (lista 2)']]
        .map(function(o){
          return '<option value="'+o[0]+'"'+(((S.lista||3)===o[0])?' selected':'')+'>'
            +o[1]+'</option>'; }).join('')
    +'</select>'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_cpExcel()">'
    +'<i class="ti ti-file-spreadsheet"></i> Exportar lo modificado</button>'
    +'<button class="xb" style="padding:9px 12px" onclick="_cpExcel(true)" '
    +'title="La lista completa que estás viendo">Exportar todo</button>'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_cpCargar()">'
    +'<i class="ti ti-refresh"></i> Recargar</button>'
    +'<button class="btn bp" style="padding:9px 18px" onclick="_cpSubir()"'
    +(cambiados.length?'':' disabled')+'><i class="ti ti-database-edit"></i> '
    +'Actualizar '+cambiados.length+' precio(s) en SAP</button></div>';
}

function _cpExcel(todo){
  var S=window._cp;
  if(typeof XLSX==='undefined'){ showT('No está cargado el lector de Excel'); return; }
  // Por defecto se exporta SOLO lo que se ha modificado, que es lo que se
  // manda a revisar o se pega de vuelta. Con «todo» sale la lista entera.
  var vis=_cpVisibles().filter(function(f){
    return todo || Math.abs((Number(f.precio)||0)-(Number(S.orig[f.itemcode])||0))>0.001; });
  if(!vis.length){
    if(!todo && confirm('No has modificado ningún precio todavía.\n\n'
      +'¿Exporto la lista completa que estás viendo?')) return _cpExcel(true);
    return;
  }
  var filas=vis.map(function(f){
    return {'Referencia':f.itemcode, 'Descripción':f.itemname, 'Marca':f.marca,
            'Departamento':f.grupo, 'Stock':f.stock, 'Por llegar':f.porllegar,
            'FOB':f.fob, 'CIF':f.cif,
            'Precio anterior':Number(S.orig[f.itemcode])||0,
            'Precio de venta':f.precio,
            'Margen vs FOB %':_cpMargen(f.precio,f.fob),
            'Margen vs CIF %':_cpMargen(f.precio,f.cif)};
  });
  var h=XLSX.utils.json_to_sheet(filas), w=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(w, h, 'Control de precios');
  XLSX.writeFile(w, (todo?'Control_precios_':'Precios_modificados_')+_hoyISO()+'.xlsx');
  showT('✓ '+vis.length+(todo?' artículo(s) exportados':' precio(s) modificados exportados'));
}

async function _cpSubir(){
  var S=window._cp; if(!S) return;
  var cambiados=(S.filas||[]).filter(function(f){
    return Math.abs((Number(f.precio)||0)-(Number(S.orig[f.itemcode])||0))>0.001
        && (Number(f.precio)||0)>0; });
  if(!cambiados.length) return;
  var bajos=cambiados.filter(function(f){ return f.cif>0 && f.precio<f.cif; });
  if(bajos.length && !confirm(bajos.length+' artículo(s) quedarían por DEBAJO del costo CIF:\n\n'
    + bajos.slice(0,8).map(function(f){
        return '· '+f.itemcode+': '+_fmtN2(f.precio)+' (CIF '+_fmtN2(f.cif)+')'; }).join('\n')
    + '\n\n¿Los subo igual?')) return;
  if(!confirm('ACTUALIZAR PRECIOS EN SAP\n\n'+cambiados.length+' artículo(s)\n\n'
    + cambiados.slice(0,10).map(function(f){
        return '· '+f.itemcode+': '+_fmtN2(S.orig[f.itemcode])+' → '+_fmtN2(f.precio); }).join('\n')
    + (cambiados.length>10?('\n· … y '+(cambiados.length-10)+' más'):'')
    + '\n\nSe escriben en la lista de precio de venta por DI API. ¿Sigo?')) return;

  try{
    _frwAbrir();
    _frwPintarEspera('Actualizando '+cambiados.length+' precio(s) en SAP…',
      'El worker los escribe en la ficha de cada artículo.');
    var r=await _postTolerante(SB+'/rest/v1/precios_venta_queue', {
      items:cambiados.map(function(f){
        return {itemcode:f.itemcode, precio:Number(f.precio)||0, cif:Number(f.cif)||0}; }),
      lista:Number(S.lista)||3,
      origen:'control de precios', estado:'pendiente', creado_por:(CU&&CU.name)||''});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre precios_venta.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,150));
    }
    var reg=((await r.json())||[])[0];
    _cpSeguir(reg.id, Date.now());
  }catch(e){
    _frwCerrar();
    showT('No se pudo enviar: '+(e.message||e));
  }
}

function _cpSeguir(id, desde){
  clearTimeout(window._cpT);
  window._cpT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    try{
      var r=await fetch(SB+'/rest/v1/precios_venta_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q && q.estado==='hecha'){
        var av=(q.avisos||[]);
        var c=document.getElementById('frwCaja');
        if(c) c.innerHTML='<div style="width:78px;height:78px;margin:0 auto 14px;'
          +'border-radius:50%;background:'+(av.length?'var(--pastel-aviso)':'var(--pastel-ok)')
          +';display:flex;align-items:center;justify-content:center">'
          +'<i class="ti ti-check" style="font-size:46px;color:'
          +(av.length?'var(--t-marron)':'var(--t-verde)')+'"></i></div>'
          +'<div style="font-size:16px;font-weight:700;color:'
          +(av.length?'var(--t-marron)':'var(--t-verde)')+'">Precios actualizados en SAP</div>'
          +'<div style="font-size:44px;font-weight:800;line-height:1.2;margin-top:8px">'
          +(q.actualizados||0)+'</div>'
          +'<div style="font-size:11.5px;color:var(--text-muted)">artículo(s) en la lista '
          +(q.lista||'')+' · en el portal se ven tras el siguiente Sync</div>'
          // Los que no entraron, con su motivo: antes había que ir al log
          +(av.length?('<div style="margin-top:12px;text-align:left"><div style="font-size:12px;'
            +'font-weight:700;color:var(--t-marron);margin-bottom:4px">'
            +av.length+' no entraron:</div>'
            +'<div style="font-size:11px;background:var(--surface-1);border-radius:8px;'
            +'padding:8px;max-height:180px;overflow:auto">'
            + av.slice(0,40).map(function(x){ return '· '+_esc(x); }).join('<br>')
            +'</div></div>'):'')
          +'<button class="btn bp" style="margin-top:14px;width:100%;padding:11px" '
          +'onclick="_frwCerrar()">Listo</button>';
        var S=window._cp;
        if(S) (S.filas||[]).forEach(function(f){ S.orig[f.itemcode]=f.precio; });
        _cpPintar();
        return;
      }
      if(q && q.estado==='error'){ _frwPintarError(q.error_msg||''); return; }
      if(Date.now()-desde > 8*60*1000){
        _frwPintarError('El worker no ha respondido en 8 minutos. Sigue en la cola.');
        return;
      }
    }catch(e){}
    _cpSeguir(id, desde);
  }, 2500);
}

/* ═══════════════════════════════════════════════════════════════════════════
   SUBIR ITEMS A SAP   (prefijo [IS])
   ───────────────────────────────────────────────────────────────────────────
   La hoja de creación de artículos, dentro del portal: las mismas columnas
   del Excel, editables una a una o en bloque (pegar desde Excel, Ctrl+D para
   arrastrar hacia abajo). Antes de mandar nada se comprueba cada referencia
   contra SAP y se dice cuántas son NUEVAS (se crearán) y cuántas YA EXISTEN
   (solo se actualizan, sin tocar el código). Todo por DI API.
   ═══════════════════════════════════════════════════════════════════════════ */

window._is = null;

// Las columnas, en el mismo orden del Excel. «udf» va por título de SAP y
// «alias» por su nombre interno (los de alfombras).
var IS_COLS=[
  {k:'itemcode',        t:'KCC ITEM No.',            w:130, req:true},
  {k:'itemname',        t:'Spanish Description',     w:230, req:true},
  {k:'foreign_name',    t:'English Description',     w:210},
  {k:'grupo',           t:'Departamento',            w:120, req:true},
  {k:'barcode',         t:'BARCODE',                 w:130},
  {k:'proveedor',       t:'Proveedor',               w:90},
  {k:'marca',           t:'Marca',                   w:120},
  {k:'arancel',         t:'Arancel',                 w:140},
  {k:'shipping_type',   t:'Clase expedición',        w:110},
  {k:'foto',            t:"ITEM'S PHOTO",            w:120},
  {k:'remarks',         t:'Comentarios',             w:150},
  // Las tres listas de precios de Kennedy en SAP: 1 FOB, 2 CIF, 3 venta.
  // Se llena la que se quiera; la que se deje vacía no se toca.
  {k:'precio_fob',      t:'FOB (lista 1)',           w:95,  num:4, lista:1},
  {k:'precio_cif',      t:'CIF (lista 2)',           w:95,  num:4, lista:2},
  {k:'precio_venta',    t:'Precio venta (lista 3)',  w:110, num:4, lista:3},
  {k:'moneda',          t:'Moneda',                  w:75},
  {k:'cod_medida',      t:'Cód. medida',             w:95},
  {k:'mfr_catalog',     t:'Cat. fabricante',         w:130},
  {k:'um_compra',       t:'Unidad compra',           w:100},
  {k:'cant_compra',     t:'Cantidad compra',         w:95,  num:2},
  {k:'empaque_compra',  t:'Empaque compra',          w:100},
  {k:'pzs_bulto_compra',t:'QTY X CTN',               w:85,  num:2},
  {k:'vol_compra',      t:'CBM X CTN',               w:90,  num:4},
  {k:'peso_compra',     t:'G.W. KGS',                w:85,  num:3},
  {k:'peso_item',       t:'N.W. KGS',                w:85,  num:3},
  {k:'um_venta',        t:'Unidad venta',            w:95},
  {k:'cant_venta',      t:'Cantidad venta',          w:90,  num:2},
  {k:'empaque_venta',   t:'Empaque venta',           w:95},
  {k:'pzs_bulto_venta', t:'Pzs por bulto venta',     w:95,  num:2},
  {k:'vol_venta',       t:'Volumen de venta',        w:95,  num:4},
  {k:'udf_color',       t:'COLOR',                   w:95,  udf:'Colores'},
  {k:'udf_cubicaje',    t:'Cubicaje por bulto',      w:100, udf:'Cubicaje por Bulto'},
  {k:'udf_tamano',      t:'ITEM SIZE',               w:120, udf:'Tamaño'},
  {k:'udf_comp_esp',    t:'MATERIAL / COMPOSICION',  w:150, udf:'Composicion'},
  {k:'udf_color_ing',   t:'COLOR (inglés)',          w:100, udf:'Color en ingles'},
  {k:'udf_comp_ing',    t:'COMPOSITION',             w:140, udf:'Composicion en ingles'},
  {k:'udf_producto',    t:'Producto',                w:100, udf:'Producto'},
  {k:'udf_categoria',   t:'Categoria',               w:100, udf:'Categoria'},
  {k:'udf_coleccion',   t:'Colección',               w:100, udf:'Colección'},
  {k:'udf_dpto',        t:'Depto',                   w:90,  udf:'Depto'},
  {k:'udf_bulto',       t:'CARTON SIZE',             w:110, udf:'Tamaño bulto'},
  // v763: van por su nombre interno exacto en SAP (OITM.U_POrigen, U_PxBlt)
  {k:'u_porigen',       t:'País de origen',          w:110, alias:'U_POrigen'},
  {k:'u_pxblt',         t:'Peso por bulto',          w:95,  num:3, alias:'U_PxBlt'},
  // ── Alfombras: van por su nombre interno, tal como están en SAP ──
  {k:'u_pelo',          t:'COMPOSICION DE PELO',     w:140, alias:'U_pelo',          alf:true},
  {k:'u_respaldo',      t:'COMPOSICION DE RESPALDO', w:150, alias:'U_respaldo',      alf:true},
  {k:'u_fabricacion',   t:'Tecnica de Fabricacion',  w:140, alias:'U_fabricacion',   alf:true},
  {k:'u_intensidad',    t:'Intensidad de Uso',       w:120, alias:'U_intensidad',    alf:true},
  {k:'u_espesor',       t:'Espesor de Pelo',         w:110, alias:'U_espesor',       alf:true},
  {k:'u_espesort',      t:'Espesor Total',           w:105, alias:'U_espesort',      alf:true},
  {k:'u_pelopeso',      t:'Peso de Pelo',            w:105, alias:'U_pelopeso',      alf:true},
  {k:'u_gramaje',       t:'Gramaje',                 w:95,  alias:'U_gramaje',       alf:true},
  {k:'u_pelopesot',     t:'Dimenciones Cm',          w:115, alias:'U_pelopesot',     alf:true},
  {k:'u_denominacionT', t:'Denominacion del Tejido', w:150, alias:'U_denominacionT', alf:true},
  {k:'u_acabadoColor',  t:'acabado por color',       w:130, alias:'U_acabadoColor',  alf:true},
  {k:'u_acabadosOtros', t:'Otros acabados',          w:130, alias:'U_acabadosOtros', alf:true}
];

function _isAbrir(){
  window._is={filas:[], lim:80, comprobado:false, soloAlf:false, q:'', cargando:false};
  _isAddFilas(12);
  var ov=document.createElement('div');
  ov.id='modalIS';
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:10068;'
    +'display:flex;flex-direction:column;padding:12px 14px;overflow:hidden';
  ov.innerHTML='<div id="isCuerpo" style="display:flex;flex-direction:column;'
    +'height:100%;min-height:0"></div>';
  document.body.appendChild(ov);
  _isPintar();
}

function _isCerrar(){
  var m=document.getElementById('modalIS'); if(m) m.remove();
  window._is=null;
}

function _isFilaVacia(){
  var f={_existe:null};
  IS_COLS.forEach(function(c){ f[c.k]= c.num!=null ? '' : ''; });
  return f;
}

function _isAddFilas(n){
  var S=window._is; if(!S) return;
  for(var i=0;i<(n||1);i++) S.filas.push(_isFilaVacia());
  if(document.getElementById('isCuerpo')) _isPintar();
}

function _isSet(i, campo, v){
  var S=window._is; if(!S||!S.filas[i]) return;
  var c=IS_COLS.filter(function(x){ return x.k===campo; })[0];
  S.filas[i][campo]= (c && c.num!=null)
    ? (String(v).trim()===''?'':(Number(String(v).replace(',','.'))||0))
    : String(v).trim();
  if(campo==='itemcode') S.filas[i]._existe=null;
}

// Pegar un bloque de Excel, desde la casilla en la que se esté
function _isPaste(ev, fila, campo){
  var texto='';
  try{ texto=(ev.clipboardData||window.clipboardData).getData('text'); }catch(e){ return; }
  if(!texto || (texto.indexOf('\t')<0 && texto.indexOf('\n')<0)) return;
  ev.preventDefault();
  var S=window._is;
  var col0=IS_COLS.map(function(c){ return c.k; }).indexOf(campo);
  var lineas=texto.replace(/\r/g,'').split('\n').filter(function(x){ return x.trim()!==''; });
  var n=0;
  lineas.forEach(function(linea, r){
    var celdas=linea.split('\t');
    while(S.filas.length<=fila+r) S.filas.push(_isFilaVacia());
    var f=S.filas[fila+r];
    celdas.forEach(function(v, cc){
      var c=IS_COLS[col0+cc];
      if(!c || v==null) return;
      var t=String(v).trim();
      if(t==='') return;
      f[c.k]= c.num!=null ? (Number(t.replace(/[^0-9.,-]/g,'').replace(',','.'))||0) : t;
      if(c.k==='itemcode') f._existe=null;
      n++;
    });
  });
  S.comprobado=false;
  _isPintar();
  showT('✓ '+n+' celda(s) pegadas en '+lineas.length+' fila(s)');
}

// Ctrl+D: arrastrar el valor hacia abajo por toda la columna
function _isTecla(ev, fila, campo){
  var k=String(ev.key||'');
  if((ev.ctrlKey||ev.metaKey) && k.toLowerCase()==='d'){
    ev.preventDefault();
    var S=window._is, v=ev.target.value, n=0;
    for(var i=fila;i<S.filas.length;i++){
      if(!S.filas[i].itemcode && i>fila && !S.filas[i].itemname) continue;
      _isSet(i, campo, v); n++;
    }
    _isPintar();
    showT('✓ «'+v+'» puesto en '+n+' fila(s)');
    return;
  }
  if(k==='Enter' || k==='ArrowDown' || k==='ArrowUp'){
    ev.preventDefault();
    var sig=fila+(k==='ArrowUp'?-1:1);
    var el=document.getElementById('is-'+sig+'-'+campo);
    if(el){ el.focus(); el.select(); }
  }
}

// ¿Cuáles existen ya en SAP?
async function _isComprobar(){
  var S=window._is; if(!S) return;
  var codigos=[...new Set(S.filas.map(function(f){ return String(f.itemcode||'').trim(); })
                            .filter(Boolean))];
  if(!codigos.length){ showT('No hay referencias que comprobar'); return; }
  S.cargando=true; _isPintar();
  try{
    var hay={};
    for(var i=0;i<codigos.length;i+=80){
      var lote=codigos.slice(i,i+80).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){ hay[String(x.itemcode)]=x; });
    }
    S.filas.forEach(function(f){
      var k=String(f.itemcode||'').trim();
      f._existe = k ? !!hay[k] : null;
    });
    S.comprobado=true;
    _isPintar();
    // De los que YA existen se trae todo lo que tienen en SAP, para que la
    // hoja salga llena y solo haya que cambiar o completar lo que falte.
    var existentes=S.filas.filter(function(f){ return f._existe; })
                     .map(function(f){ return String(f.itemcode).trim(); });
    if(existentes.length) await _isTraerDeSap(existentes);
  }catch(e){ showT('No pude comprobar: '+(e.message||e)); }
  S.cargando=false;
  _isPintar();
}

// Pide al worker la ficha completa y rellena la hoja
async function _isTraerDeSap(codigos){
  var S=window._is; if(!S) return;
  S.trayendo=true; _isPintar();
  try{
    var r=await _postTolerante(SB+'/rest/v1/items_lectura_queue',
      {codigos:codigos, estado:'pendiente', creado_por:(CU&&CU.name)||''});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre items_sap.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,140));
    }
    var reg=((await r.json())||[])[0];
    var desde=Date.now(), q=null;
    while(Date.now()-desde < 120000){
      await new Promise(function(res){ setTimeout(res, 2000); });
      var r2=await fetch(SB+'/rest/v1/items_lectura_queue?select=*&id=eq.'+reg.id,
        {headers:SBH});
      q=r2.ok ? ((await r2.json())||[])[0] : null;
      if(q && (q.estado==='hecha' || q.estado==='error')) break;
    }
    if(!q || q.estado!=='hecha'){
      showT((q&&q.error_msg) ? ('SAP: '+q.error_msg)
        : 'El worker no respondió; la hoja se queda con lo que hay', 7000);
      return;
    }
    var porTitulo={};
    Object.keys(q.titulos||{}).forEach(function(al){
      porTitulo[_fruClave(q.titulos[al])]=al; });
    var n=0;
    (q.resultado||[]).forEach(function(x){
      var f=S.filas.filter(function(z){
        return String(z.itemcode).trim()===String(x.itemcode).trim(); })[0];
      if(!f) return;
      var sap={};
      IS_COLS.forEach(function(c){
        var v=null;
        if(c.alias) v=(x.udf||{})[c.alias];
        else if(c.udf){
          var al=porTitulo[_fruClave(c.udf)];
          if(al) v=(x.udf||{})[al];
        }
        else v=x[c.k];
        if(v===undefined) v=null;
        if(v!==null && v!=='') sap[c.k]=(c.num!=null?Number(v):String(v).trim());
      });
      f._sap=sap;
      Object.keys(sap).forEach(function(k){
        if(f[k]==='' || f[k]==null) f[k]=sap[k];
      });
      n++;
    });
    showT('✓ '+n+' artículo(s) traídos de SAP con todos sus datos');
  }catch(e){
    showT('No pude traer los datos de SAP: '+(e.message||e), 8000);
  }
  S.trayendo=false;
  _isPintar();
}

// ¿Esta casilla cambia algo respecto a lo que hay en SAP?
function _isCambiado(f, campo){
  if(!f._sap) return false;
  var a=f._sap[campo], b=f[campo];
  if(b==='' || b==null) return false;
  if(a===undefined || a===null || a==='') return true;
  if(typeof a==='number' || typeof b==='number')
    return Math.abs((Number(a)||0)-(Number(b)||0))>0.00001;
  return String(a).trim()!==String(b).trim();
}

async function _isExcel(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var S=window._is; if(!S) return;
  S.cargando=true; _isPintar();
  try{
    var fichas=await _ocLeerFichasDeExcel(null, f.name, f);
    var codigos=Object.keys(fichas||{});
    if(!codigos.length) throw new Error('no encontré artículos en el Excel');
    S.filas=codigos.map(function(k){
      var x=fichas[k], f2=_isFilaVacia();
      f2.itemcode=k;
      f2.itemname=x.esp||x.ing||'';
      f2.foreign_name=x.ing||'';
      f2.barcode=x.barcode||'';
      f2.pzs_bulto_compra=Number(x.qtyCtn)||'';
      f2.vol_compra=Number(x.cbm)||'';
      f2.peso_compra=Number(x.peso_bruto)||'';
      f2.peso_item=Number(x.peso_neto)||'';
      f2.udf_tamano=x.size||'';
      f2.udf_color=x.color||'';
      f2.udf_comp_esp=x.comp||'';
      f2.udf_bulto=x.carton||'';
      f2.precio_fob=Number(x.precio)||'';
      return f2;
    });
    S.comprobado=false;
    showT('✓ '+S.filas.length+' artículo(s) leídos del Excel');
    await _isComprobar();
  }catch(e){ showT('No pude leer el Excel: '+(e.message||e)); }
  S.cargando=false;
  _isPintar();
}

function _isConDatos(){
  return (window._is.filas||[]).filter(function(f){ return String(f.itemcode||'').trim(); });
}

function _isPintar(){
  var c=document.getElementById('isCuerpo'); if(!c) return;
  var S=window._is; if(!S) return;
  var cols=IS_COLS.filter(function(x){ return S.soloAlf ? true : true; });
  var datos=_isConDatos();
  var nuevos=datos.filter(function(f){ return f._existe===false; }).length;
  var viejos=datos.filter(function(f){ return f._existe===true; }).length;
  var sinComp=datos.filter(function(f){ return f._existe===null; }).length;
  var inp='width:100%;box-sizing:border-box;border:none;background:transparent;'
    +'font-size:12px;padding:4px 5px;color:var(--text-primary)';
  var celda='border:0.5px solid var(--border);padding:0';

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px">'
    +'<i class="ti ti-database-import" style="font-size:21px;color:var(--t-azul)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">Subir items a SAP</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Los que no existan se crean; los '
    +'que ya existan se actualizan sin tocar su código. Se edita como un Excel: pega en '
    +'bloque, Ctrl+D arrastra hacia abajo, Enter baja de fila.</div></div>'
    +'<button class="btn bg2" style="padding:7px 13px" onclick="_isCerrar()">'
    +'<i class="ti ti-x"></i> Cerrar</button></div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:8px">'
    +'<label class="xb" style="cursor:pointer"><i class="ti ti-file-spreadsheet"></i> '
    +'Cargar un Excel<input type="file" accept=".xlsx,.xls,.csv" style="display:none" '
    +'onchange="_isExcel(this)"></label>'
    +'<button class="xb" onclick="_isAddFilas(10)"><i class="ti ti-plus"></i> 10 filas</button>'
    +'<button class="btn bg2" style="padding:6px 12px" onclick="_isComprobar()">'
    +'<i class="ti ti-search"></i> Comprobar en SAP</button>'
    +(S.cargando?'<span class="ai-ring g"></span>':'')
    +(S.trayendo?('<span style="font-size:11px;color:var(--t-lila)">'
      +'<span class="ai-ring"></span> trayendo de SAP…</span>'):'')
    +'<span style="flex:1"></span>'
    +'<span style="font-size:11.5px">'
    +(datos.length?('<b>'+datos.length+'</b> artículo(s) · '
       +(nuevos?('<b style="color:var(--t-verde)">'+nuevos+' nuevos</b> · '):'')
       +(viejos?('<b style="color:var(--t-azul)">'+viejos+' ya existen</b> · '):'')
       +(sinComp?('<span style="color:var(--t-marron)">'+sinComp+' sin comprobar</span>'):''))
      :'Pega o carga los artículos')+'</span></div>'
    +'<div id="isTabla" style="flex:1;min-height:0;overflow:auto;'
    +'border:0.5px solid var(--border);border-radius:9px;background:var(--surface-0)">'
    +'<table class="tbx" style="border-collapse:separate;border-spacing:0;min-width:max-content">'
    +'<thead><tr>'
    +'<th style="width:34px;position:sticky;top:0;left:0;z-index:5;background:var(--surface-1)">#</th>'
    +'<th style="width:110px;position:sticky;top:0;z-index:4;background:var(--surface-1)">'
    +'En SAP</th>'
    + cols.map(function(x){
        var bg = x.alf ? '#5B21B6' : ((x.udf||x.alias) ? '#0c447c' : 'var(--surface-1)');
        var fg = (x.alf||x.udf||x.alias) ? '#fff' : 'var(--text-secondary)';
        return '<th style="width:'+x.w+'px;position:sticky;top:0;z-index:4;'
          +'background:'+bg+';color:'+fg+';white-space:nowrap;padding:5px 6px">'
          +_esc(x.t)+(x.req?' <span style="color:#fca5a5">*</span>':'')+'</th>';
      }).join('')
    +'</tr></thead><tbody>'
    + S.filas.slice(0, S.lim).map(function(f, i){
        var zebra=(i%2)?'background:var(--bg-accent)':'background:var(--surface-0)';
        var marca = f._existe===null
          ? '<span style="font-size:10px;color:var(--text-muted)">—</span>'
          : (f._existe
             ? '<span style="font-size:10px;color:var(--t-azul)"><i class="ti ti-refresh"></i> se actualiza</span>'
             : '<span style="font-size:10px;color:var(--t-verde)"><i class="ti ti-plus"></i> se crea</span>');
        return '<tr style="'+zebra+'">'
          +'<td style="position:sticky;left:0;z-index:2;'+zebra+';color:var(--text-muted);'
          +'border:0.5px solid var(--border)">'+(i+1)+'</td>'
          +'<td style="border:0.5px solid var(--border)">'+marca+'</td>'
          + cols.map(function(x){
              var v=(f[x.k]==null?'':f[x.k]);
              var ch=_isCambiado(f, x.k);
              var nuevo=(f._existe===false && String(v)!=='');
              return '<td style="'+celda
                +(ch?';background:var(--pastel-aviso)'
                   :(nuevo?';background:var(--pastel-ok)':''))+'">'
                +'<input id="is-'+i+'-'+x.k+'" '
                +(x.num!=null?'inputmode="decimal" ':'')
                +'value="'+_esc(v)+'" '
                +'onchange="_isSet('+i+',\''+x.k+'\',this.value)" '
                +'onpaste="_isPaste(event,'+i+',\''+x.k+'\')" '
                +'onkeydown="_isTecla(event,'+i+',\''+x.k+'\')" '
                +'onfocus="this.select();this.style.background=\'var(--bg-accent)\'" '
                +'onblur="this.style.background=\'\'" '
                +'title="'+(ch?('En SAP: '+_esc(String((f._sap||{})[x.k]==null?'(vacío)'
                    :(f._sap||{})[x.k]))):'')+'" '
                +'style="'+inp+(x.num!=null?';text-align:right':'')
                +(x.k==='itemcode'?';font-weight:700':'')
                +(ch?';color:var(--t-marron);font-weight:700':'')+'"></td>';
            }).join('')
          +'</tr>';
      }).join('')
    +'</tbody></table></div>'
    +(S.lim<S.filas.length
      ? ('<div style="font-size:11px;color:var(--text-muted);padding:6px 2px">'
         +'Mostrando '+S.lim+' de '+S.filas.length+' · '
         +'<span onclick="window._is.lim+=200;_isPintar()" style="cursor:pointer;'
         +'text-decoration:underline">ver más</span></div>')
      : '')
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px;flex-wrap:wrap">'
    +'<span style="flex:1;font-size:10.5px;color:var(--text-muted);align-self:center">'
    +'<span style="background:var(--pastel-ok);padding:1px 6px;border-radius:5px">verde</span>'
    +' artículo nuevo · '
    +'<span style="background:var(--pastel-aviso);padding:1px 6px;border-radius:5px">ámbar</span>'
    +' distinto de lo que hay en SAP · cabecera azul: campos de usuario · '
    +'morada: los de alfombras · * obligatorio · '
    +'los precios van a su lista de SAP (1 FOB, 2 CIF, 3 venta); la que dejes vacía '
    +'no se toca</span>'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_isPlantilla()">'
    +'<i class="ti ti-download"></i> Bajar plantilla</button>'
    +'<button class="btn bp" style="padding:9px 18px" onclick="_isSubir()"'
    +(datos.length?'':' disabled')+'><i class="ti ti-database-import"></i> '
    +'Analizar y subir a SAP</button></div>';
}

// Una plantilla vacía con las columnas exactas
function _isPlantilla(){
  if(typeof XLSX==='undefined'){ showT('No está cargado el lector de Excel'); return; }
  var cab={}; IS_COLS.forEach(function(c){ cab[c.t]=''; });
  var h=XLSX.utils.json_to_sheet([cab]), w=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(w, h, 'Artículos');
  XLSX.writeFile(w, 'Plantilla_items_SAP.xlsx');
}

async function _isSubir(){
  var S=window._is; if(!S) return;
  if(!S.comprobado) await _isComprobar();
  var datos=_isConDatos();
  var faltan=datos.filter(function(f){
    return !String(f.itemname||'').trim() || !String(f.grupo||'').trim(); });
  if(faltan.length && !confirm(faltan.length+' fila(s) no tienen descripción o departamento.\n\n'
    +'SAP puede rechazarlas. ¿Sigo igual?')) return;

  var nuevos=datos.filter(function(f){ return f._existe===false; });
  var viejos=datos.filter(function(f){ return f._existe===true; });
  if(!confirm('SUBIR A SAP\n\n'
    +'· '+nuevos.length+' artículo(s) NUEVOS: se crean\n'
    +'· '+viejos.length+' que YA EXISTEN: se actualizan, sin tocar su código\n\n'
    +(nuevos.length?('Nuevos: '+nuevos.slice(0,6).map(function(f){ return f.itemcode; }).join(', ')
       +(nuevos.length>6?'…':'')+'\n'):'')
    +'\nTodo por DI API. ¿Sigo?')) return;

  var items=datos.map(function(f){
    var it={}, udf={}, alias={}, precios={};
    IS_COLS.forEach(function(c){
      var v=f[c.k];
      if(v==='' || v==null) return;
      if(c.lista) precios[String(c.lista)]=Number(v)||0;
      else if(c.alias) alias[c.alias]=v;
      else if(c.udf) udf[c.udf]=v;
      else it[c.k]=v;
    });
    it.precios=precios;
    it.udf_titulos=udf;
    it.udf_alias=alias;
    it.existe=(f._existe===true);
    return it;
  });

  try{
    _frwAbrir();
    _frwPintarEspera('Subiendo '+items.length+' artículo(s) a SAP…',
      'Los nuevos se crean y los existentes se actualizan, uno por uno.');
    var r=await _postTolerante(SB+'/rest/v1/items_sap_queue',
      {items:items, origen:'hoja de artículos', estado:'pendiente',
       creado_por:(CU&&CU.name)||''});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre items_sap.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,150));
    }
    var reg=((await r.json())||[])[0];
    _isSeguir(reg.id, Date.now());
  }catch(e){
    _frwCerrar();
    showT('No se pudo enviar: '+(e.message||e));
  }
}

function _isSeguir(id, desde){
  clearTimeout(window._isT);
  window._isT=setTimeout(async function(){
    if(!document.getElementById('frwOv')) return;
    try{
      var r=await fetch(SB+'/rest/v1/items_sap_queue?select=*&id=eq.'+id,{headers:SBH});
      var q=r.ok ? ((await r.json())||[])[0] : null;
      if(q && q.estado==='hecha'){
        var c=document.getElementById('frwCaja');
        if(c) c.innerHTML='<div style="width:78px;height:78px;margin:0 auto 14px;'
          +'border-radius:50%;background:var(--pastel-ok);display:flex;align-items:center;'
          +'justify-content:center"><i class="ti ti-check" style="font-size:46px;'
          +'color:var(--t-verde)"></i></div>'
          +'<div style="font-size:16px;font-weight:700;color:var(--t-verde)">'
          +'Artículos subidos a SAP</div>'
          +'<div style="font-size:15px;margin-top:12px;line-height:1.8">'
          +'<b>'+(q.creados||0)+'</b> creados<br><b>'+(q.actualizados||0)+'</b> actualizados</div>'
          +((q.avisos&&q.avisos.length)
            ? ('<div style="font-size:10.5px;color:var(--t-marron);margin-top:10px;'
               +'text-align:left;max-height:150px;overflow:auto;background:var(--surface-1);'
               +'border-radius:8px;padding:8px">'+q.avisos.slice(0,25).map(_esc).join('<br>')
               +'</div>') : '')
          +'<button class="btn bp" style="margin-top:14px;width:100%;padding:11px" '
          +'onclick="_frwCerrar()">Listo</button>';
        try{ _isComprobar(); }catch(e){}
        return;
      }
      if(q && q.estado==='error'){ _frwPintarError(q.error_msg||''); return; }
      if(Date.now()-desde > 10*60*1000){
        _frwPintarError('El worker no ha respondido en 10 minutos. Sigue en la cola.');
        return;
      }
    }catch(e){}
    _isSeguir(id, desde);
  }, 2500);
}

/* ═══════════════════════════════════════════════════════════════════════════
   SUBIR FOTOS AL SERVIDOR   (prefijo [SF])
   ───────────────────────────────────────────────────────────────────────────
   Para diseño y gerencia: se arrastran las fotos ya trabajadas y van al
   bucket «fotos-items» y, por medio de la cola, a la carpeta de red que lee
   SAP. El NOMBRE DEL ARCHIVO ES EL CÓDIGO DEL ARTÍCULO: 753492.jpg es la
   foto del 753492. Si ese artículo ya tenía foto, se reemplaza.

   Mismo mecanismo que ya usa la creación de artículos: POST al bucket y, si
   el archivo existe, PUT para reemplazarlo; después se anota en fotos_queue
   para que el worker la baje a la carpeta de red.
   ═══════════════════════════════════════════════════════════════════════════ */

window._sfCola = [];

function _sfPuede(){
  // Diseño y gerencia, más las compradoras que suben fotos de sus muestras
  var extra=['yagizel','eimy'];
  return !!(CU && (CU.role==='diseno' || _esGerencia()
                   || extra.indexOf(String(CU.id||'').toLowerCase())>=0));
}

function _sfAbrir(){
  if(!_sfPuede()){ showT('Esta opción es de diseño y gerencia'); return; }
  if(document.getElementById('sfModal')) return;
  window._sfCola=[];
  var ov=document.createElement('div');
  ov.id='sfModal';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10069;'
    +'display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;width:100%;'
    +'max-width:820px;max-height:92vh;display:flex;flex-direction:column;'
    +'box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div style="padding:15px 18px;border-bottom:0.5px solid var(--border);display:flex;'
    +'align-items:center;gap:10px">'
    +'<i class="ti ti-photo-up" style="font-size:22px;color:var(--t-lila)"></i>'
    +'<b style="flex:1;font-size:15px">Subir fotos a SAP</b>'
    +'<button class="xb" onclick="_sfCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<div style="flex:1;overflow-y:auto;padding:18px" id="sfCuerpo"></div>'
    +'<div style="padding:13px 18px;border-top:0.5px solid var(--border);display:flex;'
    +'gap:8px;align-items:center">'
    +'<span id="sfMsg" style="flex:1;font-size:12px;color:var(--text-muted)"></span>'
    +'<button class="btn bg2" style="padding:8px 14px" onclick="_sfCerrar()">Cerrar</button>'
    +'<button class="btn bp" style="padding:8px 18px" id="sfBtn" onclick="_sfSubir()" '
    +'disabled><i class="ti ti-cloud-upload"></i> Subir fotos a SAP</button>'
    +'</div></div>';
  document.body.appendChild(ov);
  _sfPintar();
}

function _sfCerrar(){
  window._sfCola=[];
  var m=document.getElementById('sfModal'); if(m) m.remove();
}

function _sfElegir(el){ _sfAnadir(el.files); el.value=''; }

function _sfAnadir(files){
  Array.prototype.slice.call(files||[]).forEach(function(f){
    if(!/^image\//.test(f.type||'')) return;
    if(window._sfCola.some(function(x){ return x.file.name===f.name; })) return;
    // El código del artículo es el nombre del archivo sin la extensión
    window._sfCola.push({file:f, code:f.name.replace(/\.[^.]+$/,'').trim(),
                         estado:'pendiente', msg:''});
  });
  _sfPintar();
  _sfVerificar();
}

// Se comprueba que cada código exista: una foto con el nombre mal escrito no
// da error, simplemente no la ve nadie. Se avisa, pero no se bloquea.
async function _sfVerificar(){
  var faltan=window._sfCola.filter(function(x){ return x.art===undefined; });
  if(!faltan.length) return;
  try{
    for(var i=0;i<faltan.length;i+=60){
      var lote=faltan.slice(i,i+60).map(function(x){
        return '"'+x.code.replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      var mapa={};
      (r.ok?(await r.json()||[]):[]).forEach(function(a){
        mapa[String(a.itemcode).toUpperCase()]=a.itemname; });
      faltan.slice(i,i+60).forEach(function(x){
        var n=mapa[x.code.toUpperCase()];
        if(n){ x.art=n; x.estado='listo'; x.msg='listo'; }
        else { x.art=''; x.estado='aviso'; x.msg='sin alta en SAP · se sube igual'; }
      });
    }
  }catch(e){
    faltan.forEach(function(x){ x.art=''; });
  }
  _sfPintar();
}

function _sfQuitar(i){ window._sfCola.splice(i,1); _sfPintar(); }

function _sfPintar(){
  var d=document.getElementById('sfCuerpo'); if(!d) return;
  var C=window._sfCola||[];
  var b=document.getElementById('sfBtn');
  if(b) b.disabled=!C.some(function(x){ return x.estado!=='ok' && x.estado!=='subiendo'; });

  d.innerHTML='<div style="font-size:12.5px;color:var(--text-muted);line-height:1.6;'
    +'margin-bottom:12px">El <b>nombre del archivo tiene que ser el código del artículo</b>: '
    +'<code>753492.jpg</code> es la foto del 753492. Van al servidor de imágenes y de ahí '
    +'a la carpeta de red que lee SAP. Si ese artículo ya tenía foto, <b>se reemplaza</b>.</div>'
    +'<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron);'
    +'margin-bottom:12px;font-size:12px">Estas fotos las ve todo el mundo. Revisa que el '
    +'nombre sea el código correcto: uno equivocado pisa la foto de otro artículo.</div>'
    +'<div id="sfZona" style="border:2px dashed var(--border);border-radius:13px;'
    +'padding:28px 20px;text-align:center;cursor:pointer;background:var(--surface-0)" '
    +'onclick="document.getElementById(\'sfFile\').click()">'
    +'<div style="font-size:34px;line-height:1">🖼️</div>'
    +'<div style="font-size:14px;font-weight:600;margin-top:8px">Arrastra aquí las fotos</div>'
    +'<div style="font-size:12px;color:var(--text-muted);margin-top:4px">'
    +'o pulsa para elegirlas · puedes soltar muchas a la vez</div></div>'
    +'<input type="file" id="sfFile" accept="image/*" multiple style="display:none" '
    +'onchange="_sfElegir(this)">'
    // Para salir de dudas con una foto concreta: dónde está y en qué estado
    +'<div style="display:flex;gap:7px;align-items:center;margin-top:12px;flex-wrap:wrap">'
    +'<input id="sfQ" placeholder="¿Dónde quedó una foto? escribe su nombre (K-FLOW.jpg)" '
    +'style="flex:1;min-width:230px;font-size:12px;padding:6px 9px;'
    +'border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);'
    +'color:var(--text-primary)" '
    +'onkeydown="if(event.key===\'Enter\')_sfComprobar()">'
    +'<button class="xb" onclick="_sfComprobar()"><i class="ti ti-search"></i> '
    +'Comprobar</button></div>'
    +'<div id="sfDiag" style="margin-top:8px"></div>'
    +(C.length?('<div class="tbx-box" style="margin-top:14px;max-height:40vh;overflow:auto">'
      +'<table class="tbx"><thead><tr><th>Archivo</th><th style="width:150px">Artículo</th>'
      +'<th style="width:80px;text-align:right">Tamaño</th><th style="width:170px">Estado</th>'
      +'<th style="width:34px"></th></tr></thead><tbody>'
      + C.map(function(x,i){
          var col = x.estado==='ok' ? 'var(--t-verde)'
                  : (x.estado==='error' ? 'var(--t-rojo)'
                  : (x.estado==='aviso' ? 'var(--t-marron)' : 'var(--text-muted)'));
          return '<tr><td style="font-size:11.5px">'+_esc(x.file.name)+'</td>'
            +'<td style="font-size:11.5px"><b>'+_esc(x.code)+'</b>'
            +(x.art?('<div style="font-size:10.5px;color:var(--text-muted)">'
              +_esc(String(x.art).slice(0,32))+'</div>'):'')+'</td>'
            +'<td style="text-align:right;font-size:11.5px">'
            +Math.round(x.file.size/1024)+' KB</td>'
            +'<td style="font-size:11.5px;color:'+col+'">'+_esc(x.msg||x.estado)
            // Con el enlace se comprueba en el acto que está arriba, y debajo
            // la ruta exacta con la que quedó guardada.
            +(x.url?('<div style="font-size:10px;margin-top:2px">'
               +'<a href="'+_esc(x.url)+'" target="_blank" '
               +'style="color:var(--text-accent)">ver en el servidor</a>'
               +' · <span style="color:var(--text-muted)">'+_esc(x.clave)+'</span></div>'):'')
            +'</td>'
            +'<td>'+(x.estado==='ok'?'':('<button class="xb" style="padding:1px 7px" '
              +'onclick="_sfQuitar('+i+')">✕</button>'))+'</td></tr>';
        }).join('')
      +'</tbody></table></div>'):'');

  var z=document.getElementById('sfZona');
  if(z){
    z.ondragover=function(e){ e.preventDefault(); z.style.borderColor='var(--fill-accent)'; };
    z.ondragleave=function(){ z.style.borderColor='var(--border)'; };
    z.ondrop=function(e){
      e.preventDefault(); z.style.borderColor='var(--border)';
      _sfAnadir(e.dataTransfer.files);
    };
  }
}

/* Comprueba una foto de punta a punta: si está en el servidor de imágenes,
   qué dice su fila de la cola, y con qué nombre la copió el worker a la
   carpeta de red. Así se ve en qué punto se quedó, sin abrir el log. */
async function _sfComprobar(){
  var el=document.getElementById('sfQ');
  var d=document.getElementById('sfDiag');
  if(!el||!d) return;
  var q=String(el.value||'').trim();
  if(!q) return;
  var clave=_sfClave(q.indexOf('.')>=0?q:(q+'.jpg'));
  var code=clave.replace(/\.[^.]+$/,'');
  d.innerHTML='<div style="font-size:12px;color:var(--text-muted)">'
    +'<span class="ai-ring g"></span> Comprobando…</div>';
  var url=SB+'/storage/v1/object/public/'+FOTOS_BUCKET+'/'+clave;
  var enBucket=false, tam='';
  try{
    var r=await fetch(url,{method:'GET', headers:{}});
    enBucket=r.ok;
    if(r.ok){
      var b=await r.blob();
      tam=Math.round(b.size/1024)+' KB';
    }
  }catch(e){}
  var cola=[];
  try{
    var rq=await fetch(SB+'/rest/v1/fotos_queue?select=*&archivo=eq.'
      +encodeURIComponent(clave)+'&order=created_at.desc&limit=3',{headers:SBH});
    cola=rq.ok ? (await rq.json()||[]) : [];
  }catch(e){}
  var art=null;
  try{
    var ra=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,picturname'
      +'&itemcode=eq.'+encodeURIComponent(code.toUpperCase())+'&limit=1',{headers:SBH});
    art=(ra.ok?((await ra.json())||[]):[])[0]||null;
  }catch(e){}

  var linea=function(ok, txt, sub){
    return '<div style="display:flex;gap:8px;align-items:flex-start;margin-bottom:5px">'
      +'<i class="ti '+(ok?'ti-circle-check':'ti-alert-circle')+'" style="color:'
      +(ok?'var(--t-verde)':'var(--t-marron)')+';font-size:15px"></i>'
      +'<div style="font-size:12px"><b>'+txt+'</b>'
      +(sub?('<div style="font-size:11px;color:var(--text-muted)">'+sub+'</div>'):'')
      +'</div></div>';
  };
  var q0=cola[0];
  d.innerHTML='<div style="border:0.5px solid var(--border);border-radius:9px;'
    +'padding:10px 12px;background:var(--surface-0)">'
    + linea(enBucket, enBucket?('Está en el servidor de imágenes'+(tam?(' · '+tam):''))
                              :'NO está en el servidor de imágenes',
        enBucket?('<a href="'+_esc(url)+'" target="_blank" style="color:var(--text-accent)">'
          +'abrir la imagen</a> · '+_esc(clave))
        :('Se buscó como <b>'+_esc(clave)+'</b>. Si la subiste con otro nombre, prueba con ese.'))
    + linea(!!q0 && q0.estado!=='error',
        q0 ? ('En la cola de copia: '+_esc(q0.estado))
           : 'No hay ninguna petición de copia para ese archivo',
        q0 ? ((q0.error_msg?('Error: '+_esc(q0.error_msg)+'<br>'):'')
              +'Se copia como <b>'+_esc(q0.nombre_orig||clave)+'</b> a '
              +'\\\\10.48.21.183\\op-kencen-attachments\\Images\\Fotos\\KennedyDB')
           : 'Sin fila en la cola, el worker no la baja a la carpeta de red.')
    + linea(!!art,
        art ? ('El artículo '+_esc(art.itemcode)+' existe en SAP')
            : ('No hay ningún artículo con el código «'+_esc(code.toUpperCase())+'»'),
        art ? ('Su ficha apunta a: <b>'+_esc(art.picturname||'(sin foto)')+'</b>'
               + ' <span style="color:var(--text-muted)">(según el último Sync; el worker'
               + ' lo pone solo al copiar la foto)</span>'
               + (String(art.picturname||'').toLowerCase()===clave
                  ? '' : ' · para que SAP la muestre, ese campo tiene que ser el nombre del archivo'))
            : 'Por eso no aparece en SAP: el nombre del archivo tiene que ser el código del artículo.')
    +'</div>';
}

// La rueda que se ve mientras suben, por encima de todo
function _sfRueda(total, quedan){
  var id='sfRueda', el=document.getElementById(id);
  if(!total){ if(el) el.remove(); return; }
  if(!el){
    el=document.createElement('div');
    el.id=id;
    el.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10090;'
      +'display:flex;align-items:center;justify-content:center';
    el.innerHTML='<div style="background:var(--surface-0);border-radius:16px;'
      +'padding:28px 34px;text-align:center;min-width:260px;'
      +'box-shadow:0 18px 50px rgba(0,0,0,.3)">'
      +'<div style="width:58px;height:58px;margin:0 auto 14px;border:5px solid var(--border);'
      +'border-top-color:var(--fill-accent);border-radius:50%;'
      +'animation:sfGira .9s linear infinite"></div>'
      +'<div style="font-size:14.5px;font-weight:700">Subiendo las fotos a SAP…</div>'
      +'<div id="sfRuedaN" style="font-size:12px;color:var(--text-muted);margin-top:5px"></div>'
      +'<style>@keyframes sfGira{to{transform:rotate(360deg)}}</style></div>';
    document.body.appendChild(el);
  }
  var n=document.getElementById('sfRuedaN');
  if(n) n.textContent=(total-quedan+1>total?total:(total-quedan+1))+' de '+total;
}

// Y el ganchito grande al terminar
function _sfListo(ok, err){
  if(!ok && !err) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10091;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';
  ov.onclick=function(){ ov.remove(); };
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:16px;padding:30px 34px;'
    +'text-align:center;max-width:420px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div style="width:78px;height:78px;margin:0 auto 14px;border-radius:50%;background:'
    +(err?'var(--pastel-aviso)':'var(--pastel-ok)')+';display:flex;align-items:center;'
    +'justify-content:center"><i class="ti ti-check" style="font-size:46px;color:'
    +(err?'var(--t-marron)':'var(--t-verde)')+'"></i></div>'
    +'<div style="font-size:17px;font-weight:800;color:'
    +(err?'var(--t-marron)':'var(--t-verde)')+'">'
    + ok +' foto'+(ok===1?'':'s')+' subida'+(ok===1?'':'s')+' correctamente a SAP</div>'
    +(err?('<div style="font-size:12.5px;color:var(--t-rojo);margin-top:8px">'
      +err+' no se pudo'+(err===1?'':'ieron')+' subir · mira el motivo en la lista</div>'):'')
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:10px">'
    +'El worker las copia a la carpeta de SAP y deja la ficha del artículo '
    +'apuntando a su foto.</div>'
    +'<button class="btn bp" style="margin-top:16px;width:100%;padding:11px" '
    +'onclick="this.closest(\'div\').parentNode.remove()">Listo</button></div>';
  document.body.appendChild(ov);
}

// El mismo saneado que usa el worker al bajarlas a la carpeta de red
function _sfClave(nombre){
  return String(nombre||'').toLowerCase().replace(/[^a-z0-9._-]/g,'_');
}

async function _sfSubir(){
  var pend=(window._sfCola||[]).filter(function(x){
    return x.estado!=='ok' && x.estado!=='subiendo'; });
  if(!pend.length) return;
  var avisos=pend.filter(function(x){ return x.estado==='aviso'; }).length;
  if(avisos && !confirm(avisos+' foto(s) tienen un código que aún no existe en SAP.\n\n'
    +'Se suben igual y quedan guardadas: aparecerán solas en cuanto se dé de alta ese '
    +'artículo.\n\n¿Continuar?')) return;

  var b=document.getElementById('sfBtn'), m=document.getElementById('sfMsg');
  if(b){ b.disabled=true; b.innerHTML='<span class="ai-ring"></span> Subiendo…'; }
  _sfRueda(pend.length, pend.length);
  var ok=0, err=0;
  // De una en una: muchas a la vez saturan la conexión y el servidor empieza
  // a rechazar peticiones.
  for(var i=0;i<pend.length;i++){
    var x=pend[i];
    x.estado='subiendo'; x.msg='subiendo…'; _sfPintar();
    _sfRueda(pend.length, pend.length-i);
    if(m) m.textContent='Subiendo '+(i+1)+' de '+pend.length+'…';
    try{
      var clave=_sfClave(x.file.name);
      var url=SB+'/storage/v1/object/'+FOTOS_BUCKET+'/'+clave;
      var cab=Object.assign({}, SBH, {'Content-Type':x.file.type||'image/jpeg'});
      delete cab['Prefer'];
      var r=await fetch(url,{method:'POST', headers:cab, body:x.file});
      if(!r.ok){
        var t=await r.text();
        // Si ya existía, el servidor responde con «KeyAlreadyExists» y se
        // reemplaza con PUT, que es la operación de actualizar.
        if(/KeyAlreadyExists|Duplicate|already exists/i.test(t)){
          r=await fetch(url,{method:'PUT', headers:cab, body:x.file});
          if(!r.ok) throw new Error((await r.text()).slice(0,140));
        } else if(r.status===403){
          throw new Error('sin permiso en el bucket (corre permisos_bucket_fotos.sql)');
        } else if(r.status===404){
          throw new Error('no existe el bucket «'+FOTOS_BUCKET+'»');
        } else {
          throw new Error(t.slice(0,140));
        }
      }
      // Se anota para que el worker la baje a la carpeta de red
      await fetch(SB+'/rest/v1/fotos_queue',{method:'POST',
        headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({archivo:clave, itemcode:x.code, nombre_orig:x.file.name,
                             estado:'pendiente', subido_por:(CU&&CU.name)||''})
      }).catch(function(){});
      x.clave=clave;
      x.url=SB+'/storage/v1/object/public/'+FOTOS_BUCKET+'/'+clave;
      // Se comprueba que de verdad quedó: el servidor puede aceptar la
      // petición y no guardar nada, y así salía «subida» sin estarlo.
      var verif=false, kb=0;
      try{
        var rv=await fetch(x.url+'?t='+Date.now());
        if(rv.ok){ var bb=await rv.blob(); verif=bb.size>0; kb=Math.round(bb.size/1024); }
      }catch(e){}
      x.estado= verif ? 'ok' : 'aviso';
      x.msg= verif ? ('✓ subida y comprobada · '+kb+' KB')
                   : '⚠ el servidor la aceptó pero no responde al abrirla';
      if(verif) ok++; else err++;
    }catch(e){
      x.estado='error';
      x.msg=String(e.message||e).slice(0,90);
      err++;
    }
    _sfPintar();
  }
  _sfRueda(0,0);
  _sfListo(ok, err);
  if(b){ b.disabled=false; b.innerHTML='<i class="ti ti-cloud-upload"></i> Subir fotos a SAP'; }
  if(m) m.innerHTML=ok+' subida(s)'+(err?(' · '+err+' con error'):'')
    +' · el worker las copia a <b>\\\\10.48.21.183\\op-kencen-attachments\\Images\\'
    +'Fotos\\KennedyDB</b> con el nombre original';
  showT('✓ '+ok+' foto(s) subidas'+(err?(' · '+err+' fallaron'):''));
}

/* ── Las etapas, con color de verdad ──────────────────────────────────────
   Los pasos que aún no tocan se dibujaban con opacidad 0,6 y los fondos de
   los terminados llevaban un alfa «22», casi invisible: parecía que hubiera
   una nube delante. Aquí se refuerzan sin cambiar la hoja de estilos, que
   vive en otro archivo. */
(function _estiloEtapasFuerte(){
  try{
    if(document.getElementById('kfEstiloEtapas')) return;
    var st=document.createElement('style');
    st.id='kfEstiloEtapas';
    st.textContent=
      '.ss.ss-future{opacity:1}'
      +'.ss.ss-future .ss-name{color:var(--text-secondary)}'
      +'.eg.done .eg-hdr{background:#E4F0D4}'
      +'.eg.active .eg-hdr{background:var(--bg-accent);box-shadow:inset 3px 0 0 var(--fill-accent)}'
      +'.ss.ss-done{background:#E4F0D4;border-color:#5C8F1E}'
      +'.ss.ss-active{border-color:var(--fill-accent);box-shadow:inset 3px 0 0 var(--fill-accent)}'
      +'.ss-name{font-size:12.5px;font-weight:700;color:var(--text-primary)}'
      +'.ss-dates{color:var(--text-secondary)}'
      +'.eg-hdr{font-weight:700}'
      +'.eg.done{border-color:#5C8F1E;border-width:1px}'
      +'.eg.active{border-width:1px}'
      // La caja de soltar artes, marcada aunque el tema esté en oscuro
      +'.artes-drop:hover{filter:brightness(.98)}';
    document.head.appendChild(st);
  }catch(e){}
})();

/* ═══════════════════════════════════════════════════════════════════════════
   MIS CORREOS ENVIADOS   (prefijo [CE])
   ───────────────────────────────────────────────────────────────────────────
   Todo lo que sale del portal queda en la cola de correos, con su fecha, su
   destinatario y sus adjuntos. Aquí cada quien ve LO SUYO: puede abrirlo,
   leerlo tal como se mandó, reenviarlo y añadir gente en copia.
   ═══════════════════════════════════════════════════════════════════════════ */

window._ce = null;

function _ceAbrir(){
  window._ce={lista:[], cargando:true, q:'', abierto:null};
  var ov=document.createElement('div');
  ov.id='modalCE';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10070;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:980px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="ceCuerpo"></div></div>';
  document.body.appendChild(ov);
  _cePintar();
  _ceCargar();
}

function _ceCerrar(){
  var m=document.getElementById('modalCE'); if(m) m.remove();
  window._ce=null;
}

async function _ceCargar(){
  var S=window._ce; if(!S) return;
  S.cargando=true; _cePintar();
  try{
    // Los míos: por correo o, si no coincide, por nombre
    var mio=encodeURIComponent(String((CU&&CU.email)||'').trim());
    var nom=encodeURIComponent('*'+String((CU&&CU.name)||'').trim()+'*');
    var url=SB+'/rest/v1/correos_queue?select=*&order=creado_en.desc&limit=300';
    if(mio) url+='&or=(de_email.eq.'+mio+',de_nombre.ilike.'+nom+')';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,120));
    S.lista=await r.json()||[];
  }catch(e){
    S.error=String(e.message||e);
    S.lista=[];
  }
  S.cargando=false;
  _cePintar();
}

function _ceVisibles(){
  var S=window._ce, q=String(S.q||'').toLowerCase().trim();
  if(!q) return S.lista||[];
  return (S.lista||[]).filter(function(c){
    return [c.asunto, c.para_email, (c.para_lista||[]).join(' '), c.origen, c.docnum, c.cuerpo]
      .map(function(v){ return String(v||'').toLowerCase(); })
      .some(function(v){ return v.indexOf(q)>=0; });
  });
}

function _cePintar(){
  var c=document.getElementById('ceCuerpo'); if(!c) return;
  var S=window._ce; if(!S) return;
  if(S.abierto) return _ceVer(S.abierto, true);
  var L=_ceVisibles();
  var est='padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;'
    +'font-size:12px;background:var(--surface-0);color:var(--text-primary)';

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-send" style="font-size:21px;color:var(--t-azul)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">Mis correos enviados</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Todo lo que has mandado desde el '
    +'portal. Pulsa uno para leerlo, reenviarlo o añadir gente en copia.</div></div>'
    +'<button class="xb" onclick="_ceCargar()"><i class="ti ti-refresh"></i></button>'
    +'<button class="xb" onclick="_ceCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<input value="'+_esc(S.q)+'" placeholder="Buscar por asunto, destinatario, orden…" '
    +'oninput="clearTimeout(window._ceT);var v=this.value;'
    +'window._ceT=setTimeout(function(){window._ce.q=v;_cePintar()},250)" '
    +'style="'+est+';width:100%;box-sizing:border-box;margin-bottom:9px">'
    +(S.error?('<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'
      +_esc(S.error)+'</div>'):'')
    +(S.cargando?'<div style="font-size:12px;color:var(--text-muted)">'
      +'<span class="ai-ring g"></span> Cargando…</div>'
     : (!L.length?'<div class="empty">Todavía no has enviado ningún correo desde el portal</div>'
      : '<div class="tbx-box" style="max-height:60vh;overflow:auto"><table class="tbx">'
        +'<thead><tr><th style="width:150px">Cuándo</th><th>Asunto</th>'
        +'<th style="width:220px">Para</th><th style="width:130px">De dónde salió</th>'
        +'<th style="width:90px">Estado</th></tr></thead><tbody>'
        + L.map(function(x){
            var dest=(x.para_lista&&x.para_lista.length)?x.para_lista:[x.para_email].filter(Boolean);
            var col = x.estado==='enviado' ? 'var(--t-verde)'
                    : (x.estado==='error' ? 'var(--t-rojo)' : 'var(--t-marron)');
            return '<tr style="cursor:pointer" onclick="_ceVer(\''+x.id+'\')" '
              +'onmouseover="this.style.background=\'var(--surface-1)\'" '
              +'onmouseout="this.style.background=\'\'">'
              +'<td style="font-size:11px">'+_esc(_fechaHora(x.creado_en))+'</td>'
              +'<td style="font-size:11.5px;font-weight:600">'+_esc(String(x.asunto||'').slice(0,60))
              +((x.adjuntos&&x.adjuntos.length)?(' <i class="ti ti-paperclip" '
                +'style="color:var(--text-muted)" title="'+x.adjuntos.length+' adjunto(s)"></i>'):'')
              +'</td>'
              +'<td style="font-size:10.5px;color:var(--text-muted)">'
              +_esc(dest.slice(0,2).join(', '))+(dest.length>2?(' +'+(dest.length-2)):'')+'</td>'
              +'<td style="font-size:10.5px;color:var(--text-muted)">'
              +_esc(String(x.origen||'').slice(0,26))
              +(x.docnum?('<div>#'+_esc(x.docnum)+'</div>'):'')+'</td>'
              +'<td style="font-size:10.5px;color:'+col+'">'+_esc(x.estado||'')+'</td></tr>';
          }).join('')
        +'</tbody></table></div>'))
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:7px">'
    +L.length+' correo(s)</div>';
}

// Un correo por dentro, con el botón de reenviar
function _ceVer(id, yaAbierto){
  var S=window._ce; if(!S) return;
  var x=(S.lista||[]).filter(function(c){ return String(c.id)===String(id); })[0];
  if(!x) return;
  S.abierto=id;
  var dest=(x.para_lista&&x.para_lista.length)?x.para_lista:[x.para_email].filter(Boolean);
  var c=document.getElementById('ceCuerpo'); if(!c) return;
  var est='padding:7px 9px;border:0.5px solid var(--border);border-radius:7px;'
    +'font-size:12px;background:var(--surface-0);color:var(--text-primary);'
    +'width:100%;box-sizing:border-box';

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<button class="xb" onclick="window._ce.abierto=null;_cePintar()">'
    +'<i class="ti ti-arrow-left"></i></button>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +_esc(x.asunto||'(sin asunto)')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">'
    +_esc(_fechaHora(x.creado_en))+' · de '+_esc(x.de_nombre||'')
    +(x.origen?(' · '+_esc(x.origen)):'')
    +(x.docnum?(' · orden #'+_esc(x.docnum)):'')+'</div></div>'
    +'<button class="xb" onclick="_ceCerrar()"><i class="ti ti-x"></i></button></div>'
    +'<div style="font-size:12px;margin-bottom:8px"><b>Para:</b> '
    +_esc(dest.join(', '))+'</div>'
    +((x.adjuntos&&x.adjuntos.length)
      ? ('<div style="font-size:11.5px;margin-bottom:8px"><b>Adjuntos:</b> '
         + x.adjuntos.map(function(a){ return _esc(a.nombre); }).join(' · ')+'</div>')
      : '')
    +'<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:9px;padding:12px;font-size:12.5px;line-height:1.6;white-space:pre-wrap;'
    +'max-height:40vh;overflow:auto">'+_esc(x.cuerpo||'')+'</div>'
    +'<div style="margin-top:12px;border-top:0.5px solid var(--border);padding-top:10px">'
    +'<div style="font-size:12px;font-weight:700;margin-bottom:5px">'
    +'<i class="ti ti-send"></i> Reenviar este correo</div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'
    +'Se manda tal cual, con sus adjuntos. Puedes cambiar los destinatarios o '
    +'añadir gente en copia, separando con comas.</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
    +'<input id="ceParaR" value="'+_esc(dest.join(', '))+'" placeholder="Para" '
    +'style="'+est+';flex:1;min-width:230px">'
    +'<input id="ceCcR" placeholder="Añadir en copia (separados por comas)" '
    +'style="'+est+';flex:1;min-width:230px"></div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">'
    +'<button class="btn bg2" style="padding:8px 14px" '
    +'onclick="window._ce.abierto=null;_cePintar()">Volver</button>'
    +'<button class="btn bp" style="padding:8px 16px" onclick="_ceReenviar(\''+x.id+'\')">'
    +'<i class="ti ti-send"></i> Reenviar</button></div></div>';
}

async function _ceReenviar(id){
  var S=window._ce;
  var x=(S.lista||[]).filter(function(c){ return String(c.id)===String(id); })[0];
  if(!x) return;
  var lee=function(el){
    return String((document.getElementById(el)||{}).value||'')
      .split(/[,;]+/).map(function(v){ return v.trim(); })
      .filter(function(v){ return v.indexOf('@')>0; });
  };
  var para=lee('ceParaR'), cc=lee('ceCcR');
  var todos=para.concat(cc).filter(function(v,i,a){ return a.indexOf(v)===i; });
  if(!todos.length){ showT('Pon al menos un destinatario'); return; }
  if(!confirm('REENVIAR\n\nAsunto: '+(x.asunto||'')+'\nPara: '+todos.join(', ')
    +((x.adjuntos&&x.adjuntos.length)?('\nCon '+x.adjuntos.length+' adjunto(s)'):'')
    +'\n\n¿Lo mando?')) return;
  try{
    var fila={
      docnum:x.docnum||null,
      para_lista:todos, para_email:todos[0],
      asunto:(String(x.asunto||'').indexOf('RV:')===0?x.asunto:('RV: '+(x.asunto||''))),
      cuerpo:x.cuerpo||'',
      adjuntos:x.adjuntos||[],
      de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
      origen:'reenvío · '+(x.origen||'correos enviados'),
      estado:'pendiente'
    };
    var r=await _postTolerante(SB+'/rest/v1/correos_queue', fila);
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));
    showT('✓ Reenviado a '+todos.length+' destinatario(s)');
    S.abierto=null;
    _ceCargar();
  }catch(e){
    showT(e&&e.cancelado ? 'Envío cancelado: no se mandó nada'
        : ('No se pudo reenviar: '+(e.message||e)), 9000);
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   ENTRADAS DE MERCANCÍA   (prefijo [EN])
   ───────────────────────────────────────────────────────────────────────────
   La última parada de la cadena: orden de compra → factura reserva → ENTRADA
   → costeo. Aquí se listan todas, se entra a cualquiera, se ve de dónde
   viene con su mapa de relaciones y se manda a los vendedores el informe de
   recepción con foto, cantidades, precio de venta y composición.
   ═══════════════════════════════════════════════════════════════════════════ */

window._en = null;

async function rEntradas(){
  var el=document.getElementById('page-entradas');
  if(!el) return;
  el.innerHTML='<div class="slbl"><i class="ti ti-truck-loading"></i> Entradas de mercancía</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'Cada factura reserva da lugar a una entrada. Pulsa cualquiera para ver de dónde '
    +'viene y mandar el informe de recepción a los vendedores.</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px">'
    +'<input id="enQ" placeholder="Número de entrada, de orden, DKC-, SKC-, HIKC-, '
    +'proveedor, BL o factura…" '
    +'oninput="clearTimeout(window._enT);var v=this.value;'
    +'window._enT=setTimeout(function(){window._en.q=v;_enPintar()},250)" '
    +'style="flex:1;min-width:240px;padding:7px 10px;border:0.5px solid var(--border);'
    +'border-radius:8px;font-size:12.5px;background:var(--surface-0);color:var(--text-primary)">'
    +'<button class="xb" onclick="_enCargar()"><i class="ti ti-refresh"></i> Actualizar</button>'
    +'</div><div id="enLista"></div>';
  if(!window._en) window._en={lista:[], q:''};
  _enPintar();
  _enCargar();
}

async function _enCargar(){
  var S=window._en=window._en||{lista:[], q:''};
  S.cargando=true; _enPintar();
  try{
    var r=await fetch(SB+'/rest/v1/opdn_entradas?select=*&order=docdate.desc,docnum.desc'
      +'&limit=500',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0 || r.status===404)
        throw new Error('falta la tabla: corre entradas.sql en Supabase y reinicia el worker');
      throw new Error(r.status+' '+t.slice(0,140));
    }
    S.lista=await r.json()||[];
    S.error='';
  }catch(e){ S.error=String(e.message||e); S.lista=[]; }
  S.cargando=false;
  _enPintar();
}

function _enVisibles(){
  var S=window._en, q=String(S.q||'').toLowerCase().trim();
  var L=(S.lista||[]).filter(function(x){ return !x.cancelada; });
  if(!q) return L;
  // El número suelto («12416») vale tanto de entrada como de orden, y los
  // DKC- / SKC- / HIKC- se buscan por el texto de la orden a la que
  // pertenecen, que el portal conoce.
  var soloNum=q.replace(/[^0-9]/g,'');
  var ordenesDelTexto={};
  try{
    (orders||[]).forEach(function(o){
      var ref=[o.id, o.dkc, o.num_proveedor].map(function(v){
        return String(v||'').toLowerCase(); });
      if(ref.some(function(v){ return v && v.indexOf(q)>=0; }))
        ordenesDelTexto[String(o.id)]=true;
    });
  }catch(e){}
  // Las facturas reserva de esas órdenes: la entrada casi siempre cuelga de
  // la factura, no de la orden, y sin esto no se encontraba nunca.
  var facturasDeEsasOrdenes={};
  try{
    Object.keys(ordenesDelTexto).forEach(function(num){
      ((window._fres&&window._fres.filas)||[]).forEach(function(f){
        if(String(f.ordenes||'').replace(/[^0-9]/g,' ').split(/\s+/).indexOf(num)>=0)
          facturasDeEsasOrdenes[String(f.docnum)]=true;
      });
    });
  }catch(e){}

  return L.filter(function(x){
    var campos=[x.docnum, x.cardname, x.cardcode, x.bl, x.numatcard, x.ordenes,
                x.facturas, x.num_doc_com, x.contenedores]
      .map(function(v){ return String(v||'').toLowerCase(); });
    if(campos.some(function(v){ return v.indexOf(q)>=0; })) return true;
    // Por número de orden suelto
    if(soloNum && String(x.ordenes||'').replace(/[^0-9,# ]/g,'')
         .split(/[^0-9]+/).indexOf(soloNum)>=0) return true;
    // Y por DKC/SKC/HIKC: se mira a qué orden corresponde
    var ords=String(x.ordenes||'').replace(/[^0-9]/g,' ').trim().split(/\s+/);
    if(ords.some(function(n){ return n && ordenesDelTexto[n]; })) return true;
    // O a qué factura reserva de esa orden
    var facs=String(x.facturas||'').replace(/[^0-9]/g,' ').trim().split(/\s+/);
    return facs.some(function(n){ return n && facturasDeEsasOrdenes[n]; });
  });
}

function _enPintar(){
  var box=document.getElementById('enLista'); if(!box) return;
  var S=window._en; if(!S) return;
  if(S.error){
    box.innerHTML='<div class="nota" style="background:var(--pastel-error);'
      +'color:var(--t-rojo)">'+_esc(S.error)+'</div>';
    return;
  }
  if(S.cargando && !(S.lista||[]).length){
    box.innerHTML='<div style="font-size:12px;color:var(--text-muted)">'
      +'<span class="ai-ring g"></span> Cargando…</div>';
    return;
  }
  var L=_enVisibles();
  if(!L.length){
    var q=String(S.q||'').trim();
    box.innerHTML='<div class="empty"><i class="ti ti-truck-loading" '
      +'style="font-size:22px"></i><br>'
      +(q ? ('No encuentro ninguna entrada para «'+_esc(q)+'».<br>'
             +'<span style="font-size:11.5px;color:var(--text-muted)">'
             +'Si es una orden, todavía no tiene entrada de mercancía: aparecerá '
             +'aquí en cuanto SAP la cree y el worker la baje.</span>')
           : 'No hay entradas que mostrar')+'</div>';
    return;
  }
  var th='position:sticky;top:0;z-index:2;background:#0C447C;color:#fff;'
    +'font-size:11px;font-weight:700;padding:8px 10px;text-align:left;'
    +'letter-spacing:.3px;white-space:nowrap';
  var tot=L.reduce(function(a,x){ return a+(Number(x.total)||0); },0);

  box.innerHTML=_enBarraSeleccion()
    +'<div style="border:0.5px solid var(--border);border-radius:11px;'
    +'overflow:hidden;background:var(--surface-0)">'
    +'<div style="max-height:70vh;overflow:auto"><table style="width:100%;'
    +'border-collapse:separate;border-spacing:0">'
    +'<thead><tr>'
    +'<th style="'+th+';width:34px;text-align:center">'
      +'<input type="checkbox" id="enTodas" onclick="_enMarcarTodas(this.checked)" '
      +'title="Marcar o desmarcar todas"></th>'
    +'<th style="'+th+';width:95px">ENTRADA</th>'
    +'<th style="'+th+';width:105px">FECHA</th>'
    +'<th style="'+th+'">PROVEEDOR</th>'
    +'<th style="'+th+';width:160px">VIENE DE</th>'
    +'<th style="'+th+';width:190px">BL / CONTENEDOR</th>'
    +'<th style="'+th+';width:115px;text-align:right">TOTAL</th>'
    // El número que usa Kennedy para hablar de la entrada
    +'<th style="'+th+';width:105px">ENTRADA doc. com.</th></tr></thead><tbody>'
    + L.map(function(x, i){
        var zebra=(i%2)?'background:var(--bg-accent)':'background:var(--surface-0)';
        var marcada=((window._enSel||{})[x.docentry])?true:false;
        if(marcada) zebra='background:var(--pastel-azul)';
        var td='padding:7px 10px;border-bottom:0.5px solid var(--border);font-size:11.5px';
        return '<tr style="cursor:pointer;'+zebra+'" onclick="_enAbrir('+x.docentry+')" '
          +'onmouseover="this.style.filter=\'brightness(.96)\'" '
          +'onmouseout="this.style.filter=\'\'" title="Ver la entrada y su informe">'
          // La casilla no abre la entrada: solo la marca
          +'<td style="'+td+';text-align:center" onclick="event.stopPropagation()">'
          +'<input type="checkbox" '+(marcada?'checked':'')+' '
          +'onclick="event.stopPropagation();_enMarcar('+x.docentry+',this.checked)" '
          +'title="Marcar para mandar un solo informe con varias entradas"></td>'
          +'<td style="'+td+'"><b style="color:var(--t-azul);font-size:12.5px">#'
          +_esc(x.docnum)+'</b></td>'
          +'<td style="'+td+';color:var(--text-secondary)">'+_esc(_fechaCorta(x.docdate))+'</td>'
          +'<td style="'+td+';font-weight:600">'+_esc(x.cardname||x.cardcode||'')+'</td>'
          +'<td style="'+td+'">'
          +(x.facturas?('<span style="background:var(--pastel-aviso);color:var(--t-marron);'
            +'border-radius:7px;padding:1px 7px;font-size:10.5px;font-weight:600">Factura '
            +_esc(x.facturas)+'</span>'):'')
          +(x.ordenes?('<div style="margin-top:2px"><span style="background:var(--pastel-azul);'
            +'color:var(--t-azul);border-radius:7px;padding:1px 7px;font-size:10.5px;'
            +'font-weight:600">Orden '+_esc(x.ordenes)+'</span></div>'):'')+'</td>'
          +'<td style="'+td+';font-size:10.5px;color:var(--text-muted);font-family:monospace">'
          +_esc(x.bl||'')
          +(x.contenedores?('<div>'+_esc(x.contenedores)+'</div>'):'')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700;color:var(--t-verde)">'
          +_fmtN2(x.total)+'</td>'
          +'<td style="'+td+'"><b style="color:var(--t-marron)">'
          +_esc(x.num_doc_com||'—')+'</b></td></tr>';
      }).join('')
    +'</tbody><tfoot><tr style="background:var(--surface-1);font-weight:700">'
    +'<td colspan="5" style="padding:8px 10px;text-align:right;font-size:11.5px">'
    +L.length+' entrada(s)</td>'
    +'<td style="padding:8px 10px;text-align:right;font-size:12.5px;color:var(--t-verde)">'
    +_fmtN2(tot)+'</td><td></td></tr></tfoot></table></div></div>';
}

// ── Una entrada por dentro ────────────────────────────────────────────────
async function _enAbrir(docentry){
  // Se puede llegar aquí desde el mapa de una orden, sin haber pasado por la
  // pantalla de Entradas. Entonces no hay lista cargada y antes no pasaba
  // nada al pulsar; ahora se trae esa entrada y se abre igual.
  window._en = window._en || {lista:[], q:''};
  var S=window._en;
  var e=(S.lista||[]).filter(function(x){ return String(x.docentry)===String(docentry); })[0];
  if(!e){
    showT('Abriendo la entrada…');
    try{
      var r=await fetch(SB+'/rest/v1/opdn_entradas?select=*&docentry=eq.'+docentry,
        {headers:SBH});
      e=(r.ok?((await r.json())||[]):[])[0];
      if(e){
        S.lista=(S.lista||[]).concat([e]);
        if(PG!=='entradas'){ go('entradas'); try{ rEntradas(); }catch(err){} }
      }
    }catch(err){}
  } else if(PG!=='entradas'){
    go('entradas');
    try{ rEntradas(); }catch(err){}
  }
  if(!e){ showT('No encuentro esa entrada en el portal'); return; }
  S.abierta=e; S.lineas=null;
  try{
    if(e.enviado_vendedores){
      window._enEnviados=window._enEnviados||{};
      window._enEnviados[String(e.docentry)]=e.enviado_vendedores;
    }
  }catch(err){}
  var ov=document.createElement('div');
  ov.id='modalEN';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10072;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:1120px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="enDet"></div></div>';
  document.body.appendChild(ov);
  _enDetPintar();
  try{
    var r=await fetch(SB+'/rest/v1/opdn_lineas?select=*&docentry=eq.'+docentry
      +'&order=linenum',{headers:SBH});
    S.lineas=r.ok ? (await r.json()||[]) : [];
  }catch(err){ S.lineas=[]; }

  // El precio de venta de cada artículo, solo para saber si ya lo tiene
  S.pv={};
  // PRIMERO los precios puestos en el costeo de las órdenes de esta entrada:
  // tardan en llegar a la copia del inventario del portal, pero son los que
  // valen. Antes la entrada decía «sin precio» aunque ya estuvieran en SAP.
  try{
    var nums=String(e.ordenes||'').replace(/[^0-9]/g,' ').trim().split(/\s+/)
      .filter(Boolean);
    for(var k=0;k<nums.length;k++){
      var rl=await fetch(SB+'/rest/v1/compras_logistica?select=datos&docnum=eq.'+nums[k],
        {headers:SBH});
      var fl=(rl.ok?((await rl.json())||[]):[])[0];
      var dd=fl&&fl.datos;
      if(typeof dd==='string'){ try{ dd=JSON.parse(dd); }catch(err){ dd=null; } }
      // Todos los precios guardados de esa orden, de cualquiera de sus costeos
    var _pp=(dd&&dd.precios)||{};
    var val={};
    Object.keys(_pp.porCosteo||{}).forEach(function(k){
      Object.assign(val, _pp.porCosteo[k]||{});
    });
    Object.assign(val, _pp.valores||{});
      Object.keys(val).forEach(function(ref){
        var p=Number(val[ref])||0;
        if(p>0) S.pv[String(ref).trim()]=p;
      });
    }
  }catch(err){}
  try{
    var codigos=[...new Set((S.lineas||[]).map(function(l){
      return String(l.itemcode||'').trim(); }).filter(Boolean))];
    for(var ci=0; ci<codigos.length; ci+=60){
      var lote=codigos.slice(ci,ci+60).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var rp=await fetch(SB+'/rest/v1/inventario?select=itemcode,precioventa&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      if(rp.ok) (await rp.json()||[]).forEach(function(x){
        var c=String(x.itemcode);
        if(!(S.pv[c]>0)) S.pv[c]=Number(x.precioventa)||0;   // el costeo manda
      });
    }
  }catch(err){}

  // La entrada suele colgar de la FACTURA, no de la orden, así que el
  // número de orden no viene en la cabecera. Se busca en las líneas y, si
  // tampoco está, en la propia factura reserva.
  if(!String(e.ordenes||'').trim()){
    var deLineas=[...new Set((S.lineas||[]).map(function(l){ return l.orden_num; })
                    .filter(Boolean))];
    if(deLineas.length) e.ordenes=deLineas.map(function(x){ return '#'+x; }).join(', ');
    else{
      var nf=String(e.facturas||'').replace(/[^0-9]/g,' ').trim().split(/\s+/)[0];
      if(nf){
        try{
          var rf=await fetch(SB+'/rest/v1/opch_reserva?select=ordenes&docnum=eq.'+nf,
            {headers:SBH});
          var cab=(rf.ok?((await rf.json())||[]):[])[0];
          if(cab && cab.ordenes) e.ordenes=cab.ordenes;
        }catch(err2){}
      }
    }
  }
  _enDetPintar();
}

function _enCerrar(){
  var m=document.getElementById('modalEN'); if(m) m.remove();
  if(window._en) window._en.abierta=null;
}

/* El mapa de relaciones, como el de SAP: socio → orden → factura reserva →
   entrada. Cada caja se puede pulsar para ir a ese documento. */
function _enMapa(e){
  var caja=function(tit, lineas, color, onclick){
    return '<div'+(onclick?(' onclick="'+onclick+'" style="cursor:pointer;'):' style="')
      +'min-width:150px;border:1.5px solid '+color+';border-radius:9px;'
      +'background:var(--surface-0);overflow:hidden">'
      +'<div style="background:'+color+';color:#fff;font-size:10.5px;font-weight:700;'
      +'padding:3px 8px">'+tit+'</div>'
      +'<div style="padding:6px 8px;font-size:11px;line-height:1.5;text-align:right">'
      + lineas.filter(Boolean).map(function(l){ return _esc(l); }).join('<br>')
      +'</div></div>';
  };
  var flecha='<div style="align-self:center;color:var(--text-muted);font-size:18px">→</div>';
  return '<div style="background:var(--surface-1);border-radius:10px;padding:12px;'
    +'margin-bottom:12px;overflow-x:auto">'
    +'<div style="font-size:11.5px;font-weight:700;margin-bottom:8px">'
    +'<i class="ti ti-sitemap"></i> De dónde viene esta entrada</div>'
    +'<div style="display:flex;gap:10px;align-items:stretch;min-width:max-content">'
    + caja('Proveedor', [e.cardcode, String(e.cardname||'').slice(0,26)], '#64748B')
    + flecha
    + caja('Orden de compra', [e.ordenes||'—', e.numatcard||''], '#0C447C',
        e.ordenes?("_enIrOrden('"+String(e.ordenes).replace(/[^0-9,# ]/g,'')+"')"):'')
    + flecha
    + caja('Factura reserva', [e.facturas||'—'], '#7C3D12',
        e.facturas?("_enIrFactura('"+String(e.facturas).replace(/[^0-9,# ]/g,'')+"')"):'')
    + flecha
    + caja('Entrada de mercancía', ['#'+e.docnum, _fechaCorta(e.docdate),
        _fmtN2(e.total)], '#166534')
    +'</div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-top:7px">'
    +'Pulsa la orden o la factura para abrirlas.</div></div>';
}

function _enIrOrden(txt){
  var n=String(txt||'').replace(/[^0-9]/g,' ').trim().split(/\s+/)[0];
  if(!n) return;
  _enCerrar();
  go('ordenes');
  setTimeout(function(){
    try{ openDetail(n); }catch(e){ showT('No encuentro la orden #'+n+' en el portal'); }
  }, 250);
}

/* La factura reserva se abre en su pantalla, no en la de crear: antes se
   iba a «factreserva», que es el asistente de creación, y por eso parecía
   que el enlace no hacía nada. Aquí se carga el listado si hace falta y se
   abre la factura por su número. */
async function _enIrFactura(txt){
  var n=String(txt||'').replace(/[^0-9]/g,' ').trim().split(/\s+/)[0];
  if(!n) return;
  _enCerrar();
  go('facturasres');
  try{ rFacturasRes(); }catch(e){}
  showT('Abriendo la factura reserva #'+n+'…');
  for(var i=0;i<20;i++){
    var f=((window._fres&&window._fres.filas)||[]).filter(function(x){
      return String(x.docnum)===String(n); })[0];
    if(f){ _fresAbrir(f.docentry); return; }
    await new Promise(function(r){ setTimeout(r, 400); });
  }
  showT('No encuentro la factura reserva #'+n+' en el listado');
}

function _enDetPintar(){
  var c=document.getElementById('enDet'); if(!c) return;
  var S=window._en, e=S&&S.abierta; if(!e) return;
  var L=S.lineas;
  var uds=(L||[]).reduce(function(a,l){ return a+(Number(l.cantidad)||0); },0);

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-truck-loading" style="font-size:22px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:16px;font-weight:700">'
    +'Entrada de mercancía #'+_esc(e.docnum)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +_esc(e.cardcode||'')+' · '+_esc(e.cardname||'')+' · '+_esc(_fechaCorta(e.docdate))
    +(e.num_doc_com?(' · doc. comercial '+_esc(e.num_doc_com)):'')
    +(e.bl?(' · BL '+_esc(e.bl)):'')+'</div></div>'
    +'<button class="xb" onclick="_enCerrar()"><i class="ti ti-x"></i></button></div>'
    + _enMapa(e)
    +(L===null
      ? '<div style="font-size:12px;color:var(--text-muted)"><span class="ai-ring g"></span> '
        +'Cargando las líneas…</div>'
      : (!L.length
         ? '<div class="empty">Esta entrada no tiene líneas en el portal</div>'
         : '<div class="tbx-box" style="max-height:46vh;overflow:auto"><table class="tbx">'
           +'<thead><tr><th style="width:44px">Foto</th><th style="width:150px">Referencia</th>'
           +'<th>Descripción</th><th style="width:130px">Código de barras</th>'
           +'<th style="width:90px;text-align:right">Cantidad</th>'
           // El precio de la entrada es el COSTO CIF; el de venta va al lado
           // solo para saber si el artículo ya lo tiene puesto.
           +'<th style="width:95px;text-align:right">Precio CIF</th>'
           +'<th style="width:100px;text-align:right">Total</th>'
           +'<th style="width:100px;text-align:right">Precio venta</th></tr></thead><tbody>'
           + L.map(function(l){
               var pvta=Number((S.pv||{})[String(l.itemcode)])||0;
               return '<tr><td>'+_frImgFoto(l)+'</td>'
                 +'<td><b>'+_esc(l.itemcode)+'</b></td>'
                 +'<td style="font-size:11.5px">'+_esc(String(l.dscription||'').slice(0,46))+'</td>'
                 +'<td style="font-size:10.5px;color:var(--text-muted)">'+_esc(l.barcode||'')+'</td>'
                 +'<td style="text-align:right">'+_fmtN2(l.cantidad)+'</td>'
                 +'<td style="text-align:right">'+_fmtN2(l.precio)+'</td>'
                 +'<td style="text-align:right">'+_fmtN2(l.total)+'</td>'
                 +'<td style="text-align:right;font-weight:700;color:'
                 +(pvta>0?'var(--t-verde)':'var(--t-rojo)')+'">'
                 +(pvta>0?_fmtN2(pvta):'sin precio')+'</td></tr>';
             }).join('')
           +'</tbody><tfoot><tr style="font-weight:700;background:var(--surface-1)">'
           +'<td colspan="4" style="text-align:right">TOTALES</td>'
           +'<td style="text-align:right">'+_fmtN2(uds)+'</td><td></td>'
           +'<td style="text-align:right">'+_fmtN2(e.total)+'</td>'
           +'<td style="text-align:right;font-size:10.5px;color:var(--text-muted)">'
           +((S.lineas||[]).filter(function(z){
               return !((S.pv||{})[String(z.itemcode)]>0); }).length)
           +' sin precio</td></tr></tfoot></table></div>'))
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px;flex-wrap:wrap">'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_enCerrar()">Cerrar</button>'
    +'<button class="btn bg2" style="padding:9px 14px" '
    +'onclick="_enPreciosDeSap()" title="Lee los precios directamente de SAP, '
    +'sin esperar al Sync del inventario">'
    +'<i class="ti ti-refresh"></i> Traer precios de SAP</button>'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_enPDF()">'
    +'<i class="ti ti-file-type-pdf"></i> Ver el informe</button>'
    + (_enEnviado(e.docentry)
       ? ('<span style="display:inline-flex;align-items:center;gap:7px;'
          +'background:var(--pastel-ok);color:var(--t-verde);border-radius:9px;'
          +'padding:9px 14px;font-size:12px;font-weight:700">'
          +'<i class="ti ti-circle-check"></i> Enviado a vendedores · '
          +_esc(_enEnviado(e.docentry).por||'')+' · '
          +_esc(_fechaHora(_enEnviado(e.docentry).fecha))+'</span>'
          +'<button class="btn bg2" style="padding:9px 14px" onclick="_enMailModal()">'
          +'<i class="ti ti-send"></i> Volver a enviar</button>')
       : ('<button class="btn bp" style="padding:9px 18px" onclick="_enMailModal()">'
          +'<i class="ti ti-mail"></i> Enviar a vendedores</button>'))
    +'</div>';
}


/* ── El informe de recepción de mercancía ─────────────────────────────────
   El mismo documento que saca SAP, con el formato de Kennedy: una ficha por
   artículo con su foto, la descripción, la composición, los colores, los
   tamaños, el empaque, el peso y el cubicaje por bulto, el código de barras
   y, a la derecha, la cantidad recibida y el precio de venta. */
async function _enFichas(){
  var S=window._en, e=S&&S.abierta;
  if(!e || !(S.lineas||[]).length) return [];
  // Lo que no viene en la línea se completa con la ficha del artículo
  var codigos=[...new Set(S.lineas.map(function(l){ return String(l.itemcode||''); })
                  .filter(Boolean))];
  var inv={};
  try{
    for(var i=0;i<codigos.length;i+=60){
      var lote=codigos.slice(i,i+60).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var r=await fetch(SB+'/rest/v1/inventario?select=*&itemcode=in.('+lote.join(',')+')',
        {headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){ inv[String(x.itemcode)]=x; });
    }
  }catch(err){}
  var fichas=[];
  for(var k=0;k<S.lineas.length;k++){
    var l=S.lineas[k];
    var f=inv[String(l.itemcode)]||{};
    fichas.push({
      grupo:f.grupo||'', marca:f.marca||'', picturname:l.picturname||f.picturname||'',
      itemcode:l.itemcode,
      desc:l.dscription||f.itemname||'',
      composicion:l.composicion||f.composicion||f.udf_composicion||'',
      colores:l.colores||f.u_color||f.colores||f.color||'',
      tam_bulto:l.tam_bulto||f.tamano_bulto||f.medida_carton||'',
      tam_pza:l.tam_pza||f.u_tamano||f.tamano||'',
      peso_bulto:Number(l.peso_bulto||f.peso_bulto)||0,
      vol_bulto:Number(l.vol_bulto||f.cubicaje_bulto)||0,
      empaque:(Number(l.pzs_bulto||l.unid_bulto||f.unidadesbulto)||0),
      um:l.um_compra||'PZA', empaque_um:l.empaque||'BULTO',
      barcode:l.barcode||f.codebars||'',
      cantidad:Number(l.cantidad)||0,
      // El precio de venta: primero el que se acaba de poner en el costeo
      // (todavía puede no estar en SAP, va por la cola del worker), y si no,
      // el de la ficha del artículo. El de la línea es el de COMPRA.
      precio:Number(((window._en&&window._en.pv)||{})[String(l.itemcode)])
             || Number(f.precioventa) || 0,
      foto:_frImgFoto({itemcode:l.itemcode, picturname:l.picturname||f.picturname}),
      _l:{itemcode:l.itemcode, picturname:l.picturname||f.picturname}
    });
  }
  // Las fotos, en base64, para poder meterlas en el PDF adjunto
  for(var j=0;j<fichas.length;j++){
    try{ fichas[j].b64=await _enFotoDe(fichas[j]._l); }catch(e){}
  }
  S.fichasCache=fichas;
  return fichas;
}

async function _enInformeHtml(){
  var S=window._en, e=S&&S.abierta;
  var fichas=await _enFichas();
  var ficha=function(x){
    return '<div class="fic">'
      +'<div class="foto">'+x.foto+'</div>'
      +'<div class="datos">'
      +'<div class="ref">'+_esc(x.itemcode)+'</div>'
      +'<div><b>Descripción:</b> '+_esc(x.desc)+'</div>'
      +(x.composicion?('<div><b>Composición:</b> '+_esc(x.composicion)+'</div>'):'')
      +(x.colores?('<div><b>Colores:</b> '+_esc(x.colores)+'</div>'):'')
      +(x.tam_bulto?('<div><b>Tamaño x Bulto:</b> '+_esc(x.tam_bulto)+'</div>'):'')
      +(x.tam_pza?('<div><b>Tamaño x Pza:</b> '+_esc(x.tam_pza)+'</div>'):'')
      +(x.peso_bulto?('<div><b>Peso x Bulto:</b> '+_fmtN2(x.peso_bulto)+' kg</div>'):'')
      +(x.vol_bulto?('<div><b>Cubicaje x Bulto:</b> '+x.vol_bulto.toFixed(5)+' ft³</div>'):'')
      +(x.empaque?('<div><b>Empaque:</b> '+_fmtN2(x.empaque)+' '+_esc(x.um)+' X 1 '
        +_esc(x.empaque_um)+'</div>'):'')
      +(x.barcode?('<div><b>Código de barra:</b> '+_esc(x.barcode)+'</div>'):'')
      +'</div>'
      +'<div class="nums"><div class="cab">Cantidad &nbsp; Precio</div>'
      +'<div class="v">'+_fmtN2(x.cantidad)+' &nbsp;&nbsp; '+_fmtN2(x.precio)+'</div></div>'
      +'</div>';
  };
  return '<html><head><meta charset="utf-8"><title>Informe de recepción '
    +_esc(e.docnum)+'</title><style>'
    +'body{font-family:Arial,Helvetica,sans-serif;color:#111;padding:22px;margin:0}'
    +'h1{font-size:15px;margin:0;text-align:center;letter-spacing:.5px}'
    +'h2{font-size:13px;margin:2px 0 12px;text-align:center;font-weight:600}'
    +'.cab2{display:flex;justify-content:space-between;font-size:11px;margin-bottom:10px;'
    +'border-bottom:1.5px solid #0c447c;padding-bottom:6px}'
    +'.fic{display:flex;gap:10px;border-bottom:0.5px solid #d6dbe2;padding:8px 0;'
    +'page-break-inside:avoid}'
    +'.foto img{width:74px;height:74px;object-fit:cover;border-radius:5px}'
    +'.datos{flex:1;font-size:10.5px;line-height:1.45}'
    +'.ref{font-weight:800;font-size:12px;color:#0c447c;margin-bottom:2px}'
    +'.nums{width:135px;text-align:right;font-size:11px}'
    +'.nums .cab{font-weight:700;border-bottom:0.5px solid #999;margin-bottom:3px}'
    +'.nums .v{font-size:13px;font-weight:700}'
    +'.pie{margin-top:14px;font-size:10px;color:#555;text-align:center}'
    +'.noprint{margin-top:16px;text-align:center}@media print{.noprint{display:none}}'
    +'</style></head><body>'
    +'<h1>KENNEDY CENTER CORP.</h1>'
    +'<h2>INFORME DE RECEPCIÓN DE MERCANCÍA</h2>'
    +'<div class="cab2"><div><b>ENTRADA COMERCIAL:</b> '
    +_esc(e.num_doc_com||('#'+e.docnum))+'</div>'
    +'<div><b>PROVEEDOR:</b> '+_esc(e.cardname||'')+'</div>'
    +'<div><b>FECHA:</b> '+_esc(_fechaCorta(e.docdate))+'</div></div>'
    + fichas.map(ficha).join('')
    +'<div class="pie">'+fichas.length+' referencia(s) · '
    +_fmtN2(fichas.reduce(function(a,x){ return a+x.cantidad; },0))+' unidades · '
    +'entrada #'+_esc(e.docnum)
    +(e.facturas?(' · factura reserva '+_esc(e.facturas)):'')
    +(e.ordenes?(' · orden '+_esc(e.ordenes)):'')+'</div>'
    +'<div class="noprint"><button onclick="window.print()" style="background:#0c447c;'
    +'color:#fff;border:none;border-radius:7px;padding:9px 18px;font-size:13px;'
    +'cursor:pointer">Imprimir o guardar como PDF</button></div>'
    +'</body></html>';
}

async function _enPDF(){
  showT('Preparando el informe…');
  var blob=await _enPDFBlob();
  if(!blob) return;
  var url=URL.createObjectURL(blob);
  var w=window.open(url,'_blank');
  if(!w) showT('El navegador bloqueó la ventana');
  setTimeout(function(){ URL.revokeObjectURL(url); }, 60000);
}

/* ── El correo a los vendedores ───────────────────────────────────────────
   Se eligen de la lista de vendedores del portal y se pueden añadir más
   direcciones a mano. Sale por Graph, como el resto de correos, con el
   informe dentro del cuerpo. */
async function _enMailModal(){
  var S=window._en, e=S&&S.abierta; if(!e) return;
  // Los vendedores a los que va siempre este informe. Salen marcados; se
  // puede desmarcar a quien no toque y añadir más abajo.
  var vend=[], vistos={};
  EN_VENDEDORES.forEach(function(v){
    var em=String(v.email||'').trim().toLowerCase();
    if(!em || vistos[em]) return;
    vistos[em]=1;
    vend.push({slpname:v.slpname, email:em, fijo:true});
  });
  try{
    var r=await fetch(SB+'/rest/v1/vendedores?select=slpcode,slpname,email&order=slpname',
      {headers:SBH});
    (r.ok?(await r.json()||[]):[]).forEach(function(v){
      var em=String(v.email||'').trim().toLowerCase();
      if(em.indexOf('@')<0 || vistos[em]) return;   // sin repetir a nadie
      vistos[em]=1;
      vend.push({slpname:v.slpname||'', email:em, fijo:false});
    });
  }catch(err){}
  // Y los usuarios del portal, que también reciben estos avisos
  var usuarios=(typeof USERS!=='undefined'?USERS:[]).filter(function(u){
    if(!u.email || u.id===(CU&&CU.id)) return false;
    return !vistos[String(u.email).trim().toLowerCase()];
  });

  var ov=document.createElement('div');
  ov.id='modalENMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10074;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  var casilla=function(email, nombre, marcado){
    return '<label style="display:flex;align-items:center;gap:7px;font-size:11.5px;'
      +'padding:3px 0;min-width:230px">'
      +'<input type="checkbox" class="en-dest" value="'+_esc(email)+'"'
      +(marcado?' checked':'')+'> '+_esc(nombre)
      +' <span style="color:var(--text-muted)">'+_esc(email)+'</span></label>';
  };
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:820px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div style="font-size:15px;font-weight:700;margin-bottom:3px">'
    +'Enviar el informe de la entrada #'+_esc(e.docnum)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'Sale por Graph con el informe de recepción dentro del correo: foto, cantidades, '
    +'precio de venta y composición de cada referencia.</div>'
    +'<div style="font-size:12px;font-weight:700;margin-bottom:4px">Vendedores</div>'
    +'<div style="display:flex;flex-wrap:wrap;gap:4px 18px;max-height:28vh;overflow:auto;'
    +'border:0.5px solid var(--border);border-radius:9px;padding:8px;margin-bottom:9px">'
    +(vend.length
      ? vend.map(function(v){ return casilla(v.email, v.slpname||'', v.fijo); }).join('')
      : '<div style="font-size:11.5px;color:var(--text-muted)">Los vendedores no tienen '
        +'correo en el portal. Añade las direcciones abajo.</div>')
    +'</div>'
    +'<div style="font-size:12px;font-weight:700;margin-bottom:4px">Del equipo</div>'
    +'<div style="display:flex;flex-wrap:wrap;gap:4px 18px;max-height:20vh;overflow:auto;'
    +'border:0.5px solid var(--border);border-radius:9px;padding:8px;margin-bottom:9px">'
    + usuarios.map(function(u){ return casilla(u.email, u.name, false); }).join('')
    +'</div>'
    +'<input id="enExtra" placeholder="Añadir más correos, separados por comas" '
    +'style="width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12px;background:var(--surface-0);color:var(--text-primary);'
    +'margin-bottom:9px">'
    +'<input id="enAsunto" value="'+_esc(_enAsuntoPorDefecto())+'" '
    +'style="width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12.5px;font-weight:600;background:var(--surface-0);'
    +'color:var(--text-primary);margin-bottom:9px">'
    +'<textarea id="enNota" rows="8" '
    +'style="width:100%;box-sizing:border-box;padding:8px;border:0.5px solid var(--border);'
    +'border-radius:8px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
    +_esc(_enCuerpoPorDefecto())+'</textarea>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:5px">'
    +'El informe va <b>adjunto en PDF</b>, con las fotos, las cantidades y los precios.</div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:11px;'
    +'flex-wrap:wrap">'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_enMailCerrar()">'
    +'Cancelar</button>'
    // Ver el PDF que se va a mandar ANTES de mandarlo
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_enPDF()">'
    +'<i class="ti ti-eye"></i> Ver el informe que se enviará</button>'
    +'<button class="btn bp" style="padding:9px 18px" onclick="_enMailEnviar()">'
    +'<i class="ti ti-send"></i> Enviar</button></div></div>';
  document.body.appendChild(ov);
}

function _enMailCerrar(){
  var m=document.getElementById('modalENMail'); if(m) m.remove();
}

async function _enMailEnviar(){
  // Candado contra el doble clic: generar el PDF tarda unos segundos y el
  // botón se quedaba activo, así que un segundo clic encolaba OTRO correo.
  if(window._enEnviando){ showT('Ya se está enviando…'); return; }
  window._enEnviando=true;
  var _btnEnv=document.querySelector('#modalENMail .btn.bp');
  if(_btnEnv){
    _btnEnv.disabled=true;
    _btnEnv.innerHTML='<span class="ai-ring"></span> Enviando…';
  }
  try{
    return await _enMailEnviarReal();
  } finally {
    window._enEnviando=false;
    if(_btnEnv && document.body.contains(_btnEnv)){
      _btnEnv.disabled=false;
      _btnEnv.innerHTML='<i class="ti ti-send"></i> Enviar';
    }
  }
}

async function _enMailEnviarReal(){
  var S=window._en, e=S&&S.abierta; if(!e) return;
  var marcados=Array.prototype.slice.call(document.querySelectorAll('.en-dest:checked'))
                 .map(function(c){ return c.value; });
  var extra=String((document.getElementById('enExtra')||{}).value||'')
              .split(/[,;]+/).map(function(v){ return v.trim(); })
              .filter(function(v){ return v.indexOf('@')>0; });
  var todos=marcados.concat(extra).filter(function(v,i,a){ return a.indexOf(v)===i; });
  if(!todos.length){ showT('Marca al menos un destinatario'); return; }

  var asunto=String((document.getElementById('enAsunto')||{}).value||'').trim()
             || _enAsuntoPorDefecto();
  var cuerpo=String((document.getElementById('enNota')||{}).value||'').trim()
             || _enCuerpoPorDefecto();

  var btn=event && event.target ? event.target : null;
  if(btn){ btn.disabled=true; btn.innerHTML='<span class="ai-ring"></span> Armando el PDF…'; }
  try{
    // El informe va adjunto, con sus fotos: se arma aquí y se manda en el
    // mismo correo, que es como lo reciben los vendedores.
    var blob=await _enPDFBlob(function(n, t){
      if(btn) btn.innerHTML='<span class="ai-ring"></span> Foto '+n+' de '+t+'…';
    });
    if(!blob) throw new Error('no pude armar el informe');
    var b64=await new Promise(function(res, rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=function(){ rej(new Error('no pude leer el PDF')); };
      fr.readAsDataURL(blob);
    });
    var nombre='Mercancia_recien_llegada_'+_enRefComercial().replace(/[^\w-]+/g,'_')+'.pdf';

    var fila={
      docnum:String(e.docnum),
      para_lista:todos, para_email:todos[0],
      asunto:asunto, cuerpo:cuerpo,
      adjuntos:[{nombre:nombre, mime:'application/pdf', contenido:b64}],
      de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
      origen:'Entrada de mercancía #'+e.docnum,
      estado:'pendiente'
    };
    var r=await _postTolerante(SB+'/rest/v1/correos_queue', fila);
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));
    _enMailCerrar();
    // Queda registrado: el botón pasa a verde con quién y cuándo, sin
    // tener que recargar nada.
    try{
      var _ents=(window._en&&window._en.entradas)||[];
      if(_ents.length>1) _ents.forEach(function(x){ _enMarcarEnviado(x.docentry, todos); });
      else _enMarcarEnviado(e.docentry, todos);
      window._enSel={};              // la selección se limpia al enviar
    }catch(err2){}
    showT('✓ Informe enviado a '+todos.length+' destinatario(s) con el PDF adjunto ('
      +Math.round(blob.size/1024)+' KB)', 9000);
  }catch(err){
    showT('No se pudo enviar: '+(err.message||err), 9000);
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
  }
}

/* El asunto y el cuerpo tal como los escribe Kennedy:
     MERCANCIA RECIEN LLEGADA DEPARTAMENTO DE HOGAR E-201/26                */
function _enAsuntoPorDefecto(){
  var dep=_enDepto();
  return 'MERCANCIA RECIEN LLEGADA'
    + (dep ? (' DEPARTAMENTO DE '+dep.toUpperCase()) : '')
    + ' ' + _enRefComercial();
}

function _enCuerpoPorDefecto(){
  var dep=_enDepto();
  return 'Buenos días,\n\n'
    +'Estimados vendedores:\n\n'
    +'En adjunto reporte con fotos de mercancía recién llegada '
    + _enRefComercial() + (dep ? (' de\n'+dep) : '') + '\n\n'
    +'Saludos.';
}

/* ── El informe de recepción como PDF adjunto ─────────────────────────────
   El mismo documento que se ve en pantalla, pero armado con jsPDF para
   poder adjuntarlo al correo: una ficha por artículo con su foto y, a la
   derecha, la cantidad recibida y el precio de venta. */
async function _enImagenB64(url, lado){
  if(!url) return null;
  try{
    var r=await fetch(url);
    if(!r.ok) return null;
    var b=await r.blob();
    if(!b.size) return null;
    // Se reduce antes de meterla en el PDF: con las fotos originales el
    // documento se iba a varios MB y Microsoft Graph, que admite unos 3 MB
    // de adjunto, lo rechazaba y el correo salía sin el informe.
    var max=lado||420;
    var chico=await new Promise(function(res){
      try{
        var fr=new FileReader();
        fr.onload=function(){
          var im=new Image();
          im.onload=function(){
            try{
              var w=im.width, h=im.height;
              if(w>max || h>max){
                if(w>=h){ h=Math.round(h*max/w); w=max; }
                else { w=Math.round(w*max/h); h=max; }
              }
              var cv=document.createElement('canvas');
              cv.width=w; cv.height=h;
              var cx=cv.getContext('2d');
              cx.fillStyle='#fff'; cx.fillRect(0,0,w,h);
              cx.drawImage(im,0,0,w,h);
              res(cv.toDataURL('image/jpeg', 0.72));
            }catch(e){ res(String(fr.result)); }
          };
          im.onerror=function(){ res(String(fr.result)); };
          im.src=String(fr.result);
        };
        fr.onerror=function(){ res(null); };
        fr.readAsDataURL(b);
      }catch(e){ res(null); }
    });
    return chico;
  }catch(e){ return null; }
}

// La primera dirección de foto que exista de verdad, de todas las variantes
async function _enFotoDe(l){
  var urls=[];
  try{ urls=(fotoVariantes(l)||[]).slice(0,8); }catch(e){}
  for(var i=0;i<urls.length;i++){
    var b64=await _enImagenB64(urls[i]);
    if(b64) return b64;
  }
  return null;
}

async function _enPDFBlob(avisar){
  var S=window._en, e=S&&S.abierta;
  if(!e) return null;
  if(!window.jspdf || !window.jspdf.jsPDF){
    showT('No se pudo cargar el generador de PDF'); return null;
  }
  var fichas=await _enFichas();
  if(!fichas.length) return null;

  var jsPDF=window.jspdf.jsPDF;
  var doc=new jsPDF({unit:'pt', format:'letter', compress:true});
  var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
  var M=30;
  var POR_PAG=4;                       // cuatro fichas por página
  var logo=null;
  try{ logo=await _catPdfLogo(); }catch(err){}

  function cabecera(pag, totPag){
    var h=44, y=26;
    doc.setFillColor(78,78,78);
    doc.rect(M, y, W-M*2, h, 'F');
    if(logo){
      var ih=24, iw=ih*(logo.w/logo.h);
      doc.setFillColor(255,255,255);
      doc.roundedRect(M+7, y+(h-ih-10)/2, iw+16, ih+10, 3, 3, 'F');
      try{ doc.addImage(logo.data,'PNG', M+15, y+(h-ih)/2, iw, ih); }catch(err){}
    }
    doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(255,255,255);
    doc.text('INFORME DE RECEPCIÓN DE MERCANCÍA', W/2, y+h/2+4, {align:'center'});
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(35,35,35);
    doc.text('ENTRADA COMERCIAL:  '+_enRefComercial(), M+2, y+h+18);
    doc.text('FECHA:  '+_fechaCorta(e.docdate), M+2, y+h+32);
    doc.setFont('helvetica','normal'); doc.setFontSize(8.5); doc.setTextColor(90);
    // Sin el nombre del proveedor: este informe lo ven los vendedores
    doc.text(fichas.length+' referencia(s)', W-M-2, y+h+18, {align:'right'});
    doc.text(_fmtN0(fichas.reduce(function(a,z){ return a+z.cantidad; },0))
      +' unidades', W-M-2, y+h+32, {align:'right'});
    doc.setDrawColor(12,68,124); doc.setLineWidth(1);
    doc.line(M, y+h+40, W-M, y+h+40);
    return y+h+52;
  }

  function pie(pag, totPag){
    doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor(110);
    doc.text('Kennedy Center Corp. · Entrada '+_enRefComercial()
      +' · '+_fechaCorta(e.docdate), M, H-26);
    doc.text('Página '+pag+' / '+totPag, W-M, H-26, {align:'right'});
  }

  // Una ficha, calcada a la de SAP: foto a la izquierda con el código
  // debajo, los datos etiquetados en el centro y el cuadro de cantidad y
  // precio a la derecha.
  function ficha(x, y0, alto){
    var fw=150, fx=M;
    doc.setDrawColor(30); doc.setLineWidth(1);
    doc.rect(fx, y0, fw, alto-18, 'D');
    if(x.b64){
      try{ doc.addImage(x.b64, 'JPEG', fx+5, y0+5, fw-10, alto-28); }
      catch(err){ try{ doc.addImage(x.b64, 'PNG', fx+5, y0+5, fw-10, alto-28); }catch(e2){} }
    } else {
      doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor(150);
      doc.text('sin foto', fx+fw/2, y0+(alto-18)/2, {align:'center'});
    }
    // El código, en su recuadro debajo de la foto
    doc.setDrawColor(30); doc.rect(fx, y0+alto-18, fw, 18, 'D');
    doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(15);
    doc.text(String(x.itemcode||''), fx+fw/2, y0+alto-5, {align:'center'});

    // Los datos
    var dx=fx+fw+18, ancho=W-M-dx-140, ln=y0+12;
    var fila=function(et, val, negrita){
      if(val===''||val==null) return;
      doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor(15);
      doc.text(et+':', dx, ln);
      doc.setFont('helvetica', negrita?'bold':'normal');
      doc.setFontSize(negrita?8.5:8); doc.setTextColor(negrita?15:60);
      // Los nombres largos se parten en varias líneas en vez de cortarse:
      // antes se imprimía solo la primera y el artículo quedaba a medias.
      var t=doc.splitTextToSize(String(val), ancho-96);
      var max=Math.min(t.length, 3);
      for(var q=0;q<max;q++) doc.text(t[q], dx+96, ln+q*9.5);
      ln+=12.5+(max-1)*9.5;
    };
    fila('Descripción', x.desc);
    fila('Composición', x.composicion);
    fila('Colores', x.colores, true);
    fila('Tamaño x Bulto', x.tam_bulto, true);
    fila('Tamaño x Pza', x.tam_pza, true);
    fila('Peso x Bulto', (x.peso_bulto?Number(x.peso_bulto).toFixed(5)+'   kg':''), true);
    fila('Cubicaje x Bulto', (x.vol_bulto?Number(x.vol_bulto).toFixed(5)+'   ft³':''), true);
    fila('Empaque', (x.empaque?(_fmtN0(x.empaque)+'   '+(x.um||'PZA')+' X 1 '
      +(x.empaque_um||'BULTO')):''), true);
    fila('Código de barra', x.barcode, true);

    // El cuadro de cantidad y precio
    var cx=W-M-130, cy=y0+18, cw=130, chh=52;
    doc.setFillColor(0,112,224);
    doc.rect(cx, cy, cw, 17, 'F');
    doc.setDrawColor(0,0,0); doc.setLineWidth(1);
    doc.rect(cx, cy, cw, chh, 'D');
    doc.line(cx+cw/2, cy, cx+cw/2, cy+chh);
    doc.line(cx, cy+17, cx+cw, cy+17);
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(255,255,255);
    doc.text('Cantidad', cx+cw/4, cy+12, {align:'center'});
    doc.text('Precio', cx+cw*3/4, cy+12, {align:'center'});
    doc.setTextColor(0,102,204); doc.setFontSize(13);
    doc.text(_fmtN0(x.cantidad), cx+cw/4, cy+40, {align:'center'});
    doc.text(x.precio>0?_fmtN2(x.precio):'—', cx+cw*3/4, cy+40, {align:'center'});
  }

  var totPag=Math.max(1, Math.ceil(fichas.length/POR_PAG));
  var y=cabecera(1, totPag), pag=1;
  var alto=Math.min(150, (H-y-60)/POR_PAG);
  for(var i=0;i<fichas.length;i++){
    if(avisar) avisar(i+1, fichas.length);
    if(i && i%POR_PAG===0){
      pie(pag, totPag);
      doc.addPage(); pag++;
      y=cabecera(pag, totPag);
    }
    ficha(fichas[i], y, alto);
    y+=alto+10;
    doc.setDrawColor(12,68,124); doc.setLineWidth(.8);
    doc.line(M, y-6, W-M, y-6);
  }
  pie(pag, totPag);
  var blob=doc.output('blob');
  _dbg('[EN] informe: '+Math.round(blob.size/1024)+' KB con '+fichas.length+' ficha(s)');
  if(blob.size > 3.2*1024*1024){
    showT('El informe pesa '+Math.round(blob.size/1024/1024*10)/10+' MB y el correo '
      +'admite unos 3. Si no llega, manda la entrada en dos tandas.', 10000);
  }
  return blob;
}

// Enteros con separador de miles, como en el informe de SAP
function _fmtN0(v){
  return (Math.round(Number(v)||0)).toLocaleString('es');
}

// La referencia comercial, como la escribe Kennedy: E-201/26
function _enRefComercial(){
  var S=window._en, e=S&&S.abierta;
  if(!e) return '';
  var n=String(e.num_doc_com||'').trim();
  if(!n) return '#'+e.docnum;
  // Un informe conjunto lleva varias entradas: «E-223/26 · E-218/26-A». Si
  // todas son del mismo número comercial, con decirlo una vez basta.
  if(n.indexOf(' · ')>=0){
    var ps=[...new Set(n.split(' · ').map(function(t){
      return /^E-/i.test(t) ? t.toUpperCase() : ('E-'+t); }))];
    return ps.length===1 ? ps[0] : ps.join(' · ');
  }
  return /^E-/i.test(n) ? n.toUpperCase() : ('E-'+n);
}

// El departamento de la mercancía, sacado de lo que trae la entrada
function _enDepto(){
  var S=window._en;
  var c={};
  (S.fichasCache||[]).forEach(function(x){
    var d=String(x.grupo||'').replace(/^[.\s\d]+/,'').trim();
    if(d) c[d]=(c[d]||0)+1;
  });
  var may='', n=0;
  Object.keys(c).forEach(function(k){ if(c[k]>n){ n=c[k]; may=k; } });
  return may;
}

/* ── Cancelar varias facturas reserva a la vez ────────────────────────────
   Se marcan en el listado y se pide la cancelación de todas en un mismo
   correo: el cuerpo lleva el desglose de cada una (orden, DKC, factura y
   monto) y el total de todas, y se adjuntan sus PDF. Todo editable antes
   de mandarlo, como en la solicitud de una sola. */
window._fresSel = window._fresSel || {};

function _fresSelUno(docentry, marcado){
  window._fresSel[String(docentry)] = !!marcado;
  if(!marcado) delete window._fresSel[String(docentry)];
  _fresPintar();
}

function _fresSelTodas(marcado){
  var filas=_fresFiltradas();
  window._fresSel={};
  if(marcado) filas.forEach(function(f){ window._fresSel[String(f.docentry)]=true; });
  _fresPintar();
}

function _fresSelLimpiar(){ window._fresSel={}; _fresPintar(); }

function _fresSeleccionadas(){
  var ids=window._fresSel||{};
  return (window._fres.filas||[]).filter(function(f){ return ids[String(f.docentry)]; });
}

function _fresSelTotal(){
  return _fresSeleccionadas().reduce(function(a,f){
    return a+(Number(f.doctotal)||0); },0);
}

async function _fresCancelarVarias(){
  var sel=_fresSeleccionadas();
  if(!sel.length){ showT('Marca al menos una factura'); return; }
  if(sel.length===1){ return _fresAbrir(sel[0].docentry); }

  var total=sel.reduce(function(a,f){ return a+(Number(f.doctotal)||0); },0);
  var provs=[...new Set(sel.map(function(f){ return f.cardname||f.cardcode||''; }))];
  if(provs.length>1 && !confirm('Las facturas marcadas son de '+provs.length
    +' proveedores distintos:\n\n'+provs.slice(0,5).join('\n')
    +'\n\nNormalmente la cancelación se pide por proveedor. ¿Sigo igual?')) return;

  // El desglose, una línea por factura, y el total al final
  var detalle=sel.map(function(f){
    return '· Factura reserva #'+f.docnum
      +(f.numatcard?(' · DKC '+f.numatcard):'')
      +(f.ordenes?(' · orden '+f.ordenes):'')
      +' · '+_fmtN2(Number(f.doctotal)||0);
  }).join('\n');

  var datos={
    proveedor:provs.join(' / '),
    dkc:sel.map(function(f){ return f.numatcard||('#'+f.docnum); }).join(', '),
    dept:'',
    total:total,
    abonado:sel.reduce(function(a,f){ return a+(Number(f.paidsum)||0); },0),
    saldo:sel.reduce(function(a,f){
      return a+(Number(f.saldo!=null?f.saldo
                 :((Number(f.doctotal)||0)-(Number(f.paidsum)||0)))||0); },0),
    eta:'',
    detalle:detalle,
    facturas:sel.length
  };

  showT('Armando las '+sel.length+' facturas en PDF…');
  await _solPagoAbrirModal(String(sel[0].docnum), 'cancelacion',
                           {datos:datos, factura:sel[0], varias:sel});
  try{
    var sp=document.getElementById('modalSolPago');
    if(sp) sp.style.zIndex='10070';
  }catch(e){}

  // El desglose se mete en el cuerpo, por delante de lo que ya trae
  try{
    var ta=document.getElementById('mail-cuerpo');
    if(ta){
      var bloque='CANCELACIÓN DE '+sel.length+' FACTURAS RESERVA\n\n'
        +detalle+'\n\nTOTAL A CANCELAR: '+_fmtN2(total)+'\n\n';
      ta.value=bloque+String(ta.value||'');
    }
  }catch(e){}

  // Y los PDF de todas, uno por factura
  var puestos=0;
  for(var i=0;i<sel.length;i++){
    try{
      var ls=await _fresTraerLineas(sel[i].docentry);
      var pdf=await _fresPdf(sel[i], ls);
      var b64=pdf.output('datauristring').split(',')[1];
      if(b64){
        window._mailAdj=window._mailAdj||[];
        window._mailAdj.push({nombre:_fresNombrePdf(sel[i]), mime:'application/pdf',
                              contenido:b64, kb:Math.round(b64.length*0.75/1024)});
        puestos++;
        try{ mailPintarAdjuntos(); }catch(e){}
      }
    }catch(e){ console.warn('[FRES] PDF de #'+sel[i].docnum+':', e); }
    showT('PDF '+(i+1)+' de '+sel.length+'…');
  }
  showT('✓ '+puestos+' factura(s) adjuntas · revisa el correo antes de enviarlo', 8000);
}

/* ── Pedidos autorizados del día ──────────────────────────────────────────
   La misma tabla del correo de las cinco de la tarde, pero en el tablero de
   inicio y durante todo el día: vendedor, fecha, pedido, cliente, marca,
   total, ganancia, porcentaje, saldo, país y condición de pago. Cada fila
   se puede pulsar para ver el pedido. */
var PAUT_COLS=['vendedor','fecha','pedido','cliente','marca','total','ganancia',
               'porcentaje','saldo','pais','condicion de pago'];
var PAUT_NUM={total:1, ganancia:1, porcentaje:1, saldo:1, pedido:1};

/* Quién ve los pedidos autorizados: gerencia general, y NO los encargados
   de departamento (Henry lleva Ropa y Gady Alfombras), porque el cuadro
   enseña la ganancia y el saldo de cada cliente. */
function _pautPuede(){
  if(!CU || CU.role!=='gerencia') return false;
  var fuera=['henry','gady'];
  if(fuera.indexOf(String(CU.id||'').toLowerCase())>=0) return false;
  return !_deptAcotado();
}

async function _pautCargar(){
  if(!_pautPuede()) return;
  var box=document.getElementById('pautBloque');
  if(!box) return;
  try{
    var hoy=_hoyISO();
    var r=await fetch(SB+'/rest/v1/pedidos_autorizados?select=*&dia=eq.'+hoy
      +'&order=id&limit=400',{headers:SBH});
    if(!r.ok){
      // Si la tabla todavía no existe se dice, pero solo a gerencia: al
      // resto no le sirve de nada ese aviso.
      var t=await r.text();
      if(_esGerencia() && (t.indexOf('does not exist')>=0 || r.status===404)){
        box.innerHTML='<div class="nota" style="background:var(--pastel-aviso);'
          +'color:var(--t-marron);font-size:11.5px">Los pedidos autorizados del día '
          +'necesitan <b>pedidos_autorizados.sql</b> en Supabase y el worker '
          +'2026-09-29-c o posterior.</div>';
      }
      return;
    }
    var crudas=await r.json()||[];
    var dia=hoy;
    // Si hoy todavía no hay ninguno (el worker sincroniza por ciclos, y los
    // fines de semana no hay pedidos), se enseña el último día que sí tuvo.
    if(!crudas.length){
      var r2=await fetch(SB+'/rest/v1/pedidos_autorizados?select=*'
        +'&order=dia.desc,id&limit=400',{headers:SBH});
      var todas=r2.ok ? (await r2.json()||[]) : [];
      if(todas.length){
        dia=todas[0].dia;
        crudas=todas.filter(function(x){ return String(x.dia)===String(dia); });
      }
    }
    var filas=crudas.map(function(x){ return x.datos||{}; });
    _dbg('[PAUT] '+filas.length+' pedido(s) del '+dia);
    if(!filas.length){
      if(_esGerencia()){
        box.innerHTML='<div class="nota" style="background:var(--surface-1);'
          +'color:var(--text-muted);font-size:11.5px">Todavía no hay pedidos '
          +'autorizados guardados. El worker los trae en cada ciclo; si no aparecen, '
          +'mira en el log la línea <b>[sync] pedidos autorizados</b>.</div>';
      }
      return;
    }
    window._paut=filas;
    box.innerHTML=_pautTabla(filas, dia);
  }catch(e){}
}

function _pautVal(d, col){
  var v=d[col];
  if(v==null){
    // Los nombres no siempre coinciden: se busca el que más se parezca
    var k=Object.keys(d).filter(function(x){
      return x.replace(/[^a-z]/g,'')===col.replace(/[^a-z]/g,''); })[0];
    v=k?d[k]:'';
  }
  return v==null?'':v;
}

function _pautTabla(filas, dia){
  var th='padding:5px 8px;border:1px solid #9fb6cd;background:#dce6f1;font-weight:700;'
    +'font-size:11.5px;text-align:left;white-space:nowrap;color:#1a1a18';
  var td='padding:4px 8px;border:1px solid #c6d4e1;font-size:11.5px;white-space:nowrap';
  var tot=0, gan=0;
  filas.forEach(function(d){
    tot+=Number(String(_pautVal(d,'total')).replace(/[^0-9.\-]/g,''))||0;
    gan+=Number(String(_pautVal(d,'ganancia')).replace(/[^0-9.\-]/g,''))||0;
  });
  var esHoy=(!dia || String(dia)===_hoyISO());
  return '<div class="slbl"><i class="ti ti-checkbox"></i>Pedidos autorizados '
    +(esHoy?'del día':('del '+_fechaCorta(dia)))
    +' <span style="font-size:10px;font-weight:400;color:var(--text-muted)">('
    +filas.length+' pedido(s) · '+_fmtN2(tot)+')</span></div>'
    +'<div class="tbx-box" style="max-height:44vh;overflow:auto;margin-bottom:16px">'
    +'<table cellspacing="0" cellpadding="0" style="border-collapse:collapse;'
    +'font-family:Calibri,Arial,sans-serif;width:100%">'
    +'<tr>'+PAUT_COLS.map(function(c){
        return '<th style="'+th+'">'+_esc(c.toUpperCase())+'</th>'; }).join('')+'</tr>'
    + filas.map(function(d,i){
        var fondo=(i%2)?'background:#eaf1f8;':'';
        return '<tr style="cursor:pointer" onclick="_pautVer('+i+')" '
          +'title="Ver el pedido">'
          + PAUT_COLS.map(function(c){
              var v=_pautVal(d,c);
              var der=PAUT_NUM[c]?'text-align:right;':'';
              var col='';
              if(c==='saldo' && (Number(String(v).replace(/[^0-9.\-]/g,''))||0)<0)
                col='color:#b00020;';
              if(PAUT_NUM[c] && c!=='pedido' && v!=='')
                v=_fmtN2(Number(String(v).replace(/[^0-9.\-]/g,''))||0);
              return '<td style="'+td+';'+fondo+der+col+'">'+_esc(String(v))+'</td>';
            }).join('')
          +'</tr>';
      }).join('')
    +'<tr><td style="'+td+';background:#dce6f1;font-weight:700">'
    +filas.length+' pedido(s)</td>'
    + PAUT_COLS.slice(1).map(function(c){
        var v='';
        if(c==='total') v=_fmtN2(tot);
        if(c==='ganancia') v=_fmtN2(gan);
        return '<td style="'+td+';background:#dce6f1;font-weight:700;'
          +(PAUT_NUM[c]?'text-align:right;':'')+'">'+v+'</td>';
      }).join('')
    +'</tr></table></div>';
}

// El pedido por dentro: todo lo que trae la consulta, sin recortar
/* ═══════════════════════════════════════════════════════════════════════════
   PEDIDOS AUTORIZADOS DEL DÍA   (prefijo [PD] · v743 · solo gerencia general)
   ───────────────────────────────────────────────────────────────────────────
   Los pedidos que se autorizaron en la fecha o el rango elegido (por defecto
   hoy). Sale de pedidos_autorizados, la tabla que el worker llena cada día
   con el mismo SQL del correo de las cinco (y que guarda los días
   anteriores). Al abrir un pedido: sus productos (tabla pedidos), con precio
   de venta, costo y % de ganancia de cada uno, el margen del pedido y la
   disponibilidad actual de cada producto (tabla inventario), marcando lo
   agotado y lo que tiene pocas unidades. Y una vista de TODOS los productos
   del período, sumados, para decidir qué volver a pedir.
   Costo = costo promedio de SAP (AvgPrice); si no lo hay, el CIF o el último
   precio de compra. Margen = ganancia / venta.
   ═══════════════════════════════════════════════════════════════════════════ */

function _pdNum(v){ return Number(String(v==null?'':v).replace(/[^0-9.\-]/g,''))||0; }
function _pdCosto(inv){
  if(!inv) return null;
  var c=_pdNum(inv.avgprice);
  if(!(c>0)) c=_pdNum(inv.cif);
  if(!(c>0)) c=_pdNum(inv.lastpurprc);
  return c>0 ? c : null;
}
function _pdDisp(inv){
  if(!inv) return null;
  if(inv.disponible!=null && inv.disponible!=='') return _pdNum(inv.disponible);
  return _pdNum(inv.onhand)-_pdNum(inv.iscommited);
}
// Agotado · pocas (no alcanza para otro pedido igual) · bien
function _pdEstado(disp, vendido){
  if(disp==null) return {t:'sin dato', c:'var(--text-muted)', bg:'var(--surface-1)', n:3};
  if(disp<=0) return {t:'AGOTADO', c:'#fff', bg:'#dc2626', n:0};
  if(disp<vendido) return {t:'POCAS', c:'#fff', bg:'#B45309', n:1};
  return {t:'Disponible', c:'#166534', bg:'var(--pastel-ok)', n:2};
}
function _pdFecha(d){ return _fechaCorta ? _fechaCorta(d) : d; }

// ── Ordenar columnas (v744): clic en el título ordena; otro clic invierte ──
function _pdOrdenar(tabla, col){
  var S=window._pd; S.ord=S.ord||{};
  var o=S.ord[tabla]||{};
  S.ord[tabla]={col:col, dir:(o.col===col && o.dir==='desc')?'asc':'desc'};
  if(tabla==='det') _pdPintarDetalle();
  else if(tabla==='lista') _pdCargar(true);      // la lista se ordena en Supabase: vale para todos, no solo los cargados
  else _pdPintar();
}
function _pdTh(tabla, col, txt, der, estilo){
  var o=((window._pd||{}).ord||{})[tabla]||{};
  var flecha=o.col===col?(o.dir==='asc'?' ▲':' ▼'):'';
  return '<th onclick="_pdOrdenar(\''+tabla+'\',\''+col+'\')" title="Ordenar" style="'+estilo+';cursor:pointer;user-select:none'
    +(der?';text-align:right':';text-align:left')+'">'+txt+flecha+'</th>';
}
function _pdAplicarOrden(lista, tabla, valor){
  var o=((window._pd||{}).ord||{})[tabla];
  if(!o || !o.col) return lista;
  var s=o.dir==='asc'?1:-1;
  return lista.slice().sort(function(a,b){
    var x=valor(a,o.col), y=valor(b,o.col);
    if(x==null && y==null) return 0; if(x==null) return 1; if(y==null) return -1;
    if(typeof x==='number' && typeof y==='number') return (x-y)*s;
    return String(x).localeCompare(String(y),'es',{numeric:true})*s;
  });
}

// ── Foto en grande, ficha del artículo y reponer (por encima de la ventana del pedido) ──
function _pdEncima(){
  setTimeout(function(){
    var fijos=[].slice.call(document.body.children).filter(function(e){
      return e.id!=='pdOv' && getComputedStyle(e).position==='fixed' && e.offsetParent!==undefined; });
    var ult=fijos[fijos.length-1]; if(ult) ult.style.zIndex='10095';
    var m=document.getElementById('modal'); if(m && m.style.display!=='none') m.style.zIndex='10095';
  }, 60);
}
function _pdZoom(url, cod){ _repZoomFoto(encodeURIComponent(url), cod); _pdEncima(); }
async function _pdFicha(cod){ await _invFicha(cod); _pdEncima(); }
function _pdReponer(cod, prov){
  cod=String(cod||'').trim().toUpperCase(); prov=String(prov||'').trim();
  if(!prov){ showT('Ese artículo no tiene proveedor en SAP'); return; }
  var ov=document.getElementById('pdOv'); if(ov) ov.remove();
  window._topRows=null;
  window._repFiltroItem=cod;          // el artículo filtrado al llegar
  go('reposiciones');
  var n=0;
  (function esperar(){
    if(document.getElementById('rep-code')){ try{ _repProvElegido(prov); }catch(e){ showT('No se pudo abrir el proveedor'); } return; }
    if(++n<40) setTimeout(esperar, 150); else showT('No se pudo abrir Reposiciones');
  })();
}
function _pdCeldaFoto(x, td){
  var foto=x&&x.picturname?_repFotoUrl(x.picturname):'';
  return '<td style="'+td+'">'+(foto?('<img src="'+foto+'" loading="lazy" title="Ver en grande" '
    +'onclick="event.stopPropagation();_pdZoom(\''+_esc(foto)+'\',\''+_esc(String(x.itemcode||''))+'\')" '
    +'style="width:34px;height:34px;object-fit:cover;border-radius:5px;cursor:zoom-in" onerror="this.style.display=\'none\'">'):'')+'</td>';
}
function _pdCeldaSku(cod, td){
  return '<td style="'+td+'"><a href="javascript:void(0)" title="Ver la ficha del artículo" '
    +'onclick="event.stopPropagation();_pdFicha(\''+_esc(String(cod))+'\')" '
    +'style="font-weight:700;color:var(--t-azul);text-decoration:underline">'+_esc(cod)+'</a></td>';
}
function _pdCeldaReponer(cod, x, td){
  var prov=x&&x.cardcode?String(x.cardcode):'';
  return '<td style="'+td+'">'+(prov
    ? ('<button class="btn bg2" style="padding:3px 9px;font-size:10.5px;font-weight:700;white-space:nowrap" '
       +'title="Reposición de este artículo con '+_esc(x.nombre_proveedor||prov)+'" '
       +'onclick="event.stopPropagation();_pdReponer(\''+_esc(String(cod))+'\',\''+_esc(prov)+'\')">'
       +'<i class="ti ti-package"></i> Reponer</button>')
    : '<span style="font-size:10px;color:var(--text-muted)" title="Sin proveedor en SAP">—</span>')+'</td>';
}





/* ═══ PEDIDOS (v746) ════════════════════════════════════════════════════════
   Antes «Pedidos autorizados del día». Ahora TODOS los pedidos de venta, del
   más nuevo al más viejo, con filtro Autorizados / Sin autorizar, buscador
   (número, cliente, vendedor, marca), fechas opcionales, columnas
   ordenables y scroll infinito (se cargan de 100 en 100 al bajar). Lee la
   vista pedidos_cab (una fila por pedido, sale de la tabla pedidos que
   sincroniza el worker: v746_pedidos.sql). Al abrir uno: productos, precio,
   costo, % de ganancia, margen y disponibilidad, como antes. */
var PD_POR_PAGINA = 100;
var PD_COL_SQL = {fecha:'docdate', pedido:'docnum', cliente:'cardname', vendedor:'vendedor', marca:'marca_cliente',
                  total:'doctotal', estado:'confirmed', lineas:'lineas', piezas:'piezas'};

async function rPautDia(){
  var pg=document.getElementById('page-pautdia'); if(!pg) return;
  if(!_pautPuede()){ pg.innerHTML='<div class="empty">Esta pantalla es de la gerencia general.</div>'; return; }
  var S=window._pd=window._pd||{q:'', filtro:'todos', desde:'', hasta:'', vista:'pedidos'};
  S.ord=S.ord||{}; S.ord.lista=S.ord.lista||{col:'fecha', dir:'desc'};
  await _pdCargar(true);
}

function _pdUrl(offset){
  var S=window._pd, o=S.ord.lista||{col:'fecha',dir:'desc'};
  var u=SB+'/rest/v1/pedidos_cab?select=*&order='+(PD_COL_SQL[o.col]||'docdate')+'.'+(o.dir==='asc'?'asc':'desc')+'.nullslast,docnum.desc'
    +'&offset='+offset+'&limit='+PD_POR_PAGINA;
  if(S.filtro==='aut') u+='&confirmed=eq.Y';
  else if(S.filtro==='sin') u+='&confirmed=neq.Y';
  if(S.desde) u+='&docdate=gte.'+S.desde;
  if(S.hasta) u+='&docdate=lte.'+S.hasta+'T23:59:59';
  var q=String(S.q||'').trim().replace(/[(),*]/g,' ').trim();
  if(q){
    var t=encodeURIComponent('*'+q+'*');
    var ors=['cardname.ilike.'+t,'vendedor.ilike.'+t,'marca_cliente.ilike.'+t,'cardcode.ilike.'+t];
    if(/^\d+$/.test(q)) ors.unshift('docnum.eq.'+q);
    u+='&or=('+ors.join(',')+')';
  }
  return u;
}

// reiniciar = true: desde el principio (otro filtro, búsqueda u orden)
async function _pdCargar(reiniciar){
  var S=window._pd; if(!S) return;
  if(S.desde && S.hasta && S.desde>S.hasta){ var t=S.desde; S.desde=S.hasta; S.hasta=t; }
  if(reiniciar){ S.filas=[]; S.fin=false; S.total=null; S.prods=null; S.error=''; S.gen=(S.gen||0)+1; }
  if(S.cargando || S.fin) { if(reiniciar) _pdPintar(); return; }
  var gen=S.gen;
  S.cargando=true; _pdPintar();
  try{
    var r=await fetch(_pdUrl(S.filas.length),{headers:Object.assign({},SBH,{'Prefer':'count=exact'})});
    if(!r.ok){
      var t=await r.text();
      throw new Error(/pedidos_cab/.test(t)&&/exist|find/i.test(t) ? 'falta correr v746_pedidos.sql en Supabase (proyecto de compras)' : ('pedidos: '+r.status));
    }
    var lote=(await r.json())||[];
    if(gen!==S.gen){ S.cargando=false; return; }       // llegó tarde: ya se pidió otra cosa
    var cr=r.headers.get('content-range')||''; var m=cr.match(/\/(\d+)/); if(m) S.total=Number(m[1]);
    S.filas=S.filas.concat(lote);
    if(lote.length<PD_POR_PAGINA) S.fin=true;
  }catch(e){ S.error=String(e.message||e); S.fin=true; }
  S.cargando=false; _pdPintar();
}

function _pdMasSiHaceFalta(el){
  var S=window._pd; if(!S || S.cargando || S.fin) return;
  if(el.scrollTop+el.clientHeight >= el.scrollHeight-300) _pdCargar(false);
}
function _pdBuscar(v){
  var S=window._pd; S.q=v;
  clearTimeout(S._tq); S._tq=setTimeout(function(){ _pdCargar(true); }, 400);
}
function _pdFiltro(f){ window._pd.filtro=f; window._pd.vista='pedidos'; _pdCargar(true); }

function _pdEstadoPedido(c){
  var aut=String(c.confirmed||'').toUpperCase()==='Y', cerr=String(c.docstatus||'').toUpperCase()==='C';
  return (aut?'<span style="font-size:10px;font-weight:800;padding:2px 8px;border-radius:6px;background:var(--pastel-ok);color:#166534">Autorizado</span>'
             :'<span style="font-size:10px;font-weight:800;padding:2px 8px;border-radius:6px;background:var(--pastel-aviso);color:#B45309">Sin autorizar</span>')
    +(cerr?' <span style="font-size:10px;padding:2px 6px;border-radius:6px;background:var(--surface-1);color:var(--text-muted)">cerrado</span>':'');
}

function _pdPintar(){
  var pg=document.getElementById('page-pautdia'); if(!pg) return;
  var S=window._pd||{}, F=S.filas||[];
  var caja=document.getElementById('pdScroll'), yy=caja?caja.scrollTop:0;
  var est='padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)';
  var chip=function(k,t){ return '<button class="'+(S.filtro===k?'btn bp':'xb')+'" onclick="_pdFiltro(\''+k+'\')">'+t+'</button>'; };
  var h='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:10px">'
    +'<div style="flex:1;min-width:200px"><div style="font-size:16px;font-weight:700"><i class="ti ti-file-invoice" style="color:var(--t-verde)"></i> Pedidos</div>'
    +'<div style="font-size:11px;color:var(--text-muted)">Del más nuevo al más viejo'+(S.total!=null?(' · <b>'+S.total.toLocaleString('es')+'</b> pedido(s)'+(F.length<S.total?(' · '+F.length+' cargados, baja para ver más'):'')):'')+'</div></div>'
    + chip('todos','Todos') + chip('aut','Autorizados') + chip('sin','Sin autorizar')
    +'<input id="pdQ" value="'+_esc(S.q||'')+'" placeholder="Buscar pedido, cliente, vendedor, marca…" oninput="_pdBuscar(this.value)" style="'+est+';min-width:240px">'
    +'<input type="date" title="Desde" value="'+_esc(S.desde||'')+'" onchange="window._pd.desde=this.value;_pdCargar(true)" style="'+est+'">'
    +'<input type="date" title="Hasta" value="'+_esc(S.hasta||'')+'" onchange="window._pd.hasta=this.value;_pdCargar(true)" style="'+est+'">'
    +((S.desde||S.hasta)?'<button class="xb" onclick="window._pd.desde=\'\';window._pd.hasta=\'\';_pdCargar(true)">Quitar fechas</button>':'')
    +'</div>';
  if(S.error) h+='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'+_esc(S.error)+'</div>';
  h+='<div style="display:flex;gap:6px;margin-bottom:8px">'
    +'<button class="'+(S.vista!=='productos'?'btn bp':'xb')+'" onclick="window._pd.vista=\'pedidos\';_pdPintar()"><i class="ti ti-list"></i> Pedidos</button>'
    +'<button class="'+(S.vista==='productos'?'btn bp':'xb')+'" onclick="_pdVerProductos()"><i class="ti ti-package"></i> Productos de estos pedidos · qué reponer</button></div>';
  if(S.vista==='productos'){ h+=_pdProductosHtml(); pg.innerHTML=h; return; }
  var th='padding:8px 10px;font-size:10.5px;font-weight:700;color:#fff;background:#166534;position:sticky;top:0;white-space:nowrap;z-index:1';
  h+='<div id="pdScroll" onscroll="_pdMasSiHaceFalta(this)" style="border:0.5px solid var(--border);border-radius:12px;overflow:auto;max-height:66vh;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr>'
    +[['fecha','Fecha'],['pedido','Pedido'],['cliente','Cliente'],['vendedor','Vendedor'],['marca','Marca'],
      ['total','Total',1],['lineas','Líneas',1],['piezas','Piezas',1],['estado','Estado']].map(function(c){ return _pdTh('lista', c[0], c[1], c[2], th); }).join('')
    +'</tr></thead><tbody>'
    + F.map(function(c,i){
        var td='padding:8px 10px;border-bottom:0.5px solid var(--border);white-space:nowrap';
        return '<tr style="cursor:pointer;'+((i%2)?'background:var(--bg-accent)':'')+'" onclick="_pdAbrir('+i+')" title="Abrir el pedido">'
          +'<td style="'+td+';color:var(--text-muted)">'+_esc(_pdFecha(String(c.docdate||'').slice(0,10)))+'</td>'
          +'<td style="'+td+'"><b style="color:var(--t-azul)">'+_esc(String(c.docnum))+'</b></td>'
          +'<td style="'+td+';white-space:normal;min-width:180px">'+_esc(c.cardname||'')+'</td>'
          +'<td style="'+td+'">'+_esc(c.vendedor||'')+'</td>'
          +'<td style="'+td+';font-size:11px">'+_esc(c.marca_cliente||'')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700">'+fmt(_pdNum(c.doctotal))+'</td>'
          +'<td style="'+td+';text-align:right">'+_esc(String(c.lineas||''))+'</td>'
          +'<td style="'+td+';text-align:right">'+_fmtN2(_pdNum(c.piezas)).replace(/,00$/,'')+'</td>'
          +'<td style="'+td+'">'+_pdEstadoPedido(c)+'</td></tr>';
      }).join('')
    +'</tbody></table>'
    +(S.cargando?'<div style="padding:14px;text-align:center"><span class="ai-ring g"></span> Cargando…</div>'
      :(S.fin?(F.length?'<div style="padding:10px;text-align:center;font-size:11px;color:var(--text-muted)">No hay más pedidos</div>'
                       :'<div class="empty" style="padding:26px">No hay pedidos con esos filtros.</div>')
             :'<div style="padding:10px;text-align:center"><button class="xb" onclick="_pdCargar(false)">Cargar más</button></div>'))
    +'</div>';
  pg.innerHTML=h;
  var c2=document.getElementById('pdScroll'); if(c2 && yy) c2.scrollTop=yy;
  var qi=document.getElementById('pdQ'); if(qi && S.q && document.activeElement!==qi && S._focoQ){ qi.focus(); }
}

// Las líneas de varios pedidos y el inventario de sus artículos
async function _pdLineas(docnums){
  var out=[];
  for(var i=0;i<docnums.length;i+=40){
    var r=await fetch(SB+'/rest/v1/pedidos?select=docnum,linenum,itemcode,dscription,quantity,price,linetotal,currency,unitmsr'
      +'&docnum=in.('+docnums.slice(i,i+40).map(encodeURIComponent).join(',')+')&order=docnum,linenum&limit=10000',{headers:SBH});
    if(!r.ok) throw new Error('pedidos: '+r.status);
    out=out.concat((await r.json())||[]);
  }
  return out;
}
async function _pdInventario(codigos){
  var inv={};
  var u=[...new Set(codigos.filter(Boolean))];
  for(var i=0;i<u.length;i+=100){
    var r=await fetch(SB+'/rest/v1/inventario?select=*&itemcode=in.('+u.slice(i,i+100).map(function(c){
        return encodeURIComponent('"'+String(c).replace(/"/g,'')+'"'); }).join(',')+')&limit=1000',{headers:SBH});
    if(!r.ok) throw new Error('inventario: '+r.status);
    ((await r.json())||[]).forEach(function(x){ inv[String(x.itemcode).toUpperCase()]=x; });
  }
  return inv;
}

async function _pdAbrir(i){
  var c0=(window._pd.filas||[])[i]; if(!c0) return;
  var d={pedido:c0.docnum, cliente:c0.cardname||'', vendedor:c0.vendedor||'', marca:c0.marca_cliente||'',
         total:c0.doctotal, _dia:String(c0.docdate||'').slice(0,10),
         'condicion de pago': String(c0.confirmed||'').toUpperCase()==='Y'?'autorizado':'sin autorizar'};
  var num=String(c0.docnum||'').replace(/[^0-9]/g,'');
  var ov=document.createElement('div'); ov.id='pdOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10070;display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow:auto';
  ov.onclick=function(e){ if(e.target===ov) ov.remove(); };
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:1180px;width:100%;padding:16px 18px">'
    +'<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-file-check" style="font-size:22px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">Pedido '+_esc(num)+' · '+_esc(String(_pautVal(d,'cliente')))+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Del '+_esc(_pdFecha(d._dia))+' · vendedor '+_esc(String(_pautVal(d,'vendedor')))
    +' · '+_esc(String(_pautVal(d,'condicion de pago')||''))+'</div></div>'
    +'<button class="xb" onclick="document.getElementById(\'pdOv\').remove()"><i class="ti ti-x"></i></button></div>'
    +'<div id="pdCuerpo"><span class="ai-ring g"></span> Cargando los productos y la disponibilidad…</div></div>';
  document.body.appendChild(ov);
  var c=document.getElementById('pdCuerpo');
  try{
    if(!num) throw new Error('el pedido no tiene número');
    var L=(await _pdLineas([num])).filter(function(l){ return String(l.docnum)===String(num); });
    if(!L.length){ c.innerHTML='<div class="nota">No encontré las líneas del pedido '+_esc(num)+' en el portal. '
      +'Si es muy reciente, espera al siguiente ciclo del worker o pulsa Sync.</div>'; return; }
    var inv=await _pdInventario(L.map(function(l){ return l.itemcode; }));
    window._pdDet={L:L, inv:inv, d:d};
    c.innerHTML=_pdTablaPedido(L, inv, d);
  }catch(e){ c.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'+_esc(e.message||String(e))+'</div>'; }
}

function _pdPintarDetalle(){
  var D=window._pdDet, c=document.getElementById('pdCuerpo');
  if(D && c) c.innerHTML=_pdTablaPedido(D.L, D.inv, D.d);
}
function _pdTablaPedido(L, inv, d){
  var tv=0, tc=0, sinCosto=0, filas=[], agot=0, pocas=0;
  L.forEach(function(l){
    var x=inv[String(l.itemcode).toUpperCase()];
    var q=_pdNum(l.quantity), p=_pdNum(l.price), v=_pdNum(l.linetotal)||q*p;
    var c=_pdCosto(x), disp=_pdDisp(x), e=_pdEstado(disp, q);
    if(e.n===0) agot++; else if(e.n===1) pocas++;
    tv+=v; if(c!=null) tc+=c*q; else sinCosto++;
    filas.push({l:l, x:x, q:q, p:p, v:v, c:c, disp:disp, e:e,
                pct:(c!=null && p>0)?((p-c)/p*100):null});
  });
  var gan=tv-tc, mg=tv?(gan/tv*100):0;
  var th='padding:7px 8px;font-size:10px;font-weight:700;color:#fff;background:#0c447c;position:sticky;top:0;white-space:nowrap';
  var h='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:8px;margin-bottom:10px">'
    +[['VENTA',fmt(tv),'var(--t-azul)','var(--pastel-azul)'],['COSTO',fmt(tc)+(sinCosto?' *':''),'var(--text-primary)','var(--surface-1)'],
      ['GANANCIA',fmt(gan),'#166534','var(--pastel-ok)'],['MARGEN DEL PEDIDO',mg.toFixed(1)+' %','#6D28D9','var(--pastel-lila)'],
      ['AGOTADOS',agot,'#fff','#dc2626'],['POCAS UNIDADES',pocas,'#fff','#B45309']].map(function(k){
        return '<div style="background:'+k[3]+';color:'+k[2]+';border-radius:10px;padding:9px 12px"><div style="font-size:10px;font-weight:700;opacity:.9">'+k[0]
          +'</div><div style="font-size:18px;font-weight:800">'+k[1]+'</div></div>'; }).join('')
    +'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:6px">'
    +(d.ganancia!=null&&d.ganancia!==''?('SAP da para este pedido: ganancia '+fmt(_pdNum(_pautVal(d,'ganancia')))
      +' · '+_pdNum(_pautVal(d,'porcentaje')).toFixed(1)+' %. '):'')+'El costo es el costo promedio actual de cada artículo'
    +(sinCosto?(' · * '+sinCosto+' línea(s) sin costo en SAP, no entran en la ganancia'):'')+'.</div>'
    +'<div class="ia-informe" data-imp-titulo="Pedido autorizado '+_esc(String(_pautVal(d,'pedido')))+'" style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;max-height:60vh">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr>'
    +'<th style="'+th+'"></th>'
    +[['itemcode','Artículo'],['desc','Descripción'],['q','Cantidad',1],['p','Precio venta',1],['c','Costo',1],
      ['pct','% Ganancia',1],['v','Total venta',1],['disp','Disponible',1],['llega','Por llegar',1],['estado','Estado']].map(function(c){
        return _pdTh('det', c[0], c[1], c[2], th); }).join('')
    +'<th style="'+th+'"></th></tr></thead><tbody>'
    + _pdAplicarOrden(filas.sort(function(a,b){ return a.e.n-b.e.n || b.v-a.v; }), 'det', function(f,c){
        if(c==='itemcode') return f.l.itemcode; if(c==='desc') return f.l.dscription||'';
        if(c==='estado') return f.e.n; if(c==='llega') return f.x?_pdNum(f.x.onorder):null;
        return f[c];
      }).map(function(f,i){
        var td='padding:6px 8px;border-bottom:0.5px solid var(--border);white-space:nowrap';
        var llega=f.x?(_pdNum(f.x.onorder)?(_fmtN2(_pdNum(f.x.onorder)).replace(/,00$/,'')+(f.x.prox_llegada?(' · '+_pdFecha(f.x.prox_llegada)):'')):'—'):'—';
        return '<tr style="'+((i%2)?'background:var(--bg-accent)':'')+'">'
          + _pdCeldaFoto(f.x||{itemcode:f.l.itemcode}, td)
          + _pdCeldaSku(f.l.itemcode, td)
          +'<td style="'+td+';white-space:normal;min-width:200px;font-size:11.5px">'+_esc(f.l.dscription||(f.x&&f.x.itemname)||'')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700">'+_fmtN2(f.q).replace(/,00$/,'')+'</td>'
          +'<td style="'+td+';text-align:right">'+fmt(f.p)+'</td>'
          +'<td style="'+td+';text-align:right;color:var(--text-secondary)">'+(f.c!=null?fmt(f.c):'—')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700;color:'+(f.pct==null?'var(--text-muted)':(f.pct<15?'#dc2626':(f.pct<25?'#B45309':'#166534')))+'">'
            +(f.pct==null?'—':(f.pct.toFixed(1)+' %'))+'</td>'
          +'<td style="'+td+';text-align:right">'+fmt(f.v)+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700;'+(f.disp!=null&&f.disp<=0?'color:#dc2626':'')+'">'+(f.disp==null?'—':_fmtN2(f.disp).replace(/,00$/,''))+'</td>'
          +'<td style="'+td+';text-align:right;font-size:11px">'+llega+'</td>'
          +'<td style="'+td+'"><span style="font-size:10px;font-weight:800;padding:2px 8px;border-radius:6px;color:'+f.e.c+';background:'+f.e.bg+'">'+f.e.t+'</span></td>'
          + _pdCeldaReponer(f.l.itemcode, f.x, td)+'</tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">Clic en un título para ordenar · en la foto para verla en grande · en el código para la ficha. Disponible = en bodega menos lo comprometido en pedidos. '
    +'<b>AGOTADO</b>: no queda nada libre. <b>POCAS</b>: lo que queda no alcanza para otro pedido igual a este. Por llegar = en órdenes de compra abiertas, con la próxima fecha.</div>';
  return h;
}

// Todos los productos del período, sumados: qué se vende y qué hay que reponer
async function _pdVerProductos(){
  var S=window._pd; S.vista='productos';
  if(S.prods){ _pdPintar(); return; }
  S.prodsCargando=true; _pdPintar();
  try{
    var nums=[...new Set((S.filas||[]).map(function(c){ return String(c.docnum||'').replace(/[^0-9]/g,''); }).filter(Boolean))];
    var L=nums.length?await _pdLineas(nums):[];
    var inv=await _pdInventario(L.map(function(l){ return l.itemcode; }));
    var por={};
    L.forEach(function(l){
      var k=String(l.itemcode).toUpperCase();
      var a=por[k]||(por[k]={itemcode:l.itemcode, desc:l.dscription, q:0, v:0, pedidos:{}});
      a.q+=_pdNum(l.quantity); a.v+=_pdNum(l.linetotal)||_pdNum(l.quantity)*_pdNum(l.price); a.pedidos[l.docnum]=1;
    });
    S.prods=Object.keys(por).map(function(k){
      var a=por[k], x=inv[k], c=_pdCosto(x), disp=_pdDisp(x);
      a.x=x; a.c=c; a.disp=disp; a.e=_pdEstado(disp, a.q); a.np=Object.keys(a.pedidos).length;
      a.pct=(c!=null && a.v>0)?((a.v-c*a.q)/a.v*100):null;
      return a;
    }).sort(function(a,b){ return a.e.n-b.e.n || b.q-a.q; });
    S.sinLineas=nums.length && !L.length;
  }catch(e){ S.prodsError=String(e.message||e); S.prods=[]; }
  S.prodsCargando=false; _pdPintar();
}

function _pdProductosHtml(){
  var S=window._pd;
  if(S.prodsCargando) return '<div class="empty"><span class="ai-ring g"></span> Sumando los productos de '+(S.filas||[]).length+' pedido(s)…</div>';
  var aviso='<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">De los '+(S.filas||[]).length+' pedido(s) cargados con los filtros de arriba'
    +((S.total!=null && (S.filas||[]).length<S.total)?(' (hay '+S.total+'; baja en la lista para cargar más, o filtra por fechas)'):'')+'.</div>';
  if(S.prodsError) return '<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'+_esc(S.prodsError)+'</div>';
  var P=S.prods||[];
  if(!P.length) return '<div class="empty">'+(S.sinLineas?'No encontré las líneas de esos pedidos en el portal.':'No hay productos en esas fechas.')+'</div>';
  var ag=P.filter(function(a){ return a.e.n===0; }).length, po=P.filter(function(a){ return a.e.n===1; }).length;
  var th='padding:7px 8px;font-size:10px;font-weight:700;color:#fff;background:#0c447c;position:sticky;top:0;white-space:nowrap';
  return aviso+'<div style="font-size:12px;margin-bottom:6px"><b>'+P.length+'</b> producto(s) vendidos · '
    +'<span style="color:#dc2626;font-weight:700">'+ag+' agotado(s)</span> · <span style="color:#B45309;font-weight:700">'+po+' con pocas unidades</span>'
    +' · primero lo que hay que reponer, después lo más vendido.</div>'
    +'<div class="ia-informe" data-imp-titulo="Productos vendidos y qué reponer" style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;max-height:62vh;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr>'
    +'<th style="'+th+'"></th>'
    +[['itemcode','Artículo'],['desc','Descripción'],['q','Vendido',1],['np','En pedidos',1],['v','Venta',1],['c','Costo',1],
      ['pct','% Ganancia',1],['disp','Disponible',1],['llega','Por llegar',1],['estado','Estado']].map(function(c){
        return _pdTh('prods', c[0], c[1], c[2], th); }).join('')
    +'<th style="'+th+'"></th></tr></thead><tbody>'
    + _pdAplicarOrden(P, 'prods', function(a,c){
        if(c==='estado') return a.e.n; if(c==='llega') return a.x?_pdNum(a.x.onorder):null;
        return a[c];
      }).map(function(a,i){
        var td='padding:6px 8px;border-bottom:0.5px solid var(--border);white-space:nowrap';
        var llega=a.x?(_pdNum(a.x.onorder)?(_fmtN2(_pdNum(a.x.onorder)).replace(/,00$/,'')+(a.x.prox_llegada?(' · '+_pdFecha(a.x.prox_llegada)):'')):'—'):'—';
        return '<tr style="'+((i%2)?'background:var(--bg-accent)':'')+'">'
          + _pdCeldaFoto(a.x||{itemcode:a.itemcode}, td)
          + _pdCeldaSku(a.itemcode, td)
          +'<td style="'+td+';white-space:normal;min-width:200px;font-size:11.5px">'+_esc(a.desc||(a.x&&a.x.itemname)||'')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700">'+_fmtN2(a.q).replace(/,00$/,'')+'</td>'
          +'<td style="'+td+';text-align:right">'+a.np+'</td>'
          +'<td style="'+td+';text-align:right">'+fmt(a.v)+'</td>'
          +'<td style="'+td+';text-align:right;color:var(--text-secondary)">'+(a.c!=null?fmt(a.c):'—')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700;color:'+(a.pct==null?'var(--text-muted)':(a.pct<15?'#dc2626':(a.pct<25?'#B45309':'#166534')))+'">'+(a.pct==null?'—':(a.pct.toFixed(1)+' %'))+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700;'+(a.disp!=null&&a.disp<=0?'color:#dc2626':'')+'">'+(a.disp==null?'—':_fmtN2(a.disp).replace(/,00$/,''))+'</td>'
          +'<td style="'+td+';text-align:right;font-size:11px">'+llega+'</td>'
          +'<td style="'+td+'"><span style="font-size:10px;font-weight:800;padding:2px 8px;border-radius:6px;color:'+a.e.c+';background:'+a.e.bg+'">'+a.e.t+'</span></td>'
          + _pdCeldaReponer(a.itemcode, a.x, td)+'</tr>';
      }).join('')
    +'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">Clic en un título para ordenar · en la foto para verla en grande · en el código para la ficha · <b>Reponer</b> abre la reposición del artículo con su proveedor. '
    +'<b>POCAS</b>: lo disponible no alcanza para volver a vender lo que se vendió en el período.</div>';
}

function _pautVer(i){
  var d=(window._paut||[])[i];
  if(!d) return;
  // El pedido se abre con la misma ventana que el resto del portal: sus
  // líneas, fotos, cantidades y totales.
  var num=String(_pautVal(d,'pedido')||'').replace(/[^0-9]/g,'');
  if(num){ abrirPedidoVenta(num); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10076;'
    +'display:flex;align-items:center;justify-content:center;padding:20px';
  ov.onclick=function(e){ if(e.target===ov) ov.remove(); };
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:620px;max-height:86vh;overflow:auto;'
    +'box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-file-check" style="font-size:20px;color:var(--t-verde)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">Pedido '
    +_esc(String(_pautVal(d,'pedido')))+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +_esc(String(_pautVal(d,'cliente')))+' · '+_esc(String(_pautVal(d,'vendedor')))+'</div>'
    +'</div><button class="xb" onclick="this.closest(\'div\').parentNode.parentNode.remove()">'
    +'<i class="ti ti-x"></i></button></div>'
    +'<table class="tbx" style="width:100%">'
    + Object.keys(d).map(function(k){
        return '<tr><td style="color:var(--text-muted);font-size:11.5px;width:45%">'
          +_esc(k)+'</td><td style="font-size:12px;font-weight:600">'
          +_esc(String(d[k]==null?'':d[k]))+'</td></tr>';
      }).join('')
    +'</table></div>';
  document.body.appendChild(ov);
}

// Los vendedores que reciben el informe de mercancía recién llegada
var EN_VENDEDORES=[
  {slpname:'Tamara',          email:'tamara@kennedyzl.com'},
  {slpname:'Alicia',          email:'alicia@kennedyzl.com'},
  {slpname:'Leo',             email:'leo@kennedyzl.com'},
  {slpname:'Gady',            email:'gady@kennedyzl.com'},
  {slpname:'Henry',           email:'henry@kennedyzl.com'},
  {slpname:'Liran Shimon',    email:'liran@kennedyzl.com'},
  {slpname:'Max',             email:'max@kennedyzl.com'},
  {slpname:'Guidi Shabot',    email:'guidi@kennedyzl.com'},
  {slpname:'Lorena',          email:'lorena@kennedyzl.com'},
  {slpname:'Eli',             email:'eli@kennedyzl.com'},
  {slpname:'Sherene',         email:'sherene@kennedyzl.com'},
  {slpname:'Ariel Shacalo',   email:'shacalo@kennedyzl.com'},
  {slpname:'Compras Hogar',   email:'compras3@kennedyzl.com'},
  {slpname:'Dan Benzaquen',   email:'dan@kennedyzl.com'},
  {slpname:'Edgar Btesh',     email:'edgar@kennedyzl.com'},
  {slpname:'Sharon Shatah',   email:'sharon@kennedyzl.com'},
  {slpname:'Irianys Guevara', email:'irianys@kennedyzl.com'},
  // Gerencia: también reciben el informe de lo que acaba de llegar
  {slpname:'Jimmy Guindi',    email:'jimmys@kennedyzl.com'},
  {slpname:'Samuel Guindi',   email:'samy@kennedyzl.com'},
  {slpname:'Ariel Guindi',    email:'ariel@kennedyzl.com'},
  {slpname:'Edy Guindi',      email:'edy@kennedyzl.com'},
  {slpname:'Itay Guindi',     email:'itay@kennedyzl.com'},
  {slpname:'Eli Guindi',      email:'eli@kennedyzl.com'}
];

/* Diagnóstico de la mercancía separada: mira qué hay de verdad en la copia
   del portal para ese artículo, para no ir adivinando. */
async function _sepDiag(itemcode){
  var box=document.getElementById('sepDiag');
  if(!box) return;
  box.innerHTML='<span class="ai-ring g"></span> Mirando…';
  var code=String(itemcode||'').trim();
  var linea=function(t, v, ok){
    return '<div style="display:flex;gap:7px;align-items:flex-start;margin-bottom:3px">'
      +'<i class="ti '+(ok?'ti-circle-check':'ti-alert-circle')+'" style="color:'
      +(ok?'var(--t-verde)':'var(--t-marron)')+'"></i><div>'+t+': <b>'+v+'</b></div></div>';
  };
  // Devuelve el número o, si la consulta falla, el motivo: un «0» a secas
  // no distinguía entre «no hay datos» y «no puedo leer la tabla».
  var cuenta=async function(url){
    try{
      var r=await fetch(url+'&limit=1',{headers:Object.assign({},SBH,
        {'Prefer':'count=exact','Range':'0-0'})});
      if(!r.ok){
        var t=await r.text();
        return {err:r.status+' '+t.slice(0,90)};
      }
      var cr=r.headers.get('content-range')||'';
      var n=cr.split('/')[1];
      if(n!=null && n!=='*') return {n:Number(n)||0};
      var j=await r.json();
      return {n:Array.isArray(j)?j.length:0};
    }catch(e){ return {err:String(e.message||e)}; }
  };
  var pinta=function(t, r){
    if(r && r.err) return linea(t, 'ERROR · '+_esc(r.err), false);
    return linea(t, (r.n||0).toLocaleString('es'), (r.n||0)>0);
  };
  var total=await cuenta(SB+'/rest/v1/pedidos?select=docnum');
  var delItem=await cuenta(SB+'/rest/v1/pedidos?select=docnum&itemcode=like.'
    +encodeURIComponent(code+'*'));
  var abiertas=await cuenta(SB+'/rest/v1/pedidos?select=docnum&itemcode=like.'
    +encodeURIComponent(code+'*')+'&openqty=gt.0');
  var res=await cuenta(SB+'/rest/v1/reservas_venta?select=docnum&itemcode=like.'
    +encodeURIComponent(code+'*'));
  // Una muestra, para ver cómo viene escrito el código
  var muestra='';
  try{
    var rm=await fetch(SB+'/rest/v1/pedidos?select=itemcode,docnum,openqty,docstatus'
      +'&itemcode=like.'+encodeURIComponent(code.slice(0,6)+'*')+'&limit=3',{headers:SBH});
    var jm=rm.ok?(await rm.json()||[]):[];
    muestra=jm.map(function(x){
      return '«'+x.itemcode+'» pedido '+x.docnum+' · abierto '+(x.openqty==null?'—':x.openqty)
        +' · estado '+(x.docstatus||'—'); }).join('<br>');
  }catch(e){}

  box.innerHTML=
      pinta('Líneas de pedido en el portal', total)
    + pinta('De este artículo', delItem)
    + pinta('De este artículo con cantidad abierta', abiertas)
    + pinta('En facturas reserva de cliente', res)
    + (muestra?('<div style="margin-top:6px;font-size:10.5px;color:var(--text-muted)">'
        +'Códigos parecidos que sí están:<br>'+muestra+'</div>'):'')
    + '<div style="margin-top:6px;font-size:10.5px;color:var(--text-muted)">'
    + ((delItem && delItem.n===0 && total && total.n>0)
       ? 'El artículo no está en la copia del portal: el sync de pedidos no lo trajo. '
         +'Mándame esta pantalla y lo miro en el worker.'
       : '')
    + '</div>';
}

/* ── El circuito de los precios de venta ──────────────────────────────────
   importación genera el costeo y lo manda → gerencia ajusta los precios en
   el portal y los devuelve → importación revisa y los sube a SAP. Cada paso
   deja aviso dentro del portal, además del correo. */
/* Los artículos cuyo precio cambió, con el anterior y el nuevo. Lo saca de
   los valores guardados por gerencia y del costeo de base. */
function _pvCambiados(oid){
  var r=_pvDatos(oid);
  if(!r || !r.base || !Array.isArray(r.base.lineas)) return [];
  var val=(r.d && r.d.precios && r.d.precios.valores) || {};
  var out=[];
  r.base.lineas.forEach(function(l){
    var ref=String(l.referencia||'').trim();
    if(!ref || val[ref]==null) return;
    var nuevo=Number(val[ref])||0;
    var antes=Number(l.precio_venta)||0;
    if(!(nuevo>0) || Math.abs(nuevo-antes)<0.0001) return;
    out.push({referencia:ref, descripcion:l.descripcion||l.nombre||'',
              precio:nuevo, precio_anterior:antes,
              cif:Number(l.cif_unit)||0});
  });
  return out;
}

async function _pvEnviarAImportacion(oid){
  var r=_pvDatos(oid);
  var d=r.d||{};
  var editados=_pvCambiados(oid);
  if(!editados || !editados.length){
    showT('Primero abre los precios y guarda los cambios');
    return;
  }
  // A quién va: importación y quien haya trabajado el costeo
  var destinos=(typeof USERS!=='undefined'?USERS:[])
    .filter(function(u){ return u.role==='importacion' && u.email; })
    .map(function(u){ return u.email; });
  var extra=prompt('Enviar los precios ajustados a importación.\n\n'
    +'Van a: '+(destinos.join(', ')||'(nadie configurado)')
    +'\n\nAñade más correos separados por comas, o deja vacío:', '');
  if(extra===null) return;
  String(extra||'').split(/[,;]+/).forEach(function(e){
    e=e.trim(); if(e.indexOf('@')>0) destinos.push(e);
  });
  destinos=destinos.filter(function(e,i,a){ return a.indexOf(e)===i; });
  if(!destinos.length){ showT('No hay a quién enviarlo'); return; }

  var cuerpo='Precios de venta ajustados por gerencia · orden '+oid+'\n\n'
    + editados.slice(0,60).map(function(x){
        return '· '+x.referencia+'  '+(x.descripcion||'').slice(0,40)
          +'\n   antes '+_fmtN2(x.precio_anterior)+'   ahora '+_fmtN2(x.precio);
      }).join('\n')
    + (editados.length>60?('\n· … y '+(editados.length-60)+' más'):'')
    + '\n\n'+editados.length+' artículo(s) con precio nuevo.\n'
    + 'Revísalos en el portal y súbelos a SAP con «Confirmar y subir a SAP».\n\n'
    + '— '+((CU&&CU.name)||'');

  try{
    var res=await _postTolerante(SB+'/rest/v1/correos_queue', {
      docnum:String(oid), para_lista:destinos, para_email:destinos[0],
      asunto:'Precios de venta ajustados · orden '+oid,
      cuerpo:cuerpo, adjuntos:[],
      de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
      origen:'Precios ajustados por gerencia · '+oid, estado:'pendiente'
    });
    if(!res.ok) throw new Error(res.status+' '+(await res.text()).slice(0,140));
    _avisarPorCorreo(destinos, oid,
      'Gerencia ajustó '+editados.length+' precio(s) de venta · orden '+oid
      +' · revisa y sube a SAP', 'ti-tag');
    showT('✓ Enviado a importación · '+destinos.length+' destinatario(s)', 8000);
  }catch(e){
    showT(e&&e.cancelado ? 'Envío cancelado: no se mandó nada'
      : ('No se pudo enviar: '+(e.message||e)), 9000);
  }
}

// Importación confirma y los precios se escriben en SAP por DI API
async function _pvSubirASap(oid){
  var editados=_pvCambiados(oid);
  if(!editados || !editados.length){
    showT('No hay precios nuevos que subir');
    return;
  }
  var bajos=editados.filter(function(x){
    return Number(x.cif)>0 && Number(x.precio)>0 && Number(x.precio)<Number(x.cif); });
  if(bajos.length && !confirm(bajos.length+' artículo(s) quedarían por DEBAJO del costo '
    +'CIF.\n\n'+bajos.slice(0,6).map(function(x){
      return '· '+x.referencia+': '+_fmtN2(x.precio)+' (CIF '+_fmtN2(x.cif)+')'; }).join('\n')
    +'\n\n¿Los subo igual?')) return;
  if(!confirm('SUBIR A SAP LOS PRECIOS DE VENTA\n\n'+editados.length+' artículo(s)\n\n'
    + editados.slice(0,8).map(function(x){
        return '· '+x.referencia+': '+_fmtN2(x.precio_anterior)+' → '+_fmtN2(x.precio);
      }).join('\n')
    + (editados.length>8?('\n· … y '+(editados.length-8)+' más'):'')
    + '\n\nSe escriben en la lista de precio de venta por DI API. ¿Sigo?')) return;

  try{
    _frwAbrir();
    _frwPintarEspera('Subiendo '+editados.length+' precio(s) a SAP…',
      'El worker los escribe en la ficha de cada artículo.');
    var r=await _postTolerante(SB+'/rest/v1/precios_venta_queue', {
      items:editados.map(function(x){
        return {itemcode:x.referencia, precio:Number(x.precio)||0,
                cif:Number(x.cif)||0}; }),
      lista:3,
      origen:'costeo · orden '+oid, estado:'pendiente',
      creado_por:(CU&&CU.name)||''});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre precios_venta.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,150));
    }
    var reg=((await r.json())||[])[0];
    _pvMarcarEnSap(oid, editados.length);
    setTimeout(function(){
      if(confirm('Precios enviados a SAP · '+editados.length+' artículo(s)\n\n'
        +'Tardan unos minutos en quedar escritos, pero el informe se arma con '
        +'los que acabas de poner.\n\n¿Se lo mando ahora a los vendedores?'))
        _pvEnviarVendedores(oid);
    }, 1500);
    _cpSeguir(reg.id, Date.now());
  }catch(e){
    _frwCerrar();
    showT(e&&e.cancelado ? 'Envío cancelado: no se mandó nada'
      : ('No se pudo enviar: '+(e.message||e)), 9000);
  }
}

/* El margen de una línea, como en «Generar catálogo»: se escribe 50 y el
   precio se calcula desde el CIF. Las dos casillas se mantienen a la par. */
function _pvMargenLinea(i, valor){
  var inp=document.getElementById('pv-'+i);
  if(!inp) return;
  var cif=parseFloat(inp.getAttribute('data-cif'))||0;
  var txt=String(valor==null?'':valor).trim().replace(',','.');
  if(txt===''){ return; }
  // Se espera medio segundo a que termines de escribir: con cada tecla se
  // recalculaba y «50» pasaba por «5», que daba un precio disparatado.
  clearTimeout((window._pvMgT=window._pvMgT||{})[i]);
  window._pvMgT[i]=setTimeout(function(){ _pvMargenAplicar(i, txt); }, 450);
}

function _pvMargenAplicar(i, txt){
  var inp=document.getElementById('pv-'+i);
  if(!inp) return;
  var cif=parseFloat(inp.getAttribute('data-cif'))||0;
  if(!cif){ showT('Esa línea no tiene CIF: pon el precio a mano'); return; }
  var m=parseFloat(txt);
  if(isNaN(m) || m<0 || m>=100){
    if(m>=100) showT('El margen tiene que ser menor que 100%', 4000);
    return;
  }
  var pv=Math.round((cif/(1-m/100))*100)/100;
  inp.value=pv.toFixed(2);
  _pvCambio(i, true);
}

// El pie de cada línea: CIF y a qué margen equivale el precio puesto
function _pvPieLinea(i, cif, pv){
  var el=document.getElementById('pvpie-'+i);
  if(!el) return;
  // Solo el CIF: el margen tiene su propia columna al lado
  el.innerHTML=(cif>0) ? ('CIF '+(Number(cif)||0).toFixed(2)) : '';
}

/* Poner el mismo margen en TODAS las líneas, igual que el botón «Precio por
   margen» del catálogo. */
function _pvMargenTodos(){
  var v=prompt('¿Qué margen quieres sobre el precio de venta?\n\n'
    +'Ejemplo: un CIF de 1,00 con 50% de margen da un precio de 2,00.\n'
    +'El margen es la parte del precio que es ganancia.','50');
  if(v===null) return;
  var m=parseFloat(String(v).replace(',','.'));
  if(isNaN(m) || m<0){ showT('El margen no es válido'); return; }
  if(m>=100){ showT('El margen tiene que ser menor que 100%', 4000); return; }
  var n=0, sin=0;
  document.querySelectorAll('input[id^="pv-"]').forEach(function(inp){
    var i=String(inp.id).replace('pv-','');
    var cif=parseFloat(inp.getAttribute('data-cif'))||0;
    if(!cif){ sin++; return; }
    var pv=Math.round((cif/(1-m/100))*100)/100;
    inp.value=pv.toFixed(2);
    var em2=document.getElementById('pvmg-'+i);
    if(em2) em2.value=Math.round(m*10)/10;
    _pvCambio(i, true);
    n++;
  });
  showT('✓ '+n+' precio(s) calculados al '+m+'%'+(sin?(' · '+sin+' sin CIF'):''));
}

/* Teclado tipo Excel en el editor de precios: Enter y las flechas bajan y
   suben de línea, y Ctrl+D copia hacia abajo (el precio o el margen, según
   dónde estés). */
function _pvTecla(ev, i, esMargen){
  var k=String(ev.key||'');
  var pre=esMargen?'pvmg-':'pv-';

  if((ev.ctrlKey||ev.metaKey) && k.toLowerCase()==='d'){
    ev.preventDefault();
    var val=ev.target.value;
    var n=0, j=Number(i);
    while(true){
      j++;
      var el=document.getElementById(pre+j);
      if(!el) break;
      el.value=val;
      if(esMargen) _pvMargenAplicar(j, val); else _pvCambio(j);
      n++;
    }
    showT('✓ «'+val+'» puesto en '+n+' línea(s) más abajo');
    return;
  }

  if(k!=='Enter' && k!=='ArrowDown' && k!=='ArrowUp') return;
  ev.preventDefault();
  var sig=Number(i)+((k==='ArrowUp')?-1:1);
  var el2=document.getElementById(pre+sig);
  if(el2){
    el2.focus();
    try{ el2.select(); }catch(e){}
    try{ el2.scrollIntoView({block:'nearest'}); }catch(e){}
  }
}

/* ── Arrastrar hacia abajo en el editor de precios, como en Excel ─────────
   Al entrar en una casilla aparece un cuadradito en su esquina. Se arrastra
   hacia abajo y todas las casillas que se van marcando quedan con el mismo
   valor. Vale para el precio y para el porcentaje, y con doble clic se
   rellena hasta la última línea. */
(function _pvArrastreIniciar(){
  if(window._pvArrOk) return;
  window._pvArrOk=true;

  function esCasilla(el){
    return el && el.id && /^pv-\d+$|^pvmg-\d+$/.test(el.id);
  }
  function datos(el){
    var m=String(el.id).match(/^(pv|pvmg)-(\d+)$/);
    return m ? {pre:m[1]+'-', i:Number(m[2])} : null;
  }
  function pintar(pre, desde, hasta){
    document.querySelectorAll('input[id^="'+pre+'"]').forEach(function(x){
      var d=datos(x); if(!d || d.pre!==pre) return;
      var dentro=(d.i>Math.min(desde,hasta)-0.5 && d.i<Math.max(desde,hasta)+0.5);
      x.style.boxShadow=dentro?'inset 0 0 0 2px #7C3AED':'';
    });
  }
  function limpiar(pre){
    document.querySelectorAll('input[id^="'+pre+'"]').forEach(function(x){
      x.style.boxShadow=''; });
  }
  function rellenar(pre, desde, hasta, valor){
    var n=0;
    for(var j=Math.min(desde,hasta); j<=Math.max(desde,hasta); j++){
      if(j===desde) continue;
      var el=document.getElementById(pre+j);
      if(!el) continue;
      el.value=valor;
      if(pre==='pvmg-') _pvMargenAplicar(j, valor); else _pvCambio(j);
      n++;
    }
    if(n) showT('✓ «'+valor+'» puesto en '+n+' línea(s)');
  }

  // El cuadradito de arrastre, pegado a la casilla donde está el cursor
  function tirador(el){
    var t=document.getElementById('pvTirador');
    if(!t){
      t=document.createElement('div');
      t.id='pvTirador';
      t.title='Arrastra hacia abajo para copiar · doble clic para llenar hasta el final';
      t.style.cssText='position:fixed;width:11px;height:11px;background:#7C3AED;'
        +'border:1.5px solid #fff;border-radius:2px;cursor:crosshair;z-index:12600;'
        +'box-shadow:0 1px 3px rgba(0,0,0,.4)';
      document.body.appendChild(t);

      t.addEventListener('mousedown', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var base=window._pvTirBase;
        if(!base) return;
        var d=datos(base); if(!d) return;
        window._pvArr={pre:d.pre, desde:d.i, hasta:d.i, valor:base.value};
        pintar(d.pre, d.i, d.i);
      });
      t.addEventListener('dblclick', function(ev){
        ev.preventDefault();
        var base=window._pvTirBase; if(!base) return;
        var d=datos(base); if(!d) return;
        var ult=d.i;
        while(document.getElementById(d.pre+(ult+1))) ult++;
        rellenar(d.pre, d.i, ult, base.value);
      });
    }
    var r=el.getBoundingClientRect();
    t.style.left=(r.right-6)+'px';
    t.style.top=(r.bottom-6)+'px';
    t.style.display='block';
    window._pvTirBase=el;
  }

  document.addEventListener('focusin', function(e){
    if(esCasilla(e.target)) tirador(e.target);
  });
  document.addEventListener('mouseover', function(e){
    if(esCasilla(e.target) && !window._pvArr) tirador(e.target);
  });
  document.addEventListener('mousemove', function(e){
    var a=window._pvArr; if(!a) return;
    var bajo=document.elementFromPoint(e.clientX, e.clientY);
    if(!esCasilla(bajo)) return;
    var d=datos(bajo); if(!d || d.pre!==a.pre) return;
    a.hasta=d.i;
    pintar(a.pre, a.desde, a.hasta);
  });
  document.addEventListener('mouseup', function(){
    var a=window._pvArr; if(!a) return;
    window._pvArr=null;
    limpiar(a.pre);
    if(a.hasta!==a.desde) rellenar(a.pre, a.desde, a.hasta, a.valor);
  });
  // Al cerrar la ventana, fuera el cuadradito
  document.addEventListener('click', function(e){
    var t=document.getElementById('pvTirador');
    if(!t) return;
    if(!document.getElementById('modalPV')){ t.style.display='none'; }
  });
})();

/* ═══════════════════════════════════════════════════════════════════════════
   ALERTAS: BANDEJA CON FRANJAS DE URGENCIA   (prefijo [AL])
   ───────────────────────────────────────────────────────────────────────────
   Antes eran cien tarjetas iguales apiladas por tipo y no había forma de
   saber por dónde empezar. Ahora: una sola lista, lo importante fijado
   arriba, tres franjas por urgencia y lo leído al final en gris. Lo leído se
   guarda en el navegador de cada quien.
   ═══════════════════════════════════════════════════════════════════════════ */
var AL_LEIDAS_KEY='alertas_leidas_v1';
var AL_FIJAS=['firma','costeo','deposito','comentario'];

function _alLeidas(){
  try{ return JSON.parse(localStorage.getItem(AL_LEIDAS_KEY)||'{}')||{}; }
  catch(e){ return {}; }
}
function _alGuardarLeidas(m){
  try{ localStorage.setItem(AL_LEIDAS_KEY, JSON.stringify(m)); }catch(e){}
}
function _alClave(a){
  return [a.type||'', a.oid||'', String(a.msg||'').slice(0,40)].join('|');
}
function _alEsLeida(a){ return !!_alLeidas()[_alClave(a)]; }

function _alMarcar(clave, leida){
  var m=_alLeidas();
  if(leida) m[clave]=Date.now(); else delete m[clave];
  _alGuardarLeidas(m);
  try{ rAlertas(); }catch(e){}
}
function _alMarcarTodas(){
  if(!confirm('¿Marcar como leídas todas las que se ven?\n\n'
    +'No se borra ninguna: bajan al final, en gris, y dejan de contar.')) return;
  var m=_alLeidas();
  (window._alVisibles||[]).forEach(function(a){ m[_alClave(a)]=Date.now(); });
  _alGuardarLeidas(m);
  rAlertas();
}
function _alVerTodas(v){ window._alFiltro=v; rAlertas(); }

// De qué va cada alerta: decide color, etiqueta y si va fijada arriba
function _alTipo(a){
  var t=String(a.type||'').toLowerCase();
  var m=String(a.msg||'').toLowerCase();
  if(/firma/.test(t+m))                      return {k:'firma',      t:'Firma',      c:'#5B21B6'};
  if(/costeo|precio/.test(t+m))              return {k:'costeo',     t:'Costeo',     c:'#B45309'};
  if(/deposit|dep[óo]sito|pago|abono/.test(t+m)) return {k:'deposito', t:'Depósito',  c:'#991B1B'};
  if(/comentario|menci/.test(t+m))           return {k:'comentario', t:'Comentario', c:'#0C447C'};
  if(/atraso|llegada|eta|contenedor/.test(t+m)) return {k:'logistica', t:'Logística', c:'#166534'};
  if(/arte|dise/.test(t+m))                  return {k:'artes',      t:'Artes',      c:'#72243E'};
  return {k:'otra', t:'Aviso', c:a.color||'#5F5E5A'};
}

// Cuándo empezó: sirve para repartirlas en las tres franjas
function _alDias(a){
  try{
    var o=a.o||{};
    var f=o.fechaAlerta||o.eta||o.creado||o.fecha||'';
    if(!f) return 0;
    return Math.max(0, daysBetween(String(f).slice(0,10), null));
  }catch(e){ return 0; }
}

// La fecha del abono de una orden (YYYY-MM-DD): la de SAP o la de la
// solicitud pagada en el portal. '' si no se sabe.
function _fechaAbonoISO(o, sols){
  var t=String((o&&o.fechaAbono)||'').trim();
  var m=t.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);            // dd/mm/yyyy (como se ve en el portal)
  if(m) return m[3]+'-'+m[2]+'-'+m[1];
  if(/^\d{4}-\d{2}-\d{2}/.test(t)) return t.slice(0,10);
  var pag=(sols||[]).map(function(x){ return String(x.pagado_en||'').slice(0,10); }).filter(Boolean).sort();
  return pag.length?pag[0]:'';
}

/* El DKC de una orden (v758): para ubicarla sin abrirla. Hay proveedores con
   varios pedidos a la vez, y el número de SAP solo no dice cuál es. */
function _dkcDeOrden(docnum){
  var d=String(docnum||'').trim();
  if(!d || /[a-z]/i.test(d)) return '';               // ya es un DKC (BORRADOR)
  var o=(typeof orders!=='undefined' && orders ? orders : []).find(function(x){ return String(x.id)===d; });
  return o ? String(o.num_proveedor||'').trim() : '';
}

function _alFila(a){
  var tipo=_alTipo(a), clave=_alClave(a), leida=_alEsLeida(a);
  var o=a.o||{};
  var borde=leida ? '0.5px solid var(--border)' : '1px solid var(--border)';
  return '<div style="display:flex;gap:10px;align-items:flex-start;'
    +'background:'+(leida?'var(--surface-1)':'var(--surface-0)')+';'
    +'border:'+borde+';'+(leida?'':'border-left:4px solid '+tipo.c+';')
    +'border-radius:10px;padding:10px 12px;margin-bottom:6px;'
    +(leida?'opacity:.72;':'')+'">'
    +'<span style="width:9px;height:9px;border-radius:50%;margin-top:6px;flex:0 0 9px;'
    +'background:'+(leida?'var(--border)':tipo.c)+'"></span>'
    +'<div style="flex:1;min-width:0">'
    +'<div style="font-size:13px;font-weight:'+(leida?'500':'600')+';'
    +(leida?'color:var(--text-secondary);':'')+'">'
    +_esc(String(a.msg||'').slice(0,120))+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);display:flex;gap:9px;'
    +'flex-wrap:wrap;margin-top:2px">'
    +'<span style="background:'+tipo.c+'1a;color:'+tipo.c+';border-radius:999px;'
    +'padding:1px 8px;font-weight:700;font-size:10px">'+tipo.t+'</span>'
    +(o.prov?('<span>'+_esc(String(o.prov).slice(0,28))+'</span>'):'')
    +(a.oid?('<span>'+_esc(a.oid)+'</span>'):'')
    +((a.oid && (o.num_proveedor||_dkcDeOrden(a.oid)))?('<span style="font-weight:700;color:var(--t-azul)">'
       +_esc(o.num_proveedor||_dkcDeOrden(a.oid))+'</span>'):'')
    +(a.dept?('<span>'+_esc(dL(a.dept))+'</span>'):'')
    +'</div></div>'
    +'<div style="display:flex;gap:6px;flex-shrink:0">'
    +(a.oid?('<button class="xb" style="font-size:11.5px" '
       +'onclick="event.stopPropagation();openDetail(\''+_esc(a.oid)+'\')">Abrir</button>'):'')
    +'<button class="xb" style="font-size:11.5px" title="'
    +(leida?'Volver a marcarla sin leer':'Marcar leída: baja al final y deja de contar')+'" '
    +'onclick="event.stopPropagation();_alMarcar(\''+_esc(clave).replace(/'/g,'')+'\','
    +(leida?'false':'true')+')">'
    +(leida?'<i class="ti ti-rotate"></i>':'<i class="ti ti-check"></i>')+'</button>'
    +'</div></div>';
}

function _alFranja(titulo, lista, color, fondo, abierta, nota){
  if(!lista.length) return '';
  var id='alfr-'+titulo.replace(/[^a-z]/gi,'');
  return '<div style="border:1px solid '+color+'33;background:'+fondo+';'
    +'border-radius:12px;margin-bottom:14px;overflow:hidden">'
    +'<div onclick="var e=document.getElementById(\''+id+'\');'
    +'e.style.display=(e.style.display===\'none\'?\'block\':\'none\')" '
    +'style="display:flex;align-items:center;gap:9px;padding:9px 13px;cursor:pointer">'
    +'<b style="font-size:13px;color:'+color+'">'+_esc(titulo)+'</b>'
    +'<span style="font-size:11.5px;color:'+color+';opacity:.8">'+lista.length+' alerta(s)'
    +(nota?(' · '+_esc(nota)):'')+'</span>'
    +'<i class="ti ti-chevron-down" style="margin-left:auto;color:'+color+'"></i></div>'
    +'<div id="'+id+'" style="padding:0 9px 9px;display:'+(abierta?'block':'none')+'">'
    + lista.map(_alFila).join('')
    +'</div></div>';
}

/* La pantalla entera: fijadas, tres franjas y las leídas al final */
function _alBandeja(visible){
  // La vista se elige arriba y se recuerda: bandeja o dos columnas
  if(_alVista()==='columnas') return _alColumnas(visible);
  window._alVisibles=visible;
  var filtro=window._alFiltro||'sinleer';
  var leidas=visible.filter(_alEsLeida);
  var sinLeer=visible.filter(function(a){ return !_alEsLeida(a); });

  var pill=function(k, t, n){
    return '<span class="pill'+(filtro===k?' active':'')+'" '
      +'onclick="_alVerTodas(\''+k+'\')">'+t+' <b style="opacity:.75">'+n+'</b></span>';
  };

  var h=_alSelector();

  // Lo que espera una acción tuya va arriba, en cajas plegables con su
  // número: no se pierde, pero tampoco ocupa media pantalla.
  var secs=_alSecciones();
  if(secs.length){
    h+='<div style="margin-bottom:12px">'
      + secs.map(function(x, i){
          var id='alsec-'+x.k;
          return '<div style="border:1px solid '+x.c+'33;background:var(--surface-0);'
            +'border-radius:11px;margin-bottom:6px;overflow:hidden">'
            +'<div onclick="var e=document.getElementById(\''+id+'\');'
            +'e.style.display=(e.style.display===\'none\'?\'block\':\'none\')" '
            +'style="display:flex;align-items:center;gap:9px;padding:9px 13px;cursor:pointer">'
            +'<i class="ti '+(x.icono||'ti-point')+'" style="color:'+x.c+'"></i>'
            +'<b style="font-size:13px;color:'+x.c+'">'+_esc(x.t)+'</b>'
            +(x.n?('<span style="font-size:11px;font-weight:700;background:'+x.c+'1a;'
              +'color:'+x.c+';border-radius:999px;padding:1px 8px">'+x.n+'</span>'):'')
            +'<i class="ti ti-chevron-down" style="margin-left:auto;color:'+x.c+'"></i></div>'
            +'<div id="'+id+'" style="display:'+(i===0?'block':'none')+';padding:0 10px 10px">'
            +(/sol$/.test(x.k)&&window._alHTML_barraSol?window._alHTML_barraSol:'')
            + x.html+'</div></div>';
        }).join('')
      +'</div>';
  }

  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:12px">'
    + pill('sinleer','Sin leer', sinLeer.length)
    + pill('todas','Todas', visible.length)
    + '<span style="flex:1"></span>'
    + (sinLeer.length?('<button class="xb" onclick="_alMarcarTodas()">'
        +'<i class="ti ti-checks"></i> Marcar todas leídas</button>'):'')
    +'</div>';

  if(!visible.length){
    return h+'<div class="empty"><i class="ti ti-circle-check" '
      +'style="font-size:22px;color:var(--text-success)"></i><br>'
      +'Todo al día. Sin alertas para estos filtros.</div>';
  }

  // Lo que siempre va primero, aunque sea viejo
  // Los avisos del sistema sobre dinero entran como alertas de depósito
  try{
    (window._menciones||[]).forEach(function(m){
      if(!_menEsDelSistema(m)) return;
      var yaEsta=sinLeer.some(function(a){ return a._mencion && a._mencion.id===m.id; });
      if(yaEsta) return;
      sinLeer.push({type:'deposito', oid:m.docnum||'', dept:'',
                    msg:String(m.texto||'').slice(0,160),
                    o:{fechaAlerta:m.creado_en}, _mencion:m});
    });
  }catch(e){}

  var fijadas=sinLeer.filter(function(a){ return AL_FIJAS.indexOf(_alTipo(a).k)>=0; });
  var resto=sinLeer.filter(function(a){ return AL_FIJAS.indexOf(_alTipo(a).k)<0; });

  if(fijadas.length){
    h+='<div style="font-size:11.5px;color:var(--text-muted);margin:2px 0 6px">'
      +'Firmas, costeos, depósitos y menciones</div>'
      + fijadas.map(_alFila).join('');
  }

  var hoy=resto.filter(function(a){ return _alDias(a)<=1; });
  var sem=resto.filter(function(a){ var d=_alDias(a); return d>1 && d<=7; });
  var lue=resto.filter(function(a){ return _alDias(a)>7; });

  var depts=function(l){
    var c={};
    l.forEach(function(a){ var d=dL(a.dept)||'otros'; c[d]=(c[d]||0)+1; });
    return Object.keys(c).sort(function(a,b){ return c[b]-c[a]; })
      .slice(0,3).map(function(k){ return k+' '+c[k]; }).join(' · ');
  };

  h+= _alFranja('Hoy', hoy, '#991B1B', 'var(--pastel-error)', true, depts(hoy));
  h+= _alFranja('Esta semana', sem, '#B45309', 'var(--pastel-aviso)', sem.length<=12, depts(sem));
  h+= _alFranja('Más adelante', lue, '#5F5E5A', 'var(--surface-1)', false, depts(lue));

  if(leidas.length && filtro==='todas'){
    h+='<div style="border-top:0.5px solid var(--border);margin:16px 0 10px"></div>'
      +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px">'
      +'Leídas · '+leidas.length+'</div>'
      + leidas.slice(0,80).map(_alFila).join('');
  } else if(leidas.length){
    h+='<div style="font-size:11.5px;color:var(--text-muted);margin-top:12px;'
      +'text-align:center">'+leidas.length+' leída(s) · '
      +'<a onclick="_alVerTodas(\'todas\')" style="color:var(--text-accent);cursor:pointer">'
      +'verlas</a></div>';
  }
  return h;
}

/* ── Alertas en dos columnas ──────────────────────────────────────────────
   Los tipos a la izquierda con su número; a la derecha solo lo elegido. Se
   convive con la bandeja: el botón de arriba cambia de una a otra y se
   recuerda la preferencia de cada quien. */
var AL_VISTA_KEY='alertas_vista_v1';

function _alVista(){
  try{ return localStorage.getItem(AL_VISTA_KEY)||'bandeja'; }catch(e){ return 'bandeja'; }
}
function _alVistaPoner(v){
  try{ localStorage.setItem(AL_VISTA_KEY, v); }catch(e){}
  window._alFiltro='sinleer';
  rAlertas();
}
function _alSelTipo(k){ window._alTipoSel=k; rAlertas(); }

function _alSelector(){
  var v=_alVista();
  return '<div style="display:flex;gap:6px;margin-bottom:10px;align-items:center;'
    +'flex-wrap:wrap">'
    +'<span class="pill'+(v==='bandeja'?' active':'')+'" onclick="_alVistaPoner(\'bandeja\')">'
    +'<i class="ti ti-list"></i> Bandeja</span>'
    +'<span class="pill'+(v==='columnas'?' active':'')+'" onclick="_alVistaPoner(\'columnas\')">'
    +'<i class="ti ti-layout-sidebar"></i> Dos columnas</span>'
    // Ir directo a una solicitud por su número: con cientos de avisos,
    // encontrar la #25875 a ojo es una pérdida de tiempo.
    +'<span style="flex:1"></span>'
    +'<input id="alBuscaSol" placeholder="Ir a una solicitud por su número…" '
    +'onkeydown="if(event.key===\'Enter\')_solAbrirPorNumero(this.value)" '
    +'style="min-width:230px;padding:6px 11px;border:0.5px solid var(--border);'
    +'border-radius:999px;font-size:12px;background:var(--surface-0);'
    +'color:var(--text-primary)">'
    +'<button class="xb" onclick="_solAbrirPorNumero(' 
    +'(document.getElementById(\'alBuscaSol\')||{}).value)">'
    +'<i class="ti ti-search"></i></button>'
    +'</div>';
}

/* Abre una solicitud por su número, venga de una orden o de varias facturas.
   Es el camino corto cuando contabilidad sabe el número y no quiere buscarlo
   entre los avisos. */
async function _solAbrirPorNumero(num){
  var n=String(num||'').replace(/[^0-9]/g,'').trim();
  if(!n){ showT('Escribe el número de la solicitud'); return; }
  var lista=window._solPago||[];
  if(!lista.length){
    try{ await _solPagoCargar(); lista=window._solPago||[]; }catch(e){}
  }
  var x=lista.filter(function(z){
    return String(z.docnum||'').replace(/[^0-9]/g,'')===n; })[0];
  if(!x){
    showT('No encuentro ninguna solicitud con el número '+n
      +'. Puede ser de otro departamento o estar ya trabajada.', 8000);
    return;
  }
  _solFichaSuelta(x);
}

var AL_ORDEN_TIPOS=[
  {k:'firma',      t:'Compras por firmar', c:'#5B21B6'},
  {k:'costeo',     t:'Costeos y precios',  c:'#B45309'},
  {k:'deposito',   t:'Depósitos y pagos',  c:'#991B1B'},
  {k:'comentario', t:'Comentarios',        c:'#0C447C'},
  {k:'logistica',  t:'Logística y ETAs',   c:'#166534'},
  {k:'artes',      t:'Artes y producción', c:'#72243E'},
  {k:'otra',       t:'Otros avisos',       c:'#5F5E5A'}
];

function _alColumnas(visible){
  window._alVisibles=visible;
  var filtro=window._alFiltro||'sinleer';
  var porTipo={};
  visible.forEach(function(a){
    var k=_alTipo(a).k;
    (porTipo[k]=porTipo[k]||[]).push(a);
  });
  // Los avisos del sistema sobre pagos, abonos y cancelaciones se suman a
  // «Depósitos y pagos»: son alertas de dinero, no menciones de nadie.
  try{
    (window._menciones||[]).forEach(function(m){
      if(!_menEsDelSistema(m)) return;
      porTipo.deposito=porTipo.deposito||[];
      porTipo.deposito.push({
        type:'deposito', oid:m.docnum||'', dept:'',
        msg:String(m.texto||'').slice(0,160),
        o:{fechaAlerta:m.creado_en},
        _mencion:m
      });
    });
  }catch(e){}
  // El tipo elegido. OJO: las secciones de arriba (solicitudes, reclamos,
  // menciones…) no están en porTipo, que solo tiene alertas de órdenes. Si
  // no se comprueba antes, se descartan y el panel vuelve solo a
  // «Depósitos y pagos»: era lo que hacía que no pasara nada al pulsarlas.
  var secsK={};
  _alSecciones().forEach(function(x){ secsK[x.k]=1; });
  var sel=window._alTipoSel;
  var conSinLeer=AL_ORDEN_TIPOS.filter(function(x){
    return (porTipo[x.k]||[]).some(function(a){ return !_alEsLeida(a); }); });
  if(!sel || (!secsK[sel] && !(porTipo[sel]||[]).length)){
    sel=(conSinLeer[0]||AL_ORDEN_TIPOS.filter(function(x){
      return (porTipo[x.k]||[]).length; })[0]||{k:'firma'}).k;
  }
  var leidasTot=visible.filter(_alEsLeida).length;

  var secs=_alSecciones();
  var itemSec=function(x){
    var on=(x.k===sel);
    return '<div onclick="_alSelTipo(\''+x.k+'\')" style="display:flex;align-items:center;'
      +'justify-content:space-between;gap:8px;padding:9px 11px;border-radius:9px;'
      +'font-size:12.5px;cursor:pointer;margin-bottom:2px;'
      +(on?('background:'+x.c+';color:#fff;font-weight:700'):'color:var(--text-primary)')+'">'
      +'<span style="display:flex;align-items:center;gap:7px">'
      +'<i class="ti '+(x.icono||'ti-point')+'" style="font-size:14px;color:'
      +(on?'#fff':x.c)+'"></i>'+_esc(x.t)+'</span>'
      +(x.n?('<span style="font-size:11px;font-weight:700;border-radius:999px;padding:1px 8px;'
        +(on?'background:rgba(255,255,255,.25);color:#fff'
           :('background:'+x.c+'1a;color:'+x.c))+'">'+x.n+'</span>'):'')
      +'</div>';
  };

  var lateral='<aside style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:12px;padding:7px;align-self:start;position:sticky;top:10px">'
    + (secs.length
       ? ('<div style="font-size:10px;color:var(--text-muted);padding:4px 11px 3px;'
          +'font-weight:700">Te esperan</div>'
          + secs.map(itemSec).join('')
          + '<div style="height:1px;background:var(--border);margin:6px 4px"></div>'
          + '<div style="font-size:10px;color:var(--text-muted);padding:4px 11px 3px;'
          + 'font-weight:700">Alertas de órdenes</div>')
       : '')
    + AL_ORDEN_TIPOS.map(function(x){
        var l=porTipo[x.k]||[];
        if(!l.length) return '';
        var sinLeer=l.filter(function(a){ return !_alEsLeida(a); }).length;
        var on=(x.k===sel);
        return '<div onclick="_alSelTipo(\''+x.k+'\')" style="display:flex;align-items:center;'
          +'justify-content:space-between;gap:8px;padding:9px 11px;border-radius:9px;'
          +'font-size:12.5px;cursor:pointer;margin-bottom:2px;'
          +(on?('background:'+x.c+';color:#fff;font-weight:700')
              :('color:var(--text-primary)'))+'">'
          +'<span style="display:flex;align-items:center;gap:7px">'
          +'<span style="width:8px;height:8px;border-radius:50%;background:'
          +(on?'#fff':x.c)+'"></span>'+_esc(x.t)+'</span>'
          +'<span style="font-size:11px;font-weight:700;border-radius:999px;padding:1px 8px;'
          +(on?'background:rgba(255,255,255,.25);color:#fff'
             :(sinLeer?('background:'+x.c+'1a;color:'+x.c)
                      :'background:var(--surface-1);color:var(--text-muted)'))+'">'
          +(sinLeer?sinLeer:l.length)+'</span></div>';
      }).join('')
    + (leidasTot?('<div style="height:1px;background:var(--border);margin:6px 4px"></div>'
        +'<div onclick="_alVerTodas(\''+(filtro==='todas'?'sinleer':'todas')+'\')" '
        +'style="padding:8px 11px;font-size:12px;color:var(--text-muted);cursor:pointer">'
        +(filtro==='todas'?'Ocultar leídas':'Ver las '+leidasTot+' leídas')+'</div>'):'')
    +'</aside>';

  // Si se eligió una sección (solicitudes, reclamos…), se muestra su panel
  var seccion=secs.filter(function(x){ return x.k===sel; })[0];
  if(seccion){
    return _alSelector()
      +'<div style="display:grid;grid-template-columns:238px 1fr;gap:15px;'
      +'align-items:start" class="al-dos">'+lateral
      +'<div>'+(window._alHTML_barraSol&&/sol$/.test(sel)?window._alHTML_barraSol:'')
      + seccion.html+'</div></div>'
      +'<style>@media(max-width:780px){.al-dos{grid-template-columns:1fr!important}}</style>';
  }

  var lista=(porTipo[sel]||[]).slice();
  if(filtro!=='todas') lista=lista.filter(function(a){ return !_alEsLeida(a); });
  lista.sort(function(a,b){
    var la=_alEsLeida(a)?1:0, lb=_alEsLeida(b)?1:0;
    if(la!==lb) return la-lb;
    return _alDias(a)-_alDias(b);
  });
  var tit=(AL_ORDEN_TIPOS.filter(function(x){ return x.k===sel; })[0]||{}).t||'Alertas';

  var derecha='<div><div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;'
    +'margin-bottom:10px"><b style="font-size:14px">'+_esc(tit)+'</b>'
    +'<span style="font-size:11.5px;color:var(--text-muted)">'+lista.length+' en pantalla</span>'
    +'<span style="flex:1"></span>'
    +(lista.some(function(a){ return !_alEsLeida(a); })
      ? '<button class="xb" onclick="_alMarcarTipo(\''+sel+'\')">'
        +'<i class="ti ti-checks"></i> Marcar leídas las de aquí</button>' : '')
    +'</div>'
    + (lista.length ? lista.map(_alFila).join('')
        : '<div class="empty">Nada pendiente aquí. '
          +(filtro==='todas'?'':'<a onclick="_alVerTodas(\'todas\')" '
            +'style="color:var(--text-accent);cursor:pointer">Ver las leídas</a>')+'</div>')
    +'</div>';

  return _alSelector()
    +'<div style="display:grid;grid-template-columns:238px 1fr;gap:15px;align-items:start" '
    +'class="al-dos">'+lateral+derecha+'</div>'
    +'<style>@media(max-width:780px){.al-dos{grid-template-columns:1fr!important}}</style>';
}

function _alMarcarTipo(k){
  var m=_alLeidas();
  (window._alVisibles||[]).forEach(function(a){
    if(_alTipo(a).k===k) m[_alClave(a)]=Date.now();
  });
  _alGuardarLeidas(m);
  rAlertas();
}

/* ── Los demás bloques de Alertas, dentro de la misma estructura ──────────
   Menciones, pendientes de gerencia, reclamos, seguimiento de abonos y las
   solicitudes de depósito y de cancelación dejan de ser cinco bloques
   apilados: en dos columnas son secciones de la izquierda, y en la bandeja
   son cajas plegadas con su número. */
function _alSecciones(){
  var S=[];
  var add=function(k, t, c, icono, html){
    html=String(html||'').trim();
    if(!html) return;
    S.push({k:k, t:t, c:c, icono:icono, html:html, n:_alContarEn(html)});
  };
  try{ add('menciones','Comentarios donde te mencionan','#0C447C','ti-at',
           window._alHTML_men); }catch(e){}
  try{ add('pendgerencia','Pendientes de seguimiento','#3C3489','ti-clock-pause',
           window._alHTML_pg); }catch(e){}
  try{ add('deposito_sol','Solicitudes de depósito','#166534','ti-coin',
           window._alHTML_sol_abono); }catch(e){}
  try{ add('cancelacion_sol','Solicitud de cancelación','#B45309','ti-file-invoice',
           window._alHTML_sol_canc); }catch(e){}
  try{ add('reclamos','Reclamos a proveedores','#991B1B','ti-alert-octagon',
           window._alHTML_recl); }catch(e){}
  try{ add('segabonos','Seguimiento de abonos','#72243E','ti-cash',
           window._alHTML_seg); }catch(e){}
  return S;
}

// Cuántas fichas trae un bloque, para el número de la izquierda
function _alContarEn(html){
  try{
    var m=String(html).match(/(\d+)\s*(?:solicitud|pendiente|reclamo|sin leer|alerta)/i);
    if(m) return Number(m[1])||0;
    var d=document.createElement('div');
    d.innerHTML=html;
    var n=d.querySelectorAll('.al-card, .sol-fila, tr[data-solid], .sec-item').length;
    return n||0;
  }catch(e){ return 0; }
}

/* ── Ficha suelta de una solicitud ────────────────────────────────────────
   Algunas solicitudes cubren varias facturas y varias órdenes a la vez, y no
   hay UNA orden que abrir. Antes eso dejaba a contabilidad sin poder hacer
   nada. Aquí se trabaja la solicitud por sí sola: se ve lo que pidió
   compras, sus adjuntos, y se devuelve el comprobante del pago. */
async function _solFichaSuelta(x){
  if(!x) return;
  var prev=document.getElementById('modalSolSuelta'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalSolSuelta';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:12300;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:880px;box-shadow:0 18px 50px rgba(0,0,0,.3)">'
    +'<div id="ssCuerpo"><div style="font-size:12px;color:var(--text-muted)">'
    +'<span class="ai-ring g"></span> Abriendo la solicitud…</div></div></div>';
  document.body.appendChild(ov);
  window._solSuelta={x:x, correo:null};

  // El correo que mandó compras, con sus adjuntos
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue?select=*&docnum=eq.'
      +encodeURIComponent(String(x.docnum||''))+'&order=creado_en.desc&limit=5',{headers:SBH});
    var l=(r.ok?((await r.json())||[]):[]);
    window._solSuelta.correo=l.filter(function(c){
      return /cancelaci|dep[oó]sito|abono|solicitud/i.test(String(c.asunto||'')+String(c.origen||''));
    })[0] || l[0] || null;
  }catch(e){}
  _solSueltaPintar();
}

function _solSueltaCerrar(){
  var m=document.getElementById('modalSolSuelta'); if(m) m.remove();
  window._solSuelta=null;
}

function _solSueltaPintar(){
  var S=window._solSuelta; if(!S) return;
  var c=document.getElementById('ssCuerpo'); if(!c) return;
  var x=S.x, co=S.correo;
  var quien=_avSolicitante(x)||{};
  var adj=(co&&co.adjuntos)||[];

  c.innerHTML='<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
    +'<i class="ti ti-file-invoice" style="font-size:21px;color:var(--t-marron)"></i>'
    +'<div style="flex:1"><div style="font-size:15px;font-weight:700">'
    +(x.tipo==='cancelacion'?'Solicitud de cancelación':'Solicitud de depósito')
    +' · '+_esc(x.docnum||'')+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +'La pidió '+_esc(x.solicitado_por||quien.name||'')
    +' · '+_esc(_fechaHora(_solFechaSol(x)))
    +' · <b style="color:var(--t-marron)">'+_fmtN2(x.monto)+'</b></div></div>'
    +'<button class="xb" onclick="_solSueltaCerrar()"><i class="ti ti-x"></i></button></div>'

    +'<div class="nota" style="background:var(--pastel-azul);color:var(--t-azul);font-size:11.5px">'
    +'Esta solicitud cubre varias facturas y varias órdenes, así que no hay una sola '
    +'orden que abrir. Desde aquí se ve lo que pidió compras y se le devuelve el '
    +'comprobante del pago.</div>'

    // El documento que originó la solicitud, a un clic
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px">'
    +'<button class="btn bg2" style="padding:7px 12px;font-size:11.5px" '
    +'onclick="_solIrAFactura(\''+_esc(String(x.docnum||''))+'\')">'
    +'<i class="ti ti-file-invoice"></i> Ver la factura reserva '+_esc(x.docnum||'')+'</button>'
    +'<button class="btn bg2" style="padding:7px 12px;font-size:11.5px" '
    +'onclick="_solIrAEntrada(\''+_esc(String(x.docnum||''))+'\')">'
    +'<i class="ti ti-truck-loading"></i> Ver la entrada de mercancía</button>'
    +'</div>'
    +(co
      ? ('<div style="background:var(--surface-0);border:0.5px solid var(--border);'
         +'border-radius:10px;padding:12px;margin-bottom:10px">'
         +'<div style="font-size:12.5px;font-weight:700;margin-bottom:3px">'
         +_esc(co.asunto||'')+'</div>'
         +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:7px">'
         +_esc(_fechaHora(co.creado_en))+' · de '+_esc(co.de_nombre||'')+'</div>'
         +(adj.length?('<div style="font-size:11.5px;margin-bottom:7px"><b>Adjuntos:</b> '
            + adj.map(function(a){ return _esc(a.nombre); }).join(' · ')+'</div>'):'')
         +'<div style="font-size:12px;line-height:1.55;white-space:pre-wrap;max-height:30vh;'
         +'overflow:auto;color:var(--text-secondary)">'+_esc(String(co.cuerpo||'').slice(0,2500))
         +'</div></div>')
      : '<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron);'
        +'font-size:11.5px">No encuentro el correo original de esta solicitud.</div>')

    +'<div style="border-top:0.5px solid var(--border);padding-top:11px">'
    +'<div style="font-size:12.5px;font-weight:700;margin-bottom:4px">'
    +'<i class="ti ti-upload"></i> Devolver el comprobante del pago</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:7px">'
    +'Se le manda a quien la pidió, con copia a quien quieras, y queda guardado '
    +'en la solicitud.</div>'
    +'<input type="file" id="ssFile" multiple '
    +'accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" '
    +'style="font-size:12px;margin-bottom:8px">'
    +'<input id="ssCopia" placeholder="Copia a (separados por comas)" '
    +'style="width:100%;box-sizing:border-box;padding:7px 9px;border:0.5px solid var(--border);'
    +'border-radius:7px;font-size:12px;background:var(--surface-0);color:var(--text-primary);'
    +'margin-bottom:8px" value="'+_esc((co&&co.de_email)||quien.email||'')+'">'
    +'<textarea id="ssNota" rows="3" placeholder="Nota (opcional)" '
    +'style="width:100%;box-sizing:border-box;padding:8px;border:0.5px solid var(--border);'
    +'border-radius:8px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
    +'Pago enviado al proveedor. Adjunto el comprobante.</textarea>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:11px">'
    +'<button class="btn bg2" style="padding:9px 14px" onclick="_solSueltaCerrar()">Cerrar</button>'
    +'<button class="btn bp" style="padding:9px 18px" id="ssBtn" '
    +'onclick="_solSueltaEnviar()"><i class="ti ti-send"></i> Enviar el comprobante</button>'
    +'</div></div>';
}

async function _solSueltaEnviar(){
  var S=window._solSuelta; if(!S) return;
  var x=S.x, co=S.correo;
  var inp=document.getElementById('ssFile');
  var files=inp&&inp.files?Array.prototype.slice.call(inp.files):[];
  if(!files.length){ showT('Elige el comprobante primero'); return; }

  var quien=_avSolicitante(x)||{};
  var destinos=[];
  [(co&&co.de_email), quien.email].forEach(function(e){
    e=String(e||'').trim(); if(e.indexOf('@')>0) destinos.push(e);
  });
  String((document.getElementById('ssCopia')||{}).value||'')
    .split(/[,;]+/).forEach(function(e){
      e=e.trim(); if(e.indexOf('@')>0) destinos.push(e); });
  destinos=destinos.filter(function(e,i,a){ return a.indexOf(e)===i; });
  if(!destinos.length){ showT('No sé a quién mandárselo: escribe un correo'); return; }

  var btn=document.getElementById('ssBtn');
  if(btn){ btn.disabled=true; btn.innerHTML='<span class="ai-ring"></span> Enviando…'; }
  try{
    var adjuntos=[];
    for(var i=0;i<files.length;i++){
      var f=await _attAligerar(files[i]);
      var b64=await new Promise(function(res, rej){
        var fr=new FileReader();
        fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
        fr.onerror=function(){ rej(new Error('no pude leer '+f.name)); };
        fr.readAsDataURL(f);
      });
      adjuntos.push({nombre:f.name, mime:f.type||'application/octet-stream', contenido:b64});
    }
    var nota=String((document.getElementById('ssNota')||{}).value||'').trim();
    var asunto='Pago enviado · '+((x.tipo==='cancelacion')?'cancelación':'depósito')
      +' · '+(co&&co.asunto ? String(co.asunto).replace(/^.*?·\s*/,'') : ('solicitud '+x.docnum));

    var fila={
      docnum:String(x.docnum||''), para_lista:destinos, para_email:destinos[0],
      asunto:asunto,
      cuerpo:(nota||'Pago enviado al proveedor.')
        +'\n\nSolicitud: '+(x.docnum||'')+'\nMonto: '+_fmtN2(x.monto)
        +'\n\n— '+((CU&&CU.name)||''),
      adjuntos:adjuntos,
      de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
      origen:'Comprobante de pago · solicitud '+(x.docnum||''), estado:'pendiente'
    };
    var r=await _postTolerante(SB+'/rest/v1/correos_queue', fila);
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,140));

    // Aviso dentro del portal y la solicitud queda trabajada
    try{ _avisarPorCorreo(destinos, x.docnum,
      'Contabilidad envió el comprobante del pago · solicitud '+(x.docnum||''), 'ti-cash'); }catch(e){}
    try{
      await _solPagoPatch(x.id, {estado:'trabajada', pagado_por:(CU&&CU.name)||'',
                                 pagado_en:new Date().toISOString()});
      _solPagoRefrescar();
    }catch(e){}
    showT('✓ Comprobante enviado a '+destinos.length+' destinatario(s)', 8000);
    _solSueltaCerrar();
  }catch(e){
    showT(e&&e.cancelado ? 'Envío cancelado: no se mandó nada'
      : ('No se pudo enviar: '+(e.message||e)), 9000);
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar el comprobante'; }
  }
}

/* De la solicitud a sus documentos: la factura reserva que la originó y la
   entrada de mercancía que salió de ella. Contabilidad paga contra esos dos
   papeles, así que los tiene a un clic. */
async function _solIrAFactura(num){
  var n=String(num||'').replace(/[^0-9]/g,'');
  if(!n){ showT('Esta solicitud no trae número de factura'); return; }
  _solSueltaCerrar();
  go('facturasres');
  try{ rFacturasRes(); }catch(e){}
  showT('Abriendo la factura reserva #'+n+'…');
  for(var i=0;i<20;i++){
    var f=((window._fres&&window._fres.filas)||[]).filter(function(x){
      return String(x.docnum)===String(n); })[0];
    if(f){ _fresAbrir(f.docentry); return; }
    await new Promise(function(r){ setTimeout(r, 400); });
  }
  showT('No encuentro la factura #'+n+' en el listado. Prueba a darle a Actualizar.', 8000);
}

async function _solIrAEntrada(num){
  // Misma fuente que todo lo demás: si la referencia es una orden, se abre
  // su entrada; si hay varias, la primera y el aviso de que hay más.
  try{
    var porOrden=await _pvEntradasDeLaOrden(String(num||'').replace(/[^0-9]/g,''));
    if(porOrden && porOrden.length){
      _solSueltaCerrar();
      if(porOrden.length>1)
        showT('Esta orden tiene '+porOrden.length+' entradas; abro la primera', 7000);
      _enAbrir(porOrden[0].docentry);
      return;
    }
  }catch(e){}
  var n=String(num||'').replace(/[^0-9]/g,'');
  if(!n){ showT('Esta solicitud no trae número de factura'); return; }
  showT('Buscando la entrada de la factura #'+n+'…');
  var docentry=null;
  try{
    // Las entradas guardan de qué factura vienen
    var r=await fetch(SB+'/rest/v1/opdn_entradas?select=docentry,docnum,facturas'
      +'&facturas=like.*'+n+'*&limit=5',{headers:SBH});
    var l=(r.ok?((await r.json())||[]):[]);
    if(l.length) docentry=l[0].docentry;
  }catch(e){}
  if(!docentry){
    try{
      var r2=await fetch(SB+'/rest/v1/opdn_lineas?select=docentry&factura_num=eq.'+n
        +'&limit=1',{headers:SBH});
      var l2=(r2.ok?((await r2.json())||[]):[]);
      if(l2.length) docentry=l2[0].docentry;
    }catch(e){}
  }
  if(!docentry){
    showT('Esa factura todavía no tiene entrada de mercancía en el portal.', 7000);
    return;
  }
  _solSueltaCerrar();
  go('entradas');
  try{ rEntradas(); }catch(e){}
  for(var i=0;i<20;i++){
    if(((window._en&&window._en.lista)||[]).some(function(x){
        return String(x.docentry)===String(docentry); })){
      _enAbrir(docentry); return;
    }
    await new Promise(function(r){ setTimeout(r, 400); });
  }
  showT('No encuentro esa entrada en el listado', 6000);
}

/* ═══════════════════════════════════════════════════════════════════════════
   EL BOOKING A SAP   (prefijo [BK])
   ───────────────────────────────────────────────────────────────────────────
   Lo que se lee del booking se manda a los campos de la orden en SAP:
   naviera, número de booking, cantidad y tipo de contenedor, ETA y los
   puertos de embarque y destino.
   ═══════════════════════════════════════════════════════════════════════════ */

// Las navieras tal como están dadas de alta en SAP
var BK_NAVIERAS=['AIR SEA WORLDWIDE','CAPITAL','CMA','COSCO SHIPPING','ETERNITY',
  'EVERGREEN','GLOBAL CARGO','HAMBURG SUD','HAPAG-LLOYD','INTERCONTINENTAL',
  'KUENE NAGEL','MAERSK','MSC','ONE OCEAN','PANAMA CARRIERS','TECH CARGO',
  'YANG MING','ECU WORLDWIDE','SABINO DEL BENE'];

/* Lo que escribe la naviera no siempre coincide con el nombre de SAP:
   «MAERSK A/S» o «Maersk China Shipping» son MAERSK; «CMA CGM», CMA. */
function _bkNaviera(txt){
  var t=String(txt||'').toUpperCase().replace(/[^A-Z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  if(!t) return '';
  var exacta=BK_NAVIERAS.filter(function(n){ return n===t; })[0];
  if(exacta) return exacta;
  var alias={'CMA CGM':'CMA','CMACGM':'CMA','COSCO':'COSCO SHIPPING',
             'HAPAG LLOYD':'HAPAG-LLOYD','KUEHNE NAGEL':'KUENE NAGEL',
             'KUEHNE':'KUENE NAGEL','ONE':'ONE OCEAN','OCEAN NETWORK EXPRESS':'ONE OCEAN',
             'HAMBURG SUED':'HAMBURG SUD','ECU':'ECU WORLDWIDE','SABINO':'SABINO DEL BENE'};
  var k=Object.keys(alias).filter(function(a){ return t.indexOf(a)>=0; })[0];
  if(k) return alias[k];
  var contiene=BK_NAVIERAS.filter(function(n){ return t.indexOf(n)>=0; })[0];
  return contiene || '';
}

/* Las fechas se escriben a mano como 16/11/2026 y la base las quiere como
   2026-11-16. Sin esto el envío moría con «date/time field value out of
   range». */
function _bkFechaISO(v){
  var t=String(v||'').trim();
  if(!t) return '';
  var m=t.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})$/);
  if(m){
    var dd=('0'+m[1]).slice(-2), mm=('0'+m[2]).slice(-2), aa=m[3];
    if(aa.length===2) aa='20'+aa;
    return aa+'-'+mm+'-'+dd;
  }
  m=t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m) return m[0];
  var d=new Date(t);
  return isNaN(d.getTime()) ? '' : d.toISOString().slice(0,10);
}

/* El tipo de contenedor de SAP: 20", 40 HQ o 40 ST. En los booking un
   «40 DRY 9 6» es un 40 HQ (nueve seis de alto) y un «40 DRY» normal es un
   40 ST, que es lo que nos dijeron. */
function _bkTipoContenedor(txt){
  var t=String(txt||'').toUpperCase().replace(/\s+/g,' ');
  if(!t) return '';
  if(/\b20\b/.test(t)) return '20"';
  if(/40.*(HQ|HIGH|9\s*6|96)/.test(t)) return '40 HQ';
  if(/\b40\b/.test(t)) return '40 ST';          // 40 DRY, 40 ST, 40'
  return '';
}

// Lo que se va a mandar, leído del booking de la orden
function _bkDatos(oid){
  var d=_logLeer(oid), b=d.booking||{};
  // Los contenedores del booking se guardan en d.contenedores; b.containers
  // es de la pantalla antigua. Se miran los dos o el tipo se queda sin
  // deducir aunque en pantalla ponga «40 DRY».
  var conts=[].concat(d.contenedores||[], b.containers||[], b.contenedores||[]);
  var tipos=conts.map(function(c){ return _bkTipoContenedor(c.tipo||c.size||''); })
                 .filter(Boolean);
  return {
    booking:String(b.numero||'').trim(),
    naviera:_bkNaviera(b.naviera),
    naviera_texto:String(b.naviera||'').trim(),
    contenedores:conts.length,
    tipo:(tipos[0]||''),
    eta:_bkFechaISO(b.eta||b.fecha_llegada||''),
    puerto_embarque:String(b.origen||'').trim(),
    puerto_destino:String(b.destino||'').trim(),
    numeros:conts.map(function(c){ return String(c.id||c.numero||'').trim(); })
             .filter(Boolean).join(', ')
  };
}

// El botón: enseña lo que va a escribir y lo manda
async function _bkMandarASap(oid){
  var x=_bkDatos(oid);
  if(!x.booking && !x.naviera && !x.contenedores){
    showT('Primero lee el booking con la IA o escribe los datos');
    return;
  }
  var lineas=[
    ['Booking', x.booking],
    ['Naviera', x.naviera || (x.naviera_texto?('⚠ «'+x.naviera_texto+'» no está en la lista de SAP'):'')],
    ['Cant. contenedores', x.contenedores||0],
    ['Tipo de contenedor', x.tipo||'(no se pudo deducir)'],
    ['Fecha ETA', x.eta||''],
    ['Puerto de embarque', x.puerto_embarque],
    ['Puerto de destino', x.puerto_destino]
  ].filter(function(l){ return String(l[1]||'')!==''; });

  if(!confirm('ACTUALIZAR EL BOOKING EN SAP · orden '+oid+'\n\n'
    + lineas.map(function(l){ return '· '+l[0]+': '+l[1]; }).join('\n')
    + (x.numeros?('\n· Contenedores: '+x.numeros):'')
    + '\n\nSe escriben en los campos de usuario de la orden. ¿Sigo?')) return;

  try{
    _frwAbrir();
    _frwPintarEspera('Escribiendo el booking en SAP…',
      'El worker actualiza la orden '+oid+' por DI API.');
    var r=await _postTolerante(SB+'/rest/v1/booking_sap_queue', {
      docnum:String(oid),
      booking:x.booking, naviera:x.naviera,
      contenedores:x.contenedores, tipo_contenedor:x.tipo,
      eta:x.eta||null,
      puerto_embarque:x.puerto_embarque, puerto_destino:x.puerto_destino,
      numeros_contenedor:x.numeros,
      origen:'booking · portal', estado:'pendiente',
      creado_por:(CU&&CU.name)||''
    });
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre booking_sap.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,150));
    }
    var reg=null;
    try{ reg=((await r.json())||[])[0]; }catch(e){}
    _bkSeguir((reg&&reg.id)||null, Date.now(), String(oid));
  }catch(e){
    _frwCerrar();
    showT(e&&e.cancelado ? 'Envío cancelado: no se mandó nada'
      : ('No se pudo enviar: '+(e.message||e)), 9000);
  }
}

async function _bkSeguir(id, desde, docnum){
  // Un minuto esperando y se avisa: el worker puede haberlo hecho ya en SAP
  // y no haber podido marcar la fila. Dejar la rueda girando sin fin es lo
  // peor de los dos mundos.
  for(var i=0;i<24;i++){
    await new Promise(function(r){ setTimeout(r, 2500); });
    try{
      // Por id si lo tenemos; si no, la última petición de esa orden. Antes,
      // si el id no llegaba, el seguimiento no miraba nada y la rueda se
      // quedaba girando aunque el worker hubiera terminado.
      var url=id
        ? (SB+'/rest/v1/booking_sap_queue?select=*&id=eq.'+id)
        : (SB+'/rest/v1/booking_sap_queue?select=*&docnum=eq.'
           +encodeURIComponent(docnum||'')+'&order=id.desc&limit=1');
      var r=await fetch(url,{headers:SBH});
      var f=(r.ok?((await r.json())||[]):[])[0];
      if(!f) continue;
      // Vale cualquier señal de que ya pasó por el worker
      if(f.estado==='ok' || f.estado==='hecha' || f.estado==='procesada'
         || (f.procesado_en && f.estado!=='error')){
        _bkPintarOK(f);
        return;
      }
      if(f.estado==='error'){
        _frwPintarError('SAP no aceptó el cambio', f.error_msg||'');
        return;
      }
    }catch(e){}
  }
  // Antes de rendirse se mira la fila y se DICE lo que hay: así se sabe si
  // el worker no llegó, si no pudo marcarla o si SAP la rechazó.
  var detalle='';
  try{
    var r=await fetch(id
      ? (SB+'/rest/v1/booking_sap_queue?select=*&id=eq.'+id)
      : (SB+'/rest/v1/booking_sap_queue?select=*&docnum=eq.'
         +encodeURIComponent(docnum||'')+'&order=id.desc&limit=1'),{headers:SBH});
    if(!r.ok){
      detalle='No puedo leer la cola: '+r.status+' '+(await r.text()).slice(0,120);
    } else {
      var f=((await r.json())||[])[0];
      if(!f){
        detalle='La petición ya no está en la cola.';
      } else if(f.estado==='ok'){
        _bkPintarOK(f);
        return;
      } else {
        detalle='La fila #'+id+' está en «'+(f.estado||'?')+'»'
          +(f.procesado_en?(' · procesada el '+_fechaHora(f.procesado_en)):' · sin procesar')
          +(f.error_msg?('<br>Motivo: '+_esc(String(f.error_msg).slice(0,200))):'');
        if(f.estado==='pendiente' && !f.procesado_en){
          detalle+='<br><br>El worker no la ha tocado todavía: comprueba que está '
            +'corriendo y que es la versión 2026-10-01-h o posterior.';
        } else if(f.estado==='procesando'){
          detalle+='<br><br>La cogió pero no terminó: mira el log del worker, '
            +'ahí estará el motivo.';
        }
      }
    }
  }catch(e){ detalle='No pude consultar la cola: '+(e.message||e); }
  _frwPintarError('El worker no ha confirmado',
    detalle
    +'<br><br>En SAP puede estar HECHO igualmente: el worker escribe primero y '
    +'avisa después. Abre la orden y mira el campo Booking antes de reenviarlo.'
    +'<br><span style="font-size:10px;color:var(--text-muted)">portal '
    +APP_VERSION+' · petición '+(id||'(sin id)')+' · orden '+(docnum||'')+'</span>');
}

/* Qué órdenes tienen BOOKING, mirando los dos lados a la vez: la tabla de
   logística del portal y el campo de SAP. Se pide una sola vez y queda en
   memoria; el tablero lo usa para el contador «Por llegar». */
async function _bkCargarBookings(){
  // Si una carga anterior se quedó colgada, el aviso de «ya estoy cargando»
  // bloqueaba todas las demás para siempre y el contador se quedaba en 0.
  // Pasados 20 segundos se da por perdida y se vuelve a intentar.
  if(window._bkCargando && (Date.now()-(window._bkCargandoDesde||0)) < 20000) return;
  window._bkCargando=true;
  window._bkCargandoDesde=Date.now();
  var mapa={};
  var tieneBooking=function(d){
    if(!d) return false;
    var b=d.booking||{};
    return !!(String(b.numero||'').trim() || String(b.naviera||'').trim()
              || (b.containers||[]).length || (d.contenedores||[]).length);
  };

  // 0) Lo que ya está en este navegador: sale al instante, sin esperar a la
  //    base. Es donde vive el booking recién escrito.
  try{
    for(var i=0;i<localStorage.length;i++){
      var k=localStorage.key(i);
      if(!k || k.indexOf('log_')!==0) continue;
      try{
        var dd=JSON.parse(localStorage.getItem(k));
        if(tieneBooking(dd)) mapa[k.slice(4)]=true;
      }catch(e){}
    }
  }catch(e){}

  // 1) Lo guardado en el portal: el paso Booking de cada orden
  try{
    var r=await fetch(SB+'/rest/v1/compras_logistica?select=docnum,datos&limit=2000',
      {headers:SBH});
    if(!r.ok) _dbg('[PL] compras_logistica: '+r.status+' '+(await r.text()).slice(0,100));
    if(r.ok){
      (await r.json()||[]).forEach(function(x){
        var d=x.datos;
        if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
        var b=(d&&d.booking)||{};
        // Vale cualquier señal de que hay booking: el número, los
        // contenedores del booking o los contenedores de la orden.
        if(String(b.numero||'').trim()
           || (b.containers||[]).length
           || ((d&&d.contenedores)||[]).length
           || String(b.naviera||'').trim()){
          mapa[String(x.docnum)]=true;
        }
      });
    }
  }catch(e){}
  // 2) Lo que ya tengamos en memoria del navegador
  try{
    Object.keys(window._logData||{}).forEach(function(k){
      var dd=window._logData[k]||{};
      var b=dd.booking||{};
      if(String(b.numero||'').trim() || (b.containers||[]).length
         || (dd.contenedores||[]).length || String(b.naviera||'').trim()) mapa[String(k)]=true;
    });
  }catch(e){}
  // 3) Y el campo Booking de SAP, que viene con la orden
  try{
    (orders||[]).forEach(function(o){
      if(String(o.booking||'').trim()) mapa[String(o.id)]=true;
    });
  }catch(e){}

  // Un mapa vacío NO se guarda: así el siguiente repintado lo vuelve a
  // intentar en vez de quedarse en cero para siempre.
  if(Object.keys(mapa).length) window._bkConBooking=mapa;
  window._bkCargando=false;
  // Cuántas de las órdenes activas casan con ese mapa: si salen muchas en
  // el mapa pero ninguna casa, el problema es la clave, no los datos.
  var casan=0;
  try{
    (orders||[]).forEach(function(o){
      if(mapa[String(o.id)] || mapa[String(o.dkc||'')]
         || mapa[String(o.num_proveedor||'')]) casan++;
    });
  }catch(e){}
  _dbg('[PL] '+Object.keys(mapa).length+' con booking en los datos · '
    +casan+' casan con una orden del portal');
  if(Object.keys(mapa).length && !casan){
    _dbg('[PL] claves de ejemplo: '+Object.keys(mapa).slice(0,5).join(', '));
    _dbg('[PL] ids de ejemplo: '+(orders||[]).slice(0,5).map(function(o){
      return o.id+(o.dkc?('/'+o.dkc):''); }).join(', '));
  }
  try{ if(PG==='dashboard') rDash(); else renderApp(); }catch(e){}
}

/* Por qué «Por llegar» da ese número. En vez de pedirle a nadie que busque
   líneas en la consola, se enseña aquí con ejemplos de las claves, que es lo
   que de verdad hace falta para arreglarlo. */
async function _plPorQue(){
  // Primero se asegura de tener el mapa cargado
  try{ await _bkCargarBookings(); }catch(e){}
  // Se fuerza un repintado para tener los números del momento: los
  // guardados podían ser de un render anterior, con la lista aún vacía.
  try{ await _bkCargarBookings(); }catch(e){}
  try{ rDash(); }catch(e){}
  var d=window._plDiag||{};
  var mapa=window._bkConBooking||{};
  var claves=Object.keys(mapa);

  // Un par de ejemplos de cómo se identifica cada cosa
  var ids=(orders||[]).slice(0,6).map(function(o){
    return String(o.id)+(o.dkc?(' / '+o.dkc):''); });

  // Y qué hay en la tabla de logística ahora mismo
  var enTabla=0, conBook=0, ejemplos=[];
  try{
    var r=await fetch(SB+'/rest/v1/compras_logistica?select=docnum,datos&limit=2000',
      {headers:SBH});
    if(r.ok){
      var filas=await r.json()||[];
      enTabla=filas.length;
      filas.forEach(function(x){
        var dd=x.datos;
        if(typeof dd==='string'){ try{ dd=JSON.parse(dd); }catch(e){ dd=null; } }
        var b=(dd&&dd.booking)||{};
        if(String(b.numero||'').trim() || String(b.naviera||'').trim()
           || ((dd&&dd.contenedores)||[]).length){
          conBook++;
          if(ejemplos.length<6) ejemplos.push(String(x.docnum)+' → '+(b.numero||b.naviera||'cont.'));
        }
      });
    } else { enTabla=-1; }
  }catch(e){ enTabla=-1; }

  alert('DE DÓNDE SALE EL '+(d.total||0)+' DE «POR LLEGAR»\n\n'
    +'De las '+(d.activas||0)+' órdenes activas, cuentan por:\n'
    +'  · con booking en el portal: '+(d.local||0)+'\n'
    +'  · con booking en SAP (U_BOOKING): '+(d.sap||0)+'\n'
    +'  · en los dos sitios: '+(d.ambos||0)+'\n\n'
    +'Cada línea cuenta TODAS las que lo tienen, aunque lo tengan también en\n'
    +'el otro sitio, así que las dos pueden sumar más que el total.\n'
    +'Solo cuenta el BOOKING: el estado de la orden y la etapa ya no suman.\n\n'
    +'TABLA DE LOGÍSTICA\n'
    +(enTabla<0 ? '  · no la pude leer (permisos o no existe)\n'
                : '  · '+enTabla+' fila(s), '+conBook+' con booking\n')
    +(ejemplos.length?('  · ejemplos: '+ejemplos.join(' | ')+'\n'):'')
    +'\nEn memoria hay '+claves.length+' clave(s) con booking'
    +(claves.length?(': '+claves.slice(0,6).join(', ')):'')+'\n'
    +'Las órdenes se identifican así: '+ids.join(', ')+'\n\n'
    +'Si las claves y los identificadores no se parecen, el problema es ese: '
    +'mándame esta pantalla y lo ajusto.');
}

/* ¿Esta orden ya viene en camino? Vale cualquier señal, del portal o de SAP.
   Se usa en el tablero para el contador «Por llegar». */
/* «Por llegar» = órdenes con BOOKING, y nada más. Se miró también el estado
   EMBARCADO/DESPACHADO y la etapa del seguimiento, pero eso inflaba el
   número con órdenes que aún no tienen reserva con la naviera. El booking es
   el hecho que importa: si hay booking, la mercancía viene. */
function _plTieneBooking(o, porQue){
  if(!o) return false;
  var enPortal=false, enSap=false;
  try{
    var mapa=window._bkConBooking||{};
    if(mapa[String(o.id)] || mapa[String(o.dkc||'')]
       || mapa[String(o.num_proveedor||'')]) enPortal=true;
    if(!enPortal){
      var d=(window._logData||{})[o.id];
      if(d){
        var b=d.booking||{};
        enPortal=!!(String(b.numero||'').trim() || String(b.naviera||'').trim()
                    || (b.containers||[]).length || (d.contenedores||[]).length);
      }
    }
  }catch(e){}
  enSap=!!String(o.booking||'').trim();
  // Cada vía se cuenta por separado: una orden puede tener el booking en los
  // dos sitios, y antes solo sumaba en el primero. Eso hacía parecer que SAP
  // no tenía ninguno cuando sí los tiene.
  if(porQue){
    if(enPortal) porQue.local++;
    if(enSap) porQue.sap++;
    if(enPortal && enSap) porQue.ambos++;
  }
  return enPortal || enSap;
}

/* El mapa de órdenes con booking se pide UNA vez al arrancar y se deja
   listo: el tablero no puede esperar a una consulta para pintar un número. */
(function _plArranque(){
  try{
    setTimeout(function(){
      if(typeof _bkCargarBookings==='function') _bkCargarBookings();
    }, 2500);
  }catch(e){}
})();

/* ── Visor de imágenes con flechas ────────────────────────────────────────
   Al pulsar una miniatura se abre a pantalla completa con TODAS las del
   mismo grupo: se pasa con ← y → o con los botones, y se cierra con Esc.
   Además, al pasar el ratón por encima de una miniatura se ve en grande
   sin tener que abrirla. */
function _visorAbrir(img){
  var grupo=img.closest('div');
  var cont=grupo && grupo.parentElement ? grupo.parentElement : document;
  var todas=Array.prototype.slice.call(cont.querySelectorAll('img.att-img'));
  if(!todas.length) todas=[img];
  var i=Math.max(0, todas.indexOf(img));
  window._visor={urls:todas.map(function(x){
                   return {src:x.getAttribute('data-src')||x.src,
                           nombre:String(x.getAttribute('title')||'').split(' — ')[0]}; }),
                 i:i};
  _visorPintar();
}

function _visorPintar(){
  var V=window._visor; if(!V) return;
  var it=V.urls[V.i]||{};
  var ov=document.getElementById('visorImg');
  if(!ov){
    ov=document.createElement('div');
    ov.id='visorImg';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.9);z-index:13000;'
      +'display:flex;flex-direction:column;align-items:center;justify-content:center';
    ov.onclick=function(e){ if(e.target===ov) _visorCerrar(); };
    document.body.appendChild(ov);
    document.addEventListener('keydown', _visorTecla);
  }
  ov.innerHTML='<img src="'+_esc(it.src||'')+'" style="max-width:92vw;max-height:82vh;'
    +'object-fit:contain;border-radius:8px;box-shadow:0 10px 40px rgba(0,0,0,.6)">'
    +'<div style="color:#fff;font-size:13px;margin-top:10px;text-align:center">'
    +_esc(it.nombre||'')+'<div style="font-size:11px;opacity:.7;margin-top:2px">'
    +(V.i+1)+' de '+V.urls.length+' · usa ← y → para pasar · Esc para cerrar</div></div>'
    +(V.urls.length>1
      ? ('<button onclick="_visorIr(-1)" style="position:fixed;left:16px;top:50%;'
         +'transform:translateY(-50%);background:rgba(255,255,255,.15);color:#fff;'
         +'border:none;border-radius:50%;width:46px;height:46px;font-size:22px;'
         +'cursor:pointer">‹</button>'
         +'<button onclick="_visorIr(1)" style="position:fixed;right:16px;top:50%;'
         +'transform:translateY(-50%);background:rgba(255,255,255,.15);color:#fff;'
         +'border:none;border-radius:50%;width:46px;height:46px;font-size:22px;'
         +'cursor:pointer">›</button>') : '')
    +'<button onclick="_visorCerrar()" style="position:fixed;top:14px;right:16px;'
    +'background:rgba(255,255,255,.15);color:#fff;border:none;border-radius:50%;'
    +'width:38px;height:38px;font-size:18px;cursor:pointer">×</button>';
}

function _visorIr(paso){
  var V=window._visor; if(!V) return;
  V.i=(V.i+paso+V.urls.length)%V.urls.length;
  _visorPintar();
}

function _visorCerrar(){
  var ov=document.getElementById('visorImg'); if(ov) ov.remove();
  document.removeEventListener('keydown', _visorTecla);
  window._visor=null;
}

function _visorTecla(e){
  if(!window._visor) return;
  if(e.key==='ArrowRight'){ e.preventDefault(); _visorIr(1); }
  else if(e.key==='ArrowLeft'){ e.preventDefault(); _visorIr(-1); }
  else if(e.key==='Escape'){ _visorCerrar(); }
}

/* La vista previa al pasar el ratón: una copia grande flotando al lado,
   sin abrir nada. */
(function _vistaPreviaMiniaturas(){
  if(window._vpOk) return;
  window._vpOk=true;
  var caja=null;
  document.addEventListener('mouseover', function(e){
    var img=e.target && e.target.closest ? e.target.closest('img.att-img') : null;
    if(!img) return;
    if(!caja){
      caja=document.createElement('div');
      caja.id='attVistaPrevia';
      caja.style.cssText='position:fixed;z-index:12900;pointer-events:none;'
        +'background:var(--surface-0);border:1px solid var(--border);border-radius:10px;'
        +'padding:5px;box-shadow:0 12px 36px rgba(0,0,0,.28);display:none';
      document.body.appendChild(caja);
    }
    var src=img.getAttribute('data-src')||img.src;
    caja.innerHTML='<img src="'+_esc(src)+'" style="max-width:340px;max-height:340px;'
      +'display:block;border-radius:6px">';
    var r=img.getBoundingClientRect();
    var x=Math.min(window.innerWidth-360, r.right+12);
    var y=Math.min(window.innerHeight-360, Math.max(10, r.top-40));
    caja.style.left=x+'px';
    caja.style.top=y+'px';
    caja.style.display='block';
  });
  document.addEventListener('mouseout', function(e){
    var img=e.target && e.target.closest ? e.target.closest('img.att-img') : null;
    if(img && caja) caja.style.display='none';
  });
})();

/* La ventana de «hecho» del booking. La de facturas reserva (_frwPintarOK)
   enseña un número de factura enorme, que aquí no pinta nada. */
function _bkPintarOK(f){
  var c=document.getElementById('frwCaja'); if(!c) return;
  f=f||{};
  c.innerHTML='<div style="width:78px;height:78px;margin:0 auto 14px;border-radius:50%;'
    +'background:var(--pastel-ok);display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-check" style="font-size:46px;color:var(--t-verde)"></i></div>'
    +'<div style="font-size:16px;font-weight:700;color:var(--t-verde)">'
    +'Booking actualizado en SAP</div>'
    +'<div style="font-size:12px;color:var(--text-secondary);margin-top:10px;text-align:left;'
    +'background:var(--surface-1);border-radius:9px;padding:10px 12px;line-height:1.7">'
    +(f.docnum?('<b>Orden '+_esc(f.docnum)+'</b><br>'):'')
    +(f.booking?('Booking: <b>'+_esc(f.booking)+'</b><br>'):'')
    +(f.naviera?('Naviera: <b>'+_esc(f.naviera)+'</b><br>'):'')
    +(f.contenedores?('Contenedores: <b>'+_esc(f.contenedores)+'</b>'
       +(f.tipo_contenedor?(' · '+_esc(f.tipo_contenedor)):'')+'<br>'):'')
    +(f.eta?('ETA: <b>'+_esc(_fechaCorta(f.eta))+'</b><br>'):'')
    +(f.puerto_embarque?('Embarque: '+_esc(f.puerto_embarque)+'<br>'):'')
    +(f.puerto_destino?('Destino: '+_esc(f.puerto_destino)):'')
    +(f.error_msg?('<div style="color:var(--t-marron);margin-top:6px">'
       +_esc(f.error_msg)+'</div>'):'')
    +'</div>'
    +'<button class="btn bp" style="margin-top:14px;width:100%;padding:10px" '
    +'onclick="_frwCerrar()">Listo</button>';
}

/* ── Estado de los precios: enviado a importación y subido a SAP ──────────
   Se guarda en la logística de la orden, así que lo ve cualquiera desde
   cualquier equipo, no solo quien lo hizo. */
function _pvEnviado(oid){
  try{
    var d=_logLeer(oid);
    return (d.precios && d.precios.enviado_impo) || null;
  }catch(e){ return null; }
}
function _pvMarcarEnviado(oid, destinos){
  try{
    var d=_logLeer(oid);
    d.precios=d.precios||{};
    d.precios.enviado_impo={por:(CU&&CU.name)||'', fecha:new Date().toISOString(),
                            para:(destinos||[]).join(', ')};
    _logGuardar(oid);
    _costRefrescarPaneles(oid);
  }catch(e){}
}
function _pvEnSap(oid){
  try{
    var d=_logLeer(oid);
    return (d.precios && d.precios.en_sap) || null;
  }catch(e){ return null; }
}
function _pvMarcarEnSap(oid, cuantos){
  try{
    var d=_logLeer(oid);
    d.precios=d.precios||{};
    d.precios.en_sap={por:(CU&&CU.name)||'', fecha:new Date().toISOString(),
                      articulos:cuantos||0};
    _logGuardar(oid);
    _costRefrescarPaneles(oid);
  }catch(e){}
}

/* ── Del costeo al informe de los vendedores ──────────────────────────────
   Los precios que se acaban de poner tardan unos minutos en estar en SAP,
   porque van por la cola del worker. Para el informe no se espera: se usan
   los que gerencia guardó, que son los buenos. */
/* Todas las entradas de una orden. Una orden puede llegar en dos embarques
   y entonces tiene DOS entradas: hay que costear y poner precios a las dos,
   no solo a la primera. */
async function _pvEntradasDeLaOrden(oid){
  var vistas={}, out=[];
  var meter=function(e){
    if(e && !vistas[e.docentry]){ vistas[e.docentry]=1; out.push(e); }
  };
  // Por el número de entrada anotado en el seguimiento de la orden
  try{
    var dd=_logLeer(oid);
    var num=String((dd.arrival&&dd.arrival.entrada)||'').replace(/[^0-9]/g,'');
    if(num){
      var rn=await fetch(SB+'/rest/v1/opdn_entradas?select=*&num_doc_com=like.*'
        +num+'*&limit=5',{headers:SBH});
      if(rn.ok) (await rn.json()||[]).forEach(meter);
    }
  }catch(e){}
  // Por las líneas, que guardan la orden de origen
  try{
    var rl=await fetch(SB+'/rest/v1/opdn_lineas?select=docentry&orden_num=eq.'+oid
      +'&limit=50',{headers:SBH});
    var ds=[...new Set(((rl.ok?((await rl.json())||[]):[]))
      .map(function(x){ return x.docentry; }).filter(Boolean))];
    for(var k=0;k<ds.length;k++){
      var re=await fetch(SB+'/rest/v1/opdn_entradas?select=*&docentry=eq.'+ds[k],
        {headers:SBH});
      if(re.ok) (await re.json()||[]).forEach(meter);
    }
  }catch(e){}
  try{
    var r=await fetch(SB+'/rest/v1/opdn_entradas?select=*&ordenes=like.*'+oid+'*'
      +'&order=docdate',{headers:SBH});
    if(r.ok) (await r.json()||[]).forEach(meter);
  }catch(e){}
  // Y las que cuelgan de las facturas reserva de esta orden
  try{
    var rf=await fetch(SB+'/rest/v1/opch_reserva?select=docnum&ordenes=like.*'+oid
      +'*&limit=20',{headers:SBH});
    var fs=(rf.ok?((await rf.json())||[]):[]);
    for(var i=0;i<fs.length;i++){
      var nf=String(fs[i].docnum||'');
      if(!nf) continue;
      var re=await fetch(SB+'/rest/v1/opdn_entradas?select=*&facturas=like.*'+nf+'*',
        {headers:SBH});
      if(re.ok) (await re.json()||[]).forEach(meter);
    }
  }catch(e){}
  return out;
}

// Las que ya se trabajaron (costeadas y enviadas), para saber qué falta
function _pvEntradasHechas(oid){
  try{
    var d=_logLeer(oid);
    return ((d.costeo||{}).entradas_hechas)||[];
  }catch(e){ return []; }
}
function _pvMarcarEntradaHecha(oid, docnum){
  try{
    var d=_logLeer(oid);
    d.costeo=d.costeo||{};
    var l=d.costeo.entradas_hechas||[];
    if(l.indexOf(String(docnum))<0) l.push(String(docnum));
    d.costeo.entradas_hechas=l;
    _logGuardar(oid);
  }catch(e){}
}

/* ¿Queda alguna entrada de esta orden sin trabajar? Se avisa al terminar
   con una, que es cuando hace falta saberlo. */
async function _pvAvisarOtraEntrada(oid, hechaDocnum){
  try{
    if(hechaDocnum) _pvMarcarEntradaHecha(oid, hechaDocnum);
    var todas=await _pvEntradasDeLaOrden(oid);
    if(todas.length<2) return;
    var hechas=_pvEntradasHechas(oid);
    var faltan=todas.filter(function(e){ return hechas.indexOf(String(e.docnum))<0; });
    if(!faltan.length){
      showT('✓ Las '+todas.length+' entradas de esta orden ya están trabajadas', 7000);
      return;
    }
    var e=faltan[0];
    if(confirm('Esta orden tiene '+todas.length+' entradas de mercancía y queda '
      +faltan.length+' por trabajar.\n\n'
      + faltan.map(function(x){
          return '· Entrada #'+x.docnum+' · '+_fechaCorta(x.docdate)
            +(x.num_doc_com?(' · '+x.num_doc_com):'')+' · '+_fmtN2(x.total);
        }).join('\n')
      +'\n\n¿Abro la entrada #'+e.docnum+' para seguir con ella?')){
      _enAbrir(e.docentry);
    }
  }catch(err){ _dbg('[PV] otra entrada: '+err); }
}

/* REGLA GENERAL, para no repetir el error: la búsqueda de entradas de una
   orden vive en UN solo sitio, _pvEntradasDeLaOrden, que devuelve TODAS.
   Esta función queda solo por compatibilidad y devuelve la primera de esa
   misma lista: así nunca vuelve a haber dos búsquedas distintas, una
   completa y otra a medias. */
async function _pvEntradaDeLaOrden(oid){
  var todas=await _pvEntradasDeLaOrden(oid);
  if(todas.length) return todas[0];
  return await _pvEntradaDeLaOrdenViejo(oid);
}

// La búsqueda antigua, de respaldo cuando la lista completa no encuentra nada
async function _pvEntradaDeLaOrdenViejo(oid){
  var d=_logLeer(oid);
  var num=String((d.arrival&&d.arrival.entrada)||'').replace(/[^0-9]/g,'');
  // Primero por el número de entrada del seguimiento
  if(num){
    try{
      var r=await fetch(SB+'/rest/v1/opdn_entradas?select=*&num_doc_com=like.*'+num+'*'
        +'&limit=1',{headers:SBH});
      var e=(r.ok?((await r.json())||[]):[])[0];
      if(e) return e;
    }catch(err){}
  }
  // Por la factura reserva que salió de esta orden: la entrada casi siempre
  // cuelga de la factura, no de la orden. Se mira ANTES que lo demás porque
  // es el camino que de verdad usa SAP.
  try{
    var rf0=await fetch(SB+'/rest/v1/opch_reserva?select=docnum&ordenes=like.*'+oid
      +'*&limit=10',{headers:SBH});
    var fs0=(rf0.ok?((await rf0.json())||[]):[]);
    for(var k0=0;k0<fs0.length;k0++){
      var nf0=String(fs0[k0].docnum||'');
      if(!nf0) continue;
      var re0=await fetch(SB+'/rest/v1/opdn_entradas?select=*&facturas=like.*'+nf0
        +'*&limit=1',{headers:SBH});
      var en0=(re0.ok?((await re0.json())||[]):[])[0];
      if(en0) return en0;
    }
  }catch(e){}

  // Y si no, por la orden: la entrada guarda de qué órdenes viene
  try{
    var r2=await fetch(SB+'/rest/v1/opdn_entradas?select=*&ordenes=like.*'+oid+'*&limit=1',
      {headers:SBH});
    var e2=(r2.ok?((await r2.json())||[]):[])[0];
    if(e2) return e2;
  }catch(err){}
  try{
    var r3=await fetch(SB+'/rest/v1/opdn_lineas?select=docentry&orden_num=eq.'+oid+'&limit=1',
      {headers:SBH});
    var l=(r3.ok?((await r3.json())||[]):[])[0];
    if(l){
      var r4=await fetch(SB+'/rest/v1/opdn_entradas?select=*&docentry=eq.'+l.docentry,
        {headers:SBH});
      return (r4.ok?((await r4.json())||[]):[])[0]||null;
    }
  }catch(err){}
  // Y por el camino largo: la entrada suele colgar de la FACTURA RESERVA, no
  // de la orden. Se buscan las facturas de esta orden y luego la entrada de
  // esas facturas.
  try{
    var rf=await fetch(SB+'/rest/v1/opch_reserva?select=docnum,ordenes'
      +'&ordenes=like.*'+oid+'*&limit=10',{headers:SBH});
    var fs=(rf.ok?((await rf.json())||[]):[]);
    for(var i=0;i<fs.length;i++){
      var nf=String(fs[i].docnum||'');
      if(!nf) continue;
      var re=await fetch(SB+'/rest/v1/opdn_entradas?select=*&facturas=like.*'+nf+'*&limit=1',
        {headers:SBH});
      var en=(re.ok?((await re.json())||[]):[])[0];
      if(en) return en;
      var rl=await fetch(SB+'/rest/v1/opdn_lineas?select=docentry&factura_num=eq.'+nf
        +'&limit=1',{headers:SBH});
      var ln=(rl.ok?((await rl.json())||[]):[])[0];
      if(ln){
        var re2=await fetch(SB+'/rest/v1/opdn_entradas?select=*&docentry=eq.'+ln.docentry,
          {headers:SBH});
        var en2=(re2.ok?((await re2.json())||[]):[])[0];
        if(en2) return en2;
      }
    }
  }catch(err){}
  return null;
}

// Prepara la entrada con los precios NUEVOS y deja todo listo para el informe
async function _pvPrepararInforme(oid){
  window._pvPreciosInforme={};     // se arma para ESTA orden, no se arrastra
  // TODAS las entradas de la orden, no solo la primera. Una orden puede
  // llegar en varios embarques (217/26-A, -B y -C) y el informe tiene que
  // llevar lo mismo que se acaba de costear, no un trozo.
  var ents=await _pvEntradasDeLaOrden(oid);
  if(!ents.length){
    var una=await _pvEntradaDeLaOrdenViejo(oid);
    if(una) ents=[una];
  }
  if(!ents.length){
    // Sin entrada localizada, el informe se arma con el COSTEO, que trae lo
    // mismo: referencia, descripción, cantidad y precio.
    return _pvInformeDesdeCosteo(oid);
  }

  // Las líneas de TODAS las entradas: sirven para completar cada artículo
  // con lo que solo está ahí (composición, colores, tamaños, código de
  // barras, empaque).
  var lineas=[], porItem={};
  for(var i=0;i<ents.length;i++){
    try{
      var r=await fetch(SB+'/rest/v1/opdn_lineas?select=*&docentry=eq.'
        +ents[i].docentry+'&order=linenum',{headers:SBH});
      ((r.ok?((await r.json())||[]):[])).forEach(function(l){
        l._entrada=ents[i].num_doc_com || ents[i].docnum;   // de cuál viene
        lineas.push(l);
        var c=String(l.itemcode||'').trim();
        if(c && !porItem[c]) porItem[c]=l;
      });
    }catch(err){}
  }

  /* EL INFORME SALE DEL COSTEO, no de la entrada. Es lo que se acaba de
     revisar y poner precio; la entrada puede tener otras referencias (llegó
     en varios embarques) y entonces el PDF no coincidía con lo editado. De
     la entrada se toman solo los datos de ficha de cada artículo. */
  try{
    var rc=_pvDatos(oid);
    var base=rc && rc.base;
    if(base && (base.lineas||[]).length){
      var edit=_pvEditados(rc.d, base);
      var delCosteo=base.lineas.map(function(l,ix){
        var ref=String(l.referencia||'').trim();
        var e=porItem[ref]||{};
        return Object.assign({}, e, {
          linenum:ix,
          itemcode:ref,
          dscription:l.descripcion || e.dscription || '',
          descripcion:l.descripcion || e.descripcion || '',
          cantidad:Number(l.cantidad)||Number(e.cantidad)||0,
          quantity:Number(l.cantidad)||Number(e.quantity)||0,
          precio:Number(l.cif_unit)||Number(e.precio)||0,
          total_linea:(Number(l.cantidad)||0)*(Number(l.cif_unit)||0),
          picturname:l.foto || e.picturname || '',
          _entrada:e._entrada || (ents[0]&&(ents[0].num_doc_com||ents[0].docnum)) || ''
        });
      });
      if(delCosteo.length){
        lineas=delCosteo;
        // Y los precios: los editados mandan; si falta alguno, el del costeo
        window._pvPreciosInforme={};
        base.lineas.forEach(function(l){
          var ref=String(l.referencia||'').trim();
          var p=Number(edit[ref]);
          if(!(p>0)) p=Number(l.precio_venta)||0;
          if(ref && p>0) window._pvPreciosInforme[ref]=p;
        });
      }
    }
  }catch(err){ _dbg('[INF] costeo: '+err); }

  // La cabecera, con las entradas juntas
  var e=Object.assign({}, ents[0]);
  if(ents.length>1){
    e.num_doc_com=ents.map(function(x){ return x.num_doc_com||('#'+x.docnum); })
                      .filter(Boolean).join(' · ');
    e.docnum=ents.map(function(x){ return x.docnum; }).join(', ');
    e.total=ents.reduce(function(a,x){ return a+(Number(x.total)||0); },0);
    e._varias=ents.length;
  }

  window._en=window._en||{lista:[], q:''};
  window._en.abierta=e;
  window._en.lineas=lineas;
  window._en.entradas=ents;
  if(ents.length>1){
    showT('El informe lleva las '+ents.length+' entradas de esta orden: '
      +e.num_doc_com, 8000);
  }

  // Los precios recién guardados mandan sobre los de SAP, que aún no están
  var pv={};
  try{
    var d=_logLeer(oid);
    var val=(d.precios&&d.precios.valores)||{};
    Object.keys(val).forEach(function(ref){ pv[ref]=Number(val[ref])||0; });
  }catch(err){}
  // Y lo que falte, del inventario
  try{
    var codigos=[...new Set(lineas.map(function(l){ return String(l.itemcode||'').trim(); })
                   .filter(function(c){ return c && !(pv[c]>0); }))];
    for(var i=0;i<codigos.length;i+=60){
      var lote=codigos.slice(i,i+60).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var rp=await fetch(SB+'/rest/v1/inventario?select=itemcode,precioventa&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      if(rp.ok) (await rp.json()||[]).forEach(function(x){
        pv[String(x.itemcode)]=Number(x.precioventa)||0; });
    }
  }catch(err){}
  // Los precios del COSTEO mandan sobre todo lo demás: son los que se acaban
  // de revisar y guardar.
  try{
    Object.keys(window._pvPreciosInforme||{}).forEach(function(k){
      pv[k]=window._pvPreciosInforme[k];
    });
  }catch(e){}
  window._en.pv=pv;
  window._en.preciosNuevos=true;
  return true;
}

async function _pvVerInforme(oid){
  showT('Preparando el informe con los precios nuevos…');
  if(!(await _pvPrepararInforme(oid))) return;
  _enPDF();
}

async function _pvEnviarVendedores(oid){
  window._pvInformeOid=String(oid);   // para marcar la orden al enviar
  showT('Preparando el informe…');
  if(!(await _pvPrepararInforme(oid))) return;
  _enMailModal();
}

/* Las entradas de mercancía dentro del mapa de la orden, como en SAP:
   orden → factura reserva → ENTRADA. Se puede pulsar para abrirla. */
/* Las entradas, encadenadas como en el mapa de SAP: factura reserva →
   ENTRADA, con su flecha. Se pulsa y se abre la entrada, igual que la
   factura. */
function _mrEntradasHtml(dn){
  var ents=((window._mrEntradas||{})[dn])||[];
  if(!ents.length) return '';
  return '<div style="margin-top:10px;border-top:0.5px dashed var(--border);'
    +'padding-top:9px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-verde);margin-bottom:6px">'
    +'<i class="ti ti-truck-loading"></i> Entrada(s) de mercancía</div>'
    +'<div style="display:flex;flex-direction:column;gap:8px">'
    + ents.map(function(e){
        var deFac=String(e.facturas||'').replace(/[^0-9,# ]/g,'').trim();
        var origen=_mrCaja('Factura reserva','#D9E4F5',
            (deFac?('<b>'+_esc(deFac)+'</b>'):'<span style="opacity:.6">de la orden</span>')
            +'<br>'+_esc(String(e.cardname||'').slice(0,26)),
            'cursor:default');
        var caja='<div onclick="_enAbrir('+e.docentry+')" '
          +'title="Abrir la entrada y su informe de recepción" '
          +'style="cursor:pointer">'
          + _mrCaja('Entrada de mercancía','#D7EDC9',
              '<b style="font-size:13px">#'+_esc(e.docnum)+'</b><br>'
              +_esc(_fechaCorta(e.docdate))
              +(e.num_doc_com?('<br>'+_esc(e.num_doc_com)):'')
              +'<br><b>'+_fmtN2(e.total)+'</b>'
              +'<br><span style="font-size:10px;color:var(--t-verde)">'
              +'<i class="ti ti-external-link"></i> ver</span>',
              'border-color:#3E8F3E')
          +'</div>';
        return '<div style="display:flex;align-items:center;gap:0;flex-wrap:wrap">'
          + origen + _mrFlecha() + caja + '</div>';
      }).join('')
    +'</div></div>';
}

// Una flecha como las del mapa de arriba, para encadenar las cajas
function _mrFlecha(){
  return '<svg width="34" height="16" style="flex-shrink:0;display:block">'
    +'<defs><marker id="mrP2" viewBox="0 0 10 10" refX="9" refY="5" '
    +'markerWidth="7" markerHeight="7" orient="auto-start-reverse">'
    +'<path d="M 0 0 L 10 5 L 0 10 z" fill="#6B8FD6"></path></marker></defs>'
    +'<line x1="0" y1="8" x2="30" y2="8" stroke="#6B8FD6" stroke-width="2" '
    +'marker-end="url(#mrP2)"></line></svg>';
}

/* Constancia de los envíos del informe de entrada: quién y cuándo. Se guarda
   en la propia entrada, así que lo ve todo el mundo, y el botón se pinta de
   verde en el acto, sin recargar. */
function _enEnviado(docentry){
  try{
    var m=JSON.parse(localStorage.getItem('entrada_enviada')||'{}');
    var l=(window._enEnviados||{})[String(docentry)];
    return l || m[String(docentry)] || null;
  }catch(e){ return null; }
}

async function _enMarcarEnviado(docentry, destinos){
  var info={por:(CU&&CU.name)||'', fecha:new Date().toISOString(),
            para:(destinos||[]).join(', ')};
  window._enEnviados=window._enEnviados||{};
  window._enEnviados[String(docentry)]=info;
  try{
    var m=JSON.parse(localStorage.getItem('entrada_enviada')||'{}');
    m[String(docentry)]=info;
    localStorage.setItem('entrada_enviada', JSON.stringify(m));
  }catch(e){}
  // Y en la base, para que lo vean los demás
  try{
    await fetch(SB+'/rest/v1/opdn_entradas?docentry=eq.'+docentry,{
      method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({enviado_vendedores:info})});
  }catch(e){}
  // Repintado inmediato del detalle
  try{ _enDetPintar(); }catch(e){}
}

/* El envío a vendedores visto desde el costeo: la orden se acuerda de que ya
   se mandó, aunque el informe saliera desde la entrada. */
function _pvVendEnviado(oid){
  try{
    var d=_logLeer(oid);
    if(d.precios && d.precios.enviado_vend) return d.precios.enviado_vend;
  }catch(e){}
  return null;
}

// Cuando se manda desde el costeo, queda marcado en la orden también
(function _pvEngancharEnvioVendedores(){
  var original=window._enMarcarEnviado;
  window._enMarcarEnviado=async function(docentry, destinos){
    if(typeof original==='function') await original(docentry, destinos);
    try{
      var oid=window._pvInformeOid;
      if(oid){
        var d=_logLeer(oid);
        d.precios=d.precios||{};
        d.precios.enviado_vend={por:(CU&&CU.name)||'', fecha:new Date().toISOString(),
                                para:(destinos||[]).join(', ')};
        _logGuardar(oid);
        _costRefrescarPaneles(oid);
        // ¿Hay otra entrada de esta misma orden sin trabajar?
        // Si el informe llevaba varias entradas, todas quedan hechas
        var _ents=(window._en&&window._en.entradas)||[];
        if(_ents.length>1){
          _ents.forEach(function(x){ _pvMarcarEntradaHecha(oid, x.docnum); });
        } else {
          var _en=(window._en&&window._en.abierta)||{};
          setTimeout(function(){ _pvAvisarOtraEntrada(oid, _en.docnum); }, 1500);
        }
      }
    }catch(e){}
  };
})();

/* Vaciar un paso de artes de una vez: diseño rehace los artes y tiene que
   quitar los anteriores sin ir uno por uno. */
async function _artesBorrarTodos(oid, sk){
  var l=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  if(!l.length) return;
  if(!confirm('¿Eliminar los '+l.length+' archivos de este paso?\n\n'
    + l.slice(0,8).map(function(a){ return '· '+(a.name||''); }).join('\n')
    + (l.length>8?('\n· … y '+(l.length-8)+' más'):'')
    + '\n\nNo se puede deshacer.')) return;
  showT('Eliminando '+l.length+' archivo(s)…');
  // De atrás hacia delante: al borrar cambian las posiciones
  for(var i=l.length-1;i>=0;i--){
    try{ await delAtt(oid, sk, i, true); }catch(e){}
  }
  try{ _redibujarPaso(oid, sk); }catch(e){}
  showT('✓ Paso vaciado · ya puedes subir los artes nuevos');
}

/* Los precios de venta de la entrada, leídos DIRECTAMENTE de SAP.
   La copia del inventario del portal se refresca cada cierto tiempo, así que
   un precio puesto en SAP hace un rato todavía no está ahí. Esto lo pide al
   worker, que lo lee de la lista 3 y lo devuelve en el momento. */
async function _enPreciosDeSap(){
  var S=window._en;
  if(!S || !S.abierta || !(S.lineas||[]).length){ showT('Abre una entrada primero'); return; }
  var codigos=[...new Set(S.lineas.map(function(l){ return String(l.itemcode||'').trim(); })
                 .filter(Boolean))];
  if(!codigos.length) return;

  showT('Pidiendo los precios a SAP…');
  try{
    var r=await _postTolerante(SB+'/rest/v1/items_lectura_queue',
      {codigos:codigos, estado:'pendiente', creado_por:(CU&&CU.name)||''});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre items_sap.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,120));
    }
    var reg=((await r.json())||[])[0];
    if(!reg || !reg.id) throw new Error('no pude encolar la lectura');

    var q=null;
    for(var i=0;i<40;i++){
      await new Promise(function(res){ setTimeout(res, 2000); });
      var rq=await fetch(SB+'/rest/v1/items_lectura_queue?select=*&id=eq.'+reg.id,
        {headers:SBH});
      q=rq.ok ? ((await rq.json())||[])[0] : null;
      if(q && (q.estado==='hecha' || q.estado==='error')) break;
    }
    if(!q || q.estado!=='hecha'){
      showT((q&&q.error_msg) ? ('SAP: '+q.error_msg)
        : 'El worker no respondió; se quedan los precios que había', 8000);
      return;
    }

    S.pv=S.pv||{};
    var n=0, sin=0;
    (q.resultado||[]).forEach(function(x){
      var code=String(x.itemcode||'').trim();
      var pv=Number(x.precio_venta || (x.udf||{}).precio_venta || 0);
      if(code && pv>0){ S.pv[code]=pv; n++; } else if(code) sin++;
    });
    S.preciosNuevos=true;
    _enDetPintar();
    showT('✓ '+n+' precio(s) traídos de SAP'+(sin?(' · '+sin+' siguen sin precio'):''), 8000);
  }catch(e){
    showT('No pude traer los precios: '+(e.message||e), 9000);
  }
}

/* Abre TODAS las imágenes de un paso en el visor, una detrás de otra: se
   pasa con las flechas y no hay que abrir y cerrar cada adjunto. */
function _visorTodas(oid, sk){
  var l=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var imgs=l.filter(function(a){
    return ['jpg','jpeg','png','gif','webp'].indexOf(
      (String(a.name||'').split('.').pop()||'').toLowerCase())>=0; });
  if(!imgs.length){ showT('No hay imágenes en este paso'); return; }
  window._visor={urls:imgs.map(function(a){
                   return {src:a.data, nombre:a.name||''}; }), i:0};
  _visorPintar();
}

/* Ver o descargar un adjunto ANTES de mandar el correo. Lo que va a salir
   hay que poder mirarlo: un PDF mal generado no se descubre en el buzón del
   proveedor. */
function _mailAdjBlob(a){
  var b64=String(a.contenido||'');
  var bin=atob(b64);
  var bytes=new Uint8Array(bin.length);
  for(var i=0;i<bin.length;i++) bytes[i]=bin.charCodeAt(i);
  return new Blob([bytes], {type:a.mime||'application/octet-stream'});
}

function mailVerAdj(i){
  var a=(window._mailAdj||[])[i];
  if(!a){ return; }
  try{
    var url=URL.createObjectURL(_mailAdjBlob(a));
    var w=window.open(url,'_blank');
    if(!w) showT('El navegador bloqueó la ventana: usa el botón de descargar');
    setTimeout(function(){ URL.revokeObjectURL(url); }, 60000);
  }catch(e){ showT('No pude abrirlo: '+(e.message||e)); }
}

function mailBajarAdj(i){
  var a=(window._mailAdj||[])[i];
  if(!a){ return; }
  try{
    var url=URL.createObjectURL(_mailAdjBlob(a));
    var el=document.createElement('a');
    el.href=url; el.download=a.nombre||'adjunto';
    document.body.appendChild(el); el.click(); el.remove();
    setTimeout(function(){ URL.revokeObjectURL(url); }, 30000);
  }catch(e){ showT('No pude descargarlo: '+(e.message||e)); }
}

/* Los artes que van al proveedor: los que gerencia aprobó y, si ese paso
   está vacío porque se aprobaron sin volver a subirlos, los de «Artes
   terminados». Sin repetir el mismo archivo dos veces. */
function _artesParaProveedor(oid){
  var out=[], vistos={};
  [_PASO_ARTES_APROB, _PASO_ARTES_FIN].forEach(function(paso){
    try{
      _artesArchivos(oid, paso).forEach(function(a){
        var k=String(a.name||a.url||'').toLowerCase();
        if(!k || vistos[k]) return;
        vistos[k]=1;
        out.push(a);
      });
    }catch(e){}
  });
  return out;
}

/* Los precios de venta que ya están en SAP, leídos del propio SAP.
   La copia del inventario del portal se refresca con el Sync, así que un
   precio puesto hace un rato todavía no aparece y la columna sale vacía
   aunque en SAP exista. Esto lo pregunta al worker y lo pone al momento. */
async function _pvPreciosDeSap(oid){
  var r0=_pvDatos(oid);
  var base=r0&&r0.base;
  if(!base || !(base.lineas||[]).length){ showT('No hay costeo cargado'); return; }
  var codigos=[...new Set(base.lineas.map(function(l){
    return String(l.referencia||'').trim(); }).filter(Boolean))];
  if(!codigos.length) return;

  showT('Pidiendo los precios a SAP · '+codigos.length+' artículo(s)…');
  try{
    var r=await _postTolerante(SB+'/rest/v1/items_lectura_queue',
      {codigos:codigos, estado:'pendiente', creado_por:(CU&&CU.name)||''});
    if(!r.ok){
      var t=await r.text();
      if(t.indexOf('does not exist')>=0)
        throw new Error('falta la tabla: corre items_sap.sql en Supabase');
      throw new Error(r.status+' '+t.slice(0,120));
    }
    var reg=((await r.json())||[])[0];
    if(!reg || !reg.id) throw new Error('no pude encolar la lectura');

    var q=null;
    for(var i=0;i<45;i++){
      await new Promise(function(res){ setTimeout(res, 2000); });
      var rq=await fetch(SB+'/rest/v1/items_lectura_queue?select=*&id=eq.'+reg.id,
        {headers:SBH});
      q=rq.ok ? ((await rq.json())||[])[0] : null;
      if(q && (q.estado==='hecha' || q.estado==='error')) break;
    }
    if(!q || q.estado!=='hecha'){
      showT((q&&q.error_msg) ? ('SAP: '+q.error_msg)
        : 'El worker no respondió a tiempo', 8000);
      return;
    }

    // Se meten como precio ACTUAL de cada línea, no como cambio
    var mapa={};
    (q.resultado||[]).forEach(function(x){
      var c=String(x.itemcode||'').trim();
      var pv=Number(x.precio_venta || (x.udf||{}).precio_venta || 0);
      if(c && pv>0) mapa[c]=pv;
    });
    var n=0;
    base.lineas.forEach(function(l){
      var p=mapa[String(l.referencia||'').trim()];
      if(p>0){
        l.precio_venta=p;
        var cif=Number(l.cif_unit)||0;
        l.margen=p?Number((((p-cif)/p)*100).toFixed(4)):0;
        n++;
      }
    });
    // Se guarda el costeo con esos precios y se repinta la pantalla
    try{
      window._costDatos=window._costDatos||{};
      window._costDatos[oid]=base;
    }catch(e){}
    _pvCerrar(oid);
    await _pvAbrir(oid);
    showT('✓ '+n+' precio(s) traídos de SAP'
      +((codigos.length-n)?(' · '+(codigos.length-n)+' siguen sin precio'):''), 8000);
  }catch(e){
    showT('No pude traer los precios: '+(e.message||e), 9000);
  }
}

/* El informe a partir del COSTEO, cuando la entrada no aparece en el portal.
   Lleva lo mismo que el de la entrada: referencia, descripción, cantidad y
   el precio de venta recién puesto. Así nunca se queda nadie sin poder
   mandárselo a los vendedores. */
function _pvInformeDesdeCosteo(oid){
  var r0=_pvDatos(oid);
  var base=r0&&r0.base;
  if(!base || !(base.lineas||[]).length){
    alert('No encuentro ni la entrada de mercancía ni el costeo de esta orden.\n\n'
      +'Genera primero el costeo de importación.');
    return false;
  }
  var o=(orders||[]).find(function(x){ return String(x.id)===String(oid); })||{};
  var pv={};
  base.lineas.forEach(function(l){
    var p=Number(l.precio_venta)||0;
    if(p>0) pv[String(l.referencia||'').trim()]=p;
  });

  window._en=window._en||{lista:[], q:''};
  window._en.abierta={
    docentry:0,
    docnum:String(base.entrada||base.num_doc_com||oid),
    docdate:_hoyISO(),
    cardname:o.prov||base.proveedor||'',
    cardcode:o.cardcode||'',
    num_doc_com:base.entrada||'',
    ordenes:'#'+oid,
    total:base.total_cif||0,
    _delCosteo:true
  };
  window._en.lineas=base.lineas.map(function(l,i){
    return {
      linenum:i,
      itemcode:String(l.referencia||''),
      dscription:l.descripcion||'',
      descripcion:l.descripcion||'',
      cantidad:Number(l.cantidad)||0,
      quantity:Number(l.cantidad)||0,
      precio:Number(l.cif_unit)||0,
      total_linea:(Number(l.cantidad)||0)*(Number(l.cif_unit)||0),
      picturname:l.foto||'',
      composicion:l.composicion||'', colores:l.colores||'',
      tam_bulto:l.tam_bulto||'', tam_pza:l.tam_pza||'',
      pzs_bulto:l.pzs_bulto||'', peso:l.peso||'', cubicaje:l.cubicaje||''
    };
  });
  window._en.pv=pv;
  window._en.preciosNuevos=true;
  showT('La entrada no está en el portal: el informe se arma con el costeo', 7000);
  return true;
}

/* ═══════════════════════════════════════════════════════════════════════════
   BANCO · MOVIMIENTOS DE BANISTMO   (prefijo [BK])
   ───────────────────────────────────────────────────────────────────────────
   Lo que el banco deja cada día en su SFTP, ya leído por el worker. Aquí se
   ve, se filtra y, sobre todo, se CONCILIA: cada cargo se ata a la orden o a
   la solicitud de pago que lo originó, que es para lo que sirve de verdad.
   ═══════════════════════════════════════════════════════════════════════════ */
/* Quién puede ver cosas de dinero del banco: contabilidad y la gerencia
   GENERAL. Henry (ropa) y Gady (alfombras) tienen rol gerencia pero llevan
   su área, no la empresa, así que quedan fuera. Es la misma regla que ya
   usan Saldos bancarios y Conciliación bancaria: _bkPuede(). */
function _bncPuede(){
  try{ return _bkPuede(); }catch(e){ return false; }
}

async function _bncAbrir(){
  if(!_bncPuede()){ showT('Esto es de contabilidad y gerencia'); return; }
  // El contenedor se crea al vuelo: así no hay que tocar la plantilla de
  // Shopify para añadir una pantalla nueva.
  if(!document.getElementById('page-banco')){
    var ref=document.getElementById('page-alertas') || document.querySelector('.page');
    if(ref && ref.parentNode){
      var d=document.createElement('div');
      d.id='page-banco'; d.className='page';
      ref.parentNode.appendChild(d);
    }
  }
  window._bnc=window._bnc||{lista:[], q:'', filtro:'todos', desde:'', hasta:'',
                            cargado:false};
  go('banco');
  _bncPintar();
  if(!window._bnc.cargado) await _bncCargar();
}

async function _bncCargar(){
  var S=window._bnc;
  S.cargando=true; _bncPintar();
  try{
    var hoy=new Date(), hace=new Date(hoy.getTime()-90*86400000);
    var desde=S.desde || hace.toISOString().slice(0,10);
    var r=await fetch(SB+'/rest/v1/banco_movimientos?select=*&fecha=gte.'+desde
      +'&order=fecha.desc,id.desc&limit=2000',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      S.error=(t.indexOf('does not exist')>=0)
        ? 'Falta la tabla: corre banco_movimientos.sql en Supabase.'
        : (r.status+' '+t.slice(0,120));
      S.lista=[];
    } else {
      S.lista=(await r.json())||[];
      S.error='';
    }
  }catch(e){ S.error=String(e.message||e); S.lista=[]; }
  // v750: el saldo del día de cada cuenta según el banco (swiftState)
  try{
    var rs=await fetch(SB+'/rest/v1/banco_saldos?select=*&order=fecha.desc&limit=300',{headers:SBH});
    S.saldos={};
    if(rs.ok) ((await rs.json())||[]).forEach(function(x){
      var k=String(x.cuenta); (S.saldos[k]=S.saldos[k]||[]).push(x); });
  }catch(e){}
  // Los nombres que se le hayan puesto a cada cuenta
  try{
    var ra=await fetch(SB+'/rest/v1/banco_cuentas?select=cuenta,alias,banco,moneda',
      {headers:SBH});
    if(ra.ok){
      S.alias={}; S.bancoDe={};
      (await ra.json()||[]).forEach(function(x){
        if(x.alias) S.alias[String(x.cuenta)]=x.alias;
        S.bancoDe[String(x.cuenta)]=x.banco||'Banistmo';
      });
    }
  }catch(e){}
  S.cargando=false; S.cargado=true;
  _bncPintar();
}

function _bncVisibles(){
  var S=window._bnc||{}, q=String(S.q||'').toLowerCase().trim();
  var L=(S.lista||[]).slice();
  // Por banco y por cuenta: lo primero que se mira al abrir
  if(S.banco && S.banco!=='todos')
    L=L.filter(function(m){ return String(m.banco||'Banistmo')===S.banco; });
  if(S.cuenta && S.cuenta!=='todas')
    L=L.filter(function(m){ return String(m.cuenta||'')===S.cuenta; });
  if(S.filtro==='cargos')     L=L.filter(function(m){ return Number(m.monto)<0; });
  if(S.filtro==='abonos')     L=L.filter(function(m){ return Number(m.monto)>0; });
  if(S.filtro==='ach')        L=L.filter(_bncEsAch);
  if(S.filtro==='sin')        L=L.filter(function(m){ return !m.conciliado; });
  if(S.filtro==='conciliados')L=L.filter(function(m){ return !!m.conciliado; });
  if(S.hasta) L=L.filter(function(m){ return String(m.fecha||'')<=S.hasta; });
  if(q){
    L=L.filter(function(m){
      return [m.concepto, m.referencia, m.docnum, m.cuenta, m.codigo, m.nota]
        .map(function(v){ return String(v||'').toLowerCase(); })
        .some(function(v){ return v.indexOf(q)>=0; })
        || String(Math.abs(Number(m.monto)||0)).indexOf(q)>=0;
    });
  }
  return L;
}

/* ── Banistmo (v750) ─────────────────────────────────────────────────────
   Los movimientos salen del CSV diario de reports/movementFormat. De
   reports/swiftState (extracto MT940) se toman el saldo de apertura y cierre
   de cada cuenta: la tarjeta de la cuenta lo enseña y dice si lo que hay en
   el portal cuadra con el banco. Los ACH enviados son las salidas con «ACH»
   en el concepto. Los cobros con tarjeta (reports/remissions) van aparte. */
function _bncEsAch(m){ return Number(m.monto)<0 && /\bACH\b/i.test(String(m.concepto||'')); }

function _bncSaldoHtml(cta, ms){
  var S=window._bnc||{}, L=(S.saldos||{})[String(cta)]||[];
  if(!L.length) return '';
  var x=L[0];                                    // el día más reciente
  var delDia=ms.filter(function(m){ return String(m.fecha||'')===String(x.fecha); });
  var ent=delDia.filter(function(m){ return Number(m.monto)>0; }).reduce(function(a,m){ return a+Number(m.monto); },0);
  var sal=delDia.filter(function(m){ return Number(m.monto)<0; }).reduce(function(a,m){ return a-Number(m.monto); },0);
  var cuadra=Math.abs(ent-Number(x.entradas||0))<0.01 && Math.abs(sal-Number(x.salidas||0))<0.01;
  var cargado=delDia.length>0 || !Number(x.movimientos);
  return '<div style="margin-top:6px;padding-top:5px;border-top:0.5px dashed var(--border);font-size:10.5px">'
    +'<div>Saldo banco al '+_esc(String(x.fecha).split('-').reverse().join('/'))+': <b style="color:'
    +(Number(x.saldo_final)<0?'#991B1B':'#166534')+'">'+fmt(Number(x.saldo_final)||0)+'</b></div>'
    +'<div style="color:var(--text-muted)">Abrió en '+fmt(Number(x.saldo_inicial)||0)+'</div>'
    +(cargado ? (cuadra
        ? '<div style="color:#166534;font-weight:700"><i class="ti ti-circle-check"></i> Cuadra con el banco</div>'
        : ('<div style="color:#B45309;font-weight:700" title="Banco: +'+fmt(Number(x.entradas||0))+' −'+fmt(Number(x.salidas||0))
           +' · Portal: +'+fmt(ent)+' −'+fmt(sal)+'"><i class="ti ti-alert-triangle"></i> No cuadra con el banco</div>'))
      : '<div style="color:var(--text-muted)">Movimientos del día aún sin cargar</div>')
    +'</div>';
}

// Los cobros con tarjeta (reports/remissions) · v751: filtros de fecha y
// tarjeta, columnas ordenables con flechitas y descarga en Excel
var BNC_REM_COLS=[['fecha','Fecha'],['hora','Hora'],['fecha_liquidacion','Liquidado'],['tarjeta','Tarjeta'],
  ['tipo_tarjeta','Tipo'],['autorizacion','Autorización'],['terminal','Terminal'],['lote','Lote'],
  ['venta','Venta',1],['comision','Comisión',1],['itbms','ITBMS',1],['neto','Neto',1]];

async function _bncRemisiones(){
  var prev=document.getElementById('bncRemOv'); if(prev) prev.remove();
  var hoy=new Date(), loc=new Date(hoy.getTime()-hoy.getTimezoneOffset()*60000);
  var S=window._bncRemS=window._bncRemS||{
    desde:new Date(loc.getTime()-30*86400000).toISOString().slice(0,10), hasta:loc.toISOString().slice(0,10),
    tipo:'todas', q:'', ord:{col:'fecha', dir:'desc'}};
  var ov=document.createElement('div'); ov.id='bncRemOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10070;display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow:auto';
  ov.onclick=function(e){ if(e.target===ov) ov.remove(); };
  var est='padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12px;background:var(--surface-2);color:var(--text-primary)';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:1150px;width:100%;padding:16px 18px">'
    +'<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;flex-wrap:wrap">'
    +'<i class="ti ti-credit-card" style="font-size:22px;color:#6D28D9"></i>'
    +'<div style="flex:1;min-width:220px"><div style="font-size:15px;font-weight:700">Cobros con tarjeta</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Remisiones de Banistmo: cada venta con tarjeta, con su comisión e ITBMS</div></div>'
    +'<button class="btn bp" style="background:#166534" onclick="_bncRemExcel()"><i class="ti ti-file-spreadsheet"></i> Descargar Excel</button>'
    +'<button class="xb" onclick="document.getElementById(\'bncRemOv\').remove()"><i class="ti ti-x"></i></button></div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    +'<span style="font-size:11.5px;color:var(--text-muted)">Del</span>'
    +'<input type="date" value="'+_esc(S.desde)+'" onchange="window._bncRemS.desde=this.value;_bncRemCargar()" style="'+est+'">'
    +'<span style="font-size:11.5px;color:var(--text-muted)">al</span>'
    +'<input type="date" value="'+_esc(S.hasta)+'" onchange="window._bncRemS.hasta=this.value;_bncRemCargar()" style="'+est+'">'
    +'<select id="bncRemTipo" onchange="window._bncRemS.tipo=this.value;_bncRemPintar()" style="'+est+'"></select>'
    +'<input id="bncRemQ" value="'+_esc(S.q||'')+'" placeholder="Buscar tarjeta (últimos 4), autorización, terminal, monto…" '
    +'oninput="window._bncRemS.q=this.value;_bncRemPintar()" style="'+est+';flex:1;min-width:240px"></div>'
    +'<div id="bncRemCuerpo"><span class="ai-ring g"></span> Cargando…</div></div>';
  document.body.appendChild(ov);
  await _bncRemCargar();
}

async function _bncRemCargar(){
  var S=window._bncRemS, c=document.getElementById('bncRemCuerpo'); if(!S||!c) return;
  if(S.desde && S.hasta && S.desde>S.hasta){ var t=S.desde; S.desde=S.hasta; S.hasta=t; }
  c.innerHTML='<span class="ai-ring g"></span> Cargando…';
  try{
    var u=SB+'/rest/v1/banco_remisiones?select=*&order=fecha.desc,hora.desc&limit=10000';
    if(S.desde) u+='&fecha=gte.'+S.desde;
    if(S.hasta) u+='&fecha=lte.'+S.hasta;
    var r=await fetch(u,{headers:SBH});
    if(!r.ok){ var tx=await r.text(); throw new Error(/exist|find/i.test(tx)?'falta correr v750_banco.sql en Supabase':('remisiones: '+r.status)); }
    window._bncRem=(await r.json())||[];
    // Los tipos de tarjeta que hay, para el filtro
    var tipos=[...new Set(window._bncRem.map(function(x){ return String(x.tipo_tarjeta||'').trim(); }).filter(Boolean))].sort();
    var sel=document.getElementById('bncRemTipo');
    if(sel) sel.innerHTML='<option value="todas">Todas las tarjetas</option>'+tipos.map(function(t){
      return '<option value="'+_esc(t)+'"'+(S.tipo===t?' selected':'')+'>'+_esc(t)+'</option>'; }).join('');
    if(S.tipo!=='todas' && tipos.indexOf(S.tipo)<0) S.tipo='todas';
    _bncRemPintar();
  }catch(e){ c.innerHTML='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo)">'+_esc(e.message||String(e))+'</div>'; }
}

// Lo que se ve: con los filtros y el orden elegidos (lo mismo va al Excel)
function _bncRemVisibles(){
  var S=window._bncRemS||{}, q=String(S.q||'').toLowerCase().trim();
  var L=(window._bncRem||[]).map(function(x){ return Object.assign({}, x, {neto:(Number(x.venta)||0)-(Number(x.comision)||0)}); });
  if(S.tipo && S.tipo!=='todas') L=L.filter(function(x){ return String(x.tipo_tarjeta||'').trim()===S.tipo; });
  if(q) L=L.filter(function(x){
    return [x.tarjeta,x.autorizacion,x.terminal,x.lote,x.tipo_tarjeta,Number(x.venta||0).toFixed(2)].join(' ').toLowerCase().indexOf(q)>=0; });
  var o=S.ord||{col:'fecha',dir:'desc'}, sg=o.dir==='asc'?1:-1;
  var num={venta:1,comision:1,itbms:1,neto:1};
  L.sort(function(a,b){
    var x=a[o.col], y=b[o.col];
    if(num[o.col]) return ((Number(x)||0)-(Number(y)||0))*sg;
    var r=String(x==null?'':x).localeCompare(String(y==null?'':y),'es',{numeric:true});
    if(!r && o.col==='fecha') r=String(a.hora||'').localeCompare(String(b.hora||''));
    return r*sg;
  });
  return L;
}
function _bncRemOrdenar(col){
  var S=window._bncRemS, o=S.ord||{};
  S.ord={col:col, dir:(o.col===col && o.dir==='desc')?'asc':'desc'};
  _bncRemPintar();
}

function _bncRemPintar(){
  var c=document.getElementById('bncRemCuerpo'); if(!c) return;
  var S=window._bncRemS||{}, L=_bncRemVisibles();
  var sum=function(k){ return L.reduce(function(a,x){ return a+(Number(x[k])||0); },0); };
  var porDia={}; L.forEach(function(x){ var d=x.fecha_liquidacion||x.fecha; porDia[d]=(porDia[d]||0)+(Number(x.venta)||0); });
  var th='padding:7px 9px;font-size:10.5px;font-weight:700;color:#fff;background:#6D28D9;position:sticky;top:0;white-space:nowrap;cursor:pointer;user-select:none';
  var f=function(d){ return d?String(d).split('-').reverse().join('/'):''; };
  var o=S.ord||{};
  c.innerHTML='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:8px;margin-bottom:10px">'
    +[['COBROS',L.length,'var(--text-primary)','var(--surface-1)'],['VENTA',fmt(sum('venta')),'#6D28D9','var(--pastel-lila)'],
      ['COMISIÓN',fmt(sum('comision')),'#991B1B','var(--pastel-error)'],['ITBMS',fmt(sum('itbms')),'var(--text-primary)','var(--surface-1)'],
      ['NETO',fmt(sum('neto')),'#166534','var(--pastel-ok)']].map(function(k){
        return '<div style="background:'+k[3]+';color:'+k[2]+';border-radius:10px;padding:9px 12px"><div style="font-size:10px;font-weight:700;opacity:.9">'+k[0]
          +'</div><div style="font-size:18px;font-weight:800">'+k[1]+'</div></div>'; }).join('')
    +'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:6px">Liquidado por día: '
    +(Object.keys(porDia).sort().reverse().slice(0,12).map(function(d){ return f(d)+' '+fmt(porDia[d]); }).join(' · ')||'—')+'</div>'
    +'<div class="ia-informe" data-imp-titulo="Cobros con tarjeta" style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;max-height:60vh">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr>'
    + BNC_REM_COLS.map(function(cl){
        var fl=o.col===cl[0]?(o.dir==='asc'?' ▲':' ▼'):' <span style="opacity:.45">↕</span>';
        return '<th onclick="_bncRemOrdenar(\''+cl[0]+'\')" title="Ordenar" style="'+th+(cl[2]?';text-align:right':';text-align:left')+'">'+cl[1]+fl+'</th>'; }).join('')
    +'</tr></thead><tbody>'
    + L.map(function(x,i){
        var td='padding:6px 9px;border-bottom:0.5px solid var(--border);white-space:nowrap';
        return '<tr style="'+((i%2)?'background:var(--bg-accent)':'')+'">'
          +'<td style="'+td+'">'+f(x.fecha)+'</td><td style="'+td+';color:var(--text-muted)">'+_esc(x.hora||'')+'</td>'
          +'<td style="'+td+'">'+f(x.fecha_liquidacion)+'</td><td style="'+td+';font-family:monospace">'+_esc(x.tarjeta||'')+'</td>'
          +'<td style="'+td+'">'+_esc(x.tipo_tarjeta||'')+'</td><td style="'+td+'">'+_esc(x.autorizacion||'')+'</td>'
          +'<td style="'+td+'">'+_esc(x.terminal||'')+'</td><td style="'+td+'">'+_esc(x.lote||'')+'</td>'
          +'<td style="'+td+';text-align:right;font-weight:700">'+fmt(Number(x.venta)||0)+'</td>'
          +'<td style="'+td+';text-align:right;color:#991B1B">'+fmt(Number(x.comision)||0)+'</td>'
          +'<td style="'+td+';text-align:right">'+fmt(Number(x.itbms)||0)+'</td>'
          +'<td style="'+td+';text-align:right;color:#166534">'+fmt(x.neto)+'</td></tr>';
      }).join('')
    +'</tbody></table></div>'
    +(L.length?'':'<div class="empty" style="padding:20px">No hay cobros con tarjeta con esos filtros.</div>');
}

// El mismo reporte en Excel: lo que se ve (filtros y orden), con formato
async function _bncRemExcel(){
  var S=window._bncRemS||{}, L=_bncRemVisibles();
  if(!L.length){ showT('No hay cobros para descargar con esos filtros'); return; }
  try{
    await _ensureExcelJS();
    var wb=new ExcelJS.Workbook(); wb.creator='Kennedy Center Corp.';
    var ws=wb.addWorksheet('Cobros con tarjeta',{views:[{state:'frozen', ySplit:5}]});
    var anchos=[12,10,12,22,10,14,12,9,14,13,11,14];
    ws.columns=anchos.map(function(w){ return {width:w}; });
    var n=BNC_REM_COLS.length;
    var f=function(d){ return d?String(d).split('-').reverse().join('/'):''; };
    ws.mergeCells(1,1,1,n); var t=ws.getCell(1,1);
    t.value='KENNEDY CENTER CORP. · COBROS CON TARJETA'; t.font={bold:true, size:14, color:{argb:'FF6D28D9'}};
    ws.mergeCells(2,1,2,n); var s2=ws.getCell(2,1);
    s2.value='Del '+f(S.desde)+' al '+f(S.hasta)+(S.tipo&&S.tipo!=='todas'?(' · '+S.tipo):'')+(S.q?(' · búsqueda «'+S.q+'»'):'')
      +' · '+L.length+' cobro(s) · generado el '+new Date().toLocaleString('es-PA',{dateStyle:'long', timeStyle:'short'})+' por '+((CU&&CU.name)||'');
    s2.font={size:10, color:{argb:'FF666666'}};
    // Resumen
    var sum=function(k){ return L.reduce(function(a,x){ return a+(Number(x[k])||0); },0); };
    var res=[['Venta',sum('venta'),'FF6D28D9'],['Comisión',sum('comision'),'FF991B1B'],['ITBMS',sum('itbms'),'FF333333'],['Neto',sum('neto'),'FF166534']];
    res.forEach(function(r,k){
      var a=ws.getCell(3,1+k*3), b=ws.getCell(3,2+k*3);
      a.value=r[0]; a.font={bold:true, size:10, color:{argb:'FF666666'}};
      b.value=r[1]; b.numFmt='$#,##0.00'; b.font={bold:true, size:12, color:{argb:r[2]}};
    });
    var hr=ws.getRow(5);
    BNC_REM_COLS.forEach(function(cl,k){
      var cell=hr.getCell(k+1); cell.value=cl[1];
      cell.font={bold:true, color:{argb:'FFFFFFFF'}};
      cell.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF6D28D9'}};
      cell.alignment={horizontal:cl[2]?'right':'left', vertical:'middle'};
    });
    hr.height=20;
    var fechaXls=function(d){ if(!d) return null; var p=String(d).split('-'); return new Date(Date.UTC(+p[0],+p[1]-1,+p[2])); };
    L.forEach(function(x,ri){
      var row=ws.getRow(6+ri);
      var vals=[fechaXls(x.fecha), x.hora||'', fechaXls(x.fecha_liquidacion), x.tarjeta||'', x.tipo_tarjeta||'',
                x.autorizacion||'', x.terminal||'', x.lote||'', Number(x.venta)||0, Number(x.comision)||0, Number(x.itbms)||0, Number(x.neto)||0];
      vals.forEach(function(v,ci){
        var cell=row.getCell(ci+1); cell.value=v;
        if(ci===0||ci===2) cell.numFmt='dd/mm/yyyy';
        if(ci>=8){ cell.numFmt='$#,##0.00'; cell.alignment={horizontal:'right'}; }
        if(ci===8) cell.font={bold:true};
        if(ci===9) cell.font={color:{argb:'FF991B1B'}};
        if(ci===11) cell.font={color:{argb:'FF166534'}};
        if(ci===3) cell.font={name:'Consolas'};
        if(ri%2===1) cell.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFF5F3FF'}};
        cell.border={bottom:{style:'hair', color:{argb:'FFDDDDDD'}}};
      });
    });
    var ult=5+L.length;
    ws.autoFilter={from:{row:5,column:1}, to:{row:ult,column:n}};
    // Totales con fórmulas (si se filtra o se corrige en Excel, se recalculan)
    var tr=ws.getRow(ult+2);
    ws.mergeCells(ult+2,1,ult+2,8);
    tr.getCell(1).value='TOTALES'; tr.getCell(1).font={bold:true}; tr.getCell(1).alignment={horizontal:'right'};
    ['I','J','K','L'].forEach(function(col,k){
      var cell=tr.getCell(9+k); cell.value={formula:'SUBTOTAL(9,'+col+'6:'+col+ult+')'}; cell.numFmt='$#,##0.00'; cell.font={bold:true};
    });
    for(var k=1;k<=n;k++) tr.getCell(k).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEDE9FE'}};
    var buf=await wb.xlsx.writeBuffer();
    var a=document.createElement('a');
    a.href=URL.createObjectURL(new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    a.download='cobros_tarjeta_'+(S.desde||'')+'_al_'+(S.hasta||'')+'.xlsx';
    document.body.appendChild(a); a.click(); a.remove();
    showT('✓ Excel descargado: '+L.length+' cobro(s)');
  }catch(e){ showT('No se pudo generar el Excel: '+(e.message||e), 8000); }
}

function _bncFiltro(k){ window._bnc.filtro=k; _bncPintar(); }
function _bncCuenta(v){ window._bnc.cuenta=v; _bncPintar(); }
function _bncBanco(v){ window._bnc.banco=v; window._bnc.cuenta='todas'; _bncPintar(); }

// El nombre de la cuenta, si se le puso uno
function _bncAlias(cta){
  var a=((window._bnc||{}).alias||{})[String(cta||'')];
  return a ? (a+' · '+cta) : String(cta||'');
}
/* v761: el logo del banco al lado de cada cuenta, para ver de un vistazo de
   quién es. «BG», «BG PRUEBA» o «Banco General» → Banco General; vacío o
   «Banistmo…» → Banistmo. Van incrustados: no dependen de ningún archivo. */
var BNC_LOGOS={
  bg:'data:image/png;base64,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',
  bni:'data:image/png;base64,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'
};
function _bncLogoDe(banco){
  var b=String(banco||'Banistmo').toLowerCase().trim();
  if(/^bg\b|banco general/.test(b)) return 'bg';
  if(/banistmo/.test(b)) return 'bni';
  return '';
}
function _bncNombreBanco(banco){
  var b=String(banco||'Banistmo');
  if(/^bg prueba$/i.test(b)) return 'Banco General (prueba)';
  if(/^bg$/i.test(b)) return 'Banco General';
  return b;
}
function _bncLogo(banco, px){
  var k=_bncLogoDe(banco); if(!k) return '';
  px=px||18;
  var n=(k==='bg'?'Banco General':'Banistmo');
  return '<img src="'+BNC_LOGOS[k]+'" alt="'+n+'" title="'+n+'" style="width:'+px+'px;height:'+px+'px;'
    +'border-radius:'+Math.round(px/4)+'px;background:#fff;border:0.5px solid var(--border);'
    +'padding:1px;box-sizing:border-box;object-fit:contain;vertical-align:middle;flex:none">';
}
// El banco de una cuenta: el de sus movimientos o, si no, el de banco_cuentas
function _bncBancoDeCta(cta, ms){
  var m=(ms||[]).find(function(x){ return x.banco; });
  if(m) return m.banco;
  return ((window._bnc||{}).bancoDe||{})[String(cta||'')]||'Banistmo';
}
function _bncBuscar(v){ window._bnc.q=v; _bncPintar(); }
function _bncFecha(cual, v){ window._bnc[cual]=v; if(cual==='desde') _bncCargar(); else _bncPintar(); }

function _bncPintar(){
  var c=document.getElementById('page-banco'); if(!c) return;
  var S=window._bnc||{};
  var L=_bncVisibles();
  var cargos=L.filter(function(m){ return Number(m.monto)<0; })
              .reduce(function(a,m){ return a+Math.abs(Number(m.monto)||0); },0);
  var abonos=L.filter(function(m){ return Number(m.monto)>0; })
              .reduce(function(a,m){ return a+(Number(m.monto)||0); },0);
  var sinConc=(S.lista||[]).filter(function(m){ return !m.conciliado; }).length;
  var cuentas=[...new Set((S.lista||[]).map(function(m){
    return String(m.cuenta||''); }).filter(Boolean))];

  var pill=function(k,t,n){
    return '<span class="pill'+((S.filtro||'todos')===k?' active':'')+'" '
      +'onclick="_bncFiltro(\''+k+'\')">'+t
      +(n!=null?(' <b style="opacity:.75">'+n+'</b>'):'')+'</span>';
  };

  var h='';
  // Accionistas vive DENTRO de Banco, como una pestaña más, y solo la ven
  // quienes tienen permiso para ella.
  if(_acnPuede()){
    h+='<div style="display:flex;gap:7px;margin-bottom:12px">'
      +'<span class="pill active"><i class="ti ti-building-bank"></i> '
      +'Movimientos</span>'
      +'<span class="pill" onclick="_acnAbrir()" '
      +'title="Información reservada"><i class="ti ti-users"></i> '
      +'Accionistas</span></div>';
  }
  h+='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'margin-bottom:12px">'
    +'<div style="width:38px;height:38px;border-radius:10px;background:var(--pastel-azul);'
    +'display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-building-bank" style="font-size:20px;color:var(--t-azul)"></i></div>'
    +'<div style="flex:1;min-width:180px">'
    +'<div style="font-size:16px;font-weight:700">Movimientos del banco</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Banistmo'
    +(cuentas.length?(' · '+cuentas.length+' cuenta(s)'):'')
    +' · '+(S.lista||[]).length+' movimiento(s)</div></div>'
    +'<button class="xb" onclick="_bncCargar()"><i class="ti ti-refresh"></i> '
    +'Actualizar</button>'
    +'<button class="xb" onclick="_bncExportar()"><i class="ti ti-file-export"></i> '
    +'Excel</button>'
    +'<button class="btn bp" style="background:#6D28D9" onclick="_bncRemisiones()"><i class="ti ti-credit-card"></i> '
    +'Cobros con tarjeta</button></div>';

  if(S.error){
    h+='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo);'
      +'border-left:3px solid var(--t-rojo)">'+_esc(S.error)+'</div>';
  }

  // Los números de arriba, con su color
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(165px,1fr));'
    +'gap:10px;margin-bottom:13px">'
    + _bncKpi('Entró', fmt(abonos), '#166534', 'var(--pastel-ok)', 'ti-arrow-down-left')
    + _bncKpi('Salió', fmt(cargos), '#991B1B', 'var(--pastel-error)', 'ti-arrow-up-right')
    + _bncKpi('Neto', fmt(abonos-cargos), (abonos-cargos)>=0?'#166534':'#991B1B',
              'var(--pastel-azul)', 'ti-equal')
    + _bncKpi('Sin conciliar', sinConc, sinConc?'#B45309':'#166534',
              sinConc?'var(--pastel-aviso)':'var(--pastel-ok)', 'ti-link')
    +'</div>';

  // ── Las cuentas, cada una con su tarjeta ──────────────────────────────
  var bancos=[...new Set((S.lista||[]).map(function(m){
    return String(m.banco||'Banistmo'); }))];
  if(bancos.length>1){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">'
      +'<span class="pill'+((S.banco||'todos')==='todos'?' active':'')+'" '
      +'onclick="_bncBanco(\'todos\')">Todos los bancos</span>'
      + bancos.map(function(b){
          return '<span class="pill'+(S.banco===b?' active':'')+'" '
            +'style="display:inline-flex;align-items:center;gap:6px" '
            +'onclick="_bncBanco(\''+_esc(b)+'\')">'+_bncLogo(b,16)+_esc(_bncNombreBanco(b))+'</span>';
        }).join('')
      +'</div>';
  }

  // Un resumen por cuenta: lo que entró, lo que salió y el saldo del periodo
  var ctasTodas=[...new Set((S.lista||[]).map(function(m){
    return String(m.cuenta||''); }).filter(Boolean))].sort();
  if(ctasTodas.length){
    h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(215px,1fr));'
      +'gap:10px;margin-bottom:13px">';
    h+='<div onclick="_bncCuenta(\'todas\')" style="cursor:pointer;border-radius:11px;'
      +'padding:10px 13px;border:1.5px solid '
      +((S.cuenta||'todas')==='todas'?'var(--t-azul)':'var(--border)')+';'
      +'background:'+((S.cuenta||'todas')==='todas'?'var(--pastel-azul)':'var(--surface-0)')+'">'
      +'<div style="font-size:11px;font-weight:700;color:var(--t-azul)">TODAS LAS CUENTAS</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">'
      +(S.lista||[]).length+' movimiento(s)</div></div>';
    ctasTodas.forEach(function(cta){
      var ms=(S.lista||[]).filter(function(m){ return String(m.cuenta||'')===cta; });
      var ent=ms.filter(function(m){ return Number(m.monto)>0; })
                .reduce(function(a,m){ return a+Number(m.monto); },0);
      var sal=ms.filter(function(m){ return Number(m.monto)<0; })
                .reduce(function(a,m){ return a+Math.abs(Number(m.monto)); },0);
      var act=(S.cuenta===cta);
      h+='<div onclick="_bncCuenta(\''+_esc(cta)+'\')" style="cursor:pointer;'
        +'border-radius:11px;padding:10px 13px;border:1.5px solid '
        +(act?'var(--t-azul)':'var(--border)')+';'
        +'background:'+(act?'var(--pastel-azul)':'var(--surface-0)')+'">'
        +'<div style="display:flex;align-items:center;gap:8px;font-size:11.5px;font-weight:700">'
        +_bncLogo(_bncBancoDeCta(cta, ms),24)
        +'<span style="min-width:0;word-break:break-word">'+_esc(_bncAlias(cta))+'</span></div>'
        +'<div style="display:flex;gap:10px;margin-top:4px;font-size:10.5px">'
        +'<span style="color:#166534">+'+fmt(ent)+'</span>'
        +'<span style="color:#991B1B">−'+fmt(sal)+'</span></div>'
        +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">'
        +ms.length+' movimiento(s)</div>'
        + _bncSaldoHtml(cta, ms)
        +'</div>';
    });
    h+='</div>';
  }

  // Filtros
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
    + pill('todos','Todos', (S.lista||[]).length)
    + pill('cargos','Salidas') + pill('abonos','Entradas')
    + pill('ach','ACH enviados', (S.lista||[]).filter(_bncEsAch).length)
    + pill('sin','Sin conciliar', sinConc) + pill('conciliados','Conciliados')
    +'<input value="'+_esc(S.desde||'')+'" type="date" onchange="_bncFecha(\'desde\',this.value)" '
    +'title="Desde" style="padding:6px 9px;border:0.5px solid var(--border);'
    +'border-radius:8px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
    +'<input value="'+_esc(S.hasta||'')+'" type="date" onchange="_bncFecha(\'hasta\',this.value)" '
    +'title="Hasta" style="padding:6px 9px;border:0.5px solid var(--border);'
    +'border-radius:8px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
    +'<input value="'+_esc(S.q||'')+'" placeholder="Buscar por concepto, referencia, orden o monto…" '
    +'oninput="_bncBuscar(this.value)" style="flex:1;min-width:250px;padding:7px 14px;'
    +'border:0.5px solid var(--border);border-radius:999px;font-size:12.5px;'
    +'background:var(--surface-0);color:var(--text-primary)"></div>';

  if(S.cargando){
    h+='<div class="empty"><span class="ai-ring g"></span> Cargando movimientos…</div>';
    c.innerHTML=h; return;
  }
  if(!L.length){
    h+='<div class="empty"><i class="ti ti-building-bank" style="font-size:26px"></i><br>'
      +((S.lista||[]).length
        ? 'Ningún movimiento con estos filtros'
        : 'Todavía no hay movimientos.<br><span style="font-size:11.5px;'
          +'color:var(--text-muted)">El banco deja el reporte del día siguiente '
          +'(T+1) y el worker lo baja solo.</span>')+'</div>';
    c.innerHTML=h; return;
  }

  // Agrupados por día, como un extracto de verdad
  var porDia={}, dias=[];
  L.slice(0,400).forEach(function(m){
    var d=String(m.fecha||'');
    if(!porDia[d]){ porDia[d]=[]; dias.push(d); }
    porDia[d].push(m);
  });

  dias.forEach(function(d){
    var ms=porDia[d];
    var neto=ms.reduce(function(a,m){ return a+(Number(m.monto)||0); },0);
    h+='<div style="display:flex;align-items:center;gap:9px;margin:16px 0 8px">'
      +'<div style="font-size:12.5px;font-weight:700">'+_esc(_bncDia(d))+'</div>'
      +'<div style="flex:1;height:1px;background:var(--border)"></div>'
      +'<div style="font-size:11.5px;color:var(--text-muted)">'+ms.length+' movimiento(s)'
      +' · neto <b style="color:'+(neto>=0?'#166534':'#991B1B')+'">'
      +(neto>=0?'+':'−')+fmt(Math.abs(neto))+'</b></div></div>';

    ms.forEach(function(m){
      var neg=Number(m.monto)<0;
      var col=neg?'#991B1B':'#166534';
      var tipo=_bncEtiqueta(m);
      h+='<div style="display:flex;gap:11px;align-items:flex-start;'
        +'background:var(--surface-0);border:0.5px solid var(--border);'
        +(m.conciliado?'border-left:4px solid #166534;':'border-left:4px solid '+col+'33;')
        +'border-radius:11px;padding:11px 13px;margin-bottom:7px">'
        // El icono dice de un vistazo si entró o salió
        +'<div style="width:32px;height:32px;border-radius:9px;flex-shrink:0;'
        +'background:'+(neg?'var(--pastel-error)':'var(--pastel-ok)')+';'
        +'display:flex;align-items:center;justify-content:center">'
        +'<i class="ti '+(neg?'ti-arrow-up-right':'ti-arrow-down-left')
        +'" style="font-size:16px;color:'+col+'"></i></div>'

        +'<div style="flex:1;min-width:0">'
        +'<div style="font-size:12.5px;font-weight:600;line-height:1.45;'
        +'word-break:break-word">'+_esc(_bncConcepto(m))+'</div>'
        +'<div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:5px;'
        +'align-items:center">'
        + (tipo?('<span style="font-size:10px;font-weight:700;border-radius:999px;'
            +'padding:2px 9px;background:'+tipo.bg+';color:'+tipo.c+'">'
            +_esc(tipo.t)+'</span>'):'')
        + (m.cuenta?('<span style="font-size:10.5px;color:var(--text-muted);display:inline-flex;align-items:center;gap:5px">'
            +(_bncLogo(m.banco,15)||'<i class="ti ti-credit-card" style="font-size:11px"></i>')
            +_esc(_bncNombreBanco(m.banco))+' · '+_esc(_bncAlias(m.cuenta))
            +'</span>'):'')
        + (m.referencia?('<span style="font-size:10.5px;color:var(--text-muted)">'
            +'ref. '+_esc(m.referencia)+'</span>'):'')
        + (m.conciliado
            ? ('<span style="font-size:10.5px;font-weight:700;color:#166534">'
               +'<i class="ti ti-link"></i> '+_esc(m.docnum||'conciliado')+'</span>')
            : '')
        + (m.nota?('<span style="font-size:10.5px;color:var(--text-muted);'
            +'font-style:italic">'+_esc(m.nota)+'</span>'):'')
        +'</div></div>'

        +'<div style="text-align:right;flex-shrink:0;display:flex;'
        +'flex-direction:column;align-items:flex-end;gap:5px">'
        +'<div style="font-size:15px;font-weight:800;color:'+col+';white-space:nowrap">'
        +(neg?'−':'+')+fmt(Math.abs(Number(m.monto)||0))+'</div>'
        +(m.conciliado
          ? ('<button class="xb" style="font-size:10.5px" '
             +'onclick="_bncDesconciliar('+m.id+')"><i class="ti ti-unlink"></i> '
             +'Soltar</button>')
          : ('<button class="btn bp" style="padding:4px 11px;font-size:10.5px" '
             +'onclick="_bncConciliar('+m.id+')"><i class="ti ti-link"></i> '
             +'Conciliar</button>'))
        +'</div></div>';
    });
  });

  if(L.length>400){
    h+='<div style="font-size:11.5px;color:var(--text-muted);margin-top:9px;'
      +'text-align:center">Mostrando 400 de '+L.length+' · afina los filtros</div>';
  }
  c.innerHTML=h;
}

/* El concepto del banco viene con barras y códigos internos. Se limpia para
   que se lea: «CR TRANSFERENCIA INTL REC//I81-ND & S SUPERSTORE» pasa a
   «Transferencia internacional recibida · ND & S SUPERSTORE». */
function _bncConcepto(m){
  var t=String(m.concepto||'').trim();
  if(!t) return '(sin concepto)';
  // Lo de después de // suele ser el nombre del tercero
  var partes=t.split('//');
  var cab=partes[0].trim();
  var resto=(partes[1]||'').trim().replace(/^[A-Z]\d{1,3}-/,'').trim();
  cab=cab.replace(/^(CR|DB)\s+/,'')
         .replace(/TRANSFERENCIA INTL REC/i,'Transferencia internacional recibida')
         .replace(/COMISION TRANF INT REC/i,'Comisión por transferencia internacional')
         .replace(/ITBMS COMISION TRANF INT REC/i,'ITBMS de la comisión')
         .replace(/TRANSACCI[ÓO]N D[ÉE]BITO CARTERA/i,'Débito de cartera');
  return resto ? (cab+' · '+resto) : cab;
}

/* Una etiqueta de color por tipo de movimiento, deducida del concepto */
function _bncEtiqueta(m){
  var t=String(m.concepto||'').toUpperCase();
  if(/ITBMS/.test(t))          return {t:'Impuesto',  c:'#6B21A8', bg:'#F3E8FF'};
  if(/COMISION|COMISIÓN/.test(t)) return {t:'Comisión', c:'#B45309', bg:'#FEF3E8'};
  if(/PRESTAMO|PRÉSTAMO|CARTERA/.test(t)) return {t:'Préstamo', c:'#991B1B', bg:'#FEF2F2'};
  if(/TRANSFERENCIA|TRANSF/.test(t)) return {t:'Transferencia', c:'#0C447C', bg:'#E6F1FB'};
  if(/CHEQUE/.test(t))         return {t:'Cheque',    c:'#72243E', bg:'#FBE9EF'};
  if(/DEPOSITO|DEPÓSITO/.test(t)) return {t:'Depósito', c:'#166534', bg:'#E4F0D4'};
  return null;
}

// La cabecera de cada día: «domingo, 4 de octubre de 2026»
function _bncDia(d){
  try{
    var p=String(d||'').split('-');
    var f=new Date(Number(p[0]), Number(p[1])-1, Number(p[2]));
    var txt=f.toLocaleDateString('es-ES',
      {weekday:'long', day:'numeric', month:'long', year:'numeric'});
    return txt.charAt(0).toUpperCase()+txt.slice(1);
  }catch(e){ return String(d||''); }
}

function _bncKpi(t, v, col){
  return '<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:10px;padding:9px 12px">'
    +'<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(t)+'</div>'
    +'<div style="font-size:16px;font-weight:700;color:'+col+'">'+v+'</div></div>';
}

/* Conciliar: se propone sola la orden o la solicitud que mejor cuadre por
   importe, y se puede corregir a mano. */
async function _bncConciliar(id){
  var m=((window._bnc||{}).lista||[]).find(function(x){ return x.id===id; });
  if(!m) return;
  var monto=Math.abs(Number(m.monto)||0);

  // Lo que más se parece: mismo importe, con margen de un dólar
  var cand=[];
  try{
    (orders||[]).forEach(function(o){
      var ab=Number(o.abono)||0, sal=(Number(o.valor)||0)-ab;
      [['abono',ab],['saldo',sal],['total',Number(o.valor)||0]].forEach(function(par){
        if(par[1]>0 && Math.abs(par[1]-monto)<=1){
          cand.push({txt:o.id+' · '+(o.prov||'')+' · '+par[0]+' '+fmt(par[1]),
                     docnum:String(o.id)});
        }
      });
    });
  }catch(e){}
  try{
    (window._solPago||[]).forEach(function(x){
      if(Math.abs((Number(x.monto)||0)-monto)<=1){
        cand.push({txt:'solicitud '+x.docnum+' · '+fmt(x.monto),
                   docnum:String(x.docnum), sol:x.id});
      }
    });
  }catch(e){}

  var sug=cand.length
    ? ('\n\nPor el importe, podría ser:\n'
       + cand.slice(0,6).map(function(c,i){ return '  '+(i+1)+') '+c.txt; }).join('\n')
       + '\n\nEscribe el número de la lista o el número de orden.')
    : '\n\nNo encuentro ninguna orden con ese importe exacto.';

  var resp=prompt('CONCILIAR MOVIMIENTO\n\n'
    + _fechaCorta(m.fecha)+' · '+(Number(m.monto)<0?'cargo':'abono')+' de '+fmt(monto)
    + '\n' + String(m.concepto||'').slice(0,90) + sug, '');
  if(resp==null) return;
  resp=String(resp).trim();
  if(!resp) return;

  var elegido=null;
  if(/^[1-9]$/.test(resp) && cand[Number(resp)-1]) elegido=cand[Number(resp)-1];
  else elegido={docnum:resp.replace(/[^0-9A-Za-z\-]/g,''), txt:''};

  var nota=prompt('Nota (opcional)', '')||'';
  try{
    var r=await fetch(SB+'/rest/v1/banco_movimientos?id=eq.'+id,{
      method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({conciliado:true, docnum:elegido.docnum,
                           sol_id:elegido.sol||null, nota:nota})});
    if(!r.ok) throw new Error(r.status+' '+(await r.text()).slice(0,120));
    m.conciliado=true; m.docnum=elegido.docnum; m.nota=nota;
    _bncPintar();
    showT('✓ Movimiento conciliado con '+elegido.docnum);
  }catch(e){ showT('No se pudo guardar: '+(e.message||e), 8000); }
}

async function _bncDesconciliar(id){
  if(!confirm('¿Soltar esta conciliación?')) return;
  try{
    await fetch(SB+'/rest/v1/banco_movimientos?id=eq.'+id,{
      method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({conciliado:false, docnum:null, sol_id:null, nota:null})});
    var m=((window._bnc||{}).lista||[]).find(function(x){ return x.id===id; });
    if(m){ m.conciliado=false; m.docnum=null; m.nota=null; }
    _bncPintar();
  }catch(e){ showT('No se pudo: '+(e.message||e)); }
}

function _bncExportar(){
  var L=_bncVisibles();
  if(!L.length){ showT('No hay nada que exportar'); return; }
  var filas=[['Banco','Cuenta','Fecha','Concepto','Referencia','Codigo','Monto',
              'Tipo','Conciliado','Orden','Nota']];
  L.forEach(function(m){
    filas.push([m.banco||'Banistmo', m.cuenta||'', m.fecha||'', m.concepto||'',
                m.referencia||'', m.codigo||'', Number(m.monto)||0, m.tipo||'',
                m.conciliado?'si':'no', m.docnum||'', m.nota||'']);
  });
  var csv=filas.map(function(f){
    return f.map(function(v){
      var t=String(v==null?'':v).replace(/"/g,'""');
      return /[",;\n]/.test(t) ? ('"'+t+'"') : t;
    }).join(';');
  }).join('\n');
  var blob=new Blob(['\ufeff'+csv], {type:'text/csv;charset=utf-8'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download='movimientos_banco_'+_hoyISO()+'.csv';
  document.body.appendChild(a); a.click(); a.remove();
}

/* Un PDF pesado convertido a imágenes para poder revisarlo.
   Los artes vienen a resolución de imprenta y pesan decenas de megas. Para
   leer el texto y comprobar el arte no hace falta esa resolución: se dibuja
   cada página a unos 1.300 píxeles de ancho y se manda como JPEG. Un arte de
   87 MB se queda en poco más de uno. */
async function _iaPdfAImagenes(blob, nombre, maxPags){
  try{
    if(!/\.pdf$/i.test(String(nombre||'')) && blob.type!=='application/pdf') return null;
    var pdfjs=await _ensurePdfJs();
    if(!pdfjs) return null;
    var buf=await blob.arrayBuffer();
    var doc=await pdfjs.getDocument({data:buf}).promise;
    var tope=Math.min(doc.numPages, maxPags||6);
    var bloques=[], pesoTotal=0;

    for(var i=1;i<=tope;i++){
      var pag=await doc.getPage(i);
      var v1=pag.getViewport({scale:1});
      var escala=Math.min(2, 1300/Math.max(1, v1.width));
      var vp=pag.getViewport({scale:escala});
      var cv=document.createElement('canvas');
      cv.width=Math.round(vp.width); cv.height=Math.round(vp.height);
      await pag.render({canvasContext:cv.getContext('2d'), viewport:vp}).promise;
      var dataUrl=cv.toDataURL('image/jpeg', 0.82);
      var b64=dataUrl.split(',')[1]||'';
      pesoTotal += b64.length*0.75;
      bloques.push({type:'image',
                    source:{type:'base64', media_type:'image/jpeg', data:b64}});
      // Si aun así se dispara, se corta: mejor cuatro páginas que nada
      if(pesoTotal > 7*1024*1024) break;
    }
    if(!bloques.length) return null;

    bloques.unshift({type:'text',
      text:'ARCHIVO: '+nombre+' · '+doc.numPages+' página(s), se envían '
        +bloques.length+' como imagen porque el PDF original pesa '
        +(blob.size/1048576).toFixed(1)+' MB.'});
    return {bloques:bloques,
            nota:nombre+': convertido a imagen ('+bloques.length+' de '
                 +doc.numPages+' pág.)'};
  }catch(e){
    console.warn('pdf a imágenes:', e);
    return null;
  }
}

/* La fecha de la versión, para el título. «2026-10-07 14:30» se enseña como
   «7 oct · 2:30 p. m.», y al pasar el ratón sale completa. */
/* La fecha que se enseña: la del despliegue y, si en este navegador la
   versión apareció más tarde, la de verdad. */
function _appFechaUsar(){
  try{
    var k='app_visto_'+APP_VERSION;
    var visto=localStorage.getItem(k);
    if(!visto){
      visto=new Date().toISOString();
      localStorage.setItem(k, visto);
      // Se limpian las marcas de versiones viejas
      for(var i=localStorage.length-1;i>=0;i--){
        var kk=localStorage.key(i);
        if(kk && kk.indexOf('app_visto_')===0 && kk!==k) localStorage.removeItem(kk);
      }
    }
    var d=new Date(visto);
    var puesta=new Date(String(APP_FECHA||'').replace(' ','T')+':00');
    // Si el navegador la vio ANTES de la fecha escrita a mano, la escrita
    // está mal: manda la real.
    if(!isNaN(d.getTime()) && !isNaN(puesta.getTime()) && d < puesta){
      var z=function(n){ return (n<10?'0':'')+n; };
      return d.getFullYear()+'-'+z(d.getMonth()+1)+'-'+z(d.getDate())
        +' '+z(d.getHours())+':'+z(d.getMinutes());
    }
  }catch(e){}
  return String(APP_FECHA||'');
}

function _appFechaCorta(){
  try{
    var p=String(_appFechaUsar()||'').split(' ');
    var f=p[0].split('-'), h=(p[1]||'').split(':');
    var meses=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    var hh=Number(h[0]||0), ap=hh>=12?'p. m.':'a. m.';
    var h12=hh%12; if(!h12) h12=12;
    return Number(f[2])+' '+meses[Number(f[1])-1]
      + (h.length>1 ? (' · '+h12+':'+h[1]+' '+ap) : '');
  }catch(e){ return String(APP_FECHA||''); }
}

function _appFechaLarga(){
  try{
    var p=String(_appFechaUsar()||'').split(' ');
    var f=p[0].split('-');
    var d=new Date(Number(f[0]), Number(f[1])-1, Number(f[2]));
    var txt=d.toLocaleDateString('es-ES',
      {weekday:'long', day:'numeric', month:'long', year:'numeric'});
    return txt.charAt(0).toUpperCase()+txt.slice(1)+(p[1]?(' a las '+p[1]):'');
  }catch(e){ return String(APP_FECHA||''); }
}

/* El costeo generado queda guardado CON la orden, igual que el booking o las
   medidas. Así, al volver a abrirla, sigue ahí con sus precios y se puede
   mandar a los vendedores sin tener que generarlo otra vez. Solo se
   reemplaza cuando alguien genera uno nuevo a propósito. */
async function _costGuardarEnOrden(oid, datos){
  if(!oid || !datos) return;
  try{
    var d=_logLeer(oid);
    d.costeo=d.costeo||{};
    // Lo pesado (las fotos en base64) fuera: con la referencia basta y el
    // guardado no revienta por tamaño.
    d.costeo.datos={
      entrada:datos.entrada||'', num_doc_com:datos.num_doc_com||'',
      proveedor:datos.proveedor||'', total_cif:datos.total_cif||0,
      fecha:datos.fecha||_hoyISO(),
      lineas:(datos.lineas||[]).map(function(l){
        return {
          referencia:l.referencia||'', descripcion:l.descripcion||'',
          cantidad:Number(l.cantidad)||0,
          fob_unit:Number(l.fob_unit)||0, gastos_unit:Number(l.gastos_unit)||0,
          cif_unit:Number(l.cif_unit)||0,
          precio_venta:Number(l.precio_venta)||0,
          margen:Number(l.margen)||0,
          foto:l.foto||''
        };
      })
    };
    d.costeo.guardado_en=new Date().toISOString();
    d.costeo.guardado_por=(CU&&CU.name)||'';
    _logGuardar(oid);
    _dbg('[COST] costeo guardado con la orden '+oid+' · '
      +(d.costeo.datos.lineas||[]).length+' línea(s)');
  }catch(e){ console.warn('[COST] no pude guardar el costeo:', e); }
}

/* Deja la pantalla como está en SAP: olvida los precios guardados de ESTE
   costeo. Útil cuando quedó algún valor de una edición vieja o de otra
   entrada de la misma orden. */
async function _pvOlvidarGuardados(oid){
  var r=_pvDatos(oid);
  if(!r.base){ showT('No hay costeo cargado'); return; }
  var clave=_pvClaveCosteo(r.base);
  var d=r.d;
  var cuantos=Object.keys(_pvEditados(d, r.base)).length;
  if(!confirm('Se olvidarán los '+cuantos+' precio(s) guardados de este costeo ('
    +clave+') y la pantalla quedará con lo que hay en SAP.\n\n'
    +'No se toca SAP ni los demás costeos de esta orden.\n\n¿Sigo?')) return;
  try{
    d.precios=d.precios||{};
    if(d.precios.porCosteo) delete d.precios.porCosteo[clave];
    if(d.precios.costeo===clave){
      delete d.precios.valores;
      delete d.precios.costeo;
    }
    // Lo viejo sin dueño conocido también se descarta, que es de donde
    // venían los precios cruzados
    if(d.precios.valores && !d.precios.costeo) delete d.precios.valores;
    await _logGuardar(oid);
    _pvCerrar(oid);
    await _pvAbrir(oid);
    showT('✓ Listo: los precios vuelven a ser los de SAP');
  }catch(e){ showT('No se pudo: '+(e.message||e)); }
}

/* ¿Salió ya este mismo correo? Se busca por orden y asunto en las últimas
   horas. Devuelve la fila anterior o null. */
async function _correoYaSalio(fila){
  try{
    var doc=String(fila.docnum||'').trim();
    var asunto=String(fila.asunto||'').trim();
    if(!asunto) return null;
    var desde=new Date(Date.now()-12*3600*1000).toISOString();
    var url=SB+'/rest/v1/correos_queue?select=id,asunto,docnum,creado_en,de_nombre,estado'
      +'&asunto=eq.'+encodeURIComponent(asunto)
      +(doc?('&docnum=eq.'+encodeURIComponent(doc)):'')
      +'&creado_en=gte.'+desde
      +'&order=creado_en.desc&limit=1';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok) return null;
    return ((await r.json())||[])[0]||null;
  }catch(e){ return null; }
}

function _correoHaceCuanto(iso){
  try{
    var min=Math.round((Date.now()-new Date(iso).getTime())/60000);
    if(min<1) return 'hace unos segundos';
    if(min<60) return 'hace '+min+' minuto(s)';
    var h=Math.round(min/60);
    if(h<24) return 'hace '+h+' hora(s)';
    return 'el '+_fechaHora(iso);
  }catch(e){ return 'hace poco'; }
}

/* Gerencia aprueba los artes → aviso a DISEÑO. Al pulsarlo se abre la orden
   en la etapa de Artes aprobados, y el aviso se da por visto. */
async function _artesAvisarDiseno(oid){
  var dis=(USERS||[]).filter(function(u){
    return String(u.role||'')==='diseno' && u.id!==((CU&&CU.id)||'');
  });
  if(!dis.length) return;
  var o=(orders||[]).find(function(x){ return String(x.id)===String(oid); })||{};
  var ap=getAprob(oid)||{};
  try{
    await _menNotificar(dis, {
      docnum:oid, contexto:'etapa', etapa:'Artes',
      paso:_PASO_ARTES_APROB,
      texto:'Artes APROBADOS por gerencia'
        + (o.prov?(' · '+String(o.prov).slice(0,40)):'')
        + (ap.comentario?(' · "'+String(ap.comentario).slice(0,90)+'"'):'')
        + ' · ya puedes mandárselos al proveedor',
      etiqueta:'Artes aprobados'
    });
    _dbg('[ARTES] avisados '+dis.length+' de diseño · orden '+oid);
  }catch(e){ console.warn('avisar diseño:', e); }
}

/* El costeo de VARIAS entradas de la misma orden, juntas.
   Se pide uno por entrada al worker y se unen las líneas en un solo costeo,
   con cada línea marcada con la entrada de la que viene. Así se le pone
   precio a todo de una vez y el informe sale completo. */
async function _costGenerarVarias(oid, entradas){
  var cont=document.getElementById('costgen-'+oid);
  var juntas=[], cabecera=null, fallos=[];

  for(var i=0;i<entradas.length;i++){
    var ent=entradas[i];
    if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)">'
      +'<span class="ai-ring g"></span> Consultando SAP · entrada '+_esc(ent)
      +' ('+(i+1)+' de '+entradas.length+')…</span>';
    try{
      var datos=await _costPedirUna(oid, ent);
      if(!datos || !(datos.lineas||[]).length){ fallos.push(ent); continue; }
      if(!cabecera) cabecera=datos;
      (datos.lineas||[]).forEach(function(l){
        l._entrada=ent;
        juntas.push(l);
      });
    }catch(e){ fallos.push(ent+' ('+(e.message||e)+')'); }
  }

  if(!juntas.length){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">'
      +'No se pudo traer el costeo de ninguna entrada'
      +(fallos.length?(': '+_esc(fallos.join(', '))):'')+'</div>';
    return;
  }

  var datosJuntos=Object.assign({}, cabecera||{}, {
    entrada: entradas.join(' · '),
    num_doc_com: entradas.join(' · '),
    lineas: juntas,
    total_cif: juntas.reduce(function(a,l){
      return a+(Number(l.cif_total)||((Number(l.cantidad)||0)*(Number(l.cif_unit)||0))); },0),
    _entradas: entradas
  });

  window._costDatos=window._costDatos||{};
  window._costDatos[oid]=datosJuntos;
  try{ await _costGuardarEnOrden(oid, datosJuntos); }catch(e){}
  if(cont) cont.innerHTML='';
  _costPreview(oid, datosJuntos);
  showT('✓ Costeo de '+entradas.length+' entrada(s) · '+juntas.length+' línea(s)'
    +(fallos.length?(' · sin datos: '+fallos.join(', ')):''), 9000);
}

// Pide a SAP el costeo de UNA entrada y espera la respuesta del worker
async function _costPedirUna(oid, entrada){
  var r=await fetch(SB+'/rest/v1/costeo_queue',{
    method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
    body:JSON.stringify({docnum:String(oid), entrada:String(entrada),
                         pedido_por:(CU&&CU.name)||'', estado:'pendiente',
                         creado_en:new Date().toISOString()})});
  if(!r.ok){
    var t=await r.text();
    throw new Error(/does not exist|Could not find the table/i.test(t)
      ? 'falta la tabla costeo_queue' : ('error '+r.status));
  }
  var f=await r.json();
  var fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  if(!fid) throw new Error('no se registró el pedido');

  for(var i=0;i<45;i++){
    await new Promise(function(res){ setTimeout(res, i===0?2500:2000); });
    var rq=await fetch(SB+'/rest/v1/costeo_queue?select=*&id=eq.'+fid,{headers:SBH});
    if(!rq.ok) continue;
    var q=((await rq.json())||[])[0];
    if(!q) continue;
    if(q.estado==='error') throw new Error(String(q.error_msg||'SAP no respondió'));
    if(q.estado==='hecha' || q.estado==='ok' || q.datos){
      var datos=q.datos;
      if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
      return datos;
    }
  }
  throw new Error('el worker no respondió a tiempo');
}

/* Avisa, dentro del panel del costeo, si la orden tiene varias entradas.
   El aviso de llegada solo guarda un número; sin esto había que acordarse
   de que la mercancía vino en dos embarques. */
async function _costAvisarEntradas(oid){
  var caja=document.getElementById('costents-'+oid);
  if(!caja) return;
  try{
    var ents=await _pvEntradasDeLaOrden(oid);
    var nums=[...new Set(ents.map(function(x){
      return String(x.num_doc_com||'').trim(); }).filter(Boolean))];
    if(nums.length<2){ caja.innerHTML=''; return; }

    // ¿Cuáles están ya en el costeo que hay guardado?
    var dentro=[];
    try{
      var base=(_pvDatos(oid)||{}).base;
      var txt=String((base&&(base.entrada||base.num_doc_com))||'');
      dentro=nums.filter(function(n){ return txt.indexOf(n)>=0; });
    }catch(e){}
    var faltan=nums.filter(function(n){ return dentro.indexOf(n)<0; });

    caja.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;'
      +'border-radius:8px;padding:7px 10px;font-size:10.5px;color:var(--t-marron)">'
      +'<b><i class="ti ti-alert-circle"></i> Esta orden llegó en '+nums.length
      +' embarques:</b> '+_esc(nums.join(' · '))
      +(faltan.length
        ? ('<br>En el costeo actual '+(dentro.length?('solo está '+_esc(dentro.join(' · '))):'no hay ninguna')
           +'. Pulsa «'+(dentro.length?'Volver a consultar SAP':'Generar costeo desde SAP')
           +'» y las traigo todas juntas.')
        : '<br>El costeo ya las incluye todas.')
      +'</div>';
  }catch(e){ caja.innerHTML=''; }
}

/* ── Varias entradas, un solo informe ─────────────────────────────────────
   Una llegada grande se parte en seis o siete entradas (una por factura).
   Mandar seis correos a los vendedores es ruido: se marcan las que van
   juntas y sale UN informe con todo. */
function _enMarcar(docentry, marcada){
  window._enSel=window._enSel||{};
  if(marcada) window._enSel[docentry]=true; else delete window._enSel[docentry];
  _enPintar();
}

function _enMarcarTodas(marcar){
  window._enSel={};
  if(marcar){
    _enVisibles().forEach(function(x){ window._enSel[x.docentry]=true; });
  }
  _enPintar();
}

function _enSeleccionadas(){
  var sel=window._enSel||{};
  return ((window._en&&window._en.lista)||[]).filter(function(x){ return sel[x.docentry]; });
}

// La barra que aparece cuando hay entradas marcadas
function _enBarraSeleccion(){
  var sel=_enSeleccionadas();
  if(!sel.length) return '';
  var tot=sel.reduce(function(a,x){ return a+(Number(x.total)||0); },0);
  var docs=[...new Set(sel.map(function(x){
    return String(x.num_doc_com||('#'+x.docnum)); }))];
  var provs=[...new Set(sel.map(function(x){ return String(x.cardname||''); }))];
  return '<div style="position:sticky;top:0;z-index:5;display:flex;align-items:center;'
    +'gap:11px;flex-wrap:wrap;background:var(--pastel-azul);border:1px solid #9CC0E8;'
    +'border-radius:11px;padding:10px 13px;margin-bottom:10px">'
    +'<div style="width:30px;height:30px;border-radius:8px;background:var(--t-azul);'
    +'color:#fff;display:flex;align-items:center;justify-content:center;'
    +'font-weight:800;font-size:13px">'+sel.length+'</div>'
    +'<div style="flex:1;min-width:190px">'
    +'<div style="font-size:12.5px;font-weight:700;color:var(--t-azul)">'
    +sel.length+' entrada(s) marcada(s) · '+fmt(tot)+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-azul);opacity:.85">'
    +_esc(docs.slice(0,6).join(' · '))+(docs.length>6?' …':'')
    +(provs.length>1?(' · '+provs.length+' proveedores'):'')+'</div></div>'
    +'<button class="xb" onclick="_enMarcarTodas(false)">Quitar la selección</button>'
    +'<button class="btn bg2" style="padding:7px 13px" onclick="_enInformeJunto(false)">'
    +'<i class="ti ti-eye"></i> Ver el informe junto</button>'
    +'<button class="btn bp" style="padding:7px 15px" onclick="_enInformeJunto(true)">'
    +'<i class="ti ti-mail"></i> Enviar UN correo a vendedores</button>'
    +'</div>';
}

/* Arma un informe único con todas las entradas marcadas y lo muestra o lo
   manda. Las líneas van una detrás de otra, cada una sabiendo de qué
   entrada viene. */
async function _enInformeJunto(enviar){
  var sel=_enSeleccionadas();
  if(!sel.length){ showT('Marca al menos una entrada'); return; }
  if(sel.length===1){
    _enAbrir(sel[0].docentry);
    setTimeout(function(){ enviar ? _enMailModal() : _enPDF(); }, 800);
    return;
  }

  showT('Juntando '+sel.length+' entrada(s)…');
  var lineas=[], pv={};
  for(var i=0;i<sel.length;i++){
    try{
      var r=await fetch(SB+'/rest/v1/opdn_lineas?select=*&docentry=eq.'
        +sel[i].docentry+'&order=linenum',{headers:SBH});
      ((r.ok?((await r.json())||[]):[])).forEach(function(l){
        l._entrada=sel[i].num_doc_com||('#'+sel[i].docnum);
        lineas.push(l);
      });
    }catch(e){}
  }
  if(!lineas.length){ showT('Esas entradas no tienen líneas en el portal'); return; }

  // Los precios de venta: los del costeo de cada orden y, si falta, el inventario
  try{
    var ordenes=[...new Set(sel.map(function(x){
      return String(x.ordenes||'').replace(/[^0-9]/g,' ').trim().split(/\s+/); })
      .reduce(function(a,b){ return a.concat(b); },[]).filter(Boolean))];
    for(var k=0;k<ordenes.length;k++){
      var rl=await fetch(SB+'/rest/v1/compras_logistica?select=datos&docnum=eq.'+ordenes[k],
        {headers:SBH});
      var fl=(rl.ok?((await rl.json())||[]):[])[0];
      var dd=fl&&fl.datos;
      if(typeof dd==='string'){ try{ dd=JSON.parse(dd); }catch(e){ dd=null; } }
      var pp=(dd&&dd.precios)||{};
      Object.keys(pp.porCosteo||{}).forEach(function(c){
        Object.assign(pv, pp.porCosteo[c]||{}); });
      Object.assign(pv, pp.valores||{});
    }
  }catch(e){}
  try{
    var codigos=[...new Set(lineas.map(function(l){ return String(l.itemcode||'').trim(); })
      .filter(function(c){ return c && !(pv[c]>0); }))];
    for(var j=0;j<codigos.length;j+=60){
      var lote=codigos.slice(j,j+60).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; });
      var rp=await fetch(SB+'/rest/v1/inventario?select=itemcode,precioventa&itemcode=in.('
        +lote.join(',')+')',{headers:SBH});
      if(rp.ok) (await rp.json()||[]).forEach(function(x){
        if(!(pv[String(x.itemcode)]>0)) pv[String(x.itemcode)]=Number(x.precioventa)||0; });
    }
  }catch(e){}

  var docs=sel.map(function(x){ return x.num_doc_com||('#'+x.docnum); });
  window._en.abierta={
    docentry:sel[0].docentry,
    docnum:sel.map(function(x){ return x.docnum; }).join(', '),
    docdate:sel[0].docdate,
    cardname:[...new Set(sel.map(function(x){ return x.cardname||''; }))].join(' · '),
    cardcode:sel[0].cardcode||'',
    num_doc_com:docs.join(' · '),
    facturas:[...new Set(sel.map(function(x){ return x.facturas||''; }))].join(' · '),
    ordenes:[...new Set(sel.map(function(x){ return x.ordenes||''; }))].join(' · '),
    bl:sel[0].bl||'',
    total:sel.reduce(function(a,x){ return a+(Number(x.total)||0); },0),
    _varias:sel.length
  };
  window._en.lineas=lineas;
  window._en.entradas=sel;
  window._en.pv=pv;
  window._en.preciosNuevos=true;

  showT('✓ '+sel.length+' entradas · '+lineas.length+' línea(s) en un solo informe', 7000);
  if(enviar) _enMailModal(); else _enPDF();
}

/* ── ¿Este artículo ya va en una reposición en curso? ─────────────────────
   Para no pedir dos veces lo mismo. Se arma un índice con las reposiciones
   abiertas y sus artículos, y se consulta al pintar cada alerta. */
/* El índice sale de reposiciones_PEDIDOS, que es donde están los artículos.
   La tabla de envíos solo guarda el archivo que se mandó, por eso mirando
   ahí no se encontraba nunca nada. */
/* OJO con los nombres de los estados: en la base se llaman de una forma y
   en pantalla se leen de otra. Lo confirma _repEstadoPedidoBadge, que es lo
   que pinta las pastillas del panel de arriba:

     en_proceso       →  «En proceso»           no marca (borrador)
     enviado_compras  →  «Enviado a compras»    MARCA
     finalizado       →  «Enviada a proveedor»  MARCA   ← esto me despistó:
                          «finalizado» NO quiere decir terminada, quiere
                          decir que compras ya se la pasó al proveedor.
     orden_creada     →  ya es una orden        deja de marcar

   Por leer «finalizado» como «ya está» dejaba sin marcar justo las que más
   importan, que son las que ya están pedidas al proveedor. */
var REP_ESTADOS_VIVOS=['enviado_compras','finalizado','enviada_proveedor'];
/* v765: también MARCA una reposición «en proceso» que ya tiene número (se
   imprimió o se mandó): es la que la compradora acaba de armar, como la R-07
   con la 2317933, y no marcarla hacía que el artículo saliera otra vez como
   «hace falta reponer». Solo avisa: no impide pedir. Las borradores sin
   número siguen sin contar. */
var REP_ESTADOS_MARCAN=REP_ESTADOS_VIVOS.concat(['en_proceso']);
/* v766: los que ya NO marcan. Cualquier otro estado (vacío, «pendiente»,
   «borrador»…) se trata como «en proceso», igual que hace la pastilla del
   panel, que pinta «En proceso» todo lo que no sea enviado/finalizado. Así
   una reposición vieja guardada con otro estado, o sin él, también avisa. */
var REP_ESTADOS_CERRADOS=['cancelada','cancelado','anulada','anulado','borrada','recibida'];
/* v767: «orden_creada» TAMBIÉN marca. Que ya tenga orden no quiere decir que
   la mercancía figure como «por llegar»: mientras la orden no esté en SAP (o
   no se haya sincronizado) el artículo sale con «Por lleg: 0» y la alerta
   pedía reponerlo otra vez. Es lo que pasaba con la 2317933, que va en la R-07
   y en la orden DKC-26138. Marca durante 120 días desde la última vez que se
   tocó; después se da por recibida. */
var REP_DIAS_ORDEN=120;

var REP_ESTADO_TXT={
  en_proceso:'en preparación',
  orden_creada:'orden creada',
  enviado_compras:'enviada a compras',
  finalizado:'enviada a proveedor',
  enviada_proveedor:'enviada a proveedor'
};
// Un color por estado, para distinguirlos de un vistazo
var REP_ESTADO_COLOR={
  orden_creada:      {c:'#5B21B6', bg:'#EDE9FE', bd:'#C4B5FD'},
  en_proceso:        {c:'#1e40af', bg:'#E6F1FB', bd:'#A9CDF0'},
  enviado_compras:   {c:'#B45309', bg:'#FDF0DC', bd:'#E9C08A'},
  finalizado:        {c:'#166534', bg:'#E4F0D4', bd:'#9CC79C'},
  enviada_proveedor: {c:'#166534', bg:'#E4F0D4', bd:'#9CC79C'}
};

function _repIndiceEnCurso(){
  return window._repIdxCurso || {};
}

async function _repCargarIndiceEnCurso(forzar){
  if(!forzar && window._repIdxCurso
     && (Date.now()-(window._repIdxCursoEn||0) < 180000)) return window._repIdxCurso;
  var idx={};
  try{
    // EXACTAMENTE la misma consulta que usa el panel «Reposiciones en
    // curso», que sí trae datos: mismo filtro de equipo y mismo orden.
    // v765: SIN filtro de equipo. «¿Ya lo pidió alguien?» tiene que mirar
    // las reposiciones de TODOS: si la hizo otra compradora, o gerencia,
    // el artículo también está pedido. Antes solo se veían las del propio
    // equipo, y además el panel de arriba rehacía el índice con sus 100
    // filas filtradas, borrando lo que hubiera de otros.
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos'
      +'?select=id,num_reposicion,estado,items,cardcode,usuario_nom,actualizado_en'
      +'&or=(estado.is.null,estado.not.in.('+REP_ESTADOS_CERRADOS.join(',')+'))'
      +'&order=actualizado_en.desc&limit=600',{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      _dbg('[REP] no pude leer reposiciones_pedidos: '+r.status+' '+t.slice(0,140));
    }
    var filas=(r.ok?((await r.json())||[]):[]);
    // v767: el DKC de la orden está en reposiciones_envios (no en pedidos)
    try{
      var re=await fetch(SB+'/rest/v1/reposiciones_envios?select=pedido_id,orden_dkc'
        +'&orden_dkc=not.is.null&order=id.desc&limit=2000',{headers:SBH});
      if(re.ok){
        var dk={};
        ((await re.json())||[]).forEach(function(e){
          if(e.pedido_id!=null && e.orden_dkc && !dk[e.pedido_id]) dk[e.pedido_id]=e.orden_dkc; });
        filas.forEach(function(p){ if(dk[p.id]) p._dkc=dk[p.id]; });
      }
    }catch(e){}
    _repIndiceDesde(filas);
    return window._repIdxCurso;
  }catch(e){ _dbg('[REP] índice en curso: '+(e.message||e)); }
  return window._repIdxCurso||{};
}

/* Arma el índice «artículo → reposición» con las filas que se le pasen.
   Se llama desde los dos sitios que cargan reposiciones, así siempre
   coincide con lo que la persona está viendo. */
function _repIndiceDesde(filas){
  var idx={};
  try{
    var sinNumero=0, estados={};
    (filas||[]).forEach(function(p){
      var est=String(p.estado||'').trim().toLowerCase();
      estados[est||'(vacío)']=(estados[est||'(vacío)']||0)+1;
      /* Los estados REALES de Kennedy, confirmados en la base:
           en_proceso       se está armando; todavía no se mandó a nadie
           enviado_compras  ya se mandó a compras para que la trabaje  ← bloquea
           finalizado       terminada; sus artículos vuelven a estar libres
         Solo bloquea lo que de verdad está en manos de compras. Un borrador
         a medias no puede impedir que se pida un artículo. */
      if(REP_ESTADOS_CERRADOS.indexOf(est)>=0) return;
      if(est==='orden_creada'){
        var _to=Date.parse(p.actualizado_en||'');
        if(!_to || (Date.now()-_to) > REP_DIAS_ORDEN*86400000) return;
      } else if(REP_ESTADOS_VIVOS.indexOf(est)<0) est='en_proceso';
      // Una «en proceso» solo cuenta si se tocó en los últimos 30 días: una
      // reposición abandonada no puede marcar artículos para siempre.
      if(est==='en_proceso'){
        var _t=Date.parse(p.actualizado_en||'');
        if(!_t || (Date.now()-_t) > 30*86400000) return;
      }
      // El número REAL, el que la gente ve. Si la reposición todavía no
      // tiene número (está a medio armar), NO se inventa uno con el id de la
      // fila: así salía un «R-62» que no existe en ninguna parte.
      var cod=String(p.num_reposicion||'').trim();
      if(!cod){ sinNumero++; return; }
      var items=p.items;
      if(typeof items==='string'){ try{ items=JSON.parse(items); }catch(e){ items=[]; } }
      (items||[]).forEach(function(l){
        var c=String((l&&(l.itemcode||l.item||l.codigo||l.sku||l.ic))||'').trim();
        if(!c) return;
        var dato={codigo:cod, estado:est, id:p.id, dkc:p._dkc||'',
                  cant:Number(l.cant||l.cantidad||l.qty)||0};
        // Se guarda tal cual y en mayúsculas sin espacios: los códigos vienen
        // de sitios distintos y una diferencia tonta dejaba sin marcar.
        // v765: si un artículo está en varias, manda la que ya está en manos
        // de compras o del proveedor; las demás quedan en «otras», para poder
        // saltarse la reposición que se está editando.
        var poner=function(k){
          var a=idx[k];
          if(!a){ idx[k]=Object.assign({otras:[]}, dato); return; }
          if(a.id===dato.id) return;
          var viva=function(e){ return e!=='en_proceso'; };
          if(!viva(a.estado) && viva(dato.estado)){
            var nuevo=Object.assign({otras:[]}, dato);
            nuevo.otras=[{codigo:a.codigo, estado:a.estado, id:a.id, cant:a.cant, dkc:a.dkc}].concat(a.otras||[]);
            idx[k]=nuevo;
          } else {
            a.otras.push(dato);
          }
        };
        poner(c);
        var k2=c.toUpperCase().replace(/\s+/g,'');
        if(k2!==c) poner(k2);
      });
    });
    window._repIdxCurso=idx;
    window._repIdxCursoEn=Date.now();
    window._repEstadosVistos=estados;
    _dbg('[REP] '+Object.keys(idx).length+' clave(s) de artículo en reposiciones vivas'
      + (sinNumero?(' · '+sinNumero+' sin número, no cuentan'):'')
      + ' · estados: '+JSON.stringify(estados));
    // Si las alertas están abiertas, se repintan para que salgan marcadas
    try{
      if(_repAlertasVisible && _repAlertasCache) _repRenderAlertas(_repAlertasCache);
    }catch(e){}
  }catch(e){ _dbg('[REP] armar índice: '+(e.message||e)); }
  return idx;
}

// Lo que se lee al lado de «YA SE ENCUENTRA EN LA R-xx»
function _repTxtEstado(d){
  if(!d) return '';
  if(d.estado==='orden_creada') return d.dkc ? ('orden '+d.dkc+' creada') : 'orden creada';
  return REP_ESTADO_TXT[d.estado]||d.estado||'';
}
function _repItemEnCurso(itemcode, excluirId){
  var c=String(itemcode||'').trim();
  if(!c) return null;
  var idx=_repIndiceEnCurso();
  var d=idx[c] || idx[c.toUpperCase().replace(/\s+/g,'')] || null;
  if(!d) return null;
  if(excluirId==null || d.id!==excluirId) return d;
  // v765: la reposición que se está editando no cuenta contra sí misma
  var o=(d.otras||[]).filter(function(x){ return x.id!==excluirId; });
  return o.length ? o[0] : null;
}

// Abre la reposición donde ya está ese artículo
/* Abre la reposición: la busca por su número y continúa en ella, igual que
   el botón «Continuar» del panel de arriba. */
async function _repIrAReposicion(codigo){
  codigo=String(codigo||'').trim();
  if(!codigo) return;
  showT('Abriendo la reposición '+codigo+'…');
  try{
    var ped=await _repBuscarPedidoPorNum(codigo);
    if(ped && typeof repContinuarPedido==='function'){
      go('reposiciones');
      repContinuarPedido(ped.id);
      return;
    }
    if(ped){
      go('reposiciones');
      try{ rReposiciones(); }catch(e){}
      showT('Reposición '+codigo+' · '+(ped.cardcode||'')+' '+(ped.cardname||''), 8000);
      return;
    }
    showT('No encuentro la reposición '+codigo
      + (window._repNumsDisponibles&&window._repNumsDisponibles.length
         ? (' · existen: '+window._repNumsDisponibles.slice(0,8).join(', ')) : ''), 9000);
  }catch(e){ showT('No pude abrirla: '+(e.message||e)); }
}

/* Qué ve el portal de las reposiciones vivas. Sirve para saber por qué un
   artículo sale o no sale marcado, sin tener que abrir la consola. */
async function _repDiagEnCurso(){
  await _repCargarIndiceEnCurso(true);
  var idx=_repIndiceEnCurso();
  var claves=Object.keys(idx);
  var porRepo={};
  claves.forEach(function(k){
    var r=idx[k];
    var key=r.codigo+' ('+(REP_ESTADO_TXT[r.estado]||r.estado)+')';
    porRepo[key]=(porRepo[key]||0)+1;
  });
  var est=window._repEstadosVistos||{};
  alert('REPOSICIONES QUE MARCAN ARTÍCULOS\n\n'
    + (claves.length
       ? Object.keys(porRepo).map(function(k){
           return '  · '+k+': '+Math.round(porRepo[k]/2)+' artículo(s)'; }).join('\n')
       : '  (ninguna)')
    + '\n\nEstados encontrados en la tabla:\n'
    + Object.keys(est).map(function(k){ return '  · '+k+': '+est[k]; }).join('\n')
    + '\n\nMarcan: '+REP_ESTADOS_VIVOS.join(', ')+' y en_proceso de los últimos 30 días, con número asignado.'
    + '\n\nEjemplos de artículos marcados:\n  '
    + (claves.filter(function(k){ return /^[0-9]/.test(k); }).slice(0,12).join(', ')
       || '(ninguno)'));
}

/* ═══════════════════════════════════════════════════════════════════════════
   ACCIONISTAS · INFORMACIÓN RESERVADA   (prefijo [ACC])
   ───────────────────────────────────────────────────────────────────────────
   Solo cuatro personas. No se abre por dirección, no sale en el menú de
   nadie más y los datos ni siquiera se piden si quien mira no está en la
   lista. Si hay que añadir a alguien, se añade AQUÍ y en ningún otro sitio.
   ═══════════════════════════════════════════════════════════════════════════ */
/* LA LISTA. Se añade o se quita gente AQUÍ y en ningún otro sitio.
   Son los seis socios: Edy, Jimmy, Ariel, Itay, Samy y Eli. */
var ACN_PERMITIDOS=['edy@kennedyzl.com',
                    'jimmys@kennedyzl.com',
                    'ariel@kennedyzl.com',
                    'itay@kennedyzl.com',
                    'samy@kennedyzl.com',
                    'eli@kennedyzl.com'];

function _acnPuede(){
  try{
    var e=String((CU&&CU.email)||'').trim().toLowerCase();
    return !!e && ACN_PERMITIDOS.indexOf(e)>=0;
  }catch(err){ return false; }
}

// Los siete del tablero, en orden
var ACN_GRUPOS=['ACCIONISTA MUEBLES','ACCIONISTA HOGAR','ACCIONISTA ROPA',
                'ACCIONISTA ELECTRONICA','ACCIONISTA ALFOMBRA',
                'ACCIONISTA SAMUEL GUINDI','ACCIONISTA ELIAHOU GUINDI'];

var ACN_MESES=['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio',
               'Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

/* Lo que la empresa le DEBE a cada accionista (v715). Es un saldo, no un
   movimiento: no depende del año ni del mes elegidos y no se suma a lo
   recibido. */
var ACN_DEUDAS={
  // 15-10-2026: quitada la de Samuel Guindi (87.242,50 de planilla desde 2013):
  // ya se le pagó en su momento. Para volver a poner un saldo, se añade aquí.
};

/* Quién es quién en la PLANILLA. Por palabras, siempre nombre Y apellido:
   «JIMMY CHAYO GUINDI» es Muebles; «SAMUEL BENNETT» no es nadie. */
var ACN_EN_PLANILLA=[
  [['JIMMY','GUINDI'],'ACCIONISTA MUEBLES'],
  [['EDUARDO','GUINDI'],'ACCIONISTA HOGAR'], [['EDY','GUINDI'],'ACCIONISTA HOGAR'],
  [['REUBEN','GUINDI'],'ACCIONISTA ROPA'],   [['ITAY','GUINDI'],'ACCIONISTA ROPA'],
  [['ARIEL','GUINDI'],'ACCIONISTA ELECTRONICA'],
  [['GADY','NAOR'],'ACCIONISTA ALFOMBRA'],
  [['SAMUEL','GUINDI'],'ACCIONISTA SAMUEL GUINDI'], [['SAMY','GUINDI'],'ACCIONISTA SAMUEL GUINDI'],
  [['ELIAHOU','GUINDI'],'ACCIONISTA ELIAHOU GUINDI'], [['ELI','GUINDI'],'ACCIONISTA ELIAHOU GUINDI']
];
function _acnGrupoDeEmpleado(nombre){
  var pal=String(nombre||'').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^A-Z ]/g,' ').split(/\s+/).filter(Boolean);
  for(var i=0;i<ACN_EN_PLANILLA.length;i++){
    if(ACN_EN_PLANILLA[i][0].every(function(w){ return pal.indexOf(w)>=0; }))
      return ACN_EN_PLANILLA[i][1];
  }
  return null;
}

/* Lo que cobra cada accionista por PLANILLA, como movimientos de la clase
   «planilla»: así lo cuentan las tarjetas, los filtros de año y mes, el
   detalle del mes y el Excel sin tocar nada más. Va lo PAGADO: el neto más
   lo que se aplicó a su préstamo; el desglose queda escrito en el concepto. */
async function _acnCargarPlanilla(){
  var filas=[];
  for(var pag=0; pag<20; pag++){
    var r=await fetch(SB+'/rest/v1/planilla_empleados?select=nombre,num_empleado,bruto,neto,otras_ded,'
      +'planilla_periodos(desde,hasta,fecha_pago,tipo)'
      +'&or=(nombre.ilike.*GUINDI*,nombre.ilike.*NAOR*)'
      +'&order=id&offset='+(pag*1000)+'&limit=1000',{headers:SBH});
    if(!r.ok) throw new Error('planilla: '+r.status);
    var lote=(await r.json())||[];
    filas=filas.concat(lote);
    if(lote.length<1000) break;
  }
  var out=[];
  filas.forEach(function(e){
    var g=_acnGrupoDeEmpleado(e.nombre);
    if(!g) return;
    var P=e.planilla_periodos||{};
    var f=String(P.fecha_pago||P.hasta||P.desde||'').slice(0,10);
    if(!/^\d{4}-\d{2}/.test(f)) return;
    /* Lo que se le PAGÓ es el neto MÁS lo que se aplicó a su préstamo
       (columna «Otras» de la planilla). Con el neto solo, a Jimmy Guindi le
       salía 0 en las quincenas en que el préstamo se come todo, y sí se le
       pagaron 433,46: fueron a su préstamo con la empresa (v716). */
    var neto=Number(e.neto)||0;
    var prestamo=Number(e.otras_ded)||0;
    var pagado=Math.round((neto+prestamo)*100)/100;
    if(!pagado) return;
    out.push({clase:'planilla', _grupo:g, _planilla:true, fecha:f,
      anio:Number(f.slice(0,4)), mes:Number(f.slice(5,7)), monto:pagado,
      neto:neto, prestamo:prestamo,
      accionista:e.nombre, contra_cta:'',
      memo:'Planilla '+(P.tipo||'')+' '+(P.desde||'')+' al '+(P.hasta||'')+' · '+e.nombre
        +' · bruto '+(Number(e.bruto)||0).toFixed(2)
        +(prestamo ? (' · pagado '+pagado.toFixed(2)+' = neto '+neto.toFixed(2)
                      +' + aplicado a préstamo '+prestamo.toFixed(2))
                   : (' · neto '+neto.toFixed(2))),
      nom_cta:'Planilla', tipo_trx:'planilla'});
  });
  return out;
}

async function _acnAbrir(){
  if(!_acnPuede()){ showT('No tienes acceso a esta información'); return; }
  window._acn=window._acn||{lista:[], grupos:{}, anio:'todos', mes:'todos',
                            sel:null, cargado:false};
  if(!document.getElementById('page-accionistas')){
    var ref=document.getElementById('page-banco')
          || document.getElementById('page-alertas')
          || document.querySelector('.page');
    if(ref && ref.parentNode){
      var d=document.createElement('div');
      d.id='page-accionistas'; d.className='page';
      ref.parentNode.appendChild(d);
    }
  }
  go('accionistas');
  _acnPintar();
  // Red de seguridad: si por lo que sea la pantalla no quedó visible (el
  // contenedor se crea al vuelo y un repintado general puede llevárselo),
  // se rehace y se vuelve a pintar.
  setTimeout(function(){
    var el=document.getElementById('page-accionistas');
    if(!el || !el.classList.contains('active') || !el.innerHTML.trim()){
      try{
        if(!el){
          var ref2=document.getElementById('page-banco')
                 || document.querySelector('.page');
          if(ref2 && ref2.parentNode){
            el=document.createElement('div');
            el.id='page-accionistas'; el.className='page';
            ref2.parentNode.appendChild(el);
          }
        }
        if(el){
          document.querySelectorAll('.page').forEach(function(p){
            p.classList.remove('active'); });
          el.classList.add('active');
          PG='accionistas';
          _acnPintar();
        }
      }catch(e){}
    }
  }, 250);
  if(!window._acn.cargado) await _acnCargar();
}

async function _acnCargar(){
  if(!_acnPuede()) return;
  var S=window._acn;
  S.cargando=true; _acnPintar();
  try{
    /* El servidor devuelve como mucho 1.000 filas por consulta, por eso se
       quedaba cortado. Se pide por páginas hasta traerlo todo. */
    var todas=[], pag=0, tope=40;
    S.error='';
    while(pag<tope){
      var desde=pag*1000;
      var r=await fetch(SB+'/rest/v1/accionistas_movimientos?select=*'
        +'&order=fecha.desc&offset='+desde+'&limit=1000',{headers:SBH});
      if(!r.ok){
        var t=await r.text();
        S.error=(t.indexOf('does not exist')>=0)
          ? 'Falta la tabla: corre accionistas.sql en Supabase.'
          : (r.status+' '+t.slice(0,120));
        break;
      }
      var lote=(await r.json())||[];
      todas=todas.concat(lote);
      if(lote.length<1000) break;          // ya no hay más
      pag++;
    }
    // Lo que cobran por planilla, como una clase más
    S.errorPlanilla='';
    try{ todas=todas.concat(await _acnCargarPlanilla()); }
    catch(e){ S.errorPlanilla=String(e.message||e); }
    S.lista=todas;
    _dbg('[ACN] '+todas.length+' movimiento(s) en '+(pag+1)+' página(s)');

    // Cómo se agrupan los nombres de SAP en los siete del tablero
    var rg=await fetch(SB+'/rest/v1/accionistas_grupos?select=*',{headers:SBH});
    S.grupos={};
    if(rg.ok) (await rg.json()||[]).forEach(function(x){
      if(x.activo===false) return;
      S.grupos[String(x.nombre_sap||'').toUpperCase()]=x.grupo;
    });
  }catch(e){ S.error=String(e.message||e); S.lista=[]; }
  S.cargando=false; S.cargado=true;
  _acnPintar();
}

/* El grupo del movimiento. Lo calcula el worker leyendo el concepto (los
   departamentos van escritos ahí: «ACCIONISTA ALFOMBRAS»). La tabla de
   equivalencias queda como respaldo por si hay que corregir algún nombre a
   mano sin tocar el worker. */
function _acnGrupoDe(m){
  /* El grupo que trae la base se calculó con las reglas de SU momento, así
     que NO manda: se vuelve a decidir aquí con las reglas de ahora. Si no,
     un «SAMUEL BENNETT» clasificado ayer como Samuel Guindi seguiría
     saliendo pese a haber corregido la regla. */
  if(m && m._grupo) return m._grupo;      // los de planilla ya vienen con el suyo
  var porTexto=_acnGrupoPorTexto(m);
  if(porTexto) return porTexto;
  return null;
}

/* Quién es, mirando el concepto. Nombre Y apellido, o la etiqueta de la
   cuenta. Nunca por el nombre de pila suelto. */
function _acnGrupoPorTexto(m){
  /* Del concepto, SIEMPRE con apellido. Con el nombre de pila suelto,
     «SAMUEL BENNETT» y «SAMUEL FORJOUN» caían en Samuel Guindi y
     «ARIEL SHACALO» en Ariel Guindi. */
  var t=String((m&&m.memo)||'').toUpperCase();

  // La etiqueta de la cuenta es la más fiable
  if(/ACCIONISTA.*MUEBLE/.test(t))   return 'ACCIONISTA MUEBLES';
  if(/ACCIONISTA.*HOGAR/.test(t))    return 'ACCIONISTA HOGAR';
  if(/ACCIONISTA.*ROPA/.test(t))     return 'ACCIONISTA ROPA';
  if(/ACCIONISTA.*ELECTR/.test(t))   return 'ACCIONISTA ELECTRONICA';
  if(/ACCIONISTA.*ALFOMBRA/.test(t)) return 'ACCIONISTA ALFOMBRA';
  if(/SR\.? *ELI\b/.test(t))         return 'ACCIONISTA ELIAHOU GUINDI';
  if(/SR\.? *SAMY\b/.test(t))        return 'ACCIONISTA SAMUEL GUINDI';

  // Y si no, nombre Y apellido
  if(/JIMMY +GUINDI/.test(t))                  return 'ACCIONISTA MUEBLES';
  if(/(EDUARDO|ERUARDO|EDY) +GUINDI/.test(t))  return 'ACCIONISTA HOGAR';
  if(/(REUBEN|ITAY) +GUINDI/.test(t))          return 'ACCIONISTA ROPA';
  if(/ARIEL +GUINDI/.test(t))                  return 'ACCIONISTA ELECTRONICA';
  if(/GADY +NAOR/.test(t))                     return 'ACCIONISTA ALFOMBRA';
  if(/(SAMUEL|SAMY) +GUINDI/.test(t))          return 'ACCIONISTA SAMUEL GUINDI';
  if(/(ELIAHOU|ELIHOU|ELI) +GUINDI/.test(t))   return 'ACCIONISTA ELIAHOU GUINDI';
  return null;
}


/* Con «sinGrupo» se ignora el accionista elegido y solo se aplican año y
   mes. Lo usan las tarjetas de arriba, que tienen que seguir mostrando SUS
   totales aunque abajo se esté mirando uno concreto. */
/* Cada accionista tiene su cuenta en SAP. Sirve para VALIDAR: si un
   movimiento cae en Muebles por el nombre pero su cuenta es la 1202-003,
   que es la de Eliahou, no pinta nada ahí y se descarta. */
var ACN_CUENTAS={
  '1202-002':'ACCIONISTA SAMUEL GUINDI',
  '1202-003':'ACCIONISTA ELIAHOU GUINDI',
  '1202-010':'ACCIONISTA ELECTRONICA',
  '1202-011':'ACCIONISTA HOGAR',
  '1202-012':'ACCIONISTA MUEBLES',
  '1202-013':'ACCIONISTA ROPA'
};

// ¿La cuenta del movimiento concuerda con el accionista al que lo asigné?
function _acnCuentaCuadra(m, grupo){
  var cta=String((m&&m.contra_cta)||'').slice(0,8);
  var dueno=ACN_CUENTAS[cta];
  if(!dueno) return true;             // cuenta que no es de nadie: no opina
  return dueno===grupo;
}

/* ¿Es una anulación? Lo dice el propio concepto. */
function _acnEsAnulacion(m){
  return /anulac|anulad|reversi|cancelad/i.test(String((m&&m.memo)||''));
}

/* Quita las anulaciones Y el pago que cada una cancela: los dos juntos
   suman cero, así que el total no cambia y la lista queda limpia. */
function _acnSinAnuladas(L){
  var anul=L.filter(_acnEsAnulacion);
  if(!anul.length) return L;
  var restan={};
  anul.forEach(function(a){
    // El pago original: mismo importe, misma cuenta, mismo accionista
    var k=[String(a.contra_cta||''), Math.abs(Number(a.monto)||0).toFixed(2),
           String(_acnGrupoPorTexto(a)||'')].join('|');
    restan[k]=(restan[k]||0)+1;
  });
  return L.filter(function(m){
    if(m._planilla) return true;                  // la planilla no se anula aquí
    if(_acnEsAnulacion(m)) return false;          // fuera la anulación
    var k=[String(m.contra_cta||''), Math.abs(Number(m.monto)||0).toFixed(2),
           String(_acnGrupoPorTexto(m)||'')].join('|');
    if(restan[k]>0){ restan[k]--; return false; } // y fuera su pago
    return true;
  });
}

function _acnFiltradas(sinGrupo){
  var S=window._acn||{};
  return _acnSinAnuladas((S.lista||[]).filter(function(m){
    // Solo los siete. OTROS, proveedores y gastos sueltos no salen aquí.
    var g=_acnGrupoDe(m);
    if(!g) return false;
    // Y la cuenta tiene que ser la suya: un pago con la cuenta de otro
    // accionista no aparece aquí aunque el concepto lleve este nombre.
    if(!_acnCuentaCuadra(m, g)) return false;
    if(S.anio!=='todos' && String(m.anio)!==String(S.anio)) return false;
    if(S.mes!=='todos'  && String(m.mes)!==String(S.mes))  return false;
    if(!sinGrupo && S.sel && _acnGrupoDe(m)!==S.sel) return false;
    return true;
  }));
}

function _acnAnio(v){ window._acn.anio=v; _acnPintar(); }
function _acnMes(v){ window._acn.mes=v; _acnPintar(); }
function _acnSel(g){ window._acn.sel=(window._acn.sel===g)?null:g; _acnPintar(); }

function _acnFila(t, v, col){
  return '<div style="display:flex;justify-content:space-between;font-size:11px;margin-top:2px">'
    +'<span style="color:var(--text-muted)">'+t+'</span><b style="color:'+col+'">'+fmt(Math.abs(v||0))+'</b></div>';
}
// Cuadro 1: pagos = recibido por banco + planilla
function _acnCuadroPagos(d){
  return '<div style="background:var(--pastel-ok);border-radius:9px;padding:7px 9px;margin-top:4px">'
    + _acnFila('Recibido', d.pago, '#166534')
    + _acnFila('Planilla', d.planilla, '#6D28D9')
    +'<div style="border-top:0.5px solid rgba(22,101,52,.25);margin-top:5px;padding-top:4px;'
    +'display:flex;justify-content:space-between;font-size:12px;color:#166534">'
    +'<span style="font-weight:700">Total pagos</span>'
    +'<b>'+fmt(Math.abs(d.pago||0)+Math.abs(d.planilla||0))+'</b></div></div>';
}
// Cuadro 2: reembolsos, aparte
function _acnCuadroReembolsos(d){
  return '<div style="background:var(--pastel-azul);border-radius:9px;padding:7px 9px;margin-top:6px;'
    +'display:flex;justify-content:space-between;font-size:12px;color:#0C447C">'
    +'<span style="font-weight:700">Total reembolsos</span>'
    +'<b>'+fmt(Math.abs(d.reembolso||0))+'</b></div>';
}

function _acnPintar(){
  var c=document.getElementById('page-accionistas'); if(!c) return;
  if(!_acnPuede()){ c.innerHTML=''; return; }
  var S=window._acn||{};
  var L=_acnFiltradas();

  var anios=[...new Set((S.lista||[]).map(function(m){ return m.anio; }))]
            .filter(Boolean).sort(function(a,b){ return b-a; });

  var h='<div style="display:flex;gap:7px;margin-bottom:12px">'
    +'<span class="pill" onclick="_bncAbrir()">'
    +'<i class="ti ti-building-bank"></i> Movimientos</span>'
    +'<span class="pill active"><i class="ti ti-users"></i> Accionistas</span></div>'
    +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'margin-bottom:12px">'
    +'<div style="width:38px;height:38px;border-radius:10px;background:var(--pastel-vino);'
    +'display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-users" style="font-size:20px;color:var(--t-vino)"></i></div>'
    +'<div style="flex:1;min-width:190px">'
    +'<div style="font-size:16px;font-weight:700">Accionistas</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +'Información reservada · '+(S.lista||[]).length+' movimiento(s)</div></div>'
    +'<button class="xb" onclick="_acnCargar()"><i class="ti ti-refresh"></i> '
    +'Actualizar</button>'
    +'<button class="xb" onclick="_acnExportar()"><i class="ti ti-file-export"></i> '
    +'Excel</button></div>';

  if(S.error){
    h+='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo);'
      +'border-left:3px solid var(--t-rojo)">'+_esc(S.error)+'</div>';
  } else if(S.cargado && !(S.lista||[]).length){
    h+='<div class="nota" style="background:var(--pastel-aviso);color:var(--t-marron);'
      +'border-left:3px solid #E9C08A;font-size:12px">'
      +'<b>Todavía no hay movimientos.</b> Hacen falta dos cosas: correr '
      +'<b>accionistas.sql</b> en Supabase y tener el worker <b>2026-10-11-d</b> '
      +'o posterior. En el log saldrá «[sync] accionistas: N movimiento(s)».</div>';
  }

  // Filtros de año y mes
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
    +'<span style="font-size:11.5px;color:var(--text-muted)">Año</span>'
    +'<span class="pill'+(S.anio==='todos'?' active':'')+'" onclick="_acnAnio(\'todos\')">Todos</span>'
    + anios.map(function(a){
        return '<span class="pill'+(String(S.anio)===String(a)?' active':'')+'" '
          +'onclick="_acnAnio(\''+a+'\')">'+a+'</span>'; }).join('')
    +'<span style="width:12px"></span>'
    +'<span style="font-size:11.5px;color:var(--text-muted)">Mes</span>'
    +'<span class="pill'+(S.mes==='todos'?' active':'')+'" onclick="_acnMes(\'todos\')">Todos</span>'
    + ACN_MESES.map(function(nm,i){
        return '<span class="pill'+(String(S.mes)===String(i+1)?' active':'')+'" '
          +'onclick="_acnMes(\''+(i+1)+'\')" title="'+nm+'">'+nm.slice(0,3)+'</span>'; }).join('')
    +'</div>';

  if(S.cargando){
    h+='<div class="empty"><span class="ai-ring g"></span> Cargando…</div>';
    c.innerHTML=h; return;
  }

  // Una tarjeta por accionista, con sus dos totales
  var porGrupo={};
  ACN_GRUPOS.forEach(function(g){ porGrupo[g]={pago:0, reembolso:0, planilla:0, n:0}; });
  var sinAsignar={pago:0, reembolso:0, n:0, nombres:{}};
  // OJO: las tarjetas van con TODOS los accionistas del periodo. Si se
  // calcularan con la lista ya filtrada, al elegir uno los demás se ponían
  // a cero, que no es lo que pasa en la realidad.
  _acnFiltradas(true).forEach(function(m){
    var g=_acnGrupoDe(m);
    var destino=g?porGrupo[g]:sinAsignar;
    if(!destino) return;
    /* CON SIGNO: una anulación viene con el signo contrario justamente
       para cancelar el pago. Sumando en valor absoluto, el cheque anulado
       contaba dos veces en vez de quedar en cero. */
    var v=Number(m.monto)||0;
    if(String(m.clase)==='pago') destino.pago+=v;
    else if(String(m.clase)==='planilla') destino.planilla=(destino.planilla||0)+v;
    else destino.reembolso+=v;
    destino.n++;
    if(!g) sinAsignar.nombres[m.accionista]=(sinAsignar.nombres[m.accionista]||0)+1;
  });

  // Los dos totales de TODOS los accionistas, cada uno en su cuadro
  var todos=ACN_GRUPOS.reduce(function(a,g){
    var d=porGrupo[g];
    a.pago+=Math.abs(d.pago||0); a.planilla+=Math.abs(d.planilla||0);
    a.reembolso+=Math.abs(d.reembolso||0); return a; }, {pago:0, planilla:0, reembolso:0});
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));'
    +'gap:10px;margin-bottom:12px">'
    +'<div style="background:var(--pastel-ok);border-radius:12px;padding:12px 15px;color:#166534">'
    +'<div style="font-size:11px;font-weight:600;opacity:.85">TOTAL PAGOS · recibido + planilla</div>'
    +'<div style="font-size:22px;font-weight:800">'+fmt(todos.pago+todos.planilla)+'</div>'
    +'<div style="font-size:10.5px;opacity:.85">Recibido '+fmt(todos.pago)+' · Planilla '
    +fmt(todos.planilla)+'</div></div>'
    +'<div style="background:var(--pastel-azul);border-radius:12px;padding:12px 15px;color:#0C447C">'
    +'<div style="font-size:11px;font-weight:600;opacity:.85">TOTAL REEMBOLSOS</div>'
    +'<div style="font-size:22px;font-weight:800">'+fmt(todos.reembolso)+'</div>'
    +'<div style="font-size:10.5px;opacity:.85">los siete accionistas, con los filtros de arriba</div>'
    +'</div></div>';

  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(235px,1fr));'
    +'gap:10px;margin-bottom:14px">';
  ACN_GRUPOS.forEach(function(g){
    var d=porGrupo[g], act=(S.sel===g);
    h+='<div onclick="_acnSel(\''+g+'\')" style="cursor:pointer;border-radius:12px;'
      +'padding:11px 13px;border:1.5px solid '+(act?'var(--t-vino)':'var(--border)')+';'
      +'background:'+(act?'var(--pastel-vino)':'var(--surface-0)')+'">'
      +'<div style="font-size:11.5px;font-weight:700;margin-bottom:6px">'
      +_esc(g.replace('ACCIONISTA ',''))+'</div>'
      /* Dos cuadros (v717): lo que se le PAGÓ (recibido por banco + planilla)
         y, aparte, los REEMBOLSOS. Ya no hay un total que lo mezcle todo. */
      + _acnCuadroPagos(d)
      + _acnCuadroReembolsos(d)
      + (ACN_DEUDAS[g]||[]).map(function(x){
          return '<div style="margin-top:6px;background:var(--pastel-aviso);border-radius:7px;'
            +'padding:4px 7px;display:flex;justify-content:space-between;gap:6px;font-size:10.5px;'
            +'color:var(--t-marron)" title="'+_esc(x.concepto)+'"><span>Se le debe · '
            +_esc(x.concepto.replace('Planilla pendiente de pago','planilla'))+'</span>'
            +'<b>'+fmt(x.monto)+'</b></div>'; }).join('')
      +'</div>';
  });
  h+='</div>';

  if(S.sel){
    h+='<div style="display:flex;align-items:center;gap:9px;margin-bottom:11px;'
      +'font-size:12px">'
      +'<span style="background:var(--pastel-vino);color:var(--t-vino);'
      +'border-radius:999px;padding:4px 12px;font-weight:700">'
      +'<i class="ti ti-filter"></i> Viendo solo '
      +_esc(String(S.sel).replace('ACCIONISTA ',''))+'</span>'
      +'<button class="xb" onclick="_acnSel(\''+S.sel+'\')">'
      +'<i class="ti ti-x"></i> Ver todos</button></div>';
  }

  // Lo que no es de los siete no se cuenta ni se enseña

  // Los dos paneles del accionista elegido
  h+= _acnDeudasHtml(S.sel)
    + _acnPanelMeses(L, 'pago',      'Montos recibidos', '#166534', 'var(--pastel-ok)')
    + _acnPanelMeses(L, 'reembolso', 'Reembolsos recibidos', '#0C447C', 'var(--pastel-azul)')
    + _acnPanelMeses(L, 'planilla',  'Pagos por planilla', '#6D28D9', 'var(--pastel-lila)')
    + (S.errorPlanilla?('<div class="nota" style="font-size:11px">No pude leer los pagos por planilla: '
        +_esc(S.errorPlanilla)+'</div>'):'');

  c.innerHTML=h;
}

/* Lo que se le debe a cada accionista: saldo aparte, sin filtros de fecha */
function _acnDeudasHtml(sel){
  var gs=Object.keys(ACN_DEUDAS).filter(function(g){ return !sel || sel===g; });
  if(!gs.length) return '';
  var total=0, filas='';
  gs.forEach(function(g){
    ACN_DEUDAS[g].forEach(function(x){
      total+=x.monto;
      filas+='<div style="display:flex;align-items:center;gap:10px;padding:9px 14px;'
        +'border-top:0.5px solid var(--border)"><b style="font-size:12.5px">'
        +_esc(g.replace('ACCIONISTA ',''))+'</b><span style="flex:1;font-size:12px;'
        +'color:var(--text-muted)">'+_esc(x.concepto)+'</span>'
        +'<b style="font-size:13.5px;color:var(--t-marron)">'+fmt(x.monto)+'</b></div>';
    });
  });
  return '<div style="border:0.5px solid var(--border);border-radius:12px;overflow:hidden;'
    +'margin-bottom:14px;background:var(--surface-0)">'
    +'<div style="background:var(--pastel-aviso);padding:11px 14px;display:flex;align-items:center;gap:9px">'
    +'<i class="ti ti-file-invoice" style="font-size:17px;color:var(--t-marron)"></i>'
    +'<b style="font-size:13.5px;color:var(--t-marron)">Saldos pendientes de pago al accionista</b>'
    +'<span style="flex:1"></span><b style="font-size:16px;color:var(--t-marron)">'+fmt(total)+'</b></div>'
    + filas
    +'<div style="padding:6px 14px;font-size:10.5px;color:var(--text-muted);border-top:0.5px solid var(--border)">'
    +'Es lo que la empresa le debe; no entra en lo recibido ni cambia con el año o el mes.</div></div>';
}

/* Un panel por clase: los meses en filas, con su total, y el detalle de los
   movimientos del mes al pulsar. */
/* Un panel por clase. Los meses en filas, alternando color, con una barra
   que compara de un vistazo cuánto pesa cada mes. Antes era una lista de
   números a la que había que seguirle la pista con el dedo. */
function _acnPanelMeses(L, clase, titulo, color, fondo){
  var filas=L.filter(function(m){ return String(m.clase)===clase; });
  var S=window._acn||{};
  var porMes={}, total=0;
  filas.forEach(function(m){
    var k=m.anio+'-'+String(m.mes).padStart(2,'0');
    porMes[k]=porMes[k]||{n:0, v:0, anio:m.anio, mes:m.mes};
    var v=Number(m.monto)||0;          // con signo: las anulaciones restan
    porMes[k].v+=v; porMes[k].n++; total+=v;
  });
  var meses=Object.keys(porMes).sort().reverse();
  var mayor=meses.reduce(function(a,k){
    return Math.max(a, Math.abs(porMes[k].v)); }, 0) || 1;

  var h='<div style="border:0.5px solid var(--border);border-radius:12px;'
    +'overflow:hidden;margin-bottom:14px;background:var(--surface-0)">'
    +'<div style="background:'+fondo+';padding:11px 14px;display:flex;'
    +'align-items:center;gap:9px;flex-wrap:wrap">'
    +'<i class="ti '+(clase==='pago'?'ti-arrow-down-left':(clase==='planilla'?'ti-users-group':'ti-receipt-refund'))
    +'" style="font-size:17px;color:'+color+'"></i>'
    +'<b style="font-size:13.5px;color:'+color+'">'+_esc(titulo)+'</b>'
    +(S.sel?('<span style="background:'+color+';color:#fff;border-radius:999px;'
      +'padding:1px 9px;font-size:10.5px;font-weight:700">'
      +_esc(String(S.sel).replace('ACCIONISTA ',''))+'</span>'):'')
    +'<span style="flex:1"></span>'
    +'<span style="font-size:11px;color:'+color+';opacity:.8">'
    +filas.length+' movimiento(s)</span>'
    +'<b style="font-size:16px;color:'+color+'">'+fmt(Math.abs(total))+'</b></div>';

  if(!meses.length){
    h+='<div class="empty" style="padding:18px;font-size:11.5px">'
      +'Sin movimientos con estos filtros</div></div>';
    return h;
  }

  meses.forEach(function(k, i){
    var d=porMes[k];
    var ancho=Math.max(3, Math.round(Math.abs(d.v)/mayor*100));
    var zebra=(i%2)?'background:var(--bg-accent)':'';
    h+='<div onclick="_acnVerMes(\''+clase+'\','+d.anio+','+d.mes+')" '
      +'style="position:relative;cursor:pointer;padding:10px 14px;'
      +'border-top:0.5px solid var(--border);'+zebra+'" '
      +'onmouseover="this.style.filter=\'brightness(.97)\'" '
      +'onmouseout="this.style.filter=\'\'" '
      +'title="Ver el detalle de '+_esc(ACN_MESES[d.mes-1])+'">'
      // La barra de fondo: cuánto pesa este mes frente al mayor
      +'<div style="position:absolute;left:0;top:0;bottom:0;width:'+ancho+'%;'
      +'background:'+fondo+';opacity:.55"></div>'
      +'<div style="position:relative;display:flex;align-items:center;gap:10px">'
      +'<div style="flex:1;min-width:0">'
      +'<b style="font-size:12.5px">'+_esc(ACN_MESES[d.mes-1])+'</b> '
      +'<span style="font-size:11.5px;color:var(--text-muted)">'+d.anio+'</span>'
      +'</div>'
      +'<span style="font-size:10.5px;color:var(--text-muted);white-space:nowrap">'
      +d.n+' mov.</span>'
      +'<b style="font-size:13.5px;color:'+color+';white-space:nowrap;'
      +'min-width:96px;text-align:right">'+fmt(Math.abs(d.v))+'</b>'
      +'<i class="ti ti-chevron-right" style="color:var(--text-muted);'
      +'font-size:14px"></i>'
      +'</div></div>';
  });

  h+='<div style="background:'+fondo+';padding:11px 14px;display:flex;'
    +'align-items:center;gap:10px;border-top:1px solid '+color+'33">'
    +'<b style="flex:1;font-size:12.5px;color:'+color+'">TOTAL</b>'
    +'<span style="font-size:10.5px;color:'+color+';opacity:.8">'
    +filas.length+' mov.</span>'
    +'<b style="font-size:15px;color:'+color+';min-width:96px;text-align:right">'
    +fmt(total)+'</b>'
    +'<span style="width:14px"></span></div>';
  h+='</div>';
  return h;
}

/* El detalle de un mes: a pantalla completa, con el memo entero y una
   pastilla de color por accionista. Antes era una ventanita apretada. */
function _acnVerMes(clase, anio, mes){
  var L=_acnFiltradas().filter(function(m){
    return String(m.clase)===clase && m.anio===anio && m.mes===mes; });
  if(!L.length) return;
  L.sort(function(a,b){ return String(a.fecha).localeCompare(String(b.fecha)); });
  // Con signo: la anulación resta, que es justo para lo que existe
  var total=L.reduce(function(a,m){ return a+(Number(m.monto)||0); },0);
  var esPago=(clase==='pago'), esPla=(clase==='planilla');
  var col   = esPago ? '#166534' : (esPla ? '#6D28D9' : '#0C447C');
  var fondo = esPago ? 'var(--pastel-ok)' : (esPla ? 'var(--pastel-lila)' : 'var(--pastel-azul)');

  var porAcc={};
  L.forEach(function(m){
    var g=String(_acnGrupoDe(m)||'').replace('ACCIONISTA ','');
    porAcc[g]=(porAcc[g]||0)+(Number(m.monto)||0);
  });

  var prev=document.getElementById('modalAcnMes'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalAcnMes';
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:12400;'
    +'display:flex;flex-direction:column;padding:12px 14px;overflow:hidden';

  var sel=(window._acn||{}).sel;
  var h='<div style="display:flex;align-items:center;gap:11px;flex-wrap:wrap;'
    +'margin-bottom:10px">'
    +'<div style="width:34px;height:34px;border-radius:9px;background:'+fondo+';'
    +'display:flex;align-items:center;justify-content:center">'
    +'<i class="ti '+(esPago?'ti-arrow-down-left':'ti-receipt-refund')
    +'" style="font-size:17px;color:'+col+'"></i></div>'
    +'<div style="flex:1;min-width:200px">'
    +'<div style="font-size:16px;font-weight:700">'+_esc(ACN_MESES[mes-1])+' '+anio+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +(esPago?'Montos recibidos':(esPla?'Pagos por planilla':'Reembolsos recibidos'))+' · '+L.length+' movimiento(s)'
    +(sel ? (' · '+_esc(String(sel).replace('ACCIONISTA ',''))) : '')
    +'</div></div>'
    +'<div style="font-size:19px;font-weight:800;color:'+col+'">'
    +fmt(Math.abs(total))+'</div>'
    +'<button class="btn bg2" style="padding:8px 14px" '
    +'onclick="document.getElementById(\'modalAcnMes\').remove()">'
    +'<i class="ti ti-x"></i> Cerrar</button></div>';

  var accs=Object.keys(porAcc).sort(function(a,b){ return porAcc[b]-porAcc[a]; });
  if(accs.length>1){
    h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px">'
      + accs.map(function(g){
          return '<div style="background:var(--surface-0);border:0.5px solid var(--border);'
            +'border-radius:9px;padding:6px 11px">'
            +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(g)+'</div>'
            +'<div style="font-size:13px;font-weight:700;color:'+col+'">'
            +fmt(Math.abs(porAcc[g]))+'</div></div>';
        }).join('')
      +'</div>';
  }

  var th='padding:9px 11px;font-size:10.5px;font-weight:700;color:#fff;'
        +'text-align:left;position:sticky;top:0;background:'+col+';z-index:1';
  h+='<div style="flex:1;min-height:0;border:0.5px solid var(--border);'
    +'border-radius:12px;overflow:auto;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px">'
    +'<thead><tr>'
    +'<th style="'+th+';width:100px">FECHA</th>'
    +'<th style="'+th+';width:150px">ACCIONISTA</th>'
    +'<th style="'+th+';width:330px">MEMO</th>'
    +'<th style="'+th+';width:230px">CONCEPTO DE LA CUENTA</th>'
    +'<th style="'+th+';width:125px">TIPO</th>'
    +'<th style="'+th+';width:100px">CUENTA</th>'
    +'<th style="'+th+';width:120px;text-align:right">MONTO</th>'
    +'</tr></thead><tbody>';

  var ultimo='', anuladas=0;
  L.forEach(function(m, i2){
    var zebra=(i2%2)?'background:var(--bg-accent)':'';
    var td='padding:8px 11px;border-bottom:0.5px solid var(--border);vertical-align:top';
    var nuevoDia=(String(m.fecha||'')!==ultimo); ultimo=String(m.fecha||'');
    // Una anulación cancela un pago: se marca y resta del total
    var signo=Number(m.monto)||0;
    var esAnula=/anulac|anulad|reversi|cancelad/i.test(String(m.memo||''))
             || (esPago ? signo>0 : signo<0);
    if(esAnula) anuladas++;
    h+='<tr style="'+zebra+'">'
      +'<td style="'+td+';white-space:nowrap;'
      +(nuevoDia?'font-weight:700':'color:var(--text-muted)')+'">'
      +(nuevoDia?_esc(_fechaCorta(m.fecha)):'·')+'</td>'
      +'<td style="'+td+'"><span style="background:'+fondo+';color:'+col+';'
      +'border-radius:7px;padding:2px 8px;font-size:10.5px;font-weight:700;'
      +'white-space:nowrap">'
      +_esc(String(_acnGrupoDe(m)||'').replace('ACCIONISTA ',''))+'</span></td>'
      // El memo recortado: ocupaba media pantalla. Completo al pasar el ratón.
      +'<td style="'+td+';line-height:1.4;max-width:330px;overflow:hidden;'
      +'text-overflow:ellipsis;white-space:nowrap" title="'
      +_esc(m.memo||'')+'">'+_esc(m.memo||'')+'</td>'
      // El nombre de la contrapartida dice QUÉ se pagó: viáticos, muestras,
      // comisiones… Es la explicación que no está en el memo.
      +'<td style="'+td+';font-size:11px;line-height:1.4">'
      +'<b>'+_esc(m.nom_cta||m.nombre_cuenta||'')+'</b>'
      +(m.tipo_cta?('<br><span style="color:var(--text-muted);font-size:10px">'
         +_esc(m.tipo_cta)+'</span>'):'')+'</td>'
      +'<td style="'+td+';font-size:11px;color:var(--text-secondary)">'
      +_esc(m.tipo_trx||'')+'</td>'
      +'<td style="'+td+';font-size:10.5px;color:var(--text-muted);white-space:nowrap">'
      +_esc(m.contra_cta||'')+'</td>'
      +'<td style="'+td+';text-align:right;font-weight:700;white-space:nowrap;'
      +'color:'+(esAnula?'var(--t-rojo)':col)+'">'
      +(esAnula?'−':'')+fmt(Math.abs(Number(m.monto)||0))+'</td></tr>';
  });
  h+='<tr style="background:'+fondo+'">'
    +'<td colspan="6" style="padding:10px 11px;font-weight:800">TOTAL · '
    +L.length+' movimiento(s)'
    +(anuladas?(' · '+anuladas+' anulación(es) descontada(s)'):'')+'</td>'
    +'<td style="padding:10px 11px;text-align:right;font-weight:800;font-size:14px;'
    +'color:'+col+'">'+fmt(Math.abs(total))+'</td></tr>'
    +'</tbody></table></div>';

  ov.innerHTML=h;
  document.body.appendChild(ov);
  var cerrar=function(e){
    if(e.key==='Escape'){ ov.remove(); document.removeEventListener('keydown', cerrar); }
  };
  document.addEventListener('keydown', cerrar);
}

function _acnExportar(){
  var L=_acnFiltradas();
  if(!L.length){ showT('No hay nada que exportar'); return; }
  var filas=[['Fecha','Anio','Mes','Accionista','Clase','Monto','Memo',
              'Concepto de la cuenta','Tipo de cuenta','Tipo','Cuenta',
              'Contra cuenta']];
  L.forEach(function(m){
    filas.push([m.fecha||'', m.anio||'', m.mes||'',
                String(_acnGrupoDe(m)||'').replace('ACCIONISTA ',''),
                m.clase||'', Math.abs(Number(m.monto)||0), m.memo||'',
                m.nom_cta||m.nombre_cuenta||'', m.tipo_cta||'',
                m.tipo_trx||'', m.cuenta||'', m.contra_cta||'']);
  });
  var S=window._acn||{};
  Object.keys(ACN_DEUDAS).forEach(function(g){
    if(S.sel && S.sel!==g) return;
    ACN_DEUDAS[g].forEach(function(x){
      filas.push(['', x.desde||'', '', g.replace('ACCIONISTA ',''), 'saldo pendiente',
                  x.monto, x.concepto, '', '', '', '', '']);
    });
  });
  var csv=filas.map(function(f){
    return f.map(function(v){
      var t=String(v==null?'':v).replace(/"/g,'""');
      return /[",;\n]/.test(t) ? ('"'+t+'"') : t;
    }).join(';');
  }).join('\n');
  var blob=new Blob(['\ufeff'+csv], {type:'text/csv;charset=utf-8'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download='accionistas_'+_hoyISO()+'.csv';
  document.body.appendChild(a); a.click(); a.remove();
}

/* ═══════════════════════════════════════════════════════════════════════════
   PLANILLA · marcaciones del reloj vs planilla calculada   (prefijo [PLA])
   ───────────────────────────────────────────────────────────────────────────
   Deicy sube los dos archivos y la IA los cruza: busca marcaciones que
   falten, horas que no cuadren con lo pagado, salarios fuera de lo normal y
   cualquier cosa que no encaje. Es información de sueldos, así que la lista
   de quién entra es corta y está aquí, en un solo sitio.
   ═══════════════════════════════════════════════════════════════════════════ */
var PLA_PERMITIDOS=['deici@kennedyzl.com',        // Deicy Soto
                    'sano@kennedyzl.com',         // Saúl Noblesilla
                    'edy@kennedyzl.com',
                    'jimmys@kennedyzl.com',
                    'itay@kennedyzl.com',
                    'ariel@kennedyzl.com',
                    'dan@kennedyzl.com'];

function _plaPuede(){
  try{
    var e=String((CU&&CU.email)||'').trim().toLowerCase();
    return !!e && PLA_PERMITIDOS.indexOf(e)>=0;
  }catch(err){ return false; }
}

async function _plaAbrir(){
  if(!_plaPuede()){ showT('No tienes acceso a esta pantalla'); return; }
  window._pla=window._pla||{reloj:null, planilla:null, revision:null};
  if(!document.getElementById('page-planilla')){
    var ref=document.getElementById('page-alertas') || document.querySelector('.page');
    if(ref && ref.parentNode){
      var d=document.createElement('div');
      d.id='page-planilla'; d.className='page';
      ref.parentNode.appendChild(d);
    }
  }
  go('planilla');
  _plaPintar();
  await _plaCargarSinReloj();          // los que se marcaron «No marca»
  _plpDatos().then(function(d){ window._plpCache=d; _plaPintar(); }).catch(function(){});
  await _plaCargarPeriodos();
  var P=(window._pla.periodos||[])[0];
  if(P && !window._pla.periodo) await _plaVerPeriodo(P.id);
}

function _plaPintar(){
  var c=document.getElementById('page-planilla'); if(!c) return;
  if(!_plaPuede()){ c.innerHTML=''; return; }
  var S=window._pla||{};

  var h='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'margin-bottom:12px">'
    +'<div style="width:38px;height:38px;border-radius:10px;background:var(--pastel-lila);'
    +'display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-clock-dollar" style="font-size:20px;color:var(--t-lila)"></i></div>'
    +'<div style="flex:1;min-width:200px">'
    +'<div style="font-size:16px;font-weight:700">Planilla</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +'Información reservada</div></div>'
    +(S.periodo?('<button class="xb" style="color:var(--text-danger)" '
      +'onclick="_plaBorrarPeriodo('+S.periodo.id+')" '
      +'title="Borrar esta planilla y todo lo suyo">'
      +'<i class="ti ti-trash"></i> Borrar esta</button>'):'')
    +'<button class="btn" style="padding:7px 13px;background:#B45309;color:#fff" onclick="_plpAbrir()">'
    +'<i class="ti ti-cash"></i> Préstamos</button>'
    +'<button class="xb" onclick="_plaCargarPeriodos(true)">'
    +'<i class="ti ti-refresh"></i> Actualizar</button>'
    +'<button class="btn bg2" style="padding:7px 13px" onclick="_plaVerSubida()">'
    +'<i class="ti ti-upload"></i> Subir informes</button></div>';

  // Los cortes disponibles
  var pers=S.periodos||[];
  if(pers.length){
    var anios=[...new Set(pers.map(_plaAnioDe))].filter(Boolean)
      .sort().reverse();
    var anio=S.anio||anios[0];
    var tipos=[...new Set(pers.map(function(p){
      return _plaTipo(p.tipo); }))];

    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;'
      +'margin-bottom:9px">'
      +'<span style="font-size:11.5px;color:var(--text-muted)">Año</span>'
      + anios.map(function(a){
          return '<span class="pill'+(String(anio)===String(a)?' active':'')+'" '
            +'onclick="_plaAnio(\''+a+'\')">'+a+'</span>'; }).join('')
      + (tipos.length>1
         ? ('<span style="width:10px"></span>'
            +'<span style="font-size:11.5px;color:var(--text-muted)">Tipo</span>'
            +'<span class="pill'+(!S.tipo?' active':'')+'" '
            +'onclick="_plaTipoFiltro(\'\')">Todos</span>'
            + tipos.map(function(t){
                return '<span class="pill'+(S.tipo===t?' active':'')+'" '
                  +'onclick="_plaTipoFiltro(\''+_esc(t)+'\')">'
                  +_esc(t)+'</span>'; }).join(''))
         : '')
      +'<span style="flex:1"></span>'
      +'<button class="xb" onclick="_plaResumenAnual()">'
      +'<i class="ti ti-calendar-stats"></i> Resumen del año</button>'
      +'</div>';

    var visibles=pers.filter(function(p){
      return _plaAnioDe(p)===String(anio)
          && (!S.tipo || _plaTipo(p.tipo)===S.tipo); });

    /* ¿Hay dos planillas del mismo corte y tipo? Pasa cuando una se guardó
       con el tipo escrito de otra forma («Regular» frente a «Quincena») y
       entonces no se reemplazó. Se avisa y se puede borrar la repetida. */
    var vistas={}, repes=[];
    pers.forEach(function(p){
      var k=p.desde+'|'+p.hasta+'|'+_plaTipo(p.tipo);
      if(vistas[k]) repes.push(p); else vistas[k]=p;
    });
    if(repes.length){
      h+='<div class="nota" style="background:var(--pastel-aviso);'
        +'color:var(--t-marron);font-size:12px">'
        +'<b>'+repes.length+' planilla(s) repetida(s):</b> '
        + repes.map(function(p){
            return _esc(_plaRotulo(p))+' ('+_esc(_plaTipo(p.tipo))+')'; }).join(', ')
        +' · <span onclick="_plaBorrarRepes()" style="cursor:pointer;'
        +'text-decoration:underline;font-weight:700">borrar las repetidas</span>'
        +' · se conserva la más antigua de cada corte</div>';
    }
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;'
      +'margin-bottom:12px">'
      + visibles.map(function(p){
          var act=(S.periodo && S.periodo.id===p.id);
          var t=_plaTipo(p.tipo);
          return '<span class="pill'+(act?' active':'')+'" '
            +'onclick="_plaVerPeriodo('+p.id+')" title="'+_esc(t)+'">'
            +_esc(_plaRotulo(p))
            +(t!=='Quincena'?(' <b style="opacity:.75">'+_esc(t)+'</b>'):'')
            +'</span>'; }).join('')
      + (visibles.length?'':'<span style="font-size:11.5px;color:var(--text-muted)">'
          +'Nada guardado con esos filtros</span>')
      +'</div>';
  }

  if(S.vista==='preliminar' && S.planilla){
    c.innerHTML=h+_plaPanelPreliminar(S);
    return;
  }
  if(S.subiendo || !pers.length){
    h+=_plaPanelSubida(S);
    c.innerHTML=h;
    return;
  }

  var P=S.periodo;
  if(!P){ c.innerHTML=h+'<div class="empty">Elige una quincena</div>'; return; }
  var emps=(S.empleados||[]).slice();

  // Resumen de la quincena
  var sum=function(k){ return emps.reduce(function(a,e){ return a+(Number(e[k])||0); },0); };
  var kpi=function(t,v,col,bg,ic){
    return '<div style="background:'+bg+';border-radius:12px;padding:11px 14px">'
      +'<div style="font-size:10.5px;color:'+col+';opacity:.85;display:flex;'
      +'align-items:center;gap:5px"><i class="ti '+ic+'"></i>'+_esc(t)+'</div>'
      +'<div style="font-size:17px;font-weight:800;color:'+col+';margin-top:2px">'
      +v+'</div></div>';
  };
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));'
    +'gap:10px;margin-bottom:14px">'
    + kpi('Empleados', emps.length, 'var(--t-lila)', 'var(--pastel-lila)', 'ti-users')
    // v764: como la planilla impresa: ingresos ya sin ausencias/tardanzas y
    // deducciones sin ellas (ISR, SS, SE y otras). Bruto − deducciones = neto.
    + kpi('Salario bruto', fmt(sum('bruto')-sum('aus_tard')), '#166534', 'var(--pastel-ok)', 'ti-cash')
    + kpi('Deducciones', fmt(sum('isr')+sum('ss')+sum('se')+sum('otras_ded')),
          '#991B1B', 'var(--pastel-error)', 'ti-minus')
    + kpi('Neto a pagar', fmt(sum('neto')), '#0C447C', 'var(--pastel-azul)', 'ti-wallet')
    + kpi('Horas del reloj', _fmtN2(emps.reduce(function(a,e){
        return a+(Number(e.horas_reloj)||0); },0)), '#B45309',
        'var(--pastel-aviso)', 'ti-clock')
    +'</div>';

  // Desglose de deducciones, que es lo que más se pregunta
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px;'
    +'font-size:11.5px">'
    + [['I.S.R.','isr'],['Seguro Social','ss'],['Seguro Educativo','se'],
       ['Ausencias y tardanzas','aus_tard'],['Otras (préstamos…)','otras_ded']]
      .map(function(d){
        var v=sum(d[1]);
        if(!v) return '';
        return '<span style="background:var(--surface-0);border:0.5px solid var(--border);'
          +'border-radius:999px;padding:4px 12px">'+_esc(d[0])+': <b>'+fmt(v)+'</b></span>';
      }).join('')
    +'</div>';

  // Las tres vistas de la quincena
  var pest=function(k, t, n){
    return '<span class="pill'+(((S.tab||'empleados')===k)?' active':'')+'" '
      +'onclick="_plaTab(\''+k+'\')">'+t
      +(n?(' <b style="opacity:.75">'+n+'</b>'):'')+'</span>';
  };
  var conDesc=emps.filter(function(e){ return (Number(e.otras_ded)||0)>0; });
  var conMarc=emps.filter(function(e){ return e.dias_reloj; });
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
    + pest('empleados','Empleados', emps.length)
    + pest('descuentos','Descuentos', conDesc.length)
    + pest('marcaciones','Marcaciones', conMarc.length)
    +'</div>';

  // Buscador
  h+='<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:11px">'
    +'<input id="plaBuscar" value="'+_esc(S.q||'')+'" '
    +'placeholder="Buscar por nombre o número de empleado…" '
    +'oninput="_plaFiltrar(this.value)" style="flex:1;min-width:240px;'
    +'padding:8px 14px;border:0.5px solid var(--border);border-radius:999px;'
    +'font-size:12.5px;background:var(--surface-0);color:var(--text-primary)">'
    +'<button class="xb" onclick="_plaExportarExcel()">'
    +'<i class="ti ti-file-export"></i> Excel</button></div>';

  // El listado
  var q=String(S.q||'').toLowerCase().trim();
  if(q) emps=emps.filter(function(e){
    return String(e.nombre||'').toLowerCase().indexOf(q)>=0
        || String(e.num_empleado||'').indexOf(q)>=0; });
  emps.sort(function(a,b){ return String(a.nombre||'').localeCompare(String(b.nombre||'')); });

  if((S.tab||'empleados')==='descuentos'){ c.innerHTML=h+_plaTablaDescuentos(emps); return; }
  if((S.tab||'empleados')==='marcaciones'){ c.innerHTML=h+_plaTablaMarcaciones(emps); return; }

  var th='padding:9px 11px;font-size:10.5px;font-weight:700;color:#fff;'
        +'text-align:left;position:sticky;top:0;background:#5B21B6;z-index:1';
  h+='<div style="border:0.5px solid var(--border);border-radius:12px;'
    +'overflow:auto;max-height:62vh;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px">'
    +'<thead><tr>'
    +'<th style="'+th+';width:70px">Nº</th>'
    +'<th style="'+th+'">EMPLEADO</th>'
    +'<th style="'+th+';width:95px;text-align:right">BRUTO</th>'
    +'<th style="'+th+';width:95px;text-align:right">DEDUCC.</th>'
    +'<th style="'+th+';width:95px;text-align:right">NETO</th>'
    +'<th style="'+th+';width:80px;text-align:right">HORAS</th>'
    +'<th style="'+th+';width:30px"></th></tr></thead><tbody>';

  emps.forEach(function(e, i){
    var ded=(Number(e.isr)||0)+(Number(e.ss)||0)+(Number(e.se)||0)
           +(Number(e.aus_tard)||0)+(Number(e.otras_ded)||0);
    var td='padding:9px 11px;border-bottom:0.5px solid var(--border)';
    h+='<tr style="cursor:pointer;'+((i%2)?'background:var(--bg-accent)':'')+'" '
      +'onclick="_plaFicha(\''+_esc(e.num_empleado)+'\')" '
      +'onmouseover="this.style.filter=\'brightness(.97)\'" '
      +'onmouseout="this.style.filter=\'\'">'
      +'<td style="'+td+';color:var(--text-muted)">'+_esc(e.num_empleado||'')+'</td>'
      +'<td style="'+td+'"><b>'+_esc(e.nombre||'')+'</b>'
      +(e.otras_ded>0?(' <span style="background:var(--pastel-aviso);'
        +'color:var(--t-marron);border-radius:6px;padding:1px 7px;font-size:10px;'
        +'font-weight:700">descuento '+fmt(e.otras_ded)+'</span>'):'')
      +(e.sobretiempo>0?(' <span style="background:var(--pastel-ok);'
        +'color:var(--t-verde);border-radius:6px;padding:1px 7px;font-size:10px;'
        +'font-weight:700">extras</span>'):'')
      +'</td>'
      +'<td style="'+td+';text-align:right">'+fmt(e.bruto)+'</td>'
      +'<td style="'+td+';text-align:right;color:#991B1B">'+(ded?('−'+fmt(ded)):'—')+'</td>'
      +'<td style="'+td+';text-align:right;font-weight:800;color:#166534">'
      +fmt(e.neto)+'</td>'
      +'<td style="'+td+';text-align:right;color:var(--text-muted)">'
      +(e.horas_reloj!=null?_fmtN2(e.horas_reloj):'—')+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'
      +'<i class="ti ti-chevron-right"></i></td></tr>';
  });
  h+='</tbody></table></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:8px">'
    +emps.length+' empleado(s)'+(q?(' de '+(S.empleados||[]).length):'')+'</div>';

  c.innerHTML=h;
}

function _plaRotulo(p){
  try{
    var d=String(p.desde||'').split('-'), h=String(p.hasta||'').split('-');
    var M=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    return Number(d[2])+' '+M[Number(d[1])-1]+' – '+Number(h[2])+' '+M[Number(h[1])-1]
      +' '+h[0];
  }catch(e){ return 'Planilla '+(p.numero||p.id); }
}

/* Al escribir se repinta la tabla entera, así que hay que devolver el foco
   y el cursor al buscador: si no, había que escribir tecla a tecla. */
function _plaFiltrar(v){
  window._pla.q=v;
  var el=document.getElementById('plaBuscar');
  var pos=el?el.selectionStart:null;
  _plaPintar();
  var el2=document.getElementById('plaBuscar');
  if(el2){
    el2.focus();
    try{ if(pos!=null) el2.setSelectionRange(pos, pos); }catch(e){}
  }
}


/* Lee el archivo y lo deja listo para la IA. Excel y CSV se convierten a
   texto para que la IA pueda leerlos; el PDF va como documento. */

/* La revisión. Se le manda a la IA el contenido de los dos archivos y se le
   pide que cruce empleado por empleado, en vez de resumir. */
async function _plaRevisar(){
  var S=window._pla||{};
  if(!S.reloj || !S.planilla){ showT('Faltan archivos'); return; }
  var caja=document.getElementById('pla-resultado');
  if(caja) caja.innerHTML='<div style="padding:16px;font-size:12px;color:var(--t-lila)">'
    +'<span class="ai-ring g"></span> Comprobando las cuentas…</div>';

  /* Primero las comprobaciones EXACTAS, que no necesitan IA y no se
     equivocan: seguro social, seguro educativo, neto y sumas. Lo que la IA
     aporta después es el ojo para lo que no cabe en una fórmula. */
  var ciertos=_plaRevisarCuentas((S.planilla.datos||{}).empleados||[],
                                 S.reloj?S.reloj.datos:null);
  // Los préstamos, con el saldo SIN contar esta quincena (aún no guardada)
  var Pq=((S.planilla.datos||{}).periodo)||{}, prestD=null;
  try{ prestD=await _plpDatos({desde:Pq.desde, hasta:Pq.hasta}); }catch(e){}
  ciertos=ciertos.concat(_plaRevisarPrestamos((S.planilla.datos||{}).empleados||[], prestD, Pq));
  ciertos=_plaConPagoVsDebe(ciertos, (S.planilla.datos||{}).empleados||[], prestD, Pq);
  if(caja) caja.innerHTML=_plaInforme({
    resumen:(ciertos.length?('Comprobación de cuentas: '+ciertos.length
      +' cosa(s) que revisar. Preguntando a la IA por el resto…')
      :'Las cuentas cuadran en todos los empleados. Preguntando a la IA…'),
    hallazgos:ciertos});

  // Se le manda lo YA INTERPRETADO, no el PDF entero: así la IA compara
  // cifras en vez de pelearse con el formato.
  var bloques=[{type:'text',
    text:'=== PLANILLA CALCULADA ===\n'
      + JSON.stringify((S.planilla.datos||{}).empleados||[]).slice(0,170000)},
    {type:'text',
    text:'=== MARCACIONES DEL RELOJ ===\n'
      + JSON.stringify(S.reloj.datos||[]).slice(0,170000)}];

  bloques.push({type:'text', text:
    'Sos el auditor de planilla de KENNEDY CENTER CORP (Panamá).\n\n'
    +'REGLAS DE LA CASA, no las discutas:\n'
    +'- El salario regular es FIJO por quincena. NO sale de las horas del '
    +'reloj, así que NO señales que las horas no cuadran con el sueldo.\n'
    +'- Seguro social = 9,75 % y seguro educativo = 1,25 %, los dos sobre el '
    +'bruto MENOS ausencias y tardanzas. Eso ya lo comprobé yo, no lo repitas.\n'
    +'- Hay días en que NADIE marca y aun así cuentan 8 horas: son feriados '
    +'de la empresa, por ejemplo Yom Kipur. NO son errores.\n'
    +'- En «Otras» deducciones van préstamos y deudas con la empresa. Es '
    +'normal; solo señálalo si cambia mucho respecto a otras quincenas.\n'
    +'- Estas personas NO fichan en el reloj y es lo correcto. NUNCA digas que '
    +'les faltan marcaciones: '+PLA_SIN_RELOJ.concat(window._plaSinRelojExtra||[]).join(', ')+'.\n\n'
    +'Te paso DOS archivos: las marcaciones del reloj (entrada, salida y '
    +'almuerzo de cada empleado) y la planilla ya calculada por el programa '
    +'de nóminas.\n\n'
    +'CRUZA LOS DOS, empleado por empleado, y busca:\n'
    +'1. Empleados que están en la planilla y NO tienen marcaciones, o al revés.\n'
    +'2. Días sin marcación de entrada o de salida, o sin almuerzo cuando el '
    +'resto de días sí lo tiene.\n'
    +'3. Horas trabajadas que NO cuadran con las horas pagadas.\n'
    +'4. Horas extra pagadas sin marcaciones que las respalden.\n'
    +'5. Marcaciones imposibles: salida antes de la entrada, jornadas de más '
    +'de 16 horas, almuerzos de más de 2 horas o de menos de 15 minutos, '
    +'marcaciones duplicadas.\n'
    +'6. Salarios o descuentos que se salen de lo normal frente al resto del '
    +'mismo empleado en otros periodos o frente a sus compañeros.\n'
    +'7. Sumas que no cuadran: totales, netos, descuentos.\n\n'
    +'Responde SOLO con un JSON, sin texto alrededor y sin ```:\n'
    +'{"resumen":"una frase con lo esencial",'
    +'"empleados_reloj":0,"empleados_planilla":0,'
    +'"hallazgos":[{"gravedad":"alta|media|baja","empleado":"",'
    +'"tipo":"","detalle":"qué pasa y en qué fecha","esperado":"",'
    +'"encontrado":""}]}\n\n'
    +'Si algo cuadra bien, NO lo listes. Ordena por gravedad. Si no '
    +'encuentras nada, devuelve hallazgos vacío. Sé concreto: nombre del '
    +'empleado, fecha y cifras.'});

  try{
    // Por la función de siempre del portal: lleva la clave, las cabeceras y
    // sabe continuar si la respuesta se corta. Llamarla a mano fallaba con
    // «Failed to fetch» porque le faltaba todo eso.
    var obj=await _iaJSON(bloques, 8000);
    if(!obj){ throw new Error('la IA no devolvió un resultado legible'); }
    obj.hallazgos=_plaConPagoVsDebe(_plaSinAvisosDeReloj((ciertos||[]).concat(obj.hallazgos||[])),
      (S.planilla.datos||{}).empleados||[], prestD, Pq);
    // El tope de incapacidad, con lo guardado del año más esta quincena
    try{
      var tope=await _plaIncapacidadAnual(S);
      obj.hallazgos=tope.hallazgos.concat(obj.hallazgos);
    }catch(e){ _dbg('[PLA] incapacidad: '+(e.message||e)); }
    window._pla.revisionObj=obj;
    window._pla.revision=_plaInforme(obj);
    _plaPintar();
  }catch(e){
    if(caja) caja.innerHTML='<div class="nota" style="background:var(--pastel-error);'
      +'color:var(--t-rojo)">No se pudo revisar: '+_esc(e.message||String(e))+'</div>';
  }
}

/* El informe en pantalla: lo grave primero, con su color. */
function _plaInforme(obj){
  var hall=(obj&&obj.hallazgos)||[];
  var col={alta:{c:'#991B1B', bg:'var(--pastel-error)', bd:'#F3C9C9', t:'GRAVE'},
           media:{c:'#B45309', bg:'var(--pastel-aviso)', bd:'#E9C08A', t:'REVISAR'},
           baja:{c:'#0C447C', bg:'var(--pastel-azul)', bd:'#9CC0E8', t:'AVISO'}};
  var orden={alta:0, media:1, baja:2};
  hall=hall.slice().sort(function(a,b){
    return (orden[a.gravedad]||3)-(orden[b.gravedad]||3); });

  var n={alta:0, media:0, baja:0};
  hall.forEach(function(x){ n[x.gravedad]=(n[x.gravedad]||0)+1; });

  var h='<div style="border:0.5px solid var(--border);border-radius:12px;'
    +'overflow:hidden;background:var(--surface-0)">'
    +'<div style="background:var(--pastel-lila);padding:12px 14px;display:flex;'
    +'align-items:center;gap:10px;flex-wrap:wrap">'
    +'<i class="ti ti-sparkles" style="font-size:18px;color:var(--t-lila)"></i>'
    +'<b style="font-size:13.5px;color:var(--t-lila)">Revisión de la planilla</b>'
    +'<span style="flex:1"></span>'
    +(obj.empleados_reloj?('<span style="font-size:11px;color:var(--t-lila)">'
      +obj.empleados_reloj+' en el reloj · '+(obj.empleados_planilla||0)
      +' en la planilla</span>'):'')
    +'</div>';

  if(obj.resumen){
    h+='<div style="padding:12px 14px;font-size:12.5px;line-height:1.6;'
      +'border-bottom:0.5px solid var(--border)">'+_esc(obj.resumen)+'</div>';
  }

  if(!hall.length){
    h+='<div style="padding:18px;text-align:center;font-size:12.5px;'
      +'color:var(--t-verde)"><i class="ti ti-circle-check" '
      +'style="font-size:22px"></i><br>No encontré inconsistencias entre las '
      +'marcaciones y la planilla.</div></div>';
    return h;
  }

  h+='<div style="display:flex;gap:8px;padding:11px 14px;flex-wrap:wrap;'
    +'border-bottom:0.5px solid var(--border)">'
    + ['alta','media','baja'].filter(function(g){ return n[g]; }).map(function(g){
        return '<span style="background:'+col[g].bg+';color:'+col[g].c+';'
          +'border-radius:999px;padding:3px 11px;font-size:11px;font-weight:700">'
          +n[g]+' '+col[g].t+'</span>'; }).join('')
    +'</div>';

  hall.forEach(function(x, i){
    var c=col[x.gravedad]||col.baja;
    h+='<div style="padding:11px 14px;border-top:0.5px solid var(--border);'
      +'border-left:4px solid '+c.c+';'+((i%2)?'background:var(--bg-accent)':'')+'">'
      +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;'
      +'margin-bottom:4px">'
      +'<span style="background:'+c.bg+';color:'+c.c+';border-radius:7px;'
      +'padding:1px 8px;font-size:10px;font-weight:800">'+c.t+'</span>'
      +(x.empleado?('<b style="font-size:12.5px">'+_esc(x.empleado)+'</b>'):'')
      +(x.tipo?('<span style="font-size:11px;color:var(--text-muted)">'
        +_esc(x.tipo)+'</span>'):'')
      +((x.empleado && /marcac|reloj/i.test(String(x.tipo||'')+' '+String(x.detalle||'')))
        ? ('<button class="xb" style="font-size:10px;padding:1px 8px" '
           +'onclick="_plaMarcarNoMarca(\''+_esc(String(x.empleado).replace(/'/g,''))+'\')">'
           +'No marca</button>') : '')
      +'</div>'
      +'<div style="font-size:12px;line-height:1.55">'+_esc(x.detalle||'')+'</div>'
      +((x.esperado||x.encontrado)
        ? ('<div style="display:flex;gap:16px;margin-top:5px;font-size:11.5px;'
           +'flex-wrap:wrap">'
           +(x.esperado?('<span>Debería ser: <b>'+_esc(x.esperado)+'</b></span>'):'')
           +(x.encontrado?('<span>Está: <b style="color:'+c.c+'">'
             +_esc(x.encontrado)+'</b></span>'):'')+'</div>')
        : '')
      + ((x.pagado!=null && x.debe!=null)
        ? (function(){
            var dif=Math.round((x.pagado-x.debe)*100)/100;
            return '<div style="display:flex;gap:6px;margin-top:7px;flex-wrap:wrap;font-size:11.5px">'
              +'<span style="background:var(--pastel-azul);color:#0C447C;border-radius:7px;padding:3px 9px">'
              +'Se le paga en la planilla: <b>'+fmt(x.pagado)+'</b></span>'
              +'<span style="background:var(--pastel-ok);color:#166534;border-radius:7px;padding:3px 9px">'
              +'Según las fórmulas debería cobrar: <b>'+fmt(x.debe)+'</b></span>'
              +'<span style="background:'+(Math.abs(dif)<0.01?'var(--surface-2);color:var(--text-muted)'
                :'var(--pastel-error);color:#991B1B')+';border-radius:7px;padding:3px 9px">'
              +(Math.abs(dif)<0.01?'Cuadra':('Diferencia: <b>'+(dif>0?'+':'−')+fmt(Math.abs(dif))+'</b>'
                +(dif>0?' (se le paga de más)':' (se le paga de menos)')))+'</span></div>';
          })() : '')
      +'</div>';
  });
  h+='</div>';
  return h;
}

function _plaExportar(){
  var caja=document.getElementById('pla-resultado');
  if(!caja || !caja.innerHTML.trim()){ showT('Primero haz la revisión'); return; }
  var w=window.open('', '_blank');
  if(!w){ showT('El navegador bloqueó la ventana'); return; }
  w.document.write('<html><head><meta charset="utf-8">'
    +'<title>Revisión de planilla</title>'
    +'<style>body{font-family:system-ui,Arial,sans-serif;padding:24px;'
    +'max-width:900px;margin:0 auto;color:#1a1a18}'
    +'@media print{button{display:none}}</style></head><body>'
    +'<h2>Revisión de planilla · Kennedy Center Corp</h2>'
    +'<div style="color:#666;font-size:13px;margin-bottom:16px">'
    +new Date().toLocaleString('es')+'</div>'
    + caja.innerHTML
    +'<button onclick="window.print()" style="margin-top:20px;padding:9px 16px">'
    +'Imprimir</button></body></html>');
  w.document.close();
}

/* ── Lectura de los dos informes en PDF ───────────────────────────────────
   Los dos vienen con columnas alineadas, así que NO se puede partir por
   espacios: se lee cada palabra con su posición y se asigna a la columna
   que le toca. Es lo único fiable cuando una celda viene vacía. */
async function _plaTextoPorFilas(b64){
  var pdfjs=await _ensurePdfJs();
  if(!pdfjs) throw new Error('no pude cargar el lector de PDF');
  var bin=atob(b64), u8=new Uint8Array(bin.length);
  for(var i=0;i<bin.length;i++) u8[i]=bin.charCodeAt(i);
  var doc=await pdfjs.getDocument({data:u8}).promise;
  var paginas=[];
  for(var p=1;p<=doc.numPages;p++){
    var pag=await doc.getPage(p);
    var tc=await pag.getTextContent();
    /* pdf.js a veces devuelve la línea ENTERA en un solo trozo y otras
       veces palabra a palabra. Si viene entera hay que partirla, o se
       pierde la posición de cada dato y no se reconoce nada. */
    var items=[];
    tc.items.forEach(function(it){
      var t=String(it.str||'');
      if(!t.trim()) return;
      var x=it.transform[4], y=Math.round(it.transform[5]*2)/2;
      /* Se guarda también el BORDE DERECHO: en estos informes las cifras
         van alineadas a la derecha, igual que el rótulo de su columna, así
         que comparar bordes derechos acierta y comparar izquierdos no. */
      var w=(it.width||t.length*5);
      if(t.trim().indexOf(' ')>=0){
        var anc=w/Math.max(1, t.length), pos=0;
        t.split(/(\s+)/).forEach(function(tr){
          if(tr.trim()) items.push({t:tr, x:x+pos*anc,
                                    x1:x+(pos+tr.length)*anc, y:y});
          pos+=tr.length;
        });
      } else {
        items.push({t:t.trim(), x:x, x1:x+w, y:y});
      }
    });
    /* Agrupar por línea CON TOLERANCIA. Las cifras en negrita, como el
       salario neto, se dibujan con la línea base medio punto más abajo, y
       agrupando por altura exacta acababan en una fila aparte: por eso el
       neto no aparecía y las columnas salían corridas. */
    items.sort(function(a,b){ return b.y-a.y || a.x-b.x; });
    var grupos=[], actual=null;
    items.forEach(function(it){
      if(!actual || Math.abs(actual.y-it.y)>2.2){
        actual={y:it.y, items:[]};
        grupos.push(actual);
      }
      actual.items.push(it);
    });
    var porY={};
    grupos.forEach(function(g, i){ porY[i]=g.items; });
    var filas=Object.keys(porY)
      .sort(function(a,b){ return Number(a)-Number(b); })
      .map(function(k){
        var fila=porY[k].sort(function(a,b){ return a.x-b.x; });
        /* Los trozos pegados se juntan. El lector de PDF parte las cifras
           («1,824.49» puede llegar como «1,824» y «.49») y repite los
           dígitos del número de empleado para simular negrita. Si no se
           juntan, cada trozo cuenta como un número y las columnas se
           corren: era lo que metía el seguro educativo en la casilla del
           salario neto. */
        var out=[];
        fila.forEach(function(it){
          var ant=out[out.length-1];
          if(ant){
            var hueco=it.x-(ant.x1!=null?ant.x1:ant.x);
            var pegados=hueco<1.6;
            var ambosCifra=/^[\d.,]+$/.test(ant.t) && /^[\d.,]+$/.test(it.t);
            if(pegados && ambosCifra){
              ant.t+=it.t;
              ant.x1=(it.x1!=null?it.x1:it.x+it.t.length*5);
              return;
            }
          }
          out.push({t:it.t, x:it.x, x1:(it.x1!=null?it.x1:it.x+it.t.length*5),
                    y:it.y});
        });
        return out;
      });
    paginas.push(filas);
  }
  return paginas;
}

/* Junta los trozos que el lector de PDF dejó partidos. Es el paso que
   evita que una cifra cuente como dos y que las columnas se corran. */
function _plaJuntarTrozos(fila){
  var out=[];
  (fila||[]).forEach(function(it){
    var x1=(it.x1!=null?it.x1:it.x+String(it.t).length*5);
    var ant=out[out.length-1];
    if(ant){
      var hueco=it.x-ant.x1;
      /* Solo se juntan CIFRAS. Las letras no: pegándolas, «Aristides
         Angeles» se convertía en «AristidesAngeles». */
      var cifras=/^[\d.,]+$/.test(ant.t) && /^[\d.,]+$/.test(it.t);
      if(hueco<1.6 && cifras){
        ant.t+=it.t; ant.x1=x1; return;
      }
    }
    out.push({t:String(it.t), x:it.x, x1:x1, y:it.y});
  });
  return out;
}

function _plaNum(t){
  var v=String(t||'').replace(/[,$\s]/g,'');
  if(!v || !/^-?[\d.]+$/.test(v)) return null;
  var n=Number(v);
  return isNaN(n)?null:n;
}

/* LA PLANILLA. Las columnas se localizan por la cabecera de cada página,
   así que si mañana se mueven un poco, sigue funcionando. */
function _plaLeerPlanilla(paginas){
  var COLS=[['salario_reg','Regular'],['sobretiempo','tiempos'],
            ['feriados','Feriados'],['enfermedad','medad'],
            ['otros_ing','Ingresos'],['reembolsos','bolsos'],
            ['bruto','Brutos'],['isr','I.S.R.'],['ss','S.S.'],['se','S.E.'],
            ['aus_tard','Inactivo'],['otras_ded','Otras'],['neto','Neto']];
  var out={empleados:[], periodo:{}};
  var dept='';

  paginas.forEach(function(filas){
    // 0 · Si una fila llegó de una pieza, se parte en palabras con su
    //     posición estimada. Igual que en las marcaciones.
    filas=filas.map(function(f){
      if(f.length!==1 || !/\s/.test(String(f[0].t).trim())) return f;
      var base=f[0].x, ancho=((f[0].x1||base+String(f[0].t).length*5)-base)
                            /Math.max(1,String(f[0].t).length);
      var pos=0, pz=[];
      String(f[0].t).split(/(\s+)/).forEach(function(tr){
        if(tr.trim()) pz.push({t:tr, x:base+pos*ancho,
                               x1:base+(pos+tr.length)*ancho});
        pos+=tr.length;
      });
      return pz;
    }).map(_plaJuntarTrozos);

    /* 0b · Una fila suelta que solo trae cifras es la continuación de la
       anterior: pasa con el salario neto, que va en negrita y queda medio
       punto más abajo. Se devuelve a su fila. */
    var unidas=[];
    filas.forEach(function(f){
      var soloCifras=f.length && f.length<=2 && f.every(function(i){
        return /^[\d.,]+$/.test(i.t) && /\./.test(i.t); });
      var ant=unidas[unidas.length-1];
      if(soloCifras && ant && ant.length>=3
         && /^\d{1,6}$/.test(ant[0].t)){
        f.forEach(function(i){ ant.push(i); });
        ant.sort(function(a,b){ return a.x-b.x; });
        return;
      }
      unidas.push(f);
    });
    filas=unidas;

    // 1 · La cabecera del corte
    filas.forEach(function(f){
      var linea=f.map(function(i){ return i.t; }).join(' ');
      var m=linea.match(/corte del (\d{2}\/\d{2}\/\d{4}) al (\d{2}\/\d{2}\/\d{4})/);
      if(m){
        out.periodo.desde=_plaFecha(m[1]);
        out.periodo.hasta=_plaFecha(m[2]);
        var t=linea.match(/Tipo:\s*([A-Za-zÁÉÍÓÚáéíóúñ ]+?),/);
        if(t) out.periodo.tipo=t[1].trim();
      }
      var n=linea.match(/Planilla Nº:\s*(\d+)/);
      if(n) out.periodo.numero=Number(n[1]);
      var fp=linea.match(/Fecha de Pago:[^0-9]*(\d{1,2}) de ([A-Za-zÁÉÍÓÚáéíóú]+) de (\d{4})/);
      if(fp) out.periodo.fecha_pago=_plaFechaLarga(fp[1],fp[2],fp[3]);
      var dp=linea.match(/^Departamento:\s*(.+)$/);
      if(dp && !/Ingresos|Deducciones/.test(dp[1])) dept=dp[1].trim();
    });

    /* 2 · Dónde cae cada columna. OJO con «Ingresos»: aparece TRES veces
       en la cabecera (el título del grupo, «Otros Ingresos» e «Ingresos
       Brutos»). Coger la primera llevaba las cifras a la columna
       equivocada. Se usa la que está entre «medad» y «bolsos». */
    var bordes={}, ingresos=[];
    filas.forEach(function(f){
      f.forEach(function(it){
        var der=(it.x1!=null?it.x1:(it.x+it.t.length*5));
        if(it.t==='Ingresos'){ ingresos.push(der); return; }
        COLS.forEach(function(c){
          if(c[1]==='Ingresos') return;
          if(it.t===c[1] && bordes[c[0]]==null) bordes[c[0]]=der;
        });
      });
    });
    if(bordes.salario_reg==null || bordes.neto==null) return;  // página sin tabla
    // «Otros ingresos» va entre enfermedad y reembolsos
    if(bordes.otros_ing==null && ingresos.length){
      var desde=bordes.enfermedad||0, hasta=bordes.reembolsos||1e9;
      var cand=ingresos.filter(function(x){ return x>desde && x<hasta; });
      if(cand.length) bordes.otros_ing=cand[0];
    }
    var centros=bordes;

    // 3 · Las filas de empleado: número, nombre y cifras por columna
    filas.forEach(function(f){
      if(f.length<3) return;
      var num=f[0].t;
      if(!/^\d{1,5}$/.test(num)) return;
      // El nombre: lo que va antes de la primera cifra
      var nombre=[], cifras=[];
      for(var i=1;i<f.length;i++){
        var v=_plaNum(f[i].t);
        if(v==null && !cifras.length) nombre.push(f[i].t);
        else if(v!=null) cifras.push(f[i]);
      }
      if(!nombre.length || !cifras.length) return;
      var e={num_empleado:num, nombre:nombre.join(' ').trim(), departamento:dept};
      COLS.forEach(function(c){ e[c[0]]=0; });
      /* Las cifras van de izquierda a derecha y las columnas también, así
         que se asignan EN ORDEN: cada número solo puede caer en su columna
         o en una posterior. Buscar la más cercana sin más fallaba cuando la
         posición venía estimada, y la última columna (el neto) se perdía. */
      var orden=COLS.map(function(c){ return c[0]; })
        .filter(function(k){ return centros[k]!=null; })
        .sort(function(a,b){ return centros[a]-centros[b]; });
      var desde=0;
      cifras.forEach(function(it, idx){
        var fin=(it.x1!=null?it.x1:(it.x+it.t.length*5));
        /* La última cifra suele ser el neto, pero NO siempre: si a alguien
           el préstamo se le come la quincena entera, el neto va en blanco y
           la última cifra es la de «Otras». Por eso solo se da por neto si
           además cae en esa columna. */
        if(idx===cifras.length-1 && centros.neto!=null
           && Math.abs(centros.neto-fin)<25){
          e.neto=_plaNum(it.t);
          return;
        }
        var mejor=-1, dist=1e9;
        for(var k=desde;k<orden.length;k++){
          var d=Math.abs(centros[orden[k]]-fin);
          if(d<dist){ dist=d; mejor=k; }
        }
        if(mejor>=0){
          // Deja sitio para las que quedan: no se agota la lista de columnas
          var restan=cifras.length-1-idx;
          if(orden.length-1-mejor < restan) mejor=orden.length-1-restan;
          if(mejor>=desde){
            e[orden[mejor]]=_plaNum(it.t);
            desde=mejor+1;
          }
        }
      });
      if(e.bruto || e.neto || e.salario_reg) out.empleados.push(e);
    });
  });
  return out;
}

function _plaFecha(t){
  var m=String(t||'').match(/(\d{2})\/(\d{2})\/(\d{4})/);
  return m ? (m[3]+'-'+m[1]+'-'+m[2]) : null;    // mm/dd/yyyy
}
function _plaFechaLarga(d, mes, anio){
  var M={enero:1,febrero:2,marzo:3,abril:4,mayo:5,junio:6,julio:7,agosto:8,
         septiembre:9,setiembre:9,octubre:10,noviembre:11,diciembre:12};
  var n=M[String(mes||'').toLowerCase()];
  if(!n) return null;
  return anio+'-'+String(n).padStart(2,'0')+'-'+String(d).padStart(2,'0');
}

/* LAS MARCACIONES. Cada empleado empieza con «nº Nombre» y luego van sus
   días. Las columnas también se asignan por posición, porque un día sin
   almuerzo deja el hueco vacío y partiendo por espacios se descoloca todo. */
function _plaLeerMarcaciones(paginas){
  var MESES={ene:1,feb:2,mar:3,abr:4,may:5,jun:6,jul:7,ago:8,sep:9,oct:10,
             nov:11,dic:12};
  var out=[], actual=null, centros=null;

  paginas.forEach(function(filas){
    /* Primero se normaliza: si una fila llegó en una sola pieza, se parte
       en palabras con su posición estimada. Va ANTES de buscar las
       columnas, que también las necesita sueltas. */
    filas=filas.map(function(f){
      if(f.length!==1 || !/\s/.test(String(f[0].t).trim())) return f;
      var base=f[0].x, pos=0, pz=[];
      String(f[0].t).split(/(\s+)/).forEach(function(tr){
        if(tr.trim()) pz.push({t:tr, x:base+pos*6, x1:base+(pos+tr.length)*6});
        pos+=tr.length;
      });
      return pz;
    }).map(_plaJuntarTrozos);

    // Cabecera de columnas de la página
    var c={};
    filas.forEach(function(f){
      f.forEach(function(it){
        var k={'Entrada':'entrada','Almu.':'salida_almu','Almu':'entrada_almu',
               'Salida':'salida','Regular':'regular','Ausen.':'ausencia',
               'Tardan.':'tardanza','Incapac.':'incapacidad',
               'Sobret.':'sobretiempo','Feriado':'feriado'}[it.t];
        if(k && c[k]==null) c[k]=it.x+(it.t.length*3);
      });
    });
    if(Object.keys(c).length>4) centros=c;

    filas.forEach(function(f){
      var txt=f.map(function(i){ return i.t; }).join(' ').trim();

      /* ¿Empieza un empleado? La línea es «374 Manuel Castillo», pero el
         número viene con los dígitos repetidos y, según cómo lo devuelva el
         lector de PDF, repartidos en piezas sueltas («3 3 7 7 4 4»). Por eso
         se mira pieza a pieza y no con un patrón sobre el texto unido. */
      if(!/^Sep|^Oct|^TOTALES/i.test(txt)){
        var dig=[], resto=[];
        for(var q=0;q<f.length;q++){
          var pz=f[q].t;
          if(!resto.length && /^\d+$/.test(pz)) dig.push(pz);
          else resto.push(pz);
        }
        var nom=resto.join(' ').trim();
        if(dig.length && /^[A-ZÁÉÍÓÚÑ][A-Za-zÁÉÍÓÚÑáéíóúñ.' ]{3,}$/.test(nom)
           && !/Empl|Nombre|Fecha|Turno|Kennedy|INFORME|Página/i.test(nom)){
          actual={num_empleado:_plaDesdoblar(dig.join('')), nombre:nom,
                  dias:[], horas:0};
          out.push(actual);
          return;
        }
      }

      // Totales del empleado. El número suele venir en la línea de abajo,
      // porque «TOTALES:» y «88.00 hr» se dibujan a alturas distintas.
      if(/TOTALES:/i.test(txt) && actual){
        var tot=txt.match(/([\d,\.]+)\s*hr/i);
        if(!tot){
          var sig=filas[filas.indexOf(f)+1];
          var txtSig=sig?sig.map(function(i){ return i.t; }).join(' '):'';
          tot=txtSig.match(/([\d,\.]+)\s*hr/i);
        }
        if(tot) actual.horas=_plaNum(tot[1])||0;
        return;
      }

      /* Un día: «Sep.11 - 2026 Vie 2 7:43 AM …». Antes de mirarlo se juntan
         los dígitos que el lector pueda haber separado: si devuelve el año
         como «2 0 2 6», la fecha no se reconocería. */
      var txtC=txt;
      for(var z=0;z<4;z++) txtC=txtC.replace(/(\d)\s+(\d)/g, '$1$2');
      var dia=txtC.match(/^([A-Za-z]{3})\.(\d{1,2})\s*-\s*(\d{4})\s+([A-Za-z]{3})/);
      if(!dia || !actual || !centros) return;
      var mes=MESES[dia[1].toLowerCase()];
      if(!mes) return;
      var d={fecha:dia[3]+'-'+String(mes).padStart(2,'0')+'-'
                   +String(dia[2]).padStart(2,'0'),
             dia:dia[4], turno:'', entrada:'', salida_almu:'', entrada_almu:'',
             salida:'', regular:null, ausencia:null, tardanza:null,
             incapacidad:null, sobretiempo:null, feriado:null};

      // Las horas vienen partidas en dos piezas: «7:43» y «AM»
      var piezas=[];
      for(var i=0;i<f.length;i++){
        var t=f[i].t;
        if(/^\d{1,2}:\d{2}$/.test(t) && f[i+1] && /^(AM|PM)$/i.test(f[i+1].t)){
          piezas.push({x:f[i].x, t:t+' '+f[i+1].t.toUpperCase()});
          i++;
        } else if(/^\d{1,2}:\d{2}\s*(AM|PM)$/i.test(t)){
          piezas.push({x:f[i].x, t:t.toUpperCase()});
        } else if(_plaNum(t)!=null && !/^\d{4}$/.test(t)){
          piezas.push({x:f[i].x, t:t, num:true});
        }
      }
      // El turno es el primer número suelto antes de las horas
      var horas=piezas.filter(function(p){ return !p.num; });
      var nums=piezas.filter(function(p){ return p.num; });
      if(nums.length && horas.length && nums[0].x < horas[0].x){
        d.turno=nums.shift().t;
      } else if(nums.length && !horas.length && nums[0].x < 230){
        d.turno=nums.shift().t;
      }

      /* Las horas se reparten POR ORDEN, no por posición: siempre van de
         izquierda a derecha (entrada, sale a almorzar, vuelve, salida) y
         el orden no falla aunque la posición venga estimada.
           4 horas → la jornada completa con almuerzo
           2 horas → entrada y salida, sin almuerzo marcado
           3 horas → falta una del almuerzo; se decide por la posición */
      if(horas.length>=4){
        d.entrada=horas[0].t; d.salida_almu=horas[1].t;
        d.entrada_almu=horas[2].t; d.salida=horas[horas.length-1].t;
      } else if(horas.length===3){
        d.entrada=horas[0].t; d.salida=horas[2].t;
        var cAlm=(centros.salida_almu!=null && centros.entrada_almu!=null)
          ? ((Math.abs(centros.salida_almu-horas[1].x)
              <= Math.abs(centros.entrada_almu-horas[1].x))
             ? 'salida_almu' : 'entrada_almu')
          : 'salida_almu';
        d[cAlm]=horas[1].t;
      } else if(horas.length===2){
        d.entrada=horas[0].t; d.salida=horas[1].t;
      } else if(horas.length===1){
        d.entrada=horas[0].t;
      }

      // Las cifras sí van por columna: puede faltar cualquiera de ellas
      nums.forEach(function(p){
        var mejor=null, dist=1e9;
        ['regular','ausencia','tardanza','incapacidad','sobretiempo','feriado']
          .forEach(function(k){
            if(centros[k]==null) return;
            var dd=Math.abs(centros[k]-(p.x+p.t.length*5));
            if(dd<dist){ dist=dd; mejor=k; }
          });
        if(mejor && dist<50) d[mejor]=_plaNum(p.t);
        else if(d.regular==null) d.regular=_plaNum(p.t);   // la primera suele ser regular
      });
      actual.dias.push(d);
    });
  });
  return out;
}

/* ── La ficha de un empleado ──────────────────────────────────────────── */
async function _plaFicha(num){
  var S=window._pla||{};
  var e=(S.empleados||[]).filter(function(x){
    return String(x.num_empleado)===String(num); })[0];
  if(!e) return;

  var prev=document.getElementById('modalPlaFicha'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPlaFicha';
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:12500;'
    +'display:flex;flex-direction:column;padding:12px 14px;overflow:hidden';
  ov.innerHTML='<div style="padding:18px;font-size:12px;color:var(--t-lila)">'
    +'<span class="ai-ring g"></span> Cargando la ficha…</div>';
  document.body.appendChild(ov);

  // Su historial y sus marcaciones
  var hist=[], marc=[];
  try{
    var r1=await fetch(SB+'/rest/v1/planilla_empleados?select=*,planilla_periodos(*)'
      +'&num_empleado=eq.'+encodeURIComponent(num)+'&order=id.desc&limit=60',
      {headers:SBH});
    if(r1.ok) hist=(await r1.json())||[];
    var r2=await fetch(SB+'/rest/v1/planilla_marcaciones?select=*'
      +'&num_empleado=eq.'+encodeURIComponent(num)
      +'&periodo_id=eq.'+e.periodo_id+'&order=fecha',{headers:SBH});
    if(r2.ok) marc=(await r2.json())||[];
    // Si el reloj numera distinto a la planilla, se busca por nombre
    if(!marc.length && e.nombre){
      var r3=await fetch(SB+'/rest/v1/planilla_marcaciones?select=*'
        +'&periodo_id=eq.'+e.periodo_id
        +'&nombre=ilike.'+encodeURIComponent('%'+String(e.nombre).trim()+'%')
        +'&order=fecha',{headers:SBH});
      if(r3.ok) marc=(await r3.json())||[];
    }
  }catch(err){}

  var ded=(Number(e.isr)||0)+(Number(e.ss)||0)+(Number(e.se)||0)
         +(Number(e.aus_tard)||0)+(Number(e.otras_ded)||0);

  var h='<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;'
    +'margin-bottom:12px">'
    +'<div style="width:44px;height:44px;border-radius:12px;background:#5B21B6;'
    +'color:#fff;display:flex;align-items:center;justify-content:center;'
    +'font-weight:800;font-size:16px">'
    +_esc(String(e.nombre||'?').trim().split(/\s+/).map(function(p){
       return p[0]; }).slice(0,2).join('').toUpperCase())+'</div>'
    +'<div style="flex:1;min-width:200px">'
    +'<div style="font-size:17px;font-weight:700">'+_esc(e.nombre||'')+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Nº '
    +_esc(e.num_empleado||'')
    +(e.departamento?(' · '+_esc(e.departamento)):'')
    +' · '+_esc(_plaRotulo((window._pla||{}).periodo||{}))+'</div></div>'
    +'<button class="btn bg2" style="padding:8px 14px" '
    +'onclick="document.getElementById(\'modalPlaFicha\').remove()">'
    +'<i class="ti ti-x"></i> Cerrar</button></div>';

  // Lo que cobra y lo que se le descuenta
  var linea=function(t, v, col, fuerte){
    if(!v) return '';
    return '<div style="display:flex;justify-content:space-between;gap:12px;'
      +'padding:6px 0;border-bottom:0.5px solid var(--border);font-size:12.5px'
      +(fuerte?';font-weight:800':'')+'">'
      +'<span>'+_esc(t)+'</span><b style="color:'+col+'">'+fmt(v)+'</b></div>';
  };
  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:13px">'
    +'<div style="flex:1;min-width:270px;background:var(--surface-0);'
    +'border:0.5px solid var(--border);border-radius:12px;padding:13px">'
    +'<div style="font-size:11px;font-weight:700;color:#166534;margin-bottom:6px">'
    +'<i class="ti ti-cash"></i> INGRESOS</div>'
    + linea('Salario regular', e.salario_reg, '#166534')
    + linea('Sobretiempo', e.sobretiempo, '#166534')
    + linea('Domingos o feriados', e.feriados, '#166534')
    + linea('Enfermedad', e.enfermedad, '#166534')
    + linea('Otros ingresos', e.otros_ing, '#166534')
    + linea('Reembolsos', e.reembolsos, '#166534')
    + linea('Salario bruto', e.bruto, '#166534', true)
    +'</div>'
    +'<div style="flex:1;min-width:270px;background:var(--surface-0);'
    +'border:0.5px solid var(--border);border-radius:12px;padding:13px">'
    +'<div style="font-size:11px;font-weight:700;color:#991B1B;margin-bottom:6px">'
    +'<i class="ti ti-minus"></i> DEDUCCIONES</div>'
    + linea('Impuesto sobre la renta', e.isr, '#991B1B')
    + linea('Seguro social', e.ss, '#991B1B')
    + linea('Seguro educativo', e.se, '#991B1B')
    + linea('Ausencias, tardanzas e inactivo', e.aus_tard, '#991B1B')
    + linea('Otras · préstamos y deudas', e.otras_ded, '#991B1B')
    + linea('Total deducciones', ded, '#991B1B', true)
    +'</div></div>';

  h+='<div style="background:var(--pastel-azul);border-radius:12px;padding:13px 16px;'
    +'display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-bottom:14px">'
    +'<b style="flex:1;font-size:13px;color:var(--t-azul)">SALARIO NETO DE ESTA QUINCENA</b>'
    +'<b style="font-size:22px;color:var(--t-azul)">'+fmt(e.neto)+'</b></div>';

  // Las marcaciones del reloj
  if(marc.length){
    var thm='padding:8px 10px;font-size:10px;font-weight:700;color:#fff;'
           +'text-align:left;position:sticky;top:0;background:#0C447C';
    h+='<div style="font-size:12.5px;font-weight:700;margin-bottom:7px">'
      +'<i class="ti ti-clock"></i> Marcaciones del reloj · '
      +marc.length+' día(s)'
      +(e.horas_reloj!=null?(' · '+_fmtN2(e.horas_reloj)+' horas'):'')+'</div>'
      +'<div style="border:0.5px solid var(--border);border-radius:12px;'
      +'overflow:auto;max-height:40vh;background:var(--surface-0)">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
      +'<thead><tr><th style="'+thm+'">FECHA</th><th style="'+thm+'">DÍA</th>'
      +'<th style="'+thm+'">ENTRADA</th><th style="'+thm+'">SALE ALMUERZO</th>'
      +'<th style="'+thm+'">VUELVE</th><th style="'+thm+'">SALIDA</th>'
      +'<th style="'+thm+';text-align:right">REGULAR</th>'
      +'<th style="'+thm+';text-align:right">EXTRA</th>'
      +'<th style="'+thm+'">AVISO</th></tr></thead><tbody>';
    marc.forEach(function(d, i){
      var falta=(!d.entrada || !d.salida);
      var td='padding:7px 10px;border-bottom:0.5px solid var(--border)';
      h+='<tr style="'+(falta?'background:var(--pastel-aviso)'
                            :((i%2)?'background:var(--bg-accent)':''))+'">'
        +'<td style="'+td+';white-space:nowrap">'+_esc(_fechaCorta(d.fecha))+'</td>'
        +'<td style="'+td+';color:var(--text-muted)">'+_esc(d.dia||'')+'</td>'
        +'<td style="'+td+'">'+_esc(d.entrada||'—')+'</td>'
        +'<td style="'+td+'">'+_esc(d.salida_almu||'—')+'</td>'
        +'<td style="'+td+'">'+_esc(d.entrada_almu||'—')+'</td>'
        +'<td style="'+td+'">'+_esc(d.salida||'—')+'</td>'
        +'<td style="'+td+';text-align:right">'
        +(d.regular!=null?_fmtN2(d.regular):'—')+'</td>'
        +'<td style="'+td+';text-align:right;color:#166534">'
        +(d.sobretiempo?_fmtN2(d.sobretiempo):'')+'</td>'
        +'<td style="'+td+';font-size:10.5px;color:var(--t-marron)">'
        +(falta?'sin marcación completa':'')
        +(d.ausencia?(' ausencia '+_fmtN2(d.ausencia)):'')
        +(d.tardanza?(' tardanza '+_fmtN2(d.tardanza)):'')+'</td></tr>';
    });
    h+='</tbody></table></div>';
  } else {
    h+='<div class="nota" style="background:var(--pastel-aviso);'
      +'color:var(--t-marron);font-size:12px">Sin marcaciones cargadas para '
      +'esta quincena.</div>';
  }

  // Su historial de quincenas
  if(hist.length>1){
    h+='<div style="font-size:12.5px;font-weight:700;margin:14px 0 7px">'
      +'<i class="ti ti-history"></i> Historial</div>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      + hist.map(function(x){
          var p=x.planilla_periodos||{};
          return '<div style="background:var(--surface-0);border:0.5px solid var(--border);'
            +'border-radius:10px;padding:8px 12px;min-width:150px">'
            +'<div style="font-size:10.5px;color:var(--text-muted)">'
            +_esc(_plaRotulo(p))+'</div>'
            +'<div style="font-size:13px;font-weight:700;color:#166534">'
            +fmt(x.neto)+'</div>'
            +(x.otras_ded>0?('<div style="font-size:10px;color:var(--t-marron)">'
              +'descuento '+fmt(x.otras_ded)+'</div>'):'')
            +'</div>';
        }).join('')
      +'</div>';
  }

  ov.innerHTML=h;
  var cerrar=function(ev){
    if(ev.key==='Escape'){ ov.remove(); document.removeEventListener('keydown', cerrar); }
  };
  document.addEventListener('keydown', cerrar);
}

/* ── Subida y guardado ────────────────────────────────────────────────── */
function _plaVerSubida(){ window._pla.subiendo=true; _plaPintar(); }

function _plaPanelSubida(S){
  var caja=function(id, titulo, pie, arch, icono, color){
    return '<div style="flex:1;min-width:280px;border:1.5px dashed '
      +(arch?color:'var(--border)')+';border-radius:12px;padding:15px;'
      +'background:'+(arch?'var(--pastel-ok)':'var(--surface-0)')+'">'
      +'<div style="display:flex;align-items:center;gap:9px;margin-bottom:5px">'
      +'<i class="ti '+icono+'" style="font-size:19px;color:'+color+'"></i>'
      +'<b style="font-size:13px">'+_esc(titulo)+'</b></div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:10px">'
      +_esc(pie)+'</div>'
      + (arch
         ? ('<div style="font-size:12px;font-weight:700;color:var(--t-verde)">'
            +'<i class="ti ti-circle-check"></i> '+_esc(arch.nombre)+'</div>'
            +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px">'
            +(arch.resumen||'')+'</div>'
            +'<button class="xb" style="margin-top:8px" onclick="_plaQuitar(\''+id+'\')">'
            +'<i class="ti ti-x"></i> Quitar</button>')
         : ('<input type="file" accept=".pdf" '
            +'onchange="_plaCargarArchivo(\''+id+'\', this.files[0])" '
            +'style="font-size:12px">'))
      +'</div>';
  };
  var tipoDet=((S.planilla&&S.planilla.datos&&S.planilla.datos.periodo)||{}).tipo||'';
  var tipoSel=S.tipoManual||_plaTipo(tipoDet);
  var h='';
  if(S.planilla){
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
      +'border-radius:12px;padding:12px 14px;margin-bottom:12px">'
      +'<div style="font-size:11.5px;font-weight:700;margin-bottom:7px">'
      +'¿Qué planilla es esta?</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
      + ['Quincena','XIII mes','Bonos','Vacaciones'].map(function(t){
          return '<span class="pill'+(tipoSel===t?' active':'')+'" '
            +'onclick="_plaPonerTipo(\''+t+'\')">'+t+'</span>'; }).join('')
      +'</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +(tipoDet?('El informe dice «'+_esc(tipoDet)+'». '):'')
      +'En Panamá el décimo tercer mes se paga tres veces al año y en '
      +'diciembre va aparte la planilla de bonos.</div></div>';
  }
  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:13px">'
    + caja('reloj','1 · Marcaciones del reloj',
           'Informe histórico de asistencia, en PDF',
           S.reloj, 'ti-clock', 'var(--t-azul)')
    + caja('planilla','2 · Planilla calculada',
           'Informe de planilla del programa de nóminas, en PDF',
           S.planilla, 'ti-file-dollar', 'var(--t-verde)')
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px">'
    +'<button class="btn bp" style="background:#5B21B6;padding:9px 18px" '
    +(S.planilla?'':'disabled ')+'onclick="_plaPreliminar()">'
    +'<i class="ti ti-eye"></i> Ver el preliminar</button>'
    +'<button class="btn bg2" style="padding:9px 16px" '
    +(S.planilla?'':'disabled ')+'onclick="_plaGuardar()">'
    +'<i class="ti ti-device-floppy"></i> Guardar sin revisar</button>'
    +'<button class="btn bg2" style="padding:9px 16px" '
    +(S.reloj&&S.planilla?'':'disabled ')+'onclick="_plaRevisar()">'
    +'<i class="ti ti-sparkles"></i> Revisar con IA</button>'
    +((S.periodos||[]).length?('<button class="xb" onclick="_plaCerrarSubida()">'
      +'Volver</button>'):'')
    +'</div>'
    +'<div class="nota" style="background:var(--pastel-azul);color:var(--t-azul);'
    +'font-size:12px">Sube los dos PDF. Primero se leen las marcaciones y '
    +'después la planilla, igual que se hace a mano. Al guardar quedan los '
    +'empleados con su sueldo y sus marcaciones, y se pueden buscar.</div>'
    +'<div id="pla-resultado">'+(S.revision||'')+'</div>';
  return h;
}

function _plaCerrarSubida(){ window._pla.subiendo=false; _plaPintar(); }

async function _plaCargarArchivo(cual, file){
  if(!file) return;
  if(!/\.pdf$/i.test(file.name)){ showT('Tiene que ser el PDF del informe'); return; }
  showT('Leyendo '+file.name+'…');
  try{
    var buf=await file.arrayBuffer();
    var bin='', u8=new Uint8Array(buf);
    for(var i=0;i<u8.length;i++) bin+=String.fromCharCode(u8[i]);
    var b64=btoa(bin);
    var paginas=await _plaTextoPorFilas(b64);

    var dato={nombre:file.name, b64:b64};
    if(cual==='planilla'){
      var r=_plaLeerPlanilla(paginas);
      if(!r.empleados.length) throw new Error('no reconocí ningún empleado; '
        +'¿es el informe de planilla?');
      dato.datos=r;
      dato.resumen=r.empleados.length+' empleado(s) · corte '
        +(r.periodo.desde||'?')+' a '+(r.periodo.hasta||'?');
    } else {
      var m=_plaLeerMarcaciones(paginas);
      if(!m.length){
        // Para no quedarnos a ciegas: se enseña lo que SÍ se leyó
        var muestra=[];
        (paginas[0]||[]).slice(0,14).forEach(function(f){
          muestra.push(f.map(function(i){ return i.t; }).join(' '));
        });
        console.warn('[PLANILLA] primeras líneas leídas:', muestra);
        throw new Error('no reconocí ningún empleado en el informe de '
          +'asistencia. Leí '+paginas.length+' página(s). Mira la consola '
          +'(F12): ahí dejé las primeras líneas tal como las leí.');
      }
      dato.datos=m;
      var dias=m.reduce(function(a,x){ return a+x.dias.length; },0);
      dato.resumen=m.length+' empleado(s) · '+dias+' día(s) marcados';
    }
    window._pla[cual]=dato;
    window._pla.revision=null;
    _plaPintar();
    showT('✓ '+dato.resumen, 7000);
  }catch(e){
    showT('No pude leerlo: '+(e.message||e), 9000);
  }
}

function _plaQuitar(cual){
  window._pla[cual]=null; window._pla.revision=null; _plaPintar();
}

/* Guarda la quincena: el periodo, cada empleado con su sueldo y, si están,
   sus marcaciones día a día. */
async function _plaGuardar(){
  var S=window._pla||{};
  if(!S.planilla){ showT('Falta la planilla'); return; }
  var P=S.planilla.datos.periodo||{};
  if(!P.desde || !P.hasta){ showT('No pude leer el corte del informe'); return; }
  var _tipo=(S.tipoManual || _plaTipo(P.tipo));
  if(!confirm('Se va a guardar como «'+_tipo+'» del '+P.desde+' al '+P.hasta
    +' con '+S.planilla.datos.empleados.length+' empleado(s).\n\n'
    +'Si ya había una de ese tipo y corte, se reemplaza.\n\n¿Sigo?')) return;

  showT('Guardando…');
  try{
    // Fuera lo que hubiera de ese mismo corte
    var tipoGuardar=(S.tipoManual || _plaTipo(P.tipo));
    var rv=await fetch(SB+'/rest/v1/planilla_periodos?select=id,tipo&desde=eq.'+P.desde
      +'&hasta=eq.'+P.hasta+'&tipo=eq.'+encodeURIComponent(tipoGuardar),
      {headers:SBH});
    var viejos=(rv.ok?((await rv.json())||[]):[]);
    for(var i=0;i<viejos.length;i++){
      await fetch(SB+'/rest/v1/planilla_periodos?id=eq.'+viejos[i].id,
        {method:'DELETE', headers:SBH});
    }

    var emps=S.planilla.datos.empleados;
    var marc=(S.reloj&&S.reloj.datos)||[];
    var porNum={}, porNombre={};
    marc.forEach(function(m){
      porNum[String(m.num_empleado)]=m;
      porNombre[String(m.nombre||'').toUpperCase().replace(/\s+/g,' ').trim()]=m;
    });

    var tot=function(k){ return emps.reduce(function(a,e){ return a+(Number(e[k])||0); },0); };
    var rp=await fetch(SB+'/rest/v1/planilla_periodos',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({numero:P.numero||null,
        tipo:(S.tipoManual || _plaTipo(P.tipo)),
        desde:P.desde, hasta:P.hasta, fecha_pago:P.fecha_pago||null,
        n_empleados:emps.length, total_bruto:tot('bruto'), total_neto:tot('neto'),
        total_isr:tot('isr'), total_ss:tot('ss'), total_se:tot('se'),
        total_otras:tot('otras_ded'),
        archivo:S.planilla.nombre, subido_por:(CU&&CU.name)||''})});
    if(!rp.ok){
      var t=await rp.text();
      throw new Error(/does not exist/i.test(t)
        ? 'falta correr planilla.sql en Supabase' : t.slice(0,140));
    }
    var periodo=((await rp.json())||[])[0];

    // Los empleados, con sus horas del reloj si las hay
    var filasE=emps.map(function(e){
      var m=porNum[String(e.num_empleado)]
         || porNombre[String(e.nombre||'').toUpperCase().replace(/\s+/g,' ').trim()];
      return Object.assign({}, e, {periodo_id:periodo.id,
        horas_reloj:m?m.horas:null, dias_reloj:m?m.dias.length:null});
    });
    for(var j=0;j<filasE.length;j+=200){
      await fetch(SB+'/rest/v1/planilla_empleados',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(filasE.slice(j,j+200))});
    }

    // Las marcaciones día a día
    var filasM=[];
    marc.forEach(function(m){
      m.dias.forEach(function(d){
        filasM.push(Object.assign({}, d, {periodo_id:periodo.id,
          num_empleado:m.num_empleado, nombre:m.nombre}));
      });
    });
    var puestas=0, errM='';
    for(var k=0;k<filasM.length;k+=400){
      var rm=await fetch(SB+'/rest/v1/planilla_marcaciones',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(filasM.slice(k,k+400))});
      if(rm.ok) puestas+=filasM.slice(k,k+400).length;
      else if(!errM){ errM=(await rm.text()).slice(0,180); }
    }
    if(filasM.length && !puestas){
      showT('OJO: no se guardó ninguna marcación. '+errM, 14000);
      console.warn('[PLANILLA] marcaciones no guardadas:', errM,
                   'ejemplo de fila:', filasM[0]);
    }

    showT('✓ Quincena guardada · '+filasE.length+' empleado(s) y '
      +puestas+' marcación(es)'
      +(filasM.length&&puestas<filasM.length
        ? (' · ATENCIÓN: faltaron '+(filasM.length-puestas)) : ''), 9000);
    window._pla.subiendo=false;
    window._pla.reloj=null; window._pla.planilla=null;
    await _plaCargarPeriodos(true);
    await _plaVerPeriodo(periodo.id);
  }catch(e){
    showT('No se pudo guardar: '+(e.message||e), 10000);
  }
}

async function _plaCargarPeriodos(forzar){
  var S=window._pla=window._pla||{};
  if(S.periodos && !forzar) return S.periodos;
  try{
    var r=await fetch(SB+'/rest/v1/planilla_periodos?select=*&order=desde.desc&limit=40',
      {headers:SBH});
    S.periodos=(r.ok?((await r.json())||[]):[]);
  }catch(e){ S.periodos=[]; }
  _plaPintar();
  return S.periodos;
}

async function _plaVerPeriodo(id){
  var S=window._pla;
  S.periodo=(S.periodos||[]).filter(function(p){ return p.id===id; })[0]||null;
  S.empleados=[];
  _plaPintar();
  try{
    var r=await fetch(SB+'/rest/v1/planilla_empleados?select=*&periodo_id=eq.'+id
      +'&order=nombre&limit=2000',{headers:SBH});
    S.empleados=(r.ok?((await r.json())||[]):[]);
  }catch(e){}
  _plaPintar();
}

function _plaExportarExcel(){
  var S=window._pla||{};
  var L=S.empleados||[];
  if(!L.length){ showT('Nada que exportar'); return; }
  var filas=[['Nº','Empleado','Departamento','Salario regular','Sobretiempo',
              'Feriados','Enfermedad','Otros ingresos','Reembolsos','Bruto',
              'ISR','Seguro social','Seguro educativo','Aus/Tard','Otras deducciones',
              'Neto','Horas reloj','Días reloj']];
  L.forEach(function(e){
    filas.push([e.num_empleado,e.nombre,e.departamento||'',e.salario_reg,
      e.sobretiempo,e.feriados,e.enfermedad,e.otros_ing,e.reembolsos,e.bruto,
      e.isr,e.ss,e.se,e.aus_tard,e.otras_ded,e.neto,
      e.horas_reloj==null?'':e.horas_reloj, e.dias_reloj==null?'':e.dias_reloj]);
  });
  var csv=filas.map(function(f){
    return f.map(function(v){
      var t=String(v==null?'':v).replace(/"/g,'""');
      return /[",;\n]/.test(t)?('"'+t+'"'):t; }).join(';'); }).join('\n');
  var blob=new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download='planilla_'+((S.periodo||{}).desde||_hoyISO())+'.csv';
  document.body.appendChild(a); a.click(); a.remove();
}

/* ── Las reglas de Kennedy, comprobadas contra la planilla real ────────────
   Verificadas sobre los 127 empleados del corte 11–25 sep 2026, sin una
   sola excepción:
     Seguro social    = 9,75 % de (bruto − ausencias/tardanzas)
     Seguro educativo = 1,25 % de la misma base
     Neto             = bruto − ISR − SS − SE − ausencias − otras
   El salario regular es FIJO por quincena (298,14 y demás), no sale de las
   horas, así que no tiene sentido compararlo con el reloj.
   Y hay días en que NADIE marca y aun así cuentan 8 horas: son feriados de
   la empresa, como Yom Kipur. No son errores. */
var PLA_TASA_SS=0.0975, PLA_TASA_SE=0.0125;

function _plaRevisarCuentas(emps, marc){
  var fallos=[];
  (emps||[]).forEach(function(e){
    var base=(Number(e.bruto)||0)-(Number(e.aus_tard)||0);
    var ss=Math.round(base*PLA_TASA_SS*100)/100;
    var se=Math.round(base*PLA_TASA_SE*100)/100;
    if(Math.abs(ss-(Number(e.ss)||0))>0.03){
      fallos.push({gravedad:'alta', empleado:e.nombre, tipo:'Seguro social',
        detalle:'El seguro social no cuadra con el 9,75 % del bruto menos '
          +'ausencias.', esperado:fmt(ss), encontrado:fmt(e.ss)});
    }
    if(Math.abs(se-(Number(e.se)||0))>0.03){
      fallos.push({gravedad:'alta', empleado:e.nombre, tipo:'Seguro educativo',
        detalle:'El seguro educativo no cuadra con el 1,25 %.',
        esperado:fmt(se), encontrado:fmt(e.se)});
    }
    var neto=(Number(e.bruto)||0)-(Number(e.isr)||0)-(Number(e.ss)||0)
            -(Number(e.se)||0)-(Number(e.aus_tard)||0)-(Number(e.otras_ded)||0);
    if(Math.abs(neto-(Number(e.neto)||0))>0.03){
      fallos.push({gravedad:'alta', empleado:e.nombre, tipo:'Salario neto',
        detalle:'El neto no es el bruto menos las deducciones.',
        esperado:fmt(neto), encontrado:fmt(e.neto)});
    }
    var ing=(Number(e.salario_reg)||0)+(Number(e.sobretiempo)||0)
           +(Number(e.feriados)||0)+(Number(e.enfermedad)||0)
           +(Number(e.otros_ing)||0)+(Number(e.reembolsos)||0);
    if(ing && Math.abs(ing-(Number(e.bruto)||0))>0.03){
      fallos.push({gravedad:'media', empleado:e.nombre, tipo:'Ingresos brutos',
        detalle:'La suma de los ingresos no da el bruto.',
        esperado:fmt(ing), encontrado:fmt(e.bruto)});
    }
  });

  // Quién está en un sitio y no en el otro
  if((marc||[]).length){
    var enReloj={}, enPlan={};
    marc.forEach(function(m){ enReloj[_plaClave(m.nombre)]=m; });
    (emps||[]).forEach(function(e){ enPlan[_plaClave(e.nombre)]=e; });
    (emps||[]).forEach(function(e){
      // Gerencia y administración no fichan: no es un fallo
      if(!enReloj[_plaClave(e.nombre)] && _plaMarcaReloj(e.nombre)){
        fallos.push({gravedad:'media', empleado:e.nombre, tipo:'Sin marcaciones',
          detalle:'Cobra en la planilla pero no aparece en el reloj.',
          esperado:'marcaciones del periodo', encontrado:'ninguna'});
      }
    });
    marc.forEach(function(m){
      if(!enPlan[_plaClave(m.nombre)]){
        fallos.push({gravedad:'media', empleado:m.nombre, tipo:'No está en planilla',
          detalle:'Marcó en el reloj pero no cobra en esta planilla.',
          esperado:'salario', encontrado:'no aparece'});
      }
    });

    // Días raros, descontando los feriados de empresa
    var feriados=_plaDiasDeEmpresa(marc);
    marc.forEach(function(m){
      (m.dias||[]).forEach(function(d){
        if(feriados[d.fecha]) return;           // Yom Kipur y demás
        if(d.entrada && !d.salida){
          fallos.push({gravedad:'media', empleado:m.nombre, tipo:'Falta la salida',
            detalle:'El '+d.fecha+' marcó la entrada pero no la salida.',
            esperado:'hora de salida', encontrado:'—'});
        } else if(!d.entrada && d.salida){
          fallos.push({gravedad:'media', empleado:m.nombre, tipo:'Falta la entrada',
            detalle:'El '+d.fecha+' marcó la salida pero no la entrada.',
            esperado:'hora de entrada', encontrado:'—'});
        }
        var h=_plaHoras(d.entrada, d.salida);
        if(h!=null && h>16){
          fallos.push({gravedad:'alta', empleado:m.nombre, tipo:'Jornada imposible',
            detalle:'El '+d.fecha+' figuran '+h.toFixed(1)+' horas entre entrada y salida.',
            esperado:'menos de 16 h', encontrado:h.toFixed(1)+' h'});
        }
        if(h!=null && h<0){
          fallos.push({gravedad:'alta', empleado:m.nombre, tipo:'Salida antes de entrar',
            detalle:'El '+d.fecha+' la salida es anterior a la entrada.',
            esperado:d.entrada+' → salida posterior', encontrado:d.salida});
        }
      });
    });
  }
  return fallos;
}

function _plaClave(n){
  return String(n||'').toUpperCase().replace(/[^A-ZÑ ]/g,'')
    .replace(/\s+/g,' ').trim();
}

/* Un día en que casi nadie marca pero a todos les cuentan horas es un
   feriado de la empresa, no un fallo de cada empleado. */
function _plaDiasDeEmpresa(marc){
  var total={}, sinMarcar={};
  (marc||[]).forEach(function(m){
    (m.dias||[]).forEach(function(d){
      total[d.fecha]=(total[d.fecha]||0)+1;
      if(!d.entrada && !d.salida && (Number(d.regular)||0)>0)
        sinMarcar[d.fecha]=(sinMarcar[d.fecha]||0)+1;
    });
  });
  var out={};
  Object.keys(sinMarcar).forEach(function(f){
    if(sinMarcar[f]/(total[f]||1) >= 0.6) out[f]=sinMarcar[f];
  });
  return out;
}

function _plaHoras(e, s){
  var p=function(t){
    var m=String(t||'').match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if(!m) return null;
    var hh=Number(m[1])%12;
    if(/PM/i.test(m[3])) hh+=12;
    return hh+Number(m[2])/60;
  };
  var a=p(e), b=p(s);
  if(a==null || b==null) return null;
  return b-a;
}

/* El número de empleado viene con CADA DÍGITO DUPLICADO: el informe lo
   dibuja dos veces para que se vea en negrita, y al leerlo sale «337744»
   donde pone 374. Si todos los pares son iguales, se deshace el doblado. */
function _plaDesdoblar(t){
  var n=String(t||'').trim();
  if(!/^\d+$/.test(n) || n.length<2 || n.length%2) return n;
  for(var i=0;i<n.length;i+=2){ if(n[i]!==n[i+1]) return n; }
  var out='';
  for(var j=0;j<n.length;j+=2) out+=n[j];
  return out;
}

/* ── Quién no marca nunca ──────────────────────────────────────────────────
   Gerencia y administración no pasan por el reloj, así que no tiene sentido
   avisar de que les faltan marcaciones. Se añade o se quita gente aquí. */
/* Los que NO fichan. Se compara POR PALABRAS y sin tildes (v715): antes
   tenía que coincidir el nombre entero, y «JIMMY CHAYO GUINDI» no era
   «JIMMY GUINDI», así que salía en las alertas cada quincena. Basta con que
   el nombre de la planilla contenga TODAS las palabras de la lista, en
   cualquier orden. Siempre nombre Y apellido: «DAVID LEVY» no tapa a otro
   David. A esta lista se suman los que se marcan con «No marca» en la
   pantalla (tabla planilla_sin_reloj). */
var PLA_SIN_RELOJ=['DAN BENZAQUEN','DAVID BENZAQUEN','HENRY PEREZ',
                   'GADY NAOR','JIMMY GUINDI','EDUARDO GUINDI','EDY GUINDI',
                   'ITAY GUINDI','REUBEN GUINDI','ARIEL GUINDI','SAMUEL GUINDI',
                   'SAMY GUINDI','ELIAHOU GUINDI','ELI GUINDI',
                   // Pedidos el 14-10-2026: no marcan, no avisar
                   'NEDER DELUQUE','EDWIN QUINTERO','DAVID LEVY','JOHN ERIC MORR REY',
                   'LORENA CABRERA','JIMMY CHAYO GUINDI','REUBEN ITAY GUINDI',
                   'SAUL NOBLESILLA'];
window._plaSinRelojExtra = window._plaSinRelojExtra || [];

function _plaPalabras(n){
  return String(n||'').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^A-ZÑ ]/g,' ').replace(/\s+/g,' ').trim().split(' ').filter(Boolean);
}
function _plaNoMarca(nombre){
  var pal=_plaPalabras(nombre);
  if(!pal.length) return false;
  return PLA_SIN_RELOJ.concat(window._plaSinRelojExtra||[]).some(function(x){
    var px=_plaPalabras(x);
    return px.length>=2 && px.every(function(w){ return pal.indexOf(w)>=0; });
  });
}
function _plaMarcaReloj(nombre){
  return !_plaNoMarca(nombre);
}

async function _plaCargarSinReloj(){
  try{
    var r=await fetch(SB+'/rest/v1/planilla_sin_reloj?select=nombre',{headers:SBH});
    if(r.ok) window._plaSinRelojExtra=((await r.json())||[]).map(function(x){ return x.nombre; });
  }catch(e){}
}

// «No marca»: desde la alerta, para que no vuelva a salir nunca
async function _plaMarcarNoMarca(nombre){
  if(!confirm(nombre+' no ficha en el reloj.\n\nNo volverá a salir en las alertas de '
    +'«sin marcaciones». ¿Sigo?')) return;
  try{
    var r=await fetch(SB+'/rest/v1/planilla_sin_reloj',{method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify({nombre:String(nombre).trim(), creado_por:(CU&&CU.name)||''})});
    if(!r.ok){
      var t=await r.text();
      throw new Error(/does not exist|Could not find/i.test(t)
        ? 'falta correr v715.sql en Supabase' : t.slice(0,140));
    }
    window._plaSinRelojExtra.push(String(nombre).trim());
    // Fuera también de una revisión ya hecha
    var S=window._pla||{};
    if(S.revisionObj){
      S.revisionObj.hallazgos=_plaSinAvisosDeReloj(S.revisionObj.hallazgos);
      S.revision=_plaInforme(S.revisionObj);
    }
    showT('✓ '+nombre+' no marca: no se vuelve a avisar');
    _plaPintar();
  }catch(e){ showT('No se pudo guardar: '+(e.message||e), 9000); }
}

// Quita de una lista de hallazgos los de «no marca» de quien no ficha
function _plaSinAvisosDeReloj(hall){
  return (hall||[]).filter(function(x){
    if(!x || !x.empleado || !_plaNoMarca(x.empleado)) return true;
    var t=String((x.tipo||'')+' '+(x.detalle||'')+' '+(x.encontrado||'')).toLowerCase();
    return !/marcac|reloj|fich|sin marc|no marc|asistencia|no aparece/.test(t);
  });
}

/* ── El preliminar: lo que se está pagando frente a lo que sale de las
   fórmulas. Se ve ANTES de guardar nada. ───────────────────────────────── */
function _plaCalculado(e){
  var bruto=Number(e.bruto)||0, aus=Number(e.aus_tard)||0;
  var base=bruto-aus;
  var ss=Math.round(base*PLA_TASA_SS*100)/100;
  var se=Math.round(base*PLA_TASA_SE*100)/100;
  var isr=Number(e.isr)||0, otras=Number(e.otras_ded)||0;
  var neto=Math.round((bruto-isr-ss-se-aus-otras)*100)/100;
  // Y el bruto que sale de sumar sus ingresos
  var ing=Math.round(((Number(e.salario_reg)||0)+(Number(e.sobretiempo)||0)
         +(Number(e.feriados)||0)+(Number(e.enfermedad)||0)
         +(Number(e.otros_ing)||0)+(Number(e.reembolsos)||0))*100)/100;
  return {bruto:ing||bruto, ss:ss, se:se, isr:isr, aus:aus, otras:otras, neto:neto};
}

function _plaPreliminar(){
  var S=window._pla||{};
  if(!S.planilla){ showT('Sube primero la planilla'); return; }
  S.vista='preliminar';
  _plaPintar();
  // El tope de incapacidad necesita lo guardado del año: llega un poco después
  S.incap=null;
  _plaIncapacidadAnual(S).then(function(r){ S.incap=r; if(S.vista==='preliminar') _plaPintar(); })
    .catch(function(e){ S.incap={error:String(e.message||e), lista:[], hallazgos:[]}; _plaPintar(); });
}

/* ── Incapacidad: 18 días al año por empleado (v715) ───────────────────
   Sale de la columna «Incapac.» del reloj, día a día: lo de las quincenas
   ya guardadas del año (planilla_marcaciones) más lo de la que se está
   subiendo. Las horas se pasan a días con la jornada de 8 h, así medio día
   de incapacidad cuenta medio. Si una quincena se guardó dos veces, un
   mismo día no cuenta doble. */
var PLA_INCAP_DIAS_ANIO = 18;
var PLA_INCAP_AVISO     = 15;     // a partir de aquí, «cerca del tope»
var PLA_HORAS_DIA       = 8;

function _plaHorasNum(v){
  if(v==null || v==='') return 0;
  if(typeof v==='number') return v;
  var t=String(v).trim(), m=t.match(/^(\d+):(\d{2})$/);
  if(m) return Number(m[1])+Number(m[2])/60;
  var n=Number(t.replace(',','.'));
  return isNaN(n)?0:n;
}

async function _plaIncapacidadAnual(S){
  var P=((S.planilla||{}).datos||{}).periodo||{};
  var anio=String(P.hasta||P.desde||'').slice(0,4);
  if(!/^\d{4}$/.test(anio)) anio=String(new Date().getFullYear());
  var dias={};                                  // clave|fecha -> {nombre, horas}
  var poner=function(nombre, fecha, horas){
    var h=_plaHorasNum(horas);
    if(!(h>0) || String(fecha||'').slice(0,4)!==anio) return;
    var k=_plaClave(nombre)+'|'+String(fecha).slice(0,10);
    if(!dias[k] || dias[k].horas<h) dias[k]={nombre:nombre, horas:h};
  };
  // Lo guardado del año
  for(var pag=0; pag<20; pag++){
    var r=await fetch(SB+'/rest/v1/planilla_marcaciones?select=nombre,fecha,incapacidad'
      +'&incapacidad=gt.0&fecha=gte.'+anio+'-01-01&fecha=lte.'+anio+'-12-31'
      +'&order=fecha&offset='+(pag*1000)+'&limit=1000',{headers:SBH});
    if(!r.ok) break;
    var lote=(await r.json())||[];
    lote.forEach(function(x){ poner(x.nombre, x.fecha, x.incapacidad); });
    if(lote.length<1000) break;
  }
  // Y la quincena que se está subiendo (todavía sin guardar)
  ((S.reloj&&S.reloj.datos)||[]).forEach(function(m){
    (m.dias||[]).forEach(function(d){ poner(m.nombre, d.fecha, d.incapacidad); });
  });
  var por={};
  Object.keys(dias).forEach(function(k){
    var x=dias[k], c=k.split('|')[0];
    var a=por[c]||(por[c]={nombre:x.nombre, horas:0, ndias:0});
    a.horas+=x.horas; a.ndias++;
  });
  var lista=Object.keys(por).map(function(c){
    var a=por[c]; a.dias=Math.round(a.horas/PLA_HORAS_DIA*10)/10; return a; })
    .sort(function(a,b){ return b.dias-a.dias; });
  var hall=[];
  lista.forEach(function(a){
    if(a.dias>=PLA_INCAP_DIAS_ANIO){
      hall.push({gravedad:'alta', empleado:a.nombre, tipo:'Tope de incapacidad',
        detalle:'Llegó al tope de '+PLA_INCAP_DIAS_ANIO+' días de incapacidad de '+anio
          +(a.dias>PLA_INCAP_DIAS_ANIO?(' y lo pasa en '+(Math.round((a.dias-PLA_INCAP_DIAS_ANIO)*10)/10)+' día(s)'):'')
          +'. Lo que pase de ahí ya no corresponde como incapacidad pagada.',
        esperado:'máximo '+PLA_INCAP_DIAS_ANIO+' días',
        encontrado:a.dias+' días ('+Math.round(a.horas*10)/10+' h)'});
    } else if(a.dias>=PLA_INCAP_AVISO){
      hall.push({gravedad:'baja', empleado:a.nombre, tipo:'Cerca del tope de incapacidad',
        detalle:'Lleva '+a.dias+' de '+PLA_INCAP_DIAS_ANIO+' días de incapacidad en '+anio
          +': le quedan '+(Math.round((PLA_INCAP_DIAS_ANIO-a.dias)*10)/10)+'.',
        esperado:'máximo '+PLA_INCAP_DIAS_ANIO+' días', encontrado:a.dias+' días'});
    }
  });
  return {anio:anio, lista:lista, hallazgos:hall};
}

function _plaIncapNotaHtml(S){
  var I=S.incap;
  if(!I) return '<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px">'
    +'<span class="ai-ring g"></span> Sumando la incapacidad del año…</div>';
  if(I.error) return '<div class="nota" style="font-size:11px">No pude sumar la incapacidad del año: '
    +_esc(I.error)+'</div>';
  var tope=I.lista.filter(function(a){ return a.dias>=PLA_INCAP_DIAS_ANIO; });
  var cerca=I.lista.filter(function(a){ return a.dias>=PLA_INCAP_AVISO && a.dias<PLA_INCAP_DIAS_ANIO; });
  if(!tope.length && !cerca.length) return '';
  var chip=function(a, rojo){
    return '<span style="background:var(--surface-0);border:0.5px solid '+(rojo?'#F3C9C9':'#E9C08A')
      +';border-radius:999px;padding:2px 10px;font-size:11px">'+_esc(a.nombre)+' · <b>'
      +a.dias+'</b> de '+PLA_INCAP_DIAS_ANIO+' días</span>';
  };
  return '<div class="nota" style="background:'+(tope.length?'var(--pastel-error);color:var(--t-rojo)'
      :'var(--pastel-aviso);color:var(--t-marron)')+';font-size:12px">'
    +'<b><i class="ti ti-first-aid-kit"></i> Incapacidad '+_esc(I.anio)+' · tope de '
    +PLA_INCAP_DIAS_ANIO+' días al año</b>'
    +(tope.length?('<div style="margin-top:5px">Llegaron al tope:</div><div style="display:flex;'
      +'flex-wrap:wrap;gap:5px;margin-top:3px">'+tope.map(function(a){ return chip(a,true); }).join('')+'</div>'):'')
    +(cerca.length?('<div style="margin-top:5px">Cerca del tope (desde '+PLA_INCAP_AVISO+' días):</div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:3px">'
      +cerca.map(function(a){ return chip(a,false); }).join('')+'</div>'):'')
    +'</div>';
}

function _plaPanelPreliminar(S){
  var emps=((S.planilla.datos||{}).empleados||[]).slice();
  var marc=(S.reloj&&S.reloj.datos)||[];
  var porNom={};
  marc.forEach(function(m){ porNom[_plaClave(m.nombre)]=m; });

  var q=String(S.q||'').toLowerCase().trim();
  var todos=emps.map(function(e){
    var c=_plaCalculado(e);
    var m=porNom[_plaClave(e.nombre)];
    return {e:e, c:c, marc:m,
            dif:Math.round(((Number(e.neto)||0)-c.neto)*100)/100};
  });
  var conDif=todos.filter(function(x){ return Math.abs(x.dif)>0.02; });

  var pagado=todos.reduce(function(a,x){ return a+(Number(x.e.neto)||0); },0);
  var calcul=todos.reduce(function(a,x){ return a+x.c.neto; },0);
  var bruto =todos.reduce(function(a,x){ return a+(Number(x.e.bruto)||0); },0);
  // v764: la planilla impresa da los ingresos YA SIN las ausencias y
  // tardanzas (no las pone como deducción). Para que el bruto cuadre con
  // ella se muestra igual; el bruto antes de ausencias queda debajo.
  var ausT  =todos.reduce(function(a,x){ return a+(Number(x.e.aus_tard)||0); },0);
  var brutoPla=Math.round((bruto-ausT)*100)/100;

  var P=(S.planilla.datos||{}).periodo||{};
  var h='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
    +'margin-bottom:12px">'
    +'<div style="flex:1;min-width:200px">'
    +'<div style="font-size:15px;font-weight:700">Preliminar de la quincena</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +'Corte '+_esc(P.desde||'?')+' al '+_esc(P.hasta||'?')
    +' · planilla nº '+_esc(String(P.numero||'?'))
    +' · '+todos.length+' empleado(s)</div></div>'
    +'<button class="xb" onclick="_plaCerrarPreliminar()">'
    +'<i class="ti ti-arrow-left"></i> Volver a los archivos</button>'
    +'<button class="btn bp" style="background:#5B21B6;padding:9px 18px" '
    +'onclick="_plaGuardar()"><i class="ti ti-device-floppy"></i> '
    +'Guardar la quincena</button></div>';

  // Los tres números que importan
  var caja=function(t,v,col,bg,pie){
    return '<div style="background:'+bg+';border-radius:12px;padding:12px 15px">'
      +'<div style="font-size:10.5px;color:'+col+';opacity:.85">'+_esc(t)+'</div>'
      +'<div style="font-size:19px;font-weight:800;color:'+col+'">'+v+'</div>'
      +(pie?('<div style="font-size:10.5px;color:'+col+';opacity:.8">'
        +_esc(pie)+'</div>'):'')+'</div>';
  };
  var difTot=Math.round((pagado-calcul)*100)/100;
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));'
    +'gap:10px;margin-bottom:14px">'
    + caja('Se está pagando', fmt(pagado), '#0C447C', 'var(--pastel-azul)',
           'neto de la planilla')
    + caja('Según las fórmulas', fmt(calcul), '#166534', 'var(--pastel-ok)',
           'bruto − ISR − 9,75% − 1,25% − ausencias − otras')
    + caja(difTot===0?'Cuadra':'Diferencia',
           (difTot===0?'$0.00':((difTot>0?'+':'−')+fmt(Math.abs(difTot)))),
           difTot===0?'#166534':'#991B1B',
           difTot===0?'var(--pastel-ok)':'var(--pastel-error)',
           difTot===0?'no hay descuadres':(conDif.length+' empleado(s) descuadran'))
    + caja('Salario bruto (como la planilla)', fmt(brutoPla), 'var(--t-lila)', 'var(--pastel-lila)',
           ausT ? ('antes de ausencias '+fmt(bruto)+' · ausencias y tardanzas '+fmt(ausT)) : '')
    +'</div>';

  // Cuántos cruzaron de verdad: se ve ANTES de guardar
  if(marc.length){
    var cruzan=todos.filter(function(x){ return x.marc; }).length;
    h+='<div class="nota" style="background:'
      +(cruzan?'var(--pastel-ok);color:var(--t-verde)'
              :'var(--pastel-error);color:var(--t-rojo)')
      +';font-size:12px"><b>'+cruzan+' de '+todos.length
      +'</b> empleados cruzan con el reloj · '
      +marc.length+' en el informe de asistencia'
      +(cruzan?'':' · revisa que los dos informes sean del mismo corte')
      +'</div>';
  }

  // Quién no aparece en el reloj (sin contar a los que nunca marcan)
  if(marc.length){
    var faltan=todos.filter(function(x){
      return !x.marc && _plaMarcaReloj(x.e.nombre); });
    var sobran=marc.filter(function(m){
      return !todos.some(function(x){ return _plaClave(x.e.nombre)===_plaClave(m.nombre); }); });
    if(faltan.length || sobran.length){
      h+='<div class="nota" style="background:var(--pastel-aviso);'
        +'color:var(--t-marron);font-size:12px">'
        +(faltan.length?('<b>'+faltan.length+' cobran sin marcaciones.</b> '
          +'Si alguno no ficha nunca, pulsa «No marca» y no se vuelve a avisar:'
          +'<div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:5px">'
          + faltan.map(function(x){
              var nm=String(x.e.nombre||'');
              return '<span style="background:var(--surface-0);border:0.5px solid #E9C08A;'
                +'border-radius:999px;padding:2px 4px 2px 10px;font-size:11px">'+_esc(nm)
                +' <button class="xb" style="font-size:10px;padding:1px 7px;margin-left:3px" '
                +'onclick="_plaMarcarNoMarca(\''+_esc(nm.replace(/'/g,''))+'\')">'
                +'No marca</button></span>'; }).join('')+'</div>'):'')
        +(faltan.length&&sobran.length?'<br>':'')
        +(sobran.length?('<b>'+sobran.length+' marcan y no están en la planilla:</b> '
          +_esc(sobran.slice(0,8).map(function(m){ return m.nombre; }).join(', '))):'')
        +'</div>';
    }
  }

  // El tope de incapacidad del año
  h+=_plaIncapNotaHtml(S);

  // Buscador
  h+='<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:11px">'
    +'<input id="plaBuscar" value="'+_esc(S.q||'')+'" autocomplete="off" '
    +'placeholder="Buscar empleado por nombre o número…" '
    +'oninput="_plaFiltrar(this.value)" style="flex:1;min-width:250px;'
    +'padding:9px 15px;border:0.5px solid var(--border);border-radius:999px;'
    +'font-size:12.5px;background:var(--surface-0);color:var(--text-primary)">'
    +'<span class="pill'+(S.soloDif?' active':'')+'" onclick="_plaSoloDif()">'
    +'Solo los que descuadran'+(conDif.length?(' ('+conDif.length+')'):'')+'</span>'
    +'</div>';

  var lista=todos;
  if(S.soloDif) lista=conDif;
  if(q) lista=lista.filter(function(x){
    return String(x.e.nombre||'').toLowerCase().indexOf(q)>=0
        || String(x.e.num_empleado||'').indexOf(q)>=0; });
  lista.sort(function(a,b){
    return Math.abs(b.dif)-Math.abs(a.dif)
        || String(a.e.nombre).localeCompare(String(b.e.nombre)); });

  var th='padding:9px 10px;font-size:10px;font-weight:700;color:#fff;'
        +'text-align:right;position:sticky;top:0;background:#5B21B6;z-index:1';
  h+='<div style="border:0.5px solid var(--border);border-radius:12px;'
    +'overflow:auto;max-height:58vh;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr>'
    +'<th style="'+th+';text-align:left;width:60px">Nº</th>'
    +'<th style="'+th+';text-align:left">EMPLEADO</th>'
    +'<th style="'+th+'">BRUTO</th>'
    +'<th style="'+th+'">S.S. PAGA</th>'
    +'<th style="'+th+'">S.S. DEBE</th>'
    +'<th style="'+th+'">S.E. PAGA</th>'
    +'<th style="'+th+'">S.E. DEBE</th>'
    +'<th style="'+th+'">OTRAS</th>'
    +'<th style="'+th+'">NETO PAGA</th>'
    +'<th style="'+th+'">NETO DEBE</th>'
    +'<th style="'+th+'">DIF.</th>'
    +'<th style="'+th+'">HORAS</th></tr></thead><tbody>';

  lista.forEach(function(x, i){
    var e=x.e, c=x.c;
    var hay=Math.abs(x.dif)>0.02;
    var td='padding:8px 10px;border-bottom:0.5px solid var(--border);text-align:right';
    var difSS=Math.abs((Number(e.ss)||0)-c.ss)>0.02;
    var difSE=Math.abs((Number(e.se)||0)-c.se)>0.02;
    h+='<tr style="'+(hay?'background:var(--pastel-error)'
                        :((i%2)?'background:var(--bg-accent)':''))+'">'
      +'<td style="'+td+';text-align:left;color:var(--text-muted)">'
      +_esc(e.num_empleado||'')+'</td>'
      +'<td style="'+td+';text-align:left"><b>'+_esc(e.nombre||'')+'</b></td>'
      +'<td style="'+td+'">'+fmt(e.bruto)+'</td>'
      +'<td style="'+td+(difSS?';color:#991B1B;font-weight:700':'')+'">'+fmt(e.ss)+'</td>'
      +'<td style="'+td+';color:#166534">'+fmt(c.ss)+'</td>'
      +'<td style="'+td+(difSE?';color:#991B1B;font-weight:700':'')+'">'+fmt(e.se)+'</td>'
      +'<td style="'+td+';color:#166534">'+fmt(c.se)+'</td>'
      +'<td style="'+td+'">'+(e.otras_ded?fmt(e.otras_ded):'—')+'</td>'
      +'<td style="'+td+';font-weight:700">'+fmt(e.neto)+'</td>'
      +'<td style="'+td+';font-weight:700;color:#166534">'+fmt(c.neto)+'</td>'
      +'<td style="'+td+';font-weight:800;color:'+(hay?'#991B1B':'var(--text-muted)')+'">'
      +(hay?((x.dif>0?'+':'−')+fmt(Math.abs(x.dif))):'ok')+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'
      +(x.marc?_fmtN2(x.marc.horas):(_plaMarcaReloj(e.nombre)?'—':'no marca'))
      +'</td></tr>';
  });

  h+='</tbody><tfoot><tr style="background:var(--pastel-lila);font-weight:800">'
    +'<td colspan="8" style="padding:10px;text-align:right">TOTALES · '
    +lista.length+' empleado(s)</td>'
    +'<td style="padding:10px;text-align:right">'
    +fmt(lista.reduce(function(a,x){ return a+(Number(x.e.neto)||0); },0))+'</td>'
    +'<td style="padding:10px;text-align:right;color:#166534">'
    +fmt(lista.reduce(function(a,x){ return a+x.c.neto; },0))+'</td>'
    +'<td style="padding:10px;text-align:right">'
    +fmt(lista.reduce(function(a,x){ return a+Math.abs(x.dif); },0))+'</td>'
    +'<td></td></tr></tfoot></table></div>';

  h+='<div id="pla-resultado" style="margin-top:12px">'+(S.revision||'')+'</div>';
  return h;
}

function _plaCerrarPreliminar(){ window._pla.vista=null; _plaPintar(); }
function _plaSoloDif(){ window._pla.soloDif=!window._pla.soloDif; _plaPintar(); }

function _plaTab(k){ window._pla.tab=k; window._pla.q=''; _plaPintar(); }

/* ── Los descuentos: quién debe, cuánto le quitan y cuánto le queda ───── */
function _plaTablaDescuentos(emps){
  var L=emps.filter(function(e){
    return (Number(e.otras_ded)||0)>0 || (Number(e.aus_tard)||0)>0; });
  if(!L.length){
    return '<div class="empty" style="padding:20px">'
      +'Nadie tiene descuentos en esta quincena.</div>';
  }
  L.sort(function(a,b){
    return ((Number(b.otras_ded)||0)+(Number(b.aus_tard)||0))
         - ((Number(a.otras_ded)||0)+(Number(a.aus_tard)||0)); });

  var totPrest=L.reduce(function(a,e){ return a+(Number(e.otras_ded)||0); },0);
  var totAus  =L.reduce(function(a,e){ return a+(Number(e.aus_tard)||0); },0);

  var h='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(165px,1fr));'
    +'gap:10px;margin-bottom:13px">'
    +'<div style="background:var(--pastel-aviso);border-radius:12px;padding:11px 14px">'
    +'<div style="font-size:10.5px;color:var(--t-marron)">Préstamos y deudas</div>'
    +'<div style="font-size:17px;font-weight:800;color:var(--t-marron)">'
    +fmt(totPrest)+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);opacity:.8">'
    +L.filter(function(e){ return (Number(e.otras_ded)||0)>0; }).length
    +' empleado(s)</div></div>'
    +'<div style="background:var(--pastel-error);border-radius:12px;padding:11px 14px">'
    +'<div style="font-size:10.5px;color:#991B1B">Ausencias y tardanzas</div>'
    +'<div style="font-size:17px;font-weight:800;color:#991B1B">'+fmt(totAus)+'</div>'
    +'<div style="font-size:10.5px;color:#991B1B;opacity:.8">'
    +L.filter(function(e){ return (Number(e.aus_tard)||0)>0; }).length
    +' empleado(s)</div></div>'
    +'<div style="background:var(--pastel-lila);border-radius:12px;padding:11px 14px">'
    +'<div style="font-size:10.5px;color:var(--t-lila)">Total descontado</div>'
    +'<div style="font-size:17px;font-weight:800;color:var(--t-lila)">'
    +fmt(totPrest+totAus)+'</div></div></div>';

  var th='padding:9px 11px;font-size:10.5px;font-weight:700;color:#fff;'
        +'text-align:right;position:sticky;top:0;background:#B45309;z-index:1';
  h+='<div style="border:0.5px solid var(--border);border-radius:12px;'
    +'overflow:auto;max-height:58vh;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px">'
    +'<thead><tr>'
    +'<th style="'+th+';text-align:left;width:65px">Nº</th>'
    +'<th style="'+th+';text-align:left">EMPLEADO</th>'
    +'<th style="'+th+'">BRUTO</th>'
    +'<th style="'+th+'">PRÉSTAMO</th>'
    +'<th style="'+th+'">SALDO PRÉSTAMO</th>'
    +'<th style="'+th+'">AUS/TARD</th>'
    +'<th style="'+th+'">IMPUESTOS Y SEGUROS</th>'
    +'<th style="'+th+'">LE QUEDA</th>'
    +'<th style="'+th+'">% DEL BRUTO</th></tr></thead><tbody>';

  L.forEach(function(e, i){
    var td='padding:9px 11px;border-bottom:0.5px solid var(--border);text-align:right';
    var prest=Number(e.otras_ded)||0, aus=Number(e.aus_tard)||0;
    var leg=(Number(e.isr)||0)+(Number(e.ss)||0)+(Number(e.se)||0);
    var bruto=Number(e.bruto)||0, neto=Number(e.neto)||0;
    var pct=bruto?Math.round((prest+aus)/bruto*1000)/10:0;
    var sinSueldo=(neto<=0.009);
    h+='<tr style="cursor:pointer;'+(sinSueldo?'background:var(--pastel-error)'
                                              :((i%2)?'background:var(--bg-accent)':''))+'" '
      +'onclick="_plaFicha(\''+_esc(e.num_empleado)+'\')">'
      +'<td style="'+td+';text-align:left;color:var(--text-muted)">'
      +_esc(e.num_empleado||'')+'</td>'
      +'<td style="'+td+';text-align:left"><b>'+_esc(e.nombre||'')+'</b>'
      +(sinSueldo?' <span style="background:#991B1B;color:#fff;border-radius:6px;'
        +'padding:1px 7px;font-size:10px;font-weight:700">sin sueldo</span>':'')
      +'</td>'
      +'<td style="'+td+'">'+fmt(bruto)+'</td>'
      +'<td style="'+td+';font-weight:700;color:var(--t-marron)">'
      +(prest?fmt(prest):'—')+'</td>'
      +'<td style="'+td+';color:var(--t-marron)">'+(function(){ var pr=_plpDe(e);
          return pr?fmt(pr.saldo):'<span style="color:var(--text-muted)">—</span>'; })()+'</td>'
      +'<td style="'+td+';color:#991B1B">'+(aus?fmt(aus):'—')+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'+fmt(leg)+'</td>'
      +'<td style="'+td+';font-weight:800;color:'+(sinSueldo?'#991B1B':'#166534')+'">'
      +fmt(neto)+'</td>'
      +'<td style="'+td+'">'+pct+'%</td></tr>';
  });
  h+='<tr style="background:var(--pastel-aviso);font-weight:800">'
    +'<td colspan="3" style="padding:10px 11px;text-align:right">TOTALES</td>'
    +'<td style="padding:10px 11px;text-align:right">'+fmt(totPrest)+'</td><td></td>'
    +'<td style="padding:10px 11px;text-align:right">'+fmt(totAus)+'</td>'
    +'<td colspan="3"></td></tr>';
  h+='</tbody></table></div>';
  return h;
}

/* ═══════════════════════════════════════════════════════════════════════════
   PRÉSTAMOS A EMPLEADOS   (prefijo [PLP] · v718)
   ───────────────────────────────────────────────────────────────────────────
   La base es el «Informe de descuentos» del programa de nómina (cuentas por
   cobrar a empleados): por cada empleado, su cuota por quincena y el saldo
   que le queda. Se sube el PDF y se guarda tal cual en planilla_prestamos,
   con su fecha de corte y su número de planilla; al subirlo se comprueba
   contra los «Totales Globales» del propio informe, así que lo que se ve
   recién cargado es IGUAL al informe.
   A partir de ahí el saldo baja solo: cada quincena guardada DESPUÉS de la
   fecha de corte resta lo que se le descontó al empleado en «Otras». Si se
   sube un informe más nuevo, pasa a ser la base y todo vuelve a cuadrar con
   él. Se casa por número de empleado y, si no, por nombre.
   ═══════════════════════════════════════════════════════════════════════════ */

var PLP_MESES={enero:1,febrero:2,marzo:3,abril:4,mayo:5,junio:6,julio:7,agosto:8,
               septiembre:9,setiembre:9,octubre:10,noviembre:11,diciembre:12};

function _plpNumEmp(n){
  var t=String(n==null?'':n).trim();
  return /^\d+$/.test(t) ? String(Number(t)) : t.toUpperCase();
}
function _plpMonto(t){ return Number(String(t||'').replace(/,/g,''))||0; }

// Lee el «Informe de descuentos» ya partido en filas por _plaTextoPorFilas
function _plpLeerInforme(paginas){
  var out={prestamos:[], fecha:null, planilla:null, totales:null, avisos:[]};
  var esMonto=function(t){ return /^-?[\d,]+\.\d{2}$/.test(t); };
  var esMayus=function(t){ return /[A-ZÑÁÉÍÓÚ]/.test(t) && t===t.toUpperCase(); };
  paginas.forEach(function(filas){
    filas.forEach(function(fila){
      var tk=fila.map(function(x){ return String(x.t||'').trim(); }).filter(Boolean);
      var txt=tk.join(' ');
      // La fecha de la planilla: la línea que es SOLO una fecha (la otra lleva la hora)
      var mf=txt.match(/^([A-Za-zé]+)\s+(\d{1,2}),\s*(\d{4})$/);
      if(mf && PLP_MESES[mf[1].toLowerCase()] && !out.fecha)
        out.fecha=mf[3]+'-'+String(PLP_MESES[mf[1].toLowerCase()]).padStart(2,'0')+'-'+mf[2].padStart(2,'0');
      var mp=txt.match(/Planilla\s*N[ºo°]?\s*:\s*(\d+)/i);
      if(mp && !out.planilla) out.planilla=Number(mp[1]);
      if(tk.length<6) return;
      var n=tk.length;
      if(!(esMonto(tk[n-1]) && esMonto(tk[n-2]) && esMonto(tk[n-3]) && esMonto(tk[n-4]))) return;
      var nums=tk.slice(n-4).map(_plpMonto);
      var resto=tk.slice(0,n-4);
      if(/^totales/i.test(resto[0]||'')){ out.totales={cuota:nums[0], saldo:nums[1]}; return; }
      if(/^sub-?total/i.test(resto[0]||'')) return;
      // El número de empleado: el primer número entero suelto tras el nombre
      var ie=-1;
      for(var i=1;i<resto.length;i++){ if(/^\d{1,6}$/.test(resto[i])){ ie=i; break; } }
      if(ie<1){ out.avisos.push('No entendí la línea: '+txt); return; }
      var antes=resto.slice(0,ie), despues=resto.slice(ie+1);
      var ced='';
      if(despues.length && /^([A-Z]{1,2}-)?\d{1,3}-\d{1,6}(-\d{1,6})?$/.test(despues[0])) ced=despues.shift();
      // El departamento va en MAYÚSCULAS al final del nombre
      var k=antes.length;
      while(k>1 && esMayus(antes[k-1])) k--;
      var acre=despues.join(' ').replace(/\s*Salario Regular\s*$/i,'').trim()||'Préstamo';
      out.prestamos.push({num_empleado:resto[ie], nombre:antes.slice(0,k).join(' '),
        departamento:antes.slice(k).join(' '), cedula:ced, acreedor:acre,
        cuota:nums[0], saldo:nums[1], acum_mes:nums[2], acum_anio:nums[3]});
    });
  });
  return out;
}

async function _plpSubir(input){
  var f=input.files&&input.files[0]; input.value='';
  if(!f) return;
  var P=window._plp; if(!P) return;
  P.estado={tipo:'info', txt:'Leyendo '+f.name+'…'}; _plpPintar();
  try{
    var b64=await new Promise(function(res,rej){
      var r=new FileReader(); r.onload=function(){ res(String(r.result).split(',')[1]); };
      r.onerror=function(){ rej(new Error('no pude leer el archivo')); }; r.readAsDataURL(f); });
    var inf=_plpLeerInforme(await _plaTextoPorFilas(b64));
    if(!inf.prestamos.length) throw new Error('no encontré ningún préstamo en el PDF');
    if(!inf.fecha) throw new Error('no encontré la fecha de la planilla en el informe');
    var tc=Math.round(inf.prestamos.reduce(function(a,x){ return a+x.cuota; },0)*100)/100;
    var ts=Math.round(inf.prestamos.reduce(function(a,x){ return a+x.saldo; },0)*100)/100;
    var cuadra = inf.totales && Math.abs(tc-inf.totales.cuota)<0.005 && Math.abs(ts-inf.totales.saldo)<0.005;
    if(!cuadra){
      throw new Error('lo leído no cuadra con los Totales Globales del informe (leí cuota '
        +fmt(tc)+' y saldo '+fmt(ts)+(inf.totales?(', el informe dice '+fmt(inf.totales.cuota)+' y '
        +fmt(inf.totales.saldo)):', y no encontré los totales')+'). No se guardó nada.');
    }
    if(!confirm('INFORME DE DESCUENTOS · planilla Nº '+(inf.planilla||'?')+' del '+inf.fecha+'\n\n'
      +inf.prestamos.length+' préstamo(s)\nCuota por quincena: '+fmt(tc)+'\nSaldo por cobrar: '+fmt(ts)
      +'\n\n✓ Cuadra con los Totales Globales del informe.\n\nPasa a ser la base de los préstamos. ¿Lo guardo?')){
      P.estado=null; _plpPintar(); return;
    }
    // Se reemplaza lo que hubiera con la misma fecha de corte
    await fetch(SB+'/rest/v1/planilla_prestamos?fecha_corte=eq.'+inf.fecha,{method:'DELETE',headers:SBH});
    var filas=inf.prestamos.map(function(x){
      return Object.assign({}, x, {fecha_corte:inf.fecha, planilla_nro:inf.planilla,
        total_cuota_informe:inf.totales.cuota, total_saldo_informe:inf.totales.saldo,
        archivo:f.name, cargado_por:(CU&&CU.name)||''}); });
    var r=await fetch(SB+'/rest/v1/planilla_prestamos',{method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}), body:JSON.stringify(filas)});
    if(!r.ok){
      var t=await r.text();
      throw new Error(/does not exist|Could not find/i.test(t)?'falta correr v718.sql en Supabase':t.slice(0,160));
    }
    P.estado={tipo:'ok', txt:'Guardado: '+inf.prestamos.length+' préstamos, saldo '+fmt(ts)
      +'. Cuadra con el informe.'};
    window._plpCache=null;
    await _plpCargar();
  }catch(e){
    P.estado={tipo:'error', txt:'No se pudo cargar: '+(e.message||e)};
    _plpPintar();
  }
}

/* Los préstamos con su saldo de HOY: la base del último informe menos lo
   descontado en las quincenas guardadas después de su fecha de corte.
   «excluir» = {desde,hasta} de una quincena que no se debe contar (la que
   se está revisando y todavía no está guardada). */
async function _plpDatos(excluir){
  var r=await fetch(SB+'/rest/v1/planilla_prestamos?select=*&order=fecha_corte.desc,nombre&limit=3000',
    {headers:SBH});
  if(!r.ok){
    var t=await r.text();
    if(/does not exist|Could not find/i.test(t)) return {sinTabla:true, lista:[]};
    throw new Error(t.slice(0,140));
  }
  var todas=(await r.json())||[];
  if(!todas.length) return {lista:[]};
  var corte=todas[0].fecha_corte;
  var base=todas.filter(function(x){ return x.fecha_corte===corte; });
  // Las quincenas guardadas DESPUÉS del corte
  var rp=await fetch(SB+'/rest/v1/planilla_periodos?select=id,desde,hasta,tipo,fecha_pago'
    +'&hasta=gt.'+corte+'&order=hasta',{headers:SBH});
  var pers=rp.ok?((await rp.json())||[]):[];
  if(excluir) pers=pers.filter(function(p){ return !(p.desde===excluir.desde && p.hasta===excluir.hasta); });
  // Una quincena guardada dos veces solo cuenta una
  var vistos={}; pers=pers.filter(function(p){ var k=p.desde+'|'+p.hasta+'|'+_plaTipo(p.tipo);
    if(vistos[k]) return false; vistos[k]=1; return true; });
  var desc=[];
  if(pers.length){
    var ids=pers.map(function(p){ return p.id; });
    for(var i=0;i<ids.length;i+=20){
      var re=await fetch(SB+'/rest/v1/planilla_empleados?select=num_empleado,nombre,otras_ded,periodo_id'
        +'&otras_ded=gt.0&periodo_id=in.('+ids.slice(i,i+20).join(',')+')&limit=5000',{headers:SBH});
      if(re.ok) desc=desc.concat((await re.json())||[]);
    }
  }
  var perPor={}; pers.forEach(function(p){ perPor[p.id]=p; });
  var lista=base.map(function(x){
    return Object.assign({}, x, {saldo_informe:Number(x.saldo)||0, cuota:Number(x.cuota)||0,
      saldo:Number(x.saldo)||0, descontado:0, movimientos:[], deMas:0}); });
  var porNum={}, porNom={};
  lista.forEach(function(x){
    (porNum[_plpNumEmp(x.num_empleado)]=porNum[_plpNumEmp(x.num_empleado)]||[]).push(x);
    (porNom[_plaClave(x.nombre)]=porNom[_plaClave(x.nombre)]||[]).push(x);
  });
  desc.sort(function(a,b){ return String((perPor[a.periodo_id]||{}).hasta).localeCompare(String((perPor[b.periodo_id]||{}).hasta)); });
  desc.forEach(function(d){
    var suyos=porNum[_plpNumEmp(d.num_empleado)] || porNom[_plaClave(d.nombre)];
    if(!suyos) return;
    var monto=Number(d.otras_ded)||0, p=perPor[d.periodo_id]||{};
    suyos.forEach(function(x){
      if(monto<=0) return;
      var toma=Math.min(monto, x.saldo);
      x.saldo=Math.round((x.saldo-toma)*100)/100;
      x.descontado=Math.round((x.descontado+toma)*100)/100;
      x.movimientos.push({desde:p.desde, hasta:p.hasta, monto:toma});
      monto=Math.round((monto-toma)*100)/100;
    });
    if(monto>0.009) suyos[suyos.length-1].deMas=Math.round((suyos[suyos.length-1].deMas+monto)*100)/100;
  });
  return {corte:corte, planilla:base[0].planilla_nro, archivo:base[0].archivo,
          cargado_por:base[0].cargado_por, cargado_en:base[0].cargado_en,
          total_cuota_informe:Number(base[0].total_cuota_informe)||null,
          total_saldo_informe:Number(base[0].total_saldo_informe)||null,
          quincenas:pers, lista:lista};
}

async function _plpAbrir(){
  if(!_plaPuede()){ showT('No tienes acceso'); return; }
  var prev=document.getElementById('modalPlp'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPlp';
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:12500;'
    +'display:flex;flex-direction:column;padding:12px 14px;overflow:auto';
  ov.innerHTML='<div id="plpCuerpo"></div>';
  document.body.appendChild(ov);
  window._plp={q:'', estado:null, cargando:true, datos:null, ver:null};
  _plpPintar();
  await _plpCargar();
}
function _plpCerrar(){ var m=document.getElementById('modalPlp'); if(m) m.remove(); }

async function _plpCargar(){
  var P=window._plp; if(!P) return;
  P.cargando=true; _plpPintar();
  try{ P.datos=await _plpDatos(); window._plpCache=P.datos; }
  catch(e){ P.estado={tipo:'error', txt:'No pude leer los préstamos: '+(e.message||e)}; }
  P.cargando=false; _plpPintar();
}

function _plpPintar(){
  var c=document.getElementById('plpCuerpo'); if(!c) return;
  var P=window._plp||{}, D=P.datos||{lista:[]};
  var L=(D.lista||[]).slice();
  var h='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:12px">'
    +'<div style="width:38px;height:38px;border-radius:10px;background:var(--pastel-aviso);display:flex;'
    +'align-items:center;justify-content:center"><i class="ti ti-cash" style="font-size:20px;color:var(--t-marron)"></i></div>'
    +'<div style="flex:1;min-width:220px"><div style="font-size:16px;font-weight:700">Préstamos a empleados</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +(D.corte?('Base: informe de descuentos de la planilla Nº '+_esc(D.planilla||'?')+' del '+_esc(D.corte)
      +' · '+(D.quincenas||[]).length+' quincena(s) guardada(s) después'):'Todavía no se ha cargado ningún informe')
    +'</div></div>'
    +'<label class="btn bp" style="padding:8px 14px;cursor:pointer;background:#B45309">'
    +'<i class="ti ti-file-upload"></i> Cargar informe de descuentos (PDF)'
    +'<input type="file" accept=".pdf" style="display:none" onchange="_plpSubir(this)"></label>'
    +'<button class="xb" onclick="_plpCerrar()"><i class="ti ti-x"></i> Cerrar</button></div>';

  if(P.estado && P.estado.txt){
    var col={info:['var(--pastel-azul)','var(--t-azul)'],error:['var(--pastel-error)','var(--t-rojo)'],
             ok:['var(--pastel-ok)','var(--t-verde)']}[P.estado.tipo]||[];
    h+='<div class="nota" style="background:'+col[0]+';color:'+col[1]+';font-size:12px;font-weight:600">'
      +(P.estado.tipo==='info'?'<span class="ai-ring g"></span> ':'')+_esc(P.estado.txt)+'</div>';
  }
  if(P.cargando){ c.innerHTML=h+'<div class="empty"><span class="ai-ring g"></span> Cargando…</div>'; return; }
  if(D.sinTabla){ c.innerHTML=h+'<div class="nota">Falta correr <b>v718.sql</b> en Supabase.</div>'; return; }
  if(!L.length){ c.innerHTML=h+'<div class="empty" style="padding:30px">Carga el «Informe de descuentos» '
    +'de la nómina (el PDF de cuentas por cobrar a empleados) para empezar.</div>'; return; }

  var sum=function(k){ return Math.round(L.reduce(function(a,x){ return a+(Number(x[k])||0); },0)*100)/100; };
  var activos=L.filter(function(x){ return x.saldo>0.009; });
  var cuotaViva=Math.round(activos.reduce(function(a,x){ return a+Math.min(x.cuota,x.saldo); },0)*100)/100;
  var caja=function(t,v,pie,colr,bg){ return '<div style="background:'+bg+';border-radius:12px;padding:12px 15px;color:'+colr+'">'
    +'<div style="font-size:11px;font-weight:600;opacity:.85">'+t+'</div>'
    +'<div style="font-size:21px;font-weight:800">'+v+'</div><div style="font-size:10.5px;opacity:.85">'+pie+'</div></div>'; };
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:10px;margin-bottom:12px">'
    + caja('PENDIENTE POR COBRAR', fmt(sum('saldo')), activos.length+' empleado(s) con saldo', 'var(--t-marron)','var(--pastel-aviso)')
    + caja('SE DESCUENTA POR QUINCENA', fmt(cuotaViva), 'la cuota de los que aún deben', '#991B1B','var(--pastel-error)')
    + caja('SALDO SEGÚN EL INFORME', fmt(sum('saldo_informe')), 'al '+_esc(D.corte)+' · planilla Nº '+_esc(D.planilla||'?'), 'var(--t-azul)','var(--pastel-azul)')
    + caja('COBRADO DESDE EL INFORME', fmt(sum('descontado')), (D.quincenas||[]).length+' quincena(s) guardada(s) después', '#166534','var(--pastel-ok)')
    +'</div>';
  // ¿Cuadra con el informe?
  if(D.total_saldo_informe!=null){
    var ok=Math.abs(sum('saldo_informe')-D.total_saldo_informe)<0.005;
    h+='<div class="nota" style="background:'+(ok?'var(--pastel-ok);color:var(--t-verde)':'var(--pastel-error);color:var(--t-rojo)')
      +';font-size:11.5px">'+(ok?'<i class="ti ti-circle-check"></i> ':'<i class="ti ti-alert-triangle"></i> ')
      +'Informe del '+_esc(D.corte)+': '+L.length+' préstamos · cuota '+fmt(sum('cuota'))+' · saldo '
      +fmt(sum('saldo_informe'))+(ok?' · igual que los Totales Globales del informe':' · NO cuadra con '+fmt(D.total_saldo_informe))
      +'. Archivo '+_esc(D.archivo||'')+(D.cargado_por?(' · cargado por '+_esc(D.cargado_por)):'')+'.</div>';
  }
  var deMas=L.filter(function(x){ return x.deMas>0; });
  if(deMas.length) h+='<div class="nota" style="background:var(--pastel-error);color:var(--t-rojo);font-size:11.5px">'
    +'<b>Descontado de más:</b> '+deMas.map(function(x){ return _esc(x.nombre)+' ('+fmt(x.deMas)+')'; }).join(', ')
    +'. Se les descontó más de lo que debían.</div>';

  var q=String(P.q||'').toLowerCase();
  if(q) L=L.filter(function(x){ return (x.nombre+' '+x.num_empleado+' '+x.departamento).toLowerCase().indexOf(q)>=0; });
  L.sort(function(a,b){ return b.saldo-a.saldo || String(a.nombre).localeCompare(String(b.nombre)); });

  h+='<input value="'+_esc(P.q||'')+'" placeholder="Buscar empleado, número o departamento…" '
    +'oninput="window._plp.q=this.value;_plpPintar();var e=document.getElementById(\'plpQ\');" id="plpQ" '
    +'style="width:100%;max-width:420px;padding:9px 15px;border:0.5px solid var(--border);border-radius:999px;'
    +'font-size:12.5px;margin-bottom:10px;background:var(--surface-0);color:var(--text-primary)">';
  var th='padding:9px 10px;font-size:10.5px;font-weight:700;color:#fff;text-align:right;position:sticky;top:0;background:#B45309;z-index:1';
  h+='<div style="border:0.5px solid var(--border);border-radius:12px;overflow:auto;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr>'
    +'<th style="'+th+';text-align:left;width:60px">Nº</th><th style="'+th+';text-align:left">EMPLEADO</th>'
    +'<th style="'+th+';text-align:left">DEPARTAMENTO</th><th style="'+th+'">CUOTA</th>'
    +'<th style="'+th+'">SALDO INFORME</th><th style="'+th+'">DESCONTADO DESPUÉS</th>'
    +'<th style="'+th+'">PENDIENTE</th><th style="'+th+'">QUINCENAS QUE FALTAN</th></tr></thead><tbody>';
  L.forEach(function(x,i){
    var td='padding:8px 10px;border-bottom:0.5px solid var(--border);text-align:right';
    var faltan=x.saldo>0.009 && x.cuota>0 ? Math.ceil(x.saldo/x.cuota-1e-9) : 0;
    var pagado=x.saldo<=0.009;
    var pct=x.saldo_informe>0?Math.round(x.descontado/x.saldo_informe*100):100;
    h+='<tr style="cursor:pointer;'+(pagado?'background:var(--pastel-ok)':((i%2)?'background:var(--bg-accent)':''))+'" '
      +'onclick="window._plp.ver=(window._plp.ver===\''+_esc(x.id)+'\'?null:\''+_esc(x.id)+'\');_plpPintar()">'
      +'<td style="'+td+';text-align:left;color:var(--text-muted)">'+_esc(x.num_empleado)+'</td>'
      +'<td style="'+td+';text-align:left"><b>'+_esc(x.nombre)+'</b>'
      +(pagado?' <span style="background:#166534;color:#fff;border-radius:6px;padding:1px 7px;font-size:10px">pagado</span>':'')
      +'<div style="height:4px;background:var(--surface-2);border-radius:3px;margin-top:4px;max-width:160px">'
      +'<div style="height:4px;width:'+Math.min(100,pct)+'%;background:#166534;border-radius:3px"></div></div></td>'
      +'<td style="'+td+';text-align:left;font-size:11px;color:var(--text-muted)">'+_esc(x.departamento)+'</td>'
      +'<td style="'+td+'">'+fmt(x.cuota)+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'+fmt(x.saldo_informe)+'</td>'
      +'<td style="'+td+';color:#166534">'+(x.descontado?fmt(x.descontado):'—')+'</td>'
      +'<td style="'+td+';font-weight:800;color:var(--t-marron)">'+fmt(x.saldo)+'</td>'
      +'<td style="'+td+'">'+(faltan||'—')+'</td></tr>';
    if(P.ver===String(x.id)){
      h+='<tr><td colspan="8" style="padding:8px 14px 12px;background:var(--surface-2);font-size:11.5px">'
        +'<b>'+_esc(x.acreedor)+'</b>'+(x.cedula?(' · cédula '+_esc(x.cedula)):'')
        +' · saldo al '+_esc(D.corte)+': '+fmt(x.saldo_informe)
        +(x.movimientos.length? x.movimientos.map(function(m){
            return '<div>Quincena '+_esc(m.desde)+' al '+_esc(m.hasta)+': descontado <b>'+fmt(m.monto)+'</b></div>'; }).join('')
          : '<div style="color:var(--text-muted)">Sin quincenas guardadas después del informe.</div>')
        +'<div style="margin-top:3px">Pendiente hoy: <b>'+fmt(x.saldo)+'</b></div></td></tr>';
    }
  });
  h+='<tr style="background:var(--pastel-aviso);font-weight:800"><td colspan="3" style="padding:10px;text-align:right">TOTALES</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(L.reduce(function(a,x){ return a+x.cuota; },0))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(L.reduce(function(a,x){ return a+x.saldo_informe; },0))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(L.reduce(function(a,x){ return a+x.descontado; },0))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(L.reduce(function(a,x){ return a+x.saldo; },0))+'</td><td></td></tr>';
  h+='</tbody></table></div>';
  c.innerHTML=h;
  var qi=document.getElementById('plpQ');
  if(qi && P.q){ qi.focus(); qi.setSelectionRange(qi.value.length, qi.value.length); }
}

// El préstamo vivo de un empleado de la planilla (por número y, si no, por nombre)
function _plpDe(e, datos){
  var D=datos||window._plpCache; if(!D || !D.lista) return null;
  var n=_plpNumEmp(e.num_empleado), k=_plaClave(e.nombre);
  var suyos=D.lista.filter(function(x){ return _plpNumEmp(x.num_empleado)===n; });
  if(!suyos.length) suyos=D.lista.filter(function(x){ return _plaClave(x.nombre)===k; });
  if(!suyos.length) return null;
  return {cuota:suyos.reduce(function(a,x){ return a+x.cuota; },0),
          saldo:Math.round(suyos.reduce(function(a,x){ return a+x.saldo; },0)*100)/100,
          esperado:Math.round(suyos.reduce(function(a,x){ return a+Math.min(x.cuota, Math.max(0,x.saldo)); },0)*100)/100};
}

/* La revisión: lo que se le descuenta de préstamo frente a lo que dice el
   registro de préstamos. Solo para quincenas posteriores al informe. */
function _plaRevisarPrestamos(emps, D, P){
  var hall=[];
  if(!D || !D.lista || !D.lista.length || !P || !(String(P.hasta||'')>String(D.corte||''))) return hall;
  (emps||[]).forEach(function(e){
    var pr=_plpDe(e, D), otras=Number(e.otras_ded)||0;
    if(pr){
      if(Math.abs(otras-pr.esperado)>0.009){
        hall.push({gravedad:otras>pr.esperado?'alta':'media', empleado:e.nombre, tipo:'Cuota del préstamo',
          detalle:(pr.esperado<pr.cuota-0.009?('Solo le quedan '+fmt(pr.saldo)+' de préstamo. '):'')
            +'Según el registro de préstamos se le debe descontar '+fmt(pr.esperado)+' y la planilla descuenta '+fmt(otras)+'.',
          esperado:fmt(pr.esperado), encontrado:fmt(otras), _pago:true});
      }
    } else if(otras>0){
      hall.push({gravedad:'media', empleado:e.nombre, tipo:'Descuento sin préstamo registrado',
        detalle:'Se le descuentan '+fmt(otras)+' en «Otras» y no tiene préstamo vivo en el último informe de descuentos.',
        esperado:fmt(0), encontrado:fmt(otras), _pago:true});
    }
  });
  return hall;
}

/* A cada hallazgo de un empleado se le añade lo que se le PAGA en la planilla
   y lo que, según las fórmulas (y el registro de préstamos), DEBERÍA cobrar. */
function _plaConPagoVsDebe(hall, emps, D, P){
  var porClave={};
  (emps||[]).forEach(function(e){ porClave[_plaClave(e.nombre)]=e; });
  var buscar=function(nombre){
    var k=_plaClave(nombre); if(porClave[k]) return porClave[k];
    var pal=_plaPalabras(nombre); if(pal.length<2) return null;
    return (emps||[]).filter(function(e){ var pe=_plaPalabras(e.nombre);
      return pal.every(function(w){ return pe.indexOf(w)>=0; }); })[0]||null;
  };
  var usarPrest = D && D.lista && D.lista.length && P && String(P.hasta||'')>String(D.corte||'');
  return (hall||[]).map(function(x){
    if(!x || !x.empleado) return x;
    var e=buscar(x.empleado); if(!e) return x;
    var c=_plaCalculado(e), otras=Number(e.otras_ded)||0;
    var debe=c.neto;
    if(usarPrest){
      var pr=_plpDe(e, D);
      var esp=pr?pr.esperado:0;
      debe=Math.round((c.neto+otras-esp)*100)/100;
    }
    return Object.assign({}, x, {pagado:Number(e.neto)||0, debe:debe});
  });
}

/* ── Las marcaciones de la quincena, empleado por empleado ─────────────── */
function _plaTablaMarcaciones(emps){
  var S=window._pla||{};
  var L=emps.filter(function(e){ return e.dias_reloj; });
  if(!L.length){
    return '<div class="empty" style="padding:20px">'
      +'Esta quincena se guardó sin el informe de marcaciones.<br>'
      +'<span style="font-size:11.5px;color:var(--text-muted)">Súbelo con '
      +'«Subir informes» y guarda otra vez.</span></div>';
  }
  var th='padding:9px 11px;font-size:10.5px;font-weight:700;color:#fff;'
        +'text-align:right;position:sticky;top:0;background:#0C447C;z-index:1';
  var h='<div style="border:0.5px solid var(--border);border-radius:12px;'
    +'overflow:auto;max-height:62vh;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px">'
    +'<thead><tr>'
    +'<th style="'+th+';text-align:left;width:65px">Nº</th>'
    +'<th style="'+th+';text-align:left">EMPLEADO</th>'
    +'<th style="'+th+'">DÍAS</th>'
    +'<th style="'+th+'">HORAS</th>'
    +'<th style="'+th+'">AUS/TARD</th>'
    +'<th style="'+th+';text-align:left;width:40px"></th></tr></thead><tbody>';
  L.sort(function(a,b){ return String(a.nombre||'').localeCompare(String(b.nombre||'')); });
  L.forEach(function(e, i){
    var td='padding:9px 11px;border-bottom:0.5px solid var(--border);text-align:right';
    h+='<tr style="cursor:pointer;'+((i%2)?'background:var(--bg-accent)':'')+'" '
      +'onclick="_plaVerMarcaciones(\''+_esc(e.num_empleado)+'\')">'
      +'<td style="'+td+';text-align:left;color:var(--text-muted)">'
      +_esc(e.num_empleado||'')+'</td>'
      +'<td style="'+td+';text-align:left"><b>'+_esc(e.nombre||'')+'</b></td>'
      +'<td style="'+td+'">'+(e.dias_reloj||0)+'</td>'
      +'<td style="'+td+';font-weight:700">'+_fmtN2(e.horas_reloj||0)+'</td>'
      +'<td style="'+td+';color:'+((Number(e.aus_tard)||0)?'#991B1B':'var(--text-muted)')+'">'
      +((Number(e.aus_tard)||0)?fmt(e.aus_tard):'—')+'</td>'
      +'<td style="'+td+';text-align:left;color:var(--text-muted)">'
      +'<i class="ti ti-clock"></i></td></tr>';
  });
  h+='</tbody></table></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:8px">'
    +'Pulsa un empleado para ver a qué hora entró, salió a comer y se fue '
    +'cada día.</div>';
  return h;
}

// Abre la ficha directamente en las marcaciones
function _plaVerMarcaciones(num){ _plaFicha(num); }

/* Los tres tipos de pago de Panamá, con nombre corto para las pastillas:
   la quincena normal, el décimo tercer mes (tres pagos al año) y la
   planilla de bonos de diciembre. */
function _plaTipo(t){
  var x=String(t||'').toLowerCase();
  if(/xiii|decimo|décimo|13/.test(x)) return 'XIII mes';
  if(/bono|aguinaldo/.test(x))        return 'Bonos';
  if(/vacacion/.test(x))              return 'Vacaciones';
  return 'Quincena';
}

/* El AÑO de una planilla es el de su FIN (v726). Antes era el del inicio,
   y la quincena «29 dic – 12 ene 2026», que es la primera de enero de 2026,
   caía en 2025. Una quincena se paga al terminar: cuenta en el año en que
   termina. */
function _plaAnioDe(p){
  return String((p && (p.hasta||p.desde))||'').slice(0,4);
}

function _plaAnio(a){ window._pla.anio=a; window._pla.periodo=null;
                      window._pla.empleados=[]; _plaPintar(); }
function _plaTipoFiltro(t){ window._pla.tipo=t; _plaPintar(); }

/* ── El año entero: cada quincena con sus totales y, si se busca un
   empleado, lo que ganó y le descontaron en cada una ──────────────────── */
async function _plaResumenAnual(){
  var S=window._pla||{};
  var anio=S.anio||String(new Date().getFullYear());
  var pers=(S.periodos||[]).filter(function(p){
    return _plaAnioDe(p)===String(anio); });
  if(!pers.length){ showT('No hay nada guardado de '+anio); return; }

  var prev=document.getElementById('modalPlaAnual'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPlaAnual';
  ov.style.cssText='position:fixed;inset:0;background:var(--surface-2);z-index:12500;'
    +'display:flex;flex-direction:column;padding:12px 14px;overflow:hidden';
  ov.innerHTML='<div style="padding:18px;font-size:12px;color:var(--t-lila)">'
    +'<span class="ai-ring g"></span> Juntando el año…</div>';
  document.body.appendChild(ov);

  // Todo lo del año, de una vez
  var ids=pers.map(function(p){ return p.id; });
  var filas=[];
  try{
    for(var i=0;i<ids.length;i+=10){
      var lote=ids.slice(i,i+10);
      var r=await fetch(SB+'/rest/v1/planilla_empleados?select=*'
        +'&periodo_id=in.('+lote.join(',')+')&limit=5000',{headers:SBH});
      if(r.ok) filas=filas.concat((await r.json())||[]);
    }
  }catch(e){}
  window._plaAnual={anio:anio, pers:pers, filas:filas};
  _plaAnualPintar();
}

function _plaAnualPintar(){
  var A=window._plaAnual||{};
  var ov=document.getElementById('modalPlaAnual'); if(!ov) return;
  var porId={}; (A.pers||[]).forEach(function(p){ porId[p.id]=p; });
  var sum=function(L,k){ return L.reduce(function(a,x){ return a+(Number(x[k])||0); },0); };

  // Si hay uno elegido, se ve SU año; si no, el de todos
  if(A.sel){ ov.innerHTML=_plaAnualEmpleado(A, porId, sum); return; }

  var q=String(A.q||'').toLowerCase().trim();

  /* Un renglón por empleado con lo que ganó en TODO el año. Antes había que
     escribir el nombre para ver algo; ahora salen todos y se elige. */
  var porEmp={};
  (A.filas||[]).forEach(function(f){
    var k=String(f.num_empleado||'')+'|'+String(f.nombre||'');
    if(!porEmp[k]) porEmp[k]={num:f.num_empleado, nombre:f.nombre, filas:[]};
    porEmp[k].filas.push(f);
  });
  var emps=Object.keys(porEmp).map(function(k){ return porEmp[k]; });
  if(q) emps=emps.filter(function(e){
    return String(e.nombre||'').toLowerCase().indexOf(q)>=0
        || String(e.num||'').indexOf(q)>=0; });
  emps.sort(function(a,b){ return sum(b.filas,'neto')-sum(a.filas,'neto'); });

  var h='<div style="display:flex;align-items:center;gap:11px;flex-wrap:wrap;'
    +'margin-bottom:11px">'
    +'<div style="width:38px;height:38px;border-radius:10px;background:var(--pastel-lila);'
    +'display:flex;align-items:center;justify-content:center">'
    +'<i class="ti ti-calendar-stats" style="font-size:19px;color:var(--t-lila)"></i></div>'
    +'<div style="flex:1;min-width:200px">'
    +'<div style="font-size:17px;font-weight:700">Resumen del año '+_esc(A.anio)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +(A.pers||[]).length+' planilla(s) · '+emps.length+' empleado(s)</div></div>'
    +'<button class="btn bg2" style="padding:8px 14px" '
    +'onclick="document.getElementById(\'modalPlaAnual\').remove()">'
    +'<i class="ti ti-x"></i> Cerrar</button></div>';

  var todas=A.filas||[];
  var kpi=function(t,v,col,bg){
    return '<div style="background:'+bg+';border-radius:12px;padding:11px 14px">'
      +'<div style="font-size:10.5px;color:'+col+'">'+_esc(t)+'</div>'
      +'<div style="font-size:17px;font-weight:800;color:'+col+'">'+v+'</div></div>';
  };
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));'
    +'gap:10px;margin-bottom:12px">'
    + kpi('Bruto del año', fmt(sum(todas,'bruto')), '#166534','var(--pastel-ok)')
    + kpi('Neto pagado', fmt(sum(todas,'neto')), '#0C447C','var(--pastel-azul)')
    + kpi('Préstamos', fmt(sum(todas,'otras_ded')), 'var(--t-marron)','var(--pastel-aviso)')
    + kpi('Seguro social', fmt(sum(todas,'ss')), '#991B1B','var(--pastel-error)')
    + kpi('I.S.R.', fmt(sum(todas,'isr')), 'var(--t-lila)','var(--pastel-lila)')
    +'</div>';

  h+='<div style="margin-bottom:11px">'
    +'<input id="plaAnualQ" value="'+_esc(A.q||'')+'" autocomplete="off" '
    +'placeholder="Filtrar empleado por nombre o número…" '
    +'oninput="_plaAnualBuscar(this.value)" style="width:100%;padding:9px 15px;'
    +'border:0.5px solid var(--border);border-radius:999px;font-size:12.5px;'
    +'background:var(--surface-0);color:var(--text-primary)"></div>';

  var th='padding:9px 11px;font-size:10.5px;font-weight:700;color:#fff;'
        +'text-align:right;position:sticky;top:0;background:#5B21B6;z-index:1';
  h+='<div style="flex:1;min-height:0;border:0.5px solid var(--border);'
    +'border-radius:12px;overflow:auto;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px">'
    +'<thead><tr>'
    +'<th style="'+th+';text-align:left;width:60px">Nº</th>'
    +'<th style="'+th+';text-align:left">EMPLEADO</th>'
    +'<th style="'+th+'">PLANILLAS</th>'
    +'<th style="'+th+'">BRUTO</th>'
    +'<th style="'+th+'">PRÉSTAMOS</th>'
    +'<th style="'+th+'">IMPUESTOS Y SEGUROS</th>'
    +'<th style="'+th+'">NETO DEL AÑO</th>'
    +'<th style="'+th+';width:30px"></th></tr></thead><tbody>';

  emps.forEach(function(e, i){
    var td='padding:9px 11px;border-bottom:0.5px solid var(--border);text-align:right';
    var leg=sum(e.filas,'isr')+sum(e.filas,'ss')+sum(e.filas,'se');
    var pre=sum(e.filas,'otras_ded');
    h+='<tr style="cursor:pointer;'+((i%2)?'background:var(--bg-accent)':'')+'" '
      +'onclick="_plaAnualVer(\''+_esc(e.num||'')+'\',\''
      +_esc(String(e.nombre||'').replace(/\'/g,""))+'\')" '
      +'onmouseover="this.style.filter=\'brightness(.97)\'" '
      +'onmouseout="this.style.filter=\'\'">'
      +'<td style="'+td+';text-align:left;color:var(--text-muted)">'
      +_esc(e.num||'')+'</td>'
      +'<td style="'+td+';text-align:left"><b>'+_esc(e.nombre||'')+'</b></td>'
      +'<td style="'+td+';color:var(--text-muted)">'+e.filas.length+'</td>'
      +'<td style="'+td+'">'+fmt(sum(e.filas,'bruto'))+'</td>'
      +'<td style="'+td+';color:'+(pre?'var(--t-marron)':'var(--text-muted)')+'">'
      +(pre?fmt(pre):'—')+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'+fmt(leg)+'</td>'
      +'<td style="'+td+';font-weight:800;color:#166534">'
      +fmt(sum(e.filas,'neto'))+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'
      +'<i class="ti ti-chevron-right"></i></td></tr>';
  });

  h+='<tr style="background:var(--pastel-lila);font-weight:800">'
    +'<td colspan="3" style="padding:10px 11px;text-align:right">TOTAL</td>'
    +'<td style="padding:10px 11px;text-align:right">'+fmt(sum(todas,'bruto'))+'</td>'
    +'<td style="padding:10px 11px;text-align:right">'+fmt(sum(todas,'otras_ded'))+'</td>'
    +'<td style="padding:10px 11px;text-align:right">'
    +fmt(sum(todas,'isr')+sum(todas,'ss')+sum(todas,'se'))+'</td>'
    +'<td style="padding:10px 11px;text-align:right;color:#166534">'
    +fmt(sum(todas,'neto'))+'</td><td></td></tr>';
  h+='</tbody></table></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:8px">'
    +'Pulsa un empleado para ver su año desglosado planilla por planilla.</div>';
  return (ov.innerHTML=h);
}

/* El año de UN empleado: cada planilla con lo que cobró y lo que le
   descontaron, y los totales abajo. */
function _plaAnualEmpleado(A, porId, sum){
  var L=(A.filas||[]).filter(function(f){
    return String(f.num_empleado||'')===String(A.sel.num)
        && String(f.nombre||'')===String(A.sel.nombre); });
  L.sort(function(a,b){
    var pa=porId[a.periodo_id]||{}, pb=porId[b.periodo_id]||{};
    return String(pa.desde||'').localeCompare(String(pb.desde||'')); });

  var h='<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;'
    +'margin-bottom:12px">'
    +'<button class="xb" onclick="_plaAnualVolver()">'
    +'<i class="ti ti-arrow-left"></i> Todos</button>'
    +'<div style="width:40px;height:40px;border-radius:11px;background:#5B21B6;'
    +'color:#fff;display:flex;align-items:center;justify-content:center;'
    +'font-weight:800">'+_esc(String(A.sel.nombre||'?').trim().split(/\s+/)
      .map(function(p){ return p[0]; }).slice(0,2).join('').toUpperCase())+'</div>'
    +'<div style="flex:1;min-width:200px">'
    +'<div style="font-size:17px;font-weight:700">'+_esc(A.sel.nombre)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Nº '
    +_esc(A.sel.num)+' · año '+_esc(A.anio)+' · '+L.length+' planilla(s)</div></div>'
    +'<button class="btn bg2" style="padding:8px 14px" '
    +'onclick="document.getElementById(\'modalPlaAnual\').remove()">'
    +'<i class="ti ti-x"></i> Cerrar</button></div>';

  var kpi=function(t,v,col,bg){
    return '<div style="background:'+bg+';border-radius:12px;padding:11px 14px">'
      +'<div style="font-size:10.5px;color:'+col+'">'+_esc(t)+'</div>'
      +'<div style="font-size:17px;font-weight:800;color:'+col+'">'+v+'</div></div>';
  };
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));'
    +'gap:10px;margin-bottom:13px">'
    + kpi('Ganó en bruto', fmt(sum(L,'bruto')), '#166534','var(--pastel-ok)')
    + kpi('Cobró neto', fmt(sum(L,'neto')), '#0C447C','var(--pastel-azul)')
    + kpi('Préstamos', fmt(sum(L,'otras_ded')), 'var(--t-marron)','var(--pastel-aviso)')
    + kpi('Ausencias', fmt(sum(L,'aus_tard')), '#991B1B','var(--pastel-error)')
    + kpi('Horas del reloj', _fmtN2(sum(L,'horas_reloj')), 'var(--t-lila)','var(--pastel-lila)')
    +'</div>';

  var th='padding:9px 10px;font-size:10px;font-weight:700;color:#fff;'
        +'text-align:right;position:sticky;top:0;background:#5B21B6;z-index:1';
  h+='<div style="flex:1;min-height:0;border:0.5px solid var(--border);'
    +'border-radius:12px;overflow:auto;background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr>'
    +'<th style="'+th+';text-align:left">PLANILLA</th>'
    +'<th style="'+th+';text-align:left;width:80px">TIPO</th>'
    +'<th style="'+th+'">SALARIO</th>'
    +'<th style="'+th+'">EXTRAS</th>'
    +'<th style="'+th+'">BRUTO</th>'
    +'<th style="'+th+'">I.S.R.</th>'
    +'<th style="'+th+'">S.S.</th>'
    +'<th style="'+th+'">S.E.</th>'
    +'<th style="'+th+'">AUS/TARD</th>'
    +'<th style="'+th+'">PRÉSTAMO</th>'
    +'<th style="'+th+'">NETO</th>'
    +'<th style="'+th+'">HORAS</th></tr></thead><tbody>';

  L.forEach(function(f, i){
    var p=porId[f.periodo_id]||{};
    var td='padding:8px 10px;border-bottom:0.5px solid var(--border);text-align:right';
    var extras=(Number(f.sobretiempo)||0)+(Number(f.feriados)||0)
              +(Number(f.enfermedad)||0)+(Number(f.otros_ing)||0)
              +(Number(f.reembolsos)||0);
    var sinSueldo=((Number(f.neto)||0)<=0.009);
    h+='<tr style="'+(sinSueldo?'background:var(--pastel-error)'
                               :((i%2)?'background:var(--bg-accent)':''))+'">'
      +'<td style="'+td+';text-align:left"><b>'+_esc(_plaRotulo(p))+'</b></td>'
      +'<td style="'+td+';text-align:left;font-size:10px;color:var(--text-muted)">'
      +_esc(_plaTipo(p.tipo))+'</td>'
      +'<td style="'+td+'">'+fmt(f.salario_reg)+'</td>'
      +'<td style="'+td+';color:'+(extras?'#166534':'var(--text-muted)')+'">'
      +(extras?fmt(extras):'—')+'</td>'
      +'<td style="'+td+';font-weight:700">'+fmt(f.bruto)+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'+(f.isr?fmt(f.isr):'—')+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'+fmt(f.ss)+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'+fmt(f.se)+'</td>'
      +'<td style="'+td+';color:'+(f.aus_tard?'#991B1B':'var(--text-muted)')+'">'
      +(f.aus_tard?fmt(f.aus_tard):'—')+'</td>'
      +'<td style="'+td+';font-weight:700;color:'
      +(f.otras_ded?'var(--t-marron)':'var(--text-muted)')+'">'
      +(f.otras_ded?fmt(f.otras_ded):'—')+'</td>'
      +'<td style="'+td+';font-weight:800;color:'+(sinSueldo?'#991B1B':'#166534')+'">'
      +fmt(f.neto)+'</td>'
      +'<td style="'+td+';color:var(--text-muted)">'
      +(f.horas_reloj!=null?_fmtN2(f.horas_reloj):'—')+'</td></tr>';
  });

  h+='<tr style="background:var(--pastel-lila);font-weight:800">'
    +'<td colspan="2" style="padding:10px;text-align:right">TOTAL DEL AÑO</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'salario_reg'))+'</td>'
    +'<td></td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'bruto'))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'isr'))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'ss'))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'se'))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'aus_tard'))+'</td>'
    +'<td style="padding:10px;text-align:right">'+fmt(sum(L,'otras_ded'))+'</td>'
    +'<td style="padding:10px;text-align:right;color:#166534">'+fmt(sum(L,'neto'))+'</td>'
    +'<td></td></tr>';
  h+='</tbody></table></div>';
  return h;
}

function _plaAnualVer(num, nombre){
  window._plaAnual.sel={num:num, nombre:nombre};
  _plaAnualPintar();
}
function _plaAnualVolver(){
  window._plaAnual.sel=null;
  _plaAnualPintar();
}

function _plaAnualBuscar(v){
  window._plaAnual=window._plaAnual||{};
  window._plaAnual.q=v;
  var el=document.getElementById('plaAnualQ');
  var pos=el?el.selectionStart:null;
  _plaAnualPintar();
  var el2=document.getElementById('plaAnualQ');
  if(el2){ el2.focus();
    try{ if(pos!=null) el2.setSelectionRange(pos,pos); }catch(e){} }
}

function _plaPonerTipo(t){ window._pla.tipoManual=t; _plaPintar(); }

/* Borra una planilla entera: su cabecera, sus empleados y sus marcaciones.
   Las dos últimas se van solas por la relación con el periodo. */
async function _plaBorrarPeriodo(id){
  var S=window._pla||{};
  var p=(S.periodos||[]).filter(function(x){ return x.id===id; })[0];
  if(!p) return;
  if(!confirm('Se va a borrar la planilla '+_plaRotulo(p)+' ('+_plaTipo(p.tipo)+')'
    +' con sus '+(p.n_empleados||'?')+' empleado(s) y sus marcaciones.\n\n'
    +'Esto no se puede deshacer.\n\n¿Sigo?')) return;
  try{
    // Primero lo que cuelga, por si la base no borra en cascada
    await fetch(SB+'/rest/v1/planilla_marcaciones?periodo_id=eq.'+id,
      {method:'DELETE', headers:SBH});
    await fetch(SB+'/rest/v1/planilla_empleados?periodo_id=eq.'+id,
      {method:'DELETE', headers:SBH});
    var r=await fetch(SB+'/rest/v1/planilla_periodos?id=eq.'+id,
      {method:'DELETE', headers:SBH});
    if(!r.ok) throw new Error((await r.text()).slice(0,140));
    showT('✓ Planilla borrada');
    window._pla.periodo=null; window._pla.empleados=[];
    await _plaCargarPeriodos(true);
    var sig=(window._pla.periodos||[])[0];
    if(sig) await _plaVerPeriodo(sig.id);
  }catch(e){ showT('No se pudo borrar: '+(e.message||e), 9000); }
}

/* Borra las repetidas de golpe, conservando la primera de cada corte y
   tipo. La primera es la más antigua, que es la que suele tener bien los
   datos de origen. */
async function _plaBorrarRepes(){
  var S=window._pla||{};
  var vistas={}, repes=[];
  (S.periodos||[]).slice().sort(function(a,b){ return a.id-b.id; })
    .forEach(function(p){
      var k=p.desde+'|'+p.hasta+'|'+_plaTipo(p.tipo);
      if(vistas[k]) repes.push(p); else vistas[k]=p;
    });
  if(!repes.length){ showT('No hay repetidas'); return; }
  if(!confirm('Se van a borrar '+repes.length+' planilla(s) repetida(s):\n\n  · '
    + repes.map(function(p){
        return _plaRotulo(p)+' ('+_plaTipo(p.tipo)+')'; }).join('\n  · ')
    +'\n\nSe conserva una de cada corte y tipo.\n\n¿Sigo?')) return;
  var n=0;
  for(var i=0;i<repes.length;i++){
    try{
      await fetch(SB+'/rest/v1/planilla_marcaciones?periodo_id=eq.'+repes[i].id,
        {method:'DELETE', headers:SBH});
      await fetch(SB+'/rest/v1/planilla_empleados?periodo_id=eq.'+repes[i].id,
        {method:'DELETE', headers:SBH});
      var r=await fetch(SB+'/rest/v1/planilla_periodos?id=eq.'+repes[i].id,
        {method:'DELETE', headers:SBH});
      if(r.ok) n++;
    }catch(e){}
  }
  showT('✓ '+n+' planilla(s) repetida(s) borrada(s)');
  window._pla.periodo=null; window._pla.empleados=[];
  await _plaCargarPeriodos(true);
  var sig=(window._pla.periodos||[])[0];
  if(sig) await _plaVerPeriodo(sig.id);
}
